/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 252);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(259);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__async__ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser__ = __webpack_require__(127);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_1__browser__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dsn__ = __webpack_require__(270);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__dsn__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error__ = __webpack_require__(75);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__error__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__instrument__ = __webpack_require__(272);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__instrument__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__is__ = __webpack_require__(24);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_5__is__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_5__is__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_5__is__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_5__is__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_5__is__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_5__is__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_5__is__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_5__is__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_5__is__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_5__is__["m"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__logger__ = __webpack_require__(76);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_6__logger__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__memo__ = __webpack_require__(128);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__misc__ = __webpack_require__(40);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__misc__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__misc__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__misc__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_8__misc__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_8__misc__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_8__misc__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_8__misc__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_8__misc__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_8__misc__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__node__ = __webpack_require__(77);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_9__node__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__object__ = __webpack_require__(78);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__object__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_10__object__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__object__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_10__object__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_10__object__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_10__object__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__path__ = __webpack_require__(273);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_11__path__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_11__path__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__promisebuffer__ = __webpack_require__(274);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_12__promisebuffer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__stacktrace__ = __webpack_require__(79);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_13__stacktrace__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__string__ = __webpack_require__(80);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_14__string__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_14__string__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_14__string__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__supports__ = __webpack_require__(129);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_15__supports__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_15__supports__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_15__supports__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__syncpromise__ = __webpack_require__(130);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_16__syncpromise__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__time__ = __webpack_require__(275);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_17__time__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_17__time__["b"]; });


















//# sourceMappingURL=index.js.map

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["b"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["d"] = __generator;
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* harmony export (immutable) */ __webpack_exports__["g"] = __values;
/* harmony export (immutable) */ __webpack_exports__["e"] = __read;
/* harmony export (immutable) */ __webpack_exports__["f"] = __spread;
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getMagnitude;
/* harmony export (immutable) */ __webpack_exports__["d"] = repeat;
/* unused harmony export setInternalSlot */
/* unused harmony export setMultiInternalSlots */
/* unused harmony export getInternalSlot */
/* unused harmony export getMultiInternalSlots */
/* unused harmony export isLiteralPart */
/* unused harmony export defineProperty */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UNICODE_EXTENSION_SEQUENCE_REGEX; });
/* harmony export (immutable) */ __webpack_exports__["c"] = invariant;
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */
function getMagnitude(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function repeat(s, times) {
    if (typeof s.repeat === 'function') {
        return s.repeat(times);
    }
    var arr = new Array(times);
    for (var i = 0; i < arr.length; i++) {
        arr[i] = s;
    }
    return arr.join('');
}
function setInternalSlot(map, pl, field, value) {
    if (!map.get(pl)) {
        map.set(pl, Object.create(null));
    }
    var slots = map.get(pl);
    slots[field] = value;
}
function setMultiInternalSlots(map, pl, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var k = _a[_i];
        setInternalSlot(map, pl, k, props[k]);
    }
}
function getInternalSlot(map, pl, field) {
    return getMultiInternalSlots(map, pl, field)[field];
}
function getMultiInternalSlots(map, pl) {
    var fields = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        fields[_i - 2] = arguments[_i];
    }
    var slots = map.get(pl);
    if (!slots) {
        throw new TypeError(pl + " InternalSlot has not been initialized");
    }
    return fields.reduce(function (all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function isLiteralPart(patternPart) {
    return patternPart.type === 'literal';
}
/*
  17 ECMAScript Standard Built-in Objects:
    Every built-in Function object, including constructors, that is not
    identified as an anonymous function has a name property whose value
    is a String.

    Unless otherwise specified, the name property of a built-in Function
    object, if it exists, has the attributes { [[Writable]]: false,
    [[Enumerable]]: false, [[Configurable]]: true }.
*/
function defineProperty(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value,
    });
}
var UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function invariant(condition, message, Err) {
    if (Err === void 0) { Err = Error; }
    if (!condition) {
        throw new Err(message);
    }
}


/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = {"APIURIS":{"dev":"https://a01-wip.animaker.com/","live":"https://app.animaker.com/","local":"https://a01-wip.animaker.com/","demo":"https://snbx.animaker.com/","current":"demo"},"SOCKETURIS":{"dev":"https://devdckping.animaker.com","live":"https://deckping.animaker.com","local":"https://sc-local.animaker.com","demo":"sockd-snbx.animaker.com","current":"demo"},"APPICONS":{"dev":"https://dev-static.animaker.com/animdeck-static","live":"https://static.animaker.com/animdeck-static","local":"","demo":"https://dev-static.animaker.com/animdeck-static","current":"demo"},"UPAPI":{"dev":"https://dev-api.animaker.com/","live":"https://api.animaker.com/","local":"https://dev-api.animaker.com/","demo":"https://api-snbx.animaker.com/","current":"demo"},"ASSETS":{"dev":"https://dev-static.animaker.com/","live":"https://library.animaker.com/","local":"https://dev-static.animaker.com/","demo":"https://library.animaker.com/","current":"demo"},"BR_ASS":{"dev":"https://dev-static.animaker.com/","live":"https://static.animaker.com/","local":"https://dev-static.animaker.com/","demo":"https://dev-static.animaker.com/","current":"demo"},"PREBUILT":{"src":"animaker/prebuilds/src/","thumb":"animaker/scene-prebuilts/thumbnails/","onload":"thumb","drag":"thumb","workspace":"src","BRAND":"https://dash.animaker.com/"},"PROP":{"src":"animaker/properties/images/","thumb":"animaker/properties/thumbnails/","animdata":"animaker/properties/animdata/","onload":"thumb","drag":"thumb","workspace":"src"},"GETTYICON":{"src":"animaker/properties/gprops/src/","thumb":"animaker/properties/gprops/thumbnails/","animdata":"animaker/properties/gprops/animdata/","onload":"thumb","drag":"thumb","workspace":"src"},"EPROP":{"src":"animaker/properties/eprops/images/","thumb":"animaker/properties/eprops/thumbnails/","animdata":"animaker/properties/eprops/animdata/","onload":"thumb","drag":"thumb","workspace":"src"},"SCREEN":{"src":"animaker/scene-transition/source/","thumb":"animaker/scene-transition/thumbnail/","animdata":"animaker/scene-transition/animdata/","proxy":"animaker/scene-transition/source/","onload":"thumb","drag":"thumb","workspace":"src"},"CHR":{"src":"animaker/characters/source/","thumb":"animaker/characters/source/","animdata":"animaker/characters/animdata/","onload":"src","onload_CCHR":"src","drag":"thumb","drag_CCHR":"thumb","workspace":"src","workspace_CCHR":"src"},"CCHR":{"src":"animaker/customcharacter/source/","thumb":"animaker/customcharacter/userfiles/","animdata":"animaker/customcharacter/animdata/","part_src":"animaker/customcharacter/parts/","onload":"src","onload_CCHR":"src","drag":"thumb","drag_CCHR":"thumb","workspace":"src","workspace_CCHR":"src","action_gif":"animaker/customcharacter/gif/"},"ECHR":{"src":"animaker/characters/echar/source/","thumb":"animaker/characters/echar/source/","animdata":"animaker/characters/echar/animdata/","onload":"src","onload_CCHR":"src","drag":"thumb","drag_CCHR":"thumb","workspace":"src","workspace_CCHR":"src","action_gif":"animaker/characters/echar/gif/"},"BG":{"src":"animaker/backgrounds/images/","thumb":"animaker/backgrounds/thumbnails/","proxy":"animaker/backgrounds/proxy/","obgsrc":"animaker/backgrounds/","onload":"thumb","drag":"thumb","workspace":"src"},"VIDEO":{"src":"animaker/backgrounds/images/","thumb":"https://media.animaker.com/api/v1/e/","proxy":"https://media.animaker.com/api/v1/a/","onload":"thumb","thumbStrip":"https://media.animaker.com/api/v1/c/","drag":"thumb","workspace_IMAGE":"src","workspace_VIDEO":"proxy","workspace":"proxy"},"TEXT":{"src":"animaker/texts/images/","thumb":"animaker/texts/thumbnails/","proxy":"deck/eff/","onload":"thumb","drag":"thumb","workspace_CALLOUT":"src","workspace_GRP":"src","workspace_TEXT_CONTAINER":"src","workspace_TXTOVLY":"proxy","workspace_TXTGRP":"proxy"},"TXTOVLY":{"src":"animaker/texts/images/","thumb":"animaker/texts/thumbnails/","proxy":"animaker/texts/prebuild/","onload":"thumb","drag":"src","workspace_TEXT_CONTAINER":"src","workspace_TXTOVLY":"proxy"},"TXTGRP":{"src":"animaker/texts/images/","thumb":"animaker/texts/thumbnails/","proxy":"animaker/texts/prebuild/","onload":"thumb","drag":"src","workspace_TEXT_CONTAINER":"src","workspace_TXTGRP":"proxy"},"GROUP":{"src":"animaker/photos/proxy-images/","thumb":"animaker/photos/thumb/","proxy":"animaker/photos/fhd/","onload":"thumb","drag":"src","workspace_GROUP":"proxy"},"OVLYSVG":{"src":"animaker/texts/images/","thumb":"animaker/texts/thumbnails/","proxy":"animaker/texts/prebuild/","onload":"thumb","drag":"src","workspace":"src","workspace_TEXT_CONTAINER":"src","workspace_TXTOVLY":"proxy"},"CALLOUT":{"src":"https://s3-us-west-2.amazonaws.com/assets.dev.animaker.com/","thumb":"https://s3-us-west-2.amazonaws.com/assets.dev.animaker.com/","proxy":"https://s3-us-west-2.amazonaws.com/assets.dev.animaker.com/","onload":"thumb","drag":"thumb","workspace_TEXT_CONTAINER":"src","workspace_CALLOUT":"proxy"},"IMG":{"img_src":"animaker/photos/proxy-images/","img_thumb":"animaker/photos/thumb/","img_proxy_1":"animaker/photos/fhd/","img_proxy_2":"animaker/photos/hd/","img_proxy_3":"animaker/photos/sd/","onload":"img_thumb","drag":"img_thumb","workspace":"img_proxy_3"},"UPLOADS":{"image_src":"https://dash.animaker.com/a/u/","image_thumb":"https://dash.animaker.com/a/u/","video_src":"https://dash.animaker.com/a/u/","audio_src":"https://dash.animaker.com/a/u/","video_thumb":"https://dash.animaker.com/a/u/","font_src":"https://dash.animaker.com/a/u/","drag_UPIMAGE":"image_thumb","drag_UPVIDEO":"video_thumb","onload_UPIMAGE":"image_thumb","onload_UPVIDEO":"video_thumb","onload_UPAUDIO":"audio_src","workspace_UPIMAGE":"image_src","workspace_UPVIDEO":"video_src","workspace_UPAUDIO":"audio_src","drag_IMG":"image_thumb","drag_VIDEO":"video_thumb","onload_IMG":"image_thumb","onload_VIDEO":"video_thumb","onload_AUDIO":"audio_src","workspace_IMG":"image_src","workspace_VIDEO":"video_src","workspace_AUDIO":"audio_src","VIDEO_THUMB":"/video/thumb/","AUDIO":"/audio/","VIDEO":"/video/","IMG_THUMB":"/image/thumbnail/","PRE_UPLOAD":"upload/prepareUpload/","S3_UPLOAD":"https://anim-user-uploads.s3-us-west-2.amazonaws.com/","POST_UPLOAD":"upload/postUpload/","UPLOAD_MULTIPART_URL":"https://dash.animaker.com/a/","UPLOAD_BUCKET":"anim-user-uploads","UPLOAD_BKEY":"a/u","PREFLIGHT_URL":"upload/preflightcheck/","UP_IMG":"image/png,image/gif,image/x-icon,image/svg+xml,image/jpg,image/jpeg","UP_VID":"video/mp4,video/mov,video/mpeg,video/x-msvideo,video/3gpp, video/quicktime, video/avi"},"GIPHY":{"src":"","thumb":"","onload":"thumb","drag":"thumb","workspace":"src"},"STOCKIMG":{"src":"","thumb":"","onload":"thumb","drag":"thumb","workspace":"src"},"PEXELS":{"src":"","thumb":"","onload":"thumb","drag":"thumb","workspace":"src"},"PIXABAY":{"src":"","thumb":"","onload":"thumb","drag":"thumb","workspace":"src"},"UNSPLASH":{"src":"","thumb":"","onload":"thumb","drag":"thumb","workspace":"src"},"TRANS":{"src":"animaker/transitionimages/","thumb":"animaker/transitionimages/","proxy":"animaker/transitionimages/","onload":"proxy","drag":"src","workspace":"src"},"EFFECTS":{"src":"animaker/effects/"},"FRAME":{"src":"/images/frames/","DEFAULT_IMAGE":"/images/frames/bg-frame.png","thumb":"animaker/properties/thumbnails/","onload":"thumb"},"GRID":{"src":"/images/frames/","DEFAULT_IMAGE":"/images/frames/bg-frame.png","thumb":"animaker/properties/thumbnails/","onload":"thumb"},"FRAME_ASSET":{"dev":"https://dev-static.animaker.com/animapp-static","live":"https://static.animaker.com/animapp-static","local":"https://dev-static.animaker.com/animapp-static","demo":"https://dev-static.animaker.com/animapp-static","current":"live"},"SHAPE":{"src":"animaker/shapes/images/","thumb":"animaker/shapes/thumbnails/","onload":"thumb","drag":"thumb","drag_CALLOUT":"thumb","workspace":"src","workspace_CALLOUT":"src"},"USER_UPLOADS":{"videoSrc":"https://animaker-dev.s3.amazonaws.com/animaker/uploads/","thumb":"thumb","vProxy1":"video/proxy1","vProxy2":"video/proxy2","vProxy3":"video/proxy3","imgProxy":"image/proxy1"},"STOCKVID":{"src":"https://media.animaker.com/api/v1/a/","thumb":"https://media.animaker.com/api/v1/e/","proxy":"https://media.animaker.com/api/v1/a/","proxyThumb":"https://media.animaker.com/api/v1/f/","onload":"proxyThumb","drag":"src","workspace":"src","edit":"proxyThumb"},"ZOOM":{"src":"","thumb":"","proxy":"","proxyThumb":"","onload":"proxyThumb","drag":"src","workspace":"src","edit":"proxyThumb"},"UPGRADE":{"2":"/images/lib_upgrade_icons/level4.svg","3":"/images/lib_upgrade_icons/level1.svg","4":"/images/lib_upgrade_icons/level3.svg","5":"/images/lib_upgrade_icons/level2.svg","6":"/images/lib_upgrade_icons/enterprise.svg","type":"deckupgrade"},"SCENE":{"duration":5},"VERSION":{"maxCount":500,"maxSeconds":900},"GRAD":{"src":"animaker/properties/images/","thumb":"animaker/properties/thumbnails/","onload":"thumb","drag":"thumb","workspace":"src"}}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["l"] = ToString;
/* harmony export (immutable) */ __webpack_exports__["j"] = ToNumber;
/* harmony export (immutable) */ __webpack_exports__["i"] = TimeClip;
/* harmony export (immutable) */ __webpack_exports__["k"] = ToObject;
/* harmony export (immutable) */ __webpack_exports__["g"] = SameValue;
/* harmony export (immutable) */ __webpack_exports__["a"] = ArrayCreate;
/* harmony export (immutable) */ __webpack_exports__["c"] = HasOwnProperty;
/* harmony export (immutable) */ __webpack_exports__["m"] = Type;
/* unused harmony export Day */
/* harmony export (immutable) */ __webpack_exports__["n"] = WeekDay;
/* unused harmony export DayFromYear */
/* unused harmony export TimeFromYear */
/* harmony export (immutable) */ __webpack_exports__["o"] = YearFromTime;
/* unused harmony export DaysInYear */
/* unused harmony export DayWithinYear */
/* unused harmony export InLeapYear */
/* harmony export (immutable) */ __webpack_exports__["f"] = MonthFromTime;
/* harmony export (immutable) */ __webpack_exports__["b"] = DateFromTime;
/* harmony export (immutable) */ __webpack_exports__["d"] = HourFromTime;
/* harmony export (immutable) */ __webpack_exports__["e"] = MinFromTime;
/* harmony export (immutable) */ __webpack_exports__["h"] = SecFromTime;
/**
 * https://tc39.es/ecma262/#sec-tostring
 */
function ToString(o) {
    // Only symbol is irregular...
    if (typeof o === 'symbol') {
        throw TypeError('Cannot convert a Symbol value to a string');
    }
    return String(o);
}
/**
 * https://tc39.es/ecma262/#sec-tonumber
 * @param val
 */
function ToNumber(val) {
    if (val === undefined) {
        return NaN;
    }
    if (val === null) {
        return +0;
    }
    if (typeof val === 'boolean') {
        return val ? 1 : +0;
    }
    if (typeof val === 'number') {
        return val;
    }
    if (typeof val === 'symbol' || typeof val === 'bigint') {
        throw new TypeError('Cannot convert symbol/bigint to number');
    }
    return Number(val);
}
/**
 * https://tc39.es/ecma262/#sec-tointeger
 * @param n
 */
function ToInteger(n) {
    var number = ToNumber(n);
    if (isNaN(number) || SameValue(number, -0)) {
        return 0;
    }
    if (isFinite(number)) {
        return number;
    }
    var integer = Math.floor(Math.abs(number));
    if (number < 0) {
        integer = -integer;
    }
    if (SameValue(integer, -0)) {
        return 0;
    }
    return integer;
}
/**
 * https://tc39.es/ecma262/#sec-timeclip
 * @param time
 */
function TimeClip(time) {
    if (!isFinite(time)) {
        return NaN;
    }
    if (Math.abs(time) > 8.64 * 1e16) {
        return NaN;
    }
    return ToInteger(time);
}
/**
 * https://tc39.es/ecma262/#sec-toobject
 * @param arg
 */
function ToObject(arg) {
    if (arg == null) {
        throw new TypeError('undefined/null cannot be converted to object');
    }
    return Object(arg);
}
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-samevalue
 * @param x
 * @param y
 */
function SameValue(x, y) {
    if (Object.is) {
        return Object.is(x, y);
    }
    // SameValue algorithm
    if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
    }
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
}
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-arraycreate
 * @param len
 */
function ArrayCreate(len) {
    return new Array(len);
}
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-hasownproperty
 * @param o
 * @param prop
 */
function HasOwnProperty(o, prop) {
    return Object.prototype.hasOwnProperty.call(o, prop);
}
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-type
 * @param x
 */
function Type(x) {
    if (x === null) {
        return 'Null';
    }
    if (typeof x === 'undefined') {
        return 'Undefined';
    }
    if (typeof x === 'function' || typeof x === 'object') {
        return 'Object';
    }
    if (typeof x === 'number') {
        return 'Number';
    }
    if (typeof x === 'boolean') {
        return 'Boolean';
    }
    if (typeof x === 'string') {
        return 'String';
    }
    if (typeof x === 'symbol') {
        return 'Symbol';
    }
    if (typeof x === 'bigint') {
        return 'BigInt';
    }
}
var MS_PER_DAY = 86400000;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#eqn-modulo
 * @param x
 * @param y
 * @return k of the same sign as y
 */
function mod(x, y) {
    return x - Math.floor(x / y) * y;
}
/**
 * https://tc39.es/ecma262/#eqn-Day
 * @param t
 */
function Day(t) {
    return Math.floor(t / MS_PER_DAY);
}
/**
 * https://tc39.es/ecma262/#sec-week-day
 * @param t
 */
function WeekDay(t) {
    return mod(Day(t) + 4, 7);
}
/**
 * https://tc39.es/ecma262/#sec-year-number
 * @param y
 */
function DayFromYear(y) {
    return (365 * (y - 1970) +
        Math.floor((y - 1969) / 4) -
        Math.floor((y - 1901) / 100) +
        Math.floor((y - 1601) / 400));
}
/**
 * https://tc39.es/ecma262/#sec-year-number
 * @param y
 */
function TimeFromYear(y) {
    return MS_PER_DAY * DayFromYear(y);
}
/**
 * https://tc39.es/ecma262/#sec-year-number
 * @param t
 */
function YearFromTime(t) {
    var min = Math.ceil(t / MS_PER_DAY / 366);
    var y = min;
    while (TimeFromYear(y) <= t) {
        y++;
    }
    return y - 1;
}
function DaysInYear(y) {
    if (y % 4 !== 0) {
        return 365;
    }
    if (y % 100 !== 0) {
        return 366;
    }
    if (y % 400 !== 0) {
        return 365;
    }
    return 366;
}
function DayWithinYear(t) {
    return Day(t) - DayFromYear(YearFromTime(t));
}
function InLeapYear(t) {
    return DaysInYear(YearFromTime(t)) === 365 ? 0 : 1;
}
/**
 * https://tc39.es/ecma262/#sec-month-number
 * @param t
 */
function MonthFromTime(t) {
    var dwy = DayWithinYear(t);
    var leap = InLeapYear(t);
    if (dwy >= 0 && dwy < 31) {
        return 0;
    }
    if (dwy < 59 + leap) {
        return 1;
    }
    if (dwy < 90 + leap) {
        return 2;
    }
    if (dwy < 120 + leap) {
        return 3;
    }
    if (dwy < 151 + leap) {
        return 4;
    }
    if (dwy < 181 + leap) {
        return 5;
    }
    if (dwy < 212 + leap) {
        return 6;
    }
    if (dwy < 243 + leap) {
        return 7;
    }
    if (dwy < 273 + leap) {
        return 8;
    }
    if (dwy < 304 + leap) {
        return 9;
    }
    if (dwy < 334 + leap) {
        return 10;
    }
    if (dwy < 365 + leap) {
        return 11;
    }
    throw new Error('Invalid time');
}
function DateFromTime(t) {
    var dwy = DayWithinYear(t);
    var mft = MonthFromTime(t);
    var leap = InLeapYear(t);
    if (mft === 0) {
        return dwy + 1;
    }
    if (mft === 1) {
        return dwy - 30;
    }
    if (mft === 2) {
        return dwy - 58 - leap;
    }
    if (mft === 3) {
        return dwy - 89 - leap;
    }
    if (mft === 4) {
        return dwy - 119 - leap;
    }
    if (mft === 5) {
        return dwy - 150 - leap;
    }
    if (mft === 6) {
        return dwy - 180 - leap;
    }
    if (mft === 7) {
        return dwy - 211 - leap;
    }
    if (mft === 8) {
        return dwy - 242 - leap;
    }
    if (mft === 9) {
        return dwy - 272 - leap;
    }
    if (mft === 10) {
        return dwy - 303 - leap;
    }
    if (mft === 11) {
        return dwy - 333 - leap;
    }
    throw new Error('Invalid time');
}
var HOURS_PER_DAY = 24;
var MINUTES_PER_HOUR = 60;
var SECONDS_PER_MINUTE = 60;
var MS_PER_SECOND = 1e3;
var MS_PER_MINUTE = MS_PER_SECOND * SECONDS_PER_MINUTE;
var MS_PER_HOUR = MS_PER_MINUTE * MINUTES_PER_HOUR;
function HourFromTime(t) {
    return mod(Math.floor(t / MS_PER_HOUR), HOURS_PER_DAY);
}
function MinFromTime(t) {
    return mod(Math.floor(t / MS_PER_MINUTE), MINUTES_PER_HOUR);
}
function SecFromTime(t) {
    return mod(Math.floor(t / MS_PER_SECOND), SECONDS_PER_MINUTE);
}


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(323);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Immutable = factory());
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      if (o !== o || o === Infinity) {
        return 0;
      }
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
      return emptyMap().withMutations(function(map ) {
        for (var i = 0; i < keyValues.length; i += 2) {
          if (i + 1 >= keyValues.length) {
            throw new Error('Missing value for key: ' + keyValues[i]);
          }
          map.set(keyValues[i], keyValues[i + 1]);
        }
      });
    };

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      if (end === Infinity) {
        end = originalSize;
      } else {
        end = end | 0;
      }
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      if (this._map && !this._map.has(k)) {
        var defaultVal = this._defaultValues[k];
        if (v === defaultVal) {
          return this;
        }
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findEntry: function(predicate, context, notSetValue) {
      var found = notSetValue;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    findLastEntry: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },

    findLastKey: function(predicate, context) {
      return this.toKeyedSeq().reverse().findKey(predicate, context);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    lastKeyOf: function(searchValue) {
      return this.toKeyedSeq().reverse().keyOf(searchValue);
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.lastKeyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var entry = this.findLastEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    keySeq: function() {
      return Range(0, this.size);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;
  SetIterable.prototype.contains = SetIterable.prototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = errorlog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_browser__ = __webpack_require__(125);
function errorlog(error,errorInfo,componentName){var hasCrashed=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var sentryId=__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["e" /* lastEventId */]();__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["f" /* withScope */](function(scope){scope.setLevel(hasCrashed?__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["a" /* Severity */].Fatal:__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["a" /* Severity */].Error);scope.setTag("Component",componentName);scope.setContext("Error Info",{'info':errorInfo});sentryId=sentryId?sentryId:__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["e" /* lastEventId */]();__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["b" /* captureException */](error);});return sentryId||__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["e" /* lastEventId */]();}

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export appLoadProgess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return moveUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return moveUpdateComplete; });
/* unused harmony export changelibBG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return deleteBG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return dropBG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return resizeUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return rotationUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return setSelectedItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return changeVideoVolumeComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return changeText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return changeTextComplete; });
/* unused harmony export updateText */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return updateTextStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return setTextOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return updateGroupText; });
/* unused harmony export initateProject */
/* unused harmony export loadSceneThumbnails */
/* unused harmony export setSearchData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return toggleCrop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return toggleBgCrop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return toggleFrame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return cropImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return cropImageComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return cropBG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return cropBgComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return toggleVideoCrop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return updateTransformStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return showLibrary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return startPlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return addTween; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return updateSVGColor; });
/* unused harmony export updateBGColor */
/* unused harmony export updateBGGradient */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return updateBgColorComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return updateBgGradientComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return updateSVGTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return changePlayTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return flipItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return flipItemComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return deleteItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return deleteItemComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return onItemDrag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return applyEnterEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return applyEnterEffectComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return updateTimelineDragChangeComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return changeObjectThumb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return deleteObject; });
/* unused harmony export updateVolume */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return setWorkspaceTextFocus; });
/* unused harmony export addUploadItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return addScene; });
/* unused harmony export dropNewScene */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return addSceneComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return duplicateSceneComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return setSelectedScene; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return moveScene; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return moveSceneComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return removeScene; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return removeSceneComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return addSceneTransitionComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return changeSceneTransColorComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return changeExpressionComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return changeActionComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return deleteBgComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return showSlides; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return addObj; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return upAddObj; });
/* unused harmony export changeAnimationType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return changeAnimationTypeComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return addObjComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return changeBgComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return duplicateScene; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return setZoom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return setPlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return setPlayAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return setZIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return setZIndexComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return changeBg; });
/* unused harmony export toggleGrid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return swapItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return swapItemUndo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return setCopyItemType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return copyObjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return cutObjects; });
/* unused harmony export pasteObjects */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return pasteItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return pasteItemsComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return groupObjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return groupObjectsComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return unGroupObjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return ungroupObjectsComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return setPropertyWindow; });
/* unused harmony export addSceneTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return changeAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return changeExpression; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return changeBGThumbValue; });
/* unused harmony export bgColorSelection */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return bgColorSelectionComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return applyFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return applyFilterComplete; });
/* unused harmony export copyFilter */
/* unused harmony export bgGradientSetting */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return bgGradientColorsComplete; });
/* unused harmony export resizeProject */
/* unused harmony export isUploadFromOutside */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return loadCommonPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return updateSvgColorComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return updateSvgThemeComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return updateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return writeText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return syncText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return updateObjectComplete; });
/* unused harmony export setUserFonts */
/* unused harmony export setShareDetails */
/* unused harmony export fontUploaded */
/* unused harmony export updateRecentColors */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return updateObjectById; });
/* unused harmony export setSelectedKey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return updateTextComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return updateGroupTextComplete; });
/* unused harmony export setPrebuiltLoad */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return addPrebuilt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return addPrebuiltComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return toggleToolBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addBulkObjects; });
/* unused harmony export uploadBulkUpdate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return uploadBulkUpdateComplete; });
/* unused harmony export uploadBulkDelete */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return uploadBulkDeleteComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return undoMove; });
/* unused harmony export updateTextFormats */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return updateSlide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return setSelectedItemsComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return setSelectedSceneComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return pasteScenesComplete; });
/* unused harmony export swapWorkspaceItems */
/* unused harmony export organiseScenes */
/* unused harmony export continueScene */
/* unused harmony export saveScreenshot */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return updateSceneComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return updateScene; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return updateBgComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return updateProjectComplete; });
/* unused harmony export saveProjectName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return setFullTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return updateSelectionBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return socketConnected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return socketDisconnected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return openLibrarySection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return setCurrentPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return newSocketConnected; });
/* unused harmony export setTextFocus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return changeVideoVolume; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return manageToast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return setFullScreen; });
/* unused harmony export loadLibrary */
/* unused harmony export loadLibraryUpload */
/* unused harmony export loadCategory */
/* unused harmony export deleteUserContent */
/* unused harmony export loadsubFolders */
/* unused harmony export moveToFolder */
/* unused harmony export renameUserUpload */
/* unused harmony export getSearchData */
/* unused harmony export getStockSearchData */
/* unused harmony export loadMasterData */
/* unused harmony export clearPropCache */
/* unused harmony export getPrebuiltScenes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return updateUserDetails; });
/* unused harmony export createFolder */
/* unused harmony export setUserDetails */
/* unused harmony export reqUpdate */
/* unused harmony export clearDataCache */
/* unused harmony export clearActions */
/* unused harmony export isUploadInProcess */
/* unused harmony export stopTour */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return startTour; });
/* unused harmony export openTourGuide */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return suggestionPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return nextBtnClicked; });
/* unused harmony export updateSuggestion */
/* unused harmony export updateTourId */
/* unused harmony export appLoaded */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return uploadedFile; });
/* unused harmony export startApp */
/* unused harmony export suggPos */
/* unused harmony export setTourMenu */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return updateUserActive; });
/* unused harmony export fromMenu */
/* unused harmony export addTourStep */
/* unused harmony export addedUpload */
/* unused harmony export startToolTour */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return fileToUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return itemToUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return draggedFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return undoScenePaste; });
/* unused harmony export getActionSearchData */
/* unused harmony export libCurrentFolder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return applyAllTransition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return applyAllTransitionComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addLinkToText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return addLinkToTextComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return setPlayerPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return addSlideLabelData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return setScenePosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return removeScenePosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return setAutoPlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return setPreview; });
/* unused harmony export setWorkspaceItemsOrder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return setWorkspaceItemsOrderComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return setAnimateValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return setAnimateValueComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return setWorkspaceStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return setZoomFit; });
/* unused harmony export setApplyEffectSlides */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return setLabelValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return setNewActionComplete; });
/* unused harmony export setTextWidth */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addLinkToObj; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addLinkToObjComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return fireAppCrash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return projectRestore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return setPaymentPastDue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return setSlideJump; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return setIsShapeInGrp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return setIsTextClicked; });
/* Project Start *//* Multimove */var appLoadProgess=function appLoadProgess(data){return{type:"APP_LOAD_PROGRESS",data:data};};/* Transform Manager*/var moveUpdate=function moveUpdate(data,socket){return{type:"MOVE_UPDATE",data:data,socket:socket};};var moveUpdateComplete=function moveUpdateComplete(selectedScene,workspaceItems,workspaceChildren,currentContainer,socketId,currentSocketId){return{type:"MOVE_UPDATE_COMPLETE",selectedScene:selectedScene,workspaceItems:workspaceItems,workspaceChildren:workspaceChildren,currentContainer:currentContainer,socketId:socketId,currentSocketId:currentSocketId};};var changelibBG=function changelibBG(data){return{type:"CHANGE_LIB_BG",data:data};};var deleteBG=function deleteBG(data,socket){return{type:"DELETE_BG",data:data,socket:socket};};var dropBG=function dropBG(data,deleteData,socket){return{type:"DROP_BG",data:data,deleteData:deleteData,socket:socket};};var resizeUpdate=function resizeUpdate(data,socket){return{type:"RESIZE_UPDATE",data:data,socket:socket};};var rotationUpdate=function rotationUpdate(data,socket){return{type:"ROTATION_UPDATE",data:data,socket:socket};};var setSelectedItems=function setSelectedItems(data,socket){return{type:"SET_SELECTED_ITEMS",data:data,socket:socket};};var changeVideoVolumeComplete=function changeVideoVolumeComplete(selectedScene,objectId,objectData,socketId,currentSocketId){return{type:'CHANGE_VIDEO_VOLUME_COMPLETE',selectedScene:selectedScene,objectId:objectId,socketId:socketId,currentSocketId:currentSocketId};};/* Text*/var changeText=function changeText(data,socket){return{type:"CHANGE_TEXT",data:data,socket:socket};};var changeTextComplete=function changeTextComplete(selectedScene,currentContainer,itemId,objectData,socketId,currentSocketId,selfUpdate){return{type:"CHANGE_TEXT_COMPLETE",selectedScene:selectedScene,currentContainer:currentContainer,itemId:itemId,objectData:objectData,socketId:socketId,currentSocketId:currentSocketId,selfUpdate:selfUpdate};};var updateText=function updateText(data,socket){return{type:"UPDATE_TEXT",data:data,socket:socket};};var updateTextStatus=function updateTextStatus(data){return{type:"UPDATE_TEXT_STATUS",data:data};};var setTextOptions=function setTextOptions(data){return{type:"SET_TEXT_OPTIONS",data:data};};var updateGroupText=function updateGroupText(data,socket){return{type:"UPDATE_GROUP_TEXT",data:data,socket:socket};};/* Project Initiation */var initateProject=function initateProject(data){return{type:"INITIATE_PROJECT",data:data};};var loadSceneThumbnails=function loadSceneThumbnails(data){return{type:"LOAD_SCENE_THUMBNAILS",data:data};};/* Project End *//* Library Start */var setSearchData=function setSearchData(data){return{type:"SET_SEARCH_DATA",data:data};};/* Library End */var toggleCrop=function toggleCrop(){return{type:"TOGGLE_CROP"};};var toggleBgCrop=function toggleBgCrop(){return{type:"TOGGLE_BG_CROP"};};var toggleFrame=function toggleFrame(){return{type:"TOGGLE_FRAME"};};var cropImage=function cropImage(data,socket){return{type:'CROP_IMAGE',data:data,socket:socket};};var cropImageComplete=function cropImageComplete(selectedScene,itemId,objectData,socketId,currentSocketId){return{type:'CROP_IMAGE_COMPLETE',selectedScene:selectedScene,itemId:itemId,objectData:objectData,socketId:socketId,currentSocketId:currentSocketId};};var cropBG=function cropBG(data,socket){return{type:'CROP_BG',data:data,socket:socket};};var cropBgComplete=function cropBgComplete(selectedScene,objectData,isVideo,videoId,bgScales,socketId,currentSocketId){return{type:'CROP_BG_COMPLETE',selectedScene:selectedScene,objectData:objectData,isVideo:isVideo,videoId:videoId,bgScales:bgScales,socketId:socketId,currentSocketId:currentSocketId};};var toggleVideoCrop=function toggleVideoCrop(id){return{type:'TOGGLE_VIDEO_CROP',id:id};};var updateTransformStatus=function updateTransformStatus(data){return{type:"UPDATE_TRANSFORM_STATUS",data:data};};var showLibrary=function showLibrary(data){return{type:"SHOW_LIBRARY",data:data};};var startPlay=function startPlay(data,source,playHead){return{type:"START_PLAY",data:data,source:source,playHead:playHead};};var addTween=function addTween(data,tweenType){return{type:"ADD_TWEEN",data:data,tweenType:tweenType};};var updateSVGColor=function updateSVGColor(socket,id,cls,color,selectedScene,container){return{type:'UPDATE_SVGCOLOR',socket:socket,id:id,cls:cls,color:color,selectedScene:selectedScene,container:container};};var updateBGColor=function updateBGColor(socket,cls,color,selectedScene,container){return{type:'UPDATE_BGCOLOR',socket:socket,cls:cls,color:color,selectedScene:selectedScene,container:container};};var updateBGGradient=function updateBGGradient(socket,cls,color,selectedScene,container){return{type:'UPDATE_BGGRADIENT',socket:socket,cls:cls,color:color,selectedScene:selectedScene,container:container};};var updateBgColorComplete=function updateBgColorComplete(selectedScene,Cls,color,socketid,currentSocketId){return{type:'UPDATE_BGCOLOR_COMPLETE',selectedScene:selectedScene,Cls:Cls,color:color,socketid:socketid,currentSocketId:currentSocketId};};var updateBgGradientComplete=function updateBgGradientComplete(selectedScene,gradientIndex,gradientSecIndex,color,socketid,currentSocketId){return{type:'UPDATE_BGGRADIENT_COMPLETE',selectedScene:selectedScene,gradientIndex:gradientIndex,gradientSecIndex:gradientSecIndex,color:color,socketid:socketid,currentSocketId:currentSocketId};};var updateSVGTheme=function updateSVGTheme(socket,id,colorData,selectedScene,container,isBG){return{type:'UPDATE_SVG_THEME',socket:socket,id:id,colorData:colorData,selectedScene:selectedScene,container:container,isBG:isBG};};var changePlayTime=function changePlayTime(data){return{type:"CHANGE_PLAYTIME",data:data};};var flipItem=function flipItem(data,socket){return{type:"FLIP_ITEM",data:data,socket:socket};};var flipItemComplete=function flipItemComplete(selectedScene,itemId,flipPosition,socketId,currentSocketId){return{type:'FLIP_ITEM_COMPLETE',selectedScene:selectedScene,itemId:itemId,flipPosition:flipPosition,socketId:socketId,currentSocketId:currentSocketId};};var deleteItem=function deleteItem(data,socket){return{type:'DELETE_ITEM',data:data,socket:socket};};var deleteItemComplete=function deleteItemComplete(selectedScene,workspaceIds,workspaceChildrenIds,indexChangeIds,socketId,currentSocketId){return{type:'DELETE_ITEM_COMPLETE',selectedScene:selectedScene,workspaceIds:workspaceIds,workspaceChildrenIds:workspaceChildrenIds,indexChangeIds:indexChangeIds,socketId:socketId,currentSocketId:currentSocketId};};/* Timeline */var onItemDrag=function onItemDrag(socket,item,data,id,selItem,selectedScene,category){return{type:'UPDATE_TIMELINE_DRAG',socket:socket,item:item,data:data,id:id,selItem:selItem,selectedScene:selectedScene,category:category};};var applyEnterEffect=function applyEnterEffect(data,socket){return{type:'APPLY_ENTER_EFFECT',data:data,socket:socket};};var applyEnterEffectComplete=function applyEnterEffectComplete(projectid,selectedScene,effectData,isUndo,sceneEffectData,socketId,currentSocketId){return{type:'APPLY_ENTER_EFFECT_COMPLETE',projectid:projectid,selectedScene:selectedScene,effectData:effectData,isUndo:isUndo,sceneEffectData:sceneEffectData,socketId:socketId,currentSocketId:currentSocketId};};var updateTimelineDragChangeComplete=function updateTimelineDragChangeComplete(selectedScene,itemData,actionData,idVal,childToUpdate,socketId,currentSocketId){return{type:'UPDATE_TIMELINE_DRAG_COMPLETE',selectedScene:selectedScene,itemData:itemData,actionData:actionData,idVal:idVal,childToUpdate:childToUpdate,socketId:socketId,currentSocketId:currentSocketId};};var changeObjectThumb=function changeObjectThumb(timeName,socket,time,id,selectedScene,index){return{type:timeName,socket:socket,time:time,id:id,selectedScene:selectedScene,index:index};};var deleteObject=function deleteObject(type,socket,id,selectedScene,selectedItem){return{type:type,socket:socket,id:id,selectedScene:selectedScene,selectedItem:selectedItem};};var updateVolume=function updateVolume(type,value,id,selectedScene,selectedItem,socket){return{type:type,value:value,id:id,selectedScene:selectedScene,selectedItem:selectedItem,socket:socket};};var setWorkspaceTextFocus=function setWorkspaceTextFocus(value){return{type:'SET_WORKSPACE_TEXT_FOCUS',value:value};};var addUploadItem=function addUploadItem(data){return{type:'ADD_UPLOAD_ITEM',data:data};};/* Slides */var addScene=function addScene(data,socket){return{type:'ADD_SCENE',data:data,socket:socket};};var dropNewScene=function dropNewScene(data){return{type:'DROP_NEW_SCENE',data:data};};var addSceneComplete=function addSceneComplete(slideIndex,newslide,socketId,currentSocketId){return{type:'ADD_SCENE_COMPLETE',slideIndex:slideIndex,newslide:newslide,socketId:socketId,currentSocketId:currentSocketId};};var duplicateSceneComplete=function duplicateSceneComplete(slideIndex,newslide,socketId,currentSocketId){return{type:'DUPLICATE_SCENE_COMPLETE',slideIndex:slideIndex,newslide:newslide,socketId:socketId,currentSocketId:currentSocketId};};var setSelectedScene=function setSelectedScene(data,time,selectedScenes,socket){return{type:'SET_SELECTED_SCENE',data:data,time:time,selectedScenes:selectedScenes,socket:socket};};var moveScene=function moveScene(newIndex,oldIndex,socket){return{type:'MOVE_SCENE',newIndex:newIndex,oldIndex:oldIndex,socket:socket};};var moveSceneComplete=function moveSceneComplete(projectId,newIndex,oldIndex,socketId,currentSocketId){return{type:'MOVE_SCENE_COMPLETE',projectId:projectId,newIndex:newIndex,oldIndex:oldIndex,socketId:socketId,currentSocketId:currentSocketId};};var removeScene=function removeScene(data,socket){return{type:'REMOVE_SCENE',data:data,socket:socket};};var removeSceneComplete=function removeSceneComplete(slideIndex,socketId,currentSocketId){return{type:'REMOVE_SCENE_COMPLETE',slideIndex:slideIndex,socketId:socketId,currentSocketId:currentSocketId};};var addSceneTransitionComplete=function addSceneTransitionComplete(slideIndex,transitionName,sizes,socketId,currentSocketId){return{type:'ADD_SCENE_TRANSITION_COMPLETE',slideIndex:slideIndex,transitionName:transitionName,sizes:sizes,socketId:socketId,currentSocketId:currentSocketId};};var changeSceneTransColorComplete=function changeSceneTransColorComplete(selectedScene,color,socketId,currentSocketId){return{type:'ADD_SCENE_TRANSITION_COLOR_COMPLETE',selectedScene:selectedScene,color:color,socketId:socketId,currentSocketId:currentSocketId};};var changeExpressionComplete=function changeExpressionComplete(selectedIndex,itemId,itemLabel,socketId,currentSocketId){return{type:'CHANGE_EXPRESSION_COMPLETE',selectedIndex:selectedIndex,itemId:itemId,itemLabel:itemLabel,socketId:socketId,currentSocketId:currentSocketId};};var changeActionComplete=function changeActionComplete(selectedIndex,itemId,itemLabel,socketId,currentSocketId){return{type:'CHANGE_ACTION_COMPLETE',selectedIndex:selectedIndex,itemId:itemId,itemLabel:itemLabel,socketId:socketId,currentSocketId:currentSocketId};};var deleteBgComplete=function deleteBgComplete(selectedScene,socketId,currentSocketId){return{type:'DELETE_BG_COMPLETE',selectedScene:selectedScene,socketId:socketId,currentSocketId:currentSocketId};};var showSlides=function showSlides(showPosition){return{type:'SHOW_SLIDE_PANEL',data:showPosition};};var addObj=function addObj(data,socket){return{type:'ADD_OBJECT',data:data,socket:socket};};var upAddObj=function upAddObj(data,socket){return{type:'UP_ADD_OBJECT',data:data,socket:socket};};var changeAnimationType=function changeAnimationType(selectedScene,itemId,value,socket){return{type:'CHANGE_ANIMATION_TYPE',selectedScene:selectedScene,itemId:itemId,value:value,socket:socket};};var changeAnimationTypeComplete=function changeAnimationTypeComplete(selectedScene,itemId,value,socketId,currentSocketId){return{type:"CHANGE_ANIMATION_TYPE_COMPLETE",selectedScene:selectedScene,itemId:itemId,value:value,socketId:socketId,currentSocketId:currentSocketId};};var addObjComplete=function addObjComplete(selectedScene,workspaceIds,workspaceData,workspaceChildrenIds,workspaceChildData,socketId,currentSocketId){return{type:'ADD_OBJECT_COMPLETE',selectedScene:selectedScene,workspaceIds:workspaceIds,workspaceData:workspaceData,workspaceChildrenIds:workspaceChildrenIds,workspaceChildData:workspaceChildData,socketId:socketId,currentSocketId:currentSocketId};};var changeBgComplete=function changeBgComplete(selectedScene,workspaceBG,deleteId,deleteData,socketId,currentSocketId){return{type:'DROP_BG_COMPLETE',selectedScene:selectedScene,workspaceBG:workspaceBG,deleteId:deleteId,deleteData:deleteData,socketId:socketId,currentSocketId:currentSocketId};};var duplicateScene=function duplicateScene(data,socket){return{type:'DUPLICATE_SCENE',data:data,socket:socket};};var setZoom=function setZoom(data){return{type:'SET_ZOOM',data:data};};var setPlay=function setPlay(data,selectedScene){return{type:'SET_PLAY',data:data,selectedScene:selectedScene};};var setPlayAll=function setPlayAll(data,fromStart){return{type:'SET_PLAY_ALL',data:data,fromStart:fromStart};};var setZIndex=function setZIndex(data,socket){return{type:'SET_Z_INDEX',data:data,socket:socket};};var setZIndexComplete=function setZIndexComplete(selectedScene,indexChangeIds,socketId,currentSocketId){return{type:'SET_Z_INDEX_COMPLETE',selectedScene:selectedScene,indexChangeIds:indexChangeIds,socketId:socketId,currentSocketId:currentSocketId};};var changeBg=function changeBg(data,socket){return{type:'CHANGE_BG',data:data,socket:socket};};var toggleGrid=function toggleGrid(data){return{type:'TOGGLE_GRID',data:data};};var swapItem=function swapItem(data){return{type:'SWAP_ITEM',data:data};};var swapItemUndo=function swapItemUndo(data){return{type:'SWAP_ITEM_UNDO',data:data};};var setCopyItemType=function setCopyItemType(data){return{type:'COPY_ITEM_TYPE',data:data};};var copyObjects=function copyObjects(value){return{type:'COPY_OBJECTS',value:value};};var cutObjects=function cutObjects(value){return{type:'CUT_OBJECTS',value:value};};var pasteObjects=function pasteObjects(value){return{type:'PASTE_OBJECTS',value:value};};var pasteItems=function pasteItems(data,socket){return{type:'PASTE_ITEMS',data:data,socket:socket};};var pasteItemsComplete=function pasteItemsComplete(selectedScene,workspaceIds,workspaceChildrenIds,workspaceData,workspaceChildData,socketId,currentSocketId,socket){return{type:'PASTE_ITEMS_COMPLETE',selectedScene:selectedScene,workspaceIds:workspaceIds,workspaceChildrenIds:workspaceChildrenIds,workspaceData:workspaceData,workspaceChildData:workspaceChildData,socketId:socketId,currentSocketId:currentSocketId,socket:socket};};var groupObjects=function groupObjects(data,socket){return{type:'GROUP_OBJECTS',data:data,socket:socket};};var groupObjectsComplete=function groupObjectsComplete(selectedScene,removeIds,workspaceItems,workspaceChildren,workspaceItemsOrder,socketId,currentSocketId){return{type:'GROUP_OBJECTS_COMPLETE',selectedScene:selectedScene,removeIds:removeIds,workspaceItems:workspaceItems,workspaceChildren:workspaceChildren,workspaceItemsOrder:workspaceItemsOrder,socketId:socketId,currentSocketId:currentSocketId};};var unGroupObjects=function unGroupObjects(data,socket){return{type:'UNGROUP_OBJECTS',data:data,socket:socket};};var ungroupObjectsComplete=function ungroupObjectsComplete(selectedScene,removeIds,workspaceChildren,workspaceItemsOrder,socketId,currentSocketId){return{type:'UNGROUP_OBJECTS_COMPLETE',selectedScene:selectedScene,removeIds:removeIds,workspaceChildren:workspaceChildren,workspaceItemsOrder:workspaceItemsOrder,socketId:socketId,currentSocketId:currentSocketId};};var setPropertyWindow=function setPropertyWindow(data){return{type:'SET_PROPERTY_WINDOW',data:data};};var addSceneTransition=function addSceneTransition(data,sizes,slideIndex,socket){return{type:'ADD_SCENE_TRANSITION',data:data,sizes:sizes,slideIndex:slideIndex,socket:socket};};var changeAction=function changeAction(label,id,selectedScene,socket){return{type:'CHANGE_ACTION',label:label,id:id,selectedScene:selectedScene,socket:socket};};var changeExpression=function changeExpression(label,id,selectedScene,socket){return{type:'CHANGE_EXPRESSION',label:label,id:id,selectedScene:selectedScene,socket:socket};};var changeBGThumbValue=function changeBGThumbValue(type,value,thumbPosition,selectedScene,socket){return{type:type,value:value,thumbPosition:thumbPosition,selectedScene:selectedScene,socket:socket};};var bgColorSelection=function bgColorSelection(socket,value,selectedScene,enteredColorPosition,deletePosition,animakerType){return{type:'BG_COLOR_SELECTION',socket:socket,value:value,selectedScene:selectedScene,enteredColorPosition:enteredColorPosition,deletePosition:deletePosition,animakerType:animakerType};};var bgColorSelectionComplete=function bgColorSelectionComplete(selectedScene,objectData,socketId,currentSocketId){return{type:'BG_COLOR_SELECTION_COMPLETE',selectedScene:selectedScene,objectData:objectData,socketId:socketId,currentSocketId:currentSocketId};};var applyFilter=function applyFilter(active,filterCode,selectedScene,socket){return{type:'APPLY_FILTER',active:active,filterCode:filterCode,selectedScene:selectedScene,socket:socket};};var applyFilterComplete=function applyFilterComplete(selectedScene,objectId,objectData,socketId,currentSocketId){return{type:'APPLY_FILTER_COMPLETE',selectedScene:selectedScene,objectId:objectId,objectData:objectData,socketId:socketId,currentSocketId:currentSocketId};};var copyFilter=function copyFilter(data,subtype){return{type:'COPY_FILTER',data:data,subtype:subtype};};var bgGradientSetting=function bgGradientSetting(value,selectedScene,radialStatus,radius,socket){return{type:'BG_GRADIENT_COLORS',value:value,selectedScene:selectedScene,radialStatus:radialStatus,radius:radius,socket:socket};};var bgGradientColorsComplete=function bgGradientColorsComplete(selectedScene,radialStatus,direction,radius,socketId){return{type:'BG_GRADIENT_COLORS_COMPLETE',selectedScene:selectedScene,radialStatus:radialStatus,direction:direction,radius:radius,socketId:socketId};};var resizeProject=function resizeProject(data){return{type:"RESIZE_PROJECT",data:data};};var isUploadFromOutside=function isUploadFromOutside(data){return{type:'FROM_OUTSIDE_UPLOAD',data:data};};var loadCommonPopup=function loadCommonPopup(value){var status=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;return{type:"DISPLAY_COMMON_POPUP",value:value,status:status};};var updateSvgColorComplete=function updateSvgColorComplete(selectedScene,container,itemId,itemCls,colorData,socketId,currentSocketId){return{type:"UPDATE_SVGCOLOR_COMPLETE",selectedScene:selectedScene,container:container,itemId:itemId,itemCls:itemCls,colorData:colorData,socketId:socketId,currentSocketId:currentSocketId};};var updateSvgThemeComplete=function updateSvgThemeComplete(projectid,selectedScene,container,itemId,colorData,isBG,socketId,currentSocketId){return{type:"UPDATE_SVGTHEME_COMPLETE",projectid:projectid,selectedScene:selectedScene,container:container,itemId:itemId,colorData:colorData,isBG:isBG,socketId:socketId,currentSocketId:currentSocketId};};var updateObject=function updateObject(data,socket){return{type:"UPDATE_OBJECT",data:data,socket:socket};};var writeText=function writeText(data,socket){return{type:"WRITE_TEXT",data:data,socket:socket};};var syncText=function syncText(data){return{type:"SYNC_TEXT",data:data};};var updateObjectComplete=function updateObjectComplete(projectid,selectedScene,selectedItem,container,toUpdate,socketId,currentSocketId){return{type:"UPDATE_OBJECT_COMPLETE",projectid:projectid,selectedScene:selectedScene,selectedItem:selectedItem,container:container,toUpdate:toUpdate,socketId:socketId,currentSocketId:currentSocketId};};var setUserFonts=function setUserFonts(data){return{type:"SET_USER_FONTS",data:data};};var setShareDetails=function setShareDetails(data){return{type:"SET_SHARE_DETAILS",data:data};};var fontUploaded=function fontUploaded(data){return{type:"FONT_UPLOADED",data:data};};var updateRecentColors=function updateRecentColors(data){return{type:"UPDATE_RECENT_COLORS",data:data};};var updateObjectById=function updateObjectById(data,socket){return{type:"UPDATE_OBJECT_BY_ID",data:data,socket:socket};};var setSelectedKey=function setSelectedKey(id,time,selectedScene,selectedId,selectedItem){return{type:'SET_SELECTED_KEYFRAME',id:id,time:time,selectedScene:selectedScene,selectedId:selectedId,selectedItem:selectedItem};};var updateTextComplete=function updateTextComplete(isGrouped,selectedScene,selectedId,container,formats,childIds,socketId,currentSocketId,selfUpdate){return{type:"UPDATE_TEXT_COMPLETE",isGrouped:isGrouped,selectedScene:selectedScene,selectedId:selectedId,container:container,formats:formats,childIds:childIds,socketId:socketId,currentSocketId:currentSocketId,selfUpdate:selfUpdate};};var updateGroupTextComplete=function updateGroupTextComplete(selectedScene,workspaceItems,workspaceChildren,socketId,currentSocketId,selfUpdate){return{type:"UPDATE_GROUP_TEXT_COMPLETE",selectedScene:selectedScene,workspaceItems:workspaceItems,workspaceChildren:workspaceChildren,socketId:socketId,currentSocketId:currentSocketId,selfUpdate:selfUpdate};};var setPrebuiltLoad=function setPrebuiltLoad(data,source){return{type:'SET_PREBUILT_LOAD',data:data,source:source};};var addPrebuilt=function addPrebuilt(data,socket){return{type:'ADD_PREBUILT',data:data,socket:socket};};var addPrebuiltComplete=function addPrebuiltComplete(selectedScene,prebuiltData,replace,addAll,socketId,currentSocketId){return{type:'ADD_PREBUILT_COMPLETE',selectedScene:selectedScene,prebuiltData:prebuiltData,replace:replace,addAll:addAll,socketId:socketId,currentSocketId:currentSocketId};};var toggleToolBar=function toggleToolBar(data){return{type:'TOGGLE_TOOLBAR',data:data};};var addBulkObjects=function addBulkObjects(data){return{type:'ADD_BULK_OBJECTS',data:data};};var uploadBulkUpdate=function uploadBulkUpdate(data,socket){return{type:'UPLOAD_BULK_UPDATE',data:data,socket:socket};};var uploadBulkUpdateComplete=function uploadBulkUpdateComplete(data){return{type:'UPLOAD_BULK_UPDATE_COMPLETE',data:data};};var uploadBulkDelete=function uploadBulkDelete(data,socket){return{type:'UPLOAD_BULK_DELETE',data:data,socket:socket};};var uploadBulkDeleteComplete=function uploadBulkDeleteComplete(data){return{type:'UPLOAD_BULK_DELETE_COMPLETE',data:data};};var undoMove=function undoMove(data){return{type:'UNDO_MOVE',data:data};};var updateTextFormats=function updateTextFormats(data){return{type:'UPDATE_TEXT_FORMATS',data:data};};var updateSlide=function updateSlide(data){return{type:'UPDATE_SLIDE',data:data};};var setSelectedItemsComplete=function setSelectedItemsComplete(projectid,selectedItems,projectUsr,userId,projectUsrImg,socketid,currentSocketId){return{type:'SET_SELECTED_ITEMS_COMPLETE',projectid:projectid,selectedItems:selectedItems,projectUsr:projectUsr,userId:userId,projectUsrImg:projectUsrImg,socketid:socketid,currentSocketId:currentSocketId};};var setSelectedSceneComplete=function setSelectedSceneComplete(projectid,selectedItems,projectUsr,userId,projectUsrImg,socketid,currentSocketId){return{type:'SET_SELECTED_SCENE_COMPLETE',projectid:projectid,selectedItems:selectedItems,projectUsr:projectUsr,userId:userId,projectUsrImg:projectUsrImg,socketid:socketid,currentSocketId:currentSocketId};};var pasteScenesComplete=function pasteScenesComplete(selectedScene,scenes,socketId,currentSocketId,socket){return{type:'PASTE_SCENES_COMPLETE',selectedScene:selectedScene,scenes:scenes,socketId:socketId,currentSocketId:currentSocketId,socket:socket};};var swapWorkspaceItems=function swapWorkspaceItems(data){return{type:'SWAP_WORKSPACE_ITEMS',data:data};};var organiseScenes=function organiseScenes(data){return{type:'ORGANISE_SCENES',data:data};};var continueScene=function continueScene(index){return{type:'CONTINUE_SCENE',index:index};};var saveScreenshot=function saveScreenshot(index,scene,project,userId,projectId,sceneId,isExceeded,screenshots){return{type:'SAVE_SCREENSHOT',index:index,scene:scene,project:project,userId:userId,projectId:projectId,sceneId:sceneId,isExceeded:isExceeded,screenshots:screenshots};};var updateSceneComplete=function updateSceneComplete(projectid,selectedScene,toUpdate,toEmit,socketId,currentSocketId){return{type:'UPDATE_SCENE_COMPLETE',projectid:projectid,selectedScene:selectedScene,toUpdate:toUpdate,toEmit:toEmit,socketId:socketId,currentSocketId:currentSocketId};};var updateScene=function updateScene(data,socket){return{type:"UPDATE_SCENE",data:data,socket:socket};};var updateBgComplete=function updateBgComplete(projectid,selectedScene,toUpdate,socketId){return{type:'UPDATE_BG_COMPLETE',projectid:projectid,selectedScene:selectedScene,toUpdate:toUpdate,socketId:socketId};};var updateProjectComplete=function updateProjectComplete(projectid,toUpdate,socketId,currentSocketId){return{type:'UPDATE_PROJECT_COMPLETE',projectid:projectid,toUpdate:toUpdate,socketId:socketId,currentSocketId:currentSocketId};};var saveProjectName=function saveProjectName(data,socket){return{type:'SAVE_PROJECT_NAME',data:data,socket:socket};};var setFullTab=function setFullTab(data){return{type:'SET_FULL_TAB',data:data};};var updateSelectionBox=function updateSelectionBox(data){return{type:"UPDATE_SELECTION_BOX",data:data};};var socketConnected=function socketConnected(projectId,userId,selectedItems,imageUrl,projectUsr,socketId,currentSocketId){return{type:"SOCKET_CONNECTED",projectId:projectId,userId:userId,selectedItems:selectedItems,imageUrl:imageUrl,projectUsr:projectUsr,socketId:socketId,currentSocketId:currentSocketId};};var socketDisconnected=function socketDisconnected(data){return{type:"SOCKET_DISCONNECTED",data:data};};var openLibrarySection=function openLibrarySection(data){return{type:"OPEN_LIBRARY_SECTION_TOOGLE",data:data};};var setCurrentPosition=function setCurrentPosition(data){return{type:"SET_CURRENT_POSITION",data:data};};var newSocketConnected=function newSocketConnected(data){return{type:"NEW_SOCKET_CONNECTED",data:data};};var setTextFocus=function setTextFocus(value){return{type:'SET_TEXT_FOCUS',value:value};};var changeVideoVolume=function changeVideoVolume(data,socket){return{type:"CHANGE_VIDEO_VOLUME",data:data,socket:socket};};var manageToast=function manageToast(data){return{type:"MANAGE_TOAST",data:data};};var setFullScreen=function setFullScreen(data){return{type:'SET_FULSCREEN',data:data};};var loadLibrary=function loadLibrary(libData){return{type:"LOAD_LIBRARY",libData:libData};};var loadLibraryUpload=function loadLibraryUpload(libData){return{type:"LOAD_LIBRARY_UPLOAD",libData:libData};};var loadCategory=function loadCategory(libData){return{type:"LOAD_LIBRARY_CATEGORY",libData:libData};};var deleteUserContent=function deleteUserContent(id,userId){return{type:"DELETE_FILE",id:id,userId:userId};};var loadsubFolders=function loadsubFolders(libData){return{type:"LOAD_USER_FOLDERS",libData:libData};};var moveToFolder=function moveToFolder(libData){return{type:"MOVE_FILE_LOCATION",libData:libData};};var renameUserUpload=function renameUserUpload(libData){return{type:"RENAME_USER_FILE",libData:libData};};var getSearchData=function getSearchData(libData){return{type:"FETCH_SEARCH",libData:libData};};var getStockSearchData=function getStockSearchData(libData){return{type:"FETCH_STOCK_SEARCH",libData:libData};};var loadMasterData=function loadMasterData(libData){return{type:"LOAD_LIBRARY_MASTER",libData:libData};};var clearPropCache=function clearPropCache(){return{type:'CLEAR_PROP_CACHE'};};var getPrebuiltScenes=function getPrebuiltScenes(data){return{type:'GET_PREBUILT_SCENES',data:data};};var updateUserDetails=function updateUserDetails(data){return{type:"UPDATE_USER_DETAILS",data:data};};var createFolder=function createFolder(libData){return{type:"CREATE_LIBRARY_FOLDER",libData:libData};};var setUserDetails=function setUserDetails(data){return{type:"SET_USER_DETAILS",data:data};};var reqUpdate=function reqUpdate(data){return{type:"RESP_UPDATE",data:data};};var clearDataCache=function clearDataCache(data){return{type:"CLEAR_DATA_CACHE",data:data};};var clearActions=function clearActions(){return{type:'CLEAR_ACTIONS'};};var isUploadInProcess=function isUploadInProcess(data){return{type:'IS_UPLOAD_IN_PROCESS',data:data};};var stopTour=function stopTour(data){return{type:'STOP_TOUR',data:data};};var startTour=function startTour(data){return{type:'START_TOUR',data:data};};var openTourGuide=function openTourGuide(data){return{type:'OPEN_TOUR_GUIDE',data:data};};var suggestionPopup=function suggestionPopup(data){return{type:'SUGGESTION_POPUP',data:data};};var nextBtnClicked=function nextBtnClicked(data){return{type:'NEXT_BTN_CLICKED',data:data};};var updateSuggestion=function updateSuggestion(data){return{type:'UPDATE_SUGGESTION',data:data};};var updateTourId=function updateTourId(data){return{type:'UPDATE_TOUR_ID',data:data};};var appLoaded=function appLoaded(){return{type:'APP_LOADED'};};var uploadedFile=function uploadedFile(data){return{type:'UPLOADED_FILE',data:data};};var startApp=function startApp(data){return{type:'START_APP',data:data};};var suggPos=function suggPos(data){return{type:'SUGG_POS',data:data};};var setTourMenu=function setTourMenu(data){return{type:'SET_TOUR_MENU',data:data};};var updateUserActive=function updateUserActive(data){return{type:'UPDATE_USER_ACTIVE',data:data};};var fromMenu=function fromMenu(data){return{type:'FROM_TOUR',data:data};};var addTourStep=function addTourStep(data){return{type:'ADD_TOUR_STEP',data:data};};var addedUpload=function addedUpload(data){return{type:'ADDED_UPLOAD',data:data};};var startToolTour=function startToolTour(data){return{type:'CHANGE_TOOL_TOUR',data:data};};var fileToUpload=function fileToUpload(data){return{type:'FILE_TO_UPLOAD',data:data};};var itemToUpdate=function itemToUpdate(data){return{type:'ITEM_TO_UPDATE',data:data};};var draggedFile=function draggedFile(data){return{type:'DRAGGED_FILE',data:data};};var undoScenePaste=function undoScenePaste(data,socket){return{type:'UNDO_SCENE_PASTE',data:data,socket:socket};};var getActionSearchData=function getActionSearchData(libData){return{type:"FETCH_ACTION_SEARCH",libData:libData};};var libCurrentFolder=function libCurrentFolder(data){return{type:'LIB_CURRENT_FOLDER',data:data};};var applyAllTransition=function applyAllTransition(data,socket){return{type:'APPLY_ALL_TRANSITION',data:data,socket:socket};};var applyAllTransitionComplete=function applyAllTransitionComplete(projectid,transData,isUndo,sceneTransData,socketId,currentSocketId){return{type:'APPLY_ALL_TRANSITION_COMPLETE',projectid:projectid,transData:transData,isUndo:isUndo,sceneTransData:sceneTransData,socketId:socketId,currentSocketId:currentSocketId};};var addLinkToText=function addLinkToText(data,socket){return{type:'ADD_LINK_TO_TEXT',data:data,socket:socket};};var addLinkToTextComplete=function addLinkToTextComplete(projectid,selectedScene,container,selectedItem,hyperLinkData,socketId,currentSocketId){return{type:'ADD_LINK_TO_TEXT_COMPLETE',projectid:projectid,selectedScene:selectedScene,container:container,selectedItem:selectedItem,hyperLinkData:hyperLinkData,socketId:socketId,currentSocketId:currentSocketId};};var setPlayerPosition=function setPlayerPosition(data){return{type:'SET_PLAYER_POSITION',data:data};};var addSlideLabelData=function addSlideLabelData(data){return{type:'ADD_SLIDELABEL_DATA',data:data};};var setScenePosition=function setScenePosition(data,currentSceneNumber,currentSceneStartTime,currentSceneDuration){return{type:'SET_SCENE_POSITION',data:data,currentSceneNumber:currentSceneNumber,currentSceneStartTime:currentSceneStartTime,currentSceneDuration:currentSceneDuration};};var removeScenePosition=function removeScenePosition(){return{type:'REMOVE_SCENE_POSITION'};};var setAutoPlay=function setAutoPlay(data){return{type:'SET_AUTO_PLAY',data:data};};var setPreview=function setPreview(data){return{type:'SET_PREVIEW',data:data};};var setWorkspaceItemsOrder=function setWorkspaceItemsOrder(data,socket){return{type:'SET_WORKSPACE_ITEMS_ORDER',data:data,socket:socket};};var setWorkspaceItemsOrderComplete=function setWorkspaceItemsOrderComplete(projectId,selectedScene,container,workspaceItemsOrder,socketId,currentSocketId){return{type:'SET_WORKSPACE_ITEMS_ORDER_COMPLETE',projectId:projectId,selectedScene:selectedScene,container:container,workspaceItemsOrder:workspaceItemsOrder,socketId:socketId,currentSocketId:currentSocketId};};var setAnimateValue=function setAnimateValue(data,socket){return{type:'SET_ANIMATE_VALUE',data:data,socket:socket};};var setAnimateValueComplete=function setAnimateValueComplete(projectId,selectedScene,container,selectedItem,animateData,socketId,currentSocketId){return{type:'SET_ANIMATE_VALUE_COMPLETE',projectId:projectId,selectedScene:selectedScene,container:container,selectedItem:selectedItem,animateData:animateData,socketId:socketId,currentSocketId:currentSocketId};};var setWorkspaceStage=function setWorkspaceStage(data){return{type:'SET_WORKSPACE_STAGE',data:data};};var setZoomFit=function setZoomFit(data){return{type:'SET_ZOOM_FIT',data:data};};var setApplyEffectSlides=function setApplyEffectSlides(data){return{type:'SET_APPLYEFFECT_SLIDES',data:data};};var setLabelValues=function setLabelValues(data){return{type:'SET_LABEL_VALUES',data:data};};var setNewActionComplete=function setNewActionComplete(data){return{type:'SET_NEW_ACTION_COMPLETE',data:data};};var setTextWidth=function setTextWidth(data,socket){return{type:'SET_TEXT_WIDTH',data:data,socket:socket};};var addLinkToObj=function addLinkToObj(data,socket){return{type:'ADD_LINK_TO_OBJ',data:data,socket:socket};};var addLinkToObjComplete=function addLinkToObjComplete(projectid,selectedScene,selectedItem,linkData,socketId,currentSocketId){return{type:'ADD_LINK_TO_OBJ_COMPLETE',projectid:projectid,selectedScene:selectedScene,selectedItem:selectedItem,linkData:linkData,socketId:socketId,currentSocketId:currentSocketId};};var fireAppCrash=function fireAppCrash(errorId,error){return{type:'APP_CRASHED',errorData:{errorId:errorId,error:error}};};var projectRestore=function projectRestore(data,socket){return{type:'PROJECT_RESTORE',data:data,socket:socket};};var setPaymentPastDue=function setPaymentPastDue(data,socket){return{type:'SET_PAYMENT_PAST_DUE',data:data,socket:socket};};var setSlideJump=function setSlideJump(data){return{type:'SET_SLIDE_JUMP',data:data};};var setIsShapeInGrp=function setIsShapeInGrp(data){return{type:'SET_ISSHAPEINGRP',data:data};};var setIsTextClicked=function setIsTextClicked(data){return{type:'SET_IS_TEXTCLICKED',data:data};};

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__ = __webpack_require__(268);
/* unused harmony reexport addBreadcrumb */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["a"]; });
/* unused harmony reexport captureEvent */
/* unused harmony reexport captureMessage */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["b"]; });
/* unused harmony reexport startTransaction */
/* unused harmony reexport setContext */
/* unused harmony reexport setExtra */
/* unused harmony reexport setExtras */
/* unused harmony reexport setTag */
/* unused harmony reexport setTags */
/* unused harmony reexport setUser */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["c"]; });
/* unused harmony reexport getHubFromCarrier */
/* unused harmony reexport Hub */
/* unused harmony reexport makeMain */
/* unused harmony reexport Scope */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(277);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__api__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseclient__ = __webpack_require__(278);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__baseclient__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__basebackend__ = __webpack_require__(280);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__basebackend__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__request__ = __webpack_require__(281);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__request__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__request__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sdk__ = __webpack_require__(282);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__sdk__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transports_noop__ = __webpack_require__(132);
/* unused harmony reexport NoopTransport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__integrations__ = __webpack_require__(283);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__integrations__; });










//# sourceMappingURL=index.js.map

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module, global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_gsScope", function() { return _gsScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TweenLite", function() { return TweenLite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "globals", function() { return globals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TweenLite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SimpleTimeline", function() { return SimpleTimeline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Animation", function() { return Animation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ease", function() { return Ease; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Linear", function() { return Linear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Power0", function() { return Power0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Power1", function() { return Power1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Power2", function() { return Power2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Power3", function() { return Power3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Power4", function() { return Power4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TweenPlugin", function() { return TweenPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventDispatcher", function() { return EventDispatcher; });
/*!
 * VERSION: 2.1.3
 * DATE: 2019-05-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 *
 * @author: Jack Doyle, jack@greensock.com
 */
/* eslint-disable */

/* ES6 changes:
	- declare and export _gsScope at top.
	- set var TweenLite = the result of the main function
	- export default TweenLite at the bottom
	- return TweenLite at the bottom of the main function
	- pass in _gsScope as the first parameter of the main function (which is actually at the bottom)
	- remove the "export to multiple environments" in Definition().
 */
var _gsScope = (typeof(window) !== "undefined") ? window : (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || {};

var TweenLite = (function(window) {

		"use strict";
		var _exports = {},
			_doc = window.document,
			_globals = window.GreenSockGlobals = window.GreenSockGlobals || window;
		if (_globals.TweenLite) {
			return _globals.TweenLite; //in case the core set of classes is already loaded, don't instantiate twice.
		}
		var _namespace = function(ns) {
				var a = ns.split("."),
					p = _globals, i;
				for (i = 0; i < a.length; i++) {
					p[a[i]] = p = p[a[i]] || {};
				}
				return p;
			},
			gs = _namespace("com.greensock"),
			_tinyNum = 0.00000001,
			_slice = function(a) { //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
				var b = [],
					l = a.length,
					i;
				for (i = 0; i !== l; b.push(a[i++])) {}
				return b;
			},
			_emptyFunc = function() {},
			_isArray = (function() { //works around issues in iframe environments where the Array global isn't shared, thus if the object originates in a different window/iframe, "(obj instanceof Array)" will evaluate false. We added some speed optimizations to avoid Object.prototype.toString.call() unless it's absolutely necessary because it's VERY slow (like 20x slower)
				var toString = Object.prototype.toString,
					array = toString.call([]);
				return function(obj) {
					return obj != null && (obj instanceof Array || (typeof(obj) === "object" && !!obj.push && toString.call(obj) === array));
				};
			}()),
			a, i, p, _ticker, _tickerActive,
			_defLookup = {},

			/**
			 * @constructor
			 * Defines a GreenSock class, optionally with an array of dependencies that must be instantiated first and passed into the definition.
			 * This allows users to load GreenSock JS files in any order even if they have interdependencies (like CSSPlugin extends TweenPlugin which is
			 * inside TweenLite.js, but if CSSPlugin is loaded first, it should wait to run its code until TweenLite.js loads and instantiates TweenPlugin
			 * and then pass TweenPlugin to CSSPlugin's definition). This is all done automatically and internally.
			 *
			 * Every definition will be added to a "com.greensock" global object (typically window, but if a window.GreenSockGlobals object is found,
			 * it will go there as of v1.7). For example, TweenLite will be found at window.com.greensock.TweenLite and since it's a global class that should be available anywhere,
			 * it is ALSO referenced at window.TweenLite. However some classes aren't considered global, like the base com.greensock.core.Animation class, so
			 * those will only be at the package like window.com.greensock.core.Animation. Again, if you define a GreenSockGlobals object on the window, everything
			 * gets tucked neatly inside there instead of on the window directly. This allows you to do advanced things like load multiple versions of GreenSock
			 * files and put them into distinct objects (imagine a banner ad uses a newer version but the main site uses an older one). In that case, you could
			 * sandbox the banner one like:
			 *
			 * <script>
			 *     var gs = window.GreenSockGlobals = {}; //the newer version we're about to load could now be referenced in a "gs" object, like gs.TweenLite.to(...). Use whatever alias you want as long as it's unique, "gs" or "banner" or whatever.
			 * </script>
			 * <script src="js/greensock/v1.7/TweenMax.js"></script>
			 * <script>
			 *     window.GreenSockGlobals = window._gsQueue = window._gsDefine = null; //reset it back to null (along with the special _gsQueue variable) so that the next load of TweenMax affects the window and we can reference things directly like TweenLite.to(...)
			 * </script>
			 * <script src="js/greensock/v1.6/TweenMax.js"></script>
			 * <script>
			 *     gs.TweenLite.to(...); //would use v1.7
			 *     TweenLite.to(...); //would use v1.6
			 * </script>
			 *
			 * @param {!string} ns The namespace of the class definition, leaving off "com.greensock." as that's assumed. For example, "TweenLite" or "plugins.CSSPlugin" or "easing.Back".
			 * @param {!Array.<string>} dependencies An array of dependencies (described as their namespaces minus "com.greensock." prefix). For example ["TweenLite","plugins.TweenPlugin","core.Animation"]
			 * @param {!function():Object} func The function that should be called and passed the resolved dependencies which will return the actual class for this definition.
			 * @param {boolean=} global If true, the class will be added to the global scope (typically window unless you define a window.GreenSockGlobals object)
			 */
			Definition = function(ns, dependencies, func, global) {
				this.sc = (_defLookup[ns]) ? _defLookup[ns].sc : []; //subclasses
				_defLookup[ns] = this;
				this.gsClass = null;
				this.func = func;
				var _classes = [];
				this.check = function(init) {
					var i = dependencies.length,
						missing = i,
						cur, a, n, cl;
					while (--i > -1) {
						if ((cur = _defLookup[dependencies[i]] || new Definition(dependencies[i], [])).gsClass) {
							_classes[i] = cur.gsClass;
							missing--;
						} else if (init) {
							cur.sc.push(this);
						}
					}
					if (missing === 0 && func) {
						a = ("com.greensock." + ns).split(".");
						n = a.pop();
						cl = _namespace(a.join("."))[n] = this.gsClass = func.apply(func, _classes);

						//exports to multiple environments
						if (global) {
							_globals[n] = _exports[n] = cl; //provides a way to avoid global namespace pollution. By default, the main classes like TweenLite, Power1, Strong, etc. are added to window unless a GreenSockGlobals is defined. So if you want to have things added to a custom object instead, just do something like window.GreenSockGlobals = {} before loading any GreenSock files. You can even set up an alias like window.GreenSockGlobals = windows.gs = {} so that you can access everything like gs.TweenLite. Also remember that ALL classes are added to the window.com.greensock object (in their respective packages, like com.greensock.easing.Power1, com.greensock.TweenLite, etc.)
							/*
							if (typeof(module) !== "undefined" && module.exports) { //node
								if (ns === moduleName) {
									module.exports = _exports[moduleName] = cl;
									for (i in _exports) {
										cl[i] = _exports[i];
									}
								} else if (_exports[moduleName]) {
									_exports[moduleName][n] = cl;
								}
							} else if (typeof(define) === "function" && define.amd){ //AMD
								define((window.GreenSockAMDPath ? window.GreenSockAMDPath + "/" : "") + ns.split(".").pop(), [], function() { return cl; });
							}
							*/
						}
						for (i = 0; i < this.sc.length; i++) {
							this.sc[i].check();
						}
					}
				};
				this.check(true);
			},

			//used to create Definition instances (which basically registers a class that has dependencies).
			_gsDefine = window._gsDefine = function(ns, dependencies, func, global) {
				return new Definition(ns, dependencies, func, global);
			},

			//a quick way to create a class that doesn't have any dependencies. Returns the class, but first registers it in the GreenSock namespace so that other classes can grab it (other classes might be dependent on the class).
			_class = gs._class = function(ns, func, global) {
				func = func || function() {};
				_gsDefine(ns, [], function(){ return func; }, global);
				return func;
			};

		_gsDefine.globals = _globals;



/*
 * ----------------------------------------------------------------
 * Ease
 * ----------------------------------------------------------------
 */
		var _baseParams = [0, 0, 1, 1],
			Ease = _class("easing.Ease", function(func, extraParams, type, power) {
				this._func = func;
				this._type = type || 0;
				this._power = power || 0;
				this._params = extraParams ? _baseParams.concat(extraParams) : _baseParams;
			}, true),
			_easeMap = Ease.map = {},
			_easeReg = Ease.register = function(ease, names, types, create) {
				var na = names.split(","),
					i = na.length,
					ta = (types || "easeIn,easeOut,easeInOut").split(","),
					e, name, j, type;
				while (--i > -1) {
					name = na[i];
					e = create ? _class("easing."+name, null, true) : gs.easing[name] || {};
					j = ta.length;
					while (--j > -1) {
						type = ta[j];
						_easeMap[name + "." + type] = _easeMap[type + name] = e[type] = ease.getRatio ? ease : ease[type] || new ease();
					}
				}
			};

		p = Ease.prototype;
		p._calcEnd = false;
		p.getRatio = function(p) {
			if (this._func) {
				this._params[0] = p;
				return this._func.apply(null, this._params);
			}
			var t = this._type,
				pw = this._power,
				r = (t === 1) ? 1 - p : (t === 2) ? p : (p < 0.5) ? p * 2 : (1 - p) * 2;
			if (pw === 1) {
				r *= r;
			} else if (pw === 2) {
				r *= r * r;
			} else if (pw === 3) {
				r *= r * r * r;
			} else if (pw === 4) {
				r *= r * r * r * r;
			}
			return (t === 1) ? 1 - r : (t === 2) ? r : (p < 0.5) ? r / 2 : 1 - (r / 2);
		};

		//create all the standard eases like Linear, Quad, Cubic, Quart, Quint, Strong, Power0, Power1, Power2, Power3, and Power4 (each with easeIn, easeOut, and easeInOut)
		a = ["Linear","Quad","Cubic","Quart","Quint,Strong"];
		i = a.length;
		while (--i > -1) {
			p = a[i]+",Power"+i;
			_easeReg(new Ease(null,null,1,i), p, "easeOut", true);
			_easeReg(new Ease(null,null,2,i), p, "easeIn" + ((i === 0) ? ",easeNone" : ""));
			_easeReg(new Ease(null,null,3,i), p, "easeInOut");
		}
		_easeMap.linear = gs.easing.Linear.easeIn;
		_easeMap.swing = gs.easing.Quad.easeInOut; //for jQuery folks


/*
 * ----------------------------------------------------------------
 * EventDispatcher
 * ----------------------------------------------------------------
 */
		var EventDispatcher = _class("events.EventDispatcher", function(target) {
			this._listeners = {};
			this._eventTarget = target || this;
		});
		p = EventDispatcher.prototype;

		p.addEventListener = function(type, callback, scope, useParam, priority) {
			priority = priority || 0;
			var list = this._listeners[type],
				index = 0,
				listener, i;
			if (this === _ticker && !_tickerActive) {
				_ticker.wake();
			}
			if (list == null) {
				this._listeners[type] = list = [];
			}
			i = list.length;
			while (--i > -1) {
				listener = list[i];
				if (listener.c === callback && listener.s === scope) {
					list.splice(i, 1);
				} else if (index === 0 && listener.pr < priority) {
					index = i + 1;
				}
			}
			list.splice(index, 0, {c:callback, s:scope, up:useParam, pr:priority});
		};

		p.removeEventListener = function(type, callback) {
			var list = this._listeners[type], i;
			if (list) {
				i = list.length;
				while (--i > -1) {
					if (list[i].c === callback) {
						list.splice(i, 1);
						return;
					}
				}
			}
		};

		p.dispatchEvent = function(type) {
			var list = this._listeners[type],
				i, t, listener;
			if (list) {
				i = list.length;
				if (i > 1) {
					list = list.slice(0); //in case addEventListener() is called from within a listener/callback (otherwise the index could change, resulting in a skip)
				}
				t = this._eventTarget;
				while (--i > -1) {
					listener = list[i];
					if (listener) {
						if (listener.up) {
							listener.c.call(listener.s || t, {type:type, target:t});
						} else {
							listener.c.call(listener.s || t);
						}
					}
				}
			}
		};


/*
 * ----------------------------------------------------------------
 * Ticker
 * ----------------------------------------------------------------
 */
 		var _reqAnimFrame = window.requestAnimationFrame,
			_cancelAnimFrame = window.cancelAnimationFrame,
			_getTime = Date.now || function() {return new Date().getTime();},
			_lastUpdate = _getTime();

		//now try to determine the requestAnimationFrame and cancelAnimationFrame functions and if none are found, we'll use a setTimeout()/clearTimeout() polyfill.
		a = ["ms","moz","webkit","o"];
		i = a.length;
		while (--i > -1 && !_reqAnimFrame) {
			_reqAnimFrame = window[a[i] + "RequestAnimationFrame"];
			_cancelAnimFrame = window[a[i] + "CancelAnimationFrame"] || window[a[i] + "CancelRequestAnimationFrame"];
		}

		_class("Ticker", function(fps, useRAF) {
			var _self = this,
				_startTime = _getTime(),
				_useRAF = (useRAF !== false && _reqAnimFrame) ? "auto" : false,
				_lagThreshold = 500,
				_adjustedLag = 33,
				_tickWord = "tick", //helps reduce gc burden
				_fps, _req, _id, _gap, _nextTime,
				_tick = function(manual) {
					var elapsed = _getTime() - _lastUpdate,
						overlap, dispatch;
					if (elapsed > _lagThreshold) {
						_startTime += elapsed - _adjustedLag;
					}
					_lastUpdate += elapsed;
					_self.time = (_lastUpdate - _startTime) / 1000;
					overlap = _self.time - _nextTime;
					if (!_fps || overlap > 0 || manual === true) {
						_self.frame++;
						_nextTime += overlap + (overlap >= _gap ? 0.004 : _gap - overlap);
						dispatch = true;
					}
					if (manual !== true) { //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
						_id = _req(_tick);
					}
					if (dispatch) {
						_self.dispatchEvent(_tickWord);
					}
				};

			EventDispatcher.call(_self);
			_self.time = _self.frame = 0;
			_self.tick = function() {
				_tick(true);
			};

			_self.lagSmoothing = function(threshold, adjustedLag) {
				if (!arguments.length) { //if lagSmoothing() is called with no arguments, treat it like a getter that returns a boolean indicating if it's enabled or not. This is purposely undocumented and is for internal use.
					return (_lagThreshold < 1 / _tinyNum);
				}
				_lagThreshold = threshold || (1 / _tinyNum); //zero should be interpreted as basically unlimited
				_adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
			};

			_self.sleep = function() {
				if (_id == null) {
					return;
				}
				if (!_useRAF || !_cancelAnimFrame) {
					clearTimeout(_id);
				} else {
					_cancelAnimFrame(_id);
				}
				_req = _emptyFunc;
				_id = null;
				if (_self === _ticker) {
					_tickerActive = false;
				}
			};

			_self.wake = function(seamless) {
				if (_id !== null) {
					_self.sleep();
				} else if (seamless) {
					_startTime += -_lastUpdate + (_lastUpdate = _getTime());
				} else if (_self.frame > 10) { //don't trigger lagSmoothing if we're just waking up, and make sure that at least 10 frames have elapsed because of the iOS bug that we work around below with the 1.5-second setTimout().
					_lastUpdate = _getTime() - _lagThreshold + 5;
				}
				_req = (_fps === 0) ? _emptyFunc : (!_useRAF || !_reqAnimFrame) ? function(f) { return setTimeout(f, ((_nextTime - _self.time) * 1000 + 1) | 0); } : _reqAnimFrame;
				if (_self === _ticker) {
					_tickerActive = true;
				}
				_tick(2);
			};

			_self.fps = function(value) {
				if (!arguments.length) {
					return _fps;
				}
				_fps = value;
				_gap = 1 / (_fps || 60);
				_nextTime = this.time + _gap;
				_self.wake();
			};

			_self.useRAF = function(value) {
				if (!arguments.length) {
					return _useRAF;
				}
				_self.sleep();
				_useRAF = value;
				_self.fps(_fps);
			};
			_self.fps(fps);

			//a bug in iOS 6 Safari occasionally prevents the requestAnimationFrame from working initially, so we use a 1.5-second timeout that automatically falls back to setTimeout() if it senses this condition.
			setTimeout(function() {
				if (_useRAF === "auto" && _self.frame < 5 && (_doc || {}).visibilityState !== "hidden") {
					_self.useRAF(false);
				}
			}, 1500);
		});

		p = gs.Ticker.prototype = new gs.events.EventDispatcher();
		p.constructor = gs.Ticker;


/*
 * ----------------------------------------------------------------
 * Animation
 * ----------------------------------------------------------------
 */
		var Animation = _class("core.Animation", function(duration, vars) {
				this.vars = vars = vars || {};
				this._duration = this._totalDuration = duration || 0;
				this._delay = Number(vars.delay) || 0;
				this._timeScale = 1;
				this._active = !!vars.immediateRender;
				this.data = vars.data;
				this._reversed = !!vars.reversed;

				if (!_rootTimeline) {
					return;
				}
				if (!_tickerActive) { //some browsers (like iOS 6 Safari) shut down JavaScript execution when the tab is disabled and they [occasionally] neglect to start up requestAnimationFrame again when returning - this code ensures that the engine starts up again properly.
					_ticker.wake();
				}

				var tl = this.vars.useFrames ? _rootFramesTimeline : _rootTimeline;
				tl.add(this, tl._time);

				if (this.vars.paused) {
					this.paused(true);
				}
			});

		_ticker = Animation.ticker = new gs.Ticker();
		p = Animation.prototype;
		p._dirty = p._gc = p._initted = p._paused = false;
		p._totalTime = p._time = 0;
		p._rawPrevTime = -1;
		p._next = p._last = p._onUpdate = p._timeline = p.timeline = null;
		p._paused = false;


		//some browsers (like iOS) occasionally drop the requestAnimationFrame event when the user switches to a different tab and then comes back again, so we use a 2-second setTimeout() to sense if/when that condition occurs and then wake() the ticker.
		var _checkTimeout = function() {
				if (_tickerActive && _getTime() - _lastUpdate > 2000 && ((_doc || {}).visibilityState !== "hidden" || !_ticker.lagSmoothing())) { //note: if the tab is hidden, we should still wake if lagSmoothing has been disabled.
					_ticker.wake();
				}
				var t = setTimeout(_checkTimeout, 2000);
				if (t.unref) {
					// allows a node process to exit even if the timeout’s callback hasn't been invoked. Without it, the node process could hang as this function is called every two seconds.
					t.unref();
				}
			};
		_checkTimeout();


		p.play = function(from, suppressEvents) {
			if (from != null) {
				this.seek(from, suppressEvents);
			}
			return this.reversed(false).paused(false);
		};

		p.pause = function(atTime, suppressEvents) {
			if (atTime != null) {
				this.seek(atTime, suppressEvents);
			}
			return this.paused(true);
		};

		p.resume = function(from, suppressEvents) {
			if (from != null) {
				this.seek(from, suppressEvents);
			}
			return this.paused(false);
		};

		p.seek = function(time, suppressEvents) {
			return this.totalTime(Number(time), suppressEvents !== false);
		};

		p.restart = function(includeDelay, suppressEvents) {
			return this.reversed(false).paused(false).totalTime(includeDelay ? -this._delay : 0, (suppressEvents !== false), true);
		};

		p.reverse = function(from, suppressEvents) {
			if (from != null) {
				this.seek((from || this.totalDuration()), suppressEvents);
			}
			return this.reversed(true).paused(false);
		};

		p.render = function(time, suppressEvents, force) {
			//stub - we override this method in subclasses.
		};

		p.invalidate = function() {
			this._time = this._totalTime = 0;
			this._initted = this._gc = false;
			this._rawPrevTime = -1;
			if (this._gc || !this.timeline) {
				this._enabled(true);
			}
			return this;
		};

		p.isActive = function() {
			var tl = this._timeline, //the 2 root timelines won't have a _timeline; they're always active.
				startTime = this._startTime,
				rawTime;
			return (!tl || (!this._gc && !this._paused && tl.isActive() && (rawTime = tl.rawTime(true)) >= startTime && rawTime < startTime + this.totalDuration() / this._timeScale - _tinyNum));
		};

		p._enabled = function (enabled, ignoreTimeline) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			this._gc = !enabled;
			this._active = this.isActive();
			if (ignoreTimeline !== true) {
				if (enabled && !this.timeline) {
					this._timeline.add(this, this._startTime - this._delay);
				} else if (!enabled && this.timeline) {
					this._timeline._remove(this, true);
				}
			}
			return false;
		};


		p._kill = function(vars, target) {
			return this._enabled(false, false);
		};

		p.kill = function(vars, target) {
			this._kill(vars, target);
			return this;
		};

		p._uncache = function(includeSelf) {
			var tween = includeSelf ? this : this.timeline;
			while (tween) {
				tween._dirty = true;
				tween = tween.timeline;
			}
			return this;
		};

		p._swapSelfInParams = function(params) {
			var i = params.length,
				copy = params.concat();
			while (--i > -1) {
				if (params[i] === "{self}") {
					copy[i] = this;
				}
			}
			return copy;
		};

		p._callback = function(type) {
			var v = this.vars,
				callback = v[type],
				params = v[type + "Params"],
				scope = v[type + "Scope"] || v.callbackScope || this,
				l = params ? params.length : 0;
			switch (l) { //speed optimization; call() is faster than apply() so use it when there are only a few parameters (which is by far most common). Previously we simply did var v = this.vars; v[type].apply(v[type + "Scope"] || v.callbackScope || this, v[type + "Params"] || _blankArray);
				case 0: callback.call(scope); break;
				case 1: callback.call(scope, params[0]); break;
				case 2: callback.call(scope, params[0], params[1]); break;
				default: callback.apply(scope, params);
			}
		};

//----Animation getters/setters --------------------------------------------------------

		p.eventCallback = function(type, callback, params, scope) {
			if ((type || "").substr(0,2) === "on") {
				var v = this.vars;
				if (arguments.length === 1) {
					return v[type];
				}
				if (callback == null) {
					delete v[type];
				} else {
					v[type] = callback;
					v[type + "Params"] = (_isArray(params) && params.join("").indexOf("{self}") !== -1) ? this._swapSelfInParams(params) : params;
					v[type + "Scope"] = scope;
				}
				if (type === "onUpdate") {
					this._onUpdate = callback;
				}
			}
			return this;
		};

		p.delay = function(value) {
			if (!arguments.length) {
				return this._delay;
			}
			if (this._timeline.smoothChildTiming) {
				this.startTime( this._startTime + value - this._delay );
			}
			this._delay = value;
			return this;
		};

		p.duration = function(value) {
			if (!arguments.length) {
				this._dirty = false;
				return this._duration;
			}
			this._duration = this._totalDuration = value;
			this._uncache(true); //true in case it's a TweenMax or TimelineMax that has a repeat - we'll need to refresh the totalDuration.
			if (this._timeline.smoothChildTiming) if (this._time > 0) if (this._time < this._duration) if (value !== 0) {
				this.totalTime(this._totalTime * (value / this._duration), true);
			}
			return this;
		};

		p.totalDuration = function(value) {
			this._dirty = false;
			return (!arguments.length) ? this._totalDuration : this.duration(value);
		};

		p.time = function(value, suppressEvents) {
			if (!arguments.length) {
				return this._time;
			}
			if (this._dirty) {
				this.totalDuration();
			}
			return this.totalTime((value > this._duration) ? this._duration : value, suppressEvents);
		};

		p.totalTime = function(time, suppressEvents, uncapped) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			if (!arguments.length) {
				return this._totalTime;
			}
			if (this._timeline) {
				if (time < 0 && !uncapped) {
					time += this.totalDuration();
				}
				if (this._timeline.smoothChildTiming) {
					if (this._dirty) {
						this.totalDuration();
					}
					var totalDuration = this._totalDuration,
						tl = this._timeline;
					if (time > totalDuration && !uncapped) {
						time = totalDuration;
					}
					this._startTime = (this._paused ? this._pauseTime : tl._time) - ((!this._reversed ? time : totalDuration - time) / this._timeScale);
					if (!tl._dirty) { //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
						this._uncache(false);
					}
					//in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The startTime of that child would get pushed out, but one of the ancestors may have completed.
					if (tl._timeline) {
						while (tl._timeline) {
							if (tl._timeline._time !== (tl._startTime + tl._totalTime) / tl._timeScale) {
								tl.totalTime(tl._totalTime, true);
							}
							tl = tl._timeline;
						}
					}
				}
				if (this._gc) {
					this._enabled(true, false);
				}
				if (this._totalTime !== time || this._duration === 0) {
					if (_lazyTweens.length) {
						_lazyRender();
					}
					this.render(time, suppressEvents, false);
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
						_lazyRender();
					}
				}
			}
			return this;
		};

		p.progress = p.totalProgress = function(value, suppressEvents) {
			var duration = this.duration();
			return (!arguments.length) ? (duration ? this._time / duration : this.ratio) : this.totalTime(duration * value, suppressEvents);
		};

		p.startTime = function(value) {
			if (!arguments.length) {
				return this._startTime;
			}
			if (value !== this._startTime) {
				this._startTime = value;
				if (this.timeline) if (this.timeline._sortChildren) {
					this.timeline.add(this, value - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
				}
			}
			return this;
		};

		p.endTime = function(includeRepeats) {
			return this._startTime + ((includeRepeats != false) ? this.totalDuration() : this.duration()) / this._timeScale;
		};

		p.timeScale = function(value) {
			if (!arguments.length) {
				return this._timeScale;
			}
			var pauseTime, t;
			value = value || _tinyNum; //can't allow zero because it'll throw the math off
			if (this._timeline && this._timeline.smoothChildTiming) {
				pauseTime = this._pauseTime;
				t = (pauseTime || pauseTime === 0) ? pauseTime : this._timeline.totalTime();
				this._startTime = t - ((t - this._startTime) * this._timeScale / value);
			}
			this._timeScale = value;
			t = this.timeline;
			while (t && t.timeline) { //must update the duration/totalDuration of all ancestor timelines immediately in case in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
				t._dirty = true;
				t.totalDuration();
				t = t.timeline;
			}
			return this;
		};

		p.reversed = function(value) {
			if (!arguments.length) {
				return this._reversed;
			}
			if (value != this._reversed) {
				this._reversed = value;
				this.totalTime(((this._timeline && !this._timeline.smoothChildTiming) ? this.totalDuration() - this._totalTime : this._totalTime), true);
			}
			return this;
		};

		p.paused = function(value) {
			if (!arguments.length) {
				return this._paused;
			}
			var tl = this._timeline,
				raw, elapsed;
			if (value != this._paused) if (tl) {
				if (!_tickerActive && !value) {
					_ticker.wake();
				}
				raw = tl.rawTime();
				elapsed = raw - this._pauseTime;
				if (!value && tl.smoothChildTiming) {
					this._startTime += elapsed;
					this._uncache(false);
				}
				this._pauseTime = value ? raw : null;
				this._paused = value;
				this._active = this.isActive();
				if (!value && elapsed !== 0 && this._initted && this.duration()) {
					raw = tl.smoothChildTiming ? this._totalTime : (raw - this._startTime) / this._timeScale;
					this.render(raw, (raw === this._totalTime), true); //in case the target's properties changed via some other tween or manual update by the user, we should force a render.
				}
			}
			if (this._gc && !value) {
				this._enabled(true, false);
			}
			return this;
		};


/*
 * ----------------------------------------------------------------
 * SimpleTimeline
 * ----------------------------------------------------------------
 */
		var SimpleTimeline = _class("core.SimpleTimeline", function(vars) {
			Animation.call(this, 0, vars);
			this.autoRemoveChildren = this.smoothChildTiming = true;
		});

		p = SimpleTimeline.prototype = new Animation();
		p.constructor = SimpleTimeline;
		p.kill()._gc = false;
		p._first = p._last = p._recent = null;
		p._sortChildren = false;

		p.add = p.insert = function(child, position, align, stagger) {
			var prevTween, st;
			child._startTime = Number(position || 0) + child._delay;
			if (child._paused) if (this !== child._timeline) { //we only adjust the _pauseTime if it wasn't in this timeline already. Remember, sometimes a tween will be inserted again into the same timeline when its startTime is changed so that the tweens in the TimelineLite/Max are re-ordered properly in the linked list (so everything renders in the proper order).
				child._pauseTime = this.rawTime() - (child._timeline.rawTime() - child._pauseTime);
			}
			if (child.timeline) {
				child.timeline._remove(child, true); //removes from existing timeline so that it can be properly added to this one.
			}
			child.timeline = child._timeline = this;
			if (child._gc) {
				child._enabled(true, true);
			}
			prevTween = this._last;
			if (this._sortChildren) {
				st = child._startTime;
				while (prevTween && prevTween._startTime > st) {
					prevTween = prevTween._prev;
				}
			}
			if (prevTween) {
				child._next = prevTween._next;
				prevTween._next = child;
			} else {
				child._next = this._first;
				this._first = child;
			}
			if (child._next) {
				child._next._prev = child;
			} else {
				this._last = child;
			}
			child._prev = prevTween;
			this._recent = child;
			if (this._timeline) {
				this._uncache(true);
			}
			return this;
		};

		p._remove = function(tween, skipDisable) {
			if (tween.timeline === this) {
				if (!skipDisable) {
					tween._enabled(false, true);
				}

				if (tween._prev) {
					tween._prev._next = tween._next;
				} else if (this._first === tween) {
					this._first = tween._next;
				}
				if (tween._next) {
					tween._next._prev = tween._prev;
				} else if (this._last === tween) {
					this._last = tween._prev;
				}
				tween._next = tween._prev = tween.timeline = null;
				if (tween === this._recent) {
					this._recent = this._last;
				}

				if (this._timeline) {
					this._uncache(true);
				}
			}
			return this;
		};

		p.render = function(time, suppressEvents, force) {
			var tween = this._first,
				next;
			this._totalTime = this._time = this._rawPrevTime = time;
			while (tween) {
				next = tween._next; //record it here because the value could change after rendering...
				if (tween._active || (time >= tween._startTime && !tween._paused && !tween._gc)) {
					if (!tween._reversed) {
						tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
					} else {
						tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
					}
				}
				tween = next;
			}
		};

		p.rawTime = function() {
			if (!_tickerActive) {
				_ticker.wake();
			}
			return this._totalTime;
		};

/*
 * ----------------------------------------------------------------
 * TweenLite
 * ----------------------------------------------------------------
 */
		var TweenLite = _class("TweenLite", function(target, duration, vars) {
				Animation.call(this, duration, vars);
				this.render = TweenLite.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)

				if (target == null) {
					throw "Cannot tween a null target.";
				}

				this.target = target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;

				var isSelector = (target.jquery || (target.length && target !== window && target[0] && (target[0] === window || (target[0].nodeType && target[0].style && !target.nodeType)))),
					overwrite = this.vars.overwrite,
					i, targ, targets;

				this._overwrite = overwrite = (overwrite == null) ? _overwriteLookup[TweenLite.defaultOverwrite] : (typeof(overwrite) === "number") ? overwrite >> 0 : _overwriteLookup[overwrite];

				if ((isSelector || target instanceof Array || (target.push && _isArray(target))) && typeof(target[0]) !== "number") {
					this._targets = targets = _slice(target);  //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					this._propLookup = [];
					this._siblings = [];
					for (i = 0; i < targets.length; i++) {
						targ = targets[i];
						if (!targ) {
							targets.splice(i--, 1);
							continue;
						} else if (typeof(targ) === "string") {
							targ = targets[i--] = TweenLite.selector(targ); //in case it's an array of strings
							if (typeof(targ) === "string") {
								targets.splice(i+1, 1); //to avoid an endless loop (can't imagine why the selector would return a string, but just in case)
							}
							continue;
						} else if (targ.length && targ !== window && targ[0] && (targ[0] === window || (targ[0].nodeType && targ[0].style && !targ.nodeType))) { //in case the user is passing in an array of selector objects (like jQuery objects), we need to check one more level and pull things out if necessary. Also note that <select> elements pass all the criteria regarding length and the first child having style, so we must also check to ensure the target isn't an HTML node itself.
							targets.splice(i--, 1);
							this._targets = targets = targets.concat(_slice(targ));
							continue;
						}
						this._siblings[i] = _register(targ, this, false);
						if (overwrite === 1) if (this._siblings[i].length > 1) {
							_applyOverwrite(targ, this, null, 1, this._siblings[i]);
						}
					}

				} else {
					this._propLookup = {};
					this._siblings = _register(target, this, false);
					if (overwrite === 1) if (this._siblings.length > 1) {
						_applyOverwrite(target, this, null, 1, this._siblings);
					}
				}
				if (this.vars.immediateRender || (duration === 0 && this._delay === 0 && this.vars.immediateRender !== false)) {
					this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
					this.render(Math.min(0, -this._delay)); //in case delay is negative
				}
			}, true),
			_isSelector = function(v) {
				return (v && v.length && v !== window && v[0] && (v[0] === window || (v[0].nodeType && v[0].style && !v.nodeType))); //we cannot check "nodeType" if the target is window from within an iframe, otherwise it will trigger a security error in some browsers like Firefox.
			},
			_autoCSS = function(vars, target) {
				var css = {},
					p;
				for (p in vars) {
					if (!_reservedProps[p] && (!(p in target) || p === "transform" || p === "x" || p === "y" || p === "width" || p === "height" || p === "className" || p === "border") && (!_plugins[p] || (_plugins[p] && _plugins[p]._autoCSS))) { //note: <img> elements contain read-only "x" and "y" properties. We should also prioritize editing css width/height rather than the element's properties.
						css[p] = vars[p];
						delete vars[p];
					}
				}
				vars.css = css;
			};

		p = TweenLite.prototype = new Animation();
		p.constructor = TweenLite;
		p.kill()._gc = false;

//----TweenLite defaults, overwrite management, and root updates ----------------------------------------------------

		p.ratio = 0;
		p._firstPT = p._targets = p._overwrittenProps = p._startAt = null;
		p._notifyPluginsOfEnabled = p._lazy = false;

		TweenLite.version = "2.1.3";
		TweenLite.defaultEase = p._ease = new Ease(null, null, 1, 1);
		TweenLite.defaultOverwrite = "auto";
		TweenLite.ticker = _ticker;
		TweenLite.autoSleep = 120;
		TweenLite.lagSmoothing = function(threshold, adjustedLag) {
			_ticker.lagSmoothing(threshold, adjustedLag);
		};

		TweenLite.selector = window.$ || window.jQuery || function(e) {
			var selector = window.$ || window.jQuery;
			if (selector) {
				TweenLite.selector = selector;
				return selector(e);
			}
			if (!_doc) { //in some dev environments (like Angular 6), GSAP gets loaded before the document is defined! So re-query it here if/when necessary.
				_doc = window.document;
			}
			return (!_doc) ? e : (_doc.querySelectorAll ? _doc.querySelectorAll(e) : _doc.getElementById((e.charAt(0) === "#") ? e.substr(1) : e));
		};

		var _lazyTweens = [],
			_lazyLookup = {},
			_numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
			_relExp = /[\+-]=-?[\.\d]/,
			//_nonNumbersExp = /(?:([\-+](?!(\d|=)))|[^\d\-+=e]|(e(?![\-+][\d])))+/ig,
			_setRatio = function(v) {
				var pt = this._firstPT,
					min = 0.000001,
					val;
				while (pt) {
					val = !pt.blob ? pt.c * v + pt.s : (v === 1 && this.end != null) ? this.end : v ? this.join("") : this.start;
					if (pt.m) {
						val = pt.m.call(this._tween, val, this._target || pt.t, this._tween);
					} else if (val < min) if (val > -min && !pt.blob) { //prevents issues with converting very small numbers to strings in the browser
						val = 0;
					}
					if (!pt.f) {
						pt.t[pt.p] = val;
					} else if (pt.fp) {
						pt.t[pt.p](pt.fp, val);
					} else {
						pt.t[pt.p](val);
					}
					pt = pt._next;
				}
			},
			_blobRound = function(v) {
				return (((v * 1000) | 0) / 1000) + "";
			},
			//compares two strings (start/end), finds the numbers that are different and spits back an array representing the whole value but with the changing values isolated as elements. For example, "rgb(0,0,0)" and "rgb(100,50,0)" would become ["rgb(", 0, ",", 50, ",0)"]. Notice it merges the parts that are identical (performance optimization). The array also has a linked list of PropTweens attached starting with _firstPT that contain the tweening data (t, p, s, c, f, etc.). It also stores the starting value as a "start" property so that we can revert to it if/when necessary, like when a tween rewinds fully. If the quantity of numbers differs between the start and end, it will always prioritize the end value(s). The pt parameter is optional - it's for a PropTween that will be appended to the end of the linked list and is typically for actually setting the value after all of the elements have been updated (with array.join("")).
			_blobDif = function(start, end, filter, pt) {
				var a = [],
					charIndex = 0,
					s = "",
					color = 0,
					startNums, endNums, num, i, l, nonNumbers, currentNum;
				a.start = start;
				a.end = end;
				start = a[0] = start + ""; //ensure values are strings
				end = a[1] = end + "";
				if (filter) {
					filter(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
					start = a[0];
					end = a[1];
				}
				a.length = 0;
				startNums = start.match(_numbersExp) || [];
				endNums = end.match(_numbersExp) || [];
				if (pt) {
					pt._next = null;
					pt.blob = 1;
					a._firstPT = a._applyPT = pt; //apply last in the linked list (which means inserting it first)
				}
				l = endNums.length;
				for (i = 0; i < l; i++) {
					currentNum = endNums[i];
					nonNumbers = end.substr(charIndex, end.indexOf(currentNum, charIndex)-charIndex);
					s += (nonNumbers || !i) ? nonNumbers : ","; //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
					charIndex += nonNumbers.length;
					if (color) { //sense rgba() values and round them.
						color = (color + 1) % 5;
					} else if (nonNumbers.substr(-5) === "rgba(") {
						color = 1;
					}
					if (currentNum === startNums[i] || startNums.length <= i) {
						s += currentNum;
					} else {
						if (s) {
							a.push(s);
							s = "";
						}
						num = parseFloat(startNums[i]);
						a.push(num);
						a._firstPT = {_next: a._firstPT, t:a, p: a.length-1, s:num, c:((currentNum.charAt(1) === "=") ? parseInt(currentNum.charAt(0) + "1", 10) * parseFloat(currentNum.substr(2)) : (parseFloat(currentNum) - num)) || 0, f:0, m:(color && color < 4) ? Math.round : _blobRound}; //limiting to 3 decimal places and casting as a string can really help performance when array.join() is called!
						//note: we don't set _prev because we'll never need to remove individual PropTweens from this list.
					}
					charIndex += currentNum.length;
				}
				s += end.substr(charIndex);
				if (s) {
					a.push(s);
				}
				a.setRatio = _setRatio;
				if (_relExp.test(end)) { //if the end string contains relative values, delete it so that on the final render (in _setRatio()), we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
					a.end = null;
				}
				return a;
			},
			//note: "funcParam" is only necessary for function-based getters/setters that require an extra parameter like getAttribute("width") and setAttribute("width", value). In this example, funcParam would be "width". Used by AttrPlugin for example.
			_addPropTween = function(target, prop, start, end, overwriteProp, mod, funcParam, stringFilter, index) {
				if (typeof(end) === "function") {
					end = end(index || 0, target);
				}
				var type = typeof(target[prop]),
					getterName = (type !== "function") ? "" : ((prop.indexOf("set") || typeof(target["get" + prop.substr(3)]) !== "function") ? prop : "get" + prop.substr(3)),
					s = (start !== "get") ? start : !getterName ? target[prop] : funcParam ? target[getterName](funcParam) : target[getterName](),
					isRelative = (typeof(end) === "string" && end.charAt(1) === "="),
					pt = {t:target, p:prop, s:s, f:(type === "function"), pg:0, n:overwriteProp || prop, m:(!mod ? 0 : (typeof(mod) === "function") ? mod : Math.round), pr:0, c:isRelative ? parseInt(end.charAt(0) + "1", 10) * parseFloat(end.substr(2)) : (parseFloat(end) - s) || 0},
					blob;

				if (typeof(s) !== "number" || (typeof(end) !== "number" && !isRelative)) {
					if (funcParam || isNaN(s) || (!isRelative && isNaN(end)) || typeof(s) === "boolean" || typeof(end) === "boolean") {
						//a blob (string that has multiple numbers in it)
						pt.fp = funcParam;
						blob = _blobDif(s, (isRelative ? (parseFloat(pt.s) + pt.c) + (pt.s + "").replace(/[0-9\-\.]/g, "") : end), stringFilter || TweenLite.defaultStringFilter, pt);
						pt = {t: blob, p: "setRatio", s: 0, c: 1, f: 2, pg: 0, n: overwriteProp || prop, pr: 0, m: 0}; //"2" indicates it's a Blob property tween. Needed for RoundPropsPlugin for example.
					} else {
						pt.s = parseFloat(s);
						if (!isRelative) {
							pt.c = (parseFloat(end) - pt.s) || 0;
						}
					}
				}
				if (pt.c) { //only add it to the linked list if there's a change.
					if ((pt._next = this._firstPT)) {
						pt._next._prev = pt;
					}
					this._firstPT = pt;
					return pt;
				}
			},
			_internals = TweenLite._internals = {isArray:_isArray, isSelector:_isSelector, lazyTweens:_lazyTweens, blobDif:_blobDif}, //gives us a way to expose certain private values to other GreenSock classes without contaminating tha main TweenLite object.
			_plugins = TweenLite._plugins = {},
			_tweenLookup = _internals.tweenLookup = {},
			_tweenLookupNum = 0,
			_reservedProps = _internals.reservedProps = {ease:1, delay:1, overwrite:1, onComplete:1, onCompleteParams:1, onCompleteScope:1, useFrames:1, runBackwards:1, startAt:1, onUpdate:1, onUpdateParams:1, onUpdateScope:1, onStart:1, onStartParams:1, onStartScope:1, onReverseComplete:1, onReverseCompleteParams:1, onReverseCompleteScope:1, onRepeat:1, onRepeatParams:1, onRepeatScope:1, easeParams:1, yoyo:1, immediateRender:1, repeat:1, repeatDelay:1, data:1, paused:1, reversed:1, autoCSS:1, lazy:1, onOverwrite:1, callbackScope:1, stringFilter:1, id:1, yoyoEase:1, stagger:1},
			_overwriteLookup = {none:0, all:1, auto:2, concurrent:3, allOnStart:4, preexisting:5, "true":1, "false":0},
			_rootFramesTimeline = Animation._rootFramesTimeline = new SimpleTimeline(),
			_rootTimeline = Animation._rootTimeline = new SimpleTimeline(),
			_nextGCFrame = 30,
			_lazyRender = _internals.lazyRender = function() {
				var l = _lazyTweens.length,
					i, tween;
				_lazyLookup = {};
				for (i = 0; i < l; i++) {
					tween = _lazyTweens[i];
					if (tween && tween._lazy !== false) {
						tween.render(tween._lazy[0], tween._lazy[1], true);
						tween._lazy = false;
					}
				}
				_lazyTweens.length = 0;
			};

		_rootTimeline._startTime = _ticker.time;
		_rootFramesTimeline._startTime = _ticker.frame;
		_rootTimeline._active = _rootFramesTimeline._active = true;
		setTimeout(_lazyRender, 1); //on some mobile devices, there isn't a "tick" before code runs which means any lazy renders wouldn't run before the next official "tick".

		Animation._updateRoot = TweenLite.render = function() {
				var i, a, p;
				if (_lazyTweens.length) { //if code is run outside of the requestAnimationFrame loop, there may be tweens queued AFTER the engine refreshed, so we need to ensure any pending renders occur before we refresh again.
					_lazyRender();
				}
				_rootTimeline.render((_ticker.time - _rootTimeline._startTime) * _rootTimeline._timeScale, false, false);
				_rootFramesTimeline.render((_ticker.frame - _rootFramesTimeline._startTime) * _rootFramesTimeline._timeScale, false, false);
				if (_lazyTweens.length) {
					_lazyRender();
				}
				if (_ticker.frame >= _nextGCFrame) { //dump garbage every 120 frames or whatever the user sets TweenLite.autoSleep to
					_nextGCFrame = _ticker.frame + (parseInt(TweenLite.autoSleep, 10) || 120);
					for (p in _tweenLookup) {
						a = _tweenLookup[p].tweens;
						i = a.length;
						while (--i > -1) {
							if (a[i]._gc) {
								a.splice(i, 1);
							}
						}
						if (a.length === 0) {
							delete _tweenLookup[p];
						}
					}
					//if there are no more tweens in the root timelines, or if they're all paused, make the _timer sleep to reduce load on the CPU slightly
					p = _rootTimeline._first;
					if (!p || p._paused) if (TweenLite.autoSleep && !_rootFramesTimeline._first && _ticker._listeners.tick.length === 1) {
						while (p && p._paused) {
							p = p._next;
						}
						if (!p) {
							_ticker.sleep();
						}
					}
				}
			};

		_ticker.addEventListener("tick", Animation._updateRoot);

		var _register = function(target, tween, scrub) {
				var id = target._gsTweenID, a, i;
				if (!_tweenLookup[id || (target._gsTweenID = id = "t" + (_tweenLookupNum++))]) {
					_tweenLookup[id] = {target:target, tweens:[]};
				}
				if (tween) {
					a = _tweenLookup[id].tweens;
					a[(i = a.length)] = tween;
					if (scrub) {
						while (--i > -1) {
							if (a[i] === tween) {
								a.splice(i, 1);
							}
						}
					}
				}
				return _tweenLookup[id].tweens;
			},
			_onOverwrite = function(overwrittenTween, overwritingTween, target, killedProps) {
				var func = overwrittenTween.vars.onOverwrite, r1, r2;
				if (func) {
					r1 = func(overwrittenTween, overwritingTween, target, killedProps);
				}
				func = TweenLite.onOverwrite;
				if (func) {
					r2 = func(overwrittenTween, overwritingTween, target, killedProps);
				}
				return (r1 !== false && r2 !== false);
			},
			_applyOverwrite = function(target, tween, props, mode, siblings) {
				var i, changed, curTween, l;
				if (mode === 1 || mode >= 4) {
					l = siblings.length;
					for (i = 0; i < l; i++) {
						if ((curTween = siblings[i]) !== tween) {
							if (!curTween._gc) {
								if (curTween._kill(null, target, tween)) {
									changed = true;
								}
							}
						} else if (mode === 5) {
							break;
						}
					}
					return changed;
				}
				//NOTE: Add tiny amount to overcome floating point errors that can cause the startTime to be VERY slightly off (when a tween's time() is set for example)
				var startTime = tween._startTime + _tinyNum,
					overlaps = [],
					oCount = 0,
					zeroDur = (tween._duration === 0),
					globalStart;
				i = siblings.length;
				while (--i > -1) {
					if ((curTween = siblings[i]) === tween || curTween._gc || curTween._paused) {
						//ignore
					} else if (curTween._timeline !== tween._timeline) {
						globalStart = globalStart || _checkOverlap(tween, 0, zeroDur);
						if (_checkOverlap(curTween, globalStart, zeroDur) === 0) {
							overlaps[oCount++] = curTween;
						}
					} else if (curTween._startTime <= startTime) if (curTween._startTime + curTween.totalDuration() / curTween._timeScale > startTime) if (!((zeroDur || !curTween._initted) && startTime - curTween._startTime <= _tinyNum * 2)) {
						overlaps[oCount++] = curTween;
					}
				}

				i = oCount;
				while (--i > -1) {
					curTween = overlaps[i];
					l = curTween._firstPT; //we need to discern if there were property tweens originally; if they all get removed in the next line's _kill() call, the tween should be killed. See https://github.com/greensock/GreenSock-JS/issues/278
					if (mode === 2) if (curTween._kill(props, target, tween)) {
						changed = true;
					}
					if (mode !== 2 || (!curTween._firstPT && curTween._initted && l)) {
						if (mode !== 2 && !_onOverwrite(curTween, tween)) {
							continue;
						}
						if (curTween._enabled(false, false)) { //if all property tweens have been overwritten, kill the tween.
							changed = true;
						}
					}
				}
				return changed;
			},
			_checkOverlap = function(tween, reference, zeroDur) {
				var tl = tween._timeline,
					ts = tl._timeScale,
					t = tween._startTime;
				while (tl._timeline) {
					t += tl._startTime;
					ts *= tl._timeScale;
					if (tl._paused) {
						return -100;
					}
					tl = tl._timeline;
				}
				t /= ts;
				return (t > reference) ? t - reference : ((zeroDur && t === reference) || (!tween._initted && t - reference < 2 * _tinyNum)) ? _tinyNum : ((t += tween.totalDuration() / tween._timeScale / ts) > reference + _tinyNum) ? 0 : t - reference - _tinyNum;
			};


//---- TweenLite instance methods -----------------------------------------------------------------------------

		p._init = function() {
			var v = this.vars,
				op = this._overwrittenProps,
				dur = this._duration,
				immediate = !!v.immediateRender,
				ease = v.ease,
				startAt = this._startAt,
				i, initPlugins, pt, p, startVars, l;
			if (v.startAt) {
				if (startAt) {
					startAt.render(-1, true); //if we've run a startAt previously (when the tween instantiated), we should revert it so that the values re-instantiate correctly particularly for relative tweens. Without this, a TweenLite.fromTo(obj, 1, {x:"+=100"}, {x:"-=100"}), for example, would actually jump to +=200 because the startAt would run twice, doubling the relative change.
					startAt.kill();
				}
				startVars = {};
				for (p in v.startAt) { //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, 1, from, to).fromTo(e, 1, to, from);
					startVars[p] = v.startAt[p];
				}
				startVars.data = "isStart";
				startVars.overwrite = false;
				startVars.immediateRender = true;
				startVars.lazy = (immediate && v.lazy !== false);
				startVars.startAt = startVars.delay = null; //no nesting of startAt objects allowed (otherwise it could cause an infinite loop).
				startVars.onUpdate = v.onUpdate;
				startVars.onUpdateParams = v.onUpdateParams;
				startVars.onUpdateScope = v.onUpdateScope || v.callbackScope || this;
				this._startAt = TweenLite.to(this.target || {}, 0, startVars);
				if (immediate) {
					if (this._time > 0) {
						this._startAt = null; //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in TimelineLite/Max instances where immediateRender was false (which is the default in the convenience methods like from()).
					} else if (dur !== 0) {
						return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a TimelineLite or TimelineMax, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
					}
				}
			} else if (v.runBackwards && dur !== 0) {
				//from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
				if (startAt) {
					startAt.render(-1, true);
					startAt.kill();
					this._startAt = null;
				} else {
					if (this._time !== 0) { //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
						immediate = false;
					}
					pt = {};
					for (p in v) { //copy props into a new object and skip any reserved props, otherwise onComplete or onUpdate or onStart could fire. We should, however, permit autoCSS to go through.
						if (!_reservedProps[p] || p === "autoCSS") {
							pt[p] = v[p];
						}
					}
					pt.overwrite = 0;
					pt.data = "isFromStart"; //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
					pt.lazy = (immediate && v.lazy !== false);
					pt.immediateRender = immediate; //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
					this._startAt = TweenLite.to(this.target, 0, pt);
					if (!immediate) {
						this._startAt._init(); //ensures that the initial values are recorded
						this._startAt._enabled(false); //no need to have the tween render on the next cycle. Disable it because we'll always manually control the renders of the _startAt tween.
						if (this.vars.immediateRender) {
							this._startAt = null;
						}
					} else if (this._time === 0) {
						return;
					}
				}
			}
			this._ease = ease = (!ease) ? TweenLite.defaultEase : (ease instanceof Ease) ? ease : (typeof(ease) === "function") ? new Ease(ease, v.easeParams) : _easeMap[ease] || TweenLite.defaultEase;
			if (v.easeParams instanceof Array && ease.config) {
				this._ease = ease.config.apply(ease, v.easeParams);
			}
			this._easeType = this._ease._type;
			this._easePower = this._ease._power;
			this._firstPT = null;

			if (this._targets) {
				l = this._targets.length;
				for (i = 0; i < l; i++) {
					if ( this._initProps( this._targets[i], (this._propLookup[i] = {}), this._siblings[i], (op ? op[i] : null), i) ) {
						initPlugins = true;
					}
				}
			} else {
				initPlugins = this._initProps(this.target, this._propLookup, this._siblings, op, 0);
			}

			if (initPlugins) {
				TweenLite._onPluginEvent("_onInitAllProps", this); //reorders the array in order of priority. Uses a static TweenPlugin method in order to minimize file size in TweenLite
			}
			if (op) if (!this._firstPT) if (typeof(this.target) !== "function") { //if all tweening properties have been overwritten, kill the tween. If the target is a function, it's probably a delayedCall so let it live.
				this._enabled(false, false);
			}
			if (v.runBackwards) {
				pt = this._firstPT;
				while (pt) {
					pt.s += pt.c;
					pt.c = -pt.c;
					pt = pt._next;
				}
			}
			this._onUpdate = v.onUpdate;
			this._initted = true;
		};

		p._initProps = function(target, propLookup, siblings, overwrittenProps, index) {
			var p, i, initPlugins, plugin, pt, v;
			if (target == null) {
				return false;
			}
			if (_lazyLookup[target._gsTweenID]) {
				_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
			}

			if (!this.vars.css) if (target.style) if (target !== window && target.nodeType) if (_plugins.css) if (this.vars.autoCSS !== false) { //it's so common to use TweenLite/Max to animate the css of DOM elements, we assume that if the target is a DOM element, that's what is intended (a convenience so that users don't have to wrap things in css:{}, although we still recommend it for a slight performance boost and better specificity). Note: we cannot check "nodeType" on the window inside an iframe.
				_autoCSS(this.vars, target);
			}
			for (p in this.vars) {
				v = this.vars[p];
				if (_reservedProps[p]) {
					if (v) if ((v instanceof Array) || (v.push && _isArray(v))) if (v.join("").indexOf("{self}") !== -1) {
						this.vars[p] = v = this._swapSelfInParams(v, this);
					}

				} else if (_plugins[p] && (plugin = new _plugins[p]())._onInitTween(target, this.vars[p], this, index)) {

					//t - target 		[object]
					//p - property 		[string]
					//s - start			[number]
					//c - change		[number]
					//f - isFunction	[boolean]
					//n - name			[string]
					//pg - isPlugin 	[boolean]
					//pr - priority		[number]
					//m - mod           [function | 0]
					this._firstPT = pt = {_next:this._firstPT, t:plugin, p:"setRatio", s:0, c:1, f:1, n:p, pg:1, pr:plugin._priority, m:0};
					i = plugin._overwriteProps.length;
					while (--i > -1) {
						propLookup[plugin._overwriteProps[i]] = this._firstPT;
					}
					if (plugin._priority || plugin._onInitAllProps) {
						initPlugins = true;
					}
					if (plugin._onDisable || plugin._onEnable) {
						this._notifyPluginsOfEnabled = true;
					}
					if (pt._next) {
						pt._next._prev = pt;
					}

				} else {
					propLookup[p] = _addPropTween.call(this, target, p, "get", v, p, 0, null, this.vars.stringFilter, index);
				}
			}

			if (overwrittenProps) if (this._kill(overwrittenProps, target)) { //another tween may have tried to overwrite properties of this tween before init() was called (like if two tweens start at the same time, the one created second will run first)
				return this._initProps(target, propLookup, siblings, overwrittenProps, index);
			}
			if (this._overwrite > 1) if (this._firstPT) if (siblings.length > 1) if (_applyOverwrite(target, this, propLookup, this._overwrite, siblings)) {
				this._kill(propLookup, target);
				return this._initProps(target, propLookup, siblings, overwrittenProps, index);
			}
			if (this._firstPT) if ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration)) { //zero duration tweens don't lazy render by default; everything else does.
				_lazyLookup[target._gsTweenID] = true;
			}
			return initPlugins;
		};

		p.render = function(time, suppressEvents, force) {
			var self = this,
				prevTime = self._time,
				duration = self._duration,
				prevRawPrevTime = self._rawPrevTime,
				isComplete, callback, pt, rawPrevTime;
			if (time >= duration - _tinyNum && time >= 0) { //to work around occasional floating point math artifacts.
				self._totalTime = self._time = duration;
				self.ratio = self._ease._calcEnd ? self._ease.getRatio(1) : 1;
				if (!self._reversed ) {
					isComplete = true;
					callback = "onComplete";
					force = (force || self._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
				}
				if (duration === 0) if (self._initted || !self.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
					if (self._startTime === self._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
						time = 0;
					}
					if (prevRawPrevTime < 0 || (time <= 0 && time >= -_tinyNum) || (prevRawPrevTime === _tinyNum && self.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
						force = true;
						if (prevRawPrevTime > _tinyNum) {
							callback = "onReverseComplete";
						}
					}
					self._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
				}

			} else if (time < _tinyNum) { //to work around occasional floating point math artifacts, round super small values to 0.
				self._totalTime = self._time = 0;
				self.ratio = self._ease._calcEnd ? self._ease.getRatio(0) : 0;
				if (prevTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
					callback = "onReverseComplete";
					isComplete = self._reversed;
				}
				if (time > -_tinyNum) {
					time = 0;
				} else if (time < 0) {
					self._active = false;
					if (duration === 0) if (self._initted || !self.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (prevRawPrevTime >= 0 && !(prevRawPrevTime === _tinyNum && self.data === "isPause")) {
							force = true;
						}
						self._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
				}
				if (!self._initted || (self._startAt && self._startAt.progress())) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately. Also, we check progress() because if startAt has already rendered at its end, we should force a render at its beginning. Otherwise, if you put the playhead directly on top of where a fromTo({immediateRender:false}) starts, and then move it backwards, the from() won't revert its values.
					force = true;
				}
			} else {
				self._totalTime = self._time = time;

				if (self._easeType) {
					var r = time / duration, type = self._easeType, pow = self._easePower;
					if (type === 1 || (type === 3 && r >= 0.5)) {
						r = 1 - r;
					}
					if (type === 3) {
						r *= 2;
					}
					if (pow === 1) {
						r *= r;
					} else if (pow === 2) {
						r *= r * r;
					} else if (pow === 3) {
						r *= r * r * r;
					} else if (pow === 4) {
						r *= r * r * r * r;
					}
					self.ratio = (type === 1) ? 1 - r : (type === 2) ? r : (time / duration < 0.5) ? r / 2 : 1 - (r / 2);
				} else {
					self.ratio = self._ease.getRatio(time / duration);
				}
			}

			if (self._time === prevTime && !force) {
				return;
			} else if (!self._initted) {
				self._init();
				if (!self._initted || self._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
					return;
				} else if (!force && self._firstPT && ((self.vars.lazy !== false && self._duration) || (self.vars.lazy && !self._duration))) {
					self._time = self._totalTime = prevTime;
					self._rawPrevTime = prevRawPrevTime;
					_lazyTweens.push(self);
					self._lazy = [time, suppressEvents];
					return;
				}
				//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
				if (self._time && !isComplete) {
					self.ratio = self._ease.getRatio(self._time / duration);
				} else if (isComplete && self._ease._calcEnd) {
					self.ratio = self._ease.getRatio((self._time === 0) ? 0 : 1);
				}
			}
			if (self._lazy !== false) { //in case a lazy render is pending, we should flush it because the new render is occurring now (imagine a lazy tween instantiating and then immediately the user calls tween.seek(tween.duration()), skipping to the end - the end render would be forced, and then if we didn't flush the lazy render, it'd fire AFTER the seek(), rendering it at the wrong time.
				self._lazy = false;
			}
			if (!self._active) if (!self._paused && self._time !== prevTime && time >= 0) {
				self._active = true;  //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
			}
			if (prevTime === 0) {
				if (self._startAt) {
					if (time >= 0) {
						self._startAt.render(time, true, force);
					} else if (!callback) {
						callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
					}
				}
				if (self.vars.onStart) if (self._time !== 0 || duration === 0) if (!suppressEvents) {
					self._callback("onStart");
				}
			}
			pt = self._firstPT;
			while (pt) {
				if (pt.f) {
					pt.t[pt.p](pt.c * self.ratio + pt.s);
				} else {
					pt.t[pt.p] = pt.c * self.ratio + pt.s;
				}
				pt = pt._next;
			}

			if (self._onUpdate) {
				if (time < 0) if (self._startAt && time !== -0.0001) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
					self._startAt.render(time, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
				}
				if (!suppressEvents) if (self._time !== prevTime || isComplete || force) {
					self._callback("onUpdate");
				}
			}
			if (callback) if (!self._gc || force) { //check _gc because there's a chance that kill() could be called in an onUpdate
				if (time < 0 && self._startAt && !self._onUpdate && time !== -0.0001) { //-0.0001 is a special value that we use when looping back to the beginning of a repeated TimelineMax, in which case we shouldn't render the _startAt values.
					self._startAt.render(time, true, force);
				}
				if (isComplete) {
					if (self._timeline.autoRemoveChildren) {
						self._enabled(false, false);
					}
					self._active = false;
				}
				if (!suppressEvents && self.vars[callback]) {
					self._callback(callback);
				}
				if (duration === 0 && self._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
					self._rawPrevTime = 0;
				}
			}
		};

		p._kill = function(vars, target, overwritingTween) {
			if (vars === "all") {
				vars = null;
			}
			if (vars == null) if (target == null || target === this.target) {
				this._lazy = false;
				return this._enabled(false, false);
			}
			target = (typeof(target) !== "string") ? (target || this._targets || this.target) : TweenLite.selector(target) || target;
			var simultaneousOverwrite = (overwritingTween && this._time && overwritingTween._startTime === this._startTime && this._timeline === overwritingTween._timeline),
				firstPT = this._firstPT,
				i, overwrittenProps, p, pt, propLookup, changed, killProps, record, killed;
			if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
				i = target.length;
				while (--i > -1) {
					if (this._kill(vars, target[i], overwritingTween)) {
						changed = true;
					}
				}
			} else {
				if (this._targets) {
					i = this._targets.length;
					while (--i > -1) {
						if (target === this._targets[i]) {
							propLookup = this._propLookup[i] || {};
							this._overwrittenProps = this._overwrittenProps || [];
							overwrittenProps = this._overwrittenProps[i] = vars ? this._overwrittenProps[i] || {} : "all";
							break;
						}
					}
				} else if (target !== this.target) {
					return false;
				} else {
					propLookup = this._propLookup;
					overwrittenProps = this._overwrittenProps = vars ? this._overwrittenProps || {} : "all";
				}

				if (propLookup) {
					killProps = vars || propLookup;
					record = (vars !== overwrittenProps && overwrittenProps !== "all" && vars !== propLookup && (typeof(vars) !== "object" || !vars._tempKill)); //_tempKill is a super-secret way to delete a particular tweening property but NOT have it remembered as an official overwritten property (like in BezierPlugin)
					if (overwritingTween && (TweenLite.onOverwrite || this.vars.onOverwrite)) {
						for (p in killProps) {
							if (propLookup[p]) {
								if (!killed) {
									killed = [];
								}
								killed.push(p);
							}
						}
						if ((killed || !vars) && !_onOverwrite(this, overwritingTween, target, killed)) { //if the onOverwrite returned false, that means the user wants to override the overwriting (cancel it).
							return false;
						}
					}

					for (p in killProps) {
						if ((pt = propLookup[p])) {
							if (simultaneousOverwrite) { //if another tween overwrites this one and they both start at exactly the same time, yet this tween has already rendered once (for example, at 0.001) because it's first in the queue, we should revert the values to where they were at 0 so that the starting values aren't contaminated on the overwriting tween.
								if (pt.f) {
									pt.t[pt.p](pt.s);
								} else {
									pt.t[pt.p] = pt.s;
								}
								changed = true;
							}
							if (pt.pg && pt.t._kill(killProps)) {
								changed = true; //some plugins need to be notified so they can perform cleanup tasks first
							}
							if (!pt.pg || pt.t._overwriteProps.length === 0) {
								if (pt._prev) {
									pt._prev._next = pt._next;
								} else if (pt === this._firstPT) {
									this._firstPT = pt._next;
								}
								if (pt._next) {
									pt._next._prev = pt._prev;
								}
								pt._next = pt._prev = null;
							}
							delete propLookup[p];
						}
						if (record) {
							overwrittenProps[p] = 1;
						}
					}
					if (!this._firstPT && this._initted && firstPT) { //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
						this._enabled(false, false);
					}
				}
			}
			return changed;
		};

		p.invalidate = function() {
			if (this._notifyPluginsOfEnabled) {
				TweenLite._onPluginEvent("_onDisable", this);
			}
			var t = this._time;
			this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null;
			this._notifyPluginsOfEnabled = this._active = this._lazy = false;
			this._propLookup = (this._targets) ? {} : [];
			Animation.prototype.invalidate.call(this);
			if (this.vars.immediateRender) {
				this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
				this.render(t, false, this.vars.lazy !== false);
			}
			return this;
		};

		p._enabled = function(enabled, ignoreTimeline) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			if (enabled && this._gc) {
				var targets = this._targets,
					i;
				if (targets) {
					i = targets.length;
					while (--i > -1) {
						this._siblings[i] = _register(targets[i], this, true);
					}
				} else {
					this._siblings = _register(this.target, this, true);
				}
			}
			Animation.prototype._enabled.call(this, enabled, ignoreTimeline);
			if (this._notifyPluginsOfEnabled) if (this._firstPT) {
				return TweenLite._onPluginEvent((enabled ? "_onEnable" : "_onDisable"), this);
			}
			return false;
		};


//----TweenLite static methods -----------------------------------------------------

		TweenLite.to = function(target, duration, vars) {
			return new TweenLite(target, duration, vars);
		};

		TweenLite.from = function(target, duration, vars) {
			vars.runBackwards = true;
			vars.immediateRender = (vars.immediateRender != false);
			return new TweenLite(target, duration, vars);
		};

		TweenLite.fromTo = function(target, duration, fromVars, toVars) {
			toVars.startAt = fromVars;
			toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
			return new TweenLite(target, duration, toVars);
		};

		TweenLite.delayedCall = function(delay, callback, params, scope, useFrames) {
			return new TweenLite(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, lazy:false, useFrames:useFrames, overwrite:0});
		};

		TweenLite.set = function(target, vars) {
			return new TweenLite(target, 0, vars);
		};

		TweenLite.getTweensOf = function(target, onlyActive) {
			if (target == null) { return []; }
			target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
			var i, a, j, t;
			if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
				i = target.length;
				a = [];
				while (--i > -1) {
					a = a.concat(TweenLite.getTweensOf(target[i], onlyActive));
				}
				i = a.length;
				//now get rid of any duplicates (tweens of arrays of objects could cause duplicates)
				while (--i > -1) {
					t = a[i];
					j = i;
					while (--j > -1) {
						if (t === a[j]) {
							a.splice(i, 1);
						}
					}
				}
			} else if (target._gsTweenID) {
				a = _register(target).concat();
				i = a.length;
				while (--i > -1) {
					if (a[i]._gc || (onlyActive && !a[i].isActive())) {
						a.splice(i, 1);
					}
				}
			}
			return a || [];
		};

		TweenLite.killTweensOf = TweenLite.killDelayedCallsTo = function(target, onlyActive, vars) {
			if (typeof(onlyActive) === "object") {
				vars = onlyActive; //for backwards compatibility (before "onlyActive" parameter was inserted)
				onlyActive = false;
			}
			var a = TweenLite.getTweensOf(target, onlyActive),
				i = a.length;
			while (--i > -1) {
				a[i]._kill(vars, target);
			}
		};



/*
 * ----------------------------------------------------------------
 * TweenPlugin   (could easily be split out as a separate file/class, but included for ease of use (so that people don't need to include another script call before loading plugins which is easy to forget)
 * ----------------------------------------------------------------
 */
		var TweenPlugin = _class("plugins.TweenPlugin", function(props, priority) {
					this._overwriteProps = (props || "").split(",");
					this._propName = this._overwriteProps[0];
					this._priority = priority || 0;
					this._super = TweenPlugin.prototype;
				}, true);

		p = TweenPlugin.prototype;
		TweenPlugin.version = "1.19.0";
		TweenPlugin.API = 2;
		p._firstPT = null;
		p._addTween = _addPropTween;
		p.setRatio = _setRatio;

		p._kill = function(lookup) {
			var a = this._overwriteProps,
				pt = this._firstPT,
				i;
			if (lookup[this._propName] != null) {
				this._overwriteProps = [];
			} else {
				i = a.length;
				while (--i > -1) {
					if (lookup[a[i]] != null) {
						a.splice(i, 1);
					}
				}
			}
			while (pt) {
				if (lookup[pt.n] != null) {
					if (pt._next) {
						pt._next._prev = pt._prev;
					}
					if (pt._prev) {
						pt._prev._next = pt._next;
						pt._prev = null;
					} else if (this._firstPT === pt) {
						this._firstPT = pt._next;
					}
				}
				pt = pt._next;
			}
			return false;
		};

		p._mod = p._roundProps = function(lookup) {
			var pt = this._firstPT,
				val;
			while (pt) {
				val = lookup[this._propName] || (pt.n != null && lookup[ pt.n.split(this._propName + "_").join("") ]);
				if (val && typeof(val) === "function") { //some properties that are very plugin-specific add a prefix named after the _propName plus an underscore, so we need to ignore that extra stuff here.
					if (pt.f === 2) {
						pt.t._applyPT.m = val;
					} else {
						pt.m = val;
					}
				}
				pt = pt._next;
			}
		};

		TweenLite._onPluginEvent = function(type, tween) {
			var pt = tween._firstPT,
				changed, pt2, first, last, next;
			if (type === "_onInitAllProps") {
				//sorts the PropTween linked list in order of priority because some plugins need to render earlier/later than others, like MotionBlurPlugin applies its effects after all x/y/alpha tweens have rendered on each frame.
				while (pt) {
					next = pt._next;
					pt2 = first;
					while (pt2 && pt2.pr > pt.pr) {
						pt2 = pt2._next;
					}
					if ((pt._prev = pt2 ? pt2._prev : last)) {
						pt._prev._next = pt;
					} else {
						first = pt;
					}
					if ((pt._next = pt2)) {
						pt2._prev = pt;
					} else {
						last = pt;
					}
					pt = next;
				}
				pt = tween._firstPT = first;
			}
			while (pt) {
				if (pt.pg) if (typeof(pt.t[type]) === "function") if (pt.t[type]()) {
					changed = true;
				}
				pt = pt._next;
			}
			return changed;
		};

		TweenPlugin.activate = function(plugins) {
			var i = plugins.length;
			while (--i > -1) {
				if (plugins[i].API === TweenPlugin.API) {
					_plugins[(new plugins[i]())._propName] = plugins[i];
				}
			}
			return true;
		};

		//provides a more concise way to define plugins that have no dependencies besides TweenPlugin and TweenLite, wrapping common boilerplate stuff into one function (added in 1.9.0). You don't NEED to use this to define a plugin - the old way still works and can be useful in certain (rare) situations.
		_gsDefine.plugin = function(config) {
			if (!config || !config.propName || !config.init || !config.API) { throw "illegal plugin definition."; }
			var propName = config.propName,
				priority = config.priority || 0,
				overwriteProps = config.overwriteProps,
				map = {init:"_onInitTween", set:"setRatio", kill:"_kill", round:"_mod", mod:"_mod", initAll:"_onInitAllProps"},
				Plugin = _class("plugins." + propName.charAt(0).toUpperCase() + propName.substr(1) + "Plugin",
					function() {
						TweenPlugin.call(this, propName, priority);
						this._overwriteProps = overwriteProps || [];
					}, (config.global === true)),
				p = Plugin.prototype = new TweenPlugin(propName),
				prop;
			p.constructor = Plugin;
			Plugin.API = config.API;
			for (prop in map) {
				if (typeof(config[prop]) === "function") {
					p[map[prop]] = config[prop];
				}
			}
			Plugin.version = config.version;
			TweenPlugin.activate([Plugin]);
			return Plugin;
		};


		//now run through all the dependencies discovered and if any are missing, log that to the console as a warning. This is why it's best to have TweenLite load last - it can check all the dependencies for you.
		a = window._gsQueue;
		if (a) {
			for (i = 0; i < a.length; i++) {
				a[i]();
			}
			for (p in _defLookup) {
				if (!_defLookup[p].func) {
					window.console.log("GSAP encountered missing dependency: " + p);
				}
			}
		}

		_tickerActive = false; //ensures that the first official animation forces a ticker.tick() to update the time when it is instantiated

		return TweenLite;

})(_gsScope, "TweenLite");

var globals = _gsScope.GreenSockGlobals;
var nonGlobals = globals.com.greensock;

var SimpleTimeline = nonGlobals.core.SimpleTimeline;
var Animation = nonGlobals.core.Animation;
var Ease = globals.Ease;
var Linear = globals.Linear;
var Power0 = Linear;
var Power1 = globals.Power1;
var Power2 = globals.Power2;
var Power3 = globals.Power3;
var Power4 = globals.Power4;
var TweenPlugin = globals.TweenPlugin;
var EventDispatcher = nonGlobals.events.EventDispatcher;

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(52)(module), __webpack_require__(1)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(195);
var isBuffer = __webpack_require__(384);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return sym; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TASK; });
/* unused harmony export HELPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELF_CANCELLATION; });
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ident; });
/* harmony export (immutable) */ __webpack_exports__["g"] = check;
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return object; });
/* harmony export (immutable) */ __webpack_exports__["t"] = remove;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return array; });
/* harmony export (immutable) */ __webpack_exports__["i"] = deferred;
/* unused harmony export arrayOfDeffered */
/* harmony export (immutable) */ __webpack_exports__["j"] = delay;
/* unused harmony export createMockTask */
/* unused harmony export autoInc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return uid; });
/* harmony export (immutable) */ __webpack_exports__["q"] = makeIterator;
/* harmony export (immutable) */ __webpack_exports__["p"] = log;
/* harmony export (immutable) */ __webpack_exports__["k"] = deprecate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return updateIncentive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createSetContextWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return wrapSagaDispatch; });
/* unused harmony export cloneableGenerator */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var sym = function sym(id) {
  return '@@redux-saga/' + id;
};

var TASK = /*#__PURE__*/sym('TASK');
var HELPER = /*#__PURE__*/sym('HELPER');
var MATCH = /*#__PURE__*/sym('MATCH');
var CANCEL = /*#__PURE__*/sym('CANCEL_PROMISE');
var SAGA_ACTION = /*#__PURE__*/sym('SAGA_ACTION');
var SELF_CANCELLATION = /*#__PURE__*/sym('SELF_CANCELLATION');
var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = /*#__PURE__*/konst(true);
var kFalse = /*#__PURE__*/konst(false);
var noop = function noop() {};
var ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  }
};

var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var array = {
  from: function from(obj) {
    var arr = Array(obj.length);
    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }
    return arr;
  }
};

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var uid = /*#__PURE__*/autoInc();

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) log('warn', deprecationWarning);
    return fn.apply(undefined, arguments);
  };
}

var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loglevel__ = __webpack_require__(264);
/* unused harmony reexport LogLevel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__session__ = __webpack_require__(265);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__session__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__severity__ = __webpack_require__(266);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__severity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__status__ = __webpack_require__(267);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__status__["a"]; });




//# sourceMappingURL=index.js.map

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IntlErrorCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IntlError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UnsupportedFormatterError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return InvalidConfigError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MissingDataError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MessageFormatError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MissingTranslationError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(45);

var IntlErrorCode;
(function (IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})(IntlErrorCode || (IntlErrorCode = {}));
var IntlError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = _super.call(this, "[@formatjs/intl Error " + code + "] " + message + " \n" + (exception ? "\n" + exception.message + "\n" + exception.stack : '')) || this;
        _this.code = code;
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(_this, IntlError);
        }
        return _this;
    }
    return IntlError;
}(Error));

var UnsupportedFormatterError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, "UNSUPPORTED_FORMATTER" /* UNSUPPORTED_FORMATTER */, message, exception) || this;
    }
    return UnsupportedFormatterError;
}(IntlError));

var InvalidConfigError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, "INVALID_CONFIG" /* INVALID_CONFIG */, message, exception) || this;
    }
    return InvalidConfigError;
}(IntlError));

var MissingDataError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, "MISSING_DATA" /* MISSING_DATA */, message, exception) || this;
    }
    return MissingDataError;
}(IntlError));

var MessageFormatError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "FORMAT_ERROR" /* FORMAT_ERROR */, message + " \nLocale: " + locale + "\nMessageID: " + (descriptor === null || descriptor === void 0 ? void 0 : descriptor.id) + "\nDefault Message: " + (descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage) + "\nDescription: " + (descriptor === null || descriptor === void 0 ? void 0 : descriptor.description) + " \n", exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}(IntlError));

var MissingTranslationError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, "MISSING_TRANSLATION" /* MISSING_TRANSLATION */, "Missing message: \"" + descriptor.id + "\" for locale \"" + locale + "\", using " + (descriptor.defaultMessage ? 'default message' : 'id') + " as fallback.") || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}(IntlError));



/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defineMessages */
/* unused harmony export defineMessage */
/* unused harmony export FormattedDate */
/* unused harmony export FormattedTime */
/* unused harmony export FormattedNumber */
/* unused harmony export FormattedList */
/* unused harmony export FormattedDisplayName */
/* unused harmony export FormattedDateParts */
/* unused harmony export FormattedTimeParts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_components_createFormattedComponent__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatjs_intl__ = __webpack_require__(99);
/* unused harmony reexport createIntlCache */
/* unused harmony reexport UnsupportedFormatterError */
/* unused harmony reexport InvalidConfigError */
/* unused harmony reexport MissingDataError */
/* unused harmony reexport MessageFormatError */
/* unused harmony reexport MissingTranslationError */
/* unused harmony reexport ReactIntlErrorCode */
/* unused harmony reexport ReactIntlError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_injectIntl__ = __webpack_require__(22);
/* unused harmony reexport injectIntl */
/* unused harmony reexport RawIntlProvider */
/* unused harmony reexport IntlContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_components_useIntl__ = __webpack_require__(374);
/* unused harmony reexport useIntl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_provider__ = __webpack_require__(375);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__src_components_provider__["a"]; });
/* unused harmony reexport createIntl */
/* unused harmony reexport FormattedNumberParts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_components_relative__ = __webpack_require__(376);
/* unused harmony reexport FormattedRelativeTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_components_plural__ = __webpack_require__(377);
/* unused harmony reexport FormattedPlural */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_components_message__ = __webpack_require__(378);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__src_components_message__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_components_dateTimeRange__ = __webpack_require__(379);
/* unused harmony reexport FormattedDateTimeRange */


function defineMessages(msgs) {
    return msgs;
}
function defineMessage(msg) {
    return msg;
}



// IMPORTANT: Explicit here to prevent api-extractor from outputing `import('./src/types').CustomFormatConfig`
var FormattedDate = Object(__WEBPACK_IMPORTED_MODULE_0__src_components_createFormattedComponent__["a" /* createFormattedComponent */])('formatDate');
var FormattedTime = Object(__WEBPACK_IMPORTED_MODULE_0__src_components_createFormattedComponent__["a" /* createFormattedComponent */])('formatTime');
var FormattedNumber = Object(__WEBPACK_IMPORTED_MODULE_0__src_components_createFormattedComponent__["a" /* createFormattedComponent */])('formatNumber');
var FormattedList = Object(__WEBPACK_IMPORTED_MODULE_0__src_components_createFormattedComponent__["a" /* createFormattedComponent */])('formatList');
var FormattedDisplayName = Object(__WEBPACK_IMPORTED_MODULE_0__src_components_createFormattedComponent__["a" /* createFormattedComponent */])('formatDisplayName');
var FormattedDateParts = Object(__WEBPACK_IMPORTED_MODULE_0__src_components_createFormattedComponent__["b" /* createFormattedDateTimePartsComponent */])('formatDate');
var FormattedTimeParts = Object(__WEBPACK_IMPORTED_MODULE_0__src_components_createFormattedComponent__["b" /* createFormattedDateTimePartsComponent */])('formatTime');







/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(222);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = filterProps;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_INTL_CONFIG; });
/* harmony export (immutable) */ __webpack_exports__["c"] = createIntlCache;
/* harmony export (immutable) */ __webpack_exports__["b"] = createFormatters;
/* harmony export (immutable) */ __webpack_exports__["e"] = getNamedFormat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fast_memoize__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fast_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fast_memoize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error__ = __webpack_require__(17);




function filterProps(props, whitelist, defaults) {
    if (defaults === void 0) { defaults = {}; }
    return whitelist.reduce(function (filtered, name) {
        if (name in props) {
            filtered[name] = props[name];
        }
        else if (name in defaults) {
            filtered[name] = defaults[name];
        }
        return filtered;
    }, {});
}
var defaultErrorHandler = function (error) {
    if (false) {
        console.error(error);
    }
};
var DEFAULT_INTL_CONFIG = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    onError: defaultErrorHandler,
};
function createIntlCache() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {},
    };
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                has: function (key) {
                    return key in store;
                },
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
// @ts-ignore this is to deal with rollup's default import shenanigans
var _memoizeIntl = __WEBPACK_IMPORTED_MODULE_2_fast_memoize__["default"] || __WEBPACK_IMPORTED_MODULE_2_fast_memoize__;
var memoizeIntl = _memoizeIntl;
/**
 * Create intl formatters and populate cache
 * @param cache explicit cache to prevent leaking memory
 */
function createFormatters(cache) {
    if (cache === void 0) { cache = createIntlCache(); }
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = memoizeIntl(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spreadArrays */])([void 0], args)))();
    }, {
        cache: createFastMemoizeCache(cache.dateTime),
        strategy: memoizeIntl.strategies.variadic,
    });
    var getNumberFormat = memoizeIntl(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.NumberFormat).bind.apply(_a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spreadArrays */])([void 0], args)))();
    }, {
        cache: createFastMemoizeCache(cache.number),
        strategy: memoizeIntl.strategies.variadic,
    });
    var getPluralRules = memoizeIntl(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.PluralRules).bind.apply(_a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spreadArrays */])([void 0], args)))();
    }, {
        cache: createFastMemoizeCache(cache.pluralRules),
        strategy: memoizeIntl.strategies.variadic,
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: memoizeIntl(function (message, locales, overrideFormats, opts) {
            return new __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__["b" /* IntlMessageFormat */](message, locales, overrideFormats, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules,
                } }, (opts || {})));
        }, {
            cache: createFastMemoizeCache(cache.message),
            strategy: memoizeIntl.strategies.variadic,
        }),
        getRelativeTimeFormat: memoizeIntl(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spreadArrays */])([void 0], args)))();
        }, {
            cache: createFastMemoizeCache(cache.relativeTime),
            strategy: memoizeIntl.strategies.variadic,
        }),
        getPluralRules: getPluralRules,
        getListFormat: memoizeIntl(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (ListFormat.bind.apply(ListFormat, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spreadArrays */])([void 0], args)))();
        }, {
            cache: createFastMemoizeCache(cache.list),
            strategy: memoizeIntl.strategies.variadic,
        }),
        getDisplayNames: memoizeIntl(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (DisplayNames.bind.apply(DisplayNames, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spreadArrays */])([void 0], args)))();
        }, {
            cache: createFastMemoizeCache(cache.displayNames),
            strategy: memoizeIntl.strategies.variadic,
        }),
    };
}
function getNamedFormat(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) {
        format = formatType[name];
    }
    if (format) {
        return format;
    }
    onError(new __WEBPACK_IMPORTED_MODULE_3__error__["f" /* UnsupportedFormatterError */]("No " + type + " format named: " + name));
}


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Context; });
/* harmony export (immutable) */ __webpack_exports__["c"] = injectIntl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(27);



// Since rollup cannot deal with namespace being a function,
// this is to interop with TypeScript since `invariant`
// does not export a default
// https://github.com/rollup/rollup/issues/1267
var hoistNonReactStatics = __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default.a.default || __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default.a;

function getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// TODO: We should provide initial value here
var IntlContext = __WEBPACK_IMPORTED_MODULE_1_react__["createContext"](null);
var IntlConsumer = IntlContext.Consumer, IntlProvider = IntlContext.Provider;
var Provider = IntlProvider;
var Context = IntlContext;
function injectIntl(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](IntlConsumer, null, function (intl) {
        var _a;
        if (enforceContext) {
            Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* invariantIntlContext */])(intl);
        }
        var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](WrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, intlProp, { ref: forwardRef ? props.forwardedRef : null })));
    })); };
    WithIntl.displayName = "injectIntl(" + getDisplayName(WrappedComponent) + ")";
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) {
        return hoistNonReactStatics(__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"](function (props, ref) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](WithIntl, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, { forwardedRef: ref }))); }), WrappedComponent);
    }
    return hoistNonReactStatics(WithIntl, WrappedComponent);
}


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export detach */
/* harmony export (immutable) */ __webpack_exports__["h"] = take;
/* unused harmony export takem */
/* harmony export (immutable) */ __webpack_exports__["g"] = put;
/* harmony export (immutable) */ __webpack_exports__["b"] = all;
/* unused harmony export race */
/* harmony export (immutable) */ __webpack_exports__["d"] = call;
/* unused harmony export apply */
/* unused harmony export cps */
/* harmony export (immutable) */ __webpack_exports__["f"] = fork;
/* unused harmony export spawn */
/* unused harmony export join */
/* harmony export (immutable) */ __webpack_exports__["e"] = cancel;
/* unused harmony export select */
/* harmony export (immutable) */ __webpack_exports__["a"] = actionChannel;
/* unused harmony export cancelled */
/* unused harmony export flush */
/* unused harmony export getContext */
/* unused harmony export setContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return asEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(14);


var IO = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["u" /* sym */])('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
};

var detach = function detach(eff) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(asEffect.fork(eff), __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, 'detach(eff): argument must be a fork effect');
  eff[FORK].detached = true;
  return eff;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(arguments[0], __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

take.maybe = function () {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
};

var takem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(take.maybe, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('takem', 'take.maybe'));

function put(channel, action) {
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument channel is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(action, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument action is undefined');
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.resolve = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].resolve = true;
  return eff;
};

put.sync = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(put.resolve, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('put.sync', 'put.resolve'));

function all(effects) {
  return effect(ALL, effects);
}

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }
  if (context && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string(fn) && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(context[fn])) {
    fn = context[fn];
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(undefined, [fn].concat(args)));
}

function join() {
  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }
  var task = tasks[0];
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'join(task): argument task is undefined');
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  return effect(JOIN, task);
}

function cancel() {
  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }
  var task = tasks[0];
  if (tasks.length === 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'cancel(task): argument task is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  }
  return effect(CANCEL, task || __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]);
}

function select(selector) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (arguments.length === 0) {
    selector = __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */];
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'select(selector,[...]): argument selector is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(pattern, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

function getContext(prop) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(prop, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string, 'getContext(prop): argument ' + prop + ' is not a string');
  return effect(GET_CONTEXT, prop);
}

function setContext(props) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])(null, props));
  return effect(SET_CONTEXT, props);
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = {
  take: /*#__PURE__*/createAsEffectType(TAKE),
  put: /*#__PURE__*/createAsEffectType(PUT),
  all: /*#__PURE__*/createAsEffectType(ALL),
  race: /*#__PURE__*/createAsEffectType(RACE),
  call: /*#__PURE__*/createAsEffectType(CALL),
  cps: /*#__PURE__*/createAsEffectType(CPS),
  fork: /*#__PURE__*/createAsEffectType(FORK),
  join: /*#__PURE__*/createAsEffectType(JOIN),
  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
  select: /*#__PURE__*/createAsEffectType(SELECT),
  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
  flush: /*#__PURE__*/createAsEffectType(FLUSH),
  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
};

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = isError;
/* harmony export (immutable) */ __webpack_exports__["e"] = isErrorEvent;
/* harmony export (immutable) */ __webpack_exports__["a"] = isDOMError;
/* harmony export (immutable) */ __webpack_exports__["b"] = isDOMException;
/* harmony export (immutable) */ __webpack_exports__["k"] = isString;
/* harmony export (immutable) */ __webpack_exports__["i"] = isPrimitive;
/* harmony export (immutable) */ __webpack_exports__["h"] = isPlainObject;
/* harmony export (immutable) */ __webpack_exports__["f"] = isEvent;
/* harmony export (immutable) */ __webpack_exports__["c"] = isElement;
/* harmony export (immutable) */ __webpack_exports__["j"] = isRegExp;
/* harmony export (immutable) */ __webpack_exports__["m"] = isThenable;
/* harmony export (immutable) */ __webpack_exports__["l"] = isSyntheticEvent;
/* harmony export (immutable) */ __webpack_exports__["g"] = isInstanceOf;
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (Object.prototype.toString.call(wat)) {
        case '[object Error]':
            return true;
        case '[object Exception]':
            return true;
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return Object.prototype.toString.call(wat) === '[object ErrorEvent]';
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMError]';
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMException]';
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return Object.prototype.toString.call(wat) === '[object String]';
}
/**
 * Checks whether given value's is a primitive (undefined, null, number, boolean, string)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return Object.prototype.toString.call(wat) === '[object Object]';
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return Object.prototype.toString.call(wat) === '[object RegExp]';
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    }
    catch (_e) {
        return false;
    }
}
//# sourceMappingURL=is.js.map

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(317)();
}


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["c"] = __rest;
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* harmony export (immutable) */ __webpack_exports__["d"] = __spreadArrays;
/* unused harmony export __spreadArray */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = invariantIntlContext;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_INTL_CONFIG; });
/* harmony export (immutable) */ __webpack_exports__["b"] = assignUniqueKeysToParts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatjs_ecma402_abstract__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatjs_intl__ = __webpack_require__(99);




function invariantIntlContext(intl) {
    Object(__WEBPACK_IMPORTED_MODULE_2__formatjs_ecma402_abstract__["a" /* invariant */])(intl, '[React Intl] Could not find required `intl` object. ' +
        '<IntlProvider> needs to exist in the component ancestry.');
}
var DEFAULT_INTL_CONFIG = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, __WEBPACK_IMPORTED_MODULE_3__formatjs_intl__["a" /* DEFAULT_INTL_CONFIG */]), { textComponent: __WEBPACK_IMPORTED_MODULE_1_react__["Fragment"] });
/**
 * Takes a `formatXMLElementFn`, and composes it in function, which passes
 * argument `parts` through, assigning unique key to each part, to prevent
 * "Each child in a list should have a unique "key"" React error.
 * @param formatXMLElementFn
 */
function assignUniqueKeysToParts(formatXMLElementFn) {
    return function (parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn(__WEBPACK_IMPORTED_MODULE_1_react__["Children"].toArray(parts));
    };
}


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GetOption;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__262__ = __webpack_require__(6);

/**
 * https://tc39.es/ecma402/#sec-getoption
 * @param opts
 * @param prop
 * @param type
 * @param values
 * @param fallback
 */
function GetOption(opts, prop, type, values, fallback) {
    // const descriptor = Object.getOwnPropertyDescriptor(opts, prop);
    var value = opts[prop];
    if (value !== undefined) {
        if (type !== 'boolean' && type !== 'string') {
            throw new TypeError('invalid type');
        }
        if (type === 'boolean') {
            value = Boolean(value);
        }
        if (type === 'string') {
            value = Object(__WEBPACK_IMPORTED_MODULE_0__262__["l" /* ToString */])(value);
        }
        if (values !== undefined && !values.filter(function (val) { return val == value; }).length) {
            throw new RangeError(value + " is not within " + values.join(', '));
        }
        return value;
    }
    return fallback;
}


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_core__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_formatters__ = __webpack_require__(185);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_formatters__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_error__ = __webpack_require__(186);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_error__["a"]; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__src_core__["a" /* IntlMessageFormat */]);


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(503),
    getValue = __webpack_require__(508);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 31 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scope__ = __webpack_require__(126);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__scope__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__scope__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__session__ = __webpack_require__(131);
/* unused harmony reexport Session */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hub__ = __webpack_require__(276);
/* unused harmony reexport getActiveDomain */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__hub__["a"]; });
/* unused harmony reexport getHubFromCarrier */
/* unused harmony reexport getMainCarrier */
/* unused harmony reexport Hub */
/* unused harmony reexport makeMain */
/* unused harmony reexport setHubOnCarrier */



//# sourceMappingURL=index.js.map

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CanonicalizeLocaleList;
/**
 * http://ecma-international.org/ecma-402/7.0/index.html#sec-canonicalizelocalelist
 * @param locales
 */
function CanonicalizeLocaleList(locales) {
    // TODO
    return Intl.getCanonicalLocales(locales);
}


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module dependencies.
 */

var keys = __webpack_require__(459);
var hasBinary = __webpack_require__(460);
var sliceBuffer = __webpack_require__(462);
var after = __webpack_require__(463);
var utf8 = __webpack_require__(464);

var base64encoder;
if (global && global.ArrayBuffer) {
  base64encoder = __webpack_require__(465);
}

/**
 * Check if we are running an android browser. That requires us to use
 * ArrayBuffer with polling transports...
 *
 * http://ghinda.net/jpeg-blob-ajax-android/
 */

var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);

/**
 * Check if we are running in PhantomJS.
 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
 * https://github.com/ariya/phantomjs/issues/11395
 * @type boolean
 */
var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);

/**
 * When true, avoids using Blobs to encode payloads.
 * @type boolean
 */
var dontSendBlobs = isAndroid || isPhantomJS;

/**
 * Current protocol version.
 */

exports.protocol = 3;

/**
 * Packet types.
 */

var packets = exports.packets = {
    open:     0    // non-ws
  , close:    1    // non-ws
  , ping:     2
  , pong:     3
  , message:  4
  , upgrade:  5
  , noop:     6
};

var packetslist = keys(packets);

/**
 * Premade error packet.
 */

var err = { type: 'error', data: 'parser error' };

/**
 * Create a blob api even for blob builder when vendor prefixes exist
 */

var Blob = __webpack_require__(466);

/**
 * Encodes a packet.
 *
 *     <packet type id> [ <data> ]
 *
 * Example:
 *
 *     5hello world
 *     3
 *     4
 *
 * Binary is encoded in an identical principle
 *
 * @api private
 */

exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
  if ('function' == typeof supportsBinary) {
    callback = supportsBinary;
    supportsBinary = false;
  }

  if ('function' == typeof utf8encode) {
    callback = utf8encode;
    utf8encode = null;
  }

  var data = (packet.data === undefined)
    ? undefined
    : packet.data.buffer || packet.data;

  if (global.ArrayBuffer && data instanceof ArrayBuffer) {
    return encodeArrayBuffer(packet, supportsBinary, callback);
  } else if (Blob && data instanceof global.Blob) {
    return encodeBlob(packet, supportsBinary, callback);
  }

  // might be an object with { base64: true, data: dataAsBase64String }
  if (data && data.base64) {
    return encodeBase64Object(packet, callback);
  }

  // Sending data as a utf-8 string
  var encoded = packets[packet.type];

  // data fragment is optional
  if (undefined !== packet.data) {
    encoded += utf8encode ? utf8.encode(String(packet.data)) : String(packet.data);
  }

  return callback('' + encoded);

};

function encodeBase64Object(packet, callback) {
  // packet data is an object { base64: true, data: dataAsBase64String }
  var message = 'b' + exports.packets[packet.type] + packet.data.data;
  return callback(message);
}

/**
 * Encode packet helpers for binary types
 */

function encodeArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var data = packet.data;
  var contentArray = new Uint8Array(data);
  var resultBuffer = new Uint8Array(1 + data.byteLength);

  resultBuffer[0] = packets[packet.type];
  for (var i = 0; i < contentArray.length; i++) {
    resultBuffer[i+1] = contentArray[i];
  }

  return callback(resultBuffer.buffer);
}

function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var fr = new FileReader();
  fr.onload = function() {
    packet.data = fr.result;
    exports.encodePacket(packet, supportsBinary, true, callback);
  };
  return fr.readAsArrayBuffer(packet.data);
}

function encodeBlob(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  if (dontSendBlobs) {
    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
  }

  var length = new Uint8Array(1);
  length[0] = packets[packet.type];
  var blob = new Blob([length.buffer, packet.data]);

  return callback(blob);
}

/**
 * Encodes a packet with binary data in a base64 string
 *
 * @param {Object} packet, has `type` and `data`
 * @return {String} base64 encoded message
 */

exports.encodeBase64Packet = function(packet, callback) {
  var message = 'b' + exports.packets[packet.type];
  if (Blob && packet.data instanceof global.Blob) {
    var fr = new FileReader();
    fr.onload = function() {
      var b64 = fr.result.split(',')[1];
      callback(message + b64);
    };
    return fr.readAsDataURL(packet.data);
  }

  var b64data;
  try {
    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
  } catch (e) {
    // iPhone Safari doesn't let you apply with typed arrays
    var typed = new Uint8Array(packet.data);
    var basic = new Array(typed.length);
    for (var i = 0; i < typed.length; i++) {
      basic[i] = typed[i];
    }
    b64data = String.fromCharCode.apply(null, basic);
  }
  message += global.btoa(b64data);
  return callback(message);
};

/**
 * Decodes a packet. Changes format to Blob if requested.
 *
 * @return {Object} with `type` and `data` (if any)
 * @api private
 */

exports.decodePacket = function (data, binaryType, utf8decode) {
  if (data === undefined) {
    return err;
  }
  // String data
  if (typeof data == 'string') {
    if (data.charAt(0) == 'b') {
      return exports.decodeBase64Packet(data.substr(1), binaryType);
    }

    if (utf8decode) {
      data = tryDecode(data);
      if (data === false) {
        return err;
      }
    }
    var type = data.charAt(0);

    if (Number(type) != type || !packetslist[type]) {
      return err;
    }

    if (data.length > 1) {
      return { type: packetslist[type], data: data.substring(1) };
    } else {
      return { type: packetslist[type] };
    }
  }

  var asArray = new Uint8Array(data);
  var type = asArray[0];
  var rest = sliceBuffer(data, 1);
  if (Blob && binaryType === 'blob') {
    rest = new Blob([rest]);
  }
  return { type: packetslist[type], data: rest };
};

function tryDecode(data) {
  try {
    data = utf8.decode(data);
  } catch (e) {
    return false;
  }
  return data;
}

/**
 * Decodes a packet encoded in a base64 string
 *
 * @param {String} base64 encoded message
 * @return {Object} with `type` and `data` (if any)
 */

exports.decodeBase64Packet = function(msg, binaryType) {
  var type = packetslist[msg.charAt(0)];
  if (!base64encoder) {
    return { type: type, data: { base64: true, data: msg.substr(1) } };
  }

  var data = base64encoder.decode(msg.substr(1));

  if (binaryType === 'blob' && Blob) {
    data = new Blob([data]);
  }

  return { type: type, data: data };
};

/**
 * Encodes multiple messages (payload).
 *
 *     <length>:data
 *
 * Example:
 *
 *     11:hello world2:hi
 *
 * If any contents are binary, they will be encoded as base64 strings. Base64
 * encoded strings are marked with a b before the length specifier
 *
 * @param {Array} packets
 * @api private
 */

exports.encodePayload = function (packets, supportsBinary, callback) {
  if (typeof supportsBinary == 'function') {
    callback = supportsBinary;
    supportsBinary = null;
  }

  var isBinary = hasBinary(packets);

  if (supportsBinary && isBinary) {
    if (Blob && !dontSendBlobs) {
      return exports.encodePayloadAsBlob(packets, callback);
    }

    return exports.encodePayloadAsArrayBuffer(packets, callback);
  }

  if (!packets.length) {
    return callback('0:');
  }

  function setLengthHeader(message) {
    return message.length + ':' + message;
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, !isBinary ? false : supportsBinary, true, function(message) {
      doneCallback(null, setLengthHeader(message));
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(results.join(''));
  });
};

/**
 * Async array map using after
 */

function map(ary, each, done) {
  var result = new Array(ary.length);
  var next = after(ary.length, done);

  var eachWithIndex = function(i, el, cb) {
    each(el, function(error, msg) {
      result[i] = msg;
      cb(error, result);
    });
  };

  for (var i = 0; i < ary.length; i++) {
    eachWithIndex(i, ary[i], next);
  }
}

/*
 * Decodes data when a payload is maybe expected. Possible binary contents are
 * decoded from their base64 representation
 *
 * @param {String} data, callback method
 * @api public
 */

exports.decodePayload = function (data, binaryType, callback) {
  if (typeof data != 'string') {
    return exports.decodePayloadAsBinary(data, binaryType, callback);
  }

  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var packet;
  if (data == '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

  var length = ''
    , n, msg;

  for (var i = 0, l = data.length; i < l; i++) {
    var chr = data.charAt(i);

    if (':' != chr) {
      length += chr;
    } else {
      if ('' == length || (length != (n = Number(length)))) {
        // parser error - ignoring payload
        return callback(err, 0, 1);
      }

      msg = data.substr(i + 1, n);

      if (length != msg.length) {
        // parser error - ignoring payload
        return callback(err, 0, 1);
      }

      if (msg.length) {
        packet = exports.decodePacket(msg, binaryType, true);

        if (err.type == packet.type && err.data == packet.data) {
          // parser error in individual packet - ignoring payload
          return callback(err, 0, 1);
        }

        var ret = callback(packet, i + n, l);
        if (false === ret) return;
      }

      // advance cursor
      i += n;
      length = '';
    }
  }

  if (length != '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

};

/**
 * Encodes multiple messages (payload) as binary.
 *
 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
 * 255><data>
 *
 * Example:
 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
 *
 * @param {Array} packets
 * @return {ArrayBuffer} encoded payload
 * @api private
 */

exports.encodePayloadAsArrayBuffer = function(packets, callback) {
  if (!packets.length) {
    return callback(new ArrayBuffer(0));
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(data) {
      return doneCallback(null, data);
    });
  }

  map(packets, encodeOne, function(err, encodedPackets) {
    var totalLength = encodedPackets.reduce(function(acc, p) {
      var len;
      if (typeof p === 'string'){
        len = p.length;
      } else {
        len = p.byteLength;
      }
      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
    }, 0);

    var resultArray = new Uint8Array(totalLength);

    var bufferIndex = 0;
    encodedPackets.forEach(function(p) {
      var isString = typeof p === 'string';
      var ab = p;
      if (isString) {
        var view = new Uint8Array(p.length);
        for (var i = 0; i < p.length; i++) {
          view[i] = p.charCodeAt(i);
        }
        ab = view.buffer;
      }

      if (isString) { // not true binary
        resultArray[bufferIndex++] = 0;
      } else { // true binary
        resultArray[bufferIndex++] = 1;
      }

      var lenStr = ab.byteLength.toString();
      for (var i = 0; i < lenStr.length; i++) {
        resultArray[bufferIndex++] = parseInt(lenStr[i]);
      }
      resultArray[bufferIndex++] = 255;

      var view = new Uint8Array(ab);
      for (var i = 0; i < view.length; i++) {
        resultArray[bufferIndex++] = view[i];
      }
    });

    return callback(resultArray.buffer);
  });
};

/**
 * Encode as Blob
 */

exports.encodePayloadAsBlob = function(packets, callback) {
  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(encoded) {
      var binaryIdentifier = new Uint8Array(1);
      binaryIdentifier[0] = 1;
      if (typeof encoded === 'string') {
        var view = new Uint8Array(encoded.length);
        for (var i = 0; i < encoded.length; i++) {
          view[i] = encoded.charCodeAt(i);
        }
        encoded = view.buffer;
        binaryIdentifier[0] = 0;
      }

      var len = (encoded instanceof ArrayBuffer)
        ? encoded.byteLength
        : encoded.size;

      var lenStr = len.toString();
      var lengthAry = new Uint8Array(lenStr.length + 1);
      for (var i = 0; i < lenStr.length; i++) {
        lengthAry[i] = parseInt(lenStr[i]);
      }
      lengthAry[lenStr.length] = 255;

      if (Blob) {
        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
        doneCallback(null, blob);
      }
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(new Blob(results));
  });
};

/*
 * Decodes data when a payload is maybe expected. Strings are decoded by
 * interpreting each byte as a key code for entries marked to start with 0. See
 * description of encodePayloadAsBinary
 *
 * @param {ArrayBuffer} data, callback method
 * @api public
 */

exports.decodePayloadAsBinary = function (data, binaryType, callback) {
  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var bufferTail = data;
  var buffers = [];

  var numberTooLong = false;
  while (bufferTail.byteLength > 0) {
    var tailArray = new Uint8Array(bufferTail);
    var isString = tailArray[0] === 0;
    var msgLength = '';

    for (var i = 1; ; i++) {
      if (tailArray[i] == 255) break;

      if (msgLength.length > 310) {
        numberTooLong = true;
        break;
      }

      msgLength += tailArray[i];
    }

    if(numberTooLong) return callback(err, 0, 1);

    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
    msgLength = parseInt(msgLength);

    var msg = sliceBuffer(bufferTail, 0, msgLength);
    if (isString) {
      try {
        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
      } catch (e) {
        // iPhone Safari doesn't let you apply to typed arrays
        var typed = new Uint8Array(msg);
        msg = '';
        for (var i = 0; i < typed.length; i++) {
          msg += String.fromCharCode(typed[i]);
        }
      }
    }

    buffers.push(msg);
    bufferTail = sliceBuffer(bufferTail, msgLength);
  }

  var total = buffers.length;
  buffers.forEach(function(buffer, i) {
    callback(exports.decodePacket(buffer, binaryType, true), i, total);
  });
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isEnd; });
/* harmony export (immutable) */ __webpack_exports__["b"] = emitter;
/* unused harmony export INVALID_BUFFER */
/* unused harmony export UNDEFINED_INPUT_ERROR */
/* unused harmony export channel */
/* harmony export (immutable) */ __webpack_exports__["c"] = eventChannel;
/* harmony export (immutable) */ __webpack_exports__["e"] = stdChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffers__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler__ = __webpack_require__(213);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = { type: CHANNEL_END_TYPE };
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (false) {
  UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].fixed();

  var closed = false;
  var takers = [];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(input, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] || cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's callback must be a function");

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.flush' callback must be a function");
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var close = function close() {
    if (!chan.__closed__) {
      if (unsubscribe) {
        unsubscribe();
      }
      chan.close();
    }
  };
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }
    if (matcher && !matcher(input)) {
      return;
    }
    chan.put(input);
  });
  if (chan.__closed__) {
    unsubscribe();
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(function (cb) {
    return subscribe(function (input) {
      if (input[__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* SAGA_ACTION */]]) {
        cb(input);
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__scheduler__["a" /* asap */])(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's matcher argument must be a function");
        cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] = matcher;
      }
      chan.take(cb);
    }
  });
}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(66),
    getRawTag = __webpack_require__(504),
    objectToString = __webpack_require__(505);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 38 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(71);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(__webpack_require__(51));
util.inherits = __webpack_require__(31);
/*</replacement>*/

var Readable = __webpack_require__(244);
var Writable = __webpack_require__(248);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["e"] = getGlobalObject;
/* harmony export (immutable) */ __webpack_exports__["i"] = uuid4;
/* harmony export (immutable) */ __webpack_exports__["h"] = parseUrl;
/* harmony export (immutable) */ __webpack_exports__["d"] = getEventDescription;
/* harmony export (immutable) */ __webpack_exports__["c"] = consoleSandbox;
/* harmony export (immutable) */ __webpack_exports__["b"] = addExceptionTypeValue;
/* harmony export (immutable) */ __webpack_exports__["a"] = addExceptionMechanism;
/* harmony export (immutable) */ __webpack_exports__["f"] = getLocationHref;
/* unused harmony export parseSemver */
/* harmony export (immutable) */ __webpack_exports__["g"] = parseRetryAfterHeader;
/* unused harmony export addContextToFrame */
/* unused harmony export stripUrlQueryAndFragment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__string__ = __webpack_require__(80);


var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
    return (Object(__WEBPACK_IMPORTED_MODULE_0__node__["b" /* isNodeEnv */])()
        ? global
        : typeof window !== 'undefined'
            ? window
            : typeof self !== 'undefined'
                ? self
                : fallbackGlobalObject);
}
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
    var global = getGlobalObject();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = (arr[3] & 0xfff) | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = (arr[4] & 0x3fff) | 0x8000;
        var pad = function (num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = "0" + v;
            }
            return v;
        };
        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line no-bitwise
        var r = (Math.random() * 16) | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment,
    };
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
    if (event.message) {
        return event.message;
    }
    if (event.exception && event.exception.values && event.exception.values[0]) {
        var exception = event.exception.values[0];
        if (exception.type && exception.value) {
            return exception.type + ": " + exception.value;
        }
        return exception.type || exception.value || event.event_id || '<unknown>';
    }
    return event.event_id || '<unknown>';
}
/** JSDoc */
function consoleSandbox(callback) {
    var global = getGlobalObject();
    var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
    if (!('console' in global)) {
        return callback();
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    levels.forEach(function (level) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (level in global.console && originalConsole[level].__sentry_original__) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalConsole[level].__sentry_original__;
        }
    });
    // Perform callback manipulations
    var result = callback();
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(function (level) {
        originalConsole[level] = wrappedLevels[level];
    });
    return result;
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
    event.exception = event.exception || {};
    event.exception.values = event.exception.values || [];
    event.exception.values[0] = event.exception.values[0] || {};
    event.exception.values[0].value = event.exception.values[0].value || value || '';
    event.exception.values[0].type = event.exception.values[0].type || type || 'Error';
}
/**
 * Adds exception mechanism to a given event.
 * @param event The event to modify.
 * @param mechanism Mechanism of the mechanism.
 * @hidden
 */
function addExceptionMechanism(event, mechanism) {
    if (mechanism === void 0) { mechanism = {}; }
    // TODO: Use real type with `keyof Mechanism` thingy and maybe make it better?
    try {
        // @ts-ignore Type 'Mechanism | {}' is not assignable to type 'Mechanism | undefined'
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].mechanism = event.exception.values[0].mechanism || {};
        Object.keys(mechanism).forEach(function (key) {
            // @ts-ignore Mechanism has no index signature
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            event.exception.values[0].mechanism[key] = mechanism[key];
        });
    }
    catch (_oO) {
        // no-empty
    }
}
/**
 * A safe form of location.href
 */
function getLocationHref() {
    try {
        return document.location.href;
    }
    catch (oO) {
        return '';
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4],
    };
}
var defaultRetryAfter = 60 * 1000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param now current unix timestamp
 * @param header string representation of 'Retry-After' header
 */
function parseRetryAfterHeader(now, header) {
    if (!header) {
        return defaultRetryAfter;
    }
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) {
        return headerDelay * 1000;
    }
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) {
        return headerDate - now;
    }
    return defaultRetryAfter;
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) { linesOfContext = 5; }
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines
        .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
        .map(function (line) { return Object(__WEBPACK_IMPORTED_MODULE_1__string__["c" /* snipLine */])(line, 0); });
    frame.context_line = Object(__WEBPACK_IMPORTED_MODULE_1__string__["c" /* snipLine */])(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines
        .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
        .map(function (line) { return Object(__WEBPACK_IMPORTED_MODULE_1__string__["c" /* snipLine */])(line, 0); });
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
//# sourceMappingURL=misc.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = shouldIgnoreOnError;
/* unused harmony export ignoreNextOnError */
/* harmony export (immutable) */ __webpack_exports__["c"] = wrap;
/* harmony export (immutable) */ __webpack_exports__["a"] = injectReportDialog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(2);



var ignoreOnError = 0;
/**
 * @hidden
 */
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function () {
        ignoreOnError -= 1;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(fn, options, before) {
    if (options === void 0) { options = {}; }
    if (typeof fn !== 'function') {
        return fn;
    }
    try {
        // We don't wanna wrap it twice
        if (fn.__sentry__) {
            return fn;
        }
        // If this has already been wrapped in the past, return that wrapped function
        if (fn.__sentry_wrapped__) {
            return fn.__sentry_wrapped__;
        }
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function () {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') {
                before.apply(this, arguments);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
            if (fn.handleEvent) {
                // Attempt to invoke user-land function
                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
                //       means the sentry.javascript SDK caught an error invoking your application code. This
                //       is expected behavior and NOT indicative of a bug with sentry.javascript.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                return fn.handleEvent.apply(this, wrappedArguments);
            }
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        }
        catch (ex) {
            ignoreNextOnError();
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["l" /* withScope */])(function (scope) {
                scope.addEventProcessor(function (event) {
                    var processedEvent = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event);
                    if (options.mechanism) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["f" /* addExceptionTypeValue */])(processedEvent, undefined, undefined);
                        Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["e" /* addExceptionMechanism */])(processedEvent, options.mechanism);
                    }
                    processedEvent.extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, processedEvent.extra), { arguments: args });
                    return processedEvent;
                });
                Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["f" /* captureException */])(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for (var property in fn) {
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    }
    catch (_oO) { } // eslint-disable-line no-empty
    fn.prototype = fn.prototype || {};
    sentryWrapped.prototype = fn.prototype;
    Object.defineProperty(fn, '__sentry_wrapped__', {
        enumerable: false,
        value: sentryWrapped,
    });
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    Object.defineProperties(sentryWrapped, {
        __sentry__: {
            enumerable: false,
            value: true,
        },
        __sentry_original__: {
            enumerable: false,
            value: fn,
        },
    });
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, 'name', {
                get: function () {
                    return fn.name;
                },
            });
        }
        // eslint-disable-next-line no-empty
    }
    catch (_oO) { }
    return sentryWrapped;
}
/**
 * Injects the Report Dialog script
 * @hidden
 */
function injectReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!options.eventId) {
        __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["E" /* logger */].error("Missing eventId option in showReportDialog call");
        return;
    }
    if (!options.dsn) {
        __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["E" /* logger */].error("Missing dsn option in showReportDialog call");
        return;
    }
    var script = document.createElement('script');
    script.async = true;
    script.src = new __WEBPACK_IMPORTED_MODULE_1__sentry_core__["a" /* API */](options.dsn).getReportDialogEndpoint(options);
    if (options.onLoad) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        script.onload = options.onLoad;
    }
    (document.head || document.body).appendChild(script);
}
//# sourceMappingURL=helpers.js.map

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TimelineLite_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TimelineMax_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TweenMax_js__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CSSPlugin_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AttrPlugin_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RoundPropsPlugin_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DirectionalRotationPlugin_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BezierPlugin_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EasePack_js__ = __webpack_require__(143);
/* unused harmony reexport default */
/* unused harmony reexport TweenLite */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__TweenMax_js__["a"]; });
/* unused harmony reexport TimelineLite */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__TimelineMax_js__["a"]; });
/* unused harmony reexport CSSPlugin */
/* unused harmony reexport AttrPlugin */
/* unused harmony reexport BezierPlugin */
/* unused harmony reexport RoundPropsPlugin */
/* unused harmony reexport DirectionalRotationPlugin */
/* unused harmony reexport TweenPlugin */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Ease"]; });
/* unused harmony reexport Power0 */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Power1"]; });
/* unused harmony reexport Power2 */
/* unused harmony reexport Power3 */
/* unused harmony reexport Power4 */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Linear"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9__EasePack_js__["a"]; });
/* unused harmony reexport Elastic */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_9__EasePack_js__["b"]; });
/* unused harmony reexport RoughEase */
/* unused harmony reexport SlowMo */
/* unused harmony reexport SteppedEase */
/* unused harmony reexport Circ */
/* unused harmony reexport Expo */
/* unused harmony reexport Sine */
/* unused harmony reexport ExpoScaleEase */
/* unused harmony reexport _gsScope */
/*!
 * VERSION: 2.1.3
 * DATE: 2019-05-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 *
 * @author: Jack Doyle, jack@greensock.com
 **/
















/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATE_TIME_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return removalPenalty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return additionPenalty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return differentNumericTypePenalty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return longLessPenalty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return longMorePenalty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return shortLessPenalty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return shortMorePenalty; });
var DATE_TIME_PROPS = [
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
];
var removalPenalty = 120;
var additionPenalty = 20;
var differentNumericTypePenalty = 15;
var longLessPenalty = 8;
var longMorePenalty = 6;
var shortLessPenalty = 6;
var shortMorePenalty = 3;


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ResolveLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LookupMatcher__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BestFitMatcher__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UnicodeExtensionValue__ = __webpack_require__(351);




/**
 * https://tc39.es/ecma402/#sec-resolvelocale
 */
function ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData, getDefaultLocale) {
    var matcher = options.localeMatcher;
    var r;
    if (matcher === 'lookup') {
        r = Object(__WEBPACK_IMPORTED_MODULE_0__LookupMatcher__["a" /* LookupMatcher */])(availableLocales, requestedLocales, getDefaultLocale);
    }
    else {
        r = Object(__WEBPACK_IMPORTED_MODULE_1__BestFitMatcher__["a" /* BestFitMatcher */])(availableLocales, requestedLocales, getDefaultLocale);
    }
    var foundLocale = r.locale;
    var result = { locale: '', dataLocale: foundLocale };
    var supportedExtension = '-u';
    for (var _i = 0, relevantExtensionKeys_1 = relevantExtensionKeys; _i < relevantExtensionKeys_1.length; _i++) {
        var key = relevantExtensionKeys_1[_i];
        Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* invariant */])(foundLocale in localeData, "Missing locale data for " + foundLocale);
        var foundLocaleData = localeData[foundLocale];
        Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* invariant */])(typeof foundLocaleData === 'object' && foundLocaleData !== null, "locale data " + key + " must be an object");
        var keyLocaleData = foundLocaleData[key];
        Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* invariant */])(Array.isArray(keyLocaleData), "keyLocaleData for " + key + " must be an array");
        var value = keyLocaleData[0];
        Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* invariant */])(typeof value === 'string' || value === null, "value must be string or null but got " + typeof value + " in key " + key);
        var supportedExtensionAddition = '';
        if (r.extension) {
            var requestedValue = Object(__WEBPACK_IMPORTED_MODULE_3__UnicodeExtensionValue__["a" /* UnicodeExtensionValue */])(r.extension, key);
            if (requestedValue !== undefined) {
                if (requestedValue !== '') {
                    if (~keyLocaleData.indexOf(requestedValue)) {
                        value = requestedValue;
                        supportedExtensionAddition = "-" + key + "-" + value;
                    }
                }
                else if (~requestedValue.indexOf('true')) {
                    value = 'true';
                    supportedExtensionAddition = "-" + key;
                }
            }
        }
        if (key in options) {
            var optionsValue = options[key];
            Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* invariant */])(typeof optionsValue === 'string' ||
                typeof optionsValue === 'undefined' ||
                optionsValue === null, 'optionsValue must be String, Undefined or Null');
            if (~keyLocaleData.indexOf(optionsValue)) {
                if (optionsValue !== value) {
                    value = optionsValue;
                    supportedExtensionAddition = '';
                }
            }
        }
        result[key] = value;
        supportedExtension += supportedExtensionAddition;
    }
    if (supportedExtension.length > 2) {
        var privateIndex = foundLocale.indexOf('-x-');
        if (privateIndex === -1) {
            foundLocale = foundLocale + supportedExtension;
        }
        else {
            var preExtension = foundLocale.slice(0, privateIndex);
            var postExtension = foundLocale.slice(privateIndex, foundLocale.length);
            foundLocale = preExtension + supportedExtension + postExtension;
        }
        foundLocale = Intl.getCanonicalLocales(foundLocale)[0];
    }
    result.locale = foundLocale;
    return result;
}


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* harmony export (immutable) */ __webpack_exports__["c"] = __spreadArrays;
/* unused harmony export __spreadArray */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(383);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FRAME_CLASSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GRID_CLASSES; });
/* unused harmony export DEFAULT_SELECTED_FRAME_CLIP */
/* unused harmony export calculateAspectRatio */
/* unused harmony export prepareClipDetails */
/* unused harmony export isVideo */
/* unused harmony export prepareDefaultImgDetails */
/* unused harmony export prepareClipFromWorkspace */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getImageSource; });
/* unused harmony export getFrameAssets */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFrameDropAreaId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getGridDropAreaId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getFrameSvgId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFrameClipFilterSvgId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFrameClipFilterId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFrameClipVignetteId; });
/* unused harmony export getCellStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_app_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_itemConfig_json__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_itemConfig_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_itemConfig_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__URLHelper__ = __webpack_require__(106);
var appUrl=__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['APPICONS'][__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['APPICONS']['current']];var FRAME_CLASSES={"DROP_AREA":"frame-droppable-area","INNER_IMAGE":"frame-img-item"};var GRID_CLASSES={"DROP_AREA":"grid-droppable-area","INNER_IMAGE":"grid-img-item","BG_COLOR":"grid-bgcolor-item"};var DEFAULT_SELECTED_FRAME_CLIP=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({id:"",groupId:"",clipId:""});var DEFAULT_IMAGE_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({src:__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a.FRAME.DEFAULT_IMAGE,width:1500,height:600});var BASE_IMAGE_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({src:"",thumb:"",defaultImageDetails:DEFAULT_IMAGE_DETAILS,flipPosition:0,filter:"6464646464640032",type:"",id:"default"});var calculateAspectRatio=function calculateAspectRatio(Frame,Image,clip){var selectedItem=Frame;var imageWidth=void 0;var imageHeight=void 0;if(Image!==null){var selectedImage=Image;imageWidth=selectedImage.get("width");imageHeight=selectedImage.get("height");}else{imageWidth=selectedItem.getIn(["clipDetails",clip,"imgDetails","width"]);imageHeight=selectedItem.getIn(["clipDetails",clip,"imgDetails","height"]);}var imageAspectRatio=imageWidth/imageHeight;var frameScale=selectedItem.get("width")/selectedItem.get("defaultWidth");var clipWidth=selectedItem.getIn(["clipDetails",clip,"clipWidth"])*frameScale;var clipHeight=selectedItem.getIn(["clipDetails",clip,"clipHeight"])*frameScale;var frameAspectRatio=clipWidth/clipHeight;var width=void 0,height=void 0,type=void 0,X=selectedItem.getIn(["clipDetails",clip,"clipX"])*frameScale,Y=selectedItem.getIn(["clipDetails",clip,"clipY"])*frameScale;if(imageAspectRatio<frameAspectRatio){width=clipWidth;height=clipWidth*(imageHeight/imageWidth);Y=Y+clipHeight/2-height/2;type=1;}else if(imageAspectRatio>frameAspectRatio){width=clipHeight*(imageWidth/imageHeight);height=clipHeight;X=X+clipWidth/2-width/2;type=2;}else if(imageAspectRatio===frameAspectRatio){width=clipWidth;height=clipHeight;X=X+clipWidth/2-width/2;Y=Y+clipHeight/2-height/2;type=0;}var frameHeight=selectedItem.get("height");var frameWidth=selectedItem.get("width");width=width/frameWidth;height=height/frameHeight;X=X/frameWidth;Y=Y/frameHeight;return{width:width,height:height,X:X,Y:Y,type:type};};var prepareClipDetails=function prepareClipDetails(Frame){var clipDetails=Frame.get("clipDetails");clipDetails.keySeq().forEach(function(key){Frame=Frame.setIn(["clipDetails",key,"imgDetails"],BASE_IMAGE_DETAILS);var _calculateAspectRatio=calculateAspectRatio(Frame,DEFAULT_IMAGE_DETAILS,key),width=_calculateAspectRatio.width,height=_calculateAspectRatio.height,x=_calculateAspectRatio.X,y=_calculateAspectRatio.Y;Frame=Frame.setIn(["clipDetails",key,"imgDetails","original"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({width:width,height:height,x:x,y:y}));});return Frame.get("clipDetails");};function isVideo(type,subType){try{if(type==="STOCKVID"||subType==="UPVIDEO"||type==="VIDEO"||subType==="VIDEO"||subType==="OBGVID"){return true;}return false;}catch(error){console.log(error);}}var prepareDefaultImgDetails=function prepareDefaultImgDetails(Frame,clipId){var imgDetails=BASE_IMAGE_DETAILS.merge({color:Frame.getIn(["clipDetails",clipId,"imgDetails","color"])});Frame=Frame.setIn(["clipDetails",clipId,"imgDetails"],imgDetails);var _calculateAspectRatio2=calculateAspectRatio(Frame,DEFAULT_IMAGE_DETAILS,clipId),width=_calculateAspectRatio2.width,height=_calculateAspectRatio2.height,x=_calculateAspectRatio2.X,y=_calculateAspectRatio2.Y;Frame=Frame.setIn(["clipDetails",clipId,"imgDetails","original"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({width:width,height:height,x:x,y:y}));return Frame.getIn(["clipDetails",clipId,"imgDetails"]);};var prepareClipFromWorkspace=function prepareClipFromWorkspace(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},Item=_ref.Item,ItemId=_ref.ItemId,Frame=_ref.Frame,clipId=_ref.clipId;var type=Item.get("type");var subType=Item.get("subType");var ClipData=Frame.getIn(["clipDetails",clipId]);var isVideoObject=isVideo(type,subType);var imgDetails=ClipData.getIn(["imgDetails"]);var imageData=imgDetails.set("subType",subType).set("type",type==="UPVIDEO"?"UPLOADS":type).set("width",Item.get("width")).set("height",Item.get("height")).set("assetId",Item.get("assetId")).set("stockId",Item.get("stockId")).set("src",Item.get("src")).set("thumb",Item.get("thumb")||Item.get("thumbnail")).set("stickerify",Item.get("stickerify")).set("strokeOptions",Item.get("strokeOptions")).set("firstEdit",Item.get("firstEdit")).set("isTransparent",Item.get("isTransparent")).set("stickerifyPath",Item.get("stickerifyPath")).set("originalPath",Item.get("originalPath")).set("recentEdit",Item.get("recentEdit")).set("bgremoval",Item.get("bgremoval")).set("bgremovalPath",Item.get("bgremovalPath")).set("id",ItemId).set("colors",Item.get("colors")).set("flipPosition",0).set("filter",Item.get("filter")||__WEBPACK_IMPORTED_MODULE_2__config_itemConfig_json___default.a["IMAGE"]["DEFAULT_FILTER"]).set("defaultColor",Item.get("defaultColor")).set("sourceType",Item.get("sourceType")).set("pwidth",Item.get("pwidth")).set("pheight",Item.get("pheight"));if(Item.get("isBlob")&&Item.get("src")&&Item.get("src").startsWith("blob:")){imageData=imageData.remove("thumb");imageData=imageData.set("isBlob",Item.get("isBlob"));}if(isVideoObject){imageData=imageData.set("videoStart",Item.get("videoStart")).set("videoEnd",Item.get("videoEnd")).set("videoDuration",Item.get("videoDuration")).set("volume",Item.get("volume")).set("duration",Item.get("duration"));}var imagePlotRatio=calculateAspectRatio(Frame,imageData,clipId);imageData=imageData.set("original",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({x:imagePlotRatio.X,y:imagePlotRatio.Y,width:imagePlotRatio.width,height:imagePlotRatio.height}));return imageData;};var getImageSource=function getImageSource(item,id){if(item.get("isBlob")&&item.get("src")&&item.get("src").startsWith("blob:")){// blob image
return{src:item.get("src"),thumb:item.get("src")};}var src=Object(__WEBPACK_IMPORTED_MODULE_3__URLHelper__["b" /* getImageURL */])(item,id);var thumbSrc=item.get("thumb")||item.get("thumbnail");var thumb=Object(__WEBPACK_IMPORTED_MODULE_3__URLHelper__["a" /* getImageThumbnailURL */])(item.get("type"),item.get("subType"),thumbSrc);if(item.get('stickerify')||item.get('bgremoval')){src=__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a.UPLOADS[__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a.UPLOADS.workspace_UPIMAGE]+item.get("src");thumb=appUrl+"/images/chr-loading.svg";}return{src:src,thumb:thumb};};var getFrameAssets=function getFrameAssets(_ref2){var frameItem=_ref2.frameItem,_ref2$canInclude=_ref2.canInclude,canInclude=_ref2$canInclude===undefined?undefined:_ref2$canInclude;var assets=[];var ignoreList=[];frameItem.get("clipDetails").forEach(function(clip){var src=undefined;var type=clip.getIn(["imgDetails","type"]);var subType=clip.getIn(["imgDetails","subType"]);if(type==="STOCKVID"||type==="UPLOADS"&&subType==="UPVIDEO"||subType==="VIDEO"||subType==="OBGVID"){return[];}if(clip.getIn(["imgDetails","id"])!==BASE_IMAGE_DETAILS.get("id")){// image is dropped
if(clip.getIn(["imgDetails","type"])!=="STOCKIMG"&&clip.getIn(["imgDetails","subType"])!=="IMAGE"){src=getImageSource(clip.get("imgDetails")).src;}}else{src=""+appUrl+clip.getIn(["imgDetails","defaultImageDetails","src"]);}if(src&&!assets.includes(src)&&!ignoreList.includes(src)){if(typeof canInclude==="function"){if(canInclude(src)){assets.push(src);}else{ignoreList.push(src);}}else{assets.push(src);}}});return assets;};var getFrameDropAreaId=function getFrameDropAreaId(id,clipId){var idPrefix=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"";return idPrefix+id+"_droppable_area_"+clipId;};var getGridDropAreaId=function getGridDropAreaId(id,clipId){var idPrefix=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"";return idPrefix+id+"_droppable_container_"+clipId;};var getFrameSvgId=function getFrameSvgId(id,svgIndex){var idPrefix=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"";return idPrefix+id+"_svg_"+svgIndex;};var getFrameClipFilterSvgId=function getFrameClipFilterSvgId(id,clipId){var idPrefix=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"";return idPrefix+id+"_svgFilter_"+clipId;};var getFrameClipFilterId=function getFrameClipFilterId(id,clipId,filterId){var idPrefix=arguments.length>3&&arguments[3]!==undefined?arguments[3]:"";return idPrefix+id+"_svgFilter_"+clipId+"_"+filterId;};var getFrameClipVignetteId=function getFrameClipVignetteId(id,clipId){var idPrefix=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"";return idPrefix+id+"-vignette-"+clipId;};function getCellStyle(itemWidth,itemHeight,cellId){return{width:itemWidth,height:itemHeight,gridArea:cellId};}

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(70);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(594)
var ieee754 = __webpack_require__(595)
var isArray = __webpack_require__(240)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50).Buffer))

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE__ActionTypes", function() { return ActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(326);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* unused harmony export __spreadArray */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PartitionPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);

/**
 * https://tc39.es/ecma402/#sec-partitionpattern
 * @param pattern
 */
function PartitionPattern(pattern) {
    var result = [];
    var beginIndex = pattern.indexOf('{');
    var endIndex = 0;
    var nextIndex = 0;
    var length = pattern.length;
    while (beginIndex < pattern.length && beginIndex > -1) {
        endIndex = pattern.indexOf('}', beginIndex);
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* invariant */])(endIndex > beginIndex, "Invalid pattern " + pattern);
        if (beginIndex > nextIndex) {
            result.push({
                type: 'literal',
                value: pattern.substring(nextIndex, beginIndex),
            });
        }
        result.push({
            type: pattern.substring(beginIndex + 1, endIndex),
            value: undefined,
        });
        nextIndex = endIndex + 1;
        beginIndex = pattern.indexOf('{', nextIndex);
    }
    if (nextIndex < length) {
        result.push({
            type: 'literal',
            value: pattern.substring(nextIndex, length),
        });
    }
    return result;
}


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FormatNumericToString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__262__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ToRawPrecision__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ToRawFixed__ = __webpack_require__(96);




/**
 * https://tc39.es/ecma402/#sec-formatnumberstring
 */
function FormatNumericToString(intlObject, x) {
    var isNegative = x < 0 || Object(__WEBPACK_IMPORTED_MODULE_0__262__["g" /* SameValue */])(x, -0);
    if (isNegative) {
        x = -x;
    }
    var result;
    var rourndingType = intlObject.roundingType;
    switch (rourndingType) {
        case 'significantDigits':
            result = Object(__WEBPACK_IMPORTED_MODULE_1__ToRawPrecision__["a" /* ToRawPrecision */])(x, intlObject.minimumSignificantDigits, intlObject.maximumSignificantDigits);
            break;
        case 'fractionDigits':
            result = Object(__WEBPACK_IMPORTED_MODULE_3__ToRawFixed__["a" /* ToRawFixed */])(x, intlObject.minimumFractionDigits, intlObject.maximumFractionDigits);
            break;
        default:
            result = Object(__WEBPACK_IMPORTED_MODULE_1__ToRawPrecision__["a" /* ToRawPrecision */])(x, 1, 2);
            if (result.integerDigitsCount > 1) {
                result = Object(__WEBPACK_IMPORTED_MODULE_3__ToRawFixed__["a" /* ToRawFixed */])(x, 0, 0);
            }
            break;
    }
    x = result.roundedNumber;
    var string = result.formattedString;
    var int = result.integerDigitsCount;
    var minInteger = intlObject.minimumIntegerDigits;
    if (int < minInteger) {
        var forwardZeros = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* repeat */])('0', minInteger - int);
        string = forwardZeros + string;
    }
    if (isNegative) {
        x = -x;
    }
    return { roundedNumber: x, formattedString: string };
}


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* harmony export (immutable) */ __webpack_exports__["c"] = __spreadArrays;
/* unused harmony export __spreadArray */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ErrorHandler=function(_Component){_inherits(ErrorHandler,_Component);function ErrorHandler(props){_classCallCheck(this,ErrorHandler);var _this=_possibleConstructorReturn(this,(ErrorHandler.__proto__||Object.getPrototypeOf(ErrorHandler)).call(this,props));_this.state={error:null,errorInfo:null};return _this;}_createClass(ErrorHandler,[{key:"componentDidCatch",value:function componentDidCatch(error,errorInfo){var _this2=this;this.setState({error:error,errorInfo:errorInfo},function(){if(!ErrorHandler.errorId){ErrorHandler.errorId=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(_this2.state.error,_this2.state.errorInfo,_this2.props.component,true);}_this2.setState({errorId:ErrorHandler.errorId});});}},{key:"render",value:function render(){if(!this.state.error)return this.props.children;// else if(this.state.errorId)
//   this.props.fireAppCrash(this.state.errorId, this.state.error);
return null;}}]);return ErrorHandler;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null,function(dispatch){return{fireAppCrash:function fireAppCrash(errorId,error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_1" /* fireAppCrash */])(errorId,error));}};})(ErrorHandler));

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetConsumer */
/* unused harmony export StyleSheetContext */
/* unused harmony export StyleSheetManager */
/* unused harmony export ThemeConsumer */
/* unused harmony export ThemeContext */
/* unused harmony export ThemeProvider */
/* unused harmony export __PRIVATE__ */
/* unused harmony export createGlobalStyle */
/* unused harmony export css */
/* unused harmony export isStyledComponent */
/* unused harmony export keyframes */
/* unused harmony export useTheme */
/* unused harmony export version */
/* unused harmony export withTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_is__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shallowequal__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emotion_unitless__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emotion_is_prop_valid__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__);
function y(){return(y=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var v=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},g=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!Object(__WEBPACK_IMPORTED_MODULE_0_react_is__["typeOf"])(t)},S=Object.freeze([]),w=Object.freeze({});function E(e){return"function"==typeof e}function b(e){return"production"!=="production"&&"string"==typeof e&&e||e.displayName||e.name||"Component"}function _(e){return e&&"string"==typeof e.styledComponentId}var N="undefined"!=typeof process&&void 0!==Object({"NODE_ENV":"production","PUBLIC_URL":""})&&(Object({"NODE_ENV":"production","PUBLIC_URL":""}).REACT_APP_SC_ATTR||Object({"NODE_ENV":"production","PUBLIC_URL":""}).SC_ATTR)||"data-styled",A="5.3.11",C="undefined"!=typeof window&&"HTMLElement"in window,I=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==Object({"NODE_ENV":"production","PUBLIC_URL":""})&&(void 0!==Object({"NODE_ENV":"production","PUBLIC_URL":""}).REACT_APP_SC_DISABLE_SPEEDY&&""!==Object({"NODE_ENV":"production","PUBLIC_URL":""}).REACT_APP_SC_DISABLE_SPEEDY?"false"!==Object({"NODE_ENV":"production","PUBLIC_URL":""}).REACT_APP_SC_DISABLE_SPEEDY&&Object({"NODE_ENV":"production","PUBLIC_URL":""}).REACT_APP_SC_DISABLE_SPEEDY:void 0!==Object({"NODE_ENV":"production","PUBLIC_URL":""}).SC_DISABLE_SPEEDY&&""!==Object({"NODE_ENV":"production","PUBLIC_URL":""}).SC_DISABLE_SPEEDY?"false"!==Object({"NODE_ENV":"production","PUBLIC_URL":""}).SC_DISABLE_SPEEDY&&Object({"NODE_ENV":"production","PUBLIC_URL":""}).SC_DISABLE_SPEEDY:"production"!=="production")),P={},O= false?{1:"Cannot create styled-component for component: %s.\n\n",2:"Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",3:"Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",4:"The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",5:"The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",6:"Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",7:'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',8:'ThemeProvider: Please make your "theme" prop an object.\n\n',9:"Missing document `<head>`\n\n",10:"Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",11:"_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",12:"It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",13:"%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",14:'ThemeProvider: "theme" prop is required.\n\n',15:"A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",16:"Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",17:"CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"}:{};function R(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function D(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):new Error(R.apply(void 0,[O[e]].concat(n)).trim())}var j=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&D(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),T=new Map,x=new Map,k=1,V=function(e){if(T.has(e))return T.get(e);for(;x.has(k);)k++;var t=k++;return"production"!=="production"&&((0|t)<0||t>1<<30)&&D(16,""+t),T.set(e,t),x.set(t,e),t},B=function(e){return x.get(e)},z=function(e,t){t>=k&&(k=t+1),T.set(e,t),x.set(t,e)},M="style["+N+'][data-styled-version="5.3.11"]',G=new RegExp("^"+N+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),L=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},F=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(G);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(z(u,c),L(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},Y=function(){return true?__webpack_require__.nc:null},q=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(N))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(N,"active"),r.setAttribute("data-styled-version","5.3.11");var i=Y();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},H=function(){function e(e){var t=this.element=q(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}D(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),$=function(){function e(e){var t=this.element=q(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),W=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),U=C,J={isServer:!C,useCSSOMInjection:!I},X=function(){function e(e,t,n){void 0===e&&(e=w),void 0===t&&(t={}),this.options=y({},J,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&C&&U&&(U=!1,function(e){for(var t=document.querySelectorAll(M),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(N)&&(F(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return V(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(y({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new W(o):r?new H(o):new $(o),new j(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(V(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(V(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(V(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=B(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=N+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),Z=/(a)(d)/gi,K=function(e){return String.fromCharCode(e+(e>25?39:97))};function Q(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=K(t%52)+n;return(K(t%52)+n).replace(Z,"$1-$2")}var ee=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},te=function(e){return ee(5381,e)};function ne(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(E(n)&&!_(n))return!1}return!0}var re=te("5.3.11"),oe=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic="production"==="production"&&(void 0===n||n.isStatic)&&ne(e),this.componentId=t,this.baseHash=ee(re,t),this.baseStyle=n,X.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=_e(this.rules,e,t,n).join(""),i=Q(ee(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=ee(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h,"production"!=="production"&&(u=ee(u,h+d));else if(h){var p=_e(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=ee(u,f+d),l+=f}}if(l){var m=Q(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),se=/^\s*\/\/.*$/gm,ie=[":","[",".","#"];function ae(e){var t,n,r,o,s=void 0===e?w:e,i=s.options,a=void 0===i?w:i,c=s.plugins,u=void 0===c?S:c,l=new __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__["a" /* default */](a),d=[],p=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ie.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(se,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},p,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||D(15),ee(e,t.name)}),5381).toString():"",m}var ce=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext(),ue=ce.Consumer,le=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext(),de=(le.Consumer,new X),he=ae();function pe(){return Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(ce)||de}function fe(){return Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(le)||he}function me(e){var t=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(e.stylisPlugins),n=t[0],s=t[1],c=pe(),u=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])((function(){return ae({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])((function(){__WEBPACK_IMPORTED_MODULE_2_shallowequal___default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ce.Provider,{value:u},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(le.Provider,{value:l}, false?r.Children.only(e.children):e.children))}var ye=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=he);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return D(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=he),this.name+e.hash},e}(),ve=/([A-Z])/,ge=/([A-Z])/g,Se=/^ms-/,we=function(e){return"-"+e.toLowerCase()};function Ee(e){return ve.test(e)?e.replace(ge,we).replace(Se,"-ms-"):e}var be=function(e){return null==e||!1===e||""===e};function _e(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=_e(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(be(e))return"";if(_(e))return"."+e.styledComponentId;if(E(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return"production"!=="production"&&Object(__WEBPACK_IMPORTED_MODULE_0_react_is__["isElement"])(u)&&console.warn(b(e)+" is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."),_e(u,n,r,o)}var l;return e instanceof ye?r?(e.inject(r,o),e.getName(o)):e:g(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!be(t[i])&&(Array.isArray(t[i])&&t[i].isCss||E(t[i])?s.push(Ee(i)+":",t[i],";"):g(t[i])?s.push.apply(s,e(t[i],i)):s.push(Ee(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in __WEBPACK_IMPORTED_MODULE_4__emotion_unitless__["a" /* default */]||r.startsWith("--")?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ne=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ae(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return E(e)||g(e)?Ne(_e(v(S,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ne(_e(v(e,n)))}var Ce=/invalid hook call/i,Ie=new Set,Pe=function(e,t){if(false){var n="The component "+e+(t?' with the id of "'+t+'"':"")+" has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.",r=console.error;try{var o=!0;console.error=function(e){if(Ce.test(e))o=!1,Ie.delete(n);else{for(var t=arguments.length,s=new Array(t>1?t-1:0),i=1;i<t;i++)s[i-1]=arguments[i];r.apply(void 0,[e].concat(s))}},c(),o&&!Ie.has(n)&&(console.warn(n),Ie.add(n))}catch(e){Ce.test(e.message)&&Ie.delete(n)}finally{console.error=r}}},Oe=function(e,t,n){return void 0===n&&(n=w),e.theme!==n.theme&&e.theme||t||n.theme},Re=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,De=/(^-|-$)/g;function je(e){return e.replace(Re,"-").replace(De,"")}var Te=function(e){return Q(te(e)>>>0)};function xe(e){return"string"==typeof e&&("production"==="production"||e.charAt(0)===e.charAt(0).toLowerCase())}var ke=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Ve=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function Be(e,t,n){var r=e[n];ke(t)&&ke(r)?ze(r,t):e[n]=t}function ze(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(ke(i))for(var a in i)Ve(a)&&Be(e,i[a],a)}return e}var Me=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext(),Ge=Me.Consumer;function Le(e){var t=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(Me),n=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])((function(){return function(e,t){if(!e)return D(14);if(E(e)){var n=e(t);return true?n:D(7)}return Array.isArray(e)||"object"!=typeof e?D(8):t?y({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Me.Provider,{value:n},e.children):null}var Fe={};function Ye(e,t,n){var o=_(e),i=!xe(e),a=t.attrs,c=void 0===a?S:a,l=t.componentId,d=void 0===l?function(e,t){var n="string"!=typeof e?"sc":je(e);Fe[n]=(Fe[n]||0)+1;var r=n+"-"+Te("5.3.11"+n+Fe[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):l,h=t.displayName,p=void 0===h?function(e){return xe(e)?"styled."+e:"Styled("+b(e)+")"}(e):h,v=t.displayName&&t.componentId?je(t.displayName)+"-"+t.componentId:t.componentId||d,g=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,N=t.shouldForwardProp;o&&e.shouldForwardProp&&(N=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var A,C=new oe(n,v,o?e.componentStyle:void 0),I=C.isStatic&&0===c.length,P=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,l=e.shouldForwardProp,d=e.styledComponentId,h=e.target,p=function(e,t,n){void 0===e&&(e=w);var r=y({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in E(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Oe(t,Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(Me),a)||w,t,o),m=p[0],v=p[1],g=function(e,t,n,r){var o=pe(),s=fe(),i=t?e.generateAndInjectStyles(w,o,s):e.generateAndInjectStyles(n,o,s);return"production"!=="production"&&!t&&r&&r(i),i}(i,r,m, false?e.warnTooManyClasses:void 0),S=n,b=v.$as||t.$as||v.as||t.as||h,_=xe(b),N=v!==t?y({},t,{},v):t,A={};for(var C in N)"$"!==C[0]&&"as"!==C&&("forwardedAs"===C?A.as=N[C]:(l?l(C,__WEBPACK_IMPORTED_MODULE_5__emotion_is_prop_valid__["a" /* default */],b):!_||Object(__WEBPACK_IMPORTED_MODULE_5__emotion_is_prop_valid__["a" /* default */])(C))&&(A[C]=N[C]));return t.style&&v.style!==t.style&&(A.style=y({},t.style,{},v.style)),A.className=Array.prototype.concat(c,d,g!==d?g:null,t.className,v.className).filter(Boolean).join(" "),A.ref=S,Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(b,A)}(A,e,t,I)};return P.displayName=p,(A=__WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef(P)).attrs=g,A.componentStyle=C,A.displayName=p,A.shouldForwardProp=N,A.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):S,A.styledComponentId=v,A.target=o?e.target:e,A.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(xe(e)?e:je(b(e)));return Ye(e,y({},o,{attrs:g,componentId:s}),n)},Object.defineProperty(A,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?ze({},e.defaultProps,t):t}}),"production"!=="production"&&(Pe(p,v),A.warnTooManyClasses=function(e,t){var n={},r=!1;return function(o){if(!r&&(n[o]=!0,Object.keys(n).length>=200)){var s=t?' with the id of "'+t+'"':"";console.warn("Over 200 classes were generated for component "+e+s+".\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"),r=!0,n={}}}}(p,v)),Object.defineProperty(A,"toString",{value:function(){return"."+A.styledComponentId}}),i&&__WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default()(A,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),A}var qe=function(e){return function e(t,r,o){if(void 0===o&&(o=w),!Object(__WEBPACK_IMPORTED_MODULE_0_react_is__["isValidElementType"])(r))return D(1,String(r));var s=function(){return t(r,o,Ae.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,y({},o,{},n))},s.attrs=function(n){return e(t,r,y({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(Ye,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){qe[e]=qe(e)}));var He=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=ne(e),X.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(_e(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&X.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function $e(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ae.apply(void 0,[e].concat(n)),a="sc-global-"+Te(JSON.stringify(i)),u=new He(i,a);function d(e){var t=pe(),n=fe(),o=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(Me),d=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(t.allocateGSInstance(a)).current;return"production"!=="production"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.count(e.children)&&console.warn("The global style component "+a+" was given child JSX. createGlobalStyle does not render children."),"production"!=="production"&&i.some((function(e){return"string"==typeof e&&-1!==e.indexOf("@import")}))&&console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."),t.server&&h(d,e,t,o,n),Object(__WEBPACK_IMPORTED_MODULE_1_react__["useLayoutEffect"])((function(){if(!t.server)return h(d,e,t,o,n),function(){return u.removeStyles(d,t)}}),[d,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,P,n,o);else{var s=y({},t,{theme:Oe(t,r,d.defaultProps)});u.renderStyles(e,s,n,o)}}return"production"!=="production"&&Pe(a),__WEBPACK_IMPORTED_MODULE_1_react___default.a.memo(d)}function We(e){"production"!=="production"&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ae.apply(void 0,[e].concat(n)).join(""),s=Te(o);return new ye(s,o)}var Ue=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=Y();return"<style "+[n&&'nonce="'+n+'"',N+'="true"','data-styled-version="5.3.11"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?D(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return D(2);var n=((t={})[N]="",t["data-styled-version"]="5.3.11",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=Y();return o&&(n.nonce=o),[__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("style",y({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new X({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?D(2):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(me,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return D(3)},e}(),Je=function(e){var t=__WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef((function(t,n){var o=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(Me),i=e.defaultProps,a=Oe(t,o,i);return"production"!=="production"&&void 0===a&&console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "'+b(e)+'"'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(e,y({},t,{theme:a,ref:n}))}));return __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default()(t,e),t.displayName="WithTheme("+b(e)+")",t},Xe=function(){return Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(Me)},Ze={StyleSheet:X,masterSheet:de};"production"!=="production"&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native"),"production"!=="production"&&"test"!=="production"&&"undefined"!=typeof window&&(window["__styled-components-init__"]=window["__styled-components-init__"]||0,1===window["__styled-components-init__"]&&console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."),window["__styled-components-init__"]+=1);/* harmony default export */ __webpack_exports__["a"] = (qe);
//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(15)))

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(444);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (window.console && (console.firebug || (console.exception && console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs() {
  var args = arguments;
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return args;

  var c = 'color: ' + this.color;
  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
  return args;
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    return exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (typeof process !== 'undefined' && 'env' in process) {
    return Object({"NODE_ENV":"production","PUBLIC_URL":""}).DEBUG;
  }
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage(){
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 61 */
/***/ (function(module, exports) {


module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(467);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (window.console && (console.firebug || (console.exception && console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs() {
  var args = arguments;
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return args;

  var c = 'color: ' + this.color;
  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
  return args;
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    return exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (typeof process !== 'undefined' && 'env' in process) {
    return Object({"NODE_ENV":"production","PUBLIC_URL":""}).DEBUG;
  }
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage(){
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUFFER_OVERFLOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(14);


var BUFFER_OVERFLOW = "Channel's Buffer overflow!";

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */], put: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */], take: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */] };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take,
    flush: flush
  };
}

var buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(493),
    listCacheDelete = __webpack_require__(494),
    listCacheGet = __webpack_require__(495),
    listCacheHas = __webpack_require__(496),
    listCacheSet = __webpack_require__(497);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(114);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(19);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(30);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(517);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(20),
    isKey = __webpack_require__(122),
    stringToPath = __webpack_require__(549),
    toString = __webpack_require__(552);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    isObjectLike = __webpack_require__(38);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(50)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(260);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SentryError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfill__ = __webpack_require__(271);


/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        Object(__WEBPACK_IMPORTED_MODULE_1__polyfill__["a" /* setPrototypeOf */])(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error));

//# sourceMappingURL=error.js.map

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return logger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__misc__ = __webpack_require__(40);
/* eslint-disable @typescript-eslint/no-explicit-any */

// TODO: Implement different loggers for different environments
var global = Object(__WEBPACK_IMPORTED_MODULE_0__misc__["e" /* getGlobalObject */])();
/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
/** JSDoc */
var Logger = /** @class */ (function () {
    /** JSDoc */
    function Logger() {
        this._enabled = false;
    }
    /** JSDoc */
    Logger.prototype.disable = function () {
        this._enabled = false;
    };
    /** JSDoc */
    Logger.prototype.enable = function () {
        this._enabled = true;
    };
    /** JSDoc */
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["c" /* consoleSandbox */])(function () {
            global.console.log(PREFIX + "[Log]: " + args.join(' '));
        });
    };
    /** JSDoc */
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["c" /* consoleSandbox */])(function () {
            global.console.warn(PREFIX + "[Warn]: " + args.join(' '));
        });
    };
    /** JSDoc */
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["c" /* consoleSandbox */])(function () {
            global.console.error(PREFIX + "[Error]: " + args.join(' '));
        });
    };
    return Logger;
}());
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
global.__SENTRY__ = global.__SENTRY__ || {};
var logger = global.__SENTRY__.logger || (global.__SENTRY__.logger = new Logger());

//# sourceMappingURL=logger.js.map

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module) {/* harmony export (immutable) */ __webpack_exports__["b"] = isNodeEnv;
/* harmony export (immutable) */ __webpack_exports__["a"] = dynamicRequire;
/* unused harmony export extractNodeRequestData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__object__ = __webpack_require__(78);


/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/** Default request keys that'll be used to extract data from the request */
var DEFAULT_REQUEST_KEYS = ['cookies', 'data', 'headers', 'method', 'query_string', 'url'];
/**
 * Normalizes data from the request object, accounting for framework differences.
 *
 * @param req The request object from which to extract data
 * @param keys An optional array of keys to include in the normalized data. Defaults to DEFAULT_REQUEST_KEYS if not
 * provided.
 * @returns An object containing normalized request data
 */
function extractNodeRequestData(req, keys) {
    if (keys === void 0) { keys = DEFAULT_REQUEST_KEYS; }
    // make sure we can safely use dynamicRequire below
    if (!isNodeEnv()) {
        throw new Error("Can't get node request data outside of a node environment");
    }
    var requestData = {};
    // headers:
    //   node, express: req.headers
    //   koa: req.header
    var headers = (req.headers || req.header || {});
    // method:
    //   node, express, koa: req.method
    var method = req.method;
    // host:
    //   express: req.hostname in > 4 and req.host in < 4
    //   koa: req.host
    //   node: req.headers.host
    var host = req.hostname || req.host || headers.host || '<no host>';
    // protocol:
    //   node: <n/a>
    //   express, koa: req.protocol
    var protocol = req.protocol === 'https' || req.secure || (req.socket || {}).encrypted
        ? 'https'
        : 'http';
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa: req.url
    var originalUrl = (req.originalUrl || req.url || '');
    // absolute url
    var absoluteUrl = protocol + "://" + host + originalUrl;
    keys.forEach(function (key) {
        switch (key) {
            case 'headers':
                requestData.headers = headers;
                break;
            case 'method':
                requestData.method = method;
                break;
            case 'url':
                requestData.url = absoluteUrl;
                break;
            case 'cookies':
                // cookies:
                //   node, express, koa: req.headers.cookie
                //   vercel, sails.js, express (w/ cookie middleware): req.cookies
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.cookies = req.cookies || dynamicRequire(module, 'cookie').parse(headers.cookie || '');
                break;
            case 'query_string':
                // query string:
                //   node: req.url (raw)
                //   express, koa: req.query
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.query_string = dynamicRequire(module, 'url').parse(originalUrl || '', false).query;
                break;
            case 'data':
                if (method === 'GET' || method === 'HEAD') {
                    break;
                }
                // body data:
                //   node, express, koa: req.body
                if (req.body !== undefined) {
                    requestData.data = Object(__WEBPACK_IMPORTED_MODULE_0__is__["k" /* isString */])(req.body) ? req.body : JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_1__object__["d" /* normalize */])(req.body));
                }
                break;
            default:
                if ({}.hasOwnProperty.call(req, key)) {
                    requestData[key] = req[key];
                }
        }
    });
    return requestData;
}
//# sourceMappingURL=node.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(15), __webpack_require__(52)(module)))

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["c"] = fill;
/* harmony export (immutable) */ __webpack_exports__["f"] = urlEncode;
/* harmony export (immutable) */ __webpack_exports__["e"] = normalizeToSize;
/* unused harmony export walk */
/* harmony export (immutable) */ __webpack_exports__["d"] = normalize;
/* harmony export (immutable) */ __webpack_exports__["b"] = extractExceptionKeysForMessage;
/* harmony export (immutable) */ __webpack_exports__["a"] = dropUndefinedKeys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__is__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__memo__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stacktrace__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__string__ = __webpack_require__(80);






/**
 * Wrap a given object method with a higher-order function
 *
 * @param source An object that contains a method to be wrapped.
 * @param name A name of method to be wrapped.
 * @param replacement A function that should be used to wrap a given method.
 * @returns void
 */
function fill(source, name, replacement) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacement(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') {
        try {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __sentry_original__: {
                    enumerable: false,
                    value: original,
                },
            });
        }
        catch (_Oo) {
            // This can throw if multiple fill happens on a global object like XMLHttpRequest
            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
        }
    }
    source[name] = wrapped;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
    return Object.keys(object)
        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join('&');
}
/**
 * Transforms any object into an object literal with all it's attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order to be usable by the serializer
 */
function getWalkSource(value) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__is__["d" /* isError */])(value)) {
        var error = value;
        var err = {
            message: error.message,
            name: error.name,
            stack: error.stack,
        };
        for (var i in error) {
            if (Object.prototype.hasOwnProperty.call(error, i)) {
                err[i] = error[i];
            }
        }
        return err;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_2__is__["f" /* isEvent */])(value)) {
        var event_1 = value;
        var source = {};
        source.type = event_1.type;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            source.target = Object(__WEBPACK_IMPORTED_MODULE_2__is__["c" /* isElement */])(event_1.target)
                ? Object(__WEBPACK_IMPORTED_MODULE_1__browser__["a" /* htmlTreeAsString */])(event_1.target)
                : Object.prototype.toString.call(event_1.target);
        }
        catch (_oO) {
            source.target = '<unknown>';
        }
        try {
            source.currentTarget = Object(__WEBPACK_IMPORTED_MODULE_2__is__["c" /* isElement */])(event_1.currentTarget)
                ? Object(__WEBPACK_IMPORTED_MODULE_1__browser__["a" /* htmlTreeAsString */])(event_1.currentTarget)
                : Object.prototype.toString.call(event_1.currentTarget);
        }
        catch (_oO) {
            source.currentTarget = '<unknown>';
        }
        if (typeof CustomEvent !== 'undefined' && Object(__WEBPACK_IMPORTED_MODULE_2__is__["g" /* isInstanceOf */])(value, CustomEvent)) {
            source.detail = event_1.detail;
        }
        for (var i in event_1) {
            if (Object.prototype.hasOwnProperty.call(event_1, i)) {
                source[i] = event_1;
            }
        }
        return source;
    }
    return value;
}
/** Calculates bytes size of input string */
function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/** JSDoc */
function normalizeToSize(object, 
// Default Node.js REPL depth
depth, 
// 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) { depth = 3; }
    if (maxSize === void 0) { maxSize = 100 * 1024; }
    var serialized = normalize(object, depth);
    if (jsonSize(serialized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return serialized;
}
/** Transforms any input value into a string form, either primitive value or a type of the input */
function serializeValue(value) {
    var type = Object.prototype.toString.call(value);
    // Node.js REPL notation
    if (typeof value === 'string') {
        return value;
    }
    if (type === '[object Object]') {
        return '[Object]';
    }
    if (type === '[object Array]') {
        return '[Array]';
    }
    var normalized = normalizeValue(value);
    return Object(__WEBPACK_IMPORTED_MODULE_2__is__["i" /* isPrimitive */])(normalized) ? normalized : type;
}
/**
 * normalizeValue()
 *
 * Takes unserializable input and make it serializable friendly
 *
 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * - serializes Error objects
 * - filter global objects
 */
function normalizeValue(value, key) {
    if (key === 'domain' && value && typeof value === 'object' && value._events) {
        return '[Domain]';
    }
    if (key === 'domainEmitter') {
        return '[DomainEmitter]';
    }
    if (typeof global !== 'undefined' && value === global) {
        return '[Global]';
    }
    if (typeof window !== 'undefined' && value === window) {
        return '[Window]';
    }
    if (typeof document !== 'undefined' && value === document) {
        return '[Document]';
    }
    // React's SyntheticEvent thingy
    if (Object(__WEBPACK_IMPORTED_MODULE_2__is__["l" /* isSyntheticEvent */])(value)) {
        return '[SyntheticEvent]';
    }
    if (typeof value === 'number' && value !== value) {
        return '[NaN]';
    }
    if (value === void 0) {
        return '[undefined]';
    }
    if (typeof value === 'function') {
        return "[Function: " + Object(__WEBPACK_IMPORTED_MODULE_4__stacktrace__["a" /* getFunctionName */])(value) + "]";
    }
    return value;
}
/**
 * Walks an object to perform a normalization on it
 *
 * @param key of object that's walked in current iteration
 * @param value object to be walked
 * @param depth Optional number indicating how deep should walking be performed
 * @param memo Optional Memo class handling decycling
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function walk(key, value, depth, memo) {
    if (depth === void 0) { depth = +Infinity; }
    if (memo === void 0) { memo = new __WEBPACK_IMPORTED_MODULE_3__memo__["a" /* Memo */](); }
    // If we reach the maximum depth, serialize whatever has left
    if (depth === 0) {
        return serializeValue(value);
    }
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // If value implements `toJSON` method, call it and return early
    if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
        return value.toJSON();
    }
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
    var normalized = normalizeValue(value, key);
    if (Object(__WEBPACK_IMPORTED_MODULE_2__is__["i" /* isPrimitive */])(normalized)) {
        return normalized;
    }
    // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
    var source = getWalkSource(value);
    // Create an accumulator that will act as a parent for all future itterations of that branch
    var acc = Array.isArray(value) ? [] : {};
    // If we already walked that branch, bail out, as it's circular reference
    if (memo.memoize(value)) {
        return '[Circular ~]';
    }
    // Walk all keys of the source
    for (var innerKey in source) {
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
            continue;
        }
        // Recursively walk through all the child nodes
        acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
    }
    // Once walked through all the branches, remove the parent from memo storage
    memo.unmemoize(value);
    // Return accumulated values
    return acc;
}
/**
 * normalize()
 *
 * - Creates a copy to prevent original input mutation
 * - Skip non-enumerablers
 * - Calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
 * - Translates known global objects/Classes to a string representations
 * - Takes care of Error objects serialization
 * - Optionally limit depth of final output
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function normalize(input, depth) {
    try {
        return JSON.parse(JSON.stringify(input, function (key, value) { return walk(key, value, depth); }));
    }
    catch (_oO) {
        return '**non-serializable**';
    }
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function extractExceptionKeysForMessage(exception, maxLength) {
    if (maxLength === void 0) { maxLength = 40; }
    var keys = Object.keys(getWalkSource(exception));
    keys.sort();
    if (!keys.length) {
        return '[object has no keys]';
    }
    if (keys[0].length >= maxLength) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__string__["d" /* truncate */])(keys[0], maxLength);
    }
    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_5__string__["d" /* truncate */])(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return the new object with removed keys that value was `undefined`.
 * Works recursively on objects and arrays.
 */
function dropUndefinedKeys(val) {
    var e_1, _a;
    if (Object(__WEBPACK_IMPORTED_MODULE_2__is__["h" /* isPlainObject */])(val)) {
        var obj = val;
        var rv = {};
        try {
            for (var _b = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __values */])(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (typeof obj[key] !== 'undefined') {
                    rv[key] = dropUndefinedKeys(obj[key]);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return rv;
    }
    if (Array.isArray(val)) {
        return val.map(dropUndefinedKeys);
    }
    return val;
}
//# sourceMappingURL=object.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFunctionName;
var defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') {
            return defaultFunctionName;
        }
        return fn.name || defaultFunctionName;
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
//# sourceMappingURL=stacktrace.js.map

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = truncate;
/* harmony export (immutable) */ __webpack_exports__["c"] = snipLine;
/* harmony export (immutable) */ __webpack_exports__["b"] = safeJoin;
/* harmony export (immutable) */ __webpack_exports__["a"] = isMatchingPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(24);

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) { max = 0; }
    if (typeof str !== 'string' || max === 0) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
    var newLine = line;
    var ll = newLine.length;
    if (ll <= 150) {
        return newLine;
    }
    if (colno > ll) {
        // eslint-disable-next-line no-param-reassign
        colno = ll;
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, ll);
    if (end > ll - 5) {
        end = ll;
    }
    if (end === ll) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} " + newLine;
    }
    if (end < ll) {
        newLine += ' {snip}';
    }
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__is__["k" /* isString */])(value)) {
        return false;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["j" /* isRegExp */])(pattern)) {
        return pattern.test(value);
    }
    if (typeof pattern === 'string') {
        return value.indexOf(pattern) !== -1;
    }
    return false;
}
//# sourceMappingURL=string.js.map

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = eventFromException;
/* harmony export (immutable) */ __webpack_exports__["b"] = eventFromMessage;
/* harmony export (immutable) */ __webpack_exports__["c"] = eventFromUnknownInput;
/* unused harmony export eventFromString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parsers__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracekit__ = __webpack_require__(82);




/**
 * Builds and Event from a Exception
 * @hidden
 */
function eventFromException(options, exception, hint) {
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromUnknownInput(exception, syntheticException, {
        attachStacktrace: options.attachStacktrace,
    });
    Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["e" /* addExceptionMechanism */])(event, {
        handled: true,
        type: 'generic',
    });
    event.level = __WEBPACK_IMPORTED_MODULE_0__sentry_types__["b" /* Severity */].Error;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].resolve(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(options, message, level, hint) {
    if (level === void 0) { level = __WEBPACK_IMPORTED_MODULE_0__sentry_types__["b" /* Severity */].Info; }
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromString(message, syntheticException, {
        attachStacktrace: options.attachStacktrace,
    });
    event.level = level;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].resolve(event);
}
/**
 * @hidden
 */
function eventFromUnknownInput(exception, syntheticException, options) {
    if (options === void 0) { options = {}; }
    var event;
    if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["v" /* isErrorEvent */])(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        // eslint-disable-next-line no-param-reassign
        exception = errorEvent.error;
        event = Object(__WEBPACK_IMPORTED_MODULE_2__parsers__["b" /* eventFromStacktrace */])(Object(__WEBPACK_IMPORTED_MODULE_3__tracekit__["a" /* computeStackTrace */])(exception));
        return event;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["s" /* isDOMError */])(exception) || Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["t" /* isDOMException */])(exception)) {
        // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
        // then we just extract the name and message, as they don't provide anything else
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
        var domException = exception;
        var name_1 = domException.name || (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["s" /* isDOMError */])(domException) ? 'DOMError' : 'DOMException');
        var message = domException.message ? name_1 + ": " + domException.message : name_1;
        event = eventFromString(message, syntheticException, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["f" /* addExceptionTypeValue */])(event, message);
        return event;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* isError */])(exception)) {
        // we have a real Error object, do nothing
        event = Object(__WEBPACK_IMPORTED_MODULE_2__parsers__["b" /* eventFromStacktrace */])(Object(__WEBPACK_IMPORTED_MODULE_3__tracekit__["a" /* computeStackTrace */])(exception));
        return event;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["A" /* isPlainObject */])(exception) || Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["w" /* isEvent */])(exception)) {
        // If it is plain Object or Event, serialize it manually and extract options
        // This will allow us to group events based on top-level keys
        // which is much better than creating new group when any key/value change
        var objectException = exception;
        event = Object(__WEBPACK_IMPORTED_MODULE_2__parsers__["a" /* eventFromPlainObject */])(objectException, syntheticException, options.rejection);
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["e" /* addExceptionMechanism */])(event, {
            synthetic: true,
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(exception, syntheticException, options);
    Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["f" /* addExceptionTypeValue */])(event, "" + exception, undefined);
    Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["e" /* addExceptionMechanism */])(event, {
        synthetic: true,
    });
    return event;
}
/**
 * @hidden
 */
function eventFromString(input, syntheticException, options) {
    if (options === void 0) { options = {}; }
    var event = {
        message: input,
    };
    if (options.attachStacktrace && syntheticException) {
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_3__tracekit__["a" /* computeStackTrace */])(syntheticException);
        var frames_1 = Object(__WEBPACK_IMPORTED_MODULE_2__parsers__["d" /* prepareFramesForEvent */])(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1,
        };
    }
    return event;
}
//# sourceMappingURL=eventbuilder.js.map

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeStackTrace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/**
 * This was originally forked from https://github.com/occ/TraceKit, but has since been
 * largely modified and is now maintained as part of Sentry JS SDK.
 */

// global reference to slice
var UNKNOWN_FUNCTION = '?';
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i;
var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function computeStackTrace(ex) {
    var stack = null;
    var popSize = 0;
    if (ex) {
        if (typeof ex.framesToPop === 'number') {
            popSize = ex.framesToPop;
        }
        else if (reactMinifiedRegexp.test(ex.message)) {
            popSize = 1;
        }
    }
    try {
        // This must be tried first because Opera 10 *destroys*
        // its stacktrace property if you try to access the stack
        // property first!!
        stack = computeStackTraceFromStacktraceProp(ex);
        if (stack) {
            return popFrames(stack, popSize);
        }
    }
    catch (e) {
        // no-empty
    }
    try {
        stack = computeStackTraceFromStackProp(ex);
        if (stack) {
            return popFrames(stack, popSize);
        }
    }
    catch (e) {
        // no-empty
    }
    return {
        message: extractMessage(ex),
        name: ex && ex.name,
        stack: [],
        failed: true,
    };
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, complexity
function computeStackTraceFromStackProp(ex) {
    if (!ex || !ex.stack) {
        return null;
    }
    var stack = [];
    var lines = ex.stack.split('\n');
    var isEval;
    var submatch;
    var parts;
    var element;
    for (var i = 0; i < lines.length; ++i) {
        if ((parts = chrome.exec(lines[i]))) {
            var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
            isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
            if (isEval && (submatch = chromeEval.exec(parts[2]))) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = submatch[1]; // url
                parts[3] = submatch[2]; // line
                parts[4] = submatch[3]; // column
            }
            element = {
                // working with the regexp above is super painful. it is quite a hack, but just stripping the `address at `
                // prefix here seems like the quickest solution for now.
                url: parts[2] && parts[2].indexOf('address at ') === 0 ? parts[2].substr('address at '.length) : parts[2],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: isNative ? [parts[2]] : [],
                line: parts[3] ? +parts[3] : null,
                column: parts[4] ? +parts[4] : null,
            };
        }
        else if ((parts = winjs.exec(lines[i]))) {
            element = {
                url: parts[2],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: [],
                line: +parts[3],
                column: parts[4] ? +parts[4] : null,
            };
        }
        else if ((parts = gecko.exec(lines[i]))) {
            isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
            if (isEval && (submatch = geckoEval.exec(parts[3]))) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = submatch[1];
                parts[4] = submatch[2];
                parts[5] = ''; // no column when eval
            }
            else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) {
                // FireFox uses this awesome columnNumber property for its top frame
                // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                // so adding 1
                // NOTE: this hack doesn't work if top-most frame is eval
                stack[0].column = ex.columnNumber + 1;
            }
            element = {
                url: parts[3],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: parts[2] ? parts[2].split(',') : [],
                line: parts[4] ? +parts[4] : null,
                column: parts[5] ? +parts[5] : null,
            };
        }
        else {
            continue;
        }
        if (!element.func && element.line) {
            element.func = UNKNOWN_FUNCTION;
        }
        stack.push(element);
    }
    if (!stack.length) {
        return null;
    }
    return {
        message: extractMessage(ex),
        name: ex.name,
        stack: stack,
    };
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function computeStackTraceFromStacktraceProp(ex) {
    if (!ex || !ex.stacktrace) {
        return null;
    }
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace;
    var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
    var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\((.*)\))? in (.*):\s*$/i;
    var lines = stacktrace.split('\n');
    var stack = [];
    var parts;
    for (var line = 0; line < lines.length; line += 2) {
        var element = null;
        if ((parts = opera10Regex.exec(lines[line]))) {
            element = {
                url: parts[2],
                func: parts[3],
                args: [],
                line: +parts[1],
                column: null,
            };
        }
        else if ((parts = opera11Regex.exec(lines[line]))) {
            element = {
                url: parts[6],
                func: parts[3] || parts[4],
                args: parts[5] ? parts[5].split(',') : [],
                line: +parts[1],
                column: +parts[2],
            };
        }
        if (element) {
            if (!element.func && element.line) {
                element.func = UNKNOWN_FUNCTION;
            }
            stack.push(element);
        }
    }
    if (!stack.length) {
        return null;
    }
    return {
        message: extractMessage(ex),
        name: ex.name,
        stack: stack,
    };
}
/** Remove N number of frames from the stack */
function popFrames(stacktrace, popSize) {
    try {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, stacktrace), { stack: stacktrace.stack.slice(popSize) });
    }
    catch (e) {
        return stacktrace;
    }
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) {
        return 'No error message';
    }
    if (message.error && typeof message.error.message === 'string') {
        return message.error.message;
    }
    return message;
}
//# sourceMappingURL=tracekit.js.map

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(2);




/** Base Transport class implementation */
var BaseTransport = /** @class */ (function () {
    function BaseTransport(options) {
        this.options = options;
        /** A simple buffer holding all requests. */
        this._buffer = new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["b" /* PromiseBuffer */](30);
        /** Locks transport after receiving rate limits in a response */
        this._rateLimits = {};
        this._api = new __WEBPACK_IMPORTED_MODULE_1__sentry_core__["a" /* API */](this.options.dsn);
        // eslint-disable-next-line deprecation/deprecation
        this.url = this._api.getStoreEndpointWithUrlEncodedAuth();
    }
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendEvent = function (_) {
        throw new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SentryError */]('Transport Class has to implement `sendEvent` method');
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.close = function (timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */
    BaseTransport.prototype._handleResponse = function (_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["c" /* Status */].fromHttpCode(response.status);
        /**
         * "The name is case-insensitive."
         * https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
         */
        var limited = this._handleRateLimit(headers);
        if (limited)
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["E" /* logger */].warn("Too many requests, backing off till: " + this._disabledUntil(requestType));
        if (status === __WEBPACK_IMPORTED_MODULE_2__sentry_types__["c" /* Status */].Success) {
            resolve({ status: status });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     */
    BaseTransport.prototype._disabledUntil = function (category) {
        return this._rateLimits[category] || this._rateLimits.all;
    };
    /**
     * Checks if a category is rate limited
     */
    BaseTransport.prototype._isRateLimited = function (category) {
        return this._disabledUntil(category) > new Date(Date.now());
    };
    /**
     * Sets internal _rateLimits from incoming headers. Returns true if headers contains a non-empty rate limiting header.
     */
    BaseTransport.prototype._handleRateLimit = function (headers) {
        var e_1, _a, e_2, _b;
        var now = Date.now();
        var rlHeader = headers['x-sentry-rate-limits'];
        var raHeader = headers['retry-after'];
        if (rlHeader) {
            try {
                for (var _c = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __values */])(rlHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var limit = _d.value;
                    var parameters = limit.split(':', 2);
                    var headerDelay = parseInt(parameters[0], 10);
                    var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
                    try {
                        for (var _e = (e_2 = void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __values */])(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var category = _f.value;
                            this._rateLimits[category || 'all'] = new Date(now + delay);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return true;
        }
        else if (raHeader) {
            this._rateLimits.all = new Date(now + Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["H" /* parseRetryAfterHeader */])(now, raHeader));
            return true;
        }
        return false;
    };
    return BaseTransport;
}());

//# sourceMappingURL=base.js.map

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globalhandlers__ = __webpack_require__(289);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GlobalHandlers", function() { return __WEBPACK_IMPORTED_MODULE_0__globalhandlers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trycatch__ = __webpack_require__(290);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TryCatch", function() { return __WEBPACK_IMPORTED_MODULE_1__trycatch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breadcrumbs__ = __webpack_require__(291);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Breadcrumbs", function() { return __WEBPACK_IMPORTED_MODULE_2__breadcrumbs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__linkederrors__ = __webpack_require__(292);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LinkedErrors", function() { return __WEBPACK_IMPORTED_MODULE_3__linkederrors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useragent__ = __webpack_require__(293);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UserAgent", function() { return __WEBPACK_IMPORTED_MODULE_4__useragent__["a"]; });





//# sourceMappingURL=index.js.map

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TimelineLite */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimelineLite; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__ = __webpack_require__(12);
/*!
 * VERSION: 2.1.3
 * DATE: 2019-05-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */
/* eslint-disable */



__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["_gsScope"]._gsDefine("TimelineLite", ["core.Animation","core.SimpleTimeline","TweenLite"], function() {

		var TimelineLite = function(vars) {
				__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["SimpleTimeline"].call(this, vars);
				var self = this,
					v = self.vars,
					val, p;
				self._labels = {};
				self.autoRemoveChildren = !!v.autoRemoveChildren;
				self.smoothChildTiming = !!v.smoothChildTiming;
				self._sortChildren = true;
				self._onUpdate = v.onUpdate;
				for (p in v) {
					val = v[p];
					if (_isArray(val)) if (val.join("").indexOf("{self}") !== -1) {
						v[p] = self._swapSelfInParams(val);
					}
				}
				if (_isArray(v.tweens)) {
					self.add(v.tweens, 0, v.align, v.stagger);
				}
			},
			_tinyNum = 0.00000001,
			TweenLiteInternals = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"]._internals,
			_internals = TimelineLite._internals = {},
			_isSelector = TweenLiteInternals.isSelector,
			_isArray = TweenLiteInternals.isArray,
			_lazyTweens = TweenLiteInternals.lazyTweens,
			_lazyRender = TweenLiteInternals.lazyRender,
			_globals = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["_gsScope"]._gsDefine.globals,
			_copy = function(vars) {
				var copy = {}, p;
				for (p in vars) {
					copy[p] = vars[p];
				}
				return copy;
			},
			_applyCycle = function(vars, targets, i) {
				var alt = vars.cycle,
					p, val;
				for (p in alt) {
					val = alt[p];
					vars[p] = (typeof(val) === "function") ? val(i, targets[i], targets) : val[i % val.length];
				}
				delete vars.cycle;
			},
			_pauseCallback = _internals.pauseCallback = function() {},
			_slice = function(a) { //don't use [].slice because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
				var b = [],
					l = a.length,
					i;
				for (i = 0; i !== l; b.push(a[i++]));
				return b;
			},
			_defaultImmediateRender = function(tl, toVars, fromVars, defaultFalse) { //default to immediateRender:true unless otherwise set in toVars, fromVars or if defaultFalse is passed in as true
				var ir = "immediateRender";
				if (!(ir in toVars)) {
					toVars[ir] = !((fromVars && fromVars[ir] === false) || defaultFalse);
				}
				return toVars;
			},
			//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
			_distribute = function(v) {
				if (typeof(v) === "function") {
					return v;
				}
				var vars = (typeof(v) === "object") ? v : {each:v}, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
					ease = vars.ease,
					from = vars.from || 0,
					base = vars.base || 0,
					cache = {},
					isFromKeyword = isNaN(from),
					axis = vars.axis,
					ratio = {center:0.5, end:1}[from] || 0;
				return function(i, target, a) {
					var l = (a || vars).length,
						distances = cache[l],
						originX, originY, x, y, d, j, max, min, wrap;
					if (!distances) {
						wrap = (vars.grid === "auto") ? 0 : (vars.grid || [Infinity])[0];
						if (!wrap) {
							max = -Infinity;
							while (max < (max = a[wrap++].getBoundingClientRect().left) && wrap < l) { }
							wrap--;
						}
						distances = cache[l] = [];
						originX = isFromKeyword ? (Math.min(wrap, l) * ratio) - 0.5 : from % wrap;
						originY = isFromKeyword ? l * ratio / wrap - 0.5 : (from / wrap) | 0;
						max = 0;
						min = Infinity;
						for (j = 0; j < l; j++) {
							x = (j % wrap) - originX;
							y = originY - ((j / wrap) | 0);
							distances[j] = d = !axis ? Math.sqrt(x * x + y * y) : Math.abs((axis === "y") ? y : x);
							if (d > max) {
								max = d;
							}
							if (d < min) {
								min = d;
							}
						}
						distances.max = max - min;
						distances.min = min;
						distances.v = l = vars.amount || (vars.each * (wrap > l ? l - 1 : !axis ? Math.max(wrap, l / wrap) : axis === "y" ? l / wrap : wrap)) || 0;
						distances.b = (l < 0) ? base - l : base;
					}
					l = (distances[i] - distances.min) / distances.max;
					return distances.b + (ease ? ease.getRatio(l) : l) * distances.v;
				};
			},
			p = TimelineLite.prototype = new __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["SimpleTimeline"]();

		TimelineLite.version = "2.1.3";
		TimelineLite.distribute = _distribute;
		p.constructor = TimelineLite;
		p.kill()._gc = p._forcingPlayhead = p._hasPause = false;

		/* might use later...
		//translates a local time inside an animation to the corresponding time on the root/global timeline, factoring in all nesting and timeScales.
		function localToGlobal(time, animation) {
			while (animation) {
				time = (time / animation._timeScale) + animation._startTime;
				animation = animation.timeline;
			}
			return time;
		}

		//translates the supplied time on the root/global timeline into the corresponding local time inside a particular animation, factoring in all nesting and timeScales
		function globalToLocal(time, animation) {
			var scale = 1;
			time -= localToGlobal(0, animation);
			while (animation) {
				scale *= animation._timeScale;
				animation = animation.timeline;
			}
			return time * scale;
		}
		*/

		p.to = function(target, duration, vars, position) {
			var Engine = (vars.repeat && _globals.TweenMax) || __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"];
			return duration ? this.add( new Engine(target, duration, vars), position) : this.set(target, vars, position);
		};

		p.from = function(target, duration, vars, position) {
			return this.add( ((vars.repeat && _globals.TweenMax) || __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"]).from(target, duration, _defaultImmediateRender(this, vars)), position);
		};

		p.fromTo = function(target, duration, fromVars, toVars, position) {
			var Engine = (toVars.repeat && _globals.TweenMax) || __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"];
			toVars = _defaultImmediateRender(this, toVars, fromVars);
			return duration ? this.add( Engine.fromTo(target, duration, fromVars, toVars), position) : this.set(target, toVars, position);
		};

		p.staggerTo = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
			var tl = new TimelineLite({onComplete:onCompleteAll, onCompleteParams:onCompleteAllParams, callbackScope:onCompleteAllScope, smoothChildTiming:this.smoothChildTiming}),
				staggerFunc = _distribute(vars.stagger || stagger),
				startAt = vars.startAt,
				cycle = vars.cycle,
				copy, i;
			if (typeof(targets) === "string") {
				targets = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].selector(targets) || targets;
			}
			targets = targets || [];
			if (_isSelector(targets)) { //if the targets object is a selector, translate it into an array.
				targets = _slice(targets);
			}
			for (i = 0; i < targets.length; i++) {
				copy = _copy(vars);
				if (startAt) {
					copy.startAt = _copy(startAt);
					if (startAt.cycle) {
						_applyCycle(copy.startAt, targets, i);
					}
				}
				if (cycle) {
					_applyCycle(copy, targets, i);
					if (copy.duration != null) {
						duration = copy.duration;
						delete copy.duration;
					}
				}
				tl.to(targets[i], duration, copy, staggerFunc(i, targets[i], targets));
			}
			return this.add(tl, position);
		};

		p.staggerFrom = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
			vars.runBackwards = true;
			return this.staggerTo(targets, duration, _defaultImmediateRender(this, vars), stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
		};

		p.staggerFromTo = function(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
			toVars.startAt = fromVars;
			return this.staggerTo(targets, duration, _defaultImmediateRender(this, toVars, fromVars), stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
		};

		p.call = function(callback, params, scope, position) {
			return this.add( __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].delayedCall(0, callback, params, scope), position);
		};

		p.set = function(target, vars, position) {
			return this.add( new __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"](target, 0, _defaultImmediateRender(this, vars, null, true)), position);
		};

		TimelineLite.exportRoot = function(vars, ignoreDelayedCalls) {
			vars = vars || {};
			if (vars.smoothChildTiming == null) {
				vars.smoothChildTiming = true;
			}
			var tl = new TimelineLite(vars),
				root = tl._timeline,
				hasNegativeStart, time,	tween, next;
			if (ignoreDelayedCalls == null) {
				ignoreDelayedCalls = true;
			}
			root._remove(tl, true);
			tl._startTime = 0;
			tl._rawPrevTime = tl._time = tl._totalTime = root._time;
			tween = root._first;
			while (tween) {
				next = tween._next;
				if (!ignoreDelayedCalls || !(tween instanceof __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"] && tween.target === tween.vars.onComplete)) {
					time = tween._startTime - tween._delay;
					if (time < 0) {
						hasNegativeStart = 1;
					}
					tl.add(tween, time);
				}
				tween = next;
			}
			root.add(tl, 0);
			if (hasNegativeStart) { //calling totalDuration() will force the adjustment necessary to shift the children forward so none of them start before zero, and moves the timeline backwards the same amount, so the playhead is still aligned where it should be globally, but the timeline doesn't have illegal children that start before zero.
				tl.totalDuration();
			}
			return tl;
		};

		p.add = function(value, position, align, stagger) {
			var self = this,
				curTime, l, i, child, tl, beforeRawTime;
			if (typeof(position) !== "number") {
				position = self._parseTimeOrLabel(position, 0, true, value);
			}
			if (!(value instanceof __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Animation"])) {
				if ((value instanceof Array) || (value && value.push && _isArray(value))) {
					align = align || "normal";
					stagger = stagger || 0;
					curTime = position;
					l = value.length;
					for (i = 0; i < l; i++) {
						if (_isArray(child = value[i])) {
							child = new TimelineLite({tweens:child});
						}
						self.add(child, curTime);
						if (typeof(child) !== "string" && typeof(child) !== "function") {
							if (align === "sequence") {
								curTime = child._startTime + (child.totalDuration() / child._timeScale);
							} else if (align === "start") {
								child._startTime -= child.delay();
							}
						}
						curTime += stagger;
					}
					return self._uncache(true);
				} else if (typeof(value) === "string") {
					return self.addLabel(value, position);
				} else if (typeof(value) === "function") {
					value = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].delayedCall(0, value);
				} else {
					throw("Cannot add " + value + " into the timeline; it is not a tween, timeline, function, or string.");
				}
			}

			__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["SimpleTimeline"].prototype.add.call(self, value, position);

			if (value._time || (!value._duration && value._initted)) { //in case, for example, the _startTime is moved on a tween that has already rendered. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning.
				curTime = (self.rawTime() - value._startTime) * value._timeScale;
				if (!value._duration || Math.abs(Math.max(0, Math.min(value.totalDuration(), curTime))) - value._totalTime > 0.00001) {
					value.render(curTime, false, false);
				}
			}

			//if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
			if (self._gc || self._time === self._duration) if (!self._paused) if (self._duration < self.duration()) {
				//in case any of the ancestors had completed but should now be enabled...
				tl = self;
				beforeRawTime = (tl.rawTime() > value._startTime); //if the tween is placed on the timeline so that it starts BEFORE the current rawTime, we should align the playhead (move the timeline). This is because sometimes users will create a timeline, let it finish, and much later append a tween and expect it to run instead of jumping to its end state. While technically one could argue that it should jump to its end state, that's not what users intuitively expect.
				while (tl._timeline) {
					if (beforeRawTime && tl._timeline.smoothChildTiming) {
						tl.totalTime(tl._totalTime, true); //moves the timeline (shifts its startTime) if necessary, and also enables it.
					} else if (tl._gc) {
						tl._enabled(true, false);
					}
					tl = tl._timeline;
				}
			}

			return self;
		};

		p.remove = function(value) {
			if (value instanceof __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Animation"]) {
				this._remove(value, false);
				var tl = value._timeline = value.vars.useFrames ? __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Animation"]._rootFramesTimeline : __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Animation"]._rootTimeline; //now that it's removed, default it to the root timeline so that if it gets played again, it doesn't jump back into this timeline.
				value._startTime = (value._paused ? value._pauseTime : tl._time) - ((!value._reversed ? value._totalTime : value.totalDuration() - value._totalTime) / value._timeScale); //ensure that if it gets played again, the timing is correct.
				return this;
			} else if (value instanceof Array || (value && value.push && _isArray(value))) {
				var i = value.length;
				while (--i > -1) {
					this.remove(value[i]);
				}
				return this;
			} else if (typeof(value) === "string") {
				return this.removeLabel(value);
			}
			return this.kill(null, value);
		};

		p._remove = function(tween, skipDisable) {
			__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["SimpleTimeline"].prototype._remove.call(this, tween, skipDisable);
			var last = this._last;
			if (!last) {
				this._time = this._totalTime = this._duration = this._totalDuration = 0;
			} else if (this._time > this.duration()) {
				this._time = this._duration;
				this._totalTime = this._totalDuration;
			}
			return this;
		};

		p.append = function(value, offsetOrLabel) {
			return this.add(value, this._parseTimeOrLabel(null, offsetOrLabel, true, value));
		};

		p.insert = p.insertMultiple = function(value, position, align, stagger) {
			return this.add(value, position || 0, align, stagger);
		};

		p.appendMultiple = function(tweens, offsetOrLabel, align, stagger) {
			return this.add(tweens, this._parseTimeOrLabel(null, offsetOrLabel, true, tweens), align, stagger);
		};

		p.addLabel = function(label, position) {
			this._labels[label] = this._parseTimeOrLabel(position);
			return this;
		};

		p.addPause = function(position, callback, params, scope) {
			var t = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].delayedCall(0, _pauseCallback, params, scope || this);
			t.vars.onComplete = t.vars.onReverseComplete = callback;
			t.data = "isPause";
			this._hasPause = true;
			return this.add(t, position);
		};

		p.removeLabel = function(label) {
			delete this._labels[label];
			return this;
		};

		p.getLabelTime = function(label) {
			return (this._labels[label] != null) ? this._labels[label] : -1;
		};

		p._parseTimeOrLabel = function(timeOrLabel, offsetOrLabel, appendIfAbsent, ignore) {
			var clippedDuration, i;
			//if we're about to add a tween/timeline (or an array of them) that's already a child of this timeline, we should remove it first so that it doesn't contaminate the duration().
			if (ignore instanceof __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Animation"] && ignore.timeline === this) {
				this.remove(ignore);
			} else if (ignore && ((ignore instanceof Array) || (ignore.push && _isArray(ignore)))) {
				i = ignore.length;
				while (--i > -1) {
					if (ignore[i] instanceof __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Animation"] && ignore[i].timeline === this) {
						this.remove(ignore[i]);
					}
				}
			}
			clippedDuration = (typeof(timeOrLabel) === "number" && !offsetOrLabel) ? 0 : (this.duration() > 99999999999) ? this.recent().endTime(false) : this._duration; //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
			if (typeof(offsetOrLabel) === "string") {
				return this._parseTimeOrLabel(offsetOrLabel, (appendIfAbsent && typeof(timeOrLabel) === "number" && this._labels[offsetOrLabel] == null) ? timeOrLabel - clippedDuration : 0, appendIfAbsent);
			}
			offsetOrLabel = offsetOrLabel || 0;
			if (typeof(timeOrLabel) === "string" && (isNaN(timeOrLabel) || this._labels[timeOrLabel] != null)) { //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
				i = timeOrLabel.indexOf("=");
				if (i === -1) {
					if (this._labels[timeOrLabel] == null) {
						return appendIfAbsent ? (this._labels[timeOrLabel] = clippedDuration + offsetOrLabel) : offsetOrLabel;
					}
					return this._labels[timeOrLabel] + offsetOrLabel;
				}
				offsetOrLabel = parseInt(timeOrLabel.charAt(i-1) + "1", 10) * Number(timeOrLabel.substr(i+1));
				timeOrLabel = (i > 1) ? this._parseTimeOrLabel(timeOrLabel.substr(0, i-1), 0, appendIfAbsent) : clippedDuration;
			} else if (timeOrLabel == null) {
				timeOrLabel = clippedDuration;
			}
			return Number(timeOrLabel) + offsetOrLabel;
		};

		p.seek = function(position, suppressEvents) {
			return this.totalTime((typeof(position) === "number") ? position : this._parseTimeOrLabel(position), (suppressEvents !== false));
		};

		p.stop = function() {
			return this.paused(true);
		};

		p.gotoAndPlay = function(position, suppressEvents) {
			return this.play(position, suppressEvents);
		};

		p.gotoAndStop = function(position, suppressEvents) {
			return this.pause(position, suppressEvents);
		};

		p.render = function(time, suppressEvents, force) {
			if (this._gc) {
				this._enabled(true, false);
			}
			var self = this,
				prevTime = self._time,
				totalDur = (!self._dirty) ? self._totalDuration : self.totalDuration(),
				prevStart = self._startTime,
				prevTimeScale = self._timeScale,
				prevPaused = self._paused,
				tween, isComplete, next, callback, internalForce, pauseTween, curTime, pauseTime;
			if (prevTime !== self._time) { //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
				time += self._time - prevTime;
			}
			if (self._hasPause && !self._forcingPlayhead && !suppressEvents) {
				if (time > prevTime) {
					tween = self._first;
					while (tween && tween._startTime <= time && !pauseTween) {
						if (!tween._duration) if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && self._rawPrevTime === 0)) {
							pauseTween = tween;
						}
						tween = tween._next;
					}
				} else {
					tween = self._last;
					while (tween && tween._startTime >= time && !pauseTween) {
						if (!tween._duration) if (tween.data === "isPause" && tween._rawPrevTime > 0) {
							pauseTween = tween;
						}
						tween = tween._prev;
					}
				}
				if (pauseTween) {
					self._time = self._totalTime = time = pauseTween._startTime;
					pauseTime = self._startTime + (self._reversed ? self._duration - time : time) / self._timeScale;
				}
			}
			if (time >= totalDur - _tinyNum && time >= 0) { //to work around occasional floating point math artifacts.
				self._totalTime = self._time = totalDur;
				if (!self._reversed) if (!self._hasPausedChild()) {
					isComplete = true;
					callback = "onComplete";
					internalForce = !!self._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					if (self._duration === 0) if ((time <= 0 && time >= -_tinyNum) || self._rawPrevTime < 0 || self._rawPrevTime === _tinyNum) if (self._rawPrevTime !== time && self._first) {
						internalForce = true;
						if (self._rawPrevTime > _tinyNum) {
							callback = "onReverseComplete";
						}
					}
				}
				self._rawPrevTime = (self._duration || !suppressEvents || time || self._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
				time = totalDur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7.

			} else if (time < _tinyNum) { //to work around occasional floating point math artifacts, round super small values to 0.
				self._totalTime = self._time = 0;
				if (time > -_tinyNum) {
					time = 0;
				}
				if (prevTime !== 0 || (self._duration === 0 && self._rawPrevTime !== _tinyNum && (self._rawPrevTime > 0 || (time < 0 && self._rawPrevTime >= 0)))) {
					callback = "onReverseComplete";
					isComplete = self._reversed;
				}
				if (time < 0) {
					self._active = false;
					if (self._timeline.autoRemoveChildren && self._reversed) { //ensures proper GC if a timeline is resumed after it's finished reversing.
						internalForce = isComplete = true;
						callback = "onReverseComplete";
					} else if (self._rawPrevTime >= 0 && self._first) { //when going back beyond the start, force a render so that zero-duration tweens that sit at the very beginning render their start values properly. Otherwise, if the parent timeline's playhead lands exactly at this timeline's startTime, and then moves backwards, the zero-duration tweens at the beginning would still be at their end state.
						internalForce = true;
					}
					self._rawPrevTime = time;
				} else {
					self._rawPrevTime = (self._duration || !suppressEvents || time || self._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					if (time === 0 && isComplete) { //if there's a zero-duration tween at the very beginning of a timeline and the playhead lands EXACTLY at time 0, that tween will correctly render its end values, but we need to keep the timeline alive for one more render so that the beginning values render properly as the parent's playhead keeps moving beyond the begining. Imagine obj.x starts at 0 and then we do tl.set(obj, {x:100}).to(obj, 1, {x:200}) and then later we tl.reverse()...the goal is to have obj.x revert to 0. If the playhead happens to land on exactly 0, without this chunk of code, it'd complete the timeline and remove it from the rendering queue (not good).
						tween = self._first;
						while (tween && tween._startTime === 0) {
							if (!tween._duration) {
								isComplete = false;
							}
							tween = tween._next;
						}
					}
					time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
					if (!self._initted) {
						internalForce = true;
					}
				}

			} else {
				self._totalTime = self._time = self._rawPrevTime = time;
			}
			if ((self._time === prevTime || !self._first) && !force && !internalForce && !pauseTween) {
				return;
			} else if (!self._initted) {
				self._initted = true;
			}

			if (!self._active) if (!self._paused && self._time !== prevTime && time > 0) {
				self._active = true;  //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
			}

			if (prevTime === 0) if (self.vars.onStart) if (self._time !== 0 || !self._duration) if (!suppressEvents) {
				self._callback("onStart");
			}

			curTime = self._time;
			if (curTime >= prevTime) {
				tween = self._first;
				while (tween) {
					next = tween._next; //record it here because the value could change after rendering...
					if (curTime !== self._time || (self._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
						break;
					} else if (tween._active || (tween._startTime <= curTime && !tween._paused && !tween._gc)) {
						if (pauseTween === tween) {
							self.pause();
							self._pauseTime = pauseTime; //so that when we resume(), it's starting from exactly the right spot (the pause() method uses the rawTime for the parent, but that may be a bit too far ahead)
						}
						if (!tween._reversed) {
							tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
						} else {
							tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
						}
					}
					tween = next;
				}
			} else {
				tween = self._last;
				while (tween) {
					next = tween._prev; //record it here because the value could change after rendering...
					if (curTime !== self._time || (self._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
						break;
					} else if (tween._active || (tween._startTime <= prevTime && !tween._paused && !tween._gc)) {
						if (pauseTween === tween) {
							pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
							while (pauseTween && pauseTween.endTime() > self._time) {
								pauseTween.render( (pauseTween._reversed ? pauseTween.totalDuration() - ((time - pauseTween._startTime) * pauseTween._timeScale) : (time - pauseTween._startTime) * pauseTween._timeScale), suppressEvents, force);
								pauseTween = pauseTween._prev;
							}
							pauseTween = null;
							self.pause();
							self._pauseTime = pauseTime; //so that when we resume(), it's starting from exactly the right spot (the pause() method uses the rawTime for the parent, but that may be a bit too far ahead)
						}
						if (!tween._reversed) {
							tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
						} else {
							tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
						}
					}
					tween = next;
				}
			}

			if (self._onUpdate) if (!suppressEvents) {
				if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
					_lazyRender();
				}
				self._callback("onUpdate");
			}

			if (callback) if (!self._gc) if (prevStart === self._startTime || prevTimeScale !== self._timeScale) if (self._time === 0 || totalDur >= self.totalDuration()) { //if one of the tweens that was rendered altered this timeline's startTime (like if an onComplete reversed the timeline), it probably isn't complete. If it is, don't worry, because whatever call altered the startTime would complete if it was necessary at the new time. The only exception is the timeScale property. Also check _gc because there's a chance that kill() could be called in an onUpdate
				if (isComplete) {
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onComplete on a timeline that reports/checks tweened values.
						_lazyRender();
					}
					if (self._timeline.autoRemoveChildren) {
						self._enabled(false, false);
					}
					self._active = false;
				}
				if (!suppressEvents && self.vars[callback]) {
					self._callback(callback);
				}
			}
		};

		p._hasPausedChild = function() {
			var tween = this._first;
			while (tween) {
				if (tween._paused || ((tween instanceof TimelineLite) && tween._hasPausedChild())) {
					return true;
				}
				tween = tween._next;
			}
			return false;
		};

		p.getChildren = function(nested, tweens, timelines, ignoreBeforeTime) {
			ignoreBeforeTime = ignoreBeforeTime || -9999999999;
			var a = [],
				tween = this._first,
				cnt = 0;
			while (tween) {
				if (tween._startTime < ignoreBeforeTime) {
					//do nothing
				} else if (tween instanceof __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"]) {
					if (tweens !== false) {
						a[cnt++] = tween;
					}
				} else {
					if (timelines !== false) {
						a[cnt++] = tween;
					}
					if (nested !== false) {
						a = a.concat(tween.getChildren(true, tweens, timelines));
						cnt = a.length;
					}
				}
				tween = tween._next;
			}
			return a;
		};

		p.getTweensOf = function(target, nested) {
			var disabled = this._gc,
				a = [],
				cnt = 0,
				tweens, i;
			if (disabled) {
				this._enabled(true, true); //getTweensOf() filters out disabled tweens, and we have to mark them as _gc = true when the timeline completes in order to allow clean garbage collection, so temporarily re-enable the timeline here.
			}
			tweens = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].getTweensOf(target);
			i = tweens.length;
			while (--i > -1) {
				if (tweens[i].timeline === this || (nested && this._contains(tweens[i]))) {
					a[cnt++] = tweens[i];
				}
			}
			if (disabled) {
				this._enabled(false, true);
			}
			return a;
		};

		p.recent = function() {
			return this._recent;
		};

		p._contains = function(tween) {
			var tl = tween.timeline;
			while (tl) {
				if (tl === this) {
					return true;
				}
				tl = tl.timeline;
			}
			return false;
		};

		p.shiftChildren = function(amount, adjustLabels, ignoreBeforeTime) {
			ignoreBeforeTime = ignoreBeforeTime || 0;
			var tween = this._first,
				labels = this._labels,
				p;
			while (tween) {
				if (tween._startTime >= ignoreBeforeTime) {
					tween._startTime += amount;
				}
				tween = tween._next;
			}
			if (adjustLabels) {
				for (p in labels) {
					if (labels[p] >= ignoreBeforeTime) {
						labels[p] += amount;
					}
				}
			}
			return this._uncache(true);
		};

		p._kill = function(vars, target) {
			if (!vars && !target) {
				return this._enabled(false, false);
			}
			var tweens = (!target) ? this.getChildren(true, true, false) : this.getTweensOf(target),
				i = tweens.length,
				changed = false;
			while (--i > -1) {
				if (tweens[i]._kill(vars, target)) {
					changed = true;
				}
			}
			return changed;
		};

		p.clear = function(labels) {
			var tweens = this.getChildren(false, true, true),
				i = tweens.length;
			this._time = this._totalTime = 0;
			while (--i > -1) {
				tweens[i]._enabled(false, false);
			}
			if (labels !== false) {
				this._labels = {};
			}
			return this._uncache(true);
		};

		p.invalidate = function() {
			var tween = this._first;
			while (tween) {
				tween.invalidate();
				tween = tween._next;
			}
			return __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Animation"].prototype.invalidate.call(this);;
		};

		p._enabled = function(enabled, ignoreTimeline) {
			if (enabled === this._gc) {
				var tween = this._first;
				while (tween) {
					tween._enabled(enabled, true);
					tween = tween._next;
				}
			}
			return __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["SimpleTimeline"].prototype._enabled.call(this, enabled, ignoreTimeline);
		};

		p.totalTime = function(time, suppressEvents, uncapped) {
			this._forcingPlayhead = true;
			var val = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Animation"].prototype.totalTime.apply(this, arguments);
			this._forcingPlayhead = false;
			return val;
		};

		p.duration = function(value) {
			if (!arguments.length) {
				if (this._dirty) {
					this.totalDuration(); //just triggers recalculation
				}
				return this._duration;
			}
			if (this.duration() !== 0 && value !== 0) {
				this.timeScale(this._duration / value);
			}
			return this;
		};

		p.totalDuration = function(value) {
			if (!arguments.length) {
				if (this._dirty) {
					var max = 0,
						self = this,
						tween = self._last,
						prevStart = 999999999999,
						prev, end;
					while (tween) {
						prev = tween._prev; //record it here in case the tween changes position in the sequence...
						if (tween._dirty) {
							tween.totalDuration(); //could change the tween._startTime, so make sure the tween's cache is clean before analyzing it.
						}
						if (tween._startTime > prevStart && self._sortChildren && !tween._paused && !self._calculatingDuration) { //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
							self._calculatingDuration = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add(), like _parseTimeOrLabel().
							self.add(tween, tween._startTime - tween._delay);
							self._calculatingDuration = 0;
						} else {
							prevStart = tween._startTime;
						}
						if (tween._startTime < 0 && !tween._paused) { //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
							max -= tween._startTime;
							if (self._timeline.smoothChildTiming) {
								self._startTime += tween._startTime / self._timeScale;
								self._time -= tween._startTime;
								self._totalTime -= tween._startTime;
								self._rawPrevTime -= tween._startTime;
							}
							self.shiftChildren(-tween._startTime, false, -9999999999);
							prevStart = 0;
						}
						end = tween._startTime + (tween._totalDuration / tween._timeScale);
						if (end > max) {
							max = end;
						}
						tween = prev;
					}
					self._duration = self._totalDuration = max;
					self._dirty = false;
				}
				return this._totalDuration;
			}
			return (value && this.totalDuration()) ? this.timeScale(this._totalDuration / value) : this;
		};

		p.paused = function(value) {
			if (value === false && this._paused) { //if there's a pause directly at the spot from where we're unpausing, skip it.
				var tween = this._first;
				while (tween) {
					if (tween._startTime === this._time && tween.data === "isPause") {
						tween._rawPrevTime = 0; //remember, _rawPrevTime is how zero-duration tweens/callbacks sense directionality and determine whether or not to fire. If _rawPrevTime is the same as _startTime on the next render, it won't fire.
					}
					tween = tween._next;
				}
			}
			return __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Animation"].prototype.paused.apply(this, arguments);
		};

		p.usesFrames = function() {
			var tl = this._timeline;
			while (tl._timeline) {
				tl = tl._timeline;
			}
			return (tl === __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Animation"]._rootFramesTimeline);
		};

		p.rawTime = function(wrapRepeats) {
			return (wrapRepeats && (this._paused || (this._repeat && this.time() > 0 && this.totalProgress() < 1))) ? this._totalTime % (this._duration + this._repeatDelay) : this._paused ? this._totalTime : (this._timeline.rawTime(wrapRepeats) - this._startTime) * this._timeScale;
		};

		return TimelineLite;

	}, true);

var TimelineLite = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["globals"].TimelineLite;



/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BezierPlugin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BezierPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__ = __webpack_require__(12);
/*!
 * VERSION: 1.3.9
 * DATE: 2019-05-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/
/* eslint-disable */


		var _RAD2DEG = 180 / Math.PI,
			_r1 = [],
			_r2 = [],
			_r3 = [],
			_corProps = {},
			_globals = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["_gsScope"]._gsDefine.globals,
			Segment = function(a, b, c, d) {
				if (c === d) { //if c and d match, the final autoRotate value could lock at -90 degrees, so differentiate them slightly.
					c = d - (d - b) / 1000000;
				}
				if (a === b) { //if a and b match, the starting autoRotate value could lock at -90 degrees, so differentiate them slightly.
					b = a + (c - a) / 1000000;
				}
				this.a = a;
				this.b = b;
				this.c = c;
				this.d = d;
				this.da = d - a;
				this.ca = c - a;
				this.ba = b - a;
			},
			_correlate = ",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",
			cubicToQuadratic = function(a, b, c, d) {
				var q1 = {a:a},
					q2 = {},
					q3 = {},
					q4 = {c:d},
					mab = (a + b) / 2,
					mbc = (b + c) / 2,
					mcd = (c + d) / 2,
					mabc = (mab + mbc) / 2,
					mbcd = (mbc + mcd) / 2,
					m8 = (mbcd - mabc) / 8;
				q1.b = mab + (a - mab) / 4;
				q2.b = mabc + m8;
				q1.c = q2.a = (q1.b + q2.b) / 2;
				q2.c = q3.a = (mabc + mbcd) / 2;
				q3.b = mbcd - m8;
				q4.b = mcd + (d - mcd) / 4;
				q3.c = q4.a = (q3.b + q4.b) / 2;
				return [q1, q2, q3, q4];
			},
			_calculateControlPoints = function(a, curviness, quad, basic, correlate) {
				var l = a.length - 1,
					ii = 0,
					cp1 = a[0].a,
					i, p1, p2, p3, seg, m1, m2, mm, cp2, qb, r1, r2, tl;
				for (i = 0; i < l; i++) {
					seg = a[ii];
					p1 = seg.a;
					p2 = seg.d;
					p3 = a[ii+1].d;

					if (correlate) {
						r1 = _r1[i];
						r2 = _r2[i];
						tl = ((r2 + r1) * curviness * 0.25) / (basic ? 0.5 : _r3[i] || 0.5);
						m1 = p2 - (p2 - p1) * (basic ? curviness * 0.5 : (r1 !== 0 ? tl / r1 : 0));
						m2 = p2 + (p3 - p2) * (basic ? curviness * 0.5 : (r2 !== 0 ? tl / r2 : 0));
						mm = p2 - (m1 + (((m2 - m1) * ((r1 * 3 / (r1 + r2)) + 0.5) / 4) || 0));
					} else {
						m1 = p2 - (p2 - p1) * curviness * 0.5;
						m2 = p2 + (p3 - p2) * curviness * 0.5;
						mm = p2 - (m1 + m2) / 2;
					}
					m1 += mm;
					m2 += mm;

					seg.c = cp2 = m1;
					if (i !== 0) {
						seg.b = cp1;
					} else {
						seg.b = cp1 = seg.a + (seg.c - seg.a) * 0.6; //instead of placing b on a exactly, we move it inline with c so that if the user specifies an ease like Back.easeIn or Elastic.easeIn which goes BEYOND the beginning, it will do so smoothly.
					}

					seg.da = p2 - p1;
					seg.ca = cp2 - p1;
					seg.ba = cp1 - p1;

					if (quad) {
						qb = cubicToQuadratic(p1, cp1, cp2, p2);
						a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
						ii += 4;
					} else {
						ii++;
					}

					cp1 = m2;
				}
				seg = a[ii];
				seg.b = cp1;
				seg.c = cp1 + (seg.d - cp1) * 0.4; //instead of placing c on d exactly, we move it inline with b so that if the user specifies an ease like Back.easeOut or Elastic.easeOut which goes BEYOND the end, it will do so smoothly.
				seg.da = seg.d - seg.a;
				seg.ca = seg.c - seg.a;
				seg.ba = cp1 - seg.a;
				if (quad) {
					qb = cubicToQuadratic(seg.a, cp1, seg.c, seg.d);
					a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
				}
			},
			_parseAnchors = function(values, p, correlate, prepend) {
				var a = [],
					l, i, p1, p2, p3, tmp;
				if (prepend) {
					values = [prepend].concat(values);
					i = values.length;
					while (--i > -1) {
						if (typeof( (tmp = values[i][p]) ) === "string") if (tmp.charAt(1) === "=") {
							values[i][p] = prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)); //accommodate relative values. Do it inline instead of breaking it out into a function for speed reasons
						}
					}
				}
				l = values.length - 2;
				if (l < 0) {
					a[0] = new Segment(values[0][p], 0, 0, values[0][p]);
					return a;
				}
				for (i = 0; i < l; i++) {
					p1 = values[i][p];
					p2 = values[i+1][p];
					a[i] = new Segment(p1, 0, 0, p2);
					if (correlate) {
						p3 = values[i+2][p];
						_r1[i] = (_r1[i] || 0) + (p2 - p1) * (p2 - p1);
						_r2[i] = (_r2[i] || 0) + (p3 - p2) * (p3 - p2);
					}
				}
				a[i] = new Segment(values[i][p], 0, 0, values[i+1][p]);
				return a;
			},
			bezierThrough = function(values, curviness, quadratic, basic, correlate, prepend) {
				var obj = {},
					props = [],
					first = prepend || values[0],
					i, p, a, j, r, l, seamless, last;
				correlate = (typeof(correlate) === "string") ? ","+correlate+"," : _correlate;
				if (curviness == null) {
					curviness = 1;
				}
				for (p in values[0]) {
					props.push(p);
				}
				//check to see if the last and first values are identical (well, within 0.05). If so, make seamless by appending the second element to the very end of the values array and the 2nd-to-last element to the very beginning (we'll remove those segments later)
				if (values.length > 1) {
					last = values[values.length - 1];
					seamless = true;
					i = props.length;
					while (--i > -1) {
						p = props[i];
						if (Math.abs(first[p] - last[p]) > 0.05) { //build in a tolerance of +/-0.05 to accommodate rounding errors.
							seamless = false;
							break;
						}
					}
					if (seamless) {
						values = values.concat(); //duplicate the array to avoid contaminating the original which the user may be reusing for other tweens
						if (prepend) {
							values.unshift(prepend);
						}
						values.push(values[1]);
						prepend = values[values.length - 3];
					}
				}
				_r1.length = _r2.length = _r3.length = 0;
				i = props.length;
				while (--i > -1) {
					p = props[i];
					_corProps[p] = (correlate.indexOf(","+p+",") !== -1);
					obj[p] = _parseAnchors(values, p, _corProps[p], prepend);
				}
				i = _r1.length;
				while (--i > -1) {
					_r1[i] = Math.sqrt(_r1[i]);
					_r2[i] = Math.sqrt(_r2[i]);
				}
				if (!basic) {
					i = props.length;
					while (--i > -1) {
						if (_corProps[p]) {
							a = obj[props[i]];
							l = a.length - 1;
							for (j = 0; j < l; j++) {
								r = (a[j+1].da / _r2[j] + a[j].da / _r1[j]) || 0;
								_r3[j] = (_r3[j] || 0) + r * r;
							}
						}
					}
					i = _r3.length;
					while (--i > -1) {
						_r3[i] = Math.sqrt(_r3[i]);
					}
				}
				i = props.length;
				j = quadratic ? 4 : 1;
				while (--i > -1) {
					p = props[i];
					a = obj[p];
					_calculateControlPoints(a, curviness, quadratic, basic, _corProps[p]); //this method requires that _parseAnchors() and _setSegmentRatios() ran first so that _r1, _r2, and _r3 values are populated for all properties
					if (seamless) {
						a.splice(0, j);
						a.splice(a.length - j, j);
					}
				}
				return obj;
			},
			_parseBezierData = function(values, type, prepend) {
				type = type || "soft";
				var obj = {},
					inc = (type === "cubic") ? 3 : 2,
					soft = (type === "soft"),
					props = [],
					a, b, c, d, cur, i, j, l, p, cnt, tmp;
				if (soft && prepend) {
					values = [prepend].concat(values);
				}
				if (values == null || values.length < inc + 1) { throw "invalid Bezier data"; }
				for (p in values[0]) {
					props.push(p);
				}
				i = props.length;
				while (--i > -1) {
					p = props[i];
					obj[p] = cur = [];
					cnt = 0;
					l = values.length;
					for (j = 0; j < l; j++) {
						a = (prepend == null) ? values[j][p] : (typeof( (tmp = values[j][p]) ) === "string" && tmp.charAt(1) === "=") ? prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)) : Number(tmp);
						if (soft) if (j > 1) if (j < l - 1) {
							cur[cnt++] = (a + cur[cnt-2]) / 2;
						}
						cur[cnt++] = a;
					}
					l = cnt - inc + 1;
					cnt = 0;
					for (j = 0; j < l; j += inc) {
						a = cur[j];
						b = cur[j+1];
						c = cur[j+2];
						d = (inc === 2) ? 0 : cur[j+3];
						cur[cnt++] = tmp = (inc === 3) ? new Segment(a, b, c, d) : new Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
					}
					cur.length = cnt;
				}
				return obj;
			},
			_addCubicLengths = function(a, steps, resolution) {
				var inc = 1 / resolution,
					j = a.length,
					d, d1, s, da, ca, ba, p, i, inv, bez, index;
				while (--j > -1) {
					bez = a[j];
					s = bez.a;
					da = bez.d - s;
					ca = bez.c - s;
					ba = bez.b - s;
					d = d1 = 0;
					for (i = 1; i <= resolution; i++) {
						p = inc * i;
						inv = 1 - p;
						d = d1 - (d1 = (p * p * da + 3 * inv * (p * ca + inv * ba)) * p);
						index = j * resolution + i - 1;
						steps[index] = (steps[index] || 0) + d * d;
					}
				}
			},
			_parseLengthData = function(obj, resolution) {
				resolution = resolution >> 0 || 6;
				var a = [],
					lengths = [],
					d = 0,
					total = 0,
					threshold = resolution - 1,
					segments = [],
					curLS = [], //current length segments array
					p, i, l, index;
				for (p in obj) {
					_addCubicLengths(obj[p], a, resolution);
				}
				l = a.length;
				for (i = 0; i < l; i++) {
					d += Math.sqrt(a[i]);
					index = i % resolution;
					curLS[index] = d;
					if (index === threshold) {
						total += d;
						index = (i / resolution) >> 0;
						segments[index] = curLS;
						lengths[index] = total;
						d = 0;
						curLS = [];
					}
				}
				return {length:total, lengths:lengths, segments:segments};
			},



			BezierPlugin = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["_gsScope"]._gsDefine.plugin({
					propName: "bezier",
					priority: -1,
					version: "1.3.9",
					API: 2,
					global:true,

					//gets called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
					init: function(target, vars, tween) {
						this._target = target;
						if (vars instanceof Array) {
							vars = {values:vars};
						}
						this._func = {};
						this._mod = {};
						this._props = [];
						this._timeRes = (vars.timeResolution == null) ? 6 : parseInt(vars.timeResolution, 10);
						var values = vars.values || [],
							first = {},
							second = values[0],
							autoRotate = vars.autoRotate || tween.vars.orientToBezier,
							p, isFunc, i, j, prepend;

						this._autoRotate = autoRotate ? (autoRotate instanceof Array) ? autoRotate : [["x","y","rotation",((autoRotate === true) ? 0 : Number(autoRotate) || 0)]] : null;
						for (p in second) {
							this._props.push(p);
						}

						i = this._props.length;
						while (--i > -1) {
							p = this._props[i];

							this._overwriteProps.push(p);
							isFunc = this._func[p] = (typeof(target[p]) === "function");
							first[p] = (!isFunc) ? parseFloat(target[p]) : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]();
							if (!prepend) if (first[p] !== values[0][p]) {
								prepend = first;
							}
						}
						this._beziers = (vars.type !== "cubic" && vars.type !== "quadratic" && vars.type !== "soft") ? bezierThrough(values, isNaN(vars.curviness) ? 1 : vars.curviness, false, (vars.type === "thruBasic"), vars.correlate, prepend) : _parseBezierData(values, vars.type, first);
						this._segCount = this._beziers[p].length;

						if (this._timeRes) {
							var ld = _parseLengthData(this._beziers, this._timeRes);
							this._length = ld.length;
							this._lengths = ld.lengths;
							this._segments = ld.segments;
							this._l1 = this._li = this._s1 = this._si = 0;
							this._l2 = this._lengths[0];
							this._curSeg = this._segments[0];
							this._s2 = this._curSeg[0];
							this._prec = 1 / this._curSeg.length;
						}

						if ((autoRotate = this._autoRotate)) {
							this._initialRotations = [];
							if (!(autoRotate[0] instanceof Array)) {
								this._autoRotate = autoRotate = [autoRotate];
							}
							i = autoRotate.length;
							while (--i > -1) {
								for (j = 0; j < 3; j++) {
									p = autoRotate[i][j];
									this._func[p] = (typeof(target[p]) === "function") ? target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ] : false;
								}
								p = autoRotate[i][2];
								this._initialRotations[i] = (this._func[p] ? this._func[p].call(this._target) : this._target[p]) || 0;
								this._overwriteProps.push(p);
							}
						}
						this._startRatio = tween.vars.runBackwards ? 1 : 0; //we determine the starting ratio when the tween inits which is always 0 unless the tween has runBackwards:true (indicating it's a from() tween) in which case it's 1.
						return true;
					},

					//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
					set: function(v) {
						var segments = this._segCount,
							func = this._func,
							target = this._target,
							notStart = (v !== this._startRatio),
							curIndex, inv, i, p, b, t, val, l, lengths, curSeg, v1;
						if (!this._timeRes) {
							curIndex = (v < 0) ? 0 : (v >= 1) ? segments - 1 : (segments * v) >> 0;
							t = (v - (curIndex * (1 / segments))) * segments;
						} else {
							lengths = this._lengths;
							curSeg = this._curSeg;
							v1 = v * this._length;
							i = this._li;
							//find the appropriate segment (if the currently cached one isn't correct)
							if (v1 > this._l2 && i < segments - 1) {
								l = segments - 1;
								while (i < l && (this._l2 = lengths[++i]) <= v1) {	}
								this._l1 = lengths[i-1];
								this._li = i;
								this._curSeg = curSeg = this._segments[i];
								this._s2 = curSeg[(this._s1 = this._si = 0)];
							} else if (v1 < this._l1 && i > 0) {
								while (i > 0 && (this._l1 = lengths[--i]) >= v1) { }
								if (i === 0 && v1 < this._l1) {
									this._l1 = 0;
								} else {
									i++;
								}
								this._l2 = lengths[i];
								this._li = i;
								this._curSeg = curSeg = this._segments[i];
								this._s1 = curSeg[(this._si = curSeg.length - 1) - 1] || 0;
								this._s2 = curSeg[this._si];
							}
							curIndex = i;
							//now find the appropriate sub-segment (we split it into the number of pieces that was defined by "precision" and measured each one)
							v1 -= this._l1;
							i = this._si;
							if (v1 > this._s2 && i < curSeg.length - 1) {
								l = curSeg.length - 1;
								while (i < l && (this._s2 = curSeg[++i]) <= v1) {	}
								this._s1 = curSeg[i-1];
								this._si = i;
							} else if (v1 < this._s1 && i > 0) {
								while (i > 0 && (this._s1 = curSeg[--i]) >= v1) {	}
								if (i === 0 && v1 < this._s1) {
									this._s1 = 0;
								} else {
									i++;
								}
								this._s2 = curSeg[i];
								this._si = i;
							}
							t = (v === 1) ? 1 : ((i + (v1 - this._s1) / (this._s2 - this._s1)) * this._prec) || 0;
						}
						inv = 1 - t;

						i = this._props.length;
						while (--i > -1) {
							p = this._props[i];
							b = this._beziers[p][curIndex];
							val = (t * t * b.da + 3 * inv * (t * b.ca + inv * b.ba)) * t + b.a;
							if (this._mod[p]) {
								val = this._mod[p](val, target);
							}
							if (func[p]) {
								target[p](val);
							} else {
								target[p] = val;
							}
						}

						if (this._autoRotate) {
							var ar = this._autoRotate,
								b2, x1, y1, x2, y2, add, conv;
							i = ar.length;
							while (--i > -1) {
								p = ar[i][2];
								add = ar[i][3] || 0;
								conv = (ar[i][4] === true) ? 1 : _RAD2DEG;
								b = this._beziers[ar[i][0]];
								b2 = this._beziers[ar[i][1]];

								if (b && b2) { //in case one of the properties got overwritten.
									b = b[curIndex];
									b2 = b2[curIndex];

									x1 = b.a + (b.b - b.a) * t;
									x2 = b.b + (b.c - b.b) * t;
									x1 += (x2 - x1) * t;
									x2 += ((b.c + (b.d - b.c) * t) - x2) * t;

									y1 = b2.a + (b2.b - b2.a) * t;
									y2 = b2.b + (b2.c - b2.b) * t;
									y1 += (y2 - y1) * t;
									y2 += ((b2.c + (b2.d - b2.c) * t) - y2) * t;

									val = notStart ? Math.atan2(y2 - y1, x2 - x1) * conv + add : this._initialRotations[i];

									if (this._mod[p]) {
										val = this._mod[p](val, target); //for modProps
									}

									if (func[p]) {
										target[p](val);
									} else {
										target[p] = val;
									}
								}
							}
						}
					}
			}),
			p = BezierPlugin.prototype;


		BezierPlugin.bezierThrough = bezierThrough;
		BezierPlugin.cubicToQuadratic = cubicToQuadratic;
		BezierPlugin._autoCSS = true; //indicates that this plugin can be inserted into the "css" object using the autoCSS feature of TweenLite
		BezierPlugin.quadraticToCubic = function(a, b, c) {
			return new Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
		};

		BezierPlugin._cssRegister = function() {
			var CSSPlugin = _globals.CSSPlugin;
			if (!CSSPlugin) {
				return;
			}
			var _internals = CSSPlugin._internals,
				_parseToProxy = _internals._parseToProxy,
				_setPluginRatio = _internals._setPluginRatio,
				CSSPropTween = _internals.CSSPropTween;
			_internals._registerComplexSpecialProp("bezier", {parser:function(t, e, prop, cssp, pt, plugin) {
				if (e instanceof Array) {
					e = {values:e};
				}
				plugin = new BezierPlugin();
				var values = e.values,
					l = values.length - 1,
					pluginValues = [],
					v = {},
					i, p, data;
				if (l < 0) {
					return pt;
				}
				for (i = 0; i <= l; i++) {
					data = _parseToProxy(t, values[i], cssp, pt, plugin, (l !== i));
					pluginValues[i] = data.end;
				}
				for (p in e) {
					v[p] = e[p]; //duplicate the vars object because we need to alter some things which would cause problems if the user plans to reuse the same vars object for another tween.
				}
				v.values = pluginValues;
				pt = new CSSPropTween(t, "bezier", 0, 0, data.pt, 2);
				pt.data = data;
				pt.plugin = plugin;
				pt.setRatio = _setPluginRatio;
				if (v.autoRotate === 0) {
					v.autoRotate = true;
				}
				if (v.autoRotate && !(v.autoRotate instanceof Array)) {
					i = (v.autoRotate === true) ? 0 : Number(v.autoRotate);
					v.autoRotate = (data.end.left != null) ? [["left","top","rotation",i,false]] : (data.end.x != null) ? [["x","y","rotation",i,false]] : false;
				}
				if (v.autoRotate) {
					if (!cssp._transform) {
						cssp._enableTransforms(false);
					}
					data.autoRotate = cssp._target._gsTransform;
					data.proxy.rotation = data.autoRotate.rotation || 0;
					cssp._overwriteProps.push("rotation");
				}
				plugin._onInitTween(data.proxy, v, cssp._tween);
				return pt;
			}});
		};

		p._mod = function(lookup) {
			var op = this._overwriteProps,
				i = op.length,
				val;
			while (--i > -1) {
				val = lookup[op[i]];
				if (val && typeof(val) === "function") {
					this._mod[op[i]] = val;
				}
			}
		};

		p._kill = function(lookup) {
			var a = this._props,
				p, i;
			for (p in this._beziers) {
				if (p in lookup) {
					delete this._beziers[p];
					delete this._func[p];
					i = a.length;
					while (--i > -1) {
						if (a[i] === p) {
							a.splice(i, 1);
						}
					}
				}
			}
			a = this._autoRotate;
			if (a) {
				i = a.length;
				while (--i > -1) {
					if (lookup[a[i][2]]) {
						a.splice(i, 1);
					}
				}
			}
			return this._super._kill.call(this, lookup);
		};



/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(91);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(320);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DateTimeFormat_BestFitFormatMatcher__ = __webpack_require__(158);
/* unused harmony reexport BestFitFormatMatcher */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CanonicalizeLocaleList__ = __webpack_require__(33);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CanonicalizeTimeZoneName__ = __webpack_require__(160);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DateTimeFormat_BasicFormatMatcher__ = __webpack_require__(161);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DateTimeFormat_DateTimeStyleFormat__ = __webpack_require__(162);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DateTimeFormat_FormatDateTime__ = __webpack_require__(344);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DateTimeFormat_FormatDateTimeRange__ = __webpack_require__(345);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DateTimeFormat_FormatDateTimeRangeToParts__ = __webpack_require__(346);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DateTimeFormat_FormatDateTimeToParts__ = __webpack_require__(347);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DateTimeFormat_InitializeDateTimeFormat__ = __webpack_require__(348);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DateTimeFormat_PartitionDateTimePattern__ = __webpack_require__(93);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DateTimeFormat_ToDateTimeOptions__ = __webpack_require__(166);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DisplayNames_CanonicalCodeForDisplayNames__ = __webpack_require__(352);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__GetNumberOption__ = __webpack_require__(168);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__GetOption__ = __webpack_require__(28);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__IsSanctionedSimpleUnitIdentifier__ = __webpack_require__(170);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__IsValidTimeZoneName__ = __webpack_require__(167);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__IsWellFormedCurrencyCode__ = __webpack_require__(95);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__IsWellFormedUnitIdentifier__ = __webpack_require__(171);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__NumberFormat_ComputeExponent__ = __webpack_require__(172);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__NumberFormat_ComputeExponentForMagnitude__ = __webpack_require__(173);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__NumberFormat_CurrencyDigits__ = __webpack_require__(175);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__NumberFormat_FormatNumericToParts__ = __webpack_require__(353);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__NumberFormat_FormatNumericToString__ = __webpack_require__(56);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__NumberFormat_InitializeNumberFormat__ = __webpack_require__(355);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__NumberFormat_PartitionNumberPattern__ = __webpack_require__(176);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__NumberFormat_SetNumberFormatDigitOptions__ = __webpack_require__(97);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__NumberFormat_SetNumberFormatUnitOptions__ = __webpack_require__(178);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__NumberFormat_ToRawFixed__ = __webpack_require__(96);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__NumberFormat_ToRawPrecision__ = __webpack_require__(174);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__PartitionPattern__ = __webpack_require__(55);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__PluralRules_GetOperands__ = __webpack_require__(179);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__PluralRules_InitializePluralRules__ = __webpack_require__(356);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__PluralRules_ResolvePlural__ = __webpack_require__(357);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__RelativeTimeFormat_FormatRelativeTime__ = __webpack_require__(358);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__RelativeTimeFormat_FormatRelativeTimeToParts__ = __webpack_require__(359);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__RelativeTimeFormat_InitializeRelativeTimeFormat__ = __webpack_require__(360);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__RelativeTimeFormat_MakePartsList__ = __webpack_require__(181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__RelativeTimeFormat_PartitionRelativeTimePattern__ = __webpack_require__(98);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__RelativeTimeFormat_SingularRelativeTimeUnit__ = __webpack_require__(180);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__ResolveLocale__ = __webpack_require__(44);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__SupportedLocales__ = __webpack_require__(361);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__NumberFormat_format_to_parts__ = __webpack_require__(177);
/* unused harmony reexport _formatToParts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__DateTimeFormat_utils__ = __webpack_require__(43);
/* unused harmony reexport DATE_TIME_PROPS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__DateTimeFormat_skeleton__ = __webpack_require__(159);
/* unused harmony reexport parseDateTimeSkeleton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__utils__ = __webpack_require__(4);
/* unused harmony reexport getInternalSlot */
/* unused harmony reexport getMultiInternalSlots */
/* unused harmony reexport isLiteralPart */
/* unused harmony reexport setInternalSlot */
/* unused harmony reexport setMultiInternalSlots */
/* unused harmony reexport getMagnitude */
/* unused harmony reexport defineProperty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__data__ = __webpack_require__(363);
/* unused harmony reexport isMissingLocaleDataError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__types_relative_time__ = __webpack_require__(364);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__types_date_time__ = __webpack_require__(365);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__types_list__ = __webpack_require__(366);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__types_plural_rules__ = __webpack_require__(367);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__types_number__ = __webpack_require__(368);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__types_displaynames__ = __webpack_require__(369);
/* unused harmony namespace reexport */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_45__utils__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__262__ = __webpack_require__(6);
/* unused harmony namespace reexport */

























































/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PartitionDateTimePattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__262__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormatDateTimePattern__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PartitionPattern__ = __webpack_require__(55);



/**
 * https://tc39.es/ecma402/#sec-partitiondatetimepattern
 * @param dtf
 * @param x
 */
function PartitionDateTimePattern(dtf, x, implDetails) {
    x = Object(__WEBPACK_IMPORTED_MODULE_0__262__["i" /* TimeClip */])(x);
    if (isNaN(x)) {
        throw new RangeError('invalid time');
    }
    /** IMPL START */
    var getInternalSlots = implDetails.getInternalSlots;
    var internalSlots = getInternalSlots(dtf);
    /** IMPL END */
    var pattern = internalSlots.pattern;
    return Object(__WEBPACK_IMPORTED_MODULE_1__FormatDateTimePattern__["a" /* FormatDateTimePattern */])(dtf, Object(__WEBPACK_IMPORTED_MODULE_2__PartitionPattern__["a" /* PartitionPattern */])(pattern), x, implDetails);
}


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BestAvailableLocale;
/**
 * https://tc39.es/ecma402/#sec-bestavailablelocale
 * @param availableLocales
 * @param locale
 */
function BestAvailableLocale(availableLocales, locale) {
    var candidate = locale;
    while (true) {
        if (availableLocales.has(candidate)) {
            return candidate;
        }
        var pos = candidate.lastIndexOf('-');
        if (!~pos) {
            return undefined;
        }
        if (pos >= 2 && candidate[pos - 2] === '-') {
            pos -= 2;
        }
        candidate = candidate.slice(0, pos);
    }
}


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IsWellFormedCurrencyCode;
/**
 * This follows https://tc39.es/ecma402/#sec-case-sensitivity-and-case-mapping
 * @param str string to convert
 */
function toUpperCase(str) {
    return str.replace(/([a-z])/g, function (_, c) { return c.toUpperCase(); });
}
var NOT_A_Z_REGEX = /[^A-Z]/;
/**
 * https://tc39.es/ecma402/#sec-iswellformedcurrencycode
 */
function IsWellFormedCurrencyCode(currency) {
    currency = toUpperCase(currency);
    if (currency.length !== 3) {
        return false;
    }
    if (NOT_A_Z_REGEX.test(currency)) {
        return false;
    }
    return true;
}


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ToRawFixed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);

/**
 * TODO: dedup with intl-pluralrules and support BigInt
 * https://tc39.es/ecma402/#sec-torawfixed
 * @param x a finite non-negative Number or BigInt
 * @param minFraction and integer between 0 and 20
 * @param maxFraction and integer between 0 and 20
 */
function ToRawFixed(x, minFraction, maxFraction) {
    var f = maxFraction;
    var n = Math.round(x * Math.pow(10, f));
    var xFinal = n / Math.pow(10, f);
    // n is a positive integer, but it is possible to be greater than 1e21.
    // In such case we will go the slow path.
    // See also: https://tc39.es/ecma262/#sec-numeric-types-number-tostring
    var m;
    if (n < 1e21) {
        m = n.toString();
    }
    else {
        m = n.toString();
        var _a = m.split('e'), mantissa = _a[0], exponent = _a[1];
        m = mantissa.replace('.', '');
        m = m + Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* repeat */])('0', Math.max(+exponent - m.length + 1, 0));
    }
    var int;
    if (f !== 0) {
        var k = m.length;
        if (k <= f) {
            var z = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* repeat */])('0', f + 1 - k);
            m = z + m;
            k = f + 1;
        }
        var a = m.slice(0, k - f);
        var b = m.slice(k - f);
        m = a + "." + b;
        int = a.length;
    }
    else {
        int = m.length;
    }
    var cut = maxFraction - minFraction;
    while (cut > 0 && m[m.length - 1] === '0') {
        m = m.slice(0, -1);
        cut--;
    }
    if (m[m.length - 1] === '.') {
        m = m.slice(0, -1);
    }
    return { formattedString: m, roundedNumber: xFinal, integerDigitsCount: int };
}


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SetNumberFormatDigitOptions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GetNumberOption__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DefaultNumberOption__ = __webpack_require__(169);


/**
 * https://tc39.es/ecma402/#sec-setnfdigitoptions
 */
function SetNumberFormatDigitOptions(internalSlots, opts, mnfdDefault, mxfdDefault, notation) {
    var mnid = Object(__WEBPACK_IMPORTED_MODULE_0__GetNumberOption__["a" /* GetNumberOption */])(opts, 'minimumIntegerDigits', 1, 21, 1);
    var mnfd = opts.minimumFractionDigits;
    var mxfd = opts.maximumFractionDigits;
    var mnsd = opts.minimumSignificantDigits;
    var mxsd = opts.maximumSignificantDigits;
    internalSlots.minimumIntegerDigits = mnid;
    if (mnsd !== undefined || mxsd !== undefined) {
        internalSlots.roundingType = 'significantDigits';
        mnsd = Object(__WEBPACK_IMPORTED_MODULE_1__DefaultNumberOption__["a" /* DefaultNumberOption */])(mnsd, 1, 21, 1);
        mxsd = Object(__WEBPACK_IMPORTED_MODULE_1__DefaultNumberOption__["a" /* DefaultNumberOption */])(mxsd, mnsd, 21, 21);
        internalSlots.minimumSignificantDigits = mnsd;
        internalSlots.maximumSignificantDigits = mxsd;
    }
    else if (mnfd !== undefined || mxfd !== undefined) {
        internalSlots.roundingType = 'fractionDigits';
        mnfd = Object(__WEBPACK_IMPORTED_MODULE_1__DefaultNumberOption__["a" /* DefaultNumberOption */])(mnfd, 0, 20, mnfdDefault);
        var mxfdActualDefault = Math.max(mnfd, mxfdDefault);
        mxfd = Object(__WEBPACK_IMPORTED_MODULE_1__DefaultNumberOption__["a" /* DefaultNumberOption */])(mxfd, mnfd, 20, mxfdActualDefault);
        internalSlots.minimumFractionDigits = mnfd;
        internalSlots.maximumFractionDigits = mxfd;
    }
    else if (notation === 'compact') {
        internalSlots.roundingType = 'compactRounding';
    }
    else {
        internalSlots.roundingType = 'fractionDigits';
        internalSlots.minimumFractionDigits = mnfdDefault;
        internalSlots.maximumFractionDigits = mxfdDefault;
    }
}


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PartitionRelativeTimePattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SingularRelativeTimeUnit__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MakePartsList__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__262__ = __webpack_require__(6);




function PartitionRelativeTimePattern(rtf, value, unit, _a) {
    var getInternalSlots = _a.getInternalSlots;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* invariant */])(Object(__WEBPACK_IMPORTED_MODULE_3__262__["m" /* Type */])(value) === 'Number', "value must be number, instead got " + typeof value, TypeError);
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* invariant */])(Object(__WEBPACK_IMPORTED_MODULE_3__262__["m" /* Type */])(unit) === 'String', "unit must be number, instead got " + typeof value, TypeError);
    if (isNaN(value) || !isFinite(value)) {
        throw new RangeError("Invalid value " + value);
    }
    var resolvedUnit = Object(__WEBPACK_IMPORTED_MODULE_1__SingularRelativeTimeUnit__["a" /* SingularRelativeTimeUnit */])(unit);
    var _b = getInternalSlots(rtf), fields = _b.fields, style = _b.style, numeric = _b.numeric, pluralRules = _b.pluralRules, numberFormat = _b.numberFormat;
    var entry = resolvedUnit;
    if (style === 'short') {
        entry = resolvedUnit + "-short";
    }
    else if (style === 'narrow') {
        entry = resolvedUnit + "-narrow";
    }
    if (!(entry in fields)) {
        entry = resolvedUnit;
    }
    var patterns = fields[entry];
    if (numeric === 'auto') {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__262__["l" /* ToString */])(value) in patterns) {
            return [
                {
                    type: 'literal',
                    value: patterns[Object(__WEBPACK_IMPORTED_MODULE_3__262__["l" /* ToString */])(value)],
                },
            ];
        }
    }
    var tl = 'future';
    if (Object(__WEBPACK_IMPORTED_MODULE_3__262__["g" /* SameValue */])(value, -0) || value < 0) {
        tl = 'past';
    }
    var po = patterns[tl];
    var fv = typeof numberFormat.formatToParts === 'function'
        ? numberFormat.formatToParts(Math.abs(value))
        : // TODO: If formatToParts is not supported, we assume the whole formatted
            // number is a part
            [
                {
                    type: 'literal',
                    value: numberFormat.format(Math.abs(value)),
                    unit: unit,
                },
            ];
    var pr = pluralRules.select(value);
    var pattern = po[pr];
    return Object(__WEBPACK_IMPORTED_MODULE_2__MakePartsList__["a" /* MakePartsList */])(pattern, resolvedUnit, fv);
}


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defineMessages */
/* unused harmony export defineMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_types__ = __webpack_require__(370);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_utils__ = __webpack_require__(21);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_utils__["c"]; });
/* unused harmony reexport filterProps */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_utils__["a"]; });
/* unused harmony reexport createFormatters */
/* unused harmony reexport getNamedFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_error__ = __webpack_require__(17);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_message__ = __webpack_require__(187);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__src_message__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_dateTime__ = __webpack_require__(188);
/* unused harmony reexport formatDate */
/* unused harmony reexport formatDateToParts */
/* unused harmony reexport formatTime */
/* unused harmony reexport formatTimeToParts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_displayName__ = __webpack_require__(189);
/* unused harmony reexport formatDisplayName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_list__ = __webpack_require__(190);
/* unused harmony reexport formatList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_plural__ = __webpack_require__(191);
/* unused harmony reexport formatPlural */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_relativeTime__ = __webpack_require__(192);
/* unused harmony reexport formatRelativeTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_number__ = __webpack_require__(193);
/* unused harmony reexport formatNumber */
/* unused harmony reexport formatNumberToParts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_create_intl__ = __webpack_require__(373);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_10__src_create_intl__["a"]; });

function defineMessages(msgs) {
    return msgs;
}
function defineMessage(msg) {
    return msg;
}












/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["m"] = parse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_parser__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_normalize__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_types__ = __webpack_require__(102);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__src_types__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__src_types__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__src_types__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__src_types__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__src_types__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__src_types__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__src_types__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_3__src_types__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__src_types__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__src_types__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_3__src_types__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_3__src_types__["l"]; });
/* unused harmony namespace reexport */





function parse(input, opts) {
    opts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ normalizeHashtagInPlural: true, shouldParseSkeleton: true }, (opts || {}));
    var els = Object(__WEBPACK_IMPORTED_MODULE_1__src_parser__["a" /* pegParse */])(input, opts);
    if (opts.normalizeHashtagInPlural) {
        Object(__WEBPACK_IMPORTED_MODULE_2__src_normalize__["a" /* normalizeHashtagInPlural */])(els);
    }
    return els;
}


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SyntaxError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pegParse; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__skeleton__ = __webpack_require__(371);
// @ts-nocheck

// @generated


var SyntaxError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(SyntaxError, _super);
    function SyntaxError(message, expected, found, location) {
        var _this = _super.call(this) || this;
        _this.message = message;
        _this.expected = expected;
        _this.found = found;
        _this.location = location;
        _this.name = "SyntaxError";
        if (typeof Error.captureStackTrace === "function") {
            Error.captureStackTrace(_this, SyntaxError);
        }
        return _this;
    }
    SyntaxError.buildMessage = function (expected, found) {
        function hex(ch) {
            return ch.charCodeAt(0).toString(16).toUpperCase();
        }
        function literalEscape(s) {
            return s
                .replace(/\\/g, "\\\\")
                .replace(/"/g, "\\\"")
                .replace(/\0/g, "\\0")
                .replace(/\t/g, "\\t")
                .replace(/\n/g, "\\n")
                .replace(/\r/g, "\\r")
                .replace(/[\x00-\x0F]/g, function (ch) { return "\\x0" + hex(ch); })
                .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) { return "\\x" + hex(ch); });
        }
        function classEscape(s) {
            return s
                .replace(/\\/g, "\\\\")
                .replace(/\]/g, "\\]")
                .replace(/\^/g, "\\^")
                .replace(/-/g, "\\-")
                .replace(/\0/g, "\\0")
                .replace(/\t/g, "\\t")
                .replace(/\n/g, "\\n")
                .replace(/\r/g, "\\r")
                .replace(/[\x00-\x0F]/g, function (ch) { return "\\x0" + hex(ch); })
                .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) { return "\\x" + hex(ch); });
        }
        function describeExpectation(expectation) {
            switch (expectation.type) {
                case "literal":
                    return "\"" + literalEscape(expectation.text) + "\"";
                case "class":
                    var escapedParts = expectation.parts.map(function (part) {
                        return Array.isArray(part)
                            ? classEscape(part[0]) + "-" + classEscape(part[1])
                            : classEscape(part);
                    });
                    return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
                case "any":
                    return "any character";
                case "end":
                    return "end of input";
                case "other":
                    return expectation.description;
            }
        }
        function describeExpected(expected1) {
            var descriptions = expected1.map(describeExpectation);
            var i;
            var j;
            descriptions.sort();
            if (descriptions.length > 0) {
                for (i = 1, j = 1; i < descriptions.length; i++) {
                    if (descriptions[i - 1] !== descriptions[i]) {
                        descriptions[j] = descriptions[i];
                        j++;
                    }
                }
                descriptions.length = j;
            }
            switch (descriptions.length) {
                case 1:
                    return descriptions[0];
                case 2:
                    return descriptions[0] + " or " + descriptions[1];
                default:
                    return descriptions.slice(0, -1).join(", ")
                        + ", or "
                        + descriptions[descriptions.length - 1];
            }
        }
        function describeFound(found1) {
            return found1 ? "\"" + literalEscape(found1) + "\"" : "end of input";
        }
        return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
    };
    return SyntaxError;
}(Error));

function peg$parse(input, options) {
    options = options !== undefined ? options : {};
    var peg$FAILED = {};
    var peg$startRuleFunctions = { start: peg$parsestart };
    var peg$startRuleFunction = peg$parsestart;
    var peg$c0 = function () { return !ignoreTag; };
    var peg$c1 = function (x) { return x; };
    var peg$c2 = function () { return ignoreTag; };
    var peg$c3 = "<";
    var peg$c4 = peg$literalExpectation("<", false);
    var peg$c5 = function (parts) {
        return parts.join('');
    };
    var peg$c6 = function () { return '<'; };
    var peg$c7 = function (messageText) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ type: __WEBPACK_IMPORTED_MODULE_1__types__["a" /* TYPE */].literal, value: messageText }, insertLocation());
    };
    var peg$c8 = "#";
    var peg$c9 = peg$literalExpectation("#", false);
    var peg$c10 = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ type: __WEBPACK_IMPORTED_MODULE_1__types__["a" /* TYPE */].pound }, insertLocation());
    };
    var peg$c11 = peg$otherExpectation("tagElement");
    var peg$c12 = function (open, children, close) {
        if (open !== close) {
            error("Mismatch tag \"" + open + "\" !== \"" + close + "\"", location());
        }
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ type: __WEBPACK_IMPORTED_MODULE_1__types__["a" /* TYPE */].tag, value: open, children: children }, insertLocation());
    };
    var peg$c13 = "/>";
    var peg$c14 = peg$literalExpectation("/>", false);
    var peg$c15 = function (value) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ type: __WEBPACK_IMPORTED_MODULE_1__types__["a" /* TYPE */].literal, value: value.join('') }, insertLocation());
    };
    var peg$c16 = ">";
    var peg$c17 = peg$literalExpectation(">", false);
    var peg$c18 = function (tag) { return tag; };
    var peg$c19 = "</";
    var peg$c20 = peg$literalExpectation("</", false);
    var peg$c21 = peg$otherExpectation("argumentElement");
    var peg$c22 = "{";
    var peg$c23 = peg$literalExpectation("{", false);
    var peg$c24 = "}";
    var peg$c25 = peg$literalExpectation("}", false);
    var peg$c26 = function (value) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ type: __WEBPACK_IMPORTED_MODULE_1__types__["a" /* TYPE */].argument, value: value }, insertLocation());
    };
    var peg$c27 = peg$otherExpectation("numberSkeletonId");
    var peg$c28 = /^['\/{}]/;
    var peg$c29 = peg$classExpectation(["'", "/", "{", "}"], false, false);
    var peg$c30 = peg$anyExpectation();
    var peg$c31 = peg$otherExpectation("numberSkeletonTokenOption");
    var peg$c32 = "/";
    var peg$c33 = peg$literalExpectation("/", false);
    var peg$c34 = function (option) { return option; };
    var peg$c35 = peg$otherExpectation("numberSkeletonToken");
    var peg$c36 = function (stem, options) {
        return { stem: stem, options: options };
    };
    var peg$c37 = function (tokens) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ type: 0 /* number */, tokens: tokens, parsedOptions: shouldParseSkeleton ? Object(__WEBPACK_IMPORTED_MODULE_2__skeleton__["b" /* parseNumberSkeleton */])(tokens) : {} }, insertLocation());
    };
    var peg$c38 = "::";
    var peg$c39 = peg$literalExpectation("::", false);
    var peg$c40 = function (skeleton) { return skeleton; };
    var peg$c41 = function () { messageCtx.push('numberArgStyle'); return true; };
    var peg$c42 = function (style) {
        messageCtx.pop();
        return style.replace(/\s*$/, '');
    };
    var peg$c43 = ",";
    var peg$c44 = peg$literalExpectation(",", false);
    var peg$c45 = "number";
    var peg$c46 = peg$literalExpectation("number", false);
    var peg$c47 = function (value, type, style) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ type: type === 'number' ? __WEBPACK_IMPORTED_MODULE_1__types__["a" /* TYPE */].number : type === 'date' ? __WEBPACK_IMPORTED_MODULE_1__types__["a" /* TYPE */].date : __WEBPACK_IMPORTED_MODULE_1__types__["a" /* TYPE */].time, style: style && style[2], value: value }, insertLocation());
    };
    var peg$c48 = "'";
    var peg$c49 = peg$literalExpectation("'", false);
    var peg$c50 = /^[^']/;
    var peg$c51 = peg$classExpectation(["'"], true, false);
    var peg$c52 = /^[^a-zA-Z'{}]/;
    var peg$c53 = peg$classExpectation([["a", "z"], ["A", "Z"], "'", "{", "}"], true, false);
    var peg$c54 = /^[a-zA-Z]/;
    var peg$c55 = peg$classExpectation([["a", "z"], ["A", "Z"]], false, false);
    var peg$c56 = function (pattern) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ type: 1 /* dateTime */, pattern: pattern, parsedOptions: shouldParseSkeleton ? Object(__WEBPACK_IMPORTED_MODULE_2__skeleton__["a" /* parseDateTimeSkeleton */])(pattern) : {} }, insertLocation());
    };
    var peg$c57 = function () { messageCtx.push('dateOrTimeArgStyle'); return true; };
    var peg$c58 = "date";
    var peg$c59 = peg$literalExpectation("date", false);
    var peg$c60 = "time";
    var peg$c61 = peg$literalExpectation("time", false);
    var peg$c62 = "plural";
    var peg$c63 = peg$literalExpectation("plural", false);
    var peg$c64 = "selectordinal";
    var peg$c65 = peg$literalExpectation("selectordinal", false);
    var peg$c66 = "offset:";
    var peg$c67 = peg$literalExpectation("offset:", false);
    var peg$c68 = function (value, pluralType, offset, options) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ type: __WEBPACK_IMPORTED_MODULE_1__types__["a" /* TYPE */].plural, pluralType: pluralType === 'plural' ? 'cardinal' : 'ordinal', value: value, offset: offset ? offset[2] : 0, options: options.reduce(function (all, _a) {
                var id = _a.id, value = _a.value, optionLocation = _a.location;
                if (id in all) {
                    error("Duplicate option \"" + id + "\" in plural element: \"" + text() + "\"", location());
                }
                all[id] = {
                    value: value,
                    location: optionLocation
                };
                return all;
            }, {}) }, insertLocation());
    };
    var peg$c69 = "select";
    var peg$c70 = peg$literalExpectation("select", false);
    var peg$c71 = function (value, options) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ type: __WEBPACK_IMPORTED_MODULE_1__types__["a" /* TYPE */].select, value: value, options: options.reduce(function (all, _a) {
                var id = _a.id, value = _a.value, optionLocation = _a.location;
                if (id in all) {
                    error("Duplicate option \"" + id + "\" in select element: \"" + text() + "\"", location());
                }
                all[id] = {
                    value: value,
                    location: optionLocation
                };
                return all;
            }, {}) }, insertLocation());
    };
    var peg$c72 = "=";
    var peg$c73 = peg$literalExpectation("=", false);
    var peg$c74 = function (id) { messageCtx.push('select'); return true; };
    var peg$c75 = function (id, value) {
        messageCtx.pop();
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ id: id,
            value: value }, insertLocation());
    };
    var peg$c76 = function (id) { messageCtx.push('plural'); return true; };
    var peg$c77 = function (id, value) {
        messageCtx.pop();
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ id: id,
            value: value }, insertLocation());
    };
    var peg$c78 = peg$otherExpectation("whitespace");
    var peg$c79 = /^[\t-\r \x85\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;
    var peg$c80 = peg$classExpectation([["\t", "\r"], " ", "\x85", "\xA0", "\u1680", ["\u2000", "\u200A"], "\u2028", "\u2029", "\u202F", "\u205F", "\u3000"], false, false);
    var peg$c81 = peg$otherExpectation("syntax pattern");
    var peg$c82 = /^[!-\/:-@[-\^`{-~\xA1-\xA7\xA9\xAB\xAC\xAE\xB0\xB1\xB6\xBB\xBF\xD7\xF7\u2010-\u2027\u2030-\u203E\u2041-\u2053\u2055-\u205E\u2190-\u245F\u2500-\u2775\u2794-\u2BFF\u2E00-\u2E7F\u3001-\u3003\u3008-\u3020\u3030\uFD3E\uFD3F\uFE45\uFE46]/;
    var peg$c83 = peg$classExpectation([["!", "/"], [":", "@"], ["[", "^"], "`", ["{", "~"], ["\xA1", "\xA7"], "\xA9", "\xAB", "\xAC", "\xAE", "\xB0", "\xB1", "\xB6", "\xBB", "\xBF", "\xD7", "\xF7", ["\u2010", "\u2027"], ["\u2030", "\u203E"], ["\u2041", "\u2053"], ["\u2055", "\u205E"], ["\u2190", "\u245F"], ["\u2500", "\u2775"], ["\u2794", "\u2BFF"], ["\u2E00", "\u2E7F"], ["\u3001", "\u3003"], ["\u3008", "\u3020"], "\u3030", "\uFD3E", "\uFD3F", "\uFE45", "\uFE46"], false, false);
    var peg$c84 = peg$otherExpectation("optional whitespace");
    var peg$c85 = peg$otherExpectation("number");
    var peg$c86 = "-";
    var peg$c87 = peg$literalExpectation("-", false);
    var peg$c88 = function (negative, num) {
        return num
            ? negative
                ? -num
                : num
            : 0;
    };
    var peg$c89 = peg$otherExpectation("apostrophe");
    var peg$c90 = peg$otherExpectation("double apostrophes");
    var peg$c91 = "''";
    var peg$c92 = peg$literalExpectation("''", false);
    var peg$c93 = function () { return "'"; };
    var peg$c94 = function (escapedChar, quotedChars) {
        return escapedChar + quotedChars.replace("''", "'");
    };
    var peg$c95 = function (x) {
        return (x !== '<' &&
            x !== '{' &&
            !(isInPluralOption() && x === '#') &&
            !(isNestedMessageText() && x === '}'));
    };
    var peg$c96 = "\n";
    var peg$c97 = peg$literalExpectation("\n", false);
    var peg$c98 = function (x) {
        return x === '<' || x === '>' || x === '{' || x === '}' || (isInPluralOption() && x === '#');
    };
    var peg$c99 = peg$otherExpectation("argNameOrNumber");
    var peg$c100 = peg$otherExpectation("validTag");
    var peg$c101 = peg$otherExpectation("argNumber");
    var peg$c102 = "0";
    var peg$c103 = peg$literalExpectation("0", false);
    var peg$c104 = function () { return 0; };
    var peg$c105 = /^[1-9]/;
    var peg$c106 = peg$classExpectation([["1", "9"]], false, false);
    var peg$c107 = /^[0-9]/;
    var peg$c108 = peg$classExpectation([["0", "9"]], false, false);
    var peg$c109 = function (digits) {
        return parseInt(digits.join(''), 10);
    };
    var peg$c110 = peg$otherExpectation("argName");
    var peg$c111 = peg$otherExpectation("tagName");
    var peg$currPos = 0;
    var peg$savedPos = 0;
    var peg$posDetailsCache = [{ line: 1, column: 1 }];
    var peg$maxFailPos = 0;
    var peg$maxFailExpected = [];
    var peg$silentFails = 0;
    var peg$result;
    if (options.startRule !== undefined) {
        if (!(options.startRule in peg$startRuleFunctions)) {
            throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
        }
        peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }
    function text() {
        return input.substring(peg$savedPos, peg$currPos);
    }
    function location() {
        return peg$computeLocation(peg$savedPos, peg$currPos);
    }
    function expected(description, location1) {
        location1 = location1 !== undefined
            ? location1
            : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildStructuredError([peg$otherExpectation(description)], input.substring(peg$savedPos, peg$currPos), location1);
    }
    function error(message, location1) {
        location1 = location1 !== undefined
            ? location1
            : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildSimpleError(message, location1);
    }
    function peg$literalExpectation(text1, ignoreCase) {
        return { type: "literal", text: text1, ignoreCase: ignoreCase };
    }
    function peg$classExpectation(parts, inverted, ignoreCase) {
        return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
    }
    function peg$anyExpectation() {
        return { type: "any" };
    }
    function peg$endExpectation() {
        return { type: "end" };
    }
    function peg$otherExpectation(description) {
        return { type: "other", description: description };
    }
    function peg$computePosDetails(pos) {
        var details = peg$posDetailsCache[pos];
        var p;
        if (details) {
            return details;
        }
        else {
            p = pos - 1;
            while (!peg$posDetailsCache[p]) {
                p--;
            }
            details = peg$posDetailsCache[p];
            details = {
                line: details.line,
                column: details.column
            };
            while (p < pos) {
                if (input.charCodeAt(p) === 10) {
                    details.line++;
                    details.column = 1;
                }
                else {
                    details.column++;
                }
                p++;
            }
            peg$posDetailsCache[pos] = details;
            return details;
        }
    }
    function peg$computeLocation(startPos, endPos) {
        var startPosDetails = peg$computePosDetails(startPos);
        var endPosDetails = peg$computePosDetails(endPos);
        return {
            start: {
                offset: startPos,
                line: startPosDetails.line,
                column: startPosDetails.column
            },
            end: {
                offset: endPos,
                line: endPosDetails.line,
                column: endPosDetails.column
            }
        };
    }
    function peg$fail(expected1) {
        if (peg$currPos < peg$maxFailPos) {
            return;
        }
        if (peg$currPos > peg$maxFailPos) {
            peg$maxFailPos = peg$currPos;
            peg$maxFailExpected = [];
        }
        peg$maxFailExpected.push(expected1);
    }
    function peg$buildSimpleError(message, location1) {
        return new SyntaxError(message, [], "", location1);
    }
    function peg$buildStructuredError(expected1, found, location1) {
        return new SyntaxError(SyntaxError.buildMessage(expected1, found), expected1, found, location1);
    }
    function peg$parsestart() {
        var s0;
        s0 = peg$parsemessage();
        return s0;
    }
    function peg$parsemessage() {
        var s0, s1;
        s0 = [];
        s1 = peg$parsemessageElement();
        while (s1 !== peg$FAILED) {
            s0.push(s1);
            s1 = peg$parsemessageElement();
        }
        return s0;
    }
    function peg$parsemessageElement() {
        var s0, s1, s2;
        s0 = peg$currPos;
        peg$savedPos = peg$currPos;
        s1 = peg$c0();
        if (s1) {
            s1 = undefined;
        }
        else {
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parsetagElement();
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c1(s2);
                s0 = s1;
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$parseliteralElement();
            if (s0 === peg$FAILED) {
                s0 = peg$parseargumentElement();
                if (s0 === peg$FAILED) {
                    s0 = peg$parsesimpleFormatElement();
                    if (s0 === peg$FAILED) {
                        s0 = peg$parsepluralElement();
                        if (s0 === peg$FAILED) {
                            s0 = peg$parseselectElement();
                            if (s0 === peg$FAILED) {
                                s0 = peg$parsepoundElement();
                            }
                        }
                    }
                }
            }
        }
        return s0;
    }
    function peg$parsemessageText() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        peg$savedPos = peg$currPos;
        s1 = peg$c2();
        if (s1) {
            s1 = undefined;
        }
        else {
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsedoubleApostrophes();
            if (s3 === peg$FAILED) {
                s3 = peg$parsequotedString();
                if (s3 === peg$FAILED) {
                    s3 = peg$parseunquotedString();
                    if (s3 === peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 60) {
                            s3 = peg$c3;
                            peg$currPos++;
                        }
                        else {
                            s3 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c4);
                            }
                        }
                    }
                }
            }
            if (s3 !== peg$FAILED) {
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = peg$parsedoubleApostrophes();
                    if (s3 === peg$FAILED) {
                        s3 = peg$parsequotedString();
                        if (s3 === peg$FAILED) {
                            s3 = peg$parseunquotedString();
                            if (s3 === peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 60) {
                                    s3 = peg$c3;
                                    peg$currPos++;
                                }
                                else {
                                    s3 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c4);
                                    }
                                }
                            }
                        }
                    }
                }
            }
            else {
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c5(s2);
                s0 = s1;
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parsedoubleApostrophes();
            if (s2 === peg$FAILED) {
                s2 = peg$parsequotedString();
                if (s2 === peg$FAILED) {
                    s2 = peg$parseunquotedString();
                    if (s2 === peg$FAILED) {
                        s2 = peg$parsenonTagStartingAngleBracket();
                    }
                }
            }
            if (s2 !== peg$FAILED) {
                while (s2 !== peg$FAILED) {
                    s1.push(s2);
                    s2 = peg$parsedoubleApostrophes();
                    if (s2 === peg$FAILED) {
                        s2 = peg$parsequotedString();
                        if (s2 === peg$FAILED) {
                            s2 = peg$parseunquotedString();
                            if (s2 === peg$FAILED) {
                                s2 = peg$parsenonTagStartingAngleBracket();
                            }
                        }
                    }
                }
            }
            else {
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c5(s1);
            }
            s0 = s1;
        }
        return s0;
    }
    function peg$parsenonTagStartingAngleBracket() {
        var s0, s1, s2;
        s0 = peg$currPos;
        s1 = peg$currPos;
        peg$silentFails++;
        s2 = peg$parseopeningTag();
        if (s2 === peg$FAILED) {
            s2 = peg$parseclosingTag();
            if (s2 === peg$FAILED) {
                s2 = peg$parseselfClosingTag();
            }
        }
        peg$silentFails--;
        if (s2 === peg$FAILED) {
            s1 = undefined;
        }
        else {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 60) {
                s2 = peg$c3;
                peg$currPos++;
            }
            else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c4);
                }
            }
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c6();
                s0 = s1;
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseliteralElement() {
        var s0, s1;
        s0 = peg$currPos;
        s1 = peg$parsemessageText();
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c7(s1);
        }
        s0 = s1;
        return s0;
    }
    function peg$parsepoundElement() {
        var s0, s1;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 35) {
            s1 = peg$c8;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c9);
            }
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c10();
        }
        s0 = s1;
        return s0;
    }
    function peg$parsetagElement() {
        var s0, s1, s2, s3;
        peg$silentFails++;
        s0 = peg$parseselfClosingTag();
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parseopeningTag();
            if (s1 !== peg$FAILED) {
                s2 = peg$parsemessage();
                if (s2 !== peg$FAILED) {
                    s3 = peg$parseclosingTag();
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c12(s1, s2, s3);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c11);
            }
        }
        return s0;
    }
    function peg$parseselfClosingTag() {
        var s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        s1 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 60) {
            s2 = peg$c3;
            peg$currPos++;
        }
        else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c4);
            }
        }
        if (s2 !== peg$FAILED) {
            s3 = peg$parsevalidTag();
            if (s3 !== peg$FAILED) {
                s4 = peg$parse_();
                if (s4 !== peg$FAILED) {
                    if (input.substr(peg$currPos, 2) === peg$c13) {
                        s5 = peg$c13;
                        peg$currPos += 2;
                    }
                    else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c14);
                        }
                    }
                    if (s5 !== peg$FAILED) {
                        s2 = [s2, s3, s4, s5];
                        s1 = s2;
                    }
                    else {
                        peg$currPos = s1;
                        s1 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s1;
                    s1 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c15(s1);
        }
        s0 = s1;
        return s0;
    }
    function peg$parseopeningTag() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 60) {
            s1 = peg$c3;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c4);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parsevalidTag();
            if (s2 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 62) {
                    s3 = peg$c16;
                    peg$currPos++;
                }
                else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c17);
                    }
                }
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c18(s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseclosingTag() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c19) {
            s1 = peg$c19;
            peg$currPos += 2;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c20);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parsevalidTag();
            if (s2 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 62) {
                    s3 = peg$c16;
                    peg$currPos++;
                }
                else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c17);
                    }
                }
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c18(s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseargumentElement() {
        var s0, s1, s2, s3, s4, s5;
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 123) {
            s1 = peg$c22;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c23);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                s3 = peg$parseargNameOrNumber();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parse_();
                    if (s4 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 125) {
                            s5 = peg$c24;
                            peg$currPos++;
                        }
                        else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c25);
                            }
                        }
                        if (s5 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c26(s3);
                            s0 = s1;
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c21);
            }
        }
        return s0;
    }
    function peg$parsenumberSkeletonId() {
        var s0, s1, s2, s3, s4;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$currPos;
        s3 = peg$currPos;
        peg$silentFails++;
        s4 = peg$parsewhiteSpace();
        if (s4 === peg$FAILED) {
            if (peg$c28.test(input.charAt(peg$currPos))) {
                s4 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c29);
                }
            }
        }
        peg$silentFails--;
        if (s4 === peg$FAILED) {
            s3 = undefined;
        }
        else {
            peg$currPos = s3;
            s3 = peg$FAILED;
        }
        if (s3 !== peg$FAILED) {
            if (input.length > peg$currPos) {
                s4 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c30);
                }
            }
            if (s4 !== peg$FAILED) {
                s3 = [s3, s4];
                s2 = s3;
            }
            else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s2;
            s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
            while (s2 !== peg$FAILED) {
                s1.push(s2);
                s2 = peg$currPos;
                s3 = peg$currPos;
                peg$silentFails++;
                s4 = peg$parsewhiteSpace();
                if (s4 === peg$FAILED) {
                    if (peg$c28.test(input.charAt(peg$currPos))) {
                        s4 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c29);
                        }
                    }
                }
                peg$silentFails--;
                if (s4 === peg$FAILED) {
                    s3 = undefined;
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
                if (s3 !== peg$FAILED) {
                    if (input.length > peg$currPos) {
                        s4 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c30);
                        }
                    }
                    if (s4 !== peg$FAILED) {
                        s3 = [s3, s4];
                        s2 = s3;
                    }
                    else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            }
        }
        else {
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
        }
        else {
            s0 = s1;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c27);
            }
        }
        return s0;
    }
    function peg$parsenumberSkeletonTokenOption() {
        var s0, s1, s2;
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 47) {
            s1 = peg$c32;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c33);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parsenumberSkeletonId();
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c34(s2);
                s0 = s1;
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c31);
            }
        }
        return s0;
    }
    function peg$parsenumberSkeletonToken() {
        var s0, s1, s2, s3, s4;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parse_();
        if (s1 !== peg$FAILED) {
            s2 = peg$parsenumberSkeletonId();
            if (s2 !== peg$FAILED) {
                s3 = [];
                s4 = peg$parsenumberSkeletonTokenOption();
                while (s4 !== peg$FAILED) {
                    s3.push(s4);
                    s4 = peg$parsenumberSkeletonTokenOption();
                }
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c36(s2, s3);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c35);
            }
        }
        return s0;
    }
    function peg$parsenumberSkeleton() {
        var s0, s1, s2;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parsenumberSkeletonToken();
        if (s2 !== peg$FAILED) {
            while (s2 !== peg$FAILED) {
                s1.push(s2);
                s2 = peg$parsenumberSkeletonToken();
            }
        }
        else {
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c37(s1);
        }
        s0 = s1;
        return s0;
    }
    function peg$parsenumberArgStyle() {
        var s0, s1, s2;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c38) {
            s1 = peg$c38;
            peg$currPos += 2;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c39);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parsenumberSkeleton();
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c40(s2);
                s0 = s1;
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            peg$savedPos = peg$currPos;
            s1 = peg$c41();
            if (s1) {
                s1 = undefined;
            }
            else {
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parsemessageText();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c42(s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        return s0;
    }
    function peg$parsenumberFormatElement() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 123) {
            s1 = peg$c22;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c23);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                s3 = peg$parseargNameOrNumber();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parse_();
                    if (s4 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 44) {
                            s5 = peg$c43;
                            peg$currPos++;
                        }
                        else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c44);
                            }
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parse_();
                            if (s6 !== peg$FAILED) {
                                if (input.substr(peg$currPos, 6) === peg$c45) {
                                    s7 = peg$c45;
                                    peg$currPos += 6;
                                }
                                else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c46);
                                    }
                                }
                                if (s7 !== peg$FAILED) {
                                    s8 = peg$parse_();
                                    if (s8 !== peg$FAILED) {
                                        s9 = peg$currPos;
                                        if (input.charCodeAt(peg$currPos) === 44) {
                                            s10 = peg$c43;
                                            peg$currPos++;
                                        }
                                        else {
                                            s10 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                                peg$fail(peg$c44);
                                            }
                                        }
                                        if (s10 !== peg$FAILED) {
                                            s11 = peg$parse_();
                                            if (s11 !== peg$FAILED) {
                                                s12 = peg$parsenumberArgStyle();
                                                if (s12 !== peg$FAILED) {
                                                    s10 = [s10, s11, s12];
                                                    s9 = s10;
                                                }
                                                else {
                                                    peg$currPos = s9;
                                                    s9 = peg$FAILED;
                                                }
                                            }
                                            else {
                                                peg$currPos = s9;
                                                s9 = peg$FAILED;
                                            }
                                        }
                                        else {
                                            peg$currPos = s9;
                                            s9 = peg$FAILED;
                                        }
                                        if (s9 === peg$FAILED) {
                                            s9 = null;
                                        }
                                        if (s9 !== peg$FAILED) {
                                            s10 = peg$parse_();
                                            if (s10 !== peg$FAILED) {
                                                if (input.charCodeAt(peg$currPos) === 125) {
                                                    s11 = peg$c24;
                                                    peg$currPos++;
                                                }
                                                else {
                                                    s11 = peg$FAILED;
                                                    if (peg$silentFails === 0) {
                                                        peg$fail(peg$c25);
                                                    }
                                                }
                                                if (s11 !== peg$FAILED) {
                                                    peg$savedPos = s0;
                                                    s1 = peg$c47(s3, s7, s9);
                                                    s0 = s1;
                                                }
                                                else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                            }
                                            else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                        }
                                        else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    }
                                    else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsedateTimeSkeletonLiteral() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 39) {
            s1 = peg$c48;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c49);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsedoubleApostrophes();
            if (s3 === peg$FAILED) {
                if (peg$c50.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c51);
                    }
                }
            }
            if (s3 !== peg$FAILED) {
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = peg$parsedoubleApostrophes();
                    if (s3 === peg$FAILED) {
                        if (peg$c50.test(input.charAt(peg$currPos))) {
                            s3 = input.charAt(peg$currPos);
                            peg$currPos++;
                        }
                        else {
                            s3 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c51);
                            }
                        }
                    }
                }
            }
            else {
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 39) {
                    s3 = peg$c48;
                    peg$currPos++;
                }
                else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c49);
                    }
                }
                if (s3 !== peg$FAILED) {
                    s1 = [s1, s2, s3];
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = [];
            s1 = peg$parsedoubleApostrophes();
            if (s1 === peg$FAILED) {
                if (peg$c52.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c53);
                    }
                }
            }
            if (s1 !== peg$FAILED) {
                while (s1 !== peg$FAILED) {
                    s0.push(s1);
                    s1 = peg$parsedoubleApostrophes();
                    if (s1 === peg$FAILED) {
                        if (peg$c52.test(input.charAt(peg$currPos))) {
                            s1 = input.charAt(peg$currPos);
                            peg$currPos++;
                        }
                        else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c53);
                            }
                        }
                    }
                }
            }
            else {
                s0 = peg$FAILED;
            }
        }
        return s0;
    }
    function peg$parsedateTimeSkeletonPattern() {
        var s0, s1;
        s0 = [];
        if (peg$c54.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c55);
            }
        }
        if (s1 !== peg$FAILED) {
            while (s1 !== peg$FAILED) {
                s0.push(s1);
                if (peg$c54.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c55);
                    }
                }
            }
        }
        else {
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsedateTimeSkeleton() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = peg$parsedateTimeSkeletonLiteral();
        if (s3 === peg$FAILED) {
            s3 = peg$parsedateTimeSkeletonPattern();
        }
        if (s3 !== peg$FAILED) {
            while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = peg$parsedateTimeSkeletonLiteral();
                if (s3 === peg$FAILED) {
                    s3 = peg$parsedateTimeSkeletonPattern();
                }
            }
        }
        else {
            s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
            s1 = input.substring(s1, peg$currPos);
        }
        else {
            s1 = s2;
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c56(s1);
        }
        s0 = s1;
        return s0;
    }
    function peg$parsedateOrTimeArgStyle() {
        var s0, s1, s2;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c38) {
            s1 = peg$c38;
            peg$currPos += 2;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c39);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parsedateTimeSkeleton();
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c40(s2);
                s0 = s1;
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            peg$savedPos = peg$currPos;
            s1 = peg$c57();
            if (s1) {
                s1 = undefined;
            }
            else {
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parsemessageText();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c42(s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        return s0;
    }
    function peg$parsedateOrTimeFormatElement() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 123) {
            s1 = peg$c22;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c23);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                s3 = peg$parseargNameOrNumber();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parse_();
                    if (s4 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 44) {
                            s5 = peg$c43;
                            peg$currPos++;
                        }
                        else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c44);
                            }
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parse_();
                            if (s6 !== peg$FAILED) {
                                if (input.substr(peg$currPos, 4) === peg$c58) {
                                    s7 = peg$c58;
                                    peg$currPos += 4;
                                }
                                else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c59);
                                    }
                                }
                                if (s7 === peg$FAILED) {
                                    if (input.substr(peg$currPos, 4) === peg$c60) {
                                        s7 = peg$c60;
                                        peg$currPos += 4;
                                    }
                                    else {
                                        s7 = peg$FAILED;
                                        if (peg$silentFails === 0) {
                                            peg$fail(peg$c61);
                                        }
                                    }
                                }
                                if (s7 !== peg$FAILED) {
                                    s8 = peg$parse_();
                                    if (s8 !== peg$FAILED) {
                                        s9 = peg$currPos;
                                        if (input.charCodeAt(peg$currPos) === 44) {
                                            s10 = peg$c43;
                                            peg$currPos++;
                                        }
                                        else {
                                            s10 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                                peg$fail(peg$c44);
                                            }
                                        }
                                        if (s10 !== peg$FAILED) {
                                            s11 = peg$parse_();
                                            if (s11 !== peg$FAILED) {
                                                s12 = peg$parsedateOrTimeArgStyle();
                                                if (s12 !== peg$FAILED) {
                                                    s10 = [s10, s11, s12];
                                                    s9 = s10;
                                                }
                                                else {
                                                    peg$currPos = s9;
                                                    s9 = peg$FAILED;
                                                }
                                            }
                                            else {
                                                peg$currPos = s9;
                                                s9 = peg$FAILED;
                                            }
                                        }
                                        else {
                                            peg$currPos = s9;
                                            s9 = peg$FAILED;
                                        }
                                        if (s9 === peg$FAILED) {
                                            s9 = null;
                                        }
                                        if (s9 !== peg$FAILED) {
                                            s10 = peg$parse_();
                                            if (s10 !== peg$FAILED) {
                                                if (input.charCodeAt(peg$currPos) === 125) {
                                                    s11 = peg$c24;
                                                    peg$currPos++;
                                                }
                                                else {
                                                    s11 = peg$FAILED;
                                                    if (peg$silentFails === 0) {
                                                        peg$fail(peg$c25);
                                                    }
                                                }
                                                if (s11 !== peg$FAILED) {
                                                    peg$savedPos = s0;
                                                    s1 = peg$c47(s3, s7, s9);
                                                    s0 = s1;
                                                }
                                                else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                            }
                                            else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                        }
                                        else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    }
                                    else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsesimpleFormatElement() {
        var s0;
        s0 = peg$parsenumberFormatElement();
        if (s0 === peg$FAILED) {
            s0 = peg$parsedateOrTimeFormatElement();
        }
        return s0;
    }
    function peg$parsepluralElement() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 123) {
            s1 = peg$c22;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c23);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                s3 = peg$parseargNameOrNumber();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parse_();
                    if (s4 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 44) {
                            s5 = peg$c43;
                            peg$currPos++;
                        }
                        else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c44);
                            }
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parse_();
                            if (s6 !== peg$FAILED) {
                                if (input.substr(peg$currPos, 6) === peg$c62) {
                                    s7 = peg$c62;
                                    peg$currPos += 6;
                                }
                                else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c63);
                                    }
                                }
                                if (s7 === peg$FAILED) {
                                    if (input.substr(peg$currPos, 13) === peg$c64) {
                                        s7 = peg$c64;
                                        peg$currPos += 13;
                                    }
                                    else {
                                        s7 = peg$FAILED;
                                        if (peg$silentFails === 0) {
                                            peg$fail(peg$c65);
                                        }
                                    }
                                }
                                if (s7 !== peg$FAILED) {
                                    s8 = peg$parse_();
                                    if (s8 !== peg$FAILED) {
                                        if (input.charCodeAt(peg$currPos) === 44) {
                                            s9 = peg$c43;
                                            peg$currPos++;
                                        }
                                        else {
                                            s9 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                                peg$fail(peg$c44);
                                            }
                                        }
                                        if (s9 !== peg$FAILED) {
                                            s10 = peg$parse_();
                                            if (s10 !== peg$FAILED) {
                                                s11 = peg$currPos;
                                                if (input.substr(peg$currPos, 7) === peg$c66) {
                                                    s12 = peg$c66;
                                                    peg$currPos += 7;
                                                }
                                                else {
                                                    s12 = peg$FAILED;
                                                    if (peg$silentFails === 0) {
                                                        peg$fail(peg$c67);
                                                    }
                                                }
                                                if (s12 !== peg$FAILED) {
                                                    s13 = peg$parse_();
                                                    if (s13 !== peg$FAILED) {
                                                        s14 = peg$parsenumber();
                                                        if (s14 !== peg$FAILED) {
                                                            s12 = [s12, s13, s14];
                                                            s11 = s12;
                                                        }
                                                        else {
                                                            peg$currPos = s11;
                                                            s11 = peg$FAILED;
                                                        }
                                                    }
                                                    else {
                                                        peg$currPos = s11;
                                                        s11 = peg$FAILED;
                                                    }
                                                }
                                                else {
                                                    peg$currPos = s11;
                                                    s11 = peg$FAILED;
                                                }
                                                if (s11 === peg$FAILED) {
                                                    s11 = null;
                                                }
                                                if (s11 !== peg$FAILED) {
                                                    s12 = peg$parse_();
                                                    if (s12 !== peg$FAILED) {
                                                        s13 = [];
                                                        s14 = peg$parsepluralOption();
                                                        if (s14 !== peg$FAILED) {
                                                            while (s14 !== peg$FAILED) {
                                                                s13.push(s14);
                                                                s14 = peg$parsepluralOption();
                                                            }
                                                        }
                                                        else {
                                                            s13 = peg$FAILED;
                                                        }
                                                        if (s13 !== peg$FAILED) {
                                                            s14 = peg$parse_();
                                                            if (s14 !== peg$FAILED) {
                                                                if (input.charCodeAt(peg$currPos) === 125) {
                                                                    s15 = peg$c24;
                                                                    peg$currPos++;
                                                                }
                                                                else {
                                                                    s15 = peg$FAILED;
                                                                    if (peg$silentFails === 0) {
                                                                        peg$fail(peg$c25);
                                                                    }
                                                                }
                                                                if (s15 !== peg$FAILED) {
                                                                    peg$savedPos = s0;
                                                                    s1 = peg$c68(s3, s7, s11, s13);
                                                                    s0 = s1;
                                                                }
                                                                else {
                                                                    peg$currPos = s0;
                                                                    s0 = peg$FAILED;
                                                                }
                                                            }
                                                            else {
                                                                peg$currPos = s0;
                                                                s0 = peg$FAILED;
                                                            }
                                                        }
                                                        else {
                                                            peg$currPos = s0;
                                                            s0 = peg$FAILED;
                                                        }
                                                    }
                                                    else {
                                                        peg$currPos = s0;
                                                        s0 = peg$FAILED;
                                                    }
                                                }
                                                else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                            }
                                            else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                        }
                                        else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    }
                                    else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseselectElement() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 123) {
            s1 = peg$c22;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c23);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                s3 = peg$parseargNameOrNumber();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parse_();
                    if (s4 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 44) {
                            s5 = peg$c43;
                            peg$currPos++;
                        }
                        else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c44);
                            }
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parse_();
                            if (s6 !== peg$FAILED) {
                                if (input.substr(peg$currPos, 6) === peg$c69) {
                                    s7 = peg$c69;
                                    peg$currPos += 6;
                                }
                                else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c70);
                                    }
                                }
                                if (s7 !== peg$FAILED) {
                                    s8 = peg$parse_();
                                    if (s8 !== peg$FAILED) {
                                        if (input.charCodeAt(peg$currPos) === 44) {
                                            s9 = peg$c43;
                                            peg$currPos++;
                                        }
                                        else {
                                            s9 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                                peg$fail(peg$c44);
                                            }
                                        }
                                        if (s9 !== peg$FAILED) {
                                            s10 = peg$parse_();
                                            if (s10 !== peg$FAILED) {
                                                s11 = [];
                                                s12 = peg$parseselectOption();
                                                if (s12 !== peg$FAILED) {
                                                    while (s12 !== peg$FAILED) {
                                                        s11.push(s12);
                                                        s12 = peg$parseselectOption();
                                                    }
                                                }
                                                else {
                                                    s11 = peg$FAILED;
                                                }
                                                if (s11 !== peg$FAILED) {
                                                    s12 = peg$parse_();
                                                    if (s12 !== peg$FAILED) {
                                                        if (input.charCodeAt(peg$currPos) === 125) {
                                                            s13 = peg$c24;
                                                            peg$currPos++;
                                                        }
                                                        else {
                                                            s13 = peg$FAILED;
                                                            if (peg$silentFails === 0) {
                                                                peg$fail(peg$c25);
                                                            }
                                                        }
                                                        if (s13 !== peg$FAILED) {
                                                            peg$savedPos = s0;
                                                            s1 = peg$c71(s3, s11);
                                                            s0 = s1;
                                                        }
                                                        else {
                                                            peg$currPos = s0;
                                                            s0 = peg$FAILED;
                                                        }
                                                    }
                                                    else {
                                                        peg$currPos = s0;
                                                        s0 = peg$FAILED;
                                                    }
                                                }
                                                else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                            }
                                            else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                        }
                                        else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    }
                                    else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsepluralRuleSelectValue() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 61) {
            s2 = peg$c72;
            peg$currPos++;
        }
        else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c73);
            }
        }
        if (s2 !== peg$FAILED) {
            s3 = peg$parsenumber();
            if (s3 !== peg$FAILED) {
                s2 = [s2, s3];
                s1 = s2;
            }
            else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
        }
        else {
            s0 = s1;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$parseargName();
        }
        return s0;
    }
    function peg$parseselectOption() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        s1 = peg$parse_();
        if (s1 !== peg$FAILED) {
            s2 = peg$parseargName();
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (s3 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 123) {
                        s4 = peg$c22;
                        peg$currPos++;
                    }
                    else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c23);
                        }
                    }
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = peg$currPos;
                        s5 = peg$c74(s2);
                        if (s5) {
                            s5 = undefined;
                        }
                        else {
                            s5 = peg$FAILED;
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parsemessage();
                            if (s6 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 125) {
                                    s7 = peg$c24;
                                    peg$currPos++;
                                }
                                else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c25);
                                    }
                                }
                                if (s7 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c75(s2, s6);
                                    s0 = s1;
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsepluralOption() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        s1 = peg$parse_();
        if (s1 !== peg$FAILED) {
            s2 = peg$parsepluralRuleSelectValue();
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (s3 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 123) {
                        s4 = peg$c22;
                        peg$currPos++;
                    }
                    else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c23);
                        }
                    }
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = peg$currPos;
                        s5 = peg$c76(s2);
                        if (s5) {
                            s5 = undefined;
                        }
                        else {
                            s5 = peg$FAILED;
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parsemessage();
                            if (s6 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 125) {
                                    s7 = peg$c24;
                                    peg$currPos++;
                                }
                                else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c25);
                                    }
                                }
                                if (s7 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c77(s2, s6);
                                    s0 = s1;
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsewhiteSpace() {
        var s0, s1;
        peg$silentFails++;
        if (peg$c79.test(input.charAt(peg$currPos))) {
            s0 = input.charAt(peg$currPos);
            peg$currPos++;
        }
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c80);
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c78);
            }
        }
        return s0;
    }
    function peg$parsepatternSyntax() {
        var s0, s1;
        peg$silentFails++;
        if (peg$c82.test(input.charAt(peg$currPos))) {
            s0 = input.charAt(peg$currPos);
            peg$currPos++;
        }
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c83);
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c81);
            }
        }
        return s0;
    }
    function peg$parse_() {
        var s0, s1, s2;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parsewhiteSpace();
        while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parsewhiteSpace();
        }
        if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
        }
        else {
            s0 = s1;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c84);
            }
        }
        return s0;
    }
    function peg$parsenumber() {
        var s0, s1, s2;
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 45) {
            s1 = peg$c86;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c87);
            }
        }
        if (s1 === peg$FAILED) {
            s1 = null;
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parseargNumber();
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c88(s1, s2);
                s0 = s1;
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c85);
            }
        }
        return s0;
    }
    function peg$parseapostrophe() {
        var s0, s1;
        peg$silentFails++;
        if (input.charCodeAt(peg$currPos) === 39) {
            s0 = peg$c48;
            peg$currPos++;
        }
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c49);
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c89);
            }
        }
        return s0;
    }
    function peg$parsedoubleApostrophes() {
        var s0, s1;
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c91) {
            s1 = peg$c91;
            peg$currPos += 2;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c92);
            }
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c93();
        }
        s0 = s1;
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c90);
            }
        }
        return s0;
    }
    function peg$parsequotedString() {
        var s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 39) {
            s1 = peg$c48;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c49);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parseescapedChar();
            if (s2 !== peg$FAILED) {
                s3 = peg$currPos;
                s4 = [];
                if (input.substr(peg$currPos, 2) === peg$c91) {
                    s5 = peg$c91;
                    peg$currPos += 2;
                }
                else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c92);
                    }
                }
                if (s5 === peg$FAILED) {
                    if (peg$c50.test(input.charAt(peg$currPos))) {
                        s5 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c51);
                        }
                    }
                }
                while (s5 !== peg$FAILED) {
                    s4.push(s5);
                    if (input.substr(peg$currPos, 2) === peg$c91) {
                        s5 = peg$c91;
                        peg$currPos += 2;
                    }
                    else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c92);
                        }
                    }
                    if (s5 === peg$FAILED) {
                        if (peg$c50.test(input.charAt(peg$currPos))) {
                            s5 = input.charAt(peg$currPos);
                            peg$currPos++;
                        }
                        else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c51);
                            }
                        }
                    }
                }
                if (s4 !== peg$FAILED) {
                    s3 = input.substring(s3, peg$currPos);
                }
                else {
                    s3 = s4;
                }
                if (s3 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 39) {
                        s4 = peg$c48;
                        peg$currPos++;
                    }
                    else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c49);
                        }
                    }
                    if (s4 === peg$FAILED) {
                        s4 = null;
                    }
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c94(s2, s3);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseunquotedString() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        if (input.length > peg$currPos) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
        }
        else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c30);
            }
        }
        if (s2 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s3 = peg$c95(s2);
            if (s3) {
                s3 = undefined;
            }
            else {
                s3 = peg$FAILED;
            }
            if (s3 !== peg$FAILED) {
                s2 = [s2, s3];
                s1 = s2;
            }
            else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        if (s1 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 10) {
                s1 = peg$c96;
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c97);
                }
            }
        }
        if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
        }
        else {
            s0 = s1;
        }
        return s0;
    }
    function peg$parseescapedChar() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        if (input.length > peg$currPos) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
        }
        else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c30);
            }
        }
        if (s2 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s3 = peg$c98(s2);
            if (s3) {
                s3 = undefined;
            }
            else {
                s3 = peg$FAILED;
            }
            if (s3 !== peg$FAILED) {
                s2 = [s2, s3];
                s1 = s2;
            }
            else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
        }
        else {
            s0 = s1;
        }
        return s0;
    }
    function peg$parseargNameOrNumber() {
        var s0, s1;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parseargNumber();
        if (s1 === peg$FAILED) {
            s1 = peg$parseargName();
        }
        if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
        }
        else {
            s0 = s1;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c99);
            }
        }
        return s0;
    }
    function peg$parsevalidTag() {
        var s0, s1;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parseargNumber();
        if (s1 === peg$FAILED) {
            s1 = peg$parsetagName();
        }
        if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
        }
        else {
            s0 = s1;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c100);
            }
        }
        return s0;
    }
    function peg$parseargNumber() {
        var s0, s1, s2, s3, s4;
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 48) {
            s1 = peg$c102;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c103);
            }
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c104();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$currPos;
            if (peg$c105.test(input.charAt(peg$currPos))) {
                s2 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c106);
                }
            }
            if (s2 !== peg$FAILED) {
                s3 = [];
                if (peg$c107.test(input.charAt(peg$currPos))) {
                    s4 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c108);
                    }
                }
                while (s4 !== peg$FAILED) {
                    s3.push(s4);
                    if (peg$c107.test(input.charAt(peg$currPos))) {
                        s4 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c108);
                        }
                    }
                }
                if (s3 !== peg$FAILED) {
                    s2 = [s2, s3];
                    s1 = s2;
                }
                else {
                    peg$currPos = s1;
                    s1 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c109(s1);
            }
            s0 = s1;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c101);
            }
        }
        return s0;
    }
    function peg$parseargName() {
        var s0, s1, s2, s3, s4;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$currPos;
        s3 = peg$currPos;
        peg$silentFails++;
        s4 = peg$parsewhiteSpace();
        if (s4 === peg$FAILED) {
            s4 = peg$parsepatternSyntax();
        }
        peg$silentFails--;
        if (s4 === peg$FAILED) {
            s3 = undefined;
        }
        else {
            peg$currPos = s3;
            s3 = peg$FAILED;
        }
        if (s3 !== peg$FAILED) {
            if (input.length > peg$currPos) {
                s4 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c30);
                }
            }
            if (s4 !== peg$FAILED) {
                s3 = [s3, s4];
                s2 = s3;
            }
            else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s2;
            s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
            while (s2 !== peg$FAILED) {
                s1.push(s2);
                s2 = peg$currPos;
                s3 = peg$currPos;
                peg$silentFails++;
                s4 = peg$parsewhiteSpace();
                if (s4 === peg$FAILED) {
                    s4 = peg$parsepatternSyntax();
                }
                peg$silentFails--;
                if (s4 === peg$FAILED) {
                    s3 = undefined;
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
                if (s3 !== peg$FAILED) {
                    if (input.length > peg$currPos) {
                        s4 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c30);
                        }
                    }
                    if (s4 !== peg$FAILED) {
                        s3 = [s3, s4];
                        s2 = s3;
                    }
                    else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            }
        }
        else {
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
        }
        else {
            s0 = s1;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c110);
            }
        }
        return s0;
    }
    function peg$parsetagName() {
        var s0, s1, s2, s3, s4;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = [];
        if (input.charCodeAt(peg$currPos) === 45) {
            s2 = peg$c86;
            peg$currPos++;
        }
        else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c87);
            }
        }
        if (s2 === peg$FAILED) {
            s2 = peg$currPos;
            s3 = peg$currPos;
            peg$silentFails++;
            s4 = peg$parsewhiteSpace();
            if (s4 === peg$FAILED) {
                s4 = peg$parsepatternSyntax();
            }
            peg$silentFails--;
            if (s4 === peg$FAILED) {
                s3 = undefined;
            }
            else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            if (s3 !== peg$FAILED) {
                if (input.length > peg$currPos) {
                    s4 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c30);
                    }
                }
                if (s4 !== peg$FAILED) {
                    s3 = [s3, s4];
                    s2 = s3;
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
        }
        if (s2 !== peg$FAILED) {
            while (s2 !== peg$FAILED) {
                s1.push(s2);
                if (input.charCodeAt(peg$currPos) === 45) {
                    s2 = peg$c86;
                    peg$currPos++;
                }
                else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c87);
                    }
                }
                if (s2 === peg$FAILED) {
                    s2 = peg$currPos;
                    s3 = peg$currPos;
                    peg$silentFails++;
                    s4 = peg$parsewhiteSpace();
                    if (s4 === peg$FAILED) {
                        s4 = peg$parsepatternSyntax();
                    }
                    peg$silentFails--;
                    if (s4 === peg$FAILED) {
                        s3 = undefined;
                    }
                    else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                    if (s3 !== peg$FAILED) {
                        if (input.length > peg$currPos) {
                            s4 = input.charAt(peg$currPos);
                            peg$currPos++;
                        }
                        else {
                            s4 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c30);
                            }
                        }
                        if (s4 !== peg$FAILED) {
                            s3 = [s3, s4];
                            s2 = s3;
                        }
                        else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                }
            }
        }
        else {
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
        }
        else {
            s0 = s1;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c111);
            }
        }
        return s0;
    }
    var messageCtx = ['root'];
    function isNestedMessageText() {
        return messageCtx.length > 1;
    }
    function isInPluralOption() {
        return messageCtx[messageCtx.length - 1] === 'plural';
    }
    function insertLocation() {
        return options && options.captureLocation ? {
            location: location()
        } : {};
    }
    var ignoreTag = options && options.ignoreTag;
    var shouldParseSkeleton = options && options.shouldParseSkeleton;
    peg$result = peg$startRuleFunction();
    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
        return peg$result;
    }
    else {
        if (peg$result !== peg$FAILED && peg$currPos < input.length) {
            peg$fail(peg$endExpectation());
        }
        throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length
            ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
            : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
    }
}
var pegParse = peg$parse;


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TYPE; });
/* unused harmony export SKELETON_TYPE */
/* harmony export (immutable) */ __webpack_exports__["e"] = isLiteralElement;
/* harmony export (immutable) */ __webpack_exports__["b"] = isArgumentElement;
/* harmony export (immutable) */ __webpack_exports__["f"] = isNumberElement;
/* harmony export (immutable) */ __webpack_exports__["c"] = isDateElement;
/* harmony export (immutable) */ __webpack_exports__["l"] = isTimeElement;
/* harmony export (immutable) */ __webpack_exports__["j"] = isSelectElement;
/* harmony export (immutable) */ __webpack_exports__["h"] = isPluralElement;
/* harmony export (immutable) */ __webpack_exports__["i"] = isPoundElement;
/* harmony export (immutable) */ __webpack_exports__["k"] = isTagElement;
/* harmony export (immutable) */ __webpack_exports__["g"] = isNumberSkeleton;
/* harmony export (immutable) */ __webpack_exports__["d"] = isDateTimeSkeleton;
/* unused harmony export createLiteralElement */
/* unused harmony export createNumberElement */
var TYPE;
(function (TYPE) {
    /**
     * Raw text
     */
    TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */
    TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */
    TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */
    TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */
    TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */
    TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */
    TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */
    TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */
    TYPE[TYPE["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function (SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
/**
 * Type Guards
 */
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
function isNumberElement(el) {
    return el.type === TYPE.number;
}
function isDateElement(el) {
    return el.type === TYPE.date;
}
function isTimeElement(el) {
    return el.type === TYPE.time;
}
function isSelectElement(el) {
    return el.type === TYPE.select;
}
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
function isTagElement(el) {
    return el.type === TYPE.tag;
}
function isNumberSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === 0 /* number */);
}
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === 1 /* dateTime */);
}
function createLiteralElement(value) {
    return {
        type: TYPE.literal,
        value: value,
    };
}
function createNumberElement(value, style) {
    return {
        type: TYPE.number,
        value: value,
        style: style,
    };
}


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(13);
var normalizeHeaderName = __webpack_require__(386);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(196);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(196);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getSVGandColors */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canPaste; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return sortGroupEle; });
/* unused harmony export arraysEqual */
/* unused harmony export removeSelection */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return preloadTextFonts; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ErrorLogService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_app_json__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var createRange=function createRange(node,chars,range){if(!range){range=document.createRange();range.selectNode(node);range.setStart(node,0);}if(chars.count===0){range.setEnd(node,chars.count);}else if(node&&chars.count>0){if(node.nodeType===Node.TEXT_NODE){if(node.textContent.length<chars.count){chars.count-=node.textContent.length;}else{range.setEnd(node,chars.count);chars.count=0;}}else{for(var lp=0;lp<node.childNodes.length;lp++){range=createRange(node.childNodes[lp],chars,range);if(chars.count===0){break;}}}}return range;};var getSVGandColors=function getSVGandColors(svgEle){try{var tempDiv=document.createElement('div'),colorObj={},countObj={},count=1,classTo='',finalCount=0,colorObjToReturn={};tempDiv.innerHTML=svgEle;svgEle=tempDiv.children[0];var proceed=true;svgEle.childNodes.forEach(function(ele,idx){if(ele.getAttribute&&ele.getAttribute('fill')&&!ele.getAttribute('fill').includes('url')&&colorObj.hasOwnProperty(ele.getAttribute('fill'))){classTo=colorObj[ele.getAttribute('fill')].class;ele.setAttribute('class',classTo);countObj[classTo]['count']+=1;}else if(ele.getAttribute&&ele.getAttribute('fill')&&!ele.getAttribute('fill').includes('url')){classTo='prop'+count;colorObj[ele.getAttribute('fill')]={idx:idx,class:classTo};ele.setAttribute('class',classTo);countObj[classTo]={'count':1,color:ele.getAttribute('fill')};colorObjToReturn[classTo]=ele.getAttribute('fill');finalCount=count;count++;}else if(ele.getAttribute&&(ele.getAttribute('fill')&&ele.getAttribute('fill').includes('url')||!ele.getAttribute('fill'))){proceed=false;}});if(proceed&&finalCount&&finalCount>7){for(var key in countObj){if(countObj[key]['count']===1){if(finalCount<=7){break;}else{svgEle.querySelector('.'+colorObj[countObj[key]['color']].class).removeAttribute('class');finalCount-=1;delete colorObjToReturn[key];}}}}if(proceed&&finalCount){var _ret=function(){var propCount=1,objIdx=Object.keys(colorObjToReturn);for(var i=0;i<objIdx.length;i++){if(parseInt(objIdx[i].split('prop')[1])!==propCount){colorObjToReturn['prop'+propCount]=colorObjToReturn[objIdx[i]];delete colorObjToReturn[objIdx[i]];svgEle.querySelectorAll('.'+objIdx[i]).forEach(function(ele){ele.setAttribute('class','prop'+propCount);});}propCount++;}return{v:{'svgEle':svgEle,'colorObj':colorObjToReturn}};}();if((typeof _ret==='undefined'?'undefined':_typeof(_ret))==="object")return _ret.v;}if(!Object.keys(colorObjToReturn).length){var _ret2=function(){var classObj={},valArr=[],objToReturn={},styleAttr=void 0;svgEle.querySelectorAll('g').forEach(function(ele){var eleChild=ele.children;for(var _key=0;_key<eleChild.length;_key++){if(eleChild[_key].nodeName!=='g'){if(eleChild[_key].getAttribute('style')&&(eleChild[_key].getAttribute('style').includes('fill')||eleChild[_key].getAttribute('style').includes('stroke'))){var re=/(fill|stroke):([^:]+)(;|;})/g,res=re.exec(eleChild[_key].getAttribute('style'));if(!res[2].includes('url')){if(valArr.indexOf(res[2])===-1){valArr.push(res[2]);var _classTo='prop'+(_key+1);if(valArr.length&&Object.keys(classObj).length){_classTo='prop'+(parseInt(classObj[valArr[valArr.length-1]].split('prop')[1])+1);}classObj[res[2]]=_classTo;if(eleChild[_key].getAttribute('class')){eleChild[_key].classList.add(_classTo);eleChild[_key].setAttribute(res[1],res[2]);}else{eleChild[_key].setAttribute('class',_classTo);eleChild[_key].setAttribute(res[1],res[2]);}}else{if(eleChild[_key].getAttribute('class')){eleChild[_key].classList.add(classObj[res[2]]);eleChild[_key].setAttribute(res[1],res[2]);}else{eleChild[_key].setAttribute('class',classObj[res[2]]);eleChild[_key].setAttribute(res[1],res[2]);}}if(styleAttr){styleAttr=styleAttr.replace(res[1]+':'+res[2]+';','');}else{styleAttr=eleChild[_key].getAttribute('style').replace(res[1]+':'+res[2]+';','');}eleChild[_key].setAttribute('style',styleAttr);eleChild[_key].getAttribute('style');}else{proceed=false;}}else{if(!svgEle.querySelector('defs > style')){if(!eleChild[_key].getAttribute('class')&&!eleChild[_key].getAttribute('fill')){eleChild[_key].setAttribute('fill','black');eleChild[_key].setAttribute('class','prop1');if(!objToReturn['prop1'])objToReturn['prop1']='black';}else{proceed=false;}}}}}});if(valArr.length){Object.keys(classObj).forEach(function(val){objToReturn[classObj[val]]=val;});}if(svgEle.querySelector('defs > style')&&!Object.keys(objToReturn).length){(function(){var styStr=svgEle.querySelector('defs > style').innerHTML,regEx=/\s*([^[}]+)(stroke|fill):([^:]+)(;|;})/g;var reArr=void 0;if(styStr){proceed=true;do{reArr=regEx.exec(styStr);if(reArr){var classes=reArr[1].substring(0,reArr[1].length-1);classes=classes.split(',');classes.forEach(function(cls){var clsNo=cls.charAt(cls.length-1);svgEle.querySelectorAll(cls).forEach(function(ele){if(reArr[2]==='stroke'){if(!ele.classList.contains('prop'+clsNo)){ele.classList.add('prop'+clsNo);}if(!ele.classList.contains('applyStroke')){ele.classList.add('applyStroke');}}else{if(!ele.classList.contains('prop'+clsNo))ele.classList.add('prop'+clsNo);}});if(reArr[3]!=='none'){classObj['prop'+clsNo]=reArr[3];valArr.push(reArr[3]);}});}}while(reArr);}else{proceed=false;}objToReturn=classObj;})();}else if(!Object.keys(objToReturn).length){proceed=false;}if(!proceed){return{v:false};}else{return{v:{svgEle:svgEle,colorObj:objToReturn}};}}();if((typeof _ret2==='undefined'?'undefined':_typeof(_ret2))==="object")return _ret2.v;}}catch(err){Object(__WEBPACK_IMPORTED_MODULE_1__helpers_ErrorLogService__["a" /* errorlog */])('Error in getSVGandColors ',err,"utilityMethod-getSVGandColors ");return null;}};var canPaste=function canPaste(pastedData){try{var isInProcess=false;if(pastedData.dataType==='SCENES'){for(var idx=0;idx<pastedData.data.length;idx++){var wrkspcItems=pastedData.data[idx].workspaceItems,wrkspcChildren=pastedData.data[idx].workspaceChildren,wrkspcBG=pastedData.data[idx].workspaceBG;if(wrkspcItems.length){for(var wii=0;wii<wrkspcItems.length;wii++){if(wrkspcItems[wii].isBlob){isInProcess=true;break;}}}if(isInProcess){break;}if(wrkspcChildren.length){for(var wci=0;wci<wrkspcChildren.length;wci++){if(wrkspcChildren[wci].isBlob){isInProcess=true;break;}}}if(isInProcess){break;}if(wrkspcBG){if(wrkspcBG.isBlob){isInProcess=true;break;}}}}else{var _wrkspcItems=pastedData.data.workspaceItems;for(var i=0;i<_wrkspcItems.length;i++){if(_wrkspcItems[i].isBlob){isInProcess=true;break;}}var wrkspcChild=pastedData.data.workspaceChildren;var wrkCKeys=Object.keys(wrkspcChild);if(wrkCKeys.length){for(var wck=0;wck<wrkCKeys.length;wck++){if(wrkspcChild[wrkCKeys[wck]].isBlob){isInProcess=true;break;}}}}return isInProcess;}catch(err){Object(__WEBPACK_IMPORTED_MODULE_1__helpers_ErrorLogService__["a" /* errorlog */])('Error in canPaste ',err,"utilityMethod-canPaste");}};var sortGroupEle=function sortGroupEle(preData,isAddAll){try{var revisedData=preData;if(!isAddAll){var wrkItems=revisedData.get('workspaceItems');wrkItems.map(function(data,key){var grpChlds=data.get('groupChildren'),allChildren=void 0;if(grpChlds){grpChlds=data.get('groupChildren').toJS();allChildren=revisedData.get('workspaceChildren');allChildren=allChildren.sortBy(function(value,key){return value.get('index');});var upList=[];allChildren.map(function(cData,aKey){if(grpChlds.indexOf(aKey)!==-1){upList.push(aKey);}});revisedData=revisedData.setIn(['workspaceItems',key,'groupChildren'],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(upList));}});}else{var sceneData=revisedData.getIn(["project","scenes"]);sceneData.entrySeq().forEach(function(_ref){var _ref2=_slicedToArray(_ref,2),sceneNum=_ref2[0],sceneVal=_ref2[1];var wrkItems=sceneVal.get('workspaceItems');wrkItems.map(function(data,key){var grpChlds=data.get('groupChildren'),allChildren=void 0;if(grpChlds){grpChlds=data.get('groupChildren').toJS();allChildren=sceneVal.get('workspaceChildren');allChildren=allChildren.sortBy(function(value,key){return value.get('index');});var upList=[];allChildren.map(function(cData,aKey){if(grpChlds.indexOf(aKey)!==-1){upList.push(aKey);}});revisedData=revisedData.setIn(['project','scenes',sceneNum,'workspaceItems',key,'groupChildren'],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(upList));}});});}return revisedData;}catch(err){Object(__WEBPACK_IMPORTED_MODULE_1__helpers_ErrorLogService__["a" /* errorlog */])('Error in sortGroupEle ',err,"utilityMethod-sortGroupEle");}};var arraysEqual=function arraysEqual(a,b){if(a===b)return true;if(a==null||b==null)return false;if(a.length!==b.length)return false;for(var i=0;i<a.length;++i){if(a[i]!==b[i])return false;}return true;};var removeSelection=function removeSelection(){try{if(window.getSelection){if(window.getSelection().empty){// Chrome
window.getSelection().empty();}else if(window.getSelection().removeAllRanges){// Firefox
window.getSelection().removeAllRanges();}}else if(document.selection){// IE?
document.selection.empty();}}catch(er){Object(__WEBPACK_IMPORTED_MODULE_1__helpers_ErrorLogService__["a" /* errorlog */])("Error in removeSelection ",er,"utilityMethod");}};var preloadTextFonts=function preloadTextFonts(htmlText){var assetUrl=__WEBPACK_IMPORTED_MODULE_2__config_app_json___default.a['ASSETS'][__WEBPACK_IMPORTED_MODULE_2__config_app_json___default.a['ASSETS']['current']];var userFontUrl=__WEBPACK_IMPORTED_MODULE_2__config_app_json___default.a.UPLOADS["font_src"];var textElement=document.createElement('div');textElement.innerHTML=htmlText;var partialFontArr=[];textElement.querySelectorAll('[data-ff]').forEach(function(node){var url="";if(node.getAttribute("data-uf")==="true"&&node.getAttribute("data-src")){url=node.getAttribute("data-src").includes(userFontUrl)?node.getAttribute('data-src'):''+userFontUrl+node.getAttribute('data-src');}else if(node.getAttribute("data-uf")!=="true"){url=assetUrl+'animaker/admin-fonts/'+node.getAttribute('data-ff')+'.css';}if(url.length>0){partialFontArr.push({font:node.getAttribute("data-ff"),load:node.style.fontFamily,byUser:node.getAttribute("data-uf"),isLoaded:false,url:url,isPartialFont:true});}});textElement.querySelectorAll('font').forEach(function(node){var url="";if(node.getAttribute("data-uf")==="true"&&node.getAttribute("data-src")&&node.getAttribute('face')){url=node.getAttribute("data-src").includes(userFontUrl)?node.getAttribute('data-src'):''+userFontUrl+node.getAttribute('data-src');}else if(node.getAttribute("data-uf")!=="true"&&node.getAttribute('face')){url=assetUrl+'animaker/admin-fonts/'+node.getAttribute('face').split('-')[0]+'.css';}if(url.length>0){partialFontArr.push({font:node.getAttribute('face').split('-')[0],load:node.getAttribute('face'),byUser:false,isLoaded:false,url:url,isPartialFont:true});}});return partialFontArr;};

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ReturnSvgFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function ReturnSvgFilter(props){var filters=props.filterCode;var filterItem=[];var tintFilter=void 0;var brightness=0;var contrast=0;var hue=0;var saturate=0;var tint=0;var blur=0;var vignette=0;if(filters!==null&&filters!==undefined){brightness=parseInt(filters.substr(0,2),16)-100;contrast=parseInt(filters.substr(2,2),16)-100;hue=parseInt(filters.substr(4,2),16)-100;saturate=parseInt(filters.substr(6,2),16)-100;tint=parseInt(filters.substr(8,2),16)-100;blur=parseInt(filters.substr(10,2),16)-100;vignette=parseInt(filters.substr(12,2),16);}if(brightness!==0){filterItem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComponentTransfer",{key:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncR",{type:"linear",id:"RbrightnessSVG",slope:1,intercept:brightness/200}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncG",{type:"linear",id:"GbrightnessSVG",slope:1,intercept:brightness/200}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncB",{type:"linear",id:"BbrightnessSVG",slope:1,intercept:brightness/200})));}else{filterItem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComponentTransfer",{key:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncR",{type:"linear",id:"RbrightnessSVG"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncG",{type:"linear",id:"GbrightnessSVG"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncB",{type:"linear",id:"BbrightnessSVG"})));}if(contrast!==0){filterItem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComponentTransfer",{key:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncR",{type:"linear",id:"RcontrastSVG",slope:contrast<0?(contrast+100)*0.006+0.4:contrast*1.5/100+1,intercept:contrast>0?-(contrast*75/100/100):-(contrast*30/100)/100}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncG",{type:"linear",id:"GcontrastSVG",slope:contrast<0?(contrast+100)*0.006+0.4:contrast*1.5/100+1,intercept:contrast>0?-(contrast*75/100/100):-(contrast*30/100)/100}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncB",{type:"linear",id:"BcontrastSVG",slope:contrast<0?(contrast+100)*0.006+0.4:contrast*1.5/100+1,intercept:contrast>0?-(contrast*75/100/100):-(contrast*30/100)/100})));}else{filterItem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComponentTransfer",{key:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncR",{type:"linear",id:"RcontrastSVG"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncG",{type:"linear",id:"GcontrastSVG"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncB",{type:"linear",id:"BcontrastSVG"})));}if(hue!==0){filterItem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feColorMatrix",{key:3,type:"hueRotate",id:"HueSVG",values:hue}));}else{filterItem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feColorMatrix",{key:3,type:"hueRotate",id:"HueSVG"}));}if(saturate!==0){var filterValue=[(saturate+100)*(1.6914-0.3086)/200+0.3086,(saturate+100)*(-0.6094-0.6094)/200+0.6094,(saturate+100)*(-0.082-0.082)/200+0.082,0,0,(saturate+100)*(-0.3086-0.3086)/200+0.3086,(saturate+100)*(1.3906-0.6094)/200+0.6094,(saturate+100)*(-0.082-0.082)/200+0.082,0,0,(saturate+100)*(-0.3086-0.3086)/200+0.3086,(saturate+100)*(-0.6094-0.6094)/200+0.6094,(saturate+100)*(1.918-0.082)/200+0.082,0,0,0,0,0,1,0].join(',');filterItem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feColorMatrix",{key:4,type:"matrix",id:"saturateSVG",values:filterValue}));}else{filterItem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feColorMatrix",{key:4,type:"matrix",id:"saturateSVG"}));}if(tint!==0){if(tint>0&&tint<=33){tintFilter=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComponentTransfer",{id:"tintSVG"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncR",{type:"linear",id:"RtintSVG",slope:0.9,intercept:0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncG",{type:"linear",id:"GtintSVG",slope:0.9,intercept:0.1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncB",{type:"linear",id:"BtintSVG",slope:0.9,intercept:tint/330}));}else if(tint>33&&tint<66){tintFilter=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComponentTransfer",{id:"tintSVG"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncR",{type:"linear",id:"RtintSVG",slope:0.9,intercept:0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncG",{type:"linear",id:"GtintSVG",slope:0.9,intercept:(33-tint%33)/330}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncB",{type:"linear",id:"BtintSVG",slope:0.9,intercept:0.1}));}else if(tint>=66){tintFilter=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComponentTransfer",{id:"tintSVG"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncR",{type:"linear",id:"RtintSVG",slope:0.9,intercept:(tint-66)/330}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncG",{type:"linear",id:"GtintSVG",slope:0.9,intercept:0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncB",{type:"linear",id:"BtintSVG",slope:0.9,intercept:0.1}));}else if(tint<0&&tint>=-33){tintFilter=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComponentTransfer",{id:"tintSVG"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncR",{type:"linear",id:"RtintSVG",slope:0.9,intercept:-(tint/330)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncG",{type:"linear",id:"GtintSVG",slope:0.9,intercept:0.1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncB",{type:"linear",id:"BtintSVG",slope:0.9,intercept:0}));}else if(tint<-33&&tint>-66){tintFilter=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComponentTransfer",{id:"tintSVG"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncR",{type:"linear",id:"RtintSVG",slope:0.9,intercept:0.1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncG",{type:"linear",id:"GtintSVG",slope:0.9,intercept:(33- -tint%33)/330}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncB",{type:"linear",id:"BtintSVG",slope:0.9,intercept:0}));}else if(tint<=-66){tintFilter=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComponentTransfer",{id:"tintSVG"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncR",{type:"linear",id:"RtintSVG",slope:0.9,intercept:0.1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncG",{type:"linear",id:"GtintSVG",slope:0.9,intercept:0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncB",{type:"linear",id:"BtintSVG",slope:0.9,intercept:-((tint+66)/330)}));}}else{tintFilter=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComponentTransfer",{id:"tintSVG"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncR",{type:"linear",id:"RtintSVG"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncG",{type:"linear",id:"GtintSVG"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncB",{type:"linear",id:"BtintSVG"}));}if(blur!==0){if(blur>0){filterItem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComponentTransfer",{result:"preblur"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feGaussianBlur",{stdDeviation:blur*3/10}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComposite",null)));}else if(blur<0){filterItem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComponentTransfer",{result:"preblur"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feGaussianBlur",{stdDeviation:"1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComposite",{operator:"arithmetic",k1:"0",k2:blur*6/100,k3:blur*6/100*-1+1,k4:"0",in2:"preblur"})));}}else{filterItem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:7.5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComponentTransfer",{result:"preblur"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feGaussianBlur",{stdDeviation:0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComposite",null)));}if(document.getElementById(props.vignetteId)!==undefined&&document.getElementById(props.vignetteId)!==null){var vignetteElement=document.getElementById(props.vignetteId);vignetteElement.style.backgroundImage="radial-gradient(circle farthest-side at center center, rgba(0, 0, 0, 0) 70%, rgba(0, 0, 0, "+vignette*0.007+") 130%)";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,filterItem,tintFilter);}

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getImageURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getImageThumbnailURL; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_app_json__);
/**
 * @summary constructs the image URL by prefixing the asset root
 * @param {string} type Type of the image
 * @param {string} subType SubType of the image
 * @param {string} src The src saved in the image
 * @returns {string} URL prefixed with asset URL
 */var getImageURL=function getImageURL(item,key){var type=item.get("type");var subType=item.get("subType");var src=item.get("src");var recentEdit=item.get("recentEdit");var sourceType=item.get("sourceType");if(type==="STOCKIMG"||type==="PEXELS"||type==="PIXABAY"||type==="UNSPLASH"){return src;// return "/getty/" + key + ".jpg";
}else if(type==="IMG"&&subType==="OBGIMG"){return""+__WEBPACK_IMPORTED_MODULE_0__config_app_json__["ASSETS"][__WEBPACK_IMPORTED_MODULE_0__config_app_json__["ASSETS"].current]+__WEBPACK_IMPORTED_MODULE_0__config_app_json__["BG"].obgsrc+src;// return "/getty/" + key + ".jpg";
}else if(type==="UPLOADS"&&subType==="UPIMAGE"&&sourceType!=="gif"&&sourceType.toLowerCase()!=="svg"){return""+__WEBPACK_IMPORTED_MODULE_0__config_app_json__["UPLOADS"].image_src+src;// return "/getty/" + key + "." + item.get("sourceType");
}else if(type==="UPLOADS"&&subType==="UPIMAGE"&&sourceType==="gif"){return""+__WEBPACK_IMPORTED_MODULE_0__config_app_json__["UPLOADS"].image_src+src;// return "/getty/" + key + "." + item.get("sourceType");
}else if(type==="UPLOADS"&&subType==="UPIMAGE"&&sourceType.toLowerCase()==="svg"){return""+__WEBPACK_IMPORTED_MODULE_0__config_app_json__["UPLOADS"].image_src+src;// return "/getty/" + key + "." + item.get("sourceType");
}if(subType==="GIPHY"){return __WEBPACK_IMPORTED_MODULE_0__config_app_json__["GIPHY"][__WEBPACK_IMPORTED_MODULE_0__config_app_json__["GIPHY"]['workspace']]+item.get("src");}if(recentEdit){return __WEBPACK_IMPORTED_MODULE_0__config_app_json__["UPLOADS"].image_src+item.get("src");}return src;};/**
 * @summary constructs the thumbnail image URL by prefixing the asset root
 * @param {string} type Type of the image
 * @param {string} subType SubType of the image
 * @param {string} thumbSrc The thumbnail src saved in the image
 * @returns {string} URL prefixed with asset URL
 */var getImageThumbnailURL=function getImageThumbnailURL(type,subType,thumbSrc){if(type==="STOCKIMG"||type==="PEXELS"||type==="PIXABAY"||type==="UNSPLASH"||type==="IMG"&&subType==="GIPHY"){return thumbSrc;}else if(type==="IMG"&&subType==="OBGIMG"){return""+__WEBPACK_IMPORTED_MODULE_0__config_app_json__["ASSETS"][__WEBPACK_IMPORTED_MODULE_0__config_app_json__["ASSETS"].current]+__WEBPACK_IMPORTED_MODULE_0__config_app_json__["BG"].thumb+thumbSrc;}else if(type==="UPLOADS"&&subType==="UPIMAGE"){return""+__WEBPACK_IMPORTED_MODULE_0__config_app_json__["UPLOADS"].image_thumb+thumbSrc;}else if(type==="STOCKVID"||type==="UPLOADS"||subType==="UPVIDEO"){if(subType==="UPVIDEO"&&!thumbSrc.includes("https")){thumbSrc=""+__WEBPACK_IMPORTED_MODULE_0__config_app_json__["UPLOADS"].image_thumb+thumbSrc;}return thumbSrc;}return thumbSrc;};

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GridContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DroppableAreaContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ImageContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GridImage; });
/* unused harmony export DropShadowWrapper */
/* unused harmony export GridImageChild */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GridDefaultImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return VIGNETTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Loader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(59);
var _templateObject=_taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    display: grid;\n"],["\n    width: 100%;\n    height: 100%;\n    display: grid;\n"]),_templateObject2=_taggedTemplateLiteral(["\n    position: relative;\n    overflow: hidden;\n    outline: none;\n    cursor: pointer;\n    * {\n        pointer-events: none; // using pointer events so that we can detect mouse up in LibraryComponent\n    }\n"],["\n    position: relative;\n    overflow: hidden;\n    outline: none;\n    cursor: pointer;\n    * {\n        pointer-events: none; // using pointer events so that we can detect mouse up in LibraryComponent\n    }\n"]),_templateObject3=_taggedTemplateLiteral(["\n    position: relative;\n    width: 100%;\n    height: 100%;\n"],["\n    position: relative;\n    width: 100%;\n    height: 100%;\n"]),_templateObject4=_taggedTemplateLiteral(["\n    display: block;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n"],["\n    display: block;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n"]),_templateObject5=_taggedTemplateLiteral(["\n    position: absolute;\n    user-select: none;\n    pointer-events: auto;\n    opacity: 1;\n    width: 100%;\n    height: 100%;\n"],["\n    position: absolute;\n    user-select: none;\n    pointer-events: auto;\n    opacity: 1;\n    width: 100%;\n    height: 100%;\n"]),_templateObject6=_taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n"],["\n    width: 100%;\n    height: 100%;\n"]),_templateObject7=_taggedTemplateLiteral(["\n    background: ",";\n"],["\n    background: ",";\n"]),_templateObject8=_taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    z-index: 2;\n    background-image: radial-gradient(\n        circle farthest-side at center center,\n        rgba(0, 0, 0, 0) 70%,\n        rgba(0, 0, 0, var(--vignette)) 130%\n    );\n"],["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    z-index: 2;\n    background-image: radial-gradient(\n        circle farthest-side at center center,\n        rgba(0, 0, 0, 0) 70%,\n        rgba(0, 0, 0, var(--vignette)) 130%\n    );\n"]),_templateObject9=_taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    position: absolute; top: 0; left: 0;\n    display: flex; align-items: center; justify-content: center;\n\n    img {\n        width: 100%;\n        max-height: 48px;\n        object-fit: contain;\n    }\n"],["\n    width: 100%;\n    height: 100%;\n    position: absolute; top: 0; left: 0;\n    display: flex; align-items: center; justify-content: center;\n\n    img {\n        width: 100%;\n        max-height: 48px;\n        object-fit: contain;\n    }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GridContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject);var DroppableAreaContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2);var ImageContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject3);var GridImage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].img(_templateObject4);var DropShadowWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject5);var GridImageChild=__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject6);var GridDefaultImage=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */])(GridImageChild)(_templateObject7,function(props){return"url(\""+props.assetUrl+"/images/frames/bg-frame.png\") 50% / auto 100%";});var VIGNETTE=__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject8);var Loader=__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject9);

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var debug = __webpack_require__(446)('socket.io-parser');
var json = __webpack_require__(449);
var Emitter = __webpack_require__(451);
var binary = __webpack_require__(452);
var isBuf = __webpack_require__(203);

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = 4;

/**
 * Packet types.
 *
 * @api public
 */

exports.types = [
  'CONNECT',
  'DISCONNECT',
  'EVENT',
  'ACK',
  'ERROR',
  'BINARY_EVENT',
  'BINARY_ACK'
];

/**
 * Packet type `connect`.
 *
 * @api public
 */

exports.CONNECT = 0;

/**
 * Packet type `disconnect`.
 *
 * @api public
 */

exports.DISCONNECT = 1;

/**
 * Packet type `event`.
 *
 * @api public
 */

exports.EVENT = 2;

/**
 * Packet type `ack`.
 *
 * @api public
 */

exports.ACK = 3;

/**
 * Packet type `error`.
 *
 * @api public
 */

exports.ERROR = 4;

/**
 * Packet type 'binary event'
 *
 * @api public
 */

exports.BINARY_EVENT = 5;

/**
 * Packet type `binary ack`. For acks with binary arguments.
 *
 * @api public
 */

exports.BINARY_ACK = 6;

/**
 * Encoder constructor.
 *
 * @api public
 */

exports.Encoder = Encoder;

/**
 * Decoder constructor.
 *
 * @api public
 */

exports.Decoder = Decoder;

/**
 * A socket.io Encoder instance
 *
 * @api public
 */

function Encoder() {}

/**
 * Encode a packet as a single string if non-binary, or as a
 * buffer sequence, depending on packet type.
 *
 * @param {Object} obj - packet object
 * @param {Function} callback - function to handle encodings (likely engine.write)
 * @return Calls callback with Array of encodings
 * @api public
 */

Encoder.prototype.encode = function(obj, callback){
  debug('encoding packet %j', obj);

  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
    encodeAsBinary(obj, callback);
  }
  else {
    var encoding = encodeAsString(obj);
    callback([encoding]);
  }
};

/**
 * Encode packet as string.
 *
 * @param {Object} packet
 * @return {String} encoded
 * @api private
 */

function encodeAsString(obj) {
  var str = '';
  var nsp = false;

  // first is type
  str += obj.type;

  // attachments if we have them
  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
    str += obj.attachments;
    str += '-';
  }

  // if we have a namespace other than `/`
  // we append it followed by a comma `,`
  if (obj.nsp && '/' != obj.nsp) {
    nsp = true;
    str += obj.nsp;
  }

  // immediately followed by the id
  if (null != obj.id) {
    if (nsp) {
      str += ',';
      nsp = false;
    }
    str += obj.id;
  }

  // json data
  if (null != obj.data) {
    if (nsp) str += ',';
    str += json.stringify(obj.data);
  }

  debug('encoded %j as %s', obj, str);
  return str;
}

/**
 * Encode packet as 'buffer sequence' by removing blobs, and
 * deconstructing packet into object with placeholders and
 * a list of buffers.
 *
 * @param {Object} packet
 * @return {Buffer} encoded
 * @api private
 */

function encodeAsBinary(obj, callback) {

  function writeEncoding(bloblessData) {
    var deconstruction = binary.deconstructPacket(bloblessData);
    var pack = encodeAsString(deconstruction.packet);
    var buffers = deconstruction.buffers;

    buffers.unshift(pack); // add packet info to beginning of data list
    callback(buffers); // write all the buffers
  }

  binary.removeBlobs(obj, writeEncoding);
}

/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 * @api public
 */

function Decoder() {
  this.reconstructor = null;
}

/**
 * Mix in `Emitter` with Decoder.
 */

Emitter(Decoder.prototype);

/**
 * Decodes an ecoded packet string into packet JSON.
 *
 * @param {String} obj - encoded packet
 * @return {Object} packet
 * @api public
 */

Decoder.prototype.add = function(obj) {
  var packet;
  if ('string' == typeof obj) {
    packet = decodeString(obj);
    if (exports.BINARY_EVENT == packet.type || exports.BINARY_ACK == packet.type) { // binary packet's json
      this.reconstructor = new BinaryReconstructor(packet);

      // no attachments, labeled binary but no binary data to follow
      if (this.reconstructor.reconPack.attachments === 0) {
        this.emit('decoded', packet);
      }
    } else { // non-binary full packet
      this.emit('decoded', packet);
    }
  }
  else if (isBuf(obj) || obj.base64) { // raw binary data
    if (!this.reconstructor) {
      throw new Error('got binary data when not reconstructing a packet');
    } else {
      packet = this.reconstructor.takeBinaryData(obj);
      if (packet) { // received final buffer
        this.reconstructor = null;
        this.emit('decoded', packet);
      }
    }
  }
  else {
    throw new Error('Unknown type: ' + obj);
  }
};

/**
 * Decode a packet String (JSON data)
 *
 * @param {String} str
 * @return {Object} packet
 * @api private
 */

function decodeString(str) {
  var p = {};
  var i = 0;

  // look up type
  p.type = Number(str.charAt(0));
  if (null == exports.types[p.type]) return error();

  // look up attachments if type binary
  if (exports.BINARY_EVENT == p.type || exports.BINARY_ACK == p.type) {
    var buf = '';
    while (str.charAt(++i) != '-') {
      buf += str.charAt(i);
      if (i == str.length) break;
    }
    if (buf != Number(buf) || str.charAt(i) != '-') {
      throw new Error('Illegal attachments');
    }
    p.attachments = Number(buf);
  }

  // look up namespace (if any)
  if ('/' == str.charAt(i + 1)) {
    p.nsp = '';
    while (++i) {
      var c = str.charAt(i);
      if (',' == c) break;
      p.nsp += c;
      if (i == str.length) break;
    }
  } else {
    p.nsp = '/';
  }

  // look up id
  var next = str.charAt(i + 1);
  if ('' !== next && Number(next) == next) {
    p.id = '';
    while (++i) {
      var c = str.charAt(i);
      if (null == c || Number(c) != c) {
        --i;
        break;
      }
      p.id += str.charAt(i);
      if (i == str.length) break;
    }
    p.id = Number(p.id);
  }

  // look up json data
  if (str.charAt(++i)) {
    p = tryParse(p, str.substr(i));
  }

  debug('decoded %s as %j', str, p);
  return p;
}

function tryParse(p, str) {
  try {
    p.data = json.parse(str);
  } catch(e){
    return error();
  }
  return p; 
};

/**
 * Deallocates a parser's resources
 *
 * @api public
 */

Decoder.prototype.destroy = function() {
  if (this.reconstructor) {
    this.reconstructor.finishedReconstruction();
  }
};

/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 * @api private
 */

function BinaryReconstructor(packet) {
  this.reconPack = packet;
  this.buffers = [];
}

/**
 * Method to be called when binary data received from connection
 * after a BINARY_EVENT packet.
 *
 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
 * @return {null | Object} returns null if more binary data is expected or
 *   a reconstructed packet object if all buffers have been received.
 * @api private
 */

BinaryReconstructor.prototype.takeBinaryData = function(binData) {
  this.buffers.push(binData);
  if (this.buffers.length == this.reconPack.attachments) { // done with buffer list
    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
    this.finishedReconstruction();
    return packet;
  }
  return null;
};

/**
 * Cleans up binary packet reconstruction variables.
 *
 * @api private
 */

BinaryReconstructor.prototype.finishedReconstruction = function() {
  this.reconPack = null;
  this.buffers = [];
};

function error(data){
  return {
    type: exports.ERROR,
    data: 'parser error'
  };
}


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// browser shim for xmlhttprequest module

var hasCORS = __webpack_require__(457);

module.exports = function (opts) {
  var xdomain = opts.xdomain;

  // scheme must be same when usign XDomainRequest
  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
  var xscheme = opts.xscheme;

  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
  // https://github.com/Automattic/engine.io-client/pull/217
  var enablesXDR = opts.enablesXDR;

  // XMLHttpRequest can be disabled on IE
  try {
    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
      return new XMLHttpRequest();
    }
  } catch (e) { }

  // Use XDomainRequest for IE8 if enablesXDR is true
  // because loading bar keeps flashing when using jsonp-polling
  // https://github.com/yujiosaka/socke.io-ie8-loading-example
  try {
    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
      return new XDomainRequest();
    }
  } catch (e) { }

  if (!xdomain) {
    try {
      return new global[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
    } catch (e) { }
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var parser = __webpack_require__(34);
var Emitter = __webpack_require__(111);

/**
 * Module exports.
 */

module.exports = Transport;

/**
 * Transport abstract constructor.
 *
 * @param {Object} options.
 * @api private
 */

function Transport (opts) {
  this.path = opts.path;
  this.hostname = opts.hostname;
  this.port = opts.port;
  this.secure = opts.secure;
  this.query = opts.query;
  this.timestampParam = opts.timestampParam;
  this.timestampRequests = opts.timestampRequests;
  this.readyState = '';
  this.agent = opts.agent || false;
  this.socket = opts.socket;
  this.enablesXDR = opts.enablesXDR;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;
  this.forceNode = opts.forceNode;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;
  this.localAddress = opts.localAddress;
}

/**
 * Mix in `Emitter`.
 */

Emitter(Transport.prototype);

/**
 * Emits an error.
 *
 * @param {String} str
 * @return {Transport} for chaining
 * @api public
 */

Transport.prototype.onError = function (msg, desc) {
  var err = new Error(msg);
  err.type = 'TransportError';
  err.description = desc;
  this.emit('error', err);
  return this;
};

/**
 * Opens the transport.
 *
 * @api public
 */

Transport.prototype.open = function () {
  if ('closed' === this.readyState || '' === this.readyState) {
    this.readyState = 'opening';
    this.doOpen();
  }

  return this;
};

/**
 * Closes the transport.
 *
 * @api private
 */

Transport.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.doClose();
    this.onClose();
  }

  return this;
};

/**
 * Sends multiple packets.
 *
 * @param {Array} packets
 * @api private
 */

Transport.prototype.send = function (packets) {
  if ('open' === this.readyState) {
    this.write(packets);
  } else {
    throw new Error('Transport not open');
  }
};

/**
 * Called upon open
 *
 * @api private
 */

Transport.prototype.onOpen = function () {
  this.readyState = 'open';
  this.writable = true;
  this.emit('open');
};

/**
 * Called with data.
 *
 * @param {String} data
 * @api private
 */

Transport.prototype.onData = function (data) {
  var packet = parser.decodePacket(data, this.socket.binaryType);
  this.onPacket(packet);
};

/**
 * Called with a decoded packet.
 */

Transport.prototype.onPacket = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon close.
 *
 * @api private
 */

Transport.prototype.onClose = function () {
  this.readyState = 'closed';
  this.emit('close');
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 112 */
/***/ (function(module, exports) {

/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */

exports.encode = function (obj) {
  var str = '';

  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      if (str.length) str += '&';
      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
  }

  return str;
};

/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */

exports.decode = function(qs){
  var qry = {};
  var pairs = qs.split('&');
  for (var i = 0, l = pairs.length; i < l; i++) {
    var pair = pairs[i].split('=');
    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return qry;
};


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return qEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeName;
/* harmony export (immutable) */ __webpack_exports__["a"] = fsmIterator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(14);


var done = { done: true, value: undefined };
var qEnd = {};

function safeName(patternOrChannel) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return 'channel';
  } else if (Array.isArray(patternOrChannel)) {
    return String(patternOrChannel.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(patternOrChannel);
  }
}

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name, true);
}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(30),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(509),
    mapCacheDelete = __webpack_require__(516),
    mapCacheGet = __webpack_require__(518),
    mapCacheHas = __webpack_require__(519),
    mapCacheSet = __webpack_require__(520);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(230),
    baseKeys = __webpack_require__(540),
    isArrayLike = __webpack_require__(120);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 118 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 119 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(221),
    isLength = __webpack_require__(119);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(69),
    toKey = __webpack_require__(49);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(20),
    isSymbol = __webpack_require__(70);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 123 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(255);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Integrations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exports__ = __webpack_require__(263);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_core__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__integrations__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__transports__ = __webpack_require__(135);
/* unused harmony reexport Transports */






var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var _window = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["p" /* getGlobalObject */])();
if (_window.Sentry && _window.Sentry.Integrations) {
    windowIntegrations = _window.Sentry.Integrations;
}
var INTEGRATIONS = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, windowIntegrations), __WEBPACK_IMPORTED_MODULE_2__sentry_core__["d" /* Integrations */]), __WEBPACK_IMPORTED_MODULE_4__integrations__);

//# sourceMappingURL=index.js.map

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scope; });
/* harmony export (immutable) */ __webpack_exports__["b"] = addGlobalEventProcessor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);


/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
var Scope = /** @class */ (function () {
    function Scope() {
        /** Flag if notifiying is happening. */
        this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */
        this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */
        this._eventProcessors = [];
        /** Array of breadcrumbs. */
        this._breadcrumbs = [];
        /** User */
        this._user = {};
        /** Tags */
        this._tags = {};
        /** Extra */
        this._extra = {};
        /** Contexts */
        this._contexts = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */
    Scope.clone = function (scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])(scope._breadcrumbs);
            newScope._tags = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, scope._tags);
            newScope._extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, scope._extra);
            newScope._contexts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])(scope._eventProcessors);
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */
    Scope.prototype.addScopeListener = function (callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addEventProcessor = function (callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setUser = function (user) {
        this._user = user || {};
        if (this._session) {
            this._session.update({ user: user });
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getUser = function () {
        return this._user;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTags = function (tags) {
        this._tags = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTag = function (key, value) {
        var _a;
        this._tags = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtras = function (extras) {
        this._extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtra = function (key, extra) {
        var _a;
        this._extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setFingerprint = function (fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setLevel = function (level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTransactionName = function (name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */
    Scope.prototype.setTransaction = function (name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setContext = function (key, context) {
        var _a;
        if (context === null) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._contexts[key];
        }
        else {
            this._contexts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._contexts), (_a = {}, _a[key] = context, _a));
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSpan = function (span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSpan = function () {
        return this._span;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getTransaction = function () {
        var _a, _b, _c, _d;
        // often, this span will be a transaction, but it's not guaranteed to be
        var span = this.getSpan();
        // try it the new way first
        if ((_a = span) === null || _a === void 0 ? void 0 : _a.transaction) {
            return (_b = span) === null || _b === void 0 ? void 0 : _b.transaction;
        }
        // fallback to the old way (known bug: this only finds transactions with sampled = true)
        if ((_d = (_c = span) === null || _c === void 0 ? void 0 : _c.spanRecorder) === null || _d === void 0 ? void 0 : _d.spans[0]) {
            return span.spanRecorder.spans[0];
        }
        // neither way found a transaction
        return undefined;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSession = function (session) {
        if (!session) {
            delete this._session;
        }
        else {
            this._session = session;
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSession = function () {
        return this._session;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.update = function (captureContext) {
        if (!captureContext) {
            return this;
        }
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._tags), captureContext._tags);
            this._extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._extra), captureContext._extra);
            this._contexts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) {
                this._user = captureContext._user;
            }
            if (captureContext._level) {
                this._level = captureContext._level;
            }
            if (captureContext._fingerprint) {
                this._fingerprint = captureContext._fingerprint;
            }
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["A" /* isPlainObject */])(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext = captureContext;
            this._tags = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._tags), captureContext.tags);
            this._extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._extra), captureContext.extra);
            this._contexts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._contexts), captureContext.contexts);
            if (captureContext.user) {
                this._user = captureContext.user;
            }
            if (captureContext.level) {
                this._level = captureContext.level;
            }
            if (captureContext.fingerprint) {
                this._fingerprint = captureContext.fingerprint;
            }
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clear = function () {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
        var mergedBreadcrumb = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ timestamp: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* dateTimestampInSeconds */])() }, breadcrumb);
        this._breadcrumbs =
            maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0
                ? Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxBreadcrumbs)
                : Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])(this._breadcrumbs, [mergedBreadcrumb]);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clearBreadcrumbs = function () {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional informartion about the original exception.
     * @hidden
     */
    Scope.prototype.applyToEvent = function (event, hint) {
        if (this._extra && Object.keys(this._extra).length) {
            event.extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._extra), event.extra);
        }
        if (this._tags && Object.keys(this._tags).length) {
            event.tags = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._tags), event.tags);
        }
        if (this._user && Object.keys(this._user).length) {
            event.user = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._user), event.user);
        }
        if (this._contexts && Object.keys(this._contexts).length) {
            event.contexts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._contexts), event.contexts);
        }
        if (this._level) {
            event.level = this._level;
        }
        if (this._transactionName) {
            event.transaction = this._transactionName;
        }
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relys on that.
        if (this._span) {
            event.contexts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ trace: this._span.getTraceContext() }, event.contexts);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])((event.breadcrumbs || []), this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        return this._notifyEventProcessors(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])(getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */
    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
        var _this = this;
        if (index === void 0) { index = 0; }
        return new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') {
                resolve(event);
            }
            else {
                var result = processor(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event), hint);
                if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* isThenable */])(result)) {
                    result
                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
                        .then(null, reject);
                }
                else {
                    _this._notifyEventProcessors(processors, result, hint, index + 1)
                        .then(resolve)
                        .then(null, reject);
                }
            }
        });
    };
    /**
     * This will be called on every set call.
     */
    Scope.prototype._notifyScopeListeners = function () {
        var _this = this;
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            setTimeout(function () {
                _this._scopeListeners.forEach(function (callback) {
                    callback(_this);
                });
                _this._notifyingListeners = false;
            });
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */
    Scope.prototype._applyFingerprint = function (event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint
            ? Array.isArray(event.fingerprint)
                ? event.fingerprint
                : [event.fingerprint]
            : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) {
            event.fingerprint = event.fingerprint.concat(this._fingerprint);
        }
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) {
            delete event.fingerprint;
        }
    };
    return Scope;
}());

/**
 * Retruns the global event processors.
 */
function getGlobalEventProcessors() {
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["p" /* getGlobalObject */])();
    global.__SENTRY__ = global.__SENTRY__ || {};
    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
    return global.__SENTRY__.globalEventProcessors;
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}
//# sourceMappingURL=scope.js.map

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = htmlTreeAsString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(24);

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
            nextStr = _htmlElementAsString(currentElem);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
                break;
            }
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return '';
    }
    out.push(elem.tagName.toLowerCase());
    if (elem.id) {
        out.push("#" + elem.id);
    }
    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && Object(__WEBPACK_IMPORTED_MODULE_0__is__["k" /* isString */])(className)) {
        classes = className.split(/\s+/);
        for (i = 0; i < classes.length; i++) {
            out.push("." + classes[i]);
        }
    }
    var allowedAttrs = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < allowedAttrs.length; i++) {
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[" + key + "=\"" + attr + "\"]");
        }
    }
    return out.join('');
}
//# sourceMappingURL=browser.js.map

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Memo; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/**
 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
 */
var Memo = /** @class */ (function () {
    function Memo() {
        this._hasWeakSet = typeof WeakSet === 'function';
        this._inner = this._hasWeakSet ? new WeakSet() : [];
    }
    /**
     * Sets obj to remember.
     * @param obj Object to remember
     */
    Memo.prototype.memoize = function (obj) {
        if (this._hasWeakSet) {
            if (this._inner.has(obj)) {
                return true;
            }
            this._inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (var i = 0; i < this._inner.length; i++) {
            var value = this._inner[i];
            if (value === obj) {
                return true;
            }
        }
        this._inner.push(obj);
        return false;
    };
    /**
     * Removes object from internal storage.
     * @param obj Object to forget
     */
    Memo.prototype.unmemoize = function (obj) {
        if (this._hasWeakSet) {
            this._inner.delete(obj);
        }
        else {
            for (var i = 0; i < this._inner.length; i++) {
                if (this._inner[i] === obj) {
                    this._inner.splice(i, 1);
                    break;
                }
            }
        }
    };
    return Memo;
}());

//# sourceMappingURL=memo.js.map

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export supportsErrorEvent */
/* unused harmony export supportsDOMError */
/* unused harmony export supportsDOMException */
/* harmony export (immutable) */ __webpack_exports__["a"] = supportsFetch;
/* harmony export (immutable) */ __webpack_exports__["c"] = supportsNativeFetch;
/* harmony export (immutable) */ __webpack_exports__["e"] = supportsReportingObserver;
/* harmony export (immutable) */ __webpack_exports__["d"] = supportsReferrerPolicy;
/* harmony export (immutable) */ __webpack_exports__["b"] = supportsHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc__ = __webpack_require__(40);


/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
    try {
        new ErrorEvent('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
    try {
        new DOMException('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
    if (!('fetch' in Object(__WEBPACK_IMPORTED_MODULE_1__misc__["e" /* getGlobalObject */])())) {
        return false;
    }
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__misc__["e" /* getGlobalObject */])();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFetch(global.fetch)) {
        return true;
    }
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") {
        try {
            var sandbox = doc.createElement('iframe');
            sandbox.hidden = true;
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // eslint-disable-next-line @typescript-eslint/unbound-method
                result = isNativeFetch(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        }
        catch (err) {
            __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* logger */].warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
        }
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
    return 'ReportingObserver' in Object(__WEBPACK_IMPORTED_MODULE_1__misc__["e" /* getGlobalObject */])();
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        new Request('_', {
            referrerPolicy: 'origin',
        });
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__misc__["e" /* getGlobalObject */])();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
//# sourceMappingURL=supports.js.map

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SyncPromise; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(24);
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/typedef */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

/** SyncPromise internal states */
var States;
(function (States) {
    /** Pending */
    States["PENDING"] = "PENDING";
    /** Resolved / OK */
    States["RESOLVED"] = "RESOLVED";
    /** Rejected / Error */
    States["REJECTED"] = "REJECTED";
})(States || (States = {}));
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
var SyncPromise = /** @class */ (function () {
    function SyncPromise(executor) {
        var _this = this;
        this._state = States.PENDING;
        this._handlers = [];
        /** JSDoc */
        this._resolve = function (value) {
            _this._setResult(States.RESOLVED, value);
        };
        /** JSDoc */
        this._reject = function (reason) {
            _this._setResult(States.REJECTED, reason);
        };
        /** JSDoc */
        this._setResult = function (state, value) {
            if (_this._state !== States.PENDING) {
                return;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["m" /* isThenable */])(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        // TODO: FIXME
        /** JSDoc */
        this._attachHandler = function (handler) {
            _this._handlers = _this._handlers.concat(handler);
            _this._executeHandlers();
        };
        /** JSDoc */
        this._executeHandlers = function () {
            if (_this._state === States.PENDING) {
                return;
            }
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function (handler) {
                if (handler.done) {
                    return;
                }
                if (_this._state === States.RESOLVED) {
                    if (handler.onfulfilled) {
                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
                        handler.onfulfilled(_this._value);
                    }
                }
                if (_this._state === States.REJECTED) {
                    if (handler.onrejected) {
                        handler.onrejected(_this._value);
                    }
                }
                handler.done = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        }
        catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */
    SyncPromise.resolve = function (value) {
        return new SyncPromise(function (resolve) {
            resolve(value);
        });
    };
    /** JSDoc */
    SyncPromise.reject = function (reason) {
        return new SyncPromise(function (_, reject) {
            reject(reason);
        });
    };
    /** JSDoc */
    SyncPromise.all = function (collection) {
        return new SyncPromise(function (resolve, reject) {
            if (!Array.isArray(collection)) {
                reject(new TypeError("Promise.all requires an array as input."));
                return;
            }
            if (collection.length === 0) {
                resolve([]);
                return;
            }
            var counter = collection.length;
            var resolvedCollection = [];
            collection.forEach(function (item, index) {
                SyncPromise.resolve(item)
                    .then(function (value) {
                    resolvedCollection[index] = value;
                    counter -= 1;
                    if (counter !== 0) {
                        return;
                    }
                    resolve(resolvedCollection);
                })
                    .then(null, reject);
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            _this._attachHandler({
                done: false,
                onfulfilled: function (result) {
                    if (!onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                        return;
                    }
                    try {
                        resolve(onfulfilled(result));
                        return;
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                },
                onrejected: function (reason) {
                    if (!onrejected) {
                        reject(reason);
                        return;
                    }
                    try {
                        resolve(onrejected(reason));
                        return;
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                },
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.catch = function (onrejected) {
        return this.then(function (val) { return val; }, onrejected);
    };
    /** JSDoc */
    SyncPromise.prototype.finally = function (onfinally) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function (value) {
                isRejected = false;
                val = value;
                if (onfinally) {
                    onfinally();
                }
            }, function (reason) {
                isRejected = true;
                val = reason;
                if (onfinally) {
                    onfinally();
                }
            }).then(function () {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.toString = function () {
        return '[object SyncPromise]';
    };
    return SyncPromise;
}());

//# sourceMappingURL=syncpromise.js.map

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Session; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);


/**
 * @inheritdoc
 */
var Session = /** @class */ (function () {
    function Session(context) {
        this.errors = 0;
        this.sid = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["R" /* uuid4 */])();
        this.timestamp = Date.now();
        this.started = Date.now();
        this.duration = 0;
        this.status = __WEBPACK_IMPORTED_MODULE_0__sentry_types__["a" /* SessionStatus */].Ok;
        if (context) {
            this.update(context);
        }
    }
    /** JSDoc */
    // eslint-disable-next-line complexity
    Session.prototype.update = function (context) {
        if (context === void 0) { context = {}; }
        if (context.user) {
            if (context.user.ip_address) {
                this.ipAddress = context.user.ip_address;
            }
            if (!context.did) {
                this.did = context.user.id || context.user.email || context.user.username;
            }
        }
        this.timestamp = context.timestamp || Date.now();
        if (context.sid) {
            // Good enough uuid validation. — Kamil
            this.sid = context.sid.length === 32 ? context.sid : Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["R" /* uuid4 */])();
        }
        if (context.did) {
            this.did = "" + context.did;
        }
        if (typeof context.started === 'number') {
            this.started = context.started;
        }
        if (typeof context.duration === 'number') {
            this.duration = context.duration;
        }
        else {
            this.duration = this.timestamp - this.started;
        }
        if (context.release) {
            this.release = context.release;
        }
        if (context.environment) {
            this.environment = context.environment;
        }
        if (context.ipAddress) {
            this.ipAddress = context.ipAddress;
        }
        if (context.userAgent) {
            this.userAgent = context.userAgent;
        }
        if (typeof context.errors === 'number') {
            this.errors = context.errors;
        }
        if (context.status) {
            this.status = context.status;
        }
    };
    /** JSDoc */
    Session.prototype.close = function (status) {
        if (status) {
            this.update({ status: status });
        }
        else if (this.status === __WEBPACK_IMPORTED_MODULE_0__sentry_types__["a" /* SessionStatus */].Ok) {
            this.update({ status: __WEBPACK_IMPORTED_MODULE_0__sentry_types__["a" /* SessionStatus */].Exited });
        }
        else {
            this.update();
        }
    };
    /** JSDoc */
    Session.prototype.toJSON = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["k" /* dropUndefinedKeys */])({
            sid: "" + this.sid,
            init: true,
            started: new Date(this.started).toISOString(),
            timestamp: new Date(this.timestamp).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["k" /* dropUndefinedKeys */])({
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent,
            }),
        });
    };
    return Session;
}());

//# sourceMappingURL=session.js.map

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoopTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);


/** Noop transport */
var NoopTransport = /** @class */ (function () {
    function NoopTransport() {
    }
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.sendEvent = function (_) {
        return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].resolve({
            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
            status: __WEBPACK_IMPORTED_MODULE_0__sentry_types__["c" /* Status */].Skipped,
        });
    };
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.close = function (_) {
        return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].resolve(true);
    };
    return NoopTransport;
}());

//# sourceMappingURL=noop.js.map

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__backend__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__integrations__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__version__ = __webpack_require__(136);







/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
var BrowserClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */
    function BrowserClient(options) {
        if (options === void 0) { options = {}; }
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_3__backend__["a" /* BrowserBackend */], options) || this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */
    BrowserClient.prototype.showReportDialog = function (options) {
        if (options === void 0) { options = {}; }
        // doesn't work without a document (React Native)
        var document = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["p" /* getGlobalObject */])().document;
        if (!document) {
            return;
        }
        if (!this._isEnabled()) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["E" /* logger */].error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* injectReportDialog */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, options), { dsn: options.dsn || this.getDsn() }));
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
        event.platform = event.platform || 'javascript';
        event.sdk = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event.sdk), { name: __WEBPACK_IMPORTED_MODULE_6__version__["a" /* SDK_NAME */], packages: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])(((event.sdk && event.sdk.packages) || []), [
                {
                    name: 'npm:@sentry/browser',
                    version: __WEBPACK_IMPORTED_MODULE_6__version__["b" /* SDK_VERSION */],
                },
            ]), version: __WEBPACK_IMPORTED_MODULE_6__version__["b" /* SDK_VERSION */] });
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._sendEvent = function (event) {
        var integration = this.getIntegration(__WEBPACK_IMPORTED_MODULE_5__integrations__["Breadcrumbs"]);
        if (integration) {
            integration.addSentryBreadcrumb(event);
        }
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["c" /* BaseClient */]));

//# sourceMappingURL=client.js.map

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = exceptionFromStacktrace;
/* harmony export (immutable) */ __webpack_exports__["a"] = eventFromPlainObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = eventFromStacktrace;
/* harmony export (immutable) */ __webpack_exports__["d"] = prepareFramesForEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracekit__ = __webpack_require__(82);


var STACKTRACE_LIMIT = 50;
/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */
function exceptionFromStacktrace(stacktrace) {
    var frames = prepareFramesForEvent(stacktrace.stack);
    var exception = {
        type: stacktrace.name,
        value: stacktrace.message,
    };
    if (frames && frames.length) {
        exception.stacktrace = { frames: frames };
    }
    if (exception.type === undefined && exception.value === '') {
        exception.value = 'Unrecoverable error caught';
    }
    return exception;
}
/**
 * @hidden
 */
function eventFromPlainObject(exception, syntheticException, rejection) {
    var event = {
        exception: {
            values: [
                {
                    type: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["w" /* isEvent */])(exception) ? exception.constructor.name : rejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (rejection ? 'promise rejection' : 'exception') + " captured with keys: " + Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["l" /* extractExceptionKeysForMessage */])(exception),
                },
            ],
        },
        extra: {
            __serialized__: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["G" /* normalizeToSize */])(exception),
        },
    };
    if (syntheticException) {
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_1__tracekit__["a" /* computeStackTrace */])(syntheticException);
        var frames_1 = prepareFramesForEvent(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1,
        };
    }
    return event;
}
/**
 * @hidden
 */
function eventFromStacktrace(stacktrace) {
    var exception = exceptionFromStacktrace(stacktrace);
    return {
        exception: {
            values: [exception],
        },
    };
}
/**
 * @hidden
 */
function prepareFramesForEvent(stack) {
    if (!stack || !stack.length) {
        return [];
    }
    var localStack = stack;
    var firstFrameFunction = localStack[0].func || '';
    var lastFrameFunction = localStack[localStack.length - 1].func || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
        localStack = localStack.slice(1);
    }
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
        localStack = localStack.slice(0, -1);
    }
    // The frame where the crash happened, should be the last entry in the array
    return localStack
        .slice(0, STACKTRACE_LIMIT)
        .map(function (frame) { return ({
        colno: frame.column === null ? undefined : frame.column,
        filename: frame.url || localStack[0].url,
        function: frame.func || '?',
        in_app: true,
        lineno: frame.line === null ? undefined : frame.line,
    }); })
        .reverse();
}
//# sourceMappingURL=parsers.js.map

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(83);
/* unused harmony reexport BaseTransport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__fetch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xhr__ = __webpack_require__(288);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__xhr__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SDK_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SDK_VERSION; });
var SDK_NAME = 'sentry.javascript.browser';
var SDK_VERSION = '5.27.2';
//# sourceMappingURL=version.js.map

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(310);


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TimelineMax */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimelineMax; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TimelineLite_js__ = __webpack_require__(85);
/* unused harmony reexport TimelineLite */
/*!
 * VERSION: 2.1.3
 * DATE: 2019-05-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */
/* eslint-disable */




__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["_gsScope"]._gsDefine("TimelineMax", ["TimelineLite","TweenLite","easing.Ease"], function() {
		
		var TimelineMax = function(vars) {
				__WEBPACK_IMPORTED_MODULE_1__TimelineLite_js__["a" /* default */].call(this, vars);
				this._repeat = this.vars.repeat || 0;
				this._repeatDelay = this.vars.repeatDelay || 0;
				this._cycle = 0;
				this._yoyo = !!this.vars.yoyo;
				this._dirty = true;
			},
			_tinyNum = 0.00000001,
			TweenLiteInternals = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"]._internals,
			_lazyTweens = TweenLiteInternals.lazyTweens,
			_lazyRender = TweenLiteInternals.lazyRender,
			_globals = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["_gsScope"]._gsDefine.globals,
			_easeNone = new __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Ease"](null, null, 1, 0),
			p = TimelineMax.prototype = new __WEBPACK_IMPORTED_MODULE_1__TimelineLite_js__["a" /* default */]();

		p.constructor = TimelineMax;
		p.kill()._gc = false;
		TimelineMax.version = "2.1.3";

		p.invalidate = function() {
			this._yoyo = !!this.vars.yoyo;
			this._repeat = this.vars.repeat || 0;
			this._repeatDelay = this.vars.repeatDelay || 0;
			this._uncache(true);
			return __WEBPACK_IMPORTED_MODULE_1__TimelineLite_js__["a" /* default */].prototype.invalidate.call(this);
		};

		p.addCallback = function(callback, position, params, scope) {
			return this.add( __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].delayedCall(0, callback, params, scope), position);
		};

		p.removeCallback = function(callback, position) {
			if (callback) {
				if (position == null) {
					this._kill(null, callback);
				} else {
					var a = this.getTweensOf(callback, false),
						i = a.length,
						time = this._parseTimeOrLabel(position);
					while (--i > -1) {
						if (a[i]._startTime === time) {
							a[i]._enabled(false, false);
						}
					}
				}
			}
			return this;
		};

		p.removePause = function(position) {
			return this.removeCallback(__WEBPACK_IMPORTED_MODULE_1__TimelineLite_js__["a" /* default */]._internals.pauseCallback, position);
		};

		p.tweenTo = function(position, vars) {
			vars = vars || {};
			var copy = {ease:_easeNone, useFrames:this.usesFrames(), immediateRender:false, lazy:false},
				Engine = (vars.repeat && _globals.TweenMax) || __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"],
				duration, p, t;
			for (p in vars) {
				copy[p] = vars[p];
			}
			copy.time = this._parseTimeOrLabel(position);
			duration = (Math.abs(Number(copy.time) - this._time) / this._timeScale) || 0.001;
			t = new Engine(this, duration, copy);
			copy.onStart = function() {
				t.target.paused(true);
				if (t.vars.time !== t.target.time() && duration === t.duration() && !t.isFromTo) { //don't make the duration zero - if it's supposed to be zero, don't worry because it's already initting the tween and will complete immediately, effectively making the duration zero anyway. If we make duration zero, the tween won't run at all.
					t.duration( Math.abs( t.vars.time - t.target.time()) / t.target._timeScale ).render(t.time(), true, true); //render() right away to ensure that things look right, especially in the case of .tweenTo(0).
				}
				if (vars.onStart) { //in case the user had an onStart in the vars - we don't want to overwrite it.
					vars.onStart.apply(vars.onStartScope || vars.callbackScope || t, vars.onStartParams || []); //don't use t._callback("onStart") or it'll point to the copy.onStart and we'll get a recursion error.
				}
			};
			return t;
		};

		p.tweenFromTo = function(fromPosition, toPosition, vars) {
			vars = vars || {};
			fromPosition = this._parseTimeOrLabel(fromPosition);
			vars.startAt = {onComplete:this.seek, onCompleteParams:[fromPosition], callbackScope:this};
			vars.immediateRender = (vars.immediateRender !== false);
			var t = this.tweenTo(toPosition, vars);
			t.isFromTo = 1; //to ensure we don't mess with the duration in the onStart (we've got the start and end values here, so lock it in)
			return t.duration((Math.abs( t.vars.time - fromPosition) / this._timeScale) || 0.001);
		};

		p.render = function(time, suppressEvents, force) {
			if (this._gc) {
				this._enabled(true, false);
			}
			var self = this,
				prevTime = self._time,
				totalDur = (!self._dirty) ? self._totalDuration : self.totalDuration(),
				dur = self._duration,
				prevTotalTime = self._totalTime,
				prevStart = self._startTime,
				prevTimeScale = self._timeScale,
				prevRawPrevTime = self._rawPrevTime,
				prevPaused = self._paused,
				prevCycle = self._cycle,
				tween, isComplete, next, callback, internalForce, cycleDuration, pauseTween, curTime, pauseTime;
			if (prevTime !== self._time) { //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
				time += self._time - prevTime;
			}
			if (time >= totalDur - _tinyNum && time >= 0) { //to work around occasional floating point math artifacts.
				if (!self._locked) {
					self._totalTime = totalDur;
					self._cycle = self._repeat;
				}
				if (!self._reversed) if (!self._hasPausedChild()) {
					isComplete = true;
					callback = "onComplete";
					internalForce = !!self._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					if (self._duration === 0) if ((time <= 0 && time >= -_tinyNum) || prevRawPrevTime < 0 || prevRawPrevTime === _tinyNum) if (prevRawPrevTime !== time && self._first) {
						internalForce = true;
						if (prevRawPrevTime > _tinyNum) {
							callback = "onReverseComplete";
						}
					}
				}
				self._rawPrevTime = (self._duration || !suppressEvents || time || self._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
				if (self._yoyo && (self._cycle & 1)) {
					self._time = time = 0;
				} else {
					self._time = dur;
					time = dur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7. We cannot do less then 0.0001 because the same issue can occur when the duration is extremely large like 999999999999 in which case adding 0.00000001, for example, causes it to act like nothing was added.
				}

			} else if (time < _tinyNum) { //to work around occasional floating point math artifacts, round super small values to 0.
				if (!self._locked) {
					self._totalTime = self._cycle = 0;
				}
				self._time = 0;
				if (time > -_tinyNum) {
					time = 0;
				}
				if (prevTime !== 0 || (dur === 0 && prevRawPrevTime !== _tinyNum && (prevRawPrevTime > 0 || (time < 0 && prevRawPrevTime >= 0)) && !self._locked)) { //edge case for checking time < 0 && prevRawPrevTime >= 0: a zero-duration fromTo() tween inside a zero-duration timeline (yeah, very rare)
					callback = "onReverseComplete";
					isComplete = self._reversed;
				}
				if (time < 0) {
					self._active = false;
					if (self._timeline.autoRemoveChildren && self._reversed) {
						internalForce = isComplete = true;
						callback = "onReverseComplete";
					} else if (prevRawPrevTime >= 0 && self._first) { //when going back beyond the start, force a render so that zero-duration tweens that sit at the very beginning render their start values properly. Otherwise, if the parent timeline's playhead lands exactly at this timeline's startTime, and then moves backwards, the zero-duration tweens at the beginning would still be at their end state.
						internalForce = true;
					}
					self._rawPrevTime = time;
				} else {
					self._rawPrevTime = (dur || !suppressEvents || time || self._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					if (time === 0 && isComplete) { //if there's a zero-duration tween at the very beginning of a timeline and the playhead lands EXACTLY at time 0, that tween will correctly render its end values, but we need to keep the timeline alive for one more render so that the beginning values render properly as the parent's playhead keeps moving beyond the begining. Imagine obj.x starts at 0 and then we do tl.set(obj, {x:100}).to(obj, 1, {x:200}) and then later we tl.reverse()...the goal is to have obj.x revert to 0. If the playhead happens to land on exactly 0, without this chunk of code, it'd complete the timeline and remove it from the rendering queue (not good).
						tween = self._first;
						while (tween && tween._startTime === 0) {
							if (!tween._duration) {
								isComplete = false;
							}
							tween = tween._next;
						}
					}
					time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
					if (!self._initted) {
						internalForce = true;
					}
				}

			} else {
				if (dur === 0 && prevRawPrevTime < 0) { //without this, zero-duration repeating timelines (like with a simple callback nested at the very beginning and a repeatDelay) wouldn't render the first time through.
					internalForce = true;
				}
				self._time = self._rawPrevTime = time;
				if (!self._locked) {
					self._totalTime = time;
					if (self._repeat !== 0) {
						cycleDuration = dur + self._repeatDelay;
						self._cycle = (self._totalTime / cycleDuration) >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but it gets reported as 0.79999999!)
						if (self._cycle) if (self._cycle === self._totalTime / cycleDuration && prevTotalTime <= time) {
							self._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
						}
						self._time = self._totalTime - (self._cycle * cycleDuration);
						if (self._yoyo) if (self._cycle & 1) {
							self._time = dur - self._time;
						}
						if (self._time > dur) {
							self._time = dur;
							time = dur + 0.0001; //to avoid occasional floating point rounding error
						} else if (self._time < 0) {
							self._time = time = 0;
						} else {
							time = self._time;
						}
					}
				}
			}

			if (self._hasPause && !self._forcingPlayhead && !suppressEvents) {
				time = self._time;
				if (time > prevTime || (self._repeat && prevCycle !== self._cycle)) {
					tween = self._first;
					while (tween && tween._startTime <= time && !pauseTween) {
						if (!tween._duration) if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && self._rawPrevTime === 0)) {
							pauseTween = tween;
						}
						tween = tween._next;
					}
				} else {
					tween = self._last;
					while (tween && tween._startTime >= time && !pauseTween) {
						if (!tween._duration) if (tween.data === "isPause" && tween._rawPrevTime > 0) {
							pauseTween = tween;
						}
						tween = tween._prev;
					}
				}
				if (pauseTween) {
					pauseTime = self._startTime + (self._reversed ? self._duration - pauseTween._startTime : pauseTween._startTime) / self._timeScale;
					if (pauseTween._startTime < dur) {
						self._time = self._rawPrevTime = time = pauseTween._startTime;
						self._totalTime = time + (self._cycle * (self._totalDuration + self._repeatDelay));
					}
				}
			}

			if (self._cycle !== prevCycle) if (!self._locked) {
				/*
				make sure children at the end/beginning of the timeline are rendered properly. If, for example,
				a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
				would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
				could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
				we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
				ensure that zero-duration tweens at the very beginning or end of the TimelineMax work.
				*/
				var backwards = (self._yoyo && (prevCycle & 1) !== 0),
					wrap = (backwards === (self._yoyo && (self._cycle & 1) !== 0)),
					recTotalTime = self._totalTime,
					recCycle = self._cycle,
					recRawPrevTime = self._rawPrevTime,
					recTime = self._time;

				self._totalTime = prevCycle * dur;
				if (self._cycle < prevCycle) {
					backwards = !backwards;
				} else {
					self._totalTime += dur;
				}
				self._time = prevTime; //temporarily revert _time so that render() renders the children in the correct order. Without this, tweens won't rewind correctly. We could arhictect things in a "cleaner" way by splitting out the rendering queue into a separate method but for performance reasons, we kept it all inside this method.

				self._rawPrevTime = (dur === 0) ? prevRawPrevTime - 0.0001 : prevRawPrevTime;
				self._cycle = prevCycle;
				self._locked = true; //prevents changes to totalTime and skips repeat/yoyo behavior when we recursively call render()
				prevTime = (backwards) ? 0 : dur;
				self.render(prevTime, suppressEvents, (dur === 0));
				if (!suppressEvents) if (!self._gc) {
					if (self.vars.onRepeat) {
						self._cycle = recCycle; //in case the onRepeat alters the playhead or invalidates(), we shouldn't stay locked or use the previous cycle.
						self._locked = false;
						self._callback("onRepeat");
					}
				}
				if (prevTime !== self._time) { //in case there's a callback like onComplete in a nested tween/timeline that changes the playhead position, like via seek(), we should just abort.
					return;
				}
				if (wrap) {
					self._cycle = prevCycle; //if there's an onRepeat, we reverted this above, so make sure it's set properly again. We also unlocked in that scenario, so reset that too.
					self._locked = true;
					prevTime = (backwards) ? dur + 0.0001 : -0.0001;
					self.render(prevTime, true, false);
				}
				self._locked = false;
				if (self._paused && !prevPaused) { //if the render() triggered callback that paused this timeline, we should abort (very rare, but possible)
					return;
				}
				self._time = recTime;
				self._totalTime = recTotalTime;
				self._cycle = recCycle;
				self._rawPrevTime = recRawPrevTime;
			}

			if ((self._time === prevTime || !self._first) && !force && !internalForce && !pauseTween) {
				if (prevTotalTime !== self._totalTime) if (self._onUpdate) if (!suppressEvents) { //so that onUpdate fires even during the repeatDelay - as long as the totalTime changed, we should trigger onUpdate.
					self._callback("onUpdate");
				}
				return;
			} else if (!self._initted) {
				self._initted = true;
			}

			if (!self._active) if (!self._paused && self._totalTime !== prevTotalTime && time > 0) {
				self._active = true;  //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
			}

			if (prevTotalTime === 0) if (self.vars.onStart) if (self._totalTime !== 0 || !self._totalDuration) if (!suppressEvents) {
				self._callback("onStart");
			}

			curTime = self._time;
			if (curTime >= prevTime) {
				tween = self._first;
				while (tween) {
					next = tween._next; //record it here because the value could change after rendering...
					if (curTime !== self._time || (self._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
						break;
					} else if (tween._active || (tween._startTime <= self._time && !tween._paused && !tween._gc)) {
						if (pauseTween === tween) {
							self.pause();
							self._pauseTime = pauseTime; //so that when we resume(), it's starting from exactly the right spot (the pause() method uses the rawTime for the parent, but that may be a bit too far ahead)
						}
						if (!tween._reversed) {
							tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
						} else {
							tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
						}
					}
					tween = next;
				}
			} else {
				tween = self._last;
				while (tween) {
					next = tween._prev; //record it here because the value could change after rendering...
					if (curTime !== self._time || (self._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
						break;
					} else if (tween._active || (tween._startTime <= prevTime && !tween._paused && !tween._gc)) {
						if (pauseTween === tween) {
							pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
							while (pauseTween && pauseTween.endTime() > self._time) {
								pauseTween.render( (pauseTween._reversed ? pauseTween.totalDuration() - ((time - pauseTween._startTime) * pauseTween._timeScale) : (time - pauseTween._startTime) * pauseTween._timeScale), suppressEvents, force);
								pauseTween = pauseTween._prev;
							}
							pauseTween = null;
							self.pause();
							self._pauseTime = pauseTime; //so that when we resume(), it's starting from exactly the right spot (the pause() method uses the rawTime for the parent, but that may be a bit too far ahead)
						}
						if (!tween._reversed) {
							tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
						} else {
							tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
						}
					}
					tween = next;
				}
			}

			if (self._onUpdate) if (!suppressEvents) {
				if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
					_lazyRender();
				}
				self._callback("onUpdate");
			}
			if (callback) if (!self._locked) if (!self._gc) if (prevStart === self._startTime || prevTimeScale !== self._timeScale) if (self._time === 0 || totalDur >= self.totalDuration()) { //if one of the tweens that was rendered altered this timeline's startTime (like if an onComplete reversed the timeline), it probably isn't complete. If it is, don't worry, because whatever call altered the startTime would complete if it was necessary at the new time. The only exception is the timeScale property. Also check _gc because there's a chance that kill() could be called in an onUpdate
				if (isComplete) {
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onComplete on a timeline that reports/checks tweened values.
						_lazyRender();
					}
					if (self._timeline.autoRemoveChildren) {
						self._enabled(false, false);
					}
					self._active = false;
				}
				if (!suppressEvents && self.vars[callback]) {
					self._callback(callback);
				}
			}
		};

		p.getActive = function(nested, tweens, timelines) {
			var a = [],
				all = this.getChildren(nested || (nested == null), tweens || (nested == null), !!timelines),
				cnt = 0,
				l = all.length,
				i, tween;
			for (i = 0; i < l; i++) {
				tween = all[i];
				if (tween.isActive()) {
					a[cnt++] = tween;
				}
			}
			return a;
		};


		p.getLabelAfter = function(time) {
			if (!time) if (time !== 0) { //faster than isNan()
				time = this._time;
			}
			var labels = this.getLabelsArray(),
				l = labels.length,
				i;
			for (i = 0; i < l; i++) {
				if (labels[i].time > time) {
					return labels[i].name;
				}
			}
			return null;
		};

		p.getLabelBefore = function(time) {
			if (time == null) {
				time = this._time;
			}
			var labels = this.getLabelsArray(),
				i = labels.length;
			while (--i > -1) {
				if (labels[i].time < time) {
					return labels[i].name;
				}
			}
			return null;
		};

		p.getLabelsArray = function() {
			var a = [],
				cnt = 0,
				p;
			for (p in this._labels) {
				a[cnt++] = {time:this._labels[p], name:p};
			}
			a.sort(function(a,b) {
				return a.time - b.time;
			});
			return a;
		};

		p.invalidate = function() {
			this._locked = false; //unlock and set cycle in case invalidate() is called from inside an onRepeat
			return __WEBPACK_IMPORTED_MODULE_1__TimelineLite_js__["a" /* default */].prototype.invalidate.call(this);
		};


//---- GETTERS / SETTERS -------------------------------------------------------------------------------------------------------

		p.progress = function(value, suppressEvents) {
			return (!arguments.length) ? (this._time / this.duration()) || 0 : this.totalTime( this.duration() * ((this._yoyo && (this._cycle & 1) !== 0) ? 1 - value : value) + (this._cycle * (this._duration + this._repeatDelay)), suppressEvents);
		};

		p.totalProgress = function(value, suppressEvents) {
			return (!arguments.length) ? (this._totalTime / this.totalDuration()) || 0 : this.totalTime( this.totalDuration() * value, suppressEvents);
		};

		p.totalDuration = function(value) {
			if (!arguments.length) {
				if (this._dirty) {
					__WEBPACK_IMPORTED_MODULE_1__TimelineLite_js__["a" /* default */].prototype.totalDuration.call(this); //just forces refresh
					//Instead of Infinity, we use 999999999999 so that we can accommodate reverses.
					this._totalDuration = (this._repeat === -1) ? 999999999999 : this._duration * (this._repeat + 1) + (this._repeatDelay * this._repeat);
				}
				return this._totalDuration;
			}
			return (this._repeat === -1 || !value) ? this : this.timeScale( this.totalDuration() / value );
		};

		p.time = function(value, suppressEvents) {
			if (!arguments.length) {
				return this._time;
			}
			if (this._dirty) {
				this.totalDuration();
			}
			var duration = this._duration,
				cycle = this._cycle,
				cycleDur = cycle * (duration + this._repeatDelay);
			if (value > duration) {
				value = duration;
			}
			return this.totalTime((this._yoyo && (cycle & 1)) ? duration - value + cycleDur : this._repeat ? value + cycleDur : value, suppressEvents);
		};

		p.repeat = function(value) {
			if (!arguments.length) {
				return this._repeat;
			}
			this._repeat = value;
			return this._uncache(true);
		};

		p.repeatDelay = function(value) {
			if (!arguments.length) {
				return this._repeatDelay;
			}
			this._repeatDelay = value;
			return this._uncache(true);
		};

		p.yoyo = function(value) {
			if (!arguments.length) {
				return this._yoyo;
			}
			this._yoyo = value;
			return this;
		};

		p.currentLabel = function(value) {
			if (!arguments.length) {
				return this.getLabelBefore(this._time + _tinyNum);
			}
			return this.seek(value, true);
		};
		
		return TimelineMax;
		
	}, true);

var TimelineMax = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["globals"].TimelineMax;


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CSSPlugin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CSSPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__ = __webpack_require__(12);
/*!
 * VERSION: 2.1.3
 * DATE: 2019-05-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */
/* eslint-disable */



	__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["_gsScope"]._gsDefine("plugins.CSSPlugin", ["plugins.TweenPlugin","TweenLite"], function() {

		/** @constructor **/
		var CSSPlugin = function() {
				__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["TweenPlugin"].call(this, "css");
				this._overwriteProps.length = 0;
				this.setRatio = CSSPlugin.prototype.setRatio; //speed optimization (avoid prototype lookup on this "hot" method)
			},
			_globals = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["_gsScope"]._gsDefine.globals,
			_hasPriority, //turns true whenever a CSSPropTween instance is created that has a priority other than 0. This helps us discern whether or not we should spend the time organizing the linked list or not after a CSSPlugin's _onInitTween() method is called.
			_suffixMap, //we set this in _onInitTween() each time as a way to have a persistent variable we can use in other methods like _parse() without having to pass it around as a parameter and we keep _parse() decoupled from a particular CSSPlugin instance
			_cs, //computed style (we store this in a shared variable to conserve memory and make minification tighter
			_overwriteProps, //alias to the currently instantiating CSSPlugin's _overwriteProps array. We use this closure in order to avoid having to pass a reference around from method to method and aid in minification.
			_specialProps = {},
			p = CSSPlugin.prototype = new __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["TweenPlugin"]("css");

		p.constructor = CSSPlugin;
		CSSPlugin.version = "2.1.3";
		CSSPlugin.API = 2;
		CSSPlugin.defaultTransformPerspective = 0;
		CSSPlugin.defaultSkewType = "compensated";
		CSSPlugin.defaultSmoothOrigin = true;
		p = "px"; //we'll reuse the "p" variable to keep file size down
		CSSPlugin.suffixMap = {top:p, right:p, bottom:p, left:p, width:p, height:p, fontSize:p, padding:p, margin:p, perspective:p, lineHeight:""};


		var _numExp = /(?:\-|\.|\b)(\d|\.|e\-)+/g,
			_relNumExp = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
			_valuesExp = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi, //finds all the values that begin with numbers or += or -= and then a number. Includes suffixes. We use this to split complex values apart like "1px 5px 20px rgb(255,102,51)"
			_valuesExpWithCommas = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b),?/gi, //finds all the values that begin with numbers or += or -= and then a number. Includes suffixes. We use this to split complex values apart like "1px 5px 20px rgb(255,102,51)"
			_NaNExp = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g, //also allows scientific notation and doesn't kill the leading -/+ in -= and +=
			_suffixExp = /(?:\d|\-|\+|=|#|\.)*/g,
			_opacityExp = /opacity *= *([^)]*)/i,
			_opacityValExp = /opacity:([^;]*)/i,
			_alphaFilterExp = /alpha\(opacity *=.+?\)/i,
			_rgbhslExp = /^(rgb|hsl)/,
			_capsExp = /([A-Z])/g,
			_camelExp = /-([a-z])/gi,
			_urlExp = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi, //for pulling out urls from url(...) or url("...") strings (some browsers wrap urls in quotes, some don't when reporting things like backgroundImage)
			_camelFunc = function(s, g) { return g.toUpperCase(); },
			_horizExp = /(?:Left|Right|Width)/i,
			_ieGetMatrixExp = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
			_ieSetMatrixExp = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
			_commasOutsideParenExp = /,(?=[^\)]*(?:\(|$))/gi, //finds any commas that are not within parenthesis
			_complexExp = /[\s,\(]/i, //for testing a string to find if it has a space, comma, or open parenthesis (clues that it's a complex value)
			_DEG2RAD = Math.PI / 180,
			_RAD2DEG = 180 / Math.PI,
			_forcePT = {},
			_dummyElement = {style:{}},
			_doc = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["_gsScope"].document || {createElement: function() {return _dummyElement;}},
			_createElement = function(type, ns) {
				var e = _doc.createElementNS ? _doc.createElementNS(ns || "http://www.w3.org/1999/xhtml", type) : _doc.createElement(type);
				return e.style ? e : _doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://greensock.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
			},
			_tempDiv = _createElement("div"),
			_tempImg = _createElement("img"),
			_internals = CSSPlugin._internals = {_specialProps:_specialProps}, //provides a hook to a few internal methods that we need to access from inside other plugins
			_agent = (__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["_gsScope"].navigator || {}).userAgent || "",
			_autoRound,
			_reqSafariFix, //we won't apply the Safari transform fix until we actually come across a tween that affects a transform property (to maintain best performance).

			_isSafari,
			_isFirefox, //Firefox has a bug that causes 3D transformed elements to randomly disappear unless a repaint is forced after each update on each element.
			_isSafariLT6, //Safari (and Android 4 which uses a flavor of Safari) has a bug that prevents changes to "top" and "left" properties from rendering properly if changed on the same frame as a transform UNLESS we set the element's WebkitBackfaceVisibility to hidden (weird, I know). Doing this for Android 3 and earlier seems to actually cause other problems, though (fun!)
			_ieVers,
			_supportsOpacity = (function() { //we set _isSafari, _ieVers, _isFirefox, and _supportsOpacity all in one function here to reduce file size slightly, especially in the minified version.
				var i = _agent.indexOf("Android"),
					a = _createElement("a");
				_isSafari = (_agent.indexOf("Safari") !== -1 && _agent.indexOf("Chrome") === -1 && (i === -1 || parseFloat(_agent.substr(i+8, 2)) > 3));
				_isSafariLT6 = (_isSafari && (parseFloat(_agent.substr(_agent.indexOf("Version/")+8, 2)) < 6));
				_isFirefox = (_agent.indexOf("Firefox") !== -1);
				if ((/MSIE ([0-9]{1,}[\.0-9]{0,})/).exec(_agent) || (/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/).exec(_agent)) {
					_ieVers = parseFloat( RegExp.$1 );
				}
				if (!a) {
					return false;
				}
				a.style.cssText = "top:1px;opacity:.55;";
				return /^0.55/.test(a.style.opacity);
			}()),
			_getIEOpacity = function(v) {
				return (_opacityExp.test( ((typeof(v) === "string") ? v : (v.currentStyle ? v.currentStyle.filter : v.style.filter) || "") ) ? ( parseFloat( RegExp.$1 ) / 100 ) : 1);
			},
			_log = function(s) {//for logging messages, but in a way that won't throw errors in old versions of IE.
				if (__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["_gsScope"].console) {
					console.log(s);
				}
			},
			_target, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params
			_index, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params

			_prefixCSS = "", //the non-camelCase vendor prefix like "-o-", "-moz-", "-ms-", or "-webkit-"
			_prefix = "", //camelCase vendor prefix like "O", "ms", "Webkit", or "Moz".

			// @private feed in a camelCase property name like "transform" and it will check to see if it is valid as-is or if it needs a vendor prefix. It returns the corrected camelCase property name (i.e. "WebkitTransform" or "MozTransform" or "transform" or null if no such property is found, like if the browser is IE8 or before, "transform" won't be found at all)
			_checkPropPrefix = function(p, e) {
				e = e || _tempDiv;
				var s = e.style,
					a, i;
				if (s[p] !== undefined) {
					return p;
				}
				p = p.charAt(0).toUpperCase() + p.substr(1);
				a = ["O","Moz","ms","Ms","Webkit"];
				i = 5;
				while (--i > -1 && s[a[i]+p] === undefined) { }
				if (i >= 0) {
					_prefix = (i === 3) ? "ms" : a[i];
					_prefixCSS = "-" + _prefix.toLowerCase() + "-";
					return _prefix + p;
				}
				return null;
			},

			_computedStyleScope = (typeof(window) !== "undefined" ? window : _doc.defaultView || {getComputedStyle:function() {}}),
			_getComputedStyle = function(e) {
				return _computedStyleScope.getComputedStyle(e); //to avoid errors in Microsoft Edge, we need to call getComputedStyle() from a specific scope, typically window.
			},

			/**
			 * @private Returns the css style for a particular property of an element. For example, to get whatever the current "left" css value for an element with an ID of "myElement", you could do:
			 * var currentLeft = CSSPlugin.getStyle( document.getElementById("myElement"), "left");
			 *
			 * @param {!Object} t Target element whose style property you want to query
			 * @param {!string} p Property name (like "left" or "top" or "marginTop", etc.)
			 * @param {Object=} cs Computed style object. This just provides a way to speed processing if you're going to get several properties on the same element in quick succession - you can reuse the result of the getComputedStyle() call.
			 * @param {boolean=} calc If true, the value will not be read directly from the element's "style" property (if it exists there), but instead the getComputedStyle() result will be used. This can be useful when you want to ensure that the browser itself is interpreting the value.
			 * @param {string=} dflt Default value that should be returned in the place of null, "none", "auto" or "auto auto".
			 * @return {?string} The current property value
			 */
			_getStyle = CSSPlugin.getStyle = function(t, p, cs, calc, dflt) {
				var rv;
				if (!_supportsOpacity) if (p === "opacity") { //several versions of IE don't use the standard "opacity" property - they use things like filter:alpha(opacity=50), so we parse that here.
					return _getIEOpacity(t);
				}
				if (!calc && t.style[p]) {
					rv = t.style[p];
				} else if ((cs = cs || _getComputedStyle(t))) {
					rv = cs[p] || cs.getPropertyValue(p) || cs.getPropertyValue(p.replace(_capsExp, "-$1").toLowerCase());
				} else if (t.currentStyle) {
					rv = t.currentStyle[p];
				}
				return (dflt != null && (!rv || rv === "none" || rv === "auto" || rv === "auto auto")) ? dflt : rv;
			},

			/**
			 * @private Pass the target element, the property name, the numeric value, and the suffix (like "%", "em", "px", etc.) and it will spit back the equivalent pixel number.
			 * @param {!Object} t Target element
			 * @param {!string} p Property name (like "left", "top", "marginLeft", etc.)
			 * @param {!number} v Value
			 * @param {string=} sfx Suffix (like "px" or "%" or "em")
			 * @param {boolean=} recurse If true, the call is a recursive one. In some browsers (like IE7/8), occasionally the value isn't accurately reported initially, but if we run the function again it will take effect.
			 * @return {number} value in pixels
			 */
			_convertToPixels = _internals.convertToPixels = function(t, p, v, sfx, recurse) {
				if (sfx === "px" || (!sfx && p !== "lineHeight")) { return v; }
				if (sfx === "auto" || !v) { return 0; }
				var horiz = _horizExp.test(p),
					node = t,
					style = _tempDiv.style,
					neg = (v < 0),
					precise = (v === 1),
					pix, cache, time;
				if (neg) {
					v = -v;
				}
				if (precise) {
					v *= 100;
				}
				if (p === "lineHeight" && !sfx) { //special case of when a simple lineHeight (without a unit) is used. Set it to the value, read back the computed value, and then revert.
					cache = _getComputedStyle(t).lineHeight;
					t.style.lineHeight = v;
					pix = parseFloat(_getComputedStyle(t).lineHeight);
					t.style.lineHeight = cache;
				} else if (sfx === "%" && p.indexOf("border") !== -1) {
					pix = (v / 100) * (horiz ? t.clientWidth : t.clientHeight);
				} else {
					style.cssText = "border:0 solid red;position:" + _getStyle(t, "position") + ";line-height:0;";
					if (sfx === "%" || !node.appendChild || sfx.charAt(0) === "v" || sfx === "rem") {
						node = t.parentNode || _doc.body;
						if (_getStyle(node, "display").indexOf("flex") !== -1) { //Edge and IE11 have a bug that causes offsetWidth to report as 0 if the container has display:flex and the child is position:relative. Switching to position: absolute solves it.
							style.position = "absolute";
						}
						cache = node._gsCache;
						time = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].ticker.frame;
						if (cache && horiz && cache.time === time) { //performance optimization: we record the width of elements along with the ticker frame so that we can quickly get it again on the same tick (seems relatively safe to assume it wouldn't change on the same tick)
							return cache.width * v / 100;
						}
						style[(horiz ? "width" : "height")] = v + sfx;
					} else {
						style[(horiz ? "borderLeftWidth" : "borderTopWidth")] = v + sfx;
					}
					node.appendChild(_tempDiv);
					pix = parseFloat(_tempDiv[(horiz ? "offsetWidth" : "offsetHeight")]);
					node.removeChild(_tempDiv);
					if (horiz && sfx === "%" && CSSPlugin.cacheWidths !== false) {
						cache = node._gsCache = node._gsCache || {};
						cache.time = time;
						cache.width = pix / v * 100;
					}
					if (pix === 0 && !recurse) {
						pix = _convertToPixels(t, p, v, sfx, true);
					}
				}
				if (precise) {
					pix /= 100;
				}
				return neg ? -pix : pix;
			},
			_calculateOffset = _internals.calculateOffset = function(t, p, cs) { //for figuring out "top" or "left" in px when it's "auto". We need to factor in margin with the offsetLeft/offsetTop
				if (_getStyle(t, "position", cs) !== "absolute") { return 0; }
				var dim = ((p === "left") ? "Left" : "Top"),
					v = _getStyle(t, "margin" + dim, cs);
				return t["offset" + dim] - (_convertToPixels(t, p, parseFloat(v), v.replace(_suffixExp, "")) || 0);
			},

			// @private returns at object containing ALL of the style properties in camelCase and their associated values.
			_getAllStyles = function(t, cs) {
				var s = {},
					i, tr, p;
				if ((cs = cs || _getComputedStyle(t, null))) {
					if ((i = cs.length)) {
						while (--i > -1) {
							p = cs[i];
							if (p.indexOf("-transform") === -1 || _transformPropCSS === p) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
								s[p.replace(_camelExp, _camelFunc)] = cs.getPropertyValue(p);
							}
						}
					} else { //some browsers behave differently - cs.length is always 0, so we must do a for...in loop.
						for (i in cs) {
							if (i.indexOf("Transform") === -1 || _transformProp === i) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
								s[i] = cs[i];
							}
						}
					}
				} else if ((cs = t.currentStyle || t.style)) {
					for (i in cs) {
						if (typeof(i) === "string" && s[i] === undefined) {
							s[i.replace(_camelExp, _camelFunc)] = cs[i];
						}
					}
				}
				if (!_supportsOpacity) {
					s.opacity = _getIEOpacity(t);
				}
				tr = _getTransform(t, cs, false);
				s.rotation = tr.rotation;
				s.skewX = tr.skewX;
				s.scaleX = tr.scaleX;
				s.scaleY = tr.scaleY;
				s.x = tr.x;
				s.y = tr.y;
				if (_supports3D) {
					s.z = tr.z;
					s.rotationX = tr.rotationX;
					s.rotationY = tr.rotationY;
					s.scaleZ = tr.scaleZ;
				}
				if (s.filters) {
					delete s.filters;
				}
				return s;
			},

			// @private analyzes two style objects (as returned by _getAllStyles()) and only looks for differences between them that contain tweenable values (like a number or color). It returns an object with a "difs" property which refers to an object containing only those isolated properties and values for tweening, and a "firstMPT" property which refers to the first MiniPropTween instance in a linked list that recorded all the starting values of the different properties so that we can revert to them at the end or beginning of the tween - we don't want the cascading to get messed up. The forceLookup parameter is an optional generic object with properties that should be forced into the results - this is necessary for className tweens that are overwriting others because imagine a scenario where a rollover/rollout adds/removes a class and the user swipes the mouse over the target SUPER fast, thus nothing actually changed yet and the subsequent comparison of the properties would indicate they match (especially when px rounding is taken into consideration), thus no tweening is necessary even though it SHOULD tween and remove those properties after the tween (otherwise the inline styles will contaminate things). See the className SpecialProp code for details.
			_cssDif = function(t, s1, s2, vars, forceLookup) {
				var difs = {},
					style = t.style,
					val, p, mpt;
				for (p in s2) {
					if (p !== "cssText") if (p !== "length") if (isNaN(p)) if (s1[p] !== (val = s2[p]) || (forceLookup && forceLookup[p])) if (p.indexOf("Origin") === -1) if (typeof(val) === "number" || typeof(val) === "string") {
						difs[p] = (val === "auto" && (p === "left" || p === "top")) ? _calculateOffset(t, p) : ((val === "" || val === "auto" || val === "none") && typeof(s1[p]) === "string" && s1[p].replace(_NaNExp, "") !== "") ? 0 : val; //if the ending value is defaulting ("" or "auto"), we check the starting value and if it can be parsed into a number (a string which could have a suffix too, like 700px), then we swap in 0 for "" or "auto" so that things actually tween.
						if (style[p] !== undefined) { //for className tweens, we must remember which properties already existed inline - the ones that didn't should be removed when the tween isn't in progress because they were only introduced to facilitate the transition between classes.
							mpt = new MiniPropTween(style, p, style[p], mpt);
						}
					}
				}
				if (vars) {
					for (p in vars) { //copy properties (except className)
						if (p !== "className") {
							difs[p] = vars[p];
						}
					}
				}
				return {difs:difs, firstMPT:mpt};
			},
			_dimensions = {width:["Left","Right"], height:["Top","Bottom"]},
			_margins = ["marginLeft","marginRight","marginTop","marginBottom"],

			/**
			 * @private Gets the width or height of an element
			 * @param {!Object} t Target element
			 * @param {!string} p Property name ("width" or "height")
			 * @param {Object=} cs Computed style object (if one exists). Just a speed optimization.
			 * @return {number} Dimension (in pixels)
			 */
			_getDimension = function(t, p, cs) {
				if ((t.nodeName + "").toLowerCase() === "svg") { //Chrome no longer supports offsetWidth/offsetHeight on SVG elements.
					return (cs || _getComputedStyle(t))[p] || 0;
				} else if (t.getCTM && _isSVG(t)) {
					return t.getBBox()[p] || 0;
				}
				var v = parseFloat((p === "width") ? t.offsetWidth : t.offsetHeight),
					a = _dimensions[p],
					i = a.length;
				cs = cs || _getComputedStyle(t, null);
				while (--i > -1) {
					v -= parseFloat( _getStyle(t, "padding" + a[i], cs, true) ) || 0;
					v -= parseFloat( _getStyle(t, "border" + a[i] + "Width", cs, true) ) || 0;
				}
				return v;
			},

			// @private Parses position-related complex strings like "top left" or "50px 10px" or "70% 20%", etc. which are used for things like transformOrigin or backgroundPosition. Optionally decorates a supplied object (recObj) with the following properties: "ox" (offsetX), "oy" (offsetY), "oxp" (if true, "ox" is a percentage not a pixel value), and "oxy" (if true, "oy" is a percentage not a pixel value)
			_parsePosition = function(v, recObj) {
				if (v === "contain" || v === "auto" || v === "auto auto") { //note: Firefox uses "auto auto" as default whereas Chrome uses "auto".
					return v + " ";
				}
				if (v == null || v === "") {
					v = "0 0";
				}
				var a = v.split(" "),
					x = (v.indexOf("left") !== -1) ? "0%" : (v.indexOf("right") !== -1) ? "100%" : a[0],
					y = (v.indexOf("top") !== -1) ? "0%" : (v.indexOf("bottom") !== -1) ? "100%" : a[1],
					i;
				if (a.length > 3 && !recObj) { //multiple positions
					a = v.split(", ").join(",").split(",");
					v = [];
					for (i = 0; i < a.length; i++) {
						v.push(_parsePosition(a[i]));
					}
					return v.join(",");
				}
				if (y == null) {
					y = (x === "center") ? "50%" : "0";
				} else if (y === "center") {
					y = "50%";
				}
				if (x === "center" || (isNaN(parseFloat(x)) && (x + "").indexOf("=") === -1)) { //remember, the user could flip-flop the values and say "bottom center" or "center bottom", etc. "center" is ambiguous because it could be used to describe horizontal or vertical, hence the isNaN(). If there's an "=" sign in the value, it's relative.
					x = "50%";
				}
				v = x + " " + y + ((a.length > 2) ? " " + a[2] : "");
				if (recObj) {
					recObj.oxp = (x.indexOf("%") !== -1);
					recObj.oyp = (y.indexOf("%") !== -1);
					recObj.oxr = (x.charAt(1) === "=");
					recObj.oyr = (y.charAt(1) === "=");
					recObj.ox = parseFloat(x.replace(_NaNExp, ""));
					recObj.oy = parseFloat(y.replace(_NaNExp, ""));
					recObj.v = v;
				}
				return recObj || v;
			},

			/**
			 * @private Takes an ending value (typically a string, but can be a number) and a starting value and returns the change between the two, looking for relative value indicators like += and -= and it also ignores suffixes (but make sure the ending value starts with a number or +=/-= and that the starting value is a NUMBER!)
			 * @param {(number|string)} e End value which is typically a string, but could be a number
			 * @param {(number|string)} b Beginning value which is typically a string but could be a number
			 * @return {number} Amount of change between the beginning and ending values (relative values that have a "+=" or "-=" are recognized)
			 */
			_parseChange = function(e, b) {
				if (typeof(e) === "function") {
					e = e(_index, _target);
				}
				return (typeof(e) === "string" && e.charAt(1) === "=") ? parseInt(e.charAt(0) + "1", 10) * parseFloat(e.substr(2)) : (parseFloat(e) - parseFloat(b)) || 0;
			},

			/**
			 * @private Takes a value and a default number, checks if the value is relative, null, or numeric and spits back a normalized number accordingly. Primarily used in the _parseTransform() function.
			 * @param {Object} v Value to be parsed
			 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
			 * @return {number} Parsed value
			 */
			_parseVal = function(v, d) {
				if (typeof(v) === "function") {
					v = v(_index, _target);
				}
				var isRelative = (typeof(v) === "string" && v.charAt(1) === "=");
				if (typeof(v) === "string" && v.charAt(v.length - 2) === "v") { //convert vw and vh into px-equivalents.
					v = (isRelative ? v.substr(0, 2) : 0) + (window["inner" + ((v.substr(-2) === "vh") ? "Height" : "Width")] * (parseFloat(isRelative ? v.substr(2) : v) / 100));
				}
				return (v == null) ? d : isRelative ? parseInt(v.charAt(0) + "1", 10) * parseFloat(v.substr(2)) + d : parseFloat(v) || 0;
			},

			/**
			 * @private Translates strings like "40deg" or "40" or 40rad" or "+=40deg" or "270_short" or "-90_cw" or "+=45_ccw" to a numeric radian angle. Of course a starting/default value must be fed in too so that relative values can be calculated properly.
			 * @param {Object} v Value to be parsed
			 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
			 * @param {string=} p property name for directionalEnd (optional - only used when the parsed value is directional ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation). Property name would be "rotation", "rotationX", or "rotationY"
			 * @param {Object=} directionalEnd An object that will store the raw end values for directional angles ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation.
			 * @return {number} parsed angle in radians
			 */
			_parseAngle = function(v, d, p, directionalEnd) {
				var min = 0.000001,
					cap, split, dif, result, isRelative;
				if (typeof(v) === "function") {
					v = v(_index, _target);
				}
				if (v == null) {
					result = d;
				} else if (typeof(v) === "number") {
					result = v;
				} else {
					cap = 360;
					split = v.split("_");
					isRelative = (v.charAt(1) === "=");
					dif = (isRelative ? parseInt(v.charAt(0) + "1", 10) * parseFloat(split[0].substr(2)) : parseFloat(split[0])) * ((v.indexOf("rad") === -1) ? 1 : _RAD2DEG) - (isRelative ? 0 : d);
					if (split.length) {
						if (directionalEnd) {
							directionalEnd[p] = d + dif;
						}
						if (v.indexOf("short") !== -1) {
							dif = dif % cap;
							if (dif !== dif % (cap / 2)) {
								dif = (dif < 0) ? dif + cap : dif - cap;
							}
						}
						if (v.indexOf("_cw") !== -1 && dif < 0) {
							dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
						} else if (v.indexOf("ccw") !== -1 && dif > 0) {
							dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
						}
					}
					result = d + dif;
				}
				if (result < min && result > -min) {
					result = 0;
				}
				return result;
			},

			_colorLookup = {aqua:[0,255,255],
				lime:[0,255,0],
				silver:[192,192,192],
				black:[0,0,0],
				maroon:[128,0,0],
				teal:[0,128,128],
				blue:[0,0,255],
				navy:[0,0,128],
				white:[255,255,255],
				fuchsia:[255,0,255],
				olive:[128,128,0],
				yellow:[255,255,0],
				orange:[255,165,0],
				gray:[128,128,128],
				purple:[128,0,128],
				green:[0,128,0],
				red:[255,0,0],
				pink:[255,192,203],
				cyan:[0,255,255],
				transparent:[255,255,255,0]},

			_hue = function(h, m1, m2) {
				h = (h < 0) ? h + 1 : (h > 1) ? h - 1 : h;
				return ((((h * 6 < 1) ? m1 + (m2 - m1) * h * 6 : (h < 0.5) ? m2 : (h * 3 < 2) ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * 255) + 0.5) | 0;
			},

			/**
			 * @private Parses a color (like #9F0, #FF9900, rgb(255,51,153) or hsl(108, 50%, 10%)) into an array with 3 elements for red, green, and blue or if toHSL parameter is true, it will populate the array with hue, saturation, and lightness values. If a relative value is found in an hsl() or hsla() string, it will preserve those relative prefixes and all the values in the array will be strings instead of numbers (in all other cases it will be populated with numbers).
			 * @param {(string|number)} v The value the should be parsed which could be a string like #9F0 or rgb(255,102,51) or rgba(255,0,0,0.5) or it could be a number like 0xFF00CC or even a named color like red, blue, purple, etc.
			 * @param {(boolean)} toHSL If true, an hsl() or hsla() value will be returned instead of rgb() or rgba()
			 * @return {Array.<number>} An array containing red, green, and blue (and optionally alpha) in that order, or if the toHSL parameter was true, the array will contain hue, saturation and lightness (and optionally alpha) in that order. Always numbers unless there's a relative prefix found in an hsl() or hsla() string and toHSL is true.
			 */
			_parseColor = CSSPlugin.parseColor = function(v, toHSL) {
				var a, r, g, b, h, s, l, max, min, d, wasHSL;
				if (!v) {
					a = _colorLookup.black;
				} else if (typeof(v) === "number") {
					a = [v >> 16, (v >> 8) & 255, v & 255];
				} else {
					if (v.charAt(v.length - 1) === ",") { //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
						v = v.substr(0, v.length - 1);
					}
					if (_colorLookup[v]) {
						a = _colorLookup[v];
					} else if (v.charAt(0) === "#") {
						if (v.length === 4) { //for shorthand like #9F0
							r = v.charAt(1);
							g = v.charAt(2);
							b = v.charAt(3);
							v = "#" + r + r + g + g + b + b;
						}
						v = parseInt(v.substr(1), 16);
						a = [v >> 16, (v >> 8) & 255, v & 255];
					} else if (v.substr(0, 3) === "hsl") {
						a = wasHSL = v.match(_numExp);
						if (!toHSL) {
							h = (Number(a[0]) % 360) / 360;
							s = Number(a[1]) / 100;
							l = Number(a[2]) / 100;
							g = (l <= 0.5) ? l * (s + 1) : l + s - l * s;
							r = l * 2 - g;
							if (a.length > 3) {
								a[3] = Number(a[3]);
							}
							a[0] = _hue(h + 1 / 3, r, g);
							a[1] = _hue(h, r, g);
							a[2] = _hue(h - 1 / 3, r, g);
						} else if (v.indexOf("=") !== -1) { //if relative values are found, just return the raw strings with the relative prefixes in place.
							return v.match(_relNumExp);
						}
					} else {
						a = v.match(_numExp) || _colorLookup.transparent;
					}
					a[0] = Number(a[0]);
					a[1] = Number(a[1]);
					a[2] = Number(a[2]);
					if (a.length > 3) {
						a[3] = Number(a[3]);
					}
				}
				if (toHSL && !wasHSL) {
					r = a[0] / 255;
					g = a[1] / 255;
					b = a[2] / 255;
					max = Math.max(r, g, b);
					min = Math.min(r, g, b);
					l = (max + min) / 2;
					if (max === min) {
						h = s = 0;
					} else {
						d = max - min;
						s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
						h = (max === r) ? (g - b) / d + (g < b ? 6 : 0) : (max === g) ? (b - r) / d + 2 : (r - g) / d + 4;
						h *= 60;
					}
					a[0] = (h + 0.5) | 0;
					a[1] = (s * 100 + 0.5) | 0;
					a[2] = (l * 100 + 0.5) | 0;
				}
				return a;
			},
			_formatColors = function(s, toHSL) {
				var colors = s.match(_colorExp) || [],
					charIndex = 0,
					parsed = "",
					i, color, temp;
				if (!colors.length) {
					return s;
				}
				for (i = 0; i < colors.length; i++) {
					color = colors[i];
					temp = s.substr(charIndex, s.indexOf(color, charIndex)-charIndex);
					charIndex += temp.length + color.length;
					color = _parseColor(color, toHSL);
					if (color.length === 3) {
						color.push(1);
					}
					parsed += temp + (toHSL ? "hsla(" + color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : "rgba(" + color.join(",")) + ")";
				}
				return parsed + s.substr(charIndex);
			},
			_colorExp = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b"; //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.

		for (p in _colorLookup) {
			_colorExp += "|" + p + "\\b";
		}
		_colorExp = new RegExp(_colorExp+")", "gi");

		CSSPlugin.colorStringFilter = function(a) {
			var combined = a[0] + " " + a[1],
				toHSL;
			if (_colorExp.test(combined)) {
				toHSL = (combined.indexOf("hsl(") !== -1 || combined.indexOf("hsla(") !== -1);
				a[0] = _formatColors(a[0], toHSL);
				a[1] = _formatColors(a[1], toHSL);
			}
			_colorExp.lastIndex = 0;
		};

		if (!__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].defaultStringFilter) {
			__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].defaultStringFilter = CSSPlugin.colorStringFilter;
		}

		/**
		 * @private Returns a formatter function that handles taking a string (or number in some cases) and returning a consistently formatted one in terms of delimiters, quantity of values, etc. For example, we may get boxShadow values defined as "0px red" or "0px 0px 10px rgb(255,0,0)" or "0px 0px 20px 20px #F00" and we need to ensure that what we get back is described with 4 numbers and a color. This allows us to feed it into the _parseComplex() method and split the values up appropriately. The neat thing about this _getFormatter() function is that the dflt defines a pattern as well as a default, so for example, _getFormatter("0px 0px 0px 0px #777", true) not only sets the default as 0px for all distances and #777 for the color, but also sets the pattern such that 4 numbers and a color will always get returned.
		 * @param {!string} dflt The default value and pattern to follow. So "0px 0px 0px 0px #777" will ensure that 4 numbers and a color will always get returned.
		 * @param {boolean=} clr If true, the values should be searched for color-related data. For example, boxShadow values typically contain a color whereas borderRadius don't.
		 * @param {boolean=} collapsible If true, the value is a top/left/right/bottom style one that acts like margin or padding, where if only one value is received, it's used for all 4; if 2 are received, the first is duplicated for 3rd (bottom) and the 2nd is duplicated for the 4th spot (left), etc.
		 * @return {Function} formatter function
		 */
		var _getFormatter = function(dflt, clr, collapsible, multi) {
				if (dflt == null) {
					return function(v) {return v;};
				}
				var dColor = clr ? (dflt.match(_colorExp) || [""])[0] : "",
					dVals = dflt.split(dColor).join("").match(_valuesExp) || [],
					pfx = dflt.substr(0, dflt.indexOf(dVals[0])),
					sfx = (dflt.charAt(dflt.length - 1) === ")") ? ")" : "",
					delim = (dflt.indexOf(" ") !== -1) ? " " : ",",
					numVals = dVals.length,
					dSfx = (numVals > 0) ? dVals[0].replace(_numExp, "") : "",
					formatter;
				if (!numVals) {
					return function(v) {return v;};
				}
				if (clr) {
					formatter = function(v) {
						var color, vals, i, a;
						if (typeof(v) === "number") {
							v += dSfx;
						} else if (multi && _commasOutsideParenExp.test(v)) {
							a = v.replace(_commasOutsideParenExp, "|").split("|");
							for (i = 0; i < a.length; i++) {
								a[i] = formatter(a[i]);
							}
							return a.join(",");
						}
						color = (v.match(_colorExp) || [dColor])[0];
						vals = v.split(color).join("").match(_valuesExp) || [];
						i = vals.length;
						if (numVals > i--) {
							while (++i < numVals) {
								vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
							}
						}
						return pfx + vals.join(delim) + delim + color + sfx + (v.indexOf("inset") !== -1 ? " inset" : "");
					};
					return formatter;

				}
				formatter = function(v) {
					var vals, a, i;
					if (typeof(v) === "number") {
						v += dSfx;
					} else if (multi && _commasOutsideParenExp.test(v)) {
						a = v.replace(_commasOutsideParenExp, "|").split("|");
						for (i = 0; i < a.length; i++) {
							a[i] = formatter(a[i]);
						}
						return a.join(",");
					}
					vals = v.match(delim === "," ? _valuesExp : _valuesExpWithCommas) || [];
					i = vals.length;
					if (numVals > i--) {
						while (++i < numVals) {
							vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
						}
					}
					return ((pfx && v !== "none") ? v.substr(0, v.indexOf(vals[0])) || pfx : pfx) + vals.join(delim) + sfx; //note: prefix might be different, like for clipPath it could start with inset( or polygon(
				};
				return formatter;
			},

			/**
			 * @private returns a formatter function that's used for edge-related values like marginTop, marginLeft, paddingBottom, paddingRight, etc. Just pass a comma-delimited list of property names related to the edges.
			 * @param {!string} props a comma-delimited list of property names in order from top to left, like "marginTop,marginRight,marginBottom,marginLeft"
			 * @return {Function} a formatter function
			 */
			_getEdgeParser = function(props) {
				props = props.split(",");
				return function(t, e, p, cssp, pt, plugin, vars) {
					var a = (e + "").split(" "),
						i;
					vars = {};
					for (i = 0; i < 4; i++) {
						vars[props[i]] = a[i] = a[i] || a[(((i - 1) / 2) >> 0)];
					}
					return cssp.parse(t, vars, pt, plugin);
				};
			},

			// @private used when other plugins must tween values first, like BezierPlugin or ThrowPropsPlugin, etc. That plugin's setRatio() gets called first so that the values are updated, and then we loop through the MiniPropTweens which handle copying the values into their appropriate slots so that they can then be applied correctly in the main CSSPlugin setRatio() method. Remember, we typically create a proxy object that has a bunch of uniquely-named properties that we feed to the sub-plugin and it does its magic normally, and then we must interpret those values and apply them to the css because often numbers must get combined/concatenated, suffixes added, etc. to work with css, like boxShadow could have 4 values plus a color.
			_setPluginRatio = _internals._setPluginRatio = function(v) {
				this.plugin.setRatio(v);
				var d = this.data,
					proxy = d.proxy,
					mpt = d.firstMPT,
					min = 0.000001,
					val, pt, i, str, p;
				while (mpt) {
					val = proxy[mpt.v];
					if (mpt.r) {
						val = mpt.r(val);
					} else if (val < min && val > -min) {
						val = 0;
					}
					mpt.t[mpt.p] = val;
					mpt = mpt._next;
				}
				if (d.autoRotate) {
					d.autoRotate.rotation = d.mod ? d.mod.call(this._tween, proxy.rotation, this.t, this._tween) : proxy.rotation; //special case for ModifyPlugin to hook into an auto-rotating bezier
				}
				//at the end, we must set the CSSPropTween's "e" (end) value dynamically here because that's what is used in the final setRatio() method. Same for "b" at the beginning.
				if (v === 1 || v === 0) {
					mpt = d.firstMPT;
					p = (v === 1) ? "e" : "b";
					while (mpt) {
						pt = mpt.t;
						if (!pt.type) {
							pt[p] = pt.s + pt.xs0;
						} else if (pt.type === 1) {
							str = pt.xs0 + pt.s + pt.xs1;
							for (i = 1; i < pt.l; i++) {
								str += pt["xn"+i] + pt["xs"+(i+1)];
							}
							pt[p] = str;
						}
						mpt = mpt._next;
					}
				}
			},

			/**
			 * @private @constructor Used by a few SpecialProps to hold important values for proxies. For example, _parseToProxy() creates a MiniPropTween instance for each property that must get tweened on the proxy, and we record the original property name as well as the unique one we create for the proxy, plus whether or not the value needs to be rounded plus the original value.
			 * @param {!Object} t target object whose property we're tweening (often a CSSPropTween)
			 * @param {!string} p property name
			 * @param {(number|string|object)} v value
			 * @param {MiniPropTween=} next next MiniPropTween in the linked list
			 * @param {boolean=} r if true, the tweened value should be rounded to the nearest integer
			 */
			MiniPropTween = function(t, p, v, next, r) {
				this.t = t;
				this.p = p;
				this.v = v;
				this.r = r;
				if (next) {
					next._prev = this;
					this._next = next;
				}
			},

			/**
			 * @private Most other plugins (like BezierPlugin and ThrowPropsPlugin and others) can only tween numeric values, but CSSPlugin must accommodate special values that have a bunch of extra data (like a suffix or strings between numeric values, etc.). For example, boxShadow has values like "10px 10px 20px 30px rgb(255,0,0)" which would utterly confuse other plugins. This method allows us to split that data apart and grab only the numeric data and attach it to uniquely-named properties of a generic proxy object ({}) so that we can feed that to virtually any plugin to have the numbers tweened. However, we must also keep track of which properties from the proxy go with which CSSPropTween values and instances. So we create a linked list of MiniPropTweens. Each one records a target (the original CSSPropTween), property (like "s" or "xn1" or "xn2") that we're tweening and the unique property name that was used for the proxy (like "boxShadow_xn1" and "boxShadow_xn2") and whether or not they need to be rounded. That way, in the _setPluginRatio() method we can simply copy the values over from the proxy to the CSSPropTween instance(s). Then, when the main CSSPlugin setRatio() method runs and applies the CSSPropTween values accordingly, they're updated nicely. So the external plugin tweens the numbers, _setPluginRatio() copies them over, and setRatio() acts normally, applying css-specific values to the element.
			 * This method returns an object that has the following properties:
			 *  - proxy: a generic object containing the starting values for all the properties that will be tweened by the external plugin.  This is what we feed to the external _onInitTween() as the target
			 *  - end: a generic object containing the ending values for all the properties that will be tweened by the external plugin. This is what we feed to the external plugin's _onInitTween() as the destination values
			 *  - firstMPT: the first MiniPropTween in the linked list
			 *  - pt: the first CSSPropTween in the linked list that was created when parsing. If shallow is true, this linked list will NOT attach to the one passed into the _parseToProxy() as the "pt" (4th) parameter.
			 * @param {!Object} t target object to be tweened
			 * @param {!(Object|string)} vars the object containing the information about the tweening values (typically the end/destination values) that should be parsed
			 * @param {!CSSPlugin} cssp The CSSPlugin instance
			 * @param {CSSPropTween=} pt the next CSSPropTween in the linked list
			 * @param {TweenPlugin=} plugin the external TweenPlugin instance that will be handling tweening the numeric values
			 * @param {boolean=} shallow if true, the resulting linked list from the parse will NOT be attached to the CSSPropTween that was passed in as the "pt" (4th) parameter.
			 * @return An object containing the following properties: proxy, end, firstMPT, and pt (see above for descriptions)
			 */
			_parseToProxy = _internals._parseToProxy = function(t, vars, cssp, pt, plugin, shallow) {
				var bpt = pt,
					start = {},
					end = {},
					transform = cssp._transform,
					oldForce = _forcePT,
					i, p, xp, mpt, firstPT;
				cssp._transform = null;
				_forcePT = vars;
				pt = firstPT = cssp.parse(t, vars, pt, plugin);
				_forcePT = oldForce;
				//break off from the linked list so the new ones are isolated.
				if (shallow) {
					cssp._transform = transform;
					if (bpt) {
						bpt._prev = null;
						if (bpt._prev) {
							bpt._prev._next = null;
						}
					}
				}
				while (pt && pt !== bpt) {
					if (pt.type <= 1) {
						p = pt.p;
						end[p] = pt.s + pt.c;
						start[p] = pt.s;
						if (!shallow) {
							mpt = new MiniPropTween(pt, "s", p, mpt, pt.r);
							pt.c = 0;
						}
						if (pt.type === 1) {
							i = pt.l;
							while (--i > 0) {
								xp = "xn" + i;
								p = pt.p + "_" + xp;
								end[p] = pt.data[xp];
								start[p] = pt[xp];
								if (!shallow) {
									mpt = new MiniPropTween(pt, xp, p, mpt, pt.rxp[xp]);
								}
							}
						}
					}
					pt = pt._next;
				}
				return {proxy:start, end:end, firstMPT:mpt, pt:firstPT};
			},



			/**
			 * @constructor Each property that is tweened has at least one CSSPropTween associated with it. These instances store important information like the target, property, starting value, amount of change, etc. They can also optionally have a number of "extra" strings and numeric values named xs1, xn1, xs2, xn2, xs3, xn3, etc. where "s" indicates string and "n" indicates number. These can be pieced together in a complex-value tween (type:1) that has alternating types of data like a string, number, string, number, etc. For example, boxShadow could be "5px 5px 8px rgb(102, 102, 51)". In that value, there are 6 numbers that may need to tween and then pieced back together into a string again with spaces, suffixes, etc. xs0 is special in that it stores the suffix for standard (type:0) tweens, -OR- the first string (prefix) in a complex-value (type:1) CSSPropTween -OR- it can be the non-tweening value in a type:-1 CSSPropTween. We do this to conserve memory.
			 * CSSPropTweens have the following optional properties as well (not defined through the constructor):
			 *  - l: Length in terms of the number of extra properties that the CSSPropTween has (default: 0). For example, for a boxShadow we may need to tween 5 numbers in which case l would be 5; Keep in mind that the start/end values for the first number that's tweened are always stored in the s and c properties to conserve memory. All additional values thereafter are stored in xn1, xn2, etc.
			 *  - xfirst: The first instance of any sub-CSSPropTweens that are tweening properties of this instance. For example, we may split up a boxShadow tween so that there's a main CSSPropTween of type:1 that has various xs* and xn* values associated with the h-shadow, v-shadow, blur, color, etc. Then we spawn a CSSPropTween for each of those that has a higher priority and runs BEFORE the main CSSPropTween so that the values are all set by the time it needs to re-assemble them. The xfirst gives us an easy way to identify the first one in that chain which typically ends at the main one (because they're all prepende to the linked list)
			 *  - plugin: The TweenPlugin instance that will handle the tweening of any complex values. For example, sometimes we don't want to use normal subtweens (like xfirst refers to) to tween the values - we might want ThrowPropsPlugin or BezierPlugin some other plugin to do the actual tweening, so we create a plugin instance and store a reference here. We need this reference so that if we get a request to round values or disable a tween, we can pass along that request.
			 *  - data: Arbitrary data that needs to be stored with the CSSPropTween. Typically if we're going to have a plugin handle the tweening of a complex-value tween, we create a generic object that stores the END values that we're tweening to and the CSSPropTween's xs1, xs2, etc. have the starting values. We store that object as data. That way, we can simply pass that object to the plugin and use the CSSPropTween as the target.
			 *  - setRatio: Only used for type:2 tweens that require custom functionality. In this case, we call the CSSPropTween's setRatio() method and pass the ratio each time the tween updates. This isn't quite as efficient as doing things directly in the CSSPlugin's setRatio() method, but it's very convenient and flexible.
			 * @param {!Object} t Target object whose property will be tweened. Often a DOM element, but not always. It could be anything.
			 * @param {string} p Property to tween (name). For example, to tween element.width, p would be "width".
			 * @param {number} s Starting numeric value
			 * @param {number} c Change in numeric value over the course of the entire tween. For example, if element.width starts at 5 and should end at 100, c would be 95.
			 * @param {CSSPropTween=} next The next CSSPropTween in the linked list. If one is defined, we will define its _prev as the new instance, and the new instance's _next will be pointed at it.
			 * @param {number=} type The type of CSSPropTween where -1 = a non-tweening value, 0 = a standard simple tween, 1 = a complex value (like one that has multiple numbers in a comma- or space-delimited string like border:"1px solid red"), and 2 = one that uses a custom setRatio function that does all of the work of applying the values on each update.
			 * @param {string=} n Name of the property that should be used for overwriting purposes which is typically the same as p but not always. For example, we may need to create a subtween for the 2nd part of a "clip:rect(...)" tween in which case "p" might be xs1 but "n" is still "clip"
			 * @param {boolean=} r If true, the value(s) should be rounded
			 * @param {number=} pr Priority in the linked list order. Higher priority CSSPropTweens will be updated before lower priority ones. The default priority is 0.
			 * @param {string=} b Beginning value. We store this to ensure that it is EXACTLY what it was when the tween began without any risk of interpretation issues.
			 * @param {string=} e Ending value. We store this to ensure that it is EXACTLY what the user defined at the end of the tween without any risk of interpretation issues.
			 */
			CSSPropTween = _internals.CSSPropTween = function(t, p, s, c, next, type, n, r, pr, b, e) {
				this.t = t; //target
				this.p = p; //property
				this.s = s; //starting value
				this.c = c; //change value
				this.n = n || p; //name that this CSSPropTween should be associated to (usually the same as p, but not always - n is what overwriting looks at)
				if (!(t instanceof CSSPropTween)) {
					_overwriteProps.push(this.n);
				}
				this.r = !r ? r : (typeof(r) === "function") ? r : Math.round; //round (boolean)
				this.type = type || 0; //0 = normal tween, -1 = non-tweening (in which case xs0 will be applied to the target's property, like tp.t[tp.p] = tp.xs0), 1 = complex-value SpecialProp, 2 = custom setRatio() that does all the work
				if (pr) {
					this.pr = pr;
					_hasPriority = true;
				}
				this.b = (b === undefined) ? s : b;
				this.e = (e === undefined) ? s + c : e;
				if (next) {
					this._next = next;
					next._prev = this;
				}
			},

			_addNonTweeningNumericPT = function(target, prop, start, end, next, overwriteProp) { //cleans up some code redundancies and helps minification. Just a fast way to add a NUMERIC non-tweening CSSPropTween
				var pt = new CSSPropTween(target, prop, start, end - start, next, -1, overwriteProp);
				pt.b = start;
				pt.e = pt.xs0 = end;
				return pt;
			},

			/**
			 * Takes a target, the beginning value and ending value (as strings) and parses them into a CSSPropTween (possibly with child CSSPropTweens) that accommodates multiple numbers, colors, comma-delimited values, etc. For example:
			 * sp.parseComplex(element, "boxShadow", "5px 10px 20px rgb(255,102,51)", "0px 0px 0px red", true, "0px 0px 0px rgb(0,0,0,0)", pt);
			 * It will walk through the beginning and ending values (which should be in the same format with the same number and type of values) and figure out which parts are numbers, what strings separate the numeric/tweenable values, and then create the CSSPropTweens accordingly. If a plugin is defined, no child CSSPropTweens will be created. Instead, the ending values will be stored in the "data" property of the returned CSSPropTween like: {s:-5, xn1:-10, xn2:-20, xn3:255, xn4:0, xn5:0} so that it can be fed to any other plugin and it'll be plain numeric tweens but the recomposition of the complex value will be handled inside CSSPlugin's setRatio().
			 * If a setRatio is defined, the type of the CSSPropTween will be set to 2 and recomposition of the values will be the responsibility of that method.
			 *
			 * @param {!Object} t Target whose property will be tweened
			 * @param {!string} p Property that will be tweened (its name, like "left" or "backgroundColor" or "boxShadow")
			 * @param {string} b Beginning value
			 * @param {string} e Ending value
			 * @param {boolean} clrs If true, the value could contain a color value like "rgb(255,0,0)" or "#F00" or "red". The default is false, so no colors will be recognized (a performance optimization)
			 * @param {(string|number|Object)} dflt The default beginning value that should be used if no valid beginning value is defined or if the number of values inside the complex beginning and ending values don't match
			 * @param {?CSSPropTween} pt CSSPropTween instance that is the current head of the linked list (we'll prepend to this).
			 * @param {number=} pr Priority in the linked list order. Higher priority properties will be updated before lower priority ones. The default priority is 0.
			 * @param {TweenPlugin=} plugin If a plugin should handle the tweening of extra properties, pass the plugin instance here. If one is defined, then NO subtweens will be created for any extra properties (the properties will be created - just not additional CSSPropTween instances to tween them) because the plugin is expected to do so. However, the end values WILL be populated in the "data" property, like {s:100, xn1:50, xn2:300}
			 * @param {function(number)=} setRatio If values should be set in a custom function instead of being pieced together in a type:1 (complex-value) CSSPropTween, define that custom function here.
			 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parseComplex() call.
			 */
			_parseComplex = CSSPlugin.parseComplex = function(t, p, b, e, clrs, dflt, pt, pr, plugin, setRatio) {
				//DEBUG: _log("parseComplex: "+p+", b: "+b+", e: "+e);
				b = b || dflt || "";
				if (typeof(e) === "function") {
					e = e(_index, _target);
				}
				pt = new CSSPropTween(t, p, 0, 0, pt, (setRatio ? 2 : 1), null, false, pr, b, e);
				e += ""; //ensures it's a string
				if (clrs && _colorExp.test(e + b)) { //if colors are found, normalize the formatting to rgba() or hsla().
					e = [b, e];
					CSSPlugin.colorStringFilter(e);
					b = e[0];
					e = e[1];
				}
				var ba = b.split(", ").join(",").split(" "), //beginning array
					ea = e.split(", ").join(",").split(" "), //ending array
					l = ba.length,
					autoRound = (_autoRound !== false),
					i, xi, ni, bv, ev, bnums, enums, bn, hasAlpha, temp, cv, str, useHSL;
				if (e.indexOf(",") !== -1 || b.indexOf(",") !== -1) {
					if ((e + b).indexOf("rgb") !== -1 || (e + b).indexOf("hsl") !== -1) { //keep rgb(), rgba(), hsl(), and hsla() values together! (remember, we're splitting on spaces)
						ba = ba.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
						ea = ea.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
					} else {
						ba = ba.join(" ").split(",").join(", ").split(" ");
						ea = ea.join(" ").split(",").join(", ").split(" ");
					}
					l = ba.length;
				}
				if (l !== ea.length) {
					//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
					ba = (dflt || "").split(" ");
					l = ba.length;
				}
				pt.plugin = plugin;
				pt.setRatio = setRatio;
				_colorExp.lastIndex = 0;
				for (i = 0; i < l; i++) {
					bv = ba[i];
					ev = ea[i] + "";
					bn = parseFloat(bv);
					//if the value begins with a number (most common). It's fine if it has a suffix like px
					if (bn || bn === 0) {
						pt.appendXtra("", bn, _parseChange(ev, bn), ev.replace(_relNumExp, ""), (autoRound && ev.indexOf("px") !== -1) ? Math.round : false, true);

					//if the value is a color
					} else if (clrs && _colorExp.test(bv)) {
						str = ev.indexOf(")") + 1;
						str = ")" + (str ? ev.substr(str) : ""); //if there's a comma or ) at the end, retain it.
						useHSL = (ev.indexOf("hsl") !== -1 && _supportsOpacity);
						temp = ev; //original string value so we can look for any prefix later.
						bv = _parseColor(bv, useHSL);
						ev = _parseColor(ev, useHSL);
						hasAlpha = (bv.length + ev.length > 6);
						if (hasAlpha && !_supportsOpacity && ev[3] === 0) { //older versions of IE don't support rgba(), so if the destination alpha is 0, just use "transparent" for the end color
							pt["xs" + pt.l] += pt.l ? " transparent" : "transparent";
							pt.e = pt.e.split(ea[i]).join("transparent");
						} else {
							if (!_supportsOpacity) { //old versions of IE don't support rgba().
								hasAlpha = false;
							}
							if (useHSL) {
								pt.appendXtra(temp.substr(0, temp.indexOf("hsl")) + (hasAlpha ? "hsla(" : "hsl("), bv[0], _parseChange(ev[0], bv[0]), ",", false, true)
									.appendXtra("", bv[1], _parseChange(ev[1], bv[1]), "%,", false)
									.appendXtra("", bv[2], _parseChange(ev[2], bv[2]), (hasAlpha ? "%," : "%" + str), false);
							} else {
								pt.appendXtra(temp.substr(0, temp.indexOf("rgb")) + (hasAlpha ? "rgba(" : "rgb("), bv[0], ev[0] - bv[0], ",", Math.round, true)
									.appendXtra("", bv[1], ev[1] - bv[1], ",", Math.round)
									.appendXtra("", bv[2], ev[2] - bv[2], (hasAlpha ? "," : str), Math.round);
							}

							if (hasAlpha) {
								bv = (bv.length < 4) ? 1 : bv[3];
								pt.appendXtra("", bv, ((ev.length < 4) ? 1 : ev[3]) - bv, str, false);
							}
						}
						_colorExp.lastIndex = 0; //otherwise the test() on the RegExp could move the lastIndex and taint future results.

					} else {
						bnums = bv.match(_numExp); //gets each group of numbers in the beginning value string and drops them into an array

						//if no number is found, treat it as a non-tweening value and just append the string to the current xs.
						if (!bnums) {
							pt["xs" + pt.l] += (pt.l || pt["xs" + pt.l]) ? " " + ev : ev;

						//loop through all the numbers that are found and construct the extra values on the pt.
						} else {
							enums = ev.match(_relNumExp); //get each group of numbers in the end value string and drop them into an array. We allow relative values too, like +=50 or -=.5
							if (!enums || enums.length !== bnums.length) {
								//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
								return pt;
							}
							ni = 0;
							for (xi = 0; xi < bnums.length; xi++) {
								cv = bnums[xi];
								temp = bv.indexOf(cv, ni);
								pt.appendXtra(bv.substr(ni, temp - ni), Number(cv), _parseChange(enums[xi], cv), "", (autoRound && bv.substr(temp + cv.length, 2) === "px") ? Math.round : false, (xi === 0));
								ni = temp + cv.length;
							}
							pt["xs" + pt.l] += bv.substr(ni);
						}
					}
				}
				//if there are relative values ("+=" or "-=" prefix), we need to adjust the ending value to eliminate the prefixes and combine the values properly.
				if (e.indexOf("=") !== -1) if (pt.data) {
					str = pt.xs0 + pt.data.s;
					for (i = 1; i < pt.l; i++) {
						str += pt["xs" + i] + pt.data["xn" + i];
					}
					pt.e = str + pt["xs" + i];
				}
				if (!pt.l) {
					pt.type = -1;
					pt.xs0 = pt.e;
				}
				return pt.xfirst || pt;
			},
			i = 9;


		p = CSSPropTween.prototype;
		p.l = p.pr = 0; //length (number of extra properties like xn1, xn2, xn3, etc.
		while (--i > 0) {
			p["xn" + i] = 0;
			p["xs" + i] = "";
		}
		p.xs0 = "";
		p._next = p._prev = p.xfirst = p.data = p.plugin = p.setRatio = p.rxp = null;


		/**
		 * Appends and extra tweening value to a CSSPropTween and automatically manages any prefix and suffix strings. The first extra value is stored in the s and c of the main CSSPropTween instance, but thereafter any extras are stored in the xn1, xn2, xn3, etc. The prefixes and suffixes are stored in the xs0, xs1, xs2, etc. properties. For example, if I walk through a clip value like "rect(10px, 5px, 0px, 20px)", the values would be stored like this:
		 * xs0:"rect(", s:10, xs1:"px, ", xn1:5, xs2:"px, ", xn2:0, xs3:"px, ", xn3:20, xn4:"px)"
		 * And they'd all get joined together when the CSSPlugin renders (in the setRatio() method).
		 * @param {string=} pfx Prefix (if any)
		 * @param {!number} s Starting value
		 * @param {!number} c Change in numeric value over the course of the entire tween. For example, if the start is 5 and the end is 100, the change would be 95.
		 * @param {string=} sfx Suffix (if any)
		 * @param {boolean=} r Round (if true).
		 * @param {boolean=} pad If true, this extra value should be separated by the previous one by a space. If there is no previous extra and pad is true, it will automatically drop the space.
		 * @return {CSSPropTween} returns itself so that multiple methods can be chained together.
		 */
		p.appendXtra = function(pfx, s, c, sfx, r, pad) {
			var pt = this,
				l = pt.l;
			pt["xs" + l] += (pad && (l || pt["xs" + l])) ? " " + pfx : pfx || "";
			if (!c) if (l !== 0 && !pt.plugin) { //typically we'll combine non-changing values right into the xs to optimize performance, but we don't combine them when there's a plugin that will be tweening the values because it may depend on the values being split apart, like for a bezier, if a value doesn't change between the first and second iteration but then it does on the 3rd, we'll run into trouble because there's no xn slot for that value!
				pt["xs" + l] += s + (sfx || "");
				return pt;
			}
			pt.l++;
			pt.type = pt.setRatio ? 2 : 1;
			pt["xs" + pt.l] = sfx || "";
			if (l > 0) {
				pt.data["xn" + l] = s + c;
				pt.rxp["xn" + l] = r; //round extra property (we need to tap into this in the _parseToProxy() method)
				pt["xn" + l] = s;
				if (!pt.plugin) {
					pt.xfirst = new CSSPropTween(pt, "xn" + l, s, c, pt.xfirst || pt, 0, pt.n, r, pt.pr);
					pt.xfirst.xs0 = 0; //just to ensure that the property stays numeric which helps modern browsers speed up processing. Remember, in the setRatio() method, we do pt.t[pt.p] = val + pt.xs0 so if pt.xs0 is "" (the default), it'll cast the end value as a string. When a property is a number sometimes and a string sometimes, it prevents the compiler from locking in the data type, slowing things down slightly.
				}
				return pt;
			}
			pt.data = {s:s + c};
			pt.rxp = {};
			pt.s = s;
			pt.c = c;
			pt.r = r;
			return pt;
		};

		/**
		 * @constructor A SpecialProp is basically a css property that needs to be treated in a non-standard way, like if it may contain a complex value like boxShadow:"5px 10px 15px rgb(255, 102, 51)" or if it is associated with another plugin like ThrowPropsPlugin or BezierPlugin. Every SpecialProp is associated with a particular property name like "boxShadow" or "throwProps" or "bezier" and it will intercept those values in the vars object that's passed to the CSSPlugin and handle them accordingly.
		 * @param {!string} p Property name (like "boxShadow" or "throwProps")
		 * @param {Object=} options An object containing any of the following configuration options:
		 *                      - defaultValue: the default value
		 *                      - parser: A function that should be called when the associated property name is found in the vars. This function should return a CSSPropTween instance and it should ensure that it is properly inserted into the linked list. It will receive 4 paramters: 1) The target, 2) The value defined in the vars, 3) The CSSPlugin instance (whose _firstPT should be used for the linked list), and 4) A computed style object if one was calculated (this is a speed optimization that allows retrieval of starting values quicker)
		 *                      - formatter: a function that formats any value received for this special property (for example, boxShadow could take "5px 5px red" and format it to "5px 5px 0px 0px red" so that both the beginning and ending values have a common order and quantity of values.)
		 *                      - prefix: if true, we'll determine whether or not this property requires a vendor prefix (like Webkit or Moz or ms or O)
		 *                      - color: set this to true if the value for this SpecialProp may contain color-related values like rgb(), rgba(), etc.
		 *                      - priority: priority in the linked list order. Higher priority SpecialProps will be updated before lower priority ones. The default priority is 0.
		 *                      - multi: if true, the formatter should accommodate a comma-delimited list of values, like boxShadow could have multiple boxShadows listed out.
		 *                      - collapsible: if true, the formatter should treat the value like it's a top/right/bottom/left value that could be collapsed, like "5px" would apply to all, "5px, 10px" would use 5px for top/bottom and 10px for right/left, etc.
		 *                      - keyword: a special keyword that can [optionally] be found inside the value (like "inset" for boxShadow). This allows us to validate beginning/ending values to make sure they match (if the keyword is found in one, it'll be added to the other for consistency by default).
		 */
		var SpecialProp = function(p, options) {
				options = options || {};
				this.p = options.prefix ? _checkPropPrefix(p) || p : p;
				_specialProps[p] = _specialProps[this.p] = this;
				this.format = options.formatter || _getFormatter(options.defaultValue, options.color, options.collapsible, options.multi);
				if (options.parser) {
					this.parse = options.parser;
				}
				this.clrs = options.color;
				this.multi = options.multi;
				this.keyword = options.keyword;
				this.dflt = options.defaultValue;
				this.allowFunc = options.allowFunc;
				this.pr = options.priority || 0;
			},

			//shortcut for creating a new SpecialProp that can accept multiple properties as a comma-delimited list (helps minification). dflt can be an array for multiple values (we don't do a comma-delimited list because the default value may contain commas, like rect(0px,0px,0px,0px)). We attach this method to the SpecialProp class/object instead of using a private _createSpecialProp() method so that we can tap into it externally if necessary, like from another plugin.
			_registerComplexSpecialProp = _internals._registerComplexSpecialProp = function(p, options, defaults) {
				if (typeof(options) !== "object") {
					options = {parser:defaults}; //to make backwards compatible with older versions of BezierPlugin and ThrowPropsPlugin
				}
				var a = p.split(","),
					d = options.defaultValue,
					i, temp;
				defaults = defaults || [d];
				for (i = 0; i < a.length; i++) {
					options.prefix = (i === 0 && options.prefix);
					options.defaultValue = defaults[i] || d;
					temp = new SpecialProp(a[i], options);
				}
			},

			//creates a placeholder special prop for a plugin so that the property gets caught the first time a tween of it is attempted, and at that time it makes the plugin register itself, thus taking over for all future tweens of that property. This allows us to not mandate that things load in a particular order and it also allows us to log() an error that informs the user when they attempt to tween an external plugin-related property without loading its .js file.
			_registerPluginProp = _internals._registerPluginProp = function(p) {
				if (!_specialProps[p]) {
					var pluginName = p.charAt(0).toUpperCase() + p.substr(1) + "Plugin";
					_registerComplexSpecialProp(p, {parser:function(t, e, p, cssp, pt, plugin, vars) {
						var pluginClass = _globals.com.greensock.plugins[pluginName];
						if (!pluginClass) {
							_log("Error: " + pluginName + " js file not loaded.");
							return pt;
						}
						pluginClass._cssRegister();
						return _specialProps[p].parse(t, e, p, cssp, pt, plugin, vars);
					}});
				}
			};


		p = SpecialProp.prototype;

		/**
		 * Alias for _parseComplex() that automatically plugs in certain values for this SpecialProp, like its property name, whether or not colors should be sensed, the default value, and priority. It also looks for any keyword that the SpecialProp defines (like "inset" for boxShadow) and ensures that the beginning and ending values have the same number of values for SpecialProps where multi is true (like boxShadow and textShadow can have a comma-delimited list)
		 * @param {!Object} t target element
		 * @param {(string|number|object)} b beginning value
		 * @param {(string|number|object)} e ending (destination) value
		 * @param {CSSPropTween=} pt next CSSPropTween in the linked list
		 * @param {TweenPlugin=} plugin If another plugin will be tweening the complex value, that TweenPlugin instance goes here.
		 * @param {function=} setRatio If a custom setRatio() method should be used to handle this complex value, that goes here.
		 * @return {CSSPropTween=} First CSSPropTween in the linked list
		 */
		p.parseComplex = function(t, b, e, pt, plugin, setRatio) {
			var kwd = this.keyword,
				i, ba, ea, l, bi, ei;
			//if this SpecialProp's value can contain a comma-delimited list of values (like boxShadow or textShadow), we must parse them in a special way, and look for a keyword (like "inset" for boxShadow) and ensure that the beginning and ending BOTH have it if the end defines it as such. We also must ensure that there are an equal number of values specified (we can't tween 1 boxShadow to 3 for example)
			if (this.multi) if (_commasOutsideParenExp.test(e) || _commasOutsideParenExp.test(b)) {
				ba = b.replace(_commasOutsideParenExp, "|").split("|");
				ea = e.replace(_commasOutsideParenExp, "|").split("|");
			} else if (kwd) {
				ba = [b];
				ea = [e];
			}
			if (ea) {
				l = (ea.length > ba.length) ? ea.length : ba.length;
				for (i = 0; i < l; i++) {
					b = ba[i] = ba[i] || this.dflt;
					e = ea[i] = ea[i] || this.dflt;
					if (kwd) {
						bi = b.indexOf(kwd);
						ei = e.indexOf(kwd);
						if (bi !== ei) {
							if (ei === -1) { //if the keyword isn't in the end value, remove it from the beginning one.
								ba[i] = ba[i].split(kwd).join("");
							} else if (bi === -1) { //if the keyword isn't in the beginning, add it.
								ba[i] += " " + kwd;
							}
						}
					}
				}
				b = ba.join(", ");
				e = ea.join(", ");
			}
			return _parseComplex(t, this.p, b, e, this.clrs, this.dflt, pt, this.pr, plugin, setRatio);
		};

		/**
		 * Accepts a target and end value and spits back a CSSPropTween that has been inserted into the CSSPlugin's linked list and conforms with all the conventions we use internally, like type:-1, 0, 1, or 2, setting up any extra property tweens, priority, etc. For example, if we have a boxShadow SpecialProp and call:
		 * this._firstPT = sp.parse(element, "5px 10px 20px rgb(2550,102,51)", "boxShadow", this);
		 * It should figure out the starting value of the element's boxShadow, compare it to the provided end value and create all the necessary CSSPropTweens of the appropriate types to tween the boxShadow. The CSSPropTween that gets spit back should already be inserted into the linked list (the 4th parameter is the current head, so prepend to that).
		 * @param {!Object} t Target object whose property is being tweened
		 * @param {Object} e End value as provided in the vars object (typically a string, but not always - like a throwProps would be an object).
		 * @param {!string} p Property name
		 * @param {!CSSPlugin} cssp The CSSPlugin instance that should be associated with this tween.
		 * @param {?CSSPropTween} pt The CSSPropTween that is the current head of the linked list (we'll prepend to it)
		 * @param {TweenPlugin=} plugin If a plugin will be used to tween the parsed value, this is the plugin instance.
		 * @param {Object=} vars Original vars object that contains the data for parsing.
		 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parse() call.
		 */
		p.parse = function(t, e, p, cssp, pt, plugin, vars) {
			return this.parseComplex(t.style, this.format(_getStyle(t, this.p, _cs, false, this.dflt)), this.format(e), pt, plugin);
		};

		/**
		 * Registers a special property that should be intercepted from any "css" objects defined in tweens. This allows you to handle them however you want without CSSPlugin doing it for you. The 2nd parameter should be a function that accepts 3 parameters:
		 *  1) Target object whose property should be tweened (typically a DOM element)
		 *  2) The end/destination value (could be a string, number, object, or whatever you want)
		 *  3) The tween instance (you probably don't need to worry about this, but it can be useful for looking up information like the duration)
		 *
		 * Then, your function should return a function which will be called each time the tween gets rendered, passing a numeric "ratio" parameter to your function that indicates the change factor (usually between 0 and 1). For example:
		 *
		 * CSSPlugin.registerSpecialProp("myCustomProp", function(target, value, tween) {
		 *      var start = target.style.width;
		 *      return function(ratio) {
		 *              target.style.width = (start + value * ratio) + "px";
		 *              console.log("set width to " + target.style.width);
		 *          }
		 * }, 0);
		 *
		 * Then, when I do this tween, it will trigger my special property:
		 *
		 * TweenLite.to(element, 1, {css:{myCustomProp:100}});
		 *
		 * In the example, of course, we're just changing the width, but you can do anything you want.
		 *
		 * @param {!string} name Property name (or comma-delimited list of property names) that should be intercepted and handled by your function. For example, if I define "myCustomProp", then it would handle that portion of the following tween: TweenLite.to(element, 1, {css:{myCustomProp:100}})
		 * @param {!function(Object, Object, Object, string):function(number)} onInitTween The function that will be called when a tween of this special property is performed. The function will receive 4 parameters: 1) Target object that should be tweened, 2) Value that was passed to the tween, 3) The tween instance itself (rarely used), and 4) The property name that's being tweened. Your function should return a function that should be called on every update of the tween. That function will receive a single parameter that is a "change factor" value (typically between 0 and 1) indicating the amount of change as a ratio. You can use this to determine how to set the values appropriately in your function.
		 * @param {number=} priority Priority that helps the engine determine the order in which to set the properties (default: 0). Higher priority properties will be updated before lower priority ones.
		 */
		CSSPlugin.registerSpecialProp = function(name, onInitTween, priority) {
			_registerComplexSpecialProp(name, {parser:function(t, e, p, cssp, pt, plugin, vars) {
				var rv = new CSSPropTween(t, p, 0, 0, pt, 2, p, false, priority);
				rv.plugin = plugin;
				rv.setRatio = onInitTween(t, e, cssp._tween, p);
				return rv;
			}, priority:priority});
		};






		//transform-related methods and properties
		CSSPlugin.useSVGTransformAttr = true; //Safari and Firefox both have some rendering bugs when applying CSS transforms to SVG elements, so default to using the "transform" attribute instead (users can override this).
		var _transformProps = ("scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent").split(","),
			_transformProp = _checkPropPrefix("transform"), //the Javascript (camelCase) transform property, like msTransform, WebkitTransform, MozTransform, or OTransform.
			_transformPropCSS = _prefixCSS + "transform",
			_transformOriginProp = _checkPropPrefix("transformOrigin"),
			_supports3D = (_checkPropPrefix("perspective") !== null),
			Transform = _internals.Transform = function() {
				this.perspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0;
				this.force3D = (CSSPlugin.defaultForce3D === false || !_supports3D) ? false : CSSPlugin.defaultForce3D || "auto";
			},
			_SVGElement = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["_gsScope"].SVGElement,
			_useSVGTransformAttr,
			//Some browsers (like Firefox and IE) don't honor transform-origin properly in SVG elements, so we need to manually adjust the matrix accordingly. We feature detect here rather than always doing the conversion for certain browsers because they may fix the problem at some point in the future.

			_createSVG = function(type, container, attributes) {
				var element = _doc.createElementNS("http://www.w3.org/2000/svg", type),
					reg = /([a-z])([A-Z])/g,
					p;
				for (p in attributes) {
					element.setAttributeNS(null, p.replace(reg, "$1-$2").toLowerCase(), attributes[p]);
				}
				container.appendChild(element);
				return element;
			},
			_docElement = _doc.documentElement || {},
			_forceSVGTransformAttr = (function() {
				//IE and Android stock don't support CSS transforms on SVG elements, so we must write them to the "transform" attribute. We populate this variable in the _parseTransform() method, and only if/when we come across an SVG element
				var force = _ieVers || (/Android/i.test(_agent) && !__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["_gsScope"].chrome),
					svg, rect, width;
				if (_doc.createElementNS && _docElement.appendChild && !force) { //IE8 and earlier doesn't support SVG anyway
					svg = _createSVG("svg", _docElement);
					rect = _createSVG("rect", svg, {width:100, height:50, x:100});
					width = rect.getBoundingClientRect().width;
					rect.style[_transformOriginProp] = "50% 50%";
					rect.style[_transformProp] = "scaleX(0.5)";
					force = (width === rect.getBoundingClientRect().width && !(_isFirefox && _supports3D)); //note: Firefox fails the test even though it does support CSS transforms in 3D. Since we can't push 3D stuff into the transform attribute, we force Firefox to pass the test here (as long as it does truly support 3D).
					_docElement.removeChild(svg);
				}
				return force;
			})(),
			_parseSVGOrigin = function(e, local, decoratee, absolute, smoothOrigin, skipRecord) {
				var tm = e._gsTransform,
					m = _getMatrix(e, true),
					v, x, y, xOrigin, yOrigin, a, b, c, d, tx, ty, determinant, xOriginOld, yOriginOld;
				if (tm) {
					xOriginOld = tm.xOrigin; //record the original values before we alter them.
					yOriginOld = tm.yOrigin;
				}
				if (!absolute || (v = absolute.split(" ")).length < 2) {
					b = e.getBBox();
					if (b.x === 0 && b.y === 0 && b.width + b.height === 0) { //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
						b = {x: parseFloat(e.hasAttribute("x") ? e.getAttribute("x") : e.hasAttribute("cx") ? e.getAttribute("cx") : 0) || 0, y: parseFloat(e.hasAttribute("y") ? e.getAttribute("y") : e.hasAttribute("cy") ? e.getAttribute("cy") : 0) || 0, width:0, height:0};
					}
					local = _parsePosition(local).split(" ");
					v = [(local[0].indexOf("%") !== -1 ? parseFloat(local[0]) / 100 * b.width : parseFloat(local[0])) + b.x,
						 (local[1].indexOf("%") !== -1 ? parseFloat(local[1]) / 100 * b.height : parseFloat(local[1])) + b.y];
				}
				decoratee.xOrigin = xOrigin = parseFloat(v[0]);
				decoratee.yOrigin = yOrigin = parseFloat(v[1]);
				if (absolute && m !== _identity2DMatrix) { //if svgOrigin is being set, we must invert the matrix and determine where the absolute point is, factoring in the current transforms. Otherwise, the svgOrigin would be based on the element's non-transformed position on the canvas.
					a = m[0];
					b = m[1];
					c = m[2];
					d = m[3];
					tx = m[4];
					ty = m[5];
					determinant = (a * d - b * c);
					if (determinant) { //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
						x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + ((c * ty - d * tx) / determinant);
						y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - ((a * ty - b * tx) / determinant);
						xOrigin = decoratee.xOrigin = v[0] = x;
						yOrigin = decoratee.yOrigin = v[1] = y;
					}
				}
				if (tm) { //avoid jump when transformOrigin is changed - adjust the x/y values accordingly
					if (skipRecord) {
						decoratee.xOffset = tm.xOffset;
						decoratee.yOffset = tm.yOffset;
						tm = decoratee;
					}
					if (smoothOrigin || (smoothOrigin !== false && CSSPlugin.defaultSmoothOrigin !== false)) {
						x = xOrigin - xOriginOld;
						y = yOrigin - yOriginOld;
						//originally, we simply adjusted the x and y values, but that would cause problems if, for example, you created a rotational tween part-way through an x/y tween. Managing the offset in a separate variable gives us ultimate flexibility.
						//tm.x -= x - (x * m[0] + y * m[2]);
						//tm.y -= y - (x * m[1] + y * m[3]);
						tm.xOffset += (x * m[0] + y * m[2]) - x;
						tm.yOffset += (x * m[1] + y * m[3]) - y;
					} else {
						tm.xOffset = tm.yOffset = 0;
					}
				}
				if (!skipRecord) {
					e.setAttribute("data-svg-origin", v.join(" "));
				}
			},
			_getBBoxHack = function(swapIfPossible) { //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
				var svg = _createElement("svg", (this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns")) || "http://www.w3.org/2000/svg"),
					oldParent = this.parentNode,
					oldSibling = this.nextSibling,
					oldCSS = this.style.cssText,
					bbox;
				_docElement.appendChild(svg);
				svg.appendChild(this);
				this.style.display = "block";
				if (swapIfPossible) {
					try {
						bbox = this.getBBox();
						this._originalGetBBox = this.getBBox;
						this.getBBox = _getBBoxHack;
					} catch (e) { }
				} else if (this._originalGetBBox) {
					bbox = this._originalGetBBox();
				}
				if (oldSibling) {
					oldParent.insertBefore(this, oldSibling);
				} else {
					oldParent.appendChild(this);
				}
				_docElement.removeChild(svg);
				this.style.cssText = oldCSS;
				return bbox;
			},
			_getBBox = function(e) {
				try {
					return e.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
				} catch (error) {
					return _getBBoxHack.call(e, true);
				}
			},
			_isSVG = function(e) { //reports if the element is an SVG on which getBBox() actually works
				return !!(_SVGElement && e.getCTM && (!e.parentNode || e.ownerSVGElement) && _getBBox(e));
			},
			_identity2DMatrix = [1,0,0,1,0,0],
			_getMatrix = function(e, force2D) {
				var tm = e._gsTransform || new Transform(),
					rnd = 100000,
					style = e.style,
					isDefault, s, m, n, dec, nextSibling, parent;
				if (_transformProp) {
					s = _getStyle(e, _transformPropCSS, null, true);
				} else if (e.currentStyle) {
					//for older versions of IE, we need to interpret the filter portion that is in the format: progid:DXImageTransform.Microsoft.Matrix(M11=6.123233995736766e-17, M12=-1, M21=1, M22=6.123233995736766e-17, sizingMethod='auto expand') Notice that we need to swap b and c compared to a normal matrix.
					s = e.currentStyle.filter.match(_ieGetMatrixExp);
					s = (s && s.length === 4) ? [s[0].substr(4), Number(s[2].substr(4)), Number(s[1].substr(4)), s[3].substr(4), (tm.x || 0), (tm.y || 0)].join(",") : "";
				}
				isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
				if (_transformProp && isDefault && !e.offsetParent && e !== _docElement) { //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
					//browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
					n = style.display;
					style.display = "block";
					parent = e.parentNode;
					if (!parent || !e.offsetParent) {
						dec = 1; //flag
						nextSibling = e.nextSibling;
						_docElement.appendChild(e); //we must add it to the DOM in order to get values properly
					}
					s = _getStyle(e, _transformPropCSS, null, true);
					isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
					if (n) {
						style.display = n;
					} else {
						_removeProp(style, "display");
					}
					if (dec) {
						if (nextSibling) {
							parent.insertBefore(e, nextSibling);
						} else if (parent) {
							parent.appendChild(e);
						} else {
							_docElement.removeChild(e);
						}
					}
				}
				if (tm.svg || (e.getCTM && _isSVG(e))) {
					if (isDefault && (style[_transformProp] + "").indexOf("matrix") !== -1) { //some browsers (like Chrome 40) don't correctly report transforms that are applied inline on an SVG element (they don't get included in the computed style), so we double-check here and accept matrix values
						s = style[_transformProp];
						isDefault = 0;
					}
					m = e.getAttribute("transform");
					if (isDefault && m) {
						m = e.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
						s = "matrix(" + m.a + "," + m.b + "," + m.c + "," + m.d + "," + m.e + "," + m.f + ")";
						isDefault = 0;
					}
				}
				if (isDefault) {
					return _identity2DMatrix;
				}
				//split the matrix values out into an array (m for matrix)
				m = (s || "").match(_numExp) || [];
				i = m.length;
				while (--i > -1) {
					n = Number(m[i]);
					m[i] = (dec = n - (n |= 0)) ? ((dec * rnd + (dec < 0 ? -0.5 : 0.5)) | 0) / rnd + n : n; //convert strings to Numbers and round to 5 decimal places to avoid issues with tiny numbers. Roughly 20x faster than Number.toFixed(). We also must make sure to round before dividing so that values like 0.9999999999 become 1 to avoid glitches in browser rendering and interpretation of flipped/rotated 3D matrices. And don't just multiply the number by rnd, floor it, and then divide by rnd because the bitwise operations max out at a 32-bit signed integer, thus it could get clipped at a relatively low value (like 22,000.00000 for example).
				}
				return (force2D && m.length > 6) ? [m[0], m[1], m[4], m[5], m[12], m[13]] : m;
			},

			/**
			 * Parses the transform values for an element, returning an object with x, y, z, scaleX, scaleY, scaleZ, rotation, rotationX, rotationY, skewX, and skewY properties. Note: by default (for performance reasons), all skewing is combined into skewX and rotation but skewY still has a place in the transform object so that we can record how much of the skew is attributed to skewX vs skewY. Remember, a skewY of 10 looks the same as a rotation of 10 and skewX of -10.
			 * @param {!Object} t target element
			 * @param {Object=} cs computed style object (optional)
			 * @param {boolean=} rec if true, the transform values will be recorded to the target element's _gsTransform object, like target._gsTransform = {x:0, y:0, z:0, scaleX:1...}
			 * @param {boolean=} parse if true, we'll ignore any _gsTransform values that already exist on the element, and force a reparsing of the css (calculated style)
			 * @return {object} object containing all of the transform properties/values like {x:0, y:0, z:0, scaleX:1...}
			 */
			_getTransform = _internals.getTransform = function(t, cs, rec, parse) {
				if (t._gsTransform && rec && !parse) {
					return t._gsTransform; //if the element already has a _gsTransform, use that. Note: some browsers don't accurately return the calculated style for the transform (particularly for SVG), so it's almost always safest to just use the values we've already applied rather than re-parsing things.
				}
				var tm = rec ? t._gsTransform || new Transform() : new Transform(),
					invX = (tm.scaleX < 0), //in order to interpret things properly, we need to know if the user applied a negative scaleX previously so that we can adjust the rotation and skewX accordingly. Otherwise, if we always interpret a flipped matrix as affecting scaleY and the user only wants to tween the scaleX on multiple sequential tweens, it would keep the negative scaleY without that being the user's intent.
					min = 0.00002,
					rnd = 100000,
					zOrigin = _supports3D ? parseFloat(_getStyle(t, _transformOriginProp, cs, false, "0 0 0").split(" ")[2]) || tm.zOrigin  || 0 : 0,
					defaultTransformPerspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0,
					m, i, scaleX, scaleY, rotation, skewX;

				tm.svg = !!(t.getCTM && _isSVG(t));
				if (tm.svg) {
					_parseSVGOrigin(t, _getStyle(t, _transformOriginProp, cs, false, "50% 50%") + "", tm, t.getAttribute("data-svg-origin"));
					_useSVGTransformAttr = CSSPlugin.useSVGTransformAttr || _forceSVGTransformAttr;
				}
				m = _getMatrix(t);
				if (m !== _identity2DMatrix) {

					if (m.length === 16) {
						//we'll only look at these position-related 6 variables first because if x/y/z all match, it's relatively safe to assume we don't need to re-parse everything which risks losing important rotational information (like rotationX:180 plus rotationY:180 would look the same as rotation:180 - there's no way to know for sure which direction was taken based solely on the matrix3d() values)
						var a11 = m[0], a21 = m[1], a31 = m[2], a41 = m[3],
							a12 = m[4], a22 = m[5], a32 = m[6], a42 = m[7],
							a13 = m[8], a23 = m[9], a33 = m[10],
							a14 = m[12], a24 = m[13], a34 = m[14],
							a43 = m[11],
							angle = Math.atan2(a32, a33),
							t1, t2, t3, t4, cos, sin;
						//we manually compensate for non-zero z component of transformOrigin to work around bugs in Safari
						if (tm.zOrigin) {
							a34 = -tm.zOrigin;
							a14 = a13*a34-m[12];
							a24 = a23*a34-m[13];
							a34 = a33*a34+tm.zOrigin-m[14];
						}
						//note for possible future consolidation: rotationX: Math.atan2(a32, a33), rotationY: Math.atan2(-a31, Math.sqrt(a33 * a33 + a32 * a32)), rotation: Math.atan2(a21, a11), skew: Math.atan2(a12, a22). However, it doesn't seem to be quite as reliable as the full-on backwards rotation procedure.
						tm.rotationX = angle * _RAD2DEG;
						//rotationX
						if (angle) {
							cos = Math.cos(-angle);
							sin = Math.sin(-angle);
							t1 = a12*cos+a13*sin;
							t2 = a22*cos+a23*sin;
							t3 = a32*cos+a33*sin;
							a13 = a12*-sin+a13*cos;
							a23 = a22*-sin+a23*cos;
							a33 = a32*-sin+a33*cos;
							a43 = a42*-sin+a43*cos;
							a12 = t1;
							a22 = t2;
							a32 = t3;
						}
						//rotationY
						angle = Math.atan2(-a31, a33);
						tm.rotationY = angle * _RAD2DEG;
						if (angle) {
							cos = Math.cos(-angle);
							sin = Math.sin(-angle);
							t1 = a11*cos-a13*sin;
							t2 = a21*cos-a23*sin;
							t3 = a31*cos-a33*sin;
							a23 = a21*sin+a23*cos;
							a33 = a31*sin+a33*cos;
							a43 = a41*sin+a43*cos;
							a11 = t1;
							a21 = t2;
							a31 = t3;
						}
						//rotationZ
						angle = Math.atan2(a21, a11);
						tm.rotation = angle * _RAD2DEG;
						if (angle) {
							cos = Math.cos(angle);
							sin = Math.sin(angle);
							t1 = a11*cos+a21*sin;
							t2 = a12*cos+a22*sin;
							t3 = a13*cos+a23*sin;
							a21 = a21*cos-a11*sin;
							a22 = a22*cos-a12*sin;
							a23 = a23*cos-a13*sin;
							a11 = t1;
							a12 = t2;
							a13 = t3;
						}

						if (tm.rotationX && Math.abs(tm.rotationX) + Math.abs(tm.rotation) > 359.9) { //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
							tm.rotationX = tm.rotation = 0;
							tm.rotationY = 180 - tm.rotationY;
						}

						//skewX
						angle = Math.atan2(a12, a22);

						//scales
						tm.scaleX = ((Math.sqrt(a11 * a11 + a21 * a21 + a31 * a31) * rnd + 0.5) | 0) / rnd;
						tm.scaleY = ((Math.sqrt(a22 * a22 + a32 * a32) * rnd + 0.5) | 0) / rnd;
						tm.scaleZ = ((Math.sqrt(a13 * a13 + a23 * a23 + a33 * a33) * rnd + 0.5) | 0) / rnd;
						a11 /= tm.scaleX;
						a12 /= tm.scaleY;
						a21 /= tm.scaleX;
						a22 /= tm.scaleY;
						if (Math.abs(angle) > min) {
							tm.skewX = angle * _RAD2DEG;
							a12 = 0; //unskews
							if (tm.skewType !== "simple") {
								tm.scaleY *= 1 / Math.cos(angle); //by default, we compensate the scale based on the skew so that the element maintains a similar proportion when skewed, so we have to alter the scaleY here accordingly to match the default (non-adjusted) skewing that CSS does (stretching more and more as it skews).
							}

						} else {
							tm.skewX = 0;
						}

						/* //for testing purposes
						var transform = "matrix3d(",
							comma = ",",
							zero = "0";
						a13 /= tm.scaleZ;
						a23 /= tm.scaleZ;
						a31 /= tm.scaleX;
						a32 /= tm.scaleY;
						a33 /= tm.scaleZ;
						transform += ((a11 < min && a11 > -min) ? zero : a11) + comma + ((a21 < min && a21 > -min) ? zero : a21) + comma + ((a31 < min && a31 > -min) ? zero : a31);
						transform += comma + ((a41 < min && a41 > -min) ? zero : a41) + comma + ((a12 < min && a12 > -min) ? zero : a12) + comma + ((a22 < min && a22 > -min) ? zero : a22);
						transform += comma + ((a32 < min && a32 > -min) ? zero : a32) + comma + ((a42 < min && a42 > -min) ? zero : a42) + comma + ((a13 < min && a13 > -min) ? zero : a13);
						transform += comma + ((a23 < min && a23 > -min) ? zero : a23) + comma + ((a33 < min && a33 > -min) ? zero : a33) + comma + ((a43 < min && a43 > -min) ? zero : a43) + comma;
						transform += a14 + comma + a24 + comma + a34 + comma + (tm.perspective ? (1 + (-a34 / tm.perspective)) : 1) + ")";
						console.log(transform);
						document.querySelector(".test").style[_transformProp] = transform;
						*/

						tm.perspective = a43 ? 1 / ((a43 < 0) ? -a43 : a43) : 0;
						tm.x = a14;
						tm.y = a24;
						tm.z = a34;
						if (tm.svg) {
							tm.x -= tm.xOrigin - (tm.xOrigin * a11 - tm.yOrigin * a12);
							tm.y -= tm.yOrigin - (tm.yOrigin * a21 - tm.xOrigin * a22);
						}

					} else if ((!_supports3D || parse || !m.length || tm.x !== m[4] || tm.y !== m[5] || (!tm.rotationX && !tm.rotationY))) { //sometimes a 6-element matrix is returned even when we performed 3D transforms, like if rotationX and rotationY are 180. In cases like this, we still need to honor the 3D transforms. If we just rely on the 2D info, it could affect how the data is interpreted, like scaleY might get set to -1 or rotation could get offset by 180 degrees. For example, do a TweenLite.to(element, 1, {css:{rotationX:180, rotationY:180}}) and then later, TweenLite.to(element, 1, {css:{rotationX:0}}) and without this conditional logic in place, it'd jump to a state of being unrotated when the 2nd tween starts. Then again, we need to honor the fact that the user COULD alter the transforms outside of CSSPlugin, like by manually applying new css, so we try to sense that by looking at x and y because if those changed, we know the changes were made outside CSSPlugin and we force a reinterpretation of the matrix values. Also, in Webkit browsers, if the element's "display" is "none", its calculated style value will always return empty, so if we've already recorded the values in the _gsTransform object, we'll just rely on those.
						var k = (m.length >= 6),
							a = k ? m[0] : 1,
							b = m[1] || 0,
							c = m[2] || 0,
							d = k ? m[3] : 1;
						tm.x = m[4] || 0;
						tm.y = m[5] || 0;
						scaleX = Math.sqrt(a * a + b * b);
						scaleY = Math.sqrt(d * d + c * c);
						rotation = (a || b) ? Math.atan2(b, a) * _RAD2DEG : tm.rotation || 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
						skewX = (c || d) ? Math.atan2(c, d) * _RAD2DEG + rotation : tm.skewX || 0;
						tm.scaleX = scaleX;
						tm.scaleY = scaleY;
						tm.rotation = rotation;
						tm.skewX = skewX;
						if (_supports3D) {
							tm.rotationX = tm.rotationY = tm.z = 0;
							tm.perspective = defaultTransformPerspective;
							tm.scaleZ = 1;
						}
						if (tm.svg) {
							tm.x -= tm.xOrigin - (tm.xOrigin * a + tm.yOrigin * c);
							tm.y -= tm.yOrigin - (tm.xOrigin * b + tm.yOrigin * d);
						}
					}
					if (Math.abs(tm.skewX) > 90 && Math.abs(tm.skewX) < 270) {
						if (invX) {
							tm.scaleX *= -1;
							tm.skewX += (tm.rotation <= 0) ? 180 : -180;
							tm.rotation += (tm.rotation <= 0) ? 180 : -180;
						} else {
							tm.scaleY *= -1;
							tm.skewX += (tm.skewX <= 0) ? 180 : -180;
						}
					}
					tm.zOrigin = zOrigin;
					//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 0 in these cases. The conditional logic here is faster than calling Math.abs(). Also, browsers tend to render a SLIGHTLY rotated object in a fuzzy way, so we need to snap to exactly 0 when appropriate.
					for (i in tm) {
						if (tm[i] < min) if (tm[i] > -min) {
							tm[i] = 0;
						}
					}
				}
				//DEBUG: _log("parsed rotation of " + t.getAttribute("id")+": "+(tm.rotationX)+", "+(tm.rotationY)+", "+(tm.rotation)+", scale: "+tm.scaleX+", "+tm.scaleY+", "+tm.scaleZ+", position: "+tm.x+", "+tm.y+", "+tm.z+", perspective: "+tm.perspective+ ", origin: "+ tm.xOrigin+ ","+ tm.yOrigin);
				if (rec) {
					t._gsTransform = tm; //record to the object's _gsTransform which we use so that tweens can control individual properties independently (we need all the properties to accurately recompose the matrix in the setRatio() method)
					if (tm.svg) { //if we're supposed to apply transforms to the SVG element's "transform" attribute, make sure there aren't any CSS transforms applied or they'll override the attribute ones. Also clear the transform attribute if we're using CSS, just to be clean.
						if (_useSVGTransformAttr && t.style[_transformProp]) {
							__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].delayedCall(0.001, function(){ //if we apply this right away (before anything has rendered), we risk there being no transforms for a brief moment and it also interferes with adjusting the transformOrigin in a tween with immediateRender:true (it'd try reading the matrix and it wouldn't have the appropriate data in place because we just removed it).
								_removeProp(t.style, _transformProp);
							});
						} else if (!_useSVGTransformAttr && t.getAttribute("transform")) {
							__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].delayedCall(0.001, function(){
								t.removeAttribute("transform");
							});
						}
					}
				}
				return tm;
			},

			//for setting 2D transforms in IE6, IE7, and IE8 (must use a "filter" to emulate the behavior of modern day browser transforms)
			_setIETransformRatio = function(v) {
				var t = this.data, //refers to the element's _gsTransform object
					ang = -t.rotation * _DEG2RAD,
					skew = ang + t.skewX * _DEG2RAD,
					rnd = 100000,
					a = ((Math.cos(ang) * t.scaleX * rnd) | 0) / rnd,
					b = ((Math.sin(ang) * t.scaleX * rnd) | 0) / rnd,
					c = ((Math.sin(skew) * -t.scaleY * rnd) | 0) / rnd,
					d = ((Math.cos(skew) * t.scaleY * rnd) | 0) / rnd,
					style = this.t.style,
					cs = this.t.currentStyle,
					filters, val;
				if (!cs) {
					return;
				}
				val = b; //just for swapping the variables an inverting them (reused "val" to avoid creating another variable in memory). IE's filter matrix uses a non-standard matrix configuration (angle goes the opposite way, and b and c are reversed and inverted)
				b = -c;
				c = -val;
				filters = cs.filter;
				style.filter = ""; //remove filters so that we can accurately measure offsetWidth/offsetHeight
				var w = this.t.offsetWidth,
					h = this.t.offsetHeight,
					clip = (cs.position !== "absolute"),
					m = "progid:DXImageTransform.Microsoft.Matrix(M11=" + a + ", M12=" + b + ", M21=" + c + ", M22=" + d,
					ox = t.x + (w * t.xPercent / 100),
					oy = t.y + (h * t.yPercent / 100),
					dx, dy;

				//if transformOrigin is being used, adjust the offset x and y
				if (t.ox != null) {
					dx = ((t.oxp) ? w * t.ox * 0.01 : t.ox) - w / 2;
					dy = ((t.oyp) ? h * t.oy * 0.01 : t.oy) - h / 2;
					ox += dx - (dx * a + dy * b);
					oy += dy - (dx * c + dy * d);
				}

				if (!clip) {
					m += ", sizingMethod='auto expand')";
				} else {
					dx = (w / 2);
					dy = (h / 2);
					//translate to ensure that transformations occur around the correct origin (default is center).
					m += ", Dx=" + (dx - (dx * a + dy * b) + ox) + ", Dy=" + (dy - (dx * c + dy * d) + oy) + ")";
				}
				if (filters.indexOf("DXImageTransform.Microsoft.Matrix(") !== -1) {
					style.filter = filters.replace(_ieSetMatrixExp, m);
				} else {
					style.filter = m + " " + filters; //we must always put the transform/matrix FIRST (before alpha(opacity=xx)) to avoid an IE bug that slices part of the object when rotation is applied with alpha.
				}

				//at the end or beginning of the tween, if the matrix is normal (1, 0, 0, 1) and opacity is 100 (or doesn't exist), remove the filter to improve browser performance.
				if (v === 0 || v === 1) if (a === 1) if (b === 0) if (c === 0) if (d === 1) if (!clip || m.indexOf("Dx=0, Dy=0") !== -1) if (!_opacityExp.test(filters) || parseFloat(RegExp.$1) === 100) if (filters.indexOf("gradient(" && filters.indexOf("Alpha")) === -1) {
					style.removeAttribute("filter");
				}

				//we must set the margins AFTER applying the filter in order to avoid some bugs in IE8 that could (in rare scenarios) cause them to be ignored intermittently (vibration).
				if (!clip) {
					var mult = (_ieVers < 8) ? 1 : -1, //in Internet Explorer 7 and before, the box model is broken, causing the browser to treat the width/height of the actual rotated filtered image as the width/height of the box itself, but Microsoft corrected that in IE8. We must use a negative offset in IE8 on the right/bottom
						marg, prop, dif;
					dx = t.ieOffsetX || 0;
					dy = t.ieOffsetY || 0;
					t.ieOffsetX = Math.round((w - ((a < 0 ? -a : a) * w + (b < 0 ? -b : b) * h)) / 2 + ox);
					t.ieOffsetY = Math.round((h - ((d < 0 ? -d : d) * h + (c < 0 ? -c : c) * w)) / 2 + oy);
					for (i = 0; i < 4; i++) {
						prop = _margins[i];
						marg = cs[prop];
						//we need to get the current margin in case it is being tweened separately (we want to respect that tween's changes)
						val = (marg.indexOf("px") !== -1) ? parseFloat(marg) : _convertToPixels(this.t, prop, parseFloat(marg), marg.replace(_suffixExp, "")) || 0;
						if (val !== t[prop]) {
							dif = (i < 2) ? -t.ieOffsetX : -t.ieOffsetY; //if another tween is controlling a margin, we cannot only apply the difference in the ieOffsets, so we essentially zero-out the dx and dy here in that case. We record the margin(s) later so that we can keep comparing them, making this code very flexible.
						} else {
							dif = (i < 2) ? dx - t.ieOffsetX : dy - t.ieOffsetY;
						}
						style[prop] = (t[prop] = Math.round( val - dif * ((i === 0 || i === 2) ? 1 : mult) )) + "px";
					}
				}
			},

			/* translates a super small decimal to a string WITHOUT scientific notation
			_safeDecimal = function(n) {
				var s = (n < 0 ? -n : n) + "",
					a = s.split("e-");
				return (n < 0 ? "-0." : "0.") + new Array(parseInt(a[1], 10) || 0).join("0") + a[0].split(".").join("");
			},
			*/

			_setTransformRatio = _internals.set3DTransformRatio = _internals.setTransformRatio = function(v) {
				var t = this.data, //refers to the element's _gsTransform object
					style = this.t.style,
					angle = t.rotation,
					rotationX = t.rotationX,
					rotationY = t.rotationY,
					sx = t.scaleX,
					sy = t.scaleY,
					sz = t.scaleZ,
					x = t.x,
					y = t.y,
					z = t.z,
					isSVG = t.svg,
					perspective = t.perspective,
					force3D = t.force3D,
					skewY = t.skewY,
					skewX = t.skewX,
					t1,	a11, a12, a13, a21, a22, a23, a31, a32, a33, a41, a42, a43,
					zOrigin, min, cos, sin, t2, transform, comma, zero, skew, rnd;
				if (skewY) { //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
					skewX += skewY;
					angle += skewY;
				}

				//check to see if we should render as 2D (and SVGs must use 2D when _useSVGTransformAttr is true)
				if (((((v === 1 || v === 0) && force3D === "auto" && (this.tween._totalTime === this.tween._totalDuration || !this.tween._totalTime)) || !force3D) && !z && !perspective && !rotationY && !rotationX && sz === 1) || (_useSVGTransformAttr && isSVG) || !_supports3D) { //on the final render (which could be 0 for a from tween), if there are no 3D aspects, render in 2D to free up memory and improve performance especially on mobile devices. Check the tween's totalTime/totalDuration too in order to make sure it doesn't happen between repeats if it's a repeating tween.

					//2D
					if (angle || skewX || isSVG) {
						angle *= _DEG2RAD;
						skew = skewX * _DEG2RAD;
						rnd = 100000;
						a11 = Math.cos(angle) * sx;
						a21 = Math.sin(angle) * sx;
						a12 = Math.sin(angle - skew) * -sy;
						a22 = Math.cos(angle - skew) * sy;
						if (skew && t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
							t1 = Math.tan(skew - skewY * _DEG2RAD);
							t1 = Math.sqrt(1 + t1 * t1);
							a12 *= t1;
							a22 *= t1;
							if (skewY) {
								t1 = Math.tan(skewY * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								a11 *= t1;
								a21 *= t1;
							}
						}
						if (isSVG) {
							x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
							y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
							if (_useSVGTransformAttr && (t.xPercent || t.yPercent)) { //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the matrix to simulate it.
								min = this.t.getBBox();
								x += t.xPercent * 0.01 * min.width;
								y += t.yPercent * 0.01 * min.height;
							}
							min = 0.000001;
							if (x < min) if (x > -min) {
								x = 0;
							}
							if (y < min) if (y > -min) {
								y = 0;
							}
						}
						transform = (((a11 * rnd) | 0) / rnd) + "," + (((a21 * rnd) | 0) / rnd) + "," + (((a12 * rnd) | 0) / rnd) + "," + (((a22 * rnd) | 0) / rnd) + "," + x + "," + y + ")";
						if (isSVG && _useSVGTransformAttr) {
							this.t.setAttribute("transform", "matrix(" + transform);
						} else {
							//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 5 decimal places.
							style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + transform;
						}
					} else {
						style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + sx + ",0,0," + sy + "," + x + "," + y + ")";
					}
					return;

				}
				if (_isFirefox) { //Firefox has a bug (at least in v25) that causes it to render the transparent part of 32-bit PNG images as black when displayed inside an iframe and the 3D scale is very small and doesn't change sufficiently enough between renders (like if you use a Power4.easeInOut to scale from 0 to 1 where the beginning values only change a tiny amount to begin the tween before accelerating). In this case, we force the scale to be 0.00002 instead which is visually the same but works around the Firefox issue.
					min = 0.0001;
					if (sx < min && sx > -min) {
						sx = sz = 0.00002;
					}
					if (sy < min && sy > -min) {
						sy = sz = 0.00002;
					}
					if (perspective && !t.z && !t.rotationX && !t.rotationY) { //Firefox has a bug that causes elements to have an odd super-thin, broken/dotted black border on elements that have a perspective set but aren't utilizing 3D space (no rotationX, rotationY, or z).
						perspective = 0;
					}
				}
				if (angle || skewX) {
					angle *= _DEG2RAD;
					cos = a11 = Math.cos(angle);
					sin = a21 = Math.sin(angle);
					if (skewX) {
						angle -= skewX * _DEG2RAD;
						cos = Math.cos(angle);
						sin = Math.sin(angle);
						if (t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
							t1 = Math.tan((skewX - skewY) * _DEG2RAD);
							t1 = Math.sqrt(1 + t1 * t1);
							cos *= t1;
							sin *= t1;
							if (t.skewY) {
								t1 = Math.tan(skewY * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								a11 *= t1;
								a21 *= t1;
							}
						}
					}
					a12 = -sin;
					a22 = cos;

				} else if (!rotationY && !rotationX && sz === 1 && !perspective && !isSVG) { //if we're only translating and/or 2D scaling, this is faster...
					style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) translate3d(" : "translate3d(") + x + "px," + y + "px," + z +"px)" + ((sx !== 1 || sy !== 1) ? " scale(" + sx + "," + sy + ")" : "");
					return;
				} else {
					a11 = a22 = 1;
					a12 = a21 = 0;
				}
				// KEY  INDEX   AFFECTS a[row][column]
				// a11  0       rotation, rotationY, scaleX
				// a21  1       rotation, rotationY, scaleX
				// a31  2       rotationY, scaleX
				// a41  3       rotationY, scaleX
				// a12  4       rotation, skewX, rotationX, scaleY
				// a22  5       rotation, skewX, rotationX, scaleY
				// a32  6       rotationX, scaleY
				// a42  7       rotationX, scaleY
				// a13  8       rotationY, rotationX, scaleZ
				// a23  9       rotationY, rotationX, scaleZ
				// a33  10      rotationY, rotationX, scaleZ
				// a43  11      rotationY, rotationX, perspective, scaleZ
				// a14  12      x, zOrigin, svgOrigin
				// a24  13      y, zOrigin, svgOrigin
				// a34  14      z, zOrigin
				// a44  15
				// rotation: Math.atan2(a21, a11)
				// rotationY: Math.atan2(a13, a33) (or Math.atan2(a13, a11))
				// rotationX: Math.atan2(a32, a33)
				a33 = 1;
				a13 = a23 = a31 = a32 = a41 = a42 = 0;
				a43 = (perspective) ? -1 / perspective : 0;
				zOrigin = t.zOrigin;
				min = 0.000001; //threshold below which browsers use scientific notation which won't work.
				comma = ",";
				zero = "0";
				angle = rotationY * _DEG2RAD;
				if (angle) {
					cos = Math.cos(angle);
					sin = Math.sin(angle);
					a31 = -sin;
					a41 = a43*-sin;
					a13 = a11*sin;
					a23 = a21*sin;
					a33 = cos;
					a43 *= cos;
					a11 *= cos;
					a21 *= cos;
				}
				angle = rotationX * _DEG2RAD;
				if (angle) {
					cos = Math.cos(angle);
					sin = Math.sin(angle);
					t1 = a12*cos+a13*sin;
					t2 = a22*cos+a23*sin;
					a32 = a33*sin;
					a42 = a43*sin;
					a13 = a12*-sin+a13*cos;
					a23 = a22*-sin+a23*cos;
					a33 = a33*cos;
					a43 = a43*cos;
					a12 = t1;
					a22 = t2;
				}
				if (sz !== 1) {
					a13*=sz;
					a23*=sz;
					a33*=sz;
					a43*=sz;
				}
				if (sy !== 1) {
					a12*=sy;
					a22*=sy;
					a32*=sy;
					a42*=sy;
				}
				if (sx !== 1) {
					a11*=sx;
					a21*=sx;
					a31*=sx;
					a41*=sx;
				}

				if (zOrigin || isSVG) {
					if (zOrigin) {
						x += a13*-zOrigin;
						y += a23*-zOrigin;
						z += a33*-zOrigin+zOrigin;
					}
					if (isSVG) { //due to bugs in some browsers, we need to manage the transform-origin of SVG manually
						x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
						y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
					}
					if (x < min && x > -min) {
						x = zero;
					}
					if (y < min && y > -min) {
						y = zero;
					}
					if (z < min && z > -min) {
						z = 0; //don't use string because we calculate perspective later and need the number.
					}
				}

				//optimized way of concatenating all the values into a string. If we do it all in one shot, it's slower because of the way browsers have to create temp strings and the way it affects memory. If we do it piece-by-piece with +=, it's a bit slower too. We found that doing it in these sized chunks works best overall:
				transform = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix3d(" : "matrix3d(");
				transform += ((a11 < min && a11 > -min) ? zero : a11) + comma + ((a21 < min && a21 > -min) ? zero : a21) + comma + ((a31 < min && a31 > -min) ? zero : a31);
				transform += comma + ((a41 < min && a41 > -min) ? zero : a41) + comma + ((a12 < min && a12 > -min) ? zero : a12) + comma + ((a22 < min && a22 > -min) ? zero : a22);
				if (rotationX || rotationY || sz !== 1) { //performance optimization (often there's no rotationX or rotationY, so we can skip these calculations)
					transform += comma + ((a32 < min && a32 > -min) ? zero : a32) + comma + ((a42 < min && a42 > -min) ? zero : a42) + comma + ((a13 < min && a13 > -min) ? zero : a13);
					transform += comma + ((a23 < min && a23 > -min) ? zero : a23) + comma + ((a33 < min && a33 > -min) ? zero : a33) + comma + ((a43 < min && a43 > -min) ? zero : a43) + comma;
				} else {
					transform += ",0,0,0,0,1,0,";
				}
				transform += x + comma + y + comma + z + comma + (perspective ? (1 + (-z / perspective)) : 1) + ")";

				style[_transformProp] = transform;
			};

		p = Transform.prototype;
		p.x = p.y = p.z = p.skewX = p.skewY = p.rotation = p.rotationX = p.rotationY = p.zOrigin = p.xPercent = p.yPercent = p.xOffset = p.yOffset = 0;
		p.scaleX = p.scaleY = p.scaleZ = 1;

		_registerComplexSpecialProp("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin", {parser:function(t, e, parsingProp, cssp, pt, plugin, vars) {
			if (cssp._lastParsedTransform === vars) { return pt; } //only need to parse the transform once, and only if the browser supports it.
			cssp._lastParsedTransform = vars;
			var scaleFunc = (vars.scale && typeof(vars.scale) === "function") ? vars.scale : 0; //if there's a function-based "scale" value, swap in the resulting numeric value temporarily. Otherwise, if it's called for both scaleX and scaleY independently, they may not match (like if the function uses Math.random()).
			if (scaleFunc) {
				vars.scale = scaleFunc(_index, t);
			}
			var originalGSTransform = t._gsTransform,
				style = t.style,
				min = 0.000001,
				i = _transformProps.length,
				v = vars,
				endRotations = {},
				transformOriginString = "transformOrigin",
				m1 = _getTransform(t, _cs, true, v.parseTransform),
				orig = v.transform && ((typeof(v.transform) === "function") ? v.transform(_index, _target) : v.transform),
				m2, copy, has3D, hasChange, dr, x, y, matrix, p;
			m1.skewType = v.skewType || m1.skewType || CSSPlugin.defaultSkewType;
			cssp._transform = m1;
			if ("rotationZ" in v) {
				v.rotation = v.rotationZ;
			}
			if (orig && typeof(orig) === "string" && _transformProp) { //for values like transform:"rotate(60deg) scale(0.5, 0.8)"
				copy = _tempDiv.style; //don't use the original target because it might be SVG in which case some browsers don't report computed style correctly.
				copy[_transformProp] = orig;
				copy.display = "block"; //if display is "none", the browser often refuses to report the transform properties correctly.
				copy.position = "absolute";
				if (orig.indexOf("%") !== -1) { //%-based translations will fail unless we set the width/height to match the original target...
					copy.width = _getStyle(t, "width");
					copy.height = _getStyle(t, "height");
				}
				_doc.body.appendChild(_tempDiv);
				m2 = _getTransform(_tempDiv, null, false);
				if (m1.skewType === "simple") { //the default _getTransform() reports the skewX/scaleY as if skewType is "compensated", thus we need to adjust that here if skewType is "simple".
					m2.scaleY *= Math.cos(m2.skewX * _DEG2RAD);
				}
				if (m1.svg) { //if it's an SVG element, x/y part of the matrix will be affected by whatever we use as the origin and the offsets, so compensate here...
					x = m1.xOrigin;
					y = m1.yOrigin;
					m2.x -= m1.xOffset;
					m2.y -= m1.yOffset;
					if (v.transformOrigin || v.svgOrigin) { //if this tween is altering the origin, we must factor that in here. The actual work of recording the transformOrigin values and setting up the PropTween is done later (still inside this function) so we cannot leave the changes intact here - we only want to update the x/y accordingly.
						orig = {};
						_parseSVGOrigin(t, _parsePosition(v.transformOrigin), orig, v.svgOrigin, v.smoothOrigin, true);
						x = orig.xOrigin;
						y = orig.yOrigin;
						m2.x -= orig.xOffset - m1.xOffset;
						m2.y -= orig.yOffset - m1.yOffset;
					}
					if (x || y) {
						matrix = _getMatrix(_tempDiv, true);
						m2.x -= x - (x * matrix[0] + y * matrix[2]);
						m2.y -= y - (x * matrix[1] + y * matrix[3]);
					}
				}
				_doc.body.removeChild(_tempDiv);
				if (!m2.perspective) {
					m2.perspective = m1.perspective; //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
				}
				if (v.xPercent != null) {
					m2.xPercent = _parseVal(v.xPercent, m1.xPercent);
				}
				if (v.yPercent != null) {
					m2.yPercent = _parseVal(v.yPercent, m1.yPercent);
				}
			} else if (typeof(v) === "object") { //for values like scaleX, scaleY, rotation, x, y, skewX, and skewY or transform:{...} (object)
				m2 = {scaleX:_parseVal((v.scaleX != null) ? v.scaleX : v.scale, m1.scaleX),
					scaleY:_parseVal((v.scaleY != null) ? v.scaleY : v.scale, m1.scaleY),
					scaleZ:_parseVal(v.scaleZ, m1.scaleZ),
					x:_parseVal(v.x, m1.x),
					y:_parseVal(v.y, m1.y),
					z:_parseVal(v.z, m1.z),
					xPercent:_parseVal(v.xPercent, m1.xPercent),
					yPercent:_parseVal(v.yPercent, m1.yPercent),
					perspective:_parseVal(v.transformPerspective, m1.perspective)};
				dr = v.directionalRotation;
				if (dr != null) {
					if (typeof(dr) === "object") {
						for (copy in dr) {
							v[copy] = dr[copy];
						}
					} else {
						v.rotation = dr;
					}
				}
				if (typeof(v.x) === "string" && v.x.indexOf("%") !== -1) {
					m2.x = 0;
					m2.xPercent = _parseVal(v.x, m1.xPercent);
				}
				if (typeof(v.y) === "string" && v.y.indexOf("%") !== -1) {
					m2.y = 0;
					m2.yPercent = _parseVal(v.y, m1.yPercent);
				}

				m2.rotation = _parseAngle(("rotation" in v) ? v.rotation : ("shortRotation" in v) ? v.shortRotation + "_short" : m1.rotation, m1.rotation, "rotation", endRotations);
				if (_supports3D) {
					m2.rotationX = _parseAngle(("rotationX" in v) ? v.rotationX : ("shortRotationX" in v) ? v.shortRotationX + "_short" : m1.rotationX || 0, m1.rotationX, "rotationX", endRotations);
					m2.rotationY = _parseAngle(("rotationY" in v) ? v.rotationY : ("shortRotationY" in v) ? v.shortRotationY + "_short" : m1.rotationY || 0, m1.rotationY, "rotationY", endRotations);
				}
				m2.skewX = _parseAngle(v.skewX, m1.skewX);
				m2.skewY = _parseAngle(v.skewY, m1.skewY);
			}
			if (_supports3D && v.force3D != null) {
				m1.force3D = v.force3D;
				hasChange = true;
			}

			has3D = (m1.force3D || m1.z || m1.rotationX || m1.rotationY || m2.z || m2.rotationX || m2.rotationY || m2.perspective);
			if (!has3D && v.scale != null) {
				m2.scaleZ = 1; //no need to tween scaleZ.
			}

			while (--i > -1) {
				p = _transformProps[i];
				orig = m2[p] - m1[p];
				if (orig > min || orig < -min || v[p] != null || _forcePT[p] != null) {
					hasChange = true;
					pt = new CSSPropTween(m1, p, m1[p], orig, pt);
					if (p in endRotations) {
						pt.e = endRotations[p]; //directional rotations typically have compensated values during the tween, but we need to make sure they end at exactly what the user requested
					}
					pt.xs0 = 0; //ensures the value stays numeric in setRatio()
					pt.plugin = plugin;
					cssp._overwriteProps.push(pt.n);
				}
			}

			orig = (typeof(v.transformOrigin) === "function") ? v.transformOrigin(_index, _target) : v.transformOrigin;
			if (m1.svg && (orig || v.svgOrigin)) {
				x = m1.xOffset; //when we change the origin, in order to prevent things from jumping we adjust the x/y so we must record those here so that we can create PropTweens for them and flip them at the same time as the origin
				y = m1.yOffset;
				_parseSVGOrigin(t, _parsePosition(orig), m2, v.svgOrigin, v.smoothOrigin);
				pt = _addNonTweeningNumericPT(m1, "xOrigin", (originalGSTransform ? m1 : m2).xOrigin, m2.xOrigin, pt, transformOriginString); //note: if there wasn't a transformOrigin defined yet, just start with the destination one; it's wasteful otherwise, and it causes problems with fromTo() tweens. For example, TweenLite.to("#wheel", 3, {rotation:180, transformOrigin:"50% 50%", delay:1}); TweenLite.fromTo("#wheel", 3, {scale:0.5, transformOrigin:"50% 50%"}, {scale:1, delay:2}); would cause a jump when the from values revert at the beginning of the 2nd tween.
				pt = _addNonTweeningNumericPT(m1, "yOrigin", (originalGSTransform ? m1 : m2).yOrigin, m2.yOrigin, pt, transformOriginString);
				if (x !== m1.xOffset || y !== m1.yOffset) {
					pt = _addNonTweeningNumericPT(m1, "xOffset", (originalGSTransform ? x : m1.xOffset), m1.xOffset, pt, transformOriginString);
					pt = _addNonTweeningNumericPT(m1, "yOffset", (originalGSTransform ? y : m1.yOffset), m1.yOffset, pt, transformOriginString);
				}
				orig = "0px 0px"; //certain browsers (like firefox) completely botch transform-origin, so we must remove it to prevent it from contaminating transforms. We manage it ourselves with xOrigin and yOrigin
			}
			if (orig || (_supports3D && has3D && m1.zOrigin)) { //if anything 3D is happening and there's a transformOrigin with a z component that's non-zero, we must ensure that the transformOrigin's z-component is set to 0 so that we can manually do those calculations to get around Safari bugs. Even if the user didn't specifically define a "transformOrigin" in this particular tween (maybe they did it via css directly).
				if (_transformProp) {
					hasChange = true;
					p = _transformOriginProp;
					if (!orig) {
						orig = (_getStyle(t, p, _cs, false, "50% 50%") + "").split(" ");
						orig = orig[0] + " " + orig[1] + " " + m1.zOrigin + "px";
					}
					orig += "";
					pt = new CSSPropTween(style, p, 0, 0, pt, -1, transformOriginString);
					pt.b = style[p];
					pt.plugin = plugin;
					if (_supports3D) {
						copy = m1.zOrigin;
						orig = orig.split(" ");
						m1.zOrigin = ((orig.length > 2) ? parseFloat(orig[2]) : copy) || 0; //Safari doesn't handle the z part of transformOrigin correctly, so we'll manually handle it in the _set3DTransformRatio() method.
						pt.xs0 = pt.e = orig[0] + " " + (orig[1] || "50%") + " 0px"; //we must define a z value of 0px specifically otherwise iOS 5 Safari will stick with the old one (if one was defined)!
						pt = new CSSPropTween(m1, "zOrigin", 0, 0, pt, -1, pt.n); //we must create a CSSPropTween for the _gsTransform.zOrigin so that it gets reset properly at the beginning if the tween runs backward (as opposed to just setting m1.zOrigin here)
						pt.b = copy;
						pt.xs0 = pt.e = m1.zOrigin;
					} else {
						pt.xs0 = pt.e = orig;
					}

					//for older versions of IE (6-8), we need to manually calculate things inside the setRatio() function. We record origin x and y (ox and oy) and whether or not the values are percentages (oxp and oyp).
				} else {
					_parsePosition(orig + "", m1);
				}
			}
			if (hasChange) {
				cssp._transformType = (!(m1.svg && _useSVGTransformAttr) && (has3D || this._transformType === 3)) ? 3 : 2; //quicker than calling cssp._enableTransforms();
			}
			if (scaleFunc) {
				vars.scale = scaleFunc;
			}
			return pt;
		}, allowFunc:true, prefix:true});

		_registerComplexSpecialProp("boxShadow", {defaultValue:"0px 0px 0px 0px #999", prefix:true, color:true, multi:true, keyword:"inset"});
		_registerComplexSpecialProp("clipPath", {defaultValue:"inset(0%)", prefix:true, multi:true, formatter:_getFormatter("inset(0% 0% 0% 0%)", false, true)});

		_registerComplexSpecialProp("borderRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
			e = this.format(e);
			var props = ["borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius"],
				style = t.style,
				ea1, i, es2, bs2, bs, es, bn, en, w, h, esfx, bsfx, rel, hn, vn, em;
			w = parseFloat(t.offsetWidth);
			h = parseFloat(t.offsetHeight);
			ea1 = e.split(" ");
			for (i = 0; i < props.length; i++) { //if we're dealing with percentages, we must convert things separately for the horizontal and vertical axis!
				if (this.p.indexOf("border")) { //older browsers used a prefix
					props[i] = _checkPropPrefix(props[i]);
				}
				bs = bs2 = _getStyle(t, props[i], _cs, false, "0px");
				if (bs.indexOf(" ") !== -1) {
					bs2 = bs.split(" ");
					bs = bs2[0];
					bs2 = bs2[1];
				}
				es = es2 = ea1[i];
				bn = parseFloat(bs);
				bsfx = bs.substr((bn + "").length);
				rel = (es.charAt(1) === "=");
				if (rel) {
					en = parseInt(es.charAt(0)+"1", 10);
					es = es.substr(2);
					en *= parseFloat(es);
					esfx = es.substr((en + "").length - (en < 0 ? 1 : 0)) || "";
				} else {
					en = parseFloat(es);
					esfx = es.substr((en + "").length);
				}
				if (esfx === "") {
					esfx = _suffixMap[p] || bsfx;
				}
				if (esfx !== bsfx) {
					hn = _convertToPixels(t, "borderLeft", bn, bsfx); //horizontal number (we use a bogus "borderLeft" property just because the _convertToPixels() method searches for the keywords "Left", "Right", "Top", and "Bottom" to determine of it's a horizontal or vertical property, and we need "border" in the name so that it knows it should measure relative to the element itself, not its parent.
					vn = _convertToPixels(t, "borderTop", bn, bsfx); //vertical number
					if (esfx === "%") {
						bs = (hn / w * 100) + "%";
						bs2 = (vn / h * 100) + "%";
					} else if (esfx === "em") {
						em = _convertToPixels(t, "borderLeft", 1, "em");
						bs = (hn / em) + "em";
						bs2 = (vn / em) + "em";
					} else {
						bs = hn + "px";
						bs2 = vn + "px";
					}
					if (rel) {
						es = (parseFloat(bs) + en) + esfx;
						es2 = (parseFloat(bs2) + en) + esfx;
					}
				}
				pt = _parseComplex(style, props[i], bs + " " + bs2, es + " " + es2, false, "0px", pt);
			}
			return pt;
		}, prefix:true, formatter:_getFormatter("0px 0px 0px 0px", false, true)});
		_registerComplexSpecialProp("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
			return _parseComplex(t.style, p, this.format(_getStyle(t, p, _cs, false, "0px 0px")), this.format(e), false, "0px", pt);
		}, prefix:true, formatter:_getFormatter("0px 0px", false, true)});
		_registerComplexSpecialProp("backgroundPosition", {defaultValue:"0 0", parser:function(t, e, p, cssp, pt, plugin) {
			var bp = "background-position",
				cs = (_cs || _getComputedStyle(t, null)),
				bs = this.format( ((cs) ? _ieVers ? cs.getPropertyValue(bp + "-x") + " " + cs.getPropertyValue(bp + "-y") : cs.getPropertyValue(bp) : t.currentStyle.backgroundPositionX + " " + t.currentStyle.backgroundPositionY) || "0 0"), //Internet Explorer doesn't report background-position correctly - we must query background-position-x and background-position-y and combine them (even in IE10). Before IE9, we must do the same with the currentStyle object and use camelCase
				es = this.format(e),
				ba, ea, i, pct, overlap, src;
			if ((bs.indexOf("%") !== -1) !== (es.indexOf("%") !== -1) && es.split(",").length < 2) {
				src = _getStyle(t, "backgroundImage").replace(_urlExp, "");
				if (src && src !== "none") {
					ba = bs.split(" ");
					ea = es.split(" ");
					_tempImg.setAttribute("src", src); //set the temp IMG's src to the background-image so that we can measure its width/height
					i = 2;
					while (--i > -1) {
						bs = ba[i];
						pct = (bs.indexOf("%") !== -1);
						if (pct !== (ea[i].indexOf("%") !== -1)) {
							overlap = (i === 0) ? t.offsetWidth - _tempImg.width : t.offsetHeight - _tempImg.height;
							ba[i] = pct ? (parseFloat(bs) / 100 * overlap) + "px" : (parseFloat(bs) / overlap * 100) + "%";
						}
					}
					bs = ba.join(" ");
				}
			}
			return this.parseComplex(t.style, bs, es, pt, plugin);
		}, formatter:_parsePosition});
		_registerComplexSpecialProp("backgroundSize", {defaultValue:"0 0", formatter:function(v) {
			v += ""; //ensure it's a string
			return (v.substr(0,2) === "co") ? v : _parsePosition(v.indexOf(" ") === -1 ? v + " " + v : v); //if set to something like "100% 100%", Safari typically reports the computed style as just "100%" (no 2nd value), but we should ensure that there are two values, so copy the first one. Otherwise, it'd be interpreted as "100% 0" (wrong). Also remember that it could be "cover" or "contain" which we can't tween but should be able to set.
		}});
		_registerComplexSpecialProp("perspective", {defaultValue:"0px", prefix:true});
		_registerComplexSpecialProp("perspectiveOrigin", {defaultValue:"50% 50%", prefix:true});
		_registerComplexSpecialProp("transformStyle", {prefix:true});
		_registerComplexSpecialProp("backfaceVisibility", {prefix:true});
		_registerComplexSpecialProp("userSelect", {prefix:true});
		_registerComplexSpecialProp("margin", {parser:_getEdgeParser("marginTop,marginRight,marginBottom,marginLeft")});
		_registerComplexSpecialProp("padding", {parser:_getEdgeParser("paddingTop,paddingRight,paddingBottom,paddingLeft")});
		_registerComplexSpecialProp("clip", {defaultValue:"rect(0px,0px,0px,0px)", parser:function(t, e, p, cssp, pt, plugin){
			var b, cs, delim;
			if (_ieVers < 9) { //IE8 and earlier don't report a "clip" value in the currentStyle - instead, the values are split apart into clipTop, clipRight, clipBottom, and clipLeft. Also, in IE7 and earlier, the values inside rect() are space-delimited, not comma-delimited.
				cs = t.currentStyle;
				delim = _ieVers < 8 ? " " : ",";
				b = "rect(" + cs.clipTop + delim + cs.clipRight + delim + cs.clipBottom + delim + cs.clipLeft + ")";
				e = this.format(e).split(",").join(delim);
			} else {
				b = this.format(_getStyle(t, this.p, _cs, false, this.dflt));
				e = this.format(e);
			}
			return this.parseComplex(t.style, b, e, pt, plugin);
		}});
		_registerComplexSpecialProp("textShadow", {defaultValue:"0px 0px 0px #999", color:true, multi:true});
		_registerComplexSpecialProp("autoRound,strictUnits", {parser:function(t, e, p, cssp, pt) {return pt;}}); //just so that we can ignore these properties (not tween them)
		_registerComplexSpecialProp("border", {defaultValue:"0px solid #000", parser:function(t, e, p, cssp, pt, plugin) {
			var bw = _getStyle(t, "borderTopWidth", _cs, false, "0px"),
				end = this.format(e).split(" "),
				esfx = end[0].replace(_suffixExp, "");
			if (esfx !== "px") { //if we're animating to a non-px value, we need to convert the beginning width to that unit.
				bw = (parseFloat(bw) / _convertToPixels(t, "borderTopWidth", 1, esfx)) + esfx;
			}
			return this.parseComplex(t.style, this.format(bw + " " + _getStyle(t, "borderTopStyle", _cs, false, "solid") + " " + _getStyle(t, "borderTopColor", _cs, false, "#000")), end.join(" "), pt, plugin);
			}, color:true, formatter:function(v) {
				var a = v.split(" ");
				return a[0] + " " + (a[1] || "solid") + " " + (v.match(_colorExp) || ["#000"])[0];
			}});
		_registerComplexSpecialProp("borderWidth", {parser:_getEdgeParser("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")}); //Firefox doesn't pick up on borderWidth set in style sheets (only inline).
		_registerComplexSpecialProp("float,cssFloat,styleFloat", {parser:function(t, e, p, cssp, pt, plugin) {
			var s = t.style,
				prop = ("cssFloat" in s) ? "cssFloat" : "styleFloat";
			return new CSSPropTween(s, prop, 0, 0, pt, -1, p, false, 0, s[prop], e);
		}});

		//opacity-related
		var _setIEOpacityRatio = function(v) {
				var t = this.t, //refers to the element's style property
					filters = t.filter || _getStyle(this.data, "filter") || "",
					val = (this.s + this.c * v) | 0,
					skip;
				if (val === 100) { //for older versions of IE that need to use a filter to apply opacity, we should remove the filter if opacity hits 1 in order to improve performance, but make sure there isn't a transform (matrix) or gradient in the filters.
					if (filters.indexOf("atrix(") === -1 && filters.indexOf("radient(") === -1 && filters.indexOf("oader(") === -1) {
						t.removeAttribute("filter");
						skip = (!_getStyle(this.data, "filter")); //if a class is applied that has an alpha filter, it will take effect (we don't want that), so re-apply our alpha filter in that case. We must first remove it and then check.
					} else {
						t.filter = filters.replace(_alphaFilterExp, "");
						skip = true;
					}
				}
				if (!skip) {
					if (this.xn1) {
						t.filter = filters = filters || ("alpha(opacity=" + val + ")"); //works around bug in IE7/8 that prevents changes to "visibility" from being applied properly if the filter is changed to a different alpha on the same frame.
					}
					if (filters.indexOf("pacity") === -1) { //only used if browser doesn't support the standard opacity style property (IE 7 and 8). We omit the "O" to avoid case-sensitivity issues
						if (val !== 0 || !this.xn1) { //bugs in IE7/8 won't render the filter properly if opacity is ADDED on the same frame/render as "visibility" changes (this.xn1 is 1 if this tween is an "autoAlpha" tween)
							t.filter = filters + " alpha(opacity=" + val + ")"; //we round the value because otherwise, bugs in IE7/8 can prevent "visibility" changes from being applied properly.
						}
					} else {
						t.filter = filters.replace(_opacityExp, "opacity=" + val);
					}
				}
			};
		_registerComplexSpecialProp("opacity,alpha,autoAlpha", {defaultValue:"1", parser:function(t, e, p, cssp, pt, plugin) {
			var b = parseFloat(_getStyle(t, "opacity", _cs, false, "1")),
				style = t.style,
				isAutoAlpha = (p === "autoAlpha");
			if (typeof(e) === "string" && e.charAt(1) === "=") {
				e = ((e.charAt(0) === "-") ? -1 : 1) * parseFloat(e.substr(2)) + b;
			}
			if (isAutoAlpha && b === 1 && _getStyle(t, "visibility", _cs) === "hidden" && e !== 0) { //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
				b = 0;
			}
			if (_supportsOpacity) {
				pt = new CSSPropTween(style, "opacity", b, e - b, pt);
			} else {
				pt = new CSSPropTween(style, "opacity", b * 100, (e - b) * 100, pt);
				pt.xn1 = isAutoAlpha ? 1 : 0; //we need to record whether or not this is an autoAlpha so that in the setRatio(), we know to duplicate the setting of the alpha in order to work around a bug in IE7 and IE8 that prevents changes to "visibility" from taking effect if the filter is changed to a different alpha(opacity) at the same time. Setting it to the SAME value first, then the new value works around the IE7/8 bug.
				style.zoom = 1; //helps correct an IE issue.
				pt.type = 2;
				pt.b = "alpha(opacity=" + pt.s + ")";
				pt.e = "alpha(opacity=" + (pt.s + pt.c) + ")";
				pt.data = t;
				pt.plugin = plugin;
				pt.setRatio = _setIEOpacityRatio;
			}
			if (isAutoAlpha) { //we have to create the "visibility" PropTween after the opacity one in the linked list so that they run in the order that works properly in IE8 and earlier
				pt = new CSSPropTween(style, "visibility", 0, 0, pt, -1, null, false, 0, ((b !== 0) ? "inherit" : "hidden"), ((e === 0) ? "hidden" : "inherit"));
				pt.xs0 = "inherit";
				cssp._overwriteProps.push(pt.n);
				cssp._overwriteProps.push(p);
			}
			return pt;
		}});


		var _removeProp = function(s, p) {
				if (p) {
					if (s.removeProperty) {
						if (p.substr(0,2) === "ms" || p.substr(0,6) === "webkit") { //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
							p = "-" + p;
						}
						s.removeProperty(p.replace(_capsExp, "-$1").toLowerCase());
					} else { //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
						s.removeAttribute(p);
					}
				}
			},
			_setClassNameRatio = function(v) {
				this.t._gsClassPT = this;
				if (v === 1 || v === 0) {
					this.t.setAttribute("class", (v === 0) ? this.b : this.e);
					var mpt = this.data, //first MiniPropTween
						s = this.t.style;
					while (mpt) {
						if (!mpt.v) {
							_removeProp(s, mpt.p);
						} else {
							s[mpt.p] = mpt.v;
						}
						mpt = mpt._next;
					}
					if (v === 1 && this.t._gsClassPT === this) {
						this.t._gsClassPT = null;
					}
				} else if (this.t.getAttribute("class") !== this.e) {
					this.t.setAttribute("class", this.e);
				}
			};
		_registerComplexSpecialProp("className", {parser:function(t, e, p, cssp, pt, plugin, vars) {
			var b = t.getAttribute("class") || "", //don't use t.className because it doesn't work consistently on SVG elements; getAttribute("class") and setAttribute("class", value") is more reliable.
				cssText = t.style.cssText,
				difData, bs, cnpt, cnptLookup, mpt;
			pt = cssp._classNamePT = new CSSPropTween(t, p, 0, 0, pt, 2);
			pt.setRatio = _setClassNameRatio;
			pt.pr = -11;
			_hasPriority = true;
			pt.b = b;
			bs = _getAllStyles(t, _cs);
			//if there's a className tween already operating on the target, force it to its end so that the necessary inline styles are removed and the class name is applied before we determine the end state (we don't want inline styles interfering that were there just for class-specific values)
			cnpt = t._gsClassPT;
			if (cnpt) {
				cnptLookup = {};
				mpt = cnpt.data; //first MiniPropTween which stores the inline styles - we need to force these so that the inline styles don't contaminate things. Otherwise, there's a small chance that a tween could start and the inline values match the destination values and they never get cleaned.
				while (mpt) {
					cnptLookup[mpt.p] = 1;
					mpt = mpt._next;
				}
				cnpt.setRatio(1);
			}
			t._gsClassPT = pt;
			pt.e = (e.charAt(1) !== "=") ? e : b.replace(new RegExp("(?:\\s|^)" + e.substr(2) + "(?![\\w-])"), "") + ((e.charAt(0) === "+") ? " " + e.substr(2) : "");
			t.setAttribute("class", pt.e);
			difData = _cssDif(t, bs, _getAllStyles(t), vars, cnptLookup);
			t.setAttribute("class", b);
			pt.data = difData.firstMPT;
			if (t.style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://greensock.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
				t.style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
			}
			pt = pt.xfirst = cssp.parse(t, difData.difs, pt, plugin); //we record the CSSPropTween as the xfirst so that we can handle overwriting propertly (if "className" gets overwritten, we must kill all the properties associated with the className part of the tween, so we can loop through from xfirst to the pt itself)
			return pt;
		}});


		var _setClearPropsRatio = function(v) {
			if (v === 1 || v === 0) if (this.data._totalTime === this.data._totalDuration && this.data.data !== "isFromStart") { //this.data refers to the tween. Only clear at the END of the tween (remember, from() tweens make the ratio go from 1 to 0, so we can't just check that and if the tween is the zero-duration one that's created internally to render the starting values in a from() tween, ignore that because otherwise, for example, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in).
				var s = this.t.style,
					transformParse = _specialProps.transform.parse,
					a, p, i, clearTransform, transform;
				if (this.e === "all") {
					s.cssText = "";
					clearTransform = true;
				} else {
					a = this.e.split(" ").join("").split(",");
					i = a.length;
					while (--i > -1) {
						p = a[i];
						if (_specialProps[p]) {
							if (_specialProps[p].parse === transformParse) {
								clearTransform = true;
							} else {
								p = (p === "transformOrigin") ? _transformOriginProp : _specialProps[p].p; //ensures that special properties use the proper browser-specific property name, like "scaleX" might be "-webkit-transform" or "boxShadow" might be "-moz-box-shadow"
							}
						}
						_removeProp(s, p);
					}
				}
				if (clearTransform) {
					_removeProp(s, _transformProp);
					transform = this.t._gsTransform;
					if (transform) {
						if (transform.svg) {
							this.t.removeAttribute("data-svg-origin");
							this.t.removeAttribute("transform");
						}
						delete this.t._gsTransform;
					}
				}

			}
		};
		_registerComplexSpecialProp("clearProps", {parser:function(t, e, p, cssp, pt) {
			pt = new CSSPropTween(t, p, 0, 0, pt, 2);
			pt.setRatio = _setClearPropsRatio;
			pt.e = e;
			pt.pr = -10;
			pt.data = cssp._tween;
			_hasPriority = true;
			return pt;
		}});

		p = "bezier,throwProps,physicsProps,physics2D".split(",");
		i = p.length;
		while (i--) {
			_registerPluginProp(p[i]);
		}








		p = CSSPlugin.prototype;
		p._firstPT = p._lastParsedTransform = p._transform = null;

		//gets called when the tween renders for the first time. This kicks everything off, recording start/end values, etc.
		p._onInitTween = function(target, vars, tween, index) {
			if (!target.nodeType) { //css is only for dom elements
				return false;
			}
			this._target = _target = target;
			this._tween = tween;
			this._vars = vars;
			_index = index;
			_autoRound = vars.autoRound;
			_hasPriority = false;
			_suffixMap = vars.suffixMap || CSSPlugin.suffixMap;
			_cs = _getComputedStyle(target, "");
			_overwriteProps = this._overwriteProps;
			var style = target.style,
				v, pt, pt2, first, last, next, zIndex, tpt, threeD;
			if (_reqSafariFix) if (style.zIndex === "") {
				v = _getStyle(target, "zIndex", _cs);
				if (v === "auto" || v === "") {
					//corrects a bug in [non-Android] Safari that prevents it from repainting elements in their new positions if they don't have a zIndex set. We also can't just apply this inside _parseTransform() because anything that's moved in any way (like using "left" or "top" instead of transforms like "x" and "y") can be affected, so it is best to ensure that anything that's tweening has a z-index. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly. Plus zIndex is less memory-intensive.
					this._addLazySet(style, "zIndex", 0);
				}
			}

			if (typeof(vars) === "string") {
				first = style.cssText;
				v = _getAllStyles(target, _cs);
				style.cssText = first + ";" + vars;
				v = _cssDif(target, v, _getAllStyles(target)).difs;
				if (!_supportsOpacity && _opacityValExp.test(vars)) {
					v.opacity = parseFloat( RegExp.$1 );
				}
				vars = v;
				style.cssText = first;
			}

			if (vars.className) { //className tweens will combine any differences they find in the css with the vars that are passed in, so {className:"myClass", scale:0.5, left:20} would work.
				this._firstPT = pt = _specialProps.className.parse(target, vars.className, "className", this, null, null, vars);
			} else {
				this._firstPT = pt = this.parse(target, vars, null);
			}

			if (this._transformType) {
				threeD = (this._transformType === 3);
				if (!_transformProp) {
					style.zoom = 1; //helps correct an IE issue.
				} else if (_isSafari) {
					_reqSafariFix = true;
					//if zIndex isn't set, iOS Safari doesn't repaint things correctly sometimes (seemingly at random).
					if (style.zIndex === "") {
						zIndex = _getStyle(target, "zIndex", _cs);
						if (zIndex === "auto" || zIndex === "") {
							this._addLazySet(style, "zIndex", 0);
						}
					}
					//Setting WebkitBackfaceVisibility corrects 3 bugs:
					// 1) [non-Android] Safari skips rendering changes to "top" and "left" that are made on the same frame/render as a transform update.
					// 2) iOS Safari sometimes neglects to repaint elements in their new positions. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly.
					// 3) Safari sometimes displayed odd artifacts when tweening the transform (or WebkitTransform) property, like ghosts of the edges of the element remained. Definitely a browser bug.
					//Note: we allow the user to override the auto-setting by defining WebkitBackfaceVisibility in the vars of the tween.
					if (_isSafariLT6) {
						this._addLazySet(style, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (threeD ? "visible" : "hidden"));
					}
				}
				pt2 = pt;
				while (pt2 && pt2._next) {
					pt2 = pt2._next;
				}
				tpt = new CSSPropTween(target, "transform", 0, 0, null, 2);
				this._linkCSSP(tpt, null, pt2);
				tpt.setRatio = _transformProp ? _setTransformRatio : _setIETransformRatio;
				tpt.data = this._transform || _getTransform(target, _cs, true);
				tpt.tween = tween;
				tpt.pr = -1; //ensures that the transforms get applied after the components are updated.
				_overwriteProps.pop(); //we don't want to force the overwrite of all "transform" tweens of the target - we only care about individual transform properties like scaleX, rotation, etc. The CSSPropTween constructor automatically adds the property to _overwriteProps which is why we need to pop() here.
			}

			if (_hasPriority) {
				//reorders the linked list in order of pr (priority)
				while (pt) {
					next = pt._next;
					pt2 = first;
					while (pt2 && pt2.pr > pt.pr) {
						pt2 = pt2._next;
					}
					if ((pt._prev = pt2 ? pt2._prev : last)) {
						pt._prev._next = pt;
					} else {
						first = pt;
					}
					if ((pt._next = pt2)) {
						pt2._prev = pt;
					} else {
						last = pt;
					}
					pt = next;
				}
				this._firstPT = first;
			}
			return true;
		};


		p.parse = function(target, vars, pt, plugin) {
			var style = target.style,
				p, sp, bn, en, bs, es, bsfx, esfx, isStr, rel;
			for (p in vars) {
				es = vars[p]; //ending value string
				sp = _specialProps[p]; //SpecialProp lookup.
				if (typeof(es) === "function" && !(sp && sp.allowFunc)) {
					es = es(_index, _target);
				}
				if (sp) {
					pt = sp.parse(target, es, p, this, pt, plugin, vars);
				} else if (p.substr(0,2) === "--") { //for tweening CSS variables (which always start with "--"). To maximize performance and simplicity, we bypass CSSPlugin altogether and just add a normal property tween to the tween instance itself.
					this._tween._propLookup[p] = this._addTween.call(this._tween, target.style, "setProperty", _getComputedStyle(target).getPropertyValue(p) + "", es + "", p, false, p);
					continue;
				} else {
					bs = _getStyle(target, p, _cs) + "";
					isStr = (typeof(es) === "string");
					if (p === "color" || p === "fill" || p === "stroke" || p.indexOf("Color") !== -1 || (isStr && _rgbhslExp.test(es))) { //Opera uses background: to define color sometimes in addition to backgroundColor:
						if (!isStr) {
							es = _parseColor(es);
							es = ((es.length > 3) ? "rgba(" : "rgb(") + es.join(",") + ")";
						}
						pt = _parseComplex(style, p, bs, es, true, "transparent", pt, 0, plugin);

					} else if (isStr && _complexExp.test(es)) {
						pt = _parseComplex(style, p, bs, es, true, null, pt, 0, plugin);

					} else {
						bn = parseFloat(bs);
						bsfx = (bn || bn === 0) ? bs.substr((bn + "").length) : ""; //remember, bs could be non-numeric like "normal" for fontWeight, so we should default to a blank suffix in that case.

						if (bs === "" || bs === "auto") {
							if (p === "width" || p === "height") {
								bn = _getDimension(target, p, _cs);
								bsfx = "px";
							} else if (p === "left" || p === "top") {
								bn = _calculateOffset(target, p, _cs);
								bsfx = "px";
							} else {
								bn = (p !== "opacity") ? 0 : 1;
								bsfx = "";
							}
						}

						rel = (isStr && es.charAt(1) === "=");
						if (rel) {
							en = parseInt(es.charAt(0) + "1", 10);
							es = es.substr(2);
							en *= parseFloat(es);
							esfx = es.replace(_suffixExp, "");
						} else {
							en = parseFloat(es);
							esfx = isStr ? es.replace(_suffixExp, "") : "";
						}

						if (esfx === "") {
							esfx = (p in _suffixMap) ? _suffixMap[p] : bsfx; //populate the end suffix, prioritizing the map, then if none is found, use the beginning suffix.
						}

						es = (en || en === 0) ? (rel ? en + bn : en) + esfx : vars[p]; //ensures that any += or -= prefixes are taken care of. Record the end value before normalizing the suffix because we always want to end the tween on exactly what they intended even if it doesn't match the beginning value's suffix.
						//if the beginning/ending suffixes don't match, normalize them...
						if (bsfx !== esfx) if (esfx !== "" || p === "lineHeight") if (en || en === 0) if (bn) { //note: if the beginning value (bn) is 0, we don't need to convert units!
							bn = _convertToPixels(target, p, bn, bsfx);
							if (esfx === "%") {
								bn /= _convertToPixels(target, p, 100, "%") / 100;
								if (vars.strictUnits !== true) { //some browsers report only "px" values instead of allowing "%" with getComputedStyle(), so we assume that if we're tweening to a %, we should start there too unless strictUnits:true is defined. This approach is particularly useful for responsive designs that use from() tweens.
									bs = bn + "%";
								}

							} else if (esfx === "em" || esfx === "rem" || esfx === "vw" || esfx === "vh") {
								bn /= _convertToPixels(target, p, 1, esfx);

							//otherwise convert to pixels.
							} else if (esfx !== "px") {
								en = _convertToPixels(target, p, en, esfx);
								esfx = "px"; //we don't use bsfx after this, so we don't need to set it to px too.
							}
							if (rel) if (en || en === 0) {
								es = (en + bn) + esfx; //the changes we made affect relative calculations, so adjust the end value here.
							}
						}

						if (rel) {
							en += bn;
						}

						if ((bn || bn === 0) && (en || en === 0)) { //faster than isNaN(). Also, previously we required en !== bn but that doesn't really gain much performance and it prevents _parseToProxy() from working properly if beginning and ending values match but need to get tweened by an external plugin anyway. For example, a bezier tween where the target starts at left:0 and has these points: [{left:50},{left:0}] wouldn't work properly because when parsing the last point, it'd match the first (current) one and a non-tweening CSSPropTween would be recorded when we actually need a normal tween (type:0) so that things get updated during the tween properly.
							pt = new CSSPropTween(style, p, bn, en - bn, pt, 0, p, (_autoRound !== false && (esfx === "px" || p === "zIndex")), 0, bs, es);
							pt.xs0 = esfx;
							//DEBUG: _log("tween "+p+" from "+pt.b+" ("+bn+esfx+") to "+pt.e+" with suffix: "+pt.xs0);
						} else if (style[p] === undefined || !es && (es + "" === "NaN" || es == null)) {
							_log("invalid " + p + " tween value: " + vars[p]);
						} else {
							pt = new CSSPropTween(style, p, en || bn || 0, 0, pt, -1, p, false, 0, bs, es);
							pt.xs0 = (es === "none" && (p === "display" || p.indexOf("Style") !== -1)) ? bs : es; //intermediate value should typically be set immediately (end value) except for "display" or things like borderTopStyle, borderBottomStyle, etc. which should use the beginning value during the tween.
							//DEBUG: _log("non-tweening value "+p+": "+pt.xs0);
						}
					}
				}
				if (plugin) if (pt && !pt.plugin) {
					pt.plugin = plugin;
				}
			}
			return pt;
		};


		//gets called every time the tween updates, passing the new ratio (typically a value between 0 and 1, but not always (for example, if an Elastic.easeOut is used, the value can jump above 1 mid-tween). It will always start and 0 and end at 1.
		p.setRatio = function(v) {
			var pt = this._firstPT,
				min = 0.000001,
				val, str, i;
			//at the end of the tween, we set the values to exactly what we received in order to make sure non-tweening values (like "position" or "float" or whatever) are set and so that if the beginning/ending suffixes (units) didn't match and we normalized to px, the value that the user passed in is used here. We check to see if the tween is at its beginning in case it's a from() tween in which case the ratio will actually go from 1 to 0 over the course of the tween (backwards).
			if (v === 1 && (this._tween._time === this._tween._duration || this._tween._time === 0)) {
				while (pt) {
					if (pt.type !== 2) {
						if (pt.r && pt.type !== -1) {
							val = pt.r(pt.s + pt.c);
							if (!pt.type) {
								pt.t[pt.p] = val + pt.xs0;
							} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
								i = pt.l;
								str = pt.xs0 + val + pt.xs1;
								for (i = 1; i < pt.l; i++) {
									str += pt["xn"+i] + pt["xs"+(i+1)];
								}
								pt.t[pt.p] = str;
							}
						} else {
							pt.t[pt.p] = pt.e;
						}
					} else {
						pt.setRatio(v);
					}
					pt = pt._next;
				}

			} else if (v || !(this._tween._time === this._tween._duration || this._tween._time === 0) || this._tween._rawPrevTime === -0.000001) {
				while (pt) {
					val = pt.c * v + pt.s;
					if (pt.r) {
						val = pt.r(val);
					} else if (val < min) if (val > -min) {
						val = 0;
					}
					if (!pt.type) {
						pt.t[pt.p] = val + pt.xs0;
					} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
						i = pt.l;
						if (i === 2) {
							pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2;
						} else if (i === 3) {
							pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3;
						} else if (i === 4) {
							pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4;
						} else if (i === 5) {
							pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4 + pt.xn4 + pt.xs5;
						} else {
							str = pt.xs0 + val + pt.xs1;
							for (i = 1; i < pt.l; i++) {
								str += pt["xn"+i] + pt["xs"+(i+1)];
							}
							pt.t[pt.p] = str;
						}

					} else if (pt.type === -1) { //non-tweening value
						pt.t[pt.p] = pt.xs0;

					} else if (pt.setRatio) { //custom setRatio() for things like SpecialProps, external plugins, etc.
						pt.setRatio(v);
					}
					pt = pt._next;
				}

			//if the tween is reversed all the way back to the beginning, we need to restore the original values which may have different units (like % instead of px or em or whatever).
			} else {
				while (pt) {
					if (pt.type !== 2) {
						pt.t[pt.p] = pt.b;
					} else {
						pt.setRatio(v);
					}
					pt = pt._next;
				}
			}
		};

		/**
		 * @private
		 * Forces rendering of the target's transforms (rotation, scale, etc.) whenever the CSSPlugin's setRatio() is called.
		 * Basically, this tells the CSSPlugin to create a CSSPropTween (type 2) after instantiation that runs last in the linked
		 * list and calls the appropriate (3D or 2D) rendering function. We separate this into its own method so that we can call
		 * it from other plugins like BezierPlugin if, for example, it needs to apply an autoRotation and this CSSPlugin
		 * doesn't have any transform-related properties of its own. You can call this method as many times as you
		 * want and it won't create duplicate CSSPropTweens.
		 *
		 * @param {boolean} threeD if true, it should apply 3D tweens (otherwise, just 2D ones are fine and typically faster)
		 */
		p._enableTransforms = function(threeD) {
			this._transform = this._transform || _getTransform(this._target, _cs, true); //ensures that the element has a _gsTransform property with the appropriate values.
			this._transformType = (!(this._transform.svg && _useSVGTransformAttr) && (threeD || this._transformType === 3)) ? 3 : 2;
		};

		var lazySet = function(v) {
			this.t[this.p] = this.e;
			this.data._linkCSSP(this, this._next, null, true); //we purposefully keep this._next even though it'd make sense to null it, but this is a performance optimization, as this happens during the while (pt) {} loop in setRatio() at the bottom of which it sets pt = pt._next, so if we null it, the linked list will be broken in that loop.
		};
		/** @private Gives us a way to set a value on the first render (and only the first render). **/
		p._addLazySet = function(t, p, v) {
			var pt = this._firstPT = new CSSPropTween(t, p, 0, 0, this._firstPT, 2);
			pt.e = v;
			pt.setRatio = lazySet;
			pt.data = this;
		};

		/** @private **/
		p._linkCSSP = function(pt, next, prev, remove) {
			if (pt) {
				if (next) {
					next._prev = pt;
				}
				if (pt._next) {
					pt._next._prev = pt._prev;
				}
				if (pt._prev) {
					pt._prev._next = pt._next;
				} else if (this._firstPT === pt) {
					this._firstPT = pt._next;
					remove = true; //just to prevent resetting this._firstPT 5 lines down in case pt._next is null. (optimized for speed)
				}
				if (prev) {
					prev._next = pt;
				} else if (!remove && this._firstPT === null) {
					this._firstPT = pt;
				}
				pt._next = next;
				pt._prev = prev;
			}
			return pt;
		};

		p._mod = function(lookup) {
			var pt = this._firstPT;
			while (pt) {
				if (typeof(lookup[pt.p]) === "function") { //only gets called by RoundPropsPlugin (ModifyPlugin manages all the rendering internally for CSSPlugin properties that need modification). Remember, we handle rounding a bit differently in this plugin for performance reasons, leveraging "r" as an indicator that the value should be rounded internally.
					pt.r = lookup[pt.p];
				}
				pt = pt._next;
			}
		};

		//we need to make sure that if alpha or autoAlpha is killed, opacity is too. And autoAlpha affects the "visibility" property.
		p._kill = function(lookup) {
			var copy = lookup,
				pt, p, xfirst;
			if (lookup.autoAlpha || lookup.alpha) {
				copy = {};
				for (p in lookup) { //copy the lookup so that we're not changing the original which may be passed elsewhere.
					copy[p] = lookup[p];
				}
				copy.opacity = 1;
				if (copy.autoAlpha) {
					copy.visibility = 1;
				}
			}
			if (lookup.className && (pt = this._classNamePT)) { //for className tweens, we need to kill any associated CSSPropTweens too; a linked list starts at the className's "xfirst".
				xfirst = pt.xfirst;
				if (xfirst && xfirst._prev) {
					this._linkCSSP(xfirst._prev, pt._next, xfirst._prev._prev); //break off the prev
				} else if (xfirst === this._firstPT) {
					this._firstPT = pt._next;
				}
				if (pt._next) {
					this._linkCSSP(pt._next, pt._next._next, xfirst._prev);
				}
				this._classNamePT = null;
			}
			pt = this._firstPT;
			while (pt) {
				if (pt.plugin && pt.plugin !== p && pt.plugin._kill) { //for plugins that are registered with CSSPlugin, we should notify them of the kill.
					pt.plugin._kill(lookup);
					p = pt.plugin;
				}
				pt = pt._next;
			}
			return __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["TweenPlugin"].prototype._kill.call(this, copy);
		};



		//used by cascadeTo() for gathering all the style properties of each child element into an array for comparison.
		var _getChildStyles = function(e, props, targets) {
				var children, i, child, type;
				if (e.slice) {
					i = e.length;
					while (--i > -1) {
						_getChildStyles(e[i], props, targets);
					}
					return;
				}
				children = e.childNodes;
				i = children.length;
				while (--i > -1) {
					child = children[i];
					type = child.type;
					if (child.style) {
						props.push(_getAllStyles(child));
						if (targets) {
							targets.push(child);
						}
					}
					if ((type === 1 || type === 9 || type === 11) && child.childNodes.length) {
						_getChildStyles(child, props, targets);
					}
				}
			};

		/**
		 * Typically only useful for className tweens that may affect child elements, this method creates a TweenLite
		 * and then compares the style properties of all the target's child elements at the tween's start and end, and
		 * if any are different, it also creates tweens for those and returns an array containing ALL of the resulting
		 * tweens (so that you can easily add() them to a TimelineLite, for example). The reason this functionality is
		 * wrapped into a separate static method of CSSPlugin instead of being integrated into all regular className tweens
		 * is because it creates entirely new tweens that may have completely different targets than the original tween,
		 * so if they were all lumped into the original tween instance, it would be inconsistent with the rest of the API
		 * and it would create other problems. For example:
		 *  - If I create a tween of elementA, that tween instance may suddenly change its target to include 50 other elements (unintuitive if I specifically defined the target I wanted)
		 *  - We can't just create new independent tweens because otherwise, what happens if the original/parent tween is reversed or pause or dropped into a TimelineLite for tight control? You'd expect that tween's behavior to affect all the others.
		 *  - Analyzing every style property of every child before and after the tween is an expensive operation when there are many children, so this behavior shouldn't be imposed on all className tweens by default, especially since it's probably rare that this extra functionality is needed.
		 *
		 * @param {Object} target object to be tweened
		 * @param {number} Duration in seconds (or frames for frames-based tweens)
		 * @param {Object} Object containing the end values, like {className:"newClass", ease:Linear.easeNone}
		 * @return {Array} An array of TweenLite instances
		 */
		CSSPlugin.cascadeTo = function(target, duration, vars) {
			var tween = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].to(target, duration, vars),
				results = [tween],
				b = [],
				e = [],
				targets = [],
				_reservedProps = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"]._internals.reservedProps,
				i, difs, p, from;
			target = tween._targets || tween.target;
			_getChildStyles(target, b, targets);
			tween.render(duration, true, true);
			_getChildStyles(target, e);
			tween.render(0, true, true);
			tween._enabled(true);
			i = targets.length;
			while (--i > -1) {
				difs = _cssDif(targets[i], b[i], e[i]);
				if (difs.firstMPT) {
					difs = difs.difs;
					for (p in vars) {
						if (_reservedProps[p]) {
							difs[p] = vars[p];
						}
					}
					from = {};
					for (p in difs) {
						from[p] = b[i][p];
					}
					results.push(__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].fromTo(targets[i], duration, from, difs));
				}
			}
			return results;
		};

		__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["TweenPlugin"].activate([CSSPlugin]);
		return CSSPlugin;

	}, true);

var CSSPlugin = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["globals"].CSSPlugin;


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AttrPlugin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AttrPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__ = __webpack_require__(12);
/*!
 * VERSION: 0.6.1
 * DATE: 2018-08-27
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */
/* eslint-disable */



var AttrPlugin = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["_gsScope"]._gsDefine.plugin({
	propName: "attr",
	API: 2,
	version: "0.6.1",

	//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
	init: function(target, value, tween, index) {
		var p, end;
		if (typeof(target.setAttribute) !== "function") {
			return false;
		}
		for (p in value) {
			end = value[p];
			if (typeof(end) === "function") {
				end = end(index, target);
			}
			this._addTween(target, "setAttribute", target.getAttribute(p) + "", end + "", p, false, p);
			this._overwriteProps.push(p);
		}
		return true;
	}

});







/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RoundPropsPlugin */
/* unused harmony export _getRoundFunc */
/* unused harmony export _roundLinkedList */
/* unused harmony export p */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RoundPropsPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__ = __webpack_require__(12);
/*!
 * VERSION: 1.6.0
 * DATE: 2018-08-27
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/
/* eslint-disable */



var RoundPropsPlugin = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["_gsScope"]._gsDefine.plugin({
				propName: "roundProps",
				version: "1.7.0",
				priority: -1,
				API: 2,

				//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
				init: function(target, value, tween) {
					this._tween = tween;
					return true;
				}

			}),
			_getRoundFunc = function(v) { //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
				var p = v < 1 ? Math.pow(10, (v + "").length - 2) : 1; //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed()
				return function(n) {
					return ((Math.round(n / v) * v * p) | 0) / p;
				};
			},
			_roundLinkedList = function(node, mod) {
				while (node) {
					if (!node.f && !node.blob) {
						node.m = mod || Math.round;
					}
					node = node._next;
				}
			},
			p = RoundPropsPlugin.prototype;

		p._onInitAllProps = function() {
			var tween = this._tween,
				rp = tween.vars.roundProps,
				lookup = {},
				rpt = tween._propLookup.roundProps,
				pt, next, i, p;
			if (typeof(rp) === "object" && !rp.push) {
				for (p in rp) {
					lookup[p] = _getRoundFunc(rp[p]);
				}
			} else {
				if (typeof(rp) === "string") {
					rp = rp.split(",");
				}
				i = rp.length;
				while (--i > -1) {
					lookup[rp[i]] = Math.round;
				}
			}

			for (p in lookup) {
				pt = tween._firstPT;
				while (pt) {
					next = pt._next; //record here, because it may get removed
					if (pt.pg) {
						pt.t._mod(lookup);
					} else if (pt.n === p) {
						if (pt.f === 2 && pt.t) { //a blob (text containing multiple numeric values)
							_roundLinkedList(pt.t._firstPT, lookup[p]);
						} else {
							this._add(pt.t, p, pt.s, pt.c, lookup[p]);
							//remove from linked list
							if (next) {
								next._prev = pt._prev;
							}
							if (pt._prev) {
								pt._prev._next = next;
							} else if (tween._firstPT === pt) {
								tween._firstPT = next;
							}
							pt._next = pt._prev = null;
							tween._propLookup[p] = rpt;
						}
					}
					pt = next;
				}
			}
			return false;
		};

		p._add = function(target, p, s, c, mod) {
			this._addTween(target, p, s, s + c, p, mod || Math.round);
			this._overwriteProps.push(p);
		};




/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DirectionalRotationPlugin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DirectionalRotationPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__ = __webpack_require__(12);
/*!
 * VERSION: 0.3.1
 * DATE: 2018-08-27
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/
/* eslint-disable */



var DirectionalRotationPlugin = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["_gsScope"]._gsDefine.plugin({
		propName: "directionalRotation",
		version: "0.3.1",
		API: 2,

		//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
		init: function(target, value, tween, index) {
			if (typeof(value) !== "object") {
				value = {rotation:value};
			}
			this.finals = {};
			var cap = (value.useRadians === true) ? Math.PI * 2 : 360,
				min = 0.000001,
				p, v, start, end, dif, split;
			for (p in value) {
				if (p !== "useRadians") {
					end = value[p];
					if (typeof(end) === "function") {
						end = end(index, target);
					}
					split = (end + "").split("_");
					v = split[0];
					start = parseFloat( (typeof(target[p]) !== "function") ? target[p] : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]() );
					end = this.finals[p] = (typeof(v) === "string" && v.charAt(1) === "=") ? start + parseInt(v.charAt(0) + "1", 10) * Number(v.substr(2)) : Number(v) || 0;
					dif = end - start;
					if (split.length) {
						v = split.join("_");
						if (v.indexOf("short") !== -1) {
							dif = dif % cap;
							if (dif !== dif % (cap / 2)) {
								dif = (dif < 0) ? dif + cap : dif - cap;
							}
						}
						if (v.indexOf("_cw") !== -1 && dif < 0) {
							dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
						} else if (v.indexOf("ccw") !== -1 && dif > 0) {
							dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
						}
					}
					if (dif > min || dif < -min) {
						this._addTween(target, p, start, start + dif, p);
						this._overwriteProps.push(p);
					}
				}
			}
			return true;
		},

		//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
		set: function(ratio) {
			var pt;
			if (ratio !== 1) {
				this._super.setRatio.call(this, ratio);
			} else {
				pt = this._firstPT;
				while (pt) {
					if (pt.f) {
						pt.t[pt.p](this.finals[pt.p]);
					} else {
						pt.t[pt.p] = this.finals[pt.p];
					}
					pt = pt._next;
				}
			}
		}

	});

DirectionalRotationPlugin._autoCSS = true;



/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Back; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Elastic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Bounce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RoughEase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SlowMo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SteppedEase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Circ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Expo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Sine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ExpoScaleEase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__ = __webpack_require__(12);
/* unused harmony reexport Linear */
/* unused harmony reexport Power0 */
/* unused harmony reexport Power1 */
/* unused harmony reexport Power2 */
/* unused harmony reexport Power3 */
/* unused harmony reexport Power4 */
/*!
 * VERSION: 1.16.1
 * DATE: 2018-08-27
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/
/* eslint-disable */



__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["_gsScope"]._gsDefine("easing.Back", ["easing.Ease"], function() {
		
		var w = (__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["_gsScope"].GreenSockGlobals || __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["_gsScope"]),
			gs = w.com.greensock,
			_2PI = Math.PI * 2,
			_HALF_PI = Math.PI / 2,
			_class = gs._class,
			_create = function(n, f) {
				var C = _class("easing." + n, function(){}, true),
					p = C.prototype = new __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Ease"]();
				p.constructor = C;
				p.getRatio = f;
				return C;
			},
			_easeReg = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Ease"].register || function(){}, //put an empty function in place just as a safety measure in case someone loads an OLD version of TweenLite.js where Ease.register doesn't exist.
			_wrap = function(name, EaseOut, EaseIn, EaseInOut, aliases) {
				var C = _class("easing."+name, {
					easeOut:new EaseOut(),
					easeIn:new EaseIn(),
					easeInOut:new EaseInOut()
				}, true);
				_easeReg(C, name);
				return C;
			},
			EasePoint = function(time, value, next) {
				this.t = time;
				this.v = value;
				if (next) {
					this.next = next;
					next.prev = this;
					this.c = next.v - value;
					this.gap = next.t - time;
				}
			},

			//Back
			_createBack = function(n, f) {
				var C = _class("easing." + n, function(overshoot) {
						this._p1 = (overshoot || overshoot === 0) ? overshoot : 1.70158;
						this._p2 = this._p1 * 1.525;
					}, true), 
					p = C.prototype = new __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Ease"]();
				p.constructor = C;
				p.getRatio = f;
				p.config = function(overshoot) {
					return new C(overshoot);
				};
				return C;
			},

			Back = _wrap("Back",
				_createBack("BackOut", function(p) {
					return ((p = p - 1) * p * ((this._p1 + 1) * p + this._p1) + 1);
				}),
				_createBack("BackIn", function(p) {
					return p * p * ((this._p1 + 1) * p - this._p1);
				}),
				_createBack("BackInOut", function(p) {
					return ((p *= 2) < 1) ? 0.5 * p * p * ((this._p2 + 1) * p - this._p2) : 0.5 * ((p -= 2) * p * ((this._p2 + 1) * p + this._p2) + 2);
				})
			),


			//SlowMo
			SlowMo = _class("easing.SlowMo", function(linearRatio, power, yoyoMode) {
				power = (power || power === 0) ? power : 0.7;
				if (linearRatio == null) {
					linearRatio = 0.7;
				} else if (linearRatio > 1) {
					linearRatio = 1;
				}
				this._p = (linearRatio !== 1) ? power : 0;
				this._p1 = (1 - linearRatio) / 2;
				this._p2 = linearRatio;
				this._p3 = this._p1 + this._p2;
				this._calcEnd = (yoyoMode === true);
			}, true),
			p = SlowMo.prototype = new __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Ease"](),
			SteppedEase, ExpoScaleEase, RoughEase, _createElastic;
			
		p.constructor = SlowMo;
		p.getRatio = function(p) {
			var r = p + (0.5 - p) * this._p;
			if (p < this._p1) {
				return this._calcEnd ? 1 - ((p = 1 - (p / this._p1)) * p) : r - ((p = 1 - (p / this._p1)) * p * p * p * r);
			} else if (p > this._p3) {
				return this._calcEnd ? (p === 1 ? 0 : 1 - (p = (p - this._p3) / this._p1) * p) : r + ((p - r) * (p = (p - this._p3) / this._p1) * p * p * p); //added p === 1 ? 0 to avoid floating point rounding errors from affecting the final value, like 1 - 0.7 = 0.30000000000000004 instead of 0.3
			}
			return this._calcEnd ? 1 : r;
		};
		SlowMo.ease = new SlowMo(0.7, 0.7);
		
		p.config = SlowMo.config = function(linearRatio, power, yoyoMode) {
			return new SlowMo(linearRatio, power, yoyoMode);
		};


		//SteppedEase
		SteppedEase = _class("easing.SteppedEase", function(steps, immediateStart) {
				steps = steps || 1;
				this._p1 = 1 / steps;
				this._p2 = steps + (immediateStart ? 0 : 1);
				this._p3 = immediateStart ? 1 : 0;
			}, true);
		p = SteppedEase.prototype = new __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Ease"]();	
		p.constructor = SteppedEase;
		p.getRatio = function(p) {
			if (p < 0) {
				p = 0;
			} else if (p >= 1) {
				p = 0.999999999;
			}
			return (((this._p2 * p) | 0) + this._p3) * this._p1;
		};
		p.config = SteppedEase.config = function(steps, immediateStart) {
			return new SteppedEase(steps, immediateStart);
		};


		//ExpoScaleEase
		ExpoScaleEase = _class("easing.ExpoScaleEase", function(start, end, ease) {
			this._p1 = Math.log(end / start);
			this._p2 = end - start;
			this._p3 = start;
			this._ease = ease;
		}, true);
		p = ExpoScaleEase.prototype = new __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Ease"]();
		p.constructor = ExpoScaleEase;
		p.getRatio = function(p) {
			if (this._ease) {
				p = this._ease.getRatio(p);
			}
			return (this._p3 * Math.exp(this._p1 * p) - this._p3) / this._p2;
		};
		p.config = ExpoScaleEase.config = function(start, end, ease) {
			return new ExpoScaleEase(start, end, ease);
		};


		//RoughEase
		RoughEase = _class("easing.RoughEase", function(vars) {
			vars = vars || {};
			var taper = vars.taper || "none",
				a = [],
				cnt = 0,
				points = (vars.points || 20) | 0,
				i = points,
				randomize = (vars.randomize !== false),
				clamp = (vars.clamp === true),
				template = (vars.template instanceof __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Ease"]) ? vars.template : null,
				strength = (typeof(vars.strength) === "number") ? vars.strength * 0.4 : 0.4,
				x, y, bump, invX, obj, pnt;
			while (--i > -1) {
				x = randomize ? Math.random() : (1 / points) * i;
				y = template ? template.getRatio(x) : x;
				if (taper === "none") {
					bump = strength;
				} else if (taper === "out") {
					invX = 1 - x;
					bump = invX * invX * strength;
				} else if (taper === "in") {
					bump = x * x * strength;
				} else if (x < 0.5) {  //"both" (start)
					invX = x * 2;
					bump = invX * invX * 0.5 * strength;
				} else {				//"both" (end)
					invX = (1 - x) * 2;
					bump = invX * invX * 0.5 * strength;
				}
				if (randomize) {
					y += (Math.random() * bump) - (bump * 0.5);
				} else if (i % 2) {
					y += bump * 0.5;
				} else {
					y -= bump * 0.5;
				}
				if (clamp) {
					if (y > 1) {
						y = 1;
					} else if (y < 0) {
						y = 0;
					}
				}
				a[cnt++] = {x:x, y:y};
			}
			a.sort(function(a, b) {
				return a.x - b.x;
			});

			pnt = new EasePoint(1, 1, null);
			i = points;
			while (--i > -1) {
				obj = a[i];
				pnt = new EasePoint(obj.x, obj.y, pnt);
			}

			this._prev = new EasePoint(0, 0, (pnt.t !== 0) ? pnt : pnt.next);
		}, true);
		p = RoughEase.prototype = new __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Ease"]();
		p.constructor = RoughEase;
		p.getRatio = function(p) {
			var pnt = this._prev;
			if (p > pnt.t) {
				while (pnt.next && p >= pnt.t) {
					pnt = pnt.next;
				}
				pnt = pnt.prev;
			} else {
				while (pnt.prev && p <= pnt.t) {
					pnt = pnt.prev;
				}
			}
			this._prev = pnt;
			return (pnt.v + ((p - pnt.t) / pnt.gap) * pnt.c);
		};
		p.config = function(vars) {
			return new RoughEase(vars);
		};
		RoughEase.ease = new RoughEase();


		//Bounce
		_wrap("Bounce",
			_create("BounceOut", function(p) {
				if (p < 1 / 2.75) {
					return 7.5625 * p * p;
				} else if (p < 2 / 2.75) {
					return 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
				} else if (p < 2.5 / 2.75) {
					return 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
				}
				return 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
			}),
			_create("BounceIn", function(p) {
				if ((p = 1 - p) < 1 / 2.75) {
					return 1 - (7.5625 * p * p);
				} else if (p < 2 / 2.75) {
					return 1 - (7.5625 * (p -= 1.5 / 2.75) * p + 0.75);
				} else if (p < 2.5 / 2.75) {
					return 1 - (7.5625 * (p -= 2.25 / 2.75) * p + 0.9375);
				}
				return 1 - (7.5625 * (p -= 2.625 / 2.75) * p + 0.984375);
			}),
			_create("BounceInOut", function(p) {
				var invert = (p < 0.5);
				if (invert) {
					p = 1 - (p * 2);
				} else {
					p = (p * 2) - 1;
				}
				if (p < 1 / 2.75) {
					p = 7.5625 * p * p;
				} else if (p < 2 / 2.75) {
					p = 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
				} else if (p < 2.5 / 2.75) {
					p = 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
				} else {
					p = 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
				}
				return invert ? (1 - p) * 0.5 : p * 0.5 + 0.5;
			})
		);


		//CIRC
		_wrap("Circ",
			_create("CircOut", function(p) {
				return Math.sqrt(1 - (p = p - 1) * p);
			}),
			_create("CircIn", function(p) {
				return -(Math.sqrt(1 - (p * p)) - 1);
			}),
			_create("CircInOut", function(p) {
				return ((p*=2) < 1) ? -0.5 * (Math.sqrt(1 - p * p) - 1) : 0.5 * (Math.sqrt(1 - (p -= 2) * p) + 1);
			})
		);


		//Elastic
		_createElastic = function(n, f, def) {
			var C = _class("easing." + n, function(amplitude, period) {
					this._p1 = (amplitude >= 1) ? amplitude : 1; //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
					this._p2 = (period || def) / (amplitude < 1 ? amplitude : 1);
					this._p3 = this._p2 / _2PI * (Math.asin(1 / this._p1) || 0);
					this._p2 = _2PI / this._p2; //precalculate to optimize
				}, true),
				p = C.prototype = new __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Ease"]();
			p.constructor = C;
			p.getRatio = f;
			p.config = function(amplitude, period) {
				return new C(amplitude, period);
			};
			return C;
		};
		_wrap("Elastic",
			_createElastic("ElasticOut", function(p) {
				return this._p1 * Math.pow(2, -10 * p) * Math.sin( (p - this._p3) * this._p2 ) + 1;
			}, 0.3),
			_createElastic("ElasticIn", function(p) {
				return -(this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin( (p - this._p3) * this._p2 ));
			}, 0.3),
			_createElastic("ElasticInOut", function(p) {
				return ((p *= 2) < 1) ? -0.5 * (this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin( (p - this._p3) * this._p2)) : this._p1 * Math.pow(2, -10 *(p -= 1)) * Math.sin( (p - this._p3) * this._p2 ) * 0.5 + 1;
			}, 0.45)
		);


		//Expo
		_wrap("Expo",
			_create("ExpoOut", function(p) {
				return 1 - Math.pow(2, -10 * p);
			}),
			_create("ExpoIn", function(p) {
				return Math.pow(2, 10 * (p - 1)) - 0.001;
			}),
			_create("ExpoInOut", function(p) {
				return ((p *= 2) < 1) ? 0.5 * Math.pow(2, 10 * (p - 1)) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
			})
		);


		//Sine
		_wrap("Sine",
			_create("SineOut", function(p) {
				return Math.sin(p * _HALF_PI);
			}),
			_create("SineIn", function(p) {
				return -Math.cos(p * _HALF_PI) + 1;
			}),
			_create("SineInOut", function(p) {
				return -0.5 * (Math.cos(Math.PI * p) - 1);
			})
		);

		_class("easing.EaseLookup", {
				find:function(s) {
					return __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Ease"].map[s];
				}
			}, true);

		//register the non-standard eases
		_easeReg(w.SlowMo, "SlowMo", "ease,");
		_easeReg(RoughEase, "RoughEase", "ease,");
		_easeReg(SteppedEase, "SteppedEase", "ease,");
		
		return Back;
		
	}, true);

var Back = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["globals"].Back;
var Elastic = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["globals"].Elastic;
var Bounce = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["globals"].Bounce;
var RoughEase = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["globals"].RoughEase;
var SlowMo = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["globals"].SlowMo;
var SteppedEase = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["globals"].SteppedEase;
var Circ = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["globals"].Circ;
var Expo = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["globals"].Expo;
var Sine = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["globals"].Sine;
var ExpoScaleEase = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["globals"].ExpoScaleEase;


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(145);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(148);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(87);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Callout */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomBGRender; });
/* unused harmony export TransitionPreview */
/* unused harmony export CustomSVGRender */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap_BezierPlugin__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_transition_group__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_app_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_TransformManager__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_ItemToolBar__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Player__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_Text__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_gsap__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_gsap_CustomEase__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_gsap_CustomEase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_gsap_CustomEase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_ShapeHelper__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_previewHelper__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__containers_Crop__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_ErrorHandler__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__containers_ProgressiveImage__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_uuid_v1__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_uuid_v1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_uuid_v1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helpers_utilityMethods__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__containers_Frame_Frames__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__containers_Grid__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ReturnSvgFilter__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__containers_HyperLinkToolBar__ = __webpack_require__(428);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RenderSvg=function(_React$Component){_inherits(RenderSvg,_React$Component);function RenderSvg(props){_classCallCheck(this,RenderSvg);var _this2=_possibleConstructorReturn(this,(RenderSvg.__proto__||Object.getPrototypeOf(RenderSvg)).call(this,props));_this2.wkspcObj=new WorkspaceComponent();_this2.state={svgElement:null};_this2.svgData=[];_this2.isLoaded=false;_this2.appUrl=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a['APPICONS'][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a['APPICONS']['current']];_this2.assetUrl=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["ASSETS"][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["ASSETS"]["current"]];_this2.isSceneClick=false;return _this2;}_createClass(RenderSvg,[{key:'componentWillMount',value:function componentWillMount(){var setClass='scene-item-inner';if(this.props.isBG){setClass='';}else if(this.props.isKeyframe){setClass='keyframe-item-inner';}if(this.props.thumbnail){this.svgData.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:this.props.data_id,className:setClass,id:this.props.data_id+"inner",style:{width:"100%",height:"100%",position:"absolute"},'data-id':this.props.data_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'thumbnail',src:this.props.thumbnail})));this.setState({svgElement:this.svgData});}__WEBPACK_IMPORTED_MODULE_11_axios___default()({method:'GET',url:this.props.src,mode:'cors',withCredentials:false,credentials:'same-origin',headers:{'Accept':'application/json','Access-Control-Allow-Origin':'*','Content-Type':'image/svg+xml'},data:{}}).then(function(res){this.svgData=[];if(!this.isLoaded){if(this.props.colors){this.props.colors.entrySeq().forEach(function(_ref){var _ref2=_slicedToArray(_ref,2),_className=_ref2[0],_color=_ref2[1];var cols=res.request.responseXML.documentElement.getElementsByClassName(_className);for(var i=0;i<cols.length;i++){if(cols[i].getAttribute("ue")!==null){var newColor=_iHSL10(_color.substr(1),cols[i].getAttribute("ue"),cols[i].getAttribute("sa"),cols[i].getAttribute("li"));cols[i].setAttribute('fill',newColor);}else{cols[i].setAttribute('fill',_color);}}});}}this.svgData.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:this.props.data_id,className:setClass,id:this.props.data_id+"inner",style:{width:"100%",height:"100%",position:"absolute"},'data-id':this.props.data_id,dangerouslySetInnerHTML:{__html:res.request.responseXML.documentElement.outerHTML}}));this.setState({svgElement:this.svgData});}.bind(this)).catch(function(error){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])("Custom character svg source failed to load componentWillMount ",error,"WorkspaceComponent-componentWillMount");});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){this.isLoaded=true;}},{key:'render',value:function render(){return this.state.svgElement;}}]);return RenderSvg;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var SVGConstructor=function(_React$Component2){_inherits(SVGConstructor,_React$Component2);function SVGConstructor(props){_classCallCheck(this,SVGConstructor);var _this3=_possibleConstructorReturn(this,(SVGConstructor.__proto__||Object.getPrototypeOf(SVGConstructor)).call(this,props));_this3.state={svgItem:""};return _this3;}_createClass(SVGConstructor,[{key:'componentDidMount',value:function componentDidMount(){var _this4=this;var svgItem=this.getCustomPath();this.setState({svgItem:svgItem});if(this.props.isPlayAll||this.props.isPlay){if(this.props.itemId)window.totalArr=window.totalArr.filter(function(e){return e!==_this4.props.itemId;});else window.totalArr=window.totalArr.filter(function(e){return e!==_this4.props.data_id;});if(window.totalArr.length===0)this.props.startPlay("workspace");}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.zoomFactor!==this.props.zoomFactor||prevProps.item.get("pathData")!==this.props.item.get("pathData")||prevProps.item.get("colors")!==this.props.item.get("colors")||prevProps.item.get("width")!==this.props.item.get("width")||prevProps.item.get("height")!==this.props.item.get("height")){var svgItem=this.getCustomPath();this.setState({svgItem:svgItem});}}},{key:'getCustomPath',value:function getCustomPath(){var item=this.props.item;var paths=[];var pathDetails=Object(__WEBPACK_IMPORTED_MODULE_12__helpers_ShapeHelper__["a" /* getPath */])(item,this.props.zoomFactor);var pathData=pathDetails.pathDetails;var colors=item.get("colors");if(Array.isArray(pathData)){for(var i=0;i<pathData.length;i++){var style={};if(pathData[i].pathStyle!==undefined)style={transform:"translate("+pathData[i].pathStyle.left+"px, "+pathData[i].pathStyle.top+"px)"};paths.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{xmlns:'http://www.w3.org/2000/svg',key:i,style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{xmlns:'http://www.w3.org/2000/svg',d:pathData[i].data,className:"path"+i,strokeWidth:'4px',stroke:pathData[i].isStroke?pathData[i].color:"none",fill:pathData[i].isFill?pathData[i].color:"none"})));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',width:pathDetails.shapeStyle===undefined?item.get("width")*this.props.zoomFactor:pathDetails.shapeStyle.width,height:pathDetails.shapeStyle===undefined?item.get("height")*this.props.zoomFactor:pathDetails.shapeStyle.height,style:pathDetails.shapeStyle!==undefined?pathDetails.shapeStyle:{}},paths);}},{key:'render',value:function render(){return this.state.svgItem;}}]);return SVGConstructor;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Callout=function(_React$Component3){_inherits(Callout,_React$Component3);function Callout(){_classCallCheck(this,Callout);return _possibleConstructorReturn(this,(Callout.__proto__||Object.getPrototypeOf(Callout)).apply(this,arguments));}_createClass(Callout,[{key:'pad',value:function pad(num,size){var s=num+"";while(s.length<size){s="0"+s;}return s;}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){var xRatio=this.props.data.get("xRatio")!==undefined?this.props.data.get("xRatio"):5;var yRatio=this.props.data.get("yRatio")!==undefined?this.props.data.get("yRatio"):5;var widthRatio=this.props.data.get("widthRatio")!==undefined?this.props.data.get("widthRatio"):90;var heightRatio=this.props.data.get("heightRatio")!==undefined?this.props.data.get("heightRatio"):90;var textX=xRatio*this.props.data.get("width")/100*this.props.zoomFactor;var textY=yRatio*this.props.data.get("height")/100*this.props.zoomFactor;var textWidth=widthRatio*this.props.data.get("width")/100*this.props.zoomFactor;var textHeight=heightRatio*this.props.data.get("height")/100*this.props.zoomFactor;var flip=getFlipPosition(this.props.data.get("flipPosition"));var configBasePath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[this.props.data.get('type')][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[this.props.data.get('type')][this.props.data.get('subType')?'workspace_'+this.props.data.get('subType'):'workspace']];var svgImage=null;if(this.props.data.get("type")==="SHAPE"&&this.props.data.get("subType")==="CSTMPTH"||this.props.data.get("type")==="TEXT"&&this.props.data.get("subType")==="BANNER"){svgImage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SVGConstructor,{data_id:this.props.data_id,item:this.props.data,zoomFactor:this.props.zoomFactor,isPlay:this.props.isPlay,isPlayAll:this.props.isPlayAll,startPlay:this.props.startPlay,itemId:this.props.itemId});}else{svgImage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomSVGRender,{animakerType:this.props.animakerType,uploadSVG:false,workspaceWidth:this.props.workspaceWidth,workspaceHeight:this.props.workspaceHeight,parentItem:this.parentItem,completeWorkspaceItems:this.props.data,startPlay:this.props.startPlay,addTween:null,workspaceItems:this.props.workspaceItems,changePlayTime:null,playHeadValue:this.props.playHeadValue,pose:this.props.data.get("pose"),expression:this.props.data.get("expression"),zoomFactor:this.props.zoomFactor,assetType:this.props.data.get("type"),data_id:this.props.data_id,isPlay:this.props.isPlay,isPlayAll:this.props.isPlayAll,key:this.props.itemId,selectedItems:this.props.selectedItems,src:configBasePath+this.props.data.get("src"),colors:this.props.data.get("colors"),parts:this.props.data.get("parts"),animdata:this.props.data.get("animdata"),socket:this.props.socket,updateItem:this.props.updateItem,selectedScene:this.props.selectedScene});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,svgImage,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'callout-text-container',style:{transform:"translate("+textX+"px, "+textY+"px)"+flip,width:textWidth+"px",height:textHeight+"px",position:"absolute"},'data-id':this.props.itemId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__containers_Text__["a" /* default */],{text:this.props.data,data_id:this.props.data_id,currentScene:this.props.selectedScene,itemId:this.props.itemId,linkEnabled:this.props.isPlay,isGrouped:this.props.isGrouped,socket:this.props.socket})));}}]);return Callout;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function getFlipPosition(value,angle){var flip=value===1?" scaleX(-1)":value===2?" scaleY(-1)":value===3?" scaleX(-1) scaleY(-1)":"";return flip;}var CustomBGRender=function(_React$Component4){_inherits(CustomBGRender,_React$Component4);function CustomBGRender(props){_classCallCheck(this,CustomBGRender);var _this6=_possibleConstructorReturn(this,(CustomBGRender.__proto__||Object.getPrototypeOf(CustomBGRender)).call(this,props));_this6.state={svgElement:null};_this6.svgData=[];_this6.isLoaded=false;_this6.loadSVGData=_this6.loadSVGData.bind(_this6);return _this6;}_createClass(CustomBGRender,[{key:'setColors',value:function setColors(colors,element,hasGradient){var _this7=this;colors.entrySeq().forEach(function(_ref3){var _ref4=_slicedToArray(_ref3,2),_className=_ref4[0],_color=_ref4[1];var cols=element.querySelectorAll("[class*='"+_className+"']");for(var i=0;i<cols.length;i++){if(_className==="prop1"&&hasGradient==="1"){_this7.setGradient(_color,_iHSL10(_color.substr(1),-0.009,-0.622,-0.221),element);return;}else{var resa=cols[i].className.animVal.replace(/zf/g,'.');resa=resa.split("_");if(cols[i].firstChild&&!cols[i].className.animVal.includes("Mc")){if(resa.length!==1){var newColor=_iHSL10(_color.substr(1),parseFloat(resa[1]),parseFloat(resa[2]),parseFloat(resa[3]));if(cols[i].children.length>0){if(cols[i].firstChild.hasAttribute("fill"))cols[i].firstChild.setAttribute('fill',newColor);if(cols[i].firstChild.hasAttribute("stroke"))cols[i].firstChild.setAttribute('stroke',newColor);}}else{if(cols[i].children.length>0){if(cols[i].firstChild.hasAttribute("fill"))cols[i].firstChild.setAttribute('fill',_color);if(cols[i].firstChild.hasAttribute("stroke"))cols[i].firstChild.setAttribute('stroke',_color);}}}else{if(cols[i].hasAttribute("fill"))cols[i].setAttribute('fill',_color);}}}});}},{key:'setGradient',value:function setGradient(color,subColor,element){var color1=hex2rgb(color.substr(1));var color2=hex2rgb(subColor.substr(1));var r1=color1[0];var g1=color1[1];var b1=color1[2];//color2
var r2=color2[0];var g2=color2[1];var b2=color2[2];var r_mid=r1+(r2-r1)/2;var g_mid=g1+(g2-g1)/2;var b_mid=b1+(b2-b1)/2;var id="gr_eKkwrvfwvE";var defs=element.querySelectorAll("stop");defs[0].setAttribute('stop-color',"rgb("+r1+","+g1+","+b1+")");defs[1].setAttribute('stop-color',"rgb("+r_mid+","+g_mid+","+b_mid+")");defs[2].setAttribute('stop-color',"rgb("+r2+","+g2+","+b2+")");}},{key:'componentWillMount',value:function componentWillMount(){this.loadSVGData(this.props.src,false);}},{key:'loadSVGData',value:function loadSVGData(srcVal,fromExpression){if(document.getElementById(this.props.data_id)&&!this.props.isPlay&&document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0]&&this.props.assetType!=="PROP"&&this.props.assetType!=="SCREEN")document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0].style.display="flex";var sceneBGData=this.props.completeWorkspaceItems.get("workspaceBG");if(sceneBGData.get('type')==='BG'){var bgPreview=document.getElementById('bgWrkspcPreview');if(bgPreview)bgPreview.style.display='none';this.setState({svgElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'bg',className:'bg-image',key:sceneBGData.get('src'),src:this.props.proxyImg,style:this.props.bgImgStyles})});}__WEBPACK_IMPORTED_MODULE_11_axios___default()({method:'GET',url:srcVal,mode:'cors',withCredentials:false,credentials:'same-origin',headers:{'Access-Control-Allow-Origin':'*','Content-Type':'image/svg+xml'},data:{}}).then(function(res){this.svgData=[];if(!this.isLoaded){if(this.props.colors){this.setColors(this.props.colors,res.request.responseXML.documentElement,this.props.hasGradient);}}var setClass='scene-item-inner';if(this.props.isBG){setClass='';}var svgEle=res.request.responseXML.documentElement;for(var i=0;i<svgEle.getElementsByTagName("mask").length;i++){var random=Math.random().toString(12).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString();svgEle.querySelectorAll("[mask=\"url(#"+svgEle.getElementsByTagName("mask")[i].id+")\"]")[0].setAttribute("mask","url(#"+random+")");svgEle.getElementsByTagName("mask")[i].id=random;}for(var i=0;i<svgEle.getElementsByTagName("filter").length;i++){var random=Math.random().toString(12).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString();svgEle.querySelectorAll("[filter=\"url(#"+svgEle.getElementsByTagName("filter")[i].id+")\"]")[0].setAttribute("filter","url(#"+random+")");svgEle.getElementsByTagName("filter")[i].id=random;}for(var i=0;i<svgEle.getElementsByTagName("clipPath").length;i++){var random=Math.random().toString(12).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString();svgEle.querySelectorAll("[clip-path=\"url(#"+svgEle.getElementsByTagName("clipPath")[i].id+")\"]")[0].setAttribute("clipPath","url(#"+random+")");svgEle.getElementsByTagName("clipPath")[i].id=random;}this.svgData.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:this.props.data_id,className:setClass,id:this.props.data_id+"inner",style:this.props.bgImgStyles,'data-id':this.props.data_id,dangerouslySetInnerHTML:{__html:res.request.responseXML.documentElement.outerHTML}}));this.setState({svgElement:this.svgData},function(){if(this.props.assetType==="PROP"||this.props.assetType==="SCREEN"){if(document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0])document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0].style.display="none";}});}.bind(this)).catch(function(error){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])("Custom character svg source failed to load loadSVGData ",error,"WorkspaceComponent-loadSVGData");});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.colors!==nextProps.colors&&this.props.src===nextProps.src&&document.getElementById(nextProps.data_id+"inner")!==null){this.setColors(nextProps.colors,document.getElementById(nextProps.data_id+"inner"),nextProps.hasGradient);}if(this.props.bgImgStyles!==nextProps.bgImgStyles){if(document.getElementById(nextProps.data_id+"inner")!==null){document.getElementById(nextProps.data_id+"inner").style.width=nextProps.bgImgStyles.width;document.getElementById(nextProps.data_id+"inner").style.height=nextProps.bgImgStyles.height;document.getElementById(nextProps.data_id+"inner").style.transform=nextProps.bgImgStyles.transform;document.getElementById(nextProps.data_id+"inner").style.filter=nextProps.bgImgStyles.filter;}}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.props.src!==prevProps.src||this.props.data_id!==prevProps.data_id||this.props.bgImgStyles.width!==prevProps.bgImgStyles.width){this.loadSVGData(this.props.src,false);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'render',value:function render(){var sourceThumb="";if(!this.props.isPlay){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:"inherit",height:"inherit",pointerEvents:"none",position:"absolute"}},this.state.svgElement);}else return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.state.svgElement);}}]);return CustomBGRender;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var TransitionPreview=function(_React$Component5){_inherits(TransitionPreview,_React$Component5);function TransitionPreview(props){_classCallCheck(this,TransitionPreview);var _this8=_possibleConstructorReturn(this,(TransitionPreview.__proto__||Object.getPrototypeOf(TransitionPreview)).call(this,props));_this8.state={status:"loaded",svgSource:null,svgData:null,effect:null,animSrc:null,animData:null,colors:null,src:null};_this8.assetUrl=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["ASSETS"][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["ASSETS"]["current"]];_this8.appUrl=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["APPICONS"][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["APPICONS"]["current"]];_this8.overAllBenzValues=[];_this8.t1=null;_this8.random=Math.random();_this8.scenePreview=new __WEBPACK_IMPORTED_MODULE_13__helpers_previewHelper__["a" /* default */]({zoomFactor:props.zoomFactor,width:props.width,height:props.height,browserName:props.browserName});return _this8;}_createClass(TransitionPreview,[{key:'componentDidMount',value:function componentDidMount(){var _this9=this;if(this.state.svgAnimation){this.loadSvgData(this.state.svgSource).then(function(data){_this9.setColors(_this9.state.colors,_this9.slideSvg.getElementsByTagName("svg")[0],false);_this9.loadAnimData(_this9.state.animSrc).then(function(data){_this9.random=Math.random();});});}}},{key:'setColors',value:function setColors(colors,element,hasGradient){var _this10=this;colors.entrySeq().forEach(function(_ref5){var _ref6=_slicedToArray(_ref5,2),_className=_ref6[0],_color=_ref6[1];var cols=element.querySelectorAll("[class*='"+_className+"']");for(var i=0;i<cols.length;i++){if(_className==="prop1"&&hasGradient==="1"){_this10.setGradient(_color,_iHSL10(_color.substr(1),-0.009,-0.622,-0.221),element);return;}else{var resa=cols[i].className.animVal.replace(/zf/g,'.');resa=resa.split("_");if(cols[i].firstChild&&!cols[i].className.animVal.includes("Mc")){if(resa.length!==1){var newColor=_iHSL10(_color.substr(1),parseFloat(resa[1]),parseFloat(resa[2]),parseFloat(resa[3]));if(cols[i].children.length>0){if(cols[i].firstChild.hasAttribute("fill"))cols[i].firstChild.setAttribute('fill',newColor);if(cols[i].firstChild.hasAttribute("stroke"))cols[i].firstChild.setAttribute('stroke',newColor);}}else{if(cols[i].children.length>0){if(cols[i].firstChild.hasAttribute("fill"))cols[i].firstChild.setAttribute('fill',_color);if(cols[i].firstChild.hasAttribute("stroke"))cols[i].firstChild.setAttribute('stroke',_color);}}}else{if(cols[i].hasAttribute("fill"))cols[i].setAttribute('fill',_color);}}}});}},{key:'assignTweenValues',value:function assignTweenValues(res,easeCount){document.getElementById("workspace").getElementsByClassName("scenes")[0].style.overflow="hidden";this.isPlaying=true;this.isLoaded=true;var parent={"essentials":res.essentials};var animateValues=res.animateValues;var originalValues={};for(var child in parent.essentials){var thisName=child;originalValues[child]={"positionX":parent.essentials[thisName].p.split(",")[0],"positionY":parent.essentials[thisName].p.split(",")[1]};}var isRepeated=0;this.t1=new __WEBPACK_IMPORTED_MODULE_9_gsap__["f" /* TimelineMax */]({repeat:isRepeated,repeatDelay:0,yoyo:false,paused:true});var easeVal=__WEBPACK_IMPORTED_MODULE_9_gsap__["d" /* Linear */].easeNone;if(easeCount===undefined)var easeCount=0;var currentEase={};for(var idVal in animateValues){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=animateValues[idVal][Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var valueData=_step.value;if(valueData.a==="P"){var _bezValues=void 0;if(valueData.e==="no Ease"){_bezValues=easeVal;}else{if(currentEase[valueData.e]===undefined){_bezValues=valueData.e.split("[")[1].split("]")[0].split(",");__WEBPACK_IMPORTED_MODULE_10_gsap_CustomEase___default.a.create("easeName"+easeCount,"\""+_bezValues[0]+","+_bezValues[1]+","+_bezValues[2]+","+_bezValues[3]+"\"");this.overAllBenzValues.push("easeName"+easeCount);_bezValues="easeName"+easeCount;currentEase[valueData.e]=_bezValues;easeCount++;}else{_bezValues=currentEase[valueData.e];}}var posXval=valueData.v.split(",")[0];var posYval=valueData.v.split(",")[1],hipMCPosition;if(posXval<0)posXval="-="+Math.abs(posXval);else posXval="+="+Math.abs(posXval);if(posYval<0)posYval="-="+Math.abs(posYval);else posYval="+="+Math.abs(posYval);if(this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0])if(this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0].firstChild){this.t1.to(this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0],valueData.d,{immediateRender:false,y:posYval,x:posXval,svgOrigin:parseFloat(originalValues[idVal].positionX)+'px '+parseFloat(originalValues[idVal].positionY)+'px',ease:_bezValues,onComplete:function onComplete(){}},valueData.t);}}if(valueData.a==="O"){var bezValues;if(valueData.e==="no Ease"){bezValues=easeVal;}else{if(currentEase[valueData.e]===undefined){bezValues=valueData.e.split("[")[1].split("]")[0].split(",");__WEBPACK_IMPORTED_MODULE_10_gsap_CustomEase___default.a.create("easeName"+easeCount,"\""+bezValues[0]+","+bezValues[1]+","+bezValues[2]+","+bezValues[3]+"\"");this.overAllBenzValues.push("easeName"+easeCount);bezValues="easeName"+easeCount;easeCount++;}else{bezValues=currentEase[valueData.e];}}var opacity=valueData.v/100;if(this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0]){this.t1.to(this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0],0.001,{immediateRender:false,opacity:opacity,ease:__WEBPACK_IMPORTED_MODULE_9_gsap__["d" /* Linear */].easeNone},valueData.t+valueData.d/2);}}if(valueData.a==="S"){var bezValues;if(valueData.e==="no Ease"){bezValues=easeVal;}else{if(currentEase[valueData.e]===undefined){bezValues=valueData.e.split("[")[1].split("]")[0].split(",");__WEBPACK_IMPORTED_MODULE_10_gsap_CustomEase___default.a.create("easeName"+easeCount,"\""+bezValues[0]+","+bezValues[1]+","+bezValues[2]+","+bezValues[3]+"\"");this.overAllBenzValues.push("easeName"+easeCount);bezValues="easeName"+easeCount;easeCount++;}else{bezValues=currentEase[valueData.e];}}var scaleXval=valueData.v.split(",")[0]/100;var scaleYval=valueData.v.split(",")[1]/100;if(this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0]){this.t1.to(this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0],valueData.d,{scaleY:scaleYval,scaleX:scaleXval,svgOrigin:parseFloat(originalValues[idVal].positionX)+'px '+parseFloat(originalValues[idVal].positionY)+'px',ease:bezValues},valueData.t);}}if(valueData.a==="R"){var bezValues;if(valueData.e==="no Ease"){bezValues=easeVal;}else{if(currentEase[valueData.e]===undefined){bezValues=valueData.e.split("[")[1].split("]")[0].split(",");__WEBPACK_IMPORTED_MODULE_10_gsap_CustomEase___default.a.create("easeName"+easeCount,"\""+bezValues[0]+","+bezValues[1]+","+bezValues[2]+","+bezValues[3]+"\"");this.overAllBenzValues.push("easeName"+easeCount);bezValues="easeName"+easeCount;easeCount++;}else{bezValues=currentEase[valueData.e];}}var rotateVal="";if(valueData.v<0){rotateVal="-="+Math.abs(valueData.v);}else{rotateVal="+="+Math.abs(valueData.v);}this.t1.to(this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0],valueData.d,{immediateRender:false,rotation:rotateVal,svgOrigin:parseFloat(originalValues[idVal].positionX)+'px '+parseFloat(originalValues[idVal].positionY)+'px',ease:bezValues},valueData.t);}if(valueData.a==="PA"){if(this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0]!=undefined&&this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0].firstChild!==undefined){this.t1.to(this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0].firstChild,valueData.d,{attr:{d:valueData.v}},Math.abs(valueData.t));}}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}currentEase={};this.t1.eventCallback("onComplete",function(e){e.pause(0);document.getElementById("workspace").getElementsByClassName("scenes")[0].style.overflow="unset";},["{self}"]).play();//Clearing the objects due to the memeory leak
originalValues={};animateValues={};return easeCount;}},{key:'setGradient',value:function setGradient(color,subColor,element){var color1=hex2rgb(color.substr(1));var color2=hex2rgb(subColor.substr(1));var r1=color1[0];var g1=color1[1];var b1=color1[2];//color2
var r2=color2[0];var g2=color2[1];var b2=color2[2];var r_mid=r1+(r2-r1)/2;var g_mid=g1+(g2-g1)/2;var b_mid=b1+(b2-b1)/2;var id="gr_eKkwrvfwvE";var defs=element.querySelectorAll("stop");if(defs&&defs[0]!==undefined){defs[0].setAttribute('stop-color',"rgb("+r1+","+g1+","+b1+")");defs[1].setAttribute('stop-color',"rgb("+r_mid+","+g_mid+","+b_mid+")");defs[2].setAttribute('stop-color',"rgb("+r2+","+g2+","+b2+")");}}},{key:'clearTimeLineMax',value:function clearTimeLineMax(){var _this11=this;if(this.t1!==null){for(var name in this.overAllBenzValues){delete __WEBPACK_IMPORTED_MODULE_9_gsap__["c" /* Ease */].map[this.overAllBenzValues[name]];}this.t1.clear();this.t1.getChildren().map(function(val){return _this11.t1.remove(val);});this.t1.kill();this.t1=null;this.overAllBenzValues=[];}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var _this12=this;if(this.t1!==null){this.clearTimeLineMax();}if(this.state.effect!==prevState.effect||this.state.colors!==prevState.colors){if(this.state.svgAnimation){if(this.state.effect!==prevState.effect){this.loadSvgData(this.state.svgSource).then(function(data){_this12.setColors(_this12.state.colors,_this12.slideSvg.getElementsByTagName("svg")[0],false);_this12.loadAnimData(_this12.state.animSrc).then(function(data){_this12.assignTweenValues(_this12.state.animData);_this12.random=Math.random();});});}else{this.setColors(this.state.colors,this.slideSvg.getElementsByTagName("svg")[0],false);this.assignTweenValues(this.state.animData);this.random=Math.random();}}else{this.scenePreview.previewScene(this.state.effect);}}}},{key:'loadAnimData',value:function loadAnimData(src){var _this13=this;this._axiosRequest=this.fetchByAxios(src).then(function(animData){_this13._axiosRequest=null;_this13.setState({animData:animData});});return this._axiosRequest;}},{key:'loadSvgData',value:function loadSvgData(src){var _this14=this;this.setState({status:"loading"});this._axiosRequest=this.fetchByAxios(src).then(function(svgData){_this14._axiosRequest=null;_this14.setState({svgData:svgData,status:"loaded"});});return this._axiosRequest;}},{key:'fetchByAxios',value:function fetchByAxios(src){return __WEBPACK_IMPORTED_MODULE_11_axios___default.a.get(src).then(function(response){return response.data;});}},{key:'render',value:function render(){var _this15=this;var returnElem=null;if(this.state.svgSource!==null){if(this.state.status==="loaded")returnElem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:this.state.src+this.random,ref:function ref(e){return _this15.slideSvg=e;},style:{position:"absolute",left:0,right:0,bottom:0,top:0,pointerEvents:"none"},className:'scene-transition',dangerouslySetInnerHTML:{__html:this.state.svgData}});else returnElem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:this.state.src+this.random,ref:function ref(e){return _this15.slideSvg=e;},style:{position:"absolute",left:0,right:0,bottom:0,top:0,pointerEvents:"none",display:"flex"},className:'scene-transition'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{id:'transition-loader',src:this.appUrl+"/images/chr-loading.svg",alt:'font-name-loader',style:{margin:"0 auto"}}));}return returnElem;}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(props,state){var toReturn={};if(props.effect!==state.effect){toReturn=Object.assign(toReturn,{effect:props.effect});}if(props.colors!==state.colors&&props.colors!==undefined&&props.colors.size>0){var svgSource=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["ASSETS"][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["ASSETS"]["current"]]+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["SCREEN"][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["SCREEN"]["workspace"]]+(props.width>props.height?"horizontal":props.width<props.height?"vertical":"square")+"/"+props.effect+".svg";var animSrc=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["ASSETS"][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["ASSETS"]["current"]]+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["SCREEN"]["animdata"]+(props.width>props.height?"horizontal":props.width<props.height?"vertical":"square")+"/"+props.effect+".json";toReturn=Object.assign(toReturn,{colors:props.colors,svgSource:svgSource,animSrc:animSrc,svgAnimation:true});}else{toReturn=Object.assign(toReturn,{svgAnimation:false});}return toReturn;}}]);return TransitionPreview;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var CustomSVGRender=function(_React$Component6){_inherits(CustomSVGRender,_React$Component6);function CustomSVGRender(props){_classCallCheck(this,CustomSVGRender);var _this16=_possibleConstructorReturn(this,(CustomSVGRender.__proto__||Object.getPrototypeOf(CustomSVGRender)).call(this,props));_this16.state={svgElement:null};_this16.svgData=[];_this16.isLoaded=false;_this16.t1=new __WEBPACK_IMPORTED_MODULE_9_gsap__["f" /* TimelineMax */]({paused:true});_this16.mouthT1=new __WEBPACK_IMPORTED_MODULE_9_gsap__["f" /* TimelineMax */]({paused:true});_this16.isPlaying=false;_this16.loadSVGData=_this16.loadSVGData.bind(_this16);_this16.loadSVGAnimation=_this16.loadSVGAnimation.bind(_this16);_this16.loadParts=_this16.loadParts.bind(_this16);_this16.changePartHandler=_this16.changePartHandler.bind(_this16);_this16.assignTweenValues=_this16.assignTweenValues.bind(_this16);_this16.changeExpression=_this16.changeExpression.bind(_this16);_this16.clearTimeLineMax=_this16.clearTimeLineMax.bind(_this16);_this16.DomParser=new DOMParser();_this16.overAllBenzValues=[];_this16.partsCount=0;_this16.partsLoadCount=0;_this16.ComponentWillMounted=false;_this16.appUrl=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a['APPICONS'][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a['APPICONS']['current']];_this16.assetUrl=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["ASSETS"][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["ASSETS"]["current"]];_this16.cancelSrcToken=__WEBPACK_IMPORTED_MODULE_11_axios___default.a.CancelToken;_this16.cancelSrc;_this16.currentExpression=props.expression;_this16.currentExpressionType=props.assetSubType;return _this16;}// upload, prop
_createClass(CustomSVGRender,[{key:'setColors',value:function setColors(colors,element){var _this17=this;if(!element)return;if(this.props.assetSubType==="GRAD"){this.setGradient(colors.get("prop1"),colors.get("prop2"),element);colors=colors.remove("prop1").remove("prop2");if(colors.size>0){colors.entrySeq().forEach(function(_ref7){var _ref8=_slicedToArray(_ref7,2),_className=_ref8[0],_color=_ref8[1];var cols=element.querySelectorAll("[class*='"+_className+"']");for(var i=0;i<cols.length;i++){if(cols[i].getElementsByTagName("path")[0].hasAttribute("fill"))cols[i].getElementsByTagName("path")[0].setAttribute('fill',_color);}});}return;}else{colors.entrySeq().forEach(function(_ref9){var _ref10=_slicedToArray(_ref9,2),_className=_ref10[0],_color=_ref10[1];var cols=element.querySelectorAll('[class'+(_this17.props.assetSubType!=="GETTYICON"?"*":"")+'='+_className+']');if(_color!==""){for(var i=0;i<cols.length;i++){var resa=cols[i].className.animVal.replace(/zf/g,'.');resa=resa.split("_");if(cols[i].firstChild&&cols[i].firstChild.hasAttribute&&!cols[i].className.animVal.includes("Mc")){if(resa.length!==1){var newColor=_iHSL10(_color.substr(1),parseFloat(resa[1]),parseFloat(resa[2]),parseFloat(resa[3]));if(cols[i].children.length>0){if(cols[i].firstChild.hasAttribute("fill")){cols[i].firstChild.setAttribute('fill',newColor);}if(cols[i].firstChild.hasAttribute("stroke")){cols[i].firstChild.setAttribute('stroke',newColor);}}}else{if(cols[i].children.length>0){if(cols[i].firstChild.hasAttribute("fill"))cols[i].firstChild.setAttribute('fill',_color);if(cols[i].firstChild.hasAttribute("stroke"))cols[i].firstChild.setAttribute('stroke',_color);}}}else if(cols[i].hasAttribute('fill')||cols[i].hasAttribute("stroke")){if(cols[i].hasAttribute("stroke")){cols[i].setAttribute("stroke",_color);}cols[i].setAttribute('fill',_color);}else if(cols[i].getAttribute('class')&&cols[i].getAttribute('class').includes('cls')){if(cols[i].getAttribute('class').includes('applyStroke')){cols[i].style.stroke=_color;}else{cols[i].style.fill=_color;}}else{if(cols[i].firstChild!==null&&cols[i].firstChild.hasAttribute("fill"))cols[i].firstChild.setAttribute('fill',_color);}}}});}}},{key:'setGradient',value:function setGradient(color,subColor,element){var color1=hex2rgb(color.substr(1));var color2=hex2rgb(subColor.substr(1));var r1=color1[0];var g1=color1[1];var b1=color1[2];//color2
var r2=color2[0];var g2=color2[1];var b2=color2[2];var r_mid=r1+(r2-r1)/2;var g_mid=g1+(g2-g1)/2;var b_mid=b1+(b2-b1)/2;var grads=element.querySelectorAll("linearGradient");for(var i=0;i<grads.length;i++){var defs=grads[i].querySelectorAll("stop");if(defs&&defs[0]!==undefined){defs[0].setAttribute('stop-color',"rgb("+r1+","+g1+","+b1+")");defs[1].setAttribute('stop-color',"rgb("+r_mid+","+g_mid+","+b_mid+")");defs[2].setAttribute('stop-color',"rgb("+r2+","+g2+","+b2+")");}}}},{key:'componentWillMount',value:function componentWillMount(){if((this.props.isPlay||this.props.isPlayAll)&&this.props.assetType==="PROP"&&this.props.isAnimated)this.loadSVGData(this.props.animsrc,false);else this.loadSVGData(this.props.src,false);}},{key:'clearTimeLineMax',value:function clearTimeLineMax(){var _this18=this;if(this.t1!==null){for(var name in this.overAllBenzValues){delete __WEBPACK_IMPORTED_MODULE_9_gsap__["c" /* Ease */].map[this.overAllBenzValues[name]];}this.t1.clear();this.t1.getChildren().map(function(val){return _this18.t1.remove(val);});this.t1.kill();this.t1=null;this.overAllBenzValues=[];}}},{key:'drawQcurve',value:function drawQcurve(l2,t2,calloutPath){var x1,y1,x0,y0,x2,y2;var miiddleDist=l2+(t2-l2)/2;x0=calloutPath.getPointAtLength(l2).x;y0=calloutPath.getPointAtLength(l2).y;x1=calloutPath.getPointAtLength(miiddleDist).x;y1=calloutPath.getPointAtLength(miiddleDist).y;x2=calloutPath.getPointAtLength(t2).x;y2=calloutPath.getPointAtLength(t2).y;x1=x1*2-(x0+x2)/2;y1=y1*2-(y0+y2)/2;return" Q"+x1+" "+y1+" "+x2+" "+y2+" ";}},{key:'getCubicBezierPoints',value:function getCubicBezierPoints(pointDataArr,t){var helperPoints=[];for(var i=1;i<4;i++){var p=this.lerp(pointDataArr[i-1],pointDataArr[i],t);helperPoints.push(p);}helperPoints.push(this.lerp(helperPoints[0],helperPoints[1],t));helperPoints.push(this.lerp(helperPoints[1],helperPoints[2],t));helperPoints.push(this.lerp(helperPoints[3],helperPoints[4],t));var firstBezier=[pointDataArr[0],helperPoints[0],helperPoints[3],helperPoints[5]];var secondBezier=[helperPoints[5],helperPoints[4],helperPoints[2],pointDataArr[3]];// returns 2 array of points for the new bezier curves;
return[firstBezier,secondBezier];}},{key:'lerp',value:function lerp(A,B,t){return[(Number(B[0])-Number(A[0]))*t+Number(A[0]),// the x coordinate;
(Number(B[1])-Number(A[1]))*t+Number(A[1])// the y coordinate;
];}},{key:'sfix',value:function sfix(arr){var num1=Number(arr[0]);var num2=Number(arr[1]);num1=num1<0?Math.floor(Math.abs(num1)*100)*-1/100:num1.toFixed(2);num2=num2<0?Math.floor(Math.abs(num2)*100)*-1/100:num2.toFixed(2);return num1+","+num2;}},{key:'sFix2',value:function sFix2(num1,num2){num1=Number(num1);num2=Number(num2);num1=num1<0?Math.floor(Math.abs(num1)*100)*-1/100:num1.toFixed(2);num2=num2<0?Math.floor(Math.abs(num2)*100)*-1/100:num2.toFixed(2);return num1+","+num2;}},{key:'loadSVGData',value:function loadSVGData(srcVal,fromExpression,newAnimData,isSwap,isAnimDataDifferent){if(document.getElementById(this.props.data_id)&&!this.props.isPlay&&document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0]&&this.props.assetType!=="PROP"&&this.props.assetType!=="UPLOADS"&&this.props.assetType!=="SCREEN"){document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0].style.display="flex";if(document.getElementById(this.props.data_id+"inner"))document.getElementById(this.props.data_id+"inner").style.display="none";}else if(document.getElementById(this.props.data_id)&&!this.props.isPlay&&document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0]&&isSwap){document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0].style.display="flex";if(document.getElementById(this.props.data_id+"inner"))document.getElementById(this.props.data_id+"inner").style.display="none";}if(this.currentExpressionType==="CCHR"||this.currentExpressionType==="CHR"){var _$exec$0$split=/[^/]*$/.exec(srcVal)[0].split('.'),_$exec$0$split2=_slicedToArray(_$exec$0$split,2),src=_$exec$0$split2[0],extension=_$exec$0$split2[1];srcVal=srcVal.replace(/\/[^\/]*$/,'/'+src+'-'+this.currentExpression+'.'+extension);}if(this.cancelSrc)this.cancelSrc();__WEBPACK_IMPORTED_MODULE_11_axios___default()({method:'GET',url:srcVal,mode:'cors',withCredentials:false,credentials:'same-origin',headers:{'Access-Control-Allow-Origin':'*','Content-Type':'image/svg+xml'},data:{},cancelToken:new this.cancelSrcToken(function executor(c){this.cancelSrc=c;}.bind(this))}).then(function(res){var svgEle='';if(this.props.uploadSVG){var tempEle=document.createElement('div');tempEle.innerHTML=res.data;svgEle=tempEle.children[0];}else{svgEle=res.request.responseXML.documentElement;}this.svgData=[];if(this.props.colors){this.setColors(this.props.colors,svgEle);}var setClass='scene-item-inner';if(this.props.isBG){setClass='';}else if(this.props.isKeyframe){setClass='keyframe-item-inner';}for(var i=0;i<svgEle.getElementsByTagName("mask").length;i++){var random=Math.random().toString(12).substr(0,10).replace(".","")+new Date().getTime().toString();var masks=svgEle.querySelectorAll("[mask=\"url(#"+svgEle.getElementsByTagName("mask")[i].id+")\"]");for(var m=0;m<masks.length;m++){masks[m].setAttribute("mask","url(#"+random+")");}svgEle.getElementsByTagName("mask")[i].id=random;}for(var i=0;i<svgEle.getElementsByTagName("filter").length;i++){var _random=Math.random().toString(12).substr(0,10).replace(".","")+new Date().getTime().toString();var filters=svgEle.querySelectorAll("[filter=\"url(#"+svgEle.getElementsByTagName("filter")[i].id+")\"]");for(var f=0;f<filters.length;f++){filters[f].setAttribute("filter","url(#"+_random+")");}svgEle.getElementsByTagName("filter")[i].id=_random;}for(var i=0;i<svgEle.getElementsByTagName("clipPath").length;i++){var _random2=Math.random().toString(12).substr(0,10).replace(".","")+new Date().getTime().toString();var clips=svgEle.querySelectorAll("[clip-path=\"url(#"+svgEle.getElementsByTagName("clipPath")[i].id+")\"]");for(var c=0;c<clips.length;c++){clips[c].setAttribute("clip-path","url(#"+_random2+")");}svgEle.getElementsByTagName("clipPath")[i].id=_random2;}for(var i=0;i<svgEle.getElementsByTagName("linearGradient").length;i++){var _random3=Math.random().toString(12).substr(0,10).replace(".","")+new Date().getTime().toString();var _clips=svgEle.querySelectorAll("[fill=\"url(#"+svgEle.getElementsByTagName("linearGradient")[i].id+")\"]");for(var c=0;c<_clips.length;c++){_clips[c].setAttribute("fill","url(#"+_random3+")");}svgEle.getElementsByTagName("linearGradient")[i].id=_random3;}for(var i=0;i<svgEle.getElementsByTagName("radialGradient").length;i++){var _random4=Math.random().toString(12).substr(0,10).replace(".","")+new Date().getTime().toString();var _clips2=svgEle.querySelectorAll("[fill=\"url(#"+svgEle.getElementsByTagName("radialGradient")[i].id+")\"]");for(var c=0;c<_clips2.length;c++){_clips2[c].setAttribute("fill","url(#"+_random4+")");}svgEle.getElementsByTagName("radialGradient")[i].id=_random4;}var uses=svgEle.getElementsByTagName("use");for(var i=0;i<uses.length;i++){var _random5="a"+Math.random().toString(12).substr(0,10).replace(".","")+new Date().getTime().toString();var hrefAttr=uses[i].getAttribute("xlink:href");var useTags=svgEle.querySelectorAll("[*|href='"+hrefAttr+"']");for(var j=0;j<useTags.length;j++){useTags[j].setAttribute("xlink:href","#"+_random5);}var usePahts=svgEle.querySelectorAll(hrefAttr);for(var u=0;u<usePahts.length;u++){usePahts[u].setAttribute("id",_random5);}}this.svgData.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:this.props.data_id,className:setClass,id:this.props.data_id+"inner",style:{width:"100%",height:"100%",position:"absolute"},'data-id':this.props.data_id,dangerouslySetInnerHTML:{__html:svgEle.outerHTML}}));this.setState({svgElement:this.svgData},function(){var _this19=this;if(this.props.assetType==="PROP"||this.props.assetType==="UPLOADS"||this.props.assetType==="SCREEN"){this.isPlaying=false;if(document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0])document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0].style.display="none";document.getElementById(this.props.data_id+"inner").style.display="block";if(this.props.selectedItems.size===1&&this.props.selectedItems.get(0)===this.props.data_id||this.props.isPlay||this.props.isPlayAll){if(this.props.isAnimated)this.loadSVGAnimation(this.props.animdata);if(this.props.assetType==="SCREEN")this.loadSVGAnimation(this.props.animdata);}if(this.props.assetType==="PROP"&&!this.props.isAnimated&&(this.props.isPlayAll||this.props.isPlay)){window.totalArr=window.totalArr.filter(function(e){return e!==_this19.props.data_id;});if(window.totalArr.length===0)this.props.startPlay("workspace");}}else if(!this.props.isPlay){if(document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0])document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0].style.display="none";document.getElementById(this.props.data_id+"inner").style.display="block";}if(this.props.assetSubType==="CHR"){var changeArr=["EYEBROW","EYE","MOUTH"];changeArr.map(function(item,key){this.changeExpression(item,this.currentExpression);}.bind(this));if(isAnimDataDifferent||this.props.isPlay||this.props.isPlayAll){this.loadSVGAnimation(this.props.animdata);}}if(this.props.assetSubType==="ANIMAL"||this.props.assetSubType==="ECHR"){if(isAnimDataDifferent||this.props.isPlay||this.props.isPlayAll){this.loadSVGAnimation(this.props.animdata);}}if(this.props.parts!==undefined){this.partsCount=this.props.parts.size;this.partsLoadCount=0;if(!this.props.isPlay){if(document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0])document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0].style.display="flex";document.getElementById(this.props.data_id+"inner").style.display="none";}this.props.parts.map(function(item,key){if(item!==""&&item!=="undefined"){this.loadParts(item,key,this.props.pose,this.props.expression);}else{this.partsLoadCount++;if(this.partsLoadCount===this.partsCount)this.loadSVGAnimation(this.props.animdata);}}.bind(this));}});}.bind(this)).catch(function(error){if(!__WEBPACK_IMPORTED_MODULE_11_axios___default.a.isCancel(error)){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])("failed to load",error,"WorkspaceComponent-loadSVGData");}});}},{key:'loadParts',value:function loadParts(partData,part,pose,expression){if(part.toLowerCase()==="mouth"){var _partData$split=partData.split('.'),_partData$split2=_slicedToArray(_partData$split,2),src=_partData$split2[0],extension=_partData$split2[1];var urlSrc=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["CCHR"]["part_src"]+pose+"/"+part.toLowerCase()+"/"+(src+'-'+expression+'.'+extension);}else{var urlSrc=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["CCHR"]["part_src"]+pose+"/"+part.toLowerCase()+"/"+partData;}__WEBPACK_IMPORTED_MODULE_11_axios___default()({method:'GET',url:urlSrc,mode:'cors',withCredentials:false,credentials:'same-origin',headers:{'Access-Control-Allow-Origin':'*','Content-Type':'image/svg+xml'},data:{}}).then(function(res){var parsedHtml=this.DomParser.parseFromString(res.request.responseText,"text/xml").firstChild;this.clearTimeLineMax();this.changePartHandler(parsedHtml,part,expression);this.partsLoadCount++;if(this.partsLoadCount===this.partsCount){if(this.props.selectedItems.size===1&&this.props.selectedItems.get(0)===this.props.data_id||this.props.isPlay||this.props.isPlayAll){if(this.props.assetType!=="PROP"&&this.props.assetType!=="UPLOADS"&&this.props.assetType!=="SCREEN"&&this.props.assetType!=="SHAPE"){this.loadSVGAnimation(this.props.animdata);}}this.setColors(this.props.colors,document.getElementById(this.props.data_id).getElementsByTagName("svg")[0]);if(!this.props.isPlay){if(document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0])document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0].style.display="none";document.getElementById(this.props.data_id+"inner").style.display="block";}}}.bind(this)).catch(function(error){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-loadParts");});}},{key:'changePartHandler',value:function changePartHandler(svgText,partName,expression){if(expression===undefined||expression==="normal")expression="";var curPart;var currentPart=partName.toLowerCase();if(currentPart==="hair")curPart=["middlehairMc","backhairMc","tophairMc","backfronthairMc"];else if(currentPart==="facehair")curPart=["mustacheMc","beardMc"];else if(currentPart==="shoe")curPart=["rshoeMc","lshoeMc","rsocksMc","lsocksMc","lshoetopMc","rshoetopMc"];else if(currentPart==="nose")curPart=["noseMc"];else if(currentPart==="ear")curPart=["learMc","rearMc"];else if(currentPart==="face")curPart=["faceMc","chinMc"];else if(currentPart==="mouth")curPart=["mouthMc","mouthMcbored","mouthMchypnotism","mouthMcconfident","mouthMcrelaxed","mouthMcfear","mouthMctough","mouthMcevil","mouthMcthoughtful","mouthMcsleepy","mouthMcshocking","mouthMcexcited","mouthMcconfused","mouthMcangry","mouthMcsad","mouthMchappy","animmouthMcevil","animmouthMcexcited","animmouthMcshocking","animmouthMcconfused","animmouthMcangry","animmouthMcsad","animmouthMchappy","animmouthMc","actmouthMc1","actmouthMc2","actmouthMc3","actmouthMc4","actmouthMc5","actmouthMc6","actmouthMc7","actmouthMc8",,"actmouthMc9","actmouthMc10","actmouthMc11","actmouthMc12","actmouthMc13","actmouthMc14"];else if(currentPart==="watch")curPart=["watchMc"];else if(currentPart==="mask")curPart=["maskMc"];else if(currentPart==="cap")curPart=["capMc","backcapMc","hathairMc"];else if(currentPart==="wband")curPart=["wristbandMc"];else if(currentPart==="headphone")curPart=["headphoneMc"];else if(currentPart==="glass")curPart=["glassMc"];else if(currentPart==="neckwear")curPart=["mufflertopMc","mufflerbottomMc"];else if(currentPart==="jewel")curPart=["chainMc"];else if(currentPart==="tattoo")curPart=["rtattooMc","ltattooMc"];else if(currentPart==="cheekline")curPart=["cheeklinesMc"];else if(currentPart==="foreheadline")curPart=["foreheadlinesMc"];else if(currentPart==="eyeline")curPart=["eyelinesMc"];else if(currentPart==="freckle")curPart=["frecklesMc"];else if(currentPart==="earring")curPart=["rearringMc","learringMc"];else if(currentPart==="eyebrow")curPart=["leyebrowMc","leyebrowMchappy","leyebrowMcsad","leyebrowMcangry","leyebrowMcexcited","leyebrowMcfrustration","leyebrowMcconfused","leyebrowMcthoughtful","leyebrowMcbored","leyebrowMcevil","leyebrowMcconfident","leyebrowMctough","leyebrowMcworried","leyebrowMcdisappointed","leyebrowMcshocking","leyebrowMcrelaxed","leyebrowMcsleepy","leyebrowMclove","leyebrowMchypnotism","leyebrowMcfear","leyebrowMcsurprise","reyebrowMc","reyebrowMchappy","reyebrowMcsad","reyebrowMcangry","reyebrowMcexcited","reyebrowMcfrustration","reyebrowMcconfused","reyebrowMcthoughtful","reyebrowMcbored","reyebrowMcevil","reyebrowMcconfident","reyebrowMctough","reyebrowMcworried","reyebrowMcdisappointed","reyebrowMcshocking","reyebrowMcrelaxed","reyebrowMcsleepy","reyebrowMclove","reyebrowMchypnotism","reyebrowMcfear","reyebrowMcsurprise"];else if(currentPart==="eye")curPart=["reyeMc","reyeMchappy","reyeMcsad","reyeMcangry","reyeMcexcited","reyeMcfrustration","reyeMcconfused","reyeMcthoughtful","reyeMcbored","reyeMcevil","reyeMcconfident","reyeMctough","reyeMcworried","reyeMcdisappointed","reyeMcshocking","reyeMcrelaxed","reyeMcsleepy","reyeMclove","reyeMchypnotism","reyeMcfear","reyeMcsurprise","leyeMc","leyeMchappy","leyeMcsad","leyeMcangry","leyeMcexcited","leyeMcfrustration","leyeMcconfused","leyeMcthoughtful","leyeMcbored","leyeMcevil","leyeMcconfident","leyeMctough","leyeMcworried","leyeMcdisappointed","leyeMcshocking","leyeMcrelaxed","leyeMcsleepy","leyeMclove","leyeMchypnotism","leyeMcfear","leyeMcsurprise"];if(currentPart==="facehair"||currentPart==="tattoo"||currentPart==="earring"||currentPart==="mouth"||currentPart==="shoe"||currentPart==="neckwear"||currentPart==="hair"||currentPart==="face"||currentPart==="cap"||currentPart==="eyebrow"||currentPart==="eye"||currentPart==="ear"){var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=curPart[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var val=_step2.value;var svgVal=val;if(document.getElementById(this.props.data_id).getElementsByClassName(val)[0]){if(svgText.getElementsByClassName(svgVal).length===0){document.getElementById(this.props.data_id).getElementsByClassName(val)[0].innerHTML="";if(currentPart==="hat")document.getElementById(this.props.data_id).getElementsByClassName("tophairMc")[0].setAttribute("opacity","1");}else{var svgData=svgText;if(currentPart==="eye"){for(var i=0;i<document.getElementById(this.props.data_id).getElementsByClassName(val)[0].children.length;i++){if(document.getElementById(this.props.data_id).getElementsByClassName(val)[0].children[i].className.animVal.indexOf("eyeglow")>-1||document.getElementById(this.props.data_id).getElementsByClassName(val)[0].children[i].className.animVal.indexOf("eyepupil")>-1){if(svgData.getElementsByClassName(document.getElementById(this.props.data_id).getElementsByClassName(val)[0].children[i].className.animVal)[0]){svgData.getElementsByClassName(document.getElementById(this.props.data_id).getElementsByClassName(val)[0].children[i].className.animVal)[0].parentNode.replaceChild(document.getElementById(this.props.data_id).getElementsByClassName(val)[0].children[i],svgData.getElementsByClassName(document.getElementById(this.props.data_id).getElementsByClassName(val)[0].children[i].className.animVal)[0]);i--;}}}}document.getElementById(this.props.data_id).getElementsByClassName(val)[0].innerHTML=svgData.getElementsByClassName(svgVal)[0].innerHTML;if(currentPart==="hat")document.getElementById(this.props.data_id).getElementsByClassName("tophairMc")[0].setAttribute("opacity","0");if(currentPart==="mouth"&&this.props.expFlag!="1"&&this.props.expFlag!="2"){if(expression==="frustration")expression="angry";else if(expression==="love"||expression==="surprise")expression="excited";else if(expression==="worried"||expression==="disappointed")expression="sad";document.getElementById(this.props.data_id).getElementsByClassName(val)[0].setAttribute("opacity","0");if(document.getElementById(this.props.data_id).getElementsByClassName("mouthMc"+expression)[0]){document.getElementById(this.props.data_id).getElementsByClassName("mouthMc"+expression)[0].setAttribute("opacity","1");document.getElementById(this.props.data_id).getElementsByClassName("mouthMc"+expression)[0].style.display="block";}else{if(this.props.expFlag!="1"&&this.props.expFlag!="2"&&this.props.expFlag!=undefined){document.getElementById(this.props.data_id).getElementsByClassName("mouthMc")[0].setAttribute("opacity","1");document.getElementById(this.props.data_id).getElementsByClassName("mouthMc")[0].style.display="block";}}}else if(currentPart==="mouth"&&(this.props.expFlag=="1"||this.props.expFlag=="2")){document.getElementById(this.props.data_id).getElementsByClassName(val)[0].setAttribute("opacity","0");document.getElementById(this.props.data_id).getElementsByClassName(this.props.mouthAction)[0].setAttribute("opacity","1");document.getElementById(this.props.data_id).getElementsByClassName(this.props.mouthAction)[0].style.display="block";}if(currentPart==="eyebrow"){document.getElementById(this.props.data_id).getElementsByClassName(val)[0].setAttribute("opacity","0");if(document.getElementById(this.props.data_id).getElementsByClassName("leyebrowMc"+expression)[0])document.getElementById(this.props.data_id).getElementsByClassName("leyebrowMc"+expression)[0].setAttribute("opacity","1");document.getElementById(this.props.data_id).getElementsByClassName("reyebrowMc"+expression)[0].setAttribute("opacity","1");}else if(currentPart==="eye"){document.getElementById(this.props.data_id).getElementsByClassName(val)[0].setAttribute("opacity","0");document.getElementById(this.props.data_id).getElementsByClassName("reyeMc"+expression)[0].setAttribute("opacity","1");if(document.getElementById(this.props.data_id).getElementsByClassName("leyeMc"+expression)[0])document.getElementById(this.props.data_id).getElementsByClassName("leyeMc"+expression)[0].setAttribute("opacity","1");}svgData=null;}}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}else if(currentPart!=="topwear"&&currentPart!=="bottomwear"){if(document.getElementById(this.props.data_id).getElementsByClassName(curPart)[0]===undefined){if(currentPart==="mustache"||currentPart==="beard"||currentPart==="glass"){{document.getElementById(this.props.data_id).getElementsByClassName("faceMc")[0].appendChild(svgText.getElementsByClassName(curPart)[0]);}}}else if(svgText.getElementsByClassName(curPart).length===0){document.getElementById(this.props.data_id).getElementsByClassName(curPart)[0].innerHTML="";}else{document.getElementById(this.props.data_id).getElementsByClassName(curPart)[0].parentNode.replaceChild(svgText.getElementsByClassName(curPart)[0],document.getElementById(this.props.data_id).getElementsByClassName(curPart)[0]);}}else if(currentPart==="bottomwear"){var pantArr=["hipwearshape1","hipwearshape2","hipwearshape3","hipwearshape4","hipwearshape5","hipwearshape6","hipwearshape7","hipwearshape8","hipwearshape9","hipwearshape10","hipwearshape11","hipwearshape12","hipwearshape13","hipwearshape14","hipwearshape15","hipwearshape16","hipwearshape17","hipwearshape18","hipwearshape19","hipwearshape20","hipwearshape21","hipwearshape22","hipwearshape23","hipwearshape24","hipwearshape25","hipwearshape26","hipwearshape27","hipwearshape28","hipwearshape29","hipwearshape30","hipwearshape31","hipChildMc","rlowerlegChildMc","llowerlegChildMc","rupperlegChildMc","lupperlegChildMc","tophipMc"];var pantObj={};for(var n=0;n<pantArr.length;n++){if(document.getElementById(this.props.data_id).getElementsByClassName(pantArr[n])[0]!==undefined){for(var j=0;j<document.getElementById(this.props.data_id).getElementsByClassName(pantArr[n])[0].childNodes.length;j++){if(!document.getElementById(this.props.data_id).getElementsByClassName(pantArr[n])[0].childNodes[j].className.baseVal.includes("skin")){if(document.getElementById(this.props.data_id).getElementsByClassName(pantArr[n])[0].childNodes[j].className.baseVal.includes("Mc"))pantObj[document.getElementById(this.props.data_id).getElementsByClassName(pantArr[n])[0].childNodes[j].className.baseVal]=document.getElementById(this.props.data_id).getElementsByClassName(document.getElementById(this.props.data_id).getElementsByClassName(pantArr[n])[0].childNodes[j].className.baseVal)[0].innerHTML;document.getElementById(this.props.data_id).getElementsByClassName(document.getElementById(this.props.data_id).getElementsByClassName(pantArr[n])[0].childNodes[j].className.baseVal)[0].parentNode.removeChild(document.getElementById(this.props.data_id).getElementsByClassName(document.getElementById(this.props.data_id).getElementsByClassName(pantArr[n])[0].childNodes[j].className.baseVal)[0]);j=j-1;}}}}for(var n=0;n<pantArr.length;n++){if(svgText.getElementsByClassName(pantArr[n])[0]!==undefined){for(var m=0;m<svgText.getElementsByClassName(pantArr[n])[0].childNodes.length;m++){if(!svgText.getElementsByClassName(pantArr[n])[0].childNodes[m].className.baseVal.includes("skin")){if(document.getElementById(this.props.data_id).getElementsByClassName(pantArr[n]).length>0){document.getElementById(this.props.data_id).getElementsByClassName(pantArr[n])[0].appendChild(svgText.getElementsByClassName(pantArr[n])[0].childNodes[m]);m=m-1;}}}}}for(var key in pantObj){if(!key.includes("regpivot")&&document.getElementById(this.props.data_id).getElementsByClassName(key)[0])document.getElementById(this.props.data_id).getElementsByClassName(key)[0].innerHTML=pantObj[key];}pantObj={};}else if(currentPart==="topwear"){var shirtArr=["bodyChildMc","lupperarmChildMc","rupperarmChildMc","rlowerarmChildMc","llowerarmChildMc"];var shirtObj={};var domParser=svgText;for(var n=0;n<shirtArr.length;n++){for(var j=0;j<document.getElementById(this.props.data_id).getElementsByClassName(shirtArr[n])[0].childNodes.length;j++){if(!document.getElementById(this.props.data_id).getElementsByClassName(shirtArr[n])[0].childNodes[j].className.baseVal.includes("skin")){if(document.getElementById(this.props.data_id).getElementsByClassName(shirtArr[n])[0].childNodes[j].className.baseVal.includes("Mc")){shirtObj[document.getElementById(this.props.data_id).getElementsByClassName(shirtArr[n])[0].childNodes[j].className.baseVal]=document.getElementById(this.props.data_id).getElementsByClassName(document.getElementById(this.props.data_id).getElementsByClassName(shirtArr[n])[0].childNodes[j].className.baseVal)[0].innerHTML;}document.getElementById(this.props.data_id).getElementsByClassName(document.getElementById(this.props.data_id).getElementsByClassName(shirtArr[n])[0].childNodes[j].className.baseVal)[0].parentNode.removeChild(document.getElementById(this.props.data_id).getElementsByClassName(document.getElementById(this.props.data_id).getElementsByClassName(shirtArr[n])[0].childNodes[j].className.baseVal)[0]);j=j-1;}}}for(var _n2=0;_n2<shirtArr.length;_n2++){if(domParser.getElementsByClassName(shirtArr[_n2]).length>0){for(var _m=0;_m<domParser.getElementsByClassName(shirtArr[_n2])[0].childNodes.length;_m++){if(!domParser.getElementsByClassName(shirtArr[_n2])[0].childNodes[_m].className.baseVal.includes("skin")){document.getElementById(this.props.data_id).getElementsByClassName(shirtArr[_n2])[0].appendChild(domParser.getElementsByClassName(shirtArr[_n2])[0].childNodes[_m]);_m=_m-1;}}}}for(var _key in shirtObj){if(!_key.includes("regpivot")&&document.getElementById(this.props.data_id).getElementsByClassName(_key)[0])document.getElementById(this.props.data_id).getElementsByClassName(_key)[0].innerHTML=shirtObj[_key];shirtObj[_key]={};}shirtObj={};domParser={};}}},{key:'isBetween',value:function isBetween(n,a,b){return(n-a)*(n-b)<=0;}},{key:'wait',value:function wait(ms){var d=new Date();var d2=null;do{d2=new Date();}while(d2-d<ms);}},{key:'assignTweenValues',value:function assignTweenValues(res,isLipsync,easeCount){var _this20=this;var prefetchFlag=isLipsync;var prefetchToken=this.props.prefetchToken;this.isPlaying=true;this.isLoaded=true;var parent={"essentials":res.data.essentials};var animateValues=res.data.animateValues;var originalValues={};for(var child in parent.essentials){var thisName=child;originalValues[child]={"positionX":parent.essentials[thisName].p.split(",")[0],"positionY":parent.essentials[thisName].p.split(",")[1]};}var isRepeated=this.props.isRepeated==="0"?0:-1;if(!this.props.isRepeated)isRepeated=-1;if(this.props.assetType==="PROP"&&this.props.isAnimated)isRepeated=this.props.repeatLoop-1;if(!isLipsync)this.t1=new __WEBPACK_IMPORTED_MODULE_9_gsap__["f" /* TimelineMax */]({repeat:isRepeated,repeatDelay:0,yoyo:false,paused:true});var easeVal=__WEBPACK_IMPORTED_MODULE_9_gsap__["d" /* Linear */].easeNone;var characterAnimateVal=[];var mouthAnimateVal=[];if(!easeCount)var easeCount=0;var currentEase={};for(var idVal in animateValues){var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=animateValues[idVal][Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var valueData=_step3.value;if(valueData.isLipsync!==undefined){if(valueData.isLipsync)isLipsync=true;else isLipsync=false;}if(valueData.a==="P"){var _bezValues2=void 0;if(valueData.e==="no Ease"){_bezValues2=easeVal;}else{if(currentEase[valueData.e]===undefined){_bezValues2=valueData.e.split("[")[1].split("]")[0].split(",");__WEBPACK_IMPORTED_MODULE_10_gsap_CustomEase___default.a.create("easeName"+easeCount,"\""+_bezValues2[0]+","+_bezValues2[1]+","+_bezValues2[2]+","+_bezValues2[3]+"\"");this.overAllBenzValues.push("easeName"+easeCount);_bezValues2="easeName"+easeCount;currentEase[valueData.e]=_bezValues2;easeCount++;}else{_bezValues2=currentEase[valueData.e];}}var posXval=valueData.v.split(",")[0];var posYval=valueData.v.split(",")[1],hipMCPosition;if(posXval<0)posXval="-="+Math.abs(posXval);else posXval="+="+Math.abs(posXval);if(posYval<0)posYval="-="+Math.abs(posYval);else posYval="+="+Math.abs(posYval);if(document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0])if(document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0].firstChild){if(idVal==="hipMc"||idVal==="skateboardMc"){if(!hipMCPosition){hipMCPosition={x:parseFloat(originalValues[idVal].positionX),y:parseFloat(originalValues[idVal].positionY)};}else{hipMCPosition.x+=parseFloat(valueData.p.split(",")[0]);hipMCPosition.y+=parseFloat(valueData.p.split(",")[1]);}this.t1.to(document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0],valueData.d,{immediateRender:false,y:posYval,x:posXval,svgOrigin:hipMCPosition.x+'px '+hipMCPosition.y+'px',ease:_bezValues2},valueData.t);characterAnimateVal.push({domVal:document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0],duration:valueData.d,toVal:{y:posYval,x:posXval,svgOrigin:hipMCPosition.x+'px '+hipMCPosition.y+'px',ease:_bezValues2,immediateRender:false},time:valueData.t});}else if(isLipsync){this.mouthT1.to(document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0],valueData.d,{immediateRender:false,y:posYval,x:posXval,svgOrigin:parseFloat(originalValues[idVal].positionX)+'px '+parseFloat(originalValues[idVal].positionY)+'px',ease:_bezValues2,onComplete:function onComplete(){}},valueData.t);mouthAnimateVal.push({domVal:document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0],duration:valueData.d,toVal:{y:posYval,x:posXval,svgOrigin:parseFloat(originalValues[idVal].positionX)+'px '+parseFloat(originalValues[idVal].positionY)+'px',ease:_bezValues2,immediateRender:false},time:valueData.t});}else{this.t1.to(document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0],valueData.d,{immediateRender:false,y:posYval,x:posXval,svgOrigin:parseFloat(originalValues[idVal].positionX)+'px '+parseFloat(originalValues[idVal].positionY)+'px',ease:_bezValues2,onComplete:function onComplete(){}},valueData.t);characterAnimateVal.push({domVal:document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0],duration:valueData.d,toVal:{y:posYval,x:posXval,svgOrigin:parseFloat(originalValues[idVal].positionX)+'px '+parseFloat(originalValues[idVal].positionY)+'px',ease:_bezValues2,immediateRender:false},time:valueData.t});}}}if(valueData.a==="O"){var bezValues;if(valueData.e==="no Ease"){bezValues=easeVal;}else{if(currentEase[valueData.e]===undefined){bezValues=valueData.e.split("[")[1].split("]")[0].split(",");__WEBPACK_IMPORTED_MODULE_10_gsap_CustomEase___default.a.create("easeName"+easeCount,"\""+bezValues[0]+","+bezValues[1]+","+bezValues[2]+","+bezValues[3]+"\"");this.overAllBenzValues.push("easeName"+easeCount);bezValues="easeName"+easeCount;easeCount++;}else{bezValues=currentEase[valueData.e];}}var opacity=valueData.v/100;if(document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0]){if(isLipsync){this.mouthT1.to(document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0],0.001,{immediateRender:false,opacity:opacity,ease:__WEBPACK_IMPORTED_MODULE_9_gsap__["d" /* Linear */].easeNone},valueData.t+valueData.d/2);mouthAnimateVal.push({domVal:document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0],duration:0.001,toVal:{immediateRender:false,opacity:opacity,ease:__WEBPACK_IMPORTED_MODULE_9_gsap__["d" /* Linear */].easeNone},time:valueData.t+valueData.d/2});}else{this.t1.to(document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0],0.001,{immediateRender:false,opacity:opacity,ease:__WEBPACK_IMPORTED_MODULE_9_gsap__["d" /* Linear */].easeNone},valueData.t+valueData.d/2);characterAnimateVal.push({domVal:document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0],duration:0.001,toVal:{immediateRender:false,opacity:opacity,ease:__WEBPACK_IMPORTED_MODULE_9_gsap__["d" /* Linear */].easeNone},time:valueData.t+valueData.d/2});}}}if(valueData.a==="S"){var bezValues;if(valueData.e==="no Ease"){bezValues=easeVal;}else{if(currentEase[valueData.e]===undefined){bezValues=valueData.e.split("[")[1].split("]")[0].split(",");__WEBPACK_IMPORTED_MODULE_10_gsap_CustomEase___default.a.create("easeName"+easeCount,"\""+bezValues[0]+","+bezValues[1]+","+bezValues[2]+","+bezValues[3]+"\"");this.overAllBenzValues.push("easeName"+easeCount);bezValues="easeName"+easeCount;easeCount++;}else{bezValues=currentEase[valueData.e];}}var scaleXval=valueData.v.split(",")[0]/100;var scaleYval=valueData.v.split(",")[1]/100;if(document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0]){if(isLipsync){this.mouthT1.to(document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0],valueData.d,{scaleY:scaleYval,scaleX:scaleXval,svgOrigin:parseFloat(originalValues[idVal].positionX)+'px '+parseFloat(originalValues[idVal].positionY)+'px',ease:bezValues},valueData.t);mouthAnimateVal.push({domVal:document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0],duration:valueData.d,toVal:{scaleY:scaleYval,scaleX:scaleXval,svgOrigin:parseFloat(originalValues[idVal].positionX)+'px '+parseFloat(originalValues[idVal].positionY)+'px',ease:bezValues},time:valueData.t});}else{this.t1.to(document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0],valueData.d,{scaleY:scaleYval,scaleX:scaleXval,svgOrigin:parseFloat(originalValues[idVal].positionX)+'px '+parseFloat(originalValues[idVal].positionY)+'px',ease:bezValues},valueData.t);characterAnimateVal.push({domVal:document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0],duration:valueData.d,toVal:{immediateRender:false,scaleY:scaleYval,scaleX:scaleXval,svgOrigin:parseFloat(originalValues[idVal].positionX)+'px '+parseFloat(originalValues[idVal].positionY)+'px',ease:bezValues},time:valueData.t});}}}if(valueData.a==="R"){var bezValues;if(valueData.e==="no Ease"){bezValues=easeVal;}else{if(currentEase[valueData.e]===undefined){bezValues=valueData.e.split("[")[1].split("]")[0].split(",");__WEBPACK_IMPORTED_MODULE_10_gsap_CustomEase___default.a.create("easeName"+easeCount,"\""+bezValues[0]+","+bezValues[1]+","+bezValues[2]+","+bezValues[3]+"\"");this.overAllBenzValues.push("easeName"+easeCount);bezValues="easeName"+easeCount;easeCount++;}else{bezValues=currentEase[valueData.e];}}var rotateVal="";if(valueData.v<0){rotateVal="-="+Math.abs(valueData.v);}else{rotateVal="+="+Math.abs(valueData.v);}if(idVal==="hipMc"||idVal==="skateboardMc"){if(!hipMCPosition){hipMCPosition={x:parseFloat(originalValues[idVal].positionX),y:parseFloat(originalValues[idVal].positionY)};}else{hipMCPosition.x+=parseFloat(valueData.p.split(",")[0]);hipMCPosition.y+=parseFloat(valueData.p.split(",")[1]);}if(document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0]){this.t1.to(document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0],valueData.d,{rotation:rotateVal,svgOrigin:hipMCPosition.x+'px '+hipMCPosition.y+'px',ease:bezValues},valueData.t);characterAnimateVal.push({domVal:document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0],duration:valueData.d,toVal:{immediateRender:false,rotation:rotateVal,svgOrigin:hipMCPosition.x+'px '+hipMCPosition.y+'px',ease:bezValues},time:valueData.t});}}else{if(document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0]){this.t1.to(document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0],valueData.d,{immediateRender:false,rotation:rotateVal,svgOrigin:parseFloat(originalValues[idVal].positionX)+'px '+parseFloat(originalValues[idVal].positionY)+'px',ease:bezValues},valueData.t);characterAnimateVal.push({domVal:document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0],duration:valueData.d,toVal:{immediateRender:false,rotation:rotateVal,svgOrigin:parseFloat(originalValues[idVal].positionX)+'px '+parseFloat(originalValues[idVal].positionY)+'px',ease:bezValues},time:valueData.t});}}}if(valueData.a==="PA"){if(document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0]!=undefined&&document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0].firstChild!==undefined){this.t1.to(document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0].firstChild,valueData.d,{attr:{d:valueData.v}},Math.abs(valueData.t));characterAnimateVal.push({domVal:document.getElementById(this.props.data_id+"inner").firstElementChild.getElementsByClassName(idVal)[0].firstChild,duration:valueData.d,toVal:{immediateRender:false,attr:{d:valueData.v}},time:Math.abs(valueData.t)});}}}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}}currentEase={};var firsttrack="";if(this.props.isPlay||this.props.isPlayAll){var voiceArr=[];var lipSyncStartArr=[];var lipSyncEndArr=[];var playStartArr=[];var voiceData="";var lipSyncStart=0;var playStart=0;var lipSyncEnd=0;var startTimeVal=this.props.completeWorkspaceItems.get('enterStart');if(this.props.isPlayAll&&this.props.assetType!=="SCREEN")startTimeVal=this.props.scenStart+startTimeVal;var endTimeVal=this.props.completeWorkspaceItems.get('exitEnd');if(this.props.isPlayAll&&this.props.assetType!=="SCREEN")endTimeVal=this.props.scenStart+endTimeVal;this.props.addTween({type:this.props.assetType,isRepeated:this.props.isRepeated,isAnimated:this.props.isAnimated,repeatLoop:this.props.repeatLoop,timeline:characterAnimateVal,mouthValues:mouthAnimateVal,voiceData:voiceArr,startTime:startTimeVal,endTime:endTimeVal,idVal:this.props.data_id,lipSyncStart:lipSyncStartArr,lipSyncEnd:lipSyncEndArr,playStart:playStartArr,from:"workspace"},"addchartween");window.totalArr=window.totalArr.filter(function(e){return e!==_this20.props.data_id;});if(window.totalArr.length===0)this.props.startPlay("workspace");}else{if(this.props.assetType!=="CHR"){this.t1.play();}// else if(isLipsync && this.props.assetType === "CHR") 
// {
//   this.t1.play();
// }
}//Clearing the objects due to the memeory leak
characterAnimateVal={};mouthAnimateVal={};originalValues={};animateValues={};return easeCount;}},{key:'loadSVGAnimation',value:function loadSVGAnimation(animdataVal){if(!this.isPlaying){var projectType=this.props.workspaceWidth>this.props.workspaceHeight?"horizontal":this.props.workspaceHeight>this.props.workspaceWidth?"vertical":"square";var url=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[this.props.assetType].animdata+animdataVal;if(this.props.assetSubType==="CCHR"||this.props.assetSubType==="ECHR"||this.props.assetSubType==='EPROP')url=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[this.props.assetSubType].animdata+animdataVal;else if(this.props.assetType==='SCREEN'){url=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[this.props.assetType].animdata+projectType+'/'+animdataVal;}if(this.props.assetSubType==="CCHR"||this.props.assetSubType==="CHR"){var _animdataVal$split=animdataVal.split('.'),_animdataVal$split2=_slicedToArray(_animdataVal$split,2),src=_animdataVal$split2[0],extension=_animdataVal$split2[1];url=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[this.props.assetSubType].animdata+(src+'-'+this.props.expression+'.'+extension);}__WEBPACK_IMPORTED_MODULE_11_axios___default()({method:'GET',url:url,mode:'cors',withCredentials:false,credentials:'same-origin',headers:{'Access-Control-Allow-Origin':'*','Content-Type':'image/svg+xml','Accept':'application/json'},data:{}}).then(function(res){var easeCount=this.assignTweenValues(res,false);if(this.props.assetType!=="PROP"&&this.props.assetType!=="UPLOADS"&&this.props.assetType!=="SCREEN"&&this.props.assetSubType!=="CHR"&&this.props.assetSubType!=="ECHR"){var urlSrc;if(this.props.assetSubType==="CHR")urlSrc=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["CCHR"]["part_src"]+this.props.pose+"/mouth/m01-mouth-001.json";else urlSrc=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["CCHR"]["part_src"]+this.props.pose+"/mouth/"+this.props.parts.get("MOUTH").split(".")[0]+('-'+this.props.expression)+".json";__WEBPACK_IMPORTED_MODULE_11_axios___default()({method:'GET',url:urlSrc,mode:'cors',withCredentials:false,credentials:'same-origin',headers:{'Access-Control-Allow-Origin':'*','Content-Type':'image/svg+xml','Accept':'application/json'},data:{}}).then(function(res){this.assignTweenValues(res,true,easeCount);}.bind(this)).catch(function(error){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])("failed to load",error,"WorkspaceComponent-loadSVGAnimation");}.bind(this));}}.bind(this)).catch(function(error){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])("failed to load",error,"WorkspaceComponent-loadSVGAnimation");}.bind(this));}}},{key:'changeExpression',value:function changeExpression(partName,expression){var currentPart=partName.toLowerCase(),curPart;if(expression===undefined||expression==="normal")expression="";if(currentPart==="mouth")curPart=["mouthMc","mouthMcbored","mouthMchypnotism","mouthMcconfident","mouthMcrelaxed","mouthMcfear","mouthMctough","mouthMcevil","mouthMcthoughtful","mouthMcsleepy","mouthMcshocking","mouthMcexcited","mouthMcconfused","mouthMcangry","mouthMcsad","mouthMchappy","animmouthMcevil","animmouthMcexcited","animmouthMcshocking","animmouthMcconfused","animmouthMcangry","animmouthMcsad","animmouthMchappy","animmouthMc","actmouthMc1","actmouthMc2","actmouthMc3","actmouthMc4","actmouthMc5","actmouthMc6","actmouthMc7","actmouthMc8",,"actmouthMc9","actmouthMc10","actmouthMc11","actmouthMc12","actmouthMc13","actmouthMc14"];else if(currentPart==="eyebrow")curPart=["leyebrowMc","leyebrowMchappy","leyebrowMcsad","leyebrowMcangry","leyebrowMcexcited","leyebrowMcfrustration","leyebrowMcconfused","leyebrowMcthoughtful","leyebrowMcbored","leyebrowMcevil","leyebrowMcconfident","leyebrowMctough","leyebrowMcworried","leyebrowMcdisappointed","leyebrowMcshocking","leyebrowMcrelaxed","leyebrowMcsleepy","leyebrowMclove","leyebrowMchypnotism","leyebrowMcfear","leyebrowMcsurprise","reyebrowMc","reyebrowMchappy","reyebrowMcsad","reyebrowMcangry","reyebrowMcexcited","reyebrowMcfrustration","reyebrowMcconfused","reyebrowMcthoughtful","reyebrowMcbored","reyebrowMcevil","reyebrowMcconfident","reyebrowMctough","reyebrowMcworried","reyebrowMcdisappointed","reyebrowMcshocking","reyebrowMcrelaxed","reyebrowMcsleepy","reyebrowMclove","reyebrowMchypnotism","reyebrowMcfear","reyebrowMcsurprise"];else if(currentPart==="eye")curPart=["reyeMc","reyeMchappy","reyeMcsad","reyeMcangry","reyeMcexcited","reyeMcfrustration","reyeMcconfused","reyeMcthoughtful","reyeMcbored","reyeMcevil","reyeMcconfident","reyeMctough","reyeMcworried","reyeMcdisappointed","reyeMcshocking","reyeMcrelaxed","reyeMcsleepy","reyeMclove","reyeMchypnotism","reyeMcfear","reyeMcsurprise","leyeMc","leyeMchappy","leyeMcsad","leyeMcangry","leyeMcexcited","leyeMcfrustration","leyeMcconfused","leyeMcthoughtful","leyeMcbored","leyeMcevil","leyeMcconfident","leyeMctough","leyeMcworried","leyeMcdisappointed","leyeMcshocking","leyeMcrelaxed","leyeMcsleepy","leyeMclove","leyeMchypnotism","leyeMcfear","leyeMcsurprise"];var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=curPart[Symbol.iterator](),_step4;!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){var val=_step4.value;var svgVal=val;var firstNode=document.getElementById(this.props.data_id).getElementsByClassName(val)[0];if(firstNode){if(currentPart==="mouth"&&this.props.expFlag!="1"&&this.props.expFlag!="2"){if(expression==="frustration")expression="angry";else if(expression==="love"||expression==="surprise")expression="excited";else if(expression==="worried"||expression==="disappointed")expression="sad";document.getElementById(this.props.data_id).getElementsByClassName(val)[0].setAttribute("opacity","0");if(document.getElementById(this.props.data_id).getElementsByClassName("mouthMc"+expression)[0]){document.getElementById(this.props.data_id).getElementsByClassName("mouthMc"+expression)[0].setAttribute("opacity","1");document.getElementById(this.props.data_id).getElementsByClassName("mouthMc"+expression)[0].style.display="block";}else{document.getElementById(this.props.data_id).getElementsByClassName("mouthMc")[0].setAttribute("opacity","1");document.getElementById(this.props.data_id).getElementsByClassName("mouthMc")[0].style.display="block";}}else if(currentPart==="mouth"&&(this.props.expFlag=="1"||this.props.expFlag=="2")){document.getElementById(this.props.data_id).getElementsByClassName(val)[0].setAttribute("opacity","0");if(document.getElementById(this.props.data_id).getElementsByClassName(this.props.mouthAction)[0]){document.getElementById(this.props.data_id).getElementsByClassName(this.props.mouthAction)[0].setAttribute("opacity","1");document.getElementById(this.props.data_id).getElementsByClassName(this.props.mouthAction)[0].style.display="block";}}if(currentPart==="eyebrow"){firstNode.setAttribute("opacity","0");if(document.getElementById(this.props.data_id).getElementsByClassName("leyebrowMc"+expression)[0])document.getElementById(this.props.data_id).getElementsByClassName("leyebrowMc"+expression)[0].setAttribute("opacity","1");document.getElementById(this.props.data_id).getElementsByClassName("reyebrowMc"+expression)[0].setAttribute("opacity","1");}else if(currentPart==="eye"){firstNode.setAttribute("opacity","0");document.getElementById(this.props.data_id).getElementsByClassName("reyeMc"+expression)[0].setAttribute("opacity","1");if(document.getElementById(this.props.data_id).getElementsByClassName("leyeMc"+expression)[0])document.getElementById(this.props.data_id).getElementsByClassName("leyeMc"+expression)[0].setAttribute("opacity","1");}}}}catch(err){_didIteratorError4=true;_iteratorError4=err;}finally{try{if(!_iteratorNormalCompletion4&&_iterator4.return){_iterator4.return();}}finally{if(_didIteratorError4){throw _iteratorError4;}}}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.decibelVal!==nextProps.decibelVal){this.mouthT1.pause(nextProps.decibelVal);}if(nextProps.assetSubType!=="CCHR"&&nextProps.assetSubType!=="CHR"){if(this.props.expression!==undefined&&this.props.expression!==nextProps.expression&&this.props.animdata===nextProps.animdata&&(nextProps.swapDetails===null||nextProps.swapDetails===undefined)){var changeArr=["EYEBROW","EYE","MOUTH"];changeArr.map(function(item,key){this.changeExpression(item,nextProps.expression);}.bind(this));}}this.currentExpressionType=nextProps.assetSubType;this.currentExpression=nextProps.expression;if((this.props.animdata!==nextProps.animdata||this.props.expression!==nextProps.expression)&&(nextProps.swapDetails===null||nextProps.swapDetails===undefined)){this.isPlaying=false;if(this.t1!==null){this.clearTimeLineMax();}var isAnimDataDifferent=this.props.animdata!==nextProps.animdata;this.isLoaded=false;this.loadSVGData(nextProps.src,true,nextProps.animdata,null,isAnimDataDifferent);}if(this.props.isAnimated!==nextProps.isAnimated){this.isPlaying=false;if(this.t1!==null){this.clearTimeLineMax();}if(nextProps.isAnimated){this.isLoaded=false;this.loadSVGData(nextProps.animsrc,false);}else{this.isLoaded=false;this.loadSVGData(nextProps.src,false);}}if(nextProps.swapDetails!==undefined&&nextProps.swapDetails!==null&&nextProps.swapDetails.id===nextProps.data_id){this.isLoaded=false;this.clearTimeLineMax();this.loadSVGData(nextProps.src,false,undefined,true);}else if(this.props.colors!==undefined&&this.props.colors!==null&&!this.props.colors.equals(nextProps.colors)&&document.getElementById(nextProps.data_id).getElementsByTagName("svg")[0]!==null){this.setColors(nextProps.colors,document.getElementById(nextProps.data_id).getElementsByTagName("svg")[0]);// this.loadSVGData(nextProps.src, false);
}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.props.selectedItems.size===1&&this.props.selectedItems.get(0)===this.props.data_id||this.props.isPlay||this.props.isPlayAll){if(this.props.assetType!=="SHAPE"&&this.props.assetType!=="UPLOADS"&&this.props.assetType!=="PROP"&&!this.props.isPlay&&!this.props.isPlayAll){}else if(this.props.assetType==="PROP"||this.props.assetType==="UPLOADS"){if(this.props.selectedItems.get(0)!==prevProps.selectedItems.get(0)){if(this.props.isAnimated){this.isLoaded=false;this.loadSVGData(this.props.animsrc,false);}else{this.isLoaded=false;this.loadSVGData(this.props.src,false);}}}}else if(this.props.selectedItems.get(0)!==prevProps.selectedItems.get(0)&&(this.props.assetType==="PROP"||this.props.assetType==="UPLOADS")){this.loadSVGData(this.props.src,false);}else{this.isPlaying=false;if(this.t1){this.t1.pause(0);this.clearTimeLineMax();}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.isPlaying=false;if(this.t1!==null){this.t1.kill();this.t1=null;}}},{key:'render',value:function render(){var sourceThumb;if(this.props.assetType==="CHR")sourceThumb=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["CCHR"][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["CCHR"]["onload"]]+this.props.completeWorkspaceItems.getIn(["src"]).split(".")[0]+".png";else if(this.props.assetType==="PROP"){sourceThumb=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[this.props.assetType][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[this.props.assetType]["onload"]]+this.props.completeWorkspaceItems.getIn(["src"]).split(".")[0]+".png";}else if(this.props.assetType==="SHAPE"){var thumb=this.props.completeWorkspaceItems.getIn(["thumb"]);sourceThumb=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[this.props.assetType][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[this.props.assetType]["onload"]]+thumb;}if(!this.props.isPlay){var itemStyle={width:"inherit",height:"inherit",pointerEvents:"none"};if(this.props.assetType==="SHAPE")itemStyle.position="absolute";if(this.props.link!==undefined&&this.props.link!==''&&(this.props.isPlayAll||this.props.mode==='slide')){itemStyle.pointerEvents='auto';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:itemStyle},this.state.svgElement,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-html2canvas-ignore':'true',className:'loaderElement',style:{width:"100%",height:"100%",position:"absolute"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'loader',src:this.appUrl+"/images/chr-loading.svg",style:{width:"100%",objectFit:"scale-down"}})));}else return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.state.svgElement);}}]);return CustomSVGRender;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function _iHSL10(str1,hue,sat,light){var color1=hex2rgb(str1);var hsl1=rgb2hsl(color1);hsl1[0]=Number(hsl1[0])-Number(hue);hsl1[1]=Number(hsl1[1])-Number(sat);hsl1[2]=Number(hsl1[2])-Number(light);hsl1[0]=hsl1[0]>1?1:hsl1[0];hsl1[1]=hsl1[1]>1?1:hsl1[1];hsl1[2]=hsl1[2]>1?1:hsl1[2];hsl1[0]=hsl1[0]<0?0:hsl1[0];hsl1[1]=hsl1[1]<0?0:hsl1[1];hsl1[2]=hsl1[2]<0?0:hsl1[2];var arr3=hsl2rgb(hsl1);return rgb2hex(arr3[0],arr3[1],arr3[2]);};function hex2rgb(str){var arr1=[];arr1[0]=parseInt(str.substring(0,2),16);arr1[1]=parseInt(str.substring(2,4),16);arr1[2]=parseInt(str.substring(4,6),16);return arr1;}function rgb2hsl(color){var r=color[0]/255;var g=color[1]/255;var b=color[2]/255;var max=Math.max(r,g,b),min=Math.min(r,g,b);var h,s,l=(max+min)/2;if(max===min){h=s=0;// achromatic
}else{var d=max-min;s=l>0.5?d/(2-max-min):d/(max+min);switch(max){case r:h=(g-b)/d+(g<b?6:0);break;case g:h=(b-r)/d+2;break;case b:h=(r-g)/d+4;break;default:break;}h/=6;}return[h,s,l];};function hsl2rgb(color){var l=color[2];if(color[1]===0){l=Math.round(l*255);return[l,l,l];}else{var hue2rgb=function hue2rgb(p,q,t){if(t<0)t+=1;if(t>1)t-=1;if(t<1/6)return p+(q-p)*6*t;if(t<1/2)return q;if(t<2/3)return p+(q-p)*(2/3-t)*6;return p;};var s=color[1];var q=l<0.5?l*(1+s):l+s-l*s;var p=2*l-q;var r=hue2rgb(p,q,color[0]+1/3);var g=hue2rgb(p,q,color[0]);var b=hue2rgb(p,q,color[0]-1/3);return[Math.round(r*255),Math.round(g*255),Math.round(b*255)];}};function rgb2hex(red,green,blue){var rgb=blue|green<<8|red<<16;return'#'+(0x1000000+rgb).toString(16).slice(1);}var WorkspaceGrid=function(_React$Component7){_inherits(WorkspaceGrid,_React$Component7);function WorkspaceGrid(){_classCallCheck(this,WorkspaceGrid);return _possibleConstructorReturn(this,(WorkspaceGrid.__proto__||Object.getPrototypeOf(WorkspaceGrid)).apply(this,arguments));}_createClass(WorkspaceGrid,[{key:'render',value:function render(){var gridStyle=this.props.styles;var cellWidth=this.props.width/this.props.cols;var cellHeight=this.props.height/this.props.rows;var grid=[];for(var i=0;i<this.props.rows;i++){var rows=[];for(var j=0;j<this.props.cols;j++){var cols=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"columns"+i+j,className:"grid-cols"+(this.props.cols/2===j?" middle-col":""),style:{width:cellWidth+"px",height:cellHeight+"px"}});rows.push(cols);}grid.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"rows"+i,className:"grid-rows"+(this.props.rows/2===i?" middle-row":"")},rows,' '));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'workspace-grid',style:gridStyle},grid);}}]);return WorkspaceGrid;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var WorkspaceComponent=function(_React$Component8){_inherits(WorkspaceComponent,_React$Component8);function WorkspaceComponent(props){_classCallCheck(this,WorkspaceComponent);var _this22=_possibleConstructorReturn(this,(WorkspaceComponent.__proto__||Object.getPrototypeOf(WorkspaceComponent)).call(this,props));_this22.isValidFileToUpload=function(file){try{var MIM=__webpack_require__(430),upMimeType=file.type,uploadType='';if(!file.type){var fileArr=file.name.split('.'),fileExt=void 0;if(fileArr.length){fileExt=fileArr.pop();}if(fileExt)upMimeType=MIM.getMIMEType(fileExt);}var _validFileExtensions=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a['UPLOADS']['UP_VID'].split(',');for(var i=0;i<_validFileExtensions.length;i++){var sCurExtension=_validFileExtensions[i].trim();if(upMimeType.toLowerCase().includes(sCurExtension.toLowerCase())){uploadType='video';}}_validFileExtensions=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a['UPLOADS']['UP_IMG'].split(',');for(var j=0;j<_validFileExtensions.length;j++){var _sCurExtension=_validFileExtensions[j].trim();if(upMimeType.toLowerCase().includes(_sCurExtension.toLowerCase())){uploadType='image';}}return uploadType;}catch(err){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])('Error in isValidFileToUpload ',err,"WorkspaceComponent-isValidFileToUpload");}};_this22.dropCalc=function(width,height,ext,src){try{var originalWidth=parseInt(width,10)*_this22.props.zoomFactor,dropWidth=0,dropHeight=0,originalHeight=parseInt(height,10)*_this22.props.zoomFactor,setSpace=50,finalObj={};var leastVal=Math.min(_this22.props.workspaceWidth*_this22.props.zoomFactor,_this22.props.workspaceHeight*_this22.props.zoomFactor)-setSpace;var aspectRatio=originalWidth/originalHeight;if(originalWidth>originalHeight){dropWidth=leastVal;dropHeight=Math.round(dropWidth/aspectRatio);}else{dropHeight=leastVal;dropWidth=Math.round(dropHeight*aspectRatio);}var set_x,set_y,docWrkspc=document.getElementById('workspace'),index=_this22.props.maxIndex.size;set_x=docWrkspc.offsetWidth/2-dropWidth/2;set_y=docWrkspc.offsetHeight/2-dropHeight/2;finalObj={assetId:Math.random().toString(12).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString(),src:src,type:"UPLOADS",subType:"UPIMAGE",x:set_x/_this22.props.zoomFactor,y:set_y/_this22.props.zoomFactor,width:dropWidth/_this22.props.zoomFactor,height:dropHeight/_this22.props.zoomFactor,displaysizes:"",sourceType:ext,index:index,item_id:Math.random().toString(12).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString(),angle:0,thumb:"",svgData:undefined,selectedScene:_this22.props.selectedScene,textData:null,swapDetails:null,emptySwap:true,widthRatio:null,heightRatio:null,xRatio:null,yRatio:null,isBlob:true};return finalObj;}catch(err){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])('Error in dropCalc ',err,"WorkspaceComponent-dropCalc");}};_this22.handledroppedFile=function(file){try{if(['Branding','Brand Video','Brand Logo'].indexOf(_this22.props.libCurrentFolder)!==-1){_this22.props.manageToast({action:"add",type:"error","message":"n.a.ibr",subMessage:"pl.t.s",formatId:"both"});return;}if(file.type.includes('svg')){_this22.props.manageToast({action:"add",type:"error","message":'svg.n.a',formatId:"msg"});return;}if(!_this22.isValidFileToUpload(file)){_this22.props.manageToast({action:"add",type:"error","message":'tp.nt.su',formatId:"msg"});return;}else if(_this22.props.updateItems||_this22.props.isUploadInProcess){_this22.props.manageToast({action:"add",type:"error","message":'al.up.pr',formatId:"msg"});return;}var URL=window.URL||window.webkitURL,blobSrc=URL.createObjectURL(file);if(file.type.match('image')){var name=file.name,lastDot=name.lastIndexOf('.'),ext=name.substring(lastDot+1);var img=new Image();img.onload=function(){var width=img.width,height=img.height;if(ext){var dropObj=this.dropCalc(width,height,ext,blobSrc);this.props.addObj(dropObj,this.props.socket);this.props.itemToUpdate({item_id:dropObj.assetId,selectedScene:dropObj.selectedScene,assetId:dropObj.assetId});}}.bind(_this22);img.src=blobSrc;}else if(file.type.match('video')){var videoElm=document.createElement('video');videoElm.src=blobSrc;videoElm.muted=true;videoElm.playsInline=true;videoElm.play();videoElm.addEventListener('loadedmetadata',function(){var width=videoElm.videoWidth,height=videoElm.videoHeight,duration=videoElm.duration;var name=file.name,lastDot=name.lastIndexOf('.'),ext=name.substring(lastDot+1);if(ext&&duration){var assetId=Math.random().toString(12).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString();this.props.dropVideoBg({assetId:assetId,sourceType:ext,selectedScene:this.props.selectedScene,selectedItems:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])([]),bgType:"UPVIDEO",bgHeight:height,bgWidth:width,thumb:'',source:blobSrc,color:undefined,hasGradient:undefined,isCustomBg:false,duration:duration,subType:"UPVIDEO",videoDuration:duration,bgFilter:"",flipPosition:0,displaysizes:"",isSample:true,isBlob:true},[],this.props.socket);this.props.itemToUpdate({selectedScene:this.props.selectedScene,assetId:assetId});}}.bind(_this22));}_this22.props.fileToUpload(file);}catch(err){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])('Error in handledroppedFile ',err,"WorkspaceComponent-handledroppedFile");}};_this22.calculateStyles=function(){var workspaceScale=_this22.props.zoomFactor;var workspaceWidth=_this22.props.workspaceWidth*workspaceScale,workspaceHeight=_this22.props.workspaceHeight*workspaceScale;var workspaceCX=_this22.props.workspaceBounds.get("cx"),workspaceCY=_this22.props.workspaceBounds.get("cy");var workspaceWidth=_this22.props.workspaceWidth*workspaceScale,workspaceHeight=_this22.props.workspaceHeight*workspaceScale;if(workspaceCX===undefined){workspaceCX=window.innerWidth/2;workspaceCY=window.innerheight/2;}var style={left:_this22.workspaceX.toFixed(2)+"px",top:_this22.workspaceY.toFixed(2)+"px",width:workspaceWidth.toFixed(2)+"px",height:workspaceHeight.toFixed(2)+"px",backgroundRepeat:'no-repeat',backgroundPosition:'center center',border:'none',borderStyle:'none'};if(_this22.props.swapDetails!==null){style.zIndex="unset";if(_this22.props.swapDetails.isBG){style.zIndex=10;}}if(Math.round(workspaceHeight)>_this22.props.workspaceBounds.get("height")){style.top=(_this22.props.workspaceBounds.get("cy")-_this22.props.workspaceBounds.get("height")/2).toFixed(2)+"px";style.height=_this22.props.workspaceBounds.get("height").toFixed(2)+"px";style.overflowY="scroll";}if(Math.round(workspaceWidth)>_this22.props.workspaceBounds.get("width")){style.left=(_this22.props.workspaceBounds.get("cx")-_this22.props.workspaceBounds.get("width")/2).toFixed(2)+"px";style.width=_this22.props.workspaceBounds.get("width").toFixed(2)+"px";style.overflowX="scroll";}_this22.overflowStyles={left:style.left,top:style.top,width:style.width,height:style.height,right:parseFloat(style.left)+parseFloat(style.width)+'px',bottom:parseFloat(style.top)+parseFloat(style.height)+'px'};style.backgroundColor="#ededef";return style;};_this22.openLink=function(e,link){e.preventDefault();if(!link.match("^Slide")){var linkVal=link;var newWindow=linkVal.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)!==null?window.open('/','_self'):window.open('/');if(linkVal.indexOf("https://")!==0&&linkVal.indexOf("http://")!==0){if(linkVal.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)!==null)linkVal='mailto:'+linkVal;else linkVal='http://'+linkVal;}newWindow.location=linkVal;}};_this22.changeVideoIndex=function(index){if(index!==undefined){setTimeout(function(){_this22.setState({currentSceneNumber:index,isFullScrVideoplay:false});},0);}};_this22.onDuplicateScene=function(e,index){if(e)e.stopPropagation();_this22.props.onDuplicateScene(index,_this22.props.socket);};_this22.onAnimateClick=function(){try{_this22.props.setPropertyWindow({component:'animate',type:'ANIM'});}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-onAnimateClick");}};_this22.handlePauseAndPlay=function(e){try{// e.stopPropagation();
e.preventDefault();_this22.props.setAutoPlay();}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-handlePauseAndPlay");}};_this22.handleControlsClick=function(e){try{e.preventDefault();e.stopPropagation();if(_this22.props.mode==='slide'&&!_this22.props.isPreview)_this22.props.setPreview(true);if(e.target.id==='nextSlide'||e.target.id==='next-slide'){_this22.props.setPlayerPosition();if(_this22.props.isFullScreen&&_this22.props.isPlayAll){if(_this22.props.t1.currentLabel()>=_this22.props.t1.getLabelsArray().length-1){document.getElementById('nextSlide').src=_this22.appUrl+"/images/playerControls-icons/next-disable.svg";document.getElementById('nextSlide').style.cursor='auto';document.getElementById('next-slide').style.cursor='auto';}if(_this22.props.t1.currentLabel()!==null){document.getElementById('prevSlide').src=_this22.appUrl+"/images/playerControls-icons/previous.svg";document.getElementById('prevSlide').style.cursor='pointer';document.getElementById('previous-slide').style.cursor='pointer';}}if(_this22.props.isPreview&&!_this22.props.isPlayAll){var currentScene=_this22.props.currentSceneNumber;if(_this22.props.scenes.count()>1){if(currentScene<_this22.props.project.get('scenes').count()-1){_this22.props.setScenePosition(_this22.props.project.getIn(['scenes',currentScene+1]),currentScene+1,_this22.props.project.getIn(['scenes',currentScene+1,'startTime']),_this22.props.project.getIn(['scenes',currentScene+1,'duration']));document.getElementById('prevSlide').src=_this22.appUrl+"/images/playerControls-icons/previous.svg";document.getElementById('prevSlide').style.cursor='pointer';document.getElementById('previous-slide').style.cursor='pointer';}if(currentScene+1>=_this22.props.project.get('scenes').count()-1){document.getElementById('nextSlide').src=_this22.appUrl+"/images/playerControls-icons/next-disable.svg";document.getElementById('nextSlide').style.cursor='auto';document.getElementById('next-slide').style.cursor='auto';}}}}if(e.target.id==='prevSlide'||e.target.id==='previous-slide'){_this22.props.setPlayerPosition('Prev');if(_this22.props.isFullScreen&&_this22.props.isPlayAll){if(_this22.props.t1.currentLabel()===null){document.getElementById('prevSlide').src=_this22.appUrl+"/images/playerControls-icons/previous-disable.svg";document.getElementById('prevSlide').style.cursor='auto';document.getElementById('previous-slide').style.cursor='auto';}if(_this22.props.t1.currentLabel()<_this22.props.t1.getLabelsArray().length){document.getElementById('nextSlide').src=_this22.appUrl+"/images/playerControls-icons/next.svg";document.getElementById('nextSlide').style.cursor='pointer';document.getElementById('next-slide').style.cursor='pointer';}}if(_this22.props.isPreview&&!_this22.props.isPlayAll){if(_this22.props.scenes.count()>1){if(_this22.props.currentSceneNumber>0){_this22.props.setScenePosition(_this22.props.project.getIn(['scenes',_this22.props.currentSceneNumber-1]),_this22.props.currentSceneNumber-1,_this22.props.project.getIn(['scenes',_this22.props.currentSceneNumber-1,'startTime']),_this22.props.project.getIn(['scenes',_this22.props.currentSceneNumber-1,'duration']));}if(_this22.props.currentSceneNumber<_this22.props.project.getIn(['scenes',_this22.props.currentSceneNumber]).count()){document.getElementById('nextSlide').src=_this22.appUrl+"/images/playerControls-icons/next.svg";document.getElementById('nextSlide').style.cursor='pointer';document.getElementById('next-slide').style.cursor='pointer';}if(_this22.props.currentSceneNumber===0||_this22.props.currentSceneNumber===1||_this22.props.currentSceneNumber===null){document.getElementById('prevSlide').src=_this22.appUrl+"/images/playerControls-icons/previous-disable.svg";document.getElementById('prevSlide').style.cursor='auto';document.getElementById('previous-slide').style.cursor='auto';}}}}}catch(error){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-handleControlsClick");}};_this22.onSceneMove=function(){var ind=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;if(ind<=_this22.props.scenes.size-1)_this22.props.setSelectedScene(ind,_this22.props.scenes.getIn([ind,'startTime']),[ind],_this22.props.socket);};_this22.onShoenableFullScreenSlidePanel=function(e){_this22.props.showSlides({show:true});_this22.props.setWorkspaceStage(_this22.props.libSection);};_this22.calculateZoomPosition=function(){var zoomPosition={right:'308px',bottom:'10px',slideRight:'9px'};var propertyWindow=_this22.props.propertyWindow.get('component');var slidePanel=_this22.props.showSlidePanel;if(slidePanel&&propertyWindow===""){zoomPosition.right='308px';return zoomPosition;}else if(!slidePanel){if(propertyWindow!==""){zoomPosition.right='420px';zoomPosition.slideRight='306px';}else{zoomPosition.right='120px';}return zoomPosition;}return zoomPosition;};_this22.state={workspace:{},worksheet:[{id:0,data:"First Thing"},{id:1,data:"Second Thing"},{id:2,data:"Third Thing"},{id:3,data:"Fourth Thing"},{id:4,data:"Fifth Thing"}],sceenPosition:1,addTransition:false,contextMenu:false,direction:'',items:[1],active:props.selectedScene,onWheelEnd:true,onclickAction:false,applyTransitions:false,animakerType:'',indicatorX:0,timelineTime:0,isZoomActive:false,isZoomDropped:false,isBgToolExpanded:false,blobPlaying:false,seekValue:0,seekTime:null,seekX:null,videoControl:false,isFullScrVideoplay:false,//playButton :true
autoPlay:false,bgToolActive:false};_this22.runTheLIst=_this22.runTheLIst.bind(_this22);_this22.addTransition=_this22.addTransition.bind(_this22);_this22.moveSelection=_this22.moveSelection.bind(_this22);_this22.initiateResize=_this22.initiateResize.bind(_this22);_this22.resizeSelection=_this22.resizeSelection.bind(_this22);_this22.stopResize=_this22.stopResize.bind(_this22);_this22.initiateRotate=_this22.initiateRotate.bind(_this22);_this22.rotateSelection=_this22.rotateSelection.bind(_this22);_this22.stopRotate=_this22.stopRotate.bind(_this22);_this22.handleMouseDown=_this22.handleMouseDown.bind(_this22);_this22.handleItemClick=_this22.handleItemClick.bind(_this22);_this22.handleRightClick=_this22.handleRightClick.bind(_this22);_this22.toggleToolBar=_this22.toggleToolBar.bind(_this22);_this22.mouseStartPosition={x:null,y:null,width:null,height:null,offsetX:null,offsetY:null};_this22.handleWindowResize=_this22.handleWindowResize.bind(_this22);_this22.handlePaste=_this22.handlePaste.bind(_this22);_this22.multimoveSelection=null;_this22.anchorAngles=null;_this22.initiateMultiselect=_this22.initiateMultiselect.bind(_this22);_this22.multiselectByBounds=_this22.multiselectByBounds.bind(_this22);_this22.selectingItems=_this22.selectingItems.bind(_this22);_this22.stopSelection=_this22.stopSelection.bind(_this22);_this22.handleBgDelete=_this22.handleBgDelete.bind(_this22);_this22.workspaceItemsAssembler=_this22.workspaceItemsAssembler.bind(_this22);_this22.zoomState="normal";_this22.imageEditIcon=[];_this22.defaultWidth=800;_this22.defaultHeight=450;_this22.tintOpacity=0.1;_this22.isManuallyZoomed=false;_this22.cancelSwap=_this22.cancelSwap.bind(_this22);_this22.applySwap=_this22.applySwap.bind(_this22);_this22.delta='';_this22.listenerStatus=true;_this22.scrollDirection='';_this22.stopProcess=false;_this22.mouseUpTime=0;_this22.mouseDownTime=20;_this22.scrollOnce=0;_this22.scrollEnd=0;_this22.currentTime=0;_this22.fail=true;_this22.showResults=false;_this22.scrollType='';_this22.workedClick=false;_this22.generateItems=_this22.generateItems.bind(_this22);_this22.moveRight=_this22.moveRight.bind(_this22);_this22.moveLeft=_this22.moveLeft.bind(_this22);_this22.setStates=_this22.setStates.bind(_this22);_this22.commonTimeout=_this22.commonTimeout.bind(_this22);_this22.reachEnd=false;_this22.checkOnMouseOveraction=false;_this22.onLoadWorkspace=true;_this22.settedListener=false;_this22.loadedContentScrens=false;_this22.flipBG=_this22.flipBG.bind(_this22);_this22.fromEnableScreen=false;//For Lite..
_this22.addOneMoreScene=_this22.addOneMoreScene.bind(_this22);_this22.setNewScreen=false;_this22.indexedPosition=0;_this22.enteredUpdate=0;_this22.startedScrolling=false;//ShortCut scene Scroll handling...
_this22.rightKeyShortCut=false;_this22.leftKeyShortCut=false;_this22.setStageLeft=60;_this22.handleZoomClick=_this22.handleZoomClick.bind(_this22);_this22.handleZoomChange=_this22.handleZoomChange.bind(_this22);_this22.handleZoomDrop=_this22.handleZoomDrop.bind(_this22);_this22.tabChanged=_this22.tabChanged.bind(_this22);_this22.removeBG=_this22.removeBG.bind(_this22);_this22.controlVideo=_this22.controlVideo.bind(_this22);_this22.videoTimeUpdate=_this22.videoTimeUpdate.bind(_this22);_this22.changeVideoTime=_this22.changeVideoTime.bind(_this22);_this22.seekOver=_this22.seekOver.bind(_this22);_this22.workspaceOver=_this22.workspaceOver.bind(_this22);_this22.exitFullScreen=_this22.exitFullScreen.bind(_this22);_this22.enableFullScreen=_this22.enableFullScreen.bind(_this22);_this22.handleFullScreenMouseMove=_this22.handleFullScreenMouseMove.bind(_this22);_this22.addFont=_this22.addFont.bind(_this22);_this22.handleFullScreenMouseOver=_this22.handleFullScreenMouseOver.bind(_this22);_this22.handleFullScreenMouseOut=_this22.handleFullScreenMouseOut.bind(_this22);_this22.handleSlideClick=_this22.handleSlideClick.bind(_this22);_this22.switchFullScreen=_this22.switchFullScreen.bind(_this22);_this22.interval;_this22.videoFullscreenTimer;_this22.appUrl=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a['APPICONS'][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a['APPICONS']['current']];_this22.assetUrl=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a['ASSETS'][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a['ASSETS']['current']];_this22.t1=new __WEBPACK_IMPORTED_MODULE_9_gsap__["f" /* TimelineMax */]({paused:true});_this22.indicatorPosition=0;_this22.overflowStyles={};_this22.controlTimer=null;_this22.controlTimeout=2500;return _this22;}_createClass(WorkspaceComponent,[{key:'getCurrentZoom',value:function getCurrentZoom(dontCare,isFit){var padding=0;if(this.props.isFit||isFit)padding=30;var stageLeft=this.props.workspaceStage.getIn(["left","menu"])+this.props.workspaceStage.getIn(["left","library"])+this.props.workspaceStage.getIn(["left","toggle"])+this.props.workspaceStage.getIn(["left","padding"])+padding;var stageTop=this.props.workspaceStage.getIn(["top","menu"])+this.props.workspaceStage.getIn(["top","zoomControlMargin"])+this.props.workspaceStage.getIn(["top","zoomControl"])+this.props.workspaceStage.getIn(["top","padding"])+padding;var stageRight=window.innerWidth-(this.props.workspaceStage.getIn(["right","maxPropertyWindow"])+this.props.workspaceStage.getIn(["right","padding"])+padding+this.props.workspaceStage.getIn(["workspace","sceneToolBarMargin"])+this.props.workspaceStage.getIn(["workspace","sceneToolbar"]));var stageBottom=window.innerHeight-(this.props.workspaceStage.getIn(["bottom","playerControlMargin"])+this.props.workspaceStage.getIn(["bottom","playerControl"])+padding+this.props.workspaceStage.getIn(["bottom","padding"]));var stageWidth=stageRight-stageLeft;var stageHeight=stageBottom-stageTop;var cx=stageLeft+stageWidth/2;var cy=stageTop+stageHeight/2;var scale=void 0,width=stageWidth,height=stageHeight,actualWidth=width,actualheight=height;var workspaceWidth=this.props.workspaceWidth;if((!this.props.workspaceStage.get("isLocked")||dontCare!==undefined)&&!this.fromEnableScreen){var widthScale=stageWidth/workspaceWidth;var heightScale=stageHeight/this.props.workspaceHeight;this.fromEnableScreen=false;scale=Math.min(widthScale,heightScale);width=stageWidth;height=stageHeight;if(this.props.isFullScreen){var currentInnerWIdth=window.innerWidth/this.props.workspaceWidth;var currentHeight=window.innerHeight/this.props.workspaceHeight;scale=Math.min(currentInnerWIdth,currentHeight);cx=window.innerWidth/2;cy=window.innerHeight/2;width=window.innerWidth;height=window.innerHeight;this.fromEnableScreen=false;}}else{this.fromEnableScreen=false;scale=this.props.zoomFactor;}return{scale:scale,cx:cx,cy:cy,width:width,height:height};}},{key:'handleWindowResize',value:function handleWindowResize(e){var propsReceived=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;try{if(!this.props.isFit){this.props.setZoomFit(true);}var currentZoom=this.getCurrentZoom(null,propsReceived);this.props.setZoom({zoomFactor:currentZoom.scale,workspaceBounds:{cx:currentZoom.cx,cy:currentZoom.cy,width:currentZoom.width,height:currentZoom.height}});}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-handleWindowResize");}}},{key:'handleRightClick',value:function handleRightClick(e){try{e.preventDefault();var isOnSelBox=this.isMouseOn(e,"selectionBox")||this.isMouseOn(e,"scene-item");if(isOnSelBox===true){this.setState({contextMenu:true,isContextBg:false});var clickX=e.clientX;var clickY=e.clientY;var screenW=window.innerWidth;var screenH=window.innerHeight;var cmWidth=this.contextMenu.offsetWidth;var cmHeight=this.contextMenu.offsetHeight;var right=screenW-clickX>cmWidth;var left=!right;var top=screenH-clickY>cmHeight;var bottom=!top;if(right){this.contextMenu.style.left=clickX+5+'px';}if(left){this.contextMenu.style.left=clickX-cmWidth-5+'px';}if(top){this.contextMenu.style.top=clickY+5+'px';}if(bottom){this.contextMenu.style.top=clickY-cmHeight-5+'px';}if(parseFloat(this.contextMenu.style.top)+cmHeight>window.innerHeight-this.props.timelineHeight-60)this.contextMenu.style.top=clickY-cmHeight-5+'px';if(parseFloat(this.contextMenu.style.left)+cmWidth>window.innerWidth-225)this.contextMenu.style.left=clickX-cmWidth-5+'px';}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-handleRightClick");}}},{key:'isFontLoaded',value:function isFontLoaded(fontFamily,element){var _aFallbackFonts=['serif','sans-serif','monospace','cursive','fantasy'];var wThisFont=0;var wPrevFont=0;for(var ix=0;ix<_aFallbackFonts.length;++ix){element.style.fontFamily='"'+fontFamily+'",'+_aFallbackFonts[ix];wThisFont=element.offsetWidth;if(ix>0&&wThisFont!==wPrevFont){return false;}wPrevFont=wThisFont;}return true;}},{key:'onFontLoad',value:function onFontLoad(toAdd,loadStatus){var fontFamily=toAdd.get("load");var span=null;var eLang='en';var aChars={'en':'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ','fa':'ابپتجچحخدذرزسشصضططعغفقکگلمنوهی'};var body=document.body;var firstChild=document.body.firstChild;var msInterval=100,msTimeout=2000;var div=document.createElement('div');div.id='fontdetectHelper';span=document.createElement('span');span.innerText=aChars[eLang];div.appendChild(span);body.insertBefore(div,firstChild);div.style.position='absolute';div.style.visibility='hidden';div.style.top='-200px';div.style.left='-100000px';div.style.width='100000px';div.style.height='200px';div.style.fontSize='100px';if(this.isFontLoaded(fontFamily,span)){div.remove();loadStatus({success:true});return true;}var outerThis=this;var utStart=new Date().getTime();var idInterval=setInterval(function(){if(outerThis.isFontLoaded(fontFamily,span)){// It's now loaded.
clearInterval(idInterval);div.remove();loadStatus({success:true});return true;}else{// Still not loaded.
var utNow=new Date().getTime();if(utNow-utStart>msTimeout){clearInterval(idInterval);div.remove();loadStatus({success:false});return false;}}},msInterval);}},{key:'addFont',value:function addFont(toAdd){var _this23=this;try{var font=toAdd.get("load");if(!document.getElementById(toAdd.get("load"))&&font!==undefined){var fontFileName=toAdd.get('font');//font.replace(new RegExp(" ", 'g'), "-"); font.replace(" ", "-");
var link=document.createElement("link");link.id=toAdd.get("load");link.rel="stylesheet";link.onload=function(){_this23.loadStyle(font,fontFileName,toAdd);};if(toAdd.get("isPartialFont")){link.href=toAdd.get("url");}else if(toAdd.get("byUser")!==true){link.href=this.assetUrl+"animaker/admin-fonts/"+fontFileName+".css";}else{link.href=toAdd.get("url").indexOf("https://")===0?toAdd.get("url"):''+this.userFontUrl+toAdd.get("url");}document.getElementsByTagName("head")[0].appendChild(link);}}catch(error){console.log(error);}}},{key:'loadStyle',value:function loadStyle(fontFamily,fontFileName,fontData){var _this24=this;var dummyNode=document.createElement("span").appendChild(document.createTextNode("abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"+fontFamily)).parentNode;dummyNode.style.position="fixed";dummyNode.style.opacity=0;// eslint-disable-next-line
var fontFamilyToSet='"'+fontFamily.replace(/\"/g,"")+'"';dummyNode.style.fontFamily=fontFamilyToSet;dummyNode.style.fontSize="14px";dummyNode.setAttribute('data-dummy','true');document.body.insertBefore(dummyNode,document.body.firstChild);var hasLoaded=document.fonts.check('12px '+fontFamilyToSet);if(hasLoaded){this.props.fontLoaded({load:fontFileName});}else{var maxTries=6;var tries=0;var interval=500;var timer=setInterval(function(){hasLoaded=document.fonts.check('12px '+fontFamilyToSet);if(hasLoaded||tries>=maxTries){clearInterval(timer);_this24.props.fontLoaded({load:fontFileName});}tries=tries+1;},interval);}// const throttleStart = Date.now();
// while (!hasLoaded && (Date.now() - throttleStart) < 3000) {
//   hasLoaded = this.isFontLoaded(fontFamily, dummyNode);
// }
/*  if(!fontData.get('byUser')){
        if(!this.loadBoldItalic.includes(fontFileName)){
            let fontFamData = fontFamilies.getIn(["default", "fonts"]).find(x => x.get("fontFamily") === fontFileName)
            let isBold = false, isItalic = false, isBoldItalic = false;
            if(fontFamData && fontFamData.get("isItalic") && fontFamData.get("isBold"))
                isBoldItalic = true;
            else if(fontFamData && fontFamData.get("isBold"))
                isBold = true
            else if(fontFamData && fontFamData.get("isItalic"))
                isItalic = true
            
            let tempText = `abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ, ابپتجچحخدذرزسشصضططعغفقکگلمنوهی`

            if(isBoldItalic){
                document.fonts.load(`12px ${fontFileName}-BoldItalic`,tempText)
                document.fonts.load(`12px ${fontFileName}-Bold`,tempText)
                document.fonts.load(`12px ${fontFileName}-Italic`,tempText)
            }else if(isBold){
                document.fonts.load(`12px ${fontFileName}-Bold`,tempText)
            }else if(isItalic){
                document.fonts.load(`12px ${fontFileName}-Italic`,tempText)
            }
            this.loadBoldItalic.push(fontFileName)   
        }
    } */// this.props.fontLoaded({ load: fontFileName });
}},{key:'componentWillMount',value:function componentWillMount(){this.enteredUpdate=0;/// For lite scene scroll issue
this.setState({workspace:{left:(window.innerWidth-this.props.appState.libraryWidth)/2+this.props.appState.libraryWidth-this.props.workspaceWidth*this.props.zoomFactor/2,top:(window.innerHeight-this.props.appState.menuHeight)/2+this.props.appState.menuHeight-this.props.workspaceHeight*this.props.zoomFactor/2,marginleft:window.innerHeight-this.props.appState.menuHeight+this.props.appState.menuHeight-this.props.workspaceHeight*this.props.zoomFactor/2}});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextState){if(nextProps.draggedFileItem&&this.props.draggedFileItem!==nextProps.draggedFileItem){this.handledroppedFile(nextProps.draggedFileItem);this.props.draggedFile('');}if(nextProps.scenes.size!==this.props.scenes.size){var itemArray=[];if(nextProps.scenes.size>1){for(var i=1;i<=nextProps.scenes.size;i++){itemArray.push(i);}}else{itemArray=this.state.items;}this.setState({items:itemArray});}if((nextProps.isPlay===true||nextProps.isPlayAll===true)&&nextProps.isLoaded){// setTimeout(function(){ 
if(document.getElementsByClassName("player-loader-img")[0]!==undefined&&document.getElementsByClassName("player-loader-img")[0]!==null)document.getElementsByClassName("player-loader-img")[0].style.display="none";// }, 3000);
}if((nextProps.selectedScene!==this.state.active||nextProps.isPlay===true||nextProps.isPlayAll===true)&&!this.rightKeyShortCut&&!this.leftKeyShortCut){// var mainCOmponent = document.getElementsByClassName('item');
// var asda = document.getElementById('workspace');
this.scrollType='';this.isSceneClick=true;this.setState({active:nextProps.selectedScene});}else if(nextProps.isPlay!==this.props.isPlay&&nextProps.isPlay===false||nextProps.isPlayAll!==this.props.isPlayAll&&nextProps.isPlayAll===false||nextProps.isPreview!==this.props.isPreview&&nextProps.isPreview===false){this.scrollType='scroll';this.checkOnMouseOveraction=true;}if(nextProps.isPlay!==this.props.isPlay||nextProps.isPlayAll!==this.props.isPlayAll){if(nextProps.isPlay||nextProps.isPlayAll)document.body.style.backgroundColor="#808080";else document.body.style.backgroundColor="#ededef";}}},{key:'getCursorPosition',value:function getCursorPosition(type,timeVal,setStore){var duration=0;if(this.props.isPlay)duration=this.props.sceneData.get('duration');else if(this.props.isPlayAll)duration=this.props.overallDuration;var currentTimeScale=this.props.workspaceWidth*this.props.zoomFactor/duration;var ValueX=(timeVal-0)*currentTimeScale;var domPlayhead=document.getElementsByClassName('playHeadCls')[0];domPlayhead.style.transform="translate3d("+parseFloat(ValueX.toFixed(1))+"px, 0px, 0px)";}},{key:'mouseOverFunctions',value:function mouseOverFunctions(e){try{var result=this.isMouseOn(e,'workspace-main-page');if(result){if(this.props.isPlay||this.props.isPlayAll||this.props.isPreview)this.checkOnMouseOveraction=!result;else{if(this.scrollType===''){this.scrollType='scroll';}this.checkOnMouseOveraction=result;}}else{this.checkOnMouseOveraction=result;if(this.scrollType===''&&!this.props.isPlay){this.onLoadWorkspace=true;}}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-mouseOverFunctions");}}},{key:'applymouseOverAction',value:function applymouseOverAction(){var _this25=this;window.addEventListener('mouseover',function(event){return _this25.mouseOverFunctions(event);},false);}},{key:'getCorner',value:function getCorner(x,y,a){var x2=Math.cos(a/180*Math.PI)*x-Math.sin(a/180*Math.PI)*y;var y2=Math.sin(a/180*Math.PI)*x+Math.cos(a/180*Math.PI)*y;return[x2,y2];}},{key:'switchFullScreen',value:function switchFullScreen(e){var isFullScreenSwitch=e.keyCode||e.which;if(isFullScreenSwitch==70){window.enableFullScreen();}}},{key:'componentDidMount',value:function componentDidMount(){var _this26=this;this.handleWindowResize(this,true);window.addEventListener('mousedown',this.handleMouseDown,false);window.addEventListener("resize",this.handleWindowResize,false);window.addEventListener("contextmenu",this.handleRightClick,false);window.addEventListener("blur",this.tabChanged,false);window.addEventListener('webkitfullscreenchange',this.exitFullScreen,false);window.addEventListener('fullscreenchange',this.exitFullScreen,false);window.addEventListener('mozfullscreenchange',this.exitFullScreen,false);window.addEventListener('msscreenchange',this.exitFullScreen,false);// window.addEventListener('mousemove',this.handleFullScreenMouseMove,false);
window.onSceneMove=this.onSceneMove;window.enableFullScreen=this.enableFullScreen;window.addEventListener("keydown",this.switchFullScreen,false);//if not reponsive for other resolutions...remove
//  let currentWindowWidth,currentWindowHeight,currentZoomFactor;
//  currentWindowWidth = (window.screen.width / this.props.workspaceWidth);
//  currentWindowHeight = (window.screen.height / this.props.workspaceHeight);
//  currentZoomFactor = Math.min(currentWindowWidth, currentWindowHeight);
//  this.props.setZoom({ zoomFactor : currentZoomFactor});
if(this.props.loadedFonts.get("fonts").size>0){this.props.loadedFonts.get("fonts").entrySeq().forEach(function(_ref11){var _ref12=_slicedToArray(_ref11,2),key=_ref12[0],fontDetail=_ref12[1];_this26.addFont(fontDetail);});}//For Scroll scenes...
// window.addEventListener("mousewheel", (event)=>this.changeLeafsOnScroll(event), false);
// if (document.readyState === "complete") 
//document.addEventListener("DOMContentLoaded", this.testing.bind(this), false);
HTMLElement.prototype.pseudoStyle=function(selectedDiv,uniqueId,element,prop,value){var _this=selectedDiv;var _sheetId="pseudoStyles";var _head=document.head||document.getElementsByTagName('head')[0];var className=uniqueId+"_bg",sheetIndex=-1,classPresent=false;_this.className=_this.className.replace(" "+className,"");_this.className+=" "+className;for(var s in document.styleSheets){if(document.styleSheets[s].title&&document.styleSheets[s].title.indexOf("pseudoStyles")===0){sheetIndex=s;break;}}var pseudoSheet=document.styleSheets[sheetIndex];if(sheetIndex>-1){for(var i=0;pseudoSheet.cssRules&&i<pseudoSheet.cssRules.length;i++){if(pseudoSheet.cssRules[i].selectorText.indexOf(className)>=0){pseudoSheet.cssRules[i].style.background=value;classPresent=true;}}}if(!classPresent){var _sheet=document.getElementById(_sheetId)||document.createElement('style');_sheet.id=_sheetId;_sheet.title=_sheetId;_sheet.innerHTML+="\n."+className+":"+element+"{"+prop+":"+value+"}";_head.appendChild(_sheet);return this;}}.bind(this);}},{key:'tabChanged',value:function tabChanged(e){try{this.ctrlPressed=false;if(!this.props.textStatus.get("isFocused"))this.enableClick(".selectionBox");}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-tabChanged");}}},{key:'getColorsFromHtml',value:function getColorsFromHtml(textItem,existColors){var rgbRegex=/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/;var extractedColors=[];var x,elemStyles,styleValue,rgbVal;var toGetColors=document.createElement("div");toGetColors.setAttribute("id","toGetColors");toGetColors.style.position="absolute";toGetColors.style.hidden="true";toGetColors.innerHTML=textItem.getIn(["textData","htmlText"]);document.getElementsByClassName('workspace')[0].appendChild(toGetColors);elemStyles=window.getComputedStyle(toGetColors);var elems=toGetColors.getElementsByTagName('*');var total=elems.length;var hasColors=false;for(x=0;x<total;x++){elemStyles=window.getComputedStyle(elems[x]);styleValue=elemStyles.color||elemStyles["color"];if(styleValue){rgbVal=styleValue.match(rgbRegex);if(rgbVal&&!hasColors&&rgbVal.input!=="rgb(0, 0, 0)"){hasColors=true;}else{rgbVal.input=textItem.getIn(["textData","formats","containerStyle","color"]);}if(rgbVal&&existColors.indexOf(rgbVal.input)===-1&&extractedColors.indexOf(rgbVal.input)===-1){extractedColors.push(rgbVal.input);}}}toGetColors.remove();return extractedColors;}},{key:'getAllColors',value:function getAllColors(props,id,container,isGrouped){var _this27=this;var textItems=void 0;var allColors=[];if(isGrouped!==undefined&&isGrouped){var childIds=props.sceneData.getIn(["workspaceItems",id,"groupChildren"]);textItems=props.sceneData.get("workspaceChildren").filter(function(obj,key){return childIds.keyOf(key)!==undefined;});textItems.entrySeq().forEach(function(_ref13){var _ref14=_slicedToArray(_ref13,2),key=_ref14[0],textItem=_ref14[1];var colors=_this27.getColorsFromHtml(textItem,allColors);if(colors.length>0)allColors=allColors.concat(colors);});}else{var textItem=props.sceneData.getIn([container,id]);var colors=this.getColorsFromHtml(textItem,allColors);if(colors.length>0)allColors=allColors.concat(colors);}return allColors;}},{key:'getTextFormats',value:function getTextFormats(item){var obj={textAlign:"left",color:"#fff",lineHeight:1,fontWeight:null,fontStyle:null,textDecoration:null,textTransform:null,wordSpacing:0,letterSpacing:0,opacity:1,isGrouped:false};var formats=item.getIn(["textData","formats"]);Object.assign(obj,formats.get("containerStyle").toObject());var bullet=formats.get("bullet");obj.fontSize=parseFloat(obj.fontSize,10);obj.letterSpacing=parseFloat(obj.letterSpacing,10);if(bullet){obj.isBullet=bullet.get("isBullet");obj.bullet=bullet.get("type");}if(item.getIn(["textData","formats","others","isRTL"]))Object.assign(obj,{isRTL:true});return obj;}},{key:'rotatedPosition',value:function rotatedPosition(x,y,width,height,rotationAngle,position){if(position===undefined)position="topLeft";// get the center of the rectangle (==rotation point)
var cx=x+width/2;var cy=y+height/2;// calc the angle of the unrotated TL corner vs the center point
var dx=x+width-cx;var dy=y-cy;var originalTopLeftAngle=Math.atan2(dy,dx);// Add the unrotatedTL + rotationAngle to get total rotation
var rotatedTopLeftAngle=originalTopLeftAngle+rotationAngle;// calc the radius of the rectangle (==diagonalLength/2)
var radius=Math.sqrt(width*width+height*height)/2;// calc the rotated top & left corner
var rx=cx+radius*Math.cos(rotatedTopLeftAngle);var ry=cy+radius*Math.sin(rotatedTopLeftAngle);// return the results
return{x:rx,y:ry};}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState){if(nextProps.isFullScreen!==this.props.isFullScreen){if(nextProps.isFullScreen){this.onFullModeResponsive();}else this.closeFullScreen(nextProps);}}},{key:'exitFullScreen',value:function exitFullScreen(e){try{if(this.props.isFullScreen&&(document.webkitFullscreenElement===null||document.mozFullScreenElement===null||document.msFullscreenElement===null||document.fullscreenElement===null)){var currentZoomFactor=this.props.prevZoomFactor;this.props.setFullScreen({status:!this.props.isFullScreen,zoomFactor:currentZoomFactor,prevZoomFactor:this.props.zoomFactor});}}catch(error){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-exitFullScreen");}}},{key:'closeFullScreen',value:function closeFullScreen(){var nextProps=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;if(document.webkitExitFullscreen){/* Chrome, Safari and Opera */document.webkitExitFullscreen();}else if(document.msExitFullscreen){/* IE/Edge */document.msExitFullscreen();}else if(document.fullscreenElement){/* Firefox */document.exitFullscreen();}// let mainDiv = document.getElementsByClassName('workspace-wrapper')[0];
// if(mainDiv !== null & mainDiv !== undefined && mainDiv){
//   var workspaceWidth = nextProps.workspaceWidth * nextProps.zoomFactor, workspaceHeight = nextProps.workspaceHeight * nextProps.zoomFactor;
//   mainDiv.style.width = "100%";
//   mainDiv.style.height = workspaceHeight +'px';
//   mainDiv.style.backgroundColor = 'none';
//   mainDiv.style.position = 'unset';
//   mainDiv.style.borderRadius = '0px';
// }
}},{key:'onFullModeResponsive',value:function onFullModeResponsive(){var elem=document.documentElement;if(elem.requestFullscreen&&!this.props.isFullScreen){elem.requestFullscreen();}else if(elem.mozRequestFullScreen&&!this.props.isFullScreen){/* Firefox */elem.mozRequestFullScreen();}else if(elem.webkitRequestFullscreen&&!this.props.isFullScreen){/* Chrome, Safari and Opera */elem.webkitRequestFullscreen();}else if(elem.msRequestFullscreen&&!this.props.isFullScreen){/* IE/Edge */elem.msRequestFullscreen();}}},{key:'handleFullScreenMouseMove',value:function handleFullScreenMouseMove(){try{if(this.props.isFullScreen===true||this.props.mode==='slide'){var currentScene=this.state.currentSceneNumber;clearInterval(this.interval);this.interval=setInterval(function(){if(document.body.contains(document.getElementById('player-controls'))){document.getElementById('player-controls').style.opacity=0;}if(document.body.contains(document.getElementById('video-controls-'+currentScene))){document.getElementById('video-controls-'+currentScene).style.opacity=0;}},800);document.getElementById('player-controls').style.opacity=1;if(document.body.contains(document.getElementById('video-controls-'+currentScene))){document.getElementById('video-controls-'+currentScene).style.opacity=1;}}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-handleFullScreenMouseMove");}}},{key:'handleFullScreenMouseOver',value:function handleFullScreenMouseOver(e){if(this.props.isFullScreen===true||this.props.mode==='slide'){var currentSceneNumber=this.state.currentSceneNumber;var videoControl='video-controls-'+currentSceneNumber;if(e.target.id==='next-slide'||e.target.id==='previous-slide'||e.target.id==='full-screen'||e.target.id==='prevSlide'||e.target.id==='nextSlide'||e.target.id===videoControl){window.removeEventListener('mousemove',this.handleFullScreenMouseMove,false);}}}},{key:'handleFullScreenMouseOut',value:function handleFullScreenMouseOut(e){if(this.props.isFullScreen===true||this.props.mode==='slide'){var currentSceneNumber=this.state.currentSceneNumber;var videoControl='video-controls-'+currentSceneNumber;if(e.target.id==='next-slide'||e.target.id==='previous-slide'||e.target.id==='nextSlide'||e.target.id==='full-screen'||e.target.id===videoControl){window.addEventListener('mousemove',this.handleFullScreenMouseMove,false);}}}},{key:'enableFullScreen',value:function enableFullScreen(){try{var currentInnerWIdth=window.innerWidth/this.props.workspaceWidth;var currentHeight=window.innerHeight/this.props.workspaceHeight;var currentZoomFactor=Math.min(currentInnerWIdth,currentHeight);var cx=void 0,cy=void 0,width=void 0,height=void 0;currentInnerWIdth=window.screen.width/this.props.workspaceWidth;currentHeight=window.screen.height/this.props.workspaceHeight;currentZoomFactor=Math.min(currentInnerWIdth,currentHeight);cx=window.screen.width/2;cy=window.screen.height/2;width=window.screen.width;height=window.screen.height;var currentScene=this.props.selectedScene;this.props.setScenePosition(this.props.project.getIn(['scenes',currentScene]),currentScene,this.props.project.getIn(['scenes',currentScene,'startTime']),this.props.project.getIn(['scenes',currentScene,'duration']));this.props.setPreview(!this.props.isPreview);this.fromEnableScreen=false;//  this.props.setPlayAll(!this.props.isPlayAll && !this.props.fromStart, !this.props.isPlayAll && !this.props.fromStart);
this.props.setFullScreen({status:!this.props.isFullScreen,zoomFactor:currentZoomFactor,prevZoomFactor:this.props.zoomFactor});this.props.setZoom({workspaceBounds:{cx:cx,cy:cy,width:width,height:height}});}catch(error){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-enableFullScreen");}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevState.currentSceneNumber!==this.state.currentSceneNumber){this.setState({seekValue:0,isFullScrVideoplay:false,seekTime:null,seekX:null});}this.flipedItem=false;if(document.readyState==='complete'&&!this.settedListener){this.applymouseOverAction();this.settedListener=true;}if(prevState.isZoomDropped){this.setState({isZoomDropped:false});}if((!this.props.workspaceStage.equals(prevProps.workspaceStage)||this.props.workspaceWidth!==prevProps.workspaceWidth)&&this.props.isFit){this.handleWindowResize();}if(!this.props.isWorkspaceTextFocus&&this.props.shortcutName!==prevProps.shortcutName&&this.props.shortcutName!==""){this.handleShortcuts(this.props.shortcutName);}else if(!this.props.isWorkspaceTextFocus&&this.props.shortcutName!==prevProps.shortcutName&&this.props.shortcutName===""){if(this.ctrlPressed)this.ctrlPressed=false;if(!this.props.textStatus.get("isFocused"))this.enableClick(".selectionBox");}if(prevProps.selectedItems!==this.props.selectedItems){if(this.state.contextMenu){this.setState({contextMenu:false});}}if(prevProps.textStatus!==this.props.textStatus){if(prevProps.textStatus.get("isFocused")!==this.props.textStatus.get("isFocused")&&this.props.textStatus.get("isFocused")||prevProps.textStatus.get("isSelected")!==this.props.textStatus.get("isSelected")&&this.props.textStatus.get("isSelected")||prevProps.textStatus.get("id")!==this.props.textStatus.get("id")){if(!this.props.textStatus.get("isGrouped")&&this.props.textStatus.get("id")!==null){var textFormats=this.getTextFormats(this.props.sceneData.getIn([this.props.textStatus.get("container"),this.props.textStatus.get("id")]));var colors=this.getAllColors(this.props,this.props.textStatus.get("id"),this.props.textStatus.get("container"));if(colors.length>0)Object.assign(textFormats,{colors:colors});this.props.setTextOptions(textFormats);}else if(this.props.textStatus.get("isGrouped")&&this.props.textStatus.get("isFocused")){var _textFormats=this.getTextFormats(this.props.sceneData.getIn([this.props.textStatus.get("container"),this.props.textStatus.get("id")]));var _colors=this.getAllColors(this.props,this.props.textStatus.get("id"),this.props.textStatus.get("container"));if(_colors.length>0)Object.assign(_textFormats,{colors:_colors});this.props.setTextOptions(_textFormats);}}else if(prevProps.textStatus.get("fontSize")!==this.props.textStatus.get("fontSize")){this.props.setTextOptions({fontSize:this.props.textStatus.get("fontSize")});}}else if((this.props.textStatus.get("isFocused")||this.props.textStatus.get("isSelected"))&&this.props.textStatus.get("id")!==null){if(!this.props.textStatus.get("isGrouped")){var nextFormats=this.props.sceneData.getIn([this.props.textStatus.get("container"),this.props.textStatus.get("id"),"textData","formats"]);var prevFormats=prevProps.sceneData.getIn([this.props.textStatus.get("container"),this.props.textStatus.get("id"),"textData","formats"]);if(nextFormats&&prevFormats&&!nextFormats.equals(prevFormats)){var _textFormats2=this.getTextFormats(this.props.sceneData.getIn([this.props.textStatus.get("container"),this.props.textStatus.get("id")]));var _colors2=this.getAllColors(this.props,this.props.textStatus.get("id"),this.props.textStatus.get("container"));if(_colors2.length>0)Object.assign(_textFormats2,{colors:_colors2});this.props.setTextOptions(_textFormats2);}}else if(this.props.textStatus.get("isSelected")&&this.props.selectedItems.get(0)===this.props.textStatus.get("id")){var selectedData=this.props.sceneData.getIn(["workspaceItems",this.props.textStatus.get("id")]);var childIds=selectedData.get("groupChildren");var textChildren=this.props.sceneData.getIn(["workspaceChildren"]).filter(function(obj,key){return childIds.keyOf(key)!==undefined&&obj.get("type")==="TEXT";});var textKeys=textChildren.keySeq().toArray();var _nextFormats=this.props.sceneData.getIn(["workspaceChildren",textKeys[0],"textData","formats"]);var _prevFormats=prevProps.sceneData.getIn(["workspaceChildren",textKeys[0],"textData","formats"]);if(_nextFormats&&_prevFormats&&!_nextFormats.equals(_prevFormats)){var _colors3=this.getAllColors(this.props,this.props.textStatus.get("id"),this.props.textStatus.get("container"),true);this.props.setTextOptions({colors:_colors3});}}}if(this.props.selectedItems!==prevProps.selectedItems){var item=this.props.selectedItems.get(0);if(item&&this.props.selectedItems.size===1&&(!this.props.textStatus.get("isFocused")||this.props.textStatus.get("id")!==this.props.selectedItems.get(0))){var _selectedData=this.props.sceneData.getIn(["workspaceItems",item]);if(_selectedData&&(_selectedData.get("type")==="TEXT"||_selectedData.get("type")==="SHAPE")){if(_selectedData.get("type")==="SHAPE"){this.props.updateTextStatus({id:item,isFocused:false,isSelected:true,container:"workspaceItems",isRTL:_selectedData.getIn(["textData","formats","others","isRTL"]),isGrouped:false,fontSize:parseFloat(_selectedData.getIn(["textData","formats","containerStyle","fontSize"]),10),type:_selectedData.get("type")});}else if(_selectedData.get("type")==="TEXT"){this.props.updateTextStatus({id:item,isSelected:true,container:"workspaceItems",isRTL:_selectedData.getIn(["textData","formats","others","isRTL"]),isGrouped:false,fontSize:parseFloat(_selectedData.getIn(["textData","formats","containerStyle","fontSize"]),10),type:_selectedData.get("type")});}var _textFormats3=this.getTextFormats(_selectedData);var _colors4=this.getAllColors(this.props,item,"workspaceItems");if(_colors4.length>0)Object.assign(_textFormats3,{colors:_colors4});this.props.setTextOptions(_textFormats3);}else if(_selectedData.get("type")==="GROUP"||_selectedData.get("type")==="TXTOVLY"){var _childIds=_selectedData.get("groupChildren");var _textChildren=this.props.sceneData.get("workspaceChildren").filter(function(obj,key){return _childIds.keyOf(key)!==undefined&&(obj.get("type")==="TEXT"||obj.get("type")==="SHAPE");});var shapeChildren=this.props.sceneData.get("workspaceChildren").filter(function(obj,key){return _childIds.keyOf(key)!==undefined&&obj.get("type")==="SHAPE";});var fontFamily=null,fontSize=null,_colors5=[],isAllBold=true,isAllItalic=true,isAllUnderline=true;if(_textChildren.size>0){var prevFont=null;_textChildren.entrySeq().forEach(function(_ref15){var _ref16=_slicedToArray(_ref15,2),key=_ref16[0],obj=_ref16[1];var formats=obj.getIn(["textData","formats"]);if((formats.getIn(["containerStyle","fontFamily"])===prevFont||prevFont===null)&&fontFamily!=="Multiple Fonts")fontFamily=formats.getIn(["containerStyle","fontFamily"]);else fontFamily="Multiple Fonts";prevFont=formats.getIn(["containerStyle","fontFamily"]);if(_colors5.indexOf(formats.getIn(["containerStyle","color"]))===-1)_colors5.push(formats.getIn(["containerStyle","color"]));var size=parseFloat(formats.getIn(["containerStyle","fontSize"]),10);if(size>fontSize||fontSize===null)fontSize=size;if((formats.getIn(["containerStyle","fontWeight"])===undefined||formats.getIn(["containerStyle","fontWeight"])==="normal"||formats.getIn(["containerStyle","fontWeight"])===null)&&isAllBold){isAllBold=false;}if((formats.getIn(["containerStyle","fontStyle"])===undefined||formats.getIn(["containerStyle","fontStyle"])==="normal"||formats.getIn(["containerStyle","fontStyle"])===null)&&isAllItalic){isAllItalic=false;}if((formats.getIn(["containerStyle","textDecoration"])===undefined||formats.getIn(["containerStyle","textDecoration"])==="none"||formats.getIn(["containerStyle","textDecoration"])===null)&&isAllUnderline){isAllUnderline=false;}});if(shapeChildren.size>0){this.props.setIsShapeInGrp(true);}else{this.props.setIsShapeInGrp(false);this.props.updateTextStatus({id:item,isFocused:false,isSelected:true,container:"workspaceItems",isRTL:_selectedData.getIn(["textData","formats","others","isRTL"]),isGrouped:true,fontSize:fontSize,type:_selectedData.get("type")});_colors5=this.getAllColors(this.props,item,"workspaceItems",true);this.props.setTextOptions({fontFamily:fontFamily,fontSize:fontSize,colors:_colors5,lineHeight:1,fontWeight:isAllBold?"bold":null,fontStyle:isAllItalic?"italic":null,textDecoration:isAllUnderline?"underline":null,textTransform:null,wordSpacing:0,opacity:1,isGrouped:true});}}}else{if(this.props.textStatus.get("id")!==null){this.props.updateTextStatus({id:null,isFocused:false,isSelected:false,container:null,isRTL:false,isGrouped:false,fontSize:null});}}}}if(this.props.sceneData!==undefined&&this.props.sceneData.size>0){var filterData=this.props.sceneData.getIn(['workspaceBG','bgFilter']);// if(this.props.sceneData.getIn(['workspaceBG','enterStart']) <= this.props.sceneData.get('playHeadValue') && this.props.sceneData.getIn(['workspaceBG','exitEnd']) >= this.props.sceneData.get('playHeadValue') && !this.props.isPlay && !this.props.isPlayAll){
//   let selectedElem = document.getElementsByClassName('bg-container tintCls')[0], selectedId = "ws-bgImg-" + this.props.selectedScene;
//   if(this.props.sceneData.getIn(['workspaceBG','type']) === "VIDEO" || this.props.sceneData.getIn(['workspaceBG','type']) === "STOCKVID"){
//     selectedElem = document.getElementsByClassName('video-container tintCls')[0];
//     selectedId = "ws-bgVideo-";
//   }
// }
var wrkscData=this.props.sceneData.get("workspaceItems");if(!wrkscData.isEmpty()){wrkscData.entrySeq().forEach(function(_ref17){var _ref18=_slicedToArray(_ref17,2),key=_ref18[0],value=_ref18[1];filterData=value.get('filter');});}}if(this.props.scenes.size!==prevProps.scenes.size){///For transitions on the scene add and delete we dont know so setting state again to rerender component........
this.setState({applyTransitions:!this.state.applyTransitions});}if((this.props.workspaceHeight!==prevProps.workspaceHeight||this.props.workspaceWidth!==prevProps.workspaceWidth)&&this.props.isFit){this.handleWindowResize();}if(this.props.selectedItems!==prevProps.selectedItems||this.props.sceneData.getIn(["workspaceItems",this.props.selectedItems.get(0)])!==prevProps.sceneData.getIn(["workspaceItems",this.props.selectedItems.get(0)])||this.props.textStatus.get("isFocused")!==prevProps.textStatus.get("isFocused")&&this.props.textStatus.get("isFocused")){document.getElementById("highlighter").style.display="none";this.setState({bgToolActive:false});}if(this.props.sceneData.getIn(["workspaceBG","src"])!==prevProps.sceneData.getIn(["workspaceBG","src"])){if(!this.props.isPlay&&!this.props.isPlayAll&&this.props.swapDetails===null&&this.props.tool!=="converttomp4"){if(this.props.sceneData.getIn(["workspaceBG","src"])!==""){this.setState({bgToolActive:true});}}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var _this28=this;window.removeEventListener('mousedown',this.handleMouseDown,false);window.removeEventListener("resize",this.handleWindowResize,false);window.removeEventListener('mousemove',this.handleFullScreenMouseMove,false);window.removeEventListener("contextmenu",this.handleRightClick,false);window.removeEventListener("blur",this.tabChanged,false);window.removeEventListener("mousewheel",function(event){return _this28.changeLeafsOnScroll(event);},false);window.removeEventListener("keydown",this.switchFullScreen,false);}//For scroll Scenes Starts from here....
},{key:'changeLeafsOnScroll',value:function changeLeafsOnScroll(){var e=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var check=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;try{if(!this.props.isPlay&&!this.props.isPlayAll&&Math.abs(e.wheelDelta)>20){if(this.props.selectedItems.toJS().length>0&&this.isMouseOn(e,"workspace-main-page")){this.props.setSelectedItems({selectedItems:[]},this.props.socket);// this.props.suggestionPopup({
//   show : false,
//   type : '',
//   subType : ''
// })
}this.onLoadWorkspace=false;if(this.checkOnMouseOveraction&&this.props.selectedScene===this.state.active){// this.startedScrolling = true;
this.scrollType='scroll';this.scrollOnce=this.scrollOnce+1;if(e!==null){e=e||window.event;this.delta=e.deltaY||e.detail||e.wheelDelta;}this.fail=true;var date=new Date();var timestamp=date.getTime();this.currentTime=timestamp;this.commonTimeout();if(this.delta>0){//Mouse wheel rotation upwards
if(e)this.mouseUpTime=e.timeStamp;else this.mouseUpTime=new Date().getTime();this.scrollDirection='up';if(this.listenerStatus)this.wheelStart();return false;}else{//mouse wheel rotation downards
if(e)this.mouseDownTime=e.timeStamp;else this.mouseDownTime=new Date().getTime();this.scrollDirection='down';if(this.listenerStatus){if(this.state.items.length!==this.state.active+1)this.wheelStart();}return false;}}}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-changeLeafsOnScroll");}}},{key:'commonTimeout',value:function commonTimeout(){var _this29=this;try{var date=new Date();//let timeInterval = (this.scrollType === 'scroll') ? 1500 : 1000; 
var timeInterval=900;setTimeout(function(){if(_this29.scrollType==='scroll'){if(date.getTime()>=_this29.currentTime||_this29.state.active===_this29.state.items.length-1||_this29.state.active===0){_this29.fail=false;_this29.setStates(true);}else{if(_this29.state.onWheelEnd)_this29.setStates(false);}}else{_this29.setState({onclickAction:true},function(){///FOR THE HANDLE SHORT CUT ISSUES ON CLICK RIGHT ARROW BECAUSE SCROLLTYPE BECOMING NULL SOME TIMES....
_this29.rightKeyShortCut=false;_this29.leftKeyShortCut=false;});}},timeInterval);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-commonTimeout");}}},{key:'wheelStart',value:function wheelStart(){this.listenerStatus=false;this.stopProcess=true;this.wheelAct();}},{key:'setStates',value:function setStates(value){this.showResults=value;this.setState({onWheelEnd:value});}},{key:'wheelAct',value:function wheelAct(){var _this30=this;try{this.scrollEnd=this.scrollOnce;setTimeout(function(){if(_this30.scrollEnd===_this30.scrollOnce){_this30.wheelEnd();}else{if(_this30.scrollDirection==='down'&&_this30.stopProcess){// if (Math.abs(this.mouseUpTime - this.mouseDownTime) > 500) {
if(_this30.state.items.length!==_this30.state.active+1){_this30.isSceneClick=false;_this30.moveRight();_this30.stopProcess=false;}//}
}else if(_this30.scrollDirection==='up'&&_this30.stopProcess){// if (Math.abs(this.mouseUpTime - this.mouseDownTime) > 500) {
_this30.moveLeft();_this30.isSceneClick=false;_this30.stopProcess=false;//}
}_this30.wheelAct();}},35);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-wheelAct");}}},{key:'wheelEnd',value:function wheelEnd(){this.listenerStatus=true,this.scrollEnd=0,this.scrollOnce=0;}},{key:'moveLeft',value:function moveLeft(){var type=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;try{var newActive=this.state.active;newActive--;if(type==='click'){this.transitionsTodiv();this.scrollType='click';this.workedClick=false;this.setState({// active: newActive < 0 ? this.state.items.length - 1 : newActive,
active:newActive<0?this.state.active:newActive,direction:'left'});this.commonTimeout();}else{this.setState({// active: newActive < 0 ? this.state.items.length - 1 : newActive,
active:newActive<0?this.state.active:newActive,direction:'left'});}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-moveLeft");}}},{key:'transitionsTodiv',value:function transitionsTodiv(){var setElement=document.getElementById('workspace');var elementItem=document.getElementsByClassName('item');if(setElement.style.transition&&setElement.style.transition.includes('none')){setElement.style.transition='all 700ms ease-in-out';for(var j=0;j<elementItem.length;j++){elementItem[j].style.transition='all 700ms ease-in-out';}}}},{key:'workspaceOver',value:function workspaceOver(e,timeout){try{if(e!=="out"){if(this.props.isToolCropping){e.preventDefault();return false;}e.stopPropagation();}else{this.setState({videoControl:false});}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-workspaceOver");}}},{key:'moveRight',value:function moveRight(){var type=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;try{var newActive=this.state.active;if(this.props.scenes.size===1)newActive=-1;if(type==='click'){this.transitionsTodiv();this.scrollType='click';this.workedClick=false;this.setState({active:(newActive+1)%this.state.items.length===0?0:newActive+1,direction:'right'});this.commonTimeout();}else{this.setState({active:(newActive+1)%this.state.items.length===0?0:newActive+1,direction:'right'});}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-moveRight");}}},{key:'generateItems',//For scroll scenes main generation of the leafs ......
value:function generateItems(){var items=[];var centerWorkspace=this.runTheLIst();var style=this.calculateStyles();items.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:0,id:"workspace",className:'item level workspace work-list',style:style},centerWorkspace));if(this.props.isPlay||this.props.isPlayAll){items=[];items.unshift(centerWorkspace);}return items;}},{key:'composedPath',value:function composedPath(el){var path=[];while(el){path.push(el);if(el.tagName==='HTML'){path.push(document);path.push(window);return path;}el=el.parentElement;}}},{key:'isMouseOn',value:function isMouseOn(e,value){try{var i;var path_array=e.path||e.composedPath&&e.composedPath()||this.composedPath(e.target);if(path_array.length>0){for(i=0;i<path_array.length;i++){if(path_array[i].className!==undefined&&_typeof(path_array[i].className)!=="object"){if(path_array[i].className.indexOf(value)!==-1){return true;}}else if(path_array[i].className!==undefined&&_typeof(path_array[i].className)==="object"){if(path_array[i].className.animVal.indexOf(value)!==-1)return true;}}}return false;}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-isMouseOn");}}},{key:'handleItemClick',value:function handleItemClick(e,id,type,subType,childId){var _this31=this;try{var existItems=this.props.selectedItems,hasThis=existItems.keyOf(id);var selectedItems;if(hasThis!==undefined&&document.activeElement!==document.querySelector('#'+id+' .text-container')&&this.props.swapDetails===null){this.props.initiateMove({currentPosition:{x:e.clientX,y:e.clientY}});return;}if(hasThis===undefined){selectedItems=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])([id]);if(this.ctrlPressed)selectedItems=existItems.push(id);var propData={selectedItems:selectedItems.toArray(),currentPosition:{x:e.clientX,y:e.clientY}};if(selectedItems.size===1){propData.type=type;propData.subType=subType;}if(propData.type==='CHR'||propData.type==='TEXT'||propData.type==='DEFAULT_TEXT'){// this.props.suggestionPopup({
//   show : true,
//   type : propData.type,
//   subType : propData.subType
// })
}if(!this.props.isPlayAll&&this.props.mode!=='slide'){this.props.setSelectedItems(propData,this.props.socket);}setTimeout(function(){if(_this31.props.selectedItems.size===2){var nextBtn=document.querySelector('.next_step');if(nextBtn){nextBtn.classList.remove('disable');}}},1000);}else if(hasThis!==undefined&&this.props.selectedItems.size>1){selectedItems=existItems.delete(hasThis);var propData={selectedItems:selectedItems.toArray(),currentPosition:{x:e.clientX,y:e.clientY}};if(selectedItems.size===1){propData.type=type;propData.subType=subType;}this.props.setSelectedItems(propData,this.props.socket);}else if(hasThis!==undefined){if(this.props.textStatus.get("isFocused")&&this.props.textStatus.get("id")!==id){if(childId===undefined||this.props.textStatus.get("id")!==childId){if(type!=="TEXT")this.props.updateTextStatus({id:null,isSelected:false,isFocused:false,container:null,isRTL:false,isGrouped:false});}}}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-handleItemClick");}}},{key:'multiselectByBounds',value:function multiselectByBounds(x,y,width,height){var _this32=this;if(width>=5||height>=5){var allItems=this.props.sceneData.get("workspaceItems");//.filter(function (obj, key) { 
//return obj.get("enterStart") <= this.props.sceneData.get("playHeadValue") && obj.get("exitEnd") >= this.props.sceneData.get("playHeadValue") }.bind(this));
var workspaceBoundsX=document.getElementById('workspace').offsetLeft,workspaceBoundsY=document.getElementById('workspace').offsetTop;allItems.entrySeq().forEach(function(_ref19){var _ref20=_slicedToArray(_ref19,2),key=_ref20[0],item=_ref20[1];var current_item_bounds=document.getElementById(key).getBoundingClientRect();var item_x=current_item_bounds.left-workspaceBoundsX,item_y=current_item_bounds.top-workspaceBoundsY;if(x<item_x+current_item_bounds.width&&x+width>item_x&&y<item_y+current_item_bounds.height&&height+y>item_y){_this32.multiSelectedItems.push(key);}});if(this.multiSelectedItems.length>0){var selectedDetails={selectedItems:this.multiSelectedItems};if(this.multiSelectedItems.length===1){selectedDetails.type=this.props.sceneData.getIn(["workspaceItems",this.multiSelectedItems[0],"type"]);selectedDetails.subType=this.props.sceneData.getIn(["workspaceItems",this.multiSelectedItems[0],"subType"]);}this.props.setSelectedItems(selectedDetails,this.props.socket);}}}},{key:'initiateMultiselect',value:function initiateMultiselect(e){try{e.preventDefault();if(this.props.selectedItems.size>0&&document.getElementsByClassName("selectionBox")[0]){var sBounds=document.getElementsByClassName("selectionBox")[0].getBoundingClientRect();if(e.clientX>=sBounds.x&&e.clientY>=sBounds.y&&sBounds.x+sBounds.width>=e.clientX&&sBounds.y+sBounds.height>=e.clientY){this.props.initiateMove({currentPosition:{x:e.clientX,y:e.clientY}});this.selecting=true;return;}}var selection_overlay=document.createElement("div");var currentX=e.clientX-document.getElementById('workspace').offsetLeft,currentY=e.clientY-document.getElementById('workspace').offsetTop;var mouse_position={x:currentX,y:currentY};selection_overlay.setAttribute("id","selection-overlay");selection_overlay.style.left=mouse_position.x+"px";selection_overlay.style.top=mouse_position.y+"px";selection_overlay.style.width="0px";selection_overlay.style.height="0px";selection_overlay.style.position="absolute";selection_overlay.style.border="2px solid #c94a75";selection_overlay.style.backgroundColor="rgba(201,74,117,0.5)";this.mouseStartPosition=Object.assign(this.mouseStartPosition,{x:mouse_position.x,y:mouse_position.y});document.getElementsByClassName('workspace')[0].appendChild(selection_overlay);this.multiSelectedItems=[];window.addEventListener('mousemove',this.selectingItems,false);window.addEventListener('mouseup',this.stopSelection,false);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-initiateMultiselect");}}},{key:'selectingItems',value:function selectingItems(e){try{e.preventDefault();var currentX=e.clientX-document.getElementById('workspace').offsetLeft,currentY=e.clientY-document.getElementById('workspace').offsetTop;var mouse_position={x:currentX,y:currentY};var selection_overlay=document.getElementById('selection-overlay');if(selection_overlay!==undefined&&selection_overlay!==null){var boundX=this.mouseStartPosition.x,boundY=this.mouseStartPosition.y;if(mouse_position.x<boundX)selection_overlay.style.left=mouse_position.x+"px";if(mouse_position.y<boundY)selection_overlay.style.top=mouse_position.y+"px";selection_overlay.style.width=Math.abs(mouse_position.x-boundX)+"px";selection_overlay.style.height=Math.abs(mouse_position.y-boundY)+"px";}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-selectingItems");}}},{key:'stopSelection',value:function stopSelection(e){try{e.preventDefault();var selection_overlay=document.getElementById('selection-overlay');if(selection_overlay!==undefined&&selection_overlay!==null){var boundX=Math.round(selection_overlay.getBoundingClientRect().x-document.getElementById('workspace').offsetLeft),boundY=Math.round(selection_overlay.getBoundingClientRect().y-document.getElementById('workspace').offsetTop),boundW=Math.round(selection_overlay.getBoundingClientRect().width),boundH=Math.round(selection_overlay.getBoundingClientRect().height);this.multiselectByBounds(boundX,boundY,boundW,boundH);selection_overlay.remove();}window.removeEventListener('mousemove',this.selectingItems,false);window.removeEventListener('mouseup',this.stopSelection,false);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-stopSelection");}}},{key:'isRightMouse',value:function isRightMouse(e){try{var isRightMB;e=e||window.event;if("which"in e)isRightMB=e.which===3;else if("button"in e)isRightMB=e.button===2;return isRightMB;}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-isRightMouse");}}},{key:'handleSlideClick',value:function handleSlideClick(e,link){e.preventDefault();var objLink=link;if(this.props.isPlayAll&&objLink!==undefined&&objLink!==""){var curSlide=objLink.replace(/[^0-9\.]+/g,"");this.props.setSlideJump(curSlide);if(this.props.isFullScreen&&this.props.isPlayAll){if(this.props.t1.currentLabel()>=this.props.t1.getLabelsArray().length-1){document.getElementById('nextSlide').src=this.appUrl+"/images/playerControls-icons/next-disable.svg";document.getElementById('nextSlide').style.cursor='auto';document.getElementById('next-slide').style.cursor='auto';}if(this.props.t1.currentLabel()!==null){document.getElementById('prevSlide').src=this.appUrl+"/images/playerControls-icons/previous.svg";document.getElementById('prevSlide').style.cursor='pointer';document.getElementById('previous-slide').style.cursor='pointer';}if(this.props.t1.currentLabel()===null){document.getElementById('prevSlide').src=this.appUrl+"/images/playerControls-icons/previous-disable.svg";document.getElementById('prevSlide').style.cursor='auto';document.getElementById('previous-slide').style.cursor='auto';}if(this.props.t1.currentLabel()<this.props.t1.getLabelsArray().length){document.getElementById('nextSlide').src=this.appUrl+"/images/playerControls-icons/next.svg";document.getElementById('nextSlide').style.cursor='pointer';document.getElementById('next-slide').style.cursor='pointer';}}}else if(!this.props.isPlayAll&&this.props.isPreview&&objLink!==undefined&&objLink!==""){var _curSlide=parseInt(link.replace(/[^0-9\.]+/g,""));this.props.setSelectedScene(_curSlide-1,this.props.scenes.getIn([_curSlide-1,'startTime']),[_curSlide-1],this.props.socket);this.props.setScenePosition(_curSlide-1,_curSlide-1,this.props.project.getIn(['scenes',_curSlide-1,'startTime']),this.props.project.getIn(['scenes',_curSlide-1,'duration']));var currentScene=this.props.currentSceneNumber;if(this.props.scenes.count()>1){if(currentScene<this.props.project.get('scenes').count()-1){document.getElementById('prevSlide').src=this.appUrl+"/images/playerControls-icons/previous.svg";document.getElementById('prevSlide').style.cursor='pointer';document.getElementById('previous-slide').style.cursor='pointer';}if(currentScene+1>=this.props.project.get('scenes').count()-1){document.getElementById('nextSlide').src=this.appUrl+"/images/playerControls-icons/next-disable.svg";document.getElementById('nextSlide').style.cursor='auto';document.getElementById('next-slide').style.cursor='auto';}if(currentScene<this.props.project.get('scenes').count()){document.getElementById('nextSlide').src=this.appUrl+"/images/playerControls-icons/next.svg";document.getElementById('nextSlide').style.cursor='pointer';document.getElementById('next-slide').style.cursor='pointer';}if(currentScene===0||currentScene===1||currentScene===null){document.getElementById('prevSlide').src=this.appUrl+"/images/playerControls-icons/previous-disable.svg";document.getElementById('prevSlide').style.cursor='auto';document.getElementById('previous-slide').style.cursor='auto';}}}}},{key:'handleMouseDown',value:function handleMouseDown(e){try{if(!this.props.isPlay&&!this.props.isPlayAll&&this.props.mode!=='slide'){var stateToUpdate={};if(this.props.selectedItems.size===0){if(this.state.contextMenu){stateToUpdate.contextMenu=false;}}if(this.state.isZoomDropped){stateToUpdate.isZoomDropped=false;}if(Object.keys(stateToUpdate).length!==0&&stateToUpdate.constructor===Object){this.setState(stateToUpdate);}if(!this.isMouseOn(e,"bg-container")&&!this.isMouseOn(e,"video-container")&&!this.isMouseOn(e,'filter-bg')&&!this.isMouseOn(e,'bg-crop')&&!this.isMouseOn(e,'swap-bg')&&!this.isMouseOn(e,'flip-bg')&&!this.isMouseOn(e,'remove-bg')&&!this.isMouseOn(e,'delete-bg')&&!this.isMouseOn(e,'bg-toggle')&&!this.isMouseOn(e,'tick-bg')&&!this.isMouseOn(e,'bgvideo-close')&&!this.isMouseOn(e,'color-bg')){if(this.props.sceneData.getIn(['workspaceBG','src'])!==""||this.props.sceneData.getIn(["workspaceBG","type"])==="UPVIDEO"||this.props.sceneData.getIn(["workspaceBG","type"])==="STOCKVID"||this.props.sceneData.getIn(["workspaceBG","type"])==="VIDEO"){this.setState({bgToolActive:false});}}if(this.isMouseOn(e,'tick-bg')||this.isMouseOn(e,'bgvideo-close')){this.setState({isBgToolExpanded:false});}if(this.isMouseOn(e,"bg-container")||this.isMouseOn(e,"video-container")||this.isMouseOn(e,"bg-video")||this.isMouseOn(e,'filter-bg')||this.isMouseOn(e,'bg-crop')||this.isMouseOn(e,'swap-bg')||this.isMouseOn(e,'flip-bg')||this.isMouseOn(e,'remove-bg')||this.isMouseOn(e,'delete-bg')||this.isMouseOn(e,'bg-toggle')||this.isMouseOn(e,'tick-bg')||this.isMouseOn(e,'bgvideo-close')||this.isMouseOn(e,'color-bg')){if(this.props.sceneData.getIn(['workspaceBG','src'])!==""||this.props.sceneData.getIn(["workspaceBG","type"])==="UPVIDEO"||this.props.sceneData.getIn(["workspaceBG","type"])==="STOCKVID"||this.props.sceneData.getIn(["workspaceBG","type"])==="VIDEO"){this.setState({bgToolActive:true});}}if(!this.isMouseOn(e,"popup-component")&&!this.isMouseOn(e,"editicon-container")&&!this.isMouseOn(e,"bezier-path")&&!this.isMouseOn(e,"scene-item")&&!this.isMouseOn(e,"tool-bar")&&!this.isMouseOn(e,"handle")&&!this.isMouseOn(e,"keyframe-item")&&!this.isMouseOn(e,"selectionBox")&&!this.isMouseOn(e,"cropBox")&&!this.isMouseOn(e,"cropSelectionBox")&&!this.isMouseOn(e,"unCroppedBox")&&!this.isMouseOn(e,"slide-dropdown")){if(this.props.isToolCropping)this.props.toggleBgCrop();if(this.props.propertyWindow.get("component")==="bgColor"||this.props.propertyWindow.get("component")==="animate"||this.props.propertyWindow.get("component")==="color"){this.props.setPropertyWindow({component:''});//   this.props.suggestionPopup({
//     show : false,
//     type : '',
//     subType : ''
// })
}if(this.props.selectedItems.size>0){var elements=document.querySelectorAll(".type-scr");for(var i=0;i<elements.length;i++){elements[i].style.display="none";}if(this.props.swapDetails!==null){this.props.undoProp.isBG===true?this.props.dropBG({selectedScene:this.props.selectedScene,value:this.props.undoProp,socket:this.props.socket,deleteId:'',deletedData:[],subType:"BG_SETTINGS"}):this.props.addObj(this.props.undoProp,this.props.socket);this.props.swapItem("");this.props.swapItemUndo("");}this.props.setSelectedItems({selectedItems:[],currentPosition:{x:e.clientX,y:e.clientY}},this.props.socket);//  this.props.suggestionPopup({
//     show : false,
//     type : '',
//     subType : ''
// })
if(this.isRightMouse(e)){this.setState({contextMenu:true,isContextBg:true});var clickX=e.clientX;var clickY=e.clientY;var screenW=window.innerWidth;var screenH=window.innerHeight;var cmWidth=this.contextMenu.offsetWidth;var cmHeight=this.contextMenu.offsetHeight;var right=screenW-clickX>cmWidth;var left=!right;var top=screenH-clickY>cmHeight;var bottom=!top;if(right){this.contextMenu.style.left=clickX+5+'px';}if(left){this.contextMenu.style.left=clickX-cmWidth-5+'px';}if(top){this.contextMenu.style.top=clickY+5+'px';}if(bottom){this.contextMenu.style.top=clickY-cmHeight-5+'px';}}}else{if(!this.isRightMouse(e)){if(this.props.sceneData.getIn(['workspaceBG','src'])===""&&this.isMouseOn(e,"bg-container")){if(this.props.isToolCropping)this.props.toggleBgCrop();this.props.setPropertyWindow({component:"bgColor"});}}else{this.setState({contextMenu:true,isContextBg:true});var _clickX=e.clientX;var _clickY=e.clientY;var _screenW=window.innerWidth;var _screenH=window.innerHeight;var _cmWidth=this.contextMenu.offsetWidth;var _cmHeight=this.contextMenu.offsetHeight;var _right=_screenW-_clickX>_cmWidth;var _left=!_right;var _top=_screenH-_clickY>_cmHeight;var _bottom=!_top;if(_right){this.contextMenu.style.left=_clickX+5+'px';}if(_left){this.contextMenu.style.left=_clickX-_cmWidth-5+'px';}if(_top){this.contextMenu.style.top=_clickY+5+'px';}if(_bottom){this.contextMenu.style.top=_clickY-_cmHeight-5+'px';}}}this.initiateMultiselect(e);}}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-handleMouseDown");}}},{key:'getItem',value:function getItem(item,key,groupId,sceneData){var _this33=this;var innerElem=null;var configPath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("type")][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("type")][item.get('subType')?'workspace_'+item.get('subType'):'workspace']];var onLoadPath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("type")][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("type")][item.get('subType')?'onload_'+item.get('subType'):'onload']];var innerStyle={};if(item.get('subType')==='EPROP'||item.get('subType')==='GETTYICON'){configPath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get('subType')][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("subType")]['workspace']];onLoadPath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("subType")][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("subType")]['workspace']];}if(item.get("type")==="UPLOADS"){configPath=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("type")][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("type")][item.get('subType')?'workspace_'+item.get('subType'):'workspace']];onLoadPath=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("type")][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("type")][item.get('subType')?'onload_'+item.get('subType'):'workspace']];}if(item.get("subType")==="GIPHY"){configPath=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("subType")][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("subType")]['workspace']];onLoadPath=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("subType")][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("subType")]['onload']];}else if(item.get("type")==="STOCKIMG"||item.get("type")==="PEXELS"||item.get("type")==="PIXABAY"||item.get("type")==="UNSPLASH"){configPath="";onLoadPath="";}else if(item.get('subType')==='OBGIMG'||item.get('subType')==='OBGVID'){configPath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["BG"]['obgsrc'];onLoadPath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a['BG']['obgsrc'];}else if(item.get("type")==="CHR"){if(item.get('subType')==='CCHR'||item.get('subType')==='ECHR')configPath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("subType")][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("subType")]['workspace']];else configPath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("type")][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("type")]['workspace']];onLoadPath="";}if(item.get('subType')==='GRAD'){configPath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get('subType')][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("subType")]['workspace']];onLoadPath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("subType")][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[item.get("subType")]['workspace']];}var parentItem;if(groupId!==undefined){parentItem=this.props.sceneData.getIn(["workspaceItems",groupId]);}var isHyperlinkClickable=// sometimes browser initiates some default behaviour when dragging transform manager, so mount anchor tags only when required
this.props.isPlay||this.props.isPlayAll||this.props.isPreview||this.props.isFullScreen;switch(item.get("type")){case"IMG":case"UPLOADS":case"STOCKIMG":case"PEXELS":case"PIXABAY":case"GIPHY":case"UNSPLASH":if(item.get("isCropped")){innerStyle.left=item.getIn(["original","x"])*item.get("width")*this.props.zoomFactor+"px";innerStyle.top=item.getIn(["original","y"])*item.get("height")*this.props.zoomFactor+"px";innerStyle.width=item.getIn(["original","width"])*item.get("width")*this.props.zoomFactor+"px";innerStyle.height=item.getIn(["original","height"])*item.get("height")*this.props.zoomFactor+"px";}if(item.get('isBlob')){configPath='';onLoadPath='';}if(item.get('type')==='UPLOADS'&&item.get('sourceType')&&item.get('sourceType').includes('svg')&&item.get('colors')){var _React$createElement;innerElem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomSVGRender,(_React$createElement={key:key,uploadSVG:true,parentId:item.get('parentId'),charId:item.get("charId"),scenStart:sceneData.get("startTime"),workspaceWidth:this.props.workspaceWidth,workspaceHeight:this.props.workspaceHeight,animakerType:this.props.animakerType,parentItem:parentItem,completeWorkspaceItems:item,startPlay:this.props.startPlay,addTween:this.props.addTween,workspaceItems:this.props.sceneData.get("workspaceItems"),changePlayTime:this.props.changePlayTime,playHeadValue:this.props.playHeadValue,pose:item.get("pose"),expression:item.get("expression"),zoomFactor:this.props.zoomFactor,assetType:item.get("type"),assetSubType:item.get("subType"),data_id:key,isPlay:this.props.isPlay,isPlayAll:this.props.isPlayAll},_defineProperty(_React$createElement,'key',key),_defineProperty(_React$createElement,'selectedItems',this.props.selectedItems),_defineProperty(_React$createElement,'src',configPath+item.get("src")),_defineProperty(_React$createElement,'colors',item.get("colors")),_defineProperty(_React$createElement,'parts',item.get("parts")),_defineProperty(_React$createElement,'animdata',item.get("animdata")),_defineProperty(_React$createElement,'swapDetails',this.props.swapDetails),_defineProperty(_React$createElement,'animsrc',configPath+item.get("animsrc")),_defineProperty(_React$createElement,'expFlag',item.get("expFlag")),_defineProperty(_React$createElement,'isRepeated',item.get("isRepeated")),_defineProperty(_React$createElement,'isAnimated',item.get("isAnimated")),_defineProperty(_React$createElement,'repeatLoop',item.get("repeatLoop")),_defineProperty(_React$createElement,'mouthAction',item.get("mouthAction")),_defineProperty(_React$createElement,'socket',this.props.socket),_defineProperty(_React$createElement,'updateItem',this.props.updateItem),_defineProperty(_React$createElement,'selectedScene',this.props.selectedScene),_React$createElement));}else{innerElem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__containers_ProgressiveImage__["a" /* default */],{src:configPath+item.get("src"),placeholder:onLoadPath+item.get("thumb")},function(image,loading){if(isHyperlinkClickable&&item.get('link')&&item.getIn('link')!==''){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.get('link'),target:'_blank',onClick:function onClick(e){!_this33.props.isPlayAll&&_this33.props.mode!=='slide'||item.get('link').match("^Slide")?_this33.handleSlideClick(e,item.get('link')):_this33.openLink(e,item.get('link'));},style:{pointerEvents:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'scene-items','data-id':key,src:image,className:"scene-item-inner",style:Object.assign({},innerStyle,{filter:item.get("filter")!==undefined&&item.get("filter")!==""&&item.get("filter")!=="6464646464640032"?'url(#filter_'+key+'_'+item.get("filter")+')':null})}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'scene-items','data-id':key,src:image,className:"scene-item-inner",style:Object.assign({},innerStyle,{filter:item.get("filter")!==undefined&&item.get("filter")!==""&&item.get("filter")!=="6464646464640032"?'url(#filter_'+key+'_'+item.get("filter")+')':null})});}});}break;case"TEXT":var itemId=null;if(groupId!==undefined){itemId=key;key=groupId;}if(item.get("subType")==="BANNER"){var _React$createElement2;innerElem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Callout,(_React$createElement2={key:key,startPlay:this.props.startPlay,selectedScene:this.props.selectedScene,data:item,itemId:key,isPlay:this.props.isPlay,isPlayAll:this.props.isPlayAll,data_id:key},_defineProperty(_React$createElement2,'itemId',itemId),_defineProperty(_React$createElement2,'isGrouped',groupId!==undefined),_defineProperty(_React$createElement2,'parentItem',parentItem),_defineProperty(_React$createElement2,'zoomFactor',this.props.zoomFactor),_defineProperty(_React$createElement2,'workspaceItems',this.props.sceneData.get("workspaceItems")),_defineProperty(_React$createElement2,'animakerType',this.props.animakerType),_defineProperty(_React$createElement2,'playHeadValue',this.props.playHeadValue),_defineProperty(_React$createElement2,'selectedItems',this.props.selectedItems),_defineProperty(_React$createElement2,'socket',this.props.socket),_React$createElement2));}else{if(isHyperlinkClickable&&item.getIn(['textData','link'])!==''&&item.getIn(['textData','link'])!==undefined&&item.getIn(['textData','htmlText']).indexOf('href')===-1){innerElem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.getIn(['textData','link']),style:{textDecorationColor:item.getIn(["textData","formats","containerStyle","color"])},target:'_blank',onClick:function onClick(e){!_this33.props.isPlayAll&&_this33.props.mode!=='slide'||item.getIn(['textData','link']).match("^Slide")?e.preventDefault():_this33.openLink(e,item.getIn(['textData','link']));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__containers_Text__["a" /* default */],{text:item,key:key,linkEnabled:false,data_id:key,itemId:itemId,currentScene:this.props.selectedScene,isGrouped:groupId!==undefined,socket:this.props.socket}));}else innerElem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__containers_Text__["a" /* default */],{text:item,key:key,linkEnabled:false,data_id:key,itemId:itemId,currentScene:this.props.selectedScene,isGrouped:groupId!==undefined,socket:this.props.socket});}break;case"CCHR":case"CHR":case"PROP":case"OVLYSVG":case"SHAPE":if(item.get("type")==="SHAPE"){var _React$createElement3;var itemId=null;if(groupId!==undefined){itemId=key;key=groupId;}innerElem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Callout,(_React$createElement3={startPlay:this.props.startPlay,key:key,selectedScene:this.props.selectedScene,data:item,itemId:key,isPlay:this.props.isPlay,isPlayAll:this.props.isPlayAll,data_id:key},_defineProperty(_React$createElement3,'itemId',itemId),_defineProperty(_React$createElement3,'isGrouped',groupId!==undefined),_defineProperty(_React$createElement3,'parentItem',parentItem),_defineProperty(_React$createElement3,'zoomFactor',this.props.zoomFactor),_defineProperty(_React$createElement3,'workspaceItems',this.props.sceneData.get("workspaceItems")),_defineProperty(_React$createElement3,'animakerType',this.props.animakerType),_defineProperty(_React$createElement3,'playHeadValue',this.props.playHeadValue),_defineProperty(_React$createElement3,'selectedItems',this.props.selectedItems),_defineProperty(_React$createElement3,'socket',this.props.socket),_React$createElement3));}else{var canPlayAnimation=item.get("isAnimated");if(!this.props.isPlay&&!this.props.isPlayAll){canPlayAnimation=groupId===undefined&&item.get("isAnimated");// dont play animation when a group child is selected
}if(isHyperlinkClickable&&item.get('link')&&item.get('link')!==''){var _React$createElement4;innerElem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.get('link'),target:'_blank',onClick:function onClick(e){!_this33.props.isPlayAll&&_this33.props.mode!=='slide'||item.get('link').match("^Slide")?_this33.handleSlideClick(e,item.get('link')):_this33.openLink(e,item.get('link'));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomSVGRender,(_React$createElement4={key:key,link:item.get('link'),uploadSVG:false,parentId:item.get('parentId'),charId:item.get("charId"),scenStart:sceneData.get("startTime"),workspaceWidth:this.props.workspaceWidth,workspaceHeight:this.props.workspaceHeight,animakerType:this.props.animakerType,parentItem:parentItem,completeWorkspaceItems:item,startPlay:this.props.startPlay,addTween:this.props.addTween,workspaceItems:this.props.sceneData.get("workspaceItems"),changePlayTime:this.props.changePlayTime,playHeadValue:this.props.playHeadValue,pose:item.get("pose"),expression:item.get("expression"),zoomFactor:this.props.zoomFactor,assetType:item.get("type"),assetSubType:item.get("subType"),data_id:key,isPlay:this.props.isPlay,isPlayAll:this.props.isPlayAll},_defineProperty(_React$createElement4,'key',key),_defineProperty(_React$createElement4,'selectedItems',this.props.selectedItems),_defineProperty(_React$createElement4,'src',configPath+item.get("src")),_defineProperty(_React$createElement4,'colors',item.get("colors")),_defineProperty(_React$createElement4,'parts',item.get("parts")),_defineProperty(_React$createElement4,'animdata',item.get("animdata")),_defineProperty(_React$createElement4,'swapDetails',this.props.swapDetails),_defineProperty(_React$createElement4,'animsrc',configPath+item.get("animsrc")),_defineProperty(_React$createElement4,'expFlag',item.get("expFlag")),_defineProperty(_React$createElement4,'isRepeated',item.get("isRepeated")),_defineProperty(_React$createElement4,'isAnimated',canPlayAnimation),_defineProperty(_React$createElement4,'repeatLoop',item.get("repeatLoop")),_defineProperty(_React$createElement4,'mouthAction',item.get("mouthAction")),_defineProperty(_React$createElement4,'socket',this.props.socket),_defineProperty(_React$createElement4,'updateItem',this.props.updateItem),_defineProperty(_React$createElement4,'selectedScene',this.props.selectedScene),_defineProperty(_React$createElement4,'mode',this.props.mode),_React$createElement4)));}else{var _React$createElement5;innerElem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomSVGRender,(_React$createElement5={key:key,link:item.get('link'),uploadSVG:false,parentId:item.get('parentId'),charId:item.get("charId"),scenStart:sceneData.get("startTime"),workspaceWidth:this.props.workspaceWidth,workspaceHeight:this.props.workspaceHeight,animakerType:this.props.animakerType,parentItem:parentItem,completeWorkspaceItems:item,startPlay:this.props.startPlay,addTween:this.props.addTween,workspaceItems:this.props.sceneData.get("workspaceItems"),changePlayTime:this.props.changePlayTime,playHeadValue:this.props.playHeadValue,pose:item.get("pose"),expression:item.get("expression"),zoomFactor:this.props.zoomFactor,assetType:item.get("type"),assetSubType:item.get("subType"),data_id:key,isPlay:this.props.isPlay,isPlayAll:this.props.isPlayAll},_defineProperty(_React$createElement5,'key',key),_defineProperty(_React$createElement5,'selectedItems',this.props.selectedItems),_defineProperty(_React$createElement5,'src',configPath+item.get("src")),_defineProperty(_React$createElement5,'colors',item.get("colors")),_defineProperty(_React$createElement5,'parts',item.get("parts")),_defineProperty(_React$createElement5,'animdata',item.get("animdata")),_defineProperty(_React$createElement5,'swapDetails',this.props.swapDetails),_defineProperty(_React$createElement5,'animsrc',configPath+item.get("animsrc")),_defineProperty(_React$createElement5,'expFlag',item.get("expFlag")),_defineProperty(_React$createElement5,'isRepeated',item.get("isRepeated")),_defineProperty(_React$createElement5,'isAnimated',canPlayAnimation),_defineProperty(_React$createElement5,'repeatLoop',item.get("repeatLoop")),_defineProperty(_React$createElement5,'mouthAction',item.get("mouthAction")),_defineProperty(_React$createElement5,'socket',this.props.socket),_defineProperty(_React$createElement5,'updateItem',this.props.updateItem),_defineProperty(_React$createElement5,'selectedScene',this.props.selectedScene),_React$createElement5));}}break;case"FRAME":innerElem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__containers_Frame_Frames__["a" /* default */],{key:key,id:key,frameItem:item,grouped:groupId?true:false,groupId:groupId,isPlay:this.props.isPlay,isPlayAll:this.props.isPlayAll,setPlay:this.props.setPlay,socket:this.props.socket,frameCount:undefined,isFullScreen:this.props.isFullScreen});if(isHyperlinkClickable&&item.get('link')&&item.get('link')!==''){innerElem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{pointerEvents:'auto'},href:item.get('link'),target:'_blank',onClick:function onClick(e){!_this33.props.isPlayAll&&_this33.props.mode!=='slide'||item.get('link').match("^Slide")?_this33.handleSlideClick(e,item.get('link')):_this33.openLink(e,item.get('link'));}},innerElem);}break;case"GRID":innerElem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__containers_Grid__["a" /* default */],{key:key,id:key,gridItemData:item,grouped:groupId?true:false,groupId:groupId,isPlay:this.props.isPlay,isPlayAll:this.props.isPlayAll,setPlay:this.props.setPlay,socket:this.props.socket,slide:this.props.selectedScene,selectedItems:this.props.selectedItems,browserName:this.props.browserName,zoomFactor:this.props.zoomFactor});if(isHyperlinkClickable&&item.get('link')&&item.get('link')!==''){innerElem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{pointerEvents:'auto'},href:item.get('link'),target:'_blank',onClick:function onClick(e){!_this33.props.isPlayAll&&_this33.props.mode!=='slide'||item.get('link').match("^Slide")?_this33.handleSlideClick(e,item.get('link')):_this33.openLink(e,item.get('link'));}},innerElem);}break;default:innerElem="none";break;}return innerElem;}},{key:'setAsBg',value:function setAsBg(){try{if(this.props.selectedItems.size===1){var selectedItem=this.props.sceneData.getIn(["workspaceItems",this.props.selectedItems.get(0)]),subType=void 0,isBlob=false;var bgType=selectedItem.get("type");if(bgType!=="STOCKIMG"&&bgType!=="PEXELS"&&bgType!=="UNSPLASH"&&bgType!=="PIXABAY"&&bgType!=='IMG'&&selectedItem.get("subType")!==undefined&&selectedItem.get("subType")!==""&&selectedItem.get("subType")!==null)bgType=selectedItem.get("subType");if(bgType==="STOCKIMG"||bgType==='IMG')subType=selectedItem.get("subType");if(bgType==="PEXELS"||bgType==="PIXABAY"||bgType==="UNSPLASH"){subType=selectedItem.get("subType");}if(selectedItem.get("subType")==="GIPHY"){bgType=selectedItem.get("subType");}var bgFilter="";if(this.props.sceneData.getIn(["workspaceBG","bgFilter"])!=="")bgFilter="";if(selectedItem.get("filter")!==undefined&&selectedItem.get("filter")!=="")bgFilter=selectedItem.get("filter");if(selectedItem.get('isBlob')){isBlob=true;}this.props.changeBg({selectedScene:this.props.selectedScene,selectedItems:this.props.selectedItems,isBlob:isBlob,assetId:selectedItem.get("assetId"),stockId:selectedItem.get("assetId"),bgType:bgType,subType:subType,sourceType:selectedItem.get("sourceType"),bgHeight:document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("img")[0].naturalHeight,bgWidth:document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("img")[0].naturalWidth,source:selectedItem.get("src"),thumb:selectedItem.get("thumb"),color:[],isCustomBg:true,bgFilter:bgFilter,flipPosition:selectedItem.get("flipPosition")},this.props.socket);}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-setAsBg");}}},{key:'pasteItem',value:function pasteItem(e){try{e.stopPropagation();this.setState({contextMenu:false,isContextBg:false});if(!this.props.textStatus.get("isFocused")){var toPaste=this.props.copiedItem;if(!this.props.updateItems){var isInProcess=false,wrkspcItems=toPaste.data.workspaceItems;for(var i=0;i<wrkspcItems.length;i++){if(wrkspcItems[i].isBlob){isInProcess=true;break;}}if(isInProcess){this.props.manageToast({action:"add",type:"error","message":'ct.dup',formatId:"msg"});return;}}if(toPaste!==null){toPaste.selectedScene=this.props.selectedScene;this.props.pasteItems(toPaste,this.props.socket);}}else{document.execCommand("paste");}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-pasteItem");}}},{key:'workspaceItemsAssembler',value:function workspaceItemsAssembler(workspaceItems,workspaceChildren,workspaceScale,sceneData){var _this34=this;var workspaceObjects=[],svgFilters=[];if(workspaceItems.size>0){workspaceItems.entrySeq().forEach(function(_ref21){var _ref22=_slicedToArray(_ref21,2),key=_ref22[0],value=_ref22[1];var flip=getFlipPosition(value.get("flipPosition")),item=null;var item_styles={transform:"translate("+parseFloat((value.get("x")*workspaceScale).toFixed(2))+"px, "+parseFloat((value.get("y")*workspaceScale).toFixed(2))+"px) rotateZ("+value.get("angle")+"deg)"+flip,position:"absolute",width:parseFloat((value.get("width")*workspaceScale).toFixed(2)),height:parseFloat((value.get("height")*workspaceScale).toFixed(2)),overflow:"hidden"};if(value.get('opacity')!==undefined)item_styles.opacity=value.get('opacity');var isHidden=false;// if (this.props.isPlay || this.props.isPlayAll || (value.get('enterStart') <= this.props.sceneData.get("playHeadValue") && value.get('exitEnd') >= this.props.sceneData.get("playHeadValue") && ((value.get('isVisible') === undefined || value.get('isVisible')) ))){
item_styles.willChange="transform, opacity";item_styles.opacity=value.get('opacity');if(_this34.props.swapDetails!==null&&_this34.props.swapDetails.id===key)item_styles.zIndex=10;if(value.get("type")!=="GROUP"&&value.get("type")!=="TXTOVLY"){if(!_this34.props.isCropping&&!_this34.props.isFraming||key!==_this34.props.selectedItems.get(0)){var filterValue={};var itemKey=key;if((value.get("type")==="IMG"||value.get("type")==="STOCKIMG"||value.get("type")==="PEXELS"||value.get("type")==="PIXABAY"||value.get("type")==="UNSPLASH"||value.get("type")==="UPLOADS"&&value.get("subType")==="UPIMAGE")&&value.get("isCropped")){var cropPosition={left:value.getIn(["original","x"])*value.get("width")*_this34.props.zoomFactor+"px",top:value.getIn(["original","y"])*value.get("height")*_this34.props.zoomFactor+"px",width:value.getIn(["original","width"])*value.get("width")*_this34.props.zoomFactor+"px",height:value.getIn(["original","height"])*value.get("height")*_this34.props.zoomFactor+"px"};Object.assign(filterValue,cropPosition);item_styles.overflow="hidden";// itemKey += Math.random();
}if(value.get("type")==="FRAME"){item_styles.overflow="hidden";item_styles.WebkitClipPath="url(#clip-"+key+")";item_styles.clipPath="url(#clip-"+key+")";}if(value.get("type")==="TEXT"||value.get("type")==="SHAPE"){item_styles.overflow="unset";}if(value.get("type")==="CHR")value=value.setIn(["parentId"],key);item=_this34.getItem(value,key,undefined,sceneData);}if(value.get("type")==="IMG"||value.get("type")==="UPLOADS"||value.get("type")==="UPIMAGE"||value.get("type")==="STOCKIMG"||value.get("type")==="PEXELS"||value.get("type")==="PIXABAY"||value.get("type")==="UNSPLASH"){var vignetteItemId=key+"-vignette-"+_this34.props.selectedScene;svgFilters.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'image-filter',id:'svgFilter_'+key,key:key+"-vignette-"+_this34.props.selectedScene},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('filter',{colorInterpolationFilters:'sRGB',id:'filter_'+key+'_'+value.get("filter")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__ReturnSvgFilter__["a" /* ReturnSvgFilter */],{'data-id':key,filterCode:value.get("filter")===""?"6464646464640032":value.get("filter"),vignetteId:vignetteItemId})))));}}else{var groupElements=[];item=[];value.get("groupChildren").entrySeq().forEach(function(_ref23){var _ref24=_slicedToArray(_ref23,2),childKey=_ref24[0],itemId=_ref24[1];var childItem=workspaceChildren.get(itemId);var groupItemX=parseFloat((childItem.get("x")-value.get("x"))*workspaceScale).toFixed(2),groupItemY=parseFloat((childItem.get("y")-value.get("y"))*workspaceScale).toFixed(2),groupItemWidth=parseFloat(childItem.get("width")*workspaceScale).toFixed(2),groupItemHeight=parseFloat(childItem.get("height")*workspaceScale).toFixed(2);var flip=getFlipPosition(childItem.get("flipPosition"));var groupStyle={willChange:"transform",transform:"translate("+groupItemX+"px, "+groupItemY+"px) rotateZ("+childItem.get("angle")+"deg)"+flip,position:"absolute",width:groupItemWidth+"px",height:groupItemHeight+"px",overflow:"hidden"};if(childItem.get('opacity')!==undefined)groupStyle.opacity=childItem.get('opacity');var filterValue={};var itemKey=key+"-"+itemId;if(childItem.get("type")==="IMG"||childItem.get("type")==="STOCKIMG"||childItem.get("type")==="PEXELS"||childItem.get("type")==="PIXABAY"||childItem.get("type")==="UNSPLASH"){if(childItem.get("isCropped")){var _cropPosition={left:childItem.getIn(["original","x"])*childItem.get("width")*_this34.props.zoomFactor+"px",top:childItem.getIn(["original","y"])*childItem.get("height")*_this34.props.zoomFactor+"px",width:childItem.getIn(["original","width"])*childItem.get("width")*_this34.props.zoomFactor+"px",height:childItem.getIn(["original","height"])*childItem.get("height")*_this34.props.zoomFactor+"px"};Object.assign(filterValue,_cropPosition);groupStyle.overflow="hidden";}}if(childItem.get("type")==="FRAME"){groupStyle.overflow="hidden";groupStyle.WebkitClipPath="url(#clip-"+itemId+")";groupStyle.clipPath="url(#clip-"+itemId+")";}if(childItem.get("type")==="TEXT"||childItem.get("type")==="SHAPE"){groupStyle.overflow="unset";item_styles.overflow="unset";}if(childItem.get("type")==="CHR")childItem=childItem.setIn(["parentId"],itemId);groupElements.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key+"-"+itemId,onMouseDown:function onMouseDown(e){return _this34.handleItemClick(e,key,childItem.get("type"),childItem.get("subType"),itemId);},id:itemId,'data-id':key,'data-group-id':itemId,'data-elem_id':childItem.get("elem_id"),className:"scene-item group-scene-item type-"+childItem.get("type").toLowerCase()+" tintCls",style:groupStyle},_this34.getItem(childItem,itemId,key,sceneData)));if(childItem.get("type")==="IMG"||childItem.get("type")==="UPLOADS"&&childItem.get("subType")==="UPIMAGE"||childItem.get("type")==="STOCKIMG"||childItem.get("type")==="PEXELS"||childItem.get("type")==="PIXABAY"||childItem.get("type")==="UNSPLASH"){var _vignetteItemId=itemId+"-vignette-"+_this34.props.selectedScene;svgFilters.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'image-filter',id:'svgFilter_'+itemId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('filter',{colorInterpolationFilters:'sRGB',id:"filter_"+itemId+"_"+childItem.get("filter")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__ReturnSvgFilter__["a" /* ReturnSvgFilter */],{'data-id':itemId,filterCode:childItem.get("filter")===""?"6464646464640032":childItem.get("filter"),vignetteId:_vignetteItemId})))));}});item=groupElements;}var vignetteContainer=[];var loaderElem=void 0;var collaborateClass="";if(_this34.props.selectedItems.size===0&&!_this34.props.isPlay&&!_this34.props.isPlayAll){_this34.props.connections.entrySeq().forEach(function(_ref25){var _ref26=_slicedToArray(_ref25,2),keyVal=_ref26[0],connectDetail=_ref26[1];if(connectDetail.get("selectedItems")===key){collaborateClass=" colSelected";var rightPosition=_this34.rotatedPosition(value.get("x"),value.get("y"),value.get("width"),value.get("height"),value.get("angle")*(Math.PI/180));_this34.collaborativeUsers.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'outline',className:'collaborative-user-selection','data-html2canvas-ignore':'true',style:{position:"absolute",left:value.get("x")*_this34.props.zoomFactor+"px",top:value.get("y")*_this34.props.zoomFactor+"px",width:value.get("width")*_this34.props.zoomFactor+"px",height:value.get("height")*_this34.props.zoomFactor+"px",transform:"rotate("+value.get("angle")+"deg)",boxShadow:"0px 0px 0px 2px rgba(0,0,0,0.1)",display:item_styles.display,opacity:!isHidden?1:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{backgroundColor:connectDetail.get("color")}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{backgroundColor:connectDetail.get("color")}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{backgroundColor:connectDetail.get("color")}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{backgroundColor:connectDetail.get("color")}})));_this34.collaborativeUsers.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'user-name','data-html2canvas-ignore':'true',style:{position:"absolute",left:rightPosition.x*_this34.props.zoomFactor+"px",top:rightPosition.y*_this34.props.zoomFactor-30+"px",backgroundColor:connectDetail.get("color"),padding:"4px 10px",borderRadius:"2px",pointerEvents:"none",display:"inline-table",opacity:!isHidden?1:0}},connectDetail.get("projectUsr")));}});}if(value.get("type")==="IMG"||value.get("type")==="STOCKIMG"||value.get("type")==="UPLOADS"||value.get("type")==="PEXELS"||value.get("type")==="PIXABAY"||value.get("type")==="UNSPLASH")vignetteContainer.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key+"-vignette",id:key+"-vignette-"+_this34.props.selectedScene,className:'vignette'}));if(value.get("type")==="GROUP"&&value.get("subType")==="TXTGRP"&&key===_this34.props.selectedItems.get(0)){loaderElem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'loader-img',alt:'loader',src:_this34.appUrl+"/images/chr-loading.svg",style:{width:"100%",height:"100%",objectFit:"scale-down",display:_this34.props.isfontLoadedTxtGrp?'block':'none',zIndex:"2"}});}workspaceObjects.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key,id:key,'data-id':key,onMouseDown:function onMouseDown(e){return value.get("type")!=="GROUP"||!_this34.props.textStatus.get("isFocused")?_this34.handleItemClick(e,key,value.get("type"),value.get("subType")):false;},'data-elem_id':value.get("elem_id"),className:"scene-item type-"+value.get("type").toLowerCase()+" tintCls"+collaborateClass,style:item_styles},loaderElem,vignetteContainer,item));});}return[workspaceObjects,svgFilters];}},{key:'highlightItem',value:function highlightItem(value){if(value!==false&&!this.props.textStatus.get("isFocused")&&this.props.selectedItems.size===0){var ix=this.props.workspaceBounds.get("cx")-this.props.workspaceWidth*this.props.zoomFactor/2+value.get("x")*this.props.zoomFactor;var iy=this.props.workspaceBounds.get("cy")-this.props.workspaceHeight*this.props.zoomFactor/2+value.get("y")*this.props.zoomFactor;document.getElementById("highlighter").style.display="block";document.getElementById("highlighter").style.left=ix+"px";document.getElementById("highlighter").style.top=iy+"px";document.getElementById("highlighter").style.width=value.get("width")*this.props.zoomFactor+"px";document.getElementById("highlighter").style.height=value.get("height")*this.props.zoomFactor+"px";document.getElementById("highlighter").style.transform="rotatez("+value.get("angle")+"deg)";}else{document.getElementById("highlighter").style.display="none";}}},{key:'workspaceBGColorAssembler',value:function workspaceBGColorAssembler(workspaceBG,bgStyles){var bgColors=[];var bgColor=workspaceBG.get("color");if(bgColor!==undefined&&bgColor.size>0){if(bgColor.size>1){var gradient,isRadial=workspaceBG.get("isRadial"),gradientType="linear";if(isRadial===undefined||!isRadial)gradient=workspaceBG.get("direction")!==undefined?"to "+workspaceBG.get("direction")+", ":"to right, ";else{gradient="";gradientType="radial";if(workspaceBG.get("radius")!=="")bgColor=bgColor.set(0,bgColor.get(0)+" "+workspaceBG.get("radius")+"%");}bgColor.map(function(color,index){gradient+=color+", ";});bgStyles.backgroundImage=gradientType+"-gradient("+gradient.replace(/,\s*$/,"")+")";}else{bgStyles.backgroundColor=bgColor.get(0);//(workspaceBG.get("src") === undefined || workspaceBG.get("src") === null || workspaceBG.get("src") === "")?bgColor.get(0):"#ededef";
}bgColors.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'color',className:'bg-container',style:bgStyles}));bgColors.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'bgPreview',className:'bg-container bg-preview',id:'bgWrkspcPreview',style:bgStyles}));return bgColors;}else{bgStyles.backgroundColor="#ffffff";bgColors.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'color',className:'bg-container',style:bgStyles}));bgColors.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'bgPreview',className:'bg-container bg-preview',id:'bgWrkspcPreview',style:bgStyles}));return bgColors;}}},{key:'enableBgSettings',value:function enableBgSettings(e){try{e.stopPropagation();this.initiateMultiselect(e);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-enableBgSettings");}}},{key:'enableBgColor',value:function enableBgColor(e){try{e.stopPropagation();if(this.props.isToolCropping)this.props.toggleBgCrop();this.props.setPropertyWindow({component:"bgColor"});if(!this.props.videoTool&&!this.props.isFullScreen)this.initiateMultiselect(e);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-enableBgColor");}}},{key:'controlVideo',value:function controlVideo(){try{this.setState(function(state,props){return{isFullScrVideoplay:true};});}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-controlVideo");}}},{key:'playPausevideo',value:function playPausevideo(event){try{event.stopPropagation();// let video=document.getElementById('bg-video-'+videoIndex);
var videoIndex=event.target.dataset.id;if(document.getElementById('bg-video-'+videoIndex).paused||document.getElementById('bg-video-'+videoIndex).ended){if(this.state.seekValue>0){document.getElementById('bg-video-'+videoIndex).currentTime=this.state.seekValue;}else{document.getElementById('bg-video-'+videoIndex).currentTime=this.props.project.getIn(['scenes',this.state.currentSceneNumber,"workspaceBG","videoStart"]);}document.getElementById('bg-video-'+videoIndex).play();this.setState({isFullScrVideoplay:true});}else{document.getElementById('bg-video-'+videoIndex).pause();this.setState({isFullScrVideoplay:false});}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-playPausevideo");}}},{key:'videoTimeUpdate',value:function videoTimeUpdate(e){try{var videoIndex=this.state.currentSceneNumber;var currentTime=e.target.currentTime;if(currentTime>=this.props.project.getIn(['scenes',this.state.currentSceneNumber,'workspaceBG','videoEnd'])&&e.target.dataset.id===this.state.currentSceneNumber){this.setState({isFullScrVideoplay:false});}if(e.target.dataset.id!==videoIndex){currentTime=0;}this.setState({seekValue:currentTime});}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-videoTimeUpdate");}}},{key:'changeVideoTime',value:function changeVideoTime(e){try{var currentTime=e.target.value;var videoIndex=this.state.currentSceneNumber;if(this.props.project.getIn(['scenes',this.state.currentSceneNumber,"workspaceBG","videoStart"])&&currentTime<this.props.project.getIn(['scenes',this.state.currentSceneNumber,"workspaceBG","videoStart"])){currentTime=this.props.project.getIn(['scenes',this.state.currentSceneNumber,"workspaceBG","videoStart"]);e.target.currentTime=currentTime;document.getElementById("bg-video-"+videoIndex).pause();}if(this.props.project.getIn(['scenes',this.state.currentSceneNumber,"workspaceBG","videoEnd"])&&currentTime>=this.props.project.getIn(['scenes',this.state.currentSceneNumber,"workspaceBG","videoEnd"])){currentTime=this.props.project.getIn(['scenes',this.state.currentSceneNumber,"workspaceBG","videoStart"])?this.props.project.getIn(['scenes',this.state.currentSceneNumber,"workspaceBG","videoStart"]):0;e.target.currentTime=currentTime;document.getElementById("bg-video-"+videoIndex).pause();}document.getElementById("bg-video-"+videoIndex).currentTime=currentTime;this.setState({seekValue:currentTime});}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-changeVideoTime");}}},{key:'videoLoaded',value:function videoLoaded(e){try{var videoIndex=this.state.currentSceneNumber;if(this.props.sceneData.getIn(["workspaceBG","videoStart"]))document.getElementById("bg-video-"+videoIndex).currentTime=this.props.sceneData.getIn(["workspaceBG","videoStart"]);if(this.props.sceneData.getIn(["workspaceBG","volume"]))document.getElementById("bg-video-"+videoIndex).volume=this.props.sceneData.getIn(["workspaceBG","volume"])/100;}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-videoLoaded");}}},{key:'secondsToHms',value:function secondsToHms(d){d=Number(d);var m=Math.floor(d%3600/60);var s=Math.floor(d%3600%60);var mDisplay=m>0?m+(m===1?"":""):"";var sDisplay=s>0?s+(s===1?"":""):"";if(sDisplay!==null&&sDisplay.length>=1){sDisplay=sDisplay.length>1?sDisplay:'0'+sDisplay;}else{sDisplay='00';}if(mDisplay!==null&&mDisplay!==""){mDisplay=mDisplay.length>1?mDisplay:'0'+mDisplay;}else{mDisplay='00';}return mDisplay+':'+sDisplay;}},{key:'seekOver',value:function seekOver(e,min,max){try{if(e!=="out"){var cont=document.getElementsByClassName("seek-container")[0].getBoundingClientRect();var contX=e.clientX-cont.x-10;var contW=cont.width-20;if(contX>=0&&contX<=contW){var currentTime=contX/contW*(max-min);this.setState({seekTime:this.secondsToHms(currentTime),seekX:contX-10});}else{this.setState({seekTime:null,seekX:null});}}else{this.setState({seekTime:null,seekX:null});}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-seekOver");}}},{key:'runTheLIst',value:function runTheLIst(){var _this35=this;var workspaceObjects=[],workspaceScale=this.props.zoomFactor;var workspaceDisplay=null;if(this.props.sceneData!==undefined&&this.props.sceneData.size>0){var sceneData=this.props.sceneData,bgStyles={},bgItems=[],bgColors=[],onLoadBg=null,bgImgStyles={},configBasePath=null;var workspaceWidth=this.props.workspaceWidth*workspaceScale,workspaceHeight=this.props.workspaceHeight*workspaceScale;bgStyles={position:"absolute",width:workspaceWidth+'px',height:workspaceHeight+'px',overflow:'hidden'};var workspaceBG=sceneData.get("workspaceBG");bgStyles.backgroundColor=sceneData.getIn(["workspaceBG","color"]);bgItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'color',className:'bg-container',style:bgStyles}));var sceneData=this.props.sceneData,bgStyles={},bgItems=[],onLoadBg=null,bgImgStyles={},configBasePath=null;var workspaceWidth=this.props.workspaceWidth*workspaceScale,workspaceHeight=this.props.workspaceHeight*workspaceScale;var workspaceCX=this.props.workspaceBounds.get("cx"),workspaceCY=this.props.workspaceBounds.get("cy");if(workspaceCX===undefined){workspaceCX=window.innerWidth/2;workspaceCY=window.innerHeight/2;}this.workspaceX=workspaceCX-workspaceWidth/2;this.workspaceY=workspaceCY-workspaceHeight/2;var svgFilters=[];bgStyles={position:"absolute",width:workspaceWidth.toFixed(2)+'px',height:workspaceHeight.toFixed(2)+'px',overflow:'hidden'};if(workspaceBG!==undefined){bgColors=this.workspaceBGColorAssembler(workspaceBG,bgStyles);if(workspaceBG.get("src")!==undefined&&workspaceBG.get("src")!==null&&workspaceBG.get("src")!==""){var mediaBgStyles={};mediaBgStyles.position="absolute";mediaBgStyles.overflow="hidden";mediaBgStyles.width=(this.props.workspaceWidth*this.props.zoomFactor).toFixed(2)+"px";mediaBgStyles.height=(this.props.workspaceHeight*this.props.zoomFactor).toFixed(2)+"px";var flip=getFlipPosition(workspaceBG.get("flipPosition"),workspaceBG.get("angle"));var bgAngle=workspaceBG.get("angle")!==undefined?workspaceBG.get("angle"):0;var _bgImgStyles={willChange:"transform, opacity",width:(this.props.workspaceWidth*workspaceBG.get("width")*workspaceScale).toFixed(2)+'px',height:(this.props.workspaceHeight*workspaceBG.get("height")*workspaceScale).toFixed(2)+'px',transform:'translate('+(this.props.workspaceWidth*workspaceBG.get("x")*workspaceScale).toFixed(2)+'px, '+(this.props.workspaceHeight*workspaceBG.get("y")*workspaceScale).toFixed(2)+'px) rotate('+bgAngle+'deg)'+flip};var bgType=workspaceBG.get("type"||bgType==="PEXELS"||bgType==="PIXABAY"||bgType==="UNSPLASH"||bgType==="IMAGE");if(bgType==="STOCKIMG"){onLoadBg=workspaceBG.get('thumbnail');configBasePath="";}else if(bgType!=="UPLOADS"){if(bgType==='UPVIDEO'){var typrToSet='UPLOADS';onLoadBg=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[typrToSet][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[typrToSet].onload_UPVIDEO]+workspaceBG.get('thumbnail');configBasePath=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[typrToSet][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[typrToSet].workspace_UPVIDEO];if(workspaceBG.get('isBlob')){configBasePath="";onLoadBg=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a['APPICONS'][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a['APPICONS']['current']]+'/images/chr-loading.svg';}}else if(bgType==='UPIMAGE'){var _typrToSet='UPLOADS';onLoadBg=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_typrToSet][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_typrToSet].onload_UPIMAGE]+workspaceBG.get('thumbnail');configBasePath=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_typrToSet][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_typrToSet].workspace_UPIMAGE];}else if(bgType==="BG"){onLoadBg=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[bgType][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[bgType].onload]+workspaceBG.get('thumbnail');configBasePath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[bgType][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[bgType].workspace];}else if(workspaceBG.get('subType')==='OBGIMG'||workspaceBG.get('subType')==='OBGVID'){onLoadBg=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a['BG']['obgsrc']+workspaceBG.get('src');if(workspaceBG.get('subType')==='OBGVID')onLoadBg=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a['BG']['obgsrc']+workspaceBG.get('thumbnail');configBasePath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["BG"]['obgsrc'];}else{onLoadBg=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[bgType][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[bgType].onload]+workspaceBG.get('thumbnail');configBasePath=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[bgType][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[bgType].workspace];}}else{onLoadBg=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[bgType][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[bgType].onload_IMG]+workspaceBG.get('thumbnail');configBasePath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[bgType][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[bgType].workspace_IMG];}var backgroundSource=configBasePath+workspaceBG.get('src');if(workspaceBG.get('isBlob')){backgroundSource=workspaceBG.get('src');}if(bgType==='UPVIDEO'){if(workspaceBG.get('displaysizes')){backgroundSource=backgroundSource.substr(0,backgroundSource.lastIndexOf("."))+".mp4";}}mediaBgStyles.backgroundRepeat='no-repeat';mediaBgStyles.backgroundPosition='center center';mediaBgStyles.backgroundSize='cover';mediaBgStyles.display='block';mediaBgStyles.filter="";// if(workspaceBG.get("bgFilter") !== undefined && workspaceBG.get("bgFilter") !== ""){
// mediaBgStyles.filter = "brightness(" + (parseInt(workspaceBG.get("bgFilter").substr(2,2),16)) + "%) contrast(" + (parseInt(workspaceBG.get("bgFilter").substr(4,2),16)) + "%) hue-rotate(" + parseInt(workspaceBG.get("bgFilter").substr(6,3),16) + "deg) blur(" + parseInt(workspaceBG.get("bgFilter").substr(14,2),16) + "px) saturate(" + (parseInt(workspaceBG.get("bgFilter").substr(9,2),16)) + "%";
var vignetteItemId="ws-vignette-"+this.props.selectedScene;svgFilters.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'image-filter',id:'svgFilter_'+sceneData.get("id"),key:"vignette-"+this.props.selectedScene,style:this.props.browserName.get(1)==="Firefox"?{width:"0",height:"0",display:"block"}:{display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('filter',{colorInterpolationFilters:'sRGB',id:"filter_"+sceneData.get("id")+"_"+workspaceBG.get("bgFilter")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__ReturnSvgFilter__["a" /* ReturnSvgFilter */],{'data-id':this.props.sceneData.get("id"),filterCode:workspaceBG.get("bgFilter")===""?"6464646464640032":workspaceBG.get("bgFilter"),vignetteId:vignetteItemId})))));// }
if(this.props.isBgCropping)mediaBgStyles.display="none";if(this.props.isToolCropping)mediaBgStyles.overflow="unset";var isVideo=workspaceBG.get("type")==="VIDEO"||workspaceBG.get("type")==="STOCKVID"||workspaceBG.get("type")==="UPVIDEO"||workspaceBG.get("type")==="ZOOM";if(!isVideo){var bgSource=void 0;if(workspaceBG.get("type")==="BG"&&workspaceBG.get('subType')!=='OBGIMG'){var _React$createElement6;bgSource=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomBGRender,(_React$createElement6={key:workspaceBG.get("assetId")+workspaceBG.get("bgFilter"),completeWorkspaceItems:sceneData,assetType:'BG',proxyImg:onLoadBg,data_id:"scenebg"+this.props.selectedScene,bgImgStyles:Object.assign({},_bgImgStyles,{filter:workspaceBG.get("bgFilter")||workspaceBG.get("bgFilter")!==""?'url(#filter_'+sceneData.get("id")+'_'+workspaceBG.get("bgFilter")+')':null}),isPlay:this.props.isPlay,isPlayAll:this.props.isPlayAll},_defineProperty(_React$createElement6,'key',key),_defineProperty(_React$createElement6,'src',backgroundSource),_defineProperty(_React$createElement6,'colors',workspaceBG.get("bgColor")),_defineProperty(_React$createElement6,'hasGradient',workspaceBG.get("hasGradient")),_React$createElement6));bgItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"bg-img-"+workspaceBG.get("assetId"),className:'bg-container tintCls',style:mediaBgStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:"ws-vignette-"+this.props.selectedScene,className:'vignette'}),bgSource));}else{bgSource=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__containers_ProgressiveImage__["a" /* default */],{src:backgroundSource,placeholder:onLoadBg},function(image){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'bg',className:'bg-image',key:workspaceBG.get('src'),src:image,style:Object.assign({},_bgImgStyles,{filter:workspaceBG.get("bgFilter")||workspaceBG.get("bgFilter")!==""?'url(#filter_'+sceneData.get("id")+'_'+workspaceBG.get("bgFilter")+')':null})});});bgItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"bg-img-"+workspaceBG.get("assetId"),className:'bg-container tintCls',style:mediaBgStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:"ws-vignette-"+this.props.selectedScene,className:'vignette'}),' ',bgSource));}var bgPreview=document.getElementById('bgWrkspcPreview');if(bgPreview)bgPreview.style.display='none';}else{_bgImgStyles.position="absolute";var _bgSource=void 0;_bgSource=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{key:"bg-img-"+workspaceBG.get("assetId"),preload:'auto',id:"workspacebg"+this.props.selectedScene,className:"bg-video "+workspaceBG.get('type'),style:Object.assign({},_bgImgStyles,{filter:workspaceBG.get("bgFilter")||workspaceBG.get("bgFilter")!==""?'url(#filter_'+sceneData.get("id")+'_'+workspaceBG.get("bgFilter")+')':null}),poster:onLoadBg,src:backgroundSource,onMouseDown:function onMouseDown(e){_this35.enableBgSettings(e);}});bgItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"bg-img-"+workspaceBG.get("assetId"),className:'video-container tintCls bg-video-index',style:mediaBgStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{pointerEvents:'auto'},id:"ws-vignette-"+this.props.selectedScene,className:'vignette'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'bg',className:'bg-image',src:onLoadBg,style:Object.assign({},_bgImgStyles,{filter:workspaceBG.get("bgFilter")||workspaceBG.get("bgFilter")!==""?'url(#filter_'+sceneData.get("id")+'_'+workspaceBG.get("bgFilter")+')':null})}),_bgSource));}}}var workspaceItems=[],workspaceChildren=[],scenes=[],playAllScene=[],transitions=[];if(this.props.isPlayAll){var _loop=function _loop(){var sceneData=_this35.props.scenes.get(j);workspaceItems=sceneData.get("workspaceItems");workspaceChildren=sceneData.get("workspaceChildren");var workspaceBG=sceneData.get("workspaceBG");bgColors=[];bgStyles={position:"absolute",width:workspaceWidth+'px',height:workspaceHeight+'px',overflow:'hidden'};bgItems=[];workspaceBG=sceneData.get("workspaceBG");if(workspaceBG!==undefined){bgColors=_this35.workspaceBGColorAssembler(workspaceBG,bgStyles);if(workspaceBG.get("src")!==undefined&&workspaceBG.get("src")!==null&&workspaceBG.get("src")!==""){var _mediaBgStyles={};_mediaBgStyles.position="absolute";_mediaBgStyles.overflow="hidden";_mediaBgStyles.width=_this35.props.workspaceWidth*_this35.props.zoomFactor+"px";_mediaBgStyles.height=_this35.props.workspaceHeight*_this35.props.zoomFactor+"px";flip=getFlipPosition(workspaceBG.get("flipPosition"),workspaceBG.get("angle"));bgAngle=workspaceBG.get("angle")!==undefined?workspaceBG.get("angle"):0;var _bgImgStyles2={width:_this35.props.workspaceWidth*workspaceBG.get("width")*workspaceScale+'px',height:_this35.props.workspaceHeight*workspaceBG.get("height")*workspaceScale+'px',transform:'translate('+_this35.props.workspaceWidth*workspaceBG.get("x")*workspaceScale+'px, '+_this35.props.workspaceHeight*workspaceBG.get("y")*workspaceScale+'px) rotate('+bgAngle+'deg)'+flip};if(_this35.props.workspaceHeight*workspaceScale>_this35.props.workspaceBounds.get("height")){_bgImgStyles2.height=_this35.props.workspaceBounds.get("height")*workspaceBG.get("height")+"px";}if(_this35.props.workspaceWidth*workspaceScale>_this35.props.workspaceBounds.get("width")){_bgImgStyles2.width=_this35.props.workspaceBounds.get("width")*workspaceBG.get("width")+"px";}if(_this35.props.isPlay||_this35.props.isPlayAll)_mediaBgStyles.opacity=1;{var _bgType=workspaceBG.get("type");if(_bgType==="STOCKIMG"||_bgType==="PEXELS"||_bgType==="PIXABAY"||_bgType==="UNSPLASH"){onLoadBg=workspaceBG.get('thumbnail');configBasePath="";}else if(_bgType!=="UPLOADS"){if(_bgType==='UPVIDEO'){var _typrToSet2='UPLOADS';onLoadBg=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_typrToSet2][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_typrToSet2].onload_UPVIDEO]+workspaceBG.get('thumbnail');configBasePath=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_typrToSet2][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_typrToSet2].workspace_UPVIDEO];if(workspaceBG.get('isBlob')){onLoadBg=workspaceBG.get('thumbnail');configBasePath="";}}else if(_bgType==='UPIMAGE'){var _typrToSet3='UPLOADS';onLoadBg=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_typrToSet3][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_typrToSet3].onload_UPIMAGE]+workspaceBG.get('thumbnail');configBasePath=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_typrToSet3][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_typrToSet3].workspace_UPIMAGE];}else if(_bgType==="BG"){onLoadBg=_this35.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_bgType][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_bgType].onload]+workspaceBG.get('thumbnail');configBasePath=_this35.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_bgType][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_bgType].workspace];}else if(workspaceBG.get('subType')==='OBGIMG'||workspaceBG.get('subType')==='OBGVID'){onLoadBg=_this35.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a['BG']['obgsrc']+workspaceBG.get('src');configBasePath=_this35.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["BG"]['obgsrc'];}else{onLoadBg=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_bgType][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_bgType].onload]+workspaceBG.get('thumbnail');configBasePath=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_bgType][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_bgType].workspace];}}else{onLoadBg=_this35.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_bgType][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_bgType].onload_IMG]+workspaceBG.get('thumbnail');configBasePath=_this35.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_bgType][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a[_bgType].workspace_IMG];}var _backgroundSource=configBasePath+workspaceBG.get('src');if(_bgType==='UPVIDEO'){if(workspaceBG.get('displaysizes')){_backgroundSource=_backgroundSource.substr(0,_backgroundSource.lastIndexOf("."))+".mp4";}}_mediaBgStyles.backgroundRepeat='no-repeat';_mediaBgStyles.backgroundPosition='center center';_mediaBgStyles.backgroundSize='cover';_mediaBgStyles.filter="";var _svgFilters=null;if(workspaceBG.get("bgFilter")!==undefined&&workspaceBG.get("bgFilter")!==""){var _vignetteItemId2="ws-vignette-"+j;_svgFilters=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'image-filter',id:'svgFilter_'+sceneData.get("id"),key:"vignette-"+j,style:_this35.props.browserName.get(1)==="Firefox"?{width:"0",height:"0",display:"block"}:{display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('filter',{colorInterpolationFilters:'sRGB',id:"filter_"+sceneData.get("id")+"_"+workspaceBG.get("bgFilter")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__ReturnSvgFilter__["a" /* ReturnSvgFilter */],{'data-id':j,filterCode:workspaceBG.get("bgFilter")===""?"6464646464640032":workspaceBG.get("bgFilter"),vignetteId:_vignetteItemId2}))));}var _isVideo=workspaceBG.get("type")==="VIDEO"||workspaceBG.get("type")==="STOCKVID"||workspaceBG.get("type")==="UPVIDEO"||workspaceBG.get("type")==="ZOOM";if(!_isVideo){var _bgSource2=workspaceBG.get("type")==="BG"&&workspaceBG.get('subType')!=="OBGIMG"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomBGRender,{completeWorkspaceItems:sceneData,assetType:'BG',data_id:"scenebg"+_this35.props.selectedScene,bgImgStyles:Object.assign({},_bgImgStyles2,{filter:workspaceBG.get("bgFilter")||workspaceBG.get("bgFilter")!==""?'url(#filter_'+sceneData.get("id")+'_'+workspaceBG.get("bgFilter")+')':null}),isPlay:_this35.props.isPlay,isPlayAll:_this35.props.isPlayAll,key:key,src:_backgroundSource,colors:workspaceBG.get("bgColor"),hasGradient:workspaceBG.get("hasGradient")}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__containers_ProgressiveImage__["a" /* default */],{src:_backgroundSource,placeholder:onLoadBg},function(image){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'bg',className:'bg-image',key:workspaceBG.get('src'),src:image,style:Object.assign({},_bgImgStyles2,{filter:workspaceBG.get("bgFilter")||workspaceBG.get("bgFilter")!==""?'url(#filter_'+sceneData.get("id")+'_'+workspaceBG.get("bgFilter")+')':null})});});bgItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:workspaceBG.get('src'),className:'bg-container tintCls',style:_mediaBgStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:"ws-vignette-"+_this35.props.selectedScene,className:'vignette'}),_svgFilters,_bgSource2));}else{var _bgSource3=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{preload:'auto',id:"bg-video-"+j,'data-id':j,className:"bg-video "+workspaceBG.get('type'),style:Object.assign({},_bgImgStyles2,{filter:workspaceBG.get("bgFilter")||workspaceBG.get("bgFilter")!==""?'url(#filter_'+sceneData.get("id")+'_'+workspaceBG.get("bgFilter")+')':null}),poster:onLoadBg,src:_backgroundSource,onPlay:_this35.controlVideo,onTimeUpdate:_this35.videoTimeUpdate});bgItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:workspaceBG.get("isBlob")?"blob":workspaceBG.get('src'),className:'video-container tintCls',style:_mediaBgStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:"ws-vignette-"+_this35.props.selectedScene,className:'vignette'}),_svgFilters,_bgSource3));}}}}workspaceObjects=_this35.workspaceItemsAssembler(workspaceItems,workspaceChildren,workspaceScale,sceneData);var playControl=null,seekBar=null;var videoControls=[];if(sceneData.getIn(['workspaceBG','type'])==="VIDEO"||sceneData.getIn(['workspaceBG','type'])==="STOCKVID"||sceneData.getIn(['workspaceBG','type'])==="UPVIDEO"||sceneData.getIn(['workspaceBG','type'])==="ZOOM"){// playControl = <img key="video-tool-play" id={'video-tool-play'+j} data-id={j} className = {"video-tool-play"} style = {{opacity :'1',pointerEvents:'auto'}} onMouseMove={(e)=>{clearInterval(this.videoFullscreenTimer)}} onMouseOver={(e) => {e.stopPropagation();}} 
// onClick = {this.playPausevideo.bind(this)} alt = "play-control"  src = {this.appUrl + "/images/player_2_0/scene-"+ (this.state.isFullScrVideoplay ? "pause" : "play") +".svg"} />;
// seekBar = <div key="video-tool-seek" id={'video-tool-seek'+j} className = {"seek-container"} style = {{opacity :'1',pointerEvents:'auto'}} onClick = {(e) => {e.stopPropagation(); }}  onMouseMoveCapture = {(e) => {e.stopPropagation();this.seekOver(e, sceneData.getIn(["workspaceBG", "videoStart"])?sceneData.getIn(["workspaceBG", "videoStart"]):0, sceneData.getIn(["workspaceBG", "videoEnd"])?sceneData.getIn(["workspaceBG", "videoEnd"]):sceneData.getIn(["workspaceBG", "duration"]))}} onMouseOutCapture ={(e)=>{e.stopPropagation();this.seekOver("out")}} onMouseMove={(e)=>{clearInterval(this.videoFullscreenTimer)}} onMouseDown = {(e) => {e.stopPropagation()}} ><input id="seek-bar" type="range" step="any" min={sceneData.getIn(["workspaceBG", "videoStart"])?sceneData.getIn(["workspaceBG", "videoStart"]):0} defaultValue = {sceneData.getIn(["workspaceBG", "videoStart"])?sceneData.getIn(["workspaceBG", "videoStart"]):0} value = {this.state.seekValue} max={sceneData.getIn(["workspaceBG", "videoEnd"])?sceneData.getIn(["workspaceBG", "videoEnd"]):sceneData.getIn(["workspaceBG", "duration"])} onChange ={this.changeVideoTime}  onMouseMove={(e)=>{e.stopPropagation()}}></input>{this.state.seekTime !== null?<div style={{left : this.state.seekX +"px"}} className = "seek-time">{this.state.seekTime}</div>:null}</div>
videoControls=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-id':j,id:'video-controls-'+j,style:{width:"100%",height:"100%"},onMouseMove:function onMouseMove(e){if(_this35.state.currentSceneNumber!==e.target.dataset.id)_this35.setState({currentSceneNumber:e.target.dataset.id});},onMouseOver:function onMouseOver(e){_this35.handleFullScreenMouseOver(e);},onMouseOut:function onMouseOut(e){_this35.handleFullScreenMouseOut(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:'video-tool-play',id:'video-tool-play'+j,'data-id':j,className:"video-tool-play",style:{opacity:'1',pointerEvents:'auto'},onMouseMove:function onMouseMove(e){clearInterval(_this35.videoFullscreenTimer);},onClick:_this35.playPausevideo.bind(_this35),alt:'play-control',src:_this35.appUrl+"/images/player_2_0/scene-"+(_this35.state.isFullScrVideoplay?"pause":"play")+".svg"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'video-tool-seek',id:'video-tool-seek'+j,className:"seek-container",style:{opacity:'1',pointerEvents:'auto'},onClick:function onClick(e){e.stopPropagation();},onMouseMoveCapture:function onMouseMoveCapture(e){e.stopPropagation();_this35.seekOver(e,sceneData.getIn(["workspaceBG","videoStart"])?sceneData.getIn(["workspaceBG","videoStart"]):0,sceneData.getIn(["workspaceBG","videoEnd"])?sceneData.getIn(["workspaceBG","videoEnd"]):sceneData.getIn(["workspaceBG","duration"]));},onMouseOutCapture:function onMouseOutCapture(e){e.stopPropagation();_this35.seekOver("out");},onMouseMove:function onMouseMove(e){clearInterval(_this35.videoFullscreenTimer);},onMouseDown:function onMouseDown(e){e.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'seek-bar',type:'range',step:'any',min:sceneData.getIn(["workspaceBG","videoStart"])?sceneData.getIn(["workspaceBG","videoStart"]):0,defaultValue:sceneData.getIn(["workspaceBG","videoStart"])?sceneData.getIn(["workspaceBG","videoStart"]):0,value:_this35.state.seekValue,max:sceneData.getIn(["workspaceBG","videoEnd"])?sceneData.getIn(["workspaceBG","videoEnd"]):sceneData.getIn(["workspaceBG","duration"]),onChange:_this35.changeVideoTime,onMouseMove:function onMouseMove(e){e.stopPropagation();}}),_this35.state.seekTime!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{left:_this35.state.seekX+"px"},className:'seek-time'},_this35.state.seekTime):null));}scenes.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:"scene"+j,key:"scene"+j,style:{width:"100%",height:"100%",position:"absolute",overflow:"hidden"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scenes pointer-events-none'},bgColors,bgItems,workspaceObjects[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'svg-filters pointer-events-none',style:_this35.props.browserName.get(1)==="Firefox"?{width:"0",height:"0",display:"block"}:{display:"none"}},workspaceObjects[1]),videoControls));item=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({"angle":0,"animdata":sceneData.get("transEffect")+".json",//"scene-transition1.json",
"assetId":"scenetransition"+j,"colors":sceneData.get("transColor")?sceneData.get("transColor"):{},"defaultColor":{},"enterEffectName":"no_Effect","enterEnd":0,"enterStart":sceneData.get("startTime")+sceneData.get("duration"),"expression":"happy","src":sceneData.get("transEffect")+".svg",//"scene-transition1.svg",
"flipPosition":0,"height":_this35.props.workspaceHeight,"index":0,"thumb":"","type":"SCREEN","voiceOver":{},"width":_this35.props.workspaceWidth,"x":0,"y":0});item_styles={willChange:"transform, opacity",transform:"translate("+parseFloat((item.get("x")*workspaceScale).toFixed(2))+"px, "+parseFloat((item.get("y")*workspaceScale).toFixed(2))+"px)",position:"absolute",width:parseFloat((item.get("width")*workspaceScale).toFixed(2)),height:parseFloat((item.get("height")*workspaceScale).toFixed(2)),visibility:'hidden',pointerEvents:'none'};if(sceneData.get("transEffect")&&sceneData.get("transEffect").indexOf("tr-")!==-1)transitions.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"scenetransition"+j,id:"scenetransition"+j,'data-id':"scenetransition"+j,className:"scene-item type-"+"screen"+" tintCls",style:item_styles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomSVGRender,{scenStart:sceneData.get("startTime"),uploadSVG:false,workspaceWidth:_this35.props.workspaceWidth,workspaceHeight:_this35.props.workspaceHeight,animakerType:_this35.props.animakerType,parentItem:null,completeWorkspaceItems:item,startPlay:_this35.props.startPlay,addTween:_this35.props.addTween,workspaceItems:_this35.props.sceneData.get("workspaceItems"),changePlayTime:_this35.props.changePlayTime,playHeadValue:_this35.props.playHeadValue,pose:item.get("pose"),expression:item.get("expression"),zoomFactor:_this35.props.zoomFactor,assetType:item.get("type"),data_id:"scenetransition"+j,isPlay:_this35.props.isPlay,isPlayAll:_this35.props.isPlayAll,key:"scenetransition"+j,selectedItems:_this35.props.selectedItems,src:_this35.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["SCREEN"]["src"]+(_this35.props.workspaceWidth>_this35.props.workspaceHeight?"horizontal":_this35.props.workspaceHeight>_this35.props.workspaceWidth?"vertical":"square")+"/"+item.get("src"),colors:item.get("colors"),parts:item.get("parts"),animdata:item.get("animdata"),swapDetails:_this35.props.swapDetails,animsrc:item.get("animsrc"),expFlag:item.get("expFlag"),isRepeated:item.get("isRepeated"),isAnimated:item.get("isAnimated"),repeatLoop:item.get("repeatLoop"),mouthAction:item.get("mouthAction"),socket:_this35.props.socket,updateItem:_this35.props.updateItem,selectedScene:_this35.props.selectedScene})));};for(var j=this.props.scenes.size-1;j>=0;j--){var workspaceBG;var flip;var bgAngle;var item;var item_styles;_loop();}playAllScene.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'player-main',style:{width:"100%",height:"100%",position:"relative"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'video-container',style:{width:"100%",height:"100%",position:"absolute",overflow:"hidden"}}),scenes,transitions));}else{workspaceItems=this.props.sceneData.get("workspaceItems");workspaceChildren=this.props.sceneData.get("workspaceChildren");this.collaborativeUsers=[];workspaceObjects=this.workspaceItemsAssembler(workspaceItems,workspaceChildren,workspaceScale,sceneData);}var transformManagers=[];if(!this.props.isCropping&&(!this.props.isBgCropping||this.props.isToolCropping)&&!this.props.isFraming&&!this.props.isVideoCropping&&!this.props.isPlayAll&&!this.props.isPlay){if(this.props.selectedItems.size>0||this.props.selectedCamera!==""||this.props.isToolCropping){var selectedObjects=this.props.selectedItems.size>0?this.props.sceneData.get("workspaceItems").filter(function(obj,key){return this.props.selectedItems.keyOf(key)!==undefined;}.bind(this)):this.props.selectedCamera!==""?this.props.sceneData.get("workspaceCameras").filter(function(obj,key){return this.props.selectedCamera===key;}.bind(this)):null;if(this.props.isToolCropping){var workspaceBg=this.props.sceneData.get("workspaceBG");var croppedBg={x:workspaceBg.get("x")*this.props.workspaceWidth,y:workspaceBg.get("y")*this.props.workspaceHeight,width:workspaceBg.get("width")*this.props.workspaceWidth,height:workspaceBg.get("height")*this.props.workspaceHeight,angle:workspaceBg.get("angle"),flipPosition:workspaceBg.get("flipPosition")};selectedObjects=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({"workspacebg0":croppedBg});}transformManagers.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__containers_TransformManager__["a" /* default */],{key:0,socket:this.props.socket,cornerResize:true,lockTransform:this.props.swapDetails!==null?true:false,moveItem:this.moveSelection,initiateResize:this.initiateResize,resizeSelection:this.resizeSelection,stopResize:this.stopResize,initiateRotate:this.initiateRotate,rotateSelection:this.rotateSelection,stopRotate:this.stopRotate,shortcutName:this.props.shortcutName,selectedObjects:selectedObjects}));}}var cameraItems=[];if(this.props.selectedCamera!==undefined&&this.props.selectedCamera!==""){var key=this.props.selectedCamera;var cameraItem=sceneData.getIn(["workspaceCameras",key]);var cameraStyles={transform:"translate("+cameraItem.get("x")*workspaceScale+"px, "+cameraItem.get("y")*workspaceScale+"px)",position:"absolute",width:cameraItem.get("width")*workspaceScale,height:cameraItem.get("height")*workspaceScale,opacity:"0.4"};cameraItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key,id:key,'data-id':key,className:"scene-item type-"+cameraItem.get("type").toLowerCase(),style:cameraStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'scene-items',className:'scene-item-inner camera',src:this.appUrl+"/images/camera-focus.png",'data-id':key})));}var indexElement=null,selectedItem=this.props.sceneData.getIn(["workspaceItems",this.props.selectedItems.get(0)]);if(this.state.contextMenu===true){var indexItems=[];if(this.props.selectedItems.size===1){var currentItem=sceneData.getIn(["workspaceItems",this.props.selectedItems.get(0)]);var currentIndex=currentItem.get("index");var itemsSize=sceneData.get("workspaceItems").size;indexItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:itemsSize>1&&currentIndex<itemsSize-1?'options':'options disabled',onClick:function onClick(e){return _this35.props.setZIndex({to:"front",selectedScene:_this35.props.selectedScene,selectedItem:_this35.props.selectedItems.get(0)},_this35.props.socket);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'br.to.fr'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:itemsSize>1&&currentIndex>0?'options':'options disabled',onClick:function onClick(e){return _this35.props.setZIndex({to:"back",selectedScene:_this35.props.selectedScene,selectedItem:_this35.props.selectedItems.get(0)},_this35.props.socket);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'mo.to.bc'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:itemsSize>1&&currentIndex!==itemsSize-1?'options':'options disabled',onClick:function onClick(e){return _this35.props.setZIndex({to:"first",selectedScene:_this35.props.selectedScene,selectedItem:_this35.props.selectedItems.get(0)},_this35.props.socket);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'br.to.fi'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:itemsSize>1&&currentIndex!==0?'options':'options disabled',onClick:function onClick(e){return _this35.props.setZIndex({to:"last",selectedScene:_this35.props.selectedScene,selectedItem:_this35.props.selectedItems.get(0)},_this35.props.socket);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'mo.to.la'}))));}indexElement=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(_ref27){_this35.contextMenu=_ref27;},className:'contextMenu context-tool-bar unselectable'},indexItems,this.props.selectedItems.size===1&&(currentItem.get("type")==="IMG"||currentItem.get("type")==="STOCKIMG"||currentItem.get("type")==="UPLOADS")?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:1,className:'options',onClick:this.setAsBg.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'s.a.bg'})):null,!this.props.textStatus.get("isFocused")&&this.state.isContextBg!==true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'options',onClick:function onClick(e){return _this35.handleShortcuts("COPY_ITEM","btnClick");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'r.c.co'})):null,this.props.copiedItem!==null&&(this.props.copiedItem.dataType==="ITEMS"||this.props.copiedItem.dataType==="SCENES")?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'options',onMouseDown:function onMouseDown(e){return _this35.pasteItem(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'r.c.pa'})):null,this.state.isContextBg===true&&this.props.sceneData.getIn(["workspaceBG","src"])!==""&&(this.props.sceneData.getIn(["workspaceBG","type"])==="IMG"||this.props.sceneData.getIn(["workspaceBG","type"])==="STOCKIMG"||this.props.sceneData.getIn(["workspaceBG","type"])==="UPLOADS")?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'options',onMouseDown:function onMouseDown(e){return _this35.removeBG(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'re.f.bg'})):null,this.state.isContextBg!==true&&this.props.selectedItems.size>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'options',onClick:function onClick(e){return _this35.props.deleteItem({selectedItems:_this35.props.selectedItems.toArray(),selectedScene:_this35.props.selectedScene},_this35.props.socket);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'r.c.de'})):this.state.isContextBg===true&&this.props.sceneData.getIn(["workspaceBG","src"])!==""?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'options',onMouseDown:function onMouseDown(e){return _this35.handleBgDelete(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'r.c.de'})):null);}if(this.props.isPlayAll){workspaceBG.get("type")==="VIDEO"||workspaceBG.get("type")==="STOCKVID"||workspaceBG.get("type")==="UPVIDEO"||workspaceBG.get("type")==="ZOOM";workspaceDisplay=this.state.worksheet.map(function(each,i){return _this35.state.sceenPosition===i?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'workspace',key:i,className:'workspace work-list playing ',style:{left:_this35.workspaceX.toFixed(2)+"px",top:_this35.workspaceY.toFixed(2)+"px",width:workspaceWidth.toFixed(2)+"px",height:workspaceHeight.toFixed(2)+"px",overflow:"hidden"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'player-loader-img',alt:'loader',src:_this35.appUrl+"/images/chr-loading.svg",style:{width:"100%",height:"100%",objectFit:"scale-down"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__containers_Player__["a" /* default */],{changeVideoIndex:_this35.changeVideoIndex,userId:_this35.props.userId}),playAllScene)):null;});}else if(this.props.isPlay){var zoomFactorVal=this.getCurrentZoom(true);workspaceDisplay=this.state.worksheet.map(function(each,i){return _this35.state.sceenPosition===i?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('React-Fragment',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'workspace',key:i,className:'workspace work-list playing pointer-events-none',style:{left:_this35.workspaceX.toFixed(2)+"px",top:_this35.workspaceY.toFixed(2)+"px",width:workspaceWidth.toFixed(2)+"px",height:workspaceHeight.toFixed(2)+"px",overflow:"hidden"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'player-loader-img',alt:'loader',src:_this35.appUrl+"/images/chr-loading.svg",style:{width:"100%",height:"100%",objectFit:"scale-down"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__containers_Player__["a" /* default */],{zoomFactor:zoomFactorVal.scale,userId:_this35.props.userId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scenes'},bgColors,bgItems,svgFilters,workspaceObjects[0],transformManagers),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'svg-filters',style:_this35.props.browserName.get(1)==="Firefox"?{width:"0",height:"0",display:"block"}:{display:"none"}},workspaceObjects[1]))):null;});}else{var transitionPreview=null;var sceneStyle={left:0,top:0,position:"absolute",width:(this.props.workspaceWidth*this.props.zoomFactor).toFixed(2)+"px",height:(this.props.workspaceHeight*this.props.zoomFactor).toFixed(2)+"px"};if(Math.round(this.props.workspaceWidth*this.props.zoomFactor)>this.props.workspaceBounds.get("width")){sceneStyle.overflow="hidden";}if(Math.round(this.props.workspaceHeight*this.props.zoomFactor)>this.props.workspaceBounds.get("height")){sceneStyle.overflow="hidden";}if(this.props.propertyWindow.get("component")==="transition"){transitionPreview=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TransitionPreview,{effect:this.props.sceneData.get("transEffect"),colors:this.props.sceneData.get("transColor"),width:this.props.workspaceWidth,height:this.props.workspaceHeight,zoomFactor:this.props.zoomFactor,browserName:this.props.browserName});}var playControl=null,seekBar=null;workspaceDisplay=this.state.worksheet.map(function(each,i){return _this35.state.sceenPosition===i?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:"workspaceDisplay"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"scenes pointer-events-none",id:'scene-one',style:sceneStyle},bgColors,bgItems,svgFilters,workspaceObjects[0],_this35.collaborativeUsers,cameraItems,transitionPreview),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"svg-filters pointer-events-none",style:_this35.props.browserName.get(1)==="Firefox"?{width:"0",height:"0",display:"block"}:{display:"none"}},workspaceObjects[1]),transformManagers,playControl,seekBar,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__["CSSTransition"],{'in':!_this35.props.showLibrary,timeout:500,classNames:'lib-add-btn',unmountOnExit:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lib-add'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:_this35.appUrl+"/images/lib-icons/lib-add.png",alt:'Continue',style:{width:"100%",height:"100%"},onClick:function onClick(e){return _this35.props.showLibraryTab(true);}}))),indexElement):null;});}}return workspaceDisplay;}},{key:'addTransition',value:function addTransition(){this.setState({addTransition:!this.state.addTransition});}},{key:'moveSelection',value:function moveSelection(x,y){var selectedItem=this.props.sceneData.getIn(["workspaceItems",this.props.selectedItems.get(0)]);var dX=selectedItem.get("x")-x,dY=selectedItem.get("y")-y,workspaceX=document.getElementById("workspace").offsetLeft,workspaceY=document.getElementById("workspace").offsetTop;}},{key:'initiateResize',value:function initiateResize(anchorBounds){this.multimoveSelection=anchorBounds;}},{key:'resizeSelection',value:function resizeSelection(x,y,width,height){var selectedItem=this.props.sceneData.getIn(["workspaceItems",this.props.selectedItems.get(0)]);var workspaceX=document.getElementById("workspace").offsetLeft,workspaceY=document.getElementById("workspace").offsetTop;}},{key:'stopResize',value:function stopResize(){this.multimoveSelection=null;}},{key:'initiateRotate',value:function initiateRotate(anchorAngles){this.anchorAngles=anchorAngles;}},{key:'rotateSelection',value:function rotateSelection(cx,cy,angle){var selectedItem=this.props.sceneData.getIn(["workspaceItems",this.props.selectedItems.get(0)]);var workspaceX=document.getElementById("workspace").offsetLeft,workspaceY=document.getElementById("workspace").offsetTop;}},{key:'stopRotate',value:function stopRotate(){this.anchorAngles=null;}},{key:'enableClick',value:function enableClick(selector){var elements=document.querySelectorAll(selector);for(var i=0;i<elements.length;i++){if(elements[i].className.indexOf("pointer-events-none")!==-1)elements[i].classList.remove("pointer-events-none");}}},{key:'disableClick',value:function disableClick(selector){var elements=document.querySelectorAll(selector);for(var i=0;i<elements.length;i++){if(elements[i].className.indexOf("pointer-events-none")===-1)elements[i].classList.add("pointer-events-none");}}},{key:'copyToClipboard',value:function copyToClipboard(string){if(window.clipboardData){window.clipboardData.setData('Text',string);}else{var aux=document.createElement("input");aux.style.top=0;aux.style.left=0;aux.style.position="absolute";aux.setAttribute("value",string);document.getElementById("root").appendChild(aux);aux.select();document.execCommand("copy",false,null);aux.remove();}}},{key:'isBase64',value:function isBase64(str){try{return btoa(unescape(encodeURIComponent(decodeURIComponent(escape(atob(str))))))===str;}catch(err){return false;}}},{key:'handlePaste',value:function handlePaste(e){try{var clipboardData,pastedData;e.stopPropagation();e.preventDefault();clipboardData=e.clipboardData||window.clipboardData;if(clipboardData&&clipboardData.getData('Text')!==""&&this.isBase64(clipboardData.getData('Text'))){pastedData=JSON.parse(decodeURIComponent(escape(atob(clipboardData.getData('Text')))));if((typeof pastedData==='undefined'?'undefined':_typeof(pastedData))==="object"&&pastedData.key!==undefined&&pastedData.key==="ANIMAKER_CLIPBOARD"){if(!this.props.updateItems){var isInProcess=__WEBPACK_IMPORTED_MODULE_20__helpers_utilityMethods__["a" /* canPaste */](pastedData,this.props.updateItems);if(isInProcess){this.props.manageToast({action:"add",type:"error","message":'ct.dup',formatId:"msg"});return;}}pastedData.selectedScene=this.props.selectedScene;this.props.pasteItems(pastedData,this.props.socket);}}e.target.remove();document.designMode="off";}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-handlePaste");}}},{key:'pasteFromClipboard',value:function pasteFromClipboard(){if(window.clipboardData){// var data = window.clipboardData.getData('Text');
}else{var aux=document.createElement("input");// aux.style.display = "none";
aux.style.top=0;aux.style.left=0;aux.style.position="absolute";aux.setAttribute("id","copytoclips");document.getElementById("root").appendChild(aux);aux.addEventListener('paste',this.handlePaste);// document.designMode = "on";
aux.focus();// document.execCommand("paste");
}}},{key:'cancelSwap',value:function cancelSwap(){try{this.props.undoProp.isBG===true?this.props.dropBG({selectedScene:this.props.selectedScene,value:this.props.undoProp,socket:this.props.socket,deleteId:'',deletedData:[],subType:"BG_SETTINGS"}):this.props.addObj(this.props.undoProp,this.props.socket);this.props.swapItem("");this.props.swapItemUndo("");document.getElementById("app-overlay").style.display="none";}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-cancelSwap");}}},{key:'applySwap',value:function applySwap(){try{var nextBtn=document.querySelector('.next_step');if(nextBtn){this.props.nextBtnClicked(true);nextBtn.classList.remove('disable');nextBtn.click();}if(this.props.swapDetails!==null){this.props.swapItem("");this.props.swapItemUndo("");document.getElementById("app-overlay").style.display="none";}else if(this.props.isToolCropping){this.props.toggleBgCrop();}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-applySwap");}}},{key:'handleShortcuts',value:function handleShortcuts(option,type){try{var project,a=0,copyChildren={},currentItem,currentIndex,itemsSize;this.ctrlPressed=false;if(!this.props.textStatus.get("isFocused"))this.enableClick(".selectionBox");if(this.props.selectedItems.size===1){currentItem=this.props.sceneData.getIn(["workspaceItems",this.props.selectedItems.get(0)]);currentIndex=currentItem.get("index");itemsSize=this.props.sceneData.get("workspaceItems").size;}// Verifying if any popup is opened or not....(BgVideo / LipSync / Audio / CreateFolder )
// if(this.props.commonPopup.get('show')){
//   option = 'STOP_SHORTCUTS';
// }
switch(option){case"SELECT_ALL_OBJECT":if(this.props.sceneData.get('workspaceItems').size>0){var item=[];this.props.sceneData.get("workspaceItems").entrySeq().forEach(function(_ref28){var _ref29=_slicedToArray(_ref28,2),key=_ref29[0],value=_ref29[1];item.push(key);});this.props.setSelectedItems({selectedItems:item},this.props.socket);}break;case"DESELECT_ALL_OBJECT":if(this.props.selectedItems.size>0){this.props.setSelectedItems({selectedItems:[]},this.props.socket);// this.props.suggestionPopup({
//   show : false,
//   type : '',
//   subType : ''
// })
}break;case"COPY_ITEM":if(type==="btnClick")this.setState({contextMenu:false});if(!this.props.textStatus.get("isFocused")){if(this.props.selectedItems.size>0){var copyItems=[];copyChildren={};for(a=0;a<this.props.selectedItems.size;a++){copyItems.push(this.props.sceneData.getIn(["workspaceItems",this.props.selectedItems.get(a)]).toJS());if(this.props.sceneData.getIn(["workspaceItems",this.props.selectedItems.get(a),"type"])==="TXTOVLY"||this.props.sceneData.getIn(["workspaceItems",this.props.selectedItems.get(a),"type"])==="GROUP"){this.props.sceneData.getIn(["workspaceItems",this.props.selectedItems.get(a),"groupChildren"]).map(function(item,index){copyChildren[item]=this.props.sceneData.getIn(["workspaceChildren",item]).toJS();}.bind(this));}}project={data:{workspaceChildren:copyChildren,workspaceItems:copyItems},dataType:"ITEMS",key:"ANIMAKER_CLIPBOARD"};var encoded=btoa(unescape(encodeURIComponent(JSON.stringify(project))));this.copyToClipboard(encoded);this.props.setCopyItemType(project);}else if(this.props.selectedMedias.size===0&&this.props.selectedCamera===""){var selectedScenes=this.props.selectedScenes.size>0?this.props.selectedScenes:[this.props.selectedScene];var scenes=this.props.scenes.filter(function(obj,key){return selectedScenes.indexOf(key)!==-1;}).toJS();project={data:scenes,width:this.props.workspaceWidth,height:this.props.workspaceHeight,dataType:"SCENES",key:"ANIMAKER_CLIPBOARD"};var _encoded=btoa(unescape(encodeURIComponent(JSON.stringify(project))));this.copyToClipboard(_encoded);this.props.setCopyItemType(project);}if(type==="btnClick"){this.props.copyObjects(false);this.setState({contextMenu:false});}}else if(type==="btnClick"){var textSelected=false;if(window.getSelection){textSelected=!(window.getSelection().focusOffset===window.getSelection().anchorOffset);}else if(document.getSelection){textSelected=!(document.getSelection().focusOffset===document.getSelection().anchorOffset);}else if(document.selection){textSelected=document.selection.createRange().text!=="";}if(textSelected)document.execCommand("copy");}break;case"CUT_ITEM":if(!this.props.textStatus.get("isFocused")){if(this.props.selectedItems.size>0){var cutItems=[],cutId=[];copyChildren={};for(a=0;a<this.props.selectedItems.size;a++){var cutTemp=this.props.selectedItems.get(a);cutItems.push(this.props.sceneData.getIn(["workspaceItems",cutTemp]).toJS());cutId.push(cutTemp);if(this.props.sceneData.getIn(["workspaceItems",this.props.selectedItems.get(a),"type"])==="TXTOVLY"||this.props.sceneData.getIn(["workspaceItems",this.props.selectedItems.get(a),"type"])==="GROUP"){this.props.sceneData.getIn(["workspaceItems",this.props.selectedItems.get(a),"groupChildren"]).map(function(item,index){copyChildren[item]=this.props.sceneData.getIn(["workspaceChildren",item]).toJS();}.bind(this));}}project={data:{workspaceChildren:copyChildren,workspaceItems:cutItems},dataType:"ITEMS",key:"ANIMAKER_CLIPBOARD"};var _encoded2=btoa(unescape(encodeURIComponent(JSON.stringify(project))));this.props.deleteItem({selectedItems:this.props.selectedItems.toArray(),selectedScene:this.props.selectedScene},this.props.socket);this.copyToClipboard(_encoded2);this.props.setCopyItemType(project);if(type==="btnClick")this.props.cutObjects(false);}}break;case"PASTE_ITEM":if(!this.props.textStatus.get("isFocused")){this.pasteFromClipboard();}else{document.execCommand("paste");}break;case"CTRL_PRESS":case"CTRL_PRESS_AGAIN":this.ctrlPressed=true;this.disableClick(".selectionBox");break;case"BRING_FRONT":case"BRING_FRONT_AGAIN":if(this.props.selectedItems.size===1&&currentIndex<itemsSize-1)this.props.setZIndex({to:"front",selectedScene:this.props.selectedScene,selectedItem:this.props.selectedItems.get(0)},this.props.socket);break;case"MOVE_BACK":case"MOVE_BACK_AGAIN":if(this.props.selectedItems.size===1&&currentIndex>0)this.props.setZIndex({to:"back",selectedScene:this.props.selectedScene,selectedItem:this.props.selectedItems.get(0)},this.props.socket);break;case"BRING_FIRST":if(this.props.selectedItems.size===1&&currentIndex!==itemsSize-1)this.props.setZIndex({to:"first",selectedScene:this.props.selectedScene,selectedItem:this.props.selectedItems.get(0)},this.props.socket);break;case"MOVE_LAST":if(this.props.selectedItems.size===1&&currentIndex!==0)this.props.setZIndex({to:"last",selectedScene:this.props.selectedScene,selectedItem:this.props.selectedItems.get(0)},this.props.socket);break;case"RIGHT_ARROW":if(this.props.selectedItems.size===0&&this.props.scenes.size-1>this.props.selectedScene&&this.state.active===this.props.selectedScene&&!this.rightKeyShortCut){this.rightKeyShortCut=true;this.moveRight('click');}break;case"LEFT_ARROW":if(this.props.selectedItems.size===0&&this.props.selectedScene>0&&this.state.active===this.props.selectedScene&&!this.leftKeyShortCut){this.leftKeyShortCut=true;this.moveLeft('click');}break;case"OPEN_SETTINGS":if(this.props.selectedItems.size===1){this.props.setPropertyWindow({component:this.props.propertyWindow.get("component")!=="settings"?"settings":"",type:this.props.sceneData.getIn(["workspaceItems",this.props.selectedItems.get(0),"type"]),isOpened:this.props.propertyWindow.get("component")!=="settings"});}break;case"ZOOMIN":case"ZOOMIN_AGAIN":this.props.setZoom({zoomFactor:this.props.zoomFactor+0.01,fromUser:true});break;case"ZOOMOUT":case"ZOOMOUT_AGAIN":this.props.setZoom({zoomFactor:this.props.zoomFactor-0.01,fromUser:true});break;default:}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-handleShortcuts");}}},{key:'handleBgDelete',value:function handleBgDelete(e){try{e.preventDefault();e.stopPropagation();this.props.deleteBG({selectedScene:this.props.selectedScene},this.props.socket);var nextBtn=document.querySelector('.next_step');if(nextBtn){this.props.nextBtnClicked(true);nextBtn.classList.remove('disable');nextBtn.click();}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-handleBgDelete");}}},{key:'handleCutEvent',value:function handleCutEvent(){try{if(this.props.sceneData.getIn(["workspaceBG","type"])==="VIDEO")this.props.openCommonPopup("VIDEO");else if(this.props.sceneData.getIn(["workspaceBG","type"])==="STOCKVID"||this.props.sceneData.getIn(["workspaceBG","type"])==="UPVIDEO")this.props.openCommonPopup("VIDEO");}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-handleCutEvent");}}},{key:'addOneMoreScene',value:function addOneMoreScene(){try{var data={selectedScene:this.props.selectedScene,setStatus:true};this.props.addLiteScene(data,this.props.socket);this.setNewScreen=true;this.scrollType='';}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-addOneMoreScene");}}},{key:'changeImgSrc',value:function changeImgSrc(e,src){try{e.currentTarget.src=src;}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-changeImgSrc");}}},{key:'handleZoomClick',value:function handleZoomClick(e){try{e.preventDefault();e.stopPropagation();this.setState({isZoomActive:!this.state.isZoomActive,isZoomDropped:!this.state.isZoomDropped});}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-handleZoomClick");}}},{key:'handleZoomDrop',value:function handleZoomDrop(e){try{e.preventDefault();e.stopPropagation();var stateToUpdate={isZoomDropped:!this.state.isZoomDropped};this.setState(stateToUpdate);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent- handleZoomDrop");}}},{key:'handleZoomChange',value:function handleZoomChange(e,value,checkToggle){try{e.preventDefault();e.stopPropagation();if(value!=="fit"){this.props.setZoom({zoomFactor:value/100,fromUser:true});this.props.setZoomFit(false);}else{this.props.setZoomFit(true);var currentZoom=this.getCurrentZoom(true,true);this.props.setZoom({zoomFactor:currentZoom.scale,fromUser:true});}if(this.state.isZoomDropped){this.setState({isZoomDropped:false});}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-handleZoomChange");}}},{key:'segmentToString',value:function segmentToString(x,y){return[x.b.toFixed(2),y.b.toFixed(2),x.c.toFixed(2),y.c.toFixed(2)].join(",");}},{key:'toggleToolBar',value:function toggleToolBar(){var _this36=this;try{this.setState({isBgToolExpanded:!this.state.isBgToolExpanded},function(){var nextBtn=document.querySelector('.next_step');if(nextBtn){_this36.props.nextBtnClicked(true);nextBtn.classList.remove('disable');nextBtn.click();}});}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-toggleToolBar");}}},{key:'flipBG',value:function flipBG(value,angle){try{var flip=value+1;if(flip>3)flip=0;this.props.flipBG({selectedScene:this.props.selectedScene,toUpdate:{flipPosition:flip}},this.props.socket);this.flipedItem=true;}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-flipBG");}}},{key:'removeBG',value:function removeBG(){try{var workspaceBg=this.props.sceneData.get("workspaceBG");var isRemoveFrmBg=true;var itemToAdd={id:Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString(),assetId:workspaceBg.get("assetId"),selectedScene:this.props.selectedScene,angle:0,src:workspaceBg.get("src"),thumb:workspaceBg.get("thumbnail"),type:workspaceBg.get("type"),subType:workspaceBg.get("subType"),flipPosition:workspaceBg.get("flipPosition"),emptySwap:true};if(workspaceBg.get("type")==="UPIMAGE"){itemToAdd.type="UPLOADS";itemToAdd.subType="UPIMAGE";}if(workspaceBg.get("type")==="GIPHY"){itemToAdd.type="IMG";itemToAdd.subType="GIPHY";}if(workspaceBg.get("bgFilter")!==""){itemToAdd.filter=workspaceBg.get("bgFilter");}if(workspaceBg.get("sourceType")!==""){itemToAdd.sourceType=workspaceBg.get("sourceType");}var bgWidth=workspaceBg.get("width")*this.props.workspaceWidth;var bgHeight=workspaceBg.get("height")*this.props.workspaceHeight;if(bgWidth>bgHeight){itemToAdd.width=this.props.workspaceWidth/2;itemToAdd.height=bgHeight*(itemToAdd.width/bgWidth);}else{itemToAdd.height=this.props.workspaceHeight/2;itemToAdd.width=bgWidth*(itemToAdd.height/bgHeight);}itemToAdd.x=this.props.workspaceWidth/2-itemToAdd.width/2;itemToAdd.y=this.props.workspaceHeight/2-itemToAdd.height/2;if(workspaceBg.get('isBlob')){itemToAdd.isBlob=true;itemToAdd.id=this.props.updateItems.get('item_id');}if(workspaceBg.get('type')==='UPIMAGE'&&workspaceBg.get('sourceType').includes('svg')&&workspaceBg.get('bgColor')&&workspaceBg.get('bgColor').size){itemToAdd.colors=workspaceBg.get('bgColor');itemToAdd.defaultColor=workspaceBg.get('defaultColor');}this.props.changeBg({itemToAdd:itemToAdd,isRemoveFrmBg:isRemoveFrmBg,selectedScene:this.props.selectedScene,selectedItems:this.props.selectedItems},this.props.socket);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-removeBG");}}},{key:'rotateBG',value:function rotateBG(bgData){try{var angle=bgData.get("angle");if(angle===0)angle=270;else if(angle===270)angle=180;else if(angle===180)angle=90;else angle=0;var toUpdate={angle:angle};var dataWidth=this.props.workspaceWidth*bgData.get("width"),dataHeight=this.props.workspaceHeight*bgData.get("height");var bgWidth=null,bgHeight=null,bgScale=null,bgWidthScale=null,bgHeightScale=null;var workspaceWidth=this.props.workspaceWidth;var workspaceHeight=this.props.workspaceHeight;if(angle===90||angle===270){if(dataWidth>=dataHeight){bgWidth=workspaceHeight;bgHeight=dataHeight*(bgWidth/dataWidth);if(bgHeight<=workspaceWidth){bgHeight=workspaceWidth;bgWidth=dataWidth*(bgHeight/dataHeight);}}else{bgHeight=workspaceWidth;bgWidth=dataWidth*(bgHeight/dataHeight);if(bgWidth<=workspaceHeight){bgWidth=workspaceHeight;bgHeight=dataHeight*(bgWidth/dataWidth);}}}else{if(workspaceWidth>=workspaceHeight){bgWidth=workspaceWidth;bgHeight=dataHeight*(bgWidth/dataWidth);if(bgHeight<=workspaceHeight){bgHeight=workspaceHeight;bgWidth=dataWidth*(bgHeight/dataHeight);}}else{bgHeight=workspaceHeight;bgWidth=dataWidth*(bgHeight/dataHeight);if(bgWidth<=workspaceWidth){bgWidth=workspaceWidth;bgHeight=dataHeight*(bgWidth/dataWidth);}}}bgWidthScale=bgWidth/workspaceWidth;bgHeightScale=bgHeight/workspaceHeight;var dW=workspaceWidth-bgWidth,dH=workspaceHeight-bgHeight;if(isNaN(dW))dW=0;if(isNaN(dH))dH=0;var x=dW/2/workspaceWidth,y=dH/2/workspaceHeight,width=bgWidthScale,height=bgHeightScale;toUpdate.x=x;toUpdate.y=y;toUpdate.width=width;toUpdate.height=height;this.props.flipBG({selectedScene:this.props.selectedScene,toUpdate:toUpdate},this.props.socket);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"WorkspaceComponent-rotateBG");}}},{key:'render',value:function render(){var _this38=this;if(this.props.scenes.size>0&&!this.loadedContentScrens){var itemArray=[];if(this.props.scenes.size>1){for(var i=1;i<=this.props.scenes.size;i++){itemArray.push(i);}}else{itemArray=this.state.items;}this.setState({items:itemArray});this.loadedContentScrens=true;}var selectedItem=null,svgPath=null,imageEditIcon=[],filterSettings=[];if(this.props.sceneData!==undefined&&this.props.sceneData.size>0){var workspaceItems=this.props.sceneData.get("workspaceItems");if(!this.props.isPlay&&!this.props.isPlayAll&&this.props.swapDetails===null&&this.props.tool!=="converttomp4"){if(this.props.sceneData.getIn(["workspaceBG","src"])!==""){var currentFlip=this.props.sceneData.getIn(["workspaceBG","flipPosition"])!==undefined?this.props.sceneData.getIn(["workspaceBG","flipPosition"]):0;var currentAngle=this.props.sceneData.getIn(["workspaceBG","angle"])!==undefined?this.props.sceneData.getIn(["workspaceBG","angle"]):0;var itemToolStyle={left:this.props.workspaceBounds.get("cx")+this.props.workspaceWidth*this.props.zoomFactor/2-92+"px",top:this.props.workspaceBounds.get("cy")-this.props.workspaceHeight*this.props.zoomFactor/2+"px",display:this.props.isBgCropping?"none":"unset"};if(Math.round(this.props.workspaceHeight*this.props.zoomFactor)>this.props.workspaceBounds.get("height"))itemToolStyle.top=(this.props.workspaceBounds.get("cy")-this.props.workspaceBounds.get("height")/2).toFixed(2)+"px";if(Math.round(this.props.workspaceWidth*this.props.zoomFactor)>this.props.workspaceBounds.get("width"))itemToolStyle.left=(this.props.workspaceBounds.get("cx")-92+this.props.workspaceBounds.get("width")/2).toFixed(2)+"px";}}}var workspaceCY=this.props.workspaceBounds?this.props.workspaceBounds.get('cy'):window.innerHeight/2;var workspaceCX=this.props.workspaceBounds?this.props.workspaceBounds.get('cx'):window.innerWidth/2;var displayResult=this.generateItems();var workspaceStyles=this.calculateStyles();var toolbarStyle={};toolbarStyle.width=workspaceStyles.width;toolbarStyle.height='33px';toolbarStyle.top=workspaceStyles.top.substr(0,workspaceStyles.top.indexOf('p'))-38+"px";toolbarStyle.left=workspaceStyles.left;toolbarStyle.position='absolute';toolbarStyle.minWidth='240px';//var upDownArrowStyle = {top : arrowTop-28+"px",left:arrowLeft+"px"};
var playerComponent='';var zoomLeft=29;if(this.state.isZoomActive)zoomLeft=52;var zoomDropDown=null;var zoomPosition=this.calculateZoomPosition();if(this.state.isZoomDropped){var zoomVlaues=[25,50,63,100,125,150,200,300];var zoomList=[];var currentZoomFactor=Math.round(this.props.zoomFactor*100);var zoomSet=false;var greenTick=null;var boldStyle=null;zoomVlaues.map(function(index,value){var _this37=this;if(currentZoomFactor===index){zoomSet=true;greenTick=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{float:'right'},src:this.appUrl+'/images/green-tick.svg',alt:'Green tick'});boldStyle={fontWeight:'bold'};}else{greenTick=null;boldStyle=null;}return zoomList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:boldStyle,key:index,onMouseDown:function onMouseDown(e){return _this37.handleZoomChange(e,index);}},index+"%",greenTick));}.bind(this));if(!zoomSet){boldStyle={fontWeight:'bold'};greenTick=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{float:'right'},src:this.appUrl+'/images/green-tick.svg',alt:'Green tick'});}else{greenTick=null;boldStyle=null;}zoomList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:boldStyle,key:zoomVlaues.length,onMouseDown:function onMouseDown(e){return _this38.handleZoomChange(e,"fit");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'z.fit'}),greenTick));var listRight=zoomPosition.right.substr(0,zoomPosition.right.indexOf('p'))-6;zoomDropDown=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{style:{right:listRight+'px',bottom:'53px'},className:'zoom-drop-down'},zoomList);}var zoomControl='';if(this.props.isPlayAll||this.props.isPreview)zoomControl="";var contentRight='6px';if(this.props.selectedScene+1>9){contentRight='3px';}else if(this.props.selectedScene+1>99){contentRight='-1px';}var slidesShow=!this.props.showSlidePanel?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:function onClick(e){return _this38.onShowSlidePanel();},style:{right:zoomPosition.slideRight,bottom:'10px'},className:'slidesShow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slide-main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slide-first'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{right:contentRight},className:'slide-content'},this.props.selectedScene+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slide-second'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'slidesShow-child'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'sl.sc'}))):null;var upArrowSrc=this.props.scenes.size>1?''+(this.appUrl+"/images/slide-icons/down-arrow-ws.svg"):''+(this.appUrl+"/images/slide-icons/down-arrow-disable-ws.svg");//const downArrowSrc = (this.props.selectedScene === this.props.scenes.size-1) ?
var isClick=false;if(this.props.scenes.size===1){var onWPClickItems=this.props.scenes.getIn([0,'workspaceItems']).filter(function(obj,key){return obj.get("animType")==="On Click";});var onWCClickItems=this.props.scenes.getIn([0,'workspaceChildren']).filter(function(obj,key){return obj.get("animType")==="On Click";});if(onWPClickItems.count()>0||onWCClickItems.count()>0){isClick=false;}else{isClick=true;}}if(this.props.mode==='slide'&&this.props.scenes.size===1){isClick=true;}var isPrevClick=false;if(this.props.scenes.size===1||this.props.selectedScene===0){isPrevClick=true;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.props.sceneData!==undefined&&this.props.sceneData.size>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'workspace-wrapper'},displayResult,playerComponent,this.props.workspaceGrid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__helpers_ErrorHandler__["a" /* default */],{component:'WorkspaceGrid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkspaceGrid,{styles:{left:this.workspaceX+"px",top:this.workspaceY+"px",width:this.props.workspaceWidth*this.props.zoomFactor+"px",height:this.props.workspaceHeight*this.props.zoomFactor+"px",borderRadius:"10px"},width:this.props.workspaceWidth*this.props.zoomFactor,height:this.props.workspaceHeight*this.props.zoomFactor,cols:8,rows:8})):"",this.props.animakerType==='full'?svgPath:null,(this.props.isCropping||this.props.isBgCropping||this.props.isFraming||this.props.isVideoCropping)&&!this.props.isPlayAll&&!this.props.isPlay?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__helpers_ErrorHandler__["a" /* default */],{key:'crop',component:'Crop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__containers_Crop__["a" /* default */],{key:'crop',userId:this.props.userId,socket:this.props.socket,config:__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a})):null,filterSettings,this.props.swapDetails!==null||this.props.isToolCropping?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multimove-controls confirm-tool-bar',style:{left:this.workspaceX+"px",top:this.workspaceY+this.props.workspaceHeight*this.props.zoomFactor+10+"px",position:"absolute",width:this.props.workspaceWidth*this.props.zoomFactor+"px",zIndex:12,pointerEvents:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'confirmation-icon',style:{display:this.props.isToolCropping?"none":"inline-block"},onClick:this.cancelSwap}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'confirmation-text',onClick:this.applySwap},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'rec.apply'})))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,zoomControl,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'zm.cl.t.t',children:function children(val){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'zoom_control_tool_tip',style:{'display':'none',left:window.innerWidth/2-zoomLeft+10}},val);}}),this.props.isFullScreen||this.props.mode==='slide'?null:slidesShow)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__["CSSTransition"],{'in':this.state.addTransition,timeout:500,classNames:'bottomTransition',unmountOnExit:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-html2canvas-ignore':'true',className:'transition-showBlock'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'close',className:'hand-cursor',onClick:function onClick(){return _this38.setState({addTransition:!_this38.state.addTransition});}},'x'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'wr.no.tr'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-show'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'wr.sw'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-show'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'wr.sw.in'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-show'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'wr.sw.ot'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-show'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'wr.zm.in'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-show'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'wr.zm.ot'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-show'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'wr.3d'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-show'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'wr.fp.ot'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-show'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'wr.fp.in'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-show'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'wr.ro.180'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-show'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'wr.ro.360'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-show'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_intl__["a" /* FormattedMessage */],{id:'wr.ro.0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-show'}))))));}}]);return WorkspaceComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["b"] = (WorkspaceComponent);

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(333));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(338));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(154));

var _Transition = _interopRequireDefault(__webpack_require__(151));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(25));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(74));

var _reactLifecyclesCompat = __webpack_require__(152);

var _PropTypes = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(25));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(25));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(152);

var _ChildMapping = __webpack_require__(339);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPath;
/* unused harmony export getHandleAngle */
/* unused harmony export getRatio */
var strokeWidth=4;function getPath(item,zoomFactor,storedItem){var pathData=item.get("pathData").toJS();pathData.colors=item.get("colors").toJS();var width=item.get("width")*zoomFactor;var height=item.get("height")*zoomFactor;if(pathData.isStroke===true){width-=strokeWidth;height-=strokeWidth;}var paths=[];if(item.get("subType")==="CSTMPTH"){if(pathData.type==="rectangle")paths=getRectangle(width,height,pathData);else if(pathData.type==="star"||pathData.type==="gons"){var spikes=pathData.spikes;var deg=0;var rx=0,ry=0,cx=0,cy=0;switch(spikes){case 4:deg=45;break;case 5:cy=26;rx=12;break;case 6:deg=30;cy=0;rx=37.5;ry=-12.5;break;case 7:cy=12;rx=6;break;case 8:rx=18;ry=18;break;case 9:rx=3;ry=-5;cy=8;break;case 10:ry=11;break;case 12:rx=10;ry=10;break;case 16:rx=5;ry=5;break;case 24:ry=-12;break;case 32:ry=-12;rx=-4;break;default:break;}paths=getStar(width,height,pathData,{spikes:spikes,rx:rx,ry:ry,cx:cx,cy:cy,deg:deg});}else if(pathData.type==="right_arrow"||pathData.type==="left_arrow"||pathData.type==="up_arrow"||pathData.type==="down_arrow"||pathData.type==="left_right"||pathData.type==="up_down"||pathData.type==="pentagon_arrow"||pathData.type==="chevron"||pathData.type==="flat_arrow_down"||pathData.type==="quad_arrow"||pathData.type==="notched_right_arrow"||pathData.type==="bent_up_arrow"||pathData.type==="left_up_arrow"||pathData.type==="bent_arrow"||pathData.type==="u_turn_arrow")paths=getArrow(width,height,pathData);if(pathData.type==="ribbon"||pathData.type==="dumbbell"||pathData.type==="circle_dumbbell"||pathData.type==="line")paths=getLine(width,height,pathData);else if(pathData.type==="circle")paths=getCircle(width,height,pathData);else if(pathData.type==="l")paths=getLShape(width,height,pathData);else if(pathData.type==="stripe")paths=getStripe(width,height,pathData);else if(pathData.type==="diamond"||pathData.type==="pentagon")paths=getSimplePath(width,height,pathData);else if(pathData.type==="hexagon")paths=getHexagon(width,height,pathData);else if(pathData.type==="lightning")paths=getLightning(width,height,pathData);else if(pathData.type==="parallelogram")paths=getParallelogram(width,height,pathData);else if(pathData.type==="trapezoid")paths=getTrapezoid(width,height,pathData);else if(pathData.type==="collate")paths=getCollate(width,height,pathData);else if(pathData.type==="pie"||pathData.type==="chord"||pathData.type==="blockarc")paths=getPie(width,height,pathData);else if(pathData.type==="half_frame")paths=getHalfFrame(width,height,pathData);else if(pathData.type==="frame")paths=getFrame(width,height,pathData);else if(pathData.type==="triangle")paths=getTriangle(width,height,pathData);else if(pathData.type==="plus")paths=getPlus(width,height,pathData);else if(pathData.type==="multiply")paths=getMultiply(width,height,pathData);else if(pathData.type==="minus")paths=getMinus(width,height,pathData);else if(pathData.type==="cube"||pathData.type==="cylinder"||pathData.type==="grouped_triangle"||pathData.type==="grouped_rectangle"||pathData.type==="equal_to"||pathData.type==="curved_right_arrow"||pathData.type==="curved_left_arrow"||pathData.type==="curved_up_arrow"||pathData.type==="curved_down_arrow"||pathData.type==="striped_right_arrow")paths=getGroupPath(width,height,pathData,storedItem);else if(pathData.type==="plaque")paths=getPlaque(width,height,pathData);else if(pathData.type==="moon")paths=getMoon(width,height,pathData);else if(pathData.type==="donut")paths=getDonut(width,height,pathData);else if(pathData.type==="file")paths=getFile(width,height,pathData);else if(pathData.type==="flowchart_connector")paths=getFlowchart(width,height,pathData);else if(pathData.type==="tear_drop")paths=getTearDrop(width,height,pathData);else if(pathData.type==="circle_callout"||pathData.type==="rectangle_callout"||pathData.type==="rounded_rectangle_callout"||pathData.type==="bubble_callout")paths=getCallout(width,height,pathData,storedItem);else if(pathData.type==="no_symbol")paths=getSymbol(width,height,pathData);else if(pathData.type==="scalene_triangle")paths=getScalene(width,height,pathData);else if(pathData.type==="repeated_arrow"||pathData.type==="repeated_bar"||pathData.type==="repeated_double"||pathData.type==="repeated_triple")paths=getRepeated(width,height,pathData);}else if(item.get("subType")==="BANNER"){paths=getBanner(item,zoomFactor);}return paths;}function getRectangle(width,height,pathData){var data="";var pathPoints=pathData.points;var controlPoints=pathData.controlPoints;var tl=0,tr=0,bl=0,br=0,tlRounded=true,trRounded=true,blRounded=true,brRounded=true;var newControlPoints={};for(var key in controlPoints){if(key==="tl"){if(controlPoints.tl.moveType==="x"){tl=controlPoints.tl.x/100*width;}else if(controlPoints.tl.moveType==="y"){tl=controlPoints.tl.y/100*height;}if(controlPoints.tl.isRounded===false)tlRounded=false;if(controlPoints.tl.mirror==="full"){tr=bl=br=tl;if(controlPoints.tl.isRounded===false)trRounded=brRounded=blRounded=false;}else if(controlPoints.tl.mirror==="x"){tr=tl;if(controlPoints.tl.isRounded===false)trRounded=false;}else if(controlPoints.tl.mirror==="y"){bl=tl;if(controlPoints.tl.isRounded===false)blRounded=false;}else if(controlPoints.tl.mirror==="diagonal"){br=tl;if(controlPoints.tl.isRounded===false)brRounded=false;}}else if(key==="tr"){if(controlPoints.tr.moveType==="x"){tr=(100-controlPoints.tr.x)/100*width;}else if(controlPoints.tr.moveType==="y"){tr=controlPoints.tr.y/100*height;}if(controlPoints.tr.isRounded===false)trRounded=false;if(controlPoints.tr.mirror==="full"){tl=bl=br=tr;if(controlPoints.tr.isRounded===false)tlRounded=brRounded=blRounded=false;}else if(controlPoints.tr.mirror==="x"){tl=tr;if(controlPoints.tr.isRounded===false)tlRounded=false;}else if(controlPoints.tr.mirror==="y"){br=tr;if(controlPoints.tr.isRounded===false)brRounded=false;}else if(controlPoints.tr.mirror==="diagonal"){bl=tr;if(controlPoints.tr.isRounded===false)blRounded=false;}}else if(key==="br"){if(controlPoints.br.moveType==="x"){br=(100-controlPoints.br.x)/100*width;}else if(controlPoints.br.moveType==="y"){br=controlPoints.br.y/100*height;}if(controlPoints.tl.isRounded===false)tlRounded=false;if(controlPoints.br.mirror==="full"){tl=tr=bl=br;if(controlPoints.br.isRounded===false)tlRounded=trRounded=blRounded=false;}else if(controlPoints.br.mirror==="x"){bl=br;if(controlPoints.br.isRounded===false)blRounded=false;}else if(controlPoints.br.mirror==="y"){tr=br;if(controlPoints.br.isRounded===false)trRounded=false;}else if(controlPoints.br.mirror==="diagonal"){tl=tr;if(controlPoints.br.isRounded===false)tlRounded=false;}}else if(key==="bl"){if(controlPoints.bl.moveType==="x"){bl=controlPoints.bl.x/100*width;}else if(controlPoints.bl.moveType==="y"){bl=controlPoints.bl.y/100*height;}if(controlPoints.bl.isRounded===false)blRounded=false;if(controlPoints.bl.mirror==="full"){tl=tr=br=bl;if(controlPoints.bl.isRounded===false)tlRounded=trRounded=brRounded=false;}else if(controlPoints.bl.mirror==="x"){br=bl;if(controlPoints.bl.isRounded===false)brRounded=false;}else if(controlPoints.bl.mirror==="y"){tl=bl;if(controlPoints.bl.isRounded===false)tlRounded=false;}else if(controlPoints.bl.mirror==="diagonal"){tr=bl;if(controlPoints.bl.isRounded===false)trRounded=false;}}}var least=height<width?height:width;tl=tl/width*least;tr=tr/width*least;bl=bl/width*least;br=br/width*least;tl=tl<=0?0:tl<=width?tl:width;tr=tr<=0?0:tr<=width?tr:width;bl=bl<=0?0:bl<=width?bl:width;br=br<=0?0:br<=width?br:width;if(pathData.controlPoints.tl!==undefined){newControlPoints.tl={};newControlPoints.tl.x=tl/width*100;newControlPoints.tl.y=pathData.controlPoints.tl.y;}if(pathData.controlPoints.tr!==undefined){newControlPoints.tr={};newControlPoints.tr.x=(width-tr)/width*100;newControlPoints.tr.y=pathData.controlPoints.tr.y;}if(pathData.controlPoints.bl!==undefined){newControlPoints.bl={};newControlPoints.bl.x=bl/width*100;newControlPoints.bl.y=pathData.controlPoints.bl.y;}if(pathData.controlPoints.br!==undefined){newControlPoints.br={};newControlPoints.br.x=(width-br)/width*100;newControlPoints.br.y=pathData.controlPoints.br.y;}var ratio=1/2;var xAdder=0,yAdder=0,outTanX=0,outTanY=0;for(var i=0;i<pathPoints.length;i++){var _xpos=pathPoints[i].x/100*width;var _ypos=pathPoints[i].y/100*height;if(i===0){xAdder=tl;yAdder=0;data="M"+(_xpos+xAdder)+","+(_ypos+yAdder)+" C"+(_xpos+xAdder)+","+(_ypos+yAdder);}else{outTanX=0;outTanY=0;if(i===1){xAdder=-tr;yAdder=0;outTanX=trRounded?tr*ratio:0;data+=" "+(_xpos+xAdder)+","+(_ypos+yAdder)+" "+(_xpos+xAdder)+","+(_ypos+yAdder)+" C"+(_xpos+xAdder+outTanX)+","+(_ypos+yAdder);}else if(i===2){xAdder=0;yAdder=tr;outTanY=trRounded?tr*ratio:0;data+=" "+(_xpos+xAdder)+","+(_ypos+yAdder-outTanY)+" "+(_xpos+xAdder)+","+(_ypos+yAdder)+" C"+(_xpos+xAdder)+","+(_ypos+yAdder);}else if(i===3){xAdder=0;yAdder=-br;outTanY=brRounded?br*ratio:0;data+=" "+(_xpos+xAdder)+","+(_ypos+yAdder)+" "+(_xpos+xAdder)+","+(_ypos+yAdder)+" C"+(_xpos+xAdder)+","+(_ypos+yAdder+outTanY);}else if(i===4){xAdder=-br;yAdder=0;outTanX=brRounded?-br*ratio:0;data+=" "+(_xpos+xAdder-outTanX)+","+(_ypos+yAdder)+" "+(_xpos+xAdder)+","+(_ypos+yAdder)+" C"+(_xpos+xAdder)+","+(_ypos+yAdder);}else if(i===5){xAdder=bl;yAdder=0;outTanX=blRounded?-bl*ratio:0;data+=" "+(_xpos+xAdder)+","+(_ypos+yAdder)+" "+(_xpos+xAdder)+","+(_ypos+yAdder)+" C"+(_xpos+xAdder+outTanX)+","+(_ypos+yAdder);}else if(i===6){xAdder=0;yAdder=-bl;outTanY=blRounded?-bl*ratio:0;data+=" "+(_xpos+xAdder)+","+(_ypos+yAdder-outTanY)+" "+(_xpos+xAdder)+","+(_ypos+yAdder)+" C"+(_xpos+xAdder)+","+(_ypos+yAdder);}else if(i===7){xAdder=0;yAdder=tl;outTanY=tlRounded?tl*ratio:0;data+=" "+(_xpos+xAdder)+","+(_ypos+yAdder)+" "+(_xpos+xAdder)+","+(_ypos+yAdder)+" C"+(_xpos+xAdder)+","+(_ypos+yAdder-outTanY);}}}var xpos=pathPoints[0].x/100*width;var ypos=pathPoints[0].y/100*height;xAdder=tl;yAdder=0;outTanX=tlRounded?tl*ratio:0;data+=" "+(xpos+xAdder-outTanX)+","+(ypos+yAdder)+" "+(xpos+xAdder)+","+(ypos+yAdder)+"z";var dataP={data:data,color:pathData.colors[Object.keys(pathData.colors)[0]]};if(pathData.isStroke===true){dataP.isStroke=true;var shapeX=-strokeWidth,shapeY=-strokeWidth,shapeWidth=width+strokeWidth*2,shapeHeight=height+strokeWidth*2;dataP.pathStyle={left:strokeWidth/2,top:strokeWidth/2};var shapeStyle={width:width+strokeWidth,height:height+strokeWidth};}else dataP.isFill=true;return{data:data,pathDetails:[dataP],pathData:pathData,shapeStyle:shapeStyle,newControlPoints:newControlPoints};}function getStar(width,height,pathData,sData){var data="";var controlPoints=pathData.controlPoints;var offset=0;if(pathData.type==="star"){offset=controlPoints.c.y/100*500/250;if(offset<=0)offset=0;if(offset>=0.95)offset=0.95;}else if(pathData.type==="gons")offset=pathData.offset/100*500/250;var spikes=sData.spikes;var rxInc=sData.rx,ryInc=sData.ry,cxInc=sData.cx,cyInc=sData.cy;var centerX=250+cxInc;var centerY=250+cyInc;var radiusX=centerX+rxInc;var radiusY=centerY+ryInc;// var offset = 0;
var angle=0;var deg=360/(spikes*2);var x_percentArr=[];var y_percentArr=[];var spikeLen=360/deg;var degree=deg+sData.deg;for(var i=0;i<spikeLen;i++){var rx,ry;if(i%2===0){rx=radiusX;ry=radiusY;}else{rx=radiusX-radiusX*offset;ry=radiusY-radiusY*offset;}angle=degree*(Math.PI/180);var boxx=centerX+Math.sin(angle)*rx;var boxy=centerY+Math.cos(angle)*ry;x_percentArr.push((boxx/500*100).toFixed(2));y_percentArr.push((boxy/500*100).toFixed(2));degree=degree+deg;}var xpos2=x_percentArr[0]/100*width;var ypos2=y_percentArr[0]/100*height;data="M"+xpos2+","+ypos2+" C"+xpos2+","+ypos2;for(i=1;i<x_percentArr.length;i++){var xpos=x_percentArr[i]/100*width;var ypos=y_percentArr[i]/100*height;data=data+" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;}data=data+" "+xpos2+","+ypos2+" "+xpos2+","+ypos2+"z";if(pathData.controlPoints.c!==undefined){var positions={c:{}};positions.c.x=pathData.controlPoints.c.x;positions.c.y=offset/height*2*100*100;}var pathD={data:data,color:pathData.colors[Object.keys(pathData.colors)[0]]};if(pathData.isStroke===true){pathD.isStroke=true;pathD.pathStyle={left:strokeWidth/2,top:strokeWidth/2};var shapeStyle={width:width+strokeWidth,height:height+strokeWidth};}else pathD.isFill=true;return{data:data,pathDetails:[pathD],pathData:pathData,shapeStyle:shapeStyle,newControlPoints:positions};}function getArrow(width,height,pathData){var data="",xpos,ypos;var controlPoints=pathData.controlPoints;var midX=width/2;var midY=height/2;if(pathData.type==="right_arrow"){var least=height;var tr=width-(100-controlPoints.t.x)*least/100;// width - ((controlPoints.t.x / 100) * least);
if(tr<0)tr=0;if(tr>=width)tr=width;var currentXValue=tr;var _thickn=least/2-controlPoints.l.y/100*least;if(_thickn>=least/2)_thickn=least/2;if(_thickn<=0.01*least)_thickn=0.01*least;data="M"+currentXValue+",0 C"+currentXValue+",0";xpos=width;ypos=height/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=midY+_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=midY+_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=midY-_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=midY-_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";var newControlPoints={t:{},l:{}};newControlPoints.t.x=tr/width*100;newControlPoints.t.y=controlPoints.t.y;newControlPoints.l.x=controlPoints.l.x;newControlPoints.l.y=(midY-_thickn)/height*100;}else if(pathData.type==="left_arrow"){var least=height;var tr=controlPoints.t.x*least/100;if(tr>width)tr=width;if(tr<0)tr=0;var currentXValue=tr;var _thickn=least/2-controlPoints.r.y/100*least;if(_thickn<=0.01*least)_thickn=least*0.01;if(_thickn>=least/2)_thickn=least/2;xpos=0;ypos=height/2;var data="M"+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=midY-_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=midY-_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=midY+_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=midY+_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=midY+_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=height/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";var newControlPoints={t:{},r:{}};newControlPoints.t.x=currentXValue/width*100;newControlPoints.t.y=controlPoints.t.y;newControlPoints.r.x=controlPoints.r.x;newControlPoints.r.y=(midY-_thickn)/height*100;}else if(pathData.type==="up_arrow"){var least=width;var tr=controlPoints.l.y*least/100;if(tr>height)tr=height;if(tr<=0)tr=0;var currentYValue=tr;var _thickn=least/2-controlPoints.b.x/100*least;if(_thickn>=least/2)_thickn=least/2;if(_thickn<=least/2*0.01)_thickn=least/2*0.01;xpos=0;ypos=currentYValue;var data="M"+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width/2;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=currentYValue;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX+_thickn;ypos=currentYValue;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX+_thickn;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX-_thickn;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX-_thickn;ypos=currentYValue;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=currentYValue;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width/2;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";var newControlPoints={l:{},b:{}};newControlPoints.l.x=controlPoints.l.x;newControlPoints.l.y=currentYValue/height*100;newControlPoints.b.x=(midX-_thickn)/width*100;newControlPoints.b.y=controlPoints.b.y;}else if(pathData.type==="down_arrow"){var least=width;var tr=height-(100-controlPoints.l.y)*least/100;// width - ((controlPoints.t.x / 100) * least);
if(tr<0)tr=0;if(tr>=height)tr=height;var currentYValue=tr;var _thickn=least/2-controlPoints.t.x/100*least;if(_thickn>=least/2)_thickn=least/2;if(_thickn<=0.01*least)_thickn=0.01*least;xpos=width;ypos=currentYValue;var data="M"+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width/2;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=currentYValue;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX-_thickn;ypos=currentYValue;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX-_thickn;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX+_thickn;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX+_thickn;ypos=currentYValue;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=currentYValue;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width/2;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";var newControlPoints={l:{},t:{}};newControlPoints.l.x=controlPoints.l.x;newControlPoints.l.y=currentYValue/height*100;newControlPoints.t.x=(midX-_thickn)/width*100;newControlPoints.t.y=controlPoints.t.y;}else if(pathData.type==="left_right"){var least=height;var tr=controlPoints.t.x*least/100;// width - ((controlPoints.t.x / 100) * least);
if(tr>width/2)tr=width/2;if(tr<=0)tr=0;var currentXValue=tr;var _thickn=least/2-controlPoints.r.y/100*least;if(_thickn>=least/2)_thickn=least/2;if(_thickn<=least/2*0.01)_thickn=least/2*0.01;xpos=currentXValue;ypos=0;var data="M"+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=midY-_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width-currentXValue;ypos=midY-_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width-currentXValue;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=height/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width-currentXValue;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width-currentXValue;ypos=midY+_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=midY+_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=height/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";var newControlPoints={r:{},t:{}};newControlPoints.t.x=currentXValue/width*100;newControlPoints.t.y=controlPoints.t.y;newControlPoints.r.x=(width-currentXValue)/width*100;newControlPoints.r.y=(midY-_thickn)/height*100;}else if(pathData.type==="up_down"){var least=width;var tr=controlPoints.l.y*least/100;// width - ((controlPoints.t.x / 100) * least);
if(tr>height/2)tr=height/2;if(tr<=0)tr=0;var currentYValue=tr;var _thickn=least/2-controlPoints.b.x/100*least;if(_thickn>=least/2)_thickn=least/2;if(_thickn<=least/2*0.01)_thickn=least/2*0.01;xpos=0;ypos=currentYValue;var data="M"+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width/2;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=currentYValue;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX+_thickn;ypos=currentYValue;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX+_thickn;ypos=height-currentYValue;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=height-currentYValue;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width/2;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=height-currentYValue;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX-_thickn;ypos=height-currentYValue;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX-_thickn;ypos=currentYValue;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=currentYValue;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";var newControlPoints={l:{},b:{}};newControlPoints.l.x=controlPoints.l.x;newControlPoints.l.y=currentYValue/height*100;newControlPoints.b.x=(midX-_thickn)/width*100;newControlPoints.b.y=(height-currentYValue)/height*100;}else if(pathData.type==="pentagon_arrow"){var least=height;var tr=width-(100-controlPoints.t.x)*least/100;// width - ((controlPoints.t.x / 100) * least);
if(tr<0)tr=0;if(tr>=width)tr=width;var currentXValue=tr;xpos=0;ypos=0;var data="M"+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=height/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";var newControlPoints={t:{}};newControlPoints.t.x=currentXValue/width*100;newControlPoints.t.y=controlPoints.t.y;}else if(pathData.type==="chevron"){var least=height;var tr=width-(100-controlPoints.t.x)*least/100;if(tr<0.1*width)tr=0.1*width;if(tr>=width)tr=width;var currentXValue=tr;xpos=0;ypos=0;var data="M"+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=height/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width-currentXValue;ypos=height/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";var newControlPoints={t:{}};newControlPoints.t.x=currentXValue/width*100;newControlPoints.t.y=controlPoints.t.y;}else if(pathData.type==="flat_arrow_down"){var least=width;var tr=height-(100-controlPoints.l.y)*least/100;if(tr<0)tr=0;if(tr>=height)tr=height;var currentYValue=tr;xpos=0;ypos=0;var data="M"+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=currentYValue;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width/2;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=currentYValue;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";var newControlPoints={l:{}};newControlPoints.l.x=controlPoints.l.x;newControlPoints.l.y=currentYValue/height*100;}else if(pathData.type==="quad_arrow"){var least=height<width?height:width;var thick1=least/2-controlPoints.t.x/100*least;var thick2=least/2-controlPoints.m.x/100*least;var r=controlPoints.r.y*least/100;if(r>=least/2-thick1)r=least/2-thick1;if(r<0)r=0;if(thick1<=0.01*least)thick1=0.01*least;if(thick1>=least/2)thick1=least/2;if(thick2<=0.01*least)thick2=0.01*least;if(thick2>=thick1)thick2=thick1;xpos=midX;ypos=0;var data="M"+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX+thick1;ypos=r;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX+thick2;ypos=r;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX+thick2;ypos=midY-thick2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX+thick1;ypos=midY-thick2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width-r;ypos=midY-thick2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width-r;ypos=midY-thick1;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=midY;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width-r;ypos=midY+thick1;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width-r;ypos=midY+thick2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX+thick2;ypos=midY+thick2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX+thick2;ypos=height-r;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX+thick1;ypos=height-r;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX-thick1;ypos=height-r;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX-thick2;ypos=height-r;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX-thick2;ypos=midY+thick2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=r;ypos=midY+thick2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=r;ypos=midY+thick1;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=midY;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=r;ypos=midY-thick1;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=r;ypos=midY-thick2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX-thick2;ypos=midY-thick2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX-thick2;ypos=r;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX-thick1;ypos=r;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";var newControlPoints={t:{},m:{},r:{}};newControlPoints.t.x=(midX-thick1)/width*100;newControlPoints.t.y=controlPoints.t.y;newControlPoints.m.x=(midX-thick2)/width*100;newControlPoints.m.y=r/height*100;newControlPoints.r.x=controlPoints.r.x;newControlPoints.r.y=r/height*100;}else if(pathData.type==="notched_right_arrow"){var least=height;var tr=width-(100-controlPoints.t.x)*least/100;var _thickn=least/2-controlPoints.l.y/100*least;if(tr<0)tr=0;if(tr>=width)tr=width;if(_thickn<=least/2*0.01)_thickn=least/2*0.01;if(_thickn>=least/2)_thickn=least/2;var currentXValue=tr;xpos=0;ypos=midY-_thickn;var data="M"+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=midY-_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=height/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=midY+_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=midY+_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width-currentXValue;ypos=midY;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=midY-_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";var newControlPoints={t:{},l:{}};newControlPoints.t.x=tr/width*100;newControlPoints.t.y=controlPoints.t.y;newControlPoints.l.x=controlPoints.l.x;newControlPoints.l.y=(midY-_thickn)/height*100;}else if(pathData.type==="bent_up_arrow"){var least=height<width?height:width;var thick1=least-controlPoints.t.x/100*least;var thick2=least-controlPoints.l.y/100*least;var m=controlPoints.m.y*least/100;if(m<0)m=0;if(m>=least/2)m=least/2;if(thick2>least/2)thick2=least/2;if(thick2<=0.01*least)thick2=0.01*least;if(thick1<=0.01*least)thick1=0.01*least;if(thick1>=least)thick1=least;if(thick2>=thick1)thick2=thick1;var _midX=width-thick1/2;var _midY=height-thick2/2;xpos=0;ypos=_midY-thick2/2;var data="M"+xpos+","+ypos+" C"+xpos+","+ypos;xpos=_midX-thick2/2;ypos=_midY-thick2/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=_midX-thick2/2;ypos=m;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=_midX-thick1/2;ypos=m;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=_midX;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=m;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=_midX+thick2/2;ypos=m;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=_midX+thick2/2;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=_midY-thick2/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";var newControlPoints={t:{},l:{},m:{}};newControlPoints.t.x=(width-thick1)/width*100;newControlPoints.t.y=controlPoints.t.y;newControlPoints.l.x=controlPoints.l.x;newControlPoints.l.y=(height-thick2)/height*100;newControlPoints.m.x=(_midX-thick2/2)/width*100;newControlPoints.m.y=m/height*100;}else if(pathData.type==="left_up_arrow"){var least=height<width?height:width;var thick1=least-controlPoints.t.x/100*least;var thick2=least-controlPoints.m2.y/100*least;var m=controlPoints.m1.y*least/100;if(m>=least-thick1)m=least-thick1;if(m<0)m=0;if(thick2>least/2)thick2=least/2;if(thick2<=0.01*least)thick2=0.01*least;if(thick1<=0.01*least)thick1=0.01*least;if(thick1>=least)thick1=least;if(thick2>=thick1)thick2=thick1;var _midX2=width-thick1/2;var _midY2=height-thick1/2;xpos=0;ypos=_midY2;var data="M"+xpos+","+ypos+" C"+xpos+","+ypos;xpos=m;ypos=_midY2-thick1/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=m;ypos=_midY2-thick2/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=_midX2-thick2/2;ypos=_midY2-thick2/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=_midX2-thick2/2;ypos=m;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=_midX2-thick1/2;ypos=m;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=_midX2;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=m;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=_midX2+thick2/2;ypos=m;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=_midX2+thick2/2;ypos=_midY2+thick2/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=m;ypos=_midY2+thick2/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=m;ypos=_midY2+thick1/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=_midY2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";var newControlPoints={t:{},m1:{},m2:{}};newControlPoints.t.x=(width-thick1)/width*100;newControlPoints.t.y=controlPoints.t.y;newControlPoints.m2.x=(_midX2-thick2/2)/width*100;newControlPoints.m2.y=(_midY2-thick2/2)/height*100;newControlPoints.m1.x=(_midX2-thick2/2)/width*100;newControlPoints.m1.y=m/height*100;}else if(pathData.type==="bent_arrow"){var least=height<width?height:width;var t1=controlPoints.t1.x*least/100;var t2=width-(100-controlPoints.t2.x)*least/100;var thick1=controlPoints.r.y/100*least;var thick2=controlPoints.b.x/100*least;if(t1>=least/2)t1=least/2;if(t1<=0)t1=0;if(t2>=width)t2=width;if(width-t2>=least/2)t2=width-least/2;if(thick2<=0.01*least)thick2=0.01*least;if(thick1<=0.01*least)thick1=0.01*least;if(thick1>=least)thick1=least;if(thick2>=thick1)thick2=thick1;var _midX3=thick2/2;var _midY3=thick1/2;var curve2=t1>thick2?t1-thick2:0;xpos=t2;ypos=0;var data="M"+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=_midY3;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=t2;ypos=thick1;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=t2;ypos=_midY3+_midX3;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=thick2+curve2;ypos=_midY3+_midX3;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+(xpos-curve2)+","+ypos;//Curve point
xpos=thick2;ypos=_midY3+_midX3+curve2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+(ypos+curve2);//Curve point
xpos=thick2;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=_midY3-_midX3+t1;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+(ypos-t1);//Curve point
xpos=t1;ypos=_midY3-_midX3;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+(xpos+t1)+","+ypos;//Curve point
xpos=t2;ypos=_midY3-_midX3;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=t2;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";var newControlPoints={t1:{},t2:{},r:{},b:{}};newControlPoints.t1.x=t1/width*100;newControlPoints.t1.y=controlPoints.t1.y;newControlPoints.t2.x=t2/width*100;newControlPoints.t2.y=controlPoints.t2.y;newControlPoints.r.x=controlPoints.r.x;newControlPoints.r.y=thick1/height*100;newControlPoints.b.x=thick2/width*100;newControlPoints.b.y=controlPoints.b.y;}else if(pathData.type==="u_turn_arrow"){var least=height<width?height:width;var t=controlPoints.t.x*least/100;var r=controlPoints.r.y*height/100;var thick1=least-controlPoints.b2.x*least/100;var thick2=controlPoints.b1.x/100*least;var m=least-controlPoints.m.y*least/100;if(t>=least/2*.95)t=least/2*.95;if(t<=0)t=0;if(thick1>=least/2)thick1=least/2;if(thick1<=least*0.01)thick1=least*0.01;if(thick2>=thick1)thick2=thick1;if(thick2>=least/2)thick2=least/2;if(thick2<=least*0.01)thick2=least*0.01;if(r>=height)r=height;if(r<=thick1)r=thick1;m=r-m;if(m>=r)m=r;if(m<=thick2)m=thick2;if(t>=m)t=m;var _midX4=thick2/2;var _midY4=width-thick1/2;var curve2=t>thick2?t-thick2:0;var newControlPoints={t:{},m:{},r:{},b1:{},b2:{}};newControlPoints.t.x=t/width*100;newControlPoints.t.y=controlPoints.t.y;newControlPoints.m.x=(width-thick1)/width*100;newControlPoints.m.y=m/height*100;newControlPoints.r.x=controlPoints.r.x;newControlPoints.r.y=r/height*100;newControlPoints.b1.x=thick2/width*100;newControlPoints.b1.y=controlPoints.b1.y;newControlPoints.b2.x=(width-thick1)/width*100;newControlPoints.b2.y=controlPoints.b2.y;xpos=thick2;ypos=height;var data="M"+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=t;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+(ypos-t);//Curve point
xpos=t;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+(xpos+t)+","+ypos;//Curve point
xpos=_midY4+_midX4-t;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+(xpos+t)+","+ypos;//Curve point
xpos=_midY4+_midX4;ypos=t;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+(ypos-t);//Curve point
xpos=_midY4+_midX4;ypos=m;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=m;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=_midY4;ypos=r;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=_midY4-thick1/2;ypos=m;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=_midY4-thick2/2;ypos=m;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;// xpos = midY - thick2/2, ypos = thick2;
// data += " "+ xpos +","+ ypos +" "+ xpos +","+ ypos +" C"+ (xpos) +","+(ypos);
xpos=_midY4-thick2/2;ypos=thick2+curve2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+(ypos-curve2);xpos=_midY4-thick2/2-curve2;ypos=thick2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+(xpos+curve2)+","+ypos;xpos=thick2+curve2;ypos=thick2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+(xpos-curve2)+","+ypos;//Curve point
xpos=thick2;ypos=thick2+curve2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+(ypos+curve2);//Curve point
xpos=thick2;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";}var dataP={data:data,color:pathData.colors[Object.keys(pathData.colors)[0]]};if(pathData.isStroke===true){dataP.isStroke=true;dataP.pathStyle={left:strokeWidth/2,top:strokeWidth/2};var shapeStyle={width:width+strokeWidth,height:height+strokeWidth};}else dataP.isFill=true;return{data:data,pathDetails:[dataP],pathData:pathData,shapeStyle:shapeStyle,newControlPoints:newControlPoints};}function getLine(width,height,pathData){var data="",xpos,ypos;var controlPoints=pathData.controlPoints;var midX=width/2;var midY=height/2;if(pathData.type==="ribbon"){var least=height<width?height:width;var tr=controlPoints.t.x*least/100;if(tr<0)tr=0;if(tr>=width)tr=width;var currentXValue=tr;xpos=0;ypos=0;var data="M"+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width-currentXValue;ypos=height/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=height/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";var newControlPoints={t:{}};newControlPoints.t.x=currentXValue/width*100;newControlPoints.t.y=controlPoints.t.y;}else if(pathData.type==="dumbbell"){var least=height;var tr=controlPoints.t.x*least/100;if(tr<0)tr=0;if(tr>=width/2)tr=width/2;var currentXValue=tr;var _thickn=least/2-controlPoints.r.y/100*least;if(_thickn<=least/2*0.01)_thickn=least/2*0.01;if(_thickn>=least/2)_thickn=least/2;xpos=0;ypos=0;var data="M"+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=midY-_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width-currentXValue;ypos=midY-_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width-currentXValue;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width-currentXValue;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width-currentXValue;ypos=midY+_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=midY+_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";var newControlPoints={t:{},r:{}};newControlPoints.t.x=currentXValue/width*100;newControlPoints.t.y=controlPoints.t.y;newControlPoints.r.x=(width-tr)/width*100;newControlPoints.r.y=(midY-_thickn)/height*100;}else if(pathData.type==="circle_dumbbell"){var least=height;var t=controlPoints.t.x*least/100;if(t>=least)t=least;if(t>=width/2)t=width/2;if(t<=least/2*0.01)t=least/2*0.01;var thickness=least/2-controlPoints.l.y/100*least;if(thickness>=t)thickness=t;if(thickness<=1)thickness=1;// y = r * sin(ang), ang = sin^-1(y / r)
var yByR=thickness/2/(t/2);// make sure thickness does not exceed circle diameter - else ang will be NaN
if(yByR<-1){yByR=-1;}if(yByR>1){yByR=1;}var ang=Math.asin(yByR)*(180/Math.PI);// in degree
var ang1=(360-ang)*Math.PI/180;var ang2=ang*Math.PI/180;var circleVal=createPie(width,height,pathData,t,t,0,height/2-t/2,ang1,ang2);var circle1=String(circleVal.data);circle1=circle1.slice(0,-1);circle1+=" C"+circleVal.x2+","+circleVal.y2+" "+circleVal.x1+","+circleVal.y1+" "+circleVal.x1+","+circleVal.y1+"z";var x1=circleVal.x1,y1=circleVal.y1,x2=circleVal.x2,y2=circleVal.y2;ang1=(-180+ang)*Math.PI/180;ang2=(180-ang)*Math.PI/180;circleVal=createPie(width,height,pathData,t,t,width-t,height/2-t/2,ang1,ang2);var x3=circleVal.x1,y3=circleVal.y1,x4=circleVal.x2,y4=circleVal.y2;var circle2=String(circleVal.data);circle2=circle2.slice(0,-1);circle2+=" C"+circleVal.x2+","+circleVal.y2+" "+circleVal.x1+","+circleVal.y1+" "+circleVal.x1+","+circleVal.y1+"z";var line1="M"+x1+","+y1+" "+x1+","+y1;xpos=x3;ypos=y3;line1+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=x4;ypos=y4;line1+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=x2;ypos=y2;line1+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;line1+=" "+x1+","+y1+" "+x1+","+y1+"z";data=circle1+line1+circle2;var newControlPoints={t:{},l:{}};newControlPoints.t.x=t/width*100;newControlPoints.t.y=controlPoints.t.y;newControlPoints.l.x=x1/width*100;newControlPoints.l.y=y1/height*100;// data = [circle1, circle2, line1]
}else if(pathData.type==="line"){var data="";var data="M0,0 C0,0";data+=drawData(width,0);data+=drawData(width,height);data+=drawData(0,height);data+=" 0,0 0,0z";}return{data:data,pathDetails:[{data:data,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData,newControlPoints:newControlPoints};}function getCircle(width,height,pathData){var data="";var pathPoints=pathData.points;var outTanX=0;var outTanY=0;var inTanX=0;var inTanY=0;for(var i=0;i<pathPoints.length;i++){var _xpos2=pathPoints[i].x/100*width;var _ypos2=pathPoints[i].y/100*height;if(i===0){outTanX=1.1/4;data="M"+_xpos2+","+_ypos2+" C"+(_xpos2+outTanX*width)+","+_ypos2;}else{outTanX=outTanY=inTanX=inTanY=0;if(i===1){inTanY=-(1.1/4);outTanY=1.1/4;}else if(i===2){inTanX=1.1/4;outTanX=-(1.1/4);}else if(i===3){inTanY=1.1/4;outTanY=-(1.1/4);}outTanX*=width;outTanY*=height;inTanX*=width;inTanY*=height;data+=" "+(_xpos2+inTanX)+","+(_ypos2+inTanY)+" "+_xpos2+","+_ypos2+" C"+(_xpos2+outTanX)+","+(_ypos2+outTanY);}}var xpos=pathPoints[0].x/100*width;var ypos=pathPoints[0].y/100*height;inTanX=-(1.1/4);data+=" "+(xpos+inTanX*width)+","+ypos+" "+xpos+","+ypos+"z";return{data:data,pathDetails:[{data:data,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData};}function getLShape(width,height,pathData){var data="";var pathPoints=pathData.points;for(var i=0;i<pathPoints.length;i++){var _xpos3=pathPoints[i].x/100*width;var _ypos3=pathPoints[i].y/100*height;var controlPoints=pathData.controlPoints;var least=height<width?height:width;var currentXValue=controlPoints.t.x/100*least;var currentYValue=controlPoints.l.y/100*least;if(currentXValue>=width)currentXValue=width;if(currentXValue<=0)currentXValue=0;if(currentYValue>=height)currentYValue=height;if(currentYValue<=0)currentYValue=0;if(i===0){data="M"+_xpos3+","+_ypos3+" C"+_xpos3+","+_ypos3;}else{if(i===1){_xpos3=currentXValue;data+=" "+_xpos3+","+_ypos3+" "+_xpos3+","+_ypos3+" C"+_xpos3+","+_ypos3;}else if(i===2){_xpos3=currentXValue;_ypos3=currentYValue;data+=" "+_xpos3+","+_ypos3+" "+_xpos3+","+_ypos3+" C"+_xpos3+","+_ypos3;}else if(i===3){_ypos3=currentYValue;data+=" "+_xpos3+","+_ypos3+" "+_xpos3+","+_ypos3+" C"+_xpos3+","+_ypos3;}else{data+=" "+_xpos3+","+_ypos3+" "+_xpos3+","+_ypos3+" C"+_xpos3+","+_ypos3;}}}var xpos=pathPoints[0].x/100*width;var ypos=pathPoints[0].y/100*height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";// pathData.controlPoints.t.x = (currentXValue / width) * 100;
// pathData.controlPoints.l.y = (currentYValue / height) * 100;
var newControlPoints={t:{},l:{}};newControlPoints.t.x=currentXValue/width*100;newControlPoints.t.y=controlPoints.t.y;newControlPoints.l.x=controlPoints.l.x;newControlPoints.l.y=currentYValue/height*100;return{data:data,pathDetails:[{data:data,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData,newControlPoints:newControlPoints};}function getStripe(width,height,pathData){var data="";var pathPoints=pathData.points;var controlPoints=pathData.controlPoints;var currentYValue=controlPoints.l.y/100*height;if(currentYValue>=0.99*height)currentYValue=0.99*height;if(currentYValue<=0)currentYValue=0;var xpos_rt=pathPoints[1].x/100*width;var ypos_rt=pathPoints[1].y/100*height;var xpos_lb=pathPoints[2].x/100*width;var ypos_lb=pathPoints[2].y/100*height;var angle=Math.atan2(ypos_rt-ypos_lb,xpos_rt-xpos_lb);var xpos3=pathPoints[3].x/100*width;var ypos3=currentYValue;var xpos1=xpos3+700*Math.cos(angle);var ypos1=ypos3+700*Math.sin(angle);var res=checkLineIntersection(xpos3,ypos3,xpos1,ypos1,0,0,xpos_rt,ypos_rt);xpos1=res.x;ypos1=res.y;var data="M"+xpos1+","+ypos1+" C"+xpos1+","+ypos1;for(var i=1;i<pathPoints.length;i++){var xpos=pathPoints[i].x/100*width;var ypos=pathPoints[i].y/100*height;if(i===3){ypos=currentYValue;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;}else{data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;}}data+=" "+xpos1+","+ypos1+" "+xpos1+","+ypos1+"z";var newControlPoints={l:{}};newControlPoints.l.x=controlPoints.l.x;newControlPoints.l.y=currentYValue/height*100;return{data:data,pathDetails:[{data:data,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData,newControlPoints:newControlPoints};}function checkLineIntersection(line1StartX,line1StartY,line1EndX,line1EndY,line2StartX,line2StartY,line2EndX,line2EndY){// if the lines intersect, the result contains the x and y of the intersection (treating the lines as infinite) and booleans for whether line segment 1 or line segment 2 contain the point
var denominator,a,b,numerator1,numerator2,result={x:null,y:null};denominator=(line2EndY-line2StartY)*(line1EndX-line1StartX)-(line2EndX-line2StartX)*(line1EndY-line1StartY);if(denominator===0){return result;}a=line1StartY-line2StartY;b=line1StartX-line2StartX;numerator1=(line2EndX-line2StartX)*a-(line2EndY-line2StartY)*b;numerator2=(line1EndX-line1StartX)*a-(line1EndY-line1StartY)*b;a=numerator1/denominator;b=numerator2/denominator;result.x=line1StartX+a*(line1EndX-line1StartX);result.y=line1StartY+a*(line1EndY-line1StartY);return result;};function getSimplePath(width,height,pathData){var pathPoints=pathData.points;var data="",xpos,ypos;for(var i=0;i<pathPoints.length;i++){xpos=pathPoints[i].x/100*width;ypos=pathPoints[i].y/100*height;if(i===0)data="M"+xpos+","+ypos+" C"+xpos+","+ypos;else data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;}xpos=pathPoints[0].x/100*width;ypos=pathPoints[0].y/100*height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";return{data:data,pathDetails:[{data:data,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData};}function getHexagon(width,height,pathData){var data="",xpos;var least=height<width?height:width;var _thickn=pathData.controlPoints.t.x/100*least;if(_thickn<=0)_thickn=0;if(_thickn>=width)_thickn=width;var data="M"+_thickn+",0 C"+_thickn+",0";xpos=width-_thickn;data+=" "+xpos+",0 "+xpos+",0 C"+xpos+",0";data+=" "+width+","+height/2+" "+width+","+height/2+" C"+width+","+height/2;data+=" "+xpos+","+height+" "+xpos+","+height+" C"+xpos+","+height;data+=" "+_thickn+","+height+" "+_thickn+","+height+" C"+_thickn+","+height;data+=" 0,"+height/2+" 0,"+height/2+" C0,"+height/2;data+=" "+_thickn+",0 "+_thickn+",0z";var positions={t:{}};positions.t.x=_thickn/width*100;positions.t.y=pathData.controlPoints.t.y;return{data:data,pathDetails:[{data:data,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData,newControlPoints:positions};}function getLightning(width,height,pathData){var data="",xpos,ypos;var x_percentArr=[0.4,0.6,0.51,0.77,0.69,1,0.47,0.57,0.24,0.35,0];var y_percentArr=[0,0.29,0.32,0.56,0.6,1,0.69,0.65,0.45,0.39,0.19];for(var i=0;i<x_percentArr.length;i++){xpos=x_percentArr[i]*width;ypos=y_percentArr[i]*height;if(i===0)data="M"+xpos+","+ypos+" C"+xpos+","+ypos;else data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;}xpos=x_percentArr[0]*width;ypos=y_percentArr[0]*height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";return{data:data,pathDetails:[{data:data,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData};}function getParallelogram(width,height,pathData){var data="",xpos,ypos;var x_percentArr=[0,1,1,0];var y_percentArr=[0,0,1,1];// var currentPosition = (pathData.controlPoints.t.x / 100) * width;
var least=height<width?height:width;var currentPosition=pathData.controlPoints.t.x/100*least;if(currentPosition>=0.99*width)currentPosition=0.99*width;if(currentPosition<=0)currentPosition=0;for(var i=0;i<x_percentArr.length;i++){xpos=x_percentArr[i]*width;ypos=y_percentArr[i]*height;if(i===0)data="M"+currentPosition+","+ypos+" C"+currentPosition+","+ypos;else if(i===2){xpos=xpos-currentPosition;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;}else data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;}ypos=y_percentArr[0]*height;data+=" "+currentPosition+","+ypos+" "+currentPosition+","+ypos+"z";var positions={t:{}};positions.t.x=currentPosition/width*100;positions.t.y=pathData.controlPoints.t.y;return{data:data,pathDetails:[{data:data,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData,newControlPoints:positions};}function getTrapezoid(width,height,pathData){var data="",xpos,ypos;var x_percentArr=[0,1,1,0];var y_percentArr=[0,0,1,1];// var currentPosition = (pathData.controlPoints.t.x / 100) * width;
var least=height<width?height:width;var currentPosition=pathData.controlPoints.t.x/100*least;if(currentPosition>=least)currentPosition=least;if(currentPosition<=0)currentPosition=0;for(var i=0;i<x_percentArr.length;i++){xpos=x_percentArr[i]*width;ypos=y_percentArr[i]*height;if(i===0)data="M"+currentPosition+","+ypos+" C"+currentPosition+","+ypos;else if(i===1){xpos=xpos-currentPosition;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;}else data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;}ypos=y_percentArr[0]*height;data+=" "+currentPosition+","+ypos+" "+currentPosition+","+ypos+"z";var positions={t:{}};positions.t.x=currentPosition/width*100;positions.t.y=pathData.controlPoints.t.y;return{data:data,pathDetails:[{data:data,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData,newControlPoints:positions};}function getCollate(width,height,pathData){var data="",xpos,ypos;var x_percentArr=[0,1,0.5,0,1,0];var y_percentArr=[0,0,0.5,1,1,0];for(var i=0;i<x_percentArr.length;i++){xpos=x_percentArr[i]*width;ypos=y_percentArr[i]*height;if(i===0)data="M"+xpos+","+ypos+" C"+xpos+","+ypos;else data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;}xpos=x_percentArr[0]*width;ypos=y_percentArr[0]*height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";return{data:data,pathDetails:[{data:data,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData};}function getHandleAngle(x,y,width,height){var centerX=width/2;var centerY=height/2;var ax=x/width*(centerX*2);var ay=y/height*(centerY*2);var angle=Math.atan2(ay-centerY,ax-centerX);return angle;}function createPie(mWidth,mHeight,pathData,width,height,xOffset,yOffset,ang1,ang2,isDonut,addAngle){var data9="";var least=0.00001;var dia=6.2831;var crossAngle=ang1;if(addAngle!==undefined)crossAngle=addAngle;var he=Math.abs(ang1)>dia?ang1%dia:crossAngle,se=Math.abs(ang2)>dia?ang2%dia:ang2,len=Math.min(dia,Math.abs(se-he)),sgn=crossAngle<ang2?+1:-1;var avd=crossAngle,point1X,point1Y,point2X,point2Y;for(var i=len;i>least;){var va=avd+sgn*Math.min(i,Math.PI/2.0);var se=(va-avd)*.5;var bt=se+avd;var he=.5*Math.cos(se);var ve=.5*Math.sin(se);var mx=he;var my=-ve;var q1=mx*mx+my*my;var q2=q1+mx*he+my*ve;var lQ=q1*q2+q1*q2;lQ=(Math.sqrt(lQ)-q2)/(mx*ve-my*he);var htu=mx-lQ*1.33*my;var vtu=my+lQ*1.33*mx;var huz=htu;var vuz=-vtu;var cx=htu*Math.cos(bt)-vtu*Math.sin(bt);var cy=htu*Math.sin(bt)+vtu*Math.cos(bt);var outTanX=huz*Math.cos(bt)-vuz*Math.sin(bt);var outTanY=huz*Math.sin(bt)+vuz*Math.cos(bt);var cpX=((.5*Math.cos(avd)+.5)*width+xOffset).toFixed(2);var cpY=((.5*Math.sin(avd)+.5)*height+yOffset).toFixed(2);if(avd===crossAngle){data9=data9+'M'+cpX+","+cpY;point1X=cpX;point1Y=cpY;}cpX=((.5*Math.cos(va)+.5)*width+xOffset).toFixed(2);cpY=((.5*Math.sin(va)+.5)*height+yOffset).toFixed(2);point2X=cpX;point2Y=cpY;data9=data9+' C'+((cx+.5)*width+xOffset).toFixed(2)+","+((cy+.5)*height+yOffset).toFixed(2)+" "+((outTanX+.5)*width+xOffset).toFixed(2)+","+((outTanY+.5)*height+yOffset).toFixed(2)+" "+cpX+","+cpY;i-=Math.abs(va-avd);avd=va;}var playArr=data9.split(" ");playArr.reverse();var jlen=playArr.length;if(isDonut===true){var cinc=0;var revData=" "+playArr[0];for(var j=1;j<jlen;j++){if(j===jlen-1){playArr[j]=playArr[j].substr(1);cinc=2;}var str=cinc===0?" C":" ";revData=revData+(str+(cinc===1?playArr[j].substr(1):playArr[j]));cinc=cinc===2?0:cinc+1;}data9=revData;}if(pathData.type==="pie"){cpX=mWidth/2;cpY=mHeight/2;data9=data9+' C'+cpX+","+cpY+" "+cpX+","+cpY+" "+cpX+","+cpY;}return{data:data9+'z',x1:point1X,y1:point1Y,x2:point2X,y2:point2Y};}function getPie(width,height,pathData){var data="";var p1x=pathData.controlPoints.p1.x/100*width,p1y=pathData.controlPoints.p1.y/100*height;var p2x=pathData.controlPoints.p2.x/100*width,p2y=pathData.controlPoints.p2.y/100*height;var ang1=getHandleAngle(p1x,p1y,width,height);var a1=ang1*180/Math.PI;if(a1<0){var temp=a1*-1;a1=180+(180-temp);ang1=a1*Math.PI/180;}var ang2=getHandleAngle(p2x,p2y,width,height);var a1=ang2*180/Math.PI;if(a1<0){var temp=a1*-1;a1=180+(180-temp);ang2=a1*Math.PI/180;}var ang1Deg=ang1*180/Math.PI;var ang2Deg=ang2*180/Math.PI;var addAngle=ang1;if(ang1Deg>ang2Deg){addAngle=(ang1Deg-360)*Math.PI/180;}var circle1=createPie(width,height,pathData,width,height,0,0,ang1,ang2,false,addAngle);var newControlPoints={p1:{},p2:{}};newControlPoints.p1.x=circle1.x1/width*100;newControlPoints.p1.y=circle1.y1/height*100;newControlPoints.p2.x=circle1.x2/width*100;newControlPoints.p2.y=circle1.y2/height*100;var data=String(circle1.data);if(pathData.type==="blockarc"){var circle2=createPie(width,height,pathData,width/2,height/2,width/4,height/4,ang1,ang2,true,addAngle);var newData2=circle2.data;data=data.slice(0,-1);var newDataArr=data.split(" ");var str=newDataArr[newDataArr.length-1];newData2=newData2.slice(0,-1);newData2+=" C"+circle2.x1+","+circle2.y1+" "+circle1.x1+","+circle1.y1+" "+circle1.x1+","+circle1.y1+"z";data=data+" C"+str+" "+str+newData2;}else if(pathData.type==="pie"){data=data.slice(0,-1);data+=" C"+width/2+","+height/2+" "+circle1.x1+","+circle1.y1+" "+circle1.x1+","+circle1.y1+"z";}else{data=data.slice(0,-1);data+=" C"+circle1.x2+","+circle1.y2+" "+circle1.x1+","+circle1.y1+" "+circle1.x1+","+circle1.y1+"z";}return{data:data,pathDetails:[{data:data,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData,newControlPoints:newControlPoints};}function getHalfFrame(width,height,pathData){var xpos,ypos;var x_percentArr=[0,100,75,25,25,0];var y_percentArr=[0,0,25,25,75,100];var arrLen=y_percentArr.length;var xpos2=x_percentArr[0]/100*width;var ypos2=y_percentArr[0]/100*height;var result0;var data0;var data1="M"+xpos2+","+ypos2+" C"+xpos2+","+ypos2;var least=height<width?height:width;var currentXValue=pathData.controlPoints.t.x/100*least;var currentYValue=pathData.controlPoints.l.y/100*least;if(currentXValue>=width)currentXValue=width;if(currentXValue<=0)currentXValue=0;if(currentYValue>=height)currentYValue=height;if(currentYValue<=0)currentYValue=0;for(var i=1;i<arrLen;i++){var xpos=x_percentArr[i]/100*width;var ypos=y_percentArr[i]/100*height;if(x_percentArr[i]===75&&y_percentArr[i]===25){result0=checkLineIntersection(0,currentYValue,width,currentYValue,width,0,0,height);xpos=result0.x;ypos=result0.y;data0=data1+" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;}else if(x_percentArr[i]===25&&y_percentArr[i]===75){var result1=checkLineIntersection(currentXValue,0,currentXValue,height,width,0,0,height);xpos=result1.x;ypos=result1.y;var angle=Math.atan2(result0.y-result1.y,result0.x-result1.x);if(angle<=0){data0=data0+" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;}else{data0=data1;}}else if(x_percentArr[i]===25&&y_percentArr[i]===25){xpos=currentXValue;//((xp/100)*width);
ypos=currentYValue;//((yp/100)*height)
data0=data0+" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;}if(i===1){data1=data1+" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;}if(i===5){data1=data0+" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;}}data1=data1+" "+xpos2+","+ypos2+" "+xpos2+","+ypos2+"z";var newControlPoints={t:{},l:{}};newControlPoints.t.x=currentXValue/width*100;newControlPoints.t.y=pathData.controlPoints.t.y;newControlPoints.l.x=pathData.controlPoints.l.x;newControlPoints.l.y=currentYValue/height*100;return{data:data1,pathDetails:[{data:data1,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData,newControlPoints:newControlPoints};}function drawData(xpos,ypos){return" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;}function getFrame(width,height,pathData){var data1="M"+0+","+0+" C"+0+","+0;var least=height<width?height:width;var _thickn=pathData.controlPoints.t.x/100*least;if(_thickn>least/2)_thickn=least/2;if(_thickn<=0.01*least)_thickn=0.01*least;// var _thickn = (pathData.controlPoints.t.x / 100) * width;
data1=data1+drawData(width,0);data1=data1+drawData(width,height);data1=data1+drawData(0,height);data1=data1+drawData(0,0);data1=data1+drawData(_thickn,0);data1=data1+drawData(_thickn,height-_thickn);data1=data1+drawData(width-_thickn,height-_thickn);data1=data1+drawData(width-_thickn,_thickn);data1=data1+drawData(0,_thickn);data1=data1+" "+0+","+0+" "+0+","+0+"z";// pathData.controlPoints.t.x = (_thickn / least) * 100;
var newControlPoints={t:{}};newControlPoints.t.x=_thickn/width*100;newControlPoints.t.y=pathData.controlPoints.t.y;return{data:data1,pathDetails:[{data:data1,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData,newControlPoints:newControlPoints};}function getTriangle(width,height,pathData){var data="";var offset=0;if(pathData.controlPoints.t!==undefined)offset=pathData.controlPoints.t.x;else if(pathData.offset!==undefined)offset=pathData.offset;var currentPosition=offset/100*width;if(currentPosition>=width)currentPosition=width;if(currentPosition<=0)currentPosition=0;// var least = (height < width) ? height : width
// var currentPosition = (offset / 100) * least;
var data="M"+currentPosition+","+0+" C"+currentPosition+","+0;data+=drawData(width,height);data+=drawData(0,height);data+=" "+currentPosition+","+0+" "+currentPosition+","+0+"z";if(pathData.controlPoints.t!==undefined){var newControlPoints={t:{}};newControlPoints.t.x=currentPosition/width*100;newControlPoints.t.y=pathData.controlPoints.t.y;}return{data:data,pathDetails:[{data:data,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData,newControlPoints:newControlPoints};}function getPlus(width,height,pathData){var arrX=[];var arrY=[];var midX=width/2;var midY=height/2;var least=height<width?height:width;var xoffset=0;var yoffset=0;var _thickn=least/2-pathData.controlPoints.l.y/100*least;if(_thickn>least/2)_thickn=least/2;if(_thickn<least/2*0.01)_thickn=least/2*0.01;arrX.push(midX-_thickn);arrY.push(0);arrX.push(midX+_thickn);arrY.push(0);arrX.push(midX+_thickn);arrY.push(midY-_thickn);arrX.push(width);arrY.push(midY-_thickn);arrX.push(width);arrY.push(midY+_thickn);arrX.push(midX+_thickn);arrY.push(midY+_thickn);arrX.push(midX+_thickn);arrY.push(height);arrX.push(midX-_thickn);arrY.push(height);arrX.push(midX-_thickn);arrY.push(midY+_thickn);arrX.push(0);arrY.push(midY+_thickn);arrX.push(0);arrY.push(midY-_thickn);arrX.push(midX-_thickn);arrY.push(midY-_thickn);var arrLen=arrY.length;var data="M"+(arrX[0]+xoffset)+","+(arrY[0]+yoffset)+" C"+(arrX[0]+xoffset)+","+(arrY[0]+yoffset);for(var i=1;i<arrLen;i++){var xpos=arrX[i]+xoffset;var ypos=arrY[i]+yoffset;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;}data+=" "+(arrX[0]+xoffset)+","+(arrY[0]+yoffset)+" "+(arrX[0]+xoffset)+","+(arrY[0]+yoffset)+"z";var newControlPoints={l:{}};newControlPoints.l.x=pathData.controlPoints.l.x;newControlPoints.l.y=(midY-_thickn)/height*100;return{data:data,pathDetails:[{data:data,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData,newControlPoints:newControlPoints};}function distance(x1,x2,y1,y2){var dx=x1-x2;var dy=y1-y2;return Math.sqrt(dx*dx+dy*dy);}function getMultiply(width,height,pathData){var angle;var midX=width/2;var midY=height/2;var least=height<width?height:width;var _thickn=least/2-pathData.controlPoints.l.y/100*least;if(_thickn>=least/4)_thickn=least/4;if(_thickn<=0.01*least)_thickn=0.01*least;var arrX=[];var arrY=[];var angl=-45*(Math.PI/180);var totalDistance=distance(midX,0,midY,0)/2;angle=Math.atan2(midY-0,midX-0);totalDistance=least/2;var nwX=midX+totalDistance*Math.cos(angle);var nwY=midY+totalDistance*Math.sin(angle);angl=-45*(Math.PI/180);var a1x=nwX+_thickn*Math.cos(angl);var a1y=nwY+_thickn*Math.sin(angl);angl=135*(Math.PI/180);var a2x=nwX+_thickn*Math.cos(angl);var a2y=nwY+_thickn*Math.sin(angl);angle=Math.atan2(midY-0,midX-width);var neX=midX+totalDistance*Math.cos(angle);var neY=midY+totalDistance*Math.sin(angle);angl=45*(Math.PI/180);var a3x=neX+_thickn*Math.cos(angl);var a3y=neY+_thickn*Math.sin(angl);angl=225*(Math.PI/180);var a4x=neX+_thickn*Math.cos(angl);var a4y=neY+_thickn*Math.sin(angl);angle=Math.atan2(midY-height,midX-width);var seX=midX+totalDistance*Math.cos(angle);var seY=midY+totalDistance*Math.sin(angle);angl=135*(Math.PI/180);var a5x=seX+_thickn*Math.cos(angl);var a5y=seY+_thickn*Math.sin(angl);angl=-45*(Math.PI/180);var a6x=seX+_thickn*Math.cos(angl);var a6y=seY+_thickn*Math.sin(angl);angle=Math.atan2(midY-height,midX-0);var swX=midX+totalDistance*Math.cos(angle);var swY=midY+totalDistance*Math.sin(angle);angl=-135*(Math.PI/180);var a7x=swX+_thickn*Math.cos(angl);var a7y=swY+_thickn*Math.sin(angl);angl=45*(Math.PI/180);var a8x=swX+_thickn*Math.cos(angl);var a8y=swY+_thickn*Math.sin(angl);arrX.push(a1x);arrY.push(a1y);arrX.push(a2x);arrY.push(a2y);var res=checkLineIntersection(a2x,a2y,a5x,a5y,a3x,a3y,a8x,a8y);arrX.push(res.x);arrY.push(res.y);arrX.push(a3x);arrY.push(a3y);arrX.push(a4x);arrY.push(a4y);res=checkLineIntersection(a4x,a4y,a7x,a7y,a2x,a2y,a5x,a5y);arrX.push(res.x);arrY.push(res.y);arrX.push(a5x);arrY.push(a5y);arrX.push(a6x);arrY.push(a6y);res=checkLineIntersection(a6x,a6y,a1x,a1y,a7x,a7y,a4x,a4y);arrX.push(res.x);arrY.push(res.y);arrX.push(a7x);arrY.push(a7y);arrX.push(a8x);arrY.push(a8y);res=checkLineIntersection(a8x,a8y,a3x,a3y,a1x,a1y,a6x,a6y);arrX.push(res.x);arrY.push(res.y);var arrLen=arrY.length;var data="M"+arrX[0]+","+arrY[0]+" C"+arrX[0]+","+arrY[0];for(var i=1;i<arrLen;i++){var xpos=arrX[i];var ypos=arrY[i];data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;}data+=" "+arrX[0]+","+arrY[0]+" "+arrX[0]+","+arrY[0]+"z";var newControlPoints={l:{}};newControlPoints.l.x=pathData.controlPoints.l.x;newControlPoints.l.y=(midY-_thickn)/height*100;return{data:data,pathDetails:[{data:data,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData,newControlPoints:newControlPoints};}function getMinus(width,height,pathData){var data="M0,0 C0,0";data+=" "+width+",0 "+width+",0 C"+width+",0";data+=" "+width+","+height+" "+width+","+height+" C"+width+","+height;data+=" 0,"+height+" 0,"+height+" C0,"+height;data+=" 0,0 0,0z";return{data:data,pathDetails:[{data:data,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData};}function getGroupPath(width,height,pathData,storedItem){var colors=Object.keys(pathData.colors);var controlPoints=pathData.controlPoints;var least=height<width?height:width;var datas=[],pathDetails=[];var midX=width/2;var midY=height/2;if(pathData.type==="cube"){var l=controlPoints.l.y/100*least,xpos,ypos;if(l>=least*0.99)l=least*0.99;if(l<0)l=0;var data="M0,"+l+" C0,"+l;xpos=l;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width-l;ypos=l;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;data+=" 0,"+l+" 0,"+l+"z";datas.push(data);pathDetails.push({data:data,isFill:true,color:pathData.colors[colors[0]]});var data="M0,"+l+" C0,"+l;xpos=width-l;ypos=l;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width-l;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;data+=" 0,"+l+" 0,"+l+"z";datas.push(data);pathDetails.push({data:data,isFill:true,color:pathData.colors[colors[1]]});var data="M"+(width-l)+","+l+" C"+(width-l)+","+l;xpos=width;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=height-l;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width-l;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;data+=" "+(width-l)+","+l+" "+(width-l)+","+l+"z";datas.push(data);pathDetails.push({data:data,isFill:true,color:pathData.colors[colors[2]]});var newControlPoints={l:{}};newControlPoints.l.x=pathData.controlPoints.l.x;newControlPoints.l.y=l/height*100;}else if(pathData.type==="cylinder"){var r=controlPoints.m.y/100*least,xpos,ypos;if(r>=least/2)r=least/2;if(r<=0)r=0;var ang1=180*Math.PI/180;var ang2=360*Math.PI/180;var circle1=createPie(width,height,pathData,-width,-r,width,height,ang1,ang2);var data=String(circle1.data);data=data.slice(0,-1);data+=" C"+circle1.x2+","+circle1.y2+" "+0+","+r/2+" "+0+","+r/2+" C"+width+","+r/2+" "+width+","+r/2+" "+width+","+r/2;data+=" C"+width+","+r/2+" "+circle1.x1+","+circle1.y1+" "+circle1.x1+","+circle1.y1+"z";datas.push(data);pathDetails.push({data:data,isFill:true,color:pathData.colors[colors[0]]});ang1=-180*Math.PI/180;ang2=190*Math.PI/180;var _circle=createPie(width,height,pathData,width,r,0,0,ang1,ang2);var data=String(_circle.data);data=data.slice(0,-1);data+=" C"+_circle.x2+","+_circle.y2+" "+_circle.x1+","+_circle.y1+" "+_circle.x1+","+_circle.y1+"z";datas.push(data);pathDetails.push({data:data,isFill:true,color:pathData.colors[colors[1]]});var newControlPoints={m:{}};newControlPoints.m.x=pathData.controlPoints.m.x;newControlPoints.m.y=r/height*100;}else if(pathData.type==="grouped_triangle"){var b=controlPoints.b.x/100*least,xpos,ypos;var midX=width/2;if(b<=0)b=0;else if(b>=width)b=width;var data="M"+midX+",0 C"+midX+",0";xpos=0;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=b;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;data+=" "+midX+",0 "+midX+",0z";datas.push(data);pathDetails.push({data:data,isFill:true,color:pathData.colors[colors[0]]});var data="M"+b+","+height+" C"+b+","+height;xpos=width;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=midX;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;data+=" "+b+","+height+" "+b+","+height+"z";datas.push(data);pathDetails.push({data:data,isFill:true,color:pathData.colors[colors[1]]});var newControlPoints={b:{}};newControlPoints.b.x=b/width*100;newControlPoints.b.y=controlPoints.b.y;}else if(pathData.type==="grouped_rectangle"){var t=controlPoints.t.x/100*least,xpos,ypos;var midX=width/2;if(t<=0)t=0;else if(t>=width)t=width;var data="M0,0 C0,0";xpos=t;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=t;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;data+=" 0,0 0,0z";datas.push(data);pathDetails.push({data:data,isFill:true,color:pathData.colors[colors[0]]});var data="M"+t+",0 C"+t+",0";xpos=width;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=t;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;data+=" "+t+",0 "+t+",0z";datas.push(data);pathDetails.push({data:data,isFill:true,color:pathData.colors[colors[1]]});var newControlPoints={t:{}};newControlPoints.t.x=t/width*100;newControlPoints.t.y=controlPoints.t.y;}else if(pathData.type==="equal_to"){var l=controlPoints.l.y/100*height,r=controlPoints.r.y/100*height,xpos,ypos;var midX=width/2,midY=height/2;var thickness=0;if(storedItem!==undefined){thickness=(storedItem.getIn(["pathData","controlPoints","r","y"])-controlPoints.l.y)/100*height;//((storedItem.getIn(["pathData", "controlPoints", "r", "y"]) / 100) * height) - ((storedItem.getIn(["pathData", "controlPoints", "l", "y"]) / 100) * height);
}else{thickness=r-l;}if(thickness>=midY*.85)thickness=midY*.85;l=r-thickness;if(l<=0){l=0;r=l+thickness;}if(r>midY){r=midY;l=r-thickness;}if(l>=r){l=r;}var data="M0,"+l+" C0,"+l;xpos=width;ypos=l;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=r;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=r;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;data+=" 0,"+l+" 0,"+l+"z";datas.push(data);pathDetails.push({data:data,isFill:true,color:pathData.colors[colors[0]]});var data="M0,"+(height-l)+" C0,"+(height-l);xpos=width;ypos=height-l;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=height-r;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=height-r;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;data+=" 0,"+(height-l)+" 0,"+(height-l)+"z";datas.push(data);pathDetails.push({data:data,isFill:true,color:pathData.colors[colors[1]]});pathData.controlPoints.l.y=l/height*100;pathData.controlPoints.r.y=r/height*100;var newControlPoints={l:{},r:{}};newControlPoints.l.x=controlPoints.l.x;newControlPoints.l.y=l/height*100;newControlPoints.r.x=controlPoints.r.x;newControlPoints.r.y=r/height*100;}else if(pathData.type==="curved_right_arrow"){var least=height<width?height:width;var r=controlPoints.r.y/100*least;var m=controlPoints.m.y/100*least;var thick1=least-controlPoints.r.y/100*least;var b=width-(100-controlPoints.b.x)*width/100;if(b>=width)b=width;if(b<0)b=0;var thick2=least-controlPoints.m.y/100*least;if(thick1>=least/2)thick1=least/2;if(thick1<=0.01*least)thick1=0.01*least;if(thick2>=thick1)thick2=thick1;if(thick2<=0.01*least)thick2=0.01*least;var _ang=270*Math.PI/180;var _ang2=180*Math.PI/180;var circle1=createPie(width,height,pathData,width*2,height-thick1/2-thick2/2,0,0,_ang,_ang2,false);var bData1=String(circle1.data);var circle2=createPie(width,height,pathData,width*2,height-thick2-(height-(height-thick1/2+thick2/2)),0,thick2,_ang,_ang2,true);var bData2=String(circle2.data);bData2=bData2.slice(0,-1);bData2+=" C"+circle2.x1+","+circle2.y1+" "+circle1.x1+","+circle1.y1+" "+circle1.x1+","+circle1.y1+"z";bData1=bData1.slice(0,-1);var newDataArr=bData1.split(" ");var str=newDataArr[newDataArr.length-1];bData1=bData1+" C"+str+" "+str+bData2;datas.push(bData1);pathDetails.push({data:bData1,isFill:true,color:pathData.colors[colors[0]]});_ang=angle(width,(height-thick1/2-thick2/2)/2,b,height)*Math.PI/180;_ang2=180*Math.PI/180;var circle1=createPie(width,height,pathData,width*2,height-thick1/2-thick2/2,0,0,_ang,_ang2,false);var bData1=String(circle1.data);var circle2=createPie(width,height,pathData,width*2,height-thick2-(height-(height-thick1/2+thick2/2)),0,thick2,_ang,_ang2,true);var bData2=String(circle2.data);bData1=bData1.slice(0,-1);var newDataArr=bData1.split(" ");var str=newDataArr[newDataArr.length-1];var data="M"+circle1.x1+","+circle1.y1+" C"+circle1.x1+","+circle1.y1;xpos=circle1.x1;ypos=parseInt(circle2.y1,10)-thick2/2-thick1/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=parseInt(circle2.y1,10)-thick2/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=circle2.x1;ypos=parseInt(circle1.y1,10)+thick2/2+thick1/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=circle2.x1;ypos=circle2.y1;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;data+=" "+circle1.x1+","+circle1.y1+" "+circle1.x1+","+circle1.y1+"z";bData2=bData2.slice(0,-1);var curve2=bData1+" C"+str+" "+str+bData2;curve2+=" C"+circle2.x1+","+circle2.y1+" "+circle1.x1+","+circle1.y1+" "+circle1.x1+","+circle1.y1+"z";data=curve2+data;datas.push(data);pathDetails.push({data:data,isFill:true,color:pathData.colors[colors[1]]});var newControlPoints={m:{},r:{},b:{}};newControlPoints.r.x=controlPoints.r.x;newControlPoints.r.y=(parseInt(circle2.y1,10)-thick2/2-thick1/2)/height*100;newControlPoints.m.x=circle1.x1/width*100;newControlPoints.m.y=circle1.y1/height*100;newControlPoints.b.x=circle1.x1/width*100;newControlPoints.b.y=controlPoints.b.y;}else if(pathData.type==="curved_left_arrow"){var least=height<width?height:width;var l=controlPoints.l.y/100*least;var m=controlPoints.m.y/100*least;var thick1=least-controlPoints.l.y/100*least;var b=controlPoints.b.x*least/100;if(b<=0)b=0;var thick2=least-controlPoints.m.y/100*least;if(thick1>=least/2)thick1=least/2;if(thick1<=0.01*least)thick1=0.01*least;if(thick2>=thick1)thick2=thick1;if(thick2<=0.01*least)thick2=0.01*least;var _ang3=0*Math.PI/180;var _ang4=-90*Math.PI/180;var circle1=createPie(width,height,pathData,width*2,height-thick1/2-thick2/2,-width,0,_ang3,_ang4,false);var bData1=String(circle1.data);var circle2=createPie(width,height,pathData,width*2,height-thick2-(height-(height-thick1/2+thick2/2)),-width,thick2,_ang3,_ang4,true);var bData2=String(circle2.data);bData2=bData2.slice(0,-1);bData2+=" C"+circle2.x1+","+circle2.y1+" "+circle1.x1+","+circle1.y1+" "+circle1.x1+","+circle1.y1+"z";bData1=bData1.slice(0,-1);var newDataArr=bData1.split(" ");var str=newDataArr[newDataArr.length-1];bData1=bData1+" C"+str+" "+str+bData2;datas.push(bData1);pathDetails.push({data:bData1,isFill:true,color:pathData.colors[colors[0]]});_ang4=0*Math.PI/180;_ang3=angle(0,(height-thick1/2-thick2/2)/2,b,height)*Math.PI/180;var circle1=createPie(width,height,pathData,width*2,height-thick1/2-thick2/2,-width,0,_ang3,_ang4,false);var bData1=String(circle1.data);var circle2=createPie(width,height,pathData,width*2,height-thick2-(height-(height-thick1/2+thick2/2)),-width,thick2,_ang3,_ang4,true);var bData2=String(circle2.data);bData1=bData1.slice(0,-1);var newDataArr=bData1.split(" ");var str=newDataArr[newDataArr.length-1];var data="M"+circle1.x1+","+circle1.y1+" C"+circle1.x1+","+circle1.y1;xpos=circle1.x1;ypos=parseInt(circle2.y1,10)-thick2/2-thick1/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=parseInt(circle2.y1,10)-thick2/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=circle2.x1;ypos=parseInt(circle1.y1,10)+thick2/2+thick1/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=circle2.x1;ypos=circle2.y1;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;data+=" "+circle1.x1+","+circle1.y1+" "+circle1.x1+","+circle1.y1+"z";bData2=bData2.slice(0,-1);var curve2=bData1+" C"+str+" "+str+bData2;curve2+=" C"+circle2.x1+","+circle2.y1+" "+circle1.x1+","+circle1.y1+" "+circle1.x1+","+circle1.y1+"z";data=curve2+data;datas.push(data);pathDetails.push({data:data,isFill:true,color:pathData.colors[colors[1]]});var newControlPoints={m:{},l:{},b:{}};newControlPoints.l.x=controlPoints.l.x;newControlPoints.l.y=(parseInt(circle2.y1,10)-thick2/2-thick1/2)/height*100;newControlPoints.m.x=circle1.x1/width*100;newControlPoints.m.y=circle1.y1/height*100;newControlPoints.b.x=circle2.x1/width*100;newControlPoints.b.y=controlPoints.b.y;// datas.push(data)
}else if(pathData.type==="curved_up_arrow"){var least=height<width?height:width;var t=controlPoints.t.x/100*least;var m=controlPoints.m.x/100*least;var thick1=least-controlPoints.t.x/100*least;var r=controlPoints.r.y*least/100;if(r<=0)r=0;var thick2=least-controlPoints.m.x/100*least;if(thick1>=least/2)thick1=least/2;if(thick1<=0.01*least)thick1=0.01*least;if(thick2>=thick1)thick2=thick1;if(thick2<=0.01*least)thick2=0.01*least;var _ang5=180*Math.PI/180;var _ang6=90*Math.PI/180;var bData1=String(createPie(width,height,pathData,width-thick1/2-thick2/2,height*2,0,-height,_ang5,_ang6,false).data);var bData2=String(createPie(width,height,pathData,width-thick2-(width-(width-thick1/2+thick2/2)),height*2,thick2,-height,_ang5,_ang6,true).data);bData1=bData1.slice(0,-1);var newDataArr=bData1.split(" ");var str=newDataArr[newDataArr.length-1];bData1=bData1+" C"+str+" "+str+bData2;datas.push(bData1);pathDetails.push({data:bData1,isFill:true,color:pathData.colors[colors[0]]});_ang6=90*Math.PI/180;_ang5=angle(width/2,0,width,r)*Math.PI/180;var circle1=createPie(width,height,pathData,width-thick1/2-thick2/2,height*2,0,-height,_ang5,_ang6,false);var bData1=String(circle1.data);var circle2=createPie(width,height,pathData,width-thick2-(width-(width-thick1/2+thick2/2)),height*2,thick2,-height,_ang5,_ang6,true);var bData2=String(circle2.data);bData1=bData1.slice(0,-1);var newDataArr=bData1.split(" ");var str=newDataArr[newDataArr.length-1];var data="M"+circle1.x1+","+circle1.y1+" C"+circle1.x1+","+circle1.y1;xpos=parseInt(circle2.x1,10)-thick2/2-thick1/2;ypos=circle1.y1;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=parseInt(circle2.x1,10)-thick2/2;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=parseInt(circle1.x1,10)+thick2/2+thick1/2;ypos=circle2.y1;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=circle2.x1;ypos=circle2.y1;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;data+=" "+circle1.x1+","+circle1.y1+" "+circle1.x1+","+circle1.y1+"z";bData2=bData2.slice(0,-1);bData1=bData1+" C"+str+" "+str+bData2+data;datas.push(bData1);pathDetails.push({data:bData1,isFill:true,color:pathData.colors[colors[1]]});var newControlPoints={m:{},t:{},r:{}};newControlPoints.t.x=(parseInt(circle2.x1,10)-thick2/2-thick1/2)/width*100;newControlPoints.t.y=controlPoints.t.y;newControlPoints.m.x=circle1.x1/width*100;newControlPoints.m.y=circle1.y1/height*100;newControlPoints.r.x=controlPoints.r.x;newControlPoints.r.y=circle2.y1/height*100;}else if(pathData.type==="curved_down_arrow"){var least=height<width?height:width;var b=controlPoints.b.x/100*least;var m=controlPoints.m.x/100*least;var thick1=least-controlPoints.b.x/100*least;var r=controlPoints.r.y*least/100;if(r>=height)r=height;var thick2=least-controlPoints.m.x/100*least;if(thick1>=least/2)thick1=least/2;if(thick1<=0)thick1=0;if(thick2>=thick1)thick2=thick1;if(thick2<=0)thick2=0;var _ang7=180*Math.PI/180;var _ang8=270*Math.PI/180;var bData1=String(createPie(width,height,pathData,width-thick1/2-thick2/2,height*2,0,0,_ang7,_ang8,false).data);var bData2=String(createPie(width,height,pathData,width-thick2-(width-(width-thick1/2+thick2/2)),height*2,thick2,0,_ang7,_ang8,true).data);bData1=bData1.slice(0,-1);var newDataArr=bData1.split(" ");var str=newDataArr[newDataArr.length-1];bData1=bData1+" C"+str+" "+str+bData2;datas.push(bData1);pathDetails.push({data:bData1,isFill:true,color:pathData.colors[colors[0]]});_ang7=angle(width/2,height,width,r)*Math.PI/180;_ang8=-90*Math.PI/180;var circle1=createPie(width,height,pathData,width-thick1/2-thick2/2,height*2,0,0,_ang7,_ang8,false);var bData1=String(circle1.data);var circle2=createPie(width,height,pathData,width-thick2-(width-(width-thick1/2+thick2/2)),height*2,thick2,0,_ang7,_ang8,true);var bData2=String(circle2.data);bData1=bData1.slice(0,-1);var newDataArr=bData1.split(" ");var str=newDataArr[newDataArr.length-1];var data="M"+circle1.x1+","+circle1.y1+" C"+circle1.x1+","+circle1.y1;xpos=parseInt(circle2.x1,10)-thick2/2-thick1/2;ypos=circle1.y1;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=parseInt(circle2.x1,10)-thick2/2;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=parseInt(circle1.x1,10)+thick2/2+thick1/2;ypos=circle2.y1;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=circle2.x1;ypos=circle2.y1;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;data+=" "+circle1.x1+","+circle1.y1+" "+circle1.x1+","+circle1.y1+"z";bData2=bData2.slice(0,-1);bData1=bData1+" C"+str+" "+str+bData2+data;datas.push(bData1);pathDetails.push({data:bData1,isFill:true,color:pathData.colors[colors[1]]});var newControlPoints={m:{},b:{},r:{}};newControlPoints.r.x=controlPoints.r.x;newControlPoints.r.y=circle1.y1/height*100;newControlPoints.m.x=circle1.x1/width*100;newControlPoints.m.y=circle1.y1/height*100;newControlPoints.b.x=(parseInt(circle2.x1,10)-thick2/2-thick1/2)/width*100;newControlPoints.b.y=controlPoints.b.y;}else if(pathData.type==="striped_right_arrow"){var least=height;var tr=width-(100-controlPoints.t.x)*least/100;var _thickn=least/2-controlPoints.l.y/100*least;var striped_width=least*0.15;var stripe_1=striped_width*0.25;var stripe_2=striped_width*0.50;var delay=striped_width*0.125;if(tr<=striped_width)tr=striped_width;if(tr>=width)tr=width;if(_thickn>=least/2)_thickn=least/2;if(_thickn<=least/2*0.01)_thickn=least/2*0.01;var stripe1_data="M0,"+(midY-_thickn)+" C0,"+(midY-_thickn);xpos=stripe_1;ypos=midY-_thickn;stripe1_data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=stripe_1;ypos=midY+_thickn;stripe1_data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=midY+_thickn;stripe1_data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;stripe1_data+=" "+"0,"+(midY-_thickn)+" 0,"+(midY-_thickn)+"z";pathDetails.push({data:stripe1_data,isFill:true,color:pathData.colors[colors[0]]});var stripe2_data="M"+(stripe_1+delay)+","+(midY-_thickn)+" C"+(stripe_1+delay)+","+(midY-_thickn);xpos=stripe_1+stripe_2+delay;ypos=midY-_thickn;stripe2_data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=stripe_1+stripe_2+delay;ypos=midY+_thickn;stripe2_data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=stripe_1+delay;ypos=midY+_thickn;stripe2_data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;stripe2_data+=" "+(stripe_1+delay)+","+(midY-_thickn)+" "+(stripe_1+delay)+","+(midY-_thickn)+"z";pathDetails.push({data:stripe2_data,isFill:true,color:pathData.colors[colors[1]]});var stripe_data=stripe1_data+stripe2_data;var currentXValue=tr;xpos=striped_width;ypos=midY-_thickn;var data="M"+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=midY-_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width,ypos=height/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=midY+_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=striped_width;ypos=midY+_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=striped_width;ypos=midY-_thickn;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";pathDetails.push({data:data,isFill:true,color:pathData.colors[colors[2]]});data=[{data:stripe1_data,isFill:true,color:pathData.colors[colors[0]]},{data:stripe2_data,isFill:true,color:pathData.colors[colors[1]]},{data:data,isFill:true,color:pathData.colors[colors[2]]}];// data = stripe1_data + stripe2_data + data;
newControlPoints={t:{},l:{}};newControlPoints.t.x=tr/width*100;newControlPoints.t.y=controlPoints.t.y;newControlPoints.l.x=controlPoints.l.x;newControlPoints.l.y=(midY-_thickn)/height*100;}return{data:datas,pathDetails:pathDetails,pathData:pathData,newControlPoints:newControlPoints};}function angle(cx,cy,ex,ey){var dy=ey-cy;var dx=ex-cx;var theta=Math.atan2(dy,dx);// range (-PI, PI]
theta*=180/Math.PI;// rads to degs, range (-180, 180]
//if (theta < 0) theta = 360 + theta; // range [0, 360)
return theta;}function getPlaque(width,height,pathData){var least=height<width?height:width;var t=pathData.controlPoints.t.x/100*least,xpos,ypos,ratio=1/2;if(t>=least/2)t=least/2;if(t<=0)t=0;var data="M"+t+",0 C"+t+",0";xpos=width-t;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+(ypos+t*ratio);xpos=width;ypos=t;data+=" "+(xpos-t*ratio)+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=height-t;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+(xpos-t*ratio)+","+ypos;xpos=width-t;ypos=height;data+=" "+xpos+","+(ypos-t*ratio)+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=t;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+(ypos-t*ratio);xpos=0;ypos=height-t;data+=" "+(xpos+t*ratio)+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=t;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+(xpos+t*ratio)+","+ypos;data+=" "+t+","+t*ratio+" "+t+",0z";var newControlPoints={t:{}};newControlPoints.t.x=t/width*100;newControlPoints.t.y=pathData.controlPoints.t.y;var dataP={data:data,color:pathData.colors[Object.keys(pathData.colors)[0]]};if(pathData.isStroke===true){dataP.isStroke=true;dataP.pathStyle={left:strokeWidth/2,top:strokeWidth/2};var shapeStyle={width:width+strokeWidth,height:height+strokeWidth};}else dataP.isFill=true;return{data:data,pathDetails:[dataP],pathData:pathData,shapeStyle:shapeStyle,newControlPoints:newControlPoints};}function getMoon(width,height,pathData){var least=width;var m=pathData.controlPoints.m.x/100*least;if(m<=width*.1)m=width*.1;if(m>=width*.9)m=width*.9;var ang1=90*Math.PI/180;var ang2=270*Math.PI/180;var newData=String(createPie(width,height,pathData,width*2,height,0,0,ang1,ang2).data);ang1=270*Math.PI/180;ang2=90*Math.PI/180;var newData2=String(createPie(width,height,pathData,width*2-m*2,height,m,0,ang1,ang2).data);newData=newData.slice(0,-1);var testARr=newData2.split(" ");testARr.shift();newData=newData+" "+testARr.join(" ");var newControlPoints={m:{}};newControlPoints.m.x=m/width*100;newControlPoints.m.y=pathData.controlPoints.m.y;return{data:newData,pathDetails:[{data:newData,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData,newControlPoints:newControlPoints};}function getDonut(width,height,pathData){var least=height<width?height:width;var m=pathData.controlPoints.m.x/100*least;if(m<=least*.1)m=least*.1;if(m>=least*.9)m=least*.9;if(m>=least*.5)m=least-m;var ang1=-180*Math.PI/180;var ang2=190*Math.PI/180;var circle1=createPie(width,height,pathData,width,height,0,0,ang1,ang2);var newData=String(circle1.data);var circle2=createPie(width,height,pathData,width-m*2,height-m*2,m,m,ang1,ang2,true);var newData2=String(circle2.data);newData=newData.slice(0,-1);var newDataArr=newData.split(" ");var str=newDataArr[newDataArr.length-1];newData2=newData2.slice(0,-1);newData2+=" C"+circle2.x2+","+circle2.y2+" "+circle1.x1+","+circle1.y1+" "+circle1.x1+","+circle1.y1+"z";newData=newData+" C"+str+" "+str+newData2;var newControlPoints={m:{}};newControlPoints.m.x=m/width*100;newControlPoints.m.y=pathData.controlPoints.m.y;return{data:newData,pathDetails:[{data:newData,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData,newControlPoints:newControlPoints};}function getFile(width,height,pathData){var least=height<width?height:width,pathDetails=[];var b=(100-pathData.controlPoints.b.x)/100*least,datas=[],xpos,ypos;if(b>=least/2)b=least/2;if(b<=0)b=0;var data="M0,0 C0,0";xpos=width;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=height-b;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width-b;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;data+=" 0,0 0,0z";datas.push(data);pathDetails.push({data:data,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]});data="M"+(width-b)+","+height+" C"+(width-b)+","+height;xpos=width-b+b*0.1;ypos=height-b+b*0.1;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=height-b;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;data+=" "+(width-b)+","+height+" "+(width-b)+","+height+"z";datas.push(data);pathDetails.push({data:data,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[1]]});var newControlPoints={b:{}};newControlPoints.b.x=(width-b)/width*100;newControlPoints.b.y=pathData.controlPoints.b.y;return{data:datas,pathDetails:pathDetails,pathData:pathData,newControlPoints:newControlPoints};}function getFlowchart(width,height,pathData){var least=height<width?height:width;if(pathData.type==="flowchart_connector"){var l=(100-pathData.controlPoints.l.y)/100*least;if(l>=least/2)l=least/2;if(l<=0)l=0;var ang1=180*Math.PI/180;var ang2=360*Math.PI/180;var circle1=createPie(width,height,pathData,-width,-l*2,width,height,ang1,ang2);var newData=String(circle1.data);newData=newData.slice(0,-1);newData+=" C"+0+","+0+" "+0+","+0+" "+0+","+0+" C"+width+","+0+" "+width+","+0+" "+width+","+0;newData+=" C"+width+","+0+" "+circle1.x1+","+circle1.y1+" "+circle1.x1+","+circle1.y1+"z";var newControlPoints={l:{}};newControlPoints.l.x=pathData.controlPoints.l.x;newControlPoints.l.y=(height-l)/height*100;return{data:newData,pathDetails:[{data:newData,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData,newControlPoints:newControlPoints};}}function getTearDrop(width,height,pathData){var t=pathData.controlPoints.t.x/100*width;var ang1=0*Math.PI/180;var ang2=270*Math.PI/180;var circle1=createPie(width,height,pathData,width,height,0,0,ang1,ang2);var newData=String(circle1.data);if(t<=0)t=0;if(t>=width)t=width;var diff=width-t;var diffX=t,diffY=diff;newData=newData.slice(0,-1);newData+=" C"+circle1.x2+","+circle1.y2+" "+diffX+","+diffY+" "+diffX+","+diffY+" C"+diffX+","+diffY+" "+circle1.x1+","+circle1.y1+" "+circle1.x1+","+circle1.y1+"z";var newControlPoints={t:{}};newControlPoints.t.x=t/width*100;newControlPoints.t.y=pathData.controlPoints.t.y;var shapeX=0,shapeY=0,shapeWidth=width,shapeHeight=height;if(diff>width/2)shapeWidth=width/2+diff;return{data:newData,pathDetails:[{data:newData,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData,newControlPoints:newControlPoints,shapeStyle:{left:shapeX,top:shapeY,width:shapeWidth,height:shapeHeight}};}function getCubicBezierPoints(pointDataArr,t){var helperPoints=[];for(var i=1;i<4;i++){var p=lerp(pointDataArr[i-1],pointDataArr[i],t);helperPoints.push(p);}helperPoints.push(lerp(helperPoints[0],helperPoints[1],t));helperPoints.push(lerp(helperPoints[1],helperPoints[2],t));helperPoints.push(lerp(helperPoints[3],helperPoints[4],t));var firstBezier=[pointDataArr[0],helperPoints[0],helperPoints[3],helperPoints[5]];var secondBezier=[helperPoints[5],helperPoints[4],helperPoints[2],pointDataArr[3]];// returns 2 array of points for the new bezier curves;
return[firstBezier,secondBezier];}function lerp(A,B,t){return[(Number(B[0])-Number(A[0]))*t+Number(A[0]),// the x coordinate;
(Number(B[1])-Number(A[1]))*t+Number(A[1])// the y coordinate;
];}function sfix(arr){var num1=Number(arr[0]);var num2=Number(arr[1]);num1=num1<0?Math.floor(Math.abs(num1)*100)*-1/100:num1.toFixed(2);num2=num2<0?Math.floor(Math.abs(num2)*100)*-1/100:num2.toFixed(2);return num1+","+num2;}function sFix2(num1,num2){num1=Number(num1);num2=Number(num2);num1=num1<0?Math.floor(Math.abs(num1)*100)*-1/100:num1.toFixed(2);num2=num2<0?Math.floor(Math.abs(num2)*100)*-1/100:num2.toFixed(2);return num1+","+num2;}function dist(pot1,pt2){var dx=pot1.x-pt2.x;var dy=pot1.y-pt2.y;return Math.sqrt(dx*dx+dy*dy);};function gradSearch(l0,pt,actualLength,cltpth){l0=l0+actualLength;var l1=l0,dist0=dist(cltpth.getPointAtLength(l0%actualLength),pt),dist1,searchDir;if(dist(cltpth.getPointAtLength((l0-1)%actualLength),pt)>dist(cltpth.getPointAtLength((l0+1)%actualLength),pt)){searchDir=1;}else{searchDir=-1;}l1+=searchDir;dist1=dist(cltpth.getPointAtLength(l1%actualLength),pt);while(dist1<dist0){dist0=dist1;l1+=searchDir;dist1=dist(cltpth.getPointAtLength(l1%actualLength),pt);}l1-=searchDir;return l1%actualLength;}function getCallout(width,height,pathData,storedItem){var px=pathData.controlPoints.p.x/100*width;var py=pathData.controlPoints.p.y/100*height;var currentAngle=(Math.PI+Math.atan2(-px+width/2,py-height/2))*180/Math.PI-90;var shapeX=0,shapeY=0,shapeWidth=width,shapeHeight=height;if(px>width)shapeWidth=px;if(py>height)shapeHeight=py;if(px<0){shapeX=px;shapeWidth=width-px;}if(py<0){shapeY=py;shapeHeight=height-py;}if(pathData.type==="circle_callout"){if(currentAngle<=0)currentAngle+=360;var angle1=currentAngle-15;var angle2=currentAngle+15;if(angle2>=0)angle2=-360+angle2;var ang2=angle1*Math.PI/180;var ang1=angle2*Math.PI/180;var circle=createPie(width,height,pathData,width,height,0,0,ang1,ang2);var data=String(circle.data);data=data.slice(0,-1);data+=" C"+circle.x2+","+circle.y2+" "+px+","+py+" "+px+","+py;data+=" C"+px+","+py+" "+circle.x1+","+circle.y1+" "+circle.x1+","+circle.y1+"z";var newControlPoints={p:{}};newControlPoints.p.x=px/width*100;newControlPoints.p.y=py/height*100;}else if(pathData.type==="bubble_callout"){var least=height<width?height:width;var dy1=py-height/2;var dx1=px-width/2;var theta=Math.atan2(dy1,dx1);// range (-PI, PI]
theta*=180/Math.PI;// rads to degs, range (-180, 180]
if(theta<0)theta=360+theta;// range [0, 360)
currentAngle=theta;var _angle=currentAngle;var _angle2=currentAngle;if(_angle2>=0)_angle2=-360+_angle2;ang1=_angle*Math.PI/180;ang2=_angle2*Math.PI/180;circle=createPie(width,height,pathData,width,height,0,0,ang1,ang2);data=String(circle.data);var handleAngle=getHandleAngle(px,py,width,height);handleAngle=handleAngle*180/Math.PI;// handleAngle = (180 - handleAngle);
if(handleAngle<0)handleAngle=360+handleAngle;handleAngle=handleAngle*Math.PI/180;var dx=px-parseFloat(circle.x1),dy=py-parseFloat(circle.y1);var _dist=Math.sqrt(dx*dx+dy*dy);var diameter1=0.05*least;var diameter2=0.1*least;var diameter3=0.15*least;var disPers=_dist*.25;var bubble1X=parseFloat(circle.x1)+(_dist-diameter1)*Math.cos(handleAngle);var bubble1Y=parseFloat(circle.y1)+(_dist-diameter1)*Math.sin(handleAngle);var bubble2X=parseFloat(circle.x1)+(_dist-(disPers+diameter2/2))*Math.cos(handleAngle);var bubble2Y=parseFloat(circle.y1)+(_dist-(disPers+diameter2/2))*Math.sin(handleAngle);var bubble3X=parseFloat(circle.x1)+(_dist-(disPers+diameter2/2)*2)*Math.cos(handleAngle);var bubble3Y=parseFloat(circle.y1)+(_dist-(disPers+diameter2/2)*2)*Math.sin(handleAngle);data+=createPie(width,height,pathData,diameter1,diameter1,bubble1X-diameter1/2,bubble1Y-diameter1/2,ang1,ang2).data;data+=createPie(width,height,pathData,diameter2,diameter2,bubble2X-diameter2/2,bubble2Y-diameter2/2,ang1,ang2).data;data+=createPie(width,height,pathData,diameter3,diameter3,bubble3X-diameter3/2,bubble3Y-diameter3/2,ang1,ang2).data;newControlPoints={p:{}};newControlPoints.p.x=bubble1X/width*100;newControlPoints.p.y=bubble1Y/height*100;if(bubble1X>width)shapeWidth=bubble1X+diameter1;if(bubble1Y>height)shapeHeight=bubble1Y+diameter1;if(bubble1X<0){shapeX=bubble1X-diameter1;shapeWidth=width-bubble1X+diameter1;}if(bubble1Y<0){shapeY=bubble1Y-diameter1;shapeHeight=height-bubble1Y+diameter1;}}else if(pathData.type==="rectangle_callout"||pathData.type==="rounded_rectangle_callout"){least=height<width?height:width;if(pathData.type==="rectangle_callout"){var data="M0,0 C0,0",xpos,ypos;xpos=width;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;data+=" 0,0 0,0z";}else if(pathData.type==="rounded_rectangle_callout"){var t=0.15*least,ratio=1/2;data="M"+t+",0 C"+t+",0";xpos=width-t;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+(xpos+t*ratio)+","+ypos;xpos=width;ypos=t;data+=" "+xpos+","+(ypos-t*ratio)+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=height-t;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+(ypos+t*ratio);xpos=width-t;ypos=height;data+=" "+(xpos+t*ratio)+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=t;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+(xpos-t*ratio)+","+ypos;xpos=0;ypos=height-t;data+=" "+xpos+","+(ypos+t*ratio)+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=t;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+(ypos-t*ratio);data+=" "+(t-t*ratio)+",0 "+t+",0z";}var cltpth=document.createElementNS("http://www.w3.org/2000/svg","path");cltpth.setAttributeNS(null,'d',data);var clt=document.createElementNS("http://www.w3.org/2000/svg","path");clt.setAttributeNS(null,'d',data);var centerX=width/2,centerY=height/2;var insideX=px>0&&px<width;var insideY=py>0&&py<height;var pointInsideRectangle=insideX&&insideY;var closestPoint={};var tailPosition=0;if(!pointInsideRectangle){//Outside
if(px>width&&py<0){closestPoint={x:width,y:0};tailPosition=width;}else if(px>width&&py>height){closestPoint={x:width,y:height};tailPosition=width+height;}else if(px<0&&py>height){closestPoint={x:0,y:height};tailPosition=width*2+height;}else if(px<0&&py<0){closestPoint={x:0,y:0};tailPosition=0;}else{if(py<0){closestPoint={x:px,y:0};tailPosition=px;}else if(px>width){closestPoint={x:width,y:py};tailPosition=width+py;}else if(py>height){closestPoint={x:px,y:height};tailPosition=width+height+(width-px);}else if(px<0){closestPoint={x:0,y:py};tailPosition=width*2+height+(height-py);}}}else{if(centerX>px){closestPoint.x=px>centerX-px?px:0;}else{closestPoint.x=px>px-centerX?px:width;}if(centerY>py){closestPoint.y=py>centerY-py?py:0;}else{closestPoint.y=py>py-centerY?py:height;}}var actualLength=cltpth.getTotalLength();var ptArray=[],segInc=0,totLen=0,individualPtArray=[];ptArray[segInc]=clt.getPointAtLength(0);ptArray[segInc].t=0;var pathString=data;var pathArr=[];var _Data=pathString.slice(0,-1);var ptArrays=[];ptArrays=_Data.split(" ");individualPtArray=_Data.split(" ");individualPtArray[0]=individualPtArray[0].substring(1);var tempArr=[];var str=ptArrays[0];for(var i=0;i<ptArrays.length-1;i+=3){if(i===0){tempArr.push(ptArrays[i]+" "+ptArrays[i+1]+" "+ptArrays[i+2]+" "+ptArrays[i+3]+" ");}else{tempArr.push(ptArrays[i+1]+" "+ptArrays[i+2]+" "+ptArrays[i+3]+" ");}str=str+" "+ptArrays[i+1]+" "+ptArrays[i+2]+" "+ptArrays[i+3]+" ";clt.setAttributeNS(null,'d',str);totLen=clt.getTotalLength();ptArray[segInc]=clt.getPointAtLength(totLen);ptArray[segInc].t=totLen;segInc++;}pathArr=tempArr;var pointLen=pathArr.length;var cTail=tailPosition,callThick=0.30*least;var midPoint=cTail+callThick/2;midPoint=gradSearch(midPoint,{x:px,y:py},actualLength,cltpth);cTail=midPoint-callThick/2;var endPt=cTail+callThick;if(cTail<0){cTail=cTail+actualLength;}if(endPt>actualLength){endPt=endPt-actualLength;}var pt=cltpth.getPointAtLength(cTail);var pt2=cltpth.getPointAtLength(endPt);midPoint=cTail+callThick/2;if(midPoint>actualLength)midPoint=midPoint-actualLength;var dx2=px;var dy2=py;cltpth=null;clt=null;var plen2=ptArray.length;var currentSegment1=0;var currentSegment2=0;for(i=0;i<plen2;i++){if(cTail<ptArray[i].t){currentSegment1=i;break;}}for(var j=0;j<plen2;j++){if(endPt<ptArray[j].t){currentSegment2=j;break;}}var istr="";var totalIndi=(currentSegment1+1)*3+1;for(var v=0;v<totalIndi-3;v++){istr=istr+individualPtArray[v]+" ";}var cir2ptDataArr=[];for(v=totalIndi-4;v<totalIndi;v++){if(individualPtArray[v].indexOf("C")!==-1){cir2ptDataArr.push(individualPtArray[v].substring(1).split(","));}else{cir2ptDataArr.push(individualPtArray[v].split(","));}}var cir3ptDataArr=[];var totalIndi2=(currentSegment2+1)*3+1;for(var d=totalIndi2-4;d<totalIndi2;d++){if(individualPtArray[d].indexOf("C")!==-1){cir3ptDataArr.push(individualPtArray[d].substring(1).split(","));}else{cir3ptDataArr.push(individualPtArray[d].split(","));}}if(currentSegment2>=currentSegment1){}else{}var ustr="";var totalInd=individualPtArray.length;for(var u=totalIndi2-1;u<totalInd;u++){ustr=ustr+individualPtArray[u]+" ";}var curseg1=currentSegment1;var t;if(currentSegment1<=0){t=cTail/ptArray[0].t;}else{t=(cTail-ptArray[curseg1-1].t)/(ptArray[curseg1].t-ptArray[curseg1-1].t);}var resultcir2Arr=getCubicBezierPoints(cir2ptDataArr,t);var t2;var curseg2=currentSegment2;if(currentSegment2-1<0){t2=endPt/ptArray[0].t;}else{t2=(endPt-ptArray[curseg2-1].t)/(ptArray[curseg2].t-ptArray[curseg2-1].t);}var resultcir3Arr=getCubicBezierPoints(cir3ptDataArr,t2);var cl0=sFix2(pt.x,pt.y);var cl=sFix2(dx2,dy2);var cl2=sFix2(pt2.x,pt2.y);var h1=sfix(resultcir2Arr[0][1]);var h2=sfix(resultcir2Arr[0][2]);var b1=sfix(resultcir3Arr[1][1]);var b2=sfix(resultcir3Arr[1][2]);if(currentSegment2>=currentSegment1){data="M"+istr+"C"+h1+" "+h2+" "+cl0+" C"+cl0+" "+cl+" "+cl+" C"+cl+" "+cl2+" "+cl2+" C"+b1+" "+b2+" "+ustr.trim()+"z";}else{var istrArr=istr.split(" ");istrArr.shift();istrArr.shift();istrArr.shift();istr=istrArr.join(" ");data="M"+cl2+" C"+b1+" "+b2+" "+istr+"C"+h1+" "+h2+" "+cl0+" C"+cl0+" "+cl+" "+cl+" C"+cl+" "+cl2+" "+cl2+"z";}newControlPoints={p:{}};newControlPoints.p.x=px/width*100;newControlPoints.p.y=py/height*100;}var dataP={data:data,color:pathData.colors[Object.keys(pathData.colors)[0]]};var pathLeft=-shapeX,pathTop=-shapeY;if(pathData.isStroke===true){dataP.isStroke=true;pathLeft+=strokeWidth/2;pathTop+=strokeWidth/2;}else dataP.isFill=true;dataP.pathStyle={left:pathLeft,top:pathTop};return{data:data,pathDetails:[dataP],pathData:pathData,shapeStyle:{left:shapeX,top:shapeY,width:shapeWidth+strokeWidth,height:shapeHeight+strokeWidth},newControlPoints:newControlPoints};}function getSymbol(width,height,pathData){var least=height<width?height:width,pathDetails=[];var data=[];var p=pathData.controlPoints.p.x/100*least;if(p<=least*.1)p=least*.1;if(p>=least*.9)p=least*.9;if(p>=least*.5)p=least-p;if(p>=width*.3)p=width*.3;var ang1=-180*Math.PI/180;var ang2=180*Math.PI/180;var circle1=createPie(width,height,pathData,width,height,0,0,ang1,ang2,false);var newData=circle1.data;var circle2=createPie(width,height,pathData,width-p*2,height-p*2,p,p,ang1,ang2,true);var newData2=circle2.data;newData2=newData2.slice(0,-1);newData2+=" C"+circle2.x1+","+circle2.y1+" "+circle1.x1+","+circle1.y1+" "+circle1.x1+","+circle1.y1+"z";newData=newData.slice(0,-1);var newDataArr=newData.split(" ");var str=newDataArr[newDataArr.length-1];newData=newData+" C"+str+" "+str+newData2;data.push(newData);pathDetails.push({data:newData,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]});var sq1=width-p*2;var aaa=(sq1*sq1+sq1*sq1-p*p)/(2*sq1*sq1);aaa=Math.acos(aaa);aaa=aaa*(180/Math.PI);var midV=-130;ang1=(midV-aaa)*Math.PI/180;ang2=(midV+aaa)*Math.PI/180;circle1=createPie(width,height,pathData,width-p*2-2,height-p*2-2,p,p,ang1,ang2,false);var bData1=circle1.data;midV=45;ang1=(midV+aaa)*Math.PI/180;ang2=(midV-aaa)*Math.PI/180;circle2=createPie(width,height,pathData,width-p*2+1,height-p*2+1,p,p,ang1,ang2,true);var bData2=circle2.data;bData2=bData2.slice(0,-1);bData2+=" C"+circle2.x1+","+circle2.y1+" "+circle1.x1+","+circle1.y1+" "+circle1.x1+","+circle1.y1+"z";bData1=bData1.slice(0,-1);newDataArr=bData1.split(" ");str=newDataArr[newDataArr.length-1];bData1=bData1+" C"+str+" "+str+bData2;data.push(bData1);pathDetails.push({data:bData1,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[1]]});var newControlPoints={p:{}};newControlPoints.p.x=p/width*100;newControlPoints.p.y=pathData.controlPoints.p.y;return{data:data,pathDetails:pathDetails,pathData:pathData,newControlPoints:newControlPoints};}function getScalene(width,height,pathData){var data="";var l=pathData.controlPoints.l.y/100*height;if(l<=0.1*height)l=0.1*height;if(l>=height)l=height;data="M0,"+l+" C0,"+l;data+=drawData(0,0);data+=drawData(width,height);data+=" 0,"+l+" 0,"+l+"z";var newControlPoints={l:{}};newControlPoints.l.x=pathData.controlPoints.l.x;newControlPoints.l.y=l/height*100;return{data:data,pathDetails:[{data:data,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData,newControlPoints:newControlPoints};}function getRepeated(width,height,pathData){var data="",xpos,ypos;var controlPoints=pathData.controlPoints;var midY=height/2;if(height<=1)height=1;if(pathData.type==="repeated_arrow"){var least=height;var repeaterLeast=height<width?height:width;var tr=width-(100-controlPoints.t.x)/100*least;if(tr<0)tr=0;if(tr>=width)tr=width;var repeaterWidth=0.2*repeaterLeast;var repeaterGap=0.1*repeaterLeast;var _thickn=least/2-controlPoints.l.y/100*least;if(_thickn>=least/2)_thickn=least/2;var startX,startY,endX,endY;for(var r=0;r<Math.floor(tr/(repeaterWidth+repeaterGap));r++){startX=r*repeaterWidth+(r+1)*repeaterGap;startY=midY-_thickn;endX=startX+repeaterWidth;endY=midY+_thickn;data+=" M"+startX+","+startY+" C"+startX+","+startY;data+=" "+endX+","+startY+" "+endX+","+startY+" C"+endX+","+startY;data+=" "+endX+","+endY+" "+endX+","+endY+" C"+endX+","+endY;data+=" "+startX+","+endY+" "+startX+","+endY+" C"+startX+","+endY;data+=" "+startX+","+startY+" "+startX+","+startY+"z";}if(tr%(repeaterWidth+repeaterGap)>repeaterGap){startX=tr-(tr%(repeaterWidth+repeaterGap)-repeaterGap);startY=midY-_thickn;endX=tr;endY=midY+_thickn;data+=" M"+startX+","+startY+" C"+startX+","+startY;data+=" "+endX+","+startY+" "+endX+","+startY+" C"+endX+","+startY;data+=" "+endX+","+endY+" "+endX+","+endY+" C"+endX+","+endY;data+=" "+startX+","+endY+" "+startX+","+endY+" C"+startX+","+endY;data+=" "+startX+","+startY+" "+startX+","+startY+"z";}data+="M"+tr+",0 C"+tr+",0";xpos=width,ypos=height/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=tr,ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;data+=" "+tr+","+0+" "+tr+","+0+"z";var newControlPoints={l:{},t:{}};newControlPoints.t.x=tr/width*100;newControlPoints.t.y=controlPoints.t.y;newControlPoints.l.x=controlPoints.l.x;newControlPoints.l.y=(least/2-_thickn)/height*100;}else if(pathData.type==="repeated_bar"){var least=height<width?height:width;if(width<height)least=height;var repeaterWidth=0.1*least;var repeaterGap=0.1*least;var startX,startY,endX,endY;for(var r=0;r<Math.floor(width/(repeaterWidth+repeaterGap));r++){startX=r*repeaterWidth+(r+1)*repeaterGap;startY=0;endX=startX+repeaterWidth;endY=height;data+=" M"+startX+","+startY+" C"+startX+","+startY;data+=" "+endX+","+startY+" "+endX+","+startY+" C"+endX+","+startY;data+=" "+endX+","+endY+" "+endX+","+endY+" C"+endX+","+endY;data+=" "+startX+","+endY+" "+startX+","+endY+" C"+startX+","+endY;data+=" "+startX+","+startY+" "+startX+","+startY+"z";}if(width%(repeaterWidth+repeaterGap)>repeaterGap){startX=width-(width%(repeaterWidth+repeaterGap)-repeaterGap);startY=0;endX=width;endY=height;data+=" M"+startX+","+startY+" C"+startX+","+startY;data+=" "+endX+","+startY+" "+endX+","+startY+" C"+endX+","+startY;data+=" "+endX+","+endY+" "+endX+","+endY+" C"+endX+","+endY;data+=" "+startX+","+endY+" "+startX+","+endY+" C"+startX+","+endY;data+=" "+startX+","+startY+" "+startX+","+startY+"z";}}else if(pathData.type==="repeated_double"){var least=height<width?height:width;if(width<height)least=height;var repeater1Width=0.25*least;var repeater1Gap=0.25*least;var repeater2Width=0.1*least;var repeater2Gap=0.30*least;var start1X=0,start1Y=0,end1X=0,end1Y=0,start2X=0,start2Y=0,end2X=0,end2Y=0;for(var r=0;r<Math.floor(width/(repeater1Width+repeater1Gap+repeater2Width+repeater2Gap));r++){start1X=r*repeater1Width+(r+1)*repeater1Gap+(r+1)*repeater2Gap;start1Y=0;end1X=start1X+repeater1Width;end1Y=height;data+=" M"+start1X+","+start1Y+" C"+start1X+","+start1Y;data+=" "+end1X+","+start1Y+" "+end1X+","+start1Y+" C"+end1X+","+start1Y;data+=" "+end1X+","+end1Y+" "+end1X+","+end1Y+" C"+end1X+","+end1Y;data+=" "+start1X+","+end1Y+" "+start1X+","+end1Y+" C"+start1X+","+end1Y;data+=" "+start1X+","+start1Y+" "+start1X+","+start1Y+"z";start2X=end1X+repeater2Gap;start2Y=0;end2X=start2X+repeater2Width;end2Y=height;data+=" M"+start2X+","+start2Y+" C"+start2X+","+start2Y;data+=" "+end2X+","+start2Y+" "+end2X+","+start2Y+" C"+end2X+","+start2Y;data+=" "+end2X+","+end2Y+" "+end2X+","+end2Y+" C"+end2X+","+end2Y;data+=" "+start2X+","+end2Y+" "+start2X+","+end2Y+" C"+start2X+","+end2Y;data+=" "+start2X+","+start2Y+" "+start2X+","+start2Y+"z";}if(end1X<width&&width-end1X>repeater2Gap){var lastX=end1X;start1X=lastX+repeater2Gap;start1Y=0;end1X=start1X+repeater2Width;end1Y=height;data+=" M"+start1X+","+start1Y+" C"+start1X+","+start1Y;data+=" "+end1X+","+start1Y+" "+end1X+","+start1Y+" C"+end1X+","+start1Y;data+=" "+end1X+","+end1Y+" "+end1X+","+end1Y+" C"+end1X+","+end1Y;data+=" "+start1X+","+end1Y+" "+start1X+","+end1Y+" C"+start1X+","+end1Y;data+=" "+start1X+","+start1Y+" "+start1X+","+start1Y+"z";start1X=lastX+repeater1Gap+repeater2Gap;start1Y=0;end1X=start1X+repeater1Width;end1Y=height;data+=" M"+start1X+","+start1Y+" C"+start1X+","+start1Y;data+=" "+end1X+","+start1Y+" "+end1X+","+start1Y+" C"+end1X+","+start1Y;data+=" "+end1X+","+end1Y+" "+end1X+","+end1Y+" C"+end1X+","+end1Y;data+=" "+start1X+","+end1Y+" "+start1X+","+end1Y+" C"+start1X+","+end1Y;data+=" "+start1X+","+start1Y+" "+start1X+","+start1Y+"z";}}else if(pathData.type==="repeated_triple"){var least=height<width?height:width;if(width<height)least=height;var repeaterWidth=least;var repeaterGap=0.25*least;var bar1=0.075*repeaterWidth;var gap1=0.225*repeaterWidth;var bar2=0.3*repeaterWidth;var gap2=0.1*repeaterWidth;var bar3=0.3*repeaterWidth;var startX=0,startY=0,endX=0,endY=0;for(var r=0;r<Math.floor(width/(repeaterWidth+repeaterGap));r++){startX=r*repeaterWidth+(r+1)*repeaterGap;startY=0;endX=startX+repeaterWidth;endY=height;data+=" M"+startX+","+startY+" C"+startX+","+startY;data+=" "+(startX+bar1)+","+startY+" "+(startX+bar1)+","+startY+" C"+(startX+bar1)+","+startY;data+=" "+(startX+bar1)+","+endY+" "+(startX+bar1)+","+endY+" C"+(startX+bar1)+","+endY;data+=" "+startX+","+endY+" "+startX+","+endY+" C"+startX+","+endY;data+=" "+startX+","+startY+" "+startX+","+startY+"z";data+=" M"+(startX+bar1+gap1)+","+startY+" C"+(startX+bar1+gap1)+","+startY;data+=" "+(startX+bar1+gap1+bar2)+","+startY+" "+(startX+bar1+gap1+bar2)+","+startY+" C"+(startX+bar1+gap1+bar2)+","+startY;data+=" "+(startX+bar1+gap1+bar2)+","+endY+" "+(startX+bar1+gap1+bar2)+","+endY+" C"+(startX+bar1+gap1+bar2)+","+endY;data+=" "+(startX+bar1+gap1)+","+endY+" "+(startX+bar1+gap1)+","+endY+" C"+(startX+bar1+gap1)+","+endY;data+=" "+(startX+bar1+gap1)+","+startY+" "+(startX+bar1+gap1)+","+startY+"z";data+=" M"+(startX+bar1+gap1+bar2+gap2)+","+startY+" C"+(startX+bar1+gap1+bar2+gap2)+","+startY;data+=" "+(startX+bar1+gap1+bar2+gap2+bar3)+","+startY+" "+(startX+bar1+gap1+bar2+gap2+bar3)+","+startY+" C"+(startX+bar1+gap1+bar2+gap2+bar3)+","+startY;data+=" "+(startX+bar1+gap1+bar2+gap2+bar3)+","+endY+" "+(startX+bar1+gap1+bar2+gap2+bar3)+","+endY+" C"+(startX+bar1+gap1+bar2+gap2+bar3)+","+endY;data+=" "+(startX+bar1+gap1+bar2+gap2)+","+endY+" "+(startX+bar1+gap1+bar2+gap2)+","+endY+" C"+(startX+bar1+gap1+bar2+gap2)+","+endY;data+=" "+(startX+bar1+gap1+bar2+gap2)+","+startY+" "+(startX+bar1+gap1+bar2+gap2)+","+startY+"z";}if(width%(repeaterWidth+repeaterGap)>repeaterGap){startX=width-(width%(repeaterWidth+repeaterGap)-repeaterGap);startY=0;endX=width;endY=height;if(startX+bar1+gap1+bar2+gap2<width){bar3=width-startX-bar1-gap1-bar2;}else if(startX+bar1+gap1+bar2<width){gap2=width-startX-bar1-gap1;bar3=0;}else if(startX+bar1+gap1<width){bar2=width-startX-bar1-gap1;gap2=0;bar3=0;}else if(startX+bar1<width){gap1=width-startX-bar1;bar2=0;gap2=0;bar3=0;}data+=" M"+startX+","+startY+" C"+startX+","+startY;data+=" "+(startX+bar1)+","+startY+" "+(startX+bar1)+","+startY+" C"+(startX+bar1)+","+startY;data+=" "+(startX+bar1)+","+endY+" "+(startX+bar1)+","+endY+" C"+(startX+bar1)+","+endY;data+=" "+startX+","+endY+" "+startX+","+endY+" C"+startX+","+endY;data+=" "+startX+","+startY+" "+startX+","+startY+"z";data+=" M"+(startX+bar1+gap1)+","+startY+" C"+(startX+bar1+gap1)+","+startY;data+=" "+(startX+bar1+gap1+bar2)+","+startY+" "+(startX+bar1+gap1+bar2)+","+startY+" C"+(startX+bar1+gap1+bar2)+","+startY;data+=" "+(startX+bar1+gap1+bar2)+","+endY+" "+(startX+bar1+gap1+bar2)+","+endY+" C"+(startX+bar1+gap1+bar2)+","+endY;data+=" "+(startX+bar1+gap1)+","+endY+" "+(startX+bar1+gap1)+","+endY+" C"+(startX+bar1+gap1)+","+endY;data+=" "+(startX+bar1+gap1)+","+startY+" "+(startX+bar1+gap1)+","+startY+"z";data+=" M"+(startX+bar1+gap1+bar2+gap2)+","+startY+" C"+(startX+bar1+gap1+bar2+gap2)+","+startY;data+=" "+(startX+bar1+gap1+bar2+gap2+bar3)+","+startY+" "+(startX+bar1+gap1+bar2+gap2+bar3)+","+startY+" C"+(startX+bar1+gap1+bar2+gap2+bar3)+","+startY;data+=" "+(startX+bar1+gap1+bar2+gap2+bar3)+","+endY+" "+(startX+bar1+gap1+bar2+gap2+bar3)+","+endY+" C"+(startX+bar1+gap1+bar2+gap2+bar3)+","+endY;data+=" "+(startX+bar1+gap1+bar2+gap2)+","+endY+" "+(startX+bar1+gap1+bar2+gap2)+","+endY+" C"+(startX+bar1+gap1+bar2+gap2)+","+endY;data+=" "+(startX+bar1+gap1+bar2+gap2)+","+startY+" "+(startX+bar1+gap1+bar2+gap2)+","+startY+"z";}}return{data:data,pathDetails:[{data:data,isFill:true,color:pathData.colors[Object.keys(pathData.colors)[0]]}],pathData:pathData,newControlPoints:newControlPoints};}function getControlPoints(item,zoomFactor){var pathData=item.get("pathData").toJS();var controlPoints=pathData.controlPoints,newControlPoints={};var width=item.get("width")*zoomFactor,height=item.get("height")*zoomFactor;var least=height<width?height:width;if(pathData.type==="ribbon"){var t=controlPoints.t.x*least/100;if(t<0)t=0;if(t>=width)t=width;newControlPoints.t={x:t/width*100,y:controlPoints.t.y};}return newControlPoints;}function getRatio(item,zoomFactor){var pathData=item.get("pathData").toJS(),textContainerRatio={};if(pathData.type==="ribbon"){var points=getControlPoints(item,zoomFactor);textContainerRatio.x=points.t.x;textContainerRatio.y=5;textContainerRatio.width=100-points.t.x*2;textContainerRatio.height=90;}return textContainerRatio;}function getBanner(item,zoomFactor){var pathData=item.get("pathData").toJS();var colors=item.get("colors").toJS();var controlPoints=pathData.controlPoints,xpos=void 0,ypos=void 0,containerRatio=void 0;var data="",width=item.get("width")*zoomFactor,height=item.get("height")*zoomFactor;if(pathData.type==="ribbon"){var points=getControlPoints(item,zoomFactor);var currentXValue=points.t.x*width/100;xpos=0;ypos=0;data="M"+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width-currentXValue;ypos=height/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=width;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=height;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=currentXValue;ypos=height/2;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+" C"+xpos+","+ypos;xpos=0;ypos=0;data+=" "+xpos+","+ypos+" "+xpos+","+ypos+"z";containerRatio=getRatio(item,zoomFactor);}return{data:data,pathDetails:[{data:data,isFill:true,color:colors[Object.keys(colors)[0]]}],pathData:pathData,containerRatio:containerRatio};}

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getCorner */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getObjectsBounds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_app_json__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var initialState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({"name":"Untitled Project","duration":"13","width":800,"height":450,"scenes":[],"audios":{},"videos":{}});var oldBounds=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]);var sceneDurationReset=function sceneDurationReset(stateVal){var oldDuration=0,totalDuration=0;for(var i=0;i<stateVal.getIn(['scenes']).size;i++){stateVal=stateVal.setIn(['scenes',i,'startTime'],oldDuration);oldDuration=stateVal.getIn(['scenes',i,'duration'])+stateVal.getIn(['scenes',i,'startTime']);totalDuration+=stateVal.getIn(['scenes',i,'duration']);}stateVal=stateVal.set('duration',totalDuration);return stateVal;};var getCorner=function getCorner(pivotX,pivotY,cornerX,cornerY,angle){var x,y,distance,diffX,diffY;/// get distance from center to point
diffX=cornerX-pivotX;diffY=cornerY-pivotY;distance=Math.sqrt(diffX*diffX+diffY*diffY);/// find angle from pivot to corner
angle+=Math.atan2(diffY,diffX);/// get new x and y and round it off to integer
x=pivotX+distance*Math.cos(angle);y=pivotY+distance*Math.sin(angle);return{x:x,y:y};};var getSelectionBoxBounds=function getSelectionBoxBounds(data){var angle=data.angle*Math.PI/180;var c1,c2,c3,c4,/// corners
bx1,by1,bx2,by2,bounds;c1=getCorner(data.cx,data.cy,data.x,data.y,angle);c2=getCorner(data.cx,data.cy,data.x+data.width,data.y,angle);c3=getCorner(data.cx,data.cy,data.x+data.width,data.y+data.height,angle);c4=getCorner(data.cx,data.cy,data.x,data.y+data.height,angle);/// get bounding box
bx1=Math.min(c1.x,c2.x,c3.x,c4.x);by1=Math.min(c1.y,c2.y,c3.y,c4.y);bx2=Math.max(c1.x,c2.x,c3.x,c4.x);by2=Math.max(c1.y,c2.y,c3.y,c4.y);bounds={x:parseFloat(bx1.toFixed(2)),y:parseFloat(by1.toFixed(2)),width:parseFloat((bx2-bx1).toFixed(2)),height:parseFloat((by2-by1).toFixed(2))};return bounds;};var getObjectsBounds=function getObjectsBounds(objects,isResize){var minX=0,maxX=0,minY=0,maxY=0;var count=0;objects.entrySeq().forEach(function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],item=_ref2[1];var bounds=getSelectionBoxBounds({x:item.get("x"),y:item.get("y"),cx:item.get("x")+item.get("width")/2,cy:item.get("y")+item.get("height")/2,width:item.get("width"),height:item.get("height"),angle:item.get("angle")});var x=bounds.x,y=bounds.y,width=bounds.width,height=bounds.height;if(count===0){minX=x;maxX=x+width;minY=y;maxY=y+height;count++;}else{minX=Math.min(minX,x);maxX=Math.max(maxX,x+width);minY=Math.min(minY,y);maxY=Math.max(maxY,y+height);}});return{x:minX,y:minY,width:maxX-minX,height:maxY-minY};};function animakerStore(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var selectedScene,currentContainer=state.getIn(['essentials','selectedCamera'])!==""?"workspaceCameras":"workspaceItems",getAllItems,getAllChildren,currentSlide=0,allChildren,allWorkspaceItems,uniqueId,workspaceItems;var duration=0;var sceneDetails;var workspaceItems;var workspaceChildren;var i;var i;var workspaceItems;var workspaceChildren;var allWorkspaceItems;var allWorkspaceChildren;var selectedText;var key;var key;var key;var key;var selectedItems;var i;var selectedChildren;var key;var workspaceIndex;var workspaceBG;var videoStart;var videoEnd;var i;var m;var copiedScenes;var selectedScene;var allScenes;var projectWidth,projectHeight,scale,modifyWidth,modifyHeight,modifyX,modifyY,setCenterX,setCenterY;var oldWidth;var oldHeight;var oldType;var newType;var oldRatio;var newRatio;var widthScale;var heightScale;var positionScale;var prebuiltData;var workspaceBG;var videoStart;var videoEnd;var newslide;var dKey;var dKey;var assetArr;var assetArr;var sceneVal;var i;var dKey;var selectedText;var _ret=function(){switch(action.type){case"ADD_SCENE_COMPLETE":state=state.updateIn(["scenes"],function(list){return list.splice(action.slideIndex,0,Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.newslide));});var duration=state.get("duration");state=sceneDurationReset(state);return{v:state};case"DUPLICATE_SCENE_COMPLETE":state=state.updateIn(["scenes"],function(list){return list.splice(action.slideIndex,0,Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.newslide));});state=state.setIn(["scenes",action.slideIndex,"workspaceItems"],state.getIn(["scenes",action.slideIndex,"workspaceItems"]).sortBy(function(value,key){return value.get("index");}).toOrderedMap());state=sceneDurationReset(state);return{v:state};case"MOVE_SCENE_COMPLETE":sceneDetails=state.getIn(['scenes']).toJS();sceneDetails=sceneDetails.slice(0);sceneDetails.splice(action.newIndex,0,sceneDetails.splice(action.oldIndex,1)[0]);var allScenes=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(sceneDetails);allScenes.entrySeq().forEach(function(_ref3){var _ref4=_slicedToArray(_ref3,2),sceneNum=_ref4[0],sceneVal=_ref4[1];sortedItems=sceneVal.get("workspaceItems").sortBy(function(value,key){return value.get("index");});allScenes=allScenes.setIn([sceneNum,"workspaceItems"],sortedItems.toOrderedMap());});state=state.setIn(['scenes'],allScenes);state=sceneDurationReset(state);return{v:state};case"REMOVE_SCENE_COMPLETE":var currentSceneStartTime=state.getIn(['scenes',action.slideIndex,"startTime"]);var currentSceneEndTime=currentSceneStartTime+state.getIn(['scenes',action.slideIndex,"duration"]);state=state.updateIn(['scenes'],function(list){return list.splice(action.slideIndex,1);});state=sceneDurationReset(state);return{v:state};case'ADD_SCENE_TRANSITION_COMPLETE':state=state.setIn(["scenes",action.slideIndex,"transEffect"],action.transitionName);state=state.setIn(["scenes",action.slideIndex,"sizes"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.sizes));return{v:state};case"ADD_SCENE_TRANSITION_COLOR_COMPLETE":state=state.setIn(["scenes",action.selectedScene,"transColor"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])(action.color));return{v:state};case"INITIATE_PROJECT":var project=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.project);var sortedProject=project,sortedItems=null;if(project.get('height')){state=state.set('height',project.get('height'));}if(project.get('width')){state=state.set('width',project.get('width'));}project.get("scenes").entrySeq().forEach(function(_ref5){var _ref6=_slicedToArray(_ref5,2),sceneNum=_ref6[0],sceneVal=_ref6[1];sortedItems=sceneVal.get("workspaceItems").sortBy(function(value,key){return value.get("index");});sortedProject=sortedProject.setIn(["scenes",sceneNum,"workspaceItems"],sortedItems.toOrderedMap());});return{v:sortedProject};case'CHANGE_ACTION_COMPLETE':state=state.setIn(["scenes",action.selectedIndex,"workspaceItems",action.itemId,"animdata"],action.itemLabel.animdata);state=state.setIn(["scenes",action.selectedIndex,"workspaceItems",action.itemId,"height"],action.itemLabel.height);state=state.setIn(["scenes",action.selectedIndex,"workspaceItems",action.itemId,"width"],action.itemLabel.width);state=state.setIn(["scenes",action.selectedIndex,"workspaceItems",action.itemId,"src"],action.itemLabel.src);state=state.setIn(["scenes",action.selectedIndex,"workspaceItems",action.itemId,"pose"],action.itemLabel.pose);state=state.setIn(["scenes",action.selectedIndex,"workspaceItems",action.itemId,"expFlag"],action.itemLabel.expFlag);state=state.setIn(["scenes",action.selectedIndex,"workspaceItems",action.itemId,"isRepeated"],action.itemLabel.isRepeated);state=state.setIn(["scenes",action.selectedIndex,"workspaceItems",action.itemId,"mouthAction"],action.itemLabel.mouthAction);state=state.setIn(["scenes",action.selectedIndex,"workspaceItems",action.itemId,"expression"],action.itemLabel.expression);state=state.setIn(["scenes",action.selectedIndex,"workspaceItems",action.itemId,"colors"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.itemLabel.colors));return{v:state};case'CHANGE_EXPRESSION_COMPLETE':state=state.setIn(["scenes",action.selectedIndex,"workspaceItems",action.itemId,"expression"],action.itemLabel);return{v:state};case'ADD_OBJECT_COMPLETE':selectedScene=action.selectedScene;workspaceItems=state.getIn(["scenes",selectedScene,"workspaceItems"]);workspaceChildren=state.getIn(["scenes",selectedScene,"workspaceChildren"]);for(i=0;i<action.workspaceIds.length;i++){workspaceItems=workspaceItems.set(action.workspaceIds[i],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceData[i]));if(!action.workspaceData[i].deleteAudio&&action.workspaceData[i].voiceOverData&&action.workspaceData[i].voiceOverData.length){var _loop=function _loop(v){state=state.updateIn(['audios',action.workspaceData[i].checkAudio[v]],function(value){return value.set('parent',action.workspaceData[i].voiceOverData[v][action.workspaceData[i].checkAudio[v]]);});};for(var v=0;v<action.workspaceData[i].checkAudio.length;v++){_loop(v);}}else if(action.workspaceData[i].deleteAudio&&action.workspaceData[i].deleteAudio.length){for(var v=0;v<action.workspaceData[i].deleteAudio.length;v++){state=state.updateIn(['audios',action.workspaceData[i].deleteAudio[v]],function(value){return value.delete('parent');});}}}for(i=0;i<action.workspaceChildrenIds.length;i++){workspaceChildren=workspaceChildren.set(action.workspaceChildrenIds[i],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceChildData[i]));}state=state.setIn(["scenes",selectedScene,"workspaceItems"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(workspaceItems.toJS()).sortBy(function(value,key){return value.get("index");}).toOrderedMap());state=state.setIn(["scenes",selectedScene,"workspaceChildren"],workspaceChildren);return{v:state};case"UPDATE_BGCOLOR_COMPLETE":state=state.setIn(["scenes",action.selectedScene,"workspaceBG","bgColor",action.Cls],action.color);return{v:state};case"UPDATE_BGGRADIENT_COMPLETE":state=state.setIn(["scenes",action.selectedScene,"workspaceBG","gradient",action.gradientIndex,action.gradientSecIndex],action.color);return{v:state};case"CHANGE_ANIMATION_TYPE_COMPLETE":state=state.setIn(["scenes",action.selectedScene,"workspaceItems",action.itemId,"isAnimated"],action.value);return{v:state};case"MOVE_UPDATE_COMPLETE":workspaceItems=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceItems);workspaceChildren=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceChildren);if(workspaceItems.size>0){allWorkspaceItems=state.getIn(["scenes",action.selectedScene,action.currentContainer]);workspaceItems.entrySeq().forEach(function(_ref7){var _ref8=_slicedToArray(_ref7,2),key=_ref8[0],item=_ref8[1];state=state.setIn(["scenes",action.selectedScene,action.currentContainer,key],allWorkspaceItems.get(key).merge(item));});}if(workspaceChildren.size>0){allWorkspaceChildren=state.getIn(["scenes",action.selectedScene,"workspaceChildren"]);workspaceChildren.entrySeq().forEach(function(_ref9){var _ref10=_slicedToArray(_ref9,2),key=_ref10[0],item=_ref10[1];state=state.setIn(["scenes",action.selectedScene,"workspaceChildren",key],allWorkspaceChildren.get(key).merge(item));});}return{v:state};case"RESIZE_UPDATE":if(action.data.isShapeOnly){selectedScene=action.data.selectedScene;var item=action.data.items.first();var map_to_update=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({x:item.get('x'),y:item.get('y'),width:item.get('width'),height:item.get('height')});if(item.get("pathData")!==undefined)map_to_update.set("pathData",item.get("pathData"));state=state.setIn(["scenes",selectedScene,"workspaceItems",action.data.selectedItems.get(0)],state.getIn(["scenes",selectedScene,"workspaceItems",action.data.selectedItems.get(0)]).merge(map_to_update));}return{v:state};case"CHANGE_TEXT_COMPLETE":if(action.selfUpdate===true){state=state.setIn(["scenes",action.selectedScene,action.currentContainer,action.itemId],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.objectData));}return{v:state};case"UPDATE_TEXT_COMPLETE":if(action.selfUpdate===true){if(!action.isGrouped){selectedText=state.getIn(["scenes",action.selectedScene,action.container,action.selectedId,"textData"]);if(selectedText!==undefined){selectedText=selectedText.setIn(["formats","containerStyle"],selectedText.getIn(["formats","containerStyle"]).merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.formats.containerStyle)));selectedText=selectedText.setIn(["formats","others"],selectedText.getIn(["formats","others"]).merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.formats.others)));selectedText=selectedText.setIn(["formats","bullet"],selectedText.getIn(["formats","bullet"]).merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.formats.bullet)));state=state.setIn(["scenes",action.selectedScene,action.container,action.selectedId,"textData"],selectedText);}}else{action.childIds.entrySeq().forEach(function(_ref11){var _ref12=_slicedToArray(_ref11,2),key=_ref12[0],id=_ref12[1];});}}return{v:state};case"UPDATE_GROUP_OBJECTS_COMPLETE":if(action.selfUpdate===true){selectedScene=action.selectedScene;for(key in action.workspaceChildren){if(action.workspaceChildren.hasOwnProperty(key))state=state.setIn(["scenes",action.selectedScene,"workspaceChildren",key],state.getIn(["scenes",action.selectedScene,"workspaceChildren",key]).merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceChildren[key])));}for(key in action.workspaceItems){if(action.workspaceItems.hasOwnProperty(key))state=state.setIn(["scenes",action.selectedScene,"workspaceItems",key],state.getIn(["scenes",action.selectedScene,"workspaceItems",key]).merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceItems[key])));}}return{v:state};break;case"UPDATE_GROUP_TEXT_COMPLETE":if(action.selfUpdate===true){selectedScene=action.selectedScene;for(key in action.workspaceChildren){if(action.workspaceChildren.hasOwnProperty(key))state=state.setIn(["scenes",action.selectedScene,"workspaceChildren",key],state.getIn(["scenes",action.selectedScene,"workspaceChildren",key]).merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceChildren[key])));}for(key in action.workspaceItems){if(action.workspaceItems.hasOwnProperty(key))state=state.setIn(["scenes",action.selectedScene,"workspaceItems",key],state.getIn(["scenes",action.selectedScene,"workspaceItems",key]).merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceItems[key])));}}return{v:state};break;case"FLIP_ITEM_COMPLETE":state=state.setIn(["scenes",action.selectedScene,"workspaceItems",action.itemId,"flipPosition"],action.flipPosition);return{v:state};case'DELETE_ITEM_COMPLETE':selectedItems=action.workspaceIds;selectedScene=action.selectedScene;getAllItems=state.getIn(["scenes",selectedScene,"workspaceItems"]);getAllChildren=state.getIn(["scenes",selectedScene,"workspaceChildren"]);for(i=0;i<selectedItems.length;i++){if(state.getIn(["scenes",selectedScene,"workspaceItems",selectedItems[i],"type"])==="GROUP"){selectedChildren=state.getIn(["scenes",selectedScene,"workspaceItems",selectedItems[i],"groupChildren"]).toJS();getAllChildren=selectedChildren.reduce(function(map,key){return map.delete(key);},getAllChildren);}}getAllItems=selectedItems.reduce(function(map,key){return map.delete(key);},getAllItems);if(getAllItems.size>0){i=0;getAllItems.entrySeq().forEach(function(_ref13){var _ref14=_slicedToArray(_ref13,2),key=_ref14[0],value=_ref14[1];getAllItems=getAllItems.setIn([key,"index"],i);getAllItems=getAllItems.setIn([key,"animIndex"],i);i++;});}state=state.setIn(["scenes",selectedScene,"workspaceItems"],getAllItems);state=state.setIn(["scenes",selectedScene,"workspaceChildren"],getAllChildren);return{v:state};case"CHANGE_SCENE_DURATION_COMPLETE":var newDuration=parseFloat(action.objectData);var videoEnd=parseFloat(action.videoEndTime);var bgType=state.getIn(['scenes',action.selectedScene,'workspaceBG',"type"]);if(bgType==="STOCKVID"||bgType==="UPVIDEO"||bgType==="VIDEO"){if(state.getIn(['scenes',action.selectedScene,'workspaceBG',"videoDuration"])-state.getIn(['scenes',action.selectedScene,'workspaceBG',"videoStart"])+state.getIn(['scenes',action.selectedScene,"startTime"])<=action.objectData){newDuration=state.getIn(['scenes',action.selectedScene,'workspaceBG',"videoDuration"])-state.getIn(['scenes',action.selectedScene,'workspaceBG',"videoStart"]);}}state=state.setIn(['scenes',action.selectedScene,'duration'],newDuration);state=state.setIn(['scenes',action.selectedScene,'playHeadValue'],parseFloat(action.playHead));state=state.setIn(['scenes',action.selectedScene,'workspaceBG','videoEnd'],videoEnd);state=sceneDurationReset(state);return{v:state};case"UPDATE_TIMELINE_DRAG_COMPLETE":selectedScene=action.selectedScene;var itr=0;if(action.itemData==="audios"){for(itr=0;itr<action.actionData.length;itr++){state=state.setIn([action.itemData,action.idVal,action.actionData[itr].name],action.actionData[itr].value);}}else if(action.itemData==="workspaceItems"){for(itr=0;itr<action.actionData.length;itr++){if(action.actionData[itr].name!=="enterEffectName")action.actionData[itr].value=parseFloat(parseFloat(action.actionData[itr].value).toFixed(1));if(action.actionData[itr].name==='playHead')state=state.setIn(['scenes',selectedScene,'playHeadValue'],action.actionData[itr].value);else if(action.actionData[itr].name==='duration'){state=state.setIn(['scenes',selectedScene,'duration'],action.actionData[itr].value);state=sceneDurationReset(state);var playHead=state.getIn(['scenes',selectedScene,'playHeadValue']);if(playHead>action.actionData[itr].value)state=state.setIn(['scenes',selectedScene,'playHeadValue'],action.actionData[itr].value);}else if(action.actionData[itr].name==='endTime')state=state.setIn(['scenes',selectedScene,'workspaceCameras',action.actionData[itr].id,'endTime'],action.actionData[itr].value);else if(action.actionData[itr].name==='camDelete')state=state.updateIn(['scenes',selectedScene,'workspaceCameras'],function(value){return value.delete(action.actionData[itr].id);});else if(action.actionData[itr].name==='voiceStart'||action.actionData[itr].name==='voiceEnd'||action.actionData[itr].name==='playStart'||action.actionData[itr].name==='playEnd')state=state.setIn(["scenes",selectedScene,"workspaceItems",action.actionData[itr].id,"voiceOver","audio",action.actionData[itr].name],action.actionData[itr].value);else if(action.actionData[itr].name==='bgEnd')state=state.setIn(['scenes',selectedScene,'workspaceBG','exitEnd'],action.actionData[itr].value);else if(action.actionData[itr].name==='bgStart')state=state.setIn(['scenes',selectedScene,'workspaceBG','enterStart'],action.actionData[itr].value);else if(action.actionData[itr].name==='videoEnd'){var _videoEnd=action.actionData[itr].value;if(_videoEnd>state.getIn(['scenes',selectedScene,'workspaceBG','videoDuration']))_videoEnd=state.getIn(['scenes',selectedScene,'workspaceBG','videoDuration']);state=state.setIn(['scenes',selectedScene,'workspaceBG','videoEnd'],_videoEnd);}else if(action.actionData[itr].name==='videoStart')state=state.setIn(['scenes',selectedScene,'workspaceBG','videoStart'],action.actionData[itr].value);else if(action.actionData[itr].name!=='audioplayhead'){state=state.setIn(['scenes',selectedScene,action.itemData,action.actionData[itr].id,action.actionData[itr].name],action.actionData[itr].value);}}}else if(action.itemData==="workspaceBG"){for(itr=0;itr<action.actionData.length;itr++){if(action.actionData[itr].name==='bgStart')state=state.setIn(["scenes",selectedScene,"workspaceBG","enterStart"],action.actionData[itr].value);else if(action.actionData[itr].name==='bgEnd')state=state.setIn(["scenes",selectedScene,"workspaceBG","exitEnd"],action.actionData[itr].value);else if(action.actionData[itr].name==='bgEnter')state=state.setIn(["scenes",selectedScene,"workspaceBG","enterEnd"],action.actionData[itr].value);else if(action.actionData[itr].name==='bgExit')state=state.setIn(["scenes",selectedScene,"workspaceBG","exitStart"],action.actionData[itr].value);else state=state.setIn(["scenes",selectedScene,"workspaceBG",action.actionData[itr].name],action.actionData[itr].value);}}else{for(itr=0;itr<action.actionData.length;itr++){state=state.setIn(['scenes',selectedScene,action.itemData,action.idVal,action.actionData[itr].name],action.actionData[itr].value);}}if(Object.keys(action.childToUpdate).length>0){for(key in action.childToUpdate){state=state.setIn(['scenes',selectedScene,'workspaceChildren',key],state.getIn(['scenes',selectedScene,'workspaceChildren',key]).merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.childToUpdate[key])));}}return{v:state};case"APPLY_ENTER_EFFECT_COMPLETE":if(action.isUndo!==true){if(action.effectData.isapplyToallSlides===true){state.getIn(['scenes']).entrySeq().forEach(function(_ref15){var _ref16=_slicedToArray(_ref15,2),sceneNum=_ref16[0],value=_ref16[1];state.getIn(['scenes',sceneNum,'workspaceItems']).entrySeq().forEach(function(_ref17){var _ref18=_slicedToArray(_ref17,2),key=_ref18[0],value=_ref18[1];state=state.setIn(['scenes',sceneNum,'workspaceItems',key,'enterEffectName'],action.effectData.effectName);});});}else{state.getIn(['scenes',action.selectedScene,'workspaceItems']).entrySeq().forEach(function(_ref19){var _ref20=_slicedToArray(_ref19,2),key=_ref20[0],value=_ref20[1];state=state.setIn(['scenes',action.selectedScene,'workspaceItems',key,'enterEffectName'],action.effectData.effectName);});}}else if(action.isUndo){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=Object.entries(action.sceneEffectData)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _ref21=_step.value;var _ref22=_slicedToArray(_ref21,2);var scene=_ref22[0];var workspaceItem=_ref22[1];var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=Object.entries(workspaceItem)[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var _ref23=_step2.value;var _ref24=_slicedToArray(_ref23,2);var _key=_ref24[0];var value=_ref24[1];state=state.setIn(['scenes',scene,'workspaceItems',_key,'enterEffectName'],value);}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}return{v:state};case'SET_Z_INDEX_COMPLETE':selectedScene=action.selectedScene;workspaceItems=state.getIn(["scenes",selectedScene,"workspaceItems"]);workspaceIndex=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.indexChangeIds);workspaceIndex.entrySeq().forEach(function(_ref25){var _ref26=_slicedToArray(_ref25,2),key=_ref26[0],value=_ref26[1];state=state.setIn(["scenes",selectedScene,"workspaceItems",key,"index"],value.get("index"));});workspaceItems=state.getIn(["scenes",selectedScene,"workspaceItems"]).sortBy(function(value,key){return value.get("index");});state=state.setIn(["scenes",selectedScene,"workspaceItems"],workspaceItems);return{v:state};case'UPDATE_VIDEO_DATA_COMPLETE':state=state.setIn(["scenes",action.selectedScene,"workspaceBG"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceBg));if(state.getIn(["scenes",action.selectedScene,"isContinuous"])){workspaceBG=action.workspaceBG;if(workspaceBG.exitEnd===state.getIn(["scenes",action.selectedScene,"duration"])){workspaceBG.enterStart=0;videoStart=workspaceBG.videoEnd;videoEnd=videoStart+10;if(videoEnd>workspaceBG.duration)videoEnd=workspaceBG.duration;workspaceBG.videoStart=videoStart;workspaceBG.videoEnd=videoEnd;workspaceBG.exitEnd=videoEnd-videoStart;state=state.setIn(["scenes",action.selectedScene+1,"workspaceBG"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(workspaceBG));}}return{v:state};case'DELETE_BG_COMPLETE':state=state.setIn(["scenes",action.selectedScene,"workspaceBG","src"],"");state=state.setIn(["scenes",action.selectedScene,"workspaceBG","thumbnail"],"");state=state.setIn(["scenes",action.selectedScene,"workspaceBG","type"],"");state=state.setIn(["scenes",action.selectedScene,"workspaceBG","subType"],"");state=state.setIn(["scenes",action.selectedScene,"workspaceBG","stockId"],"");state=state.setIn(["scenes",action.selectedScene,"workspaceBG","flipPosition"],0);state=state.setIn(["scenes",action.selectedScene,"workspaceBG","angle"],0);state=state.setIn(["scenes",action.selectedScene,"workspaceBG","bgFilter"],"");state=state.setIn(["scenes",action.selectedScene,"workspaceBG","videoStart"],0);state=state.setIn(["scenes",action.selectedScene,"workspaceBG","isBlob"],false);state=state.setIn(["scenes",action.selectedScene,"workspaceBG","videoEnd"],state.getIn(["scenes",action.selectedScene,"duration"]));return{v:state};case"DROP_BG_COMPLETE":state=state.setIn(["scenes",action.selectedScene,"workspaceBG"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceBG));if(action.deleteId!==""){var _allWorkspaceItems=state.getIn(["scenes",action.selectedScene,"workspaceItems"]);_allWorkspaceItems=_allWorkspaceItems.delete(action.deleteId);state=state.setIn(["scenes",action.selectedScene,"workspaceItems"],_allWorkspaceItems);}else if(action.workspaceBG.type==="STOCKVID"||action.workspaceBG.type==="UPVIDEO"||action.workspaceBG.type==='VIDEO'){state=state.setIn(["scenes",action.selectedScene,"duration"],action.workspaceBG.videoDuration);state=state.setIn(["scenes",action.selectedScene,"workspaceBG","videoEnd"],action.workspaceBG.videoDuration);state=sceneDurationReset(state);for(itr=0;itr<action.deleteData.length;itr++){if(action.deleteData[itr].name!=="enterEffectName")action.deleteData[itr].value=parseFloat(parseFloat(action.deleteData[itr].value).toFixed(1));if(action.deleteData[itr].name==='endTime')state=state.setIn(['scenes',action.selectedScene,'workspaceCameras',action.deleteData[itr].id,'endTime'],action.deleteData[itr].value);else if(action.deleteData[itr].name==='camDelete')state=state.updateIn(['scenes',action.selectedScene,'workspaceCameras'],function(value){return value.delete(action.deleteData[itr].id);});else{state=state.setIn(['scenes',action.selectedScene,"workspaceItems",action.deleteData[itr].id,action.deleteData[itr].name],action.deleteData[itr].value);}}}return{v:state};case"CROP_IMAGE_COMPLETE":state=state.setIn(["scenes",action.selectedScene,"workspaceItems",action.itemId],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.objectData));return{v:state};case"CROP_BG_COMPLETE":selectedScene=action.selectedScene;if(!action.isVideo){state=state.setIn(["scenes",selectedScene,"workspaceBG"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.objectData));}else state=state.setIn(["videos",action.videoId,"bgScales"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.bgScales));return{v:state};case"PASTE_ITEMS_COMPLETE":for(i=0;i<action.workspaceIds.length;i++){state=state.setIn(['scenes',action.selectedScene,'workspaceItems',action.workspaceIds[i]],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceData[i]));}for(m=0;m<action.workspaceChildrenIds.length;m++){state=state.setIn(['scenes',action.selectedScene,'workspaceChildren',action.workspaceChildrenIds[m]],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceChildData[m]));}state=state.setIn(["scenes",action.selectedScene,"workspaceItems"],state.getIn(["scenes",action.selectedScene,"workspaceItems"]).sortBy(function(value,key){return value.get("index");}).toOrderedMap());return{v:state};case"PASTE_SCENES_COMPLETE":copiedScenes=action.scenes;selectedScene=action.selectedScene+1;allScenes=state.get("scenes").toJS();copiedScenes.unshift(selectedScene,0);Array.prototype.splice.apply(allScenes,copiedScenes);allScenes=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(allScenes);allScenes.entrySeq().forEach(function(_ref27){var _ref28=_slicedToArray(_ref27,2),sceneNum=_ref28[0],sceneVal=_ref28[1];sortedItems=sceneVal.get("workspaceItems").sortBy(function(value,key){return value.get("index");});allScenes=allScenes.setIn([sceneNum,"workspaceItems"],sortedItems.toOrderedMap());});state=state.set("scenes",allScenes);state=sceneDurationReset(state);return{v:state};case"GROUP_OBJECTS_COMPLETE":selectedScene=action.selectedScene;if(action.removeIds.length>0){getAllItems=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.removeIds).reduce(function(map,key){return map.delete(key);},state.getIn(["scenes",selectedScene,"workspaceItems"]));state=state.setIn(["scenes",selectedScene,"workspaceItems"],getAllItems);state=state.setIn(["scenes",selectedScene,"workspaceItems"],state.getIn(["scenes",selectedScene,"workspaceItems"]).merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceItems))).setIn(["scenes",selectedScene,"workspaceChildren"],state.getIn(["scenes",selectedScene,"workspaceChildren"]).merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceChildren)));var _itemsOrder=action.workspaceItemsOrder;for(var _key2 in _itemsOrder){state=state.setIn(['scenes',selectedScene,'workspaceItems',_key2,'animIndex'],_itemsOrder[_key2]);}}return{v:state};case"UNGROUP_OBJECTS_COMPLETE":selectedScene=action.selectedScene;if(action.removeIds.length>0){var childIds=state.getIn(["scenes",selectedScene,"workspaceItems",action.removeIds[0],"groupChildren"]);getAllItems=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.removeIds).reduce(function(map,key){return map.delete(key);},state.getIn(["scenes",selectedScene,"workspaceItems"]));state=state.setIn(["scenes",selectedScene,"workspaceItems"],getAllItems);var unGroupedItems=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceChildren);state=state.setIn(["scenes",selectedScene,"playHeadValue"],unGroupedItems.maxBy(function(x){return x.get("enterStart");}).get("enterStart"));allWorkspaceItems=state.getIn(["scenes",selectedScene,"workspaceItems"]).merge(unGroupedItems);allChildren=childIds.toArray().reduce(function(map,key){return map.delete(key);},state.getIn(["scenes",selectedScene,"workspaceChildren"]));allWorkspaceItems=allWorkspaceItems.sortBy(function(value,key){return value.get("index");});state=state.setIn(["scenes",selectedScene,"workspaceItems"],allWorkspaceItems).setIn(["scenes",selectedScene,"workspaceChildren"],allChildren);var _itemsOrder2=action.workspaceItemsOrder;for(var _key3 in _itemsOrder2){state=state.setIn(['scenes',selectedScene,'workspaceItems',_key3,'animIndex'],_itemsOrder2[_key3]);}}return{v:state};case"BG_COLOR_SELECTION_COMPLETE":state=state.setIn(["scenes",action.selectedScene,"workspaceBG","color"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.objectData));return{v:state};case'UPDATE_SVGCOLOR_COMPLETE':state=state.setIn(["scenes",action.selectedScene,action.container,action.itemId,"colors",action.itemCls],action.colorData);return{v:state};case'UPDATE_SVGTHEME_COMPLETE':if(!action.isBG)state=state.setIn(["scenes",action.selectedScene,action.container,action.itemId,"colors"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.colorData));else state=state.setIn(["scenes",action.selectedScene,"workspaceBG","bgColor"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.colorData));return{v:state};case'APPLY_FILTER_COMPLETE':if(action.objectId!=="BG"){state=state.setIn(["scenes",action.selectedScene,"workspaceItems",action.objectId,"filter"],action.objectData);}else{state=state.setIn(["scenes",action.selectedScene,"workspaceBG","bgFilter"],action.objectData);}return{v:state};case'BG_GRADIENT_COLORS_COMPLETE':state=state.setIn(["scenes",action.selectedScene,"workspaceBG","isRadial"],action.radialStatus);state=state.setIn(["scenes",action.selectedScene,"workspaceBG","radius"],action.radius);if(!action.radialStatus){state=state.setIn(["scenes",action.selectedScene,"workspaceBG","direction"],action.direction);}return{v:state};case"RESIZE_PROJECT":projectWidth=800;projectHeight=450;setCenterX=0;setCenterY=0;oldWidth=state.get('width');oldHeight=state.get('height');oldType=oldWidth===800&&oldHeight===450?"horizontal":oldWidth===450&&oldHeight===800?"vertical":oldWidth===450&&oldHeight===450?"square":"custom";newType=action.data.type;if(newType==="horizontal"){}else if(newType==="vertical"){projectWidth=450;projectHeight=800;}else if(newType==="square"){projectWidth=450;projectHeight=450;}else{projectWidth=action.data.width;projectHeight=action.data.height;}oldRatio=oldWidth/oldHeight;newRatio=projectWidth/projectHeight;widthScale=projectWidth/oldWidth;heightScale=projectHeight/oldHeight;positionScale=widthScale;state.get("scenes").entrySeq().forEach(function(_ref29){var _ref30=_slicedToArray(_ref29,2),sceneNum=_ref30[0],sceneVal=_ref30[1];var xScale=false,yScale=false;var sceneBounds=getObjectsBounds(state.getIn(["scenes",sceneNum,"workspaceItems"]),true);var isReverted=Math.round(oldBounds.getIn([sceneNum,"width"]))===Math.round(sceneBounds.width*widthScale)&&Math.round(oldBounds.getIn([sceneNum,"height"]))===Math.round(sceneBounds.height*widthScale);if(oldType==="vertical"){scale=widthScale;if((sceneBounds.width>=oldWidth&&sceneBounds.width*scale>=projectWidth||sceneBounds.height<=oldHeight&&sceneBounds.height*scale>=projectHeight)&&!isReverted){scale=heightScale;if(sceneBounds.width*scale<=projectWidth||newType==="square"){setCenterX=projectWidth/2-sceneBounds.width*scale/2;setCenterX=setCenterX>sceneBounds.x*scale?setCenterX-sceneBounds.x*scale:-(sceneBounds.x*scale-setCenterX);}}setCenterY=projectHeight/2-sceneBounds.height*scale/2;setCenterY=setCenterY>sceneBounds.y*scale?setCenterY-sceneBounds.y*scale:-(sceneBounds.y*scale-setCenterY);}else if(oldType==="horizontal"){scale=widthScale;setCenterY=projectHeight/2-sceneBounds.height*scale/2;setCenterY=setCenterY>sceneBounds.y*scale?setCenterY-sceneBounds.y*scale:-(sceneBounds.y*scale-setCenterY);}else if(oldType==="square"){if(newType==="horizontal"){scale=widthScale;setCenterY=projectHeight/2-sceneBounds.height*scale/2;setCenterY=setCenterY>sceneBounds.y*scale?setCenterY-sceneBounds.y*scale:-(sceneBounds.y*scale-setCenterY);}else if(newType==="vertical"){scale=widthScale;if(isReverted){scale=widthScale;}setCenterY=projectHeight/2-sceneBounds.height*scale/2;setCenterY=setCenterY>sceneBounds.y*scale?setCenterY-sceneBounds.y*scale:-(sceneBounds.y*scale-setCenterY);}}var newBoundWidth=sceneBounds.width*scale;var newBoundHeight=sceneBounds.height*scale;if(xScale){if(projectWidth>newBoundWidth){setCenterX=projectWidth/2-newBoundWidth/2;setCenterX=setCenterX>sceneBounds.x*scale?setCenterX-sceneBounds.x*scale:-(sceneBounds.x*scale-setCenterX);}else{setCenterX=-(sceneBounds.x*scale);}}if(yScale){if(projectHeight>newBoundHeight){setCenterY=projectHeight/2-newBoundHeight/2;setCenterY=setCenterY>sceneBounds.y*scale?setCenterY-sceneBounds.y*scale:-(sceneBounds.y*scale-setCenterY);}else{setCenterY=-(sceneBounds.y*scale);}}getAllItems=state.getIn(["scenes",sceneNum,"workspaceItems"]);getAllChildren=sceneVal.get("workspaceChildren");var getAllCameras=sceneVal.get("workspaceCameras");if(sceneVal.get("workspaceBG")!==undefined){if(oldType==="horizontal"){if(newType==="vertical"){if(sceneVal.getIn(["workspaceBG","height"])*oldHeight<=projectHeight){state=state.setIn(["scenes",sceneNum,"workspaceBG","height"],1);state=state.setIn(["scenes",sceneNum,"workspaceBG","y"],0);var bgWidthScale=projectHeight/(sceneVal.getIn(["workspaceBG","height"])*oldHeight)*(sceneVal.getIn(["workspaceBG","width"])*oldWidth)/projectWidth;state=state.setIn(["scenes",sceneNum,"workspaceBG","width"],bgWidthScale);var dW=projectWidth-projectWidth*bgWidthScale;if(isNaN(dW))dW=0;state=state.setIn(["scenes",sceneNum,"workspaceBG","x"],dW/2/projectWidth);}else{var bgHeightScale=sceneVal.getIn(["workspaceBG","height"])*oldHeight/projectHeight;state=state.setIn(["scenes",sceneNum,"workspaceBG","height"],bgHeightScale);var dH=projectHeight-projectHeight*bgHeightScale;if(isNaN(dH))dH=0;state=state.setIn(["scenes",sceneNum,"workspaceBG","y"],dH/2/projectHeight);var _bgWidthScale=sceneVal.getIn(["workspaceBG","width"])*oldWidth/projectWidth;state=state.setIn(["scenes",sceneNum,"workspaceBG","width"],_bgWidthScale);var _dW=projectWidth-projectWidth*_bgWidthScale;if(isNaN(_dW))_dW=0;state=state.setIn(["scenes",sceneNum,"workspaceBG","x"],_dW/2/projectWidth);}}else if(newType==="square"){var _bgWidthScale2=state.getIn(["scenes",sceneNum,"workspaceBG","width"])*(oldWidth/projectWidth);state=state.setIn(["scenes",sceneNum,"workspaceBG","width"],_bgWidthScale2);var _dW2=projectWidth-projectWidth*_bgWidthScale2;if(isNaN(_dW2))_dW2=0;state=state.setIn(["scenes",sceneNum,"workspaceBG","x"],_dW2/2/projectWidth);}}else if(oldType==="vertical"){if(newType==="horizontal"){if(sceneVal.getIn(["workspaceBG","width"])*oldWidth<=projectWidth){state=state.setIn(["scenes",sceneNum,"workspaceBG","width"],1);state=state.setIn(["scenes",sceneNum,"workspaceBG","x"],0);var _bgHeightScale=sceneVal.getIn(["workspaceBG","width"])*oldWidth/projectWidth;state=state.setIn(["scenes",sceneNum,"workspaceBG","height"],_bgHeightScale);var _dH=projectHeight-projectHeight*_bgHeightScale;if(isNaN(_dH))_dH=0;state=state.setIn(["scenes",sceneNum,"workspaceBG","y"],_dH/2/projectHeight);}else{var _bgWidthScale3=sceneVal.getIn(["workspaceBG","width"])*oldWidth/projectWidth;state=state.setIn(["scenes",sceneNum,"workspaceBG","width"],_bgWidthScale3);var _dW3=projectWidth-projectWidth*_bgWidthScale3;if(isNaN(_dW3))_dW3=0;state=state.setIn(["scenes",sceneNum,"workspaceBG","x"],_dW3/2/projectWidth);var _bgHeightScale2=sceneVal.getIn(["workspaceBG","height"])*oldHeight/projectHeight;state=state.setIn(["scenes",sceneNum,"workspaceBG","height"],_bgHeightScale2);var _dH2=projectHeight-projectHeight*_bgHeightScale2;if(isNaN(_dH2))_dH2=0;state=state.setIn(["scenes",sceneNum,"workspaceBG","y"],_dH2/2/projectHeight);}}else if(newType==="square"){var _bgHeightScale3=state.getIn(["scenes",sceneNum,"workspaceBG","height"])*(oldHeight/projectHeight);state=state.setIn(["scenes",sceneNum,"workspaceBG","height"],_bgHeightScale3);var _dH3=projectHeight-projectHeight*_bgHeightScale3;if(isNaN(_dH3))_dH3=0;state=state.setIn(["scenes",sceneNum,"workspaceBG","y"],_dH3/2/projectHeight);}}else if(oldType==="square"){if(newType==="horizontal"){if(sceneVal.getIn(["workspaceBG","width"])*oldWidth<=projectWidth){state=state.setIn(["scenes",sceneNum,"workspaceBG","width"],1);state=state.setIn(["scenes",sceneNum,"workspaceBG","x"],0);var _bgHeightScale4=sceneVal.getIn(["workspaceBG","width"])*oldWidth/projectWidth;state=state.setIn(["scenes",sceneNum,"workspaceBG","height"],_bgHeightScale4);var _dH4=projectHeight-projectHeight*_bgHeightScale4;if(isNaN(_dH4))_dH4=0;state=state.setIn(["scenes",sceneNum,"workspaceBG","y"],_dH4/2/projectHeight);}else{var _bgWidthScale4=sceneVal.getIn(["workspaceBG","width"])*oldWidth/projectWidth;state=state.setIn(["scenes",sceneNum,"workspaceBG","width"],_bgWidthScale4);var _dW4=projectWidth-projectWidth*_bgWidthScale4;if(isNaN(_dW4))_dW4=0;state=state.setIn(["scenes",sceneNum,"workspaceBG","x"],_dW4/2/projectWidth);}}else if(newType==="vertical"){if(sceneVal.getIn(["workspaceBG","height"])*oldHeight<=projectHeight){state=state.setIn(["scenes",sceneNum,"workspaceBG","height"],1);state=state.setIn(["scenes",sceneNum,"workspaceBG","y"],0);var _bgWidthScale5=projectHeight/(sceneVal.getIn(["workspaceBG","height"])*oldHeight)*(sceneVal.getIn(["workspaceBG","width"])*oldWidth)/projectWidth;state=state.setIn(["scenes",sceneNum,"workspaceBG","width"],_bgWidthScale5);var _dW5=projectWidth-projectWidth*_bgWidthScale5;if(isNaN(_dW5))_dW5=0;state=state.setIn(["scenes",sceneNum,"workspaceBG","x"],_dW5/2/projectWidth);}else{var _bgHeightScale5=sceneVal.getIn(["workspaceBG","height"])*oldHeight/projectHeight;state=state.setIn(["scenes",sceneNum,"workspaceBG","height"],_bgHeightScale5);var _dH5=projectHeight-projectHeight*_bgHeightScale5;if(isNaN(_dH5))_dH5=0;state=state.setIn(["scenes",sceneNum,"workspaceBG","y"],_dH5/2/projectHeight);}}}}/*************** Set ratio ****************/state.getIn(["scenes",sceneNum,"workspaceItems"]).entrySeq().forEach(function(_ref31){var _ref32=_slicedToArray(_ref31,2),key=_ref32[0],value=_ref32[1];getAllItems=getAllItems.setIn([key,"x"],value.get("x")*scale+setCenterX).setIn([key,"y"],value.get("y")*scale+setCenterY).setIn([key,"width"],value.get("width")*scale).setIn([key,"height"],value.get("height")*scale);if(value.get("type")==="TEXT"||value.get("subType")==="CALLOUT"){var fontSize=getAllItems.getIn([key,"textData","formats","containerStyle","fontSize"]);if(fontSize!==undefined){getAllItems=getAllItems.setIn([key,"textData","formats","containerStyle","fontSize"],(parseFloat(fontSize,10)*scale).toFixed(2)+"px");}}else if(value.get("type")==="GROUP"){value.get("groupChildren").entrySeq().forEach(function(_ref33){var _ref34=_slicedToArray(_ref33,2),cKey=_ref34[0],cValue=_ref34[1];getAllChildren=getAllChildren.setIn([cValue,"width"],getAllChildren.getIn([cValue,"width"])*scale).setIn([cValue,"height"],getAllChildren.getIn([cValue,"height"])*scale).setIn([cValue,"x"],getAllChildren.getIn([cValue,"x"])*scale+setCenterX).setIn([cValue,"y"],getAllChildren.getIn([cValue,"y"])*scale+setCenterY);if(getAllChildren.getIn([cValue,"type"])==="TEXT"||getAllChildren.getIn([cValue,"subType"])==="CALLOUT"){var _fontSize=getAllChildren.getIn([cValue,"textData","formats","containerStyle","fontSize"]);if(_fontSize!==undefined){getAllChildren=getAllChildren.setIn([cValue,"textData","formats","containerStyle","fontSize"],(parseFloat(_fontSize,10)*scale).toFixed(2)+"px");}}});}});if(getAllCameras!==undefined&&getAllCameras.size>0){state.getIn(["scenes",sceneNum,"workspaceCameras"]).entrySeq().forEach(function(_ref35){var _ref36=_slicedToArray(_ref35,2),key=_ref36[0],value=_ref36[1];getAllCameras=getAllCameras.setIn([key,"width"],value.get("width")*scale).setIn([key,"height"],value.get("height")*scale).setIn([key,"x"],value.get("x")*scale+setCenterX).setIn([key,"y"],value.get("y")*scale+setCenterY);});state=state.setIn(["scenes",sceneNum,"workspaceCameras"],getAllCameras);}state=state.setIn(["scenes",sceneNum,"workspaceItems"],getAllItems);state=state.setIn(["scenes",sceneNum,"workspaceChildren"],getAllChildren);oldBounds=oldBounds.set(sceneNum,Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(sceneBounds));});state=state.set("width",projectWidth).set("height",projectHeight);return{v:state};case"UPDATE_OBJECT_COMPLETE":state=state.setIn(["scenes",action.selectedScene,action.container,action.selectedItem],state.getIn(["scenes",action.selectedScene,action.container,action.selectedItem]).merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.toUpdate)));return{v:state};case"UPDATE_OBJECT_BY_ID":state=state.setIn(["scenes",action.data.selectedScene,action.data.container,action.data.id],state.getIn(["scenes",action.data.selectedScene,action.data.container,action.data.id]).merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.toUpdate)));return{v:state};case"ADD_PREBUILT_COMPLETE":prebuiltData=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.prebuiltData);if(action.addAll!==true){if(action.replace!==true)state=state.updateIn(["scenes"],function(list){return list.splice(action.selectedScene+1,0,prebuiltData);});else state=state.setIn(["scenes",action.selectedScene],prebuiltData);state=state.setIn(["scenes",action.selectedScene,"workspaceItems"],state.getIn(["scenes",action.selectedScene,"workspaceItems"]).sortBy(function(value,key){return value.get("index");}).toOrderedMap());}else{if(action.replace!==true)state=state.set("scenes",prebuiltData.getIn(["project","scenes"]));else state=prebuiltData.get("project");state.get("scenes").entrySeq().forEach(function(_ref37){var _ref38=_slicedToArray(_ref37,2),sceneNum=_ref38[0],sceneVal=_ref38[1];sortedItems=sceneVal.get("workspaceItems").sortBy(function(value,key){return value.get("index");});state=state.setIn(["scenes",sceneNum,"workspaceItems"],sortedItems.toOrderedMap());});}state=sceneDurationReset(state);return{v:state};case'ORGANISE_SCENES':if(state.getIn(['scenes']).size>0){var pushValues=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]);action.data.map(function(each,index){pushValues=pushValues.set(index,state.getIn(['scenes',each]));});state=state.setIn(['scenes'],pushValues);}return{v:state};break;case"CONTINUE_SCENE":var currentScene=state.getIn(["scenes",action.index]);if(!currentScene){var _workspaceChildren={},_workspaceItems={},workspaceCameras={};workspaceBG=state.getIn(["scenes",action.index,"workspaceBG"]).toJS();if(workspaceBG.type==="VIDEO"&&workspaceBG.exitEnd===duration){workspaceBG.enterStart=0;videoStart=workspaceBG.videoEnd;videoEnd=videoStart+10;if(videoEnd>workspaceBG.duration)videoEnd=workspaceBG.duration;workspaceBG.videoStart=videoStart;workspaceBG.videoEnd=videoEnd;workspaceBG.exitEnd=videoEnd-videoStart;}newslide={"duration":10,"workspaceChildren":_workspaceChildren,"workspaceItems":_workspaceItems,"workspaceCameras":workspaceCameras,"workspaceBG":workspaceBG,"continuedFrom":action.index,"playHeadValue":0,"transEffect":"NoTransition"};state=state.setIn(["scenes",action.index,"isContinuous"],true);state=state.update("scenes",function(list){return list.splice(action.index+1,0,Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(newslide));});state=sceneDurationReset(state);}else{state=state.setIn(["scenes",action.index,"isContinuous"],false);}return{v:state};break;case"CHANGE_VIDEO_VOLUME_COMPLETE":state=state.setIn(["scenes",action.selectedScene,"workspaceBG","volume"],action.objectId);return{v:state};case"UPDATE_BG_COMPLETE":state=state.setIn(["scenes",action.selectedScene,"workspaceBG"],state.getIn(["scenes",action.selectedScene,"workspaceBG"]).merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.toUpdate)));return{v:state};case'UPLOAD_BULK_UPDATE_COMPLETE':for(var _i=0;_i<action.data.length;_i++){if(['workspaceItems','workspaceChildren'].indexOf(action.data[_i].type)!==-1){state=state.setIn(['scenes',action.data[_i].selectedScene,action.data[_i].type,action.data[_i].id],state.getIn(['scenes',action.data[_i].selectedScene,action.data[_i].type,action.data[_i].id]).merge(action.data[_i].toUpdate));}else if(action.data[_i].type==='workspaceBG'){state=state.setIn(['scenes',action.data[_i].selectedScene,action.data[_i].type],state.getIn(['scenes',action.data[_i].selectedScene,action.data[_i].type]).merge(action.data[_i].toUpdate));}}return{v:state};case'UPLOAD_BULK_DELETE_COMPLETE':var _loop2=function _loop2(_i2){if(['workspaceItems','workspaceChildren'].indexOf(action.data[_i2].type)!==-1){state=state.setIn(['scenes',action.data[_i2].selectedScene,action.data[_i2].type],function(value){return value.delete(action.data[_i2].id);});state=state.setIn(['scenes',action.data[_i2].selectedScene,action.data[_i2].type,action.data[_i2].id],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(state.getIn(['scenes',action.data[_i2].selectedScene,action.data[_i2].type])));}else if(action.data[_i2].type==='workspaceBG'){state=state.setIn(['scenes',action.data[_i2].selectedScene,action.data[_i2].type],state.getIn(['scenes',action.data[_i2].selectedScene,action.data[_i2].type]).merge(action.data[_i2].toUpdate));}};for(var _i2=0;_i2<action.data.length;_i2++){_loop2(_i2);}return{v:state};case"UPDATE_PROJECT_COMPLETE":for(dKey in action.toUpdate){state=state.set(dKey,Array.isArray(action.toUpdate[dKey])||_typeof(action.toUpdate[dKey])==="object"?Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.toUpdate[dKey]):action.toUpdate[dKey]);}if(action.toUpdate["scenes"]!==undefined)state=sceneDurationReset(state);return{v:state};case"UPDATE_SCENE_COMPLETE":for(dKey in action.toUpdate){state=state.setIn(["scenes",action.selectedScene,dKey],dKey==="transColor"||dKey==="sizes"||Array.isArray(action.toUpdate[dKey])||_typeof(action.toUpdate[dKey])==="object"?Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.toUpdate[dKey]):action.toUpdate[dKey]);}if(action.toUpdate["duration"]!==undefined)state=sceneDurationReset(state);if(action.toUpdate["workspaceItems"]!==undefined)state=state.setIn(["scenes",action.selectedScene,"workspaceItems"],state.getIn(["scenes",action.selectedScene,"workspaceItems"]).sortBy(function(value,key){return value.get("index");}).toOrderedMap());return{v:state};case"UPLOAD_FAILED":state=state.setIn(["scenes",0,"workspaceBG","isBlob"],false);return{v:state};case"SET_PLAY_ALL":assetArr=[];if(action.data){state.get("scenes").entrySeq().forEach(function(_ref39){var _ref40=_slicedToArray(_ref39,2),i=_ref40[0],sceneVal=_ref40[1];sceneVal.get("workspaceItems").entrySeq().forEach(function(_ref41){var _ref42=_slicedToArray(_ref41,2),key=_ref42[0],wsItem=_ref42[1];if(wsItem.get("type")!=="TEXT"&&wsItem.get("type")!=="STOCKIMG"&&wsItem.get("type")!=="GROUP"&&wsItem.get("type")!=="UPLOADS"&&wsItem.get("type")!=="IMG")assetArr.push(key);});sceneVal.get("workspaceChildren").entrySeq().forEach(function(_ref43){var _ref44=_slicedToArray(_ref43,2),key=_ref44[0],wsItem=_ref44[1];if(wsItem.get("type")!=="TEXT"&&wsItem.get("type")!=="STOCKIMG"&&wsItem.get("type")!=="UPLOADS"&&wsItem.get("type")!=="IMG")assetArr.push(key);});if(sceneVal.get("transEffect").includes("tr-")&&i!==state.get("scenes").length-1)assetArr.push("scenetransition"+i);});window.totalArr=assetArr;}return{v:state};case"SET_PLAY":assetArr=[];if(action.data){sceneVal=state.getIn(["scenes",action.selectedScene]);sceneVal.get("workspaceItems").entrySeq().forEach(function(_ref45){var _ref46=_slicedToArray(_ref45,2),key=_ref46[0],wsItem=_ref46[1];if(wsItem.get("type")!=="TEXT"&&wsItem.get("type")!=="STOCKIMG"&&wsItem.get("type")!=="GROUP"&&wsItem.get("type")!=="UPLOADS"&&wsItem.get("type")!=="IMG")assetArr.push(key);});sceneVal.get("workspaceChildren").entrySeq().forEach(function(_ref47){var _ref48=_slicedToArray(_ref47,2),key=_ref48[0],wsItem=_ref48[1];if(wsItem.get("type")!=="TEXT"&&wsItem.get("type")!=="STOCKIMG"&&wsItem.get("type")!=="UPLOADS"&&wsItem.get("type")!=="IMG")assetArr.push(key);});window.totalArr=assetArr;}return{v:state};case'APPLY_ALL_TRANSITION_COMPLETE':var isUndo=action.isUndo,sceneTransData=action.sceneTransData,transData=action.transData;if(isUndo&&sceneTransData){for(var _i3=0;_i3<sceneTransData.length;_i3++){state=state.setIn(['scenes',_i3,'transEffect'],sceneTransData[_i3].toUpdate.transEffect);state=state.setIn(['scenes',_i3,'sizes'],sceneTransData[_i3].toUpdate.sizes);state=state.setIn(['scenes',_i3,'transColor'],sceneTransData[_i3].toUpdate.transColor);}}else{for(i=0;i<state.get('scenes').size-1;i++){for(dKey in transData){state=state.setIn(['scenes',i,dKey],transData[dKey]);}}}return{v:state};case'ADD_LINK_TO_TEXT_COMPLETE':if(action.hyperLinkData){selectedText=state.getIn(["scenes",action.selectedScene,action.container,action.selectedItem,"textData"]);if(selectedText!==undefined){selectedText=selectedText.set('link',action.hyperLinkData.link);}state=state.setIn(["scenes",action.selectedScene,action.container,action.selectedItem,"textData"],selectedText);}return{v:state};case'SET_WORKSPACE_ITEMS_ORDER_COMPLETE':var itemsOrder=action.workspaceItemsOrder;for(var _key4 in itemsOrder){state=state.setIn(['scenes',action.selectedScene,action.container,_key4,'animIndex'],itemsOrder[_key4]);}return{v:state};case'SET_ANIMATE_VALUE_COMPLETE':state=state.setIn(['scenes',action.selectedScene,action.container,action.selectedItem,'animType'],action.animateData);return{v:state};case'ADD_LINK_TO_OBJ_COMPLETE':state=state.updateIn(["scenes",action.selectedScene,"workspaceItems",action.selectedItem,'link'],function(value){return action.linkData.link;});return{v:state};default:return{v:state};}}();if((typeof _ret==='undefined'?'undefined':_typeof(_ret))==="object")return _ret.v;}/* harmony default export */ __webpack_exports__["a"] = (animakerStore);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormattedNumberParts */
/* harmony export (immutable) */ __webpack_exports__["b"] = createFormattedDateTimePartsComponent;
/* harmony export (immutable) */ __webpack_exports__["a"] = createFormattedComponent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__injectIntl__ = __webpack_require__(22);




var DisplayName;
(function (DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})(DisplayName || (DisplayName = {}));
var DisplayNameParts;
(function (DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})(DisplayNameParts || (DisplayNameParts = {}));
var FormattedNumberParts = function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__injectIntl__["a" /* Context */].Consumer, null, function (intl) {
    Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* invariantIntlContext */])(intl);
    var value = props.value, children = props.children, formatProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(props, ["value", "children"]);
    return children(intl.formatNumberToParts(value, formatProps));
})); };
FormattedNumberParts.displayName = 'FormattedNumberParts';
function createFormattedDateTimePartsComponent(name) {
    var ComponentParts = function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__injectIntl__["a" /* Context */].Consumer, null, function (intl) {
        Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* invariantIntlContext */])(intl);
        var value = props.value, children = props.children, formatProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(props, ["value", "children"]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate'
            ? intl.formatDateToParts(date, formatProps)
            : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    })); };
    ComponentParts.displayName = DisplayNameParts[name];
    return ComponentParts;
}
function createFormattedComponent(name) {
    var Component = function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__injectIntl__["a" /* Context */].Consumer, null, function (intl) {
        Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* invariantIntlContext */])(intl);
        var value = props.value, children = props.children, formatProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(props, ["value", "children"]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') {
            return children(formattedValue);
        }
        var Text = intl.textComponent || __WEBPACK_IMPORTED_MODULE_1_react__["Fragment"];
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Text, null, formattedValue);
    })); };
    Component.displayName = DisplayName[name];
    return Component;
}


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bestFitFormatMatcherScore */
/* harmony export (immutable) */ __webpack_exports__["a"] = BestFitFormatMatcher;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__skeleton__ = __webpack_require__(159);




function isNumericType(t) {
    return t === 'numeric' || t === '2-digit';
}
/**
 * Credit: https://github.com/andyearnshaw/Intl.js/blob/0958dc1ad8153f1056653ea22b8208f0df289a4e/src/12.datetimeformat.js#L611
 * with some modifications
 * @param options
 * @param format
 */
function bestFitFormatMatcherScore(options, format) {
    var score = 0;
    if (options.hour12 && !format.hour12) {
        score -= __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* removalPenalty */];
    }
    else if (!options.hour12 && format.hour12) {
        score -= __WEBPACK_IMPORTED_MODULE_2__utils__["b" /* additionPenalty */];
    }
    for (var _i = 0, DATE_TIME_PROPS_1 = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* DATE_TIME_PROPS */]; _i < DATE_TIME_PROPS_1.length; _i++) {
        var prop = DATE_TIME_PROPS_1[_i];
        var optionsProp = options[prop];
        var formatProp = format[prop];
        if (optionsProp === undefined && formatProp !== undefined) {
            score -= __WEBPACK_IMPORTED_MODULE_2__utils__["b" /* additionPenalty */];
        }
        else if (optionsProp !== undefined && formatProp === undefined) {
            score -= __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* removalPenalty */];
        }
        else if (optionsProp !== formatProp) {
            // extra penalty for numeric vs non-numeric
            if (isNumericType(optionsProp) !==
                isNumericType(formatProp)) {
                score -= __WEBPACK_IMPORTED_MODULE_2__utils__["c" /* differentNumericTypePenalty */];
            }
            else {
                var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];
                var optionsPropIndex = values.indexOf(optionsProp);
                var formatPropIndex = values.indexOf(formatProp);
                var delta = Math.max(-2, Math.min(formatPropIndex - optionsPropIndex, 2));
                if (delta === 2) {
                    score -= __WEBPACK_IMPORTED_MODULE_2__utils__["e" /* longMorePenalty */];
                }
                else if (delta === 1) {
                    score -= __WEBPACK_IMPORTED_MODULE_2__utils__["h" /* shortMorePenalty */];
                }
                else if (delta === -1) {
                    score -= __WEBPACK_IMPORTED_MODULE_2__utils__["g" /* shortLessPenalty */];
                }
                else if (delta === -2) {
                    score -= __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* longLessPenalty */];
                }
            }
        }
    }
    return score;
}
/**
 * https://tc39.es/ecma402/#sec-bestfitformatmatcher
 * Just alias to basic for now
 * @param options
 * @param formats
 * @param implDetails Implementation details
 */
function BestFitFormatMatcher(options, formats) {
    var bestScore = -Infinity;
    var bestFormat = formats[0];
    Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* invariant */])(Array.isArray(formats), 'formats should be a list of things');
    for (var _i = 0, formats_1 = formats; _i < formats_1.length; _i++) {
        var format = formats_1[_i];
        var score = bestFitFormatMatcherScore(options, format);
        if (score > bestScore) {
            bestScore = score;
            bestFormat = format;
        }
    }
    var skeletonFormat = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, bestFormat);
    var patternFormat = { rawPattern: bestFormat.rawPattern };
    Object(__WEBPACK_IMPORTED_MODULE_3__skeleton__["a" /* processDateTimePattern */])(bestFormat.rawPattern, patternFormat);
    // Kinda following https://github.com/unicode-org/icu/blob/dd50e38f459d84e9bf1b0c618be8483d318458ad/icu4j/main/classes/core/src/com/ibm/icu/text/DateTimePatternGenerator.java
    // Method adjustFieldTypes
    for (var prop in skeletonFormat) {
        var skeletonValue = skeletonFormat[prop];
        var patternValue = patternFormat[prop];
        var requestedValue = options[prop];
        // Don't mess with minute/second or we can get in the situation of
        // 7:0:0 which is weird
        if (prop === 'minute' || prop === 'second') {
            continue;
        }
        // Nothing to do here
        if (!requestedValue) {
            continue;
        }
        // https://unicode.org/reports/tr35/tr35-dates.html#Matching_Skeletons
        // Looks like we should not convert numeric to alphabetic but the other way
        // around is ok
        if (isNumericType(patternValue) &&
            !isNumericType(requestedValue)) {
            continue;
        }
        if (skeletonValue === requestedValue) {
            continue;
        }
        patternFormat[prop] = requestedValue;
    }
    // Copy those over
    patternFormat.pattern = skeletonFormat.pattern;
    patternFormat.pattern12 = skeletonFormat.pattern12;
    patternFormat.skeleton = skeletonFormat.skeleton;
    patternFormat.rangePatterns = skeletonFormat.rangePatterns;
    patternFormat.rangePatterns12 = skeletonFormat.rangePatterns12;
    return patternFormat;
}


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = processDateTimePattern;
/* unused harmony export parseDateTimeSkeleton */
/* unused harmony export splitFallbackRangePattern */
/* unused harmony export splitRangePattern */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(54);

/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
// trim patterns after transformations
var expPatternTrimmer = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
function matchSkeletonPattern(match, result) {
    var len = match.length;
    switch (match[0]) {
        // Era
        case 'G':
            result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
            return '{era}';
        // Year
        case 'y':
        case 'Y':
        case 'u':
        case 'U':
        case 'r':
            result.year = len === 2 ? '2-digit' : 'numeric';
            return '{year}';
        // Quarter
        case 'q':
        case 'Q':
            throw new RangeError('`w/Q` (quarter) patterns are not supported');
        // Month
        case 'M':
        case 'L':
            result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
            return '{month}';
        // Week
        case 'w':
        case 'W':
            throw new RangeError('`w/W` (week of year) patterns are not supported');
        case 'd':
            result.day = ['numeric', '2-digit'][len - 1];
            return '{day}';
        case 'D':
        case 'F':
        case 'g':
            result.day = 'numeric';
            return '{day}';
        // Weekday
        case 'E':
            result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
            return '{weekday}';
        case 'e':
            result.weekday = [
                'numeric',
                '2-digit',
                'short',
                'long',
                'narrow',
                'short',
            ][len - 1];
            return '{weekday}';
        case 'c':
            result.weekday = [
                'numeric',
                undefined,
                'short',
                'long',
                'narrow',
                'short',
            ][len - 1];
            return '{weekday}';
        // Period
        case 'a': // AM, PM
        case 'b': // am, pm, noon, midnight
        case 'B': // flexible day periods
            result.hour12 = true;
            return '{ampm}';
        // Hour
        case 'h':
            result.hour = ['numeric', '2-digit'][len - 1];
            result.hour12 = true;
            return '{hour}';
        case 'H':
            result.hour = ['numeric', '2-digit'][len - 1];
            return '{hour}';
        case 'K':
            result.hour = ['numeric', '2-digit'][len - 1];
            result.hour12 = true;
            return '{hour}';
        case 'k':
            result.hour = ['numeric', '2-digit'][len - 1];
            return '{hour}';
        case 'j':
        case 'J':
        case 'C':
            throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
        // Minute
        case 'm':
            result.minute = ['numeric', '2-digit'][len - 1];
            return '{minute}';
        // Second
        case 's':
            result.second = ['numeric', '2-digit'][len - 1];
            return '{second}';
        case 'S':
        case 'A':
            result.second = 'numeric';
            return '{second}';
        // Zone
        case 'z': // 1..3, 4: specific non-location format
        case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
        case 'O': // 1, 4: miliseconds in day short, long
        case 'v': // 1, 4: generic non-location format
        case 'V': // 1, 2, 3, 4: time zone ID or city
        case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
        case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
            result.timeZoneName = len < 4 ? 'short' : 'long';
            return '{timeZoneName}';
    }
    return '';
}
function skeletonTokenToTable2(c) {
    switch (c) {
        // Era
        case 'G':
            return 'era';
        // Year
        case 'y':
        case 'Y':
        case 'u':
        case 'U':
        case 'r':
            return 'year';
        // Month
        case 'M':
        case 'L':
            return 'month';
        // Day
        case 'd':
        case 'D':
        case 'F':
        case 'g':
            return 'day';
        // Period
        case 'a': // AM, PM
        case 'b': // am, pm, noon, midnight
        case 'B': // flexible day periods
            return 'ampm';
        // Hour
        case 'h':
        case 'H':
        case 'K':
        case 'k':
            return 'hour';
        // Minute
        case 'm':
            return 'minute';
        // Second
        case 's':
        case 'S':
        case 'A':
            return 'second';
        default:
            throw new RangeError('Invalid range pattern token');
    }
}
function processDateTimePattern(pattern, result) {
    var literals = [];
    // Use skeleton to populate result, but use mapped pattern to populate pattern
    var pattern12 = pattern
        // Double apostrophe
        .replace(/'{2}/g, '{apostrophe}')
        // Apostrophe-escaped
        .replace(/'(.*?)'/g, function (_, literal) {
        literals.push(literal);
        return "$$" + (literals.length - 1) + "$$";
    })
        .replace(DATE_TIME_REGEX, function (m) { return matchSkeletonPattern(m, result || {}); });
    //Restore literals
    if (literals.length) {
        pattern12 = pattern12
            .replace(/\$\$(\d+)\$\$/g, function (_, i) {
            return literals[+i];
        })
            .replace(/\{apostrophe\}/g, "'");
    }
    // Handle apostrophe-escaped things
    return [
        pattern12
            .replace(/([\s\uFEFF\xA0])\{ampm\}([\s\uFEFF\xA0])/, '$1')
            .replace('{ampm}', '')
            .replace(expPatternTrimmer, ''),
        pattern12,
    ];
}
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */
function parseDateTimeSkeleton(skeleton, rawPattern, rangePatterns, intervalFormatFallback) {
    if (rawPattern === void 0) { rawPattern = skeleton; }
    var result = {
        pattern: '',
        pattern12: '',
        skeleton: skeleton,
        rawPattern: rawPattern,
        rangePatterns: {},
        rangePatterns12: {},
    };
    if (rangePatterns) {
        for (var k in rangePatterns) {
            var key = skeletonTokenToTable2(k);
            var rawPattern_1 = rangePatterns[k];
            var intervalResult = {
                patternParts: [],
            };
            var _a = processDateTimePattern(rawPattern_1, intervalResult), pattern_1 = _a[0], pattern12_1 = _a[1];
            result.rangePatterns[key] = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, intervalResult), { patternParts: splitRangePattern(pattern_1) });
            result.rangePatterns12[key] = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, intervalResult), { patternParts: splitRangePattern(pattern12_1) });
        }
    }
    else if (intervalFormatFallback) {
        var patternParts = splitFallbackRangePattern(intervalFormatFallback);
        result.rangePatterns.default = {
            patternParts: patternParts,
        };
        result.rangePatterns12.default = {
            patternParts: patternParts,
        };
    }
    // Process skeleton
    skeleton.replace(DATE_TIME_REGEX, function (m) { return matchSkeletonPattern(m, result); });
    var _b = processDateTimePattern(rawPattern), pattern = _b[0], pattern12 = _b[1];
    result.pattern = pattern;
    result.pattern12 = pattern12;
    return result;
}
function splitFallbackRangePattern(pattern) {
    var parts = pattern.split(/(\{[0|1]\})/g).filter(Boolean);
    return parts.map(function (pattern) {
        switch (pattern) {
            case '{0}':
                return {
                    source: "startRange" /* startRange */,
                    pattern: pattern,
                };
            case '{1}':
                return {
                    source: "endRange" /* endRange */,
                    pattern: pattern,
                };
            default:
                return {
                    source: "shared" /* shared */,
                    pattern: pattern,
                };
        }
    });
}
function splitRangePattern(pattern) {
    var PART_REGEX = /\{(.*?)\}/g;
    // Map of part and index within the string
    var parts = {};
    var match;
    var splitIndex = 0;
    while ((match = PART_REGEX.exec(pattern))) {
        if (!(match[0] in parts)) {
            parts[match[0]] = match.index;
        }
        else {
            splitIndex = match.index;
            break;
        }
    }
    if (!splitIndex) {
        return [
            {
                source: "startRange" /* startRange */,
                pattern: pattern,
            },
        ];
    }
    return [
        {
            source: "startRange" /* startRange */,
            pattern: pattern.slice(0, splitIndex),
        },
        {
            source: "endRange" /* endRange */,
            pattern: pattern.slice(splitIndex),
        },
    ];
}


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CanonicalizeTimeZoneName;
/**
 * https://tc39.es/ecma402/#sec-canonicalizetimezonename
 * @param tz
 */
function CanonicalizeTimeZoneName(tz, _a) {
    var tzData = _a.tzData, uppercaseLinks = _a.uppercaseLinks;
    var uppercasedTz = tz.toUpperCase();
    var uppercasedZones = Object.keys(tzData).reduce(function (all, z) {
        all[z.toUpperCase()] = z;
        return all;
    }, {});
    var ianaTimeZone = uppercaseLinks[uppercasedTz] || uppercasedZones[uppercasedTz];
    if (ianaTimeZone === 'Etc/UTC' || ianaTimeZone === 'Etc/GMT') {
        return 'UTC';
    }
    return ianaTimeZone;
}


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BasicFormatMatcher;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(43);



/**
 * https://tc39.es/ecma402/#sec-basicformatmatcher
 * @param options
 * @param formats
 */
function BasicFormatMatcher(options, formats) {
    var bestScore = -Infinity;
    var bestFormat = formats[0];
    Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* invariant */])(Array.isArray(formats), 'formats should be a list of things');
    for (var _i = 0, formats_1 = formats; _i < formats_1.length; _i++) {
        var format = formats_1[_i];
        var score = 0;
        for (var _a = 0, DATE_TIME_PROPS_1 = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* DATE_TIME_PROPS */]; _a < DATE_TIME_PROPS_1.length; _a++) {
            var prop = DATE_TIME_PROPS_1[_a];
            var optionsProp = options[prop];
            var formatProp = format[prop];
            if (optionsProp === undefined && formatProp !== undefined) {
                score -= __WEBPACK_IMPORTED_MODULE_2__utils__["b" /* additionPenalty */];
            }
            else if (optionsProp !== undefined && formatProp === undefined) {
                score -= __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* removalPenalty */];
            }
            else if (optionsProp !== formatProp) {
                var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];
                var optionsPropIndex = values.indexOf(optionsProp);
                var formatPropIndex = values.indexOf(formatProp);
                var delta = Math.max(-2, Math.min(formatPropIndex - optionsPropIndex, 2));
                if (delta === 2) {
                    score -= __WEBPACK_IMPORTED_MODULE_2__utils__["e" /* longMorePenalty */];
                }
                else if (delta === 1) {
                    score -= __WEBPACK_IMPORTED_MODULE_2__utils__["h" /* shortMorePenalty */];
                }
                else if (delta === -1) {
                    score -= __WEBPACK_IMPORTED_MODULE_2__utils__["g" /* shortLessPenalty */];
                }
                else if (delta === -2) {
                    score -= __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* longLessPenalty */];
                }
            }
        }
        if (score > bestScore) {
            bestScore = score;
            bestFormat = format;
        }
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, bestFormat);
}


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DateTimeStyleFormat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);

function DateTimeStyleFormat(dateStyle, timeStyle, dataLocaleData) {
    var dateFormat, timeFormat;
    if (timeStyle !== undefined) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* invariant */])(timeStyle === 'full' ||
            timeStyle === 'long' ||
            timeStyle === 'medium' ||
            timeStyle === 'short', 'invalid timeStyle');
        timeFormat = dataLocaleData.timeFormat[timeStyle];
    }
    if (dateStyle !== undefined) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* invariant */])(dateStyle === 'full' ||
            dateStyle === 'long' ||
            dateStyle === 'medium' ||
            dateStyle === 'short', 'invalid dateStyle');
        dateFormat = dataLocaleData.dateFormat[dateStyle];
    }
    if (dateStyle !== undefined && timeStyle !== undefined) {
        var format = {};
        for (var field in dateFormat) {
            if (field !== 'pattern') {
                // @ts-ignore
                format[field] = dateFormat[field];
            }
        }
        for (var field in timeFormat) {
            if (field !== 'pattern' && field !== 'pattern12') {
                // @ts-ignore
                format[field] = timeFormat[field];
            }
        }
        var connector = dataLocaleData.dateTimeFormat[dateStyle];
        var pattern = connector
            .replace('{0}', timeFormat.pattern)
            .replace('{1}', dateFormat.pattern);
        format.pattern = pattern;
        if ('pattern12' in timeFormat) {
            var pattern12 = connector
                .replace('{0}', timeFormat.pattern12)
                .replace('{1}', dateFormat.pattern);
            format.pattern12 = pattern12;
        }
        return format;
    }
    if (timeStyle !== undefined) {
        return timeFormat;
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* invariant */])(dateStyle !== undefined, 'dateStyle should not be undefined');
    return dateFormat;
}


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FormatDateTimePattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ToLocalTime__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__262__ = __webpack_require__(6);



function pad(n) {
    if (n < 10) {
        return "0" + n;
    }
    return String(n);
}
function offsetToGmtString(gmtFormat, hourFormat, offsetInMs, style) {
    var offsetInMinutes = Math.floor(offsetInMs / 60000);
    var mins = Math.abs(offsetInMinutes) % 60;
    var hours = Math.floor(Math.abs(offsetInMinutes) / 60);
    var _a = hourFormat.split(';'), positivePattern = _a[0], negativePattern = _a[1];
    var offsetStr = '';
    var pattern = offsetInMs < 0 ? negativePattern : positivePattern;
    if (style === 'long') {
        offsetStr = pattern
            .replace('HH', pad(hours))
            .replace('H', String(hours))
            .replace('mm', pad(mins))
            .replace('m', String(mins));
    }
    else if (mins || hours) {
        if (!mins) {
            pattern = pattern.replace(/:?m+/, '');
        }
        offsetStr = pattern
            .replace(/H+/, String(hours))
            .replace(/m+/, String(mins));
    }
    return gmtFormat.replace('{0}', offsetStr);
}
/**
 * https://tc39.es/ecma402/#sec-partitiondatetimepattern
 * @param dtf
 * @param x
 */
function FormatDateTimePattern(dtf, patternParts, x, _a) {
    var getInternalSlots = _a.getInternalSlots, localeData = _a.localeData, getDefaultTimeZone = _a.getDefaultTimeZone, tzData = _a.tzData;
    x = Object(__WEBPACK_IMPORTED_MODULE_2__262__["i" /* TimeClip */])(x);
    /** IMPL START */
    var internalSlots = getInternalSlots(dtf);
    var dataLocale = internalSlots.dataLocale;
    var dataLocaleData = localeData[dataLocale];
    /** IMPL END */
    var locale = internalSlots.locale;
    var nfOptions = Object.create(null);
    nfOptions.useGrouping = false;
    var nf = new Intl.NumberFormat(locale, nfOptions);
    var nf2Options = Object.create(null);
    nf2Options.minimumIntegerDigits = 2;
    nf2Options.useGrouping = false;
    var nf2 = new Intl.NumberFormat(locale, nf2Options);
    var tm = Object(__WEBPACK_IMPORTED_MODULE_1__ToLocalTime__["a" /* ToLocalTime */])(x, 
    // @ts-ignore
    internalSlots.calendar, internalSlots.timeZone, { tzData: tzData });
    var result = [];
    for (var _i = 0, patternParts_1 = patternParts; _i < patternParts_1.length; _i++) {
        var patternPart = patternParts_1[_i];
        var p = patternPart.type;
        if (p === 'literal') {
            result.push({
                type: 'literal',
                value: patternPart.value,
            });
        }
        else if (__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* DATE_TIME_PROPS */].indexOf(p) > -1) {
            var fv = '';
            var f = internalSlots[p];
            // @ts-ignore
            var v = tm[p];
            if (p === 'year' && v <= 0) {
                v = 1 - v;
            }
            if (p === 'month') {
                v++;
            }
            var hourCycle = internalSlots.hourCycle;
            if (p === 'hour' && (hourCycle === 'h11' || hourCycle === 'h12')) {
                v = v % 12;
                if (v === 0 && hourCycle === 'h12') {
                    v = 12;
                }
            }
            if (p === 'hour' && hourCycle === 'h24') {
                if (v === 0) {
                    v = 24;
                }
            }
            if (f === 'numeric') {
                fv = nf.format(v);
            }
            else if (f === '2-digit') {
                fv = nf2.format(v);
                if (fv.length > 2) {
                    fv = fv.slice(fv.length - 2, fv.length);
                }
            }
            else if (f === 'narrow' || f === 'short' || f === 'long') {
                if (p === 'era') {
                    fv = dataLocaleData[p][f][v];
                }
                else if (p === 'timeZoneName') {
                    var timeZoneName = dataLocaleData.timeZoneName, gmtFormat = dataLocaleData.gmtFormat, hourFormat = dataLocaleData.hourFormat;
                    var timeZone = internalSlots.timeZone || getDefaultTimeZone();
                    var timeZoneData = timeZoneName[timeZone];
                    if (timeZoneData && timeZoneData[f]) {
                        fv = timeZoneData[f][+tm.inDST];
                    }
                    else {
                        // Fallback to gmtFormat
                        fv = offsetToGmtString(gmtFormat, hourFormat, tm.timeZoneOffset, f);
                    }
                }
                else if (p === 'month') {
                    fv = dataLocaleData.month[f][v - 1];
                }
                else {
                    fv = dataLocaleData[p][f][v];
                }
            }
            result.push({
                type: p,
                value: fv,
            });
        }
        else if (p === 'ampm') {
            var v = tm.hour;
            var fv = void 0;
            if (v > 11) {
                fv = dataLocaleData.pm;
            }
            else {
                fv = dataLocaleData.am;
            }
            result.push({
                type: 'dayPeriod',
                value: fv,
            });
        }
        else if (p === 'relatedYear') {
            var v = tm.relatedYear;
            // @ts-ignore
            var fv = nf.format(v);
            result.push({
                // @ts-ignore TODO: Fix TS type
                type: 'relatedYear',
                value: fv,
            });
        }
        else if (p === 'yearName') {
            var v = tm.yearName;
            // @ts-ignore
            var fv = nf.format(v);
            result.push({
                // @ts-ignore TODO: Fix TS type
                type: 'yearName',
                value: fv,
            });
        }
    }
    return result;
}


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ToLocalTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__262__ = __webpack_require__(6);


function getApplicableZoneData(t, timeZone, tzData) {
    var _a;
    var zoneData = tzData[timeZone];
    // We don't have data for this so just say it's UTC
    if (!zoneData) {
        return [0, false];
    }
    var i = 0;
    var offset = 0;
    var dst = false;
    for (; i <= zoneData.length; i++) {
        if (i === zoneData.length || zoneData[i][0] * 1e3 > t) {
            _a = zoneData[i - 1], offset = _a[2], dst = _a[3];
            break;
        }
    }
    return [offset * 1e3, dst];
}
/**
 * https://tc39.es/ecma402/#sec-tolocaltime
 * @param t
 * @param calendar
 * @param timeZone
 */
function ToLocalTime(t, calendar, timeZone, _a) {
    var tzData = _a.tzData;
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* invariant */])(Object(__WEBPACK_IMPORTED_MODULE_1__262__["m" /* Type */])(t) === 'Number', 'invalid time');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* invariant */])(calendar === 'gregory', 'We only support Gregory calendar right now');
    var _b = getApplicableZoneData(t, timeZone, tzData), timeZoneOffset = _b[0], inDST = _b[1];
    var tz = t + timeZoneOffset;
    var year = Object(__WEBPACK_IMPORTED_MODULE_1__262__["o" /* YearFromTime */])(tz);
    return {
        weekday: Object(__WEBPACK_IMPORTED_MODULE_1__262__["n" /* WeekDay */])(tz),
        era: year < 0 ? 'BC' : 'AD',
        year: year,
        relatedYear: undefined,
        yearName: undefined,
        month: Object(__WEBPACK_IMPORTED_MODULE_1__262__["f" /* MonthFromTime */])(tz),
        day: Object(__WEBPACK_IMPORTED_MODULE_1__262__["b" /* DateFromTime */])(tz),
        hour: Object(__WEBPACK_IMPORTED_MODULE_1__262__["d" /* HourFromTime */])(tz),
        minute: Object(__WEBPACK_IMPORTED_MODULE_1__262__["e" /* MinFromTime */])(tz),
        second: Object(__WEBPACK_IMPORTED_MODULE_1__262__["h" /* SecFromTime */])(tz),
        inDST: inDST,
        // IMPORTANT: Not in spec
        timeZoneOffset: timeZoneOffset,
    };
}


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PartitionDateTimeRangePattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__262__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ToLocalTime__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormatDateTimePattern__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PartitionPattern__ = __webpack_require__(55);




var TABLE_2_FIELDS = [
    'era',
    'year',
    'month',
    'day',
    'ampm',
    'hour',
    'minute',
    'second',
];
function PartitionDateTimeRangePattern(dtf, x, y, implDetails) {
    x = Object(__WEBPACK_IMPORTED_MODULE_0__262__["i" /* TimeClip */])(x);
    if (isNaN(x)) {
        throw new RangeError('Invalid start time');
    }
    y = Object(__WEBPACK_IMPORTED_MODULE_0__262__["i" /* TimeClip */])(y);
    if (isNaN(y)) {
        throw new RangeError('Invalid end time');
    }
    /** IMPL START */
    var getInternalSlots = implDetails.getInternalSlots, tzData = implDetails.tzData;
    var internalSlots = getInternalSlots(dtf);
    /** IMPL END */
    var tm1 = Object(__WEBPACK_IMPORTED_MODULE_1__ToLocalTime__["a" /* ToLocalTime */])(x, 
    // @ts-ignore
    internalSlots.calendar, internalSlots.timeZone, { tzData: tzData });
    var tm2 = Object(__WEBPACK_IMPORTED_MODULE_1__ToLocalTime__["a" /* ToLocalTime */])(y, 
    // @ts-ignore
    internalSlots.calendar, internalSlots.timeZone, { tzData: tzData });
    var pattern = internalSlots.pattern, rangePatterns = internalSlots.rangePatterns;
    var rangePattern;
    var dateFieldsPracticallyEqual = true;
    var patternContainsLargerDateField = false;
    for (var _i = 0, TABLE_2_FIELDS_1 = TABLE_2_FIELDS; _i < TABLE_2_FIELDS_1.length; _i++) {
        var fieldName = TABLE_2_FIELDS_1[_i];
        if (dateFieldsPracticallyEqual && !patternContainsLargerDateField) {
            if (fieldName === 'ampm') {
                var rp = rangePatterns.ampm;
                if (rangePattern !== undefined && rp === undefined) {
                    patternContainsLargerDateField = true;
                }
                else {
                    var v1 = tm1.hour;
                    var v2 = tm2.hour;
                    if ((v1 > 11 && v2 < 11) || (v1 < 11 && v2 > 11)) {
                        dateFieldsPracticallyEqual = false;
                    }
                    rangePattern = rp;
                }
            }
            else {
                var rp = rangePatterns[fieldName];
                if (rangePattern !== undefined && rp === undefined) {
                    patternContainsLargerDateField = true;
                }
                else {
                    var v1 = tm1[fieldName];
                    var v2 = tm2[fieldName];
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__262__["g" /* SameValue */])(v1, v2)) {
                        dateFieldsPracticallyEqual = false;
                    }
                    rangePattern = rp;
                }
            }
        }
    }
    if (dateFieldsPracticallyEqual) {
        var result_2 = Object(__WEBPACK_IMPORTED_MODULE_2__FormatDateTimePattern__["a" /* FormatDateTimePattern */])(dtf, Object(__WEBPACK_IMPORTED_MODULE_3__PartitionPattern__["a" /* PartitionPattern */])(pattern), x, implDetails);
        for (var _a = 0, result_1 = result_2; _a < result_1.length; _a++) {
            var r = result_1[_a];
            r.source = "shared" /* shared */;
        }
        return result_2;
    }
    var result = [];
    if (rangePattern === undefined) {
        rangePattern = rangePatterns.default;
        /** IMPL DETAILS */
        // Now we have to replace {0} & {1} with actual pattern
        for (var _b = 0, _c = rangePattern.patternParts; _b < _c.length; _b++) {
            var patternPart = _c[_b];
            if (patternPart.pattern === '{0}' || patternPart.pattern === '{1}') {
                patternPart.pattern = pattern;
            }
        }
    }
    for (var _d = 0, _e = rangePattern.patternParts; _d < _e.length; _d++) {
        var rangePatternPart = _e[_d];
        var source = rangePatternPart.source, pattern_1 = rangePatternPart.pattern;
        var z = void 0;
        if (source === "startRange" /* startRange */ ||
            source === "shared" /* shared */) {
            z = x;
        }
        else {
            z = y;
        }
        var patternParts = Object(__WEBPACK_IMPORTED_MODULE_3__PartitionPattern__["a" /* PartitionPattern */])(pattern_1);
        var partResult = Object(__WEBPACK_IMPORTED_MODULE_2__FormatDateTimePattern__["a" /* FormatDateTimePattern */])(dtf, patternParts, z, implDetails);
        for (var _f = 0, partResult_1 = partResult; _f < partResult_1.length; _f++) {
            var r = partResult_1[_f];
            r.source = source;
        }
        result = result.concat(partResult);
    }
    return result;
}


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ToDateTimeOptions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__262__ = __webpack_require__(6);

/**
 * https://tc39.es/ecma402/#sec-todatetimeoptions
 * @param options
 * @param required
 * @param defaults
 */
function ToDateTimeOptions(options, required, defaults) {
    if (options === undefined) {
        options = null;
    }
    else {
        options = Object(__WEBPACK_IMPORTED_MODULE_0__262__["k" /* ToObject */])(options);
    }
    options = Object.create(options);
    var needDefaults = true;
    if (required === 'date' || required === 'any') {
        for (var _i = 0, _a = ['weekday', 'year', 'month', 'day']; _i < _a.length; _i++) {
            var prop = _a[_i];
            var value = options[prop];
            if (value !== undefined) {
                needDefaults = false;
            }
        }
    }
    if (required === 'time' || required === 'any') {
        for (var _b = 0, _c = ['hour', 'minute', 'second']; _b < _c.length; _b++) {
            var prop = _c[_b];
            var value = options[prop];
            if (value !== undefined) {
                needDefaults = false;
            }
        }
    }
    if (options.dateStyle !== undefined || options.timeStyle !== undefined) {
        needDefaults = false;
    }
    if (required === 'date' && options.timeStyle) {
        throw new TypeError('Intl.DateTimeFormat date was required but timeStyle was included');
    }
    if (required === 'time' && options.dateStyle) {
        throw new TypeError('Intl.DateTimeFormat time was required but dateStyle was included');
    }
    if (needDefaults && (defaults === 'date' || defaults === 'all')) {
        for (var _d = 0, _e = ['year', 'month', 'day']; _d < _e.length; _d++) {
            var prop = _e[_d];
            options[prop] = 'numeric';
        }
    }
    if (needDefaults && (defaults === 'time' || defaults === 'all')) {
        for (var _f = 0, _g = ['hour', 'minute', 'second']; _f < _g.length; _f++) {
            var prop = _g[_f];
            options[prop] = 'numeric';
        }
    }
    return options;
}


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IsValidTimeZoneName;
/**
 * https://tc39.es/ecma402/#sec-isvalidtimezonename
 * @param tz
 * @param implDetails implementation details
 */
function IsValidTimeZoneName(tz, _a) {
    var tzData = _a.tzData, uppercaseLinks = _a.uppercaseLinks;
    var uppercasedTz = tz.toUpperCase();
    var zoneNames = new Set();
    Object.keys(tzData)
        .map(function (z) { return z.toUpperCase(); })
        .forEach(function (z) { return zoneNames.add(z); });
    return zoneNames.has(uppercasedTz) || uppercasedTz in uppercaseLinks;
}


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GetNumberOption;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DefaultNumberOption__ = __webpack_require__(169);
/**
 * https://tc39.es/ecma402/#sec-getnumberoption
 * @param options
 * @param property
 * @param min
 * @param max
 * @param fallback
 */

function GetNumberOption(options, property, minimum, maximum, fallback) {
    var val = options[property];
    return Object(__WEBPACK_IMPORTED_MODULE_0__DefaultNumberOption__["a" /* DefaultNumberOption */])(val, minimum, maximum, fallback);
}


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DefaultNumberOption;
/**
 * https://tc39.es/ecma402/#sec-defaultnumberoption
 * @param val
 * @param min
 * @param max
 * @param fallback
 */
function DefaultNumberOption(val, min, max, fallback) {
    if (val !== undefined) {
        val = Number(val);
        if (isNaN(val) || val < min || val > max) {
            throw new RangeError(val + " is outside of range [" + min + ", " + max + "]");
        }
        return Math.floor(val);
    }
    return fallback;
}


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SANCTIONED_UNITS */
/* unused harmony export removeUnitNamespace */
/* unused harmony export SIMPLE_UNITS */
/* harmony export (immutable) */ __webpack_exports__["a"] = IsSanctionedSimpleUnitIdentifier;
/**
 * https://tc39.es/ecma402/#table-sanctioned-simple-unit-identifiers
 */
var SANCTIONED_UNITS = [
    'angle-degree',
    'area-acre',
    'area-hectare',
    'concentr-percent',
    'digital-bit',
    'digital-byte',
    'digital-gigabit',
    'digital-gigabyte',
    'digital-kilobit',
    'digital-kilobyte',
    'digital-megabit',
    'digital-megabyte',
    'digital-petabyte',
    'digital-terabit',
    'digital-terabyte',
    'duration-day',
    'duration-hour',
    'duration-millisecond',
    'duration-minute',
    'duration-month',
    'duration-second',
    'duration-week',
    'duration-year',
    'length-centimeter',
    'length-foot',
    'length-inch',
    'length-kilometer',
    'length-meter',
    'length-mile-scandinavian',
    'length-mile',
    'length-millimeter',
    'length-yard',
    'mass-gram',
    'mass-kilogram',
    'mass-ounce',
    'mass-pound',
    'mass-stone',
    'temperature-celsius',
    'temperature-fahrenheit',
    'volume-fluid-ounce',
    'volume-gallon',
    'volume-liter',
    'volume-milliliter',
];
// In CLDR, the unit name always follows the form `namespace-unit` pattern.
// For example: `digital-bit` instead of `bit`. This function removes the namespace prefix.
function removeUnitNamespace(unit) {
    return unit.slice(unit.indexOf('-') + 1);
}
/**
 * https://tc39.es/ecma402/#table-sanctioned-simple-unit-identifiers
 */
var SIMPLE_UNITS = SANCTIONED_UNITS.map(removeUnitNamespace);
/**
 * https://tc39.es/ecma402/#sec-issanctionedsimpleunitidentifier
 */
function IsSanctionedSimpleUnitIdentifier(unitIdentifier) {
    return SIMPLE_UNITS.indexOf(unitIdentifier) > -1;
}


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IsWellFormedUnitIdentifier;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IsSanctionedSimpleUnitIdentifier__ = __webpack_require__(170);

/**
 * This follows https://tc39.es/ecma402/#sec-case-sensitivity-and-case-mapping
 * @param str string to convert
 */
function toLowerCase(str) {
    return str.replace(/([A-Z])/g, function (_, c) { return c.toLowerCase(); });
}
/**
 * https://tc39.es/ecma402/#sec-iswellformedunitidentifier
 * @param unit
 */
function IsWellFormedUnitIdentifier(unit) {
    unit = toLowerCase(unit);
    if (Object(__WEBPACK_IMPORTED_MODULE_0__IsSanctionedSimpleUnitIdentifier__["a" /* IsSanctionedSimpleUnitIdentifier */])(unit)) {
        return true;
    }
    var units = unit.split('-per-');
    if (units.length !== 2) {
        return false;
    }
    var numerator = units[0], denominator = units[1];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__IsSanctionedSimpleUnitIdentifier__["a" /* IsSanctionedSimpleUnitIdentifier */])(numerator) ||
        !Object(__WEBPACK_IMPORTED_MODULE_0__IsSanctionedSimpleUnitIdentifier__["a" /* IsSanctionedSimpleUnitIdentifier */])(denominator)) {
        return false;
    }
    return true;
}


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ComputeExponent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ComputeExponentForMagnitude__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormatNumericToString__ = __webpack_require__(56);



/**
 * The abstract operation ComputeExponent computes an exponent (power of ten) by which to scale x
 * according to the number formatting settings. It handles cases such as 999 rounding up to 1000,
 * requiring a different exponent.
 *
 * NOT IN SPEC: it returns [exponent, magnitude].
 */
function ComputeExponent(numberFormat, x, _a) {
    var getInternalSlots = _a.getInternalSlots;
    if (x === 0) {
        return [0, 0];
    }
    if (x < 0) {
        x = -x;
    }
    var magnitude = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* getMagnitude */])(x);
    var exponent = Object(__WEBPACK_IMPORTED_MODULE_1__ComputeExponentForMagnitude__["a" /* ComputeExponentForMagnitude */])(numberFormat, magnitude, {
        getInternalSlots: getInternalSlots,
    });
    // Preserve more precision by doing multiplication when exponent is negative.
    x = exponent < 0 ? x * Math.pow(10, -exponent) : x / Math.pow(10, exponent);
    var formatNumberResult = Object(__WEBPACK_IMPORTED_MODULE_2__FormatNumericToString__["a" /* FormatNumericToString */])(getInternalSlots(numberFormat), x);
    if (formatNumberResult.roundedNumber === 0) {
        return [exponent, magnitude];
    }
    var newMagnitude = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* getMagnitude */])(formatNumberResult.roundedNumber);
    if (newMagnitude === magnitude - exponent) {
        return [exponent, magnitude];
    }
    return [
        Object(__WEBPACK_IMPORTED_MODULE_1__ComputeExponentForMagnitude__["a" /* ComputeExponentForMagnitude */])(numberFormat, magnitude + 1, {
            getInternalSlots: getInternalSlots,
        }),
        magnitude + 1,
    ];
}


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ComputeExponentForMagnitude;
/**
 * The abstract operation ComputeExponentForMagnitude computes an exponent by which to scale a
 * number of the given magnitude (power of ten of the most significant digit) according to the
 * locale and the desired notation (scientific, engineering, or compact).
 */
function ComputeExponentForMagnitude(numberFormat, magnitude, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(numberFormat);
    var notation = internalSlots.notation, dataLocaleData = internalSlots.dataLocaleData, numberingSystem = internalSlots.numberingSystem;
    switch (notation) {
        case 'standard':
            return 0;
        case 'scientific':
            return magnitude;
        case 'engineering':
            return Math.floor(magnitude / 3) * 3;
        default: {
            // Let exponent be an implementation- and locale-dependent (ILD) integer by which to scale a
            // number of the given magnitude in compact notation for the current locale.
            var compactDisplay = internalSlots.compactDisplay, style = internalSlots.style, currencyDisplay = internalSlots.currencyDisplay;
            var thresholdMap = void 0;
            if (style === 'currency' && currencyDisplay !== 'name') {
                var currency = dataLocaleData.numbers.currency[numberingSystem] ||
                    dataLocaleData.numbers.currency[dataLocaleData.numbers.nu[0]];
                thresholdMap = currency.short;
            }
            else {
                var decimal = dataLocaleData.numbers.decimal[numberingSystem] ||
                    dataLocaleData.numbers.decimal[dataLocaleData.numbers.nu[0]];
                thresholdMap = compactDisplay === 'long' ? decimal.long : decimal.short;
            }
            if (!thresholdMap) {
                return 0;
            }
            var num = String(Math.pow(10, magnitude));
            var thresholds = Object.keys(thresholdMap); // TODO: this can be pre-processed
            if (num < thresholds[0]) {
                return 0;
            }
            if (num > thresholds[thresholds.length - 1]) {
                return thresholds[thresholds.length - 1].length - 1;
            }
            var i = thresholds.indexOf(num);
            if (i === -1) {
                return 0;
            }
            // See https://unicode.org/reports/tr35/tr35-numbers.html#Compact_Number_Formats
            // Special handling if the pattern is precisely `0`.
            var magnitudeKey = thresholds[i];
            // TODO: do we need to handle plural here?
            var compactPattern = thresholdMap[magnitudeKey].other;
            if (compactPattern === '0') {
                return 0;
            }
            // Example: in zh-TW, `10000000` maps to `0000萬`. So we need to return 8 - 4 = 4 here.
            return (magnitudeKey.length -
                thresholdMap[magnitudeKey].other.match(/0+/)[0].length);
        }
    }
}


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ToRawPrecision;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);

function ToRawPrecision(x, minPrecision, maxPrecision) {
    var p = maxPrecision;
    var m;
    var e;
    var xFinal;
    if (x === 0) {
        m = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* repeat */])('0', p);
        e = 0;
        xFinal = 0;
    }
    else {
        var xToString = x.toString();
        // If xToString is formatted as scientific notation, the number is either very small or very
        // large. If the precision of the formatted string is lower that requested max precision, we
        // should still infer them from the formatted string, otherwise the formatted result might have
        // precision loss (e.g. 1e41 will not have 0 in every trailing digits).
        var xToStringExponentIndex = xToString.indexOf('e');
        var _a = xToString.split('e'), xToStringMantissa = _a[0], xToStringExponent = _a[1];
        var xToStringMantissaWithoutDecimalPoint = xToStringMantissa.replace('.', '');
        if (xToStringExponentIndex >= 0 &&
            xToStringMantissaWithoutDecimalPoint.length <= p) {
            e = +xToStringExponent;
            m =
                xToStringMantissaWithoutDecimalPoint +
                    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* repeat */])('0', p - xToStringMantissaWithoutDecimalPoint.length);
            xFinal = x;
        }
        else {
            e = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* getMagnitude */])(x);
            var decimalPlaceOffset = e - p + 1;
            // n is the integer containing the required precision digits. To derive the formatted string,
            // we will adjust its decimal place in the logic below.
            var n = Math.round(adjustDecimalPlace(x, decimalPlaceOffset));
            // The rounding caused the change of magnitude, so we should increment `e` by 1.
            if (adjustDecimalPlace(n, p - 1) >= 10) {
                e = e + 1;
                // Divide n by 10 to swallow one precision.
                n = Math.floor(n / 10);
            }
            m = n.toString();
            // Equivalent of n * 10 ** (e - p + 1)
            xFinal = adjustDecimalPlace(n, p - 1 - e);
        }
    }
    var int;
    if (e >= p - 1) {
        m = m + Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* repeat */])('0', e - p + 1);
        int = e + 1;
    }
    else if (e >= 0) {
        m = m.slice(0, e + 1) + "." + m.slice(e + 1);
        int = e + 1;
    }
    else {
        m = "0." + Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* repeat */])('0', -e - 1) + m;
        int = 1;
    }
    if (m.indexOf('.') >= 0 && maxPrecision > minPrecision) {
        var cut = maxPrecision - minPrecision;
        while (cut > 0 && m[m.length - 1] === '0') {
            m = m.slice(0, -1);
            cut--;
        }
        if (m[m.length - 1] === '.') {
            m = m.slice(0, -1);
        }
    }
    return { formattedString: m, roundedNumber: xFinal, integerDigitsCount: int };
    // x / (10 ** magnitude), but try to preserve as much floating point precision as possible.
    function adjustDecimalPlace(x, magnitude) {
        return magnitude < 0 ? x * Math.pow(10, -magnitude) : x / Math.pow(10, magnitude);
    }
}


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CurrencyDigits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__262__ = __webpack_require__(6);

/**
 * https://tc39.es/ecma402/#sec-currencydigits
 */
function CurrencyDigits(c, _a) {
    var currencyDigitsData = _a.currencyDigitsData;
    return Object(__WEBPACK_IMPORTED_MODULE_0__262__["c" /* HasOwnProperty */])(currencyDigitsData, c)
        ? currencyDigitsData[c]
        : 2;
}


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PartitionNumberPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormatNumericToString__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__262__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComputeExponent__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__format_to_parts__ = __webpack_require__(177);




/**
 * https://tc39.es/ecma402/#sec-formatnumberstring
 */
function PartitionNumberPattern(numberFormat, x, _a) {
    var _b;
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(numberFormat);
    var pl = internalSlots.pl, dataLocaleData = internalSlots.dataLocaleData, numberingSystem = internalSlots.numberingSystem;
    var symbols = dataLocaleData.numbers.symbols[numberingSystem] ||
        dataLocaleData.numbers.symbols[dataLocaleData.numbers.nu[0]];
    var magnitude = 0;
    var exponent = 0;
    var n;
    if (isNaN(x)) {
        n = symbols.nan;
    }
    else if (!isFinite(x)) {
        n = symbols.infinity;
    }
    else {
        if (internalSlots.style === 'percent') {
            x *= 100;
        }
        _b = Object(__WEBPACK_IMPORTED_MODULE_2__ComputeExponent__["a" /* ComputeExponent */])(numberFormat, x, {
            getInternalSlots: getInternalSlots,
        }), exponent = _b[0], magnitude = _b[1];
        // Preserve more precision by doing multiplication when exponent is negative.
        x = exponent < 0 ? x * Math.pow(10, -exponent) : x / Math.pow(10, exponent);
        var formatNumberResult = Object(__WEBPACK_IMPORTED_MODULE_0__FormatNumericToString__["a" /* FormatNumericToString */])(internalSlots, x);
        n = formatNumberResult.formattedString;
        x = formatNumberResult.roundedNumber;
    }
    // Based on https://tc39.es/ecma402/#sec-getnumberformatpattern
    // We need to do this before `x` is rounded.
    var sign;
    var signDisplay = internalSlots.signDisplay;
    switch (signDisplay) {
        case 'never':
            sign = 0;
            break;
        case 'auto':
            if (Object(__WEBPACK_IMPORTED_MODULE_1__262__["g" /* SameValue */])(x, 0) || x > 0 || isNaN(x)) {
                sign = 0;
            }
            else {
                sign = -1;
            }
            break;
        case 'always':
            if (Object(__WEBPACK_IMPORTED_MODULE_1__262__["g" /* SameValue */])(x, 0) || x > 0 || isNaN(x)) {
                sign = 1;
            }
            else {
                sign = -1;
            }
            break;
        default:
            // x === 0 -> x is 0 or x is -0
            if (x === 0 || isNaN(x)) {
                sign = 0;
            }
            else if (x > 0) {
                sign = 1;
            }
            else {
                sign = -1;
            }
    }
    return Object(__WEBPACK_IMPORTED_MODULE_3__format_to_parts__["a" /* default */])({ roundedNumber: x, formattedString: n, exponent: exponent, magnitude: magnitude, sign: sign }, internalSlots.dataLocaleData, pl, internalSlots);
}


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatToParts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ToRawFixed__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__digit_mapping_json__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__digit_mapping_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__digit_mapping_json__);


// This is from: unicode-12.1.0/General_Category/Symbol/regex.js
// IE11 does not support unicode flag, otherwise this is just /\p{S}/u.
var S_UNICODE_REGEX = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20BF\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B98-\u2BFF\u2CE5-\u2CEA\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uFB29\uFBB2-\uFBC1\uFDFC\uFDFD\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9B\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD10-\uDD6C\uDD70-\uDDAC\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED5\uDEE0-\uDEEC\uDEF0-\uDEFA\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD00-\uDD0B\uDD0D-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDE53\uDE60-\uDE6D\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95]/;
// /^\p{S}/u
var CARET_S_UNICODE_REGEX = new RegExp("^" + S_UNICODE_REGEX.source);
// /\p{S}$/u
var S_DOLLAR_UNICODE_REGEX = new RegExp(S_UNICODE_REGEX.source + "$");
var CLDR_NUMBER_PATTERN = /[#0](?:[\.,][#0]+)*/g;
function formatToParts(numberResult, data, pl, options) {
    var sign = numberResult.sign, exponent = numberResult.exponent, magnitude = numberResult.magnitude;
    var notation = options.notation, style = options.style, numberingSystem = options.numberingSystem;
    var defaultNumberingSystem = data.numbers.nu[0];
    // #region Part 1: partition and interpolate the CLDR number pattern.
    // ----------------------------------------------------------
    var compactNumberPattern = null;
    if (notation === 'compact' && magnitude) {
        compactNumberPattern = getCompactDisplayPattern(numberResult, pl, data, style, options.compactDisplay, options.currencyDisplay, numberingSystem);
    }
    // This is used multiple times
    var nonNameCurrencyPart;
    if (style === 'currency' && options.currencyDisplay !== 'name') {
        var byCurrencyDisplay = data.currencies[options.currency];
        if (byCurrencyDisplay) {
            switch (options.currencyDisplay) {
                case 'code':
                    nonNameCurrencyPart = options.currency;
                    break;
                case 'symbol':
                    nonNameCurrencyPart = byCurrencyDisplay.symbol;
                    break;
                default:
                    nonNameCurrencyPart = byCurrencyDisplay.narrow;
                    break;
            }
        }
        else {
            // Fallback for unknown currency
            nonNameCurrencyPart = options.currency;
        }
    }
    var numberPattern;
    if (!compactNumberPattern) {
        // Note: if the style is unit, or is currency and the currency display is name,
        // its unit parts will be interpolated in part 2. So here we can fallback to decimal.
        if (style === 'decimal' ||
            style === 'unit' ||
            (style === 'currency' && options.currencyDisplay === 'name')) {
            // Shortcut for decimal
            var decimalData = data.numbers.decimal[numberingSystem] ||
                data.numbers.decimal[defaultNumberingSystem];
            numberPattern = getPatternForSign(decimalData.standard, sign);
        }
        else if (style === 'currency') {
            var currencyData = data.numbers.currency[numberingSystem] ||
                data.numbers.currency[defaultNumberingSystem];
            // We replace number pattern part with `0` for easier postprocessing.
            numberPattern = getPatternForSign(currencyData[options.currencySign], sign);
        }
        else {
            // percent
            var percentPattern = data.numbers.percent[numberingSystem] ||
                data.numbers.percent[defaultNumberingSystem];
            numberPattern = getPatternForSign(percentPattern, sign);
        }
    }
    else {
        numberPattern = compactNumberPattern;
    }
    // Extract the decimal number pattern string. It looks like "#,##0,00", which will later be
    // used to infer decimal group sizes.
    var decimalNumberPattern = CLDR_NUMBER_PATTERN.exec(numberPattern)[0];
    // Now we start to substitute patterns
    // 1. replace strings like `0` and `#,##0.00` with `{0}`
    // 2. unquote characters (invariant: the quoted characters does not contain the special tokens)
    numberPattern = numberPattern
        .replace(CLDR_NUMBER_PATTERN, '{0}')
        .replace(/'(.)'/g, '$1');
    // Handle currency spacing (both compact and non-compact).
    if (style === 'currency' && options.currencyDisplay !== 'name') {
        var currencyData = data.numbers.currency[numberingSystem] ||
            data.numbers.currency[defaultNumberingSystem];
        // See `currencySpacing` substitution rule in TR-35.
        // Here we always assume the currencyMatch is "[:^S:]" and surroundingMatch is "[:digit:]".
        //
        // Example 1: for pattern "#,##0.00¤" with symbol "US$", we replace "¤" with the symbol,
        // but insert an extra non-break space before the symbol, because "[:^S:]" matches "U" in
        // "US$" and "[:digit:]" matches the latn numbering system digits.
        //
        // Example 2: for pattern "¤#,##0.00" with symbol "US$", there is no spacing between symbol
        // and number, because `$` does not match "[:^S:]".
        //
        // Implementation note: here we do the best effort to infer the insertion.
        // We also assume that `beforeInsertBetween` and `afterInsertBetween` will never be `;`.
        var afterCurrency = currencyData.currencySpacing.afterInsertBetween;
        if (afterCurrency && !S_DOLLAR_UNICODE_REGEX.test(nonNameCurrencyPart)) {
            numberPattern = numberPattern.replace('¤{0}', "\u00A4" + afterCurrency + "{0}");
        }
        var beforeCurrency = currencyData.currencySpacing.beforeInsertBetween;
        if (beforeCurrency && !CARET_S_UNICODE_REGEX.test(nonNameCurrencyPart)) {
            numberPattern = numberPattern.replace('{0}¤', "{0}" + beforeCurrency + "\u00A4");
        }
    }
    // The following tokens are special: `{0}`, `¤`, `%`, `-`, `+`, `{c:...}.
    var numberPatternParts = numberPattern.split(/({c:[^}]+}|\{0\}|[¤%\-\+])/g);
    var numberParts = [];
    var symbols = data.numbers.symbols[numberingSystem] ||
        data.numbers.symbols[defaultNumberingSystem];
    for (var _i = 0, numberPatternParts_1 = numberPatternParts; _i < numberPatternParts_1.length; _i++) {
        var part = numberPatternParts_1[_i];
        if (!part) {
            continue;
        }
        switch (part) {
            case '{0}': {
                // We only need to handle scientific and engineering notation here.
                numberParts.push.apply(numberParts, paritionNumberIntoParts(symbols, numberResult, notation, exponent, numberingSystem, 
                // If compact number pattern exists, do not insert group separators.
                !compactNumberPattern && options.useGrouping, decimalNumberPattern));
                break;
            }
            case '-':
                numberParts.push({ type: 'minusSign', value: symbols.minusSign });
                break;
            case '+':
                numberParts.push({ type: 'plusSign', value: symbols.plusSign });
                break;
            case '%':
                numberParts.push({ type: 'percentSign', value: symbols.percentSign });
                break;
            case '¤':
                // Computed above when handling currency spacing.
                numberParts.push({ type: 'currency', value: nonNameCurrencyPart });
                break;
            default:
                if (/^\{c:/.test(part)) {
                    numberParts.push({
                        type: 'compact',
                        value: part.substring(3, part.length - 1),
                    });
                }
                else {
                    // literal
                    numberParts.push({ type: 'literal', value: part });
                }
                break;
        }
    }
    // #endregion
    // #region Part 2: interpolate unit pattern if necessary.
    // ----------------------------------------------
    switch (style) {
        case 'currency': {
            // `currencyDisplay: 'name'` has similar pattern handling as units.
            if (options.currencyDisplay === 'name') {
                var unitPattern = (data.numbers.currency[numberingSystem] ||
                    data.numbers.currency[defaultNumberingSystem]).unitPattern;
                // Select plural
                var unitName = void 0;
                var currencyNameData = data.currencies[options.currency];
                if (currencyNameData) {
                    unitName = selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), currencyNameData.displayName);
                }
                else {
                    // Fallback for unknown currency
                    unitName = options.currency;
                }
                // Do {0} and {1} substitution
                var unitPatternParts = unitPattern.split(/(\{[01]\})/g);
                var result = [];
                for (var _a = 0, unitPatternParts_1 = unitPatternParts; _a < unitPatternParts_1.length; _a++) {
                    var part = unitPatternParts_1[_a];
                    switch (part) {
                        case '{0}':
                            result.push.apply(result, numberParts);
                            break;
                        case '{1}':
                            result.push({ type: 'currency', value: unitName });
                            break;
                        default:
                            if (part) {
                                result.push({ type: 'literal', value: part });
                            }
                            break;
                    }
                }
                return result;
            }
            else {
                return numberParts;
            }
        }
        case 'unit': {
            var unit = options.unit, unitDisplay = options.unitDisplay;
            var unitData = data.units.simple[unit];
            var unitPattern = void 0;
            if (unitData) {
                // Simple unit pattern
                unitPattern = selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), data.units.simple[unit][unitDisplay]);
            }
            else {
                // See: http://unicode.org/reports/tr35/tr35-general.html#perUnitPatterns
                // If cannot find unit in the simple pattern, it must be "per" compound pattern.
                // Implementation note: we are not following TR-35 here because we need to format to parts!
                var _b = unit.split('-per-'), numeratorUnit = _b[0], denominatorUnit = _b[1];
                unitData = data.units.simple[numeratorUnit];
                var numeratorUnitPattern = selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), data.units.simple[numeratorUnit][unitDisplay]);
                var perUnitPattern = data.units.simple[denominatorUnit].perUnit[unitDisplay];
                if (perUnitPattern) {
                    // perUnitPattern exists, combine it with numeratorUnitPattern
                    unitPattern = perUnitPattern.replace('{0}', numeratorUnitPattern);
                }
                else {
                    // get compoundUnit pattern (e.g. "{0} per {1}"), repalce {0} with numerator pattern and {1} with
                    // the denominator pattern in singular form.
                    var perPattern = data.units.compound.per[unitDisplay];
                    var denominatorPattern = selectPlural(pl, 1, data.units.simple[denominatorUnit][unitDisplay]);
                    unitPattern = unitPattern = perPattern
                        .replace('{0}', numeratorUnitPattern)
                        .replace('{1}', denominatorPattern.replace('{0}', ''));
                }
            }
            var result = [];
            // We need spacing around "{0}" because they are not treated as "unit" parts, but "literal".
            for (var _c = 0, _d = unitPattern.split(/(\s*\{0\}\s*)/); _c < _d.length; _c++) {
                var part = _d[_c];
                var interpolateMatch = /^(\s*)\{0\}(\s*)$/.exec(part);
                if (interpolateMatch) {
                    // Space before "{0}"
                    if (interpolateMatch[1]) {
                        result.push({ type: 'literal', value: interpolateMatch[1] });
                    }
                    // "{0}" itself
                    result.push.apply(result, numberParts);
                    // Space after "{0}"
                    if (interpolateMatch[2]) {
                        result.push({ type: 'literal', value: interpolateMatch[2] });
                    }
                }
                else if (part) {
                    result.push({ type: 'unit', value: part });
                }
            }
            return result;
        }
        default:
            return numberParts;
    }
    // #endregion
}
// A subset of https://tc39.es/ecma402/#sec-partitionnotationsubpattern
// Plus the exponent parts handling.
function paritionNumberIntoParts(symbols, numberResult, notation, exponent, numberingSystem, useGrouping, 
/**
 * This is the decimal number pattern without signs or symbols.
 * It is used to infer the group size when `useGrouping` is true.
 *
 * A typical value looks like "#,##0.00" (primary group size is 3).
 * Some locales like Hindi has secondary group size of 2 (e.g. "#,##,##0.00").
 */
decimalNumberPattern) {
    var result = [];
    // eslint-disable-next-line prefer-const
    var n = numberResult.formattedString, x = numberResult.roundedNumber;
    if (isNaN(x)) {
        return [{ type: 'nan', value: n }];
    }
    else if (!isFinite(x)) {
        return [{ type: 'infinity', value: n }];
    }
    var digitReplacementTable = __WEBPACK_IMPORTED_MODULE_1__digit_mapping_json__[numberingSystem];
    if (digitReplacementTable) {
        n = n.replace(/\d/g, function (digit) { return digitReplacementTable[+digit] || digit; });
    }
    // TODO: Else use an implementation dependent algorithm to map n to the appropriate
    // representation of n in the given numbering system.
    var decimalSepIndex = n.indexOf('.');
    var integer;
    var fraction;
    if (decimalSepIndex > 0) {
        integer = n.slice(0, decimalSepIndex);
        fraction = n.slice(decimalSepIndex + 1);
    }
    else {
        integer = n;
    }
    // #region Grouping integer digits
    // The weird compact and x >= 10000 check is to ensure consistency with Node.js and Chrome.
    // Note that `de` does not have compact form for thousands, but Node.js does not insert grouping separator
    // unless the rounded number is greater than 10000:
    //   NumberFormat('de', {notation: 'compact', compactDisplay: 'short'}).format(1234) //=> "1234"
    //   NumberFormat('de').format(1234) //=> "1.234"
    if (useGrouping && (notation !== 'compact' || x >= 10000)) {
        var groupSepSymbol = symbols.group;
        var groups = [];
        // > There may be two different grouping sizes: The primary grouping size used for the least
        // > significant integer group, and the secondary grouping size used for more significant groups.
        // > If a pattern contains multiple grouping separators, the interval between the last one and the
        // > end of the integer defines the primary grouping size, and the interval between the last two
        // > defines the secondary grouping size. All others are ignored.
        var integerNumberPattern = decimalNumberPattern.split('.')[0];
        var patternGroups = integerNumberPattern.split(',');
        var primaryGroupingSize = 3;
        var secondaryGroupingSize = 3;
        if (patternGroups.length > 1) {
            primaryGroupingSize = patternGroups[patternGroups.length - 1].length;
        }
        if (patternGroups.length > 2) {
            secondaryGroupingSize = patternGroups[patternGroups.length - 2].length;
        }
        var i = integer.length - primaryGroupingSize;
        if (i > 0) {
            // Slice the least significant integer group
            groups.push(integer.slice(i, i + primaryGroupingSize));
            // Then iteratively push the more signicant groups
            // TODO: handle surrogate pairs in some numbering system digits
            for (i -= secondaryGroupingSize; i > 0; i -= secondaryGroupingSize) {
                groups.push(integer.slice(i, i + secondaryGroupingSize));
            }
            groups.push(integer.slice(0, i + secondaryGroupingSize));
        }
        else {
            groups.push(integer);
        }
        while (groups.length > 0) {
            var integerGroup = groups.pop();
            result.push({ type: 'integer', value: integerGroup });
            if (groups.length > 0) {
                result.push({ type: 'group', value: groupSepSymbol });
            }
        }
    }
    else {
        result.push({ type: 'integer', value: integer });
    }
    // #endregion
    if (fraction !== undefined) {
        result.push({ type: 'decimal', value: symbols.decimal }, { type: 'fraction', value: fraction });
    }
    if ((notation === 'scientific' || notation === 'engineering') &&
        isFinite(x)) {
        result.push({ type: 'exponentSeparator', value: symbols.exponential });
        if (exponent < 0) {
            result.push({ type: 'exponentMinusSign', value: symbols.minusSign });
            exponent = -exponent;
        }
        var exponentResult = Object(__WEBPACK_IMPORTED_MODULE_0__ToRawFixed__["a" /* ToRawFixed */])(exponent, 0, 0);
        result.push({
            type: 'exponentInteger',
            value: exponentResult.formattedString,
        });
    }
    return result;
}
function getPatternForSign(pattern, sign) {
    if (pattern.indexOf(';') < 0) {
        pattern = pattern + ";-" + pattern;
    }
    var _a = pattern.split(';'), zeroPattern = _a[0], negativePattern = _a[1];
    switch (sign) {
        case 0:
            return zeroPattern;
        case -1:
            return negativePattern;
        default:
            return negativePattern.indexOf('-') >= 0
                ? negativePattern.replace(/-/g, '+')
                : "+" + zeroPattern;
    }
}
// Find the CLDR pattern for compact notation based on the magnitude of data and style.
//
// Example return value: "¤ {c:laki}000;¤{c:laki} -0" (`sw` locale):
// - Notice the `{c:...}` token that wraps the compact literal.
// - The consecutive zeros are normalized to single zero to match CLDR_NUMBER_PATTERN.
//
// Returning null means the compact display pattern cannot be found.
function getCompactDisplayPattern(numberResult, pl, data, style, compactDisplay, currencyDisplay, numberingSystem) {
    var _a;
    var roundedNumber = numberResult.roundedNumber, sign = numberResult.sign, magnitude = numberResult.magnitude;
    var magnitudeKey = String(Math.pow(10, magnitude));
    var defaultNumberingSystem = data.numbers.nu[0];
    var pattern;
    if (style === 'currency' && currencyDisplay !== 'name') {
        var byNumberingSystem = data.numbers.currency;
        var currencyData = byNumberingSystem[numberingSystem] ||
            byNumberingSystem[defaultNumberingSystem];
        // NOTE: compact notation ignores currencySign!
        var compactPluralRules = (_a = currencyData.short) === null || _a === void 0 ? void 0 : _a[magnitudeKey];
        if (!compactPluralRules) {
            return null;
        }
        pattern = selectPlural(pl, roundedNumber, compactPluralRules);
    }
    else {
        var byNumberingSystem = data.numbers.decimal;
        var byCompactDisplay = byNumberingSystem[numberingSystem] ||
            byNumberingSystem[defaultNumberingSystem];
        var compactPlaralRule = byCompactDisplay[compactDisplay][magnitudeKey];
        if (!compactPlaralRule) {
            return null;
        }
        pattern = selectPlural(pl, roundedNumber, compactPlaralRule);
    }
    // See https://unicode.org/reports/tr35/tr35-numbers.html#Compact_Number_Formats
    // > If the value is precisely “0”, either explicit or defaulted, then the normal number format
    // > pattern for that sort of object is supplied.
    if (pattern === '0') {
        return null;
    }
    pattern = getPatternForSign(pattern, sign)
        // Extract compact literal from the pattern
        .replace(/([^\s;\-\+\d¤]+)/g, '{c:$1}')
        // We replace one or more zeros with a single zero so it matches `CLDR_NUMBER_PATTERN`.
        .replace(/0+/, '0');
    return pattern;
}
function selectPlural(pl, x, rules) {
    return rules[pl.select(x)] || rules.other;
}


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SetNumberFormatUnitOptions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GetOption__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IsWellFormedCurrencyCode__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IsWellFormedUnitIdentifier__ = __webpack_require__(171);



/**
 * https://tc39.es/ecma402/#sec-setnumberformatunitoptions
 */
function SetNumberFormatUnitOptions(nf, options, _a) {
    if (options === void 0) { options = Object.create(null); }
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(nf);
    var style = Object(__WEBPACK_IMPORTED_MODULE_0__GetOption__["a" /* GetOption */])(options, 'style', 'string', ['decimal', 'percent', 'currency', 'unit'], 'decimal');
    internalSlots.style = style;
    var currency = Object(__WEBPACK_IMPORTED_MODULE_0__GetOption__["a" /* GetOption */])(options, 'currency', 'string', undefined, undefined);
    if (currency !== undefined && !Object(__WEBPACK_IMPORTED_MODULE_1__IsWellFormedCurrencyCode__["a" /* IsWellFormedCurrencyCode */])(currency)) {
        throw RangeError('Malformed currency code');
    }
    if (style === 'currency' && currency === undefined) {
        throw TypeError('currency cannot be undefined');
    }
    var currencyDisplay = Object(__WEBPACK_IMPORTED_MODULE_0__GetOption__["a" /* GetOption */])(options, 'currencyDisplay', 'string', ['code', 'symbol', 'narrowSymbol', 'name'], 'symbol');
    var currencySign = Object(__WEBPACK_IMPORTED_MODULE_0__GetOption__["a" /* GetOption */])(options, 'currencySign', 'string', ['standard', 'accounting'], 'standard');
    var unit = Object(__WEBPACK_IMPORTED_MODULE_0__GetOption__["a" /* GetOption */])(options, 'unit', 'string', undefined, undefined);
    if (unit !== undefined && !Object(__WEBPACK_IMPORTED_MODULE_2__IsWellFormedUnitIdentifier__["a" /* IsWellFormedUnitIdentifier */])(unit)) {
        throw RangeError('Invalid unit argument for Intl.NumberFormat()');
    }
    if (style === 'unit' && unit === undefined) {
        throw TypeError('unit cannot be undefined');
    }
    var unitDisplay = Object(__WEBPACK_IMPORTED_MODULE_0__GetOption__["a" /* GetOption */])(options, 'unitDisplay', 'string', ['short', 'narrow', 'long'], 'short');
    if (style === 'currency') {
        internalSlots.currency = currency.toUpperCase();
        internalSlots.currencyDisplay = currencyDisplay;
        internalSlots.currencySign = currencySign;
    }
    if (style === 'unit') {
        internalSlots.unit = unit;
        internalSlots.unitDisplay = unitDisplay;
    }
}


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GetOperands;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__262__ = __webpack_require__(6);


/**
 * http://ecma-international.org/ecma-402/7.0/index.html#sec-getoperands
 * @param s
 */
function GetOperands(s) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* invariant */])(typeof s === 'string', "GetOperands should have been called with a string");
    var n = Object(__WEBPACK_IMPORTED_MODULE_1__262__["j" /* ToNumber */])(s);
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* invariant */])(isFinite(n), 'n should be finite');
    var dp = s.indexOf('.');
    var iv;
    var f;
    var v;
    var fv = '';
    if (dp === -1) {
        iv = n;
        f = 0;
        v = 0;
    }
    else {
        iv = s.slice(0, dp);
        fv = s.slice(dp, s.length);
        f = Object(__WEBPACK_IMPORTED_MODULE_1__262__["j" /* ToNumber */])(fv);
        v = fv.length;
    }
    var i = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_1__262__["j" /* ToNumber */])(iv));
    var w;
    var t;
    if (f !== 0) {
        var ft = fv.replace(/0+$/, '');
        w = ft.length;
        t = Object(__WEBPACK_IMPORTED_MODULE_1__262__["j" /* ToNumber */])(ft);
    }
    else {
        w = 0;
        t = 0;
    }
    return {
        Number: n,
        IntegerDigits: i,
        NumberOfFractionDigits: v,
        NumberOfFractionDigitsWithoutTrailing: w,
        FractionDigits: f,
        FractionDigitsWithoutTrailing: t,
    };
}


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SingularRelativeTimeUnit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__262__ = __webpack_require__(6);


/**
 * https://tc39.es/proposal-intl-relative-time/#sec-singularrelativetimeunit
 * @param unit
 */
function SingularRelativeTimeUnit(unit) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* invariant */])(Object(__WEBPACK_IMPORTED_MODULE_1__262__["m" /* Type */])(unit) === 'String', 'unit must be a string');
    if (unit === 'seconds')
        return 'second';
    if (unit === 'minutes')
        return 'minute';
    if (unit === 'hours')
        return 'hour';
    if (unit === 'days')
        return 'day';
    if (unit === 'weeks')
        return 'week';
    if (unit === 'months')
        return 'month';
    if (unit === 'quarters')
        return 'quarter';
    if (unit === 'years')
        return 'year';
    if (unit !== 'second' &&
        unit !== 'minute' &&
        unit !== 'hour' &&
        unit !== 'day' &&
        unit !== 'week' &&
        unit !== 'month' &&
        unit !== 'quarter' &&
        unit !== 'year') {
        throw new RangeError('invalid unit');
    }
    return unit;
}


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MakePartsList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PartitionPattern__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(4);


function MakePartsList(pattern, unit, parts) {
    var patternParts = Object(__WEBPACK_IMPORTED_MODULE_0__PartitionPattern__["a" /* PartitionPattern */])(pattern);
    var result = [];
    for (var _i = 0, patternParts_1 = patternParts; _i < patternParts_1.length; _i++) {
        var patternPart = patternParts_1[_i];
        if (patternPart.type === 'literal') {
            result.push({
                type: 'literal',
                value: patternPart.value,
            });
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* invariant */])(patternPart.type === '0', "Malformed pattern " + pattern);
            for (var _a = 0, parts_1 = parts; _a < parts_1.length; _a++) {
                var part = parts_1[_a];
                result.push({
                    type: part.type,
                    value: part.value,
                    unit: unit,
                });
            }
        }
    }
    return result;
}


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IntlMessageFormat; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat_parser__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fast_memoize__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fast_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fast_memoize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatters__ = __webpack_require__(185);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/




// -- MessageFormat --------------------------------------------------------
function mergeConfig(c1, c2) {
    if (!c2) {
        return c1;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
        all[k] = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, c1[k]), (c2[k] || {}));
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) {
        return defaultConfig;
    }
    return Object.keys(defaultConfig).reduce(function (all, k) {
        all[k] = mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, defaultConfig));
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                has: function (key) {
                    return key in store;
                },
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
// @ts-ignore this is to deal with rollup's default import shenanigans
var _memoizeIntl = __WEBPACK_IMPORTED_MODULE_2_fast_memoize__["default"] || __WEBPACK_IMPORTED_MODULE_2_fast_memoize__;
var memoizeIntl = _memoizeIntl;
function createDefaultFormatters(cache) {
    if (cache === void 0) { cache = {
        number: {},
        dateTime: {},
        pluralRules: {},
    }; }
    return {
        getNumberFormat: memoizeIntl(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.NumberFormat).bind.apply(_a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spreadArrays */])([void 0], args)))();
        }, {
            cache: createFastMemoizeCache(cache.number),
            strategy: memoizeIntl.strategies.variadic,
        }),
        getDateTimeFormat: memoizeIntl(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spreadArrays */])([void 0], args)))();
        }, {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: memoizeIntl.strategies.variadic,
        }),
        getPluralRules: memoizeIntl(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.PluralRules).bind.apply(_a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spreadArrays */])([void 0], args)))();
        }, {
            cache: createFastMemoizeCache(cache.pluralRules),
            strategy: memoizeIntl.strategies.variadic,
        }),
    };
}
var IntlMessageFormat = /** @class */ (function () {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {},
        };
        this.format = function (values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) {
                return parts[0].value;
            }
            var result = parts.reduce(function (all, part) {
                if (!all.length ||
                    part.type !== 0 /* literal */ ||
                    typeof all[all.length - 1] !== 'string') {
                    all.push(part.value);
                }
                else {
                    all[all.length - 1] += part.value;
                }
                return all;
            }, []);
            if (result.length <= 1) {
                return result[0] || '';
            }
            return result;
        };
        this.formatToParts = function (values) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__formatters__["a" /* formatToParts */])(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function () { return ({
            locale: Intl.NumberFormat.supportedLocalesOf(_this.locales)[0],
        }); };
        this.getAst = function () { return _this.ast; };
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) {
                throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            }
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                normalizeHashtagInPlural: false,
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
            });
        }
        else {
            this.ast = message;
        }
        if (!Array.isArray(this.ast)) {
            throw new TypeError('A message must be provided as a String or AST.');
        }
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.formatters =
            (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function () {
            if (!IntlMessageFormat.memoizedDefaultLocale) {
                IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            }
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.__parse = __WEBPACK_IMPORTED_MODULE_1_intl_messageformat_parser__["m" /* parse */];
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            currency: {
                style: 'currency',
            },
            percent: {
                style: 'percent',
            },
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit',
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric',
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
        },
    };
    return IntlMessageFormat;
}());



/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* harmony export (immutable) */ __webpack_exports__["c"] = __spreadArrays;
/* unused harmony export __spreadArray */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 184 */
/***/ (function(module, exports) {

//
// Main
//

function memoize (fn, options) {
  var cache = options && options.cache
    ? options.cache
    : cacheDefault

  var serializer = options && options.serializer
    ? options.serializer
    : serializerDefault

  var strategy = options && options.strategy
    ? options.strategy
    : strategyDefault

  return strategy(fn, {
    cache: cache,
    serializer: serializer
  })
}

//
// Strategy
//

function isPrimitive (value) {
  return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
}

function monadic (fn, cache, serializer, arg) {
  var cacheKey = isPrimitive(arg) ? arg : serializer(arg)

  var computedValue = cache.get(cacheKey)
  if (typeof computedValue === 'undefined') {
    computedValue = fn.call(this, arg)
    cache.set(cacheKey, computedValue)
  }

  return computedValue
}

function variadic (fn, cache, serializer) {
  var args = Array.prototype.slice.call(arguments, 3)
  var cacheKey = serializer(args)

  var computedValue = cache.get(cacheKey)
  if (typeof computedValue === 'undefined') {
    computedValue = fn.apply(this, args)
    cache.set(cacheKey, computedValue)
  }

  return computedValue
}

function assemble (fn, context, strategy, cache, serialize) {
  return strategy.bind(
    context,
    fn,
    cache,
    serialize
  )
}

function strategyDefault (fn, options) {
  var strategy = fn.length === 1 ? monadic : variadic

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

function strategyVariadic (fn, options) {
  var strategy = variadic

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

function strategyMonadic (fn, options) {
  var strategy = monadic

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

//
// Serializer
//

function serializerDefault () {
  return JSON.stringify(arguments)
}

//
// Cache
//

function ObjectWithoutPrototypeCache () {
  this.cache = Object.create(null)
}

ObjectWithoutPrototypeCache.prototype.has = function (key) {
  return (key in this.cache)
}

ObjectWithoutPrototypeCache.prototype.get = function (key) {
  return this.cache[key]
}

ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
  this.cache[key] = value
}

var cacheDefault = {
  create: function create () {
    return new ObjectWithoutPrototypeCache()
  }
}

//
// API
//

module.exports = memoize
module.exports.strategies = {
  variadic: strategyVariadic,
  monadic: strategyMonadic
}


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PART_TYPE */
/* harmony export (immutable) */ __webpack_exports__["b"] = isFormatXMLElementFn;
/* harmony export (immutable) */ __webpack_exports__["a"] = formatToParts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_intl_messageformat_parser__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(186);


var PART_TYPE;
(function (PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) {
        return parts;
    }
    return parts.reduce(function (all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart ||
            lastPart.type !== 0 /* literal */ ||
            part.type !== 0 /* literal */) {
            all.push(part);
        }
        else {
            lastPart.value += part.value;
        }
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === 'function';
}
// TODO(skeleton): add skeleton support
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
// For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && Object(__WEBPACK_IMPORTED_MODULE_0_intl_messageformat_parser__["e" /* isLiteralElement */])(els[0])) {
        return [
            {
                type: 0 /* literal */,
                value: els[0].value,
            },
        ];
    }
    var result = [];
    for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
        var el = els_1[_i];
        // Exit early for string parts.
        if (Object(__WEBPACK_IMPORTED_MODULE_0_intl_messageformat_parser__["e" /* isLiteralElement */])(el)) {
            result.push({
                type: 0 /* literal */,
                value: el.value,
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if (Object(__WEBPACK_IMPORTED_MODULE_0_intl_messageformat_parser__["i" /* isPoundElement */])(el)) {
            if (typeof currentPluralValue === 'number') {
                result.push({
                    type: 0 /* literal */,
                    value: formatters.getNumberFormat(locales).format(currentPluralValue),
                });
            }
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["d" /* MissingValueError */](varName, originalMessage);
        }
        var value = values[varName];
        if (Object(__WEBPACK_IMPORTED_MODULE_0_intl_messageformat_parser__["b" /* isArgumentElement */])(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') {
                value =
                    typeof value === 'string' || typeof value === 'number'
                        ? String(value)
                        : '';
            }
            result.push({
                type: typeof value === 'string' ? 0 /* literal */ : 1 /* object */,
                value: value,
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (Object(__WEBPACK_IMPORTED_MODULE_0_intl_messageformat_parser__["c" /* isDateElement */])(el)) {
            var style = typeof el.style === 'string'
                ? formats.date[el.style]
                : Object(__WEBPACK_IMPORTED_MODULE_0_intl_messageformat_parser__["d" /* isDateTimeSkeleton */])(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            result.push({
                type: 0 /* literal */,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0_intl_messageformat_parser__["l" /* isTimeElement */])(el)) {
            var style = typeof el.style === 'string'
                ? formats.time[el.style]
                : Object(__WEBPACK_IMPORTED_MODULE_0_intl_messageformat_parser__["d" /* isDateTimeSkeleton */])(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            result.push({
                type: 0 /* literal */,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0_intl_messageformat_parser__["f" /* isNumberElement */])(el)) {
            var style = typeof el.style === 'string'
                ? formats.number[el.style]
                : Object(__WEBPACK_IMPORTED_MODULE_0_intl_messageformat_parser__["g" /* isNumberSkeleton */])(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            if (style && style.scale) {
                value =
                    value *
                        (style.scale || 1);
            }
            result.push({
                type: 0 /* literal */,
                value: formatters
                    .getNumberFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0_intl_messageformat_parser__["k" /* isTagElement */])(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) {
                throw new __WEBPACK_IMPORTED_MODULE_1__error__["c" /* InvalidValueTypeError */](value_1, 'function', originalMessage);
            }
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function (p) { return p.value; }));
            if (!Array.isArray(chunks)) {
                chunks = [chunks];
            }
            result.push.apply(result, chunks.map(function (c) {
                return {
                    type: typeof c === 'string' ? 0 /* literal */ : 1 /* object */,
                    value: c,
                };
            }));
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0_intl_messageformat_parser__["j" /* isSelectElement */])(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) {
                throw new __WEBPACK_IMPORTED_MODULE_1__error__["b" /* InvalidValueError */](el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0_intl_messageformat_parser__["h" /* isPluralElement */])(el)) {
            var opt = el.options["=" + value];
            if (!opt) {
                if (!Intl.PluralRules) {
                    throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* FormatError */]("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", "MISSING_INTL_API" /* MISSING_INTL_API */, originalMessage);
                }
                var rule = formatters
                    .getPluralRules(locales, { type: el.pluralType })
                    .select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) {
                throw new __WEBPACK_IMPORTED_MODULE_1__error__["b" /* InvalidValueError */](el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ErrorCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormatError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return InvalidValueError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return InvalidValueTypeError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MissingValueError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(183);

var ErrorCode;
(function (ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function () {
        return "[formatjs Error: " + this.code + "] " + this.message;
    };
    return FormatError;
}(Error));

var InvalidValueError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"" + variableId + "\": \"" + value + "\". Options are \"" + Object.keys(options).join('", "') + "\"", "INVALID_VALUE" /* INVALID_VALUE */, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError));

var InvalidValueTypeError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"" + value + "\" must be of type " + type, "INVALID_VALUE" /* INVALID_VALUE */, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError));

var MissingValueError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"" + variableId + "\" was not provided to the string \"" + originalMessage + "\"", "MISSING_VALUE" /* MISSING_VALUE */, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError));



/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatjs_ecma402_abstract__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_messageformat__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_intl_messageformat_parser__ = __webpack_require__(100);





function setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function (all, k) {
        all[k] = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ timeZone: timeZone }, opts[k]);
        return all;
    }, {});
}
function deepMergeOptions(opts1, opts2) {
    var keys = Object.keys(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, opts1), opts2));
    return keys.reduce(function (all, k) {
        all[k] = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (opts1[k] || {})), (opts2[k] || {}));
        return all;
    }, {});
}
function deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) {
        return f1;
    }
    var mfFormats = __WEBPACK_IMPORTED_MODULE_2_intl_messageformat__["b" /* IntlMessageFormat */].formats;
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, mfFormats), f1), { date: deepMergeOptions(setTimeZoneInOptions(mfFormats.date, timeZone), setTimeZoneInOptions(f1.date || {}, timeZone)), time: deepMergeOptions(setTimeZoneInOptions(mfFormats.time, timeZone), setTimeZoneInOptions(f1.time || {}, timeZone)) });
}
function formatMessage(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) { messageDescriptor = { id: '' }; }
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    Object(__WEBPACK_IMPORTED_MODULE_1__formatjs_ecma402_abstract__["a" /* invariant */])(!!msgId, '[@formatjs/intl] An `id` must be provided to format a message.');
    var id = String(msgId);
    var message = 
    // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages &&
        Object.prototype.hasOwnProperty.call(messages, id) &&
        messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) &&
        message.length === 1 &&
        message[0].type === __WEBPACK_IMPORTED_MODULE_4_intl_messageformat_parser__["a" /* TYPE */].literal) {
        return message[0].value;
    }
    // IMPORTANT: Hot path straight lookup for performance
    if (!values &&
        message &&
        typeof message === 'string' &&
        !defaultRichTextElements) {
        return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    }
    values = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, defaultRichTextElements), (values || {}));
    formats = deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (!defaultMessage ||
            (locale && locale.toLowerCase() !== defaultLocale.toLowerCase())) {
            // This prevents warnings from littering the console in development
            // when no `messages` are passed into the <IntlProvider> for the
            // default locale.
            onError(new __WEBPACK_IMPORTED_MODULE_3__error__["e" /* MissingTranslationError */](messageDescriptor, locale));
        }
        if (defaultMessage) {
            try {
                var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
                return formatter.format(values);
            }
            catch (e) {
                onError(new __WEBPACK_IMPORTED_MODULE_3__error__["c" /* MessageFormatError */]("Error formatting default message for: \"" + id + "\", rendering default message verbatim", locale, messageDescriptor, e));
                return typeof defaultMessage === 'string' ? defaultMessage : id;
            }
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ formatters: state }, (opts || {})));
        return formatter.format(values);
    }
    catch (e) {
        onError(new __WEBPACK_IMPORTED_MODULE_3__error__["c" /* MessageFormatError */]("Error formatting message: \"" + id + "\", using " + (defaultMessage ? 'default message' : 'id') + " as fallback.", locale, messageDescriptor, e));
    }
    if (defaultMessage) {
        try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        }
        catch (e) {
            onError(new __WEBPACK_IMPORTED_MODULE_3__error__["c" /* MessageFormatError */]("Error formatting the default message for: \"" + id + "\", rendering message verbatim", locale, messageDescriptor, e));
        }
    }
    if (typeof message === 'string') {
        return message;
    }
    if (typeof defaultMessage === 'string') {
        return defaultMessage;
    }
    return id;
}


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getFormatter */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = formatTime;
/* harmony export (immutable) */ __webpack_exports__["b"] = formatDateTimeRange;
/* harmony export (immutable) */ __webpack_exports__["c"] = formatDateToParts;
/* harmony export (immutable) */ __webpack_exports__["e"] = formatTimeToParts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error__ = __webpack_require__(17);



var DATE_TIME_FORMAT_OPTIONS = [
    'localeMatcher',
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'fractionalSecondDigits',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
];
function getFormatter(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (timeZone && { timeZone: timeZone })), (format && Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* getNamedFormat */])(formats, type, format, onError)));
    var filteredOptions = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* filterProps */])(options, DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' &&
        !filteredOptions.hour &&
        !filteredOptions.minute &&
        !filteredOptions.second &&
        !filteredOptions.timeStyle &&
        !filteredOptions.dateStyle) {
        // Add default formatting options if hour, minute, or second isn't defined.
        filteredOptions = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, filteredOptions), { hour: 'numeric', minute: 'numeric' });
    }
    return getDateTimeFormat(locale, filteredOptions);
}
function formatDate(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return getFormatter(config, 'date', getDateTimeFormat, options).format(date);
    }
    catch (e) {
        config.onError(new __WEBPACK_IMPORTED_MODULE_2__error__["a" /* IntlError */]("FORMAT_ERROR" /* FORMAT_ERROR */, 'Error formatting date.', e));
    }
    return String(date);
}
function formatTime(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return getFormatter(config, 'time', getDateTimeFormat, options).format(date);
    }
    catch (e) {
        config.onError(new __WEBPACK_IMPORTED_MODULE_2__error__["a" /* IntlError */]("FORMAT_ERROR" /* FORMAT_ERROR */, 'Error formatting time.', e));
    }
    return String(date);
}
function formatDateTimeRange(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* filterProps */])(options, DATE_TIME_FORMAT_OPTIONS, timeZone ? { timeZone: timeZone } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    }
    catch (e) {
        onError(new __WEBPACK_IMPORTED_MODULE_2__error__["a" /* IntlError */]("FORMAT_ERROR" /* FORMAT_ERROR */, 'Error formatting date time range.', e));
    }
    return String(from);
}
function formatDateToParts(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return getFormatter(config, 'date', getDateTimeFormat, options).formatToParts(date);
    }
    catch (e) {
        config.onError(new __WEBPACK_IMPORTED_MODULE_2__error__["a" /* IntlError */]("FORMAT_ERROR" /* FORMAT_ERROR */, 'Error formatting date.', e));
    }
    return [];
}
function formatTimeToParts(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return getFormatter(config, 'time', getDateTimeFormat, options).formatToParts(date);
    }
    catch (e) {
        config.onError(new __WEBPACK_IMPORTED_MODULE_2__error__["a" /* IntlError */]("FORMAT_ERROR" /* FORMAT_ERROR */, 'Error formatting time.', e));
    }
    return [];
}


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDisplayName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error__ = __webpack_require__(17);



var DISPLAY_NAMES_OPTONS = [
    'localeMatcher',
    'style',
    'type',
    'fallback',
];
function formatDisplayName(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) {
        onError(new __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__["a" /* FormatError */]("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", "MISSING_INTL_API" /* MISSING_INTL_API */));
    }
    var filteredOptions = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* filterProps */])(options, DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    }
    catch (e) {
        onError(new __WEBPACK_IMPORTED_MODULE_2__error__["a" /* IntlError */]("FORMAT_ERROR" /* FORMAT_ERROR */, 'Error formatting display name.', e));
    }
}


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error__ = __webpack_require__(17);



var LIST_FORMAT_OPTIONS = [
    'localeMatcher',
    'type',
    'style',
];
var now = Date.now();
function generateToken(i) {
    return now + "_" + i + "_" + now;
}
function formatList(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) {
        onError(new __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__["a" /* FormatError */]("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", "MISSING_INTL_API" /* MISSING_INTL_API */));
    }
    var filteredOptions = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* filterProps */])(options, LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function (v, i) {
            if (typeof v === 'object') {
                var id = generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        if (!Object.keys(richValues_1).length) {
            return getListFormat(locale, filteredOptions).format(serializedValues);
        }
        var parts = getListFormat(locale, filteredOptions).formatToParts(serializedValues);
        return parts.reduce(function (all, el) {
            var val = el.value;
            if (richValues_1[val]) {
                all.push(richValues_1[val]);
            }
            else if (typeof all[all.length - 1] === 'string') {
                all[all.length - 1] += val;
            }
            else {
                all.push(val);
            }
            return all;
        }, []);
    }
    catch (e) {
        onError(new __WEBPACK_IMPORTED_MODULE_2__error__["a" /* IntlError */]("FORMAT_ERROR" /* FORMAT_ERROR */, 'Error formatting list.', e));
    }
    // @ts-ignore
    return values;
}


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPlural;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_messageformat__ = __webpack_require__(29);



var PLURAL_FORMAT_OPTIONS = [
    'localeMatcher',
    'type',
];
function formatPlural(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) { options = {}; }
    if (!Intl.PluralRules) {
        onError(new __WEBPACK_IMPORTED_MODULE_2_intl_messageformat__["a" /* FormatError */]("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", "MISSING_INTL_API" /* MISSING_INTL_API */));
    }
    var filteredOptions = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* filterProps */])(options, PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    }
    catch (e) {
        onError(new __WEBPACK_IMPORTED_MODULE_1__error__["c" /* MessageFormatError */]('Error formatting plural.', e));
    }
    return 'other';
}


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatRelativeTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error__ = __webpack_require__(17);



var RELATIVE_TIME_FORMAT_OPTIONS = ['numeric', 'style'];
function getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = (!!format && Object(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* getNamedFormat */])(formats, 'relative', format, onError)) || {};
    var filteredOptions = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* filterProps */])(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) { options = {}; }
    if (!unit) {
        unit = 'second';
    }
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) {
        config.onError(new __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__["a" /* FormatError */]("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", "MISSING_INTL_API" /* MISSING_INTL_API */));
    }
    try {
        return getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    }
    catch (e) {
        config.onError(new __WEBPACK_IMPORTED_MODULE_2__error__["c" /* MessageFormatError */]('Error formatting relative time.', e));
    }
    return String(value);
}


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getFormatter */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatNumber;
/* harmony export (immutable) */ __webpack_exports__["b"] = formatNumberToParts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(17);


var NUMBER_FORMAT_OPTIONS = [
    'localeMatcher',
    'style',
    'currency',
    'currencyDisplay',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
];
function getFormatter(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = ((format &&
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* getNamedFormat */])(formats, 'number', format, onError)) ||
        {});
    var filteredOptions = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* filterProps */])(options, NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function formatNumber(config, getNumberFormat, value, options) {
    if (options === void 0) { options = {}; }
    try {
        return getFormatter(config, getNumberFormat, options).format(value);
    }
    catch (e) {
        config.onError(new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* IntlError */]("FORMAT_ERROR" /* FORMAT_ERROR */, 'Error formatting number.', e));
    }
    return String(value);
}
function formatNumberToParts(config, getNumberFormat, value, options) {
    if (options === void 0) { options = {}; }
    try {
        return getFormatter(config, getNumberFormat, options).formatToParts(value);
    }
    catch (e) {
        config.onError(new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* IntlError */]("FORMAT_ERROR" /* FORMAT_ERROR */, 'Error formatting number.', e));
    }
    return [];
}


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function shallowEqualObjects(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if (!objA || !objB) {
    return false;
  }

  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);
  var len = aKeys.length;

  if (bKeys.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqualObjects;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);
var settle = __webpack_require__(387);
var buildURL = __webpack_require__(389);
var parseHeaders = __webpack_require__(390);
var isURLSameOrigin = __webpack_require__(391);
var createError = __webpack_require__(197);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(392);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(388);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(410);
var bytesToUuid = __webpack_require__(411);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports = {"TEXT":{"limit":{"lineHeight":{"min":0.8,"max":2.5,"default":1.16}}},"PPT":{"importLimit":{"assetPerSlide":50,"slidePerProject":50}},"PROJECT_TITLE":{"maxLength":50},"SWAP_TARGETS":{"FRAME_CLIP":"frame-clip","GRID_CELL":"grid-cell","WORKSPACE":"workspace","NONE":null},"SWAP_SOURCE":{"LIBRARY":"library","WORKSPACE":"workspace","NONE":null},"FRAME":{"DROP_OPACITY":0.5},"GRID":{"DROP_OPACITY":0},"IMAGE":{"DEFAULT_FILTER":"6464646464640032"}}

/***/ }),
/* 202 */
/***/ (function(module, exports) {

/**
 * Parses an URI
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */

var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;

var parts = [
    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
];

module.exports = function parseuri(str) {
    var src = str,
        b = str.indexOf('['),
        e = str.indexOf(']');

    if (b != -1 && e != -1) {
        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    }

    var m = re.exec(str || ''),
        uri = {},
        i = 14;

    while (i--) {
        uri[parts[i]] = m[i] || '';
    }

    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }

    return uri;
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
module.exports = isBuf;

/**
 * Returns true if obj is a buffer or an arraybuffer.
 *
 * @api private
 */

function isBuf(obj) {
  return (global.Buffer && global.Buffer.isBuffer(obj)) ||
         (global.ArrayBuffer && obj instanceof ArrayBuffer);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var eio = __webpack_require__(454);
var Socket = __webpack_require__(209);
var Emitter = __webpack_require__(210);
var parser = __webpack_require__(108);
var on = __webpack_require__(211);
var bind = __webpack_require__(212);
var debug = __webpack_require__(60)('socket.io-client:manager');
var indexOf = __webpack_require__(208);
var Backoff = __webpack_require__(476);

/**
 * IE6+ hasOwnProperty
 */

var has = Object.prototype.hasOwnProperty;

/**
 * Module exports
 */

module.exports = Manager;

/**
 * `Manager` constructor.
 *
 * @param {String} engine instance or engine uri/opts
 * @param {Object} options
 * @api public
 */

function Manager (uri, opts) {
  if (!(this instanceof Manager)) return new Manager(uri, opts);
  if (uri && ('object' === typeof uri)) {
    opts = uri;
    uri = undefined;
  }
  opts = opts || {};

  opts.path = opts.path || '/socket.io';
  this.nsps = {};
  this.subs = [];
  this.opts = opts;
  this.reconnection(opts.reconnection !== false);
  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
  this.reconnectionDelay(opts.reconnectionDelay || 1000);
  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
  this.randomizationFactor(opts.randomizationFactor || 0.5);
  this.backoff = new Backoff({
    min: this.reconnectionDelay(),
    max: this.reconnectionDelayMax(),
    jitter: this.randomizationFactor()
  });
  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
  this.readyState = 'closed';
  this.uri = uri;
  this.connecting = [];
  this.lastPing = null;
  this.encoding = false;
  this.packetBuffer = [];
  this.encoder = new parser.Encoder();
  this.decoder = new parser.Decoder();
  this.autoConnect = opts.autoConnect !== false;
  if (this.autoConnect) this.open();
}

/**
 * Propagate given event to sockets and emit on `this`
 *
 * @api private
 */

Manager.prototype.emitAll = function () {
  this.emit.apply(this, arguments);
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
    }
  }
};

/**
 * Update `socket.id` of all sockets
 *
 * @api private
 */

Manager.prototype.updateSocketIds = function () {
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].id = this.engine.id;
    }
  }
};

/**
 * Mix in `Emitter`.
 */

Emitter(Manager.prototype);

/**
 * Sets the `reconnection` config.
 *
 * @param {Boolean} true/false if it should automatically reconnect
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnection = function (v) {
  if (!arguments.length) return this._reconnection;
  this._reconnection = !!v;
  return this;
};

/**
 * Sets the reconnection attempts config.
 *
 * @param {Number} max reconnection attempts before giving up
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionAttempts = function (v) {
  if (!arguments.length) return this._reconnectionAttempts;
  this._reconnectionAttempts = v;
  return this;
};

/**
 * Sets the delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelay = function (v) {
  if (!arguments.length) return this._reconnectionDelay;
  this._reconnectionDelay = v;
  this.backoff && this.backoff.setMin(v);
  return this;
};

Manager.prototype.randomizationFactor = function (v) {
  if (!arguments.length) return this._randomizationFactor;
  this._randomizationFactor = v;
  this.backoff && this.backoff.setJitter(v);
  return this;
};

/**
 * Sets the maximum delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelayMax = function (v) {
  if (!arguments.length) return this._reconnectionDelayMax;
  this._reconnectionDelayMax = v;
  this.backoff && this.backoff.setMax(v);
  return this;
};

/**
 * Sets the connection timeout. `false` to disable
 *
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.timeout = function (v) {
  if (!arguments.length) return this._timeout;
  this._timeout = v;
  return this;
};

/**
 * Starts trying to reconnect if reconnection is enabled and we have not
 * started reconnecting yet
 *
 * @api private
 */

Manager.prototype.maybeReconnectOnOpen = function () {
  // Only try to reconnect if it's the first time we're connecting
  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
    // keeps reconnection from firing twice for the same reconnection loop
    this.reconnect();
  }
};

/**
 * Sets the current transport `socket`.
 *
 * @param {Function} optional, callback
 * @return {Manager} self
 * @api public
 */

Manager.prototype.open =
Manager.prototype.connect = function (fn, opts) {
  debug('readyState %s', this.readyState);
  if (~this.readyState.indexOf('open')) return this;

  debug('opening %s', this.uri);
  this.engine = eio(this.uri, this.opts);
  var socket = this.engine;
  var self = this;
  this.readyState = 'opening';
  this.skipReconnect = false;

  // emit `open`
  var openSub = on(socket, 'open', function () {
    self.onopen();
    fn && fn();
  });

  // emit `connect_error`
  var errorSub = on(socket, 'error', function (data) {
    debug('connect_error');
    self.cleanup();
    self.readyState = 'closed';
    self.emitAll('connect_error', data);
    if (fn) {
      var err = new Error('Connection error');
      err.data = data;
      fn(err);
    } else {
      // Only do this if there is no fn to handle the error
      self.maybeReconnectOnOpen();
    }
  });

  // emit `connect_timeout`
  if (false !== this._timeout) {
    var timeout = this._timeout;
    debug('connect attempt will timeout after %d', timeout);

    // set timer
    var timer = setTimeout(function () {
      debug('connect attempt timed out after %d', timeout);
      openSub.destroy();
      socket.close();
      socket.emit('error', 'timeout');
      self.emitAll('connect_timeout', timeout);
    }, timeout);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }

  this.subs.push(openSub);
  this.subs.push(errorSub);

  return this;
};

/**
 * Called upon transport open.
 *
 * @api private
 */

Manager.prototype.onopen = function () {
  debug('open');

  // clear old subs
  this.cleanup();

  // mark as open
  this.readyState = 'open';
  this.emit('open');

  // add new subs
  var socket = this.engine;
  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
};

/**
 * Called upon a ping.
 *
 * @api private
 */

Manager.prototype.onping = function () {
  this.lastPing = new Date();
  this.emitAll('ping');
};

/**
 * Called upon a packet.
 *
 * @api private
 */

Manager.prototype.onpong = function () {
  this.emitAll('pong', new Date() - this.lastPing);
};

/**
 * Called with data.
 *
 * @api private
 */

Manager.prototype.ondata = function (data) {
  this.decoder.add(data);
};

/**
 * Called when parser fully decodes a packet.
 *
 * @api private
 */

Manager.prototype.ondecoded = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon socket error.
 *
 * @api private
 */

Manager.prototype.onerror = function (err) {
  debug('error', err);
  this.emitAll('error', err);
};

/**
 * Creates a new socket for the given `nsp`.
 *
 * @return {Socket}
 * @api public
 */

Manager.prototype.socket = function (nsp, opts) {
  var socket = this.nsps[nsp];
  if (!socket) {
    socket = new Socket(this, nsp, opts);
    this.nsps[nsp] = socket;
    var self = this;
    socket.on('connecting', onConnecting);
    socket.on('connect', function () {
      socket.id = self.engine.id;
    });

    if (this.autoConnect) {
      // manually call here since connecting evnet is fired before listening
      onConnecting();
    }
  }

  function onConnecting () {
    if (!~indexOf(self.connecting, socket)) {
      self.connecting.push(socket);
    }
  }

  return socket;
};

/**
 * Called upon a socket close.
 *
 * @param {Socket} socket
 */

Manager.prototype.destroy = function (socket) {
  var index = indexOf(this.connecting, socket);
  if (~index) this.connecting.splice(index, 1);
  if (this.connecting.length) return;

  this.close();
};

/**
 * Writes a packet.
 *
 * @param {Object} packet
 * @api private
 */

Manager.prototype.packet = function (packet) {
  debug('writing packet %j', packet);
  var self = this;
  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;

  if (!self.encoding) {
    // encode, then write to engine with result
    self.encoding = true;
    this.encoder.encode(packet, function (encodedPackets) {
      for (var i = 0; i < encodedPackets.length; i++) {
        self.engine.write(encodedPackets[i], packet.options);
      }
      self.encoding = false;
      self.processPacketQueue();
    });
  } else { // add packet to the queue
    self.packetBuffer.push(packet);
  }
};

/**
 * If packet buffer is non-empty, begins encoding the
 * next packet in line.
 *
 * @api private
 */

Manager.prototype.processPacketQueue = function () {
  if (this.packetBuffer.length > 0 && !this.encoding) {
    var pack = this.packetBuffer.shift();
    this.packet(pack);
  }
};

/**
 * Clean up transport subscriptions and packet buffer.
 *
 * @api private
 */

Manager.prototype.cleanup = function () {
  debug('cleanup');

  var subsLength = this.subs.length;
  for (var i = 0; i < subsLength; i++) {
    var sub = this.subs.shift();
    sub.destroy();
  }

  this.packetBuffer = [];
  this.encoding = false;
  this.lastPing = null;

  this.decoder.destroy();
};

/**
 * Close the current socket.
 *
 * @api private
 */

Manager.prototype.close =
Manager.prototype.disconnect = function () {
  debug('disconnect');
  this.skipReconnect = true;
  this.reconnecting = false;
  if ('opening' === this.readyState) {
    // `onclose` will not fire because
    // an open event never happened
    this.cleanup();
  }
  this.backoff.reset();
  this.readyState = 'closed';
  if (this.engine) this.engine.close();
};

/**
 * Called upon engine close.
 *
 * @api private
 */

Manager.prototype.onclose = function (reason) {
  debug('onclose');

  this.cleanup();
  this.backoff.reset();
  this.readyState = 'closed';
  this.emit('close', reason);

  if (this._reconnection && !this.skipReconnect) {
    this.reconnect();
  }
};

/**
 * Attempt a reconnection.
 *
 * @api private
 */

Manager.prototype.reconnect = function () {
  if (this.reconnecting || this.skipReconnect) return this;

  var self = this;

  if (this.backoff.attempts >= this._reconnectionAttempts) {
    debug('reconnect failed');
    this.backoff.reset();
    this.emitAll('reconnect_failed');
    this.reconnecting = false;
  } else {
    var delay = this.backoff.duration();
    debug('will wait %dms before reconnect attempt', delay);

    this.reconnecting = true;
    var timer = setTimeout(function () {
      if (self.skipReconnect) return;

      debug('attempting reconnect');
      self.emitAll('reconnect_attempt', self.backoff.attempts);
      self.emitAll('reconnecting', self.backoff.attempts);

      // check again for the case socket closed in above events
      if (self.skipReconnect) return;

      self.open(function (err) {
        if (err) {
          debug('reconnect attempt error');
          self.reconnecting = false;
          self.reconnect();
          self.emitAll('reconnect_error', err.data);
        } else {
          debug('reconnect success');
          self.onreconnect();
        }
      });
    }, delay);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }
};

/**
 * Called upon successful reconnect.
 *
 * @api private
 */

Manager.prototype.onreconnect = function () {
  var attempt = this.backoff.attempts;
  this.reconnecting = false;
  this.backoff.reset();
  this.updateSocketIds();
  this.emitAll('reconnect', attempt);
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module dependencies
 */

var XMLHttpRequest = __webpack_require__(109);
var XHR = __webpack_require__(458);
var JSONP = __webpack_require__(469);
var websocket = __webpack_require__(470);

/**
 * Export transports.
 */

exports.polling = polling;
exports.websocket = websocket;

/**
 * Polling transport polymorphic constructor.
 * Decides on xhr vs jsonp based on feature detection.
 *
 * @api private
 */

function polling (opts) {
  var xhr;
  var xd = false;
  var xs = false;
  var jsonp = false !== opts.jsonp;

  if (global.location) {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    xd = opts.hostname !== location.hostname || port !== opts.port;
    xs = opts.secure !== isSSL;
  }

  opts.xdomain = xd;
  opts.xscheme = xs;
  xhr = new XMLHttpRequest(opts);

  if ('open' in xhr && !opts.forceJSONP) {
    return new XHR(opts);
  } else {
    if (!jsonp) throw new Error('JSONP disabled');
    return new JSONP(opts);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var Transport = __webpack_require__(110);
var parseqs = __webpack_require__(112);
var parser = __webpack_require__(34);
var inherit = __webpack_require__(61);
var yeast = __webpack_require__(207);
var debug = __webpack_require__(62)('engine.io-client:polling');

/**
 * Module exports.
 */

module.exports = Polling;

/**
 * Is XHR2 supported?
 */

var hasXHR2 = (function () {
  var XMLHttpRequest = __webpack_require__(109);
  var xhr = new XMLHttpRequest({ xdomain: false });
  return null != xhr.responseType;
})();

/**
 * Polling interface.
 *
 * @param {Object} opts
 * @api private
 */

function Polling (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (!hasXHR2 || forceBase64) {
    this.supportsBinary = false;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(Polling, Transport);

/**
 * Transport name.
 */

Polling.prototype.name = 'polling';

/**
 * Opens the socket (triggers polling). We write a PING message to determine
 * when the transport is open.
 *
 * @api private
 */

Polling.prototype.doOpen = function () {
  this.poll();
};

/**
 * Pauses polling.
 *
 * @param {Function} callback upon buffers are flushed and transport is paused
 * @api private
 */

Polling.prototype.pause = function (onPause) {
  var self = this;

  this.readyState = 'pausing';

  function pause () {
    debug('paused');
    self.readyState = 'paused';
    onPause();
  }

  if (this.polling || !this.writable) {
    var total = 0;

    if (this.polling) {
      debug('we are currently polling - waiting to pause');
      total++;
      this.once('pollComplete', function () {
        debug('pre-pause polling complete');
        --total || pause();
      });
    }

    if (!this.writable) {
      debug('we are currently writing - waiting to pause');
      total++;
      this.once('drain', function () {
        debug('pre-pause writing complete');
        --total || pause();
      });
    }
  } else {
    pause();
  }
};

/**
 * Starts polling cycle.
 *
 * @api public
 */

Polling.prototype.poll = function () {
  debug('polling');
  this.polling = true;
  this.doPoll();
  this.emit('poll');
};

/**
 * Overloads onData to detect payloads.
 *
 * @api private
 */

Polling.prototype.onData = function (data) {
  var self = this;
  debug('polling got data %s', data);
  var callback = function (packet, index, total) {
    // if its the first message we consider the transport open
    if ('opening' === self.readyState) {
      self.onOpen();
    }

    // if its a close packet, we close the ongoing requests
    if ('close' === packet.type) {
      self.onClose();
      return false;
    }

    // otherwise bypass onData and handle the message
    self.onPacket(packet);
  };

  // decode payload
  parser.decodePayload(data, this.socket.binaryType, callback);

  // if an event did not trigger closing
  if ('closed' !== this.readyState) {
    // if we got data we're not polling
    this.polling = false;
    this.emit('pollComplete');

    if ('open' === this.readyState) {
      this.poll();
    } else {
      debug('ignoring poll - transport state "%s"', this.readyState);
    }
  }
};

/**
 * For polling, send a close packet.
 *
 * @api private
 */

Polling.prototype.doClose = function () {
  var self = this;

  function close () {
    debug('writing close packet');
    self.write([{ type: 'close' }]);
  }

  if ('open' === this.readyState) {
    debug('transport open - closing');
    close();
  } else {
    // in case we're trying to close while
    // handshaking is in progress (GH-164)
    debug('transport not open - deferring close');
    this.once('open', close);
  }
};

/**
 * Writes a packets payload.
 *
 * @param {Array} data packets
 * @param {Function} drain callback
 * @api private
 */

Polling.prototype.write = function (packets) {
  var self = this;
  this.writable = false;
  var callbackfn = function () {
    self.writable = true;
    self.emit('drain');
  };

  parser.encodePayload(packets, this.supportsBinary, function (data) {
    self.doWrite(data, callbackfn);
  });
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

Polling.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'https' : 'http';
  var port = '';

  // cache busting is forced
  if (false !== this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  if (!this.supportsBinary && !query.sid) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // avoid port if default for schema
  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
     ('http' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
  , length = 64
  , map = {}
  , seed = 0
  , i = 0
  , prev;

/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */
function encode(num) {
  var encoded = '';

  do {
    encoded = alphabet[num % length] + encoded;
    num = Math.floor(num / length);
  } while (num > 0);

  return encoded;
}

/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */
function decode(str) {
  var decoded = 0;

  for (i = 0; i < str.length; i++) {
    decoded = decoded * length + map[str.charAt(i)];
  }

  return decoded;
}

/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */
function yeast() {
  var now = encode(+new Date());

  if (now !== prev) return seed = 0, prev = now;
  return now +'.'+ encode(seed++);
}

//
// Map each character to its index.
//
for (; i < length; i++) map[alphabet[i]] = i;

//
// Expose the `yeast`, `encode` and `decode` functions.
//
yeast.encode = encode;
yeast.decode = decode;
module.exports = yeast;


/***/ }),
/* 208 */
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var parser = __webpack_require__(108);
var Emitter = __webpack_require__(210);
var toArray = __webpack_require__(473);
var on = __webpack_require__(211);
var bind = __webpack_require__(212);
var debug = __webpack_require__(60)('socket.io-client:socket');
var hasBin = __webpack_require__(474);

/**
 * Module exports.
 */

module.exports = exports = Socket;

/**
 * Internal events (blacklisted).
 * These events can't be emitted by the user.
 *
 * @api private
 */

var events = {
  connect: 1,
  connect_error: 1,
  connect_timeout: 1,
  connecting: 1,
  disconnect: 1,
  error: 1,
  reconnect: 1,
  reconnect_attempt: 1,
  reconnect_failed: 1,
  reconnect_error: 1,
  reconnecting: 1,
  ping: 1,
  pong: 1
};

/**
 * Shortcut to `Emitter#emit`.
 */

var emit = Emitter.prototype.emit;

/**
 * `Socket` constructor.
 *
 * @api public
 */

function Socket (io, nsp, opts) {
  this.io = io;
  this.nsp = nsp;
  this.json = this; // compat
  this.ids = 0;
  this.acks = {};
  this.receiveBuffer = [];
  this.sendBuffer = [];
  this.connected = false;
  this.disconnected = true;
  if (opts && opts.query) {
    this.query = opts.query;
  }
  if (this.io.autoConnect) this.open();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Subscribe to open, close and packet events
 *
 * @api private
 */

Socket.prototype.subEvents = function () {
  if (this.subs) return;

  var io = this.io;
  this.subs = [
    on(io, 'open', bind(this, 'onopen')),
    on(io, 'packet', bind(this, 'onpacket')),
    on(io, 'close', bind(this, 'onclose'))
  ];
};

/**
 * "Opens" the socket.
 *
 * @api public
 */

Socket.prototype.open =
Socket.prototype.connect = function () {
  if (this.connected) return this;

  this.subEvents();
  this.io.open(); // ensure open
  if ('open' === this.io.readyState) this.onopen();
  this.emit('connecting');
  return this;
};

/**
 * Sends a `message` event.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.send = function () {
  var args = toArray(arguments);
  args.unshift('message');
  this.emit.apply(this, args);
  return this;
};

/**
 * Override `emit`.
 * If the event is in `events`, it's emitted normally.
 *
 * @param {String} event name
 * @return {Socket} self
 * @api public
 */

Socket.prototype.emit = function (ev) {
  if (events.hasOwnProperty(ev)) {
    emit.apply(this, arguments);
    return this;
  }

  var args = toArray(arguments);
  var parserType = parser.EVENT; // default
  if (hasBin(args)) { parserType = parser.BINARY_EVENT; } // binary
  var packet = { type: parserType, data: args };

  packet.options = {};
  packet.options.compress = !this.flags || false !== this.flags.compress;

  // event ack callback
  if ('function' === typeof args[args.length - 1]) {
    debug('emitting packet with ack id %d', this.ids);
    this.acks[this.ids] = args.pop();
    packet.id = this.ids++;
  }

  if (this.connected) {
    this.packet(packet);
  } else {
    this.sendBuffer.push(packet);
  }

  delete this.flags;

  return this;
};

/**
 * Sends a packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.packet = function (packet) {
  packet.nsp = this.nsp;
  this.io.packet(packet);
};

/**
 * Called upon engine `open`.
 *
 * @api private
 */

Socket.prototype.onopen = function () {
  debug('transport is open - connecting');

  // write connect packet if necessary
  if ('/' !== this.nsp) {
    if (this.query) {
      this.packet({type: parser.CONNECT, query: this.query});
    } else {
      this.packet({type: parser.CONNECT});
    }
  }
};

/**
 * Called upon engine `close`.
 *
 * @param {String} reason
 * @api private
 */

Socket.prototype.onclose = function (reason) {
  debug('close (%s)', reason);
  this.connected = false;
  this.disconnected = true;
  delete this.id;
  this.emit('disconnect', reason);
};

/**
 * Called with socket packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onpacket = function (packet) {
  if (packet.nsp !== this.nsp) return;

  switch (packet.type) {
    case parser.CONNECT:
      this.onconnect();
      break;

    case parser.EVENT:
      this.onevent(packet);
      break;

    case parser.BINARY_EVENT:
      this.onevent(packet);
      break;

    case parser.ACK:
      this.onack(packet);
      break;

    case parser.BINARY_ACK:
      this.onack(packet);
      break;

    case parser.DISCONNECT:
      this.ondisconnect();
      break;

    case parser.ERROR:
      this.emit('error', packet.data);
      break;
  }
};

/**
 * Called upon a server event.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onevent = function (packet) {
  var args = packet.data || [];
  debug('emitting event %j', args);

  if (null != packet.id) {
    debug('attaching ack callback to event');
    args.push(this.ack(packet.id));
  }

  if (this.connected) {
    emit.apply(this, args);
  } else {
    this.receiveBuffer.push(args);
  }
};

/**
 * Produces an ack callback to emit with an event.
 *
 * @api private
 */

Socket.prototype.ack = function (id) {
  var self = this;
  var sent = false;
  return function () {
    // prevent double callbacks
    if (sent) return;
    sent = true;
    var args = toArray(arguments);
    debug('sending ack %j', args);

    var type = hasBin(args) ? parser.BINARY_ACK : parser.ACK;
    self.packet({
      type: type,
      id: id,
      data: args
    });
  };
};

/**
 * Called upon a server acknowlegement.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onack = function (packet) {
  var ack = this.acks[packet.id];
  if ('function' === typeof ack) {
    debug('calling ack %s with %j', packet.id, packet.data);
    ack.apply(this, packet.data);
    delete this.acks[packet.id];
  } else {
    debug('bad ack %s', packet.id);
  }
};

/**
 * Called upon server connect.
 *
 * @api private
 */

Socket.prototype.onconnect = function () {
  this.connected = true;
  this.disconnected = false;
  this.emit('connect');
  this.emitBuffered();
};

/**
 * Emit buffered events (received and emitted).
 *
 * @api private
 */

Socket.prototype.emitBuffered = function () {
  var i;
  for (i = 0; i < this.receiveBuffer.length; i++) {
    emit.apply(this, this.receiveBuffer[i]);
  }
  this.receiveBuffer = [];

  for (i = 0; i < this.sendBuffer.length; i++) {
    this.packet(this.sendBuffer[i]);
  }
  this.sendBuffer = [];
};

/**
 * Called upon server disconnect.
 *
 * @api private
 */

Socket.prototype.ondisconnect = function () {
  debug('server disconnect (%s)', this.nsp);
  this.destroy();
  this.onclose('io server disconnect');
};

/**
 * Called upon forced client/server side disconnections,
 * this method ensures the manager stops tracking us and
 * that reconnections don't get triggered for this.
 *
 * @api private.
 */

Socket.prototype.destroy = function () {
  if (this.subs) {
    // clean subscriptions to avoid reconnections
    for (var i = 0; i < this.subs.length; i++) {
      this.subs[i].destroy();
    }
    this.subs = null;
  }

  this.io.destroy(this);
};

/**
 * Disconnects the socket manually.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.close =
Socket.prototype.disconnect = function () {
  if (this.connected) {
    debug('performing disconnect (%s)', this.nsp);
    this.packet({ type: parser.DISCONNECT });
  }

  // remove socket from pool
  this.destroy();

  if (this.connected) {
    // fire events
    this.onclose('io client disconnect');
  }
  return this;
};

/**
 * Sets the compress flag.
 *
 * @param {Boolean} if `true`, compresses the sending data
 * @return {Socket} self
 * @api public
 */

Socket.prototype.compress = function (compress) {
  this.flags = this.flags || {};
  this.flags.compress = compress;
  return this;
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 211 */
/***/ (function(module, exports) {


/**
 * Module exports.
 */

module.exports = on;

/**
 * Helper for subscriptions.
 *
 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
 * @param {String} event name
 * @param {Function} callback
 * @api public
 */

function on (obj, ev, fn) {
  obj.on(ev, fn);
  return {
    destroy: function () {
      obj.removeListener(ev, fn);
    }
  };
}


/***/ }),
/* 212 */
/***/ (function(module, exports) {

/**
 * Slice reference.
 */

var slice = [].slice;

/**
 * Bind `obj` to `fn`.
 *
 * @param {Object} obj
 * @param {Function|String} fn or string
 * @return {Function}
 * @api public
 */

module.exports = function(obj, fn){
  if ('string' == typeof fn) fn = obj[fn];
  if ('function' != typeof fn) throw new Error('bind() requires a function');
  var args = slice.call(arguments, 2);
  return function(){
    return fn.apply(obj, args.concat(slice.call(arguments)));
  }
};


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* harmony export (immutable) */ __webpack_exports__["c"] = suspend;
/* harmony export (immutable) */ __webpack_exports__["b"] = flush;
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/
var semaphore = 0;

/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/
function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}

/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/
function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}

/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/
function suspend() {
  semaphore++;
}

/**
  Puts the scheduler in a `released` state.
**/
function release() {
  semaphore--;
}

/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/
function flush() {
  release();

  var task = void 0;
  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__proc__ = __webpack_require__(215);



var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';

function runSaga(storeInterface, saga) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator = void 0;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(storeInterface)) {
    if (false) {
      log('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
    }
    iterator = storeInterface;
    storeInterface = saga;
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(saga, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, NON_GENERATOR_ERR);
    iterator = saga.apply(undefined, args);
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NON_GENERATOR_ERR);
  }

  var _storeInterface = storeInterface,
      subscribe = _storeInterface.subscribe,
      dispatch = _storeInterface.dispatch,
      getState = _storeInterface.getState,
      context = _storeInterface.context,
      sagaMonitor = _storeInterface.sagaMonitor,
      logger = _storeInterface.logger,
      onError = _storeInterface.onError;


  var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
  }

  var task = Object(__WEBPACK_IMPORTED_MODULE_1__proc__["a" /* default */])(iterator, subscribe, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["x" /* wrapSagaDispatch */])(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NOT_ITERATOR_ERROR */
/* unused harmony export CHANNEL_END */
/* unused harmony export TASK_CANCEL */
/* harmony export (immutable) */ __webpack_exports__["a"] = proc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__io__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buffers__ = __webpack_require__(63);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }







var NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */];
  },
  default: function _default(pattern) {
    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
      return input.type === pattern;
    } : function (input) {
      return input.type === String(pattern);
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return matcher(p)(input);
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  // prettier-ignore
  return (pattern === '*' ? matchers.wildcard : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(pattern) ? matchers.array : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].stringableFunc(pattern) ? matchers.default : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(tasks, task);
      task.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    throw error;
  }) : Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

var wrapHelper = function wrapHelper(helper) {
  return { fn: helper };
};

function proc(iterator) {
  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  };
  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
  var cont = arguments[8];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NOT_ITERATOR_ERROR);

  var effectsString = '[...effects]';
  var runParallelEffect = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(runAllEffect, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])(effectsString, 'all(' + effectsString + ')'));

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;

  var log = logger || __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* log */];
  var logError = function logError(err) {
    var message = err.sagaStack;

    if (!message && err.stack) {
      message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
    }

    log('error', 'uncaught at ' + name, message || err.message || err);
  };
  var stdChannel = Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* stdChannel */])(subscribe);
  var taskContext = Object.create(parentContext);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        logError(error);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        Object.defineProperty(result, 'sagaStack', {
          value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
          configurable: true
        });
      }
      if (!task.cont) {
        if (result instanceof Error && onError) {
          onError(result);
        } else {
          logError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }
      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        logError(err);
      }
      currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      for completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    // prettier-ignore
    return (
      // Non declarative effect
      __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(effect) ? resolvePromise(effect, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].take(effect)) ? runTakeEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].put(effect)) ? runPutEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].all(effect)) ? runAllEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].call(effect)) ? runCallEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cps(effect)) ? runCPSEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].join(effect)) ? runJoinEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cancel(effect)) ? runCancelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].select(effect)) ? runSelectEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].flush(effect)) ? runFlushEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].getContext(effect)) ? runGetContextEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* CANCEL */]];
    if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(cancelPromise)) {
      cb.cancel = cancelPromise;
    } else if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(promise.abort)) {
      cb.cancel = function () {
        return promise.abort();
      };
      // TODO: add support for the fetch API, whenever they get around to
      // adding cancel support
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
        pattern = _ref2.pattern,
        maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
        action = _ref3.action,
        resolve = _ref3.resolve;

    /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/
    Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["a" /* asap */])(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        logError(error);
      }

      if (resolve && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
        fn = _ref4.fn,
        args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result) ? resolvePromise(result, cb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
        fn = _ref5.fn,
        args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
        fn = _ref6.fn,
        args = _ref6.args,
        detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["c" /* suspend */])();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["b" /* flush */])();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = Object.keys(effects);

    if (!keys.length) {
      return cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [] : {});
    }

    var completedCount = 0;
    var completed = void 0;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* array */].from(_extends({}, results, { length: keys.length })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _response;

          cb.cancel();
          completed = true;
          var response = (_response = {}, _response[key] = res, _response);
          cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [].slice.call(_extends({}, response, { length: keys.length })) : response);
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
        args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
        buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb(Object(__WEBPACK_IMPORTED_MODULE_3__channel__["c" /* eventChannel */])(subscribe, buffer || __WEBPACK_IMPORTED_MODULE_4__buffers__["a" /* buffers */].fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* TASK */]] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* deferred */])();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('task', props));
      __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export takeEvery */
/* unused harmony export takeLatest */
/* unused harmony export throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__takeEvery__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takeLatest__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__throttle__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(14);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__takeEvery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__takeLatest__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__throttle__["a"]; });






var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};

var takeEvery = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_0__takeEvery__["a" /* default */], /*#__PURE__*/deprecationWarning('takeEvery'));
var takeLatest = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_1__takeLatest__["a" /* default */], /*#__PURE__*/deprecationWarning('takeLatest'));
var throttle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_2__throttle__["a" /* default */], /*#__PURE__*/deprecationWarning('throttle'));



/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_io__ = __webpack_require__(23);
/* unused harmony reexport take */
/* unused harmony reexport takem */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["b"]; });
/* unused harmony reexport race */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["d"]; });
/* unused harmony reexport apply */
/* unused harmony reexport cps */
/* unused harmony reexport fork */
/* unused harmony reexport spawn */
/* unused harmony reexport join */
/* unused harmony reexport cancel */
/* unused harmony reexport select */
/* unused harmony reexport actionChannel */
/* unused harmony reexport cancelled */
/* unused harmony reexport flush */
/* unused harmony reexport getContext */
/* unused harmony reexport setContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__ = __webpack_require__(485);
/* unused harmony reexport takeEvery */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["a"]; });
/* unused harmony reexport throttle */




/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actions = exports.undoHistoryReducerCreator = exports.undoHistoryReducer = exports.createUndoMiddleware = undefined;

var _reducer = __webpack_require__(488);

Object.defineProperty(exports, 'undoHistoryReducerCreator', {
  enumerable: true,
  get: function get() {
    return _reducer.undoHistoryReducerCreator;
  }
});

var _createUndoMiddleware2 = __webpack_require__(574);

var _createUndoMiddleware3 = _interopRequireDefault(_createUndoMiddleware2);

var _reducer2 = _interopRequireDefault(_reducer);

var _actions2 = __webpack_require__(239);

var _actions = _interopRequireWildcard(_actions2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createUndoMiddleware = _createUndoMiddleware3.default;
exports.undoHistoryReducer = _reducer2.default;
exports.actions = _actions;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(491),
    baseMatchesProperty = __webpack_require__(548),
    identity = __webpack_require__(557),
    isArray = __webpack_require__(20),
    property = __webpack_require__(558);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(64),
    stackClear = __webpack_require__(498),
    stackDelete = __webpack_require__(499),
    stackGet = __webpack_require__(500),
    stackHas = __webpack_require__(501),
    stackSet = __webpack_require__(502);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    isObject = __webpack_require__(37);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 223 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(521),
    isObjectLike = __webpack_require__(38);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(522),
    arraySome = __webpack_require__(525),
    cacheHas = __webpack_require__(526);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(227),
    isArray = __webpack_require__(20);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 227 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(533),
    stubArray = __webpack_require__(229);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 229 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(534),
    isArguments = __webpack_require__(231),
    isArray = __webpack_require__(20),
    isBuffer = __webpack_require__(232),
    isIndex = __webpack_require__(118),
    isTypedArray = __webpack_require__(233);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(535),
    isObjectLike = __webpack_require__(38);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(19),
    stubFalse = __webpack_require__(536);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)(module)))

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(537),
    baseUnary = __webpack_require__(538),
    nodeUtil = __webpack_require__(539);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 234 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 235 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(37);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 237 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(121);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.undo = undo;
exports.redo = redo;
exports.addUndoItem = addUndoItem;
exports.clear = clear;
function undo() {
  return { type: 'UNDO_HISTORY@UNDO' };
}

function redo() {
  return { type: 'UNDO_HISTORY@REDO' };
}

function addUndoItem(action, beforeState, afterState, args) {
  return {
    type: 'UNDO_HISTORY@ADD',
    payload: {
      action: action,
      beforeState: beforeState,
      afterState: afterState,
      args: args
    }
  };
}

function clear() {
  return {
    type: 'UNDO_HISTORY@CLEAR'
  };
}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.fetch = isFunction(global.fetch) && isFunction(global.ReadableStream)

exports.writableStream = isFunction(global.WritableStream)

exports.abortController = isFunction(global.AbortController)

exports.blobConstructor = false
try {
	new Blob([new ArrayBuffer(1)])
	exports.blobConstructor = true
} catch (e) {}

// The xhr request to example.com may violate some restrictive CSP configurations,
// so if we're running in a browser that supports `fetch`, avoid calling getXHR()
// and assume support for certain features below.
var xhr
function getXHR () {
	// Cache the xhr value
	if (xhr !== undefined) return xhr

	if (global.XMLHttpRequest) {
		xhr = new global.XMLHttpRequest()
		// If XDomainRequest is available (ie only, where xhr might not work
		// cross domain), use the page location. Otherwise use example.com
		// Note: this doesn't actually make an http request.
		try {
			xhr.open('GET', global.XDomainRequest ? '/' : 'https://example.com')
		} catch(e) {
			xhr = null
		}
	} else {
		// Service workers don't have XHR
		xhr = null
	}
	return xhr
}

function checkTypeSupport (type) {
	var xhr = getXHR()
	if (!xhr) return false
	try {
		xhr.responseType = type
		return xhr.responseType === type
	} catch (e) {}
	return false
}

// For some strange reason, Safari 7.0 reports typeof global.ArrayBuffer === 'object'.
// Safari 7.1 appears to have fixed this bug.
var haveArrayBuffer = typeof global.ArrayBuffer !== 'undefined'
var haveSlice = haveArrayBuffer && isFunction(global.ArrayBuffer.prototype.slice)

// If fetch is supported, then arraybuffer will be supported too. Skip calling
// checkTypeSupport(), since that calls getXHR().
exports.arraybuffer = exports.fetch || (haveArrayBuffer && checkTypeSupport('arraybuffer'))

// These next two tests unavoidably show warnings in Chrome. Since fetch will always
// be used if it's available, just return false for these to avoid the warnings.
exports.msstream = !exports.fetch && haveSlice && checkTypeSupport('ms-stream')
exports.mozchunkedarraybuffer = !exports.fetch && haveArrayBuffer &&
	checkTypeSupport('moz-chunked-arraybuffer')

// If fetch is supported, then overrideMimeType will be supported too. Skip calling
// getXHR().
exports.overrideMimeType = exports.fetch || (getXHR() ? isFunction(getXHR().overrideMimeType) : false)

exports.vbArray = isFunction(global.VBArray)

function isFunction (value) {
	return typeof value === 'function'
}

xhr = null // Help gc

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, Buffer, global) {var capability = __webpack_require__(241)
var inherits = __webpack_require__(31)
var stream = __webpack_require__(243)

var rStates = exports.readyStates = {
	UNSENT: 0,
	OPENED: 1,
	HEADERS_RECEIVED: 2,
	LOADING: 3,
	DONE: 4
}

var IncomingMessage = exports.IncomingMessage = function (xhr, response, mode, fetchTimer) {
	var self = this
	stream.Readable.call(self)

	self._mode = mode
	self.headers = {}
	self.rawHeaders = []
	self.trailers = {}
	self.rawTrailers = []

	// Fake the 'close' event, but only once 'end' fires
	self.on('end', function () {
		// The nextTick is necessary to prevent the 'request' module from causing an infinite loop
		process.nextTick(function () {
			self.emit('close')
		})
	})

	if (mode === 'fetch') {
		self._fetchResponse = response

		self.url = response.url
		self.statusCode = response.status
		self.statusMessage = response.statusText
		
		response.headers.forEach(function (header, key){
			self.headers[key.toLowerCase()] = header
			self.rawHeaders.push(key, header)
		})

		if (capability.writableStream) {
			var writable = new WritableStream({
				write: function (chunk) {
					return new Promise(function (resolve, reject) {
						if (self._destroyed) {
							reject()
						} else if(self.push(new Buffer(chunk))) {
							resolve()
						} else {
							self._resumeFetch = resolve
						}
					})
				},
				close: function () {
					global.clearTimeout(fetchTimer)
					if (!self._destroyed)
						self.push(null)
				},
				abort: function (err) {
					if (!self._destroyed)
						self.emit('error', err)
				}
			})

			try {
				response.body.pipeTo(writable).catch(function (err) {
					global.clearTimeout(fetchTimer)
					if (!self._destroyed)
						self.emit('error', err)
				})
				return
			} catch (e) {} // pipeTo method isn't defined. Can't find a better way to feature test this
		}
		// fallback for when writableStream or pipeTo aren't available
		var reader = response.body.getReader()
		function read () {
			reader.read().then(function (result) {
				if (self._destroyed)
					return
				if (result.done) {
					global.clearTimeout(fetchTimer)
					self.push(null)
					return
				}
				self.push(new Buffer(result.value))
				read()
			}).catch(function (err) {
				global.clearTimeout(fetchTimer)
				if (!self._destroyed)
					self.emit('error', err)
			})
		}
		read()
	} else {
		self._xhr = xhr
		self._pos = 0

		self.url = xhr.responseURL
		self.statusCode = xhr.status
		self.statusMessage = xhr.statusText
		var headers = xhr.getAllResponseHeaders().split(/\r?\n/)
		headers.forEach(function (header) {
			var matches = header.match(/^([^:]+):\s*(.*)/)
			if (matches) {
				var key = matches[1].toLowerCase()
				if (key === 'set-cookie') {
					if (self.headers[key] === undefined) {
						self.headers[key] = []
					}
					self.headers[key].push(matches[2])
				} else if (self.headers[key] !== undefined) {
					self.headers[key] += ', ' + matches[2]
				} else {
					self.headers[key] = matches[2]
				}
				self.rawHeaders.push(matches[1], matches[2])
			}
		})

		self._charset = 'x-user-defined'
		if (!capability.overrideMimeType) {
			var mimeType = self.rawHeaders['mime-type']
			if (mimeType) {
				var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/)
				if (charsetMatch) {
					self._charset = charsetMatch[1].toLowerCase()
				}
			}
			if (!self._charset)
				self._charset = 'utf-8' // best guess
		}
	}
}

inherits(IncomingMessage, stream.Readable)

IncomingMessage.prototype._read = function () {
	var self = this

	var resolve = self._resumeFetch
	if (resolve) {
		self._resumeFetch = null
		resolve()
	}
}

IncomingMessage.prototype._onXHRProgress = function () {
	var self = this

	var xhr = self._xhr

	var response = null
	switch (self._mode) {
		case 'text:vbarray': // For IE9
			if (xhr.readyState !== rStates.DONE)
				break
			try {
				// This fails in IE8
				response = new global.VBArray(xhr.responseBody).toArray()
			} catch (e) {}
			if (response !== null) {
				self.push(new Buffer(response))
				break
			}
			// Falls through in IE8	
		case 'text':
			try { // This will fail when readyState = 3 in IE9. Switch mode and wait for readyState = 4
				response = xhr.responseText
			} catch (e) {
				self._mode = 'text:vbarray'
				break
			}
			if (response.length > self._pos) {
				var newData = response.substr(self._pos)
				if (self._charset === 'x-user-defined') {
					var buffer = new Buffer(newData.length)
					for (var i = 0; i < newData.length; i++)
						buffer[i] = newData.charCodeAt(i) & 0xff

					self.push(buffer)
				} else {
					self.push(newData, self._charset)
				}
				self._pos = response.length
			}
			break
		case 'arraybuffer':
			if (xhr.readyState !== rStates.DONE || !xhr.response)
				break
			response = xhr.response
			self.push(new Buffer(new Uint8Array(response)))
			break
		case 'moz-chunked-arraybuffer': // take whole
			response = xhr.response
			if (xhr.readyState !== rStates.LOADING || !response)
				break
			self.push(new Buffer(new Uint8Array(response)))
			break
		case 'ms-stream':
			response = xhr.response
			if (xhr.readyState !== rStates.LOADING)
				break
			var reader = new global.MSStreamReader()
			reader.onprogress = function () {
				if (reader.result.byteLength > self._pos) {
					self.push(new Buffer(new Uint8Array(reader.result.slice(self._pos))))
					self._pos = reader.result.byteLength
				}
			}
			reader.onload = function () {
				self.push(null)
			}
			// reader.onerror = ??? // TODO: this
			reader.readAsArrayBuffer(response)
			break
	}

	// The ms-stream case handles end separately in reader.onload()
	if (self._xhr.readyState === rStates.DONE && self._mode !== 'ms-stream') {
		self.push(null)
	}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(50).Buffer, __webpack_require__(1)))

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(244);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(248);
exports.Duplex = __webpack_require__(39);
exports.Transform = __webpack_require__(250);
exports.PassThrough = __webpack_require__(602);


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(71);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(240);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(245).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(246);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(72).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(__webpack_require__(51));
util.inherits = __webpack_require__(31);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(596);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(597);
var destroyImpl = __webpack_require__(247);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(39);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(249).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(39);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(249).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(15)))

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(245).EventEmitter;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(71);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(71);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(__webpack_require__(51));
util.inherits = __webpack_require__(31);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(601)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(246);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(72).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(247);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(39);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(39);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(599).setImmediate, __webpack_require__(1)))

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(72).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(39);

/*<replacement>*/
var util = Object.create(__webpack_require__(51));
util.inherits = __webpack_require__(31);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(606);
var util = __webpack_require__(607);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(608);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(253);
module.exports = __webpack_require__(258);


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(254).enable();
  window.Promise = __webpack_require__(256);
}

// fetch() polyfill for making API calls.
__webpack_require__(257);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(73);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(124);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(124);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 257 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_browser__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_integrations__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_App__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_saga__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sagas__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_devtools_extension__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_devtools_extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_redux_devtools_extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_catch__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_catch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_redux_catch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_ErrorLogService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__undoMiddleware__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__autosaveMiddleware__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__config_app_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_ErrorHandler__ = __webpack_require__(58);
if(__WEBPACK_IMPORTED_MODULE_15__config_app_json__["APIURIS"].current!=="dev"){__WEBPACK_IMPORTED_MODULE_2__sentry_browser__["d" /* init */]({release:"20210728.01",// Client's DSN.
dsn:'https://f64255e362cd433eb96977e1ea34d803@o219485.ingest.sentry.io/5501742',// An array of strings or regexps that'll be used to allow specific errors based on their origin url
allowUrls:[__WEBPACK_IMPORTED_MODULE_15__config_app_json__["APIURIS"][__WEBPACK_IMPORTED_MODULE_15__config_app_json__["APIURIS"].current]],// Debug mode with valuable initialization/lifecycle informations.
debug:false,// Whether SDK should be enabled or not.
enabled:true,// An environment identifier.
environment:__WEBPACK_IMPORTED_MODULE_15__config_app_json__["APIURIS"].current,integrations:[new __WEBPACK_IMPORTED_MODULE_3__sentry_integrations__["a" /* Dedupe */]()],ignoreErrors:["ResizeObserver loop limit exceeded","ResizeObserver loop completed with undelivered notifications"]});__WEBPACK_IMPORTED_MODULE_2__sentry_browser__["c" /* configureScope */](function(scope){scope.setTags({projectId:document.querySelector('#root').dataset.id,teamId:document.querySelector('#root').dataset.teamid,userId:document.querySelector('#root').dataset.userid});});}var sagaMiddleware=Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga__["a" /* default */])();// addLocaleData([...en, ...fr]);
function errorHandler(error,getState,lastAction,dispatch){// var errorInfo = {currentState: getState(), lastAction: lastAction} // optionally dispatch an action due to the error using the dispatch parameter
Object(__WEBPACK_IMPORTED_MODULE_12__helpers_ErrorLogService__["a" /* errorlog */])(error,lastAction,"Redux-errorHandler");}var root=document.getElementById('root');var store=Object(__WEBPACK_IMPORTED_MODULE_5_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_8__reducers__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_5_redux__["applyMiddleware"])(__WEBPACK_IMPORTED_MODULE_11_redux_catch___default()(errorHandler),__WEBPACK_IMPORTED_MODULE_13__undoMiddleware__["a" /* default */],sagaMiddleware,__WEBPACK_IMPORTED_MODULE_14__autosaveMiddleware__["a" /* autosaveMiddleware */]));// const store = createStore(reducer,composeWithDevTools({trace: true})(applyMiddleware(reduxCatch(errorHandler),undoMiddleware,sagaMiddleware,autosaveMiddleware)));
sagaMiddleware.run(__WEBPACK_IMPORTED_MODULE_9__sagas__["a" /* watchLoadProject */],{'projectId':root.dataset.id,'userId':root.dataset.userid,'teamId':root.dataset.teamid,lang:root.dataset.language,'mode':root.dataset.apptype});__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__helpers_ErrorHandler__["a" /* default */],{component:'Animaker'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_App__["a" /* default */],{projectid:root.dataset.id,projectUsr:root.dataset.user,appType:root.dataset.type,userId:root.dataset.userid,teamId:root.dataset.teamid,mode:root.dataset.apptype,projectUsrImg:root.dataset.img,defaultView:root.dataset.view!==undefined?root.dataset.view:"full",langToLoad:root.dataset.language,userStatus:root.dataset.active,isEdit:root.dataset.isedit!==undefined&&root.dataset.isedit==="1",sampleTourDemo:root.dataset.sample,sampleSrc:root.dataset.src}))),document.getElementById('root'));

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(73),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.13.1";


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(73),r=__webpack_require__(261);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.13.1",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.13.1";


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(262);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_types__ = __webpack_require__(16);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_types__["b"]; });
/* unused harmony reexport Status */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(11);
/* unused harmony reexport addGlobalEventProcessor */
/* unused harmony reexport addBreadcrumb */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["f"]; });
/* unused harmony reexport captureEvent */
/* unused harmony reexport captureMessage */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["g"]; });
/* unused harmony reexport getHubFromCarrier */
/* unused harmony reexport getCurrentHub */
/* unused harmony reexport Hub */
/* unused harmony reexport makeMain */
/* unused harmony reexport Scope */
/* unused harmony reexport startTransaction */
/* unused harmony reexport setContext */
/* unused harmony reexport setExtra */
/* unused harmony reexport setExtras */
/* unused harmony reexport setTag */
/* unused harmony reexport setTags */
/* unused harmony reexport setUser */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["l"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__client__ = __webpack_require__(133);
/* unused harmony reexport BrowserClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(41);
/* unused harmony reexport injectReportDialog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventbuilder__ = __webpack_require__(81);
/* unused harmony reexport eventFromException */
/* unused harmony reexport eventFromMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sdk__ = __webpack_require__(294);
/* unused harmony reexport defaultIntegrations */
/* unused harmony reexport forceLoad */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__sdk__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__sdk__["b"]; });
/* unused harmony reexport onLoad */
/* unused harmony reexport showReportDialog */
/* unused harmony reexport flush */
/* unused harmony reexport close */
/* unused harmony reexport wrap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__version__ = __webpack_require__(136);
/* unused harmony reexport SDK_NAME */
/* unused harmony reexport SDK_VERSION */







//# sourceMappingURL=exports.js.map

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LogLevel */
/** Console logging verbosity for the SDK. */
var LogLevel;
(function (LogLevel) {
    /** No logs will be generated. */
    LogLevel[LogLevel["None"] = 0] = "None";
    /** Only SDK internal errors will be logged. */
    LogLevel[LogLevel["Error"] = 1] = "Error";
    /** Information useful for debugging the SDK will be logged. */
    LogLevel[LogLevel["Debug"] = 2] = "Debug";
    /** All SDK actions will be logged. */
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
})(LogLevel || (LogLevel = {}));
//# sourceMappingURL=loglevel.js.map

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SessionStatus; });
/**
 * Session Status
 */
var SessionStatus;
(function (SessionStatus) {
    /** JSDoc */
    SessionStatus["Ok"] = "ok";
    /** JSDoc */
    SessionStatus["Exited"] = "exited";
    /** JSDoc */
    SessionStatus["Crashed"] = "crashed";
    /** JSDoc */
    SessionStatus["Abnormal"] = "abnormal";
})(SessionStatus || (SessionStatus = {}));
//# sourceMappingURL=session.js.map

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Severity; });
/** JSDoc */
// eslint-disable-next-line import/export
var Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
(function (Severity) {
    /**
     * Converts a string-based level into a {@link Severity}.
     *
     * @param level string representation of Severity
     * @returns Severity
     */
    function fromString(level) {
        switch (level) {
            case 'debug':
                return Severity.Debug;
            case 'info':
                return Severity.Info;
            case 'warn':
            case 'warning':
                return Severity.Warning;
            case 'error':
                return Severity.Error;
            case 'fatal':
                return Severity.Fatal;
            case 'critical':
                return Severity.Critical;
            case 'log':
            default:
                return Severity.Log;
        }
    }
    Severity.fromString = fromString;
})(Severity || (Severity = {}));
//# sourceMappingURL=severity.js.map

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Status; });
/** The status of an event. */
// eslint-disable-next-line import/export
var Status;
(function (Status) {
    /** The status could not be determined. */
    Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */
    Status["Skipped"] = "skipped";
    /** The event was sent to Sentry successfully. */
    Status["Success"] = "success";
    /** The client is currently rate limited and will try again later. */
    Status["RateLimit"] = "rate_limit";
    /** The event could not be processed. */
    Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */
    Status["Failed"] = "failed";
})(Status || (Status = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
(function (Status) {
    /**
     * Converts a HTTP status code into a {@link Status}.
     *
     * @param code The HTTP response status code.
     * @returns The send status or {@link Status.Unknown}.
     */
    function fromHttpCode(code) {
        if (code >= 200 && code < 300) {
            return Status.Success;
        }
        if (code === 429) {
            return Status.RateLimit;
        }
        if (code >= 400 && code < 500) {
            return Status.Invalid;
        }
        if (code >= 500) {
            return Status.Failed;
        }
        return Status.Unknown;
    }
    Status.fromHttpCode = fromHttpCode;
})(Status || (Status = {}));
//# sourceMappingURL=status.js.map

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = captureException;
/* unused harmony export captureMessage */
/* unused harmony export captureEvent */
/* harmony export (immutable) */ __webpack_exports__["b"] = configureScope;
/* unused harmony export addBreadcrumb */
/* unused harmony export setContext */
/* unused harmony export setExtras */
/* unused harmony export setTags */
/* unused harmony export setExtra */
/* unused harmony export setTag */
/* unused harmony export setUser */
/* harmony export (immutable) */ __webpack_exports__["c"] = withScope;
/* unused harmony export _callOnClient */
/* unused harmony export startTransaction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(32);


/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function callOnHub(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var hub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["c" /* getCurrentHub */])();
    if (hub && hub[method]) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return hub[method].apply(hub, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])(args));
    }
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
    var syntheticException;
    try {
        throw new Error('Sentry syntheticException');
    }
    catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException,
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param level Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(message, captureContext) {
    var syntheticException;
    try {
        throw new Error(message);
    }
    catch (exception) {
        syntheticException = exception;
    }
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? { captureContext: captureContext } : undefined;
    return callOnHub('captureMessage', message, level, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ originalException: message, syntheticException: syntheticException }, context));
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event) {
    return callOnHub('captureEvent', event);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
    callOnHub('configureScope', callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
    callOnHub('addBreadcrumb', breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
    callOnHub('setContext', name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
    callOnHub('setExtras', extras);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
    callOnHub('setTags', tags);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
    callOnHub('setExtra', key, extra);
}
/**
 * Set key:value that will be sent as tags data with the event.
 * @param key String key of tag
 * @param value String value of tag
 */
function setTag(key, value) {
    callOnHub('setTag', key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
    callOnHub('setUser', user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
    callOnHub('withScope', callback);
}
/**
 * Calls a function on the latest client. Use this with caution, it's meant as
 * in "internal" helper so we don't need to expose every possible function in
 * the shim. It is not guaranteed that the client actually implements the
 * function.
 *
 * @param method The method to call on the client/client.
 * @param args Arguments to pass to the client/fontend.
 * @hidden
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _callOnClient(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    callOnHub.apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])(['_invokeClient', method], args));
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(context, customSamplingContext) {
    return callOnHub('startTransaction', Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, context), customSamplingContext);
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export forget */
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function forget(promise) {
    promise.then(null, function (e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}
//# sourceMappingURL=async.js.map

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dsn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(75);


/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
/** Error message */
var ERROR_MESSAGE = 'Invalid Dsn';
/** The Sentry Dsn, identifying a Sentry instance and project. */
var Dsn = /** @class */ (function () {
    /** Creates a new Dsn component */
    function Dsn(from) {
        if (typeof from === 'string') {
            this._fromString(from);
        }
        else {
            this._fromComponents(from);
        }
        this._validate();
    }
    /**
     * Renders the string representation of this Dsn.
     *
     * By default, this will render the public representation without the password
     * component. To get the deprecated private representation, set `withPassword`
     * to true.
     *
     * @param withPassword When set to true, the password will be included.
     */
    Dsn.prototype.toString = function (withPassword) {
        if (withPassword === void 0) { withPassword = false; }
        var _a = this, host = _a.host, path = _a.path, pass = _a.pass, port = _a.port, projectId = _a.projectId, protocol = _a.protocol, user = _a.user;
        return (protocol + "://" + user + (withPassword && pass ? ":" + pass : '') +
            ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
    };
    /** Parses a string into this Dsn. */
    Dsn.prototype._fromString = function (str) {
        var match = DSN_REGEX.exec(str);
        if (!match) {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE);
        }
        var _a = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __read */])(match.slice(1), 6), protocol = _a[0], user = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
        var path = '';
        var projectId = lastPath;
        var split = projectId.split('/');
        if (split.length > 1) {
            path = split.slice(0, -1).join('/');
            projectId = split.pop();
        }
        if (projectId) {
            var projectMatch = projectId.match(/^\d+/);
            if (projectMatch) {
                projectId = projectMatch[0];
            }
        }
        this._fromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, user: user });
    };
    /** Maps Dsn components into this instance. */
    Dsn.prototype._fromComponents = function (components) {
        this.protocol = components.protocol;
        this.user = components.user;
        this.pass = components.pass || '';
        this.host = components.host;
        this.port = components.port || '';
        this.path = components.path || '';
        this.projectId = components.projectId;
    };
    /** Validates this Dsn and throws on error. */
    Dsn.prototype._validate = function () {
        var _this = this;
        ['protocol', 'user', 'host', 'projectId'].forEach(function (component) {
            if (!_this[component]) {
                throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE + ": " + component + " missing");
            }
        });
        if (!this.projectId.match(/^\d+$/)) {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE + ": Invalid projectId " + this.projectId);
        }
        if (this.protocol !== 'http' && this.protocol !== 'https') {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE + ": Invalid protocol " + this.protocol);
        }
        if (this.port && isNaN(parseInt(this.port, 10))) {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE + ": Invalid port " + this.port);
        }
    };
    return Dsn;
}());

//# sourceMappingURL=dsn.js.map

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setPrototypeOf; });
var setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function mixinProperties(obj, proto) {
    for (var prop in proto) {
        // eslint-disable-next-line no-prototype-builtins
        if (!obj.hasOwnProperty(prop)) {
            // @ts-ignore typescript complains about indexing so we remove
            obj[prop] = proto[prop];
        }
    }
    return obj;
}
//# sourceMappingURL=polyfill.js.map

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addInstrumentationHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__misc__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__object__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stacktrace__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__supports__ = __webpack_require__(129);







var global = Object(__WEBPACK_IMPORTED_MODULE_3__misc__["e" /* getGlobalObject */])();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */
var handlers = {};
var instrumented = {};
/** Instruments given API */
function instrument(type) {
    if (instrumented[type]) {
        return;
    }
    instrumented[type] = true;
    switch (type) {
        case 'console':
            instrumentConsole();
            break;
        case 'dom':
            instrumentDOM();
            break;
        case 'xhr':
            instrumentXHR();
            break;
        case 'fetch':
            instrumentFetch();
            break;
        case 'history':
            instrumentHistory();
            break;
        case 'error':
            instrumentError();
            break;
        case 'unhandledrejection':
            instrumentUnhandledRejection();
            break;
        default:
            __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* logger */].warn('unknown instrumentation type:', type);
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(handler) {
    if (!handler || typeof handler.type !== 'string' || typeof handler.callback !== 'function') {
        return;
    }
    handlers[handler.type] = handlers[handler.type] || [];
    handlers[handler.type].push(handler.callback);
    instrument(handler.type);
}
/** JSDoc */
function triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !handlers[type]) {
        return;
    }
    try {
        for (var _b = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __values */])(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
            var handler = _c.value;
            try {
                handler(data);
            }
            catch (e) {
                __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* logger */].error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + Object(__WEBPACK_IMPORTED_MODULE_5__stacktrace__["a" /* getFunctionName */])(handler) + "\nError: " + e);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
/** JSDoc */
function instrumentConsole() {
    if (!('console' in global)) {
        return;
    }
    ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
        if (!(level in global.console)) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__object__["c" /* fill */])(global.console, level, function (originalConsoleLevel) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                triggerHandlers('console', { args: args, level: level });
                // this fails for some browsers. :(
                if (originalConsoleLevel) {
                    Function.prototype.apply.call(originalConsoleLevel, global.console, args);
                }
            };
        });
    });
}
/** JSDoc */
function instrumentFetch() {
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__supports__["c" /* supportsNativeFetch */])()) {
        return;
    }
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["c" /* fill */])(global, 'fetch', function (originalFetch) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var handlerData = {
                args: args,
                fetchData: {
                    method: getFetchMethod(args),
                    url: getFetchUrl(args),
                },
                startTimestamp: Date.now(),
            };
            triggerHandlers('fetch', Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply(global, args).then(function (response) {
                triggerHandlers('fetch', Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, handlerData), { endTimestamp: Date.now(), response: response }));
                return response;
            }, function (error) {
                triggerHandlers('fetch', Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, handlerData), { endTimestamp: Date.now(), error: error }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if ('Request' in global && Object(__WEBPACK_IMPORTED_MODULE_1__is__["g" /* isInstanceOf */])(fetchArgs[0], Request) && fetchArgs[0].method) {
        return String(fetchArgs[0].method).toUpperCase();
    }
    if (fetchArgs[1] && fetchArgs[1].method) {
        return String(fetchArgs[1].method).toUpperCase();
    }
    return 'GET';
}
/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if (typeof fetchArgs[0] === 'string') {
        return fetchArgs[0];
    }
    if ('Request' in global && Object(__WEBPACK_IMPORTED_MODULE_1__is__["g" /* isInstanceOf */])(fetchArgs[0], Request)) {
        return fetchArgs[0].url;
    }
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */
/** JSDoc */
function instrumentXHR() {
    if (!('XMLHttpRequest' in global)) {
        return;
    }
    // Poor man's implementation of ES6 `Map`, tracking and keeping in sync key and value separately.
    var requestKeys = [];
    var requestValues = [];
    var xhrproto = XMLHttpRequest.prototype;
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["c" /* fill */])(xhrproto, 'open', function (originalOpen) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: Object(__WEBPACK_IMPORTED_MODULE_1__is__["k" /* isString */])(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (Object(__WEBPACK_IMPORTED_MODULE_1__is__["k" /* isString */])(url) && xhr.__sentry_xhr__.method === 'POST' && url.match(/sentry_key/)) {
                xhr.__sentry_own_request__ = true;
            }
            var onreadystatechangeHandler = function () {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        if (xhr.__sentry_xhr__) {
                            xhr.__sentry_xhr__.status_code = xhr.status;
                        }
                    }
                    catch (e) {
                        /* do nothing */
                    }
                    try {
                        var requestPos = requestKeys.indexOf(xhr);
                        if (requestPos !== -1) {
                            // Make sure to pop both key and value to keep it in sync.
                            requestKeys.splice(requestPos);
                            var args_1 = requestValues.splice(requestPos)[0];
                            if (xhr.__sentry_xhr__ && args_1[0] !== undefined) {
                                xhr.__sentry_xhr__.body = args_1[0];
                            }
                        }
                    }
                    catch (e) {
                        /* do nothing */
                    }
                    triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr,
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                Object(__WEBPACK_IMPORTED_MODULE_4__object__["c" /* fill */])(xhr, 'onreadystatechange', function (original) {
                    return function () {
                        var readyStateArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            readyStateArgs[_i] = arguments[_i];
                        }
                        onreadystatechangeHandler();
                        return original.apply(xhr, readyStateArgs);
                    };
                });
            }
            else {
                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            }
            return originalOpen.apply(xhr, args);
        };
    });
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["c" /* fill */])(xhrproto, 'send', function (originalSend) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            requestKeys.push(this);
            requestValues.push(args);
            triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this,
            });
            return originalSend.apply(this, args);
        };
    });
}
var lastHref;
/** JSDoc */
function instrumentHistory() {
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__supports__["b" /* supportsHistory */])()) {
        return;
    }
    var oldOnPopState = global.onpopstate;
    global.onpopstate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var to = global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        triggerHandlers('history', {
            from: from,
            to: to,
        });
        if (oldOnPopState) {
            return oldOnPopState.apply(this, args);
        }
    };
    /** @hidden */
    function historyReplacementFunction(originalHistoryFunction) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                triggerHandlers('history', {
                    from: from,
                    to: to,
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["c" /* fill */])(global.history, 'pushState', historyReplacementFunction);
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["c" /* fill */])(global.history, 'replaceState', historyReplacementFunction);
}
/** JSDoc */
function instrumentDOM() {
    if (!('document' in global)) {
        return;
    }
    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    global.document.addEventListener('click', domEventHandler('click', triggerHandlers.bind(null, 'dom')), false);
    global.document.addEventListener('keypress', keypressEventHandler(triggerHandlers.bind(null, 'dom')), false);
    // After hooking into document bubbled up click and keypresses events, we also hook into user handled click & keypresses.
    ['EventTarget', 'Node'].forEach(function (target) {
        /* eslint-disable @typescript-eslint/no-unsafe-member-access */
        var proto = global[target] && global[target].prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        /* eslint-enable @typescript-eslint/no-unsafe-member-access */
        Object(__WEBPACK_IMPORTED_MODULE_4__object__["c" /* fill */])(proto, 'addEventListener', function (original) {
            return function (eventName, fn, options) {
                if (fn && fn.handleEvent) {
                    if (eventName === 'click') {
                        Object(__WEBPACK_IMPORTED_MODULE_4__object__["c" /* fill */])(fn, 'handleEvent', function (innerOriginal) {
                            return function (event) {
                                domEventHandler('click', triggerHandlers.bind(null, 'dom'))(event);
                                return innerOriginal.call(this, event);
                            };
                        });
                    }
                    if (eventName === 'keypress') {
                        Object(__WEBPACK_IMPORTED_MODULE_4__object__["c" /* fill */])(fn, 'handleEvent', function (innerOriginal) {
                            return function (event) {
                                keypressEventHandler(triggerHandlers.bind(null, 'dom'))(event);
                                return innerOriginal.call(this, event);
                            };
                        });
                    }
                }
                else {
                    if (eventName === 'click') {
                        domEventHandler('click', triggerHandlers.bind(null, 'dom'), true)(this);
                    }
                    if (eventName === 'keypress') {
                        keypressEventHandler(triggerHandlers.bind(null, 'dom'))(this);
                    }
                }
                return original.call(this, eventName, fn, options);
            };
        });
        Object(__WEBPACK_IMPORTED_MODULE_4__object__["c" /* fill */])(proto, 'removeEventListener', function (original) {
            return function (eventName, fn, options) {
                try {
                    original.call(this, eventName, fn.__sentry_wrapped__, options);
                }
                catch (e) {
                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return original.call(this, eventName, fn, options);
            };
        });
    });
}
var debounceDuration = 1000;
var debounceTimer = 0;
var keypressTimeout;
var lastCapturedEvent;
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param name the event name (e.g. "click")
 * @param handler function that will be triggered
 * @param debounce decides whether it should wait till another event loop
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function domEventHandler(name, handler, debounce) {
    if (debounce === void 0) { debounce = false; }
    return function (event) {
        // reset keypress timeout; e.g. triggering a 'click' after
        // a 'keypress' will reset the keypress debounce so that a new
        // set of keypresses can be recorded
        keypressTimeout = undefined;
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors). Ignore if we've
        // already captured the event.
        if (!event || lastCapturedEvent === event) {
            return;
        }
        lastCapturedEvent = event;
        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }
        if (debounce) {
            debounceTimer = setTimeout(function () {
                handler({ event: event, name: name });
            });
        }
        else {
            handler({ event: event, name: name });
        }
    };
}
/**
 * Wraps addEventListener to capture keypress UI events
 * @param handler function that will be triggered
 * @returns wrapped keypress events handler
 * @hidden
 */
function keypressEventHandler(handler) {
    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function (event) {
        var target;
        try {
            target = event.target;
        }
        catch (e) {
            // just accessing event properties can throw an exception in some rare circumstances
            // see: https://github.com/getsentry/raven-js/issues/838
            return;
        }
        var tagName = target && target.tagName;
        // only consider keypress events on actual input elements
        // this will disregard keypresses targeting body (e.g. tabbing
        // through elements, hotkeys, etc)
        if (!tagName || (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)) {
            return;
        }
        // record first keypress in a series, but ignore subsequent
        // keypresses until debounce clears
        if (!keypressTimeout) {
            domEventHandler('input', handler)(event);
        }
        clearTimeout(keypressTimeout);
        keypressTimeout = setTimeout(function () {
            keypressTimeout = undefined;
        }, debounceDuration);
    };
}
var _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
    _oldOnErrorHandler = global.onerror;
    global.onerror = function (msg, url, line, column, error) {
        triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url,
        });
        if (_oldOnErrorHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnErrorHandler.apply(this, arguments);
        }
        return false;
    };
}
var _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = global.onunhandledrejection;
    global.onunhandledrejection = function (e) {
        triggerHandlers('unhandledrejection', e);
        if (_oldOnUnhandledRejectionHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        }
        return true;
    };
}
//# sourceMappingURL=instrument.js.map

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resolve */
/* harmony export (immutable) */ __webpack_exports__["b"] = relative;
/* unused harmony export normalizePath */
/* unused harmony export isAbsolute */
/* unused harmony export join */
/* unused harmony export dirname */
/* harmony export (immutable) */ __webpack_exports__["a"] = basename;
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for (var i = parts.length - 1; i >= 0; i--) {
        var last = parts[i];
        if (last === '.') {
            parts.splice(i, 1);
        }
        else if (last === '..') {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up++;
        }
        else if (up) {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) {
        // eslint-disable-next-line no-plusplus
        for (; up--; up) {
            parts.unshift('..');
        }
    }
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
/** JSDoc */
function splitPath(filename) {
    var parts = splitPathRe.exec(filename);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) {
            continue;
        }
        resolvedPath = path + "/" + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function (p) { return !!p; }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */
function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
        if (arr[start] !== '') {
            break;
        }
    }
    var end = arr.length - 1;
    for (; end >= 0; end--) {
        if (arr[end] !== '') {
            break;
        }
    }
    if (start > end) {
        return [];
    }
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
    /* eslint-disable no-param-reassign */
    from = resolve(from).substr(1);
    to = resolve(to).substr(1);
    /* eslint-enable no-param-reassign */
    var fromParts = trim(from.split('/'));
    var toParts = trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for (var i = 0; i < length; i++) {
        if (fromParts[i] !== toParts[i]) {
            samePartsLength = i;
            break;
        }
    }
    var outputParts = [];
    for (var i = samePartsLength; i < fromParts.length; i++) {
        outputParts.push('..');
    }
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
    var isPathAbsolute = isAbsolute(path);
    var trailingSlash = path.substr(-1) === '/';
    // Normalize the path
    var normalizedPath = normalizeArray(path.split('/').filter(function (p) { return !!p; }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) {
        normalizedPath = '.';
    }
    if (normalizedPath && trailingSlash) {
        normalizedPath += '/';
    }
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
// posix version
/** JSDoc */
function isAbsolute(path) {
    return path.charAt(0) === '/';
}
// posix version
/** JSDoc */
function join() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return normalizePath(args.join('/'));
}
/** JSDoc */
function dirname(path) {
    var result = splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) {
        // No dirname whatsoever
        return '.';
    }
    if (dir) {
        // It has a dirname, strip trailing slash
        dir = dir.substr(0, dir.length - 1);
    }
    return root + dir;
}
/** JSDoc */
function basename(path, ext) {
    var f = splitPath(path)[2];
    if (ext && f.substr(ext.length * -1) === ext) {
        f = f.substr(0, f.length - ext.length);
    }
    return f;
}
//# sourceMappingURL=path.js.map

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PromiseBuffer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncpromise__ = __webpack_require__(130);


/** A simple queue that holds promises. */
var PromiseBuffer = /** @class */ (function () {
    function PromiseBuffer(_limit) {
        this._limit = _limit;
        /** Internal set of queued Promises */
        this._buffer = [];
    }
    /**
     * Says if the buffer is ready to take more requests
     */
    PromiseBuffer.prototype.isReady = function () {
        return this._limit === undefined || this.length() < this._limit;
    };
    /**
     * Add a promise to the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns The original promise.
     */
    PromiseBuffer.prototype.add = function (task) {
        var _this = this;
        if (!this.isReady()) {
            return __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */].reject(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* SentryError */]('Not adding Promise due to buffer limit reached.'));
        }
        if (this._buffer.indexOf(task) === -1) {
            this._buffer.push(task);
        }
        task
            .then(function () { return _this.remove(task); })
            .then(null, function () {
            return _this.remove(task).then(null, function () {
                // We have to add this catch here otherwise we have an unhandledPromiseRejection
                // because it's a new Promise chain.
            });
        });
        return task;
    };
    /**
     * Remove a promise to the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */
    PromiseBuffer.prototype.remove = function (task) {
        var removedTask = this._buffer.splice(this._buffer.indexOf(task), 1)[0];
        return removedTask;
    };
    /**
     * This function returns the number of unresolved promises in the queue.
     */
    PromiseBuffer.prototype.length = function () {
        return this._buffer.length;
    };
    /**
     * This will drain the whole queue, returns true if queue is empty or drained.
     * If timeout is provided and the queue takes longer to drain, the promise still resolves but with false.
     *
     * @param timeout Number in ms to wait until it resolves with false.
     */
    PromiseBuffer.prototype.drain = function (timeout) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */](function (resolve) {
            var capturedSetTimeout = setTimeout(function () {
                if (timeout && timeout > 0) {
                    resolve(false);
                }
            }, timeout);
            __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */].all(_this._buffer)
                .then(function () {
                clearTimeout(capturedSetTimeout);
                resolve(true);
            })
                .then(null, function () {
                resolve(true);
            });
        });
    };
    return PromiseBuffer;
}());

//# sourceMappingURL=promisebuffer.js.map

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dateTimestampInSeconds; });
/* unused harmony export timestampInSeconds */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return timestampWithMs; });
/* unused harmony export usingPerformanceAPI */
/* unused harmony export browserPerformanceTimeOrigin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__misc__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node__ = __webpack_require__(77);


/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
var dateTimestampSource = {
    nowSeconds: function () { return Date.now() / 1000; },
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
    var performance = Object(__WEBPACK_IMPORTED_MODULE_0__misc__["e" /* getGlobalObject */])().performance;
    if (!performance || !performance.now) {
        return undefined;
    }
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function () { return performance.now(); },
        timeOrigin: timeOrigin,
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
    try {
        var perfHooks = Object(__WEBPACK_IMPORTED_MODULE_1__node__["a" /* dynamicRequire */])(module, 'perf_hooks');
        return perfHooks.performance;
    }
    catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */
var platformPerformance = Object(__WEBPACK_IMPORTED_MODULE_1__node__["b" /* isNodeEnv */])() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: function () { return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000; },
    };
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
// Re-exported with an old name for backwards-compatibility.
var timestampWithMs = timestampInSeconds;
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
var usingPerformanceAPI = platformPerformance !== undefined;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
var browserPerformanceTimeOrigin = (function () {
    var performance = Object(__WEBPACK_IMPORTED_MODULE_0__misc__["e" /* getGlobalObject */])().performance;
    if (!performance) {
        return undefined;
    }
    if (performance.timeOrigin) {
        return performance.timeOrigin;
    }
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    return (performance.timing && performance.timing.navigationStart) || Date.now();
})();
//# sourceMappingURL=time.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(52)(module)))

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API_VERSION */
/* unused harmony export Hub */
/* unused harmony export getMainCarrier */
/* unused harmony export makeMain */
/* harmony export (immutable) */ __webpack_exports__["a"] = getCurrentHub;
/* unused harmony export getActiveDomain */
/* unused harmony export getHubFromCarrier */
/* unused harmony export setHubOnCarrier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scope__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__session__ = __webpack_require__(131);




/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
var API_VERSION = 3;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 100;
/**
 * Absolute maximum number of breadcrumbs added to an event. The
 * `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */
var Hub = /** @class */ (function () {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */
    function Hub(client, scope, _version) {
        if (scope === void 0) { scope = new __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */](); }
        if (_version === void 0) { _version = API_VERSION; }
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */
        this._stack = [{}];
        this.getStackTop().scope = scope;
        this.bindClient(client);
    }
    /**
     * @inheritDoc
     */
    Hub.prototype.isOlderThan = function (version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.bindClient = function (client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) {
            client.setupIntegrations();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.pushScope = function () {
        // We want to clone the content of prev scope
        var scope = __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */].clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope,
        });
        return scope;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.popScope = function () {
        if (this.getStack().length <= 1)
            return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.withScope = function (callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        }
        finally {
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getClient = function () {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */
    Hub.prototype.getScope = function () {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */
    Hub.prototype.getStack = function () {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */
    Hub.prototype.getStackTop = function () {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function (exception, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["R" /* uuid4 */])());
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureException', exception, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureMessage = function (message, level, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["R" /* uuid4 */])());
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureMessage', message, level, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureEvent = function (event, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["R" /* uuid4 */])());
        this._invokeClient('captureEvent', event, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, hint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.lastEventId = function () {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client)
            return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = (client.getOptions && client.getOptions()) || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0)
            return;
        var timestamp = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* dateTimestampInSeconds */])();
        var mergedBreadcrumb = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ timestamp: timestamp }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb
            ? Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["i" /* consoleSandbox */])(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
            : mergedBreadcrumb;
        if (finalBreadcrumb === null)
            return;
        scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, MAX_BREADCRUMBS));
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setUser = function (user) {
        var scope = this.getScope();
        if (scope)
            scope.setUser(user);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTags = function (tags) {
        var scope = this.getScope();
        if (scope)
            scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtras = function (extras) {
        var scope = this.getScope();
        if (scope)
            scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTag = function (key, value) {
        var scope = this.getScope();
        if (scope)
            scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtra = function (key, extra) {
        var scope = this.getScope();
        if (scope)
            scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function (name, context) {
        var scope = this.getScope();
        if (scope)
            scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.configureScope = function (callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) {
            callback(scope);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.run = function (callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        }
        finally {
            makeMain(oldHub);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getIntegration = function (integration) {
        var client = this.getClient();
        if (!client)
            return null;
        try {
            return client.getIntegration(integration);
        }
        catch (_oO) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* logger */].warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSpan = function (context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startTransaction = function (context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.traceHeaders = function () {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSession = function (context) {
        // End existing session if there's one
        this.endSession();
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = (client && client.getOptions()) || {}, release = _b.release, environment = _b.environment;
        var session = new __WEBPACK_IMPORTED_MODULE_3__session__["a" /* Session */](Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ release: release,
            environment: environment }, (scope && { user: scope.getUser() })), context));
        if (scope) {
            scope.setSession(session);
        }
        return session;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.endSession = function () {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope)
            return;
        var session = scope.getSession();
        if (session) {
            session.close();
            if (client && client.captureSession) {
                client.captureSession(session);
            }
            scope.setSession();
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function (method) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            (_a = client)[method].apply(_a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])(args, [scope]));
        }
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */
    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function (method) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var carrier = getMainCarrier();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
            return sentry.extensions[method].apply(this, args);
        }
        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* logger */].warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}());

/** Returns the global shim registry. */
function getMainCarrier() {
    var carrier = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["p" /* getGlobalObject */])();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined,
    };
    return carrier;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        setHubOnCarrier(registry, new Hub());
    }
    // Prefer domains over global if they are there (applicable only to Node environment)
    if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["z" /* isNodeEnv */])()) {
        return getHubFromActiveDomain(registry);
    }
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * Returns the active domain, if one exists
 *
 * @returns The domain, or undefined if there is no active domain
 */
function getActiveDomain() {
    var sentry = getMainCarrier().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
    try {
        var activeDomain = getActiveDomain();
        // If there's no active domain, just return global hub
        if (!activeDomain) {
            return getHubFromCarrier(registry);
        }
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */].clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    }
    catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub)
        return carrier.__SENTRY__.hub;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = new Hub();
    return carrier.__SENTRY__.hub;
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 */
function setHubOnCarrier(carrier, hub) {
    if (!carrier)
        return false;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = hub;
    return true;
}
//# sourceMappingURL=hub.js.map

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(2);

var SENTRY_API_VERSION = '7';
/** Helper class to provide urls to different Sentry endpoints. */
var API = /** @class */ (function () {
    /** Create a new instance of API */
    function API(dsn) {
        this.dsn = dsn;
        this._dsnObject = new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["a" /* Dsn */](dsn);
    }
    /** Returns the Dsn object. */
    API.prototype.getDsn = function () {
        return this._dsnObject;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */
    API.prototype.getBaseApiEndpoint = function () {
        var dsn = this._dsnObject;
        var protocol = dsn.protocol ? dsn.protocol + ":" : '';
        var port = dsn.port ? ":" + dsn.port : '';
        return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
    };
    /** Returns the store endpoint URL. */
    API.prototype.getStoreEndpoint = function () {
        return this._getIngestEndpoint('store');
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */
    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
        return this.getStoreEndpoint() + "?" + this._encodedAuth();
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */
    API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function () {
        return this._getEnvelopeEndpoint() + "?" + this._encodedAuth();
    };
    /** Returns only the path component for the store endpoint. */
    API.prototype.getStoreEndpointPath = function () {
        var dsn = this._dsnObject;
        return (dsn.path ? "/" + dsn.path : '') + "/api/" + dsn.projectId + "/store/";
    };
    /**
     * Returns an object that can be used in request headers.
     * This is needed for node and the old /store endpoint in sentry
     */
    API.prototype.getRequestHeaders = function (clientName, clientVersion) {
        var dsn = this._dsnObject;
        var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
        header.push("sentry_client=" + clientName + "/" + clientVersion);
        header.push("sentry_key=" + dsn.user);
        if (dsn.pass) {
            header.push("sentry_secret=" + dsn.pass);
        }
        return {
            'Content-Type': 'application/json',
            'X-Sentry-Auth': header.join(', '),
        };
    };
    /** Returns the url to the report dialog endpoint. */
    API.prototype.getReportDialogEndpoint = function (dialogOptions) {
        if (dialogOptions === void 0) { dialogOptions = {}; }
        var dsn = this._dsnObject;
        var endpoint = this.getBaseApiEndpoint() + "embed/error-page/";
        var encodedOptions = [];
        encodedOptions.push("dsn=" + dsn.toString());
        for (var key in dialogOptions) {
            if (key === 'user') {
                if (!dialogOptions.user) {
                    continue;
                }
                if (dialogOptions.user.name) {
                    encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
                }
                if (dialogOptions.user.email) {
                    encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
                }
            }
            else {
                encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
            }
        }
        if (encodedOptions.length) {
            return endpoint + "?" + encodedOptions.join('&');
        }
        return endpoint;
    };
    /** Returns the envelope endpoint URL. */
    API.prototype._getEnvelopeEndpoint = function () {
        return this._getIngestEndpoint('envelope');
    };
    /** Returns the ingest API endpoint for target. */
    API.prototype._getIngestEndpoint = function (target) {
        var base = this.getBaseApiEndpoint();
        var dsn = this._dsnObject;
        return "" + base + dsn.projectId + "/" + target + "/";
    };
    /** Returns a URL-encoded string with auth config suitable for a query string. */
    API.prototype._encodedAuth = function () {
        var dsn = this._dsnObject;
        var auth = {
            // We send only the minimum set of required information. See
            // https://github.com/getsentry/sentry-javascript/issues/2572.
            sentry_key: dsn.user,
            sentry_version: SENTRY_API_VERSION,
        };
        return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["Q" /* urlEncode */])(auth);
    };
    return API;
}());

//# sourceMappingURL=api.js.map

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__integration__ = __webpack_require__(279);

/* eslint-disable max-lines */




/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient.prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */
var BaseClient = /** @class */ (function () {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */
    function BaseClient(backendClass, options) {
        /** Array of used integrations. */
        this._integrations = {};
        /** Number of call being processed */
        this._processing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) {
            this._dsn = new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["a" /* Dsn */](options.dsn);
        }
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function (exception, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._process(this._getBackend()
            .eventFromException(exception, hint)
            .then(function (event) { return _this._captureEvent(event, hint, scope); })
            .then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["B" /* isPrimitive */])(message)
            ? this._getBackend().eventFromMessage("" + message, level, hint)
            : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent
            .then(function (event) { return _this._captureEvent(event, hint, scope); })
            .then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureEvent = function (event, hint, scope) {
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureSession = function (session) {
        if (!session.release) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["E" /* logger */].warn('Discarded session because of missing release');
        }
        else {
            this._sendSession(session);
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getDsn = function () {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getOptions = function () {
        return this._options;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.flush = function (timeout) {
        var _this = this;
        return this._isClientProcessing(timeout).then(function (ready) {
            return _this._getBackend()
                .getTransport()
                .close(timeout)
                .then(function (transportFlushed) { return ready && transportFlushed; });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.close = function (timeout) {
        var _this = this;
        return this.flush(timeout).then(function (result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */
    BaseClient.prototype.setupIntegrations = function () {
        if (this._isEnabled()) {
            this._integrations = Object(__WEBPACK_IMPORTED_MODULE_4__integration__["a" /* setupIntegrations */])(this._options);
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegration = function (integration) {
        try {
            return this._integrations[integration.id] || null;
        }
        catch (_oO) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["E" /* logger */].warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */
    BaseClient.prototype._updateSessionFromEvent = function (session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var userAgent;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for (var exceptions_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __values */])(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()) {
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        var user = event.user;
        if (!session.userAgent) {
            var headers = event.request ? event.request.headers : {};
            for (var key in headers) {
                if (key.toLowerCase() === 'user-agent') {
                    userAgent = headers[key];
                    break;
                }
            }
        }
        session.update(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (crashed && { status: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* SessionStatus */].Crashed })), { user: user,
            userAgent: userAgent, errors: session.errors + Number(errored || crashed) }));
    };
    /** Deliver captured session to Sentry */
    BaseClient.prototype._sendSession = function (session) {
        this._getBackend().sendSession(session);
    };
    /** Waits for the client to be done with processing. */
    BaseClient.prototype._isClientProcessing = function (timeout) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* SyncPromise */](function (resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function () {
                if (_this._processing == 0) {
                    clearInterval(interval);
                    resolve(true);
                }
                else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */
    BaseClient.prototype._getBackend = function () {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */
    BaseClient.prototype._isEnabled = function () {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */
    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
        var _this = this;
        var _a = this.getOptions().normalizeDepth, normalizeDepth = _a === void 0 ? 3 : _a;
        var prepared = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event), { event_id: event.event_id || (hint && hint.event_id ? hint.event_id : Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["R" /* uuid4 */])()), timestamp: event.timestamp || Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["j" /* dateTimestampInSeconds */])() });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) {
            finalScope = __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["a" /* Scope */].clone(finalScope).update(hint.captureContext);
        }
        // We prepare the result here with a resolved Event.
        var result = __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* SyncPromise */].resolve(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) {
            // In case we have a hub we reassign it.
            result = finalScope.applyToEvent(prepared, hint);
        }
        return result.then(function (evt) {
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
                return _this._normalizeEvent(evt, normalizeDepth);
            }
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */
    BaseClient.prototype._normalizeEvent = function (event, depth) {
        if (!event) {
            return null;
        }
        var normalized = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event), (event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function (b) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, b), (b.data && {
                data: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["F" /* normalize */])(b.data, depth),
            }))); }),
        })), (event.user && {
            user: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["F" /* normalize */])(event.user, depth),
        })), (event.contexts && {
            contexts: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["F" /* normalize */])(event.contexts, depth),
        })), (event.extra && {
            extra: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["F" /* normalize */])(event.extra, depth),
        }));
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            normalized.contexts.trace = event.contexts.trace;
        }
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */
    BaseClient.prototype._applyClientOptions = function (event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) {
            event.environment = 'environment' in options ? environment : 'production';
        }
        if (event.release === undefined && release !== undefined) {
            event.release = release;
        }
        if (event.dist === undefined && dist !== undefined) {
            event.dist = dist;
        }
        if (event.message) {
            event.message = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["P" /* truncate */])(event.message, maxValueLength);
        }
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) {
            exception.value = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["P" /* truncate */])(exception.value, maxValueLength);
        }
        var request = event.request;
        if (request && request.url) {
            request.url = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["P" /* truncate */])(request.url, maxValueLength);
        }
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param sdkInfo The sdkInfo of the event that will be filled with all integrations.
     */
    BaseClient.prototype._applyIntegrationsMetadata = function (event) {
        var sdkInfo = event.sdk;
        var integrationsArray = Object.keys(this._integrations);
        if (sdkInfo && integrationsArray.length > 0) {
            sdkInfo.integrations = integrationsArray;
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */
    BaseClient.prototype._sendEvent = function (event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */
    BaseClient.prototype._captureEvent = function (event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function (finalEvent) {
            return finalEvent.event_id;
        }, function (reason) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["E" /* logger */].error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */
    BaseClient.prototype._processEvent = function (event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        if (!this._isEnabled()) {
            return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* SyncPromise */].reject(new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SentryError */]('SDK not enabled, will not send event.'));
        }
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* SyncPromise */].reject(new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SentryError */]('This event has been sampled, will not send event.'));
        }
        return this._prepareEvent(event, scope, hint)
            .then(function (prepared) {
            if (prepared === null) {
                throw new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SentryError */]('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) {
                return prepared;
            }
            var beforeSendResult = beforeSend(prepared, hint);
            if (typeof beforeSendResult === 'undefined') {
                throw new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SentryError */]('`beforeSend` method has to return `null` or a valid event.');
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["D" /* isThenable */])(beforeSendResult)) {
                return beforeSendResult.then(function (event) { return event; }, function (e) {
                    throw new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SentryError */]("beforeSend rejected with " + e);
                });
            }
            return beforeSendResult;
        })
            .then(function (processedEvent) {
            if (processedEvent === null) {
                throw new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SentryError */]('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession();
            if (!isTransaction && session) {
                _this._updateSessionFromEvent(session, processedEvent);
            }
            _this._sendEvent(processedEvent);
            return processedEvent;
        })
            .then(null, function (reason) {
            if (reason instanceof __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SentryError */]) {
                throw reason;
            }
            _this.captureException(reason, {
                data: {
                    __sentry__: true,
                },
                originalException: reason,
            });
            throw new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SentryError */]("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */
    BaseClient.prototype._process = function (promise) {
        var _this = this;
        this._processing += 1;
        promise.then(function (value) {
            _this._processing -= 1;
            return value;
        }, function (reason) {
            _this._processing -= 1;
            return reason;
        });
    };
    return BaseClient;
}());

//# sourceMappingURL=baseclient.js.map

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export installedIntegrations */
/* unused harmony export getIntegrationsToSetup */
/* unused harmony export setupIntegration */
/* harmony export (immutable) */ __webpack_exports__["a"] = setupIntegrations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(2);



var installedIntegrations = [];
/** Gets integration to install */
function getIntegrationsToSetup(options) {
    var defaultIntegrations = (options.defaultIntegrations && Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])(options.defaultIntegrations)) || [];
    var userIntegrations = options.integrations;
    var integrations = [];
    if (Array.isArray(userIntegrations)) {
        var userIntegrationsNames_1 = userIntegrations.map(function (i) { return i.name; });
        var pickedIntegrationsNames_1 = [];
        // Leave only unique default integrations, that were not overridden with provided user integrations
        defaultIntegrations.forEach(function (defaultIntegration) {
            if (userIntegrationsNames_1.indexOf(defaultIntegration.name) === -1 &&
                pickedIntegrationsNames_1.indexOf(defaultIntegration.name) === -1) {
                integrations.push(defaultIntegration);
                pickedIntegrationsNames_1.push(defaultIntegration.name);
            }
        });
        // Don't add same user integration twice
        userIntegrations.forEach(function (userIntegration) {
            if (pickedIntegrationsNames_1.indexOf(userIntegration.name) === -1) {
                integrations.push(userIntegration);
                pickedIntegrationsNames_1.push(userIntegration.name);
            }
        });
    }
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(integrations) ? integrations : [integrations];
    }
    else {
        integrations = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])(defaultIntegrations);
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function (i) { return i.name; });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
        integrations.push.apply(integrations, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    }
    return integrations;
}
/** Setup given integration */
function setupIntegration(integration) {
    if (installedIntegrations.indexOf(integration.name) !== -1) {
        return;
    }
    integration.setupOnce(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* addGlobalEventProcessor */], __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["c" /* getCurrentHub */]);
    installedIntegrations.push(integration.name);
    __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["E" /* logger */].log("Integration installed: " + integration.name);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(options) {
    var integrations = {};
    getIntegrationsToSetup(options).forEach(function (integration) {
        integrations[integration.name] = integration;
        setupIntegration(integration);
    });
    return integrations;
}
//# sourceMappingURL=integration.js.map

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseBackend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transports_noop__ = __webpack_require__(132);


/**
 * This is the base implemention of a Backend.
 * @hidden
 */
var BaseBackend = /** @class */ (function () {
    /** Creates a new backend instance. */
    function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["E" /* logger */].warn('No DSN provided, backend will not do anything.');
        }
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
        throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* SentryError */]('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
        throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* SentryError */]('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendEvent = function (event) {
        this._transport.sendEvent(event).then(null, function (reason) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["E" /* logger */].error("Error while sending event: " + reason);
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendSession = function (session) {
        if (!this._transport.sendSession) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["E" /* logger */].warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        this._transport.sendSession(session).then(null, function (reason) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["E" /* logger */].error("Error while sending session: " + reason);
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.getTransport = function () {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */
    BaseBackend.prototype._setupTransport = function () {
        return new __WEBPACK_IMPORTED_MODULE_1__transports_noop__["a" /* NoopTransport */]();
    };
    return BaseBackend;
}());

//# sourceMappingURL=basebackend.js.map

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = sessionToSentryRequest;
/* harmony export (immutable) */ __webpack_exports__["a"] = eventToSentryRequest;
/** Creates a SentryRequest from an event. */
function sessionToSentryRequest(session, api) {
    var envelopeHeaders = JSON.stringify({
        sent_at: new Date().toISOString(),
    });
    var itemHeaders = JSON.stringify({
        type: 'session',
    });
    return {
        body: envelopeHeaders + "\n" + itemHeaders + "\n" + JSON.stringify(session),
        type: 'session',
        url: api.getEnvelopeEndpointWithUrlEncodedAuth(),
    };
}
/** Creates a SentryRequest from an event. */
function eventToSentryRequest(event, api) {
    var useEnvelope = event.type === 'transaction';
    var req = {
        body: JSON.stringify(event),
        type: event.type || 'event',
        url: useEnvelope ? api.getEnvelopeEndpointWithUrlEncodedAuth() : api.getStoreEndpointWithUrlEncodedAuth(),
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = JSON.stringify({
            event_id: event.event_id,
            // We need to add * 1000 since we divide it by 1000 by default but JS works with ms precision
            // The reason we use timestampWithMs here is that all clocks across the SDK use the same clock
            sent_at: new Date().toISOString(),
        });
        var itemHeaders = JSON.stringify({
            type: event.type,
        });
        // The trailing newline is optional. We intentionally don't send it to avoid
        // sending unnecessary bytes.
        //
        // const envelope = `${envelopeHeaders}\n${itemHeaders}\n${req.body}\n`;
        var envelope = envelopeHeaders + "\n" + itemHeaders + "\n" + req.body;
        req.body = envelope;
    }
    return req;
}
//# sourceMappingURL=request.js.map

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initAndBind;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_hub__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);


/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(clientClass, options) {
    if (options.debug === true) {
        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* logger */].enable();
    }
    var hub = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_hub__["c" /* getCurrentHub */])();
    var client = new clientClass(options);
    hub.bindClient(client);
}
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functiontostring__ = __webpack_require__(284);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FunctionToString", function() { return __WEBPACK_IMPORTED_MODULE_0__functiontostring__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inboundfilters__ = __webpack_require__(285);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InboundFilters", function() { return __WEBPACK_IMPORTED_MODULE_1__inboundfilters__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FunctionToString; });
var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */ (function () {
    function FunctionToString() {
        /**
         * @inheritDoc
         */
        this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */
    FunctionToString.prototype.setupOnce = function () {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = this.__sentry_original__ || this;
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */
    FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}());

//# sourceMappingURL=functiontostring.js.map

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InboundFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(2);



// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var InboundFilters = /** @class */ (function () {
    function InboundFilters(_options) {
        if (_options === void 0) { _options = {}; }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */
    InboundFilters.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* addGlobalEventProcessor */])(function (event) {
            var hub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["c" /* getCurrentHub */])();
            if (!hub) {
                return event;
            }
            var self = hub.getIntegration(InboundFilters);
            if (self) {
                var client = hub.getClient();
                var clientOptions = client ? client.getOptions() : {};
                var options = self._mergeOptions(clientOptions);
                if (self._shouldDropEvent(event, options)) {
                    return null;
                }
            }
            return event;
        });
    };
    /** JSDoc */
    InboundFilters.prototype._shouldDropEvent = function (event, options) {
        if (this._isSentryError(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["E" /* logger */].warn("Event dropped due to being internal Sentry Error.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["n" /* getEventDescription */])(event));
            return true;
        }
        if (this._isIgnoredError(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["E" /* logger */].warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["n" /* getEventDescription */])(event));
            return true;
        }
        if (this._isDeniedUrl(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["E" /* logger */].warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["n" /* getEventDescription */])(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        if (!this._isAllowedUrl(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["E" /* logger */].warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["n" /* getEventDescription */])(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        return false;
    };
    /** JSDoc */
    InboundFilters.prototype._isSentryError = function (event, options) {
        if (!options.ignoreInternal) {
            return false;
        }
        try {
            return ((event &&
                event.exception &&
                event.exception.values &&
                event.exception.values[0] &&
                event.exception.values[0].type === 'SentryError') ||
                false);
        }
        catch (_oO) {
            return false;
        }
    };
    /** JSDoc */
    InboundFilters.prototype._isIgnoredError = function (event, options) {
        if (!options.ignoreErrors || !options.ignoreErrors.length) {
            return false;
        }
        return this._getPossibleEventMessages(event).some(function (message) {
            // Not sure why TypeScript complains here...
            return options.ignoreErrors.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["y" /* isMatchingPattern */])(message, pattern); });
        });
    };
    /** JSDoc */
    InboundFilters.prototype._isDeniedUrl = function (event, options) {
        // TODO: Use Glob instead?
        if (!options.denyUrls || !options.denyUrls.length) {
            return false;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? false : options.denyUrls.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["y" /* isMatchingPattern */])(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._isAllowedUrl = function (event, options) {
        // TODO: Use Glob instead?
        if (!options.allowUrls || !options.allowUrls.length) {
            return true;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? true : options.allowUrls.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["y" /* isMatchingPattern */])(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._mergeOptions = function (clientOptions) {
        if (clientOptions === void 0) { clientOptions = {}; }
        return {
            allowUrls: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])((this._options.whitelistUrls || []), (this._options.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
            denyUrls: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])((this._options.blacklistUrls || []), (this._options.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
            ignoreErrors: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])((this._options.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
            ignoreInternal: typeof this._options.ignoreInternal !== 'undefined' ? this._options.ignoreInternal : true,
        };
    };
    /** JSDoc */
    InboundFilters.prototype._getPossibleEventMessages = function (event) {
        if (event.message) {
            return [event.message];
        }
        if (event.exception) {
            try {
                var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
                return ["" + value, type + ": " + value];
            }
            catch (oO) {
                __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["E" /* logger */].error("Cannot extract message for event " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["n" /* getEventDescription */])(event));
                return [];
            }
        }
        return [];
    };
    /** JSDoc */
    InboundFilters.prototype._getEventFilterUrl = function (event) {
        try {
            if (event.stacktrace) {
                var frames_1 = event.stacktrace.frames;
                return (frames_1 && frames_1[frames_1.length - 1].filename) || null;
            }
            if (event.exception) {
                var frames_2 = event.exception.values && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames;
                return (frames_2 && frames_2[frames_2.length - 1].filename) || null;
            }
            return null;
        }
        catch (oO) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["E" /* logger */].error("Cannot extract url for event " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["n" /* getEventDescription */])(event));
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}());

//# sourceMappingURL=inboundfilters.js.map

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserBackend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventbuilder__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__transports__ = __webpack_require__(135);






/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */
var BrowserBackend = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromException = function (exception, hint) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["a" /* eventFromException */])(this._options, exception, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
        if (level === void 0) { level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["b" /* Severity */].Info; }
        return Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["b" /* eventFromMessage */])(this._options, message, level, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype._setupTransport = function () {
        if (!this._options.dsn) {
            // We return the noop transport here in case there is no Dsn.
            return _super.prototype._setupTransport.call(this);
        }
        var transportOptions = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._options.transportOptions), { dsn: this._options.dsn });
        if (this._options.transport) {
            return new this._options.transport(transportOptions);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["L" /* supportsFetch */])()) {
            return new __WEBPACK_IMPORTED_MODULE_5__transports__["a" /* FetchTransport */](transportOptions);
        }
        return new __WEBPACK_IMPORTED_MODULE_5__transports__["b" /* XHRTransport */](transportOptions);
    };
    return BrowserBackend;
}(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["b" /* BaseBackend */]));

//# sourceMappingURL=backend.js.map

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FetchTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(83);




var global = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["p" /* getGlobalObject */])();
/** `fetch` based transport */
var FetchTransport = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(FetchTransport, _super);
    function FetchTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    FetchTransport.prototype.sendEvent = function (event) {
        return this._sendRequest(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* eventToSentryRequest */])(event, this._api), event);
    };
    /**
     * @inheritDoc
     */
    FetchTransport.prototype.sendSession = function (session) {
        return this._sendRequest(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["k" /* sessionToSentryRequest */])(session, this._api), session);
    };
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */
    FetchTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
        var _this = this;
        if (this._isRateLimited(sentryRequest.type)) {
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                reason: "Transport locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429,
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
            // https://caniuse.com/#feat=referrer-policy
            // It doesn't. And it throw exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["M" /* supportsReferrerPolicy */])() ? 'origin' : ''),
        };
        if (this.options.fetchParameters !== undefined) {
            Object.assign(options, this.options.fetchParameters);
        }
        if (this.options.headers !== undefined) {
            options.headers = this.options.headers;
        }
        return this._buffer.add(new __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            global
                .fetch(sentryRequest.url, options)
                .then(function (response) {
                var headers = {
                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                    'retry-after': response.headers.get('Retry-After'),
                };
                _this._handleResponse({ requestType: sentryRequest.type, response: response, headers: headers, resolve: resolve, reject: reject });
            })
                .catch(reject);
        }));
    };
    return FetchTransport;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseTransport */]));

//# sourceMappingURL=fetch.js.map

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return XHRTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(83);




/** `XHR` based transport */
var XHRTransport = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    XHRTransport.prototype.sendEvent = function (event) {
        return this._sendRequest(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* eventToSentryRequest */])(event, this._api), event);
    };
    /**
     * @inheritDoc
     */
    XHRTransport.prototype.sendSession = function (session) {
        return this._sendRequest(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["k" /* sessionToSentryRequest */])(session, this._api), session);
    };
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */
    XHRTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
        var _this = this;
        if (this._isRateLimited(sentryRequest.type)) {
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                reason: "Transport locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429,
            });
        }
        return this._buffer.add(new __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
                if (request.readyState === 4) {
                    var headers = {
                        'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': request.getResponseHeader('Retry-After'),
                    };
                    _this._handleResponse({ requestType: sentryRequest.type, response: request, headers: headers, resolve: resolve, reject: reject });
                }
            };
            request.open('POST', sentryRequest.url);
            for (var header in _this.options.headers) {
                if (_this.options.headers.hasOwnProperty(header)) {
                    request.setRequestHeader(header, _this.options.headers[header]);
                }
            }
            request.send(sentryRequest.body);
        }));
    };
    return XHRTransport;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseTransport */]));

//# sourceMappingURL=xhr.js.map

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalHandlers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventbuilder__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(41);

/* eslint-disable @typescript-eslint/no-unsafe-member-access */





/** Global handlers */
var GlobalHandlers = /** @class */ (function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        /** JSDoc */
        this._onErrorHandlerInstalled = false;
        /** JSDoc */
        this._onUnhandledRejectionHandlerInstalled = false;
        this._options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ onerror: true, onunhandledrejection: true }, options);
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        Error.stackTraceLimit = 50;
        if (this._options.onerror) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["E" /* logger */].log('Global Handler attached: onerror');
            this._installGlobalOnErrorHandler();
        }
        if (this._options.onunhandledrejection) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["E" /* logger */].log('Global Handler attached: onunhandledrejection');
            this._installGlobalOnUnhandledRejectionHandler();
        }
    };
    /** JSDoc */
    GlobalHandlers.prototype._installGlobalOnErrorHandler = function () {
        var _this = this;
        if (this._onErrorHandlerInstalled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            callback: function (data) {
                var error = data.error;
                var currentHub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* getCurrentHub */])();
                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
                if (!hasIntegration || Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* shouldIgnoreOnError */])() || isFailedOwnDelivery) {
                    return;
                }
                var client = currentHub.getClient();
                var event = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["B" /* isPrimitive */])(error)
                    ? _this._eventFromIncompleteOnError(data.msg, data.url, data.line, data.column)
                    : _this._enhanceEventWithInitialFrame(Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["c" /* eventFromUnknownInput */])(error, undefined, {
                        attachStacktrace: client && client.getOptions().attachStacktrace,
                        rejection: false,
                    }), data.url, data.line, data.column);
                Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["e" /* addExceptionMechanism */])(event, {
                    handled: false,
                    type: 'onerror',
                });
                currentHub.captureEvent(event, {
                    originalException: error,
                });
            },
            type: 'error',
        });
        this._onErrorHandlerInstalled = true;
    };
    /** JSDoc */
    GlobalHandlers.prototype._installGlobalOnUnhandledRejectionHandler = function () {
        var _this = this;
        if (this._onUnhandledRejectionHandlerInstalled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            callback: function (e) {
                var error = e;
                // dig the object of the rejection out of known event types
                try {
                    // PromiseRejectionEvents store the object of the rejection under 'reason'
                    // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
                    if ('reason' in e) {
                        error = e.reason;
                    }
                    // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
                    // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
                    // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
                    // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
                    // https://github.com/getsentry/sentry-javascript/issues/2380
                    else if ('detail' in e && 'reason' in e.detail) {
                        error = e.detail.reason;
                    }
                }
                catch (_oO) {
                    // no-empty
                }
                var currentHub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* getCurrentHub */])();
                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
                if (!hasIntegration || Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* shouldIgnoreOnError */])() || isFailedOwnDelivery) {
                    return true;
                }
                var client = currentHub.getClient();
                var event = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["B" /* isPrimitive */])(error)
                    ? _this._eventFromIncompleteRejection(error)
                    : Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["c" /* eventFromUnknownInput */])(error, undefined, {
                        attachStacktrace: client && client.getOptions().attachStacktrace,
                        rejection: true,
                    });
                event.level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["b" /* Severity */].Error;
                Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["e" /* addExceptionMechanism */])(event, {
                    handled: false,
                    type: 'onunhandledrejection',
                });
                currentHub.captureEvent(event, {
                    originalException: error,
                });
                return;
            },
            type: 'unhandledrejection',
        });
        this._onUnhandledRejectionHandlerInstalled = true;
    };
    /**
     * This function creates a stack from an old, error-less onerror handler.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GlobalHandlers.prototype._eventFromIncompleteOnError = function (msg, url, line, column) {
        var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
        // If 'message' is ErrorEvent, get real message from inside
        var message = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["v" /* isErrorEvent */])(msg) ? msg.message : msg;
        var name;
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["C" /* isString */])(message)) {
            var groups = message.match(ERROR_TYPES_RE);
            if (groups) {
                name = groups[1];
                message = groups[2];
            }
        }
        var event = {
            exception: {
                values: [
                    {
                        type: name || 'Error',
                        value: message,
                    },
                ],
            },
        };
        return this._enhanceEventWithInitialFrame(event, url, line, column);
    };
    /**
     * This function creates an Event from an TraceKitStackTrace that has part of it missing.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GlobalHandlers.prototype._eventFromIncompleteRejection = function (error) {
        return {
            exception: {
                values: [
                    {
                        type: 'UnhandledRejection',
                        value: "Non-Error promise rejection captured with value: " + error,
                    },
                ],
            },
        };
    };
    /** JSDoc */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GlobalHandlers.prototype._enhanceEventWithInitialFrame = function (event, url, line, column) {
        event.exception = event.exception || {};
        event.exception.values = event.exception.values || [];
        event.exception.values[0] = event.exception.values[0] || {};
        event.exception.values[0].stacktrace = event.exception.values[0].stacktrace || {};
        event.exception.values[0].stacktrace.frames = event.exception.values[0].stacktrace.frames || [];
        var colno = isNaN(parseInt(column, 10)) ? undefined : column;
        var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
        var filename = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["C" /* isString */])(url) && url.length > 0 ? url : Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["q" /* getLocationHref */])();
        if (event.exception.values[0].stacktrace.frames.length === 0) {
            event.exception.values[0].stacktrace.frames.push({
                colno: colno,
                filename: filename,
                function: '?',
                in_app: true,
                lineno: lineno,
            });
        }
        return event;
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}());

//# sourceMappingURL=globalhandlers.js.map

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TryCatch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(41);



var DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload',
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */
var TryCatch = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function TryCatch(options) {
        /**
         * @inheritDoc
         */
        this.name = TryCatch.id;
        this._options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */
    TryCatch.prototype.setupOnce = function () {
        var global = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["p" /* getGlobalObject */])();
        if (this._options.setTimeout) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* fill */])(global, 'setTimeout', this._wrapTimeFunction.bind(this));
        }
        if (this._options.setInterval) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* fill */])(global, 'setInterval', this._wrapTimeFunction.bind(this));
        }
        if (this._options.requestAnimationFrame) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* fill */])(global, 'requestAnimationFrame', this._wrapRAF.bind(this));
        }
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* fill */])(XMLHttpRequest.prototype, 'send', this._wrapXHR.bind(this));
        }
        if (this._options.eventTarget) {
            var eventTarget = Array.isArray(this._options.eventTarget) ? this._options.eventTarget : DEFAULT_EVENT_TARGET;
            eventTarget.forEach(this._wrapEventTarget.bind(this));
        }
    };
    /** JSDoc */
    TryCatch.prototype._wrapTimeFunction = function (original) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var originalCallback = args[0];
            args[0] = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* wrap */])(originalCallback, {
                mechanism: {
                    data: { function: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["o" /* getFunctionName */])(original) },
                    handled: true,
                    type: 'instrument',
                },
            });
            return original.apply(this, args);
        };
    };
    /** JSDoc */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    TryCatch.prototype._wrapRAF = function (original) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function (callback) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return original.call(this, Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* wrap */])(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["o" /* getFunctionName */])(original),
                    },
                    handled: true,
                    type: 'instrument',
                },
            }));
        };
    };
    /** JSDoc */
    TryCatch.prototype._wrapEventTarget = function (target) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var global = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["p" /* getGlobalObject */])();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = global[target] && global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* fill */])(proto, 'addEventListener', function (original) {
            return function (eventName, fn, options) {
                try {
                    if (typeof fn.handleEvent === 'function') {
                        fn.handleEvent = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* wrap */])(fn.handleEvent.bind(fn), {
                            mechanism: {
                                data: {
                                    function: 'handleEvent',
                                    handler: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["o" /* getFunctionName */])(fn),
                                    target: target,
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        });
                    }
                }
                catch (err) {
                    // can sometimes get 'Permission denied to access property "handle Event'
                }
                return original.call(this, eventName, 
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* wrap */])(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["o" /* getFunctionName */])(fn),
                            target: target,
                        },
                        handled: true,
                        type: 'instrument',
                    },
                }), options);
            };
        });
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* fill */])(proto, 'removeEventListener', function (original) {
            return function (eventName, fn, options) {
                /**
                 * There are 2 possible scenarios here:
                 *
                 * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
                 * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
                 * as a pass-through, and call original `removeEventListener` with it.
                 *
                 * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
                 * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
                 * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
                 * in order for us to make a distinction between wrapped/non-wrapped functions possible.
                 * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
                 *
                 * When someone adds a handler prior to initialization, and then do it again, but after,
                 * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
                 * to get rid of the initial handler and it'd stick there forever.
                 */
                try {
                    original.call(this, eventName, fn.__sentry_wrapped__, options);
                }
                catch (e) {
                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return original.call(this, eventName, fn, options);
            };
        });
    };
    /** JSDoc */
    TryCatch.prototype._wrapXHR = function (originalSend) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
            xmlHttpRequestProps.forEach(function (prop) {
                if (prop in xhr && typeof xhr[prop] === 'function') {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* fill */])(xhr, prop, function (original) {
                        var wrapOptions = {
                            mechanism: {
                                data: {
                                    function: prop,
                                    handler: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["o" /* getFunctionName */])(original),
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        };
                        // If Instrument integration has been called before TryCatch, get the name of original function
                        if (original.__sentry_original__) {
                            wrapOptions.mechanism.data.handler = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["o" /* getFunctionName */])(original.__sentry_original__);
                        }
                        // Otherwise wrap directly
                        return Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* wrap */])(original, wrapOptions);
                    });
                }
            });
            return originalSend.apply(this, args);
        };
    };
    /**
     * @inheritDoc
     */
    TryCatch.id = 'TryCatch';
    return TryCatch;
}());

//# sourceMappingURL=trycatch.js.map

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Breadcrumbs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(2);

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable max-lines */



/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
var Breadcrumbs = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */
        this.name = Breadcrumbs.id;
        this._options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */
    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
        if (!this._options.sentry) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* getCurrentHub */])().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["n" /* getEventDescription */])(event),
        }, {
            event: event,
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */
    Breadcrumbs.prototype.setupOnce = function () {
        var _this = this;
        if (this._options.console) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._consoleBreadcrumb.apply(_this, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])(args));
                },
                type: 'console',
            });
        }
        if (this._options.dom) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._domBreadcrumb.apply(_this, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])(args));
                },
                type: 'dom',
            });
        }
        if (this._options.xhr) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._xhrBreadcrumb.apply(_this, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])(args));
                },
                type: 'xhr',
            });
        }
        if (this._options.fetch) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._fetchBreadcrumb.apply(_this, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])(args));
                },
                type: 'fetch',
            });
        }
        if (this._options.history) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._historyBreadcrumb.apply(_this, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])(args));
                },
                type: 'history',
            });
        }
    };
    /**
     * Creates breadcrumbs from console API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._consoleBreadcrumb = function (handlerData) {
        var breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console',
            },
            level: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["b" /* Severity */].fromString(handlerData.level),
            message: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["K" /* safeJoin */])(handlerData.args, ' '),
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = "Assertion failed: " + (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["K" /* safeJoin */])(handlerData.args.slice(1), ' ') || 'console.assert');
                breadcrumb.data.arguments = handlerData.args.slice(1);
            }
            else {
                // Don't capture a breadcrumb for passed assertions
                return;
            }
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* getCurrentHub */])().addBreadcrumb(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level,
        });
    };
    /**
     * Creates breadcrumbs from DOM API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._domBreadcrumb = function (handlerData) {
        var target;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target
                ? Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["r" /* htmlTreeAsString */])(handlerData.event.target)
                : Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["r" /* htmlTreeAsString */])(handlerData.event);
        }
        catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* getCurrentHub */])().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target,
        }, {
            event: handlerData.event,
            name: handlerData.name,
        });
    };
    /**
     * Creates breadcrumbs from XHR API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._xhrBreadcrumb = function (handlerData) {
        if (handlerData.endTimestamp) {
            // We only capture complete, non-sentry requests
            if (handlerData.xhr.__sentry_own_request__) {
                return;
            }
            var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* getCurrentHub */])().addBreadcrumb({
                category: 'xhr',
                data: {
                    method: method,
                    url: url,
                    status_code: status_code,
                },
                type: 'http',
            }, {
                xhr: handlerData.xhr,
                input: body,
            });
            return;
        }
    };
    /**
     * Creates breadcrumbs from fetch API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._fetchBreadcrumb = function (handlerData) {
        // We only capture complete fetch requests
        if (!handlerData.endTimestamp) {
            return;
        }
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
            // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
            return;
        }
        if (handlerData.error) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* getCurrentHub */])().addBreadcrumb({
                category: 'fetch',
                data: handlerData.fetchData,
                level: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["b" /* Severity */].Error,
                type: 'http',
            }, {
                data: handlerData.error,
                input: handlerData.args,
            });
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* getCurrentHub */])().addBreadcrumb({
                category: 'fetch',
                data: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, handlerData.fetchData), { status_code: handlerData.response.status }),
                type: 'http',
            }, {
                input: handlerData.args,
                response: handlerData.response,
            });
        }
    };
    /**
     * Creates breadcrumbs from history API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._historyBreadcrumb = function (handlerData) {
        var global = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["p" /* getGlobalObject */])();
        var from = handlerData.from;
        var to = handlerData.to;
        var parsedLoc = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["I" /* parseUrl */])(global.location.href);
        var parsedFrom = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["I" /* parseUrl */])(from);
        var parsedTo = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["I" /* parseUrl */])(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom.path) {
            parsedFrom = parsedLoc;
        }
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
            to = parsedTo.relative;
        }
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
            from = parsedFrom.relative;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* getCurrentHub */])().addBreadcrumb({
            category: 'navigation',
            data: {
                from: from,
                to: to,
            },
        });
    };
    /**
     * @inheritDoc
     */
    Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}());

//# sourceMappingURL=breadcrumbs.js.map

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkedErrors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracekit__ = __webpack_require__(82);





var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */
var LinkedErrors = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function LinkedErrors(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["e" /* addGlobalEventProcessor */])(function (event, hint) {
            var self = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* getCurrentHub */])().getIntegration(LinkedErrors);
            if (self) {
                return self._handler(event, hint);
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._handler = function (event, hint) {
        if (!event.exception || !event.exception.values || !hint || !Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["x" /* isInstanceOf */])(hint.originalException, Error)) {
            return event;
        }
        var linkedErrors = this._walkErrorTree(hint.originalException, this._key);
        event.exception.values = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])(linkedErrors, event.exception.values);
        return event;
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._walkErrorTree = function (error, key, stack) {
        if (stack === void 0) { stack = []; }
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["x" /* isInstanceOf */])(error[key], Error) || stack.length + 1 >= this._limit) {
            return stack;
        }
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_4__tracekit__["a" /* computeStackTrace */])(error[key]);
        var exception = Object(__WEBPACK_IMPORTED_MODULE_3__parsers__["c" /* exceptionFromStacktrace */])(stacktrace);
        return this._walkErrorTree(error[key], key, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([exception], stack));
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}());

//# sourceMappingURL=linkederrors.js.map

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserAgent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(2);



var global = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["p" /* getGlobalObject */])();
/** UserAgent */
var UserAgent = /** @class */ (function () {
    function UserAgent() {
        /**
         * @inheritDoc
         */
        this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */
    UserAgent.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["e" /* addGlobalEventProcessor */])(function (event) {
            var _a, _b, _c;
            if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* getCurrentHub */])().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!global.navigator && !global.location && !global.document) {
                    return event;
                }
                // grab as much info as exists and add it to the event
                var url = ((_a = event.request) === null || _a === void 0 ? void 0 : _a.url) || ((_b = global.location) === null || _b === void 0 ? void 0 : _b.href);
                var referrer = (global.document || {}).referrer;
                var userAgent = (global.navigator || {}).userAgent;
                var headers = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (_c = event.request) === null || _c === void 0 ? void 0 : _c.headers), (referrer && { Referer: referrer })), (userAgent && { 'User-Agent': userAgent }));
                var request = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (url && { url: url })), { headers: headers });
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event), { request: request });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    UserAgent.id = 'UserAgent';
    return UserAgent;
}());

//# sourceMappingURL=useragent.js.map

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultIntegrations */
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* unused harmony export showReportDialog */
/* harmony export (immutable) */ __webpack_exports__["b"] = lastEventId;
/* unused harmony export forceLoad */
/* unused harmony export onLoad */
/* unused harmony export flush */
/* unused harmony export close */
/* unused harmony export wrap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__client__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__integrations__ = __webpack_require__(84);





var defaultIntegrations = [
    new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["d" /* Integrations */].InboundFilters(),
    new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["d" /* Integrations */].FunctionToString(),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["TryCatch"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["Breadcrumbs"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["GlobalHandlers"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["LinkedErrors"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["UserAgent"](),
];
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options) {
    if (options === void 0) { options = {}; }
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = defaultIntegrations;
    }
    if (options.release === undefined) {
        var window_1 = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["p" /* getGlobalObject */])();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
            options.release = window_1.SENTRY_RELEASE.id;
        }
    }
    if (options.autoSessionTracking === undefined) {
        options.autoSessionTracking = false;
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["j" /* initAndBind */])(__WEBPACK_IMPORTED_MODULE_2__client__["a" /* BrowserClient */], options);
    if (options.autoSessionTracking) {
        startSessionTracking();
    }
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!options.eventId) {
        options.eventId = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["i" /* getCurrentHub */])().lastEventId();
    }
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["i" /* getCurrentHub */])().getClient();
    if (client) {
        client.showReportDialog(options);
    }
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["i" /* getCurrentHub */])().lastEventId();
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
    // Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
    callback();
}
/**
 * A promise that resolves when all current events have been sent.
 * If you provide a timeout and the queue takes longer to drain the promise returns false.
 *
 * @param timeout Maximum time in ms the client should wait.
 */
function flush(timeout) {
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["i" /* getCurrentHub */])().getClient();
    if (client) {
        return client.flush(timeout);
    }
    return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].reject(false);
}
/**
 * A promise that resolves when all current events have been sent.
 * If you provide a timeout and the queue takes longer to drain the promise returns false.
 *
 * @param timeout Maximum time in ms the client should wait.
 */
function close(timeout) {
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["i" /* getCurrentHub */])().getClient();
    if (client) {
        return client.close(timeout);
    }
    return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].reject(false);
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrap(fn) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["c" /* wrap */])(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
    var window = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["p" /* getGlobalObject */])();
    var hub = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["i" /* getCurrentHub */])();
    /**
     * We should be using `Promise.all([windowLoaded, firstContentfulPaint])` here,
     * but, as always, it's not available in the IE10-11. Thanks IE.
     */
    var loadResolved = document.readyState === 'complete';
    var fcpResolved = false;
    var possiblyEndSession = function () {
        if (fcpResolved && loadResolved) {
            hub.endSession();
        }
    };
    var resolveWindowLoaded = function () {
        loadResolved = true;
        possiblyEndSession();
        window.removeEventListener('load', resolveWindowLoaded);
    };
    hub.startSession();
    if (!loadResolved) {
        // IE doesn't support `{ once: true }` for event listeners, so we have to manually
        // attach and then detach it once completed.
        window.addEventListener('load', resolveWindowLoaded);
    }
    try {
        var po = new PerformanceObserver(function (entryList, po) {
            entryList.getEntries().forEach(function (entry) {
                if (entry.name === 'first-contentful-paint' && entry.startTime < firstHiddenTime_1) {
                    po.disconnect();
                    fcpResolved = true;
                    possiblyEndSession();
                }
            });
        });
        // There's no need to even attach this listener if `PerformanceObserver` constructor will fail,
        // so we do it below here.
        var firstHiddenTime_1 = document.visibilityState === 'hidden' ? 0 : Infinity;
        document.addEventListener('visibilitychange', function (event) {
            firstHiddenTime_1 = Math.min(firstHiddenTime_1, event.timeStamp);
        }, { once: true });
        po.observe({
            type: 'paint',
            buffered: true,
        });
    }
    catch (e) {
        fcpResolved = true;
        possiblyEndSession();
    }
}
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular__ = __webpack_require__(296);
/* unused harmony reexport Angular */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__captureconsole__ = __webpack_require__(297);
/* unused harmony reexport CaptureConsole */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__debug__ = __webpack_require__(298);
/* unused harmony reexport Debug */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dedupe__ = __webpack_require__(299);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__dedupe__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ember__ = __webpack_require__(300);
/* unused harmony reexport Ember */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__extraerrordata__ = __webpack_require__(301);
/* unused harmony reexport ExtraErrorData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__offline__ = __webpack_require__(302);
/* unused harmony reexport Offline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reportingobserver__ = __webpack_require__(304);
/* unused harmony reexport ReportingObserver */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rewriteframes__ = __webpack_require__(305);
/* unused harmony reexport RewriteFrames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sessiontiming__ = __webpack_require__(306);
/* unused harmony reexport SessionTiming */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__transaction__ = __webpack_require__(307);
/* unused harmony reexport Transaction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vue__ = __webpack_require__(308);
/* unused harmony reexport Vue */












//# sourceMappingURL=index.js.map

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Angular */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);


// See https://github.com/angular/angular.js/blob/v1.4.7/src/minErr.js
var angularPattern = /^\[((?:[$a-zA-Z0-9]+:)?(?:[$a-zA-Z0-9]+))\] (.*?)\n?(\S+)$/;
/**
 * AngularJS integration
 *
 * Provides an $exceptionHandler for AngularJS
 */
var Angular = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function Angular(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = Angular.id;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        this._angular = options.angular || Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["p" /* getGlobalObject */])().angular;
        if (!this._angular) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* logger */].error('AngularIntegration is missing an Angular instance');
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        this._module = this._angular.module(Angular.moduleName, []);
    }
    /**
     * @inheritDoc
     */
    Angular.prototype.setupOnce = function (_, getCurrentHub) {
        var _this = this;
        if (!this._module) {
            return;
        }
        this._getCurrentHub = getCurrentHub;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        this._module.config([
            '$provide',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function ($provide) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                $provide.decorator('$exceptionHandler', ['$delegate', _this._$exceptionHandlerDecorator.bind(_this)]);
            },
        ]);
    };
    /**
     * Angular's exceptionHandler for Sentry integration
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Angular.prototype._$exceptionHandlerDecorator = function ($delegate) {
        var _this = this;
        return function (exception, cause) {
            var hub = _this._getCurrentHub && _this._getCurrentHub();
            if (hub && hub.getIntegration(Angular)) {
                hub.withScope(function (scope) {
                    if (cause) {
                        scope.setExtra('cause', cause);
                    }
                    scope.addEventProcessor(function (event) {
                        var ex = event.exception && event.exception.values && event.exception.values[0];
                        if (ex) {
                            var matches = angularPattern.exec(ex.value || '');
                            if (matches) {
                                // This type now becomes something like: $rootScope:inprog
                                ex.type = matches[1];
                                ex.value = matches[2];
                                event.message = ex.type + ": " + ex.value;
                                // auto set a new tag specifically for the angular error url
                                event.extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event.extra), { angularDocs: matches[3].substr(0, 250) });
                            }
                        }
                        return event;
                    });
                    hub.captureException(exception);
                });
            }
            $delegate(exception, cause);
        };
    };
    /**
     * @inheritDoc
     */
    Angular.id = 'AngularJS';
    /**
     * moduleName used in Angular's DI resolution algorithm
     */
    Angular.moduleName = 'ngSentry';
    return Angular;
}());

//# sourceMappingURL=angular.js.map

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CaptureConsole */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);


var global = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["p" /* getGlobalObject */])();
/** Send Console API calls as Sentry Events */
var CaptureConsole = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function CaptureConsole(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = CaptureConsole.id;
        /**
         * @inheritDoc
         */
        this._levels = ['log', 'info', 'warn', 'error', 'debug', 'assert'];
        if (options.levels) {
            this._levels = options.levels;
        }
    }
    /**
     * @inheritDoc
     */
    CaptureConsole.prototype.setupOnce = function (_, getCurrentHub) {
        if (!('console' in global)) {
            return;
        }
        this._levels.forEach(function (level) {
            if (!(level in global.console)) {
                return;
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* fill */])(global.console, level, function (originalConsoleLevel) { return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var hub = getCurrentHub();
                if (hub.getIntegration(CaptureConsole)) {
                    hub.withScope(function (scope) {
                        scope.setLevel(__WEBPACK_IMPORTED_MODULE_0__sentry_types__["b" /* Severity */].fromString(level));
                        scope.setExtra('arguments', args);
                        scope.addEventProcessor(function (event) {
                            event.logger = 'console';
                            return event;
                        });
                        var message = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["K" /* safeJoin */])(args, ' ');
                        if (level === 'assert') {
                            if (args[0] === false) {
                                message = "Assertion failed: " + (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["K" /* safeJoin */])(args.slice(1), ' ') || 'console.assert');
                                scope.setExtra('arguments', args.slice(1));
                                hub.captureMessage(message);
                            }
                        }
                        else {
                            hub.captureMessage(message);
                        }
                    });
                }
                // this fails for some browsers. :(
                if (originalConsoleLevel) {
                    Function.prototype.apply.call(originalConsoleLevel, global.console, args);
                }
            }; });
        });
    };
    /**
     * @inheritDoc
     */
    CaptureConsole.id = 'CaptureConsole';
    return CaptureConsole;
}());

//# sourceMappingURL=captureconsole.js.map

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Debug */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);


/** JSDoc */
var Debug = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Debug(options) {
        /**
         * @inheritDoc
         */
        this.name = Debug.id;
        this._options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ debugger: false, stringify: false }, options);
    }
    /**
     * @inheritDoc
     */
    Debug.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (event, hint) {
            var self = getCurrentHub().getIntegration(Debug);
            if (self) {
                if (self._options.debugger) {
                    // eslint-disable-next-line no-debugger
                    debugger;
                }
                /* eslint-disable no-console */
                Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["i" /* consoleSandbox */])(function () {
                    if (self._options.stringify) {
                        console.log(JSON.stringify(event, null, 2));
                        if (hint) {
                            console.log(JSON.stringify(hint, null, 2));
                        }
                    }
                    else {
                        console.log(event);
                        if (hint) {
                            console.log(hint);
                        }
                    }
                });
                /* eslint-enable no-console */
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    Debug.id = 'Debug';
    return Debug;
}());

//# sourceMappingURL=debug.js.map

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dedupe; });
/** Deduplication filter */
var Dedupe = /** @class */ (function () {
    function Dedupe() {
        /**
         * @inheritDoc
         */
        this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */
    Dedupe.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if (self._shouldDropEvent(currentEvent, self._previousEvent)) {
                        return null;
                    }
                }
                catch (_oO) {
                    return (self._previousEvent = currentEvent);
                }
                return (self._previousEvent = currentEvent);
            }
            return currentEvent;
        });
    };
    /** JSDoc */
    Dedupe.prototype._shouldDropEvent = function (currentEvent, previousEvent) {
        if (!previousEvent) {
            return false;
        }
        if (this._isSameMessageEvent(currentEvent, previousEvent)) {
            return true;
        }
        if (this._isSameExceptionEvent(currentEvent, previousEvent)) {
            return true;
        }
        return false;
    };
    /** JSDoc */
    Dedupe.prototype._isSameMessageEvent = function (currentEvent, previousEvent) {
        var currentMessage = currentEvent.message;
        var previousMessage = previousEvent.message;
        // If neither event has a message property, they were both exceptions, so bail out
        if (!currentMessage && !previousMessage) {
            return false;
        }
        // If only one event has a stacktrace, but not the other one, they are not the same
        if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
            return false;
        }
        if (currentMessage !== previousMessage) {
            return false;
        }
        if (!this._isSameFingerprint(currentEvent, previousEvent)) {
            return false;
        }
        if (!this._isSameStacktrace(currentEvent, previousEvent)) {
            return false;
        }
        return true;
    };
    /** JSDoc */
    Dedupe.prototype._getFramesFromEvent = function (event) {
        var exception = event.exception;
        if (exception) {
            try {
                // @ts-ignore Object could be undefined
                return exception.values[0].stacktrace.frames;
            }
            catch (_oO) {
                return undefined;
            }
        }
        else if (event.stacktrace) {
            return event.stacktrace.frames;
        }
        return undefined;
    };
    /** JSDoc */
    Dedupe.prototype._isSameStacktrace = function (currentEvent, previousEvent) {
        var currentFrames = this._getFramesFromEvent(currentEvent);
        var previousFrames = this._getFramesFromEvent(previousEvent);
        // If neither event has a stacktrace, they are assumed to be the same
        if (!currentFrames && !previousFrames) {
            return true;
        }
        // If only one event has a stacktrace, but not the other one, they are not the same
        if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
            return false;
        }
        currentFrames = currentFrames;
        previousFrames = previousFrames;
        // If number of frames differ, they are not the same
        if (previousFrames.length !== currentFrames.length) {
            return false;
        }
        // Otherwise, compare the two
        for (var i = 0; i < previousFrames.length; i++) {
            var frameA = previousFrames[i];
            var frameB = currentFrames[i];
            if (frameA.filename !== frameB.filename ||
                frameA.lineno !== frameB.lineno ||
                frameA.colno !== frameB.colno ||
                frameA.function !== frameB.function) {
                return false;
            }
        }
        return true;
    };
    /** JSDoc */
    Dedupe.prototype._getExceptionFromEvent = function (event) {
        return event.exception && event.exception.values && event.exception.values[0];
    };
    /** JSDoc */
    Dedupe.prototype._isSameExceptionEvent = function (currentEvent, previousEvent) {
        var previousException = this._getExceptionFromEvent(previousEvent);
        var currentException = this._getExceptionFromEvent(currentEvent);
        if (!previousException || !currentException) {
            return false;
        }
        if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
            return false;
        }
        if (!this._isSameFingerprint(currentEvent, previousEvent)) {
            return false;
        }
        if (!this._isSameStacktrace(currentEvent, previousEvent)) {
            return false;
        }
        return true;
    };
    /** JSDoc */
    Dedupe.prototype._isSameFingerprint = function (currentEvent, previousEvent) {
        var currentFingerprint = currentEvent.fingerprint;
        var previousFingerprint = previousEvent.fingerprint;
        // If neither event has a fingerprint, they are assumed to be the same
        if (!currentFingerprint && !previousFingerprint) {
            return true;
        }
        // If only one event has a fingerprint, but not the other one, they are not the same
        if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
            return false;
        }
        currentFingerprint = currentFingerprint;
        previousFingerprint = previousFingerprint;
        // Otherwise, compare the two
        try {
            return !!(currentFingerprint.join('') === previousFingerprint.join(''));
        }
        catch (_oO) {
            return false;
        }
    };
    /**
     * @inheritDoc
     */
    Dedupe.id = 'Dedupe';
    return Dedupe;
}());

//# sourceMappingURL=dedupe.js.map

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Ember */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(2);

/** JSDoc */
var Ember = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function Ember(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = Ember.id;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        this._Ember = options.Ember || Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["p" /* getGlobalObject */])().Ember;
    }
    /**
     * @inheritDoc
     */
    Ember.prototype.setupOnce = function (_, getCurrentHub) {
        var _this = this;
        if (!this._Ember) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["E" /* logger */].error('EmberIntegration is missing an Ember instance');
            return;
        }
        /* eslint-disable @typescript-eslint/no-unsafe-member-access */
        var oldOnError = this._Ember.onerror;
        this._Ember.onerror = function (error) {
            if (getCurrentHub().getIntegration(Ember)) {
                getCurrentHub().captureException(error, { originalException: error });
            }
            if (typeof oldOnError === 'function') {
                oldOnError.call(_this._Ember, error);
            }
            else if (_this._Ember.testing) {
                throw error;
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this._Ember.RSVP.on('error', function (reason) {
            if (getCurrentHub().getIntegration(Ember)) {
                getCurrentHub().withScope(function (scope) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["x" /* isInstanceOf */])(reason, Error)) {
                        scope.setExtra('context', 'Unhandled Promise error detected');
                        getCurrentHub().captureException(reason, { originalException: reason });
                    }
                    else {
                        scope.setExtra('reason', reason);
                        getCurrentHub().captureMessage('Unhandled Promise error detected');
                    }
                });
            }
        });
    };
    /**
     * @inheritDoc
     */
    Ember.id = 'Ember';
    return Ember;
}());

//# sourceMappingURL=ember.js.map

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ExtraErrorData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);


/** Patch toString calls to return proper name for wrapped functions */
var ExtraErrorData = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function ExtraErrorData(_options) {
        if (_options === void 0) { _options = { depth: 3 }; }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = ExtraErrorData.id;
    }
    /**
     * @inheritDoc
     */
    ExtraErrorData.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (event, hint) {
            var self = getCurrentHub().getIntegration(ExtraErrorData);
            if (!self) {
                return event;
            }
            return self.enhanceEventWithErrorData(event, hint);
        });
    };
    /**
     * Attaches extracted information from the Error object to extra field in the Event
     */
    ExtraErrorData.prototype.enhanceEventWithErrorData = function (event, hint) {
        var _a;
        if (!hint || !hint.originalException || !Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* isError */])(hint.originalException)) {
            return event;
        }
        var name = hint.originalException.name || hint.originalException.constructor.name;
        var errorData = this._extractErrorData(hint.originalException);
        if (errorData) {
            var contexts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event.contexts);
            var normalizedErrorData = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["F" /* normalize */])(errorData, this._options.depth);
            if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["A" /* isPlainObject */])(normalizedErrorData)) {
                contexts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event.contexts), (_a = {}, _a[name] = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, normalizedErrorData), _a));
            }
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event), { contexts: contexts });
        }
        return event;
    };
    /**
     * Extract extra information from the Error object
     */
    ExtraErrorData.prototype._extractErrorData = function (error) {
        var e_1, _a;
        var result = null;
        // We are trying to enhance already existing event, so no harm done if it won't succeed
        try {
            var nativeKeys_1 = ['name', 'message', 'stack', 'line', 'column', 'fileName', 'lineNumber', 'columnNumber'];
            var errorKeys = Object.getOwnPropertyNames(error).filter(function (key) { return nativeKeys_1.indexOf(key) === -1; });
            if (errorKeys.length) {
                var extraErrorInfo = {};
                try {
                    for (var errorKeys_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __values */])(errorKeys), errorKeys_1_1 = errorKeys_1.next(); !errorKeys_1_1.done; errorKeys_1_1 = errorKeys_1.next()) {
                        var key = errorKeys_1_1.value;
                        var value = error[key];
                        if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* isError */])(value)) {
                            value = value.toString();
                        }
                        extraErrorInfo[key] = value;
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (errorKeys_1_1 && !errorKeys_1_1.done && (_a = errorKeys_1.return)) _a.call(errorKeys_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                result = extraErrorInfo;
            }
        }
        catch (oO) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* logger */].error('Unable to extract extra data from the Error object:', oO);
        }
        return result;
    };
    /**
     * @inheritDoc
     */
    ExtraErrorData.id = 'ExtraErrorData';
    return ExtraErrorData;
}());

//# sourceMappingURL=extraerrordata.js.map

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Offline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);


// eslint-disable-next-line @typescript-eslint/no-var-requires
var localForage = __webpack_require__(303);
/**
 * cache offline errors and send when connected
 */
var Offline = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Offline(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = Offline.id;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.global = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["p" /* getGlobalObject */])();
        this.maxStoredEvents = options.maxStoredEvents || 30; // set a reasonable default
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        this.offlineEventStore = localForage.createInstance({
            name: 'sentry/offlineEventStore',
        });
    }
    /**
     * @inheritDoc
     */
    Offline.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        var _this = this;
        this.hub = getCurrentHub();
        if ('addEventListener' in this.global) {
            this.global.addEventListener('online', function () {
                _this._sendEvents().catch(function () {
                    __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* logger */].warn('could not send cached events');
                });
            });
        }
        addGlobalEventProcessor(function (event) {
            if (_this.hub && _this.hub.getIntegration(Offline)) {
                // cache if we are positively offline
                if ('navigator' in _this.global && 'onLine' in _this.global.navigator && !_this.global.navigator.onLine) {
                    _this._cacheEvent(event)
                        .then(function (_event) { return _this._enforceMaxEvents(); })
                        .catch(function (_error) {
                        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* logger */].warn('could not cache event while offline');
                    });
                    // return null on success or failure, because being offline will still result in an error
                    return null;
                }
            }
            return event;
        });
        // if online now, send any events stored in a previous offline session
        if ('navigator' in this.global && 'onLine' in this.global.navigator && this.global.navigator.onLine) {
            this._sendEvents().catch(function () {
                __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* logger */].warn('could not send cached events');
            });
        }
    };
    /**
     * cache an event to send later
     * @param event an event
     */
    Offline.prototype._cacheEvent = function (event) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, this.offlineEventStore.setItem(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["R" /* uuid4 */])(), event)];
            });
        });
    };
    /**
     * purge excess events if necessary
     */
    Offline.prototype._enforceMaxEvents = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var events;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
                events = [];
                return [2 /*return*/, this.offlineEventStore
                        .iterate(function (event, cacheKey, _index) {
                        // aggregate events
                        events.push({ cacheKey: cacheKey, event: event });
                    })
                        .then(function () {
                        // this promise resolves when the iteration is finished
                        return _this._purgeEvents(
                        // purge all events past maxStoredEvents in reverse chronological order
                        events
                            .sort(function (a, b) { return (b.event.timestamp || 0) - (a.event.timestamp || 0); })
                            .slice(_this.maxStoredEvents < events.length ? _this.maxStoredEvents : events.length)
                            .map(function (event) { return event.cacheKey; }));
                    })
                        .catch(function (_error) {
                        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* logger */].warn('could not enforce max events');
                    })];
            });
        });
    };
    /**
     * purge event from cache
     */
    Offline.prototype._purgeEvent = function (cacheKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, this.offlineEventStore.removeItem(cacheKey)];
            });
        });
    };
    /**
     * purge events from cache
     */
    Offline.prototype._purgeEvents = function (cacheKeys) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
                // trail with .then to ensure the return type as void and not void|void[]
                return [2 /*return*/, Promise.all(cacheKeys.map(function (cacheKey) { return _this._purgeEvent(cacheKey); })).then()];
            });
        });
    };
    /**
     * send all events
     */
    Offline.prototype._sendEvents = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, this.offlineEventStore.iterate(function (event, cacheKey, _index) {
                        if (_this.hub) {
                            _this.hub.captureEvent(event);
                            _this._purgeEvent(cacheKey).catch(function (_error) {
                                __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* logger */].warn('could not purge event from cache');
                            });
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* logger */].warn('no hub found - could not send cached event');
                        }
                    })];
            });
        });
    };
    /**
     * @inheritDoc
     */
    Offline.id = 'Offline';
    return Offline;
}());

//# sourceMappingURL=offline.js.map

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;var require;/*!
    localForage -- Offline Storage, Improved
    Version 1.8.1
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/
(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.localforage = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw (f.code="MODULE_NOT_FOUND", f)}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
(function (global){
'use strict';
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(_dereq_,module,exports){
'use strict';
var immediate = _dereq_(1);

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

Promise.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

Promise.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

Promise.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

Promise.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}

},{"1":1}],3:[function(_dereq_,module,exports){
(function (global){
'use strict';
if (typeof global.Promise !== 'function') {
  global.Promise = _dereq_(2);
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"2":2}],4:[function(_dereq_,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getIDB() {
    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
    try {
        if (typeof indexedDB !== 'undefined') {
            return indexedDB;
        }
        if (typeof webkitIndexedDB !== 'undefined') {
            return webkitIndexedDB;
        }
        if (typeof mozIndexedDB !== 'undefined') {
            return mozIndexedDB;
        }
        if (typeof OIndexedDB !== 'undefined') {
            return OIndexedDB;
        }
        if (typeof msIndexedDB !== 'undefined') {
            return msIndexedDB;
        }
    } catch (e) {
        return;
    }
}

var idb = getIDB();

function isIndexedDBValid() {
    try {
        // Initialize IndexedDB; fall back to vendor-prefixed versions
        // if needed.
        if (!idb || !idb.open) {
            return false;
        }
        // We mimic PouchDB here;
        //
        // We test for openDatabase because IE Mobile identifies itself
        // as Safari. Oh the lulz...
        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);

        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;

        // Safari <10.1 does not meet our requirements for IDB support
        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
        // Safari 10.1 shipped with fetch, we can use that to detect it.
        // Note: this creates issues with `window.fetch` polyfills and
        // overrides; see:
        // https://github.com/localForage/localForage/issues/856
        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' &&
        // some outdated implementations of IDB that appear on Samsung
        // and HTC Android devices <4.4 are missing IDBKeyRange
        // See: https://github.com/mozilla/localForage/issues/128
        // See: https://github.com/mozilla/localForage/issues/272
        typeof IDBKeyRange !== 'undefined';
    } catch (e) {
        return false;
    }
}

// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
function createBlob(parts, properties) {
    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
    parts = parts || [];
    properties = properties || {};
    try {
        return new Blob(parts, properties);
    } catch (e) {
        if (e.name !== 'TypeError') {
            throw e;
        }
        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
        var builder = new Builder();
        for (var i = 0; i < parts.length; i += 1) {
            builder.append(parts[i]);
        }
        return builder.getBlob(properties.type);
    }
}

// This is CommonJS because lie is an external dependency, so Rollup
// can just ignore it.
if (typeof Promise === 'undefined') {
    // In the "nopromises" build this will just throw if you don't have
    // a global promise object, but it would throw anyway later.
    _dereq_(3);
}
var Promise$1 = Promise;

function executeCallback(promise, callback) {
    if (callback) {
        promise.then(function (result) {
            callback(null, result);
        }, function (error) {
            callback(error);
        });
    }
}

function executeTwoCallbacks(promise, callback, errorCallback) {
    if (typeof callback === 'function') {
        promise.then(callback);
    }

    if (typeof errorCallback === 'function') {
        promise["catch"](errorCallback);
    }
}

function normalizeKey(key) {
    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    return key;
}

function getCallback() {
    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
        return arguments[arguments.length - 1];
    }
}

// Some code originally from async_storage.js in
// [Gaia](https://github.com/mozilla-b2g/gaia).

var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
var supportsBlobs = void 0;
var dbContexts = {};
var toString = Object.prototype.toString;

// Transaction Modes
var READ_ONLY = 'readonly';
var READ_WRITE = 'readwrite';

// Transform a binary string to an array buffer, because otherwise
// weird stuff happens when you try to work with the binary string directly.
// It is known.
// From http://stackoverflow.com/questions/14967647/ (continues on next line)
// encode-decode-image-with-base64-breaks-image (2013-04-21)
function _binStringToArrayBuffer(bin) {
    var length = bin.length;
    var buf = new ArrayBuffer(length);
    var arr = new Uint8Array(buf);
    for (var i = 0; i < length; i++) {
        arr[i] = bin.charCodeAt(i);
    }
    return buf;
}

//
// Blobs are not supported in all versions of IndexedDB, notably
// Chrome <37 and Android <5. In those versions, storing a blob will throw.
//
// Various other blob bugs exist in Chrome v37-42 (inclusive).
// Detecting them is expensive and confusing to users, and Chrome 37-42
// is at very low usage worldwide, so we do a hacky userAgent check instead.
//
// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
//
// Code borrowed from PouchDB. See:
// https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
//
function _checkBlobSupportWithoutCaching(idb) {
    return new Promise$1(function (resolve) {
        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
        var blob = createBlob(['']);
        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');

        txn.onabort = function (e) {
            // If the transaction aborts now its due to not being able to
            // write to the database, likely due to the disk being full
            e.preventDefault();
            e.stopPropagation();
            resolve(false);
        };

        txn.oncomplete = function () {
            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
            var matchedEdge = navigator.userAgent.match(/Edge\//);
            // MS Edge pretends to be Chrome 42:
            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
        };
    })["catch"](function () {
        return false; // error, so assume unsupported
    });
}

function _checkBlobSupport(idb) {
    if (typeof supportsBlobs === 'boolean') {
        return Promise$1.resolve(supportsBlobs);
    }
    return _checkBlobSupportWithoutCaching(idb).then(function (value) {
        supportsBlobs = value;
        return supportsBlobs;
    });
}

function _deferReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Create a deferred object representing the current database operation.
    var deferredOperation = {};

    deferredOperation.promise = new Promise$1(function (resolve, reject) {
        deferredOperation.resolve = resolve;
        deferredOperation.reject = reject;
    });

    // Enqueue the deferred operation.
    dbContext.deferredOperations.push(deferredOperation);

    // Chain its promise to the database readiness.
    if (!dbContext.dbReady) {
        dbContext.dbReady = deferredOperation.promise;
    } else {
        dbContext.dbReady = dbContext.dbReady.then(function () {
            return deferredOperation.promise;
        });
    }
}

function _advanceReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Resolve its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.resolve();
        return deferredOperation.promise;
    }
}

function _rejectReadiness(dbInfo, err) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Reject its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.reject(err);
        return deferredOperation.promise;
    }
}

function _getConnection(dbInfo, upgradeNeeded) {
    return new Promise$1(function (resolve, reject) {
        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();

        if (dbInfo.db) {
            if (upgradeNeeded) {
                _deferReadiness(dbInfo);
                dbInfo.db.close();
            } else {
                return resolve(dbInfo.db);
            }
        }

        var dbArgs = [dbInfo.name];

        if (upgradeNeeded) {
            dbArgs.push(dbInfo.version);
        }

        var openreq = idb.open.apply(idb, dbArgs);

        if (upgradeNeeded) {
            openreq.onupgradeneeded = function (e) {
                var db = openreq.result;
                try {
                    db.createObjectStore(dbInfo.storeName);
                    if (e.oldVersion <= 1) {
                        // Added when support for blob shims was added
                        db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                    }
                } catch (ex) {
                    if (ex.name === 'ConstraintError') {
                        console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                    } else {
                        throw ex;
                    }
                }
            };
        }

        openreq.onerror = function (e) {
            e.preventDefault();
            reject(openreq.error);
        };

        openreq.onsuccess = function () {
            resolve(openreq.result);
            _advanceReadiness(dbInfo);
        };
    });
}

function _getOriginalConnection(dbInfo) {
    return _getConnection(dbInfo, false);
}

function _getUpgradedConnection(dbInfo) {
    return _getConnection(dbInfo, true);
}

function _isUpgradeNeeded(dbInfo, defaultVersion) {
    if (!dbInfo.db) {
        return true;
    }

    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
    var isDowngrade = dbInfo.version < dbInfo.db.version;
    var isUpgrade = dbInfo.version > dbInfo.db.version;

    if (isDowngrade) {
        // If the version is not the default one
        // then warn for impossible downgrade.
        if (dbInfo.version !== defaultVersion) {
            console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
        }
        // Align the versions to prevent errors.
        dbInfo.version = dbInfo.db.version;
    }

    if (isUpgrade || isNewStore) {
        // If the store is new then increment the version (if needed).
        // This will trigger an "upgradeneeded" event which is required
        // for creating a store.
        if (isNewStore) {
            var incVersion = dbInfo.db.version + 1;
            if (incVersion > dbInfo.version) {
                dbInfo.version = incVersion;
            }
        }

        return true;
    }

    return false;
}

// encode a blob for indexeddb engines that don't support blobs
function _encodeBlob(blob) {
    return new Promise$1(function (resolve, reject) {
        var reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = function (e) {
            var base64 = btoa(e.target.result || '');
            resolve({
                __local_forage_encoded_blob: true,
                data: base64,
                type: blob.type
            });
        };
        reader.readAsBinaryString(blob);
    });
}

// decode an encoded blob
function _decodeBlob(encodedBlob) {
    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
    return createBlob([arrayBuff], { type: encodedBlob.type });
}

// is this one of our fancy encoded blobs?
function _isEncodedBlob(value) {
    return value && value.__local_forage_encoded_blob;
}

// Specialize the default `ready()` function by making it dependent
// on the current database operations. Thus, the driver will be actually
// ready when it's been initialized (default) *and* there are no pending
// operations on the database (initiated by some other instances).
function _fullyReady(callback) {
    var self = this;

    var promise = self._initReady().then(function () {
        var dbContext = dbContexts[self._dbInfo.name];

        if (dbContext && dbContext.dbReady) {
            return dbContext.dbReady;
        }
    });

    executeTwoCallbacks(promise, callback, callback);
    return promise;
}

// Try to establish a new db connection to replace the
// current one which is broken (i.e. experiencing
// InvalidStateError while creating a transaction).
function _tryReconnect(dbInfo) {
    _deferReadiness(dbInfo);

    var dbContext = dbContexts[dbInfo.name];
    var forages = dbContext.forages;

    for (var i = 0; i < forages.length; i++) {
        var forage = forages[i];
        if (forage._dbInfo.db) {
            forage._dbInfo.db.close();
            forage._dbInfo.db = null;
        }
    }
    dbInfo.db = null;

    return _getOriginalConnection(dbInfo).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        // store the latest db reference
        // in case the db was upgraded
        dbInfo.db = dbContext.db = db;
        for (var i = 0; i < forages.length; i++) {
            forages[i]._dbInfo.db = db;
        }
    })["catch"](function (err) {
        _rejectReadiness(dbInfo, err);
        throw err;
    });
}

// FF doesn't like Promises (micro-tasks) and IDDB store operations,
// so we have to do it with callbacks
function createTransaction(dbInfo, mode, callback, retries) {
    if (retries === undefined) {
        retries = 1;
    }

    try {
        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
        callback(null, tx);
    } catch (err) {
        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) {
            return Promise$1.resolve().then(function () {
                if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                    // increase the db version, to create the new ObjectStore
                    if (dbInfo.db) {
                        dbInfo.version = dbInfo.db.version + 1;
                    }
                    // Reopen the database for upgrading.
                    return _getUpgradedConnection(dbInfo);
                }
            }).then(function () {
                return _tryReconnect(dbInfo).then(function () {
                    createTransaction(dbInfo, mode, callback, retries - 1);
                });
            })["catch"](callback);
        }

        callback(err);
    }
}

function createDbContext() {
    return {
        // Running localForages sharing a database.
        forages: [],
        // Shared database.
        db: null,
        // Database readiness (promise).
        dbReady: null,
        // Deferred operations on the database.
        deferredOperations: []
    };
}

// Open the IndexedDB database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    // Get the current context of the database;
    var dbContext = dbContexts[dbInfo.name];

    // ...or create a new context.
    if (!dbContext) {
        dbContext = createDbContext();
        // Register the new context in the global container.
        dbContexts[dbInfo.name] = dbContext;
    }

    // Register itself as a running localForage in the current context.
    dbContext.forages.push(self);

    // Replace the default `ready()` function with the specialized one.
    if (!self._initReady) {
        self._initReady = self.ready;
        self.ready = _fullyReady;
    }

    // Create an array of initialization states of the related localForages.
    var initPromises = [];

    function ignoreErrors() {
        // Don't handle errors here,
        // just makes sure related localForages aren't pending.
        return Promise$1.resolve();
    }

    for (var j = 0; j < dbContext.forages.length; j++) {
        var forage = dbContext.forages[j];
        if (forage !== self) {
            // Don't wait for itself...
            initPromises.push(forage._initReady()["catch"](ignoreErrors));
        }
    }

    // Take a snapshot of the related localForages.
    var forages = dbContext.forages.slice(0);

    // Initialize the connection process only when
    // all the related localForages aren't pending.
    return Promise$1.all(initPromises).then(function () {
        dbInfo.db = dbContext.db;
        // Get the connection or open a new one without upgrade.
        return _getOriginalConnection(dbInfo);
    }).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        dbInfo.db = dbContext.db = db;
        self._dbInfo = dbInfo;
        // Share the final connection amongst related localForages.
        for (var k = 0; k < forages.length; k++) {
            var forage = forages[k];
            if (forage !== self) {
                // Self is already up-to-date.
                forage._dbInfo.db = dbInfo.db;
                forage._dbInfo.version = dbInfo.version;
            }
        }
    });
}

function getItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.get(key);

                    req.onsuccess = function () {
                        var value = req.result;
                        if (value === undefined) {
                            value = null;
                        }
                        if (_isEncodedBlob(value)) {
                            value = _decodeBlob(value);
                        }
                        resolve(value);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items stored in database.
function iterate(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openCursor();
                    var iterationNumber = 1;

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (cursor) {
                            var value = cursor.value;
                            if (_isEncodedBlob(value)) {
                                value = _decodeBlob(value);
                            }
                            var result = iterator(value, cursor.key, iterationNumber++);

                            // when the iterator callback returns any
                            // (non-`undefined`) value, then we stop
                            // the iteration immediately
                            if (result !== void 0) {
                                resolve(result);
                            } else {
                                cursor["continue"]();
                            }
                        } else {
                            resolve();
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);

    return promise;
}

function setItem(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        var dbInfo;
        self.ready().then(function () {
            dbInfo = self._dbInfo;
            if (toString.call(value) === '[object Blob]') {
                return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
                    if (blobSupport) {
                        return value;
                    }
                    return _encodeBlob(value);
                });
            }
            return value;
        }).then(function (value) {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);

                    // The reason we don't _save_ null is because IE 10 does
                    // not support saving the `null` type in IndexedDB. How
                    // ironic, given the bug below!
                    // See: https://github.com/mozilla/localForage/issues/161
                    if (value === null) {
                        value = undefined;
                    }

                    var req = store.put(value, key);

                    transaction.oncomplete = function () {
                        // Cast to undefined so the value passed to
                        // callback/promise is the same as what one would get out
                        // of `getItem()` later. This leads to some weirdness
                        // (setItem('foo', undefined) will return `null`), but
                        // it's not my fault localStorage is our baseline and that
                        // it's weird.
                        if (value === undefined) {
                            value = null;
                        }

                        resolve(value);
                    };
                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function removeItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    // We use a Grunt task to make this safe for IE and some
                    // versions of Android (including those used by Cordova).
                    // Normally IE won't like `.delete()` and will insist on
                    // using `['delete']()`, but we have a build step that
                    // fixes this for us now.
                    var req = store["delete"](key);
                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onerror = function () {
                        reject(req.error);
                    };

                    // The request will be also be aborted if we've exceeded our storage
                    // space.
                    transaction.onabort = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function clear(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.clear();

                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function length(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.count();

                    req.onsuccess = function () {
                        resolve(req.result);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function key(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        if (n < 0) {
            resolve(null);

            return;
        }

        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var advanced = false;
                    var req = store.openKeyCursor();

                    req.onsuccess = function () {
                        var cursor = req.result;
                        if (!cursor) {
                            // this means there weren't enough keys
                            resolve(null);

                            return;
                        }

                        if (n === 0) {
                            // We have the first key, return it if that's what they
                            // wanted.
                            resolve(cursor.key);
                        } else {
                            if (!advanced) {
                                // Otherwise, ask the cursor to skip ahead n
                                // records.
                                advanced = true;
                                cursor.advance(n);
                            } else {
                                // When we get here, we've got the nth key.
                                resolve(cursor.key);
                            }
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openKeyCursor();
                    var keys = [];

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (!cursor) {
                            resolve(keys);
                            return;
                        }

                        keys.push(cursor.key);
                        cursor["continue"]();
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        var isCurrentDb = options.name === currentConfig.name && self._dbInfo.db;

        var dbPromise = isCurrentDb ? Promise$1.resolve(self._dbInfo.db) : _getOriginalConnection(options).then(function (db) {
            var dbContext = dbContexts[options.name];
            var forages = dbContext.forages;
            dbContext.db = db;
            for (var i = 0; i < forages.length; i++) {
                forages[i]._dbInfo.db = db;
            }
            return db;
        });

        if (!options.storeName) {
            promise = dbPromise.then(function (db) {
                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                }

                var dropDBPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.deleteDatabase(options.name);

                    req.onerror = req.onblocked = function (err) {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        reject(err);
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        resolve(db);
                    };
                });

                return dropDBPromise.then(function (db) {
                    dbContext.db = db;
                    for (var i = 0; i < forages.length; i++) {
                        var _forage = forages[i];
                        _advanceReadiness(_forage._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        } else {
            promise = dbPromise.then(function (db) {
                if (!db.objectStoreNames.contains(options.storeName)) {
                    return;
                }

                var newVersion = db.version + 1;

                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                    forage._dbInfo.version = newVersion;
                }

                var dropObjectPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.open(options.name, newVersion);

                    req.onerror = function (err) {
                        var db = req.result;
                        db.close();
                        reject(err);
                    };

                    req.onupgradeneeded = function () {
                        var db = req.result;
                        db.deleteObjectStore(options.storeName);
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        db.close();
                        resolve(db);
                    };
                });

                return dropObjectPromise.then(function (db) {
                    dbContext.db = db;
                    for (var j = 0; j < forages.length; j++) {
                        var _forage2 = forages[j];
                        _forage2._dbInfo.db = db;
                        _advanceReadiness(_forage2._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        }
    }

    executeCallback(promise, callback);
    return promise;
}

var asyncStorage = {
    _driver: 'asyncStorage',
    _initStorage: _initStorage,
    _support: isIndexedDBValid(),
    iterate: iterate,
    getItem: getItem,
    setItem: setItem,
    removeItem: removeItem,
    clear: clear,
    length: length,
    key: key,
    keys: keys,
    dropInstance: dropInstance
};

function isWebSQLValid() {
    return typeof openDatabase === 'function';
}

// Sadly, the best way to save binary data in WebSQL/localStorage is serializing
// it to Base64, so this is how we store it to prevent very strange errors with less
// verbose ways of binary <-> string data storage.
var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

var BLOB_TYPE_PREFIX = '~~local_forage_type~';
var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;

var SERIALIZED_MARKER = '__lfsc__:';
var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

// OMG the serializations!
var TYPE_ARRAYBUFFER = 'arbf';
var TYPE_BLOB = 'blob';
var TYPE_INT8ARRAY = 'si08';
var TYPE_UINT8ARRAY = 'ui08';
var TYPE_UINT8CLAMPEDARRAY = 'uic8';
var TYPE_INT16ARRAY = 'si16';
var TYPE_INT32ARRAY = 'si32';
var TYPE_UINT16ARRAY = 'ur16';
var TYPE_UINT32ARRAY = 'ui32';
var TYPE_FLOAT32ARRAY = 'fl32';
var TYPE_FLOAT64ARRAY = 'fl64';
var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;

var toString$1 = Object.prototype.toString;

function stringToBuffer(serializedString) {
    // Fill the string into a ArrayBuffer.
    var bufferLength = serializedString.length * 0.75;
    var len = serializedString.length;
    var i;
    var p = 0;
    var encoded1, encoded2, encoded3, encoded4;

    if (serializedString[serializedString.length - 1] === '=') {
        bufferLength--;
        if (serializedString[serializedString.length - 2] === '=') {
            bufferLength--;
        }
    }

    var buffer = new ArrayBuffer(bufferLength);
    var bytes = new Uint8Array(buffer);

    for (i = 0; i < len; i += 4) {
        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

        /*jslint bitwise: true */
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return buffer;
}

// Converts a buffer to a string to store, serialized, in the backend
// storage library.
function bufferToString(buffer) {
    // base64-arraybuffer
    var bytes = new Uint8Array(buffer);
    var base64String = '';
    var i;

    for (i = 0; i < bytes.length; i += 3) {
        /*jslint bitwise: true */
        base64String += BASE_CHARS[bytes[i] >> 2];
        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64String += BASE_CHARS[bytes[i + 2] & 63];
    }

    if (bytes.length % 3 === 2) {
        base64String = base64String.substring(0, base64String.length - 1) + '=';
    } else if (bytes.length % 3 === 1) {
        base64String = base64String.substring(0, base64String.length - 2) + '==';
    }

    return base64String;
}

// Serialize a value, afterwards executing a callback (which usually
// instructs the `setItem()` callback/promise to be executed). This is how
// we store binary data with localStorage.
function serialize(value, callback) {
    var valueType = '';
    if (value) {
        valueType = toString$1.call(value);
    }

    // Cannot use `value instanceof ArrayBuffer` or such here, as these
    // checks fail when running the tests using casper.js...
    //
    // TODO: See why those tests fail and use a better solution.
    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
        // Convert binary arrays to a string and prefix the string with
        // a special marker.
        var buffer;
        var marker = SERIALIZED_MARKER;

        if (value instanceof ArrayBuffer) {
            buffer = value;
            marker += TYPE_ARRAYBUFFER;
        } else {
            buffer = value.buffer;

            if (valueType === '[object Int8Array]') {
                marker += TYPE_INT8ARRAY;
            } else if (valueType === '[object Uint8Array]') {
                marker += TYPE_UINT8ARRAY;
            } else if (valueType === '[object Uint8ClampedArray]') {
                marker += TYPE_UINT8CLAMPEDARRAY;
            } else if (valueType === '[object Int16Array]') {
                marker += TYPE_INT16ARRAY;
            } else if (valueType === '[object Uint16Array]') {
                marker += TYPE_UINT16ARRAY;
            } else if (valueType === '[object Int32Array]') {
                marker += TYPE_INT32ARRAY;
            } else if (valueType === '[object Uint32Array]') {
                marker += TYPE_UINT32ARRAY;
            } else if (valueType === '[object Float32Array]') {
                marker += TYPE_FLOAT32ARRAY;
            } else if (valueType === '[object Float64Array]') {
                marker += TYPE_FLOAT64ARRAY;
            } else {
                callback(new Error('Failed to get type for BinaryArray'));
            }
        }

        callback(marker + bufferToString(buffer));
    } else if (valueType === '[object Blob]') {
        // Conver the blob to a binaryArray and then to a string.
        var fileReader = new FileReader();

        fileReader.onload = function () {
            // Backwards-compatible prefix for the blob type.
            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);

            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
        };

        fileReader.readAsArrayBuffer(value);
    } else {
        try {
            callback(JSON.stringify(value));
        } catch (e) {
            console.error("Couldn't convert value into a JSON string: ", value);

            callback(null, e);
        }
    }
}

// Deserialize data we've inserted into a value column/field. We place
// special markers into our strings to mark them as encoded; this isn't
// as nice as a meta field, but it's the only sane thing we can do whilst
// keeping localStorage support intact.
//
// Oftentimes this will just deserialize JSON content, but if we have a
// special marker (SERIALIZED_MARKER, defined above), we will extract
// some kind of arraybuffer/binary data/typed array out of the string.
function deserialize(value) {
    // If we haven't marked this string as being specially serialized (i.e.
    // something other than serialized JSON), we can just return it and be
    // done with it.
    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
        return JSON.parse(value);
    }

    // The following code deals with deserializing some kind of Blob or
    // TypedArray. First we separate out the type of data we're dealing
    // with from the data itself.
    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);

    var blobType;
    // Backwards-compatible blob type serialization strategy.
    // DBs created with older versions of localForage will simply not have the blob type.
    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
        blobType = matcher[1];
        serializedString = serializedString.substring(matcher[0].length);
    }
    var buffer = stringToBuffer(serializedString);

    // Return the right type based on the code/type set during
    // serialization.
    switch (type) {
        case TYPE_ARRAYBUFFER:
            return buffer;
        case TYPE_BLOB:
            return createBlob([buffer], { type: blobType });
        case TYPE_INT8ARRAY:
            return new Int8Array(buffer);
        case TYPE_UINT8ARRAY:
            return new Uint8Array(buffer);
        case TYPE_UINT8CLAMPEDARRAY:
            return new Uint8ClampedArray(buffer);
        case TYPE_INT16ARRAY:
            return new Int16Array(buffer);
        case TYPE_UINT16ARRAY:
            return new Uint16Array(buffer);
        case TYPE_INT32ARRAY:
            return new Int32Array(buffer);
        case TYPE_UINT32ARRAY:
            return new Uint32Array(buffer);
        case TYPE_FLOAT32ARRAY:
            return new Float32Array(buffer);
        case TYPE_FLOAT64ARRAY:
            return new Float64Array(buffer);
        default:
            throw new Error('Unkown type: ' + type);
    }
}

var localforageSerializer = {
    serialize: serialize,
    deserialize: deserialize,
    stringToBuffer: stringToBuffer,
    bufferToString: bufferToString
};

/*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */

function createDbTable(t, dbInfo, callback, errorCallback) {
    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
}

// Open the WebSQL database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage$1(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
        }
    }

    var dbInfoPromise = new Promise$1(function (resolve, reject) {
        // Open the database; the openDatabase API will automatically
        // create it for us if it doesn't exist.
        try {
            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
        } catch (e) {
            return reject(e);
        }

        // Create our key/value table if it doesn't exist.
        dbInfo.db.transaction(function (t) {
            createDbTable(t, dbInfo, function () {
                self._dbInfo = dbInfo;
                resolve();
            }, function (t, error) {
                reject(error);
            });
        }, reject);
    });

    dbInfo.serializer = localforageSerializer;
    return dbInfoPromise;
}

function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
    t.executeSql(sqlStatement, args, callback, function (t, error) {
        if (error.code === error.SYNTAX_ERR) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name = ?", [dbInfo.storeName], function (t, results) {
                if (!results.rows.length) {
                    // if the table is missing (was deleted)
                    // re-create it table and retry
                    createDbTable(t, dbInfo, function () {
                        t.executeSql(sqlStatement, args, callback, errorCallback);
                    }, errorCallback);
                } else {
                    errorCallback(t, error);
                }
            }, errorCallback);
        } else {
            errorCallback(t, error);
        }
    }, errorCallback);
}

function getItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).value : null;

                    // Check to see if this is serialized content we need to
                    // unpack.
                    if (result) {
                        result = dbInfo.serializer.deserialize(result);
                    }

                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function iterate$1(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;

            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
                    var rows = results.rows;
                    var length = rows.length;

                    for (var i = 0; i < length; i++) {
                        var item = rows.item(i);
                        var result = item.value;

                        // Check to see if this is serialized content
                        // we need to unpack.
                        if (result) {
                            result = dbInfo.serializer.deserialize(result);
                        }

                        result = iterator(result, item.key, i + 1);

                        // void(0) prevents problems with redefinition
                        // of `undefined`.
                        if (result !== void 0) {
                            resolve(result);
                            return;
                        }
                    }

                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function _setItem(key, value, callback, retriesLeft) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            // The localStorage API doesn't return undefined values in an
            // "expected" way, so undefined is always cast to null in all
            // drivers. See: https://github.com/mozilla/localForage/pull/42
            if (value === undefined) {
                value = null;
            }

            // Save the original value to pass to the callback.
            var originalValue = value;

            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    dbInfo.db.transaction(function (t) {
                        tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [key, value], function () {
                            resolve(originalValue);
                        }, function (t, error) {
                            reject(error);
                        });
                    }, function (sqlError) {
                        // The transaction failed; check
                        // to see if it's a quota error.
                        if (sqlError.code === sqlError.QUOTA_ERR) {
                            // We reject the callback outright for now, but
                            // it's worth trying to re-run the transaction.
                            // Even if the user accepts the prompt to use
                            // more storage on Safari, this error will
                            // be called.
                            //
                            // Try to re-run the transaction.
                            if (retriesLeft > 0) {
                                resolve(_setItem.apply(self, [key, originalValue, callback, retriesLeft - 1]));
                                return;
                            }
                            reject(sqlError);
                        }
                    });
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function setItem$1(key, value, callback) {
    return _setItem.apply(this, [key, value, callback, 1]);
}

function removeItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Deletes every item in the table.
// TODO: Find out if this resets the AUTO_INCREMENT number.
function clear$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Does a simple `COUNT(key)` to get the number of items stored in
// localForage.
function length$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                // Ahhh, SQL makes this one soooooo easy.
                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
                    var result = results.rows.item(0).c;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Return the key located at key index X; essentially gets the key from a
// `WHERE id = ?`. This is the most efficient way I can think to implement
// this rarely-used (in my experience) part of the API, but it can seem
// inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
// the ID of each key will change every time it's updated. Perhaps a stored
// procedure for the `setItem()` SQL would solve this problem?
// TODO: Don't change ID on `setItem()`.
function key$1(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).key : null;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
                    var keys = [];

                    for (var i = 0; i < results.rows.length; i++) {
                        keys.push(results.rows.item(i).key);
                    }

                    resolve(keys);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// https://www.w3.org/TR/webdatabase/#databases
// > There is no way to enumerate or delete the databases available for an origin from this API.
function getAllStoreNames(db) {
    return new Promise$1(function (resolve, reject) {
        db.transaction(function (t) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (t, results) {
                var storeNames = [];

                for (var i = 0; i < results.rows.length; i++) {
                    storeNames.push(results.rows.item(i).name);
                }

                resolve({
                    db: db,
                    storeNames: storeNames
                });
            }, function (t, error) {
                reject(error);
            });
        }, function (sqlError) {
            reject(sqlError);
        });
    });
}

function dropInstance$1(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            var db;
            if (options.name === currentConfig.name) {
                // use the db reference of the current instance
                db = self._dbInfo.db;
            } else {
                db = openDatabase(options.name, '', '', 0);
            }

            if (!options.storeName) {
                // drop all database tables
                resolve(getAllStoreNames(db));
            } else {
                resolve({
                    db: db,
                    storeNames: [options.storeName]
                });
            }
        }).then(function (operationInfo) {
            return new Promise$1(function (resolve, reject) {
                operationInfo.db.transaction(function (t) {
                    function dropTable(storeName) {
                        return new Promise$1(function (resolve, reject) {
                            t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function () {
                                resolve();
                            }, function (t, error) {
                                reject(error);
                            });
                        });
                    }

                    var operations = [];
                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
                        operations.push(dropTable(operationInfo.storeNames[i]));
                    }

                    Promise$1.all(operations).then(function () {
                        resolve();
                    })["catch"](function (e) {
                        reject(e);
                    });
                }, function (sqlError) {
                    reject(sqlError);
                });
            });
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var webSQLStorage = {
    _driver: 'webSQLStorage',
    _initStorage: _initStorage$1,
    _support: isWebSQLValid(),
    iterate: iterate$1,
    getItem: getItem$1,
    setItem: setItem$1,
    removeItem: removeItem$1,
    clear: clear$1,
    length: length$1,
    key: key$1,
    keys: keys$1,
    dropInstance: dropInstance$1
};

function isLocalStorageValid() {
    try {
        return typeof localStorage !== 'undefined' && 'setItem' in localStorage &&
        // in IE8 typeof localStorage.setItem === 'object'
        !!localStorage.setItem;
    } catch (e) {
        return false;
    }
}

function _getKeyPrefix(options, defaultConfig) {
    var keyPrefix = options.name + '/';

    if (options.storeName !== defaultConfig.storeName) {
        keyPrefix += options.storeName + '/';
    }
    return keyPrefix;
}

// Check if localStorage throws when saving an item
function checkIfLocalStorageThrows() {
    var localStorageTestKey = '_localforage_support_test';

    try {
        localStorage.setItem(localStorageTestKey, true);
        localStorage.removeItem(localStorageTestKey);

        return false;
    } catch (e) {
        return true;
    }
}

// Check if localStorage is usable and allows to save an item
// This method checks if localStorage is usable in Safari Private Browsing
// mode, or in any other case where the available quota for localStorage
// is 0 and there wasn't any saved items yet.
function _isLocalStorageUsable() {
    return !checkIfLocalStorageThrows() || localStorage.length > 0;
}

// Config the localStorage backend, using options set in the config.
function _initStorage$2(options) {
    var self = this;
    var dbInfo = {};
    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    dbInfo.keyPrefix = _getKeyPrefix(options, self._defaultConfig);

    if (!_isLocalStorageUsable()) {
        return Promise$1.reject();
    }

    self._dbInfo = dbInfo;
    dbInfo.serializer = localforageSerializer;

    return Promise$1.resolve();
}

// Remove all keys from the datastore, effectively destroying all data in
// the app's key/value store!
function clear$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var keyPrefix = self._dbInfo.keyPrefix;

        for (var i = localStorage.length - 1; i >= 0; i--) {
            var key = localStorage.key(i);

            if (key.indexOf(keyPrefix) === 0) {
                localStorage.removeItem(key);
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Retrieve an item from the store. Unlike the original async_storage
// library in Gaia, we don't modify return values at all. If a key's value
// is `undefined`, we pass that value to the callback function.
function getItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result = localStorage.getItem(dbInfo.keyPrefix + key);

        // If a result was found, parse it from the serialized
        // string into a JS object. If result isn't truthy, the key
        // is likely undefined and we'll pass it straight to the
        // callback.
        if (result) {
            result = dbInfo.serializer.deserialize(result);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items in the store.
function iterate$2(iterator, callback) {
    var self = this;

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var keyPrefix = dbInfo.keyPrefix;
        var keyPrefixLength = keyPrefix.length;
        var length = localStorage.length;

        // We use a dedicated iterator instead of the `i` variable below
        // so other keys we fetch in localStorage aren't counted in
        // the `iterationNumber` argument passed to the `iterate()`
        // callback.
        //
        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
        var iterationNumber = 1;

        for (var i = 0; i < length; i++) {
            var key = localStorage.key(i);
            if (key.indexOf(keyPrefix) !== 0) {
                continue;
            }
            var value = localStorage.getItem(key);

            // If a result was found, parse it from the serialized
            // string into a JS object. If result isn't truthy, the
            // key is likely undefined and we'll pass it straight
            // to the iterator.
            if (value) {
                value = dbInfo.serializer.deserialize(value);
            }

            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);

            if (value !== void 0) {
                return value;
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Same as localStorage's key() method, except takes a callback.
function key$2(n, callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result;
        try {
            result = localStorage.key(n);
        } catch (error) {
            result = null;
        }

        // Remove the prefix from the key, if a key is found.
        if (result) {
            result = result.substring(dbInfo.keyPrefix.length);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var length = localStorage.length;
        var keys = [];

        for (var i = 0; i < length; i++) {
            var itemKey = localStorage.key(i);
            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
                keys.push(itemKey.substring(dbInfo.keyPrefix.length));
            }
        }

        return keys;
    });

    executeCallback(promise, callback);
    return promise;
}

// Supply the number of keys in the datastore to the callback function.
function length$2(callback) {
    var self = this;
    var promise = self.keys().then(function (keys) {
        return keys.length;
    });

    executeCallback(promise, callback);
    return promise;
}

// Remove an item from the store, nice and simple.
function removeItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        localStorage.removeItem(dbInfo.keyPrefix + key);
    });

    executeCallback(promise, callback);
    return promise;
}

// Set a key's value and run an optional callback once the value is set.
// Unlike Gaia's implementation, the callback function is passed the value,
// in case you want to operate on that value only after you're sure it
// saved, or something like that.
function setItem$2(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        // Convert undefined values to null.
        // https://github.com/mozilla/localForage/pull/42
        if (value === undefined) {
            value = null;
        }

        // Save the original value to pass to the callback.
        var originalValue = value;

        return new Promise$1(function (resolve, reject) {
            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    try {
                        localStorage.setItem(dbInfo.keyPrefix + key, value);
                        resolve(originalValue);
                    } catch (e) {
                        // localStorage capacity exceeded.
                        // TODO: Make this a specific error/event.
                        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                            reject(e);
                        }
                        reject(e);
                    }
                }
            });
        });
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance$2(options, callback) {
    callback = getCallback.apply(this, arguments);

    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        var currentConfig = this.config();
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            if (!options.storeName) {
                resolve(options.name + '/');
            } else {
                resolve(_getKeyPrefix(options, self._defaultConfig));
            }
        }).then(function (keyPrefix) {
            for (var i = localStorage.length - 1; i >= 0; i--) {
                var key = localStorage.key(i);

                if (key.indexOf(keyPrefix) === 0) {
                    localStorage.removeItem(key);
                }
            }
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var localStorageWrapper = {
    _driver: 'localStorageWrapper',
    _initStorage: _initStorage$2,
    _support: isLocalStorageValid(),
    iterate: iterate$2,
    getItem: getItem$2,
    setItem: setItem$2,
    removeItem: removeItem$2,
    clear: clear$2,
    length: length$2,
    key: key$2,
    keys: keys$2,
    dropInstance: dropInstance$2
};

var sameValue = function sameValue(x, y) {
    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
};

var includes = function includes(array, searchElement) {
    var len = array.length;
    var i = 0;
    while (i < len) {
        if (sameValue(array[i], searchElement)) {
            return true;
        }
        i++;
    }

    return false;
};

var isArray = Array.isArray || function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
};

// Drivers are stored here when `defineDriver()` is called.
// They are shared across all instances of localForage.
var DefinedDrivers = {};

var DriverSupport = {};

var DefaultDrivers = {
    INDEXEDDB: asyncStorage,
    WEBSQL: webSQLStorage,
    LOCALSTORAGE: localStorageWrapper
};

var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];

var OptionalDriverMethods = ['dropInstance'];

var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'].concat(OptionalDriverMethods);

var DefaultConfig = {
    description: '',
    driver: DefaultDriverOrder.slice(),
    name: 'localforage',
    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
    // we can use without a prompt.
    size: 4980736,
    storeName: 'keyvaluepairs',
    version: 1.0
};

function callWhenReady(localForageInstance, libraryMethod) {
    localForageInstance[libraryMethod] = function () {
        var _args = arguments;
        return localForageInstance.ready().then(function () {
            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
        });
    };
}

function extend() {
    for (var i = 1; i < arguments.length; i++) {
        var arg = arguments[i];

        if (arg) {
            for (var _key in arg) {
                if (arg.hasOwnProperty(_key)) {
                    if (isArray(arg[_key])) {
                        arguments[0][_key] = arg[_key].slice();
                    } else {
                        arguments[0][_key] = arg[_key];
                    }
                }
            }
        }
    }

    return arguments[0];
}

var LocalForage = function () {
    function LocalForage(options) {
        _classCallCheck(this, LocalForage);

        for (var driverTypeKey in DefaultDrivers) {
            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                var driver = DefaultDrivers[driverTypeKey];
                var driverName = driver._driver;
                this[driverTypeKey] = driverName;

                if (!DefinedDrivers[driverName]) {
                    // we don't need to wait for the promise,
                    // since the default drivers can be defined
                    // in a blocking manner
                    this.defineDriver(driver);
                }
            }
        }

        this._defaultConfig = extend({}, DefaultConfig);
        this._config = extend({}, this._defaultConfig, options);
        this._driverSet = null;
        this._initDriver = null;
        this._ready = false;
        this._dbInfo = null;

        this._wrapLibraryMethodsWithReady();
        this.setDriver(this._config.driver)["catch"](function () {});
    }

    // Set any config values for localForage; can be called anytime before
    // the first API call (e.g. `getItem`, `setItem`).
    // We loop through options so we don't overwrite existing config
    // values.


    LocalForage.prototype.config = function config(options) {
        // If the options argument is an object, we use it to set values.
        // Otherwise, we return either a specified config value or all
        // config values.
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            // If localforage is ready and fully initialized, we can't set
            // any new configuration values. Instead, we return an error.
            if (this._ready) {
                return new Error("Can't call config() after localforage " + 'has been used.');
            }

            for (var i in options) {
                if (i === 'storeName') {
                    options[i] = options[i].replace(/\W/g, '_');
                }

                if (i === 'version' && typeof options[i] !== 'number') {
                    return new Error('Database version must be a number.');
                }

                this._config[i] = options[i];
            }

            // after all config options are set and
            // the driver option is used, try setting it
            if ('driver' in options && options.driver) {
                return this.setDriver(this._config.driver);
            }

            return true;
        } else if (typeof options === 'string') {
            return this._config[options];
        } else {
            return this._config;
        }
    };

    // Used to define a custom driver, shared across all instances of
    // localForage.


    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
        var promise = new Promise$1(function (resolve, reject) {
            try {
                var driverName = driverObject._driver;
                var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');

                // A driver name should be defined and not overlap with the
                // library-defined, default drivers.
                if (!driverObject._driver) {
                    reject(complianceError);
                    return;
                }

                var driverMethods = LibraryMethods.concat('_initStorage');
                for (var i = 0, len = driverMethods.length; i < len; i++) {
                    var driverMethodName = driverMethods[i];

                    // when the property is there,
                    // it should be a method even when optional
                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
                        reject(complianceError);
                        return;
                    }
                }

                var configureMissingMethods = function configureMissingMethods() {
                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                        return function () {
                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
                            var promise = Promise$1.reject(error);
                            executeCallback(promise, arguments[arguments.length - 1]);
                            return promise;
                        };
                    };

                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
                        var optionalDriverMethod = OptionalDriverMethods[_i];
                        if (!driverObject[optionalDriverMethod]) {
                            driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                        }
                    }
                };

                configureMissingMethods();

                var setDriverSupport = function setDriverSupport(support) {
                    if (DefinedDrivers[driverName]) {
                        console.info('Redefining LocalForage driver: ' + driverName);
                    }
                    DefinedDrivers[driverName] = driverObject;
                    DriverSupport[driverName] = support;
                    // don't use a then, so that we can define
                    // drivers that have simple _support methods
                    // in a blocking manner
                    resolve();
                };

                if ('_support' in driverObject) {
                    if (driverObject._support && typeof driverObject._support === 'function') {
                        driverObject._support().then(setDriverSupport, reject);
                    } else {
                        setDriverSupport(!!driverObject._support);
                    }
                } else {
                    setDriverSupport(true);
                }
            } catch (e) {
                reject(e);
            }
        });

        executeTwoCallbacks(promise, callback, errorCallback);
        return promise;
    };

    LocalForage.prototype.driver = function driver() {
        return this._driver || null;
    };

    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));

        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
        return getDriverPromise;
    };

    LocalForage.prototype.getSerializer = function getSerializer(callback) {
        var serializerPromise = Promise$1.resolve(localforageSerializer);
        executeTwoCallbacks(serializerPromise, callback);
        return serializerPromise;
    };

    LocalForage.prototype.ready = function ready(callback) {
        var self = this;

        var promise = self._driverSet.then(function () {
            if (self._ready === null) {
                self._ready = self._initDriver();
            }

            return self._ready;
        });

        executeTwoCallbacks(promise, callback, callback);
        return promise;
    };

    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
        var self = this;

        if (!isArray(drivers)) {
            drivers = [drivers];
        }

        var supportedDrivers = this._getSupportedDrivers(drivers);

        function setDriverToConfig() {
            self._config.driver = self.driver();
        }

        function extendSelfWithDriver(driver) {
            self._extend(driver);
            setDriverToConfig();

            self._ready = self._initStorage(self._config);
            return self._ready;
        }

        function initDriver(supportedDrivers) {
            return function () {
                var currentDriverIndex = 0;

                function driverPromiseLoop() {
                    while (currentDriverIndex < supportedDrivers.length) {
                        var driverName = supportedDrivers[currentDriverIndex];
                        currentDriverIndex++;

                        self._dbInfo = null;
                        self._ready = null;

                        return self.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                    }

                    setDriverToConfig();
                    var error = new Error('No available storage method found.');
                    self._driverSet = Promise$1.reject(error);
                    return self._driverSet;
                }

                return driverPromiseLoop();
            };
        }

        // There might be a driver initialization in progress
        // so wait for it to finish in order to avoid a possible
        // race condition to set _dbInfo
        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
            return Promise$1.resolve();
        }) : Promise$1.resolve();

        this._driverSet = oldDriverSetDone.then(function () {
            var driverName = supportedDrivers[0];
            self._dbInfo = null;
            self._ready = null;

            return self.getDriver(driverName).then(function (driver) {
                self._driver = driver._driver;
                setDriverToConfig();
                self._wrapLibraryMethodsWithReady();
                self._initDriver = initDriver(supportedDrivers);
            });
        })["catch"](function () {
            setDriverToConfig();
            var error = new Error('No available storage method found.');
            self._driverSet = Promise$1.reject(error);
            return self._driverSet;
        });

        executeTwoCallbacks(this._driverSet, callback, errorCallback);
        return this._driverSet;
    };

    LocalForage.prototype.supports = function supports(driverName) {
        return !!DriverSupport[driverName];
    };

    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
        extend(this, libraryMethodsAndProperties);
    };

    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
        var supportedDrivers = [];
        for (var i = 0, len = drivers.length; i < len; i++) {
            var driverName = drivers[i];
            if (this.supports(driverName)) {
                supportedDrivers.push(driverName);
            }
        }
        return supportedDrivers;
    };

    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
        // Add a stub for each driver API method that delays the call to the
        // corresponding driver method until localForage is ready. These stubs
        // will be replaced by the driver methods as soon as the driver is
        // loaded, so there is no performance impact.
        for (var i = 0, len = LibraryMethods.length; i < len; i++) {
            callWhenReady(this, LibraryMethods[i]);
        }
    };

    LocalForage.prototype.createInstance = function createInstance(options) {
        return new LocalForage(options);
    };

    return LocalForage;
}();

// The actual localForage object that we expose as a module or via a
// global. It's extended by pulling in one of our other libraries.


var localforage_js = new LocalForage();

module.exports = localforage_js;

},{"3":3}]},{},[4])(4)
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ReportingObserver */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);


/** JSDoc */
var ReportTypes;
(function (ReportTypes) {
    /** JSDoc */
    ReportTypes["Crash"] = "crash";
    /** JSDoc */
    ReportTypes["Deprecation"] = "deprecation";
    /** JSDoc */
    ReportTypes["Intervention"] = "intervention";
})(ReportTypes || (ReportTypes = {}));
/** Reporting API integration - https://w3c.github.io/reporting/ */
var ReportingObserver = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function ReportingObserver(_options) {
        if (_options === void 0) { _options = {
            types: [ReportTypes.Crash, ReportTypes.Deprecation, ReportTypes.Intervention],
        }; }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = ReportingObserver.id;
    }
    /**
     * @inheritDoc
     */
    ReportingObserver.prototype.setupOnce = function (_, getCurrentHub) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["N" /* supportsReportingObserver */])()) {
            return;
        }
        this._getCurrentHub = getCurrentHub;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var observer = new (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["p" /* getGlobalObject */])().ReportingObserver)(this.handler.bind(this), {
            buffered: true,
            types: this._options.types,
        });
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        observer.observe();
    };
    /**
     * @inheritDoc
     */
    ReportingObserver.prototype.handler = function (reports) {
        var e_1, _a;
        var hub = this._getCurrentHub && this._getCurrentHub();
        if (!hub || !hub.getIntegration(ReportingObserver)) {
            return;
        }
        var _loop_1 = function (report) {
            hub.withScope(function (scope) {
                scope.setExtra('url', report.url);
                var label = "ReportingObserver [" + report.type + "]";
                var details = 'No details available';
                if (report.body) {
                    // Object.keys doesn't work on ReportBody, as all properties are inheirted
                    var plainBody = {};
                    // eslint-disable-next-line guard-for-in
                    for (var prop in report.body) {
                        plainBody[prop] = report.body[prop];
                    }
                    scope.setExtra('body', plainBody);
                    if (report.type === ReportTypes.Crash) {
                        var body = report.body;
                        // A fancy way to create a message out of crashId OR reason OR both OR fallback
                        details = [body.crashId || '', body.reason || ''].join(' ').trim() || details;
                    }
                    else {
                        var body = report.body;
                        details = body.message || details;
                    }
                }
                hub.captureMessage(label + ": " + details);
            });
        };
        try {
            for (var reports_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __values */])(reports), reports_1_1 = reports_1.next(); !reports_1_1.done; reports_1_1 = reports_1.next()) {
                var report = reports_1_1.value;
                _loop_1(report);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (reports_1_1 && !reports_1_1.done && (_a = reports_1.return)) _a.call(reports_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /**
     * @inheritDoc
     */
    ReportingObserver.id = 'ReportingObserver';
    return ReportingObserver;
}());

//# sourceMappingURL=reportingobserver.js.map

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RewriteFrames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);


/** Rewrite event frames paths */
var RewriteFrames = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function RewriteFrames(options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = RewriteFrames.id;
        /**
         * @inheritDoc
         */
        this._iteratee = function (frame) {
            if (!frame.filename) {
                return frame;
            }
            // Check if the frame filename begins with `/` or a Windows-style prefix such as `C:\`
            var isWindowsFrame = /^[A-Z]:\\/.test(frame.filename);
            var startsWithSlash = /^\//.test(frame.filename);
            if (isWindowsFrame || startsWithSlash) {
                var filename = isWindowsFrame
                    ? frame.filename
                        .replace(/^[A-Z]:/, '') // remove Windows-style prefix
                        .replace(/\\/g, '/') // replace all `\\` instances with `/`
                    : frame.filename;
                var base = _this._root ? Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["J" /* relative */])(_this._root, filename) : Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["h" /* basename */])(filename);
                frame.filename = "app:///" + base;
            }
            return frame;
        };
        if (options.root) {
            this._root = options.root;
        }
        if (options.iteratee) {
            this._iteratee = options.iteratee;
        }
    }
    /**
     * @inheritDoc
     */
    RewriteFrames.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (event) {
            var self = getCurrentHub().getIntegration(RewriteFrames);
            if (self) {
                return self.process(event);
            }
            return event;
        });
    };
    /** JSDoc */
    RewriteFrames.prototype.process = function (event) {
        if (event.exception && Array.isArray(event.exception.values)) {
            return this._processExceptionsEvent(event);
        }
        if (event.stacktrace) {
            return this._processStacktraceEvent(event);
        }
        return event;
    };
    /** JSDoc */
    RewriteFrames.prototype._processExceptionsEvent = function (event) {
        var _this = this;
        try {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event), { exception: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event.exception), { 
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map(function (value) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, value), { stacktrace: _this._processStacktrace(value.stacktrace) })); }) }) });
        }
        catch (_oO) {
            return event;
        }
    };
    /** JSDoc */
    RewriteFrames.prototype._processStacktraceEvent = function (event) {
        try {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event), { stacktrace: this._processStacktrace(event.stacktrace) });
        }
        catch (_oO) {
            return event;
        }
    };
    /** JSDoc */
    RewriteFrames.prototype._processStacktrace = function (stacktrace) {
        var _this = this;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, stacktrace), { frames: stacktrace && stacktrace.frames && stacktrace.frames.map(function (f) { return _this._iteratee(f); }) });
    };
    /**
     * @inheritDoc
     */
    RewriteFrames.id = 'RewriteFrames';
    return RewriteFrames;
}());

//# sourceMappingURL=rewriteframes.js.map

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SessionTiming */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);

/** This function adds duration since Sentry was initialized till the time event was sent */
var SessionTiming = /** @class */ (function () {
    function SessionTiming() {
        /**
         * @inheritDoc
         */
        this.name = SessionTiming.id;
        /** Exact time Client was initialized expressed in milliseconds since Unix Epoch. */
        this._startTime = Date.now();
    }
    /**
     * @inheritDoc
     */
    SessionTiming.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (event) {
            var self = getCurrentHub().getIntegration(SessionTiming);
            if (self) {
                return self.process(event);
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    SessionTiming.prototype.process = function (event) {
        var _a;
        var now = Date.now();
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event), { extra: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event.extra), (_a = {}, _a['session:start'] = this._startTime, _a['session:duration'] = now - this._startTime, _a['session:end'] = now, _a)) });
    };
    /**
     * @inheritDoc
     */
    SessionTiming.id = 'SessionTiming';
    return SessionTiming;
}());

//# sourceMappingURL=sessiontiming.js.map

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Transaction */
/** Add node transaction to the event */
var Transaction = /** @class */ (function () {
    function Transaction() {
        /**
         * @inheritDoc
         */
        this.name = Transaction.id;
    }
    /**
     * @inheritDoc
     */
    Transaction.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (event) {
            var self = getCurrentHub().getIntegration(Transaction);
            if (self) {
                return self.process(event);
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    Transaction.prototype.process = function (event) {
        var frames = this._getFramesFromEvent(event);
        // use for loop so we don't have to reverse whole frames array
        for (var i = frames.length - 1; i >= 0; i--) {
            var frame = frames[i];
            if (frame.in_app === true) {
                event.transaction = this._getTransaction(frame);
                break;
            }
        }
        return event;
    };
    /** JSDoc */
    Transaction.prototype._getFramesFromEvent = function (event) {
        var exception = event.exception && event.exception.values && event.exception.values[0];
        return (exception && exception.stacktrace && exception.stacktrace.frames) || [];
    };
    /** JSDoc */
    Transaction.prototype._getTransaction = function (frame) {
        return frame.module || frame.function ? (frame.module || '?') + "/" + (frame.function || '?') : '<unknown>';
    };
    /**
     * @inheritDoc
     */
    Transaction.id = 'Transaction';
    return Transaction;
}());

//# sourceMappingURL=transaction.js.map

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Vue */
/* unused harmony export getActiveTransaction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);


/**
 * Used to extract Tracing integration from the current client,
 * without the need to import `Tracing` itself from the @sentry/apm package.
 * @deprecated as @sentry/tracing should be used over @sentry/apm.
 */
var TRACING_GETTER = {
    id: 'Tracing',
};
/**
 * Used to extract BrowserTracing integration from @sentry/tracing
 */
var BROWSER_TRACING_GETTER = {
    id: 'BrowserTracing',
};
// Mappings from operation to corresponding lifecycle hook.
var HOOKS = {
    activate: ['activated', 'deactivated'],
    create: ['beforeCreate', 'created'],
    destroy: ['beforeDestroy', 'destroyed'],
    mount: ['beforeMount', 'mounted'],
    update: ['beforeUpdate', 'updated'],
};
var COMPONENT_NAME_REGEXP = /(?:^|[-_/])(\w)/g;
var ROOT_COMPONENT_NAME = 'root';
var ANONYMOUS_COMPONENT_NAME = 'anonymous component';
/** JSDoc */
var Vue = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Vue(options) {
        var _this = this;
        /**
         * @inheritDoc
         */
        this.name = Vue.id;
        /**
         * Cache holding already processed component names
         */
        this._componentsCache = {};
        /** Keep it as attribute function, to keep correct `this` binding inside the hooks callbacks  */
        // eslint-disable-next-line @typescript-eslint/typedef
        this._applyTracingHooks = function (vm, getCurrentHub) {
            // Don't attach twice, just in case
            if (vm.$options.$_sentryPerfHook) {
                return;
            }
            vm.$options.$_sentryPerfHook = true;
            var name = _this._getComponentName(vm);
            var rootMount = name === ROOT_COMPONENT_NAME;
            var spans = {};
            // Render hook starts after once event is emitted,
            // but it ends before the second event of the same type.
            //
            // Because of this, we start measuring inside the first event,
            // but finish it before it triggers, to skip the event emitter timing itself.
            var rootHandler = function (hook) {
                var now = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["O" /* timestampWithMs */])();
                // On the first handler call (before), it'll be undefined, as `$once` will add it in the future.
                // However, on the second call (after), it'll be already in place.
                if (_this._rootSpan) {
                    _this._finishRootSpan(now, getCurrentHub);
                }
                else {
                    vm.$once("hook:" + hook, function () {
                        // Create an activity on the first event call. There'll be no second call, as rootSpan will be in place,
                        // thus new event handler won't be attached.
                        // We do this whole dance with `TRACING_GETTER` to prevent `@sentry/apm` from becoming a peerDependency.
                        // We also need to ask for the `.constructor`, as `pushActivity` and `popActivity` are static, not instance methods.
                        /* eslint-disable @typescript-eslint/no-unsafe-member-access */
                        // eslint-disable-next-line deprecation/deprecation
                        var tracingIntegration = getCurrentHub().getIntegration(TRACING_GETTER);
                        if (tracingIntegration) {
                            _this._tracingActivity = tracingIntegration.constructor.pushActivity('Vue Application Render');
                            var transaction = tracingIntegration.constructor.getTransaction();
                            if (transaction) {
                                _this._rootSpan = transaction.startChild({
                                    description: 'Application Render',
                                    op: 'Vue',
                                });
                            }
                            // Use functionality from @sentry/tracing
                        }
                        else {
                            var activeTransaction = getActiveTransaction(getCurrentHub());
                            if (activeTransaction) {
                                _this._rootSpan = activeTransaction.startChild({
                                    description: 'Application Render',
                                    op: 'Vue',
                                });
                            }
                        }
                        /* eslint-enable @typescript-eslint/no-unsafe-member-access */
                    });
                }
            };
            var childHandler = function (hook, operation) {
                // Skip components that we don't want to track to minimize the noise and give a more granular control to the user
                var shouldTrack = Array.isArray(_this._options.tracingOptions.trackComponents)
                    ? _this._options.tracingOptions.trackComponents.indexOf(name) > -1
                    : _this._options.tracingOptions.trackComponents;
                if (!_this._rootSpan || !shouldTrack) {
                    return;
                }
                var now = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["O" /* timestampWithMs */])();
                var span = spans[operation];
                // On the first handler call (before), it'll be undefined, as `$once` will add it in the future.
                // However, on the second call (after), it'll be already in place.
                if (span) {
                    span.finish();
                    _this._finishRootSpan(now, getCurrentHub);
                }
                else {
                    vm.$once("hook:" + hook, function () {
                        if (_this._rootSpan) {
                            spans[operation] = _this._rootSpan.startChild({
                                description: "Vue <" + name + ">",
                                op: operation,
                            });
                        }
                    });
                }
            };
            // Each component has it's own scope, so all activities are only related to one of them
            _this._options.tracingOptions.hooks.forEach(function (operation) {
                // Retrieve corresponding hooks from Vue lifecycle.
                // eg. mount => ['beforeMount', 'mounted']
                var internalHooks = HOOKS[operation];
                if (!internalHooks) {
                    __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* logger */].warn("Unknown hook: " + operation);
                    return;
                }
                internalHooks.forEach(function (internalHook) {
                    var handler = rootMount
                        ? rootHandler.bind(_this, internalHook)
                        : childHandler.bind(_this, internalHook, operation);
                    var currentValue = vm.$options[internalHook];
                    if (Array.isArray(currentValue)) {
                        vm.$options[internalHook] = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([handler], currentValue);
                    }
                    else if (typeof currentValue === 'function') {
                        vm.$options[internalHook] = [handler, currentValue];
                    }
                    else {
                        vm.$options[internalHook] = [handler];
                    }
                });
            });
        };
        this._options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ 
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            Vue: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["p" /* getGlobalObject */])().Vue, attachProps: true, logErrors: false, tracing: false }, options), { tracingOptions: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ hooks: ['mount', 'update'], timeout: 2000, trackComponents: false }, options.tracingOptions) });
    }
    /**
     * @inheritDoc
     */
    Vue.prototype.setupOnce = function (_, getCurrentHub) {
        if (!this._options.Vue) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* logger */].error('Vue integration is missing a Vue instance');
            return;
        }
        this._attachErrorHandler(getCurrentHub);
        if (this._options.tracing) {
            this._startTracing(getCurrentHub);
        }
    };
    /**
     * Extract component name from the ViewModel
     */
    Vue.prototype._getComponentName = function (vm) {
        // Such level of granularity is most likely not necessary, but better safe than sorry. — Kamil
        if (!vm) {
            return ANONYMOUS_COMPONENT_NAME;
        }
        if (vm.$root === vm) {
            return ROOT_COMPONENT_NAME;
        }
        if (!vm.$options) {
            return ANONYMOUS_COMPONENT_NAME;
        }
        if (vm.$options.name) {
            return vm.$options.name;
        }
        if (vm.$options._componentTag) {
            return vm.$options._componentTag;
        }
        // injected by vue-loader
        if (vm.$options.__file) {
            var unifiedFile = vm.$options.__file.replace(/^[a-zA-Z]:/, '').replace(/\\/g, '/');
            var filename = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["h" /* basename */])(unifiedFile, '.vue');
            return (this._componentsCache[filename] ||
                (this._componentsCache[filename] = filename.replace(COMPONENT_NAME_REGEXP, function (_, c) {
                    return c ? c.toUpperCase() : '';
                })));
        }
        return ANONYMOUS_COMPONENT_NAME;
    };
    /** Finish top-level span and activity with a debounce configured using `timeout` option */
    Vue.prototype._finishRootSpan = function (timestamp, getCurrentHub) {
        var _this = this;
        if (this._rootSpanTimer) {
            clearTimeout(this._rootSpanTimer);
        }
        this._rootSpanTimer = setTimeout(function () {
            if (_this._tracingActivity) {
                // We do this whole dance with `TRACING_GETTER` to prevent `@sentry/apm` from becoming a peerDependency.
                // We also need to ask for the `.constructor`, as `pushActivity` and `popActivity` are static, not instance methods.
                // eslint-disable-next-line deprecation/deprecation
                var tracingIntegration = getCurrentHub().getIntegration(TRACING_GETTER);
                if (tracingIntegration) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    tracingIntegration.constructor.popActivity(_this._tracingActivity);
                }
            }
            // We should always finish the span, only should pop activity if using @sentry/apm
            if (_this._rootSpan) {
                _this._rootSpan.finish(timestamp);
            }
        }, this._options.tracingOptions.timeout);
    };
    /** Inject configured tracing hooks into Vue's component lifecycles */
    Vue.prototype._startTracing = function (getCurrentHub) {
        var applyTracingHooks = this._applyTracingHooks;
        this._options.Vue.mixin({
            beforeCreate: function () {
                // eslint-disable-next-line deprecation/deprecation
                if (getCurrentHub().getIntegration(TRACING_GETTER) || getCurrentHub().getIntegration(BROWSER_TRACING_GETTER)) {
                    // `this` points to currently rendered component
                    applyTracingHooks(this, getCurrentHub);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* logger */].error('Vue integration has tracing enabled, but Tracing integration is not configured');
                }
            },
        });
    };
    /** Inject Sentry's handler into owns Vue's error handler  */
    Vue.prototype._attachErrorHandler = function (getCurrentHub) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var currentErrorHandler = this._options.Vue.config.errorHandler;
        this._options.Vue.config.errorHandler = function (error, vm, info) {
            var metadata = {};
            if (vm) {
                try {
                    metadata.componentName = _this._getComponentName(vm);
                    if (_this._options.attachProps) {
                        metadata.propsData = vm.$options.propsData;
                    }
                }
                catch (_oO) {
                    __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* logger */].warn('Unable to extract metadata from Vue component.');
                }
            }
            if (info) {
                metadata.lifecycleHook = info;
            }
            if (getCurrentHub().getIntegration(Vue)) {
                // Capture exception in the next event loop, to make sure that all breadcrumbs are recorded in time.
                setTimeout(function () {
                    getCurrentHub().withScope(function (scope) {
                        scope.setContext('vue', metadata);
                        getCurrentHub().captureException(error);
                    });
                });
            }
            if (typeof currentErrorHandler === 'function') {
                currentErrorHandler.call(_this._options.Vue, error, vm, info);
            }
            if (_this._options.logErrors) {
                if (_this._options.Vue.util) {
                    _this._options.Vue.util.warn("Error in " + info + ": \"" + error.toString() + "\"", vm);
                }
                // eslint-disable-next-line no-console
                console.error(error);
            }
        };
    };
    /**
     * @inheritDoc
     */
    Vue.id = 'Vue';
    return Vue;
}());

/** Grabs active transaction off scope */
function getActiveTransaction(hub) {
    if (hub && hub.getScope) {
        var scope = hub.getScope();
        if (scope) {
            return scope.getTransaction();
        }
    }
    return undefined;
}
//# sourceMappingURL=vue.js.map

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export App */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_main_css__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Workspace__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_Keymap__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_ErrorHandler__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_CommonPopup__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_ConfirmPopup__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_ToolTip__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Toast__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_socket_io_client__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_socket_io_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__config_app_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helpers_ScreenshotHelper__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_deck_css__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_deck_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__styles_deck_css__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var socket=void 0;var actionCount=0;var lastVersionSavedTime=new Date();function getCookie(name){var cookieValue=null;if(document.cookie&&document.cookie!==''){var cookies=document.cookie.split(';');for(var i=0;i<cookies.length;i++){var cookie=cookies[i].trim();// Does this cookie string begin with the name we want?
if(cookie.substring(0,name.length+1)===name+'='){cookieValue=decodeURIComponent(cookie.substring(name.length+1));break;}}}return cookieValue;}var App=function(_React$Component){_inherits(App,_React$Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.loadProjectData=function(){try{var params=new URLSearchParams(window.location.search);return __WEBPACK_IMPORTED_MODULE_16_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a["APIURIS"][__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a["APIURIS"]["current"]]+'getSlidesRenderProjectData/',headers:{"X-CSRFToken":getCookie("csrftoken"),"Authorization":getCookie("encoded_token")},data:params});}catch(err){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])("Error in loadProjectData",err,"Server-loadProjectData");}};_this.loadLanguage=function(){try{var params=new URLSearchParams();params.append('l',_this.props.langToLoad);params.append('u',_this.props.userId);params.append('from','deck');return __WEBPACK_IMPORTED_MODULE_16_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a["APIURIS"][__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a["APIURIS"]["current"]]+'deck/glangd/',headers:{"X-CSRFToken":getCookie("csrftoken"),"Authorization":getCookie("encoded_token")},data:params});}catch(err){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])('Error in loadLanguage ',err,"Server-loadLanguage");}};_this.startApp=function(){try{var langRes=_this.loadLanguage();langRes.then(function(lresp){_this.setState({appLangData:lresp.data});var resp=_this.loadProjectData();resp.then(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resp){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(resp.status===200)){_context.next=8;break;}_context.next=3;return this.validateSource(resp.data.project);case 3:this.removeConflictData(resp.data.project.scenes);this.writeLoaderData(resp.data.project);// Taking the items into an array to check for loading later.
this.props.initiateProject(resp.data);this.props.appLoadProgess(20);this.setState({loaded:true});case 8:case'end':return _context.stop();}}},_callee,this);}));return function(_x){return _ref.apply(this,arguments);};}().bind(_this),function(error){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])("error in StartApp",error,"server-startApp");});}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])('Error in loadLanguage call',err,"server-startApp");});}catch(err){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])('Error in startApp ',err,"server-startApp");}};_this.handleConnectionChange=function(e){if(e.type==="online"&&!_this.state.isConnected){_this.setState({isConnected:true});}else if(e.type==="offline"){_this.setState({isConnected:false});}};_this.handleMouseClick=function(e){try{if(e.target.id!=='full-screen'&&e.target.id!=='fullScreen'&&e.target.id!=='next-slide'&&e.target.id!=='previous-slide'&&e.target.id!=='prevSlide'&&e.target.id!=='nextSlide'&&!e.target.closest('a')){if(_this.props.isFullScreen&&_this.props.isPlayAll){_this.props.setPlayerPosition();if(_this.props.t1.currentLabel()>=_this.props.t1.getLabelsArray().length-1){document.getElementById('nextSlide').src=_this.appUrl+"/images/playerControls-icons/next-disable.svg";document.getElementById('nextSlide').style.cursor='auto';document.getElementById('next-slide').style.cursor='auto';}if(_this.props.t1.currentLabel()!==null){document.getElementById('prevSlide').src=_this.appUrl+"/images/playerControls-icons/previous.svg";document.getElementById('prevSlide').style.cursor='pointer';document.getElementById('previous-slide').style.cursor='pointer';}}}}catch(error){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"App-handleMouseClick");}};_this.redirectPayment=function(){try{var _this$props=_this.props,teamId=_this$props.teamId,_manageToast=_this$props.manageToast,_setPaymentPastDue=_this$props.setPaymentPastDue,_setWorkspaceTextFocus=_this$props.setWorkspaceTextFocus;}catch(err){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(err,err.message,"App-PaymentDueFailed");}};_this.appUrl=__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a['APPICONS'][__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a['APPICONS']['current']];_this.frameUrl=__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a['FRAME_ASSET'][__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a['FRAME_ASSET']['current']];_this.assetUrl=__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a['ASSETS'][__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a['ASSETS']['current']];_this.apiUrl=__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a['APIURIS'][__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a['APIURIS']['current']];_this.logoutURL=__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a["APIURIS"][__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a["APIURIS"]["current"]]+'logout';_this.handleKeyDown=_this.handleKeyDown.bind(_this);_this.handleKeyUp=_this.handleKeyUp.bind(_this);_this.state={loaded:false,isConnected:true,errorThrown:false,authError:false,sesError:false,libraryWidth:70,menuHeight:60,bottomPlayerHeight:100,liteRightWindow:370,liteScenesHeight:200,worksheet:[{id:1,data:"One",color:'pink'},{id:2,data:"Two",color:'#F0FFFF'},{id:3,data:"Three",color:'#FFE4C4'},{id:4,data:"Four",color:'#6495ED'},{id:5,data:"Five",color:'#008B8B'},{id:6,data:"Six",color:'#00BFFF'},{id:7,data:"Seven",color:'#DAA520'},{id:8,data:"Eight",color:'#F08080'},{id:9,data:"Nine",color:'#778899'},{id:10,data:"Ten",color:'#9370DB'},{id:11,data:"Eleven",color:'#FFDEAD'},{id:12,data:"Twelve",color:'#FFDAB9'},{id:13,data:"Thirteen",color:'#A0522D'},{id:14,data:"Fourteen",color:'#FF6347'},{id:15,data:"Fifteen",color:'#9ACD32'}],appLangData:{},sceenPosition:1,screenPressed:false,selectedItems:Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["fromJS"])(["alwqde1534929278802"]),playerControl:"",workspace:"",slides:"",menuBar:"",library:"",textProperty:"",setAnimaker:false,toolTipData:{}};_this.changeBoxes=_this.changeBoxes.bind(_this);_this.appLoadingCompleted=_this.appLoadingCompleted.bind(_this);_this.socketId="";_this.maxCount=__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a["VERSION"]["maxCount"];_this.maxSeconds=__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a["VERSION"]["maxSeconds"];if(_this.props.mode==='slide'){socket=__WEBPACK_IMPORTED_MODULE_13_socket_io_client___default.a.connect(__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a["SOCKETURIS"][__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a["SOCKETURIS"]["current"]],{transports:['websocket'],query:"pr="+_this.props.projectid+"&mode=1"});}else{socket=__WEBPACK_IMPORTED_MODULE_13_socket_io_client___default.a.connect(__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a["SOCKETURIS"][__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a["SOCKETURIS"]["current"]],{transports:['websocket'],query:"pr="+_this.props.projectid});}socket.on('connect',function(){if(!_this.state.isConnected)_this.setState({isConnected:true});socket.on('disconnect',function(reason){if(reason==='io server disconnect'){// the disconnection was initiated by the server, you need to reconnect manually
socket.connect();}if(_this.state.isConnected)_this.setState({isConnected:false});// else the socket will automatically try to reconnect
});});socket.on('disconnect',function(reason){if(reason==='io server disconnect'){// the disconnection is initiated by the server, you need to reconnect manually
socket.disconnect();_this.setState({authError:true});}_this.setState({isConnected:false});});socket.on('authenticated',function(){if(_this.props.mode!=='slide'){socket.emit('adduser',_this.props.userId,null,_this.props.projectUsrImg,_this.props.projectUsr);}_this.props.loadProject(_this.props.projectid,_this.props.projectUsr,_this.props.mode,_this.props.userId,_this.props.projectUsrImg,socket.id);_this.props.loadUserFonts(_this.props.projectid,_this.props.userId,socket.id);_this.props.setUserDetails({userId:_this.props.userId,projectId:_this.props.projectid,teamId:_this.props.teamId});_this.props.loadSceneThumbs({userId:_this.props.userId,projectId:_this.props.projectid});});socket.on('connect_error',function(error){// ...
// console.log("connection error");
});socket.on('connect_timeout',function(timeout){// console.log("connection timeout");
_this.setState({isConnected:false});// ...
});// socket.on('error', (error) =>
// {
//     // ...
//     // console.log("connection error");
//     if(error === 'authentication error'){
//         socket.disconnect();
//         this.setState({ authError: true })   
//     }
//     else if(error === 'Internal server error'){
//         socket.disconnect();
//         this.setState({ errorThrown: true }) 
//     }
//     else{
//     this.setState({ isConnected: false })
//     }
// });
socket.on('unauthorised',function(reason,socketId){if(reason==='authentication error'){socket.disconnect();_this.setState({authError:true});}else if(reason==='Internal server error'){socket.disconnect();_this.setState({errorThrown:true});}else{_this.setState({isConnected:false});}});socket.on('reconnect',function(attemptNumber){// ...
// console.log("reconnect", attemptNumber);
_this.setState({isConnected:false});});socket.on('reconnect_attempt',function(attemptNumber){// console.log("reconnect attempt", attemptNumber);
_this.setState({isConnected:false});// ...
});socket.on('reconnecting',function(attemptNumber){// console.log("reconnecting", attemptNumber);
_this.setState({isConnected:false});// ...
});socket.on('reconnect_error',function(error){// ...
// console.log("reconnect_error", error);
_this.setState({isConnected:false});});socket.on('reconnect_failed',function(){// ...
// console.log("reconnect_failed");
_this.setState({isConnected:false});});var timeout;_this.processingTimeOut=function(socketId){timeout=setTimeout(function(){if(!_this.props.isNewAction)socket.emit('saveme',_this.props.projectId,socketId);},2000);};socket.on('createversionComplete',function(userName,socketid){if(_this.props.propertyWindow.get('isOpened')&&_this.props.propertyWindow.get('component')==='history'){var _this$props2=_this.props,projectid=_this$props2.projectid,userId=_this$props2.userId,teamId=_this$props2.teamId;var date=new Date();var timeZone=(-date.getTimezoneOffset()<0?'-':'+')+(Math.abs(date.getTimezoneOffset()/60)<10?'0':'')+Math.floor(Math.abs(date.getTimezoneOffset()/60))+':'+(Math.abs(date.getTimezoneOffset()%60)<10?'0':'')+Math.abs(date.getTimezoneOffset()%60);var url=_this.apiUrl+'deck/v/gav';var params=new URLSearchParams();params.append("projectid",projectid);params.append("userid",userId);params.append("teamid",teamId);// params.append("from",0);
// params.append("size",20)
params.append("tz",timeZone);__WEBPACK_IMPORTED_MODULE_16_axios___default()({method:'post',url:url,headers:{"Content-Type":"application/x-www-form-urlencoded","X-CSRFToken":getCookie("csrftoken"),"Authorization":getCookie("encoded_token")},data:params}).then(function(response){if(response.status===200&&Object.keys(response.data).length!==0){this.props.addVersionHistory(response.data);}}.bind(_this)).catch(function(error){if(error.response.status!==422){this.props.manageToast({action:"add",type:"error","message":"common.toast.msg",subMessage:"common.toast.submsg",formatId:"both"});}}.bind(_this));}});socket.on('restoreChecking',function(userName,socketid){if(socketid===socket.id){socket.emit('restoreCheck',userName);}else{_this.setState({isRestoring:true,restoreUser:userName});}});socket.on('restoreStartComplete',function(userName,socketid){if(socketid===socket.id){var _this$props3=_this.props,projectid=_this$props3.projectid,userId=_this$props3.userId,teamId=_this$props3.teamId,versionId=_this$props3.versionId;var url=_this.apiUrl+'deck/v/rsv/';var params=new URLSearchParams();params.append("projectid",projectid);params.append("userid",userId);params.append("teamid",teamId);params.append("versionid",versionId);__WEBPACK_IMPORTED_MODULE_16_axios___default()({method:'post',url:url,headers:{"Content-Type":"application/x-www-form-urlencoded","X-CSRFToken":getCookie("csrftoken"),"Authorization":getCookie("encoded_token")},data:params}).then(function(response){if(response.status===200){// this.removeConflictData(response.data.project.scenes);
// console.log(response.data)
// this.props.initiateProject(response.data);
// this.props.appLoadProgess(20); 
// this.props.projectRestore({versionId:null,isRestore:false,isEmit:false},socket); 
// this.props.setPropertyWindow({'component' : ''});
socket.emit('restored',userName);// actionCount=0;
// let dateNow = new Date();
// lastVersionSavedTime = dateNow;
window.location.reload();}}.bind(_this)).catch(function(error){if(error.response.status===422){this.props.manageToast({action:"add",type:"error","message":error.response.message,formatId:"msg"});}else if(error.response.status===401){this.props.manageToast({action:"add",type:"error","message":error.response.message,formatId:"msg"});}else{this.props.manageToast({action:"add",type:"error","message":"common.toast.msg",subMessage:"common.toast.submsg",formatId:"both"});}}.bind(_this));}else{_this.setState({isRestoring:true,restoreUser:userName});}});socket.on('restoredComplete',function(userName,socketid){_this.props.projectRestore({versionId:null,isRestore:false,isEmit:false},socket);_this.setState({isRestoring:false,isRestored:true,restoreCheck:false});if(socket.id===socketid){_this.setState({restoreUser:null});setTimeout(function(){_this.setState({isRestored:false});},1500);}else{_this.setState({restoreUser:userName});}});socket.on('restoring',function(socketid){if(socket.id===socketid)_this.setState({restoreCheck:true});});socket.on('processing',function(socketId){_this.props.setNewActionComplete(false);clearTimeout(timeout);_this.processingTimeOut(socketId);});_this.checkVersion=function(){var currentDate=new Date();var diffSeconds=(currentDate-lastVersionSavedTime)/1000;if(diffSeconds>_this.maxSeconds){socket.emit("createversion",1,_this.props.userId);actionCount=0;lastVersionSavedTime=currentDate;}else{if(actionCount>_this.maxCount){socket.emit("createversion",2,_this.props.userId);actionCount=0;lastVersionSavedTime=currentDate;}}};socket.on('addSceneComplete',function(slideIndex,newslide,socketId){if(socketId!==socket.id)_this.props.addSceneComplete(slideIndex,newslide,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('projectSaveException',function(data,slideIndex,newslide,socketId){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(data,{slideIndex:slideIndex,newslide:newslide},"Server-projectSaveException");_this.setState({errorThrown:true});});socket.on('duplicateSceneComplete',function(slideIndex,newslide,socketId){if(socketId!==socket.id)_this.props.duplicateSceneComplete(slideIndex,newslide,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('addObjectComplete',function(selectedScene,workspaceIds,workspaceData,workspaceChildrenIds,workspaceChildData,socketId){if(socketId!==socket.id)_this.props.addObjComplete(selectedScene,workspaceIds,workspaceData,workspaceChildrenIds,workspaceChildData,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('moveUpdateComplete',function(selectedScene,workspaceItems,workspaceChildren,currentContainer,socketId){if(socketId!==socket.id)_this.props.moveUpdateComplete(selectedScene,workspaceItems,workspaceChildren,currentContainer,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('removeSceneComplete',function(slideIndex,socketId){if(socketId!==socket.id)_this.props.removeSceneComplete(slideIndex,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('addSceneTransitionComplete',function(slideIndex,transitionName,sizes,socketId){if(socketId!==socket.id)_this.props.addSceneTransitionComplete(slideIndex,transitionName,sizes,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('changeSceneTransColorComplete',function(selectedScene,color,socketId){if(socketId!==socket.id)_this.props.changeSceneTransColorComplete(selectedScene,color,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('changeExpressionComplete',function(selectedIndex,itemId,itemLabel,socketId){if(socketId!==socket.id)_this.props.changeExpressionComplete(selectedIndex,itemId,itemLabel,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('changeActionComplete',function(selectedIndex,itemId,itemLabel,socketId){if(socketId!==socket.id)_this.props.changeActionComplete(selectedIndex,itemId,itemLabel,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('changeBgComplete',function(selectedScene,workspaceBG,deleteId,deleteData,socketId){if(socketId!==socket.id)_this.props.changeBgComplete(selectedScene,workspaceBG,deleteId,deleteData,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('deleteBgComplete',function(selectedScene,socketId){if(socketId!==socket.id)_this.props.deleteBgComplete(selectedScene,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('changeVideoVolumeComplete',function(selectedScene,objectId,socketId){if(socketId!==socket.id)_this.props.changeVideoVolumeComplete(selectedScene,objectId,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('applyFilterComplete',function(selectedScene,objectId,objectData,socketId){if(socketId!==socket.id)_this.props.applyFilterComplete(selectedScene,objectId,objectData,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('updateSvgColorComplete',function(selectedScene,container,itemId,itemCls,colorData,socketId){if(socketId!==socket.id)_this.props.updateSvgColorComplete(selectedScene,container,itemId,itemCls,colorData,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('updateSvgThemeComplete',function(projectid,selectedScene,container,itemId,colorData,isBG,socketId){if(socketId!==socket.id)_this.props.updateSvgThemeComplete(projectid,selectedScene,container,itemId,colorData,isBG,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('cropImageComplete',function(selectedScene,itemId,objectData,socketId){if(socketId!==socket.id)_this.props.cropImageComplete(selectedScene,itemId,objectData,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('flipItemComplete',function(selectedScene,itemId,flipPosition,socketId){if(socketId!==socket.id)_this.props.flipItemComplete(selectedScene,itemId,flipPosition,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('cropBgComplete',function(selectedScene,objectData,isVideo,videoId,bgScales,socketId){if(socketId!==socket.id)_this.props.cropBgComplete(selectedScene,objectData,isVideo,videoId,bgScales,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('bgColorSelectionComplete',function(selectedScene,objectData,socketId){if(socketId!==socket.id)_this.props.bgColorSelectionComplete(selectedScene,objectData,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('bgGradientColorsComplete',function(selectedScene,radialStatus,direction,radius,socketId){if(socketId!==socket.id)_this.props.bgGradientColorsComplete(selectedScene,radialStatus,direction,radius,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('changeTextComplete',function(selectedScene,currentContainer,itemId,objectData,socketId){var selfUpdate=socketId!==socket.id;if(socketId!==socket.id)_this.props.changeTextComplete(selectedScene,currentContainer,itemId,objectData,socketId,socket.id,selfUpdate);else{actionCount++;_this.checkVersion();}});socket.on('groupObjectsComplete',function(selectedScene,removeIds,workspaceItems,workspaceChildren,workspaceItemsOrder,socketId){if(socketId!==socket.id)_this.props.groupObjectsComplete(selectedScene,removeIds,workspaceItems,workspaceChildren,workspaceItemsOrder,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('ungroupObjectsComplete',function(selectedScene,removeIds,workspaceChildren,workspaceItemsOrder,socketId){if(socketId!==socket.id)_this.props.ungroupObjectsComplete(selectedScene,removeIds,workspaceChildren,workspaceItemsOrder,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('deleteItemComplete',function(selectedScene,workspaceIds,workspaceChildrenIds,indexChangeIds,socketId){if(socketId!==socket.id)_this.props.deleteItemComplete(selectedScene,workspaceIds,workspaceChildrenIds,indexChangeIds,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('setZIndexComplete',function(selectedScene,indexChangeIds,socketId){if(socketId!==socket.id)_this.props.setZIndexComplete(selectedScene,indexChangeIds,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('updateTimelineDragChangeComplete',function(selectedScene,itemData,actionData,idVal,childToUpdate,socketId){if(socketId!==socket.id)_this.props.updateTimelineDragChangeComplete(selectedScene,itemData,actionData,idVal,childToUpdate,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('pasteItemsComplete',function(selectedScene,workspaceIds,workspaceChildrenIds,workspaceData,workspaceChildData,socketId){if(socketId!==socket.id)_this.props.pasteItemsComplete(selectedScene,workspaceIds,workspaceChildrenIds,workspaceData,workspaceChildData,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on('updateTextComplete',function(isGrouped,selectedScene,selectedId,container,formats,childIds,socketId){var selfUpdate=socketId!==socket.id;if(socketId!==socket.id)_this.props.updateTextComplete(isGrouped,selectedScene,selectedId,container,formats,childIds,socketId,socket.id,selfUpdate);else{actionCount++;_this.checkVersion();}});socket.on('updateGroupTextComplete',function(selectedScene,workspaceItems,workspaceChildren,socketId){var selfUpdate=socketId!==socket.id;if(socketId!==socket.id)_this.props.updateGroupTextComplete(selectedScene,workspaceItems,workspaceChildren,socketId,socket.id,selfUpdate);else{actionCount++;_this.checkVersion();}});socket.on("pasteScenesComplete",function(selectedScene,scenes,socketId){if(socketId!==socket.id)_this.props.pasteScenesComplete(selectedScene,scenes,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on("setSelectedItemsComplete",function(projectid,selectedItems,projectUsr,userId,projectUsrImg,socketid){_this.props.setSelectedItemsComplete(projectid,selectedItems,projectUsr,userId,projectUsrImg,socketid,socket.id);});socket.on("setSelectedSceneComplete",function(projectid,selectedItems,projectUsr,userId,projectUsrImg,socketid){_this.props.setSelectedSceneComplete(projectid,selectedItems,projectUsr,userId,projectUsrImg,socketid,socket.id);});socket.on("updateBgColorComplete",function(selectedScene,Cls,color,socketId){if(socketId!==socket.id)_this.props.updateBgColorComplete(selectedScene,Cls,color,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on("updateBgGradientComplete",function(selectedScene,gradientIndex,gradientSecIndex,color,socketId){if(socketId!==socket.id)_this.props.updateBgGradientComplete(selectedScene,gradientIndex,gradientSecIndex,color,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on("connectionComplete",function(projectId,userId,selectedItems,imageUrl,projectUsr,socketId){_this.props.socketConnected(projectId,userId,selectedItems,imageUrl,projectUsr,socketId,socket.id);socket.emit('sendData',{userId:_this.props.userId,selectedItems:_this.props.selectedItems,selectedScene:_this.props.selectedScene,imageUrl:_this.props.projectUsrImg,userName:_this.props.projectUsr,socketId:socket.id});});socket.on("changeAnimationTypeComplete",function(selectedScene,itemId,value,socketId){if(socketId!==socket.id)_this.props.changeAnimationTypeComplete(selectedScene,itemId,value,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on("moveSceneComplete",function(projectid,newIndex,oldIndex,socketId){if(socketId!==socket.id)_this.props.moveSceneComplete(projectid,newIndex,oldIndex,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on("updateSceneValueComplete",function(projectid,selectedScene,toUpdate,toEmit,socketId){if(socketId!==socket.id)_this.props.updateSceneComplete(projectid,selectedScene,toUpdate,toEmit,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on("updateBgComplete",function(projectid,selectedScene,toUpdate,socketId){if(socketId!==socket.id)_this.props.updateBgComplete(projectid,selectedScene,toUpdate,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on("updateProjectComplete",function(projectid,toUpdate,socketId){if(socketId!==socket.id)_this.props.updateProjectComplete(projectid,toUpdate,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on("updateObjectComplete",function(projectid,selectedScene,selectedItem,container,toUpdate,socketId){if(socketId!==socket.id)_this.props.updateObjectComplete(projectid,selectedScene,selectedItem,container,toUpdate,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on("addPrebuiltComplete",function(selectedScene,prebuiltData,replace,addAll,socketId){if(socketId!==socket.id)_this.props.addPrebuiltComplete(selectedScene,prebuiltData,replace,addAll,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on("disconnectComplete",function(socketId){_this.props.socketDisconnected(socketId);});socket.on("sendDataComplete",function(data,socketId){if(socketId!==socket.id)_this.props.newSocketConnected(data);});socket.on("applyEnterEffectComplete",function(projectid,selectedScene,effectData,isUndo,sceneEffectData,socketId){if(socketId!==socket.id)_this.props.applyEnterEffectComplete(projectid,selectedScene,effectData,isUndo,sceneEffectData,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on("applyAllTransitionComplete",function(projectid,transData,isUndo,seceneTransData,socketId){if(socketId!==socket.id)_this.props.applyAllTransitionComplete(projectid,transData,isUndo,seceneTransData,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on("addLinkToTextComplete",function(projectid,selectedScene,container,selectedItem,hyperLinkData,socketId){if(socketId!==socket.id)_this.props.addLinkToTextComplete(projectid,selectedScene,container,selectedItem,hyperLinkData,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on("addLinkToObjComplete",function(projectid,selectedScene,selectedItem,linkData,socketId){if(socketId!==socket.id)_this.props.addLinkToObjComplete(projectid,selectedScene,selectedItem,linkData,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on("onWorkspaceItemsOrderComplete",function(projectId,selectedScene,container,workspaceItemsOrder,socketId){if(socketId!==socket.id)_this.props.setWorkspaceItemsOrderComplete(projectId,selectedScene,container,workspaceItemsOrder,socketId,socket.id);else{actionCount++;_this.checkVersion();}});socket.on("onSetAnimateValueComplete",function(projectid,selectedScene,container,selectedItem,animateData,socketId){if(socketId!==socket.id)_this.props.setAnimateValueComplete(projectid,selectedScene,container,selectedItem,animateData,socketId);else{actionCount++;_this.checkVersion();}});socket.on('userSessionClosed',function(data){if(data.user===_this.props.userId){socket.disconnect();_this.setState({sesError:true});}});return _this;}_createClass(App,[{key:'checkIsAssetExist',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(url,key){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return __WEBPACK_IMPORTED_MODULE_16_axios___default.a.get(url);case 3:response=_context2.sent;return _context2.abrupt('return',response.status);case 7:_context2.prev=7;_context2.t0=_context2['catch'](0);console.log(_context2.t0,key);return _context2.abrupt('return',403);case 11:case'end':return _context2.stop();}}},_callee2,this,[[0,7]]);}));function checkIsAssetExist(_x2,_x3){return _ref2.apply(this,arguments);}return checkIsAssetExist;}()},{key:'validateSource',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(project){var workspaceHeight,workspaceWidth,scenes,sceneNo,scene,workspaceItems,workspaceChildren,workspaceBG,transEffect,bgTypes,type,subType,src,sourceType,configBasePath,backgroundSource,status;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;workspaceHeight=project.workspaceHeight,workspaceWidth=project.workspaceWidth,scenes=project.scenes;console.log('inside validate src');_context3.t0=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(scenes);case 4:if((_context3.t1=_context3.t0()).done){_context3.next=25;break;}sceneNo=_context3.t1.value;scene=scenes[sceneNo];workspaceItems=scene.workspaceItems,workspaceChildren=scene.workspaceChildren,workspaceBG=scene.workspaceBG,transEffect=scene.transEffect;_context3.next=10;return this.validateWsItemsSrc(workspaceItems,workspaceWidth,workspaceHeight);case 10:_context3.next=12;return this.validateWsItemsSrc(workspaceChildren,workspaceWidth,workspaceHeight);case 12:bgTypes=["BG","IMG","UPIMAGE"];type=workspaceBG.type,subType=workspaceBG.subType,src=workspaceBG.src;sourceType=workspaceBG.sourceType;if(!(src&&bgTypes.includes(type))){_context3.next=23;break;}configBasePath="",backgroundSource="";// if (type === 'UPIMAGE' && sourceType.toLowerCase() !== "gif") {
//     let typrToSet = 'UPLOADS', uploadfileUrl = "";
//     configBasePath = config[typrToSet][config[typrToSet].workspace_UPIMAGE];
//     backgroundSource = configBasePath + src;
//     if (src.split("/").length == 3) {
//         var fileName
//         if (sourceType != undefined)
//             fileName = src.split("/")[2].split(".")[0] + "." + sourceType;
//         else
//             fileName = src.split("/")[2].split(".")[0] + ".jpg"
//         uploadfileUrl = src.split("/")[0] + "/" + src.split("/")[1] + "/" + fileName
//         backgroundSource = configBasePath + uploadfileUrl
//     }
//     else {
//         var fileName
//         if (sourceType != undefined)
//             fileName = src.split("/")[3].split(".")[0] + "." + sourceType;
//         else
//             fileName = src.split("/")[3].split(".")[0] + ".jpg";
//         uploadfileUrl = src.split("/")[0] + "/" + src.split("/")[1] + "/" + fileName
//         backgroundSource = configBasePath + uploadfileUrl
//     }
// }
// else 
if(type==="BG"){if(workspaceBG.subType==='EBG'){configBasePath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a['EBG'][__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a["EBG"].workspace];backgroundSource=configBasePath+workspaceBG.src;}else{configBasePath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a[type][__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a[type].workspace];backgroundSource=configBasePath+workspaceBG.src;}}else if(type==="IMG"&&subType!=='OBGIMG'&&subType!=="GIPHY"){configBasePath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a["BG"]['obgsrc'];backgroundSource=configBasePath+src.replace("/proxy1","");}_context3.next=20;return this.checkIsAssetExist(backgroundSource);case 20:status=_context3.sent;console.log("The status",status);if(status!==200){scene['workspaceBG'].type="";scene['workspaceBG'].src="";}case 23:_context3.next=4;break;case 25:_context3.next=30;break;case 27:_context3.prev=27;_context3.t2=_context3['catch'](0);console.log(_context3.t2);case 30:case'end':return _context3.stop();}}},_callee3,this,[[0,27]]);}));function validateSource(_x4){return _ref3.apply(this,arguments);}return validateSource;}()},{key:'validateWsItemsSrc',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(data,workspaceWidth,workspaceHeight){var item,wsItem,configPath,ImgSrc,projectType,finalPath,_wsItem$src$split,_wsItem$src$split2,src,extension,url,status;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.t0=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(data);case 1:if((_context4.t1=_context4.t0()).done){_context4.next=17;break;}item=_context4.t1.value;wsItem=data[item];configPath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a[wsItem.type][__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a[wsItem.type][wsItem.subType?'workspace_'+wsItem.subType:'workspace']];ImgSrc="";if(wsItem.subType==='EPROP'||wsItem.subType==='GETTYICON'||wsItem.subType==='GRAD'){configPath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a[wsItem.subType][__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a[wsItem.subType]['workspace']];}// if (wsItem.type === "UPLOADS" && wsItem.subType === "UPIMAGE" && wsItem.sourceType.toLowerCase() !== "gif") {
//     configPath = config[wsItem.type][config[wsItem.type][(wsItem.subType) ? 'workspace_' + wsItem.subType : 'workspace']];
//     let uploadfileUrl = "";
//     if (wsItem.src.split("/").length == 3) {
//         var fileName
//         if (wsItem.sourceType != undefined)
//             fileName = wsItem.src.split("/")[2].split(".")[0] + "." + wsItem.sourceType;
//         else
//             fileName = wsItem.src.split("/")[2].split(".")[0] + ".jpg"
//         uploadfileUrl = wsItem.src.split("/")[0] + "/" + wsItem.src.split("/")[1] + "/" + fileName
//         ImgSrc = configPath + uploadfileUrl
//     }
//     else {
//         var fileName
//         if (wsItem.sourceType != undefined)
//             fileName = wsItem.src.split("/")[3].split(".")[0] + "." + wsItem.sourceType;
//         else
//             fileName = wsItem.src.split("/")[3].split(".")[0] + ".jpg";
//         uploadfileUrl = wsItem.src.split("/")[0] + "/" + wsItem.src.split("/")[1] + "/" + fileName
//         ImgSrc = configPath + uploadfileUrl
//     }
// }
// else 
if(wsItem.subType==='OBGIMG'){// configPath = this.assetUrl + config["BG"]['obgsrc'] + wsItem.src.replace("proxy1/", "");
// ImgSrc = configPath;
}else if(wsItem.subType==='ECHR'||wsItem.type==="SCR"||wsItem.subType==="EMOJI"||wsItem.subType==='ANIMAL'){if(wsItem.type==='SCR'){projectType=workspaceWidth>workspaceHeight?"horizontal":workspaceHeight>workspaceWidth?"vertical":"square";configPath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a[wsItem.type][__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a[wsItem.type]['workspace']]+projectType+'/';}else if(wsItem.subType==='ECHR')configPath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a[wsItem.subType][__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a[wsItem.subType]['workspace']];else if(wsItem.subType==='ANIMAL'){configPath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a["CHR"][__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a["CHR"]['workspace']];}else configPath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a[wsItem.type][__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a[wsItem.type]['workspace']];}finalPath="";if(wsItem.type==='PROP'||wsItem.type==="CHR"||wsItem.type==="SCR"){finalPath=configPath+wsItem.src;if(wsItem.subType==="CHR"||wsItem.subType==="CCHR"){_wsItem$src$split=wsItem.src.split('.'),_wsItem$src$split2=_slicedToArray(_wsItem$src$split,2),src=_wsItem$src$split2[0],extension=_wsItem$src$split2[1];configPath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a[wsItem.subType][__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a[wsItem.subType]['workspace']];url=src+'-'+wsItem.expression+'.'+extension;finalPath=configPath+url;}}else if(wsItem.type==="UPLOADS"&&wsItem.subType==="UPIMAGE"&&wsItem.sourceType.toLowerCase()!=="gif"||wsItem.subType==='OBGIMG'){// finalPath = ImgSrc;
// var srcType = wsItem.sourceType ? wsItem.sourceType : wsItem.src.split(".")[wsItem.src.split(".").length - 1];
// if (wsItem.type === 'UPLOADS' && srcType.toLowerCase().includes('svg')) {
//     finalPath = configPath + wsItem.src;
// }
}else if(wsItem.type==="FRAME"||wsItem.type==="GRID"){configPath=''+this.frameUrl+[__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a[wsItem.type].DEFAULT_IMAGE];finalPath=''+configPath;// console.log(finalPath)
}if(!(finalPath!=="")){_context4.next=15;break;}_context4.next=13;return this.checkIsAssetExist(finalPath,item);case 13:status=_context4.sent;if(status!==200){delete data[item];}case 15:_context4.next=1;break;case 17:case'end':return _context4.stop();}}},_callee4,this);}));function validateWsItemsSrc(_x5,_x6,_x7){return _ref4.apply(this,arguments);}return validateWsItemsSrc;}()},{key:'removeConflictData',value:function removeConflictData(scenes){for(var i=0;i<scenes.length;i++){var ChildrenIds=[];for(var key in scenes[i].workspaceItems){if(scenes[i].workspaceItems[key].type==="GROUP"){for(var m=0;m<scenes[i].workspaceItems[key].groupChildren.length;m++){ChildrenIds.push(scenes[i].workspaceItems[key].groupChildren[m]);}}var wsItem=scenes[i].workspaceItems[key];if(wsItem.type==="FRAME"){var clipDetails=wsItem.clipDetails;if(clipDetails){for(var clipKey in clipDetails){var imgDetails=clipDetails[clipKey]["imgDetails"];if(imgDetails){if(imgDetails.src.includes("blob:")){delete scenes[i].workspaceItems[key];}}}}}else if(wsItem.type==="GRID"){var gridCells=wsItem.gridData&&wsItem.gridData.gridCells;if(gridCells){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=Object.values(gridCells)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var cell=_step.value;var _imgDetails=cell.imgDetails;if(_imgDetails){if(_imgDetails.src&&_imgDetails.src.includes("blob:")){delete scenes[i].workspaceItems[key];break;}}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}}}for(var key in scenes[i].workspaceChildren){if(!ChildrenIds.includes(key)){delete scenes[i].workspaceChildren[key];}}}}},{key:'writeLoaderData',value:function writeLoaderData(data){var isItemPresent=false;var assetArr=[];for(var i=0;i<data.scenes.length;i++){for(var key in data.scenes[i].workspaceItems){var itemType=data.scenes[i].workspaceItems[key].type;var itemSourceType=data.scenes[i].workspaceItems[key].sourceType;isItemPresent=true;if(itemType==="FRAME"){var clipDetails=data.scenes[i].workspaceItems[key].clipDetails;if(clipDetails){for(var clipKey in clipDetails){var imgDetails=clipDetails[clipKey]["imgDetails"];itemSourceType=imgDetails["sourceType"];if(imgDetails){if(imgDetails.subType!=="GIPHY"){if(!imgDetails.src.includes("blob:")){var imageId=clipKey+'-'+key;assetArr.push(imageId);}}}}}}else if(itemType==="GRID"){var item=data.scenes[i].workspaceItems[key];var gridCells=item.gridData&&item.gridData.gridCells;if(gridCells){var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=Object.entries(gridCells)[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var _ref5=_step2.value;var _ref6=_slicedToArray(_ref5,2);var cellId=_ref6[0];var cell=_ref6[1];var _imgDetails2=cell.imgDetails;if(_imgDetails2){if(_imgDetails2.subType!=="GIPHY"){if(!_imgDetails2.src.includes("blob:")){var _imageId=cellId+'-'+key;assetArr.push(_imageId);}}}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}}}for(var key in data.scenes[i].workspaceChildren){var _itemType=data.scenes[i].workspaceChildren[key].type;var _itemSourceType=data.scenes[i].workspaceChildren[key].sourceType;if(_itemType==="FRAME"){var _clipDetails=data.scenes[i].workspaceChildren[key].clipDetails;if(_clipDetails){for(var _clipKey in _clipDetails){var _imgDetails3=_clipDetails[_clipKey]["imgDetails"];_itemSourceType=_imgDetails3["sourceType"];if(_imgDetails3){// let isVideoObj = this.isVideo(imgDetails.type, imgDetails.subType);
if(_imgDetails3.subType!=="GIPHY"){if(!_imgDetails3.src.includes("blob:")){var _imageId2=_clipKey+'-'+key;assetArr.push(_imageId2);}}}}}}else if(_itemType==="GRID"){var _item=data.scenes[i].workspaceChildren[key];var _gridCells=_item.gridData&&_item.gridData.gridCells;if(_gridCells){var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=Object.entries(_gridCells)[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var _ref7=_step3.value;var _ref8=_slicedToArray(_ref7,2);var _cellId=_ref8[0];var _cell=_ref8[1];var _imgDetails4=_cell.imgDetails;if(_imgDetails4){if(_imgDetails4.subType!=="GIPHY"){if(!_imgDetails4.src.includes("blob:")){var _imageId3=_cellId+'-'+key;assetArr.push(_imageId3);}}}}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}}}}}window.totalArr=assetArr;this.props.setAssetArray(assetArr);}// onUnload = (e) => { 
//   e.preventDefault();
//   if(actionCount>0)
//   {
//   socket.emit("createversion",3, this.props.userId);
//   }
//  }
},{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('keydown',this.handleKeyDown,false);window.addEventListener('keyup',this.handleKeyUp,false);// window.addEventListener('beforeunload', this.onUnload,false );
window.addEventListener('online',this.handleConnectionChange);window.addEventListener('offline',this.handleConnectionChange);this.startApp();this.props.updateUserActive(this.props.userStatus);var link=document.createElement("link");link.id="NotoSansFallback";link.rel="stylesheet";link.href=this.assetUrl+"animaker/admin-fonts/NotoSansFallback.css";;document.getElementsByTagName("head")[0].appendChild(link);}},{key:'componentWillUnmount',value:function componentWillUnmount(){socket.disconnect();window.removeEventListener('keydown',this.handleKeyDown,false);window.removeEventListener('keyup',this.handleKeyUp,false);window.removeEventListener('online',this.handleConnectionChange);window.removeEventListener('offline',this.handleConnectionChange);//window.removeEventListener("beforeunload", this.onUnload,false );
}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps!==this.props&&nextProps.appLoadProgressValue<=100){var loadingScreen=document.getElementById('app-start-loading-screen');var loader=document.querySelector(".loaderbar2");if(loader){loader.style.width=nextProps.appLoadProgressValue+"%";}if(loadingScreen&&nextProps.appLoadProgressValue===100){loadingScreen.style.display='none';}}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.appLoadProgressValue!==this.props.appLoadProgressValue&&this.props.appLoadProgressValue===100){var thumbWidth=this.props.projectWidth>this.props.projectHeight?400:this.props.projectWidth<this.props.projectHeight?210:230;var thumbHeight=this.props.projectWidth>this.props.projectHeight?210:this.props.projectWidth<this.props.projectHeight?400:230;Object(__WEBPACK_IMPORTED_MODULE_20__helpers_ScreenshotHelper__["a" /* saveScreenshot */])(thumbWidth,thumbHeight).then(function(res){if(res!==null)this.props.saveScreenshot(this.props.selectedScene,"",res[0],this.props.ownerId,this.props.projectid,this.props.sceneId);}.bind(this));}if((prevProps.templateThumbnails.get("status")!==this.props.templateThumbnails.get("status")&&this.props.templateThumbnails.get("status")==="started"||prevProps.templateThumbnails.get("current")!==this.props.templateThumbnails.get("current"))&&this.props.templateThumbnails.get("status")!=="completed"){this.props.setScene({scene:this.props.templateThumbnails.get("current")});var thumbWidth=this.props.projectWidth>this.props.projectHeight?352:this.props.projectWidth<this.props.projectHeight?198:200;var thumbHeight=this.props.projectWidth>this.props.projectHeight?198:this.props.projectWidth<this.props.projectHeight?352:200;setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_20__helpers_ScreenshotHelper__["a" /* saveScreenshot */])(thumbWidth,thumbHeight).then(function(res){try{if(res!==null){var url=__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a["APIURIS"][__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a["APIURIS"]["current"]]+"app/svest";var params=new URLSearchParams();params.append('userId',this.props.userId);params.append('projectId',this.props.projectid);params.append('project',res[0]);params.append('sceneNo',this.props.templateThumbnails.get("current"));var screenshots={};params.append('screenshots',JSON.stringify(screenshots));__WEBPACK_IMPORTED_MODULE_16_axios___default()({method:'post',url:url,headers:{'Content-Type':'application/x-www-form-urlencoded',"X-CSRFToken":getCookie("csrftoken"),"Authorization":getCookie("encoded_token")},data:params}).then(function(response){var current=this.props.templateThumbnails.get("current");if(current<this.props.templateThumbnails.get("totalScenes")-1){current+=1;}var toUpdate={thumbnails:this.props.templateThumbnails.setIn(["thumbnails",this.props.templateThumbnails.get("thumbnails").size,"status"],"completed").get("thumbnails"),current:current};if(this.props.templateThumbnails.get("current")===this.props.templateThumbnails.get("totalScenes")-1){toUpdate.status="completed";document.getElementById("app-overlay").className="";document.getElementById("app-overlay").style.display="none";document.getElementById("app-overlay").style.zIndex="9";document.getElementById("app-overlay").style.backgroundColor="transparent";document.getElementById("app-overlay").style.background="none";this.props.manageToast({action:"add",type:"success","message":"sv.su",formatId:"msg"});window.open(__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a["APIURIS"][__WEBPACK_IMPORTED_MODULE_19__config_app_json___default.a["APIURIS"]["current"]]+'brand','_blank');}this.props.updateThumbnails(toUpdate);}.bind(this)).catch(function(error){document.getElementById("app-overlay").className="";document.getElementById("app-overlay").style.display="none";document.getElementById("app-overlay").style.zIndex="9";document.getElementById("app-overlay").style.backgroundColor="transparent";document.getElementById("app-overlay").style.background="none";this.props.manageToast({action:"add",type:"error","message":"common.toast.msg",subMessage:"common.toast.submsg",formatId:"both"});this.props.updateThumbnails({thumbnails:Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["fromJS"])([]),current:0,status:"failed"});}.bind(this));}}catch(error){//Error Severity: LOW
//Project Screen Shot
Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])("Error in project screenshot",error,"Animaker-saveScreenshot");}}.bind(this));}.bind(this),500);}}},{key:'getRecordTime',value:function getRecordTime(time){this.setState({voiceTime:time});}},{key:'appLoadingCompleted',value:function appLoadingCompleted(e){var loadingScreen=document.getElementById('app-start-loading-screen');loadingScreen.style.display='none';}},{key:'handleKeyDown',value:function handleKeyDown(e){try{//for the Up and Right arrow   
if(e.which===16)this.setState({workspace:""});if(e.which===38||e.which===39){if(this.props.isPlayAll&&this.props.isFullScreen){this.props.setPlayerPosition();if(this.props.t1.currentLabel()>=this.props.t1.getLabelsArray().length-1){document.getElementById('nextSlide').src=this.appUrl+"/images/playerControls-icons/next-disable.svg";document.getElementById('nextSlide').style.cursor='auto';document.getElementById('next-slide').style.cursor='auto';}if(this.props.t1.currentLabel()!==null){document.getElementById('prevSlide').src=this.appUrl+"/images/playerControls-icons/previous.svg";document.getElementById('prevSlide').style.cursor='pointer';document.getElementById('previous-slide').style.cursor='pointer';}}if(this.props.isPreview===true&&!this.props.isPlayAll){var currentScene=this.props.currentSceneNumber;if(this.props.scenes.count()>1){if(currentScene<this.props.projectData.get('scenes').count()-1){this.props.setScenePosition(this.props.projectData.getIn(['scenes',currentScene+1]),currentScene+1,this.props.projectData.getIn(['scenes',currentScene+1,'startTime']),this.props.projectData.getIn(['scenes',currentScene+1,'duration']));document.getElementById('prevSlide').src=this.appUrl+"/images/playerControls-icons/previous.svg";document.getElementById('prevSlide').style.cursor='pointer';document.getElementById('previous-slide').style.cursor='pointer';}if(currentScene+1>=this.props.projectData.get('scenes').count()-1){document.getElementById('nextSlide').src=this.appUrl+"/images/playerControls-icons/next-disable.svg";document.getElementById('nextSlide').style.cursor='auto';document.getElementById('next-slide').style.cursor='auto';}}}}// for the Down and Left arrow
if(e.which===40||e.which===37){if(this.props.isPlayAll&&this.props.isFullScreen){this.props.setPlayerPosition('Prev');if(this.props.t1.currentLabel()===null){document.getElementById('prevSlide').src=this.appUrl+"/images/playerControls-icons/previous-disable.svg";document.getElementById('prevSlide').style.cursor='auto';document.getElementById('previous-slide').style.cursor='auto';}if(this.props.t1.currentLabel()<this.props.t1.getLabelsArray().length){document.getElementById('nextSlide').src=this.appUrl+"/images/playerControls-icons/next.svg";document.getElementById('nextSlide').style.cursor='pointer';document.getElementById('next-slide').style.cursor='pointer';}}if(this.props.isPreview===true&&!this.props.isPlayAll){if(this.props.scenes.count()>1){if(this.props.currentSceneNumber>0){this.props.setScenePosition(this.props.projectData.getIn(['scenes',this.props.currentSceneNumber-1]),this.props.currentSceneNumber-1,this.props.projectData.getIn(['scenes',this.props.currentSceneNumber-1,'startTime']),this.props.projectData.getIn(['scenes',this.props.currentSceneNumber-1,'duration']));}if(this.props.currentSceneNumber<this.props.projectData.getIn(['scenes',this.props.currentSceneNumber]).count()){document.getElementById('nextSlide').src=this.appUrl+"/images/playerControls-icons/next.svg";document.getElementById('nextSlide').style.cursor='pointer';document.getElementById('next-slide').style.cursor='pointer';}if(this.props.currentSceneNumber===0||this.props.currentSceneNumber===null){document.getElementById('prevSlide').src=this.appUrl+"/images/playerControls-icons/previous-disable.svg";document.getElementById('prevSlide').style.cursor='none';document.getElementById('previous-slide').style.cursor='none';}}}}this.isRefresh=false;if(e.which===116)this.isRefresh=true;if(e.keycode===82)this.isRefresh=true;var optionArr=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_Keymap__["a" /* validateKeydown */])(e,this.props.isWorkspaceTextFocus,this.props.textStatus),tempState={};for(var i=0;i<optionArr.length&&(!this.props.isPlay&&!this.props.isPlayAll||optionArr[i].component==="playerControl")&&(!this.props.isWorkspaceTextFocus&&!this.props.textStatus.get('isFocused')||optionArr[i].component==="textProperty"||optionArr[i].option==="UNDO_PROJECT"||optionArr[i].option==="REDO_PROJECT");i++){var keyoption=optionArr[i].option;if(keyoption!==""){if(this.state[''+optionArr[i].component]===keyoption)keyoption+="_AGAIN";tempState[''+optionArr[i].component]=keyoption;}}if(Object.keys(tempState).length>0)this.setState(tempState);}catch(error){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"App-handleKeyDown");}}},{key:'handleKeyUp',value:function handleKeyUp(e){try{if(this.state.playerControl||this.state.workspace||this.state.slides||this.state.menuBar||this.state.library||this.state.textProperty)this.setState({playerControl:"",workspace:"",slides:"",menuBar:"",library:"",textProperty:""});}catch(error){Object(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"App-handleKeyUp");}}},{key:'changeBoxes',value:function changeBoxes(whichState){var screens=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;if(whichState==='screens')this.setState({worksheet:screens});if(whichState==='screenPressed')this.setState({screenPressed:!this.state.screenPressed});}},{key:'render',value:function render(){var _this2=this;var projectToLoad='';if(this.state.loaded&&this.props.userDetails.size){var toastNotifications=null;if(this.props.toastNotifications.size>0){var toastArray=[];this.props.toastNotifications.map(function(noty,index){toastArray.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Toast__["a" /* default */],{key:noty.get("id"),data:noty,manageToast:this.props.manageToast}));}.bind(this));toastNotifications=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'toast-notification-controller toast-tool-bar'},toastArray);}projectToLoad=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"app full"+(parseInt(this.props.userStatus)===0?" anonymous":""),onDragEnter:function onDragEnter(e){if(e.target.closest('.effects-ul')||e.target.closest('.workspace-main-page')||e.target.closest('.animate-properties'))return;e.preventDefault();e.stopPropagation();var uploadTab=document.querySelector('.icon-UPLOADS');if(uploadTab){uploadTab.click();}var appLIb=document.querySelector('.app-lib-container');if(!appLIb.classList.contains('opened')){document.querySelector('.lib-additional-div').click();}},onDragLeave:function onDragLeave(e){e.preventDefault();e.stopPropagation();},onDragOver:function onDragOver(e){e.preventDefault();e.stopPropagation();},onDrop:function onDrop(e){if(e.target.closest('.lib-showBlock')&&e.target.closest('.lib-showBlock').querySelector('.library-pack.uploads'))return;e.preventDefault();var file=e.dataTransfer.files[0];_this2.props.draggedFile(file);},style:{backgroundColor:this.props.isFullScreen||this.props.mode==='slide'?'black':''}},!this.state.isConnected&&!this.props.isFullScreen?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-wrapper tool-bar'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-text-bg'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'v2',tabindex:'0',role:'link'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_intl__["a" /* FormattedMessage */],{id:'ne.err'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnect-wrapper'})):null,this.state.errorThrown&&!this.props.isFullScreen?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-wrapper tool-bar'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-text-bg'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'v2',tabindex:'0',role:'link'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_intl__["a" /* FormattedMessage */],{id:'pl.re'}),' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:function onClick(){window.location.reload();},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('u',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_intl__["a" /* FormattedMessage */],{id:'pa.re'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnect-wrapper'})):null,this.state.authError&&!this.props.isFullScreen?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-wrapper tool-bar'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-text-bg'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'v2',tabindex:'0',role:'link'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_intl__["a" /* FormattedMessage */],{id:'auth.err'}),' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:function onClick(){window.location.reload();},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('u',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_intl__["a" /* FormattedMessage */],{id:'auth.log'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnect-wrapper'})):null,this.state.sesError?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-wrapper tool-bar'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-text-bg'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'v2',tabindex:'0',role:'link'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_intl__["a" /* FormattedMessage */],{id:'ses.err'}),' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:function onClick(){window.location.reload();},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('u',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_intl__["a" /* FormattedMessage */],{id:'ses.log'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnect-wrapper'})):null,this.props.isProjectRestore&&!this.props.isFullScreen?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-wrapper tool-bar'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-text-bg'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'v2',tabindex:'0',role:'link'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_intl__["a" /* FormattedMessage */],{id:'res.pro'}),' '))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnect-wrapper'})):null,this.state.isRestored&&!this.props.isFullScreen?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-wrapper tool-bar'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-text-bg'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'v2',tabindex:'0',role:'link'},this.state.restoreUser===null?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_intl__["a" /* FormattedMessage */],{id:'res.pro.suc'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_intl__["a" /* FormattedMessage */],{id:'res.pro.by'},' '),' ',this.state.restoreUser,' '),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:function onClick(){window.location.reload();},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('u',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_intl__["a" /* FormattedMessage */],{id:'pa.re'}))),' ')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnect-wrapper'})):null,this.state.isRestoring&&!this.props.isFullScreen?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-wrapper tool-bar'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-text-bg'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'v2',tabindex:'0',role:'link'},this.state.restoreUser,' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_intl__["a" /* FormattedMessage */],{id:'res.pro'}),' '))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnect-wrapper'})):null,this.state.restoreCheck&&!this.props.isFullScreen?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-wrapper tool-bar'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-text-bg'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnected-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'v2',tabindex:'0',role:'link'},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_intl__["a" /* FormattedMessage */],{id:'oth.res'}),' '))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'disconnect-wrapper'})):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'app-main-page'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'app-page'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'workspace-main-page',onClick:function onClick(e){return _this2.handleMouseClick(e);},style:{height:this.props.isFullScreen?'105vh':'100vh'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__containers_Workspace__["a" /* default */],{socket:socket,userId:this.props.userId,projectId:this.props.projectid,mode:this.props.mode,shortcutName:this.state.workspace,appState:this.state,animakerType:this.props.animakerType,teamId:this.props.teamId,langToLoad:this.props.langToLoad})),toastNotifications),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'app-overlay','data-html2canvas-ignore':'true',style:{top:0,left:0,right:0,bottom:0,position:"absolute",backgroundColor:"rgba(0,0,0,0.5)",zIndex:9,display:"none"}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'overlays','data-html2canvas-ignore':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'snap-line vertical-line ver-left'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'snap-line vertical-line ver-center'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'snap-line vertical-line ver-right'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'snap-line horizontal-line hor-top'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'snap-line horizontal-line hor-center'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'snap-line horizontal-line hor-bottom'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'snap-line rotationLine'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'snap-line rotationDisplay'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{id:'rotationAngle'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'highlighter',style:{position:"absolute",boxShadow:"0px 0px 0px 1px #ffc423",zIndex:15,display:"none",pointerEvents:"none"}}),this.props.confirmPopup.get("show")?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__containers_ConfirmPopup__["a" /* default */],{details:this.props.confirmPopup}):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__containers_CommonPopup__["a" /* default */],{socket:socket,userId:this.props.userId,teamId:this.props.teamId,projectid:this.props.projectid}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__containers_ToolTip__["a" /* default */],{socket:socket}));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_intl__["b" /* IntlProvider */],{locale:this.props.langToLoad,messages:this.state.appLangData.language},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'  ',projectToLoad,' ')));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);var mapStateToProps=function mapStateToProps(state,ownProps){return{projectData:state.project,currentSceneNumber:state.localStore.get('currentSceneNumber'),isWorkspaceTextFocus:state.localStore.get("isWorkspaceTextFocus"),textStatus:state.localStore.get("textStatus"),isPlay:state.localStore.get("isPlay"),isPlayAll:state.localStore.get("isPlayAll"),animakerType:state.localStore.get("animakerType"),showSlidePanel:state.localStore.get('showSlidePanel'),selectedItems:state.localStore.get('selectedItems'),selectedScene:state.localStore.get('selectedScene'),toastNotifications:state.localStore.get('toastNotifications'),confirmPopup:state.localStore.get('confirmPopup'),appLoadProgressValue:state.localStore.get('appLoadProgressValue'),isSuggestionOn:state.localStore.get('isSuggestionOn'),showSuggestion:state.localStore.get('suggestionPopup'),anymsUploadStatus:state.localStore.get('anymsUploadStatus'),invalidBg:state.project.getIn(["scenes",0,"workspaceBG","src"])===""||state.project.getIn(["scenes",0,"workspaceBG","isBlob"])===true,sceneId:state.project.getIn(["scenes",state.localStore.get('selectedScene'),"id"]),ownerId:state.localStore.getIn(["userDetails","owner"]),projectWidth:state.project.get("width"),projectHeight:state.project.get("height"),templateThumbnails:state.localStore.get("templateThumbnails"),userDetails:state.localStore.get('userDetails'),isFullScreen:state.localStore.get('isFullScreen'),isNewAction:state.localStore.get('isNewAction'),t1:state.localStore.get('t1'),isPreview:state.localStore.get('isPreview'),scenes:state.project.getIn(["scenes"]),isProjectRestore:state.localStore.get('isProjectRestore'),versionId:state.localStore.get('versionId'),propertyWindow:state.localStore.get('propertyWindow')};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{appLoadProgess:function appLoadProgess(data){dispatch({type:'APP_LOAD_PROGRESS',data:data});},loadProject:function loadProject(projectid,projectUsr,mode,userId,projectUsrImg,socketid){dispatch({type:"LOAD_PROJECT",projectid:projectid,projectUsr:projectUsr,mode:mode,userId:userId,projectUsrImg:projectUsrImg,socketid:socketid});},loadUserFonts:function loadUserFonts(projectid,userId,socketid){dispatch({type:"LOAD_USER_FONTS",projectid:projectid,userId:userId,socketid:socketid});},setUserDetails:function setUserDetails(data){dispatch({type:"SET_USER_DETAILS",data:data});},loadSceneThumbs:function loadSceneThumbs(data){dispatch({type:"LOAD_SCENE_THUMBS",data:data});},addSceneComplete:function addSceneComplete(slideIndex,newslide,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["k" /* addSceneComplete */])(slideIndex,newslide,socketId,currentSocketId));},duplicateSceneComplete:function duplicateSceneComplete(slideIndex,newslide,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["Z" /* duplicateSceneComplete */])(slideIndex,newslide,socketId,currentSocketId));},removeSceneComplete:function removeSceneComplete(slideIndex,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_22" /* removeSceneComplete */])(slideIndex,socketId,currentSocketId));},addSceneTransitionComplete:function addSceneTransitionComplete(slideIndex,transitionName,sizes,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["l" /* addSceneTransitionComplete */])(slideIndex,transitionName,sizes,socketId,currentSocketId));},changeSceneTransColorComplete:function changeSceneTransColorComplete(selectedScene,color,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["G" /* changeSceneTransColorComplete */])(selectedScene,color,socketId,currentSocketId));},changeExpressionComplete:function changeExpressionComplete(selectedIndex,itemId,itemLabel,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["D" /* changeExpressionComplete */])(selectedIndex,itemId,itemLabel,socketId,currentSocketId));},changeActionComplete:function changeActionComplete(selectedIndex,itemId,itemLabel,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["x" /* changeActionComplete */])(selectedIndex,itemId,itemLabel,socketId,currentSocketId));},deleteBgComplete:function deleteBgComplete(selectedScene,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["S" /* deleteBgComplete */])(selectedScene,socketId,currentSocketId));},addObjComplete:function addObjComplete(selectedScene,workspaceIds,workspaceData,workspaceChildrenIds,workspaceChildData,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["g" /* addObjComplete */])(selectedScene,workspaceIds,workspaceData,workspaceChildrenIds,workspaceChildData,socketId,currentSocketId));},changeBgComplete:function changeBgComplete(selectedScene,workspaceBG,deleteId,deleteData,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["B" /* changeBgComplete */])(selectedScene,workspaceBG,deleteId,deleteData,socketId,currentSocketId));},moveUpdateComplete:function moveUpdateComplete(selectedScene,workspaceItems,workspaceChildren,currentContainer,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_12" /* moveUpdateComplete */])(selectedScene,workspaceItems,workspaceChildren,currentContainer,socketId,currentSocketId));},changeVideoVolumeComplete:function changeVideoVolumeComplete(selectedScene,objectId,objectData,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["K" /* changeVideoVolumeComplete */])(selectedScene,objectId,socketId,currentSocketId));},applyFilterComplete:function applyFilterComplete(selectedScene,objectId,objectData,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["t" /* applyFilterComplete */])(selectedScene,objectId,objectData,socketId,currentSocketId));},updateSvgColorComplete:function updateSvgColorComplete(selectedScene,container,itemId,itemCls,colorData,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_92" /* updateSvgColorComplete */])(selectedScene,container,itemId,itemCls,colorData,socketId,currentSocketId));},updateSvgThemeComplete:function updateSvgThemeComplete(projectid,selectedScene,container,itemId,colorData,isBG,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_93" /* updateSvgThemeComplete */])(projectid,selectedScene,container,itemId,colorData,isBG,socketId,currentSocketId));},cropImageComplete:function cropImageComplete(selectedScene,itemId,objectData,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["P" /* cropImageComplete */])(selectedScene,itemId,objectData,socketId,currentSocketId));},flipItemComplete:function flipItemComplete(selectedScene,itemId,flipPosition,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_3" /* flipItemComplete */])(selectedScene,itemId,flipPosition,socketId,currentSocketId));},cropBgComplete:function cropBgComplete(selectedScene,objectData,isVideo,videoId,bgScales,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["N" /* cropBgComplete */])(selectedScene,objectData,isVideo,videoId,bgScales,socketId,currentSocketId));},bgColorSelectionComplete:function bgColorSelectionComplete(selectedScene,objectData,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["u" /* bgColorSelectionComplete */])(selectedScene,objectData,socketId,currentSocketId));},bgGradientColorsComplete:function bgGradientColorsComplete(selectedScene,radialStatus,direction,radius,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["v" /* bgGradientColorsComplete */])(selectedScene,radialStatus,direction,radius,socketId,currentSocketId));},changeTextComplete:function changeTextComplete(selectedScene,currentContainer,itemId,objectData,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["I" /* changeTextComplete */])(selectedScene,currentContainer,itemId,objectData,socketId,currentSocketId));},groupObjectsComplete:function groupObjectsComplete(selectedScene,removeIds,workspaceItems,workspaceChildren,workspaceItemsOrder,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_5" /* groupObjectsComplete */])(selectedScene,removeIds,workspaceItems,workspaceChildren,workspaceItemsOrder,socketId,currentSocketId));},ungroupObjectsComplete:function ungroupObjectsComplete(selectedScene,removeIds,workspaceChildren,workspaceItemsOrder,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_75" /* ungroupObjectsComplete */])(selectedScene,removeIds,workspaceChildren,workspaceItemsOrder,socketId,currentSocketId));},deleteItemComplete:function deleteItemComplete(selectedScene,workspaceIds,workspaceChildrenIds,indexChangeIds,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["U" /* deleteItemComplete */])(selectedScene,workspaceIds,workspaceChildrenIds,indexChangeIds,socketId,currentSocketId));},setZIndexComplete:function setZIndexComplete(selectedScene,indexChangeIds,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_54" /* setZIndexComplete */])(selectedScene,indexChangeIds,socketId,currentSocketId));},updateTimelineDragChangeComplete:function updateTimelineDragChangeComplete(selectedScene,itemData,actionData,idVal,childToUpdate,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_96" /* updateTimelineDragChangeComplete */])(selectedScene,itemData,actionData,idVal,childToUpdate,socketId,currentSocketId));},pasteItemsComplete:function pasteItemsComplete(selectedScene,workspaceIds,workspaceChildrenIds,workspaceData,workspaceChildData,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_18" /* pasteItemsComplete */])(selectedScene,workspaceIds,workspaceChildrenIds,workspaceData,workspaceChildData,socketId,currentSocketId));},updateTextComplete:function updateTextComplete(selectedScene,isGrouped,selectedId,container,formats,childIds,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_94" /* updateTextComplete */])(selectedScene,isGrouped,selectedId,container,formats,childIds,socketId,currentSocketId));},updateGroupTextComplete:function updateGroupTextComplete(selectedScene,workspaceItems,workspaceChildren,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_81" /* updateGroupTextComplete */])(selectedScene,workspaceItems,workspaceChildren,socketId,currentSocketId));},pasteScenesComplete:function pasteScenesComplete(selectedScene,scenes,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_19" /* pasteScenesComplete */])(selectedScene,scenes,socketId,currentSocketId));},setSelectedItemsComplete:function setSelectedItemsComplete(projectid,selectedItems,projectUsr,userId,projectUsrImg,socketid,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_45" /* setSelectedItemsComplete */])(projectid,selectedItems,projectUsr,userId,projectUsrImg,socketid,currentSocketId));},setSelectedSceneComplete:function setSelectedSceneComplete(projectid,selectedItems,projectUsr,userId,projectUsrImg,socketid,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_47" /* setSelectedSceneComplete */])(projectid,selectedItems,projectUsr,userId,projectUsrImg,socketid,currentSocketId));},updateBgColorComplete:function updateBgColorComplete(selectedScene,Cls,color,socketid,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_77" /* updateBgColorComplete */])(selectedScene,Cls,color,socketid,currentSocketId));},updateBgGradientComplete:function updateBgGradientComplete(selectedScene,gradientIndex,gradientSecIndex,color,socketid,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_79" /* updateBgGradientComplete */])(selectedScene,gradientIndex,gradientSecIndex,color,socketid,currentSocketId));},socketConnected:function socketConnected(projectid,userId,selectedItems,imageUrl,projectUsr,socketid,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_59" /* socketConnected */])(projectid,userId,selectedItems,imageUrl,projectUsr,socketid,currentSocketId));},changeAnimationTypeComplete:function changeAnimationTypeComplete(selectedScene,itemId,value,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["y" /* changeAnimationTypeComplete */])(selectedScene,itemId,value,socketId,currentSocketId));},moveSceneComplete:function moveSceneComplete(projectid,newIndex,oldIndex,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_10" /* moveSceneComplete */])(projectid,newIndex,oldIndex,socketId,currentSocketId));},updateSceneComplete:function updateSceneComplete(projectid,selectedScene,toUpdate,toEmit,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_89" /* updateSceneComplete */])(projectid,selectedScene,toUpdate,toEmit,socketId,currentSocketId));},updateBgComplete:function updateBgComplete(projectid,selectedScene,toUpdate,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_78" /* updateBgComplete */])(projectid,selectedScene,toUpdate,socketId,currentSocketId));},updateProjectComplete:function updateProjectComplete(projectid,toUpdate,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_85" /* updateProjectComplete */])(projectid,toUpdate,socketId,currentSocketId));},updateObjectComplete:function updateObjectComplete(projectid,selectedScene,selectedItem,container,toUpdate,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_84" /* updateObjectComplete */])(projectid,selectedScene,selectedItem,container,toUpdate,socketId,currentSocketId));},addPrebuiltComplete:function addPrebuiltComplete(selectedScene,prebuiltData,replace,addAll,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["i" /* addPrebuiltComplete */])(selectedScene,prebuiltData,replace,addAll,socketId,currentSocketId));},newSocketConnected:function newSocketConnected(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_13" /* newSocketConnected */])(data));},socketDisconnected:function socketDisconnected(socketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_60" /* socketDisconnected */])(socketId));},manageToast:function manageToast(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_8" /* manageToast */])(data));},initiateProject:function initiateProject(data){dispatch({type:'INITIATE_PROJECT',data:data});},setFullTab:function setFullTab(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_32" /* setFullTab */])());},uploadedFile:function uploadedFile(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_102" /* uploadedFile */])(data));},openCommonPopup:function openCommonPopup(value,status){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_7" /* loadCommonPopup */])(value,status));},dropBG:function dropBG(data,deleteData,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["X" /* dropBG */])(data,deleteData,socket));},updateUserActive:function updateUserActive(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_98" /* updateUserActive */])(data));},updateBg:function updateBg(data,socket){dispatch({type:'UPDATE_BG',data:data,socket:socket});},draggedFile:function draggedFile(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["W" /* draggedFile */])(data));},saveScreenshot:function saveScreenshot(index,scene,project,userId,projectId,sceneId,isExceeded,screenshots){dispatch({type:"SAVE_SCREENSHOT",index:index,scene:scene,project:project,userId:userId,projectId:projectId,sceneId:sceneId,isExceeded:isExceeded,screenshots:screenshots});},updateThumbnails:function updateThumbnails(data){dispatch({type:'UPDATE_THUMBNAILS',data:data});},setScene:function setScene(data){dispatch({type:"SET_SCENE",data:data});},updateUserDetails:function updateUserDetails(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_99" /* updateUserDetails */])(data));},applyEnterEffectComplete:function applyEnterEffectComplete(projectid,selectedScene,effectData,isUndo,sceneEffectData,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["r" /* applyEnterEffectComplete */])(projectid,selectedScene,effectData,isUndo,sceneEffectData,socketId,currentSocketId));},applyAllTransitionComplete:function applyAllTransitionComplete(projectid,transData,isUndo,seceneTransData,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["p" /* applyAllTransitionComplete */])(projectid,transData,isUndo,seceneTransData,socketId,currentSocketId));},addLinkToTextComplete:function addLinkToTextComplete(projectid,selectedScene,container,selectedItem,hyperLinkData,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["e" /* addLinkToTextComplete */])(projectid,selectedScene,container,selectedItem,hyperLinkData,socketId,currentSocketId));},addLinkToObjComplete:function addLinkToObjComplete(projectid,selectedScene,selectedItem,linkData,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["c" /* addLinkToObjComplete */])(projectid,selectedScene,selectedItem,linkData,socketId,currentSocketId));},setPlayerPosition:function setPlayerPosition(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_40" /* setPlayerPosition */])(data));},setScenePosition:function setScenePosition(data,currentSceneNumber,currentSceneStartTime,currentSceneDuration){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_43" /* setScenePosition */])(data,currentSceneNumber,currentSceneStartTime,currentSceneDuration));},setWorkspaceItemsOrderComplete:function setWorkspaceItemsOrderComplete(projectId,selectedScene,container,workspaceItem,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_50" /* setWorkspaceItemsOrderComplete */])(projectId,selectedScene,container,workspaceItem,socketId,currentSocketId));},setAnimateValueComplete:function setAnimateValueComplete(projectid,selectedScene,container,selectedItem,animateData,socketId,currentSocketId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_27" /* setAnimateValueComplete */])(projectid,selectedScene,container,selectedItem,animateData,socketId,currentSocketId));},setNewActionComplete:function setNewActionComplete(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_36" /* setNewActionComplete */])(data));},projectRestore:function projectRestore(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_20" /* projectRestore */])(data,socket));},setPropertyWindow:function setPropertyWindow(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_42" /* setPropertyWindow */])(data));},addVersionHistory:function addVersionHistory(data){dispatch({type:'VERSION_HISTORY',data:data});},setPaymentPastDue:function setPaymentPastDue(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_37" /* setPaymentPastDue */])(data,socket));},setWorkspaceTextFocus:function setWorkspaceTextFocus(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_index__["_52" /* setWorkspaceTextFocus */])(data));},setAssetArray:function setAssetArray(data){dispatch({type:'SET_ASSET_ARRAY',data:data});}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(App));

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(311);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 311 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TweenMax */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TweenMax; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TweenMaxBase_js__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CSSPlugin_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AttrPlugin_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RoundPropsPlugin_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DirectionalRotationPlugin_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TimelineLite_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TimelineMax_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BezierPlugin_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EasePack_js__ = __webpack_require__(143);
/* unused harmony reexport TweenLite */
/* unused harmony reexport TimelineLite */
/* unused harmony reexport TimelineMax */
/* unused harmony reexport CSSPlugin */
/* unused harmony reexport AttrPlugin */
/* unused harmony reexport BezierPlugin */
/* unused harmony reexport DirectionalRotationPlugin */
/* unused harmony reexport RoundPropsPlugin */
/* unused harmony reexport TweenPlugin */
/* unused harmony reexport Ease */
/* unused harmony reexport Power0 */
/* unused harmony reexport Power1 */
/* unused harmony reexport Power2 */
/* unused harmony reexport Power3 */
/* unused harmony reexport Power4 */
/* unused harmony reexport Linear */
/* unused harmony reexport Back */
/* unused harmony reexport Elastic */
/* unused harmony reexport Bounce */
/* unused harmony reexport RoughEase */
/* unused harmony reexport SlowMo */
/* unused harmony reexport SteppedEase */
/* unused harmony reexport Circ */
/* unused harmony reexport Expo */
/* unused harmony reexport Sine */
/* unused harmony reexport ExpoScaleEase */
/*!
 * VERSION: 2.1.3
 * DATE: 2019-05-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/
/* eslint-disable */












//the following two lines are designed to prevent tree shaking of the classes that were historically included with TweenMax (otherwise, folks would have to reference CSSPlugin, for example, to ensure their CSS-related animations worked)
var TweenMax = __WEBPACK_IMPORTED_MODULE_1__TweenMaxBase_js__["a" /* default */];
TweenMax._autoActivated = [__WEBPACK_IMPORTED_MODULE_6__TimelineLite_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__TimelineMax_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__CSSPlugin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__AttrPlugin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__BezierPlugin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__RoundPropsPlugin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__DirectionalRotationPlugin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__EasePack_js__["a" /* Back */], __WEBPACK_IMPORTED_MODULE_9__EasePack_js__["d" /* Elastic */], __WEBPACK_IMPORTED_MODULE_9__EasePack_js__["b" /* Bounce */], __WEBPACK_IMPORTED_MODULE_9__EasePack_js__["g" /* RoughEase */], __WEBPACK_IMPORTED_MODULE_9__EasePack_js__["i" /* SlowMo */], __WEBPACK_IMPORTED_MODULE_9__EasePack_js__["j" /* SteppedEase */], __WEBPACK_IMPORTED_MODULE_9__EasePack_js__["c" /* Circ */], __WEBPACK_IMPORTED_MODULE_9__EasePack_js__["e" /* Expo */], __WEBPACK_IMPORTED_MODULE_9__EasePack_js__["h" /* Sine */], __WEBPACK_IMPORTED_MODULE_9__EasePack_js__["f" /* ExpoScaleEase */]];





/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TweenMax */
/* unused harmony export TweenMaxBase */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TweenMax; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__ = __webpack_require__(12);
/* unused harmony reexport TweenLite */
/* unused harmony reexport Ease */
/* unused harmony reexport Power0 */
/* unused harmony reexport Power1 */
/* unused harmony reexport Power2 */
/* unused harmony reexport Power3 */
/* unused harmony reexport Power4 */
/* unused harmony reexport Linear */
/*!
 * VERSION: 2.1.3
 * DATE: 2019-05-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/
/* eslint-disable */




__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["_gsScope"]._gsDefine("TweenMax", ["core.Animation","core.SimpleTimeline","TweenLite"], function() {

		var _slice = function(a) { //don't use [].slice because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
				var b = [],
					l = a.length,
					i;
				for (i = 0; i !== l; b.push(a[i++]));
				return b;
			},
			_applyCycle = function(vars, targets, i) {
				var alt = vars.cycle,
					p, val;
				for (p in alt) {
					val = alt[p];
					vars[p] = (typeof(val) === "function") ? val(i, targets[i], targets) : val[i % val.length];
				}
				delete vars.cycle;
			},
			//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
			_distribute = function(v) {
				if (typeof(v) === "function") {
					return v;
				}
				var vars = (typeof(v) === "object") ? v : {each:v}, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
					ease = vars.ease,
					from = vars.from || 0,
					base = vars.base || 0,
					cache = {},
					isFromKeyword = isNaN(from),
					axis = vars.axis,
					ratio = {center:0.5, end:1}[from] || 0;
				return function(i, target, a) {
					var l = (a || vars).length,
						distances = cache[l],
						originX, originY, x, y, d, j, max, min, wrap;
					if (!distances) {
						wrap = (vars.grid === "auto") ? 0 : (vars.grid || [Infinity])[0];
						if (!wrap) {
							max = -Infinity;
							while (max < (max = a[wrap++].getBoundingClientRect().left) && wrap < l) { }
							wrap--;
						}
						distances = cache[l] = [];
						originX = isFromKeyword ? (Math.min(wrap, l) * ratio) - 0.5 : from % wrap;
						originY = isFromKeyword ? l * ratio / wrap - 0.5 : (from / wrap) | 0;
						max = 0;
						min = Infinity;
						for (j = 0; j < l; j++) {
							x = (j % wrap) - originX;
							y = originY - ((j / wrap) | 0);
							distances[j] = d = !axis ? Math.sqrt(x * x + y * y) : Math.abs((axis === "y") ? y : x);
							if (d > max) {
								max = d;
							}
							if (d < min) {
								min = d;
							}
						}
						distances.max = max - min;
						distances.min = min;
						distances.v = l = vars.amount || (vars.each * (wrap > l ? l - 1 : !axis ? Math.max(wrap, l / wrap) : axis === "y" ? l / wrap : wrap)) || 0;
						distances.b = (l < 0) ? base - l : base;
					}
					l = (distances[i] - distances.min) / distances.max;
					return distances.b + (ease ? ease.getRatio(l) : l) * distances.v;
				};
			},
			TweenMax = function(target, duration, vars) {
				__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].call(this, target, duration, vars);
				this._cycle = 0;
				this._yoyo = (this.vars.yoyo === true || !!this.vars.yoyoEase);
				this._repeat = this.vars.repeat || 0;
				this._repeatDelay = this.vars.repeatDelay || 0;
				if (this._repeat) {
					this._uncache(true); //ensures that if there is any repeat, the totalDuration will get recalculated to accurately report it.
				}
				this.render = TweenMax.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
			},
			_tinyNum = 0.00000001,
			TweenLiteInternals = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"]._internals,
			_isSelector = TweenLiteInternals.isSelector,
			_isArray = TweenLiteInternals.isArray,
			p = TweenMax.prototype = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].to({}, 0.1, {}),
			_blankArray = [];

		TweenMax.version = "2.1.3";
		p.constructor = TweenMax;
		p.kill()._gc = false;
		TweenMax.killTweensOf = TweenMax.killDelayedCallsTo = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].killTweensOf;
		TweenMax.getTweensOf = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].getTweensOf;
		TweenMax.lagSmoothing = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].lagSmoothing;
		TweenMax.ticker = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].ticker;
		TweenMax.render = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].render;
		TweenMax.distribute = _distribute;

		p.invalidate = function() {
			this._yoyo = (this.vars.yoyo === true || !!this.vars.yoyoEase);
			this._repeat = this.vars.repeat || 0;
			this._repeatDelay = this.vars.repeatDelay || 0;
			this._yoyoEase = null;
			this._uncache(true);
			return __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].prototype.invalidate.call(this);
		};

		p.updateTo = function(vars, resetDuration) {
			var self = this,
				curRatio = self.ratio,
				immediate = self.vars.immediateRender || vars.immediateRender,
				p;
			if (resetDuration && self._startTime < self._timeline._time) {
				self._startTime = self._timeline._time;
				self._uncache(false);
				if (self._gc) {
					self._enabled(true, false);
				} else {
					self._timeline.insert(self, self._startTime - self._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
				}
			}
			for (p in vars) {
				self.vars[p] = vars[p];
			}
			if (self._initted || immediate) {
				if (resetDuration) {
					self._initted = false;
					if (immediate) {
						self.render(0, true, true);
					}
				} else {
					if (self._gc) {
						self._enabled(true, false);
					}
					if (self._notifyPluginsOfEnabled && self._firstPT) {
						__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"]._onPluginEvent("_onDisable", self); //in case a plugin like MotionBlur must perform some cleanup tasks
					}
					if (self._time / self._duration > 0.998) { //if the tween has finished (or come extremely close to finishing), we just need to rewind it to 0 and then render it again at the end which forces it to re-initialize (parsing the new vars). We allow tweens that are close to finishing (but haven't quite finished) to work this way too because otherwise, the values are so small when determining where to project the starting values that binary math issues creep in and can make the tween appear to render incorrectly when run backwards.
						var prevTime = self._totalTime;
						self.render(0, true, false);
						self._initted = false;
						self.render(prevTime, true, false);
					} else {
						self._initted = false;
						self._init();
						if (self._time > 0 || immediate) {
							var inv = 1 / (1 - curRatio),
								pt = self._firstPT, endValue;
							while (pt) {
								endValue = pt.s + pt.c;
								pt.c *= inv;
								pt.s = endValue - pt.c;
								pt = pt._next;
							}
						}
					}
				}
			}
			return self;
		};

		p.render = function(time, suppressEvents, force) {
			if (!this._initted) if (this._duration === 0 && this.vars.repeat) { //zero duration tweens that render immediately have render() called from TweenLite's constructor, before TweenMax's constructor has finished setting _repeat, _repeatDelay, and _yoyo which are critical in determining totalDuration() so we need to call invalidate() which is a low-kb way to get those set properly.
				this.invalidate();
			}
			var self = this,
				totalDur = (!self._dirty) ? self._totalDuration : self.totalDuration(),
				prevTime = self._time,
				prevTotalTime = self._totalTime,
				prevCycle = self._cycle,
				duration = self._duration,
				prevRawPrevTime = self._rawPrevTime,
				isComplete, callback, pt, cycleDuration, r, type, pow, rawPrevTime, yoyoEase;
			if (time >= totalDur - _tinyNum && time >= 0) { //to work around occasional floating point math artifacts.
				self._totalTime = totalDur;
				self._cycle = self._repeat;
				if (self._yoyo && (self._cycle & 1) !== 0) {
					self._time = 0;
					self.ratio = self._ease._calcEnd ? self._ease.getRatio(0) : 0;
				} else {
					self._time = duration;
					self.ratio = self._ease._calcEnd ? self._ease.getRatio(1) : 1;
				}
				if (!self._reversed) {
					isComplete = true;
					callback = "onComplete";
					force = (force || self._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
				}
				if (duration === 0) if (self._initted || !self.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
					if (self._startTime === self._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
						time = 0;
					}
					if (prevRawPrevTime < 0 || (time <= 0 && time >= -_tinyNum) || (prevRawPrevTime === _tinyNum && self.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
						force = true;
						if (prevRawPrevTime > _tinyNum) {
							callback = "onReverseComplete";
						}
					}
					self._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
				}

			} else if (time < _tinyNum) { //to work around occasional floating point math artifacts, round super small values to 0.
				self._totalTime = self._time = self._cycle = 0;
				self.ratio = self._ease._calcEnd ? self._ease.getRatio(0) : 0;
				if (prevTotalTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
					callback = "onReverseComplete";
					isComplete = self._reversed;
				}
				if (time > -_tinyNum) {
					time = 0;
				} else if (time < 0) {
					self._active = false;
					if (duration === 0) if (self._initted || !self.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (prevRawPrevTime >= 0) {
							force = true;
						}
						self._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
				}
				if (!self._initted) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
					force = true;
				}
			} else {
				self._totalTime = self._time = time;
				if (self._repeat !== 0) {
					cycleDuration = duration + self._repeatDelay;
					self._cycle = (self._totalTime / cycleDuration) >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
					if (self._cycle !== 0) if (self._cycle === self._totalTime / cycleDuration && prevTotalTime <= time) {
						self._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
					}
					self._time = self._totalTime - (self._cycle * cycleDuration);
					if (self._yoyo) if ((self._cycle & 1) !== 0) {
						self._time = duration - self._time;
						yoyoEase = self._yoyoEase || self.vars.yoyoEase; //note: we don't set this._yoyoEase in _init() like we do other properties because it's TweenMax-specific and doing it here allows us to optimize performance (most tweens don't have a yoyoEase). Note that we also must skip the this.ratio calculation further down right after we _init() in this function, because we're doing it here.
						if (yoyoEase) {
							if (!self._yoyoEase) {
								if (yoyoEase === true && !self._initted) { //if it's not initted and yoyoEase is true, this._ease won't have been populated yet so we must discern it here.
									yoyoEase = self.vars.ease;
									self._yoyoEase = yoyoEase = !yoyoEase ? __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].defaultEase : (yoyoEase instanceof __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Ease"]) ? yoyoEase : (typeof(yoyoEase) === "function") ? new __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Ease"](yoyoEase, self.vars.easeParams) : __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Ease"].map[yoyoEase] || __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].defaultEase;
								} else {
									self._yoyoEase = yoyoEase = (yoyoEase === true) ? self._ease : (yoyoEase instanceof __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Ease"]) ? yoyoEase : __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Ease"].map[yoyoEase];
								}
							}
							self.ratio = yoyoEase ? 1 - yoyoEase.getRatio((duration - self._time) / duration) : 0;
						}
					}
					if (self._time > duration) {
						self._time = duration;
					} else if (self._time < 0) {
						self._time = 0;
					}
				}
				if (self._easeType && !yoyoEase) {
					r = self._time / duration;
					type = self._easeType;
					pow = self._easePower;
					if (type === 1 || (type === 3 && r >= 0.5)) {
						r = 1 - r;
					}
					if (type === 3) {
						r *= 2;
					}
					if (pow === 1) {
						r *= r;
					} else if (pow === 2) {
						r *= r * r;
					} else if (pow === 3) {
						r *= r * r * r;
					} else if (pow === 4) {
						r *= r * r * r * r;
					}
					self.ratio = (type === 1) ? 1 - r : (type === 2) ? r : (self._time / duration < 0.5) ? r / 2 : 1 - (r / 2);

				} else if (!yoyoEase) {
					self.ratio = self._ease.getRatio(self._time / duration);
				}

			}

			if (prevTime === self._time && !force && prevCycle === self._cycle) {
				if (prevTotalTime !== self._totalTime) if (self._onUpdate) if (!suppressEvents) { //so that onUpdate fires even during the repeatDelay - as long as the totalTime changed, we should trigger onUpdate.
					self._callback("onUpdate");
				}
				return;
			} else if (!self._initted) {
				self._init();
				if (!self._initted || self._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
					return;
				} else if (!force && self._firstPT && ((self.vars.lazy !== false && self._duration) || (self.vars.lazy && !self._duration))) { //we stick it in the queue for rendering at the very end of the tick - this is a performance optimization because browsers invalidate styles and force a recalculation if you read, write, and then read style data (so it's better to read/read/read/write/write/write than read/write/read/write/read/write). The down side, of course, is that usually you WANT things to render immediately because you may have code running right after that which depends on the change. Like imagine running TweenLite.set(...) and then immediately after that, creating a nother tween that animates the same property to another value; the starting values of that 2nd tween wouldn't be accurate if lazy is true.
					self._time = prevTime;
					self._totalTime = prevTotalTime;
					self._rawPrevTime = prevRawPrevTime;
					self._cycle = prevCycle;
					TweenLiteInternals.lazyTweens.push(self);
					self._lazy = [time, suppressEvents];
					return;
				}
				//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
				if (self._time && !isComplete && !yoyoEase) {
					self.ratio = self._ease.getRatio(self._time / duration);
				} else if (isComplete && this._ease._calcEnd && !yoyoEase) {
					self.ratio = self._ease.getRatio((self._time === 0) ? 0 : 1);
				}
			}
			if (self._lazy !== false) {
				self._lazy = false;
			}

			if (!self._active) if (!self._paused && self._time !== prevTime && time >= 0) {
				self._active = true; //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
			}
			if (prevTotalTime === 0) {
				if (self._initted === 2 && time > 0) {
					self._init(); //will just apply overwriting since _initted of (2) means it was a from() tween that had immediateRender:true
				}
				if (self._startAt) {
					if (time >= 0) {
						self._startAt.render(time, true, force);
					} else if (!callback) {
						callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
					}
				}
				if (self.vars.onStart) if (self._totalTime !== 0 || duration === 0) if (!suppressEvents) {
					self._callback("onStart");
				}
			}

			pt = self._firstPT;
			while (pt) {
				if (pt.f) {
					pt.t[pt.p](pt.c * self.ratio + pt.s);
				} else {
					pt.t[pt.p] = pt.c * self.ratio + pt.s;
				}
				pt = pt._next;
			}

			if (self._onUpdate) {
				if (time < 0) if (self._startAt && self._startTime) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
					self._startAt.render(time, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
				}
				if (!suppressEvents) if (self._totalTime !== prevTotalTime || callback) {
					self._callback("onUpdate");
				}
			}
			if (self._cycle !== prevCycle) if (!suppressEvents) if (!self._gc) if (self.vars.onRepeat) {
				self._callback("onRepeat");
			}
			if (callback) if (!self._gc || force) { //check gc because there's a chance that kill() could be called in an onUpdate
				if (time < 0 && self._startAt && !self._onUpdate && self._startTime) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
					self._startAt.render(time, true, force);
				}
				if (isComplete) {
					if (self._timeline.autoRemoveChildren) {
						self._enabled(false, false);
					}
					self._active = false;
				}
				if (!suppressEvents && self.vars[callback]) {
					self._callback(callback);
				}
				if (duration === 0 && self._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
					self._rawPrevTime = 0;
				}
			}
		};

//---- STATIC FUNCTIONS -----------------------------------------------------------------------------------------------------------

		TweenMax.to = function(target, duration, vars) {
			return new TweenMax(target, duration, vars);
		};

		TweenMax.from = function(target, duration, vars) {
			vars.runBackwards = true;
			vars.immediateRender = (vars.immediateRender != false);
			return new TweenMax(target, duration, vars);
		};

		TweenMax.fromTo = function(target, duration, fromVars, toVars) {
			toVars.startAt = fromVars;
			toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
			return new TweenMax(target, duration, toVars);
		};

		TweenMax.staggerTo = TweenMax.allTo = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
			var a = [],
				staggerFunc = _distribute(vars.stagger || stagger),
				cycle = vars.cycle,
				fromCycle = (vars.startAt || _blankArray).cycle,
				l, copy, i, p;
			if (!_isArray(targets)) {
				if (typeof(targets) === "string") {
					targets = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].selector(targets) || targets;
				}
				if (_isSelector(targets)) {
					targets = _slice(targets);
				}
			}
			targets = targets || [];
			l = targets.length - 1;
			for (i = 0; i <= l; i++) {
				copy = {};
				for (p in vars) {
					copy[p] = vars[p];
				}
				if (cycle) {
					_applyCycle(copy, targets, i);
					if (copy.duration != null) {
						duration = copy.duration;
						delete copy.duration;
					}
				}
				if (fromCycle) {
					fromCycle = copy.startAt = {};
					for (p in vars.startAt) {
						fromCycle[p] = vars.startAt[p];
					}
					_applyCycle(copy.startAt, targets, i);
				}
				copy.delay = staggerFunc(i, targets[i], targets) + (copy.delay || 0);
				if (i === l && onCompleteAll) {
					copy.onComplete = function() {
						if (vars.onComplete) {
							vars.onComplete.apply(vars.onCompleteScope || this, arguments);
						}
						onCompleteAll.apply(onCompleteAllScope || vars.callbackScope || this, onCompleteAllParams || _blankArray);
					};
				}
				a[i] = new TweenMax(targets[i], duration, copy);
			}
			return a;
		};

		TweenMax.staggerFrom = TweenMax.allFrom = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
			vars.runBackwards = true;
			vars.immediateRender = (vars.immediateRender != false);
			return TweenMax.staggerTo(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
		};

		TweenMax.staggerFromTo = TweenMax.allFromTo = function(targets, duration, fromVars, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
			toVars.startAt = fromVars;
			toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
			return TweenMax.staggerTo(targets, duration, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
		};

		TweenMax.delayedCall = function(delay, callback, params, scope, useFrames) {
			return new TweenMax(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, useFrames:useFrames, overwrite:0});
		};

		TweenMax.set = function(target, vars) {
			return new TweenMax(target, 0, vars);
		};

		TweenMax.isTweening = function(target) {
			return (__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].getTweensOf(target, true).length > 0);
		};

		var _getChildrenOf = function(timeline, includeTimelines) {
				var a = [],
					cnt = 0,
					tween = timeline._first;
				while (tween) {
					if (tween instanceof __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"]) {
						a[cnt++] = tween;
					} else {
						if (includeTimelines) {
							a[cnt++] = tween;
						}
						a = a.concat(_getChildrenOf(tween, includeTimelines));
						cnt = a.length;
					}
					tween = tween._next;
				}
				return a;
			},
			getAllTweens = TweenMax.getAllTweens = function(includeTimelines) {
				return _getChildrenOf(__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Animation"]._rootTimeline, includeTimelines).concat( _getChildrenOf(__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Animation"]._rootFramesTimeline, includeTimelines) );
			};

		TweenMax.killAll = function(complete, tweens, delayedCalls, timelines) {
			if (tweens == null) {
				tweens = true;
			}
			if (delayedCalls == null) {
				delayedCalls = true;
			}
			var a = getAllTweens((timelines != false)),
				l = a.length,
				allTrue = (tweens && delayedCalls && timelines),
				isDC, tween, i;
			for (i = 0; i < l; i++) {
				tween = a[i];
				if (allTrue || (tween instanceof __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["SimpleTimeline"]) || ((isDC = (tween.target === tween.vars.onComplete)) && delayedCalls) || (tweens && !isDC)) {
					if (complete) {
						tween.totalTime(tween._reversed ? 0 : tween.totalDuration());
					} else {
						tween._enabled(false, false);
					}
				}
			}
		};

		TweenMax.killChildTweensOf = function(parent, complete) {
			if (parent == null) {
				return;
			}
			var tl = TweenLiteInternals.tweenLookup,
				a, curParent, p, i, l;
			if (typeof(parent) === "string") {
				parent = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].selector(parent) || parent;
			}
			if (_isSelector(parent)) {
				parent = _slice(parent);
			}
			if (_isArray(parent)) {
				i = parent.length;
				while (--i > -1) {
					TweenMax.killChildTweensOf(parent[i], complete);
				}
				return;
			}
			a = [];
			for (p in tl) {
				curParent = tl[p].target.parentNode;
				while (curParent) {
					if (curParent === parent) {
						a = a.concat(tl[p].tweens);
					}
					curParent = curParent.parentNode;
				}
			}
			l = a.length;
			for (i = 0; i < l; i++) {
				if (complete) {
					a[i].totalTime(a[i].totalDuration());
				}
				a[i]._enabled(false, false);
			}
		};

		var _changePause = function(pause, tweens, delayedCalls, timelines) {
			tweens = (tweens !== false);
			delayedCalls = (delayedCalls !== false);
			timelines = (timelines !== false);
			var a = getAllTweens(timelines),
				allTrue = (tweens && delayedCalls && timelines),
				i = a.length,
				isDC, tween;
			while (--i > -1) {
				tween = a[i];
				if (allTrue || (tween instanceof __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["SimpleTimeline"]) || ((isDC = (tween.target === tween.vars.onComplete)) && delayedCalls) || (tweens && !isDC)) {
					tween.paused(pause);
				}
			}
		};

		TweenMax.pauseAll = function(tweens, delayedCalls, timelines) {
			_changePause(true, tweens, delayedCalls, timelines);
		};

		TweenMax.resumeAll = function(tweens, delayedCalls, timelines) {
			_changePause(false, tweens, delayedCalls, timelines);
		};

		TweenMax.globalTimeScale = function(value) {
			var tl = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Animation"]._rootTimeline,
				t = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].ticker.time;
			if (!arguments.length) {
				return tl._timeScale;
			}
			value = value || _tinyNum; //can't allow zero because it'll throw the math off
			tl._startTime = t - ((t - tl._startTime) * tl._timeScale / value);
			tl = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Animation"]._rootFramesTimeline;
			t = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["default"].ticker.frame;
			tl._startTime = t - ((t - tl._startTime) * tl._timeScale / value);
			tl._timeScale = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Animation"]._rootTimeline._timeScale = value;
			return value;
		};


//---- GETTERS / SETTERS ----------------------------------------------------------------------------------------------------------

		p.progress = function(value, suppressEvents) {
			return (!arguments.length) ? (this.duration() ? this._time / this._duration : this.ratio) : this.totalTime( this.duration() * ((this._yoyo && (this._cycle & 1) !== 0) ? 1 - value : value) + (this._cycle * (this._duration + this._repeatDelay)), suppressEvents);
		};

		p.totalProgress = function(value, suppressEvents) {
			return (!arguments.length) ? this._totalTime / this.totalDuration() : this.totalTime( this.totalDuration() * value, suppressEvents);
		};

		p.time = function(value, suppressEvents) {
			if (!arguments.length) {
				return this._time;
			}
			if (this._dirty) {
				this.totalDuration();
			}
			var duration = this._duration,
				cycle = this._cycle,
				cycleDur = cycle * (duration + this._repeatDelay);
			if (value > duration) {
				value = duration;
			}
			return this.totalTime((this._yoyo && (cycle & 1)) ? duration - value + cycleDur : this._repeat ? value + cycleDur : value, suppressEvents);
		};

		p.duration = function(value) {
			if (!arguments.length) {
				return this._duration; //don't set _dirty = false because there could be repeats that haven't been factored into the _totalDuration yet. Otherwise, if you create a repeated TweenMax and then immediately check its duration(), it would cache the value and the totalDuration would not be correct, thus repeats wouldn't take effect.
			}
			return __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["Animation"].prototype.duration.call(this, value);
		};

		p.totalDuration = function(value) {
			if (!arguments.length) {
				if (this._dirty) {
					//instead of Infinity, we use 999999999999 so that we can accommodate reverses
					this._totalDuration = (this._repeat === -1) ? 999999999999 : this._duration * (this._repeat + 1) + (this._repeatDelay * this._repeat);
					this._dirty = false;
				}
				return this._totalDuration;
			}
			return (this._repeat === -1) ? this : this.duration( (value - (this._repeat * this._repeatDelay)) / (this._repeat + 1) );
		};

		p.repeat = function(value) {
			if (!arguments.length) {
				return this._repeat;
			}
			this._repeat = value;
			return this._uncache(true);
		};

		p.repeatDelay = function(value) {
			if (!arguments.length) {
				return this._repeatDelay;
			}
			this._repeatDelay = value;
			return this._uncache(true);
		};

		p.yoyo = function(value) {
			if (!arguments.length) {
				return this._yoyo;
			}
			this._yoyo = value;
			return this;
		};


		return TweenMax;

	}, true);

var TweenMax = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["globals"].TweenMax;
var TweenMaxBase = TweenMax;




/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WorkspaceComponent__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_index__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state,ownProps){return{project:state.project,maxIndex:state.project.getIn(['scenes',state.localStore.get("selectedScene"),'workspaceItems']),selectedScene:state.localStore.get("selectedScene"),selectedItems:state.localStore.get("selectedItems"),selectedCamera:state.localStore.get("selectedCamera"),workspaceWidth:state.project.get("width"),workspaceHeight:state.project.get("height"),sceneData:state.project.getIn(["scenes",state.localStore.get("selectedScene")]),scenes:state.project.getIn(["scenes"]),zoomFactor:state.localStore.get("zoomFactor"),prevZoomFactor:state.localStore.get("prevZoomFactor"),isFullScreen:state.localStore.get("isFullScreen"),textStatus:state.localStore.get("textStatus"),playHeadValue:state.localStore.get("playHeadValue"),swapDetails:state.localStore.get("swapDetails"),isCropping:state.localStore.get("isCropping"),transformStatus:state.localStore.get('transformStatus'),isWorkspaceTextFocus:state.localStore.get('isWorkspaceTextFocus'),videos:state.project.get('videos'),isPlay:state.localStore.getIn(['isPlay']),isPlayAll:state.localStore.getIn(['isPlayAll']),showLibrary:state.localStore.get('showLibrary'),workspaceBounds:state.localStore.get('workspaceBounds'),workspaceGrid:state.localStore.get("workspaceGrid"),copiedItem:state.localStore.get("copiedItem"),selectedMedias:state.localStore.get("selectedMedias"),isBgCropping:state.localStore.get("isBgCropping"),selectedScenes:state.localStore.get("selectedScenes"),animakerType:state.localStore.get("animakerType"),propertyWindow:state.localStore.get("propertyWindow"),transitionLibrary:state.library.get('TRANS'),showSlidePanel:state.localStore.get('showSlidePanel'),t1:state.localStore.get('t1'),isLoaded:state.localStore.get('isLoaded'),timelineHeight:state.localStore.get("timelineHeight"),connections:state.localStore.get("connections"),overallDuration:state.project.getIn(["duration"]),commonPopup:state.localStore.getIn(['commonPopup']),workspaceStage:state.localStore.get("workspaceStage"),screenshots:state.localStore.get("screenshots"),screenShotsHandler:state.localStore.get("screenShotsHandler"),fontScenes:state.localStore.getIn(["loadedFonts","scenes"]),ownerId:state.localStore.getIn(["userDetails","owner"]),editclicked:state.localStore.get('editClicked'),undoProp:state.localStore.get('undoProp'),browserName:state.localStore.get('browserName'),isUserActive:state.localStore.get('isUserActive'),isToolCropping:state.localStore.get('isToolCropping'),updateItems:state.localStore.get('itemToUpdate'),isUploadInProcess:state.localStore.get('isUploadInProcess'),undoResize:state.localStore.get('undoResize'),draggedFileItem:state.localStore.get('draggedFile'),libCurrentFolder:state.localStore.get('libCurrentFolder'),currentSceneNumber:state.localStore.get('currentSceneNumber'),autoPlay:state.localStore.get('autoPlay'),fromStart:state.localStore.get("fromStart"),isPreview:state.localStore.get('isPreview'),libSection:state.localStore.get('libSection'),isFit:state.localStore.get('isFit'),loadedFonts:state.localStore.get("loadedFonts"),isfontLoadedTxtGrp:state.localStore.get('isfontLoadedTxtGrp')};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{setSelectedItems:function setSelectedItems(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_44" /* setSelectedItems */])(data,socket));},setZoom:function setZoom(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_55" /* setZoom */])(data));},setZIndex:function setZIndex(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_53" /* setZIndex */])(data,socket));},changeBg:function changeBg(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["A" /* changeBg */])(data,socket));},addTween:function addTween(data,tweenType){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["n" /* addTween */])(data,tweenType));},startPlay:function startPlay(data,source,playHead){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_61" /* startPlay */])(data,source,playHead));},showLibraryTab:function showLibraryTab(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_57" /* showLibrary */])(data));},setCopyItemType:function setCopyItemType(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_29" /* setCopyItemType */])(data));},copyObjects:function copyObjects(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["L" /* copyObjects */])(data));},cutObjects:function cutObjects(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["Q" /* cutObjects */])(data));},pasteItems:function pasteItems(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_17" /* pasteItems */])(data,socket));},setPropertyWindow:function setPropertyWindow(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_42" /* setPropertyWindow */])(data));},setTextOptions:function setTextOptions(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_49" /* setTextOptions */])(data));},updateTextStatus:function updateTextStatus(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_95" /* updateTextStatus */])(data));},deleteBG:function deleteBG(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["R" /* deleteBG */])(data,socket));},deleteItem:function deleteItem(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["T" /* deleteItem */])(data,socket));},toggleBgCrop:function toggleBgCrop(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_67" /* toggleBgCrop */])());},swapItem:function swapItem(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_64" /* swapItem */])(data));},swapItemUndo:function swapItemUndo(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_65" /* swapItemUndo */])(data));},flipBG:function flipBG(data,socket){dispatch({type:"UPDATE_BG",data:data,socket:socket});},setSelectedScene:function setSelectedScene(data,time,selectedScenes,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_46" /* setSelectedScene */])(data,time,selectedScenes,socket));},setWorkspaceStage:function setWorkspaceStage(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_51" /* setWorkspaceStage */])(data));},setZoomFit:function setZoomFit(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_56" /* setZoomFit */])(data));},openCommonPopup:function openCommonPopup(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_7" /* loadCommonPopup */])(value));},onAddScene:function onAddScene(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["j" /* addScene */])(data,socket));},showSlides:function showSlides(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_58" /* showSlides */])(data));},onDuplicateScene:function onDuplicateScene(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["Y" /* duplicateScene */])(data,socket));},onRemoveScene:function onRemoveScene(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_21" /* removeScene */])(data,socket));},updateFonts:function updateFonts(data){dispatch({type:"UPDATE_FONTS",data:data});},addObj:function addObj(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["f" /* addObj */])(data,socket));},dropBG:function dropBG(data){dispatch({type:"UPDATE_SLIDE",data:data});},openLibrarySection:function openLibrarySection(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_16" /* openLibrarySection */])(data));},startTour:function startTour(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_62" /* startTour */])(data));},nextBtnClicked:function nextBtnClicked(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_14" /* nextBtnClicked */])(data));},suggestionPopup:function suggestionPopup(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_63" /* suggestionPopup */])(data));},updateProject:function updateProject(data){dispatch({type:"UPDATE_PROJECT",data:data});},fileToUpload:function fileToUpload(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_0" /* fileToUpload */])(data));},manageToast:function manageToast(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_8" /* manageToast */])(data));},itemToUpdate:function itemToUpdate(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_6" /* itemToUpdate */])(data));},dropVideoBg:function dropVideoBg(data,deleteData,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["X" /* dropBG */])(data,deleteData,socket));},upAddObj:function upAddObj(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_76" /* upAddObj */])(data,socket));},draggedFile:function draggedFile(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["W" /* draggedFile */])(data));},updateItem:function updateItem(data,socket){dispatch({type:"UPDATE_ITEM",data:data,socket:socket});},deleteObject:function deleteObject(type,socket,id,selectedScene,selectedItem){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["V" /* deleteObject */])(type,socket,id,selectedScene,selectedItem));},setFullScreen:function setFullScreen(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_31" /* setFullScreen */])(data));},setPlayAll:function setPlayAll(data,fromStart){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_39" /* setPlayAll */])(data,fromStart));},setPlayerPosition:function setPlayerPosition(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_40" /* setPlayerPosition */])(data));},setScenePosition:function setScenePosition(data,currentSceneNumber,currentSceneStartTime,currentSceneDuration){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_43" /* setScenePosition */])(data,currentSceneNumber,currentSceneStartTime,currentSceneDuration));},removeScenePosition:function removeScenePosition(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_23" /* removeScenePosition */])(data));},setAutoPlay:function setAutoPlay(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_28" /* setAutoPlay */])(data));},setPreview:function setPreview(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_41" /* setPreview */])(data));},fontLoaded:function fontLoaded(data){dispatch({type:"FONT_LOADED",data:data});},setSlideJump:function setSlideJump(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_48" /* setSlideJump */])(data));},addSlideLabelData:function addSlideLabelData(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["m" /* addSlideLabelData */])(data));},setIsShapeInGrp:function setIsShapeInGrp(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_33" /* setIsShapeInGrp */])(data));},initiateMove:function initiateMove(data){dispatch({type:"INITIATE_MOVE",data:data});}};};var Workspace=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_WorkspaceComponent__["b" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Workspace);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(87);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(318);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(331);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(147);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(327);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(52)(module)))

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(147);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(148);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(332);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(87);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(25));

var _addClass = _interopRequireDefault(__webpack_require__(334));

var _removeClass = _interopRequireDefault(__webpack_require__(337));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(151));

var _PropTypes = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or
   * has finished the transition. A single name can be provided and it will be
   * suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(335);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(336));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 335 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(25));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(74);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(154));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TransformManagerComponent__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_index__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state,ownProps){return{selectedScene:state.localStore.get("selectedScene"),selectedItems:state.localStore.get("selectedItems"),selectedCamera:state.localStore.get("selectedCamera"),workspaceWidth:state.project.get("width"),workspaceHeight:state.project.get("height"),unSelectedObjects:state.localStore.get("selectedItems").size>0?state.project.getIn(["scenes",state.localStore.get("selectedScene"),"workspaceItems"]).filter(function(obj,key){return state.localStore.get("selectedItems").keyOf(key)===undefined;}):state.localStore.get("selectedCamera")!==""?state.project.getIn(["scenes",state.localStore.get("selectedScene"),"workspaceItems"]):null,selectedChildren:state.project.getIn(["scenes",state.localStore.get("selectedScene"),"workspaceChildren"]),unSelectedCameras:state.localStore.get("selectedCamera")!==""?state.project.getIn(["scenes",state.localStore.get("selectedScene"),"workspaceCameras"]).filter(function(obj,key){return state.localStore.get("selectedCamera")!==key;}):null,zoomFactor:state.localStore.get("zoomFactor"),playHeadValue:state.project.getIn(["scenes",state.localStore.get("selectedScene"),"playHeadValue"]),currentPosition:state.localStore.get("currentPosition"),textStatus:state.localStore.get("textStatus"),isCropping:state.localStore.get("isCropping"),isFraming:state.localStore.get("isFraming"),workspaceGrid:state.localStore.get("workspaceGrid"),transformStatus:state.localStore.get("transformStatus"),isWorkspaceTextFocus:state.localStore.get('isWorkspaceTextFocus'),animakerType:state.localStore.get('animakerType'),isToolCropping:state.localStore.get('isToolCropping'),textOffset:state.localStore.get('textOffset'),isTextClicked:state.localStore.get("isTextClicked")};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{moveUpdate:function moveUpdate(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_11" /* moveUpdate */])(data,socket));},resizeUpdate:function resizeUpdate(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_24" /* resizeUpdate */])(data,socket));},rotationUpdate:function rotationUpdate(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_25" /* rotationUpdate */])(data,socket));},updateTransformStatus:function updateTransformStatus(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_97" /* updateTransformStatus */])(data));},updateTextStatus:function updateTextStatus(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_95" /* updateTextStatus */])(data));},setCurrentPosition:function setCurrentPosition(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_30" /* setCurrentPosition */])(data));},cropImage:function cropImage(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["O" /* cropImage */])(data,socket));},toggleCrop:function toggleCrop(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_68" /* toggleCrop */])(data));},toggleFrame:function toggleFrame(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_69" /* toggleFrame */])(data));},updateObjectById:function updateObjectById(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_83" /* updateObjectById */])(data,socket));},updateItem:function updateItem(data,socket){dispatch({type:"UPDATE_ITEM",data:data,socket:socket});},updateSelectionBox:function updateSelectionBox(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_90" /* updateSelectionBox */])(data));},updateBg:function updateBg(data,socket){dispatch({type:'UPDATE_BG',data:data,socket:socket});},setIsTextClicked:function setIsTextClicked(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_34" /* setIsTextClicked */])(data));}};};var TransformManager=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_TransformManagerComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (TransformManager);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ShapeHelper__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_app_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__ = __webpack_require__(9);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TransformManagerComponent=function(_React$Component){_inherits(TransformManagerComponent,_React$Component);function TransformManagerComponent(props){_classCallCheck(this,TransformManagerComponent);var _this=_possibleConstructorReturn(this,(TransformManagerComponent.__proto__||Object.getPrototypeOf(TransformManagerComponent)).call(this,props));_this.eventMatchers={'HTMLEvents':/^(?:load|unload|abort|error|select|change|submit|reset|focus|blur|resize|scroll)$/,'MouseEvents':/^(?:click|dblclick|mouse(?:down|up|over|move|out))$/};_this.defaultOptions={pointerX:0,pointerY:0,button:0,ctrlKey:false,altKey:false,shiftKey:false,metaKey:false,bubbles:true,cancelable:true};_this.selectionBox={};_this.keyPressUpdate={};_this.initialSelectionBox={};_this.selectedItems=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({});_this.groupedItems=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({});_this.mouseStartPosition={};_this.currentItemContainer="workspaceItems";_this.initiateMove=_this.initiateMove.bind(_this);_this.moveSelection=_this.moveSelection.bind(_this);_this.stopMove=_this.stopMove.bind(_this);_this.moveItem=_this.moveItem.bind(_this);_this.initiateResize=_this.initiateResize.bind(_this);_this.resizeSelection=_this.resizeSelection.bind(_this);_this.stopResize=_this.stopResize.bind(_this);_this.resizeTextContainer=_this.resizeTextContainer.bind(_this);_this.getResizePosition=_this.getResizePosition.bind(_this);_this.initiateRotate=_this.initiateRotate.bind(_this);_this.rotateSelection=_this.rotateSelection.bind(_this);_this.stopRotate=_this.stopRotate.bind(_this);_this.getTextBounds=_this.getTextBounds.bind(_this);_this.handleShortcuts=_this.handleShortcuts.bind(_this);_this.moveControlPoint=_this.moveControlPoint.bind(_this);_this.controlShape=_this.controlShape.bind(_this);_this.tabChanged=_this.tabChanged.bind(_this);_this.anchorScales=null;_this.anchorAngles=null;_this.restrictedSelectionBox=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({});_this.restrictBounds=false;_this.lockRotate=false;_this.state={prevSelectedObjects:{}};_this.snapPoints=[];_this.xSnapPoints=[];_this.ySnapPoints=[];_this.widthLocked=false;_this.lockedWidth=null;_this.heightLocked=false;_this.lockedHeight=null;_this.cornerResize=_this.props.cornerResize;_this.appUrl=__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a['APPICONS'][__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a['APPICONS']['current']];_this.transformingTimer=null;_this.transformTimeout=500;_this.rotateCount=0;return _this;}/*
	Lifecycles
	*/_createClass(TransformManagerComponent,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.selectedItems.size>0&&this.props.currentPosition!==null){this.simulate(this.selectionBoxElement.getElementsByClassName("inner-box")[0],"mousedown",{pointerX:this.props.currentPosition.get("x"),pointerY:this.props.currentPosition.get("y")});}if(this.props.selectedCamera!==""&&this.props.selectedCamera!==undefined){this.currentItemContainer="workspaceCameras";this.restrictBounds=true;this.lockRotate=true;this.cornerResize=false;}this.setSnapPoints();window.addEventListener("blur",this.tabChanged,false);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('mousemove',this.moveSelection,false);window.removeEventListener("mouseup",this.stopMove,false);window.removeEventListener("blur",this.tabChanged,false);}},{key:'tabChanged',value:function tabChanged(e){try{this.ctrlPressed=false;}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"TransformManagerComponent-tabChanged");}}},{key:'setSnapPoints',value:function setSnapPoints(){var _this2=this;this.snapPoints=[];this.xSnapPoints=[];this.ySnapPoints=[];if(this.props.workspaceGrid){this.snapPoints=[{x:0,y:0,width:this.props.workspaceWidth,height:this.props.workspaceHeight,left:true},{x:this.props.workspaceWidth/2,y:this.props.workspaceHeight/2,width:this.props.workspaceWidth,height:this.props.workspaceHeight,center:true},{x:this.props.workspaceWidth,y:this.props.workspaceHeight,width:this.props.workspaceWidth,height:this.props.workspaceHeight,right:true}];for(var i=0;i<8;i++){for(var j=0;j<8;j++){this.snapPoints.push({x:i*this.props.workspaceWidth/8,y:j*this.props.workspaceHeight/8,width:this.props.workspaceWidth,height:this.props.workspaceHeight});}}}else{if(this.currentItemContainer==="workspaceItems"){this.xSnapPoints.push.apply(this.xSnapPoints,[{x:0,y:0,height:this.props.workspaceHeight},{x:this.props.workspaceWidth/2,y:0,height:this.props.workspaceHeight},{x:this.props.workspaceWidth,y:0,height:this.props.workspaceHeight}]);this.ySnapPoints.push.apply(this.ySnapPoints,[{x:0,y:0,width:this.props.workspaceWidth},{x:0,y:this.props.workspaceHeight/2,width:this.props.workspaceWidth},{x:0,y:this.props.workspaceHeight,width:this.props.workspaceWidth}]);this.snapPoints.push({x:0,y:0,width:this.props.workspaceWidth,height:this.props.workspaceHeight},{x:this.props.workspaceWidth/2,y:this.props.workspaceHeight/2,width:this.props.workspaceWidth,height:this.props.workspaceHeight},{x:this.props.workspaceWidth,y:this.props.workspaceHeight,width:this.props.workspaceWidth,height:this.props.workspaceHeight});if(this.props.unSelectedObjects!==null&&this.props.unSelectedObjects.size>0){this.props.unSelectedObjects.entrySeq().forEach(function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],single_item=_ref2[1];var bound=_this2.getSelectionBoxBounds({x:single_item.get("x"),y:single_item.get("y"),cx:single_item.get("x")+single_item.get("width")/2,cy:single_item.get("y")+single_item.get("height")/2,width:single_item.get("width"),height:single_item.get("height"),angle:single_item.get("angle")});_this2.snapPoints.push({x:bound.x,y:bound.y,width:single_item.get("width"),height:single_item.get("height"),left:true},{x:bound.x+bound.width/2,y:bound.y+bound.height/2,width:single_item.get("width"),height:single_item.get("height"),center:true},{x:bound.x+bound.width,y:bound.y+bound.height,width:single_item.get("width"),height:single_item.get("height"),right:true});_this2.xSnapPoints.push.apply(_this2.xSnapPoints,[{x:bound.x,y:bound.y,height:bound.height},{x:bound.x+bound.width/2,y:bound.y,height:bound.height},{x:bound.x+bound.width,y:bound.y,height:bound.height}]);_this2.ySnapPoints.push.apply(_this2.ySnapPoints,[{x:bound.x,y:bound.y,width:bound.width},{x:bound.x,y:bound.y+bound.height/2,width:bound.width},{x:bound.x,y:bound.y+bound.height,width:bound.width}]);});}}else if(this.currentItemContainer==="workspaceCameras"){this.xSnapPoints.push.apply(this.xSnapPoints,[{x:this.props.workspaceWidth/2,y:0,height:this.props.workspaceHeight}]);this.ySnapPoints.push.apply(this.ySnapPoints,[{x:0,y:this.props.workspaceHeight/2,width:this.props.workspaceWidth}]);this.snapPoints.push({x:this.props.workspaceWidth/2,y:this.props.workspaceHeight/2,width:this.props.workspaceWidth,height:this.props.workspaceHeight});if(this.props.unSelectedCameras!==null&&this.props.unSelectedCameras.size>0){this.props.unSelectedCameras.entrySeq().forEach(function(_ref3){var _ref4=_slicedToArray(_ref3,2),key=_ref4[0],single_item=_ref4[1];var bound=_this2.getSelectionBoxBounds({x:single_item.get("x"),y:single_item.get("y"),cx:single_item.get("x")+single_item.get("width")/2,cy:single_item.get("y")+single_item.get("height")/2,width:single_item.get("width"),height:single_item.get("height"),angle:single_item.get("angle")});_this2.snapPoints.push({x:bound.x,y:bound.y,width:single_item.get("width"),height:single_item.get("height"),left:true},{x:bound.x+bound.width/2,y:bound.y+bound.height/2,width:single_item.get("width"),height:single_item.get("height"),center:true},{x:bound.x+bound.width,y:bound.y+bound.height,width:single_item.get("width"),height:single_item.get("height"),right:true});_this2.xSnapPoints.push.apply(_this2.xSnapPoints,[{x:bound.x,y:bound.y,height:bound.height},{x:bound.x+bound.width/2,y:bound.y,height:bound.height},{x:bound.x+bound.width,y:bound.y,height:bound.height}]);_this2.ySnapPoints.push.apply(_this2.ySnapPoints,[{x:bound.x,y:bound.y,width:bound.width},{x:bound.x,y:bound.y+bound.height/2,width:bound.width},{x:bound.x,y:bound.y+bound.height,width:bound.width}]);});}}}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.props.selectedItems!==prevProps.selectedItems){var elements=document.querySelectorAll(".type-scr");for(var i=0;i<elements.length;i++){elements[i].style.display="none";}}if(this.props.textStatus!==prevProps.textStatus){if(this.props.textStatus.get("id")!==prevProps.textStatus.get("id")&&this.props.isTextClicked){this.props.setIsTextClicked(false);}}if(!this.props.isWorkspaceTextFocus&&this.props.shortcutName!==prevProps.shortcutName&&this.props.shortcutName!=="")this.handleShortcuts(this.props.shortcutName);else if(!this.props.isWorkspaceTextFocus&&this.props.shortcutName!==prevProps.shortcutName&&this.props.shortcutName===""){if(prevProps.shortcutName==="LEFT_ARROW"||prevProps.shortcutName==="LEFT_ARROW_AGAIN"||prevProps.shortcutName==="RIGHT_ARROW"||prevProps.shortcutName==="RIGHT_ARROW_AGAIN"||prevProps.shortcutName==="UP_ARROW"||prevProps.shortcutName==="UP_ARROW_AGAIN"||prevProps.shortcutName==="DOWN_ARROW"||prevProps.shortcutName==="DOWN_ARROW_AGAIN"||prevProps.shortcutName==="SHIFT_LEFT_ARROW"||prevProps.shortcutName==="SHIFT_LEFT_ARROW_AGAIN"||prevProps.shortcutName==="SHIFT_RIGHT_ARROW"||prevProps.shortcutName==="SHIFT_RIGHT_ARROW_AGAIN"||prevProps.shortcutName==="SHIFT_UP_ARROW"||prevProps.shortcutName==="SHIFT_UP_ARROW_AGAIN"||prevProps.shortcutName==="SHIFT_DOWN_ARROW"||prevProps.shortcutName==="SHIFT_DOWN_ARROW_AGAIN"){this.transformingByKey=false;this.hideSnaplines();this.updateInitialSelectionBox({transforming:false,moving:false,x:this.keyPressUpdate.x,y:this.keyPressUpdate.y,cx:this.keyPressUpdate.x+this.keyPressUpdate.width/2,cy:this.keyPressUpdate.y+this.keyPressUpdate.height/2});this.props.moveUpdate({"items":this.selectedItems,"children":this.groupedItems,"selectedScene":this.props.selectedScene,"currentContainer":this.currentItemContainer,selectedItems:this.props.selectedItems},this.props.socket);}}if((prevProps.selectedItems!==this.props.selectedItems||this.props.currentPosition!==prevProps.currentPosition)&&this.props.selectedItems.size>0&&this.props.currentPosition!==null){this.simulate(this.selectionBoxElement.getElementsByClassName("inner-box")[0],"mousedown",{pointerX:this.props.currentPosition.get("x"),pointerY:this.props.currentPosition.get("y")});}if(this.props.selectedItems!==prevProps.selectedItems&&this.props.selectedItems.size>0){if(this.currentItemContainer!=="workspaceItems")this.currentItemContainer="workspaceItems";this.restrictBounds=false;this.lockRotate=false;if(this.props.cornerResize!==undefined&&this.props.cornerResize)this.cornerResize=true;}else if(this.props.selectedCamera!==prevProps.selectedCamera&&this.props.selectedCamera!==""){if(this.currentItemContainer!=="workspaceCameras")this.currentItemContainer="workspaceCameras";this.restrictBounds=true;this.lockRotate=true;this.cornerResize=false;}this.setSnapPoints();}},{key:'simulate',value:function simulate(element,eventName){var options=this.extend(this.defaultOptions,arguments[2]||{});var oEvent,eventType=null;for(var name in this.eventMatchers){if(this.eventMatchers[name].test(eventName)){eventType=name;break;}}if(!eventType)throw new SyntaxError('Only HTMLEvents and MouseEvents interfaces are supported');if(document.createEvent){oEvent=document.createEvent(eventType);if(eventType==='HTMLEvents'){oEvent.initEvent(eventName,options.bubbles,options.cancelable);}else{oEvent.initMouseEvent(eventName,options.bubbles,options.cancelable,document.defaultView,options.button,options.pointerX,options.pointerY,options.pointerX,options.pointerY,options.ctrlKey,options.altKey,options.shiftKey,options.metaKey,options.button,element);}element.dispatchEvent(oEvent);}else{options.clientX=options.pointerX;options.clientY=options.pointerY;var evt=document.createEventObject();oEvent=this.extend(evt,options);element.fireEvent('on'+eventName,oEvent);}return element;}},{key:'extend',value:function extend(destination,source){for(var property in source){destination[property]=source[property];}return destination;}},{key:'disableClick',value:function disableClick(selector){var elements=document.querySelectorAll(selector);for(var i=0;i<elements.length;i++){if(elements[i].className.indexOf("pointer-events-none")===-1){elements[i].classList.add("pointer-events-none");}}}},{key:'enableClick',value:function enableClick(selector){var elements=document.querySelectorAll(selector);for(var i=0;i<elements.length;i++){if(elements[i].className.indexOf("pointer-events-none")!==-1)elements[i].classList.remove("pointer-events-none");}}},{key:'updateInitialSelectionBox',value:function updateInitialSelectionBox(obj){this.selectionBox=Object.assign(this.selectionBox,obj);this.initialSelectionBox=Object.assign(this.initialSelectionBox,obj);}},{key:'getMousePosition',value:function getMousePosition(e){try{var currentX=e.clientX-document.getElementById('workspace').offsetLeft,currentY=e.clientY-document.getElementById('workspace').offsetTop;return{x:currentX,y:currentY};}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"TransformManagerComponent-getMousePosition");}}},{key:'hideSnaplines',value:function hideSnaplines(){var snapLines=document.getElementsByClassName("snap-line");for(var i=0;i<snapLines.length;i++){snapLines[i].style.display="none";}}},{key:'getWorkspaceBounds',value:function getWorkspaceBounds(){var workspace=document.getElementById('workspace');return{x:workspace.offsetLeft,y:workspace.offsetTop,width:workspace.offsetWidth,height:workspace.offsetHeight};}},{key:'composedPath',value:function composedPath(el){var path=[];while(el){path.push(el);if(el.tagName==='HTML'){path.push(document);path.push(window);return path;}el=el.parentElement;}}},{key:'isMouseOn',value:function isMouseOn(e,value){try{var i;var path_array=e.path||e.composedPath&&e.composedPath()||this.composedPath(e.target);if(path_array.length>0){for(i=0;i<path_array.length;i++){if(path_array[i].className!==undefined&&_typeof(path_array[i].className)!=="object"){if(path_array[i].className.indexOf(value)!==-1){return true;}}else if(path_array[i].className!==undefined&&_typeof(path_array[i].className)==="object"){if(path_array[i].className.animVal===value)return true;}}}return false;}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"TransformManagerComponent-isMouseOn");}}},{key:'isRightMouse',value:function isRightMouse(e){try{var isRightMB;e=e||window.event;if("which"in e)isRightMB=e.which===3;else if("button"in e)isRightMB=e.button===2;return isRightMB;}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"TransformManagerComponent-isRightMouse");}}},{key:'isMouseOnSelectionBox',value:function isMouseOnSelectionBox(e){try{var workspace_bounds=this.getWorkspaceBounds(),currentX=e.clientX-workspace_bounds.x,currentY=e.clientY-workspace_bounds.y;if(this.selectionBox.x!==null){if(currentX>this.selectionBox.x&&currentY>this.selectionBox.y&&currentX<this.selectionBox.x+this.selectionBox.width&&currentY<this.selectionBox.y+this.selectionBox.height&&!this.isMouseOn(e,"handle"))return true;}return false;}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"TransformManagerComponent-isMouseOnSelectionBox");}}},{key:'setCursor',value:function setCursor(e,action){}},{key:'resetCursor',value:function resetCursor(e){try{if(!this.selectionBox.transforming){document.getElementById('workspace').style.cursor='default';}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"TransformManagerComponent-resetCursor");}}/*
	  Move
	*/},{key:'getXSnapPoint',value:function getXSnapPoint(point,r,array){var result=array.filter(function(arr){return Math.abs(arr.x-point)<=r;});return result;}},{key:'getYSnapPoint',value:function getYSnapPoint(point,r,array){var result=array.filter(function(arr){return Math.abs(arr.y-point)<=r;});return result;}},{key:'getSelectionSnapPoints',value:function getSelectionSnapPoints(x,y){var cx=x+this.selectionBox.width*this.props.zoomFactor/2;var cy=y+this.selectionBox.height*this.props.zoomFactor/2;var bounds=this.getSelectionBoxBounds({x:x,y:y,cx:cx,cy:cy,width:this.selectionBox.width*this.props.zoomFactor,height:this.selectionBox.height*this.props.zoomFactor,angle:this.selectionBox.angle});var boundX=bounds.x/this.props.zoomFactor,boundY=bounds.y/this.props.zoomFactor,boundWidth=bounds.width/this.props.zoomFactor,boundHeight=bounds.height/this.props.zoomFactor;var selectionLeft=boundX,selectionTop=boundY,selectionRight=boundX+boundWidth,selectionBottom=boundY+boundHeight,selectionCenterX=boundX+boundWidth/2,selectionCenterY=boundY+boundHeight/2;return{left:selectionLeft,top:selectionTop,centerX:selectionCenterX,centerY:selectionCenterY,right:selectionRight,bottom:selectionBottom};}},{key:'handleShortcuts',value:function handleShortcuts(option){if(this.selectionBox.x!==null){var x=this.selectionBox.x,y=this.selectionBox.y;var d=1,sd=10;switch(option){case"RIGHT_ARROW":case"RIGHT_ARROW_AGAIN":x+=d;break;case"LEFT_ARROW":case"LEFT_ARROW_AGAIN":x-=d;break;case"UP_ARROW":case"UP_ARROW_AGAIN":y-=d;break;case"DOWN_ARROW":case"DOWN_ARROW_AGAIN":y+=d;break;case"SHIFT_RIGHT_ARROW":case"SHIFT_RIGHT_ARROW_AGAIN":x+=sd;break;case"SHIFT_LEFT_ARROW":case"SHIFT_LEFT_ARROW_AGAIN":x-=sd;break;case"SHIFT_UP_ARROW":case"SHIFT_UP_ARROW_AGAIN":y-=sd;break;case"SHIFT_DOWN_ARROW":case"SHIFT_DOWN_ARROW_AGAIN":y+=sd;break;default:break;}if((this.selectionBox.x!==x||this.selectionBox.y!==y)&&!this.props.textStatus.get("isFocused")){this.transformingByKey=true;if(!this.props.transformStatus.get("transforming")){this.props.updateTransformStatus({transforming:true,moving:true});}this.moveItem(x*this.props.zoomFactor,y*this.props.zoomFactor);if(this.transformingTimer)clearTimeout(this.transformingTimer);this.transformingTimer=setTimeout(function(){this.props.moveUpdate({"items":this.selectedItems,"children":this.groupedItems,"selectedScene":this.props.selectedScene,"currentContainer":this.currentItemContainer,selectedItems:this.props.selectedItems},this.props.socket);}.bind(this),this.transformTimeout);}}}},{key:'moveItem',value:function moveItem(x,y){var _this3=this;var selectionBox=this.selectionBoxElement;var workspaceBounds=this.getWorkspaceBounds();if(this.restrictBounds!==undefined&&this.restrictBounds){var outLineWidth=0;if(x-outLineWidth<0)x=outLineWidth;if(y-outLineWidth<0)y=outLineWidth;if(y+this.selectionBox.height*this.props.zoomFactor+outLineWidth>document.getElementById('workspace').offsetHeight)y=document.getElementById('workspace').offsetHeight-this.selectionBox.height*this.props.zoomFactor-outLineWidth;if(x+this.selectionBox.width*this.props.zoomFactor+outLineWidth>document.getElementById('workspace').offsetWidth)x=document.getElementById('workspace').offsetWidth-this.selectionBox.width*this.props.zoomFactor-outLineWidth;}if(!this.transformingByKey){var selectionPoints=this.getSelectionSnapPoints(x,y),i=0;var xSnapped=false,ySnapped=false;var r=2;if(this.props.workspaceGrid)r=4;for(i=0;i<this.snapPoints.length;i++){var dX=(selectionPoints.left-this.snapPoints[i].x)*this.props.zoomFactor,dY=(selectionPoints.top-this.snapPoints[i].y)*this.props.zoomFactor;var dCX=(selectionPoints.centerX-this.snapPoints[i].x)*this.props.zoomFactor,dCY=(selectionPoints.centerY-this.snapPoints[i].y)*this.props.zoomFactor;var dRX=(selectionPoints.right-this.snapPoints[i].x)*this.props.zoomFactor,dRY=(selectionPoints.bottom-this.snapPoints[i].y)*this.props.zoomFactor;var snappedX=Math.abs(dX)<=r?dX:Math.abs(dCX)<=(this.snapPoints[i].center?6:r)?dCX:Math.abs(dRX)<=r?dRX:false;var snappedY=Math.abs(dY)<=r?dY:Math.abs(dCY)<=(this.snapPoints[i].center?6:r)?dCY:Math.abs(dRY)<=r?dRY:false;if(snappedX!==false&&!xSnapped){x=parseFloat((x-snappedX).toFixed(2));xSnapped=true;}if(snappedY!==false&&!ySnapped){y=parseFloat((y-snappedY).toFixed(2));ySnapped=true;}}}var selectionCX=x/this.props.zoomFactor+this.selectionBox.width/2,selectionCy=y/this.props.zoomFactor+this.selectionBox.height/2;selectionBox.style.transform="translate("+x+"px, "+y+"px) rotateZ("+this.selectionBox.angle+"deg)";var allItems=this.selectedItems;allItems.entrySeq().forEach(function(_ref5){var _ref6=_slicedToArray(_ref5,2),key=_ref6[0],item=_ref6[1];var item_x=Math.cos((item.get("angle_to_center")+_this3.initialSelectionBox.angle)*Math.PI/180)*Math.abs(item.get("dis_to_center"))+selectionCX-item.get("width")/2;var item_y=Math.sin((item.get("angle_to_center")+_this3.initialSelectionBox.angle)*Math.PI/180)*Math.abs(item.get("dis_to_center"))+selectionCy-item.get("height")/2;var item_to_update=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({"x":item_x,"y":item_y});allItems=allItems.set(key,item.merge(item_to_update));if(document.getElementById(key)!==null){var flipPos=item.get("flipPosition");var flip=flipPos===1?" scaleX(-1)":flipPos===2?" scaleY(-1)":flipPos===3?" scaleX(-1) scaleY(-1)":"";document.getElementById(key).style.transform="translate("+(item_x*_this3.props.zoomFactor).toFixed(2)+"px, "+(item_y*_this3.props.zoomFactor).toFixed(2)+"px) rotateZ("+item.get("angle")+"deg)"+flip;}});this.selectedItems=allItems;this.selectionBox=Object.assign(this.selectionBox,{"x":x/this.props.zoomFactor,"y":y/this.props.zoomFactor});if(this.props.shortcutName!=="")this.keyPressUpdate=Object.assign(this.keyPressUpdate,this.selectionBox);var selectionSnaps=this.getSelectionSnapPoints(x,y);var xSelectionPoints=[selectionSnaps.left,selectionSnaps.centerX,selectionSnaps.right];var ySelectionPoints=[selectionSnaps.top,selectionSnaps.centerY,selectionSnaps.bottom];if(!this.props.workspaceGrid){r=0.5;for(i=0;i<xSelectionPoints.length;i++){var snapPoint=this.getXSnapPoint(xSelectionPoints[i],r,this.xSnapPoints);var verticalLine=document.getElementsByClassName("vertical-line")[i];if(snapPoint.length>0){var verX=snapPoint[0].x*this.props.zoomFactor+workspaceBounds.x,verY=snapPoint[0].y*this.props.zoomFactor+workspaceBounds.y,verHeight=snapPoint[0].height*this.props.zoomFactor;if(verY>selectionSnaps.top*this.props.zoomFactor+workspaceBounds.y){var _dY=verY-(selectionSnaps.top*this.props.zoomFactor+workspaceBounds.y);verY-=_dY;verHeight+=_dY;}if(verY+verHeight<selectionSnaps.bottom*this.props.zoomFactor+workspaceBounds.y){var _dY2=selectionSnaps.bottom*this.props.zoomFactor+workspaceBounds.y-(verY+verHeight);verHeight+=_dY2;}verticalLine.style.height=verHeight+"px";verticalLine.style.left=verX-0.5+"px";verticalLine.style.top=verY-0.5+"px";verticalLine.style.display="block";}else{verticalLine.style.display="none";}}for(i=0;i<ySelectionPoints.length;i++){var _snapPoint=this.getYSnapPoint(ySelectionPoints[i],r,this.ySnapPoints);var horizontalLine=document.getElementsByClassName("horizontal-line")[i];if(_snapPoint.length>0){var horX=_snapPoint[0].x*this.props.zoomFactor+workspaceBounds.x,horY=_snapPoint[0].y*this.props.zoomFactor+workspaceBounds.y,horWidth=_snapPoint[0].width*this.props.zoomFactor;if(horX>selectionSnaps.left*this.props.zoomFactor+workspaceBounds.x){var _dX=horX-(selectionSnaps.left*this.props.zoomFactor+workspaceBounds.x);horX-=_dX;horWidth+=_dX;}if(horX+horWidth<selectionSnaps.right*this.props.zoomFactor+workspaceBounds.x){var _dX2=selectionSnaps.right*this.props.zoomFactor+workspaceBounds.x-(horX+horWidth);horWidth+=_dX2;}horizontalLine.style.width=horWidth+"px";horizontalLine.style.left=horX-0.5+"px";horizontalLine.style.top=horY-0.5+"px";horizontalLine.style.display="block";}else{horizontalLine.style.display="none";}}}}},{key:'initiateMove',value:function initiateMove(e){try{var target=e.target;if(target.className.indexOf("crop-handle")!==-1){return;}e.stopPropagation();if(e.timeStamp-this.lastDown<250&&!this.isRightMouse(e)){if(this.props.selectedItems.size===1){if(!this.props.isCropping&&(this.selectedItems.get(this.props.selectedItems.get(0)).get("type")==="IMG"||this.selectedItems.get(this.props.selectedItems.get(0)).get("type")==="STOCKIMG"||this.selectedItems.get(this.props.selectedItems.get(0)).get("type")==="UPLOADS"&&this.selectedItems.get(this.props.selectedItems.get(0)).get("subType")==="UPIMAGE"))this.props.toggleCrop();else if(!this.props.isFraming&&this.selectedItems.get(this.props.selectedItems.get(0)).get("type")==="FRAME")this.props.toggleFrame();if(this.selectedItems.getIn([this.props.selectedItems.get(0),"type"])==="SHAPE"){this.props.updateTextStatus({id:this.props.selectedItems.get(0),isFocused:true,container:"workspaceItems",isRTL:this.selectedItems.getIn([this.props.selectedItems.get(0),"textData","formats","others","isRTL"]),isGrouped:false,type:"SHAPE",fontSize:parseFloat(this.selectedItems.getIn([this.props.selectedItems.get(0),"textData","formats","containerStyle","fontSize"]),10)});}}if(this.props.selectedItems.size===1&&this.props.animakerType==='lite')this.disableClick(".selectionBox");}this.lastDown=e.timeStamp;this.moved=false;if(this.props.selectedItems.size===1&&this.props.animakerType==='full')this.disableClick(".selectionBox");e.preventDefault();var isMoveLocked=this.lockMove!==undefined&&this.lockMove?true:false;if(!isMoveLocked){this.updateInitialSelectionBox({transforming:true,moving:true});var mouse_position=this.getMousePosition(e);this.mouseStartPosition=Object.assign(this.mouseStartPosition,{x:mouse_position.x,y:mouse_position.y,offsetX:this.selectionBox.x-mouse_position.x/this.props.zoomFactor,offsetY:this.selectionBox.y-mouse_position.y/this.props.zoomFactor});if(this.selectionBox)window.addEventListener('mousemove',this.moveSelection,false);window.addEventListener('mouseup',this.stopMove,false);}else{this.enableClick(".selectionBox");}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"TransformManagerComponent-initiateMove");}}},{key:'moveSelection',value:function moveSelection(e){try{if(this.lastDown+10<e.timeStamp){if(!this.moved){this.moved=true;this.enableClick(".selectionBox");this.props.updateTransformStatus({transforming:true,moving:true});}e.preventDefault();var mouse_position=this.getMousePosition(e),x=parseFloat((mouse_position.x+this.mouseStartPosition.offsetX*this.props.zoomFactor).toFixed(2)),y=parseFloat((mouse_position.y+this.mouseStartPosition.offsetY*this.props.zoomFactor).toFixed(2));this.moveItem(x,y);}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"TransformManagerComponent-moveSelection");}}},{key:'stopMove',value:function stopMove(e){try{this.enableClick(".selectionBox");this.updateInitialSelectionBox({transforming:false,moving:false,x:this.selectionBox.x,y:this.selectionBox.y,cx:this.selectionBox.x+this.selectionBox.width/2,cy:this.selectionBox.y+this.selectionBox.height/2});if(this.moved){e.preventDefault();if(!this.props.isToolCropping){var mouse_position=this.getMousePosition(e),x=parseFloat((mouse_position.x+this.mouseStartPosition.offsetX*this.props.zoomFactor).toFixed(2)),y=parseFloat((mouse_position.y+this.mouseStartPosition.offsetY*this.props.zoomFactor).toFixed(2));this.moveItem(x,y);this.props.moveUpdate({"items":this.selectedItems,"children":this.groupedItems,isMultimove:this.state.selectedObjects.size===1&&this.state.selectedObjects.first().get("isMultimove")&&this.props.animakerType==='full',isSwitch:this.state.selectedObjects.size===1&&this.state.selectedObjects.first().get("isSwitch")&&this.props.animakerType==='full',"selectedScene":this.props.selectedScene,"currentContainer":this.currentItemContainer,selectedItems:this.props.selectedItems},this.props.socket);}else{var toUpdate={x:this.selectionBox.x/this.props.workspaceWidth,y:this.selectionBox.y/this.props.workspaceHeight};this.props.updateBg({selectedScene:this.props.selectedScene,toUpdate:toUpdate,toolCrop:true},this.props.socket);}}else{this.props.setCurrentPosition(null);if(this.props.selectedItems.size===1&&this.props.animakerType==='full'){if(this.selectedItems.getIn([this.props.selectedItems.get(0),"type"])==="TEXT"){if(this.props.isTextClicked)this.props.updateTextStatus({id:this.props.selectedItems.get(0),isFocused:true,container:"workspaceItems",isRTL:false,isGrouped:this.props.isGrouped,fontSize:parseFloat(this.selectedItems.getIn([this.props.selectedItems.get(0),"textData","formats","containerStyle","fontSize"]),10),type:"TEXT"});else this.props.updateTextStatus({id:this.props.selectedItems.get(0),isFocused:false,container:"workspaceItems",isRTL:false,isGrouped:this.props.isGrouped,fontSize:parseFloat(this.selectedItems.getIn([this.props.selectedItems.get(0),"textData","formats","containerStyle","fontSize"]),10),type:"TEXT"});this.disableClick(".selectionBox");if(this.props.textStatus.get("isSelected")){this.props.setIsTextClicked(true);}}}if(this.props.textStatus.get("isFocused"))this.disableClick(".selectionBox");}window.removeEventListener('mousemove',this.moveSelection,false);window.removeEventListener('mouseup',this.stopMove,false);this.hideSnaplines();if(!this.isMouseOnSelectionBox(e))this.resetCursor(e);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"TransformManagerComponent-stopMove");}}},{key:'isFontAutoSize',value:function isFontAutoSize(id,container){if(!container)container="workspaceItems";var active_text=container==="workspaceItems"?this.props.selectedObjects.getIn([id,"textData"]):this.props.selectedChildren.getIn([id,"textData"]);var result=false;var auto_font_size=active_text.getIn(["formats","others","isAutoFontSize"]);if(auto_font_size!==undefined)result=auto_font_size;return result;}},{key:'getTextBounds',value:function getTextBounds(e,id){var handle=this.initialSelectionBox.handle;var textItem;var textId=id;textItem=this.props.selectedObjects.get(id);var textElement=document.getElementById(textId),width,height,x,y;var textContainer=textElement.getElementsByClassName('text-container')[0];if(handle==="left"||handle==="right"){var mouse_position=this.getMousePosition(e);var dx=(mouse_position.x-this.mouseStartPosition.x)/this.props.zoomFactor,dy=(mouse_position.y-this.mouseStartPosition.y)/this.props.zoomFactor,angle=this.initialSelectionBox.angle;var newX=this.initialSelectionBox.x,newY=this.initialSelectionBox.y,newWidth=this.initialSelectionBox.width,newHeight=this.initialSelectionBox.height;var prevX=this.initialSelectionBox.x,prevY=this.initialSelectionBox.y,prevWidth=this.initialSelectionBox.width;var rPx=this.initialSelectionBox.rotated_x,rPy=this.initialSelectionBox.rotated_y;var adX=dx*Math.cos(angle*(Math.PI/180))+dy*Math.sin(angle*(Math.PI/180));var rotatedX,rotatedY,r1Px,r1Py,tempY;if(handle==="left"){newWidth=prevWidth-adX;newX=prevX+adX;tempY=newY-(newY+newHeight/2);rotatedX=(newX-(newX+newWidth/2))*Math.cos(angle*(Math.PI/180))-tempY*Math.sin(angle*(Math.PI/180));rotatedY=(newY-(newY+newHeight/2))*Math.sin(angle*(Math.PI/180))+tempY*Math.cos(angle*(Math.PI/180));r1Px=newX+(rotatedX+newWidth/2);r1Py=newY+(rotatedY+newHeight/2);newX=prevX-(rPx-r1Px);newY=prevY-(rPy-r1Py);}else if(handle==="right"){newWidth=prevWidth+adX;tempY=newY-(newY+newHeight/2);rotatedX=(newX-(newX+newWidth/2))*Math.cos(angle*(Math.PI/180))-tempY*Math.sin(angle*(Math.PI/180));rotatedY=(newY-(newY+newHeight/2))*Math.sin(angle*(Math.PI/180))+tempY*Math.cos(angle*(Math.PI/180));r1Px=newX+(rotatedX+newWidth/2);r1Py=newY+(rotatedY+newHeight/2);newX=prevX-(r1Px-rPx);newY=prevY-(r1Py-rPy);}width=newWidth;height=newHeight;x=newX;y=newY;textElement.style.transform="translate("+newX*this.props.zoomFactor+"px, "+newY*this.props.zoomFactor+"px) rotateZ(0deg)";textElement.style.width=width*this.props.zoomFactor+"px";var range=document.createRange();range.selectNode(textElement.getElementsByClassName('text-container')[0]);var rangeBounds=range.getBoundingClientRect();textElement.style.transform="translate("+newX*this.props.zoomFactor+"px, "+newY*this.props.zoomFactor+"px) rotateZ("+textItem.get("angle")+"deg)";var rangeWidth=rangeBounds.width+this.props.textOffset*this.props.zoomFactor;var rangeHeight=rangeBounds.height+this.props.textOffset*this.props.zoomFactor;if(rangeWidth>width*this.props.zoomFactor){width=rangeWidth/this.props.zoomFactor;}height=rangeHeight/this.props.zoomFactor;}else{var resize_position=this.getResizePosition(e);var scale_x=resize_position.scale_x,scale_y=resize_position.scale_y,cx=resize_position.cx,cy=resize_position.cy;var item=this.selectedItems.get(id);width=Math.abs(item.get("width")*scale_x);height=Math.abs(item.get("height")*scale_y);x=Math.cos((item.get("angle_to_center")+item.get("angle"))*Math.PI/180)*Math.abs(item.get("dis_to_center")*scale_x)+cx-width/2;y=Math.sin((item.get("angle_to_center")+item.get("angle"))*Math.PI/180)*Math.abs(item.get("dis_to_center")*scale_y)+cy-height/2;var textOffset=this.props.textOffset;if(item.get("type")==="SHAPE")textOffset=0;var tsx=(item.get("width")*scale_x-textOffset)/item.get("width"),tsy=(item.get("height")*scale_y-textOffset)/item.get("height");var fontSize=(parseFloat(textItem.getIn(["textData","formats","containerStyle","fontSize"]),10)*Math.abs(Math.max(tsx,tsy))*this.props.zoomFactor).toFixed(2);textContainer.style.fontSize=fontSize+"px";this.props.updateTextStatus({fontSize:fontSize});}return{x:x,y:y,width:width,height:height};}},{key:'resizeTextContainer',value:function resizeTextContainer(e){try{var selectedId=this.selectedItems.keySeq().toArray()[0];var textBounds=this.getTextBounds(e,selectedId);var selectionBox=this.selectionBoxElement;var textWidth=textBounds.width,textHeight=textBounds.height;var x=textBounds.x*this.props.zoomFactor,y=textBounds.y*this.props.zoomFactor,width=textWidth*this.props.zoomFactor,height=textHeight*this.props.zoomFactor;selectionBox.style.transform="translate("+x+"px, "+y+"px) rotateZ("+this.selectionBox.angle+"deg)";selectionBox.style.width=width+"px";selectionBox.style.height=height+"px";if(height<60){if(document.querySelector(".resize-handle.left").className.indexOf("hide-handle")===-1){document.querySelector(".resize-handle.left").classList.add("hide-handle");}if(document.querySelector(".resize-handle.right").className.indexOf("hide-handle")===-1){document.querySelector(".resize-handle.right").classList.add("hide-handle");}}else{if(document.querySelector(".resize-handle.left").className.indexOf("hide-handle")!==-1){document.querySelector(".resize-handle.left").classList.remove("hide-handle");}if(document.querySelector(".resize-handle.right").className.indexOf("hide-handle")!==-1){document.querySelector(".resize-handle.right").classList.remove("hide-handle");}}var textElement=document.getElementById(selectedId);var textItem=void 0;textItem=this.props.selectedObjects.get(selectedId);textElement.style.transform="translate("+x+"px, "+y+"px) rotateZ("+textItem.get("angle")+"deg)";textElement.style.width=width+"px";textElement.style.height=height+"px";}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"TransformManagerComponent-resizeTextContainer");}}},{key:'getResizePosition',value:function getResizePosition(e){try{var mouse_position=this.getMousePosition(e),handle=this.initialSelectionBox.handle;var angle=this.selectionBox.angle;var dx=(mouse_position.x-this.mouseStartPosition.x)/this.props.zoomFactor,dy=(mouse_position.y-this.mouseStartPosition.y)/this.props.zoomFactor;var newX=this.initialSelectionBox.x,newY=this.initialSelectionBox.y,newWidth=this.initialSelectionBox.width,newHeight=this.initialSelectionBox.height;var prevX=this.initialSelectionBox.x,prevY=this.initialSelectionBox.y,prevWidth=this.initialSelectionBox.width,prevHeight=this.initialSelectionBox.height;var rPx=this.initialSelectionBox.rotated_x,rPy=this.initialSelectionBox.rotated_y;var adX=dx*Math.cos(angle*(Math.PI/180))+dy*Math.sin(angle*(Math.PI/180));var adY=dy*Math.cos(angle*(Math.PI/180))-dx*Math.sin(angle*(Math.PI/180));if(!this.cornerResize){adX*=2;adY*=2;}var tempX,tempY,rotatedX,rotatedY,r1Px,r1Py;switch(handle){case"top-left":newWidth=prevWidth-adX;newHeight=prevHeight-adY;newX=prevX+adX;newY=prevY+adY;newY=newY-(newWidth/prevWidth*prevHeight-newHeight);newHeight=newWidth/prevWidth*prevHeight;tempX=newX-(newX+newWidth/2);tempY=newY-(newY+newHeight/2);if(!this.cornerResize){tempX+=(newWidth-prevWidth)/2;tempY+=(newHeight-prevHeight)/2;}rotatedX=tempX*Math.cos(angle*(Math.PI/180))-tempY*Math.sin(angle*(Math.PI/180));rotatedY=tempX*Math.sin(angle*(Math.PI/180))+tempY*Math.cos(angle*(Math.PI/180));r1Px=newX+(rotatedX+newWidth/2);r1Py=newY+(rotatedY+newHeight/2);newX=prevX-(rPx-r1Px);newY=prevY-(rPy-r1Py);break;case"top":newHeight=prevHeight-adY;newY=prevY+adY;tempX=newX-(newX+newWidth/2);tempY=newY-(newY+newHeight/2);if(!this.cornerResize){tempX+=(newWidth-prevWidth)/2;tempY+=(newHeight-prevHeight)/2;}rotatedX=tempX*Math.cos(angle*(Math.PI/180))-tempY*Math.sin(angle*(Math.PI/180));rotatedY=tempX*Math.sin(angle*(Math.PI/180))+tempY*Math.cos(angle*(Math.PI/180));r1Px=newX+(rotatedX+newWidth/2);r1Py=newY+(rotatedY+newHeight/2);newX=prevX-(rPx-r1Px);newY=prevY-(rPy-r1Py);break;case"top-right":newWidth=prevWidth+adX;newHeight=prevHeight-adY;newY=prevY+adY;newY=newY-(newWidth/prevWidth*prevHeight-newHeight);newHeight=newWidth/prevWidth*prevHeight;tempX=newX-(newX+newWidth/2);tempY=newY-(newY+newHeight/2);if(!this.cornerResize){tempX-=(newWidth-prevWidth)/2;tempY+=(newHeight-prevHeight)/2;}rotatedX=tempX*Math.cos(angle*(Math.PI/180))-tempY*Math.sin(angle*(Math.PI/180));rotatedY=tempX*Math.sin(angle*(Math.PI/180))+tempY*Math.cos(angle*(Math.PI/180));r1Px=newX+(rotatedX+newWidth/2);r1Py=newY+(rotatedY+newHeight/2);newX=prevX-(rPx-r1Px);newY=prevY-(rPy-r1Py);break;case"right":newWidth=prevWidth+adX;tempX=newX-(newX+newWidth/2);tempY=newY-(newY+newHeight/2);if(!this.cornerResize){tempX+=(newWidth-prevWidth)/2;tempY+=(newHeight-prevHeight)/2;}rotatedX=tempX*Math.cos(angle*(Math.PI/180))-tempY*Math.sin(angle*(Math.PI/180));rotatedY=tempX*Math.sin(angle*(Math.PI/180))+tempY*Math.cos(angle*(Math.PI/180));r1Px=newX+(rotatedX+newWidth/2);r1Py=newY+(rotatedY+newHeight/2);newX=prevX-(r1Px-rPx);newY=prevY-(r1Py-rPy);break;case"bottom-right":newWidth=prevWidth+adX;newHeight=prevHeight+adY;newHeight=newWidth/prevWidth*prevHeight;tempX=newX-(newX+newWidth/2);tempY=newY-(newY+newHeight/2);if(!this.cornerResize){tempX+=(newWidth-prevWidth)/2;tempY+=(newHeight-prevHeight)/2;}rotatedX=tempX*Math.cos(angle*(Math.PI/180))-tempY*Math.sin(angle*(Math.PI/180));rotatedY=tempX*Math.sin(angle*(Math.PI/180))+tempY*Math.cos(angle*(Math.PI/180));r1Px=newX+(rotatedX+newWidth/2);r1Py=newY+(rotatedY+newHeight/2);newX=prevX-(r1Px-rPx);newY=prevY-(r1Py-rPy);break;case"bottom":newHeight=prevHeight+adY;tempX=newX-(newX+newWidth/2);tempY=newY-(newY+newHeight/2);if(!this.cornerResize){tempX+=(newWidth-prevWidth)/2;tempY+=(newHeight-prevHeight)/2;}rotatedX=tempX*Math.cos(angle*(Math.PI/180))-tempY*Math.sin(angle*(Math.PI/180));rotatedY=tempX*Math.sin(angle*(Math.PI/180))+tempY*Math.cos(angle*(Math.PI/180));r1Px=newX+(rotatedX+newWidth/2);r1Py=newY+(rotatedY+newHeight/2);newX=prevX-(r1Px-rPx);newY=prevY-(r1Py-rPy);break;case"bottom-left":newWidth=prevWidth-adX;newHeight=prevHeight+adY;newX=prevX+adX;newHeight=newWidth/prevWidth*prevHeight;tempX=newX-(newX+newWidth/2);tempY=newY-(newY+newHeight/2);if(!this.cornerResize){tempX+=(newWidth-prevWidth)/2;tempY+=(newHeight-prevHeight)/2;}rotatedX=tempX*Math.cos(angle*(Math.PI/180))-tempY*Math.sin(angle*(Math.PI/180));rotatedY=tempX*Math.sin(angle*(Math.PI/180))+tempY*Math.cos(angle*(Math.PI/180));r1Px=newX+(rotatedX+newWidth/2);r1Py=newY+(rotatedY+newHeight/2);newX=prevX-(rPx-r1Px);newY=prevY-(r1Py-rPy);break;case"left":newWidth=prevWidth-adX;newX=prevX+adX;tempX=newX-(newX+newWidth/2);tempY=newY-(newY+newHeight/2);if(!this.cornerResize){tempX+=(newWidth-prevWidth)/2;tempY+=(newHeight-prevHeight)/2;}rotatedX=tempX*Math.cos(angle*(Math.PI/180))-tempY*Math.sin(angle*(Math.PI/180));rotatedY=tempX*Math.sin(angle*(Math.PI/180))+tempY*Math.cos(angle*(Math.PI/180));r1Px=newX+(rotatedX+newWidth/2);r1Py=newY+(rotatedY+newHeight/2);newX=prevX-(rPx-r1Px);newY=prevY-(rPy-r1Py);break;default:break;}var new_cx=newX+newWidth/2;var new_cy=newY+newHeight/2;if(this.restrictBounds){if(newX+newWidth>=this.props.workspaceWidth||newX>=this.props.workspaceWidth){var oldWidth=newWidth;var rX=newX+newWidth-this.props.workspaceWidth;newWidth-=rX*2;new_cx=this.props.workspaceWidth-newWidth/2;newHeight*=newWidth/oldWidth;newX=new_cx-newWidth/2;newY=new_cy-newHeight/2;}if(newX<=0||newX+newWidth<=0){var _oldWidth=newWidth;newWidth+=newX*2;newHeight*=newWidth/_oldWidth;newX=new_cx-newWidth/2;newY=new_cy-newHeight/2;}if(newY+newHeight>=this.props.workspaceHeight||newY>=this.props.workspaceHeight){var oldHeight=newHeight;var rY=newY+newHeight-this.props.workspaceHeight;newHeight-=rY*2;new_cy=this.props.workspaceHeight-newHeight/2;newWidth*=newHeight/oldHeight;newX=new_cx-newWidth/2;newY=new_cy-newHeight/2;}if(newY<=0||newY+newHeight<=0){var _oldHeight=newHeight;newHeight+=newY*2;newWidth*=newHeight/_oldHeight;newX=new_cx-newWidth/2;newY=new_cy-newHeight/2;}}var scale_x=newWidth/this.initialSelectionBox.width;var scale_y=newHeight/this.initialSelectionBox.height;return{scale_x:scale_x,scale_y:scale_y,cx:new_cx,cy:new_cy};}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"TransformManagerComponent-getResizePosition");}}},{key:'getFontSize',value:function getFontSize(text){var container=document.getElementById(text.id);var ourText=container.getElementsByClassName("text-container")[0];if(ourText.style.fontSize==="")ourText.style.fontSize="16px";var fontSize=parseFloat(ourText.style.fontSize,10).toFixed(2);var maxHeight=text.height*this.props.zoomFactor;var textHeight=ourText.clientHeight,i,j;if(textHeight>maxHeight){reached:for(i=0;i<500;i++){if(textHeight<maxHeight){fontSize=fontSize+1;for(j=0;j<10;j++){var decFontSize=fontSize-(j+1)/10;ourText.style.fontSize=decFontSize+"px";textHeight=ourText.clientHeight;if(textHeight<=maxHeight){ourText.style.fontSize=decFontSize+"px";return decFontSize+"px";break reached;}}ourText.style.fontSize=fontSize+"px";return fontSize+"px";break;}fontSize--;ourText.style.fontSize=fontSize+"px";textHeight=ourText.clientHeight;}}else if(textHeight>0&&textHeight<maxHeight){reached:for(i=0;i<500;i++){if(textHeight>maxHeight){for(j=0;j<10;j++){var _decFontSize=fontSize-(j+1)/10;ourText.style.fontSize=_decFontSize+"px";textHeight=ourText.clientHeight;if(textHeight<=maxHeight){ourText.style.fontSize=_decFontSize+"px";return _decFontSize+"px";break reached;}}fontSize=fontSize-1;ourText.style.fontSize=fontSize+"px";return fontSize+"px";break;}fontSize++;ourText.style.fontSize=fontSize+"px";textHeight=ourText.clientHeight;}}else{return ourText.style.fontSize+"px";}}},{key:'updateResizeValues',value:function updateResizeValues(e){var _this4=this;try{this.setCursor(e);var handle=this.initialSelectionBox.handle;var selectedId=this.selectedItems.keySeq().toArray()[0];if(this.isTextOnly()){var textBounds=this.getTextBounds(e,selectedId);this.updateInitialSelectionBox({transforming:false,resizing:false,x:textBounds.x,y:textBounds.y,width:textBounds.width,height:textBounds.height,cx:textBounds.x+textBounds.width/2,cy:textBounds.y+textBounds.height/2});this.selectedItems=this.selectedItems.set(selectedId,this.selectedItems.get(selectedId).merge(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(textBounds)));if(handle!=="left"&&handle!=="right"){var fontSize=parseFloat(this.getFontSize({id:this.props.textStatus.get("id"),width:textBounds.width-this.props.textOffset,height:textBounds.height-this.props.textOffset}),10);this.selectedItems=this.selectedItems.setIn([selectedId,"textData","formats","containerStyle","fontSize"],(fontSize/this.props.zoomFactor).toFixed(2)+"px");}this.props.resizeUpdate({"items":this.selectedItems,"children":this.groupedItems,"selectedScene":this.props.selectedScene,"currentContainer":this.currentItemContainer,selectedItems:this.props.selectedItems,anchorScales:this.anchorScales},this.props.socket);}else{var resize_position=this.getResizePosition(e);var scale_x=resize_position.scale_x,scale_y=resize_position.scale_y,cx=resize_position.cx,cy=resize_position.cy,new_width=Math.abs(this.initialSelectionBox.width*scale_x),new_height=Math.abs(this.initialSelectionBox.height*scale_y),new_x=cx-new_width/2,new_y=cy-new_height/2;this.updateInitialSelectionBox({transforming:false,resizing:false,x:new_x,y:new_y,width:new_width,height:new_height,cx:new_x+new_width/2,cy:new_y+new_height/2});var allItems=this.selectedItems;this.selectedItems.entrySeq().forEach(function(_ref7){var _ref8=_slicedToArray(_ref7,2),key=_ref8[0],item=_ref8[1];var item_width=Math.abs(item.get("width")*scale_x),item_height=Math.abs(item.get("height")*scale_y);var item_x=Math.cos((item.get("angle_to_center")+_this4.initialSelectionBox.angle)*Math.PI/180)*Math.abs(item.get("dis_to_center")*scale_x)+cx-item_width/2;var item_y=Math.sin((item.get("angle_to_center")+_this4.initialSelectionBox.angle)*Math.PI/180)*Math.abs(item.get("dis_to_center")*scale_y)+cy-item_height/2;var item_to_update=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({"x":item_x,"y":item_y,"width":item_width,"height":item_height});if(item.get("type")==="GROUP"){var groupItems=_this4.props.selectedChildren;item.get("groupChildren").entrySeq().forEach(function(_ref9){var _ref10=_slicedToArray(_ref9,2),childKey=_ref10[0],itemId=_ref10[1];var child=groupItems.get(itemId);var childWidth=Math.abs(child.get("width")*scale_x),childHeight=Math.abs(child.get("height")*scale_y);var groupedItem=_this4.groupedItems.get(itemId);var childGX=Math.cos((groupedItem.get("angle_to_center")+item.get("angle"))*Math.PI/180)*Math.abs(groupedItem.get("dis_to_center")*scale_x)+(item_x+item_width/2)-childWidth/2;var childGY=Math.sin((groupedItem.get("angle_to_center")+item.get("angle"))*Math.PI/180)*Math.abs(groupedItem.get("dis_to_center")*scale_y)+(item_y+item_height/2)-childHeight/2;var childToUpdate=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({"x":parseFloat(childGX.toFixed(2)+item_x.toFixed(2)),"y":parseFloat(childGY.toFixed(2)+item_x.toFixed(2)),"height":childHeight});if(item.get("subType")==="TXTGRP"&&item.get("isExpands")){var svgItem=groupItems.filter(function(obj,key){return item.get("groupChildren").indexOf(key)!==-1;}).find(function(x){return x.get("type")==="OVLYSVG";});var xScale=scale_x;if(handle==="left"||handle==="right")xScale=1;if(child.get("type")==="TEXT"){childToUpdate=childToUpdate.set("width",item_width-svgItem.getIn(["groupBounds","leftItem","width"])*svgItem.getIn(["groupBounds","leftItem","scaleX"])*xScale-svgItem.getIn(["groupBounds","rightItem","width"])*svgItem.getIn(["groupBounds","rightItem","scaleX"])*xScale);childToUpdate=childToUpdate.set("x",item_x+svgItem.getIn(["groupBounds","leftItem","width"])*svgItem.getIn(["groupBounds","leftItem","scaleX"])*xScale);}else{childToUpdate=childToUpdate.set("x",parseFloat(childGX.toFixed(2)+item_x.toFixed(2)));childToUpdate=childToUpdate.set("width",childWidth);}}else{childToUpdate=childToUpdate.set("x",parseFloat(childGX.toFixed(2)+item_x.toFixed(2)));childToUpdate=childToUpdate.set("width",childWidth);}if(child.get("type")==="TEXT"||child.get("type")==="SHAPE"){if(_this4.isFontAutoSize(itemId,"workspaceChildren")||handle==="top-left"||handle==="top-right"||handle==="bottom-left"||handle==="bottom-right"){var widthRatio=child.get("widthRatio")!==undefined&&child.get("widthRatio")!==null?Math.round(child.get("widthRatio")):child.get("type")==="SHAPE"?90:100;var heightRatio=child.get("heightRatio")!==undefined&&child.get("heightRatio")!==null?Math.round(child.get("heightRatio")):child.get("type")==="SHAPE"?90:100;var textWidth=widthRatio/100*childWidth;var textHeight=heightRatio/100*childHeight;if(child.get("type")!=="SHAPE"&&item.get("subType")!=="TXTGRP"){textWidth-=_this4.props.textOffset;textHeight-=_this4.props.textOffset;}var _fontSize=parseFloat(_this4.getFontSize({id:itemId,width:textWidth,height:textHeight,isGrouped:true,parentId:key}),10);childToUpdate=childToUpdate.set("textData",child.setIn(["textData","formats","containerStyle","fontSize"],(_fontSize/_this4.props.zoomFactor).toFixed(2)+"px").get("textData"));}}if(child.get("type")==="SHAPE"){var currentItem=child.set("width",childWidth).set("height",childHeight);var pathDetails=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ShapeHelper__["a" /* getPath */])(currentItem,_this4.props.zoomFactor,child);var pathData=childToUpdate.get("pathData")!==undefined?childToUpdate.get("pathData").merge(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(pathDetails.pathData)):Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(pathDetails.pathData);childToUpdate=childToUpdate.set("pathData",pathData);var dataPath=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ShapeHelper__["a" /* getPath */])(currentItem,1,child).pathDetails;childToUpdate=childToUpdate.set("path",Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(dataPath));}_this4.groupedItems=_this4.groupedItems.set(itemId,groupedItem.merge(childToUpdate));});}if(item.get("type")==="SHAPE"){var currentItem=item.set("width",item_width).set("height",item_height);var pathDetails=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ShapeHelper__["a" /* getPath */])(currentItem,1,item);var dataPath=pathDetails.pathDetails;item_to_update=item_to_update.set("path",Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(dataPath));}if(item.get("type")==="TEXT"||item.get("type")==="SHAPE"){var textWidth=item_width;var textHeight=item_height;if(item.get("type")!=="SHAPE"){textWidth-=_this4.props.textOffset;textHeight-=_this4.props.textOffset;}else{var widthRatio=item.get("widthRatio")!==undefined&&item.get("widthRatio")!==null?Math.round(item.get("widthRatio")):90;var heightRatio=item.get("heightRatio")!==undefined&&item.get("heightRatio")!==null?Math.round(item.get("heightRatio")):90;textWidth=widthRatio/100*textWidth;textHeight=heightRatio/100*textHeight;}var _fontSize2=parseFloat(_this4.getFontSize({id:key,width:textWidth,height:textHeight}),10);if(_this4.isFontAutoSize(key)||handle==="top-left"||handle==="top-right"||handle==="bottom-left"||handle==="bottom-right"||item.get("type")==="SHAPE"){if(!isNaN(_fontSize2))item_to_update=item_to_update.set("textData",item.setIn(["textData","formats","containerStyle","fontSize"],(_fontSize2/_this4.props.zoomFactor).toFixed(2)+"px").get("textData"));}}allItems=allItems.set(key,item.merge(item_to_update));});this.selectedItems=allItems;this.props.resizeUpdate({"items":this.selectedItems,"children":this.groupedItems,"selectedScene":this.props.selectedScene,"currentContainer":this.currentItemContainer,selectedItems:this.props.selectedItems,anchorScales:this.anchorScales,isShapeOnly:this.isShapeOnly()},this.props.socket);}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"TransformManagerComponent-updateResizeValues");}}},{key:'initiateResize',value:function initiateResize(e){try{e.preventDefault();this.scaleX=1;this.scaleY=1;var isResizeLocked=this.lockResize!==undefined&&this.lockResize?true:false;if(!isResizeLocked){var handle=e.target.getAttribute("data-handle");if(this.isTextOnly()&&(handle==="top-left"||handle==="top-right"||handle==="bottom-left"||handle==="bottom-right")){this.cornerResize=true;}var corner_x=this.selectionBox.x,corner_y=this.selectionBox.y,center_x=this.selectionBox.cx,center_y=this.selectionBox.cy,width=this.selectionBox.width,height=this.selectionBox.height;if(!this.cornerResize){corner_x=corner_x+width/2;corner_y=corner_y+height/2;}else{if(handle==="top-right")corner_y=corner_y+height;else if(handle==="top-left"){corner_y=corner_y+height;corner_x=corner_x+width;}else if(handle==="bottom-left")corner_x=corner_x+width;else if(handle==="right"){corner_y=corner_y+height/2;}else if(handle==="left"){corner_x=corner_x+width;corner_y=corner_y+height/2;}else if(handle==="top"){corner_y=corner_y+height;corner_x=corner_x+width/2;}else if(handle==="bottom")corner_x=corner_x+width/2;}var distance=Math.sqrt(Math.pow(center_x-corner_x,2)+Math.pow(center_y-corner_y,2)),angle_to_center=Math.atan2(center_y-corner_y,center_x-corner_x)*(180/Math.PI),angle_to_corner=Math.atan2(corner_y-center_y,corner_x-center_x)*(180/Math.PI);var tempX=this.selectionBox.x-(this.selectionBox.x+this.selectionBox.width/2);var tempY=this.selectionBox.y-(this.selectionBox.y+this.selectionBox.height/2);// now apply rotation
var rotatedX=tempX*Math.cos(this.selectionBox.angle*(Math.PI/180))-tempY*Math.sin(this.selectionBox.angle*(Math.PI/180));var rotatedY=tempX*Math.sin(this.selectionBox.angle*(Math.PI/180))+tempY*Math.cos(this.selectionBox.angle*(Math.PI/180));// translate back
var rPx=this.selectionBox.x+(rotatedX+this.selectionBox.width/2);var rPy=this.selectionBox.y+(rotatedY+this.selectionBox.height/2);this.updateInitialSelectionBox({transforming:true,resizing:true,handle:handle,distance:distance,angle_to_center:angle_to_center,angle_to_corner:angle_to_corner,rotated_x:rPx,rotated_y:rPy});this.props.updateTransformStatus({transforming:true,resizing:true});var mouse_position=this.getMousePosition(e);this.mouseStartPosition=Object.assign(this.mouseStartPosition,{x:mouse_position.x,y:mouse_position.y});if(this.isTextOnly())window.addEventListener('mousemove',this.resizeTextContainer,false);else window.addEventListener('mousemove',this.resizeSelection,false);window.addEventListener('mouseup',this.stopResize,false);}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"TransformManagerComponent-initiateResize");}}},{key:'resizeSelection',value:function resizeSelection(e){var _this5=this;try{e.preventDefault();var resize_position=this.getResizePosition(e);var scale_x=resize_position.scale_x,scale_y=resize_position.scale_y,cx=resize_position.cx,cy=resize_position.cy,new_width=Math.abs(this.initialSelectionBox.width*scale_x),new_height=Math.abs(this.initialSelectionBox.height*scale_y);var handle=this.selectionBox.handle;var selectionX=parseFloat(((cx-new_width/2)*this.props.zoomFactor).toFixed(2)),selectionY=parseFloat(((cy-new_height/2)*this.props.zoomFactor).toFixed(2)),selectionWidth=parseFloat((new_width*this.props.zoomFactor).toFixed(2)),selectionHeight=parseFloat((new_height*this.props.zoomFactor).toFixed(2));var selectionBox=this.selectionBoxElement;selectionBox.style.transform="translate("+selectionX+"px, "+selectionY+"px) rotateZ("+this.selectionBox.angle+"deg)";selectionBox.style.width=selectionWidth+"px";selectionBox.style.height=selectionHeight+"px";if(selectionWidth<60){if(document.querySelector(".resize-handle.top").className.indexOf("hide-handle")===-1){document.querySelector(".resize-handle.top").classList.add("hide-handle");}if(document.querySelector(".resize-handle.bottom").className.indexOf("hide-handle")===-1){document.querySelector(".resize-handle.bottom").classList.add("hide-handle");}}else{if(document.querySelector(".resize-handle.top").className.indexOf("hide-handle")!==-1){document.querySelector(".resize-handle.top").classList.remove("hide-handle");}if(document.querySelector(".resize-handle.bottom").className.indexOf("hide-handle")!==-1){document.querySelector(".resize-handle.bottom").classList.remove("hide-handle");}}if(selectionHeight<60){if(document.querySelector(".resize-handle.left").className.indexOf("hide-handle")===-1){document.querySelector(".resize-handle.left").classList.add("hide-handle");}if(document.querySelector(".resize-handle.right").className.indexOf("hide-handle")===-1){document.querySelector(".resize-handle.right").classList.add("hide-handle");}}else{if(document.querySelector(".resize-handle.left").className.indexOf("hide-handle")!==-1){document.querySelector(".resize-handle.left").classList.remove("hide-handle");}if(document.querySelector(".resize-handle.right").className.indexOf("hide-handle")!==-1){document.querySelector(".resize-handle.right").classList.remove("hide-handle");}}this.selectedItems.entrySeq().forEach(function(_ref11){var _ref12=_slicedToArray(_ref11,2),key=_ref12[0],item=_ref12[1];var item_width=Math.abs(item.get("width")*scale_x),item_height=Math.abs(item.get("height")*scale_y);var item_x=Math.cos((item.get("angle_to_center")+_this5.initialSelectionBox.angle)*Math.PI/180)*Math.abs(item.get("dis_to_center")*scale_x)+cx-item_width/2;var item_y=Math.sin((item.get("angle_to_center")+_this5.initialSelectionBox.angle)*Math.PI/180)*Math.abs(item.get("dis_to_center")*scale_y)+cy-item_height/2;var current_item=document.getElementById(key);var flipPos=item.get("flipPosition");var flip=flipPos===1?" scaleX(-1)":flipPos===2?" scaleY(-1)":flipPos===3?" scaleX(-1) scaleY(-1)":"";current_item.style.transform="translate("+(item_x*_this5.props.zoomFactor).toFixed(2)+"px, "+(item_y*_this5.props.zoomFactor).toFixed(2)+"px) rotateZ("+item.get("angle")+"deg)"+flip;current_item.style.width=item_width*_this5.props.zoomFactor+"px";current_item.style.height=item_height*_this5.props.zoomFactor+"px";var groupFontSize=null;var textOffset=_this5.props.textOffset;if(item.get("type")==="GROUP"){if(item.get("subType")==="TXTGRP")textOffset=0;item.get("groupChildren").entrySeq().forEach(function(_ref13){var _ref14=_slicedToArray(_ref13,2),childKey=_ref14[0],itemId=_ref14[1];var groupItems=_this5.props.selectedChildren;var child=groupItems.get(itemId);var childWidth=Math.abs(child.get("width")*scale_x),childHeight=Math.abs(child.get("height")*scale_y);var groupedItem=_this5.groupedItems.get(itemId);var childX=Math.cos((groupedItem.get("angle_to_center")+item.get("angle"))*Math.PI/180)*Math.abs(groupedItem.get("dis_to_center")*scale_x)+(item_x+item_width/2)-childWidth/2;var childY=Math.sin((groupedItem.get("angle_to_center")+item.get("angle"))*Math.PI/180)*Math.abs(groupedItem.get("dis_to_center")*scale_y)+(item_y+item_height/2)-childHeight/2;var currentChildItem=document.getElementById(itemId);var flipPos=child.get("flipPosition");var flip=flipPos===1?" scaleX(-1)":flipPos===2?" scaleY(-1)":flipPos===3?" scaleX(-1) scaleY(-1)":"";var transform="translate("+(childX.toFixed(2)-item_x.toFixed(2))*_this5.props.zoomFactor+"px, "+(childY.toFixed(2)-item_y.toFixed(2))*_this5.props.zoomFactor+"px) rotateZ("+child.get("angle")+"deg)"+flip;currentChildItem.style.transform=transform;currentChildItem.style.width=childWidth*_this5.props.zoomFactor+"px";currentChildItem.style.height=childHeight*_this5.props.zoomFactor+"px";if(child.get("type")==="TEXT"||child.get("type")==="SHAPE"){var container=document.getElementById(itemId);if(child.get("type")==="SHAPE"){container=container.getElementsByClassName("callout-text-container")[0];var xRatio=child.get("xRatio")!==undefined&&child.get("xRatio")!==null?child.get("xRatio"):10;var yRatio=child.get("yRatio")!==undefined&&child.get("yRatio")!==null?child.get("yRatio"):10;var widthRatio=child.get("widthRatio")!==undefined&&child.get("widthRatio")!==null?child.get("widthRatio"):90;var heightRatio=child.get("heightRatio")!==undefined&&child.get("heightRatio")!==null?child.get("heightRatio"):90;container.style.transform="translate("+childWidth*xRatio*_this5.props.zoomFactor/100+"px, "+childHeight*yRatio*_this5.props.zoomFactor/100+"px)"+flip;container.style.width=childWidth*widthRatio*_this5.props.zoomFactor/100+"px";container.style.height=childHeight*heightRatio*_this5.props.zoomFactor/100+"px";}if(_this5.isFontAutoSize(itemId,"workspaceChildren")||handle==="top-left"||handle==="top-right"||handle==="bottom-left"||handle==="bottom-right"){var fontSize=parseFloat(child.getIn(["textData","formats","containerStyle","fontSize"]));var ourText=container.getElementsByClassName("text-container")[0];if(child.get("type")==="SHAPE")textOffset=0;else if(item.get("subType")!=="TXTGRP")textOffset=_this5.props.textOffset;var tsx=(childWidth-textOffset)/child.get("width"),tsy=(childHeight-textOffset)/child.get("height");var scaledFontsize=Math.abs(fontSize*(tsx+tsy)/2);ourText.style.fontSize=scaledFontsize*_this5.props.zoomFactor+"px";if(scaledFontsize>groupFontSize||groupFontSize===null)groupFontSize=scaledFontsize;if(_this5.props.textStatus.get("isFocused")&&_this5.props.textStatus.get("id")===itemId){_this5.props.updateTextStatus({fontSize:scaledFontsize.toFixed(2)});}}}if((child.get("type")==="IMG"||child.get("type")==="STOCKIMG")&&child.get("isCropped")||child.get("type")==="FRAME"){var cropImageElem=document.getElementById(itemId).getElementsByTagName("img")[0];cropImageElem.style.left=child.getIn(["original","x"])*childWidth*_this5.props.zoomFactor+"px";cropImageElem.style.top=child.getIn(["original","y"])*childHeight*_this5.props.zoomFactor+"px";cropImageElem.style.width=child.getIn(["original","width"])*childWidth*_this5.props.zoomFactor+"px";cropImageElem.style.height=child.getIn(["original","height"])*childHeight*_this5.props.zoomFactor+"px";}if(child.get("type")==="SHAPE"&&child.get("subType")==="CSTMPTH"){var currentItem=child.set("width",childWidth).set("height",childHeight);var pathDetails=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ShapeHelper__["a" /* getPath */])(currentItem,_this5.props.zoomFactor,child);var dataPath=pathDetails.pathDetails;if(Array.isArray(dataPath)){for(var p=0;p<dataPath.length;p++){document.getElementById(itemId).getElementsByTagName("svg")[0].getElementsByClassName("path"+p)[0].setAttribute("d",dataPath[p].data);if(dataPath[p].pathStyle!==undefined)document.getElementById(itemId).getElementsByTagName("svg")[0].getElementsByTagName("g")[0].style.transform="translate("+dataPath[p].pathStyle.left+"px, "+dataPath[p].pathStyle.top+"px)";}}}});if(_this5.props.textStatus.get("isSelected")&&_this5.props.textStatus.get("isGrouped")&&_this5.props.textStatus.get("id")===key&&groupFontSize!==null){_this5.props.updateTextStatus({fontSize:groupFontSize.toFixed(2)});}}if(item.get("type")==="TEXT"||item.get("type")==="SHAPE"){var container=document.getElementById(key);if(item.get("type")==="SHAPE"){var xRatio=item.get("xRatio")!==undefined&&item.get("xRatio")!==null?item.get("xRatio"):10;var yRatio=item.get("yRatio")!==undefined&&item.get("yRatio")!==null?item.get("yRatio"):10;var widthRatio=item.get("widthRatio")!==undefined&&item.get("widthRatio")!==null?item.get("widthRatio"):90;var heightRatio=item.get("heightRatio")!==undefined&&item.get("heightRatio")!==null?item.get("heightRatio"):90;container=container.getElementsByClassName("callout-text-container")[0];if(item.get("subType")==="CSTMPTH"){var currentItem=item.set("width",item_width).set("height",item_height);var pathDetails=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ShapeHelper__["a" /* getPath */])(currentItem,_this5.props.zoomFactor,item);var dataPath=pathDetails.pathDetails;if(Array.isArray(dataPath)){for(var p=0;p<dataPath.length;p++){document.getElementById(key).getElementsByTagName("svg")[0].getElementsByClassName("path"+p)[0].setAttribute("d",dataPath[p].data);if(dataPath[p].pathStyle!==undefined)document.getElementById(key).getElementsByTagName("svg")[0].getElementsByTagName("g")[0].style.transform="translate("+dataPath[p].pathStyle.left+"px, "+dataPath[p].pathStyle.top+"px)";}}var _flipPos=item.get("flipPosition");var _flip=_flipPos===1?" scaleX(-1)":_flipPos===2?" scaleY(-1)":_flipPos===3?" scaleX(-1) scaleY(-1)":"";container.style.transform="translate("+item_width*xRatio*_this5.props.zoomFactor/100+"px, "+item_height*yRatio*_this5.props.zoomFactor/100+"px)"+_flip;container.style.width=item_width*widthRatio*_this5.props.zoomFactor/100+"px";container.style.height=item_height*heightRatio*_this5.props.zoomFactor/100+"px";if(pathDetails.shapeStyle!==undefined){document.getElementById(key).getElementsByTagName("svg")[0].style.left=pathDetails.shapeStyle.left;document.getElementById(key).getElementsByTagName("svg")[0].style.top=pathDetails.shapeStyle.top;document.getElementById(key).getElementsByTagName("svg")[0].style.width=pathDetails.shapeStyle.width;document.getElementById(key).getElementsByTagName("svg")[0].style.height=pathDetails.shapeStyle.height;}if(item.get("subType")==="CSTMPTH"&&_this5.selectedItems.size===1){var pathData=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(pathDetails.pathData);if(pathDetails.newControlPoints!==undefined){var newControlPoints=_this5.getFlipPosition(pathDetails.newControlPoints,item.get("flipPosition"));for(var _p in newControlPoints){document.getElementsByClassName("control-point "+_p)[0].style.left="calc("+newControlPoints[_p].x+"% - 7.5px)";document.getElementsByClassName("control-point "+_p)[0].style.top="calc("+newControlPoints[_p].y+"% - 7.5px)";}}else if(pathData){pathData.get("controlPoints").entrySeq().forEach(function(_ref15){var _ref16=_slicedToArray(_ref15,2),key=_ref16[0],pos=_ref16[1];document.getElementsByClassName("control-point "+key)[0].style.left="calc("+pos.get("x")+"% - 7.5px)";document.getElementsByClassName("control-point "+key)[0].style.top="calc("+pos.get("y")+"% - 7.5px)";});}}}}if(_this5.isFontAutoSize(key)||handle==="top-left"||handle==="top-right"||handle==="bottom-left"||handle==="bottom-right"||item.get("type")==="SHAPE"){var fontSize=parseFloat(item.getIn(["textData","formats","containerStyle","fontSize"]),10);var ourText=container.getElementsByClassName("text-container")[0];if(item.get("type")==="SHAPE")textOffset=0;var tsx=(item_width-textOffset)/item.get("width"),tsy=(item_height-textOffset)/item.get("height");ourText.style.fontSize=(fontSize*Math.abs(Math.max(tsx,tsy))*_this5.props.zoomFactor).toFixed(2)+"px";if((_this5.props.textStatus.get("isSelected")||_this5.props.textStatus.get("isFocused"))&&_this5.props.textStatus.get("id")===key){if(document.getElementsByClassName("font-size-input")[0]!==undefined&&document.getElementsByClassName("font-size-input")[0]!==null){document.getElementsByClassName("font-size-input")[0].value=(fontSize*Math.abs(Math.max(tsx,tsy))*_this5.props.zoomFactor).toFixed(2);}}}}if((item.get("type")==="IMG"||item.get("type")==="STOCKIMG")&&item.get("isCropped")||item.get("type")==="FRAME"){var cropImageElem=document.getElementById(key).getElementsByTagName("img")[0];cropImageElem.style.left=item.getIn(["original","x"])*item_width*_this5.props.zoomFactor+"px";cropImageElem.style.top=item.getIn(["original","y"])*item_height*_this5.props.zoomFactor+"px";cropImageElem.style.width=item.getIn(["original","width"])*item_width*_this5.props.zoomFactor+"px";cropImageElem.style.height=item.getIn(["original","height"])*item_height*_this5.props.zoomFactor+"px";}});}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"TransformManagerComponent-resizeSelection");}}},{key:'stopResize',value:function stopResize(e){try{e.preventDefault();if(!this.props.isToolCropping){this.updateResizeValues(e);}else{var resize_position=this.getResizePosition(e);var scale_x=resize_position.scale_x,scale_y=resize_position.scale_y,cx=resize_position.cx,cy=resize_position.cy,new_width=Math.abs(this.initialSelectionBox.width*scale_x),new_height=Math.abs(this.initialSelectionBox.height*scale_y);var handle=this.selectionBox.handle;var selectionX=cx-new_width/2,selectionY=cy-new_height/2,selectionWidth=new_width,selectionHeight=new_height;var toUpdate={x:selectionX/this.props.workspaceWidth,y:selectionY/this.props.workspaceHeight,width:selectionWidth/this.props.workspaceWidth,height:selectionHeight/this.props.workspaceHeight};this.props.updateBg({selectedScene:this.props.selectedScene,toUpdate:toUpdate,toolCrop:true},this.props.socket);}window.removeEventListener('mousemove',this.resizeSelection,false);window.removeEventListener('mousemove',this.resizeTextContainer,false);window.removeEventListener('mouseup',this.stopResize,false);this.resetCursor(e);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"TransformManagerComponent-stopResize");}}},{key:'getQuadrant',value:function getQuadrant(_deg){var r=0;if(_deg>=0&&_deg<=90){r=1;}else if(_deg>90&&_deg<=180){r=2;}else if(_deg>180&&_deg<=270){r=3;}else if(_deg>270&&_deg<=360){r=4;}return r;}},{key:'getAngle',value:function getAngle(e){var workspaceBounds=this.getWorkspaceBounds();var angle=Math.atan2(e.clientY-workspaceBounds.y-this.selectionBox.cy*this.props.zoomFactor,e.clientX-workspaceBounds.x-this.selectionBox.cx*this.props.zoomFactor)*(180/Math.PI);this.prevY=e.clientY-workspaceBounds.y;this.prevX=e.clientX-workspaceBounds.x;var rotation=angle-this.startAngle;var rAngle=rotation+this.initialSelectionBox.angle;if(rAngle<0)rAngle+=360;var increements=8;var snapAngle=360/increements;var snapPoint=5;if(Math.abs(rAngle)%snapAngle<snapPoint){rAngle-=rAngle%snapAngle;document.getElementsByClassName("rotationLine")[0].style.left=(this.selectionBox.x+this.selectionBox.width/2)*this.props.zoomFactor+workspaceBounds.x+"px";document.getElementsByClassName("rotationLine")[0].style.top=this.selectionBox.y*this.props.zoomFactor+workspaceBounds.y+"px";document.getElementsByClassName("rotationLine")[0].style.height=this.selectionBox.height*this.props.zoomFactor+"px";document.getElementsByClassName("rotationLine")[0].style.transform="rotateZ("+rAngle+"deg)";document.getElementsByClassName("rotationLine")[0].style.display="block";}else{document.getElementsByClassName("rotationLine")[0].style.display="none";}if(this.restrictBounds){var bounds=this.getSelectionBoxBounds({x:this.selectionBox.x,y:this.selectionBox.y,cx:this.selectionBox.cx,cy:this.selectionBox.cy,width:this.selectionBox.width,height:this.selectionBox.height,angle:rAngle});var x=bounds.x,y=bounds.y,sWidth=bounds.width,sHeight=bounds.height;x=x<0?0:x;y=y<0?0:y;var widthRestricted=x+sWidth>=workspaceBounds.width?true:false;var heightRestricted=y+sHeight>=workspaceBounds.height?true:false;if(x===0||y===0||widthRestricted||heightRestricted){if(!this.restrictedSelectionBox.isRestricted){Object.assign(this.restrictedSelectionBox,{isRestricted:true,angle:rAngle});}rAngle=this.restrictedSelectionBox.angle;}else if(this.restrictedSelectionBox.isRestricted){Object.assign(this.restrictedSelectionBox,{isRestricted:false});}}var oldQuad=this.getQuadrant(this.angle);var newQuad=this.getQuadrant(rAngle);if(oldQuad!==newQuad){if(newQuad-oldQuad===1||oldQuad-newQuad===1){}else{if(oldQuad===4&&newQuad===1){this.rotateCount++;}else if(oldQuad===1&&newQuad===4){this.rotateCount--;}}}this.angle=rAngle;return Math.abs(this.angle)>360?this.angle%360:this.angle;}},{key:'initiateRotate',value:function initiateRotate(e){try{e.preventDefault();var isRotateLocked=this.lockRotate!==undefined&&this.lockRotate?true:false;if(!isRotateLocked){this.angle=this.selectionBox.angle;this.rotateCount=0;var workspace_bounds=this.getWorkspaceBounds();var wpx=e.clientX-workspace_bounds.x,wpy=e.clientY-workspace_bounds.y,scx=this.selectionBox.cx*this.props.zoomFactor,scy=this.selectionBox.cy*this.props.zoomFactor;this.diffX=wpx;this.diffY=wpy;this.prevY=wpx;this.prevX=wpy;this.startAngle=Math.atan2(wpy-scy,wpx-scx)*(180/Math.PI);this.updateInitialSelectionBox({transforming:true,rotating:true,handle:e.target.getAttribute("data-handle")});this.props.updateTransformStatus({transforming:true,rotating:true});document.getElementsByClassName("rotationDisplay")[0].style.left=workspace_bounds.x+(this.selectionBox.x+this.selectionBox.width/2)*this.props.zoomFactor-11+"px";document.getElementsByClassName("rotationDisplay")[0].style.top=workspace_bounds.y+(this.selectionBox.y+this.selectionBox.height/2)*this.props.zoomFactor-11+"px";document.getElementsByClassName("rotationDisplay")[0].style.display="table";window.addEventListener('mousemove',this.rotateSelection,false);window.addEventListener('mouseup',this.stopRotate,false);}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"TransformManagerComponent-initiateRotate");}}},{key:'rotateSelection',value:function rotateSelection(e){var _this6=this;try{e.preventDefault();var rAngle=this.getAngle(e);var angleDisplay=rAngle;if(angleDisplay>180)angleDisplay=angleDisplay-360;var selectionBox=this.selectionBoxElement;selectionBox.style.transform="translate("+this.selectionBox.x*this.props.zoomFactor+"px, "+this.selectionBox.y*this.props.zoomFactor+"px) rotateZ("+rAngle+"deg)";document.getElementById("rotationAngle").innerText=Math.round(angleDisplay).toFixed(0);var allItems=this.selectedItems;rAngle=parseFloat(rAngle);this.selectedItems.entrySeq().forEach(function(_ref17){var _ref18=_slicedToArray(_ref17,2),key=_ref18[0],item=_ref18[1];var current_item=document.getElementById(key);var flipPos=item.get("flipPosition");var flip=flipPos===1?" scaleX(-1)":flipPos===2?" scaleY(-1)":flipPos===3?" scaleX(-1) scaleY(-1)":"";var item_x=Math.cos((item.get("angle_to_center")+rAngle)*Math.PI/180)*item.get("dis_to_center")+_this6.selectionBox.cx-item.get("width")/2,item_y=Math.sin((item.get("angle_to_center")+rAngle)*Math.PI/180)*item.get("dis_to_center")+_this6.selectionBox.cy-item.get("height")/2;var initialAngle=parseFloat(_this6.state.selectedObjects.getIn([key,"angle"]));var item_angle=rAngle+initialAngle;if(allItems.size===1)item_angle-=initialAngle;item_angle=Math.abs(item_angle)>360?item_angle%360:item_angle;current_item.style.transform="translate("+(item_x*_this6.props.zoomFactor).toFixed(4)+"px, "+(item_y*_this6.props.zoomFactor).toFixed(4)+"px) rotateZ("+item_angle+"deg) "+flip;var item_to_update=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({"x":item_x,"y":item_y,"angle":item_angle,"rotationCount":_this6.rotateCount});allItems=allItems.set(key,item.merge(item_to_update));});this.selectedItems=allItems;}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"TransformManagerComponent-rotateSelection");}}},{key:'stopRotate',value:function stopRotate(e){try{e.preventDefault();this.setCursor(e);var rAngle=this.getAngle(e);document.getElementsByClassName("rotationDisplay")[0].style.display="none";document.getElementsByClassName("rotationLine")[0].style.display="none";this.updateInitialSelectionBox({transforming:false,rotating:false,angle:rAngle});{var allChildrens=this.groupedItems;var allItems=this.selectedItems;}this.props.rotationUpdate({"items":this.selectedItems,"children":this.groupedItems,"selectedScene":this.props.selectedScene,"currentContainer":this.currentItemContainer,selectedItems:this.props.selectedItems},this.props.socket);window.removeEventListener('mousemove',this.rotateSelection,false);window.removeEventListener('mouseup',this.stopRotate,false);this.resetCursor(e);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"TransformManagerComponent-stopRotate");}}},{key:'isTextOnly',value:function isTextOnly(){var result=false;if(this.props.selectedItems.size===1){var itemType=this.props.selectedObjects.get(this.props.selectedItems.get(0));if(itemType!==undefined&&itemType.get("type")==="TEXT"&&itemType.get("subType")==="DTXT"){result=true;}}return result;}},{key:'isCalloutOnly',value:function isCalloutOnly(){var result=false;if(this.props.selectedItems.size===1){var itemType=this.props.selectedObjects.get(this.props.selectedItems.get(0));if(itemType!==undefined&&itemType.get("type")==="SHAPE"){result=true;}}return result;}},{key:'isShapeOnly',value:function isShapeOnly(){var result=false;if(this.props.selectedItems.size===1){var itemType=this.props.selectedObjects.get(this.props.selectedItems.get(0));if(itemType!==undefined&&itemType.get("type")==="SHAPE"){result=true;}}return result;}},{key:'isPermenantGroup',value:function isPermenantGroup(){if(this.props.selectedItems.size===1){if(this.props.selectedObjects.getIn([this.props.selectedItems.get(0),"type"])==="GROUP"){return true;}}return false;}},{key:'getCorner',value:function getCorner(pivotX,pivotY,cornerX,cornerY,angle){var x,y,distance,diffX,diffY;/// get distance from center to point
diffX=cornerX-pivotX;diffY=cornerY-pivotY;distance=Math.sqrt(diffX*diffX+diffY*diffY);/// find angle from pivot to corner
angle+=Math.atan2(diffY,diffX);/// get new x and y and round it off to integer
x=pivotX+distance*Math.cos(angle);y=pivotY+distance*Math.sin(angle);return{x:x,y:y};}},{key:'getSelectionBoxBounds',value:function getSelectionBoxBounds(data){var angle=data.angle*Math.PI/180;var c1,c2,c3,c4,/// corners
bx1,by1,bx2,by2,bounds;c1=this.getCorner(data.cx,data.cy,data.x,data.y,angle);c2=this.getCorner(data.cx,data.cy,data.x+data.width,data.y,angle);c3=this.getCorner(data.cx,data.cy,data.x+data.width,data.y+data.height,angle);c4=this.getCorner(data.cx,data.cy,data.x,data.y+data.height,angle);/// get bounding box
bx1=Math.min(c1.x,c2.x,c3.x,c4.x);by1=Math.min(c1.y,c2.y,c3.y,c4.y);bx2=Math.max(c1.x,c2.x,c3.x,c4.x);by2=Math.max(c1.y,c2.y,c3.y,c4.y);bounds={x:parseFloat(bx1.toFixed(2)),y:parseFloat(by1.toFixed(2)),width:parseFloat((bx2-bx1).toFixed(2)),height:parseFloat((by2-by1).toFixed(2))};return bounds;}},{key:'getObjectsBounds',value:function getObjectsBounds(objects){var _this7=this;var minX=0,maxX=0,minY=0,maxY=0;var count=0;objects.entrySeq().forEach(function(_ref19){var _ref20=_slicedToArray(_ref19,2),key=_ref20[0],item=_ref20[1];var bounds=void 0,x=void 0,y=void 0,width=void 0,height=void 0;bounds=_this7.getSelectionBoxBounds({x:item.get("x"),y:item.get("y"),cx:item.get("x")+item.get("width")/2,cy:item.get("y")+item.get("height")/2,width:item.get("width"),height:item.get("height"),angle:item.get("angle")});x=bounds.x;y=bounds.y;width=bounds.width;height=bounds.height;if(count===0){minX=x;maxX=x+width;minY=y;maxY=y+height;count++;}else{minX=Math.min(minX,x);maxX=Math.max(maxX,x+width);minY=Math.min(minY,y);maxY=Math.max(maxY,y+height);}});return{x:minX,y:minY,width:maxX-minX,height:maxY-minY};}},{key:'setItemPositions',value:function setItemPositions(item){var _this8=this;var scx=this.selectionBox.cx,scy=this.selectionBox.cy,icx=item.get("x")/this.props.zoomFactor+item.get("width")/this.props.zoomFactor/2,icy=item.get("y")/this.props.zoomFactor+item.get("height")/this.props.zoomFactor/2;var item_angle=Math.atan2(icy*this.props.zoomFactor-scy,icx*this.props.zoomFactor-scx)*(180/Math.PI);var dis=Math.sqrt(Math.pow(scx-icx*this.props.zoomFactor,2)+Math.pow(scy-icy*this.props.zoomFactor,2));var itemToMerge=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({"angle_to_center":item_angle,"dis_to_center":dis});if(item.get("type")==="GROUP"){var groupedCX=item.get("x")+item.get("width")/2,groupedCY=item.get("y")+item.get("height")/2;var groupItems=this.props.selectedChildren;var anchorAngles={};item.get("groupChildren").entrySeq().forEach(function(_ref21){var _ref22=_slicedToArray(_ref21,2),childKey=_ref22[0],itemId=_ref22[1];var child=groupItems.get(itemId);var groupedItemCX=child.get("x")+child.get("width")/2,groupedItemCY=child.get("y")+child.get("height")/2;var childAngle=Math.atan2(groupedItemCY-groupedCY,groupedItemCX-groupedCX)*(180/Math.PI)-item.get("angle");var childDis=Math.sqrt(Math.pow(groupedCX-groupedItemCX,2)+Math.pow(groupedCY-groupedItemCY,2));var childToMerge=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({"angle_to_center":childAngle,"dis_to_center":childDis});_this8.groupedItems=_this8.groupedItems.set(itemId,child.merge(childToMerge));});}return item.merge(itemToMerge);}},{key:'getSelectionBox',value:function getSelectionBox(){var _this9=this;var x=null,y=null,width=null,height=null,cx=null,cy=null,angle=0;var selectedObjects=this.state.selectedObjects;this.selectedItems=this.state.selectedObjects;if(selectedObjects!==null&&selectedObjects.size===1){var item=selectedObjects.first();x=item.get("x");y=item.get("y");width=item.get("width");height=item.get("height");angle=item.get("angle");}else{if(this.props.selectedTab==="cameraTab")this.selectedItems=this.props.selectedItems;var bounds=this.getObjectsBounds(this.selectedItems);x=bounds.x;y=bounds.y;width=bounds.width;height=bounds.height;}if(x!==null)cx=x+width/2;if(y!==null)cy=y+height/2;if(angle===undefined)angle=0;this.selectionBox=Object.assign(this.selectionBox,{x:x,y:y,width:width,height:height,cx:cx,cy:cy,angle:angle});this.initialSelectionBox=this.selectionBox;this.selectedItems=this.selectedItems.map(function(x){return _this9.setItemPositions(x);});var getAllItems=this.selectedItems;this.selectedItems.entrySeq().forEach(function(_ref23){var _ref24=_slicedToArray(_ref23,2),key=_ref24[0],single_item=_ref24[1];getAllItems=getAllItems.set(key,single_item.set("sAngle",single_item.get("angle")!==undefined?single_item.get("angle"):0));});this.selectedItems=getAllItems;return this.selectionBox;}},{key:'isVerticalScale',value:function isVerticalScale(){var result=false;if(this.props.selectedItems.size===1){var item=this.props.selectedObjects.get(this.props.selectedItems.get(0));if(item!==undefined){if(item.get("type")==="GROUP"&&item.get("subType")==="TXTGRP"&&!item.get("isOverlay")){if(item.get("isExpands")){var svgItem=this.props.selectedChildren.filter(function(obj,key){return item.get("groupChildren").indexOf(key)!==-1;}).find(function(x){return x.get("type")==="TEXT";});if(svgItem.get("verticalAlign")!==undefined)result=true;}}else if(item.get("type")==="SHAPE"||item.get("type")==="TEXT"){if(item.get("scaleType")==="square"||item.get("scaleType")==="vertical")return true;else return false;}}}return result;}},{key:'isHorizontalScale',value:function isHorizontalScale(){var result=false;if(this.props.selectedItems.size===1){var item=this.props.selectedObjects.get(this.props.selectedItems.get(0));if(item!==undefined){if(item.get("type")==="TEXT"&&item.get("subType")==="DTXT"){result=true;}else if(item.get("type")==="GROUP"&&item.get("subType")==="TXTGRP"&&!item.get("isOverlay")){if(item.get("isExpands")){var svgItem=this.props.selectedChildren.filter(function(obj,key){return item.get("groupChildren").indexOf(key)!==-1;}).find(function(x){return x.get("type")==="TEXT";});if(svgItem.get("horizontalAlign")!==undefined)result=true;}}else if(item.get("type")==="SHAPE"||item.get("type")==="TEXT"){if(item.get("scaleType")==="square"||item.get("scaleType")==="horizontal")return true;else return false;}}}return result;}},{key:'getXYRotation',value:function getXYRotation(cx,cy,x,y,angle){var x2=Math.cos(angle/180*Math.PI)*(x-cx)-Math.sin(angle/180*Math.PI)*(y-cy);var y2=Math.sin(angle/180*Math.PI)*(x-cx)+Math.cos(angle/180*Math.PI)*(y-cy);return[x2+cx,y2+cy];}},{key:'dist',value:function dist(pot1,pt2){var dx=pot1.x-pt2.x;var dy=pot1.y-pt2.y;return Math.sqrt(dx*dx+dy*dy);}},{key:'getCubicBezierPoints',value:function getCubicBezierPoints(pointDataArr,t){var helperPoints=[];for(var i=1;i<4;i++){var p=this.lerp(pointDataArr[i-1],pointDataArr[i],t);helperPoints.push(p);}helperPoints.push(this.lerp(helperPoints[0],helperPoints[1],t));helperPoints.push(this.lerp(helperPoints[1],helperPoints[2],t));helperPoints.push(this.lerp(helperPoints[3],helperPoints[4],t));var firstBezier=[pointDataArr[0],helperPoints[0],helperPoints[3],helperPoints[5]];var secondBezier=[helperPoints[5],helperPoints[4],helperPoints[2],pointDataArr[3]];// returns 2 array of points for the new bezier curves;
return[firstBezier,secondBezier];}},{key:'lerp',value:function lerp(A,B,t){return[(Number(B[0])-Number(A[0]))*t+Number(A[0]),// the x coordinate;
(Number(B[1])-Number(A[1]))*t+Number(A[1])// the y coordinate;
];}},{key:'sfix',value:function sfix(arr){var num1=Number(arr[0]);var num2=Number(arr[1]);num1=num1<0?Math.floor(Math.abs(num1)*100)*-1/100:num1.toFixed(2);num2=num2<0?Math.floor(Math.abs(num2)*100)*-1/100:num2.toFixed(2);return num1+","+num2;}},{key:'sFix2',value:function sFix2(num1,num2){num1=Number(num1);num2=Number(num2);num1=num1<0?Math.floor(Math.abs(num1)*100)*-1/100:num1.toFixed(2);num2=num2<0?Math.floor(Math.abs(num2)*100)*-1/100:num2.toFixed(2);return num1+","+num2;}},{key:'drawTail',value:function drawTail(pathData,calloutPath,callout,dataArray,ptArray,xy,cTail,endPt,update){var individualPtArray=dataArray;var plen2=ptArray.length;var pt=calloutPath.getPointAtLength(cTail);var pt2=calloutPath.getPointAtLength(endPt);var currentSegment1=0;var currentSegment2=0;for(var i=0;i<plen2;i++){if(cTail<ptArray[i].t){currentSegment1=i;break;}}for(var j=0;j<plen2;j++){if(endPt<ptArray[j].t){currentSegment2=j;break;}}var istr="";var totalIndi=(currentSegment1+1)*3+1;for(var v=0;v<totalIndi-3;v++){istr=istr+individualPtArray[v]+" ";}var cir2ptDataArr=[];for(v=totalIndi-4;v<totalIndi;v++){if(individualPtArray[v].indexOf("C")!==-1){cir2ptDataArr.push(individualPtArray[v].substring(1).split(","));}else{cir2ptDataArr.push(individualPtArray[v].split(","));}}var cir3ptDataArr=[];var totalIndi2=(currentSegment2+1)*3+1;for(var d=totalIndi2-4;d<totalIndi2;d++){if(individualPtArray[d].indexOf("C")!==-1){cir3ptDataArr.push(individualPtArray[d].substring(1).split(","));}else{cir3ptDataArr.push(individualPtArray[d].split(","));}}var ustr="";var totalInd=individualPtArray.length;for(var u=totalIndi2-1;u<totalInd;u++){ustr=ustr+individualPtArray[u]+" ";}var curseg1=currentSegment1;var t;if(currentSegment1<=0){t=cTail/ptArray[0].t;}else{t=(cTail-ptArray[curseg1-1].t)/(ptArray[curseg1].t-ptArray[curseg1-1].t);}var resultcir2Arr=this.getCubicBezierPoints(cir2ptDataArr,t);var t2;var curseg2=currentSegment2;if(currentSegment2-1<0){t2=endPt/ptArray[0].t;}else{t2=(endPt-ptArray[curseg2-1].t)/(ptArray[curseg2].t-ptArray[curseg2-1].t);}var resultcir3Arr=this.getCubicBezierPoints(cir3ptDataArr,t2);var cl0=this.sFix2(pt.x,pt.y);var cl=this.sFix2(xy.x,xy.y);var cl2=this.sFix2(pt2.x,pt2.y);var h1=this.sfix(resultcir2Arr[0][1]);var h2=this.sfix(resultcir2Arr[0][2]);var b1=this.sfix(resultcir3Arr[1][1]);var b2=this.sfix(resultcir3Arr[1][2]);var data="M"+istr+"C"+h1+" "+h2+" "+cl0+" C"+cl0+" "+cl+" "+cl+" C"+cl+" "+cl2+" "+cl2+" C"+b1+" "+b2+" "+ustr;if(currentSegment2>=currentSegment1){// callout.setAttributeNS(null,'d',"M"+istr+"C"+h1+" "+h2+" "+cl0+" C"+cl0+" "+cl+" "+cl+" C"+cl+" "+cl2+" "+cl2+" C"+b1+" "+b2+" "+ustr);
}else{var istrArr=istr.split(" ");istrArr.shift();istrArr.shift();istrArr.shift();istr=istrArr.join(" ");// callout.setAttributeNS(null,'d',"M"+cl2+" C"+b1+" "+	b2+" "+istr+"C"+h1+" "+h2+" "+cl0+" C"+cl0+" "+cl+" "+cl+" C"+cl+" "+cl2+" "+cl2);
data="M"+cl2+" C"+b1+" "+b2+" "+istr+"C"+h1+" "+h2+" "+cl0+" C"+cl0+" "+cl+" "+cl+" C"+cl+" "+cl2+" "+cl2;// callout.setAttributeNS(null,'d',"M"+istr+"C"+h1+" "+h2+" "+cl0+" C"+cl0+" "+cl+" "+cl+" C"+cl+" "+cl2+" "+cl2);
}callout.setAttributeNS(null,'d',data);if(update===true){this.props.updateObjectById({selectedScene:this.props.selectedScene,container:"workspaceItems",id:this.props.selectedItems.get(0),toUpdate:{path:[data]}},this.props.socket);}}},{key:'gradSearch',value:function gradSearch(l0,pt){l0=l0+this.actualLength;var l1=l0,dist0=this.dist(this.calloutPath.getPointAtLength(l0%this.actualLength),pt),dist1,searchDir;if(this.dist(this.calloutPath.getPointAtLength((l0-1)%this.actualLength),pt)>this.dist(this.calloutPath.getPointAtLength((l0+1)%this.actualLength),pt)){searchDir=1;}else{searchDir=-1;}l1+=searchDir;dist1=this.dist(this.calloutPath.getPointAtLength(l1%this.actualLength),pt);while(dist1<dist0){dist0=dist1;l1+=searchDir;dist1=this.dist(this.calloutPath.getPointAtLength(l1%this.actualLength),pt);}l1-=searchDir;return l1%this.actualLength;}},{key:'controlShape',value:function controlShape(e){e.preventDefault();e.stopPropagation();var t=e.target,et=e.type,m={x:e.pageX,y:e.pageY};if(et==="mousedown"||et==="touchstart"){if(!this.drag){this.drag=t;this.dPoint=m;this.handle=e.target.getAttribute("datahandle");this.pathData=this.selectedItems.getIn([this.props.selectedItems.get(0),"pathData"]).toJS();this.moveType=this.pathData.controlPoints[this.handle].moveType;this.angle=this.selectedItems.getIn([this.props.selectedItems.get(0),"angle"]);this.prevX=this.pathData.controlPoints[this.handle].x/100*this.selectedItems.getIn([this.props.selectedItems.get(0),"width"]);this.prevY=this.pathData.controlPoints[this.handle].y/100*this.selectedItems.getIn([this.props.selectedItems.get(0),"height"]);var pathDetails=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ShapeHelper__["a" /* getPath */])(this.selectedItems.get(this.props.selectedItems.get(0)),this.props.zoomFactor,this.props.selectedObjects.get(this.props.selectedItems.get(0)));if(pathDetails.newControlPoints!==undefined&&pathDetails.newControlPoints[this.handle]!==undefined){this.prevX=pathDetails.newControlPoints[this.handle].x/100*this.selectedItems.getIn([this.props.selectedItems.get(0),"width"]);this.prevY=pathDetails.newControlPoints[this.handle].y/100*this.selectedItems.getIn([this.props.selectedItems.get(0),"height"]);}}window.addEventListener('mousemove',this.controlShape,false);window.addEventListener('mouseup',this.controlShape,false);}if(this.drag&&(et==="mousemove"||et==="touchmove")){var dx=(m.x-this.dPoint.x)/this.props.zoomFactor,dy=(m.y-this.dPoint.y)/this.props.zoomFactor;var adX=dx*Math.cos(this.angle*(Math.PI/180))+dy*Math.sin(this.angle*(Math.PI/180));var adY=dy*Math.cos(this.angle*(Math.PI/180))-dx*Math.sin(this.angle*(Math.PI/180));if(this.selectedItems.getIn([this.props.selectedItems.get(0),"flipPosition"])===1)adX*=-1;else if(this.selectedItems.getIn([this.props.selectedItems.get(0),"flipPosition"])===2)adY*=-1;else if(this.selectedItems.getIn([this.props.selectedItems.get(0),"flipPosition"])===3){adX*=-1;adY*=-1;}var currentX=this.moveType==="x"||this.moveType==="xy"?this.prevX+adX:this.prevX;var currentY=this.moveType==="y"||this.moveType==="xy"?this.prevY+adY:this.prevY;var xPoint=currentX/this.selectedItems.getIn([this.props.selectedItems.get(0),"width"])*100,yPoint=currentY/this.selectedItems.getIn([this.props.selectedItems.get(0),"height"])*100;var currentPathData=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(this.pathData).setIn(["controlPoints",this.handle,"x"],xPoint).setIn(["controlPoints",this.handle,"y"],yPoint);var pathDetails=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ShapeHelper__["a" /* getPath */])(this.selectedItems.setIn([this.props.selectedItems.get(0),"pathData"],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(currentPathData)).get(this.props.selectedItems.get(0)),this.props.zoomFactor,this.props.selectedObjects.get(this.props.selectedItems.get(0)));var dataPath=pathDetails.pathDetails;if(Array.isArray(dataPath)){for(var p=0;p<dataPath.length;p++){document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].getElementsByClassName("path"+p)[0].setAttribute("d",dataPath[p].data);if(dataPath[p].pathStyle!==undefined)document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].getElementsByTagName("g")[0].style.transform="translate("+dataPath[p].pathStyle.left+"px, "+dataPath[p].pathStyle.top+"px)";}}if(pathDetails.shapeStyle!==undefined){document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].style.left=pathDetails.shapeStyle.left;document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].style.top=pathDetails.shapeStyle.top;document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].style.width=pathDetails.shapeStyle.width;document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].style.height=pathDetails.shapeStyle.height;}if(pathDetails.newControlPoints!==undefined){var newControlPoints=this.getFlipPosition(pathDetails.newControlPoints,this.selectedItems.getIn([this.props.selectedItems.get(0),"flipPosition"]));for(var _p2 in newControlPoints){document.getElementsByClassName("control-point "+_p2)[0].style.left="calc("+newControlPoints[_p2].x+"% - 7.5px)";document.getElementsByClassName("control-point "+_p2)[0].style.top="calc("+newControlPoints[_p2].y+"% - 7.5px)";}}}if(this.drag&&(et==="mouseup"||et==="touchend")){var _dx=(m.x-this.dPoint.x)/this.props.zoomFactor,_dy=(m.y-this.dPoint.y)/this.props.zoomFactor;var _adX=_dx*Math.cos(this.angle*(Math.PI/180))+_dy*Math.sin(this.angle*(Math.PI/180));var _adY=_dy*Math.cos(this.angle*(Math.PI/180))-_dx*Math.sin(this.angle*(Math.PI/180));if(this.selectedItems.getIn([this.props.selectedItems.get(0),"flipPosition"])===1)_adX*=-1;else if(this.selectedItems.getIn([this.props.selectedItems.get(0),"flipPosition"])===2)_adY*=-1;else if(this.selectedItems.getIn([this.props.selectedItems.get(0),"flipPosition"])===3){_adX*=-1;_adY*=-1;}var _currentX=this.moveType==="x"||this.moveType==="xy"?this.prevX+_adX:this.prevX;var _currentY=this.moveType==="y"||this.moveType==="xy"?this.prevY+_adY:this.prevY;var _xPoint=_currentX/this.selectedItems.getIn([this.props.selectedItems.get(0),"width"])*100,_yPoint=_currentY/this.selectedItems.getIn([this.props.selectedItems.get(0),"height"])*100;var _currentPathData=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(this.pathData).setIn(["controlPoints",this.handle,"x"],_xPoint).setIn(["controlPoints",this.handle,"y"],_yPoint);var pathDetails=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ShapeHelper__["a" /* getPath */])(this.selectedItems.setIn([this.props.selectedItems.get(0),"pathData"],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(_currentPathData)).get(this.props.selectedItems.get(0)),1,this.props.selectedObjects.get(this.props.selectedItems.get(0)));var _dataPath=pathDetails.pathDetails;this.props.updateItem({selectedScene:this.props.selectedScene,container:"workspaceItems",selectedItem:this.props.selectedItems.get(0),toUpdate:{pathData:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(pathDetails.pathData),path:_dataPath}},this.props.socket);this.drag=null,this.handle=null,this.pathData,this.prevX=null,this.prevY=null;window.removeEventListener('mousemove',this.controlShape,false);window.removeEventListener('mouseup',this.controlShape,false);}}},{key:'moveControlPoint',value:function moveControlPoint(e){try{e.preventDefault();e.stopPropagation();var t=e.target,et=e.type,m={x:e.pageX,y:e.pageY};var curWidth=this.selectedItems.getIn([this.props.selectedItems.get(0),"width"]);var curX=this.selectedItems.getIn([this.props.selectedItems.get(0),"x"]);var curY=this.selectedItems.getIn([this.props.selectedItems.get(0),"y"]);var curHeight=this.selectedItems.getIn([this.props.selectedItems.get(0),"height"]);if(et==="mousedown"||et==="touchstart"){if(!this.drag){this.relativeXY=this.getXYRotation(curX+curWidth/2,curY+curHeight/2,curX,curY,this.selectedItems.getIn([this.props.selectedItems.get(0),"angle"]));this.drag=t;this.dPoint=m;this.handle=e.target.getAttribute("datahandle");this.pathData=this.selectedItems.getIn([this.props.selectedItems.get(0),"pathData"]).toJS();if(this.handle==="callout-tail"){this.calloutPath=document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].getElementsByClassName("center")[0].getElementsByClassName("calloutPath")[0];this.callout=document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].getElementsByClassName("center")[0].getElementsByClassName("callout")[0];this.tailElement=document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].getElementsByClassName("tail")[0];this.position=this.pathData.tail.position;var p=document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].createSVGPoint();p.x=e.clientX;p.y=e.clientY;m=this.tailElement.getScreenCTM();p=p.matrixTransform(m.inverse());this.nMouseOffsetX=p.x-parseInt(this.tailElement.getAttribute("cx"),10);this.nMouseOffsetY=p.y-parseInt(this.tailElement.getAttribute("cy"),10);var tmpPt={x:p.x-this.nMouseOffsetX,y:p.y-this.nMouseOffsetY};this.actualLength=this.calloutPath.getTotalLength();var ptArray=[],segInc=0,totLen=0,individualPtArray=[];ptArray[segInc]=this.callout.getPointAtLength(0);ptArray[segInc].t=0;var pathString=this.calloutPath.getAttributeNS(null,"d");this.pathArr=[];var _Data=pathString.slice(0,-1);var ptArrays=[];ptArrays=_Data.split(" ");individualPtArray=_Data.split(" ");individualPtArray[0]=individualPtArray[0].substring(1);var tempArr=[];var str=ptArrays[0];for(var i=0;i<ptArrays.length-1;i+=3){if(i===0){tempArr.push(ptArrays[i]+" "+ptArrays[i+1]+" "+ptArrays[i+2]+" "+ptArrays[i+3]+" ");}else{tempArr.push(ptArrays[i+1]+" "+ptArrays[i+2]+" "+ptArrays[i+3]+" ");}str=str+" "+ptArrays[i+1]+" "+ptArrays[i+2]+" "+ptArrays[i+3]+" ";// updatePtArr(str)
this.callout.setAttributeNS(null,'d',str);totLen=this.callout.getTotalLength();ptArray[segInc]=this.callout.getPointAtLength(totLen);ptArray[segInc].t=totLen;segInc++;}this.cTail=this.pathData.tail.position;var callOffset=this.pathData.tail.offset;var endPt=this.cTail+callOffset;if(this.cTail<0){this.cTail=this.cTail+this.actualLength;}if(endPt>this.actualLength){endPt=endPt-this.actualLength;}this.pt=this.calloutPath.getPointAtLength(this.cTail);this.pt2=this.calloutPath.getPointAtLength(endPt);this.drawTail(this.pathData,this.calloutPath,this.callout,individualPtArray,ptArray,{x:tmpPt.x,y:tmpPt.y},this.cTail,endPt);this.ptArray=ptArray;this.individualPtArray=individualPtArray;}}window.addEventListener('mousemove',this.moveControlPoint,false);window.addEventListener('mouseup',this.moveControlPoint,false);}if(this.drag&&(et==="mousemove"||et==="touchmove")){var actualWidth=this.pathData.bounds.width;var actualHeight=this.pathData.bounds.height;if(this.handle!=="callout-tail"){if(this.pathData.controlPoints.top){var arr1,arr2;if(!this.pathData.isRectangle){var dX=m.x-this.dPoint.x+this.pathData.controlPoints.top.x/100*curWidth;dX=dX<0?0:dX>curWidth?curWidth:dX;var xPos=dX/curWidth*100;var data=this.pathData.data;var pointArrays=data.split(" ");var ctrlPoint=actualWidth*(xPos/100);var mY=pointArrays[0].split(",")[1];mY=Number(mY).toFixed(2);var newData="";newData="M"+ctrlPoint+","+mY;for(i=1;i<pointArrays.length;i+=3){arr1=pointArrays[i].substring(1).split(",");arr2=pointArrays[i+1].split(",");var arr3=pointArrays[i+2].split(",");var arrz=arr3[1].split("z")[0];var neutral1=i===1?ctrlPoint:arr1[0];newData=newData+" C"+neutral1+","+arr1[1];var neutral2=i+3===pointArrays.length?ctrlPoint:arr2[0];newData=newData+" "+neutral2+","+arr2[1];var neutral3=i+3===pointArrays.length?ctrlPoint:arr3[0];newData=newData+" "+neutral3+","+arrz;}newData=newData+"z";this.drag.parentNode.style.left="calc("+xPos+"% - 9px)";}else{var _dX3=(actualWidth*(this.pathData.controlPoints.top.x/100)+(m.x-this.dPoint.x))/actualWidth*100;_dX3=_dX3<10?10:_dX3>45?45:_dX3;var _data=this.pathData.data;var _pointArrays=_data.split(" ");_pointArrays[_pointArrays.length-1]=_pointArrays[_pointArrays.length-1].slice(0,-1);var cX=_pointArrays[1].split(",")[0];cX=Number(cX.substring(1)).toFixed(2);var cY=_pointArrays[1].split(",")[1];cY=Number(cY).toFixed(2);newData="";newData=_pointArrays[0];newData=newData+" C"+Number(cX)+","+Number(cY);var curviness=_dX3/100*actualWidth;for(i=2;i<_pointArrays.length;i+=3){var xadder=0;var yadder=0;arr1=_pointArrays[i].split(",");arr2=_pointArrays[i+1].split(",");if(i!==_pointArrays.length-2)var arr3=_pointArrays[i+2].substring(1).split(",");if(i===5){xadder=-curviness;}if(i===2){yadder=-curviness;}if(i===8){xadder=curviness;}if(i===11){yadder=-curviness;}if(i===17){xadder=curviness;}if(i===14){yadder=curviness;}if(i===20){xadder=-curviness;}if(i===23){yadder=curviness;}//newData=newData+" C"+arr1[0]+","+arr1[1];
newData=newData+" "+(Number(arr1[0])+xadder)+","+(Number(arr1[1])+yadder);newData=newData+" "+(Number(arr2[0])+xadder)+","+(Number(arr2[1])+yadder);if(i!==_pointArrays.length-2)newData=newData+" C"+Number(arr3[0])+","+Number(arr3[1]);}newData=newData+"z";this.drag.parentNode.style.left="calc("+_dX3+"% - 6px)";}// this.drag.style.left = "calc("+ xPos +"% - 6px)";
document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].getElementsByClassName("center")[0].getElementsByTagName("path")[0].setAttribute("d",newData);}}else{var cTail=this.cTail;var callOffset=this.pathData.tail.offset;var endPt=cTail+callOffset;// cTail = cTail + this.actualLength;
var _p3=document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].createSVGPoint();_p3.x=e.clientX;_p3.y=e.clientY;var ctm=this.tailElement.getScreenCTM();_p3=_p3.matrixTransform(ctm.inverse());var tmpPt={x:_p3.x-this.nMouseOffsetX,y:_p3.y-this.nMouseOffsetY};this.tailElement.setAttribute("cx",tmpPt.x);this.tailElement.setAttribute("cy",tmpPt.y);var midPoint=cTail+callOffset/2;midPoint=this.gradSearch(midPoint,tmpPt);cTail=midPoint-callOffset/2;endPt=cTail+callOffset;if(cTail<0){cTail=cTail+this.actualLength;}if(endPt>this.actualLength){endPt=endPt-this.actualLength;}this.cTail=cTail;this.position=this.cTail/this.actualLength;var pt1=this.calloutPath.getPointAtLength(this.cTail);var pt2=this.calloutPath.getPointAtLength(endPt);var a_angle=Math.atan2(pt1.y-pt2.y,pt1.x-pt2.x)*(180/Math.PI);a_angle=a_angle+90;a_angle=a_angle*(Math.PI/180);var midPoint=this.cTail+callOffset/2;if(midPoint>this.actualLength)midPoint=midPoint-this.actualLength;var tailPoint=this.calloutPath.getPointAtLength(midPoint);var scaleX=this.selectedItems.getIn([this.props.selectedItems.get(0),"groupBounds","center","scaleX"]);var scaleY=this.selectedItems.getIn([this.props.selectedItems.get(0),"groupBounds","center","scaleY"]);var translateX=this.selectedItems.getIn([this.props.selectedItems.get(0),"groupBounds","center","x"]),translateY=this.selectedItems.getIn([this.props.selectedItems.get(0),"groupBounds","center","y"]);var _dX4=tailPoint.x+tmpPt.x+(translateX-tailPoint.x);var dY=tailPoint.y+tmpPt.y+(translateY-tailPoint.y);var svgX=0,svgY=0,distX=0,distY=0;if(_dX4<0){svgX=_dX4*scaleX;distX=this.pathData.bounds.width-_dX4;}if(_dX4>this.pathData.bounds.width){distX=_dX4-this.pathData.bounds.width;}if(dY<0){svgY=dY*scaleY;distY=this.pathData.bounds.height-dY;}if(dY>this.pathData.bounds.height){distY=dY-this.pathData.bounds.height;}var svgWidth=(actualWidth+distX)*scaleX;var svgHeight=(actualHeight+distY)*scaleY;document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].style.top=svgY*this.props.zoomFactor+"px";document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].style.left=svgX*this.props.zoomFactor+"px";document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].getElementsByClassName("center")[0].style.transform="matrix("+scaleX*this.props.zoomFactor+", 0, 0, "+scaleY*this.props.zoomFactor+", "+(translateX-svgX)*this.props.zoomFactor+", "+(translateY-svgY)*this.props.zoomFactor+")";// if(actualWidth < svgWidth){
document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].style.width=svgWidth+"px";// }
// if(actualHeight < svgHeight){
document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].style.height=svgHeight-svgY+"px";// }
this.drawTail(this.pathData,this.calloutPath,this.callout,this.individualPtArray,this.ptArray,{x:tmpPt.x,y:tmpPt.y},this.cTail,endPt);this.drag.parentNode.style.left=tmpPt.x*scaleX*this.props.zoomFactor-10+"px";this.drag.parentNode.style.top=tmpPt.y*scaleY*this.props.zoomFactor-10+"px";}}if(this.drag&&(et==="mouseup"||et==="touchend")){var _actualWidth=this.pathData.bounds.width;var _actualHeight=this.pathData.bounds.height;if(this.handle!=="callout-tail"){if(this.pathData.controlPoints.top){if(!this.pathData.isRectangle){var _dX5=m.x-this.dPoint.x+this.pathData.controlPoints.top.x/100*curWidth;_dX5=_dX5<0?0:_dX5>curWidth?curWidth:_dX5;var _xPos=_dX5/curWidth*100;this.pathData.controlPoints.top.x=_xPos;}else{var _dX6=(_actualWidth*(this.pathData.controlPoints.top.x/100)+(m.x-this.dPoint.x))/_actualWidth*100;_dX6=_dX6<10?10:_dX6>45?45:_dX6;this.pathData.controlPoints.top.x=_dX6;}var svgPath=document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].getElementsByClassName("center")[0].getElementsByTagName("path")[0].getAttribute("d");this.props.updateObjectById({selectedScene:this.props.selectedScene,container:"workspaceItems",id:this.props.selectedItems.get(0),toUpdate:{pathData:this.pathData,path:[svgPath]}},this.props.socket);}}else{var _p4=document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].createSVGPoint();_p4.x=e.clientX;_p4.y=e.clientY;var ctm=this.tailElement.getScreenCTM();_p4=_p4.matrixTransform(ctm.inverse());var tmpPt={x:_p4.x-this.nMouseOffsetX,y:_p4.y-this.nMouseOffsetY};var endPt=this.cTail+this.pathData.tail.offset;if(this.cTail<0){this.cTail=this.cTail+this.actualLength;}if(endPt>this.actualLength){endPt=endPt-this.actualLength;}this.drawTail(this.pathData,this.calloutPath,this.callout,this.individualPtArray,this.ptArray,{x:tmpPt.x,y:tmpPt.y},this.cTail,endPt,true);this.pathData.tail.position=this.cTail;this.pathData.tail.point=tmpPt;var midPoint=this.cTail+this.pathData.tail.offset/2;if(midPoint>this.actualLength)midPoint=midPoint-this.actualLength;this.pathData.tail.distance=-this.dist(this.calloutPath.getPointAtLength(midPoint),tmpPt);this.props.updateObjectById({selectedScene:this.props.selectedScene,container:"workspaceItems",id:this.props.selectedItems.get(0),toUpdate:{pathData:this.pathData}},this.props.socket);this.pathArr=null;this.callout=null;this.calloutPath=null;this.actualLength=null;this.ptArray=null;this.individualPtArray=null;this.pt=null;this.pt3=null;this.tailElement=null;this.nMouseOffsetX=null;this.nMouseOffsetY=null;}this.drag=null,this.handle=null,this.relativeXY=null;window.removeEventListener('mousemove',this.moveControlPoint,false);window.removeEventListener('mouseup',this.moveControlPoint,false);}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"TransformManagerComponent-moveControlPoint");}}},{key:'getFlipPosition',value:function getFlipPosition(controlPoints,flipPosition){if(flipPosition===1){for(var key in controlPoints){controlPoints[key].x=100-controlPoints[key].x;}}else if(flipPosition===2){for(var _key in controlPoints){controlPoints[_key].y=100-controlPoints[_key].y;}}else if(flipPosition===3){for(var _key2 in controlPoints){controlPoints[_key2].x=100-controlPoints[_key2].x;controlPoints[_key2].y=100-controlPoints[_key2].y;}}return controlPoints;}},{key:'render',value:function render(){var _this10=this;var selectionBounds={};if(!this.transformingByKey)selectionBounds=this.getSelectionBox();else selectionBounds=this.selectionBox;var selection_styles={transform:"translate("+parseFloat(selectionBounds.x*this.props.zoomFactor).toFixed(2)+"px, "+parseFloat(selectionBounds.y*this.props.zoomFactor).toFixed(2)+"px) rotateZ("+selectionBounds.angle+"deg)",width:selectionBounds.width*this.props.zoomFactor,height:selectionBounds.height*this.props.zoomFactor,userSelect:'none',pointerEvents:this.isShapeOnly()&&!this.props.textStatus.get("isFocused")?undefined:'none'};var id=null;// selection_styles.display = "none";
var selectionBoxClass="selectionBox";var innerBoxClass="inner-box";var handlesClass="handles";if(this.isTextOnly()){selectionBoxClass+=" text-only";}if(this.isPermenantGroup()||this.isTextOnly()||this.isCalloutOnly()){selectionBoxClass+=" text-content";}if(this.props.lockTransform){innerBoxClass+=" hide pointer-events-none";handlesClass+=" hide pointer-events-none";}if(this.props.textStatus.get("isFocused")){selectionBoxClass+=" pointer-events-none";handlesClass+=" pointer-events-auto";}if(this.selectionBox.angle>=337.5||this.selectionBox.angle<=22.5)selectionBoxClass+=" e";else if(this.selectionBox.angle>=22.5&&this.selectionBox.angle<=67.5)selectionBoxClass+=" se";else if(this.selectionBox.angle>=67.5&&this.selectionBox.angle<=112.5)selectionBoxClass+=" s";else if(this.selectionBox.angle>=112.5&&this.selectionBox.angle<=157.5)selectionBoxClass+=" sw";else if(this.selectionBox.angle>=157.5&&this.selectionBox.angle<=202.5)selectionBoxClass+=" w";else if(this.selectionBox.angle>=202.5&&this.selectionBox.angle<=247.5)selectionBoxClass+=" nw";else if(this.selectionBox.angle>=247.5&&this.selectionBox.angle<=292.5)selectionBoxClass+=" n";else if(this.selectionBox.angle>=292.5&&this.selectionBox.angle<=337.5)selectionBoxClass+=" ne";if(this.props.transformStatus.get("transforming")&&(this.props.selectedCamera===""||this.props.selectedCamera===undefined))selectionBoxClass+=" invisible";if(this.props.isToolCropping)selectionBoxClass+=" tool-crop";var controlPoints=[];if(this.isShapeOnly()){if(this.selectedItems.getIn([this.props.selectedItems.get(0),"subType"])==="CSTMPTH"){var pathDetails=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ShapeHelper__["a" /* getPath */])(this.selectedItems.get(this.props.selectedItems.get(0)),this.props.zoomFactor,this.props.selectedObjects.get(this.props.selectedItems.get(0)));var pathData=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(pathDetails.pathData);if(pathDetails.newControlPoints!==undefined){var flilpPostion=this.selectedItems.getIn([this.props.selectedItems.get(0),"flipPosition"]);var newControlPoints=this.getFlipPosition(pathDetails.newControlPoints,flilpPostion);for(var p in newControlPoints){controlPoints.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:p,className:"control-point "+p,style:{left:"calc("+newControlPoints[p].x+"% - 7.5px)",top:"calc("+newControlPoints[p].y+"% - 7.5px)",display:"block"},datahandle:p,onMouseDown:this.controlShape},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{datahandle:p,src:this.appUrl+"/images/property-icons/control-point.svg"})));}}else if(pathData){pathData.get("controlPoints").entrySeq().forEach(function(_ref25){var _ref26=_slicedToArray(_ref25,2),key=_ref26[0],pos=_ref26[1];controlPoints.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:key,className:"control-point "+key,style:{left:"calc("+pos.get("x")+"% - 7.5px)",top:"calc("+pos.get("y")+"% - 7.5px)",display:"block"},datahandle:key,onMouseDown:_this10.controlShape},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{datahandle:key,src:_this10.appUrl+"/images/property-icons/control-point.svg"})));});}}else if(this.selectedItems.getIn([this.props.selectedItems.get(0),"pathData","controlPoints"])){var _pathData=this.selectedItems.getIn([this.props.selectedItems.get(0),"pathData"]);if(_pathData){_pathData.get("controlPoints").entrySeq().forEach(function(_ref27){var _ref28=_slicedToArray(_ref27,2),key=_ref28[0],pos=_ref28[1];if(key==="top"||key==="right"||key==="bottom"||key==="left"){var left=_this10.selectedItems.getIn([_this10.props.selectedItems.get(0),"width"])*(pos.get("x")/100),top=_this10.selectedItems.getIn([_this10.props.selectedItems.get(0),"height"])*(pos.get("y")/100);controlPoints.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:key,className:"control-point "+key,style:{left:"calc("+pos.get("x")+"% - 9px)",top:top-9+"px",display:"block"},datahandle:key,onMouseDown:_this10.moveControlPoint},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{datahandle:key,src:_this10.appUrl+"/images/property-icons/control-point.svg"})));}else{var _left=pos,_top=pos;var style={};if(key==="topLeft")style={left:_left-9+"px",top:_top-9+"px"};else if(key==="topRight")style={right:_left-9+"px",top:_top-9+"px"};else if(key==="bottomRight")style={right:_left-9+"px",bottom:_top-9+"px"};else if(key==="bottomLeft")style={left:_left-9+"px",bottom:_top-9+"px"};controlPoints.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:key,className:"control-point "+key,style:style,datahandle:key,onMouseDown:_this10.moveControlPoint},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{datahandle:key,src:_this10.appUrl+"/images/property-icons/control-point.svg"})));}});}}else if(this.selectedItems.getIn([this.props.selectedItems.get(0),"subType"])==="CALLOUT"){var calloutTail=this.selectedItems.getIn([this.props.selectedItems.get(0),"pathData","tail"]).toJS();var callout=document.getElementById(this.props.selectedItems.get(0)).getElementsByClassName("center")[0].getElementsByClassName("callout")[0];var calloutPath=document.getElementById(this.props.selectedItems.get(0)).getElementsByClassName("center")[0].getElementsByClassName("calloutPath")[0];var actualLength=calloutPath.getTotalLength();var cTail=calloutTail.position;var callOffset=calloutTail.offset;var endPt=cTail+callOffset;var pt=calloutPath.getPointAtLength(cTail);var pt2=calloutPath.getPointAtLength(endPt);var a_angle=Math.atan2(pt.y-pt2.y,pt.x-pt2.x)*(180/Math.PI);a_angle=a_angle+90;a_angle=a_angle*(Math.PI/180);var midPoint=cTail+callOffset/2;if(midPoint>actualLength)midPoint=midPoint-actualLength;var pt3=calloutPath.getPointAtLength(midPoint);var scaleX=this.selectedItems.getIn([this.props.selectedItems.get(0),"groupBounds","center","scaleX"]);var scaleY=this.selectedItems.getIn([this.props.selectedItems.get(0),"groupBounds","center","scaleY"]);var dx2=calloutTail.point.x;var dy2=calloutTail.point.y;var style={top:dy2*scaleY*this.props.zoomFactor-10+"px",left:dx2*scaleX*this.props.zoomFactor-10+"px"};controlPoints.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'clt',className:"control-point callout-tail",style:style,datahandle:'callout-tail',onMouseDown:this.moveControlPoint},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{datahandle:'callout-tail',src:this.appUrl+"/images/property-icons/control-point.svg"})));}}var transformManager=void 0;transformManager=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-html2canvas-ignore':'true',key:this.props.keyframe,className:selectionBoxClass,ref:function ref(instance){return _this10.selectionBoxElement=instance;},'data-id':id,style:selection_styles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:innerBoxClass,'data-id':id,onMouseDown:this.initiateMove,onMouseEnter:function onMouseEnter(e){return _this10.setCursor(e,"move");},onMouseLeave:function onMouseLeave(e){return _this10.resetCursor(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:handlesClass,style:{pointerEvents:'auto'}},controlPoints,this.isTextOnly()&&this.props.textStatus.get("isFocused")?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-inner-box','data-id':id,onMouseDown:this.initiateMove,onMouseEnter:function onMouseEnter(e){return _this10.setCursor(e,"move");},onMouseLeave:function onMouseLeave(e){return _this10.resetCursor(e);},style:{top:"-15px",left:"-15px",right:"-15px",height:"15px",position:"absolute"}}):null,this.isTextOnly()&&this.props.textStatus.get("isFocused")?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-inner-box','data-id':id,onMouseDown:this.initiateMove,onMouseEnter:function onMouseEnter(e){return _this10.setCursor(e,"move");},onMouseLeave:function onMouseLeave(e){return _this10.resetCursor(e);},style:{top:"-15px",right:"-15px",bottom:"-15px",width:"15px",position:"absolute"}}):null,this.isTextOnly()&&this.props.textStatus.get("isFocused")?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-inner-box','data-id':id,onMouseDown:this.initiateMove,onMouseEnter:function onMouseEnter(e){return _this10.setCursor(e,"move");},onMouseLeave:function onMouseLeave(e){return _this10.resetCursor(e);},style:{left:"-15px",right:"-15px",bottom:"-15px",height:"15px",position:"absolute"}}):null,this.isTextOnly()&&this.props.textStatus.get("isFocused")?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-inner-box','data-id':id,onMouseDown:this.initiateMove,onMouseEnter:function onMouseEnter(e){return _this10.setCursor(e,"move");},onMouseLeave:function onMouseLeave(e){return _this10.resetCursor(e);},style:{left:"-15px",top:"-15px",bottom:"-15px",width:"15px",position:"absolute"}}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"resize-handle top-left"+((this.props.transformStatus.get("resizing")||this.props.transformStatus.get("rotating"))&&this.selectionBox.handle==="top-left"||this.props.isToolCropping?" active":""),'data-handle':'top-left',onMouseDown:this.initiateResize,onMouseEnter:function onMouseEnter(e){return _this10.setCursor(e,"resize");},onMouseLeave:function onMouseLeave(e){return _this10.resetCursor(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"rotate-handle top-left"+(this.props.selectedItems.size===0?" disabled":""),'data-handle':'top-left',onMouseDown:this.initiateRotate,onMouseEnter:function onMouseEnter(e){return _this10.setCursor(e,"rotate");},onMouseLeave:function onMouseLeave(e){return _this10.resetCursor(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"resize-handle top"+(this.isVerticalScale()?"":" disabled")+((this.props.transformStatus.get("resizing")||this.props.transformStatus.get("rotating"))&&this.selectionBox.handle==="top"?" active":"")+(selectionBounds.width*this.props.zoomFactor>60?"":" hide-handle"),'data-handle':'top',onMouseDown:this.initiateResize,onMouseEnter:function onMouseEnter(e){return _this10.setCursor(e,"resize");},onMouseLeave:function onMouseLeave(e){return _this10.resetCursor(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"resize-handle top-right"+((this.props.transformStatus.get("resizing")||this.props.transformStatus.get("rotating"))&&this.selectionBox.handle==="top-right"||this.props.isToolCropping?" active":""),'data-handle':'top-right',onMouseDown:this.initiateResize,onMouseEnter:function onMouseEnter(e){return _this10.setCursor(e,"resize");},onMouseLeave:function onMouseLeave(e){return _this10.resetCursor(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"rotate-handle top-right"+(this.props.selectedItems.size===0?" disabled":""),'data-handle':'top-right',onMouseDown:this.initiateRotate,onMouseEnter:function onMouseEnter(e){return _this10.setCursor(e,"rotate");},onMouseLeave:function onMouseLeave(e){return _this10.resetCursor(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"resize-handle right"+(this.isHorizontalScale()?"":" disabled")+((this.props.transformStatus.get("resizing")||this.props.transformStatus.get("rotating"))&&this.selectionBox.handle==="right"||this.props.isToolCropping?" active":"")+(selectionBounds.height*this.props.zoomFactor>60?"":" hide-handle"),'data-handle':'right',onMouseDown:this.initiateResize,onMouseEnter:function onMouseEnter(e){return _this10.setCursor(e,"resize");},onMouseLeave:function onMouseLeave(e){return _this10.resetCursor(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"resize-handle bottom-left"+((this.props.transformStatus.get("resizing")||this.props.transformStatus.get("rotating"))&&this.selectionBox.handle==="bottom-left"||this.props.isToolCropping?" active":""),'data-handle':'bottom-left',onMouseDown:this.initiateResize,onMouseEnter:function onMouseEnter(e){return _this10.setCursor(e,"resize");},onMouseLeave:function onMouseLeave(e){return _this10.resetCursor(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"rotate-handle bottom-left"+(this.props.selectedItems.size===0?" disabled":""),'data-handle':'bottom-left',onMouseDown:this.initiateRotate,onMouseEnter:function onMouseEnter(e){return _this10.setCursor(e,"rotate");},onMouseLeave:function onMouseLeave(e){return _this10.resetCursor(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"resize-handle bottom"+(this.isVerticalScale()?"":" disabled")+(this.props.transformStatus.get("resizing")&&this.selectionBox.handle==="bottom"?" active":"")+(selectionBounds.width*this.props.zoomFactor>60?"":" hide-handle"),'data-handle':'bottom',onMouseDown:this.initiateResize,onMouseEnter:function onMouseEnter(e){return _this10.setCursor(e,"resize");},onMouseLeave:function onMouseLeave(e){return _this10.resetCursor(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"resize-handle bottom-right"+((this.props.transformStatus.get("resizing")||this.props.transformStatus.get("rotating"))&&this.selectionBox.handle==="bottom-right"||this.props.isToolCropping?" active":""),'data-handle':'bottom-right',onMouseDown:this.initiateResize,onMouseEnter:function onMouseEnter(e){return _this10.setCursor(e,"resize");},onMouseLeave:function onMouseLeave(e){return _this10.resetCursor(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"rotate-handle bottom-right"+(this.props.selectedItems.size===0?" disabled":""),'data-handle':'bottom-right',onMouseDown:this.initiateRotate,onMouseEnter:function onMouseEnter(e){return _this10.setCursor(e,"rotate");},onMouseLeave:function onMouseLeave(e){return _this10.resetCursor(e);}}),this.props.selectedItems.size>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"rotate-handle bottom"+((this.props.transformStatus.get("resizing")||this.props.transformStatus.get("rotating"))&&this.selectionBox.handle==="bottom"?" active":""),'data-handle':'bottom',onMouseDown:this.initiateRotate,onMouseEnter:function onMouseEnter(e){return _this10.setCursor(e,"rotate");},onMouseLeave:function onMouseLeave(e){return _this10.resetCursor(e);}}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"resize-handle left"+(this.isHorizontalScale()?"":" disabled")+((this.props.transformStatus.get("resizing")||this.props.transformStatus.get("rotating"))&&this.selectionBox.handle==="left"?" active":"")+(selectionBounds.height*this.props.zoomFactor>60?"":" hide-handle"),'data-handle':'left',onMouseDown:this.initiateResize,onMouseEnter:function onMouseEnter(e){return _this10.setCursor(e,"resize");},onMouseLeave:function onMouseLeave(e){return _this10.resetCursor(e);}})));// if (this.props.animakerType === 'lite') {
//   selectionBoxClass = selectionBoxClass + " lite-selection"
//   transformManager = <div key={this.props.keyframe} className={selectionBoxClass} ref={(instance) => this.selectionBoxElement = instance} data-id={id} style={selection_styles} >
//     <div className={innerBoxClass} data-id={id} onMouseEnter={(e) => this.setCursor(e, "move")} onMouseLeave={(e) => this.resetCursor(e)} >
//     </div>
//   </div>
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,transformManager);}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(props,state){if(props.selectedObjects!==state.prevSelectedObjects){return{selectedObjects:props.selectedObjects,prevSelectedObjects:state.selectedObjects,selectedItems:props.selectedItems,prevSelectedItems:state.selectedItems};}else return null;}}]);return TransformManagerComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (TransformManagerComponent);

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ItemToolBar__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_index__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state,ownProps){return{selectedScene:state.localStore.get("selectedScene"),selectedItems:state.localStore.get("selectedItems"),workspaceWidth:state.project.get("width"),workspaceHeight:state.project.get("height"),selectedObjects:state.project.getIn(["scenes",state.localStore.get("selectedScene"),"workspaceItems"]).filter(function(obj,key){return state.localStore.get("selectedItems").keyOf(key)!==undefined;}),workspaceChildren:state.project.getIn(["scenes",state.localStore.get("selectedScene"),"workspaceChildren"]),duration:state.project.getIn(["scenes",state.localStore.get("selectedScene"),"duration"]),playHeadValue:state.project.getIn(["scenes",state.localStore.get("selectedScene"),"playHeadValue"]),propertyWindow:state.localStore.get("propertyWindow"),textStatus:state.localStore.get("textStatus"),isWorkspaceTextFocus:state.localStore.get('isWorkspaceTextFocus'),transformStatus:state.localStore.get('transformStatus'),isToolBarExpanded:state.localStore.get('isToolBarExpanded'),zoomFactor:state.localStore.get('zoomFactor'),workspaceBounds:state.localStore.get('workspaceBounds'),selectionBox:state.localStore.get("selectionBox"),selectedCamera:state.localStore.get("selectedCamera"),swapDetails:state.localStore.get("swapDetails"),workspaceStage:state.localStore.get("workspaceStage"),showSlidePanel:state.localStore.get("showSlidePanel"),workspaceCameras:state.localStore.get("selectedCamera")!==""?state.project.getIn(["scenes",state.localStore.get("selectedScene"),"workspaceCameras"]):null,animakerType:state.localStore.get('animakerType'),undoProp:state.localStore.get('undoProp'),updateItems:state.localStore.get('itemToUpdate'),textOffset:state.localStore.get('textOffset'),workspaceItems:state.project.getIn(['scenes',state.localStore.get('selectedScene'),'workspaceItems']),projectData:state.project};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{flipItem:function flipItem(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_2" /* flipItem */])(data,socket));},deleteItem:function deleteItem(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["T" /* deleteItem */])(data,socket));},updateTextStatus:function updateTextStatus(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_95" /* updateTextStatus */])(data));},swapItem:function swapItem(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_64" /* swapItem */])(data));},swapItemUndo:function swapItemUndo(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_65" /* swapItemUndo */])(data));},groupObjects:function groupObjects(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_4" /* groupObjects */])(data,socket));},unGroupObjects:function unGroupObjects(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_72" /* unGroupObjects */])(data,socket));},setPropertyWindow:function setPropertyWindow(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_42" /* setPropertyWindow */])(data));},toggleToolBar:function toggleToolBar(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_70" /* toggleToolBar */])(data,socket));},changeBg:function changeBg(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["A" /* changeBg */])(data,socket));},deleteObject:function deleteObject(type,socket,id,selectedScene,selectedItem){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["V" /* deleteObject */])(type,socket,id,selectedScene,selectedItem));},resizeUpdate:function resizeUpdate(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_24" /* resizeUpdate */])(data,socket));},toggleCrop:function toggleCrop(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_68" /* toggleCrop */])(data));},nextBtnClicked:function nextBtnClicked(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_14" /* nextBtnClicked */])(data));},manageToast:function manageToast(data){dispatch({type:"MANAGE_TOAST",data:data});}};};var ItemToolBar=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ItemToolBar__["a" /* default */]);/* unused harmony default export */ var _unused_webpack_default_export = (ItemToolBar);

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_project__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_app_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_ErrorLogService__ = __webpack_require__(9);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ItemToolBar=function(_React$Component){_inherits(ItemToolBar,_React$Component);function ItemToolBar(props){_classCallCheck(this,ItemToolBar);var _this=_possibleConstructorReturn(this,(ItemToolBar.__proto__||Object.getPrototypeOf(ItemToolBar)).call(this,props));_this.state={icons:[],type:"vertical",column:"two",canExpand:true};_this.handleClick=_this.handleClick.bind(_this);_this.handleShortcuts=_this.handleShortcuts.bind(_this);_this.toggleToolBar=_this.toggleToolBar.bind(_this);_this.appUrl=__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a['APPICONS'][__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a['APPICONS']['current']];return _this;}_createClass(ItemToolBar,[{key:'getCorner',value:function getCorner(pivotX,pivotY,cornerX,cornerY,angle){var x,y,distance,diffX,diffY;/// get distance from center to point
diffX=cornerX-pivotX;diffY=cornerY-pivotY;distance=Math.sqrt(diffX*diffX+diffY*diffY);/// find angle from pivot to corner
angle+=Math.atan2(diffY,diffX);/// get new x and y and round it off to integer
x=pivotX+distance*Math.cos(angle);y=pivotY+distance*Math.sin(angle);return{x:x,y:y};}},{key:'getSelectionBoxBounds',value:function getSelectionBoxBounds(data){var angle=data.angle*Math.PI/180;var c1,c2,c3,c4,/// corners
bx1,by1,bx2,by2,bounds;c1=this.getCorner(data.cx,data.cy,data.x,data.y,angle);c2=this.getCorner(data.cx,data.cy,data.x+data.width,data.y,angle);c3=this.getCorner(data.cx,data.cy,data.x+data.width,data.y+data.height,angle);c4=this.getCorner(data.cx,data.cy,data.x,data.y+data.height,angle);/// get bounding box
bx1=Math.min(c1.x,c2.x,c3.x,c4.x);by1=Math.min(c1.y,c2.y,c3.y,c4.y);bx2=Math.max(c1.x,c2.x,c3.x,c4.x);by2=Math.max(c1.y,c2.y,c3.y,c4.y);bounds={x:parseFloat(bx1.toFixed(2)),y:parseFloat(by1.toFixed(2)),width:parseFloat((bx2-bx1).toFixed(2)),height:parseFloat((by2-by1).toFixed(2))};return bounds;}},{key:'getObjectsBounds',value:function getObjectsBounds(objects,zoomFactor){var _this2=this;var minX=0,maxX=0,minY=0,maxY=0,width=0,height=0;var count=0;objects.entrySeq().forEach(function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],item=_ref2[1];var bounds=void 0,x=void 0,y=void 0,width=void 0,height=void 0;bounds=_this2.getSelectionBoxBounds({x:item.get("x"),y:item.get("y"),cx:item.get("x")+item.get("width")/2,cy:item.get("y")+item.get("height")/2,width:item.get("width"),height:item.get("height"),angle:item.get("angle")});x=bounds.x;y=bounds.y;width=bounds.width;height=bounds.height;if(count===0){minX=x;maxX=x+width;minY=y;maxY=y+height;count++;}else{minX=Math.min(minX,x);maxX=Math.max(maxX,x+width);minY=Math.min(minY,y);maxY=Math.max(maxY,y+height);}});width=(maxX-minX)*this.props.zoomFactor;height=(maxY-minY)*this.props.zoomFactor;minX*=this.props.zoomFactor;minY*=this.props.zoomFactor;var x=this.props.workspaceWidth*this.props.zoomFactor<=this.props.workspaceBounds.get("width")?this.props.workspaceBounds.get("cx")-this.props.workspaceWidth*this.props.zoomFactor/2:this.props.workspaceBounds.get("cx")-this.props.workspaceBounds.get("width")/2,y=this.props.workspaceHeight*this.props.zoomFactor<=this.props.workspaceBounds.get("height")?this.props.workspaceBounds.get("cy")-this.props.workspaceHeight*this.props.zoomFactor/2:this.props.workspaceBounds.get("cy")-this.props.workspaceBounds.get("height")/2;return{x:x+minX,y:y+minY,width:width,height:height};}},{key:'getToolBarXY',value:function getToolBarXY(){var allItems=void 0;if(this.props.selectedItems.size>0){allItems=this.props.selectedObjects;if(this.props.selectedItems.size===1){var item=this.props.selectedObjects.first();}}if(allItems!==undefined){var bounds=this.getObjectsBounds(allItems,this.props.zoomFactor);var stageLeft=this.props.workspaceStage.getIn(["left","menu"]);var stageTop=this.props.workspaceStage.getIn(["top","menu"]);var stageRight=window.innerWidth;var stageBottom=window.innerHeight-this.props.workspaceStage.getIn(["bottom","timeline"]);if(document.getElementsByClassName("app-lib-container")[0].className.indexOf("opened")!==-1)stageLeft+=this.props.workspaceStage.getIn(["left","library"]);if(this.props.propertyWindow.get("isOpened")===true&&document.getElementsByClassName("property-window-container")[0]){stageRight-=document.getElementsByClassName("property-window-container")[0].offsetWidth;}else if(this.props.showSlidePanel){stageRight-=document.getElementsByClassName("slide-panel")[0].offsetWidth;}var toolBarX=bounds.x+bounds.width+10,toolBarY=bounds.y;if(toolBarX<stageLeft)toolBarX=stageLeft;if(toolBarX+this.toolBar.offsetWidth>stageRight){toolBarX=bounds.x-this.toolBar.offsetWidth-10;if(toolBarX+this.toolBar.offsetWidth>stageRight)toolBarX=stageRight-this.toolBar.offsetWidth-10;}if(toolBarY<stageTop){toolBarY=stageTop+10;}if(toolBarY+this.toolBar.offsetHeight>stageBottom){toolBarY=stageBottom-this.toolBar.offsetHeight-10;}if(bounds.x-this.toolBar.offsetWidth<=stageLeft&&bounds.x+bounds.width+this.toolBar.offsetWidth>=stageRight&&bounds.y<stageTop&&bounds.y+bounds.height>=stageBottom){toolBarY=stageTop+10;toolBarX=stageRight-this.toolBar.offsetWidth-10;}else if(bounds.x-this.toolBar.offsetWidth<=stageLeft&&bounds.x+bounds.width+this.toolBar.offsetWidth>=stageRight){toolBarX=stageRight-this.toolBar.offsetWidth-10;}else if(bounds.y<stageTop&&bounds.y+bounds.height>=stageBottom){toolBarY=stageTop+10;}else if(bounds.x+bounds.width+this.toolBar.offsetWidth<=stageRight){toolBarX=bounds.x+bounds.width+10;}return{x:toolBarX,y:toolBarY};}else{return{x:stageRight-this.toolBar.offsetWidth-10,y:stageTop+10};}}},{key:'componentDidMount',value:function componentDidMount(){var toolBarXY=this.getToolBarXY();this.toolBar.style.left=toolBarXY.x+"px";this.toolBar.style.top=toolBarXY.y+"px";}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var toolBarXY=this.getToolBarXY();this.toolBar.style.left=toolBarXY.x+"px";this.toolBar.style.top=toolBarXY.y+"px";this.flipClicked=false;if(!this.props.isWorkspaceTextFocus&&this.props.shortcutName!==prevProps.shortcutName&&this.props.shortcutName!=="")this.handleShortcuts(this.props.shortcutName);}},{key:'handleShortcuts',value:function handleShortcuts(option){switch(option){case"FLIP_ITEM":this.handleClick('keys',"flip");break;case"GROUP_ITEM":this.handleClick('keys',"group");break;case"UN_GROUP_ITEM":this.handleClick('keys',"ungroup");break;case"DELETE_ITEM":case"DELETE_ITEM_MAC":this.handleClick('keys',"delete");break;default:break;}}},{key:'DistanceTwoPoints',value:function DistanceTwoPoints(x1,x2,y1,y2){var dx=x1-x2;var dy=y1-y2;return Math.sqrt(dx*dx+dy*dy);}},{key:'handleClick',value:function handleClick(e,icon){var _this3=this;try{if(icon.indexOf("flip")!==-1){if(this.props.selectedItems.size===1&&(this.props.selectedObjects.getIn([this.props.selectedItems.get(0),"type"])!=="TEXT"||this.props.selectedObjects.getIn([this.props.selectedItems.get(0),"subType"])==="CALLOUT")){var _nextBtn=document.querySelector('.next_step');if(_nextBtn){_nextBtn.classList.remove('disable');this.flipClicked=true;}var flipValue=this.props.selectedObjects.getIn([this.props.selectedItems.get(0),"flipPosition"]);this.props.flipItem({active:this.props.selectedItems.get(0),flipPosition:flipValue>=3?0:flipValue+1,selectedScene:this.props.selectedScene},this.props.socket);}}else{var nextBtn=document.querySelector('.next_step');var breakFlow=false;switch(icon){case"effect":this.props.setPropertyWindow({component:"settings",type:this.props.selectedObjects.first().get("type"),subWindow:"enter",isOpened:true});break;case"flip":if(this.props.selectedItems.size===1&&(this.props.selectedObjects.getIn([this.props.selectedItems.get(0),"type"])!=="TEXT"||this.props.selectedObjects.getIn([this.props.selectedItems.get(0),"subType"])==="CALLOUT")){var flipValue=this.props.selectedObjects.getIn([this.props.selectedItems.get(0),"flipPosition"]);this.props.flipItem({active:this.props.selectedItems.get(0),flipPosition:flipValue>=3?0:flipValue+1,selectedScene:this.props.selectedScene},this.props.socket);}break;case"delete":if(this.props.selectedItems.size>0){this.props.deleteItem({selectedItems:this.props.selectedItems.toArray(),selectedScene:this.props.selectedScene},this.props.socket);this.props.suggestionPopup({show:false,type:'',subType:''});}break;case"swap":if(this.props.selectedItems.size===1){this.props.selectedObjects.map(function(data){if(data.get('isBlob')){breakFlow=true;}});if(breakFlow){this.props.manageToast({action:"add",type:"error","message":"br.sw",formatId:"msg"});return;}var currentItem=this.props.selectedObjects.get(this.props.selectedItems.get(0));var swapProp=currentItem.toJS();var itemText=null;if(currentItem.get("type")==="TEXT"){this.props.updateTextStatus({id:null,isSelected:false,isFocused:false,container:null,isRTL:false,isGrouped:false});var text=document.getElementById(this.props.selectedItems.get(0)).getElementsByClassName("text-container")[0].innerHTML;itemText=currentItem.get("textData");itemText=itemText.setIn("htmlText",text);}document.getElementsByClassName('app-lib-container')[0].style.zIndex=11;var swapObject={id:this.props.selectedItems.get(0),type:currentItem.get("type"),subType:currentItem.get("subType"),x:currentItem.get("x"),y:currentItem.get("y"),width:currentItem.get("width"),height:currentItem.get("height"),angle:currentItem.get("angle"),enterStart:currentItem.get("enterStart"),enterEnd:currentItem.get("enterEnd"),enterEffectName:currentItem.get("enterEffectName"),flipPosition:currentItem.get("flipPosition"),filter:currentItem.get("filter"),index:currentItem.get("index"),text:itemText,voiceOver:currentItem.get("voiceOver"),orbit:currentItem.get("orbit"),opacity:currentItem.get("opacity"),animType:currentItem.get("animType"),animIndex:currentItem.get("animIndex")};if(currentItem.get("type")==="CHR"){swapObject.parts=currentItem.get("parts");swapObject.colors=currentItem.get("colors");swapObject.animdata=currentItem.get("animdata");swapObject.defaultColor=currentItem.get("defaultColor");swapObject.expression=currentItem.get("expression");swapObject.genderType=currentItem.get("genderType");swapObject.pose=currentItem.get("pose");swapObject.src=currentItem.get("src");swapObject.expFlag=currentItem.get("expFlag");swapObject.mouthAction=currentItem.get("mouthAction");}swapProp.emptySwap=true;swapProp.selectedScene=this.props.selectedScene;swapProp.item_id=this.props.selectedItems.get(0);swapProp.undoSwap=true;if(['CHR','CCHR'].indexOf(currentItem.get('subType'))!==-1){swapProp.checkAudio=[];swapProp['voiceOverData']=[];}this.props.swapItemUndo(swapProp);this.props.swapItem(swapObject);if(nextBtn){this.props.nextBtnClicked(true);nextBtn.classList.remove('disable');nextBtn.click();}}break;case"swap-active":this.props.swapItem("");break;case"group":if(this.props.selectedItems.size>1){if(this.props.selectedObjects.find(function(x){return x.get("type")==="GROUP";})===undefined){if(this.props.selectedItems.size>0){var selectedObjects=this.props.selectedObjects;var maxItem=selectedObjects.maxBy(function(x){return x.get("index");});var minAnimIndex=selectedObjects.minBy(function(x){return x.get('animIndex');});selectedObjects.entrySeq().forEach(function(_ref3){var _ref4=_slicedToArray(_ref3,2),key=_ref4[0],item=_ref4[1];if(item.get("type")==="TEXT"||item.get("type")==="SHAPE"){selectedObjects=selectedObjects.set(key,item.setIn(["textData","formats","others","isFixedWidth"],true));}});var bounds=Object(__WEBPACK_IMPORTED_MODULE_2__reducers_project__["b" /* getObjectsBounds */])(selectedObjects);selectedObjects=selectedObjects.sortBy(function(value,key){return value.get("index");}).toOrderedMap();var uniqueId=Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString();var enterStart=selectedObjects.minBy(function(x){return x.get("enterStart");}).get("enterStart"),exitEnd=selectedObjects.maxBy(function(x){return x.get("exitEnd");}).get("exitEnd");var enterEnd=0,exitStart=0,enterEffectName="no_Effect",exitEffectName="no_Effect";if(exitEnd-enterStart<=1&&exitEnd>=2)enterStart=exitEnd-2;if(enterStart===exitEnd)enterStart=0;var workspaceItems=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({});workspaceItems=workspaceItems.set(uniqueId,Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({"index":maxItem.get('index'),"animIndex":minAnimIndex.get('animIndex'),"width":bounds.width,"height":bounds.height,"x":bounds.x,"y":bounds.y,"angle":0,"type":"GROUP","flipPosition":0,"opacity":1,"groupChildren":selectedObjects.keySeq().toArray(),"enterStart":enterStart,"enterEffectName":enterEffectName,"exitStart":exitStart,"enterEnd":enterEnd,"animType":'On Load'}));}if(nextBtn){this.props.nextBtnClicked(true);nextBtn.classList.remove('disable');nextBtn.click();}var workspaceItemsAnimIndexOrder={};var count=0;var workspaceItemsCopy=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({workspaceItems:this.props.workspaceItems}).sortBy(function(item){return item.get('animIndex');});var getAllItems=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(this.props.selectedItems).reduce(function(map,key){return map.delete(key);},workspaceItemsCopy.get("workspaceItems"));workspaceItemsCopy=workspaceItemsCopy.setIn(["scenes",this.props.selectedScene,"workspaceItems"],getAllItems);workspaceItemsCopy=workspaceItemsCopy.setIn(["scenes",this.props.selectedScene,"workspaceItems"],workspaceItemsCopy.getIn(["scenes",this.props.selectedScene,"workspaceItems"]).merge(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(workspaceItems)));workspaceItemsCopy.getIn(['scenes',this.props.selectedScene,'workspaceItems']).sortBy(function(item){return item.get('animIndex');}).entrySeq().forEach(function(_ref5){var _ref6=_slicedToArray(_ref5,2),key=_ref6[0],item=_ref6[1];workspaceItemsAnimIndexOrder[key]=count;count++;});this.props.groupObjects({selectedScene:this.props.selectedScene,selectedItems:this.props.selectedItems,workspaceItems:workspaceItems,workspaceChildren:selectedObjects,workspaceItemsOrder:workspaceItemsAnimIndexOrder},this.props.socket);}else{this.props.manageToast({action:"add",type:"error","message":"c.n.g",formatId:"msg"});}}break;case"ungroup":if(this.props.selectedItems.size===1){var parentItem=this.props.selectedObjects.get(this.props.selectedItems.get(0));var parentIndex=parentItem.get("index");var childIds=parentItem.get("groupChildren");if(childIds&&childIds.count()>0){var children=this.props.workspaceChildren.filter(function(obj,key){return childIds.keyOf(key)!==undefined;});var indexToUpdate=parentIndex-children.size+1;if(this.props.textStatus.get("isFocused")===true&&children.has(this.props.textStatus.get("id"))){children=children.setIn([this.props.textStatus.get("id"),"textData","htmlText"],document.getElementById(this.props.textStatus.get("id")).getElementsByClassName("text-container")[0].innerHTML);}childIds.entrySeq().forEach(function(_ref7){var _ref8=_slicedToArray(_ref7,2),index=_ref8[0],key=_ref8[1];var item=children.get(key);var itemX=item.get("xRatio")&&item.get("xRatio")!==null?parentItem.get("x")+item.get("xRatio")*parentItem.get("width")/100:item.get("x"),itemY=item.get("yRatio")&&item.get("yRatio")!==null?parentItem.get("y")+item.get("yRatio")*parentItem.get("height")/100:item.get("y"),itemWidth=item.get("widthRatio")&&item.get("widthRatio")!==null?item.get("widthRatio")*parentItem.get("width")/100:item.get("width"),itemHeight=item.get("heightRatio")&&item.get("heightRatio")!==null?item.get("heightRatio")*parentItem.get("height")/100:item.get("height");if(item.get("type")==="SHAPE"||item.get("type")==="TEXT"){itemX=item.get("x");itemY=item.get("y");itemWidth=item.get("width");itemHeight=item.get("height");if(parentItem.get("subType")==="TXTGRP"){itemWidth+=_this3.props.textOffset;itemHeight+=_this3.props.textOffset;children=children.setIn([key,"textData","formats","containerStyle","margin"],_this3.props.textOffset/2+"px");children=children.setIn([key,"width"],itemWidth).setIn([key,"height"],itemHeight);}}var pcx=parentItem.get("x")+parentItem.get("width")/2,pcy=parentItem.get("y")+parentItem.get("height")/2;var icx=itemX+itemWidth/2,icy=itemY+itemHeight/2;var angleS=Math.atan2(icy-pcy,icx-pcx)*(180/Math.PI);var dist=Math.sqrt(Math.pow(pcx-icx,2)+Math.pow(pcy-icy,2));itemX=Math.cos((angleS+parentItem.get("angle"))*Math.PI/180)*Math.abs(dist)+pcx-item.get("width")/2;itemY=Math.sin((angleS+parentItem.get("angle"))*Math.PI/180)*Math.abs(dist)+pcy-item.get("height")/2;var item_angle=parentItem.get("angle")+item.get("angle");children=children.setIn([key,"x"],itemX).setIn([key,"y"],itemY).setIn([key,"angle"],item_angle).setIn([key,"index"],indexToUpdate);indexToUpdate++;});var selectedScene=this.props.selectedScene;var _workspaceItemsAnimIndexOrder={};var _count=0;var _workspaceItemsCopy=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({workspaceItems:this.props.workspaceItems}).sortBy(function(item){return item.get('animIndex');});var childIdstep=this.props.projectData.getIn(["scenes",selectedScene,"workspaceItems",this.props.selectedItems.first(),"groupChildren"]);var _getAllItems=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(this.props.selectedItems).reduce(function(map,key){return map.delete(key);},_workspaceItemsCopy.get("workspaceItems"));_workspaceItemsCopy=_workspaceItemsCopy.setIn(["scenes",selectedScene,"workspaceItems"],_getAllItems);var unGroupedItems=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(children);_workspaceItemsCopy=_workspaceItemsCopy.setIn(["scenes",selectedScene,"playHeadValue"],unGroupedItems.maxBy(function(x){return x.get("enterStart");}).get("enterStart"));var allWorkspaceItems=_workspaceItemsCopy.getIn(["scenes",selectedScene,"workspaceItems"]).merge(unGroupedItems);var allChildren=childIdstep.toArray().reduce(function(map,key){return map.delete(key);},this.props.projectData.getIn(["scenes",selectedScene,"workspaceChildren"]));allWorkspaceItems=allWorkspaceItems.sortBy(function(value,key){return value.get("index");});_workspaceItemsCopy=_workspaceItemsCopy.setIn(["scenes",selectedScene,"workspaceItems"],allWorkspaceItems).setIn(["scenes",selectedScene,"workspaceChildren"],allChildren);_workspaceItemsCopy.getIn(['scenes',this.props.selectedScene,'workspaceItems']).sortBy(function(item){return item.get('animIndex');}).entrySeq().forEach(function(_ref9){var _ref10=_slicedToArray(_ref9,2),key=_ref10[0],item=_ref10[1];_workspaceItemsAnimIndexOrder[key]=_count;_count++;});this.props.unGroupObjects({selectedScene:this.props.selectedScene,selectedItems:this.props.selectedItems,workspaceChildren:children,workspaceItems:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(this.props.selectedObjects.toJS()),workspaceItemsOrder:_workspaceItemsAnimIndexOrder},this.props.socket);}if(nextBtn){this.props.nextBtnClicked(true);nextBtn.classList.remove('disable');nextBtn.click();}}else{if(nextBtn){this.props.nextBtnClicked(true);nextBtn.classList.remove('disable');nextBtn.click();}}break;case"action":this.props.setPropertyWindow({component:"action"});if(nextBtn){this.props.nextBtnClicked(true);nextBtn.classList.remove('disable');nextBtn.click();}break;case"filter":this.props.setPropertyWindow({component:"filterSetting"});break;case"color":this.props.setPropertyWindow({component:"color"});if(nextBtn){this.props.nextBtnClicked(true);nextBtn.classList.remove('disable');nextBtn.click();}break;case"settings-active":this.props.setPropertyWindow({component:"",type:"",isOpened:false});if(nextBtn){this.props.nextBtnClicked(true);nextBtn.classList.remove('disable');nextBtn.click();}break;case"settings":this.props.setPropertyWindow({component:"settings",type:this.props.selectedObjects.first().get("type"),isOpened:true});if(nextBtn){this.props.nextBtnClicked(true);nextBtn.classList.remove('disable');nextBtn.click();}break;case"crop":this.props.toggleCrop();break;case"set-bg":var selectedItem=this.props.selectedObjects.get(this.props.selectedItems.get(0)),subType=void 0;var bgType=selectedItem.get("type");if(bgType!=="STOCKIMG"&&bgType!=='IMG'&&selectedItem.get("subType")!==undefined&&selectedItem.get("subType")!==""&&selectedItem.get("subType")!==null)bgType=selectedItem.get("subType");if(bgType==="STOCKIMG"||bgType==='IMG')subType=selectedItem.get("subType");if(selectedItem.get("subType")==="GIPHY")bgType=selectedItem.get("subType");var bgFilter="",isBlob=false;if(selectedItem.get("filter")!==undefined&&selectedItem.get("filter")!=="")bgFilter=selectedItem.get("filter");if(selectedItem.get('isBlob')){isBlob=true;}var color=[],defaultColor='';if(selectedItem.get('type')==='UPLOADS'&&selectedItem.get('sourceType').includes('svg')&&selectedItem.get('colors')&&selectedItem.get('colors').size){color=selectedItem.get('colors');defaultColor=selectedItem.get('defaultColor');}this.props.changeBg({selectedScene:this.props.selectedScene,selectedItems:this.props.selectedItems,isBlob:isBlob,assetId:selectedItem.get("assetId"),stockId:selectedItem.get("assetId"),bgType:bgType,subType:subType,sourceType:selectedItem.get("sourceType"),bgHeight:document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("img")[0].naturalHeight,bgWidth:document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("img")[0].naturalWidth,source:selectedItem.get("src"),thumb:selectedItem.get("thumb"),color:color,defaultColor:defaultColor,isCustomBg:true,bgFilter:bgFilter,flipPosition:selectedItem.get("flipPosition")},this.props.socket);break;default:break;}}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_5__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"ItemToolbar-handleClick");}}},{key:'toggleToolBar',value:function toggleToolBar(e){try{this.props.toggleToolBar();}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_5__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"ItemToolbar-toggleToolBar");}}},{key:'changeImgSrc',value:function changeImgSrc(e,src){try{e.currentTarget.src=src;}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_5__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"ItemToolbar-changeImgSrc");}}},{key:'render',value:function render(){var _this5=this;var iconsList=[];this.state.icons.map(function(icon,index){var _this4=this;var selectedItem=this.props.selectedObjects.get(this.props.selectedItems.get(0));if(selectedItem&&selectedItem.get('subType')==='ECHR'&&['lipsync'].indexOf(icon)!==-1){return;}iconsList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:index+"a"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,onMouseMove:function onMouseMove(e){var toolTip=document.querySelector('.wrkspc_'+icon+'Item_tool_tip');var toolItem=document.querySelector('.item-tool.'+icon);var pageX=e.pageX,pageY=e.pageY;if(toolItem){if(toolTip){var toolContainer=document.querySelector('.item-tool-container'),toolContPos=toolContainer.getBoundingClientRect();toolTip.style.display='';toolTip.style.top=pageY-toolContPos.top-5+'px';toolTip.style.left=pageX-toolContPos.left+15+'px';}}},onMouseLeave:function onMouseLeave(e){var toolTip=document.querySelector('.wrkspc_'+icon+'Item_tool_tip');if(toolTip){toolTip.style.display='none';}},className:"item-tool "+icon+(''+(icon.includes('flip')?' flip':''))+(''+(this.flipClicked&&icon.includes('flip')?' highlighted_node':'')),onClick:function onClick(e){_this4.handleClick(e,icon);var toolTip=document.querySelector('.wrkspc_'+icon+'Item_tool_tip');if(toolTip){toolTip.style.display='none';}}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"ws."+(icon.includes('-')&&(icon.includes('flip')||icon.includes('settings'))?icon.split('-')[0]:icon)+".t.t",children:function children(val){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"item_tools_tooltip wrkspc_"+icon+"Item_tool_tip",style:{'display':'none'}},val);}})));}.bind(this));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-html2canvas-ignore':'true',ref:function ref(instance){return _this5.toolBar=instance;},className:"item-tool-bar "+this.state.type+" "+this.state.column+(iconsList.length===0?" padding-none":"")},iconsList.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-tool-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,iconsList)):null,this.state.canExpand?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:function onClick(e){_this5.toggleToolBar(e);var nextBtn=document.querySelector('.next_step');if(nextBtn){_this5.props.nextBtnClicked(true);nextBtn.classList.remove('disable');nextBtn.click();}},className:'item-tool-toggle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:this.state.isExpanded?{transform:"rotate(180deg)"}:{},onMouseEnter:function onMouseEnter(e){return _this5.changeImgSrc(e,_this5.appUrl+"/images/item-tools/toggle-hover.svg");},onMouseLeave:function onMouseLeave(e){return _this5.changeImgSrc(e,_this5.appUrl+"/images/item-tools/toggle.svg");},src:this.appUrl+"/images/item-tools/toggle.svg",alt:'Toggle'})):null);}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(props,state){var toReturn=null;if(props.selectedItems!==state.prevSelectedItems||props.propertyWindow!==state.prevPropertyWindow||props.textStatus!==state.textStatus||!props.transformStatus.get("transfroming")||props.isToolBarExpanded!==state.isPrevExpanded){var icons=[];toReturn={selectedItems:props.selectedItems,prevSelectedItems:state.selectedItems,propertyWindow:props.propertyWindow,prevPropertyWindow:state.propertyWindow,textStatus:props.textStatus,prevTextStatus:state.textStatus,isExpanded:props.isToolBarExpanded,isPrevExpanded:state.isExpanded,transformStatus:props.transformStatus,prevTransformStatus:state.transformStatus};toReturn.column="two";if(props.selectedObjects.size>1){icons=[];if(props.selectedObjects.find(function(x){return x.get("type")==="GROUP";})===undefined){icons.push("group");}icons.push("delete");}else if(props.selectedObjects.size===1){if(props.selectedObjects.first().get("type")==="GROUP"){icons=["ungroup"];if(props.workspaceChildren.filter(function(obj,key){return props.selectedObjects.first().get("groupChildren").indexOf(key)!==-1;}).some(function(v){return v.get("type")==="TEXT"||v.get("type")==="SHAPE"||v.get("type")==="PROP";}))icons.push("color");}else if(props.selectedObjects.first().get("type")==="TEXT"){icons=["effect"];}else if(props.selectedObjects.first().get("type")==="CHR"){icons=["action","color","effect","swap","flip-"+props.selectedObjects.first().get("flipPosition")];}else if(props.selectedObjects.first().get("type")==="PROP"||props.selectedObjects.first().get("type")==="SHAPE"){icons=["effect","swap","flip-"+props.selectedObjects.first().get("flipPosition")];}else if(props.selectedObjects.first().get("type")==="IMG"||props.selectedObjects.first().get("type")==="STOCKIMG"||props.selectedObjects.first().get("type")==="UPLOADS"){icons=["filter","swap","flip-"+props.selectedObjects.first().get("flipPosition")];if(props.selectedObjects.first().get("type")==="IMG"||props.selectedObjects.first().get("type")==="STOCKIMG"||props.selectedObjects.first().get("subType")==="UPIMAGE"&&props.selectedObjects.first().get("sourceType")!=="svg")icons=["crop","filter","swap","flip-"+props.selectedObjects.first().get("flipPosition"),"set-bg"];else icons=["effect","filter","swap","flip-"+props.selectedObjects.first().get("flipPosition")];if(props.selectedObjects.first().get("sourceType")==="svg"){var mIndex=icons.indexOf("filter");if(mIndex!==-1){icons.splice(mIndex,1);}}}if(props.propertyWindow.get("component")==="settings")icons.push("settings-active");else icons.push("settings");icons.push("delete");}if(icons.indexOf("swap")!==-1&&props.swapDetails!==null){icons.splice(icons.indexOf("swap"),1,"swap-active");}var mIndex;if(icons.length<=6)toReturn.canExpand=false;else if(!state.canExpand)toReturn.canExpand=true;if(!props.isToolBarExpanded&&icons.length>6)icons.length=6;toReturn.icons=icons;if(icons.length<4)toReturn.column="one";}return toReturn;}}]);return ItemToolBar;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ItemToolBar);

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormatDateTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PartitionDateTimePattern__ = __webpack_require__(93);

/**
 * https://tc39.es/ecma402/#sec-formatdatetime
 * @param dtf DateTimeFormat
 * @param x
 */
function FormatDateTime(dtf, x, implDetails) {
    var parts = Object(__WEBPACK_IMPORTED_MODULE_0__PartitionDateTimePattern__["a" /* PartitionDateTimePattern */])(dtf, x, implDetails);
    var result = '';
    for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
        var part = parts_1[_i];
        result += part.value;
    }
    return result;
}


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormatDateTimeRange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PartitionDateTimeRangePattern__ = __webpack_require__(165);

function FormatDateTimeRange(dtf, x, y, implDetails) {
    var parts = Object(__WEBPACK_IMPORTED_MODULE_0__PartitionDateTimeRangePattern__["a" /* PartitionDateTimeRangePattern */])(dtf, x, y, implDetails);
    var result = '';
    for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
        var part = parts_1[_i];
        result += part.value;
    }
    return result;
}


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormatDateTimeRangeToParts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PartitionDateTimeRangePattern__ = __webpack_require__(165);

function FormatDateTimeRangeToParts(dtf, x, y, implDetails) {
    var parts = Object(__WEBPACK_IMPORTED_MODULE_0__PartitionDateTimeRangePattern__["a" /* PartitionDateTimeRangePattern */])(dtf, x, y, implDetails);
    var result = new Array(0);
    for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
        var part = parts_1[_i];
        result.push({
            type: part.type,
            value: part.value,
            source: part.source,
        });
    }
    return result;
}


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormatDateTimeToParts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PartitionDateTimePattern__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__262__ = __webpack_require__(6);


/**
 * https://tc39.es/ecma402/#sec-formatdatetimetoparts
 *
 * @param dtf
 * @param x
 * @param implDetails
 */
function FormatDateTimeToParts(dtf, x, implDetails) {
    var parts = Object(__WEBPACK_IMPORTED_MODULE_0__PartitionDateTimePattern__["a" /* PartitionDateTimePattern */])(dtf, x, implDetails);
    var result = Object(__WEBPACK_IMPORTED_MODULE_1__262__["a" /* ArrayCreate */])(0);
    for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
        var part = parts_1[_i];
        result.push({
            type: part.type,
            value: part.value,
        });
    }
    return result;
}


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InitializeDateTimeFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CanonicalizeLocaleList__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ToDateTimeOptions__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GetOption__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResolveLocale__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IsValidTimeZoneName__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CanonicalizeTimeZoneName__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BasicFormatMatcher__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BestFitFormatMatcher__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DateTimeStyleFormat__ = __webpack_require__(162);











function isTimeRelated(opt) {
    for (var _i = 0, _a = ['hour', 'minute', 'second']; _i < _a.length; _i++) {
        var prop = _a[_i];
        var value = opt[prop];
        if (value !== undefined) {
            return true;
        }
    }
    return false;
}
function resolveHourCycle(hc, hcDefault, hour12) {
    if (hc == null) {
        hc = hcDefault;
    }
    if (hour12 !== undefined) {
        if (hour12) {
            if (hcDefault === 'h11' || hcDefault === 'h23') {
                hc = 'h11';
            }
            else {
                hc = 'h12';
            }
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_8__utils__["c" /* invariant */])(!hour12, 'hour12 must not be set');
            if (hcDefault === 'h11' || hcDefault === 'h23') {
                hc = 'h23';
            }
            else {
                hc = 'h24';
            }
        }
    }
    return hc;
}
var TYPE_REGEX = /^[a-z0-9]{3,8}$/i;
/**
 * https://tc39.es/ecma402/#sec-initializedatetimeformat
 * @param dtf DateTimeFormat
 * @param locales locales
 * @param opts options
 */
function InitializeDateTimeFormat(dtf, locales, opts, _a) {
    var getInternalSlots = _a.getInternalSlots, availableLocales = _a.availableLocales, localeData = _a.localeData, getDefaultLocale = _a.getDefaultLocale, getDefaultTimeZone = _a.getDefaultTimeZone, relevantExtensionKeys = _a.relevantExtensionKeys, tzData = _a.tzData, uppercaseLinks = _a.uppercaseLinks;
    // @ts-ignore
    var requestedLocales = Object(__WEBPACK_IMPORTED_MODULE_0__CanonicalizeLocaleList__["a" /* CanonicalizeLocaleList */])(locales);
    var options = Object(__WEBPACK_IMPORTED_MODULE_1__ToDateTimeOptions__["a" /* ToDateTimeOptions */])(opts, 'any', 'date');
    var opt = Object.create(null);
    var matcher = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'localeMatcher', 'string', ['lookup', 'best fit'], 'best fit');
    opt.localeMatcher = matcher;
    var calendar = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'calendar', 'string', undefined, undefined);
    if (calendar !== undefined && !TYPE_REGEX.test(calendar)) {
        throw new RangeError('Malformed calendar');
    }
    var internalSlots = getInternalSlots(dtf);
    opt.ca = calendar;
    var numberingSystem = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'numberingSystem', 'string', undefined, undefined);
    if (numberingSystem !== undefined && !TYPE_REGEX.test(numberingSystem)) {
        throw new RangeError('Malformed numbering system');
    }
    opt.nu = numberingSystem;
    var hour12 = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'hour12', 'boolean', undefined, undefined);
    var hourCycle = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'hourCycle', 'string', ['h11', 'h12', 'h23', 'h24'], undefined);
    if (hour12 !== undefined) {
        // @ts-ignore
        hourCycle = null;
    }
    opt.hc = hourCycle;
    var r = Object(__WEBPACK_IMPORTED_MODULE_3__ResolveLocale__["a" /* ResolveLocale */])(availableLocales, requestedLocales, opt, relevantExtensionKeys, localeData, getDefaultLocale);
    internalSlots.locale = r.locale;
    calendar = r.ca;
    internalSlots.calendar = calendar;
    internalSlots.hourCycle = r.hc;
    internalSlots.numberingSystem = r.nu;
    var dataLocale = r.dataLocale;
    internalSlots.dataLocale = dataLocale;
    var timeZone = options.timeZone;
    if (timeZone !== undefined) {
        timeZone = String(timeZone);
        if (!Object(__WEBPACK_IMPORTED_MODULE_4__IsValidTimeZoneName__["a" /* IsValidTimeZoneName */])(timeZone, { tzData: tzData, uppercaseLinks: uppercaseLinks })) {
            throw new RangeError('Invalid timeZoneName');
        }
        timeZone = Object(__WEBPACK_IMPORTED_MODULE_5__CanonicalizeTimeZoneName__["a" /* CanonicalizeTimeZoneName */])(timeZone, { tzData: tzData, uppercaseLinks: uppercaseLinks });
    }
    else {
        timeZone = getDefaultTimeZone();
    }
    internalSlots.timeZone = timeZone;
    opt = Object.create(null);
    opt.weekday = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'weekday', 'string', ['narrow', 'short', 'long'], undefined);
    opt.era = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'era', 'string', ['narrow', 'short', 'long'], undefined);
    opt.year = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'year', 'string', ['2-digit', 'numeric'], undefined);
    opt.month = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'month', 'string', ['2-digit', 'numeric', 'narrow', 'short', 'long'], undefined);
    opt.day = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'day', 'string', ['2-digit', 'numeric'], undefined);
    opt.hour = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'hour', 'string', ['2-digit', 'numeric'], undefined);
    opt.minute = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'minute', 'string', ['2-digit', 'numeric'], undefined);
    opt.second = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'second', 'string', ['2-digit', 'numeric'], undefined);
    opt.timeZoneName = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'timeZoneName', 'string', ['short', 'long'], undefined);
    var dataLocaleData = localeData[dataLocale];
    Object(__WEBPACK_IMPORTED_MODULE_8__utils__["c" /* invariant */])(!!dataLocaleData, "Missing locale data for " + dataLocale);
    var formats = dataLocaleData.formats[calendar];
    // UNSPECCED: IMPLEMENTATION DETAILS
    if (!formats) {
        throw new RangeError("Calendar \"" + calendar + "\" is not supported. Try setting \"calendar\" to 1 of the following: " + Object.keys(dataLocaleData.formats).join(', '));
    }
    matcher = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'formatMatcher', 'string', ['basic', 'best fit'], 'best fit');
    var dateStyle = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'dateStyle', 'string', ['full', 'long', 'medium', 'short'], undefined);
    internalSlots.dateStyle = dateStyle;
    var timeStyle = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'timeStyle', 'string', ['full', 'long', 'medium', 'short'], undefined);
    internalSlots.timeStyle = timeStyle;
    var bestFormat;
    if (dateStyle === undefined && timeStyle === undefined) {
        if (matcher === 'basic') {
            bestFormat = Object(__WEBPACK_IMPORTED_MODULE_6__BasicFormatMatcher__["a" /* BasicFormatMatcher */])(opt, formats);
        }
        else {
            // IMPL DETAILS START
            if (isTimeRelated(opt)) {
                var hc = resolveHourCycle(internalSlots.hourCycle, dataLocaleData.hourCycle, hour12);
                opt.hour12 = hc === 'h11' || hc === 'h12';
            }
            // IMPL DETAILS END
            bestFormat = Object(__WEBPACK_IMPORTED_MODULE_7__BestFitFormatMatcher__["a" /* BestFitFormatMatcher */])(opt, formats);
        }
    }
    else {
        for (var _i = 0, DATE_TIME_PROPS_1 = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* DATE_TIME_PROPS */]; _i < DATE_TIME_PROPS_1.length; _i++) {
            var prop = DATE_TIME_PROPS_1[_i];
            var p = opt[prop];
            if (p !== undefined) {
                throw new TypeError("Intl.DateTimeFormat can't set option " + prop + " when " + (dateStyle ? 'dateStyle' : 'timeStyle') + " is used");
            }
        }
        bestFormat = Object(__WEBPACK_IMPORTED_MODULE_10__DateTimeStyleFormat__["a" /* DateTimeStyleFormat */])(dateStyle, timeStyle, dataLocaleData);
    }
    // IMPL DETAIL START
    // For debugging
    internalSlots.format = bestFormat;
    // IMPL DETAIL END
    for (var prop in opt) {
        var p = bestFormat[prop];
        if (p !== undefined) {
            internalSlots[prop] = p;
        }
    }
    var pattern;
    var rangePatterns;
    if (internalSlots.hour !== undefined) {
        var hc = resolveHourCycle(internalSlots.hourCycle, dataLocaleData.hourCycle, hour12);
        internalSlots.hourCycle = hc;
        if (hc === 'h11' || hc === 'h12') {
            pattern = bestFormat.pattern12;
            rangePatterns = bestFormat.rangePatterns12;
        }
        else {
            pattern = bestFormat.pattern;
            rangePatterns = bestFormat.rangePatterns;
        }
    }
    else {
        // @ts-ignore
        internalSlots.hourCycle = undefined;
        pattern = bestFormat.pattern;
        rangePatterns = bestFormat.rangePatterns;
    }
    internalSlots.pattern = pattern;
    internalSlots.rangePatterns = rangePatterns;
    return dtf;
}


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = LookupMatcher;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BestAvailableLocale__ = __webpack_require__(94);


/**
 * https://tc39.es/ecma402/#sec-lookupmatcher
 * @param availableLocales
 * @param requestedLocales
 * @param getDefaultLocale
 */
function LookupMatcher(availableLocales, requestedLocales, getDefaultLocale) {
    var result = { locale: '' };
    for (var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++) {
        var locale = requestedLocales_1[_i];
        var noExtensionLocale = locale.replace(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* UNICODE_EXTENSION_SEQUENCE_REGEX */], '');
        var availableLocale = Object(__WEBPACK_IMPORTED_MODULE_1__BestAvailableLocale__["a" /* BestAvailableLocale */])(availableLocales, noExtensionLocale);
        if (availableLocale) {
            result.locale = availableLocale;
            if (locale !== noExtensionLocale) {
                result.extension = locale.slice(noExtensionLocale.length + 1, locale.length);
            }
            return result;
        }
    }
    result.locale = getDefaultLocale();
    return result;
}


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BestFitMatcher;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BestAvailableLocale__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(4);


/**
 * https://tc39.es/ecma402/#sec-bestfitmatcher
 * @param availableLocales
 * @param requestedLocales
 * @param getDefaultLocale
 */
function BestFitMatcher(availableLocales, requestedLocales, getDefaultLocale) {
    var minimizedAvailableLocaleMap = {};
    var minimizedAvailableLocales = new Set();
    availableLocales.forEach(function (locale) {
        var minimizedLocale = new Intl.Locale(locale)
            .minimize()
            .toString();
        minimizedAvailableLocaleMap[minimizedLocale] = locale;
        minimizedAvailableLocales.add(minimizedLocale);
    });
    var foundLocale;
    for (var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++) {
        var l = requestedLocales_1[_i];
        if (foundLocale) {
            break;
        }
        var noExtensionLocale = l.replace(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* UNICODE_EXTENSION_SEQUENCE_REGEX */], '');
        if (availableLocales.has(noExtensionLocale)) {
            foundLocale = noExtensionLocale;
            break;
        }
        if (minimizedAvailableLocales.has(noExtensionLocale)) {
            foundLocale = minimizedAvailableLocaleMap[noExtensionLocale];
            break;
        }
        var locale = new Intl.Locale(noExtensionLocale);
        var maximizedRequestedLocale = locale.maximize().toString();
        var minimizedRequestedLocale = locale.minimize().toString();
        // Check minimized locale
        if (minimizedAvailableLocales.has(minimizedRequestedLocale)) {
            foundLocale = minimizedAvailableLocaleMap[minimizedRequestedLocale];
            break;
        }
        // Lookup algo on maximized locale
        foundLocale = Object(__WEBPACK_IMPORTED_MODULE_0__BestAvailableLocale__["a" /* BestAvailableLocale */])(minimizedAvailableLocales, maximizedRequestedLocale);
    }
    return {
        locale: foundLocale || getDefaultLocale(),
    };
}


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UnicodeExtensionValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);

/**
 * https://tc39.es/ecma402/#sec-unicodeextensionvalue
 * @param extension
 * @param key
 */
function UnicodeExtensionValue(extension, key) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* invariant */])(key.length === 2, 'key must have 2 elements');
    var size = extension.length;
    var searchValue = "-" + key + "-";
    var pos = extension.indexOf(searchValue);
    if (pos !== -1) {
        var start = pos + 4;
        var end = start;
        var k = start;
        var done = false;
        while (!done) {
            var e = extension.indexOf('-', k);
            var len = void 0;
            if (e === -1) {
                len = size - k;
            }
            else {
                len = e - k;
            }
            if (len === 2) {
                done = true;
            }
            else if (e === -1) {
                end = size;
                done = true;
            }
            else {
                end = e;
                k = e + 1;
            }
        }
        return extension.slice(start, end);
    }
    searchValue = "-" + key;
    pos = extension.indexOf(searchValue);
    if (pos !== -1 && pos + 3 === size) {
        return '';
    }
    return undefined;
}


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CanonicalCodeForDisplayNames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CanonicalizeLocaleList__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IsWellFormedCurrencyCode__ = __webpack_require__(95);



var UNICODE_REGION_SUBTAG_REGEX = /^([a-z]{2}|[0-9]{3})$/i;
var ALPHA_4 = /^[a-z]{4}$/i;
function isUnicodeRegionSubtag(region) {
    return UNICODE_REGION_SUBTAG_REGEX.test(region);
}
function isUnicodeScriptSubtag(script) {
    return ALPHA_4.test(script);
}
function CanonicalCodeForDisplayNames(type, code) {
    if (type === 'language') {
        return Object(__WEBPACK_IMPORTED_MODULE_0__CanonicalizeLocaleList__["a" /* CanonicalizeLocaleList */])([code])[0];
    }
    if (type === 'region') {
        if (!isUnicodeRegionSubtag(code)) {
            throw RangeError('invalid region');
        }
        return code.toUpperCase();
    }
    if (type === 'script') {
        if (!isUnicodeScriptSubtag(code)) {
            throw RangeError('invalid script');
        }
        return "" + code[0].toUpperCase() + code.slice(1);
    }
    Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* invariant */])(type === 'currency', 'invalid type');
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__IsWellFormedCurrencyCode__["a" /* IsWellFormedCurrencyCode */])(code)) {
        throw RangeError('invalid currency');
    }
    return code.toUpperCase();
}


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormatNumericToParts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PartitionNumberPattern__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__262__ = __webpack_require__(6);


function FormatNumericToParts(nf, x, implDetails) {
    var parts = Object(__WEBPACK_IMPORTED_MODULE_0__PartitionNumberPattern__["a" /* PartitionNumberPattern */])(nf, x, implDetails);
    var result = Object(__WEBPACK_IMPORTED_MODULE_1__262__["a" /* ArrayCreate */])(0);
    for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
        var part = parts_1[_i];
        result.push({
            type: part.type,
            value: part.value,
        });
    }
    return result;
}


/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports = {"adlm":["𞥐","𞥑","𞥒","𞥓","𞥔","𞥕","𞥖","𞥗","𞥘","𞥙"],"ahom":["𑜰","𑜱","𑜲","𑜳","𑜴","𑜵","𑜶","𑜷","𑜸","𑜹"],"arab":["٠","١","٢","٣","٤","٥","٦","٧","٨","٩"],"arabext":["۰","۱","۲","۳","۴","۵","۶","۷","۸","۹"],"bali":["᭐","᭑","᭒","᭓","᭔","᭕","᭖","᭗","᭘","᭙"],"beng":["০","১","২","৩","৪","৫","৬","৭","৮","৯"],"bhks":["𑱐","𑱑","𑱒","𑱓","𑱔","𑱕","𑱖","𑱗","𑱘","𑱙"],"brah":["𑁦","𑁧","𑁨","𑁩","𑁪","𑁫","𑁬","𑁭","𑁮","𑁯"],"cakm":["𑄶","𑄷","𑄸","𑄹","𑄺","𑄻","𑄼","𑄽","𑄾","𑄿"],"cham":["꩐","꩑","꩒","꩓","꩔","꩕","꩖","꩗","꩘","꩙"],"deva":["०","१","२","३","४","५","६","७","८","९"],"diak":["𑥐","𑥑","𑥒","𑥓","𑥔","𑥕","𑥖","𑥗","𑥘","𑥙"],"fullwide":["０","１","２","３","４","５","６","７","８","９"],"gong":["𑶠","𑶡","𑶢","𑶣","𑶤","𑶥","𑶦","𑶧","𑶨","𑶩"],"gonm":["𑵐","𑵑","𑵒","𑵓","𑵔","𑵕","𑵖","𑵗","𑵘","𑵙"],"gujr":["૦","૧","૨","૩","૪","૫","૬","૭","૮","૯"],"guru":["੦","੧","੨","੩","੪","੫","੬","੭","੮","੯"],"hanidec":["〇","一","二","三","四","五","六","七","八","九"],"hmng":["𖭐","𖭑","𖭒","𖭓","𖭔","𖭕","𖭖","𖭗","𖭘","𖭙"],"hmnp":["𞅀","𞅁","𞅂","𞅃","𞅄","𞅅","𞅆","𞅇","𞅈","𞅉"],"java":["꧐","꧑","꧒","꧓","꧔","꧕","꧖","꧗","꧘","꧙"],"kali":["꤀","꤁","꤂","꤃","꤄","꤅","꤆","꤇","꤈","꤉"],"khmr":["០","១","២","៣","៤","៥","៦","៧","៨","៩"],"knda":["೦","೧","೨","೩","೪","೫","೬","೭","೮","೯"],"lana":["᪀","᪁","᪂","᪃","᪄","᪅","᪆","᪇","᪈","᪉"],"lanatham":["᪐","᪑","᪒","᪓","᪔","᪕","᪖","᪗","᪘","᪙"],"laoo":["໐","໑","໒","໓","໔","໕","໖","໗","໘","໙"],"lepc":["᪐","᪑","᪒","᪓","᪔","᪕","᪖","᪗","᪘","᪙"],"limb":["᥆","᥇","᥈","᥉","᥊","᥋","᥌","᥍","᥎","᥏"],"mathbold":["𝟎","𝟏","𝟐","𝟑","𝟒","𝟓","𝟔","𝟕","𝟖","𝟗"],"mathdbl":["𝟘","𝟙","𝟚","𝟛","𝟜","𝟝","𝟞","𝟟","𝟠","𝟡"],"mathmono":["𝟶","𝟷","𝟸","𝟹","𝟺","𝟻","𝟼","𝟽","𝟾","𝟿"],"mathsanb":["𝟬","𝟭","𝟮","𝟯","𝟰","𝟱","𝟲","𝟳","𝟴","𝟵"],"mathsans":["𝟢","𝟣","𝟤","𝟥","𝟦","𝟧","𝟨","𝟩","𝟪","𝟫"],"mlym":["൦","൧","൨","൩","൪","൫","൬","൭","൮","൯"],"modi":["𑙐","𑙑","𑙒","𑙓","𑙔","𑙕","𑙖","𑙗","𑙘","𑙙"],"mong":["᠐","᠑","᠒","᠓","᠔","᠕","᠖","᠗","᠘","᠙"],"mroo":["𖩠","𖩡","𖩢","𖩣","𖩤","𖩥","𖩦","𖩧","𖩨","𖩩"],"mtei":["꯰","꯱","꯲","꯳","꯴","꯵","꯶","꯷","꯸","꯹"],"mymr":["၀","၁","၂","၃","၄","၅","၆","၇","၈","၉"],"mymrshan":["႐","႑","႒","႓","႔","႕","႖","႗","႘","႙"],"mymrtlng":["꧰","꧱","꧲","꧳","꧴","꧵","꧶","꧷","꧸","꧹"],"newa":["𑑐","𑑑","𑑒","𑑓","𑑔","𑑕","𑑖","𑑗","𑑘","𑑙"],"nkoo":["߀","߁","߂","߃","߄","߅","߆","߇","߈","߉"],"olck":["᱐","᱑","᱒","᱓","᱔","᱕","᱖","᱗","᱘","᱙"],"orya":["୦","୧","୨","୩","୪","୫","୬","୭","୮","୯"],"osma":["𐒠","𐒡","𐒢","𐒣","𐒤","𐒥","𐒦","𐒧","𐒨","𐒩"],"rohg":["𐴰","𐴱","𐴲","𐴳","𐴴","𐴵","𐴶","𐴷","𐴸","𐴹"],"saur":["꣐","꣑","꣒","꣓","꣔","꣕","꣖","꣗","꣘","꣙"],"segment":["🯰","🯱","🯲","🯳","🯴","🯵","🯶","🯷","🯸","🯹"],"shrd":["𑇐","𑇑","𑇒","𑇓","𑇔","𑇕","𑇖","𑇗","𑇘","𑇙"],"sind":["𑋰","𑋱","𑋲","𑋳","𑋴","𑋵","𑋶","𑋷","𑋸","𑋹"],"sinh":["෦","෧","෨","෩","෪","෫","෬","෭","෮","෯"],"sora":["𑃰","𑃱","𑃲","𑃳","𑃴","𑃵","𑃶","𑃷","𑃸","𑃹"],"sund":["᮰","᮱","᮲","᮳","᮴","᮵","᮶","᮷","᮸","᮹"],"takr":["𑛀","𑛁","𑛂","𑛃","𑛄","𑛅","𑛆","𑛇","𑛈","𑛉"],"talu":["᧐","᧑","᧒","᧓","᧔","᧕","᧖","᧗","᧘","᧙"],"tamldec":["௦","௧","௨","௩","௪","௫","௬","௭","௮","௯"],"telu":["౦","౧","౨","౩","౪","౫","౬","౭","౮","౯"],"thai":["๐","๑","๒","๓","๔","๕","๖","๗","๘","๙"],"tibt":["༠","༡","༢","༣","༤","༥","༦","༧","༨","༩"],"tirh":["𑓐","𑓑","𑓒","𑓓","𑓔","𑓕","𑓖","𑓗","𑓘","𑓙"],"vaii":["ᘠ","ᘡ","ᘢ","ᘣ","ᘤ","ᘥ","ᘦ","ᘧ","ᘨ","ᘩ"],"wara":["𑣠","𑣡","𑣢","𑣣","𑣤","𑣥","𑣦","𑣧","𑣨","𑣩"],"wcho":["𞋰","𞋱","𞋲","𞋳","𞋴","𞋵","𞋶","𞋷","𞋸","𞋹"]}

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InitializeNumberFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CanonicalizeLocaleList__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__262__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GetOption__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResolveLocale__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SetNumberFormatUnitOptions__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CurrencyDigits__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SetNumberFormatDigitOptions__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(4);








/**
 * https://tc39.es/ecma402/#sec-initializenumberformat
 */
function InitializeNumberFormat(nf, locales, opts, _a) {
    var getInternalSlots = _a.getInternalSlots, localeData = _a.localeData, availableLocales = _a.availableLocales, numberingSystemNames = _a.numberingSystemNames, getDefaultLocale = _a.getDefaultLocale, currencyDigitsData = _a.currencyDigitsData;
    // @ts-ignore
    var requestedLocales = Object(__WEBPACK_IMPORTED_MODULE_0__CanonicalizeLocaleList__["a" /* CanonicalizeLocaleList */])(locales);
    var options = opts === undefined ? Object.create(null) : Object(__WEBPACK_IMPORTED_MODULE_1__262__["k" /* ToObject */])(opts);
    var opt = Object.create(null);
    var matcher = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'localeMatcher', 'string', ['lookup', 'best fit'], 'best fit');
    opt.localeMatcher = matcher;
    var numberingSystem = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'numberingSystem', 'string', undefined, undefined);
    if (numberingSystem !== undefined &&
        numberingSystemNames.indexOf(numberingSystem) < 0) {
        // 8.a. If numberingSystem does not match the Unicode Locale Identifier type nonterminal,
        // throw a RangeError exception.
        throw RangeError("Invalid numberingSystems: " + numberingSystem);
    }
    opt.nu = numberingSystem;
    var r = Object(__WEBPACK_IMPORTED_MODULE_3__ResolveLocale__["a" /* ResolveLocale */])(availableLocales, requestedLocales, opt, 
    // [[RelevantExtensionKeys]] slot, which is a constant
    ['nu'], localeData, getDefaultLocale);
    var dataLocaleData = localeData[r.dataLocale];
    Object(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* invariant */])(!!dataLocaleData, "Missing locale data for " + r.dataLocale);
    var internalSlots = getInternalSlots(nf);
    internalSlots.locale = r.locale;
    internalSlots.dataLocale = r.dataLocale;
    internalSlots.numberingSystem = r.nu;
    internalSlots.dataLocaleData = dataLocaleData;
    Object(__WEBPACK_IMPORTED_MODULE_4__SetNumberFormatUnitOptions__["a" /* SetNumberFormatUnitOptions */])(nf, options, { getInternalSlots: getInternalSlots });
    var style = internalSlots.style;
    var mnfdDefault;
    var mxfdDefault;
    if (style === 'currency') {
        var currency = internalSlots.currency;
        var cDigits = Object(__WEBPACK_IMPORTED_MODULE_5__CurrencyDigits__["a" /* CurrencyDigits */])(currency, { currencyDigitsData: currencyDigitsData });
        mnfdDefault = cDigits;
        mxfdDefault = cDigits;
    }
    else {
        mnfdDefault = 0;
        mxfdDefault = style === 'percent' ? 0 : 3;
    }
    var notation = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'notation', 'string', ['standard', 'scientific', 'engineering', 'compact'], 'standard');
    internalSlots.notation = notation;
    Object(__WEBPACK_IMPORTED_MODULE_6__SetNumberFormatDigitOptions__["a" /* SetNumberFormatDigitOptions */])(internalSlots, options, mnfdDefault, mxfdDefault, notation);
    var compactDisplay = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'compactDisplay', 'string', ['short', 'long'], 'short');
    if (notation === 'compact') {
        internalSlots.compactDisplay = compactDisplay;
    }
    var useGrouping = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'useGrouping', 'boolean', undefined, true);
    internalSlots.useGrouping = useGrouping;
    var signDisplay = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(options, 'signDisplay', 'string', ['auto', 'never', 'always', 'exceptZero'], 'auto');
    internalSlots.signDisplay = signDisplay;
    return nf;
}


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InitializePluralRules */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CanonicalizeLocaleList__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__262__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GetOption__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NumberFormat_SetNumberFormatDigitOptions__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ResolveLocale__ = __webpack_require__(44);





function InitializePluralRules(pl, locales, options, _a) {
    var availableLocales = _a.availableLocales, relevantExtensionKeys = _a.relevantExtensionKeys, localeData = _a.localeData, getDefaultLocale = _a.getDefaultLocale, getInternalSlots = _a.getInternalSlots;
    var requestedLocales = Object(__WEBPACK_IMPORTED_MODULE_0__CanonicalizeLocaleList__["a" /* CanonicalizeLocaleList */])(locales);
    var opt = Object.create(null);
    var opts = options === undefined ? Object.create(null) : Object(__WEBPACK_IMPORTED_MODULE_1__262__["k" /* ToObject */])(options);
    var internalSlots = getInternalSlots(pl);
    internalSlots.initializedPluralRules = true;
    var matcher = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(opts, 'localeMatcher', 'string', ['best fit', 'lookup'], 'best fit');
    opt.localeMatcher = matcher;
    internalSlots.type = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(opts, 'type', 'string', ['cardinal', 'ordinal'], 'cardinal');
    Object(__WEBPACK_IMPORTED_MODULE_3__NumberFormat_SetNumberFormatDigitOptions__["a" /* SetNumberFormatDigitOptions */])(internalSlots, opts, 0, 3, 'standard');
    var r = Object(__WEBPACK_IMPORTED_MODULE_4__ResolveLocale__["a" /* ResolveLocale */])(availableLocales, requestedLocales, opt, relevantExtensionKeys, localeData, getDefaultLocale);
    internalSlots.locale = r.locale;
    return pl;
}


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ResolvePlural */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__262__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NumberFormat_FormatNumericToString__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GetOperands__ = __webpack_require__(179);




/**
 * http://ecma-international.org/ecma-402/7.0/index.html#sec-resolveplural
 * @param pl
 * @param n
 * @param PluralRuleSelect Has to pass in bc it's implementation-specific
 */
function ResolvePlural(pl, n, _a) {
    var getInternalSlots = _a.getInternalSlots, PluralRuleSelect = _a.PluralRuleSelect;
    var internalSlots = getInternalSlots(pl);
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* invariant */])(Object(__WEBPACK_IMPORTED_MODULE_1__262__["m" /* Type */])(internalSlots) === 'Object', 'pl has to be an object');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* invariant */])('initializedPluralRules' in internalSlots, 'pluralrules must be initialized');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* invariant */])(Object(__WEBPACK_IMPORTED_MODULE_1__262__["m" /* Type */])(n) === 'Number', 'n must be a number');
    if (!isFinite(n)) {
        return 'other';
    }
    var locale = internalSlots.locale, type = internalSlots.type;
    var res = Object(__WEBPACK_IMPORTED_MODULE_2__NumberFormat_FormatNumericToString__["a" /* FormatNumericToString */])(internalSlots, n);
    var s = res.formattedString;
    var operands = Object(__WEBPACK_IMPORTED_MODULE_3__GetOperands__["a" /* GetOperands */])(s);
    return PluralRuleSelect(locale, type, n, operands);
}


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormatRelativeTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PartitionRelativeTimePattern__ = __webpack_require__(98);

function FormatRelativeTime(rtf, value, unit, implDetails) {
    var parts = Object(__WEBPACK_IMPORTED_MODULE_0__PartitionRelativeTimePattern__["a" /* PartitionRelativeTimePattern */])(rtf, value, unit, implDetails);
    var result = '';
    for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
        var part = parts_1[_i];
        result += part.value;
    }
    return result;
}


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormatRelativeTimeToParts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PartitionRelativeTimePattern__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__262__ = __webpack_require__(6);


function FormatRelativeTimeToParts(rtf, value, unit, implDetails) {
    var parts = Object(__WEBPACK_IMPORTED_MODULE_0__PartitionRelativeTimePattern__["a" /* PartitionRelativeTimePattern */])(rtf, value, unit, implDetails);
    var result = Object(__WEBPACK_IMPORTED_MODULE_1__262__["a" /* ArrayCreate */])(0);
    for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
        var part = parts_1[_i];
        var o = {
            type: part.type,
            value: part.value,
        };
        if ('unit' in part) {
            o.unit = part.unit;
        }
        result.push(o);
    }
    return result;
}


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InitializeRelativeTimeFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CanonicalizeLocaleList__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__262__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GetOption__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResolveLocale__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(4);





var NUMBERING_SYSTEM_REGEX = /^[a-z0-9]{3,8}(-[a-z0-9]{3,8})*$/i;
function InitializeRelativeTimeFormat(rtf, locales, options, _a) {
    var getInternalSlots = _a.getInternalSlots, availableLocales = _a.availableLocales, relevantExtensionKeys = _a.relevantExtensionKeys, localeData = _a.localeData, getDefaultLocale = _a.getDefaultLocale;
    var internalSlots = getInternalSlots(rtf);
    internalSlots.initializedRelativeTimeFormat = true;
    var requestedLocales = Object(__WEBPACK_IMPORTED_MODULE_0__CanonicalizeLocaleList__["a" /* CanonicalizeLocaleList */])(locales);
    var opt = Object.create(null);
    var opts = options === undefined ? Object.create(null) : Object(__WEBPACK_IMPORTED_MODULE_1__262__["k" /* ToObject */])(options);
    var matcher = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(opts, 'localeMatcher', 'string', ['best fit', 'lookup'], 'best fit');
    opt.localeMatcher = matcher;
    var numberingSystem = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(opts, 'numberingSystem', 'string', undefined, undefined);
    if (numberingSystem !== undefined) {
        if (!NUMBERING_SYSTEM_REGEX.test(numberingSystem)) {
            throw new RangeError("Invalid numbering system " + numberingSystem);
        }
    }
    opt.nu = numberingSystem;
    var r = Object(__WEBPACK_IMPORTED_MODULE_3__ResolveLocale__["a" /* ResolveLocale */])(availableLocales, requestedLocales, opt, relevantExtensionKeys, localeData, getDefaultLocale);
    var locale = r.locale, nu = r.nu;
    internalSlots.locale = locale;
    internalSlots.style = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(opts, 'style', 'string', ['long', 'narrow', 'short'], 'long');
    internalSlots.numeric = Object(__WEBPACK_IMPORTED_MODULE_2__GetOption__["a" /* GetOption */])(opts, 'numeric', 'string', ['always', 'auto'], 'always');
    var fields = localeData[r.dataLocale];
    Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* invariant */])(!!fields, "Missing locale data for " + r.dataLocale);
    internalSlots.fields = fields;
    internalSlots.numberFormat = new Intl.NumberFormat(locales);
    internalSlots.pluralRules = new Intl.PluralRules(locales);
    internalSlots.numberingSystem = nu;
    return rtf;
}


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SupportedLocales */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__262__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GetOption__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LookupSupportedLocales__ = __webpack_require__(362);



/**
 * https://tc39.es/ecma402/#sec-supportedlocales
 * @param availableLocales
 * @param requestedLocales
 * @param options
 */
function SupportedLocales(availableLocales, requestedLocales, options) {
    var matcher = 'best fit';
    if (options !== undefined) {
        options = Object(__WEBPACK_IMPORTED_MODULE_0__262__["k" /* ToObject */])(options);
        matcher = Object(__WEBPACK_IMPORTED_MODULE_1__GetOption__["a" /* GetOption */])(options, 'localeMatcher', 'string', ['lookup', 'best fit'], 'best fit');
    }
    if (matcher === 'best fit') {
        return Object(__WEBPACK_IMPORTED_MODULE_2__LookupSupportedLocales__["a" /* LookupSupportedLocales */])(availableLocales, requestedLocales);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__LookupSupportedLocales__["a" /* LookupSupportedLocales */])(availableLocales, requestedLocales);
}


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = LookupSupportedLocales;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BestAvailableLocale__ = __webpack_require__(94);


/**
 * https://tc39.es/ecma402/#sec-lookupsupportedlocales
 * @param availableLocales
 * @param requestedLocales
 */
function LookupSupportedLocales(availableLocales, requestedLocales) {
    var subset = [];
    for (var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++) {
        var locale = requestedLocales_1[_i];
        var noExtensionLocale = locale.replace(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* UNICODE_EXTENSION_SEQUENCE_REGEX */], '');
        var availableLocale = Object(__WEBPACK_IMPORTED_MODULE_1__BestAvailableLocale__["a" /* BestAvailableLocale */])(availableLocales, noExtensionLocale);
        if (availableLocale) {
            subset.push(availableLocale);
        }
    }
    return subset;
}


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isMissingLocaleDataError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(54);

var MissingLocaleDataError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(MissingLocaleDataError, _super);
    function MissingLocaleDataError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'MISSING_LOCALE_DATA';
        return _this;
    }
    return MissingLocaleDataError;
}(Error));
function isMissingLocaleDataError(e) {
    return e.type === 'MISSING_LOCALE_DATA';
}


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";



/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RangePatternType */
var RangePatternType;
(function (RangePatternType) {
    RangePatternType["startRange"] = "startRange";
    RangePatternType["shared"] = "shared";
    RangePatternType["endRange"] = "endRange";
})(RangePatternType || (RangePatternType = {}));


/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";



/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";



/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";



/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";



/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";



/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseDateTimeSkeleton;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseNumberSkeleton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);

/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function (match) {
        var len = match.length;
        switch (match[0]) {
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = ['numeric', '2-digit'][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) {
                    throw new RangeError('`e..eee` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            case 'c':
                if (len < 4) {
                    throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            // Period
            case 'a': // AM, PM
                result.hour12 = true;
                break;
            case 'b': // am, pm, noon, midnight
            case 'B': // flexible day periods
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = ['numeric', '2-digit'][len - 1];
                break;
            // Second
            case 's':
                result.second = ['numeric', '2-digit'][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z': // 1..3, 4: specific non-location format
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
            case 'O': // 1, 4: miliseconds in day short, long
            case 'v': // 1, 4: generic non-location format
            case 'V': // 1, 2, 3, 4: time zone ID or city
            case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
            case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        }
        // @@@+ case
        else if (g2 === '+') {
            result.minimumSignificantDigits = g1.length;
        }
        // .### case
        else if (g1[0] === '#') {
            result.maximumSignificantDigits = g1.length;
        }
        // .@@## or .@@@ case
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits =
                g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function parseSign(str) {
    switch (str) {
        case 'sign-auto':
            return {
                signDisplay: 'auto',
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting',
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always',
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting',
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero',
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting',
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never',
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering',
        };
        stem = stem.slice(2);
    }
    else if (stem[0] === 'E') {
        result = {
            notation: 'scientific',
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        }
        else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
            throw new Error('Malformed concise eng/scientific notation');
        }
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) {
        return signOpts;
    }
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */
function parseNumberSkeleton(tokens) {
    var result = {};
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        switch (token.stem) {
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'engineering':
                result = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) {
                    throw new RangeError('integer-width stems only accept a single optional option');
                }
                token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
                    if (g1) {
                        result.minimumIntegerDigits = g2.length;
                    }
                    else if (g3 && g4) {
                        throw new Error('We currently do not support maximum integer digits');
                    }
                    else if (g5) {
                        throw new Error('We currently do not support exact integer digits');
                    }
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) {
                throw new RangeError('Fraction-precision stems only accept a single optional option');
            }
            token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') {
                    result.minimumFractionDigits = g1.length;
                }
                // .### case
                else if (g3 && g3[0] === '#') {
                    result.maximumFractionDigits = g3.length;
                }
                // .00## case
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                }
                else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            if (token.options.length) {
                result = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, result), parseSignificantPrecision(token.options[0]));
            }
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) {
            result = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, result), signOpts);
        }
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) {
            result = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, result), conciseScientificAndEngineeringOpts);
        }
    }
    return result;
}


/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeHashtagInPlural;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parser__ = __webpack_require__(101);



var PLURAL_HASHTAG_REGEX = /(^|[^\\])#/g;
/**
 * Whether to convert `#` in plural rule options
 * to `{var, number}`
 * @param el AST Element
 * @param pluralStack current plural stack
 */
function normalizeHashtagInPlural(els) {
    els.forEach(function (el) {
        // If we're encountering a plural el
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__types__["h" /* isPluralElement */])(el) && !Object(__WEBPACK_IMPORTED_MODULE_1__types__["j" /* isSelectElement */])(el)) {
            return;
        }
        // Go down the options and search for # in any literal element
        Object.keys(el.options).forEach(function (id) {
            var _a;
            var opt = el.options[id];
            // If we got a match, we have to split this
            // and inject a NumberElement in the middle
            var matchingLiteralElIndex = -1;
            var literalEl = undefined;
            for (var i = 0; i < opt.value.length; i++) {
                var el_1 = opt.value[i];
                if (Object(__WEBPACK_IMPORTED_MODULE_1__types__["e" /* isLiteralElement */])(el_1) && PLURAL_HASHTAG_REGEX.test(el_1.value)) {
                    matchingLiteralElIndex = i;
                    literalEl = el_1;
                    break;
                }
            }
            if (literalEl) {
                var newValue = literalEl.value.replace(PLURAL_HASHTAG_REGEX, "$1{" + el.value + ", number}");
                var newEls = Object(__WEBPACK_IMPORTED_MODULE_2__parser__["a" /* pegParse */])(newValue);
                (_a = opt.value).splice.apply(_a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spreadArrays */])([matchingLiteralElIndex, 1], newEls));
            }
            normalizeHashtagInPlural(opt.value);
        });
    });
}


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createIntl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__number__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__relativeTime__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dateTime__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plural__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__message__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__list__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__displayName__ = __webpack_require__(189);










function messagesContainAst(messages) {
    var firstMessage = messages
        ? messages[Object.keys(messages)[0]]
        : undefined;
    return typeof firstMessage === 'object' && !!firstMessage;
}
function verifyConfigMessages(config) {
    if (config.defaultRichTextElements &&
        !messagesContainAst(config.messages || {})) {
        console.warn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
    }
}
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */
function createIntl(config, cache) {
    var formatters = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* createFormatters */])(cache);
    var resolvedConfig = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* DEFAULT_INTL_CONFIG */]), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) {
            onError(new __WEBPACK_IMPORTED_MODULE_2__error__["b" /* InvalidConfigError */]("\"locale\" was not configured, using \"" + defaultLocale + "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details"));
        }
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    }
    else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) {
        onError(new __WEBPACK_IMPORTED_MODULE_2__error__["d" /* MissingDataError */]("Missing locale data for locale: \"" + locale + "\" in Intl.NumberFormat. Using default locale: \"" + defaultLocale + "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details"));
    }
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length &&
        onError) {
        onError(new __WEBPACK_IMPORTED_MODULE_2__error__["d" /* MissingDataError */]("Missing locale data for locale: \"" + locale + "\" in Intl.DateTimeFormat. Using default locale: \"" + defaultLocale + "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details"));
    }
    verifyConfigMessages(resolvedConfig);
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, resolvedConfig), { formatters: formatters, formatNumber: __WEBPACK_IMPORTED_MODULE_3__number__["a" /* formatNumber */].bind(null, resolvedConfig, formatters.getNumberFormat), formatNumberToParts: __WEBPACK_IMPORTED_MODULE_3__number__["b" /* formatNumberToParts */].bind(null, resolvedConfig, formatters.getNumberFormat), formatRelativeTime: __WEBPACK_IMPORTED_MODULE_4__relativeTime__["a" /* formatRelativeTime */].bind(null, resolvedConfig, formatters.getRelativeTimeFormat), formatDate: __WEBPACK_IMPORTED_MODULE_5__dateTime__["a" /* formatDate */].bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateToParts: __WEBPACK_IMPORTED_MODULE_5__dateTime__["c" /* formatDateToParts */].bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTime: __WEBPACK_IMPORTED_MODULE_5__dateTime__["d" /* formatTime */].bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateTimeRange: __WEBPACK_IMPORTED_MODULE_5__dateTime__["b" /* formatDateTimeRange */].bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTimeToParts: __WEBPACK_IMPORTED_MODULE_5__dateTime__["e" /* formatTimeToParts */].bind(null, resolvedConfig, formatters.getDateTimeFormat), formatPlural: __WEBPACK_IMPORTED_MODULE_6__plural__["a" /* formatPlural */].bind(null, resolvedConfig, formatters.getPluralRules), formatMessage: __WEBPACK_IMPORTED_MODULE_7__message__["a" /* formatMessage */].bind(null, resolvedConfig, formatters), formatList: __WEBPACK_IMPORTED_MODULE_8__list__["a" /* formatList */].bind(null, resolvedConfig, formatters.getListFormat), formatDisplayName: __WEBPACK_IMPORTED_MODULE_9__displayName__["a" /* formatDisplayName */].bind(null, resolvedConfig, formatters.getDisplayNames), __addMessages: function (messages) {
            var existingMessagesContainAst = messagesContainAst(resolvedConfig.messages);
            var mergingMessagesContainAst = messagesContainAst(messages);
            if (config.onError &&
                ((existingMessagesContainAst && !mergingMessagesContainAst) ||
                    (!existingMessagesContainAst && mergingMessagesContainAst))) {
                config.onError(new __WEBPACK_IMPORTED_MODULE_2__error__["b" /* InvalidConfigError */]("Cannot mix AST & non-AST messages for locale " + resolvedConfig.locale));
            }
            // @ts-expect-error this is fine
            resolvedConfig.messages = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, resolvedConfig.messages), messages);
        } });
}


/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__injectIntl__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(27);



function useIntl() {
    var intl = __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_1__injectIntl__["a" /* Context */]);
    Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* invariantIntlContext */])(intl);
    return intl;
}


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createIntl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__injectIntl__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatjs_intl__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shallow_equal_objects__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shallow_equal_objects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shallow_equal_objects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_messageformat__ = __webpack_require__(29);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */







var shallowEquals = __WEBPACK_IMPORTED_MODULE_5_shallow_equal_objects__["default"] || __WEBPACK_IMPORTED_MODULE_5_shallow_equal_objects__;
function processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements,
    };
}
function assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) {
        return values;
    }
    return Object.keys(values).reduce(function (acc, k) {
        var v = values[k];
        acc[k] = Object(__WEBPACK_IMPORTED_MODULE_6_intl_messageformat__["c" /* isFormatXMLElementFn */])(v)
            ? Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* assignUniqueKeysToParts */])(v)
            : v;
        return acc;
    }, {});
}
var formatMessage = function (config, formatters, descriptor, rawValues) {
    var values = assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = Object(__WEBPACK_IMPORTED_MODULE_4__formatjs_intl__["d" /* formatMessage */])(config, formatters, descriptor, values);
    if (Array.isArray(chunks)) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].toArray(chunks);
    }
    return chunks;
};
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */
var createIntl = function (_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["defaultRichTextElements"]);
    var defaultRichTextElements = assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = Object(__WEBPACK_IMPORTED_MODULE_4__formatjs_intl__["b" /* createIntl */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* DEFAULT_INTL_CONFIG */]), config), { defaultRichTextElements: defaultRichTextElements }), cache);
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, coreIntl), { formatMessage: formatMessage.bind(null, {
            locale: coreIntl.locale,
            timeZone: coreIntl.timeZone,
            formats: coreIntl.formats,
            defaultLocale: coreIntl.defaultLocale,
            defaultFormats: coreIntl.defaultFormats,
            messages: coreIntl.messages,
            onError: coreIntl.onError,
            defaultRichTextElements: defaultRichTextElements,
        }, coreIntl.formatters) });
};
var IntlProvider = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = Object(__WEBPACK_IMPORTED_MODULE_4__formatjs_intl__["c" /* createIntlCache */])();
        _this.state = {
            cache: _this.cache,
            intl: createIntl(processIntlConfig(_this.props), _this.cache),
            prevConfig: processIntlConfig(_this.props),
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function (props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = processIntlConfig(props);
        if (!shallowEquals(prevConfig, config)) {
            return {
                intl: createIntl(config, cache),
                prevConfig: config,
            };
        }
        return null;
    };
    IntlProvider.prototype.render = function () {
        Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* invariantIntlContext */])(this.state.intl);
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__injectIntl__["b" /* Provider */], { value: this.state.intl }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* DEFAULT_INTL_CONFIG */];
    return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (IntlProvider);


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormattedRelativeTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__injectIntl__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatjs_ecma402_abstract__ = __webpack_require__(92);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */




var MINUTE = 60;
var HOUR = 60 * 60;
var DAY = 60 * 60 * 24;
function selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < MINUTE) {
        return 'second';
    }
    if (absValue < HOUR) {
        return 'minute';
    }
    if (absValue < DAY) {
        return 'hour';
    }
    return 'day';
}
function getDurationInSeconds(unit) {
    switch (unit) {
        case 'second':
            return 1;
        case 'minute':
            return MINUTE;
        case 'hour':
            return HOUR;
        default:
            return DAY;
    }
}
function valueToSeconds(value, unit) {
    if (!value) {
        return 0;
    }
    switch (unit) {
        case 'second':
            return value;
        case 'minute':
            return value * MINUTE;
        default:
            return value * HOUR;
    }
}
var INCREMENTABLE_UNITS = ['second', 'minute', 'hour'];
function canIncrement(unit) {
    if (unit === void 0) { unit = 'second'; }
    return INCREMENTABLE_UNITS.includes(unit);
}
var FormattedRelativeTime = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FormattedRelativeTime, _super);
    function FormattedRelativeTime(props) {
        var _this = _super.call(this, props) || this;
        // Public for testing
        _this._updateTimer = null;
        _this.state = {
            prevUnit: _this.props.unit,
            prevValue: _this.props.value,
            currentValueInSeconds: canIncrement(_this.props.unit)
                ? valueToSeconds(_this.props.value, _this.props.unit)
                : 0,
        };
        Object(__WEBPACK_IMPORTED_MODULE_4__formatjs_ecma402_abstract__["a" /* invariant */])(!props.updateIntervalInSeconds ||
            !!(props.updateIntervalInSeconds && canIncrement(props.unit)), 'Cannot schedule update with unit longer than hour');
        return _this;
    }
    FormattedRelativeTime.prototype.scheduleNextUpdate = function (_a, _b) {
        var _this = this;
        var updateIntervalInSeconds = _a.updateIntervalInSeconds, unit = _a.unit;
        var currentValueInSeconds = _b.currentValueInSeconds;
        clearTimeout(this._updateTimer);
        this._updateTimer = null;
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !canIncrement(unit)) {
            return;
        }
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') {
            return;
        }
        var unitDuration = getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds
            ? prevInterestingValueInSeconds - unitDuration
            : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        this._updateTimer = setTimeout(function () {
            return _this.setState({
                currentValueInSeconds: nextInterestingValueInSeconds,
            });
        }, delayInSeconds * 1e3);
    };
    FormattedRelativeTime.prototype.componentDidMount = function () {
        this.scheduleNextUpdate(this.props, this.state);
    };
    FormattedRelativeTime.prototype.componentDidUpdate = function () {
        this.scheduleNextUpdate(this.props, this.state);
    };
    FormattedRelativeTime.prototype.componentWillUnmount = function () {
        clearTimeout(this._updateTimer);
        this._updateTimer = null;
    };
    FormattedRelativeTime.getDerivedStateFromProps = function (props, state) {
        if (props.unit !== state.prevUnit || props.value !== state.prevValue) {
            return {
                prevValue: props.value,
                prevUnit: props.unit,
                currentValueInSeconds: canIncrement(props.unit)
                    ? valueToSeconds(props.value, props.unit)
                    : 0,
            };
        }
        return null;
    };
    FormattedRelativeTime.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__injectIntl__["a" /* Context */].Consumer, null, function (intl) {
            Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* invariantIntlContext */])(intl);
            var formatRelativeTime = intl.formatRelativeTime, Text = intl.textComponent;
            var _a = _this.props, children = _a.children, value = _a.value, unit = _a.unit, updateIntervalInSeconds = _a.updateIntervalInSeconds;
            var currentValueInSeconds = _this.state.currentValueInSeconds;
            var currentValue = value || 0;
            var currentUnit = unit;
            if (canIncrement(unit) &&
                typeof currentValueInSeconds === 'number' &&
                updateIntervalInSeconds) {
                currentUnit = selectUnit(currentValueInSeconds);
                var unitDuration = getDurationInSeconds(currentUnit);
                currentValue = Math.round(currentValueInSeconds / unitDuration);
            }
            var formattedRelativeTime = formatRelativeTime(currentValue, currentUnit, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, _this.props));
            if (typeof children === 'function') {
                return children(formattedRelativeTime);
            }
            if (Text) {
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Text, null, formattedRelativeTime);
            }
            return formattedRelativeTime;
        }));
    };
    FormattedRelativeTime.displayName = 'FormattedRelativeTime';
    FormattedRelativeTime.defaultProps = {
        value: 0,
        unit: 'second',
    };
    return FormattedRelativeTime;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

/* unused harmony default export */ var _unused_webpack_default_export = (FormattedRelativeTime);


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__injectIntl__ = __webpack_require__(22);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */


var FormattedPlural = function (props) {
    var value = props.value, other = props.other, children = props.children, _a = props.intl, formatPlural = _a.formatPlural, Text = _a.textComponent;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === 'function') {
        return children(formattedPlural);
    }
    if (Text) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text, null, formattedPlural);
    }
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
FormattedPlural.defaultProps = {
    type: 'cardinal',
};
FormattedPlural.displayName = 'FormattedPlural';
// Explicitly annotate type here to workaround API extractor's inability to handle `import('./someModule')`
// type annotations when rolling up DTS file.
var FormattedPluralWithIntl = Object(__WEBPACK_IMPORTED_MODULE_1__injectIntl__["c" /* default */])(FormattedPlural);
/* unused harmony default export */ var _unused_webpack_default_export = (FormattedPluralWithIntl);


/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__injectIntl__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shallow_equal_objects__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shallow_equal_objects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shallow_equal_objects__);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */





var shallowEquals = __WEBPACK_IMPORTED_MODULE_4_shallow_equal_objects__["default"] || __WEBPACK_IMPORTED_MODULE_4_shallow_equal_objects__;
var FormattedMessage = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FormattedMessage, _super);
    function FormattedMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormattedMessage.prototype.shouldComponentUpdate = function (nextProps) {
        var _a = this.props, values = _a.values, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["values"]);
        var nextValues = nextProps.values, nextOtherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(nextProps, ["values"]);
        return (!shallowEquals(nextValues, values) ||
            !shallowEquals(otherProps, nextOtherProps));
    };
    FormattedMessage.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__injectIntl__["a" /* Context */].Consumer, null, function (intl) {
            Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* invariantIntlContext */])(intl);
            var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? __WEBPACK_IMPORTED_MODULE_1_react__["Fragment"] : _a;
            var _b = _this.props, id = _b.id, description = _b.description, defaultMessage = _b.defaultMessage, values = _b.values, children = _b.children, _c = _b.tagName, Component = _c === void 0 ? Text : _c;
            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
            var nodes = formatMessage(descriptor, values);
            if (!Array.isArray(nodes)) {
                nodes = [nodes];
            }
            if (typeof children === 'function') {
                return children(nodes);
            }
            if (Component) {
                // Needs to use `createElement()` instead of JSX, otherwise React will
                // warn about a missing `key` prop with rich-text message formatting.
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"].apply(__WEBPACK_IMPORTED_MODULE_1_react__, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spreadArrays */])([Component, null], nodes));
            }
            return nodes;
        }));
    };
    FormattedMessage.displayName = 'FormattedMessage';
    return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (FormattedMessage);


/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__injectIntl__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(27);




var FormattedDateTimeRange = function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__injectIntl__["a" /* Context */].Consumer, null, function (intl) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* invariantIntlContext */])(intl);
    var from = props.from, to = props.to, children = props.children, formatProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(props, ["from", "to", "children"]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === 'function') {
        return children(formattedValue);
    }
    var Text = intl.textComponent || __WEBPACK_IMPORTED_MODULE_1_react__["Fragment"];
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Text, null, formattedValue);
})); };
FormattedDateTimeRange.displayName = 'FormattedDateTimeRange';
/* unused harmony default export */ var _unused_webpack_default_export = (FormattedDateTimeRange);


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PlayerComponent__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_index__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state,ownProps){return{projectData:state.project,localStore:state.localStore,t1:state.localStore.get('t1'),browserName:state.localStore.get("browserName"),playAllThumb:state.localStore.get("audioPlayHead"),playThumb:state.project.getIn(["scenes",state.localStore.get("selectedScene"),"playHeadValue"]),selectedScene:state.localStore.get("selectedScene"),playSceneStartTime:state.project.getIn(["scenes",state.localStore.get("selectedScene"),"startTime"]),isPlay:state.localStore.get('isPlay'),isPlayAll:state.localStore.get('isPlayAll'),playSceneDuration:state.project.getIn(["scenes",state.localStore.get("selectedScene"),"duration"]),userId:ownProps.userId,projectDuration:state.project.get("duration"),autoPlay:state.localStore.get('autoPlay'),zoomFactor:state.localStore.get('zoomFactor')};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{changePlayTime:function changePlayTime(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["F" /* changePlayTime */])(data));},setPlay:function setPlay(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_38" /* setPlay */])(data));},setPlayAll:function setPlayAll(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_39" /* setPlayAll */])(data));},startPlay:function startPlay(data,source,playHead,sceneStart){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_61" /* startPlay */])(data,source,playHead,sceneStart));},addTween:function addTween(data,tweenType){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["n" /* addTween */])(data,tweenType));},nextBtnClicked:function nextBtnClicked(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_14" /* nextBtnClicked */])(data));},addSlideLabelData:function addSlideLabelData(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["m" /* addSlideLabelData */])(data));}};};var Player=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_PlayerComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Player);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap_SplitText__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap_SplitText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap_SplitText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_app_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hls_js__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hls_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hls_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_ErrorLogService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_immutable__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Player=function(_Component){_inherits(Player,_Component);function Player(props){_classCallCheck(this,Player);var _this=_possibleConstructorReturn(this,(Player.__proto__||Object.getPrototypeOf(Player)).call(this,props));_this.videoOnTimeUpdate=function(videoElement,videoDOM,currentSceneStart,volume,list,globalThumb,currentScene){if(videoDOM.play&&videoElement.get("videoEnd")<videoDOM.currentTime){videoDOM.pause();videoDOM.currentTime=0;}};_this.filterWorkspaceItemsAnimate=function(clonedProjectData){var _loop=function _loop(m){var itemsToLoad=Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["OrderedMap"])();var workspaceItems=clonedProjectData.getIn(['scenes',m,'workspaceItems']).sortBy(function(item){return item.get('animIndex');});var workspaceChildren=clonedProjectData.getIn(['scenes',m,'workspaceChildren']).sortBy(function(item){return item.get('animIndex');});workspaceItems.entrySeq().forEach(function(_ref){var _ref2=_slicedToArray(_ref,2),item=_ref2[0],workspaceItem=_ref2[1];if(workspaceItem.get("type")==="GROUP"){if(!(workspaceItem.get("enterEffectName")==="no_Effect"&&workspaceItem.get('animType')==='On Load')){itemsToLoad=itemsToLoad.setIn([item],workspaceItem);itemsToLoad=itemsToLoad.setIn([item,"isChild"],false);}else{workspaceChildren.entrySeq().forEach(function(_ref3){var _ref4=_slicedToArray(_ref3,2),item=_ref4[0],child=_ref4[1];if(workspaceItem.getIn(["groupChildren"]).includes(item)){itemsToLoad=itemsToLoad.setIn([item],child);itemsToLoad=itemsToLoad.setIn([item,"isChild"],true);}});}}else{itemsToLoad=itemsToLoad.setIn([item],workspaceItem);itemsToLoad=itemsToLoad.setIn([item,"isChild"],false);}});var animIndex=0;itemsToLoad.entrySeq().forEach(function(_ref5){var _ref6=_slicedToArray(_ref5,2),item=_ref6[0],workspaceItem=_ref6[1];itemsToLoad=itemsToLoad.setIn([item,'animIndex'],animIndex);animIndex=animIndex+1;});clonedProjectData=clonedProjectData.setIn(['scenes',m,'workspaceItems'],itemsToLoad);};for(var m=0;m<clonedProjectData.getIn(['scenes']).size;m++){_loop(m);}return clonedProjectData;};_this.fetchTransitionTime=function(transEffect){if(transEffect==="NoTransition")return 0;else if(transEffect==="SlideFade"||transEffect==="SlideIrisCircle"||transEffect==="SlideIrisSquare")return 1.1;else if(transEffect==="SlideLeft"||transEffect==="SlideRight"||transEffect==="SlideBottom"||transEffect==="SlideTop")return 0.4;else if(transEffect==="SlideBrightSquare"||transEffect==="WipeLeft"||transEffect==="WipeTop"||transEffect==="WipeRight"||transEffect==="WipeBottom"||transEffect==="SlideStripeLeft"||transEffect==="SlideStripeRight"||transEffect==="SlideStripeBottom"||transEffect==="SlideStripeTop"||transEffect==="SlideCircularReveal"||transEffect==="SlideBlindsVerLeft"||transEffect==="SlideBlindsVerRight"||transEffect==="SlideBlindsHorDown"||transEffect==="SlideBlindsHorUp"||transEffect==="SlideSplitVerticalOut"||transEffect==="SlideSplitHorizontalOut"||transEffect==="SlideSplitVerticalIn"||transEffect==="SlideSplitHorizontalIn"||transEffect==="SlideSplitMoveVer"||transEffect==="SlideSplitMoveHor")return 0.9;else return 1;};_this.addImagePlayerItems=_this.addImagePlayerItems.bind(_this);_this.addTextOverlayItems=_this.addTextOverlayItems.bind(_this);_this.addEffectsToItem=_this.addEffectsToItem.bind(_this);_this.addSceneTransition=_this.addSceneTransition.bind(_this);_this.addMask=_this.addMask.bind(_this);_this.addMaskDOM=_this.addMaskDOM.bind(_this);_this.textWriteEnterHandler=_this.textWriteEnterHandler.bind(_this);_this.isPlaying=false;_this.CancelToken=__WEBPACK_IMPORTED_MODULE_4_axios___default.a.CancelToken;_this.source=_this.CancelToken.source();_this.playPromise=undefined;_this.tweenToHandler=_this.tweenToHandler.bind(_this);_this.tweenfromHandler=_this.tweenfromHandler.bind(_this);_this.tweenFromToHandler=_this.tweenFromToHandler.bind(_this);_this.tweenStaggerHandler=_this.tweenFromToHandler.bind(_this);_this.tweenAddCallbackHandler=_this.tweenAddCallbackHandler.bind(_this);_this.changeVideo=_this.changeVideo.bind(_this);_this.pauseVideo=_this.pauseVideo.bind(_this);_this.assetUrl=__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a["ASSETS"][__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a["ASSETS"]["current"]];_this.appUrl=__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a['APPICONS'][__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a['APPICONS']['current']];return _this;}_createClass(Player,[{key:'tweenToHandler',value:function tweenToHandler(playerDOM,startTime,toVal,time){this.props.addTween({playerDOM:playerDOM,startTime:startTime,toVal:toVal,time:time},"to");}},{key:'tweenfromHandler',value:function tweenfromHandler(playerDOM,startTime,fromVal,time){this.props.addTween({playerDOM:playerDOM,startTime:startTime,fromVal:fromVal,time:time},"from");}},{key:'tweenFromToHandler',value:function tweenFromToHandler(playerDOM,startTime,fromVal,toVal,time){this.props.addTween({playerDOM:playerDOM,startTime:startTime,fromVal:fromVal,toVal:toVal,time:time},"fromTo");}},{key:'tweenStaggerFromToHandler',value:function tweenStaggerFromToHandler(playerDOM,startTime,fromVal,toVal,staggerTime,time){this.props.addTween({playerDOM:playerDOM,startTime:startTime,fromVal:fromVal,toVal:toVal,staggerTime:staggerTime,time:time},"staggerFromTo");}},{key:'tweenStaggerToHandler',value:function tweenStaggerToHandler(playerDOM,startTime,toVal,staggerTime,time){this.props.addTween({playerDOM:playerDOM,startTime:startTime,toVal:toVal,staggerTime:staggerTime,time:time},"staggerTo");}},{key:'tweenStaggerFromHandler',value:function tweenStaggerFromHandler(playerDOM,startTime,fromVal,staggerTime,time,onComplete){this.props.addTween({playerDOM:playerDOM,startTime:startTime,fromVal:fromVal,staggerTime:staggerTime,time:time,onComplete:onComplete},"staggerFrom");}},{key:'tweenSetHandler',value:function tweenSetHandler(duration){this.props.addTween({time:duration},"set");}},{key:'tweenSetPropHandler',value:function tweenSetPropHandler(elem,vals){this.props.addTween({playerDOM:elem,setType:"styles",setVal:vals},"set");}},{key:'tweenAddCallbackHandler',value:function tweenAddCallbackHandler(valArr){this.props.addTween(valArr,"addCallback");}},{key:'addFilter',value:function addFilter(elementId,type){var val=document.getElementById(elementId);if(val!==null){var filter_tag=document.createElementNS('http://www.w3.org/2000/svg',"filter");var myfilter="myfilter_"+elementId;var filter_name="Blurfilter_"+elementId;var blurValue=10;if(type==="remove")blurValue=0;val.setAttributeNS(null,"filter","url(#"+filter_name+")");filter_tag.setAttributeNS(null,"id",filter_name);document.getElementById(elementId).parentElement.appendChild(filter_tag);var Blur=document.createElementNS('http://www.w3.org/2000/svg',"feGaussianBlur");Blur.setAttributeNS(null,"id",myfilter);Blur.setAttributeNS(null,"stdDeviation",blurValue);document.getElementById(filter_name).appendChild(Blur);}}},{key:'removeMask',value:function removeMask(elementId){var mask_name="mymask_"+elementId;var elements=[];var tmpsvg,par;elements=document.querySelectorAll('*[id^="'+mask_name+'"]');for(var cnt=0;cnt<elements.length;cnt++){tmpsvg=document.getElementById(elements[cnt].id);if(tmpsvg!==null){par=tmpsvg.parentNode;par.removeChild(tmpsvg);document.getElementById(elementId).removeAttribute("mask");}}}},{key:'maskExist',value:function maskExist(elementId,type){if(!type)type="";if(document.getElementById("mymask_"+elementId+type))return true;else return false;}},{key:'addMaskDOM',value:function addMaskDOM(domName,idVal,xVal,yVal,widthVal,heightVal,strokeWidthVal){var newDOM=document.createElementNS('http://www.w3.org/2000/svg',domName);newDOM.setAttributeNS(null,"id",idVal);newDOM.setAttributeNS(null,"x",xVal);newDOM.setAttributeNS(null,"y",yVal);newDOM.setAttributeNS(null,"width",widthVal);newDOM.setAttributeNS(null,"height",heightVal);newDOM.setAttributeNS(null,"stroke-width",strokeWidthVal);newDOM.setAttributeNS(null,"fill","beige");newDOM.setAttributeNS(null,"stroke","beige");return newDOM;}},{key:'addSceneTransition',value:function addSceneTransition(slides){for(var j=0;j<slides.size;j++){if(j!==slides.size-1){var thisSlide=document.getElementById("scene"+j);var nextSlide=document.getElementById("scene"+(j+1));// scene Transitions  not playing issue fix
if(j==0){thisSlide.style.opacity=0;this.tweenToHandler(thisSlide,0.01,{opacity:1},0-0.01);}var transitionTime=slides.getIn([j,"startTime"])+slides.getIn([j,"duration"]);var transEffect=slides.getIn([j,"transEffect"]);if(transEffect==="NoTransition"){this.tweenToHandler(thisSlide,0.000001,{autoAlpha:0},transitionTime);this.tweenFromToHandler(nextSlide,0.000001,{autoAlpha:0},{autoAlpha:1},transitionTime);}else if(transEffect==="SlideFade"){this.tweenFromToHandler(thisSlide,1,{autoAlpha:1},{autoAlpha:0},transitionTime);this.tweenFromToHandler(nextSlide,1,{autoAlpha:0},{autoAlpha:1},transitionTime);}else if(transEffect==="SlideLeft"){this.tweenToHandler(thisSlide,0.3,{x:this.projectWidth*this.props.zoomFactor*-1},transitionTime);this.tweenFromToHandler(nextSlide,0.3,{x:this.projectWidth*this.props.zoomFactor},{x:0},transitionTime);}else if(transEffect==="SlideRight"){this.tweenToHandler(thisSlide,0.3,{x:this.projectWidth*this.props.zoomFactor},transitionTime);this.tweenFromToHandler(nextSlide,0.3,{x:this.projectWidth*this.props.zoomFactor*-1},{x:0},transitionTime);}else if(transEffect==="SlideBottom"){this.tweenToHandler(thisSlide,0.3,{y:this.projectHeight*this.props.zoomFactor},transitionTime);this.tweenFromToHandler(nextSlide,0.3,{y:this.projectHeight*this.props.zoomFactor*-1},{y:0},transitionTime);}else if(transEffect==="SlideTop"){this.tweenToHandler(thisSlide,0.3,{y:this.projectHeight*this.props.zoomFactor*-1},transitionTime);this.tweenFromToHandler(nextSlide,0.3,{y:this.projectHeight*this.props.zoomFactor},{y:0},transitionTime);}else if(transEffect==="SlideBrightSquare"){this.brightSquareSlideEnterHandler(thisSlide,0.8,transitionTime);this.tweenToHandler(thisSlide,0.000001,{autoAlpha:0},transitionTime+0.8);}else if(transEffect==="WipeLeft"||transEffect==="WipeTop"||transEffect==="WipeRight"||transEffect==="WipeBottom"){this.wipeExitHandler(thisSlide,0.8,transitionTime,transEffect,0,1,1);this.tweenToHandler(thisSlide,0.000001,{autoAlpha:0},transitionTime+0.8);}else if(transEffect==="SlideStripeLeft"||transEffect==="SlideStripeRight"||transEffect==="SlideStripeBottom"||transEffect==="SlideStripeTop"){this.stripeExitHandler(thisSlide,0,0,0.8,transitionTime,transEffect,1,1);this.tweenToHandler(thisSlide,0.000001,{autoAlpha:0},transitionTime+0.8);}else if(transEffect==="SlideCircularReveal"){this.circularRevealExitHandler(thisSlide,0.8,transEffect,transitionTime,1,1);this.tweenToHandler(thisSlide,0.000001,{autoAlpha:0},transitionTime+0.8);}else if(transEffect==="SlideIrisCircle"){this.irishExitHandler(thisSlide,1,transitionTime,transEffect);this.tweenToHandler(thisSlide,0.000001,{autoAlpha:0},transitionTime+1);}else if(transEffect==="SlideIrisSquare"){this.irishExitHandler(thisSlide,1,transitionTime,transEffect);this.tweenToHandler(thisSlide,0.000001,{autoAlpha:0},transitionTime+1);}else if(transEffect==="SlideBlindsVerLeft"||transEffect==="SlideBlindsVerRight"||transEffect==="SlideBlindsHorDown"||transEffect==="SlideBlindsHorUp"){this.blindsExitHandler(thisSlide,0,0,0.8,transitionTime,transEffect,1,1);this.tweenToHandler(thisSlide,0.000001,{autoAlpha:0},transitionTime+0.8);}else if(transEffect==="SlideSplitVerticalOut"||transEffect==="SlideSplitHorizontalOut"||transEffect==="SlideSplitVerticalIn"||transEffect==="SlideSplitHorizontalIn"||transEffect==="SlideSplitMoveVer"||transEffect==="SlideSplitMoveHor"){this.SceneSplitHandler(thisSlide,0.8,transitionTime,transEffect);this.tweenToHandler(thisSlide,0.000001,{autoAlpha:0},transitionTime+0.8);}else{this.tweenToHandler(thisSlide,0.000001,{autoAlpha:0},transitionTime+0.5);this.tweenFromToHandler(nextSlide,0.000001,{autoAlpha:0},{autoAlpha:1},transitionTime+0.5);}}}}},{key:'brightSquareSlideEnterHandler',value:function brightSquareSlideEnterHandler(innerblock,startTime,enterstart){function onStartTween(blockId){var maskFound=this.maskExist(blockId,"slidesquare");if(!maskFound){this.removeMask(blockId);this.addMask(blockId,"slidesquare");}var mask_rect="#mask_"+innerblock.id+"_rect";__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(mask_rect,{scale:1,transformOrigin:"50% 50%"});__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock,{scale:1,transformOrigin:"50% 50%"});var totalCount=6;for(var count=0;count<totalCount;count++){for(var cnt=0;cnt<totalCount;cnt++){if(this.props.browserName!=="Apple Safari")this.tweenToHandler(mask_rect+count+cnt,startTime,{transformOrigin:"50% 50%",scale:0},enterstart);else this.tweenToHandler(mask_rect+count+cnt,startTime,{transformOrigin:"50% 50%",scale:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+innerblock.id+"square"]},enterstart);}}}this.tweenfromHandler(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id],opacity:1},enterstart);}},{key:'SceneSplitHandler',value:function SceneSplitHandler(innerblock,startTime,enterstart,transEffect){function onStartTween(blockId){var maskFound=this.maskExist(blockId,"split"),type="split";if(!maskFound){this.removeMask(blockId);if(transEffect==="SlideSplitHorizontalOut"||transEffect==="SlideSplitHorizontalIn"||transEffect==="SlideSplitMoveHor")this.addMask(blockId,"splitHor");else if(transEffect==="SlideSplitVerticalOut"||transEffect==="SlideSplitVerticalIn"||transEffect==="SlideSplitMoveVer")this.addMask(blockId,"splitVer");}var mask_rect="#mask_"+blockId+"_rect";var totalCount=2;var firstSplit,SecondSplit;__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(mask_rect,{scale:1,transformOrigin:"50% 50%"});__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock,{scale:1,transformOrigin:"50% 50%"});if(this.props.browserName!=="Apple Safari"){if(transEffect==="SlideSplitVerticalOut"||transEffect==="SlideSplitMoveHor"){firstSplit={x:this.projectWidth*this.props.zoomFactor*-1};SecondSplit={x:this.projectWidth*this.props.zoomFactor};}else if(transEffect==="SlideSplitMoveVer"||transEffect==="SlideSplitHorizontalOut"){firstSplit={y:this.projectHeight*this.props.zoomFactor*-1};SecondSplit={y:this.projectHeight*this.props.zoomFactor};}else if(transEffect==="SlideSplitHorizontalIn"){firstSplit={transformOrigin:"50% 100%",scaleY:0};SecondSplit={transformOrigin:"50% 0%",scaleY:0};}else if(transEffect==="SlideSplitVerticalIn"){firstSplit={transformOrigin:"100% 50%",scaleX:0};SecondSplit={transformOrigin:"0% 50%",scaleX:0};}}else{if(transEffect==="SlideSplitVerticalOut"||transEffect==="SlideSplitMoveHor"){firstSplit={x:this.projectWidth*this.props.zoomFactor*-1,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};SecondSplit={x:this.projectWidth*this.props.zoomFactor,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};}else if(transEffect==="SlideSplitMoveVer"||transEffect==="SlideSplitHorizontalOut"){firstSplit={y:this.projectHeight*this.props.zoomFactor*-1,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};SecondSplit={y:this.projectHeight*this.props.zoomFactor,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};}else if(transEffect==="SlideSplitHorizontalIn"){firstSplit={transformOrigin:"50% 100%",scaleY:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};SecondSplit={transformOrigin:"50% 0%",scaleY:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};}else if(transEffect==="SlideSplitVerticalIn"){firstSplit={transformOrigin:"100% 50%",scaleX:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};SecondSplit={transformOrigin:"0% 50%",scaleX:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};}}for(var count=0;count<totalCount;count++){if(count===0)this.tweenToHandler(mask_rect+count,startTime,firstSplit,enterstart);else this.tweenToHandler(mask_rect+count,startTime,SecondSplit,enterstart);}}this.tweenfromHandler(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id],opacity:1},enterstart);}},{key:'addImagePlayerItems',value:function addImagePlayerItems(nextProps,id,globalStart,enterEffectEnd,exitEfftectStart,isChild,sceneDuration){var svg=document.getElementById(id);var scaleXVal=1,scaleYVal=1;if(nextProps.get("flipPosition")===1)scaleXVal=-1;else if(nextProps.get("flipPosition")===2)scaleYVal=-1;else if(nextProps.get("flipPosition")===3){scaleXVal=-1;scaleYVal=-1;}var correctedWidth=this.projectWidth*this.props.zoomFactor/this.projectWidth*nextProps.get("width");var correctedHeight=this.projectHeight*this.props.zoomFactor/this.projectHeight*nextProps.get("height");var originalPositionX=nextProps.get("x")*(this.projectWidth*this.props.zoomFactor/this.projectWidth);var originalPositionY=nextProps.get("y")*(this.projectHeight*this.props.zoomFactor/this.projectHeight);var opacityVal=nextProps.get("opacity")?nextProps.get("opacity"):1;var currentObj=Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["fromJS"])({enter:nextProps.get("enterEffectName"),enterduration:enterEffectEnd-nextProps.get("enterStart")-0.01,xval:originalPositionX,yval:originalPositionY,width:correctedWidth,height:correctedHeight,rotation:nextProps.get("angle"),scaleX:scaleXVal,scaleY:scaleYVal,opacity:opacityVal});var enterTime=parseFloat(nextProps.get("enterStart")+globalStart);var exitTime=parseFloat(exitEfftectStart+globalStart);var objectEnd=parseFloat(nextProps.get("exitEnd")+globalStart);var innerblock=svg;this.addEffectsToItem(innerblock,currentObj,enterTime,exitTime,objectEnd,isChild);}},{key:'addTextOverlayItems',value:function addTextOverlayItems(nextProps,id,globalStart){var svg=document.getElementById(id);var currentObj=Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["fromJS"])({enter:nextProps.get("enterEffectName"),enterduration:nextProps.get("enterEnd")-nextProps.get("enterStart"),xval:nextProps.get("x"),yval:nextProps.get("y"),width:nextProps.get("width"),height:nextProps.get("height"),rotation:nextProps.get("angle")});var enterTime=parseFloat(nextProps.get("enterStart")+globalStart);var exitTime=parseFloat(nextProps.get("exitStart")+globalStart);var objectEnd=parseFloat(nextProps.get("exitEnd")+globalStart);var innerblock=svg;this.addEffectsToItem(innerblock,currentObj,enterTime,exitTime,objectEnd);}},{key:'addEffectsToItem',value:function addEffectsToItem(playerElement,currentObj,enterTime,exitTime,objectEnd,isChild){if(currentObj.get("enter")==="pixel"||currentObj.get("enter")==="photo"||currentObj.get("enter")==="stripeTopLeft"||currentObj.get("enter")==="stripe_Topright"||currentObj.get("enter")==="stripe_Bottomleft"||currentObj.get("enter")==="stripe_Bottomright"||currentObj.get("enter")==="stripeLeftTop"||currentObj.get("enter")==="stripeRightTop"||currentObj.get("enter")==="stripeLeftBottom"||currentObj.get("enter")==="stripeRightBottom"||currentObj.get("enter")==="verticalSplit"||currentObj.get("enter")==="horizontalSplit"||currentObj.get("enter")==="irishSquare"||currentObj.get("enter")==="irishCircle"||currentObj.get("enter")==="brightSquare"||currentObj.get("enter")==="circularRevealClockwise"||currentObj.get("enter")==="circularRevealAntiClockwise"||currentObj.get("enter")==="circularRevealClockwiseRight"||currentObj.get("enter")==="circularRevealAntiClockwiseRight"||currentObj.get("enter")==="circularRevealClockwiseLeft"||currentObj.get("enter")==="circularRevealAntiClockwiseLeft"||currentObj.get("enter")==="circularRevealClockwiseBottom"||currentObj.get("enter")==="circularRevealAntiClockwiseBottom"||currentObj.get("enter")==="splitRevealFromTopCenter"||currentObj.get("enter")==="splitRevealFromBottomCenter"||currentObj.get("enter")==="splitRevealFromLeftCenter"||currentObj.get("enter")==="splitRevealFromRightCenter"||currentObj.get("enter")==="revealFromLeftBottom"||currentObj.get("enter")==="revealFromLeftTop"||currentObj.get("enter")==="revealFromRightBottom"||currentObj.get("enter")==="revealFromRightTop"||currentObj.get("enter")==="wipeTop"||currentObj.get("enter")==="wipeDown"||currentObj.get("enter")==="wipeRight"||currentObj.get("enter")==="wipeLeft"){__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(playerElement,{opacity:parseFloat(currentObj.get("opacity"))});this.tweenToHandler(playerElement,currentObj.get("enterduration"),{opacity:currentObj.get("opacity")-0.01},enterTime-0.01);}else{__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(playerElement,{opacity:0});if(currentObj.get("enter")!=="fadeIn")this.tweenToHandler(playerElement,0.01,{opacity:currentObj.get("opacity")},enterTime-0.01);}// if (currentObj.get("enter") === "no_Effect")
// {
//   this.tweenToHandler(playerElement, 0.1, { opacity: currentObj.get("opacity")}, enterTime) 
// } else
if(currentObj.get("enter")==="drawSvg")this.t1.add(this.drawSVGHandler(playerElement,currentObj.get("enterduration")),enterTime);else if(currentObj.get("enter")==="fadeIn")this.fadeinHandler(playerElement,currentObj.get("enterduration"),enterTime,currentObj.get("opacity"),isChild);else if(currentObj.get("enter")==="fadeInZoomIn")this.fadeinWithZoom(playerElement,currentObj.get("enterduration"),currentObj.get("scaleX"),currentObj.get("scaleY"),currentObj.get("opacity"),currentObj.get("rotation"),currentObj.get("xval"),currentObj.get("yval"),enterTime,isChild);else if(currentObj.get("enter")==="bigToNormal")this.bigToNormal(playerElement,currentObj.get("enterduration"),enterTime,currentObj.get("scaleX"),currentObj.get("scaleY"),currentObj.get("opacity"),currentObj.get("width"),currentObj.get("height"),currentObj.get("rotation"),isChild);else if(currentObj.get("enter")==="wipeTop"||currentObj.get("enter")==="wipeDown"||currentObj.get("enter")==="wipeRight"||currentObj.get("enter")==="wipeLeft")this.wipeEnterHandler(playerElement,currentObj.get("enterduration"),currentObj.get("enter"),currentObj.get("rotation"),currentObj.get("scaleX"),currentObj.get("scaleY"),enterTime,isChild);else if(currentObj.get("enter")==="rotateZoomInPopupCw"||currentObj.get("enter")==="rotateZoomInPopupCcw")this.rotateZoominPopup(playerElement,currentObj.get("enterduration"),enterTime,currentObj.get("enter"),currentObj.get("rotation"),currentObj.get("scaleX"),currentObj.get("scaleY"),isChild);else if(currentObj.get("enter")==="rotateZoomInCw"||currentObj.get("enter")==="rotateZoomInCcw")this.rotateZoomin(playerElement,currentObj.get("enterduration"),enterTime,currentObj.get("enter"),currentObj.get("rotation"),currentObj.get("scaleX"),currentObj.get("scaleY"),isChild);else if(currentObj.get("enter")==="popup")this.popupHandler(playerElement,currentObj.get("enterduration"),currentObj.get("scaleX"),currentObj.get("scaleY"),enterTime,isChild);else if(currentObj.get("enter")==="popupFromLeft"||currentObj.get("enter")==="popupFromRight"||currentObj.get("enter")==="popupFromTop"||currentObj.get("enter")==="popupFromBottom"||currentObj.get("enter")==="popupFromBottomRight"||currentObj.get("enter")==="popupFromCenter"||currentObj.get("enter")==="popupFromBottomLeft"||currentObj.get("enter")==="popupFromTopLeft"||currentObj.get("enter")==="popupFromTopRight")this.popupTransformHandler(playerElement,currentObj.get("enterduration"),currentObj.get("scaleX"),currentObj.get("scaleY"),enterTime,currentObj.get("enter"),currentObj.get("rotation"),currentObj.get("xval"),currentObj.get("yval"),isChild);else if(currentObj.get("enter")==="pixel")this.pixelEnterHandler(playerElement,currentObj.get("xval"),currentObj.get("yval"),currentObj.get("enterduration"),enterTime,isChild);else if(currentObj.get("enter")==="photo")this.photoEnterHandler(playerElement,currentObj.get("xval"),currentObj.get("yval"),currentObj.get("enterduration"),enterTime,isChild);else if(currentObj.get("enter")==="blindsLeft"||currentObj.get("enter")==="blindsRight"||currentObj.get("enter")==="blindsTop"||currentObj.get("enter")==="blindsBottom")this.blindsEnterHandler(playerElement,currentObj.get("xval"),currentObj.get("yval"),currentObj.get("enterduration"),enterTime,currentObj.get("enter"),currentObj.get("scaleX"),currentObj.get("scaleY"),isChild);else if(currentObj.get("enter")==="scaleTop"||currentObj.get("enter")==="scaleDown"||currentObj.get("enter")==="scaleRight"||currentObj.get("enter")==="scaleLeft")this.scaleEnterHandler(playerElement,currentObj.get("enterduration"),currentObj.get("enter"),currentObj.get("scaleX"),currentObj.get("scaleY"),enterTime,currentObj.get("rotation"),isChild);else if(currentObj.get("enter")==="rotation")this.rotationEnterHandler(playerElement,currentObj.get("enterduration"),currentObj.get("rotation"),currentObj.get("scaleX"),currentObj.get("scaleY"),enterTime,isChild);else if(currentObj.get("enter")==="stripeTopLeft"||currentObj.get("enter")==="stripe_Topright"||currentObj.get("enter")==="stripe_Bottomleft"||currentObj.get("enter")==="stripe_Bottomright"||currentObj.get("enter")==="stripeLeftTop"||currentObj.get("enter")==="stripeRightTop"||currentObj.get("enter")==="stripeLeftBottom"||currentObj.get("enter")==="stripeRightBottom")this.stripeEnterHandler(playerElement,currentObj.get("xval"),currentObj.get("yval"),currentObj.get("enterduration"),enterTime,currentObj.get("enter"),currentObj.get("scaleX"),currentObj.get("scaleY"),isChild);else if(currentObj.get("enter")==="moveFromTop"||currentObj.get("enter")==="moveFromDown"||currentObj.get("enter")==="moveFromRight"||currentObj.get("enter")==="moveFromLeft")this.moveEnterHandler(playerElement,currentObj.get("xval"),currentObj.get("yval"),currentObj.get("rotation"),currentObj.get("enterduration"),enterTime,currentObj.get("enter"),currentObj.get("scaleX"),currentObj.get("scaleY"),isChild);else if(currentObj.get("enter")==="verticalSplit"||currentObj.get("enter")==="horizontalSplit")this.splitFromCenterEnterHandler(playerElement,currentObj.get("enterduration"),currentObj.get("enter"),enterTime,isChild);else if(currentObj.get("enter")==="irishSquare"||currentObj.get("enter")==="irishCircle")this.irishEnterHandler(playerElement,currentObj.get("enterduration"),currentObj.get("enter"),enterTime,isChild);else if(currentObj.get("enter")==="brightSquare")this.brightSquareEnterHandler(playerElement,currentObj.get("xval"),currentObj.get("yval"),currentObj.get("enterduration"),enterTime,isChild);else if(currentObj.get("enter")==="bounce")this.bounceEnterHandler(playerElement,currentObj.get("enterduration"),currentObj.get("height"),currentObj.get("yval"),enterTime,currentObj.get("opacity"),isChild);else if(currentObj.get("enter")==="circularRevealClockwise"||currentObj.get("enter")==="circularRevealAntiClockwise"||currentObj.get("enter")==="circularRevealClockwiseRight"||currentObj.get("enter")==="circularRevealAntiClockwiseRight"||currentObj.get("enter")==="circularRevealClockwiseLeft"||currentObj.get("enter")==="circularRevealAntiClockwiseLeft"||currentObj.get("enter")==="circularRevealClockwiseBottom"||currentObj.get("enter")==="circularRevealAntiClockwiseBottom")this.circularRevealEnterHandler(playerElement,currentObj.get("enterduration"),currentObj.get("enter"),enterTime,currentObj.get("scaleX"),currentObj.get("scaleY"),isChild);else if(currentObj.get("enter")==="splitRevealFromTopCenter"||currentObj.get("enter")==="splitRevealFromBottomCenter"||currentObj.get("enter")==="splitRevealFromLeftCenter"||currentObj.get("enter")==="splitRevealFromRightCenter")this.splitRevealEnterHandler(playerElement,currentObj.get("enterduration"),currentObj.get("enter"),enterTime,currentObj.get("scaleX"),currentObj.get("scaleY"),isChild);else if(currentObj.get("enter")==="revealFromLeftBottom"||currentObj.get("enter")==="revealFromLeftTop"||currentObj.get("enter")==="revealFromRightBottom"||currentObj.get("enter")==="revealFromRightTop")this.revealFromEnterHandler(playerElement,currentObj.get("enterduration"),currentObj.get("enter"),enterTime,currentObj.get("scaleX"),currentObj.get("scaleY"),isChild);else if(currentObj.get("enter")==="textWrite")this.textWriteEnterHandler(playerElement,currentObj.get("enterduration"),this.t1,enterTime,isChild);else if(currentObj.get("enter")==="splitText")this.splitTextEnterHandler(playerElement,currentObj.get("enterduration"),this.t1,enterTime,isChild);else if(currentObj.get("enter")==="handWrite")this.handWriteEnterHandler(playerElement,currentObj.get("enterduration"),enterTime,isChild);else if(currentObj.get("enter")==="enterFromLeftBottom")this.EnterFromLeftBottom(playerElement,currentObj.get("enterduration"),currentObj.get("height"),currentObj.get("width"),currentObj.get("xval"),currentObj.get("yval"),enterTime,isChild);else if(currentObj.get("enter")==="enterFromLeftTop")this.EnterFromLeftTop(playerElement,currentObj.get("enterduration"),currentObj.get("height"),currentObj.get("width"),currentObj.get("xval"),currentObj.get("yval"),enterTime,isChild);else if(currentObj.get("enter")==="enterFromRightBottom")this.EnterFromRightBottom(playerElement,currentObj.get("enterduration"),currentObj.get("height"),currentObj.get("width"),currentObj.get("xval"),currentObj.get("yval"),enterTime,isChild);else if(currentObj.get("enter")==="enterFromRightTop")this.EnterFromRightTop(playerElement,currentObj.get("enterduration"),currentObj.get("height"),currentObj.get("width"),currentObj.get("xval"),currentObj.get("yval"),enterTime,isChild);else if(currentObj.get("enter")==="enterFromTop")this.EnterFromTop(playerElement,currentObj.get("enterduration"),currentObj.get("height"),currentObj.get("width"),currentObj.get("xval"),currentObj.get("yval"),enterTime,isChild);else if(currentObj.get("enter")==="enterFromLeft")this.EnterFromLeft(playerElement,currentObj.get("enterduration"),currentObj.get("height"),currentObj.get("width"),currentObj.get("xval"),currentObj.get("yval"),enterTime,isChild);else if(currentObj.get("enter")==="enterFromBottom")this.EnterFromBottom(playerElement,currentObj.get("enterduration"),currentObj.get("height"),currentObj.get("width"),currentObj.get("xval"),currentObj.get("yval"),enterTime,isChild);else if(currentObj.get("enter")==="enterFromRight")this.EnterFromRight(playerElement,currentObj.get("enterduration"),currentObj.get("height"),currentObj.get("width"),currentObj.get("xval"),currentObj.get("yval"),enterTime,isChild);}},{key:'changeVideo',value:function changeVideo(videoDOM,index){this.props.changeVideoIndex(index);videoDOM.currentTime=0;document.querySelectorAll('video').forEach(function(vid){return vid.pause();});// document.getElementById("video-controls-" + index).style.opacity = 0
// videoDOM.ontimeupdate = () => this.videoOnTimeUpdate(videoElement, videoDOM, currentSceneStart, volume, list, globalThumb, currentScene);
// var playStart = videoElement.get('enterStart');
// var musicStart = videoElement.get('videoStart');
// if (playStart < 0)
// {
//   musicStart = musicStart + (this.props.playStart);
//   playStart = 0;
// }
// videoDOM.volume = videoElement.get("volume")/100;
// videoDOM.currentTime = musicStart + globalThumb;
// videoDOM.muted = videoElement.get('videoMute');
// if((this.props.projectData.getIn(["scenes", currentScene, "startTime"]) + this.props.projectData.getIn(["scenes", currentScene, "duration"])) > currentSceneStart && this.props.localStore.get("isPlayAll"))
//   this.playPromise = videoDOM.play();
}},{key:'pauseVideo',value:function pauseVideo(sceneIndex){var isEnd=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;if(!isEnd)document.querySelectorAll('video').forEach(function(vid){return vid.pause();});}},{key:'componentDidMount',value:function componentDidMount(){this.t1=this.props.t1;this.isPlaying=true;this.projectWidth=this.props.projectData.get("width");this.projectHeight=this.props.projectData.get("height");document.getElementsByClassName("scenes")[0].style.width="100%";//this.projectWidth + "px"
document.getElementsByClassName("scenes")[0].style.height="100%";//this.projectHeight + "px"
document.getElementsByClassName("scenes")[0].style.overflow="hidden";this.addPlayerEssentials(this.props);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.source.cancel('Operation canceled by the user.');this.props.changePlayTime(0);this.addImagePlayerItems=null;this.addTextOverlayItems=null;this.addEffectsToItem=null;this.addSceneTransition=null;this.addMaskDOM=null;this.textWriteEnterHandler=null;this.CancelToken=null;this.source=null;this.tweenToHandler=null;this.tweenfromHandler=null;this.tweenFromToHandler=null;this.tweenStaggerHandler=null;this.tweenAddCallbackHandler=null;this.playPromise=undefined;}// filterWorkspaceItems = (workspaceItems, workspaceChildren) => {
//   var itemsToLoad = OrderedMap();
//   workspaceItems.entrySeq().forEach(([item, workspaceItem]) => {
//     if(workspaceItem.get("type") === "GROUP") {
//       if(workspaceItem.get("enterEffectName") !== "no_Effect" && (workspaceItem.get("groupChildren").size !== 0)) {
//         itemsToLoad = itemsToLoad.setIn([item], workspaceItem);
//         itemsToLoad = itemsToLoad.setIn([item, "isChild"], false);
//       }
//       else {
//         workspaceChildren.entrySeq().forEach(([item, child]) => {
//           if(workspaceItem.getIn(["groupChildren"]).includes(item)) {
//             itemsToLoad = itemsToLoad.setIn([item], child);
//             itemsToLoad = itemsToLoad.setIn([item, "isChild"], true);
//           }
//         })
//       }
//     } else {
//       itemsToLoad = itemsToLoad.setIn([item], workspaceItem);
//       itemsToLoad = itemsToLoad.setIn([item, "isChild"], false);
//     }
//   })
//   return itemsToLoad;
// }
},{key:'processProjectData',value:function processProjectData(projectData){var _this2=this;var projectDataCopy=new __WEBPACK_IMPORTED_MODULE_7_immutable__["OrderedMap"](projectData);var clonedProjectData=this.filterWorkspaceItemsAnimate(projectDataCopy);var labelName=0;var slideLabelData={};var _loop2=function _loop2(){//to sort the items using key animIndex
var sortedItems=clonedProjectData.getIn(['scenes',m,'workspaceItems']).sortBy(function(item){return item.get('animType')!="On Load";});currentTime=0;var startTimeDelay=0;var delayed=false;var isClick=false;sortedItems.entrySeq().forEach(function(_ref7){var _ref8=_slicedToArray(_ref7,2),key=_ref8[0],value=_ref8[1];var transition=clonedProjectData.getIn(['scenes',m-1,'transEffect']);var isDelayReq=value.get('enterEffectName')==='no_Effect'||m===0||transition==='NoTransition'?false:true;if(value.get("animType")=="On Load"){if(!isDelayReq){clonedProjectData=clonedProjectData.setIn(['scenes',m,'workspaceItems',key,'enterStart'],0);clonedProjectData=clonedProjectData.setIn(['scenes',m,"workspaceItems",key,"enterEnd"],0.5);}else{var timeDelay=_this2.fetchTransitionTime(transition);startTimeDelay=Math.max(timeDelay,startTimeDelay);delayed=true;clonedProjectData=clonedProjectData.setIn(['scenes',m,'workspaceItems',key,'enterStart'],timeDelay);clonedProjectData=clonedProjectData.setIn(['scenes',m,"workspaceItems",key,"enterEnd"],0.5+timeDelay);}}else if(value.get("animType")=="On Click"){isClick=true;if(!delayed){currentTime+=1;_this2.props.t1.addPause(clonedProjectData.getIn(['scenes',m,"startTime"])+currentTime-0.01);labelName+=1;_this2.props.t1.addLabel(labelName,clonedProjectData.getIn(['scenes',m,"startTime"])+currentTime+0.01);clonedProjectData=clonedProjectData.setIn(['scenes',m,"workspaceItems",key,"enterStart"],currentTime);clonedProjectData=clonedProjectData.setIn(['scenes',m,"workspaceItems",key,"enterEnd"],currentTime+0.5);}else{var _timeDelay=_this2.fetchTransitionTime(transition);startTimeDelay=startTimeDelay+_timeDelay;currentTime+=1;_this2.props.t1.addPause(clonedProjectData.getIn(['scenes',m,"startTime"])+currentTime-0.01+0.5+_timeDelay);labelName+=1;_this2.props.t1.addLabel(labelName,clonedProjectData.getIn(['scenes',m,"startTime"])+currentTime+0.01+0.5+_timeDelay);clonedProjectData=clonedProjectData.setIn(['scenes',m,"workspaceItems",key,"enterStart"],currentTime+0.5+_timeDelay);clonedProjectData=clonedProjectData.setIn(['scenes',m,"workspaceItems",key,"enterEnd"],currentTime+0.5+0.5+_timeDelay);}}else if(value.get("animType")=="With Previous"){if(!isDelayReq){clonedProjectData=clonedProjectData.setIn(['scenes',m,"workspaceItems",key,"enterStart"],currentTime);clonedProjectData=clonedProjectData.setIn(['scenes',m,"workspaceItems",key,"enterEnd"],currentTime+0.5);}else{var _timeDelay2=_this2.fetchTransitionTime(transition);startTimeDelay=Math.max(_timeDelay2,startTimeDelay);delayed=true;var timer=0;if(isClick){timer=0.5;}clonedProjectData=clonedProjectData.setIn(['scenes',m,"workspaceItems",key,"enterStart"],currentTime+timer+_timeDelay2);clonedProjectData=clonedProjectData.setIn(['scenes',m,"workspaceItems",key,"enterEnd"],currentTime+0.5+timer+_timeDelay2);}}else if(value.get("animType")=="After Previous"){isClick=true;if(!delayed){currentTime+=1;labelName+=1;_this2.props.t1.addLabel(labelName,clonedProjectData.getIn(['scenes',m,"startTime"])+currentTime+0.01);clonedProjectData=clonedProjectData.setIn(['scenes',m,"workspaceItems",key,"enterStart"],currentTime+0.01);clonedProjectData=clonedProjectData.setIn(['scenes',m,"workspaceItems",key,"enterEnd"],currentTime+0.5);}else{var _timeDelay3=_this2.fetchTransitionTime(transition);startTimeDelay=startTimeDelay+_timeDelay3;currentTime+=1;labelName+=1;_this2.props.t1.addLabel(labelName,clonedProjectData.getIn(['scenes',m,"startTime"])+currentTime+0.01+0.5+_timeDelay3);clonedProjectData=clonedProjectData.setIn(['scenes',m,"workspaceItems",key,"enterStart"],currentTime+0.01+0.5+_timeDelay3);clonedProjectData=clonedProjectData.setIn(['scenes',m,"workspaceItems",key,"enterEnd"],currentTime+0.5+0.5+_timeDelay3);}}});clonedProjectData=clonedProjectData.setIn(['scenes',m,"duration"],currentTime+1+startTimeDelay);if(m<clonedProjectData.getIn(['scenes']).size-1){clonedProjectData=clonedProjectData.setIn(['scenes',m+1,"startTime"],clonedProjectData.getIn(['scenes',m,"duration"])+clonedProjectData.getIn(['scenes',m,"startTime"]));}if(!_this2.props.autoPlay){_this2.props.t1.addPause(clonedProjectData.getIn(['scenes',m,"startTime"])+clonedProjectData.getIn(['scenes',m,"duration"])-0.01);labelName+=1;_this2.props.t1.addLabel(labelName,clonedProjectData.getIn(['scenes',m,"startTime"])+clonedProjectData.getIn(['scenes',m,"duration"])+0.01);slideLabelData[m+1]={'slide':m+1,'label':labelName};}};for(var m=0;m<clonedProjectData.getIn(['scenes']).size;m++){var currentTime;_loop2();}this.props.addSlideLabelData(slideLabelData);return clonedProjectData;}},{key:'addPlayerEssentials',value:function addPlayerEssentials(nextProps){var _this3=this;var selectedScene=nextProps.localStore.get('selectedScene');var filteredItems,workspaceItems,workspaceChildren;if(nextProps.projectData.getIn(['scenes']).size>0){if(nextProps.localStore.get('isPlayAll')){var projectData=this.processProjectData(nextProps.projectData);this.addSceneTransition(projectData.getIn(['scenes']));for(var m=0;m<projectData.getIn(['scenes']).size;m++){var slideStartTime=projectData.getIn(['scenes',m,"startTime"]);workspaceItems=projectData.getIn(['scenes',m,'workspaceItems']);workspaceChildren=projectData.getIn(['scenes',m,'workspaceChildren']);//filteredItems = this.filterWorkspaceItems(workspaceItems, workspaceChildren);
workspaceItems.entrySeq().forEach(function(_ref9){var _ref10=_slicedToArray(_ref9,2),key=_ref10[0],value=_ref10[1];if(nextProps.localStore.get('isPlayAll')){var enterEffectEnd=value.get("enterEnd");var exitEfftectStart=value.get("exitStart");if(value.getIn(['type'])==="TXTOVLY"){for(var mk=0;mk<value.get('groupChildren').size;mk++){var textTmp=value.getIn(['groupChildren',mk]);var childVal=projectData.getIn(['scenes',m,'workspaceChildren',textTmp]);_this3.addTextOverlayItems(childVal,textTmp,slideStartTime);}}else{_this3.addImagePlayerItems(value,key,slideStartTime,enterEffectEnd,exitEfftectStart,value.getIn(['isChild']),projectData.getIn(['scenes',selectedScene,'duration']),projectData.getIn(['scenes',m,'duration']));}}});if(projectData.getIn(['scenes',m,"workspaceBG","src"])!==""){if(projectData.getIn(['scenes',m,"workspaceBG","type"])==="VIDEO"||projectData.getIn(['scenes',m,"workspaceBG","type"])==="STOCKVID"||projectData.getIn(['scenes',m,"workspaceBG","type"])==="UPVIDEO"||projectData.getIn(['scenes',m,"workspaceBG","type"])==="ZOOM"){var imageDiv=document.getElementById("scene"+m).getElementsByClassName("scenes")[0].getElementsByClassName("bg-video")[0];this.tweenToHandler(imageDiv,0.01,{opacity:1},slideStartTime);var workspaceBg=projectData.getIn(['scenes',m,"workspaceBG"]);var videoElement=workspaceBg;var videoDOM=document.getElementById("scene"+m).getElementsByClassName("scenes")[0].getElementsByClassName("bg-video")[0];var playStart=projectData.getIn(['scenes',m,"startTime"]);//slideStartTime + workspaceBg.get('enterStart');
var valArr={};var bgDOM=document.getElementById("scene"+m).getElementsByClassName("scenes")[0].getElementsByClassName("bg-container");var playEnd=projectData.getIn(['scenes',m,"startTime"])+projectData.getIn(['scenes',m,"duration"]);var globalStart=0;if(this.props.selectedScene===m){globalStart=this.props.playAllThumb-projectData.getIn(['scenes',m,"startTime"]);}valArr.callBack=this.changeVideo;valArr.startTime=playStart;valArr.dataArr=[videoDOM,m];this.props.addTween(valArr,"addCallback");var changeArr={};changeArr.callBack=this.pauseVideo;changeArr.startTime=playEnd;if(m===this.props.projectData.get('scenes').size-1){changeArr.dataArr=[m,true];}else{changeArr.dataArr=[m];}this.props.addTween(changeArr,'addCallback');}}}var currentSceneStart=projectData.getIn(['scenes',selectedScene,'startTime']);this.tweenSetHandler(projectData.getIn(["duration"]));var valArr={};valArr.callBack=this.PlayEnded.bind(this);valArr.startTime=projectData.getIn(["duration"]);valArr.dataArr=[];this.tweenAddCallbackHandler(valArr);if(window.totalArr.length===0)this.props.startPlay("workspace");this.props.startPlay("player","player",projectData.getIn(['scenes',selectedScene,"playHeadValue"]),projectData.getIn(['scenes',selectedScene,"startTime"]));}}}},{key:'PlayEnded',value:function PlayEnded(){// if (this.props.localStore.get('isPlayAll'))
//   this.props.setPlayAll(false)
}},{key:'render',value:function render(){return null;}},{key:'splitTextEnterHandler',value:function splitTextEnterHandler(innerblock,startTime,t1,exitstart,isChild){function nestedLinesSplit(target,vars){var split=new __WEBPACK_IMPORTED_MODULE_2_gsap_SplitText___default.a(target,vars),words=vars.type.indexOf("words")!==-1,chars=vars.type.indexOf("chars")!==-1,insertAt=function insertAt(a,b,i){var l=b.length,j;for(j=0;j<l;j++){a.splice(i++,0,b[j]);}return l;},children,child,i;if(typeof target==="string"){target=document.querySelectorAll(target);}if(target.length>1){for(i=0;i<target.length;i++){split.lines=split.lines.concat(nestedLinesSplit(target[i],vars).lines);}return split;}children=(words?split.words:[]).concat(chars?split.chars:[]);for(i=0;i<children.length;i++){children[i]._protect=true;}children=split.lines;for(i=0;i<children.length;i++){child=children[i].firstChild;if(!child._protect&&child.nodeType!==3){children[i].parentNode.insertBefore(child,children[i]);children[i].parentNode.removeChild(children[i]);children.splice(i,1);i+=insertAt(children,nestedLinesSplit(child,vars).lines,i)-1;}}return split;}var assetTexts=innerblock.getElementsByClassName("text-container")[0];if(assetTexts!==undefined&&assetTexts!==null){var setVisibility=function setVisibility(){for(var _i=0;_i<mySplitText.lines.length;_i++){mySplitText.lines[_i].style.visibility="visible";}};var mySplitText=nestedLinesSplit(assetTexts,{type:"lines"});for(var i=0;i<mySplitText.lines.length;i++){mySplitText.lines[i].style.visibility="hidden";}this.tweenStaggerFromToHandler(mySplitText.lines,startTime/mySplitText.lines.length,{left:this.projectWidth*this.props.zoomFactor,visibility:"visible"},{left:0,visibility:"visible",onComplete:setVisibility},startTime/mySplitText.lines.length,exitstart);}}},{key:'textWriteEnterHandler',value:function textWriteEnterHandler(innerblock,duration,t1,enterstart,isChild){var cursorSpan=document.createElement('span');cursorSpan.id="cursorCls"+Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString();cursorSpan.className='cursorCls';if(!innerblock.contains(document.getElementById("cursorCls")))innerblock.appendChild(cursorSpan);var assetTexts=innerblock.getElementsByClassName("text-container")[0],isUnderline=false;if(assetTexts.style.textDecoration==="underline"){var textValue=assetTexts.innerHTML;textValue=textValue.split(' ').join('&nbsp;');assetTexts.innerHTML=textValue;}var cursor=document.getElementById(cursorSpan.id);cursor.style.left="0px";cursor.style.height="0px";cursor.style.opacity="1";if(assetTexts!==undefined&&assetTexts!==null){var allDone=function allDone(){mySplitText.revert();if(isUnderline)assetTexts.style.textDecoration="underline";};var placeCursor=function placeCursor(){cursor.style.height=this.target.offsetHeight+"px";cursor.style.left=this.target.offsetWidth+"px";this.target.appendChild(cursorSpan);_blink();};var _blink=function _blink(){__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].fromTo(cursor,0.3,{opacity:1},{opacity:0,repeat:-1,ease:__WEBPACK_IMPORTED_MODULE_1_gsap__["d" /* Linear */].easeNone});};var hideCursor=function hideCursor(){cursor.outerHTML="";};var mySplitText=new __WEBPACK_IMPORTED_MODULE_2_gsap_SplitText___default.a(assetTexts,{type:"chars",reduceWhiteSpace:false}),chars=mySplitText.chars;var textDivs=innerblock.getElementsByClassName("text-container")[0].getElementsByTagName('div');if(assetTexts.style.textDecoration==="underline"){assetTexts.style.textDecoration="unset";isUnderline=true;for(var t=0;t<textDivs.length;t++){textDivs[t].style.textDecoration="underline";}}for(var txt=0;txt<textDivs.length;txt++){if(textDivs[txt].getElementsByTagName("div").length===0){textDivs[txt].style.display="inline";textDivs[txt].style.opacity="0";}}this.tweenStaggerToHandler(chars.slice(),0.0001,{opacity:1,ease:__WEBPACK_IMPORTED_MODULE_1_gsap__["e" /* Power1 */].easeIn,onStart:placeCursor},duration/chars.length,enterstart,allDone);this.t1.addCallback(hideCursor,enterstart+duration);}}},{key:'handWriteEnterHandler',value:function handWriteEnterHandler(innerblock,duration,enterstart,isChild){var handSpan=document.createElement('span'),handOffset=10;handSpan.id="hand"+Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString();handSpan.className='handPenCls';if(!innerblock.contains(document.getElementById("hand")))innerblock.appendChild(handSpan);var assetTexts=innerblock.getElementsByClassName("text-container")[0],isUnderline=false;if(assetTexts.style.textDecoration==="underline"){var textValue=assetTexts.innerHTML;textValue=textValue.split(' ').join('&nbsp;');assetTexts.innerHTML=textValue;}var hand=document.getElementById(handSpan.id);hand.style.left="0px";if(assetTexts!==undefined&&assetTexts!==null){var allDone=function allDone(){mySplitText.revert();if(isUnderline)assetTexts.style.textDecoration="underline";};var placeHand=function placeHand(){hand.style.left=this.target.offsetWidth-handOffset+"px";this.target.appendChild(handSpan);_blink2();};var _blink2=function _blink2(){__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].fromTo(hand,0.5,{opacity:1},{repeat:-1,ease:__WEBPACK_IMPORTED_MODULE_1_gsap__["d" /* Linear */].easeNone});};var hideHand=function hideHand(){hand.outerHTML="";};var mySplitText=new __WEBPACK_IMPORTED_MODULE_2_gsap_SplitText___default.a(assetTexts,{type:"chars",reduceWhiteSpace:false}),chars=mySplitText.chars;var textDivs=innerblock.getElementsByClassName("text-container")[0].getElementsByTagName('div');if(assetTexts.style.textDecoration==="underline"){assetTexts.style.textDecoration="unset";isUnderline=true;for(var t=0;t<textDivs.length;t++){textDivs[t].style.textDecoration="underline";}}for(var txt=0;txt<textDivs.length;txt++){if(textDivs[txt].getElementsByTagName("div").length===0){textDivs[txt].style.display="inline";textDivs[txt].style.opacity="0";}}this.tweenStaggerToHandler(chars.slice(),0.0001,{opacity:1,ease:__WEBPACK_IMPORTED_MODULE_1_gsap__["e" /* Power1 */].easeIn,onStart:placeHand},(duration-duration*0.2)/chars.length,enterstart,allDone);this.tweenToHandler(hand,duration*0.2,{y:this.projectHeight*this.props.zoomFactor},enterstart+duration-duration*0.2);this.t1.addCallback(hideHand,enterstart+duration);}}},{key:'revealFromEnterHandler',value:function revealFromEnterHandler(innerblock,startTime,effectType,enterTime,scaleX,scaleY,isChild){this.addMask(innerblock.id,"reveal",null,null,null,null,null,false);var mask_rect="#mask_"+innerblock.id+"_rect";var idVal=document.getElementById(innerblock.id);if(scaleX===-1||scaleY===-1){if(effectType==="revealFromLeftBottom"&&scaleX===-1&&scaleY===1)effectType="revealFromRightBottom";else if(effectType==="revealFromLeftBottom"&&scaleY===-1&&scaleX===1)effectType="revealFromLeftTop";else if(effectType==="revealFromLeftBottom"&&scaleY===-1&&scaleX===-1)effectType="revealFromRightTop";else if(effectType==="revealFromLeftTop"&&scaleX===-1&&scaleY===1)effectType="revealFromRightTop";else if(effectType==="revealFromLeftTop"&&scaleY===-1&&scaleX===1)effectType="revealFromLeftBottom";else if(effectType==="revealFromLeftTop"&&scaleY===-1&&scaleX===-1)effectType="revealFromRightBottom";else if(effectType==="revealFromRightTop"&&scaleX===-1&&scaleY===1)effectType="revealFromLeftTop";else if(effectType==="revealFromRightTop"&&scaleY===-1&&scaleX===1)effectType="revealFromRightBottom";else if(effectType==="revealFromRightTop"&&scaleY===-1&&scaleX===-1)effectType="revealFromLeftBottom";else if(effectType==="revealFromRightBottom"&&scaleX===-1&&scaleY===1)effectType="revealFromLeftBottom";else if(effectType==="revealFromRightBottom"&&scaleY===-1&&scaleX===1)effectType="revealFromRightTop";else if(effectType==="revealFromRightBottom"&&scaleY===-1&&scaleX===-1)effectType="revealFromLeftTop";}if(effectType==="revealFromLeftBottom")this.tweenFromToHandler(mask_rect,startTime,{attr:{x:idVal.offsetWidth*-1,y:idVal.offsetHeight}},{attr:{x:0,y:0}},enterTime);else if(effectType==="revealFromLeftTop")this.tweenFromToHandler(mask_rect,startTime,{attr:{x:idVal.offsetWidth*-1,y:idVal.offsetHeight*-1}},{attr:{x:0,y:0}},enterTime);else if(effectType==="revealFromRightBottom")this.tweenFromToHandler(mask_rect,startTime,{attr:{x:idVal.offsetWidth,y:idVal.offsetHeight}},{attr:{x:0,y:0}},enterTime);else if(effectType==="revealFromRightTop")this.tweenFromToHandler(mask_rect,startTime,{attr:{x:idVal.offsetWidth,y:idVal.offsetHeight*-1}},{attr:{x:0,y:0}},enterTime);this.tweenToHandler(innerblock,0.01,{"clip-path":""},startTime+enterTime);}},{key:'splitRevealEnterHandler',value:function splitRevealEnterHandler(innerblock,startTime,effectType,enterTime,scaleX,scaleY,isChild){this.removeMask(innerblock.id);this.addMask(innerblock.id,"circularReveal");if(scaleX===-1||scaleY===-1){if(effectType==="splitRevealFromTopCenter"&&scaleY===-1)effectType="splitRevealFromBottomCenter";else if(effectType==="splitRevealFromBottomCenter"&&scaleY===-1)effectType="splitRevealFromTopCenter";else if(effectType==="splitRevealFromRightCenter"&&scaleX===-1)effectType="splitRevealFromLeftCenter";else if(effectType==="splitRevealFromLeftCenter"&&scaleX===-1)effectType="splitRevealFromRightCenter";}var offsetWidthVal=document.getElementById(innerblock.id).offsetWidth;var offsetHeightVal=document.getElementById(innerblock.id).offsetHeight;var clipPath=document.querySelector("#arcPath"+innerblock.id);var radiusVal=Math.max(offsetWidthVal,offsetHeightVal);var effectVars={};if(effectType==="splitRevealFromTopCenter")effectVars={start:360,mainStart:540,mainEnd:180};else if(effectType==="splitRevealFromRightCenter")effectVars={start:90,mainStart:270,mainEnd:-90};else if(effectType==="splitRevealFromBottomCenter")effectVars={start:180,mainStart:360,mainEnd:0};else if(effectType==="splitRevealFromLeftCenter")effectVars={start:270,mainStart:this.projectHeight,mainEnd:90};radiusVal=0.5*Math.sqrt(offsetWidthVal*offsetWidthVal+offsetHeightVal*offsetHeightVal);var arc={start:effectVars.start,end:effectVars.start,cx:offsetWidthVal/2,cy:offsetHeightVal/2,r:radiusVal};this.tweenToHandler(arc,startTime,{start:effectVars.mainStart,end:effectVars.mainEnd,ease:__WEBPACK_IMPORTED_MODULE_1_gsap__["d" /* Linear */].easeNone,onUpdate:updatePath},enterTime);this.tweenToHandler(innerblock,0.01,{"clip-path":""},startTime+enterTime);function updatePath(){clipPath.setAttribute("d",getPath(arc.cx,arc.cy,arc.r,arc.end,arc.start));}function getPath(cx,cy,r,a1,a2){var delta=a2-a1;if(delta===360){return"M "+(cx-r)+" "+cy+" a "+r+" "+r+" 0 1 0 "+r*2+" 0 a "+r+" "+r+" 0 1 0 "+-r*2+" 0z";}var largeArc=delta>180?1:0;a1=a1*Math.PI/180-Math.PI/2;a2=a2*Math.PI/180-Math.PI/2;var x1=cx+r*Math.cos(a2);var y1=cy+r*Math.sin(a2);var x2=cx+r*Math.cos(a1);var y2=cy+r*Math.sin(a1);return"M "+x1+" "+y1+" A "+r+" "+r+" 0 "+largeArc+" 0 "+x2+" "+y2+" L "+cx+" "+cy+"z";}}},{key:'circularRevealEnterHandler',value:function circularRevealEnterHandler(innerblock,startTime,effectType,enterTime,scaleX,scaleY,isChild){this.removeMask(innerblock.id);this.addMask(innerblock.id,"circularReveal");var offsetWidthVal=document.getElementById(innerblock.id).offsetWidth;var offsetHeightVal=document.getElementById(innerblock.id).offsetHeight;if(scaleX===-1||scaleY===-1){if(effectType==="circularRevealClockwise"&&scaleX===-1&&scaleY===1)effectType="circularRevealAntiClockwise";else if(effectType==="circularRevealClockwise"&&scaleX===1&&scaleY===-1)effectType="circularRevealAntiClockwiseBottom";else if(effectType==="circularRevealClockwise"&&scaleX===-1&&scaleY===-1)effectType="circularRevealClockwiseBottom";else if(effectType==="circularRevealAntiClockwise"&&scaleX===-1&&scaleY===1)effectType="circularRevealClockwise";else if(effectType==="circularRevealAntiClockwise"&&scaleX===1&&scaleY===-1)effectType="circularRevealClockwiseBottom";else if(effectType==="circularRevealAntiClockwise"&&scaleX===-1&&scaleY===-1)effectType="circularRevealAntiClockwiseBottom";else if(effectType==="circularRevealClockwiseRight"&&scaleX===-1&&scaleY===1)effectType="circularRevealAntiClockwiseLeft";else if(effectType==="circularRevealClockwiseRight"&&scaleX===1&&scaleY===-1)effectType="circularRevealAntiClockwiseRight";else if(effectType==="circularRevealClockwiseRight"&&scaleX===-1&&scaleY===-1)effectType="circularRevealClockwiseLeft";else if(effectType==="circularRevealAntiClockwiseRight"&&scaleX===-1&&scaleY===1)effectType="circularRevealClockwiseLeft";else if(effectType==="circularRevealAntiClockwiseRight"&&scaleX===1&&scaleY===-1)effectType="circularRevealClockwiseRight";else if(effectType==="circularRevealAntiClockwiseRight"&&scaleX===-1&&scaleY===-1)effectType="circularRevealAntiClockwiseLeft";else if(effectType==="circularRevealClockwiseLeft"&&scaleX===-1&&scaleY===1)effectType="circularRevealAntiClockwiseRight";else if(effectType==="circularRevealClockwiseLeft"&&scaleX===1&&scaleY===-1)effectType="circularRevealAntiClockwiseLeft";else if(effectType==="circularRevealClockwiseLeft"&&scaleX===-1&&scaleY===-1)effectType="circularRevealClockwiseRight";else if(effectType==="circularRevealAntiClockwiseLeft"&&scaleX===-1&&scaleY===1)effectType="circularRevealClockwiseRight";else if(effectType==="circularRevealAntiClockwiseLeft"&&scaleX===1&&scaleY===-1)effectType="circularRevealClockwiseLeft";else if(effectType==="circularRevealAntiClockwiseLeft"&&scaleX===-1&&scaleY===-1)effectType="circularRevealAntiClockwiseRight";else if(effectType==="circularRevealClockwiseBottom"&&scaleX===-1&&scaleY===1)effectType="circularRevealAntiClockwiseBottom";else if(effectType==="circularRevealClockwiseBottom"&&scaleX===1&&scaleY===-1)effectType="circularRevealAntiClockwise";else if(effectType==="circularRevealClockwiseBottom"&&scaleX===-1&&scaleY===-1)effectType="circularRevealClockwise";else if(effectType==="circularRevealAntiClockwiseBottom"&&scaleX===-1&&scaleY===1)effectType="circularRevealClockwiseBottom";else if(effectType==="circularRevealAntiClockwiseBottom"&&scaleX===1&&scaleY===-1)effectType="circularRevealClockwise";else if(effectType==="circularRevealAntiClockwiseBottom"&&scaleX===-1&&scaleY===-1)effectType="circularRevealAntiClockwise";}var clipPath=document.querySelector("#arcPath"+innerblock.id);var radiusVal=offsetWidthVal>offsetHeightVal?offsetWidthVal:offsetHeightVal;var effectVars={};if(effectType==="circularRevealClockwise")effectVars={start:0,end:360};else if(effectType==="circularRevealAntiClockwise")effectVars={start:360,end:0};else if(effectType==="circularRevealClockwiseRight")effectVars={start:90,end:this.projectHeight};else if(effectType==="circularRevealAntiClockwiseRight")effectVars={start:90,end:-270};else if(effectType==="circularRevealClockwiseLeft")effectVars={start:270,end:630};else if(effectType==="circularRevealAntiClockwiseLeft")effectVars={start:270,end:-90};else if(effectType==="circularRevealClockwiseBottom")effectVars={start:180,end:540};else if(effectType==="circularRevealAntiClockwiseBottom")effectVars={start:180,end:-180};var arc={start:effectVars.start,end:effectVars.start,cx:offsetWidthVal/2,cy:offsetHeightVal/2,r:radiusVal};if(effectType==="circularRevealClockwise"||effectType==="circularRevealClockwiseRight"||effectType==="circularRevealClockwiseLeft"||effectType==="circularRevealClockwiseBottom"){var updatePath=function updatePath(){clipPath.setAttribute("d",getPath(arc.cx,arc.cy,arc.r,arc.start,arc.end));};this.tweenToHandler(arc,startTime,{end:effectVars.end,ease:__WEBPACK_IMPORTED_MODULE_1_gsap__["d" /* Linear */].easeNone,onUpdate:updatePath},enterTime);}else if(effectType==="circularRevealAntiClockwise"||effectType==="circularRevealAntiClockwiseRight"||effectType==="circularRevealAntiClockwiseLeft"||effectType==="circularRevealAntiClockwiseBottom"){var _updatePath=function _updatePath(){clipPath.setAttribute("d",getPath(arc.cx,arc.cy,arc.r,arc.end,arc.start));};this.tweenToHandler(arc,startTime,{end:effectVars.end,ease:__WEBPACK_IMPORTED_MODULE_1_gsap__["d" /* Linear */].easeNone,onUpdate:_updatePath},enterTime);}function getPath(cx,cy,r,a1,a2){var delta=a2-a1;if(delta===360){return"M "+(cx-r)+" "+cy+" a "+r+" "+r+" 0 1 0 "+r*2+" 0 a "+r+" "+r+" 0 1 0 "+-r*2+" 0z";}var largeArc=delta>180?1:0;a1=a1*Math.PI/180-Math.PI/2;a2=a2*Math.PI/180-Math.PI/2;var x1=cx+r*Math.cos(a2);var y1=cy+r*Math.sin(a2);var x2=cx+r*Math.cos(a1);var y2=cy+r*Math.sin(a1);return"M "+x1+" "+y1+" A "+r+" "+r+" 0 "+largeArc+" 0 "+x2+" "+y2+" L "+cx+" "+cy+"z";}}},{key:'circularRevealExitHandler',value:function circularRevealExitHandler(innerblock,startTime,effectType,time,scaleX,scaleY,opacity,isChild){var effectVars={};var clipPath=document.querySelector("#arcPath"+innerblock.id);var offsetWidthVal=document.getElementById(innerblock.id).offsetWidth;var offsetHeightVal=document.getElementById(innerblock.id).offsetHeight;if(scaleX===-1||scaleY===-1){if(effectType==="circularHideClockwise"&&scaleX===-1&&scaleY===1)effectType="circularHideAntiClockwise";else if(effectType==="circularHideClockwise"&&scaleX===1&&scaleY===-1)effectType="circularHideAntiClockwiseBottom";else if(effectType==="circularHideClockwise"&&scaleX===-1&&scaleY===-1)effectType="circularHideClockwiseBottom";else if(effectType==="circularHideAntiClockwise"&&scaleX===-1&&scaleY===1)effectType="circularHideClockwise";else if(effectType==="circularHideAntiClockwise"&&scaleX===1&&scaleY===-1)effectType="circularHideClockwiseBottom";else if(effectType==="circularHideAntiClockwise"&&scaleX===-1&&scaleY===-1)effectType="circularHideAntiClockwiseBottom";else if(effectType==="circularHideClockwiseRight"&&scaleX===-1&&scaleY===1)effectType="circularHideAntiClockwiseLeft";else if(effectType==="circularHideClockwiseRight"&&scaleX===1&&scaleY===-1)effectType="circularHideAntiClockwiseRight";else if(effectType==="circularHideClockwiseRight"&&scaleX===-1&&scaleY===-1)effectType="circularHideClockwiseLeft";else if(effectType==="circularHideAntiClockwiseRight"&&scaleX===-1&&scaleY===1)effectType="circularHideClockwiseLeft";else if(effectType==="circularHideAntiClockwiseRight"&&scaleX===1&&scaleY===-1)effectType="circularHideClockwiseRight";else if(effectType==="circularHideAntiClockwiseRight"&&scaleX===-1&&scaleY===-1)effectType="circularHideAntiClockwiseLeft";else if(effectType==="circularHideClockwiseLeft"&&scaleX===-1&&scaleY===1)effectType="circularHideAntiClockwiseRight";else if(effectType==="circularHideClockwiseLeft"&&scaleX===1&&scaleY===-1)effectType="circularHideAntiClockwiseLeft";else if(effectType==="circularHideClockwiseLeft"&&scaleX===-1&&scaleY===-1)effectType="circularHideClockwiseRight";else if(effectType==="circularHideAntiClockwiseLeft"&&scaleX===-1&&scaleY===1)effectType="circularHideClockwiseRight";else if(effectType==="circularHideAntiClockwiseLeft"&&scaleX===1&&scaleY===-1)effectType="circularHideClockwiseLeft";else if(effectType==="circularHideAntiClockwiseLeft"&&scaleX===-1&&scaleY===-1)effectType="circularHideAntiClockwiseRight";else if(effectType==="circularHideClockwiseBottom"&&scaleX===-1&&scaleY===1)effectType="circularHideAntiClockwiseBottom";else if(effectType==="circularHideClockwiseBottom"&&scaleX===1&&scaleY===-1)effectType="circularHideAntiClockwise";else if(effectType==="circularHideClockwiseBottom"&&scaleX===-1&&scaleY===-1)effectType="circularHideClockwise";else if(effectType==="circularHideAntiClockwiseBottom"&&scaleX===-1&&scaleY===1)effectType="circularHideClockwiseBottom";else if(effectType==="circularHideAntiClockwiseBottom"&&scaleX===1&&scaleY===-1)effectType="circularHideClockwise";else if(effectType==="circularHideAntiClockwiseBottom"&&scaleX===-1&&scaleY===-1)effectType="circularHideAntiClockwise";}var radiusVal=offsetWidthVal>offsetHeightVal?offsetWidthVal:offsetHeightVal;if(effectType==="circularHideAntiClockwise")effectVars={start:0,endEnter:360,endExit:0};else if(effectType==="circularHideClockwise"||effectType==="SlideCircularReveal")effectVars={start:360,endEnter:0,endExit:360};else if(effectType==="circularHideAntiClockwiseRight")effectVars={start:90,endEnter:this.projectHeight,endExit:90};else if(effectType==="circularHideClockwiseRight")effectVars={start:90,endEnter:-270,endExit:90};else if(effectType==="circularHideAntiClockwiseLeft")effectVars={start:270,endEnter:630,endExit:270};else if(effectType==="circularHideClockwiseLeft")effectVars={start:270,endEnter:-90,endExit:270};else if(effectType==="circularHideAntiClockwiseBottom")effectVars={start:180,endEnter:540,endExit:180};else if(effectType==="circularHideClockwiseBottom")effectVars={start:180,endEnter:-180,endExit:180};var arc={start:effectVars.start,end:effectVars.endEnter,cx:offsetWidthVal/2,cy:offsetHeightVal/2,r:radiusVal};function onStartTween(blockId,type){this.removeMask(innerblock.id);this.addMask(innerblock.id,"circularReveal");clipPath=document.querySelector("#arcPath"+innerblock.id);__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set("arcPath"+innerblock.id,{opacity:1,transformOrigin:"50% 50%"});__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock,{opacity:opacity,transformOrigin:"50% 50%"});}if(effectType==="circularHideAntiClockwise"||effectType==="circularHideAntiClockwiseRight"||effectType==="circularHideAntiClockwiseLeft"||effectType==="circularHideAntiClockwiseBottom"){var updatePath=function updatePath(){if(clipPath!==null)clipPath.setAttribute("d",getPath(arc.cx,arc.cy,arc.r,arc.start,arc.end));};this.tweenToHandler(arc,startTime,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,""],end:effectVars.endExit,ease:__WEBPACK_IMPORTED_MODULE_1_gsap__["d" /* Linear */].easeNone,onUpdate:updatePath},time);}else if(effectType==="circularHideClockwise"||effectType==="SlideCircularReveal"||effectType==="circularHideClockwiseRight"||effectType==="circularHideClockwiseLeft"||effectType==="circularHideClockwiseBottom"){var _updatePath2=function _updatePath2(){if(effectType==="SlideCircularReveal"&&this.props.browserName==="Apple Safari")this.redrawClipPath(innerblock,"#mymask_"+innerblock.id+"circularReveal");if(clipPath!==null)clipPath.setAttribute("d",getPath(arc.cx,arc.cy,arc.r,arc.end,arc.start));};this.tweenToHandler(arc,startTime,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,""],end:effectVars.endExit,ease:__WEBPACK_IMPORTED_MODULE_1_gsap__["d" /* Linear */].easeNone,onUpdate:_updatePath2.bind(this)},time);}function getPath(cx,cy,r,a1,a2){var delta=a2-a1;if(delta===360){return"M "+(cx-r)+" "+cy+" a "+r+" "+r+" 0 1 0 "+r*2+" 0 a "+r+" "+r+" 0 1 0 "+-r*2+" 0z";}var largeArc=delta>180?1:0;a1=a1*Math.PI/180-Math.PI/2;a2=a2*Math.PI/180-Math.PI/2;var x1=cx+r*Math.cos(a2);var y1=cy+r*Math.sin(a2);var x2=cx+r*Math.cos(a1);var y2=cy+r*Math.sin(a1);return"M "+x1+" "+y1+" A "+r+" "+r+" 0 "+largeArc+" 0 "+x2+" "+y2+" L "+cx+" "+cy+"z";}}},{key:'stripeEnterHandler',value:function stripeEnterHandler(innerblock,xval,yval,startTime,enterstart,effectType,scaleX,scaleY,isChild){this.removeMask(innerblock.id);var mask_rect="#mask_"+innerblock.id+"_rect";if(scaleY===-1||scaleX===-1){if(effectType==="stripeTopLeft"&&scaleY===-1&&scaleX===1)effectType="stripe_Bottomleft";else if(effectType==="stripeTopLeft"&&scaleX===-1&&scaleY===1)effectType="stripe_Topright";else if(effectType==="stripeTopLeft"&&scaleX===-1&&scaleY===-1)effectType="stripe_Bottomright";else if(effectType==="stripe_Topright"&&scaleY===-1&&scaleX===1)effectType="stripe_Bottomright";else if(effectType==="stripe_Topright"&&scaleX===-1&&scaleY===1)effectType="stripeTopLeft";else if(effectType==="stripe_Topright"&&scaleX===-1&&scaleY===-1)effectType="stripe_Bottomleft";else if(effectType==="stripe_Bottomleft"&&scaleY===-1&&scaleX===1)effectType="stripeTopLeft";else if(effectType==="stripe_Bottomleft"&&scaleX===-1&&scaleY===1)effectType="stripe_Bottomright";else if(effectType==="stripe_Bottomleft"&&scaleX===-1&&scaleY===-1)effectType="stripe_Topright";else if(effectType==="stripe_Bottomright"&&scaleY===-1&&scaleX===1)effectType="stripe_Topright";else if(effectType==="stripe_Bottomright"&&scaleX===-1&&scaleY===1)effectType="stripe_Bottomleft";else if(effectType==="stripe_Bottomright"&&scaleX===-1&&scaleY===-1)effectType="stripeTopLeft";else if(effectType==="stripeLeftTop"&&scaleY===-1&&scaleX===1)effectType="stripeLeftBottom";else if(effectType==="stripeLeftTop"&&scaleX===-1&&scaleY===1)effectType="stripeRightTop";else if(effectType==="stripeLeftTop"&&scaleX===-1&&scaleY===-1)effectType="stripeRightBottom";else if(effectType==="stripeRightTop"&&scaleY===-1&&scaleX===1)effectType="stripeRightBottom";else if(effectType==="stripeRightTop"&&scaleX===-1&&scaleY===1)effectType="stripeLeftTop";else if(effectType==="stripeRightTop"&&scaleX===-1&&scaleY===-1)effectType="stripeLeftBottom";else if(effectType==="stripeLeftBottom"&&scaleY===-1&&scaleX===1)effectType="stripeLeftTop";else if(effectType==="stripeLeftBottom"&&scaleX===-1&&scaleY===1)effectType="stripeRightBottom";else if(effectType==="stripeLeftBottom"&&scaleX===-1&&scaleY===-1)effectType="stripeRightTop";else if(effectType==="stripeRightBottom"&&scaleY===-1&&scaleX===1)effectType="stripeRightTop";else if(effectType==="stripeRightBottom"&&scaleX===-1&&scaleY===1)effectType="stripeLeftBottom";else if(effectType==="stripeRightBottom"&&scaleX===-1&&scaleY===-1)effectType="stripeLeftTop";}if(effectType==="stripeLeftBottom"||effectType==="stripeRightBottom"||effectType==="stripeLeftTop"||effectType==="stripeRightTop")this.addMask(innerblock.id,"multiWidth");else if(effectType==="stripe_Topright"||effectType==="stripe_Bottomleft"||effectType==="stripeTopLeft"||effectType==="stripe_Bottomright")this.addMask(innerblock.id,"multiHeight");var totalCount=10;var num=0;for(var count=totalCount;count>=0;count--){if(effectType==="stripeLeftBottom")this.tweenFromToHandler(mask_rect+count,startTime/totalCount,{transformOrigin:"bottom",scaleY:0},{transformOrigin:"bottom",scaleY:1},enterstart+count*startTime/totalCount);else if(effectType==="stripeRightBottom")this.tweenFromToHandler(mask_rect+count,startTime/totalCount,{transformOrigin:"bottom",scaleY:0},{transformOrigin:"bottom",scaleY:1},enterstart+num*startTime/totalCount);else if(effectType==="stripe_Bottomright")this.tweenFromToHandler(mask_rect+count,startTime/totalCount,{transformOrigin:"100%",scaleX:0},{transformOrigin:"100%",scaleX:1},enterstart+num*startTime/totalCount);else if(effectType==="stripeLeftTop")this.tweenFromToHandler(mask_rect+count,startTime/totalCount,{scaleY:0},{scaleY:1},enterstart+count*startTime/totalCount);else if(effectType==="stripeRightTop")this.tweenFromToHandler(mask_rect+count,startTime/totalCount,{scaleY:0},{scaleY:1},enterstart+num*startTime/totalCount);else if(effectType==="stripe_Topright")this.tweenFromToHandler(mask_rect+count,startTime/totalCount,{transformOrigin:"100%",scaleX:0},{transformOrigin:"100%",scaleX:1},enterstart+count*startTime/totalCount);else if(effectType==="stripe_Bottomleft")this.tweenFromToHandler(mask_rect+count,startTime/totalCount,{scaleX:0},{scaleX:1},enterstart+num*startTime/totalCount);else if(effectType==="stripeTopLeft")this.tweenFromToHandler(mask_rect+count,startTime/totalCount,{scaleX:0},{scaleX:1},enterstart+count*startTime/totalCount);num++;}}},{key:'fadeinHandler',value:function fadeinHandler(innerblock,startTime,enterstart,opacity,isChild){this.removeMask(innerblock.id);__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock,{opacity:0});this.tweenToHandler(innerblock,startTime,{opacity:opacity,immediateRender:false,ease:__WEBPACK_IMPORTED_MODULE_1_gsap__["a" /* Back */].easeNone},enterstart);}},{key:'scaleEnterHandler',value:function scaleEnterHandler(innerblock,startTime,effectType,scaleX,scaleY,enterTime,rotation,isChild){var _this4=this;this.removeMask(innerblock.id);var onStartTween=function onStartTween(){if(effectType==="scaleTop")_this4.tweenFromToHandler(innerblock.children[0],startTime,{scaleY:0},{opacity:1,scaleY:scaleY,transformOrigin:"0% 0%"},enterTime);else if(effectType==="scaleDown")_this4.tweenFromToHandler(innerblock.children[0],startTime,{scaleY:0,transformOrigin:"0% 100%"},{scaleY:scaleY,transformOrigin:"0% bottom"},enterTime);else if(effectType==="scaleRight")_this4.tweenFromToHandler(innerblock.children[0],startTime,{scaleX:0,transformOrigin:"100% 0%"},{opacity:1,scaleX:scaleX,transformOrigin:"right 0%"},enterTime);else if(effectType==="scaleLeft")_this4.tweenFromToHandler(innerblock.children[0],startTime,{scaleX:0},{opacity:1,scaleX:scaleX,transformOrigin:"0% 0%"},enterTime);};this.tweenAddCallbackHandler({callBack:onStartTween,startTime:0.1,dataArr:[]});}},{key:'bounceEnterHandler',value:function bounceEnterHandler(innerblock,startTime,heightVal,yVal,enterTime,opacity,isChild){var groupYoffset=0;if(isChild)groupYoffset=innerblock.parentNode.getBoundingClientRect().y-innerblock.parentNode.parentNode.getBoundingClientRect().y;this.removeMask(innerblock.id);this.tweenFromToHandler(innerblock,startTime,{y:(heightVal+groupYoffset)*-1},{opacity:opacity,y:yVal-groupYoffset,ease:__WEBPACK_IMPORTED_MODULE_1_gsap__["b" /* Bounce */].easeOut,immediateRender:false},enterTime);}},{key:'redrawClipPath',value:function redrawClipPath(innerblock,mask_rect){innerblock.style.clipPath="none";innerblock.style.clipPath="url("+mask_rect+")";innerblock.style.webkitClipPath="url("+mask_rect+")";innerblock.style.mozClipPath="url("+mask_rect+")";innerblock.style.msClipPath="url("+mask_rect+")";innerblock.style.oClipPath="url("+mask_rect+")";}},{key:'addMask',value:function addMask(elementId,type,direction,rotation,scaleX,scaleY,effectType,isScene){var val=document.getElementById(elementId);var bounds=val.getBoundingClientRect();if(!scaleX)scaleX=1;if(!scaleY)scaleY=1;if(!direction)direction="";if(!type)type="";if(val!==null){var mask_rect="mask_"+elementId+"_rect";var mask_tag=document.createElementNS('http://www.w3.org/2000/svg',"clipPath");var mask_name,myRect;var mySVG=document.createElementNS('http://www.w3.org/2000/svg',"svg");var totalCount=10,count;if(type==="multiWidth"||type==="multiHeight"){mask_name="mymask_"+elementId+type;var _h=val.offsetHeight;var _w=val.offsetWidth;val.style.clipPath="url(#"+mask_name+")";val.style.webkitClipPath="url(#"+mask_name+")";val.style.mozClipPath="url(#"+mask_name+")";val.style.msClipPath="url(#"+mask_name+")";val.style.oClipPath="url(#"+mask_name+")";mask_tag.setAttributeNS(null,"id",mask_name);for(count=0;count<totalCount;count++){if(type==="multiWidth")myRect=this.addMaskDOM("rect",mask_rect+count,count*(_w/totalCount),0,_w/totalCount+1,_h,val.getAttribute("stroke-width"));else if(type==="multiHeight")myRect=this.addMaskDOM("rect",mask_rect+count,0,count*_h/totalCount,_w,_h/totalCount+1,val.getAttribute("stroke-width"));mask_tag.appendChild(myRect);}mySVG.setAttributeNS(null,"width",0);mySVG.setAttributeNS(null,"height",0);mySVG.appendChild(mask_tag);document.getElementById(elementId).appendChild(mySVG);}else if(type==="square"||type==="slidesquare"||type==="pixelsquare"){if(effectType!=="exit"){mask_name="mymask_"+elementId+type;}else{mask_name="mymask_"+elementId+"exitsquare";mask_rect+="exit";}val.style.clipPath="url(#"+mask_name+")";val.style.webkitClipPath="url(#"+mask_name+")";val.style.mozClipPath="url(#"+mask_name+")";val.style.msClipPath="url(#"+mask_name+")";val.style.oClipPath="url(#"+mask_name+")";mask_tag.setAttributeNS(null,"id",mask_name);var _h2=document.getElementById(elementId).offsetHeight;var _w2=document.getElementById(elementId).offsetWidth;var totalSquare=6;if(type==="square")totalSquare=6;for(count=0;count<totalSquare;count++){for(var cnt=0;cnt<totalSquare;cnt++){var changeValY=cnt*_h2/totalSquare;var changeValX=count*_w2/totalSquare;myRect=this.addMaskDOM("rect",mask_rect+count+cnt,changeValX,changeValY,_w2/totalSquare+1,_h2/totalSquare+1,val.getAttribute("stroke-width"));mask_tag.appendChild(myRect);}}mySVG.setAttributeNS(null,"width",0);mySVG.setAttributeNS(null,"height",0);mySVG.appendChild(mask_tag);document.getElementById(elementId).appendChild(mySVG);}else if(type==="splitVer"||type==="splitHor"){totalCount=2;mask_name="mymask_"+elementId+"split";val.style.clipPath="url(#"+mask_name+")";val.style.webkitClipPath="url(#"+mask_name+")";val.style.mozClipPath="url(#"+mask_name+")";val.style.msClipPath="url(#"+mask_name+")";val.style.oClipPath="url(#"+mask_name+")";mask_tag.setAttributeNS(null,"id",mask_name);var _h3=bounds.height;var _w3=bounds.width;for(count=0;count<totalCount;count++){if(type==="splitHor")myRect=this.addMaskDOM("rect",mask_rect+count,0,count*_h3/2,_w3,_h3/totalCount+1,val.getAttribute("stroke-width"));else myRect=this.addMaskDOM("rect",mask_rect+count,count*_w3/2,0,_w3/totalCount+1,_h3,val.getAttribute("stroke-width"));mask_tag.appendChild(myRect);}mySVG.setAttributeNS(null,"width",0);mySVG.setAttributeNS(null,"height",0);mySVG.appendChild(mask_tag);document.getElementById(elementId).appendChild(mySVG);}else if(type==="circle"){mask_name="mymask_"+elementId+type;val.style.clipPath="url(#"+mask_name+")";val.style.webkitClipPath="url(#"+mask_name+")";val.style.mozClipPath="url(#"+mask_name+")";val.style.msClipPath="url(#"+mask_name+")";val.style.oClipPath="url(#"+mask_name+")";mask_tag.setAttributeNS(null,"id",mask_name);var myCir=document.createElementNS('http://www.w3.org/2000/svg',"circle");myCir.setAttributeNS(null,"id",mask_rect);myCir.setAttributeNS(null,"cx",document.getElementById(elementId).offsetWidth/2);myCir.setAttributeNS(null,"cy",document.getElementById(elementId).offsetHeight/2);myCir.setAttributeNS(null,"r",(document.getElementById(elementId).offsetWidth+document.getElementById(elementId).offsetHeight)/2);myCir.setAttributeNS(null,"stroke-width",val.getAttribute("stroke-width"));myCir.setAttributeNS(null,"fill","beige");myCir.setAttributeNS(null,"stroke","beige");mask_tag.appendChild(myCir);mySVG.setAttributeNS(null,"width",0);mySVG.setAttributeNS(null,"height",0);mySVG.appendChild(mask_tag);document.getElementById(elementId).appendChild(mySVG);}else if(type==="circularReveal"){mask_name="mymask_"+elementId+type;val.style.clipPath="url(#"+mask_name+")";val.style.webkitClipPath="url(#"+mask_name+")";val.style.mozClipPath="url(#"+mask_name+")";val.style.msClipPath="url(#"+mask_name+")";val.style.oClipPath="url(#"+mask_name+")";mask_tag.setAttributeNS(null,"id",mask_name);var myPath=document.createElementNS('http://www.w3.org/2000/svg',"path");myPath.setAttributeNS(null,"id","arcPath"+elementId);myPath.setAttributeNS(null,"d"," ");mask_tag.appendChild(myPath);mySVG.setAttributeNS(null,"width",0);mySVG.setAttributeNS(null,"height",0);mySVG.appendChild(mask_tag);document.getElementById(elementId).appendChild(mySVG);}else{mask_name="mymask_"+elementId+type;val.style.clipPath="url(#"+mask_name+")";val.style.webkitClipPath="url(#"+mask_name+")";val.style.mozClipPath="url(#"+mask_name+")";val.style.msClipPath="url(#"+mask_name+")";val.style.oClipPath="url(#"+mask_name+")";mask_tag.setAttributeNS(null,"id",mask_name);var h=bounds.height>document.getElementById(elementId).offsetHeight?bounds.height:document.getElementById(elementId).offsetHeight;//* Math.abs(Math.cos(rotation)) + bounds.width * Math.abs(Math.sin(rotation));
var w=bounds.width>document.getElementById(elementId).offsetWidth?bounds.width:document.getElementById(elementId).offsetWidth;//* Math.abs(Math.cos(rotation)) + bounds.height * Math.abs(Math.sin(rotation));
if(type==="reveal"||type==="irish"){h=document.getElementById(elementId).offsetHeight;w=document.getElementById(elementId).offsetWidth;}myRect=this.addMaskDOM("rect",mask_rect,0,0,w,h);mask_tag.appendChild(myRect);mySVG.setAttributeNS(null,"width",0);mySVG.setAttributeNS(null,"height",0);mySVG.style.top=0;if(rotation){if(scaleX===scaleY)rotation*=-1;var rotVal="rotate("+rotation+")";myRect.setAttribute("transform",rotVal);}mySVG.appendChild(mask_tag);document.getElementById(elementId).appendChild(mySVG);if(type!=="wipe"||type==="wipe"&&rotation!==0){var newx=document.getElementById(elementId).getBoundingClientRect().x-document.getElementById(mask_rect).getBoundingClientRect().x;var newy=document.getElementById(elementId).getBoundingClientRect().y-document.getElementById(mask_rect).getBoundingClientRect().y;myRect.setAttribute("x",newx*scaleX);myRect.setAttribute("y",newy*scaleY);}}}}},{key:'wipeExitHandler',value:function wipeExitHandler(innerblock,startTime,exitstart,effectType,rotation,scaleX,scaleY,opacity,isChild){function onStartTween(blockId,type,rotation){var maskFound=this.maskExist(blockId,"");if(!maskFound){this.removeMask(blockId);this.addMask(blockId,"wipe","",rotation,scaleX,scaleY,"",!innerblock.classList.contains("scene-item"));}var mask_rect="#mask_"+blockId+"_rect";var idVal=document.getElementById(innerblock.id);var bboxVal=idVal.getBoundingClientRect();var offset=2;var yval=document.getElementById("mask_"+innerblock.id+"_rect").getAttribute("y");var xval=document.getElementById("mask_"+innerblock.id+"_rect").getAttribute("x");__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(mask_rect,{opacity:1,transformOrigin:"50% 50%"});__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock,{opacity:opacity,transformOrigin:"50% 50%"});if(type==="wipeTop")this.tweenToHandler(mask_rect,startTime,{attr:{y:parseFloat(yval)+(bboxVal.height+offset)*scaleY}},exitstart);else if(type==="wipeDown")this.tweenToHandler(mask_rect,startTime,{attr:{y:parseFloat(yval)+(bboxVal.height+offset)*-scaleY}},exitstart);else if(type==="wipeRight")this.tweenToHandler(mask_rect,startTime,{attr:{x:parseFloat(xval)+(bboxVal.width+offset)*-scaleX}},exitstart);else if(type==="wipeLeft")this.tweenToHandler(mask_rect,startTime,{attr:{x:parseFloat(xval)+(bboxVal.width+offset)*scaleX}},exitstart);else if(this.props.browserName!=="Apple Safari"){if(type==="WipeBottom")this.tweenToHandler(mask_rect,startTime,{attr:{y:parseFloat(yval)+bboxVal.height+offset}},exitstart);else if(type==="WipeTop")this.tweenToHandler(mask_rect,startTime,{attr:{y:parseFloat(yval)+(bboxVal.height+offset)*-1}},exitstart);else if(type==="WipeLeft")this.tweenToHandler(mask_rect,startTime,{attr:{x:parseFloat(xval)+(bboxVal.width+offset)*-1}},exitstart);else if(type==="WipeRight")this.tweenToHandler(mask_rect,startTime,{attr:{x:parseFloat(xval)+(bboxVal.width+offset)}},exitstart);}else{if(type==="WipeBottom")this.tweenToHandler(mask_rect,startTime,{attr:{y:parseFloat(yval)+bboxVal.height+offset},onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+"wipe"]},exitstart);else if(type==="WipeTop")this.tweenToHandler(mask_rect,startTime,{attr:{y:parseFloat(yval)+(bboxVal.height+offset)*-1},onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+"wipe"]},exitstart);else if(type==="WipeLeft")this.tweenToHandler(mask_rect,startTime,{attr:{x:parseFloat(xval)+(bboxVal.width+offset)*-1},onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+"wipe"]},exitstart);else if(type==="WipeRight")this.tweenToHandler(mask_rect,startTime,{attr:{x:parseFloat(xval)+(bboxVal.width+offset)},onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+"wipe"]},exitstart);}}this.tweenfromHandler(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,effectType,rotation,opacity],opacity:opacity},exitstart);}},{key:'wipeEnterHandler',value:function wipeEnterHandler(innerblock,startTime,effectType,rotation,scaleX,scaleY,enterTime,isChild){this.removeMask(innerblock.id);if(innerblock.getElementsByClassName("text-container")[0])this.addMask(innerblock.id,"wipe","",rotation,scaleX,scaleY,true);else this.addMask(innerblock.id,"wipe","",rotation,scaleX,scaleY,false);var mask_rect="#mask_"+innerblock.id+"_rect";var idVal=document.getElementById(innerblock.id);var bboxVal=idVal.getBoundingClientRect();__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(mask_rect,{opacity:1,transformOrigin:"50% 50%"});//Inba - For wipe enter effect items - innerblock element is shown so changing its opacity to 0
__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock,{opacity:0,transformOrigin:"50% 50%"});var yval=document.getElementById("mask_"+innerblock.id+"_rect").getAttribute("y");var xval=document.getElementById("mask_"+innerblock.id+"_rect").getAttribute("x");if(effectType==="wipeTop")this.tweenfromHandler(mask_rect,startTime,{attr:{y:parseFloat(yval)+bboxVal.height*-scaleY}},enterTime);else if(effectType==="wipeDown")this.tweenfromHandler(mask_rect,startTime,{attr:{y:parseFloat(yval)+bboxVal.height*scaleY}},enterTime);else if(effectType==="wipeRight")this.tweenfromHandler(mask_rect,startTime,{attr:{x:parseFloat(xval)+bboxVal.width*scaleX}},enterTime);else if(effectType==="wipeLeft")this.tweenfromHandler(mask_rect,startTime,{attr:{x:parseFloat(xval)+bboxVal.width*-scaleX}},enterTime);this.tweenToHandler(innerblock,0.1,{"clip-path":""},enterTime+startTime);}},{key:'splitFromCenterEnterHandler',value:function splitFromCenterEnterHandler(innerblock,startTime,effectType,enterTime,isChild){this.removeMask(innerblock.id,"reveal");this.addMask(innerblock.id,"reveal");var mask_rect="#mask_"+innerblock.id+"_rect";__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(mask_rect,{attr:{x:0,y:0},opacity:1,transformOrigin:"50% 50%"});__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock,{opacity:1,transformOrigin:"50% 50%"});if(effectType==="verticalSplit")this.tweenFromToHandler(mask_rect,startTime,{scaleX:0,transformOrigin:"50% 50%"},{scaleX:1,transformOrigin:"50% 50%",attr:{y:0}},enterTime);else if(effectType==="horizontalSplit")this.tweenFromToHandler(mask_rect,startTime,{scaleY:0,transformOrigin:"50% 50%"},{scaleY:1,transformOrigin:"50% 50%",attr:{y:0}},enterTime);}},{key:'irishExitHandler',value:function irishExitHandler(innerblock,startTime,exitstart,effectType,isChild){function onStartTween(blockId,type){if(!type)type="";var maskFound=this.maskExist(blockId,type);if(!maskFound){this.removeMask(blockId);this.addMask(blockId,type);}var mask_rect="#mask_"+blockId+"_rect";__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(mask_rect,{scale:1,transformOrigin:"50% 50%"});__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock,{scale:1,transformOrigin:"50% 50%"});if(effectType!=="SlideIrisSquare"&&effectType!=="SlideIrisCircle"||this.props.browserName!=="Apple Safari")this.tweenToHandler(mask_rect,startTime,{scale:0,transformOrigin:"50% 50%"},exitstart);else if(this.props.browserName==="Apple Safari"&&(effectType==="SlideIrisSquare"||effectType==="SlideIrisCircle"))this.tweenToHandler(mask_rect,startTime,{scale:0,transformOrigin:"50% 50%",onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]},exitstart);}if(effectType==="irishSquare"||effectType==="SlideIrisSquare")this.tweenfromHandler(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"irish"],opacity:1},exitstart);else if(effectType==="irishCircle"||effectType==="SlideIrisCircle")this.tweenfromHandler(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"circle"],opacity:1},exitstart);}},{key:'circularHideAntiClockwiseBottom',value:function circularHideAntiClockwiseBottom(innerblock,startTime,t1,exitstart){function onStartTween(blockId,type){if(!type)type="";var maskFound=this.maskExist(blockId,type);if(!maskFound){this.removeMask(blockId);this.addMask(blockId,type);}var mask_rect="#mask_"+blockId+"_rect";__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(mask_rect,{rotation:"-270",transformOrigin:"50% 50%"});this.tweenFromToHandler(mask_rect,startTime,{drawSVG:"0% 100%"},{drawSVG:"100% 100%"},exitstart);}this.tweenfromHandler(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"circularReveal"],opacity:1},exitstart);}},{key:'moveEnterHandler',value:function moveEnterHandler(innerblock,xval,yval,rotation,startTime,enterstart,effectType,scaleX,scaleY,isChild){this.removeMask(innerblock.id);this.addMask(innerblock.id,"wipe","",rotation,scaleX,scaleY);var mask_rect="#mask_"+innerblock.id+"_rect";var idVal=document.getElementById(innerblock.id);var bboxVal=idVal.getBoundingClientRect();var yvalue=document.getElementById("mask_"+innerblock.id+"_rect").getAttribute("y");var xvalue=document.getElementById("mask_"+innerblock.id+"_rect").getAttribute("x");var groupXoffset=0,groupYoffset=0;if(isChild){groupXoffset=innerblock.parentNode.getBoundingClientRect().x-innerblock.parentNode.parentNode.getBoundingClientRect().x;groupYoffset=innerblock.parentNode.getBoundingClientRect().y-innerblock.parentNode.parentNode.getBoundingClientRect().y;}if(effectType==="moveFromTop"){this.tweenFromToHandler(innerblock,startTime,{y:yval-innerblock.offsetHeight-groupYoffset},{y:yval-groupYoffset},enterstart);this.tweenfromHandler(mask_rect,startTime,{attr:{y:parseFloat(yvalue)+innerblock.offsetHeight*scaleY}},enterstart);}else if(effectType==="moveFromDown"){this.tweenFromToHandler(innerblock,startTime,{y:yval+innerblock.offsetHeight-groupYoffset},{y:yval-groupYoffset},enterstart);this.tweenfromHandler(mask_rect,startTime,{attr:{y:parseFloat(yvalue)+innerblock.offsetHeight*-scaleY}},enterstart);}else if(effectType==="moveFromLeft"){this.tweenFromToHandler(innerblock,startTime,{x:xval-innerblock.offsetWidth-groupXoffset},{x:xval-groupXoffset},enterstart);this.tweenfromHandler(mask_rect,startTime,{attr:{x:parseFloat(xvalue)+innerblock.offsetWidth*scaleX}},enterstart);}else if(effectType==="moveFromRight"){this.tweenFromToHandler(innerblock,startTime,{x:xval+innerblock.offsetWidth-groupXoffset},{x:xval-groupXoffset},enterstart);this.tweenfromHandler(mask_rect,startTime,{attr:{x:parseFloat(xvalue)+innerblock.offsetWidth*-scaleX}},enterstart);}this.tweenToHandler(innerblock,0.1,{"clip-path":""},enterstart+startTime);}},{key:'photoEnterHandler',value:function photoEnterHandler(innerblock,xval,yval,startTime,enterstart,isChild){this.removeMask(innerblock.id);this.tweenFromToHandler(innerblock,startTime,{opacity:0},{opacity:1},enterstart);}},{key:'pixelEnterHandler',value:function pixelEnterHandler(innerblock,xval,yval,startTime,enterstart,isChild){this.removeMask(innerblock.id);this.addMask(innerblock.id,"pixelsquare");var mask_rect="#mask_"+innerblock.id+"_rect";var totalCount=20;var maskGroup=[];for(var count=0;count<totalCount;count++){for(var cnt=0;cnt<totalCount;cnt++){maskGroup.push(mask_rect+count+cnt);}}maskGroup=shuffle(maskGroup);function shuffle(array){var m=array.length,t,i;while(m){i=Math.floor(Math.random()*m--);t=array[m];array[m]=array[i];array[i]=t;}return array;}this.tweenStaggerFromToHandler(maskGroup,startTime,{transformOrigin:"50% 50%",display:"none"},{transformOrigin:"50% 50%",display:"block"},startTime/Math.pow(totalCount,2),enterstart);this.tweenToHandler(innerblock,0.01,{"clip-path":""},startTime+enterstart);}},{key:'brightSquareEnterHandler',value:function brightSquareEnterHandler(innerblock,xval,yval,startTime,enterstart,isChild){this.removeMask(innerblock.id);this.addMask(innerblock.id,"square");var mask_rect="#mask_"+innerblock.id+"_rect";var totalCount=6;for(var count=0;count<totalCount;count++){for(var cnt=0;cnt<totalCount;cnt++){this.tweenFromToHandler(mask_rect+count+cnt,startTime,{transformOrigin:"50% 50%",scale:0},{transformOrigin:"50% 50%",scale:1},enterstart);}}this.tweenToHandler(innerblock,0.01,{"clip-path":""},enterstart+startTime);}},{key:'stripeExitHandler',value:function stripeExitHandler(innerblock,xval,yval,startTime,enterstart,effectType,scaleX,scaleY,opacity,isChild){if(scaleY===-1||scaleX===-1){if(effectType==="stripeTopLeft"&&scaleY===-1&&scaleX===1)effectType="stripe_Bottomleft";else if(effectType==="stripeTopLeft"&&scaleX===-1&&scaleY===1)effectType="stripe_Topright";else if(effectType==="stripeTopLeft"&&scaleX===-1&&scaleY===-1)effectType="stripe_Bottomright";else if(effectType==="stripe_Topright"&&scaleY===-1&&scaleX===1)effectType="stripe_Bottomright";else if(effectType==="stripe_Topright"&&scaleX===-1&&scaleY===1)effectType="stripeTopLeft";else if(effectType==="stripe_Topright"&&scaleX===-1&&scaleY===-1)effectType="stripe_Bottomleft";else if(effectType==="stripe_Bottomleft"&&scaleY===-1&&scaleX===1)effectType="stripeTopLeft";else if(effectType==="stripe_Bottomleft"&&scaleX===-1&&scaleY===1)effectType="stripe_Bottomright";else if(effectType==="stripe_Bottomleft"&&scaleX===-1&&scaleY===-1)effectType="stripe_Topright";else if(effectType==="stripe_Bottomright"&&scaleY===-1&&scaleX===1)effectType="stripe_Topright";else if(effectType==="stripe_Bottomright"&&scaleX===-1&&scaleY===1)effectType="stripe_Bottomleft";else if(effectType==="stripe_Bottomright"&&scaleX===-1&&scaleY===-1)effectType="stripeTopLeft";else if(effectType==="stripeLeftTop"&&scaleY===-1&&scaleX===1)effectType="stripeLeftBottom";else if(effectType==="stripeLeftTop"&&scaleX===-1&&scaleY===1)effectType="stripeRightTop";else if(effectType==="stripeLeftTop"&&scaleX===-1&&scaleY===-1)effectType="stripeRightBottom";else if(effectType==="stripeRightTop"&&scaleY===-1&&scaleX===1)effectType="stripeRightBottom";else if(effectType==="stripeRightTop"&&scaleX===-1&&scaleY===1)effectType="stripeLeftTop";else if(effectType==="stripeRightTop"&&scaleX===-1&&scaleY===-1)effectType="stripeLeftBottom";else if(effectType==="stripeLeftBottom"&&scaleY===-1&&scaleX===1)effectType="stripeLeftTop";else if(effectType==="stripeLeftBottom"&&scaleX===-1&&scaleY===1)effectType="stripeRightBottom";else if(effectType==="stripeLeftBottom"&&scaleX===-1&&scaleY===-1)effectType="stripeRightTop";else if(effectType==="stripeRightBottom"&&scaleY===-1&&scaleX===1)effectType="stripeRightTop";else if(effectType==="stripeRightBottom"&&scaleX===-1&&scaleY===1)effectType="stripeLeftBottom";else if(effectType==="stripeRightBottom"&&scaleX===-1&&scaleY===-1)effectType="stripeLeftTop";}function onStartTween(blockId,type,effectType){if(!type)type="";var maskFound=this.maskExist(blockId,type);if(!maskFound){this.removeMask(blockId);this.addMask(blockId,type);}var mask_rect="#mask_"+blockId+"_rect";var totalCount=10;var num=0,count=0;__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(mask_rect,{opacity:1,transformOrigin:"50% 50%"});__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock,{opacity:opacity,transformOrigin:"50% 50%"});if(effectType==="stripe_Topright"||effectType==="stripeTopLeft"||effectType==="stripeLeftTop"||effectType==="stripeLeftBottom"||effectType==="stripeRightBottom"||effectType==="SlideStripeRight"||effectType==="SlideStripeLeft"||effectType==="SlideStripeBottom"||effectType==="SlideStripeTop"){for(count=0;count<totalCount;count++){if(effectType==="stripeTopLeft")this.tweenToHandler(mask_rect+count,startTime/totalCount,{scaleX:0},enterstart+count*startTime/totalCount);else if(effectType==="stripe_Topright")this.tweenToHandler(mask_rect+count,startTime/totalCount,{transformOrigin:"100%",scaleX:0},enterstart+count*startTime/totalCount);else if(effectType==="stripeLeftBottom")this.tweenToHandler(mask_rect+count,startTime/totalCount,{scaleY:0},enterstart+count*startTime/totalCount);else if(effectType==="stripeLeftTop")this.tweenToHandler(mask_rect+count,startTime/totalCount,{transformOrigin:"bottom",scaleY:0},enterstart+count*startTime/totalCount);else if(effectType==="stripeRightBottom")this.tweenToHandler(mask_rect+count,startTime/totalCount,{transformOrigin:"bottom",scaleY:0},enterstart+num*startTime/totalCount);else if(this.props.browserName!=="Apple Safari"){if(effectType==="SlideStripeRight")this.tweenToHandler(mask_rect+count,startTime/totalCount,{scaleX:0},enterstart+count*startTime/totalCount);else if(effectType==="SlideStripeLeft")this.tweenToHandler(mask_rect+count,startTime/totalCount,{transformOrigin:"100%",scaleX:0},enterstart+count*startTime/totalCount);else if(effectType==="SlideStripeBottom")this.tweenToHandler(mask_rect+count,startTime/totalCount,{scaleY:0},enterstart+count*startTime/totalCount);else if(effectType==="SlideStripeTop")this.tweenToHandler(mask_rect+count,startTime/totalCount,{transformOrigin:"bottom",scaleY:0},enterstart+count*startTime/totalCount);}else{if(effectType==="SlideStripeRight")this.tweenToHandler(mask_rect+count,startTime/totalCount,{scaleX:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]},enterstart+count*startTime/totalCount);else if(effectType==="SlideStripeLeft")this.tweenToHandler(mask_rect+count,startTime/totalCount,{transformOrigin:"100%",scaleX:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]},enterstart+count*startTime/totalCount);else if(effectType==="SlideStripeBottom")this.tweenToHandler(mask_rect+count,startTime/totalCount,{scaleY:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]},enterstart+count*startTime/totalCount);else if(effectType==="SlideStripeTop")this.tweenToHandler(mask_rect+count,startTime/totalCount,{transformOrigin:"bottom",scaleY:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]},enterstart+count*startTime/totalCount);}num++;}}else if(effectType==="stripe_Bottomleft"||effectType==="stripe_Bottomright"||effectType==="stripeRightTop"){for(count=totalCount;count>=0;count--){if(effectType==="stripe_Bottomright")this.tweenToHandler(mask_rect+count,startTime/totalCount,{scaleX:0},enterstart+num*startTime/totalCount);else if(effectType==="stripe_Bottomleft")this.tweenToHandler(mask_rect+count,startTime/totalCount,{transformOrigin:"100%",scaleX:0},enterstart+num*startTime/totalCount);else if(effectType==="stripeRightTop")this.tweenToHandler(mask_rect+count,startTime/totalCount,{scaleY:0},enterstart+num*startTime/totalCount);num++;}}}if(effectType==="stripe_Topright"||effectType==="SlideStripeRight")this.tweenfromHandler(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"multiHeight",effectType],opacity:1},enterstart);else if(effectType==="stripeTopLeft"||effectType==="SlideStripeLeft")this.tweenfromHandler(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"multiHeight",effectType],opacity:1},enterstart);else if(effectType==="stripe_Bottomleft")this.tweenfromHandler(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"multiHeight",effectType],opacity:1},enterstart);else if(effectType==="stripe_Bottomright")this.tweenfromHandler(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"multiHeight",effectType],opacity:1},enterstart);else if(effectType==="stripeLeftBottom"||effectType==="SlideStripeBottom")this.tweenfromHandler(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"multiWidth",effectType],opacity:1},enterstart);else if(effectType==="stripeRightTop")this.tweenfromHandler(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"multiWidth",effectType],opacity:1},enterstart);else if(effectType==="stripeLeftTop"||effectType==="SlideStripeTop")this.tweenfromHandler(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"multiWidth",effectType],opacity:1},enterstart);else if(effectType==="stripeRightBottom")this.tweenfromHandler(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"multiWidth",effectType],opacity:1},enterstart);}},{key:'blindsEnterHandler',value:function blindsEnterHandler(innerblock,xval,yval,startTime,enterstart,effectName,scaleX,scaleY,isChild){this.removeMask(innerblock.id);if(scaleY===-1||scaleX===-1){if(effectName==="blindsTop"&&scaleY===-1)effectName="blindsBottom";else if(effectName==="blindsBottom"&&scaleY===-1)effectName="blindsTop";else if(effectName==="blindsRight"&&scaleX===-1)effectName="blindsLeft";else if(effectName==="blindsLeft"&&scaleX===-1)effectName="blindsRight";}if(effectName==="blindsLeft"||effectName==="blindsRight")this.addMask(innerblock.id,"multiWidth");else if(effectName==="blindsTop"||effectName==="blindsBottom")this.addMask(innerblock.id,"multiHeight");var mask_rect="#mask_"+innerblock.id+"_rect";var totalCount=10;for(var count=0;count<totalCount;count++){if(effectName==="blindsLeft")this.tweenFromToHandler(mask_rect+count,startTime,{scaleX:0},{scaleX:1},enterstart);else if(effectName==="blindsRight")this.tweenFromToHandler(mask_rect+count,startTime,{transformOrigin:"100%",scaleX:0},{transformOrigin:"100%",scaleX:1},enterstart);else if(effectName==="blindsTop")this.tweenFromToHandler(mask_rect+count,startTime,{scaleY:0},{scaleY:1},enterstart);else if(effectName==="blindsBottom")this.tweenFromToHandler(mask_rect+count,startTime,{transformOrigin:"bottom",scaleY:0},{transformOrigin:"bottom",scaleY:1},enterstart);}this.tweenToHandler(innerblock,0.1,{"clip-path":""},startTime+enterstart);}},{key:'blindsExitHandler',value:function blindsExitHandler(innerblock,xval,yval,endTime,exitstart,effectType,scaleX,scaleY,opacity,isChild){if(scaleY===-1||scaleX===-1){if(effectType==="blindsTop"&&scaleY===-1)effectType="blindsBottom";else if(effectType==="blindsBottom"&&scaleY===-1)effectType="blindsTop";else if(effectType==="blindsRight"&&scaleX===-1)effectType="blindsLeft";else if(effectType==="blindsLeft"&&scaleX===-1)effectType="blindsRight";}function onStartTween(blockId,type){if(!type)type="";var maskFound=this.maskExist(blockId,type);if(!maskFound){this.removeMask(blockId);this.addMask(blockId,type);}var mask_rect="#mask_"+blockId+"_rect";__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(mask_rect,{opacity:1,transformOrigin:"50% 50%"});__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock,{opacity:opacity,transformOrigin:"50% 50%"});var totalCount=10;for(var count=0;count<totalCount;count++){if(effectType==="blindsLeft")this.tweenToHandler(mask_rect+count,endTime,{scaleX:0},exitstart);else if(effectType==="blindsRight")this.tweenToHandler(mask_rect+count,endTime,{transformOrigin:"100%",scaleX:0},exitstart);else if(effectType==="blindsTop")this.tweenToHandler(mask_rect+count,endTime,{scaleY:0},exitstart);else if(effectType==="blindsBottom")this.tweenToHandler(mask_rect+count,endTime,{transformOrigin:"bottom",scaleY:0},exitstart);else if(this.props.browserName!=="Apple Safari"){if(effectType==="SlideBlindsVerLeft")this.tweenToHandler(mask_rect+count,endTime,{scaleX:0},exitstart);else if(effectType==="SlideBlindsVerRight")this.tweenToHandler(mask_rect+count,endTime,{transformOrigin:"100%",scaleX:0},exitstart);else if(effectType==="SlideBlindsHorUp")this.tweenToHandler(mask_rect+count,endTime,{scaleY:0},exitstart);else if(effectType==="SlideBlindsHorDown")this.tweenToHandler(mask_rect+count,endTime,{transformOrigin:"bottom",scaleY:0},exitstart);}else{if(effectType==="SlideBlindsVerLeft")this.tweenToHandler(mask_rect+count,endTime,{scaleX:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]},exitstart);else if(effectType==="SlideBlindsVerRight")this.tweenToHandler(mask_rect+count,endTime,{transformOrigin:"100%",scaleX:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]},exitstart);else if(effectType==="SlideBlindsHorUp")this.tweenToHandler(mask_rect+count,endTime,{scaleY:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]},exitstart);else if(effectType==="SlideBlindsHorDown")this.tweenToHandler(mask_rect+count,endTime,{transformOrigin:"bottom",scaleY:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]},exitstart);}}}if(effectType==="blindsLeft"||effectType==="SlideBlindsVerLeft")this.tweenfromHandler(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"multiWidth"],opacity:1},exitstart);else if(effectType==="blindsRight"||effectType==="SlideBlindsVerRight")this.tweenfromHandler(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"multiWidth"],opacity:1},exitstart);else if(effectType==="blindsTop"||effectType==="SlideBlindsHorUp")this.tweenfromHandler(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"multiHeight"],opacity:1},exitstart);else if(effectType==="blindsBottom"||effectType==="SlideBlindsHorDown")this.tweenfromHandler(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"multiHeight"],opacity:1},exitstart);}},{key:'irishEnterHandler',value:function irishEnterHandler(innerblock,startTime,effectType,enterTime,isChild){this.removeMask(innerblock.id);if(effectType==="irishSquare")this.addMask(innerblock.id,"irish");else if(effectType==="irishCircle")this.addMask(innerblock.id,"circle");var mask_rect="#mask_"+innerblock.id+"_rect";__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(mask_rect,{attr:{x:0,y:0},opacity:1,transformOrigin:"50% 50%"});__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock,{opacity:1,transformOrigin:"50% 50%"});this.tweenFromToHandler(mask_rect,startTime,{scale:0,transformOrigin:"50% 50%"},{scale:1,transformOrigin:"50% 50%"},enterTime);}},{key:'EnterFromRightBottom',value:function EnterFromRightBottom(innerblock,startTime,heightVal,widthVal,xval,yval,enterTime,isChild){var groupXoffset=0,groupYoffset=0;if(isChild){groupXoffset=innerblock.parentNode.getBoundingClientRect().x-innerblock.parentNode.parentNode.getBoundingClientRect().x;groupYoffset=innerblock.parentNode.getBoundingClientRect().y-innerblock.parentNode.parentNode.getBoundingClientRect().y;}this.removeMask(innerblock.id);__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock,{x:this.projectWidth*this.props.zoomFactor,y:this.projectHeight*this.props.zoomFactor});this.tweenToHandler(innerblock,startTime,{x:xval-groupXoffset,y:yval-groupYoffset},enterTime);}},{key:'EnterFromLeftTop',value:function EnterFromLeftTop(innerblock,startTime,heightVal,widthVal,xval,yval,enterTime,isChild){var groupXoffset=0,groupYoffset=0;if(isChild){groupXoffset=innerblock.parentNode.getBoundingClientRect().x-innerblock.parentNode.parentNode.getBoundingClientRect().x;groupYoffset=innerblock.parentNode.getBoundingClientRect().y-innerblock.parentNode.parentNode.getBoundingClientRect().y;}this.removeMask(innerblock.id);__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock,{x:widthVal*-1,y:heightVal*-1});this.tweenToHandler(innerblock,startTime,{x:xval-groupXoffset,y:yval-groupYoffset},enterTime);}},{key:'EnterFromLeftBottom',value:function EnterFromLeftBottom(innerblock,startTime,heightVal,widthVal,xval,yval,enterTime,isChild){var groupXoffset=0,groupYoffset=0;if(isChild){groupXoffset=innerblock.parentNode.getBoundingClientRect().x-innerblock.parentNode.parentNode.getBoundingClientRect().x;groupYoffset=innerblock.parentNode.getBoundingClientRect().y-innerblock.parentNode.parentNode.getBoundingClientRect().y;}this.removeMask(innerblock.id);__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock,{x:widthVal*-1,y:this.projectHeight*this.props.zoomFactor});this.tweenToHandler(innerblock,startTime,{x:xval-groupXoffset,y:yval-groupYoffset},enterTime);}},{key:'EnterFromBottom',value:function EnterFromBottom(innerblock,startTime,heightVal,widthVal,xval,yval,enterTime,isChild){var groupXoffset=0,groupYoffset=0;if(isChild){groupXoffset=innerblock.parentNode.getBoundingClientRect().x-innerblock.parentNode.parentNode.getBoundingClientRect().x;groupYoffset=innerblock.parentNode.getBoundingClientRect().y-innerblock.parentNode.parentNode.getBoundingClientRect().y;}this.removeMask(innerblock.id);__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock,{y:this.projectHeight*this.props.zoomFactor});this.tweenToHandler(innerblock,startTime,{x:xval-groupXoffset,y:yval-groupYoffset},enterTime);}},{key:'EnterFromTop',value:function EnterFromTop(innerblock,startTime,heightVal,widthVal,xval,yval,enterTime,isChild){var groupXoffset=0,groupYoffset=0;if(isChild){groupXoffset=innerblock.parentNode.getBoundingClientRect().x-innerblock.parentNode.parentNode.getBoundingClientRect().x;groupYoffset=innerblock.parentNode.getBoundingClientRect().y-innerblock.parentNode.parentNode.getBoundingClientRect().y;}this.removeMask(innerblock.id);__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock,{y:heightVal*-1});this.tweenToHandler(innerblock,startTime,{x:xval-groupXoffset,y:yval-groupYoffset},enterTime);}},{key:'EnterFromLeft',value:function EnterFromLeft(innerblock,startTime,heightVal,widthVal,xval,yval,enterTime,isChild){var groupXoffset=0,groupYoffset=0;if(isChild){groupXoffset=innerblock.parentNode.getBoundingClientRect().x-innerblock.parentNode.parentNode.getBoundingClientRect().x;groupYoffset=innerblock.parentNode.getBoundingClientRect().y-innerblock.parentNode.parentNode.getBoundingClientRect().y;}this.removeMask(innerblock.id);__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock,{x:widthVal*-1});this.tweenToHandler(innerblock,startTime,{x:xval-groupXoffset,y:yval-groupYoffset},enterTime);}},{key:'EnterFromRight',value:function EnterFromRight(innerblock,startTime,heightVal,widthVal,xval,yval,enterTime,isChild){var groupXoffset=0,groupYoffset=0;if(isChild){groupXoffset=innerblock.parentNode.getBoundingClientRect().x-innerblock.parentNode.parentNode.getBoundingClientRect().x;groupYoffset=innerblock.parentNode.getBoundingClientRect().y-innerblock.parentNode.parentNode.getBoundingClientRect().y;}this.removeMask(innerblock.id);__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock,{x:this.projectWidth*this.props.zoomFactor});this.tweenToHandler(innerblock,startTime,{x:xval-groupXoffset,y:yval-groupYoffset},enterTime);}},{key:'EnterFromRightTop',value:function EnterFromRightTop(innerblock,startTime,heightVal,widthVal,xval,yval,enterTime,isChild){var groupXoffset=0,groupYoffset=0;if(isChild){groupXoffset=innerblock.parentNode.getBoundingClientRect().x-innerblock.parentNode.parentNode.getBoundingClientRect().x;groupYoffset=innerblock.parentNode.getBoundingClientRect().y-innerblock.parentNode.parentNode.getBoundingClientRect().y;}this.removeMask(innerblock.id);__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock,{x:this.projectWidth*this.props.zoomFactor,y:heightVal*-1});this.tweenToHandler(innerblock,startTime,{x:xval-groupXoffset,y:yval-groupXoffset},enterTime);}},{key:'rotationEnterHandler',value:function rotationEnterHandler(innerblock,startTime,rotation,scaleX,scaleY,time,isChild){this.removeMask(innerblock.id);this.tweenFromToHandler(innerblock,startTime,{scale:0,transformOrigin:"50% 50%"},{scaleX:scaleX,scaleY:scaleY,rotation:rotation+360,transformOrigin:"50% 50%"},time);this.tweenToHandler(innerblock,0.001,{rotation:rotation},time+startTime);}},{key:'blurEnterHandler',value:function blurEnterHandler(innerblock,startTime){this.removeMask(innerblock.id);this.addFilter(innerblock.id);var filterName="#myfilter_"+innerblock.id;var blurNode=filterName;return __WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].to(blurNode,startTime,{attr:{stdDeviation:0}},"blur");}},{key:'popupHandler',value:function popupHandler(innerblock,startTime,scaleX,scaleY,enterTime,isChild){this.removeMask(innerblock.id);__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock,{scaleX:0,scaleY:0,transformOrigin:"50% 50%"});this.tweenToHandler(innerblock,startTime,{scaleX:scaleX,scaleY:scaleY,transformOrigin:"50% 50%",immediateRender:false,ease:__WEBPACK_IMPORTED_MODULE_1_gsap__["a" /* Back */].easeOut},enterTime);}},{key:'popupTransformHandler',value:function popupTransformHandler(innerblock,startTime,scaleX,scaleY,enterTime,type,rotation,xval,yval,isChild){var _this5=this;var groupXoffset=0,groupYoffset=0,rotateHeightOffset=0,rotateWidthOffset=0;if(isChild){groupXoffset=innerblock.parentNode.getBoundingClientRect().x-innerblock.parentNode.parentNode.getBoundingClientRect().x;groupYoffset=innerblock.parentNode.getBoundingClientRect().y-innerblock.parentNode.parentNode.getBoundingClientRect().y;}if(rotation){rotateHeightOffset=(innerblock.getBoundingClientRect().height-innerblock.clientHeight)/2;rotateWidthOffset=(innerblock.getBoundingClientRect().width-innerblock.clientWidth)/2;}var updateWrapper=function updateWrapper(){if(!document.getElementById(innerblock.id+"_tempWrapper")){var parent=innerblock.parentNode;var wrapper=document.createElement("div");parent.replaceChild(wrapper,innerblock);wrapper.appendChild(innerblock);innerblock.parentNode.style.width=innerblock.getBoundingClientRect().width+"px";innerblock.parentNode.style.height=innerblock.getBoundingClientRect().height+"px";innerblock.parentNode.style.display="block";innerblock.parentNode.style.position="absolute";innerblock.parentNode.setAttribute("id",innerblock.id+"_tempWrapper");var transformOriginVal="0% 0%";if(type==="popupFromLeft")transformOriginVal="0% 50%";if(type==="popupFromRight")transformOriginVal="100% 50%";if(type==="popupFromTop")transformOriginVal="50% 0%";if(type==="popupFromBottom")transformOriginVal="50% 100%";if(type==="popupFromBottomLeft")transformOriginVal="0% 100%";if(type==="popupFromBottomRight")transformOriginVal="100% 100%";if(type==="popupFromTopLeft")transformOriginVal="0% 0%";if(type==="popupFromTopRight")transformOriginVal="100% 0%";if(type==="popupFromCenter")transformOriginVal="50% 50%";_this5.removeMask(innerblock.id);_this5.t1.to(innerblock.parentNode,startTime,{scaleX:1,scaleY:1,immediateRender:false,ease:__WEBPACK_IMPORTED_MODULE_1_gsap__["a" /* Back */].easeOut},enterTime);innerblock.style.left=-xval+rotateWidthOffset+groupXoffset+"px";innerblock.style.top=-yval+rotateHeightOffset+groupYoffset+"px";__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock.parentNode,{x:xval-groupXoffset-rotateWidthOffset,y:yval-groupYoffset-rotateHeightOffset,transformOrigin:transformOriginVal,scaleX:0,scaleY:0});}};function delWrapper(){// var parentNode = innerblock.parentNode.parentNode;
// parentNode.insertBefore(innerblock, innerblock.parentNode);
if(document.getElementById(innerblock.id+"_tempWrapper")){var _document$getElementB;(_document$getElementB=document.getElementById(innerblock.id+"_tempWrapper")).replaceWith.apply(_document$getElementB,_toConsumableArray(document.getElementById(innerblock.id+"_tempWrapper").childNodes));}// parentNode.appendChild(innerblock);
}this.t1.addCallback(delWrapper,startTime+enterTime);// To revert the position of the innerblock.
function revertPosition(){innerblock.style.left="0px";innerblock.style.top="0px";}this.t1.addCallback(revertPosition,startTime+enterTime);this.t1.addCallback(updateWrapper,enterTime-0.01);}},{key:'rotateZoominPopup',value:function rotateZoominPopup(innerblock,tween_duration,enterstart,effectType,rotation,scaleX,scaleY,isChild){this.removeMask(innerblock.id);this.tweenFromToHandler(innerblock,tween_duration,{scale:0,transformOrigin:"50% 50%",immediateRender:false},{scaleX:scaleX,scaleY:scaleY,transformOrigin:"50% 50%",ease:__WEBPACK_IMPORTED_MODULE_1_gsap__["a" /* Back */].easeOut},enterstart);if(effectType==="rotateZoomInPopupCw")this.tweenFromToHandler(innerblock,tween_duration-tween_duration/2,{rotation:"-=180",transformOrigin:"50% 50%"},{rotation:rotation,transformOrigin:"50% 50%"},enterstart);else if(effectType==="rotateZoomInPopupCcw")this.tweenFromToHandler(innerblock,tween_duration-tween_duration/2,{rotation:"+=180",transformOrigin:"50% 50%"},{rotation:rotation,transformOrigin:"50% 50%"},enterstart);}},{key:'rotateZoomin',value:function rotateZoomin(innerblock,tween_duration,enterstart,effectName,rotation,scaleX,scaleY,isChild){this.removeMask(innerblock.id);if(effectName==="rotateZoomInCw")this.tweenFromToHandler(innerblock,tween_duration,{scale:0,rotation:"-=180",transformOrigin:"50% 50%",immediateRender:false},{scaleX:scaleX,scaleY:scaleY,rotation:rotation,transformOrigin:"50% 50%"},enterstart);else if(effectName==="rotateZoomInCcw")this.tweenFromToHandler(innerblock,tween_duration,{rotation:"+=180",scale:0,transformOrigin:"50% 50%"},{rotation:rotation,scaleX:scaleX,scaleY:scaleY,transformOrigin:"50% 50%"},enterstart);}},{key:'bigToNormal',value:function bigToNormal(innerblock,tween_duration,enterstart,scaleX,scaleY,opacity,width,height,rotation,isChild){this.removeMask(innerblock.id);this.tweenFromToHandler(innerblock,tween_duration,{opacity:0,scaleX:scaleX*1.5,scaleY:scaleY*1.5,rotation:rotation},{opacity:opacity,scaleX:scaleX,scaleY:scaleY},enterstart);}},{key:'fadeinWithZoom',value:function fadeinWithZoom(innerblock,tween_duration,scaleX,scaleY,opacity,rotation,xVal,yVal,enterstart,isChild){var _this6=this;this.removeMask(innerblock.id);this.tweenFromToHandler(innerblock,tween_duration,{alpha:0},{alpha:opacity,force3D:true},enterstart);var popupHandler=function popupHandler(innerblock,startTime,enterTime,rotation,xval,yval,isChild){var groupXoffset=0,groupYoffset=0,rotateHeightOffset=0,rotateWidthOffset=0;if(isChild){groupXoffset=innerblock.parentNode.getBoundingClientRect().x-innerblock.parentNode.parentNode.getBoundingClientRect().x;groupYoffset=innerblock.parentNode.getBoundingClientRect().y-innerblock.parentNode.parentNode.getBoundingClientRect().y;}if(rotation){rotateHeightOffset=(innerblock.getBoundingClientRect().height-innerblock.clientHeight)/2;rotateWidthOffset=(innerblock.getBoundingClientRect().width-innerblock.clientWidth)/2;}var updateWrapper=function updateWrapper(){if(!document.getElementById(innerblock.id+"_tempWrapper")){var parent=innerblock.parentNode;var wrapper=document.createElement("div");parent.replaceChild(wrapper,innerblock);wrapper.appendChild(innerblock);innerblock.parentNode.style.width=innerblock.getBoundingClientRect().width+"px";innerblock.parentNode.style.height=innerblock.getBoundingClientRect().height+"px";innerblock.parentNode.style.display="block";innerblock.parentNode.style.position="absolute";innerblock.parentNode.setAttribute("id",innerblock.id+"_tempWrapper");var transformOriginVal="50% 50%";_this6.removeMask(innerblock.id);_this6.tweenToHandler(innerblock.parentNode,startTime,{scaleX:1,scaleY:1,immediateRender:false,ease:__WEBPACK_IMPORTED_MODULE_1_gsap__["a" /* Back */].easeOut},enterTime);innerblock.style.left=-xval+rotateWidthOffset+groupXoffset+"px";innerblock.style.top=-yval+rotateHeightOffset+groupYoffset+"px";__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock.parentNode,{x:xval-groupXoffset-rotateWidthOffset,y:yval-groupYoffset-rotateHeightOffset,transformOrigin:transformOriginVal,scaleX:0,scaleY:0});}};// Inba - Added if condition to add callbacks for one scene only, muitlple scenes reverse not 
// not showing any effects.
if(_this6.props.projectData.get('scenes').size===1){var delWrapper=function delWrapper(){// var parentNode = innerblock.parentNode.parentNode;
// parentNode.insertBefore(innerblock, innerblock.parentNode);
if(document.getElementById(innerblock.id+"_tempWrapper")){var _document$getElementB2;(_document$getElementB2=document.getElementById(innerblock.id+"_tempWrapper")).replaceWith.apply(_document$getElementB2,_toConsumableArray(document.getElementById(innerblock.id+"_tempWrapper").childNodes));}// parentNode.appendChild(innerblock);
};// // To revert the position of the innerblock.
var revertPosition=function revertPosition(){innerblock.style.left="0px";innerblock.style.top="0px";};_this6.t1.addCallback(delWrapper,startTime+enterTime);_this6.t1.addCallback(revertPosition,startTime+enterTime);}_this6.t1.addCallback(updateWrapper,enterTime+0.001);};popupHandler(innerblock,tween_duration-tween_duration/2,enterstart,rotation,xVal,yVal,isChild);}},{key:'drawSVGHandler',value:function drawSVGHandler(innerblock,startTime){this.removeMask(innerblock.id);__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(innerblock.querySelectorAll("path")[0],{drawSVG:"0%"});return __WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].to(innerblock.querySelectorAll("path")[0],startTime,{drawSVG:"100%"});}}]);return Player;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Player);

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * VERSION: 0.5.8
 * DATE: 2017-08-22
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2017, GreenSock. All rights reserved.
 * SplitText is a Club GreenSock membership benefit; You must have a valid membership to use
 * this code without violating the terms of use. Visit http://greensock.com/club/ to sign up or get more details.
 * This work is subject to the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */
var _gsScope = (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
(function(window) {
	
	"use strict";
	var _globals = window.GreenSockGlobals || window,
		_namespace = function(ns) {
			var a = ns.split("."),
				p = _globals, i;
			for (i = 0; i < a.length; i++) {
				p[a[i]] = p = p[a[i]] || {};
			}
			return p;
		},
		pkg = _namespace("com.greensock.utils"),
		_getText = function(e) {
			var type = e.nodeType,
				result = "";
			if (type === 1 || type === 9 || type === 11) {
				if (typeof(e.textContent) === "string") {
					return e.textContent;
				} else {
					for ( e = e.firstChild; e; e = e.nextSibling ) {
						result += _getText(e);
					}
				}
			} else if (type === 3 || type === 4) {
				return e.nodeValue;
			}
			return result;
		},
		_doc = document,
		_getComputedStyle = _doc.defaultView ? _doc.defaultView.getComputedStyle : function() {},
		_capsExp = /([A-Z])/g,
		_getStyle = function(t, p, cs, str) {
			var result;
			if ((cs = cs || _getComputedStyle(t, null))) {
				t = cs.getPropertyValue(p.replace(_capsExp, "-$1").toLowerCase());
				result = (t || cs.length) ? t : cs[p]; //Opera behaves VERY strangely - length is usually 0 and cs[p] is the only way to get accurate results EXCEPT when checking for -o-transform which only works with cs.getPropertyValue()!
			} else if (t.currentStyle) {
				cs = t.currentStyle;
				result = cs[p];
			}
			return str ? result : parseInt(result, 10) || 0;
		},
		_isArrayLike = function(e) {
			return (e.length && e[0] && ((e[0].nodeType && e[0].style && !e.nodeType) || (e[0].length && e[0][0]))) ? true : false; //could be an array of jQuery objects too, so accommodate that.
		},
		_flattenArray = function(a) {
			var result = [],
				l = a.length,
				i, e, j;
			for (i = 0; i < l; i++) {
				e = a[i];
				if (_isArrayLike(e)) {
					j = e.length;
					for (j = 0; j < e.length; j++) {
						result.push(e[j]);
					}
				} else {
					result.push(e);
				}
			}
			return result;
		},
		_stripExp = /(?:\r|\n|\t\t)/g, //find carriage returns, new line feeds and double-tabs.
		_multipleSpacesExp = /(?:\s\s+)/g,
		_emojiStart = 0xD800,
		_emojiEnd = 0xDBFF,
		_emojiLowStart = 0xDC00,
		_emojiRegionStart = 0x1F1E6,
		_emojiRegionEnd = 0x1F1FF,
		_emojiModStart = 0x1f3fb,
		_emojiModEnd = 0x1f3ff,
		_emojiPairCode = function(s) {
			return ((s.charCodeAt(0) - _emojiStart) << 10) + (s.charCodeAt(1) - _emojiLowStart) + 0x10000;
		},
		_isOldIE = (_doc.all && !_doc.addEventListener),
		_divStart = " style='position:relative;display:inline-block;" + (_isOldIE ? "*display:inline;*zoom:1;'" : "'"), //note: we must use both display:inline-block and *display:inline for IE8 and earlier, otherwise it won't flow correctly (and if we only use display:inline, IE won't render most of the property tweens - very odd).
		_cssClassFunc = function(cssClass, tag) {
			cssClass = cssClass || "";
			var iterate = (cssClass.indexOf("++") !== -1),
				num = 1;
			if (iterate) {
				cssClass = cssClass.split("++").join("");
			}
			return function() {
				return "<" + tag + _divStart + (cssClass ? " class='" + cssClass + (iterate ? num++ : "") + "'>" : ">");
			};
		},
		SplitText = pkg.SplitText = _globals.SplitText = function(element, vars) {
			if (typeof(element) === "string") {
				element = SplitText.selector(element);
			}
			if (!element) {
				throw("cannot split a null element.");
			}
			this.elements = _isArrayLike(element) ? _flattenArray(element) : [element];
			this.chars = [];
			this.words = [];
			this.lines = [];
			this._originals = [];
			this.vars = vars || {};
			this.split(vars);
		},
		_swapText = function(element, oldText, newText) {
			var type = element.nodeType;
			if (type === 1 || type === 9 || type === 11) {
				for (element = element.firstChild; element; element = element.nextSibling) {
					_swapText(element, oldText, newText);
				}
			} else if (type === 3 || type === 4) {
				element.nodeValue = element.nodeValue.split(oldText).join(newText);
			}
		},
		_pushReversed = function(a, merge) {
			var i = merge.length;
			while (--i > -1) {
				a.push(merge[i]);
			}
		},
		_slice = function(a) { //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
			var b = [],
				l = a.length,
				i;
			for (i = 0; i !== l; b.push(a[i++])) {}
			return b;
		},
		_isBeforeWordDelimiter = function(e, root, wordDelimiter) {
			var next;
			while (e && e !== root) {
				next = e._next || e.nextSibling;
				if (next) {
					return next.textContent.charAt(0) === wordDelimiter;
				}
				e = e.parentNode || e._parent;
			}
			return false;
		},
		_deWordify = function(e) {
			var children = _slice(e.childNodes),
				l = children.length,
				i, child;
			for (i = 0; i < l; i++) {
				child = children[i];
				if (child._isSplit) {
					_deWordify(child);
				} else {
					if (i && child.previousSibling.nodeType === 3) {
						child.previousSibling.nodeValue += (child.nodeType === 3) ? child.nodeValue : child.firstChild.nodeValue;
					} else if (child.nodeType !== 3) {
						e.insertBefore(child.firstChild, child);
					}
					e.removeChild(child);
				}
			}
		},
		_setPositionsAfterSplit = function(element, vars, allChars, allWords, allLines, origWidth, origHeight) {
			var cs = _getComputedStyle(element),
				paddingLeft = _getStyle(element, "paddingLeft", cs),
				lineOffsetY = -999,
				borderTopAndBottom = _getStyle(element, "borderBottomWidth", cs) + _getStyle(element, "borderTopWidth", cs),
				borderLeftAndRight = _getStyle(element, "borderLeftWidth", cs) + _getStyle(element, "borderRightWidth", cs),
				padTopAndBottom = _getStyle(element, "paddingTop", cs) + _getStyle(element, "paddingBottom", cs),
				padLeftAndRight = _getStyle(element, "paddingLeft", cs) + _getStyle(element, "paddingRight", cs),
				lineThreshold = _getStyle(element, "fontSize") * 0.2,
				textAlign = _getStyle(element, "textAlign", cs, true),
				charArray = [],
				wordArray = [],
				lineArray = [],
				wordDelimiter = vars.wordDelimiter || " ",
				tag = vars.span ? "span" : "div",
				types = vars.type || vars.split || "chars,words,lines",
				lines = (allLines && types.indexOf("lines") !== -1) ? [] : null,
				words = (types.indexOf("words") !== -1),
				chars = (types.indexOf("chars") !== -1),
				absolute = (vars.position === "absolute" || vars.absolute === true),
				linesClass = vars.linesClass,
				iterateLine = ((linesClass || "").indexOf("++") !== -1),
				spaceNodesToRemove = [],
				i, j, l, node, nodes, isChild, curLine, addWordSpaces, style, lineNode, lineWidth, offset;
			if (lines && element.children.length === 1 && element.children[0]._isSplit) { //lines are always split on the main element (not inside nested elements), so if there's only one child, bust apart lines inside that rather than forcing it all into one big line. Like <div><div>lots of stuff</div></div> - if they split the outer one, it'd all be in one line.
				element = element.children[0];
			}
			if (iterateLine) {
				linesClass = linesClass.split("++").join("");
			}

			//copy all the descendant nodes into an array (we can't use a regular nodeList because it's live and we may need to renest things)
			j = element.getElementsByTagName("*");
			l = j.length;
			nodes = [];
			for (i = 0; i < l; i++) {
				nodes[i] = j[i];
			}

			//for absolute positioning, we need to record the x/y offsets and width/height for every <div>. And even if we're not positioning things absolutely, in order to accommodate lines, we must figure out where the y offset changes so that we can sense where the lines break, and we populate the lines array.
			if (lines || absolute) {
				for (i = 0; i < l; i++) {
					node = nodes[i];
					isChild = (node.parentNode === element);
					if (isChild || absolute || (chars && !words)) {
						offset = node.offsetTop;
						if (lines && isChild && Math.abs(offset - lineOffsetY) > lineThreshold && (node.nodeName !== "BR" || i === 0)) { //we found some rare occasions where a certain character like &#8209; could cause the offsetTop to be off by 1 pixel, so we build in a threshold.
							curLine = [];
							lines.push(curLine);
							lineOffsetY = offset;
						}
						if (absolute) { //record offset x and y, as well as width and height so that we can access them later for positioning. Grabbing them at once ensures we don't trigger a browser paint & we maximize performance.
							node._x = node.offsetLeft;
							node._y = offset;
							node._w = node.offsetWidth;
							node._h = node.offsetHeight;
						}
						if (lines) {
							if ((node._isSplit && isChild) || (!chars && isChild) || (words && isChild) || (!words && node.parentNode.parentNode === element && !node.parentNode._isSplit)) {
								curLine.push(node);
								node._x -= paddingLeft;
								if (_isBeforeWordDelimiter(node, element, wordDelimiter)) {
									node._wordEnd = true;
								}
							}
							if (node.nodeName === "BR" && ((node.nextSibling && node.nextSibling.nodeName === "BR") || i === 0)) { //two consecutive <br> tags signify a new [empty] line. Also, if the entire block of content STARTS with a <br>, add a line.
								lines.push([]);
							}
						}
					}
				}
			}

			for (i = 0; i < l; i++) {
				node = nodes[i];
				isChild = (node.parentNode === element);
				if (node.nodeName === "BR") {
					if (lines || absolute) {
						if (node.parentNode) {
							node.parentNode.removeChild(node);
						}
						nodes.splice(i--, 1);
						l--;
					} else if (!words) {
						element.appendChild(node);
					}
					continue;
				}

				if (absolute) {
					style = node.style;
					if (!words && !isChild) {
						node._x += node.parentNode._x;
						node._y += node.parentNode._y;
					}
					style.left = node._x + "px";
					style.top = node._y + "px";
					style.position = "absolute";
					style.display = "block";
					//if we don't set the width/height, things collapse in older versions of IE and the origin for transforms is thrown off in all browsers.
					style.width = (node._w + 1) + "px"; //IE is 1px short sometimes. Avoid wrapping
					style.height = node._h + "px";
				}

				if (!words && chars) {
					//we always start out wrapping words in their own <div> so that line breaks happen correctly, but here we'll remove those <div> tags if necessary and renest the characters directly into the element rather than inside the word <div>
					if (node._isSplit) {
						node._next = node.nextSibling;
						node.parentNode.appendChild(node); //put it at the end to keep the order correct.

					} else if (node.parentNode._isSplit) {
						node._parent = node.parentNode;
						if (!node.previousSibling && node.firstChild) {
							node.firstChild._isFirst = true;
						}
						if (node.nextSibling && node.nextSibling.textContent === " " && !node.nextSibling.nextSibling) { //if the last node inside a nested element is just a space (like T<span>nested </span>), remove it otherwise it'll get placed in the wrong order. Don't remove it right away, though, because we need to sense when words/characters are before a space like _isBeforeWordDelimiter(). Removing it now would make that a false negative.
							spaceNodesToRemove.push(node.nextSibling);
						}
						node._next = (node.nextSibling && node.nextSibling._isFirst) ? null : node.nextSibling;
						node.parentNode.removeChild(node);
						nodes.splice(i--, 1);
						l--;
					} else if (!isChild) {
						offset = (!node.nextSibling && _isBeforeWordDelimiter(node.parentNode, element, wordDelimiter)); //if this is the last letter in the word (and we're not breaking by lines and not positioning things absolutely), we need to add a space afterwards so that the characters don't just mash together
						if (node.parentNode._parent) {
							node.parentNode._parent.appendChild(node);
						}
						if (offset) {
							node.parentNode.appendChild(_doc.createTextNode(" "));
						}
						if (vars.span) {
							node.style.display = "inline"; //so that word breaks are honored properly.
						}
						charArray.push(node);
					}
				} else if (node.parentNode._isSplit && !node._isSplit && node.innerHTML !== "") {
					wordArray.push(node);
				} else if (chars && !node._isSplit) {
					if (vars.span) {
						node.style.display = "inline";
					}
					charArray.push(node);
				}
			}

			i = spaceNodesToRemove.length;
			while (--i > -1) {
				spaceNodesToRemove[i].parentNode.removeChild(spaceNodesToRemove[i]);
			}

			if (lines) {
				//the next 7 lines just give us the line width in the most reliable way and figure out the left offset (if position isn't relative or absolute). We must set the width along with text-align to ensure everything works properly for various alignments.
				if (absolute) {
					lineNode = _doc.createElement(tag);
					element.appendChild(lineNode);
					lineWidth = lineNode.offsetWidth + "px";
					offset = (lineNode.offsetParent === element) ? 0 : element.offsetLeft;
					element.removeChild(lineNode);
				}
				style = element.style.cssText;
				element.style.cssText = "display:none;"; //to improve performance, set display:none on the element so that the browser doesn't have to worry about reflowing or rendering while we're renesting things. We'll revert the cssText later.
				//we can't use element.innerHTML = "" because that causes IE to literally delete all the nodes and their content even though we've stored them in an array! So we must loop through the children and remove them.
				while (element.firstChild) {
					element.removeChild(element.firstChild);
				}
				addWordSpaces = (wordDelimiter === " " && (!absolute || (!words && !chars)));
				for (i = 0; i < lines.length; i++) {
					curLine = lines[i];
					lineNode = _doc.createElement(tag);
					lineNode.style.cssText = "display:block;text-align:" + textAlign + ";position:" + (absolute ? "absolute;" : "relative;");
					if (linesClass) {
						lineNode.className = linesClass + (iterateLine ? i+1 : "");
					}
					lineArray.push(lineNode);
					l = curLine.length;
					for (j = 0; j < l; j++) {
						if (curLine[j].nodeName !== "BR") {
							node = curLine[j];
							lineNode.appendChild(node);
							if (addWordSpaces && node._wordEnd) {
								lineNode.appendChild(_doc.createTextNode(" "));
							}
							if (absolute) {
								if (j === 0) {
									lineNode.style.top = (node._y) + "px";
									lineNode.style.left = (paddingLeft + offset) + "px";
								}
								node.style.top = "0px";
								if (offset) {
									node.style.left = (node._x - offset) + "px";
								}
							}
						}
					}
					if (l === 0) { //if there are no nodes in the line (typically meaning there were two consecutive <br> tags, just add a non-breaking space so that things display properly.
						lineNode.innerHTML = "&nbsp;";
					} else if (!words && !chars) {
						_deWordify(lineNode);
						_swapText(lineNode, String.fromCharCode(160), " ");
					}
					if (absolute) {
						lineNode.style.width = lineWidth;
						lineNode.style.height = node._h + "px";
					}
					element.appendChild(lineNode);
				}
				element.style.cssText = style;
			}

			//if everything shifts to being position:absolute, the container can collapse in terms of height or width, so fix that here.
			if (absolute) {
				if (origHeight > element.clientHeight) {
					element.style.height = (origHeight - padTopAndBottom) + "px";
					if (element.clientHeight < origHeight) { //IE8 and earlier use a different box model - we must include padding and borders
						element.style.height = (origHeight + borderTopAndBottom)+ "px";
					}
				}
				if (origWidth > element.clientWidth) {
					element.style.width = (origWidth - padLeftAndRight) + "px";
					if (element.clientWidth < origWidth) { //IE8 and earlier use a different box model - we must include padding and borders
						element.style.width = (origWidth + borderLeftAndRight)+ "px";
					}
				}
			}
			_pushReversed(allChars, charArray);
			_pushReversed(allWords, wordArray);
			_pushReversed(allLines, lineArray);
		},
		_splitRawText = function(element, vars, wordStart, charStart) {
			var tag = vars.span ? "span" : "div",
				types = vars.type || vars.split || "chars,words,lines",
				//words = (types.indexOf("words") !== -1),
				chars = (types.indexOf("chars") !== -1),
				absolute = (vars.position === "absolute" || vars.absolute === true),
				wordDelimiter = vars.wordDelimiter || " ",
				space = wordDelimiter !== " " ? "" : (absolute ? "&#173; " : " "),
				wordEnd = vars.span ? "</span>" : "</div>",
				wordIsOpen = true,
				text, splitText, i, j, l, character, hasTagStart, emojiPair1, emojiPair2,
				container = _doc.createElement("div"),
				parent = element.parentNode;

			parent.insertBefore(container, element);
			container.textContent = element.nodeValue;
			parent.removeChild(element);
			element = container;
			text = _getText(element);
			hasTagStart = text.indexOf("<") !== -1;

			if (vars.reduceWhiteSpace !== false) {
				text = text.replace(_multipleSpacesExp, " ").replace(_stripExp, "");
			}
			if (hasTagStart) {
				text = text.split("<").join("{{LT}}"); //we can't leave "<" in the string, or when we set the innerHTML, it can be interpreted as a node
			}
			l = text.length;
			splitText = ((text.charAt(0) === " ") ? space : "") + wordStart();
			for (i = 0; i < l; i++) {
				character = text.charAt(i);
				if (character === wordDelimiter && text.charAt(i-1) !== wordDelimiter && i) {
					splitText += wordIsOpen ? wordEnd : "";
					wordIsOpen = false;
					while (text.charAt(i + 1) === wordDelimiter) { //skip over empty spaces (to avoid making them words)
						splitText += space;
						i++;
					}
					if (i === l-1) {
						splitText += space;
					} else if (text.charAt(i + 1) !== ")") {
						splitText += space + wordStart();
						wordIsOpen = true;
					}

				} else if (character === "{" && text.substr(i, 6) === "{{LT}}") {
					splitText += chars ? charStart() + "{{LT}}" + "</" + tag + ">" : "{{LT}}";
					i += 5;

				} else if ((character.charCodeAt(0) >= _emojiStart && character.charCodeAt(0) <= _emojiEnd) || (text.charCodeAt(i+1) >= 0xFE00 && text.charCodeAt(i+1) <= 0xFE0F)) { //special emoji characters use 2 or 4 unicode characters that we must keep together.
					emojiPair1 = _emojiPairCode(text.substr(i, 2));
					emojiPair2 = _emojiPairCode(text.substr(i + 2, 2));
					j = ((emojiPair1 >= _emojiRegionStart && emojiPair1 <= _emojiRegionEnd && emojiPair2 >= _emojiRegionStart && emojiPair2 <= _emojiRegionEnd) || (emojiPair2 >= _emojiModStart && emojiPair2 <= _emojiModEnd)) ? 4 : 2;
					splitText += (chars && character !== " ") ? charStart() + text.substr(i, j) + "</" + tag + ">" : text.substr(i, j);
					i += j - 1;
				} else {
					splitText += (chars && character !== " ") ? charStart() + character + "</" + tag + ">" : character;
				}
			}
			element.outerHTML = splitText + (wordIsOpen ? wordEnd : "");
			if (hasTagStart) {
				_swapText(parent, "{{LT}}", "<"); //note: don't perform this on "element" because that gets replaced with all new elements when we set element.outerHTML.
			}
		},
		_split = function(element, vars, wordStart, charStart) {
			var children = _slice(element.childNodes),
				l = children.length,
				absolute = (vars.position === "absolute" || vars.absolute === true),
				i, child;

			if (element.nodeType !== 3 || l > 1) {
				vars.absolute = false;
				for (i = 0; i < l; i++) {
					child = children[i];
					if (child.nodeType !== 3 || /\S+/.test(child.nodeValue)) {
						if (absolute && child.nodeType !== 3 && _getStyle(child, "display", null, true) === "inline") { //if there's a child node that's display:inline, switch it to inline-block so that absolute positioning works properly (most browsers don't report offsetTop/offsetLeft properly inside a <span> for example)
							child.style.display = "inline-block";
							child.style.position = "relative";
						}
						child._isSplit = true;
						_split(child, vars, wordStart, charStart); //don't split lines on child elements
					}
				}
				vars.absolute = absolute;
				element._isSplit = true;
				return;
			}

			_splitRawText(element, vars, wordStart, charStart);

		},
		p = SplitText.prototype;

	p.split = function(vars) {
		if (this.isSplit) {
			this.revert();
		}
		this.vars = vars = vars || this.vars;
		this._originals.length = this.chars.length = this.words.length = this.lines.length = 0;
		var i = this.elements.length,
			tag = vars.span ? "span" : "div",
			wordStart = _cssClassFunc(vars.wordsClass, tag),
			charStart = _cssClassFunc(vars.charsClass, tag),
			origHeight, origWidth, e;
		//we split in reversed order so that if/when we position:absolute elements, they don't affect the position of the ones after them in the document flow (shifting them up as they're taken out of the document flow).
		while (--i > -1) {
			e = this.elements[i];
			this._originals[i] = e.innerHTML;
			origHeight = e.clientHeight;
			origWidth = e.clientWidth;
			_split(e, vars, wordStart, charStart);
			_setPositionsAfterSplit(e, vars, this.chars, this.words, this.lines, origWidth, origHeight);
		}
		this.chars.reverse();
		this.words.reverse();
		this.lines.reverse();
		this.isSplit = true;
		return this;
	};

	p.revert = function() {
		if (!this._originals) {
			throw("revert() call wasn't scoped properly.");
		}
		var i = this._originals.length;
		while (--i > -1) {
			this.elements[i].innerHTML = this._originals[i];
		}
		this.chars = [];
		this.words = [];
		this.lines = [];
		this.isSplit = false;
		return this;
	};

	SplitText.selector = window.$ || window.jQuery || function(e) {
		var selector = window.$ || window.jQuery;
		if (selector) {
			SplitText.selector = selector;
			return selector(e);
		}
		return (typeof(document) === "undefined") ? e : (document.querySelectorAll ? document.querySelectorAll(e) : document.getElementById((e.charAt(0) === "#") ? e.substr(1) : e));
	};
	SplitText.version = "0.5.8";
	
})(_gsScope);

//export to AMD/RequireJS and CommonJS/Node (precursor to full modular build system coming at a later date)
(function(name) {
	"use strict";
	var getGlobal = function() {
		return (_gsScope.GreenSockGlobals || _gsScope)[name];
	};
	if (typeof(module) !== "undefined" && module.exports) { //node
		module.exports = getGlobal();
	} else if (true) { //AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (getGlobal),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
}("SplitText"));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);
var bind = __webpack_require__(195);
var Axios = __webpack_require__(385);
var defaults = __webpack_require__(103);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(199);
axios.CancelToken = __webpack_require__(398);
axios.isCancel = __webpack_require__(198);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(399);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 384 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(103);
var utils = __webpack_require__(13);
var InterceptorManager = __webpack_require__(393);
var dispatchRequest = __webpack_require__(394);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(197);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);
var transformData = __webpack_require__(395);
var isCancel = __webpack_require__(198);
var defaults = __webpack_require__(103);
var isAbsoluteURL = __webpack_require__(396);
var combineURLs = __webpack_require__(397);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(199);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

typeof window !== "undefined" &&
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Hls"] = factory();
	else
		root["Hls"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/hls.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/eventemitter3/index.js":
/*!*********************************************!*\
  !*** ./node_modules/eventemitter3/index.js ***!
  \*********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once)
    , evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
  else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();
  else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event
    , handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event
    , listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
      listeners.fn === fn &&
      (!once || listeners.once) &&
      (!context || listeners.context === context)
    ) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
        listeners[i].fn !== fn ||
        (once && !listeners[i].once) ||
        (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/events/events.js":
/*!**********************************************************************!*\
  !*** ./node_modules/node-libs-browser/node_modules/events/events.js ***!
  \**********************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),

/***/ "./node_modules/url-toolkit/src/url-toolkit.js":
/*!*****************************************************!*\
  !*** ./node_modules/url-toolkit/src/url-toolkit.js ***!
  \*****************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

// see https://tools.ietf.org/html/rfc1808

/* jshint ignore:start */
(function(root) { 
/* jshint ignore:end */

  var URL_REGEX = /^((?:[a-zA-Z0-9+\-.]+:)?)(\/\/[^\/?#]*)?((?:[^\/\?#]*\/)*.*?)??(;.*?)?(\?.*?)?(#.*?)?$/;
  var FIRST_SEGMENT_REGEX = /^([^\/?#]*)(.*)$/;
  var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
  var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/).*?(?=\/)/g;

  var URLToolkit = { // jshint ignore:line
    // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
    // E.g
    // With opts.alwaysNormalize = false (default, spec compliant)
    // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
    // With opts.alwaysNormalize = true (not spec compliant)
    // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
    buildAbsoluteURL: function(baseURL, relativeURL, opts) {
      opts = opts || {};
      // remove any remaining space and CRLF
      baseURL = baseURL.trim();
      relativeURL = relativeURL.trim();
      if (!relativeURL) {
        // 2a) If the embedded URL is entirely empty, it inherits the
        // entire base URL (i.e., is set equal to the base URL)
        // and we are done.
        if (!opts.alwaysNormalize) {
          return baseURL;
        }
        var basePartsForNormalise = URLToolkit.parseURL(baseURL);
        if (!basePartsForNormalise) {
          throw new Error('Error trying to parse base URL.');
        }
        basePartsForNormalise.path = URLToolkit.normalizePath(basePartsForNormalise.path);
        return URLToolkit.buildURLFromParts(basePartsForNormalise);
      }
      var relativeParts = URLToolkit.parseURL(relativeURL);
      if (!relativeParts) {
        throw new Error('Error trying to parse relative URL.');
      }
      if (relativeParts.scheme) {
        // 2b) If the embedded URL starts with a scheme name, it is
        // interpreted as an absolute URL and we are done.
        if (!opts.alwaysNormalize) {
          return relativeURL;
        }
        relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
        return URLToolkit.buildURLFromParts(relativeParts);
      }
      var baseParts = URLToolkit.parseURL(baseURL);
      if (!baseParts) {
        throw new Error('Error trying to parse base URL.');
      }
      if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
        // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
        // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
        var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
        baseParts.netLoc = pathParts[1];
        baseParts.path = pathParts[2];
      }
      if (baseParts.netLoc && !baseParts.path) {
        baseParts.path = '/';
      }
      var builtParts = {
        // 2c) Otherwise, the embedded URL inherits the scheme of
        // the base URL.
        scheme: baseParts.scheme,
        netLoc: relativeParts.netLoc,
        path: null,
        params: relativeParts.params,
        query: relativeParts.query,
        fragment: relativeParts.fragment
      };
      if (!relativeParts.netLoc) {
        // 3) If the embedded URL's <net_loc> is non-empty, we skip to
        // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
        // (if any) of the base URL.
        builtParts.netLoc = baseParts.netLoc;
        // 4) If the embedded URL path is preceded by a slash "/", the
        // path is not relative and we skip to Step 7.
        if (relativeParts.path[0] !== '/') {
          if (!relativeParts.path) {
            // 5) If the embedded URL path is empty (and not preceded by a
            // slash), then the embedded URL inherits the base URL path
            builtParts.path = baseParts.path;
            // 5a) if the embedded URL's <params> is non-empty, we skip to
            // step 7; otherwise, it inherits the <params> of the base
            // URL (if any) and
            if (!relativeParts.params) {
              builtParts.params = baseParts.params;
              // 5b) if the embedded URL's <query> is non-empty, we skip to
              // step 7; otherwise, it inherits the <query> of the base
              // URL (if any) and we skip to step 7.
              if (!relativeParts.query) {
                builtParts.query = baseParts.query;
              }
            }
          } else {
            // 6) The last segment of the base URL's path (anything
            // following the rightmost slash "/", or the entire path if no
            // slash is present) is removed and the embedded URL's path is
            // appended in its place.
            var baseURLPath = baseParts.path;
            var newPath = baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) + relativeParts.path;
            builtParts.path = URLToolkit.normalizePath(newPath);
          }
        }
      }
      if (builtParts.path === null) {
        builtParts.path = opts.alwaysNormalize ? URLToolkit.normalizePath(relativeParts.path) : relativeParts.path;
      }
      return URLToolkit.buildURLFromParts(builtParts);
    },
    parseURL: function(url) {
      var parts = URL_REGEX.exec(url);
      if (!parts) {
        return null;
      }
      return {
        scheme: parts[1] || '',
        netLoc: parts[2] || '',
        path: parts[3] || '',
        params: parts[4] || '',
        query: parts[5] || '',
        fragment: parts[6] || ''
      };
    },
    normalizePath: function(path) {
      // The following operations are
      // then applied, in order, to the new path:
      // 6a) All occurrences of "./", where "." is a complete path
      // segment, are removed.
      // 6b) If the path ends with "." as a complete path segment,
      // that "." is removed.
      path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
      // 6c) All occurrences of "<segment>/../", where <segment> is a
      // complete path segment not equal to "..", are removed.
      // Removal of these path segments is performed iteratively,
      // removing the leftmost matching pattern on each iteration,
      // until no matching pattern remains.
      // 6d) If the path ends with "<segment>/..", where <segment> is a
      // complete path segment not equal to "..", that
      // "<segment>/.." is removed.
      while (path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length) {} // jshint ignore:line
      return path.split('').reverse().join('');
    },
    buildURLFromParts: function(parts) {
      return parts.scheme + parts.netLoc + parts.path + parts.params + parts.query + parts.fragment;
    }
  };

/* jshint ignore:start */
  if(true)
    module.exports = URLToolkit;
  else {}
})(this);
/* jshint ignore:end */


/***/ }),

/***/ "./node_modules/webworkify-webpack/index.js":
/*!**************************************************!*\
  !*** ./node_modules/webworkify-webpack/index.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

function webpackBootstrapFunc (modules) {
/******/  // The module cache
/******/  var installedModules = {};

/******/  // The require function
/******/  function __webpack_require__(moduleId) {

/******/    // Check if module is in cache
/******/    if(installedModules[moduleId])
/******/      return installedModules[moduleId].exports;

/******/    // Create a new module (and put it into the cache)
/******/    var module = installedModules[moduleId] = {
/******/      i: moduleId,
/******/      l: false,
/******/      exports: {}
/******/    };

/******/    // Execute the module function
/******/    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/    // Flag the module as loaded
/******/    module.l = true;

/******/    // Return the exports of the module
/******/    return module.exports;
/******/  }

/******/  // expose the modules object (__webpack_modules__)
/******/  __webpack_require__.m = modules;

/******/  // expose the module cache
/******/  __webpack_require__.c = installedModules;

/******/  // identity function for calling harmony imports with the correct context
/******/  __webpack_require__.i = function(value) { return value; };

/******/  // define getter function for harmony exports
/******/  __webpack_require__.d = function(exports, name, getter) {
/******/    if(!__webpack_require__.o(exports, name)) {
/******/      Object.defineProperty(exports, name, {
/******/        configurable: false,
/******/        enumerable: true,
/******/        get: getter
/******/      });
/******/    }
/******/  };

/******/  // define __esModule on exports
/******/  __webpack_require__.r = function(exports) {
/******/    Object.defineProperty(exports, '__esModule', { value: true });
/******/  };

/******/  // getDefaultExport function for compatibility with non-harmony modules
/******/  __webpack_require__.n = function(module) {
/******/    var getter = module && module.__esModule ?
/******/      function getDefault() { return module['default']; } :
/******/      function getModuleExports() { return module; };
/******/    __webpack_require__.d(getter, 'a', getter);
/******/    return getter;
/******/  };

/******/  // Object.prototype.hasOwnProperty.call
/******/  __webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

/******/  // __webpack_public_path__
/******/  __webpack_require__.p = "/";

/******/  // on error function for async loading
/******/  __webpack_require__.oe = function(err) { console.error(err); throw err; };

  var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE)
  return f.default || f // try to call default if defined to also support babel esmodule exports
}

var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+'
var dependencyRegExp = '\\((\/\\*.*?\\*\/)?\s?.*?(' + moduleNameReqExp + ').*?\\)' // additional chars when output.pathinfo is true

// http://stackoverflow.com/a/2593661/130442
function quoteRegExp (str) {
  return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&')
}

function isNumeric(n) {
  return !isNaN(1 * n); // 1 * n converts integers, integers as string ("123"), 1e3 and "1e3" to integers and strings to NaN
}

function getModuleDependencies (sources, module, queueName) {
  var retval = {}
  retval[queueName] = []

  var fnString = module.toString()
  var wrapperSignature = fnString.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/)
  if (!wrapperSignature) return retval
  var webpackRequireName = wrapperSignature[1]

  // main bundle deps
  var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g')
  var match
  while ((match = re.exec(fnString))) {
    if (match[3] === 'dll-reference') continue
    retval[queueName].push(match[3])
  }

  // dll deps
  re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g')
  while ((match = re.exec(fnString))) {
    if (!sources[match[2]]) {
      retval[queueName].push(match[1])
      sources[match[2]] = __webpack_require__(match[1]).m
    }
    retval[match[2]] = retval[match[2]] || []
    retval[match[2]].push(match[4])
  }

  // convert 1e3 back to 1000 - this can be important after uglify-js converted 1000 to 1e3
  var keys = Object.keys(retval);
  for (var i = 0; i < keys.length; i++) {
    for (var j = 0; j < retval[keys[i]].length; j++) {
      if (isNumeric(retval[keys[i]][j])) {
        retval[keys[i]][j] = 1 * retval[keys[i]][j];
      }
    }
  }

  return retval
}

function hasValuesInQueues (queues) {
  var keys = Object.keys(queues)
  return keys.reduce(function (hasValues, key) {
    return hasValues || queues[key].length > 0
  }, false)
}

function getRequiredModules (sources, moduleId) {
  var modulesQueue = {
    main: [moduleId]
  }
  var requiredModules = {
    main: []
  }
  var seenModules = {
    main: {}
  }

  while (hasValuesInQueues(modulesQueue)) {
    var queues = Object.keys(modulesQueue)
    for (var i = 0; i < queues.length; i++) {
      var queueName = queues[i]
      var queue = modulesQueue[queueName]
      var moduleToCheck = queue.pop()
      seenModules[queueName] = seenModules[queueName] || {}
      if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue
      seenModules[queueName][moduleToCheck] = true
      requiredModules[queueName] = requiredModules[queueName] || []
      requiredModules[queueName].push(moduleToCheck)
      var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName)
      var newModulesKeys = Object.keys(newModules)
      for (var j = 0; j < newModulesKeys.length; j++) {
        modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || []
        modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]])
      }
    }
  }

  return requiredModules
}

module.exports = function (moduleId, options) {
  options = options || {}
  var sources = {
    main: __webpack_require__.m
  }

  var requiredModules = options.all ? { main: Object.keys(sources.main) } : getRequiredModules(sources, moduleId)

  var src = ''

  Object.keys(requiredModules).filter(function (m) { return m !== 'main' }).forEach(function (module) {
    var entryModule = 0
    while (requiredModules[module][entryModule]) {
      entryModule++
    }
    requiredModules[module].push(entryModule)
    sources[module][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })'
    src = src + 'var ' + module + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module].map(function (id) { return '' + JSON.stringify(id) + ': ' + sources[module][id].toString() }).join(',') + '});\n'
  })

  src = src + 'new ((' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function (id) { return '' + JSON.stringify(id) + ': ' + sources.main[id].toString() }).join(',') + '}))(self);'

  var blob = new window.Blob([src], { type: 'text/javascript' })
  if (options.bare) { return blob }

  var URL = window.URL || window.webkitURL || window.mozURL || window.msURL

  var workerUrl = URL.createObjectURL(blob)
  var worker = new window.Worker(workerUrl)
  worker.objectURL = workerUrl

  return worker
}


/***/ }),

/***/ "./src/config.js":
/*!***********************!*\
  !*** ./src/config.js ***!
  \***********************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * HLS config
 */
Object.defineProperty(exports, "__esModule", { value: true });
var abr_controller_1 = __webpack_require__(/*! ./controller/abr-controller */ "./src/controller/abr-controller.js");
var buffer_controller_1 = __webpack_require__(/*! ./controller/buffer-controller */ "./src/controller/buffer-controller.js");
var cap_level_controller_1 = __webpack_require__(/*! ./controller/cap-level-controller */ "./src/controller/cap-level-controller.js");
var fps_controller_1 = __webpack_require__(/*! ./controller/fps-controller */ "./src/controller/fps-controller.js");
var xhr_loader_1 = __webpack_require__(/*! ./utils/xhr-loader */ "./src/utils/xhr-loader.js");
// import FetchLoader from './utils/fetch-loader';
var audio_track_controller_1 = __webpack_require__(/*! ./controller/audio-track-controller */ "./src/controller/audio-track-controller.js");
var audio_stream_controller_1 = __webpack_require__(/*! ./controller/audio-stream-controller */ "./src/controller/audio-stream-controller.js");
var Cues = __webpack_require__(/*! ./utils/cues */ "./src/utils/cues.js");
var timeline_controller_1 = __webpack_require__(/*! ./controller/timeline-controller */ "./src/controller/timeline-controller.js");
var subtitle_track_controller_1 = __webpack_require__(/*! ./controller/subtitle-track-controller */ "./src/controller/subtitle-track-controller.js");
var subtitle_stream_controller_1 = __webpack_require__(/*! ./controller/subtitle-stream-controller */ "./src/controller/subtitle-stream-controller.js");
var eme_controller_1 = __webpack_require__(/*! ./controller/eme-controller */ "./src/controller/eme-controller.js");
var mediakeys_helper_1 = __webpack_require__(/*! ./utils/mediakeys-helper */ "./src/utils/mediakeys-helper.js");
exports.hlsDefaultConfig = {
    autoStartLoad: true,
    startPosition: -1,
    defaultAudioCodec: undefined,
    debug: false,
    capLevelOnFPSDrop: false,
    capLevelToPlayerSize: false,
    initialLiveManifestSize: 1,
    maxBufferLength: 30,
    maxBufferSize: 60 * 1000 * 1000,
    maxBufferHole: 0.5,
    lowBufferWatchdogPeriod: 0.5,
    highBufferWatchdogPeriod: 3,
    nudgeOffset: 0.1,
    nudgeMaxRetry: 3,
    maxFragLookUpTolerance: 0.25,
    liveSyncDurationCount: 3,
    liveMaxLatencyDurationCount: Infinity,
    liveSyncDuration: undefined,
    liveMaxLatencyDuration: undefined,
    liveDurationInfinity: false,
    liveBackBufferLength: Infinity,
    maxMaxBufferLength: 600,
    enableWorker: true,
    enableSoftwareAES: true,
    manifestLoadingTimeOut: 10000,
    manifestLoadingMaxRetry: 1,
    manifestLoadingRetryDelay: 1000,
    manifestLoadingMaxRetryTimeout: 64000,
    startLevel: undefined,
    levelLoadingTimeOut: 10000,
    levelLoadingMaxRetry: 4,
    levelLoadingRetryDelay: 1000,
    levelLoadingMaxRetryTimeout: 64000,
    fragLoadingTimeOut: 20000,
    fragLoadingMaxRetry: 6,
    fragLoadingRetryDelay: 1000,
    fragLoadingMaxRetryTimeout: 64000,
    startFragPrefetch: false,
    fpsDroppedMonitoringPeriod: 5000,
    fpsDroppedMonitoringThreshold: 0.2,
    appendErrorMaxRetry: 3,
    loader: xhr_loader_1.default,
    // loader: FetchLoader,
    fLoader: undefined,
    pLoader: undefined,
    xhrSetup: undefined,
    licenseXhrSetup: undefined,
    // fetchSetup: undefined,
    abrController: abr_controller_1.default,
    bufferController: buffer_controller_1.default,
    capLevelController: cap_level_controller_1.default,
    fpsController: fps_controller_1.default,
    stretchShortVideoTrack: false,
    maxAudioFramesDrift: 1,
    forceKeyFrameOnDiscontinuity: true,
    abrEwmaFastLive: 3,
    abrEwmaSlowLive: 9,
    abrEwmaFastVoD: 3,
    abrEwmaSlowVoD: 9,
    abrEwmaDefaultEstimate: 5e5,
    abrBandWidthFactor: 0.95,
    abrBandWidthUpFactor: 0.7,
    abrMaxWithRealBitrate: false,
    maxStarvationDelay: 4,
    maxLoadingDelay: 4,
    minAutoBitrate: 0,
    emeEnabled: false,
    widevineLicenseUrl: undefined,
    requestMediaKeySystemAccessFunc: mediakeys_helper_1.requestMediaKeySystemAccess // used by eme-controller
};
if (true) {
    exports.hlsDefaultConfig.subtitleStreamController = subtitle_stream_controller_1.SubtitleStreamController;
    exports.hlsDefaultConfig.subtitleTrackController = subtitle_track_controller_1.default;
    exports.hlsDefaultConfig.timelineController = timeline_controller_1.default;
    exports.hlsDefaultConfig.cueHandler = Cues; // used by timeline-controller
    exports.hlsDefaultConfig.enableCEA708Captions = true; // used by timeline-controller
    exports.hlsDefaultConfig.enableWebVTT = true; // used by timeline-controller
    exports.hlsDefaultConfig.captionsTextTrack1Label = 'English'; // used by timeline-controller
    exports.hlsDefaultConfig.captionsTextTrack1LanguageCode = 'en'; // used by timeline-controller
    exports.hlsDefaultConfig.captionsTextTrack2Label = 'Spanish'; // used by timeline-controller
    exports.hlsDefaultConfig.captionsTextTrack2LanguageCode = 'es'; // used by timeline-controller
}
if (true) {
    exports.hlsDefaultConfig.audioStreamController = audio_stream_controller_1.default;
    exports.hlsDefaultConfig.audioTrackController = audio_track_controller_1.default;
}
if (true) {
    exports.hlsDefaultConfig.emeController = eme_controller_1.default;
}


/***/ }),

/***/ "./src/controller/abr-controller.js":
/*!******************************************!*\
  !*** ./src/controller/abr-controller.js ***!
  \******************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
/*
 * simple ABR Controller
 *  - compute next level based on last fragment bw heuristics
 *  - implement an abandon rules triggered if we have less than 2 frag buffered and if computed bw shows that we risk buffer stalling
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var buffer_helper_1 = __webpack_require__(/*! ../utils/buffer-helper */ "./src/utils/buffer-helper.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var ewma_bandwidth_estimator_1 = __webpack_require__(/*! ../utils/ewma-bandwidth-estimator */ "./src/utils/ewma-bandwidth-estimator.js");
var performance = window.performance;
var AbrController = /** @class */ (function (_super) {
    __extends(AbrController, _super);
    function AbrController(hls) {
        var _this = _super.call(this, hls, events_1.default.FRAG_LOADING, events_1.default.FRAG_LOADED, events_1.default.FRAG_BUFFERED, events_1.default.ERROR) || this;
        _this.lastLoadedFragLevel = 0;
        _this._nextAutoLevel = -1;
        _this.hls = hls;
        _this.timer = null;
        _this._bwEstimator = null;
        _this.onCheck = _this._abandonRulesCheck.bind(_this);
        return _this;
    }
    AbrController.prototype.destroy = function () {
        this.clearTimer();
        event_handler_1.default.prototype.destroy.call(this);
    };
    AbrController.prototype.onFragLoading = function (data) {
        var frag = data.frag;
        if (frag.type === 'main') {
            if (!this.timer) {
                this.fragCurrent = frag;
                this.timer = setInterval(this.onCheck, 100);
            }
            // lazy init of BwEstimator, rationale is that we use different params for Live/VoD
            // so we need to wait for stream manifest / playlist type to instantiate it.
            if (!this._bwEstimator) {
                var hls_1 = this.hls;
                var config = hls_1.config;
                var level = frag.level;
                var isLive = hls_1.levels[level].details.live;
                var ewmaFast = void 0, ewmaSlow = void 0;
                if (isLive) {
                    ewmaFast = config.abrEwmaFastLive;
                    ewmaSlow = config.abrEwmaSlowLive;
                }
                else {
                    ewmaFast = config.abrEwmaFastVoD;
                    ewmaSlow = config.abrEwmaSlowVoD;
                }
                this._bwEstimator = new ewma_bandwidth_estimator_1.default(hls_1, ewmaSlow, ewmaFast, config.abrEwmaDefaultEstimate);
            }
        }
    };
    AbrController.prototype._abandonRulesCheck = function () {
        /*
          monitor fragment retrieval time...
          we compute expected time of arrival of the complete fragment.
          we compare it to expected time of buffer starvation
        */
        var hls = this.hls;
        var video = hls.media;
        var frag = this.fragCurrent;
        if (!frag) {
            return;
        }
        var loader = frag.loader;
        var minAutoLevel = hls.minAutoLevel;
        // if loader has been destroyed or loading has been aborted, stop timer and return
        if (!loader || (loader.stats && loader.stats.aborted)) {
            logger_1.logger.warn('frag loader destroy or aborted, disarm abandonRules');
            this.clearTimer();
            // reset forced auto level value so that next level will be selected
            this._nextAutoLevel = -1;
            return;
        }
        var stats = loader.stats;
        /* only monitor frag retrieval time if
        (video not paused OR first fragment being loaded(ready state === HAVE_NOTHING = 0)) AND autoswitching enabled AND not lowest level (=> means that we have several levels) */
        if (video && stats && ((!video.paused && (video.playbackRate !== 0)) || !video.readyState) && frag.autoLevel && frag.level) {
            var requestDelay = performance.now() - stats.trequest, playbackRate = Math.abs(video.playbackRate);
            // monitor fragment load progress after half of expected fragment duration,to stabilize bitrate
            if (requestDelay > (500 * frag.duration / playbackRate)) {
                var levels = hls.levels, loadRate = Math.max(1, stats.bw ? stats.bw / 8 : stats.loaded * 1000 / requestDelay), // byte/s; at least 1 byte/s to avoid division by zero
                // compute expected fragment length using frag duration and level bitrate. also ensure that expected len is gte than already loaded size
                level = levels[frag.level], levelBitrate = level.realBitrate ? Math.max(level.realBitrate, level.bitrate) : level.bitrate, expectedLen = stats.total ? stats.total : Math.max(stats.loaded, Math.round(frag.duration * levelBitrate / 8)), pos = video.currentTime, fragLoadedDelay = (expectedLen - stats.loaded) / loadRate, bufferStarvationDelay = (buffer_helper_1.BufferHelper.bufferInfo(video, pos, hls.config.maxBufferHole).end - pos) / playbackRate;
                // consider emergency switch down only if we have less than 2 frag buffered AND
                // time to finish loading current fragment is bigger than buffer starvation delay
                // ie if we risk buffer starvation if bw does not increase quickly
                if ((bufferStarvationDelay < (2 * frag.duration / playbackRate)) && (fragLoadedDelay > bufferStarvationDelay)) {
                    var fragLevelNextLoadedDelay = void 0, nextLoadLevel = void 0;
                    // lets iterate through lower level and try to find the biggest one that could avoid rebuffering
                    // we start from current level - 1 and we step down , until we find a matching level
                    for (nextLoadLevel = frag.level - 1; nextLoadLevel > minAutoLevel; nextLoadLevel--) {
                        // compute time to load next fragment at lower level
                        // 0.8 : consider only 80% of current bw to be conservative
                        // 8 = bits per byte (bps/Bps)
                        var levelNextBitrate = levels[nextLoadLevel].realBitrate ? Math.max(levels[nextLoadLevel].realBitrate, levels[nextLoadLevel].bitrate) : levels[nextLoadLevel].bitrate;
                        fragLevelNextLoadedDelay = frag.duration * levelNextBitrate / (8 * 0.8 * loadRate);
                        if (fragLevelNextLoadedDelay < bufferStarvationDelay) {
                            // we found a lower level that be rebuffering free with current estimated bw !
                            break;
                        }
                    }
                    // only emergency switch down if it takes less time to load new fragment at lowest level instead
                    // of finishing loading current one ...
                    if (fragLevelNextLoadedDelay < fragLoadedDelay) {
                        logger_1.logger.warn("loading too slow, abort fragment loading and switch to level " + nextLoadLevel + ":fragLoadedDelay[" + nextLoadLevel + "]<fragLoadedDelay[" + (frag.level - 1) + "];bufferStarvationDelay:" + fragLevelNextLoadedDelay.toFixed(1) + "<" + fragLoadedDelay.toFixed(1) + ":" + bufferStarvationDelay.toFixed(1));
                        // force next load level in auto mode
                        hls.nextLoadLevel = nextLoadLevel;
                        // update bw estimate for this fragment before cancelling load (this will help reducing the bw)
                        this._bwEstimator.sample(requestDelay, stats.loaded);
                        // abort fragment loading
                        loader.abort();
                        // stop abandon rules timer
                        this.clearTimer();
                        hls.trigger(events_1.default.FRAG_LOAD_EMERGENCY_ABORTED, { frag: frag, stats: stats });
                    }
                }
            }
        }
    };
    AbrController.prototype.onFragLoaded = function (data) {
        var frag = data.frag;
        if (frag.type === 'main' && Number.isFinite(frag.sn)) {
            // stop monitoring bw once frag loaded
            this.clearTimer();
            // store level id after successful fragment load
            this.lastLoadedFragLevel = frag.level;
            // reset forced auto level value so that next level will be selected
            this._nextAutoLevel = -1;
            // compute level average bitrate
            if (this.hls.config.abrMaxWithRealBitrate) {
                var level = this.hls.levels[frag.level];
                var loadedBytes = (level.loaded ? level.loaded.bytes : 0) + data.stats.loaded;
                var loadedDuration = (level.loaded ? level.loaded.duration : 0) + data.frag.duration;
                level.loaded = { bytes: loadedBytes, duration: loadedDuration };
                level.realBitrate = Math.round(8 * loadedBytes / loadedDuration);
            }
            // if fragment has been loaded to perform a bitrate test,
            if (data.frag.bitrateTest) {
                var stats = data.stats;
                stats.tparsed = stats.tbuffered = stats.tload;
                this.onFragBuffered(data);
            }
        }
    };
    AbrController.prototype.onFragBuffered = function (data) {
        var stats = data.stats;
        var frag = data.frag;
        // only update stats on first frag buffering
        // if same frag is loaded multiple times, it might be in browser cache, and loaded quickly
        // and leading to wrong bw estimation
        // on bitrate test, also only update stats once (if tload = tbuffered == on FRAG_LOADED)
        if (stats.aborted !== true && frag.type === 'main' && Number.isFinite(frag.sn) && ((!frag.bitrateTest || stats.tload === stats.tbuffered))) {
            // use tparsed-trequest instead of tbuffered-trequest to compute fragLoadingProcessing; rationale is that  buffer appending only happens once media is attached
            // in case we use config.startFragPrefetch while media is not attached yet, fragment might be parsed while media not attached yet, but it will only be buffered on media attached
            // as a consequence it could happen really late in the process. meaning that appending duration might appears huge ... leading to underestimated throughput estimation
            var fragLoadingProcessingMs = stats.tparsed - stats.trequest;
            logger_1.logger.log("latency/loading/parsing/append/kbps:" + Math.round(stats.tfirst - stats.trequest) + "/" + Math.round(stats.tload - stats.tfirst) + "/" + Math.round(stats.tparsed - stats.tload) + "/" + Math.round(stats.tbuffered - stats.tparsed) + "/" + Math.round(8 * stats.loaded / (stats.tbuffered - stats.trequest)));
            this._bwEstimator.sample(fragLoadingProcessingMs, stats.loaded);
            stats.bwEstimate = this._bwEstimator.getEstimate();
            // if fragment has been loaded to perform a bitrate test, (hls.startLevel = -1), store bitrate test delay duration
            if (frag.bitrateTest) {
                this.bitrateTestDelay = fragLoadingProcessingMs / 1000;
            }
            else {
                this.bitrateTestDelay = 0;
            }
        }
    };
    AbrController.prototype.onError = function (data) {
        // stop timer in case of frag loading error
        switch (data.details) {
            case errors_1.ErrorDetails.FRAG_LOAD_ERROR:
            case errors_1.ErrorDetails.FRAG_LOAD_TIMEOUT:
                this.clearTimer();
                break;
            default:
                break;
        }
    };
    AbrController.prototype.clearTimer = function () {
        clearInterval(this.timer);
        this.timer = null;
    };
    Object.defineProperty(AbrController.prototype, "nextAutoLevel", {
        // return next auto level
        get: function () {
            var forcedAutoLevel = this._nextAutoLevel;
            var bwEstimator = this._bwEstimator;
            // in case next auto level has been forced, and bw not available or not reliable, return forced value
            if (forcedAutoLevel !== -1 && (!bwEstimator || !bwEstimator.canEstimate())) {
                return forcedAutoLevel;
            }
            // compute next level using ABR logic
            var nextABRAutoLevel = this._nextABRAutoLevel;
            // if forced auto level has been defined, use it to cap ABR computed quality level
            if (forcedAutoLevel !== -1) {
                nextABRAutoLevel = Math.min(forcedAutoLevel, nextABRAutoLevel);
            }
            return nextABRAutoLevel;
        },
        set: function (nextLevel) {
            this._nextAutoLevel = nextLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbrController.prototype, "_nextABRAutoLevel", {
        get: function () {
            var hls = this.hls, maxAutoLevel = hls.maxAutoLevel, levels = hls.levels, config = hls.config, minAutoLevel = hls.minAutoLevel;
            var video = hls.media, currentLevel = this.lastLoadedFragLevel, currentFragDuration = this.fragCurrent ? this.fragCurrent.duration : 0, pos = (video ? video.currentTime : 0), 
            // playbackRate is the absolute value of the playback rate; if video.playbackRate is 0, we use 1 to load as
            // if we're playing back at the normal rate.
            playbackRate = ((video && (video.playbackRate !== 0)) ? Math.abs(video.playbackRate) : 1.0), avgbw = this._bwEstimator ? this._bwEstimator.getEstimate() : config.abrEwmaDefaultEstimate, 
            // bufferStarvationDelay is the wall-clock time left until the playback buffer is exhausted.
            bufferStarvationDelay = (buffer_helper_1.BufferHelper.bufferInfo(video, pos, config.maxBufferHole).end - pos) / playbackRate;
            // First, look to see if we can find a level matching with our avg bandwidth AND that could also guarantee no rebuffering at all
            var bestLevel = this._findBestLevel(currentLevel, currentFragDuration, avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, config.abrBandWidthFactor, config.abrBandWidthUpFactor, levels);
            if (bestLevel >= 0) {
                return bestLevel;
            }
            else {
                logger_1.logger.trace('rebuffering expected to happen, lets try to find a quality level minimizing the rebuffering');
                // not possible to get rid of rebuffering ... let's try to find level that will guarantee less than maxStarvationDelay of rebuffering
                // if no matching level found, logic will return 0
                var maxStarvationDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxStarvationDelay) : config.maxStarvationDelay, bwFactor = config.abrBandWidthFactor, bwUpFactor = config.abrBandWidthUpFactor;
                if (bufferStarvationDelay === 0) {
                    // in case buffer is empty, let's check if previous fragment was loaded to perform a bitrate test
                    var bitrateTestDelay = this.bitrateTestDelay;
                    if (bitrateTestDelay) {
                        // if it is the case, then we need to adjust our max starvation delay using maxLoadingDelay config value
                        // max video loading delay used in  automatic start level selection :
                        // in that mode ABR controller will ensure that video loading time (ie the time to fetch the first fragment at lowest quality level +
                        // the time to fetch the fragment at the appropriate quality level is less than ```maxLoadingDelay``` )
                        // cap maxLoadingDelay and ensure it is not bigger 'than bitrate test' frag duration
                        var maxLoadingDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxLoadingDelay) : config.maxLoadingDelay;
                        maxStarvationDelay = maxLoadingDelay - bitrateTestDelay;
                        logger_1.logger.trace("bitrate test took " + Math.round(1000 * bitrateTestDelay) + "ms, set first fragment max fetchDuration to " + Math.round(1000 * maxStarvationDelay) + " ms");
                        // don't use conservative factor on bitrate test
                        bwFactor = bwUpFactor = 1;
                    }
                }
                bestLevel = this._findBestLevel(currentLevel, currentFragDuration, avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay + maxStarvationDelay, bwFactor, bwUpFactor, levels);
                return Math.max(bestLevel, 0);
            }
        },
        enumerable: true,
        configurable: true
    });
    AbrController.prototype._findBestLevel = function (currentLevel, currentFragDuration, currentBw, minAutoLevel, maxAutoLevel, maxFetchDuration, bwFactor, bwUpFactor, levels) {
        for (var i = maxAutoLevel; i >= minAutoLevel; i--) {
            var levelInfo = levels[i];
            if (!levelInfo) {
                continue;
            }
            var levelDetails = levelInfo.details, avgDuration = levelDetails ? levelDetails.totalduration / levelDetails.fragments.length : currentFragDuration, live = levelDetails ? levelDetails.live : false, adjustedbw = void 0;
            // follow algorithm captured from stagefright :
            // https://android.googlesource.com/platform/frameworks/av/+/master/media/libstagefright/httplive/LiveSession.cpp
            // Pick the highest bandwidth stream below or equal to estimated bandwidth.
            // consider only 80% of the available bandwidth, but if we are switching up,
            // be even more conservative (70%) to avoid overestimating and immediately
            // switching back.
            if (i <= currentLevel) {
                adjustedbw = bwFactor * currentBw;
            }
            else {
                adjustedbw = bwUpFactor * currentBw;
            }
            var bitrate = levels[i].realBitrate ? Math.max(levels[i].realBitrate, levels[i].bitrate) : levels[i].bitrate, fetchDuration = bitrate * avgDuration / adjustedbw;
            logger_1.logger.trace("level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: " + i + "/" + Math.round(adjustedbw) + "/" + bitrate + "/" + avgDuration + "/" + maxFetchDuration + "/" + fetchDuration);
            // if adjusted bw is greater than level bitrate AND
            if (adjustedbw > bitrate &&
                // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
                // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
                // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that _findBestLevel will return -1
                (!fetchDuration || (live && !this.bitrateTestDelay) || fetchDuration < maxFetchDuration)) {
                // as we are looping from highest to lowest, this will return the best achievable quality level
                return i;
            }
        }
        // not enough time budget even with quality level 0 ... rebuffering might happen
        return -1;
    };
    return AbrController;
}(event_handler_1.default));
exports.default = AbrController;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/controller/audio-stream-controller.js":
/*!***************************************************!*\
  !*** ./src/controller/audio-stream-controller.js ***!
  \***************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
/*
 * Audio Stream Controller
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var binary_search_1 = __webpack_require__(/*! ../utils/binary-search */ "./src/utils/binary-search.js");
var buffer_helper_1 = __webpack_require__(/*! ../utils/buffer-helper */ "./src/utils/buffer-helper.js");
var demuxer_1 = __webpack_require__(/*! ../demux/demuxer */ "./src/demux/demuxer.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var LevelHelper = __webpack_require__(/*! ./level-helper */ "./src/controller/level-helper.js");
var time_ranges_1 = __webpack_require__(/*! ../utils/time-ranges */ "./src/utils/time-ranges.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var discontinuities_1 = __webpack_require__(/*! ../utils/discontinuities */ "./src/utils/discontinuities.js");
var fragment_tracker_1 = __webpack_require__(/*! ./fragment-tracker */ "./src/controller/fragment-tracker.js");
var fragment_1 = __webpack_require__(/*! ../loader/fragment */ "./src/loader/fragment.js");
var base_stream_controller_1 = __webpack_require__(/*! ./base-stream-controller */ "./src/controller/base-stream-controller.js");
var performance = window.performance;
var TICK_INTERVAL = 100; // how often to tick in ms
var AudioStreamController = /** @class */ (function (_super) {
    __extends(AudioStreamController, _super);
    function AudioStreamController(hls, fragmentTracker) {
        var _this = _super.call(this, hls, events_1.default.MEDIA_ATTACHED, events_1.default.MEDIA_DETACHING, events_1.default.AUDIO_TRACKS_UPDATED, events_1.default.AUDIO_TRACK_SWITCHING, events_1.default.AUDIO_TRACK_LOADED, events_1.default.KEY_LOADED, events_1.default.FRAG_LOADED, events_1.default.FRAG_PARSING_INIT_SEGMENT, events_1.default.FRAG_PARSING_DATA, events_1.default.FRAG_PARSED, events_1.default.ERROR, events_1.default.BUFFER_RESET, events_1.default.BUFFER_CREATED, events_1.default.BUFFER_APPENDED, events_1.default.BUFFER_FLUSHED, events_1.default.INIT_PTS_FOUND) || this;
        _this.fragmentTracker = fragmentTracker;
        _this.config = hls.config;
        _this.audioCodecSwap = false;
        _this._state = base_stream_controller_1.State.STOPPED;
        _this.initPTS = [];
        _this.waitingFragment = null;
        _this.videoTrackCC = null;
        return _this;
    }
    // Signal that video PTS was found
    AudioStreamController.prototype.onInitPtsFound = function (data) {
        var demuxerId = data.id, cc = data.frag.cc, initPTS = data.initPTS;
        if (demuxerId === 'main') {
            // Always update the new INIT PTS
            // Can change due level switch
            this.initPTS[cc] = initPTS;
            this.videoTrackCC = cc;
            logger_1.logger.log("InitPTS for cc: " + cc + " found from video track: " + initPTS);
            // If we are waiting we need to demux/remux the waiting frag
            // With the new initPTS
            if (this.state === base_stream_controller_1.State.WAITING_INIT_PTS) {
                this.tick();
            }
        }
    };
    AudioStreamController.prototype.startLoad = function (startPosition) {
        if (this.tracks) {
            var lastCurrentTime = this.lastCurrentTime;
            this.stopLoad();
            this.setInterval(TICK_INTERVAL);
            this.fragLoadError = 0;
            if (lastCurrentTime > 0 && startPosition === -1) {
                logger_1.logger.log("audio:override startPosition with lastCurrentTime @" + lastCurrentTime.toFixed(3));
                this.state = base_stream_controller_1.State.IDLE;
            }
            else {
                this.lastCurrentTime = this.startPosition ? this.startPosition : startPosition;
                this.state = base_stream_controller_1.State.STARTING;
            }
            this.nextLoadPosition = this.startPosition = this.lastCurrentTime;
            this.tick();
        }
        else {
            this.startPosition = startPosition;
            this.state = base_stream_controller_1.State.STOPPED;
        }
    };
    Object.defineProperty(AudioStreamController.prototype, "state", {
        get: function () {
            return this._state;
        },
        set: function (nextState) {
            if (this.state !== nextState) {
                var previousState = this.state;
                this._state = nextState;
                logger_1.logger.log("audio stream:" + previousState + "->" + nextState);
            }
        },
        enumerable: true,
        configurable: true
    });
    AudioStreamController.prototype.doTick = function () {
        var pos, track, trackDetails, hls = this.hls, config = hls.config;
        // logger.log('audioStream:' + this.state);
        switch (this.state) {
            case base_stream_controller_1.State.ERROR:
            // don't do anything in error state to avoid breaking further ...
            case base_stream_controller_1.State.PAUSED:
            // don't do anything in paused state either ...
            case base_stream_controller_1.State.BUFFER_FLUSHING:
                break;
            case base_stream_controller_1.State.STARTING:
                this.state = base_stream_controller_1.State.WAITING_TRACK;
                this.loadedmetadata = false;
                break;
            case base_stream_controller_1.State.IDLE:
                var tracks = this.tracks;
                // audio tracks not received => exit loop
                if (!tracks) {
                    break;
                }
                // if video not attached AND
                // start fragment already requested OR start frag prefetch disable
                // exit loop
                // => if media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
                if (!this.media &&
                    (this.startFragRequested || !config.startFragPrefetch)) {
                    break;
                }
                // determine next candidate fragment to be loaded, based on current position and
                //  end of buffer position
                // if we have not yet loaded any fragment, start loading from start position
                if (this.loadedmetadata) {
                    pos = this.media.currentTime;
                }
                else {
                    pos = this.nextLoadPosition;
                    if (pos === undefined) {
                        break;
                    }
                }
                var media = this.mediaBuffer ? this.mediaBuffer : this.media, videoBuffer = this.videoBuffer ? this.videoBuffer : this.media, bufferInfo = buffer_helper_1.BufferHelper.bufferInfo(media, pos, config.maxBufferHole), mainBufferInfo = buffer_helper_1.BufferHelper.bufferInfo(videoBuffer, pos, config.maxBufferHole), bufferLen = bufferInfo.len, bufferEnd_1 = bufferInfo.end, fragPrevious = this.fragPrevious, 
                // ensure we buffer at least config.maxBufferLength (default 30s) or config.maxMaxBufferLength (default: 600s)
                // whichever is smaller.
                // once we reach that threshold, don't buffer more than video (mainBufferInfo.len)
                maxConfigBuffer = Math.min(config.maxBufferLength, config.maxMaxBufferLength), maxBufLen = Math.max(maxConfigBuffer, mainBufferInfo.len), audioSwitch = this.audioSwitch, trackId = this.trackId;
                // if buffer length is less than maxBufLen try to load a new fragment
                if ((bufferLen < maxBufLen || audioSwitch) && trackId < tracks.length) {
                    trackDetails = tracks[trackId].details;
                    // if track info not retrieved yet, switch state and wait for track retrieval
                    if (typeof trackDetails === 'undefined') {
                        this.state = base_stream_controller_1.State.WAITING_TRACK;
                        break;
                    }
                    if (!audioSwitch && this._streamEnded(bufferInfo, trackDetails)) {
                        this.hls.trigger(events_1.default.BUFFER_EOS, { type: 'audio' });
                        this.state = base_stream_controller_1.State.ENDED;
                        return;
                    }
                    // find fragment index, contiguous with end of buffer position
                    var fragments = trackDetails.fragments, fragLen = fragments.length, start = fragments[0].start, end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration, frag = void 0;
                    // When switching audio track, reload audio as close as possible to currentTime
                    if (audioSwitch) {
                        if (trackDetails.live && !trackDetails.PTSKnown) {
                            logger_1.logger.log('switching audiotrack, live stream, unknown PTS,load first fragment');
                            bufferEnd_1 = 0;
                        }
                        else {
                            bufferEnd_1 = pos;
                            // if currentTime (pos) is less than alt audio playlist start time, it means that alt audio is ahead of currentTime
                            if (trackDetails.PTSKnown && pos < start) {
                                // if everything is buffered from pos to start or if audio buffer upfront, let's seek to start
                                if (bufferInfo.end > start || bufferInfo.nextStart) {
                                    logger_1.logger.log('alt audio track ahead of main track, seek to start of alt audio track');
                                    this.media.currentTime = start + 0.05;
                                }
                                else {
                                    return;
                                }
                            }
                        }
                    }
                    if (trackDetails.initSegment && !trackDetails.initSegment.data) {
                        frag = trackDetails.initSegment;
                    } // eslint-disable-line brace-style
                    // if bufferEnd before start of playlist, load first fragment
                    else if (bufferEnd_1 <= start) {
                        frag = fragments[0];
                        if (this.videoTrackCC !== null && frag.cc !== this.videoTrackCC) {
                            // Ensure we find a fragment which matches the continuity of the video track
                            frag = discontinuities_1.findFragWithCC(fragments, this.videoTrackCC);
                        }
                        if (trackDetails.live && frag.loadIdx && frag.loadIdx === this.fragLoadIdx) {
                            // we just loaded this first fragment, and we are still lagging behind the start of the live playlist
                            // let's force seek to start
                            var nextBuffered = bufferInfo.nextStart ? bufferInfo.nextStart : start;
                            logger_1.logger.log("no alt audio available @currentTime:" + this.media.currentTime + ", seeking @" + (nextBuffered + 0.05));
                            this.media.currentTime = nextBuffered + 0.05;
                            return;
                        }
                    }
                    else {
                        var foundFrag = void 0;
                        var maxFragLookUpTolerance_1 = config.maxFragLookUpTolerance;
                        var fragNext = fragPrevious ? fragments[fragPrevious.sn - fragments[0].sn + 1] : undefined;
                        var fragmentWithinToleranceTest = function (candidate) {
                            // offset should be within fragment boundary - config.maxFragLookUpTolerance
                            // this is to cope with situations like
                            // bufferEnd = 9.991
                            // frag[Ø] : [0,10]
                            // frag[1] : [10,20]
                            // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
                            //              frag start               frag start+duration
                            //                  |-----------------------------|
                            //              <--->                         <--->
                            //  ...--------><-----------------------------><---------....
                            // previous frag         matching fragment         next frag
                            //  return -1             return 0                 return 1
                            // logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
                            // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
                            var candidateLookupTolerance = Math.min(maxFragLookUpTolerance_1, candidate.duration);
                            if ((candidate.start + candidate.duration - candidateLookupTolerance) <= bufferEnd_1) {
                                return 1;
                            }
                            else if (candidate.start - candidateLookupTolerance > bufferEnd_1 && candidate.start) {
                                // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
                                return -1;
                            }
                            return 0;
                        };
                        if (bufferEnd_1 < end) {
                            if (bufferEnd_1 > end - maxFragLookUpTolerance_1) {
                                maxFragLookUpTolerance_1 = 0;
                            }
                            // Prefer the next fragment if it's within tolerance
                            if (fragNext && !fragmentWithinToleranceTest(fragNext)) {
                                foundFrag = fragNext;
                            }
                            else {
                                foundFrag = binary_search_1.default.search(fragments, fragmentWithinToleranceTest);
                            }
                        }
                        else {
                            // reach end of playlist
                            foundFrag = fragments[fragLen - 1];
                        }
                        if (foundFrag) {
                            frag = foundFrag;
                            start = foundFrag.start;
                            // logger.log('find SN matching with pos:' +  bufferEnd + ':' + frag.sn);
                            if (fragPrevious && frag.level === fragPrevious.level && frag.sn === fragPrevious.sn) {
                                if (frag.sn < trackDetails.endSN) {
                                    frag = fragments[frag.sn + 1 - trackDetails.startSN];
                                    logger_1.logger.log("SN just loaded, load next one: " + frag.sn);
                                }
                                else {
                                    frag = null;
                                }
                            }
                        }
                    }
                    if (frag) {
                        // logger.log('      loading frag ' + i +',pos/bufEnd:' + pos.toFixed(3) + '/' + bufferEnd.toFixed(3));
                        if (frag.encrypted) {
                            logger_1.logger.log("Loading key for " + frag.sn + " of [" + trackDetails.startSN + " ," + trackDetails.endSN + "],track " + trackId);
                            this.state = base_stream_controller_1.State.KEY_LOADING;
                            hls.trigger(events_1.default.KEY_LOADING, { frag: frag });
                        }
                        else {
                            logger_1.logger.log("Loading " + frag.sn + ", cc: " + frag.cc + " of [" + trackDetails.startSN + " ," + trackDetails.endSN + "],track " + trackId + ", currentTime:" + pos + ",bufferEnd:" + bufferEnd_1.toFixed(3));
                            // only load if fragment is not loaded or if in audio switch
                            // we force a frag loading in audio switch as fragment tracker might not have evicted previous frags in case of quick audio switch
                            this.fragCurrent = frag;
                            if (audioSwitch || this.fragmentTracker.getState(frag) === fragment_tracker_1.FragmentState.NOT_LOADED) {
                                this.startFragRequested = true;
                                if (Number.isFinite(frag.sn)) {
                                    this.nextLoadPosition = frag.start + frag.duration;
                                }
                                hls.trigger(events_1.default.FRAG_LOADING, { frag: frag });
                                this.state = base_stream_controller_1.State.FRAG_LOADING;
                            }
                        }
                    }
                }
                break;
            case base_stream_controller_1.State.WAITING_TRACK:
                track = this.tracks[this.trackId];
                // check if playlist is already loaded
                if (track && track.details) {
                    this.state = base_stream_controller_1.State.IDLE;
                }
                break;
            case base_stream_controller_1.State.FRAG_LOADING_WAITING_RETRY:
                var now = performance.now();
                var retryDate = this.retryDate;
                media = this.media;
                var isSeeking = media && media.seeking;
                // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
                if (!retryDate || (now >= retryDate) || isSeeking) {
                    logger_1.logger.log('audioStreamController: retryDate reached, switch back to IDLE state');
                    this.state = base_stream_controller_1.State.IDLE;
                }
                break;
            case base_stream_controller_1.State.WAITING_INIT_PTS:
                var videoTrackCC = this.videoTrackCC;
                if (this.initPTS[videoTrackCC] === undefined) {
                    break;
                }
                // Ensure we don't get stuck in the WAITING_INIT_PTS state if the waiting frag CC doesn't match any initPTS
                var waitingFrag = this.waitingFragment;
                if (waitingFrag) {
                    var waitingFragCC = waitingFrag.frag.cc;
                    if (videoTrackCC !== waitingFragCC) {
                        track = this.tracks[this.trackId];
                        if (track.details && track.details.live) {
                            logger_1.logger.warn("Waiting fragment CC (" + waitingFragCC + ") does not match video track CC (" + videoTrackCC + ")");
                            this.waitingFragment = null;
                            this.state = base_stream_controller_1.State.IDLE;
                        }
                    }
                    else {
                        this.state = base_stream_controller_1.State.FRAG_LOADING;
                        this.onFragLoaded(this.waitingFragment);
                        this.waitingFragment = null;
                    }
                }
                else {
                    this.state = base_stream_controller_1.State.IDLE;
                }
                break;
            case base_stream_controller_1.State.STOPPED:
            case base_stream_controller_1.State.FRAG_LOADING:
            case base_stream_controller_1.State.PARSING:
            case base_stream_controller_1.State.PARSED:
            case base_stream_controller_1.State.ENDED:
                break;
            default:
                break;
        }
    };
    AudioStreamController.prototype.onMediaAttached = function (data) {
        var media = this.media = this.mediaBuffer = data.media;
        this.onvseeking = this.onMediaSeeking.bind(this);
        this.onvended = this.onMediaEnded.bind(this);
        media.addEventListener('seeking', this.onvseeking);
        media.addEventListener('ended', this.onvended);
        var config = this.config;
        if (this.tracks && config.autoStartLoad) {
            this.startLoad(config.startPosition);
        }
    };
    AudioStreamController.prototype.onMediaDetaching = function () {
        var media = this.media;
        if (media && media.ended) {
            logger_1.logger.log('MSE detaching and video ended, reset startPosition');
            this.startPosition = this.lastCurrentTime = 0;
        }
        // remove video listeners
        if (media) {
            media.removeEventListener('seeking', this.onvseeking);
            media.removeEventListener('ended', this.onvended);
            this.onvseeking = this.onvseeked = this.onvended = null;
        }
        this.media = this.mediaBuffer = this.videoBuffer = null;
        this.loadedmetadata = false;
        this.stopLoad();
    };
    AudioStreamController.prototype.onAudioTracksUpdated = function (data) {
        logger_1.logger.log('audio tracks updated');
        this.tracks = data.audioTracks;
    };
    AudioStreamController.prototype.onAudioTrackSwitching = function (data) {
        // if any URL found on new audio track, it is an alternate audio track
        var altAudio = !!data.url;
        this.trackId = data.id;
        this.fragCurrent = null;
        this.state = base_stream_controller_1.State.PAUSED;
        this.waitingFragment = null;
        // destroy useless demuxer when switching audio to main
        if (!altAudio) {
            if (this.demuxer) {
                this.demuxer.destroy();
                this.demuxer = null;
            }
        }
        else {
            // switching to audio track, start timer if not already started
            this.setInterval(TICK_INTERVAL);
        }
        // should we switch tracks ?
        if (altAudio) {
            this.audioSwitch = true;
            // main audio track are handled by stream-controller, just do something if switching to alt audio track
            this.state = base_stream_controller_1.State.IDLE;
        }
        this.tick();
    };
    AudioStreamController.prototype.onAudioTrackLoaded = function (data) {
        var newDetails = data.details, trackId = data.id, track = this.tracks[trackId], duration = newDetails.totalduration, sliding = 0;
        logger_1.logger.log("track " + trackId + " loaded [" + newDetails.startSN + "," + newDetails.endSN + "],duration:" + duration);
        if (newDetails.live) {
            var curDetails = track.details;
            if (curDetails && newDetails.fragments.length > 0) {
                // we already have details for that level, merge them
                LevelHelper.mergeDetails(curDetails, newDetails);
                sliding = newDetails.fragments[0].start;
                // TODO
                // this.liveSyncPosition = this.computeLivePosition(sliding, curDetails);
                if (newDetails.PTSKnown) {
                    logger_1.logger.log("live audio playlist sliding:" + sliding.toFixed(3));
                }
                else {
                    logger_1.logger.log('live audio playlist - outdated PTS, unknown sliding');
                }
            }
            else {
                newDetails.PTSKnown = false;
                logger_1.logger.log('live audio playlist - first load, unknown sliding');
            }
        }
        else {
            newDetails.PTSKnown = false;
        }
        track.details = newDetails;
        // compute start position
        if (!this.startFragRequested) {
            // compute start position if set to -1. use it straight away if value is defined
            if (this.startPosition === -1) {
                // first, check if start time offset has been set in playlist, if yes, use this value
                var startTimeOffset = newDetails.startTimeOffset;
                if (Number.isFinite(startTimeOffset)) {
                    logger_1.logger.log("start time offset found in playlist, adjust startPosition to " + startTimeOffset);
                    this.startPosition = startTimeOffset;
                }
                else {
                    this.startPosition = 0;
                }
            }
            this.nextLoadPosition = this.startPosition;
        }
        // only switch batck to IDLE state if we were waiting for track to start downloading a new fragment
        if (this.state === base_stream_controller_1.State.WAITING_TRACK) {
            this.state = base_stream_controller_1.State.IDLE;
        }
        // trigger handler right now
        this.tick();
    };
    AudioStreamController.prototype.onKeyLoaded = function () {
        if (this.state === base_stream_controller_1.State.KEY_LOADING) {
            this.state = base_stream_controller_1.State.IDLE;
            this.tick();
        }
    };
    AudioStreamController.prototype.onFragLoaded = function (data) {
        var fragCurrent = this.fragCurrent, fragLoaded = data.frag;
        if (this.state === base_stream_controller_1.State.FRAG_LOADING &&
            fragCurrent &&
            fragLoaded.type === 'audio' &&
            fragLoaded.level === fragCurrent.level &&
            fragLoaded.sn === fragCurrent.sn) {
            var track = this.tracks[this.trackId], details = track.details, duration = details.totalduration, trackId = fragCurrent.level, sn = fragCurrent.sn, cc = fragCurrent.cc, audioCodec = this.config.defaultAudioCodec || track.audioCodec || 'mp4a.40.2', stats = this.stats = data.stats;
            if (sn === 'initSegment') {
                this.state = base_stream_controller_1.State.IDLE;
                stats.tparsed = stats.tbuffered = performance.now();
                details.initSegment.data = data.payload;
                this.hls.trigger(events_1.default.FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'audio' });
                this.tick();
            }
            else {
                this.state = base_stream_controller_1.State.PARSING;
                // transmux the MPEG-TS data to ISO-BMFF segments
                this.appended = false;
                if (!this.demuxer) {
                    this.demuxer = new demuxer_1.default(this.hls, 'audio');
                }
                // Check if we have video initPTS
                // If not we need to wait for it
                var initPTS = this.initPTS[cc];
                var initSegmentData = details.initSegment ? details.initSegment.data : [];
                if (details.initSegment || initPTS !== undefined) {
                    this.pendingBuffering = true;
                    logger_1.logger.log("Demuxing " + sn + " of [" + details.startSN + " ," + details.endSN + "],track " + trackId);
                    // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
                    var accurateTimeOffset = false; // details.PTSKnown || !details.live;
                    this.demuxer.push(data.payload, initSegmentData, audioCodec, null, fragCurrent, duration, accurateTimeOffset, initPTS);
                }
                else {
                    logger_1.logger.log("unknown video PTS for continuity counter " + cc + ", waiting for video PTS before demuxing audio frag " + sn + " of [" + details.startSN + " ," + details.endSN + "],track " + trackId);
                    this.waitingFragment = data;
                    this.state = base_stream_controller_1.State.WAITING_INIT_PTS;
                }
            }
        }
        this.fragLoadError = 0;
    };
    AudioStreamController.prototype.onFragParsingInitSegment = function (data) {
        var fragCurrent = this.fragCurrent;
        var fragNew = data.frag;
        if (fragCurrent &&
            data.id === 'audio' &&
            fragNew.sn === fragCurrent.sn &&
            fragNew.level === fragCurrent.level &&
            this.state === base_stream_controller_1.State.PARSING) {
            var tracks = data.tracks, track = void 0;
            // delete any video track found on audio demuxer
            if (tracks.video) {
                delete tracks.video;
            }
            // include levelCodec in audio and video tracks
            track = tracks.audio;
            if (track) {
                track.levelCodec = track.codec;
                track.id = data.id;
                this.hls.trigger(events_1.default.BUFFER_CODECS, tracks);
                logger_1.logger.log("audio track:audio,container:" + track.container + ",codecs[level/parsed]=[" + track.levelCodec + "/" + track.codec + "]");
                var initSegment = track.initSegment;
                if (initSegment) {
                    var appendObj = { type: 'audio', data: initSegment, parent: 'audio', content: 'initSegment' };
                    if (this.audioSwitch) {
                        this.pendingData = [appendObj];
                    }
                    else {
                        this.appended = true;
                        // arm pending Buffering flag before appending a segment
                        this.pendingBuffering = true;
                        this.hls.trigger(events_1.default.BUFFER_APPENDING, appendObj);
                    }
                }
                // trigger handler right now
                this.tick();
            }
        }
    };
    AudioStreamController.prototype.onFragParsingData = function (data) {
        var _this = this;
        var fragCurrent = this.fragCurrent;
        var fragNew = data.frag;
        if (fragCurrent &&
            data.id === 'audio' &&
            data.type === 'audio' &&
            fragNew.sn === fragCurrent.sn &&
            fragNew.level === fragCurrent.level &&
            this.state === base_stream_controller_1.State.PARSING) {
            var trackId = this.trackId, track = this.tracks[trackId], hls_1 = this.hls;
            if (!Number.isFinite(data.endPTS)) {
                data.endPTS = data.startPTS + fragCurrent.duration;
                data.endDTS = data.startDTS + fragCurrent.duration;
            }
            fragCurrent.addElementaryStream(fragment_1.default.ElementaryStreamTypes.AUDIO);
            logger_1.logger.log("parsed " + data.type + ",PTS:[" + data.startPTS.toFixed(3) + "," + data.endPTS.toFixed(3) + "],DTS:[" + data.startDTS.toFixed(3) + "/" + data.endDTS.toFixed(3) + "],nb:" + data.nb);
            LevelHelper.updateFragPTSDTS(track.details, fragCurrent, data.startPTS, data.endPTS);
            var audioSwitch = this.audioSwitch, media = this.media, appendOnBufferFlush = false;
            // Only flush audio from old audio tracks when PTS is known on new audio track
            if (audioSwitch && media) {
                if (media.readyState) {
                    var currentTime = media.currentTime;
                    logger_1.logger.log('switching audio track : currentTime:' + currentTime);
                    if (currentTime >= data.startPTS) {
                        logger_1.logger.log('switching audio track : flushing all audio');
                        this.state = base_stream_controller_1.State.BUFFER_FLUSHING;
                        hls_1.trigger(events_1.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
                        appendOnBufferFlush = true;
                        // Lets announce that the initial audio track switch flush occur
                        this.audioSwitch = false;
                        hls_1.trigger(events_1.default.AUDIO_TRACK_SWITCHED, { id: trackId });
                    }
                }
                else {
                    // Lets announce that the initial audio track switch flush occur
                    this.audioSwitch = false;
                    hls_1.trigger(events_1.default.AUDIO_TRACK_SWITCHED, { id: trackId });
                }
            }
            var pendingData_1 = this.pendingData;
            if (!pendingData_1) {
                logger_1.logger.warn('Apparently attempt to enqueue media payload without codec initialization data upfront');
                hls_1.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MEDIA_ERROR, details: null, fatal: true });
                return;
            }
            if (!this.audioSwitch) {
                [data.data1, data.data2].forEach(function (buffer) {
                    if (buffer && buffer.length) {
                        pendingData_1.push({ type: data.type, data: buffer, parent: 'audio', content: 'data' });
                    }
                });
                if (!appendOnBufferFlush && pendingData_1.length) {
                    pendingData_1.forEach(function (appendObj) {
                        // only append in PARSING state (rationale is that an appending error could happen synchronously on first segment appending)
                        // in that case it is useless to append following segments
                        if (_this.state === base_stream_controller_1.State.PARSING) {
                            // arm pending Buffering flag before appending a segment
                            _this.pendingBuffering = true;
                            _this.hls.trigger(events_1.default.BUFFER_APPENDING, appendObj);
                        }
                    });
                    this.pendingData = [];
                    this.appended = true;
                }
            }
            // trigger handler right now
            this.tick();
        }
    };
    AudioStreamController.prototype.onFragParsed = function (data) {
        var fragCurrent = this.fragCurrent;
        var fragNew = data.frag;
        if (fragCurrent &&
            data.id === 'audio' &&
            fragNew.sn === fragCurrent.sn &&
            fragNew.level === fragCurrent.level &&
            this.state === base_stream_controller_1.State.PARSING) {
            this.stats.tparsed = performance.now();
            this.state = base_stream_controller_1.State.PARSED;
            this._checkAppendedParsed();
        }
    };
    AudioStreamController.prototype.onBufferReset = function () {
        // reset reference to sourcebuffers
        this.mediaBuffer = this.videoBuffer = null;
        this.loadedmetadata = false;
    };
    AudioStreamController.prototype.onBufferCreated = function (data) {
        var audioTrack = data.tracks.audio;
        if (audioTrack) {
            this.mediaBuffer = audioTrack.buffer;
            this.loadedmetadata = true;
        }
        if (data.tracks.video) {
            this.videoBuffer = data.tracks.video.buffer;
        }
    };
    AudioStreamController.prototype.onBufferAppended = function (data) {
        if (data.parent === 'audio') {
            var state = this.state;
            if (state === base_stream_controller_1.State.PARSING || state === base_stream_controller_1.State.PARSED) {
                // check if all buffers have been appended
                this.pendingBuffering = (data.pending > 0);
                this._checkAppendedParsed();
            }
        }
    };
    AudioStreamController.prototype._checkAppendedParsed = function () {
        // trigger handler right now
        if (this.state === base_stream_controller_1.State.PARSED && (!this.appended || !this.pendingBuffering)) {
            var frag = this.fragCurrent, stats = this.stats, hls_2 = this.hls;
            if (frag) {
                this.fragPrevious = frag;
                stats.tbuffered = performance.now();
                hls_2.trigger(events_1.default.FRAG_BUFFERED, { stats: stats, frag: frag, id: 'audio' });
                var media = this.mediaBuffer ? this.mediaBuffer : this.media;
                logger_1.logger.log("audio buffered : " + time_ranges_1.default.toString(media.buffered));
                if (this.audioSwitch && this.appended) {
                    this.audioSwitch = false;
                    hls_2.trigger(events_1.default.AUDIO_TRACK_SWITCHED, { id: this.trackId });
                }
                this.state = base_stream_controller_1.State.IDLE;
            }
            this.tick();
        }
    };
    AudioStreamController.prototype.onError = function (data) {
        var frag = data.frag;
        // don't handle frag error not related to audio fragment
        if (frag && frag.type !== 'audio') {
            return;
        }
        switch (data.details) {
            case errors_1.ErrorDetails.FRAG_LOAD_ERROR:
            case errors_1.ErrorDetails.FRAG_LOAD_TIMEOUT:
                var frag_1 = data.frag;
                // don't handle frag error not related to audio fragment
                if (frag_1 && frag_1.type !== 'audio') {
                    break;
                }
                if (!data.fatal) {
                    var loadError = this.fragLoadError;
                    if (loadError) {
                        loadError++;
                    }
                    else {
                        loadError = 1;
                    }
                    var config = this.config;
                    if (loadError <= config.fragLoadingMaxRetry) {
                        this.fragLoadError = loadError;
                        // exponential backoff capped to config.fragLoadingMaxRetryTimeout
                        var delay = Math.min(Math.pow(2, loadError - 1) * config.fragLoadingRetryDelay, config.fragLoadingMaxRetryTimeout);
                        logger_1.logger.warn("AudioStreamController: frag loading failed, retry in " + delay + " ms");
                        this.retryDate = performance.now() + delay;
                        // retry loading state
                        this.state = base_stream_controller_1.State.FRAG_LOADING_WAITING_RETRY;
                    }
                    else {
                        logger_1.logger.error("AudioStreamController: " + data.details + " reaches max retry, redispatch as fatal ...");
                        // switch error to fatal
                        data.fatal = true;
                        this.state = base_stream_controller_1.State.ERROR;
                    }
                }
                break;
            case errors_1.ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
            case errors_1.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
            case errors_1.ErrorDetails.KEY_LOAD_ERROR:
            case errors_1.ErrorDetails.KEY_LOAD_TIMEOUT:
                //  when in ERROR state, don't switch back to IDLE state in case a non-fatal error is received
                if (this.state !== base_stream_controller_1.State.ERROR) {
                    // if fatal error, stop processing, otherwise move to IDLE to retry loading
                    this.state = data.fatal ? base_stream_controller_1.State.ERROR : base_stream_controller_1.State.IDLE;
                    logger_1.logger.warn("AudioStreamController: " + data.details + " while loading frag, now switching to " + this.state + " state ...");
                }
                break;
            case errors_1.ErrorDetails.BUFFER_FULL_ERROR:
                // if in appending state
                if (data.parent === 'audio' && (this.state === base_stream_controller_1.State.PARSING || this.state === base_stream_controller_1.State.PARSED)) {
                    var media = this.mediaBuffer, currentTime = this.media.currentTime, mediaBuffered = media && buffer_helper_1.BufferHelper.isBuffered(media, currentTime) && buffer_helper_1.BufferHelper.isBuffered(media, currentTime + 0.5);
                    // reduce max buf len if current position is buffered
                    if (mediaBuffered) {
                        var config = this.config;
                        if (config.maxMaxBufferLength >= config.maxBufferLength) {
                            // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
                            config.maxMaxBufferLength /= 2;
                            logger_1.logger.warn("AudioStreamController: reduce max buffer length to " + config.maxMaxBufferLength + "s");
                        }
                        this.state = base_stream_controller_1.State.IDLE;
                    }
                    else {
                        // current position is not buffered, but browser is still complaining about buffer full error
                        // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
                        // in that case flush the whole audio buffer to recover
                        logger_1.logger.warn('AudioStreamController: buffer full error also media.currentTime is not buffered, flush audio buffer');
                        this.fragCurrent = null;
                        // flush everything
                        this.state = base_stream_controller_1.State.BUFFER_FLUSHING;
                        this.hls.trigger(events_1.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
                    }
                }
                break;
            default:
                break;
        }
    };
    AudioStreamController.prototype.onBufferFlushed = function () {
        var _this = this;
        var pendingData = this.pendingData;
        if (pendingData && pendingData.length) {
            logger_1.logger.log('AudioStreamController: appending pending audio data after buffer flushed');
            pendingData.forEach(function (appendObj) {
                _this.hls.trigger(events_1.default.BUFFER_APPENDING, appendObj);
            });
            this.appended = true;
            this.pendingData = [];
            this.state = base_stream_controller_1.State.PARSED;
        }
        else {
            // move to IDLE once flush complete. this should trigger new fragment loading
            this.state = base_stream_controller_1.State.IDLE;
            // reset reference to frag
            this.fragPrevious = null;
            this.tick();
        }
    };
    return AudioStreamController;
}(base_stream_controller_1.default));
exports.default = AudioStreamController;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/controller/audio-track-controller.js":
/*!**************************************************!*\
  !*** ./src/controller/audio-track-controller.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var task_loop_1 = __webpack_require__(/*! ../task-loop */ "./src/task-loop.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
/**
 * @class AudioTrackController
 * @implements {EventHandler}
 *
 * Handles main manifest and audio-track metadata loaded,
 * owns and exposes the selectable audio-tracks data-models.
 *
 * Exposes internal interface to select available audio-tracks.
 *
 * Handles errors on loading audio-track playlists. Manages fallback mechanism
 * with redundants tracks (group-IDs).
 *
 * Handles level-loading and group-ID switches for video (fallback on video levels),
 * and eventually adapts the audio-track group-ID to match.
 *
 * @fires AUDIO_TRACK_LOADING
 * @fires AUDIO_TRACK_SWITCHING
 * @fires AUDIO_TRACKS_UPDATED
 * @fires ERROR
 *
 */
var AudioTrackController = /** @class */ (function (_super) {
    __extends(AudioTrackController, _super);
    function AudioTrackController(hls) {
        var _this = _super.call(this, hls, events_1.default.MANIFEST_LOADING, events_1.default.MANIFEST_PARSED, events_1.default.AUDIO_TRACK_LOADED, events_1.default.AUDIO_TRACK_SWITCHED, events_1.default.LEVEL_LOADED, events_1.default.ERROR) || this;
        /**
         * @private
         * Currently selected index in `tracks`
         * @member {number} trackId
         */
        _this._trackId = -1;
        /**
         * @private
         * If should select tracks according to default track attribute
         * @member {boolean} _selectDefaultTrack
         */
        _this._selectDefaultTrack = true;
        /**
         * @public
         * All tracks available
         * @member {AudioTrack[]}
         */
        _this.tracks = [];
        /**
         * @public
         * List of blacklisted audio track IDs (that have caused failure)
         * @member {number[]}
         */
        _this.trackIdBlacklist = Object.create(null);
        /**
         * @public
         * The currently running group ID for audio
         * (we grab this on manifest-parsed and new level-loaded)
         * @member {string}
         */
        _this.audioGroupId = null;
        return _this;
    }
    /**
     * Reset audio tracks on new manifest loading.
     */
    AudioTrackController.prototype.onManifestLoading = function () {
        this.tracks = [];
        this._trackId = -1;
        this._selectDefaultTrack = true;
    };
    /**
     * Store tracks data from manifest parsed data.
     *
     * Trigger AUDIO_TRACKS_UPDATED event.
     *
     * @param {*} data
     */
    AudioTrackController.prototype.onManifestParsed = function (data) {
        var tracks = this.tracks = data.audioTracks || [];
        this.hls.trigger(events_1.default.AUDIO_TRACKS_UPDATED, { audioTracks: tracks });
    };
    /**
     * Store track details of loaded track in our data-model.
     *
     * Set-up metadata update interval task for live-mode streams.
     *
     * @param {} data
     */
    AudioTrackController.prototype.onAudioTrackLoaded = function (data) {
        if (data.id >= this.tracks.length) {
            logger_1.logger.warn('Invalid audio track id:', data.id);
            return;
        }
        logger_1.logger.log("audioTrack " + data.id + " loaded");
        this.tracks[data.id].details = data.details;
        // check if current playlist is a live playlist
        // and if we have already our reload interval setup
        if (data.details.live && !this.hasInterval()) {
            // if live playlist we will have to reload it periodically
            // set reload period to playlist target duration
            var updatePeriodMs = data.details.targetduration * 1000;
            this.setInterval(updatePeriodMs);
        }
        if (!data.details.live && this.hasInterval()) {
            // playlist is not live and timer is scheduled: cancel it
            this.clearInterval();
        }
    };
    /**
     * Update the internal group ID to any audio-track we may have set manually
     * or because of a failure-handling fallback.
     *
     * Quality-levels should update to that group ID in this case.
     *
     * @param {*} data
     */
    AudioTrackController.prototype.onAudioTrackSwitched = function (data) {
        var audioGroupId = this.tracks[data.id].groupId;
        if (audioGroupId && (this.audioGroupId !== audioGroupId)) {
            this.audioGroupId = audioGroupId;
        }
    };
    /**
     * When a level gets loaded, if it has redundant audioGroupIds (in the same ordinality as it's redundant URLs)
     * we are setting our audio-group ID internally to the one set, if it is different from the group ID currently set.
     *
     * If group-ID got update, we re-select the appropriate audio-track with this group-ID matching the currently
     * selected one (based on NAME property).
     *
     * @param {*} data
     */
    AudioTrackController.prototype.onLevelLoaded = function (data) {
        // FIXME: crashes because currentLevel is undefined
        // const levelInfo = this.hls.levels[this.hls.currentLevel];
        var levelInfo = this.hls.levels[data.level];
        if (!levelInfo.audioGroupIds) {
            return;
        }
        var audioGroupId = levelInfo.audioGroupIds[levelInfo.urlId];
        if (this.audioGroupId !== audioGroupId) {
            this.audioGroupId = audioGroupId;
            this._selectInitialAudioTrack();
        }
    };
    /**
     * Handle network errors loading audio track manifests
     * and also pausing on any netwok errors.
     *
     * @param {ErrorEventData} data
     */
    AudioTrackController.prototype.onError = function (data) {
        // Only handle network errors
        if (data.type !== errors_1.ErrorTypes.NETWORK_ERROR) {
            return;
        }
        // If fatal network error, cancel update task
        if (data.fatal) {
            this.clearInterval();
        }
        // If not an audio-track loading error don't handle further
        if (data.details !== errors_1.ErrorDetails.AUDIO_TRACK_LOAD_ERROR) {
            return;
        }
        logger_1.logger.warn('Network failure on audio-track id:', data.context.id);
        this._handleLoadError();
    };
    Object.defineProperty(AudioTrackController.prototype, "audioTracks", {
        /**
         * @type {AudioTrack[]} Audio-track list we own
         */
        get: function () {
            return this.tracks;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AudioTrackController.prototype, "audioTrack", {
        /**
         * @type {number} Index into audio-tracks list of currently selected track.
         */
        get: function () {
            return this._trackId;
        },
        /**
         * Select current track by index
         */
        set: function (newId) {
            this._setAudioTrack(newId);
            // If audio track is selected from API then don't choose from the manifest default track
            this._selectDefaultTrack = false;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @private
     * @param {number} newId
     */
    AudioTrackController.prototype._setAudioTrack = function (newId) {
        // noop on same audio track id as already set
        if (this._trackId === newId && this.tracks[this._trackId].details) {
            logger_1.logger.debug('Same id as current audio-track passed, and track details available -> no-op');
            return;
        }
        // check if level idx is valid
        if (newId < 0 || newId >= this.tracks.length) {
            logger_1.logger.warn('Invalid id passed to audio-track controller');
            return;
        }
        var audioTrack = this.tracks[newId];
        logger_1.logger.log("Now switching to audio-track index " + newId);
        // stopping live reloading timer if any
        this.clearInterval();
        this._trackId = newId;
        var url = audioTrack.url, type = audioTrack.type, id = audioTrack.id;
        this.hls.trigger(events_1.default.AUDIO_TRACK_SWITCHING, { id: id, type: type, url: url });
        this._loadTrackDetailsIfNeeded(audioTrack);
    };
    /**
     * @override
     */
    AudioTrackController.prototype.doTick = function () {
        this._updateTrack(this._trackId);
    };
    /**
     * Select initial track
     * @private
     */
    AudioTrackController.prototype._selectInitialAudioTrack = function () {
        var _this = this;
        var tracks = this.tracks;
        if (!tracks.length) {
            return;
        }
        var currentAudioTrack = this.tracks[this._trackId];
        var name = null;
        if (currentAudioTrack) {
            name = currentAudioTrack.name;
        }
        // Pre-select default tracks if there are any
        if (this._selectDefaultTrack) {
            var defaultTracks = tracks.filter(function (track) { return track.default; });
            if (defaultTracks.length) {
                tracks = defaultTracks;
            }
            else {
                logger_1.logger.warn('No default audio tracks defined');
            }
        }
        var trackFound = false;
        var traverseTracks = function () {
            // Select track with right group ID
            tracks.forEach(function (track) {
                if (trackFound) {
                    return;
                }
                // We need to match the (pre-)selected group ID
                // and the NAME of the current track.
                if ((!_this.audioGroupId || track.groupId === _this.audioGroupId) &&
                    (!name || name === track.name)) {
                    // If there was a previous track try to stay with the same `NAME`.
                    // It should be unique across tracks of same group, and consistent through redundant track groups.
                    _this._setAudioTrack(track.id);
                    trackFound = true;
                }
            });
        };
        traverseTracks();
        if (!trackFound) {
            name = null;
            traverseTracks();
        }
        if (!trackFound) {
            logger_1.logger.error("No track found for running audio group-ID: " + this.audioGroupId);
            this.hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.MEDIA_ERROR,
                details: errors_1.ErrorDetails.AUDIO_TRACK_LOAD_ERROR,
                fatal: true
            });
        }
    };
    /**
     * @private
     * @param {AudioTrack} audioTrack
     * @returns {boolean}
     */
    AudioTrackController.prototype._needsTrackLoading = function (audioTrack) {
        var details = audioTrack.details, url = audioTrack.url;
        if (!details || details.live) {
            // check if we face an audio track embedded in main playlist (audio track without URI attribute)
            return !!url;
        }
        return false;
    };
    /**
     * @private
     * @param {AudioTrack} audioTrack
     */
    AudioTrackController.prototype._loadTrackDetailsIfNeeded = function (audioTrack) {
        if (this._needsTrackLoading(audioTrack)) {
            var url = audioTrack.url, id = audioTrack.id;
            // track not retrieved yet, or live playlist we need to (re)load it
            logger_1.logger.log("loading audio-track playlist for id: " + id);
            this.hls.trigger(events_1.default.AUDIO_TRACK_LOADING, { url: url, id: id });
        }
    };
    /**
     * @private
     * @param {number} newId
     */
    AudioTrackController.prototype._updateTrack = function (newId) {
        // check if level idx is valid
        if (newId < 0 || newId >= this.tracks.length) {
            return;
        }
        // stopping live reloading timer if any
        this.clearInterval();
        this._trackId = newId;
        logger_1.logger.log("trying to update audio-track " + newId);
        var audioTrack = this.tracks[newId];
        this._loadTrackDetailsIfNeeded(audioTrack);
    };
    /**
     * @private
     */
    AudioTrackController.prototype._handleLoadError = function () {
        // First, let's black list current track id
        this.trackIdBlacklist[this._trackId] = true;
        // Let's try to fall back on a functional audio-track with the same group ID
        var previousId = this._trackId;
        var _a = this.tracks[previousId], name = _a.name, language = _a.language, groupId = _a.groupId;
        logger_1.logger.warn("Loading failed on audio track id: " + previousId + ", group-id: " + groupId + ", name/language: \"" + name + "\" / \"" + language + "\"");
        // Find a non-blacklisted track ID with the same NAME
        // At least a track that is not blacklisted, thus on another group-ID.
        var newId = previousId;
        for (var i = 0; i < this.tracks.length; i++) {
            if (this.trackIdBlacklist[i]) {
                continue;
            }
            var newTrack = this.tracks[i];
            if (newTrack.name === name) {
                newId = i;
                break;
            }
        }
        if (newId === previousId) {
            logger_1.logger.warn("No fallback audio-track found for name/language: \"" + name + "\" / \"" + language + "\"");
            return;
        }
        logger_1.logger.log('Attempting audio-track fallback id:', newId, 'group-id:', this.tracks[newId].groupId);
        this._setAudioTrack(newId);
    };
    return AudioTrackController;
}(task_loop_1.default));
exports.default = AudioTrackController;


/***/ }),

/***/ "./src/controller/base-stream-controller.js":
/*!**************************************************!*\
  !*** ./src/controller/base-stream-controller.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var task_loop_1 = __webpack_require__(/*! ../task-loop */ "./src/task-loop.js");
var fragment_tracker_1 = __webpack_require__(/*! ./fragment-tracker */ "./src/controller/fragment-tracker.js");
var buffer_helper_1 = __webpack_require__(/*! ../utils/buffer-helper */ "./src/utils/buffer-helper.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
exports.State = {
    STOPPED: 'STOPPED',
    STARTING: 'STARTING',
    IDLE: 'IDLE',
    PAUSED: 'PAUSED',
    KEY_LOADING: 'KEY_LOADING',
    FRAG_LOADING: 'FRAG_LOADING',
    FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
    WAITING_TRACK: 'WAITING_TRACK',
    PARSING: 'PARSING',
    PARSED: 'PARSED',
    BUFFER_FLUSHING: 'BUFFER_FLUSHING',
    ENDED: 'ENDED',
    ERROR: 'ERROR',
    WAITING_INIT_PTS: 'WAITING_INIT_PTS',
    WAITING_LEVEL: 'WAITING_LEVEL'
};
var BaseStreamController = /** @class */ (function (_super) {
    __extends(BaseStreamController, _super);
    function BaseStreamController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseStreamController.prototype.doTick = function () { };
    BaseStreamController.prototype.startLoad = function () { };
    BaseStreamController.prototype.stopLoad = function () {
        var frag = this.fragCurrent;
        if (frag) {
            if (frag.loader) {
                frag.loader.abort();
            }
            this.fragmentTracker.removeFragment(frag);
        }
        if (this.demuxer) {
            this.demuxer.destroy();
            this.demuxer = null;
        }
        this.fragCurrent = null;
        this.fragPrevious = null;
        this.clearInterval();
        this.clearNextTick();
        this.state = exports.State.STOPPED;
    };
    BaseStreamController.prototype._streamEnded = function (bufferInfo, levelDetails) {
        var _a = this, fragCurrent = _a.fragCurrent, fragmentTracker = _a.fragmentTracker;
        // we just got done loading the final fragment and there is no other buffered range after ...
        // rationale is that in case there are any buffered ranges after, it means that there are unbuffered portion in between
        // so we should not switch to ENDED in that case, to be able to buffer them
        // dont switch to ENDED if we need to backtrack last fragment
        if (!levelDetails.live && fragCurrent && !fragCurrent.backtracked && fragCurrent.sn === levelDetails.endSN && !bufferInfo.nextStart) {
            var fragState = fragmentTracker.getState(fragCurrent);
            return fragState === fragment_tracker_1.FragmentState.PARTIAL || fragState === fragment_tracker_1.FragmentState.OK;
        }
        return false;
    };
    BaseStreamController.prototype.onMediaSeeking = function () {
        var _a = this, config = _a.config, media = _a.media, mediaBuffer = _a.mediaBuffer, state = _a.state;
        var currentTime = media ? media.currentTime : null;
        var bufferInfo = buffer_helper_1.BufferHelper.bufferInfo(mediaBuffer || media, currentTime, this.config.maxBufferHole);
        if (Number.isFinite(currentTime)) {
            logger_1.logger.log("media seeking to " + currentTime.toFixed(3));
        }
        if (state === exports.State.FRAG_LOADING) {
            var fragCurrent = this.fragCurrent;
            // check if we are seeking to a unbuffered area AND if frag loading is in progress
            if (bufferInfo.len === 0 && fragCurrent) {
                var tolerance = config.maxFragLookUpTolerance;
                var fragStartOffset = fragCurrent.start - tolerance;
                var fragEndOffset = fragCurrent.start + fragCurrent.duration + tolerance;
                // check if we seek position will be out of currently loaded frag range : if out cancel frag load, if in, don't do anything
                if (currentTime < fragStartOffset || currentTime > fragEndOffset) {
                    if (fragCurrent.loader) {
                        logger_1.logger.log('seeking outside of buffer while fragment load in progress, cancel fragment load');
                        fragCurrent.loader.abort();
                    }
                    this.fragCurrent = null;
                    this.fragPrevious = null;
                    // switch to IDLE state to load new fragment
                    this.state = exports.State.IDLE;
                }
                else {
                    logger_1.logger.log('seeking outside of buffer but within currently loaded fragment range');
                }
            }
        }
        else if (state === exports.State.ENDED) {
            // if seeking to unbuffered area, clean up fragPrevious
            if (bufferInfo.len === 0) {
                this.fragPrevious = null;
                this.fragCurrent = null;
            }
            // switch to IDLE state to check for potential new fragment
            this.state = exports.State.IDLE;
        }
        if (media) {
            this.lastCurrentTime = currentTime;
        }
        // in case seeking occurs although no media buffered, adjust startPosition and nextLoadPosition to seek target
        if (!this.loadedmetadata) {
            this.nextLoadPosition = this.startPosition = currentTime;
        }
        // tick to speed up processing
        this.tick();
    };
    BaseStreamController.prototype.onMediaEnded = function () {
        // reset startPosition and lastCurrentTime to restart playback @ stream beginning
        this.startPosition = this.lastCurrentTime = 0;
    };
    BaseStreamController.prototype.onHandlerDestroying = function () {
        this.stopLoad();
        _super.prototype.onHandlerDestroying.call(this);
    };
    BaseStreamController.prototype.onHandlerDestroyed = function () {
        this.state = exports.State.STOPPED;
        this.fragmentTracker = null;
    };
    return BaseStreamController;
}(task_loop_1.default));
exports.default = BaseStreamController;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/controller/buffer-controller.js":
/*!*********************************************!*\
  !*** ./src/controller/buffer-controller.js ***!
  \*********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
/*
 * Buffer Controller
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var mediasource_helper_1 = __webpack_require__(/*! ../utils/mediasource-helper */ "./src/utils/mediasource-helper.js");
var MediaSource = mediasource_helper_1.getMediaSource();
var BufferController = /** @class */ (function (_super) {
    __extends(BufferController, _super);
    function BufferController(hls) {
        var _this = _super.call(this, hls, events_1.default.MEDIA_ATTACHING, events_1.default.MEDIA_DETACHING, events_1.default.MANIFEST_PARSED, events_1.default.BUFFER_RESET, events_1.default.BUFFER_APPENDING, events_1.default.BUFFER_CODECS, events_1.default.BUFFER_EOS, events_1.default.BUFFER_FLUSHING, events_1.default.LEVEL_PTS_UPDATED, events_1.default.LEVEL_UPDATED) || this;
        // the value that we have set mediasource.duration to
        // (the actual duration may be tweaked slighly by the browser)
        _this._msDuration = null;
        // the value that we want to set mediaSource.duration to
        _this._levelDuration = null;
        // the target duration of the current media playlist
        _this._levelTargetDuration = 10;
        // current stream state: true - for live broadcast, false - for VoD content
        _this._live = null;
        // cache the self generated object url to detect hijack of video tag
        _this._objectUrl = null;
        // The number of BUFFER_CODEC events received before any sourceBuffers are created
        _this.bufferCodecEventsExpected = 0;
        // Source Buffer listeners
        _this.onsbue = _this.onSBUpdateEnd.bind(_this);
        _this.onsbe = _this.onSBUpdateError.bind(_this);
        _this.pendingTracks = {};
        _this.tracks = {};
        return _this;
    }
    BufferController.prototype.destroy = function () {
        event_handler_1.default.prototype.destroy.call(this);
    };
    BufferController.prototype.onLevelPtsUpdated = function (data) {
        var type = data.type;
        var audioTrack = this.tracks.audio;
        // Adjusting `SourceBuffer.timestampOffset` (desired point in the timeline where the next frames should be appended)
        // in Chrome browser when we detect MPEG audio container and time delta between level PTS and `SourceBuffer.timestampOffset`
        // is greater than 100ms (this is enough to handle seek for VOD or level change for LIVE videos). At the time of change we issue
        // `SourceBuffer.abort()` and adjusting `SourceBuffer.timestampOffset` if `SourceBuffer.updating` is false or awaiting `updateend`
        // event if SB is in updating state.
        // More info here: https://github.com/video-dev/hls.js/issues/332#issuecomment-257986486
        if (type === 'audio' && audioTrack && audioTrack.container === 'audio/mpeg') { // Chrome audio mp3 track
            var audioBuffer = this.sourceBuffer.audio;
            var delta = Math.abs(audioBuffer.timestampOffset - data.start);
            // adjust timestamp offset if time delta is greater than 100ms
            if (delta > 0.1) {
                var updating = audioBuffer.updating;
                try {
                    audioBuffer.abort();
                }
                catch (err) {
                    logger_1.logger.warn('can not abort audio buffer: ' + err);
                }
                if (!updating) {
                    logger_1.logger.warn('change mpeg audio timestamp offset from ' + audioBuffer.timestampOffset + ' to ' + data.start);
                    audioBuffer.timestampOffset = data.start;
                }
                else {
                    this.audioTimestampOffset = data.start;
                }
            }
        }
    };
    BufferController.prototype.onManifestParsed = function (data) {
        // in case of alt audio 2 BUFFER_CODECS events will be triggered, one per stream controller
        // sourcebuffers will be created all at once when the expected nb of tracks will be reached
        // in case alt audio is not used, only one BUFFER_CODEC event will be fired from main stream controller
        // it will contain the expected nb of source buffers, no need to compute it
        this.bufferCodecEventsExpected = data.altAudio ? 2 : 1;
        logger_1.logger.log(this.bufferCodecEventsExpected + " bufferCodec event(s) expected");
    };
    BufferController.prototype.onMediaAttaching = function (data) {
        var media = this.media = data.media;
        if (media) {
            // setup the media source
            var ms = this.mediaSource = new MediaSource();
            // Media Source listeners
            this.onmso = this.onMediaSourceOpen.bind(this);
            this.onmse = this.onMediaSourceEnded.bind(this);
            this.onmsc = this.onMediaSourceClose.bind(this);
            ms.addEventListener('sourceopen', this.onmso);
            ms.addEventListener('sourceended', this.onmse);
            ms.addEventListener('sourceclose', this.onmsc);
            // link video and media Source
            media.src = window.URL.createObjectURL(ms);
            // cache the locally generated object url
            this._objectUrl = media.src;
        }
    };
    BufferController.prototype.onMediaDetaching = function () {
        logger_1.logger.log('media source detaching');
        var ms = this.mediaSource;
        if (ms) {
            if (ms.readyState === 'open') {
                try {
                    // endOfStream could trigger exception if any sourcebuffer is in updating state
                    // we don't really care about checking sourcebuffer state here,
                    // as we are anyway detaching the MediaSource
                    // let's just avoid this exception to propagate
                    ms.endOfStream();
                }
                catch (err) {
                    logger_1.logger.warn("onMediaDetaching:" + err.message + " while calling endOfStream");
                }
            }
            ms.removeEventListener('sourceopen', this.onmso);
            ms.removeEventListener('sourceended', this.onmse);
            ms.removeEventListener('sourceclose', this.onmsc);
            // Detach properly the MediaSource from the HTMLMediaElement as
            // suggested in https://github.com/w3c/media-source/issues/53.
            if (this.media) {
                window.URL.revokeObjectURL(this._objectUrl);
                // clean up video tag src only if it's our own url. some external libraries might
                // hijack the video tag and change its 'src' without destroying the Hls instance first
                if (this.media.src === this._objectUrl) {
                    this.media.removeAttribute('src');
                    this.media.load();
                }
                else {
                    logger_1.logger.warn('media.src was changed by a third party - skip cleanup');
                }
            }
            this.mediaSource = null;
            this.media = null;
            this._objectUrl = null;
            this.pendingTracks = {};
            this.tracks = {};
            this.sourceBuffer = {};
            this.flushRange = [];
            this.segments = [];
            this.appended = 0;
        }
        this.onmso = this.onmse = this.onmsc = null;
        this.hls.trigger(events_1.default.MEDIA_DETACHED);
    };
    BufferController.prototype.onMediaSourceOpen = function () {
        logger_1.logger.log('media source opened');
        this.hls.trigger(events_1.default.MEDIA_ATTACHED, { media: this.media });
        var mediaSource = this.mediaSource;
        if (mediaSource) {
            // once received, don't listen anymore to sourceopen event
            mediaSource.removeEventListener('sourceopen', this.onmso);
        }
        this.checkPendingTracks();
    };
    BufferController.prototype.checkPendingTracks = function () {
        var _a = this, bufferCodecEventsExpected = _a.bufferCodecEventsExpected, pendingTracks = _a.pendingTracks;
        // Check if we've received all of the expected bufferCodec events. When none remain, create all the sourceBuffers at once.
        // This is important because the MSE spec allows implementations to throw QuotaExceededErrors if creating new sourceBuffers after
        // data has been appended to existing ones.
        // 2 tracks is the max (one for audio, one for video). If we've reach this max go ahead and create the buffers.
        var pendingTracksCount = Object.keys(pendingTracks).length;
        if ((pendingTracksCount && !bufferCodecEventsExpected) || pendingTracksCount === 2) {
            // ok, let's create them now !
            this.createSourceBuffers(pendingTracks);
            this.pendingTracks = {};
            // append any pending segments now !
            this.doAppending();
        }
    };
    BufferController.prototype.onMediaSourceClose = function () {
        logger_1.logger.log('media source closed');
    };
    BufferController.prototype.onMediaSourceEnded = function () {
        logger_1.logger.log('media source ended');
    };
    BufferController.prototype.onSBUpdateEnd = function () {
        // update timestampOffset
        if (this.audioTimestampOffset) {
            var audioBuffer = this.sourceBuffer.audio;
            logger_1.logger.warn("change mpeg audio timestamp offset from " + audioBuffer.timestampOffset + " to " + this.audioTimestampOffset);
            audioBuffer.timestampOffset = this.audioTimestampOffset;
            delete this.audioTimestampOffset;
        }
        if (this._needsFlush) {
            this.doFlush();
        }
        if (this._needsEos) {
            this.checkEos();
        }
        this.appending = false;
        var parent = this.parent;
        // count nb of pending segments waiting for appending on this sourcebuffer
        var pending = this.segments.reduce(function (counter, segment) { return (segment.parent === parent) ? counter + 1 : counter; }, 0);
        // this.sourceBuffer is better to use than media.buffered as it is closer to the PTS data from the fragments
        var timeRanges = {};
        var sourceBuffer = this.sourceBuffer;
        for (var streamType in sourceBuffer) {
            timeRanges[streamType] = sourceBuffer[streamType].buffered;
        }
        this.hls.trigger(events_1.default.BUFFER_APPENDED, { parent: parent, pending: pending, timeRanges: timeRanges });
        // don't append in flushing mode
        if (!this._needsFlush) {
            this.doAppending();
        }
        this.updateMediaElementDuration();
        // appending goes first
        if (pending === 0) {
            this.flushLiveBackBuffer();
        }
    };
    BufferController.prototype.onSBUpdateError = function (event) {
        logger_1.logger.error('sourceBuffer error:', event);
        // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
        // this error might not always be fatal (it is fatal if decode error is set, in that case
        // it will be followed by a mediaElement error ...)
        this.hls.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MEDIA_ERROR, details: errors_1.ErrorDetails.BUFFER_APPENDING_ERROR, fatal: false });
        // we don't need to do more than that, as accordin to the spec, updateend will be fired just after
    };
    BufferController.prototype.onBufferReset = function () {
        var sourceBuffer = this.sourceBuffer;
        for (var type in sourceBuffer) {
            var sb = sourceBuffer[type];
            try {
                this.mediaSource.removeSourceBuffer(sb);
                sb.removeEventListener('updateend', this.onsbue);
                sb.removeEventListener('error', this.onsbe);
            }
            catch (err) {
            }
        }
        this.sourceBuffer = {};
        this.flushRange = [];
        this.segments = [];
        this.appended = 0;
    };
    BufferController.prototype.onBufferCodecs = function (tracks) {
        var _this = this;
        // if source buffer(s) not created yet, appended buffer tracks in this.pendingTracks
        // if sourcebuffers already created, do nothing ...
        if (Object.keys(this.sourceBuffer).length) {
            return;
        }
        Object.keys(tracks).forEach(function (trackName) {
            _this.pendingTracks[trackName] = tracks[trackName];
        });
        var mediaSource = this.mediaSource;
        this.bufferCodecEventsExpected = Math.max(this.bufferCodecEventsExpected - 1, 0);
        if (mediaSource && mediaSource.readyState === 'open') {
            this.checkPendingTracks();
        }
    };
    BufferController.prototype.createSourceBuffers = function (tracks) {
        var sourceBuffer = this.sourceBuffer, mediaSource = this.mediaSource;
        for (var trackName in tracks) {
            if (!sourceBuffer[trackName]) {
                var track = tracks[trackName];
                // use levelCodec as first priority
                var codec = track.levelCodec || track.codec;
                var mimeType = track.container + ";codecs=" + codec;
                logger_1.logger.log("creating sourceBuffer(" + mimeType + ")");
                try {
                    var sb = sourceBuffer[trackName] = mediaSource.addSourceBuffer(mimeType);
                    sb.addEventListener('updateend', this.onsbue);
                    sb.addEventListener('error', this.onsbe);
                    this.tracks[trackName] = { codec: codec, container: track.container };
                    track.buffer = sb;
                }
                catch (err) {
                    logger_1.logger.error("error while trying to add sourceBuffer:" + err.message);
                    this.hls.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MEDIA_ERROR, details: errors_1.ErrorDetails.BUFFER_ADD_CODEC_ERROR, fatal: false, err: err, mimeType: mimeType });
                }
            }
        }
        this.hls.trigger(events_1.default.BUFFER_CREATED, { tracks: tracks });
    };
    BufferController.prototype.onBufferAppending = function (data) {
        if (!this._needsFlush) {
            if (!this.segments) {
                this.segments = [data];
            }
            else {
                this.segments.push(data);
            }
            this.doAppending();
        }
    };
    BufferController.prototype.onBufferAppendFail = function (data) {
        logger_1.logger.error('sourceBuffer error:', data.event);
        // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
        // this error might not always be fatal (it is fatal if decode error is set, in that case
        // it will be followed by a mediaElement error ...)
        this.hls.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MEDIA_ERROR, details: errors_1.ErrorDetails.BUFFER_APPENDING_ERROR, fatal: false });
    };
    // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()
    BufferController.prototype.onBufferEos = function (data) {
        var sb = this.sourceBuffer;
        var dataType = data.type;
        for (var type in sb) {
            if (!dataType || type === dataType) {
                if (!sb[type].ended) {
                    sb[type].ended = true;
                    logger_1.logger.log(type + " sourceBuffer now EOS");
                }
            }
        }
        this.checkEos();
    };
    // if all source buffers are marked as ended, signal endOfStream() to MediaSource.
    BufferController.prototype.checkEos = function () {
        var sb = this.sourceBuffer, mediaSource = this.mediaSource;
        if (!mediaSource || mediaSource.readyState !== 'open') {
            this._needsEos = false;
            return;
        }
        for (var type in sb) {
            var sbobj = sb[type];
            if (!sbobj.ended) {
                return;
            }
            if (sbobj.updating) {
                this._needsEos = true;
                return;
            }
        }
        logger_1.logger.log('all media data are available, signal endOfStream() to MediaSource and stop loading fragment');
        // Notify the media element that it now has all of the media data
        try {
            mediaSource.endOfStream();
        }
        catch (e) {
            logger_1.logger.warn('exception while calling mediaSource.endOfStream()');
        }
        this._needsEos = false;
    };
    BufferController.prototype.onBufferFlushing = function (data) {
        this.flushRange.push({ start: data.startOffset, end: data.endOffset, type: data.type });
        // attempt flush immediately
        this.flushBufferCounter = 0;
        this.doFlush();
    };
    BufferController.prototype.flushLiveBackBuffer = function () {
        // clear back buffer for live only
        if (!this._live) {
            return;
        }
        var liveBackBufferLength = this.hls.config.liveBackBufferLength;
        if (!isFinite(liveBackBufferLength) || liveBackBufferLength < 0) {
            return;
        }
        var currentTime = this.media.currentTime;
        var sourceBuffer = this.sourceBuffer;
        var bufferTypes = Object.keys(sourceBuffer);
        var targetBackBufferPosition = currentTime - Math.max(liveBackBufferLength, this._levelTargetDuration);
        for (var index = bufferTypes.length - 1; index >= 0; index--) {
            var bufferType = bufferTypes[index], buffered = sourceBuffer[bufferType].buffered;
            // when target buffer start exceeds actual buffer start
            if (buffered.length > 0 && targetBackBufferPosition > buffered.start(0)) {
                // remove buffer up until current time minus minimum back buffer length (removing buffer too close to current
                // time will lead to playback freezing)
                // credits for level target duration - https://github.com/videojs/http-streaming/blob/3132933b6aa99ddefab29c10447624efd6fd6e52/src/segment-loader.js#L91
                this.removeBufferRange(bufferType, sourceBuffer[bufferType], 0, targetBackBufferPosition);
            }
        }
    };
    BufferController.prototype.onLevelUpdated = function (_a) {
        var details = _a.details;
        if (details.fragments.length > 0) {
            this._levelDuration = details.totalduration + details.fragments[0].start;
            this._levelTargetDuration = details.averagetargetduration || details.targetduration || 10;
            this._live = details.live;
            this.updateMediaElementDuration();
        }
    };
    /**
     * Update Media Source duration to current level duration or override to Infinity if configuration parameter
     * 'liveDurationInfinity` is set to `true`
     * More details: https://github.com/video-dev/hls.js/issues/355
     */
    BufferController.prototype.updateMediaElementDuration = function () {
        var config = this.hls.config;
        var duration;
        if (this._levelDuration === null ||
            !this.media ||
            !this.mediaSource ||
            !this.sourceBuffer ||
            this.media.readyState === 0 ||
            this.mediaSource.readyState !== 'open') {
            return;
        }
        for (var type in this.sourceBuffer) {
            if (this.sourceBuffer[type].updating === true) {
                // can't set duration whilst a buffer is updating
                return;
            }
        }
        duration = this.media.duration;
        // initialise to the value that the media source is reporting
        if (this._msDuration === null) {
            this._msDuration = this.mediaSource.duration;
        }
        if (this._live === true && config.liveDurationInfinity === true) {
            // Override duration to Infinity
            logger_1.logger.log('Media Source duration is set to Infinity');
            this._msDuration = this.mediaSource.duration = Infinity;
        }
        else if ((this._levelDuration > this._msDuration && this._levelDuration > duration) || !Number.isFinite(duration)) {
            // levelDuration was the last value we set.
            // not using mediaSource.duration as the browser may tweak this value
            // only update Media Source duration if its value increase, this is to avoid
            // flushing already buffered portion when switching between quality level
            logger_1.logger.log("Updating Media Source duration to " + this._levelDuration.toFixed(3));
            this._msDuration = this.mediaSource.duration = this._levelDuration;
        }
    };
    BufferController.prototype.doFlush = function () {
        // loop through all buffer ranges to flush
        while (this.flushRange.length) {
            var range = this.flushRange[0];
            // flushBuffer will abort any buffer append in progress and flush Audio/Video Buffer
            if (this.flushBuffer(range.start, range.end, range.type)) {
                // range flushed, remove from flush array
                this.flushRange.shift();
                this.flushBufferCounter = 0;
            }
            else {
                this._needsFlush = true;
                // avoid looping, wait for SB update end to retrigger a flush
                return;
            }
        }
        if (this.flushRange.length === 0) {
            // everything flushed
            this._needsFlush = false;
            // let's recompute this.appended, which is used to avoid flush looping
            var appended = 0;
            var sourceBuffer = this.sourceBuffer;
            try {
                for (var type in sourceBuffer) {
                    appended += sourceBuffer[type].buffered.length;
                }
            }
            catch (error) {
                // error could be thrown while accessing buffered, in case sourcebuffer has already been removed from MediaSource
                // this is harmess at this stage, catch this to avoid reporting an internal exception
                logger_1.logger.error('error while accessing sourceBuffer.buffered');
            }
            this.appended = appended;
            this.hls.trigger(events_1.default.BUFFER_FLUSHED);
        }
    };
    BufferController.prototype.doAppending = function () {
        var _a = this, hls = _a.hls, segments = _a.segments, sourceBuffer = _a.sourceBuffer;
        if (Object.keys(sourceBuffer).length) {
            if (this.media.error) {
                this.segments = [];
                logger_1.logger.error('trying to append although a media error occured, flush segment and abort');
                return;
            }
            if (this.appending) {
                // logger.log(`sb appending in progress`);
                return;
            }
            if (segments && segments.length) {
                var segment = segments.shift();
                try {
                    var type = segment.type, sb = sourceBuffer[type];
                    if (sb) {
                        if (!sb.updating) {
                            // reset sourceBuffer ended flag before appending segment
                            sb.ended = false;
                            // logger.log(`appending ${segment.content} ${type} SB, size:${segment.data.length}, ${segment.parent}`);
                            this.parent = segment.parent;
                            sb.appendBuffer(segment.data);
                            this.appendError = 0;
                            this.appended++;
                            this.appending = true;
                        }
                        else {
                            segments.unshift(segment);
                        }
                    }
                    else {
                        // in case we don't have any source buffer matching with this segment type,
                        // it means that Mediasource fails to create sourcebuffer
                        // discard this segment, and trigger update end
                        this.onSBUpdateEnd();
                    }
                }
                catch (err) {
                    // in case any error occured while appending, put back segment in segments table
                    logger_1.logger.error("error while trying to append buffer:" + err.message);
                    segments.unshift(segment);
                    var event_1 = { type: errors_1.ErrorTypes.MEDIA_ERROR, parent: segment.parent };
                    if (err.code !== 22) {
                        if (this.appendError) {
                            this.appendError++;
                        }
                        else {
                            this.appendError = 1;
                        }
                        event_1.details = errors_1.ErrorDetails.BUFFER_APPEND_ERROR;
                        /* with UHD content, we could get loop of quota exceeded error until
                          browser is able to evict some data from sourcebuffer. retrying help recovering this
                        */
                        if (this.appendError > hls.config.appendErrorMaxRetry) {
                            logger_1.logger.log("fail " + hls.config.appendErrorMaxRetry + " times to append segment in sourceBuffer");
                            this.segments = [];
                            event_1.fatal = true;
                            hls.trigger(events_1.default.ERROR, event_1);
                        }
                        else {
                            event_1.fatal = false;
                            hls.trigger(events_1.default.ERROR, event_1);
                        }
                    }
                    else {
                        // QuotaExceededError: http://www.w3.org/TR/html5/infrastructure.html#quotaexceedederror
                        // let's stop appending any segments, and report BUFFER_FULL_ERROR error
                        this.segments = [];
                        event_1.details = errors_1.ErrorDetails.BUFFER_FULL_ERROR;
                        event_1.fatal = false;
                        hls.trigger(events_1.default.ERROR, event_1);
                    }
                }
            }
        }
    };
    /*
      flush specified buffered range,
      return true once range has been flushed.
      as sourceBuffer.remove() is asynchronous, flushBuffer will be retriggered on sourceBuffer update end
    */
    BufferController.prototype.flushBuffer = function (startOffset, endOffset, typeIn) {
        var sb;
        var sourceBuffer = this.sourceBuffer;
        if (Object.keys(sourceBuffer).length) {
            logger_1.logger.log("flushBuffer,pos/start/end: " + this.media.currentTime.toFixed(3) + "/" + startOffset + "/" + endOffset);
            // safeguard to avoid infinite looping : don't try to flush more than the nb of appended segments
            if (this.flushBufferCounter < this.appended) {
                for (var type in sourceBuffer) {
                    // check if sourcebuffer type is defined (typeIn): if yes, let's only flush this one
                    // if no, let's flush all sourcebuffers
                    if (typeIn && type !== typeIn) {
                        continue;
                    }
                    sb = sourceBuffer[type];
                    // we are going to flush buffer, mark source buffer as 'not ended'
                    sb.ended = false;
                    if (!sb.updating) {
                        if (this.removeBufferRange(type, sb, startOffset, endOffset)) {
                            this.flushBufferCounter++;
                            return false;
                        }
                    }
                    else {
                        logger_1.logger.warn('cannot flush, sb updating in progress');
                        return false;
                    }
                }
            }
            else {
                logger_1.logger.warn('abort flushing too many retries');
            }
            logger_1.logger.log('buffer flushed');
        }
        // everything flushed !
        return true;
    };
    /**
     * Removes first buffered range from provided source buffer that lies within given start and end offsets.
     *
     * @param type Type of the source buffer, logging purposes only.
     * @param sb Target SourceBuffer instance.
     * @param startOffset
     * @param endOffset
     *
     * @returns {boolean} True when source buffer remove requested.
     */
    BufferController.prototype.removeBufferRange = function (type, sb, startOffset, endOffset) {
        try {
            for (var i = 0; i < sb.buffered.length; i++) {
                var bufStart = sb.buffered.start(i);
                var bufEnd = sb.buffered.end(i);
                var removeStart = Math.max(bufStart, startOffset);
                var removeEnd = Math.min(bufEnd, endOffset);
                /* sometimes sourcebuffer.remove() does not flush
                  the exact expected time range.
                  to avoid rounding issues/infinite loop,
                  only flush buffer range of length greater than 500ms.
                */
                if (Math.min(removeEnd, bufEnd) - removeStart > 0.5) {
                    logger_1.logger.log("sb remove " + type + " [" + removeStart + "," + removeEnd + "], of [" + bufStart + "," + bufEnd + "], pos:" + this.media.currentTime);
                    sb.remove(removeStart, removeEnd);
                    return true;
                }
            }
        }
        catch (error) {
            logger_1.logger.warn('removeBufferRange failed', error);
        }
        return false;
    };
    return BufferController;
}(event_handler_1.default));
exports.default = BufferController;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/controller/cap-level-controller.js":
/*!************************************************!*\
  !*** ./src/controller/cap-level-controller.js ***!
  \************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
/*
 * cap stream level to media size dimension controller
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var CapLevelController = /** @class */ (function (_super) {
    __extends(CapLevelController, _super);
    function CapLevelController(hls) {
        var _this = _super.call(this, hls, events_1.default.FPS_DROP_LEVEL_CAPPING, events_1.default.MEDIA_ATTACHING, events_1.default.MANIFEST_PARSED, events_1.default.BUFFER_CODECS, events_1.default.MEDIA_DETACHING) || this;
        _this.autoLevelCapping = Number.POSITIVE_INFINITY;
        _this.firstLevel = null;
        _this.levels = [];
        _this.media = null;
        _this.restrictedLevels = [];
        _this.timer = null;
        return _this;
    }
    CapLevelController.prototype.destroy = function () {
        if (this.hls.config.capLevelToPlayerSize) {
            this.media = null;
            this._stopCapping();
        }
    };
    CapLevelController.prototype.onFpsDropLevelCapping = function (data) {
        // Don't add a restricted level more than once
        if (CapLevelController.isLevelAllowed(data.droppedLevel, this.restrictedLevels)) {
            this.restrictedLevels.push(data.droppedLevel);
        }
    };
    CapLevelController.prototype.onMediaAttaching = function (data) {
        this.media = data.media instanceof window.HTMLVideoElement ? data.media : null;
    };
    CapLevelController.prototype.onManifestParsed = function (data) {
        var hls = this.hls;
        this.restrictedLevels = [];
        this.levels = data.levels;
        this.firstLevel = data.firstLevel;
        if (hls.config.capLevelToPlayerSize && data.video) {
            // Start capping immediately if the manifest has signaled video codecs
            this._startCapping();
        }
    };
    // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
    // to the first level
    CapLevelController.prototype.onBufferCodecs = function (data) {
        var hls = this.hls;
        if (hls.config.capLevelToPlayerSize && data.video) {
            // If the manifest did not signal a video codec capping has been deferred until we're certain video is present
            this._startCapping();
        }
    };
    CapLevelController.prototype.onLevelsUpdated = function (data) {
        this.levels = data.levels;
    };
    CapLevelController.prototype.onMediaDetaching = function () {
        this._stopCapping();
    };
    CapLevelController.prototype.detectPlayerSize = function () {
        if (this.media) {
            var levelsLength = this.levels ? this.levels.length : 0;
            if (levelsLength) {
                var hls_1 = this.hls;
                hls_1.autoLevelCapping = this.getMaxLevel(levelsLength - 1);
                if (hls_1.autoLevelCapping > this.autoLevelCapping) {
                    // if auto level capping has a higher value for the previous one, flush the buffer using nextLevelSwitch
                    // usually happen when the user go to the fullscreen mode.
                    hls_1.streamController.nextLevelSwitch();
                }
                this.autoLevelCapping = hls_1.autoLevelCapping;
            }
        }
    };
    /*
    * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
    */
    CapLevelController.prototype.getMaxLevel = function (capLevelIndex) {
        var _this = this;
        if (!this.levels) {
            return -1;
        }
        var validLevels = this.levels.filter(function (level, index) {
            return CapLevelController.isLevelAllowed(index, _this.restrictedLevels) && index <= capLevelIndex;
        });
        return CapLevelController.getMaxLevelByMediaSize(validLevels, this.mediaWidth, this.mediaHeight);
    };
    CapLevelController.prototype._startCapping = function () {
        if (this.timer) {
            // Don't reset capping if started twice; this can happen if the manifest signals a video codec
            return;
        }
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        this.hls.firstLevel = this.getMaxLevel(this.firstLevel);
        clearInterval(this.timer);
        this.timer = setInterval(this.detectPlayerSize.bind(this), 1000);
        this.detectPlayerSize();
    };
    CapLevelController.prototype._stopCapping = function () {
        this.restrictedLevels = [];
        this.firstLevel = null;
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        if (this.timer) {
            this.timer = clearInterval(this.timer);
            this.timer = null;
        }
    };
    Object.defineProperty(CapLevelController.prototype, "mediaWidth", {
        get: function () {
            var width;
            var media = this.media;
            if (media) {
                width = media.width || media.clientWidth || media.offsetWidth;
                width *= CapLevelController.contentScaleFactor;
            }
            return width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CapLevelController.prototype, "mediaHeight", {
        get: function () {
            var height;
            var media = this.media;
            if (media) {
                height = media.height || media.clientHeight || media.offsetHeight;
                height *= CapLevelController.contentScaleFactor;
            }
            return height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CapLevelController, "contentScaleFactor", {
        get: function () {
            var pixelRatio = 1;
            try {
                pixelRatio = window.devicePixelRatio;
            }
            catch (e) { }
            return pixelRatio;
        },
        enumerable: true,
        configurable: true
    });
    CapLevelController.isLevelAllowed = function (level, restrictedLevels) {
        if (restrictedLevels === void 0) { restrictedLevels = []; }
        return restrictedLevels.indexOf(level) === -1;
    };
    CapLevelController.getMaxLevelByMediaSize = function (levels, width, height) {
        if (!levels || (levels && !levels.length)) {
            return -1;
        }
        // Levels can have the same dimensions but differing bandwidths - since levels are ordered, we can look to the next
        // to determine whether we've chosen the greatest bandwidth for the media's dimensions
        var atGreatestBandiwdth = function (curLevel, nextLevel) {
            if (!nextLevel) {
                return true;
            }
            return curLevel.width !== nextLevel.width || curLevel.height !== nextLevel.height;
        };
        // If we run through the loop without breaking, the media's dimensions are greater than every level, so default to
        // the max level
        var maxLevelIndex = levels.length - 1;
        for (var i = 0; i < levels.length; i += 1) {
            var level = levels[i];
            if ((level.width >= width || level.height >= height) && atGreatestBandiwdth(level, levels[i + 1])) {
                maxLevelIndex = i;
                break;
            }
        }
        return maxLevelIndex;
    };
    return CapLevelController;
}(event_handler_1.default));
exports.default = CapLevelController;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/controller/eme-controller.js":
/*!******************************************!*\
  !*** ./src/controller/eme-controller.js ***!
  \******************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @author Stephan Hesse <disparat@gmail.com> | <tchakabam@gmail.com>
 *
 * DRM support for Hls.js
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var XMLHttpRequest = window.XMLHttpRequest;
var MAX_LICENSE_REQUEST_FAILURES = 3;
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/requestMediaKeySystemAccess
 */
var KeySystems = {
    WIDEVINE: 'com.widevine.alpha',
    PLAYREADY: 'com.microsoft.playready'
};
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaKeySystemConfiguration
 * @param {Array<string>} audioCodecs List of required audio codecs to support
 * @param {Array<string>} videoCodecs List of required video codecs to support
 * @param {object} drmSystemOptions Optional parameters/requirements for the key-system
 * @returns {Array<MediaSystemConfiguration>} An array of supported configurations
 */
var createWidevineMediaKeySystemConfigurations = function (audioCodecs, videoCodecs, drmSystemOptions) {
    var baseConfig = {
        // initDataTypes: ['keyids', 'mp4'],
        // label: "",
        // persistentState: "not-allowed", // or "required" ?
        // distinctiveIdentifier: "not-allowed", // or "required" ?
        // sessionTypes: ['temporary'],
        videoCapabilities: [
        // { contentType: 'video/mp4; codecs="avc1.42E01E"' }
        ]
    };
    videoCodecs.forEach(function (codec) {
        baseConfig.videoCapabilities.push({
            contentType: "video/mp4; codecs=\"" + codec + "\""
        });
    });
    return [
        baseConfig
    ];
};
/**
 * The idea here is to handle key-system (and their respective platforms) specific configuration differences
 * in order to work with the local requestMediaKeySystemAccess method.
 *
 * We can also rule-out platform-related key-system support at this point by throwing an error or returning null.
 *
 * @param {string} keySystem Identifier for the key-system, see `KeySystems` enum
 * @param {Array<string>} audioCodecs List of required audio codecs to support
 * @param {Array<string>} videoCodecs List of required video codecs to support
 * @returns {Array<MediaSystemConfiguration> | null} A non-empty Array of MediaKeySystemConfiguration objects or `null`
 */
var getSupportedMediaKeySystemConfigurations = function (keySystem, audioCodecs, videoCodecs) {
    switch (keySystem) {
        case KeySystems.WIDEVINE:
            return createWidevineMediaKeySystemConfigurations(audioCodecs, videoCodecs);
        default:
            throw Error('Unknown key-system: ' + keySystem);
    }
};
/**
 * Controller to deal with encrypted media extensions (EME)
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Encrypted_Media_Extensions_API
 *
 * @class
 * @constructor
 */
var EMEController = /** @class */ (function (_super) {
    __extends(EMEController, _super);
    /**
       * @constructs
       * @param {Hls} hls Our Hls.js instance
       */
    function EMEController(hls) {
        var _this = _super.call(this, hls, events_1.default.MEDIA_ATTACHED, events_1.default.MANIFEST_PARSED) || this;
        _this._widevineLicenseUrl = hls.config.widevineLicenseUrl;
        _this._licenseXhrSetup = hls.config.licenseXhrSetup;
        _this._emeEnabled = hls.config.emeEnabled;
        _this._requestMediaKeySystemAccess = hls.config.requestMediaKeySystemAccessFunc;
        _this._mediaKeysList = [];
        _this._media = null;
        _this._hasSetMediaKeys = false;
        _this._isMediaEncrypted = false;
        _this._requestLicenseFailureCount = 0;
        return _this;
    }
    /**
       *
       * @param {string} keySystem Identifier for the key-system, see `KeySystems` enum
       * @returns {string} License server URL for key-system (if any configured, otherwise causes error)
       */
    EMEController.prototype.getLicenseServerUrl = function (keySystem) {
        var url;
        switch (keySystem) {
            case KeySystems.WIDEVINE:
                url = this._widevineLicenseUrl;
                break;
            default:
                url = null;
                break;
        }
        if (!url) {
            logger_1.logger.error("No license server URL configured for key-system \"" + keySystem + "\"");
            this.hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.KEY_SYSTEM_ERROR,
                details: errors_1.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                fatal: true
            });
        }
        return url;
    };
    /**
       * Requests access object and adds it to our list upon success
       * @private
       * @param {string} keySystem System ID (see `KeySystems`)
       * @param {Array<string>} audioCodecs List of required audio codecs to support
       * @param {Array<string>} videoCodecs List of required video codecs to support
       */
    EMEController.prototype._attemptKeySystemAccess = function (keySystem, audioCodecs, videoCodecs) {
        // TODO: add other DRM "options"
        var _this = this;
        var mediaKeySystemConfigs = getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs);
        if (!mediaKeySystemConfigs) {
            logger_1.logger.warn('Can not create config for key-system (maybe because platform is not supported):', keySystem);
            return;
        }
        logger_1.logger.log('Requesting encrypted media key-system access');
        // expecting interface like window.navigator.requestMediaKeySystemAccess
        this.requestMediaKeySystemAccess(keySystem, mediaKeySystemConfigs)
            .then(function (mediaKeySystemAccess) {
            _this._onMediaKeySystemAccessObtained(keySystem, mediaKeySystemAccess);
        })
            .catch(function (err) {
            logger_1.logger.error("Failed to obtain key-system \"" + keySystem + "\" access:", err);
        });
    };
    Object.defineProperty(EMEController.prototype, "requestMediaKeySystemAccess", {
        get: function () {
            if (!this._requestMediaKeySystemAccess) {
                throw new Error('No requestMediaKeySystemAccess function configured');
            }
            return this._requestMediaKeySystemAccess;
        },
        enumerable: true,
        configurable: true
    });
    /**
       * Handles obtaining access to a key-system
       *
       * @param {string} keySystem
       * @param {MediaKeySystemAccess} mediaKeySystemAccess https://developer.mozilla.org/en-US/docs/Web/API/MediaKeySystemAccess
       */
    EMEController.prototype._onMediaKeySystemAccessObtained = function (keySystem, mediaKeySystemAccess) {
        var _this = this;
        logger_1.logger.log("Access for key-system \"" + keySystem + "\" obtained");
        var mediaKeysListItem = {
            mediaKeys: null,
            mediaKeysSession: null,
            mediaKeysSessionInitialized: false,
            mediaKeySystemAccess: mediaKeySystemAccess,
            mediaKeySystemDomain: keySystem
        };
        this._mediaKeysList.push(mediaKeysListItem);
        mediaKeySystemAccess.createMediaKeys()
            .then(function (mediaKeys) {
            mediaKeysListItem.mediaKeys = mediaKeys;
            logger_1.logger.log("Media-keys created for key-system \"" + keySystem + "\"");
            _this._onMediaKeysCreated();
        })
            .catch(function (err) {
            logger_1.logger.error('Failed to create media-keys:', err);
        });
    };
    /**
       * Handles key-creation (represents access to CDM). We are going to create key-sessions upon this
       * for all existing keys where no session exists yet.
       */
    EMEController.prototype._onMediaKeysCreated = function () {
        var _this = this;
        // check for all key-list items if a session exists, otherwise, create one
        this._mediaKeysList.forEach(function (mediaKeysListItem) {
            if (!mediaKeysListItem.mediaKeysSession) {
                mediaKeysListItem.mediaKeysSession = mediaKeysListItem.mediaKeys.createSession();
                _this._onNewMediaKeySession(mediaKeysListItem.mediaKeysSession);
            }
        });
    };
    /**
       *
       * @param {*} keySession
       */
    EMEController.prototype._onNewMediaKeySession = function (keySession) {
        var _this = this;
        logger_1.logger.log("New key-system session " + keySession.sessionId);
        keySession.addEventListener('message', function (event) {
            _this._onKeySessionMessage(keySession, event.message);
        }, false);
    };
    EMEController.prototype._onKeySessionMessage = function (keySession, message) {
        logger_1.logger.log('Got EME message event, creating license request');
        this._requestLicense(message, function (data) {
            logger_1.logger.log('Received license data, updating key-session');
            keySession.update(data);
        });
    };
    EMEController.prototype._onMediaEncrypted = function (initDataType, initData) {
        logger_1.logger.log("Media is encrypted using \"" + initDataType + "\" init data type");
        this._isMediaEncrypted = true;
        this._mediaEncryptionInitDataType = initDataType;
        this._mediaEncryptionInitData = initData;
        this._attemptSetMediaKeys();
        this._generateRequestWithPreferredKeySession();
    };
    EMEController.prototype._attemptSetMediaKeys = function () {
        if (!this._hasSetMediaKeys) {
            // FIXME: see if we can/want/need-to really to deal with several potential key-sessions?
            var keysListItem = this._mediaKeysList[0];
            if (!keysListItem || !keysListItem.mediaKeys) {
                logger_1.logger.error('Fatal: Media is encrypted but no CDM access or no keys have been obtained yet');
                this.hls.trigger(events_1.default.ERROR, {
                    type: errors_1.ErrorTypes.KEY_SYSTEM_ERROR,
                    details: errors_1.ErrorDetails.KEY_SYSTEM_NO_KEYS,
                    fatal: true
                });
                return;
            }
            logger_1.logger.log('Setting keys for encrypted media');
            this._media.setMediaKeys(keysListItem.mediaKeys);
            this._hasSetMediaKeys = true;
        }
    };
    EMEController.prototype._generateRequestWithPreferredKeySession = function () {
        var _this = this;
        // FIXME: see if we can/want/need-to really to deal with several potential key-sessions?
        var keysListItem = this._mediaKeysList[0];
        if (!keysListItem) {
            logger_1.logger.error('Fatal: Media is encrypted but not any key-system access has been obtained yet');
            this.hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.KEY_SYSTEM_ERROR,
                details: errors_1.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                fatal: true
            });
            return;
        }
        if (keysListItem.mediaKeysSessionInitialized) {
            logger_1.logger.warn('Key-Session already initialized but requested again');
            return;
        }
        var keySession = keysListItem.mediaKeysSession;
        if (!keySession) {
            logger_1.logger.error('Fatal: Media is encrypted but no key-session existing');
            this.hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.KEY_SYSTEM_ERROR,
                details: errors_1.ErrorDetails.KEY_SYSTEM_NO_SESSION,
                fatal: true
            });
        }
        var initDataType = this._mediaEncryptionInitDataType;
        var initData = this._mediaEncryptionInitData;
        logger_1.logger.log("Generating key-session request for \"" + initDataType + "\" init data type");
        keysListItem.mediaKeysSessionInitialized = true;
        keySession.generateRequest(initDataType, initData)
            .then(function () {
            logger_1.logger.debug('Key-session generation succeeded');
        })
            .catch(function (err) {
            logger_1.logger.error('Error generating key-session request:', err);
            _this.hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.KEY_SYSTEM_ERROR,
                details: errors_1.ErrorDetails.KEY_SYSTEM_NO_SESSION,
                fatal: false
            });
        });
    };
    /**
       * @param {string} url License server URL
       * @param {ArrayBuffer} keyMessage Message data issued by key-system
       * @param {function} callback Called when XHR has succeeded
       * @returns {XMLHttpRequest} Unsent (but opened state) XHR object
       */
    EMEController.prototype._createLicenseXhr = function (url, keyMessage, callback) {
        var xhr = new XMLHttpRequest();
        var licenseXhrSetup = this._licenseXhrSetup;
        try {
            if (licenseXhrSetup) {
                try {
                    licenseXhrSetup(xhr, url);
                }
                catch (e) {
                    // let's try to open before running setup
                    xhr.open('POST', url, true);
                    licenseXhrSetup(xhr, url);
                }
            }
            // if licenseXhrSetup did not yet call open, let's do it now
            if (!xhr.readyState) {
                xhr.open('POST', url, true);
            }
        }
        catch (e) {
            // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
            logger_1.logger.error('Error setting up key-system license XHR', e);
            this.hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.KEY_SYSTEM_ERROR,
                details: errors_1.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                fatal: true
            });
            return;
        }
        xhr.responseType = 'arraybuffer';
        xhr.onreadystatechange =
            this._onLicenseRequestReadyStageChange.bind(this, xhr, url, keyMessage, callback);
        return xhr;
    };
    /**
       * @param {XMLHttpRequest} xhr
       * @param {string} url License server URL
       * @param {ArrayBuffer} keyMessage Message data issued by key-system
       * @param {function} callback Called when XHR has succeeded
       *
       */
    EMEController.prototype._onLicenseRequestReadyStageChange = function (xhr, url, keyMessage, callback) {
        switch (xhr.readyState) {
            case 4:
                if (xhr.status === 200) {
                    this._requestLicenseFailureCount = 0;
                    logger_1.logger.log('License request succeeded');
                    callback(xhr.response);
                }
                else {
                    logger_1.logger.error("License Request XHR failed (" + url + "). Status: " + xhr.status + " (" + xhr.statusText + ")");
                    this._requestLicenseFailureCount++;
                    if (this._requestLicenseFailureCount <= MAX_LICENSE_REQUEST_FAILURES) {
                        var attemptsLeft = MAX_LICENSE_REQUEST_FAILURES - this._requestLicenseFailureCount + 1;
                        logger_1.logger.warn("Retrying license request, " + attemptsLeft + " attempts left");
                        this._requestLicense(keyMessage, callback);
                        return;
                    }
                    this.hls.trigger(events_1.default.ERROR, {
                        type: errors_1.ErrorTypes.KEY_SYSTEM_ERROR,
                        details: errors_1.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                        fatal: true
                    });
                }
                break;
        }
    };
    /**
       * @param {object} keysListItem
       * @param {ArrayBuffer} keyMessage
       * @returns {ArrayBuffer} Challenge data posted to license server
       */
    EMEController.prototype._generateLicenseRequestChallenge = function (keysListItem, keyMessage) {
        var challenge;
        if (keysListItem.mediaKeySystemDomain === KeySystems.PLAYREADY) {
            logger_1.logger.error('PlayReady is not supported (yet)');
            // from https://github.com/MicrosoftEdge/Demos/blob/master/eme/scripts/demo.js
            /*
              if (this.licenseType !== this.LICENSE_TYPE_WIDEVINE) {
                  // For PlayReady CDMs, we need to dig the Challenge out of the XML.
                  var keyMessageXml = new DOMParser().parseFromString(String.fromCharCode.apply(null, new Uint16Array(keyMessage)), 'application/xml');
                  if (keyMessageXml.getElementsByTagName('Challenge')[0]) {
                      challenge = atob(keyMessageXml.getElementsByTagName('Challenge')[0].childNodes[0].nodeValue);
                  } else {
                      throw 'Cannot find <Challenge> in key message';
                  }
                  var headerNames = keyMessageXml.getElementsByTagName('name');
                  var headerValues = keyMessageXml.getElementsByTagName('value');
                  if (headerNames.length !== headerValues.length) {
                      throw 'Mismatched header <name>/<value> pair in key message';
                  }
                  for (var i = 0; i < headerNames.length; i++) {
                      xhr.setRequestHeader(headerNames[i].childNodes[0].nodeValue, headerValues[i].childNodes[0].nodeValue);
                  }
              }
              */
        }
        else if (keysListItem.mediaKeySystemDomain === KeySystems.WIDEVINE) {
            // For Widevine CDMs, the challenge is the keyMessage.
            challenge = keyMessage;
        }
        else {
            logger_1.logger.error('Unsupported key-system:', keysListItem.mediaKeySystemDomain);
        }
        return challenge;
    };
    EMEController.prototype._requestLicense = function (keyMessage, callback) {
        logger_1.logger.log('Requesting content license for key-system');
        var keysListItem = this._mediaKeysList[0];
        if (!keysListItem) {
            logger_1.logger.error('Fatal error: Media is encrypted but no key-system access has been obtained yet');
            this.hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.KEY_SYSTEM_ERROR,
                details: errors_1.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                fatal: true
            });
            return;
        }
        var url = this.getLicenseServerUrl(keysListItem.mediaKeySystemDomain);
        var xhr = this._createLicenseXhr(url, keyMessage, callback);
        logger_1.logger.log("Sending license request to URL: " + url);
        xhr.send(this._generateLicenseRequestChallenge(keysListItem, keyMessage));
    };
    EMEController.prototype.onMediaAttached = function (data) {
        var _this = this;
        if (!this._emeEnabled) {
            return;
        }
        var media = data.media;
        // keep reference of media
        this._media = media;
        // FIXME: also handle detaching media !
        media.addEventListener('encrypted', function (e) {
            _this._onMediaEncrypted(e.initDataType, e.initData);
        });
    };
    EMEController.prototype.onManifestParsed = function (data) {
        if (!this._emeEnabled) {
            return;
        }
        var audioCodecs = data.levels.map(function (level) { return level.audioCodec; });
        var videoCodecs = data.levels.map(function (level) { return level.videoCodec; });
        this._attemptKeySystemAccess(KeySystems.WIDEVINE, audioCodecs, videoCodecs);
    };
    return EMEController;
}(event_handler_1.default));
exports.default = EMEController;


/***/ }),

/***/ "./src/controller/fps-controller.js":
/*!******************************************!*\
  !*** ./src/controller/fps-controller.js ***!
  \******************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * FPS Controller
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var performance = window.performance;
var FPSController = /** @class */ (function (_super) {
    __extends(FPSController, _super);
    function FPSController(hls) {
        return _super.call(this, hls, events_1.default.MEDIA_ATTACHING) || this;
    }
    FPSController.prototype.destroy = function () {
        if (this.timer) {
            clearInterval(this.timer);
        }
        this.isVideoPlaybackQualityAvailable = false;
    };
    FPSController.prototype.onMediaAttaching = function (data) {
        var config = this.hls.config;
        if (config.capLevelOnFPSDrop) {
            var video_1 = this.video = data.media instanceof window.HTMLVideoElement ? data.media : null;
            if (typeof video_1.getVideoPlaybackQuality === 'function') {
                this.isVideoPlaybackQualityAvailable = true;
            }
            clearInterval(this.timer);
            this.timer = setInterval(this.checkFPSInterval.bind(this), config.fpsDroppedMonitoringPeriod);
        }
    };
    FPSController.prototype.checkFPS = function (video, decodedFrames, droppedFrames) {
        var currentTime = performance.now();
        if (decodedFrames) {
            if (this.lastTime) {
                var currentPeriod = currentTime - this.lastTime, currentDropped = droppedFrames - this.lastDroppedFrames, currentDecoded = decodedFrames - this.lastDecodedFrames, droppedFPS = 1000 * currentDropped / currentPeriod, hls_1 = this.hls;
                hls_1.trigger(events_1.default.FPS_DROP, { currentDropped: currentDropped, currentDecoded: currentDecoded, totalDroppedFrames: droppedFrames });
                if (droppedFPS > 0) {
                    // logger.log('checkFPS : droppedFPS/decodedFPS:' + droppedFPS/(1000 * currentDecoded / currentPeriod));
                    if (currentDropped > hls_1.config.fpsDroppedMonitoringThreshold * currentDecoded) {
                        var currentLevel = hls_1.currentLevel;
                        logger_1.logger.warn('drop FPS ratio greater than max allowed value for currentLevel: ' + currentLevel);
                        if (currentLevel > 0 && (hls_1.autoLevelCapping === -1 || hls_1.autoLevelCapping >= currentLevel)) {
                            currentLevel = currentLevel - 1;
                            hls_1.trigger(events_1.default.FPS_DROP_LEVEL_CAPPING, { level: currentLevel, droppedLevel: hls_1.currentLevel });
                            hls_1.autoLevelCapping = currentLevel;
                            hls_1.streamController.nextLevelSwitch();
                        }
                    }
                }
            }
            this.lastTime = currentTime;
            this.lastDroppedFrames = droppedFrames;
            this.lastDecodedFrames = decodedFrames;
        }
    };
    FPSController.prototype.checkFPSInterval = function () {
        var video = this.video;
        if (video) {
            if (this.isVideoPlaybackQualityAvailable) {
                var videoPlaybackQuality = video.getVideoPlaybackQuality();
                this.checkFPS(video, videoPlaybackQuality.totalVideoFrames, videoPlaybackQuality.droppedVideoFrames);
            }
            else {
                this.checkFPS(video, video.webkitDecodedFrameCount, video.webkitDroppedFrameCount);
            }
        }
    };
    return FPSController;
}(event_handler_1.default));
exports.default = FPSController;


/***/ }),

/***/ "./src/controller/fragment-finders.js":
/*!********************************************!*\
  !*** ./src/controller/fragment-finders.js ***!
  \********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
Object.defineProperty(exports, "__esModule", { value: true });
var binary_search_1 = __webpack_require__(/*! ../utils/binary-search */ "./src/utils/binary-search.js");
/**
 * Returns first fragment whose endPdt value exceeds the given PDT.
 * @param {Array<Fragment>} fragments - The array of candidate fragments
 * @param {number|null} [PDTValue = null] - The PDT value which must be exceeded
 * @param {number} [maxFragLookUpTolerance = 0] - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 * @returns {*|null} fragment - The best matching fragment
 */
function findFragmentByPDT(fragments, PDTValue, maxFragLookUpTolerance) {
    if (!Array.isArray(fragments) || !fragments.length || !Number.isFinite(PDTValue)) {
        return null;
    }
    // if less than start
    if (PDTValue < fragments[0].programDateTime) {
        return null;
    }
    if (PDTValue >= fragments[fragments.length - 1].endProgramDateTime) {
        return null;
    }
    maxFragLookUpTolerance = maxFragLookUpTolerance || 0;
    for (var seg = 0; seg < fragments.length; ++seg) {
        var frag = fragments[seg];
        if (pdtWithinToleranceTest(PDTValue, maxFragLookUpTolerance, frag)) {
            return frag;
        }
    }
    return null;
}
exports.findFragmentByPDT = findFragmentByPDT;
/**
 * Finds a fragment based on the SN of the previous fragment; or based on the needs of the current buffer.
 * This method compensates for small buffer gaps by applying a tolerance to the start of any candidate fragment, thus
 * breaking any traps which would cause the same fragment to be continuously selected within a small range.
 * @param {*} fragPrevious - The last frag successfully appended
 * @param {Array<Fragment>} fragments - The array of candidate fragments
 * @param {number} [bufferEnd = 0] - The end of the contiguous buffered range the playhead is currently within
 * @param {number} maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 * @returns {*} foundFrag - The best matching fragment
 */
function findFragmentByPTS(fragPrevious, fragments, bufferEnd, maxFragLookUpTolerance) {
    if (bufferEnd === void 0) { bufferEnd = 0; }
    if (maxFragLookUpTolerance === void 0) { maxFragLookUpTolerance = 0; }
    var fragNext = fragPrevious ? fragments[fragPrevious.sn - fragments[0].sn + 1] : null;
    // Prefer the next fragment if it's within tolerance
    if (fragNext && !fragmentWithinToleranceTest(bufferEnd, maxFragLookUpTolerance, fragNext)) {
        return fragNext;
    }
    return binary_search_1.default.search(fragments, fragmentWithinToleranceTest.bind(null, bufferEnd, maxFragLookUpTolerance));
}
exports.findFragmentByPTS = findFragmentByPTS;
/**
 * The test function used by the findFragmentBySn's BinarySearch to look for the best match to the current buffer conditions.
 * @param {*} candidate - The fragment to test
 * @param {number} [bufferEnd = 0] - The end of the current buffered range the playhead is currently within
 * @param {number} [maxFragLookUpTolerance = 0] - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns {number} - 0 if it matches, 1 if too low, -1 if too high
 */
function fragmentWithinToleranceTest(bufferEnd, maxFragLookUpTolerance, candidate) {
    if (bufferEnd === void 0) { bufferEnd = 0; }
    if (maxFragLookUpTolerance === void 0) { maxFragLookUpTolerance = 0; }
    // offset should be within fragment boundary - config.maxFragLookUpTolerance
    // this is to cope with situations like
    // bufferEnd = 9.991
    // frag[Ø] : [0,10]
    // frag[1] : [10,20]
    // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
    //              frag start               frag start+duration
    //                  |-----------------------------|
    //              <--->                         <--->
    //  ...--------><-----------------------------><---------....
    // previous frag         matching fragment         next frag
    //  return -1             return 0                 return 1
    // logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
    // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
    var candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0));
    if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) {
        return 1;
    }
    else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) {
        // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
        return -1;
    }
    return 0;
}
exports.fragmentWithinToleranceTest = fragmentWithinToleranceTest;
/**
 * The test function used by the findFragmentByPdt's BinarySearch to look for the best match to the current buffer conditions.
 * This function tests the candidate's program date time values, as represented in Unix time
 * @param {*} candidate - The fragment to test
 * @param {number} [pdtBufferEnd = 0] - The Unix time representing the end of the current buffered range
 * @param {number} [maxFragLookUpTolerance = 0] - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns {boolean} True if contiguous, false otherwise
 */
function pdtWithinToleranceTest(pdtBufferEnd, maxFragLookUpTolerance, candidate) {
    var candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0)) * 1000;
    return candidate.endProgramDateTime - candidateLookupTolerance > pdtBufferEnd;
}
exports.pdtWithinToleranceTest = pdtWithinToleranceTest;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/controller/fragment-tracker.js":
/*!********************************************!*\
  !*** ./src/controller/fragment-tracker.js ***!
  \********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
exports.FragmentState = {
    NOT_LOADED: 'NOT_LOADED',
    APPENDING: 'APPENDING',
    PARTIAL: 'PARTIAL',
    OK: 'OK'
};
var FragmentTracker = /** @class */ (function (_super) {
    __extends(FragmentTracker, _super);
    function FragmentTracker(hls) {
        var _this = _super.call(this, hls, events_1.default.BUFFER_APPENDED, events_1.default.FRAG_BUFFERED, events_1.default.FRAG_LOADED) || this;
        _this.bufferPadding = 0.2;
        _this.fragments = Object.create(null);
        _this.timeRanges = Object.create(null);
        _this.config = hls.config;
        return _this;
    }
    FragmentTracker.prototype.destroy = function () {
        this.fragments = Object.create(null);
        this.timeRanges = Object.create(null);
        this.config = null;
        event_handler_1.default.prototype.destroy.call(this);
        _super.prototype.destroy.call(this);
    };
    /**
     * Return a Fragment that match the position and levelType.
     * If not found any Fragment, return null
     * @param {number} position
     * @param {LevelType} levelType
     * @returns {Fragment|null}
     */
    FragmentTracker.prototype.getBufferedFrag = function (position, levelType) {
        var fragments = this.fragments;
        var bufferedFrags = Object.keys(fragments).filter(function (key) {
            var fragmentEntity = fragments[key];
            if (fragmentEntity.body.type !== levelType) {
                return false;
            }
            if (!fragmentEntity.buffered) {
                return false;
            }
            var frag = fragmentEntity.body;
            return frag.startPTS <= position && position <= frag.endPTS;
        });
        if (bufferedFrags.length === 0) {
            return null;
        }
        else {
            // https://github.com/video-dev/hls.js/pull/1545#discussion_r166229566
            var bufferedFragKey = bufferedFrags.pop();
            return fragments[bufferedFragKey].body;
        }
    };
    /**
     * Partial fragments effected by coded frame eviction will be removed
     * The browser will unload parts of the buffer to free up memory for new buffer data
     * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
     * @param {String} elementaryStream The elementaryStream of media this is (eg. video/audio)
     * @param {TimeRanges} timeRange TimeRange object from a sourceBuffer
     */
    FragmentTracker.prototype.detectEvictedFragments = function (elementaryStream, timeRange) {
        var _this = this;
        var fragmentTimes, time;
        // Check if any flagged fragments have been unloaded
        Object.keys(this.fragments).forEach(function (key) {
            var fragmentEntity = _this.fragments[key];
            if (fragmentEntity.buffered === true) {
                var esData = fragmentEntity.range[elementaryStream];
                if (esData) {
                    fragmentTimes = esData.time;
                    for (var i = 0; i < fragmentTimes.length; i++) {
                        time = fragmentTimes[i];
                        if (_this.isTimeBuffered(time.startPTS, time.endPTS, timeRange) === false) {
                            // Unregister partial fragment as it needs to load again to be reused
                            _this.removeFragment(fragmentEntity.body);
                            break;
                        }
                    }
                }
            }
        });
    };
    /**
     * Checks if the fragment passed in is loaded in the buffer properly
     * Partially loaded fragments will be registered as a partial fragment
     * @param {Object} fragment Check the fragment against all sourceBuffers loaded
     */
    FragmentTracker.prototype.detectPartialFragments = function (fragment) {
        var _this = this;
        var fragKey = this.getFragmentKey(fragment);
        var fragmentEntity = this.fragments[fragKey];
        if (fragmentEntity) {
            fragmentEntity.buffered = true;
            Object.keys(this.timeRanges).forEach(function (elementaryStream) {
                if (fragment.hasElementaryStream(elementaryStream)) {
                    var timeRange = _this.timeRanges[elementaryStream];
                    // Check for malformed fragments
                    // Gaps need to be calculated for each elementaryStream
                    fragmentEntity.range[elementaryStream] = _this.getBufferedTimes(fragment.startPTS, fragment.endPTS, timeRange);
                }
            });
        }
    };
    FragmentTracker.prototype.getBufferedTimes = function (startPTS, endPTS, timeRange) {
        var fragmentTimes = [];
        var startTime, endTime;
        var fragmentPartial = false;
        for (var i = 0; i < timeRange.length; i++) {
            startTime = timeRange.start(i) - this.bufferPadding;
            endTime = timeRange.end(i) + this.bufferPadding;
            if (startPTS >= startTime && endPTS <= endTime) {
                // Fragment is entirely contained in buffer
                // No need to check the other timeRange times since it's completely playable
                fragmentTimes.push({
                    startPTS: Math.max(startPTS, timeRange.start(i)),
                    endPTS: Math.min(endPTS, timeRange.end(i))
                });
                break;
            }
            else if (startPTS < endTime && endPTS > startTime) {
                // Check for intersection with buffer
                // Get playable sections of the fragment
                fragmentTimes.push({
                    startPTS: Math.max(startPTS, timeRange.start(i)),
                    endPTS: Math.min(endPTS, timeRange.end(i))
                });
                fragmentPartial = true;
            }
            else if (endPTS <= startTime) {
                // No need to check the rest of the timeRange as it is in order
                break;
            }
        }
        return {
            time: fragmentTimes,
            partial: fragmentPartial
        };
    };
    FragmentTracker.prototype.getFragmentKey = function (fragment) {
        return fragment.type + "_" + fragment.level + "_" + fragment.urlId + "_" + fragment.sn;
    };
    /**
     * Gets the partial fragment for a certain time
     * @param {Number} time
     * @returns {Object} fragment Returns a partial fragment at a time or null if there is no partial fragment
     */
    FragmentTracker.prototype.getPartialFragment = function (time) {
        var _this = this;
        var timePadding, startTime, endTime;
        var bestFragment = null;
        var bestOverlap = 0;
        Object.keys(this.fragments).forEach(function (key) {
            var fragmentEntity = _this.fragments[key];
            if (_this.isPartial(fragmentEntity)) {
                startTime = fragmentEntity.body.startPTS - _this.bufferPadding;
                endTime = fragmentEntity.body.endPTS + _this.bufferPadding;
                if (time >= startTime && time <= endTime) {
                    // Use the fragment that has the most padding from start and end time
                    timePadding = Math.min(time - startTime, endTime - time);
                    if (bestOverlap <= timePadding) {
                        bestFragment = fragmentEntity.body;
                        bestOverlap = timePadding;
                    }
                }
            }
        });
        return bestFragment;
    };
    /**
     * @param {Object} fragment The fragment to check
     * @returns {String} Returns the fragment state when a fragment never loaded or if it partially loaded
     */
    FragmentTracker.prototype.getState = function (fragment) {
        var fragKey = this.getFragmentKey(fragment);
        var fragmentEntity = this.fragments[fragKey];
        var state = exports.FragmentState.NOT_LOADED;
        if (fragmentEntity !== undefined) {
            if (!fragmentEntity.buffered) {
                state = exports.FragmentState.APPENDING;
            }
            else if (this.isPartial(fragmentEntity) === true) {
                state = exports.FragmentState.PARTIAL;
            }
            else {
                state = exports.FragmentState.OK;
            }
        }
        return state;
    };
    FragmentTracker.prototype.isPartial = function (fragmentEntity) {
        return fragmentEntity.buffered === true &&
            ((fragmentEntity.range.video !== undefined && fragmentEntity.range.video.partial === true) ||
                (fragmentEntity.range.audio !== undefined && fragmentEntity.range.audio.partial === true));
    };
    FragmentTracker.prototype.isTimeBuffered = function (startPTS, endPTS, timeRange) {
        var startTime, endTime;
        for (var i = 0; i < timeRange.length; i++) {
            startTime = timeRange.start(i) - this.bufferPadding;
            endTime = timeRange.end(i) + this.bufferPadding;
            if (startPTS >= startTime && endPTS <= endTime) {
                return true;
            }
            if (endPTS <= startTime) {
                // No need to check the rest of the timeRange as it is in order
                return false;
            }
        }
        return false;
    };
    /**
     * Fires when a fragment loading is completed
     */
    FragmentTracker.prototype.onFragLoaded = function (e) {
        var fragment = e.frag;
        // don't track initsegment (for which sn is not a number)
        // don't track frags used for bitrateTest, they're irrelevant.
        if (!Number.isFinite(fragment.sn) || fragment.bitrateTest) {
            return;
        }
        this.fragments[this.getFragmentKey(fragment)] = {
            body: fragment,
            range: Object.create(null),
            buffered: false
        };
    };
    /**
     * Fires when the buffer is updated
     */
    FragmentTracker.prototype.onBufferAppended = function (e) {
        var _this = this;
        // Store the latest timeRanges loaded in the buffer
        this.timeRanges = e.timeRanges;
        Object.keys(this.timeRanges).forEach(function (elementaryStream) {
            var timeRange = _this.timeRanges[elementaryStream];
            _this.detectEvictedFragments(elementaryStream, timeRange);
        });
    };
    /**
     * Fires after a fragment has been loaded into the source buffer
     */
    FragmentTracker.prototype.onFragBuffered = function (e) {
        this.detectPartialFragments(e.frag);
    };
    /**
     * Return true if fragment tracker has the fragment.
     * @param {Object} fragment
     * @returns {boolean}
     */
    FragmentTracker.prototype.hasFragment = function (fragment) {
        var fragKey = this.getFragmentKey(fragment);
        return this.fragments[fragKey] !== undefined;
    };
    /**
     * Remove a fragment from fragment tracker until it is loaded again
     * @param {Object} fragment The fragment to remove
     */
    FragmentTracker.prototype.removeFragment = function (fragment) {
        var fragKey = this.getFragmentKey(fragment);
        delete this.fragments[fragKey];
    };
    /**
     * Remove all fragments from fragment tracker.
     */
    FragmentTracker.prototype.removeAllFragments = function () {
        this.fragments = Object.create(null);
    };
    return FragmentTracker;
}(event_handler_1.default));
exports.FragmentTracker = FragmentTracker;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/controller/gap-controller.js":
/*!******************************************!*\
  !*** ./src/controller/gap-controller.js ***!
  \******************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var buffer_helper_1 = __webpack_require__(/*! ../utils/buffer-helper */ "./src/utils/buffer-helper.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var stallDebounceInterval = 1000;
var jumpThreshold = 0.5; // tolerance needed as some browsers stalls playback before reaching buffered range end
var GapController = /** @class */ (function () {
    function GapController(config, media, fragmentTracker, hls) {
        this.config = config;
        this.media = media;
        this.fragmentTracker = fragmentTracker;
        this.hls = hls;
        this.stallReported = false;
    }
    /**
     * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
     * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
     * @param lastCurrentTime
     * @param buffered
     */
    GapController.prototype.poll = function (lastCurrentTime, buffered) {
        var _a = this, config = _a.config, media = _a.media;
        var currentTime = media.currentTime;
        var tnow = window.performance.now();
        if (currentTime !== lastCurrentTime) {
            // The playhead is now moving, but was previously stalled
            if (this.stallReported) {
                logger_1.logger.warn("playback not stuck anymore @" + currentTime + ", after " + Math.round(tnow - this.stalled) + "ms");
                this.stallReported = false;
            }
            this.stalled = null;
            this.nudgeRetry = 0;
            return;
        }
        if (media.ended || !media.buffered.length || media.readyState > 2) {
            return;
        }
        if (media.seeking && buffer_helper_1.BufferHelper.isBuffered(media, currentTime)) {
            return;
        }
        // The playhead isn't moving but it should be
        // Allow some slack time to for small stalls to resolve themselves
        var stalledDuration = tnow - this.stalled;
        var bufferInfo = buffer_helper_1.BufferHelper.bufferInfo(media, currentTime, config.maxBufferHole);
        if (!this.stalled) {
            this.stalled = tnow;
            return;
        }
        else if (stalledDuration >= stallDebounceInterval) {
            // Report stalling after trying to fix
            this._reportStall(bufferInfo.len);
        }
        this._tryFixBufferStall(bufferInfo, stalledDuration);
    };
    /**
     * Detects and attempts to fix known buffer stalling issues.
     * @param bufferInfo - The properties of the current buffer.
     * @param stalledDuration - The amount of time Hls.js has been stalling for.
     * @private
     */
    GapController.prototype._tryFixBufferStall = function (bufferInfo, stalledDuration) {
        var _a = this, config = _a.config, fragmentTracker = _a.fragmentTracker, media = _a.media;
        var currentTime = media.currentTime;
        var partial = fragmentTracker.getPartialFragment(currentTime);
        if (partial) {
            // Try to skip over the buffer hole caused by a partial fragment
            // This method isn't limited by the size of the gap between buffered ranges
            this._trySkipBufferHole(partial);
        }
        if (bufferInfo.len > jumpThreshold && stalledDuration > config.highBufferWatchdogPeriod * 1000) {
            // Try to nudge currentTime over a buffer hole if we've been stalling for the configured amount of seconds
            // We only try to jump the hole if it's under the configured size
            // Reset stalled so to rearm watchdog timer
            this.stalled = null;
            this._tryNudgeBuffer();
        }
    };
    /**
     * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
     * @param bufferLen - The playhead distance from the end of the current buffer segment.
     * @private
     */
    GapController.prototype._reportStall = function (bufferLen) {
        var _a = this, hls = _a.hls, media = _a.media, stallReported = _a.stallReported;
        if (!stallReported) {
            // Report stalled error once
            this.stallReported = true;
            logger_1.logger.warn("Playback stalling at @" + media.currentTime + " due to low buffer");
            hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.MEDIA_ERROR,
                details: errors_1.ErrorDetails.BUFFER_STALLED_ERROR,
                fatal: false,
                buffer: bufferLen
            });
        }
    };
    /**
     * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
     * @param partial - The partial fragment found at the current time (where playback is stalling).
     * @private
     */
    GapController.prototype._trySkipBufferHole = function (partial) {
        var _a = this, hls = _a.hls, media = _a.media;
        var currentTime = media.currentTime;
        var lastEndTime = 0;
        // Check if currentTime is between unbuffered regions of partial fragments
        for (var i = 0; i < media.buffered.length; i++) {
            var startTime = media.buffered.start(i);
            if (currentTime >= lastEndTime && currentTime < startTime) {
                media.currentTime = Math.max(startTime, media.currentTime + 0.1);
                logger_1.logger.warn("skipping hole, adjusting currentTime from " + currentTime + " to " + media.currentTime);
                this.stalled = null;
                hls.trigger(events_1.default.ERROR, {
                    type: errors_1.ErrorTypes.MEDIA_ERROR,
                    details: errors_1.ErrorDetails.BUFFER_SEEK_OVER_HOLE,
                    fatal: false,
                    reason: "fragment loaded with buffer holes, seeking from " + currentTime + " to " + media.currentTime,
                    frag: partial
                });
                return;
            }
            lastEndTime = media.buffered.end(i);
        }
    };
    /**
     * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
     * @private
     */
    GapController.prototype._tryNudgeBuffer = function () {
        var _a = this, config = _a.config, hls = _a.hls, media = _a.media;
        var currentTime = media.currentTime;
        var nudgeRetry = (this.nudgeRetry || 0) + 1;
        this.nudgeRetry = nudgeRetry;
        if (nudgeRetry < config.nudgeMaxRetry) {
            var targetTime = currentTime + nudgeRetry * config.nudgeOffset;
            logger_1.logger.log("adjust currentTime from " + currentTime + " to " + targetTime);
            // playback stalled in buffered area ... let's nudge currentTime to try to overcome this
            media.currentTime = targetTime;
            hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.MEDIA_ERROR,
                details: errors_1.ErrorDetails.BUFFER_NUDGE_ON_STALL,
                fatal: false
            });
        }
        else {
            logger_1.logger.error("still stuck in high buffer @" + currentTime + " after " + config.nudgeMaxRetry + ", raise fatal error");
            hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.MEDIA_ERROR,
                details: errors_1.ErrorDetails.BUFFER_STALLED_ERROR,
                fatal: true
            });
        }
    };
    return GapController;
}());
exports.default = GapController;


/***/ }),

/***/ "./src/controller/id3-track-controller.js":
/*!************************************************!*\
  !*** ./src/controller/id3-track-controller.js ***!
  \************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * id3 metadata track controller
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var id3_1 = __webpack_require__(/*! ../demux/id3 */ "./src/demux/id3.js");
var texttrack_utils_1 = __webpack_require__(/*! ../utils/texttrack-utils */ "./src/utils/texttrack-utils.js");
var ID3TrackController = /** @class */ (function (_super) {
    __extends(ID3TrackController, _super);
    function ID3TrackController(hls) {
        var _this = _super.call(this, hls, events_1.default.MEDIA_ATTACHED, events_1.default.MEDIA_DETACHING, events_1.default.FRAG_PARSING_METADATA) || this;
        _this.id3Track = undefined;
        _this.media = undefined;
        return _this;
    }
    ID3TrackController.prototype.destroy = function () {
        event_handler_1.default.prototype.destroy.call(this);
    };
    // Add ID3 metatadata text track.
    ID3TrackController.prototype.onMediaAttached = function (data) {
        this.media = data.media;
        if (!this.media) {
        }
    };
    ID3TrackController.prototype.onMediaDetaching = function () {
        texttrack_utils_1.clearCurrentCues(this.id3Track);
        this.id3Track = undefined;
        this.media = undefined;
    };
    ID3TrackController.prototype.getID3Track = function (textTracks) {
        for (var i = 0; i < textTracks.length; i++) {
            var textTrack = textTracks[i];
            if (textTrack.kind === 'metadata' && textTrack.label === 'id3') {
                // send 'addtrack' when reusing the textTrack for metadata,
                // same as what we do for captions
                texttrack_utils_1.sendAddTrackEvent(textTrack, this.media);
                return textTrack;
            }
        }
        return this.media.addTextTrack('metadata', 'id3');
    };
    ID3TrackController.prototype.onFragParsingMetadata = function (data) {
        var fragment = data.frag;
        var samples = data.samples;
        // create track dynamically
        if (!this.id3Track) {
            this.id3Track = this.getID3Track(this.media.textTracks);
            this.id3Track.mode = 'hidden';
        }
        // Attempt to recreate Safari functionality by creating
        // WebKitDataCue objects when available and store the decoded
        // ID3 data in the value property of the cue
        var Cue = window.WebKitDataCue || window.VTTCue || window.TextTrackCue;
        for (var i = 0; i < samples.length; i++) {
            var frames_1 = id3_1.default.getID3Frames(samples[i].data);
            if (frames_1) {
                var startTime = samples[i].pts;
                var endTime = i < samples.length - 1 ? samples[i + 1].pts : fragment.endPTS;
                // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
                if (startTime === endTime) {
                    endTime += 0.0001;
                }
                for (var j = 0; j < frames_1.length; j++) {
                    var frame = frames_1[j];
                    // Safari doesn't put the timestamp frame in the TextTrack
                    if (!id3_1.default.isTimeStampFrame(frame)) {
                        var cue = new Cue(startTime, endTime, '');
                        cue.value = frame;
                        this.id3Track.addCue(cue);
                    }
                }
            }
        }
    };
    return ID3TrackController;
}(event_handler_1.default));
exports.default = ID3TrackController;


/***/ }),

/***/ "./src/controller/level-controller.js":
/*!********************************************!*\
  !*** ./src/controller/level-controller.js ***!
  \********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Level Controller
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var codecs_1 = __webpack_require__(/*! ../utils/codecs */ "./src/utils/codecs.js");
var level_helper_1 = __webpack_require__(/*! ./level-helper */ "./src/controller/level-helper.js");
var performance = window.performance;
var chromeOrFirefox;
var LevelController = /** @class */ (function (_super) {
    __extends(LevelController, _super);
    function LevelController(hls) {
        var _this = _super.call(this, hls, events_1.default.MANIFEST_LOADED, events_1.default.LEVEL_LOADED, events_1.default.AUDIO_TRACK_SWITCHED, events_1.default.FRAG_LOADED, events_1.default.ERROR) || this;
        _this.canload = false;
        _this.currentLevelIndex = null;
        _this.manualLevelIndex = -1;
        _this.timer = null;
        chromeOrFirefox = /chrome|firefox/.test(navigator.userAgent.toLowerCase());
        return _this;
    }
    LevelController.prototype.onHandlerDestroying = function () {
        this.clearTimer();
        this.manualLevelIndex = -1;
    };
    LevelController.prototype.clearTimer = function () {
        if (this.timer !== null) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    };
    LevelController.prototype.startLoad = function () {
        var levels = this._levels;
        this.canload = true;
        this.levelRetryCount = 0;
        // clean up live level details to force reload them, and reset load errors
        if (levels) {
            levels.forEach(function (level) {
                level.loadError = 0;
                var levelDetails = level.details;
                if (levelDetails && levelDetails.live) {
                    level.details = undefined;
                }
            });
        }
        // speed up live playlist refresh if timer exists
        if (this.timer !== null) {
            this.loadLevel();
        }
    };
    LevelController.prototype.stopLoad = function () {
        this.canload = false;
    };
    LevelController.prototype.onManifestLoaded = function (data) {
        var levels = [];
        var audioTracks = [];
        var bitrateStart;
        var levelSet = {};
        var levelFromSet = null;
        var videoCodecFound = false;
        var audioCodecFound = false;
        // regroup redundant levels together
        data.levels.forEach(function (level) {
            var attributes = level.attrs;
            level.loadError = 0;
            level.fragmentError = false;
            videoCodecFound = videoCodecFound || !!level.videoCodec;
            audioCodecFound = audioCodecFound || !!level.audioCodec;
            // erase audio codec info if browser does not support mp4a.40.34.
            // demuxer will autodetect codec and fallback to mpeg/audio
            if (chromeOrFirefox && level.audioCodec && level.audioCodec.indexOf('mp4a.40.34') !== -1) {
                level.audioCodec = undefined;
            }
            levelFromSet = levelSet[level.bitrate]; // FIXME: we would also have to match the resolution here
            if (!levelFromSet) {
                level.url = [level.url];
                level.urlId = 0;
                levelSet[level.bitrate] = level;
                levels.push(level);
            }
            else {
                levelFromSet.url.push(level.url);
            }
            if (attributes) {
                if (attributes.AUDIO) {
                    audioCodecFound = true;
                    level_helper_1.addGroupId(levelFromSet || level, 'audio', attributes.AUDIO);
                }
                if (attributes.SUBTITLES) {
                    level_helper_1.addGroupId(levelFromSet || level, 'text', attributes.SUBTITLES);
                }
            }
        });
        // remove audio-only level if we also have levels with audio+video codecs signalled
        if (videoCodecFound && audioCodecFound) {
            levels = levels.filter(function (_a) {
                var videoCodec = _a.videoCodec;
                return !!videoCodec;
            });
        }
        // only keep levels with supported audio/video codecs
        levels = levels.filter(function (_a) {
            var audioCodec = _a.audioCodec, videoCodec = _a.videoCodec;
            return (!audioCodec || codecs_1.isCodecSupportedInMp4(audioCodec, 'audio')) && (!videoCodec || codecs_1.isCodecSupportedInMp4(videoCodec, 'video'));
        });
        if (data.audioTracks) {
            audioTracks = data.audioTracks.filter(function (track) { return !track.audioCodec || codecs_1.isCodecSupportedInMp4(track.audioCodec, 'audio'); });
            // Reassign id's after filtering since they're used as array indices
            audioTracks.forEach(function (track, index) {
                track.id = index;
            });
        }
        if (levels.length > 0) {
            // start bitrate is the first bitrate of the manifest
            bitrateStart = levels[0].bitrate;
            // sort level on bitrate
            levels.sort(function (a, b) { return a.bitrate - b.bitrate; });
            this._levels = levels;
            // find index of first level in sorted levels
            for (var i = 0; i < levels.length; i++) {
                if (levels[i].bitrate === bitrateStart) {
                    this._firstLevel = i;
                    logger_1.logger.log("manifest loaded," + levels.length + " level(s) found, first bitrate:" + bitrateStart);
                    break;
                }
            }
            // Audio is only alternate if manifest include a URI along with the audio group tag
            this.hls.trigger(events_1.default.MANIFEST_PARSED, {
                levels: levels,
                audioTracks: audioTracks,
                firstLevel: this._firstLevel,
                stats: data.stats,
                audio: audioCodecFound,
                video: videoCodecFound,
                altAudio: audioTracks.some(function (t) { return !!t.url; })
            });
        }
        else {
            this.hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.MEDIA_ERROR,
                details: errors_1.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
                fatal: true,
                url: this.hls.url,
                reason: 'no level with compatible codecs found in manifest'
            });
        }
    };
    Object.defineProperty(LevelController.prototype, "levels", {
        get: function () {
            return this._levels;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LevelController.prototype, "level", {
        get: function () {
            return this.currentLevelIndex;
        },
        set: function (newLevel) {
            var levels = this._levels;
            if (levels) {
                newLevel = Math.min(newLevel, levels.length - 1);
                if (this.currentLevelIndex !== newLevel || !levels[newLevel].details) {
                    this.setLevelInternal(newLevel);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    LevelController.prototype.setLevelInternal = function (newLevel) {
        var levels = this._levels;
        var hls = this.hls;
        // check if level idx is valid
        if (newLevel >= 0 && newLevel < levels.length) {
            // stopping live reloading timer if any
            this.clearTimer();
            if (this.currentLevelIndex !== newLevel) {
                logger_1.logger.log("switching to level " + newLevel);
                this.currentLevelIndex = newLevel;
                var levelProperties = levels[newLevel];
                levelProperties.level = newLevel;
                hls.trigger(events_1.default.LEVEL_SWITCHING, levelProperties);
            }
            var level = levels[newLevel];
            var levelDetails = level.details;
            // check if we need to load playlist for this level
            if (!levelDetails || levelDetails.live) {
                // level not retrieved yet, or live playlist we need to (re)load it
                var urlId = level.urlId;
                hls.trigger(events_1.default.LEVEL_LOADING, { url: level.url[urlId], level: newLevel, id: urlId });
            }
        }
        else {
            // invalid level id given, trigger error
            hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.OTHER_ERROR,
                details: errors_1.ErrorDetails.LEVEL_SWITCH_ERROR,
                level: newLevel,
                fatal: false,
                reason: 'invalid level idx'
            });
        }
    };
    Object.defineProperty(LevelController.prototype, "manualLevel", {
        get: function () {
            return this.manualLevelIndex;
        },
        set: function (newLevel) {
            this.manualLevelIndex = newLevel;
            if (this._startLevel === undefined) {
                this._startLevel = newLevel;
            }
            if (newLevel !== -1) {
                this.level = newLevel;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LevelController.prototype, "firstLevel", {
        get: function () {
            return this._firstLevel;
        },
        set: function (newLevel) {
            this._firstLevel = newLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LevelController.prototype, "startLevel", {
        get: function () {
            // hls.startLevel takes precedence over config.startLevel
            // if none of these values are defined, fallback on this._firstLevel (first quality level appearing in variant manifest)
            if (this._startLevel === undefined) {
                var configStartLevel = this.hls.config.startLevel;
                if (configStartLevel !== undefined) {
                    return configStartLevel;
                }
                else {
                    return this._firstLevel;
                }
            }
            else {
                return this._startLevel;
            }
        },
        set: function (newLevel) {
            this._startLevel = newLevel;
        },
        enumerable: true,
        configurable: true
    });
    LevelController.prototype.onError = function (data) {
        if (data.fatal) {
            if (data.type === errors_1.ErrorTypes.NETWORK_ERROR) {
                this.clearTimer();
            }
            return;
        }
        var levelError = false, fragmentError = false;
        var levelIndex;
        // try to recover not fatal errors
        switch (data.details) {
            case errors_1.ErrorDetails.FRAG_LOAD_ERROR:
            case errors_1.ErrorDetails.FRAG_LOAD_TIMEOUT:
            case errors_1.ErrorDetails.KEY_LOAD_ERROR:
            case errors_1.ErrorDetails.KEY_LOAD_TIMEOUT:
                levelIndex = data.frag.level;
                fragmentError = true;
                break;
            case errors_1.ErrorDetails.LEVEL_LOAD_ERROR:
            case errors_1.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                levelIndex = data.context.level;
                levelError = true;
                break;
            case errors_1.ErrorDetails.REMUX_ALLOC_ERROR:
                levelIndex = data.level;
                levelError = true;
                break;
        }
        if (levelIndex !== undefined) {
            this.recoverLevel(data, levelIndex, levelError, fragmentError);
        }
    };
    /**
     * Switch to a redundant stream if any available.
     * If redundant stream is not available, emergency switch down if ABR mode is enabled.
     *
     * @param {Object} errorEvent
     * @param {Number} levelIndex current level index
     * @param {Boolean} levelError
     * @param {Boolean} fragmentError
     */
    // FIXME Find a better abstraction where fragment/level retry management is well decoupled
    LevelController.prototype.recoverLevel = function (errorEvent, levelIndex, levelError, fragmentError) {
        var _this = this;
        var config = this.hls.config;
        var errorDetails = errorEvent.details;
        var level = this._levels[levelIndex];
        var redundantLevels, delay, nextLevel;
        level.loadError++;
        level.fragmentError = fragmentError;
        if (levelError) {
            if ((this.levelRetryCount + 1) <= config.levelLoadingMaxRetry) {
                // exponential backoff capped to max retry timeout
                delay = Math.min(Math.pow(2, this.levelRetryCount) * config.levelLoadingRetryDelay, config.levelLoadingMaxRetryTimeout);
                // Schedule level reload
                this.timer = setTimeout(function () { return _this.loadLevel(); }, delay);
                // boolean used to inform stream controller not to switch back to IDLE on non fatal error
                errorEvent.levelRetry = true;
                this.levelRetryCount++;
                logger_1.logger.warn("level controller, " + errorDetails + ", retry in " + delay + " ms, current retry count is " + this.levelRetryCount);
            }
            else {
                logger_1.logger.error("level controller, cannot recover from " + errorDetails + " error");
                this.currentLevelIndex = null;
                // stopping live reloading timer if any
                this.clearTimer();
                // switch error to fatal
                errorEvent.fatal = true;
                return;
            }
        }
        // Try any redundant streams if available for both errors: level and fragment
        // If level.loadError reaches redundantLevels it means that we tried them all, no hope  => let's switch down
        if (levelError || fragmentError) {
            redundantLevels = level.url.length;
            if (redundantLevels > 1 && level.loadError < redundantLevels) {
                level.urlId = (level.urlId + 1) % redundantLevels;
                level.details = undefined;
                logger_1.logger.warn("level controller, " + errorDetails + " for level " + levelIndex + ": switching to redundant URL-id " + level.urlId);
                // console.log('Current audio track group ID:', this.hls.audioTracks[this.hls.audioTrack].groupId);
                // console.log('New video quality level audio group id:', level.attrs.AUDIO);
            }
            else {
                // Search for available level
                if (this.manualLevelIndex === -1) {
                    // When lowest level has been reached, let's start hunt from the top
                    nextLevel = (levelIndex === 0) ? this._levels.length - 1 : levelIndex - 1;
                    logger_1.logger.warn("level controller, " + errorDetails + ": switch to " + nextLevel);
                    this.hls.nextAutoLevel = this.currentLevelIndex = nextLevel;
                }
                else if (fragmentError) {
                    // Allow fragment retry as long as configuration allows.
                    // reset this._level so that another call to set level() will trigger again a frag load
                    logger_1.logger.warn("level controller, " + errorDetails + ": reload a fragment");
                    this.currentLevelIndex = null;
                }
            }
        }
    };
    // reset errors on the successful load of a fragment
    LevelController.prototype.onFragLoaded = function (_a) {
        var frag = _a.frag;
        if (frag !== undefined && frag.type === 'main') {
            var level = this._levels[frag.level];
            if (level !== undefined) {
                level.fragmentError = false;
                level.loadError = 0;
                this.levelRetryCount = 0;
            }
        }
    };
    LevelController.prototype.onLevelLoaded = function (data) {
        var _this = this;
        var level = data.level, details = data.details;
        // only process level loaded events matching with expected level
        if (level !== this.currentLevelIndex) {
            return;
        }
        var curLevel = this._levels[level];
        // reset level load error counter on successful level loaded only if there is no issues with fragments
        if (!curLevel.fragmentError) {
            curLevel.loadError = 0;
            this.levelRetryCount = 0;
        }
        // if current playlist is a live playlist, arm a timer to reload it
        if (details.live) {
            var reloadInterval = level_helper_1.computeReloadInterval(curLevel.details, details, data.stats.trequest);
            logger_1.logger.log("live playlist, reload in " + Math.round(reloadInterval) + " ms");
            this.timer = setTimeout(function () { return _this.loadLevel(); }, reloadInterval);
        }
        else {
            this.clearTimer();
        }
    };
    LevelController.prototype.onAudioTrackSwitched = function (data) {
        var audioGroupId = this.hls.audioTracks[data.id].groupId;
        var currentLevel = this.hls.levels[this.currentLevelIndex];
        if (!currentLevel) {
            return;
        }
        if (currentLevel.audioGroupIds) {
            var urlId = -1;
            for (var i = 0; i < currentLevel.audioGroupIds.length; i++) {
                if (currentLevel.audioGroupIds[i] === audioGroupId) {
                    urlId = i;
                    break;
                }
            }
            if (urlId !== currentLevel.urlId) {
                currentLevel.urlId = urlId;
                this.startLoad();
            }
        }
    };
    LevelController.prototype.loadLevel = function () {
        logger_1.logger.debug('call to loadLevel');
        if (this.currentLevelIndex !== null && this.canload) {
            var levelObject = this._levels[this.currentLevelIndex];
            if (typeof levelObject === 'object' &&
                levelObject.url.length > 0) {
                var level = this.currentLevelIndex;
                var id = levelObject.urlId;
                var url = levelObject.url[id];
                logger_1.logger.log("Attempt loading level index " + level + " with URL-id " + id);
                // console.log('Current audio track group ID:', this.hls.audioTracks[this.hls.audioTrack].groupId);
                // console.log('New video quality level audio group id:', levelObject.attrs.AUDIO, level);
                this.hls.trigger(events_1.default.LEVEL_LOADING, { url: url, level: level, id: id });
            }
        }
    };
    Object.defineProperty(LevelController.prototype, "nextLoadLevel", {
        get: function () {
            if (this.manualLevelIndex !== -1) {
                return this.manualLevelIndex;
            }
            else {
                return this.hls.nextAutoLevel;
            }
        },
        set: function (nextLevel) {
            this.level = nextLevel;
            if (this.manualLevelIndex === -1) {
                this.hls.nextAutoLevel = nextLevel;
            }
        },
        enumerable: true,
        configurable: true
    });
    return LevelController;
}(event_handler_1.default));
exports.default = LevelController;


/***/ }),

/***/ "./src/controller/level-helper.js":
/*!****************************************!*\
  !*** ./src/controller/level-helper.js ***!
  \****************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
/**
 * @module LevelHelper
 *
 * Providing methods dealing with playlist sliding and drift
 *
 * TODO: Create an actual `Level` class/model that deals with all this logic in an object-oriented-manner.
 *
 * */
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
function addGroupId(level, type, id) {
    switch (type) {
        case 'audio':
            if (!level.audioGroupIds) {
                level.audioGroupIds = [];
            }
            level.audioGroupIds.push(id);
            break;
        case 'text':
            if (!level.textGroupIds) {
                level.textGroupIds = [];
            }
            level.textGroupIds.push(id);
            break;
    }
}
exports.addGroupId = addGroupId;
function updatePTS(fragments, fromIdx, toIdx) {
    var fragFrom = fragments[fromIdx], fragTo = fragments[toIdx], fragToPTS = fragTo.startPTS;
    // if we know startPTS[toIdx]
    if (Number.isFinite(fragToPTS)) {
        // update fragment duration.
        // it helps to fix drifts between playlist reported duration and fragment real duration
        if (toIdx > fromIdx) {
            fragFrom.duration = fragToPTS - fragFrom.start;
            if (fragFrom.duration < 0) {
                logger_1.logger.warn("negative duration computed for frag " + fragFrom.sn + ",level " + fragFrom.level + ", there should be some duration drift between playlist and fragment!");
            }
        }
        else {
            fragTo.duration = fragFrom.start - fragToPTS;
            if (fragTo.duration < 0) {
                logger_1.logger.warn("negative duration computed for frag " + fragTo.sn + ",level " + fragTo.level + ", there should be some duration drift between playlist and fragment!");
            }
        }
    }
    else {
        // we dont know startPTS[toIdx]
        if (toIdx > fromIdx) {
            fragTo.start = fragFrom.start + fragFrom.duration;
        }
        else {
            fragTo.start = Math.max(fragFrom.start - fragTo.duration, 0);
        }
    }
}
exports.updatePTS = updatePTS;
function updateFragPTSDTS(details, frag, startPTS, endPTS, startDTS, endDTS) {
    // update frag PTS/DTS
    var maxStartPTS = startPTS;
    if (Number.isFinite(frag.startPTS)) {
        // delta PTS between audio and video
        var deltaPTS = Math.abs(frag.startPTS - startPTS);
        if (!Number.isFinite(frag.deltaPTS)) {
            frag.deltaPTS = deltaPTS;
        }
        else {
            frag.deltaPTS = Math.max(deltaPTS, frag.deltaPTS);
        }
        maxStartPTS = Math.max(startPTS, frag.startPTS);
        startPTS = Math.min(startPTS, frag.startPTS);
        endPTS = Math.max(endPTS, frag.endPTS);
        startDTS = Math.min(startDTS, frag.startDTS);
        endDTS = Math.max(endDTS, frag.endDTS);
    }
    var drift = startPTS - frag.start;
    frag.start = frag.startPTS = startPTS;
    frag.maxStartPTS = maxStartPTS;
    frag.endPTS = endPTS;
    frag.startDTS = startDTS;
    frag.endDTS = endDTS;
    frag.duration = endPTS - startPTS;
    var sn = frag.sn;
    // exit if sn out of range
    if (!details || sn < details.startSN || sn > details.endSN) {
        return 0;
    }
    var fragIdx, fragments, i;
    fragIdx = sn - details.startSN;
    fragments = details.fragments;
    // update frag reference in fragments array
    // rationale is that fragments array might not contain this frag object.
    // this will happen if playlist has been refreshed between frag loading and call to updateFragPTSDTS()
    // if we don't update frag, we won't be able to propagate PTS info on the playlist
    // resulting in invalid sliding computation
    fragments[fragIdx] = frag;
    // adjust fragment PTS/duration from seqnum-1 to frag 0
    for (i = fragIdx; i > 0; i--) {
        updatePTS(fragments, i, i - 1);
    }
    // adjust fragment PTS/duration from seqnum to last frag
    for (i = fragIdx; i < fragments.length - 1; i++) {
        updatePTS(fragments, i, i + 1);
    }
    details.PTSKnown = true;
    return drift;
}
exports.updateFragPTSDTS = updateFragPTSDTS;
function mergeDetails(oldDetails, newDetails) {
    // potentially retrieve cached initsegment
    if (newDetails.initSegment && oldDetails.initSegment) {
        newDetails.initSegment = oldDetails.initSegment;
    }
    // check if old/new playlists have fragments in common
    // loop through overlapping SN and update startPTS , cc, and duration if any found
    var ccOffset = 0;
    var PTSFrag;
    mapFragmentIntersection(oldDetails, newDetails, function (oldFrag, newFrag) {
        ccOffset = oldFrag.cc - newFrag.cc;
        if (Number.isFinite(oldFrag.startPTS)) {
            newFrag.start = newFrag.startPTS = oldFrag.startPTS;
            newFrag.endPTS = oldFrag.endPTS;
            newFrag.duration = oldFrag.duration;
            newFrag.backtracked = oldFrag.backtracked;
            newFrag.dropped = oldFrag.dropped;
            PTSFrag = newFrag;
        }
        // PTS is known when there are overlapping segments
        newDetails.PTSKnown = true;
    });
    if (!newDetails.PTSKnown) {
        return;
    }
    if (ccOffset) {
        logger_1.logger.log('discontinuity sliding from playlist, take drift into account');
        var newFragments = newDetails.fragments;
        for (var i = 0; i < newFragments.length; i++) {
            newFragments[i].cc += ccOffset;
        }
    }
    // if at least one fragment contains PTS info, recompute PTS information for all fragments
    if (PTSFrag) {
        updateFragPTSDTS(newDetails, PTSFrag, PTSFrag.startPTS, PTSFrag.endPTS, PTSFrag.startDTS, PTSFrag.endDTS);
    }
    else {
        // ensure that delta is within oldFragments range
        // also adjust sliding in case delta is 0 (we could have old=[50-60] and new=old=[50-61])
        // in that case we also need to adjust start offset of all fragments
        adjustSliding(oldDetails, newDetails);
    }
    // if we are here, it means we have fragments overlapping between
    // old and new level. reliable PTS info is thus relying on old level
    newDetails.PTSKnown = oldDetails.PTSKnown;
}
exports.mergeDetails = mergeDetails;
function mergeSubtitlePlaylists(oldPlaylist, newPlaylist, referenceStart) {
    if (referenceStart === void 0) { referenceStart = 0; }
    var lastIndex = -1;
    mapFragmentIntersection(oldPlaylist, newPlaylist, function (oldFrag, newFrag, index) {
        newFrag.start = oldFrag.start;
        lastIndex = index;
    });
    var frags = newPlaylist.fragments;
    if (lastIndex < 0) {
        frags.forEach(function (frag) {
            frag.start += referenceStart;
        });
        return;
    }
    for (var i = lastIndex + 1; i < frags.length; i++) {
        frags[i].start = (frags[i - 1].start + frags[i - 1].duration);
    }
}
exports.mergeSubtitlePlaylists = mergeSubtitlePlaylists;
function mapFragmentIntersection(oldPlaylist, newPlaylist, intersectionFn) {
    if (!oldPlaylist || !newPlaylist) {
        return;
    }
    var start = Math.max(oldPlaylist.startSN, newPlaylist.startSN) - newPlaylist.startSN;
    var end = Math.min(oldPlaylist.endSN, newPlaylist.endSN) - newPlaylist.startSN;
    var delta = newPlaylist.startSN - oldPlaylist.startSN;
    for (var i = start; i <= end; i++) {
        var oldFrag = oldPlaylist.fragments[delta + i];
        var newFrag = newPlaylist.fragments[i];
        if (!oldFrag || !newFrag) {
            break;
        }
        intersectionFn(oldFrag, newFrag, i);
    }
}
exports.mapFragmentIntersection = mapFragmentIntersection;
function adjustSliding(oldPlaylist, newPlaylist) {
    var delta = newPlaylist.startSN - oldPlaylist.startSN;
    var oldFragments = oldPlaylist.fragments;
    var newFragments = newPlaylist.fragments;
    if (delta < 0 || delta > oldFragments.length) {
        return;
    }
    for (var i = 0; i < newFragments.length; i++) {
        newFragments[i].start += oldFragments[delta].start;
    }
}
exports.adjustSliding = adjustSliding;
function computeReloadInterval(currentPlaylist, newPlaylist, lastRequestTime) {
    var reloadInterval = 1000 * (newPlaylist.averagetargetduration ? newPlaylist.averagetargetduration : newPlaylist.targetduration);
    var minReloadInterval = reloadInterval / 2;
    if (currentPlaylist && newPlaylist.endSN === currentPlaylist.endSN) {
        // follow HLS Spec, If the client reloads a Playlist file and finds that it has not
        // changed then it MUST wait for a period of one-half the target
        // duration before retrying.
        reloadInterval = minReloadInterval;
    }
    if (lastRequestTime) {
        reloadInterval = Math.max(minReloadInterval, reloadInterval - (window.performance.now() - lastRequestTime));
    }
    // in any case, don't reload more than half of target duration
    return Math.round(reloadInterval);
}
exports.computeReloadInterval = computeReloadInterval;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/controller/stream-controller.js":
/*!*********************************************!*\
  !*** ./src/controller/stream-controller.js ***!
  \*********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
/*
 * Stream Controller
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var binary_search_1 = __webpack_require__(/*! ../utils/binary-search */ "./src/utils/binary-search.js");
var buffer_helper_1 = __webpack_require__(/*! ../utils/buffer-helper */ "./src/utils/buffer-helper.js");
var demuxer_1 = __webpack_require__(/*! ../demux/demuxer */ "./src/demux/demuxer.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var fragment_tracker_1 = __webpack_require__(/*! ./fragment-tracker */ "./src/controller/fragment-tracker.js");
var fragment_1 = __webpack_require__(/*! ../loader/fragment */ "./src/loader/fragment.js");
var playlist_loader_1 = __webpack_require__(/*! ../loader/playlist-loader */ "./src/loader/playlist-loader.js");
var LevelHelper = __webpack_require__(/*! ./level-helper */ "./src/controller/level-helper.js");
var time_ranges_1 = __webpack_require__(/*! ../utils/time-ranges */ "./src/utils/time-ranges.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var discontinuities_1 = __webpack_require__(/*! ../utils/discontinuities */ "./src/utils/discontinuities.js");
var fragment_finders_1 = __webpack_require__(/*! ./fragment-finders */ "./src/controller/fragment-finders.js");
var gap_controller_1 = __webpack_require__(/*! ./gap-controller */ "./src/controller/gap-controller.js");
var base_stream_controller_1 = __webpack_require__(/*! ./base-stream-controller */ "./src/controller/base-stream-controller.js");
var TICK_INTERVAL = 100; // how often to tick in ms
var StreamController = /** @class */ (function (_super) {
    __extends(StreamController, _super);
    function StreamController(hls, fragmentTracker) {
        var _this = _super.call(this, hls, events_1.default.MEDIA_ATTACHED, events_1.default.MEDIA_DETACHING, events_1.default.MANIFEST_LOADING, events_1.default.MANIFEST_PARSED, events_1.default.LEVEL_LOADED, events_1.default.KEY_LOADED, events_1.default.FRAG_LOADED, events_1.default.FRAG_LOAD_EMERGENCY_ABORTED, events_1.default.FRAG_PARSING_INIT_SEGMENT, events_1.default.FRAG_PARSING_DATA, events_1.default.FRAG_PARSED, events_1.default.ERROR, events_1.default.AUDIO_TRACK_SWITCHING, events_1.default.AUDIO_TRACK_SWITCHED, events_1.default.BUFFER_CREATED, events_1.default.BUFFER_APPENDED, events_1.default.BUFFER_FLUSHED) || this;
        _this.fragmentTracker = fragmentTracker;
        _this.config = hls.config;
        _this.audioCodecSwap = false;
        _this._state = base_stream_controller_1.State.STOPPED;
        _this.stallReported = false;
        _this.gapController = null;
        return _this;
    }
    StreamController.prototype.startLoad = function (startPosition) {
        if (this.levels) {
            var lastCurrentTime = this.lastCurrentTime, hls_1 = this.hls;
            this.stopLoad();
            this.setInterval(TICK_INTERVAL);
            this.level = -1;
            this.fragLoadError = 0;
            if (!this.startFragRequested) {
                // determine load level
                var startLevel = hls_1.startLevel;
                if (startLevel === -1) {
                    // -1 : guess start Level by doing a bitrate test by loading first fragment of lowest quality level
                    startLevel = 0;
                    this.bitrateTest = true;
                }
                // set new level to playlist loader : this will trigger start level load
                // hls.nextLoadLevel remains until it is set to a new value or until a new frag is successfully loaded
                this.level = hls_1.nextLoadLevel = startLevel;
                this.loadedmetadata = false;
            }
            // if startPosition undefined but lastCurrentTime set, set startPosition to last currentTime
            if (lastCurrentTime > 0 && startPosition === -1) {
                logger_1.logger.log("override startPosition with lastCurrentTime @" + lastCurrentTime.toFixed(3));
                startPosition = lastCurrentTime;
            }
            this.state = base_stream_controller_1.State.IDLE;
            this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
            this.tick();
        }
        else {
            this.forceStartLoad = true;
            this.state = base_stream_controller_1.State.STOPPED;
        }
    };
    StreamController.prototype.stopLoad = function () {
        this.forceStartLoad = false;
        _super.prototype.stopLoad.call(this);
    };
    StreamController.prototype.doTick = function () {
        switch (this.state) {
            case base_stream_controller_1.State.BUFFER_FLUSHING:
                // in buffer flushing state, reset fragLoadError counter
                this.fragLoadError = 0;
                break;
            case base_stream_controller_1.State.IDLE:
                this._doTickIdle();
                break;
            case base_stream_controller_1.State.WAITING_LEVEL:
                var level = this.levels[this.level];
                // check if playlist is already loaded
                if (level && level.details) {
                    this.state = base_stream_controller_1.State.IDLE;
                }
                break;
            case base_stream_controller_1.State.FRAG_LOADING_WAITING_RETRY:
                var now = window.performance.now();
                var retryDate = this.retryDate;
                // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
                if (!retryDate || (now >= retryDate) || (this.media && this.media.seeking)) {
                    logger_1.logger.log('mediaController: retryDate reached, switch back to IDLE state');
                    this.state = base_stream_controller_1.State.IDLE;
                }
                break;
            case base_stream_controller_1.State.ERROR:
            case base_stream_controller_1.State.STOPPED:
            case base_stream_controller_1.State.FRAG_LOADING:
            case base_stream_controller_1.State.PARSING:
            case base_stream_controller_1.State.PARSED:
            case base_stream_controller_1.State.ENDED:
                break;
            default:
                break;
        }
        // check buffer
        this._checkBuffer();
        // check/update current fragment
        this._checkFragmentChanged();
    };
    // Ironically the "idle" state is the on we do the most logic in it seems ....
    // NOTE: Maybe we could rather schedule a check for buffer length after half of the currently
    //       played segment, or on pause/play/seek instead of naively checking every 100ms?
    StreamController.prototype._doTickIdle = function () {
        var hls = this.hls, config = hls.config, media = this.media;
        // if start level not parsed yet OR
        // if video not attached AND start fragment already requested OR start frag prefetch disable
        // exit loop, as we either need more info (level not parsed) or we need media to be attached to load new fragment
        if (this.levelLastLoaded === undefined || (!media && (this.startFragRequested || !config.startFragPrefetch))) {
            return;
        }
        // if we have not yet loaded any fragment, start loading from start position
        var pos;
        if (this.loadedmetadata) {
            pos = media.currentTime;
        }
        else {
            pos = this.nextLoadPosition;
        }
        // determine next load level
        var level = hls.nextLoadLevel, levelInfo = this.levels[level];
        if (!levelInfo) {
            return;
        }
        var levelBitrate = levelInfo.bitrate, maxBufLen;
        // compute max Buffer Length that we could get from this load level, based on level bitrate. don't buffer more than 60 MB and more than 30s
        if (levelBitrate) {
            maxBufLen = Math.max(8 * config.maxBufferSize / levelBitrate, config.maxBufferLength);
        }
        else {
            maxBufLen = config.maxBufferLength;
        }
        maxBufLen = Math.min(maxBufLen, config.maxMaxBufferLength);
        // determine next candidate fragment to be loaded, based on current position and end of buffer position
        // ensure up to `config.maxMaxBufferLength` of buffer upfront
        var bufferInfo = buffer_helper_1.BufferHelper.bufferInfo(this.mediaBuffer ? this.mediaBuffer : media, pos, config.maxBufferHole), bufferLen = bufferInfo.len;
        // Stay idle if we are still with buffer margins
        if (bufferLen >= maxBufLen) {
            return;
        }
        // if buffer length is less than maxBufLen try to load a new fragment ...
        logger_1.logger.trace("buffer length of " + bufferLen.toFixed(3) + " is below max of " + maxBufLen.toFixed(3) + ". checking for more payload ...");
        // set next load level : this will trigger a playlist load if needed
        this.level = hls.nextLoadLevel = level;
        var levelDetails = levelInfo.details;
        // if level info not retrieved yet, switch state and wait for level retrieval
        // if live playlist, ensure that new playlist has been refreshed to avoid loading/try to load
        // a useless and outdated fragment (that might even introduce load error if it is already out of the live playlist)
        if (!levelDetails || (levelDetails.live && this.levelLastLoaded !== level)) {
            this.state = base_stream_controller_1.State.WAITING_LEVEL;
            return;
        }
        if (this._streamEnded(bufferInfo, levelDetails)) {
            var data = {};
            if (this.altAudio) {
                data.type = 'video';
            }
            this.hls.trigger(events_1.default.BUFFER_EOS, data);
            this.state = base_stream_controller_1.State.ENDED;
            return;
        }
        // if we have the levelDetails for the selected variant, lets continue enrichen our stream (load keys/fragments or trigger EOS, etc..)
        this._fetchPayloadOrEos(pos, bufferInfo, levelDetails);
    };
    StreamController.prototype._fetchPayloadOrEos = function (pos, bufferInfo, levelDetails) {
        var fragPrevious = this.fragPrevious, level = this.level, fragments = levelDetails.fragments, fragLen = fragments.length;
        // empty playlist
        if (fragLen === 0) {
            return;
        }
        // find fragment index, contiguous with end of buffer position
        var start = fragments[0].start, end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration, bufferEnd = bufferInfo.end, frag;
        if (levelDetails.initSegment && !levelDetails.initSegment.data) {
            frag = levelDetails.initSegment;
        }
        else {
            // in case of live playlist we need to ensure that requested position is not located before playlist start
            if (levelDetails.live) {
                var initialLiveManifestSize = this.config.initialLiveManifestSize;
                if (fragLen < initialLiveManifestSize) {
                    logger_1.logger.warn("Can not start playback of a level, reason: not enough fragments " + fragLen + " < " + initialLiveManifestSize);
                    return;
                }
                frag = this._ensureFragmentAtLivePoint(levelDetails, bufferEnd, start, end, fragPrevious, fragments, fragLen);
                // if it explicitely returns null don't load any fragment and exit function now
                if (frag === null) {
                    return;
                }
            }
            else {
                // VoD playlist: if bufferEnd before start of playlist, load first fragment
                if (bufferEnd < start) {
                    frag = fragments[0];
                }
            }
        }
        if (!frag) {
            frag = this._findFragment(start, fragPrevious, fragLen, fragments, bufferEnd, end, levelDetails);
        }
        if (frag) {
            if (frag.encrypted) {
                logger_1.logger.log("Loading key for " + frag.sn + " of [" + levelDetails.startSN + " ," + levelDetails.endSN + "],level " + level);
                this._loadKey(frag);
            }
            else {
                logger_1.logger.log("Loading " + frag.sn + " of [" + levelDetails.startSN + " ," + levelDetails.endSN + "],level " + level + ", currentTime:" + pos.toFixed(3) + ",bufferEnd:" + bufferEnd.toFixed(3));
                this._loadFragment(frag);
            }
        }
    };
    StreamController.prototype._ensureFragmentAtLivePoint = function (levelDetails, bufferEnd, start, end, fragPrevious, fragments, fragLen) {
        var config = this.hls.config, media = this.media;
        var frag;
        // check if requested position is within seekable boundaries :
        // logger.log(`start/pos/bufEnd/seeking:${start.toFixed(3)}/${pos.toFixed(3)}/${bufferEnd.toFixed(3)}/${this.media.seeking}`);
        var maxLatency = config.liveMaxLatencyDuration !== undefined ? config.liveMaxLatencyDuration : config.liveMaxLatencyDurationCount * levelDetails.targetduration;
        if (bufferEnd < Math.max(start - config.maxFragLookUpTolerance, end - maxLatency)) {
            var liveSyncPosition = this.liveSyncPosition = this.computeLivePosition(start, levelDetails);
            logger_1.logger.log("buffer end: " + bufferEnd.toFixed(3) + " is located too far from the end of live sliding playlist, reset currentTime to : " + liveSyncPosition.toFixed(3));
            bufferEnd = liveSyncPosition;
            if (media && media.readyState && media.duration > liveSyncPosition) {
                media.currentTime = liveSyncPosition;
            }
            this.nextLoadPosition = liveSyncPosition;
        }
        // if end of buffer greater than live edge, don't load any fragment
        // this could happen if live playlist intermittently slides in the past.
        // level 1 loaded [182580161,182580167]
        // level 1 loaded [182580162,182580169]
        // Loading 182580168 of [182580162 ,182580169],level 1 ..
        // Loading 182580169 of [182580162 ,182580169],level 1 ..
        // level 1 loaded [182580162,182580168] <============= here we should have bufferEnd > end. in that case break to avoid reloading 182580168
        // level 1 loaded [182580164,182580171]
        //
        // don't return null in case media not loaded yet (readystate === 0)
        if (levelDetails.PTSKnown && bufferEnd > end && media && media.readyState) {
            return null;
        }
        if (this.startFragRequested && !levelDetails.PTSKnown) {
            /* we are switching level on live playlist, but we don't have any PTS info for that quality level ...
               try to load frag matching with next SN.
               even if SN are not synchronized between playlists, loading this frag will help us
               compute playlist sliding and find the right one after in case it was not the right consecutive one */
            if (fragPrevious) {
                if (levelDetails.hasProgramDateTime) {
                    // Relies on PDT in order to switch bitrates (Support EXT-X-DISCONTINUITY without EXT-X-DISCONTINUITY-SEQUENCE)
                    logger_1.logger.log("live playlist, switching playlist, load frag with same PDT: " + fragPrevious.programDateTime);
                    frag = fragment_finders_1.findFragmentByPDT(fragments, fragPrevious.endProgramDateTime, config.maxFragLookUpTolerance);
                }
                else {
                    // Uses buffer and sequence number to calculate switch segment (required if using EXT-X-DISCONTINUITY-SEQUENCE)
                    var targetSN = fragPrevious.sn + 1;
                    if (targetSN >= levelDetails.startSN && targetSN <= levelDetails.endSN) {
                        var fragNext = fragments[targetSN - levelDetails.startSN];
                        if (fragPrevious.cc === fragNext.cc) {
                            frag = fragNext;
                            logger_1.logger.log("live playlist, switching playlist, load frag with next SN: " + frag.sn);
                        }
                    }
                    // next frag SN not available (or not with same continuity counter)
                    // look for a frag sharing the same CC
                    if (!frag) {
                        frag = binary_search_1.default.search(fragments, function (frag) {
                            return fragPrevious.cc - frag.cc;
                        });
                        if (frag) {
                            logger_1.logger.log("live playlist, switching playlist, load frag with same CC: " + frag.sn);
                        }
                    }
                }
            }
            if (!frag) {
                /* we have no idea about which fragment should be loaded.
                   so let's load mid fragment. it will help computing playlist sliding and find the right one
                */
                frag = fragments[Math.min(fragLen - 1, Math.round(fragLen / 2))];
                logger_1.logger.log("live playlist, switching playlist, unknown, load middle frag : " + frag.sn);
            }
        }
        return frag;
    };
    StreamController.prototype._findFragment = function (start, fragPrevious, fragLen, fragments, bufferEnd, end, levelDetails) {
        var config = this.hls.config;
        var frag;
        if (bufferEnd < end) {
            var lookupTolerance = (bufferEnd > end - config.maxFragLookUpTolerance) ? 0 : config.maxFragLookUpTolerance;
            // Remove the tolerance if it would put the bufferEnd past the actual end of stream
            // Uses buffer and sequence number to calculate switch segment (required if using EXT-X-DISCONTINUITY-SEQUENCE)
            frag = fragment_finders_1.findFragmentByPTS(fragPrevious, fragments, bufferEnd, lookupTolerance);
        }
        else {
            // reach end of playlist
            frag = fragments[fragLen - 1];
        }
        if (frag) {
            var curSNIdx = frag.sn - levelDetails.startSN;
            var sameLevel = fragPrevious && frag.level === fragPrevious.level;
            var prevFrag = fragments[curSNIdx - 1];
            var nextFrag = fragments[curSNIdx + 1];
            // logger.log('find SN matching with pos:' +  bufferEnd + ':' + frag.sn);
            if (fragPrevious && frag.sn === fragPrevious.sn) {
                if (sameLevel && !frag.backtracked) {
                    if (frag.sn < levelDetails.endSN) {
                        var deltaPTS = fragPrevious.deltaPTS;
                        // if there is a significant delta between audio and video, larger than max allowed hole,
                        // and if previous remuxed fragment did not start with a keyframe. (fragPrevious.dropped)
                        // let's try to load previous fragment again to get last keyframe
                        // then we will reload again current fragment (that way we should be able to fill the buffer hole ...)
                        if (deltaPTS && deltaPTS > config.maxBufferHole && fragPrevious.dropped && curSNIdx) {
                            frag = prevFrag;
                            logger_1.logger.warn('SN just loaded, with large PTS gap between audio and video, maybe frag is not starting with a keyframe ? load previous one to try to overcome this');
                        }
                        else {
                            frag = nextFrag;
                            logger_1.logger.log("SN just loaded, load next one: " + frag.sn, frag);
                        }
                    }
                    else {
                        frag = null;
                    }
                }
                else if (frag.backtracked) {
                    // Only backtrack a max of 1 consecutive fragment to prevent sliding back too far when little or no frags start with keyframes
                    if (nextFrag && nextFrag.backtracked) {
                        logger_1.logger.warn("Already backtracked from fragment " + nextFrag.sn + ", will not backtrack to fragment " + frag.sn + ". Loading fragment " + nextFrag.sn);
                        frag = nextFrag;
                    }
                    else {
                        // If a fragment has dropped frames and it's in a same level/sequence, load the previous fragment to try and find the keyframe
                        // Reset the dropped count now since it won't be reset until we parse the fragment again, which prevents infinite backtracking on the same segment
                        logger_1.logger.warn('Loaded fragment with dropped frames, backtracking 1 segment to find a keyframe');
                        frag.dropped = 0;
                        if (prevFrag) {
                            frag = prevFrag;
                            frag.backtracked = true;
                        }
                        else if (curSNIdx) {
                            // can't backtrack on very first fragment
                            frag = null;
                        }
                    }
                }
            }
        }
        return frag;
    };
    StreamController.prototype._loadKey = function (frag) {
        this.state = base_stream_controller_1.State.KEY_LOADING;
        this.hls.trigger(events_1.default.KEY_LOADING, { frag: frag });
    };
    StreamController.prototype._loadFragment = function (frag) {
        // Check if fragment is not loaded
        var fragState = this.fragmentTracker.getState(frag);
        this.fragCurrent = frag;
        this.startFragRequested = true;
        // Don't update nextLoadPosition for fragments which are not buffered
        if (Number.isFinite(frag.sn) && !frag.bitrateTest) {
            this.nextLoadPosition = frag.start + frag.duration;
        }
        // Allow backtracked fragments to load
        if (frag.backtracked || fragState === fragment_tracker_1.FragmentState.NOT_LOADED || fragState === fragment_tracker_1.FragmentState.PARTIAL) {
            frag.autoLevel = this.hls.autoLevelEnabled;
            frag.bitrateTest = this.bitrateTest;
            this.hls.trigger(events_1.default.FRAG_LOADING, { frag: frag });
            // lazy demuxer init, as this could take some time ... do it during frag loading
            if (!this.demuxer) {
                this.demuxer = new demuxer_1.default(this.hls, 'main');
            }
            this.state = base_stream_controller_1.State.FRAG_LOADING;
        }
        else if (fragState === fragment_tracker_1.FragmentState.APPENDING) {
            // Lower the buffer size and try again
            if (this._reduceMaxBufferLength(frag.duration)) {
                this.fragmentTracker.removeFragment(frag);
            }
        }
    };
    Object.defineProperty(StreamController.prototype, "state", {
        get: function () {
            return this._state;
        },
        set: function (nextState) {
            if (this.state !== nextState) {
                var previousState = this.state;
                this._state = nextState;
                logger_1.logger.log("main stream:" + previousState + "->" + nextState);
                this.hls.trigger(events_1.default.STREAM_STATE_TRANSITION, { previousState: previousState, nextState: nextState });
            }
        },
        enumerable: true,
        configurable: true
    });
    StreamController.prototype.getBufferedFrag = function (position) {
        return this.fragmentTracker.getBufferedFrag(position, playlist_loader_1.default.LevelType.MAIN);
    };
    Object.defineProperty(StreamController.prototype, "currentLevel", {
        get: function () {
            var media = this.media;
            if (media) {
                var frag = this.getBufferedFrag(media.currentTime);
                if (frag) {
                    return frag.level;
                }
            }
            return -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StreamController.prototype, "nextBufferedFrag", {
        get: function () {
            var media = this.media;
            if (media) {
                // first get end range of current fragment
                return this.followingBufferedFrag(this.getBufferedFrag(media.currentTime));
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    StreamController.prototype.followingBufferedFrag = function (frag) {
        if (frag) {
            // try to get range of next fragment (500ms after this range)
            return this.getBufferedFrag(frag.endPTS + 0.5);
        }
        return null;
    };
    Object.defineProperty(StreamController.prototype, "nextLevel", {
        get: function () {
            var frag = this.nextBufferedFrag;
            if (frag) {
                return frag.level;
            }
            else {
                return -1;
            }
        },
        enumerable: true,
        configurable: true
    });
    StreamController.prototype._checkFragmentChanged = function () {
        var fragPlayingCurrent, currentTime, video = this.media;
        if (video && video.readyState && video.seeking === false) {
            currentTime = video.currentTime;
            /* if video element is in seeked state, currentTime can only increase.
              (assuming that playback rate is positive ...)
              As sometimes currentTime jumps back to zero after a
              media decode error, check this, to avoid seeking back to
              wrong position after a media decode error
            */
            if (currentTime > this.lastCurrentTime) {
                this.lastCurrentTime = currentTime;
            }
            if (buffer_helper_1.BufferHelper.isBuffered(video, currentTime)) {
                fragPlayingCurrent = this.getBufferedFrag(currentTime);
            }
            else if (buffer_helper_1.BufferHelper.isBuffered(video, currentTime + 0.1)) {
                /* ensure that FRAG_CHANGED event is triggered at startup,
                  when first video frame is displayed and playback is paused.
                  add a tolerance of 100ms, in case current position is not buffered,
                  check if current pos+100ms is buffered and use that buffer range
                  for FRAG_CHANGED event reporting */
                fragPlayingCurrent = this.getBufferedFrag(currentTime + 0.1);
            }
            if (fragPlayingCurrent) {
                var fragPlaying = fragPlayingCurrent;
                if (fragPlaying !== this.fragPlaying) {
                    this.hls.trigger(events_1.default.FRAG_CHANGED, { frag: fragPlaying });
                    var fragPlayingLevel = fragPlaying.level;
                    if (!this.fragPlaying || this.fragPlaying.level !== fragPlayingLevel) {
                        this.hls.trigger(events_1.default.LEVEL_SWITCHED, { level: fragPlayingLevel });
                    }
                    this.fragPlaying = fragPlaying;
                }
            }
        }
    };
    /*
      on immediate level switch :
       - pause playback if playing
       - cancel any pending load request
       - and trigger a buffer flush
    */
    StreamController.prototype.immediateLevelSwitch = function () {
        logger_1.logger.log('immediateLevelSwitch');
        if (!this.immediateSwitch) {
            this.immediateSwitch = true;
            var media = this.media, previouslyPaused = void 0;
            if (media) {
                previouslyPaused = media.paused;
                media.pause();
            }
            else {
                // don't restart playback after instant level switch in case media not attached
                previouslyPaused = true;
            }
            this.previouslyPaused = previouslyPaused;
        }
        var fragCurrent = this.fragCurrent;
        if (fragCurrent && fragCurrent.loader) {
            fragCurrent.loader.abort();
        }
        this.fragCurrent = null;
        // flush everything
        this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
    };
    /**
     * on immediate level switch end, after new fragment has been buffered:
     * - nudge video decoder by slightly adjusting video currentTime (if currentTime buffered)
     * - resume the playback if needed
     */
    StreamController.prototype.immediateLevelSwitchEnd = function () {
        var media = this.media;
        if (media && media.buffered.length) {
            this.immediateSwitch = false;
            if (buffer_helper_1.BufferHelper.isBuffered(media, media.currentTime)) {
                // only nudge if currentTime is buffered
                media.currentTime -= 0.0001;
            }
            if (!this.previouslyPaused) {
                media.play();
            }
        }
    };
    /**
     * try to switch ASAP without breaking video playback:
     * in order to ensure smooth but quick level switching,
     * we need to find the next flushable buffer range
     * we should take into account new segment fetch time
     */
    StreamController.prototype.nextLevelSwitch = function () {
        var media = this.media;
        // ensure that media is defined and that metadata are available (to retrieve currentTime)
        if (media && media.readyState) {
            var fetchdelay = void 0, fragPlayingCurrent = void 0, nextBufferedFrag = void 0;
            fragPlayingCurrent = this.getBufferedFrag(media.currentTime);
            if (fragPlayingCurrent && fragPlayingCurrent.startPTS > 1) {
                // flush buffer preceding current fragment (flush until current fragment start offset)
                // minus 1s to avoid video freezing, that could happen if we flush keyframe of current video ...
                this.flushMainBuffer(0, fragPlayingCurrent.startPTS - 1);
            }
            if (!media.paused) {
                // add a safety delay of 1s
                var nextLevelId = this.hls.nextLoadLevel, nextLevel = this.levels[nextLevelId], fragLastKbps = this.fragLastKbps;
                if (fragLastKbps && this.fragCurrent) {
                    fetchdelay = this.fragCurrent.duration * nextLevel.bitrate / (1000 * fragLastKbps) + 1;
                }
                else {
                    fetchdelay = 0;
                }
            }
            else {
                fetchdelay = 0;
            }
            // logger.log('fetchdelay:'+fetchdelay);
            // find buffer range that will be reached once new fragment will be fetched
            nextBufferedFrag = this.getBufferedFrag(media.currentTime + fetchdelay);
            if (nextBufferedFrag) {
                // we can flush buffer range following this one without stalling playback
                nextBufferedFrag = this.followingBufferedFrag(nextBufferedFrag);
                if (nextBufferedFrag) {
                    // if we are here, we can also cancel any loading/demuxing in progress, as they are useless
                    var fragCurrent = this.fragCurrent;
                    if (fragCurrent && fragCurrent.loader) {
                        fragCurrent.loader.abort();
                    }
                    this.fragCurrent = null;
                    // start flush position is the start PTS of next buffered frag.
                    // we use frag.naxStartPTS which is max(audio startPTS, video startPTS).
                    // in case there is a small PTS Delta between audio and video, using maxStartPTS avoids flushing last samples from current fragment
                    this.flushMainBuffer(nextBufferedFrag.maxStartPTS, Number.POSITIVE_INFINITY);
                }
            }
        }
    };
    StreamController.prototype.flushMainBuffer = function (startOffset, endOffset) {
        this.state = base_stream_controller_1.State.BUFFER_FLUSHING;
        var flushScope = { startOffset: startOffset, endOffset: endOffset };
        // if alternate audio tracks are used, only flush video, otherwise flush everything
        if (this.altAudio) {
            flushScope.type = 'video';
        }
        this.hls.trigger(events_1.default.BUFFER_FLUSHING, flushScope);
    };
    StreamController.prototype.onMediaAttached = function (data) {
        var media = this.media = this.mediaBuffer = data.media;
        this.onvseeking = this.onMediaSeeking.bind(this);
        this.onvseeked = this.onMediaSeeked.bind(this);
        this.onvended = this.onMediaEnded.bind(this);
        media.addEventListener('seeking', this.onvseeking);
        media.addEventListener('seeked', this.onvseeked);
        media.addEventListener('ended', this.onvended);
        var config = this.config;
        if (this.levels && config.autoStartLoad) {
            this.hls.startLoad(config.startPosition);
        }
        this.gapController = new gap_controller_1.default(config, media, this.fragmentTracker, this.hls);
    };
    StreamController.prototype.onMediaDetaching = function () {
        var media = this.media;
        if (media && media.ended) {
            logger_1.logger.log('MSE detaching and video ended, reset startPosition');
            this.startPosition = this.lastCurrentTime = 0;
        }
        // reset fragment backtracked flag
        var levels = this.levels;
        if (levels) {
            levels.forEach(function (level) {
                if (level.details) {
                    level.details.fragments.forEach(function (fragment) {
                        fragment.backtracked = undefined;
                    });
                }
            });
        }
        // remove video listeners
        if (media) {
            media.removeEventListener('seeking', this.onvseeking);
            media.removeEventListener('seeked', this.onvseeked);
            media.removeEventListener('ended', this.onvended);
            this.onvseeking = this.onvseeked = this.onvended = null;
        }
        this.media = this.mediaBuffer = null;
        this.loadedmetadata = false;
        this.stopLoad();
    };
    StreamController.prototype.onMediaSeeked = function () {
        var media = this.media, currentTime = media ? media.currentTime : undefined;
        if (Number.isFinite(currentTime)) {
            logger_1.logger.log("media seeked to " + currentTime.toFixed(3));
        }
        // tick to speed up FRAGMENT_PLAYING triggering
        this.tick();
    };
    StreamController.prototype.onManifestLoading = function () {
        // reset buffer on manifest loading
        logger_1.logger.log('trigger BUFFER_RESET');
        this.hls.trigger(events_1.default.BUFFER_RESET);
        this.fragmentTracker.removeAllFragments();
        this.stalled = false;
        this.startPosition = this.lastCurrentTime = 0;
    };
    StreamController.prototype.onManifestParsed = function (data) {
        var aac = false, heaac = false, codec;
        data.levels.forEach(function (level) {
            // detect if we have different kind of audio codecs used amongst playlists
            codec = level.audioCodec;
            if (codec) {
                if (codec.indexOf('mp4a.40.2') !== -1) {
                    aac = true;
                }
                if (codec.indexOf('mp4a.40.5') !== -1) {
                    heaac = true;
                }
            }
        });
        this.audioCodecSwitch = (aac && heaac);
        if (this.audioCodecSwitch) {
            logger_1.logger.log('both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC');
        }
        this.levels = data.levels;
        this.startFragRequested = false;
        var config = this.config;
        if (config.autoStartLoad || this.forceStartLoad) {
            this.hls.startLoad(config.startPosition);
        }
    };
    StreamController.prototype.onLevelLoaded = function (data) {
        var newDetails = data.details;
        var newLevelId = data.level;
        var lastLevel = this.levels[this.levelLastLoaded];
        var curLevel = this.levels[newLevelId];
        var duration = newDetails.totalduration;
        var sliding = 0;
        logger_1.logger.log("level " + newLevelId + " loaded [" + newDetails.startSN + "," + newDetails.endSN + "],duration:" + duration);
        if (newDetails.live) {
            var curDetails = curLevel.details;
            if (curDetails && newDetails.fragments.length > 0) {
                // we already have details for that level, merge them
                LevelHelper.mergeDetails(curDetails, newDetails);
                sliding = newDetails.fragments[0].start;
                this.liveSyncPosition = this.computeLivePosition(sliding, curDetails);
                if (newDetails.PTSKnown && Number.isFinite(sliding)) {
                    logger_1.logger.log("live playlist sliding:" + sliding.toFixed(3));
                }
                else {
                    logger_1.logger.log('live playlist - outdated PTS, unknown sliding');
                    discontinuities_1.alignStream(this.fragPrevious, lastLevel, newDetails);
                }
            }
            else {
                logger_1.logger.log('live playlist - first load, unknown sliding');
                newDetails.PTSKnown = false;
                discontinuities_1.alignStream(this.fragPrevious, lastLevel, newDetails);
            }
        }
        else {
            newDetails.PTSKnown = false;
        }
        // override level info
        curLevel.details = newDetails;
        this.levelLastLoaded = newLevelId;
        this.hls.trigger(events_1.default.LEVEL_UPDATED, { details: newDetails, level: newLevelId });
        if (this.startFragRequested === false) {
            // compute start position if set to -1. use it straight away if value is defined
            if (this.startPosition === -1 || this.lastCurrentTime === -1) {
                // first, check if start time offset has been set in playlist, if yes, use this value
                var startTimeOffset = newDetails.startTimeOffset;
                if (Number.isFinite(startTimeOffset)) {
                    if (startTimeOffset < 0) {
                        logger_1.logger.log("negative start time offset " + startTimeOffset + ", count from end of last fragment");
                        startTimeOffset = sliding + duration + startTimeOffset;
                    }
                    logger_1.logger.log("start time offset found in playlist, adjust startPosition to " + startTimeOffset);
                    this.startPosition = startTimeOffset;
                }
                else {
                    // if live playlist, set start position to be fragment N-this.config.liveSyncDurationCount (usually 3)
                    if (newDetails.live) {
                        this.startPosition = this.computeLivePosition(sliding, newDetails);
                        logger_1.logger.log("configure startPosition to " + this.startPosition);
                    }
                    else {
                        this.startPosition = 0;
                    }
                }
                this.lastCurrentTime = this.startPosition;
            }
            this.nextLoadPosition = this.startPosition;
        }
        // only switch batck to IDLE state if we were waiting for level to start downloading a new fragment
        if (this.state === base_stream_controller_1.State.WAITING_LEVEL) {
            this.state = base_stream_controller_1.State.IDLE;
        }
        // trigger handler right now
        this.tick();
    };
    StreamController.prototype.onKeyLoaded = function () {
        if (this.state === base_stream_controller_1.State.KEY_LOADING) {
            this.state = base_stream_controller_1.State.IDLE;
            this.tick();
        }
    };
    StreamController.prototype.onFragLoaded = function (data) {
        var _a = this, fragCurrent = _a.fragCurrent, hls = _a.hls, levels = _a.levels, media = _a.media;
        var fragLoaded = data.frag;
        if (this.state === base_stream_controller_1.State.FRAG_LOADING &&
            fragCurrent &&
            fragLoaded.type === 'main' &&
            fragLoaded.level === fragCurrent.level &&
            fragLoaded.sn === fragCurrent.sn) {
            var stats = data.stats;
            var currentLevel = levels[fragCurrent.level];
            var details = currentLevel.details;
            // reset frag bitrate test in any case after frag loaded event
            // if this frag was loaded to perform a bitrate test AND if hls.nextLoadLevel is greater than 0
            // then this means that we should be able to load a fragment at a higher quality level
            this.bitrateTest = false;
            this.stats = stats;
            logger_1.logger.log("Loaded " + fragCurrent.sn + " of [" + details.startSN + " ," + details.endSN + "],level " + fragCurrent.level);
            if (fragLoaded.bitrateTest && hls.nextLoadLevel) {
                // switch back to IDLE state ... we just loaded a fragment to determine adequate start bitrate and initialize autoswitch algo
                this.state = base_stream_controller_1.State.IDLE;
                this.startFragRequested = false;
                stats.tparsed = stats.tbuffered = window.performance.now();
                hls.trigger(events_1.default.FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'main' });
                this.tick();
            }
            else if (fragLoaded.sn === 'initSegment') {
                this.state = base_stream_controller_1.State.IDLE;
                stats.tparsed = stats.tbuffered = window.performance.now();
                details.initSegment.data = data.payload;
                hls.trigger(events_1.default.FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'main' });
                this.tick();
            }
            else {
                logger_1.logger.log("Parsing " + fragCurrent.sn + " of [" + details.startSN + " ," + details.endSN + "],level " + fragCurrent.level + ", cc " + fragCurrent.cc);
                this.state = base_stream_controller_1.State.PARSING;
                this.pendingBuffering = true;
                this.appended = false;
                // Bitrate test frags are not usually buffered so the fragment tracker ignores them. If Hls.js decides to buffer
                // it (and therefore ends up at this line), then the fragment tracker needs to be manually informed.
                if (fragLoaded.bitrateTest) {
                    fragLoaded.bitrateTest = false;
                    this.fragmentTracker.onFragLoaded({
                        frag: fragLoaded
                    });
                }
                // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live) and if media is not seeking (this is to overcome potential timestamp drifts between playlists and fragments)
                var accurateTimeOffset = !(media && media.seeking) && (details.PTSKnown || !details.live);
                var initSegmentData = details.initSegment ? details.initSegment.data : [];
                var audioCodec = this._getAudioCodec(currentLevel);
                // transmux the MPEG-TS data to ISO-BMFF segments
                var demuxer = this.demuxer = this.demuxer || new demuxer_1.default(this.hls, 'main');
                demuxer.push(data.payload, initSegmentData, audioCodec, currentLevel.videoCodec, fragCurrent, details.totalduration, accurateTimeOffset);
            }
        }
        this.fragLoadError = 0;
    };
    StreamController.prototype.onFragParsingInitSegment = function (data) {
        var fragCurrent = this.fragCurrent;
        var fragNew = data.frag;
        if (fragCurrent &&
            data.id === 'main' &&
            fragNew.sn === fragCurrent.sn &&
            fragNew.level === fragCurrent.level &&
            this.state === base_stream_controller_1.State.PARSING) {
            var tracks = data.tracks, trackName = void 0, track = void 0;
            // if audio track is expected to come from audio stream controller, discard any coming from main
            if (tracks.audio && this.altAudio) {
                delete tracks.audio;
            }
            // include levelCodec in audio and video tracks
            track = tracks.audio;
            if (track) {
                var audioCodec = this.levels[this.level].audioCodec, ua = navigator.userAgent.toLowerCase();
                if (audioCodec && this.audioCodecSwap) {
                    logger_1.logger.log('swapping playlist audio codec');
                    if (audioCodec.indexOf('mp4a.40.5') !== -1) {
                        audioCodec = 'mp4a.40.2';
                    }
                    else {
                        audioCodec = 'mp4a.40.5';
                    }
                }
                // in case AAC and HE-AAC audio codecs are signalled in manifest
                // force HE-AAC , as it seems that most browsers prefers that way,
                // except for mono streams OR on FF
                // these conditions might need to be reviewed ...
                if (this.audioCodecSwitch) {
                    // don't force HE-AAC if mono stream
                    if (track.metadata.channelCount !== 1 &&
                        // don't force HE-AAC if firefox
                        ua.indexOf('firefox') === -1) {
                        audioCodec = 'mp4a.40.5';
                    }
                }
                // HE-AAC is broken on Android, always signal audio codec as AAC even if variant manifest states otherwise
                if (ua.indexOf('android') !== -1 && track.container !== 'audio/mpeg') { // Exclude mpeg audio
                    audioCodec = 'mp4a.40.2';
                    logger_1.logger.log("Android: force audio codec to " + audioCodec);
                }
                track.levelCodec = audioCodec;
                track.id = data.id;
            }
            track = tracks.video;
            if (track) {
                track.levelCodec = this.levels[this.level].videoCodec;
                track.id = data.id;
            }
            this.hls.trigger(events_1.default.BUFFER_CODECS, tracks);
            // loop through tracks that are going to be provided to bufferController
            for (trackName in tracks) {
                track = tracks[trackName];
                logger_1.logger.log("main track:" + trackName + ",container:" + track.container + ",codecs[level/parsed]=[" + track.levelCodec + "/" + track.codec + "]");
                var initSegment = track.initSegment;
                if (initSegment) {
                    this.appended = true;
                    // arm pending Buffering flag before appending a segment
                    this.pendingBuffering = true;
                    this.hls.trigger(events_1.default.BUFFER_APPENDING, { type: trackName, data: initSegment, parent: 'main', content: 'initSegment' });
                }
            }
            // trigger handler right now
            this.tick();
        }
    };
    StreamController.prototype.onFragParsingData = function (data) {
        var _this = this;
        var fragCurrent = this.fragCurrent;
        var fragNew = data.frag;
        if (fragCurrent &&
            data.id === 'main' &&
            fragNew.sn === fragCurrent.sn &&
            fragNew.level === fragCurrent.level &&
            !(data.type === 'audio' && this.altAudio) && // filter out main audio if audio track is loaded through audio stream controller
            this.state === base_stream_controller_1.State.PARSING) {
            var level = this.levels[this.level], frag = fragCurrent;
            if (!Number.isFinite(data.endPTS)) {
                data.endPTS = data.startPTS + fragCurrent.duration;
                data.endDTS = data.startDTS + fragCurrent.duration;
            }
            if (data.hasAudio === true) {
                frag.addElementaryStream(fragment_1.default.ElementaryStreamTypes.AUDIO);
            }
            if (data.hasVideo === true) {
                frag.addElementaryStream(fragment_1.default.ElementaryStreamTypes.VIDEO);
            }
            logger_1.logger.log("Parsed " + data.type + ",PTS:[" + data.startPTS.toFixed(3) + "," + data.endPTS.toFixed(3) + "],DTS:[" + data.startDTS.toFixed(3) + "/" + data.endDTS.toFixed(3) + "],nb:" + data.nb + ",dropped:" + (data.dropped || 0));
            // Detect gaps in a fragment  and try to fix it by finding a keyframe in the previous fragment (see _findFragments)
            if (data.type === 'video') {
                frag.dropped = data.dropped;
                if (frag.dropped) {
                    if (!frag.backtracked) {
                        var levelDetails = level.details;
                        if (levelDetails && frag.sn === levelDetails.startSN) {
                            logger_1.logger.warn('missing video frame(s) on first frag, appending with gap', frag.sn);
                        }
                        else {
                            logger_1.logger.warn('missing video frame(s), backtracking fragment', frag.sn);
                            // Return back to the IDLE state without appending to buffer
                            // Causes findFragments to backtrack a segment and find the keyframe
                            // Audio fragments arriving before video sets the nextLoadPosition, causing _findFragments to skip the backtracked fragment
                            this.fragmentTracker.removeFragment(frag);
                            frag.backtracked = true;
                            this.nextLoadPosition = data.startPTS;
                            this.state = base_stream_controller_1.State.IDLE;
                            this.fragPrevious = frag;
                            this.tick();
                            return;
                        }
                    }
                    else {
                        logger_1.logger.warn('Already backtracked on this fragment, appending with the gap', frag.sn);
                    }
                }
                else {
                    // Only reset the backtracked flag if we've loaded the frag without any dropped frames
                    frag.backtracked = false;
                }
            }
            var drift = LevelHelper.updateFragPTSDTS(level.details, frag, data.startPTS, data.endPTS, data.startDTS, data.endDTS), hls_2 = this.hls;
            hls_2.trigger(events_1.default.LEVEL_PTS_UPDATED, { details: level.details, level: this.level, drift: drift, type: data.type, start: data.startPTS, end: data.endPTS });
            // has remuxer dropped video frames located before first keyframe ?
            [data.data1, data.data2].forEach(function (buffer) {
                // only append in PARSING state (rationale is that an appending error could happen synchronously on first segment appending)
                // in that case it is useless to append following segments
                if (buffer && buffer.length && _this.state === base_stream_controller_1.State.PARSING) {
                    _this.appended = true;
                    // arm pending Buffering flag before appending a segment
                    _this.pendingBuffering = true;
                    hls_2.trigger(events_1.default.BUFFER_APPENDING, { type: data.type, data: buffer, parent: 'main', content: 'data' });
                }
            });
            // trigger handler right now
            this.tick();
        }
    };
    StreamController.prototype.onFragParsed = function (data) {
        var fragCurrent = this.fragCurrent;
        var fragNew = data.frag;
        if (fragCurrent &&
            data.id === 'main' &&
            fragNew.sn === fragCurrent.sn &&
            fragNew.level === fragCurrent.level &&
            this.state === base_stream_controller_1.State.PARSING) {
            this.stats.tparsed = window.performance.now();
            this.state = base_stream_controller_1.State.PARSED;
            this._checkAppendedParsed();
        }
    };
    StreamController.prototype.onAudioTrackSwitching = function (data) {
        // if any URL found on new audio track, it is an alternate audio track
        var altAudio = !!data.url, trackId = data.id;
        // if we switch on main audio, ensure that main fragment scheduling is synced with media.buffered
        // don't do anything if we switch to alt audio: audio stream controller is handling it.
        // we will just have to change buffer scheduling on audioTrackSwitched
        if (!altAudio) {
            if (this.mediaBuffer !== this.media) {
                logger_1.logger.log('switching on main audio, use media.buffered to schedule main fragment loading');
                this.mediaBuffer = this.media;
                var fragCurrent = this.fragCurrent;
                // we need to refill audio buffer from main: cancel any frag loading to speed up audio switch
                if (fragCurrent.loader) {
                    logger_1.logger.log('switching to main audio track, cancel main fragment load');
                    fragCurrent.loader.abort();
                }
                this.fragCurrent = null;
                this.fragPrevious = null;
                // destroy demuxer to force init segment generation (following audio switch)
                if (this.demuxer) {
                    this.demuxer.destroy();
                    this.demuxer = null;
                }
                // switch to IDLE state to load new fragment
                this.state = base_stream_controller_1.State.IDLE;
            }
            var hls_3 = this.hls;
            // switching to main audio, flush all audio and trigger track switched
            hls_3.trigger(events_1.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
            hls_3.trigger(events_1.default.AUDIO_TRACK_SWITCHED, { id: trackId });
            this.altAudio = false;
        }
    };
    StreamController.prototype.onAudioTrackSwitched = function (data) {
        var trackId = data.id, altAudio = !!this.hls.audioTracks[trackId].url;
        if (altAudio) {
            var videoBuffer = this.videoBuffer;
            // if we switched on alternate audio, ensure that main fragment scheduling is synced with video sourcebuffer buffered
            if (videoBuffer && this.mediaBuffer !== videoBuffer) {
                logger_1.logger.log('switching on alternate audio, use video.buffered to schedule main fragment loading');
                this.mediaBuffer = videoBuffer;
            }
        }
        this.altAudio = altAudio;
        this.tick();
    };
    StreamController.prototype.onBufferCreated = function (data) {
        var tracks = data.tracks, mediaTrack, name, alternate = false;
        for (var type in tracks) {
            var track = tracks[type];
            if (track.id === 'main') {
                name = type;
                mediaTrack = track;
                // keep video source buffer reference
                if (type === 'video') {
                    this.videoBuffer = tracks[type].buffer;
                }
            }
            else {
                alternate = true;
            }
        }
        if (alternate && mediaTrack) {
            logger_1.logger.log("alternate track found, use " + name + ".buffered to schedule main fragment loading");
            this.mediaBuffer = mediaTrack.buffer;
        }
        else {
            this.mediaBuffer = this.media;
        }
    };
    StreamController.prototype.onBufferAppended = function (data) {
        if (data.parent === 'main') {
            var state = this.state;
            if (state === base_stream_controller_1.State.PARSING || state === base_stream_controller_1.State.PARSED) {
                // check if all buffers have been appended
                this.pendingBuffering = (data.pending > 0);
                this._checkAppendedParsed();
            }
        }
    };
    StreamController.prototype._checkAppendedParsed = function () {
        // trigger handler right now
        if (this.state === base_stream_controller_1.State.PARSED && (!this.appended || !this.pendingBuffering)) {
            var frag = this.fragCurrent;
            if (frag) {
                var media = this.mediaBuffer ? this.mediaBuffer : this.media;
                logger_1.logger.log("main buffered : " + time_ranges_1.default.toString(media.buffered));
                this.fragPrevious = frag;
                var stats = this.stats;
                stats.tbuffered = window.performance.now();
                // we should get rid of this.fragLastKbps
                this.fragLastKbps = Math.round(8 * stats.total / (stats.tbuffered - stats.tfirst));
                this.hls.trigger(events_1.default.FRAG_BUFFERED, { stats: stats, frag: frag, id: 'main' });
                this.state = base_stream_controller_1.State.IDLE;
            }
            this.tick();
        }
    };
    StreamController.prototype.onError = function (data) {
        var frag = data.frag || this.fragCurrent;
        // don't handle frag error not related to main fragment
        if (frag && frag.type !== 'main') {
            return;
        }
        // 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
        var mediaBuffered = !!this.media && buffer_helper_1.BufferHelper.isBuffered(this.media, this.media.currentTime) && buffer_helper_1.BufferHelper.isBuffered(this.media, this.media.currentTime + 0.5);
        switch (data.details) {
            case errors_1.ErrorDetails.FRAG_LOAD_ERROR:
            case errors_1.ErrorDetails.FRAG_LOAD_TIMEOUT:
            case errors_1.ErrorDetails.KEY_LOAD_ERROR:
            case errors_1.ErrorDetails.KEY_LOAD_TIMEOUT:
                if (!data.fatal) {
                    // keep retrying until the limit will be reached
                    if ((this.fragLoadError + 1) <= this.config.fragLoadingMaxRetry) {
                        // exponential backoff capped to config.fragLoadingMaxRetryTimeout
                        var delay = Math.min(Math.pow(2, this.fragLoadError) * this.config.fragLoadingRetryDelay, this.config.fragLoadingMaxRetryTimeout);
                        logger_1.logger.warn("mediaController: frag loading failed, retry in " + delay + " ms");
                        this.retryDate = window.performance.now() + delay;
                        // retry loading state
                        // if loadedmetadata is not set, it means that we are emergency switch down on first frag
                        // in that case, reset startFragRequested flag
                        if (!this.loadedmetadata) {
                            this.startFragRequested = false;
                            this.nextLoadPosition = this.startPosition;
                        }
                        this.fragLoadError++;
                        this.state = base_stream_controller_1.State.FRAG_LOADING_WAITING_RETRY;
                    }
                    else {
                        logger_1.logger.error("mediaController: " + data.details + " reaches max retry, redispatch as fatal ...");
                        // switch error to fatal
                        data.fatal = true;
                        this.state = base_stream_controller_1.State.ERROR;
                    }
                }
                break;
            case errors_1.ErrorDetails.LEVEL_LOAD_ERROR:
            case errors_1.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                if (this.state !== base_stream_controller_1.State.ERROR) {
                    if (data.fatal) {
                        // if fatal error, stop processing
                        this.state = base_stream_controller_1.State.ERROR;
                        logger_1.logger.warn("streamController: " + data.details + ",switch to " + this.state + " state ...");
                    }
                    else {
                        // in case of non fatal error while loading level, if level controller is not retrying to load level , switch back to IDLE
                        if (!data.levelRetry && this.state === base_stream_controller_1.State.WAITING_LEVEL) {
                            this.state = base_stream_controller_1.State.IDLE;
                        }
                    }
                }
                break;
            case errors_1.ErrorDetails.BUFFER_FULL_ERROR:
                // if in appending state
                if (data.parent === 'main' && (this.state === base_stream_controller_1.State.PARSING || this.state === base_stream_controller_1.State.PARSED)) {
                    // reduce max buf len if current position is buffered
                    if (mediaBuffered) {
                        this._reduceMaxBufferLength(this.config.maxBufferLength);
                        this.state = base_stream_controller_1.State.IDLE;
                    }
                    else {
                        // current position is not buffered, but browser is still complaining about buffer full error
                        // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
                        // in that case flush the whole buffer to recover
                        logger_1.logger.warn('buffer full error also media.currentTime is not buffered, flush everything');
                        this.fragCurrent = null;
                        // flush everything
                        this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
                    }
                }
                break;
            default:
                break;
        }
    };
    StreamController.prototype._reduceMaxBufferLength = function (minLength) {
        var config = this.config;
        if (config.maxMaxBufferLength >= minLength) {
            // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
            config.maxMaxBufferLength /= 2;
            logger_1.logger.warn("main:reduce max buffer length to " + config.maxMaxBufferLength + "s");
            return true;
        }
        return false;
    };
    /**
     * Checks the health of the buffer and attempts to resolve playback stalls.
     * @private
     */
    StreamController.prototype._checkBuffer = function () {
        var media = this.media;
        if (!media || media.readyState === 0) {
            // Exit early if we don't have media or if the media hasn't bufferd anything yet (readyState 0)
            return;
        }
        var mediaBuffer = this.mediaBuffer ? this.mediaBuffer : media;
        var buffered = mediaBuffer.buffered;
        if (!this.loadedmetadata && buffered.length) {
            this.loadedmetadata = true;
            this._seekToStartPos();
        }
        else if (this.immediateSwitch) {
            this.immediateLevelSwitchEnd();
        }
        else {
            this.gapController.poll(this.lastCurrentTime, buffered);
        }
    };
    StreamController.prototype.onFragLoadEmergencyAborted = function () {
        this.state = base_stream_controller_1.State.IDLE;
        // if loadedmetadata is not set, it means that we are emergency switch down on first frag
        // in that case, reset startFragRequested flag
        if (!this.loadedmetadata) {
            this.startFragRequested = false;
            this.nextLoadPosition = this.startPosition;
        }
        this.tick();
    };
    StreamController.prototype.onBufferFlushed = function () {
        /* after successful buffer flushing, filter flushed fragments from bufferedFrags
          use mediaBuffered instead of media (so that we will check against video.buffered ranges in case of alt audio track)
        */
        var media = this.mediaBuffer ? this.mediaBuffer : this.media;
        if (media) {
            // filter fragments potentially evicted from buffer. this is to avoid memleak on live streams
            this.fragmentTracker.detectEvictedFragments(fragment_1.default.ElementaryStreamTypes.VIDEO, media.buffered);
        }
        // move to IDLE once flush complete. this should trigger new fragment loading
        this.state = base_stream_controller_1.State.IDLE;
        // reset reference to frag
        this.fragPrevious = null;
    };
    StreamController.prototype.swapAudioCodec = function () {
        this.audioCodecSwap = !this.audioCodecSwap;
    };
    StreamController.prototype.computeLivePosition = function (sliding, levelDetails) {
        var targetLatency = this.config.liveSyncDuration !== undefined ? this.config.liveSyncDuration : this.config.liveSyncDurationCount * levelDetails.targetduration;
        return sliding + Math.max(0, levelDetails.totalduration - targetLatency);
    };
    /**
     * Seeks to the set startPosition if not equal to the mediaElement's current time.
     * @private
     */
    StreamController.prototype._seekToStartPos = function () {
        var media = this.media;
        var currentTime = media.currentTime;
        // only adjust currentTime if different from startPosition or if startPosition not buffered
        // at that stage, there should be only one buffered range, as we reach that code after first fragment has been buffered
        var startPosition = media.seeking ? currentTime : this.startPosition;
        // if currentTime not matching with expected startPosition or startPosition not buffered but close to first buffered
        if (currentTime !== startPosition) {
            // if startPosition not buffered, let's seek to buffered.start(0)
            logger_1.logger.log("target start position not buffered, seek to buffered.start(0) " + startPosition + " from current time " + currentTime + " ");
            media.currentTime = startPosition;
        }
    };
    StreamController.prototype._getAudioCodec = function (currentLevel) {
        var audioCodec = this.config.defaultAudioCodec || currentLevel.audioCodec;
        if (this.audioCodecSwap) {
            logger_1.logger.log('swapping playlist audio codec');
            if (audioCodec) {
                if (audioCodec.indexOf('mp4a.40.5') !== -1) {
                    audioCodec = 'mp4a.40.2';
                }
                else {
                    audioCodec = 'mp4a.40.5';
                }
            }
        }
        return audioCodec;
    };
    Object.defineProperty(StreamController.prototype, "liveSyncPosition", {
        get: function () {
            return this._liveSyncPosition;
        },
        set: function (value) {
            this._liveSyncPosition = value;
        },
        enumerable: true,
        configurable: true
    });
    return StreamController;
}(base_stream_controller_1.default));
exports.default = StreamController;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/controller/subtitle-stream-controller.js":
/*!******************************************************!*\
  !*** ./src/controller/subtitle-stream-controller.js ***!
  \******************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @class SubtitleStreamController
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var decrypter_1 = __webpack_require__(/*! ../crypt/decrypter */ "./src/crypt/decrypter.js");
var buffer_helper_1 = __webpack_require__(/*! ../utils/buffer-helper */ "./src/utils/buffer-helper.js");
var fragment_finders_1 = __webpack_require__(/*! ./fragment-finders */ "./src/controller/fragment-finders.js");
var fragment_tracker_1 = __webpack_require__(/*! ./fragment-tracker */ "./src/controller/fragment-tracker.js");
var base_stream_controller_1 = __webpack_require__(/*! ./base-stream-controller */ "./src/controller/base-stream-controller.js");
var level_helper_1 = __webpack_require__(/*! ./level-helper */ "./src/controller/level-helper.js");
var performance = window.performance;
var TICK_INTERVAL = 500; // how often to tick in ms
var SubtitleStreamController = /** @class */ (function (_super) {
    __extends(SubtitleStreamController, _super);
    function SubtitleStreamController(hls, fragmentTracker) {
        var _this = _super.call(this, hls, events_1.default.MEDIA_ATTACHED, events_1.default.MEDIA_DETACHING, events_1.default.ERROR, events_1.default.KEY_LOADED, events_1.default.FRAG_LOADED, events_1.default.SUBTITLE_TRACKS_UPDATED, events_1.default.SUBTITLE_TRACK_SWITCH, events_1.default.SUBTITLE_TRACK_LOADED, events_1.default.SUBTITLE_FRAG_PROCESSED, events_1.default.LEVEL_UPDATED) || this;
        _this.fragmentTracker = fragmentTracker;
        _this.config = hls.config;
        _this.state = base_stream_controller_1.State.STOPPED;
        _this.tracks = [];
        _this.tracksBuffered = [];
        _this.currentTrackId = -1;
        _this.decrypter = new decrypter_1.default(hls, hls.config);
        // lastAVStart stores the time in seconds for the start time of a level load
        _this.lastAVStart = 0;
        _this._onMediaSeeking = _this.onMediaSeeking.bind(_this);
        return _this;
    }
    SubtitleStreamController.prototype.onSubtitleFragProcessed = function (data) {
        var frag = data.frag, success = data.success;
        this.fragPrevious = frag;
        this.state = base_stream_controller_1.State.IDLE;
        if (!success) {
            return;
        }
        var buffered = this.tracksBuffered[this.currentTrackId];
        if (!buffered) {
            return;
        }
        // Create/update a buffered array matching the interface used by BufferHelper.bufferedInfo
        // so we can re-use the logic used to detect how much have been buffered
        var timeRange;
        var fragStart = frag.start;
        for (var i = 0; i < buffered.length; i++) {
            if (fragStart >= buffered[i].start && fragStart <= buffered[i].end) {
                timeRange = buffered[i];
                break;
            }
        }
        var fragEnd = frag.start + frag.duration;
        if (timeRange) {
            timeRange.end = fragEnd;
        }
        else {
            timeRange = {
                start: fragStart,
                end: fragEnd
            };
            buffered.push(timeRange);
        }
    };
    SubtitleStreamController.prototype.onMediaAttached = function (_a) {
        var media = _a.media;
        this.media = media;
        media.addEventListener('seeking', this._onMediaSeeking);
        this.state = base_stream_controller_1.State.IDLE;
    };
    SubtitleStreamController.prototype.onMediaDetaching = function () {
        this.media.removeEventListener('seeking', this._onMediaSeeking);
        this.media = null;
        this.state = base_stream_controller_1.State.STOPPED;
    };
    // If something goes wrong, proceed to next frag, if we were processing one.
    SubtitleStreamController.prototype.onError = function (data) {
        var frag = data.frag;
        // don't handle error not related to subtitle fragment
        if (!frag || frag.type !== 'subtitle') {
            return;
        }
        this.state = base_stream_controller_1.State.IDLE;
    };
    // Got all new subtitle tracks.
    SubtitleStreamController.prototype.onSubtitleTracksUpdated = function (data) {
        var _this = this;
        logger_1.logger.log('subtitle tracks updated');
        this.tracksBuffered = [];
        this.tracks = data.subtitleTracks;
        this.tracks.forEach(function (track) {
            _this.tracksBuffered[track.id] = [];
        });
    };
    SubtitleStreamController.prototype.onSubtitleTrackSwitch = function (data) {
        this.currentTrackId = data.id;
        if (!this.tracks || this.currentTrackId === -1) {
            this.clearInterval();
            return;
        }
        // Check if track has the necessary details to load fragments
        var currentTrack = this.tracks[this.currentTrackId];
        if (currentTrack && currentTrack.details) {
            this.setInterval(TICK_INTERVAL);
        }
    };
    // Got a new set of subtitle fragments.
    SubtitleStreamController.prototype.onSubtitleTrackLoaded = function (data) {
        var id = data.id, details = data.details;
        var _a = this, currentTrackId = _a.currentTrackId, tracks = _a.tracks;
        var currentTrack = tracks[currentTrackId];
        if (id >= tracks.length || id !== currentTrackId || !currentTrack) {
            return;
        }
        if (details.live) {
            level_helper_1.mergeSubtitlePlaylists(currentTrack.details, details, this.lastAVStart);
        }
        currentTrack.details = details;
        this.setInterval(TICK_INTERVAL);
    };
    SubtitleStreamController.prototype.onKeyLoaded = function () {
        if (this.state === base_stream_controller_1.State.KEY_LOADING) {
            this.state = base_stream_controller_1.State.IDLE;
        }
    };
    SubtitleStreamController.prototype.onFragLoaded = function (data) {
        var fragCurrent = this.fragCurrent;
        var decryptData = data.frag.decryptdata;
        var fragLoaded = data.frag;
        var hls = this.hls;
        if (this.state === base_stream_controller_1.State.FRAG_LOADING &&
            fragCurrent &&
            data.frag.type === 'subtitle' &&
            fragCurrent.sn === data.frag.sn) {
            // check to see if the payload needs to be decrypted
            if (data.payload.byteLength > 0 && (decryptData && decryptData.key && decryptData.method === 'AES-128')) {
                var startTime_1 = performance.now();
                // decrypt the subtitles
                this.decrypter.decrypt(data.payload, decryptData.key.buffer, decryptData.iv.buffer, function (decryptedData) {
                    var endTime = performance.now();
                    hls.trigger(events_1.default.FRAG_DECRYPTED, { frag: fragLoaded, payload: decryptedData, stats: { tstart: startTime_1, tdecrypt: endTime } });
                });
            }
        }
    };
    SubtitleStreamController.prototype.onLevelUpdated = function (_a) {
        var details = _a.details;
        var frags = details.fragments;
        this.lastAVStart = frags.length ? frags[0].start : 0;
    };
    SubtitleStreamController.prototype.doTick = function () {
        if (!this.media) {
            this.state = base_stream_controller_1.State.IDLE;
            return;
        }
        switch (this.state) {
            case base_stream_controller_1.State.IDLE: {
                var _a = this, config = _a.config, currentTrackId = _a.currentTrackId, fragmentTracker = _a.fragmentTracker, media = _a.media, tracks = _a.tracks;
                if (!tracks || !tracks[currentTrackId] || !tracks[currentTrackId].details) {
                    break;
                }
                var maxBufferHole = config.maxBufferHole, maxFragLookUpTolerance = config.maxFragLookUpTolerance;
                var maxConfigBuffer = Math.min(config.maxBufferLength, config.maxMaxBufferLength);
                var bufferedInfo = buffer_helper_1.BufferHelper.bufferedInfo(this._getBuffered(), media.currentTime, maxBufferHole);
                var bufferEnd = bufferedInfo.end, bufferLen = bufferedInfo.len;
                var trackDetails = tracks[currentTrackId].details;
                var fragments = trackDetails.fragments;
                var fragLen = fragments.length;
                var end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration;
                if (bufferLen > maxConfigBuffer) {
                    return;
                }
                var foundFrag = void 0;
                var fragPrevious = this.fragPrevious;
                if (bufferEnd < end) {
                    if (fragPrevious && trackDetails.hasProgramDateTime) {
                        foundFrag = fragment_finders_1.findFragmentByPDT(fragments, fragPrevious.endProgramDateTime, maxFragLookUpTolerance);
                    }
                    if (!foundFrag) {
                        foundFrag = fragment_finders_1.findFragmentByPTS(fragPrevious, fragments, bufferEnd, maxFragLookUpTolerance);
                    }
                }
                else {
                    foundFrag = fragments[fragLen - 1];
                }
                if (foundFrag && foundFrag.encrypted) {
                    logger_1.logger.log("Loading key for " + foundFrag.sn);
                    this.state = base_stream_controller_1.State.KEY_LOADING;
                    this.hls.trigger(events_1.default.KEY_LOADING, { frag: foundFrag });
                }
                else if (foundFrag && fragmentTracker.getState(foundFrag) === fragment_tracker_1.FragmentState.NOT_LOADED) {
                    // only load if fragment is not loaded
                    this.fragCurrent = foundFrag;
                    this.state = base_stream_controller_1.State.FRAG_LOADING;
                    this.hls.trigger(events_1.default.FRAG_LOADING, { frag: foundFrag });
                }
            }
        }
    };
    SubtitleStreamController.prototype.stopLoad = function () {
        this.lastAVStart = 0;
        _super.prototype.stopLoad.call(this);
    };
    SubtitleStreamController.prototype._getBuffered = function () {
        return this.tracksBuffered[this.currentTrackId] || [];
    };
    SubtitleStreamController.prototype.onMediaSeeking = function () {
        this.fragPrevious = null;
    };
    return SubtitleStreamController;
}(base_stream_controller_1.default));
exports.SubtitleStreamController = SubtitleStreamController;


/***/ }),

/***/ "./src/controller/subtitle-track-controller.js":
/*!*****************************************************!*\
  !*** ./src/controller/subtitle-track-controller.js ***!
  \*****************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var level_helper_1 = __webpack_require__(/*! ./level-helper */ "./src/controller/level-helper.js");
var SubtitleTrackController = /** @class */ (function (_super) {
    __extends(SubtitleTrackController, _super);
    function SubtitleTrackController(hls) {
        var _this = _super.call(this, hls, events_1.default.MEDIA_ATTACHED, events_1.default.MEDIA_DETACHING, events_1.default.MANIFEST_LOADED, events_1.default.SUBTITLE_TRACK_LOADED) || this;
        _this.tracks = [];
        _this.trackId = -1;
        _this.media = null;
        _this.stopped = true;
        /**
         * @member {boolean} subtitleDisplay Enable/disable subtitle display rendering
         */
        _this.subtitleDisplay = true;
        return _this;
    }
    SubtitleTrackController.prototype.destroy = function () {
        event_handler_1.default.prototype.destroy.call(this);
    };
    // Listen for subtitle track change, then extract the current track ID.
    SubtitleTrackController.prototype.onMediaAttached = function (data) {
        var _this = this;
        this.media = data.media;
        if (!this.media) {
            return;
        }
        if (this.queuedDefaultTrack) {
            this.subtitleTrack = this.queuedDefaultTrack;
            delete this.queuedDefaultTrack;
        }
        this.trackChangeListener = this._onTextTracksChanged.bind(this);
        this.useTextTrackPolling = !(this.media.textTracks && 'onchange' in this.media.textTracks);
        if (this.useTextTrackPolling) {
            this.subtitlePollingInterval = setInterval(function () {
                _this.trackChangeListener();
            }, 500);
        }
        else {
            this.media.textTracks.addEventListener('change', this.trackChangeListener);
        }
    };
    SubtitleTrackController.prototype.onMediaDetaching = function () {
        if (!this.media) {
            return;
        }
        if (this.useTextTrackPolling) {
            clearInterval(this.subtitlePollingInterval);
        }
        else {
            this.media.textTracks.removeEventListener('change', this.trackChangeListener);
        }
        this.media = null;
    };
    // Fired whenever a new manifest is loaded.
    SubtitleTrackController.prototype.onManifestLoaded = function (data) {
        var _this = this;
        var tracks = data.subtitles || [];
        this.tracks = tracks;
        this.hls.trigger(events_1.default.SUBTITLE_TRACKS_UPDATED, { subtitleTracks: tracks });
        // loop through available subtitle tracks and autoselect default if needed
        // TODO: improve selection logic to handle forced, etc
        tracks.forEach(function (track) {
            if (track.default) {
                // setting this.subtitleTrack will trigger internal logic
                // if media has not been attached yet, it will fail
                // we keep a reference to the default track id
                // and we'll set subtitleTrack when onMediaAttached is triggered
                if (_this.media) {
                    _this.subtitleTrack = track.id;
                }
                else {
                    _this.queuedDefaultTrack = track.id;
                }
            }
        });
    };
    SubtitleTrackController.prototype.onSubtitleTrackLoaded = function (data) {
        var _this = this;
        var id = data.id, details = data.details;
        var _a = this, trackId = _a.trackId, tracks = _a.tracks;
        var currentTrack = tracks[trackId];
        if (id >= tracks.length || id !== trackId || !currentTrack || this.stopped) {
            this._clearReloadTimer();
            return;
        }
        logger_1.logger.log("subtitle track " + id + " loaded");
        if (details.live) {
            var reloadInterval = level_helper_1.computeReloadInterval(currentTrack.details, details, data.stats.trequest);
            logger_1.logger.log("Reloading live subtitle playlist in " + reloadInterval + "ms");
            this.timer = setTimeout(function () {
                _this._loadCurrentTrack();
            }, reloadInterval);
        }
        else {
            this._clearReloadTimer();
        }
    };
    SubtitleTrackController.prototype.startLoad = function () {
        this.stopped = false;
        this._loadCurrentTrack();
    };
    SubtitleTrackController.prototype.stopLoad = function () {
        this.stopped = true;
        this._clearReloadTimer();
    };
    Object.defineProperty(SubtitleTrackController.prototype, "subtitleTracks", {
        /** get alternate subtitle tracks list from playlist **/
        get: function () {
            return this.tracks;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubtitleTrackController.prototype, "subtitleTrack", {
        /** get index of the selected subtitle track (index in subtitle track lists) **/
        get: function () {
            return this.trackId;
        },
        /** select a subtitle track, based on its index in subtitle track lists**/
        set: function (subtitleTrackId) {
            if (this.trackId !== subtitleTrackId) {
                this._toggleTrackModes(subtitleTrackId);
                this._setSubtitleTrackInternal(subtitleTrackId);
            }
        },
        enumerable: true,
        configurable: true
    });
    SubtitleTrackController.prototype._clearReloadTimer = function () {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    };
    SubtitleTrackController.prototype._loadCurrentTrack = function () {
        var _a = this, trackId = _a.trackId, tracks = _a.tracks, hls = _a.hls;
        var currentTrack = tracks[trackId];
        if (trackId < 0 || !currentTrack || (currentTrack.details && !currentTrack.details.live)) {
            return;
        }
        logger_1.logger.log("Loading subtitle track " + trackId);
        hls.trigger(events_1.default.SUBTITLE_TRACK_LOADING, { url: currentTrack.url, id: trackId });
    };
    /**
     * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
     * This operates on the DOM textTracks.
     * A value of -1 will disable all subtitle tracks.
     * @param newId - The id of the next track to enable
     * @private
     */
    SubtitleTrackController.prototype._toggleTrackModes = function (newId) {
        var _a = this, media = _a.media, subtitleDisplay = _a.subtitleDisplay, trackId = _a.trackId;
        if (!media) {
            return;
        }
        var textTracks = filterSubtitleTracks(media.textTracks);
        if (newId === -1) {
            [].slice.call(textTracks).forEach(function (track) {
                track.mode = 'disabled';
            });
        }
        else {
            var oldTrack = textTracks[trackId];
            if (oldTrack) {
                oldTrack.mode = 'disabled';
            }
        }
        var nextTrack = textTracks[newId];
        if (nextTrack) {
            nextTrack.mode = subtitleDisplay ? 'showing' : 'hidden';
        }
    };
    /**
       * This method is responsible for validating the subtitle index and periodically reloading if live.
       * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
       * @param newId - The id of the subtitle track to activate.
       */
    SubtitleTrackController.prototype._setSubtitleTrackInternal = function (newId) {
        var _a = this, hls = _a.hls, tracks = _a.tracks;
        if (!Number.isFinite(newId) || newId < -1 || newId >= tracks.length) {
            return;
        }
        this.trackId = newId;
        logger_1.logger.log("Switching to subtitle track " + newId);
        hls.trigger(events_1.default.SUBTITLE_TRACK_SWITCH, { id: newId });
        this._loadCurrentTrack();
    };
    SubtitleTrackController.prototype._onTextTracksChanged = function () {
        // Media is undefined when switching streams via loadSource()
        if (!this.media) {
            return;
        }
        var trackId = -1;
        var tracks = filterSubtitleTracks(this.media.textTracks);
        for (var id = 0; id < tracks.length; id++) {
            if (tracks[id].mode === 'hidden') {
                // Do not break in case there is a following track with showing.
                trackId = id;
            }
            else if (tracks[id].mode === 'showing') {
                trackId = id;
                break;
            }
        }
        // Setting current subtitleTrack will invoke code.
        this.subtitleTrack = trackId;
    };
    return SubtitleTrackController;
}(event_handler_1.default));
function filterSubtitleTracks(textTrackList) {
    var tracks = [];
    for (var i = 0; i < textTrackList.length; i++) {
        var track = textTrackList[i];
        // Edge adds a track without a label; we don't want to use it
        if (track.kind === 'subtitles' && track.label) {
            tracks.push(textTrackList[i]);
        }
    }
    return tracks;
}
exports.default = SubtitleTrackController;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/controller/timeline-controller.js":
/*!***********************************************!*\
  !*** ./src/controller/timeline-controller.js ***!
  \***********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
/*
 * Timeline Controller
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var cea_608_parser_1 = __webpack_require__(/*! ../utils/cea-608-parser */ "./src/utils/cea-608-parser.js");
var output_filter_1 = __webpack_require__(/*! ../utils/output-filter */ "./src/utils/output-filter.js");
var webvtt_parser_1 = __webpack_require__(/*! ../utils/webvtt-parser */ "./src/utils/webvtt-parser.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var texttrack_utils_1 = __webpack_require__(/*! ../utils/texttrack-utils */ "./src/utils/texttrack-utils.js");
function canReuseVttTextTrack(inUseTrack, manifestTrack) {
    return inUseTrack && inUseTrack.label === manifestTrack.name && !(inUseTrack.textTrack1 || inUseTrack.textTrack2);
}
function intersection(x1, x2, y1, y2) {
    return Math.min(x2, y2) - Math.max(x1, y1);
}
var TimelineController = /** @class */ (function (_super) {
    __extends(TimelineController, _super);
    function TimelineController(hls) {
        var _this = _super.call(this, hls, events_1.default.MEDIA_ATTACHING, events_1.default.MEDIA_DETACHING, events_1.default.FRAG_PARSING_USERDATA, events_1.default.FRAG_DECRYPTED, events_1.default.MANIFEST_LOADING, events_1.default.MANIFEST_LOADED, events_1.default.FRAG_LOADED, events_1.default.LEVEL_SWITCHING, events_1.default.INIT_PTS_FOUND) || this;
        _this.hls = hls;
        _this.config = hls.config;
        _this.enabled = true;
        _this.Cues = hls.config.cueHandler;
        _this.textTracks = [];
        _this.tracks = [];
        _this.unparsedVttFrags = [];
        _this.initPTS = [];
        _this.cueRanges = [];
        _this.captionsTracks = {};
        _this.captionsProperties = {
            textTrack1: {
                label: _this.config.captionsTextTrack1Label,
                languageCode: _this.config.captionsTextTrack1LanguageCode
            },
            textTrack2: {
                label: _this.config.captionsTextTrack2Label,
                languageCode: _this.config.captionsTextTrack2LanguageCode
            }
        };
        if (_this.config.enableCEA708Captions) {
            var channel1 = new output_filter_1.default(_this, 'textTrack1');
            var channel2 = new output_filter_1.default(_this, 'textTrack2');
            _this.cea608Parser = new cea_608_parser_1.default(0, channel1, channel2);
        }
        return _this;
    }
    TimelineController.prototype.addCues = function (trackName, startTime, endTime, screen) {
        // skip cues which overlap more than 50% with previously parsed time ranges
        var ranges = this.cueRanges;
        var merged = false;
        for (var i = ranges.length; i--;) {
            var cueRange = ranges[i];
            var overlap = intersection(cueRange[0], cueRange[1], startTime, endTime);
            if (overlap >= 0) {
                cueRange[0] = Math.min(cueRange[0], startTime);
                cueRange[1] = Math.max(cueRange[1], endTime);
                merged = true;
                if ((overlap / (endTime - startTime)) > 0.5) {
                    return;
                }
            }
        }
        if (!merged) {
            ranges.push([startTime, endTime]);
        }
        this.Cues.newCue(this.captionsTracks[trackName], startTime, endTime, screen);
    };
    // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
    TimelineController.prototype.onInitPtsFound = function (data) {
        var _this = this;
        if (data.id === 'main') {
            this.initPTS[data.frag.cc] = data.initPTS;
        }
        // Due to asynchronous processing, initial PTS may arrive later than the first VTT fragments are loaded.
        // Parse any unparsed fragments upon receiving the initial PTS.
        if (this.unparsedVttFrags.length) {
            var unparsedVttFrags = this.unparsedVttFrags;
            this.unparsedVttFrags = [];
            unparsedVttFrags.forEach(function (frag) {
                _this.onFragLoaded(frag);
            });
        }
    };
    TimelineController.prototype.getExistingTrack = function (trackName) {
        var media = this.media;
        if (media) {
            for (var i = 0; i < media.textTracks.length; i++) {
                var textTrack = media.textTracks[i];
                if (textTrack[trackName]) {
                    return textTrack;
                }
            }
        }
        return null;
    };
    TimelineController.prototype.createCaptionsTrack = function (trackName) {
        var _a = this.captionsProperties[trackName], label = _a.label, languageCode = _a.languageCode;
        var captionsTracks = this.captionsTracks;
        if (!captionsTracks[trackName]) {
            // Enable reuse of existing text track.
            var existingTrack = this.getExistingTrack(trackName);
            if (!existingTrack) {
                var textTrack = this.createTextTrack('captions', label, languageCode);
                if (textTrack) {
                    // Set a special property on the track so we know it's managed by Hls.js
                    textTrack[trackName] = true;
                    captionsTracks[trackName] = textTrack;
                }
            }
            else {
                captionsTracks[trackName] = existingTrack;
                texttrack_utils_1.clearCurrentCues(captionsTracks[trackName]);
                texttrack_utils_1.sendAddTrackEvent(captionsTracks[trackName], this.media);
            }
        }
    };
    TimelineController.prototype.createTextTrack = function (kind, label, lang) {
        var media = this.media;
        if (media) {
            return media.addTextTrack(kind, label, lang);
        }
    };
    TimelineController.prototype.destroy = function () {
        event_handler_1.default.prototype.destroy.call(this);
    };
    TimelineController.prototype.onMediaAttaching = function (data) {
        this.media = data.media;
        this._cleanTracks();
    };
    TimelineController.prototype.onMediaDetaching = function () {
        var captionsTracks = this.captionsTracks;
        Object.keys(captionsTracks).forEach(function (trackName) {
            texttrack_utils_1.clearCurrentCues(captionsTracks[trackName]);
            delete captionsTracks[trackName];
        });
    };
    TimelineController.prototype.onManifestLoading = function () {
        this.lastSn = -1; // Detect discontiguity in fragment parsing
        this.prevCC = -1;
        this.vttCCs = {
            ccOffset: 0,
            presentationOffset: 0,
            0: {
                start: 0, prevCC: -1, new: false
            }
        };
        this._cleanTracks();
    };
    TimelineController.prototype._cleanTracks = function () {
        // clear outdated subtitles
        var media = this.media;
        if (media) {
            var textTracks = media.textTracks;
            if (textTracks) {
                for (var i = 0; i < textTracks.length; i++) {
                    texttrack_utils_1.clearCurrentCues(textTracks[i]);
                }
            }
        }
    };
    TimelineController.prototype.onManifestLoaded = function (data) {
        var _this = this;
        this.textTracks = [];
        this.unparsedVttFrags = this.unparsedVttFrags || [];
        this.initPTS = [];
        this.cueRanges = [];
        if (this.config.enableWebVTT) {
            this.tracks = data.subtitles || [];
            var inUseTracks_1 = this.media ? this.media.textTracks : [];
            this.tracks.forEach(function (track, index) {
                var textTrack;
                if (index < inUseTracks_1.length) {
                    var inUseTrack = null;
                    for (var i = 0; i < inUseTracks_1.length; i++) {
                        if (canReuseVttTextTrack(inUseTracks_1[i], track)) {
                            inUseTrack = inUseTracks_1[i];
                            break;
                        }
                    }
                    // Reuse tracks with the same label, but do not reuse 608/708 tracks
                    if (inUseTrack) {
                        textTrack = inUseTrack;
                    }
                }
                if (!textTrack) {
                    textTrack = _this.createTextTrack('subtitles', track.name, track.lang);
                }
                if (track.default) {
                    textTrack.mode = _this.hls.subtitleDisplay ? 'showing' : 'hidden';
                }
                else {
                    textTrack.mode = 'disabled';
                }
                _this.textTracks.push(textTrack);
            });
        }
    };
    TimelineController.prototype.onLevelSwitching = function () {
        this.enabled = this.hls.currentLevel.closedCaptions !== 'NONE';
    };
    TimelineController.prototype.onFragLoaded = function (data) {
        var frag = data.frag, payload = data.payload;
        if (frag.type === 'main') {
            var sn = frag.sn;
            // if this frag isn't contiguous, clear the parser so cues with bad start/end times aren't added to the textTrack
            if (sn !== this.lastSn + 1) {
                var cea608Parser = this.cea608Parser;
                if (cea608Parser) {
                    cea608Parser.reset();
                }
            }
            this.lastSn = sn;
        } // eslint-disable-line brace-style
        // If fragment is subtitle type, parse as WebVTT.
        else if (frag.type === 'subtitle') {
            if (payload.byteLength) {
                // We need an initial synchronisation PTS. Store fragments as long as none has arrived.
                if (!Number.isFinite(this.initPTS[frag.cc])) {
                    this.unparsedVttFrags.push(data);
                    if (this.initPTS.length) {
                        // finish unsuccessfully, otherwise the subtitle-stream-controller could be blocked from loading new frags.
                        this.hls.trigger(events_1.default.SUBTITLE_FRAG_PROCESSED, { success: false, frag: frag });
                    }
                    return;
                }
                var decryptData = frag.decryptdata;
                // If the subtitles are not encrypted, parse VTTs now. Otherwise, we need to wait.
                if ((decryptData == null) || (decryptData.key == null) || (decryptData.method !== 'AES-128')) {
                    this._parseVTTs(frag, payload);
                }
            }
            else {
                // In case there is no payload, finish unsuccessfully.
                this.hls.trigger(events_1.default.SUBTITLE_FRAG_PROCESSED, { success: false, frag: frag });
            }
        }
    };
    TimelineController.prototype._parseVTTs = function (frag, payload) {
        var vttCCs = this.vttCCs;
        if (!vttCCs[frag.cc]) {
            vttCCs[frag.cc] = { start: frag.start, prevCC: this.prevCC, new: true };
            this.prevCC = frag.cc;
        }
        var textTracks = this.textTracks, hls = this.hls;
        // Parse the WebVTT file contents.
        webvtt_parser_1.default.parse(payload, this.initPTS[frag.cc], vttCCs, frag.cc, function (cues) {
            var currentTrack = textTracks[frag.level];
            // WebVTTParser.parse is an async method and if the currently selected text track mode is set to "disabled"
            // before parsing is done then don't try to access currentTrack.cues.getCueById as cues will be null
            // and trying to access getCueById method of cues will throw an exception
            if (currentTrack.mode === 'disabled') {
                hls.trigger(events_1.default.SUBTITLE_FRAG_PROCESSED, { success: false, frag: frag });
                return;
            }
            // Add cues and trigger event with success true.
            cues.forEach(function (cue) {
                // Sometimes there are cue overlaps on segmented vtts so the same
                // cue can appear more than once in different vtt files.
                // This avoid showing duplicated cues with same timecode and text.
                if (!currentTrack.cues.getCueById(cue.id)) {
                    try {
                        currentTrack.addCue(cue);
                    }
                    catch (err) {
                        var textTrackCue = new window.TextTrackCue(cue.startTime, cue.endTime, cue.text);
                        textTrackCue.id = cue.id;
                        currentTrack.addCue(textTrackCue);
                    }
                }
            });
            hls.trigger(events_1.default.SUBTITLE_FRAG_PROCESSED, { success: true, frag: frag });
        }, function (e) {
            // Something went wrong while parsing. Trigger event with success false.
            logger_1.logger.log("Failed to parse VTT cue: " + e);
            hls.trigger(events_1.default.SUBTITLE_FRAG_PROCESSED, { success: false, frag: frag });
        });
    };
    TimelineController.prototype.onFragDecrypted = function (data) {
        var decryptedData = data.payload, frag = data.frag;
        if (frag.type === 'subtitle') {
            if (!Number.isFinite(this.initPTS[frag.cc])) {
                this.unparsedVttFrags.push(data);
                return;
            }
            this._parseVTTs(frag, decryptedData);
        }
    };
    TimelineController.prototype.onFragParsingUserdata = function (data) {
        // push all of the CEA-708 messages into the interpreter
        // immediately. It will create the proper timestamps based on our PTS value
        if (this.enabled && this.config.enableCEA708Captions) {
            for (var i = 0; i < data.samples.length; i++) {
                var ccdatas = this.extractCea608Data(data.samples[i].bytes);
                this.cea608Parser.addData(data.samples[i].pts, ccdatas);
            }
        }
    };
    TimelineController.prototype.extractCea608Data = function (byteArray) {
        var count = byteArray[0] & 31;
        var position = 2;
        var tmpByte, ccbyte1, ccbyte2, ccValid, ccType;
        var actualCCBytes = [];
        for (var j = 0; j < count; j++) {
            tmpByte = byteArray[position++];
            ccbyte1 = 0x7F & byteArray[position++];
            ccbyte2 = 0x7F & byteArray[position++];
            ccValid = (4 & tmpByte) !== 0;
            ccType = 3 & tmpByte;
            if (ccbyte1 === 0 && ccbyte2 === 0) {
                continue;
            }
            if (ccValid) {
                if (ccType === 0) { // || ccType === 1
                    actualCCBytes.push(ccbyte1);
                    actualCCBytes.push(ccbyte2);
                }
            }
        }
        return actualCCBytes;
    };
    return TimelineController;
}(event_handler_1.default));
exports.default = TimelineController;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/crypt/aes-crypto.js":
/*!*********************************!*\
  !*** ./src/crypt/aes-crypto.js ***!
  \*********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AESCrypto = /** @class */ (function () {
    function AESCrypto(subtle, iv) {
        this.subtle = subtle;
        this.aesIV = iv;
    }
    AESCrypto.prototype.decrypt = function (data, key) {
        return this.subtle.decrypt({ name: 'AES-CBC', iv: this.aesIV }, key, data);
    };
    return AESCrypto;
}());
exports.default = AESCrypto;


/***/ }),

/***/ "./src/crypt/aes-decryptor.js":
/*!************************************!*\
  !*** ./src/crypt/aes-decryptor.js ***!
  \************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// PKCS7
function removePadding(buffer) {
    var outputBytes = buffer.byteLength;
    var paddingBytes = outputBytes && (new DataView(buffer)).getUint8(outputBytes - 1);
    if (paddingBytes) {
        return buffer.slice(0, outputBytes - paddingBytes);
    }
    else {
        return buffer;
    }
}
exports.removePadding = removePadding;
var AESDecryptor = /** @class */ (function () {
    function AESDecryptor() {
        // Static after running initTable
        this.rcon = [0x0, 0x1, 0x2, 0x4, 0x8, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
        this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
        this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
        this.sBox = new Uint32Array(256);
        this.invSBox = new Uint32Array(256);
        // Changes during runtime
        this.key = new Uint32Array(0);
        this.initTable();
    }
    // Using view.getUint32() also swaps the byte order.
    AESDecryptor.prototype.uint8ArrayToUint32Array_ = function (arrayBuffer) {
        var view = new DataView(arrayBuffer);
        var newArray = new Uint32Array(4);
        for (var i = 0; i < 4; i++) {
            newArray[i] = view.getUint32(i * 4);
        }
        return newArray;
    };
    AESDecryptor.prototype.initTable = function () {
        var sBox = this.sBox;
        var invSBox = this.invSBox;
        var subMix = this.subMix;
        var subMix0 = subMix[0];
        var subMix1 = subMix[1];
        var subMix2 = subMix[2];
        var subMix3 = subMix[3];
        var invSubMix = this.invSubMix;
        var invSubMix0 = invSubMix[0];
        var invSubMix1 = invSubMix[1];
        var invSubMix2 = invSubMix[2];
        var invSubMix3 = invSubMix[3];
        var d = new Uint32Array(256);
        var x = 0;
        var xi = 0;
        var i = 0;
        for (i = 0; i < 256; i++) {
            if (i < 128) {
                d[i] = i << 1;
            }
            else {
                d[i] = (i << 1) ^ 0x11b;
            }
        }
        for (i = 0; i < 256; i++) {
            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
            sBox[x] = sx;
            invSBox[sx] = x;
            // Compute multiplication
            var x2 = d[x];
            var x4 = d[x2];
            var x8 = d[x4];
            // Compute sub/invSub bytes, mix columns tables
            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
            subMix0[x] = (t << 24) | (t >>> 8);
            subMix1[x] = (t << 16) | (t >>> 16);
            subMix2[x] = (t << 8) | (t >>> 24);
            subMix3[x] = t;
            // Compute inv sub bytes, inv mix columns tables
            t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
            invSubMix0[sx] = (t << 24) | (t >>> 8);
            invSubMix1[sx] = (t << 16) | (t >>> 16);
            invSubMix2[sx] = (t << 8) | (t >>> 24);
            invSubMix3[sx] = t;
            // Compute next counter
            if (!x) {
                x = xi = 1;
            }
            else {
                x = x2 ^ d[d[d[x8 ^ x2]]];
                xi ^= d[d[xi]];
            }
        }
    };
    AESDecryptor.prototype.expandKey = function (keyBuffer) {
        // convert keyBuffer to Uint32Array
        var key = this.uint8ArrayToUint32Array_(keyBuffer);
        var sameKey = true;
        var offset = 0;
        while (offset < key.length && sameKey) {
            sameKey = (key[offset] === this.key[offset]);
            offset++;
        }
        if (sameKey) {
            return;
        }
        this.key = key;
        var keySize = this.keySize = key.length;
        if (keySize !== 4 && keySize !== 6 && keySize !== 8) {
            throw new Error('Invalid aes key size=' + keySize);
        }
        var ksRows = this.ksRows = (keySize + 6 + 1) * 4;
        var ksRow;
        var invKsRow;
        var keySchedule = this.keySchedule = new Uint32Array(ksRows);
        var invKeySchedule = this.invKeySchedule = new Uint32Array(ksRows);
        var sbox = this.sBox;
        var rcon = this.rcon;
        var invSubMix = this.invSubMix;
        var invSubMix0 = invSubMix[0];
        var invSubMix1 = invSubMix[1];
        var invSubMix2 = invSubMix[2];
        var invSubMix3 = invSubMix[3];
        var prev;
        var t;
        for (ksRow = 0; ksRow < ksRows; ksRow++) {
            if (ksRow < keySize) {
                prev = keySchedule[ksRow] = key[ksRow];
                continue;
            }
            t = prev;
            if (ksRow % keySize === 0) {
                // Rot word
                t = (t << 8) | (t >>> 24);
                // Sub word
                t = (sbox[t >>> 24] << 24) | (sbox[(t >>> 16) & 0xff] << 16) | (sbox[(t >>> 8) & 0xff] << 8) | sbox[t & 0xff];
                // Mix Rcon
                t ^= rcon[(ksRow / keySize) | 0] << 24;
            }
            else if (keySize > 6 && ksRow % keySize === 4) {
                // Sub word
                t = (sbox[t >>> 24] << 24) | (sbox[(t >>> 16) & 0xff] << 16) | (sbox[(t >>> 8) & 0xff] << 8) | sbox[t & 0xff];
            }
            keySchedule[ksRow] = prev = (keySchedule[ksRow - keySize] ^ t) >>> 0;
        }
        for (invKsRow = 0; invKsRow < ksRows; invKsRow++) {
            ksRow = ksRows - invKsRow;
            if (invKsRow & 3) {
                t = keySchedule[ksRow];
            }
            else {
                t = keySchedule[ksRow - 4];
            }
            if (invKsRow < 4 || ksRow <= 4) {
                invKeySchedule[invKsRow] = t;
            }
            else {
                invKeySchedule[invKsRow] = invSubMix0[sbox[t >>> 24]] ^ invSubMix1[sbox[(t >>> 16) & 0xff]] ^ invSubMix2[sbox[(t >>> 8) & 0xff]] ^ invSubMix3[sbox[t & 0xff]];
            }
            invKeySchedule[invKsRow] = invKeySchedule[invKsRow] >>> 0;
        }
    };
    // Adding this as a method greatly improves performance.
    AESDecryptor.prototype.networkToHostOrderSwap = function (word) {
        return (word << 24) | ((word & 0xff00) << 8) | ((word & 0xff0000) >> 8) | (word >>> 24);
    };
    AESDecryptor.prototype.decrypt = function (inputArrayBuffer, offset, aesIV, removePKCS7Padding) {
        var nRounds = this.keySize + 6;
        var invKeySchedule = this.invKeySchedule;
        var invSBOX = this.invSBox;
        var invSubMix = this.invSubMix;
        var invSubMix0 = invSubMix[0];
        var invSubMix1 = invSubMix[1];
        var invSubMix2 = invSubMix[2];
        var invSubMix3 = invSubMix[3];
        var initVector = this.uint8ArrayToUint32Array_(aesIV);
        var initVector0 = initVector[0];
        var initVector1 = initVector[1];
        var initVector2 = initVector[2];
        var initVector3 = initVector[3];
        var inputInt32 = new Int32Array(inputArrayBuffer);
        var outputInt32 = new Int32Array(inputInt32.length);
        var t0, t1, t2, t3;
        var s0, s1, s2, s3;
        var inputWords0, inputWords1, inputWords2, inputWords3;
        var ksRow, i;
        var swapWord = this.networkToHostOrderSwap;
        while (offset < inputInt32.length) {
            inputWords0 = swapWord(inputInt32[offset]);
            inputWords1 = swapWord(inputInt32[offset + 1]);
            inputWords2 = swapWord(inputInt32[offset + 2]);
            inputWords3 = swapWord(inputInt32[offset + 3]);
            s0 = inputWords0 ^ invKeySchedule[0];
            s1 = inputWords3 ^ invKeySchedule[1];
            s2 = inputWords2 ^ invKeySchedule[2];
            s3 = inputWords1 ^ invKeySchedule[3];
            ksRow = 4;
            // Iterate through the rounds of decryption
            for (i = 1; i < nRounds; i++) {
                t0 = invSubMix0[s0 >>> 24] ^ invSubMix1[(s1 >> 16) & 0xff] ^ invSubMix2[(s2 >> 8) & 0xff] ^ invSubMix3[s3 & 0xff] ^ invKeySchedule[ksRow];
                t1 = invSubMix0[s1 >>> 24] ^ invSubMix1[(s2 >> 16) & 0xff] ^ invSubMix2[(s3 >> 8) & 0xff] ^ invSubMix3[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
                t2 = invSubMix0[s2 >>> 24] ^ invSubMix1[(s3 >> 16) & 0xff] ^ invSubMix2[(s0 >> 8) & 0xff] ^ invSubMix3[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
                t3 = invSubMix0[s3 >>> 24] ^ invSubMix1[(s0 >> 16) & 0xff] ^ invSubMix2[(s1 >> 8) & 0xff] ^ invSubMix3[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
                // Update state
                s0 = t0;
                s1 = t1;
                s2 = t2;
                s3 = t3;
                ksRow = ksRow + 4;
            }
            // Shift rows, sub bytes, add round key
            t0 = ((invSBOX[s0 >>> 24] << 24) ^ (invSBOX[(s1 >> 16) & 0xff] << 16) ^ (invSBOX[(s2 >> 8) & 0xff] << 8) ^ invSBOX[s3 & 0xff]) ^ invKeySchedule[ksRow];
            t1 = ((invSBOX[s1 >>> 24] << 24) ^ (invSBOX[(s2 >> 16) & 0xff] << 16) ^ (invSBOX[(s3 >> 8) & 0xff] << 8) ^ invSBOX[s0 & 0xff]) ^ invKeySchedule[ksRow + 1];
            t2 = ((invSBOX[s2 >>> 24] << 24) ^ (invSBOX[(s3 >> 16) & 0xff] << 16) ^ (invSBOX[(s0 >> 8) & 0xff] << 8) ^ invSBOX[s1 & 0xff]) ^ invKeySchedule[ksRow + 2];
            t3 = ((invSBOX[s3 >>> 24] << 24) ^ (invSBOX[(s0 >> 16) & 0xff] << 16) ^ (invSBOX[(s1 >> 8) & 0xff] << 8) ^ invSBOX[s2 & 0xff]) ^ invKeySchedule[ksRow + 3];
            ksRow = ksRow + 3;
            // Write
            outputInt32[offset] = swapWord(t0 ^ initVector0);
            outputInt32[offset + 1] = swapWord(t3 ^ initVector1);
            outputInt32[offset + 2] = swapWord(t2 ^ initVector2);
            outputInt32[offset + 3] = swapWord(t1 ^ initVector3);
            // reset initVector to last 4 unsigned int
            initVector0 = inputWords0;
            initVector1 = inputWords1;
            initVector2 = inputWords2;
            initVector3 = inputWords3;
            offset = offset + 4;
        }
        return removePKCS7Padding ? removePadding(outputInt32.buffer) : outputInt32.buffer;
    };
    AESDecryptor.prototype.destroy = function () {
        this.key = undefined;
        this.keySize = undefined;
        this.ksRows = undefined;
        this.sBox = undefined;
        this.invSBox = undefined;
        this.subMix = undefined;
        this.invSubMix = undefined;
        this.keySchedule = undefined;
        this.invKeySchedule = undefined;
        this.rcon = undefined;
    };
    return AESDecryptor;
}());
exports.default = AESDecryptor;


/***/ }),

/***/ "./src/crypt/decrypter.js":
/*!********************************!*\
  !*** ./src/crypt/decrypter.js ***!
  \********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var aes_crypto_1 = __webpack_require__(/*! ./aes-crypto */ "./src/crypt/aes-crypto.js");
var fast_aes_key_1 = __webpack_require__(/*! ./fast-aes-key */ "./src/crypt/fast-aes-key.js");
var aes_decryptor_1 = __webpack_require__(/*! ./aes-decryptor */ "./src/crypt/aes-decryptor.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var get_self_scope_1 = __webpack_require__(/*! ../utils/get-self-scope */ "./src/utils/get-self-scope.js");
// see https://stackoverflow.com/a/11237259/589493
var global = get_self_scope_1.getSelfScope(); // safeguard for code that might run both on worker and main thread
var Decrypter = /** @class */ (function () {
    function Decrypter(observer, config, _a) {
        var _b = (_a === void 0 ? {} : _a).removePKCS7Padding, removePKCS7Padding = _b === void 0 ? true : _b;
        this.logEnabled = true;
        this.observer = observer;
        this.config = config;
        this.removePKCS7Padding = removePKCS7Padding;
        // built in decryptor expects PKCS7 padding
        if (removePKCS7Padding) {
            try {
                var browserCrypto = global.crypto;
                if (browserCrypto) {
                    this.subtle = browserCrypto.subtle || browserCrypto.webkitSubtle;
                }
            }
            catch (e) { }
        }
        this.disableWebCrypto = !this.subtle;
    }
    Decrypter.prototype.isSync = function () {
        return (this.disableWebCrypto && this.config.enableSoftwareAES);
    };
    Decrypter.prototype.decrypt = function (data, key, iv, callback) {
        var _this = this;
        if (this.disableWebCrypto && this.config.enableSoftwareAES) {
            if (this.logEnabled) {
                logger_1.logger.log('JS AES decrypt');
                this.logEnabled = false;
            }
            var decryptor = this.decryptor;
            if (!decryptor) {
                this.decryptor = decryptor = new aes_decryptor_1.default();
            }
            decryptor.expandKey(key);
            callback(decryptor.decrypt(data, 0, iv, this.removePKCS7Padding));
        }
        else {
            if (this.logEnabled) {
                logger_1.logger.log('WebCrypto AES decrypt');
                this.logEnabled = false;
            }
            var subtle_1 = this.subtle;
            if (this.key !== key) {
                this.key = key;
                this.fastAesKey = new fast_aes_key_1.default(subtle_1, key);
            }
            this.fastAesKey.expandKey()
                .then(function (aesKey) {
                // decrypt using web crypto
                var crypto = new aes_crypto_1.default(subtle_1, iv);
                crypto.decrypt(data, aesKey)
                    .catch(function (err) {
                    _this.onWebCryptoError(err, data, key, iv, callback);
                })
                    .then(function (result) {
                    callback(result);
                });
            })
                .catch(function (err) {
                _this.onWebCryptoError(err, data, key, iv, callback);
            });
        }
    };
    Decrypter.prototype.onWebCryptoError = function (err, data, key, iv, callback) {
        if (this.config.enableSoftwareAES) {
            logger_1.logger.log('WebCrypto Error, disable WebCrypto API');
            this.disableWebCrypto = true;
            this.logEnabled = true;
            this.decrypt(data, key, iv, callback);
        }
        else {
            logger_1.logger.error("decrypting error : " + err.message);
            this.observer.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MEDIA_ERROR, details: errors_1.ErrorDetails.FRAG_DECRYPT_ERROR, fatal: true, reason: err.message });
        }
    };
    Decrypter.prototype.destroy = function () {
        var decryptor = this.decryptor;
        if (decryptor) {
            decryptor.destroy();
            this.decryptor = undefined;
        }
    };
    return Decrypter;
}());
exports.default = Decrypter;


/***/ }),

/***/ "./src/crypt/fast-aes-key.js":
/*!***********************************!*\
  !*** ./src/crypt/fast-aes-key.js ***!
  \***********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FastAESKey = /** @class */ (function () {
    function FastAESKey(subtle, key) {
        this.subtle = subtle;
        this.key = key;
    }
    FastAESKey.prototype.expandKey = function () {
        return this.subtle.importKey('raw', this.key, { name: 'AES-CBC' }, false, ['encrypt', 'decrypt']);
    };
    return FastAESKey;
}());
exports.default = FastAESKey;


/***/ }),

/***/ "./src/demux/aacdemuxer.js":
/*!*********************************!*\
  !*** ./src/demux/aacdemuxer.js ***!
  \*********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * AAC demuxer
 */
var ADTS = __webpack_require__(/*! ./adts */ "./src/demux/adts.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var id3_1 = __webpack_require__(/*! ../demux/id3 */ "./src/demux/id3.js");
var AACDemuxer = /** @class */ (function () {
    function AACDemuxer(observer, remuxer, config) {
        this.observer = observer;
        this.config = config;
        this.remuxer = remuxer;
    }
    AACDemuxer.prototype.resetInitSegment = function (initSegment, audioCodec, videoCodec, duration) {
        this._audioTrack = { container: 'audio/adts', type: 'audio', id: 0, sequenceNumber: 0, isAAC: true, samples: [], len: 0, manifestCodec: audioCodec, duration: duration, inputTimeScale: 90000 };
    };
    AACDemuxer.prototype.resetTimeStamp = function () {
    };
    AACDemuxer.probe = function (data) {
        if (!data) {
            return false;
        }
        // Check for the ADTS sync word
        // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
        // Layer bits (position 14 and 15) in header should be always 0 for ADTS
        // More info https://wiki.multimedia.cx/index.php?title=ADTS
        var id3Data = id3_1.default.getID3Data(data, 0) || [];
        var offset = id3Data.length;
        for (var length_1 = data.length; offset < length_1; offset++) {
            if (ADTS.probe(data, offset)) {
                logger_1.logger.log('ADTS sync word found !');
                return true;
            }
        }
        return false;
    };
    // feed incoming data to the front of the parsing pipeline
    AACDemuxer.prototype.append = function (data, timeOffset, contiguous, accurateTimeOffset) {
        var track = this._audioTrack;
        var id3Data = id3_1.default.getID3Data(data, 0) || [];
        var timestamp = id3_1.default.getTimeStamp(id3Data);
        var pts = Number.isFinite(timestamp) ? timestamp * 90 : timeOffset * 90000;
        var frameIndex = 0;
        var stamp = pts;
        var length = data.length;
        var offset = id3Data.length;
        var id3Samples = [{ pts: stamp, dts: stamp, data: id3Data }];
        while (offset < length - 1) {
            if (ADTS.isHeader(data, offset) && (offset + 5) < length) {
                ADTS.initTrackConfig(track, this.observer, data, offset, track.manifestCodec);
                var frame = ADTS.appendFrame(track, data, offset, pts, frameIndex);
                if (frame) {
                    offset += frame.length;
                    stamp = frame.sample.pts;
                    frameIndex++;
                }
                else {
                    logger_1.logger.log('Unable to parse AAC frame');
                    break;
                }
            }
            else if (id3_1.default.isHeader(data, offset)) {
                id3Data = id3_1.default.getID3Data(data, offset);
                id3Samples.push({ pts: stamp, dts: stamp, data: id3Data });
                offset += id3Data.length;
            }
            else {
                // nothing found, keep looking
                offset++;
            }
        }
        this.remuxer.remux(track, { samples: [] }, { samples: id3Samples, inputTimeScale: 90000 }, { samples: [] }, timeOffset, contiguous, accurateTimeOffset);
    };
    AACDemuxer.prototype.destroy = function () {
    };
    return AACDemuxer;
}());
exports.default = AACDemuxer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/demux/adts.js":
/*!***************************!*\
  !*** ./src/demux/adts.js ***!
  \***************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 *  ADTS parser helper
 */
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
function getAudioConfig(observer, data, offset, audioCodec) {
    var adtsObjectType, // :int
    adtsSampleingIndex, // :int
    adtsExtensionSampleingIndex, // :int
    adtsChanelConfig, // :int
    config, userAgent = navigator.userAgent.toLowerCase(), manifestCodec = audioCodec, adtsSampleingRates = [
        96000, 88200,
        64000, 48000,
        44100, 32000,
        24000, 22050,
        16000, 12000,
        11025, 8000,
        7350
    ];
    // byte 2
    adtsObjectType = ((data[offset + 2] & 0xC0) >>> 6) + 1;
    adtsSampleingIndex = ((data[offset + 2] & 0x3C) >>> 2);
    if (adtsSampleingIndex > adtsSampleingRates.length - 1) {
        observer.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MEDIA_ERROR, details: errors_1.ErrorDetails.FRAG_PARSING_ERROR, fatal: true, reason: "invalid ADTS sampling index:" + adtsSampleingIndex });
        return;
    }
    adtsChanelConfig = ((data[offset + 2] & 0x01) << 2);
    // byte 3
    adtsChanelConfig |= ((data[offset + 3] & 0xC0) >>> 6);
    logger_1.logger.log("manifest codec:" + audioCodec + ",ADTS data:type:" + adtsObjectType + ",sampleingIndex:" + adtsSampleingIndex + "[" + adtsSampleingRates[adtsSampleingIndex] + "Hz],channelConfig:" + adtsChanelConfig);
    // firefox: freq less than 24kHz = AAC SBR (HE-AAC)
    if (/firefox/i.test(userAgent)) {
        if (adtsSampleingIndex >= 6) {
            adtsObjectType = 5;
            config = new Array(4);
            // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
            // there is a factor 2 between frame sample rate and output sample rate
            // multiply frequency by 2 (see table below, equivalent to substract 3)
            adtsExtensionSampleingIndex = adtsSampleingIndex - 3;
        }
        else {
            adtsObjectType = 2;
            config = new Array(2);
            adtsExtensionSampleingIndex = adtsSampleingIndex;
        }
        // Android : always use AAC
    }
    else if (userAgent.indexOf('android') !== -1) {
        adtsObjectType = 2;
        config = new Array(2);
        adtsExtensionSampleingIndex = adtsSampleingIndex;
    }
    else {
        /*  for other browsers (Chrome/Vivaldi/Opera ...)
            always force audio type to be HE-AAC SBR, as some browsers do not support audio codec switch properly (like Chrome ...)
        */
        adtsObjectType = 5;
        config = new Array(4);
        // if (manifest codec is HE-AAC or HE-AACv2) OR (manifest codec not specified AND frequency less than 24kHz)
        if ((audioCodec && ((audioCodec.indexOf('mp4a.40.29') !== -1) ||
            (audioCodec.indexOf('mp4a.40.5') !== -1))) ||
            (!audioCodec && adtsSampleingIndex >= 6)) {
            // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
            // there is a factor 2 between frame sample rate and output sample rate
            // multiply frequency by 2 (see table below, equivalent to substract 3)
            adtsExtensionSampleingIndex = adtsSampleingIndex - 3;
        }
        else {
            // if (manifest codec is AAC) AND (frequency less than 24kHz AND nb channel is 1) OR (manifest codec not specified and mono audio)
            // Chrome fails to play back with low frequency AAC LC mono when initialized with HE-AAC.  This is not a problem with stereo.
            if (audioCodec && audioCodec.indexOf('mp4a.40.2') !== -1 && ((adtsSampleingIndex >= 6 && adtsChanelConfig === 1) ||
                /vivaldi/i.test(userAgent)) ||
                (!audioCodec && adtsChanelConfig === 1)) {
                adtsObjectType = 2;
                config = new Array(2);
            }
            adtsExtensionSampleingIndex = adtsSampleingIndex;
        }
    }
    /* refer to http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio#Audio_Specific_Config
        ISO 14496-3 (AAC).pdf - Table 1.13 — Syntax of AudioSpecificConfig()
      Audio Profile / Audio Object Type
      0: Null
      1: AAC Main
      2: AAC LC (Low Complexity)
      3: AAC SSR (Scalable Sample Rate)
      4: AAC LTP (Long Term Prediction)
      5: SBR (Spectral Band Replication)
      6: AAC Scalable
     sampling freq
      0: 96000 Hz
      1: 88200 Hz
      2: 64000 Hz
      3: 48000 Hz
      4: 44100 Hz
      5: 32000 Hz
      6: 24000 Hz
      7: 22050 Hz
      8: 16000 Hz
      9: 12000 Hz
      10: 11025 Hz
      11: 8000 Hz
      12: 7350 Hz
      13: Reserved
      14: Reserved
      15: frequency is written explictly
      Channel Configurations
      These are the channel configurations:
      0: Defined in AOT Specifc Config
      1: 1 channel: front-center
      2: 2 channels: front-left, front-right
    */
    // audioObjectType = profile => profile, the MPEG-4 Audio Object Type minus 1
    config[0] = adtsObjectType << 3;
    // samplingFrequencyIndex
    config[0] |= (adtsSampleingIndex & 0x0E) >> 1;
    config[1] |= (adtsSampleingIndex & 0x01) << 7;
    // channelConfiguration
    config[1] |= adtsChanelConfig << 3;
    if (adtsObjectType === 5) {
        // adtsExtensionSampleingIndex
        config[1] |= (adtsExtensionSampleingIndex & 0x0E) >> 1;
        config[2] = (adtsExtensionSampleingIndex & 0x01) << 7;
        // adtsObjectType (force to 2, chrome is checking that object type is less than 5 ???
        //    https://chromium.googlesource.com/chromium/src.git/+/master/media/formats/mp4/aac.cc
        config[2] |= 2 << 2;
        config[3] = 0;
    }
    return { config: config, samplerate: adtsSampleingRates[adtsSampleingIndex], channelCount: adtsChanelConfig, codec: ('mp4a.40.' + adtsObjectType), manifestCodec: manifestCodec };
}
exports.getAudioConfig = getAudioConfig;
function isHeaderPattern(data, offset) {
    return data[offset] === 0xff && (data[offset + 1] & 0xf6) === 0xf0;
}
exports.isHeaderPattern = isHeaderPattern;
function getHeaderLength(data, offset) {
    return (data[offset + 1] & 0x01 ? 7 : 9);
}
exports.getHeaderLength = getHeaderLength;
function getFullFrameLength(data, offset) {
    return ((data[offset + 3] & 0x03) << 11) |
        (data[offset + 4] << 3) |
        ((data[offset + 5] & 0xE0) >>> 5);
}
exports.getFullFrameLength = getFullFrameLength;
function isHeader(data, offset) {
    // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
    // Layer bits (position 14 and 15) in header should be always 0 for ADTS
    // More info https://wiki.multimedia.cx/index.php?title=ADTS
    if (offset + 1 < data.length && isHeaderPattern(data, offset)) {
        return true;
    }
    return false;
}
exports.isHeader = isHeader;
function probe(data, offset) {
    // same as isHeader but we also check that ADTS frame follows last ADTS frame
    // or end of data is reached
    if (offset + 1 < data.length && isHeaderPattern(data, offset)) {
        // ADTS header Length
        var headerLength = getHeaderLength(data, offset);
        // ADTS frame Length
        var frameLength = headerLength;
        if (offset + 5 < data.length) {
            frameLength = getFullFrameLength(data, offset);
        }
        var newOffset = offset + frameLength;
        if (newOffset === data.length || (newOffset + 1 < data.length && isHeaderPattern(data, newOffset))) {
            return true;
        }
    }
    return false;
}
exports.probe = probe;
function initTrackConfig(track, observer, data, offset, audioCodec) {
    if (!track.samplerate) {
        var config = getAudioConfig(observer, data, offset, audioCodec);
        track.config = config.config;
        track.samplerate = config.samplerate;
        track.channelCount = config.channelCount;
        track.codec = config.codec;
        track.manifestCodec = config.manifestCodec;
        logger_1.logger.log("parsed codec:" + track.codec + ",rate:" + config.samplerate + ",nb channel:" + config.channelCount);
    }
}
exports.initTrackConfig = initTrackConfig;
function getFrameDuration(samplerate) {
    return 1024 * 90000 / samplerate;
}
exports.getFrameDuration = getFrameDuration;
function parseFrameHeader(data, offset, pts, frameIndex, frameDuration) {
    var headerLength, frameLength, stamp;
    var length = data.length;
    // The protection skip bit tells us if we have 2 bytes of CRC data at the end of the ADTS header
    headerLength = getHeaderLength(data, offset);
    // retrieve frame size
    frameLength = getFullFrameLength(data, offset);
    frameLength -= headerLength;
    if ((frameLength > 0) && ((offset + headerLength + frameLength) <= length)) {
        stamp = pts + frameIndex * frameDuration;
        // logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}/${(stamp/90).toFixed(0)}`);
        return { headerLength: headerLength, frameLength: frameLength, stamp: stamp };
    }
    return undefined;
}
exports.parseFrameHeader = parseFrameHeader;
function appendFrame(track, data, offset, pts, frameIndex) {
    var frameDuration = getFrameDuration(track.samplerate);
    var header = parseFrameHeader(data, offset, pts, frameIndex, frameDuration);
    if (header) {
        var stamp = header.stamp;
        var headerLength = header.headerLength;
        var frameLength = header.frameLength;
        // logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}/${(stamp/90).toFixed(0)}`);
        var aacSample = {
            unit: data.subarray(offset + headerLength, offset + headerLength + frameLength),
            pts: stamp,
            dts: stamp
        };
        track.samples.push(aacSample);
        track.len += frameLength;
        return { sample: aacSample, length: frameLength + headerLength };
    }
    return undefined;
}
exports.appendFrame = appendFrame;


/***/ }),

/***/ "./src/demux/demuxer-inline.js":
/*!*************************************!*\
  !*** ./src/demux/demuxer-inline.js ***!
  \*************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 *
 * inline demuxer: probe fragments and instantiate
 * appropriate demuxer depending on content type (TSDemuxer, AACDemuxer, ...)
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var decrypter_1 = __webpack_require__(/*! ../crypt/decrypter */ "./src/crypt/decrypter.js");
var aacdemuxer_1 = __webpack_require__(/*! ../demux/aacdemuxer */ "./src/demux/aacdemuxer.js");
var mp4demuxer_1 = __webpack_require__(/*! ../demux/mp4demuxer */ "./src/demux/mp4demuxer.js");
var tsdemuxer_1 = __webpack_require__(/*! ../demux/tsdemuxer */ "./src/demux/tsdemuxer.js");
var mp3demuxer_1 = __webpack_require__(/*! ../demux/mp3demuxer */ "./src/demux/mp3demuxer.js");
var mp4_remuxer_1 = __webpack_require__(/*! ../remux/mp4-remuxer */ "./src/remux/mp4-remuxer.js");
var passthrough_remuxer_1 = __webpack_require__(/*! ../remux/passthrough-remuxer */ "./src/remux/passthrough-remuxer.js");
var get_self_scope_1 = __webpack_require__(/*! ../utils/get-self-scope */ "./src/utils/get-self-scope.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
// see https://stackoverflow.com/a/11237259/589493
var global = get_self_scope_1.getSelfScope(); // safeguard for code that might run both on worker and main thread
var now;
// performance.now() not available on WebWorker, at least on Safari Desktop
try {
    now = global.performance.now.bind(global.performance);
}
catch (err) {
    logger_1.logger.debug('Unable to use Performance API on this environment');
    now = global.Date.now;
}
var DemuxerInline = /** @class */ (function () {
    function DemuxerInline(observer, typeSupported, config, vendor) {
        this.observer = observer;
        this.typeSupported = typeSupported;
        this.config = config;
        this.vendor = vendor;
    }
    DemuxerInline.prototype.destroy = function () {
        var demuxer = this.demuxer;
        if (demuxer) {
            demuxer.destroy();
        }
    };
    DemuxerInline.prototype.push = function (data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS) {
        var _this = this;
        if ((data.byteLength > 0) && (decryptdata != null) && (decryptdata.key != null) && (decryptdata.method === 'AES-128')) {
            var decrypter = this.decrypter;
            if (decrypter == null) {
                decrypter = this.decrypter = new decrypter_1.default(this.observer, this.config);
            }
            var startTime_1 = now();
            decrypter.decrypt(data, decryptdata.key.buffer, decryptdata.iv.buffer, function (decryptedData) {
                var endTime = now();
                _this.observer.trigger(events_1.default.FRAG_DECRYPTED, { stats: { tstart: startTime_1, tdecrypt: endTime } });
                _this.pushDecrypted(new Uint8Array(decryptedData), decryptdata, new Uint8Array(initSegment), audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
            });
        }
        else {
            this.pushDecrypted(new Uint8Array(data), decryptdata, new Uint8Array(initSegment), audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
        }
    };
    DemuxerInline.prototype.pushDecrypted = function (data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS) {
        var demuxer = this.demuxer;
        if (!demuxer ||
            // in case of continuity change, or track switch
            // we might switch from content type (AAC container to TS container, or TS to fmp4 for example)
            // so let's check that current demuxer is still valid
            ((discontinuity || trackSwitch) && !this.probe(data))) {
            var observer = this.observer;
            var typeSupported = this.typeSupported;
            var config = this.config;
            // probing order is TS/AAC/MP3/MP4
            var muxConfig = [
                { demux: tsdemuxer_1.default, remux: mp4_remuxer_1.default },
                { demux: mp4demuxer_1.default, remux: passthrough_remuxer_1.default },
                { demux: aacdemuxer_1.default, remux: mp4_remuxer_1.default },
                { demux: mp3demuxer_1.default, remux: mp4_remuxer_1.default }
            ];
            // probe for content type
            for (var i = 0, len = muxConfig.length; i < len; i++) {
                var mux = muxConfig[i];
                var probe = mux.demux.probe;
                if (probe(data)) {
                    var remuxer_1 = this.remuxer = new mux.remux(observer, config, typeSupported, this.vendor);
                    demuxer = new mux.demux(observer, remuxer_1, config, typeSupported);
                    this.probe = probe;
                    break;
                }
            }
            if (!demuxer) {
                observer.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MEDIA_ERROR, details: errors_1.ErrorDetails.FRAG_PARSING_ERROR, fatal: true, reason: 'no demux matching with content found' });
                return;
            }
            this.demuxer = demuxer;
        }
        var remuxer = this.remuxer;
        if (discontinuity || trackSwitch) {
            demuxer.resetInitSegment(initSegment, audioCodec, videoCodec, duration);
            remuxer.resetInitSegment();
        }
        if (discontinuity) {
            demuxer.resetTimeStamp(defaultInitPTS);
            remuxer.resetTimeStamp(defaultInitPTS);
        }
        if (typeof demuxer.setDecryptData === 'function') {
            demuxer.setDecryptData(decryptdata);
        }
        demuxer.append(data, timeOffset, contiguous, accurateTimeOffset);
    };
    return DemuxerInline;
}());
exports.default = DemuxerInline;


/***/ }),

/***/ "./src/demux/demuxer-worker.js":
/*!*************************************!*\
  !*** ./src/demux/demuxer-worker.js ***!
  \*************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* demuxer web worker.
 *  - listen to worker message, and trigger DemuxerInline upon reception of Fragments.
 *  - provides MP4 Boxes back to main thread using [transferable objects](https://developers.google.com/web/updates/2011/12/Transferable-Objects-Lightning-Fast) in order to minimize message passing overhead.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var demuxer_inline_1 = __webpack_require__(/*! ../demux/demuxer-inline */ "./src/demux/demuxer-inline.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var events_2 = __webpack_require__(/*! events */ "./node_modules/node-libs-browser/node_modules/events/events.js");
var DemuxerWorker = function (self) {
    // observer setup
    var observer = new events_2.EventEmitter();
    observer.trigger = function trigger(event) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        observer.emit.apply(observer, [event, event].concat(data));
    };
    observer.off = function off(event) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        observer.removeListener.apply(observer, [event].concat(data));
    };
    var forwardMessage = function (ev, data) {
        self.postMessage({ event: ev, data: data });
    };
    self.addEventListener('message', function (ev) {
        var data = ev.data;
        // console.log('demuxer cmd:' + data.cmd);
        switch (data.cmd) {
            case 'init':
                var config = JSON.parse(data.config);
                self.demuxer = new demuxer_inline_1.default(observer, data.typeSupported, config, data.vendor);
                logger_1.enableLogs(config.debug);
                // signal end of worker init
                forwardMessage('init', null);
                break;
            case 'demux':
                self.demuxer.push(data.data, data.decryptdata, data.initSegment, data.audioCodec, data.videoCodec, data.timeOffset, data.discontinuity, data.trackSwitch, data.contiguous, data.duration, data.accurateTimeOffset, data.defaultInitPTS);
                break;
            default:
                break;
        }
    });
    // forward events to main thread
    observer.on(events_1.default.FRAG_DECRYPTED, forwardMessage);
    observer.on(events_1.default.FRAG_PARSING_INIT_SEGMENT, forwardMessage);
    observer.on(events_1.default.FRAG_PARSED, forwardMessage);
    observer.on(events_1.default.ERROR, forwardMessage);
    observer.on(events_1.default.FRAG_PARSING_METADATA, forwardMessage);
    observer.on(events_1.default.FRAG_PARSING_USERDATA, forwardMessage);
    observer.on(events_1.default.INIT_PTS_FOUND, forwardMessage);
    // special case for FRAG_PARSING_DATA: pass data1/data2 as transferable object (no copy)
    observer.on(events_1.default.FRAG_PARSING_DATA, function (ev, data) {
        var transferable = [];
        var message = { event: ev, data: data };
        if (data.data1) {
            message.data1 = data.data1.buffer;
            transferable.push(data.data1.buffer);
            delete data.data1;
        }
        if (data.data2) {
            message.data2 = data.data2.buffer;
            transferable.push(data.data2.buffer);
            delete data.data2;
        }
        self.postMessage(message, transferable);
    });
};
exports.default = DemuxerWorker;


/***/ }),

/***/ "./src/demux/demuxer.js":
/*!******************************!*\
  !*** ./src/demux/demuxer.js ***!
  \******************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
Object.defineProperty(exports, "__esModule", { value: true });
var work = __webpack_require__(/*! webworkify-webpack */ "./node_modules/webworkify-webpack/index.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var demuxer_inline_1 = __webpack_require__(/*! ../demux/demuxer-inline */ "./src/demux/demuxer-inline.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var mediasource_helper_1 = __webpack_require__(/*! ../utils/mediasource-helper */ "./src/utils/mediasource-helper.js");
var get_self_scope_1 = __webpack_require__(/*! ../utils/get-self-scope */ "./src/utils/get-self-scope.js");
var observer_1 = __webpack_require__(/*! ../observer */ "./src/observer.js");
// see https://stackoverflow.com/a/11237259/589493
var global = get_self_scope_1.getSelfScope(); // safeguard for code that might run both on worker and main thread
var MediaSource = mediasource_helper_1.getMediaSource();
var Demuxer = /** @class */ (function () {
    function Demuxer(hls, id) {
        var _this = this;
        this.hls = hls;
        this.id = id;
        var observer = this.observer = new observer_1.Observer();
        var config = hls.config;
        var forwardMessage = function (ev, data) {
            data = data || {};
            data.frag = _this.frag;
            data.id = _this.id;
            hls.trigger(ev, data);
        };
        // forward events to main thread
        observer.on(events_1.default.FRAG_DECRYPTED, forwardMessage);
        observer.on(events_1.default.FRAG_PARSING_INIT_SEGMENT, forwardMessage);
        observer.on(events_1.default.FRAG_PARSING_DATA, forwardMessage);
        observer.on(events_1.default.FRAG_PARSED, forwardMessage);
        observer.on(events_1.default.ERROR, forwardMessage);
        observer.on(events_1.default.FRAG_PARSING_METADATA, forwardMessage);
        observer.on(events_1.default.FRAG_PARSING_USERDATA, forwardMessage);
        observer.on(events_1.default.INIT_PTS_FOUND, forwardMessage);
        var typeSupported = {
            mp4: MediaSource.isTypeSupported('video/mp4'),
            mpeg: MediaSource.isTypeSupported('audio/mpeg'),
            mp3: MediaSource.isTypeSupported('audio/mp4; codecs="mp3"')
        };
        // navigator.vendor is not always available in Web Worker
        // refer to https://developer.mozilla.org/en-US/docs/Web/API/WorkerGlobalScope/navigator
        var vendor = navigator.vendor;
        if (config.enableWorker && (typeof (Worker) !== 'undefined')) {
            logger_1.logger.log('demuxing in webworker');
            var w = void 0;
            try {
                w = this.w = work(/*require.resolve*/(/*! ../demux/demuxer-worker.js */ "./src/demux/demuxer-worker.js"));
                this.onwmsg = this.onWorkerMessage.bind(this);
                w.addEventListener('message', this.onwmsg);
                w.onerror = function (event) {
                    hls.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.OTHER_ERROR, details: errors_1.ErrorDetails.INTERNAL_EXCEPTION, fatal: true, event: 'demuxerWorker', err: { message: event.message + ' (' + event.filename + ':' + event.lineno + ')' } });
                };
                w.postMessage({ cmd: 'init', typeSupported: typeSupported, vendor: vendor, id: id, config: JSON.stringify(config) });
            }
            catch (err) {
                logger_1.logger.warn('Error in worker:', err);
                logger_1.logger.error('Error while initializing DemuxerWorker, fallback on DemuxerInline');
                if (w) {
                    // revoke the Object URL that was used to create demuxer worker, so as not to leak it
                    global.URL.revokeObjectURL(w.objectURL);
                }
                this.demuxer = new demuxer_inline_1.default(observer, typeSupported, config, vendor);
                this.w = undefined;
            }
        }
        else {
            this.demuxer = new demuxer_inline_1.default(observer, typeSupported, config, vendor);
        }
    }
    Demuxer.prototype.destroy = function () {
        var w = this.w;
        if (w) {
            w.removeEventListener('message', this.onwmsg);
            w.terminate();
            this.w = null;
        }
        else {
            var demuxer = this.demuxer;
            if (demuxer) {
                demuxer.destroy();
                this.demuxer = null;
            }
        }
        var observer = this.observer;
        if (observer) {
            observer.removeAllListeners();
            this.observer = null;
        }
    };
    Demuxer.prototype.push = function (data, initSegment, audioCodec, videoCodec, frag, duration, accurateTimeOffset, defaultInitPTS) {
        var w = this.w;
        var timeOffset = Number.isFinite(frag.startPTS) ? frag.startPTS : frag.start;
        var decryptdata = frag.decryptdata;
        var lastFrag = this.frag;
        var discontinuity = !(lastFrag && (frag.cc === lastFrag.cc));
        var trackSwitch = !(lastFrag && (frag.level === lastFrag.level));
        var nextSN = lastFrag && (frag.sn === (lastFrag.sn + 1));
        var contiguous = !trackSwitch && nextSN;
        if (discontinuity) {
            logger_1.logger.log(this.id + ":discontinuity detected");
        }
        if (trackSwitch) {
            logger_1.logger.log(this.id + ":switch detected");
        }
        this.frag = frag;
        if (w) {
            // post fragment payload as transferable objects for ArrayBuffer (no copy)
            w.postMessage({ cmd: 'demux', data: data, decryptdata: decryptdata, initSegment: initSegment, audioCodec: audioCodec, videoCodec: videoCodec, timeOffset: timeOffset, discontinuity: discontinuity, trackSwitch: trackSwitch, contiguous: contiguous, duration: duration, accurateTimeOffset: accurateTimeOffset, defaultInitPTS: defaultInitPTS }, data instanceof ArrayBuffer ? [data] : []);
        }
        else {
            var demuxer = this.demuxer;
            if (demuxer) {
                demuxer.push(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
            }
        }
    };
    Demuxer.prototype.onWorkerMessage = function (ev) {
        var data = ev.data, hls = this.hls;
        switch (data.event) {
            case 'init':
                // revoke the Object URL that was used to create demuxer worker, so as not to leak it
                global.URL.revokeObjectURL(this.w.objectURL);
                break;
            // special case for FRAG_PARSING_DATA: data1 and data2 are transferable objects
            case events_1.default.FRAG_PARSING_DATA:
                data.data.data1 = new Uint8Array(data.data1);
                if (data.data2) {
                    data.data.data2 = new Uint8Array(data.data2);
                }
            /* falls through */
            default:
                data.data = data.data || {};
                data.data.frag = this.frag;
                data.data.id = this.id;
                hls.trigger(data.event, data.data);
                break;
        }
    };
    return Demuxer;
}());
exports.default = Demuxer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/demux/exp-golomb.js":
/*!*********************************!*\
  !*** ./src/demux/exp-golomb.js ***!
  \*********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Parser for exponential Golomb codes, a variable-bitwidth number encoding scheme used by h264.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var ExpGolomb = /** @class */ (function () {
    function ExpGolomb(data) {
        this.data = data;
        // the number of bytes left to examine in this.data
        this.bytesAvailable = data.byteLength;
        // the current word being examined
        this.word = 0; // :uint
        // the number of bits left to examine in the current word
        this.bitsAvailable = 0; // :uint
    }
    // ():void
    ExpGolomb.prototype.loadWord = function () {
        var data = this.data, bytesAvailable = this.bytesAvailable, position = data.byteLength - bytesAvailable, workingBytes = new Uint8Array(4), availableBytes = Math.min(4, bytesAvailable);
        if (availableBytes === 0) {
            throw new Error('no bytes available');
        }
        workingBytes.set(data.subarray(position, position + availableBytes));
        this.word = new DataView(workingBytes.buffer).getUint32(0);
        // track the amount of this.data that has been processed
        this.bitsAvailable = availableBytes * 8;
        this.bytesAvailable -= availableBytes;
    };
    // (count:int):void
    ExpGolomb.prototype.skipBits = function (count) {
        var skipBytes; // :int
        if (this.bitsAvailable > count) {
            this.word <<= count;
            this.bitsAvailable -= count;
        }
        else {
            count -= this.bitsAvailable;
            skipBytes = count >> 3;
            count -= (skipBytes >> 3);
            this.bytesAvailable -= skipBytes;
            this.loadWord();
            this.word <<= count;
            this.bitsAvailable -= count;
        }
    };
    // (size:int):uint
    ExpGolomb.prototype.readBits = function (size) {
        var bits = Math.min(this.bitsAvailable, size), // :uint
        valu = this.word >>> (32 - bits); // :uint
        if (size > 32) {
            logger_1.logger.error('Cannot read more than 32 bits at a time');
        }
        this.bitsAvailable -= bits;
        if (this.bitsAvailable > 0) {
            this.word <<= bits;
        }
        else if (this.bytesAvailable > 0) {
            this.loadWord();
        }
        bits = size - bits;
        if (bits > 0 && this.bitsAvailable) {
            return valu << bits | this.readBits(bits);
        }
        else {
            return valu;
        }
    };
    // ():uint
    ExpGolomb.prototype.skipLZ = function () {
        var leadingZeroCount; // :uint
        for (leadingZeroCount = 0; leadingZeroCount < this.bitsAvailable; ++leadingZeroCount) {
            if ((this.word & (0x80000000 >>> leadingZeroCount)) !== 0) {
                // the first bit of working word is 1
                this.word <<= leadingZeroCount;
                this.bitsAvailable -= leadingZeroCount;
                return leadingZeroCount;
            }
        }
        // we exhausted word and still have not found a 1
        this.loadWord();
        return leadingZeroCount + this.skipLZ();
    };
    // ():void
    ExpGolomb.prototype.skipUEG = function () {
        this.skipBits(1 + this.skipLZ());
    };
    // ():void
    ExpGolomb.prototype.skipEG = function () {
        this.skipBits(1 + this.skipLZ());
    };
    // ():uint
    ExpGolomb.prototype.readUEG = function () {
        var clz = this.skipLZ(); // :uint
        return this.readBits(clz + 1) - 1;
    };
    // ():int
    ExpGolomb.prototype.readEG = function () {
        var valu = this.readUEG(); // :int
        if (0x01 & valu) {
            // the number is odd if the low order bit is set
            return (1 + valu) >>> 1; // add 1 to make it even, and divide by 2
        }
        else {
            return -1 * (valu >>> 1); // divide by two then make it negative
        }
    };
    // Some convenience functions
    // :Boolean
    ExpGolomb.prototype.readBoolean = function () {
        return this.readBits(1) === 1;
    };
    // ():int
    ExpGolomb.prototype.readUByte = function () {
        return this.readBits(8);
    };
    // ():int
    ExpGolomb.prototype.readUShort = function () {
        return this.readBits(16);
    };
    // ():int
    ExpGolomb.prototype.readUInt = function () {
        return this.readBits(32);
    };
    /**
     * Advance the ExpGolomb decoder past a scaling list. The scaling
     * list is optionally transmitted as part of a sequence parameter
     * set and is not relevant to transmuxing.
     * @param count {number} the number of entries in this scaling list
     * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
     */
    ExpGolomb.prototype.skipScalingList = function (count) {
        var lastScale = 8, nextScale = 8, j, deltaScale;
        for (j = 0; j < count; j++) {
            if (nextScale !== 0) {
                deltaScale = this.readEG();
                nextScale = (lastScale + deltaScale + 256) % 256;
            }
            lastScale = (nextScale === 0) ? lastScale : nextScale;
        }
    };
    /**
     * Read a sequence parameter set and return some interesting video
     * properties. A sequence parameter set is the H264 metadata that
     * describes the properties of upcoming video frames.
     * @param data {Uint8Array} the bytes of a sequence parameter set
     * @return {object} an object with configuration parsed from the
     * sequence parameter set, including the dimensions of the
     * associated video frames.
     */
    ExpGolomb.prototype.readSPS = function () {
        var frameCropLeftOffset = 0, frameCropRightOffset = 0, frameCropTopOffset = 0, frameCropBottomOffset = 0, profileIdc, profileCompat, levelIdc, numRefFramesInPicOrderCntCycle, picWidthInMbsMinus1, picHeightInMapUnitsMinus1, frameMbsOnlyFlag, scalingListCount, i, readUByte = this.readUByte.bind(this), readBits = this.readBits.bind(this), readUEG = this.readUEG.bind(this), readBoolean = this.readBoolean.bind(this), skipBits = this.skipBits.bind(this), skipEG = this.skipEG.bind(this), skipUEG = this.skipUEG.bind(this), skipScalingList = this.skipScalingList.bind(this);
        readUByte();
        profileIdc = readUByte(); // profile_idc
        profileCompat = readBits(5); // constraint_set[0-4]_flag, u(5)
        skipBits(3); // reserved_zero_3bits u(3),
        levelIdc = readUByte(); // level_idc u(8)
        skipUEG(); // seq_parameter_set_id
        // some profiles have more optional data we don't need
        if (profileIdc === 100 ||
            profileIdc === 110 ||
            profileIdc === 122 ||
            profileIdc === 244 ||
            profileIdc === 44 ||
            profileIdc === 83 ||
            profileIdc === 86 ||
            profileIdc === 118 ||
            profileIdc === 128) {
            var chromaFormatIdc = readUEG();
            if (chromaFormatIdc === 3) {
                skipBits(1);
            } // separate_colour_plane_flag
            skipUEG(); // bit_depth_luma_minus8
            skipUEG(); // bit_depth_chroma_minus8
            skipBits(1); // qpprime_y_zero_transform_bypass_flag
            if (readBoolean()) { // seq_scaling_matrix_present_flag
                scalingListCount = (chromaFormatIdc !== 3) ? 8 : 12;
                for (i = 0; i < scalingListCount; i++) {
                    if (readBoolean()) { // seq_scaling_list_present_flag[ i ]
                        if (i < 6) {
                            skipScalingList(16);
                        }
                        else {
                            skipScalingList(64);
                        }
                    }
                }
            }
        }
        skipUEG(); // log2_max_frame_num_minus4
        var picOrderCntType = readUEG();
        if (picOrderCntType === 0) {
            readUEG(); // log2_max_pic_order_cnt_lsb_minus4
        }
        else if (picOrderCntType === 1) {
            skipBits(1); // delta_pic_order_always_zero_flag
            skipEG(); // offset_for_non_ref_pic
            skipEG(); // offset_for_top_to_bottom_field
            numRefFramesInPicOrderCntCycle = readUEG();
            for (i = 0; i < numRefFramesInPicOrderCntCycle; i++) {
                skipEG();
            } // offset_for_ref_frame[ i ]
        }
        skipUEG(); // max_num_ref_frames
        skipBits(1); // gaps_in_frame_num_value_allowed_flag
        picWidthInMbsMinus1 = readUEG();
        picHeightInMapUnitsMinus1 = readUEG();
        frameMbsOnlyFlag = readBits(1);
        if (frameMbsOnlyFlag === 0) {
            skipBits(1);
        } // mb_adaptive_frame_field_flag
        skipBits(1); // direct_8x8_inference_flag
        if (readBoolean()) { // frame_cropping_flag
            frameCropLeftOffset = readUEG();
            frameCropRightOffset = readUEG();
            frameCropTopOffset = readUEG();
            frameCropBottomOffset = readUEG();
        }
        var pixelRatio = [1, 1];
        if (readBoolean()) {
            // vui_parameters_present_flag
            if (readBoolean()) {
                // aspect_ratio_info_present_flag
                var aspectRatioIdc = readUByte();
                switch (aspectRatioIdc) {
                    case 1:
                        pixelRatio = [1, 1];
                        break;
                    case 2:
                        pixelRatio = [12, 11];
                        break;
                    case 3:
                        pixelRatio = [10, 11];
                        break;
                    case 4:
                        pixelRatio = [16, 11];
                        break;
                    case 5:
                        pixelRatio = [40, 33];
                        break;
                    case 6:
                        pixelRatio = [24, 11];
                        break;
                    case 7:
                        pixelRatio = [20, 11];
                        break;
                    case 8:
                        pixelRatio = [32, 11];
                        break;
                    case 9:
                        pixelRatio = [80, 33];
                        break;
                    case 10:
                        pixelRatio = [18, 11];
                        break;
                    case 11:
                        pixelRatio = [15, 11];
                        break;
                    case 12:
                        pixelRatio = [64, 33];
                        break;
                    case 13:
                        pixelRatio = [160, 99];
                        break;
                    case 14:
                        pixelRatio = [4, 3];
                        break;
                    case 15:
                        pixelRatio = [3, 2];
                        break;
                    case 16:
                        pixelRatio = [2, 1];
                        break;
                    case 255: {
                        pixelRatio = [readUByte() << 8 | readUByte(), readUByte() << 8 | readUByte()];
                        break;
                    }
                }
            }
        }
        return {
            width: Math.ceil((((picWidthInMbsMinus1 + 1) * 16) - frameCropLeftOffset * 2 - frameCropRightOffset * 2)),
            height: ((2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16) - ((frameMbsOnlyFlag ? 2 : 4) * (frameCropTopOffset + frameCropBottomOffset)),
            pixelRatio: pixelRatio
        };
    };
    ExpGolomb.prototype.readSliceType = function () {
        // skip NALu type
        this.readUByte();
        // discard first_mb_in_slice
        this.readUEG();
        // return slice_type
        return this.readUEG();
    };
    return ExpGolomb;
}());
exports.default = ExpGolomb;


/***/ }),

/***/ "./src/demux/id3.js":
/*!**************************!*\
  !*** ./src/demux/id3.js ***!
  \**************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * ID3 parser
 */
var ID3 = /** @class */ (function () {
    function ID3() {
    }
    /**
     * Returns true if an ID3 header can be found at offset in data
     * @param {Uint8Array} data - The data to search in
     * @param {number} offset - The offset at which to start searching
     * @return {boolean} - True if an ID3 header is found
     */
    ID3.isHeader = function (data, offset) {
        /*
        * http://id3.org/id3v2.3.0
        * [0]     = 'I'
        * [1]     = 'D'
        * [2]     = '3'
        * [3,4]   = {Version}
        * [5]     = {Flags}
        * [6-9]   = {ID3 Size}
        *
        * An ID3v2 tag can be detected with the following pattern:
        *  $49 44 33 yy yy xx zz zz zz zz
        * Where yy is less than $FF, xx is the 'flags' byte and zz is less than $80
        */
        if (offset + 10 <= data.length) {
            // look for 'ID3' identifier
            if (data[offset] === 0x49 && data[offset + 1] === 0x44 && data[offset + 2] === 0x33) {
                // check version is within range
                if (data[offset + 3] < 0xFF && data[offset + 4] < 0xFF) {
                    // check size is within range
                    if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) {
                        return true;
                    }
                }
            }
        }
        return false;
    };
    /**
     * Returns true if an ID3 footer can be found at offset in data
     * @param {Uint8Array} data - The data to search in
     * @param {number} offset - The offset at which to start searching
     * @return {boolean} - True if an ID3 footer is found
     */
    ID3.isFooter = function (data, offset) {
        /*
        * The footer is a copy of the header, but with a different identifier
        */
        if (offset + 10 <= data.length) {
            // look for '3DI' identifier
            if (data[offset] === 0x33 && data[offset + 1] === 0x44 && data[offset + 2] === 0x49) {
                // check version is within range
                if (data[offset + 3] < 0xFF && data[offset + 4] < 0xFF) {
                    // check size is within range
                    if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) {
                        return true;
                    }
                }
            }
        }
        return false;
    };
    /**
     * Returns any adjacent ID3 tags found in data starting at offset, as one block of data
     * @param {Uint8Array} data - The data to search in
     * @param {number} offset - The offset at which to start searching
     * @return {Uint8Array} - The block of data containing any ID3 tags found
     */
    ID3.getID3Data = function (data, offset) {
        var front = offset;
        var length = 0;
        while (ID3.isHeader(data, offset)) {
            // ID3 header is 10 bytes
            length += 10;
            var size = ID3._readSize(data, offset + 6);
            length += size;
            if (ID3.isFooter(data, offset + 10)) {
                // ID3 footer is 10 bytes
                length += 10;
            }
            offset += length;
        }
        if (length > 0) {
            return data.subarray(front, front + length);
        }
        return undefined;
    };
    ID3._readSize = function (data, offset) {
        var size = 0;
        size = ((data[offset] & 0x7f) << 21);
        size |= ((data[offset + 1] & 0x7f) << 14);
        size |= ((data[offset + 2] & 0x7f) << 7);
        size |= (data[offset + 3] & 0x7f);
        return size;
    };
    /**
     * Searches for the Elementary Stream timestamp found in the ID3 data chunk
     * @param {Uint8Array} data - Block of data containing one or more ID3 tags
     * @return {number} - The timestamp
     */
    ID3.getTimeStamp = function (data) {
        var frames = ID3.getID3Frames(data);
        for (var i = 0; i < frames.length; i++) {
            var frame = frames[i];
            if (ID3.isTimeStampFrame(frame)) {
                return ID3._readTimeStamp(frame);
            }
        }
        return undefined;
    };
    /**
     * Returns true if the ID3 frame is an Elementary Stream timestamp frame
     * @param {ID3 frame} frame
     */
    ID3.isTimeStampFrame = function (frame) {
        return (frame && frame.key === 'PRIV' && frame.info === 'com.apple.streaming.transportStreamTimestamp');
    };
    ID3._getFrameData = function (data) {
        /*
        Frame ID       $xx xx xx xx (four characters)
        Size           $xx xx xx xx
        Flags          $xx xx
        */
        var type = String.fromCharCode(data[0], data[1], data[2], data[3]);
        var size = ID3._readSize(data, 4);
        // skip frame id, size, and flags
        var offset = 10;
        return { type: type, size: size, data: data.subarray(offset, offset + size) };
    };
    /**
     * Returns an array of ID3 frames found in all the ID3 tags in the id3Data
     * @param {Uint8Array} id3Data - The ID3 data containing one or more ID3 tags
     * @return {ID3 frame[]} - Array of ID3 frame objects
     */
    ID3.getID3Frames = function (id3Data) {
        var offset = 0;
        var frames = [];
        while (ID3.isHeader(id3Data, offset)) {
            var size = ID3._readSize(id3Data, offset + 6);
            // skip past ID3 header
            offset += 10;
            var end = offset + size;
            // loop through frames in the ID3 tag
            while (offset + 8 < end) {
                var frameData = ID3._getFrameData(id3Data.subarray(offset));
                var frame = ID3._decodeFrame(frameData);
                if (frame) {
                    frames.push(frame);
                }
                // skip frame header and frame data
                offset += frameData.size + 10;
            }
            if (ID3.isFooter(id3Data, offset)) {
                offset += 10;
            }
        }
        return frames;
    };
    ID3._decodeFrame = function (frame) {
        if (frame.type === 'PRIV') {
            return ID3._decodePrivFrame(frame);
        }
        else if (frame.type[0] === 'T') {
            return ID3._decodeTextFrame(frame);
        }
        else if (frame.type[0] === 'W') {
            return ID3._decodeURLFrame(frame);
        }
        return undefined;
    };
    ID3._readTimeStamp = function (timeStampFrame) {
        if (timeStampFrame.data.byteLength === 8) {
            var data = new Uint8Array(timeStampFrame.data);
            // timestamp is 33 bit expressed as a big-endian eight-octet number,
            // with the upper 31 bits set to zero.
            var pts33Bit = data[3] & 0x1;
            var timestamp = (data[4] << 23) +
                (data[5] << 15) +
                (data[6] << 7) +
                data[7];
            timestamp /= 45;
            if (pts33Bit) {
                timestamp += 47721858.84;
            } // 2^32 / 90
            return Math.round(timestamp);
        }
        return undefined;
    };
    ID3._decodePrivFrame = function (frame) {
        /*
        Format: <text string>\0<binary data>
        */
        if (frame.size < 2) {
            return undefined;
        }
        var owner = ID3._utf8ArrayToStr(frame.data, true);
        var privateData = new Uint8Array(frame.data.subarray(owner.length + 1));
        return { key: frame.type, info: owner, data: privateData.buffer };
    };
    ID3._decodeTextFrame = function (frame) {
        if (frame.size < 2) {
            return undefined;
        }
        if (frame.type === 'TXXX') {
            /*
            Format:
            [0]   = {Text Encoding}
            [1-?] = {Description}\0{Value}
            */
            var index = 1;
            var description = ID3._utf8ArrayToStr(frame.data.subarray(index));
            index += description.length + 1;
            var value = ID3._utf8ArrayToStr(frame.data.subarray(index));
            return { key: frame.type, info: description, data: value };
        }
        else {
            /*
            Format:
            [0]   = {Text Encoding}
            [1-?] = {Value}
            */
            var text = ID3._utf8ArrayToStr(frame.data.subarray(1));
            return { key: frame.type, data: text };
        }
    };
    ID3._decodeURLFrame = function (frame) {
        if (frame.type === 'WXXX') {
            /*
            Format:
            [0]   = {Text Encoding}
            [1-?] = {Description}\0{URL}
            */
            if (frame.size < 2) {
                return undefined;
            }
            var index = 1;
            var description = ID3._utf8ArrayToStr(frame.data.subarray(index));
            index += description.length + 1;
            var value = ID3._utf8ArrayToStr(frame.data.subarray(index));
            return { key: frame.type, info: description, data: value };
        }
        else {
            /*
            Format:
            [0-?] = {URL}
            */
            var url = ID3._utf8ArrayToStr(frame.data);
            return { key: frame.type, data: url };
        }
    };
    // http://stackoverflow.com/questions/8936984/uint8array-to-string-in-javascript/22373197
    // http://www.onicos.com/staff/iz/amuse/javascript/expert/utf.txt
    /* utf.js - UTF-8 <=> UTF-16 convertion
     *
     * Copyright (C) 1999 Masanao Izumo <iz@onicos.co.jp>
     * Version: 1.0
     * LastModified: Dec 25 1999
     * This library is free.  You can redistribute it and/or modify it.
     */
    ID3._utf8ArrayToStr = function (array, exitOnNull) {
        if (exitOnNull === void 0) { exitOnNull = false; }
        var len = array.length;
        var c;
        var char2;
        var char3;
        var out = '';
        var i = 0;
        while (i < len) {
            c = array[i++];
            if (c === 0x00 && exitOnNull) {
                return out;
            }
            else if (c === 0x00 || c === 0x03) {
                // If the character is 3 (END_OF_TEXT) or 0 (NULL) then skip it
                continue;
            }
            switch (c >> 4) {
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                    // 0xxxxxxx
                    out += String.fromCharCode(c);
                    break;
                case 12:
                case 13:
                    // 110x xxxx   10xx xxxx
                    char2 = array[i++];
                    out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
                    break;
                case 14:
                    // 1110 xxxx  10xx xxxx  10xx xxxx
                    char2 = array[i++];
                    char3 = array[i++];
                    out += String.fromCharCode(((c & 0x0F) << 12) |
                        ((char2 & 0x3F) << 6) |
                        ((char3 & 0x3F) << 0));
                    break;
                default:
            }
        }
        return out;
    };
    return ID3;
}());
var utf8ArrayToStr = ID3._utf8ArrayToStr;
exports.utf8ArrayToStr = utf8ArrayToStr;
exports.default = ID3;


/***/ }),

/***/ "./src/demux/mp3demuxer.js":
/*!*********************************!*\
  !*** ./src/demux/mp3demuxer.js ***!
  \*********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * MP3 demuxer
 */
var id3_1 = __webpack_require__(/*! ../demux/id3 */ "./src/demux/id3.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var mpegaudio_1 = __webpack_require__(/*! ./mpegaudio */ "./src/demux/mpegaudio.js");
var MP3Demuxer = /** @class */ (function () {
    function MP3Demuxer(observer, remuxer, config) {
        this.observer = observer;
        this.config = config;
        this.remuxer = remuxer;
    }
    MP3Demuxer.prototype.resetInitSegment = function (initSegment, audioCodec, videoCodec, duration) {
        this._audioTrack = { container: 'audio/mpeg', type: 'audio', id: -1, sequenceNumber: 0, isAAC: false, samples: [], len: 0, manifestCodec: audioCodec, duration: duration, inputTimeScale: 90000 };
    };
    MP3Demuxer.prototype.resetTimeStamp = function () {
    };
    MP3Demuxer.probe = function (data) {
        // check if data contains ID3 timestamp and MPEG sync word
        var offset, length;
        var id3Data = id3_1.default.getID3Data(data, 0);
        if (id3Data && id3_1.default.getTimeStamp(id3Data) !== undefined) {
            // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
            // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
            // More info http://www.mp3-tech.org/programmer/frame_header.html
            for (offset = id3Data.length, length = Math.min(data.length - 1, offset + 100); offset < length; offset++) {
                if (mpegaudio_1.default.probe(data, offset)) {
                    logger_1.logger.log('MPEG Audio sync word found !');
                    return true;
                }
            }
        }
        return false;
    };
    // feed incoming data to the front of the parsing pipeline
    MP3Demuxer.prototype.append = function (data, timeOffset, contiguous, accurateTimeOffset) {
        var id3Data = id3_1.default.getID3Data(data, 0);
        var timestamp = id3_1.default.getTimeStamp(id3Data);
        var pts = timestamp ? 90 * timestamp : timeOffset * 90000;
        var offset = id3Data.length;
        var length = data.length;
        var frameIndex = 0, stamp = 0;
        var track = this._audioTrack;
        var id3Samples = [{ pts: pts, dts: pts, data: id3Data }];
        while (offset < length) {
            if (mpegaudio_1.default.isHeader(data, offset)) {
                var frame = mpegaudio_1.default.appendFrame(track, data, offset, pts, frameIndex);
                if (frame) {
                    offset += frame.length;
                    stamp = frame.sample.pts;
                    frameIndex++;
                }
                else {
                    // logger.log('Unable to parse Mpeg audio frame');
                    break;
                }
            }
            else if (id3_1.default.isHeader(data, offset)) {
                id3Data = id3_1.default.getID3Data(data, offset);
                id3Samples.push({ pts: stamp, dts: stamp, data: id3Data });
                offset += id3Data.length;
            }
            else {
                // nothing found, keep looking
                offset++;
            }
        }
        this.remuxer.remux(track, { samples: [] }, { samples: id3Samples, inputTimeScale: 90000 }, { samples: [] }, timeOffset, contiguous, accurateTimeOffset);
    };
    MP3Demuxer.prototype.destroy = function () {
    };
    return MP3Demuxer;
}());
exports.default = MP3Demuxer;


/***/ }),

/***/ "./src/demux/mp4demuxer.js":
/*!*********************************!*\
  !*** ./src/demux/mp4demuxer.js ***!
  \*********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * MP4 demuxer
 */
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var UINT32_MAX = Math.pow(2, 32) - 1;
var MP4Demuxer = /** @class */ (function () {
    function MP4Demuxer(observer, remuxer) {
        this.observer = observer;
        this.remuxer = remuxer;
    }
    MP4Demuxer.prototype.resetTimeStamp = function (initPTS) {
        this.initPTS = initPTS;
    };
    MP4Demuxer.prototype.resetInitSegment = function (initSegment, audioCodec, videoCodec, duration) {
        // jshint unused:false
        if (initSegment && initSegment.byteLength) {
            var initData = this.initData = MP4Demuxer.parseInitSegment(initSegment);
            // default audio codec if nothing specified
            // TODO : extract that from initsegment
            if (audioCodec == null) {
                audioCodec = 'mp4a.40.5';
            }
            if (videoCodec == null) {
                videoCodec = 'avc1.42e01e';
            }
            var tracks = {};
            if (initData.audio && initData.video) {
                tracks.audiovideo = { container: 'video/mp4', codec: audioCodec + ',' + videoCodec, initSegment: duration ? initSegment : null };
            }
            else {
                if (initData.audio) {
                    tracks.audio = { container: 'audio/mp4', codec: audioCodec, initSegment: duration ? initSegment : null };
                }
                if (initData.video) {
                    tracks.video = { container: 'video/mp4', codec: videoCodec, initSegment: duration ? initSegment : null };
                }
            }
            this.observer.trigger(events_1.default.FRAG_PARSING_INIT_SEGMENT, { tracks: tracks });
        }
        else {
            if (audioCodec) {
                this.audioCodec = audioCodec;
            }
            if (videoCodec) {
                this.videoCodec = videoCodec;
            }
        }
    };
    MP4Demuxer.probe = function (data) {
        // ensure we find a moof box in the first 16 kB
        return MP4Demuxer.findBox({ data: data, start: 0, end: Math.min(data.length, 16384) }, ['moof']).length > 0;
    };
    MP4Demuxer.bin2str = function (buffer) {
        return String.fromCharCode.apply(null, buffer);
    };
    MP4Demuxer.readUint16 = function (buffer, offset) {
        if (buffer.data) {
            offset += buffer.start;
            buffer = buffer.data;
        }
        var val = buffer[offset] << 8 |
            buffer[offset + 1];
        return val < 0 ? 65536 + val : val;
    };
    MP4Demuxer.readUint32 = function (buffer, offset) {
        if (buffer.data) {
            offset += buffer.start;
            buffer = buffer.data;
        }
        var val = buffer[offset] << 24 |
            buffer[offset + 1] << 16 |
            buffer[offset + 2] << 8 |
            buffer[offset + 3];
        return val < 0 ? 4294967296 + val : val;
    };
    MP4Demuxer.writeUint32 = function (buffer, offset, value) {
        if (buffer.data) {
            offset += buffer.start;
            buffer = buffer.data;
        }
        buffer[offset] = value >> 24;
        buffer[offset + 1] = (value >> 16) & 0xff;
        buffer[offset + 2] = (value >> 8) & 0xff;
        buffer[offset + 3] = value & 0xff;
    };
    // Find the data for a box specified by its path
    MP4Demuxer.findBox = function (data, path) {
        var results = [], i, size, type, end, subresults, start, endbox;
        if (data.data) {
            start = data.start;
            end = data.end;
            data = data.data;
        }
        else {
            start = 0;
            end = data.byteLength;
        }
        if (!path.length) {
            // short-circuit the search for empty paths
            return null;
        }
        for (i = start; i < end;) {
            size = MP4Demuxer.readUint32(data, i);
            type = MP4Demuxer.bin2str(data.subarray(i + 4, i + 8));
            endbox = size > 1 ? i + size : end;
            if (type === path[0]) {
                if (path.length === 1) {
                    // this is the end of the path and we've found the box we were
                    // looking for
                    results.push({ data: data, start: i + 8, end: endbox });
                }
                else {
                    // recursively search for the next box along the path
                    subresults = MP4Demuxer.findBox({ data: data, start: i + 8, end: endbox }, path.slice(1));
                    if (subresults.length) {
                        results = results.concat(subresults);
                    }
                }
            }
            i = endbox;
        }
        // we've finished searching all of data
        return results;
    };
    MP4Demuxer.parseSegmentIndex = function (initSegment) {
        var moov = MP4Demuxer.findBox(initSegment, ['moov'])[0];
        var moovEndOffset = moov ? moov.end : null; // we need this in case we need to chop of garbage of the end of current data
        var index = 0;
        var sidx = MP4Demuxer.findBox(initSegment, ['sidx']);
        var references;
        if (!sidx || !sidx[0]) {
            return null;
        }
        references = [];
        sidx = sidx[0];
        var version = sidx.data[0];
        // set initial offset, we skip the reference ID (not needed)
        index = version === 0 ? 8 : 16;
        var timescale = MP4Demuxer.readUint32(sidx, index);
        index += 4;
        // TODO: parse earliestPresentationTime and firstOffset
        // usually zero in our case
        var earliestPresentationTime = 0;
        var firstOffset = 0;
        if (version === 0) {
            index += 8;
        }
        else {
            index += 16;
        }
        // skip reserved
        index += 2;
        var startByte = sidx.end + firstOffset;
        var referencesCount = MP4Demuxer.readUint16(sidx, index);
        index += 2;
        for (var i = 0; i < referencesCount; i++) {
            var referenceIndex = index;
            var referenceInfo = MP4Demuxer.readUint32(sidx, referenceIndex);
            referenceIndex += 4;
            var referenceSize = referenceInfo & 0x7FFFFFFF;
            var referenceType = (referenceInfo & 0x80000000) >>> 31;
            if (referenceType === 1) {
                console.warn('SIDX has hierarchical references (not supported)');
                return;
            }
            var subsegmentDuration = MP4Demuxer.readUint32(sidx, referenceIndex);
            referenceIndex += 4;
            references.push({
                referenceSize: referenceSize,
                subsegmentDuration: subsegmentDuration,
                info: {
                    duration: subsegmentDuration / timescale,
                    start: startByte,
                    end: startByte + referenceSize - 1
                }
            });
            startByte += referenceSize;
            // Skipping 1 bit for |startsWithSap|, 3 bits for |sapType|, and 28 bits
            // for |sapDelta|.
            referenceIndex += 4;
            // skip to next ref
            index = referenceIndex;
        }
        return {
            earliestPresentationTime: earliestPresentationTime,
            timescale: timescale,
            version: version,
            referencesCount: referencesCount,
            references: references,
            moovEndOffset: moovEndOffset
        };
    };
    /**
     * Parses an MP4 initialization segment and extracts stream type and
     * timescale values for any declared tracks. Timescale values indicate the
     * number of clock ticks per second to assume for time-based values
     * elsewhere in the MP4.
     *
     * To determine the start time of an MP4, you need two pieces of
     * information: the timescale unit and the earliest base media decode
     * time. Multiple timescales can be specified within an MP4 but the
     * base media decode time is always expressed in the timescale from
     * the media header box for the track:
     * ```
     * moov > trak > mdia > mdhd.timescale
     * moov > trak > mdia > hdlr
     * ```
     * @param init {Uint8Array} the bytes of the init segment
     * @return {object} a hash of track type to timescale values or null if
     * the init segment is malformed.
     */
    MP4Demuxer.parseInitSegment = function (initSegment) {
        var result = [];
        var traks = MP4Demuxer.findBox(initSegment, ['moov', 'trak']);
        traks.forEach(function (trak) {
            var tkhd = MP4Demuxer.findBox(trak, ['tkhd'])[0];
            if (tkhd) {
                var version = tkhd.data[tkhd.start];
                var index = version === 0 ? 12 : 20;
                var trackId = MP4Demuxer.readUint32(tkhd, index);
                var mdhd = MP4Demuxer.findBox(trak, ['mdia', 'mdhd'])[0];
                if (mdhd) {
                    version = mdhd.data[mdhd.start];
                    index = version === 0 ? 12 : 20;
                    var timescale = MP4Demuxer.readUint32(mdhd, index);
                    var hdlr = MP4Demuxer.findBox(trak, ['mdia', 'hdlr'])[0];
                    if (hdlr) {
                        var hdlrType = MP4Demuxer.bin2str(hdlr.data.subarray(hdlr.start + 8, hdlr.start + 12));
                        var type = { 'soun': 'audio', 'vide': 'video' }[hdlrType];
                        if (type) {
                            // extract codec info. TODO : parse codec details to be able to build MIME type
                            var codecBox = MP4Demuxer.findBox(trak, ['mdia', 'minf', 'stbl', 'stsd']);
                            if (codecBox.length) {
                                codecBox = codecBox[0];
                                var codecType = MP4Demuxer.bin2str(codecBox.data.subarray(codecBox.start + 12, codecBox.start + 16));
                                logger_1.logger.log("MP4Demuxer:" + type + ":" + codecType + " found");
                            }
                            result[trackId] = { timescale: timescale, type: type };
                            result[type] = { timescale: timescale, id: trackId };
                        }
                    }
                }
            }
        });
        return result;
    };
    /**
   * Determine the base media decode start time, in seconds, for an MP4
   * fragment. If multiple fragments are specified, the earliest time is
   * returned.
   *
   * The base media decode time can be parsed from track fragment
   * metadata:
   * ```
   * moof > traf > tfdt.baseMediaDecodeTime
   * ```
   * It requires the timescale value from the mdhd to interpret.
   *
   * @param timescale {object} a hash of track ids to timescale values.
   * @return {number} the earliest base media decode start time for the
   * fragment, in seconds
   */
    MP4Demuxer.getStartDTS = function (initData, fragment) {
        var trafs, baseTimes, result;
        // we need info from two childrend of each track fragment box
        trafs = MP4Demuxer.findBox(fragment, ['moof', 'traf']);
        // determine the start times for each track
        baseTimes = [].concat.apply([], trafs.map(function (traf) {
            return MP4Demuxer.findBox(traf, ['tfhd']).map(function (tfhd) {
                var id, scale, baseTime;
                // get the track id from the tfhd
                id = MP4Demuxer.readUint32(tfhd, 4);
                // assume a 90kHz clock if no timescale was specified
                scale = initData[id].timescale || 90e3;
                // get the base media decode time from the tfdt
                baseTime = MP4Demuxer.findBox(traf, ['tfdt']).map(function (tfdt) {
                    var version, result;
                    version = tfdt.data[tfdt.start];
                    result = MP4Demuxer.readUint32(tfdt, 4);
                    if (version === 1) {
                        result *= Math.pow(2, 32);
                        result += MP4Demuxer.readUint32(tfdt, 8);
                    }
                    return result;
                })[0];
                // convert base time to seconds
                return baseTime / scale;
            });
        }));
        // return the minimum
        result = Math.min.apply(null, baseTimes);
        return isFinite(result) ? result : 0;
    };
    MP4Demuxer.offsetStartDTS = function (initData, fragment, timeOffset) {
        MP4Demuxer.findBox(fragment, ['moof', 'traf']).map(function (traf) {
            return MP4Demuxer.findBox(traf, ['tfhd']).map(function (tfhd) {
                // get the track id from the tfhd
                var id = MP4Demuxer.readUint32(tfhd, 4);
                // assume a 90kHz clock if no timescale was specified
                var timescale = initData[id].timescale || 90e3;
                // get the base media decode time from the tfdt
                MP4Demuxer.findBox(traf, ['tfdt']).map(function (tfdt) {
                    var version = tfdt.data[tfdt.start];
                    var baseMediaDecodeTime = MP4Demuxer.readUint32(tfdt, 4);
                    if (version === 0) {
                        MP4Demuxer.writeUint32(tfdt, 4, baseMediaDecodeTime - timeOffset * timescale);
                    }
                    else {
                        baseMediaDecodeTime *= Math.pow(2, 32);
                        baseMediaDecodeTime += MP4Demuxer.readUint32(tfdt, 8);
                        baseMediaDecodeTime -= timeOffset * timescale;
                        baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
                        var upper = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1));
                        var lower = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));
                        MP4Demuxer.writeUint32(tfdt, 4, upper);
                        MP4Demuxer.writeUint32(tfdt, 8, lower);
                    }
                });
            });
        });
    };
    // feed incoming data to the front of the parsing pipeline
    MP4Demuxer.prototype.append = function (data, timeOffset, contiguous, accurateTimeOffset) {
        var initData = this.initData;
        if (!initData) {
            this.resetInitSegment(data, this.audioCodec, this.videoCodec, false);
            initData = this.initData;
        }
        var startDTS, initPTS = this.initPTS;
        if (initPTS === undefined) {
            var startDTS_1 = MP4Demuxer.getStartDTS(initData, data);
            this.initPTS = initPTS = startDTS_1 - timeOffset;
            this.observer.trigger(events_1.default.INIT_PTS_FOUND, { initPTS: initPTS });
        }
        MP4Demuxer.offsetStartDTS(initData, data, initPTS);
        startDTS = MP4Demuxer.getStartDTS(initData, data);
        this.remuxer.remux(initData.audio, initData.video, null, null, startDTS, contiguous, accurateTimeOffset, data);
    };
    MP4Demuxer.prototype.destroy = function () { };
    return MP4Demuxer;
}());
exports.default = MP4Demuxer;


/***/ }),

/***/ "./src/demux/mpegaudio.js":
/*!********************************!*\
  !*** ./src/demux/mpegaudio.js ***!
  \********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 *  MPEG parser helper
 */
Object.defineProperty(exports, "__esModule", { value: true });
var MpegAudio = {
    BitratesMap: [
        32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448,
        32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384,
        32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320,
        32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256,
        8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160
    ],
    SamplingRateMap: [44100, 48000, 32000, 22050, 24000, 16000, 11025, 12000, 8000],
    SamplesCoefficients: [
        // MPEG 2.5
        [
            0,
            72,
            144,
            12 // Layer1
        ],
        // Reserved
        [
            0,
            0,
            0,
            0 // Layer1
        ],
        // MPEG 2
        [
            0,
            72,
            144,
            12 // Layer1
        ],
        // MPEG 1
        [
            0,
            144,
            144,
            12 // Layer1
        ]
    ],
    BytesInSlot: [
        0,
        1,
        1,
        4 // Layer1
    ],
    appendFrame: function (track, data, offset, pts, frameIndex) {
        // Using http://www.datavoyage.com/mpgscript/mpeghdr.htm as a reference
        if (offset + 24 > data.length) {
            return undefined;
        }
        var header = this.parseHeader(data, offset);
        if (header && offset + header.frameLength <= data.length) {
            var frameDuration = header.samplesPerFrame * 90000 / header.sampleRate;
            var stamp = pts + frameIndex * frameDuration;
            var sample = { unit: data.subarray(offset, offset + header.frameLength), pts: stamp, dts: stamp };
            track.config = [];
            track.channelCount = header.channelCount;
            track.samplerate = header.sampleRate;
            track.samples.push(sample);
            track.len += header.frameLength;
            return { sample: sample, length: header.frameLength };
        }
        return undefined;
    },
    parseHeader: function (data, offset) {
        var headerB = (data[offset + 1] >> 3) & 3;
        var headerC = (data[offset + 1] >> 1) & 3;
        var headerE = (data[offset + 2] >> 4) & 15;
        var headerF = (data[offset + 2] >> 2) & 3;
        var headerG = (data[offset + 2] >> 1) & 1;
        if (headerB !== 1 && headerE !== 0 && headerE !== 15 && headerF !== 3) {
            var columnInBitrates = headerB === 3 ? (3 - headerC) : (headerC === 3 ? 3 : 4);
            var bitRate = MpegAudio.BitratesMap[columnInBitrates * 14 + headerE - 1] * 1000;
            var columnInSampleRates = headerB === 3 ? 0 : headerB === 2 ? 1 : 2;
            var sampleRate = MpegAudio.SamplingRateMap[columnInSampleRates * 3 + headerF];
            var channelCount = data[offset + 3] >> 6 === 3 ? 1 : 2; // If bits of channel mode are `11` then it is a single channel (Mono)
            var sampleCoefficient = MpegAudio.SamplesCoefficients[headerB][headerC];
            var bytesInSlot = MpegAudio.BytesInSlot[headerC];
            var samplesPerFrame = sampleCoefficient * 8 * bytesInSlot;
            var frameLength = parseInt(sampleCoefficient * bitRate / sampleRate + headerG, 10) * bytesInSlot;
            return { sampleRate: sampleRate, channelCount: channelCount, frameLength: frameLength, samplesPerFrame: samplesPerFrame };
        }
        return undefined;
    },
    isHeaderPattern: function (data, offset) {
        return data[offset] === 0xff && (data[offset + 1] & 0xe0) === 0xe0 && (data[offset + 1] & 0x06) !== 0x00;
    },
    isHeader: function (data, offset) {
        // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
        // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
        // More info http://www.mp3-tech.org/programmer/frame_header.html
        if (offset + 1 < data.length && this.isHeaderPattern(data, offset)) {
            return true;
        }
        return false;
    },
    probe: function (data, offset) {
        // same as isHeader but we also check that MPEG frame follows last MPEG frame
        // or end of data is reached
        if (offset + 1 < data.length && this.isHeaderPattern(data, offset)) {
            // MPEG header Length
            var headerLength = 4;
            // MPEG frame Length
            var header = this.parseHeader(data, offset);
            var frameLength = headerLength;
            if (header && header.frameLength) {
                frameLength = header.frameLength;
            }
            var newOffset = offset + frameLength;
            if (newOffset === data.length || (newOffset + 1 < data.length && this.isHeaderPattern(data, newOffset))) {
                return true;
            }
        }
        return false;
    }
};
exports.default = MpegAudio;


/***/ }),

/***/ "./src/demux/sample-aes.js":
/*!*********************************!*\
  !*** ./src/demux/sample-aes.js ***!
  \*********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * SAMPLE-AES decrypter
*/
Object.defineProperty(exports, "__esModule", { value: true });
var decrypter_1 = __webpack_require__(/*! ../crypt/decrypter */ "./src/crypt/decrypter.js");
var SampleAesDecrypter = /** @class */ (function () {
    function SampleAesDecrypter(observer, config, decryptdata, discardEPB) {
        this.decryptdata = decryptdata;
        this.discardEPB = discardEPB;
        this.decrypter = new decrypter_1.default(observer, config, { removePKCS7Padding: false });
    }
    SampleAesDecrypter.prototype.decryptBuffer = function (encryptedData, callback) {
        this.decrypter.decrypt(encryptedData, this.decryptdata.key.buffer, this.decryptdata.iv.buffer, callback);
    };
    // AAC - encrypt all full 16 bytes blocks starting from offset 16
    SampleAesDecrypter.prototype.decryptAacSample = function (samples, sampleIndex, callback, sync) {
        var curUnit = samples[sampleIndex].unit;
        var encryptedData = curUnit.subarray(16, curUnit.length - curUnit.length % 16);
        var encryptedBuffer = encryptedData.buffer.slice(encryptedData.byteOffset, encryptedData.byteOffset + encryptedData.length);
        var localthis = this;
        this.decryptBuffer(encryptedBuffer, function (decryptedData) {
            decryptedData = new Uint8Array(decryptedData);
            curUnit.set(decryptedData, 16);
            if (!sync) {
                localthis.decryptAacSamples(samples, sampleIndex + 1, callback);
            }
        });
    };
    SampleAesDecrypter.prototype.decryptAacSamples = function (samples, sampleIndex, callback) {
        for (;; sampleIndex++) {
            if (sampleIndex >= samples.length) {
                callback();
                return;
            }
            if (samples[sampleIndex].unit.length < 32) {
                continue;
            }
            var sync = this.decrypter.isSync();
            this.decryptAacSample(samples, sampleIndex, callback, sync);
            if (!sync) {
                return;
            }
        }
    };
    // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
    SampleAesDecrypter.prototype.getAvcEncryptedData = function (decodedData) {
        var encryptedDataLen = Math.floor((decodedData.length - 48) / 160) * 16 + 16;
        var encryptedData = new Int8Array(encryptedDataLen);
        var outputPos = 0;
        for (var inputPos = 32; inputPos <= decodedData.length - 16; inputPos += 160, outputPos += 16) {
            encryptedData.set(decodedData.subarray(inputPos, inputPos + 16), outputPos);
        }
        return encryptedData;
    };
    SampleAesDecrypter.prototype.getAvcDecryptedUnit = function (decodedData, decryptedData) {
        decryptedData = new Uint8Array(decryptedData);
        var inputPos = 0;
        for (var outputPos = 32; outputPos <= decodedData.length - 16; outputPos += 160, inputPos += 16) {
            decodedData.set(decryptedData.subarray(inputPos, inputPos + 16), outputPos);
        }
        return decodedData;
    };
    SampleAesDecrypter.prototype.decryptAvcSample = function (samples, sampleIndex, unitIndex, callback, curUnit, sync) {
        var decodedData = this.discardEPB(curUnit.data);
        var encryptedData = this.getAvcEncryptedData(decodedData);
        var localthis = this;
        this.decryptBuffer(encryptedData.buffer, function (decryptedData) {
            curUnit.data = localthis.getAvcDecryptedUnit(decodedData, decryptedData);
            if (!sync) {
                localthis.decryptAvcSamples(samples, sampleIndex, unitIndex + 1, callback);
            }
        });
    };
    SampleAesDecrypter.prototype.decryptAvcSamples = function (samples, sampleIndex, unitIndex, callback) {
        for (;; sampleIndex++, unitIndex = 0) {
            if (sampleIndex >= samples.length) {
                callback();
                return;
            }
            var curUnits = samples[sampleIndex].units;
            for (;; unitIndex++) {
                if (unitIndex >= curUnits.length) {
                    break;
                }
                var curUnit = curUnits[unitIndex];
                if (curUnit.length <= 48 || (curUnit.type !== 1 && curUnit.type !== 5)) {
                    continue;
                }
                var sync = this.decrypter.isSync();
                this.decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit, sync);
                if (!sync) {
                    return;
                }
            }
        }
    };
    return SampleAesDecrypter;
}());
exports.default = SampleAesDecrypter;


/***/ }),

/***/ "./src/demux/tsdemuxer.js":
/*!********************************!*\
  !*** ./src/demux/tsdemuxer.js ***!
  \********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * highly optimized TS demuxer:
 * parse PAT, PMT
 * extract PES packet from audio and video PIDs
 * extract AVC/H264 NAL units and AAC/ADTS samples from PES packet
 * trigger the remuxer upon parsing completion
 * it also tries to workaround as best as it can audio codec switch (HE-AAC to AAC and vice versa), without having to restart the MediaSource.
 * it also controls the remuxing process :
 * upon discontinuity or level switch detection, it will also notifies the remuxer so that it can reset its state.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var ADTS = __webpack_require__(/*! ./adts */ "./src/demux/adts.js");
var mpegaudio_1 = __webpack_require__(/*! ./mpegaudio */ "./src/demux/mpegaudio.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var exp_golomb_1 = __webpack_require__(/*! ./exp-golomb */ "./src/demux/exp-golomb.js");
var sample_aes_1 = __webpack_require__(/*! ./sample-aes */ "./src/demux/sample-aes.js");
// import Hex from '../utils/hex';
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
// We are using fixed track IDs for driving the MP4 remuxer
// instead of following the TS PIDs.
// There is no reason not to do this and some browsers/SourceBuffer-demuxers
// may not like if there are TrackID "switches"
// See https://github.com/video-dev/hls.js/issues/1331
// Here we are mapping our internal track types to constant MP4 track IDs
// With MSE currently one can only have one track of each, and we are muxing
// whatever video/audio rendition in them.
var RemuxerTrackIdConfig = {
    video: 1,
    audio: 2,
    id3: 3,
    text: 4
};
var TSDemuxer = /** @class */ (function () {
    function TSDemuxer(observer, remuxer, config, typeSupported) {
        this.observer = observer;
        this.config = config;
        this.typeSupported = typeSupported;
        this.remuxer = remuxer;
        this.sampleAes = null;
    }
    TSDemuxer.prototype.setDecryptData = function (decryptdata) {
        if ((decryptdata != null) && (decryptdata.key != null) && (decryptdata.method === 'SAMPLE-AES')) {
            this.sampleAes = new sample_aes_1.default(this.observer, this.config, decryptdata, this.discardEPB);
        }
        else {
            this.sampleAes = null;
        }
    };
    TSDemuxer.probe = function (data) {
        var syncOffset = TSDemuxer._syncOffset(data);
        if (syncOffset < 0) {
            return false;
        }
        else {
            if (syncOffset) {
                logger_1.logger.warn("MPEG2-TS detected but first sync word found @ offset " + syncOffset + ", junk ahead ?");
            }
            return true;
        }
    };
    TSDemuxer._syncOffset = function (data) {
        // scan 1000 first bytes
        var scanwindow = Math.min(1000, data.length - 3 * 188);
        var i = 0;
        while (i < scanwindow) {
            // a TS fragment should contain at least 3 TS packets, a PAT, a PMT, and one PID, each starting with 0x47
            if (data[i] === 0x47 && data[i + 188] === 0x47 && data[i + 2 * 188] === 0x47) {
                return i;
            }
            else {
                i++;
            }
        }
        return -1;
    };
    /**
     * Creates a track model internal to demuxer used to drive remuxing input
     *
     * @param {string} type 'audio' | 'video' | 'id3' | 'text'
     * @param {number} duration
     * @return {object} TSDemuxer's internal track model
     */
    TSDemuxer.createTrack = function (type, duration) {
        return {
            container: type === 'video' || type === 'audio' ? 'video/mp2t' : undefined,
            type: type,
            id: RemuxerTrackIdConfig[type],
            pid: -1,
            inputTimeScale: 90000,
            sequenceNumber: 0,
            samples: [],
            len: 0,
            dropped: type === 'video' ? 0 : undefined,
            isAAC: type === 'audio' ? true : undefined,
            duration: type === 'audio' ? duration : undefined
        };
    };
    /**
     * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
     * Resets all internal track instances of the demuxer.
     *
     * @override Implements generic demuxing/remuxing interface (see DemuxerInline)
     * @param {object} initSegment
     * @param {string} audioCodec
     * @param {string} videoCodec
     * @param {number} duration (in TS timescale = 90kHz)
     */
    TSDemuxer.prototype.resetInitSegment = function (initSegment, audioCodec, videoCodec, duration) {
        this.pmtParsed = false;
        this._pmtId = -1;
        this._avcTrack = TSDemuxer.createTrack('video', duration);
        this._audioTrack = TSDemuxer.createTrack('audio', duration);
        this._id3Track = TSDemuxer.createTrack('id3', duration);
        this._txtTrack = TSDemuxer.createTrack('text', duration);
        // flush any partial content
        this.aacOverFlow = null;
        this.aacLastPTS = null;
        this.avcSample = null;
        this.audioCodec = audioCodec;
        this.videoCodec = videoCodec;
        this._duration = duration;
    };
    /**
     *
     * @override
     */
    TSDemuxer.prototype.resetTimeStamp = function () { };
    // feed incoming data to the front of the parsing pipeline
    TSDemuxer.prototype.append = function (data, timeOffset, contiguous, accurateTimeOffset) {
        var start, len = data.length, stt, pid, atf, offset, pes, unknownPIDs = false;
        this.contiguous = contiguous;
        var pmtParsed = this.pmtParsed, avcTrack = this._avcTrack, audioTrack = this._audioTrack, id3Track = this._id3Track, avcId = avcTrack.pid, audioId = audioTrack.pid, id3Id = id3Track.pid, pmtId = this._pmtId, avcData = avcTrack.pesData, audioData = audioTrack.pesData, id3Data = id3Track.pesData, parsePAT = this._parsePAT, parsePMT = this._parsePMT, parsePES = this._parsePES, parseAVCPES = this._parseAVCPES.bind(this), parseAACPES = this._parseAACPES.bind(this), parseMPEGPES = this._parseMPEGPES.bind(this), parseID3PES = this._parseID3PES.bind(this);
        var syncOffset = TSDemuxer._syncOffset(data);
        // don't parse last TS packet if incomplete
        len -= (len + syncOffset) % 188;
        // loop through TS packets
        for (start = syncOffset; start < len; start += 188) {
            if (data[start] === 0x47) {
                stt = !!(data[start + 1] & 0x40);
                // pid is a 13-bit field starting at the last bit of TS[1]
                pid = ((data[start + 1] & 0x1f) << 8) + data[start + 2];
                atf = (data[start + 3] & 0x30) >> 4;
                // if an adaption field is present, its length is specified by the fifth byte of the TS packet header.
                if (atf > 1) {
                    offset = start + 5 + data[start + 4];
                    // continue if there is only adaptation field
                    if (offset === (start + 188)) {
                        continue;
                    }
                }
                else {
                    offset = start + 4;
                }
                switch (pid) {
                    case avcId:
                        if (stt) {
                            if (avcData && (pes = parsePES(avcData)) && pes.pts !== undefined) {
                                parseAVCPES(pes, false);
                            }
                            avcData = { data: [], size: 0 };
                        }
                        if (avcData) {
                            avcData.data.push(data.subarray(offset, start + 188));
                            avcData.size += start + 188 - offset;
                        }
                        break;
                    case audioId:
                        if (stt) {
                            if (audioData && (pes = parsePES(audioData)) && pes.pts !== undefined) {
                                if (audioTrack.isAAC) {
                                    parseAACPES(pes);
                                }
                                else {
                                    parseMPEGPES(pes);
                                }
                            }
                            audioData = { data: [], size: 0 };
                        }
                        if (audioData) {
                            audioData.data.push(data.subarray(offset, start + 188));
                            audioData.size += start + 188 - offset;
                        }
                        break;
                    case id3Id:
                        if (stt) {
                            if (id3Data && (pes = parsePES(id3Data)) && pes.pts !== undefined) {
                                parseID3PES(pes);
                            }
                            id3Data = { data: [], size: 0 };
                        }
                        if (id3Data) {
                            id3Data.data.push(data.subarray(offset, start + 188));
                            id3Data.size += start + 188 - offset;
                        }
                        break;
                    case 0:
                        if (stt) {
                            offset += data[offset] + 1;
                        }
                        pmtId = this._pmtId = parsePAT(data, offset);
                        break;
                    case pmtId:
                        if (stt) {
                            offset += data[offset] + 1;
                        }
                        var parsedPIDs = parsePMT(data, offset, this.typeSupported.mpeg === true || this.typeSupported.mp3 === true, this.sampleAes != null);
                        // only update track id if track PID found while parsing PMT
                        // this is to avoid resetting the PID to -1 in case
                        // track PID transiently disappears from the stream
                        // this could happen in case of transient missing audio samples for example
                        // NOTE this is only the PID of the track as found in TS,
                        // but we are not using this for MP4 track IDs.
                        avcId = parsedPIDs.avc;
                        if (avcId > 0) {
                            avcTrack.pid = avcId;
                        }
                        audioId = parsedPIDs.audio;
                        if (audioId > 0) {
                            audioTrack.pid = audioId;
                            audioTrack.isAAC = parsedPIDs.isAAC;
                        }
                        id3Id = parsedPIDs.id3;
                        if (id3Id > 0) {
                            id3Track.pid = id3Id;
                        }
                        if (unknownPIDs && !pmtParsed) {
                            logger_1.logger.log('reparse from beginning');
                            unknownPIDs = false;
                            // we set it to -188, the += 188 in the for loop will reset start to 0
                            start = syncOffset - 188;
                        }
                        pmtParsed = this.pmtParsed = true;
                        break;
                    case 17:
                    case 0x1fff:
                        break;
                    default:
                        unknownPIDs = true;
                        break;
                }
            }
            else {
                this.observer.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MEDIA_ERROR, details: errors_1.ErrorDetails.FRAG_PARSING_ERROR, fatal: false, reason: 'TS packet did not start with 0x47' });
            }
        }
        // try to parse last PES packets
        if (avcData && (pes = parsePES(avcData)) && pes.pts !== undefined) {
            parseAVCPES(pes, true);
            avcTrack.pesData = null;
        }
        else {
            // either avcData null or PES truncated, keep it for next frag parsing
            avcTrack.pesData = avcData;
        }
        if (audioData && (pes = parsePES(audioData)) && pes.pts !== undefined) {
            if (audioTrack.isAAC) {
                parseAACPES(pes);
            }
            else {
                parseMPEGPES(pes);
            }
            audioTrack.pesData = null;
        }
        else {
            if (audioData && audioData.size) {
                logger_1.logger.log('last AAC PES packet truncated,might overlap between fragments');
            }
            // either audioData null or PES truncated, keep it for next frag parsing
            audioTrack.pesData = audioData;
        }
        if (id3Data && (pes = parsePES(id3Data)) && pes.pts !== undefined) {
            parseID3PES(pes);
            id3Track.pesData = null;
        }
        else {
            // either id3Data null or PES truncated, keep it for next frag parsing
            id3Track.pesData = id3Data;
        }
        if (this.sampleAes == null) {
            this.remuxer.remux(audioTrack, avcTrack, id3Track, this._txtTrack, timeOffset, contiguous, accurateTimeOffset);
        }
        else {
            this.decryptAndRemux(audioTrack, avcTrack, id3Track, this._txtTrack, timeOffset, contiguous, accurateTimeOffset);
        }
    };
    TSDemuxer.prototype.decryptAndRemux = function (audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
        if (audioTrack.samples && audioTrack.isAAC) {
            var localthis_1 = this;
            this.sampleAes.decryptAacSamples(audioTrack.samples, 0, function () {
                localthis_1.decryptAndRemuxAvc(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
            });
        }
        else {
            this.decryptAndRemuxAvc(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
        }
    };
    TSDemuxer.prototype.decryptAndRemuxAvc = function (audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
        if (videoTrack.samples) {
            var localthis_2 = this;
            this.sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, function () {
                localthis_2.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
            });
        }
        else {
            this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
        }
    };
    TSDemuxer.prototype.destroy = function () {
        this._initPTS = this._initDTS = undefined;
        this._duration = 0;
    };
    TSDemuxer.prototype._parsePAT = function (data, offset) {
        // skip the PSI header and parse the first PMT entry
        return (data[offset + 10] & 0x1F) << 8 | data[offset + 11];
        // logger.log('PMT PID:'  + this._pmtId);
    };
    TSDemuxer.prototype._parsePMT = function (data, offset, mpegSupported, isSampleAes) {
        var sectionLength, tableEnd, programInfoLength, pid, result = { audio: -1, avc: -1, id3: -1, isAAC: true };
        sectionLength = (data[offset + 1] & 0x0f) << 8 | data[offset + 2];
        tableEnd = offset + 3 + sectionLength - 4;
        // to determine where the table is, we have to figure out how
        // long the program info descriptors are
        programInfoLength = (data[offset + 10] & 0x0f) << 8 | data[offset + 11];
        // advance the offset to the first entry in the mapping table
        offset += 12 + programInfoLength;
        while (offset < tableEnd) {
            pid = (data[offset + 1] & 0x1F) << 8 | data[offset + 2];
            switch (data[offset]) {
                case 0xcf: // SAMPLE-AES AAC
                    if (!isSampleAes) {
                        logger_1.logger.log('unkown stream type:' + data[offset]);
                        break;
                    }
                /* falls through */
                // ISO/IEC 13818-7 ADTS AAC (MPEG-2 lower bit-rate audio)
                case 0x0f:
                    // logger.log('AAC PID:'  + pid);
                    if (result.audio === -1) {
                        result.audio = pid;
                    }
                    break;
                // Packetized metadata (ID3)
                case 0x15:
                    // logger.log('ID3 PID:'  + pid);
                    if (result.id3 === -1) {
                        result.id3 = pid;
                    }
                    break;
                case 0xdb: // SAMPLE-AES AVC
                    if (!isSampleAes) {
                        logger_1.logger.log('unkown stream type:' + data[offset]);
                        break;
                    }
                /* falls through */
                // ITU-T Rec. H.264 and ISO/IEC 14496-10 (lower bit-rate video)
                case 0x1b:
                    // logger.log('AVC PID:'  + pid);
                    if (result.avc === -1) {
                        result.avc = pid;
                    }
                    break;
                // ISO/IEC 11172-3 (MPEG-1 audio)
                // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
                case 0x03:
                case 0x04:
                    // logger.log('MPEG PID:'  + pid);
                    if (!mpegSupported) {
                        logger_1.logger.log('MPEG audio found, not supported in this browser for now');
                    }
                    else if (result.audio === -1) {
                        result.audio = pid;
                        result.isAAC = false;
                    }
                    break;
                case 0x24:
                    logger_1.logger.warn('HEVC stream type found, not supported for now');
                    break;
                default:
                    logger_1.logger.log('unkown stream type:' + data[offset]);
                    break;
            }
            // move to the next table entry
            // skip past the elementary stream descriptors, if present
            offset += ((data[offset + 3] & 0x0F) << 8 | data[offset + 4]) + 5;
        }
        return result;
    };
    TSDemuxer.prototype._parsePES = function (stream) {
        var i = 0, frag, pesFlags, pesPrefix, pesLen, pesHdrLen, pesData, pesPts, pesDts, payloadStartOffset, data = stream.data;
        // safety check
        if (!stream || stream.size === 0) {
            return null;
        }
        // we might need up to 19 bytes to read PES header
        // if first chunk of data is less than 19 bytes, let's merge it with following ones until we get 19 bytes
        // usually only one merge is needed (and this is rare ...)
        while (data[0].length < 19 && data.length > 1) {
            var newData = new Uint8Array(data[0].length + data[1].length);
            newData.set(data[0]);
            newData.set(data[1], data[0].length);
            data[0] = newData;
            data.splice(1, 1);
        }
        // retrieve PTS/DTS from first fragment
        frag = data[0];
        pesPrefix = (frag[0] << 16) + (frag[1] << 8) + frag[2];
        if (pesPrefix === 1) {
            pesLen = (frag[4] << 8) + frag[5];
            // if PES parsed length is not zero and greater than total received length, stop parsing. PES might be truncated
            // minus 6 : PES header size
            if (pesLen && pesLen > stream.size - 6) {
                return null;
            }
            pesFlags = frag[7];
            if (pesFlags & 0xC0) {
                /* PES header described here : http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
                    as PTS / DTS is 33 bit we cannot use bitwise operator in JS,
                    as Bitwise operators treat their operands as a sequence of 32 bits */
                pesPts = (frag[9] & 0x0E) * 536870912 + // 1 << 29
                    (frag[10] & 0xFF) * 4194304 + // 1 << 22
                    (frag[11] & 0xFE) * 16384 + // 1 << 14
                    (frag[12] & 0xFF) * 128 + // 1 << 7
                    (frag[13] & 0xFE) / 2;
                // check if greater than 2^32 -1
                if (pesPts > 4294967295) {
                    // decrement 2^33
                    pesPts -= 8589934592;
                }
                if (pesFlags & 0x40) {
                    pesDts = (frag[14] & 0x0E) * 536870912 + // 1 << 29
                        (frag[15] & 0xFF) * 4194304 + // 1 << 22
                        (frag[16] & 0xFE) * 16384 + // 1 << 14
                        (frag[17] & 0xFF) * 128 + // 1 << 7
                        (frag[18] & 0xFE) / 2;
                    // check if greater than 2^32 -1
                    if (pesDts > 4294967295) {
                        // decrement 2^33
                        pesDts -= 8589934592;
                    }
                    if (pesPts - pesDts > 60 * 90000) {
                        logger_1.logger.warn(Math.round((pesPts - pesDts) / 90000) + "s delta between PTS and DTS, align them");
                        pesPts = pesDts;
                    }
                }
                else {
                    pesDts = pesPts;
                }
            }
            pesHdrLen = frag[8];
            // 9 bytes : 6 bytes for PES header + 3 bytes for PES extension
            payloadStartOffset = pesHdrLen + 9;
            stream.size -= payloadStartOffset;
            // reassemble PES packet
            pesData = new Uint8Array(stream.size);
            for (var j = 0, dataLen = data.length; j < dataLen; j++) {
                frag = data[j];
                var len = frag.byteLength;
                if (payloadStartOffset) {
                    if (payloadStartOffset > len) {
                        // trim full frag if PES header bigger than frag
                        payloadStartOffset -= len;
                        continue;
                    }
                    else {
                        // trim partial frag if PES header smaller than frag
                        frag = frag.subarray(payloadStartOffset);
                        len -= payloadStartOffset;
                        payloadStartOffset = 0;
                    }
                }
                pesData.set(frag, i);
                i += len;
            }
            if (pesLen) {
                // payload size : remove PES header + PES extension
                pesLen -= pesHdrLen + 3;
            }
            return { data: pesData, pts: pesPts, dts: pesDts, len: pesLen };
        }
        else {
            return null;
        }
    };
    TSDemuxer.prototype.pushAccesUnit = function (avcSample, avcTrack) {
        if (avcSample.units.length && avcSample.frame) {
            var samples = avcTrack.samples;
            var nbSamples = samples.length;
            // only push AVC sample if starting with a keyframe is not mandatory OR
            //    if keyframe already found in this fragment OR
            //       keyframe found in last fragment (track.sps) AND
            //          samples already appended (we already found a keyframe in this fragment) OR fragment is contiguous
            if (!this.config.forceKeyFrameOnDiscontinuity ||
                avcSample.key === true ||
                (avcTrack.sps && (nbSamples || this.contiguous))) {
                avcSample.id = nbSamples;
                samples.push(avcSample);
            }
            else {
                // dropped samples, track it
                avcTrack.dropped++;
            }
        }
        if (avcSample.debug.length) {
            logger_1.logger.log(avcSample.pts + '/' + avcSample.dts + ':' + avcSample.debug);
        }
    };
    TSDemuxer.prototype._parseAVCPES = function (pes, last) {
        var _this = this;
        // logger.log('parse new PES');
        var track = this._avcTrack, units = this._parseAVCNALu(pes.data), debug = false, expGolombDecoder, avcSample = this.avcSample, push, spsfound = false, i, pushAccesUnit = this.pushAccesUnit.bind(this), createAVCSample = function (key, pts, dts, debug) {
            return { key: key, pts: pts, dts: dts, units: [], debug: debug };
        };
        // free pes.data to save up some memory
        pes.data = null;
        // if new NAL units found and last sample still there, let's push ...
        // this helps parsing streams with missing AUD (only do this if AUD never found)
        if (avcSample && units.length && !track.audFound) {
            pushAccesUnit(avcSample, track);
            avcSample = this.avcSample = createAVCSample(false, pes.pts, pes.dts, '');
        }
        units.forEach(function (unit) {
            switch (unit.type) {
                // NDR
                case 1:
                    push = true;
                    if (!avcSample) {
                        avcSample = _this.avcSample = createAVCSample(true, pes.pts, pes.dts, '');
                    }
                    if (debug) {
                        avcSample.debug += 'NDR ';
                    }
                    avcSample.frame = true;
                    var data = unit.data;
                    // only check slice type to detect KF in case SPS found in same packet (any keyframe is preceded by SPS ...)
                    if (spsfound && data.length > 4) {
                        // retrieve slice type by parsing beginning of NAL unit (follow H264 spec, slice_header definition) to detect keyframe embedded in NDR
                        var sliceType = new exp_golomb_1.default(data).readSliceType();
                        // 2 : I slice, 4 : SI slice, 7 : I slice, 9: SI slice
                        // SI slice : A slice that is coded using intra prediction only and using quantisation of the prediction samples.
                        // An SI slice can be coded such that its decoded samples can be constructed identically to an SP slice.
                        // I slice: A slice that is not an SI slice that is decoded using intra prediction only.
                        // if (sliceType === 2 || sliceType === 7) {
                        if (sliceType === 2 || sliceType === 4 || sliceType === 7 || sliceType === 9) {
                            avcSample.key = true;
                        }
                    }
                    break;
                // IDR
                case 5:
                    push = true;
                    // handle PES not starting with AUD
                    if (!avcSample) {
                        avcSample = _this.avcSample = createAVCSample(true, pes.pts, pes.dts, '');
                    }
                    if (debug) {
                        avcSample.debug += 'IDR ';
                    }
                    avcSample.key = true;
                    avcSample.frame = true;
                    break;
                // SEI
                case 6:
                    push = true;
                    if (debug && avcSample) {
                        avcSample.debug += 'SEI ';
                    }
                    expGolombDecoder = new exp_golomb_1.default(_this.discardEPB(unit.data));
                    // skip frameType
                    expGolombDecoder.readUByte();
                    var payloadType = 0;
                    var payloadSize = 0;
                    var endOfCaptions = false;
                    var b = 0;
                    while (!endOfCaptions && expGolombDecoder.bytesAvailable > 1) {
                        payloadType = 0;
                        do {
                            b = expGolombDecoder.readUByte();
                            payloadType += b;
                        } while (b === 0xFF);
                        // Parse payload size.
                        payloadSize = 0;
                        do {
                            b = expGolombDecoder.readUByte();
                            payloadSize += b;
                        } while (b === 0xFF);
                        // TODO: there can be more than one payload in an SEI packet...
                        // TODO: need to read type and size in a while loop to get them all
                        if (payloadType === 4 && expGolombDecoder.bytesAvailable !== 0) {
                            endOfCaptions = true;
                            var countryCode = expGolombDecoder.readUByte();
                            if (countryCode === 181) {
                                var providerCode = expGolombDecoder.readUShort();
                                if (providerCode === 49) {
                                    var userStructure = expGolombDecoder.readUInt();
                                    if (userStructure === 0x47413934) {
                                        var userDataType = expGolombDecoder.readUByte();
                                        // Raw CEA-608 bytes wrapped in CEA-708 packet
                                        if (userDataType === 3) {
                                            var firstByte = expGolombDecoder.readUByte();
                                            var secondByte = expGolombDecoder.readUByte();
                                            var totalCCs = 31 & firstByte;
                                            var byteArray = [firstByte, secondByte];
                                            for (i = 0; i < totalCCs; i++) {
                                                // 3 bytes per CC
                                                byteArray.push(expGolombDecoder.readUByte());
                                                byteArray.push(expGolombDecoder.readUByte());
                                                byteArray.push(expGolombDecoder.readUByte());
                                            }
                                            _this._insertSampleInOrder(_this._txtTrack.samples, { type: 3, pts: pes.pts, bytes: byteArray });
                                        }
                                    }
                                }
                            }
                        }
                        else if (payloadSize < expGolombDecoder.bytesAvailable) {
                            for (i = 0; i < payloadSize; i++) {
                                expGolombDecoder.readUByte();
                            }
                        }
                    }
                    break;
                // SPS
                case 7:
                    push = true;
                    spsfound = true;
                    if (debug && avcSample) {
                        avcSample.debug += 'SPS ';
                    }
                    if (!track.sps) {
                        expGolombDecoder = new exp_golomb_1.default(unit.data);
                        var config = expGolombDecoder.readSPS();
                        track.width = config.width;
                        track.height = config.height;
                        track.pixelRatio = config.pixelRatio;
                        track.sps = [unit.data];
                        track.duration = _this._duration;
                        var codecarray = unit.data.subarray(1, 4);
                        var codecstring = 'avc1.';
                        for (i = 0; i < 3; i++) {
                            var h = codecarray[i].toString(16);
                            if (h.length < 2) {
                                h = '0' + h;
                            }
                            codecstring += h;
                        }
                        track.codec = codecstring;
                    }
                    break;
                // PPS
                case 8:
                    push = true;
                    if (debug && avcSample) {
                        avcSample.debug += 'PPS ';
                    }
                    if (!track.pps) {
                        track.pps = [unit.data];
                    }
                    break;
                // AUD
                case 9:
                    push = false;
                    track.audFound = true;
                    if (avcSample) {
                        pushAccesUnit(avcSample, track);
                    }
                    avcSample = _this.avcSample = createAVCSample(false, pes.pts, pes.dts, debug ? 'AUD ' : '');
                    break;
                // Filler Data
                case 12:
                    push = false;
                    break;
                default:
                    push = false;
                    if (avcSample) {
                        avcSample.debug += 'unknown NAL ' + unit.type + ' ';
                    }
                    break;
            }
            if (avcSample && push) {
                var units_1 = avcSample.units;
                units_1.push(unit);
            }
        });
        // if last PES packet, push samples
        if (last && avcSample) {
            pushAccesUnit(avcSample, track);
            this.avcSample = null;
        }
    };
    TSDemuxer.prototype._insertSampleInOrder = function (arr, data) {
        var len = arr.length;
        if (len > 0) {
            if (data.pts >= arr[len - 1].pts) {
                arr.push(data);
            }
            else {
                for (var pos = len - 1; pos >= 0; pos--) {
                    if (data.pts < arr[pos].pts) {
                        arr.splice(pos, 0, data);
                        break;
                    }
                }
            }
        }
        else {
            arr.push(data);
        }
    };
    TSDemuxer.prototype._getLastNalUnit = function () {
        var avcSample = this.avcSample, lastUnit;
        // try to fallback to previous sample if current one is empty
        if (!avcSample || avcSample.units.length === 0) {
            var track = this._avcTrack, samples = track.samples;
            avcSample = samples[samples.length - 1];
        }
        if (avcSample) {
            var units = avcSample.units;
            lastUnit = units[units.length - 1];
        }
        return lastUnit;
    };
    TSDemuxer.prototype._parseAVCNALu = function (array) {
        var i = 0, len = array.byteLength, value, overflow, track = this._avcTrack, state = track.naluState || 0, lastState = state;
        var units = [], unit, unitType, lastUnitStart = -1, lastUnitType;
        // logger.log('PES:' + Hex.hexDump(array));
        if (state === -1) {
            // special use case where we found 3 or 4-byte start codes exactly at the end of previous PES packet
            lastUnitStart = 0;
            // NALu type is value read from offset 0
            lastUnitType = array[0] & 0x1f;
            state = 0;
            i = 1;
        }
        while (i < len) {
            value = array[i++];
            // optimization. state 0 and 1 are the predominant case. let's handle them outside of the switch/case
            if (!state) {
                state = value ? 0 : 1;
                continue;
            }
            if (state === 1) {
                state = value ? 0 : 2;
                continue;
            }
            // here we have state either equal to 2 or 3
            if (!value) {
                state = 3;
            }
            else if (value === 1) {
                if (lastUnitStart >= 0) {
                    unit = { data: array.subarray(lastUnitStart, i - state - 1), type: lastUnitType };
                    // logger.log('pushing NALU, type/size:' + unit.type + '/' + unit.data.byteLength);
                    units.push(unit);
                }
                else {
                    // lastUnitStart is undefined => this is the first start code found in this PES packet
                    // first check if start code delimiter is overlapping between 2 PES packets,
                    // ie it started in last packet (lastState not zero)
                    // and ended at the beginning of this PES packet (i <= 4 - lastState)
                    var lastUnit = this._getLastNalUnit();
                    if (lastUnit) {
                        if (lastState && (i <= 4 - lastState)) {
                            // start delimiter overlapping between PES packets
                            // strip start delimiter bytes from the end of last NAL unit
                            // check if lastUnit had a state different from zero
                            if (lastUnit.state) {
                                // strip last bytes
                                lastUnit.data = lastUnit.data.subarray(0, lastUnit.data.byteLength - lastState);
                            }
                        }
                        // If NAL units are not starting right at the beginning of the PES packet, push preceding data into previous NAL unit.
                        overflow = i - state - 1;
                        if (overflow > 0) {
                            // logger.log('first NALU found with overflow:' + overflow);
                            var tmp = new Uint8Array(lastUnit.data.byteLength + overflow);
                            tmp.set(lastUnit.data, 0);
                            tmp.set(array.subarray(0, overflow), lastUnit.data.byteLength);
                            lastUnit.data = tmp;
                        }
                    }
                }
                // check if we can read unit type
                if (i < len) {
                    unitType = array[i] & 0x1f;
                    // logger.log('find NALU @ offset:' + i + ',type:' + unitType);
                    lastUnitStart = i;
                    lastUnitType = unitType;
                    state = 0;
                }
                else {
                    // not enough byte to read unit type. let's read it on next PES parsing
                    state = -1;
                }
            }
            else {
                state = 0;
            }
        }
        if (lastUnitStart >= 0 && state >= 0) {
            unit = { data: array.subarray(lastUnitStart, len), type: lastUnitType, state: state };
            units.push(unit);
            // logger.log('pushing NALU, type/size/state:' + unit.type + '/' + unit.data.byteLength + '/' + state);
        }
        // no NALu found
        if (units.length === 0) {
            // append pes.data to previous NAL unit
            var lastUnit = this._getLastNalUnit();
            if (lastUnit) {
                var tmp = new Uint8Array(lastUnit.data.byteLength + array.byteLength);
                tmp.set(lastUnit.data, 0);
                tmp.set(array, lastUnit.data.byteLength);
                lastUnit.data = tmp;
            }
        }
        track.naluState = state;
        return units;
    };
    /**
     * remove Emulation Prevention bytes from a RBSP
     */
    TSDemuxer.prototype.discardEPB = function (data) {
        var length = data.byteLength, EPBPositions = [], i = 1, newLength, newData;
        // Find all `Emulation Prevention Bytes`
        while (i < length - 2) {
            if (data[i] === 0 &&
                data[i + 1] === 0 &&
                data[i + 2] === 0x03) {
                EPBPositions.push(i + 2);
                i += 2;
            }
            else {
                i++;
            }
        }
        // If no Emulation Prevention Bytes were found just return the original
        // array
        if (EPBPositions.length === 0) {
            return data;
        }
        // Create a new array to hold the NAL unit data
        newLength = length - EPBPositions.length;
        newData = new Uint8Array(newLength);
        var sourceIndex = 0;
        for (i = 0; i < newLength; sourceIndex++, i++) {
            if (sourceIndex === EPBPositions[0]) {
                // Skip this byte
                sourceIndex++;
                // Remove this position index
                EPBPositions.shift();
            }
            newData[i] = data[sourceIndex];
        }
        return newData;
    };
    TSDemuxer.prototype._parseAACPES = function (pes) {
        var track = this._audioTrack, data = pes.data, pts = pes.pts, startOffset = 0, aacOverFlow = this.aacOverFlow, aacLastPTS = this.aacLastPTS, frameDuration, frameIndex, offset, stamp, len;
        if (aacOverFlow) {
            var tmp = new Uint8Array(aacOverFlow.byteLength + data.byteLength);
            tmp.set(aacOverFlow, 0);
            tmp.set(data, aacOverFlow.byteLength);
            // logger.log(`AAC: append overflowing ${aacOverFlow.byteLength} bytes to beginning of new PES`);
            data = tmp;
        }
        // look for ADTS header (0xFFFx)
        for (offset = startOffset, len = data.length; offset < len - 1; offset++) {
            if (ADTS.isHeader(data, offset)) {
                break;
            }
        }
        // if ADTS header does not start straight from the beginning of the PES payload, raise an error
        if (offset) {
            var reason = void 0, fatal = void 0;
            if (offset < len - 1) {
                reason = "AAC PES did not start with ADTS header,offset:" + offset;
                fatal = false;
            }
            else {
                reason = 'no ADTS header found in AAC PES';
                fatal = true;
            }
            logger_1.logger.warn("parsing error:" + reason);
            this.observer.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MEDIA_ERROR, details: errors_1.ErrorDetails.FRAG_PARSING_ERROR, fatal: fatal, reason: reason });
            if (fatal) {
                return;
            }
        }
        ADTS.initTrackConfig(track, this.observer, data, offset, this.audioCodec);
        frameIndex = 0;
        frameDuration = ADTS.getFrameDuration(track.samplerate);
        // if last AAC frame is overflowing, we should ensure timestamps are contiguous:
        // first sample PTS should be equal to last sample PTS + frameDuration
        if (aacOverFlow && aacLastPTS) {
            var newPTS = aacLastPTS + frameDuration;
            if (Math.abs(newPTS - pts) > 1) {
                logger_1.logger.log("AAC: align PTS for overlapping frames by " + Math.round((newPTS - pts) / 90));
                pts = newPTS;
            }
        }
        // scan for aac samples
        while (offset < len) {
            if (ADTS.isHeader(data, offset) && (offset + 5) < len) {
                var frame = ADTS.appendFrame(track, data, offset, pts, frameIndex);
                if (frame) {
                    // logger.log(`${Math.round(frame.sample.pts)} : AAC`);
                    offset += frame.length;
                    stamp = frame.sample.pts;
                    frameIndex++;
                }
                else {
                    // logger.log('Unable to parse AAC frame');
                    break;
                }
            }
            else {
                // nothing found, keep looking
                offset++;
            }
        }
        if (offset < len) {
            aacOverFlow = data.subarray(offset, len);
            // logger.log(`AAC: overflow detected:${len-offset}`);
        }
        else {
            aacOverFlow = null;
        }
        this.aacOverFlow = aacOverFlow;
        this.aacLastPTS = stamp;
    };
    TSDemuxer.prototype._parseMPEGPES = function (pes) {
        var data = pes.data;
        var length = data.length;
        var frameIndex = 0;
        var offset = 0;
        var pts = pes.pts;
        while (offset < length) {
            if (mpegaudio_1.default.isHeader(data, offset)) {
                var frame = mpegaudio_1.default.appendFrame(this._audioTrack, data, offset, pts, frameIndex);
                if (frame) {
                    offset += frame.length;
                    frameIndex++;
                }
                else {
                    // logger.log('Unable to parse Mpeg audio frame');
                    break;
                }
            }
            else {
                // nothing found, keep looking
                offset++;
            }
        }
    };
    TSDemuxer.prototype._parseID3PES = function (pes) {
        this._id3Track.samples.push(pes);
    };
    return TSDemuxer;
}());
exports.default = TSDemuxer;


/***/ }),

/***/ "./src/errors.js":
/*!***********************!*\
  !*** ./src/errors.js ***!
  \***********************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorTypes = {
    // Identifier for a network error (loading error / timeout ...)
    NETWORK_ERROR: 'networkError',
    // Identifier for a media Error (video/parsing/mediasource error)
    MEDIA_ERROR: 'mediaError',
    // EME (encrypted media extensions) errors
    KEY_SYSTEM_ERROR: 'keySystemError',
    // Identifier for a mux Error (demuxing/remuxing)
    MUX_ERROR: 'muxError',
    // Identifier for all other errors
    OTHER_ERROR: 'otherError'
};
/**
 * @enum {ErrorDetails}
 * @typedef {string} ErrorDetail
 */
exports.ErrorDetails = {
    KEY_SYSTEM_NO_KEYS: 'keySystemNoKeys',
    KEY_SYSTEM_NO_ACCESS: 'keySystemNoAccess',
    KEY_SYSTEM_NO_SESSION: 'keySystemNoSession',
    KEY_SYSTEM_LICENSE_REQUEST_FAILED: 'keySystemLicenseRequestFailed',
    // Identifier for a manifest load error - data: { url : faulty URL, response : { code: error code, text: error text }}
    MANIFEST_LOAD_ERROR: 'manifestLoadError',
    // Identifier for a manifest load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
    MANIFEST_LOAD_TIMEOUT: 'manifestLoadTimeOut',
    // Identifier for a manifest parsing error - data: { url : faulty URL, reason : error reason}
    MANIFEST_PARSING_ERROR: 'manifestParsingError',
    // Identifier for a manifest with only incompatible codecs error - data: { url : faulty URL, reason : error reason}
    MANIFEST_INCOMPATIBLE_CODECS_ERROR: 'manifestIncompatibleCodecsError',
    // Identifier for a level load error - data: { url : faulty URL, response : { code: error code, text: error text }}
    LEVEL_LOAD_ERROR: 'levelLoadError',
    // Identifier for a level load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
    LEVEL_LOAD_TIMEOUT: 'levelLoadTimeOut',
    // Identifier for a level switch error - data: { level : faulty level Id, event : error description}
    LEVEL_SWITCH_ERROR: 'levelSwitchError',
    // Identifier for an audio track load error - data: { url : faulty URL, response : { code: error code, text: error text }}
    AUDIO_TRACK_LOAD_ERROR: 'audioTrackLoadError',
    // Identifier for an audio track load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
    AUDIO_TRACK_LOAD_TIMEOUT: 'audioTrackLoadTimeOut',
    // Identifier for fragment load error - data: { frag : fragment object, response : { code: error code, text: error text }}
    FRAG_LOAD_ERROR: 'fragLoadError',
    // Identifier for fragment load timeout error - data: { frag : fragment object}
    FRAG_LOAD_TIMEOUT: 'fragLoadTimeOut',
    // Identifier for a fragment decryption error event - data: {id : demuxer Id,frag: fragment object, reason : parsing error description }
    FRAG_DECRYPT_ERROR: 'fragDecryptError',
    // Identifier for a fragment parsing error event - data: { id : demuxer Id, reason : parsing error description }
    // will be renamed DEMUX_PARSING_ERROR and switched to MUX_ERROR in the next major release
    FRAG_PARSING_ERROR: 'fragParsingError',
    // Identifier for a remux alloc error event - data: { id : demuxer Id, frag : fragment object, bytes : nb of bytes on which allocation failed , reason : error text }
    REMUX_ALLOC_ERROR: 'remuxAllocError',
    // Identifier for decrypt key load error - data: { frag : fragment object, response : { code: error code, text: error text }}
    KEY_LOAD_ERROR: 'keyLoadError',
    // Identifier for decrypt key load timeout error - data: { frag : fragment object}
    KEY_LOAD_TIMEOUT: 'keyLoadTimeOut',
    // Triggered when an exception occurs while adding a sourceBuffer to MediaSource - data : {  err : exception , mimeType : mimeType }
    BUFFER_ADD_CODEC_ERROR: 'bufferAddCodecError',
    // Identifier for a buffer append error - data: append error description
    BUFFER_APPEND_ERROR: 'bufferAppendError',
    // Identifier for a buffer appending error event - data: appending error description
    BUFFER_APPENDING_ERROR: 'bufferAppendingError',
    // Identifier for a buffer stalled error event
    BUFFER_STALLED_ERROR: 'bufferStalledError',
    // Identifier for a buffer full event
    BUFFER_FULL_ERROR: 'bufferFullError',
    // Identifier for a buffer seek over hole event
    BUFFER_SEEK_OVER_HOLE: 'bufferSeekOverHole',
    // Identifier for a buffer nudge on stall (playback is stuck although currentTime is in a buffered area)
    BUFFER_NUDGE_ON_STALL: 'bufferNudgeOnStall',
    // Identifier for an internal exception happening inside hls.js while handling an event
    INTERNAL_EXCEPTION: 'internalException'
};


/***/ }),

/***/ "./src/event-handler.js":
/*!******************************!*\
  !*** ./src/event-handler.js ***!
  \******************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
*
* All objects in the event handling chain should inherit from this class
*
*/
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = __webpack_require__(/*! ./utils/logger */ "./src/utils/logger.js");
var errors_1 = __webpack_require__(/*! ./errors */ "./src/errors.js");
var events_1 = __webpack_require__(/*! ./events */ "./src/events.js");
var FORBIDDEN_EVENT_NAMES = {
    'hlsEventGeneric': true,
    'hlsHandlerDestroying': true,
    'hlsHandlerDestroyed': true
};
var EventHandler = /** @class */ (function () {
    function EventHandler(hls) {
        var events = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            events[_i - 1] = arguments[_i];
        }
        this.hls = hls;
        this.onEvent = this.onEvent.bind(this);
        this.handledEvents = events;
        this.useGenericHandler = true;
        this.registerListeners();
    }
    EventHandler.prototype.destroy = function () {
        this.onHandlerDestroying();
        this.unregisterListeners();
        this.onHandlerDestroyed();
    };
    EventHandler.prototype.onHandlerDestroying = function () { };
    EventHandler.prototype.onHandlerDestroyed = function () { };
    EventHandler.prototype.isEventHandler = function () {
        return typeof this.handledEvents === 'object' && this.handledEvents.length && typeof this.onEvent === 'function';
    };
    EventHandler.prototype.registerListeners = function () {
        if (this.isEventHandler()) {
            this.handledEvents.forEach(function (event) {
                if (FORBIDDEN_EVENT_NAMES[event]) {
                    throw new Error('Forbidden event-name: ' + event);
                }
                this.hls.on(event, this.onEvent);
            }, this);
        }
    };
    EventHandler.prototype.unregisterListeners = function () {
        if (this.isEventHandler()) {
            this.handledEvents.forEach(function (event) {
                this.hls.off(event, this.onEvent);
            }, this);
        }
    };
    /**
     * arguments: event (string), data (any)
     */
    EventHandler.prototype.onEvent = function (event, data) {
        this.onEventGeneric(event, data);
    };
    EventHandler.prototype.onEventGeneric = function (event, data) {
        var eventToFunction = function (event, data) {
            var funcName = 'on' + event.replace('hls', '');
            if (typeof this[funcName] !== 'function') {
                throw new Error("Event " + event + " has no generic handler in this " + this.constructor.name + " class (tried " + funcName + ")");
            }
            return this[funcName].bind(this, data);
        };
        try {
            eventToFunction.call(this, event, data).call();
        }
        catch (err) {
            logger_1.logger.error("An internal error happened while handling event " + event + ". Error message: \"" + err.message + "\". Here is a stacktrace:", err);
            this.hls.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.OTHER_ERROR, details: errors_1.ErrorDetails.INTERNAL_EXCEPTION, fatal: false, event: event, err: err });
        }
    };
    return EventHandler;
}());
exports.default = EventHandler;


/***/ }),

/***/ "./src/events.js":
/*!***********************!*\
  !*** ./src/events.js ***!
  \***********************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @readonly
 * @enum {string}
 */
var HlsEvents = {
    // fired before MediaSource is attaching to media element - data: { media }
    MEDIA_ATTACHING: 'hlsMediaAttaching',
    // fired when MediaSource has been succesfully attached to media element - data: { }
    MEDIA_ATTACHED: 'hlsMediaAttached',
    // fired before detaching MediaSource from media element - data: { }
    MEDIA_DETACHING: 'hlsMediaDetaching',
    // fired when MediaSource has been detached from media element - data: { }
    MEDIA_DETACHED: 'hlsMediaDetached',
    // fired when we buffer is going to be reset - data: { }
    BUFFER_RESET: 'hlsBufferReset',
    // fired when we know about the codecs that we need buffers for to push into - data: {tracks : { container, codec, levelCodec, initSegment, metadata }}
    BUFFER_CODECS: 'hlsBufferCodecs',
    // fired when sourcebuffers have been created - data: { tracks : tracks }
    BUFFER_CREATED: 'hlsBufferCreated',
    // fired when we append a segment to the buffer - data: { segment: segment object }
    BUFFER_APPENDING: 'hlsBufferAppending',
    // fired when we are done with appending a media segment to the buffer - data : { parent : segment parent that triggered BUFFER_APPENDING, pending : nb of segments waiting for appending for this segment parent}
    BUFFER_APPENDED: 'hlsBufferAppended',
    // fired when the stream is finished and we want to notify the media buffer that there will be no more data - data: { }
    BUFFER_EOS: 'hlsBufferEos',
    // fired when the media buffer should be flushed - data { startOffset, endOffset }
    BUFFER_FLUSHING: 'hlsBufferFlushing',
    // fired when the media buffer has been flushed - data: { }
    BUFFER_FLUSHED: 'hlsBufferFlushed',
    // fired to signal that a manifest loading starts - data: { url : manifestURL}
    MANIFEST_LOADING: 'hlsManifestLoading',
    // fired after manifest has been loaded - data: { levels : [available quality levels], audioTracks : [ available audio tracks], url : manifestURL, stats : { trequest, tfirst, tload, mtime}}
    MANIFEST_LOADED: 'hlsManifestLoaded',
    // fired after manifest has been parsed - data: { levels : [available quality levels], firstLevel : index of first quality level appearing in Manifest}
    MANIFEST_PARSED: 'hlsManifestParsed',
    // fired when a level switch is requested - data: { level : id of new level }
    LEVEL_SWITCHING: 'hlsLevelSwitching',
    // fired when a level switch is effective - data: { level : id of new level }
    LEVEL_SWITCHED: 'hlsLevelSwitched',
    // fired when a level playlist loading starts - data: { url : level URL, level : id of level being loaded}
    LEVEL_LOADING: 'hlsLevelLoading',
    // fired when a level playlist loading finishes - data: { details : levelDetails object, level : id of loaded level, stats : { trequest, tfirst, tload, mtime} }
    LEVEL_LOADED: 'hlsLevelLoaded',
    // fired when a level's details have been updated based on previous details, after it has been loaded - data: { details : levelDetails object, level : id of updated level }
    LEVEL_UPDATED: 'hlsLevelUpdated',
    // fired when a level's PTS information has been updated after parsing a fragment - data: { details : levelDetails object, level : id of updated level, drift: PTS drift observed when parsing last fragment }
    LEVEL_PTS_UPDATED: 'hlsLevelPtsUpdated',
    // fired to notify that audio track lists has been updated - data: { audioTracks : audioTracks }
    AUDIO_TRACKS_UPDATED: 'hlsAudioTracksUpdated',
    // fired when an audio track switching is requested - data: { id : audio track id }
    AUDIO_TRACK_SWITCHING: 'hlsAudioTrackSwitching',
    // fired when an audio track switch actually occurs - data: { id : audio track id }
    AUDIO_TRACK_SWITCHED: 'hlsAudioTrackSwitched',
    // fired when an audio track loading starts - data: { url : audio track URL, id : audio track id }
    AUDIO_TRACK_LOADING: 'hlsAudioTrackLoading',
    // fired when an audio track loading finishes - data: { details : levelDetails object, id : audio track id, stats : { trequest, tfirst, tload, mtime } }
    AUDIO_TRACK_LOADED: 'hlsAudioTrackLoaded',
    // fired to notify that subtitle track lists has been updated - data: { subtitleTracks : subtitleTracks }
    SUBTITLE_TRACKS_UPDATED: 'hlsSubtitleTracksUpdated',
    // fired when an subtitle track switch occurs - data: { id : subtitle track id }
    SUBTITLE_TRACK_SWITCH: 'hlsSubtitleTrackSwitch',
    // fired when a subtitle track loading starts - data: { url : subtitle track URL, id : subtitle track id }
    SUBTITLE_TRACK_LOADING: 'hlsSubtitleTrackLoading',
    // fired when a subtitle track loading finishes - data: { details : levelDetails object, id : subtitle track id, stats : { trequest, tfirst, tload, mtime } }
    SUBTITLE_TRACK_LOADED: 'hlsSubtitleTrackLoaded',
    // fired when a subtitle fragment has been processed - data: { success : boolean, frag : the processed frag }
    SUBTITLE_FRAG_PROCESSED: 'hlsSubtitleFragProcessed',
    // fired when the first timestamp is found - data: { id : demuxer id, initPTS: initPTS, frag : fragment object }
    INIT_PTS_FOUND: 'hlsInitPtsFound',
    // fired when a fragment loading starts - data: { frag : fragment object }
    FRAG_LOADING: 'hlsFragLoading',
    // fired when a fragment loading is progressing - data: { frag : fragment object, { trequest, tfirst, loaded } }
    FRAG_LOAD_PROGRESS: 'hlsFragLoadProgress',
    // Identifier for fragment load aborting for emergency switch down - data: { frag : fragment object }
    FRAG_LOAD_EMERGENCY_ABORTED: 'hlsFragLoadEmergencyAborted',
    // fired when a fragment loading is completed - data: { frag : fragment object, payload : fragment payload, stats : { trequest, tfirst, tload, length } }
    FRAG_LOADED: 'hlsFragLoaded',
    // fired when a fragment has finished decrypting - data: { id : demuxer id, frag: fragment object, payload : fragment payload, stats : { tstart, tdecrypt } }
    FRAG_DECRYPTED: 'hlsFragDecrypted',
    // fired when Init Segment has been extracted from fragment - data: { id : demuxer id, frag: fragment object, moov : moov MP4 box, codecs : codecs found while parsing fragment }
    FRAG_PARSING_INIT_SEGMENT: 'hlsFragParsingInitSegment',
    // fired when parsing sei text is completed - data: { id : demuxer id, frag: fragment object, samples : [ sei samples pes ] }
    FRAG_PARSING_USERDATA: 'hlsFragParsingUserdata',
    // fired when parsing id3 is completed - data: { id : demuxer id, frag: fragment object, samples : [ id3 samples pes ] }
    FRAG_PARSING_METADATA: 'hlsFragParsingMetadata',
    // fired when data have been extracted from fragment - data: { id : demuxer id, frag: fragment object, data1 : moof MP4 box or TS fragments, data2 : mdat MP4 box or null}
    FRAG_PARSING_DATA: 'hlsFragParsingData',
    // fired when fragment parsing is completed - data: { id : demuxer id, frag: fragment object }
    FRAG_PARSED: 'hlsFragParsed',
    // fired when fragment remuxed MP4 boxes have all been appended into SourceBuffer - data: { id : demuxer id, frag : fragment object, stats : { trequest, tfirst, tload, tparsed, tbuffered, length, bwEstimate } }
    FRAG_BUFFERED: 'hlsFragBuffered',
    // fired when fragment matching with current media position is changing - data : { id : demuxer id, frag : fragment object }
    FRAG_CHANGED: 'hlsFragChanged',
    // Identifier for a FPS drop event - data: { curentDropped, currentDecoded, totalDroppedFrames }
    FPS_DROP: 'hlsFpsDrop',
    // triggered when FPS drop triggers auto level capping - data: { level, droppedlevel }
    FPS_DROP_LEVEL_CAPPING: 'hlsFpsDropLevelCapping',
    // Identifier for an error event - data: { type : error type, details : error details, fatal : if true, hls.js cannot/will not try to recover, if false, hls.js will try to recover,other error specific data }
    ERROR: 'hlsError',
    // fired when hls.js instance starts destroying. Different from MEDIA_DETACHED as one could want to detach and reattach a media to the instance of hls.js to handle mid-rolls for example - data: { }
    DESTROYING: 'hlsDestroying',
    // fired when a decrypt key loading starts - data: { frag : fragment object }
    KEY_LOADING: 'hlsKeyLoading',
    // fired when a decrypt key loading is completed - data: { frag : fragment object, payload : key payload, stats : { trequest, tfirst, tload, length } }
    KEY_LOADED: 'hlsKeyLoaded',
    // fired upon stream controller state transitions - data: { previousState, nextState }
    STREAM_STATE_TRANSITION: 'hlsStreamStateTransition'
};
exports.default = HlsEvents;


/***/ }),

/***/ "./src/hls.js":
/*!********************!*\
  !*** ./src/hls.js ***!
  \********************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var URLToolkit = __webpack_require__(/*! url-toolkit */ "./node_modules/url-toolkit/src/url-toolkit.js");
var errors_1 = __webpack_require__(/*! ./errors */ "./src/errors.js");
var playlist_loader_1 = __webpack_require__(/*! ./loader/playlist-loader */ "./src/loader/playlist-loader.js");
var fragment_loader_1 = __webpack_require__(/*! ./loader/fragment-loader */ "./src/loader/fragment-loader.js");
var key_loader_1 = __webpack_require__(/*! ./loader/key-loader */ "./src/loader/key-loader.js");
var fragment_tracker_1 = __webpack_require__(/*! ./controller/fragment-tracker */ "./src/controller/fragment-tracker.js");
var stream_controller_1 = __webpack_require__(/*! ./controller/stream-controller */ "./src/controller/stream-controller.js");
var level_controller_1 = __webpack_require__(/*! ./controller/level-controller */ "./src/controller/level-controller.js");
var id3_track_controller_1 = __webpack_require__(/*! ./controller/id3-track-controller */ "./src/controller/id3-track-controller.js");
var is_supported_1 = __webpack_require__(/*! ./is-supported */ "./src/is-supported.js");
var logger_1 = __webpack_require__(/*! ./utils/logger */ "./src/utils/logger.js");
var config_1 = __webpack_require__(/*! ./config */ "./src/config.js");
var events_1 = __webpack_require__(/*! ./events */ "./src/events.js");
var observer_1 = __webpack_require__(/*! ./observer */ "./src/observer.js");
/**
 * @module Hls
 * @class
 * @constructor
 */
var Hls = /** @class */ (function (_super) {
    __extends(Hls, _super);
    /**
     * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
     *
     * @constructs Hls
     * @param {HlsConfig} config
     */
    function Hls(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        var defaultConfig = Hls.DefaultConfig;
        if ((config.liveSyncDurationCount || config.liveMaxLatencyDurationCount) && (config.liveSyncDuration || config.liveMaxLatencyDuration)) {
            throw new Error('Illegal hls.js config: don\'t mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration');
        }
        for (var prop in defaultConfig) {
            if (prop in config)
                continue;
            config[prop] = defaultConfig[prop];
        }
        if (config.liveMaxLatencyDurationCount !== undefined && config.liveMaxLatencyDurationCount <= config.liveSyncDurationCount) {
            throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be gt "liveSyncDurationCount"');
        }
        if (config.liveMaxLatencyDuration !== undefined && (config.liveMaxLatencyDuration <= config.liveSyncDuration || config.liveSyncDuration === undefined)) {
            throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be gt "liveSyncDuration"');
        }
        logger_1.enableLogs(config.debug);
        _this.config = config;
        _this._autoLevelCapping = -1;
        // core controllers and network loaders
        /**
         * @member {AbrController} abrController
         */
        var abrController = _this.abrController = new config.abrController(_this);
        var bufferController = new config.bufferController(_this);
        var capLevelController = new config.capLevelController(_this);
        var fpsController = new config.fpsController(_this);
        var playListLoader = new playlist_loader_1.default(_this);
        var fragmentLoader = new fragment_loader_1.default(_this);
        var keyLoader = new key_loader_1.default(_this);
        var id3TrackController = new id3_track_controller_1.default(_this);
        // network controllers
        /**
         * @member {LevelController} levelController
         */
        var levelController = _this.levelController = new level_controller_1.default(_this);
        // FIXME: FragmentTracker must be defined before StreamController because the order of event handling is important
        var fragmentTracker = new fragment_tracker_1.FragmentTracker(_this);
        /**
         * @member {StreamController} streamController
         */
        var streamController = _this.streamController = new stream_controller_1.default(_this, fragmentTracker);
        var networkControllers = [levelController, streamController];
        // optional audio stream controller
        /**
         * @var {ICoreComponent | Controller}
         */
        var Controller = config.audioStreamController;
        if (Controller) {
            networkControllers.push(new Controller(_this, fragmentTracker));
        }
        /**
         * @member {INetworkController[]} networkControllers
         */
        _this.networkControllers = networkControllers;
        /**
         * @var {ICoreComponent[]}
         */
        var coreComponents = [
            playListLoader,
            fragmentLoader,
            keyLoader,
            abrController,
            bufferController,
            capLevelController,
            fpsController,
            id3TrackController,
            fragmentTracker
        ];
        // optional audio track and subtitle controller
        Controller = config.audioTrackController;
        if (Controller) {
            var audioTrackController = new Controller(_this);
            /**
             * @member {AudioTrackController} audioTrackController
             */
            _this.audioTrackController = audioTrackController;
            coreComponents.push(audioTrackController);
        }
        Controller = config.subtitleTrackController;
        if (Controller) {
            var subtitleTrackController = new Controller(_this);
            /**
             * @member {SubtitleTrackController} subtitleTrackController
             */
            _this.subtitleTrackController = subtitleTrackController;
            networkControllers.push(subtitleTrackController);
        }
        Controller = config.emeController;
        if (Controller) {
            var emeController = new Controller(_this);
            /**
             * @member {EMEController} emeController
             */
            _this.emeController = emeController;
            coreComponents.push(emeController);
        }
        // optional subtitle controllers
        Controller = config.subtitleStreamController;
        if (Controller) {
            networkControllers.push(new Controller(_this, fragmentTracker));
        }
        Controller = config.timelineController;
        if (Controller) {
            coreComponents.push(new Controller(_this));
        }
        /**
         * @member {ICoreComponent[]}
         */
        _this.coreComponents = coreComponents;
        return _this;
    }
    Object.defineProperty(Hls, "version", {
        /**
         * @type {string}
         */
        get: function () {
            return "0.12.4";
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @type {boolean}
     */
    Hls.isSupported = function () {
        return is_supported_1.isSupported();
    };
    Object.defineProperty(Hls, "Events", {
        /**
         * @type {HlsEvents}
         */
        get: function () {
            return events_1.default;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls, "ErrorTypes", {
        /**
         * @type {HlsErrorTypes}
         */
        get: function () {
            return errors_1.ErrorTypes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls, "ErrorDetails", {
        /**
         * @type {HlsErrorDetails}
         */
        get: function () {
            return errors_1.ErrorDetails;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls, "DefaultConfig", {
        /**
         * @type {HlsConfig}
         */
        get: function () {
            if (!Hls.defaultConfig) {
                return config_1.hlsDefaultConfig;
            }
            return Hls.defaultConfig;
        },
        /**
         * @type {HlsConfig}
         */
        set: function (defaultConfig) {
            Hls.defaultConfig = defaultConfig;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Dispose of the instance
     */
    Hls.prototype.destroy = function () {
        logger_1.logger.log('destroy');
        this.trigger(events_1.default.DESTROYING);
        this.detachMedia();
        this.coreComponents.concat(this.networkControllers).forEach(function (component) {
            component.destroy();
        });
        this.url = null;
        this.removeAllListeners();
        this._autoLevelCapping = -1;
    };
    /**
     * Attach a media element
     * @param {HTMLMediaElement} media
     */
    Hls.prototype.attachMedia = function (media) {
        logger_1.logger.log('attachMedia');
        this.media = media;
        this.trigger(events_1.default.MEDIA_ATTACHING, { media: media });
    };
    /**
     * Detach from the media
     */
    Hls.prototype.detachMedia = function () {
        logger_1.logger.log('detachMedia');
        this.trigger(events_1.default.MEDIA_DETACHING);
        this.media = null;
    };
    /**
     * Set the source URL. Can be relative or absolute.
     * @param {string} url
     */
    Hls.prototype.loadSource = function (url) {
        url = URLToolkit.buildAbsoluteURL(window.location.href, url, { alwaysNormalize: true });
        logger_1.logger.log("loadSource:" + url);
        this.url = url;
        // when attaching to a source URL, trigger a playlist load
        this.trigger(events_1.default.MANIFEST_LOADING, { url: url });
    };
    /**
     * Start loading data from the stream source.
     * Depending on default config, client starts loading automatically when a source is set.
     *
     * @param {number} startPosition Set the start position to stream from
     * @default -1 None (from earliest point)
     */
    Hls.prototype.startLoad = function (startPosition) {
        if (startPosition === void 0) { startPosition = -1; }
        logger_1.logger.log("startLoad(" + startPosition + ")");
        this.networkControllers.forEach(function (controller) {
            controller.startLoad(startPosition);
        });
    };
    /**
     * Stop loading of any stream data.
     */
    Hls.prototype.stopLoad = function () {
        logger_1.logger.log('stopLoad');
        this.networkControllers.forEach(function (controller) {
            controller.stopLoad();
        });
    };
    /**
     * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
     */
    Hls.prototype.swapAudioCodec = function () {
        logger_1.logger.log('swapAudioCodec');
        this.streamController.swapAudioCodec();
    };
    /**
     * When the media-element fails, this allows to detach and then re-attach it
     * as one call (convenience method).
     *
     * Automatic recovery of media-errors by this process is configurable.
     */
    Hls.prototype.recoverMediaError = function () {
        logger_1.logger.log('recoverMediaError');
        var media = this.media;
        this.detachMedia();
        this.attachMedia(media);
    };
    Object.defineProperty(Hls.prototype, "levels", {
        /**
         * @type {QualityLevel[]}
         */
        get: function () {
            return this.levelController.levels;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "currentLevel", {
        /**
         * Index of quality level currently played
         * @type {number}
         */
        get: function () {
            return this.streamController.currentLevel;
        },
        /**
         * Set quality level index immediately .
         * This will flush the current buffer to replace the quality asap.
         * That means playback will interrupt at least shortly to re-buffer and re-sync eventually.
         * @type {number} -1 for automatic level selection
         */
        set: function (newLevel) {
            logger_1.logger.log("set currentLevel:" + newLevel);
            this.loadLevel = newLevel;
            this.streamController.immediateLevelSwitch();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "nextLevel", {
        /**
         * Index of next quality level loaded as scheduled by stream controller.
         * @type {number}
         */
        get: function () {
            return this.streamController.nextLevel;
        },
        /**
         * Set quality level index for next loaded data.
         * This will switch the video quality asap, without interrupting playback.
         * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
         * @type {number} -1 for automatic level selection
         */
        set: function (newLevel) {
            logger_1.logger.log("set nextLevel:" + newLevel);
            this.levelController.manualLevel = newLevel;
            this.streamController.nextLevelSwitch();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "loadLevel", {
        /**
         * Return the quality level of the currently or last (of none is loaded currently) segment
         * @type {number}
         */
        get: function () {
            return this.levelController.level;
        },
        /**
         * Set quality level index for next loaded data in a conservative way.
         * This will switch the quality without flushing, but interrupt current loading.
         * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
         * @type {number} newLevel -1 for automatic level selection
         */
        set: function (newLevel) {
            logger_1.logger.log("set loadLevel:" + newLevel);
            this.levelController.manualLevel = newLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "nextLoadLevel", {
        /**
         * get next quality level loaded
         * @type {number}
         */
        get: function () {
            return this.levelController.nextLoadLevel;
        },
        /**
         * Set quality level of next loaded segment in a fully "non-destructive" way.
         * Same as `loadLevel` but will wait for next switch (until current loading is done).
         * @type {number} level
         */
        set: function (level) {
            this.levelController.nextLoadLevel = level;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "firstLevel", {
        /**
         * Return "first level": like a default level, if not set,
         * falls back to index of first level referenced in manifest
         * @type {number}
         */
        get: function () {
            return Math.max(this.levelController.firstLevel, this.minAutoLevel);
        },
        /**
         * Sets "first-level", see getter.
         * @type {number}
         */
        set: function (newLevel) {
            logger_1.logger.log("set firstLevel:" + newLevel);
            this.levelController.firstLevel = newLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "startLevel", {
        /**
         * Return start level (level of first fragment that will be played back)
         * if not overrided by user, first level appearing in manifest will be used as start level
         * if -1 : automatic start level selection, playback will start from level matching download bandwidth
         * (determined from download of first segment)
         * @type {number}
         */
        get: function () {
            return this.levelController.startLevel;
        },
        /**
         * set  start level (level of first fragment that will be played back)
         * if not overrided by user, first level appearing in manifest will be used as start level
         * if -1 : automatic start level selection, playback will start from level matching download bandwidth
         * (determined from download of first segment)
         * @type {number} newLevel
         */
        set: function (newLevel) {
            logger_1.logger.log("set startLevel:" + newLevel);
            var hls = this;
            // if not in automatic start level detection, ensure startLevel is greater than minAutoLevel
            if (newLevel !== -1) {
                newLevel = Math.max(newLevel, hls.minAutoLevel);
            }
            hls.levelController.startLevel = newLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "autoLevelCapping", {
        /**
         * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
         * @type {number}
         */
        get: function () {
            return this._autoLevelCapping;
        },
        /**
         * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
         * @type {number}
         */
        set: function (newLevel) {
            logger_1.logger.log("set autoLevelCapping:" + newLevel);
            this._autoLevelCapping = newLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "autoLevelEnabled", {
        /**
         * True when automatic level selection enabled
         * @type {boolean}
         */
        get: function () {
            return (this.levelController.manualLevel === -1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "manualLevel", {
        /**
         * Level set manually (if any)
         * @type {number}
         */
        get: function () {
            return this.levelController.manualLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "minAutoLevel", {
        /**
         * min level selectable in auto mode according to config.minAutoBitrate
         * @type {number}
         */
        get: function () {
            var hls = this, levels = hls.levels, minAutoBitrate = hls.config.minAutoBitrate, len = levels ? levels.length : 0;
            for (var i = 0; i < len; i++) {
                var levelNextBitrate = levels[i].realBitrate ? Math.max(levels[i].realBitrate, levels[i].bitrate) : levels[i].bitrate;
                if (levelNextBitrate > minAutoBitrate) {
                    return i;
                }
            }
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "maxAutoLevel", {
        /**
         * max level selectable in auto mode according to autoLevelCapping
         * @type {number}
         */
        get: function () {
            var hls = this;
            var levels = hls.levels;
            var autoLevelCapping = hls.autoLevelCapping;
            var maxAutoLevel;
            if (autoLevelCapping === -1 && levels && levels.length) {
                maxAutoLevel = levels.length - 1;
            }
            else {
                maxAutoLevel = autoLevelCapping;
            }
            return maxAutoLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "nextAutoLevel", {
        /**
         * next automatically selected quality level
         * @type {number}
         */
        get: function () {
            var hls = this;
            // ensure next auto level is between  min and max auto level
            return Math.min(Math.max(hls.abrController.nextAutoLevel, hls.minAutoLevel), hls.maxAutoLevel);
        },
        /**
         * this setter is used to force next auto level.
         * this is useful to force a switch down in auto mode:
         * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
         * forced value is valid for one fragment. upon succesful frag loading at forced level,
         * this value will be resetted to -1 by ABR controller.
         * @type {number}
         */
        set: function (nextLevel) {
            var hls = this;
            hls.abrController.nextAutoLevel = Math.max(hls.minAutoLevel, nextLevel);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "audioTracks", {
        /**
         * @type {AudioTrack[]}
         */
        get: function () {
            var audioTrackController = this.audioTrackController;
            return audioTrackController ? audioTrackController.audioTracks : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "audioTrack", {
        /**
         * index of the selected audio track (index in audio track lists)
         * @type {number}
         */
        get: function () {
            var audioTrackController = this.audioTrackController;
            return audioTrackController ? audioTrackController.audioTrack : -1;
        },
        /**
         * selects an audio track, based on its index in audio track lists
         * @type {number}
         */
        set: function (audioTrackId) {
            var audioTrackController = this.audioTrackController;
            if (audioTrackController) {
                audioTrackController.audioTrack = audioTrackId;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "liveSyncPosition", {
        /**
         * @type {Seconds}
         */
        get: function () {
            return this.streamController.liveSyncPosition;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "subtitleTracks", {
        /**
         * get alternate subtitle tracks list from playlist
         * @type {SubtitleTrack[]}
         */
        get: function () {
            var subtitleTrackController = this.subtitleTrackController;
            return subtitleTrackController ? subtitleTrackController.subtitleTracks : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "subtitleTrack", {
        /**
         * index of the selected subtitle track (index in subtitle track lists)
         * @type {number}
         */
        get: function () {
            var subtitleTrackController = this.subtitleTrackController;
            return subtitleTrackController ? subtitleTrackController.subtitleTrack : -1;
        },
        /**
         * select an subtitle track, based on its index in subtitle track lists
         * @type{number}
         */
        set: function (subtitleTrackId) {
            var subtitleTrackController = this.subtitleTrackController;
            if (subtitleTrackController) {
                subtitleTrackController.subtitleTrack = subtitleTrackId;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "subtitleDisplay", {
        /**
         * @type {boolean}
         */
        get: function () {
            var subtitleTrackController = this.subtitleTrackController;
            return subtitleTrackController ? subtitleTrackController.subtitleDisplay : false;
        },
        /**
         * Enable/disable subtitle display rendering
         * @type {boolean}
         */
        set: function (value) {
            var subtitleTrackController = this.subtitleTrackController;
            if (subtitleTrackController) {
                subtitleTrackController.subtitleDisplay = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    return Hls;
}(observer_1.Observer));
exports.default = Hls;


/***/ }),

/***/ "./src/is-supported.js":
/*!*****************************!*\
  !*** ./src/is-supported.js ***!
  \*****************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var mediasource_helper_1 = __webpack_require__(/*! ./utils/mediasource-helper */ "./src/utils/mediasource-helper.js");
function isSupported() {
    var mediaSource = mediasource_helper_1.getMediaSource();
    var sourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer;
    var isTypeSupported = mediaSource &&
        typeof mediaSource.isTypeSupported === 'function' &&
        mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
    // if SourceBuffer is exposed ensure its API is valid
    // safari and old version of Chrome doe not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
    var sourceBufferValidAPI = !sourceBuffer ||
        (sourceBuffer.prototype &&
            typeof sourceBuffer.prototype.appendBuffer === 'function' &&
            typeof sourceBuffer.prototype.remove === 'function');
    return !!isTypeSupported && !!sourceBufferValidAPI;
}
exports.isSupported = isSupported;


/***/ }),

/***/ "./src/loader/fragment-loader.js":
/*!***************************************!*\
  !*** ./src/loader/fragment-loader.js ***!
  \***************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
/*
 * Fragment Loader
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var FragmentLoader = /** @class */ (function (_super) {
    __extends(FragmentLoader, _super);
    function FragmentLoader(hls) {
        var _this = _super.call(this, hls, events_1.default.FRAG_LOADING) || this;
        _this.loaders = {};
        return _this;
    }
    FragmentLoader.prototype.destroy = function () {
        var loaders = this.loaders;
        for (var loaderName in loaders) {
            var loader = loaders[loaderName];
            if (loader) {
                loader.destroy();
            }
        }
        this.loaders = {};
        _super.prototype.destroy.call(this);
    };
    FragmentLoader.prototype.onFragLoading = function (data) {
        var frag = data.frag, type = frag.type, loaders = this.loaders, config = this.hls.config, FragmentILoader = config.fLoader, DefaultILoader = config.loader;
        // reset fragment state
        frag.loaded = 0;
        var loader = loaders[type];
        if (loader) {
            logger_1.logger.warn("abort previous fragment loader for type: " + type);
            loader.abort();
        }
        loader = loaders[type] = frag.loader =
            config.fLoader ? new FragmentILoader(config) : new DefaultILoader(config);
        var loaderContext, loaderConfig, loaderCallbacks;
        loaderContext = { url: frag.url, frag: frag, responseType: 'arraybuffer', progressData: false };
        var start = frag.byteRangeStartOffset, end = frag.byteRangeEndOffset;
        if (Number.isFinite(start) && Number.isFinite(end)) {
            loaderContext.rangeStart = start;
            loaderContext.rangeEnd = end;
        }
        loaderConfig = {
            timeout: config.fragLoadingTimeOut,
            maxRetry: 0,
            retryDelay: 0,
            maxRetryDelay: config.fragLoadingMaxRetryTimeout
        };
        loaderCallbacks = {
            onSuccess: this.loadsuccess.bind(this),
            onError: this.loaderror.bind(this),
            onTimeout: this.loadtimeout.bind(this),
            onProgress: this.loadprogress.bind(this)
        };
        loader.load(loaderContext, loaderConfig, loaderCallbacks);
    };
    FragmentLoader.prototype.loadsuccess = function (response, stats, context, networkDetails) {
        if (networkDetails === void 0) { networkDetails = null; }
        var payload = response.data, frag = context.frag;
        // detach fragment loader on load success
        frag.loader = undefined;
        this.loaders[frag.type] = undefined;
        this.hls.trigger(events_1.default.FRAG_LOADED, { payload: payload, frag: frag, stats: stats, networkDetails: networkDetails });
    };
    FragmentLoader.prototype.loaderror = function (response, context, networkDetails) {
        if (networkDetails === void 0) { networkDetails = null; }
        var frag = context.frag;
        var loader = frag.loader;
        if (loader) {
            loader.abort();
        }
        this.loaders[frag.type] = undefined;
        this.hls.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.NETWORK_ERROR, details: errors_1.ErrorDetails.FRAG_LOAD_ERROR, fatal: false, frag: context.frag, response: response, networkDetails: networkDetails });
    };
    FragmentLoader.prototype.loadtimeout = function (stats, context, networkDetails) {
        if (networkDetails === void 0) { networkDetails = null; }
        var frag = context.frag;
        var loader = frag.loader;
        if (loader) {
            loader.abort();
        }
        this.loaders[frag.type] = undefined;
        this.hls.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.NETWORK_ERROR, details: errors_1.ErrorDetails.FRAG_LOAD_TIMEOUT, fatal: false, frag: context.frag, networkDetails: networkDetails });
    };
    // data will be used for progressive parsing
    FragmentLoader.prototype.loadprogress = function (stats, context, data, networkDetails) {
        if (networkDetails === void 0) { networkDetails = null; }
        var frag = context.frag;
        frag.loaded = stats.loaded;
        this.hls.trigger(events_1.default.FRAG_LOAD_PROGRESS, { frag: frag, stats: stats, networkDetails: networkDetails });
    };
    return FragmentLoader;
}(event_handler_1.default));
exports.default = FragmentLoader;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/loader/fragment.js":
/*!********************************!*\
  !*** ./src/loader/fragment.js ***!
  \********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
Object.defineProperty(exports, "__esModule", { value: true });
var URLToolkit = __webpack_require__(/*! url-toolkit */ "./node_modules/url-toolkit/src/url-toolkit.js");
var level_key_1 = __webpack_require__(/*! ./level-key */ "./src/loader/level-key.js");
var Fragment = /** @class */ (function () {
    function Fragment() {
        var _a;
        this._url = null;
        this._byteRange = null;
        this._decryptdata = null;
        this.tagList = [];
        this.programDateTime = null;
        this.rawProgramDateTime = null;
        // Holds the types of data this fragment supports
        this._elementaryStreams = (_a = {},
            _a[Fragment.ElementaryStreamTypes.AUDIO] = false,
            _a[Fragment.ElementaryStreamTypes.VIDEO] = false,
            _a);
    }
    Object.defineProperty(Fragment, "ElementaryStreamTypes", {
        /**
         * `type` property for this._elementaryStreams
         *
         * @enum
         */
        get: function () {
            return {
                AUDIO: 'audio',
                VIDEO: 'video'
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fragment.prototype, "url", {
        get: function () {
            if (!this._url && this.relurl) {
                this._url = URLToolkit.buildAbsoluteURL(this.baseurl, this.relurl, { alwaysNormalize: true });
            }
            return this._url;
        },
        set: function (value) {
            this._url = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fragment.prototype, "byteRange", {
        get: function () {
            if (!this._byteRange && !this.rawByteRange) {
                return [];
            }
            if (this._byteRange) {
                return this._byteRange;
            }
            var byteRange = [];
            if (this.rawByteRange) {
                var params = this.rawByteRange.split('@', 2);
                if (params.length === 1) {
                    var lastByteRangeEndOffset = this.lastByteRangeEndOffset;
                    byteRange[0] = lastByteRangeEndOffset || 0;
                }
                else {
                    byteRange[0] = parseInt(params[1]);
                }
                byteRange[1] = parseInt(params[0]) + byteRange[0];
                this._byteRange = byteRange;
            }
            return byteRange;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fragment.prototype, "byteRangeStartOffset", {
        /**
         * @type {number}
         */
        get: function () {
            return this.byteRange[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fragment.prototype, "byteRangeEndOffset", {
        get: function () {
            return this.byteRange[1];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fragment.prototype, "decryptdata", {
        get: function () {
            if (!this._decryptdata) {
                this._decryptdata = this.fragmentDecryptdataFromLevelkey(this.levelkey, this.sn);
            }
            return this._decryptdata;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fragment.prototype, "endProgramDateTime", {
        get: function () {
            if (!Number.isFinite(this.programDateTime)) {
                return null;
            }
            var duration = !Number.isFinite(this.duration) ? 0 : this.duration;
            return this.programDateTime + (duration * 1000);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fragment.prototype, "encrypted", {
        get: function () {
            return !!((this.decryptdata && this.decryptdata.uri !== null) && (this.decryptdata.key === null));
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {ElementaryStreamType} type
     */
    Fragment.prototype.addElementaryStream = function (type) {
        this._elementaryStreams[type] = true;
    };
    /**
     * @param {ElementaryStreamType} type
     */
    Fragment.prototype.hasElementaryStream = function (type) {
        return this._elementaryStreams[type] === true;
    };
    /**
     * Utility method for parseLevelPlaylist to create an initialization vector for a given segment
     * @returns {Uint8Array}
     */
    Fragment.prototype.createInitializationVector = function (segmentNumber) {
        var uint8View = new Uint8Array(16);
        for (var i = 12; i < 16; i++) {
            uint8View[i] = (segmentNumber >> 8 * (15 - i)) & 0xff;
        }
        return uint8View;
    };
    /**
     * Utility method for parseLevelPlaylist to get a fragment's decryption data from the currently parsed encryption key data
     * @param levelkey - a playlist's encryption info
     * @param segmentNumber - the fragment's segment number
     * @returns {*} - an object to be applied as a fragment's decryptdata
     */
    Fragment.prototype.fragmentDecryptdataFromLevelkey = function (levelkey, segmentNumber) {
        var decryptdata = levelkey;
        if (levelkey && levelkey.method && levelkey.uri && !levelkey.iv) {
            decryptdata = new level_key_1.default();
            decryptdata.method = levelkey.method;
            decryptdata.baseuri = levelkey.baseuri;
            decryptdata.reluri = levelkey.reluri;
            decryptdata.iv = this.createInitializationVector(segmentNumber);
        }
        return decryptdata;
    };
    return Fragment;
}());
exports.default = Fragment;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/loader/key-loader.js":
/*!**********************************!*\
  !*** ./src/loader/key-loader.js ***!
  \**********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Decrypt key Loader
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var KeyLoader = /** @class */ (function (_super) {
    __extends(KeyLoader, _super);
    function KeyLoader(hls) {
        var _this = _super.call(this, hls, events_1.default.KEY_LOADING) || this;
        _this.loaders = {};
        _this.decryptkey = null;
        _this.decrypturl = null;
        return _this;
    }
    KeyLoader.prototype.destroy = function () {
        for (var loaderName in this.loaders) {
            var loader = this.loaders[loaderName];
            if (loader) {
                loader.destroy();
            }
        }
        this.loaders = {};
        event_handler_1.default.prototype.destroy.call(this);
    };
    KeyLoader.prototype.onKeyLoading = function (data) {
        var frag = data.frag, type = frag.type, loader = this.loaders[type], decryptdata = frag.decryptdata, uri = decryptdata.uri;
        // if uri is different from previous one or if decrypt key not retrieved yet
        if (uri !== this.decrypturl || this.decryptkey === null) {
            var config = this.hls.config;
            if (loader) {
                logger_1.logger.warn("abort previous key loader for type:" + type);
                loader.abort();
            }
            frag.loader = this.loaders[type] = new config.loader(config);
            this.decrypturl = uri;
            this.decryptkey = null;
            var loaderContext = void 0, loaderConfig = void 0, loaderCallbacks = void 0;
            loaderContext = { url: uri, frag: frag, responseType: 'arraybuffer' };
            // maxRetry is 0 so that instead of retrying the same key on the same variant multiple times,
            // key-loader will trigger an error and rely on stream-controller to handle retry logic.
            // this will also align retry logic with fragment-loader
            loaderConfig = { timeout: config.fragLoadingTimeOut, maxRetry: 0, retryDelay: config.fragLoadingRetryDelay, maxRetryDelay: config.fragLoadingMaxRetryTimeout };
            loaderCallbacks = { onSuccess: this.loadsuccess.bind(this), onError: this.loaderror.bind(this), onTimeout: this.loadtimeout.bind(this) };
            frag.loader.load(loaderContext, loaderConfig, loaderCallbacks);
        }
        else if (this.decryptkey) {
            // we already loaded this key, return it
            decryptdata.key = this.decryptkey;
            this.hls.trigger(events_1.default.KEY_LOADED, { frag: frag });
        }
    };
    KeyLoader.prototype.loadsuccess = function (response, stats, context) {
        var frag = context.frag;
        this.decryptkey = frag.decryptdata.key = new Uint8Array(response.data);
        // detach fragment loader on load success
        frag.loader = undefined;
        this.loaders[frag.type] = undefined;
        this.hls.trigger(events_1.default.KEY_LOADED, { frag: frag });
    };
    KeyLoader.prototype.loaderror = function (response, context) {
        var frag = context.frag, loader = frag.loader;
        if (loader) {
            loader.abort();
        }
        this.loaders[context.type] = undefined;
        this.hls.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.NETWORK_ERROR, details: errors_1.ErrorDetails.KEY_LOAD_ERROR, fatal: false, frag: frag, response: response });
    };
    KeyLoader.prototype.loadtimeout = function (stats, context) {
        var frag = context.frag, loader = frag.loader;
        if (loader) {
            loader.abort();
        }
        this.loaders[context.type] = undefined;
        this.hls.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.NETWORK_ERROR, details: errors_1.ErrorDetails.KEY_LOAD_TIMEOUT, fatal: false, frag: frag });
    };
    return KeyLoader;
}(event_handler_1.default));
exports.default = KeyLoader;


/***/ }),

/***/ "./src/loader/level-key.js":
/*!*********************************!*\
  !*** ./src/loader/level-key.js ***!
  \*********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var URLToolkit = __webpack_require__(/*! url-toolkit */ "./node_modules/url-toolkit/src/url-toolkit.js");
var LevelKey = /** @class */ (function () {
    function LevelKey() {
        this.method = null;
        this.key = null;
        this.iv = null;
        this._uri = null;
    }
    Object.defineProperty(LevelKey.prototype, "uri", {
        get: function () {
            if (!this._uri && this.reluri) {
                this._uri = URLToolkit.buildAbsoluteURL(this.baseuri, this.reluri, { alwaysNormalize: true });
            }
            return this._uri;
        },
        enumerable: true,
        configurable: true
    });
    return LevelKey;
}());
exports.default = LevelKey;


/***/ }),

/***/ "./src/loader/level.js":
/*!*****************************!*\
  !*** ./src/loader/level.js ***!
  \*****************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
Object.defineProperty(exports, "__esModule", { value: true });
var Level = /** @class */ (function () {
    function Level(baseUrl) {
        // Please keep properties in alphabetical order
        this.endCC = 0;
        this.endSN = 0;
        this.fragments = [];
        this.initSegment = null;
        this.live = true;
        this.needSidxRanges = false;
        this.startCC = 0;
        this.startSN = 0;
        this.startTimeOffset = null;
        this.targetduration = 0;
        this.totalduration = 0;
        this.type = null;
        this.url = baseUrl;
        this.version = null;
    }
    Object.defineProperty(Level.prototype, "hasProgramDateTime", {
        get: function () {
            return !!(this.fragments[0] && Number.isFinite(this.fragments[0].programDateTime));
        },
        enumerable: true,
        configurable: true
    });
    return Level;
}());
exports.default = Level;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/loader/m3u8-parser.js":
/*!***********************************!*\
  !*** ./src/loader/m3u8-parser.js ***!
  \***********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
Object.defineProperty(exports, "__esModule", { value: true });
var URLToolkit = __webpack_require__(/*! url-toolkit */ "./node_modules/url-toolkit/src/url-toolkit.js");
var fragment_1 = __webpack_require__(/*! ./fragment */ "./src/loader/fragment.js");
var level_1 = __webpack_require__(/*! ./level */ "./src/loader/level.js");
var level_key_1 = __webpack_require__(/*! ./level-key */ "./src/loader/level-key.js");
var attr_list_1 = __webpack_require__(/*! ../utils/attr-list */ "./src/utils/attr-list.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var codecs_1 = __webpack_require__(/*! ../utils/codecs */ "./src/utils/codecs.js");
/**
 * M3U8 parser
 * @module
 */
// https://regex101.com is your friend
var MASTER_PLAYLIST_REGEX = /#EXT-X-STREAM-INF:([^\n\r]*)[\r\n]+([^\r\n]+)/g;
var MASTER_PLAYLIST_MEDIA_REGEX = /#EXT-X-MEDIA:(.*)/g;
var LEVEL_PLAYLIST_REGEX_FAST = new RegExp([
    /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
    /|(?!#)([\S+ ?]+)/.source,
    /|#EXT-X-BYTERANGE:*(.+)/.source,
    /|#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
    /|#.*/.source // All other non-segment oriented tags will match with all groups empty
].join(''), 'g');
var LEVEL_PLAYLIST_REGEX_SLOW = /(?:(?:#(EXTM3U))|(?:#EXT-X-(PLAYLIST-TYPE):(.+))|(?:#EXT-X-(MEDIA-SEQUENCE): *(\d+))|(?:#EXT-X-(TARGETDURATION): *(\d+))|(?:#EXT-X-(KEY):(.+))|(?:#EXT-X-(START):(.+))|(?:#EXT-X-(ENDLIST))|(?:#EXT-X-(DISCONTINUITY-SEQ)UENCE:(\d+))|(?:#EXT-X-(DIS)CONTINUITY))|(?:#EXT-X-(VERSION):(\d+))|(?:#EXT-X-(MAP):(.+))|(?:(#)([^:]*):(.*))|(?:(#)(.*))(?:.*)\r?\n?/;
var MP4_REGEX_SUFFIX = /\.(mp4|m4s|m4v|m4a)$/i;
var M3U8Parser = /** @class */ (function () {
    function M3U8Parser() {
    }
    M3U8Parser.findGroup = function (groups, mediaGroupId) {
        if (!groups) {
            return null;
        }
        var matchingGroup = null;
        for (var i = 0; i < groups.length; i++) {
            var group = groups[i];
            if (group.id === mediaGroupId) {
                matchingGroup = group;
            }
        }
        return matchingGroup;
    };
    M3U8Parser.convertAVC1ToAVCOTI = function (codec) {
        var result, avcdata = codec.split('.');
        if (avcdata.length > 2) {
            result = avcdata.shift() + '.';
            result += parseInt(avcdata.shift()).toString(16);
            result += ('000' + parseInt(avcdata.shift()).toString(16)).substr(-4);
        }
        else {
            result = codec;
        }
        return result;
    };
    M3U8Parser.resolve = function (url, baseUrl) {
        return URLToolkit.buildAbsoluteURL(baseUrl, url, { alwaysNormalize: true });
    };
    M3U8Parser.parseMasterPlaylist = function (string, baseurl) {
        var levels = [], result;
        MASTER_PLAYLIST_REGEX.lastIndex = 0;
        function setCodecs(codecs, level) {
            ['video', 'audio'].forEach(function (type) {
                var filtered = codecs.filter(function (codec) { return codecs_1.isCodecType(codec, type); });
                if (filtered.length) {
                    var preferred = filtered.filter(function (codec) {
                        return codec.lastIndexOf('avc1', 0) === 0 || codec.lastIndexOf('mp4a', 0) === 0;
                    });
                    level[type + "Codec"] = preferred.length > 0 ? preferred[0] : filtered[0];
                    // remove from list
                    codecs = codecs.filter(function (codec) { return filtered.indexOf(codec) === -1; });
                }
            });
            level.unknownCodecs = codecs;
        }
        while ((result = MASTER_PLAYLIST_REGEX.exec(string)) != null) {
            var level = {};
            var attrs = level.attrs = new attr_list_1.default(result[1]);
            level.url = M3U8Parser.resolve(result[2], baseurl);
            var resolution = attrs.decimalResolution('RESOLUTION');
            if (resolution) {
                level.width = resolution.width;
                level.height = resolution.height;
            }
            level.bitrate = attrs.decimalInteger('AVERAGE-BANDWIDTH') || attrs.decimalInteger('BANDWIDTH');
            level.name = attrs.NAME;
            setCodecs([].concat((attrs.CODECS || '').split(/[ ,]+/)), level);
            if (level.videoCodec && level.videoCodec.indexOf('avc1') !== -1) {
                level.videoCodec = M3U8Parser.convertAVC1ToAVCOTI(level.videoCodec);
            }
            levels.push(level);
        }
        return levels;
    };
    M3U8Parser.parseMasterPlaylistMedia = function (string, baseurl, type, audioGroups) {
        if (audioGroups === void 0) { audioGroups = []; }
        var result;
        var medias = [];
        var id = 0;
        MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
        while ((result = MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) !== null) {
            var media = {};
            var attrs = new attr_list_1.default(result[1]);
            if (attrs.TYPE === type) {
                media.groupId = attrs['GROUP-ID'];
                media.name = attrs.NAME;
                media.type = type;
                media.default = (attrs.DEFAULT === 'YES');
                media.autoselect = (attrs.AUTOSELECT === 'YES');
                media.forced = (attrs.FORCED === 'YES');
                if (attrs.URI) {
                    media.url = M3U8Parser.resolve(attrs.URI, baseurl);
                }
                media.lang = attrs.LANGUAGE;
                if (!media.name) {
                    media.name = media.lang;
                }
                if (audioGroups.length) {
                    var groupCodec = M3U8Parser.findGroup(audioGroups, media.groupId);
                    media.audioCodec = groupCodec ? groupCodec.codec : audioGroups[0].codec;
                }
                media.id = id++;
                medias.push(media);
            }
        }
        return medias;
    };
    M3U8Parser.parseLevelPlaylist = function (string, baseurl, id, type, levelUrlId) {
        var currentSN = 0;
        var totalduration = 0;
        var level = new level_1.default(baseurl);
        var levelkey = new level_key_1.default();
        var cc = 0;
        var prevFrag = null;
        var frag = new fragment_1.default();
        var result;
        var i;
        var firstPdtIndex = null;
        LEVEL_PLAYLIST_REGEX_FAST.lastIndex = 0;
        while ((result = LEVEL_PLAYLIST_REGEX_FAST.exec(string)) !== null) {
            var duration = result[1];
            if (duration) { // INF
                frag.duration = parseFloat(duration);
                // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                var title = (' ' + result[2]).slice(1);
                frag.title = title || null;
                frag.tagList.push(title ? ['INF', duration, title] : ['INF', duration]);
            }
            else if (result[3]) { // url
                if (Number.isFinite(frag.duration)) {
                    var sn = currentSN++;
                    frag.type = type;
                    frag.start = totalduration;
                    frag.levelkey = levelkey;
                    frag.sn = sn;
                    frag.level = id;
                    frag.cc = cc;
                    frag.urlId = levelUrlId;
                    frag.baseurl = baseurl;
                    // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                    frag.relurl = (' ' + result[3]).slice(1);
                    assignProgramDateTime(frag, prevFrag);
                    level.fragments.push(frag);
                    prevFrag = frag;
                    totalduration += frag.duration;
                    frag = new fragment_1.default();
                }
            }
            else if (result[4]) { // X-BYTERANGE
                frag.rawByteRange = (' ' + result[4]).slice(1);
                if (prevFrag) {
                    var lastByteRangeEndOffset = prevFrag.byteRangeEndOffset;
                    if (lastByteRangeEndOffset) {
                        frag.lastByteRangeEndOffset = lastByteRangeEndOffset;
                    }
                }
            }
            else if (result[5]) { // PROGRAM-DATE-TIME
                // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                frag.rawProgramDateTime = (' ' + result[5]).slice(1);
                frag.tagList.push(['PROGRAM-DATE-TIME', frag.rawProgramDateTime]);
                if (firstPdtIndex === null) {
                    firstPdtIndex = level.fragments.length;
                }
            }
            else {
                result = result[0].match(LEVEL_PLAYLIST_REGEX_SLOW);
                for (i = 1; i < result.length; i++) {
                    if (result[i] !== undefined) {
                        break;
                    }
                }
                // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                var value1 = (' ' + result[i + 1]).slice(1);
                var value2 = (' ' + result[i + 2]).slice(1);
                switch (result[i]) {
                    case '#':
                        frag.tagList.push(value2 ? [value1, value2] : [value1]);
                        break;
                    case 'PLAYLIST-TYPE':
                        level.type = value1.toUpperCase();
                        break;
                    case 'MEDIA-SEQUENCE':
                        currentSN = level.startSN = parseInt(value1);
                        break;
                    case 'TARGETDURATION':
                        level.targetduration = parseFloat(value1);
                        break;
                    case 'VERSION':
                        level.version = parseInt(value1);
                        break;
                    case 'EXTM3U':
                        break;
                    case 'ENDLIST':
                        level.live = false;
                        break;
                    case 'DIS':
                        cc++;
                        frag.tagList.push(['DIS']);
                        break;
                    case 'DISCONTINUITY-SEQ':
                        cc = parseInt(value1);
                        break;
                    case 'KEY':
                        // https://tools.ietf.org/html/draft-pantos-http-live-streaming-08#section-3.4.4
                        var decryptparams = value1;
                        var keyAttrs = new attr_list_1.default(decryptparams);
                        var decryptmethod = keyAttrs.enumeratedString('METHOD'), decrypturi = keyAttrs.URI, decryptiv = keyAttrs.hexadecimalInteger('IV');
                        if (decryptmethod) {
                            levelkey = new level_key_1.default();
                            if ((decrypturi) && (['AES-128', 'SAMPLE-AES', 'SAMPLE-AES-CENC'].indexOf(decryptmethod) >= 0)) {
                                levelkey.method = decryptmethod;
                                // URI to get the key
                                levelkey.baseuri = baseurl;
                                levelkey.reluri = decrypturi;
                                levelkey.key = null;
                                // Initialization Vector (IV)
                                levelkey.iv = decryptiv;
                            }
                        }
                        break;
                    case 'START':
                        var startParams = value1;
                        var startAttrs = new attr_list_1.default(startParams);
                        var startTimeOffset = startAttrs.decimalFloatingPoint('TIME-OFFSET');
                        // TIME-OFFSET can be 0
                        if (Number.isFinite(startTimeOffset)) {
                            level.startTimeOffset = startTimeOffset;
                        }
                        break;
                    case 'MAP':
                        var mapAttrs = new attr_list_1.default(value1);
                        frag.relurl = mapAttrs.URI;
                        frag.rawByteRange = mapAttrs.BYTERANGE;
                        frag.baseurl = baseurl;
                        frag.level = id;
                        frag.type = type;
                        frag.sn = 'initSegment';
                        level.initSegment = frag;
                        frag = new fragment_1.default();
                        frag.rawProgramDateTime = level.initSegment.rawProgramDateTime;
                        break;
                    default:
                        logger_1.logger.warn("line parsed but not handled: " + result);
                        break;
                }
            }
        }
        frag = prevFrag;
        // logger.log('found ' + level.fragments.length + ' fragments');
        if (frag && !frag.relurl) {
            level.fragments.pop();
            totalduration -= frag.duration;
        }
        level.totalduration = totalduration;
        level.averagetargetduration = totalduration / level.fragments.length;
        level.endSN = currentSN - 1;
        level.startCC = level.fragments[0] ? level.fragments[0].cc : 0;
        level.endCC = cc;
        if (!level.initSegment && level.fragments.length) {
            // this is a bit lurky but HLS really has no other way to tell us
            // if the fragments are TS or MP4, except if we download them :/
            // but this is to be able to handle SIDX.
            if (level.fragments.every(function (frag) { return MP4_REGEX_SUFFIX.test(frag.relurl); })) {
                logger_1.logger.warn('MP4 fragments found but no init segment (probably no MAP, incomplete M3U8), trying to fetch SIDX');
                frag = new fragment_1.default();
                frag.relurl = level.fragments[0].relurl;
                frag.baseurl = baseurl;
                frag.level = id;
                frag.type = type;
                frag.sn = 'initSegment';
                level.initSegment = frag;
                level.needSidxRanges = true;
            }
        }
        /**
         * Backfill any missing PDT values
           "If the first EXT-X-PROGRAM-DATE-TIME tag in a Playlist appears after
           one or more Media Segment URIs, the client SHOULD extrapolate
           backward from that tag (using EXTINF durations and/or media
           timestamps) to associate dates with those segments."
         * We have already extrapolated forward, but all fragments up to the first instance of PDT do not have their PDTs
         * computed.
         */
        if (firstPdtIndex) {
            backfillProgramDateTimes(level.fragments, firstPdtIndex);
        }
        return level;
    };
    return M3U8Parser;
}());
exports.default = M3U8Parser;
function backfillProgramDateTimes(fragments, startIndex) {
    var fragPrev = fragments[startIndex];
    for (var i = startIndex - 1; i >= 0; i--) {
        var frag = fragments[i];
        frag.programDateTime = fragPrev.programDateTime - (frag.duration * 1000);
        fragPrev = frag;
    }
}
function assignProgramDateTime(frag, prevFrag) {
    if (frag.rawProgramDateTime) {
        frag.programDateTime = Date.parse(frag.rawProgramDateTime);
    }
    else if (prevFrag && prevFrag.programDateTime) {
        frag.programDateTime = prevFrag.endProgramDateTime;
    }
    if (!Number.isFinite(frag.programDateTime)) {
        frag.programDateTime = null;
        frag.rawProgramDateTime = null;
    }
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/loader/playlist-loader.js":
/*!***************************************!*\
  !*** ./src/loader/playlist-loader.js ***!
  \***************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
/**
 * PlaylistLoader - delegate for media manifest/playlist loading tasks. Takes care of parsing media to internal data-models.
 *
 * Once loaded, dispatches events with parsed data-models of manifest/levels/audio/subtitle tracks.
 *
 * Uses loader(s) set in config to do actual internal loading of resource tasks.
 *
 * @module
 *
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var mp4demuxer_1 = __webpack_require__(/*! ../demux/mp4demuxer */ "./src/demux/mp4demuxer.js");
var m3u8_parser_1 = __webpack_require__(/*! ./m3u8-parser */ "./src/loader/m3u8-parser.js");
var performance = window.performance;
/**
 * `type` property values for this loaders' context object
 * @enum
 *
 */
var ContextType = {
    MANIFEST: 'manifest',
    LEVEL: 'level',
    AUDIO_TRACK: 'audioTrack',
    SUBTITLE_TRACK: 'subtitleTrack'
};
/**
 * @enum {string}
 */
var LevelType = {
    MAIN: 'main',
    AUDIO: 'audio',
    SUBTITLE: 'subtitle'
};
/**
 * @constructor
 */
var PlaylistLoader = /** @class */ (function (_super) {
    __extends(PlaylistLoader, _super);
    /**
     * @constructs
     * @param {Hls} hls
     */
    function PlaylistLoader(hls) {
        var _this = _super.call(this, hls, events_1.default.MANIFEST_LOADING, events_1.default.LEVEL_LOADING, events_1.default.AUDIO_TRACK_LOADING, events_1.default.SUBTITLE_TRACK_LOADING) || this;
        _this.loaders = {};
        return _this;
    }
    Object.defineProperty(PlaylistLoader, "ContextType", {
        get: function () {
            return ContextType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlaylistLoader, "LevelType", {
        get: function () {
            return LevelType;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {ContextType} type
     * @returns {boolean}
     */
    PlaylistLoader.canHaveQualityLevels = function (type) {
        return (type !== ContextType.AUDIO_TRACK &&
            type !== ContextType.SUBTITLE_TRACK);
    };
    /**
     * Map context.type to LevelType
     * @param {{type: ContextType}} context
     * @returns {LevelType}
     */
    PlaylistLoader.mapContextToLevelType = function (context) {
        var type = context.type;
        switch (type) {
            case ContextType.AUDIO_TRACK:
                return LevelType.AUDIO;
            case ContextType.SUBTITLE_TRACK:
                return LevelType.SUBTITLE;
            default:
                return LevelType.MAIN;
        }
    };
    PlaylistLoader.getResponseUrl = function (response, context) {
        var url = response.url;
        // responseURL not supported on some browsers (it is used to detect URL redirection)
        // data-uri mode also not supported (but no need to detect redirection)
        if (url === undefined || url.indexOf('data:') === 0) {
            // fallback to initial URL
            url = context.url;
        }
        return url;
    };
    /**
     * Returns defaults or configured loader-type overloads (pLoader and loader config params)
     * Default loader is XHRLoader (see utils)
     * @param {object} context
     * @returns {XHRLoader} or other compatible configured overload
     */
    PlaylistLoader.prototype.createInternalLoader = function (context) {
        var config = this.hls.config;
        var PLoader = config.pLoader;
        var Loader = config.loader;
        var InternalLoader = PLoader || Loader;
        var loader = new InternalLoader(config);
        context.loader = loader;
        this.loaders[context.type] = loader;
        return loader;
    };
    PlaylistLoader.prototype.getInternalLoader = function (context) {
        return this.loaders[context.type];
    };
    PlaylistLoader.prototype.resetInternalLoader = function (contextType) {
        if (this.loaders[contextType]) {
            delete this.loaders[contextType];
        }
    };
    /**
     * Call `destroy` on all internal loader instances mapped (one per context type)
     */
    PlaylistLoader.prototype.destroyInternalLoaders = function () {
        for (var contextType in this.loaders) {
            var loader = this.loaders[contextType];
            if (loader) {
                loader.destroy();
            }
            this.resetInternalLoader(contextType);
        }
    };
    PlaylistLoader.prototype.destroy = function () {
        this.destroyInternalLoaders();
        _super.prototype.destroy.call(this);
    };
    PlaylistLoader.prototype.onManifestLoading = function (data) {
        this.load(data.url, { type: ContextType.MANIFEST, level: 0, id: null });
    };
    PlaylistLoader.prototype.onLevelLoading = function (data) {
        this.load(data.url, { type: ContextType.LEVEL, level: data.level, id: data.id });
    };
    PlaylistLoader.prototype.onAudioTrackLoading = function (data) {
        this.load(data.url, { type: ContextType.AUDIO_TRACK, level: null, id: data.id });
    };
    PlaylistLoader.prototype.onSubtitleTrackLoading = function (data) {
        this.load(data.url, { type: ContextType.SUBTITLE_TRACK, level: null, id: data.id });
    };
    PlaylistLoader.prototype.load = function (url, context) {
        var config = this.hls.config;
        logger_1.logger.debug("Loading playlist of type " + context.type + ", level: " + context.level + ", id: " + context.id);
        // Check if a loader for this context already exists
        var loader = this.getInternalLoader(context);
        if (loader) {
            var loaderContext = loader.context;
            if (loaderContext && loaderContext.url === url) { // same URL can't overlap
                logger_1.logger.trace('playlist request ongoing');
                return false;
            }
            else {
                logger_1.logger.warn("aborting previous loader for type: " + context.type);
                loader.abort();
            }
        }
        var maxRetry, timeout, retryDelay, maxRetryDelay;
        // apply different configs for retries depending on
        // context (manifest, level, audio/subs playlist)
        switch (context.type) {
            case ContextType.MANIFEST:
                maxRetry = config.manifestLoadingMaxRetry;
                timeout = config.manifestLoadingTimeOut;
                retryDelay = config.manifestLoadingRetryDelay;
                maxRetryDelay = config.manifestLoadingMaxRetryTimeout;
                break;
            case ContextType.LEVEL:
                // Disable internal loader retry logic, since we are managing retries in Level Controller
                maxRetry = 0;
                timeout = config.levelLoadingTimeOut;
                // TODO Introduce retry settings for audio-track and subtitle-track, it should not use level retry config
                break;
            default:
                maxRetry = config.levelLoadingMaxRetry;
                timeout = config.levelLoadingTimeOut;
                retryDelay = config.levelLoadingRetryDelay;
                maxRetryDelay = config.levelLoadingMaxRetryTimeout;
                break;
        }
        loader = this.createInternalLoader(context);
        context.url = url;
        context.responseType = context.responseType || ''; // FIXME: (should not be necessary to do this)
        var loaderConfig = {
            timeout: timeout,
            maxRetry: maxRetry,
            retryDelay: retryDelay,
            maxRetryDelay: maxRetryDelay
        };
        var loaderCallbacks = {
            onSuccess: this.loadsuccess.bind(this),
            onError: this.loaderror.bind(this),
            onTimeout: this.loadtimeout.bind(this)
        };
        logger_1.logger.debug("Calling internal loader delegate for URL: " + url);
        loader.load(context, loaderConfig, loaderCallbacks);
        return true;
    };
    PlaylistLoader.prototype.loadsuccess = function (response, stats, context, networkDetails) {
        if (networkDetails === void 0) { networkDetails = null; }
        if (context.isSidxRequest) {
            this._handleSidxRequest(response, context);
            this._handlePlaylistLoaded(response, stats, context, networkDetails);
            return;
        }
        this.resetInternalLoader(context.type);
        var string = response.data;
        stats.tload = performance.now();
        // stats.mtime = new Date(target.getResponseHeader('Last-Modified'));
        // Validate if it is an M3U8 at all
        if (string.indexOf('#EXTM3U') !== 0) {
            this._handleManifestParsingError(response, context, 'no EXTM3U delimiter', networkDetails);
            return;
        }
        // Check if chunk-list or master. handle empty chunk list case (first EXTINF not signaled, but TARGETDURATION present)
        if (string.indexOf('#EXTINF:') > 0 || string.indexOf('#EXT-X-TARGETDURATION:') > 0) {
            this._handleTrackOrLevelPlaylist(response, stats, context, networkDetails);
        }
        else {
            this._handleMasterPlaylist(response, stats, context, networkDetails);
        }
    };
    PlaylistLoader.prototype.loaderror = function (response, context, networkDetails) {
        if (networkDetails === void 0) { networkDetails = null; }
        this._handleNetworkError(context, networkDetails, false, response);
    };
    PlaylistLoader.prototype.loadtimeout = function (stats, context, networkDetails) {
        if (networkDetails === void 0) { networkDetails = null; }
        this._handleNetworkError(context, networkDetails, true);
    };
    PlaylistLoader.prototype._handleMasterPlaylist = function (response, stats, context, networkDetails) {
        var hls = this.hls;
        var string = response.data;
        var url = PlaylistLoader.getResponseUrl(response, context);
        var levels = m3u8_parser_1.default.parseMasterPlaylist(string, url);
        if (!levels.length) {
            this._handleManifestParsingError(response, context, 'no level found in manifest', networkDetails);
            return;
        }
        // multi level playlist, parse level info
        var audioGroups = levels.map(function (level) { return ({
            id: level.attrs.AUDIO,
            codec: level.audioCodec
        }); });
        var audioTracks = m3u8_parser_1.default.parseMasterPlaylistMedia(string, url, 'AUDIO', audioGroups);
        var subtitles = m3u8_parser_1.default.parseMasterPlaylistMedia(string, url, 'SUBTITLES');
        if (audioTracks.length) {
            // check if we have found an audio track embedded in main playlist (audio track without URI attribute)
            var embeddedAudioFound_1 = false;
            audioTracks.forEach(function (audioTrack) {
                if (!audioTrack.url) {
                    embeddedAudioFound_1 = true;
                }
            });
            // if no embedded audio track defined, but audio codec signaled in quality level,
            // we need to signal this main audio track this could happen with playlists with
            // alt audio rendition in which quality levels (main)
            // contains both audio+video. but with mixed audio track not signaled
            if (embeddedAudioFound_1 === false && levels[0].audioCodec && !levels[0].attrs.AUDIO) {
                logger_1.logger.log('audio codec signaled in quality level, but no embedded audio track signaled, create one');
                audioTracks.unshift({
                    type: 'main',
                    name: 'main'
                });
            }
        }
        hls.trigger(events_1.default.MANIFEST_LOADED, {
            levels: levels,
            audioTracks: audioTracks,
            subtitles: subtitles,
            url: url,
            stats: stats,
            networkDetails: networkDetails
        });
    };
    PlaylistLoader.prototype._handleTrackOrLevelPlaylist = function (response, stats, context, networkDetails) {
        var hls = this.hls;
        var id = context.id, level = context.level, type = context.type;
        var url = PlaylistLoader.getResponseUrl(response, context);
        var levelUrlId = Number.isFinite(id) ? id : 0;
        var levelId = Number.isFinite(level) ? level : levelUrlId;
        var levelType = PlaylistLoader.mapContextToLevelType(context);
        var levelDetails = m3u8_parser_1.default.parseLevelPlaylist(response.data, url, levelId, levelType, levelUrlId);
        // set stats on level structure
        levelDetails.tload = stats.tload;
        // We have done our first request (Manifest-type) and receive
        // not a master playlist but a chunk-list (track/level)
        // We fire the manifest-loaded event anyway with the parsed level-details
        // by creating a single-level structure for it.
        if (type === ContextType.MANIFEST) {
            var singleLevel = {
                url: url,
                details: levelDetails
            };
            hls.trigger(events_1.default.MANIFEST_LOADED, {
                levels: [singleLevel],
                audioTracks: [],
                url: url,
                stats: stats,
                networkDetails: networkDetails
            });
        }
        // save parsing time
        stats.tparsed = performance.now();
        // in case we need SIDX ranges
        // return early after calling load for
        // the SIDX box.
        if (levelDetails.needSidxRanges) {
            var sidxUrl = levelDetails.initSegment.url;
            this.load(sidxUrl, {
                isSidxRequest: true,
                type: type,
                level: level,
                levelDetails: levelDetails,
                id: id,
                rangeStart: 0,
                rangeEnd: 2048,
                responseType: 'arraybuffer'
            });
            return;
        }
        // extend the context with the new levelDetails property
        context.levelDetails = levelDetails;
        this._handlePlaylistLoaded(response, stats, context, networkDetails);
    };
    PlaylistLoader.prototype._handleSidxRequest = function (response, context) {
        var sidxInfo = mp4demuxer_1.default.parseSegmentIndex(new Uint8Array(response.data));
        // if provided fragment does not contain sidx, early return
        if (!sidxInfo) {
            return;
        }
        var sidxReferences = sidxInfo.references;
        var levelDetails = context.levelDetails;
        sidxReferences.forEach(function (segmentRef, index) {
            var segRefInfo = segmentRef.info;
            var frag = levelDetails.fragments[index];
            if (frag.byteRange.length === 0) {
                frag.rawByteRange = String(1 + segRefInfo.end - segRefInfo.start) + '@' + String(segRefInfo.start);
            }
        });
        levelDetails.initSegment.rawByteRange = String(sidxInfo.moovEndOffset) + '@0';
    };
    PlaylistLoader.prototype._handleManifestParsingError = function (response, context, reason, networkDetails) {
        this.hls.trigger(events_1.default.ERROR, {
            type: errors_1.ErrorTypes.NETWORK_ERROR,
            details: errors_1.ErrorDetails.MANIFEST_PARSING_ERROR,
            fatal: true,
            url: response.url,
            reason: reason,
            networkDetails: networkDetails
        });
    };
    PlaylistLoader.prototype._handleNetworkError = function (context, networkDetails, timeout, response) {
        if (timeout === void 0) { timeout = false; }
        if (response === void 0) { response = null; }
        logger_1.logger.info("A network error occured while loading a " + context.type + "-type playlist");
        var details;
        var fatal;
        var loader = this.getInternalLoader(context);
        switch (context.type) {
            case ContextType.MANIFEST:
                details = (timeout ? errors_1.ErrorDetails.MANIFEST_LOAD_TIMEOUT : errors_1.ErrorDetails.MANIFEST_LOAD_ERROR);
                fatal = true;
                break;
            case ContextType.LEVEL:
                details = (timeout ? errors_1.ErrorDetails.LEVEL_LOAD_TIMEOUT : errors_1.ErrorDetails.LEVEL_LOAD_ERROR);
                fatal = false;
                break;
            case ContextType.AUDIO_TRACK:
                details = (timeout ? errors_1.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT : errors_1.ErrorDetails.AUDIO_TRACK_LOAD_ERROR);
                fatal = false;
                break;
            default:
                // details = ...?
                fatal = false;
        }
        if (loader) {
            loader.abort();
            this.resetInternalLoader(context.type);
        }
        var errorData = {
            type: errors_1.ErrorTypes.NETWORK_ERROR,
            details: details,
            fatal: fatal,
            url: loader.url,
            loader: loader,
            context: context,
            networkDetails: networkDetails
        };
        if (response) {
            errorData.response = response;
        }
        this.hls.trigger(events_1.default.ERROR, errorData);
    };
    PlaylistLoader.prototype._handlePlaylistLoaded = function (response, stats, context, networkDetails) {
        var type = context.type, level = context.level, id = context.id, levelDetails = context.levelDetails;
        if (!levelDetails.targetduration) {
            this._handleManifestParsingError(response, context, 'invalid target duration', networkDetails);
            return;
        }
        var canHaveLevels = PlaylistLoader.canHaveQualityLevels(context.type);
        if (canHaveLevels) {
            this.hls.trigger(events_1.default.LEVEL_LOADED, {
                details: levelDetails,
                level: level || 0,
                id: id || 0,
                stats: stats,
                networkDetails: networkDetails
            });
        }
        else {
            switch (type) {
                case ContextType.AUDIO_TRACK:
                    this.hls.trigger(events_1.default.AUDIO_TRACK_LOADED, {
                        details: levelDetails,
                        id: id,
                        stats: stats,
                        networkDetails: networkDetails
                    });
                    break;
                case ContextType.SUBTITLE_TRACK:
                    this.hls.trigger(events_1.default.SUBTITLE_TRACK_LOADED, {
                        details: levelDetails,
                        id: id,
                        stats: stats,
                        networkDetails: networkDetails
                    });
                    break;
            }
        }
    };
    return PlaylistLoader;
}(event_handler_1.default));
exports.default = PlaylistLoader;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/observer.js":
/*!*************************!*\
  !*** ./src/observer.js ***!
  \*************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var eventemitter3_1 = __webpack_require__(/*! eventemitter3 */ "./node_modules/eventemitter3/index.js");
/**
 * @class
 *
 * Simple adapter sub-class of Nodejs-like EventEmitter.
 *
 * We simply want to pass along the event-name itself
 * in every call to a handler, which is the purpose of our `trigger` method
 * extending the standard API.
 *
 */
var Observer = /** @class */ (function (_super) {
    __extends(Observer, _super);
    function Observer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} event
     * @param {any} data
     */
    Observer.prototype.trigger = function (event) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        this.emit.apply(this, [event, event].concat(data));
    };
    return Observer;
}(eventemitter3_1.EventEmitter));
exports.Observer = Observer;


/***/ }),

/***/ "./src/polyfills/number.js":
/*!*********************************!*\
  !*** ./src/polyfills/number.js ***!
  \*********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var get_self_scope_1 = __webpack_require__(/*! ../utils/get-self-scope */ "./src/utils/get-self-scope.js");
var self = get_self_scope_1.getSelfScope();
var Number = self.Number;
exports.Number = Number;
// TODO: get rid of global polyfills and replace them with wrappers ("ponyfills")
Number.isFinite = Number.isFinite || function (value) {
    return typeof value === 'number' && isFinite(value);
};


/***/ }),

/***/ "./src/remux/aac-helper.js":
/*!*********************************!*\
  !*** ./src/remux/aac-helper.js ***!
  \*********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 *  AAC helper
 */
Object.defineProperty(exports, "__esModule", { value: true });
var AAC = /** @class */ (function () {
    function AAC() {
    }
    AAC.getSilentFrame = function (codec, channelCount) {
        switch (codec) {
            case 'mp4a.40.2':
                if (channelCount === 1) {
                    return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x23, 0x80]);
                }
                else if (channelCount === 2) {
                    return new Uint8Array([0x21, 0x00, 0x49, 0x90, 0x02, 0x19, 0x00, 0x23, 0x80]);
                }
                else if (channelCount === 3) {
                    return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x8e]);
                }
                else if (channelCount === 4) {
                    return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x80, 0x2c, 0x80, 0x08, 0x02, 0x38]);
                }
                else if (channelCount === 5) {
                    return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x38]);
                }
                else if (channelCount === 6) {
                    return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x00, 0xb2, 0x00, 0x20, 0x08, 0xe0]);
                }
                break;
            // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
            default:
                if (channelCount === 1) {
                    // ffmpeg -y -f lavfi -i "aevalsrc=0:d=0.05" -c:a libfdk_aac -profile:a aac_he -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                    return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x4e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x1c, 0x6, 0xf1, 0xc1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
                }
                else if (channelCount === 2) {
                    // ffmpeg -y -f lavfi -i "aevalsrc=0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                    return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x5e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x0, 0x95, 0x0, 0x6, 0xf1, 0xa1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
                }
                else if (channelCount === 3) {
                    // ffmpeg -y -f lavfi -i "aevalsrc=0|0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                    return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x5e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x0, 0x95, 0x0, 0x6, 0xf1, 0xa1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
                }
                break;
        }
        return null;
    };
    return AAC;
}());
exports.default = AAC;


/***/ }),

/***/ "./src/remux/mp4-generator.js":
/*!************************************!*\
  !*** ./src/remux/mp4-generator.js ***!
  \************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Generate MP4 Box
*/
Object.defineProperty(exports, "__esModule", { value: true });
var UINT32_MAX = Math.pow(2, 32) - 1;
var MP4 = /** @class */ (function () {
    function MP4() {
    }
    MP4.init = function () {
        MP4.types = {
            avc1: [],
            avcC: [],
            btrt: [],
            dinf: [],
            dref: [],
            esds: [],
            ftyp: [],
            hdlr: [],
            mdat: [],
            mdhd: [],
            mdia: [],
            mfhd: [],
            minf: [],
            moof: [],
            moov: [],
            mp4a: [],
            '.mp3': [],
            mvex: [],
            mvhd: [],
            pasp: [],
            sdtp: [],
            stbl: [],
            stco: [],
            stsc: [],
            stsd: [],
            stsz: [],
            stts: [],
            tfdt: [],
            tfhd: [],
            traf: [],
            trak: [],
            trun: [],
            trex: [],
            tkhd: [],
            vmhd: [],
            smhd: []
        };
        var i;
        for (i in MP4.types) {
            if (MP4.types.hasOwnProperty(i)) {
                MP4.types[i] = [
                    i.charCodeAt(0),
                    i.charCodeAt(1),
                    i.charCodeAt(2),
                    i.charCodeAt(3)
                ];
            }
        }
        var videoHdlr = new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x76, 0x69, 0x64, 0x65,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x56, 0x69, 0x64, 0x65,
            0x6f, 0x48, 0x61, 0x6e,
            0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'VideoHandler'
        ]);
        var audioHdlr = new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x73, 0x6f, 0x75, 0x6e,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x53, 0x6f, 0x75, 0x6e,
            0x64, 0x48, 0x61, 0x6e,
            0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'SoundHandler'
        ]);
        MP4.HDLR_TYPES = {
            'video': videoHdlr,
            'audio': audioHdlr
        };
        var dref = new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x01,
            0x00, 0x00, 0x00, 0x0c,
            0x75, 0x72, 0x6c, 0x20,
            0x00,
            0x00, 0x00, 0x01 // entry_flags
        ]);
        var stco = new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00 // entry_count
        ]);
        MP4.STTS = MP4.STSC = MP4.STCO = stco;
        MP4.STSZ = new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00 // sample_count
        ]);
        MP4.VMHD = new Uint8Array([
            0x00,
            0x00, 0x00, 0x01,
            0x00, 0x00,
            0x00, 0x00,
            0x00, 0x00,
            0x00, 0x00 // opcolor
        ]);
        MP4.SMHD = new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            0x00, 0x00,
            0x00, 0x00 // reserved
        ]);
        MP4.STSD = new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x01
        ]); // entry_count
        var majorBrand = new Uint8Array([105, 115, 111, 109]); // isom
        var avc1Brand = new Uint8Array([97, 118, 99, 49]); // avc1
        var minorVersion = new Uint8Array([0, 0, 0, 1]);
        MP4.FTYP = MP4.box(MP4.types.ftyp, majorBrand, minorVersion, majorBrand, avc1Brand);
        MP4.DINF = MP4.box(MP4.types.dinf, MP4.box(MP4.types.dref, dref));
    };
    MP4.box = function (type) {
        var payload = Array.prototype.slice.call(arguments, 1), size = 8, i = payload.length, len = i, result;
        // calculate the total size we need to allocate
        while (i--) {
            size += payload[i].byteLength;
        }
        result = new Uint8Array(size);
        result[0] = (size >> 24) & 0xff;
        result[1] = (size >> 16) & 0xff;
        result[2] = (size >> 8) & 0xff;
        result[3] = size & 0xff;
        result.set(type, 4);
        // copy the payload into the result
        for (i = 0, size = 8; i < len; i++) {
            // copy payload[i] array @ offset size
            result.set(payload[i], size);
            size += payload[i].byteLength;
        }
        return result;
    };
    MP4.hdlr = function (type) {
        return MP4.box(MP4.types.hdlr, MP4.HDLR_TYPES[type]);
    };
    MP4.mdat = function (data) {
        return MP4.box(MP4.types.mdat, data);
    };
    MP4.mdhd = function (timescale, duration) {
        duration *= timescale;
        var upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
        var lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
        return MP4.box(MP4.types.mdhd, new Uint8Array([
            0x01,
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,
            0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,
            (timescale >> 24) & 0xFF,
            (timescale >> 16) & 0xFF,
            (timescale >> 8) & 0xFF,
            timescale & 0xFF,
            (upperWordDuration >> 24),
            (upperWordDuration >> 16) & 0xFF,
            (upperWordDuration >> 8) & 0xFF,
            upperWordDuration & 0xFF,
            (lowerWordDuration >> 24),
            (lowerWordDuration >> 16) & 0xFF,
            (lowerWordDuration >> 8) & 0xFF,
            lowerWordDuration & 0xFF,
            0x55, 0xc4,
            0x00, 0x00
        ]));
    };
    MP4.mdia = function (track) {
        return MP4.box(MP4.types.mdia, MP4.mdhd(track.timescale, track.duration), MP4.hdlr(track.type), MP4.minf(track));
    };
    MP4.mfhd = function (sequenceNumber) {
        return MP4.box(MP4.types.mfhd, new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            (sequenceNumber >> 24),
            (sequenceNumber >> 16) & 0xFF,
            (sequenceNumber >> 8) & 0xFF,
            sequenceNumber & 0xFF // sequence_number
        ]));
    };
    MP4.minf = function (track) {
        if (track.type === 'audio') {
            return MP4.box(MP4.types.minf, MP4.box(MP4.types.smhd, MP4.SMHD), MP4.DINF, MP4.stbl(track));
        }
        else {
            return MP4.box(MP4.types.minf, MP4.box(MP4.types.vmhd, MP4.VMHD), MP4.DINF, MP4.stbl(track));
        }
    };
    MP4.moof = function (sn, baseMediaDecodeTime, track) {
        return MP4.box(MP4.types.moof, MP4.mfhd(sn), MP4.traf(track, baseMediaDecodeTime));
    };
    /**
   * @param tracks... (optional) {array} the tracks associated with this movie
   */
    MP4.moov = function (tracks) {
        var i = tracks.length, boxes = [];
        while (i--) {
            boxes[i] = MP4.trak(tracks[i]);
        }
        return MP4.box.apply(null, [MP4.types.moov, MP4.mvhd(tracks[0].timescale, tracks[0].duration)].concat(boxes).concat(MP4.mvex(tracks)));
    };
    MP4.mvex = function (tracks) {
        var i = tracks.length, boxes = [];
        while (i--) {
            boxes[i] = MP4.trex(tracks[i]);
        }
        return MP4.box.apply(null, [MP4.types.mvex].concat(boxes));
    };
    MP4.mvhd = function (timescale, duration) {
        duration *= timescale;
        var upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
        var lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
        var bytes = new Uint8Array([
            0x01,
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,
            0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,
            (timescale >> 24) & 0xFF,
            (timescale >> 16) & 0xFF,
            (timescale >> 8) & 0xFF,
            timescale & 0xFF,
            (upperWordDuration >> 24),
            (upperWordDuration >> 16) & 0xFF,
            (upperWordDuration >> 8) & 0xFF,
            upperWordDuration & 0xFF,
            (lowerWordDuration >> 24),
            (lowerWordDuration >> 16) & 0xFF,
            (lowerWordDuration >> 8) & 0xFF,
            lowerWordDuration & 0xFF,
            0x00, 0x01, 0x00, 0x00,
            0x01, 0x00,
            0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x01, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x01, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x40, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0xff, 0xff, 0xff, 0xff // next_track_ID
        ]);
        return MP4.box(MP4.types.mvhd, bytes);
    };
    MP4.sdtp = function (track) {
        var samples = track.samples || [], bytes = new Uint8Array(4 + samples.length), flags, i;
        // leave the full box header (4 bytes) all zero
        // write the sample table
        for (i = 0; i < samples.length; i++) {
            flags = samples[i].flags;
            bytes[i + 4] = (flags.dependsOn << 4) |
                (flags.isDependedOn << 2) |
                (flags.hasRedundancy);
        }
        return MP4.box(MP4.types.sdtp, bytes);
    };
    MP4.stbl = function (track) {
        return MP4.box(MP4.types.stbl, MP4.stsd(track), MP4.box(MP4.types.stts, MP4.STTS), MP4.box(MP4.types.stsc, MP4.STSC), MP4.box(MP4.types.stsz, MP4.STSZ), MP4.box(MP4.types.stco, MP4.STCO));
    };
    MP4.avc1 = function (track) {
        var sps = [], pps = [], i, data, len;
        // assemble the SPSs
        for (i = 0; i < track.sps.length; i++) {
            data = track.sps[i];
            len = data.byteLength;
            sps.push((len >>> 8) & 0xFF);
            sps.push((len & 0xFF));
            // SPS
            sps = sps.concat(Array.prototype.slice.call(data));
        }
        // assemble the PPSs
        for (i = 0; i < track.pps.length; i++) {
            data = track.pps[i];
            len = data.byteLength;
            pps.push((len >>> 8) & 0xFF);
            pps.push((len & 0xFF));
            pps = pps.concat(Array.prototype.slice.call(data));
        }
        var avcc = MP4.box(MP4.types.avcC, new Uint8Array([
            0x01,
            sps[3],
            sps[4],
            sps[5],
            0xfc | 3,
            0xE0 | track.sps.length // 3bit reserved (111) + numOfSequenceParameterSets
        ].concat(sps).concat([
            track.pps.length // numOfPictureParameterSets
        ]).concat(pps))), // "PPS"
        width = track.width, height = track.height, hSpacing = track.pixelRatio[0], vSpacing = track.pixelRatio[1];
        return MP4.box(MP4.types.avc1, new Uint8Array([
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00,
            0x00, 0x01,
            0x00, 0x00,
            0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            (width >> 8) & 0xFF,
            width & 0xff,
            (height >> 8) & 0xFF,
            height & 0xff,
            0x00, 0x48, 0x00, 0x00,
            0x00, 0x48, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x01,
            0x12,
            0x64, 0x61, 0x69, 0x6C,
            0x79, 0x6D, 0x6F, 0x74,
            0x69, 0x6F, 0x6E, 0x2F,
            0x68, 0x6C, 0x73, 0x2E,
            0x6A, 0x73, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00,
            0x00, 0x18,
            0x11, 0x11
        ]), // pre_defined = -1
        avcc, MP4.box(MP4.types.btrt, new Uint8Array([
            0x00, 0x1c, 0x9c, 0x80,
            0x00, 0x2d, 0xc6, 0xc0,
            0x00, 0x2d, 0xc6, 0xc0
        ])), // avgBitrate
        MP4.box(MP4.types.pasp, new Uint8Array([
            (hSpacing >> 24),
            (hSpacing >> 16) & 0xFF,
            (hSpacing >> 8) & 0xFF,
            hSpacing & 0xFF,
            (vSpacing >> 24),
            (vSpacing >> 16) & 0xFF,
            (vSpacing >> 8) & 0xFF,
            vSpacing & 0xFF
        ])));
    };
    MP4.esds = function (track) {
        var configlen = track.config.length;
        return new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            0x03,
            0x17 + configlen,
            0x00, 0x01,
            0x00,
            0x04,
            0x0f + configlen,
            0x40,
            0x15,
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x05 // descriptor_type
        ].concat([configlen]).concat(track.config).concat([0x06, 0x01, 0x02])); // GASpecificConfig)); // length + audio config descriptor
    };
    MP4.mp4a = function (track) {
        var samplerate = track.samplerate;
        return MP4.box(MP4.types.mp4a, new Uint8Array([
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00,
            0x00, 0x01,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, track.channelCount,
            0x00, 0x10,
            0x00, 0x00, 0x00, 0x00,
            (samplerate >> 8) & 0xFF,
            samplerate & 0xff,
            0x00, 0x00
        ]), MP4.box(MP4.types.esds, MP4.esds(track)));
    };
    MP4.mp3 = function (track) {
        var samplerate = track.samplerate;
        return MP4.box(MP4.types['.mp3'], new Uint8Array([
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00,
            0x00, 0x01,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, track.channelCount,
            0x00, 0x10,
            0x00, 0x00, 0x00, 0x00,
            (samplerate >> 8) & 0xFF,
            samplerate & 0xff,
            0x00, 0x00
        ]));
    };
    MP4.stsd = function (track) {
        if (track.type === 'audio') {
            if (!track.isAAC && track.codec === 'mp3') {
                return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp3(track));
            }
            return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp4a(track));
        }
        else {
            return MP4.box(MP4.types.stsd, MP4.STSD, MP4.avc1(track));
        }
    };
    MP4.tkhd = function (track) {
        var id = track.id, duration = track.duration * track.timescale, width = track.width, height = track.height, upperWordDuration = Math.floor(duration / (UINT32_MAX + 1)), lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
        return MP4.box(MP4.types.tkhd, new Uint8Array([
            0x01,
            0x00, 0x00, 0x07,
            0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,
            0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,
            (id >> 24) & 0xFF,
            (id >> 16) & 0xFF,
            (id >> 8) & 0xFF,
            id & 0xFF,
            0x00, 0x00, 0x00, 0x00,
            (upperWordDuration >> 24),
            (upperWordDuration >> 16) & 0xFF,
            (upperWordDuration >> 8) & 0xFF,
            upperWordDuration & 0xFF,
            (lowerWordDuration >> 24),
            (lowerWordDuration >> 16) & 0xFF,
            (lowerWordDuration >> 8) & 0xFF,
            lowerWordDuration & 0xFF,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00,
            0x00, 0x00,
            0x00, 0x00,
            0x00, 0x00,
            0x00, 0x01, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x01, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x40, 0x00, 0x00, 0x00,
            (width >> 8) & 0xFF,
            width & 0xFF,
            0x00, 0x00,
            (height >> 8) & 0xFF,
            height & 0xFF,
            0x00, 0x00 // height
        ]));
    };
    MP4.traf = function (track, baseMediaDecodeTime) {
        var sampleDependencyTable = MP4.sdtp(track), id = track.id, upperWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1)), lowerWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));
        return MP4.box(MP4.types.traf, MP4.box(MP4.types.tfhd, new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            (id >> 24),
            (id >> 16) & 0XFF,
            (id >> 8) & 0XFF,
            (id & 0xFF) // track_ID
        ])), MP4.box(MP4.types.tfdt, new Uint8Array([
            0x01,
            0x00, 0x00, 0x00,
            (upperWordBaseMediaDecodeTime >> 24),
            (upperWordBaseMediaDecodeTime >> 16) & 0XFF,
            (upperWordBaseMediaDecodeTime >> 8) & 0XFF,
            (upperWordBaseMediaDecodeTime & 0xFF),
            (lowerWordBaseMediaDecodeTime >> 24),
            (lowerWordBaseMediaDecodeTime >> 16) & 0XFF,
            (lowerWordBaseMediaDecodeTime >> 8) & 0XFF,
            (lowerWordBaseMediaDecodeTime & 0xFF)
        ])), MP4.trun(track, sampleDependencyTable.length +
            16 + // tfhd
            20 + // tfdt
            8 + // traf header
            16 + // mfhd
            8 + // moof header
            8), // mdat header
        sampleDependencyTable);
    };
    /**
     * Generate a track box.
     * @param track {object} a track definition
     * @return {Uint8Array} the track box
     */
    MP4.trak = function (track) {
        track.duration = track.duration || 0xffffffff;
        return MP4.box(MP4.types.trak, MP4.tkhd(track), MP4.mdia(track));
    };
    MP4.trex = function (track) {
        var id = track.id;
        return MP4.box(MP4.types.trex, new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            (id >> 24),
            (id >> 16) & 0XFF,
            (id >> 8) & 0XFF,
            (id & 0xFF),
            0x00, 0x00, 0x00, 0x01,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x01, 0x00, 0x01 // default_sample_flags
        ]));
    };
    MP4.trun = function (track, offset) {
        var samples = track.samples || [], len = samples.length, arraylen = 12 + (16 * len), array = new Uint8Array(arraylen), i, sample, duration, size, flags, cts;
        offset += 8 + arraylen;
        array.set([
            0x00,
            0x00, 0x0f, 0x01,
            (len >>> 24) & 0xFF,
            (len >>> 16) & 0xFF,
            (len >>> 8) & 0xFF,
            len & 0xFF,
            (offset >>> 24) & 0xFF,
            (offset >>> 16) & 0xFF,
            (offset >>> 8) & 0xFF,
            offset & 0xFF // data_offset
        ], 0);
        for (i = 0; i < len; i++) {
            sample = samples[i];
            duration = sample.duration;
            size = sample.size;
            flags = sample.flags;
            cts = sample.cts;
            array.set([
                (duration >>> 24) & 0xFF,
                (duration >>> 16) & 0xFF,
                (duration >>> 8) & 0xFF,
                duration & 0xFF,
                (size >>> 24) & 0xFF,
                (size >>> 16) & 0xFF,
                (size >>> 8) & 0xFF,
                size & 0xFF,
                (flags.isLeading << 2) | flags.dependsOn,
                (flags.isDependedOn << 6) |
                    (flags.hasRedundancy << 4) |
                    (flags.paddingValue << 1) |
                    flags.isNonSync,
                flags.degradPrio & 0xF0 << 8,
                flags.degradPrio & 0x0F,
                (cts >>> 24) & 0xFF,
                (cts >>> 16) & 0xFF,
                (cts >>> 8) & 0xFF,
                cts & 0xFF // sample_composition_time_offset
            ], 12 + 16 * i);
        }
        return MP4.box(MP4.types.trun, array);
    };
    MP4.initSegment = function (tracks) {
        if (!MP4.types) {
            MP4.init();
        }
        var movie = MP4.moov(tracks), result;
        result = new Uint8Array(MP4.FTYP.byteLength + movie.byteLength);
        result.set(MP4.FTYP);
        result.set(movie, MP4.FTYP.byteLength);
        return result;
    };
    return MP4;
}());
exports.default = MP4;


/***/ }),

/***/ "./src/remux/mp4-remuxer.js":
/*!**********************************!*\
  !*** ./src/remux/mp4-remuxer.js ***!
  \**********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * fMP4 remuxer
*/
Object.defineProperty(exports, "__esModule", { value: true });
var aac_helper_1 = __webpack_require__(/*! ./aac-helper */ "./src/remux/aac-helper.js");
var mp4_generator_1 = __webpack_require__(/*! ./mp4-generator */ "./src/remux/mp4-generator.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
// 10 seconds
var MAX_SILENT_FRAME_DURATION = 10 * 1000;
var MP4Remuxer = /** @class */ (function () {
    function MP4Remuxer(observer, config, typeSupported, vendor) {
        this.observer = observer;
        this.config = config;
        this.typeSupported = typeSupported;
        var userAgent = navigator.userAgent;
        this.isSafari = vendor && vendor.indexOf('Apple') > -1 && userAgent && !userAgent.match('CriOS');
        this.ISGenerated = false;
    }
    MP4Remuxer.prototype.destroy = function () {
    };
    MP4Remuxer.prototype.resetTimeStamp = function (defaultTimeStamp) {
        this._initPTS = this._initDTS = defaultTimeStamp;
    };
    MP4Remuxer.prototype.resetInitSegment = function () {
        this.ISGenerated = false;
    };
    MP4Remuxer.prototype.remux = function (audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
        // generate Init Segment if needed
        if (!this.ISGenerated) {
            this.generateIS(audioTrack, videoTrack, timeOffset);
        }
        if (this.ISGenerated) {
            var nbAudioSamples = audioTrack.samples.length;
            var nbVideoSamples = videoTrack.samples.length;
            var audioTimeOffset = timeOffset;
            var videoTimeOffset = timeOffset;
            if (nbAudioSamples && nbVideoSamples) {
                // timeOffset is expected to be the offset of the first timestamp of this fragment (first DTS)
                // if first audio DTS is not aligned with first video DTS then we need to take that into account
                // when providing timeOffset to remuxAudio / remuxVideo. if we don't do that, there might be a permanent / small
                // drift between audio and video streams
                var audiovideoDeltaDts = (audioTrack.samples[0].pts - videoTrack.samples[0].pts) / videoTrack.inputTimeScale;
                audioTimeOffset += Math.max(0, audiovideoDeltaDts);
                videoTimeOffset += Math.max(0, -audiovideoDeltaDts);
            }
            // Purposefully remuxing audio before video, so that remuxVideo can use nextAudioPts, which is
            // calculated in remuxAudio.
            // logger.log('nb AAC samples:' + audioTrack.samples.length);
            if (nbAudioSamples) {
                // if initSegment was generated without video samples, regenerate it again
                if (!audioTrack.timescale) {
                    logger_1.logger.warn('regenerate InitSegment as audio detected');
                    this.generateIS(audioTrack, videoTrack, timeOffset);
                }
                var audioData = this.remuxAudio(audioTrack, audioTimeOffset, contiguous, accurateTimeOffset);
                // logger.log('nb AVC samples:' + videoTrack.samples.length);
                if (nbVideoSamples) {
                    var audioTrackLength = void 0;
                    if (audioData) {
                        audioTrackLength = audioData.endPTS - audioData.startPTS;
                    }
                    // if initSegment was generated without video samples, regenerate it again
                    if (!videoTrack.timescale) {
                        logger_1.logger.warn('regenerate InitSegment as video detected');
                        this.generateIS(audioTrack, videoTrack, timeOffset);
                    }
                    this.remuxVideo(videoTrack, videoTimeOffset, contiguous, audioTrackLength, accurateTimeOffset);
                }
            }
            else {
                // logger.log('nb AVC samples:' + videoTrack.samples.length);
                if (nbVideoSamples) {
                    var videoData = this.remuxVideo(videoTrack, videoTimeOffset, contiguous, 0, accurateTimeOffset);
                    if (videoData && audioTrack.codec) {
                        this.remuxEmptyAudio(audioTrack, audioTimeOffset, contiguous, videoData);
                    }
                }
            }
        }
        // logger.log('nb ID3 samples:' + audioTrack.samples.length);
        if (id3Track.samples.length) {
            this.remuxID3(id3Track, timeOffset);
        }
        // logger.log('nb ID3 samples:' + audioTrack.samples.length);
        if (textTrack.samples.length) {
            this.remuxText(textTrack, timeOffset);
        }
        // notify end of parsing
        this.observer.trigger(events_1.default.FRAG_PARSED);
    };
    MP4Remuxer.prototype.generateIS = function (audioTrack, videoTrack, timeOffset) {
        var observer = this.observer, audioSamples = audioTrack.samples, videoSamples = videoTrack.samples, typeSupported = this.typeSupported, container = 'audio/mp4', tracks = {}, data = { tracks: tracks }, computePTSDTS = (this._initPTS === undefined), initPTS, initDTS;
        if (computePTSDTS) {
            initPTS = initDTS = Infinity;
        }
        if (audioTrack.config && audioSamples.length) {
            // let's use audio sampling rate as MP4 time scale.
            // rationale is that there is a integer nb of audio frames per audio sample (1024 for AAC)
            // using audio sampling rate here helps having an integer MP4 frame duration
            // this avoids potential rounding issue and AV sync issue
            audioTrack.timescale = audioTrack.samplerate;
            logger_1.logger.log("audio sampling rate : " + audioTrack.samplerate);
            if (!audioTrack.isAAC) {
                if (typeSupported.mpeg) { // Chrome and Safari
                    container = 'audio/mpeg';
                    audioTrack.codec = '';
                }
                else if (typeSupported.mp3) { // Firefox
                    audioTrack.codec = 'mp3';
                }
            }
            tracks.audio = {
                container: container,
                codec: audioTrack.codec,
                initSegment: !audioTrack.isAAC && typeSupported.mpeg ? new Uint8Array() : mp4_generator_1.default.initSegment([audioTrack]),
                metadata: {
                    channelCount: audioTrack.channelCount
                }
            };
            if (computePTSDTS) {
                // remember first PTS of this demuxing context. for audio, PTS = DTS
                initPTS = initDTS = audioSamples[0].pts - audioTrack.inputTimeScale * timeOffset;
            }
        }
        if (videoTrack.sps && videoTrack.pps && videoSamples.length) {
            // let's use input time scale as MP4 video timescale
            // we use input time scale straight away to avoid rounding issues on frame duration / cts computation
            var inputTimeScale = videoTrack.inputTimeScale;
            videoTrack.timescale = inputTimeScale;
            tracks.video = {
                container: 'video/mp4',
                codec: videoTrack.codec,
                initSegment: mp4_generator_1.default.initSegment([videoTrack]),
                metadata: {
                    width: videoTrack.width,
                    height: videoTrack.height
                }
            };
            if (computePTSDTS) {
                initPTS = Math.min(initPTS, videoSamples[0].pts - inputTimeScale * timeOffset);
                initDTS = Math.min(initDTS, videoSamples[0].dts - inputTimeScale * timeOffset);
                this.observer.trigger(events_1.default.INIT_PTS_FOUND, { initPTS: initPTS });
            }
        }
        if (Object.keys(tracks).length) {
            observer.trigger(events_1.default.FRAG_PARSING_INIT_SEGMENT, data);
            this.ISGenerated = true;
            if (computePTSDTS) {
                this._initPTS = initPTS;
                this._initDTS = initDTS;
            }
        }
        else {
            observer.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MEDIA_ERROR, details: errors_1.ErrorDetails.FRAG_PARSING_ERROR, fatal: false, reason: 'no audio/video samples found' });
        }
    };
    MP4Remuxer.prototype.remuxVideo = function (track, timeOffset, contiguous, audioTrackLength, accurateTimeOffset) {
        var offset = 8;
        var mp4SampleDuration;
        var mdat;
        var moof;
        var firstPTS;
        var firstDTS;
        var lastPTS;
        var lastDTS;
        var timeScale = track.timescale;
        var inputSamples = track.samples;
        var outputSamples = [];
        var nbSamples = inputSamples.length;
        var ptsNormalize = this._PTSNormalize;
        var initPTS = this._initPTS;
        // if parsed fragment is contiguous with last one, let's use last DTS value as reference
        var nextAvcDts = this.nextAvcDts;
        var isSafari = this.isSafari;
        if (nbSamples === 0) {
            return;
        }
        // Safari does not like overlapping DTS on consecutive fragments. let's use nextAvcDts to overcome this if fragments are consecutive
        if (isSafari) {
            // also consider consecutive fragments as being contiguous (even if a level switch occurs),
            // for sake of clarity:
            // consecutive fragments are frags with
            //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
            //  - less than 200 ms PTS gaps (timeScale/5)
            contiguous |= (inputSamples.length && nextAvcDts &&
                ((accurateTimeOffset && Math.abs(timeOffset - nextAvcDts / timeScale) < 0.1) ||
                    Math.abs((inputSamples[0].pts - nextAvcDts - initPTS)) < timeScale / 5));
        }
        if (!contiguous) {
            // if not contiguous, let's use target timeOffset
            nextAvcDts = timeOffset * timeScale;
        }
        // PTS is coded on 33bits, and can loop from -2^32 to 2^32
        // ptsNormalize will make PTS/DTS value monotonic, we use last known DTS value as reference value
        inputSamples.forEach(function (sample) {
            sample.pts = ptsNormalize(sample.pts - initPTS, nextAvcDts);
            sample.dts = ptsNormalize(sample.dts - initPTS, nextAvcDts);
        });
        // sort video samples by DTS then PTS then demux id order
        inputSamples.sort(function (a, b) {
            var deltadts = a.dts - b.dts;
            var deltapts = a.pts - b.pts;
            return deltadts || (deltapts || (a.id - b.id));
        });
        // handle broken streams with PTS < DTS, tolerance up 200ms (18000 in 90kHz timescale)
        var PTSDTSshift = inputSamples.reduce(function (prev, curr) { return Math.max(Math.min(prev, curr.pts - curr.dts), -18000); }, 0);
        if (PTSDTSshift < 0) {
            logger_1.logger.warn("PTS < DTS detected in video samples, shifting DTS by " + Math.round(PTSDTSshift / 90) + " ms to overcome this issue");
            for (var i = 0; i < inputSamples.length; i++) {
                inputSamples[i].dts += PTSDTSshift;
            }
        }
        // compute first DTS and last DTS, normalize them against reference value
        var sample = inputSamples[0];
        firstDTS = Math.max(sample.dts, 0);
        firstPTS = Math.max(sample.pts, 0);
        // check timestamp continuity accross consecutive fragments (this is to remove inter-fragment gap/hole)
        var delta = Math.round((firstDTS - nextAvcDts) / 90);
        // if fragment are contiguous, detect hole/overlapping between fragments
        if (contiguous) {
            if (delta) {
                if (delta > 1) {
                    logger_1.logger.log("AVC:" + delta + " ms hole between fragments detected,filling it");
                }
                else if (delta < -1) {
                    logger_1.logger.log("AVC:" + (-delta) + " ms overlapping between fragments detected");
                }
                // remove hole/gap : set DTS to next expected DTS
                firstDTS = nextAvcDts;
                inputSamples[0].dts = firstDTS;
                // offset PTS as well, ensure that PTS is smaller or equal than new DTS
                firstPTS = Math.max(firstPTS - delta, nextAvcDts);
                inputSamples[0].pts = firstPTS;
                logger_1.logger.log("Video/PTS/DTS adjusted: " + Math.round(firstPTS / 90) + "/" + Math.round(firstDTS / 90) + ",delta:" + delta + " ms");
            }
        }
        // compute lastPTS/lastDTS
        sample = inputSamples[inputSamples.length - 1];
        lastDTS = Math.max(sample.dts, 0);
        lastPTS = Math.max(sample.pts, 0, lastDTS);
        // on Safari let's signal the same sample duration for all samples
        // sample duration (as expected by trun MP4 boxes), should be the delta between sample DTS
        // set this constant duration as being the avg delta between consecutive DTS.
        if (isSafari) {
            mp4SampleDuration = Math.round((lastDTS - firstDTS) / (inputSamples.length - 1));
        }
        var nbNalu = 0, naluLen = 0;
        for (var i = 0; i < nbSamples; i++) {
            // compute total/avc sample length and nb of NAL units
            var sample_1 = inputSamples[i], units = sample_1.units, nbUnits = units.length, sampleLen = 0;
            for (var j = 0; j < nbUnits; j++) {
                sampleLen += units[j].data.length;
            }
            naluLen += sampleLen;
            nbNalu += nbUnits;
            sample_1.length = sampleLen;
            // normalize PTS/DTS
            if (isSafari) {
                // sample DTS is computed using a constant decoding offset (mp4SampleDuration) between samples
                sample_1.dts = firstDTS + i * mp4SampleDuration;
            }
            else {
                // ensure sample monotonic DTS
                sample_1.dts = Math.max(sample_1.dts, firstDTS);
            }
            // ensure that computed value is greater or equal than sample DTS
            sample_1.pts = Math.max(sample_1.pts, sample_1.dts);
        }
        /* concatenate the video data and construct the mdat in place
          (need 8 more bytes to fill length and mpdat type) */
        var mdatSize = naluLen + (4 * nbNalu) + 8;
        try {
            mdat = new Uint8Array(mdatSize);
        }
        catch (err) {
            this.observer.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MUX_ERROR, details: errors_1.ErrorDetails.REMUX_ALLOC_ERROR, fatal: false, bytes: mdatSize, reason: "fail allocating video mdat " + mdatSize });
            return;
        }
        var view = new DataView(mdat.buffer);
        view.setUint32(0, mdatSize);
        mdat.set(mp4_generator_1.default.types.mdat, 4);
        for (var i = 0; i < nbSamples; i++) {
            var avcSample = inputSamples[i], avcSampleUnits = avcSample.units, mp4SampleLength = 0, compositionTimeOffset = void 0;
            // convert NALU bitstream to MP4 format (prepend NALU with size field)
            for (var j = 0, nbUnits = avcSampleUnits.length; j < nbUnits; j++) {
                var unit = avcSampleUnits[j], unitData = unit.data, unitDataLen = unit.data.byteLength;
                view.setUint32(offset, unitDataLen);
                offset += 4;
                mdat.set(unitData, offset);
                offset += unitDataLen;
                mp4SampleLength += 4 + unitDataLen;
            }
            if (!isSafari) {
                // expected sample duration is the Decoding Timestamp diff of consecutive samples
                if (i < nbSamples - 1) {
                    mp4SampleDuration = inputSamples[i + 1].dts - avcSample.dts;
                }
                else {
                    var config = this.config, lastFrameDuration = avcSample.dts - inputSamples[i > 0 ? i - 1 : i].dts;
                    if (config.stretchShortVideoTrack) {
                        // In some cases, a segment's audio track duration may exceed the video track duration.
                        // Since we've already remuxed audio, and we know how long the audio track is, we look to
                        // see if the delta to the next segment is longer than maxBufferHole.
                        // If so, playback would potentially get stuck, so we artificially inflate
                        // the duration of the last frame to minimize any potential gap between segments.
                        var maxBufferHole = config.maxBufferHole, gapTolerance = Math.floor(maxBufferHole * timeScale), deltaToFrameEnd = (audioTrackLength ? firstPTS + audioTrackLength * timeScale : this.nextAudioPts) - avcSample.pts;
                        if (deltaToFrameEnd > gapTolerance) {
                            // We subtract lastFrameDuration from deltaToFrameEnd to try to prevent any video
                            // frame overlap. maxBufferHole should be >> lastFrameDuration anyway.
                            mp4SampleDuration = deltaToFrameEnd - lastFrameDuration;
                            if (mp4SampleDuration < 0) {
                                mp4SampleDuration = lastFrameDuration;
                            }
                            logger_1.logger.log("It is approximately " + deltaToFrameEnd / 90 + " ms to the next segment; using duration " + mp4SampleDuration / 90 + " ms for the last video frame.");
                        }
                        else {
                            mp4SampleDuration = lastFrameDuration;
                        }
                    }
                    else {
                        mp4SampleDuration = lastFrameDuration;
                    }
                }
                compositionTimeOffset = Math.round(avcSample.pts - avcSample.dts);
            }
            else {
                compositionTimeOffset = Math.max(0, mp4SampleDuration * Math.round((avcSample.pts - avcSample.dts) / mp4SampleDuration));
            }
            // console.log('PTS/DTS/initDTS/normPTS/normDTS/relative PTS : ${avcSample.pts}/${avcSample.dts}/${initDTS}/${ptsnorm}/${dtsnorm}/${(avcSample.pts/4294967296).toFixed(3)}');
            outputSamples.push({
                size: mp4SampleLength,
                // constant duration
                duration: mp4SampleDuration,
                cts: compositionTimeOffset,
                flags: {
                    isLeading: 0,
                    isDependedOn: 0,
                    hasRedundancy: 0,
                    degradPrio: 0,
                    dependsOn: avcSample.key ? 2 : 1,
                    isNonSync: avcSample.key ? 0 : 1
                }
            });
        }
        // next AVC sample DTS should be equal to last sample DTS + last sample duration (in PES timescale)
        this.nextAvcDts = lastDTS + mp4SampleDuration;
        var dropped = track.dropped;
        track.len = 0;
        track.nbNalu = 0;
        track.dropped = 0;
        if (outputSamples.length && navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
            var flags = outputSamples[0].flags;
            // chrome workaround, mark first sample as being a Random Access Point to avoid sourcebuffer append issue
            // https://code.google.com/p/chromium/issues/detail?id=229412
            flags.dependsOn = 2;
            flags.isNonSync = 0;
        }
        track.samples = outputSamples;
        moof = mp4_generator_1.default.moof(track.sequenceNumber++, firstDTS, track);
        track.samples = [];
        var data = {
            data1: moof,
            data2: mdat,
            startPTS: firstPTS / timeScale,
            endPTS: (lastPTS + mp4SampleDuration) / timeScale,
            startDTS: firstDTS / timeScale,
            endDTS: this.nextAvcDts / timeScale,
            type: 'video',
            hasAudio: false,
            hasVideo: true,
            nb: outputSamples.length,
            dropped: dropped
        };
        this.observer.trigger(events_1.default.FRAG_PARSING_DATA, data);
        return data;
    };
    MP4Remuxer.prototype.remuxAudio = function (track, timeOffset, contiguous, accurateTimeOffset) {
        var inputTimeScale = track.inputTimeScale;
        var mp4timeScale = track.timescale;
        var scaleFactor = inputTimeScale / mp4timeScale;
        var mp4SampleDuration = track.isAAC ? 1024 : 1152;
        var inputSampleDuration = mp4SampleDuration * scaleFactor;
        var ptsNormalize = this._PTSNormalize;
        var initPTS = this._initPTS;
        var rawMPEG = !track.isAAC && this.typeSupported.mpeg;
        var offset, mp4Sample, fillFrame, mdat, moof, firstPTS, lastPTS, inputSamples = track.samples, outputSamples = [], nextAudioPts = this.nextAudioPts;
        // for audio samples, also consider consecutive fragments as being contiguous (even if a level switch occurs),
        // for sake of clarity:
        // consecutive fragments are frags with
        //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
        //  - less than 20 audio frames distance
        // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
        // this helps ensuring audio continuity
        // and this also avoids audio glitches/cut when switching quality, or reporting wrong duration on first audio frame
        contiguous |= (inputSamples.length && nextAudioPts &&
            ((accurateTimeOffset && Math.abs(timeOffset - nextAudioPts / inputTimeScale) < 0.1) ||
                Math.abs((inputSamples[0].pts - nextAudioPts - initPTS)) < 20 * inputSampleDuration));
        // compute normalized PTS
        inputSamples.forEach(function (sample) {
            sample.pts = sample.dts = ptsNormalize(sample.pts - initPTS, timeOffset * inputTimeScale);
        });
        // filter out sample with negative PTS that are not playable anyway
        // if we don't remove these negative samples, they will shift all audio samples forward.
        // leading to audio overlap between current / next fragment
        inputSamples = inputSamples.filter(function (sample) {
            return sample.pts >= 0;
        });
        // in case all samples have negative PTS, and have been filtered out, return now
        if (inputSamples.length === 0) {
            return;
        }
        if (!contiguous) {
            if (!accurateTimeOffset) {
                // if frag are mot contiguous and if we cant trust time offset, let's use first sample PTS as next audio PTS
                nextAudioPts = inputSamples[0].pts;
            }
            else {
                // if timeOffset is accurate, let's use it as predicted next audio PTS
                nextAudioPts = timeOffset * inputTimeScale;
            }
        }
        // If the audio track is missing samples, the frames seem to get "left-shifted" within the
        // resulting mp4 segment, causing sync issues and leaving gaps at the end of the audio segment.
        // In an effort to prevent this from happening, we inject frames here where there are gaps.
        // When possible, we inject a silent frame; when that's not possible, we duplicate the last
        // frame.
        if (track.isAAC) {
            var maxAudioFramesDrift = this.config.maxAudioFramesDrift;
            for (var i = 0, nextPts = nextAudioPts; i < inputSamples.length;) {
                // First, let's see how far off this frame is from where we expect it to be
                var sample = inputSamples[i], delta;
                var pts = sample.pts;
                delta = pts - nextPts;
                var duration = Math.abs(1000 * delta / inputTimeScale);
                // If we're overlapping by more than a duration, drop this sample
                if (delta <= -maxAudioFramesDrift * inputSampleDuration) {
                    logger_1.logger.warn("Dropping 1 audio frame @ " + (nextPts / inputTimeScale).toFixed(3) + "s due to " + Math.round(duration) + " ms overlap.");
                    inputSamples.splice(i, 1);
                    track.len -= sample.unit.length;
                    // Don't touch nextPtsNorm or i
                } // eslint-disable-line brace-style
                // Insert missing frames if:
                // 1: We're more than maxAudioFramesDrift frame away
                // 2: Not more than MAX_SILENT_FRAME_DURATION away
                // 3: currentTime (aka nextPtsNorm) is not 0
                else if (delta >= maxAudioFramesDrift * inputSampleDuration && duration < MAX_SILENT_FRAME_DURATION && nextPts) {
                    var missing = Math.round(delta / inputSampleDuration);
                    logger_1.logger.warn("Injecting " + missing + " audio frame @ " + (nextPts / inputTimeScale).toFixed(3) + "s due to " + Math.round(1000 * delta / inputTimeScale) + " ms gap.");
                    for (var j = 0; j < missing; j++) {
                        var newStamp = Math.max(nextPts, 0);
                        fillFrame = aac_helper_1.default.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
                        if (!fillFrame) {
                            logger_1.logger.log('Unable to get silent frame for given audio codec; duplicating last frame instead.');
                            fillFrame = sample.unit.subarray();
                        }
                        inputSamples.splice(i, 0, { unit: fillFrame, pts: newStamp, dts: newStamp });
                        track.len += fillFrame.length;
                        nextPts += inputSampleDuration;
                        i++;
                    }
                    // Adjust sample to next expected pts
                    sample.pts = sample.dts = nextPts;
                    nextPts += inputSampleDuration;
                    i++;
                }
                else {
                    // Otherwise, just adjust pts
                    if (Math.abs(delta) > (0.1 * inputSampleDuration)) {
                        // logger.log(`Invalid frame delta ${Math.round(delta + inputSampleDuration)} at PTS ${Math.round(pts / 90)} (should be ${Math.round(inputSampleDuration)}).`);
                    }
                    sample.pts = sample.dts = nextPts;
                    nextPts += inputSampleDuration;
                    i++;
                }
            }
        }
        for (var j = 0, nbSamples_1 = inputSamples.length; j < nbSamples_1; j++) {
            var audioSample = inputSamples[j];
            var unit = audioSample.unit;
            var pts = audioSample.pts;
            // logger.log(`Audio/PTS:${Math.round(pts/90)}`);
            // if not first sample
            if (lastPTS !== undefined) {
                mp4Sample.duration = Math.round((pts - lastPTS) / scaleFactor);
            }
            else {
                var delta_1 = Math.round(1000 * (pts - nextAudioPts) / inputTimeScale), numMissingFrames = 0;
                // if fragment are contiguous, detect hole/overlapping between fragments
                // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
                if (contiguous && track.isAAC) {
                    // log delta
                    if (delta_1) {
                        if (delta_1 > 0 && delta_1 < MAX_SILENT_FRAME_DURATION) {
                            numMissingFrames = Math.round((pts - nextAudioPts) / inputSampleDuration);
                            logger_1.logger.log(delta_1 + " ms hole between AAC samples detected,filling it");
                            if (numMissingFrames > 0) {
                                fillFrame = aac_helper_1.default.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
                                if (!fillFrame) {
                                    fillFrame = unit.subarray();
                                }
                                track.len += numMissingFrames * fillFrame.length;
                            }
                            // if we have frame overlap, overlapping for more than half a frame duraion
                        }
                        else if (delta_1 < -12) {
                            // drop overlapping audio frames... browser will deal with it
                            logger_1.logger.log("drop overlapping AAC sample, expected/parsed/delta:" + (nextAudioPts / inputTimeScale).toFixed(3) + "s/" + (pts / inputTimeScale).toFixed(3) + "s/" + (-delta_1) + "ms");
                            track.len -= unit.byteLength;
                            continue;
                        }
                        // set PTS/DTS to expected PTS/DTS
                        pts = nextAudioPts;
                    }
                }
                // remember first PTS of our audioSamples
                firstPTS = pts;
                if (track.len > 0) {
                    /* concatenate the audio data and construct the mdat in place
                      (need 8 more bytes to fill length and mdat type) */
                    var mdatSize = rawMPEG ? track.len : track.len + 8;
                    offset = rawMPEG ? 0 : 8;
                    try {
                        mdat = new Uint8Array(mdatSize);
                    }
                    catch (err) {
                        this.observer.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MUX_ERROR, details: errors_1.ErrorDetails.REMUX_ALLOC_ERROR, fatal: false, bytes: mdatSize, reason: "fail allocating audio mdat " + mdatSize });
                        return;
                    }
                    if (!rawMPEG) {
                        var view = new DataView(mdat.buffer);
                        view.setUint32(0, mdatSize);
                        mdat.set(mp4_generator_1.default.types.mdat, 4);
                    }
                }
                else {
                    // no audio samples
                    return;
                }
                for (var i = 0; i < numMissingFrames; i++) {
                    fillFrame = aac_helper_1.default.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
                    if (!fillFrame) {
                        logger_1.logger.log('Unable to get silent frame for given audio codec; duplicating this frame instead.');
                        fillFrame = unit.subarray();
                    }
                    mdat.set(fillFrame, offset);
                    offset += fillFrame.byteLength;
                    mp4Sample = {
                        size: fillFrame.byteLength,
                        cts: 0,
                        duration: 1024,
                        flags: {
                            isLeading: 0,
                            isDependedOn: 0,
                            hasRedundancy: 0,
                            degradPrio: 0,
                            dependsOn: 1
                        }
                    };
                    outputSamples.push(mp4Sample);
                }
            }
            mdat.set(unit, offset);
            var unitLen = unit.byteLength;
            offset += unitLen;
            // console.log('PTS/DTS/initDTS/normPTS/normDTS/relative PTS : ${audioSample.pts}/${audioSample.dts}/${initDTS}/${ptsnorm}/${dtsnorm}/${(audioSample.pts/4294967296).toFixed(3)}');
            mp4Sample = {
                size: unitLen,
                cts: 0,
                duration: 0,
                flags: {
                    isLeading: 0,
                    isDependedOn: 0,
                    hasRedundancy: 0,
                    degradPrio: 0,
                    dependsOn: 1
                }
            };
            outputSamples.push(mp4Sample);
            lastPTS = pts;
        }
        var lastSampleDuration = 0;
        var nbSamples = outputSamples.length;
        // set last sample duration as being identical to previous sample
        if (nbSamples >= 2) {
            lastSampleDuration = outputSamples[nbSamples - 2].duration;
            mp4Sample.duration = lastSampleDuration;
        }
        if (nbSamples) {
            // next audio sample PTS should be equal to last sample PTS + duration
            this.nextAudioPts = nextAudioPts = lastPTS + scaleFactor * lastSampleDuration;
            // logger.log('Audio/PTS/PTSend:' + audioSample.pts.toFixed(0) + '/' + this.nextAacDts.toFixed(0));
            track.len = 0;
            track.samples = outputSamples;
            if (rawMPEG) {
                moof = new Uint8Array();
            }
            else {
                moof = mp4_generator_1.default.moof(track.sequenceNumber++, firstPTS / scaleFactor, track);
            }
            track.samples = [];
            var start = firstPTS / inputTimeScale;
            var end = nextAudioPts / inputTimeScale;
            var audioData = {
                data1: moof,
                data2: mdat,
                startPTS: start,
                endPTS: end,
                startDTS: start,
                endDTS: end,
                type: 'audio',
                hasAudio: true,
                hasVideo: false,
                nb: nbSamples
            };
            this.observer.trigger(events_1.default.FRAG_PARSING_DATA, audioData);
            return audioData;
        }
        return null;
    };
    MP4Remuxer.prototype.remuxEmptyAudio = function (track, timeOffset, contiguous, videoData) {
        var inputTimeScale = track.inputTimeScale, mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale, scaleFactor = inputTimeScale / mp4timeScale, nextAudioPts = this.nextAudioPts, 
        // sync with video's timestamp
        startDTS = (nextAudioPts !== undefined ? nextAudioPts : videoData.startDTS * inputTimeScale) + this._initDTS, endDTS = videoData.endDTS * inputTimeScale + this._initDTS, 
        // one sample's duration value
        sampleDuration = 1024, frameDuration = scaleFactor * sampleDuration, 
        // samples count of this segment's duration
        nbSamples = Math.ceil((endDTS - startDTS) / frameDuration), 
        // silent frame
        silentFrame = aac_helper_1.default.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
        logger_1.logger.warn('remux empty Audio');
        // Can't remux if we can't generate a silent frame...
        if (!silentFrame) {
            logger_1.logger.trace('Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec!');
            return;
        }
        var samples = [];
        for (var i = 0; i < nbSamples; i++) {
            var stamp = startDTS + i * frameDuration;
            samples.push({ unit: silentFrame, pts: stamp, dts: stamp });
            track.len += silentFrame.length;
        }
        track.samples = samples;
        this.remuxAudio(track, timeOffset, contiguous);
    };
    MP4Remuxer.prototype.remuxID3 = function (track) {
        var length = track.samples.length, sample;
        var inputTimeScale = track.inputTimeScale;
        var initPTS = this._initPTS;
        var initDTS = this._initDTS;
        // consume samples
        if (length) {
            for (var index = 0; index < length; index++) {
                sample = track.samples[index];
                // setting id3 pts, dts to relative time
                // using this._initPTS and this._initDTS to calculate relative time
                sample.pts = ((sample.pts - initPTS) / inputTimeScale);
                sample.dts = ((sample.dts - initDTS) / inputTimeScale);
            }
            this.observer.trigger(events_1.default.FRAG_PARSING_METADATA, {
                samples: track.samples
            });
        }
        track.samples = [];
    };
    MP4Remuxer.prototype.remuxText = function (track) {
        track.samples.sort(function (a, b) {
            return (a.pts - b.pts);
        });
        var length = track.samples.length, sample;
        var inputTimeScale = track.inputTimeScale;
        var initPTS = this._initPTS;
        // consume samples
        if (length) {
            for (var index = 0; index < length; index++) {
                sample = track.samples[index];
                // setting text pts, dts to relative time
                // using this._initPTS and this._initDTS to calculate relative time
                sample.pts = ((sample.pts - initPTS) / inputTimeScale);
            }
            this.observer.trigger(events_1.default.FRAG_PARSING_USERDATA, {
                samples: track.samples
            });
        }
        track.samples = [];
    };
    MP4Remuxer.prototype._PTSNormalize = function (value, reference) {
        var offset;
        if (reference === undefined) {
            return value;
        }
        if (reference < value) {
            // - 2^33
            offset = -8589934592;
        }
        else {
            // + 2^33
            offset = 8589934592;
        }
        /* PTS is 33bit (from 0 to 2^33 -1)
          if diff between value and reference is bigger than half of the amplitude (2^32) then it means that
          PTS looping occured. fill the gap */
        while (Math.abs(value - reference) > 4294967296) {
            value += offset;
        }
        return value;
    };
    return MP4Remuxer;
}());
exports.default = MP4Remuxer;


/***/ }),

/***/ "./src/remux/passthrough-remuxer.js":
/*!******************************************!*\
  !*** ./src/remux/passthrough-remuxer.js ***!
  \******************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * passthrough remuxer
*/
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var PassThroughRemuxer = /** @class */ (function () {
    function PassThroughRemuxer(observer) {
        this.observer = observer;
    }
    PassThroughRemuxer.prototype.destroy = function () {
    };
    PassThroughRemuxer.prototype.resetTimeStamp = function () {
    };
    PassThroughRemuxer.prototype.resetInitSegment = function () {
    };
    PassThroughRemuxer.prototype.remux = function (audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset, rawData) {
        var observer = this.observer;
        var streamType = '';
        if (audioTrack) {
            streamType += 'audio';
        }
        if (videoTrack) {
            streamType += 'video';
        }
        observer.trigger(events_1.default.FRAG_PARSING_DATA, {
            data1: rawData,
            startPTS: timeOffset,
            startDTS: timeOffset,
            type: streamType,
            hasAudio: !!audioTrack,
            hasVideo: !!videoTrack,
            nb: 1,
            dropped: 0
        });
        // notify end of parsing
        observer.trigger(events_1.default.FRAG_PARSED);
    };
    return PassThroughRemuxer;
}());
exports.default = PassThroughRemuxer;


/***/ }),

/***/ "./src/task-loop.js":
/*!**************************!*\
  !*** ./src/task-loop.js ***!
  \**************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var event_handler_1 = __webpack_require__(/*! ./event-handler */ "./src/event-handler.js");
/**
 * Sub-class specialization of EventHandler base class.
 *
 * TaskLoop allows to schedule a task function being called (optionnaly repeatedly) on the main loop,
 * scheduled asynchroneously, avoiding recursive calls in the same tick.
 *
 * The task itself is implemented in `doTick`. It can be requested and called for single execution
 * using the `tick` method.
 *
 * It will be assured that the task execution method (`tick`) only gets called once per main loop "tick",
 * no matter how often it gets requested for execution. Execution in further ticks will be scheduled accordingly.
 *
 * If further execution requests have already been scheduled on the next tick, it can be checked with `hasNextTick`,
 * and cancelled with `clearNextTick`.
 *
 * The task can be scheduled as an interval repeatedly with a period as parameter (see `setInterval`, `clearInterval`).
 *
 * Sub-classes need to implement the `doTick` method which will effectively have the task execution routine.
 *
 * Further explanations:
 *
 * The baseclass has a `tick` method that will schedule the doTick call. It may be called synchroneously
 * only for a stack-depth of one. On re-entrant calls, sub-sequent calls are scheduled for next main loop ticks.
 *
 * When the task execution (`tick` method) is called in re-entrant way this is detected and
 * we are limiting the task execution per call stack to exactly one, but scheduling/post-poning further
 * task processing on the next main loop iteration (also known as "next tick" in the Node/JS runtime lingo).
 */
var TaskLoop = /** @class */ (function (_super) {
    __extends(TaskLoop, _super);
    function TaskLoop(hls) {
        var events = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            events[_i - 1] = arguments[_i];
        }
        var _this = _super.apply(this, [hls].concat(events)) || this;
        _this._tickInterval = null;
        _this._tickTimer = null;
        _this._tickCallCount = 0;
        _this._boundTick = _this.tick.bind(_this);
        return _this;
    }
    /**
     * @override
     */
    TaskLoop.prototype.onHandlerDestroying = function () {
        // clear all timers before unregistering from event bus
        this.clearNextTick();
        this.clearInterval();
    };
    /**
     * @returns {boolean}
     */
    TaskLoop.prototype.hasInterval = function () {
        return !!this._tickInterval;
    };
    /**
     * @returns {boolean}
     */
    TaskLoop.prototype.hasNextTick = function () {
        return !!this._tickTimer;
    };
    /**
     * @param {number} millis Interval time (ms)
     * @returns {boolean} True when interval has been scheduled, false when already scheduled (no effect)
     */
    TaskLoop.prototype.setInterval = function (millis) {
        if (!this._tickInterval) {
            this._tickInterval = setInterval(this._boundTick, millis);
            return true;
        }
        return false;
    };
    /**
     * @returns {boolean} True when interval was cleared, false when none was set (no effect)
     */
    TaskLoop.prototype.clearInterval = function () {
        if (this._tickInterval) {
            clearInterval(this._tickInterval);
            this._tickInterval = null;
            return true;
        }
        return false;
    };
    /**
     * @returns {boolean} True when timeout was cleared, false when none was set (no effect)
     */
    TaskLoop.prototype.clearNextTick = function () {
        if (this._tickTimer) {
            clearTimeout(this._tickTimer);
            this._tickTimer = null;
            return true;
        }
        return false;
    };
    /**
     * Will call the subclass doTick implementation in this main loop tick
     * or in the next one (via setTimeout(,0)) in case it has already been called
     * in this tick (in case this is a re-entrant call).
     */
    TaskLoop.prototype.tick = function () {
        this._tickCallCount++;
        if (this._tickCallCount === 1) {
            this.doTick();
            // re-entrant call to tick from previous doTick call stack
            // -> schedule a call on the next main loop iteration to process this task processing request
            if (this._tickCallCount > 1) {
                // make sure only one timer exists at any time at max
                this.clearNextTick();
                this._tickTimer = setTimeout(this._boundTick, 0);
            }
            this._tickCallCount = 0;
        }
    };
    /**
     * For subclass to implement task logic
     * @abstract
     */
    TaskLoop.prototype.doTick = function () { };
    return TaskLoop;
}(event_handler_1.default));
exports.default = TaskLoop;


/***/ }),

/***/ "./src/utils/attr-list.js":
/*!********************************!*\
  !*** ./src/utils/attr-list.js ***!
  \********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
Object.defineProperty(exports, "__esModule", { value: true });
var DECIMAL_RESOLUTION_REGEX = /^(\d+)x(\d+)$/; // eslint-disable-line no-useless-escape
var ATTR_LIST_REGEX = /\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g; // eslint-disable-line no-useless-escape
// adapted from https://github.com/kanongil/node-m3u8parse/blob/master/attrlist.js
var AttrList = /** @class */ (function () {
    function AttrList(attrs) {
        if (typeof attrs === 'string') {
            attrs = AttrList.parseAttrList(attrs);
        }
        for (var attr in attrs) {
            if (attrs.hasOwnProperty(attr)) {
                this[attr] = attrs[attr];
            }
        }
    }
    AttrList.prototype.decimalInteger = function (attrName) {
        var intValue = parseInt(this[attrName], 10);
        if (intValue > Number.MAX_SAFE_INTEGER) {
            return Infinity;
        }
        return intValue;
    };
    AttrList.prototype.hexadecimalInteger = function (attrName) {
        if (this[attrName]) {
            var stringValue = (this[attrName] || '0x').slice(2);
            stringValue = ((stringValue.length & 1) ? '0' : '') + stringValue;
            var value = new Uint8Array(stringValue.length / 2);
            for (var i = 0; i < stringValue.length / 2; i++) {
                value[i] = parseInt(stringValue.slice(i * 2, i * 2 + 2), 16);
            }
            return value;
        }
        else {
            return null;
        }
    };
    AttrList.prototype.hexadecimalIntegerAsNumber = function (attrName) {
        var intValue = parseInt(this[attrName], 16);
        if (intValue > Number.MAX_SAFE_INTEGER) {
            return Infinity;
        }
        return intValue;
    };
    AttrList.prototype.decimalFloatingPoint = function (attrName) {
        return parseFloat(this[attrName]);
    };
    AttrList.prototype.enumeratedString = function (attrName) {
        return this[attrName];
    };
    AttrList.prototype.decimalResolution = function (attrName) {
        var res = DECIMAL_RESOLUTION_REGEX.exec(this[attrName]);
        if (res === null) {
            return undefined;
        }
        return {
            width: parseInt(res[1], 10),
            height: parseInt(res[2], 10)
        };
    };
    AttrList.parseAttrList = function (input) {
        var match, attrs = {};
        ATTR_LIST_REGEX.lastIndex = 0;
        while ((match = ATTR_LIST_REGEX.exec(input)) !== null) {
            var value = match[2], quote = '"';
            if (value.indexOf(quote) === 0 &&
                value.lastIndexOf(quote) === (value.length - 1)) {
                value = value.slice(1, -1);
            }
            attrs[match[1]] = value;
        }
        return attrs;
    };
    return AttrList;
}());
exports.default = AttrList;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/utils/binary-search.js":
/*!************************************!*\
  !*** ./src/utils/binary-search.js ***!
  \************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BinarySearch = {
    /**
       * Searches for an item in an array which matches a certain condition.
       * This requires the condition to only match one item in the array,
       * and for the array to be ordered.
       *
       * @param {Array} list The array to search.
       * @param {Function} comparisonFunction
       *      Called and provided a candidate item as the first argument.
       *      Should return:
       *          > -1 if the item should be located at a lower index than the provided item.
       *          > 1 if the item should be located at a higher index than the provided item.
       *          > 0 if the item is the item you're looking for.
       *
       * @return {*} The object if it is found or null otherwise.
       */
    search: function (list, comparisonFunction) {
        var minIndex = 0;
        var maxIndex = list.length - 1;
        var currentIndex = null;
        var currentElement = null;
        while (minIndex <= maxIndex) {
            currentIndex = (minIndex + maxIndex) / 2 | 0;
            currentElement = list[currentIndex];
            var comparisonResult = comparisonFunction(currentElement);
            if (comparisonResult > 0) {
                minIndex = currentIndex + 1;
            }
            else if (comparisonResult < 0) {
                maxIndex = currentIndex - 1;
            }
            else {
                return currentElement;
            }
        }
        return null;
    }
};
exports.default = BinarySearch;


/***/ }),

/***/ "./src/utils/buffer-helper.js":
/*!************************************!*\
  !*** ./src/utils/buffer-helper.js ***!
  \************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module BufferHelper
 *
 * Providing methods dealing with buffer length retrieval for example.
 *
 * In general, a helper around HTML5 MediaElement TimeRanges gathered from `buffered` property.
 *
 * Also @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/buffered
*/
Object.defineProperty(exports, "__esModule", { value: true });
var BufferHelper = /** @class */ (function () {
    function BufferHelper() {
    }
    /**
     * Return true if `media`'s buffered include `position`
     * @param {HTMLMediaElement|SourceBuffer} media
     * @param {number} position
     * @returns {boolean}
     */
    BufferHelper.isBuffered = function (media, position) {
        try {
            if (media) {
                var buffered = media.buffered;
                for (var i = 0; i < buffered.length; i++) {
                    if (position >= buffered.start(i) && position <= buffered.end(i)) {
                        return true;
                    }
                }
            }
        }
        catch (error) {
            // this is to catch
            // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
            // This SourceBuffer has been removed from the parent media source
        }
        return false;
    };
    BufferHelper.bufferInfo = function (media, pos, maxHoleDuration) {
        try {
            if (media) {
                var vbuffered = media.buffered, buffered = [], i = void 0;
                for (i = 0; i < vbuffered.length; i++) {
                    buffered.push({ start: vbuffered.start(i), end: vbuffered.end(i) });
                }
                return this.bufferedInfo(buffered, pos, maxHoleDuration);
            }
        }
        catch (error) {
            // this is to catch
            // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
            // This SourceBuffer has been removed from the parent media source
        }
        return { len: 0, start: pos, end: pos, nextStart: undefined };
    };
    BufferHelper.bufferedInfo = function (buffered, pos, maxHoleDuration) {
        var buffered2 = [], 
        // bufferStart and bufferEnd are buffer boundaries around current video position
        bufferLen, bufferStart, bufferEnd, bufferStartNext, i;
        // sort on buffer.start/smaller end (IE does not always return sorted buffered range)
        buffered.sort(function (a, b) {
            var diff = a.start - b.start;
            if (diff) {
                return diff;
            }
            else {
                return b.end - a.end;
            }
        });
        // there might be some small holes between buffer time range
        // consider that holes smaller than maxHoleDuration are irrelevant and build another
        // buffer time range representations that discards those holes
        for (i = 0; i < buffered.length; i++) {
            var buf2len = buffered2.length;
            if (buf2len) {
                var buf2end = buffered2[buf2len - 1].end;
                // if small hole (value between 0 or maxHoleDuration ) or overlapping (negative)
                if ((buffered[i].start - buf2end) < maxHoleDuration) {
                    // merge overlapping time ranges
                    // update lastRange.end only if smaller than item.end
                    // e.g.  [ 1, 15] with  [ 2,8] => [ 1,15] (no need to modify lastRange.end)
                    // whereas [ 1, 8] with  [ 2,15] => [ 1,15] ( lastRange should switch from [1,8] to [1,15])
                    if (buffered[i].end > buf2end) {
                        buffered2[buf2len - 1].end = buffered[i].end;
                    }
                }
                else {
                    // big hole
                    buffered2.push(buffered[i]);
                }
            }
            else {
                // first value
                buffered2.push(buffered[i]);
            }
        }
        for (i = 0, bufferLen = 0, bufferStart = bufferEnd = pos; i < buffered2.length; i++) {
            var start = buffered2[i].start, end = buffered2[i].end;
            // logger.log('buf start/end:' + buffered.start(i) + '/' + buffered.end(i));
            if ((pos + maxHoleDuration) >= start && pos < end) {
                // play position is inside this buffer TimeRange, retrieve end of buffer position and buffer length
                bufferStart = start;
                bufferEnd = end;
                bufferLen = bufferEnd - pos;
            }
            else if ((pos + maxHoleDuration) < start) {
                bufferStartNext = start;
                break;
            }
        }
        return { len: bufferLen, start: bufferStart, end: bufferEnd, nextStart: bufferStartNext };
    };
    return BufferHelper;
}());
exports.BufferHelper = BufferHelper;


/***/ }),

/***/ "./src/utils/cea-608-parser.js":
/*!*************************************!*\
  !*** ./src/utils/cea-608-parser.js ***!
  \*************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 *
 * This code was ported from the dash.js project at:
 *   https://github.com/Dash-Industry-Forum/dash.js/blob/development/externals/cea608-parser.js
 *   https://github.com/Dash-Industry-Forum/dash.js/commit/8269b26a761e0853bb21d78780ed945144ecdd4d#diff-71bc295a2d6b6b7093a1d3290d53a4b2
 *
 * The original copyright appears below:
 *
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2015-2016, DASH Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  1. Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  2. Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
     *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
     */
Object.defineProperty(exports, "__esModule", { value: true });
var specialCea608CharsCodes = {
    0x2a: 0xe1,
    0x5c: 0xe9,
    0x5e: 0xed,
    0x5f: 0xf3,
    0x60: 0xfa,
    0x7b: 0xe7,
    0x7c: 0xf7,
    0x7d: 0xd1,
    0x7e: 0xf1,
    0x7f: 0x2588,
    // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
    // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
    0x80: 0xae,
    0x81: 0xb0,
    0x82: 0xbd,
    0x83: 0xbf,
    0x84: 0x2122,
    0x85: 0xa2,
    0x86: 0xa3,
    0x87: 0x266a,
    0x88: 0xe0,
    0x89: 0x20,
    0x8a: 0xe8,
    0x8b: 0xe2,
    0x8c: 0xea,
    0x8d: 0xee,
    0x8e: 0xf4,
    0x8f: 0xfb,
    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
    0x90: 0xc1,
    0x91: 0xc9,
    0x92: 0xd3,
    0x93: 0xda,
    0x94: 0xdc,
    0x95: 0xfc,
    0x96: 0x2018,
    0x97: 0xa1,
    0x98: 0x2a,
    0x99: 0x2019,
    0x9a: 0x2501,
    0x9b: 0xa9,
    0x9c: 0x2120,
    0x9d: 0x2022,
    0x9e: 0x201c,
    0x9f: 0x201d,
    0xa0: 0xc0,
    0xa1: 0xc2,
    0xa2: 0xc7,
    0xa3: 0xc8,
    0xa4: 0xca,
    0xa5: 0xcb,
    0xa6: 0xeb,
    0xa7: 0xce,
    0xa8: 0xcf,
    0xa9: 0xef,
    0xaa: 0xd4,
    0xab: 0xd9,
    0xac: 0xf9,
    0xad: 0xdb,
    0xae: 0xab,
    0xaf: 0xbb,
    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
    0xb0: 0xc3,
    0xb1: 0xe3,
    0xb2: 0xcd,
    0xb3: 0xcc,
    0xb4: 0xec,
    0xb5: 0xd2,
    0xb6: 0xf2,
    0xb7: 0xd5,
    0xb8: 0xf5,
    0xb9: 0x7b,
    0xba: 0x7d,
    0xbb: 0x5c,
    0xbc: 0x5e,
    0xbd: 0x5f,
    0xbe: 0x7c,
    0xbf: 0x223c,
    0xc0: 0xc4,
    0xc1: 0xe4,
    0xc2: 0xd6,
    0xc3: 0xf6,
    0xc4: 0xdf,
    0xc5: 0xa5,
    0xc6: 0xa4,
    0xc7: 0x2503,
    0xc8: 0xc5,
    0xc9: 0xe5,
    0xca: 0xd8,
    0xcb: 0xf8,
    0xcc: 0x250f,
    0xcd: 0x2513,
    0xce: 0x2517,
    0xcf: 0x251b // Box drawings heavy up and left
};
/**
 * Utils
 */
var getCharForByte = function (byte) {
    var charCode = byte;
    if (specialCea608CharsCodes.hasOwnProperty(byte)) {
        charCode = specialCea608CharsCodes[byte];
    }
    return String.fromCharCode(charCode);
};
var NR_ROWS = 15, NR_COLS = 100;
// Tables to look up row from PAC data
var rowsLowCh1 = { 0x11: 1, 0x12: 3, 0x15: 5, 0x16: 7, 0x17: 9, 0x10: 11, 0x13: 12, 0x14: 14 };
var rowsHighCh1 = { 0x11: 2, 0x12: 4, 0x15: 6, 0x16: 8, 0x17: 10, 0x13: 13, 0x14: 15 };
var rowsLowCh2 = { 0x19: 1, 0x1A: 3, 0x1D: 5, 0x1E: 7, 0x1F: 9, 0x18: 11, 0x1B: 12, 0x1C: 14 };
var rowsHighCh2 = { 0x19: 2, 0x1A: 4, 0x1D: 6, 0x1E: 8, 0x1F: 10, 0x1B: 13, 0x1C: 15 };
var backgroundColors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'black', 'transparent'];
/**
 * Simple logger class to be able to write with time-stamps and filter on level.
 */
var logger = {
    verboseFilter: { 'DATA': 3, 'DEBUG': 3, 'INFO': 2, 'WARNING': 2, 'TEXT': 1, 'ERROR': 0 },
    time: null,
    verboseLevel: 0,
    setTime: function (newTime) {
        this.time = newTime;
    },
    log: function (severity, msg) {
        var minLevel = this.verboseFilter[severity];
        if (this.verboseLevel >= minLevel) {
            // console.log(this.time + ' [' + severity + '] ' + msg);
        }
    }
};
var numArrayToHexArray = function (numArray) {
    var hexArray = [];
    for (var j = 0; j < numArray.length; j++) {
        hexArray.push(numArray[j].toString(16));
    }
    return hexArray;
};
var PenState = /** @class */ (function () {
    function PenState(foreground, underline, italics, background, flash) {
        this.foreground = foreground || 'white';
        this.underline = underline || false;
        this.italics = italics || false;
        this.background = background || 'black';
        this.flash = flash || false;
    }
    PenState.prototype.reset = function () {
        this.foreground = 'white';
        this.underline = false;
        this.italics = false;
        this.background = 'black';
        this.flash = false;
    };
    PenState.prototype.setStyles = function (styles) {
        var attribs = ['foreground', 'underline', 'italics', 'background', 'flash'];
        for (var i = 0; i < attribs.length; i++) {
            var style = attribs[i];
            if (styles.hasOwnProperty(style)) {
                this[style] = styles[style];
            }
        }
    };
    PenState.prototype.isDefault = function () {
        return (this.foreground === 'white' && !this.underline && !this.italics &&
            this.background === 'black' && !this.flash);
    };
    PenState.prototype.equals = function (other) {
        return ((this.foreground === other.foreground) &&
            (this.underline === other.underline) &&
            (this.italics === other.italics) &&
            (this.background === other.background) &&
            (this.flash === other.flash));
    };
    PenState.prototype.copy = function (newPenState) {
        this.foreground = newPenState.foreground;
        this.underline = newPenState.underline;
        this.italics = newPenState.italics;
        this.background = newPenState.background;
        this.flash = newPenState.flash;
    };
    PenState.prototype.toString = function () {
        return ('color=' + this.foreground + ', underline=' + this.underline + ', italics=' + this.italics +
            ', background=' + this.background + ', flash=' + this.flash);
    };
    return PenState;
}());
/**
 * Unicode character with styling and background.
 * @constructor
 */
var StyledUnicodeChar = /** @class */ (function () {
    function StyledUnicodeChar(uchar, foreground, underline, italics, background, flash) {
        this.uchar = uchar || ' '; // unicode character
        this.penState = new PenState(foreground, underline, italics, background, flash);
    }
    StyledUnicodeChar.prototype.reset = function () {
        this.uchar = ' ';
        this.penState.reset();
    };
    StyledUnicodeChar.prototype.setChar = function (uchar, newPenState) {
        this.uchar = uchar;
        this.penState.copy(newPenState);
    };
    StyledUnicodeChar.prototype.setPenState = function (newPenState) {
        this.penState.copy(newPenState);
    };
    StyledUnicodeChar.prototype.equals = function (other) {
        return this.uchar === other.uchar && this.penState.equals(other.penState);
    };
    StyledUnicodeChar.prototype.copy = function (newChar) {
        this.uchar = newChar.uchar;
        this.penState.copy(newChar.penState);
    };
    StyledUnicodeChar.prototype.isEmpty = function () {
        return this.uchar === ' ' && this.penState.isDefault();
    };
    return StyledUnicodeChar;
}());
/**
 * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
 * @constructor
 */
var Row = /** @class */ (function () {
    function Row() {
        this.chars = [];
        for (var i = 0; i < NR_COLS; i++) {
            this.chars.push(new StyledUnicodeChar());
        }
        this.pos = 0;
        this.currPenState = new PenState();
    }
    Row.prototype.equals = function (other) {
        var equal = true;
        for (var i = 0; i < NR_COLS; i++) {
            if (!this.chars[i].equals(other.chars[i])) {
                equal = false;
                break;
            }
        }
        return equal;
    };
    Row.prototype.copy = function (other) {
        for (var i = 0; i < NR_COLS; i++) {
            this.chars[i].copy(other.chars[i]);
        }
    };
    Row.prototype.isEmpty = function () {
        var empty = true;
        for (var i = 0; i < NR_COLS; i++) {
            if (!this.chars[i].isEmpty()) {
                empty = false;
                break;
            }
        }
        return empty;
    };
    /**
       *  Set the cursor to a valid column.
       */
    Row.prototype.setCursor = function (absPos) {
        if (this.pos !== absPos) {
            this.pos = absPos;
        }
        if (this.pos < 0) {
            logger.log('ERROR', 'Negative cursor position ' + this.pos);
            this.pos = 0;
        }
        else if (this.pos > NR_COLS) {
            logger.log('ERROR', 'Too large cursor position ' + this.pos);
            this.pos = NR_COLS;
        }
    };
    /**
       * Move the cursor relative to current position.
       */
    Row.prototype.moveCursor = function (relPos) {
        var newPos = this.pos + relPos;
        if (relPos > 1) {
            for (var i = this.pos + 1; i < newPos + 1; i++) {
                this.chars[i].setPenState(this.currPenState);
            }
        }
        this.setCursor(newPos);
    };
    /**
       * Backspace, move one step back and clear character.
       */
    Row.prototype.backSpace = function () {
        this.moveCursor(-1);
        this.chars[this.pos].setChar(' ', this.currPenState);
    };
    Row.prototype.insertChar = function (byte) {
        if (byte >= 0x90) { // Extended char
            this.backSpace();
        }
        var char = getCharForByte(byte);
        if (this.pos >= NR_COLS) {
            logger.log('ERROR', 'Cannot insert ' + byte.toString(16) +
                ' (' + char + ') at position ' + this.pos + '. Skipping it!');
            return;
        }
        this.chars[this.pos].setChar(char, this.currPenState);
        this.moveCursor(1);
    };
    Row.prototype.clearFromPos = function (startPos) {
        var i;
        for (i = startPos; i < NR_COLS; i++) {
            this.chars[i].reset();
        }
    };
    Row.prototype.clear = function () {
        this.clearFromPos(0);
        this.pos = 0;
        this.currPenState.reset();
    };
    Row.prototype.clearToEndOfRow = function () {
        this.clearFromPos(this.pos);
    };
    Row.prototype.getTextString = function () {
        var chars = [];
        var empty = true;
        for (var i = 0; i < NR_COLS; i++) {
            var char = this.chars[i].uchar;
            if (char !== ' ') {
                empty = false;
            }
            chars.push(char);
        }
        if (empty) {
            return '';
        }
        else {
            return chars.join('');
        }
    };
    Row.prototype.setPenStyles = function (styles) {
        this.currPenState.setStyles(styles);
        var currChar = this.chars[this.pos];
        currChar.setPenState(this.currPenState);
    };
    return Row;
}());
/**
 * Keep a CEA-608 screen of 32x15 styled characters
 * @constructor
*/
var CaptionScreen = /** @class */ (function () {
    function CaptionScreen() {
        this.rows = [];
        for (var i = 0; i < NR_ROWS; i++) {
            this.rows.push(new Row());
        } // Note that we use zero-based numbering (0-14)
        this.currRow = NR_ROWS - 1;
        this.nrRollUpRows = null;
        this.reset();
    }
    CaptionScreen.prototype.reset = function () {
        for (var i = 0; i < NR_ROWS; i++) {
            this.rows[i].clear();
        }
        this.currRow = NR_ROWS - 1;
    };
    CaptionScreen.prototype.equals = function (other) {
        var equal = true;
        for (var i = 0; i < NR_ROWS; i++) {
            if (!this.rows[i].equals(other.rows[i])) {
                equal = false;
                break;
            }
        }
        return equal;
    };
    CaptionScreen.prototype.copy = function (other) {
        for (var i = 0; i < NR_ROWS; i++) {
            this.rows[i].copy(other.rows[i]);
        }
    };
    CaptionScreen.prototype.isEmpty = function () {
        var empty = true;
        for (var i = 0; i < NR_ROWS; i++) {
            if (!this.rows[i].isEmpty()) {
                empty = false;
                break;
            }
        }
        return empty;
    };
    CaptionScreen.prototype.backSpace = function () {
        var row = this.rows[this.currRow];
        row.backSpace();
    };
    CaptionScreen.prototype.clearToEndOfRow = function () {
        var row = this.rows[this.currRow];
        row.clearToEndOfRow();
    };
    /**
       * Insert a character (without styling) in the current row.
       */
    CaptionScreen.prototype.insertChar = function (char) {
        var row = this.rows[this.currRow];
        row.insertChar(char);
    };
    CaptionScreen.prototype.setPen = function (styles) {
        var row = this.rows[this.currRow];
        row.setPenStyles(styles);
    };
    CaptionScreen.prototype.moveCursor = function (relPos) {
        var row = this.rows[this.currRow];
        row.moveCursor(relPos);
    };
    CaptionScreen.prototype.setCursor = function (absPos) {
        logger.log('INFO', 'setCursor: ' + absPos);
        var row = this.rows[this.currRow];
        row.setCursor(absPos);
    };
    CaptionScreen.prototype.setPAC = function (pacData) {
        logger.log('INFO', 'pacData = ' + JSON.stringify(pacData));
        var newRow = pacData.row - 1;
        if (this.nrRollUpRows && newRow < this.nrRollUpRows - 1) {
            newRow = this.nrRollUpRows - 1;
        }
        // Make sure this only affects Roll-up Captions by checking this.nrRollUpRows
        if (this.nrRollUpRows && this.currRow !== newRow) {
            // clear all rows first
            for (var i = 0; i < NR_ROWS; i++) {
                this.rows[i].clear();
            }
            // Copy this.nrRollUpRows rows from lastOutputScreen and place it in the newRow location
            // topRowIndex - the start of rows to copy (inclusive index)
            var topRowIndex = this.currRow + 1 - (this.nrRollUpRows);
            // We only copy if the last position was already shown.
            // We use the cueStartTime value to check this.
            var lastOutputScreen = this.lastOutputScreen;
            if (lastOutputScreen) {
                var prevLineTime = lastOutputScreen.rows[topRowIndex].cueStartTime;
                if (prevLineTime && prevLineTime < logger.time) {
                    for (var i = 0; i < this.nrRollUpRows; i++) {
                        this.rows[newRow - this.nrRollUpRows + i + 1].copy(lastOutputScreen.rows[topRowIndex + i]);
                    }
                }
            }
        }
        this.currRow = newRow;
        var row = this.rows[this.currRow];
        if (pacData.indent !== null) {
            var indent = pacData.indent;
            var prevPos = Math.max(indent - 1, 0);
            row.setCursor(pacData.indent);
            pacData.color = row.chars[prevPos].penState.foreground;
        }
        var styles = { foreground: pacData.color, underline: pacData.underline, italics: pacData.italics, background: 'black', flash: false };
        this.setPen(styles);
    };
    /**
       * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
       */
    CaptionScreen.prototype.setBkgData = function (bkgData) {
        logger.log('INFO', 'bkgData = ' + JSON.stringify(bkgData));
        this.backSpace();
        this.setPen(bkgData);
        this.insertChar(0x20); // Space
    };
    CaptionScreen.prototype.setRollUpRows = function (nrRows) {
        this.nrRollUpRows = nrRows;
    };
    CaptionScreen.prototype.rollUp = function () {
        if (this.nrRollUpRows === null) {
            logger.log('DEBUG', 'roll_up but nrRollUpRows not set yet');
            return; // Not properly setup
        }
        logger.log('TEXT', this.getDisplayText());
        var topRowIndex = this.currRow + 1 - this.nrRollUpRows;
        var topRow = this.rows.splice(topRowIndex, 1)[0];
        topRow.clear();
        this.rows.splice(this.currRow, 0, topRow);
        logger.log('INFO', 'Rolling up');
        // logger.log('TEXT', this.get_display_text())
    };
    /**
      * Get all non-empty rows with as unicode text.
      */
    CaptionScreen.prototype.getDisplayText = function (asOneRow) {
        asOneRow = asOneRow || false;
        var displayText = [];
        var text = '';
        var rowNr = -1;
        for (var i = 0; i < NR_ROWS; i++) {
            var rowText = this.rows[i].getTextString();
            if (rowText) {
                rowNr = i + 1;
                if (asOneRow) {
                    displayText.push('Row ' + rowNr + ': \'' + rowText + '\'');
                }
                else {
                    displayText.push(rowText.trim());
                }
            }
        }
        if (displayText.length > 0) {
            if (asOneRow) {
                text = '[' + displayText.join(' | ') + ']';
            }
            else {
                text = displayText.join('\n');
            }
        }
        return text;
    };
    CaptionScreen.prototype.getTextAndFormat = function () {
        return this.rows;
    };
    return CaptionScreen;
}());
// var modes = ['MODE_ROLL-UP', 'MODE_POP-ON', 'MODE_PAINT-ON', 'MODE_TEXT'];
var Cea608Channel = /** @class */ (function () {
    function Cea608Channel(channelNumber, outputFilter) {
        this.chNr = channelNumber;
        this.outputFilter = outputFilter;
        this.mode = null;
        this.verbose = 0;
        this.displayedMemory = new CaptionScreen();
        this.nonDisplayedMemory = new CaptionScreen();
        this.lastOutputScreen = new CaptionScreen();
        this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
        this.writeScreen = this.displayedMemory;
        this.mode = null;
        this.cueStartTime = null; // Keeps track of where a cue started.
    }
    Cea608Channel.prototype.reset = function () {
        this.mode = null;
        this.displayedMemory.reset();
        this.nonDisplayedMemory.reset();
        this.lastOutputScreen.reset();
        this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
        this.writeScreen = this.displayedMemory;
        this.mode = null;
        this.cueStartTime = null;
        this.lastCueEndTime = null;
    };
    Cea608Channel.prototype.getHandler = function () {
        return this.outputFilter;
    };
    Cea608Channel.prototype.setHandler = function (newHandler) {
        this.outputFilter = newHandler;
    };
    Cea608Channel.prototype.setPAC = function (pacData) {
        this.writeScreen.setPAC(pacData);
    };
    Cea608Channel.prototype.setBkgData = function (bkgData) {
        this.writeScreen.setBkgData(bkgData);
    };
    Cea608Channel.prototype.setMode = function (newMode) {
        if (newMode === this.mode) {
            return;
        }
        this.mode = newMode;
        logger.log('INFO', 'MODE=' + newMode);
        if (this.mode === 'MODE_POP-ON') {
            this.writeScreen = this.nonDisplayedMemory;
        }
        else {
            this.writeScreen = this.displayedMemory;
            this.writeScreen.reset();
        }
        if (this.mode !== 'MODE_ROLL-UP') {
            this.displayedMemory.nrRollUpRows = null;
            this.nonDisplayedMemory.nrRollUpRows = null;
        }
        this.mode = newMode;
    };
    Cea608Channel.prototype.insertChars = function (chars) {
        for (var i = 0; i < chars.length; i++) {
            this.writeScreen.insertChar(chars[i]);
        }
        var screen = this.writeScreen === this.displayedMemory ? 'DISP' : 'NON_DISP';
        logger.log('INFO', screen + ': ' + this.writeScreen.getDisplayText(true));
        if (this.mode === 'MODE_PAINT-ON' || this.mode === 'MODE_ROLL-UP') {
            logger.log('TEXT', 'DISPLAYED: ' + this.displayedMemory.getDisplayText(true));
            this.outputDataUpdate();
        }
    };
    Cea608Channel.prototype.ccRCL = function () {
        logger.log('INFO', 'RCL - Resume Caption Loading');
        this.setMode('MODE_POP-ON');
    };
    Cea608Channel.prototype.ccBS = function () {
        logger.log('INFO', 'BS - BackSpace');
        if (this.mode === 'MODE_TEXT') {
            return;
        }
        this.writeScreen.backSpace();
        if (this.writeScreen === this.displayedMemory) {
            this.outputDataUpdate();
        }
    };
    Cea608Channel.prototype.ccAOF = function () {
    };
    Cea608Channel.prototype.ccAON = function () {
    };
    Cea608Channel.prototype.ccDER = function () {
        logger.log('INFO', 'DER- Delete to End of Row');
        this.writeScreen.clearToEndOfRow();
        this.outputDataUpdate();
    };
    Cea608Channel.prototype.ccRU = function (nrRows) {
        logger.log('INFO', 'RU(' + nrRows + ') - Roll Up');
        this.writeScreen = this.displayedMemory;
        this.setMode('MODE_ROLL-UP');
        this.writeScreen.setRollUpRows(nrRows);
    };
    Cea608Channel.prototype.ccFON = function () {
        logger.log('INFO', 'FON - Flash On');
        this.writeScreen.setPen({ flash: true });
    };
    Cea608Channel.prototype.ccRDC = function () {
        logger.log('INFO', 'RDC - Resume Direct Captioning');
        this.setMode('MODE_PAINT-ON');
    };
    Cea608Channel.prototype.ccTR = function () {
        logger.log('INFO', 'TR');
        this.setMode('MODE_TEXT');
    };
    Cea608Channel.prototype.ccRTD = function () {
        logger.log('INFO', 'RTD');
        this.setMode('MODE_TEXT');
    };
    Cea608Channel.prototype.ccEDM = function () {
        logger.log('INFO', 'EDM - Erase Displayed Memory');
        this.displayedMemory.reset();
        this.outputDataUpdate(true);
    };
    Cea608Channel.prototype.ccCR = function () {
        logger.log('CR - Carriage Return');
        this.writeScreen.rollUp();
        this.outputDataUpdate(true);
    };
    Cea608Channel.prototype.ccENM = function () {
        logger.log('INFO', 'ENM - Erase Non-displayed Memory');
        this.nonDisplayedMemory.reset();
    };
    Cea608Channel.prototype.ccEOC = function () {
        logger.log('INFO', 'EOC - End Of Caption');
        if (this.mode === 'MODE_POP-ON') {
            var tmp = this.displayedMemory;
            this.displayedMemory = this.nonDisplayedMemory;
            this.nonDisplayedMemory = tmp;
            this.writeScreen = this.nonDisplayedMemory;
            logger.log('TEXT', 'DISP: ' + this.displayedMemory.getDisplayText());
        }
        this.outputDataUpdate(true);
    };
    Cea608Channel.prototype.ccTO = function (nrCols) {
        logger.log('INFO', 'TO(' + nrCols + ') - Tab Offset');
        this.writeScreen.moveCursor(nrCols);
    };
    Cea608Channel.prototype.ccMIDROW = function (secondByte) {
        var styles = { flash: false };
        styles.underline = secondByte % 2 === 1;
        styles.italics = secondByte >= 0x2e;
        if (!styles.italics) {
            var colorIndex = Math.floor(secondByte / 2) - 0x10;
            var colors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta'];
            styles.foreground = colors[colorIndex];
        }
        else {
            styles.foreground = 'white';
        }
        logger.log('INFO', 'MIDROW: ' + JSON.stringify(styles));
        this.writeScreen.setPen(styles);
    };
    Cea608Channel.prototype.outputDataUpdate = function (dispatch) {
        if (dispatch === void 0) { dispatch = false; }
        var t = logger.time;
        if (t === null) {
            return;
        }
        if (this.outputFilter) {
            if (this.cueStartTime === null && !this.displayedMemory.isEmpty()) { // Start of a new cue
                this.cueStartTime = t;
            }
            else {
                if (!this.displayedMemory.equals(this.lastOutputScreen)) {
                    if (this.outputFilter.newCue) {
                        this.outputFilter.newCue(this.cueStartTime, t, this.lastOutputScreen);
                        if (dispatch === true && this.outputFilter.dispatchCue) {
                            this.outputFilter.dispatchCue();
                        }
                    }
                    this.cueStartTime = this.displayedMemory.isEmpty() ? null : t;
                }
            }
            this.lastOutputScreen.copy(this.displayedMemory);
        }
    };
    Cea608Channel.prototype.cueSplitAtTime = function (t) {
        if (this.outputFilter) {
            if (!this.displayedMemory.isEmpty()) {
                if (this.outputFilter.newCue) {
                    this.outputFilter.newCue(this.cueStartTime, t, this.displayedMemory);
                }
                this.cueStartTime = t;
            }
        }
    };
    return Cea608Channel;
}());
var Cea608Parser = /** @class */ (function () {
    function Cea608Parser(field, out1, out2) {
        this.field = field || 1;
        this.outputs = [out1, out2];
        this.channels = [new Cea608Channel(1, out1), new Cea608Channel(2, out2)];
        this.currChNr = -1; // Will be 1 or 2
        this.lastCmdA = null; // First byte of last command
        this.lastCmdB = null; // Second byte of last command
        this.bufferedData = [];
        this.startTime = null;
        this.lastTime = null;
        this.dataCounters = { 'padding': 0, 'char': 0, 'cmd': 0, 'other': 0 };
    }
    Cea608Parser.prototype.getHandler = function (index) {
        return this.channels[index].getHandler();
    };
    Cea608Parser.prototype.setHandler = function (index, newHandler) {
        this.channels[index].setHandler(newHandler);
    };
    /**
       * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
       */
    Cea608Parser.prototype.addData = function (t, byteList) {
        var cmdFound, a, b, charsFound = false;
        this.lastTime = t;
        logger.setTime(t);
        for (var i = 0; i < byteList.length; i += 2) {
            a = byteList[i] & 0x7f;
            b = byteList[i + 1] & 0x7f;
            if (a === 0 && b === 0) {
                this.dataCounters.padding += 2;
                continue;
            }
            else {
                logger.log('DATA', '[' + numArrayToHexArray([byteList[i], byteList[i + 1]]) + '] -> (' + numArrayToHexArray([a, b]) + ')');
            }
            cmdFound = this.parseCmd(a, b);
            if (!cmdFound) {
                cmdFound = this.parseMidrow(a, b);
            }
            if (!cmdFound) {
                cmdFound = this.parsePAC(a, b);
            }
            if (!cmdFound) {
                cmdFound = this.parseBackgroundAttributes(a, b);
            }
            if (!cmdFound) {
                charsFound = this.parseChars(a, b);
                if (charsFound) {
                    if (this.currChNr && this.currChNr >= 0) {
                        var channel = this.channels[this.currChNr - 1];
                        channel.insertChars(charsFound);
                    }
                    else {
                        logger.log('WARNING', 'No channel found yet. TEXT-MODE?');
                    }
                }
            }
            if (cmdFound) {
                this.dataCounters.cmd += 2;
            }
            else if (charsFound) {
                this.dataCounters.char += 2;
            }
            else {
                this.dataCounters.other += 2;
                logger.log('WARNING', 'Couldn\'t parse cleaned data ' + numArrayToHexArray([a, b]) +
                    ' orig: ' + numArrayToHexArray([byteList[i], byteList[i + 1]]));
            }
        }
    };
    /**
       * Parse Command.
       * @returns {Boolean} Tells if a command was found
       */
    Cea608Parser.prototype.parseCmd = function (a, b) {
        var chNr = null;
        var cond1 = (a === 0x14 || a === 0x1C) && (b >= 0x20 && b <= 0x2F);
        var cond2 = (a === 0x17 || a === 0x1F) && (b >= 0x21 && b <= 0x23);
        if (!(cond1 || cond2)) {
            return false;
        }
        if (a === this.lastCmdA && b === this.lastCmdB) {
            this.lastCmdA = null;
            this.lastCmdB = null; // Repeated commands are dropped (once)
            logger.log('DEBUG', 'Repeated command (' + numArrayToHexArray([a, b]) + ') is dropped');
            return true;
        }
        if (a === 0x14 || a === 0x17) {
            chNr = 1;
        }
        else {
            chNr = 2;
        } // (a === 0x1C || a=== 0x1f)
        var channel = this.channels[chNr - 1];
        if (a === 0x14 || a === 0x1C) {
            if (b === 0x20) {
                channel.ccRCL();
            }
            else if (b === 0x21) {
                channel.ccBS();
            }
            else if (b === 0x22) {
                channel.ccAOF();
            }
            else if (b === 0x23) {
                channel.ccAON();
            }
            else if (b === 0x24) {
                channel.ccDER();
            }
            else if (b === 0x25) {
                channel.ccRU(2);
            }
            else if (b === 0x26) {
                channel.ccRU(3);
            }
            else if (b === 0x27) {
                channel.ccRU(4);
            }
            else if (b === 0x28) {
                channel.ccFON();
            }
            else if (b === 0x29) {
                channel.ccRDC();
            }
            else if (b === 0x2A) {
                channel.ccTR();
            }
            else if (b === 0x2B) {
                channel.ccRTD();
            }
            else if (b === 0x2C) {
                channel.ccEDM();
            }
            else if (b === 0x2D) {
                channel.ccCR();
            }
            else if (b === 0x2E) {
                channel.ccENM();
            }
            else if (b === 0x2F) {
                channel.ccEOC();
            }
        }
        else { // a == 0x17 || a == 0x1F
            channel.ccTO(b - 0x20);
        }
        this.lastCmdA = a;
        this.lastCmdB = b;
        this.currChNr = chNr;
        return true;
    };
    /**
       * Parse midrow styling command
       * @returns {Boolean}
       */
    Cea608Parser.prototype.parseMidrow = function (a, b) {
        var chNr = null;
        if (((a === 0x11) || (a === 0x19)) && b >= 0x20 && b <= 0x2f) {
            if (a === 0x11) {
                chNr = 1;
            }
            else {
                chNr = 2;
            }
            if (chNr !== this.currChNr) {
                logger.log('ERROR', 'Mismatch channel in midrow parsing');
                return false;
            }
            var channel = this.channels[chNr - 1];
            channel.ccMIDROW(b);
            logger.log('DEBUG', 'MIDROW (' + numArrayToHexArray([a, b]) + ')');
            return true;
        }
        return false;
    };
    /**
       * Parse Preable Access Codes (Table 53).
       * @returns {Boolean} Tells if PAC found
       */
    Cea608Parser.prototype.parsePAC = function (a, b) {
        var chNr = null;
        var row = null;
        var case1 = ((a >= 0x11 && a <= 0x17) || (a >= 0x19 && a <= 0x1F)) && (b >= 0x40 && b <= 0x7F);
        var case2 = (a === 0x10 || a === 0x18) && (b >= 0x40 && b <= 0x5F);
        if (!(case1 || case2)) {
            return false;
        }
        if (a === this.lastCmdA && b === this.lastCmdB) {
            this.lastCmdA = null;
            this.lastCmdB = null;
            return true; // Repeated commands are dropped (once)
        }
        chNr = (a <= 0x17) ? 1 : 2;
        if (b >= 0x40 && b <= 0x5F) {
            row = (chNr === 1) ? rowsLowCh1[a] : rowsLowCh2[a];
        }
        else { // 0x60 <= b <= 0x7F
            row = (chNr === 1) ? rowsHighCh1[a] : rowsHighCh2[a];
        }
        var pacData = this.interpretPAC(row, b);
        var channel = this.channels[chNr - 1];
        channel.setPAC(pacData);
        this.lastCmdA = a;
        this.lastCmdB = b;
        this.currChNr = chNr;
        return true;
    };
    /**
       * Interpret the second byte of the pac, and return the information.
       * @returns {Object} pacData with style parameters.
       */
    Cea608Parser.prototype.interpretPAC = function (row, byte) {
        var pacIndex = byte;
        var pacData = { color: null, italics: false, indent: null, underline: false, row: row };
        if (byte > 0x5F) {
            pacIndex = byte - 0x60;
        }
        else {
            pacIndex = byte - 0x40;
        }
        pacData.underline = (pacIndex & 1) === 1;
        if (pacIndex <= 0xd) {
            pacData.color = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'white'][Math.floor(pacIndex / 2)];
        }
        else if (pacIndex <= 0xf) {
            pacData.italics = true;
            pacData.color = 'white';
        }
        else {
            pacData.indent = (Math.floor((pacIndex - 0x10) / 2)) * 4;
        }
        return pacData; // Note that row has zero offset. The spec uses 1.
    };
    /**
       * Parse characters.
       * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
       */
    Cea608Parser.prototype.parseChars = function (a, b) {
        var channelNr = null, charCodes = null, charCode1 = null;
        if (a >= 0x19) {
            channelNr = 2;
            charCode1 = a - 8;
        }
        else {
            channelNr = 1;
            charCode1 = a;
        }
        if (charCode1 >= 0x11 && charCode1 <= 0x13) {
            // Special character
            var oneCode = b;
            if (charCode1 === 0x11) {
                oneCode = b + 0x50;
            }
            else if (charCode1 === 0x12) {
                oneCode = b + 0x70;
            }
            else {
                oneCode = b + 0x90;
            }
            logger.log('INFO', 'Special char \'' + getCharForByte(oneCode) + '\' in channel ' + channelNr);
            charCodes = [oneCode];
        }
        else if (a >= 0x20 && a <= 0x7f) {
            charCodes = (b === 0) ? [a] : [a, b];
        }
        if (charCodes) {
            var hexCodes = numArrayToHexArray(charCodes);
            logger.log('DEBUG', 'Char codes =  ' + hexCodes.join(','));
            this.lastCmdA = null;
            this.lastCmdB = null;
        }
        return charCodes;
    };
    /**
      * Parse extended background attributes as well as new foreground color black.
      * @returns{Boolean} Tells if background attributes are found
      */
    Cea608Parser.prototype.parseBackgroundAttributes = function (a, b) {
        var bkgData, index, chNr, channel;
        var case1 = (a === 0x10 || a === 0x18) && (b >= 0x20 && b <= 0x2f);
        var case2 = (a === 0x17 || a === 0x1f) && (b >= 0x2d && b <= 0x2f);
        if (!(case1 || case2)) {
            return false;
        }
        bkgData = {};
        if (a === 0x10 || a === 0x18) {
            index = Math.floor((b - 0x20) / 2);
            bkgData.background = backgroundColors[index];
            if (b % 2 === 1) {
                bkgData.background = bkgData.background + '_semi';
            }
        }
        else if (b === 0x2d) {
            bkgData.background = 'transparent';
        }
        else {
            bkgData.foreground = 'black';
            if (b === 0x2f) {
                bkgData.underline = true;
            }
        }
        chNr = (a < 0x18) ? 1 : 2;
        channel = this.channels[chNr - 1];
        channel.setBkgData(bkgData);
        this.lastCmdA = null;
        this.lastCmdB = null;
        return true;
    };
    /**
       * Reset state of parser and its channels.
       */
    Cea608Parser.prototype.reset = function () {
        for (var i = 0; i < this.channels.length; i++) {
            if (this.channels[i]) {
                this.channels[i].reset();
            }
        }
        this.lastCmdA = null;
        this.lastCmdB = null;
    };
    /**
       * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
       */
    Cea608Parser.prototype.cueSplitAtTime = function (t) {
        for (var i = 0; i < this.channels.length; i++) {
            if (this.channels[i]) {
                this.channels[i].cueSplitAtTime(t);
            }
        }
    };
    return Cea608Parser;
}());
exports.default = Cea608Parser;


/***/ }),

/***/ "./src/utils/codecs.js":
/*!*****************************!*\
  !*** ./src/utils/codecs.js ***!
  \*****************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// from http://mp4ra.org/codecs.html
var sampleEntryCodesISO = {
    audio: {
        'a3ds': true,
        'ac-3': true,
        'ac-4': true,
        'alac': true,
        'alaw': true,
        'dra1': true,
        'dts+': true,
        'dts-': true,
        'dtsc': true,
        'dtse': true,
        'dtsh': true,
        'ec-3': true,
        'enca': true,
        'g719': true,
        'g726': true,
        'm4ae': true,
        'mha1': true,
        'mha2': true,
        'mhm1': true,
        'mhm2': true,
        'mlpa': true,
        'mp4a': true,
        'raw ': true,
        'Opus': true,
        'samr': true,
        'sawb': true,
        'sawp': true,
        'sevc': true,
        'sqcp': true,
        'ssmv': true,
        'twos': true,
        'ulaw': true
    },
    video: {
        'avc1': true,
        'avc2': true,
        'avc3': true,
        'avc4': true,
        'avcp': true,
        'drac': true,
        'dvav': true,
        'dvhe': true,
        'encv': true,
        'hev1': true,
        'hvc1': true,
        'mjp2': true,
        'mp4v': true,
        'mvc1': true,
        'mvc2': true,
        'mvc3': true,
        'mvc4': true,
        'resv': true,
        'rv60': true,
        's263': true,
        'svc1': true,
        'svc2': true,
        'vc-1': true,
        'vp08': true,
        'vp09': true
    }
};
function isCodecType(codec, type) {
    var typeCodes = sampleEntryCodesISO[type];
    return !!typeCodes && typeCodes[codec.slice(0, 4)] === true;
}
exports.isCodecType = isCodecType;
function isCodecSupportedInMp4(codec, type) {
    return window.MediaSource.isTypeSupported((type || 'video') + "/mp4;codecs=\"" + codec + "\"");
}
exports.isCodecSupportedInMp4 = isCodecSupportedInMp4;


/***/ }),

/***/ "./src/utils/cues.js":
/*!***************************!*\
  !*** ./src/utils/cues.js ***!
  \***************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var vttparser_1 = __webpack_require__(/*! ./vttparser */ "./src/utils/vttparser.js");
function newCue(track, startTime, endTime, captionScreen) {
    var row;
    var cue;
    var indenting;
    var indent;
    var text;
    var VTTCue = window.VTTCue || window.TextTrackCue;
    for (var r = 0; r < captionScreen.rows.length; r++) {
        row = captionScreen.rows[r];
        indenting = true;
        indent = 0;
        text = '';
        if (!row.isEmpty()) {
            for (var c = 0; c < row.chars.length; c++) {
                if (row.chars[c].uchar.match(/\s/) && indenting) {
                    indent++;
                }
                else {
                    text += row.chars[c].uchar;
                    indenting = false;
                }
            }
            // To be used for cleaning-up orphaned roll-up captions
            row.cueStartTime = startTime;
            // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
            if (startTime === endTime) {
                endTime += 0.0001;
            }
            cue = new VTTCue(startTime, endTime, vttparser_1.fixLineBreaks(text.trim()));
            if (indent >= 16) {
                indent--;
            }
            else {
                indent++;
            }
            // VTTCue.line get's flakey when using controls, so let's now include line 13&14
            // also, drop line 1 since it's to close to the top
            if (navigator.userAgent.match(/Firefox\//)) {
                cue.line = r + 1;
            }
            else {
                cue.line = (r > 7 ? r - 2 : r + 1);
            }
            cue.align = 'left';
            // Clamp the position between 0 and 100 - if out of these bounds, Firefox throws an exception and captions break
            cue.position = Math.max(0, Math.min(100, 100 * (indent / 32) + (navigator.userAgent.match(/Firefox\//) ? 50 : 0)));
            track.addCue(cue);
        }
    }
}
exports.newCue = newCue;


/***/ }),

/***/ "./src/utils/discontinuities.js":
/*!**************************************!*\
  !*** ./src/utils/discontinuities.js ***!
  \**************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
Object.defineProperty(exports, "__esModule", { value: true });
var binary_search_1 = __webpack_require__(/*! ./binary-search */ "./src/utils/binary-search.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
function findFirstFragWithCC(fragments, cc) {
    var firstFrag = null;
    for (var i = 0; i < fragments.length; i += 1) {
        var currentFrag = fragments[i];
        if (currentFrag && currentFrag.cc === cc) {
            firstFrag = currentFrag;
            break;
        }
    }
    return firstFrag;
}
exports.findFirstFragWithCC = findFirstFragWithCC;
function findFragWithCC(fragments, CC) {
    return binary_search_1.default.search(fragments, function (candidate) {
        if (candidate.cc < CC) {
            return 1;
        }
        else if (candidate.cc > CC) {
            return -1;
        }
        else {
            return 0;
        }
    });
}
exports.findFragWithCC = findFragWithCC;
function shouldAlignOnDiscontinuities(lastFrag, lastLevel, details) {
    var shouldAlign = false;
    if (lastLevel && lastLevel.details && details) {
        if (details.endCC > details.startCC || (lastFrag && lastFrag.cc < details.startCC)) {
            shouldAlign = true;
        }
    }
    return shouldAlign;
}
exports.shouldAlignOnDiscontinuities = shouldAlignOnDiscontinuities;
// Find the first frag in the previous level which matches the CC of the first frag of the new level
function findDiscontinuousReferenceFrag(prevDetails, curDetails) {
    var prevFrags = prevDetails.fragments;
    var curFrags = curDetails.fragments;
    if (!curFrags.length || !prevFrags.length) {
        logger_1.logger.log('No fragments to align');
        return;
    }
    var prevStartFrag = findFirstFragWithCC(prevFrags, curFrags[0].cc);
    if (!prevStartFrag || (prevStartFrag && !prevStartFrag.startPTS)) {
        logger_1.logger.log('No frag in previous level to align on');
        return;
    }
    return prevStartFrag;
}
exports.findDiscontinuousReferenceFrag = findDiscontinuousReferenceFrag;
function adjustPts(sliding, details) {
    details.fragments.forEach(function (frag) {
        if (frag) {
            var start = frag.start + sliding;
            frag.start = frag.startPTS = start;
            frag.endPTS = start + frag.duration;
        }
    });
    details.PTSKnown = true;
}
exports.adjustPts = adjustPts;
/**
 * Using the parameters of the last level, this function computes PTS' of the new fragments so that they form a
 * contiguous stream with the last fragments.
 * The PTS of a fragment lets Hls.js know where it fits into a stream - by knowing every PTS, we know which fragment to
 * download at any given time. PTS is normally computed when the fragment is demuxed, so taking this step saves us time
 * and an extra download.
 * @param lastFrag
 * @param lastLevel
 * @param details
 */
function alignStream(lastFrag, lastLevel, details) {
    alignDiscontinuities(lastFrag, details, lastLevel);
    if (!details.PTSKnown && lastLevel) {
        // If the PTS wasn't figured out via discontinuity sequence that means there was no CC increase within the level.
        // Aligning via Program Date Time should therefore be reliable, since PDT should be the same within the same
        // discontinuity sequence.
        alignPDT(details, lastLevel.details);
    }
}
exports.alignStream = alignStream;
/**
 * Computes the PTS if a new level's fragments using the PTS of a fragment in the last level which shares the same
 * discontinuity sequence.
 * @param lastLevel - The details of the last loaded level
 * @param details - The details of the new level
 */
function alignDiscontinuities(lastFrag, details, lastLevel) {
    if (shouldAlignOnDiscontinuities(lastFrag, lastLevel, details)) {
        var referenceFrag = findDiscontinuousReferenceFrag(lastLevel.details, details);
        if (referenceFrag) {
            logger_1.logger.log('Adjusting PTS using last level due to CC increase within current level');
            adjustPts(referenceFrag.start, details);
        }
    }
}
exports.alignDiscontinuities = alignDiscontinuities;
/**
 * Computes the PTS of a new level's fragments using the difference in Program Date Time from the last level.
 * @param details - The details of the new level
 * @param lastDetails - The details of the last loaded level
 */
function alignPDT(details, lastDetails) {
    if (lastDetails && lastDetails.fragments.length) {
        if (!details.hasProgramDateTime || !lastDetails.hasProgramDateTime) {
            return;
        }
        // if last level sliding is 1000 and its first frag PROGRAM-DATE-TIME is 2017-08-20 1:10:00 AM
        // and if new details first frag PROGRAM DATE-TIME is 2017-08-20 1:10:08 AM
        // then we can deduce that playlist B sliding is 1000+8 = 1008s
        var lastPDT = lastDetails.fragments[0].programDateTime;
        var newPDT = details.fragments[0].programDateTime;
        // date diff is in ms. frag.start is in seconds
        var sliding = (newPDT - lastPDT) / 1000 + lastDetails.fragments[0].start;
        if (Number.isFinite(sliding)) {
            logger_1.logger.log("adjusting PTS using programDateTime delta, sliding:" + sliding.toFixed(3));
            adjustPts(sliding, details);
        }
    }
}
exports.alignPDT = alignPDT;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/utils/ewma-bandwidth-estimator.js":
/*!***********************************************!*\
  !*** ./src/utils/ewma-bandwidth-estimator.js ***!
  \***********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * EWMA Bandwidth Estimator
 *  - heavily inspired from shaka-player
 * Tracks bandwidth samples and estimates available bandwidth.
 * Based on the minimum of two exponentially-weighted moving averages with
 * different half-lives.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ewma_1 = __webpack_require__(/*! ../utils/ewma */ "./src/utils/ewma.js");
var EwmaBandWidthEstimator = /** @class */ (function () {
    function EwmaBandWidthEstimator(hls, slow, fast, defaultEstimate) {
        this.hls = hls;
        this.defaultEstimate_ = defaultEstimate;
        this.minWeight_ = 0.001;
        this.minDelayMs_ = 50;
        this.slow_ = new ewma_1.default(slow);
        this.fast_ = new ewma_1.default(fast);
    }
    EwmaBandWidthEstimator.prototype.sample = function (durationMs, numBytes) {
        durationMs = Math.max(durationMs, this.minDelayMs_);
        var bandwidth = 8000 * numBytes / durationMs, 
        // console.log('instant bw:'+ Math.round(bandwidth));
        // we weight sample using loading duration....
        weight = durationMs / 1000;
        this.fast_.sample(weight, bandwidth);
        this.slow_.sample(weight, bandwidth);
    };
    EwmaBandWidthEstimator.prototype.canEstimate = function () {
        var fast = this.fast_;
        return (fast && fast.getTotalWeight() >= this.minWeight_);
    };
    EwmaBandWidthEstimator.prototype.getEstimate = function () {
        if (this.canEstimate()) {
            // console.log('slow estimate:'+ Math.round(this.slow_.getEstimate()));
            // console.log('fast estimate:'+ Math.round(this.fast_.getEstimate()));
            // Take the minimum of these two estimates.  This should have the effect of
            // adapting down quickly, but up more slowly.
            return Math.min(this.fast_.getEstimate(), this.slow_.getEstimate());
        }
        else {
            return this.defaultEstimate_;
        }
    };
    EwmaBandWidthEstimator.prototype.destroy = function () {
    };
    return EwmaBandWidthEstimator;
}());
exports.default = EwmaBandWidthEstimator;


/***/ }),

/***/ "./src/utils/ewma.js":
/*!***************************!*\
  !*** ./src/utils/ewma.js ***!
  \***************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * compute an Exponential Weighted moving average
 * - https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
 *  - heavily inspired from shaka-player
 */
Object.defineProperty(exports, "__esModule", { value: true });
var EWMA = /** @class */ (function () {
    //  About half of the estimated value will be from the last |halfLife| samples by weight.
    function EWMA(halfLife) {
        // Larger values of alpha expire historical data more slowly.
        this.alpha_ = halfLife ? Math.exp(Math.log(0.5) / halfLife) : 0;
        this.estimate_ = 0;
        this.totalWeight_ = 0;
    }
    EWMA.prototype.sample = function (weight, value) {
        var adjAlpha = Math.pow(this.alpha_, weight);
        this.estimate_ = value * (1 - adjAlpha) + adjAlpha * this.estimate_;
        this.totalWeight_ += weight;
    };
    EWMA.prototype.getTotalWeight = function () {
        return this.totalWeight_;
    };
    EWMA.prototype.getEstimate = function () {
        if (this.alpha_) {
            var zeroFactor = 1 - Math.pow(this.alpha_, this.totalWeight_);
            return this.estimate_ / zeroFactor;
        }
        else {
            return this.estimate_;
        }
    };
    return EWMA;
}());
exports.default = EWMA;


/***/ }),

/***/ "./src/utils/get-self-scope.js":
/*!*************************************!*\
  !*** ./src/utils/get-self-scope.js ***!
  \*************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getSelfScope() {
    // see https://stackoverflow.com/a/11237259/589493
    if (typeof window === 'undefined') {
        /* eslint-disable-next-line no-undef */
        return self;
    }
    else {
        return window;
    }
}
exports.getSelfScope = getSelfScope;


/***/ }),

/***/ "./src/utils/logger.js":
/*!*****************************!*\
  !*** ./src/utils/logger.js ***!
  \*****************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var get_self_scope_1 = __webpack_require__(/*! ./get-self-scope */ "./src/utils/get-self-scope.js");
function noop() { }
var fakeLogger = {
    trace: noop,
    debug: noop,
    log: noop,
    warn: noop,
    info: noop,
    error: noop
};
var exportedLogger = fakeLogger;
// let lastCallTime;
// function formatMsgWithTimeInfo(type, msg) {
//   const now = Date.now();
//   const diff = lastCallTime ? '+' + (now - lastCallTime) : '0';
//   lastCallTime = now;
//   msg = (new Date(now)).toISOString() + ' | [' +  type + '] > ' + msg + ' ( ' + diff + ' ms )';
//   return msg;
// }
function formatMsg(type, msg) {
    msg = '[' + type + '] > ' + msg;
    return msg;
}
var global = get_self_scope_1.getSelfScope();
function consolePrintFn(type) {
    var func = global.console[type];
    if (func) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (args[0]) {
                args[0] = formatMsg(type, args[0]);
            }
            func.apply(global.console, args);
        };
    }
    return noop;
}
function exportLoggerFunctions(debugConfig) {
    var functions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        functions[_i - 1] = arguments[_i];
    }
    functions.forEach(function (type) {
        exportedLogger[type] = debugConfig[type] ? debugConfig[type].bind(debugConfig) : consolePrintFn(type);
    });
}
exports.enableLogs = function (debugConfig) {
    if (debugConfig === true || typeof debugConfig === 'object') {
        exportLoggerFunctions(debugConfig, 
        // Remove out from list here to hard-disable a log-level
        // 'trace',
        'debug', 'log', 'info', 'warn', 'error');
        // Some browsers don't allow to use bind on console object anyway
        // fallback to default if needed
        try {
            exportedLogger.log();
        }
        catch (e) {
            exportedLogger = fakeLogger;
        }
    }
    else {
        exportedLogger = fakeLogger;
    }
};
exports.logger = exportedLogger;


/***/ }),

/***/ "./src/utils/mediakeys-helper.js":
/*!***************************************!*\
  !*** ./src/utils/mediakeys-helper.js ***!
  \***************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var requestMediaKeySystemAccess = (function () {
    if (typeof window !== 'undefined' && window.navigator && window.navigator.requestMediaKeySystemAccess) {
        return window.navigator.requestMediaKeySystemAccess.bind(window.navigator);
    }
    else {
        return null;
    }
})();
exports.requestMediaKeySystemAccess = requestMediaKeySystemAccess;


/***/ }),

/***/ "./src/utils/mediasource-helper.js":
/*!*****************************************!*\
  !*** ./src/utils/mediasource-helper.js ***!
  \*****************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * MediaSource helper
 */
Object.defineProperty(exports, "__esModule", { value: true });
function getMediaSource() {
    if (typeof window !== 'undefined') {
        return window.MediaSource || window.WebKitMediaSource;
    }
}
exports.getMediaSource = getMediaSource;


/***/ }),

/***/ "./src/utils/output-filter.js":
/*!************************************!*\
  !*** ./src/utils/output-filter.js ***!
  \************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OutputFilter = /** @class */ (function () {
    function OutputFilter(timelineController, trackName) {
        this.timelineController = timelineController;
        this.trackName = trackName;
        this.startTime = null;
        this.endTime = null;
        this.screen = null;
    }
    OutputFilter.prototype.dispatchCue = function () {
        if (this.startTime === null) {
            return;
        }
        this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen);
        this.startTime = null;
    };
    OutputFilter.prototype.newCue = function (startTime, endTime, screen) {
        if (this.startTime === null || this.startTime > startTime) {
            this.startTime = startTime;
        }
        this.endTime = endTime;
        this.screen = screen;
        this.timelineController.createCaptionsTrack(this.trackName);
    };
    return OutputFilter;
}());
exports.default = OutputFilter;


/***/ }),

/***/ "./src/utils/texttrack-utils.js":
/*!**************************************!*\
  !*** ./src/utils/texttrack-utils.js ***!
  \**************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function sendAddTrackEvent(track, videoEl) {
    var event = null;
    try {
        event = new window.Event('addtrack');
    }
    catch (err) {
        // for IE11
        event = document.createEvent('Event');
        event.initEvent('addtrack', false, false);
    }
    event.track = track;
    videoEl.dispatchEvent(event);
}
exports.sendAddTrackEvent = sendAddTrackEvent;
function clearCurrentCues(track) {
    if (track && track.cues) {
        while (track.cues.length > 0) {
            track.removeCue(track.cues[0]);
        }
    }
}
exports.clearCurrentCues = clearCurrentCues;


/***/ }),

/***/ "./src/utils/time-ranges.js":
/*!**********************************!*\
  !*** ./src/utils/time-ranges.js ***!
  \**********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 *  TimeRanges to string helper
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TimeRanges = {
    toString: function (r) {
        var log = '', len = r.length;
        for (var i = 0; i < len; i++) {
            log += '[' + r.start(i).toFixed(3) + ',' + r.end(i).toFixed(3) + ']';
        }
        return log;
    }
};
exports.default = TimeRanges;


/***/ }),

/***/ "./src/utils/vttcue.js":
/*!*****************************!*\
  !*** ./src/utils/vttcue.js ***!
  \*****************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () {
    if (typeof window !== 'undefined' && window.VTTCue) {
        return window.VTTCue;
    }
    var autoKeyword = 'auto';
    var directionSetting = {
        '': true,
        lr: true,
        rl: true
    };
    var alignSetting = {
        start: true,
        middle: true,
        end: true,
        left: true,
        right: true
    };
    function findDirectionSetting(value) {
        if (typeof value !== 'string') {
            return false;
        }
        var dir = directionSetting[value.toLowerCase()];
        return dir ? value.toLowerCase() : false;
    }
    function findAlignSetting(value) {
        if (typeof value !== 'string') {
            return false;
        }
        var align = alignSetting[value.toLowerCase()];
        return align ? value.toLowerCase() : false;
    }
    function extend(obj) {
        var i = 1;
        for (; i < arguments.length; i++) {
            var cobj = arguments[i];
            for (var p in cobj) {
                obj[p] = cobj[p];
            }
        }
        return obj;
    }
    function VTTCue(startTime, endTime, text) {
        var cue = this;
        var isIE8 = (function () {
            if (typeof navigator === 'undefined') {
                return;
            }
            return (/MSIE\s8\.0/).test(navigator.userAgent);
        })();
        var baseObj = {};
        if (isIE8) {
            cue = document.createElement('custom');
        }
        else {
            baseObj.enumerable = true;
        }
        /**
         * Shim implementation specific properties. These properties are not in
         * the spec.
         */
        // Lets us know when the VTTCue's data has changed in such a way that we need
        // to recompute its display state. This lets us compute its display state
        // lazily.
        cue.hasBeenReset = false;
        /**
         * VTTCue and TextTrackCue properties
         * http://dev.w3.org/html5/webvtt/#vttcue-interface
         */
        var _id = '';
        var _pauseOnExit = false;
        var _startTime = startTime;
        var _endTime = endTime;
        var _text = text;
        var _region = null;
        var _vertical = '';
        var _snapToLines = true;
        var _line = 'auto';
        var _lineAlign = 'start';
        var _position = 50;
        var _positionAlign = 'middle';
        var _size = 50;
        var _align = 'middle';
        Object.defineProperty(cue, 'id', extend({}, baseObj, {
            get: function () {
                return _id;
            },
            set: function (value) {
                _id = '' + value;
            }
        }));
        Object.defineProperty(cue, 'pauseOnExit', extend({}, baseObj, {
            get: function () {
                return _pauseOnExit;
            },
            set: function (value) {
                _pauseOnExit = !!value;
            }
        }));
        Object.defineProperty(cue, 'startTime', extend({}, baseObj, {
            get: function () {
                return _startTime;
            },
            set: function (value) {
                if (typeof value !== 'number') {
                    throw new TypeError('Start time must be set to a number.');
                }
                _startTime = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'endTime', extend({}, baseObj, {
            get: function () {
                return _endTime;
            },
            set: function (value) {
                if (typeof value !== 'number') {
                    throw new TypeError('End time must be set to a number.');
                }
                _endTime = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'text', extend({}, baseObj, {
            get: function () {
                return _text;
            },
            set: function (value) {
                _text = '' + value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'region', extend({}, baseObj, {
            get: function () {
                return _region;
            },
            set: function (value) {
                _region = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'vertical', extend({}, baseObj, {
            get: function () {
                return _vertical;
            },
            set: function (value) {
                var setting = findDirectionSetting(value);
                // Have to check for false because the setting an be an empty string.
                if (setting === false) {
                    throw new SyntaxError('An invalid or illegal string was specified.');
                }
                _vertical = setting;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'snapToLines', extend({}, baseObj, {
            get: function () {
                return _snapToLines;
            },
            set: function (value) {
                _snapToLines = !!value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'line', extend({}, baseObj, {
            get: function () {
                return _line;
            },
            set: function (value) {
                if (typeof value !== 'number' && value !== autoKeyword) {
                    throw new SyntaxError('An invalid number or illegal string was specified.');
                }
                _line = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'lineAlign', extend({}, baseObj, {
            get: function () {
                return _lineAlign;
            },
            set: function (value) {
                var setting = findAlignSetting(value);
                if (!setting) {
                    throw new SyntaxError('An invalid or illegal string was specified.');
                }
                _lineAlign = setting;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'position', extend({}, baseObj, {
            get: function () {
                return _position;
            },
            set: function (value) {
                if (value < 0 || value > 100) {
                    throw new Error('Position must be between 0 and 100.');
                }
                _position = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'positionAlign', extend({}, baseObj, {
            get: function () {
                return _positionAlign;
            },
            set: function (value) {
                var setting = findAlignSetting(value);
                if (!setting) {
                    throw new SyntaxError('An invalid or illegal string was specified.');
                }
                _positionAlign = setting;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'size', extend({}, baseObj, {
            get: function () {
                return _size;
            },
            set: function (value) {
                if (value < 0 || value > 100) {
                    throw new Error('Size must be between 0 and 100.');
                }
                _size = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'align', extend({}, baseObj, {
            get: function () {
                return _align;
            },
            set: function (value) {
                var setting = findAlignSetting(value);
                if (!setting) {
                    throw new SyntaxError('An invalid or illegal string was specified.');
                }
                _align = setting;
                this.hasBeenReset = true;
            }
        }));
        /**
         * Other <track> spec defined properties
         */
        // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
        cue.displayState = undefined;
        if (isIE8) {
            return cue;
        }
    }
    /**
     * VTTCue methods
     */
    VTTCue.prototype.getCueAsHTML = function () {
        // Assume WebVTT.convertCueToDOMTree is on the global.
        var WebVTT = window.WebVTT;
        return WebVTT.convertCueToDOMTree(window, this.text);
    };
    return VTTCue;
})();


/***/ }),

/***/ "./src/utils/vttparser.js":
/*!********************************!*\
  !*** ./src/utils/vttparser.js ***!
  \********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Source: https://github.com/mozilla/vtt.js/blob/master/dist/vtt.js#L1716
 */
Object.defineProperty(exports, "__esModule", { value: true });
var vttcue_1 = __webpack_require__(/*! ./vttcue */ "./src/utils/vttcue.js");
var StringDecoder = function StringDecoder() {
    return {
        decode: function (data) {
            if (!data) {
                return '';
            }
            if (typeof data !== 'string') {
                throw new Error('Error - expected string data.');
            }
            return decodeURIComponent(encodeURIComponent(data));
        }
    };
};
function VTTParser() {
    this.window = window;
    this.state = 'INITIAL';
    this.buffer = '';
    this.decoder = new StringDecoder();
    this.regionList = [];
}
// Try to parse input as a time stamp.
function parseTimeStamp(input) {
    function computeSeconds(h, m, s, f) {
        return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1000;
    }
    var m = input.match(/^(\d+):(\d{2})(:\d{2})?\.(\d{3})/);
    if (!m) {
        return null;
    }
    if (m[3]) {
        // Timestamp takes the form of [hours]:[minutes]:[seconds].[milliseconds]
        return computeSeconds(m[1], m[2], m[3].replace(':', ''), m[4]);
    }
    else if (m[1] > 59) {
        // Timestamp takes the form of [hours]:[minutes].[milliseconds]
        // First position is hours as it's over 59.
        return computeSeconds(m[1], m[2], 0, m[4]);
    }
    else {
        // Timestamp takes the form of [minutes]:[seconds].[milliseconds]
        return computeSeconds(0, m[1], m[2], m[4]);
    }
}
// A settings object holds key/value pairs and will ignore anything but the first
// assignment to a specific key.
function Settings() {
    this.values = Object.create(null);
}
Settings.prototype = {
    // Only accept the first assignment to any key.
    set: function (k, v) {
        if (!this.get(k) && v !== '') {
            this.values[k] = v;
        }
    },
    // Return the value for a key, or a default value.
    // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
    // a number of possible default values as properties where 'defaultKey' is
    // the key of the property that will be chosen; otherwise it's assumed to be
    // a single value.
    get: function (k, dflt, defaultKey) {
        if (defaultKey) {
            return this.has(k) ? this.values[k] : dflt[defaultKey];
        }
        return this.has(k) ? this.values[k] : dflt;
    },
    // Check whether we have a value for a key.
    has: function (k) {
        return k in this.values;
    },
    // Accept a setting if its one of the given alternatives.
    alt: function (k, v, a) {
        for (var n = 0; n < a.length; ++n) {
            if (v === a[n]) {
                this.set(k, v);
                break;
            }
        }
    },
    // Accept a setting if its a valid (signed) integer.
    integer: function (k, v) {
        if (/^-?\d+$/.test(v)) { // integer
            this.set(k, parseInt(v, 10));
        }
    },
    // Accept a setting if its a valid percentage.
    percent: function (k, v) {
        var m;
        if ((m = v.match(/^([\d]{1,3})(\.[\d]*)?%$/))) {
            v = parseFloat(v);
            if (v >= 0 && v <= 100) {
                this.set(k, v);
                return true;
            }
        }
        return false;
    }
};
// Helper function to parse input into groups separated by 'groupDelim', and
// interprete each group as a key/value pair separated by 'keyValueDelim'.
function parseOptions(input, callback, keyValueDelim, groupDelim) {
    var groups = groupDelim ? input.split(groupDelim) : [input];
    for (var i in groups) {
        if (typeof groups[i] !== 'string') {
            continue;
        }
        var kv = groups[i].split(keyValueDelim);
        if (kv.length !== 2) {
            continue;
        }
        var k = kv[0];
        var v = kv[1];
        callback(k, v);
    }
}
var defaults = new vttcue_1.default(0, 0, 0);
// 'middle' was changed to 'center' in the spec: https://github.com/w3c/webvtt/pull/244
//  Safari doesn't yet support this change, but FF and Chrome do.
var center = defaults.align === 'middle' ? 'middle' : 'center';
function parseCue(input, cue, regionList) {
    // Remember the original input if we need to throw an error.
    var oInput = input;
    // 4.1 WebVTT timestamp
    function consumeTimeStamp() {
        var ts = parseTimeStamp(input);
        if (ts === null) {
            throw new Error('Malformed timestamp: ' + oInput);
        }
        // Remove time stamp from input.
        input = input.replace(/^[^\sa-zA-Z-]+/, '');
        return ts;
    }
    // 4.4.2 WebVTT cue settings
    function consumeCueSettings(input, cue) {
        var settings = new Settings();
        parseOptions(input, function (k, v) {
            switch (k) {
                case 'region':
                    // Find the last region we parsed with the same region id.
                    for (var i = regionList.length - 1; i >= 0; i--) {
                        if (regionList[i].id === v) {
                            settings.set(k, regionList[i].region);
                            break;
                        }
                    }
                    break;
                case 'vertical':
                    settings.alt(k, v, ['rl', 'lr']);
                    break;
                case 'line':
                    var vals = v.split(','), vals0 = vals[0];
                    settings.integer(k, vals0);
                    if (settings.percent(k, vals0)) {
                        settings.set('snapToLines', false);
                    }
                    settings.alt(k, vals0, ['auto']);
                    if (vals.length === 2) {
                        settings.alt('lineAlign', vals[1], ['start', center, 'end']);
                    }
                    break;
                case 'position':
                    vals = v.split(',');
                    settings.percent(k, vals[0]);
                    if (vals.length === 2) {
                        settings.alt('positionAlign', vals[1], ['start', center, 'end', 'line-left', 'line-right', 'auto']);
                    }
                    break;
                case 'size':
                    settings.percent(k, v);
                    break;
                case 'align':
                    settings.alt(k, v, ['start', center, 'end', 'left', 'right']);
                    break;
            }
        }, /:/, /\s/);
        // Apply default values for any missing fields.
        cue.region = settings.get('region', null);
        cue.vertical = settings.get('vertical', '');
        var line = settings.get('line', 'auto');
        if (line === 'auto' && defaults.line === -1) {
            // set numeric line number for Safari
            line = -1;
        }
        cue.line = line;
        cue.lineAlign = settings.get('lineAlign', 'start');
        cue.snapToLines = settings.get('snapToLines', true);
        cue.size = settings.get('size', 100);
        cue.align = settings.get('align', center);
        var position = settings.get('position', 'auto');
        if (position === 'auto' && defaults.position === 50) {
            // set numeric position for Safari
            position = cue.align === 'start' || cue.align === 'left' ? 0 : cue.align === 'end' || cue.align === 'right' ? 100 : 50;
        }
        cue.position = position;
    }
    function skipWhitespace() {
        input = input.replace(/^\s+/, '');
    }
    // 4.1 WebVTT cue timings.
    skipWhitespace();
    cue.startTime = consumeTimeStamp(); // (1) collect cue start time
    skipWhitespace();
    if (input.substr(0, 3) !== '-->') { // (3) next characters must match '-->'
        throw new Error('Malformed time stamp (time stamps must be separated by \'-->\'): ' +
            oInput);
    }
    input = input.substr(3);
    skipWhitespace();
    cue.endTime = consumeTimeStamp(); // (5) collect cue end time
    // 4.1 WebVTT cue settings list.
    skipWhitespace();
    consumeCueSettings(input, cue);
}
function fixLineBreaks(input) {
    return input.replace(/<br(?: \/)?>/gi, '\n');
}
exports.fixLineBreaks = fixLineBreaks;
VTTParser.prototype = {
    parse: function (data) {
        var self = this;
        // If there is no data then we won't decode it, but will just try to parse
        // whatever is in buffer already. This may occur in circumstances, for
        // example when flush() is called.
        if (data) {
            // Try to decode the data that we received.
            self.buffer += self.decoder.decode(data, { stream: true });
        }
        function collectNextLine() {
            var buffer = self.buffer;
            var pos = 0;
            buffer = fixLineBreaks(buffer);
            while (pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n') {
                ++pos;
            }
            var line = buffer.substr(0, pos);
            // Advance the buffer early in case we fail below.
            if (buffer[pos] === '\r') {
                ++pos;
            }
            if (buffer[pos] === '\n') {
                ++pos;
            }
            self.buffer = buffer.substr(pos);
            return line;
        }
        // 3.2 WebVTT metadata header syntax
        function parseHeader(input) {
            parseOptions(input, function (k, v) {
                switch (k) {
                    case 'Region':
                        // 3.3 WebVTT region metadata header syntax
                        // console.log('parse region', v);
                        // parseRegion(v);
                        break;
                }
            }, /:/);
        }
        // 5.1 WebVTT file parsing.
        try {
            var line = void 0;
            if (self.state === 'INITIAL') {
                // We can't start parsing until we have the first line.
                if (!/\r\n|\n/.test(self.buffer)) {
                    return this;
                }
                line = collectNextLine();
                // strip of UTF-8 BOM if any
                // https://en.wikipedia.org/wiki/Byte_order_mark#UTF-8
                var m = line.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
                if (!m || !m[0]) {
                    throw new Error('Malformed WebVTT signature.');
                }
                self.state = 'HEADER';
            }
            var alreadyCollectedLine = false;
            while (self.buffer) {
                // We can't parse a line until we have the full line.
                if (!/\r\n|\n/.test(self.buffer)) {
                    return this;
                }
                if (!alreadyCollectedLine) {
                    line = collectNextLine();
                }
                else {
                    alreadyCollectedLine = false;
                }
                switch (self.state) {
                    case 'HEADER':
                        // 13-18 - Allow a header (metadata) under the WEBVTT line.
                        if (/:/.test(line)) {
                            parseHeader(line);
                        }
                        else if (!line) {
                            // An empty line terminates the header and starts the body (cues).
                            self.state = 'ID';
                        }
                        continue;
                    case 'NOTE':
                        // Ignore NOTE blocks.
                        if (!line) {
                            self.state = 'ID';
                        }
                        continue;
                    case 'ID':
                        // Check for the start of NOTE blocks.
                        if (/^NOTE($|[ \t])/.test(line)) {
                            self.state = 'NOTE';
                            break;
                        }
                        // 19-29 - Allow any number of line terminators, then initialize new cue values.
                        if (!line) {
                            continue;
                        }
                        self.cue = new vttcue_1.default(0, 0, '');
                        self.state = 'CUE';
                        // 30-39 - Check if self line contains an optional identifier or timing data.
                        if (line.indexOf('-->') === -1) {
                            self.cue.id = line;
                            continue;
                        }
                    // Process line as start of a cue.
                    /* falls through */
                    case 'CUE':
                        // 40 - Collect cue timings and settings.
                        try {
                            parseCue(line, self.cue, self.regionList);
                        }
                        catch (e) {
                            // In case of an error ignore rest of the cue.
                            self.cue = null;
                            self.state = 'BADCUE';
                            continue;
                        }
                        self.state = 'CUETEXT';
                        continue;
                    case 'CUETEXT':
                        var hasSubstring = line.indexOf('-->') !== -1;
                        // 34 - If we have an empty line then report the cue.
                        // 35 - If we have the special substring '-->' then report the cue,
                        // but do not collect the line as we need to process the current
                        // one as a new cue.
                        if (!line || hasSubstring && (alreadyCollectedLine = true)) {
                            // We are done parsing self cue.
                            if (self.oncue) {
                                self.oncue(self.cue);
                            }
                            self.cue = null;
                            self.state = 'ID';
                            continue;
                        }
                        if (self.cue.text) {
                            self.cue.text += '\n';
                        }
                        self.cue.text += line;
                        continue;
                    case 'BADCUE': // BADCUE
                        // 54-62 - Collect and discard the remaining cue.
                        if (!line) {
                            self.state = 'ID';
                        }
                        continue;
                }
            }
        }
        catch (e) {
            // If we are currently parsing a cue, report what we have.
            if (self.state === 'CUETEXT' && self.cue && self.oncue) {
                self.oncue(self.cue);
            }
            self.cue = null;
            // Enter BADWEBVTT state if header was not parsed correctly otherwise
            // another exception occurred so enter BADCUE state.
            self.state = self.state === 'INITIAL' ? 'BADWEBVTT' : 'BADCUE';
        }
        return this;
    },
    flush: function () {
        var self = this;
        try {
            // Finish decoding the stream.
            self.buffer += self.decoder.decode();
            // Synthesize the end of the current cue or region.
            if (self.cue || self.state === 'HEADER') {
                self.buffer += '\n\n';
                self.parse();
            }
            // If we've flushed, parsed, and we're still on the INITIAL state then
            // that means we don't have enough of the stream to parse the first
            // line.
            if (self.state === 'INITIAL') {
                throw new Error('Malformed WebVTT signature.');
            }
        }
        catch (e) {
            throw e;
        }
        if (self.onflush) {
            self.onflush();
        }
        return this;
    }
};
exports.default = VTTParser;


/***/ }),

/***/ "./src/utils/webvtt-parser.js":
/*!************************************!*\
  !*** ./src/utils/webvtt-parser.js ***!
  \************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
Object.defineProperty(exports, "__esModule", { value: true });
var vttparser_1 = __webpack_require__(/*! ./vttparser */ "./src/utils/vttparser.js");
var id3_1 = __webpack_require__(/*! ../demux/id3 */ "./src/demux/id3.js");
// String.prototype.startsWith is not supported in IE11
var startsWith = function (inputString, searchString, position) {
    return inputString.substr(position || 0, searchString.length) === searchString;
};
var cueString2millis = function (timeString) {
    var ts = parseInt(timeString.substr(-3));
    var secs = parseInt(timeString.substr(-6, 2));
    var mins = parseInt(timeString.substr(-9, 2));
    var hours = timeString.length > 9 ? parseInt(timeString.substr(0, timeString.indexOf(':'))) : 0;
    if (!Number.isFinite(ts) || !Number.isFinite(secs) || !Number.isFinite(mins) || !Number.isFinite(hours)) {
        return -1;
    }
    ts += 1000 * secs;
    ts += 60 * 1000 * mins;
    ts += 60 * 60 * 1000 * hours;
    return ts;
};
// From https://github.com/darkskyapp/string-hash
var hash = function (text) {
    var hash = 5381;
    var i = text.length;
    while (i) {
        hash = (hash * 33) ^ text.charCodeAt(--i);
    }
    return (hash >>> 0).toString();
};
var calculateOffset = function (vttCCs, cc, presentationTime) {
    var currCC = vttCCs[cc];
    var prevCC = vttCCs[currCC.prevCC];
    // This is the first discontinuity or cues have been processed since the last discontinuity
    // Offset = current discontinuity time
    if (!prevCC || (!prevCC.new && currCC.new)) {
        vttCCs.ccOffset = vttCCs.presentationOffset = currCC.start;
        currCC.new = false;
        return;
    }
    // There have been discontinuities since cues were last parsed.
    // Offset = time elapsed
    while (prevCC && prevCC.new) {
        vttCCs.ccOffset += currCC.start - prevCC.start;
        currCC.new = false;
        currCC = prevCC;
        prevCC = vttCCs[currCC.prevCC];
    }
    vttCCs.presentationOffset = presentationTime;
};
var WebVTTParser = {
    parse: function (vttByteArray, syncPTS, vttCCs, cc, callBack, errorCallBack) {
        // Convert byteArray into string, replacing any somewhat exotic linefeeds with "\n", then split on that character.
        var re = /\r\n|\n\r|\n|\r/g;
        // Uint8Array.prototype.reduce is not implemented in IE11
        var vttLines = id3_1.utf8ArrayToStr(new Uint8Array(vttByteArray)).trim().replace(re, '\n').split('\n');
        var cueTime = '00:00.000';
        var mpegTs = 0;
        var localTime = 0;
        var presentationTime = 0;
        var cues = [];
        var parsingError;
        var inHeader = true;
        // let VTTCue = VTTCue || window.TextTrackCue;
        // Create parser object using VTTCue with TextTrackCue fallback on certain browsers.
        var parser = new vttparser_1.default();
        parser.oncue = function (cue) {
            // Adjust cue timing; clamp cues to start no earlier than - and drop cues that don't end after - 0 on timeline.
            var currCC = vttCCs[cc];
            var cueOffset = vttCCs.ccOffset;
            // Update offsets for new discontinuities
            if (currCC && currCC.new) {
                if (localTime !== undefined) {
                    // When local time is provided, offset = discontinuity start time - local time
                    cueOffset = vttCCs.ccOffset = currCC.start;
                }
                else {
                    calculateOffset(vttCCs, cc, presentationTime);
                }
            }
            if (presentationTime) {
                // If we have MPEGTS, offset = presentation time + discontinuity offset
                cueOffset = presentationTime - vttCCs.presentationOffset;
            }
            cue.startTime += cueOffset - localTime;
            cue.endTime += cueOffset - localTime;
            // Create a unique hash id for a cue based on start/end times and text.
            // This helps timeline-controller to avoid showing repeated captions.
            cue.id = hash(cue.startTime.toString()) + hash(cue.endTime.toString()) + hash(cue.text);
            // Fix encoding of special characters. TODO: Test with all sorts of weird characters.
            cue.text = decodeURIComponent(encodeURIComponent(cue.text));
            if (cue.endTime > 0) {
                cues.push(cue);
            }
        };
        parser.onparsingerror = function (e) {
            parsingError = e;
        };
        parser.onflush = function () {
            if (parsingError && errorCallBack) {
                errorCallBack(parsingError);
                return;
            }
            callBack(cues);
        };
        // Go through contents line by line.
        vttLines.forEach(function (line) {
            if (inHeader) {
                // Look for X-TIMESTAMP-MAP in header.
                if (startsWith(line, 'X-TIMESTAMP-MAP=')) {
                    // Once found, no more are allowed anyway, so stop searching.
                    inHeader = false;
                    // Extract LOCAL and MPEGTS.
                    line.substr(16).split(',').forEach(function (timestamp) {
                        if (startsWith(timestamp, 'LOCAL:')) {
                            cueTime = timestamp.substr(6);
                        }
                        else if (startsWith(timestamp, 'MPEGTS:')) {
                            mpegTs = parseInt(timestamp.substr(7));
                        }
                    });
                    try {
                        // Calculate subtitle offset in milliseconds.
                        if (syncPTS + ((vttCCs[cc].start * 90000) || 0) < 0) {
                            syncPTS += 8589934592;
                        }
                        // Adjust MPEGTS by sync PTS.
                        mpegTs -= syncPTS;
                        // Convert cue time to seconds
                        localTime = cueString2millis(cueTime) / 1000;
                        // Convert MPEGTS to seconds from 90kHz.
                        presentationTime = mpegTs / 90000;
                        if (localTime === -1) {
                            parsingError = new Error("Malformed X-TIMESTAMP-MAP: " + line);
                        }
                    }
                    catch (e) {
                        parsingError = new Error("Malformed X-TIMESTAMP-MAP: " + line);
                    }
                    // Return without parsing X-TIMESTAMP-MAP line.
                    return;
                }
                else if (line === '') {
                    inHeader = false;
                }
            }
            // Parse line by default.
            parser.parse(line + '\n');
        });
        parser.flush();
    }
};
exports.default = WebVTTParser;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/utils/xhr-loader.js":
/*!*********************************!*\
  !*** ./src/utils/xhr-loader.js ***!
  \*********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * XHR based logger
*/
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var performance = window.performance, XMLHttpRequest = window.XMLHttpRequest;
var XhrLoader = /** @class */ (function () {
    function XhrLoader(config) {
        if (config && config.xhrSetup) {
            this.xhrSetup = config.xhrSetup;
        }
    }
    XhrLoader.prototype.destroy = function () {
        this.abort();
        this.loader = null;
    };
    XhrLoader.prototype.abort = function () {
        var loader = this.loader;
        if (loader && loader.readyState !== 4) {
            this.stats.aborted = true;
            loader.abort();
        }
        window.clearTimeout(this.requestTimeout);
        this.requestTimeout = null;
        window.clearTimeout(this.retryTimeout);
        this.retryTimeout = null;
    };
    XhrLoader.prototype.load = function (context, config, callbacks) {
        this.context = context;
        this.config = config;
        this.callbacks = callbacks;
        this.stats = { trequest: performance.now(), retry: 0 };
        this.retryDelay = config.retryDelay;
        this.loadInternal();
    };
    XhrLoader.prototype.loadInternal = function () {
        var xhr, context = this.context;
        xhr = this.loader = new XMLHttpRequest();
        var stats = this.stats;
        stats.tfirst = 0;
        stats.loaded = 0;
        var xhrSetup = this.xhrSetup;
        try {
            if (xhrSetup) {
                try {
                    xhrSetup(xhr, context.url);
                }
                catch (e) {
                    // fix xhrSetup: (xhr, url) => {xhr.setRequestHeader("Content-Language", "test");}
                    // not working, as xhr.setRequestHeader expects xhr.readyState === OPEN
                    xhr.open('GET', context.url, true);
                    xhrSetup(xhr, context.url);
                }
            }
            if (!xhr.readyState) {
                xhr.open('GET', context.url, true);
            }
        }
        catch (e) {
            // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
            this.callbacks.onError({ code: xhr.status, text: e.message }, context, xhr);
            return;
        }
        if (context.rangeEnd) {
            xhr.setRequestHeader('Range', 'bytes=' + context.rangeStart + '-' + (context.rangeEnd - 1));
        }
        xhr.onreadystatechange = this.readystatechange.bind(this);
        xhr.onprogress = this.loadprogress.bind(this);
        xhr.responseType = context.responseType;
        // setup timeout before we perform request
        this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), this.config.timeout);
        xhr.send();
    };
    XhrLoader.prototype.readystatechange = function (event) {
        var xhr = event.currentTarget, readyState = xhr.readyState, stats = this.stats, context = this.context, config = this.config;
        // don't proceed if xhr has been aborted
        if (stats.aborted) {
            return;
        }
        // >= HEADERS_RECEIVED
        if (readyState >= 2) {
            // clear xhr timeout and rearm it if readyState less than 4
            window.clearTimeout(this.requestTimeout);
            if (stats.tfirst === 0) {
                stats.tfirst = Math.max(performance.now(), stats.trequest);
            }
            if (readyState === 4) {
                var status_1 = xhr.status;
                // http status between 200 to 299 are all successful
                if (status_1 >= 200 && status_1 < 300) {
                    stats.tload = Math.max(stats.tfirst, performance.now());
                    var data = void 0, len = void 0;
                    if (context.responseType === 'arraybuffer') {
                        data = xhr.response;
                        len = data.byteLength;
                    }
                    else {
                        data = xhr.responseText;
                        len = data.length;
                    }
                    stats.loaded = stats.total = len;
                    var response = { url: xhr.responseURL, data: data };
                    this.callbacks.onSuccess(response, stats, context, xhr);
                }
                else {
                    // if max nb of retries reached or if http status between 400 and 499 (such error cannot be recovered, retrying is useless), return error
                    if (stats.retry >= config.maxRetry || (status_1 >= 400 && status_1 < 499)) {
                        logger_1.logger.error(status_1 + " while loading " + context.url);
                        this.callbacks.onError({ code: status_1, text: xhr.statusText }, context, xhr);
                    }
                    else {
                        // retry
                        logger_1.logger.warn(status_1 + " while loading " + context.url + ", retrying in " + this.retryDelay + "...");
                        // aborts and resets internal state
                        this.destroy();
                        // schedule retry
                        this.retryTimeout = window.setTimeout(this.loadInternal.bind(this), this.retryDelay);
                        // set exponential backoff
                        this.retryDelay = Math.min(2 * this.retryDelay, config.maxRetryDelay);
                        stats.retry++;
                    }
                }
            }
            else {
                // readyState >= 2 AND readyState !==4 (readyState = HEADERS_RECEIVED || LOADING) rearm timeout as xhr not finished yet
                this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), config.timeout);
            }
        }
    };
    XhrLoader.prototype.loadtimeout = function () {
        logger_1.logger.warn("timeout while loading " + this.context.url);
        this.callbacks.onTimeout(this.stats, this.context, null);
    };
    XhrLoader.prototype.loadprogress = function (event) {
        var xhr = event.currentTarget, stats = this.stats;
        stats.loaded = event.loaded;
        if (event.lengthComputable) {
            stats.total = event.total;
        }
        var onProgress = this.callbacks.onProgress;
        if (onProgress) {
            // third arg is to provide on progress data
            onProgress(stats, this.context, null, xhr);
        }
    };
    return XhrLoader;
}());
exports.default = XhrLoader;


/***/ })

/******/ })["default"];
});
//# sourceMappingURL=hls.js.map

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TextComponent__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_index__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state,ownProps){return{workspaceParent:ownProps.isGrouped||ownProps.isTextOverlay?function(){return state.project.getIn(["scenes",state.localStore.get("selectedScene"),"workspaceItems",ownProps.data_id]);}:null,parentItem:ownProps.isGrouped?state.project.getIn(["scenes",state.localStore.get("selectedScene"),"workspaceItems",ownProps.data_id]):null,selectedScene:state.localStore.get("selectedScene"),workspaceWidth:state.project.get("width"),selectedItems:state.localStore.get("selectedItems"),zoomFactor:state.localStore.get("zoomFactor"),isPlay:state.localStore.get("isPlay"),isPlayAll:state.localStore.get("isPlayAll"),textStatus:state.localStore.get("textStatus"),transformStatus:state.localStore.get("transformStatus"),textUpdated:state.localStore.get("textUpdated"),workspaceItems:state.project.getIn(["scenes",state.localStore.get("selectedScene"),"workspaceItems"]),animakerType:state.localStore.get("animakerType"),fontStatus:state.localStore.getIn(["loadedFonts","fonts"]).find(function(x){return x.get("load")===ownProps.text.getIn(["textData","formats","containerStyle","fontFamily"]);}),fontTrack:state.localStore.getIn(["loadedFonts","fontTracking",!ownProps.isGrouped?ownProps.data_id:ownProps.itemId]),loadedFonts:state.localStore.get("loadedFonts"),audioPlayHead:state.localStore.get("audioPlayHead"),undoResize:state.localStore.get("undoResize"),textOffset:ownProps.text.getIn(["textData","formats","containerStyle","margin"])==="0px"?state.localStore.get("textOffset"):30,isHyperLinkTextAdded:state.localStore.get('isHyperLinkTextAdded'),lastEditText:state.localStore.get("lastEditText"),project:state.project,scenes:state.project.getIn(["scenes"]),isPreview:state.localStore.get('isPreview'),t1:state.localStore.get('t1'),currentSceneNumber:state.localStore.get('currentSceneNumber'),isFullScreen:state.localStore.get("isFullScreen"),childrenSelection:state.localStore.get("childrenSelection")};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{changeText:function changeText(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["H" /* changeText */])(data,socket));},deleteItem:function deleteItem(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["T" /* deleteItem */])(data,socket));},resizeUpdate:function resizeUpdate(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_24" /* resizeUpdate */])(data));},updateTextStatus:function updateTextStatus(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_95" /* updateTextStatus */])(data));},setTextOptions:function setTextOptions(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_49" /* setTextOptions */])(data));},updateGroupText:function updateGroupText(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_80" /* updateGroupText */])(data,socket));},updateObject:function updateObject(data,socket){dispatch({type:"UPDATE_OBJECT",data:data,socket:socket});},syncText:function syncText(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_66" /* syncText */])(data,socket));},writeText:function writeText(data,socket){dispatch({type:"WRITE_TEXT",data:data,socket:socket});},setSlideJump:function setSlideJump(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_48" /* setSlideJump */])(data));},setSelectedScene:function setSelectedScene(data,time,selectedScenes,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_46" /* setSelectedScene */])(data,time,selectedScenes,socket));},setScenePosition:function setScenePosition(data,currentSceneNumber,currentSceneStartTime,currentSceneDuration){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_43" /* setScenePosition */])(data,currentSceneNumber,currentSceneStartTime,currentSceneDuration));},fontLoaded:function fontLoaded(data){dispatch({type:"FONT_LOADED",data:data});}};};var Text=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_TextComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Text);

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_TextEffectsHelper__ = __webpack_require__(403);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentEditable=function(_Component){_inherits(ContentEditable,_Component);function ContentEditable(){_classCallCheck(this,ContentEditable);return _possibleConstructorReturn(this,(ContentEditable.__proto__||Object.getPrototypeOf(ContentEditable)).apply(this,arguments));}_createClass(ContentEditable,[{key:'render',value:function render(){var _this2=this;var styles=this.props.styles;styles.fontSize=(parseFloat(styles.fontSize,10)*this.props.zoomFactor).toFixed(2)+"px";styles.fontFamily+=", gfs";var dir="auto";if(this.props.otherOptions.get("isRTL")){dir="rtl";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.classes,ref:function ref(e){return _this2.htmlContent=e;},style:styles,contentEditable:this.props.isEditable,'data-id':this.props.dataId,'data-group-id':this.props.dataGroupId,dangerouslySetInnerHTML:{__html:this.props.html},dir:dir});}}]);return ContentEditable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var TextComponent=function(_Component2){_inherits(TextComponent,_Component2);function TextComponent(){_classCallCheck(this,TextComponent);return _possibleConstructorReturn(this,(TextComponent.__proto__||Object.getPrototypeOf(TextComponent)).apply(this,arguments));}_createClass(TextComponent,[{key:'render',value:function render(){var styles=this.props.text.getIn(["textData","formats","containerStyle"]).toObject();var classes="text-container scene-item-inner";if(styles.margin!==undefined)styles.margin=(parseFloat(styles.margin,10)*this.props.zoomFactor).toFixed(2)+"px";if(styles.letterSpacing!==undefined&&this.props.isBullet){styles.paddingLeft=(parseFloat(styles.letterSpacing,10)*3).toFixed(2)+"em";}if(this.props.text.getIn(["textData","formats","others","isRTL"])){classes+=" rtl-text";}var padding=0;if(this.props.text.getIn(["textData","formats","bullet","type"])!=="none"||this.props.text.getIn(["textData","formats","bullet","type"])!==""){if(this.props.text.getIn(["textData","formats","bullet","bulletSpace"])!==undefined){classes+=" bspace"+this.props.text.getIn(["textData","formats","bullet","bulletSpace"]);padding=this.props.text.getIn(["textData","formats","bullet","bulletSpace"]);}}padding=padding*this.props.zoomFactor;styles['--paddingSpace']=padding+'px';if(this.props.text.get("yRatio")&&this.props.isGrouped){}var innerX=this.props.text.get("innerX")?this.props.text.get("innerX"):0;var innerY=this.props.text.get("innerY")?this.props.text.get("innerY"):0;styles.transform="translate("+innerX*this.props.zoomFactor+"px, "+innerY*this.props.zoomFactor+"px)";var currentEffects=this.props.text.getIn(["textData","effects"]);var fontSize=this.props.text.getIn(["textData","formats","containerStyle","fontSize"]);var fontColor=this.props.text.getIn(["textData","formats","containerStyle","color"]);if(currentEffects!=="None"&&currentEffects!==undefined){var effect=Object(__WEBPACK_IMPORTED_MODULE_1__helpers_TextEffectsHelper__["a" /* convertEffectValuesToStyles */])(currentEffects.toJS(),fontSize,fontColor);// console.log("effect", effect)
styles.textShadow=effect.textShadow;styles.webkitTextFillColor=effect.webkitTextFillColor;styles.webkitTextStroke=effect.webkitTextStroke;styles.filter=effect.filter;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentEditable,{dataId:this.props.data_id,textId:this.textId,isEditable:false,height:this.props.text.get("height"),otherOptions:this.props.text.getIn(["textData","formats","others"]),zoomFactor:this.props.zoomFactor,dataGroupId:this.props.itemId,html:this.props.text.getIn(["textData","htmlText"]),isBullet:this.props.text.getIn(["textData","formats","bullet","type"])!=="none",classes:classes,styles:styles});}}]);return TextComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TextComponent);

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = convertEffectValuesToStyles;
/* unused harmony export hexToRgb */
/* unused harmony export calculatedThickness */
/* unused harmony export getDirectionValues */
/* unused harmony export calculateNeonShadow */
/* unused harmony export calculateNeonColor */
/* unused harmony export calculateOutlineTextShadow */
//main function where the styles are returned
function convertEffectValuesToStyles(effect,fontSize,fontColor){var effectName=effect.Type;var styles={};var rgb=effect.Color!==undefined&&effectName!=="Glitch"&&hexToRgb(effect.Color);var directions=effect.Direction!==undefined&&getDirectionValues(effect.Offset,effect.Direction,fontSize);var intensity=effect.Intensity!==undefined&&effect.Intensity;var thickness=effect.Thickness!==undefined&&calculatedThickness(effect.Thickness,fontSize);var transparency=effect.Transparency!==undefined&&effect.Transparency;if(effectName==="Shadow"){var shadowBlur=effect.Blur*0.05;styles.filter='none';styles.webkitTextFillColor="currentcolor";styles.webkitTextStroke="0px currentcolor";styles.textShadow="rgb("+rgb[0]+" "+rgb[1]+" "+rgb[2]+"/ "+transparency+"%) "+directions.directionOne+"px "+directions.directionTwo+"px "+shadowBlur+"px";}else if(effectName==="Lift"){var maxSize=0.5*parseInt(fontSize.replace("px",""),10);var variableSize=maxSize/200;var depth=effect.Depth;styles.filter='none';styles.webkitTextFillColor="currentcolor";styles.webkitTextStroke="0px currentcolor";styles.textShadow="rgb(0 0 0 / "+(intensity*0.55+5)+"%) 0px "+maxSize*depth/100+"px "+(maxSize-variableSize*intensity)+"px";}else if(effectName==="Hollow"){styles.webkitTextStroke=thickness+"px currentcolor";styles.webkitTextFillColor="transparent";styles.filter='none';styles.textShadow="none";}else if(effectName==="Glitch"){var glitchColor=effect.Color===1?"rgb(0 255 255) "+directions.directionOne+"px "+directions.directionTwo+"px 0px, rgb(255 0 0) "+directions.directionOne*-1+"px "+directions.directionTwo*-1+"px 0px":"rgb(0 255 255) "+directions.directionOne+"px "+directions.directionTwo+"px 0px, rgb(255 0 255) "+directions.directionOne*-1+"px "+directions.directionTwo*-1+"px 0px";styles.filter='none';styles.webkitTextFillColor="currentcolor";styles.webkitTextStroke="0px currentcolor";styles.textShadow=glitchColor;}else if(effectName==="Echo"){styles.filter='none';styles.webkitTextFillColor="currentcolor";styles.webkitTextStroke="0px currentcolor";styles.textShadow="rgb("+rgb[0]+" "+rgb[1]+" "+rgb[2]+"/50%) "+directions.directionOne+"px "+directions.directionTwo+"px,\n                             rgb("+rgb[0]+" "+rgb[1]+" "+rgb[2]+"/ 30%) "+directions.directionOne*2+"px "+directions.directionTwo*2+"px";}else if(effectName==="Neon"){styles.webkitTextStroke="0px currentcolor";styles.textShadow="none";styles.webkitTextFillColor=calculateNeonColor(intensity,fontColor);styles.filter=calculateNeonShadow(intensity,fontColor);}else if(effectName==="Splice"){styles.webkitTextStroke=thickness+"px currentcolor";styles.webkitTextFillColor="transparent";styles.filter='none';styles.textShadow="rgb("+rgb[0]+" "+rgb[1]+" "+rgb[2]+") "+directions.directionOne+"px "+directions.directionTwo+"px 0px";}else if(effectName==="Outline"){var _shadowBlur=effect.Blur;var outlineThickness=effect.Thickness;styles.filter='none';styles.webkitTextFillColor="currentcolor";styles.webkitTextStroke="0px currentcolor";styles.textShadow=calculateOutlineTextShadow(effect.Color,outlineThickness,_shadowBlur,transparency,fontSize);}return styles;}// Individual Util functions that perform the necessary calculation.
// Can be reused for future requirements.
function hexToRgb(hex){return hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i,function(m,r,g,b){return'#'+r+r+g+g+b+b;}).substring(1).match(/.{2}/g).map(function(x){return parseInt(x,16);});};function calculatedThickness(val,fontSize){var maxThickness=0.06*parseInt(fontSize.replace("px",""),10);return(1+maxThickness*val*0.01)/2;};function getDirectionValues(shadowOffset,shadowDir,fontSize){var maxShadow=0.12*parseInt(fontSize.replace("px",""),10)*0.6;var offset=maxShadow*(shadowOffset/100);var dir1=offset*Math.cos(shadowDir*Math.PI/180);var dir2=offset*Math.sin(shadowDir*Math.PI/180);return{directionOne:dir1,directionTwo:dir2};};function calculateNeonShadow(intensity,color){var rgb=hexToRgb(color);return"drop-shadow(rgb("+rgb[0]+" "+rgb[1]+" "+rgb[2]+"/95%) 0px 0px "+(1+0.01*intensity)+"px)\n            drop-shadow(rgb("+rgb[0]+" "+rgb[1]+" "+rgb[2]+"/75%) 0px 0px "+(1+0.02*intensity)+"px)\n            drop-shadow(rgb("+rgb[0]+" "+rgb[1]+" "+rgb[2]+"/44%) 0px 0px "+(3+0.02*intensity)+"px)";};function calculateNeonColor(intensity,color){var rgb=hexToRgb(color);var r=rgb[0]+Math.ceil((255-rgb[0])/100*intensity);var g=rgb[1]+Math.ceil((255-rgb[1])/100*intensity);var b=rgb[2]+Math.ceil((255-rgb[2])/100*intensity);return"rgb("+r+" "+g+" "+b+")";};function calculateOutlineTextShadow(color,thickness,blurValue,transparency,fontSize){var strokewidth=calculatedThickness(thickness,fontSize);var blur=20*0.05+blurValue*0.02;var rgb=hexToRgb(color);var shadowColor="rgb("+rgb[0]+" "+rgb[1]+" "+rgb[2]+" / "+transparency+"%)";return strokewidth<6?"\n        "+strokewidth*1+"px "+strokewidth*0+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.9808+"px "+strokewidth*0.1951+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.9239+"px "+strokewidth*0.3827+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.8315+"px "+strokewidth*0.5556+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.7071+"px "+strokewidth*0.7071+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.5556+"px "+strokewidth*0.8315+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.3827+"px "+strokewidth*0.9239+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.1951+"px "+strokewidth*0.9808+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0+"px "+strokewidth*1+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.1951+"px "+strokewidth*0.9808+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.3827+"px "+strokewidth*0.9239+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.5556+"px "+strokewidth*0.8315+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.7071+"px "+strokewidth*0.7071+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.8315+"px "+strokewidth*0.5556+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.9239+"px "+strokewidth*0.3827+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.9808+"px "+strokewidth*0.1951+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-1+"px "+strokewidth*0+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.9808+"px "+strokewidth*-0.1951+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.9239+"px "+strokewidth*-0.3827+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.8315+"px "+strokewidth*-0.5556+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.7071+"px "+strokewidth*-0.7071+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.5556+"px "+strokewidth*-0.8315+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.3827+"px "+strokewidth*-0.9239+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.1951+"px "+strokewidth*-0.9808+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0+"px "+strokewidth*-1+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.1951+"px "+strokewidth*-0.9808+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.3827+"px "+strokewidth*-0.9239+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.5556+"px "+strokewidth*-0.8315+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.7071+"px "+strokewidth*-0.7071+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.8315+"px "+strokewidth*-0.5556+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.9239+"px "+strokewidth*-0.3827+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.9808+"px "+strokewidth*-0.1951+"px "+blur+"px "+shadowColor+"\n    ":"\n        "+strokewidth*1+"px "+strokewidth*0+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.9952+"px "+strokewidth*0.098+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.9808+"px "+strokewidth*0.1951+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.9569+"px "+strokewidth*0.2903+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.9239+"px "+strokewidth*0.3827+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.8819+"px "+strokewidth*0.4714+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.8315+"px "+strokewidth*0.5556+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.773+"px "+strokewidth*0.6344+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.7071+"px "+strokewidth*0.7071+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.6344+"px "+strokewidth*0.773+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.5556+"px "+strokewidth*0.8315+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.4714+"px "+strokewidth*0.8819+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.3827+"px "+strokewidth*0.9239+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.2903+"px "+strokewidth*0.9569+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.1951+"px "+strokewidth*0.9808+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.098+"px "+strokewidth*0.9952+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0+"px "+strokewidth*1+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.098+"px "+strokewidth*0.9952+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.1951+"px "+strokewidth*0.9808+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.2903+"px "+strokewidth*0.9569+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.3827+"px "+strokewidth*0.9239+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.4714+"px "+strokewidth*0.8819+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.5556+"px "+strokewidth*0.8315+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.6344+"px "+strokewidth*0.773+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.7071+"px "+strokewidth*0.7071+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.773+"px "+strokewidth*0.6344+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.8315+"px "+strokewidth*0.5556+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.8819+"px "+strokewidth*0.4714+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.9239+"px "+strokewidth*0.3827+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.9569+"px "+strokewidth*0.2903+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.9808+"px "+strokewidth*0.1951+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.9952+"px "+strokewidth*0.098+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-1+"px "+strokewidth*0+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.9952+"px "+strokewidth*-0.098+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.9808+"px "+strokewidth*-0.1951+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.9569+"px "+strokewidth*-0.2903+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.9239+"px "+strokewidth*-0.3827+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.8819+"px "+strokewidth*-0.4714+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.8315+"px "+strokewidth*-0.5556+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.773+"px "+strokewidth*-0.6344+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.7071+"px "+strokewidth*-0.7071+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.6344+"px "+strokewidth*-0.773+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.5556+"px "+strokewidth*-0.8315+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.4714+"px "+strokewidth*-0.8819+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.3827+"px "+strokewidth*-0.9239+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.2903+"px "+strokewidth*-0.9569+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.1951+"px "+strokewidth*-0.9808+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*-0.098+"px "+strokewidth*-0.9952+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0+"px "+strokewidth*-1+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.098+"px "+strokewidth*-0.9952+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.1951+"px "+strokewidth*-0.9808+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.2903+"px "+strokewidth*-0.9569+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.3827+"px "+strokewidth*-0.9239+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.4714+"px "+strokewidth*-0.8819+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.5556+"px "+strokewidth*-0.8315+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.6344+"px "+strokewidth*-0.773+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.7071+"px "+strokewidth*-0.7071+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.773+"px "+strokewidth*-0.6344+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.8315+"px "+strokewidth*-0.5556+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.8819+"px "+strokewidth*-0.4714+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.9239+"px "+strokewidth*-0.3827+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.9569+"px "+strokewidth*-0.2903+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.9808+"px "+strokewidth*-0.1951+"px "+blur+"px "+shadowColor+",\n        "+strokewidth*0.9952+"px "+strokewidth*-0.098+"px "+blur+"px "+shadowColor+"\n    ";}

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * VERSION: 0.2.2
 * DATE: 2017-06-19
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2017, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 *
 * @author: Jack Doyle, jack@greensock.com
 **/
var _gsScope = (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push( function() {

	"use strict";

	_gsScope._gsDefine("easing.CustomEase", ["easing.Ease"], function(Ease) {

		var _numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
			_svgPathExp = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
			_scientific = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/ig,
			_needsParsingExp = /[cLlsS]/g,
			_bezierError = "CustomEase only accepts Cubic Bezier data.",
			_bezierToPoints = function (x1, y1, x2, y2, x3, y3, x4, y4, threshold, points, index) {
				var x12 = (x1 + x2) / 2,
					y12 = (y1 + y2) / 2,
					x23 = (x2 + x3) / 2,
					y23 = (y2 + y3) / 2,
					x34 = (x3 + x4) / 2,
					y34 = (y3 + y4) / 2,
					x123 = (x12 + x23) / 2,
					y123 = (y12 + y23) / 2,
					x234 = (x23 + x34) / 2,
					y234 = (y23 + y34) / 2,
					x1234 = (x123 + x234) / 2,
					y1234 = (y123 + y234) / 2,
					dx = x4 - x1,
					dy = y4 - y1,
					d2 = Math.abs((x2 - x4) * dy - (y2 - y4) * dx),
					d3 = Math.abs((x3 - x4) * dy - (y3 - y4) * dx),
					length;
				if (!points) {
					points = [{x: x1, y: y1}, {x: x4, y: y4}];
					index = 1;
				}
				points.splice(index || points.length - 1, 0, {x: x1234, y: y1234});
				if ((d2 + d3) * (d2 + d3) > threshold * (dx * dx + dy * dy)) {
					length = points.length;
					_bezierToPoints(x1, y1, x12, y12, x123, y123, x1234, y1234, threshold, points, index);
					_bezierToPoints(x1234, y1234, x234, y234, x34, y34, x4, y4, threshold, points, index + 1 + (points.length - length));
				}
				return points;
			},

			_pathDataToBezier = function (d) {
				var a = (d + "").replace(_scientific, function (m) {
							var n = +m;
							return (n < 0.0001 && n > -0.0001) ? 0 : n;
						}).match(_svgPathExp) || [], //some authoring programs spit out very small numbers in scientific notation like "1e-5", so make sure we round that down to 0 first.
					path = [],
					relativeX = 0,
					relativeY = 0,
					elements = a.length,
					l = 2,
					i, x, y, command, isRelative, segment, startX, startY, prevCommand, difX, difY;
				for (i = 0; i < elements; i++) {
					prevCommand = command;
					if (isNaN(a[i])) {
						command = a[i].toUpperCase();
						isRelative = (command !== a[i]); //lower case means relative
					} else { //commands like "C" can be strung together without any new command characters between.
						i--;
					}
					x = +a[i + 1];
					y = +a[i + 2];
					if (isRelative) {
						x += relativeX;
						y += relativeY;
					}
					if (!i) {
						startX = x;
						startY = y;
					}
					if (command === "M") {
						if (segment && segment.length < 8) { //if the path data was funky and just had a M with no actual drawing anywhere, skip it.
							path.length -= 1;
							l = 0;
						}
						relativeX = startX = x;
						relativeY = startY = y;
						segment = [x, y];
						l = 2;
						path.push(segment);
						i += 2;
						command = "L"; //an "M" with more than 2 values gets interpreted as "lineTo" commands ("L").

					} else if (command === "C") {
						if (!segment) {
							segment = [0, 0];
						}
						segment[l++] = x;
						segment[l++] = y;
						if (!isRelative) {
							relativeX = relativeY = 0;
						}
						segment[l++] = relativeX + a[i + 3] * 1; //note: "*1" is just a fast/short way to cast the value as a Number. WAAAY faster in Chrome, slightly slower in Firefox.
						segment[l++] = relativeY + a[i + 4] * 1;
						segment[l++] = relativeX = relativeX + a[i + 5] * 1;
						segment[l++] = relativeY = relativeY + a[i + 6] * 1;
						i += 6;

					} else if (command === "S") {
						if (prevCommand === "C" || prevCommand === "S") {
							difX = relativeX - segment[l - 4];
							difY = relativeY - segment[l - 3];
							segment[l++] = relativeX + difX;
							segment[l++] = relativeY + difY;
						} else {
							segment[l++] = relativeX;
							segment[l++] = relativeY;
						}
						segment[l++] = x;
						segment[l++] = y;
						if (!isRelative) {
							relativeX = relativeY = 0;
						}
						segment[l++] = relativeX = relativeX + a[i + 3] * 1;
						segment[l++] = relativeY = relativeY + a[i + 4] * 1;
						i += 4;

					} else if (command === "L" || command === "Z") {
						if (command === "Z") {
							x = startX;
							y = startY;
							segment.closed = true;
						}
						if (command === "L" || Math.abs(relativeX - x) > 0.5 || Math.abs(relativeY - y) > 0.5) {
							segment[l++] = relativeX + (x - relativeX) / 3;
							segment[l++] = relativeY + (y - relativeY) / 3;
							segment[l++] = relativeX + (x - relativeX) * 2 / 3;
							segment[l++] = relativeY + (y - relativeY) * 2 / 3;
							segment[l++] = x;
							segment[l++] = y;
							if (command === "L") {
								i += 2;
							}
						}
						relativeX = x;
						relativeY = y;
					} else {
						throw _bezierError;
					}

				}
				return path[0];
			},

			_findMinimum = function (values) {
				var l = values.length,
					min = 999999999999,
					i;
				for (i = 1; i < l; i += 6) {
					if (+values[i] < min) {
						min = +values[i];
					}
				}
				return min;
			},

			_normalize = function (values, height, originY) { //takes all the points and translates/scales them so that the x starts at 0 and ends at 1.
				if (!originY && originY !== 0) {
					originY = Math.max(+values[values.length-1], +values[1]);
				}
				var tx = +values[0] * -1,
					ty = -originY,
					l = values.length,
					sx = 1 / (+values[l - 2] + tx),
					sy = -height || ((Math.abs(+values[l - 1] - +values[1]) < 0.01 * (+values[l - 2] - +values[0])) ? _findMinimum(values) + ty : +values[l - 1] + ty),
					i;
				if (sy) { //typically y ends at 1 (so that the end values are reached)
					sy = 1 / sy;
				} else { //in case the ease returns to its beginning value, scale everything proportionally
					sy = -sx;
				}
				for (i = 0; i < l; i += 2) {
					values[i] = (+values[i] + tx) * sx;
					values[i + 1] = (+values[i + 1] + ty) * sy;
				}
			},

			_getRatio = function (p) {
				var point = this.lookup[(p * this.l) | 0] || this.lookup[this.l - 1];
				if (point.nx < p) {
					point = point.n;
				}
				return point.y + ((p - point.x) / point.cx) * point.cy;
			},


			CustomEase = function (id, data, config) {
				this._calcEnd = true;
				this.id = id;
				if (id) {
					Ease.map[id] = this;
				}
				this.getRatio = _getRatio; //speed optimization, faster lookups.
				this.setData(data, config);
			},
			p = CustomEase.prototype = new Ease();

		p.constructor = CustomEase;

		p.setData = function(data, config) {
			data = data || "0,0,1,1";
			var values = data.match(_numbersExp),
				closest = 1,
				points = [],
				l, a1, a2, i, inc, j, point, prevPoint, p, precision;
			config = config || {};
			precision = config.precision || 1;
			this.data = data;
			this.lookup = [];
			this.points = points;
			this.fast = (precision <= 1);
			if (_needsParsingExp.test(data) || (data.indexOf("M") !== -1 && data.indexOf("C") === -1)) {
				values = _pathDataToBezier(data);
			}
			l = values.length;
			if (l === 4) {
				values.unshift(0, 0);
				values.push(1, 1);
				l = 8;
			} else if ((l - 2) % 6) {
				throw _bezierError;
			}
			if (+values[0] !== 0 || +values[l - 2] !== 1) {
				_normalize(values, config.height, config.originY);
			}

			this.rawBezier = values;

			for (i = 2; i < l; i += 6) {
				a1 = {x: +values[i - 2], y: +values[i - 1]};
				a2 = {x: +values[i + 4], y: +values[i + 5]};
				points.push(a1, a2);
				_bezierToPoints(a1.x, a1.y, +values[i], +values[i + 1], +values[i + 2], +values[i + 3], a2.x, a2.y, 1 / (precision * 200000), points, points.length - 1);
			}
			l = points.length;
			for (i = 0; i < l; i++) {
				point = points[i];
				prevPoint = points[i - 1] || point;
				if (point.x > prevPoint.x || (prevPoint.y !== point.y && prevPoint.x === point.x) || point === prevPoint) { //if a point goes BACKWARD in time or is a duplicate, just drop it.
					prevPoint.cx = point.x - prevPoint.x; //change in x between this point and the next point (performance optimization)
					prevPoint.cy = point.y - prevPoint.y;
					prevPoint.n = point;
					prevPoint.nx = point.x; //next point's x value (performance optimization, making lookups faster in getRatio()). Remember, the lookup will always land on a spot where it's either this point or the very next one (never beyond that)
					if (this.fast && i > 1 && Math.abs(prevPoint.cy / prevPoint.cx - points[i - 2].cy / points[i - 2].cx) > 2) { //if there's a sudden change in direction, prioritize accuracy over speed. Like a bounce ease - you don't want to risk the sampling chunks landing on each side of the bounce anchor and having it clipped off.
						this.fast = false;
					}
					if (prevPoint.cx < closest) {
						if (!prevPoint.cx) {
							prevPoint.cx = 0.001; //avoids math problems in getRatio() (dividing by zero)
							if (i === l - 1) { //in case the final segment goes vertical RIGHT at the end, make sure we end at the end.
								prevPoint.x -= 0.001;
								closest = Math.min(closest, 0.001);
								this.fast = false;
							}
						} else {
							closest = prevPoint.cx;
						}
					}
				} else {
					points.splice(i--, 1);
					l--;
				}
			}
			l = (1 / closest + 1) | 0;
			this.l = l; //record for speed optimization
			inc = 1 / l;
			j = 0;
			point = points[0];
			if (this.fast) {
				for (i = 0; i < l; i++) { //for fastest lookups, we just sample along the path at equal x (time) distance. Uses more memory and is slightly less accurate for anchors that don't land on the sampling points, but for the vast majority of eases it's excellent (and fast).
					p = i * inc;
					if (point.nx < p) {
						point = points[++j];
					}
					a1 = point.y + ((p - point.x) / point.cx) * point.cy;
					this.lookup[i] = {x: p, cx: inc, y: a1, cy: 0, nx: 9};
					if (i) {
						this.lookup[i - 1].cy = a1 - this.lookup[i - 1].y;
					}
				}
				this.lookup[l - 1].cy = points[points.length - 1].y - a1;
			} else { //this option is more accurate, ensuring that EVERY anchor is hit perfectly. Clipping across a bounce, for example, would never happen.
				for (i = 0; i < l; i++) { //build a lookup table based on the smallest distance so that we can instantly find the appropriate point (well, it'll either be that point or the very next one). We'll look up based on the linear progress. So it's it's 0.5 and the lookup table has 100 elements, it'd be like lookup[Math.floor(0.5 * 100)]
					if (point.nx < i * inc) {
						point = points[++j];
					}
					this.lookup[i] = point;
				}

				if (j < points.length - 1) {
					this.lookup[i-1] = points[points.length-2];
				}
			}
			this._calcEnd = (points[points.length-1].y !== 1 || points[0].y !== 0); //ensures that we don't run into floating point errors. As long as we're starting at 0 and ending at 1, tell GSAP to skip the final calculation and use 0/1 as the factor.
			return this;
		};

		p.getRatio = _getRatio;

		p.getSVGData = function(config) {
			return CustomEase.getSVGData(this, config);
		};

		CustomEase.create = function (id, data, config) {
			return new CustomEase(id, data, config);
		};

		CustomEase.version = "0.2.2";

		CustomEase.bezierToPoints = _bezierToPoints;
		CustomEase.get = function (id) {
			return Ease.map[id];
		};
		CustomEase.getSVGData = function(ease, config) {
			config = config || {};
			var rnd = 1000,
				width = config.width || 100,
				height = config.height || 100,
				x = config.x || 0,
				y = (config.y || 0) + height,
				e = config.path,
				a, slope, i, inc, tx, ty, precision, threshold, prevX, prevY;
			if (config.invert) {
				height = -height;
				y = 0;
			}
			ease = ease.getRatio ? ease : Ease.map[ease] || console.log("No ease found: ", ease);
			if (!ease.rawBezier) {
				a = ["M" + x + "," + y];
				precision = Math.max(5, (config.precision || 1) * 200);
				inc = 1 / precision;
				precision += 2;
				threshold = 5 / precision;
				prevX = (((x + inc * width) * rnd) | 0) / rnd;
				prevY = (((y + ease.getRatio(inc) * -height) * rnd) | 0) / rnd;
				slope = (prevY - y) / (prevX - x);
				for (i = 2; i < precision; i++) {
					tx = (((x + i * inc * width) * rnd) | 0) / rnd;
					ty = (((y + ease.getRatio(i * inc) * -height) * rnd) | 0) / rnd;
					if (Math.abs((ty - prevY) / (tx - prevX) - slope) > threshold || i === precision - 1) { //only add points when the slope changes beyond the threshold
						a.push(prevX + "," + prevY);
						slope = (ty - prevY) / (tx - prevX);
					}
					prevX = tx;
					prevY = ty;
				}
			} else {
				a = [];
				precision = ease.rawBezier.length;
				for (i = 0; i < precision; i += 2) {
					a.push((((x + ease.rawBezier[i] * width) * rnd) | 0) / rnd + "," + (((y + ease.rawBezier[i + 1] * -height) * rnd) | 0) / rnd);
				}
				a[0] = "M" + a[0];
				a[1] = "C" + a[1];
			}
			if (e) {
				(typeof(e) === "string" ? document.querySelector(e) : e).setAttribute("d", a.join(" "));
			}
			return a.join(" ");
		};

		return CustomEase;

	}, true);

}); if (_gsScope._gsDefine) { _gsScope._gsQueue.pop()(); }

//export to AMD/RequireJS and CommonJS/Node (precursor to full modular build system coming at a later date)
(function(name) {
	"use strict";
	var getGlobal = function() {
		return (_gsScope.GreenSockGlobals || _gsScope)[name];
	};
	if (typeof(module) !== "undefined" && module.exports) { //node
		__webpack_require__(12);
		module.exports = getGlobal();
	} else if (true) { //AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(12)], __WEBPACK_AMD_DEFINE_FACTORY__ = (getGlobal),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
}("CustomEase"));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export spontaneousFilters */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(42);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var PreviewEffects=function(){function PreviewEffects(props){_classCallCheck(this,PreviewEffects);this.tween=new __WEBPACK_IMPORTED_MODULE_0_gsap__["f" /* TimelineMax */]({paused:true});this.killTween=this.killTween.bind(this);this.browserName=props.browserName;this.width=props.width;this.height=props.height;this.zoomFactor=props.zoomFactor;}_createClass(PreviewEffects,[{key:"maskExist",value:function maskExist(elementId,type){if(!type)type="";if(document.getElementById("mymask_"+elementId+type))return true;else return false;}},{key:"removeMask",value:function removeMask(elementId){var mask_name="mymask_"+elementId;var elements=[];var tmpsvg,par;elements=document.querySelectorAll('*[id^="'+mask_name+'"]');for(var cnt=0;cnt<elements.length;cnt++){tmpsvg=document.getElementById(elements[cnt].id);if(tmpsvg!==null){par=tmpsvg.parentNode;par.removeChild(tmpsvg);par.parentNode.removeChild(par);document.getElementById(elementId).removeAttribute("mask");}}}},{key:"addMask",value:function addMask(elementId,type,direction,rotation,scaleX,scaleY,effectType,isScene){var val=document.getElementById(elementId);var bounds=val.getBoundingClientRect();if(!scaleX)scaleX=1;if(!scaleY)scaleY=1;if(!direction)direction="";if(!type)type="";if(val!==null){var mask_rect="mask_"+elementId+"_rect";var mask_tag=document.createElementNS('http://www.w3.org/2000/svg',"clipPath");var mask_name,myRect;var mySVG=document.createElementNS('http://www.w3.org/2000/svg',"svg");var totalCount=10,count;if(type==="multiWidth"||type==="multiHeight"){mask_name="mymask_"+elementId+type;var _h=val.offsetHeight;var _w=val.offsetWidth;val.style.clipPath="url(#"+mask_name+")";val.style.webkitClipPath="url(#"+mask_name+")";val.style.mozClipPath="url(#"+mask_name+")";val.style.msClipPath="url(#"+mask_name+")";val.style.oClipPath="url(#"+mask_name+")";mask_tag.setAttributeNS(null,"id",mask_name);for(count=0;count<totalCount;count++){if(type==="multiWidth")myRect=this.addMaskDOM("rect",mask_rect+count,count*(_w/totalCount),0,_w/totalCount+1,_h,val.getAttribute("stroke-width"));else if(type==="multiHeight")myRect=this.addMaskDOM("rect",mask_rect+count,0,count*_h/totalCount,_w,_h/totalCount+1,val.getAttribute("stroke-width"));mask_tag.appendChild(myRect);}mySVG.setAttributeNS(null,"width",0);mySVG.setAttributeNS(null,"height",0);mySVG.appendChild(mask_tag);document.getElementById(elementId).appendChild(mySVG);}else if(type==="square"||type==="slidesquare"||type==="pixelsquare"){if(effectType!=="exit"){mask_name="mymask_"+elementId+type;}else{mask_name="mymask_"+elementId+"exitsquare";mask_rect+="exit";}val.style.clipPath="url(#"+mask_name+")";val.style.webkitClipPath="url(#"+mask_name+")";val.style.mozClipPath="url(#"+mask_name+")";val.style.msClipPath="url(#"+mask_name+")";val.style.oClipPath="url(#"+mask_name+")";mask_tag.setAttributeNS(null,"id",mask_name);var _h2=document.getElementById(elementId).offsetHeight;var _w2=document.getElementById(elementId).offsetWidth;var totalSquare=6;if(type==="square")totalSquare=6;for(count=0;count<totalSquare;count++){for(var cnt=0;cnt<totalSquare;cnt++){var changeValY=cnt*_h2/totalSquare;var changeValX=count*_w2/totalSquare;myRect=this.addMaskDOM("rect",mask_rect+count+cnt,changeValX,changeValY,_w2/totalSquare+1,_h2/totalSquare+1,val.getAttribute("stroke-width"));mask_tag.appendChild(myRect);}}mySVG.setAttributeNS(null,"width",0);mySVG.setAttributeNS(null,"height",0);mySVG.appendChild(mask_tag);document.getElementById(elementId).appendChild(mySVG);}else if(type==="splitVer"||type==="splitHor"){totalCount=2;mask_name="mymask_"+elementId+"split";val.style.clipPath="url(#"+mask_name+")";val.style.webkitClipPath="url(#"+mask_name+")";val.style.mozClipPath="url(#"+mask_name+")";val.style.msClipPath="url(#"+mask_name+")";val.style.oClipPath="url(#"+mask_name+")";mask_tag.setAttributeNS(null,"id",mask_name);var _h3=bounds.height;var _w3=bounds.width;for(count=0;count<totalCount;count++){if(type==="splitHor")myRect=this.addMaskDOM("rect",mask_rect+count,0,count*_h3/2,_w3,_h3/totalCount+1,val.getAttribute("stroke-width"));else myRect=this.addMaskDOM("rect",mask_rect+count,count*_w3/2,0,_w3/totalCount+1,_h3,val.getAttribute("stroke-width"));mask_tag.appendChild(myRect);}mySVG.setAttributeNS(null,"width",0);mySVG.setAttributeNS(null,"height",0);mySVG.appendChild(mask_tag);document.getElementById(elementId).appendChild(mySVG);}else if(type==="circle"){mask_name="mymask_"+elementId+type;val.style.clipPath="url(#"+mask_name+")";val.style.webkitClipPath="url(#"+mask_name+")";val.style.mozClipPath="url(#"+mask_name+")";val.style.msClipPath="url(#"+mask_name+")";val.style.oClipPath="url(#"+mask_name+")";mask_tag.setAttributeNS(null,"id",mask_name);var myCir=document.createElementNS('http://www.w3.org/2000/svg',"circle");myCir.setAttributeNS(null,"id",mask_rect);myCir.setAttributeNS(null,"cx",document.getElementById(elementId).offsetWidth/2);myCir.setAttributeNS(null,"cy",document.getElementById(elementId).offsetHeight/2);myCir.setAttributeNS(null,"r",(document.getElementById(elementId).offsetWidth+document.getElementById(elementId).offsetHeight)/2);myCir.setAttributeNS(null,"stroke-width",val.getAttribute("stroke-width"));myCir.setAttributeNS(null,"fill","beige");myCir.setAttributeNS(null,"stroke","beige");mask_tag.appendChild(myCir);mySVG.setAttributeNS(null,"width",0);mySVG.setAttributeNS(null,"height",0);mySVG.appendChild(mask_tag);document.getElementById(elementId).appendChild(mySVG);}else if(type==="circularReveal"){mask_name="mymask_"+elementId+type;val.style.clipPath="url(#"+mask_name+")";val.style.webkitClipPath="url(#"+mask_name+")";val.style.mozClipPath="url(#"+mask_name+")";val.style.msClipPath="url(#"+mask_name+")";val.style.oClipPath="url(#"+mask_name+")";mask_tag.setAttributeNS(null,"id",mask_name);var myPath=document.createElementNS('http://www.w3.org/2000/svg',"path");myPath.setAttributeNS(null,"id","arcPath"+elementId);myPath.setAttributeNS(null,"d"," ");mask_tag.appendChild(myPath);mySVG.setAttributeNS(null,"width",0);mySVG.setAttributeNS(null,"height",0);mySVG.appendChild(mask_tag);// document.getElementById(elementId).parentElement.appendChild(mySVG);
document.getElementById(elementId).appendChild(mySVG);}else{mask_name="mymask_"+elementId+type;val.style.clipPath="url(#"+mask_name+")";val.style.webkitClipPath="url(#"+mask_name+")";val.style.mozClipPath="url(#"+mask_name+")";val.style.msClipPath="url(#"+mask_name+")";val.style.oClipPath="url(#"+mask_name+")";mask_tag.setAttributeNS(null,"id",mask_name);var h=bounds.height>document.getElementById(elementId).offsetHeight?bounds.height:document.getElementById(elementId).offsetHeight;//* Math.abs(Math.cos(rotation)) + bounds.width * Math.abs(Math.sin(rotation));
var w=bounds.width>document.getElementById(elementId).offsetWidth?bounds.width:document.getElementById(elementId).offsetWidth;//* Math.abs(Math.cos(rotation)) + bounds.height * Math.abs(Math.sin(rotation));
if(type==="reveal"||type==="irish"){h=document.getElementById(elementId).offsetHeight;w=document.getElementById(elementId).offsetWidth;}myRect=this.addMaskDOM("rect",mask_rect,0,0,w,h);mask_tag.appendChild(myRect);mySVG.setAttributeNS(null,"width",0);mySVG.setAttributeNS(null,"height",0);if(rotation){if(scaleX===scaleY)rotation*=-1;var rotVal="rotate("+rotation+")";myRect.setAttribute("transform",rotVal);}mySVG.appendChild(mask_tag);// document.getElementById(elementId).parentElement.appendChild(mySVG);
// if(isScene)
document.getElementById(elementId).appendChild(mySVG);// else
//   document.getElementById(elementId).insertBefore(mySVG, document.getElementById(elementId).childNodes[0]);
if(type!=="wipe"||type==="wipe"&&rotation!==0){var newx=document.getElementById(elementId).getBoundingClientRect().x-document.getElementById(mask_rect).getBoundingClientRect().x;var newy=document.getElementById(elementId).getBoundingClientRect().y-document.getElementById(mask_rect).getBoundingClientRect().y;myRect.setAttribute("x",newx*scaleX);myRect.setAttribute("y",newy*scaleY);}}}}},{key:"addMaskDOM",value:function addMaskDOM(domName,idVal,xVal,yVal,widthVal,heightVal,strokeWidthVal){var newDOM=document.createElementNS('http://www.w3.org/2000/svg',domName);newDOM.setAttributeNS(null,"id",idVal);newDOM.setAttributeNS(null,"x",xVal);newDOM.setAttributeNS(null,"y",yVal);newDOM.setAttributeNS(null,"width",widthVal);newDOM.setAttributeNS(null,"height",heightVal);newDOM.setAttributeNS(null,"stroke-width",strokeWidthVal);newDOM.setAttributeNS(null,"fill","beige");newDOM.setAttributeNS(null,"stroke","beige");return newDOM;}},{key:"redrawClipPath",value:function redrawClipPath(innerblock,mask_rect){innerblock.style.clipPath="none";innerblock.style.clipPath="url("+mask_rect+")";innerblock.style.webkitClipPath="url("+mask_rect+")";innerblock.style.mozClipPath="url("+mask_rect+")";innerblock.style.msClipPath="url("+mask_rect+")";innerblock.style.oClipPath="url("+mask_rect+")";}},{key:"sceneSplitHandler",value:function sceneSplitHandler(innerblock,startTime,enterstart,transEffect){function onStartTween(blockId){var maskFound=this.maskExist(blockId,"split"),type="split";if(!maskFound){this.removeMask(blockId);if(transEffect==="SlideSplitHorizontalOut"||transEffect==="SlideSplitHorizontalIn"||transEffect==="SlideSplitMoveHor")this.addMask(blockId,"splitHor");else if(transEffect==="SlideSplitVerticalOut"||transEffect==="SlideSplitVerticalIn"||transEffect==="SlideSplitMoveVer")this.addMask(blockId,"splitVer");}var mask_rect="#mask_"+blockId+"_rect";var totalCount=2;var firstSplit,SecondSplit;__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].set(mask_rect,{scale:1,transformOrigin:"50% 50%"});__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].set(innerblock,{scale:1,transformOrigin:"50% 50%"});if(this.browserName!=="Apple Safari"){if(transEffect==="SlideSplitVerticalOut"||transEffect==="SlideSplitMoveHor"){firstSplit={x:this.width*this.zoomFactor*-1};SecondSplit={x:this.width*this.zoomFactor};}else if(transEffect==="SlideSplitMoveVer"||transEffect==="SlideSplitHorizontalOut"){firstSplit={y:this.height*this.zoomFactor*-1};SecondSplit={y:this.height*this.zoomFactor};}else if(transEffect==="SlideSplitHorizontalIn"){firstSplit={transformOrigin:"50% 100%",scaleY:0};SecondSplit={transformOrigin:"50% 0%",scaleY:0};}else if(transEffect==="SlideSplitVerticalIn"){firstSplit={transformOrigin:"100% 50%",scaleX:0};SecondSplit={transformOrigin:"0% 50%",scaleX:0};}}else{if(transEffect==="SlideSplitVerticalOut"||transEffect==="SlideSplitMoveHor"){firstSplit={x:this.width*this.zoomFactor*-1,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};SecondSplit={x:this.width*this.zoomFactor,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};}else if(transEffect==="SlideSplitMoveVer"||transEffect==="SlideSplitHorizontalOut"){firstSplit={y:this.height*this.zoomFactor*-1,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};SecondSplit={y:this.height*this.zoomFactor,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};}else if(transEffect==="SlideSplitHorizontalIn"){firstSplit={transformOrigin:"50% 100%",scaleY:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};SecondSplit={transformOrigin:"50% 0%",scaleY:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};}else if(transEffect==="SlideSplitVerticalIn"){firstSplit={transformOrigin:"100% 50%",scaleX:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};SecondSplit={transformOrigin:"0% 50%",scaleX:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};}}for(var count=0;count<totalCount;count++){if(count===0)this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].to(mask_rect+count,startTime,firstSplit),enterstart);else this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].to(mask_rect+count,startTime,SecondSplit),enterstart);}}this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].from(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id],opacity:1}),enterstart);}},{key:"stripeExitHandler",value:function stripeExitHandler(innerblock,xval,yval,startTime,enterstart,effectType,scaleX,scaleY,opacity,isChild){if(scaleY===-1||scaleX===-1){if(effectType==="stripeTopLeft"&&scaleY===-1&&scaleX===1)effectType="stripe_Bottomleft";else if(effectType==="stripeTopLeft"&&scaleX===-1&&scaleY===1)effectType="stripe_Topright";else if(effectType==="stripeTopLeft"&&scaleX===-1&&scaleY===-1)effectType="stripe_Bottomright";else if(effectType==="stripe_Topright"&&scaleY===-1&&scaleX===1)effectType="stripe_Bottomright";else if(effectType==="stripe_Topright"&&scaleX===-1&&scaleY===1)effectType="stripeTopLeft";else if(effectType==="stripe_Topright"&&scaleX===-1&&scaleY===-1)effectType="stripe_Bottomleft";else if(effectType==="stripe_Bottomleft"&&scaleY===-1&&scaleX===1)effectType="stripeTopLeft";else if(effectType==="stripe_Bottomleft"&&scaleX===-1&&scaleY===1)effectType="stripe_Bottomright";else if(effectType==="stripe_Bottomleft"&&scaleX===-1&&scaleY===-1)effectType="stripe_Topright";else if(effectType==="stripe_Bottomright"&&scaleY===-1&&scaleX===1)effectType="stripe_Topright";else if(effectType==="stripe_Bottomright"&&scaleX===-1&&scaleY===1)effectType="stripe_Bottomleft";else if(effectType==="stripe_Bottomright"&&scaleX===-1&&scaleY===-1)effectType="stripeTopLeft";else if(effectType==="stripeLeftTop"&&scaleY===-1&&scaleX===1)effectType="stripeLeftBottom";else if(effectType==="stripeLeftTop"&&scaleX===-1&&scaleY===1)effectType="stripeRightTop";else if(effectType==="stripeLeftTop"&&scaleX===-1&&scaleY===-1)effectType="stripeRightBottom";else if(effectType==="stripeRightTop"&&scaleY===-1&&scaleX===1)effectType="stripeRightBottom";else if(effectType==="stripeRightTop"&&scaleX===-1&&scaleY===1)effectType="stripeLeftTop";else if(effectType==="stripeRightTop"&&scaleX===-1&&scaleY===-1)effectType="stripeLeftBottom";else if(effectType==="stripeLeftBottom"&&scaleY===-1&&scaleX===1)effectType="stripeLeftTop";else if(effectType==="stripeLeftBottom"&&scaleX===-1&&scaleY===1)effectType="stripeRightBottom";else if(effectType==="stripeLeftBottom"&&scaleX===-1&&scaleY===-1)effectType="stripeRightTop";else if(effectType==="stripeRightBottom"&&scaleY===-1&&scaleX===1)effectType="stripeRightTop";else if(effectType==="stripeRightBottom"&&scaleX===-1&&scaleY===1)effectType="stripeLeftBottom";else if(effectType==="stripeRightBottom"&&scaleX===-1&&scaleY===-1)effectType="stripeLeftTop";}function onStartTween(blockId,type,effectType){if(!type)type="";var maskFound=this.maskExist(blockId,type);if(!maskFound){this.removeMask(blockId);this.addMask(blockId,type);}var mask_rect="#mask_"+blockId+"_rect";var totalCount=10;var num=0,count=0;__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].set(mask_rect,{opacity:1,transformOrigin:"50% 50%"});__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].set(innerblock,{opacity:opacity,transformOrigin:"50% 50%"});if(effectType==="stripe_Topright"||effectType==="stripeTopLeft"||effectType==="stripeLeftTop"||effectType==="stripeLeftBottom"||effectType==="stripeRightBottom"||effectType==="SlideStripeRight"||effectType==="SlideStripeLeft"||effectType==="SlideStripeBottom"||effectType==="SlideStripeTop"){for(count=0;count<totalCount;count++){var vars=void 0;if(effectType==="stripeTopLeft")vars={scaleX:0};else if(effectType==="stripe_Topright")vars={transformOrigin:"100%",scaleX:0};else if(effectType==="stripeLeftBottom")vars={scaleY:0};else if(effectType==="stripeLeftTop")vars={transformOrigin:"bottom",scaleY:0};else if(effectType==="stripeRightBottom")vars={transformOrigin:"bottom",scaleY:0};else if(this.browserName!=="Apple Safari"){if(effectType==="SlideStripeRight")vars={scaleX:0};else if(effectType==="SlideStripeLeft")vars={transformOrigin:"100%",scaleX:0};else if(effectType==="SlideStripeBottom")vars={scaleY:0};else if(effectType==="SlideStripeTop")vars={transformOrigin:"bottom",scaleY:0};}else{if(effectType==="SlideStripeRight")vars={transformOrigin:"100%",scaleX:0};else if(effectType==="SlideStripeLeft")vars={transformOrigin:"100%",scaleX:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};else if(effectType==="SlideStripeBottom")vars={scaleY:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};else if(effectType==="SlideStripeTop")vars={transformOrigin:"bottom",scaleY:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};}if(vars!==undefined)this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].to(mask_rect+count,startTime/totalCount,vars),enterstart+count*startTime/totalCount);num++;}}else if(effectType==="stripe_Bottomleft"||effectType==="stripe_Bottomright"||effectType==="stripeRightTop"){for(count=totalCount;count>=0;count--){var _vars=void 0;if(effectType==="stripe_Bottomright")_vars={scaleX:0};else if(effectType==="stripe_Bottomleft")_vars={transformOrigin:"100%",scaleX:0};else if(effectType==="stripeRightTop")_vars={scaleY:0};if(_vars!==undefined)this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].to(mask_rect+count,startTime/totalCount,_vars),enterstart+num*startTime/totalCount);num++;}}}if(effectType==="stripe_Topright"||effectType==="SlideStripeRight"||effectType==="stripeTopLeft"||effectType==="SlideStripeLeft"||effectType==="stripe_Bottomleft"||effectType==="stripe_Bottomright")this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].from(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"multiHeight",effectType],opacity:1}),enterstart);else if(effectType==="stripeLeftBottom"||effectType==="SlideStripeBottom"||effectType==="stripeRightTop"||effectType==="stripeLeftTop"||effectType==="SlideStripeTop"||effectType==="stripeRightBottom")this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].from(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"multiWidth",effectType],opacity:1}),enterstart);}},{key:"irishExitHandler",value:function irishExitHandler(innerblock,startTime,exitstart,effectType,isChild){function onStartTween(blockId,type){if(!type)type="";var maskFound=this.maskExist(blockId,type);if(!maskFound){this.removeMask(blockId);this.addMask(blockId,type);}var mask_rect="#mask_"+blockId+"_rect";__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].set(mask_rect,{scale:1,transformOrigin:"50% 50%"});__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].set(innerblock,{scale:1,transformOrigin:"50% 50%"});if(effectType!=="SlideIrisSquare"&&effectType!=="SlideIrisCircle"||this.browserName!=="Apple Safari")this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].to(mask_rect,startTime,{scale:0,transformOrigin:"50% 50%"}),exitstart);else if(this.browserName==="Apple Safari"&&(effectType==="SlideIrisSquare"||effectType==="SlideIrisCircle"))this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].to(mask_rect,startTime,{scale:0,transformOrigin:"50% 50%",onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]}),exitstart);}if(effectType==="irishSquare"||effectType==="SlideIrisSquare")this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].from(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"irish"],opacity:1}),exitstart);else if(effectType==="irishCircle"||effectType==="SlideIrisCircle")this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].from(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"circle"],opacity:1}),exitstart);}},{key:"blindsExitHandler",value:function blindsExitHandler(innerblock,xval,yval,endTime,exitstart,effectType,scaleX,scaleY,opacity,isChild){if(scaleY===-1||scaleX===-1){if(effectType==="blindsTop"&&scaleY===-1)effectType="blindsBottom";else if(effectType==="blindsBottom"&&scaleY===-1)effectType="blindsTop";else if(effectType==="blindsRight"&&scaleX===-1)effectType="blindsLeft";else if(effectType==="blindsLeft"&&scaleX===-1)effectType="blindsRight";}function onStartTween(blockId,type){if(!type)type="";var maskFound=this.maskExist(blockId,type);if(!maskFound){this.removeMask(blockId);this.addMask(blockId,type);}var mask_rect="#mask_"+blockId+"_rect";__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].set(mask_rect,{opacity:1,transformOrigin:"50% 50%"});__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].set(innerblock,{opacity:opacity,transformOrigin:"50% 50%"});var totalCount=10;for(var count=0;count<totalCount;count++){var vars=void 0;if(effectType==="blindsLeft")vars={scaleX:0};else if(effectType==="blindsRight")vars={transformOrigin:"100%",scaleX:0};else if(effectType==="blindsTop")vars={scaleY:0};else if(effectType==="blindsBottom")vars={transformOrigin:"bottom",scaleY:0};else if(this.browserName!=="Apple Safari"){if(effectType==="SlideBlindsVerLeft")vars={scaleX:0};else if(effectType==="SlideBlindsVerRight")vars={transformOrigin:"100%",scaleX:0};else if(effectType==="SlideBlindsHorUp")vars={scaleY:0};else if(effectType==="SlideBlindsHorDown")vars={transformOrigin:"bottom",scaleY:0};}else{if(effectType==="SlideBlindsVerLeft")vars={scaleX:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};else if(effectType==="SlideBlindsVerRight")vars={transformOrigin:"100%",scaleX:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};else if(effectType==="SlideBlindsHorUp")vars={scaleY:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};else if(effectType==="SlideBlindsHorDown")vars={transformOrigin:"bottom",scaleY:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+type]};}if(vars!==undefined)this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].to(mask_rect+count,endTime,vars),exitstart);}}if(effectType==="blindsLeft"||effectType==="SlideBlindsVerLeft"||effectType==="blindsRight"||effectType==="SlideBlindsVerRight")this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].from(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"multiWidth"],opacity:1}),exitstart);else if(effectType==="blindsTop"||effectType==="SlideBlindsHorUp"||effectType==="blindsBottom"||effectType==="SlideBlindsHorDown")this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].from(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,"multiHeight"],opacity:1}),exitstart);}},{key:"wipeExitHandler",value:function wipeExitHandler(innerblock,startTime,exitstart,effectType,rotation,scaleX,scaleY,opacity,isChild){function onStartTween(blockId,type,rotation){var maskFound=this.maskExist(blockId,"");if(!maskFound){this.removeMask(blockId);this.addMask(blockId,"wipe","",rotation,scaleX,scaleY,"",!innerblock.classList.contains("scene-item"));}var mask_rect="#mask_"+blockId+"_rect";var idVal=document.getElementById(innerblock.id);var bboxVal=idVal.getBoundingClientRect();var offset=2;var yval=document.getElementById("mask_"+innerblock.id+"_rect").getAttribute("y");var xval=document.getElementById("mask_"+innerblock.id+"_rect").getAttribute("x");__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].set(mask_rect,{opacity:1,transformOrigin:"50% 50%"});__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].set(innerblock,{opacity:opacity,transformOrigin:"50% 50%"});var vars=void 0;if(type==="wipeTop")vars={attr:{y:parseFloat(yval)+(bboxVal.height+offset)*scaleY}};else if(type==="wipeDown")vars={attr:{y:parseFloat(yval)+(bboxVal.height+offset)*-scaleY}};else if(type==="wipeRight")vars={attr:{x:parseFloat(xval)+(bboxVal.width+offset)*-scaleX}};else if(type==="wipeLeft")vars={attr:{x:parseFloat(xval)+(bboxVal.width+offset)*scaleX}};else if(this.browserName!=="Apple Safari"){if(type==="WipeBottom")vars={attr:{y:parseFloat(yval)+bboxVal.height+offset}};else if(type==="WipeTop")vars={attr:{y:parseFloat(yval)+(bboxVal.height+offset)*-1}};else if(type==="WipeLeft")vars={attr:{x:parseFloat(xval)+(bboxVal.width+offset)*-1}};else if(type==="WipeRight")vars={attr:{x:parseFloat(xval)+(bboxVal.width+offset)}};}else{if(type==="WipeBottom")vars={attr:{y:parseFloat(yval)+bboxVal.height+offset},onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+"wipe"]};else if(type==="WipeTop")vars={attr:{y:parseFloat(yval)+(bboxVal.height+offset)*-1},onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+"wipe"]};else if(type==="WipeLeft")vars={attr:{x:parseFloat(xval)+(bboxVal.width+offset)*-1},onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+"wipe"]};else if(type==="WipeRight")vars={attr:{x:parseFloat(xval)+(bboxVal.width+offset)},onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+blockId+"wipe"]};}if(vars!==undefined)this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].to(mask_rect,startTime,vars),exitstart);}this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].from(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,effectType,rotation,opacity],opacity:opacity}),exitstart);}},{key:"circularRevealExitHandler",value:function circularRevealExitHandler(innerblock,startTime,effectType,time,scaleX,scaleY,opacity,isChild){var effectVars={};var clipPath=document.querySelector("#arcPath"+innerblock.id);var offsetWidthVal=document.getElementById(innerblock.id).offsetWidth;var offsetHeightVal=document.getElementById(innerblock.id).offsetHeight;if(scaleX===-1||scaleY===-1){if(effectType==="circularHideClockwise"&&scaleX===-1&&scaleY===1)effectType="circularHideAntiClockwise";else if(effectType==="circularHideClockwise"&&scaleX===1&&scaleY===-1)effectType="circularHideAntiClockwiseBottom";else if(effectType==="circularHideClockwise"&&scaleX===-1&&scaleY===-1)effectType="circularHideClockwiseBottom";else if(effectType==="circularHideAntiClockwise"&&scaleX===-1&&scaleY===1)effectType="circularHideClockwise";else if(effectType==="circularHideAntiClockwise"&&scaleX===1&&scaleY===-1)effectType="circularHideClockwiseBottom";else if(effectType==="circularHideAntiClockwise"&&scaleX===-1&&scaleY===-1)effectType="circularHideAntiClockwiseBottom";else if(effectType==="circularHideClockwiseRight"&&scaleX===-1&&scaleY===1)effectType="circularHideAntiClockwiseLeft";else if(effectType==="circularHideClockwiseRight"&&scaleX===1&&scaleY===-1)effectType="circularHideAntiClockwiseRight";else if(effectType==="circularHideClockwiseRight"&&scaleX===-1&&scaleY===-1)effectType="circularHideClockwiseLeft";else if(effectType==="circularHideAntiClockwiseRight"&&scaleX===-1&&scaleY===1)effectType="circularHideClockwiseLeft";else if(effectType==="circularHideAntiClockwiseRight"&&scaleX===1&&scaleY===-1)effectType="circularHideClockwiseRight";else if(effectType==="circularHideAntiClockwiseRight"&&scaleX===-1&&scaleY===-1)effectType="circularHideAntiClockwiseLeft";else if(effectType==="circularHideClockwiseLeft"&&scaleX===-1&&scaleY===1)effectType="circularHideAntiClockwiseRight";else if(effectType==="circularHideClockwiseLeft"&&scaleX===1&&scaleY===-1)effectType="circularHideAntiClockwiseLeft";else if(effectType==="circularHideClockwiseLeft"&&scaleX===-1&&scaleY===-1)effectType="circularHideClockwiseRight";else if(effectType==="circularHideAntiClockwiseLeft"&&scaleX===-1&&scaleY===1)effectType="circularHideClockwiseRight";else if(effectType==="circularHideAntiClockwiseLeft"&&scaleX===1&&scaleY===-1)effectType="circularHideClockwiseLeft";else if(effectType==="circularHideAntiClockwiseLeft"&&scaleX===-1&&scaleY===-1)effectType="circularHideAntiClockwiseRight";else if(effectType==="circularHideClockwiseBottom"&&scaleX===-1&&scaleY===1)effectType="circularHideAntiClockwiseBottom";else if(effectType==="circularHideClockwiseBottom"&&scaleX===1&&scaleY===-1)effectType="circularHideAntiClockwise";else if(effectType==="circularHideClockwiseBottom"&&scaleX===-1&&scaleY===-1)effectType="circularHideClockwise";else if(effectType==="circularHideAntiClockwiseBottom"&&scaleX===-1&&scaleY===1)effectType="circularHideClockwiseBottom";else if(effectType==="circularHideAntiClockwiseBottom"&&scaleX===1&&scaleY===-1)effectType="circularHideClockwise";else if(effectType==="circularHideAntiClockwiseBottom"&&scaleX===-1&&scaleY===-1)effectType="circularHideAntiClockwise";}var radiusVal=offsetWidthVal>offsetHeightVal?offsetWidthVal:offsetHeightVal;if(effectType==="circularHideAntiClockwise")effectVars={start:0,endEnter:360,endExit:0};else if(effectType==="circularHideClockwise"||effectType==="SlideCircularReveal")effectVars={start:360,endEnter:0,endExit:360};else if(effectType==="circularHideAntiClockwiseRight")effectVars={start:90,endEnter:this.projectHeight,endExit:90};else if(effectType==="circularHideClockwiseRight")effectVars={start:90,endEnter:-270,endExit:90};else if(effectType==="circularHideAntiClockwiseLeft")effectVars={start:270,endEnter:630,endExit:270};else if(effectType==="circularHideClockwiseLeft")effectVars={start:270,endEnter:-90,endExit:270};else if(effectType==="circularHideAntiClockwiseBottom")effectVars={start:180,endEnter:540,endExit:180};else if(effectType==="circularHideClockwiseBottom")effectVars={start:180,endEnter:-180,endExit:180};var arc={start:effectVars.start,end:effectVars.endEnter,cx:offsetWidthVal/2,cy:offsetHeightVal/2,r:radiusVal};function onStartTween(blockId,type){this.removeMask(innerblock.id);this.addMask(innerblock.id,"circularReveal");clipPath=document.querySelector("#arcPath"+innerblock.id);__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].set("arcPath"+innerblock.id,{opacity:1,transformOrigin:"50% 50%"});__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].set(innerblock,{opacity:opacity,transformOrigin:"50% 50%"});}if(effectType==="circularHideAntiClockwise"||effectType==="circularHideAntiClockwiseRight"||effectType==="circularHideAntiClockwiseLeft"||effectType==="circularHideAntiClockwiseBottom"){var updatePath=function updatePath(){if(clipPath!==null)clipPath.setAttribute("d",getPath(arc.cx,arc.cy,arc.r,arc.start,arc.end));};this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].to(arc,startTime,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,""],end:effectVars.endExit,ease:__WEBPACK_IMPORTED_MODULE_0_gsap__["d" /* Linear */].easeNone,onUpdate:updatePath}),time);}else if(effectType==="circularHideClockwise"||effectType==="SlideCircularReveal"||effectType==="circularHideClockwiseRight"||effectType==="circularHideClockwiseLeft"||effectType==="circularHideClockwiseBottom"){var _updatePath=function _updatePath(){if(effectType==="SlideCircularReveal"&&this.browserName==="Apple Safari")this.redrawClipPath(innerblock,"#mymask_"+innerblock.id+"circularReveal");if(clipPath!==null)clipPath.setAttribute("d",getPath(arc.cx,arc.cy,arc.r,arc.end,arc.start));};this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].to(arc,startTime,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id,""],end:effectVars.endExit,ease:__WEBPACK_IMPORTED_MODULE_0_gsap__["d" /* Linear */].easeNone,onUpdate:_updatePath.bind(this)}),time);}function getPath(cx,cy,r,a1,a2){var delta=a2-a1;if(delta===360){return"M "+(cx-r)+" "+cy+" a "+r+" "+r+" 0 1 0 "+r*2+" 0 a "+r+" "+r+" 0 1 0 "+-r*2+" 0z";}var largeArc=delta>180?1:0;a1=a1*Math.PI/180-Math.PI/2;a2=a2*Math.PI/180-Math.PI/2;var x1=cx+r*Math.cos(a2);var y1=cy+r*Math.sin(a2);var x2=cx+r*Math.cos(a1);var y2=cy+r*Math.sin(a1);return"M "+x1+" "+y1+" A "+r+" "+r+" 0 "+largeArc+" 0 "+x2+" "+y2+" L "+cx+" "+cy+"z";}}},{key:"brightSquareSlideEnterHandler",value:function brightSquareSlideEnterHandler(innerblock,startTime,enterstart){function onStartTween(blockId){var maskFound=this.maskExist(blockId,"slidesquare");if(!maskFound){this.removeMask(blockId);this.addMask(blockId,"slidesquare");}var mask_rect="#mask_"+innerblock.id+"_rect";__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].set(mask_rect,{scale:1,transformOrigin:"50% 50%"});__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].set(innerblock,{scale:1,transformOrigin:"50% 50%"});var totalCount=6;for(var count=0;count<totalCount;count++){for(var cnt=0;cnt<totalCount;cnt++){if(this.browserName!=="Apple Safari")this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].to(mask_rect+count+cnt,startTime,{transformOrigin:"50% 50%",scale:0}),enterstart);else this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].to(mask_rect+count+cnt,startTime,{transformOrigin:"50% 50%",scale:0,onUpdate:this.redrawClipPath,onUpdateParams:[innerblock,"#mymask_"+innerblock.id+"square"]}),enterstart);}}}this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].from(innerblock.id,0.1,{onStart:onStartTween.bind(this),onStartParams:[innerblock.id],opacity:1}),enterstart);}},{key:"previewScene",value:function previewScene(effectName){var workspaceBounds=document.getElementById("workspace").getElementsByClassName("scenes")[0].getBoundingClientRect();this.killTween;this.tween=new __WEBPACK_IMPORTED_MODULE_0_gsap__["f" /* TimelineMax */]({paused:true,opacity:1});document.getElementById("workspace").getElementsByClassName("scenes")[0].style.overflow="hidden";if(effectName==="SlideLeft"){this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].to(document.getElementById("workspace").getElementsByClassName("scenes")[0],1,{x:workspaceBounds.width*-1}),0);}else if(effectName==="SlideRight"){this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].to(document.getElementById("workspace").getElementsByClassName("scenes")[0],1,{x:workspaceBounds.width}),0);}else if(effectName==="SlideTop"){this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].to(document.getElementById("workspace").getElementsByClassName("scenes")[0],1,{y:workspaceBounds.height*-1}),0);}else if(effectName==="SlideBottom"){this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].to(document.getElementById("workspace").getElementsByClassName("scenes")[0],1,{y:workspaceBounds.height}),0);}else if(effectName==="SlideSplitVerticalOut"||effectName==="SlideSplitHorizontalOut"||effectName==="SlideSplitVerticalIn"||effectName==="SlideSplitHorizontalIn"||effectName==="SlideSplitMoveVer"||effectName==="SlideSplitMoveHor"){this.sceneSplitHandler(document.getElementById("workspace").getElementsByClassName("scenes")[0],0.8,0,effectName);}else if(effectName==="SlideStripeLeft"||effectName==="SlideStripeRight"||effectName==="SlideStripeBottom"||effectName==="SlideStripeTop"){this.stripeExitHandler(document.getElementById("workspace").getElementsByClassName("scenes")[0],0,0,0.8,0,effectName,1,1);}else if(effectName==="SlideIrisCircle"||effectName==="SlideIrisSquare"){this.irishExitHandler(document.getElementById("workspace").getElementsByClassName("scenes")[0],1,0,effectName);}else if(effectName==="SlideBlindsVerLeft"||effectName==="SlideBlindsVerRight"||effectName==="SlideBlindsHorDown"||effectName==="SlideBlindsHorUp"){this.blindsExitHandler(document.getElementById("workspace").getElementsByClassName("scenes")[0],0,0,0.8,0,effectName,1,1);}else if(effectName==="WipeLeft"||effectName==="WipeTop"||effectName==="WipeRight"||effectName==="WipeBottom"){this.wipeExitHandler(document.getElementById("workspace").getElementsByClassName("scenes")[0],0.8,0,effectName,0,1,1);}else if(effectName==="SlideCircularReveal"){this.circularRevealExitHandler(document.getElementById("workspace").getElementsByClassName("scenes")[0],0.8,effectName,0,1,1);}else if(effectName==="SlideFade"){this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].fromTo(document.getElementById("workspace").getElementsByClassName("scenes")[0],0,{opacity:1},{opacity:0}),0.5);this.tween.add(__WEBPACK_IMPORTED_MODULE_0_gsap__["g" /* TweenMax */].fromTo(document.getElementById("workspace").getElementsByClassName("scenes")[0],0.5,{opacity:0},{opacity:1}),1);}else if(effectName==="SlideBrightSquare"){this.brightSquareSlideEnterHandler(document.getElementById("workspace").getElementsByClassName("scenes")[0],0.8,0);}this.tween.eventCallback("onComplete",function(ev,e){ev.removeMask(document.getElementById("workspace").getElementsByClassName("scenes")[0].id);document.getElementById("workspace").getElementsByClassName("scenes")[0].style.transform="none";document.getElementById("workspace").getElementsByClassName("scenes")[0].style.clipPath="unset";document.getElementById("workspace").getElementsByClassName("scenes")[0].style.transformOrigin="initial";document.getElementById("workspace").getElementsByClassName("scenes")[0].style.overflow="unset";e.pause(0);ev.killTween;},[this,"{self}"]).play();return false;}},{key:"killTween",value:function killTween(){this.tween.kill();this.tween.eventCallback("onComplete",null);this.tween.eventCallback("onUpdate",null);this.tween.eventCallback("onStart",null);this.tween.clear();}}]);return PreviewEffects;}();/* harmony default export */ __webpack_exports__["a"] = (PreviewEffects);function spontaneousFilters(selectedItems,selectedScene,svgFilterItem,presetName,changingValues,inputValue,type){var brightness=0;var contrast=0;var hue=0;var saturate=void 0;var tint=void 0;var blur=void 0;var vignette=0;if(type==="intensity"){var FilterValues=changingValues[presetName];// console.log({...FilterValues});
brightness=FilterValues.bright*(inputValue/100)>100?100:FilterValues.bright*(inputValue/100)<-100?-100:FilterValues.bright*(inputValue/100);contrast=FilterValues.contrast*(inputValue/100)>100?100:FilterValues.contrast*(inputValue/100)<-100?-100:FilterValues.contrast*(inputValue/100);hue=FilterValues.hue*(inputValue/100)>100?100:FilterValues.hue*(inputValue/100)<-100?-100:FilterValues.hue*(inputValue/100);saturate=FilterValues.saturate*(inputValue/100)>100?100:FilterValues.saturate*(inputValue/100)<-100?-100:FilterValues.saturate*(inputValue/100);tint=inputValue===0?0:FilterValues.tint;blur=FilterValues.blur*(inputValue/100)>100?100:FilterValues.blur*(inputValue/100)<-100?-100:FilterValues.blur*(inputValue/100);vignette=FilterValues.vignette*(inputValue/100)>100?100:FilterValues.vignette*(inputValue/100)<-100?-100:FilterValues.vignette*(inputValue/100);}else if(type==="bright"){brightness=inputValue;}else if(type==="contrast"){contrast=inputValue;}else if(type==="hue"){hue=inputValue;}else if(type==="saturate"){saturate=inputValue;}else if(type==="tint"){tint=inputValue;}else if(type==="blur"){blur=inputValue;}else if(type==="vignette"){vignette=inputValue;}if(brightness!==0){svgFilterItem.getElementById("RbrightnessSVG").setAttribute("intercept",brightness/200);svgFilterItem.getElementById("GbrightnessSVG").setAttribute("intercept",brightness/200);svgFilterItem.getElementById("BbrightnessSVG").setAttribute("intercept",brightness/200);}if(contrast!==0){svgFilterItem.getElementById("RcontrastSVG").setAttribute("slope",contrast<0?(contrast+100)*0.006+0.4:contrast*1.5/100+1);svgFilterItem.getElementById("GcontrastSVG").setAttribute("slope",contrast<0?(contrast+100)*0.006+0.4:contrast*1.5/100+1);svgFilterItem.getElementById("BcontrastSVG").setAttribute("slope",contrast<0?(contrast+100)*0.006+0.4:contrast*1.5/100+1);svgFilterItem.getElementById("RcontrastSVG").setAttribute("intercept",contrast>0?-(contrast*75/100/100):-(contrast*30/100)/100);svgFilterItem.getElementById("GcontrastSVG").setAttribute("intercept",contrast>0?-(contrast*75/100/100):-(contrast*30/100)/100);svgFilterItem.getElementById("BcontrastSVG").setAttribute("intercept",contrast>0?-(contrast*75/100/100):-(contrast*30/100)/100);}if(hue!==0){svgFilterItem.getElementById("HueSVG").setAttribute("values",hue);}if(saturate!==0&&saturate!==undefined){// svgFilterItem.getElementById("saturateSVG").setAttribute("values", ( saturate + 100 ) * 2 / 100)
// console.log(saturate);
var filterValue=[(saturate+100)*(1.6914-0.3086)/200+0.3086,(saturate+100)*(-0.6094-0.6094)/200+0.6094,(saturate+100)*(-0.082-0.082)/200+0.082,0,0,(saturate+100)*(-0.3086-0.3086)/200+0.3086,(saturate+100)*(1.3906-0.6094)/200+0.6094,(saturate+100)*(-0.082-0.082)/200+0.082,0,0,(saturate+100)*(-0.3086-0.3086)/200+0.3086,(saturate+100)*(-0.6094-0.6094)/200+0.6094,(saturate+100)*(1.918-0.082)/200+0.082,0,0,0,0,0,1,0].join(',');svgFilterItem.getElementById("saturateSVG").setAttribute("values",filterValue);}else if(saturate===0){// svgFilterItem.getElementById("saturateSVG").setAttribute("values", 2)
svgFilterItem.getElementById("saturateSVG").removeAttribute("values");}var feFuncR=svgFilterItem.getElementById("RtintSVG");var feFuncG=svgFilterItem.getElementById("GtintSVG");var feFuncB=svgFilterItem.getElementById("BtintSVG");if(tint!==0&&tint!==undefined){feFuncR.setAttribute("slope",0.9);feFuncG.setAttribute("slope",0.9);feFuncB.setAttribute("slope",0.9);if(tint>0&&tint<=33){feFuncR.setAttribute("intercept",0);feFuncG.setAttribute("intercept",0.1);feFuncB.setAttribute("intercept",tint/330);}else if(tint>33&&tint<66){feFuncR.setAttribute("intercept",0);feFuncG.setAttribute("intercept",(33-tint%33)/330);feFuncB.setAttribute("intercept",0.1);}else if(tint>=66){feFuncR.setAttribute("intercept",(tint-66)/330);feFuncG.setAttribute("intercept",0);feFuncB.setAttribute("intercept",0.1);}else if(tint<0&&tint>=-33){feFuncR.setAttribute("intercept",-(tint/330));feFuncG.setAttribute("intercept",0.1);feFuncB.setAttribute("intercept",0);}else if(tint<-33&&tint>-66){feFuncR.setAttribute("intercept",0.1);feFuncG.setAttribute("intercept",(33- -tint%33)/330);feFuncB.setAttribute("intercept",0);}else if(tint<=-66){feFuncR.setAttribute("intercept",0.1);feFuncG.setAttribute("intercept",0);feFuncB.setAttribute("intercept",-((tint+66)/330));}}else if(tint===0){feFuncR.removeAttribute("slope");feFuncG.removeAttribute("slope");feFuncB.removeAttribute("slope");feFuncR.removeAttribute("intercept");feFuncG.removeAttribute("intercept");feFuncB.removeAttribute("intercept");}if(blur!==0&&blur!==undefined){if(blur>0){svgFilterItem.getElementsByTagName("feGaussianBlur")[0].setAttribute('stdDeviation',blur*3/10);svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('operator');svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('k1');svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('k2');svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('k3');svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('k4');svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('in2');}else if(blur<0){svgFilterItem.getElementsByTagName("feGaussianBlur")[0].setAttribute('stdDeviation',1);svgFilterItem.getElementsByTagName("feComposite")[0].setAttribute('operator',"arithmetic");svgFilterItem.getElementsByTagName("feComposite")[0].setAttribute('k1',0);svgFilterItem.getElementsByTagName("feComposite")[0].setAttribute('k2',blur*6/100);svgFilterItem.getElementsByTagName("feComposite")[0].setAttribute('k3',blur*6/100*-1+1);svgFilterItem.getElementsByTagName("feComposite")[0].setAttribute('k4',0);svgFilterItem.getElementsByTagName("feComposite")[0].setAttribute('in2',"preblur");}}else if(blur===0){svgFilterItem.getElementsByTagName("feGaussianBlur")[0].setAttribute('stdDeviation',0);svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('operator');svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('k1');svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('k2');svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('k3');svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('k4');svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('in2');}if(vignette!==0){if(selectedItems.size>0){var vignetteId=selectedItems.get(0)+"-vignette-"+selectedScene;document.getElementById(vignetteId).style.backgroundImage="radial-gradient(circle farthest-side at center center, rgba(0, 0, 0, 0) 70%, rgba(0, 0, 0, "+vignette*0.007+") 130%)";}else if(selectedItems.size===0){var _vignetteId="ws-vignette-"+selectedScene;document.getElementById(_vignetteId).style.backgroundImage="radial-gradient(circle farthest-side at center center, rgba(0, 0, 0, 0) 70%, rgba(0, 0, 0, "+vignette*0.007+") 130%)";}}}

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CropComponent__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_index__ = __webpack_require__(10);
//import { updateAudioDuration } from "../actions/index"
var mapStateToProps=function mapStateToProps(state,ownProps){return{selectedScene:state.localStore.get('selectedScene'),selectedItems:state.localStore.get('selectedItems'),cropItem:state.project.getIn(["scenes",state.localStore.get('selectedScene'),"workspaceItems",state.localStore.getIn(['selectedItems',0])]),bgFilter:state.project.getIn(["scenes",state.localStore.get('selectedScene'),"bgFilter"]),currentSceneItems:state.project.getIn(['scenes',state.localStore.get('selectedScene')]),videoItem:state.localStore.get('isVideoCropping')?state.project.getIn(["videos",state.localStore.get('cropVideoId')]):null,workspaceWidth:state.project.get('width'),workspaceHeight:state.project.get('height'),workspaceBounds:state.localStore.get("workspaceBounds"),zoomFactor:state.localStore.get('zoomFactor'),isCropping:state.localStore.get('isCropping'),isFraming:state.localStore.get('isFraming'),isBgCropping:state.localStore.get('isBgCropping'),isVideoCropping:state.localStore.get('isVideoCropping'),videoId:state.localStore.get('cropVideoId'),projectType:state.project.get('width')>state.project.get('height')?"hor":state.project.get('width')<state.project.get('height')?"ver":"sqr"};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{cropImage:function cropImage(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["O" /* cropImage */])(data,socket));},cropBG:function cropBG(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["M" /* cropBG */])(data,socket));},toggleCrop:function toggleCrop(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_68" /* toggleCrop */])(data));},toggleBgCrop:function toggleBgCrop(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_67" /* toggleBgCrop */])(data));},toggleFrame:function toggleFrame(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_69" /* toggleFrame */])(data));},toggleVideoCrop:function toggleVideoCrop(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_71" /* toggleVideoCrop */])(data));},nextBtnClicked:function nextBtnClicked(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_14" /* nextBtnClicked */])(data));},updateTourArea:function updateTourArea(data){dispatch(dispatch({type:"UPDATE_TOUR_AREA",data:{}}));}};};var Crop=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps,null,{withRef:true})(__WEBPACK_IMPORTED_MODULE_1__components_CropComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Crop);

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_app_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_WorkspaceComponent__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RenderSvg=function(_React$Component){_inherits(RenderSvg,_React$Component);function RenderSvg(props){_classCallCheck(this,RenderSvg);var _this=_possibleConstructorReturn(this,(RenderSvg.__proto__||Object.getPrototypeOf(RenderSvg)).call(this,props));_this.appUrl=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a['APPICONS'][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a['APPICONS']['current']];_this.assetUrl=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["ASSETS"][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["ASSETS"]["current"]];_this.state={svgElement:null,imgElement:null};return _this;}_createClass(RenderSvg,[{key:'componentWillMount',value:function componentWillMount(){var svgSource=this.assetUrl+this.props.config[this.props.data.get('type')][this.props.config[this.props.data.get('type')][this.props.data.get('subType')?'workspace_'+this.props.data.get('subType'):'workspace']]+this.props.data.get("src");var imgSource=void 0;if(this.props.data.get('imageSource')&&this.props.data.get('imageSource')!==""){imgSource=this.props.config[this.props.data.get('imageType')][this.props.config[this.props.data.get('imageType')][this.props.data.get('imageSubType')?'workspace_'+this.props.data.get('imageSubType'):'workspace']]+this.props.data.get('imageSource');}else{imgSource="/assets/maskcover.png";}this.setState({imgElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'element',src:this.appUrl+imgSource})});__WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'GET',url:svgSource,mode:'cors',withCredentials:false,credentials:'same-origin',headers:{'Accept':'application/json','Access-Control-Allow-Origin':'*','Content-Type':'image/svg+xml'},data:{}}).then(function(res){var _this2=this;res.request.responseXML.documentElement.getElementsByTagName("clipPath")[0].setAttribute("id","clip-"+this.props.id);var svgData=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:this.props.id,ref:function ref(instance){return _this2.frameContainer=instance;},className:"scene-item-inner pointer-events-none",id:this.props.id+"inner",style:{width:"100%",height:"100%",position:"absolute"},'data-id':this.props.id,dangerouslySetInnerHTML:{__html:res.request.responseXML.documentElement.outerHTML}});this.setState({svgElement:svgData});}.bind(this)).catch(function(error){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])("Frames source failed to load ",error,"CropComponent-componentWillMount");});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){return this.state.svgElement;}}]);return RenderSvg;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function updateTourArea(){var currentElm=document.querySelector(".unCroppedBox-wrapper");if(currentElm){var docHeight=document.documentElement.offsetHeight,docWidth=document.documentElement.offsetWidth,width=currentElm.getBoundingClientRect().width,height=currentElm.getBoundingClientRect().height,posLeft=currentElm.getBoundingClientRect().left,posRight=docWidth-(posLeft+width),posTop=currentElm.getBoundingClientRect().top,posBottom=docHeight-(posTop+height);}}var CropComponent=function(_React$Component2){_inherits(CropComponent,_React$Component2);function CropComponent(props){_classCallCheck(this,CropComponent);var _this3=_possibleConstructorReturn(this,(CropComponent.__proto__||Object.getPrototypeOf(CropComponent)).call(this,props));_this3.state={cropSelectionBox:{},unCroppedBox:{},cropBox:{},cropImage:{},image:null};_this3.moveSelection=_this3.moveSelection.bind(_this3);_this3.stopMove=_this3.stopMove.bind(_this3);_this3.resizeCropSelection=_this3.resizeCropSelection.bind(_this3);_this3.stopCropResize=_this3.stopCropResize.bind(_this3);_this3.resizeSelection=_this3.resizeSelection.bind(_this3);_this3.stopResize=_this3.stopResize.bind(_this3);_this3.getUnCroppedXY=_this3.getUnCroppedXY.bind(_this3);_this3.getMousePosition=_this3.getMousePosition.bind(_this3);_this3.getUnCroppedResizePosition=_this3.getUnCroppedResizePosition.bind(_this3);_this3.resetCrop=_this3.resetCrop.bind(_this3);_this3.mouseStartPosition={x:null,y:null,offsetX:null,offsetY:null};_this3.lastDown=null;_this3.moved=false;_this3.xLocked=false;_this3.lockedX=null;_this3.yLocked=false;_this3.lockedY=null;_this3.heightLocked=false;_this3.lockedHeight=null;_this3.widthLocked=false;_this3.lockedWidth=null;_this3.appUrl=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a['APPICONS'][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a['APPICONS']['current']];_this3.assetUrl=__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["ASSETS"][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["ASSETS"]["current"]];return _this3;}_createClass(CropComponent,[{key:'componentWillMount',value:function componentWillMount(){var stateToUpdate={};var cropItem=this.props.cropItem,config=this.props.config;var cropX=void 0,cropY=void 0,cropWidth=void 0,cropHeight=void 0,selectionX=void 0,selectionY=void 0,selectionWidth=void 0,selectionHeight=void 0,imgSrc=void 0,angle=0,unCroppedX=void 0,unCroppedY=void 0,cropImageX=void 0,cropImageY=void 0;if(this.props.isCropping||this.props.isFraming){if(cropItem.get("isCropped")||this.props.isFraming){selectionX=cropItem.get("x")+cropItem.getIn(["original","x"])*cropItem.get("width");selectionY=cropItem.get("y")+cropItem.getIn(["original","y"])*cropItem.get("height");selectionWidth=cropItem.getIn(["original","width"])*cropItem.get("width");selectionHeight=cropItem.getIn(["original","height"])*cropItem.get("height");cropWidth=cropItem.get("width");cropHeight=cropItem.get("height");cropX=cropItem.get("x")-selectionX;cropY=cropItem.get("y")-selectionY;}else{selectionX=cropItem.get("x");selectionY=cropItem.get("y");selectionWidth=cropItem.get("width");selectionHeight=cropItem.get("height");cropWidth=cropItem.get("width")*0.75;cropHeight=cropItem.get("height")*0.75;if(this.props.isFraming){cropWidth=cropItem.get("width");cropHeight=cropItem.get("height");}cropX=cropItem.get("width")/2-cropWidth/2;cropY=cropItem.get("height")/2-cropHeight/2;}var dX=0,dY=0;if(cropItem.get("flipPosition")===1){dX=cropX-(selectionWidth-(cropX+cropWidth));}else if(cropItem.get("flipPosition")===2){dY=cropY-(selectionHeight-(cropY+cropHeight));}else if(cropItem.get("flipPosition")===3){dX=cropX-(selectionWidth-(cropX+cropWidth));dY=cropY-(selectionHeight-(cropY+cropHeight));}unCroppedX=dX;unCroppedY=dY;cropImageX=-1*cropX+dX;cropImageY=-1*cropY+dY;if(this.props.isCropping){imgSrc=this.assetUrl+config[cropItem.get('type')][config[cropItem.get('type')][cropItem.get('subType')?'workspace_'+cropItem.get('subType'):'workspace']]+cropItem.get("src");if(cropItem.get('subType')==="GIPHY")imgSrc=config[cropItem.get("subType")][config[cropItem.get("subType")]['workspace']]+cropItem.get("src");if(cropItem.get('type')==="STOCKIMG")imgSrc=config[cropItem.get("type")][config[cropItem.get("type")]['workspace']]+cropItem.get("src");else if(cropItem.get('type')==="UPLOADS"&&cropItem.get("subType")==="UPIMAGE"){if(cropItem.get('isBlob')){imgSrc=cropItem.get("src");}else{imgSrc=config["UPLOADS"][config["UPLOADS"]["workspace_UPIMAGE"]]+cropItem.get("src");}}else if(cropItem.get('type')==='IMG'&&cropItem.get('subType')==='OBGIMG'){imgSrc=this.assetUrl+config['BG']['obgsrc']+cropItem.get('src');}}else{if(this.props.cropItem.get('imageSource')&&this.props.cropItem.get('imageSource')!==""){imgSrc=this.assetUrl+this.props.config[this.props.cropItem.get('imageType')][this.props.config[this.props.cropItem.get('imageType')][this.props.cropItem.get('imageSubType')?'workspace_'+this.props.cropItem.get('imageSubType'):'workspace']]+this.props.cropItem.get('imageSource');}else{imgSrc="/assets/maskcover.png";}}angle=cropItem.get("angle");stateToUpdate.type=cropItem.get("type");}else if(this.props.isBgCropping){var workspaceBG=this.props.currentSceneItems.get("workspaceBG");selectionX=workspaceBG.get("x")*this.props.workspaceWidth;selectionY=workspaceBG.get("y")*this.props.workspaceHeight;selectionWidth=workspaceBG.get("width")*this.props.workspaceWidth;selectionHeight=workspaceBG.get("height")*this.props.workspaceHeight;cropWidth=this.props.workspaceWidth;cropHeight=this.props.workspaceHeight;cropX=-selectionX;cropY=-selectionY;unCroppedX=0;unCroppedY=0;cropImageX=-1*cropX;cropImageY=-1*cropY;var bgType=workspaceBG.get("type");if(bgType==="STOCKIMG"||bgType==="GIPHY"){imgSrc=workspaceBG.get("src");}else if(workspaceBG.get('type')==='VIDEO'&&workspaceBG.get('subType')==='OBGVID'){imgSrc=this.assetUrl+config['BG']['obgsrc']+workspaceBG.get("thumbnail");}else if(workspaceBG.get('type')==='IMG'&&workspaceBG.get('subType')==='OBGIMG'){imgSrc=this.assetUrl+config['BG']['obgsrc']+workspaceBG.get('src');}else if(bgType==="STOCKVID"){imgSrc=config[bgType][config[bgType]["edit"]]+workspaceBG.get("thumbnail");}else if(bgType!=="UPLOADS"){if(bgType==='UPVIDEO'){imgSrc=config['UPLOADS'][config['UPLOADS']['onload_UPVIDEO']]+workspaceBG.get("thumbnail");if(workspaceBG.get("isBlob")){imgSrc=workspaceBG.get("thumbnail");}}else if(bgType==='UPIMAGE'){if(workspaceBG.get('isBlob')){imgSrc=workspaceBG.get("src");}else{imgSrc=config["UPLOADS"][config["UPLOADS"]["workspace_UPIMAGE"]]+workspaceBG.get("src");}}else imgSrc=this.assetUrl+config[bgType][config[bgType]["workspace"]]+workspaceBG.get("src");}if(bgType==="BG")stateToUpdate.type="BG";}else{var bgScales=this.props.videoItem.get("bgScales");if(bgScales===undefined)bgScales=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({x:0,y:0,width:1,height:1});selectionX=bgScales.get("x")*this.props.workspaceWidth;selectionY=bgScales.get("y")*this.props.workspaceHeight;selectionWidth=bgScales.get("width")*this.props.workspaceWidth;selectionHeight=bgScales.get("height")*this.props.workspaceHeight;cropWidth=this.props.workspaceWidth;cropHeight=this.props.workspaceHeight;cropX=-selectionX;cropY=-selectionY;unCroppedX=0;unCroppedY=0;cropImageX=-1*cropX;cropImageY=-1*cropY;if(this.props.videoItem.get("type")==="UPVIDEO"){imgSrc=config['UPLOADS'][config['UPLOADS']['workspace_UPVIDEO']]+this.props.videoItem.get("src");}else{imgSrc=config['BG'][config['BG']['workspace_VIDEO']]+this.props.videoItem.get("src");}stateToUpdate.type="VIDEO";}stateToUpdate.cropSelectionBox={x:selectionX,y:selectionY,width:selectionWidth,height:selectionHeight,angle:angle};stateToUpdate.cropBox={x:cropX,y:cropY,width:cropWidth,height:cropHeight};stateToUpdate.cropImage={x:cropImageX,y:cropImageY,width:selectionWidth,height:selectionHeight};stateToUpdate.unCroppedBox={x:unCroppedX,y:unCroppedY,width:selectionWidth,height:selectionHeight};stateToUpdate.image=imgSrc;this.setState(stateToUpdate);}},{key:'updateCropToolBar',value:function updateCropToolBar(){var stageLeft=document.getElementsByClassName("app-lib-container")[0].offsetWidth+10;if(document.getElementsByClassName("lib-showBlock").length>0)stageLeft+=document.getElementsByClassName("lib-showBlock")[0].offsetWidth;var stageTop=document.getElementsByClassName("app-menu")[0].offsetHeight+25;//var stageBottom = document.getElementsByClassName("player-control-container")[0].offsetTop - 25;
var stageRight=document.documentElement.clientWidth-10;var bounds=document.getElementsByClassName("unCroppedBox")[0].getBoundingClientRect();var toolBarX=bounds.x,toolBarY=bounds.y,toolBar=document.getElementById("crop-handle-bar");if(toolBarX<stageLeft)toolBarX=stageLeft;if(bounds.x+toolBar.offsetWidth>stageRight)toolBarX=stageRight-toolBar.offsetWidth;if(toolBarY<stageTop){toolBarY=bounds.y+bounds.height+42;if(toolBarY>window.screen.height)toolBarY=stageTop+42;}var getWorkspaceBounds=this.getWorkspaceBounds();var toolX=toolBarX-getWorkspaceBounds.x,toolY=toolBarY-getWorkspaceBounds.y;if(!this.props.isBgCropping){document.getElementById("crop-handle-bar").style.left=toolX+"px";document.getElementById("crop-handle-bar").style.top=toolY-60+"px";}document.getElementById("crop-handle-bar").style.display="block";}},{key:'getWorkspaceBounds',value:function getWorkspaceBounds(){var workspace=document.getElementById('workspace');return{x:workspace.offsetLeft,y:workspace.offsetTop,width:workspace.offsetWidth,height:workspace.offsetHeight};}},{key:'setCursor',value:function setCursor(e,action){try{var cursor="";if(action==="move"){document.getElementById('workspace').style.cursor='url(/assets/icons/move.png) 12 12, auto';}else if(action==="resize"||action==="rotate"){var workspace_bounds=this.getWorkspaceBounds(),handle=e.target.getAttribute('data-handle'),x=e.pageX-workspace_bounds.x,y=e.pageY-workspace_bounds.y,cx=this.state.cropSelectionBox.x+this.state.cropSelectionBox.width/2*this.props.zoomFactor,cy=this.state.cropSelectionBox.y+this.state.cropSelectionBox.height/2*this.props.zoomFactor,dx=Math.abs(x-cx),dy=Math.abs(y-cy),angle=Math.abs(this.state.cropSelectionBox.angle);var closeX=dx<dy;var quarter=x<cx&&y<cy?1:x>cx&&y<cy?2:x>cx&&y>cy?3:4;if(angle>180)angle=angle%180;var sloped=angle>=22.5&&angle<=67.5||angle>=122.5&&angle<=150;var handle_for="scale";if(action==="rotate")handle_for="rotate";if(handle==="top-left"||handle==="top-right"||handle==="bottom-right"||handle==="bottom-left"){cursor=quarter===1?sloped?closeX?"-y-t":"-x-l":"-t-l":quarter===2?sloped?closeX?"-y-t":"-x-r":"-t-r":quarter===3?sloped?closeX?"-y-b":"-x-r":"-b-r":quarter===4?sloped?closeX?"-y-b":"-x-l":"-b-l":"";cursor=handle_for+cursor;}else if(handle==="top"||handle==="right"||handle==="bottom"||handle==="left"){cursor=quarter===2||quarter===4?closeX?sloped?"-t-r":"-y-t":sloped?"-t-r":"-x-r":!closeX?sloped?"-t-l":"-x-l":sloped?"-t-l":"-y-b";cursor="scale"+cursor;}document.getElementById('workspace').style.cursor='url(/assets/icons/'+cursor+'.png) 12 12, auto';}else{this.resetCursor(e);}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CropComponent-setCursor");}}},{key:'resetCursor',value:function resetCursor(e){try{document.getElementById('workspace').style.cursor='default';}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CropComponent-resetCursor");}}},{key:'getMousePosition',value:function getMousePosition(e){try{var currentX=e.clientX-document.getElementById('workspace').offsetLeft,currentY=e.clientY-document.getElementById('workspace').offsetTop;return{x:currentX,y:currentY};}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CropComponent-getMousePosition");}}},{key:'initiateMove',value:function initiateMove(e){try{e.preventDefault();e.stopPropagation();this.lastDown=e.timeStamp;this.moved=false;var mouse_position=this.getMousePosition(e);this.mouseStartPosition=Object.assign(this.mouseStartPosition,{x:mouse_position.x,y:mouse_position.y});var unCroppedBox=Object.assign({},this.state.unCroppedBox);this.setState({unCroppedBox:Object.assign(unCroppedBox,{transforming:true})});window.addEventListener('mousemove',this.moveSelection,false);window.addEventListener('mouseup',this.stopMove,false);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CropComponent-initiateMove");}}},{key:'getUnCroppedXY',value:function getUnCroppedXY(e){try{var mouse_position=this.getMousePosition(e);var x=this.state.unCroppedBox.x-(this.mouseStartPosition.x-mouse_position.x)/this.props.zoomFactor;var y=this.state.unCroppedBox.y-(this.mouseStartPosition.y-mouse_position.y)/this.props.zoomFactor;var projectType=this.props.projectType;var videoType=this.state.unCroppedBox.width.toFixed(2)>this.state.unCroppedBox.height.toFixed(2)?"hor":this.state.unCroppedBox.width.toFixed(2)<this.state.unCroppedBox.height.toFixed(2)?"ver":"sqr";if(projectType==="sqr")projectType=this.state.unCroppedBox.width.toFixed(2)>this.state.unCroppedBox.height.toFixed(2)?"ver":this.state.unCroppedBox.width.toFixed(2)<this.state.unCroppedBox.height.toFixed(2)?"hor":"sqr";if(x>=this.state.cropBox.x&&(projectType!=="hor"&&videoType!==this.props.projectType||this.props.isCropping))x=this.state.cropBox.x;if(y>=this.state.cropBox.y&&(projectType!=="ver"&&videoType!==this.props.projectType||this.props.isCropping))y=this.state.cropBox.y;if(x+this.state.unCroppedBox.width<=this.state.cropBox.x+this.state.cropBox.width&&(projectType!=="hor"&&videoType!==this.props.projectType||this.props.isCropping))x=this.state.cropBox.x+this.state.cropBox.width-this.state.unCroppedBox.width;if(y+this.state.unCroppedBox.height<=this.state.cropBox.y+this.state.cropBox.height&&(projectType!=="ver"&&videoType!==this.props.projectType||this.props.isCropping))y=this.state.cropBox.y+this.state.cropBox.height-this.state.unCroppedBox.height;if(x>=this.state.cropBox.x+this.state.cropBox.width){x=this.state.cropBox.x+this.state.cropBox.width;}if(x+this.state.unCroppedBox.width<=this.state.cropBox.x){x=this.state.cropBox.x-this.state.unCroppedBox.width;}if(y>=this.state.cropBox.y+this.state.cropBox.height){y=this.state.cropBox.y+this.state.cropBox.height;}if(y+this.state.unCroppedBox.height<=this.state.cropBox.y){y=this.state.cropBox.y-this.state.unCroppedBox.height;}return{x:x,y:y};}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CropComponent-getUnCroppedXY");}}},{key:'moveSelection',value:function moveSelection(e){try{if(this.lastDown+10<e.timeStamp){if(!this.moved)this.moved=true;e.preventDefault();var XY=this.getUnCroppedXY(e);this.unCroppedBoxElement.style.transform="translate("+XY.x*this.props.zoomFactor+"px, "+XY.y*this.props.zoomFactor+"px)";var flip=this.getFlipPosition();var angle=this.getAngle();if(this.state.type!=="BG")this.cropImageElem.style.transform="translate("+(this.state.cropImage.x+(XY.x-this.state.unCroppedBox.x))*this.props.zoomFactor+"px, "+(this.state.cropImage.y+(XY.y-this.state.unCroppedBox.y))*this.props.zoomFactor+"px) rotate("+angle+"deg)"+flip;else{document.getElementById("crop-bg"+this.props.selectedScene+"inner").style.transform="translate("+(this.state.cropImage.x+(XY.x-this.state.unCroppedBox.x))*this.props.zoomFactor+"px, "+(this.state.cropImage.y+(XY.y-this.state.unCroppedBox.y))*this.props.zoomFactor+"px) rotate("+angle+"deg)"+flip;}}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CropComponent-moveSelection");}}},{key:'stopMove',value:function stopMove(e){try{e.preventDefault();e.stopPropagation();var unCroppedBox=Object.assign({},this.state.unCroppedBox);var cropImage=Object.assign({},this.state.cropImage);if(this.moved){var XY=this.getUnCroppedXY(e);cropImage=Object.assign(cropImage,{x:this.state.cropImage.x+(XY.x-this.state.unCroppedBox.x),y:this.state.cropImage.y+(XY.y-this.state.unCroppedBox.y)});unCroppedBox=Object.assign(unCroppedBox,{x:XY.x,y:XY.y});}unCroppedBox.transforming=false;this.setState({unCroppedBox:unCroppedBox,cropImage:cropImage});window.removeEventListener('mousemove',this.moveSelection,false);window.removeEventListener('mouseup',this.stopMove,false);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CropComponent-stopMove");}}},{key:'getCropBoxPosition',value:function getCropBoxPosition(e){try{var mouse_position=this.getMousePosition(e);var dx=(mouse_position.x-this.mouseStartPosition.x)/this.props.zoomFactor,dy=(mouse_position.y-this.mouseStartPosition.y)/this.props.zoomFactor;var cropX=void 0,cropY=void 0,cropWidth=void 0,cropHeight=void 0;if(this.state.cropBox.handle==="top-left"){cropX=this.state.cropBox.x+dx;cropY=this.state.cropBox.y+dy;cropWidth=this.state.cropBox.width-dx;cropHeight=this.state.cropBox.height-dy;}else if(this.state.cropBox.handle==="top-right"){cropX=this.state.cropBox.x;cropY=this.state.cropBox.y+dy;cropWidth=this.state.cropBox.width+dx;cropHeight=this.state.cropBox.height-dy;}else if(this.state.cropBox.handle==="bottom-right"){cropX=this.state.cropBox.x;cropY=this.state.cropBox.y;cropWidth=this.state.cropBox.width+dx;cropHeight=this.state.cropBox.height+dy;}else if(this.state.cropBox.handle==="bottom-left"){cropX=this.state.cropBox.x+dx;cropY=this.state.cropBox.y;cropWidth=this.state.cropBox.width-dx;cropHeight=this.state.cropBox.height+dy;}else if(this.state.cropBox.handle==="left"){cropX=this.state.cropBox.x+dx;cropWidth=this.state.cropBox.width-dx;cropY=this.state.cropBox.y;cropHeight=this.state.cropBox.height;}else if(this.state.cropBox.handle==="top"){cropX=this.state.cropBox.x;cropY=this.state.cropBox.y+dy;cropWidth=this.state.cropBox.width;cropHeight=this.state.cropBox.height-dy;}else if(this.state.cropBox.handle==="right"){cropX=this.state.cropBox.x;cropY=this.state.cropBox.y;cropWidth=this.state.cropBox.width+dx;cropHeight=this.state.cropBox.height;}else if(this.state.cropBox.handle==="bottom"){cropX=this.state.cropBox.x;cropY=this.state.cropBox.y;cropWidth=this.state.cropBox.width;cropHeight=this.state.cropBox.height+dy;}if(cropX<=this.state.unCroppedBox.x){cropWidth-=this.state.unCroppedBox.x-cropX;cropX=this.state.unCroppedBox.x;}if(cropY<=this.state.unCroppedBox.y){cropHeight-=this.state.unCroppedBox.y-cropY;cropY=this.state.unCroppedBox.y;}if(cropX+cropWidth-this.state.unCroppedBox.width>=this.state.unCroppedBox.x){cropWidth-=cropX+cropWidth-this.state.unCroppedBox.width-this.state.unCroppedBox.x;}if(cropY+cropHeight-this.state.unCroppedBox.height>=this.state.unCroppedBox.y){cropHeight-=cropY+cropHeight-this.state.unCroppedBox.height-this.state.unCroppedBox.y;}if(cropWidth<50){if(!this.xLocked)this.lockedX=cropX;cropX-=cropX-this.lockedX;this.xLocked=true;cropWidth=50;}else{if(this.xLocked)this.xLocked=false;}if(cropHeight<50){if(!this.yLocked)this.lockedY=cropY;cropY-=cropY-this.lockedY;this.yLocked=true;cropHeight=50;}else{if(this.yLocked)this.yLocked=false;}return{x:cropX,y:cropY,width:cropWidth,height:cropHeight};}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CropComponent-getCropBoxPosition");}}},{key:'initiateCropResize',value:function initiateCropResize(e){try{e.preventDefault();e.stopPropagation();var handle=e.target.getAttribute("data-handle");var mouse_position=this.getMousePosition(e);this.mouseStartPosition=Object.assign(this.mouseStartPosition,{x:mouse_position.x,y:mouse_position.y});var cropBox=Object.assign({},this.state.cropBox);this.setState({cropBox:Object.assign(cropBox,{"handle":handle})});window.addEventListener('mousemove',this.resizeCropSelection,false);window.addEventListener('mouseup',this.stopCropResize,false);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CropComponent-initiateCropResize");}}},{key:'resizeCropSelection',value:function resizeCropSelection(e){try{e.preventDefault();e.stopPropagation();var crop=this.getCropBoxPosition(e);var cropBoxElement=this.cropBoxElement;cropBoxElement.style.transform="translate("+parseFloat(crop.x*this.props.zoomFactor).toFixed(2)+"px, "+parseFloat(crop.y*this.props.zoomFactor).toFixed(2)+"px)";cropBoxElement.style.width=crop.width*this.props.zoomFactor+"px";cropBoxElement.style.height=crop.height*this.props.zoomFactor+"px";if(this.props.isCropping){var cropHandles=this.cropHandles;cropHandles.style.transform="translate("+parseFloat(crop.x*this.props.zoomFactor).toFixed(2)+"px, "+parseFloat(crop.y*this.props.zoomFactor).toFixed(2)+"px)";cropHandles.style.width=crop.width*this.props.zoomFactor+"px";cropHandles.style.height=crop.height*this.props.zoomFactor+"px";}var flip=this.getFlipPosition();var angle=this.getAngle();if(this.state.type!=="BG")this.cropImageElem.style.transform="translate("+parseFloat((this.state.cropImage.x-(crop.x-this.state.cropBox.x))*this.props.zoomFactor).toFixed(2)+"px, "+parseFloat((this.state.cropImage.y-(crop.y-this.state.cropBox.y))*this.props.zoomFactor).toFixed(2)+"px) rotate("+angle+"deg)"+flip;else{document.getElementById("crop-bg"+this.props.selectedScene+"inner").style.transform="translate("+parseFloat((this.state.cropImage.x-(crop.x-this.state.cropBox.x))*this.props.zoomFactor).toFixed(2)+"px, "+parseFloat((this.state.cropImage.y-(crop.y-this.state.cropBox.y))*this.props.zoomFactor).toFixed(2)+"px) rotate("+angle+"deg)"+flip;}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CropComponent-resizeCropSelection");}}},{key:'stopCropResize',value:function stopCropResize(e){try{e.preventDefault();e.stopPropagation();var crop=this.getCropBoxPosition(e);var cropImage=Object.assign({},this.state.cropImage);var cropBox=Object.assign({},this.state.cropBox);cropImage=Object.assign(cropImage,{x:this.state.cropImage.x-(crop.x-this.state.cropBox.x),y:this.state.cropImage.y-(crop.y-this.state.cropBox.y)});cropBox=Object.assign(cropBox,{x:crop.x,y:crop.y,width:crop.width,height:crop.height});this.setState({cropImage:cropImage,cropBox:cropBox});window.removeEventListener('mousemove',this.resizeCropSelection,false);window.removeEventListener('mouseup',this.stopCropResize,false);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CropComponent-stopCropResize");}}},{key:'getUnCroppedResizePosition',value:function getUnCroppedResizePosition(e){try{var mouse_position=this.getMousePosition(e);var mouseX=this.state.unCroppedBox.x-(this.mouseStartPosition.x-mouse_position.x),mouseY=this.state.unCroppedBox.x-(this.mouseStartPosition.y-mouse_position.y);var unCropX=void 0,unCropY=void 0,unCropWidth=void 0,unCropHeight=void 0;if(this.state.unCroppedBox.handle==="top-left"){unCropWidth=this.state.unCroppedBox.width-(mouseX-this.state.unCroppedBox.x);unCropHeight=this.state.unCroppedBox.height-(mouseY-this.state.unCroppedBox.y);unCropX=mouseX;unCropY=mouseY-(unCropWidth/this.state.unCroppedBox.width*this.state.unCroppedBox.height-unCropHeight);}else if(this.state.unCroppedBox.handle==="top-right"){unCropWidth=mouseX-this.state.unCroppedBox.x+this.state.unCroppedBox.width;unCropHeight=this.state.unCroppedBox.height-(mouseY-this.state.unCroppedBox.y);unCropX=this.state.unCroppedBox.x;unCropY=mouseY-(unCropWidth/this.state.unCroppedBox.width*this.state.unCroppedBox.height-unCropHeight);}else if(this.state.unCroppedBox.handle==="bottom-right"){unCropWidth=mouseX-this.state.unCroppedBox.x+this.state.unCroppedBox.width;unCropHeight=mouseY-this.state.unCroppedBox.y+this.state.unCroppedBox.height;unCropX=this.state.unCroppedBox.x;unCropY=this.state.unCroppedBox.y;}else{unCropWidth=this.state.unCroppedBox.width-(mouseX-this.state.unCroppedBox.x);unCropHeight=mouseY-this.state.unCroppedBox.y;unCropX=mouseX;unCropY=this.state.unCroppedBox.y;}unCropHeight=unCropWidth/this.state.unCroppedBox.width*this.state.unCroppedBox.height;var projectType=this.props.projectType;var videoType=this.state.unCroppedBox.width.toFixed(2)>this.state.unCroppedBox.height.toFixed(2)?"hor":this.state.unCroppedBox.width.toFixed(2)<this.state.unCroppedBox.height.toFixed(2)?"ver":"sqr";if(projectType==="sqr")projectType=this.state.unCroppedBox.width.toFixed(2)>this.state.unCroppedBox.height.toFixed(2)?"ver":this.state.unCroppedBox.width.toFixed(2)<this.state.unCroppedBox.height.toFixed(2)?"hor":"sqr";var dW=void 0,dH=void 0;if(this.state.unCroppedBox.handle==="top-left"){if(projectType!=="hor"&&videoType!==this.props.projectType||this.props.isCropping){if(unCropX>=this.state.cropBox.x){dW=this.state.cropBox.x-unCropX;unCropWidth-=dW;unCropHeight-=dW/this.state.unCroppedBox.width*this.state.unCroppedBox.height;unCropX=this.state.cropBox.x;unCropY=this.props.workspaceBounds.get("cy")-(unCropHeight-this.state.unCroppedBox.dB)-(this.props.workspaceBounds.get("cy")-this.props.workspaceHeight/2);}}if(projectType!=="ver"&&videoType!==this.props.projectType||this.props.isCropping){if(unCropY>=this.state.cropBox.y){dH=this.state.cropBox.y-unCropY;unCropHeight-=dH;unCropY=this.state.cropBox.y;unCropWidth-=dH/this.state.unCroppedBox.height*this.state.unCroppedBox.width;unCropX=this.props.workspaceBounds.get("cx")-(unCropWidth-this.state.unCroppedBox.dR)-(this.props.workspaceBounds.get("cx")-this.props.workspaceWidth/2);}}}else if(this.state.unCroppedBox.handle==="top-right"){if(projectType!=="hor"&&videoType!==this.props.projectType||this.props.isCropping){if(this.state.cropBox.x-unCropX+this.state.cropBox.width>=unCropWidth){dW=unCropWidth-(this.state.cropBox.x-unCropX+this.state.cropBox.width);unCropWidth-=dW;unCropHeight-=dW/this.state.unCroppedBox.width*this.state.unCroppedBox.height;unCropY=this.props.workspaceBounds.get("cy")-(unCropHeight-this.state.unCroppedBox.dB)-(this.props.workspaceBounds.get("cy")-this.props.workspaceHeight/2);}}if(projectType!=="ver"&&videoType!==this.props.projectType||this.props.isCropping){if(unCropY>=this.state.cropBox.y){dH=this.state.cropBox.y-unCropY;unCropHeight-=dH;unCropWidth-=dH/this.state.unCroppedBox.height*this.state.unCroppedBox.width;unCropY=this.state.cropBox.y;}}}else if(this.state.unCroppedBox.handle==="bottom-right"){if(projectType!=="hor"&&videoType!==this.props.projectType||this.props.isCropping){if(this.state.cropBox.x-unCropX+this.state.cropBox.width>=unCropWidth){dW=unCropWidth-(this.state.cropBox.x-unCropX+this.state.cropBox.width);unCropWidth-=dW;unCropHeight-=dW/this.state.unCroppedBox.width*this.state.unCroppedBox.height;}}if(projectType!=="ver"&&videoType!==this.props.projectType||this.props.isCropping){if(this.state.cropBox.y-unCropY+this.state.cropBox.height>=unCropHeight){dH=unCropHeight-(this.state.cropBox.y-unCropY+this.state.cropBox.height);unCropHeight-=dH;unCropWidth-=dH/this.state.unCroppedBox.height*this.state.unCroppedBox.width;}}}else{if(projectType!=="hor"&&videoType!==this.props.projectType||this.props.isCropping){if(unCropX>=this.state.cropBox.x){dW=this.state.cropBox.x-unCropX;unCropWidth-=this.state.cropBox.x-unCropX;unCropX=this.state.cropBox.x;unCropHeight-=dW/this.state.unCroppedBox.width*this.state.unCroppedBox.height;}}if(projectType!=="ver"&&videoType!==this.props.projectType||this.props.isCropping){if(this.state.cropBox.y-unCropY+this.state.cropBox.height>=unCropHeight){dH=unCropHeight-(this.state.cropBox.y-unCropY+this.state.cropBox.height);unCropHeight-=dH;unCropWidth-=dH/this.state.unCroppedBox.height*this.state.unCroppedBox.width;unCropX=this.props.workspaceBounds.get("cx")-(unCropWidth-this.state.unCroppedBox.dR)-(this.props.workspaceBounds.get("cx")-this.props.workspaceWidth/2);}}}return{x:unCropX,y:unCropY,width:unCropWidth,height:unCropHeight};}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CropComponent-getUnCroppedResizePosition");}}},{key:'initiateResize',value:function initiateResize(e){try{e.preventDefault();e.stopPropagation();var handle=e.target.getAttribute("data-handle");var mouse_position=this.getMousePosition(e);this.mouseStartPosition=Object.assign(this.mouseStartPosition,{x:mouse_position.x,y:mouse_position.y});var unCroppedBox=Object.assign({},this.state.unCroppedBox);unCroppedBox=Object.assign(unCroppedBox,{"handle":handle,transforming:true,dR:this.props.workspaceBounds.get("cx")-this.props.workspaceWidth/2+this.state.unCroppedBox.x+this.state.unCroppedBox.width-this.props.workspaceBounds.get("cx"),dB:this.props.workspaceBounds.get("cy")-this.props.workspaceHeight/2+this.state.unCroppedBox.y+this.state.unCroppedBox.height-this.props.workspaceBounds.get("cy")});this.setState({unCroppedBox:unCroppedBox});window.addEventListener('mousemove',this.resizeSelection,false);window.addEventListener('mouseup',this.stopResize,false);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CropComponent-initiateResize");}}},{key:'resizeSelection',value:function resizeSelection(e){try{e.preventDefault();e.stopPropagation();var unCrop=this.getUnCroppedResizePosition(e);var unCroppedBoxElement=this.unCroppedBoxElement;unCroppedBoxElement.style.transform="translate("+parseFloat(unCrop.x*this.props.zoomFactor).toFixed(2)+"px, "+parseFloat(unCrop.y*this.props.zoomFactor).toFixed(2)+"px)";unCroppedBoxElement.style.width=unCrop.width*this.props.zoomFactor+"px";unCroppedBoxElement.style.height=unCrop.height*this.props.zoomFactor+"px";var flip=this.getFlipPosition();var angle=this.getAngle();var nextBtn=document.querySelector('.next_step');if(nextBtn){nextBtn.classList.remove('disable');}if(this.state.type!=="BG"){this.cropImageElem.style.transform="translate("+(this.state.cropImage.x+(unCrop.x-this.state.unCroppedBox.x))*this.props.zoomFactor+"px, "+(this.state.cropImage.y+(unCrop.y-this.state.unCroppedBox.y))*this.props.zoomFactor+"px) rotate("+angle+"deg)"+flip;this.cropImageElem.style.width=(this.state.cropImage.width+(unCrop.width-this.state.unCroppedBox.width))*this.props.zoomFactor+"px";this.cropImageElem.style.height=(this.state.cropImage.height+(unCrop.height-this.state.unCroppedBox.height))*this.props.zoomFactor+"px";}else{document.getElementById("crop-bg"+this.props.selectedScene+"inner").style.transform="translate("+(this.state.cropImage.x+(unCrop.x-this.state.unCroppedBox.x))*this.props.zoomFactor+"px, "+(this.state.cropImage.y+(unCrop.y-this.state.unCroppedBox.y))*this.props.zoomFactor+"px) rotate("+angle+"deg)"+flip;document.getElementById("crop-bg"+this.props.selectedScene+"inner").style.width=(this.state.cropImage.width+(unCrop.width-this.state.unCroppedBox.width))*this.props.zoomFactor+"px";document.getElementById("crop-bg"+this.props.selectedScene+"inner").style.height=(this.state.cropImage.height+(unCrop.height-this.state.unCroppedBox.height))*this.props.zoomFactor+"px";}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CropComponent-resizeSelection");}}},{key:'stopResize',value:function stopResize(e){try{e.preventDefault();e.stopPropagation();var unCrop=this.getUnCroppedResizePosition(e);this.isLocked=false;var unCroppedBox=Object.assign({},this.state.unCroppedBox);var cropImage=Object.assign({},this.state.cropImage);cropImage=Object.assign(cropImage,{x:this.state.cropImage.x+(unCrop.x-this.state.unCroppedBox.x),y:this.state.cropImage.y+(unCrop.y-this.state.unCroppedBox.y),width:this.state.cropImage.width+(unCrop.width-this.state.unCroppedBox.width),height:this.state.cropImage.height+(unCrop.height-this.state.unCroppedBox.height)});unCroppedBox=Object.assign(unCroppedBox,{x:unCrop.x,y:unCrop.y,width:unCrop.width,height:unCrop.height,transforming:false});this.setState({unCroppedBox:unCroppedBox,cropImage:cropImage});window.removeEventListener('mousemove',this.resizeSelection,false);window.removeEventListener('mouseup',this.stopResize,false);this.resetCursor(e);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CropComponent-stopResize");}}},{key:'handleCropClick',value:function handleCropClick(e){try{var oX=this.state.cropSelectionBox.x+this.state.unCroppedBox.x;var oY=this.state.cropSelectionBox.y+this.state.unCroppedBox.y;var oWidth=this.state.unCroppedBox.width;var oHeight=this.state.unCroppedBox.height;var cX=this.state.cropSelectionBox.x+this.state.cropBox.x;var cY=this.state.cropSelectionBox.y+this.state.cropBox.y;var cWidth=this.state.cropBox.width;var cHeight=this.state.cropBox.height;var cropItem=this.props.cropItem;var xDiff=oWidth-(cWidth+cX-oX)-(oWidth-cWidth),yDiff=oHeight-(cHeight+cY-oY)-(oHeight-cHeight);if(this.props.isCropping||this.props.isFraming){if(cropItem.get("flipPosition")===1){xDiff=0-(oWidth-(cWidth+cX-oX));}else if(cropItem.get("flipPosition")===2){yDiff=0-(oHeight-(cHeight+cY-oY));}else if(cropItem.get("flipPosition")===3){xDiff=0-(oWidth-(cWidth+cX-oX));yDiff=0-(oHeight-(cHeight+cY-oY));}var cropData={selectedScene:this.props.selectedScene,selectedItems:this.props.selectedItems,original:{x:xDiff/cWidth,y:yDiff/cHeight,width:oWidth/cWidth,height:oHeight/cHeight},crop:{x:cX,y:cY,width:cWidth,height:cHeight},isCropping:this.props.isCropping};this.props.cropImage(cropData,this.props.socket);}else{this.props.cropBG({selectedScene:this.props.selectedScene,selectedItems:this.props.selectedItems,bgScales:{x:xDiff/cWidth,y:yDiff/cHeight,width:oWidth/cWidth,height:oHeight/cHeight},isVideo:this.props.isVideoCropping,videoId:this.props.videoId},this.props.socket);var nextBtn=document.querySelector('.next_step');if(nextBtn){this.props.nextBtnClicked(true);nextBtn.classList.remove('disable');nextBtn.click();}}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CropComponent-handleCropClick");}}},{key:'cancelCrop',value:function cancelCrop(e){try{if(this.props.isCropping||this.isFraming)this.props.toggleCrop();else if(this.props.isVideoCropping)this.props.toggleVideoCrop(this.props.videoId);else this.props.toggleBgCrop();var nextBtn=document.querySelector('.next_step');if(nextBtn){this.props.nextBtnClicked(true);nextBtn.classList.remove('disable');nextBtn.click();}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CropComponent-cancelCrop");}}},{key:'getAngle',value:function getAngle(){if((this.props.isBgCropping||this.props.isVideoCropping)&&this.props.currentSceneItems.getIn(["workspaceBG","angle"])!==undefined){return this.props.currentSceneItems.getIn(["workspaceBG","angle"]);}else{return 0;}}},{key:'getFlipPosition',value:function getFlipPosition(){if(!this.props.isBgCropping&&!this.props.isVideoCropping){var flipValue=this.props.cropItem.get("flipPosition");return flipValue===1?" scaleX(-1)":flipValue===2?" scaleY(-1)":flipValue===3?" scaleX(-1) scaleY(-1)":"";}else if(this.props.currentSceneItems.getIn(["workspaceBG","flipPosition"])!==undefined){var _flipValue=this.props.currentSceneItems.getIn(["workspaceBG","flipPosition"]);return _flipValue===1?" scaleX(-1)":_flipValue===2?" scaleY(-1)":_flipValue===3?" scaleX(-1) scaleY(-1)":"";}else{return"";}}},{key:'resetCrop',value:function resetCrop(){try{var stateToUpdate={};stateToUpdate.cropSelectionBox={x:this.props.cropItem.get("x"),y:this.props.cropItem.get("y"),width:this.props.cropItem.get("width"),height:this.props.cropItem.get("height"),angle:this.props.cropItem.get("angle")};stateToUpdate.cropBox={x:0,y:0,width:this.state.cropSelectionBox.width,height:this.state.cropSelectionBox.height,angle:this.props.cropItem.get("angle")};stateToUpdate.cropImage={x:0,y:0,width:this.state.cropSelectionBox.width,height:this.state.cropSelectionBox.height,angle:this.props.cropItem.get("angle")};stateToUpdate.unCroppedBox={x:0,y:0,width:this.state.cropSelectionBox.width,height:this.state.cropSelectionBox.height,angle:this.props.cropItem.get("angle")};this.setState(stateToUpdate);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CropComponent-resetCrop");}}},{key:'render',value:function render(){var _this4=this;var flip=this.getFlipPosition();var selectionStyles={transform:"translate("+parseFloat(this.state.cropSelectionBox.x*this.props.zoomFactor).toFixed(2)+"px, "+parseFloat(this.state.cropSelectionBox.y*this.props.zoomFactor).toFixed(2)+"px) rotateZ("+this.state.cropSelectionBox.angle+"deg)",width:parseFloat(this.state.cropSelectionBox.width*this.props.zoomFactor).toFixed(2)+"px",height:parseFloat(this.state.cropSelectionBox.height*this.props.zoomFactor).toFixed(2)+"px"};var cropStyles={transform:"translate("+parseFloat(this.state.cropBox.x*this.props.zoomFactor).toFixed(2)+"px, "+parseFloat(this.state.cropBox.y*this.props.zoomFactor).toFixed(2)+"px)",width:parseFloat(this.state.cropBox.width*this.props.zoomFactor).toFixed(2)+"px",height:parseFloat(this.state.cropBox.height*this.props.zoomFactor).toFixed(2)+"px"};var unCroppedStyle={transform:"translate("+parseFloat(this.state.unCroppedBox.x*this.props.zoomFactor).toFixed(2)+"px, "+parseFloat(this.state.unCroppedBox.y*this.props.zoomFactor).toFixed(2)+"px)",width:parseFloat(this.state.unCroppedBox.width*this.props.zoomFactor).toFixed(2)+"px",height:parseFloat(this.state.unCroppedBox.height*this.props.zoomFactor).toFixed(2)+"px"};var unCroppedImageStyle={};var cropImageStyle={transform:"translate("+parseFloat(this.state.cropImage.x*this.props.zoomFactor).toFixed(2)+"px, "+parseFloat(this.state.cropImage.y*this.props.zoomFactor).toFixed(2)+"px) rotate("+this.getAngle()+"deg)"+flip,width:parseFloat(this.state.unCroppedBox.width*this.props.zoomFactor).toFixed(2)+"px",height:parseFloat(this.state.unCroppedBox.height*this.props.zoomFactor).toFixed(2)+"px"};var svgElement=null,filterValue={};unCroppedImageStyle.transform="rotate("+this.getAngle()+"deg)"+flip;if(this.props.isFraming){cropStyles.WebkitClipPath="url(#clip-"+this.props.selectedItems.get(0)+")";cropStyles.clipPath="url(#clip-"+this.props.selectedItems.get(0)+")";svgElement=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderSvg,{id:this.props.selectedItems.get(0),data:this.props.cropItem,config:this.props.config});}var cropImgElem=void 0,unCropImgElem=void 0;var filterId=!this.props.isBgCropping?this.props.cropItem.get("filter"):this.props.currentSceneItems.getIn(["workspaceBG","bgFilter"]);var selectedId=!this.props.isBgCropping?this.props.selectedItems.get(0):this.props.currentSceneItems.get("id");cropImgElem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'crop-imgHolder tintCls',style:Object.assign({},filterValue,{overflow:"hidden"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:"crop-vignette-"+this.props.selectedScene,className:'vignette'}),this.props.isBgCropping&&this.props.currentSceneItems.getIn(["workspaceBG","type"])==="BG"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_WorkspaceComponent__["a" /* CustomBGRender */],{completeWorkspaceItems:this.props.currentSceneItems,assetType:'BG',proxyImg:this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["BG"][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["BG"].onload]+this.props.currentSceneItems.getIn(["workspaceBG","thumbnail"]),data_id:"crop-bg"+this.props.selectedScene,bgImgStyles:Object.assign({},cropImageStyle,{filter:'url(#filter_'+selectedId+'_'+filterId+')'}),isPlay:false,isPlayAll:false,key:"bg-crop",src:this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["BG"][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["BG"].workspace]+this.props.currentSceneItems.getIn(["workspaceBG","src"]),colors:this.props.currentSceneItems.getIn(["workspaceBG","bgColor"]),hasGradient:this.props.currentSceneItems.getIn(["workspaceBG","hasGradient"])}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'cropImageElem',ref:function ref(instance){return _this4.cropImageElem=instance;},src:this.state.image,style:Object.assign({},cropImageStyle,{filter:'url(#filter_'+selectedId+'_'+filterId+')'})}));unCropImgElem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'crop-imgHolder tintCls',style:Object.assign({},filterValue,{overflow:"hidden"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:"uncrop-vignette-"+this.props.selectedScene,className:'vignette'}),this.props.isBgCropping&&this.props.currentSceneItems.getIn(["workspaceBG","type"])==="BG"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_WorkspaceComponent__["a" /* CustomBGRender */],{completeWorkspaceItems:this.props.currentSceneItems,assetType:'BG',proxyImg:this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["BG"][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["BG"].onload]+this.props.currentSceneItems.getIn(["workspaceBG","thumbnail"]),data_id:"uncrop-bg"+this.props.selectedScene,bgImgStyles:Object.assign({},unCroppedImageStyle,{filter:'url(#filter_'+selectedId+'_'+filterId+')'}),isPlay:false,isPlayAll:false,key:"bg-crop",src:this.assetUrl+__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["BG"][__WEBPACK_IMPORTED_MODULE_4__config_app_json___default.a["BG"].workspace]+this.props.currentSceneItems.getIn(["workspaceBG","src"]),colors:this.props.currentSceneItems.getIn(["workspaceBG","bgColor"]),hasGradient:this.props.currentSceneItems.getIn(["workspaceBG","hasGradient"])}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'unCroppedImageElem',ref:function ref(instance){return _this4.unCroppedImageElem=instance;},src:this.state.image,style:Object.assign({},unCroppedImageStyle,{filter:'url(#filter_'+selectedId+'_'+filterId+')'})}));var top=this.props.workspaceHeight*this.props.zoomFactor+20;var workspaceX=this.props.workspaceBounds.get("cx")-this.props.workspaceWidth*this.props.zoomFactor/2,workspaceY=this.props.workspaceBounds.get("cy")-this.props.workspaceHeight*this.props.zoomFactor/2,workspaceWidth=this.props.workspaceWidth*this.props.zoomFactor,workspaceHeight=this.props.workspaceHeight*this.props.zoomFactor;if(Math.round(workspaceHeight)>this.props.workspaceBounds.get("height")){workspaceY=this.props.workspaceBounds.get("cy")-this.props.workspaceBounds.get("height")/2;workspaceHeight=this.props.workspaceBounds.get("height");}if(Math.round(workspaceWidth)>this.props.workspaceBounds.get("width")){workspaceX=this.props.workspaceBounds.get("cx")-this.props.workspaceBounds.get("width")/2;workspaceWidth=this.props.workspaceBounds.get("width");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'crop-workspace',style:{position:"absolute",left:workspaceX.toFixed(2)+"px",top:workspaceY.toFixed(2)+"px",width:workspaceWidth.toFixed(2)+"px",height:workspaceHeight.toFixed(2)+"px",zIndex:5}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cropSelectionBox',style:selectionStyles,'data-html2canvas-ignore':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cropBox',ref:function ref(instance){return _this4.cropBoxElement=instance;},style:cropStyles,onMouseDown:this.initiateMove.bind(this),onMouseEnter:function onMouseEnter(e){return _this4.setCursor(e,"move");},onMouseLeave:function onMouseLeave(e){return _this4.resetCursor(e);}},cropImgElem,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'crop-inner-box'}),svgElement),this.props.isCropping?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(instance){return _this4.cropHandles=instance;},className:'crop-handles',style:cropStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'crop-handle top-left','data-handle':'top-left',onMouseDown:this.initiateCropResize.bind(this),onMouseEnter:function onMouseEnter(e){return _this4.setCursor(e,"resize");},onMouseLeave:function onMouseLeave(e){return _this4.setCursor(e,"move");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{'data-handle':'top-left',width:'14',height:'14'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{'data-handle':'top-left',d:'M.75,.75 H13.25, V4, H4, V13.25, H.75z',fill:'#000000',stroke:'#ffffff',strokeWidth:'.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'crop-handle top','data-handle':'top',onMouseDown:this.initiateCropResize.bind(this),onMouseEnter:function onMouseEnter(e){return _this4.setCursor(e,"resize");},onMouseLeave:function onMouseLeave(e){return _this4.setCursor(e,"move");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{'data-handle':'top',width:'14',height:'5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{'data-handle':'top',d:'M.75,.75 H13.25, V4, H.75z',fill:'#000000',stroke:'#ffffff',strokeWidth:'.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'crop-handle top-right','data-handle':'top-right',onMouseDown:this.initiateCropResize.bind(this),onMouseEnter:function onMouseEnter(e){return _this4.setCursor(e,"resize");},onMouseLeave:function onMouseLeave(e){return _this4.setCursor(e,"move");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{'data-handle':'top-right',width:'14',height:'14'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{'data-handle':'top-right',d:'M.75,.75 H13.25, V4, H4, V13.25, H.75z',fill:'#000000',stroke:'#ffffff',strokeWidth:'.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'crop-handle right','data-handle':'right',onMouseDown:this.initiateCropResize.bind(this),onMouseEnter:function onMouseEnter(e){return _this4.setCursor(e,"resize");},onMouseLeave:function onMouseLeave(e){return _this4.setCursor(e,"move");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{'data-handle':'right',width:'5',height:'14'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{'data-handle':'right',d:'M.75,.75 H4, V13.25, H.75z',fill:'#000000',stroke:'#ffffff',strokeWidth:'.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'crop-handle bottom-left','data-handle':'bottom-left',onMouseDown:this.initiateCropResize.bind(this),onMouseEnter:function onMouseEnter(e){return _this4.setCursor(e,"resize");},onMouseLeave:function onMouseLeave(e){return _this4.setCursor(e,"move");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{'data-handle':'bottom-left',width:'14',height:'14'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{'data-handle':'bottom-left',d:'M.75,.75 H13.25, V4, H4, V13.25, H.75z',fill:'#000000',stroke:'#ffffff',strokeWidth:'.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'crop-handle bottom','data-handle':'bottom',onMouseDown:this.initiateCropResize.bind(this),onMouseEnter:function onMouseEnter(e){return _this4.setCursor(e,"resize");},onMouseLeave:function onMouseLeave(e){return _this4.setCursor(e,"move");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{'data-handle':'bottom',width:'14',height:'5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{'data-handle':'bottom',d:'M.75,.75 H13.25, V4, H.75z',fill:'#000000',stroke:'#ffffff',strokeWidth:'.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'crop-handle bottom-right','data-handle':'bottom-right',onMouseDown:this.initiateCropResize.bind(this),onMouseEnter:function onMouseEnter(e){return _this4.setCursor(e,"resize");},onMouseLeave:function onMouseLeave(e){return _this4.setCursor(e,"move");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{'data-handle':'bottom-right',width:'14',height:'14'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{'data-handle':'bottom-right',d:'M.75,.75 H13.25, V4, H4, V13.25, H.75z',fill:'#000000',stroke:'#ffffff',strokeWidth:'.75'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'crop-handle left','data-handle':'left',onMouseDown:this.initiateCropResize.bind(this),onMouseEnter:function onMouseEnter(e){return _this4.setCursor(e,"resize");},onMouseLeave:function onMouseLeave(e){return _this4.setCursor(e,"move");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{'data-handle':'left',width:'5',height:'14'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{'data-handle':'left',d:'M.75,.75 H4, V13.25, H.75z',fill:'#000000',stroke:'#ffffff',strokeWidth:'.75'})))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'unCroppedBox pre_tour_action',ref:function ref(instance){return _this4.unCroppedBoxElement=instance;},style:unCroppedStyle,onMouseDown:this.initiateMove.bind(this),onMouseEnter:function onMouseEnter(e){return _this4.setCursor(e,"move");},onMouseLeave:function onMouseLeave(e){return _this4.resetCursor(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'unCroppedBox-wrapper',style:{position:"absolute",top:"-10px",right:"-10px",bottom:"-10px",left:"-10px",pointerEvents:"none",outline:"none",outlineOffset:0,animation:"unset"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'uncrop-inner-box',style:{width:"100%",height:"100%",position:"absolute"},onMouseDown:this.initiateMove.bind(this),onMouseEnter:function onMouseEnter(e){return _this4.setCursor(e,"move");},onMouseLeave:function onMouseLeave(e){return _this4.resetCursor(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'uncrop-box-handles'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'resize-handle top-left','data-handle':'top-left',onMouseDown:this.initiateResize.bind(this),onMouseEnter:function onMouseEnter(e){return _this4.setCursor(e,"resize");},onMouseLeave:function onMouseLeave(e){return _this4.resetCursor(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'resize-handle top-right','data-handle':'top-right',onMouseDown:this.initiateResize.bind(this),onMouseEnter:function onMouseEnter(e){return _this4.setCursor(e,"resize");},onMouseLeave:function onMouseLeave(e){return _this4.resetCursor(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'resize-handle bottom-right','data-handle':'bottom-right',onMouseDown:this.initiateResize.bind(this),onMouseEnter:function onMouseEnter(e){return _this4.setCursor(e,"resize");},onMouseLeave:function onMouseLeave(e){return _this4.resetCursor(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'resize-handle bottom-left','data-handle':'bottom-left',onMouseDown:this.initiateResize.bind(this),onMouseEnter:function onMouseEnter(e){return _this4.setCursor(e,"resize");},onMouseLeave:function onMouseLeave(e){return _this4.resetCursor(e);}})),unCropImgElem)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multimove-controls confirm-tool-bar',style:{top:top+"px",position:"absolute",width:this.props.workspaceWidth*this.props.zoomFactor+"px",display:"flex",alignItems:"center",pointerEvents:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'preview',style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'preview-text',style:{cursor:"pointer"},onClick:this.resetCrop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'cr.re'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation',style:{marginLeft:"auto"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'confirmation-icon pre_tour_action',onClick:this.cancelCrop.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'confirmation-text pre_tour_action',onClick:this.handleCropClick.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'rec.apply'}))))));}}]);return CropComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CropComponent);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProgressiveImageComponent__ = __webpack_require__(409);
var mapStateToProps=function mapStateToProps(state,ownProps){return{};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{};};var ProgressiveImage=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ProgressiveImageComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ProgressiveImage);

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ErrorLogService__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProgressiveImageComponent=function(_React$Component){_inherits(ProgressiveImageComponent,_React$Component);function ProgressiveImageComponent(props){_classCallCheck(this,ProgressiveImageComponent);var _this=_possibleConstructorReturn(this,(ProgressiveImageComponent.__proto__||Object.getPrototypeOf(ProgressiveImageComponent)).call(this,props));_this.state={image:props.placeholder,loading:true};_this.image=null;_this.loadImage=_this.loadImage.bind(_this);_this.onLoad=_this.onLoad.bind(_this);_this.onError=_this.onError.bind(_this);return _this;}_createClass(ProgressiveImageComponent,[{key:"componentDidMount",value:function componentDidMount(){var src=this.props.src;this.loadImage(src);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _this2=this;var src=nextProps.src,placeholder=nextProps.placeholder;// We only invalidate the current image if the src has changed.
if(src!==this.props.src){this.setState({image:placeholder,loading:true},function(){_this2.loadImage(src);});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.image){this.image.onload=null;this.image.onerror=null;}}},{key:"loadImage",value:function loadImage(src){// If there is already an image we nullify the onload
// and onerror props so it does not incorrectly set state
// when it resolves
if(this.image){this.image.onload=null;this.image.onerror=null;}var image=new Image();this.image=image;image.onload=this.onLoad;image.onerror=this.onError;image.src=src;}},{key:"onLoad",value:function onLoad(){try{// use this.image.src instead of this.props.src to
// avoid the possibility of props being updated and the
// new image loading before the new props are available as
// this.props.
this.setState({image:this.image.src,loading:false});}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_1__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"ProgressiveImageComponent-onLoad");}}},{key:"onError",value:function onError(errorEvent){try{var onError=this.props.onError;if(onError){onError(errorEvent);}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_1__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"ProgressiveImageComponent-onError");}}},{key:"render",value:function render(){var _state=this.state,image=_state.image,loading=_state.loading;var children=this.props.children;if(!children||typeof children!=="function"){throw new Error("ProgressiveImage requires a function as its only child");}return children(image,loading);}}]);return ProgressiveImageComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProgressiveImageComponent);

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 411 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Frame_FramesComponent__ = __webpack_require__(413);
var mapStateToProps=function mapStateToProps(state,ownProps){return{zoomFactor:state.localStore.get("zoomFactor"),propertyWindow:state.localStore.get("propertyWindow"),transformStatus:state.localStore.get("transformStatus"),clipCount:state.localStore.get("clipCount")// isPreview : state.localStore.get('isPreview'),
// isFullScreen : state.localStore.get("isFullScreen"),
};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{// selectFrameClip: (data) => dispatch(selectFrameClip(data)),
// setPropertyWindow: (data) => dispatch(setPropertyWindow(data)),
// setFrameLoad: (data) => dispatch(setFrameLoad(data)),
// setLoadedFrameCount: (data) => dispatch(setLoadedFrameCount(data)),
};};var Frames=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components_Frame_FramesComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Frames);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Frame_DroppableAreas__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_frameHelper__ = __webpack_require__(47);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n    overflow: visible;\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n"],["\n    overflow: visible;\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SVG=__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* default */].svg(_templateObject);function ReturnSVG(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{id:props.id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SVG,{width:props.width,height:props.height},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:props.d,fill:props.fill,stroke:props.stroke})));}function FramesComponent(props){var frameContainerRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);var canAllowClick=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(false);var id=props.id,grouped=props.grouped,groupId=props.groupId,frameItem=props.frameItem,zoomFactor=props.zoomFactor,propertyWindow=props.propertyWindow,socket=props.socket,transformStatus=props.transformStatus,isSlidePreview=props.isSlidePreview,idPrefix=props.idPrefix,slidesPanelZoomFactor=props.slidesPanelZoomFactor;var _zoomFactor=isSlidePreview?slidesPanelZoomFactor:zoomFactor;var isFrameVisible=true;function renderDroppables(){var frameClipDetails=frameItem.get("clipDetails");var frameDetails=[];frameClipDetails.entrySeq().forEach(function(_ref,ind){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],item=_ref2[1];console.log(ind);frameDetails.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__containers_Frame_DroppableAreas__["a" /* default */],{key:key,Id:id,clip_id:key,groupId:groupId,selectedItem:id,isGrouped:grouped,droppableItemData:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(item),frameItemData:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(frameItem),socket:socket,totalLength:frameClipDetails.size,currIndex:ind,isPlay:props.isPlay,isPlayAll:props.isPlayAll,onLoadData:function onLoadData(imageId){return _onLoadData(imageId);},isFrameVisible:isFrameVisible,isSlidePreview:isSlidePreview,idPrefix:idPrefix}));});return frameDetails;}var _onLoadData=function _onLoadData(imageId){try{// if ((props.isFullScreen === true)) {
window.totalArr=window.totalArr.filter(function(e){return e!==imageId;});console.log(window.totalArr,"window.totalArr",imageId);// if (window.totalArr.length === 0) {
//     props.startPlay("workspace")
// }
// }
}catch(error){console.log(error);}};function frameContainerStyles(){var defaultWidth=frameItem.get("defaultWidth");var defaultHeight=frameItem.get("defaultHeight");var frameWidth=frameItem.get("width")*_zoomFactor;var frameHeight=frameItem.get("height")*_zoomFactor;return{width:defaultWidth+"px",height:defaultHeight+"px",transform:"scaleX("+frameWidth/defaultWidth+") scaleY("+frameHeight/defaultHeight+")",transformOrigin:"0 0"};}function renderSVGs(){return frameItem.get("d").map(function(item,key){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ReturnSVG,{key:key,id:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_frameHelper__["g" /* getFrameSvgId */])(id,key,idPrefix)// for color pallete
,d:item.get("path"),fill:item.get("fill"),stroke:item.get("stroke"),width:item.get("width"),height:item.get("height")});});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"inner-frame "+(id+1),style:frameContainerStyles(),ref:frameContainerRef},renderSVGs(),renderDroppables());}/* harmony default export */ __webpack_exports__["a"] = (FramesComponent);

/***/ }),
/* 414 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isPropValid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(418);


// eslint-disable-next-line no-undef
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);




/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return memoize; });
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}




/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Frame_DroppableAreasComponent__ = __webpack_require__(420);
var mapStateToProps=function mapStateToProps(state,ownProps){return{selectedScene:state.localStore.get("selectedScene"),selectedItemId:state.localStore.getIn(["selectedItems",0]),selectedItem:state.localStore.get("selectedItems").size===1?state.project.getIn(["scenes",state.localStore.get("selectedScene"),"workspaceItems",state.localStore.getIn(["selectedItems",0])]):undefined,isFraming:state.localStore.get("isFraming"),transformStatus:state.localStore.getIn(["transformStatus"]),isLibraryItemDragging:state.localStore.get("isLibraryItemDragging"),libraryImageDrag:state.localStore.get("libraryImageDrag"),swapHoverDrop:state.localStore.get("swapHoverDrop"),selectedFrameClip:state.localStore.get("selectedFrameClip"),propertyWindow:state.localStore.get("propertyWindow"),isPlay:state.localStore.get("isPlay"),isPlayAll:state.localStore.get("isPlayAll")};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{// selectFrameClip: (data) => dispatch(selectFrameClip(data)),
// frameImageDropped: (data, socket) => dispatch(frameImageDropped(data, socket)),
// updateSwapHoverDrop: (data) => dispatch(updateSwapHoverDrop(data)),
// setPropertyWindow: (data) => dispatch(setPropertyWindow(data)),
// updateTransformStatus: (data) => dispatch(updateTransformStatus(data)),
};};var DroppableAreas=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components_Frame_DroppableAreasComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (DroppableAreas);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_app_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Frame_InnerFrameImage__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_frameHelper__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_URLHelper__ = __webpack_require__(106);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    cursor: pointer;\n\n    * {\n        pointer-events: none; // using pointer events so that we can detect mouse up in LibraryComponent\n    }\n"],["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    cursor: pointer;\n\n    * {\n        pointer-events: none; // using pointer events so that we can detect mouse up in LibraryComponent\n    }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var appUrl=__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a['APPICONS'][__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a['APPICONS']['current']];var DroppableContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* default */].div(_templateObject);function DroppableAreasComponent(props){var Id=props.Id,groupId=props.groupId,isGrouped=props.isGrouped,clip_id=props.clip_id,frameItemData=props.frameItemData,droppableItemData=props.droppableItemData,socket=props.socket,totalLength=props.totalLength,currIndex=props.currIndex,isFrameVisible=props.isFrameVisible,isSlidePreview=props.isSlidePreview,idPrefix=props.idPrefix;var libraryImageDrag=props.libraryImageDrag,isLibraryItemDragging=props.isLibraryItemDragging,transformStatus=props.transformStatus,selectedItem=props.selectedItem,selectedItemId=props.selectedItemId,swapHoverDrop=props.swapHoverDrop,selectedScene=props.selectedScene,selectedFrameClip=props.selectedFrameClip,propertyWindow=props.propertyWindow,isFraming=props.isFraming,isPlay=props.isPlay,isPlayAll=props.isPlayAll;var updateSwapHoverDrop=props.updateSwapHoverDrop,frameImageDropped=props.frameImageDropped,selectFrameClip=props.selectFrameClip,setPropertyWindow=props.setPropertyWindow,updateTransformStatus=props.updateTransformStatus;var lastMouseUp=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(0);var canAllowClick=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(false);var imageRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])();var imageContainerRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])();var droppableAreaRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])();var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(true),_useState2=_slicedToArray(_useState,2),showImage=_useState2[0],setShowImage=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),imageHovered=_useState4[0],setImageHovered=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])({}),_useState6=_slicedToArray(_useState5,2),hoveredImageStyles=_useState6[0],setHoveredImageStyles=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(),_useState8=_slicedToArray(_useState7,2),hoverImage=_useState8[0],setHoverImage=_useState8[1];var isItemMoving=transformStatus.get("moving");Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){if(droppableItemData.getIn(["imgDetails","color"])!==undefined&&droppableItemData.getIn(["imgDetails","color"])!==""&&droppableItemData.getIn(["imgDetails","src"])===""){setShowImage(false);// props.onLoadData(currIndex);
}else{// color picker undo
setShowImage(true);}},[droppableItemData]);function getFlipPosition(value){var flip=value===1?" scaleX(-1)":value===2?" scaleY(-1)":value===3?" scaleX(-1) scaleY(-1)":"";return flip;}function getStyles(){var flipPosition=droppableItemData.getIn(["imgDetails","flipPosition"]);if(!imageHovered){var imageWidth=frameItemData.get("defaultWidth")*droppableItemData.getIn(["imgDetails","original","width"]);var imageHeight=frameItemData.get("defaultHeight")*droppableItemData.getIn(["imgDetails","original","height"]);var imageX=frameItemData.get("defaultWidth")*droppableItemData.getIn(["imgDetails","original","x"]);var imageY=frameItemData.get("defaultHeight")*droppableItemData.getIn(["imgDetails","original","y"]);return{position:"relative",width:imageWidth+"px",height:imageHeight+"px",transform:"translate("+imageX+"px, "+imageY+"px) "+getFlipPosition(flipPosition)};}else if(imageHovered){var width=hoveredImageStyles.width,height=hoveredImageStyles.height,X=hoveredImageStyles.X,Y=hoveredImageStyles.Y;return{position:"relative",width:frameItemData.get("defaultWidth")*width+"px",height:frameItemData.get("defaultHeight")*height+"px",transform:"translate("+frameItemData.get("defaultWidth")*X+"px, "+frameItemData.get("defaultHeight")*Y+"px)"};}}function getSource(id){var imageDetails=droppableItemData.getIn(["imgDetails"]);var defaultImageSrc=""+appUrl+imageDetails.getIn(["defaultImageDetails","src"]);if(imageHovered){imageDetails=hoverImage;}var _getImageSource=Object(__WEBPACK_IMPORTED_MODULE_5__helpers_frameHelper__["i" /* getImageSource */])(imageDetails,id),src=_getImageSource.src,thumb=_getImageSource.thumb;if(!imageDetails.get("src")&&!imageDetails.get('stickerify')&&!imageDetails.get('bgremoval')){return defaultImageSrc;}else if(imageHovered){return thumb;}return src;}var dropAreaPointerEvents="auto";return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DroppableContainer,{ref:droppableAreaRef,style:{clipPath:"path('"+droppableItemData.get("clipData")+"')",backgroundColor:droppableItemData.getIn(["imgDetails","color"]),pointerEvents:dropAreaPointerEvents,touchAction:'none'},id:Object(__WEBPACK_IMPORTED_MODULE_5__helpers_frameHelper__["f" /* getFrameDropAreaId */])(Id,clip_id,idPrefix),className:__WEBPACK_IMPORTED_MODULE_5__helpers_frameHelper__["a" /* FRAME_CLASSES */]["DROP_AREA"]// onMouseEnter={handleMouseEnter}
// onMouseLeave={handleMouseLeave}
// onPointerDown={handleMouseDown}
// onPointerUp={handleMouseUp}
,"data-tswap-tkn":Object(__WEBPACK_IMPORTED_MODULE_5__helpers_frameHelper__["f" /* getFrameDropAreaId */])(Id,clip_id,idPrefix)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__containers_Frame_InnerFrameImage__["a" /* default */],{imageContainerRef:imageContainerRef,containerStyles:getStyles(),Id:Id,clip_id:clip_id,droppableItemData:droppableItemData,src:getSource(Id),thumb:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_URLHelper__["a" /* getImageThumbnailURL */])(droppableItemData.getIn(["imgDetails","type"]),droppableItemData.getIn(["imgDetails","subType"]),droppableItemData.getIn(["imgDetails","thumb"])||droppableItemData.getIn(["imgDetails","thumbnail"])),imageRef:imageRef,showImage:showImage||imageHovered,onLoadData:props.onLoadData,isImageHovered:imageHovered,currIndex:props.currIndex,idPrefix:idPrefix}));}/* harmony default export */ __webpack_exports__["a"] = (DroppableAreasComponent);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Frame_InnerFrameImageComponent__ = __webpack_require__(422);
var mapStateToProps=function mapStateToProps(state,ownProps){return{browserName:state.localStore.get("browserName")};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{};};var InnerFrameImage=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Frame_InnerFrameImageComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (InnerFrameImage);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReturnSvgFilter__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_app_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_itemConfig_json__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_itemConfig_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_itemConfig_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_frameHelper__ = __webpack_require__(47);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    position: absolute; top: 0; left: 0;\n    display: flex; align-items: center; justify-content: center;\n\n    img {\n        width: 100%;\n        max-height: 48px;\n        object-fit: contain;\n    }\n"],["\n    width: 100%;\n    height: 100%;\n    position: absolute; top: 0; left: 0;\n    display: flex; align-items: center; justify-content: center;\n\n    img {\n        width: 100%;\n        max-height: 48px;\n        object-fit: contain;\n    }\n"]),_templateObject2=_taggedTemplateLiteral(["\n    display: block;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n"],["\n    display: block;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n"]),_templateObject3=_taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    z-index: 2;\n    background-image: radial-gradient(\n        circle farthest-side at center center,\n        rgba(0, 0, 0, 0) 70%,\n        rgba(0, 0, 0, var(--vignette)) 130%\n    );\n"],["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    z-index: 2;\n    background-image: radial-gradient(\n        circle farthest-side at center center,\n        rgba(0, 0, 0, 0) 70%,\n        rgba(0, 0, 0, var(--vignette)) 130%\n    );\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var appUrl=__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a['APPICONS'][__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a['APPICONS']['current']];var Loader=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject);var FrameImage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].img(_templateObject2);var FrameVideo=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].video(_templateObject2);var VIGNETTE=__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject3);function FilterItem(props){var id=props.id,clip=props.clip,ItemID=props.ItemID,filterCode=props.filterCode,filterId=props.filterId,browserName=props.browserName,idPrefix=props.idPrefix;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{id:Object(__WEBPACK_IMPORTED_MODULE_5__helpers_frameHelper__["d" /* getFrameClipFilterSvgId */])(ItemID,clip,idPrefix),style:browserName==="Firefox"?{width:"0",height:"0",display:"block"}:{display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("filter",{colorInterpolationFilters:"sRGB",id:filterId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ReturnSvgFilter__["a" /* ReturnSvgFilter */],{filterCode:filterCode}))))));}function InnerFrameImageComponent(props){var Id=props.Id,clip_id=props.clip_id,showImage=props.showImage,isFraming=props.isFraming,containerStyles=props.containerStyles,src=props.src,imageRef=props.imageRef,imageContainerRef=props.imageContainerRef,droppableItemData=props.droppableItemData,totalLength=props.totalLength,currIndex=props.currIndex,thumb=props.thumb,isImageHovered=props.isImageHovered,idPrefix=props.idPrefix;var browserName=props.browserName;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState2=_slicedToArray(_useState,2),loading=_useState2[0],setLoading=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(),_useState4=_slicedToArray(_useState3,2),loadingImg=_useState4[0],setLoadingImg=_useState4[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var image=new Image();setLoading(true);image.onload=function(){setLoading(false);};image.onerror=function(){setLoading(false);};image.src=src;setLoadingImg(image);},[src]);if(showImage&&!isFraming&&!loading){var filterData=droppableItemData.getIn(["imgDetails","filter"])?droppableItemData.getIn(["imgDetails","filter"]):__WEBPACK_IMPORTED_MODULE_4__config_itemConfig_json___default.a["IMAGE"]["DEFAULT_FILTER"];var vignetteValue=parseInt(filterData.substr(12,2),16);var vignetteId=Object(__WEBPACK_IMPORTED_MODULE_5__helpers_frameHelper__["e" /* getFrameClipVignetteId */])(Id,clip_id,idPrefix);var filterId=Object(__WEBPACK_IMPORTED_MODULE_5__helpers_frameHelper__["c" /* getFrameClipFilterId */])(Id,clip_id,filterData,idPrefix);var type=droppableItemData.getIn(["imgDetails","type"]);var subType=droppableItemData.getIn(["imgDetails","subType"]);var imgSrc=loadingImg.src;var isVideo=false;var videoSrc="";if(type==="STOCKVID"||type==="UPLOADS"&&subType==="UPVIDEO"||type==="PEXELS"&&subType==="VIDEO"||type==="PIXABAY"&&subType==="VIDEO"||subType==="OBGVID"){if(type==="UPLOADS"&&subType==="UPVIDEO"){if(!thumb.includes("https")){loadingImg.src=__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a["UPLOADS"][__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a["UPLOADS"][subType?'onload_'+subType:'workspace']]+thumb;}var thumbSource=thumb;if(!thumbSource.includes("https")){thumbSource=__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a["UPLOADS"][__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a["UPLOADS"][subType?'onload_'+subType:'workspace']]+thumb;}imgSrc=isImageHovered?loadingImg.src:thumbSource;isVideo=true;videoSrc=__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a["UPLOADS"][__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a["UPLOADS"][subType?'onload_'+subType:'workspace']]+src;}else if(type==="STOCKVID"){var _thumbSource=thumb;if(!_thumbSource.includes("https")){_thumbSource=__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a[type][__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a[type].onload]+thumb;}imgSrc=isImageHovered?loadingImg.src:_thumbSource;isVideo=true;videoSrc=__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a[type][__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a[type].workspace]+src;}else if(type==="PEXELS"&&subType==="VIDEO"||type==="PIXABAY"&&subType==="VIDEO"){imgSrc=isImageHovered?loadingImg.src:thumb;isVideo=true;videoSrc=src;}else if(subType==="OBGVID"){var _thumbSource2=thumb;if(!thumb.includes("https")){loadingImg.src=""+__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a.ASSETS[__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a.ASSETS.current]+__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a.BG.obgsrc+_thumbSource2;}if(!_thumbSource2.includes("https")){_thumbSource2=""+__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a.ASSETS[__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a.ASSETS.current]+__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a.BG.obgsrc+_thumbSource2;}imgSrc=isImageHovered?loadingImg.src:_thumbSource2;videoSrc=""+__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a.ASSETS[__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a.ASSETS.current]+__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a.BG.obgsrc+src;}}var onLoadImage=function onLoadImage(currIndex,status,imgSrc){try{if(status===true){console.log(currIndex,status,imgSrc,props.onLoadData,clip_id+"-"+props.Id);var imageId=clip_id+"-"+props.Id;props.onLoadData(imageId);}}catch(error){console.log(error);}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:imageContainerRef,style:containerStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FrameImage,{clip:clip_id,className:"img-item "+__WEBPACK_IMPORTED_MODULE_5__helpers_frameHelper__["a" /* FRAME_CLASSES */]["INNER_IMAGE"],alt:"FrameImage",style:{filter:"url(#"+filterId+")"},src:loading===false?imgSrc:"",ref:imageRef,draggable:false,onLoad:function onLoad(){return onLoadImage(currIndex,true,imgSrc);},onError:function onError(){return onLoadImage(currIndex,false,imgSrc);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VIGNETTE,{id:vignetteId,className:"vignette",style:{"--vignette":vignetteValue*0.007}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FilterItem,{key:clip_id+"_filter",clip:clip_id,filterId:filterId,filterCode:filterData,ItemID:Id,browserName:browserName,idPrefix:idPrefix}));}else if(loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Loader,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"loader",src:appUrl+"/images/chr-loading.gif"}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null);}}/* harmony default export */ __webpack_exports__["a"] = (InnerFrameImageComponent);

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Grid_GridComponent__ = __webpack_require__(424);
// import { gridObjectDropped, selectFrameClip, setPropertyWindow, updateSwapHoverDrop, updateTransformStatus } from "../actions";
var mapStateToProps=function mapStateToProps(){return{// zoomFactor: state.localStore.get("zoomFactor"),
// propertyWindow: state.localStore.get("propertyWindow"),
// transformStatus: state.localStore.get("transformStatus"),
// isLibraryItemDragging: state.localStore.get("isLibraryItemDragging"),
// libraryImageDrag: state.localStore.get("libraryImageDrag"),
// selectedItemId: state.localStore.getIn(["selectedItems", 0]),
// selectedItem:
//     state.localStore.get("selectedItems").size === 1
//         ? state.project.getIn([
//             "scenes", state.localStore.get("selectedScene"), "workspaceItems",
//             state.localStore.getIn(["selectedItems", 0])
//         ])
//         : undefined,
// swapHoverDrop: state.localStore.get("swapHoverDrop"),
// propertyWindow: state.localStore.get("propertyWindow"),
// selectedFrameClip: state.localStore.get("selectedFrameClip"),
// selectedScene: state.localStore.get("selectedScene"),
// sceneData: state.project.getIn(["scenes", state.localStore.get("selectedScene")]),
// isSwapping: state.localStore.get("swapDetails") ? true : false,
// selectedItems: state.localStore.get("selectedItems"),
};};var mapDispatchToProps=function mapDispatchToProps(){return{// selectFrameClip: (data) => dispatch(selectFrameClip(data)),
// setPropertyWindow: (data) => dispatch(setPropertyWindow(data)),
// updateSwapHoverDrop: (data) => dispatch(updateSwapHoverDrop(data)),
// updateTransformStatus: (data) => dispatch(updateTransformStatus(data)),
// gridObjectDropped: (data, socket) => dispatch(gridObjectDropped(data, socket)),
};};var Grid=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Grid_GridComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Grid);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GridComponent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styledComponent__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DroppableAreaComponent__ = __webpack_require__(425);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function GridComponent(props){var gridContainerRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var id=props.id,gridItemData=props.gridItemData,browserName=props.browserName,zoomFactor=props.zoomFactor,idPrefix=props.idPrefix;var onLoadData=function onLoadData(imageId){try{// if ((props.isFullScreen === true)) {
window.totalArr=window.totalArr.filter(function(e){return e!==imageId;});console.log(window.totalArr,"window.totalArr",imageId);// if (window.totalArr.length === 0) {
//     props.startPlay("workspace")
// }
// }
}catch(error){console.log(error);}};function renderDroppaleAreas(){var gridDetails=gridItemData.getIn(["gridData","gridCells"]);var gridCells=[];gridDetails.entrySeq().forEach(function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],cellData=_ref2[1];gridCells.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DroppableAreaComponent__["a" /* DroppableAreaComponent */],{key:key,cellId:key,itemId:id,Id:id,droppableCellData:cellData,gridItemData:gridItemData,gridCellWidth:cellData.get("cellWidth"),gridCellHeight:cellData.get("cellHeight"),browserName:browserName,zoomFactor:zoomFactor,idPrefix:idPrefix,onLoadData:onLoadData}));});return gridCells;}function gridContainerStyles(){return{gridTemplateAreas:gridItemData.getIn(["gridData","template","areas"]),gridTemplateColumns:gridItemData.getIn(["gridData","template","columns"]),gridTemplateRows:gridItemData.getIn(["gridData","template","rows"]),gap:gridItemData.getIn(["gridData","gap"])*zoomFactor};}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__styledComponent__["b" /* GridContainer */],{className:"inner-grid-"+(props.id+1),style:gridContainerStyles(),ref:gridContainerRef},renderDroppaleAreas());}

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DroppableAreaComponent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_app_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GridAreaComponent__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styledComponent__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_frameHelper__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_URLHelper__ = __webpack_require__(106);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var appUrl=__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['APPICONS'][__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['APPICONS']['current']];function DroppableAreaComponent(props){var droppableCellData=props.droppableCellData,gridItemData=props.gridItemData,gridCellWidth=props.gridCellWidth,gridCellHeight=props.gridCellHeight,cellId=props.cellId,itemId=props.itemId,idPrefix=props.idPrefix,onLoadData=props.onLoadData;var browserName=props.browserName,zoomFactor=props.zoomFactor,Id=props.Id;var imageRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef();var imageContainerRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();var droppableAreaGridRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showGridArea=_useState2[0],setShowGridArea=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),showImage=_useState4[0],setShowImage=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(getCellStyle(gridCellWidth,gridCellHeight)),_useState6=_slicedToArray(_useState5,2),cellStyle=_useState6[0],setCellStyle=_useState6[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){setCellStyle(getCellStyle(gridCellWidth,gridCellHeight));},[gridCellWidth,gridCellHeight]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(droppableCellData.getIn(["imgDetails","color"])!==undefined&&droppableCellData.getIn(["imgDetails","color"])!==""&&droppableCellData.getIn(["imgDetails","src"])===""){setShowGridArea(false);}else{// color picker undo
setShowGridArea(true);}},[droppableCellData]);function getCellStyle(itemWidth,itemHeight){return{width:itemWidth,height:itemHeight,gridArea:cellId};}Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(droppableCellData.get("color")||droppableCellData.get("imgDetails")){setShowGridArea(true);}else{setShowGridArea(false);}if(droppableCellData.get("imgDetails")!==undefined){setShowImage(true);}else{setShowImage(false);}},[droppableCellData]);function getSource(){var imageDetails=droppableCellData.getIn(["imgDetails"]);if(imageDetails){var defaultImageSrc=""+appUrl+imageDetails.getIn(["defaultImageDetails","src"]);var _getImageSource=Object(__WEBPACK_IMPORTED_MODULE_4__helpers_frameHelper__["i" /* getImageSource */])(imageDetails),src=_getImageSource.src;if(!imageDetails.get("src")&&!imageDetails.get('stickerify')&&!imageDetails.get('bgremoval')){return defaultImageSrc;}return src;}}function getFlipPosition(value){var flip=value===1?" scaleX(-1)":value===2?" scaleY(-1)":value===3?" scaleX(-1) scaleY(-1)":"";return flip;}function getStyles(){var styles={};// let flipPosition =
//     imageEffects && imageEffects.size > 0 &&
//         imageEffects.get("effectName") === "doubleExposure" &&
//         selectedItemId === itemId && selectedClipId === cellId
//         ? ""
//         : droppableCellData.getIn(["imgDetails", "flipPosition"]);
var flipPosition=droppableCellData.getIn(["imgDetails","flipPosition"]);flipPosition=flipPosition?flipPosition:0;if(droppableCellData.get("imgDetails")){var widthScale=droppableCellData.getIn(["imgDetails","original","width"]);var heightScale=droppableCellData.getIn(["imgDetails","original","height"]);var xScale=droppableCellData.getIn(["imgDetails","original","x"]);var yScale=droppableCellData.getIn(["imgDetails","original","y"]);styles={width:gridCellWidth*zoomFactor*widthScale,height:gridCellHeight*zoomFactor*heightScale,transform:"translate("+gridCellWidth*zoomFactor*xScale+"px, "+gridCellHeight*zoomFactor*yScale+"px) "+getFlipPosition(flipPosition)};}else{styles={};}if(droppableCellData.get("color")){var backgroundStyles={background:droppableCellData.get("color")};styles=Object.assign(styles,backgroundStyles);}return styles;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styledComponent__["a" /* DroppableAreaContainer */],{style:{width:cellStyle.width*zoomFactor+"px",height:cellStyle.height*zoomFactor+"px",gridArea:cellStyle.gridArea,pointerEvents:"none",borderRadius:gridItemData.getIn(["gridData","borderRadius"])?gridItemData.getIn(["gridData","borderRadius"])*zoomFactor+"px":0},className:"droppable_area_container cell-"+cellId+" "+__WEBPACK_IMPORTED_MODULE_4__helpers_frameHelper__["b" /* GRID_CLASSES */]["DROP_AREA"],id:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_frameHelper__["h" /* getGridDropAreaId */])(Id,cellId,idPrefix),ref:droppableAreaGridRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__GridAreaComponent__["a" /* GridAreaComponent */],{itemId:itemId,cellId:cellId,cellStyle:cellStyle,imageRef:imageRef,imageContainerRef:imageContainerRef,showGridArea:showGridArea,showImage:showImage,filterData:droppableCellData.getIn(["imgDetails","filter"]),droppableCellData:droppableCellData,flipPosition:gridItemData.get("flipPosition"),src:getSource(),thumb:Object(__WEBPACK_IMPORTED_MODULE_5__helpers_URLHelper__["a" /* getImageThumbnailURL */])(droppableCellData.getIn(["imgDetails","type"]),droppableCellData.getIn(["imgDetails","subType"]),droppableCellData.getIn(["imgDetails","thumb"])||droppableCellData.getIn(["imgDetails","thumbnail"])),containerStyles:getStyles(),browserName:browserName,idPrefix:idPrefix,onLoadData:onLoadData}));}

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GridAreaComponent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_app_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styledComponent__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ReturnSvgFilter__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Helpers_ColorConversion__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_frameHelper__ = __webpack_require__(47);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var assetUrl=__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a["APPICONS"][__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a["APPICONS"]["current"]];var appUrl=__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['APPICONS'][__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['APPICONS']['current']];function FilterItem(props){var clip=props.clip,ItemID=props.ItemID,filterCode=props.filterCode,filterId=props.filterId,browserName=props.browserName,idPrefix=props.idPrefix;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{id:Object(__WEBPACK_IMPORTED_MODULE_5__helpers_frameHelper__["d" /* getFrameClipFilterSvgId */])(ItemID,clip,idPrefix),style:browserName==="Firefox"?{width:"0",height:"0",display:"block"}:{display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("filter",{colorInterpolationFilters:"sRGB",id:filterId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ReturnSvgFilter__["a" /* ReturnSvgFilter */],{filterCode:filterCode}))))));}function GridAreaComponent(props){var droppableCellData=props.droppableCellData,showImage=props.showImage,showGridArea=props.showGridArea,cellId=props.cellId,itemId=props.itemId,src=props.src,containerStyles=props.containerStyles,imageRef=props.imageRef,imageContainerRef=props.imageContainerRef,filterData=props.filterData,thumb=props.thumb,idPrefix=props.idPrefix,onLoadData=props.onLoadData;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState2=_slicedToArray(_useState,2),loading=_useState2[0],setLoading=_useState2[1];var imageSource=src;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var image=new Image();setLoading(true);image.onload=function(){setLoading(false);};image.onerror=function(){setLoading(false);};image.src=thumb;},[imageSource]);var workspaceWidth=props.projectWidth;var workspaceHeight=props.projectHeight;var onLoadImage=function onLoadImage(status,imgSrc){try{if(status===true){var imageId=cellId+"-"+itemId;console.log(status,imgSrc,onLoadData,imageId);onLoadData(imageId);}}catch(error){console.log(error);}};if(showGridArea&&droppableCellData&&!droppableCellData.get("imgDetails")){if(containerStyles&&containerStyles.background){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styledComponent__["c" /* GridDefaultImage */],{className:__WEBPACK_IMPORTED_MODULE_5__helpers_frameHelper__["b" /* GRID_CLASSES */]["BG_COLOR"],assetUrl:assetUrl,style:{background:containerStyles.background}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styledComponent__["c" /* GridDefaultImage */],{className:__WEBPACK_IMPORTED_MODULE_5__helpers_frameHelper__["b" /* GRID_CLASSES */]["BG_COLOR"],assetUrl:assetUrl});}if(showGridArea){var duotone=void 0;var opacity=1;var imgDetails=droppableCellData.get("imgDetails");var filterCode=!filterData?"6464646464640032":filterData;var vignetteValue=parseInt(filterCode.substr(12,2),16);var vignetteId=Object(__WEBPACK_IMPORTED_MODULE_5__helpers_frameHelper__["e" /* getFrameClipVignetteId */])(itemId,cellId,idPrefix);var filterId=Object(__WEBPACK_IMPORTED_MODULE_5__helpers_frameHelper__["c" /* getFrameClipFilterId */])(itemId,cellId,filterCode,idPrefix);if(imgDetails&&imgDetails.get("imageEffectsData")){var vignetteItemId=cellId+"-vignette-"+itemId;var i=imgDetails.get("imageEffectsData").findIndex(function(data){return data.get("effectName")==="duotone";});var highlights=void 0,shadow=void 0;if(i>=0){highlights=Object(__WEBPACK_IMPORTED_MODULE_4__Helpers_ColorConversion__["a" /* getRGBAForDuotone */])(imgDetails.getIn(["imageEffectsData",i,"highlights"]));shadow=Object(__WEBPACK_IMPORTED_MODULE_4__Helpers_ColorConversion__["a" /* getRGBAForDuotone */])(imgDetails.getIn(["imageEffectsData",i,"shadow"]));duotone=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styledComponent__["d" /* GridImage */],{alt:"duo",src:imageSource,style:{position:"absolute",top:"0px",filter:"url(#filter_"+itemId+"_"+cellId+"_duotone)",opacity:1}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{id:"svgFilter_"+itemId+"_"+cellId+"_duotone",style:{width:"0",height:"0",position:"absolute"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("filter",{colorInterpolationFilters:"sRGB",id:"filter_"+itemId+"_"+cellId+"_duotone"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feColorMatrix",{type:"matrix",values:".33 .33 .33 0 0 .33 .33 .33 0 0 .33 .33 .33 0 0 0 0 0 1 0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComponentTransfer",{colorInterpolationFilters:"sRGB",result:"duotone"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncR",{type:"table",tableValues:shadow.r/255+"  "+highlights.r/255}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncG",{type:"table",tableValues:shadow.g/255+"  "+highlights.g/255}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncB",{type:"table",tableValues:shadow.b/255+"  "+highlights.b/255}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFuncA",{type:"table",tableValues:"0 1"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ReturnSvgFilter__["a" /* ReturnSvgFilter */],{filterCode:filterId,vignetteId:vignetteItemId,projectDimensions:{width:workspaceWidth,height:workspaceHeight}}))))));opacity=1-shadow.a;}}/*
        let imgSrc = thumb;
        let isVideo = false;
        let videoSrc = src;

        if (imgDetails) {
            const type = imgDetails.get("type");
            const subType = imgDetails.get("subType");
            if (!imageHovered) {
                if (type === "STOCKVID" || (type === "UPLOADS" && subType === "UPVIDEO") || (type === "PEXELS" && subType === "VIDEO") || (type === "PIXABAY" && subType === "VIDEO") || subType === "OBGVID") {
                    if ((type === "UPLOADS" && subType === "UPVIDEO")) {
                        if (!imgSrc.includes("https")) {
                            imgSrc = config["UPLOADS"][config["UPLOADS"][(subType) ? 'onload_' + subType : 'workspace']] + imgSrc
                        }
                        isVideo = true;
                        videoSrc = config["UPLOADS"][config["UPLOADS"][(subType) ? 'onload_' + subType : 'workspace']] + videoSrc;
                    } else if (type === "STOCKVID") {
                        if (!imgSrc.includes("https")) {
                            imgSrc = config[type][config[type].onload] + imgSrc;
                        }
                        isVideo = true;
                        if(!src.includes("https")) {
                            videoSrc = config[type][config[type].workspace] + videoSrc;
                        }
                    } else if ((type === "PEXELS" && subType === "VIDEO") || (type === "PIXABAY" && subType === "VIDEO")) {
                        isVideo = true;
                    } else if (subType === "OBGVID") {
                        if (!imgSrc.includes("https")) {
                            imgSrc = `${config.ASSETS[config.ASSETS.current]}${config.BG.obgsrc}${imgSrc}`;
                        }
                        isVideo = true;
                        videoSrc = `${config.ASSETS[config.ASSETS.current]}${config.BG.obgsrc}${videoSrc}`;
                    }
                }
            }
        }

        if (!isVideo) {
            videoSrc = "";
            imgSrc = imageSource;
        }
        */if(loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styledComponent__["f" /* Loader */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"loader",src:appUrl+"/images/chr-loading.gif"}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styledComponent__["e" /* ImageContainer */],{ref:imageContainerRef,className:"grid_image_container_"+cellId+" "+__WEBPACK_IMPORTED_MODULE_5__helpers_frameHelper__["b" /* GRID_CLASSES */]["BG_COLOR"],style:containerStyles},showImage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,duotone,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styledComponent__["d" /* GridImage */],{clip:cellId,"data-alt":"cellImage",ref:imageRef// src={imgSrc}
,src:imageSource,alt:"cellImage",style:{opacity:opacity,filter:"url(#"+filterId+")"},className:"img-item "+__WEBPACK_IMPORTED_MODULE_5__helpers_frameHelper__["b" /* GRID_CLASSES */]["INNER_IMAGE"],onLoad:function onLoad(){return onLoadImage(true,imageSource);},onError:function onError(){return onLoadImage(false,imageSource);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styledComponent__["g" /* VIGNETTE */],{id:vignetteId,className:"vignette",style:{"--vignette":vignetteValue*0.007}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FilterItem,{key:cellId+"_filter",clip:cellId,filterId:filterId,filterCode:filterData,ItemID:itemId,browserName:props.browserName,idPrefix:idPrefix})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styledComponent__["c" /* GridDefaultImage */],{className:__WEBPACK_IMPORTED_MODULE_5__helpers_frameHelper__["b" /* GRID_CLASSES */]["BG_COLOR"],assetUrl:assetUrl});}

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HSLAToRGBA */
/* unused harmony export RGBTextToHex */
/* unused harmony export hexAToRGBA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRGBAForDuotone; });
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/**
 * Color Value Converter
 */// Convert HSLA to RGBA
var HSLAToRGBA=function HSLAToRGBA(h,s,l,a,toHex){s/=100;l/=100;var c=(1-Math.abs(2*l-1))*s,x=c*(1-Math.abs(h/60%2-1)),m=l-c/2,r=0,g=0,b=0;if(0<=h&&h<60){r=c;g=x;b=0;}else if(60<=h&&h<120){r=x;g=c;b=0;}else if(120<=h&&h<180){r=0;g=c;b=x;}else if(180<=h&&h<240){r=0;g=x;b=c;}else if(240<=h&&h<300){r=x;g=0;b=c;}else if(300<=h&&h<360){r=c;g=0;b=x;}r=Math.round((r+m)*255);g=Math.round((g+m)*255);b=Math.round((b+m)*255);if(toHex===true){return RGBAToHexA(r,g,b,a);}else{return{r:r,g:g,b:b,a:a};}};// Convert RGBA to HSLA
var RGBAToHSLA=function RGBAToHSLA(r,g,b,a){r/=255;g/=255;b/=255;a=a==undefined?1:a;var cmin=Math.min(r,g,b),cmax=Math.max(r,g,b),delta=cmax-cmin,h=0,s=0,l=0;if(delta==0)h=0;else if(cmax==r)h=(g-b)/delta%6;else if(cmax==g)h=(b-r)/delta+2;else h=(r-g)/delta+4;h=Math.round(h*60);if(h<0)h+=360;l=(cmax+cmin)/2;s=delta==0?0:delta/(1-Math.abs(2*l-1));s=+(s*100).toFixed(1);l=+(l*100).toFixed(1);return{h:h,s:s,l:l,a:a};};// Convert RGBA to HexA
var RGBAToHexA=function RGBAToHexA(r,g,b,a){r=r.toString(16);g=g.toString(16);b=b.toString(16);a=Math.round(a*255).toString(16);if(r.length==1)r='0'+r;if(g.length==1)g='0'+g;if(b.length==1)b='0'+b;if(a.length==1)a='0'+a;if(a=='ff'){return'#'+r+g+b;}else{return'#'+r+g+b+a;}};// rgb(c,c,c) to Hex
var RGBTextToHex=function RGBTextToHex(rgb){// Choose correct separator
var sep=rgb.indexOf(",")>-1?",":" ";// Turn "rgb(r,g,b)" into [r,g,b]
rgb=rgb.substr(4).split(")")[0].split(sep);var r=(+rgb[0]).toString(16),g=(+rgb[1]).toString(16),b=(+rgb[2]).toString(16);if(r.length==1)r="0"+r;if(g.length==1)g="0"+g;if(b.length==1)b="0"+b;return"#"+r+g+b;};// Convert HexA to RGBA
var hexAToRGBA=function hexAToRGBA(h,toHSL){if(h.length==7)h+='ff';else if(h.length==4)h+=h.substring(1,4)+'ff';var r=0,g=0,b=0,a=1;if(h.length==5){r='0x'+h[1]+h[1];g='0x'+h[2]+h[2];b='0x'+h[3]+h[3];a='0x'+h[4]+h[4];}else if(h.length==9){r='0x'+h[1]+h[2];g='0x'+h[3]+h[4];b='0x'+h[5]+h[6];a='0x'+h[7]+h[8];}a=+(a/255).toFixed(3);if(toHSL===true){return RGBAToHSLA(+r,+g,+b,a);}else{return'rgba('+ +r+','+ +g+','+ +b+','+a+')';}};var getRGBAForDuotone=function getRGBAForDuotone(source){if(source){if(source.includes("#")){source=hexAToRGBA(source);}var _source$replace$split=source.replace(/[^\d,.]/g,"").split(","),_source$replace$split2=_slicedToArray(_source$replace$split,4),r=_source$replace$split2[0],g=_source$replace$split2[1],b=_source$replace$split2[2],a=_source$replace$split2[3];return{r:r,g:g,b:b,a:a};}return{r:255,g:255,b:255,a:0.5};};

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HyperLinkToolBarComponent__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_index__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state,ownProps){return{selectedScene:state.localStore.get("selectedScene"),selectedItems:state.localStore.get("selectedItems"),workspaceWidth:state.project.get("width"),workspaceHeight:state.project.get("height"),selectedObjects:state.project.getIn(["scenes",state.localStore.get("selectedScene"),"workspaceItems"]).filter(function(obj,key){return state.localStore.get("selectedItems").keyOf(key)!==undefined;}),zoomFactor:state.localStore.get('zoomFactor'),workspaceBounds:state.localStore.get('workspaceBounds'),selectionBox:state.localStore.get("selectionBox"),workspaceChildren:state.project.getIn(["scenes",state.localStore.get("selectedScene"),"workspaceChildren"]),propertyWindow:state.localStore.get("propertyWindow"),textStatus:state.localStore.get("textStatus"),isWorkspaceTextFocus:state.localStore.get('isWorkspaceTextFocus'),transformStatus:state.localStore.get('transformStatus'),workspaceStage:state.localStore.get("workspaceStage"),showSlidePanel:state.localStore.get("showSlidePanel"),animakerType:state.localStore.get('animakerType'),undoProp:state.localStore.get('undoProp'),updateItems:state.localStore.get('itemToUpdate'),textOffset:state.localStore.get('textOffset'),scenes:state.project.getIn(["scenes"])};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{addLinkToText:function addLinkToText(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["d" /* addLinkToText */])(data,socket));},addLinkToObj:function addLinkToObj(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["b" /* addLinkToObj */])(data,socket));},setSelectedScene:function setSelectedScene(data,time,selectedScenes,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_46" /* setSelectedScene */])(data,time,selectedScenes,socket));}};};var HyperLinkToolBar=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_HyperLinkToolBarComponent__["a" /* default */]);/* unused harmony default export */ var _unused_webpack_default_export = (HyperLinkToolBar);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_app_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__ = __webpack_require__(9);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HyperLinkToolBarComponent=function(_React$Component){_inherits(HyperLinkToolBarComponent,_React$Component);function HyperLinkToolBarComponent(props){_classCallCheck(this,HyperLinkToolBarComponent);var _this=_possibleConstructorReturn(this,(HyperLinkToolBarComponent.__proto__||Object.getPrototypeOf(HyperLinkToolBarComponent)).call(this,props));_this.appUrl=__WEBPACK_IMPORTED_MODULE_2__config_app_json___default.a['APPICONS'][__WEBPACK_IMPORTED_MODULE_2__config_app_json___default.a['APPICONS']['current']];_this.assetUrl=__WEBPACK_IMPORTED_MODULE_2__config_app_json___default.a['ASSETS'][__WEBPACK_IMPORTED_MODULE_2__config_app_json___default.a['ASSETS']['current']];_this.removeLink=_this.removeLink.bind(_this);_this.goToLinkpage=_this.goToLinkpage.bind(_this);return _this;}_createClass(HyperLinkToolBarComponent,[{key:'getCorner',value:function getCorner(pivotX,pivotY,cornerX,cornerY,angle){var x,y,distance,diffX,diffY;/// get distance from center to point
diffX=cornerX-pivotX;diffY=cornerY-pivotY;distance=Math.sqrt(diffX*diffX+diffY*diffY);/// find angle from pivot to corner
angle+=Math.atan2(diffY,diffX);/// get new x and y and round it off to integer
x=pivotX+distance*Math.cos(angle);y=pivotY+distance*Math.sin(angle);return{x:x,y:y};}},{key:'getSelectionBoxBounds',value:function getSelectionBoxBounds(data){var angle=data.angle*Math.PI/180;var c1,c2,c3,c4,/// corners
bx1,by1,bx2,by2,bounds;c1=this.getCorner(data.cx,data.cy,data.x,data.y,angle);c2=this.getCorner(data.cx,data.cy,data.x+data.width,data.y,angle);c3=this.getCorner(data.cx,data.cy,data.x+data.width,data.y+data.height,angle);c4=this.getCorner(data.cx,data.cy,data.x,data.y+data.height,angle);/// get bounding box
bx1=Math.min(c1.x,c2.x,c3.x,c4.x);by1=Math.min(c1.y,c2.y,c3.y,c4.y);bx2=Math.max(c1.x,c2.x,c3.x,c4.x);by2=Math.max(c1.y,c2.y,c3.y,c4.y);bounds={x:parseFloat(bx1.toFixed(2)),y:parseFloat(by1.toFixed(2)),width:parseFloat((bx2-bx1).toFixed(2)),height:parseFloat((by2-by1).toFixed(2))};return bounds;}},{key:'getObjectsBounds',value:function getObjectsBounds(objects,zoomFactor){var _this2=this;var minX=0,maxX=0,minY=0,maxY=0,width=0,height=0;var count=0;objects.entrySeq().forEach(function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],item=_ref2[1];var bounds=void 0,x=void 0,y=void 0,width=void 0,height=void 0;bounds=_this2.getSelectionBoxBounds({x:item.get("x"),y:item.get("y"),cx:item.get("x")+item.get("width")/2,cy:item.get("y")+item.get("height")/2,width:item.get("width"),height:item.get("height"),angle:item.get("angle")});x=bounds.x;y=bounds.y;width=bounds.width;height=bounds.height;if(count===0){minX=x;maxX=x+width;minY=y;maxY=y+height;count++;}else{minX=Math.min(minX,x);maxX=Math.max(maxX,x+width);minY=Math.min(minY,y);maxY=Math.max(maxY,y+height);}});width=(maxX-minX)*this.props.zoomFactor;height=(maxY-minY)*this.props.zoomFactor;minX*=this.props.zoomFactor;minY*=this.props.zoomFactor;var x=this.props.workspaceWidth*this.props.zoomFactor<=this.props.workspaceBounds.get("width")?this.props.workspaceBounds.get("cx")-this.props.workspaceWidth*this.props.zoomFactor/2:this.props.workspaceBounds.get("cx")-this.props.workspaceBounds.get("width")/2,y=this.props.workspaceHeight*this.props.zoomFactor<=this.props.workspaceBounds.get("height")?this.props.workspaceBounds.get("cy")-this.props.workspaceHeight*this.props.zoomFactor/2:this.props.workspaceBounds.get("cy")-this.props.workspaceBounds.get("height")/2;return{x:x+minX,y:y+minY,width:width,height:height};}},{key:'getToolBarXY',value:function getToolBarXY(){var allItems=void 0;if(this.props.selectedItems.size>0){allItems=this.props.selectedObjects;if(this.props.selectedItems.size===1){var item=this.props.selectedObjects.first();}}if(allItems!==undefined){var bounds=this.getObjectsBounds(allItems,this.props.zoomFactor);var stageLeft=this.props.workspaceStage.getIn(["left","menu"]);var stageTop=this.props.workspaceStage.getIn(["top","menu"]);var stageRight=window.innerWidth;if(document.getElementsByClassName("app-lib-container")[0].className.indexOf("opened")!==-1)stageLeft+=this.props.workspaceStage.getIn(["left","library"]);if(this.props.propertyWindow.get("isOpened")===true&&document.getElementsByClassName("property-window-container")[0]){stageRight-=document.getElementsByClassName("property-window-container")[0].offsetWidth;}else if(this.props.showSlidePanel){stageRight-=document.getElementsByClassName("slide-panel")[0].offsetWidth;}var toolBarX=bounds.x+bounds.width+10,toolBarY=bounds.y;return{x:toolBarX,y:toolBarY};}else{return{x:stageRight-this.hyperlinkContainer.offsetWidth-10,y:stageTop+10};}}},{key:'componentDidMount',value:function componentDidMount(){var toolBarXY=this.getToolBarXY();this.hyperlinkContainer.style.left=toolBarXY.x-this.hyperlinkContainer.offsetWidth-10+"px";this.hyperlinkContainer.style.top=toolBarXY.y-this.hyperlinkContainer.offsetHeight-10+"px";}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var toolBarXY=this.getToolBarXY();this.hyperlinkContainer.style.left=toolBarXY.x-this.hyperlinkContainer.offsetWidth-10+"px";this.hyperlinkContainer.style.top=toolBarXY.y-this.hyperlinkContainer.offsetHeight-10+"px";}},{key:'removeLink',value:function removeLink(e){try{if(this.props.isaddLinkToObj){this.props.addLinkToObj({selectedScene:this.props.selectedScene,selectedItem:this.props.selectedItems.get(0),linkData:{'link':''}},this.props.socket);}else{this.props.addLinkToText({selectedScene:this.props.selectedScene,container:this.props.textStatus.get('container'),selectedItem:this.props.textStatus.get('id'),hyperLinkData:{'link':''}},this.props.socket);}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"HyperLinkToolBarComponent-removeLink");}}},{key:'goToLinkpage',value:function goToLinkpage(e){try{e.preventDefault();if(!this.props.hyperlinkText.match("^Slide")){var url=this.props.hyperlinkText;var newWindow=url.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)!==null?window.open('/','_self'):window.open('/');if(url.indexOf("https://")!==0&&url.indexOf("http://")!==0){if(url.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)!==null)url='mailto:'+url;else url='http://'+url;}newWindow.location=url;}else{var curSlide=parseInt(this.props.hyperlinkText.replace(/[^0-9\.]+/g,""));this.props.setSelectedScene(curSlide-1,this.props.scenes.getIn([curSlide-1,'startTime']),[curSlide-1],this.props.socket);}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_4__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"HyperLinkToolBarComponent-goToLinkpage");}}},{key:'render',value:function render(){var _this3=this,_ref3;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(instance){return _this3.hyperlinkContainer=instance;},className:'hyperlink-tool-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hyperlink-Contentbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'url-holder'},this.props.hyperlinkText.match("^Slide")?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slide-main',style:{width:'20px',right:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slide-first'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'slide-content'},this.props.hyperlinkText.replace(/[^0-9\.]+/g,""))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slide-second'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'url',src:this.appUrl+'/images/url.svg',style:{width:'18px',height:'18px',marginLeft:'4px',marginTop:'8px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:(_ref3={color:'#414758',textAlign:'center',padding:'8px',cursor:'pointer',userSelect:'none',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'},_defineProperty(_ref3,'overflow','hidden'),_defineProperty(_ref3,'maxWidth','315px'),_ref3),onClick:function onClick(e){return _this3.goToLinkpage(e);}},this.props.hyperlinkText)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'8px',cursor:'pointer',borderLeft:'1px solid #8796c1'},className:'hl-remove',onMouseMove:function onMouseMove(e){var toolTip=document.querySelector('.hl_remove_tool_tip');var toolItem=document.querySelector('.hl-remove');if(toolItem){if(toolTip){toolTip.style.display='';toolTip.style.top=e.clientY+15+'px';toolTip.style.left=e.clientX-toolTip.offsetWidth/2+'px';}}},onMouseLeave:function onMouseLeave(e){var toolTip=document.querySelector('.hl_remove_tool_tip');if(toolTip){toolTip.style.display='none';}},onClick:function onClick(e){_this3.removeLink(e);var toolTip=document.querySelector('.hl_remove_tool_tip');if(toolTip){toolTip.style.display='none';}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'url',src:this.appUrl+'/images/deleteLink.svg',style:{width:'18px',height:'18px',marginTop:'8px'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:'hl.t.t',children:function children(val){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"hl_remove_tool_tip",style:{'display':'none','float':'right'}},val);}}));}}]);return HyperLinkToolBarComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (HyperLinkToolBarComponent);

/***/ }),
/* 430 */
/***/ (function(module, exports) {

/**
 * The MIT License (MIT)
 *
 * Copyright (c) 2013 mediapeers GmbH
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */

/**
 * The main MIM namespace
 */
var MIM = {};

/**
 * @constat
 */

MIM.VERSION = '0.3.1';

/**
 * Object containig MIME types with their extensions
 * Source: http://svn.apache.org/repos/asf/httpd/httpd/trunk/docs/conf/mime.types
 *
 * @constant
 */
MIM.MIME_TYPES = {
  "123":               "application/vnd.lotus-1-2-3",
  "ez":                "application/andrew-inset",
  "aw":                "application/applixware",
  "atom":              "application/atom+xml",
  "atomcat":           "application/atomcat+xml",
  "atomsvc":           "application/atomsvc+xml",
  "ccxml":             "application/ccxml+xml",
  "cdmia":             "application/cdmi-capability",
  "cdmic":             "application/cdmi-container",
  "cdmid":             "application/cdmi-domain",
  "cdmio":             "application/cdmi-object",
  "cdmiq":             "application/cdmi-queue",
  "cu":                "application/cu-seeme",
  "davmount":          "application/davmount+xml",
  "dbk":               "application/docbook+xml",
  "dssc":              "application/dssc+der",
  "xdssc":             "application/dssc+xml",
  "ecma":              "application/ecmascript",
  "emma":              "application/emma+xml",
  "epub":              "application/epub+zip",
  "exi":               "application/exi",
  "pfr":               "application/font-tdpfr",
  "gml":               "application/gml+xml",
  "gpx":               "application/gpx+xml",
  "gxf":               "application/gxf",
  "stk":               "application/hyperstudio",
  "ink":               "application/inkml+xml",
  "inkml":             "application/inkml+xml",
  "ipfix":             "application/ipfix",
  "jar":               "application/java-archive",
  "ser":               "application/java-serialized-object",
  "class":             "application/java-vm",
  "js":                "application/javascript",
  "json":              "application/json",
  "jsonml":            "application/jsonml+json",
  "lostxml":           "application/lost+xml",
  "hqx":               "application/mac-binhex40",
  "cpt":               "application/mac-compactpro",
  "mads":              "application/mads+xml",
  "mrc":               "application/marc",
  "mrcx":              "application/marcxml+xml",
  "ma":                "application/mathematica",
  "nb":                "application/mathematica",
  "mb":                "application/mathematica",
  "mathml":            "application/mathml+xml",
  "mbox":              "application/mbox",
  "mscml":             "application/mediaservercontrol+xml",
  "metalink":          "application/metalink+xml",
  "meta4":             "application/metalink4+xml",
  "mets":              "application/mets+xml",
  "mods":              "application/mods+xml",
  "m21":               "application/mp21",
  "mp21":              "application/mp21",
  "mp4s":              "application/mp4",
  "doc":               "application/msword",
  "dot":               "application/msword",
  "mxf":               "application/mxf",
  "bin":               "application/octet-stream",
  "dms":               "application/octet-stream",
  "lrf":               "application/octet-stream",
  "mar":               "application/octet-stream",
  "so":                "application/octet-stream",
  "dist":              "application/octet-stream",
  "distz":             "application/octet-stream",
  "pkg":               "application/octet-stream",
  "bpk":               "application/octet-stream",
  "dump":              "application/octet-stream",
  "elc":               "application/octet-stream",
  "deploy":            "application/octet-stream",
  "oda":               "application/oda",
  "opf":               "application/oebps-package+xml",
  "ogx":               "application/ogg",
  "omdoc":             "application/omdoc+xml",
  "onetoc":            "application/onenote",
  "onetoc2":           "application/onenote",
  "onetmp":            "application/onenote",
  "onepkg":            "application/onenote",
  "oxps":              "application/oxps",
  "xer":               "application/patch-ops-error+xml",
  "pdf":               "application/pdf",
  "pgp":               "application/pgp-encrypted",
  "asc":               "application/pgp-signature",
  "sig":               "application/pgp-signature",
  "prf":               "application/pics-rules",
  "p10":               "application/pkcs10",
  "p7m":               "application/pkcs7-mime",
  "p7c":               "application/pkcs7-mime",
  "p7s":               "application/pkcs7-signature",
  "p8":                "application/pkcs8",
  "ac":                "application/pkix-attr-cert",
  "cer":               "application/pkix-cert",
  "crl":               "application/pkix-crl",
  "pkipath":           "application/pkix-pkipath",
  "pki":               "application/pkixcmp",
  "pls":               "application/pls+xml",
  "ai":                "application/postscript",
  "eps":               "application/postscript",
  "ps":                "application/postscript",
  "cww":               "application/prs.cww",
  "pskcxml":           "application/pskc+xml",
  "rdf":               "application/rdf+xml",
  "rif":               "application/reginfo+xml",
  "rnc":               "application/relax-ng-compact-syntax",
  "rl":                "application/resource-lists+xml",
  "rld":               "application/resource-lists-diff+xml",
  "rs":                "application/rls-services+xml",
  "gbr":               "application/rpki-ghostbusters",
  "mft":               "application/rpki-manifest",
  "roa":               "application/rpki-roa",
  "rsd":               "application/rsd+xml",
  "rss":               "application/rss+xml",
  "rtf":               "application/rtf",
  "sbml":              "application/sbml+xml",
  "scq":               "application/scvp-cv-request",
  "scs":               "application/scvp-cv-response",
  "spq":               "application/scvp-vp-request",
  "spp":               "application/scvp-vp-response",
  "sdp":               "application/sdp",
  "setpay":            "application/set-payment-initiation",
  "setreg":            "application/set-registration-initiation",
  "shf":               "application/shf+xml",
  "smi":               "application/smil+xml",
  "smil":              "application/smil+xml",
  "rq":                "application/sparql-query",
  "srx":               "application/sparql-results+xml",
  "gram":              "application/srgs",
  "grxml":             "application/srgs+xml",
  "sru":               "application/sru+xml",
  "ssdl":              "application/ssdl+xml",
  "ssml":              "application/ssml+xml",
  "tei":               "application/tei+xml",
  "teicorpus":         "application/tei+xml",
  "tfi":               "application/thraud+xml",
  "tsd":               "application/timestamped-data",
  "plb":               "application/vnd.3gpp.pic-bw-large",
  "psb":               "application/vnd.3gpp.pic-bw-small",
  "pvb":               "application/vnd.3gpp.pic-bw-var",
  "tcap":              "application/vnd.3gpp2.tcap",
  "pwn":               "application/vnd.3m.post-it-notes",
  "aso":               "application/vnd.accpac.simply.aso",
  "imp":               "application/vnd.accpac.simply.imp",
  "acu":               "application/vnd.acucobol",
  "atc":               "application/vnd.acucorp",
  "acutc":             "application/vnd.acucorp",
  "air":               "application/vnd.adobe.air-application-installer-package+zip",
  "fcdt":              "application/vnd.adobe.formscentral.fcdt",
  "fxp":               "application/vnd.adobe.fxp",
  "fxpl":              "application/vnd.adobe.fxp",
  "xdp":               "application/vnd.adobe.xdp+xml",
  "xfdf":              "application/vnd.adobe.xfdf",
  "ahead":             "application/vnd.ahead.space",
  "azf":               "application/vnd.airzip.filesecure.azf",
  "azs":               "application/vnd.airzip.filesecure.azs",
  "azw":               "application/vnd.amazon.ebook",
  "acc":               "application/vnd.americandynamics.acc",
  "ami":               "application/vnd.amiga.ami",
  "apk":               "application/vnd.android.package-archive",
  "cii":               "application/vnd.anser-web-certificate-issue-initiation",
  "fti":               "application/vnd.anser-web-funds-transfer-initiation",
  "atx":               "application/vnd.antix.game-component",
  "mpkg":              "application/vnd.apple.installer+xml",
  "m3u8":              "application/vnd.apple.mpegurl",
  "swi":               "application/vnd.aristanetworks.swi",
  "iota":              "application/vnd.astraea-software.iota",
  "aep":               "application/vnd.audiograph",
  "mpm":               "application/vnd.blueice.multipass",
  "bmi":               "application/vnd.bmi",
  "rep":               "application/vnd.businessobjects",
  "cdxml":             "application/vnd.chemdraw+xml",
  "mmd":               "application/vnd.chipnuts.karaoke-mmd",
  "cdy":               "application/vnd.cinderella",
  "cla":               "application/vnd.claymore",
  "rp9":               "application/vnd.cloanto.rp9",
  "c4g":               "application/vnd.clonk.c4group",
  "c4d":               "application/vnd.clonk.c4group",
  "c4f":               "application/vnd.clonk.c4group",
  "c4p":               "application/vnd.clonk.c4group",
  "c4u":               "application/vnd.clonk.c4group",
  "c11amc":            "application/vnd.cluetrust.cartomobile-config",
  "c11amz":            "application/vnd.cluetrust.cartomobile-config-pkg",
  "csp":               "application/vnd.commonspace",
  "cdbcmsg":           "application/vnd.contact.cmsg",
  "cmc":               "application/vnd.cosmocaller",
  "clkx":              "application/vnd.crick.clicker",
  "clkk":              "application/vnd.crick.clicker.keyboard",
  "clkp":              "application/vnd.crick.clicker.palette",
  "clkt":              "application/vnd.crick.clicker.template",
  "clkw":              "application/vnd.crick.clicker.wordbank",
  "wbs":               "application/vnd.criticaltools.wbs+xml",
  "pml":               "application/vnd.ctc-posml",
  "ppd":               "application/vnd.cups-ppd",
  "car":               "application/vnd.curl.car",
  "pcurl":             "application/vnd.curl.pcurl",
  "dart":              "application/vnd.dart",
  "rdz":               "application/vnd.data-vision.rdz",
  "uvf":               "application/vnd.dece.data",
  "uvvf":              "application/vnd.dece.data",
  "uvd":               "application/vnd.dece.data",
  "uvvd":              "application/vnd.dece.data",
  "uvt":               "application/vnd.dece.ttml+xml",
  "uvvt":              "application/vnd.dece.ttml+xml",
  "uvx":               "application/vnd.dece.unspecified",
  "uvvx":              "application/vnd.dece.unspecified",
  "uvz":               "application/vnd.dece.zip",
  "uvvz":              "application/vnd.dece.zip",
  "fe_launch":         "application/vnd.denovo.fcselayout-link",
  "dna":               "application/vnd.dna",
  "mlp":               "application/vnd.dolby.mlp",
  "dpg":               "application/vnd.dpgraph",
  "dfac":              "application/vnd.dreamfactory",
  "kpxx":              "application/vnd.ds-keypoint",
  "ait":               "application/vnd.dvb.ait",
  "svc":               "application/vnd.dvb.service",
  "geo":               "application/vnd.dynageo",
  "mag":               "application/vnd.ecowin.chart",
  "nml":               "application/vnd.enliven",
  "esf":               "application/vnd.epson.esf",
  "msf":               "application/vnd.epson.msf",
  "qam":               "application/vnd.epson.quickanime",
  "slt":               "application/vnd.epson.salt",
  "ssf":               "application/vnd.epson.ssf",
  "es3":               "application/vnd.eszigno3+xml",
  "et3":               "application/vnd.eszigno3+xml",
  "ez2":               "application/vnd.ezpix-album",
  "ez3":               "application/vnd.ezpix-package",
  "fdf":               "application/vnd.fdf",
  "mseed":             "application/vnd.fdsn.mseed",
  "seed":              "application/vnd.fdsn.seed",
  "dataless":          "application/vnd.fdsn.seed",
  "gph":               "application/vnd.flographit",
  "ftc":               "application/vnd.fluxtime.clip",
  "fm":                "application/vnd.framemaker",
  "frame":             "application/vnd.framemaker",
  "maker":             "application/vnd.framemaker",
  "book":              "application/vnd.framemaker",
  "fnc":               "application/vnd.frogans.fnc",
  "ltf":               "application/vnd.frogans.ltf",
  "fsc":               "application/vnd.fsc.weblaunch",
  "oas":               "application/vnd.fujitsu.oasys",
  "oa2":               "application/vnd.fujitsu.oasys2",
  "oa3":               "application/vnd.fujitsu.oasys3",
  "fg5":               "application/vnd.fujitsu.oasysgp",
  "bh2":               "application/vnd.fujitsu.oasysprs",
  "ddd":               "application/vnd.fujixerox.ddd",
  "xdw":               "application/vnd.fujixerox.docuworks",
  "xbd":               "application/vnd.fujixerox.docuworks.binder",
  "fzs":               "application/vnd.fuzzysheet",
  "txd":               "application/vnd.genomatix.tuxedo",
  "ggb":               "application/vnd.geogebra.file",
  "ggt":               "application/vnd.geogebra.tool",
  "gex":               "application/vnd.geometry-explorer",
  "gre":               "application/vnd.geometry-explorer",
  "gxt":               "application/vnd.geonext",
  "g2w":               "application/vnd.geoplan",
  "g3w":               "application/vnd.geospace",
  "gmx":               "application/vnd.gmx",
  "kml":               "application/vnd.google-earth.kml+xml",
  "kmz":               "application/vnd.google-earth.kmz",
  "gqf":               "application/vnd.grafeq",
  "gqs":               "application/vnd.grafeq",
  "gac":               "application/vnd.groove-account",
  "ghf":               "application/vnd.groove-help",
  "gim":               "application/vnd.groove-identity-message",
  "grv":               "application/vnd.groove-injector",
  "gtm":               "application/vnd.groove-tool-message",
  "tpl":               "application/vnd.groove-tool-template",
  "vcg":               "application/vnd.groove-vcard",
  "hal":               "application/vnd.hal+xml",
  "zmm":               "application/vnd.handheld-entertainment+xml",
  "hbci":              "application/vnd.hbci",
  "les":               "application/vnd.hhe.lesson-player",
  "hpgl":              "application/vnd.hp-hpgl",
  "hpid":              "application/vnd.hp-hpid",
  "hps":               "application/vnd.hp-hps",
  "jlt":               "application/vnd.hp-jlyt",
  "pcl":               "application/vnd.hp-pcl",
  "pclxl":             "application/vnd.hp-pclxl",
  "sfd-hdstx":         "application/vnd.hydrostatix.sof-data",
  "mpy":               "application/vnd.ibm.minipay",
  "afp":               "application/vnd.ibm.modcap",
  "listafp":           "application/vnd.ibm.modcap",
  "list3820":          "application/vnd.ibm.modcap",
  "irm":               "application/vnd.ibm.rights-management",
  "sc":                "application/vnd.ibm.secure-container",
  "icc":               "application/vnd.iccprofile",
  "icm":               "application/vnd.iccprofile",
  "igl":               "application/vnd.igloader",
  "ivp":               "application/vnd.immervision-ivp",
  "ivu":               "application/vnd.immervision-ivu",
  "igm":               "application/vnd.insors.igm",
  "xpw":               "application/vnd.intercon.formnet",
  "xpx":               "application/vnd.intercon.formnet",
  "i2g":               "application/vnd.intergeo",
  "qbo":               "application/vnd.intu.qbo",
  "qfx":               "application/vnd.intu.qfx",
  "rcprofile":         "application/vnd.ipunplugged.rcprofile",
  "irp":               "application/vnd.irepository.package+xml",
  "xpr":               "application/vnd.is-xpr",
  "fcs":               "application/vnd.isac.fcs",
  "jam":               "application/vnd.jam",
  "rms":               "application/vnd.jcp.javame.midlet-rms",
  "jisp":              "application/vnd.jisp",
  "joda":              "application/vnd.joost.joda-archive",
  "ktz":               "application/vnd.kahootz",
  "ktr":               "application/vnd.kahootz",
  "karbon":            "application/vnd.kde.karbon",
  "chrt":              "application/vnd.kde.kchart",
  "kfo":               "application/vnd.kde.kformula",
  "flw":               "application/vnd.kde.kivio",
  "kon":               "application/vnd.kde.kontour",
  "kpr":               "application/vnd.kde.kpresenter",
  "kpt":               "application/vnd.kde.kpresenter",
  "ksp":               "application/vnd.kde.kspread",
  "kwd":               "application/vnd.kde.kword",
  "kwt":               "application/vnd.kde.kword",
  "htke":              "application/vnd.kenameaapp",
  "kia":               "application/vnd.kidspiration",
  "kne":               "application/vnd.kinar",
  "knp":               "application/vnd.kinar",
  "skp":               "application/vnd.koan",
  "skd":               "application/vnd.koan",
  "skt":               "application/vnd.koan",
  "skm":               "application/vnd.koan",
  "sse":               "application/vnd.kodak-descriptor",
  "lasxml":            "application/vnd.las.las+xml",
  "lbd":               "application/vnd.llamagraphics.life-balance.desktop",
  "lbe":               "application/vnd.llamagraphics.life-balance.exchange+xml",
  "apr":               "application/vnd.lotus-approach",
  "pre":               "application/vnd.lotus-freelance",
  "nsf":               "application/vnd.lotus-notes",
  "org":               "application/vnd.lotus-organizer",
  "scm":               "application/vnd.lotus-screencam",
  "lwp":               "application/vnd.lotus-wordpro",
  "portpkg":           "application/vnd.macports.portpkg",
  "mcd":               "application/vnd.mcd",
  "mc1":               "application/vnd.medcalcdata",
  "cdkey":             "application/vnd.mediastation.cdkey",
  "mwf":               "application/vnd.mfer",
  "mfm":               "application/vnd.mfmp",
  "flo":               "application/vnd.micrografx.flo",
  "igx":               "application/vnd.micrografx.igx",
  "mif":               "application/vnd.mif",
  "daf":               "application/vnd.mobius.daf",
  "dis":               "application/vnd.mobius.dis",
  "mbk":               "application/vnd.mobius.mbk",
  "mqy":               "application/vnd.mobius.mqy",
  "msl":               "application/vnd.mobius.msl",
  "plc":               "application/vnd.mobius.plc",
  "txf":               "application/vnd.mobius.txf",
  "mpn":               "application/vnd.mophun.application",
  "mpc":               "application/vnd.mophun.certificate",
  "xul":               "application/vnd.mozilla.xul+xml",
  "cil":               "application/vnd.ms-artgalry",
  "cab":               "application/vnd.ms-cab-compressed",
  "xls":               "application/vnd.ms-excel",
  "xlm":               "application/vnd.ms-excel",
  "xla":               "application/vnd.ms-excel",
  "xlc":               "application/vnd.ms-excel",
  "xlt":               "application/vnd.ms-excel",
  "xlw":               "application/vnd.ms-excel",
  "xlam":              "application/vnd.ms-excel.addin.macroenabled.12",
  "xlsb":              "application/vnd.ms-excel.sheet.binary.macroenabled.12",
  "xlsm":              "application/vnd.ms-excel.sheet.macroenabled.12",
  "xltm":              "application/vnd.ms-excel.template.macroenabled.12",
  "eot":               "application/vnd.ms-fontobject",
  "chm":               "application/vnd.ms-htmlhelp",
  "ims":               "application/vnd.ms-ims",
  "lrm":               "application/vnd.ms-lrm",
  "thmx":              "application/vnd.ms-officetheme",
  "cat":               "application/vnd.ms-pki.seccat",
  "stl":               "application/vnd.ms-pki.stl",
  "ppt":               "application/vnd.ms-powerpoint",
  "pps":               "application/vnd.ms-powerpoint",
  "pot":               "application/vnd.ms-powerpoint",
  "ppam":              "application/vnd.ms-powerpoint.addin.macroenabled.12",
  "pptm":              "application/vnd.ms-powerpoint.presentation.macroenabled.12",
  "sldm":              "application/vnd.ms-powerpoint.slide.macroenabled.12",
  "ppsm":              "application/vnd.ms-powerpoint.slideshow.macroenabled.12",
  "potm":              "application/vnd.ms-powerpoint.template.macroenabled.12",
  "mpp":               "application/vnd.ms-project",
  "mpt":               "application/vnd.ms-project",
  "docm":              "application/vnd.ms-word.document.macroenabled.12",
  "dotm":              "application/vnd.ms-word.template.macroenabled.12",
  "wps":               "application/vnd.ms-works",
  "wks":               "application/vnd.ms-works",
  "wcm":               "application/vnd.ms-works",
  "wdb":               "application/vnd.ms-works",
  "wpl":               "application/vnd.ms-wpl",
  "xps":               "application/vnd.ms-xpsdocument",
  "mseq":              "application/vnd.mseq",
  "mus":               "application/vnd.musician",
  "msty":              "application/vnd.muvee.style",
  "taglet":            "application/vnd.mynfc",
  "nlu":               "application/vnd.neurolanguage.nlu",
  "ntf":               "application/vnd.nitf",
  "nitf":              "application/vnd.nitf",
  "nnd":               "application/vnd.noblenet-directory",
  "nns":               "application/vnd.noblenet-sealer",
  "nnw":               "application/vnd.noblenet-web",
  "ngdat":             "application/vnd.nokia.n-gage.data",
  "n-gage":            "application/vnd.nokia.n-gage.symbian.install",
  "rpst":              "application/vnd.nokia.radio-preset",
  "rpss":              "application/vnd.nokia.radio-presets",
  "edm":               "application/vnd.novadigm.edm",
  "edx":               "application/vnd.novadigm.edx",
  "ext":               "application/vnd.novadigm.ext",
  "odc":               "application/vnd.oasis.opendocument.chart",
  "otc":               "application/vnd.oasis.opendocument.chart-template",
  "odb":               "application/vnd.oasis.opendocument.database",
  "odf":               "application/vnd.oasis.opendocument.formula",
  "odft":              "application/vnd.oasis.opendocument.formula-template",
  "odg":               "application/vnd.oasis.opendocument.graphics",
  "otg":               "application/vnd.oasis.opendocument.graphics-template",
  "odi":               "application/vnd.oasis.opendocument.image",
  "oti":               "application/vnd.oasis.opendocument.image-template",
  "odp":               "application/vnd.oasis.opendocument.presentation",
  "otp":               "application/vnd.oasis.opendocument.presentation-template",
  "ods":               "application/vnd.oasis.opendocument.spreadsheet",
  "ots":               "application/vnd.oasis.opendocument.spreadsheet-template",
  "odt":               "application/vnd.oasis.opendocument.text",
  "odm":               "application/vnd.oasis.opendocument.text-master",
  "ott":               "application/vnd.oasis.opendocument.text-template",
  "oth":               "application/vnd.oasis.opendocument.text-web",
  "xo":                "application/vnd.olpc-sugar",
  "dd2":               "application/vnd.oma.dd2+xml",
  "oxt":               "application/vnd.openofficeorg.extension",
  "pptx":              "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "sldx":              "application/vnd.openxmlformats-officedocument.presentationml.slide",
  "ppsx":              "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
  "potx":              "application/vnd.openxmlformats-officedocument.presentationml.template",
  "xlsx":              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "xltx":              "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
  "docx":              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "dotx":              "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
  "mgp":               "application/vnd.osgeo.mapguide.package",
  "dp":                "application/vnd.osgi.dp",
  "esa":               "application/vnd.osgi.subsystem",
  "pdb":               "application/vnd.palm",
  "pqa":               "application/vnd.palm",
  "oprc":              "application/vnd.palm",
  "paw":               "application/vnd.pawaafile",
  "str":               "application/vnd.pg.format",
  "ei6":               "application/vnd.pg.osasli",
  "efif":              "application/vnd.picsel",
  "wg":                "application/vnd.pmi.widget",
  "plf":               "application/vnd.pocketlearn",
  "pbd":               "application/vnd.powerbuilder6",
  "box":               "application/vnd.previewsystems.box",
  "mgz":               "application/vnd.proteus.magazine",
  "qps":               "application/vnd.publishare-delta-tree",
  "ptid":              "application/vnd.pvi.ptid1",
  "qxd":               "application/vnd.quark.quarkxpress",
  "qxt":               "application/vnd.quark.quarkxpress",
  "qwd":               "application/vnd.quark.quarkxpress",
  "qwt":               "application/vnd.quark.quarkxpress",
  "qxl":               "application/vnd.quark.quarkxpress",
  "qxb":               "application/vnd.quark.quarkxpress",
  "bed":               "application/vnd.realvnc.bed",
  "mxl":               "application/vnd.recordare.musicxml",
  "musicxml":          "application/vnd.recordare.musicxml+xml",
  "cryptonote":        "application/vnd.rig.cryptonote",
  "cod":               "application/vnd.rim.cod",
  "rm":                "application/vnd.rn-realmedia",
  "rmvb":              "application/vnd.rn-realmedia-vbr",
  "link66":            "application/vnd.route66.link66+xml",
  "st":                "application/vnd.sailingtracker.track",
  "see":               "application/vnd.seemail",
  "sema":              "application/vnd.sema",
  "semd":              "application/vnd.semd",
  "semf":              "application/vnd.semf",
  "ifm":               "application/vnd.shana.informed.formdata",
  "itp":               "application/vnd.shana.informed.formtemplate",
  "iif":               "application/vnd.shana.informed.interchange",
  "ipk":               "application/vnd.shana.informed.package",
  "twd":               "application/vnd.simtech-mindmapper",
  "twds":              "application/vnd.simtech-mindmapper",
  "mmf":               "application/vnd.smaf",
  "teacher":           "application/vnd.smart.teacher",
  "sdkm":              "application/vnd.solent.sdkm+xml",
  "sdkd":              "application/vnd.solent.sdkm+xml",
  "dxp":               "application/vnd.spotfire.dxp",
  "sfs":               "application/vnd.spotfire.sfs",
  "sdc":               "application/vnd.stardivision.calc",
  "sda":               "application/vnd.stardivision.draw",
  "sdd":               "application/vnd.stardivision.impress",
  "smf":               "application/vnd.stardivision.math",
  "sdw":               "application/vnd.stardivision.writer",
  "vor":               "application/vnd.stardivision.writer",
  "sgl":               "application/vnd.stardivision.writer-global",
  "smzip":             "application/vnd.stepmania.package",
  "sm":                "application/vnd.stepmania.stepchart",
  "sxc":               "application/vnd.sun.xml.calc",
  "stc":               "application/vnd.sun.xml.calc.template",
  "sxd":               "application/vnd.sun.xml.draw",
  "std":               "application/vnd.sun.xml.draw.template",
  "sxi":               "application/vnd.sun.xml.impress",
  "sti":               "application/vnd.sun.xml.impress.template",
  "sxm":               "application/vnd.sun.xml.math",
  "sxw":               "application/vnd.sun.xml.writer",
  "sxg":               "application/vnd.sun.xml.writer.global",
  "stw":               "application/vnd.sun.xml.writer.template",
  "sus":               "application/vnd.sus-calendar",
  "susp":              "application/vnd.sus-calendar",
  "svd":               "application/vnd.svd",
  "sis":               "application/vnd.symbian.install",
  "sisx":              "application/vnd.symbian.install",
  "xsm":               "application/vnd.syncml+xml",
  "bdm":               "application/vnd.syncml.dm+wbxml",
  "xdm":               "application/vnd.syncml.dm+xml",
  "tao":               "application/vnd.tao.intent-module-archive",
  "pcap":              "application/vnd.tcpdump.pcap",
  "cap":               "application/vnd.tcpdump.pcap",
  "dmp":               "application/vnd.tcpdump.pcap",
  "tmo":               "application/vnd.tmobile-livetv",
  "tpt":               "application/vnd.trid.tpt",
  "mxs":               "application/vnd.triscape.mxs",
  "tra":               "application/vnd.trueapp",
  "ufd":               "application/vnd.ufdl",
  "ufdl":              "application/vnd.ufdl",
  "utz":               "application/vnd.uiq.theme",
  "umj":               "application/vnd.umajin",
  "unityweb":          "application/vnd.unity",
  "uoml":              "application/vnd.uoml+xml",
  "vcx":               "application/vnd.vcx",
  "vsd":               "application/vnd.visio",
  "vsw":               "application/vnd.visio",
  "vss":               "application/vnd.visio",
  "vst":               "application/vnd.visio",
  "vis":               "application/vnd.visionary",
  "vsf":               "application/vnd.vsf",
  "wbxml":             "application/vnd.wap.wbxml",
  "wmlc":              "application/vnd.wap.wmlc",
  "wmlsc":             "application/vnd.wap.wmlscriptc",
  "wtb":               "application/vnd.webturbo",
  "nbp":               "application/vnd.wolfram.player",
  "wpd":               "application/vnd.wordperfect",
  "wqd":               "application/vnd.wqd",
  "stf":               "application/vnd.wt.stf",
  "xar":               "application/vnd.xara",
  "xfdl":              "application/vnd.xfdl",
  "hvd":               "application/vnd.yamaha.hv-dic",
  "hvs":               "application/vnd.yamaha.hv-script",
  "hvp":               "application/vnd.yamaha.hv-voice",
  "osf":               "application/vnd.yamaha.openscoreformat",
  "osfpvg":            "application/vnd.yamaha.openscoreformat.osfpvg+xml",
  "saf":               "application/vnd.yamaha.smaf-audio",
  "spf":               "application/vnd.yamaha.smaf-phrase",
  "cmp":               "application/vnd.yellowriver-custom-menu",
  "zir":               "application/vnd.zul",
  "zirz":              "application/vnd.zul",
  "zaz":               "application/vnd.zzazz.deck+xml",
  "vxml":              "application/voicexml+xml",
  "wgt":               "application/widget",
  "hlp":               "application/winhlp",
  "wsdl":              "application/wsdl+xml",
  "wspolicy":          "application/wspolicy+xml",
  "7z":                "application/x-7z-compressed",
  "abw":               "application/x-abiword",
  "ace":               "application/x-ace-compressed",
  "dmg":               "application/x-apple-diskimage",
  "aab":               "application/x-authorware-bin",
  "x32":               "application/x-authorware-bin",
  "u32":               "application/x-authorware-bin",
  "vox":               "application/x-authorware-bin",
  "aam":               "application/x-authorware-map",
  "aas":               "application/x-authorware-seg",
  "bcpio":             "application/x-bcpio",
  "torrent":           "application/x-bittorrent",
  "blb":               "application/x-blorb",
  "blorb":             "application/x-blorb",
  "bz":                "application/x-bzip",
  "bz2":               "application/x-bzip2",
  "boz":               "application/x-bzip2",
  "cbr":               "application/x-cbr",
  "cba":               "application/x-cbr",
  "cbt":               "application/x-cbr",
  "cbz":               "application/x-cbr",
  "cb7":               "application/x-cbr",
  "vcd":               "application/x-cdlink",
  "cfs":               "application/x-cfs-compressed",
  "chat":              "application/x-chat",
  "pgn":               "application/x-chess-pgn",
  "nsc":               "application/x-conference",
  "cpio":              "application/x-cpio",
  "csh":               "application/x-csh",
  "deb":               "application/x-debian-package",
  "udeb":              "application/x-debian-package",
  "dgc":               "application/x-dgc-compressed",
  "dir":               "application/x-director",
  "dcr":               "application/x-director",
  "dxr":               "application/x-director",
  "cst":               "application/x-director",
  "cct":               "application/x-director",
  "cxt":               "application/x-director",
  "w3d":               "application/x-director",
  "fgd":               "application/x-director",
  "swa":               "application/x-director",
  "wad":               "application/x-doom",
  "ncx":               "application/x-dtbncx+xml",
  "dtb":               "application/x-dtbook+xml",
  "res":               "application/x-dtbresource+xml",
  "dvi":               "application/x-dvi",
  "evy":               "application/x-envoy",
  "eva":               "application/x-eva",
  "bdf":               "application/x-font-bdf",
  "gsf":               "application/x-font-ghostscript",
  "psf":               "application/x-font-linux-psf",
  "otf":               "application/x-font-otf",
  "pcf":               "application/x-font-pcf",
  "snf":               "application/x-font-snf",
  "ttf":               "application/x-font-ttf",
  "ttc":               "application/x-font-ttf",
  "pfa":               "application/x-font-type1",
  "pfb":               "application/x-font-type1",
  "pfm":               "application/x-font-type1",
  "afm":               "application/x-font-type1",
  "woff":              "application/font-woff",
  "arc":               "application/x-freearc",
  "spl":               "application/x-futuresplash",
  "gca":               "application/x-gca-compressed",
  "ulx":               "application/x-glulx",
  "gnumeric":          "application/x-gnumeric",
  "gramps":            "application/x-gramps-xml",
  "gtar":              "application/x-gtar",
  "hdf":               "application/x-hdf",
  "install":           "application/x-install-instructions",
  "iso":               "application/x-iso9660-image",
  "jnlp":              "application/x-java-jnlp-file",
  "latex":             "application/x-latex",
  "lzh":               "application/x-lzh-compressed",
  "lha":               "application/x-lzh-compressed",
  "mie":               "application/x-mie",
  "prc":               "application/x-mobipocket-ebook",
  "mobi":              "application/x-mobipocket-ebook",
  "application":       "application/x-ms-application",
  "lnk":               "application/x-ms-shortcut",
  "wmd":               "application/x-ms-wmd",
  "wmz":               "application/x-msmetafile",
  "xbap":              "application/x-ms-xbap",
  "mdb":               "application/x-msaccess",
  "obd":               "application/x-msbinder",
  "crd":               "application/x-mscardfile",
  "clp":               "application/x-msclip",
  "exe":               "application/x-msdownload",
  "dll":               "application/x-msdownload",
  "com":               "application/x-msdownload",
  "bat":               "application/x-msdownload",
  "msi":               "application/x-msdownload",
  "mvb":               "application/x-msmediaview",
  "m13":               "application/x-msmediaview",
  "m14":               "application/x-msmediaview",
  "wmf":               "application/x-msmetafile",
  "emf":               "application/x-msmetafile",
  "emz":               "application/x-msmetafile",
  "mny":               "application/x-msmoney",
  "pub":               "application/x-mspublisher",
  "scd":               "application/x-msschedule",
  "trm":               "application/x-msterminal",
  "wri":               "application/x-mswrite",
  "nc":                "application/x-netcdf",
  "cdf":               "application/x-netcdf",
  "nzb":               "application/x-nzb",
  "p12":               "application/x-pkcs12",
  "pfx":               "application/x-pkcs12",
  "p7b":               "application/x-pkcs7-certificates",
  "spc":               "application/x-pkcs7-certificates",
  "p7r":               "application/x-pkcs7-certreqresp",
  "rar":               "application/x-rar-compressed",
  "ris":               "application/x-research-info-systems",
  "sh":                "application/x-sh",
  "shar":              "application/x-shar",
  "swf":               "application/x-shockwave-flash",
  "xap":               "application/x-silverlight-app",
  "sql":               "application/x-sql",
  "sit":               "application/x-stuffit",
  "sitx":              "application/x-stuffitx",
  "srt":               "application/x-subrip",
  "sv4cpio":           "application/x-sv4cpio",
  "sv4crc":            "application/x-sv4crc",
  "t3":                "application/x-t3vm-image",
  "gam":               "application/x-tads",
  "tar":               "application/x-tar",
  "tcl":               "application/x-tcl",
  "tex":               "application/x-tex",
  "tfm":               "application/x-tex-tfm",
  "texinfo":           "application/x-texinfo",
  "texi":              "application/x-texinfo",
  "obj":               "application/x-tgif",
  "ustar":             "application/x-ustar",
  "src":               "application/x-wais-source",
  "der":               "application/x-x509-ca-cert",
  "crt":               "application/x-x509-ca-cert",
  "fig":               "application/x-xfig",
  "xlf":               "application/x-xliff+xml",
  "xpi":               "application/x-xpinstall",
  "xz":                "application/x-xz",
  "z1":                "application/x-zmachine",
  "z2":                "application/x-zmachine",
  "z3":                "application/x-zmachine",
  "z4":                "application/x-zmachine",
  "z5":                "application/x-zmachine",
  "z6":                "application/x-zmachine",
  "z7":                "application/x-zmachine",
  "z8":                "application/x-zmachine",
  "xaml":              "application/xaml+xml",
  "xdf":               "application/xcap-diff+xml",
  "xenc":              "application/xenc+xml",
  "xhtml":             "application/xhtml+xml",
  "xht":               "application/xhtml+xml",
  "xml":               "application/xml",
  "xsl":               "application/xml",
  "dtd":               "application/xml-dtd",
  "xop":               "application/xop+xml",
  "xpl":               "application/xproc+xml",
  "xslt":              "application/xslt+xml",
  "xspf":              "application/xspf+xml",
  "mxml":              "application/xv+xml",
  "xhvml":             "application/xv+xml",
  "xvml":              "application/xv+xml",
  "xvm":               "application/xv+xml",
  "yang":              "application/yang",
  "yin":               "application/yin+xml",
  "zip":               "application/zip",
  "adp":               "audio/adpcm",
  "au":                "audio/basic",
  "snd":               "audio/basic",
  "mid":               "audio/midi",
  "midi":              "audio/midi",
  "kar":               "audio/midi",
  "rmi":               "audio/midi",
  "mp4a":              "audio/mp4",
  "mpga":              "audio/mpeg",
  "mp2":               "audio/mpeg",
  "mp2a":              "audio/mpeg",
  "mp3":               "audio/mpeg",
  "m2a":               "audio/mpeg",
  "m3a":               "audio/mpeg",
  "oga":               "audio/ogg",
  "ogg":               "audio/ogg",
  "spx":               "audio/ogg",
  "s3m":               "audio/s3m",
  "sil":               "audio/silk",
  "uva":               "audio/vnd.dece.audio",
  "uvva":              "audio/vnd.dece.audio",
  "dra":               "audio/vnd.dra",
  "dts":               "audio/vnd.dts",
  "dtshd":             "audio/vnd.dts.hd",
  "lvp":               "audio/vnd.lucent.voice",
  "pya":               "audio/vnd.ms-playready.media.pya",
  "ecelp4800":         "audio/vnd.nuera.ecelp4800",
  "ecelp7470":         "audio/vnd.nuera.ecelp7470",
  "ecelp9600":         "audio/vnd.nuera.ecelp9600",
  "rip":               "audio/vnd.rip",
  "weba":              "audio/webm",
  "aac":               "audio/x-aac",
  "aif":               "audio/x-aiff",
  "aiff":              "audio/x-aiff",
  "aifc":              "audio/x-aiff",
  "caf":               "audio/x-caf",
  "flac":              "audio/x-flac",
  "mka":               "audio/x-matroska",
  "m3u":               "audio/x-mpegurl",
  "wax":               "audio/x-ms-wax",
  "wma":               "audio/x-ms-wma",
  "ram":               "audio/x-pn-realaudio",
  "ra":                "audio/x-pn-realaudio",
  "rmp":               "audio/x-pn-realaudio-plugin",
  "wav":               "audio/x-wav",
  "xm":                "audio/xm",
  "cdx":               "chemical/x-cdx",
  "cif":               "chemical/x-cif",
  "cmdf":              "chemical/x-cmdf",
  "cml":               "chemical/x-cml",
  "csml":              "chemical/x-csml",
  "xyz":               "chemical/x-xyz",
  "bmp":               "image/bmp",
  "cgm":               "image/cgm",
  "g3":                "image/g3fax",
  "gif":               "image/gif",
  "ief":               "image/ief",
  "jpeg":              "image/jpeg",
  "jpg":               "image/jpeg",
  "jpe":               "image/jpeg",
  "ktx":               "image/ktx",
  "png":               "image/png",
  "btif":              "image/prs.btif",
  "sgi":               "image/sgi",
  "svg":               "image/svg+xml",
  "svgz":              "image/svg+xml",
  "tiff":              "image/tiff",
  "tif":               "image/tiff",
  "psd":               "image/vnd.adobe.photoshop",
  "uvi":               "image/vnd.dece.graphic",
  "uvvi":              "image/vnd.dece.graphic",
  "uvg":               "image/vnd.dece.graphic",
  "uvvg":              "image/vnd.dece.graphic",
  "sub":               "text/vnd.dvb.subtitle",
  "djvu":              "image/vnd.djvu",
  "djv":               "image/vnd.djvu",
  "dwg":               "image/vnd.dwg",
  "dxf":               "image/vnd.dxf",
  "fbs":               "image/vnd.fastbidsheet",
  "fpx":               "image/vnd.fpx",
  "fst":               "image/vnd.fst",
  "mmr":               "image/vnd.fujixerox.edmics-mmr",
  "rlc":               "image/vnd.fujixerox.edmics-rlc",
  "mdi":               "image/vnd.ms-modi",
  "wdp":               "image/vnd.ms-photo",
  "npx":               "image/vnd.net-fpx",
  "wbmp":              "image/vnd.wap.wbmp",
  "xif":               "image/vnd.xiff",
  "webp":              "image/webp",
  "3ds":               "image/x-3ds",
  "ras":               "image/x-cmu-raster",
  "cmx":               "image/x-cmx",
  "fh":                "image/x-freehand",
  "fhc":               "image/x-freehand",
  "fh4":               "image/x-freehand",
  "fh5":               "image/x-freehand",
  "fh7":               "image/x-freehand",
  "ico":               "image/x-icon",
  "sid":               "image/x-mrsid-image",
  "pcx":               "image/x-pcx",
  "pct":               "image/x-pict",
  "pic":               "image/x-pict",
  "pnm":               "image/x-portable-anymap",
  "pbm":               "image/x-portable-bitmap",
  "pgm":               "image/x-portable-graymap",
  "ppm":               "image/x-portable-pixmap",
  "rgb":               "image/x-rgb",
  "tga":               "image/x-tga",
  "xbm":               "image/x-xbitmap",
  "xpm":               "image/x-xpixmap",
  "xwd":               "image/x-xwindowdump",
  "eml":               "message/rfc822",
  "mime":              "message/rfc822",
  "igs":               "model/iges",
  "iges":              "model/iges",
  "msh":               "model/mesh",
  "mesh":              "model/mesh",
  "silo":              "model/mesh",
  "dae":               "model/vnd.collada+xml",
  "dwf":               "model/vnd.dwf",
  "gdl":               "model/vnd.gdl",
  "gtw":               "model/vnd.gtw",
  "mts":               "model/vnd.mts",
  "vtu":               "model/vnd.vtu",
  "wrl":               "model/vrml",
  "vrml":              "model/vrml",
  "x3db":              "model/x3d+binary",
  "x3dbz":             "model/x3d+binary",
  "x3dv":              "model/x3d+vrml",
  "x3dvz":             "model/x3d+vrml",
  "x3d":               "model/x3d+xml",
  "x3dz":              "model/x3d+xml",
  "appcache":          "text/cache-manifest",
  "ics":               "text/calendar",
  "ifb":               "text/calendar",
  "css":               "text/css",
  "csv":               "text/csv",
  "html":              "text/html",
  "htm":               "text/html",
  "n3":                "text/n3",
  "txt":               "text/plain",
  "text":              "text/plain",
  "conf":              "text/plain",
  "def":               "text/plain",
  "list":              "text/plain",
  "log":               "text/plain",
  "in":                "text/plain",
  "dsc":               "text/prs.lines.tag",
  "rtx":               "text/richtext",
  "sgml":              "text/sgml",
  "sgm":               "text/sgml",
  "tsv":               "text/tab-separated-values",
  "t":                 "text/troff",
  "tr":                "text/troff",
  "roff":              "text/troff",
  "man":               "text/troff",
  "me":                "text/troff",
  "ms":                "text/troff",
  "ttl":               "text/turtle",
  "uri":               "text/uri-list",
  "uris":              "text/uri-list",
  "urls":              "text/uri-list",
  "vcard":             "text/vcard",
  "curl":              "text/vnd.curl",
  "dcurl":             "text/vnd.curl.dcurl",
  "scurl":             "text/vnd.curl.scurl",
  "mcurl":             "text/vnd.curl.mcurl",
  "fly":               "text/vnd.fly",
  "flx":               "text/vnd.fmi.flexstor",
  "gv":                "text/vnd.graphviz",
  "3dml":              "text/vnd.in3d.3dml",
  "spot":              "text/vnd.in3d.spot",
  "jad":               "text/vnd.sun.j2me.app-descriptor",
  "wml":               "text/vnd.wap.wml",
  "wmls":              "text/vnd.wap.wmlscript",
  "s":                 "text/x-asm",
  "asm":               "text/x-asm",
  "c":                 "text/x-c",
  "cc":                "text/x-c",
  "cxx":               "text/x-c",
  "cpp":               "text/x-c",
  "h":                 "text/x-c",
  "hh":                "text/x-c",
  "dic":               "text/x-c",
  "f":                 "text/x-fortran",
  "for":               "text/x-fortran",
  "f77":               "text/x-fortran",
  "f90":               "text/x-fortran",
  "java":              "text/x-java-source",
  "opml":              "text/x-opml",
  "p":                 "text/x-pascal",
  "pas":               "text/x-pascal",
  "nfo":               "text/x-nfo",
  "etx":               "text/x-setext",
  "sfv":               "text/x-sfv",
  "uu":                "text/x-uuencode",
  "vcs":               "text/x-vcalendar",
  "vcf":               "text/x-vcard",
  "3gp":               "video/3gpp",
  "3g2":               "video/3gpp2",
  "h261":              "video/h261",
  "h263":              "video/h263",
  "h264":              "video/h264",
  "jpgv":              "video/jpeg",
  "jpm":               "video/jpm",
  "jpgm":              "video/jpm",
  "mj2":               "video/mj2",
  "mjp2":              "video/mj2",
  "mp4":               "video/mp4",
  "mp4v":              "video/mp4",
  "mpg4":              "video/mp4",
  "mpeg":              "video/mpeg",
  "mpg":               "video/mpeg",
  "mpe":               "video/mpeg",
  "m1v":               "video/mpeg",
  "m2v":               "video/mpeg",
  "ogv":               "video/ogg",
  "qt":                "video/quicktime",
  "mov":               "video/quicktime",
  "uvh":               "video/vnd.dece.hd",
  "uvvh":              "video/vnd.dece.hd",
  "uvm":               "video/vnd.dece.mobile",
  "uvvm":              "video/vnd.dece.mobile",
  "uvp":               "video/vnd.dece.pd",
  "uvvp":              "video/vnd.dece.pd",
  "uvs":               "video/vnd.dece.sd",
  "uvvs":              "video/vnd.dece.sd",
  "uvv":               "video/vnd.dece.video",
  "uvvv":              "video/vnd.dece.video",
  "dvb":               "video/vnd.dvb.file",
  "fvt":               "video/vnd.fvt",
  "mxu":               "video/vnd.mpegurl",
  "m4u":               "video/vnd.mpegurl",
  "pyv":               "video/vnd.ms-playready.media.pyv",
  "uvu":               "video/vnd.uvvu.mp4",
  "uvvu":              "video/vnd.uvvu.mp4",
  "viv":               "video/vnd.vivo",
  "webm":              "video/webm",
  "f4v":               "video/x-f4v",
  "fli":               "video/x-fli",
  "flv":               "video/x-flv",
  "m4v":               "video/x-m4v",
  "mkv":               "video/x-matroska",
  "mk3d":              "video/x-matroska",
  "mks":               "video/x-matroska",
  "mng":               "video/x-mng",
  "asf":               "video/x-ms-asf",
  "asx":               "video/x-ms-asf",
  "vob":               "video/x-ms-vob",
  "wm":                "video/x-ms-wm",
  "wmv":               "video/x-ms-wmv",
  "wmx":               "video/x-ms-wmx",
  "wvx":               "video/x-ms-wvx",
  "avi":               "video/x-msvideo",
  "movie":             "video/x-sgi-movie",
  "smv":               "video/x-smv",
  "ice":               "x-conference/x-cooltalk"
};

/**
 * Searches throw all known MIME types and returns the one that matches given
 * extension.
 *
 * @param path [String] Extension, absolute path, relative path or URL
 * @param def [String] A string that gets returned if MIME type lookup fails
 *
 * @example MIME type lookup
 *   var mimeType = MIM.getMIMEType('filename.avi');
 *
 * @return [Null] if no MIME type was found
 * @return [String] MIME type
 */
MIM.getMIMEType = function(path, defaultType) {
  if(defaultType === undefined) {
    defaultType = null;
  }

  var result = defaultType;
  var extensions = String(path).toLowerCase().replace(/\?.+/, '').match(/(?!\.)[a-z0-9]+$/);

  if(extensions !== null) {
    var extension = extensions.pop();
    result = MIM.MIME_TYPES[extension] || defaultType;
  }

  return result;
};

if(typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = MIM;
}


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Keymap */
/* unused harmony export Keycode */
/* harmony export (immutable) */ __webpack_exports__["a"] = validateKeydown;
var Keymap={slides:{ADD_SCENE:{key:"ctrl + m",type:"basic"},NEXT_SCENE:{key:"down arrow",type:"basic"},PREV_SCENE:{key:"up arrow",type:"basic"},DUPLICATE_SCENE:{key:"ctrl + d",type:"basic"},REMOVE_SCENE:{key:"delete",type:"basic"},REMOVE_SCENE_MAC:{key:"backspace",type:"basic"},MOVE_SCENE_UP:{key:"ctrl + down arrow",type:"basic"},MOVE_SCENE_DOWN:{key:"ctrl + up arrow",type:"basic"},MOVE_SCENE_LAST:{key:"ctrl + shift + down arrow",type:"basic"},MOVE_SCENE_FIRST:{key:"ctrl + shift + up arrow",type:"basic"},CHANGE_TRANSITION:{key:"shift + t",type:"basic"},CTRL_PRESS:{key:"ctrl",type:"basic"}},workspace:{DOWN_ARROW:{key:"shift + down arrow",type:"basic"},UP_ARROW:{key:"shift + up arrow",type:"basic"},RIGHT_ARROW:{key:"shift + right arrow",type:"basic"},LEFT_ARROW:{key:"shift + left arrow",type:"basic"},SHIFT_DOWN_ARROW:{key:"down arrow",type:"basic"},SHIFT_UP_ARROW:{key:"up arrow",type:"basic"},SHIFT_RIGHT_ARROW:{key:"right arrow",type:"basic"},SHIFT_LEFT_ARROW:{key:"left arrow",type:"basic"},DELETE_ITEM:{key:"delete",type:"basic"},DELETE_ITEM_MAC:{key:"backspace",type:"basic"},SELECT_ALL_OBJECT:{key:"ctrl + a",type:"basic"},DESELECT_ALL_OBJECT:{key:"ctrl + shift + a",type:"basic"},COPY_ITEM:{key:"ctrl + c",type:"basic"},PASTE_ITEM:{key:"ctrl + v",type:"basic"},CUT_ITEM:{key:"ctrl + x",type:"basic"},CTRL_PRESS:{key:"ctrl",type:"basic"},OPEN_SETTINGS:{key:"shift + s",type:"basic"},BRING_FRONT:{key:"ctrl + up arrow",type:"basic"},MOVE_LAST:{key:"ctrl + shift + down arrow",type:"basic"},BRING_FIRST:{key:"ctrl + shift + up arrow",type:"basic"},MOVE_BACK:{key:"ctrl + down arrow",type:"basic"},FLIP_ITEM:{key:"alt + f",type:"basic"},GROUP_ITEM:{key:"ctrl + alt + g",type:"basic"},UN_GROUP_ITEM:{key:"ctrl + shift + alt + g",type:"basic"},ENTER:{key:"enter",type:"basic"},ESCAPE:{key:"escape",type:"basic"},ZOOMIN:{key:"ctrl + alt + plus",type:"basic"},ZOOMOUT:{key:"ctrl + alt + minus",type:"basic"},START_PLAY:{key:"spacebar",type:"basic"}},textProperty:{SET_BOLD:{key:"ctrl + b",type:"basic"},SET_ITALIC:{key:"ctrl + i",type:"basic"},SET_UNDERLINE:{key:"ctrl + u",type:"basic"},ALIGN_RIGHT:{key:"ctrl + shift + r",type:"basic"},ALIGN_LEFT:{key:"ctrl + shift + l",type:"basic"},ALIGN_CENTER:{key:"ctrl + shift + e",type:"basic"},TO_UPPERCASE:{key:"ctrl + shift + u",type:"basic"},TO_SMALLCASE:{key:"ctrl + shift + s",type:"basic"},TO_CAPITALCASE:{key:"ctrl + shift + c",type:"basic"},REMOVE_CASE:{key:"ctrl + back slash",type:"basic"},INCREASE_FONT_SIZE:{key:"ctrl + shift + period",type:"basic"},DECREASE_FONT_SIZE:{key:"ctrl + shift + comma",type:"basic"},CHANGE_FONT_FAMILY:{key:"ctrl + shift + f",type:"basic"},CHANGE_FONT_COLOR:{key:"ctrl + alt + c",type:"basic"}},timeline:{INCREASE_ITEM_START:{key:"alt + s",type:"basic"},DECREASE_ITEM_START:{key:"alt + a",type:"basic"},INCREASE_ITEM_END:{key:"alt + w",type:"basic"},DECREASE_ITEM_END:{key:"alt + q",type:"basic"},INCREASE_ENTER_EFFECT_TIME:{key:"shift + alt + s",type:"basic"},DECREASE_ENTER_EFFECT_TIME:{key:"shift + alt + a",type:"basic"},INCREASE_EXIT_EFFECT_TIME:{key:"shift + alt + w",type:"basic"},DECREASE_EXIT_EFFECT_TIME:{key:"shift + alt + q",type:"basic"},INCREASE_PLAYHEAD:{key:"alt + x",type:"basic"},DECREASE_PLAYHEAD:{key:"alt + z",type:"basic"},COPY_ITEM:{key:"ctrl + c",type:"basic"},PASTE_ITEM:{key:"ctrl + v",type:"basic"},CUT_ITEM:{key:"ctrl + x",type:"basic"},DELETE_ITEM:{key:"delete",type:"basic"},DELETE_ITEM_MAC:{key:"backspace",type:"basic"},INCREASE_SCENE_DURATION:{key:"alt + l",type:"basic"},DECREASE_SCENE_DURATION:{key:"alt + k",type:"basic"},CTRL_PRESS:{key:"ctrl",type:"basic"},CHANGE_ENTER_EFFECT:{key:"alt + left arrow",type:"basic"},CHANGE_EXIT_EFFECT:{key:"alt + right arrow",type:"basic"}},menuBar:{UNDO_PROJECT:{key:"ctrl + z",type:"basic"},REDO_PROJECT:{key:"ctrl + y",type:"basic"},EXPORT_PROJECT:{key:"ctrl + e",type:"basic"}},playerControl:{START_PLAY:{key:"spacebar",type:"basic"},START_PLAYALL:{key:"shift + spacebar",type:"basic"}},library:{TAB0:{key:"shift + 1",type:"basic"},TAB1:{key:"shift + 2",type:"basic"},TAB2:{key:"shift + 3",type:"basic"},TAB3:{key:"shift + 4",type:"basic"},TAB4:{key:"shift + 5",type:"basic"},TAB5:{key:"shift + 6",type:"basic"},TAB6:{key:"shift + 7",type:"basic"},TAB7:{key:"shift + 8",type:"basic"},TAB8:{key:"shift + 9",type:"basic"},TAB9:{key:"shift + u",type:"basic"},TAB10:{key:"shift + +",type:"basic"}}};var Keycode={"backspace":8,"tab":9,"enter":13,"shift":16,"ctrl":17,"alt":18,"pause/break":19,"caps lock":20,"escape":27,"spacebar":32,"page up":33,"page down":34,"end":35,"home":36,"left arrow":37,"up arrow":38,"right arrow":39,"down arrow":40,"insert":45,"delete":46,"0":48,"1":49,"2":50,"3":51,"4":52,"5":53,"6":54,"7":55,"8":56,"9":57,"a":65,"b":66,"c":67,"d":68,"e":69,"f":70,"g":71,"h":72,"i":73,"j":74,"k":75,"l":76,"m":77,"n":78,"o":79,"p":80,"q":81,"r":82,"s":83,"t":84,"u":85,"v":86,"w":87,"x":88,"y":89,"z":90,"meta":91,"meta_ff":224,"right window key":92,"select key":93,"numpad 0":96,"numpad 1":97,"numpad 2":98,"numpad 3":99,"numpad 4":100,"numpad 5":101,"numpad 6":102,"numpad 7":103,"numpad 8":104,"numpad 9":105,"multiply":106,"add":107,"subtract":109,"decimal point":110,"divide":111,"f1":112,"f2":113,"f3":114,"f4":115,"f5":116,"f6":117,"f7":118,"f8":119,"f9":120,"f10":121,"f11":122,"f12":123,"num lock":144,"scroll lock":145,"semi-colon":186,"plus":187,"plus_ff":61,"comma":188,"minus":189,"minus_ff":173,"period":190,"forward slash":191,"grave accent":192,"open bracket":219,"back slash":220,"close bracket":221,"single quote":222};function override(e){e.preventDefault();e.stopPropagation();}function validateKeydown(e,textFocus,textStatus){var c=e.which||e.keyCode;//Get key code
if((c===32||c===46||c===8)&&!textFocus)override(e);if((e.ctrlKey||e.metaKey)&&!e.shiftKey&&!e.altKey){switch(c){case 32://Block Ctrl+space
case 37://Block Ctrl+left arrow
case 39://Block Ctrl+right arrow
case 66://Block Ctrl+B
case 68://Block Ctrl+D
case 69://Block Ctrl+E
case 70://Block Ctrl+F
case 71://Block Ctrl+G
case 73://Block Ctrl+I
case 76://Block Ctrl+L
case 78://Block Ctrl+N --Not working
case 79://Block Ctrl+O
case 72://Block Ctrl+H
case 74://Block Ctrl+J
case 77://Block Ctrl+M
case 81://Block Ctrl+Q
case 80://Block Ctrl+P
case 83://Block Ctrl+S
case 84://Block Ctrl+T --Not working
case 85://Block Ctrl+U
case 89://Block Ctrl+Y
case 87://Block Ctrl+W --Not working
case 220://Block Ctrl+Back Slash
override(e);break;case 65://Block Ctrl+A
case 67://Block Ctrl+C
if(!textFocus||e.altKey)override(e);break;case 82://Block Ctrl+R
if(textStatus.get('isSelected'))override(e);break;default:break;}}else if((e.ctrlKey||e.metaKey)&&e.shiftKey){switch(c){case 67://Block ctrl+shift+c chrome shortcut to enable responsive mode
case 70://Block Ctrl+shift+f chrome shortcut to activate url bar
case 69://Block Ctrl+shift+e chrome shortcut to extension
case 83://Block Ctrl+shift+s Firefox shortcut to screenshot
case 65://Block Ctrl+a Firefox shortcut to open addons
override(e);break;case 82://Block Ctrl+Shift+e Hard Refresh
if(textStatus.get('isSelected'))override(e);break;default:break;}}else if((e.ctrlKey||e.metaKey)&&e.altKey){switch(c){case 187://Block ctrl+alt++ 
case 189://Block Ctrl+alt+- 
case 61://Block ctrl+alt++ 
case 173://Block Ctrl+alt+- 
override(e);break;default:break;}}else if(e.altKey){switch(c){case 36://Block alt+home
case 37://Block alt+left arrow
case 39://Block alt+right arrow
case 67://Block alt+C
case 68://Block alt+D
case 9://Block alt+tab
override(e);break;default:break;}}var keyName="",keyOption="",key=void 0,compName="",resultArr=[];for(key in Keycode){if(e.keyCode===Keycode[key])keyName=key;}if(keyName!==""){if(keyName==="add"||e.keyCode===61)keyName="plus";else if(keyName==="subtract"||e.keyCode===173)keyName="minus";if((e.ctrlKey||e.metaKey)&&e.shiftKey&&e.altKey)keyName="ctrl + shift + alt + "+keyName;else if((e.ctrlKey||e.metaKey)&&e.shiftKey)keyName="ctrl + shift + "+keyName;else if((e.ctrlKey||e.metaKey)&&e.altKey)keyName="ctrl + alt + "+keyName;else if(e.shiftKey&&e.altKey)keyName="shift + alt + "+keyName;else if(e.altKey&&keyName!=="alt")keyName="alt + "+keyName;else if(e.shiftKey&&keyName!=="shift")keyName="shift + "+keyName;else if((e.ctrlKey||e.metaKey)&&keyName!=="ctrl"&&keyName!=="meta"&&keyName!=="meta_ff")keyName="ctrl + "+keyName;else if(e.ctrlKey||e.metaKey)keyName="ctrl";for(key in Keymap){var obj=Keymap[key];for(var innerkey in obj){if(keyName===obj[innerkey].key&&obj[innerkey].type==="basic"){keyOption=innerkey;compName=key;resultArr.push({option:keyOption,component:compName});}}}}return resultArr;}

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CommonPopupComponent__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_index__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state,ownProps){return{selectedScene:state.localStore.get('selectedScene'),workspaceBG:state.project.getIn(['scenes',state.localStore.get('selectedScene'),'workspaceBG']),commonPopup:state.localStore.getIn(['commonPopup'])};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{openCommonPopup:function openCommonPopup(value,status){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_7" /* loadCommonPopup */])(value,status));},setWorkspaceTextFocus:function setWorkspaceTextFocus(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_52" /* setWorkspaceTextFocus */])(data));},manageToast:function manageToast(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_8" /* manageToast */])(data));},updateUserDetails:function updateUserDetails(data){dispatch({type:"UPDATE_USER_DETAILS",data:data});}};};var CommonPopup=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_CommonPopupComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CommonPopup);

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_BgVideo__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ErrorHandler__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_app_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_ErrorLogService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(18);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShortcutsPopup=function(_React$Component){_inherits(ShortcutsPopup,_React$Component);function ShortcutsPopup(props){_classCallCheck(this,ShortcutsPopup);var _this=_possibleConstructorReturn(this,(ShortcutsPopup.__proto__||Object.getPrototypeOf(ShortcutsPopup)).call(this,props));_this.state={currentTab:0};_this.shortCuts=Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])([{name:"Slides",langId:'k.st.sl',shortcuts:[{name:"Add Slide",langId:'k.st.as',keys:["ctrl","m"]},{name:"Select Next Slide",langId:'k.st.sns',keys:["↓"]},{name:"Select Previous Slide",langId:'k.st.sps',keys:["↑"]},{name:"Move Slide Up",langId:'k.st.msu',keys:["ctrl","↑"]},{name:"Move Slide Down",langId:'k.st.msd',keys:["ctrl","↓"]},{name:"Move Slide First",langId:'k.st.msf',keys:["ctrl","shift","↑"]},{name:"Move Slide Last",langId:'k.st.msl',keys:["ctrl","shift","↓"]},{name:"Duplicate Slide",langId:'k.st.ds',keys:["ctrl","d"]},{name:"Delete Slide",langId:'k.st.dsc',keys:["Delete\\Backspace"]},{name:"Select Multiple Slide",langId:'k.st.sms',keys:["ctrl","click"]},{name:"Change Transition",langId:'k.st.ctr',keys:["shift","t"]}]},{name:"Menubar",langId:'k.st.mu',shortcuts:[{name:"Undo",langId:'k.st.undo',keys:["ctrl","z"]},{name:"Redo",langId:'k.st.redo',keys:["ctrl","y"]}]},{name:"Text",langId:'k.st.txt',shortcuts:[{name:"Align Right",langId:'k.st.alr',keys:["ctrl","shift","r"]},{name:"Align Left",langId:'k.st.all',keys:["ctrl","shift","l"]},{name:"Align Center",langId:'k.st.alc',keys:["ctrl","shift","e"]},{name:"To Uppercase",langId:'k.st.toup',keys:["ctrl","shift","u"]},{name:"To Lowercase",langId:'k.st.tolo',keys:["ctrl","shift","s"]},{name:"To Capitalize",langId:'k.st.tocap',keys:["ctrl","shift","c"]},{name:"To Removecase",langId:'k.st.torem',keys:["ctrl",'\\']},{name:"Set Bold",langId:'k.st.sebo',keys:["ctrl","b"]},{name:"Set Italic",langId:'k.st.seit',keys:["ctrl","i"]},{name:"Increase Font Size",langId:'k.st.infs',keys:["ctrl","shift",">"]},{name:"Decrease Font Size",langId:'k.st.defs',keys:["ctrl","shift","<"]},{name:"Change Font Family",langId:'k.st.chff',keys:["ctrl","shift","f"]}]},{name:"Player",langId:'k.st.ply',shortcuts:[{name:"Previous Slide",langId:'k.st.prev',keys:["Left Arrow"]},{name:"Next Slide",langId:'k.st.next',keys:["Right Arrow"]}]},{name:"Workspace",langId:'k.st.wrk',shortcuts:[{name:"Move Object Down 10px",langId:'k.st.modo',keys:["↓"]},{name:"Move Object Top 10px",langId:'k.st.moto',keys:["↑"]},{name:"Move Object Left 10px",langId:'k.st.molof',keys:["←"]},{name:"Move Object Right 10px",langId:'k.st.moro',keys:["→"]},{name:"Move Object Down 1px",langId:'k.st.modd',keys:["shift","↓"]},{name:"Move Object Top 1px",langId:'k.st.mott',keys:["shift","↑"]},{name:"Move Object Left 1px",langId:'k.st.moll',keys:["shift","←"]},{name:"Move Object Right 1px",langId:'k.st.morri',keys:["shift","→"]},{name:"Select All Objects",langId:'k.st.saob',keys:["ctrl","a"]},{name:"Deselect All Objects",langId:'k.st.deao',keys:["ctrl","shift","a"]},{name:"Select Multiple Objects",langId:'k.st.smobj',keys:["ctrl","click"]},{name:"Open/Close settings",langId:'k.st.ocse',keys:["shift","s"]},{name:"Copy Item",langId:'k.st.coit',keys:["ctrl","c"]},{name:"Cut Item",langId:'k.st.cuit',keys:["ctrl","x"]},{name:"Paste Item",langId:'k.st.pait',keys:["ctrl","v"]},{name:"Delete Item",langId:'k.st.deits',keys:["Delete\\Backspace"]},{name:"Zoom In",langId:'k.st.zoin',keys:["ctrl","alt","+"]},{name:"Zoom Out",langId:'k.st.zout',keys:["ctrl","alt","-"]},{name:"Bring Front",langId:'k.st.brfro',keys:["ctrl","shift","↑"]},{name:"Move Last",langId:'k.st.molas',keys:["ctrl","shift","↓"]},{name:"Bring First",langId:'k.st.brfri',keys:["ctrl","↑"]},{name:"Move Back",langId:'k.st.mobac',keys:["ctrl","↓"]},{name:"Flip Item",langId:'k.st.flite',keys:["alt","f"]},{name:"Group Item",langId:'k.st.grpit',keys:["ctrl","alt","g"]},{name:"Ungroup Item",langId:'k.st.ungrit',keys:["ctrl","alt","shift","g"]}]},{name:"Library",langId:'k.st.liby',shortcuts:[{name:"Open Prebuild",langId:'k.st.oppre',keys:["shift","1"]},{name:"Open Character",langId:'k.st.opchr',keys:["shift","2"]},{name:"Open Properties",langId:'k.st.oppro',keys:["shift","3"]},{name:"Open Text",langId:'k.st.potxt',keys:["shift","4"]},{name:"Open Background",langId:'k.st.opbck',keys:["shift","5"]},{name:"Open Image",langId:'k.st.opimg',keys:["shift","6"]},{name:"Open Uploads",langId:'k.st.opupl',keys:["shift","7"]}]}]);_this.changeTab=_this.changeTab.bind(_this);return _this;}_createClass(ShortcutsPopup,[{key:'changeTab',value:function changeTab(currentTab){try{this.setState({currentTab:currentTab});}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_5__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CommonPopup-changeTab");}}},{key:'render',value:function render(){var tabs=[];var content=[];var macosPlatforms=['Macintosh','MacIntel','MacPPC','Mac68K'],os=null;if(macosPlatforms.indexOf(window.navigator.platform)!==-1)os='Mac';else os="Windows";this.shortCuts.map(function(item,idx){var _this2=this;tabs.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:idx,className:this.state.currentTab===idx?"active":this.state.currentTab===idx+1?"prev":this.state.currentTab===idx-1?"next":"",onClick:function onClick(e){return _this2.changeTab(idx);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:''+item.get("langId")})));if(idx===this.state.currentTab&&item.get("shortcuts").size>0){item.get("shortcuts").map(function(sItem,sIdx){var keys=[];if(sItem.get("keys").size>0){sItem.get("keys").map(function(KItem,kIdx){if(os==="Mac"){if(KItem==='ctrl')KItem='cmd';else if(KItem==='alt')KItem='opt';}keys.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:kIdx},KItem));});}content.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:sIdx},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:''+sItem.get("langId")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,keys)));}.bind(this));}}.bind(this));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shortcut-popup popup-tool-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'popup-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'m.keyboard.shortcuts'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'popup-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'popup-tabs-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:this.state.currentTab===0?"prev":""}),tabs,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:this.state.currentTab===tabs.length-1?"next":""}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'popup-tabs-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,content))));}}]);return ShortcutsPopup;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var AnmsPopup=function(_React$Component2){_inherits(AnmsPopup,_React$Component2);function AnmsPopup(props){_classCallCheck(this,AnmsPopup);var _this3=_possibleConstructorReturn(this,(AnmsPopup.__proto__||Object.getPrototypeOf(AnmsPopup)).call(this,props));_this3.apiUrl=__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a['APIURIS'][__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a['APIURIS']['current']];_this3.animPopupClosed=_this3.animPopupClosed.bind(_this3);_this3.popupContent={"anmsPopup1":{"header":"Create Stunning Animated and Live Videos yourself!","content_1":"Our free Drag-And-Drop video maker makes it easy for anyone to create stunning videos using pre-made templates and ready-to-go assets.No Technical knowledge required.","content_header":"Join over 4,000,000 people already using Animaker","button":"Create your first video","isSignup":false,"button_tag":"Free, Forever, No Credit Card required"},"anmsPopup2":{"header":"Rapid Video Creation with Point-and-Click simplicity","content_1":"With Animaker's Lite Mode, just Point, Click and Swap stuff. No dragging and dropping required. Create a professional video in SECONDS!!!","button":"Create your first video","isSignup":false,"button_tag":"Free, Forever, No Credit Card required"},"anmsPopup3":{"header":"Make and Edit Videos together with your team","content_1":"Sign Up and share this Video Project with your Team Members.","button":"Create your first video","isSignup":false,"button_tag":"Free, Forever, No Credit Card required"},"anmsPopup4":{"header":"Sign Up to Save and Rename Your Video","content_1":"Access and e-Edit your videos from anywhere. Your videos are protected with Best-In-Class Security Tools","button":"Sign me up","isSignup":true,"button_tag":"Free, Forever, No Credit Card required"}};return _this3;}_createClass(AnmsPopup,[{key:'signup',value:function signup(){var _this4=this;try{this.props.setWorkspaceTextFocus(true);var uploadId=this.props.workspaceBG.get("assetId");window.anonymousUserExport({uploadId:uploadId,type:"signup"}).then(function(result){this.props.setWorkspaceTextFocus(false);if(!result.error){if(result.hit==="signup"||result.hit==="login"){document.getElementById("app-overlay").style.display="block";document.getElementById("app-overlay").style.zIndex="2000";document.getElementById("app-overlay").style.backgroundColor="rgba(0,0,0,0.5)";document.getElementById("app-overlay").style.backgroundImage="url("+this.appUrl+"/images/chr-loading.svg)";document.getElementById("app-overlay").style.backgroundPosition="center";document.getElementById("app-overlay").style.backgroundRepeat="no-repeat";document.getElementById("app-overlay").className="overlayDom-tool-bar";window.location=this.apiUrl+"customproject/"+result.projectId;}}else{this.props.closePopup();if(result.errorMsg!==undefined)this.props.manageToast({action:"add",type:"error","message":"common.toast.msg",subMessage:result.errorMsg,formatId:'msg'});}}.bind(this),function(error){_this4.props.closePopup();_this4.props.setWorkspaceTextFocus(false);_this4.props.manageToast({action:"add",type:"error","message":"common.toast.msg",formatId:'msg'});});}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_5__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CommonPopup-signup");}}},{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('POPUPCLOSE',this.animPopupClosed,false);}},{key:'animPopupClosed',value:function animPopupClosed(e){try{this.props.setWorkspaceTextFocus(false);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_5__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CommonPopup-animPopupClosed");}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('POPUPCLOSE',this.animPopupClosed,false);}},{key:'render',value:function render(){var _this5=this;var thisContent=this.popupContent[this.props.data.get("popup")];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'anms-popup'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'anms-popup-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'anms-container',dangerouslySetInnerHTML:{__html:thisContent.header}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'anms-popup-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'anms-container flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-1'},thisContent.content_1),thisContent.content_header!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-header'},thisContent.content_header):null,thisContent.button!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:function onClick(e){return _this5.signup();},className:'popup-btn'},thisContent.button):null,thisContent.button_tag!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'popup-btn-tag'},thisContent.button_tag):null)));}}]);return AnmsPopup;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var BrandPopup=function(_React$Component3){_inherits(BrandPopup,_React$Component3);function BrandPopup(props){_classCallCheck(this,BrandPopup);var _this6=_possibleConstructorReturn(this,(BrandPopup.__proto__||Object.getPrototypeOf(BrandPopup)).call(this,props));_this6.apiUrl=__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a['APIURIS'][__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a['APIURIS']['current']];return _this6;}_createClass(BrandPopup,[{key:'render',value:function render(){var _this7=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'brand-popup'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'brand-popup-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'un.to.st'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'brand-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'brand-container flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'brand-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'li.ex.sat'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'brand-btn',onClick:function onClick(e){_this7.props.cancelPopup();window.open(__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a["APIURIS"][__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a["APIURIS"]["current"]]+'brand','_blank');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:'re.tx'})))));}}]);return BrandPopup;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var CommonPopupComponent=function(_React$Component4){_inherits(CommonPopupComponent,_React$Component4);function CommonPopupComponent(props){_classCallCheck(this,CommonPopupComponent);var _this8=_possibleConstructorReturn(this,(CommonPopupComponent.__proto__||Object.getPrototypeOf(CommonPopupComponent)).call(this,props));_this8.appUrl=__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a['APPICONS'][__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a['APPICONS']['current']];_this8.state={popupDisplay:'none',responsiveWidth:'',responsiveHeight:''};_this8.ClosePopup=_this8.ClosePopup.bind(_this8);_this8.applyCss=_this8.applyCss.bind(_this8);_this8.popWidth=1152;_this8.popHeight=450;return _this8;}_createClass(CommonPopupComponent,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.applyCss,false);if(this.popWidth>window.innerWidth||this.popHeight>window.innerHeight){this.applyCss(window.innerWidth,window.innerHeight,'start');}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextState){if(nextProps.commonPopup.toJS().popup!==this.props.commonPopup.toJS().popup){if(nextProps.commonPopup.toJS().popup==='VIDEO')this.popWidth=800;this.popHeight=450;this.setState({responsiveWidth:this.popWidth,responsiveHeight:this.popHeight,windowHeight:window.innerHeight,windowWidth:window.innerWidth});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.applyCss,false);}},{key:'applyCss',value:function applyCss(alignWidth,alignHeight,position){try{this.windowWidth=window.innerWidth;this.windowHeight=window.innerHeight;var setWidth;var setHeight;if(position==='start'){setWidth=alignWidth-100;if(this.windowHeight>this.popHeight){setHeight=this.popHeight-this.popHeight*2.56/100-100/2.56;}}else{if(this.props.commonPopup.toJS().show){var innerPopup=document.querySelector('.common-popup').getElementsByClassName('common-popup-inner')[0];setWidth=innerPopup.offsetWidth;setHeight=innerPopup.offsetHeight;}else{if(this.popWidth>window.innerWidth||this.popHeight>window.innerHeight){setWidth=window.innerWidth-100;if(this.windowHeight>this.popHeight){setHeight=this.popHeight-this.popHeight*2.56/100-100/2.56;}}else{setWidth=this.popWidth;setHeight=this.popHeight;}}}if(this.props.commonPopup.toJS().show){if(this.state.windowWidth>window.innerWidth||this.state.windowHeight>window.innerHeight){if(setWidth>window.innerWidth/2&&setWidth>=924||setHeight>window.innerHeight/2&&setHeight>=640){setWidth=setWidth-setWidth*2.56/100;setHeight=setHeight-setHeight*1/100;}}else{if(setWidth<this.popWidth&&window.innerWidth>=1024&&window.innerHeight>=700||setHeight<this.popHeight&&window.innerWidth>=1024&&window.innerHeight>=700){setWidth=setWidth+setWidth*2.56/100;setHeight=setHeight+setHeight*1/100;}else if(window.innerWidth>this.popWidth&&window.innerHeight>this.popHeight){setWidth=this.popWidth;setHeight=this.popHeight;}}}this.setState({responsiveWidth:setWidth,responsiveHeight:setHeight,windowHeight:window.innerHeight,windowWidth:window.innerWidth});}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_5__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CommonPopup-applyCss");}}},{key:'ClosePopup',value:function ClosePopup(){var e=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var status=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;try{if(status==='outside'){if(!this.isMouseOn(e,"common-popup-inner")&&this.props.commonPopup.toJS().popup==='VIDEO'){this.setState({popupDisplay:'none'});this.props.openCommonPopup(null,false);}}else{this.setState({popupDisplay:'none'});this.props.openCommonPopup(null,false);}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_5__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CommonPopup-ClosePopup");}}},{key:'isMouseOn',value:function isMouseOn(e,value){try{var i;var path_array=e.path||e.composedPath&&e.composedPath()||this.composedPath(e.target);if(path_array.length>0){for(i=0;i<path_array.length;i++){if(path_array[i].className!==undefined&&_typeof(path_array[i].className)!=="object"){if(path_array[i].className.indexOf(value)!==-1){return true;}}else if(path_array[i].className!==undefined&&_typeof(path_array[i].className)==="object"){if(path_array[i].className.animVal.indexOf(value)!==-1)return true;}}}return false;}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_5__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"CommonPopup-isMouseOn");}}},{key:'composedPath',value:function composedPath(el){var path=[];while(el){path.push(el);if(el.tagName==='HTML'){path.push(document);path.push(window);return path;}el=el.parentElement;}}},{key:'render',value:function render(){var _this9=this;var visibility=this.props.commonPopup.toJS().show?'block':'none';var stylePopup={};var popupType=this.props.commonPopup.toJS().popup;if(this.props.commonPopup.toJS().show){if(this.props.commonPopup.toJS().popup==="VIDEO")stylePopup={width:this.state.responsiveWidth+'px',height:this.state.responsiveHeight+'px',zIndex:1};else if(this.props.commonPopup.toJS().popup==="SHORTCUT")stylePopup={width:"990px",height:"auto",zIndex:1};else if(popupType&&popupType.indexOf("anms")!==-1)stylePopup={width:"550px",height:"auto",zIndex:1};else if(popupType==="brandExceeds"){stylePopup={width:"550px",height:"auto",zIndex:1,backgroundColor:"#fff"};}}var videoSliderHeight=document.getElementById('videoSLiderDiv')!==null&&document.getElementById('videoSLiderDiv')!==undefined?document.getElementById('videoSLiderDiv').offsetHeight:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-html2canvas-ignore':'true',className:'common-popup tool-bar'+(popupType&&popupType.indexOf("anms")!==-1?" anms":""),style:{display:visibility},onMouseDown:function onMouseDown(e){_this9.ClosePopup(e,'outside');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'common-popup-inner',style:stylePopup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close-button bgvideo-close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.appUrl+"/images/cancel-normal.svg",onClick:function onClick(){_this9.ClosePopup();}})),this.props.commonPopup.toJS().popup==="VIDEO"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__helpers_ErrorHandler__["a" /* default */],{component:'BgVideo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__containers_BgVideo__["a" /* default */],{changedDimensions:videoSliderHeight,cancelPopup:this.ClosePopup,socket:this.props.socket})):null,this.props.commonPopup.toJS().popup==="SHORTCUT"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__helpers_ErrorHandler__["a" /* default */],{component:'SHORTCUT'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShortcutsPopup,{socket:this.props.socket,userId:this.props.userId})):null,popupType&&popupType.indexOf("anms")!==-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__helpers_ErrorHandler__["a" /* default */],{component:'ANMSPOPUP'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AnmsPopup,{socket:this.props.socket,data:this.props.commonPopup,userId:this.props.userId,workspaceBG:this.props.workspaceBG,setWorkspaceTextFocus:this.props.setWorkspaceTextFocus,updateUserDetails:this.props.updateUserDetails,manageToast:this.props.manageToast,closePopup:this.ClosePopup})):null,this.props.commonPopup.toJS().popup==="brandExceeds"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__helpers_ErrorHandler__["a" /* default */],{component:'brandExceeds'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BrandPopup,{socket:this.props.socket,userId:this.props.userId,cancelPopup:this.ClosePopup})):null));}}]);return CommonPopupComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CommonPopupComponent);

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BgVideoComponent__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_index__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state,ownProps){return{selectedScene:state.localStore.get('selectedScene'),workspaceBG:state.project.getIn(['scenes',state.localStore.get('selectedScene'),'workspaceBG']),commonPopup:state.localStore.getIn(['commonPopup']),sceneDuration:state.project.getIn(['scenes',state.localStore.get('selectedScene'),'duration']),example:2,bgFilterCode:state.project.getIn(['scenes',state.localStore.get('selectedScene'),'workspaceBG','bgFilter']),isWorkspaceTextFocus:state.localStore.get('isWorkspaceTextFocus'),selectedItems:state.localStore.get("selectedItems"),workspaceItems:state.project.getIn(["scenes",state.localStore.get('selectedScene'),"workspaceItems"]),workspaceCameras:state.project.getIn(["scenes",state.localStore.get('selectedScene'),"workspaceCameras"]),bgVideoWidth:state.project.getIn(['scenes',state.localStore.get('selectedScene'),'workspaceBG','width']),bgVideoHeight:state.project.getIn(['scenes',state.localStore.get('selectedScene'),'workspaceBG','height']),projectHeight:state.project.get("height"),projectWidth:state.project.get("width"),isBGVideoSwapinLite:state.localStore.get("isBGVideoSwapinLite"),BgUndoData:state.localStore.get("undoProp")};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{openCommonPopup:function openCommonPopup(value,status){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_7" /* loadCommonPopup */])(value,status));},setWorkspaceTextFocus:function setWorkspaceTextFocus(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_52" /* setWorkspaceTextFocus */])(data));},changeBg:function changeBg(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["A" /* changeBg */])(data,socket));},dropBG:function dropBG(data,deleteData,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["X" /* dropBG */])(data,deleteData,socket));},onItemDrag:function onItemDrag(socket,item,data,id,selItem,selectedScene){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_15" /* onItemDrag */])(socket,item,data,id,selItem,selectedScene));},changeVideoVolume:function changeVideoVolume(data,socket){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["J" /* changeVideoVolume */])(data,socket));},nextBtnClicked:function nextBtnClicked(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_14" /* nextBtnClicked */])(data));}};};var BgVideo=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_BgVideoComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (BgVideo);

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_app_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ErrorLogService__ = __webpack_require__(9);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BgVideoComponent=function(_React$Component){_inherits(BgVideoComponent,_React$Component);function BgVideoComponent(props){_classCallCheck(this,BgVideoComponent);var _this=_possibleConstructorReturn(this,(BgVideoComponent.__proto__||Object.getPrototypeOf(BgVideoComponent)).call(this,props));_this.getCurTime=function(){var videoTag=document.getElementById('video-in-popup');var videoStart=_this.state.minCursorValue,videoEnd=_this.state.maxCursorValue;if(videoTag.currentTime>=videoEnd||videoTag.currentTime>=videoTag.duration){if(_this.playPromise!==undefined){_this.playPromise.then(function(_){videoTag.pause();_this.playPromise=undefined;}).catch(function(error){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ErrorLogService__["a" /* errorlog */])("Popup video is paused before play start ",error,"BgVideoComponent-getCurTime");});}videoTag.currentTime=videoStart;var mincursorX=parseFloat(_this.videoStarts/_this.props.workspaceBG.get("videoDuration")*_this.state.totalWidth);videoTag.removeEventListener("timeupdate",_this.getCurTime,false);_this.setState({playVideo:false,isPlaying:false,playCursorX:0});}else{var _mincursorX=parseFloat(videoTag.currentTime/_this.state.totalDuration*_this.state.totalWidth);_this.setState({isPlaying:true,playCursorX:_mincursorX-_this.state.minCursorX});videoTag.volume=_this.state.volume/100;}};_this.isCanvasTransparent=function(canvas,width,height){var ctx=canvas.getContext("2d");if(width>0&&height>0){var imageData=ctx.getImageData(0,0,width,height);for(var i=0;i<imageData.data.length;i+=4){if(imageData.data[i+3]!==0)return false;}return true;}};_this.videoSeek=function(){_this.thumbWidth=_this.vid.videoWidth/_this.vid.videoHeight*_this.cursorHeight;var frameCount=Math.ceil(_this.totalDur*_this.timeScale/_this.thumbWidth)+2;var seekVal=_this.totalDur/frameCount,checkVal=_this.totalDur;_this.generateThumbnail(_this.vidTime,_this.vid,_this.thumbWidth);_this.vidTime+=seekVal;if(_this.vidTime<=checkVal)_this.vid.currentTime=_this.vidTime;else{_this.loadImages(_this.sources,function(images){var _this2=this;var canvas=document.createElement('canvas');var context=canvas.getContext('2d');canvas.width=this.totalDur*this.timeScale;canvas.height=this.cursorHeight;var xpos=0,state={};if(Object.keys(images).indexOf(NaN)>=0)return;for(var x in images){if(x){context.drawImage(images[x],xpos,0,this.thumbWidth,this.cursorHeight);xpos+=this.thumbWidth;}}if(Object.keys(images).length<frameCount){for(var cnt=0;cnt<frameCount-Object.keys(images).length;cnt++){context.drawImage(images[x],xpos,0,this.thumbWidth,this.cursorHeight);xpos+=this.thumbWidth;}}this.loadedData=true;this.completeThumbnail=true;state['videoThumbnailSeries']=canvas.toDataURL();this.setState(state,function(){_this2.vid.removeEventListener('seeked',_this2.videoSeek,false);});}.bind(_this));}};_this.loadImages=function(sources,callback){var images={},numImages=Object.keys(sources).length;_this.loadedImages=0;for(var src in sources){images[src]=new Image();images[src].onload=function(){_this.arrangeImage(numImages,images,callback);};images[src].src=sources[src];}};_this.arrangeImage=function(numImages,images,callback){if(++_this.loadedImages>=numImages){callback(images);}};_this.timelineReducer=function(value){var updateDetails=[],duration=parseFloat(value);var thumbArr=['enterStart','enterEnd','exitStart','exitEnd','numStart','numEnd'],thumbValues=[];_this.props.workspaceItems.entrySeq().forEach(function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];thumbValues=[value.get('enterStart'),value.get('enterEnd'),value.get('exitStart'),value.get('exitEnd'),value.get('numStart'),value.get('numEnd')];for(var i=0;i<thumbArr.length;i++){if(parseFloat(thumbValues[i])>=duration){if(thumbArr[i]==="enterStart"){updateDetails.push({name:thumbArr[i],value:duration-1<0?0:duration-1,id:key});updateDetails.push({name:'enterEffectName',value:'no_Effect',id:key});updateDetails.push({name:'enterEnd',value:0,id:key});}else if(thumbArr[i]==="numStart")updateDetails.push({name:thumbArr[i],value:duration-0.1,id:key});else if(parseFloat(thumbValues[i])>duration)updateDetails.push({name:thumbArr[i],value:duration,id:key});}}});if(_this.props.workspaceBG.get('src')!==''){var _duration=parseFloat(value);if(_this.props.workspaceBG.get('exitEnd')>_duration){updateDetails.push({name:'bgEnd',value:_duration});}if(_this.props.workspaceBG.get('enterStart')>_duration-1)updateDetails.push({name:'bgStart',value:_duration-1});}return updateDetails;};_this.getWidthandHeight=function(w,h){var style={};var bgWidth=_this.props.projectWidth*w;var bgHeight=_this.props.projectHeight*h;var angle=0;if(_this.props.workspaceBG.get("angle")!==undefined)angle=_this.props.workspaceBG.get("angle");style.transform="rotatez("+angle+"deg)";if(bgWidth>bgHeight){style.width=_this.videoWidth+'px';style.height=_this.videoWidth/bgWidth*bgHeight+"px";return style;}else if(bgWidth<bgHeight||bgWidth===bgHeight){style.height=_this.videoHeight+'px';style.width=_this.videoHeight/bgHeight*bgWidth+"px";return style;}};_this.applyVolume=function(e){try{if(_this.state.volume!==e.target.value){if(parseInt(e.target.value)===0){_this.setState({volume:0,tempVolume:_this.state.volume,muteValue:true});}else{_this.setState({volume:parseInt(e.target.value),tempVolume:parseInt(e.target.value),muteValue:false});}}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"BgVideoComponent-applyVolume");}};_this.saveVolume=function(e){_this.props.changeVideoVolume({selectedScene:_this.props.selectedScene,value:parseInt(e.target.value,10)},_this.props.socket);};_this.secToMin=function(sec){var decimal="";if(Math.abs(parseFloat(sec)-Math.floor(parseFloat(sec)))){decimal="."+Math.abs(parseFloat(sec)-Math.floor(parseFloat(sec))).toFixed(1).split(".")[1];}sec=Math.floor(sec);var rem=sec%60;var quo=Math.round((sec-rem)/60);var len=String(quo).length;return("0"+quo).slice(-(len<=1?2:len))+':'+("0"+rem+decimal).slice(decimal?-4:-2);};_this.handleMousedown=function(e,cursor){try{e.preventDefault();var secondVideo=document.querySelector(".second-video-range").getBoundingClientRect().left;var translateValue=e.clientX-secondVideo;if(cursor==="range"){var midShadow=document.querySelector("#mid-shadow");_this.midWidth=midShadow.offsetWidth;_this.setState({activeCursor:"range",initialrangeCursorX:e.clientX,minxD:_this.state.minCursorX,maxxD:_this.state.maxCursorX});}if(cursor==="min")_this.setState({activeCursor:cursor,initialminCursorX:translateValue,minisMoving:true});if(cursor==="max")_this.setState({activeCursor:cursor,initialmaxCursorX:translateValue,maxisMoving:true});window.addEventListener('mousemove',_this.handleMouseMove,true);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"BgVideoComponent-handleMousedown");}};_this.handleMouseMove=function(e){try{e.preventDefault();var secondLeft=document.querySelector(".second-video-range").getBoundingClientRect().left;var translateValue=e.clientX-secondLeft;var midWidth=document.querySelector("#mid-shadow").offsetWidth;var videoElem=document.getElementById("video-in-popup");if(_this.state.activeCursor==="range")translateValue=e.clientX;var tmaxmidValue=translateValue-_this.midWidth;if(translateValue<_this.state.initialrangeCursorX&&_this.state.activeCursor==="range"){var negativeDeviation=_this.state.initialrangeCursorX-translateValue;var midValue=_this.state.minxD-negativeDeviation;var maxMidValue=_this.state.maxxD-negativeDeviation;if(midValue>=0){var cursorValue=parseFloat((midValue/_this.state.totalWidth*_this.state.totalDuration).toFixed(1));videoElem.currentTime=cursorValue;var maxcursorValue=parseFloat((maxMidValue/_this.state.totalWidth*_this.state.totalDuration).toFixed(1));_this.setState({minCursorX:midValue,minCursorValue:cursorValue,maxCursorX:maxMidValue,maxCursorValue:maxcursorValue});}else{var _maxcursorValue=parseFloat(((_this.midWidth+7)/_this.state.totalWidth*_this.state.totalDuration).toFixed(1));_this.setState({minCursorX:0,minCursorValue:0,maxCursorX:_this.midWidth+7,maxCursorValue:_maxcursorValue});}}if(translateValue>_this.state.initialrangeCursorX&&_this.state.activeCursor==="range"){var positiveDeviation=translateValue-_this.state.initialrangeCursorX;var _midValue=_this.state.minxD+positiveDeviation;var _maxMidValue=_this.state.maxxD+positiveDeviation;if(_maxMidValue<=_this.state.totalWidth){var _cursorValue=parseFloat((_midValue/_this.state.totalWidth*_this.state.totalDuration).toFixed(1));videoElem.currentTime=_cursorValue;var _maxcursorValue2=parseFloat((_maxMidValue/_this.state.totalWidth*_this.state.totalDuration).toFixed(1));_this.setState({minCursorX:_midValue,minCursorValue:_cursorValue,maxCursorX:_maxMidValue,maxCursorValue:_maxcursorValue2});}else{var maxCursorX=_this.state.totalWidth;var maxCursorValue=parseFloat((maxCursorX/_this.state.totalWidth*_this.state.totalDuration).toFixed(1));var minCursorX=maxCursorX-_this.midWidth-7;var minCursorValue=parseFloat((minCursorX/_this.state.totalWidth*_this.state.totalDuration).toFixed(1));_this.setState({minCursorX:minCursorX,minCursorValue:minCursorValue,maxCursorX:maxCursorX,maxCursorValue:maxCursorValue});}}if(translateValue!==_this.state.initialminCursorX&&_this.state.activeCursor==="min"&&translateValue+7<_this.state.maxCursorX){if(translateValue<=0){translateValue=0;}if(translateValue>=_this.state.totalWidth){translateValue=_this.state.maxCursorX-7;}var _cursorValue2=parseFloat((translateValue/_this.state.totalWidth*_this.state.totalDuration).toFixed(1));videoElem.currentTime=_cursorValue2;_this.setState({minCursorX:translateValue,minCursorValue:_cursorValue2});}if(translateValue!==_this.state.initialmaxCursorX&&_this.state.activeCursor==="max"&&translateValue-7>_this.state.minCursorX){if(translateValue>=_this.state.totalWidth){translateValue=_this.state.totalWidth;}if(translateValue<0){translateValue=_this.state.minCursorX+7;}var _cursorValue3=parseFloat((translateValue/_this.state.totalWidth*_this.state.totalDuration).toFixed(1));videoElem.currentTime=_cursorValue3;_this.setState({maxCursorX:translateValue,maxCursorValue:_cursorValue3});}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"BgVideoComponent-handleMouseMove");}};_this.handleMouseUp=function(e){try{_this.setState({minisMoving:false,maxisMoving:false});window.removeEventListener('mousemove',_this.handleMouseMove,true);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"BgVideoComponent-handleMouseUp");}};_this.generateThumbnails=function(){var thumbDetails={};thumbDetails.src=_this.props.workspaceBG.get('thumbnail');thumbDetails.mainType=_this.props.workspaceBG.get('type');thumbDetails.musicEnd=_this.props.workspaceBG.get('videoEnd');thumbDetails.musicDuration=_this.props.workspaceBG.get('videoDuration');var objWidth=document.querySelector(".second-video-range").offsetWidth;var setThumbNail=[];if(thumbDetails.src!==""&&(thumbDetails.mainType!=="UPLOADS"||thumbDetails.mainType!=="IMG"||thumbDetails.mainType!=="STOCKIMG"||thumbDetails.mainType!=="UPIMAGE"||thumbDetails.mainType!=="BG")){var imageCount=Math.ceil(objWidth/90);var vidStyle={};vidStyle.backgroundImage="";vidStyle.backgroundPosition="";var offset=0;var left=0;var xPos=-90+offset;for(var i=0;i<imageCount;i++){thumbDetails.musicDuration/2;var takenFrames=thumbDetails.musicDuration/2;var divider=1;var maxFrame=thumbDetails.musicEnd/divider;if(maxFrame>150)maxFrame=150;var frameCount=imageCount/maxFrame;var currentFrame=Math.floor(i/frameCount);var videoThumburl=_this.assetUrl+"animaker/videothumbs/newimage.png";if(thumbDetails.mainType==="UPVIDEO"){var thumbSrc=void 0;thumbDetails.src=_this.props.workspaceBG.get('src');if(thumbDetails.src.includes('proxy1'))thumbSrc=thumbDetails.src.replace('proxy1','thumbstrip');else{thumbSrc=thumbDetails.src.split('video/').join('video/thumbstrip/');}videoThumburl=__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['UPLOADS'][__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['UPLOADS']['workspace_UPVIDEO']]+thumbSrc.split(".")[0]+".png";if(_this.props.workspaceBG.get('isBlob')){videoThumburl=_this.props.workspaceBG.get('thumbnail');}}else if(thumbDetails.mainType==="STOCKVID"){videoThumburl=__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['VIDEO']["thumbStrip"]+thumbDetails.src;}else if(thumbDetails.mainType==='VIDEO'&&_this.props.workspaceBG.get('subType')==='OBGVID'){videoThumburl=_this.assetUrl+__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['BG']['obgsrc']+_this.props.workspaceBG.get('thumbnail').split('thumb').join('thumbstrip');}xPos=xPos+90;var yPos=currentFrame*50*-1;if(vidStyle.backgroundImage===""){vidStyle.backgroundImage+="url("+videoThumburl+")";}else{vidStyle.backgroundImage+=",url("+videoThumburl+")";}if(vidStyle.backgroundPosition==="")vidStyle.backgroundPosition+=xPos+"px "+yPos+"px";else vidStyle.backgroundPosition+=","+xPos+"px "+yPos+"px";}if(document.querySelector(".second-video-range")){document.querySelector(".second-video-range").style.backgroundImage=vidStyle.backgroundImage;document.querySelector(".second-video-range").style.backgroundPosition=vidStyle.backgroundPosition;}}};_this.getFlipPosition=function(){var style={};var flipPos=_this.props.workspaceBG.get("flipPosition");style.transform=flipPos===1?" scaleX(-1)":flipPos===2?" scaleY(-1)":flipPos===3?" scaleX(-1) scaleY(-1)":"";return style;};_this.appUrl=__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['APPICONS'][__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['APPICONS']['current']];_this.mainDimensions={width:'',height:'',left:''};_this.state={minThumbHeight:'',minThumbLeft:'',maxThumbHeight:'',maxThumbLeft:'',commonPopupLeft:'',minThumbWidth:'',innerWrapperLeft:'',innerWrapperWidth:'',videoDuration:'',muteValue:false,volume:0,tempVolume:0,videoThumbnailSeries:_this.appUrl+'/images/loading/load-progress.gif',startThumbTime:'',endThumbTime:'',playVideo:false,indicatorPos:0,effects:false,filterType:'',pastArr:'',filterEffects:false,filterCode:'32646400064 -10000',gifWidth:0,inputEnd:0,inputStart:0,playStarted:false,playEnded:false,minisMoving:false,maxisMoving:false,isPlaying:false};_this.onThumbMove=_this.onThumbMove.bind(_this);_this.onMultipleChange=_this.onMultipleChange.bind(_this);_this.addCss=_this.addCss.bind(_this);_this.handleApply=_this.handleApply.bind(_this);_this.handleCancel=_this.handleCancel.bind(_this);_this.setDummyThumbnail=_this.setDummyThumbnail.bind(_this);_this.handleplayheadMove=_this.handleplayheadMove.bind(_this);_this.handleplayheadClick=_this.handleplayheadClick.bind(_this);_this.removeListeners=_this.removeListeners.bind(_this);_this.onInputChange=_this.onInputChange.bind(_this);_this.addEffects=_this.addEffects.bind(_this);_this.handleCancelClick=_this.handleCancelClick.bind(_this);_this.assetUrl=__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['ASSETS'][__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['ASSETS']['current']];//THumbNail Details displaying..
_this.vid='';_this.thumbId='';_this.totalDur='';_this.timeScale='';_this.thumbnailIndex='';_this.vidTime='';_this.sources=[];_this.cursorHeight=0;_this.loadImages=_this.loadImages.bind(_this);_this.getThumbnail=_this.getThumbnail.bind(_this);_this.loadedData=true;_this.maxThumPosition='';_this.minThumPosition='';_this.effectsOutput=[];_this.completeThumbnail=false;_this.defaultThumbPosition=0;_this.applyVideoChanges=_this.applyVideoChanges.bind(_this);_this.thumbs=[];_this.container={width:'800px',height:'530px'};_this.videoWidth=800;_this.videoHeight=450;_this.volumeUI=[];return _this;}_createClass(BgVideoComponent,[{key:'componentDidMount',value:function componentDidMount(){var firstDivision=document.getElementsByClassName('first-play-button')[0]?document.getElementsByClassName('first-play-button')[0].offsetWidth:0;var videTag=document.getElementById("video-in-popup");var firstTime=document.getElementsByClassName('cut-start-time')[0]?document.getElementsByClassName('cut-start-time')[0].offsetWidth:0;this.defaultThumbPosition=firstDivision+firstTime;var objWidth=document.querySelector(".second-video-range").offsetWidth;this.generateThumbnails();if(this.props.isBGVideoSwapinLite&&this.props.BgUndoData.videoEnd<=this.props.workspaceBG.get("videoDuration")){var mincursorValue=parseFloat(this.props.BgUndoData.videoStart.toFixed(1));videTag.currentTime=mincursorValue;var maxcursorValue=parseFloat(this.props.BgUndoData.videoEnd.toFixed(1));var duration=this.props.BgUndoData.videoEnd-this.props.BgUndoData.videoStart;var mincursorX=parseFloat(this.props.BgUndoData.videoStart/this.props.workspaceBG.get("videoDuration")*objWidth);var maxcursorX=parseFloat(this.props.BgUndoData.videoEnd/this.props.workspaceBG.get("videoDuration")*objWidth);this.setState({minCursorX:mincursorX,minCursorValue:mincursorValue,maxCursorX:maxcursorX,maxCursorValue:maxcursorValue,totalWidth:objWidth,totalDuration:this.props.workspaceBG.get("videoDuration"),volume:parseInt(this.props.BgUndoData.volume)>=0?parseInt(this.props.BgUndoData.volume):100});}else{var _mincursorValue=parseFloat(this.props.workspaceBG.get("videoStart").toFixed(1));videTag.currentTime=_mincursorValue;var _maxcursorValue3=parseFloat(this.props.workspaceBG.get("videoEnd").toFixed(1));var _duration2=this.props.workspaceBG.get("videoEnd")-this.props.workspaceBG.get("videoStart");var _mincursorX2=parseFloat(this.props.workspaceBG.get("videoStart")/this.props.workspaceBG.get("videoDuration")*objWidth);var _maxcursorX=parseFloat(this.props.workspaceBG.get("videoEnd")/this.props.workspaceBG.get("videoDuration")*objWidth);this.setState({minCursorX:_mincursorX2,minCursorValue:_mincursorValue,maxCursorX:_maxcursorX,maxCursorValue:_maxcursorValue3,totalWidth:objWidth,totalDuration:this.props.workspaceBG.get("videoDuration"),volume:parseInt(this.props.workspaceBG.get("volume"))>=0?parseInt(this.props.workspaceBG.get("volume")):100});}var nextBtn=document.querySelector('.next_step');if(nextBtn){this.props.nextBtnClicked(true);nextBtn.classList.remove('disable');nextBtn.click();}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.workspaceBG.get("type")==="UPVIDEO"||nextProps.workspaceBG.get("type")==="STOCKVID"){if(nextProps.workspaceBG.get('src')!==this.props.workspaceBG.get("src")){this.props=nextProps;var objWidth=document.querySelector(".second-video-range").offsetWidth;this.generateThumbnails();var mincursorValue=parseFloat(this.props.workspaceBG.get("videoStart").toFixed(1));var maxcursorValue=parseFloat(this.props.workspaceBG.get("videoEnd").toFixed(1));var duration=this.props.workspaceBG.get("videoEnd")-this.props.workspaceBG.get("videoStart");var mincursorX=parseFloat(this.props.workspaceBG.get("videoStart")/this.props.workspaceBG.get("videoDuration")*objWidth);var maxcursorX=parseFloat(this.props.workspaceBG.get("videoEnd")/this.props.workspaceBG.get("videoDuration")*objWidth);this.setState({minCursorX:mincursorX,minCursorValue:mincursorValue,maxCursorX:maxcursorX,maxCursorValue:maxcursorValue,totalWidth:objWidth,totalDuration:this.props.workspaceBG.get("videoDuration"),volume:parseInt(this.props.workspaceBG.get("volume"))>=0?parseInt(this.props.workspaceBG.get("volume")):100});}}}},{key:'componentWillMount',value:function componentWillMount(){window.addEventListener('mouseup',this.removeListeners,false);this._addListeners();this.props.setWorkspaceTextFocus(true);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var elements=document.getElementsByClassName('filterEdit-icon');if(elements&&elements.length>0){for(var i=0;i<elements.length;i++){elements[i].style.display="none";}if(this.state.filterType!=="")document.getElementById(this.state.filterType.toLowerCase()+"-filterEdit").style.display="flex";}}},{key:'removeListeners',value:function removeListeners(){window.removeEventListener('mousemove',this.handleplayheadMove,false);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('mouseup',this.removeListeners,false);var videoTag=document.getElementById('video-in-popup');videoTag.removeEventListener("timeupdate",this.getCurTime,false);this._removeListeners();}},{key:'secondsToHms',value:function secondsToHms(d){d=Number(d);var m=Math.floor(d%3600/60);var s=Math.floor(d%3600%60);var mDisplay=m>0?m+(m===1?"":""):"";var sDisplay=s>0?s+(s===1?"":""):"";if(sDisplay!==null&&sDisplay.length>=1){sDisplay=sDisplay.length>1?sDisplay:'0'+sDisplay;}else{sDisplay='00';}if(mDisplay!==null&&mDisplay!==""){mDisplay=mDisplay.length>1?mDisplay:'0'+mDisplay;}else{mDisplay='00';}return mDisplay+':'+sDisplay;}},{key:'runVideo',value:function runVideo(){try{var videoTag=document.getElementById('video-in-popup');videoTag.addEventListener("timeupdate",this.getCurTime,false);videoTag.currentTime=this.state.minCursorValue;if(!this.state.playVideo){this.videoStarts=Number(Math.round(videoTag.currentTime+"e1")+"e-1");videoTag.volume=this.state.volume/100;this.playPromise=videoTag.play();}else{videoTag.pause();this.playPromise=undefined;videoTag.removeEventListener("timeupdate",this.getCurTime,false);}this.setState({playVideo:!this.state.playVideo,isPlaying:!this.state.playVideo,playCursorX:0});}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"BgVideoComponent-runVideo");}}},{key:'enableMute',value:function enableMute(event){try{var videoTag=document.getElementById('video-in-popup');videoTag.muted=!this.state.muteValue;this.setState({muteValue:videoTag.muted,volume:videoTag.muted?0:100});}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"BgVideoComponent-enableMute");}}},{key:'setDummyThumbnail',value:function setDummyThumbnail(){var video=document.getElementById('video-in-popup');var source=this.assetUrl+"animaker/videothumbs/newimage.png";var thumbStrip=this.props.workspaceBG.get('src');if(this.props.workspaceBG.get('type')==="UPVIDEO"){var thumbSrc=void 0;if(this.props.workspaceBG.get('src').includes("proxy1"))thumbSrc=thumbStrip.replace('proxy1','thumbstrip');else{thumbSrc=thumbStrip.split('video/').join('video/thumbstrip/');}source=__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['UPLOADS'][__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['UPLOADS']['workspace_UPVIDEO']]+thumbSrc.split(".")[0]+".png";if(this.props.workspaceBG.get('isBlob')){source=this.props.workspaceBG.get('thumbnail');}}else if(this.props.workspaceBG.get('type')==="STOCKVID"){source=__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['VIDEO']["thumbStrip"]+thumbStrip.split(".")[0]+".png";}var posterImg=new Image();posterImg.src=source;posterImg.onload=function(){video.onloadedmetadata=function(){var totalWidth=document.getElementById('duration-in-width-video').offsetWidth;this.timeScale=totalWidth/video.duration;this.thumbWidth=video.videoWidth/video.videoHeight*this.cursorHeight;var frameCount=Math.ceil(video.duration*this.timeScale/this.thumbWidth)+2;var canvas=document.createElement("canvas");canvas.width=this.thumbWidth;canvas.height=this.cursorHeight;var ctx=canvas.getContext("2d");ctx.drawImage(posterImg,0,0,this.thumbWidth,this.cursorHeight);var dataURL=canvas.toDataURL();var imgSrcArr=new Array(frameCount);imgSrcArr.fill(dataURL);this.loadImages(imgSrcArr,function(images){var _this3=this;var canvas=document.createElement('canvas');var context=canvas.getContext('2d');canvas.width=video.duration*this.timeScale;canvas.height=this.cursorHeight;var xpos=0;if(Object.keys(images).indexOf(NaN)>=0)return;for(var x in images){if(x){context.drawImage(images[x],xpos,0,this.thumbWidth,this.cursorHeight);xpos+=this.thumbWidth;}}if(Object.keys(images).length<frameCount){for(var cnt=0;cnt<frameCount-Object.keys(images).length;cnt++){context.drawImage(images[x],xpos,0,this.thumbWidth,this.cursorHeight);xpos+=this.thumbWidth;}}this.loadedData=true;var endThumbTime=this.props.workspaceBG.get('videoEnd');if(endThumbTime>video.duration)endThumbTime=video.duration;if(!this.completeThumbnail){this.setState({videoThumbnailSeries:canvas.toDataURL(),videoDuration:video.duration,startThumbTime:this.props.workspaceBG.get('videoStart'),endThumbTime:endThumbTime,inputStart:this.props.workspaceBG.get('videoStart'),inputEnd:endThumbTime},function(){_this3.addCss();});}}.bind(this));}.bind(this);}.bind(this);}},{key:'getThumbnail',value:function getThumbnail(){this.vidTime=0.001;this.sources=[];var video=document.createElement('video');var source=this.assetUrl+"animaker/videothumbs/newimage.png";var thumbStrip=this.props.workspaceBG.get('src');var configBasePath=this.props.workspaceBG.get('src');if(this.props.workspaceBG.get('type')==="UPVIDEO"){var thumbSrc=void 0;if(this.props.workspaceBG.get('src').includes("proxy1"))thumbSrc=thumbStrip.replace('proxy1','thumbstrip');else{thumbSrc=thumbStrip.split('video/').join('video/thumbstrip/');}configBasePath=__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['UPLOADS'][__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['UPLOADS']['workspace_UPVIDEO']]+thumbSrc.split(".")[0]+".png";if(this.props.workspaceBG.get('isBlob')){configBasePath=this.props.workspaceBG.get('thumbnail');}}else if(this.props.workspaceBG.get('type')==="STOCKVID"){configBasePath=__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['VIDEO']["thumbStrip"]+thumbStrip.split(".")[0]+".png";}video.src=configBasePath;video.id="video-in-thumbnail";video.preload="auto";this.vid=video;this.thumbId='video-in-popup';video.currentTime=this.vidTime;video.onloadedmetadata=function(){var _this4=this;this.loadedData=true;var pixelForOnesecond=this.innerWrapperWidthMain/video.duration,endThumbTime=this.props.workspaceBG.get('videoEnd');if(endThumbTime>video.duration)endThumbTime=video.duration;this.setState({videoDuration:video.duration,startThumbTime:this.props.workspaceBG.get('videoStart'),endThumbTime:endThumbTime,inputStart:this.props.workspaceBG.get('videoStart'),inputEnd:endThumbTime},function(){_this4.addCss();});this.totalDur=video.duration;this.timeScale=pixelForOnesecond;this.thumbnailIndex=1;video.addEventListener('seeked',this.videoSeek,false);}.bind(this);}},{key:'generateThumbnail',value:function generateThumbnail(i,video,thumbWidth,type){var canvas=document.createElement("canvas");canvas.width=thumbWidth;canvas.height=this.cursorHeight;var ctx=canvas.getContext("2d");ctx.drawImage(video,0,0,thumbWidth,this.cursorHeight);var isEmpty=this.isCanvasTransparent(canvas,thumbWidth,this.cursorHeight);if(isEmpty){video.currentTime=i+0.1;this.vidTime=i+0.1;}var dataURL=canvas.toDataURL();if(type!=='temp'&&!isEmpty)this.sources[i]=dataURL;}},{key:'addCss',value:function addCss(){var thumbNailBackground=document.getElementById('videoSLiderDiv');var widthPerSecond=thumbNailBackground.offsetWidth/this.state.videoDuration;thumbNailBackground.style.boxShadow='inset '+Math.round(this.state.startThumbTime*widthPerSecond+2)+'px 0px 0px 0px #ffffffe0, inset '+Math.round(this.state.endThumbTime*widthPerSecond-thumbNailBackground.offsetWidth)+'px 0px 0px 0px #ffffffe0';}},{key:'handleApply',value:function handleApply(){var duration=Number(Math.round(this.state.maxCursorValue-this.state.minCursorValue+"e1")+"e-1");var objectData=this.timelineReducer(duration);var timelineData=[{name:"bgEnd",value:duration,key:"playHeadValue"},{name:"videoStart",value:this.state.minCursorValue,key:"playHeadValue"},{name:"videoEnd",value:this.state.maxCursorValue<this.props.workspaceBG.get("videoDuration")?this.state.maxCursorValue:this.props.workspaceBG.get("videoDuration"),key:"playHeadValue"},{name:"duration",value:duration,key:"playHeadValue"}];timelineData=timelineData.concat(objectData);this.props.onItemDrag(this.props.socket,"workspaceItems",timelineData,"",this.props.selectedItems.toJS(),this.props.selectedScene);this.props.cancelPopup();var nextBtn=document.querySelector('.next_step');if(nextBtn){this.props.nextBtnClicked(true);nextBtn.classList.remove('disable');nextBtn.click();}}},{key:'applyVideoChanges',value:function applyVideoChanges(){this.handleApply();}},{key:'handleCancel',value:function handleCancel(){try{this.props.openCommonPopup('',false);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"BgVideoComponent- handleCancel");}}},{key:'onThumbMove',value:function onThumbMove(name,value,id,type){var thumbNailBackground=document.getElementById('videoSLiderDiv');var widthPerSecond=thumbNailBackground.offsetWidth/this.state.videoDuration;if(type==='min'){this.minThumPosition=value;this.setState({indicatorPos:this.defaultThumbPosition+value+10});if((value!==undefined||value!==null||value!=='')&&(this.maxThumPosition===null||this.maxThumPosition===''))this.maxThumPosition=this.state.endThumbTime*widthPerSecond;thumbNailBackground.style.boxShadow='inset '+Math.round(value+2)+'px 0px 0px 0px #ffffffe0, inset '+Math.round(this.maxThumPosition-thumbNailBackground.offsetWidth)+'px 0px 0px 0px #ffffffe0';}else if(type==='max'){this.maxThumPosition=value;if(this.minThumPosition!==undefined||this.minThumPosition!==null||this.minThumPosition!=='')this.minThumPosition=this.state.startThumbTime*widthPerSecond;thumbNailBackground.style.boxShadow='inset '+Math.round(this.minThumPosition)+'px 0px 0px 0px #ffffffe0, inset '+Math.round(this.maxThumPosition-thumbNailBackground.offsetWidth)+'px 0px 0px 0px #ffffffe0';}else if(type==='updateStore'){var startTime=this.state.startThumbTime;var endTime=this.state.endThumbTime;if(name==='enterStart'){startTime=value;var videoTag=document.getElementById('video-in-popup');videoTag.currentTime=value;}else if(name==='exitEnd')endTime=value;this.setState({startThumbTime:startTime,endThumbTime:endTime,inputStart:startTime,inputEnd:endTime});}}},{key:'onMultipleChange',value:function onMultipleChange(name,values){var videoTag=document.getElementById('video-in-popup');videoTag.currentTime=this.state.startThumbTime;this.setState({endThumbTime:values[0].name==='exitEnd'?values[0].value:this.state.endThumbTime,startThumbTime:values[1].name==='enterStart'?values[1].value:this.state.startThumbTime,inputEnd:values[0].name==='exitEnd'?values[0].value:this.state.endThumbTime,inputStart:values[1].name==='enterStart'?values[1].value:this.state.startThumbTime});}},{key:'onInputChange',value:function onInputChange(position,e,type){var startTime=this.state.startThumbTime;var endTime=this.state.endThumbTime;if(type==="blur")this.props.setWorkspaceTextFocus(false);if(position==='start'){if(type==="blur"&&(Number(e.target.value)>Number(this.state.endThumbTime)||Math.abs(Number(e.target.value)-Number(this.state.endThumbTime))>this.props.sceneDuration)){alert("Enter a valid start time.");startTime=this.state.startThumbTime;}else startTime=e.target.value;}if(position==='end'){if(type==="blur"&&(Number(e.target.value)<Number(this.state.startThumbTime)||Math.abs(Number(e.target.value)-Number(this.state.startThumbTime))>this.props.sceneDuration)){alert("Enter a valid end time.");endTime=this.state.endThumbTime;}else endTime=e.target.value;}if(type==="blur"){var thumbNailBackground=document.getElementById('videoSLiderDiv');var widthPerSecond=thumbNailBackground.offsetWidth/this.state.videoDuration;thumbNailBackground.style.boxShadow='inset '+Math.round(startTime*widthPerSecond+4)+'px 0px 0px 0px #ffffffe0, inset '+Math.round(endTime*widthPerSecond-thumbNailBackground.offsetWidth)+'px 0px 0px 0px #ffffffe0';this.setState({startThumbTime:startTime,endThumbTime:endTime,inputStart:startTime,inputEnd:endTime});}else{this.setState({inputStart:startTime,inputEnd:endTime});}}},{key:'_addListeners',value:function _addListeners(){window.addEventListener('mouseup',this.handleMouseUp,false);}},{key:'_removeListeners',value:function _removeListeners(){window.removeEventListener('mouseup',this.handleMouseUp,false);}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState){var _this5=this;if(nextProps.changedDimensions!==this.props.changedDimensions){var totalWidth=document.getElementById('duration-in-width-video').offsetWidth;this.timeScale=totalWidth/this.state.videoDuration;this.setState({indicatorPos:nextState.startThumbTime*this.timeScale+this.defaultThumbPosition});var thumbNailBackground=document.getElementById('videoSLiderDiv');var widthPerSecond=thumbNailBackground.offsetWidth/nextState.videoDuration;thumbNailBackground.style.boxShadow='inset '+Math.round(nextState.startThumbTime*widthPerSecond)+'px 0px 0px 0px #ffffffe0, inset '+Math.round(nextState.endThumbTime*widthPerSecond-thumbNailBackground.offsetWidth)+'px 0px 0px 0px #ffffffe0';}this.effectsOutput=[];var minTransform={transform:'translate3d('+this.state['minCursorX']+'px,0,10px)'};var maxTransform={transform:'translate3d('+this.state['maxCursorX']+'px,0,10px)'};var minshadowWidth={width:this.state['minCursorX']+'px',transform:'translate3d(0,0,10px)'};var maxshadowWidth={width:nextState['totalWidth']-nextState['maxCursorX']-7+"px",transform:'translate3d('+(nextState['maxCursorX']+7)+'px,0,10px)'};var midShadow={width:nextState['maxCursorX']-nextState['minCursorX']-7+"px",transform:'translate3d('+(nextState['minCursorX']+7)+'px,0,10px)'};this.thumbs.length=0;if(nextState['minCursorX']!==this.state.minCursorX){minTransform={transform:'translate3d('+nextState['minCursorX']+'px,0,10px)'};minshadowWidth={width:nextState['minCursorX']+'px',transform:'translate3d(0,0,10px)'};midShadow={width:nextState['maxCursorX']-nextState['minCursorX']-7+"px",transform:'translate3d('+(nextState['minCursorX']+7)+'px,0,10px)'};}if(nextState['maxCursorX']!==this.state.maxCursorX){maxTransform={transform:'translate3d('+(nextState['maxCursorX']-1)+'px,0,10px)'};maxshadowWidth=nextState['maxCursorX']>=nextState.totalWidth?{width:0+"px",transform:'translate3d('+(nextState['maxCursorX']+7)+'px,0,10px)'}:{width:nextState['totalWidth']-nextState['maxCursorX']-7+"px",transform:'translate3d('+(nextState['maxCursorX']+7)+'px,0,10px)'};midShadow={width:nextState['maxCursorX']-nextState['minCursorX']-7+"px",transform:'translate3d('+(nextState['minCursorX']+7)+'px,0,10px)'};}this.thumbs.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'min-shadow',style:minshadowWidth},'  ',nextState.minisMoving?this.secToMin(Number(Math.round(nextState['minCursorValue']+"e1")+"e-1")):"",' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'min-thumb',style:minTransform,onMouseDown:function onMouseDown(e){_this5.handleMousedown(e,"min");}},' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'mid-shadow',style:midShadow,onMouseDown:function onMouseDown(e){_this5.handleMousedown(e,"range");}},' ',nextState.isPlaying?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'play-thumb',style:{left:nextState['playCursorX']+'px'}},' '):!(nextState.minisMoving||nextState.maxisMoving)?this.secToMin(Number(Math.round(nextState['maxCursorValue']-nextState['minCursorValue']+"e1")+"e-1")):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'max-thumb',style:maxTransform,onMouseDown:function onMouseDown(e){_this5.handleMousedown(e,"max");}},' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'max-shadow',style:maxshadowWidth},' ',nextState.maxisMoving?this.secToMin(Number(Math.round(nextState['maxCursorValue']+"e1")+"e-1")):"")));}},{key:'addEffects',value:function addEffects(){this.setState({effects:true});}},{key:'handleinputChange',value:function handleinputChange(e,type){try{var tempState={};this.sliderInputChange=true;var value=parseFloat(e.target.value);tempState[type]=value;if(type!=="intensity"){this.changeFilterValue(type,value);this.setState(tempState);}else{var hueValue=this.state.givenHue;this.handleSetFilters(this.state.editFilters,value,this.state.givenBright*value/50,this.state.givenContrast*value/50,hueValue*value/50,this.state.givenSaturate*value/50,this.state.tint,this.state.givenBlur*value/50,this.state.givenVignette*value/50);}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"BgVideoComponent-handleinputChange");}}},{key:'changeFilterValue',value:function changeFilterValue(type,value){value=parseFloat(value);var opacity=this.props.tintOpacity,selectedId="bgImg",selectedElem=document.getElementById("video-effects-block");var hueValue=this.state.hue;if(hueValue!==0){hueValue*=1.8;hueValue+=180;}if(!selectedElem)return;switch(type){case'bright':selectedElem.style.filter="brightness("+(value+100)+"%) contrast("+(this.state.contrast+100)+"%) hue-rotate("+hueValue+"deg) blur("+this.state.blur+"px) saturate("+(this.state.saturate+100)+"%)";break;case'contrast':selectedElem.style.filter="brightness("+(this.state.bright+100)+"%) contrast("+(value+100)+"%) hue-rotate("+hueValue+"deg) blur("+this.state.blur+"px) saturate("+(this.state.saturate+100)+"%)";break;case'hue':if(value!==0){value*=1.8;value+=180;}selectedElem.style.filter="brightness("+(this.state.bright+100)+"%) contrast("+(this.state.contrast+100)+"%) hue-rotate("+value+"deg) blur("+this.state.blur+"px) saturate("+(this.state.saturate+100)+"%)";break;case'saturate':selectedElem.style.filter="brightness("+(this.state.bright+100)+"%) contrast("+(this.state.contrast+100)+"%) hue-rotate("+hueValue+"deg) blur("+this.state.blur+"px) saturate("+(value+100)+"%)";break;case'tint':if(value!==-1)selectedElem.pseudoStyle(selectedElem,selectedId,"after","background","hsla("+value+","+(this.state.saturate+100)+"%,50%,"+opacity+")");else selectedElem.pseudoStyle(selectedElem,selectedId,"after","background","none");break;case'blur':selectedElem.style.filter="brightness("+(this.state.bright+100)+"%) contrast("+(this.state.contrast+100)+"%) hue-rotate("+hueValue+"deg) blur("+value+"px) saturate("+(this.state.saturate+100)+"%)";break;case'vignette':if(value>0)document.getElementById('video_filter-'+this.props.selectedScene).style.backgroundImage="radial-gradient(circle farthest-side at center center, rgba(0, 0, 0, 0) 70%, rgba(0, 0, 0, "+value*0.007+") 130%)";else document.getElementById('video_filter-'+this.props.selectedScene).style.backgroundImage="none";break;case'opacity':selectedElem.style.opacity=value/100;if(value<this.props.tintOpacity)opacity=value;if(this.state.tint!==-1)selectedElem.pseudoStyle(selectedElem,selectedId,"after","background","hsla("+this.state.tint+","+(this.state.saturate+100)+"%,50%,"+opacity+")");else selectedElem.pseudoStyle(selectedElem,selectedId,"after","background","none");break;default:break;}}},{key:'convertToHex',value:function convertToHex(d,type){var slice=-2,append="00";d=parseInt(d,10);if(type==='hue'||type==='tint')slice=-3;if(d===-1)append=" ";return(append+Number(d).toString(16)).slice(slice).toUpperCase();}},{key:'handleCancelClick',value:function handleCancelClick(){var position=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;try{if(position===3){this.setState({filterEffects:false});}if(position===2){this.setState({filterEffects:false,effects:false});}if(position===1){this.setState({filterEffects:false,effects:false});}if(position===''||position===null){this.setState({filterEffects:false,effects:false});}if(position==='cancel'){this.props.cancelPopup();}}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"BgVideoComponent-handleCancelClick");}}},{key:'handleSaveClick',value:function handleSaveClick(){}},{key:'handleplayheadClick',value:function handleplayheadClick(event){var _this6=this;try{if(this.state.playVideo)return;this.setState({activeCursorOffsetClient:event.clientX-this.state.indicatorPos},function(){window.addEventListener('mousemove',_this6.handleplayheadMove,false);});}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"BgVideoComponent-handleplayheadClick");}}},{key:'handleplayheadMove',value:function handleplayheadMove(event){try{this.playheadMove=true;var totalWidth=document.getElementById('duration-in-width-video').offsetWidth+this.defaultThumbPosition;var leftEnd=this.defaultThumbPosition,rightEnd=totalWidth;var timeScale=totalWidth/this.state.videoDuration,translateValue=event.clientX-this.state.activeCursorOffsetClient;if(translateValue<leftEnd)translateValue=leftEnd;if(translateValue>rightEnd)translateValue=rightEnd;var cursorValue=parseFloat((Math.ceil(translateValue/timeScale*20)/20).toFixed(2));translateValue=cursorValue*timeScale;document.getElementById('video-in-popup').currentTime=cursorValue;this.setState({indicatorPos:translateValue});}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_2__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"BgVideoComponent-handleplayheadMove");}}},{key:'render',value:function render(){var _this7=this;this.OutPutData=[];var configBasePath=this.props.workspaceBG.get('src');var onLoadPath=this.props.workspaceBG.get('thumbnail');var bgType=this.props.workspaceBG.get('type');if(bgType!=="UPVIDEO"&&bgType==="STOCKVID"){onLoadPath=__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a[bgType][__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a[bgType].onload]+this.props.workspaceBG.get('thumbnail');configBasePath=__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a[bgType][__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a[bgType].workspace]+this.props.workspaceBG.get('src');}else if(bgType==="UPVIDEO"){var typrToSet='UPLOADS';onLoadPath=__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a[typrToSet][__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a[typrToSet].onload_UPVIDEO]+this.props.workspaceBG.get('thumbnail');configBasePath=__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a[typrToSet][__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a[typrToSet].workspace_UPVIDEO]+this.props.workspaceBG.get('src');if(this.props.workspaceBG.get("isBlob")){onLoadPath=this.props.workspaceBG.get('thumbnail');configBasePath=this.props.workspaceBG.get('src');}}else if(bgType==='VIDEO'&&this.props.workspaceBG.get('subType')==='OBGVID'){onLoadPath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['BG']['obgsrc']+this.props.workspaceBG.get('thumbnail');configBasePath=this.assetUrl+__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['BG']['obgsrc']+this.props.workspaceBG.get('src');}else{this.handleCancel();}var Duration=this.secondsToHms(this.props.sceneDuration);var chnageImage='scene_play';if(this.state.playVideo)chnageImage='scene_stop';var displayBlock='grid';if(this.state.effects)displayBlock='none';var audioIcon='audio';if(this.state.muteValue||this.state.volume===0){audioIcon='mute';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loading-bar-popup',style:{display:this.loadedData?'none':'block'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{id:'loading-image-display',draggable:'false',src:this.appUrl+"/images/loaders/round-load.gif",alt:'Loading...'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-common-popup tool-bar',style:this.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'first-half',key:'bg-video-popup'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'first-half-top',style:this.getFlipPosition()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'video-effects-block',style:{width:"100%",margin:'0 auto',textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{id:'video-in-popup',preload:'auto',poster:onLoadPath,style:this.getWidthandHeight(this.props.bgVideoWidth,this.props.bgVideoHeight),src:configBasePath,type:'video/mp4'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'first-half-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'first-play-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'scene_play',src:this.appUrl+"/images/video_cutter/"+chnageImage+".svg",onClick:function onClick(){_this7.runVideo();}}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flex:'1 1'},className:'parentSecond-video-range'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'second-video-range'},this.thumbs)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'third-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'third-sound-button volume_holder',key:'volume-ui'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'bg-videoSlider'},'  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'bg-videoSlider-input',type:'range',value:this.state.volume,onChange:this.applyVolume,onMouseUp:this.saveVolume,style:{background:'linear-gradient(to right, #f3c340 0%, #f3c340 '+this.state.volume+'%, rgb(239, 242, 244) '+this.state.volume+'%, rgb(239, 242, 244,0.9) 100%)'},min:'0',step:'10',max:'100'}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'scene_play',src:this.appUrl+"/images/video_cutter/"+audioIcon+".svg",onClick:function onClick(event){_this7.enableMute(event);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'third-sound-button last_image tick-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'scene_play',src:this.appUrl+"/images/video_cutter/tick_mark.svg",onClick:function onClick(){_this7.applyVideoChanges();}}),' '))))));}}]);return BgVideoComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);BgVideoComponent.defaultProps={tintOpacity:0.1,initIntensity:50,initBright:100,initContrast:100,initHue:0,initSaturate:100,initTint:-1,initBlur:0,initvignette:0};/* harmony default export */ __webpack_exports__["a"] = (BgVideoComponent);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ConfirmPopupComponent__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_index__ = __webpack_require__(10);
var mapStateToProps=function mapStateToProps(state,ownProps){return{};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{dispatchAction:function dispatchAction(action){dispatch(action);},confirmPopup:function confirmPopup(data){dispatch({type:"CONFIRM_POPUP",data:data});}};};var ConfirmPopup=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ConfirmPopupComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ConfirmPopup);

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConfirmPopupComponent=function(_React$Component){_inherits(ConfirmPopupComponent,_React$Component);function ConfirmPopupComponent(props){_classCallCheck(this,ConfirmPopupComponent);var _this=_possibleConstructorReturn(this,(ConfirmPopupComponent.__proto__||Object.getPrototypeOf(ConfirmPopupComponent)).call(this,props));_this.timeOut1=null;_this.timeOut2=null;return _this;}_createClass(ConfirmPopupComponent,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.timeOut1=setTimeout(function(){_this2.confirmPopup.style.opacity=1;},350);this.timeOut2=setTimeout(function(){_this2.confirmContainer.style.transform="scale(1)";},400);}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.timeOut1);clearTimeout(this.timeOut2);}},{key:'render',value:function render(){var _this3=this;var mess=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'popup-msg'},this.props.details.get("message"));if(this.props.details.get("formatId")){mess=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'popup-msg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:this.props.details.get("message")}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(e){return _this3.confirmPopup=e;},className:"confirm-popup popup-overlay"+(this.props.details.get("position")?" "+this.props.details("position"):""),onMouseDown:function onMouseDown(e){_this3.props.confirmPopup({show:false});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirm-container',ref:function ref(e){return _this3.confirmContainer=e;},onMouseDown:function onMouseDown(e){e.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'popup-body'},mess,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'popup-btns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cancel-btn',onClick:function onClick(e){return _this3.props.dispatchAction(_this3.props.details.get("cancelAction").toJS());}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'ca.btn'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ok-btn',onClick:function onClick(e){return _this3.props.dispatchAction(_this3.props.details.get("okAction").toJS());}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'co.btn'}))))));}}]);return ConfirmPopupComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ConfirmPopupComponent);

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ToolTipComponent__ = __webpack_require__(439);
var mapStateToProps=function mapStateToProps(state,ownProps){return{};};var mapDispatchToProps={};var ToolTip=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ToolTipComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ToolTip);

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_tooltip_json__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_tooltip_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_tooltip_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//Over all tool tip component to access any where in over all the project 
var ToolTipComponent=function(_React$Component){_inherits(ToolTipComponent,_React$Component);function ToolTipComponent(props){_classCallCheck(this,ToolTipComponent);var _this=_possibleConstructorReturn(this,(ToolTipComponent.__proto__||Object.getPrototypeOf(ToolTipComponent)).call(this,props));_this.state={toolTipData:null};_this.styles={};_this.tooltipInformation='';_this.tooltipTitle='';_this.toolTipMouseOver=_this.toolTipMouseOver.bind(_this);return _this;}_createClass(ToolTipComponent,[{key:'toolTipMouseOver',value:function toolTipMouseOver(e){try{var tooldTipData='';if(e.target.getAttribute('data-tooltip')!==null&&e.target.getAttribute('data-tooltip')!==undefined&&e.target.getAttribute('data-tooltip')!==''){tooldTipData={xPosition:e.pageX+10,yPosition:e.pageY+10,data:e.target.getAttribute('data-tooltip'),show:true};}else{tooldTipData={show:false};}this.setState({toolTipData:tooldTipData});}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"ToolTipComponent-toolTipMouseOver");}}},{key:'componentWillMount',value:function componentWillMount(){window.addEventListener("mousemove",this.toolTipMouseOver,false);}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState){if(nextState.toolTipData.show){var toolTipdata=nextState.toolTipData.data.split("-"),componentData=void 0,leftPosition=void 0,topPosition=void 0,tooltipActualWidth=void 0;leftPosition=nextState.toolTipData.xPosition;topPosition=nextState.toolTipData.yPosition;if(toolTipdata[0]==="langId"){this.tooltipTitle='';this.tooltipInformation=toolTipdata[0]+'-'+toolTipdata[1];}else{var _componentData=__WEBPACK_IMPORTED_MODULE_1__config_tooltip_json___default.a[toolTipdata[0]][toolTipdata[1]];this.tooltipTitle=Object.keys(_componentData).includes('title')?_componentData.title:'';this.tooltipInformation=Object.keys(_componentData).includes('data')?_componentData.data:'';}this.styles={display:'block',left:leftPosition+'px',top:topPosition+'px'};}else{this.tooltipTitle='';this.tooltipInformation='';this.styles={display:'none'};}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app-tooltip',style:this.styles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tooltip-title',style:{display:this.tooltipTitle!==''?'block':'none'}},this.tooltipTitle),this.tooltipInformation.includes('langId')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tooltip-information'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:''+this.tooltipInformation.split('-')[1]})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tooltip-information'},this.tooltipInformation)));}}]);return ToolTipComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ToolTipComponent);

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports = {"HEADER":{"BELL":{"data":"Hello, welcome to new world","title":"Information","minWidth":true}},"ACTIONS":{"SMILING":{}},"EXPRESSIONS":{"NORMAL":{"data":"Smiling"},"SAD":{"data":"Sad"},"ANGRY":{"data":"Angry"},"HAPPY":{"data":"Happy"},"CONFUSED":{"data":"Un-impressed"},"EXCITED":{"data":"Star"},"FRUSTRATION":{"data":"Super-Angry"},"HYPNOTISM":{"data":"Confused"},"LOVE":{"data":"In-Love"},"SHOCKING":{"data":"Astonished"},"SLEEPY":{"data":"Sleepy"},"THOUGHTFUL":{"data":"Smug"},"BORED":{"data":"Poker face"},"EVIL":{"data":"Evil"},"TOUGH":{"data":"Goofy eyed"},"WORRIED":{"data":"Annoyed"},"DISAPPOINTED":{"data":"Tired"},"RELAXED":{"data":"Super-sad"},"FEAR":{"data":"Relieved"},"SURPRISE":{"data":"Shocked"},"CONFIDENT":{"data":"Confident"}}}

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_app_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Toast=function(_React$Component){_inherits(Toast,_React$Component);function Toast(props){_classCallCheck(this,Toast);var _this=_possibleConstructorReturn(this,(Toast.__proto__||Object.getPrototypeOf(Toast)).call(this,props));_this.state={};_this.closeToast=_this.closeToast.bind(_this);_this.appUrl=__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['APPICONS'][__WEBPACK_IMPORTED_MODULE_1__config_app_json___default.a['APPICONS']['current']];_this.timeout=props.data.get("timeout")!==undefined?props.data.get("timeout"):3000;_this.timer=null;_this.start=null;_this.handleMouseEnter=_this.handleMouseEnter.bind(_this);_this.handleMouseLeave=_this.handleMouseLeave.bind(_this);return _this;}_createClass(Toast,[{key:'componentDidMount',value:function componentDidMount(){setTimeout(function(){this.toastElement.classList.add("visible");}.bind(this),10);if(this.props.data.get("autoClose")===undefined||this.props.data.get("autoClose")===true){this.start=Date.now();this.timer=window.setTimeout(this.closeToast,this.timeout);}}},{key:'closeToast',value:function closeToast(){try{if(this.toastElement!==null)this.toastElement.classList.remove("visible");setTimeout(function(){this.props.manageToast({action:"delete",id:this.props.data.get("id")});}.bind(this),360);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"Toast-closeToast");}}},{key:'pauseTimout',value:function pauseTimout(){try{window.clearTimeout(this.timer);this.timeout-=Date.now()-this.start;}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"Toast-pauseTimout");}}},{key:'resumeTimout',value:function resumeTimout(){try{this.start=Date.now();window.clearTimeout(this.timer);this.timer=window.setTimeout(this.closeToast,this.timeout);}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"Toast-resumeTimout");}}},{key:'handleMouseEnter',value:function handleMouseEnter(e){try{if(this.props.data.get("autoClose")===undefined||this.props.data.get("autoClose")===true)this.pauseTimout();}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"Toast-handleMouseEnter");}}},{key:'handleMouseLeave',value:function handleMouseLeave(e){try{if(this.props.data.get("autoClose")===undefined||this.props.data.get("autoClose")===true)this.resumeTimout();}catch(error){//Error Severity: LOW
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"Toast-handleMouseLeave");}}},{key:'render',value:function render(){var _this2=this;var toastMsg=void 0;if(['both','msg'].indexOf(this.props.data.get('formatId'))===-1){toastMsg=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"toast-message"},this.props.data.get("message"));}else{if(this.props.data.get('lVal')){toastMsg=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"toast-message"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:this.props.data.get('message'),values:{'val':this.props.data.get('lVal')}}));}else{toastMsg=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"toast-message"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:this.props.data.get('message')}));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(instance){return _this2.toastElement=instance;},className:"toast-notification "+this.props.data.get("type"),onMouseEnter:this.handleMouseEnter,onMouseLeave:this.handleMouseLeave},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"toast-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.appUrl+"/images/share/"+this.props.data.get("type")+".svg"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"toast-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'toast-msg-container'},toastMsg,this.props.data.get("link")!==undefined&&this.props.data.get("linkName")!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"toast-link"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.props.data.get("link"),target:'_blank',alt:'Externel Link'},this.props.data.get("linkName"))):null,this.props.data.get("subMessage")!==undefined?['both','sub'].indexOf(this.props.data.get('formatId'))===-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"toast-sub-message"},this.props.data.get("subMessage")):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:this.props.data.get('subMessage'),children:function children(val){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"toast-sub-message"},val);}}):null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{onClick:this.closeToast,className:"close-toast",src:this.appUrl+"/images/share/close.svg"}));}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(props,state){var toReturn=null;return toReturn;}}]);return Toast;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Toast);

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var url = __webpack_require__(443);
var parser = __webpack_require__(108);
var Manager = __webpack_require__(204);
var debug = __webpack_require__(60)('socket.io-client');

/**
 * Module exports.
 */

module.exports = exports = lookup;

/**
 * Managers cache.
 */

var cache = exports.managers = {};

/**
 * Looks up an existing `Manager` for multiplexing.
 * If the user summons:
 *
 *   `io('http://localhost/a');`
 *   `io('http://localhost/b');`
 *
 * We reuse the existing instance based on same scheme/port/host,
 * and we initialize sockets for each namespace.
 *
 * @api public
 */

function lookup (uri, opts) {
  if (typeof uri === 'object') {
    opts = uri;
    uri = undefined;
  }

  opts = opts || {};

  var parsed = url(uri);
  var source = parsed.source;
  var id = parsed.id;
  var path = parsed.path;
  var sameNamespace = cache[id] && path in cache[id].nsps;
  var newConnection = opts.forceNew || opts['force new connection'] ||
                      false === opts.multiplex || sameNamespace;

  var io;

  if (newConnection) {
    debug('ignoring socket cache for %s', source);
    io = Manager(source, opts);
  } else {
    if (!cache[id]) {
      debug('new io instance for %s', source);
      cache[id] = Manager(source, opts);
    }
    io = cache[id];
  }
  if (parsed.query && !opts.query) {
    opts.query = parsed.query;
  } else if (opts && 'object' === typeof opts.query) {
    opts.query = encodeQueryString(opts.query);
  }
  return io.socket(parsed.path, opts);
}
/**
 *  Helper method to parse query objects to string.
 * @param {object} query
 * @returns {string}
 */
function encodeQueryString (obj) {
  var str = [];
  for (var p in obj) {
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  }
  return str.join('&');
}
/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = parser.protocol;

/**
 * `connect`.
 *
 * @param {String} uri
 * @api public
 */

exports.connect = lookup;

/**
 * Expose constructors for standalone build.
 *
 * @api public
 */

exports.Manager = __webpack_require__(204);
exports.Socket = __webpack_require__(209);


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module dependencies.
 */

var parseuri = __webpack_require__(202);
var debug = __webpack_require__(60)('socket.io-client:url');

/**
 * Module exports.
 */

module.exports = url;

/**
 * URL parser.
 *
 * @param {String} url
 * @param {Object} An object meant to mimic window.location.
 *                 Defaults to window.location.
 * @api public
 */

function url (uri, loc) {
  var obj = uri;

  // default to window.location
  loc = loc || global.location;
  if (null == uri) uri = loc.protocol + '//' + loc.host;

  // relative path support
  if ('string' === typeof uri) {
    if ('/' === uri.charAt(0)) {
      if ('/' === uri.charAt(1)) {
        uri = loc.protocol + uri;
      } else {
        uri = loc.host + uri;
      }
    }

    if (!/^(https?|wss?):\/\//.test(uri)) {
      debug('protocol-less url %s', uri);
      if ('undefined' !== typeof loc) {
        uri = loc.protocol + '//' + uri;
      } else {
        uri = 'https://' + uri;
      }
    }

    // parse
    debug('parse %s', uri);
    obj = parseuri(uri);
  }

  // make sure we treat `localhost:80` and `localhost` equally
  if (!obj.port) {
    if (/^(http|ws)$/.test(obj.protocol)) {
      obj.port = '80';
    } else if (/^(http|ws)s$/.test(obj.protocol)) {
      obj.port = '443';
    }
  }

  obj.path = obj.path || '/';

  var ipv6 = obj.host.indexOf(':') !== -1;
  var host = ipv6 ? '[' + obj.host + ']' : obj.host;

  // define unique id
  obj.id = obj.protocol + '://' + host + ':' + obj.port;
  // define href
  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));

  return obj;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = debug.debug = debug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(445);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lowercased letter, i.e. "n".
 */

exports.formatters = {};

/**
 * Previously assigned color.
 */

var prevColor = 0;

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 *
 * @return {Number}
 * @api private
 */

function selectColor() {
  return exports.colors[prevColor++ % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function debug(namespace) {

  // define the `disabled` version
  function disabled() {
  }
  disabled.enabled = false;

  // define the `enabled` version
  function enabled() {

    var self = enabled;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // add the `color` if not set
    if (null == self.useColors) self.useColors = exports.useColors();
    if (null == self.color && self.useColors) self.color = selectColor();

    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %o
      args = ['%o'].concat(args);
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting
    args = exports.formatArgs.apply(self, args);

    var logFn = enabled.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }
  enabled.enabled = true;

  var fn = exports.enabled(namespace) ? enabled : disabled;

  fn.namespace = namespace;

  return fn;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  var split = (namespaces || '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/[\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 445 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000
var m = s * 60
var h = m * 60
var d = h * 24
var y = d * 365.25

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} options
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {}
  var type = typeof val
  if (type === 'string' && val.length > 0) {
    return parse(val)
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ?
			fmtLong(val) :
			fmtShort(val)
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
}

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str)
  if (str.length > 10000) {
    return
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
  if (!match) {
    return
  }
  var n = parseFloat(match[1])
  var type = (match[2] || 'ms').toLowerCase()
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y
    case 'days':
    case 'day':
    case 'd':
      return n * d
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n
    default:
      return undefined
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd'
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h'
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm'
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's'
  }
  return ms + 'ms'
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms'
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name
  }
  return Math.ceil(ms / n) + ' ' + name + 's'
}


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(447);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // is webkit? http://stackoverflow.com/a/16459606/376773
  return ('WebkitAppearance' in document.documentElement.style) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (window.console && (console.firebug || (console.exception && console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  return JSON.stringify(v);
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs() {
  var args = arguments;
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return args;

  var c = 'color: ' + this.color;
  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
  return args;
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}
  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage(){
  try {
    return window.localStorage;
  } catch (e) {}
}


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = debug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(448);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lowercased letter, i.e. "n".
 */

exports.formatters = {};

/**
 * Previously assigned color.
 */

var prevColor = 0;

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 *
 * @return {Number}
 * @api private
 */

function selectColor() {
  return exports.colors[prevColor++ % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function debug(namespace) {

  // define the `disabled` version
  function disabled() {
  }
  disabled.enabled = false;

  // define the `enabled` version
  function enabled() {

    var self = enabled;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // add the `color` if not set
    if (null == self.useColors) self.useColors = exports.useColors();
    if (null == self.color && self.useColors) self.color = selectColor();

    var args = Array.prototype.slice.call(arguments);

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %o
      args = ['%o'].concat(args);
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    if ('function' === typeof exports.formatArgs) {
      args = exports.formatArgs.apply(self, args);
    }
    var logFn = enabled.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }
  enabled.enabled = true;

  var fn = exports.enabled(namespace) ? enabled : disabled;

  fn.namespace = namespace;

  return fn;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  var split = (namespaces || '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 448 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} options
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options){
  options = options || {};
  if ('string' == typeof val) return parse(val);
  return options.long
    ? long(val)
    : short(val);
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = '' + str;
  if (str.length > 10000) return;
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
  if (!match) return;
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function short(ms) {
  if (ms >= d) return Math.round(ms / d) + 'd';
  if (ms >= h) return Math.round(ms / h) + 'h';
  if (ms >= m) return Math.round(ms / m) + 'm';
  if (ms >= s) return Math.round(ms / s) + 's';
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function long(ms) {
  return plural(ms, d, 'day')
    || plural(ms, h, 'hour')
    || plural(ms, m, 'minute')
    || plural(ms, s, 'second')
    || ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) return;
  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */
;(function () {
  // Detect the `define` function exposed by asynchronous module loaders. The
  // strict `define` check is necessary for compatibility with `r.js`.
  var isLoader = "function" === "function" && __webpack_require__(450);

  // A set of types used to distinguish objects from primitives.
  var objectTypes = {
    "function": true,
    "object": true
  };

  // Detect the `exports` object exposed by CommonJS implementations.
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  // Use the `global` object exposed by Node (including Browserify via
  // `insert-module-globals`), Narwhal, and Ringo as the default context,
  // and the `window` object in browsers. Rhino exports a `global` function
  // instead.
  var root = objectTypes[typeof window] && window || this,
      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == "object" && global;

  if (freeGlobal && (freeGlobal["global"] === freeGlobal || freeGlobal["window"] === freeGlobal || freeGlobal["self"] === freeGlobal)) {
    root = freeGlobal;
  }

  // Public: Initializes JSON 3 using the given `context` object, attaching the
  // `stringify` and `parse` functions to the specified `exports` object.
  function runInContext(context, exports) {
    context || (context = root["Object"]());
    exports || (exports = root["Object"]());

    // Native constructor aliases.
    var Number = context["Number"] || root["Number"],
        String = context["String"] || root["String"],
        Object = context["Object"] || root["Object"],
        Date = context["Date"] || root["Date"],
        SyntaxError = context["SyntaxError"] || root["SyntaxError"],
        TypeError = context["TypeError"] || root["TypeError"],
        Math = context["Math"] || root["Math"],
        nativeJSON = context["JSON"] || root["JSON"];

    // Delegate to the native `stringify` and `parse` implementations.
    if (typeof nativeJSON == "object" && nativeJSON) {
      exports.stringify = nativeJSON.stringify;
      exports.parse = nativeJSON.parse;
    }

    // Convenience aliases.
    var objectProto = Object.prototype,
        getClass = objectProto.toString,
        isProperty, forEach, undef;

    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.
    var isExtended = new Date(-3509827334573292);
    try {
      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
      // results for certain dates in Opera >= 10.53.
      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&
        // Safari < 2.0.2 stores the internal millisecond time value correctly,
        // but clips the values returned by the date methods to the range of
        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).
        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
    } catch (exception) {}

    // Internal: Determines whether the native `JSON.stringify` and `parse`
    // implementations are spec-compliant. Based on work by Ken Snyder.
    function has(name) {
      if (has[name] !== undef) {
        // Return cached feature test result.
        return has[name];
      }
      var isSupported;
      if (name == "bug-string-char-index") {
        // IE <= 7 doesn't support accessing string characters using square
        // bracket notation. IE 8 only supports this for primitives.
        isSupported = "a"[0] != "a";
      } else if (name == "json") {
        // Indicates whether both `JSON.stringify` and `JSON.parse` are
        // supported.
        isSupported = has("json-stringify") && has("json-parse");
      } else {
        var value, serialized = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
        // Test `JSON.stringify`.
        if (name == "json-stringify") {
          var stringify = exports.stringify, stringifySupported = typeof stringify == "function" && isExtended;
          if (stringifySupported) {
            // A test function object with a custom `toJSON` method.
            (value = function () {
              return 1;
            }).toJSON = value;
            try {
              stringifySupported =
                // Firefox 3.1b1 and b2 serialize string, number, and boolean
                // primitives as object literals.
                stringify(0) === "0" &&
                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
                // literals.
                stringify(new Number()) === "0" &&
                stringify(new String()) == '""' &&
                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
                // does not define a canonical JSON representation (this applies to
                // objects with `toJSON` properties as well, *unless* they are nested
                // within an object or array).
                stringify(getClass) === undef &&
                // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
                // FF 3.1b3 pass this test.
                stringify(undef) === undef &&
                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
                // respectively, if the value is omitted entirely.
                stringify() === undef &&
                // FF 3.1b1, 2 throw an error if the given value is not a number,
                // string, array, object, Boolean, or `null` literal. This applies to
                // objects with custom `toJSON` methods as well, unless they are nested
                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
                // methods entirely.
                stringify(value) === "1" &&
                stringify([value]) == "[1]" &&
                // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
                // `"[null]"`.
                stringify([undef]) == "[null]" &&
                // YUI 3.0.0b1 fails to serialize `null` literals.
                stringify(null) == "null" &&
                // FF 3.1b1, 2 halts serialization if an array contains a function:
                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
                // elides non-JSON values from objects and arrays, unless they
                // define custom `toJSON` methods.
                stringify([undef, getClass, null]) == "[null,null,null]" &&
                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
                // where character escape codes are expected (e.g., `\b` => `\u0008`).
                stringify({ "a": [value, true, false, null, "\x00\b\n\f\r\t"] }) == serialized &&
                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
                stringify(null, value) === "1" &&
                stringify([1, 2], null, 1) == "[\n 1,\n 2\n]" &&
                // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
                // serialize extended years.
                stringify(new Date(-8.64e15)) == '"-271821-04-20T00:00:00.000Z"' &&
                // The milliseconds are optional in ES 5, but required in 5.1.
                stringify(new Date(8.64e15)) == '"+275760-09-13T00:00:00.000Z"' &&
                // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
                // four-digit years instead of six-digit years. Credits: @Yaffle.
                stringify(new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' &&
                // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
                // values less than 1000. Credits: @Yaffle.
                stringify(new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
            } catch (exception) {
              stringifySupported = false;
            }
          }
          isSupported = stringifySupported;
        }
        // Test `JSON.parse`.
        if (name == "json-parse") {
          var parse = exports.parse;
          if (typeof parse == "function") {
            try {
              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
              // Conforming implementations should also coerce the initial argument to
              // a string prior to parsing.
              if (parse("0") === 0 && !parse(false)) {
                // Simple parsing test.
                value = parse(serialized);
                var parseSupported = value["a"].length == 5 && value["a"][0] === 1;
                if (parseSupported) {
                  try {
                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
                    parseSupported = !parse('"\t"');
                  } catch (exception) {}
                  if (parseSupported) {
                    try {
                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading
                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
                      // certain octal literals.
                      parseSupported = parse("01") !== 1;
                    } catch (exception) {}
                  }
                  if (parseSupported) {
                    try {
                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
                      // points. These environments, along with FF 3.1b1 and 2,
                      // also allow trailing commas in JSON objects and arrays.
                      parseSupported = parse("1.") !== 1;
                    } catch (exception) {}
                  }
                }
              }
            } catch (exception) {
              parseSupported = false;
            }
          }
          isSupported = parseSupported;
        }
      }
      return has[name] = !!isSupported;
    }

    if (!has("json")) {
      // Common `[[Class]]` name aliases.
      var functionClass = "[object Function]",
          dateClass = "[object Date]",
          numberClass = "[object Number]",
          stringClass = "[object String]",
          arrayClass = "[object Array]",
          booleanClass = "[object Boolean]";

      // Detect incomplete support for accessing string characters by index.
      var charIndexBuggy = has("bug-string-char-index");

      // Define additional utility methods if the `Date` methods are buggy.
      if (!isExtended) {
        var floor = Math.floor;
        // A mapping between the months of the year and the number of days between
        // January 1st and the first of the respective month.
        var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
        // Internal: Calculates the number of days between the Unix epoch and the
        // first day of the given month.
        var getDay = function (year, month) {
          return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
        };
      }

      // Internal: Determines if a property is a direct property of the given
      // object. Delegates to the native `Object#hasOwnProperty` method.
      if (!(isProperty = objectProto.hasOwnProperty)) {
        isProperty = function (property) {
          var members = {}, constructor;
          if ((members.__proto__ = null, members.__proto__ = {
            // The *proto* property cannot be set multiple times in recent
            // versions of Firefox and SeaMonkey.
            "toString": 1
          }, members).toString != getClass) {
            // Safari <= 2.0.3 doesn't implement `Object#hasOwnProperty`, but
            // supports the mutable *proto* property.
            isProperty = function (property) {
              // Capture and break the object's prototype chain (see section 8.6.2
              // of the ES 5.1 spec). The parenthesized expression prevents an
              // unsafe transformation by the Closure Compiler.
              var original = this.__proto__, result = property in (this.__proto__ = null, this);
              // Restore the original prototype chain.
              this.__proto__ = original;
              return result;
            };
          } else {
            // Capture a reference to the top-level `Object` constructor.
            constructor = members.constructor;
            // Use the `constructor` property to simulate `Object#hasOwnProperty` in
            // other environments.
            isProperty = function (property) {
              var parent = (this.constructor || constructor).prototype;
              return property in this && !(property in parent && this[property] === parent[property]);
            };
          }
          members = null;
          return isProperty.call(this, property);
        };
      }

      // Internal: Normalizes the `for...in` iteration algorithm across
      // environments. Each enumerated key is yielded to a `callback` function.
      forEach = function (object, callback) {
        var size = 0, Properties, members, property;

        // Tests for bugs in the current environment's `for...in` algorithm. The
        // `valueOf` property inherits the non-enumerable flag from
        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.
        (Properties = function () {
          this.valueOf = 0;
        }).prototype.valueOf = 0;

        // Iterate over a new instance of the `Properties` class.
        members = new Properties();
        for (property in members) {
          // Ignore all properties inherited from `Object.prototype`.
          if (isProperty.call(members, property)) {
            size++;
          }
        }
        Properties = members = null;

        // Normalize the iteration algorithm.
        if (!size) {
          // A list of non-enumerable properties inherited from `Object.prototype`.
          members = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
          // properties.
          forEach = function (object, callback) {
            var isFunction = getClass.call(object) == functionClass, property, length;
            var hasProperty = !isFunction && typeof object.constructor != "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;
            for (property in object) {
              // Gecko <= 1.0 enumerates the `prototype` property of functions under
              // certain conditions; IE does not.
              if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
                callback(property);
              }
            }
            // Manually invoke the callback for each non-enumerable property.
            for (length = members.length; property = members[--length]; hasProperty.call(object, property) && callback(property));
          };
        } else if (size == 2) {
          // Safari <= 2.0.4 enumerates shadowed properties twice.
          forEach = function (object, callback) {
            // Create a set of iterated properties.
            var members = {}, isFunction = getClass.call(object) == functionClass, property;
            for (property in object) {
              // Store each property name to prevent double enumeration. The
              // `prototype` property of functions is not enumerated due to cross-
              // environment inconsistencies.
              if (!(isFunction && property == "prototype") && !isProperty.call(members, property) && (members[property] = 1) && isProperty.call(object, property)) {
                callback(property);
              }
            }
          };
        } else {
          // No bugs detected; use the standard `for...in` algorithm.
          forEach = function (object, callback) {
            var isFunction = getClass.call(object) == functionClass, property, isConstructor;
            for (property in object) {
              if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
                callback(property);
              }
            }
            // Manually invoke the callback for the `constructor` property due to
            // cross-environment inconsistencies.
            if (isConstructor || isProperty.call(object, (property = "constructor"))) {
              callback(property);
            }
          };
        }
        return forEach(object, callback);
      };

      // Public: Serializes a JavaScript `value` as a JSON string. The optional
      // `filter` argument may specify either a function that alters how object and
      // array members are serialized, or an array of strings and numbers that
      // indicates which properties should be serialized. The optional `width`
      // argument may be either a string or number that specifies the indentation
      // level of the output.
      if (!has("json-stringify")) {
        // Internal: A map of control characters and their escaped equivalents.
        var Escapes = {
          92: "\\\\",
          34: '\\"',
          8: "\\b",
          12: "\\f",
          10: "\\n",
          13: "\\r",
          9: "\\t"
        };

        // Internal: Converts `value` into a zero-padded string such that its
        // length is at least equal to `width`. The `width` must be <= 6.
        var leadingZeroes = "000000";
        var toPaddedString = function (width, value) {
          // The `|| 0` expression is necessary to work around a bug in
          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
          return (leadingZeroes + (value || 0)).slice(-width);
        };

        // Internal: Double-quotes a string `value`, replacing all ASCII control
        // characters (characters with code unit values between 0 and 31) with
        // their escaped equivalents. This is an implementation of the
        // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
        var unicodePrefix = "\\u00";
        var quote = function (value) {
          var result = '"', index = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;
          var symbols = useCharIndex && (charIndexBuggy ? value.split("") : value);
          for (; index < length; index++) {
            var charCode = value.charCodeAt(index);
            // If the character is a control character, append its Unicode or
            // shorthand escape sequence; otherwise, append the character as-is.
            switch (charCode) {
              case 8: case 9: case 10: case 12: case 13: case 34: case 92:
                result += Escapes[charCode];
                break;
              default:
                if (charCode < 32) {
                  result += unicodePrefix + toPaddedString(2, charCode.toString(16));
                  break;
                }
                result += useCharIndex ? symbols[index] : value.charAt(index);
            }
          }
          return result + '"';
        };

        // Internal: Recursively serializes an object. Implements the
        // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.
        var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {
          var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index, length, prefix, result;
          try {
            // Necessary for host object support.
            value = object[property];
          } catch (exception) {}
          if (typeof value == "object" && value) {
            className = getClass.call(value);
            if (className == dateClass && !isProperty.call(value, "toJSON")) {
              if (value > -1 / 0 && value < 1 / 0) {
                // Dates are serialized according to the `Date#toJSON` method
                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
                // for the ISO 8601 date time string format.
                if (getDay) {
                  // Manually compute the year, month, date, hours, minutes,
                  // seconds, and milliseconds if the `getUTC*` methods are
                  // buggy. Adapted from @Yaffle's `date-shim` project.
                  date = floor(value / 864e5);
                  for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);
                  for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);
                  date = 1 + date - getDay(year, month);
                  // The `time` value specifies the time within the day (see ES
                  // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
                  // to compute `A modulo B`, as the `%` operator does not
                  // correspond to the `modulo` operation for negative numbers.
                  time = (value % 864e5 + 864e5) % 864e5;
                  // The hours, minutes, seconds, and milliseconds are obtained by
                  // decomposing the time within the day. See section 15.9.1.10.
                  hours = floor(time / 36e5) % 24;
                  minutes = floor(time / 6e4) % 60;
                  seconds = floor(time / 1e3) % 60;
                  milliseconds = time % 1e3;
                } else {
                  year = value.getUTCFullYear();
                  month = value.getUTCMonth();
                  date = value.getUTCDate();
                  hours = value.getUTCHours();
                  minutes = value.getUTCMinutes();
                  seconds = value.getUTCSeconds();
                  milliseconds = value.getUTCMilliseconds();
                }
                // Serialize extended years correctly.
                value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +
                  "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) +
                  // Months, dates, hours, minutes, and seconds should have two
                  // digits; milliseconds should have three.
                  "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) +
                  // Milliseconds are optional in ES 5.0, but required in 5.1.
                  "." + toPaddedString(3, milliseconds) + "Z";
              } else {
                value = null;
              }
            } else if (typeof value.toJSON == "function" && ((className != numberClass && className != stringClass && className != arrayClass) || isProperty.call(value, "toJSON"))) {
              // Prototype <= 1.6.1 adds non-standard `toJSON` methods to the
              // `Number`, `String`, `Date`, and `Array` prototypes. JSON 3
              // ignores all `toJSON` methods on these objects unless they are
              // defined directly on an instance.
              value = value.toJSON(property);
            }
          }
          if (callback) {
            // If a replacement function was provided, call it to obtain the value
            // for serialization.
            value = callback.call(object, property, value);
          }
          if (value === null) {
            return "null";
          }
          className = getClass.call(value);
          if (className == booleanClass) {
            // Booleans are represented literally.
            return "" + value;
          } else if (className == numberClass) {
            // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
            // `"null"`.
            return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
          } else if (className == stringClass) {
            // Strings are double-quoted and escaped.
            return quote("" + value);
          }
          // Recursively serialize objects and arrays.
          if (typeof value == "object") {
            // Check for cyclic structures. This is a linear search; performance
            // is inversely proportional to the number of unique nested objects.
            for (length = stack.length; length--;) {
              if (stack[length] === value) {
                // Cyclic structures cannot be serialized by `JSON.stringify`.
                throw TypeError();
              }
            }
            // Add the object to the stack of traversed objects.
            stack.push(value);
            results = [];
            // Save the current indentation level and indent one additional level.
            prefix = indentation;
            indentation += whitespace;
            if (className == arrayClass) {
              // Recursively serialize array elements.
              for (index = 0, length = value.length; index < length; index++) {
                element = serialize(index, value, callback, properties, whitespace, indentation, stack);
                results.push(element === undef ? "null" : element);
              }
              result = results.length ? (whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : ("[" + results.join(",") + "]")) : "[]";
            } else {
              // Recursively serialize object members. Members are selected from
              // either a user-specified list of property names, or the object
              // itself.
              forEach(properties || value, function (property) {
                var element = serialize(property, value, callback, properties, whitespace, indentation, stack);
                if (element !== undef) {
                  // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
                  // is not the empty string, let `member` {quote(property) + ":"}
                  // be the concatenation of `member` and the `space` character."
                  // The "`space` character" refers to the literal space
                  // character, not the `space` {width} argument provided to
                  // `JSON.stringify`.
                  results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
                }
              });
              result = results.length ? (whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : ("{" + results.join(",") + "}")) : "{}";
            }
            // Remove the object from the traversed object stack.
            stack.pop();
            return result;
          }
        };

        // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
        exports.stringify = function (source, filter, width) {
          var whitespace, callback, properties, className;
          if (objectTypes[typeof filter] && filter) {
            if ((className = getClass.call(filter)) == functionClass) {
              callback = filter;
            } else if (className == arrayClass) {
              // Convert the property names array into a makeshift set.
              properties = {};
              for (var index = 0, length = filter.length, value; index < length; value = filter[index++], ((className = getClass.call(value)), className == stringClass || className == numberClass) && (properties[value] = 1));
            }
          }
          if (width) {
            if ((className = getClass.call(width)) == numberClass) {
              // Convert the `width` to an integer and create a string containing
              // `width` number of space characters.
              if ((width -= width % 1) > 0) {
                for (whitespace = "", width > 10 && (width = 10); whitespace.length < width; whitespace += " ");
              }
            } else if (className == stringClass) {
              whitespace = width.length <= 10 ? width : width.slice(0, 10);
            }
          }
          // Opera <= 7.54u2 discards the values associated with empty string keys
          // (`""`) only if they are used directly within an object member list
          // (e.g., `!("" in { "": 1})`).
          return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
        };
      }

      // Public: Parses a JSON source string.
      if (!has("json-parse")) {
        var fromCharCode = String.fromCharCode;

        // Internal: A map of escaped control characters and their unescaped
        // equivalents.
        var Unescapes = {
          92: "\\",
          34: '"',
          47: "/",
          98: "\b",
          116: "\t",
          110: "\n",
          102: "\f",
          114: "\r"
        };

        // Internal: Stores the parser state.
        var Index, Source;

        // Internal: Resets the parser state and throws a `SyntaxError`.
        var abort = function () {
          Index = Source = null;
          throw SyntaxError();
        };

        // Internal: Returns the next token, or `"$"` if the parser has reached
        // the end of the source string. A token may be a string, number, `null`
        // literal, or Boolean literal.
        var lex = function () {
          var source = Source, length = source.length, value, begin, position, isSigned, charCode;
          while (Index < length) {
            charCode = source.charCodeAt(Index);
            switch (charCode) {
              case 9: case 10: case 13: case 32:
                // Skip whitespace tokens, including tabs, carriage returns, line
                // feeds, and space characters.
                Index++;
                break;
              case 123: case 125: case 91: case 93: case 58: case 44:
                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
                // the current position.
                value = charIndexBuggy ? source.charAt(Index) : source[Index];
                Index++;
                return value;
              case 34:
                // `"` delimits a JSON string; advance to the next character and
                // begin parsing the string. String tokens are prefixed with the
                // sentinel `@` character to distinguish them from punctuators and
                // end-of-string tokens.
                for (value = "@", Index++; Index < length;) {
                  charCode = source.charCodeAt(Index);
                  if (charCode < 32) {
                    // Unescaped ASCII control characters (those with a code unit
                    // less than the space character) are not permitted.
                    abort();
                  } else if (charCode == 92) {
                    // A reverse solidus (`\`) marks the beginning of an escaped
                    // control character (including `"`, `\`, and `/`) or Unicode
                    // escape sequence.
                    charCode = source.charCodeAt(++Index);
                    switch (charCode) {
                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:
                        // Revive escaped control characters.
                        value += Unescapes[charCode];
                        Index++;
                        break;
                      case 117:
                        // `\u` marks the beginning of a Unicode escape sequence.
                        // Advance to the first character and validate the
                        // four-digit code point.
                        begin = ++Index;
                        for (position = Index + 4; Index < position; Index++) {
                          charCode = source.charCodeAt(Index);
                          // A valid sequence comprises four hexdigits (case-
                          // insensitive) that form a single hexadecimal value.
                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
                            // Invalid Unicode escape sequence.
                            abort();
                          }
                        }
                        // Revive the escaped character.
                        value += fromCharCode("0x" + source.slice(begin, Index));
                        break;
                      default:
                        // Invalid escape sequence.
                        abort();
                    }
                  } else {
                    if (charCode == 34) {
                      // An unescaped double-quote character marks the end of the
                      // string.
                      break;
                    }
                    charCode = source.charCodeAt(Index);
                    begin = Index;
                    // Optimize for the common case where a string is valid.
                    while (charCode >= 32 && charCode != 92 && charCode != 34) {
                      charCode = source.charCodeAt(++Index);
                    }
                    // Append the string as-is.
                    value += source.slice(begin, Index);
                  }
                }
                if (source.charCodeAt(Index) == 34) {
                  // Advance to the next character and return the revived string.
                  Index++;
                  return value;
                }
                // Unterminated string.
                abort();
              default:
                // Parse numbers and literals.
                begin = Index;
                // Advance past the negative sign, if one is specified.
                if (charCode == 45) {
                  isSigned = true;
                  charCode = source.charCodeAt(++Index);
                }
                // Parse an integer or floating-point value.
                if (charCode >= 48 && charCode <= 57) {
                  // Leading zeroes are interpreted as octal literals.
                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {
                    // Illegal octal literal.
                    abort();
                  }
                  isSigned = false;
                  // Parse the integer component.
                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);
                  // Floats cannot contain a leading decimal point; however, this
                  // case is already accounted for by the parser.
                  if (source.charCodeAt(Index) == 46) {
                    position = ++Index;
                    // Parse the decimal component.
                    for (; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
                    if (position == Index) {
                      // Illegal trailing decimal.
                      abort();
                    }
                    Index = position;
                  }
                  // Parse exponents. The `e` denoting the exponent is
                  // case-insensitive.
                  charCode = source.charCodeAt(Index);
                  if (charCode == 101 || charCode == 69) {
                    charCode = source.charCodeAt(++Index);
                    // Skip past the sign following the exponent, if one is
                    // specified.
                    if (charCode == 43 || charCode == 45) {
                      Index++;
                    }
                    // Parse the exponential component.
                    for (position = Index; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
                    if (position == Index) {
                      // Illegal empty exponent.
                      abort();
                    }
                    Index = position;
                  }
                  // Coerce the parsed value to a JavaScript number.
                  return +source.slice(begin, Index);
                }
                // A negative sign may only precede numbers.
                if (isSigned) {
                  abort();
                }
                // `true`, `false`, and `null` literals.
                if (source.slice(Index, Index + 4) == "true") {
                  Index += 4;
                  return true;
                } else if (source.slice(Index, Index + 5) == "false") {
                  Index += 5;
                  return false;
                } else if (source.slice(Index, Index + 4) == "null") {
                  Index += 4;
                  return null;
                }
                // Unrecognized token.
                abort();
            }
          }
          // Return the sentinel `$` character if the parser has reached the end
          // of the source string.
          return "$";
        };

        // Internal: Parses a JSON `value` token.
        var get = function (value) {
          var results, hasMembers;
          if (value == "$") {
            // Unexpected end of input.
            abort();
          }
          if (typeof value == "string") {
            if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
              // Remove the sentinel `@` character.
              return value.slice(1);
            }
            // Parse object and array literals.
            if (value == "[") {
              // Parses a JSON array, returning a new JavaScript array.
              results = [];
              for (;; hasMembers || (hasMembers = true)) {
                value = lex();
                // A closing square bracket marks the end of the array literal.
                if (value == "]") {
                  break;
                }
                // If the array literal contains elements, the current token
                // should be a comma separating the previous element from the
                // next.
                if (hasMembers) {
                  if (value == ",") {
                    value = lex();
                    if (value == "]") {
                      // Unexpected trailing `,` in array literal.
                      abort();
                    }
                  } else {
                    // A `,` must separate each array element.
                    abort();
                  }
                }
                // Elisions and leading commas are not permitted.
                if (value == ",") {
                  abort();
                }
                results.push(get(value));
              }
              return results;
            } else if (value == "{") {
              // Parses a JSON object, returning a new JavaScript object.
              results = {};
              for (;; hasMembers || (hasMembers = true)) {
                value = lex();
                // A closing curly brace marks the end of the object literal.
                if (value == "}") {
                  break;
                }
                // If the object literal contains members, the current token
                // should be a comma separator.
                if (hasMembers) {
                  if (value == ",") {
                    value = lex();
                    if (value == "}") {
                      // Unexpected trailing `,` in object literal.
                      abort();
                    }
                  } else {
                    // A `,` must separate each object member.
                    abort();
                  }
                }
                // Leading commas are not permitted, object property names must be
                // double-quoted strings, and a `:` must separate each property
                // name and value.
                if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
                  abort();
                }
                results[value.slice(1)] = get(lex());
              }
              return results;
            }
            // Unexpected token encountered.
            abort();
          }
          return value;
        };

        // Internal: Updates a traversed object member.
        var update = function (source, property, callback) {
          var element = walk(source, property, callback);
          if (element === undef) {
            delete source[property];
          } else {
            source[property] = element;
          }
        };

        // Internal: Recursively traverses a parsed JSON object, invoking the
        // `callback` function for each value. This is an implementation of the
        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.
        var walk = function (source, property, callback) {
          var value = source[property], length;
          if (typeof value == "object" && value) {
            // `forEach` can't be used to traverse an array in Opera <= 8.54
            // because its `Object#hasOwnProperty` implementation returns `false`
            // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
            if (getClass.call(value) == arrayClass) {
              for (length = value.length; length--;) {
                update(value, length, callback);
              }
            } else {
              forEach(value, function (property) {
                update(value, property, callback);
              });
            }
          }
          return callback.call(source, property, value);
        };

        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.
        exports.parse = function (source, callback) {
          var result, value;
          Index = 0;
          Source = "" + source;
          result = get(lex());
          // If a JSON string contains multiple tokens, it is invalid.
          if (lex() != "$") {
            abort();
          }
          // Reset the parser state.
          Index = Source = null;
          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
        };
      }
    }

    exports["runInContext"] = runInContext;
    return exports;
  }

  if (freeExports && !isLoader) {
    // Export for CommonJS environments.
    runInContext(root, freeExports);
  } else {
    // Export for web browsers and JavaScript engines.
    var nativeJSON = root.JSON,
        previousJSON = root["JSON3"],
        isRestored = false;

    var JSON3 = runInContext(root, (root["JSON3"] = {
      // Public: Restores the original value of the global `JSON` object and
      // returns a reference to the `JSON3` object.
      "noConflict": function () {
        if (!isRestored) {
          isRestored = true;
          root.JSON = nativeJSON;
          root["JSON3"] = previousJSON;
          nativeJSON = previousJSON = null;
        }
        return JSON3;
      }
    }));

    root.JSON = {
      "parse": JSON3.parse,
      "stringify": JSON3.stringify
    };
  }

  // Export for asynchronous module loaders.
  if (isLoader) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return JSON3;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)(module), __webpack_require__(1)))

/***/ }),
/* 450 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 451 */
/***/ (function(module, exports) {


/**
 * Expose `Emitter`.
 */

module.exports = Emitter;

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks[event] = this._callbacks[event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  var self = this;
  this._callbacks = this._callbacks || {};

  function on() {
    self.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks[event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks[event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks[event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks[event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*global Blob,File*/

/**
 * Module requirements
 */

var isArray = __webpack_require__(453);
var isBuf = __webpack_require__(203);

/**
 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
 * Anything with blobs or files should be fed through removeBlobs before coming
 * here.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @api public
 */

exports.deconstructPacket = function(packet){
  var buffers = [];
  var packetData = packet.data;

  function _deconstructPacket(data) {
    if (!data) return data;

    if (isBuf(data)) {
      var placeholder = { _placeholder: true, num: buffers.length };
      buffers.push(data);
      return placeholder;
    } else if (isArray(data)) {
      var newData = new Array(data.length);
      for (var i = 0; i < data.length; i++) {
        newData[i] = _deconstructPacket(data[i]);
      }
      return newData;
    } else if ('object' == typeof data && !(data instanceof Date)) {
      var newData = {};
      for (var key in data) {
        newData[key] = _deconstructPacket(data[key]);
      }
      return newData;
    }
    return data;
  }

  var pack = packet;
  pack.data = _deconstructPacket(packetData);
  pack.attachments = buffers.length; // number of binary 'attachments'
  return {packet: pack, buffers: buffers};
};

/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @api public
 */

exports.reconstructPacket = function(packet, buffers) {
  var curPlaceHolder = 0;

  function _reconstructPacket(data) {
    if (data && data._placeholder) {
      var buf = buffers[data.num]; // appropriate buffer (should be natural order anyway)
      return buf;
    } else if (isArray(data)) {
      for (var i = 0; i < data.length; i++) {
        data[i] = _reconstructPacket(data[i]);
      }
      return data;
    } else if (data && 'object' == typeof data) {
      for (var key in data) {
        data[key] = _reconstructPacket(data[key]);
      }
      return data;
    }
    return data;
  }

  packet.data = _reconstructPacket(packet.data);
  packet.attachments = undefined; // no longer useful
  return packet;
};

/**
 * Asynchronously removes Blobs or Files from data via
 * FileReader's readAsArrayBuffer method. Used before encoding
 * data as msgpack. Calls callback with the blobless data.
 *
 * @param {Object} data
 * @param {Function} callback
 * @api private
 */

exports.removeBlobs = function(data, callback) {
  function _removeBlobs(obj, curKey, containingObject) {
    if (!obj) return obj;

    // convert any blob
    if ((global.Blob && obj instanceof Blob) ||
        (global.File && obj instanceof File)) {
      pendingBlobs++;

      // async filereader
      var fileReader = new FileReader();
      fileReader.onload = function() { // this.result == arraybuffer
        if (containingObject) {
          containingObject[curKey] = this.result;
        }
        else {
          bloblessData = this.result;
        }

        // if nothing pending its callback time
        if(! --pendingBlobs) {
          callback(bloblessData);
        }
      };

      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
    } else if (isArray(obj)) { // handle array
      for (var i = 0; i < obj.length; i++) {
        _removeBlobs(obj[i], i, obj);
      }
    } else if (obj && 'object' == typeof obj && !isBuf(obj)) { // and object
      for (var key in obj) {
        _removeBlobs(obj[key], key, obj);
      }
    }
  }

  var pendingBlobs = 0;
  var bloblessData = data;
  _removeBlobs(bloblessData);
  if (!pendingBlobs) {
    callback(bloblessData);
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = __webpack_require__(455);


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = __webpack_require__(456);

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = __webpack_require__(34);


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module dependencies.
 */

var transports = __webpack_require__(205);
var Emitter = __webpack_require__(111);
var debug = __webpack_require__(62)('engine.io-client:socket');
var index = __webpack_require__(208);
var parser = __webpack_require__(34);
var parseuri = __webpack_require__(202);
var parsejson = __webpack_require__(472);
var parseqs = __webpack_require__(112);

/**
 * Module exports.
 */

module.exports = Socket;

/**
 * Socket constructor.
 *
 * @param {String|Object} uri or options
 * @param {Object} options
 * @api public
 */

function Socket (uri, opts) {
  if (!(this instanceof Socket)) return new Socket(uri, opts);

  opts = opts || {};

  if (uri && 'object' === typeof uri) {
    opts = uri;
    uri = null;
  }

  if (uri) {
    uri = parseuri(uri);
    opts.hostname = uri.host;
    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
    opts.port = uri.port;
    if (uri.query) opts.query = uri.query;
  } else if (opts.host) {
    opts.hostname = parseuri(opts.host).host;
  }

  this.secure = null != opts.secure ? opts.secure
    : (global.location && 'https:' === location.protocol);

  if (opts.hostname && !opts.port) {
    // if no port is specified manually, use the protocol default
    opts.port = this.secure ? '443' : '80';
  }

  this.agent = opts.agent || false;
  this.hostname = opts.hostname ||
    (global.location ? location.hostname : 'localhost');
  this.port = opts.port || (global.location && location.port
      ? location.port
      : (this.secure ? 443 : 80));
  this.query = opts.query || {};
  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
  this.upgrade = false !== opts.upgrade;
  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
  this.forceJSONP = !!opts.forceJSONP;
  this.jsonp = false !== opts.jsonp;
  this.forceBase64 = !!opts.forceBase64;
  this.enablesXDR = !!opts.enablesXDR;
  this.timestampParam = opts.timestampParam || 't';
  this.timestampRequests = opts.timestampRequests;
  this.transports = opts.transports || ['polling', 'websocket'];
  this.readyState = '';
  this.writeBuffer = [];
  this.prevBufferLen = 0;
  this.policyPort = opts.policyPort || 843;
  this.rememberUpgrade = opts.rememberUpgrade || false;
  this.binaryType = null;
  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;

  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
    this.perMessageDeflate.threshold = 1024;
  }

  // SSL options for Node.js client
  this.pfx = opts.pfx || null;
  this.key = opts.key || null;
  this.passphrase = opts.passphrase || null;
  this.cert = opts.cert || null;
  this.ca = opts.ca || null;
  this.ciphers = opts.ciphers || null;
  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? null : opts.rejectUnauthorized;
  this.forceNode = !!opts.forceNode;

  // other options for Node.js client
  var freeGlobal = typeof global === 'object' && global;
  if (freeGlobal.global === freeGlobal) {
    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
      this.extraHeaders = opts.extraHeaders;
    }

    if (opts.localAddress) {
      this.localAddress = opts.localAddress;
    }
  }

  // set on handshake
  this.id = null;
  this.upgrades = null;
  this.pingInterval = null;
  this.pingTimeout = null;

  // set on heartbeat
  this.pingIntervalTimer = null;
  this.pingTimeoutTimer = null;

  this.open();
}

Socket.priorWebsocketSuccess = false;

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Protocol version.
 *
 * @api public
 */

Socket.protocol = parser.protocol; // this is an int

/**
 * Expose deps for legacy compatibility
 * and standalone browser access.
 */

Socket.Socket = Socket;
Socket.Transport = __webpack_require__(110);
Socket.transports = __webpack_require__(205);
Socket.parser = __webpack_require__(34);

/**
 * Creates transport of the given type.
 *
 * @param {String} transport name
 * @return {Transport}
 * @api private
 */

Socket.prototype.createTransport = function (name) {
  debug('creating transport "%s"', name);
  var query = clone(this.query);

  // append engine.io protocol identifier
  query.EIO = parser.protocol;

  // transport name
  query.transport = name;

  // session id if we already have one
  if (this.id) query.sid = this.id;

  var transport = new transports[name]({
    agent: this.agent,
    hostname: this.hostname,
    port: this.port,
    secure: this.secure,
    path: this.path,
    query: query,
    forceJSONP: this.forceJSONP,
    jsonp: this.jsonp,
    forceBase64: this.forceBase64,
    enablesXDR: this.enablesXDR,
    timestampRequests: this.timestampRequests,
    timestampParam: this.timestampParam,
    policyPort: this.policyPort,
    socket: this,
    pfx: this.pfx,
    key: this.key,
    passphrase: this.passphrase,
    cert: this.cert,
    ca: this.ca,
    ciphers: this.ciphers,
    rejectUnauthorized: this.rejectUnauthorized,
    perMessageDeflate: this.perMessageDeflate,
    extraHeaders: this.extraHeaders,
    forceNode: this.forceNode,
    localAddress: this.localAddress
  });

  return transport;
};

function clone (obj) {
  var o = {};
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      o[i] = obj[i];
    }
  }
  return o;
}

/**
 * Initializes transport to use and starts probe.
 *
 * @api private
 */
Socket.prototype.open = function () {
  var transport;
  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
    transport = 'websocket';
  } else if (0 === this.transports.length) {
    // Emit error on next tick so it can be listened to
    var self = this;
    setTimeout(function () {
      self.emit('error', 'No transports available');
    }, 0);
    return;
  } else {
    transport = this.transports[0];
  }
  this.readyState = 'opening';

  // Retry with the next transport if the transport is disabled (jsonp: false)
  try {
    transport = this.createTransport(transport);
  } catch (e) {
    this.transports.shift();
    this.open();
    return;
  }

  transport.open();
  this.setTransport(transport);
};

/**
 * Sets the current transport. Disables the existing one (if any).
 *
 * @api private
 */

Socket.prototype.setTransport = function (transport) {
  debug('setting transport %s', transport.name);
  var self = this;

  if (this.transport) {
    debug('clearing existing transport %s', this.transport.name);
    this.transport.removeAllListeners();
  }

  // set up transport
  this.transport = transport;

  // set up transport listeners
  transport
  .on('drain', function () {
    self.onDrain();
  })
  .on('packet', function (packet) {
    self.onPacket(packet);
  })
  .on('error', function (e) {
    self.onError(e);
  })
  .on('close', function () {
    self.onClose('transport close');
  });
};

/**
 * Probes a transport.
 *
 * @param {String} transport name
 * @api private
 */

Socket.prototype.probe = function (name) {
  debug('probing transport "%s"', name);
  var transport = this.createTransport(name, { probe: 1 });
  var failed = false;
  var self = this;

  Socket.priorWebsocketSuccess = false;

  function onTransportOpen () {
    if (self.onlyBinaryUpgrades) {
      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
      failed = failed || upgradeLosesBinary;
    }
    if (failed) return;

    debug('probe transport "%s" opened', name);
    transport.send([{ type: 'ping', data: 'probe' }]);
    transport.once('packet', function (msg) {
      if (failed) return;
      if ('pong' === msg.type && 'probe' === msg.data) {
        debug('probe transport "%s" pong', name);
        self.upgrading = true;
        self.emit('upgrading', transport);
        if (!transport) return;
        Socket.priorWebsocketSuccess = 'websocket' === transport.name;

        debug('pausing current transport "%s"', self.transport.name);
        self.transport.pause(function () {
          if (failed) return;
          if ('closed' === self.readyState) return;
          debug('changing transport and sending upgrade packet');

          cleanup();

          self.setTransport(transport);
          transport.send([{ type: 'upgrade' }]);
          self.emit('upgrade', transport);
          transport = null;
          self.upgrading = false;
          self.flush();
        });
      } else {
        debug('probe transport "%s" failed', name);
        var err = new Error('probe error');
        err.transport = transport.name;
        self.emit('upgradeError', err);
      }
    });
  }

  function freezeTransport () {
    if (failed) return;

    // Any callback called by transport should be ignored since now
    failed = true;

    cleanup();

    transport.close();
    transport = null;
  }

  // Handle any error that happens while probing
  function onerror (err) {
    var error = new Error('probe error: ' + err);
    error.transport = transport.name;

    freezeTransport();

    debug('probe transport "%s" failed because of error: %s', name, err);

    self.emit('upgradeError', error);
  }

  function onTransportClose () {
    onerror('transport closed');
  }

  // When the socket is closed while we're probing
  function onclose () {
    onerror('socket closed');
  }

  // When the socket is upgraded while we're probing
  function onupgrade (to) {
    if (transport && to.name !== transport.name) {
      debug('"%s" works - aborting "%s"', to.name, transport.name);
      freezeTransport();
    }
  }

  // Remove all listeners on the transport and on self
  function cleanup () {
    transport.removeListener('open', onTransportOpen);
    transport.removeListener('error', onerror);
    transport.removeListener('close', onTransportClose);
    self.removeListener('close', onclose);
    self.removeListener('upgrading', onupgrade);
  }

  transport.once('open', onTransportOpen);
  transport.once('error', onerror);
  transport.once('close', onTransportClose);

  this.once('close', onclose);
  this.once('upgrading', onupgrade);

  transport.open();
};

/**
 * Called when connection is deemed open.
 *
 * @api public
 */

Socket.prototype.onOpen = function () {
  debug('socket open');
  this.readyState = 'open';
  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
  this.emit('open');
  this.flush();

  // we check for `readyState` in case an `open`
  // listener already closed the socket
  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
    debug('starting upgrade probes');
    for (var i = 0, l = this.upgrades.length; i < l; i++) {
      this.probe(this.upgrades[i]);
    }
  }
};

/**
 * Handles a packet.
 *
 * @api private
 */

Socket.prototype.onPacket = function (packet) {
  if ('opening' === this.readyState || 'open' === this.readyState ||
      'closing' === this.readyState) {
    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);

    this.emit('packet', packet);

    // Socket is live - any packet counts
    this.emit('heartbeat');

    switch (packet.type) {
      case 'open':
        this.onHandshake(parsejson(packet.data));
        break;

      case 'pong':
        this.setPing();
        this.emit('pong');
        break;

      case 'error':
        var err = new Error('server error');
        err.code = packet.data;
        this.onError(err);
        break;

      case 'message':
        this.emit('data', packet.data);
        this.emit('message', packet.data);
        break;
    }
  } else {
    debug('packet received with socket readyState "%s"', this.readyState);
  }
};

/**
 * Called upon handshake completion.
 *
 * @param {Object} handshake obj
 * @api private
 */

Socket.prototype.onHandshake = function (data) {
  this.emit('handshake', data);
  this.id = data.sid;
  this.transport.query.sid = data.sid;
  this.upgrades = this.filterUpgrades(data.upgrades);
  this.pingInterval = data.pingInterval;
  this.pingTimeout = data.pingTimeout;
  this.onOpen();
  // In case open handler closes socket
  if ('closed' === this.readyState) return;
  this.setPing();

  // Prolong liveness of socket on heartbeat
  this.removeListener('heartbeat', this.onHeartbeat);
  this.on('heartbeat', this.onHeartbeat);
};

/**
 * Resets ping timeout.
 *
 * @api private
 */

Socket.prototype.onHeartbeat = function (timeout) {
  clearTimeout(this.pingTimeoutTimer);
  var self = this;
  self.pingTimeoutTimer = setTimeout(function () {
    if ('closed' === self.readyState) return;
    self.onClose('ping timeout');
  }, timeout || (self.pingInterval + self.pingTimeout));
};

/**
 * Pings server every `this.pingInterval` and expects response
 * within `this.pingTimeout` or closes connection.
 *
 * @api private
 */

Socket.prototype.setPing = function () {
  var self = this;
  clearTimeout(self.pingIntervalTimer);
  self.pingIntervalTimer = setTimeout(function () {
    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
    self.ping();
    self.onHeartbeat(self.pingTimeout);
  }, self.pingInterval);
};

/**
* Sends a ping packet.
*
* @api private
*/

Socket.prototype.ping = function () {
  var self = this;
  this.sendPacket('ping', function () {
    self.emit('ping');
  });
};

/**
 * Called on `drain` event
 *
 * @api private
 */

Socket.prototype.onDrain = function () {
  this.writeBuffer.splice(0, this.prevBufferLen);

  // setting prevBufferLen = 0 is very important
  // for example, when upgrading, upgrade packet is sent over,
  // and a nonzero prevBufferLen could cause problems on `drain`
  this.prevBufferLen = 0;

  if (0 === this.writeBuffer.length) {
    this.emit('drain');
  } else {
    this.flush();
  }
};

/**
 * Flush write buffers.
 *
 * @api private
 */

Socket.prototype.flush = function () {
  if ('closed' !== this.readyState && this.transport.writable &&
    !this.upgrading && this.writeBuffer.length) {
    debug('flushing %d packets in socket', this.writeBuffer.length);
    this.transport.send(this.writeBuffer);
    // keep track of current length of writeBuffer
    // splice writeBuffer and callbackBuffer on `drain`
    this.prevBufferLen = this.writeBuffer.length;
    this.emit('flush');
  }
};

/**
 * Sends a message.
 *
 * @param {String} message.
 * @param {Function} callback function.
 * @param {Object} options.
 * @return {Socket} for chaining.
 * @api public
 */

Socket.prototype.write =
Socket.prototype.send = function (msg, options, fn) {
  this.sendPacket('message', msg, options, fn);
  return this;
};

/**
 * Sends a packet.
 *
 * @param {String} packet type.
 * @param {String} data.
 * @param {Object} options.
 * @param {Function} callback function.
 * @api private
 */

Socket.prototype.sendPacket = function (type, data, options, fn) {
  if ('function' === typeof data) {
    fn = data;
    data = undefined;
  }

  if ('function' === typeof options) {
    fn = options;
    options = null;
  }

  if ('closing' === this.readyState || 'closed' === this.readyState) {
    return;
  }

  options = options || {};
  options.compress = false !== options.compress;

  var packet = {
    type: type,
    data: data,
    options: options
  };
  this.emit('packetCreate', packet);
  this.writeBuffer.push(packet);
  if (fn) this.once('flush', fn);
  this.flush();
};

/**
 * Closes the connection.
 *
 * @api private
 */

Socket.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.readyState = 'closing';

    var self = this;

    if (this.writeBuffer.length) {
      this.once('drain', function () {
        if (this.upgrading) {
          waitForUpgrade();
        } else {
          close();
        }
      });
    } else if (this.upgrading) {
      waitForUpgrade();
    } else {
      close();
    }
  }

  function close () {
    self.onClose('forced close');
    debug('socket closing - telling transport to close');
    self.transport.close();
  }

  function cleanupAndClose () {
    self.removeListener('upgrade', cleanupAndClose);
    self.removeListener('upgradeError', cleanupAndClose);
    close();
  }

  function waitForUpgrade () {
    // wait for upgrade to finish since we can't send packets while pausing a transport
    self.once('upgrade', cleanupAndClose);
    self.once('upgradeError', cleanupAndClose);
  }

  return this;
};

/**
 * Called upon transport error
 *
 * @api private
 */

Socket.prototype.onError = function (err) {
  debug('socket error %j', err);
  Socket.priorWebsocketSuccess = false;
  this.emit('error', err);
  this.onClose('transport error', err);
};

/**
 * Called upon transport close.
 *
 * @api private
 */

Socket.prototype.onClose = function (reason, desc) {
  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
    debug('socket close with reason: "%s"', reason);
    var self = this;

    // clear timers
    clearTimeout(this.pingIntervalTimer);
    clearTimeout(this.pingTimeoutTimer);

    // stop event from firing again for transport
    this.transport.removeAllListeners('close');

    // ensure transport won't stay open
    this.transport.close();

    // ignore further transport communication
    this.transport.removeAllListeners();

    // set ready state
    this.readyState = 'closed';

    // clear session id
    this.id = null;

    // emit close event
    this.emit('close', reason, desc);

    // clean buffers after, so users can still
    // grab the buffers on `close` event
    self.writeBuffer = [];
    self.prevBufferLen = 0;
  }
};

/**
 * Filters upgrades, returning only those matching client transports.
 *
 * @param {Array} server upgrades
 * @api private
 *
 */

Socket.prototype.filterUpgrades = function (upgrades) {
  var filteredUpgrades = [];
  for (var i = 0, j = upgrades.length; i < j; i++) {
    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
  }
  return filteredUpgrades;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 457 */
/***/ (function(module, exports) {


/**
 * Module exports.
 *
 * Logic borrowed from Modernizr:
 *
 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
 */

try {
  module.exports = typeof XMLHttpRequest !== 'undefined' &&
    'withCredentials' in new XMLHttpRequest();
} catch (err) {
  // if XMLHttp support is disabled in IE then it will throw
  // when trying to create
  module.exports = false;
}


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module requirements.
 */

var XMLHttpRequest = __webpack_require__(109);
var Polling = __webpack_require__(206);
var Emitter = __webpack_require__(111);
var inherit = __webpack_require__(61);
var debug = __webpack_require__(62)('engine.io-client:polling-xhr');

/**
 * Module exports.
 */

module.exports = XHR;
module.exports.Request = Request;

/**
 * Empty function
 */

function empty () {}

/**
 * XHR Polling constructor.
 *
 * @param {Object} opts
 * @api public
 */

function XHR (opts) {
  Polling.call(this, opts);
  this.requestTimeout = opts.requestTimeout;

  if (global.location) {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    this.xd = opts.hostname !== global.location.hostname ||
      port !== opts.port;
    this.xs = opts.secure !== isSSL;
  } else {
    this.extraHeaders = opts.extraHeaders;
  }
}

/**
 * Inherits from Polling.
 */

inherit(XHR, Polling);

/**
 * XHR supports binary
 */

XHR.prototype.supportsBinary = true;

/**
 * Creates a request.
 *
 * @param {String} method
 * @api private
 */

XHR.prototype.request = function (opts) {
  opts = opts || {};
  opts.uri = this.uri();
  opts.xd = this.xd;
  opts.xs = this.xs;
  opts.agent = this.agent || false;
  opts.supportsBinary = this.supportsBinary;
  opts.enablesXDR = this.enablesXDR;

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  opts.requestTimeout = this.requestTimeout;

  // other options for Node.js client
  opts.extraHeaders = this.extraHeaders;

  return new Request(opts);
};

/**
 * Sends data.
 *
 * @param {String} data to send.
 * @param {Function} called upon flush.
 * @api private
 */

XHR.prototype.doWrite = function (data, fn) {
  var isBinary = typeof data !== 'string' && data !== undefined;
  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
  var self = this;
  req.on('success', fn);
  req.on('error', function (err) {
    self.onError('xhr post error', err);
  });
  this.sendXhr = req;
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

XHR.prototype.doPoll = function () {
  debug('xhr poll');
  var req = this.request();
  var self = this;
  req.on('data', function (data) {
    self.onData(data);
  });
  req.on('error', function (err) {
    self.onError('xhr poll error', err);
  });
  this.pollXhr = req;
};

/**
 * Request constructor
 *
 * @param {Object} options
 * @api public
 */

function Request (opts) {
  this.method = opts.method || 'GET';
  this.uri = opts.uri;
  this.xd = !!opts.xd;
  this.xs = !!opts.xs;
  this.async = false !== opts.async;
  this.data = undefined !== opts.data ? opts.data : null;
  this.agent = opts.agent;
  this.isBinary = opts.isBinary;
  this.supportsBinary = opts.supportsBinary;
  this.enablesXDR = opts.enablesXDR;
  this.requestTimeout = opts.requestTimeout;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;

  this.create();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Request.prototype);

/**
 * Creates the XHR object and sends the request.
 *
 * @api private
 */

Request.prototype.create = function () {
  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;

  var xhr = this.xhr = new XMLHttpRequest(opts);
  var self = this;

  try {
    debug('xhr open %s: %s', this.method, this.uri);
    xhr.open(this.method, this.uri, this.async);
    try {
      if (this.extraHeaders) {
        xhr.setDisableHeaderCheck(true);
        for (var i in this.extraHeaders) {
          if (this.extraHeaders.hasOwnProperty(i)) {
            xhr.setRequestHeader(i, this.extraHeaders[i]);
          }
        }
      }
    } catch (e) {}
    if (this.supportsBinary) {
      // This has to be done after open because Firefox is stupid
      // http://stackoverflow.com/questions/13216903/get-binary-data-with-xmlhttprequest-in-a-firefox-extension
      xhr.responseType = 'arraybuffer';
    }

    if ('POST' === this.method) {
      try {
        if (this.isBinary) {
          xhr.setRequestHeader('Content-type', 'application/octet-stream');
        } else {
          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
        }
      } catch (e) {}
    }

    try {
      xhr.setRequestHeader('Accept', '*/*');
    } catch (e) {}

    // ie6 check
    if ('withCredentials' in xhr) {
      xhr.withCredentials = true;
    }

    if (this.requestTimeout) {
      xhr.timeout = this.requestTimeout;
    }

    if (this.hasXDR()) {
      xhr.onload = function () {
        self.onLoad();
      };
      xhr.onerror = function () {
        self.onError(xhr.responseText);
      };
    } else {
      xhr.onreadystatechange = function () {
        if (4 !== xhr.readyState) return;
        if (200 === xhr.status || 1223 === xhr.status) {
          self.onLoad();
        } else {
          // make sure the `error` event handler that's user-set
          // does not throw in the same tick and gets caught here
          setTimeout(function () {
            self.onError(xhr.status);
          }, 0);
        }
      };
    }

    debug('xhr data %s', this.data);
    xhr.send(this.data);
  } catch (e) {
    // Need to defer since .create() is called directly fhrom the constructor
    // and thus the 'error' event can only be only bound *after* this exception
    // occurs.  Therefore, also, we cannot throw here at all.
    setTimeout(function () {
      self.onError(e);
    }, 0);
    return;
  }

  if (global.document) {
    this.index = Request.requestsCount++;
    Request.requests[this.index] = this;
  }
};

/**
 * Called upon successful response.
 *
 * @api private
 */

Request.prototype.onSuccess = function () {
  this.emit('success');
  this.cleanup();
};

/**
 * Called if we have data.
 *
 * @api private
 */

Request.prototype.onData = function (data) {
  this.emit('data', data);
  this.onSuccess();
};

/**
 * Called upon error.
 *
 * @api private
 */

Request.prototype.onError = function (err) {
  this.emit('error', err);
  this.cleanup(true);
};

/**
 * Cleans up house.
 *
 * @api private
 */

Request.prototype.cleanup = function (fromError) {
  if ('undefined' === typeof this.xhr || null === this.xhr) {
    return;
  }
  // xmlhttprequest
  if (this.hasXDR()) {
    this.xhr.onload = this.xhr.onerror = empty;
  } else {
    this.xhr.onreadystatechange = empty;
  }

  if (fromError) {
    try {
      this.xhr.abort();
    } catch (e) {}
  }

  if (global.document) {
    delete Request.requests[this.index];
  }

  this.xhr = null;
};

/**
 * Called upon load.
 *
 * @api private
 */

Request.prototype.onLoad = function () {
  var data;
  try {
    var contentType;
    try {
      contentType = this.xhr.getResponseHeader('Content-Type').split(';')[0];
    } catch (e) {}
    if (contentType === 'application/octet-stream') {
      data = this.xhr.response || this.xhr.responseText;
    } else {
      if (!this.supportsBinary) {
        data = this.xhr.responseText;
      } else {
        try {
          data = String.fromCharCode.apply(null, new Uint8Array(this.xhr.response));
        } catch (e) {
          var ui8Arr = new Uint8Array(this.xhr.response);
          var dataArray = [];
          for (var idx = 0, length = ui8Arr.length; idx < length; idx++) {
            dataArray.push(ui8Arr[idx]);
          }

          data = String.fromCharCode.apply(null, dataArray);
        }
      }
    }
  } catch (e) {
    this.onError(e);
  }
  if (null != data) {
    this.onData(data);
  }
};

/**
 * Check if it has XDomainRequest.
 *
 * @api private
 */

Request.prototype.hasXDR = function () {
  return 'undefined' !== typeof global.XDomainRequest && !this.xs && this.enablesXDR;
};

/**
 * Aborts the request.
 *
 * @api public
 */

Request.prototype.abort = function () {
  this.cleanup();
};

/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */

Request.requestsCount = 0;
Request.requests = {};

if (global.document) {
  if (global.attachEvent) {
    global.attachEvent('onunload', unloadHandler);
  } else if (global.addEventListener) {
    global.addEventListener('beforeunload', unloadHandler, false);
  }
}

function unloadHandler () {
  for (var i in Request.requests) {
    if (Request.requests.hasOwnProperty(i)) {
      Request.requests[i].abort();
    }
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 459 */
/***/ (function(module, exports) {


/**
 * Gets the keys for an object.
 *
 * @return {Array} keys
 * @api private
 */

module.exports = Object.keys || function keys (obj){
  var arr = [];
  var has = Object.prototype.hasOwnProperty;

  for (var i in obj) {
    if (has.call(obj, i)) {
      arr.push(i);
    }
  }
  return arr;
};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/*
 * Module requirements.
 */

var isArray = __webpack_require__(461);

/**
 * Module exports.
 */

module.exports = hasBinary;

/**
 * Checks for binary data.
 *
 * Right now only Buffer and ArrayBuffer are supported..
 *
 * @param {Object} anything
 * @api public
 */

function hasBinary(data) {

  function _hasBinary(obj) {
    if (!obj) return false;

    if ( (global.Buffer && global.Buffer.isBuffer(obj)) ||
         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||
         (global.Blob && obj instanceof Blob) ||
         (global.File && obj instanceof File)
        ) {
      return true;
    }

    if (isArray(obj)) {
      for (var i = 0; i < obj.length; i++) {
          if (_hasBinary(obj[i])) {
              return true;
          }
      }
    } else if (obj && 'object' == typeof obj) {
      if (obj.toJSON) {
        obj = obj.toJSON();
      }

      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {
          return true;
        }
      }
    }

    return false;
  }

  return _hasBinary(data);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 462 */
/***/ (function(module, exports) {

/**
 * An abstraction for slicing an arraybuffer even when
 * ArrayBuffer.prototype.slice is not supported
 *
 * @api public
 */

module.exports = function(arraybuffer, start, end) {
  var bytes = arraybuffer.byteLength;
  start = start || 0;
  end = end || bytes;

  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }

  if (start < 0) { start += bytes; }
  if (end < 0) { end += bytes; }
  if (end > bytes) { end = bytes; }

  if (start >= bytes || start >= end || bytes === 0) {
    return new ArrayBuffer(0);
  }

  var abv = new Uint8Array(arraybuffer);
  var result = new Uint8Array(end - start);
  for (var i = start, ii = 0; i < end; i++, ii++) {
    result[ii] = abv[i];
  }
  return result.buffer;
};


/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports = after

function after(count, callback, err_cb) {
    var bail = false
    err_cb = err_cb || noop
    proxy.count = count

    return (count === 0) ? callback() : proxy

    function proxy(err, result) {
        if (proxy.count <= 0) {
            throw new Error('after called too many times')
        }
        --proxy.count

        // after first error, rest are passed to err_cb
        if (err) {
            bail = true
            callback(err)
            // future error callbacks will go to error handler
            callback = err_cb
        } else if (proxy.count === 0 && !bail) {
            callback(null, result)
        }
    }
}

function noop() {}


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/wtf8 v1.0.0 by @mathias */
;(function(root) {

	// Detect free variables `exports`
	var freeExports = typeof exports == 'object' && exports;

	// Detect free variable `module`
	var freeModule = typeof module == 'object' && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code,
	// and use it as `root`
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var stringFromCharCode = String.fromCharCode;

	// Taken from https://mths.be/punycode
	function ucs2decode(string) {
		var output = [];
		var counter = 0;
		var length = string.length;
		var value;
		var extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	// Taken from https://mths.be/punycode
	function ucs2encode(array) {
		var length = array.length;
		var index = -1;
		var value;
		var output = '';
		while (++index < length) {
			value = array[index];
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
		}
		return output;
	}

	/*--------------------------------------------------------------------------*/

	function createByte(codePoint, shift) {
		return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
	}

	function encodeCodePoint(codePoint) {
		if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
			return stringFromCharCode(codePoint);
		}
		var symbol = '';
		if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
			symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
		}
		else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
			symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
			symbol += createByte(codePoint, 6);
		}
		else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
			symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
			symbol += createByte(codePoint, 12);
			symbol += createByte(codePoint, 6);
		}
		symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
		return symbol;
	}

	function wtf8encode(string) {
		var codePoints = ucs2decode(string);
		var length = codePoints.length;
		var index = -1;
		var codePoint;
		var byteString = '';
		while (++index < length) {
			codePoint = codePoints[index];
			byteString += encodeCodePoint(codePoint);
		}
		return byteString;
	}

	/*--------------------------------------------------------------------------*/

	function readContinuationByte() {
		if (byteIndex >= byteCount) {
			throw Error('Invalid byte index');
		}

		var continuationByte = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		if ((continuationByte & 0xC0) == 0x80) {
			return continuationByte & 0x3F;
		}

		// If we end up here, it’s not a continuation byte.
		throw Error('Invalid continuation byte');
	}

	function decodeSymbol() {
		var byte1;
		var byte2;
		var byte3;
		var byte4;
		var codePoint;

		if (byteIndex > byteCount) {
			throw Error('Invalid byte index');
		}

		if (byteIndex == byteCount) {
			return false;
		}

		// Read the first byte.
		byte1 = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		// 1-byte sequence (no continuation bytes)
		if ((byte1 & 0x80) == 0) {
			return byte1;
		}

		// 2-byte sequence
		if ((byte1 & 0xE0) == 0xC0) {
			var byte2 = readContinuationByte();
			codePoint = ((byte1 & 0x1F) << 6) | byte2;
			if (codePoint >= 0x80) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 3-byte sequence (may include unpaired surrogates)
		if ((byte1 & 0xF0) == 0xE0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
			if (codePoint >= 0x0800) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 4-byte sequence
		if ((byte1 & 0xF8) == 0xF0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			byte4 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 0x12) | (byte2 << 0x0C) |
				(byte3 << 0x06) | byte4;
			if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
				return codePoint;
			}
		}

		throw Error('Invalid WTF-8 detected');
	}

	var byteArray;
	var byteCount;
	var byteIndex;
	function wtf8decode(byteString) {
		byteArray = ucs2decode(byteString);
		byteCount = byteArray.length;
		byteIndex = 0;
		var codePoints = [];
		var tmp;
		while ((tmp = decodeSymbol()) !== false) {
			codePoints.push(tmp);
		}
		return ucs2encode(codePoints);
	}

	/*--------------------------------------------------------------------------*/

	var wtf8 = {
		'version': '1.0.0',
		'encode': wtf8encode,
		'decode': wtf8decode
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return wtf8;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = wtf8;
		} else { // in Narwhal or RingoJS v0.7.0-
			var object = {};
			var hasOwnProperty = object.hasOwnProperty;
			for (var key in wtf8) {
				hasOwnProperty.call(wtf8, key) && (freeExports[key] = wtf8[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.wtf8 = wtf8;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)(module), __webpack_require__(1)))

/***/ }),
/* 465 */
/***/ (function(module, exports) {

/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */
(function(){
  "use strict";

  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

  // Use a lookup table to find the index.
  var lookup = new Uint8Array(256);
  for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
  }

  exports.encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer),
    i, len = bytes.length, base64 = "";

    for (i = 0; i < len; i+=3) {
      base64 += chars[bytes[i] >> 2];
      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
      base64 += chars[bytes[i + 2] & 63];
    }

    if ((len % 3) === 2) {
      base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
      base64 = base64.substring(0, base64.length - 2) + "==";
    }

    return base64;
  };

  exports.decode =  function(base64) {
    var bufferLength = base64.length * 0.75,
    len = base64.length, i, p = 0,
    encoded1, encoded2, encoded3, encoded4;

    if (base64[base64.length - 1] === "=") {
      bufferLength--;
      if (base64[base64.length - 2] === "=") {
        bufferLength--;
      }
    }

    var arraybuffer = new ArrayBuffer(bufferLength),
    bytes = new Uint8Array(arraybuffer);

    for (i = 0; i < len; i+=4) {
      encoded1 = lookup[base64.charCodeAt(i)];
      encoded2 = lookup[base64.charCodeAt(i+1)];
      encoded3 = lookup[base64.charCodeAt(i+2)];
      encoded4 = lookup[base64.charCodeAt(i+3)];

      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }

    return arraybuffer;
  };
})();


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Create a blob builder even when vendor prefixes exist
 */

var BlobBuilder = global.BlobBuilder
  || global.WebKitBlobBuilder
  || global.MSBlobBuilder
  || global.MozBlobBuilder;

/**
 * Check if Blob constructor is supported
 */

var blobSupported = (function() {
  try {
    var a = new Blob(['hi']);
    return a.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if Blob constructor supports ArrayBufferViews
 * Fails in Safari 6, so we need to map to ArrayBuffers there.
 */

var blobSupportsArrayBufferView = blobSupported && (function() {
  try {
    var b = new Blob([new Uint8Array([1,2])]);
    return b.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if BlobBuilder is supported
 */

var blobBuilderSupported = BlobBuilder
  && BlobBuilder.prototype.append
  && BlobBuilder.prototype.getBlob;

/**
 * Helper function that maps ArrayBufferViews to ArrayBuffers
 * Used by BlobBuilder constructor and old browsers that didn't
 * support it in the Blob constructor.
 */

function mapArrayBufferViews(ary) {
  for (var i = 0; i < ary.length; i++) {
    var chunk = ary[i];
    if (chunk.buffer instanceof ArrayBuffer) {
      var buf = chunk.buffer;

      // if this is a subarray, make a copy so we only
      // include the subarray region from the underlying buffer
      if (chunk.byteLength !== buf.byteLength) {
        var copy = new Uint8Array(chunk.byteLength);
        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
        buf = copy.buffer;
      }

      ary[i] = buf;
    }
  }
}

function BlobBuilderConstructor(ary, options) {
  options = options || {};

  var bb = new BlobBuilder();
  mapArrayBufferViews(ary);

  for (var i = 0; i < ary.length; i++) {
    bb.append(ary[i]);
  }

  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
};

function BlobConstructor(ary, options) {
  mapArrayBufferViews(ary);
  return new Blob(ary, options || {});
};

module.exports = (function() {
  if (blobSupported) {
    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;
  } else if (blobBuilderSupported) {
    return BlobBuilderConstructor;
  } else {
    return undefined;
  }
})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = debug.debug = debug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(468);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lowercased letter, i.e. "n".
 */

exports.formatters = {};

/**
 * Previously assigned color.
 */

var prevColor = 0;

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 *
 * @return {Number}
 * @api private
 */

function selectColor() {
  return exports.colors[prevColor++ % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function debug(namespace) {

  // define the `disabled` version
  function disabled() {
  }
  disabled.enabled = false;

  // define the `enabled` version
  function enabled() {

    var self = enabled;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // add the `color` if not set
    if (null == self.useColors) self.useColors = exports.useColors();
    if (null == self.color && self.useColors) self.color = selectColor();

    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %o
      args = ['%o'].concat(args);
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting
    args = exports.formatArgs.apply(self, args);

    var logFn = enabled.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }
  enabled.enabled = true;

  var fn = exports.enabled(namespace) ? enabled : disabled;

  fn.namespace = namespace;

  return fn;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  var split = (namespaces || '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/[\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 468 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000
var m = s * 60
var h = m * 60
var d = h * 24
var y = d * 365.25

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} options
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {}
  var type = typeof val
  if (type === 'string' && val.length > 0) {
    return parse(val)
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ?
			fmtLong(val) :
			fmtShort(val)
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
}

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str)
  if (str.length > 10000) {
    return
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
  if (!match) {
    return
  }
  var n = parseFloat(match[1])
  var type = (match[2] || 'ms').toLowerCase()
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y
    case 'days':
    case 'day':
    case 'd':
      return n * d
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n
    default:
      return undefined
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd'
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h'
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm'
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's'
  }
  return ms + 'ms'
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms'
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name
  }
  return Math.ceil(ms / n) + ' ' + name + 's'
}


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module requirements.
 */

var Polling = __webpack_require__(206);
var inherit = __webpack_require__(61);

/**
 * Module exports.
 */

module.exports = JSONPPolling;

/**
 * Cached regular expressions.
 */

var rNewline = /\n/g;
var rEscapedNewline = /\\n/g;

/**
 * Global JSONP callbacks.
 */

var callbacks;

/**
 * Noop.
 */

function empty () { }

/**
 * JSONP Polling constructor.
 *
 * @param {Object} opts.
 * @api public
 */

function JSONPPolling (opts) {
  Polling.call(this, opts);

  this.query = this.query || {};

  // define global callbacks array if not present
  // we do this here (lazily) to avoid unneeded global pollution
  if (!callbacks) {
    // we need to consider multiple engines in the same page
    if (!global.___eio) global.___eio = [];
    callbacks = global.___eio;
  }

  // callback identifier
  this.index = callbacks.length;

  // add callback to jsonp global
  var self = this;
  callbacks.push(function (msg) {
    self.onData(msg);
  });

  // append to query string
  this.query.j = this.index;

  // prevent spurious errors from being emitted when the window is unloaded
  if (global.document && global.addEventListener) {
    global.addEventListener('beforeunload', function () {
      if (self.script) self.script.onerror = empty;
    }, false);
  }
}

/**
 * Inherits from Polling.
 */

inherit(JSONPPolling, Polling);

/*
 * JSONP only supports binary as base64 encoded strings
 */

JSONPPolling.prototype.supportsBinary = false;

/**
 * Closes the socket.
 *
 * @api private
 */

JSONPPolling.prototype.doClose = function () {
  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  if (this.form) {
    this.form.parentNode.removeChild(this.form);
    this.form = null;
    this.iframe = null;
  }

  Polling.prototype.doClose.call(this);
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

JSONPPolling.prototype.doPoll = function () {
  var self = this;
  var script = document.createElement('script');

  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  script.async = true;
  script.src = this.uri();
  script.onerror = function (e) {
    self.onError('jsonp poll error', e);
  };

  var insertAt = document.getElementsByTagName('script')[0];
  if (insertAt) {
    insertAt.parentNode.insertBefore(script, insertAt);
  } else {
    (document.head || document.body).appendChild(script);
  }
  this.script = script;

  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);

  if (isUAgecko) {
    setTimeout(function () {
      var iframe = document.createElement('iframe');
      document.body.appendChild(iframe);
      document.body.removeChild(iframe);
    }, 100);
  }
};

/**
 * Writes with a hidden iframe.
 *
 * @param {String} data to send
 * @param {Function} called upon flush.
 * @api private
 */

JSONPPolling.prototype.doWrite = function (data, fn) {
  var self = this;

  if (!this.form) {
    var form = document.createElement('form');
    var area = document.createElement('textarea');
    var id = this.iframeId = 'eio_iframe_' + this.index;
    var iframe;

    form.className = 'socketio';
    form.style.position = 'absolute';
    form.style.top = '-1000px';
    form.style.left = '-1000px';
    form.target = id;
    form.method = 'POST';
    form.setAttribute('accept-charset', 'utf-8');
    area.name = 'd';
    form.appendChild(area);
    document.body.appendChild(form);

    this.form = form;
    this.area = area;
  }

  this.form.action = this.uri();

  function complete () {
    initIframe();
    fn();
  }

  function initIframe () {
    if (self.iframe) {
      try {
        self.form.removeChild(self.iframe);
      } catch (e) {
        self.onError('jsonp polling iframe removal error', e);
      }
    }

    try {
      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
      iframe = document.createElement(html);
    } catch (e) {
      iframe = document.createElement('iframe');
      iframe.name = self.iframeId;
      iframe.src = 'javascript:0';
    }

    iframe.id = self.iframeId;

    self.form.appendChild(iframe);
    self.iframe = iframe;
  }

  initIframe();

  // escape \n to prevent it from being converted into \r\n by some UAs
  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
  data = data.replace(rEscapedNewline, '\\\n');
  this.area.value = data.replace(rNewline, '\\n');

  try {
    this.form.submit();
  } catch (e) {}

  if (this.iframe.attachEvent) {
    this.iframe.onreadystatechange = function () {
      if (self.iframe.readyState === 'complete') {
        complete();
      }
    };
  } else {
    this.iframe.onload = complete;
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module dependencies.
 */

var Transport = __webpack_require__(110);
var parser = __webpack_require__(34);
var parseqs = __webpack_require__(112);
var inherit = __webpack_require__(61);
var yeast = __webpack_require__(207);
var debug = __webpack_require__(62)('engine.io-client:websocket');
var BrowserWebSocket = global.WebSocket || global.MozWebSocket;
var NodeWebSocket;
if (typeof window === 'undefined') {
  try {
    NodeWebSocket = __webpack_require__(471);
  } catch (e) { }
}

/**
 * Get either the `WebSocket` or `MozWebSocket` globals
 * in the browser or try to resolve WebSocket-compatible
 * interface exposed by `ws` for Node-like environment.
 */

var WebSocket = BrowserWebSocket;
if (!WebSocket && typeof window === 'undefined') {
  WebSocket = NodeWebSocket;
}

/**
 * Module exports.
 */

module.exports = WS;

/**
 * WebSocket transport constructor.
 *
 * @api {Object} connection options
 * @api public
 */

function WS (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (forceBase64) {
    this.supportsBinary = false;
  }
  this.perMessageDeflate = opts.perMessageDeflate;
  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
  if (!this.usingBrowserWebSocket) {
    WebSocket = NodeWebSocket;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(WS, Transport);

/**
 * Transport name.
 *
 * @api public
 */

WS.prototype.name = 'websocket';

/*
 * WebSockets support binary
 */

WS.prototype.supportsBinary = true;

/**
 * Opens socket.
 *
 * @api private
 */

WS.prototype.doOpen = function () {
  if (!this.check()) {
    // let probe timeout
    return;
  }

  var uri = this.uri();
  var protocols = void (0);
  var opts = {
    agent: this.agent,
    perMessageDeflate: this.perMessageDeflate
  };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  if (this.extraHeaders) {
    opts.headers = this.extraHeaders;
  }
  if (this.localAddress) {
    opts.localAddress = this.localAddress;
  }

  try {
    this.ws = this.usingBrowserWebSocket ? new WebSocket(uri) : new WebSocket(uri, protocols, opts);
  } catch (err) {
    return this.emit('error', err);
  }

  if (this.ws.binaryType === undefined) {
    this.supportsBinary = false;
  }

  if (this.ws.supports && this.ws.supports.binary) {
    this.supportsBinary = true;
    this.ws.binaryType = 'nodebuffer';
  } else {
    this.ws.binaryType = 'arraybuffer';
  }

  this.addEventListeners();
};

/**
 * Adds event listeners to the socket
 *
 * @api private
 */

WS.prototype.addEventListeners = function () {
  var self = this;

  this.ws.onopen = function () {
    self.onOpen();
  };
  this.ws.onclose = function () {
    self.onClose();
  };
  this.ws.onmessage = function (ev) {
    self.onData(ev.data);
  };
  this.ws.onerror = function (e) {
    self.onError('websocket error', e);
  };
};

/**
 * Writes data to socket.
 *
 * @param {Array} array of packets.
 * @api private
 */

WS.prototype.write = function (packets) {
  var self = this;
  this.writable = false;

  // encodePacket efficient as it uses WS framing
  // no need for encodePayload
  var total = packets.length;
  for (var i = 0, l = total; i < l; i++) {
    (function (packet) {
      parser.encodePacket(packet, self.supportsBinary, function (data) {
        if (!self.usingBrowserWebSocket) {
          // always create a new object (GH-437)
          var opts = {};
          if (packet.options) {
            opts.compress = packet.options.compress;
          }

          if (self.perMessageDeflate) {
            var len = 'string' === typeof data ? global.Buffer.byteLength(data) : data.length;
            if (len < self.perMessageDeflate.threshold) {
              opts.compress = false;
            }
          }
        }

        // Sometimes the websocket has already been closed but the browser didn't
        // have a chance of informing us about it yet, in that case send will
        // throw an error
        try {
          if (self.usingBrowserWebSocket) {
            // TypeError is thrown when passing the second argument on Safari
            self.ws.send(data);
          } else {
            self.ws.send(data, opts);
          }
        } catch (e) {
          debug('websocket closed before onclose event');
        }

        --total || done();
      });
    })(packets[i]);
  }

  function done () {
    self.emit('flush');

    // fake drain
    // defer to next tick to allow Socket to clear writeBuffer
    setTimeout(function () {
      self.writable = true;
      self.emit('drain');
    }, 0);
  }
};

/**
 * Called upon close
 *
 * @api private
 */

WS.prototype.onClose = function () {
  Transport.prototype.onClose.call(this);
};

/**
 * Closes socket.
 *
 * @api private
 */

WS.prototype.doClose = function () {
  if (typeof this.ws !== 'undefined') {
    this.ws.close();
  }
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

WS.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'wss' : 'ws';
  var port = '';

  // avoid port if default for schema
  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
    ('ws' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // append timestamp to URI
  if (this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  // communicate binary support capabilities
  if (!this.supportsBinary) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};

/**
 * Feature detection for WebSocket.
 *
 * @return {Boolean} whether this transport is available.
 * @api public
 */

WS.prototype.check = function () {
  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 471 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * JSON parse.
 *
 * @see Based on jQuery#parseJSON (MIT) and JSON2
 * @api private
 */

var rvalidchars = /^[\],:{}\s]*$/;
var rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
var rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g;
var rtrimLeft = /^\s+/;
var rtrimRight = /\s+$/;

module.exports = function parsejson(data) {
  if ('string' != typeof data || !data) {
    return null;
  }

  data = data.replace(rtrimLeft, '').replace(rtrimRight, '');

  // Attempt to parse using the native JSON parser first
  if (global.JSON && JSON.parse) {
    return JSON.parse(data);
  }

  if (rvalidchars.test(data.replace(rvalidescape, '@')
      .replace(rvalidtokens, ']')
      .replace(rvalidbraces, ''))) {
    return (new Function('return ' + data))();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports = toArray

function toArray(list, index) {
    var array = []

    index = index || 0

    for (var i = index || 0; i < list.length; i++) {
        array[i - index] = list[i]
    }

    return array
}


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/*
 * Module requirements.
 */

var isArray = __webpack_require__(475);

/**
 * Module exports.
 */

module.exports = hasBinary;

/**
 * Checks for binary data.
 *
 * Right now only Buffer and ArrayBuffer are supported..
 *
 * @param {Object} anything
 * @api public
 */

function hasBinary(data) {

  function _hasBinary(obj) {
    if (!obj) return false;

    if ( (global.Buffer && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||
         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||
         (global.Blob && obj instanceof Blob) ||
         (global.File && obj instanceof File)
        ) {
      return true;
    }

    if (isArray(obj)) {
      for (var i = 0; i < obj.length; i++) {
          if (_hasBinary(obj[i])) {
              return true;
          }
      }
    } else if (obj && 'object' == typeof obj) {
      // see: https://github.com/Automattic/has-binary/pull/4
      if (obj.toJSON && 'function' == typeof obj.toJSON) {
        obj = obj.toJSON();
      }

      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {
          return true;
        }
      }
    }

    return false;
  }

  return _hasBinary(data);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 476 */
/***/ (function(module, exports) {


/**
 * Expose `Backoff`.
 */

module.exports = Backoff;

/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */

function Backoff(opts) {
  opts = opts || {};
  this.ms = opts.min || 100;
  this.max = opts.max || 10000;
  this.factor = opts.factor || 2;
  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
  this.attempts = 0;
}

/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */

Backoff.prototype.duration = function(){
  var ms = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var rand =  Math.random();
    var deviation = Math.floor(rand * this.jitter * ms);
    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
  }
  return Math.min(ms, this.max) | 0;
};

/**
 * Reset the number of attempts.
 *
 * @api public
 */

Backoff.prototype.reset = function(){
  this.attempts = 0;
};

/**
 * Set the minimum duration
 *
 * @api public
 */

Backoff.prototype.setMin = function(min){
  this.ms = min;
};

/**
 * Set the maximum duration
 *
 * @api public
 */

Backoff.prototype.setMax = function(max){
  this.max = max;
};

/**
 * Set the jitter
 *
 * @api public
 */

Backoff.prototype.setJitter = function(jitter){
  this.jitter = jitter;
};



/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = saveScreenshot;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html2canvas__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_html2canvas__);
function saveScreenshot(thumbWidth,thumbHeight){return new Promise(function(resolve,reject){try{if(document.querySelector("#workspace .scenes")){__WEBPACK_IMPORTED_MODULE_0_html2canvas___default()(document.querySelector("#workspace .scenes"),{useCORS:true,logging:false}).then(function(canvas){var extra_canvas=document.createElement("canvas");var projectUrl="";extra_canvas.setAttribute('width',thumbWidth*2);extra_canvas.setAttribute('height',thumbHeight*2);var ctx=extra_canvas.getContext('2d');ctx.drawImage(canvas,0,0,canvas.width,canvas.height,0,0,thumbWidth*2,thumbHeight*2);projectUrl=extra_canvas.toDataURL();extra_canvas.remove();resolve([projectUrl]);}).catch(reject);}else{resolve(null);}}catch(err){reject(err);}});}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * html2canvas 1.0.0-rc.5 <https://html2canvas.hertzen.com>
 * Copyright (c) 2019 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = global || self, global.html2canvas = factory());
}(this, function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    var Bounds = /** @class */ (function () {
        function Bounds(x, y, w, h) {
            this.left = x;
            this.top = y;
            this.width = w;
            this.height = h;
        }
        Bounds.prototype.add = function (x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function (clientRect) {
            return new Bounds(clientRect.left, clientRect.top, clientRect.width, clientRect.height);
        };
        return Bounds;
    }());
    var parseBounds = function (node) {
        return Bounds.fromClientRect(node.getBoundingClientRect());
    };
    var parseDocumentSize = function (document) {
        var body = document.body;
        var documentElement = document.documentElement;
        if (!body || !documentElement) {
            throw new Error("Unable to get document size");
        }
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };

    /*
     * css-line-break 1.1.1 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2019 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var toCodePoints = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
    }
    var decode = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup[base64.charCodeAt(i)];
            encoded2 = lookup[base64.charCodeAt(i + 1)];
            encoded3 = lookup[base64.charCodeAt(i + 2)];
            encoded4 = lookup[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function (base64) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16(view16, (headerLength + view32[4]) / 2)
            : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    var base64 = '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';

    /* @flow */
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR = 2; //  Cause a line break (after), except between CR and LF
    var LF = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED = '×';
    var BREAK_ALLOWED = '÷';
    var UnicodeTrie = createTrieFromBase64(base64);
    var ALPHABETICS = [AL, HL];
    var HARD_LINE_BREAKS = [BK, CR, LF, NL];
    var SPACE = [SP, ZW];
    var PREFIX_POSTFIX = [PR, PO];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE);
    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
    var HYPHEN = [HY, BA];
    var codePointsToCharacterClasses = function (codePoints, lineBreak) {
        if (lineBreak === void 0) { lineBreak = 'strict'; }
        var types = [];
        var indicies = [];
        var categories = [];
        codePoints.forEach(function (codePoint, index) {
            var classType = UnicodeTrie.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            }
            else {
                categories.push(false);
            }
            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                    indicies.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indicies.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indicies.push(indicies[index - 1]);
                    return types.push(prev);
                }
                indicies.push(index);
                return types.push(AL);
            }
            indicies.push(index);
            if (classType === CJ) {
                return types.push(lineBreak === 'strict' ? NS : ID);
            }
            if (classType === SA) {
                return types.push(AL);
            }
            if (classType === AI) {
                return types.push(AL);
            }
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if ((codePoint >= 0x20000 && codePoint <= 0x2fffd) || (codePoint >= 0x30000 && codePoint <= 0x3fffd)) {
                    return types.push(ID);
                }
                else {
                    return types.push(AL);
                }
            }
            types.push(classType);
        });
        return [indicies, types, categories];
    };
    var isAdjacentWithSpaceIgnored = function (a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while (i <= classTypes.length) {
                i++;
                var next = classTypes[i];
                if (next === b) {
                    return true;
                }
                if (next !== SP) {
                    break;
                }
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while (i > 0) {
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while (n <= classTypes.length) {
                        n++;
                        var next = classTypes[n];
                        if (next === b) {
                            return true;
                        }
                        if (next !== SP) {
                            break;
                        }
                    }
                }
                if (prev !== SP) {
                    break;
                }
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function (currentIndex, classTypes) {
        var i = currentIndex;
        while (i >= 0) {
            var type = classTypes[i];
            if (type === SP) {
                i--;
            }
            else {
                return type;
            }
        }
        return 0;
    };
    var _lineBreakAtIndex = function (codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) {
            return BREAK_NOT_ALLOWED;
        }
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED;
        }
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR && next === LF) {
            return BREAK_NOT_ALLOWED;
        }
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
        }
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB7 Do not break before spaces or zero width space.
        if (SPACE.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED;
        }
        // LB8a Do not break between a zero width joiner and an ideograph, emoji base or emoji modifier.
        if (UnicodeTrie.get(codePoints[currentIndex]) === ZWJ && (next === ID || next === EB || next === EM)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) {
            return BREAK_NOT_ALLOWED;
        }
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) {
            return BREAK_NOT_ALLOWED;
        }
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
            return BREAK_NOT_ALLOWED;
        }
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED;
        }
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB18 Break after spaces.
        if (current === SP) {
            return BREAK_ALLOWED;
        }
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) {
            return BREAK_NOT_ALLOWED;
        }
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) {
            return BREAK_ALLOWED;
        }
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED;
        }
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) {
            return BREAK_NOT_ALLOWED;
        }
        // LB22 Do not break between two ellipses, or between letters, numbers or exclamations and ellipsis.
        if (next === IN && ALPHABETICS.concat(IN, EX, NU, ID, EB, EM).indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB23 Do not break between digits and letters.
        if ((ALPHABETICS.indexOf(next) !== -1 && current === NU) || (ALPHABETICS.indexOf(current) !== -1 && next === NU)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if ((current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
            ([ID, EB, EM].indexOf(current) !== -1 && next === PO)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if ((ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
            (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (
        // (PR | PO) × ( OP | HY )? NU
        ([PR, PO].indexOf(current) !== -1 &&
            (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
            // ( OP | HY ) × NU
            ([OP, HY].indexOf(current) !== -1 && next === NU) ||
            // NU ×	(NU | SY | IS)
            (current === NU && [NU, SY, IS].indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED;
        }
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([PR, PO].indexOf(next) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // LB26 Do not break a Korean syllable.
        if ((JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
            ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
            ([JT, H3].indexOf(current) !== -1 && next === JT)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB27 Treat a Korean Syllable Block the same as ID.
        if ((KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
            (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if ((ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP) ||
            (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI && next === RI) {
            var i = indicies[currentIndex];
            var count = 1;
            while (i > 0) {
                i--;
                if (classTypes[i] === RI) {
                    count++;
                }
                else {
                    break;
                }
            }
            if (count % 2 !== 0) {
                return BREAK_NOT_ALLOWED;
            }
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) {
            return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var cssFormattedClasses = function (codePoints, options) {
        if (!options) {
            options = { lineBreak: 'normal', wordBreak: 'normal' };
        }
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
            classTypes = classTypes.map(function (type) { return ([NU, AL, SA].indexOf(type) !== -1 ? ID : type); });
        }
        var forbiddenBreakpoints = options.wordBreak === 'keep-all'
            ? isLetterNumber.map(function (letterNumber, i) {
                return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
            })
            : undefined;
        return [indicies, classTypes, forbiddenBreakpoints];
    };
    var Break = /** @class */ (function () {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function () {
            return fromCodePoint.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }());
    var LineBreaker = function (str, options) {
        var codePoints = toCodePoints(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function () {
                if (nextIndex >= length) {
                    return { done: true, value: null };
                }
                var lineBreak = BREAK_NOT_ALLOWED;
                while (nextIndex < length &&
                    (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) ===
                        BREAK_NOT_ALLOWED) { }
                if (lineBreak !== BREAK_NOT_ALLOWED || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };

    // https://www.w3.org/TR/css-syntax-3
    var TokenType;
    (function (TokenType) {
        TokenType[TokenType["STRING_TOKEN"] = 0] = "STRING_TOKEN";
        TokenType[TokenType["BAD_STRING_TOKEN"] = 1] = "BAD_STRING_TOKEN";
        TokenType[TokenType["LEFT_PARENTHESIS_TOKEN"] = 2] = "LEFT_PARENTHESIS_TOKEN";
        TokenType[TokenType["RIGHT_PARENTHESIS_TOKEN"] = 3] = "RIGHT_PARENTHESIS_TOKEN";
        TokenType[TokenType["COMMA_TOKEN"] = 4] = "COMMA_TOKEN";
        TokenType[TokenType["HASH_TOKEN"] = 5] = "HASH_TOKEN";
        TokenType[TokenType["DELIM_TOKEN"] = 6] = "DELIM_TOKEN";
        TokenType[TokenType["AT_KEYWORD_TOKEN"] = 7] = "AT_KEYWORD_TOKEN";
        TokenType[TokenType["PREFIX_MATCH_TOKEN"] = 8] = "PREFIX_MATCH_TOKEN";
        TokenType[TokenType["DASH_MATCH_TOKEN"] = 9] = "DASH_MATCH_TOKEN";
        TokenType[TokenType["INCLUDE_MATCH_TOKEN"] = 10] = "INCLUDE_MATCH_TOKEN";
        TokenType[TokenType["LEFT_CURLY_BRACKET_TOKEN"] = 11] = "LEFT_CURLY_BRACKET_TOKEN";
        TokenType[TokenType["RIGHT_CURLY_BRACKET_TOKEN"] = 12] = "RIGHT_CURLY_BRACKET_TOKEN";
        TokenType[TokenType["SUFFIX_MATCH_TOKEN"] = 13] = "SUFFIX_MATCH_TOKEN";
        TokenType[TokenType["SUBSTRING_MATCH_TOKEN"] = 14] = "SUBSTRING_MATCH_TOKEN";
        TokenType[TokenType["DIMENSION_TOKEN"] = 15] = "DIMENSION_TOKEN";
        TokenType[TokenType["PERCENTAGE_TOKEN"] = 16] = "PERCENTAGE_TOKEN";
        TokenType[TokenType["NUMBER_TOKEN"] = 17] = "NUMBER_TOKEN";
        TokenType[TokenType["FUNCTION"] = 18] = "FUNCTION";
        TokenType[TokenType["FUNCTION_TOKEN"] = 19] = "FUNCTION_TOKEN";
        TokenType[TokenType["IDENT_TOKEN"] = 20] = "IDENT_TOKEN";
        TokenType[TokenType["COLUMN_TOKEN"] = 21] = "COLUMN_TOKEN";
        TokenType[TokenType["URL_TOKEN"] = 22] = "URL_TOKEN";
        TokenType[TokenType["BAD_URL_TOKEN"] = 23] = "BAD_URL_TOKEN";
        TokenType[TokenType["CDC_TOKEN"] = 24] = "CDC_TOKEN";
        TokenType[TokenType["CDO_TOKEN"] = 25] = "CDO_TOKEN";
        TokenType[TokenType["COLON_TOKEN"] = 26] = "COLON_TOKEN";
        TokenType[TokenType["SEMICOLON_TOKEN"] = 27] = "SEMICOLON_TOKEN";
        TokenType[TokenType["LEFT_SQUARE_BRACKET_TOKEN"] = 28] = "LEFT_SQUARE_BRACKET_TOKEN";
        TokenType[TokenType["RIGHT_SQUARE_BRACKET_TOKEN"] = 29] = "RIGHT_SQUARE_BRACKET_TOKEN";
        TokenType[TokenType["UNICODE_RANGE_TOKEN"] = 30] = "UNICODE_RANGE_TOKEN";
        TokenType[TokenType["WHITESPACE_TOKEN"] = 31] = "WHITESPACE_TOKEN";
        TokenType[TokenType["EOF_TOKEN"] = 32] = "EOF_TOKEN";
    })(TokenType || (TokenType = {}));
    var FLAG_UNRESTRICTED = 1 << 0;
    var FLAG_ID = 1 << 1;
    var FLAG_INTEGER = 1 << 2;
    var FLAG_NUMBER = 1 << 3;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE$1 = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function (codePoint) { return codePoint >= ZERO && codePoint <= 0x0039; };
    var isSurrogateCodePoint = function (codePoint) { return codePoint >= 0xd800 && codePoint <= 0xdfff; };
    var isHex = function (codePoint) {
        return isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f);
    };
    var isLowerCaseLetter = function (codePoint) { return codePoint >= a && codePoint <= z; };
    var isUpperCaseLetter = function (codePoint) { return codePoint >= A && codePoint <= Z; };
    var isLetter = function (codePoint) { return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint); };
    var isNonASCIICodePoint = function (codePoint) { return codePoint >= CONTROL; };
    var isWhiteSpace = function (codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE$1;
    };
    var isNameStartCodePoint = function (codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function (codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function (codePoint) {
        return ((codePoint >= NULL && codePoint <= BACKSPACE) ||
            codePoint === LINE_TABULATION ||
            (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
            codePoint === DELETE);
    };
    var isValidEscape = function (c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) {
            return false;
        }
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function (c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        }
        else if (isNameStartCodePoint(c1)) {
            return true;
        }
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
            return true;
        }
        return false;
    };
    var isNumberStart = function (c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) {
                return true;
            }
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) {
            return isDigit(c2);
        }
        return isDigit(c1);
    };
    var stringToNumber = function (codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                sign = -1;
            }
            c++;
        }
        var integers = [];
        while (isDigit(codePoints[c])) {
            integers.push(codePoints[c++]);
        }
        var int = integers.length ? parseInt(fromCodePoint.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) {
            c++;
        }
        var fraction = [];
        while (isDigit(codePoints[c])) {
            fraction.push(codePoints[c++]);
        }
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) {
            c++;
        }
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                expsign = -1;
            }
            c++;
        }
        var exponent = [];
        while (isDigit(codePoints[c])) {
            exponent.push(codePoints[c++]);
        }
        var exp = exponent.length ? parseInt(fromCodePoint.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: TokenType.LEFT_PARENTHESIS_TOKEN
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: TokenType.RIGHT_PARENTHESIS_TOKEN
    };
    var COMMA_TOKEN = { type: TokenType.COMMA_TOKEN };
    var SUFFIX_MATCH_TOKEN = { type: TokenType.SUFFIX_MATCH_TOKEN };
    var PREFIX_MATCH_TOKEN = { type: TokenType.PREFIX_MATCH_TOKEN };
    var COLUMN_TOKEN = { type: TokenType.COLUMN_TOKEN };
    var DASH_MATCH_TOKEN = { type: TokenType.DASH_MATCH_TOKEN };
    var INCLUDE_MATCH_TOKEN = { type: TokenType.INCLUDE_MATCH_TOKEN };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: TokenType.LEFT_CURLY_BRACKET_TOKEN
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: TokenType.RIGHT_CURLY_BRACKET_TOKEN
    };
    var SUBSTRING_MATCH_TOKEN = { type: TokenType.SUBSTRING_MATCH_TOKEN };
    var BAD_URL_TOKEN = { type: TokenType.BAD_URL_TOKEN };
    var BAD_STRING_TOKEN = { type: TokenType.BAD_STRING_TOKEN };
    var CDO_TOKEN = { type: TokenType.CDO_TOKEN };
    var CDC_TOKEN = { type: TokenType.CDC_TOKEN };
    var COLON_TOKEN = { type: TokenType.COLON_TOKEN };
    var SEMICOLON_TOKEN = { type: TokenType.SEMICOLON_TOKEN };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: TokenType.LEFT_SQUARE_BRACKET_TOKEN
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: TokenType.RIGHT_SQUARE_BRACKET_TOKEN
    };
    var WHITESPACE_TOKEN = { type: TokenType.WHITESPACE_TOKEN };
    var EOF_TOKEN = { type: TokenType.EOF_TOKEN };
    var Tokenizer = /** @class */ (function () {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function (chunk) {
            this._value = this._value.concat(toCodePoints(chunk));
        };
        Tokenizer.prototype.read = function () {
            var tokens = [];
            var token = this.consumeToken();
            while (token !== EOF_TOKEN) {
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function () {
            var codePoint = this.consumeCodePoint();
            switch (codePoint) {
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return { type: TokenType.HASH_TOKEN, value: value, flags: flags };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while (true) {
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) {
                                    return this.consumeToken();
                                }
                            }
                            if (c === EOF) {
                                return this.consumeToken();
                            }
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK &&
                        this.peekCodePoint(1) === HYPHEN_MINUS &&
                        this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return { type: TokenType.AT_KEYWORD_TOKEN, value: value };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return { type: TokenType.DELIM_TOKEN, value: fromCodePoint(codePoint) };
        };
        Tokenizer.prototype.consumeCodePoint = function () {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function (delta) {
            if (delta >= this._value.length) {
                return -1;
            }
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while (isHex(codePoint) && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while (codePoint === QUESTION_MARK && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? ZERO : digit); })), 16);
                var end = parseInt(fromCodePoint.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? F : digit); })), 16);
                return { type: TokenType.UNICODE_RANGE_TOKEN, start: start_1, end: end };
            }
            var start = parseInt(fromCodePoint.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while (isHex(codePoint) && endDigits.length < 6) {
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint.apply(void 0, endDigits), 16);
                return { type: TokenType.UNICODE_RANGE_TOKEN, start: start, end: end };
            }
            else {
                return { type: TokenType.UNICODE_RANGE_TOKEN, start: start, end: start };
            }
        };
        Tokenizer.prototype.consumeIdentLikeToken = function () {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            }
            else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return { type: TokenType.FUNCTION_TOKEN, value: value };
            }
            return { type: TokenType.IDENT_TOKEN, value: value };
        };
        Tokenizer.prototype.consumeUrlToken = function () {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) {
                return { type: TokenType.URL_TOKEN, value: '' };
            }
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === TokenType.STRING_TOKEN) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: TokenType.URL_TOKEN, value: stringToken.value };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                    return { type: TokenType.URL_TOKEN, value: fromCodePoint.apply(void 0, value) };
                }
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: TokenType.URL_TOKEN, value: fromCodePoint.apply(void 0, value) };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === QUOTATION_MARK ||
                    codePoint === APOSTROPHE ||
                    codePoint === LEFT_PARENTHESIS ||
                    isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        value.push(this.consumeEscapedCodePoint());
                    }
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                }
                else {
                    value.push(codePoint);
                }
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function () {
            while (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
            }
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function () {
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                    return;
                }
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.consumeEscapedCodePoint();
                }
            }
        };
        Tokenizer.prototype.consumeStringSlice = function (count) {
            var SLICE_STACK_SIZE = 60000;
            var value = '';
            while (count > 0) {
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return { type: TokenType.STRING_TOKEN, value: value };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        }
                        else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            } while (true);
        };
        Tokenizer.prototype.consumeNumber = function () {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                repr.push(this.consumeCodePoint());
            }
            while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            return [stringToNumber(repr), type];
        };
        Tokenizer.prototype.consumeNumericToken = function () {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return { type: TokenType.DIMENSION_TOKEN, number: number, flags: flags, unit: unit };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return { type: TokenType.PERCENTAGE_TOKEN, number: number, flags: flags };
            }
            return { type: TokenType.NUMBER_TOKEN, number: number, flags: flags };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function () {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint(codePoint);
                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                    hex += fromCodePoint(this.consumeCodePoint());
                }
                if (isWhiteSpace(this.peekCodePoint(0))) {
                    this.consumeCodePoint();
                }
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
                    return REPLACEMENT_CHARACTER;
                }
                return hexCodePoint;
            }
            if (codePoint === EOF) {
                return REPLACEMENT_CHARACTER;
            }
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function () {
            var result = '';
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) {
                    result += fromCodePoint(codePoint);
                }
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    result += fromCodePoint(this.consumeEscapedCodePoint());
                }
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }());

    var Parser = /** @class */ (function () {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function (value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function (value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function (value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function () {
            var token = this.consumeToken();
            while (token.type === TokenType.WHITESPACE_TOKEN) {
                token = this.consumeToken();
            }
            if (token.type === TokenType.EOF_TOKEN) {
                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            }
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do {
                token = this.consumeToken();
            } while (token.type === TokenType.WHITESPACE_TOKEN);
            if (token.type === TokenType.EOF_TOKEN) {
                return value;
            }
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function () {
            var values = [];
            while (true) {
                var value = this.consumeComponentValue();
                if (value.type === TokenType.EOF_TOKEN) {
                    return values;
                }
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function () {
            var token = this.consumeToken();
            switch (token.type) {
                case TokenType.LEFT_CURLY_BRACKET_TOKEN:
                case TokenType.LEFT_SQUARE_BRACKET_TOKEN:
                case TokenType.LEFT_PARENTHESIS_TOKEN:
                    return this.consumeSimpleBlock(token.type);
                case TokenType.FUNCTION_TOKEN:
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function (type) {
            var block = { type: type, values: [] };
            var token = this.consumeToken();
            while (true) {
                if (token.type === TokenType.EOF_TOKEN || isEndingTokenFor(token, type)) {
                    return block;
                }
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function (functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: TokenType.FUNCTION
            };
            while (true) {
                var token = this.consumeToken();
                if (token.type === TokenType.EOF_TOKEN || token.type === TokenType.RIGHT_PARENTHESIS_TOKEN) {
                    return cssFunction;
                }
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function () {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function (token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }());
    var isDimensionToken = function (token) { return token.type === TokenType.DIMENSION_TOKEN; };
    var isNumberToken = function (token) { return token.type === TokenType.NUMBER_TOKEN; };
    var isIdentToken = function (token) { return token.type === TokenType.IDENT_TOKEN; };
    var isStringToken = function (token) { return token.type === TokenType.STRING_TOKEN; };
    var isIdentWithValue = function (token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function (token) { return token.type !== TokenType.WHITESPACE_TOKEN; };
    var nonFunctionArgSeparator = function (token) {
        return token.type !== TokenType.WHITESPACE_TOKEN && token.type !== TokenType.COMMA_TOKEN;
    };
    var parseFunctionArgs = function (tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function (token) {
            if (token.type === TokenType.COMMA_TOKEN) {
                if (arg.length === 0) {
                    throw new Error("Error parsing function args, zero tokens for arg");
                }
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== TokenType.WHITESPACE_TOKEN) {
                arg.push(token);
            }
        });
        if (arg.length) {
            args.push(arg);
        }
        return args;
    };
    var isEndingTokenFor = function (token, type) {
        if (type === TokenType.LEFT_CURLY_BRACKET_TOKEN && token.type === TokenType.RIGHT_CURLY_BRACKET_TOKEN) {
            return true;
        }
        if (type === TokenType.LEFT_SQUARE_BRACKET_TOKEN && token.type === TokenType.RIGHT_SQUARE_BRACKET_TOKEN) {
            return true;
        }
        return type === TokenType.LEFT_PARENTHESIS_TOKEN && token.type === TokenType.RIGHT_PARENTHESIS_TOKEN;
    };

    var isLength = function (token) {
        return token.type === TokenType.NUMBER_TOKEN || token.type === TokenType.DIMENSION_TOKEN;
    };

    var isLengthPercentage = function (token) {
        return token.type === TokenType.PERCENTAGE_TOKEN || isLength(token);
    };
    var parseLengthPercentageTuple = function (tokens) {
        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
    };
    var ZERO_LENGTH = {
        type: TokenType.NUMBER_TOKEN,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: TokenType.PERCENTAGE_TOKEN,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: TokenType.PERCENTAGE_TOKEN,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function (tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
    };
    var getAbsoluteValue = function (token, parent) {
        if (token.type === TokenType.PERCENTAGE_TOKEN) {
            return (token.number / 100) * parent;
        }
        if (isDimensionToken(token)) {
            switch (token.unit) {
                case 'rem':
                case 'em':
                    return 16 * token.number; // TODO use correct font-size
                case 'px':
                default:
                    return token.number;
            }
        }
        return token.number;
    };

    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function (value) {
            if (value.type === TokenType.DIMENSION_TOKEN) {
                switch (value.unit) {
                    case DEG:
                        return (Math.PI * value.number) / 180;
                    case GRAD:
                        return (Math.PI / 200) * value.number;
                    case RAD:
                        return value.number;
                    case TURN:
                        return Math.PI * 2 * value.number;
                }
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function (value) {
        if (value.type === TokenType.DIMENSION_TOKEN) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
                return true;
            }
        }
        return false;
    };
    var parseNamedSide = function (tokens) {
        var sideOrCorner = tokens
            .filter(isIdentToken)
            .map(function (ident) { return ident.value; })
            .join(' ');
        switch (sideOrCorner) {
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [ZERO_LENGTH, ZERO_LENGTH];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [ZERO_LENGTH, HUNDRED_PERCENT];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [HUNDRED_PERCENT, ZERO_LENGTH];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function (deg) { return (Math.PI * deg) / 180; };

    var color = {
        name: 'color',
        parse: function (value) {
            if (value.type === TokenType.FUNCTION) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                }
                return colorFunction(value.values);
            }
            if (value.type === TokenType.HASH_TOKEN) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === TokenType.IDENT_TOKEN) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') {
                    return namedColor;
                }
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function (color) { return (0xff & color) === 0; };
    var asString = function (color) {
        var alpha = 0xff & color;
        var blue = 0xff & (color >> 8);
        var green = 0xff & (color >> 16);
        var red = 0xff & (color >> 24);
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function (r, g, b, a) {
        return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0;
    };
    var getTokenColorValue = function (token, i) {
        if (token.type === TokenType.NUMBER_TOKEN) {
            return token.number;
        }
        if (token.type === TokenType.PERCENTAGE_TOKEN) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max);
        }
        return 0;
    };
    var rgb = function (args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) {
            hue += 1;
        }
        if (hue >= 1) {
            hue -= 1;
        }
        if (hue < 1 / 6) {
            return (t2 - t1) * hue * 6 + t1;
        }
        else if (hue < 1 / 2) {
            return t2;
        }
        else if (hue < 2 / 3) {
            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        }
        else {
            return t1;
        }
    }
    var hsl = function (args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === TokenType.NUMBER_TOKEN ? deg(hue.number) : angle.parse(hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) {
            return pack(l * 255, l * 255, l * 255, 1);
        }
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };

    var PropertyDescriptorParsingType;
    (function (PropertyDescriptorParsingType) {
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["VALUE"] = 0] = "VALUE";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["LIST"] = 1] = "LIST";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["IDENT_VALUE"] = 2] = "IDENT_VALUE";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["TYPE_VALUE"] = 3] = "TYPE_VALUE";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["TOKEN_VALUE"] = 4] = "TOKEN_VALUE";
    })(PropertyDescriptorParsingType || (PropertyDescriptorParsingType = {}));

    var BACKGROUND_CLIP;
    (function (BACKGROUND_CLIP) {
        BACKGROUND_CLIP[BACKGROUND_CLIP["BORDER_BOX"] = 0] = "BORDER_BOX";
        BACKGROUND_CLIP[BACKGROUND_CLIP["PADDING_BOX"] = 1] = "PADDING_BOX";
        BACKGROUND_CLIP[BACKGROUND_CLIP["CONTENT_BOX"] = 2] = "CONTENT_BOX";
    })(BACKGROUND_CLIP || (BACKGROUND_CLIP = {}));
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return BACKGROUND_CLIP.PADDING_BOX;
                        case 'content-box':
                            return BACKGROUND_CLIP.CONTENT_BOX;
                    }
                }
                return BACKGROUND_CLIP.BORDER_BOX;
            });
        }
    };

    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    };

    var parseColorStop = function (args) {
        var color$1 = color.parse(args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? { color: color$1, stop: stop } : { color: color$1, stop: null };
    };
    var processColorStops = function (stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) {
            first.stop = ZERO_LENGTH;
        }
        if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
        }
        var processStops = [];
        var previous = 0;
        for (var i = 0; i < stops.length; i++) {
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) {
                    processStops.push(absoluteValue);
                }
                else {
                    processStops.push(previous);
                }
                previous = absoluteValue;
            }
            else {
                processStops.push(null);
            }
        }
        var gapBegin = null;
        for (var i = 0; i < processStops.length; i++) {
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) {
                    gapBegin = i;
                }
            }
            else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for (var g = 1; g <= gapLength; g++) {
                    processStops[gapBegin + g - 1] = gapValue * g;
                }
                gapBegin = null;
            }
        }
        return stops.map(function (_a, i) {
            var color = _a.color;
            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
        });
    };
    var getAngleFromCorner = function (corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function (angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
    };
    var distance = function (a, b) { return Math.sqrt(a * a + b * b); };
    var findCorner = function (width, height, x, y, closest) {
        var corners = [[0, 0], [0, height], [width, 0], [width, height]];
        return corners.reduce(function (stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
                return {
                    optimumCorner: corner,
                    optimumDistance: d
                };
            }
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function (gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch (gradient.size) {
            case CSSRadialExtent.CLOSEST_SIDE:
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === CSSRadialShape.CIRCLE) {
                    rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case CSSRadialExtent.CLOSEST_CORNER:
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === CSSRadialShape.CIRCLE) {
                    rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case CSSRadialExtent.FARTHEST_SIDE:
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === CSSRadialShape.CIRCLE) {
                    rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case CSSRadialExtent.FARTHEST_CORNER:
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === CSSRadialShape.CIRCLE) {
                    rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [rx, ry];
    };

    var linearGradient = function (tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === TokenType.IDENT_TOKEN && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(arg);
            stops.push(colorStop);
        });
        return { angle: angle$1, stops: stops, type: CSSImageType.LINEAR_GRADIENT };
    };

    var prefixLinearGradient = function (tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === TokenType.IDENT_TOKEN &&
                    ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: CSSImageType.LINEAR_GRADIENT
        };
    };

    var testRangeBounds = function (document) {
        var TEST_HEIGHT = 123;
        if (document.createRange) {
            var range = document.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) {
                    return true;
                }
            }
        }
        return false;
    };
    var testCORS = function () { return typeof new Image().crossOrigin !== 'undefined'; };
    var testResponseType = function () { return typeof new XMLHttpRequest().responseType === 'string'; };
    var testSVG = function (document) {
        var img = new Image();
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return false;
        }
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        }
        catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function (data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function (document) {
        var canvas = document.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return Promise.reject(false);
        }
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG(svg)
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data)
                ? loadSerializedSVG(createForeignObjectSVG(size, size, 0, 0, node))
                : Promise.reject(false);
        })
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        })
            .catch(function () { return false; });
    };
    var createForeignObjectSVG = function (width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () { return resolve(img); };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
            return value;
        },
        get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === 'function' && typeof window.fetch === 'function'
                ? testForeignObject(document)
                : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
            return value;
        },
        get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
            return value;
        },
        get SUPPORT_CORS_XHR() {
            var value = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
            return value;
        }
    };

    var Logger = /** @class */ (function () {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
                    // eslint-disable-next-line no-console
                    console.debug.apply(console, [this.id, this.getTime() + "ms"].concat(args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.prototype.getTime = function () {
            return Date.now() - this.start;
        };
        Logger.create = function (options) {
            Logger.instances[options.id] = new Logger(options);
        };
        Logger.destroy = function (id) {
            delete Logger.instances[id];
        };
        Logger.getInstance = function (id) {
            var instance = Logger.instances[id];
            if (typeof instance === 'undefined') {
                throw new Error("No logger instance found with id " + id);
            }
            return instance;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
                    // eslint-disable-next-line no-console
                    console.info.apply(console, [this.id, this.getTime() + "ms"].concat(args));
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
                    // eslint-disable-next-line no-console
                    console.error.apply(console, [this.id, this.getTime() + "ms"].concat(args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.instances = {};
        return Logger;
    }());

    var CacheStorage = /** @class */ (function () {
        function CacheStorage() {
        }
        CacheStorage.create = function (name, options) {
            return (CacheStorage._caches[name] = new Cache(name, options));
        };
        CacheStorage.destroy = function (name) {
            delete CacheStorage._caches[name];
        };
        CacheStorage.open = function (name) {
            var cache = CacheStorage._caches[name];
            if (typeof cache !== 'undefined') {
                return cache;
            }
            throw new Error("Cache with key \"" + name + "\" not found");
        };
        CacheStorage.getOrigin = function (url) {
            var link = CacheStorage._link;
            if (!link) {
                return 'about:blank';
            }
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function (src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function (window) {
            CacheStorage._link = window.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
        };
        CacheStorage.getInstance = function () {
            var current = CacheStorage._current;
            if (current === null) {
                throw new Error("No cache instance attached");
            }
            return current;
        };
        CacheStorage.attachInstance = function (cache) {
            CacheStorage._current = cache;
        };
        CacheStorage.detachInstance = function () {
            CacheStorage._current = null;
        };
        CacheStorage._caches = {};
        CacheStorage._origin = 'about:blank';
        CacheStorage._current = null;
        return CacheStorage;
    }());
    var Cache = /** @class */ (function () {
        function Cache(id, options) {
            this.id = id;
            this._options = options;
            this._cache = {};
        }
        Cache.prototype.addImage = function (src) {
            var result = Promise.resolve();
            if (this.has(src)) {
                return result;
            }
            if (isBlobImage(src) || isRenderable(src)) {
                this._cache[src] = this.loadImage(src);
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function (src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) &&
                                !isSameOrigin &&
                                typeof this._options.proxy === 'string' &&
                                FEATURES.SUPPORT_CORS_XHR &&
                                !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !useProxy && !useCORS) {
                                return [2 /*return*/];
                            }
                            src = key;
                            if (!useProxy) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.proxy(src)];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            Logger.getInstance(this.id).debug("Added image " + key.substring(0, 256));
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    var img = new Image();
                                    img.onload = function () { return resolve(img); };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) {
                                        img.crossOrigin = 'anonymous';
                                    }
                                    img.src = src;
                                    if (img.complete === true) {
                                        // Inline XML images may fail to parse, throwing an Error later on
                                        setTimeout(function () { return resolve(img); }, 500);
                                    }
                                    if (_this._options.imageTimeout > 0) {
                                        setTimeout(function () { return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image"); }, _this._options.imageTimeout);
                                    }
                                })];
                        case 3: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        Cache.prototype.has = function (key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function () {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function (src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) {
                throw new Error('No proxy defined');
            }
            var key = src.substring(0, 256);
            return new Promise(function (resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        if (responseType === 'text') {
                            resolve(xhr.response);
                        }
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function () { return resolve(reader_1.result); }, false);
                            reader_1.addEventListener('error', function (e) { return reject(e); }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    }
                    else {
                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                    }
                };
                xhr.onerror = reject;
                xhr.open('GET', proxy + "?url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
                    xhr.responseType = responseType;
                }
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function () { return reject("Timed out (" + timeout_1 + "ms) proxying " + key); };
                }
                xhr.send();
            });
        };
        return Cache;
    }());
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function (src) { return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src); };
    var isInlineImage = function (src) { return INLINE_IMG.test(src); };
    var isInlineBase64Image = function (src) { return INLINE_BASE64.test(src); };
    var isBlobImage = function (src) { return src.substr(0, 4) === 'blob'; };
    var isSVG = function (src) { return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src); };

    var webkitGradient = function (tokens) {
        var angle = deg(180);
        var stops = [];
        var type = CSSImageType.LINEAR_GRADIENT;
        var shape = CSSRadialShape.CIRCLE;
        var size = CSSRadialExtent.FARTHEST_CORNER;
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = CSSImageType.LINEAR_GRADIENT;
                    return;
                }
                else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = CSSImageType.RADIAL_GRADIENT;
                    return;
                }
            }
            if (firstToken.type === TokenType.FUNCTION) {
                if (firstToken.name === 'from') {
                    var color$1 = color.parse(firstToken.values[0]);
                    stops.push({ stop: ZERO_LENGTH, color: color$1 });
                }
                else if (firstToken.name === 'to') {
                    var color$1 = color.parse(firstToken.values[0]);
                    stops.push({ stop: HUNDRED_PERCENT, color: color$1 });
                }
                else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color$1 = color.parse(values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) {
                            stops.push({
                                stop: { type: TokenType.PERCENTAGE_TOKEN, number: stop_1.number * 100, flags: stop_1.flags },
                                color: color$1
                            });
                        }
                    }
                }
            }
        });
        return type === CSSImageType.LINEAR_GRADIENT
            ? {
                angle: (angle + deg(180)) % deg(360),
                stops: stops,
                type: type
            }
            : { size: size, shape: shape, stops: stops, position: position, type: type };
    };

    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function (tokens) {
        var shape = CSSRadialShape.CIRCLE;
        var size = CSSRadialExtent.FARTHEST_CORNER;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function (acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case 'center':
                                    position.push(FIFTY_PERCENT);
                                    return acc;
                                case 'top':
                                case 'left':
                                    position.push(ZERO_LENGTH);
                                    return acc;
                                case 'right':
                                case 'bottom':
                                    position.push(HUNDRED_PERCENT);
                                    return acc;
                            }
                        }
                        else if (isLengthPercentage(token) || isLength(token)) {
                            position.push(token);
                        }
                    }
                    else if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = CSSRadialShape.CIRCLE;
                                return false;
                            case ELLIPSE:
                                shape = CSSRadialShape.ELLIPSE;
                                return false;
                            case 'at':
                                isAtPosition_1 = true;
                                return false;
                            case CLOSEST_SIDE:
                                size = CSSRadialExtent.CLOSEST_SIDE;
                                return false;
                            case COVER:
                            case FARTHEST_SIDE:
                                size = CSSRadialExtent.FARTHEST_SIDE;
                                return false;
                            case CONTAIN:
                            case CLOSEST_CORNER:
                                size = CSSRadialExtent.CLOSEST_CORNER;
                                return false;
                            case FARTHEST_CORNER:
                                size = CSSRadialExtent.FARTHEST_CORNER;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: CSSImageType.RADIAL_GRADIENT };
    };

    var prefixRadialGradient = function (tokens) {
        var shape = CSSRadialShape.CIRCLE;
        var size = CSSRadialExtent.FARTHEST_CORNER;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return false;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return false;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return false;
                        }
                    }
                    else if (isLengthPercentage(token) || isLength(token)) {
                        position.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            else if (i === 1) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = CSSRadialShape.CIRCLE;
                                return false;
                            case ELLIPSE:
                                shape = CSSRadialShape.ELLIPSE;
                                return false;
                            case CONTAIN:
                            case CLOSEST_SIDE:
                                size = CSSRadialExtent.CLOSEST_SIDE;
                                return false;
                            case FARTHEST_SIDE:
                                size = CSSRadialExtent.FARTHEST_SIDE;
                                return false;
                            case CLOSEST_CORNER:
                                size = CSSRadialExtent.CLOSEST_CORNER;
                                return false;
                            case COVER:
                            case FARTHEST_CORNER:
                                size = CSSRadialExtent.FARTHEST_CORNER;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: CSSImageType.RADIAL_GRADIENT };
    };

    var CSSImageType;
    (function (CSSImageType) {
        CSSImageType[CSSImageType["URL"] = 0] = "URL";
        CSSImageType[CSSImageType["LINEAR_GRADIENT"] = 1] = "LINEAR_GRADIENT";
        CSSImageType[CSSImageType["RADIAL_GRADIENT"] = 2] = "RADIAL_GRADIENT";
    })(CSSImageType || (CSSImageType = {}));
    var isLinearGradient = function (background) {
        return background.type === CSSImageType.LINEAR_GRADIENT;
    };
    var isRadialGradient = function (background) {
        return background.type === CSSImageType.RADIAL_GRADIENT;
    };
    var CSSRadialShape;
    (function (CSSRadialShape) {
        CSSRadialShape[CSSRadialShape["CIRCLE"] = 0] = "CIRCLE";
        CSSRadialShape[CSSRadialShape["ELLIPSE"] = 1] = "ELLIPSE";
    })(CSSRadialShape || (CSSRadialShape = {}));
    var CSSRadialExtent;
    (function (CSSRadialExtent) {
        CSSRadialExtent[CSSRadialExtent["CLOSEST_SIDE"] = 0] = "CLOSEST_SIDE";
        CSSRadialExtent[CSSRadialExtent["FARTHEST_SIDE"] = 1] = "FARTHEST_SIDE";
        CSSRadialExtent[CSSRadialExtent["CLOSEST_CORNER"] = 2] = "CLOSEST_CORNER";
        CSSRadialExtent[CSSRadialExtent["FARTHEST_CORNER"] = 3] = "FARTHEST_CORNER";
    })(CSSRadialExtent || (CSSRadialExtent = {}));
    var image = {
        name: 'image',
        parse: function (value) {
            if (value.type === TokenType.URL_TOKEN) {
                var image_1 = { url: value.value, type: CSSImageType.URL };
                CacheStorage.getInstance().addImage(value.value);
                return image_1;
            }
            if (value.type === TokenType.FUNCTION) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                }
                return imageFunction(value.values);
            }
            throw new Error("Unsupported image type");
        }
    };
    function isSupportedImage(value) {
        return value.type !== TokenType.FUNCTION || SUPPORTED_IMAGE_FUNCTIONS[value.name];
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };

    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
                return [];
            }
            return tokens.filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); }).map(image.parse);
        }
    };

    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) { return values.filter(isLengthPercentage); })
                .map(parseLengthPercentageTuple);
        }
    };

    var BACKGROUND_REPEAT;
    (function (BACKGROUND_REPEAT) {
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT"] = 0] = "REPEAT";
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["NO_REPEAT"] = 1] = "NO_REPEAT";
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT_X"] = 2] = "REPEAT_X";
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT_Y"] = 3] = "REPEAT_Y";
    })(BACKGROUND_REPEAT || (BACKGROUND_REPEAT = {}));
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) {
                return values
                    .filter(isIdentToken)
                    .map(function (token) { return token.value; })
                    .join(' ');
            })
                .map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function (value) {
        switch (value) {
            case 'no-repeat':
                return BACKGROUND_REPEAT.NO_REPEAT;
            case 'repeat-x':
            case 'repeat no-repeat':
                return BACKGROUND_REPEAT.REPEAT_X;
            case 'repeat-y':
            case 'no-repeat repeat':
                return BACKGROUND_REPEAT.REPEAT_Y;
            case 'repeat':
            default:
                return BACKGROUND_REPEAT.REPEAT;
        }
    };

    var BACKGROUND_SIZE;
    (function (BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return parseFunctionArgs(tokens).map(function (values) { return values.filter(isBackgroundSizeInfoToken); });
        }
    };
    var isBackgroundSizeInfoToken = function (value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };

    var borderColorForSide = function (side) { return ({
        name: "border-" + side + "-color",
        initialValue: 'transparent',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    }); };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');

    var borderRadiusForSide = function (side) { return ({
        name: "border-radius-" + side,
        initialValue: '0 0',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) { return parseLengthPercentageTuple(tokens.filter(isLengthPercentage)); }
    }); };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');

    var BORDER_STYLE;
    (function (BORDER_STYLE) {
        BORDER_STYLE[BORDER_STYLE["NONE"] = 0] = "NONE";
        BORDER_STYLE[BORDER_STYLE["SOLID"] = 1] = "SOLID";
    })(BORDER_STYLE || (BORDER_STYLE = {}));
    var borderStyleForSide = function (side) { return ({
        name: "border-" + side + "-style",
        initialValue: 'solid',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (style) {
            switch (style) {
                case 'none':
                    return BORDER_STYLE.NONE;
            }
            return BORDER_STYLE.SOLID;
        }
    }); };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');

    var borderWidthForSide = function (side) { return ({
        name: "border-" + side + "-width",
        initialValue: '0',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    }); };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');

    var color$1 = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    };

    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.filter(isIdentToken).reduce(function (bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */);
        }
    };
    var parseDisplayValue = function (display) {
        switch (display) {
            case 'block':
                return 2 /* BLOCK */;
            case 'inline':
                return 4 /* INLINE */;
            case 'run-in':
                return 8 /* RUN_IN */;
            case 'flow':
                return 16 /* FLOW */;
            case 'flow-root':
                return 32 /* FLOW_ROOT */;
            case 'table':
                return 64 /* TABLE */;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */;
            case 'ruby':
                return 512 /* RUBY */;
            case 'subgrid':
                return 1024 /* SUBGRID */;
            case 'list-item':
                return 2048 /* LIST_ITEM */;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */;
            case 'table-row':
                return 32768 /* TABLE_ROW */;
            case 'table-cell':
                return 65536 /* TABLE_CELL */;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */;
            case 'contents':
                return 16777216 /* CONTENTS */;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */;
        }
        return 0 /* NONE */;
    };

    var FLOAT;
    (function (FLOAT) {
        FLOAT[FLOAT["NONE"] = 0] = "NONE";
        FLOAT[FLOAT["LEFT"] = 1] = "LEFT";
        FLOAT[FLOAT["RIGHT"] = 2] = "RIGHT";
        FLOAT[FLOAT["INLINE_START"] = 3] = "INLINE_START";
        FLOAT[FLOAT["INLINE_END"] = 4] = "INLINE_END";
    })(FLOAT || (FLOAT = {}));
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (float) {
            switch (float) {
                case 'left':
                    return FLOAT.LEFT;
                case 'right':
                    return FLOAT.RIGHT;
                case 'inline-start':
                    return FLOAT.INLINE_START;
                case 'inline-end':
                    return FLOAT.INLINE_END;
            }
            return FLOAT.NONE;
        }
    };

    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.VALUE,
        parse: function (token) {
            if (token.type === TokenType.IDENT_TOKEN && token.value === 'normal') {
                return 0;
            }
            if (token.type === TokenType.NUMBER_TOKEN) {
                return token.number;
            }
            if (token.type === TokenType.DIMENSION_TOKEN) {
                return token.number;
            }
            return 0;
        }
    };

    var LINE_BREAK;
    (function (LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (lineBreak) {
            switch (lineBreak) {
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };

    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.TOKEN_VALUE
    };
    var computeLineHeight = function (token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') {
            return 1.2 * fontSize;
        }
        else if (token.type === TokenType.NUMBER_TOKEN) {
            return fontSize * token.number;
        }
        else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize);
        }
        return fontSize;
    };

    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (token.type === TokenType.IDENT_TOKEN && token.value === 'none') {
                return null;
            }
            return image.parse(token);
        }
    };

    var LIST_STYLE_POSITION;
    (function (LIST_STYLE_POSITION) {
        LIST_STYLE_POSITION[LIST_STYLE_POSITION["INSIDE"] = 0] = "INSIDE";
        LIST_STYLE_POSITION[LIST_STYLE_POSITION["OUTSIDE"] = 1] = "OUTSIDE";
    })(LIST_STYLE_POSITION || (LIST_STYLE_POSITION = {}));
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (position) {
            switch (position) {
                case 'inside':
                    return LIST_STYLE_POSITION.INSIDE;
                case 'outside':
                default:
                    return LIST_STYLE_POSITION.OUTSIDE;
            }
        }
    };

    var LIST_STYLE_TYPE;
    (function (LIST_STYLE_TYPE) {
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["NONE"] = -1] = "NONE";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISC"] = 0] = "DISC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CIRCLE"] = 1] = "CIRCLE";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SQUARE"] = 2] = "SQUARE";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DECIMAL"] = 3] = "DECIMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_DECIMAL"] = 4] = "CJK_DECIMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DECIMAL_LEADING_ZERO"] = 5] = "DECIMAL_LEADING_ZERO";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ROMAN"] = 6] = "LOWER_ROMAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ROMAN"] = 7] = "UPPER_ROMAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_GREEK"] = 8] = "LOWER_GREEK";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ALPHA"] = 9] = "LOWER_ALPHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ALPHA"] = 10] = "UPPER_ALPHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ARABIC_INDIC"] = 11] = "ARABIC_INDIC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ARMENIAN"] = 12] = "ARMENIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["BENGALI"] = 13] = "BENGALI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CAMBODIAN"] = 14] = "CAMBODIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_EARTHLY_BRANCH"] = 15] = "CJK_EARTHLY_BRANCH";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_HEAVENLY_STEM"] = 16] = "CJK_HEAVENLY_STEM";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_IDEOGRAPHIC"] = 17] = "CJK_IDEOGRAPHIC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DEVANAGARI"] = 18] = "DEVANAGARI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ETHIOPIC_NUMERIC"] = 19] = "ETHIOPIC_NUMERIC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GEORGIAN"] = 20] = "GEORGIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GUJARATI"] = 21] = "GUJARATI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GURMUKHI"] = 22] = "GURMUKHI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HEBREW"] = 22] = "HEBREW";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HIRAGANA"] = 23] = "HIRAGANA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HIRAGANA_IROHA"] = 24] = "HIRAGANA_IROHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["JAPANESE_FORMAL"] = 25] = "JAPANESE_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["JAPANESE_INFORMAL"] = 26] = "JAPANESE_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KANNADA"] = 27] = "KANNADA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KATAKANA"] = 28] = "KATAKANA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KATAKANA_IROHA"] = 29] = "KATAKANA_IROHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KHMER"] = 30] = "KHMER";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANGUL_FORMAL"] = 31] = "KOREAN_HANGUL_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANJA_FORMAL"] = 32] = "KOREAN_HANJA_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANJA_INFORMAL"] = 33] = "KOREAN_HANJA_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LAO"] = 34] = "LAO";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ARMENIAN"] = 35] = "LOWER_ARMENIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MALAYALAM"] = 36] = "MALAYALAM";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MONGOLIAN"] = 37] = "MONGOLIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MYANMAR"] = 38] = "MYANMAR";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ORIYA"] = 39] = "ORIYA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["PERSIAN"] = 40] = "PERSIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SIMP_CHINESE_FORMAL"] = 41] = "SIMP_CHINESE_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SIMP_CHINESE_INFORMAL"] = 42] = "SIMP_CHINESE_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TAMIL"] = 43] = "TAMIL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TELUGU"] = 44] = "TELUGU";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["THAI"] = 45] = "THAI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TIBETAN"] = 46] = "TIBETAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TRAD_CHINESE_FORMAL"] = 47] = "TRAD_CHINESE_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TRAD_CHINESE_INFORMAL"] = 48] = "TRAD_CHINESE_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ARMENIAN"] = 49] = "UPPER_ARMENIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISCLOSURE_OPEN"] = 50] = "DISCLOSURE_OPEN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISCLOSURE_CLOSED"] = 51] = "DISCLOSURE_CLOSED";
    })(LIST_STYLE_TYPE || (LIST_STYLE_TYPE = {}));
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (type) {
            switch (type) {
                case 'disc':
                    return LIST_STYLE_TYPE.DISC;
                case 'circle':
                    return LIST_STYLE_TYPE.CIRCLE;
                case 'square':
                    return LIST_STYLE_TYPE.SQUARE;
                case 'decimal':
                    return LIST_STYLE_TYPE.DECIMAL;
                case 'cjk-decimal':
                    return LIST_STYLE_TYPE.CJK_DECIMAL;
                case 'decimal-leading-zero':
                    return LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO;
                case 'lower-roman':
                    return LIST_STYLE_TYPE.LOWER_ROMAN;
                case 'upper-roman':
                    return LIST_STYLE_TYPE.UPPER_ROMAN;
                case 'lower-greek':
                    return LIST_STYLE_TYPE.LOWER_GREEK;
                case 'lower-alpha':
                    return LIST_STYLE_TYPE.LOWER_ALPHA;
                case 'upper-alpha':
                    return LIST_STYLE_TYPE.UPPER_ALPHA;
                case 'arabic-indic':
                    return LIST_STYLE_TYPE.ARABIC_INDIC;
                case 'armenian':
                    return LIST_STYLE_TYPE.ARMENIAN;
                case 'bengali':
                    return LIST_STYLE_TYPE.BENGALI;
                case 'cambodian':
                    return LIST_STYLE_TYPE.CAMBODIAN;
                case 'cjk-earthly-branch':
                    return LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH;
                case 'cjk-heavenly-stem':
                    return LIST_STYLE_TYPE.CJK_HEAVENLY_STEM;
                case 'cjk-ideographic':
                    return LIST_STYLE_TYPE.CJK_IDEOGRAPHIC;
                case 'devanagari':
                    return LIST_STYLE_TYPE.DEVANAGARI;
                case 'ethiopic-numeric':
                    return LIST_STYLE_TYPE.ETHIOPIC_NUMERIC;
                case 'georgian':
                    return LIST_STYLE_TYPE.GEORGIAN;
                case 'gujarati':
                    return LIST_STYLE_TYPE.GUJARATI;
                case 'gurmukhi':
                    return LIST_STYLE_TYPE.GURMUKHI;
                case 'hebrew':
                    return LIST_STYLE_TYPE.HEBREW;
                case 'hiragana':
                    return LIST_STYLE_TYPE.HIRAGANA;
                case 'hiragana-iroha':
                    return LIST_STYLE_TYPE.HIRAGANA_IROHA;
                case 'japanese-formal':
                    return LIST_STYLE_TYPE.JAPANESE_FORMAL;
                case 'japanese-informal':
                    return LIST_STYLE_TYPE.JAPANESE_INFORMAL;
                case 'kannada':
                    return LIST_STYLE_TYPE.KANNADA;
                case 'katakana':
                    return LIST_STYLE_TYPE.KATAKANA;
                case 'katakana-iroha':
                    return LIST_STYLE_TYPE.KATAKANA_IROHA;
                case 'khmer':
                    return LIST_STYLE_TYPE.KHMER;
                case 'korean-hangul-formal':
                    return LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL;
                case 'korean-hanja-formal':
                    return LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL;
                case 'korean-hanja-informal':
                    return LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL;
                case 'lao':
                    return LIST_STYLE_TYPE.LAO;
                case 'lower-armenian':
                    return LIST_STYLE_TYPE.LOWER_ARMENIAN;
                case 'malayalam':
                    return LIST_STYLE_TYPE.MALAYALAM;
                case 'mongolian':
                    return LIST_STYLE_TYPE.MONGOLIAN;
                case 'myanmar':
                    return LIST_STYLE_TYPE.MYANMAR;
                case 'oriya':
                    return LIST_STYLE_TYPE.ORIYA;
                case 'persian':
                    return LIST_STYLE_TYPE.PERSIAN;
                case 'simp-chinese-formal':
                    return LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL;
                case 'simp-chinese-informal':
                    return LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL;
                case 'tamil':
                    return LIST_STYLE_TYPE.TAMIL;
                case 'telugu':
                    return LIST_STYLE_TYPE.TELUGU;
                case 'thai':
                    return LIST_STYLE_TYPE.THAI;
                case 'tibetan':
                    return LIST_STYLE_TYPE.TIBETAN;
                case 'trad-chinese-formal':
                    return LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL;
                case 'trad-chinese-informal':
                    return LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL;
                case 'upper-armenian':
                    return LIST_STYLE_TYPE.UPPER_ARMENIAN;
                case 'disclosure-open':
                    return LIST_STYLE_TYPE.DISCLOSURE_OPEN;
                case 'disclosure-closed':
                    return LIST_STYLE_TYPE.DISCLOSURE_CLOSED;
                case 'none':
                default:
                    return LIST_STYLE_TYPE.NONE;
            }
        }
    };

    var marginForSide = function (side) { return ({
        name: "margin-" + side,
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.TOKEN_VALUE
    }); };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');

    var OVERFLOW;
    (function (OVERFLOW) {
        OVERFLOW[OVERFLOW["VISIBLE"] = 0] = "VISIBLE";
        OVERFLOW[OVERFLOW["HIDDEN"] = 1] = "HIDDEN";
        OVERFLOW[OVERFLOW["SCROLL"] = 2] = "SCROLL";
        OVERFLOW[OVERFLOW["AUTO"] = 3] = "AUTO";
    })(OVERFLOW || (OVERFLOW = {}));
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.filter(isIdentToken).map(function (overflow) {
                switch (overflow.value) {
                    case 'hidden':
                        return OVERFLOW.HIDDEN;
                    case 'scroll':
                        return OVERFLOW.SCROLL;
                    case 'auto':
                        return OVERFLOW.AUTO;
                    case 'visible':
                    default:
                        return OVERFLOW.VISIBLE;
                }
            });
        }
    };

    var OVERFLOW_WRAP;
    (function (OVERFLOW_WRAP) {
        OVERFLOW_WRAP["NORMAL"] = "normal";
        OVERFLOW_WRAP["BREAK_WORD"] = "break-word";
    })(OVERFLOW_WRAP || (OVERFLOW_WRAP = {}));
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (overflow) {
            switch (overflow) {
                case 'break-word':
                    return OVERFLOW_WRAP.BREAK_WORD;
                case 'normal':
                default:
                    return OVERFLOW_WRAP.NORMAL;
            }
        }
    };

    var paddingForSide = function (side) { return ({
        name: "padding-" + side,
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'length-percentage'
    }); };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');

    var TEXT_ALIGN;
    (function (TEXT_ALIGN) {
        TEXT_ALIGN[TEXT_ALIGN["LEFT"] = 0] = "LEFT";
        TEXT_ALIGN[TEXT_ALIGN["CENTER"] = 1] = "CENTER";
        TEXT_ALIGN[TEXT_ALIGN["RIGHT"] = 2] = "RIGHT";
    })(TEXT_ALIGN || (TEXT_ALIGN = {}));
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (textAlign) {
            switch (textAlign) {
                case 'right':
                    return TEXT_ALIGN.RIGHT;
                case 'center':
                case 'justify':
                    return TEXT_ALIGN.CENTER;
                case 'left':
                default:
                    return TEXT_ALIGN.LEFT;
            }
        }
    };

    var POSITION;
    (function (POSITION) {
        POSITION[POSITION["STATIC"] = 0] = "STATIC";
        POSITION[POSITION["RELATIVE"] = 1] = "RELATIVE";
        POSITION[POSITION["ABSOLUTE"] = 2] = "ABSOLUTE";
        POSITION[POSITION["FIXED"] = 3] = "FIXED";
        POSITION[POSITION["STICKY"] = 4] = "STICKY";
    })(POSITION || (POSITION = {}));
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (position) {
            switch (position) {
                case 'relative':
                    return POSITION.RELATIVE;
                case 'absolute':
                    return POSITION.ABSOLUTE;
                case 'fixed':
                    return POSITION.FIXED;
                case 'sticky':
                    return POSITION.STICKY;
            }
            return POSITION.STATIC;
        }
    };

    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else {
                            shadow.blur = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color.parse(token);
                    }
                }
                return shadow;
            });
        }
    };

    var TEXT_TRANSFORM;
    (function (TEXT_TRANSFORM) {
        TEXT_TRANSFORM[TEXT_TRANSFORM["NONE"] = 0] = "NONE";
        TEXT_TRANSFORM[TEXT_TRANSFORM["LOWERCASE"] = 1] = "LOWERCASE";
        TEXT_TRANSFORM[TEXT_TRANSFORM["UPPERCASE"] = 2] = "UPPERCASE";
        TEXT_TRANSFORM[TEXT_TRANSFORM["CAPITALIZE"] = 3] = "CAPITALIZE";
    })(TEXT_TRANSFORM || (TEXT_TRANSFORM = {}));
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (textTransform) {
            switch (textTransform) {
                case 'uppercase':
                    return TEXT_TRANSFORM.UPPERCASE;
                case 'lowercase':
                    return TEXT_TRANSFORM.LOWERCASE;
                case 'capitalize':
                    return TEXT_TRANSFORM.CAPITALIZE;
            }
            return TEXT_TRANSFORM.NONE;
        }
    };

    var transform = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: PropertyDescriptorParsingType.VALUE,
        parse: function (token) {
            if (token.type === TokenType.IDENT_TOKEN && token.value === 'none') {
                return null;
            }
            if (token.type === TokenType.FUNCTION) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                }
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function (args) {
        var values = args.filter(function (arg) { return arg.type === TokenType.NUMBER_TOKEN; }).map(function (arg) { return arg.number; });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function (args) {
        var values = args.filter(function (arg) { return arg.type === TokenType.NUMBER_TOKEN; }).map(function (arg) { return arg.number; });
        var a1 = values[0], b1 = values[1], _a = values[2], _b = values[3], a2 = values[4], b2 = values[5], _c = values[6], _d = values[7], _e = values[8], _f = values[9], _g = values[10], _h = values[11], a4 = values[12], b4 = values[13], _j = values[14], _k = values[15];
        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };

    var DEFAULT_VALUE = {
        type: TokenType.PERCENTAGE_TOKEN,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
                return DEFAULT;
            }
            return [origins[0], origins[1]];
        }
    };

    var VISIBILITY;
    (function (VISIBILITY) {
        VISIBILITY[VISIBILITY["VISIBLE"] = 0] = "VISIBLE";
        VISIBILITY[VISIBILITY["HIDDEN"] = 1] = "HIDDEN";
        VISIBILITY[VISIBILITY["COLLAPSE"] = 2] = "COLLAPSE";
    })(VISIBILITY || (VISIBILITY = {}));
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (visibility) {
            switch (visibility) {
                case 'hidden':
                    return VISIBILITY.HIDDEN;
                case 'collapse':
                    return VISIBILITY.COLLAPSE;
                case 'visible':
                default:
                    return VISIBILITY.VISIBLE;
            }
        }
    };

    var WORD_BREAK;
    (function (WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (wordBreak) {
            switch (wordBreak) {
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };

    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: PropertyDescriptorParsingType.VALUE,
        parse: function (token) {
            if (token.type === TokenType.IDENT_TOKEN) {
                return { auto: true, order: 0 };
            }
            if (isNumberToken(token)) {
                return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
        }
    };

    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            return 1;
        }
    };

    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    };

    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens
                .filter(isIdentToken)
                .map(function (token) {
                switch (token.value) {
                    case 'underline':
                        return 1 /* UNDERLINE */;
                    case 'overline':
                        return 2 /* OVERLINE */;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */;
                    case 'none':
                        return 4 /* BLINK */;
                }
                return 0 /* NONE */;
            })
                .filter(function (line) { return line !== 0 /* NONE */; });
        }
    };

    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.filter(isStringToken$1).map(function (token) { return token.value; });
        }
    };
    var isStringToken$1 = function (token) {
        return token.type === TokenType.STRING_TOKEN || token.type === TokenType.IDENT_TOKEN;
    };

    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'length'
    };

    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            if (isIdentToken(token)) {
                switch (token.value) {
                    case 'bold':
                        return 700;
                    case 'normal':
                    default:
                        return 400;
                }
            }
            return 400;
        }
    };

    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            return tokens.filter(isIdentToken).map(function (token) { return token.value; });
        }
    };

    var FONT_STYLE;
    (function (FONT_STYLE) {
        FONT_STYLE["NORMAL"] = "normal";
        FONT_STYLE["ITALIC"] = "italic";
        FONT_STYLE["OBLIQUE"] = "oblique";
    })(FONT_STYLE || (FONT_STYLE = {}));
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (overflow) {
            switch (overflow) {
                case 'oblique':
                    return FONT_STYLE.OBLIQUE;
                case 'italic':
                    return FONT_STYLE.ITALIC;
                case 'normal':
                default:
                    return FONT_STYLE.NORMAL;
            }
        }
    };

    var contains = function (bit, value) { return (bit & value) !== 0; };

    var content = {
        name: 'content',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
                return [];
            }
            return tokens;
        }
    };

    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
                return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === TokenType.IDENT_TOKEN) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({ counter: counter.value, increment: increment });
                }
            }
            return increments;
        }
    };

    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({ counter: counter.value, reset: reset });
                }
            }
            return resets;
        }
    };

    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
                return null;
            }
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
                return null;
            }
            for (var i = 0; i < filtered.length; i += 2) {
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({ open: open_1, close: close_1 });
            }
            return quotes;
        }
    };
    var getQuote = function (quotes, depth, open) {
        if (!quotes) {
            return '';
        }
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) {
            return '';
        }
        return open ? quote.open : quote.close;
    };

    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) {
                        shadow.inset = true;
                    }
                    else if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else if (c === 2) {
                            shadow.blur = token;
                        }
                        else {
                            shadow.spread = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color.parse(token);
                    }
                }
                return shadow;
            });
        }
    };

    var CSSParsedDeclaration = /** @class */ (function () {
        function CSSParsedDeclaration(declaration) {
            this.backgroundClip = parse(backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(boxShadow, declaration.boxShadow);
            this.color = parse(color$1, declaration.color);
            this.display = parse(display, declaration.display);
            this.float = parse(float, declaration.cssFloat);
            this.fontFamily = parse(fontFamily, declaration.fontFamily);
            this.fontSize = parse(fontSize, declaration.fontSize);
            this.fontStyle = parse(fontStyle, declaration.fontStyle);
            this.fontVariant = parse(fontVariant, declaration.fontVariant);
            this.fontWeight = parse(fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(lineBreak, declaration.lineBreak);
            this.lineHeight = parse(lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(listStyleType, declaration.listStyleType);
            this.marginTop = parse(marginTop, declaration.marginTop);
            this.marginRight = parse(marginRight, declaration.marginRight);
            this.marginBottom = parse(marginBottom, declaration.marginBottom);
            this.marginLeft = parse(marginLeft, declaration.marginLeft);
            this.opacity = parse(opacity, declaration.opacity);
            var overflowTuple = parse(overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(paddingTop, declaration.paddingTop);
            this.paddingRight = parse(paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(paddingLeft, declaration.paddingLeft);
            this.position = parse(position, declaration.position);
            this.textAlign = parse(textAlign, declaration.textAlign);
            this.textDecorationColor = parse(textDecorationColor, declaration.textDecorationColor || declaration.color);
            this.textDecorationLine = parse(textDecorationLine, declaration.textDecorationLine);
            this.textShadow = parse(textShadow, declaration.textShadow);
            this.textTransform = parse(textTransform, declaration.textTransform);
            this.transform = parse(transform, declaration.transform);
            this.transformOrigin = parse(transformOrigin, declaration.transformOrigin);
            this.visibility = parse(visibility, declaration.visibility);
            this.wordBreak = parse(wordBreak, declaration.wordBreak);
            this.zIndex = parse(zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function () {
            return this.display > 0 && this.opacity > 0 && this.visibility === VISIBILITY.VISIBLE;
        };
        CSSParsedDeclaration.prototype.isTransparent = function () {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function () {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function () {
            return this.position !== POSITION.STATIC;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function () {
            return this.float !== FLOAT.NONE;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function () {
            return (contains(this.display, 4 /* INLINE */) ||
                contains(this.display, 33554432 /* INLINE_BLOCK */) ||
                contains(this.display, 268435456 /* INLINE_FLEX */) ||
                contains(this.display, 536870912 /* INLINE_GRID */) ||
                contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
                contains(this.display, 134217728 /* INLINE_TABLE */));
        };
        return CSSParsedDeclaration;
    }());
    var CSSParsedPseudoDeclaration = /** @class */ (function () {
        function CSSParsedPseudoDeclaration(declaration) {
            this.content = parse(content, declaration.content);
            this.quotes = parse(quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }());
    var CSSParsedCounterDeclaration = /** @class */ (function () {
        function CSSParsedCounterDeclaration(declaration) {
            this.counterIncrement = parse(counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function (descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch (descriptor.type) {
            case PropertyDescriptorParsingType.IDENT_VALUE:
                var token = parser.parseComponentValue();
                return descriptor.parse(isIdentToken(token) ? token.value : descriptor.initialValue);
            case PropertyDescriptorParsingType.VALUE:
                return descriptor.parse(parser.parseComponentValue());
            case PropertyDescriptorParsingType.LIST:
                return descriptor.parse(parser.parseComponentValues());
            case PropertyDescriptorParsingType.TOKEN_VALUE:
                return parser.parseComponentValue();
            case PropertyDescriptorParsingType.TYPE_VALUE:
                switch (descriptor.format) {
                    case 'angle':
                        return angle.parse(parser.parseComponentValue());
                    case 'color':
                        return color.parse(parser.parseComponentValue());
                    case 'image':
                        return image.parse(parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                }
        }
        throw new Error("Attempting to parse unsupported css format type " + descriptor.format);
    };

    var ElementContainer = /** @class */ (function () {
        function ElementContainer(element) {
            this.styles = new CSSParsedDeclaration(window.getComputedStyle(element, null));
            this.textNodes = [];
            this.elements = [];
            if (this.styles.transform !== null && isHTMLElementNode(element)) {
                // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(element);
            this.flags = 0;
        }
        return ElementContainer;
    }());

    var TextBounds = /** @class */ (function () {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }());
    var parseTextBounds = function (value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function (text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    textBounds.push(new TextBounds(text, getRangeBounds(node, offset, text.length)));
                }
                else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(node)));
                    node = replacementNode;
                }
            }
            else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
                node = node.splitText(text.length);
            }
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function (node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(wrapper);
                if (wrapper.firstChild) {
                    parentNode.replaceChild(wrapper.firstChild, wrapper);
                }
                return bounds;
            }
        }
        return new Bounds(0, 0, 0, 0);
    };
    var getRangeBounds = function (node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) {
            throw new Error('Node has no owner document');
        }
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return Bounds.fromClientRect(range.getBoundingClientRect());
    };
    var breakText = function (value, styles) {
        return styles.letterSpacing !== 0 ? toCodePoints(value).map(function (i) { return fromCodePoint(i); }) : breakWords(value, styles);
    };
    var breakWords = function (str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === OVERFLOW_WRAP.BREAK_WORD ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        while (!(bk = breaker.next()).done) {
            if (bk.value) {
                words.push(bk.value.slice());
            }
        }
        return words;
    };

    var TextContainer = /** @class */ (function () {
        function TextContainer(node, styles) {
            this.text = transform$1(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(this.text, styles, node);
        }
        return TextContainer;
    }());
    var transform$1 = function (text, transform) {
        switch (transform) {
            case TEXT_TRANSFORM.LOWERCASE:
                return text.toLowerCase();
            case TEXT_TRANSFORM.CAPITALIZE:
                return text.replace(CAPITALIZE, capitalize);
            case TEXT_TRANSFORM.UPPERCASE:
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function (m, p1, p2) {
        if (m.length > 0) {
            return p1 + p2.toUpperCase();
        }
        return m;
    };

    var ImageElementContainer = /** @class */ (function (_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(img) {
            var _this = _super.call(this, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            CacheStorage.getInstance().addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer));

    var CanvasElementContainer = /** @class */ (function (_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(canvas) {
            var _this = _super.call(this, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer));

    var SVGElementContainer = /** @class */ (function (_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(img) {
            var _this = _super.call(this, img) || this;
            var s = new XMLSerializer();
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            CacheStorage.getInstance().addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer));

    var LIElementContainer = /** @class */ (function (_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(element) {
            var _this = _super.call(this, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer));

    var OLElementContainer = /** @class */ (function (_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(element) {
            var _this = _super.call(this, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer));

    var CHECKBOX_BORDER_RADIUS = [
        {
            type: TokenType.DIMENSION_TOKEN,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: TokenType.PERCENTAGE_TOKEN,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function (bounds) {
        if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        }
        else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        }
        return bounds;
    };
    var getInputValue = function (node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ (function (_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(input) {
            var _this = _super.call(this, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle =
                    BORDER_STYLE.SOLID;
                _this.styles.backgroundClip = [BACKGROUND_CLIP.BORDER_BOX];
                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch (_this.type) {
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer));

    var SelectElementContainer = /** @class */ (function (_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(element) {
            var _this = _super.call(this, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer));

    var TextareaElementContainer = /** @class */ (function (_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(element) {
            var _this = _super.call(this, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer));

    var parseColor = function (value) { return color.parse(Parser.create(value).parseComponentValue()); };
    var IFrameElementContainer = /** @class */ (function (_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(iframe) {
            var _this = _super.call(this, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow &&
                    iframe.contentWindow.document &&
                    iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement
                        ? parseColor(getComputedStyle(iframe.contentWindow.document.documentElement)
                            .backgroundColor)
                        : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body
                        ? parseColor(getComputedStyle(iframe.contentWindow.document.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor)
                        ? isTransparent(bodyBackgroundColor)
                            ? _this.styles.backgroundColor
                            : bodyBackgroundColor
                        : documentBackgroundColor;
                }
            }
            catch (e) { }
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer));

    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
    var parseNodeTree = function (node, parent, root) {
        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
                parent.textNodes.push(new TextContainer(childNode, parent.styles));
            }
            else if (isElementNode(childNode)) {
                var container = createContainer(childNode);
                if (container.styles.isVisible()) {
                    if (createsRealStackingContext(childNode, container, root)) {
                        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
                    }
                    else if (createsStackingContext(container.styles)) {
                        container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
                    }
                    if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                        container.flags |= 8 /* IS_LIST_OWNER */;
                    }
                    parent.elements.push(container);
                    if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) {
                        parseNodeTree(childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function (element) {
        if (isImageElement(element)) {
            return new ImageElementContainer(element);
        }
        if (isCanvasElement(element)) {
            return new CanvasElementContainer(element);
        }
        if (isSVGElement(element)) {
            return new SVGElementContainer(element);
        }
        if (isLIElement(element)) {
            return new LIElementContainer(element);
        }
        if (isOLElement(element)) {
            return new OLElementContainer(element);
        }
        if (isInputElement(element)) {
            return new InputElementContainer(element);
        }
        if (isSelectElement(element)) {
            return new SelectElementContainer(element);
        }
        if (isTextareaElement(element)) {
            return new TextareaElementContainer(element);
        }
        if (isIFrameElement(element)) {
            return new IFrameElementContainer(element);
        }
        return new ElementContainer(element);
    };
    var parseTree = function (element) {
        var container = createContainer(element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
        parseNodeTree(element, container, container);
        return container;
    };
    var createsRealStackingContext = function (node, container, root) {
        return (container.styles.isPositionedWithZIndex() ||
            container.styles.opacity < 1 ||
            container.styles.isTransformed() ||
            (isBodyElement(node) && root.styles.isTransparent()));
    };
    var createsStackingContext = function (styles) { return styles.isPositioned() || styles.isFloating(); };
    var isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    var isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    var isHTMLElementNode = function (node) {
        return typeof node.style !== 'undefined';
    };
    var isLIElement = function (node) { return node.tagName === 'LI'; };
    var isOLElement = function (node) { return node.tagName === 'OL'; };
    var isInputElement = function (node) { return node.tagName === 'INPUT'; };
    var isHTMLElement = function (node) { return node.tagName === 'HTML'; };
    var isSVGElement = function (node) { return node.tagName === 'svg'; };
    var isBodyElement = function (node) { return node.tagName === 'BODY'; };
    var isCanvasElement = function (node) { return node.tagName === 'CANVAS'; };
    var isImageElement = function (node) { return node.tagName === 'IMG'; };
    var isIFrameElement = function (node) { return node.tagName === 'IFRAME'; };
    var isStyleElement = function (node) { return node.tagName === 'STYLE'; };
    var isScriptElement = function (node) { return node.tagName === 'SCRIPT'; };
    var isTextareaElement = function (node) { return node.tagName === 'TEXTAREA'; };
    var isSelectElement = function (node) { return node.tagName === 'SELECT'; };

    var CounterState = /** @class */ (function () {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function (name) {
            var counter = this.counters[name];
            if (counter && counter.length) {
                return counter[counter.length - 1];
            }
            return 1;
        };
        CounterState.prototype.getCounterValues = function (name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function (counters) {
            var _this = this;
            counters.forEach(function (counter) { return _this.counters[counter].pop(); });
        };
        CounterState.prototype.parse = function (style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) {
                counterIncrement.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    if (counter && entry.increment !== 0) {
                        canReset = false;
                        counter[Math.max(0, counter.length - 1)] += entry.increment;
                    }
                });
            }
            var counterNames = [];
            if (canReset) {
                counterReset.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    counterNames.push(entry.counter);
                    if (!counter) {
                        counter = _this.counters[entry.counter] = [];
                    }
                    counter.push(entry.reset);
                });
            }
            return counterNames;
        };
        return CounterState;
    }());
    var ROMAN_UPPER = {
        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            'Ք',
            'Փ',
            'Ւ',
            'Ց',
            'Ր',
            'Տ',
            'Վ',
            'Ս',
            'Ռ',
            'Ջ',
            'Պ',
            'Չ',
            'Ո',
            'Շ',
            'Ն',
            'Յ',
            'Մ',
            'Ճ',
            'Ղ',
            'Ձ',
            'Հ',
            'Կ',
            'Ծ',
            'Խ',
            'Լ',
            'Ի',
            'Ժ',
            'Թ',
            'Ը',
            'Է',
            'Զ',
            'Ե',
            'Դ',
            'Գ',
            'Բ',
            'Ա'
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            'י׳',
            'ט׳',
            'ח׳',
            'ז׳',
            'ו׳',
            'ה׳',
            'ד׳',
            'ג׳',
            'ב׳',
            'א׳',
            'ת',
            'ש',
            'ר',
            'ק',
            'צ',
            'פ',
            'ע',
            'ס',
            'נ',
            'מ',
            'ל',
            'כ',
            'יט',
            'יח',
            'יז',
            'טז',
            'טו',
            'י',
            'ט',
            'ח',
            'ז',
            'ו',
            'ה',
            'ד',
            'ג',
            'ב',
            'א'
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            'ჵ',
            'ჰ',
            'ჯ',
            'ჴ',
            'ხ',
            'ჭ',
            'წ',
            'ძ',
            'ც',
            'ჩ',
            'შ',
            'ყ',
            'ღ',
            'ქ',
            'ფ',
            'ჳ',
            'ტ',
            'ს',
            'რ',
            'ჟ',
            'პ',
            'ო',
            'ჲ',
            'ნ',
            'მ',
            'ლ',
            'კ',
            'ი',
            'თ',
            'ჱ',
            'ზ',
            'ვ',
            'ე',
            'დ',
            'გ',
            'ბ',
            'ა'
        ]
    };
    var createAdditiveCounter = function (value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) {
            return createCounterText(value, fallback, suffix.length > 0);
        }
        return (symbols.integers.reduce(function (string, integer, index) {
            while (value >= integer) {
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix);
    };
    var createCounterStyleWithSymbolResolver = function (value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) {
                value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
        } while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return ((value < 0 ? '-' : '') +
            (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
                return fromCodePoint(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
            }) +
                suffix));
    };
    var createCounterStyleFromSymbols = function (value, symbols, suffix) {
        if (suffix === void 0) { suffix = '. '; }
        var codePointRangeLength = symbols.length;
        return (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) { return symbols[Math.floor(codePoint % codePointRangeLength)]; }) + suffix);
    };
    var CJK_ZEROS = 1 << 0;
    var CJK_TEN_COEFFICIENTS = 1 << 1;
    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
    var createCJKCounter = function (value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) {
            return createCounterText(value, LIST_STYLE_TYPE.CJK_DECIMAL, suffix.length > 0);
        }
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) {
            return numbers[0] + string;
        }
        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
                string = numbers[coefficient] + string;
            }
            else if (coefficient > 1 ||
                (coefficient === 1 && digit === 0) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100) ||
                (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))) {
                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            }
            else if (coefficient === 1 && digit > 0) {
                string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
    var JAPANESE_NEGATIVE = 'マイナス';
    var KOREAN_NEGATIVE = '마이너스';
    var createCounterText = function (value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? '、' : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch (type) {
            case LIST_STYLE_TYPE.DISC:
                return '•' + spaceSuffix;
            case LIST_STYLE_TYPE.CIRCLE:
                return '◦' + spaceSuffix;
            case LIST_STYLE_TYPE.SQUARE:
                return '◾' + spaceSuffix;
            case LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO:
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case LIST_STYLE_TYPE.CJK_DECIMAL:
                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
            case LIST_STYLE_TYPE.LOWER_ROMAN:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
            case LIST_STYLE_TYPE.UPPER_ROMAN:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_GREEK:
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_ALPHA:
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case LIST_STYLE_TYPE.UPPER_ALPHA:
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case LIST_STYLE_TYPE.ARABIC_INDIC:
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case LIST_STYLE_TYPE.ARMENIAN:
            case LIST_STYLE_TYPE.UPPER_ARMENIAN:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_ARMENIAN:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
            case LIST_STYLE_TYPE.BENGALI:
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case LIST_STYLE_TYPE.CAMBODIAN:
            case LIST_STYLE_TYPE.KHMER:
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH:
                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
            case LIST_STYLE_TYPE.CJK_HEAVENLY_STEM:
                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
            case LIST_STYLE_TYPE.CJK_IDEOGRAPHIC:
            case LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL:
                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL:
                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.JAPANESE_INFORMAL:
                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
            case LIST_STYLE_TYPE.JAPANESE_FORMAL:
                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL:
                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL:
                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
            case LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL:
                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.DEVANAGARI:
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case LIST_STYLE_TYPE.GEORGIAN:
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.GUJARATI:
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case LIST_STYLE_TYPE.GURMUKHI:
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case LIST_STYLE_TYPE.HEBREW:
                return createAdditiveCounter(value, 1, 10999, HEBREW, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.HIRAGANA:
                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
            case LIST_STYLE_TYPE.HIRAGANA_IROHA:
                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
            case LIST_STYLE_TYPE.KANNADA:
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case LIST_STYLE_TYPE.KATAKANA:
                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
            case LIST_STYLE_TYPE.KATAKANA_IROHA:
                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
            case LIST_STYLE_TYPE.LAO:
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case LIST_STYLE_TYPE.MONGOLIAN:
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case LIST_STYLE_TYPE.MYANMAR:
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case LIST_STYLE_TYPE.ORIYA:
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case LIST_STYLE_TYPE.PERSIAN:
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case LIST_STYLE_TYPE.TAMIL:
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case LIST_STYLE_TYPE.TELUGU:
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case LIST_STYLE_TYPE.THAI:
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case LIST_STYLE_TYPE.TIBETAN:
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case LIST_STYLE_TYPE.DECIMAL:
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };

    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ (function () {
        function DocumentCloner(element, options) {
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) {
                throw new Error('Cloned element does not have an owner document');
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement);
        }
        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) {
                return Promise.reject("Unable to find iframe window");
            }
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
            var iframeLoad = iframeLoader(iframe).then(function () { return __awaiter(_this, void 0, void 0, function () {
                var onclone;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.scrolledElements.forEach(restoreNodeScroll);
                            if (cloneWindow) {
                                cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
                                    (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                    documentClone.documentElement.style.top = -windowSize.top + 'px';
                                    documentClone.documentElement.style.left = -windowSize.left + 'px';
                                    documentClone.documentElement.style.position = 'absolute';
                                }
                            }
                            onclone = this.options.onclone;
                            if (typeof this.clonedReferenceElement === 'undefined') {
                                return [2 /*return*/, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                            }
                            if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2];
                            return [4 /*yield*/, documentClone.fonts.ready];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (typeof onclone === 'function') {
                                return [2 /*return*/, Promise.resolve()
                                        .then(function () { return onclone(documentClone); })
                                        .then(function () { return iframe; })];
                            }
                            return [2 /*return*/, iframe];
                    }
                });
            }); });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function (node) {
            if (isCanvasElement(node)) {
                return this.createCanvasClone(node);
            }
            /*
            if (isIFrameElement(node)) {
                return this.createIFrameClone(node);
            }
    */
            if (isStyleElement(node)) {
                return this.createStyleClone(node);
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createStyleClone = function (node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
                        if (rule && typeof rule.cssText === 'string') {
                            return css + rule.cssText;
                        }
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            }
            catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                Logger.getInstance(this.options.id).error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') {
                    throw e;
                }
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function (canvas) {
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                }
                catch (e) {
                    Logger.getInstance(this.options.id).info("Unable to clone canvas contents, canvas is tainted");
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (ctx) {
                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    }
                    else {
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            }
            catch (e) { }
            return clonedCanvas;
        };
        /*
        createIFrameClone(iframe: HTMLIFrameElement) {
            const tempIframe = <HTMLIFrameElement>iframe.cloneNode(false);
            const iframeKey = generateIframeKey();
            tempIframe.setAttribute('data-html2canvas-internal-iframe-key', iframeKey);

            const {width, height} = parseBounds(iframe);

            this.resourceLoader.cache[iframeKey] = getIframeDocumentElement(iframe, this.options)
                .then(documentElement => {
                    return this.renderer(
                        documentElement,
                        {
                            allowTaint: this.options.allowTaint,
                            backgroundColor: '#ffffff',
                            canvas: null,
                            imageTimeout: this.options.imageTimeout,
                            logging: this.options.logging,
                            proxy: this.options.proxy,
                            removeContainer: this.options.removeContainer,
                            scale: this.options.scale,
                            foreignObjectRendering: this.options.foreignObjectRendering,
                            useCORS: this.options.useCORS,
                            target: new CanvasRenderer(),
                            width,
                            height,
                            x: 0,
                            y: 0,
                            windowWidth: documentElement.ownerDocument.defaultView.innerWidth,
                            windowHeight: documentElement.ownerDocument.defaultView.innerHeight,
                            scrollX: documentElement.ownerDocument.defaultView.pageXOffset,
                            scrollY: documentElement.ownerDocument.defaultView.pageYOffset
                        },
                    );
                })
                .then(
                    (canvas: HTMLCanvasElement) =>
                        new Promise((resolve, reject) => {
                            const iframeCanvas = document.createElement('img');
                            iframeCanvas.onload = () => resolve(canvas);
                            iframeCanvas.onerror = (event) => {
                                // Empty iframes may result in empty "data:," URLs, which are invalid from the <img>'s point of view
                                // and instead of `onload` cause `onerror` and unhandled rejection warnings
                                // https://github.com/niklasvh/html2canvas/issues/1502
                                iframeCanvas.src == 'data:,' ? resolve(canvas) : reject(event);
                            };
                            iframeCanvas.src = canvas.toDataURL();
                            if (tempIframe.parentNode && iframe.ownerDocument && iframe.ownerDocument.defaultView) {
                                tempIframe.parentNode.replaceChild(
                                    copyCSSStyles(
                                        iframe.ownerDocument.defaultView.getComputedStyle(iframe),
                                        iframeCanvas
                                    ),
                                    tempIframe
                                );
                            }
                        })
                );
            return tempIframe;
        }
    */
        DocumentCloner.prototype.cloneNode = function (node) {
            if (isTextNode(node)) {
                return document.createTextNode(node.data);
            }
            if (!node.ownerDocument) {
                return node.cloneNode(false);
            }
            var window = node.ownerDocument.defaultView;
            if (isHTMLElementNode(node) && window) {
                var clone = this.createElementClone(node);
                var style = window.getComputedStyle(node);
                var styleBefore = window.getComputedStyle(node, ':before');
                var styleAfter = window.getComputedStyle(node, ':after');
                if (this.referenceElement === node) {
                    this.clonedReferenceElement = clone;
                }
                if (isBodyElement(clone)) {
                    createPseudoHideStyles(clone);
                }
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                for (var child = node.firstChild; child; child = child.nextSibling) {
                    if (!isElementNode(child) ||
                        (!isScriptElement(child) &&
                            !child.hasAttribute(IGNORE_ATTRIBUTE) &&
                            (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child)))) {
                        if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                            clone.appendChild(this.cloneNode(child));
                        }
                    }
                }
                if (before) {
                    clone.insertBefore(before, clone.firstChild);
                }
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) {
                    clone.appendChild(after);
                }
                this.counters.pop(counters);
                if (style && this.options.copyStyles && !isIFrameElement(node)) {
                    copyCSSStyles(style, clone);
                }
                //this.inlineAllImages(clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                if ((isTextareaElement(node) || isSelectElement(node)) &&
                    (isTextareaElement(clone) || isSelectElement(clone))) {
                    clone.value = node.value;
                }
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) {
                return;
            }
            var value = style.content;
            var document = clone.ownerDocument;
            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
                return;
            }
            this.counters.parse(new CSSParsedCounterDeclaration(style));
            var declaration = new CSSParsedPseudoDeclaration(style);
            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function (token) {
                if (token.type === TokenType.STRING_TOKEN) {
                    anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                }
                else if (token.type === TokenType.URL_TOKEN) {
                    var img = document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                }
                else if (token.type === TokenType.FUNCTION) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) {
                            anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
                        }
                    }
                    else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(counterStyle.value)
                                : LIST_STYLE_TYPE.DECIMAL;
                            anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    }
                    else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(counterStyle.value)
                                : LIST_STYLE_TYPE.DECIMAL;
                            var separator = delim && delim.type === TokenType.STRING_TOKEN ? delim.value : '';
                            var text = counterStates
                                .map(function (value) { return createCounterText(value, counterType_1, false); })
                                .join(separator);
                            anonymousReplacedElement.appendChild(document.createTextNode(text));
                        }
                    }
                }
                else if (token.type === TokenType.IDENT_TOKEN) {
                    switch (token.value) {
                        case 'open-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                            break;
                        case 'close-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                            break;
                        default:
                            // safari doesn't parse string tokens correctly because of lack of quotes
                            anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                    }
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            clone.className +=
                pseudoElt === PseudoElementType.BEFORE
                    ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
                    : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function (container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }());
    var PseudoElementType;
    (function (PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function (ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var iframeLoader = function (iframe) {
        return new Promise(function (resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
                return reject("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = documentClone.onreadystatechange = function () {
                cloneWindow.onload = iframe.onload = documentClone.onreadystatechange = null;
                var interval = setInterval(function () {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var copyCSSStyles = function (style, target) {
        // Edge does not provide value for cssText
        for (var i = style.length - 1; i >= 0; i--) {
            var property = style.item(i);
            // Safari shows pseudoelements if content is set
            if (property !== 'content') {
                target.style.setProperty(property, style.getPropertyValue(property));
            }
        }
        return target;
    };
    var serializeDoctype = function (doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) {
                str += doctype.name;
            }
            if (doctype.internalSubset) {
                str += doctype.internalSubset;
            }
            if (doctype.publicId) {
                str += "\"" + doctype.publicId + "\"";
            }
            if (doctype.systemId) {
                str += "\"" + doctype.systemId + "\"";
            }
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function (ownerDocument, x, y) {
        if (ownerDocument &&
            ownerDocument.defaultView &&
            (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
        }
    };
    var restoreNodeScroll = function (_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function (body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function (body, styles) {
        var document = body.ownerDocument;
        if (document) {
            var style = document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };

    var PathType;
    (function (PathType) {
        PathType[PathType["VECTOR"] = 0] = "VECTOR";
        PathType[PathType["BEZIER_CURVE"] = 1] = "BEZIER_CURVE";
    })(PathType || (PathType = {}));
    var equalPath = function (a, b) {
        if (a.length === b.length) {
            return a.some(function (v, i) { return v === b[i]; });
        }
        return false;
    };
    var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function (point, index) {
            switch (index) {
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };

    var Vector = /** @class */ (function () {
        function Vector(x, y) {
            this.type = PathType.VECTOR;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function (deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }());

    var lerp = function (a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ (function () {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = PathType.BEZIER_CURVE;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function (t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function (deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function () {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }());
    var isBezierCurve = function (path) { return path.type === PathType.BEZIER_CURVE; };

    var BoundCurves = /** @class */ (function () {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
                    : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderLeftWidth ? 0 : trh - borderLeftWidth, trv - borderTopWidth, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth), Math.max(0, brh - borderRightWidth), brv - borderBottomWidth, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + leftHeight, Math.max(0, blh - borderLeftWidth), blv - borderBottomWidth, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }());
    var CORNER;
    (function (CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function (x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch (position) {
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function (curves) {
        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
    };
    var calculateContentBoxPath = function (curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function (curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };

    var TransformEffect = /** @class */ (function () {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.type = 0 /* TRANSFORM */;
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return TransformEffect;
    }());
    var ClipEffect = /** @class */ (function () {
        function ClipEffect(path, target) {
            this.type = 1 /* CLIP */;
            this.target = target;
            this.path = path;
        }
        return ClipEffect;
    }());
    var isTransformEffect = function (effect) {
        return effect.type === 0 /* TRANSFORM */;
    };
    var isClipEffect = function (effect) { return effect.type === 1 /* CLIP */; };

    var StackingContext = /** @class */ (function () {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }());
    var ElementPaint = /** @class */ (function () {
        function ElementPaint(element, parentStack) {
            this.container = element;
            this.effects = parentStack.slice(0);
            this.curves = new BoundCurves(element);
            if (element.styles.transform !== null) {
                var offsetX = element.bounds.left + element.styles.transformOrigin[0].number;
                var offsetY = element.bounds.top + element.styles.transformOrigin[1].number;
                var matrix = element.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (element.styles.overflowX !== OVERFLOW.VISIBLE) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
                }
            }
        }
        ElementPaint.prototype.getParentEffects = function () {
            var effects = this.effects.slice(0);
            if (this.container.styles.overflowX !== OVERFLOW.VISIBLE) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (!equalPath(borderBox, paddingBox)) {
                    effects.push(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
            }
            return effects;
        };
        return ElementPaint;
    }());
    var parseStackTree = function (parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function (child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
            var paintContainer = new ElementPaint(child, parent.getParentEffects());
            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
                listItems.push(paintContainer);
            }
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            }
                            else if (index_1 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    }
                    else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            }
                            else if (index_2 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    }
                    else {
                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                    }
                }
                else {
                    if (child.styles.isFloating()) {
                        parentStack.nonPositionedFloats.push(stack);
                    }
                    else {
                        parentStack.nonPositionedInlineLevel.push(stack);
                    }
                }
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            }
            else {
                if (child.styles.isInlineLevel()) {
                    stackingContext.inlineLevel.push(paintContainer);
                }
                else {
                    stackingContext.nonInlineLevel.push(paintContainer);
                }
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
                processListItems(child, listOwnerItems);
            }
        });
    };
    var processListItems = function (owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for (var i = 0; i < elements.length; i++) {
            var item = elements[i];
            if (item.container instanceof LIElementContainer &&
                typeof item.container.value === 'number' &&
                item.container.value !== 0) {
                numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function (container) {
        var paintContainer = new ElementPaint(container, []);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };

    var parsePathForBorder = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
        }
        else {
            path.push(inner2);
        }
        if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
        }
        else {
            path.push(inner1);
        }
        return path;
    };

    var paddingBox = function (element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function (element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };

    var calculateBackgroundPositioningArea = function (backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function (backgroundClip, element) {
        if (backgroundClip === BACKGROUND_CLIP.BORDER_BOX) {
            return element.bounds;
        }
        if (backgroundClip === BACKGROUND_CLIP.CONTENT_BOX) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function (container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
    };
    var isAuto = function (token) { return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO; };
    var hasIntrinsicValue = function (value) { return typeof value === 'number'; };
    var calculateBackgroundSize = function (size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
        }
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
                    ? [bounds.width, bounds.width / intrinsicProportion]
                    : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
                return [intrinsicWidth, intrinsicHeight];
            }
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
                return [bounds.width, bounds.height];
            }
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth
                    ? intrinsicWidth
                    : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight
                    ? intrinsicHeight
                    : intrinsicWidth / intrinsicProportion;
                return [width_1, height_1];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
                width_3 = getAbsoluteValue(first, bounds.width);
            }
            else if (isLengthPercentage(second)) {
                height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
                width_3 = height_3 * intrinsicProportion;
            }
            else if (!second || isAuto(second)) {
                height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
        }
        else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
        }
        if (width !== null && (!second || isAuto(second))) {
            height =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (width / intrinsicWidth) * intrinsicHeight
                    : bounds.height;
        }
        if (height !== null && isAuto(first)) {
            width =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (height / intrinsicHeight) * intrinsicWidth
                    : bounds.width;
        }
        if (width !== null && height !== null) {
            return [width, height];
        }
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function (values, index) {
        var value = values[index];
        if (typeof value === 'undefined') {
            return values[0];
        }
        return value;
    };
    var calculateBackgroundRepeatPath = function (repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch (repeat) {
            case BACKGROUND_REPEAT.REPEAT_X:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case BACKGROUND_REPEAT.REPEAT_Y:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case BACKGROUND_REPEAT.NO_REPEAT:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };

    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ (function () {
        function FontMetrics(document) {
            this._data = {};
            this._document = document;
        }
        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return { baseline: baseline, middle: middle };
        };
        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') {
                this._data[key] = this.parseMetrics(fontFamily, fontSize);
            }
            return this._data[key];
        };
        return FontMetrics;
    }());

    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ (function () {
        function CanvasRenderer(options) {
            this._activeEffects = [];
            this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            this.ctx = this.canvas.getContext('2d');
            this.options = options;
            if (!options.canvas) {
                this.canvas.width = Math.floor(options.width * options.scale);
                this.canvas.height = Math.floor(options.height * options.scale);
                this.canvas.style.width = options.width + "px";
                this.canvas.style.height = options.height + "px";
            }
            this.fontMetrics = new FontMetrics(document);
            this.ctx.scale(this.options.scale, this.options.scale);
            this.ctx.translate(-options.x + options.scrollX, -options.y + options.scrollY);
            this.ctx.textBaseline = 'bottom';
            this._activeEffects = [];
            Logger.getInstance(options.id).debug("Canvas renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
        }
        CanvasRenderer.prototype.applyEffects = function (effects, target) {
            var _this = this;
            while (this._activeEffects.length) {
                this.popEffect();
            }
            effects.filter(function (effect) { return contains(effect.target, target); }).forEach(function (effect) { return _this.applyEffect(effect); });
        };
        CanvasRenderer.prototype.applyEffect = function (effect) {
            this.ctx.save();
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function () {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var styles;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [3 /*break*/, 2];
                            this.ctx.globalAlpha = styles.opacity;
                            return [4 /*yield*/, this.renderStackContent(stack)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.renderNodeContent(paint)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing) {
            var _this = this;
            if (letterSpacing === 0) {
                this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
            }
            else {
                var letters = toCodePoints(text.text).map(function (i) { return fromCodePoint(i); });
                letters.reduce(function (left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + text.bounds.height);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function (styles) {
            var fontVariant = styles.fontVariant
                .filter(function (variant) { return variant === 'normal' || variant === 'small-caps'; })
                .join('');
            var fontFamily = styles.fontFamily.join(', ');
            var fontSize = isDimensionToken(styles.fontSize)
                ? "" + styles.fontSize.number + styles.fontSize.unit
                : styles.fontSize.number + "px";
            return [
                [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, font, fontFamily, fontSize;
                var _this = this;
                return __generator(this, function (_b) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    text.textBounds.forEach(function (text) {
                        _this.ctx.fillStyle = asString(styles.color);
                        _this.renderTextWithLetterSpacing(text, styles.letterSpacing);
                        var textShadows = styles.textShadow;
                        if (textShadows.length && text.text.trim().length) {
                            textShadows
                                .slice(0)
                                .reverse()
                                .forEach(function (textShadow) {
                                _this.ctx.shadowColor = asString(textShadow.color);
                                _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                _this.ctx.shadowBlur = textShadow.blur.number;
                                _this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
                            });
                            _this.ctx.shadowColor = '';
                            _this.ctx.shadowOffsetX = 0;
                            _this.ctx.shadowOffsetY = 0;
                            _this.ctx.shadowBlur = 0;
                        }
                        if (styles.textDecorationLine.length) {
                            _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                            styles.textDecorationLine.forEach(function (textDecorationLine) {
                                switch (textDecorationLine) {
                                    case 1 /* UNDERLINE */:
                                        // Draws a line at the baseline of the font
                                        // TODO As some browsers display the line as more than 1px if the font-size is big,
                                        // need to take that into account both in position and size
                                        var baseline = _this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                        _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                        break;
                                    case 2 /* OVERLINE */:
                                        _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                        break;
                                    case 3 /* LINE_THROUGH */:
                                        // TODO try and find exact position for line-through
                                        var middle = _this.fontMetrics.getMetrics(fontFamily, fontSize).middle;
                                        _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                        break;
                                }
                            });
                        }
                    });
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var container, curves, styles, _i, _a, child, image, e_1, image, e_2, iframeRenderer, canvas, size, bounds, x, textBounds, img, image, url, e_3, bounds;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this.applyEffects(paint.effects, 4 /* CONTENT */);
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderTextNode(child, styles)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
                            _b.label = 5;
                        case 5:
                            _b.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, this.options.cache.match(container.src)];
                        case 6:
                            image = _b.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 8];
                        case 7:
                            e_1 = _b.sent();
                            Logger.getInstance(this.options.id).error("Error loading image " + container.src);
                            return [3 /*break*/, 8];
                        case 8:
                            if (container instanceof CanvasElementContainer) {
                                this.renderReplacedElement(container, curves, container.canvas);
                            }
                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
                            _b.label = 9;
                        case 9:
                            _b.trys.push([9, 11, , 12]);
                            return [4 /*yield*/, this.options.cache.match(container.svg)];
                        case 10:
                            image = _b.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 12];
                        case 11:
                            e_2 = _b.sent();
                            Logger.getInstance(this.options.id).error("Error loading svg " + container.svg.substring(0, 255));
                            return [3 /*break*/, 12];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
                            iframeRenderer = new CanvasRenderer({
                                id: this.options.id,
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                scrollX: 0,
                                scrollY: 0,
                                width: container.width,
                                height: container.height,
                                cache: this.options.cache,
                                windowWidth: container.width,
                                windowHeight: container.height
                            });
                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
                        case 13:
                            canvas = _b.sent();
                            if (container.width && container.height) {
                                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            }
                            _b.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                                else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                this.ctx.font = this.createFontStyle(styles)[0];
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch (container.styles.textAlign) {
                                    case TEXT_ALIGN.CENTER:
                                        x += bounds.width / 2;
                                        break;
                                    case TEXT_ALIGN.RIGHT:
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
                            img = container.styles.listStyleImage;
                            if (!(img.type === CSSImageType.URL)) return [3 /*break*/, 18];
                            image = void 0;
                            url = img.url;
                            _b.label = 15;
                        case 15:
                            _b.trys.push([15, 17, , 18]);
                            return [4 /*yield*/, this.options.cache.match(url)];
                        case 16:
                            image = _b.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [3 /*break*/, 18];
                        case 17:
                            e_3 = _b.sent();
                            Logger.getInstance(this.options.id).error("Error loading list-style-image " + url);
                            return [3 /*break*/, 18];
                        case 18: return [3 /*break*/, 20];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== LIST_STYLE_TYPE.NONE) {
                                this.ctx.font = this.createFontStyle(styles)[0];
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _b.label = 20;
                        case 20: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0: 
                        // https://www.w3.org/TR/css-position-3/#painting-order
                        // 1. the background and borders of the element forming the stacking context.
                        return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element)];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 5];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5: 
                        // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                        return [4 /*yield*/, this.renderNodeContent(stack.element)];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [3 /*break*/, 10];
                            child = _c[_b];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [3 /*break*/, 7];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [3 /*break*/, 14];
                            child = _e[_d];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [3 /*break*/, 11];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [3 /*break*/, 18];
                            child = _g[_f];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [3 /*break*/, 15];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [3 /*break*/, 22];
                            child = _j[_h];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [3 /*break*/, 19];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [3 /*break*/, 26];
                            child = _l[_k];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [3 /*break*/, 23];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [3 /*break*/, 30];
                            child = _o[_m];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [3 /*break*/, 27];
                        case 30: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function (paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function (paths) {
            var _this = this;
            paths.forEach(function (point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) {
                    _this.ctx.moveTo(start.x, start.y);
                }
                else {
                    _this.ctx.lineTo(start.x, start.y);
                }
                if (isBezierCurve(point)) {
                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                }
            });
        };
        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
            if (image.width === width && image.height === height) {
                return image;
            }
            var canvas = this.canvas.ownerDocument.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
            return __awaiter(this, void 0, void 0, function () {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function (backgroundImage) {
                                var image, url, e_4, _a, path, x, y, width, height, pattern, _b, path, x, y, width, height, _c, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _d, path, left, top_1, width, height, position, x, y, _e, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function (_f) {
                                    switch (_f.label) {
                                        case 0:
                                            if (!(backgroundImage.type === CSSImageType.URL)) return [3 /*break*/, 5];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _f.label = 1;
                                        case 1:
                                            _f.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this_1.options.cache.match(url)];
                                        case 2:
                                            image = _f.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            e_4 = _f.sent();
                                            Logger.getInstance(this_1.options.id).error("Error loading background-image " + url);
                                            return [3 /*break*/, 4];
                                        case 4:
                                            if (image) {
                                                _a = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _a[0], x = _a[1], y = _a[2], width = _a[3], height = _a[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [3 /*break*/, 6];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _b = calculateBackgroundRendering(container, index, [null, null, null]), path = _b[0], x = _b[1], y = _b[2], width = _b[3], height = _b[4];
                                                _c = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _c[0], x0 = _c[1], x1 = _c[2], y0 = _c[3], y1 = _c[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            }
                                            else if (isRadialGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], left = _d[1], top_1 = _d[2], width = _d[3], height = _d[4];
                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _e = calculateRadius(backgroundImage, x, y, width, height), rx = _e[0], ry = _e[1];
                                                if (rx > 0 && rx > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    }
                                                    else {
                                                        this_1.ctx.fill();
                                                    }
                                                }
                                            }
                                            _f.label = 6;
                                        case 6:
                                            index--;
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            backgroundImage = _a[_i];
                            return [5 /*yield**/, _loop_1(backgroundImage)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderBorder = function (color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.applyEffects(paint.effects, 2 /* BACKGROUND_BORDERS */);
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                { style: styles.borderTopStyle, color: styles.borderTopColor },
                                { style: styles.borderRightStyle, color: styles.borderRightColor },
                                { style: styles.borderBottomStyle, color: styles.borderBottomColor },
                                { style: styles.borderLeftStyle, color: styles.borderLeftColor }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow
                                .slice(0)
                                .reverse()
                                .forEach(function (shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                }
                                else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [3 /*break*/, 7];
                            border = borders_1[_i];
                            if (!(border.style !== BORDER_STYLE.NONE && !isTransparent(border.color))) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.renderBorder(border.color, side, paint.curves)];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5:
                            side++;
                            _a.label = 6;
                        case 6:
                            _i++;
                            return [3 /*break*/, 3];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var stack;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x - this.options.scrollX, this.options.y - this.options.scrollY, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [4 /*yield*/, this.renderStack(stack)];
                        case 1:
                            _a.sent();
                            this.applyEffects([], 2 /* BACKGROUND_BORDERS */);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return CanvasRenderer;
    }());
    var isTextInputElement = function (container) {
        if (container instanceof TextareaElementContainer) {
            return true;
        }
        else if (container instanceof SelectElementContainer) {
            return true;
        }
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
        }
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
        switch (clip) {
            case BACKGROUND_CLIP.BORDER_BOX:
                return calculateBorderBoxPath(curves);
            case BACKGROUND_CLIP.CONTENT_BOX:
                return calculateContentBoxPath(curves);
            case BACKGROUND_CLIP.PADDING_BOX:
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function (textAlign) {
        switch (textAlign) {
            case TEXT_ALIGN.CENTER:
                return 'center';
            case TEXT_ALIGN.RIGHT:
                return 'right';
            case TEXT_ALIGN.LEFT:
            default:
                return 'left';
        }
    };

    var ForeignObjectRenderer = /** @class */ (function () {
        function ForeignObjectRenderer(options) {
            this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            this.ctx = this.canvas.getContext('2d');
            this.options = options;
            this.canvas.width = Math.floor(options.width * options.scale);
            this.canvas.height = Math.floor(options.height * options.scale);
            this.canvas.style.width = options.width + "px";
            this.canvas.style.height = options.height + "px";
            this.ctx.scale(this.options.scale, this.options.scale);
            this.ctx.translate(-options.x + options.scrollX, -options.y + options.scrollY);
            Logger.getInstance(options.id).debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
        }
        ForeignObjectRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var svg, img;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            svg = createForeignObjectSVG(Math.max(this.options.windowWidth, this.options.width) * this.options.scale, Math.max(this.options.windowHeight, this.options.height) * this.options.scale, this.options.scrollX * this.options.scale, this.options.scrollY * this.options.scale, element);
                            return [4 /*yield*/, loadSerializedSVG$1(svg)];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }());
    var loadSerializedSVG$1 = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };

    var _this = undefined;
    var parseColor$1 = function (value) { return color.parse(Parser.create(value).parseComponentValue()); };
    var html2canvas = function (element, options) {
        if (options === void 0) { options = {}; }
        return renderElement(element, options);
    };
    CacheStorage.setContext(window);
    var renderElement = function (element, opts) { return __awaiter(_this, void 0, void 0, function () {
        var ownerDocument, defaultView, instanceName, _a, width, height, left, top, defaultResourceOptions, resourceOptions, defaultOptions, options, windowBounds, documentCloner, clonedElement, container, documentBackgroundColor, bodyBackgroundColor, bgColor, defaultBackgroundColor, backgroundColor, renderOptions, canvas, renderer, root, renderer;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    ownerDocument = element.ownerDocument;
                    if (!ownerDocument) {
                        throw new Error("Element is not attached to a Document");
                    }
                    defaultView = ownerDocument.defaultView;
                    if (!defaultView) {
                        throw new Error("Document is not attached to a Window");
                    }
                    instanceName = (Math.round(Math.random() * 1000) + Date.now()).toString(16);
                    _a = isBodyElement(element) || isHTMLElement(element) ? parseDocumentSize(ownerDocument) : parseBounds(element), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                    defaultResourceOptions = {
                        allowTaint: false,
                        imageTimeout: 15000,
                        proxy: undefined,
                        useCORS: false
                    };
                    resourceOptions = __assign({}, defaultResourceOptions, opts);
                    defaultOptions = {
                        backgroundColor: '#ffffff',
                        cache: opts.cache ? opts.cache : CacheStorage.create(instanceName, resourceOptions),
                        logging: true,
                        removeContainer: true,
                        foreignObjectRendering: false,
                        scale: defaultView.devicePixelRatio || 1,
                        windowWidth: defaultView.innerWidth,
                        windowHeight: defaultView.innerHeight,
                        scrollX: defaultView.pageXOffset,
                        scrollY: defaultView.pageYOffset,
                        x: left,
                        y: top,
                        width: Math.ceil(width),
                        height: Math.ceil(height),
                        id: instanceName
                    };
                    options = __assign({}, defaultOptions, resourceOptions, opts);
                    windowBounds = new Bounds(options.scrollX, options.scrollY, options.windowWidth, options.windowHeight);
                    Logger.create({ id: instanceName, enabled: options.logging });
                    Logger.getInstance(instanceName).debug("Starting document clone");
                    documentCloner = new DocumentCloner(element, {
                        id: instanceName,
                        onclone: options.onclone,
                        ignoreElements: options.ignoreElements,
                        inlineImages: options.foreignObjectRendering,
                        copyStyles: options.foreignObjectRendering
                    });
                    clonedElement = documentCloner.clonedReferenceElement;
                    if (!clonedElement) {
                        return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
                    }
                    return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
                case 1:
                    container = _b.sent();
                    documentBackgroundColor = ownerDocument.documentElement
                        ? parseColor$1(getComputedStyle(ownerDocument.documentElement).backgroundColor)
                        : COLORS.TRANSPARENT;
                    bodyBackgroundColor = ownerDocument.body
                        ? parseColor$1(getComputedStyle(ownerDocument.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    bgColor = opts.backgroundColor;
                    defaultBackgroundColor = typeof bgColor === 'string' ? parseColor$1(bgColor) : bgColor === null ? COLORS.TRANSPARENT : 0xffffffff;
                    backgroundColor = element === ownerDocument.documentElement
                        ? isTransparent(documentBackgroundColor)
                            ? isTransparent(bodyBackgroundColor)
                                ? defaultBackgroundColor
                                : bodyBackgroundColor
                            : documentBackgroundColor
                        : defaultBackgroundColor;
                    renderOptions = {
                        id: instanceName,
                        cache: options.cache,
                        canvas: options.canvas,
                        backgroundColor: backgroundColor,
                        scale: options.scale,
                        x: options.x,
                        y: options.y,
                        scrollX: options.scrollX,
                        scrollY: options.scrollY,
                        width: options.width,
                        height: options.height,
                        windowWidth: options.windowWidth,
                        windowHeight: options.windowHeight
                    };
                    if (!options.foreignObjectRendering) return [3 /*break*/, 3];
                    Logger.getInstance(instanceName).debug("Document cloned, using foreign object rendering");
                    renderer = new ForeignObjectRenderer(renderOptions);
                    return [4 /*yield*/, renderer.render(clonedElement)];
                case 2:
                    canvas = _b.sent();
                    return [3 /*break*/, 5];
                case 3:
                    Logger.getInstance(instanceName).debug("Document cloned, using computed rendering");
                    CacheStorage.attachInstance(options.cache);
                    Logger.getInstance(instanceName).debug("Starting DOM parsing");
                    root = parseTree(clonedElement);
                    CacheStorage.detachInstance();
                    if (backgroundColor === root.styles.backgroundColor) {
                        root.styles.backgroundColor = COLORS.TRANSPARENT;
                    }
                    Logger.getInstance(instanceName).debug("Starting renderer");
                    renderer = new CanvasRenderer(renderOptions);
                    return [4 /*yield*/, renderer.render(root)];
                case 4:
                    canvas = _b.sent();
                    _b.label = 5;
                case 5:
                    if (options.removeContainer === true) {
                        if (!DocumentCloner.destroy(container)) {
                            Logger.getInstance(instanceName).error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                    }
                    Logger.getInstance(instanceName).debug("Finished rendering");
                    Logger.destroy(instanceName);
                    CacheStorage.destroy(instanceName);
                    return [2 /*return*/, canvas];
            }
        });
    }); };

    return html2canvas;

}));
//# sourceMappingURL=html2canvas.js.map


/***/ }),
/* 479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_middleware__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__ = __webpack_require__(214);
/* unused harmony reexport runSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_channel__ = __webpack_require__(35);
/* unused harmony reexport END */
/* unused harmony reexport eventChannel */
/* unused harmony reexport channel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_buffers__ = __webpack_require__(63);
/* unused harmony reexport buffers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__ = __webpack_require__(216);
/* unused harmony reexport takeEvery */
/* unused harmony reexport takeLatest */
/* unused harmony reexport throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_utils__ = __webpack_require__(14);
/* unused harmony reexport delay */
/* unused harmony reexport CANCEL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_io__ = __webpack_require__(23);
/* unused harmony reexport detach */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__effects__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(486);
/* unused harmony reexport effects */
/* unused harmony reexport utils */

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__internal_middleware__["a" /* default */]);













/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sagaMiddlewareFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__runSaga__ = __webpack_require__(214);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      options = _objectWithoutProperties(_ref, ['context']);

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;


  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (logger && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (false) {
    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
  }

  if (onError && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;

    var sagaEmitter = Object(__WEBPACK_IMPORTED_MODULE_1__channel__["b" /* emitter */])();
    sagaEmitter.emit = (options.emitter || __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */])(sagaEmitter.emit);

    sagaMiddleware.run = __WEBPACK_IMPORTED_MODULE_2__runSaga__["a" /* runSaga */].bind(null, {
      context: context,
      subscribe: sagaEmitter.subscribe,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError
    });

    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('sagaMiddleware', props));
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(context, props);
  };

  return sagaMiddleware;
}

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(35);




function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["h" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(35);




function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["h" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["e" /* cancel */])(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buffers__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(14);






function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["a" /* actionChannel */])(pattern, __WEBPACK_IMPORTED_MODULE_3__buffers__["a" /* buffers */].sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["h" /* take */])(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["d" /* call */])(__WEBPACK_IMPORTED_MODULE_4__utils__["j" /* delay */], delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(pattern) + ', ' + worker.name + ')');
}

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export takeEvery */
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatest;
/* unused harmony export throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__io__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sagaHelpers__ = __webpack_require__(216);



function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["f" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["a" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}

function takeLatest(patternOrChannel, worker) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["f" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["b" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}

function throttle(ms, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["f" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["c" /* throttleHelper */], ms, pattern, worker].concat(args));
}

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_utils__ = __webpack_require__(14);
/* unused harmony reexport TASK */
/* unused harmony reexport SAGA_ACTION */
/* unused harmony reexport noop */
/* unused harmony reexport is */
/* unused harmony reexport deferred */
/* unused harmony reexport arrayOfDeffered */
/* unused harmony reexport createMockTask */
/* unused harmony reexport cloneableGenerator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io__ = __webpack_require__(23);
/* unused harmony reexport asEffect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_proc__ = __webpack_require__(215);
/* unused harmony reexport CHANNEL_END */




/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_undo_redo__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_undo_redo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_undo_redo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__project__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__library__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__localStore__ = __webpack_require__(588);
var AnimakerStore=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({project:__WEBPACK_IMPORTED_MODULE_2__project__["a" /* default */],library:__WEBPACK_IMPORTED_MODULE_3__library__["a" /* default */],localStore:__WEBPACK_IMPORTED_MODULE_4__localStore__["a" /* default */],undoHistory:__WEBPACK_IMPORTED_MODULE_1_redux_undo_redo__["undoHistoryReducer"]});/* harmony default export */ __webpack_exports__["a"] = (AnimakerStore);

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isNil2 = __webpack_require__(489);

var _isNil3 = _interopRequireDefault(_isNil2);

var _omitBy2 = __webpack_require__(490);

var _omitBy3 = _interopRequireDefault(_omitBy2);

exports.undoHistoryReducerCreator = undoHistoryReducerCreator;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var INITIAL_UNDO_HISTORY_STATE = {
  undoQueue: [],
  redoQueue: []
};

var unlimitedUndoHistoryReducer = undoHistoryReducerCreator();

exports.default = unlimitedUndoHistoryReducer;
function undoHistoryReducerCreator() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      undoHistoryLimit = _ref.undoHistoryLimit;

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_UNDO_HISTORY_STATE;
    var action = arguments[1];
    var type = action.type,
        undoItem = action.payload;
    var undoQueue = state.undoQueue,
        redoQueue = state.redoQueue;


    switch (type) {
      case 'UNDO_HISTORY@UNDO':
        {
          return undoQueue.length === 0 ? state : {
            undoQueue: undoQueue.slice(1),
            redoQueue: [undoQueue[0]].concat(_toConsumableArray(redoQueue))
          };
        }
      case 'UNDO_HISTORY@REDO':
        {
          return redoQueue.length === 0 ? state : {
            undoQueue: [redoQueue[0]].concat(_toConsumableArray(undoQueue)),
            redoQueue: redoQueue.slice(1)
          };
        }
      case 'UNDO_HISTORY@ADD':
        {
          var newUndoQueue = [(0, _omitBy3.default)(undoItem, _isNil3.default)];
          undoHistoryLimit ? newUndoQueue.push.apply(newUndoQueue, _toConsumableArray(undoQueue.slice(0, undoHistoryLimit - 1))) : newUndoQueue.push.apply(newUndoQueue, _toConsumableArray(undoQueue));

          return {
            undoQueue: newUndoQueue,
            redoQueue: []
          };
        }
      case 'UNDO_HISTORY@CLEAR':
        return INITIAL_UNDO_HISTORY_STATE;
      default:
        return state;
    }
  };
}

/***/ }),
/* 489 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(219),
    negate = __webpack_require__(561),
    pickBy = __webpack_require__(562);

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee(predicate)));
}

module.exports = omitBy;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(492),
    getMatchData = __webpack_require__(547),
    matchesStrictComparable = __webpack_require__(237);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(220),
    baseIsEqual = __webpack_require__(224);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 493 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(65);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(65);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(65);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(65);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(64);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 499 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 500 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 501 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(64),
    Map = __webpack_require__(115),
    MapCache = __webpack_require__(116);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(221),
    isMasked = __webpack_require__(506),
    isObject = __webpack_require__(37),
    toSource = __webpack_require__(223);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(66);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 505 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(507);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(19);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 508 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(510),
    ListCache = __webpack_require__(64),
    Map = __webpack_require__(115);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(511),
    hashDelete = __webpack_require__(512),
    hashGet = __webpack_require__(513),
    hashHas = __webpack_require__(514),
    hashSet = __webpack_require__(515);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(67);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 512 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(67);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(67);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(67);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(68);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 517 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(68);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(68);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(68);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(220),
    equalArrays = __webpack_require__(225),
    equalByTag = __webpack_require__(527),
    equalObjects = __webpack_require__(531),
    getTag = __webpack_require__(542),
    isArray = __webpack_require__(20),
    isBuffer = __webpack_require__(232),
    isTypedArray = __webpack_require__(233);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(116),
    setCacheAdd = __webpack_require__(523),
    setCacheHas = __webpack_require__(524);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 523 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 524 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 525 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 526 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(66),
    Uint8Array = __webpack_require__(528),
    eq = __webpack_require__(114),
    equalArrays = __webpack_require__(225),
    mapToArray = __webpack_require__(529),
    setToArray = __webpack_require__(530);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(19);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 529 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 530 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(532);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(226),
    getSymbols = __webpack_require__(228),
    keys = __webpack_require__(117);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 533 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 534 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    isObjectLike = __webpack_require__(38);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 536 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    isLength = __webpack_require__(119),
    isObjectLike = __webpack_require__(38);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 538 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(222);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)(module)))

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(234),
    nativeKeys = __webpack_require__(541);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(235);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(543),
    Map = __webpack_require__(115),
    Promise = __webpack_require__(544),
    Set = __webpack_require__(545),
    WeakMap = __webpack_require__(546),
    baseGetTag = __webpack_require__(36),
    toSource = __webpack_require__(223);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(30),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(30),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(30),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(30),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(236),
    keys = __webpack_require__(117);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(224),
    get = __webpack_require__(238),
    hasIn = __webpack_require__(554),
    isKey = __webpack_require__(122),
    isStrictComparable = __webpack_require__(236),
    matchesStrictComparable = __webpack_require__(237),
    toKey = __webpack_require__(49);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(550);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(551);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(116);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(553);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(66),
    arrayMap = __webpack_require__(123),
    isArray = __webpack_require__(20),
    isSymbol = __webpack_require__(70);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(555),
    hasPath = __webpack_require__(556);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 555 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(69),
    isArguments = __webpack_require__(231),
    isArray = __webpack_require__(20),
    isIndex = __webpack_require__(118),
    isLength = __webpack_require__(119),
    toKey = __webpack_require__(49);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 557 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(559),
    basePropertyDeep = __webpack_require__(560),
    isKey = __webpack_require__(122),
    toKey = __webpack_require__(49);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 559 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(121);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 561 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

module.exports = negate;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(123),
    baseIteratee = __webpack_require__(219),
    basePickBy = __webpack_require__(563),
    getAllKeysIn = __webpack_require__(568);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(121),
    baseSet = __webpack_require__(564),
    castPath = __webpack_require__(69);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(565),
    castPath = __webpack_require__(69),
    isIndex = __webpack_require__(118),
    isObject = __webpack_require__(37),
    toKey = __webpack_require__(49);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(566),
    eq = __webpack_require__(114);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(567);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(30);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(226),
    getSymbolsIn = __webpack_require__(569),
    keysIn = __webpack_require__(571);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(227),
    getPrototype = __webpack_require__(570),
    getSymbols = __webpack_require__(228),
    stubArray = __webpack_require__(229);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(235);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(230),
    baseKeysIn = __webpack_require__(572),
    isArrayLike = __webpack_require__(120);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(37),
    isPrototype = __webpack_require__(234),
    nativeKeysIn = __webpack_require__(573);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 573 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _includes2 = __webpack_require__(575);

var _includes3 = _interopRequireDefault(_includes2);

var _get2 = __webpack_require__(238);

var _get3 = _interopRequireDefault(_get2);

exports.default = createUndoMiddleware;

var _actions = __webpack_require__(239);

var _selectors = __webpack_require__(586);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createUndoMiddleware(_ref) {
  var getViewState = _ref.getViewState,
      setViewState = _ref.setViewState,
      revertingActions = _ref.revertingActions;


  if (Object.values(revertingActions).some(function (revertingAction) {
    return revertingAction.meta;
  })) {
    console.warn('[redux-undo-redo] The "meta" property in reverting actions is deprecated and replaced with "createArgs" and will be removed in future versions.');
  }

  var SUPPORTED_ACTIONS = Object.keys(revertingActions);
  var acting = false;

  return function (_ref2) {
    var dispatch = _ref2.dispatch,
        getState = _ref2.getState;
    return function (next) {
      return function (action) {
        var state = getState();
        var ret = next(action);

        switch (action.type) {
          case 'UNDO_HISTORY@UNDO':
            {
              var undoItem = (0, _selectors.getUndoItem)(state);
              if (undoItem) {
                acting = true;
                setViewState && dispatch(setViewState(undoItem.afterState));
                dispatch(getUndoAction(undoItem));
                setViewState && dispatch(setViewState(undoItem.beforeState));
                acting = false;
              }
            }
            break;
          case 'UNDO_HISTORY@REDO':
            {
              var redoItem = (0, _selectors.getRedoItem)(state);
              if (redoItem) {
                acting = true;
                setViewState && dispatch(setViewState(redoItem.beforeState));
                dispatch(redoItem.action);
                acting = false;
              }
            }
            break;
          default:
            if (!acting && (0, _includes3.default)(SUPPORTED_ACTIONS, action.type)) {
              dispatch((0, _actions.addUndoItem)(action, getViewState && getViewState(state), getViewState && getViewState(getState()), getUndoArgs(state, action)));
            }
            break;
        }

        return ret;
      };
    };
  };

  function getUndoAction(undoItem) {
    var action = undoItem.action,
        args = undoItem.args;
    var type = action.type;

    var actionCreator = (0, _get3.default)(revertingActions[type], 'action', revertingActions[type]);
    if (!actionCreator) {
      throw new Error('Illegal reverting action definition for \'' + type + '\'');
    }
    return actionCreator(action, args);
  }

  function getUndoArgs(state, action) {
    var argsFactory = (0, _get3.default)(revertingActions[action.type], 'createArgs');

    if (!argsFactory) {
      argsFactory = (0, _get3.default)(revertingActions[action.type], 'meta');
    }

    return argsFactory && argsFactory(state, action);
  }
}

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(576),
    isArrayLike = __webpack_require__(120),
    isString = __webpack_require__(580),
    toInteger = __webpack_require__(581),
    values = __webpack_require__(584);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(577),
    baseIsNaN = __webpack_require__(578),
    strictIndexOf = __webpack_require__(579);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 577 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 578 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 579 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    isArray = __webpack_require__(20),
    isObjectLike = __webpack_require__(38);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(582);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(583);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(37),
    isSymbol = __webpack_require__(70);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(585),
    keys = __webpack_require__(117);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(123);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getUndoItem = exports.getUndoItem = function getUndoItem(state) {
  return state.undoHistory.undoQueue[0];
};
var getRedoItem = exports.getRedoItem = function getRedoItem(state) {
  return state.undoHistory.redoQueue[0];
};

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = animakerStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ErrorLogService__ = __webpack_require__(9);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var initialState=fromJSOrdered({"SEARCH":{},"ACTIONSEARCH":{"total":"","items":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},"autoSearch":"","defaultActionCat":"","libFailedType":'','PREBUILT':{"total":"","data":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},'PREBUILTSCENES':{'total':'','data':Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},'PROP':{"total":"","data":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},'EPROP':{"total":"","data":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},'ECHR':{"total":"","data":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},'GIPHY':{"total":"","data":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},'TEXT':{"total":"","data":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},'SHAPE':{"total":"","items":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},'TXTGRP':{"total":"","items":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},'TXTOVLY':{"total":"","items":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},'BG':{"total":"","data":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},'IMG':{"total":"","items":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},'STOCKIMG':{"total":"","data":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},'VIDEO':{"total":"","items":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},'STOCKVID':{"total":"","data":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},'CCHR':{"total":"","items":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},'CHR':{"total":"","data":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},'UPIMAGE':{"data":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])(),"total":0},'UPVIDEO':{"data":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])(),"total":0},'EFFECTS':{'ENTER':Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()},'UPLOADS':{"items":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},'ACTION':{"total":"","items":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},'SM':{"total":"","data":Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()},'TRANS':{},'uploadedFile':'','versions':{}});function fromJSOrdered(js){return(typeof js==='undefined'?'undefined':_typeof(js))!=='object'||js===null?js:Array.isArray(js)?Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Seq"])(js).map(fromJSOrdered).toList():Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Seq"])(js).map(fromJSOrdered).toOrderedMap();}function getRandomColor(){var letters='0123456789ABCDEF';var color='#';for(var i=0;i<6;i++){color+=letters[Math.floor(Math.random()*16)];}return color;}function animakerStore(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var uploadItems=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({});switch(action.type){case"CREATE_FOLDER_COMPLETE":var obj={"active":1,"userid":1,"roottype":"folder","created":action.data.response.created,"name":action.data.response.name,"parent":action.data.response.parent};state=state.setIn(["UPLOADS","items",action.data.response.id],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(obj));return state;case"RENAME_USER_FILE":state=state.setIn(["UPLOADS","items",action.libData.id,"name"],action.libData.name);return state;case"MOVE_FILE_LOCATION":for(var i=0;i<action.libData.id.length;i++){state=state.updateIn(["UPLOADS","items"],function(value){return value.delete(action.libData.id[i]);});}return state;case"DELETE_FILE":if(_typeof(action.id)==='object'){action.id.map(function(fileId){state=state.updateIn(["UPLOADS","items"],function(value){return value.delete(fileId);});});return state;}else{return state.updateIn(["UPLOADS","items"],function(value){return value.delete(action.id);});}case"UPLOADED_FILE":state=state.set('uploadedFile',action.data);return state;case"SET_SEARCH_DATA":state=state.set("SEARCH",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data));return state;case"LOAD_ACTIONS":state=state.setIn(["ACTION","total"],action.total);if(!state.getIn(["ACTION","items"]).size||action.data.get(action.data.keys().next().value).genderType!==state.getIn(["ACTION","items"]).first().get('genderType'))state=state.setIn(["ACTION","items"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])());action.data.forEach(function(value,key){state=state.setIn(["ACTION","items",key],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(value));});return state;case'FETCH_ACTION_SEARCH':if(!action.libData.fromScroll){state=state.setIn(["ACTIONSEARCH","total"],action.total);state=state.setIn(["ACTIONSEARCH","items"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])());}return state;case"LOAD_AUTOSEARCH":state=state.setIn(["autoSearch"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data["ACTION"]));state=state.setIn(["defaultActionCat"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data["ACTIONCATEGORY"]));return state;case"LOAD_ACTIONSEARCH_DATA":state=state.setIn(["ACTIONSEARCH","total"],action.total);action.data.forEach(function(value,key){state=state.setIn(["ACTIONSEARCH","items",key],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(value));});return state;case'CLEAR_ACTIONS':state=state.setIn(["ACTION","items"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])());return state;case'LOAD_MASTER_LIBRARY_COMPLETE':switch(action.libType){case"HPRE":case"VPRE":case"SPRE":state=state.setIn(['PREBUILT'],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])());state=state.setIn(['PREBUILT'],fromJSOrdered(action.data));return state;case'PROP':case'BG':state=state.setIn([action.libType],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])());state=state.setIn([action.libType],fromJSOrdered(action.data));return state;case'UPIMAGE':case'UPVIDEO':var dataExist=state.getIn([action.libType,'data']);if(dataExist.size){try{action.data.data.forEach(function(val){var isExist=false;for(var _i=0;_i<dataExist.size;_i++){if(dataExist.get(_i).get('id')===val.id){isExist=true;break;}}if(!isExist)state=state.updateIn([action.libType,'data'],function(arr){return arr.concat(fromJSOrdered([val]));});});}catch(err){Object(__WEBPACK_IMPORTED_MODULE_1__helpers_ErrorLogService__["a" /* errorlog */])('Error in libData ',err,"libraryReducer-animakerStore");}}else{state=state.setIn([action.libType],fromJSOrdered({data:action.data.data,total:action.data.total}));}return state;default:return state;}case'FETCH_SEARCH':if(!action.libData.fromScroll)state=state.set("SEARCH",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({}));return state;case'LOAD_SEARCH_DATA':if(!action.fromScroll){if(action.aggs){Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.aggs).entrySeq().forEach(function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];var keyTab=value.get('key').toUpperCase();state=state.setIn(["SEARCH",keyTab,"total"],value.get('doc_count'));state=state.setIn(["SEARCH",keyTab,"items"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])());});}}action.data.forEach(function(datas){var dataToItr=new __WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"](datas.data);dataToItr.entrySeq().forEach(function(_ref3){var _ref4=_slicedToArray(_ref3,2),key=_ref4[0],value=_ref4[1];state=state.setIn(["SEARCH",datas.type,"items",key],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(value));state=state.setIn(['SEARCH',datas.type,'loadedType'],action.libType);state=state.setIn(['SEARCH',datas.type,'loadedValue'],action.tagValue);});});return state;case'CLEAR_PROP_CACHE':state=state.set(state.getIn(['PROP','total']),0);state=state.set(state.getIn(['PROP','data']),Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])({}));return state;case'CLEAR_DATA_CACHE':if(action.data.category){if(state.getIn([action.data.type,'data',action.data.category,'items']).size>action.data.max){var count=0;state.getIn([action.data.type,'data',action.data.category,'items']).entrySeq().forEach(function(_ref5){var _ref6=_slicedToArray(_ref5,2),key=_ref6[0],val=_ref6[1];count++;if(count>action.data.max)state=state.setIn([action.data.type,'data',action.data.category,'items'],state.getIn([action.data.type,'data',action.data.category,'items']).delete(key));});}}else{var maxCount=5;if(state.getIn([action.data.type,'data']).has('Top Exclusive')){maxCount=6;}var mainCount=0;state.getIn([action.data.type,'data']).entrySeq().forEach(function(_ref7){var _ref8=_slicedToArray(_ref7,2),key=_ref8[0],value=_ref8[1];mainCount++;if(mainCount>maxCount){state=state.setIn([action.data.type,'data'],state.getIn([action.data.type,'data']).delete(key));}else{if(key!=='All Items'){var _count=0;value.get('items').entrySeq().forEach(function(_ref9){var _ref10=_slicedToArray(_ref9,2),k=_ref10[0],val=_ref10[1];_count++;if(_count>action.data.max)state=state.setIn([action.data.type,'data',key,'items'],state.getIn([action.data.type,'data',key,'items']).delete(k));});}}});}return state;case'RESP_UPDATE':state=state.set('libFailedType',action.data.status);return state;case'LOAD_CATEGORY_COMPLETE':switch(action.libData.type){case"HPRE":case"VPRE":case"SPRE":state=state.setIn(['PREBUILT',action.libData.categories,"total"],action.total);Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data).entrySeq().forEach(function(_ref11){var _ref12=_slicedToArray(_ref11,2),key=_ref12[0],value=_ref12[1];state=state.setIn(['PREBUILT',action.libData.categories,"items",key],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(value));});return state;case'PROP':case'BG':case'TEXT':case'GIPHY':case'PREBUILT':case'STOCKVID':case'SM':case'CHR':case"STOCKIMG":if(action.libData.type==='PROP'||action.libData.type==='BG'||action.libData.type==='STOCKIMG'||action.libData.type==='STOCKVID'||action.libData.type==='CHR'||action.libData.type==='PREBUILT'||action.libData.type==='GIPHY'||action.libData.type==='TEXT'||action.libData.type==='SM'){state=state.setIn([action.libData.type,'data',action.libData.categories,"total"],action.total);if(!state.getIn([action.libData.type,'data',action.libData.categories,"items"])){state=state.setIn([action.libData.type,'data',action.libData.categories,"items"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])());}var i=0;var dataToItr=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])(action.data);dataToItr.entrySeq().forEach(function(_ref13){var _ref14=_slicedToArray(_ref13,2),key=_ref14[0],value=_ref14[1];i++;value.name=value['name_'+action.lang];state=state.setIn([action.libData.type,'data',action.libData.categories,"items",key],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(value));});if(action.libData.type==='TEXT'&&Object.keys(action.brandData).length){state=state.setIn([action.libData.type,'data','brandData'],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.brandData));}}else{state=state.setIn([action.libData.type,action.libData.categories,"total"],action.total);Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data).entrySeq().forEach(function(_ref15){var _ref16=_slicedToArray(_ref15,2),key=_ref16[0],value=_ref16[1];state=state.setIn([action.libData.type,action.libData.categories,"items",key],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(value));});}return state;case'VIDEO':case"IMG":case"SHAPE":case"CCHR":case"CHR":state=state.setIn([action.libData.type,"total"],action.total);Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data).entrySeq().forEach(function(_ref17){var _ref18=_slicedToArray(_ref17,2),key=_ref18[0],value=_ref18[1];state=state.setIn([action.libData.type,"items",key],value);});return state;default:return state;}case'ADD_UPLOAD_ITEM':var value={src:action.data.src,subType:action.data.subType,width:action.data.width,type:action.data.type,height:action.data.height};if(action.data.type!=="IMG")value['duration']=action.data.duration;if(action.data.type!=="AUDIO")value['thumbnail']=action.data.thumbnail;else if(action.data.type==="AUDIO")value['name']=action.data.name;state=state.setIn(["UPLOADS","items",action.data.id],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data));uploadItems=state.getIn(["UPLOADS","items"]).sortBy(function(value){return value.get('created');}).reverse();state=state.setIn(["UPLOADS","items"],uploadItems);return state;case'GET_PREBUILT_SCENES':var data=state.get('PREBUILT').get('data').get(action.data.name).get('items').get(action.data.id);if(action.data.fromType==='SEARCH'){data=state.get(action.data.fromType).get('PREBUILT').get('items').get(action.data.id);}state=state.setIn(['PREBUILTSCENES','data','total'],data.get('scenetotal'));state=state.setIn(['PREBUILTSCENES','data','sceneName'],data.get('name'));state=state.setIn(['PREBUILTSCENES','data','scenes'],data.get('scenes'));return state;case'LOAD_LIBRARY_COMPLETE':switch(action.libType){case"CCHR":case"ECHR":state=state.setIn([action.libType,"total"],action.total);var _dataToItr=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])(action.data);state=state.setIn([action.libType,"items"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])());_dataToItr.entrySeq().forEach(function(_ref19){var _ref20=_slicedToArray(_ref19,2),key=_ref20[0],value=_ref20[1];value=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(value);value=value.set('background',getRandomColor());state=state.setIn([action.libType,"items",key],value);});return state;case"IMG":case'VIDEO':case'SHAPE':state=state.setIn([action.libType,"total"],action.total);Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data).entrySeq().forEach(function(_ref21){var _ref22=_slicedToArray(_ref21,2),key=_ref22[0],value=_ref22[1];state=state.setIn([action.libType,"items",key],value);});return state;case'UPLOADS':state=state.setIn([action.libType,"items"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])());action.data.forEach(function(value){state=state.setIn([action.libType,"items",value.id],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(value));});return state;case'PROP':case'BG':case"STOCKIMG":case"STOCKVID":case'ACTION':case'GIPHY':case"PREBUILT":case'SM':case'CHR':if(action.libType==='PROP'&&action.subType!=='EPROP'||action.libType==='STOCKIMG'||action.libType==='STOCKVID'||action.libType==='CHR'||action.libType==='BG'||action.libType==='GIPHY'||action.libType==='PREBUILT'||action.libType==='SM'){var _dataToItr2=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])(action.data);_dataToItr2.entrySeq().forEach(function(_ref23){var _ref24=_slicedToArray(_ref23,2),key=_ref24[0],value=_ref24[1];if(key==='total'){state=state.setIn([action.libType,key],value);}else{var datas=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])(action.data.data);datas.entrySeq().forEach(function(_ref25){var _ref26=_slicedToArray(_ref25,2),key=_ref26[0],value=_ref26[1];if(!state.getIn([action.libType,'data',key,"items"])){state.setIn([action.libType,'data',key,"items"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])());}var values=new __WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"](),stockVal=new __WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"]();Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(value).get('items').forEach(function(val){var keyID=val.get('id');if(action.libType==='STOCKIMG'){stockVal=stockVal.set('id',keyID);stockVal=stockVal.set('thumbnail',val.get('display_sizes').get(2).get('uri'));stockVal=stockVal.set('src',val.get('display_sizes').get(0).get('uri'));stockVal=stockVal.set('name',val.get('title'));stockVal=stockVal.set('width',val.get('max_dimensions').get('width'));stockVal=stockVal.set('height',val.get('max_dimensions').get('height'));stockVal=stockVal.set('type',action.libType);stockVal=stockVal.set('artist',val.get('artist'));stockVal=stockVal.set('title',val.get('title'));stockVal=stockVal.set('stockId',keyID);stockVal=stockVal.set('subType',val.get('subType'));stockVal=stockVal.set('istock_collection',val.get('istock_collection'));stockVal=stockVal.set('cost',val.get('cost'));values=values.set(keyID,stockVal);}else{if(action.libType==='SM'){val=val.set('name',val.get('name_'+action.lang));}values=values.set(keyID,val);}});state=state.setIn([action.libType,'data',key,"searchtag"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(value).get('searchtag'));state=state.setIn([action.libType,'data',key,"items"],values);});}});}else{var datasToItr=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])(action.data);if(action.subType==='EPROP'){action.libType=action.subType;var epropVal=new __WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"]();datasToItr.entrySeq().forEach(function(_ref27){var _ref28=_slicedToArray(_ref27,2),key=_ref28[0],value=_ref28[1];epropVal=epropVal.set(key,Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(value));});state=state.setIn([action.libType,'data',key,'items'],epropVal);}else{datasToItr.entrySeq().forEach(function(_ref29){var _ref30=_slicedToArray(_ref29,2),key=_ref30[0],value=_ref30[1];state=state.setIn([action.libType,key,"searchtag"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(value).get('searchtag'));state=state.setIn([action.libType,key],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(value));});}}state=state.set('libFailedType','completed');return state;case'SEARCH':if(action.searchType==='enter'){return state.setIn([action.libType],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data));}else{Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data).entrySeq().forEach(function(_ref31){var _ref32=_slicedToArray(_ref31,2),key=_ref32[0],value=_ref32[1];state=state.setIn([action.libType,key],value);});return state;}case'COLOR_THEMES':case'EFFECTS':return state.setIn([action.libType],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data));case'TRANS':var transData=action.data;for(var key in transData){transData[key]=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(transData[key]);}state=state.setIn(["TRANS"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])(transData));return state;case'TEXT':state=state.setIn([action.subType,"total"],action.total);Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data).entrySeq().forEach(function(_ref33){var _ref34=_slicedToArray(_ref33,2),key=_ref34[0],value=_ref34[1];state=state.setIn([action.subType,"items",key],value);});return state;default:return state;}case'VERSION_HISTORY':state=state.setIn(['versions'],state.getIn(['versions']).merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data)));return state;default:return state;}}

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = localStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_app_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utilityMethods__ = __webpack_require__(104);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var initialState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({"appLoadProgressValue":0,"t1":new __WEBPACK_IMPORTED_MODULE_1_gsap__["f" /* TimelineMax */]({paused:true}),"selectedScene":0,"selectedItems":[],"selectedCamera":"","selectedKeyframe":"","userColors":[],"userFonts":[],"isPlay":false,"isPlayAll":false,"fromStart":false,"isPreview":false,"zoomFactor":1,"textStatus":{},"isWorkspaceTextFocus":false,"textOptions":{fontFamily:{disabled:false,isActive:false,value:null},fontSize:{disabled:false,isActive:false,value:null},fontWeight:{disabled:false,isActive:false,value:null},fontStyle:{disabled:false,isActive:false,value:null},textDecoration:{disabled:false,isActive:false,value:null},bullet:{disabled:false,isActive:false,value:"none"},textAlign:{disabled:false,isActive:false,value:null},textTransform:{disabled:false,isActive:false,value:null},color:{disabled:false,isActive:false,value:null},link:{disabled:false,isActive:false,value:null},opacity:{disabled:false,isActive:false,value:null},lineSpacing:{disabled:false,isActive:false,value:null},wordSpacing:{disabled:false,isActive:false,value:null},letterSpacing:{disabled:false,isActive:false,value:null},colors:[]},"transformStatus":{transforming:false,moving:false,resizing:false,rotating:false},"currentPosition":null,"isCropping":false,"isFraming":false,"isBgCropping":false,"isVideoCroping":false,"cropVideoId":null,"swapDetails":null,"visibleTimelineTab":"objectTab","audioPlayHead":0,"displayDuration":32470,"animdisplayDuration":30,"timeScaleZoom":0,"animTimeScaleZoom":0,"selectedMedias":[],"timelineHeight":130,"showSlidePanel":true,"workspaceBounds":{},"tweenCount":0,"loadCount":0,"showLibrary":true,"workspaceGrid":false,"copiedItem":null,"isCopyObject":false,"isPasteObject":false,"isCutObject":false,"workspaceBgImages":{},"propertyWindow":{component:"",isOpened:false},"userFolders":{items:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])(),parent:{parent:"0",name:"My Files"}},"userMainFolders":{parent:{parent:"0",name:"My Files"}},"BGDrop":"","textUpdated":null,"clonedBgFilter":"","enableAutoSave":false,"commonPopup":{popup:'',show:false},"isSaving":false,"loadprebuilt":{load:false,src:''},"isToolBarExpanded":true,"projectType":"horizontal","selectedScenes":[],"animakerType":'full',"innerActiveTab":'PREBUILT',"currentActiveTab":'library',"multimovePlayHead":null,"projectid":"","projectUsr":"","projectUsrImg":"","socketid":"","selectionBox":{},"connections":{},"openLibrarySection":false,"screenshots":{},"projectThumb":"","audioSync":false,"addNewScene":false,"recentColors":[],"screenShotsHandler":{frequency:5,currentCount:0,random:Math.random(),loading:false},"workspaceStage":{left:{menu:70,library:350,toggle:20,padding:0},top:{menu:60,zoomControlMargin:10,zoomControl:0,padding:0},right:{maxPropertyWindow:300,padding:0},bottom:{timeline:0,playerControlMargin:0,playerControl:0,padding:0},workspace:{sceneToolBarMargin:0,sceneToolbar:0}},"toastNotifications":[],"colorPalettes":{},"themes":{},"addressBook":[],"sharedWith":[],"oldTimelineTab":"objectTab","loaders":{sharing:false,exporting:false},"userDetails":{},"loadedFonts":{fonts:{},scenes:[],fontTracking:{}},"audiosTracked":false,"saveHandler":{scenes:[],count:0,limit:5},"editClicked":false,"confirmPopup":{show:false},"playRunningTime":{seconds:"00",minutes:"00",hours:"00"},"undoProp":{},'isUploadInProcess':false,'isUploadFromOutside':false,"toolPreviewStarted":false,'browserName':navigator.userAgent.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i),"tempPlayhead":0,"anymsUploadStatus":null,"highlightUpload":false,"isEdit":false,"isToolCropping":false,"isFullScreen":false,"currentScene":null,"currentSceneNumber":null,"currentSceneStartTime":null,"currentSceneDuration":null,"autoPlay":false,"isFit":true,"isapplyEffecttoAllSlides":false,"hyperLinkData":{isHyperLinkEnabled:false,isHyperLinkAdded:false},"isProjectRestore":false,"isfontLoadedTxtGrp":false,"isShapeInGrp":false,suggestionPopup:{show:false,type:''},nextBtnClicked:false,isSuggestionOn:true,isSugg:false,firstLoad:true,suggPos:{},isUserActive:0,addedUpload:{addUpload:false,sceneNo:0},fileToUpload:'',itemToUpdate:'',draggedFile:'',"isLoaded":false,"isPlayerTweenComplete":false,"isWsTweenComplete":false,textOffset:0,zoomVideoStatus:null,actionSearchProgress:true,templateThumbnails:{thumbnails:[],status:null},libCurrentFolder:'My Files',libSection:null,labelData:{},isNewAction:false,loadComplete:false,bgCategoryLoad:false,"slideLabelData":[],isTextClicked:false,"assetArray":[]});var randomColors=["#00bcd4","#FFEB3B","#8bc34a","#ff9800","#673ab7","#ff5722","#f27927","#f95d77","#e34840","#f985e4","#9378d6"];var changeTimelineDisplayDuration=function changeTimelineDisplayDuration(duration,zoomPercentage){var newDisplayDuration=duration-duration*zoomPercentage/100;return parseInt(newDisplayDuration,10)<1?1:parseFloat(newDisplayDuration.toFixed(1));};function disableSelection(state){state=state.set("selectedItems",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));state=state.set("isCropping",false).set("isFraming",false).set("isBgCropping",false);return state;}function getZoom(workspaceStage,workspaceWidth,workspaceHeight,zoomFactor,isFit){var padding=0;if(isFit)padding=30;var stageLeft=workspaceStage.getIn(["left","menu"])+workspaceStage.getIn(["left","library"])+workspaceStage.getIn(["left","toggle"])+workspaceStage.getIn(["left","padding"])+padding;var stageTop=workspaceStage.getIn(["top","menu"])+workspaceStage.getIn(["top","zoomControlMargin"])+workspaceStage.getIn(["top","zoomControl"])+workspaceStage.getIn(["top","padding"])+padding;var stageRight=window.innerWidth-(workspaceStage.getIn(["right","maxPropertyWindow"])+workspaceStage.getIn(["right","padding"])+padding+workspaceStage.getIn(["workspace","sceneToolBarMargin"])+workspaceStage.getIn(["workspace","sceneToolbar"]));var stageBottom=window.innerHeight-(workspaceStage.getIn(["bottom","timeline"])+workspaceStage.getIn(["bottom","playerControlMargin"])+workspaceStage.getIn(["bottom","playerControl"])+padding+workspaceStage.getIn(["bottom","padding"]));var stageWidth=stageRight-stageLeft;var stageHeight=stageBottom-stageTop;var scale=void 0;if(!workspaceStage.get("isLocked")){var widthScale=stageWidth/workspaceWidth;var heightScale=stageHeight/workspaceHeight;scale=Math.min(widthScale,heightScale);}else{scale=zoomFactor;}return scale;}function getPropertyWindowWidth(showSlide,windowName){var width=300;if(!showSlide&&windowName===""){width=0;}// else if(windowName === "action"){width = 355;}
// else if(windowName === "settings" ||  windowName === "animate" || windowName === "filterSetting" || 
// windowName === "color"){width = 300 ;}
// else if( windowName ==="transition"){width = 325;}
// else if( windowName ==="bgColor"){width = 260;}
// else{width= 230;}
return width;}function localStore(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var color;var selectedItems;var currentVal;var allTextItems;var loadedFonts;var textOptions;var key;var isActive;var loadedFonts;var loadedFonts;var loadedFonts;var currentZoom;var currentZoom;var tweenDuration;var isRepeated;var chart;var i;var allTextItems;var loadedFonts;var loadedFonts;var i;var scene;var allTextItems;var allFonts;var i;var scene;var allTextItems;var scene;var allTextItems;var userItem;var color;var userItem;var color;var toPush;var allNotifications;var _ret=function(){switch(action.type){case"APP_LOAD_PROGRESS":state=state.set("appLoadProgressValue",state.get("appLoadProgressValue")+action.data);return{v:state};case'FETCH_ACTION_SEARCH':state=state.setIn(['actionSearchProgress'],true);return{v:state};case'LOAD_ACTIONSEARCH_DATA':state=state.setIn(['actionSearchProgress'],false);return{v:state};case'SUGGESTION_POPUP':state=state.setIn(['suggestionPopup','show'],action.data.show);state=state.setIn(['suggestionPopup','type'],action.data.type);state=state.setIn(['suggestionPopup','subType'],action.data.subType);return{v:state};case'SUGG_POS':state=state.setIn(['suggPos','top'],action.data.top);state=state.setIn(['suggPos','left'],action.data.left);return{v:state};case'NEXT_BTN_CLICKED':state=state.setIn(['nextBtnClicked'],action.data);return{v:state};case'UPDATE_SUGGESTION':state=state.setIn(['isSuggestionOn'],action.data);return{v:state};case'UPDATE_USER_ACTIVE':state=state.setIn(['isUserActive'],action.data);return{v:state};case"EDIT_CLICKED":state=state.set('editClicked',!state.get('editClicked'));return{v:state};case"DROP_NEW_SCENE":state=state.setIn(["addNewScene"],action.data);return{v:state};case'ADDED_UPLOAD':state=state.setIn(['addedUpload','addUpload'],action.data.addUpload);state=state.setIn(['addedUpload','sceneNo'],action.data.sceneNo);return{v:state};case'FILE_TO_UPLOAD':state=state.set('fileToUpload',action.data);return{v:state};case'ITEM_TO_UPDATE':state=state.set('itemToUpdate',Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data));return{v:state};case"INITIATE_PROJECT":state=state.set("displayDuration",action.data.project.duration);state=state.set("animdisplayDuration",action.data.project.scenes[0].duration);state=state.set("width",action.data.project.width);state=state.set("height",action.data.project.height);if(action.data.project.scenes[0].workspaceBG.type==="STOCKVID"||action.data.project.scenes[0].workspaceBG.type==="UPVIDEO"){state=state.set("timelineHeight",130);state=state.set("visibleTimelineTab","musicTab");state=state.setIn(["workspaceStage","bottom","timeline"],130);}if(action.data.project.scenes[0]!==undefined){(function(){if(action.data.project.scenes[0].workspaceBG.type==="ZOOM"&&action.data.project.scenes[0].workspaceBG.isBlob){state=state.set("zoomVideoStatus","start");}var loadedFonts=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]);for(var _i=0;_i<action.data.project.scenes.length;_i++){var _scene=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.project.scenes[_i]);allTextItems=_scene.get("workspaceItems").filter(function(value,key){return value.get("type")==="TEXT"||value.get("type")==="SHAPE";});allTextItems=allTextItems.merge(_scene.get("workspaceChildren").filter(function(value,key){return value.get("type")==="TEXT"||value.get("type")==="SHAPE";}));console.log(allTextItems);if(allTextItems.size>0){// eslint-disable-next-line 
allTextItems.entrySeq().forEach(function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];var textData=value.get("textData");// eslint-disable-next-line 
if(loadedFonts.find(function(x){return textData.getIn(["formats","containerStyle","fontFamily"])&&x.get("load")===textData.getIn(["formats","containerStyle","fontFamily"]).replace(/^[\"]|[\"]$/g,"");})===undefined&&textData.getIn(["formats","others","family"])!==undefined&&(textData.getIn(["formats","others","cssUrl"])||!textData.getIn(["formats","others","isUserFont"]))){var userFontUrl=__WEBPACK_IMPORTED_MODULE_2__config_app_json___default.a.UPLOADS.font_src;var assetUrl=__WEBPACK_IMPORTED_MODULE_2__config_app_json___default.a['ASSETS'][__WEBPACK_IMPORTED_MODULE_2__config_app_json___default.a['ASSETS']['current']];var cssUrl=textData.getIn(["formats","others","cssUrl"])||textData.getIn(["formats","others","family"]);var url=textData.getIn(["formats","others","isUserFont"])&&!cssUrl.includes("admin-fonts")?cssUrl.indexOf("https://")===0?cssUrl:''+userFontUrl+cssUrl:cssUrl.indexOf("https://")===0?cssUrl:assetUrl+'animaker/admin-fonts/'+cssUrl+'.css';loadedFonts=loadedFonts.push(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({font:textData.getIn(["formats","others","family"]),load:textData.getIn(["formats","containerStyle","fontFamily"]),byUser:textData.getIn(["formats","others","isUserFont"])===true,isLoaded:false,url:url}));}var partialFonts=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_utilityMethods__["b" /* preloadTextFonts */])(textData.get("htmlText"));var _loop=function _loop(fontData){if(loadedFonts.find(function(x){return x.get("url")===fontData.url;})===undefined){loadedFonts=loadedFonts.push(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(fontData));}};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=partialFonts[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var fontData=_step.value;_loop(fontData);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}});}}var prevLoadedFonts=state.getIn(["loadedFonts","fonts"]);if(prevLoadedFonts&&prevLoadedFonts.size>0){// when initiate project is called second time (for pptx import), we need to maintain previous font load status to prevent infinite loader in text component
var groupedPrevLoadedFonts=prevLoadedFonts.groupBy(function(loadedFont){return loadedFont.get("load");});var groupedNewLoadedFonts=loadedFonts.groupBy(function(loadedFont){return loadedFont.get("load");});groupedNewLoadedFonts.forEach(function(newLoadedFontList,newLoad){if(groupedPrevLoadedFonts.get(newLoad)===undefined){newLoadedFontList.forEach(function(newLoadedFont){prevLoadedFonts=prevLoadedFonts.push(newLoadedFont);});}});loadedFonts=prevLoadedFonts;}state=state.setIn(["loadedFonts","fonts"],loadedFonts);})();}return{v:state};case"LOAD_COLOR_THEMES":if(action.data!==undefined){if(action.data.colorPalettes!==undefined){var val=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])({});Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])(action.data.colorPalettes).map(function(v,i){val=val.set(i,Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(v));});state=state.set("colorPalettes",val);}if(action.data.themes!==undefined)state=state.set("themes",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.themes));}return{v:state};case"SET_SELECTED_ITEMS_COMPLETE":if(action.socketid!==action.currentSocketId){var _connections=state.get("connections");if(!_connections.has(action.socketid)){color=randomColors[0];state=state.setIn(['connections',action.socketid,"color"],color);}state=state.setIn(['connections',action.socketid,"selectedItems"],action.selectedItems);state=state.setIn(['connections',action.socketid,"projectUsr"],action.projectUsr);state=state.setIn(['connections',action.socketid,"userId"],action.userId);state=state.setIn(['connections',action.socketid,"projectUsrImg"],action.projectUsrImg);}return{v:state};case"SET_SELECTED_SCENE_COMPLETE":if(action.socketid!==action.currentSocketId){var _connections2=state.get("connections");if(!_connections2.has(action.socketid)){color=randomColors[0];state=state.setIn(['connections',action.socketid,"color"],color);}state=state.setIn(['connections',action.socketid,"selectedScene"],action.selectedItems);state=state.setIn(['connections',action.socketid,"projectUsr"],action.projectUsr);state=state.setIn(['connections',action.socketid,"userId"],action.userId);state=state.setIn(['connections',action.socketid,"projectUsrImg"],action.projectUsrImg);}return{v:state};case"AUTO_SAVE_DATA":state=state.set("enableAutoSave",action.data);return{v:state};case"SAVE_START":state=state.set("isSaving",true);return{v:state};case"SAVE_DONE":state=state.set("isSaving",false);return{v:state};case"CHANGE_LIB_BG":state=state.set("BGDrop",action.data);return{v:state};case"LOAD_PROJECT":state=state.set("projectid",action.projectid);state=state.set("projectUsr",action.projectUsr);state=state.set("socketid",action.socketid);state=state.set("userId",action.userId);state=state.set("projectUsrImg",action.projectUsrImg);if(action.mode==='slide'){state=state.set("isPreview",true);}return{v:state};case"ADD_SCENE_COMPLETE":if(action.currentSocketId===action.socketId){state=state.set("selectedScene",action.slideIndex);state=state.set("selectedItems",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));if(state.getIn(["propertyWindow","component"])!==""){state=state.setIn(["propertyWindow","component"],"").setIn(["propertyWindow","isOpened"],false);state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}state=state.set("selectedMedias",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));state=state.set('audioPlayHead',action.newslide.startTime);state=state.setIn(["addNewScene"],false);state=state.set("isCropping",false).set("isFraming",false).set("isBgCropping",false);if(state.get("visibleTimelineTab")==="musicTab"||state.get("visibleTimelineTab")==="bgColorTab"){var _newTime=state.get("displayDuration")+action.newslide.duration;state=state.set("displayDuration",changeTimelineDisplayDuration(_newTime,state.get("timeScaleZoom")));}state=state.set("animdisplayDuration",changeTimelineDisplayDuration(action.newslide.duration,state.get("animTimeScaleZoom")));}else if(action.slideIndex<=state.get("selectedScene")){state=state.set("selectedScene",state.get("selectedScene")+1);state=state.set("selectedScenes",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([state.get("selectedScene")]));}state=state.set("selectedScenes",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([state.get("selectedScene")]));return{v:state};case'DROP_BG':case'CHANGE_BG':if(action.data.isTrimedVideo){state=state.set("isBGVideoSwapinLite",true);}else{state=state.set("isBGVideoSwapinLite",false);}state=state.set("selectedCamera","");state=state.set("selectedMedias",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));if(action.data.bgType!=="BG"){state=state.set('visibleTimelineTab',"musicTab");state=state.set("selectedItems",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));if(state.getIn(["propertyWindow","component"])!=="")state=state.setIn(["propertyWindow","component"],"").setIn(["propertyWindow","isOpened"],false);state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}state=state.set("isCropping",false);state=state.set("isFraming",false);state=state.set("isBgCropping",false);state=state.set("isVideoCropping",false);if(state.get("visibleTimelineTab")==="musicTab"){state=state.set("displayDuration",changeTimelineDisplayDuration(action.totalDuration,state.get("timeScaleZoom")));}state=state.set("bgVideoWidth",action.bgVideoWidth);state=state.set("bgVideoHeight",action.bgVideoHeight);if((state.get("anymsUploadStatus")==="processing"||action.data.isSample)&&action.data.isBlob!==true){state=state.set("anymsUploadStatus","completed");}return{v:state};case"LOAD_MAIN_FOLDERS":state=state.setIn(["userMainFolders","parent"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.parent));return{v:state};case"LOAD_FOLDERS":state=state.setIn(["userFolders","items"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])());Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data).entrySeq().forEach(function(_ref3){var _ref4=_slicedToArray(_ref3,2),key=_ref4[0],value=_ref4[1];state=state.setIn(["userFolders","items",key],value);});state=state.setIn(["userFolders","parent"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.parent));return{v:state};case"DUPLICATE_SCENE":state=state.set('audioPlayHead',action.playHeadValue);return{v:state};case'DELETE_ITEM_COMPLETE':if(state.get("textStatus").get("id")!==null){state=state.set("textStatus",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({id:null,isSelected:false,isFocused:false,container:null,isRTL:false,isGrouped:false,fontSize:null}));state=state.update("isWorkspaceTextFocus",function(value){return false;});}selectedItems=state.get("selectedItems");for(var index=0;index<action.workspaceIds.length;index++){currentVal=action.workspaceIds[index];selectedItems=selectedItems.filter(function(obj){return obj!==currentVal;});}state=state.set("selectedItems",selectedItems);if(state.get("selectedItems").size===0){if(state.getIn(["propertyWindow","component"])!=="")state=state.setIn(["propertyWindow","component"],"").setIn(["propertyWindow","isOpened"],false);state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}return{v:state};case"DUPLICATE_SCENE_COMPLETE":if(action.currentSocketId===action.socketId){state=state.set("selectedScene",action.slideIndex);state=state.set("selectedScenes",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([action.slideIndex]));state=state.set("selectedItems",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));if(state.getIn(["propertyWindow","component"])!==""){state=state.setIn(["propertyWindow","component"],"").setIn(["propertyWindow","isOpened"],false);state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}state=state.set("isCropping",false).set("isFraming",false).set("isBgCropping",false);}else if(action.slideIndex<=state.get("selectedScene")){state=state.set("selectedScene",state.get("selectedScene")+1);state=state.set("selectedScenes",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([state.get("selectedScene")]));}var newTime=action.newslide.duration+state.get("displayDuration");state=state.set("displayDuration",changeTimelineDisplayDuration(newTime,state.get("timeScaleZoom")));return{v:state};case"SHOW_LIBRARY":state=state.set("showLibrary",action.data);return{v:state};case"SHOW_SLIDE_PANEL":state=state.set("showSlidePanel",action.data.show);return{v:state};case"MOVE_SCENE_COMPLETE":if(action.socketId!==action.currentSocketId){if(state.get("selectedScene")===action.oldIndex)state=state.set("selectedScene",action.newIndex);else{if(action.oldIndex<state.get("selectedScene")&&action.newIndex>=state.get("selectedScene")){state=state.update("selectedScene",function(x){return x-1;});}else if(action.oldIndex>state.get("selectedScene")&&action.newIndex>=state.get("selectedScene")){state=state.update("selectedScene",function(x){return x+1;});}}}else{state=state.set("selectedScene",action.newIndex);}var changedConnections=state.get("connections").filter(function(x){return x.get("selectedScene")===action.oldIndex;});changedConnections.entrySeq().forEach(function(_ref5){var _ref6=_slicedToArray(_ref5,2),key=_ref6[0],value=_ref6[1];changedConnections=changedConnections.setIn([key,"selectedScene"],action.newIndex);});state=state.set("connections",state.get("connections").merge(changedConnections));state=state.set("selectedScenes",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([state.get("selectedScene")]));return{v:state};case"MOVE_SCENE":state=state.set('selectedItems',Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));state=state.set('selectedScenes',Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));state=state.set("audioPlayHead",action.playheadVal);return{v:state};case"SET_SELECTED_SCENE":state=state.set("selectedScene",action.data);state=state.set('audioPlayHead',action.playHead);state=state.update("isWorkspaceTextFocus",function(value){return false;});if(action.selectedScenes!==undefined)state=state.set("selectedScenes",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.selectedScenes));else state=state.set("selectedScenes",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));if(state.get("selectedItems").size>0){state=state.set("selectedItems",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));if(state.getIn(["propertyWindow","component"])!==""){state=state.setIn(["propertyWindow","component"],"").setIn(["propertyWindow","isOpened"],false);state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}}if(state.get("isCropping"))state=state.set("isCropping",false);if(state.get("isFraming"))state=state.set("isFraming",false);if(state.get("isBgCropping"))state=state.set("isBgCropping",false);if(state.get("isVideoCropping"))state=state.set("isVideoCropping",false);if(state.get("selectedCamera")!==""){state=state.set("selectedCamera","");}state=state.set("animdisplayDuration",changeTimelineDisplayDuration(action.newduration,state.get("animTimeScaleZoom")));return{v:state};case"REMOVE_SCENE":state=state.set('audioPlayHead',action.newPlayheadVaue);state=state.set("animdisplayDuration",changeTimelineDisplayDuration(action.selectedSceneDuration,state.get("animTimeScaleZoom")));state=state.set("displayDuration",changeTimelineDisplayDuration(action.totalDuration,state.get("timeScaleZoom")));return{v:state};case"REMOVE_SCENE_COMPLETE":if(action.currentSocketId===action.socketId||action.slideIndex===state.get("selectedScene")){state=state.set("selectedScene",action.slideIndex===0?0:action.slideIndex<=state.get("selectedScene")?state.get("selectedScene")-1:state.get("selectedScene"));if(state.get("selectedCamera")!==""){state=state.set("selectedCamera","");}if(state.get("selectedItems").size>0){state=state.set("selectedItems",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));state=state.set("isCropping",false).set("isFraming",false).set("isBgCropping",false);}if(state.getIn(["propertyWindow","component"])!==""){state=state.setIn(["propertyWindow","component"],"").setIn(["propertyWindow","isOpened"],false);state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}}else if(action.slideIndex<=state.get("selectedScene")){state=state.set("selectedScene",state.get("selectedScene")===0?0:state.get("selectedScene")-1);}state=state.set("selectedScenes",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([state.get("selectedScene")]));state=state.set('selectedMedias',Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));return{v:state};case"APP_LOADED":state=state.set('firstLoad',false);return{v:state};case"ADD_OBJECT_COMPLETE":if(action.socketId===action.currentSocketId){if(action.workspaceIds.length>0){state=state.set("selectedItems",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceIds));if(action.workspaceData.length===1){var addedItem=action.workspaceData[0];if(addedItem.type==="CHR"){state=state.set("propertyWindow",state.get("propertyWindow").merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({component:"action",isOpened:true,type:addedItem.type,"subWindow":""})));state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}else{state=state.set("propertyWindow",state.get("propertyWindow").merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({component:"settings",isOpened:true,"subWindow":"",type:addedItem.type})));state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}}}if(state.get("swapDetails")!==null&&state.get("swapDetails").isSwitch&&!action.workspaceData[0].isSwitch){state=state.set("swapDetails",null);}if(state.get("currentPosition")!==null)state=state.set("currentPosition",null);if(state.get("selectedCamera")!=="")state=state.set("selectedCamera","");state=state.set('visibleTimelineTab',"objectTab");state=state.set("isCropping",false);state=state.set("isFraming",false);state=state.set("isBgCropping",false);state=state.set("isVideoCropping",false);if(state.getIn(["textStatus","id"])!==undefined&&state.getIn(["textStatus","id"])!==null)state=state.set("textStatus",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({id:null,isSelected:false,isFocused:false,container:null,isRTL:false,isGrouped:false,fontSize:null}));}allTextItems=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceData).filter(function(value,key){return value.get("type")==="TEXT"||value.get("type")==="SHAPE";});allTextItems=allTextItems.merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceChildData).filter(function(value,key){return value.get("type")==="TEXT"||value.get("type")==="SHAPE";}));loadedFonts=state.getIn(["loadedFonts","fonts"]);if(allTextItems.size>0){allTextItems.entrySeq().forEach(function(_ref7){var _ref8=_slicedToArray(_ref7,2),key=_ref8[0],value=_ref8[1];var textData=value.get("textData");if(loadedFonts.find(function(x){return x.get("load")===textData.getIn(["formats","containerStyle","fontFamily"]);})===undefined&&textData.getIn(["formats","others","family"])!==undefined){loadedFonts=loadedFonts.push(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({font:textData.getIn(["formats","others","family"]),load:textData.getIn(["formats","containerStyle","fontFamily"]),byUser:textData.getIn(["formats","others","isUserFont"])===true,isLoaded:false,url:textData.getIn(["formats","others","cssUrl"])}));}});if(!state.getIn(["loadedFonts","fonts"]).equals(loadedFonts)){state=state.setIn(["loadedFonts","fonts"],loadedFonts);if(action.workspaceData.length===1){var addedObj=action.workspaceData[0];if(addedObj.type==='GROUP'&&addedObj.subType==='TXTGRP')state=state.set('isfontLoadedTxtGrp',true);}}}return{v:state};case"SET_LABEL_VALUES":state=state.setIn(["labelData"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data));return{v:state};case"SET_PLAY":if(state.get('isPlayAll')){if(state.get('t1')!==null){state.get('t1').kill();state.get('t1').eventCallback("onComplete",null);state.get('t1').eventCallback("onUpdate",null);state.get('t1').eventCallback("onStart",null);state.get('t1').clear();state=state.set('t1',null);}state=state.set("isTweening",false);state=state.set('visibleTimelineTab',state.get('oldTimelineTab'));state=state.set('isPlayAll',false);}if(!action.data){state=state.set('isPlayerTweenComplete',false);state=state.set('isWsTweenComplete',false);state=state.set('isLoaded',false);}state=state.set('selectedItems',Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));if(state.get("fromStart"))state=state.set("fromStart",false);if(state.getIn(["propertyWindow","component"])!==""){state=state.setIn(["propertyWindow","component"],"").setIn(["propertyWindow","isOpened"],false);}state=state.set('isPlay',action.data);state=state.set('tweenCount',0);state=state.set('loadCount',0);state=state.set("propertyWindow",state.get("propertyWindow").merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({component:"",isOpened:false})));if(action.data){state=state.set('t1',new __WEBPACK_IMPORTED_MODULE_1_gsap__["f" /* TimelineMax */]({paused:true}));state=state.set("textStatus",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({id:null,isSelected:false,isFocused:false,container:null,isRTL:false,isGrouped:false,fontSize:null}));state=state.update("isWorkspaceTextFocus",function(value){return false;});state=state.set("selectedMedias",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));state=state.set("isTweening",true);state=state.set('selectedCamera',"");if(action.data===false&&state.get("toolPreviewStarted"))state=state.set("toolPreviewStarted",false);}else{if(state.get('t1')!==null){state.get('t1').kill();state.get('t1').eventCallback("onComplete",null);state.get('t1').eventCallback("onUpdate",null);state.get('t1').eventCallback("onStart",null);state.get('t1').clear();state=state.set('t1',null);}state=state.set("isTweening",false);}state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor")));return{v:state};case'SET_PLAY_ALL':if(!action.data){state=state.set('isPlayerTweenComplete',false);state=state.set('isWsTweenComplete',false);state=state.set('isLoaded',false);}state=state.set('selectedItems',Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));state=state.set('selectedCamera',"");state=state.set('isPlayAll',action.data);if(action.fromStart===true){state=state.set("tempPlayhead",state.get('audioPlayHead'));state=state.set('audioPlayHead',0);if(parseInt(state.get("isUserActive"))===0&&action.data===true){state=state.set("toolPreviewStarted",true);}}if(action.data===false&&state.get("toolPreviewStarted"))state=state.set("toolPreviewStarted",false);if(action.fromStart===false||state.get('fromStart')&&action.fromStart===undefined){state=state.set('audioPlayHead',state.get("tempPlayhead"));}if(state.get('isPlay'))state=state.set('isPlay',false);state=state.set('tweenCount',0);state=state.set('loadCount',0);state=state.set("propertyWindow",state.get("propertyWindow").merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({component:"",isOpened:false})));if(action.fromStart!==undefined)state=state.set("fromStart",action.fromStart);else if(state.get("fromStart"))state=state.set("fromStart",false);if(action.data){state=state.set('t1',new __WEBPACK_IMPORTED_MODULE_1_gsap__["f" /* TimelineMax */]({paused:true}));state=state.set("textStatus",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({id:null,isSelected:false,isFocused:false,container:null,isRTL:false,isGrouped:false,fontSize:null}));state=state.update("isWorkspaceTextFocus",function(value){return false;});state=state.set("selectedMedias",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));state=state.set("isTweening",true);state=state.set('oldTimelineTab',state.get('visibleTimelineTab'));state=state.set('visibleTimelineTab',"musicTab");}else{if(state.get('t1')!==null){state.get('t1').kill();state.get('t1').eventCallback("onComplete",null);state.get('t1').eventCallback("onUpdate",null);state.get('t1').eventCallback("onStart",null);state.get('t1').clear();state=state.set('t1',null);}state=state.set("isTweening",false);state=state.set('visibleTimelineTab',state.get('oldTimelineTab'));}// state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor")));
return{v:state};case"SET_ISSHAPEINGRP":state=state.set("isShapeInGrp",action.data);return{v:state};case"UPDATE_TEXT_STATUS":if(action.data.isFocused){state=state.update("isWorkspaceTextFocus",function(value){return true;});state=state.setIn(["propertyWindow","component"],"settings").setIn(["propertyWindow","isOpened"],true);state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}else if(state.getIn(["textStatus","isFocused"])&&action.data.isFocused===false&&!action.data.isSelected){state=state.update("isWorkspaceTextFocus",function(value){return false;});if(state.getIn(["propertyWindow","component"])==="settings"){state=state.setIn(["propertyWindow","component"],"").setIn(["propertyWindow","isOpened"],false);state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}}else{state=state.update("isWorkspaceTextFocus",function(value){return false;});}state=state.set("currentPosition",null);state=state.set("textStatus",state.get("textStatus").merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data)));return{v:state};case"SET_TEXT_OPTIONS":textOptions=state.get("textOptions");for(key in action.data){var property=key,value=action.data[key];if(property!=="isBullet"){if(property!=="colors"){if(property==="unlink"){value=null;property="link";}isActive=value!==null&&value!=="normal";if(property==="bullet"){isActive=textOptions.getIn(["bullet","isActive"]);}textOptions=textOptions.setIn([property,"value"],value).setIn([property,"isActive"],isActive);}else{textOptions=textOptions.set("colors",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(value));}}else{textOptions=textOptions.setIn(["bullet","isActive"],value);}}if(!state.get("textOptions").equals(textOptions))state=state.set("textOptions",textOptions);return{v:state};case"CHANGE_TEXT":if(action.data.settings!==undefined){if(action.data.settings.property!=="isBullet"){var _property=action.data.settings.property,_value=action.data.settings.value;if(_property==="fontSize")_value=_value!==null?parseFloat(_value,10):null;if(_property==="unlink"){_value=null;_property="link";}isActive=_value!==null;if(_property==="bullet")isActive=state.getIn(["textOptions","bullet","isActive"]);state=state.setIn(["textOptions",_property,"value"],_value).setIn(["textOptions",_property,"isActive"],isActive);if(_property==="color")state=state.setIn(["textOptions","colors"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));}else{state=state.setIn(["textOptions","bullet","isActive"],action.data.settings.value);}if(state.getIn(["textStatus","selectedAll"]))state=state.setIn(["textStatus","selectedAll"],false);}return{v:state};case"UPDATE_TEXT":if(action.data.isGrouped){state=state.set("textUpdated",0);}textOptions=state.get("textOptions");if(action.data.property!=="isBullet"){var _value2=action.data.value,_property2=action.data.property;if(action.data.property==="fontSize")_value2=_value2!==null?parseFloat(_value2,10):null;if(action.data.property==="letterSpacing")_value2=_value2!==null?parseFloat(_value2,10):null;isActive=_value2!==null;if(_property2==="bullet"){isActive=state.getIn(["textOptions","bullet","isActive"]);if(state.getIn(["textOptions","textAlign","value"])!=="left")state=state.setIn(["textOptions","textAlign","value"],"left");}state=state.setIn(["textOptions",_property2,"value"],_value2).setIn(["textOptions",_property2,"isActive"],isActive);if(_property2==="fontFamily"&&action.data.textData!==undefined){state=state.setIn(["textOptions","fontFamily","value"],_value2);if(action.data.fontLoaded===true){loadedFonts=state.getIn(["loadedFonts","fonts"]);var loadedFont=loadedFonts.find(function(x){return x.get("load")===_value2;});if(loadedFont===undefined){if(action.data.family!==undefined)state=state.setIn(["loadedFonts","fonts"],loadedFonts.push(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({font:action.data.family,load:_value2,byUser:action.data.textData.getIn(["formats","others","isUserFont"]),isLoaded:true,url:action.data.textData.getIn(["formats","others","cssUrl"])})));state=state.setIn(["loadedFonts","fontTracking",action.data.id],true);}else if(loadedFont.get("isLoaded")===false){var fontIndex=loadedFonts.findIndex(function(x){return x.get("load")===_value2;});state=state.setIn(["loadedFonts","fontTracking",action.data.id],true);state=state.setIn(["loadedFonts","fonts",fontIndex,"isLoaded"],true);}}}}else{state=state.setIn(["textOptions","bullet","isActive"],action.data.value);}var selectedAll=false;if(action.data.selectedAll!==undefined&&action.data.selectedAll&&state.getIn(["textStatus","isFocused"]))selectedAll=true;if(state.getIn(["textStatus","selectedAll"])!==selectedAll){state=state.setIn(["textStatus","selectedAll"],selectedAll);}return{v:state};case"UPDATE_GROUP_TEXT":if(action.data.propertyUpdate){var _value3=action.data.value,_property3=action.data.property;if(action.data.property==="fontSize")_value3=_value3!==null?parseFloat(_value3,10):null;if(action.data.property==="letterSpacing")_value3=_value3!==null?parseFloat(_value3,10):null;isActive=_value3!==null;if(_property3==="bullet"){isActive=state.getIn(["textOptions","bullet","isActive"]);if(state.getIn(["textOptions","textAlign","value"])!=="left")state=state.setIn(["textOptions","textAlign","value"],"left");}state=state.setIn(["textOptions",_property3,"value"],_value3).setIn(["textOptions",_property3,"isActive"],isActive);var _selectedAll=false;if(action.data.selectedAll!==undefined&&action.data.selectedAll&&state.getIn(["textStatus","isFocused"]))_selectedAll=true;if(state.getIn(["textStatus","selectedAll"])!==_selectedAll){state=state.setIn(["textStatus","selectedAll"],_selectedAll);}}return{v:state};case"UPDATE_TEXT_COMPLETE":if(action.formats.containerStyle.fontFamily!==undefined){loadedFonts=state.getIn(["loadedFonts","fonts"]);if(loadedFonts.find(function(x){return x.get("load")===action.formats.containerStyle.fontFamily;})===undefined&&action.formats.others.family!==undefined){state=state.setIn(["loadedFonts","fonts"],loadedFonts.push(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({font:action.formats.others.family,load:action.formats.containerStyle.fontFamily,byUser:action.formats.others.isUserFont,isLoaded:false,url:action.formats.others.cssUrl})));}}return{v:state};case"UPDATE_OBJECT_COMPLETE":if(action.toUpdate.textData!==undefined&&action.toUpdate.textData.formats.containerStyle.fontFamily!==undefined&&action.toUpdate.textData.formats.others.family!==undefined){loadedFonts=state.getIn(["loadedFonts","fonts"]);if(loadedFonts.find(function(x){return x.get("load")===action.toUpdate.textData.formats.containerStyle.fontFamily;})===undefined&&action.toUpdate.textData.formats.others.family!==undefined){state=state.setIn(["loadedFonts","fonts"],loadedFonts.push(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({font:action.toUpdate.textData.formats.others.family,load:action.toUpdate.textData.formats.containerStyle.fontFamily,byUser:action.toUpdate.textData.formats.others.isUserFont,isLoaded:false,url:action.toUpdate.textData.formats.others.cssUrl,id:action.selectedItem})));state=state.setIn(["loadedFonts","fontTracking",action.selectedItem],false);}}return{v:state};case"SET_SELECTED_ITEMS":state=state.set("selectedItems",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.selectedItems));if(state.getIn(['propertyWindow','type'])!=='ANIM'){state=state.setIn(['propertyWindow','type'],action.data.type);state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}state=state.update("isWorkspaceTextFocus",function(value){return false;});state=state.set('selectedKeyframe','');if(action.data.currentPosition!==undefined)state=state.set("currentPosition",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.currentPosition));else state=state.set("currentPosition",null);state=state.set("selectedCamera","");if(action.data.selectedItems.length>0){state=state.set("visibleTimelineTab","objectTab");if(action.selectedSceneDuration){state=state.set("animdisplayDuration",changeTimelineDisplayDuration(action.selectedSceneDuration,state.get("animTimeScaleZoom")));}}if(state.getIn(["textStatus","id"])!==null)state=state.set("textStatus",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({id:null,isSelected:false,isFocused:false,container:null,isRTL:false,isGrouped:false,fontSize:null}));state=state.set("isCropping",false);state=state.set("isFraming",false);state=state.set("isBgCropping",false);state=state.set("isVideoCropping",false);if(action.data.selectedItems.length===1&&state.get("swapDetails")!==null&&action.data.selectedItems[0]!==state.get("swapDetails").id||action.data.selectedItems.length!==1){state=state.set('swapDetails',null);document.getElementById("app-overlay").style.display="none";}if(action.data.selectedItems.length===null){state=state.set("propertyWindow",state.get("propertyWindow").merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({component:"",isOpened:false,type:action.data.type})));state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}if(state.getIn(["transformStatus","transforming"]))state=state.set("transformStatus",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({transforming:false,moving:false,resizing:false,rotating:false}));if(state.get("selectedScenes").size>1)state=state.set("selectedScenes",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([state.get("selectedScene")]));if(state.getIn(['propertyWindow','type'])!=='ANIM'){if(action.data.selectedItems.length===1){if(action.data.type==="CHR"){if(state.get("swapDetails")===null&&state.getIn(['propertyWindow','isOpened'])===false||state.get("swapDetails")===null&&state.getIn(['propertyWindow','isOpened'])===true&&state.getIn(['propertyWindow','component'])=='bgColor'){state=state.set("propertyWindow",state.get("propertyWindow").merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({component:"action",isOpened:true,"subWindow":"",type:action.data.type})));state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}}else{state=state.set("propertyWindow",state.get("propertyWindow").merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({component:"settings",isOpened:true,"subWindow":"",type:action.data.type})));state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}}else{state=state.set("propertyWindow",state.get("propertyWindow").merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({component:"",isOpened:false})));state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}}return{v:state};case"TOGGLE_CROP":if(state.get("currentPosition")!==null)state=state.set("currentPosition",null);currentZoom=getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"));if(currentZoom<state.get("zoomFactor"))state=state.set("zoomFactor",currentZoom);return{v:state.update("isCropping",function(value){return!value;})};case"TOGGLE_FRAME":return{v:state.update("isFraming",function(value){return!value;})};case"TOGGLE_BG_CROP":currentZoom=getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"));if(currentZoom<state.get("zoomFactor"))state=state.set("zoomFactor",currentZoom);state=state.update("isBgCropping",function(value){return!value;});return{v:state};case"UPDATE_TRANSFORM_STATUS":state=state.set("transformStatus",state.get("transformStatus").merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data)));return{v:state};case"START_PLAY":if(action.data==="player")state=state.set("isPlayerTweenComplete",true);if(action.data==="workspace")state=state.set("isWsTweenComplete",true);if(state.get("isPlayerTweenComplete")&&state.get("isWsTweenComplete")&&!state.get("isLoaded")){state=state.set("isLoaded",true);if(state.get("isPlay"))state.get('t1').play();else{var startTime=state.getIn(['labelData','sceneStartTime',''+state.get('currentSceneNumber')]);state.get('t1').play(startTime);}}return{v:state};case'SET_PLAYER_POSITION':if(state.get('isPlayAll')){if(action.data==='Prev'){if(state.get('t1').currentLabel()!==null){state.get('t1').play((parseInt(state.get('t1').currentLabel())-1).toString(),false);}}else{if(state.get('t1').currentLabel()<state.get('t1').getLabelsArray().length){state.get('t1').play((parseInt(state.get('t1').currentLabel()===null?0:state.get('t1').currentLabel())+1).toString(),false);}}}return{v:state};case'ADD_SLIDELABEL_DATA':if(action.data==='')state=state.setIn(['slideLabelData'],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));else state=state.setIn(['slideLabelData'],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data));return{v:state};case'SET_SLIDE_JUMP':var slideLabelList=state.getIn(['slideLabelData']);if(state.get('isPlayAll')){slideLabelList.entrySeq().forEach(function(_ref9){var _ref10=_slicedToArray(_ref9,2),key=_ref10[0],value=_ref10[1];if(action.data-1===0)state.get('t1').play(parseInt(0).toString(),false);if(parseInt(action.data-1)===value.get('slide')){state.get('t1').play(parseInt(value.get('label')).toString(),false);}});}return{v:state};case'SET_SCENE_POSITION':if(state.get('isPlayAll')){state=state.set('currentScene',action.data);state=state.set('currentSceneNumber',action.currentSceneNumber);state=state.set('selectedScene',action.currentSceneNumber);state=state.set('currentSceneStartTime',action.currentSceneStartTime);state=state.set('currentSceneDuration',action.currentSceneDuration);}else if(state.get('isPreview')){state=state.set('currentScene',action.data);state=state.set('currentSceneNumber',action.currentSceneNumber);state=state.set('selectedScene',action.currentSceneNumber);}return{v:state};case"ADD_TWEEN":if(action.tweenType==="addchartween"){tweenDuration=action.data.endTime-action.data.startTime;isRepeated=1;//(action.data.isRepeated === "0") ? 0 : -1;
if(action.data.type==="PROP"&&action.data.isAnimated){isRepeated=action.data.repeatLoop===0?-1:action.data.repeatLoop-1;}if(action.data.type==="SCREEN")isRepeated=0;// const timelineEaseName = action.data.timeline.length ?
//   action.data.timeline.filter(val => (typeof val.toVal.ease === "string")).map(val => val.toVal.ease)
//   : [];
chart=new __WEBPACK_IMPORTED_MODULE_1_gsap__["f" /* TimelineMax */]({repeat:isRepeated,paused:true});for(i=0;i<action.data.timeline.length;i++){chart.add(__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].to(action.data.timeline[i].domVal,action.data.timeline[i].duration,action.data.timeline[i].toVal),action.data.timeline[i].time);}// state.get('t1').add(chart, action.data.startTime)
state.get('t1').addCallback(function(chartimeline){chartimeline.play(0);},state.getIn(["labelData",action.data.idVal,"enterStart"]).toString(),[chart]);if(action.data.type==="SCREEN"){state.get('t1').add(__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].fromTo(document.getElementById(action.data.idVal),0.001,{autoAlpha:0},{autoAlpha:1}),state.getIn(["labelData",action.data.idVal,"enterStart"]).toString());state.get('t1').add(__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].to(document.getElementById(action.data.idVal),0.001,{autoAlpha:0}),(state.getIn(["labelData",action.data.idVal,"enterStart"])+0.9).toString());}// var mouthtimeline = new TimelineMax({ paused: true, repeat: -1 });
// for (i = 0; i < action.data.mouthValues.length; i++) {
//   mouthtimeline.add(TweenMax.to(action.data.mouthValues[i].domVal, action.data.mouthValues[i].duration, action.data.mouthValues[i].toVal), action.data.mouthValues[i].time)
// }
// for (var m = 0; m < action.data.voiceData.length; m++) 
// {
//   for (var jj = 0; jj < action.data.voiceData[m].length-1; jj++) {
//     var time = parseFloat(action.data.voiceData[m][jj].split(",")[0]) - action.data.lipSyncStart[m]
//     var decibal = (time <0)?0:action.data.voiceData[m][jj].split(",")[1]
//     if(jj === action.data.voiceData[m].length-2)
//       decibal = 0;
//     if(time > action.data.playStart[m]) 
//     {
//       state.get('t1').addCallback(function (t1, pauseVal) {
//         t1.pause(pauseVal);
//       }
//       , time, [mouthtimeline, decibal])
//     }
//   }
// }
}else if(action.tweenType==="fromTo")state.get('t1').add(__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].fromTo(action.data.playerDOM,action.data.startTime,action.data.fromVal,action.data.toVal),action.data.time);else if(action.tweenType==="addCallback")state.get('t1').addCallback(action.data.callBack,action.data.startTime,action.data.dataArr);else if(action.tweenType==="eventCallback")state.get('t1').eventCallback("onUpdate",action.data.callBack);else if(action.tweenType==="onStart"){state.get('t1').eventCallback("onStart",action.data.callBack);}else if(action.tweenType==="from")state.get('t1').add(__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].from(action.data.playerDOM,action.data.startTime,action.data.fromVal),action.data.time);else if(action.tweenType==="to")state.get('t1').add(__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].to(action.data.playerDOM,action.data.startTime,action.data.toVal),action.data.time);else if(action.tweenType==="staggerFromTo")state.get('t1').add(__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].staggerFromTo(action.data.playerDOM,action.data.startTime,action.data.fromVal,action.data.toVal,action.data.staggerTime),action.data.time);else if(action.tweenType==="staggerTo")state.get('t1').staggerTo(action.data.playerDOM,action.data.startTime,action.data.toVal,action.data.staggerTime,action.data.time);else if(action.tweenType==="staggerFrom")state.get('t1').staggerFrom(action.data.playerDOM,action.data.startTime,action.data.fromVal,action.data.staggerTime,action.data.time,action.data.onComplete);else if(action.tweenType==="set"){if(action.data.setType==="styles")state.get('t1').add(__WEBPACK_IMPORTED_MODULE_1_gsap__["g" /* TweenMax */].set(action.data.playerDOM,action.data.setVal));else state.get('t1').set({},{},action.data.time);}return{v:state};case"CHANGE_PLAYTIME":state=state.set('playTime',action.data);return{v:state};case"MOVE_UPDATE":state.set("transformStatus",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({transforming:false,moving:false,resizing:false,rotating:false}));if(state.get("currentPosition")!==null)state=state.set("currentPosition",null);return{v:state};case"MOVE_UPDATE_COMPLETE":if(state.get("undoResize"))state=state.set("undoResie",false);return{v:state.set("transformStatus",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({transforming:false,moving:false,resizing:false,rotating:false}))};case"RESIZE_UPDATE":case"ROTATION_UPDATE":if(!state.get("undoResize"))state=state.set("undoResie",true);return{v:state.set("transformStatus",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({transforming:false,moving:false,resizing:false,rotating:false}))};case'DELETE_ITEM':if(state.get("textStatus").get("id")!==null){state=state.set("textStatus",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({id:null,isSelected:false,isFocused:false,container:null,isRTL:false,isGrouped:false,fontSize:null}));state=state.update("isWorkspaceTextFocus",function(value){return false;});}if(state.getIn(["propertyWindow","component"])!==""){state=state.setIn(["propertyWindow","component"],"");state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}if(state.get("swapDetails")!==null){state=state.set("swapDetails",null);}state=state.set("selectedItems",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));state=state.set("isCropping",false).set("isFraming",false).set("isBgCropping",false);if(state.getIn(["propertyWindow","component"])!==""){state=state.setIn(["propertyWindow","component"],"").setIn(["propertyWindow","isOpened"],false);state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}state=state.set("multiEffect",[]);return{v:state};case"CHANGE_TIMELINE_TAB_NAME":state=state.set('selectedItems',Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));state=state.set('visibleTimelineTab',action.tabName);state=state.set("selectedMedias",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));state=state.set("BGDrop","");state=state.setIn(["propertyWindow","component"],"").setIn(["propertyWindow","isOpened"],false);state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));if(action.globalStart&&action.tabName==="musicTab")state=state.set('audioPlayHead',action.globalStart);if(action.tabName==="cameraTab")state=state.set('selectedCamera',action.staticCam);if(action.tabName!=="cameraTab"&&state.get("selectedCamera")!=="")state=state.set("selectedCamera","");if(action.tabName!=="musicTab"&&action.tabName!=="bgColorTab"&&action.duration){var newDisplayDuration=action.duration-action.duration*state.get("animTimeScaleZoom")/100;state=state.set("animdisplayDuration",parseInt(newDisplayDuration,10)<1?1:newDisplayDuration);}else{if(action.duration){var _newDisplayDuration=action.duration-action.duration*state.get("timeScaleZoom")/100;state=state.set("displayDuration",parseInt(_newDisplayDuration,10)<1?1:_newDisplayDuration);}}return{v:state};case"UPDATE_TIMELINE_DRAG":if(action.item==="workspaceItems"){for(var _itr=0;_itr<action.data.length;_itr++){if(action.data[_itr].name==='duration'){state=state.set("selectedCamera","");state=state.set("selectedItems",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));state=state.set("isCropping",false).set("isFraming",false).set("isBgCropping",false);if(state.getIn(["propertyWindow","component"])!==""){state=state.setIn(["propertyWindow","component"],"").setIn(["propertyWindow","isOpened"],false);state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}state=state.set("selectedMedias",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));}}if(action.nextDuration)state=state.set("displayDuration",changeTimelineDisplayDuration(action.nextDuration,state.get("timeScaleZoom")));}return{v:state};case"UPDATE_TIMELINE_DRAG_COMPLETE":var itr=0;var isBackTrim=false;if(action.itemData==="workspaceItems"){for(itr=0;itr<action.actionData.length;itr++){if(action.actionData[itr].name==="videoEnd")isBackTrim=true;if(action.actionData[itr].name==='duration'&&action.actionData[itr].value<state.get('audioPlayHead')){if(isBackTrim)state=state.set('audioPlayHead',action.actionData[itr].sceneStartTime+action.actionData[itr].value);else state=state.set('audioPlayHead',action.actionData[itr].sceneStartTime);}}}return{v:state};if(action.category==="VIDEO"){state=state.set("selectedScene",action.id[0]);state=state.set("selectedScenes",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([action.id[0]]));state=state.set('audioPlayHead',action.time);}if(state.get("selectedItems").size>0){state=state.set("selectedItems",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));if(state.getIn(["propertyWindow","component"])!==""){state=state.setIn(["propertyWindow","component"],"").setIn(["propertyWindow","isOpened"],false);state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}state=state.set("isCropping",false).set("isFraming",false).set("isBgCropping",false);}if(state.getIn(["propertyWindow","component"])!==""){state=state.setIn(["propertyWindow","component"],"");state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}state=state.update("isWorkspaceTextFocus",function(value){return false;});state=state.update("selectedMedias",function(value){return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.id);});return{v:state};case"DELETE_VIDEO":return{v:state.set("selectedMedias",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]))};case"SET_WORKSPACE_TEXT_FOCUS":if(state.getIn(["textStatus","isFocused"]))state=state.update("isWorkspaceTextFocus",function(value){return true;});else state=state.update("isWorkspaceTextFocus",function(value){return action.value;});return{v:state};case'SET_MUSIC_DATA':state=state.set('musicData',Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data));return{v:state};case"SET_ZOOM":if(action.data.zoomFactor!==undefined)state=state.set("zoomFactor",action.data.zoomFactor);if(action.data.workspaceBounds!==undefined)state=state.set("workspaceBounds",state.get("workspaceBounds").merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.workspaceBounds)));if(action.data.fromUser!==undefined&&action.data.fromUser){state=state.setIn(["workspaceStage","isLocked"],true);}if(state.get("zoomFactor")<0.01)state=state.set("zoomFactor",0.01);return{v:state};case"CHANGE_BG_COMPLETE":case"DROP_BG_COMPLETE":if(action.socketId!==action.currentSocketId&&action.deleteId!==""){state=state.set("selectedItems",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));if(state.getIn(["propertyWindow","component"])!==""){state=state.setIn(["propertyWindow","component"],"").setIn(["propertyWindow","isOpened"],false);state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}state=state.set("isCropping",false).set("isFraming",false).set("isBgCropping",false);state=state.set("multiEffect",[]);}return{v:state};case"CROP_BG":state=state.set("transformStatus",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({transforming:false,moving:false,resizing:false,rotating:false}));state=state.set("isVideoCropping",false);return{v:state.set("isBgCropping",false)};case"TOGGLE_VIDEO_CROP":state=state.set("cropVideoId",action.id);return{v:state.update("isVideoCropping",function(value){return!value;})};case"TOGGLE_CROP":return{v:state.update("isCropping",function(value){return!value;})};case"TOGGLE_FRAME":return{v:state.update("isFraming",function(value){return!value;})};case"CROP_IMAGE":state=state.set("transformStatus",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({transforming:false,moving:false,resizing:false,rotating:false}));state=state.set("isCropping",false);state=state.set("isFraming",false);if(state.get("currentPosition")!==null)state=state.set("currentPosition",null);return{v:state};case"TOGGLE_GRID":return{v:state.update("workspaceGrid",function(value){return!value;})};case'SWAP_ITEM_UNDO':state=state.set("undoProp",action.data);return{v:state};case'SWAP_ITEM':state=state.set("textStatus",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({id:null,isSelected:false,isFocused:false,container:null,isRTL:false,isGrouped:false,fontSize:null}));state=state.update("isWorkspaceTextFocus",function(value){return false;});state=state.set('visibleTimelineTab',"objectTab");state=state.set("swapDetails",action.data!==""?action.data:null);if(action.data.libType!==undefined){state.set('innerActiveTab',action.data.libType);}if(action.data.isBG)state=state.set("BGDrop",action.data.libType);else if(action.data==="")state=state.set("BGDrop","");return{v:state};case"COPY_ITEM_TYPE":state=state.set('copiedItem',action.data);return{v:state};case"COPY_OBJECTS":return{v:state.update("isCopyObject",function(value){return action.value;})};case"CUT_OBJECTS":return{v:state.update("isCutObject",function(value){return action.value;})};case"PASTE_OBJECTS":if(action.value===false)state=state.update("selectedMedias",function(value){return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]);});if(state.get("currentPosition")!==null)state=state.set("currentPosition",null);return{v:state.update("isPasteObject",function(value){return action.value;})};case"PASTE_ITEMS_COMPLETE":if(action.currentSocketId===action.socketId||action.selectedScene===state.get("selectedScene")){if(action.currentSocketId===action.socketId){if(state.get("currentPosition")!==null)state=state.set("currentPosition",null);state=state.set('visibleTimelineTab',"objectTab");state=state.set('selectedCamera',"");state=state.set("selectedItems",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceIds));}}allTextItems=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceData).filter(function(value,key){return value.get("type")==="TEXT"||value.get("type")==="SHAPE";});allTextItems=allTextItems.merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.workspaceChildData).filter(function(value,key){return value.get("type")==="TEXT"||value.get("type")==="SHAPE";}));loadedFonts=state.getIn(["loadedFonts","fonts"]);if(allTextItems.size>0){allTextItems.entrySeq().forEach(function(_ref11){var _ref12=_slicedToArray(_ref11,2),key=_ref12[0],value=_ref12[1];var textData=value.get("textData");if(loadedFonts.find(function(x){return x.get("load")===textData.getIn(["formats","containerStyle","fontFamily"]);})===undefined&&textData.getIn(["formats","others","family"])!==undefined){loadedFonts=loadedFonts.push(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({font:textData.getIn(["formats","others","family"]),load:textData.getIn(["formats","containerStyle","fontFamily"]),byUser:textData.getIn(["formats","others","isUserFont"])===true,isLoaded:false,url:textData.getIn(["formats","others","cssUrl"])}));}});if(!state.getIn(["loadedFonts","fonts"]).equals(loadedFonts)){state=state.setIn(["loadedFonts","fonts"],loadedFonts);}}return{v:state};case"PASTE_SCENES_COMPLETE":loadedFonts=state.getIn(["loadedFonts","fonts"]);for(i=0;i<action.scenes.length;i++){scene=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.scenes[i]);if((typeof scene==='undefined'?'undefined':_typeof(scene))==="object"){allTextItems=scene.get("workspaceItems").filter(function(value,key){return value.get("type")==="TEXT"||value.get("type")==="SHAPE";});allTextItems=allTextItems.merge(scene.get("workspaceChildren").filter(function(value,key){return value.get("type")==="TEXT"||value.get("type")==="SHAPE";}));if(allTextItems.size>0){allTextItems.entrySeq().forEach(function(_ref13){var _ref14=_slicedToArray(_ref13,2),key=_ref14[0],value=_ref14[1];var textData=value.get("textData");if(loadedFonts.find(function(x){return x.get("load")===textData.getIn(["formats","containerStyle","fontFamily"]);})===undefined&&textData.getIn(["formats","others","family"])!==undefined){loadedFonts=loadedFonts.push(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({font:textData.getIn(["formats","others","family"]),load:textData.getIn(["formats","containerStyle","fontFamily"]),byUser:textData.getIn(["formats","others","isUserFont"])===true,isLoaded:false,url:textData.getIn(["formats","others","cssUrl"])}));}});}}}state=state.setIn(["loadedFonts","fonts"],loadedFonts);return{v:state};case"GROUP_OBJECTS_COMPLETE":if(action.currentSocketId===action.socketId||state.get("selectedItems").some(function(r){return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.removeIds).includes(r);})){state=state.set("selectedItems",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([Object.keys(action.workspaceItems)[0]]));if(state.getIn(["textStatus","id"])!==undefined&&state.getIn(["textStatus","id"])!==null)state=state.set("textStatus",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({id:null,isSelected:false,isFocused:false,container:null,isRTL:false,isGrouped:false,fontSize:null}));state=state.set("propertyWindow",state.get("propertyWindow").merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({component:"settings",isOpened:true,"subWindow":"",type:"GROUP"})));state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));state=state.set("currentPosition",null);}return{v:state};break;case"UNGROUP_OBJECTS_COMPLETE":if(action.currentSocketId===action.socketId||state.get("selectedItems").includes(action.removeIds[0])){state=state.set("selectedItems",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(Object.keys(action.workspaceChildren)));state=state.set("propertyWindow",state.get("propertyWindow").merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({component:"",isOpened:false})));state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));if(state.getIn(["textStatus","id"])!==undefined&&state.getIn(["textStatus","id"])!==null)state=state.set("textStatus",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({id:null,isSelected:false,isFocused:false,container:null,isRTL:false,isGrouped:false,fontSize:null}));state=state.set("currentPosition",null);}else{}return{v:state};break;case"SET_PROPERTY_WINDOW":if(action.data.subWindow===undefined){state=state.setIn(["propertyWindow","component"],action.data.component);state=state.setIn(["propertyWindow","subWindow"],"");state=state.setIn(["propertyWindow","type"],action.data.type);state=state.setIn(["propertyWindow","isOpened"],true);if(action.data.selectedScene!==undefined){if(action.data.selectedScene!==state.get("selectedScene")){state=disableSelection(state);}state=state.set("selectedScene",action.data.selectedScene);state=state.set("selectedScenes",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([state.get("selectedScene")]));}if(action.data.component===""){state=state.setIn(["propertyWindow","isOpened"],false);}if(action.data.component==="transition"){state=disableSelection(state);}if(action.data.component==="settings"&&action.data.type==="text"){state=state.set("textStatus",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({id:null,isSelected:false,isFocused:false,container:null,isRTL:false,isGrouped:false,fontSize:null}));}}else if(action.data.component&&action.data.component!==''&&action.data.subWindow&&action.data.subWindow!==''){state=state.setIn(["propertyWindow","component"],action.data.component);state=state.setIn(["propertyWindow","subWindow"],action.data.subWindow);state=state.setIn(["propertyWindow","type"],action.data.type);state=state.setIn(["propertyWindow","isOpened"],true);}else{state=state.setIn(["propertyWindow","subWindow"],action.data.subWindow);}state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));return{v:state};break;case"COPY_FILTER":if(action.subtype==="BG")state=state.set("clonedBgFilter",action.data);return{v:state};case"DISPLAY_COMMON_POPUP":state=state.update("isWorkspaceTextFocus",function(value){return false;});if(action.value!==undefined&&action.value!==null){state=state.setIn(["commonPopup","popup"],action.value);state=state.setIn(["commonPopup","show"],!state.getIn(['commonPopup','show']));}else{if(action.status!==undefined&&!action.status){state=state.setIn(["commonPopup","popup"],action.value);state=state.setIn(["commonPopup","show"],action.status);}}return{v:state};case"APPLY_FILTER":case"UPDATE_VIDEO_DATA":state=state.setIn(["commonPopup","popup"],'');state=state.setIn(["commonPopup","show"],false);return{v:state};case"FONT_UPLOADED":allFonts=state.get("userFonts");return{v:state.set("userFonts",allFonts.push(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data)))};case"SET_USER_FONTS":if(action.data.length>0)state=state.set("userFonts",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data));return{v:state};case"SET_SHARE_DETAILS":if(action.data.addressBook!==undefined){state=state.set("addressBook",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.addressBook));}if(action.data.sharedWith!==undefined){state=state.set("sharedWith",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.sharedWith));}return{v:state};case"SET_PREBUILT_LOAD":if(state.getIn(['liteChanges','newScene']))state=state.setIn(['liteChanges','newScene'],false);state=state.set('loadprebuilt',Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({load:action.data,src:action.source}));return{v:state};case"ADD_PREBUILT":state=state.set("prebuiltScenes",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.sceneThumbs));return{v:state};case"ADD_PREBUILT_COMPLETE":if(action.currentSocketId===action.socketId||action.addAll&&action.replace||action.replace&&action.selectedScene===state.get("selectedScene")){state=state.update("selectedMedias",function(value){return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]);});state=state.update("selecteCamera",function(value){return"";});state=state.update("selectedKeyframe",function(value){return"";});state=state.set("selectedItems",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));if(state.getIn(["propertyWindow","component"])!==""){state=state.setIn(["propertyWindow","component"],"").setIn(["propertyWindow","isOpened"],false);state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}state=state.set("isCropping",false).set("isFraming",false).set("isBgCropping",false);if(action.currentSocketId===action.socketId){state=state.set("selectedScene",action.selectedScene);state=state.set("confirmPopup",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({show:false}));}if(action.addAll&&action.replace)state=state.set("selectedScene",0);state=state.set("selectedScenes",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([state.get("selectedScene")]));state=state.set('loadprebuilt',Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({load:true,src:''}));}var loadedFonts=state.getIn(["loadedFonts","fonts"]);if(action.addAll){var scenes=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.prebuiltData.project.scenes);state=state.set("audioPlayHead",scenes.getIn([0,"playHeadValue"]));for(i=0;i<scenes.size;i++){scene=scenes.get(i);allTextItems=scene.get("workspaceItems").filter(function(value,key){return value.get("type")==="TEXT"||value.get("type")==="SHAPE";});allTextItems=allTextItems.merge(scene.get("workspaceChildren").filter(function(value,key){return value.get("type")==="TEXT"||value.get("type")==="SHAPE";}));if(allTextItems.size>0){allTextItems.entrySeq().forEach(function(_ref15){var _ref16=_slicedToArray(_ref15,2),key=_ref16[0],value=_ref16[1];var textData=value.get("textData");if(textData.getIn(["formats","others","family"])!==undefined&&loadedFonts.find(function(x){return x.get("load")===textData.getIn(["formats","containerStyle","fontFamily"]);})===undefined){loadedFonts=loadedFonts.push(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({font:textData.getIn(["formats","others","family"]),load:textData.getIn(["formats","containerStyle","fontFamily"]),byUser:textData.getIn(["formats","others","isUserFont"])===true,isLoaded:false,url:textData.getIn(["formats","others","cssUrl"])}));}});}}state=state.set("displayDuration",changeTimelineDisplayDuration(parseFloat(action.prebuiltData.project.duration.toFixed(1)),state.get("timeScaleZoom")));}else{scene=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.prebuiltData);state=state.set("animDisplayDuration",changeTimelineDisplayDuration(parseFloat(action.prebuiltData.duration.toFixed(1)),state.get("timeScaleZoom")));state=state.set("audioPlayHead",action.prebuiltData.duration);if(action.prebuiltData.workspaceBG.type!=="UPVIDEO"&&action.prebuiltData.workspaceBG.type!=="STOCKVID")state=state.set("visibleTimelineTab","objectTab");allTextItems=scene.get("workspaceItems").filter(function(value,key){return value.get("type")==="TEXT"||value.get("type")==="SHAPE";});allTextItems=allTextItems.merge(scene.get("workspaceChildren").filter(function(value,key){return value.get("type")==="TEXT"||value.get("type")==="SHAPE";}));if(allTextItems.size>0){allTextItems.entrySeq().forEach(function(_ref17){var _ref18=_slicedToArray(_ref17,2),key=_ref18[0],value=_ref18[1];var textData=value.get("textData");if(textData.getIn(["formats","others","family"])!==undefined&&loadedFonts.find(function(x){return x.get("load")===textData.getIn(["formats","containerStyle","fontFamily"]);})===undefined){loadedFonts=loadedFonts.push(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({font:textData.getIn(["formats","others","family"]),load:textData.getIn(["formats","containerStyle","fontFamily"]),byUser:textData.getIn(["formats","others","isUserFont"])===true,isLoaded:false,url:textData.getIn(["formats","others","cssUrl"])}));}});}}state=state.setIn(["loadedFonts","fonts"],loadedFonts);return{v:state};case"TOGGLE_TOOLBAR":state=state.update("isToolBarExpanded",function(value){return!value;});return{v:state};case"UPDATE_SELECTION_BOX":return{v:state};break;case"SOCKET_CONNECTED":if(action.socketId!==action.currentSocketId){(function(){var connections=state.get("connections");if(!connections.has(action.socketId)){userItem=connections.filter(function(obj,key){return obj.get("userId")===action.userId;});color=randomColors[0];if(userItem.size>0){color=userItem.first().get("color");}else if(connections.size>0){var _loop2=function _loop2(_i2){connections.entrySeq().forEach(function(_ref19){var _ref20=_slicedToArray(_ref19,2),key=_ref20[0],value=_ref20[1];if(connections.getIn([action.socketId,"color"])!==randomColors[_i2]){color=randomColors[_i2];}});};for(var _i2=0;_i2<=randomColors.length;_i2++){_loop2(_i2);}}state=state.setIn(['connections',action.socketId,"color"],color);}state=state.setIn(['connections',action.socketId,"selectedItems"],action.selectedItems);state=state.setIn(['connections',action.socketId,"selectedScene"],0);state=state.setIn(['connections',action.socketId,"projectUsr"],action.projectUsr);state=state.setIn(['connections',action.socketId,"userId"],action.userId);state=state.setIn(['connections',action.socketId,"projectUsrImg"],action.imageUrl);})();}return{v:state};case"SOCKET_DISCONNECTED":state=state.set("connections",state.get("connections").delete(action.data));return{v:state};break;case"OPEN_LIBRARY_SECTION_TOOGLE":state=state.set("openLibrarySection",action.data.status);return{v:state};break;case"RESIZE_PROJECT":state=state.set("projectType",action.data.type);return{v:state};case"SET_CURRENT_POSITION":state=state.set("currentPosition",action.data);return{v:state};case'FROM_OUTSIDE_UPLOAD':state=state.set('isUploadFromOutside',action.data);return{v:state};case'IS_UPLOAD_IN_PROCESS':state=state.set('isUploadInProcess',action.data);return{v:state};case"NEW_SOCKET_CONNECTED":var connections=state.get("connections");if(!connections.has(action.data.socketId)){userItem=connections.filter(function(obj,key){return obj.get("userId")===action.data.userId;});color=randomColors[0];if(userItem.size>0){color=userItem.first().get("color");}else if(connections.size>0){var _loop3=function _loop3(_i3){connections.entrySeq().forEach(function(_ref21){var _ref22=_slicedToArray(_ref21,2),key=_ref22[0],value=_ref22[1];if(connections.getIn([action.data.socketId,"color"])!==randomColors[_i3]){color=randomColors[_i3];}});};for(var _i3=0;_i3<=randomColors.length;_i3++){_loop3(_i3);}}state=state.setIn(['connections',action.data.socketId,"color"],color);}state=state.setIn(['connections',action.data.socketId,"selectedItems"],action.data.selectedItems.length>0?action.data.selectedItems[0]:null);state=state.setIn(['connections',action.data.socketId,"selectedScene"],action.data.selectedScene);state=state.setIn(['connections',action.data.socketId,"projectUsr"],action.data.userName);state=state.setIn(['connections',action.data.socketId,"userId"],action.data.userId);state=state.setIn(['connections',action.data.socketId,"projectUsrImg"],action.data.imageUrl);return{v:state};case'SET_TEXT_FOCUS':state=state.update("isWorkspaceTextFocus",function(value){return action.value;});return{v:state};case"UPDATE_RECENT_COLORS":state=state.set("recentColors",action.data.colors);return{v:state};case"MANAGE_TOAST":if(action.data.action==="add"){toPush={id:Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString()};toPush=Object.assign(toPush,action.data);state=state.set("toastNotifications",state.get("toastNotifications").push(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(toPush)));}else if(action.data.action==="delete"){allNotifications=state.get("toastNotifications");allNotifications=allNotifications.delete(allNotifications.findKey(function(x){return x.get("id")===action.data.id;}));state=state.set("toastNotifications",allNotifications);}if(state.getIn(["loaders","sharing"])===true)state=state.setIn(["loaders","sharing"],false);if(state.getIn(["loaders","duplicate"])===true)state=state.setIn(["loaders","duplicate"],false);return{v:state};case"SHARE_PROJECT":state=state.setIn(["loaders","sharing"],true);return{v:state};case"DUPLICATE_PROJECT":state=state.setIn(["loaders","duplicate"],true);return{v:state};case"UPDATE_USER_DETAILS":state=state.set("userDetails",state.get("userDetails").merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data)));if(action.data.anymsUser===false)state=state.set("isUserActive",1);return{v:state};case"UPDATE_FONTS":if(!state.getIn(["loadedFonts","scenes"]).has(action.data.selectedScene))state=state.setIn(["loadedFonts","fonts"],action.data.fonts).setIn(["loadedFonts","scenes"],state.getIn(["loadedFonts","scenes"]).push(action.data.selectedScene));return{v:state};case"FONT_LOADED":var loadedIndex=state.getIn(["loadedFonts","fonts"]).findKey(function(x){return x.get("load")===action.data.load;});if(loadedIndex!==undefined){state=state.setIn(["loadedFonts","fonts",loadedIndex,"isLoaded"],true);state=state.setIn(["loadedFonts","fontTracking",action.data.id],true);if(state.get('isfontLoadedTxtGrp'))state=state.set('isfontLoadedTxtGrp',false);}return{v:state};case"FONT_ADDED":state=state.updateIn(["loadedFonts","fonts"],function(fonts){return fonts.push(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.font));});return{v:state};case"MANAGE_SHARE":var sharedIndex=state.get("sharedWith").findKey(function(x){return x.get("email")===action.data.email;});if(action.data.action==="delete"){if(sharedIndex!==undefined)state=state.set("sharedWith",state.get("sharedWith").delete(sharedIndex));}else if(action.data.action==="edit"||action.data.action==="view"){if(sharedIndex!==undefined)state=state.setIn(["sharedWith",sharedIndex,"edit"],action.data.action==="edit");}return{v:state};case"CONFIRM_POPUP":state=state.set("confirmPopup",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data));if(action.data.isapplyEffecttoAllSlides===false){state=state.set("isapplyEffecttoAllSlides",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.isapplyEffecttoAllSlides));}return{v:state};case'RESET_AUDIO_DATA':state=state.setIn(['ttsObj','isEdit'],false);state=state.setIn(['ttsObj','gender'],'');state=state.setIn(['ttsObj','lang'],'');state=state.setIn(['ttsObj','voice'],'');state=state.setIn(['ttsObj','data'],'');state=state.setIn(['ttsObj','isSpecific'],'');state=state.setIn(['ttsObj','audioData'],'');state=state.setIn(['ttsObj','audioId'],'');return{v:state};case"UPLOAD_AGAIN":case"UPLOADED_FILE":if(action.data.anymsUser){state=state.set("anymsUploadStatus","processing");state=state.set("isUploadFromOutside",true);}return{v:state};case"UPLOAD_FAILED":if(state.get("anymsUploadStatus")==="processing"){state=state.set("anymsUploadStatus","failed");}return{v:state};case"UPDATE_BG":if(action.data.toUpdate.isBlob===false)state=state.set("anymsUploadStatus","completed");if(action.data.toolCrop)state=state.setIn(["transformStatus","transforming"],false);return{v:state};case"ADD_HIGHLIGHTER":if(action.data.type==="upload_processing")state=state.set("highlightUpload",true);return{v:state};case"UPDATE_SLIDE":if(action.data.subType==="BG_SETTINGS"){if(action.data.value.src===""){if(state.getIn(["propertyWindow","component"])!==""){state=state.setIn(["propertyWindow","component"],"").setIn(["propertyWindow","isOpened"],false);state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}}}return{v:state};case"UNDO_MOVE":state=state.set("undoResize",action.data.resizing);return{v:state};case'DRAGGED_FILE':state=state.set('draggedFile',action.data);return{v:state};case"WRITE_TEXT":if(action.data.undo){state=state.setIn(["textStatus","isFocused"],false);}if(action.data.isTyping===false){state=state.setIn(["textStatus","currentText"],action.data.toUpdate.textData.htmlText).setIn(["textStatus","currentWidth"],action.data.toUpdate.width).setIn(["textStatus","currentHeight"],action.data.toUpdate.height).setIn(["textStatus","currentX"],action.data.toUpdate.x).setIn(["textStatus","currentY"],action.data.toUpdate.y);}return{v:state};case"SET_TEXT_WIDTH":if(action.data.undo){state=state.setIn(["textStatus","isFocused"],false);}if(action.data.isTyping===false){state=state.setIn(["textStatus","currentText"],action.data.toUpdate.textData.htmlText).setIn(["textStatus","currentWidth"],action.data.toUpdate.width).setIn(["textStatus","currentHeight"],action.data.toUpdate.height).setIn(["textStatus","currentX"],action.data.toUpdate.x).setIn(["textStatus","currentY"],action.data.toUpdate.y);}return{v:state};case"UPDATE_AUDIOS":case"UPDATE_AUDIOS_COMPLETE":state=state.set("selectedMedias",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]));return{v:state};case"UPDATE_LOCALSTORE":state=state.merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data));case"UPDATE_SCENE":state=disableSelection(state);if(state.getIn(["propertyWindow","component"])!==""&&state.getIn(["propertyWindow","component"])!=="transition"){state=state.setIn(["propertyWindow","component"],"").setIn(["propertyWindow","isOpened"],false);state=state.setIn(["workspaceStage","right","maxPropertyWindow"],getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow","component"])));state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}return{v:state};case"SET_SCENE":state=state.set("selectedScene",action.data.scene);return{v:state};case"START_SCREENSHOT":state=state.setIn(["templateThumbnails","status"],"started").setIn(["templateThumbnails","totalScenes"],action.data.totalScenes).setIn(["templateThumbnails","current"],0).setIn(["templateThumbnails","selectedScene"],state.get("selectedScene"));return{v:state};case"UPDATE_THUMBNAILS":state=state.set("templateThumbnails",state.get("templateThumbnails").merge(action.data));if(action.data.status==="completed"||action.data.status==="failed"){state=state.set("selectedScene",state.getIn(["templateThumbnails","selectedScene"]));}return{v:state};case'LIB_CURRENT_FOLDER':state=state.set('libCurrentFolder',action.data);return{v:state};case"SET_FULSCREEN":state=state.setIn(['isFullScreen'],action.data.status);state=state.setIn(['zoomFactor'],action.data.zoomFactor);state=state.setIn(['prevZoomFactor'],action.data.prevZoomFactor);if(state.get("assetArray").length>0)state=state.set("isWsTweenComplete",false);window.totalArr=state.get("assetArray");return{v:state};case'REMOVE_SCENE_POSITION':state=state.set('currentScene',null);state=state.set('currentSceneNumber',null);state=state.set('currentSceneStartTime',null);state=state.set('currentSceneDuration',null);return{v:state};case'SET_AUTO_PLAY':if(action.data!==undefined){state=state.set('autoPlay',action.data);}else{state=state.set('autoPlay',!state.get('autoPlay'));if(state.get('autoPlay')){state.get('t1').removePause().play();}else{state.get('t1').addPause(state.get('currentSceneStartTime')+state.get('currentSceneDuration'));}}return{v:state};case'SET_PREVIEW':state=state.set('isPreview',action.data);return{v:state};case'SET_WORKSPACE_STAGE':state=state.set('libSection',action.data);if(!action.data){state=state.setIn(["workspaceStage","left","menu"],0);state=state.setIn(["workspaceStage","left","library"],0);state=state.setIn(["workspaceStage","left","toggle"],0);}else{state=state.setIn(["workspaceStage","left","menu"],70);state=state.setIn(["workspaceStage","left","library"],350);state=state.setIn(["workspaceStage","left","toggle"],20);}if(!state.get('showSlidePanel')&&state.getIn(['propertyWindow','component'])===""){state=state.setIn(["workspaceStage","right","maxPropertyWindow"],0);if(state.get('isFit'))state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}else if(state.get('showSlidePanel')||state.getIn(['propertyWindow','component'])!==""){state=state.setIn(["workspaceStage","right","maxPropertyWindow"],300);if(state.get('isFit'))state=state.set("zoomFactor",getZoom(state.get("workspaceStage"),state.get("width"),state.get("height"),state.get("zoomFactor"),state.get("isFit")));}return{v:state};case'SET_ZOOM_FIT':state=state.set("isFit",action.data);return{v:state};case'SET_APPLYEFFECT_SLIDES':state=state.set("isapplyEffecttoAllSlides",action.data);return{v:state};case"APPLY_ENTER_EFFECT_COMPLETE":if(action.currentSocketId===action.socketId&&action.isUndo!==true){state=state.set("confirmPopup",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({show:false}));if(action.effectData.isapplyToallSlides){state=state.set("isapplyEffecttoAllSlides",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.effectData.isapplyToallSlides));}}if(action.isUndo===true&&action.currentSocketId===action.socketId&&Object.keys(action.sceneEffectData).length>1){state=state.set("isapplyEffecttoAllSlides",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(!action.effectData.isapplyToallSlides));}return{v:state};case"APPLY_ALL_TRANSITION":if(action.currentSocketId===action.socketId){state=state.set("confirmPopup",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({show:false}));}return{v:state};case'SET_NEW_ACTION_COMPLETE':state=state.set('isNewAction',action.data);return{v:state};case'APP_CRASHED':state=state.set("hasAppCrashed",true);state=state.set("errorData",action.errorData);return{v:state};case'PROJECT_RESTORE':state=state.set('isProjectRestore',action.data.isRestore);state=state.set('versionId',action.data.versionId);return{v:state};case'LOAD_COMPLETE':state=state.set('loadComplete',action.loadComplete);return{v:state};case'BG_CATEGORY_LOAD':state=state.set('bgCategoryLoad',action.bgCategoryLoad);return{v:state};case'SET_PAYMENT_PAST_DUE':state=state.setIn(["userDetails","pastdue","status"],action.data.status);state=state.setIn(["userDetails","pastdue","message"],action.data.message);return{v:state};case"INITIATE_MOVE":state=state.set("currentPosition",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.currentPosition));return{v:state};case"SET_IS_TEXTCLICKED":state=state.set("isTextClicked",action.data);return{v:state};case"SET_ASSET_ARRAY":state=state.set("assetArray",action.data);return{v:state};default:return{v:state};}}();if((typeof _ret==='undefined'?'undefined':_typeof(_ret))==="object")return _ret.v;}

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export onExportProject */
/* unused harmony export onShareProject */
/* unused harmony export onProjectResize */
/* unused harmony export onProjectDuplicate */
/* unused harmony export createLibraryFolder */
/* unused harmony export deleteFiles */
/* unused harmony export loadMasterLibrary */
/* unused harmony export loadLibraryUpload */
/* unused harmony export loadFolders */
/* unused harmony export moveFolder */
/* unused harmony export renameFolder */
/* unused harmony export fetchActions */
/* unused harmony export fetchSearch */
/* unused harmony export fetchStockSearch */
/* unused harmony export fetchActionSearch */
/* unused harmony export loadLibrary */
/* unused harmony export loadCategoryLibrary */
/* unused harmony export batchActions */
/* unused harmony export saveSceneThumb */
/* harmony export (immutable) */ __webpack_exports__["a"] = watchLoadProject;
/* unused harmony export watchLibraryLoader */
/* unused harmony export watchCreateLibraryFolder */
/* unused harmony export watchDeleteUserContent */
/* unused harmony export startProjectLoad */
/* unused harmony export loadUserFonts */
/* unused harmony export loadShareDetails */
/* unused harmony export setUserDetails */
/* unused harmony export watchProjectLoader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_PaymentDueHelper__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config_app_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_https__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_https___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_https__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid_v1__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid_v1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid_v1__);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(onExportProject),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(onShareProject),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(onProjectResize),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(onProjectDuplicate),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(createLibraryFolder),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteFiles),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(loadMasterLibrary),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(loadLibraryUpload),_marked9=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(loadFolders),_marked10=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(moveFolder),_marked11=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(renameFolder),_marked12=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchActions),_marked13=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchSearch),_marked14=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchStockSearch),_marked15=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchActionSearch),_marked16=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(loadLibrary),_marked17=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(loadCategoryLibrary),_marked18=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(batchActions),_marked19=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(saveSceneThumb),_marked20=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchLoadProject),_marked21=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchLibraryLoader),_marked22=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchCreateLibraryFolder),_marked23=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchDeleteUserContent),_marked24=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(startProjectLoad),_marked25=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(loadUserFonts),_marked26=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(loadShareDetails),_marked27=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setUserDetails),_marked28=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchProjectLoader);var csrftoken=getCookie('csrftoken');var encodetoken=getCookie("encoded_token");var environment=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"]["current"];function fetchUserDetails(data){var params=new URLSearchParams();params.append('projectId',data.projectId);params.append('userId',data.userId);params.append('teamId',data.teamId);return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'app/usr/slides/d/',headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params});}function fetchEffects(data){var params=new URLSearchParams();var url=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'deck/eff';params.append('id','transitioneffects_'+data.lang);return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:url,headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params});}function fetchAutoSearch(data){var params=new URLSearchParams();params.append('type',"ACTION");params.append('u',data.data.userId);var url=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'app/sgs';return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:url,headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params});}function getColorThemes(data){var params=new URLSearchParams();params.append('bf',data.hasBrand);params.append('t',data.data.teamId);params.append('u',data.data.userId);var url=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'deck/eff';params.append('id','colorthemes_'+data.data.lang);return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:url,headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params});}function fetchShareDetails(data){var params=new URLSearchParams();var url=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'share/shareDetails/';params.append("userId",data.userId);params.append("projectId",data.projectId);return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:url,headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params});}function fetchMaster(gitLib){var params=new URLSearchParams();var url=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'library/masterdata/',libData=gitLib.libData,libType=libData.type;if(libType==='VIDEO'||libType==='AUDIO'||libType==='IMG'){url=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'app/f/guploads';params.append('type',libType);params.append('userid',libData.userId);params.append('from',libData.from);params.append('size',libData.size);}else{params.append('id',libType.toLowerCase());}return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:url,headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params});}function fetchTransition(data){var params=new URLSearchParams();var url=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'deck/eff';params.append('id','scenetransitions_'+data.lang);return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:url,headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params});}function fetchUserFonts(data){var params=new URLSearchParams();params.append('userId',data.userId);params.append('t',data.teamId);params.append('bf',data.bf);return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'getFontFiles',headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params});}function postFolder(getLib){var params=new URLSearchParams();params.append('name',getLib.folder);params.append('parent',getLib.parent);params.append('userId',getLib.userId);params.append('u',getLib.userId);params.append('teamId',getLib.teamId);return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'app/f/cf',headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params});}function deleteFilesContent(getlib){var params=new URLSearchParams();params.append('id',getlib.id);params.append('u',getlib.userId);return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'app/f/df',headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params});}function fetchCategory(getLib){var params=new URLSearchParams();var url=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'app/gll/';params.append('u',getLib.userId);params.append('teamId',getLib.teamId);params.append('projectId',getLib.projectId);if(getLib.type.includes('MAS')&&(!getLib.type.includes('MASSCENEPRE')||getLib.type.includes('MASSCENEPRE')&&!getLib.propCategoryEnded)){url=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'deck/mst/';if(getLib.type.includes('MASSCENEPRE')){params.append('app','deck');}}if(getLib.type==="SHAPE"){params.append('subType',"CSTMPTH");params.append('isActive',1);}if(getLib.type==='PROP'&&getLib.subType==='EPROP'){params.append('subType',getLib.subType);}if(getLib.type==='PROP'){if(getLib.subType==='EPROP'){params.append('type','PROP');}else{params.append('type','PROP,SHAPE');}}else if(getLib.type==='PREBUILT'){params.append('type','SCENEPRE');}else{params.append('type',getLib.type);}params.append('projectSize',getLib.projectSize);if(getLib.propCategoryEnded||getLib.type==='TEXT'){url=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'deck/fprop/';}if(getLib.type==='MASGIPHY'||getLib.type==='GIPHY'){url=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'app/gif/gd';}if(getLib.type==='STOCKIMG'){url=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'app/sicol';params.append('exclusive',getLib.exclusive);}if(getLib.type==='STOCKVID'){url=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a['APIURIS'][environment]+'app/svcol';params.append('exclusive',getLib.exclusive);}if(getLib.type==="TEXT"){params.append('isActive',1);}if(getLib.type!=='STOCKIMG'&&getLib.type!=='STOCKVID'&&getLib.type!=='GIPHY')params.append('categories',getLib.categories);params.append('from',getLib.from);params.append('size',getLib.size);if(getLib.fromSearch||getLib.type==='STOCKIMG'||getLib.type==='STOCKVID'||getLib.type==='GIPHY'){var tagValue=getLib.fromSearch?getLib.tags:getLib.categories==='Top Exclusive'||getLib.categories==='All Items'?'':getLib.categories;if((getLib.type==='STOCKIMG'||getLib.type==='STOCKVID'||getLib.type==='GIPHY')&&getLib.searchtag){tagValue=getLib.searchtag;}params.append('tags',tagValue);}if(getLib.excludes!==undefined)params.append('excludes',getLib.excludes);if(getLib.hasBrand){params.append('bf',getLib.hasBrand);}return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:url,mode:'cors',withCredentials:false,credentials:'same-origin',headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},xsrfHeaderName:"X-CSRFToken",data:params});}function getCookie(name){var cookieValue=null;if(document.cookie&&document.cookie!==''){var cookies=document.cookie.split(';');for(var i=0;i<cookies.length;i++){var cookie=cookies[i].trim();// Does this cookie string begin with the name we want?
if(cookie.substring(0,name.length+1)===name+'='){cookieValue=decodeURIComponent(cookie.substring(name.length+1));break;}}}return cookieValue;}function fetchUpload(getLib,roottype){var params=new URLSearchParams();params.append('roottype',roottype);params.append('parent',getLib.parent);params.append('u',getLib.userId);params.append('t',getLib.teamId);params.append('bf',getLib.bf);if(roottype==="folder"){params.append('from',0);params.append('size',100);params.append('userId',getLib.userId);}else{params.append('from',getLib.from);params.append('size',getLib.size);params.append('userId',getLib.userId);}return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'deck/f/gf',headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params});}function moveUserFolder(getLib){var params=new URLSearchParams();params.append('selectedobjects',[getLib.id]);params.append('parent',getLib.parent);params.append('u',getLib.userId);return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'app/f/mf',headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params});}function renameUserFolder(getLib){var params=new URLSearchParams();params.append('id',getLib.id);params.append('name',getLib.name);params.append('u',getLib.userId);return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'app/f/rf',headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params});}function fetchActionData(getLib){var params=new URLSearchParams();params.append('genderType',getLib.gender);params.append('from',getLib.from);params.append('size',getLib.size);params.append('u',getLib.userId);params.append('t',getLib.teamId);params.append('type',getLib.actionToLoad);return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'app/gact',headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params});}function fetchSearchData(getLib){var params=new URLSearchParams();params.append('tags',getLib.tags);params.append('from',getLib.from);params.append('size',getLib.size);params.append('fromScroll',getLib.fromScroll);params.append('action',getLib.action);params.append('priority',getLib.priority);params.append('userId',getLib.userId);params.append('u',getLib.userId);params.append('teamId',getLib.teamId);params.append('projectSize',getLib.projectSize);params.append('projectId',getLib.projectId);if(getLib.type==='PROP'){params.append('type','PROP,SHAPE');}else{params.append('type',getLib.type);}if(getLib.type==="ACTION")params.append('genderType',getLib.genderType);return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'app/soak',headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params});}function fetchGiphyData(getLib){var params=new URLSearchParams();params.append('tags',getLib.tags);params.append('from',getLib.from);params.append('size',getLib.size);params.append('action',getLib.action);params.append('priority',getLib.priority);params.append('userId',getLib.userId);params.append('u',getLib.userId);params.append('teamId',getLib.teamId);params.append('type','GIPHY');return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'app/gif/s',headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params});}function fetchStockImgData(getLib){var params=new URLSearchParams();params.append('tags',getLib.tags);params.append('from',getLib.from);params.append('size',getLib.size);params.append('action',getLib.action);params.append('priority',getLib.priority);params.append('userId',getLib.userId);params.append('u',getLib.userId);params.append('teamId',getLib.teamId);params.append('type','STOCKIMG');params.append('exclusive',getLib.exclusive);params.append('projectId',getLib.projectId);if(getLib.fromSearch){params.append('fromSearch',getLib.fromSearch);}return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'app/sicol',headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params});}function fetchStockVideos(getLib){var params=new URLSearchParams();params.append('tags',getLib.tags);params.append('from',getLib.from);params.append('size',getLib.size);params.append('action',getLib.action);params.append('priority',getLib.priority);params.append('userId',getLib.userId);params.append('u',getLib.userId);params.append('teamId',getLib.teamId);params.append('type',getLib.type);params.append('exclusive',getLib.exclusive);params.append('projectId',getLib.projectId);if(getLib.excludes!==undefined)params.append('excludes',getLib.excludes);if(getLib.isScroll)params.append('fromScroll',getLib.isScroll);else params.append('fromScroll',false);if(getLib.fromSearch){params.append('fromSearch',getLib.fromSearch);}return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'app/svcol',headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params});}function fetchStockSearchData(getLib){var params=new URLSearchParams();params.append('tags',getLib.tags);params.append('type',getLib.type);params.append('from',getLib.from);params.append('size',getLib.size);params.append('fromScroll',getLib.fromScroll);params.append('userId',getLib.userId);params.append('u',getLib.userId);params.append('teamId',getLib.teamId);return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'SearchStock',headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params});}function exportProject(postState){var exportUrl=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+"dashboard/download_upload";var params=new URLSearchParams();for(var key in postState){params.append(key,postState[key]);}return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:exportUrl,headers:{"Content-Type":"application/x-www-form-urlencoded","X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params}).then(function(response){return response;}).catch(function(error){return'error';});}function onExportProject(getData){var postState,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function onExportProject$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!getData.isClicked){_context.next=25;break;}postState=getData.state;_context.prev=2;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(exportProject,postState);case 5:response=_context.sent;if(!(response.data.success===true)){_context.next=11;break;}_context.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'MANAGE_TOAST',data:{action:"add",type:"success","message":"ex.suc",formatId:'msg'}});case 9:_context.next=19;break;case 11:if(!(response.data.error!==undefined&&response.data.error!=="")){_context.next=16;break;}_context.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'MANAGE_TOAST',data:{action:"add",type:"error","message":response.data.error}});case 14:_context.next=19;break;case 16:if(!(response==="error")){_context.next=19;break;}_context.next=19;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'MANAGE_TOAST',data:{action:"add",type:"error","message":"common.toast.msg",link:__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment],linkName:"Marketing Video",formatId:'msg'}});case 19:_context.next=25;break;case 21:_context.prev=21;_context.t0=_context['catch'](2);_context.next=25;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'MANAGE_TOAST',data:{action:"add",type:"error","message":"common.toast.msg",formatId:'msg'}});case 25:case'end':return _context.stop();}}},_marked,this,[[2,21]]);}function shareProject(postState){var params=new URLSearchParams();for(var key in postState.data){params.append(key,postState.data[key]);}return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+"deckshare",headers:{"Content-Type":"application/x-www-form-urlencoded","X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params}).then(function(response){return response;}).catch(function(error){return'error';});}function onShareProject(getData){var response,shareDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function onShareProject$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(shareProject,getData);case 3:response=_context2.sent;if(!(response.data.shared===true)){_context2.next=14;break;}_context2.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchShareDetails,{projectId:getData.data.projectid,userId:getData.data.userId});case 7:shareDetails=_context2.sent;_context2.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:"SET_SHARE_DETAILS",data:shareDetails.data});case 10:_context2.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'MANAGE_TOAST',data:{action:"add",type:"success","message":"sh.su.w",formatId:"msg",lVal:response.data.sharedWith.length+" "+(response.data.sharedWith.length===1?"person":"people")}});case 12:_context2.next=22;break;case 14:if(!(response.data.error!==undefined&&response.data.error)){_context2.next=19;break;}_context2.next=17;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'MANAGE_TOAST',data:{action:"add",type:"error","message":response.data.message}});case 17:_context2.next=22;break;case 19:if(!(response==="error")){_context2.next=22;break;}_context2.next=22;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'MANAGE_TOAST',data:{action:"add",type:"error","message":"common.toast.msg",formatId:'msg'}});case 22:if(!response.data.sharedError){_context2.next=25;break;}_context2.next=25;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'MANAGE_TOAST',data:{action:"add",type:"error","message":response.data.alreadyShared.length+" email(s) already shared"}});case 25:if(!response.data.emailError){_context2.next=28;break;}_context2.next=28;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'MANAGE_TOAST',data:{action:"add",type:"error","message":"mt.inv.eml",formatId:'msg'}});case 28:_context2.next=34;break;case 30:_context2.prev=30;_context2.t0=_context2['catch'](0);_context2.next=34;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'MANAGE_TOAST',data:{action:"add",type:"error","message":"common.toast.msg",formatId:'msg'}});case 34:case'end':return _context2.stop();}}},_marked2,this,[[0,30]]);}/* To Resize project */function projectResize(postState){var exportUrl=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+"share/createproject/";var params=new URLSearchParams();params.append('type',postState.data.type==="vertical"?"ver":postState.data.type==="horizontal"?"hor":"sqr");params.append('userId',postState.data.userId);params.append('teamId',postState.data.teamId);params.append('projectId',postState.data.projectId);params.append('projectWidth',postState.data.projectData.width);params.append('projectHeight',postState.data.projectData.height);params.append('projectDuration',postState.data.projectData.duration);params.append('appMode',postState.data.appMode);params.append('projectData',JSON.stringify(postState.data.projectData));document.getElementById("app-overlay").style.display="block";document.getElementById("app-overlay").style.zIndex="2000";document.getElementById("app-overlay").style.backgroundColor="rgba(0,0,0,0.5)";document.getElementById("app-overlay").style.backgroundImage="url("+__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APPICONS"][__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APPICONS"]["current"]]+"/images/chr-loading.svg)";document.getElementById("app-overlay").style.backgroundPosition="center";document.getElementById("app-overlay").style.backgroundRepeat="no-repeat";document.getElementById("app-overlay").className="overlayDom-tool-bar";var newWindow=window.open();return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:exportUrl,headers:{'Content-Type':'application/x-www-form-urlencoded',"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params}).then(function(response){document.getElementById("app-overlay").className="";document.getElementById("app-overlay").style.display="none";document.getElementById("app-overlay").style.zIndex="9";document.getElementById("app-overlay").style.backgroundColor="transparent";document.getElementById("app-overlay").style.background="none";if(response.status===200){newWindow.location=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+"slides"+'/'+response.data.projectid+'/';return'export done';}else{return'export failed';}}).catch(function(error){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(error,error.message,"Saga-projectResize");newWindow.close();document.getElementById("app-overlay").className="";document.getElementById("app-overlay").style.display="none";document.getElementById("app-overlay").style.zIndex="9";document.getElementById("app-overlay").style.backgroundColor="transparent";document.getElementById("app-overlay").style.background="none";return'error';});}function onProjectResize(data){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function onProjectResize$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(projectResize,data);case 3:response=_context3.sent;_context3.next=9;break;case 6:_context3.prev=6;_context3.t0=_context3['catch'](0);Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])("Error on project resize....!",_context3.t0,"Saga-onProjectResize");case 9:case'end':return _context3.stop();}}},_marked3,this,[[0,6]]);}function duplicateProject(postState){var exportUrl=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+"moments/duplicateProject/";var params=new URLSearchParams();params.append("projectId",postState.data.projectId);params.append('userId',postState.data.userId);params.append('teamId',postState.data.teamId);document.getElementById("app-overlay").style.display="block";document.getElementById("app-overlay").style.zIndex="2000";document.getElementById("app-overlay").style.backgroundColor="rgba(0,0,0,0.5)";document.getElementById("app-overlay").style.backgroundImage="url("+__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APPICONS"][__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APPICONS"]["current"]]+"/images/chr-loading.svg)";document.getElementById("app-overlay").style.backgroundPosition="center";document.getElementById("app-overlay").style.backgroundRepeat="no-repeat";document.getElementById("app-overlay").className="overlayDom-tool-bar";var newWindow=window.open();return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:exportUrl,headers:{'Content-Type':'application/x-www-form-urlencoded',"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params}).then(function(response){newWindow.location=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+"slides"+'/'+response.data.projectId+'/';document.getElementById("app-overlay").className="";document.getElementById("app-overlay").style.display="none";document.getElementById("app-overlay").style.zIndex="9";document.getElementById("app-overlay").style.backgroundColor="transparent";document.getElementById("app-overlay").style.background="none";return response;}).catch(function(error){newWindow.close();document.getElementById("app-overlay").className="";document.getElementById("app-overlay").style.display="none";document.getElementById("app-overlay").style.zIndex="9";document.getElementById("app-overlay").style.backgroundColor="transparent";document.getElementById("app-overlay").style.background="none";return'error';});}function onProjectDuplicate(data){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function onProjectDuplicate$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(duplicateProject,data);case 3:response=_context4.sent;if(response.data.error){_context4.next=9;break;}_context4.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'MANAGE_TOAST',data:{action:"add",type:"success","message":"dup.suc",formatId:'msg'}});case 7:_context4.next=15;break;case 9:if(!response.data.data.pastdue){_context4.next=13;break;}Object(__WEBPACK_IMPORTED_MODULE_4__helpers_PaymentDueHelper__["a" /* payPaymentDue */])(data.data.propsToDispatch,data.data.teamId,'duplicate',data.data.socket,'deckupgrade','duplicate');_context4.next=15;break;case 13:_context4.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'MANAGE_TOAST',data:{action:"add",type:"error","message":response.data.message}});case 15:_context4.next=21;break;case 17:_context4.prev=17;_context4.t0=_context4['catch'](0);_context4.next=21;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'MANAGE_TOAST',data:{action:"add",type:"error","message":"common.toast.msg",formatId:'msg'}});case 21:case'end':return _context4.stop();}}},_marked4,this,[[0,17]]);}/* End Heres */function createLibraryFolder(getLib){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createLibraryFolder$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.prev=0;_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(postFolder,getLib.libData);case 3:response=_context5.sent;if(!getLib.libData.isAddLibrary){_context5.next=7;break;}_context5.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'CREATE_FOLDER_COMPLETE',data:response.data});case 7:_context5.next=14;break;case 9:_context5.prev=9;_context5.t0=_context5['catch'](0);Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(getLib.libData+" failed while creating folder ",_context5.t0,"Saga-createLibraryFolder");_context5.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'MANAGE_TOAST',data:{action:"add",type:"error","message":"err.c.f",formatId:'msg'}});case 14:case'end':return _context5.stop();}}},_marked5,this,[[0,9]]);}function deleteFiles(id,userId){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteFiles$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(deleteFilesContent,id,userId);case 2:response=_context6.sent;case 3:case'end':return _context6.stop();}}},_marked6,this);}function loadMasterLibrary(getLib){var response,type;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadMasterLibrary$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.prev=0;response='',type=getLib.libData.type;_context7.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchMaster,getLib);case 4:response=_context7.sent;if(getLib.libData.type==='VIDEO'){type='UPVIDEO';}else if(getLib.libData.type==='IMG'){type='UPIMAGE';}if(response.data.length){_context7.next=9;break;}_context7.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'RESP_UPDATE',data:{status:'failed'}});case 9:_context7.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'LOAD_MASTER_LIBRARY_COMPLETE',data:response.data,libType:type});case 11:_context7.next=16;break;case 13:_context7.prev=13;_context7.t0=_context7['catch'](0);Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(getLib.libData+" load library failed loadMasterLibrary",_context7.t0,"Saga-loadMasterLibrary");case 16:case'end':return _context7.stop();}}},_marked7,this,[[0,13]]);}function loadLibraryUpload(getLib){var responseFolder,libraries,i,responseFile,_i,errObj;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadLibraryUpload$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.prev=0;_context8.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchUpload,getLib.libData,"folder");case 3:responseFolder=_context8.sent;libraries=Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["OrderedMap"])();if(responseFolder.data.success){for(i=0;i<responseFolder.data.assets.length;i++){libraries=libraries.set(responseFolder.data.assets[i]._source.id,responseFolder.data.assets[i]._source);}}_context8.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'LOAD_FOLDERS',data:libraries,parent:responseFolder.data.parent});case 8:_context8.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'LOAD_MAIN_FOLDERS',data:libraries,parent:responseFolder.data.parent});case 10:_context8.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchUpload,getLib.libData,"file");case 12:responseFile=_context8.sent;if(responseFile.data.success){for(_i=0;_i<responseFile.data.assets.length;_i++){libraries=libraries.set(responseFile.data.assets[_i]._source.id,responseFile.data.assets[_i]._source);}}_context8.next=16;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'LOAD_LIBRARY_COMPLETE',data:libraries,libType:getLib.libData.type});case 16:_context8.next=22;break;case 18:_context8.prev=18;_context8.t0=_context8['catch'](0);errObj={err:_context8.t0,respfolder:JSON.stringify(responseFolder),respFile:JSON.stringify(responseFile),request:JSON.stringify(getLib.libData)};Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])("loadLibraryUpload:  ",errObj,"Saga-loadLibraryUpload");case 22:case'end':return _context8.stop();}}},_marked8,this,[[0,18]]);}function loadFolders(getLib){var responseFolder,libraries,i;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadFolders$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.prev=0;_context9.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchUpload,{parent:getLib.libData.id,userId:getLib.libData.userId},"folder");case 3:responseFolder=_context9.sent;libraries={};if(responseFolder.data.success){for(i=0;i<responseFolder.data.assets.length;i++){libraries[responseFolder.data.assets[i]._source.id]=responseFolder.data.assets[i]._source;}}_context9.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'LOAD_FOLDERS',data:libraries,parent:responseFolder.data.parent});case 8:_context9.next=13;break;case 10:_context9.prev=10;_context9.t0=_context9['catch'](0);Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])("Folders load in library failed ",_context9.t0,"Saga-loadFolders");case 13:case'end':return _context9.stop();}}},_marked9,this,[[0,10]]);}function moveFolder(getLib){var responseFolder;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function moveFolder$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.prev=0;_context10.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(moveUserFolder,getLib.libData);case 3:responseFolder=_context10.sent;_context10.next=9;break;case 6:_context10.prev=6;_context10.t0=_context10['catch'](0);Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])("Move folder failed ",_context10.t0,"Saga-moveFolder");case 9:case'end':return _context10.stop();}}},_marked10,this,[[0,6]]);}function renameFolder(getLib){var responseFolder;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function renameFolder$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.prev=0;_context11.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(renameUserFolder,getLib.libData);case 3:responseFolder=_context11.sent;_context11.next=9;break;case 6:_context11.prev=6;_context11.t0=_context11['catch'](0);Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])("Rename folder failed ",_context11.t0,"Saga-renameFolder");case 9:case'end':return _context11.stop();}}},_marked11,this,[[0,6]]);}function fetchActions(getLib){var response,libraries,i,errorObj;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchActions$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.prev=0;_context12.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchActionData,getLib.libData);case 3:response=_context12.sent;libraries=new Map();if(response.data.hits.length>0){for(i=0;i<response.data.hits.length;i++){libraries.set(response.data.hits[i]._source.id,response.data.hits[i]._source);}}_context12.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'LOAD_ACTIONS',data:libraries,total:response.data.total});case 8:_context12.next=14;break;case 10:_context12.prev=10;_context12.t0=_context12['catch'](0);errorObj={error:_context12.t0,request:''+JSON.stringify(getLib),response:''+JSON.stringify(response.data)};Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])('Characters action load failed fetchActions Request: ',errorObj,"Saga-fetchActions");case 14:case'end':return _context12.stop();}}},_marked12,this,[[0,10]]);}function fetchSearch(getLib){var response,upResponse,otherRes,stockRes,gifRes,stockImgRes,isAlternateNeeded,dataCount,typeToSearch,uploadSearch,action,isStockImg,isStockVid,isGiphy,isUpload,others,prevType,respAssets,upResAssets,otherResAssets,vidResAssets,imgResAssets,gifResAssets,i,videoData,duration,imgData,_i2,_i3,_i4,_videoData,_duration,_i5,_imgData,_i6,gifData,uploadsCount,isWentIn,aggs,aggsObj,audioC,videoC,imgC,overallCount,overAllAggs;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchSearch$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.prev=0;response={},isAlternateNeeded=false,dataCount=0,typeToSearch='',uploadSearch='AUDIO, VIDEO, IMG',action='uploaded',isStockImg=false,isStockVid=false,isGiphy=false,isUpload=false,others=false,prevType=getLib.libData.type;if(!(getLib.libData.type==='PROP'||getLib.libData.type==='BG')){_context13.next=10;break;}_context13.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchSearchData,getLib.libData);case 5:response=_context13.sent;if(!getLib.libData.isExpanded){if(response.data.aggs&&response.data.aggs.length){response.data.aggs.forEach(function(resObj){if(getLib.libData.type==='PROP'){if(resObj.key==='prop'||resObj.key==='shape'){dataCount+=resObj.doc_count;}}else{dataCount=resObj.doc_count;}});if(dataCount<=5){isAlternateNeeded=true;}else{if(getLib.libData.type==='PROP'){response.data.aggs.forEach(function(objj){objj.doc_count=objj.key==='prop'?dataCount:0;});}}}else if(response.data.aggs&&!response.data.aggs.length){isAlternateNeeded=true;}}else{if(!response.data||!response.data.hits||!response.data.hits.hits||!response.data.hits.hits.length){others=true;typeToSearch='PROP';}}if(isAlternateNeeded){if(getLib.libData.type==='PROP'){isStockImg=true;isGiphy=true;isUpload=true;}else if(getLib.libData.type==='BG'){isStockImg=true;isStockVid=true;isUpload=true;}}_context13.next=11;break;case 10:if(getLib.libData.type==='AUDIO, VIDEO, IMG'){isUpload=true;}else if(getLib.libData.type==='STOCKVID'){isStockVid=true;}else if(getLib.libData.type==='STOCKIMG'){isStockImg=true;}else if(getLib.libData.type==='GIPHY'){isGiphy=true;}case 11:if(!isStockImg){_context13.next=16;break;}_context13.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchStockImgData,getLib.libData);case 14:stockImgRes=_context13.sent;if(getLib.libData.type==='STOCKIMG'&&!getLib.libData.isExpanded&&(!stockImgRes.data||!stockImgRes.data.aggs||!stockImgRes.data.aggs.length||stockImgRes.data.aggs[0].doc_count<=5)){others=true;typeToSearch='PROP';isGiphy=true;isUpload=true;}case 16:if(!isStockVid){_context13.next=27;break;}_context13.next=19;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchStockVideos,getLib.libData);case 19:stockRes=_context13.sent;if(!(getLib.libData.type==='STOCKVID'&&!getLib.libData.isExpanded&&(!stockRes.data||!stockRes.data.aggs||!stockRes.data.aggs.length||stockRes.data.aggs[0].doc_count<=5))){_context13.next=27;break;}_context13.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchStockImgData,getLib.libData);case 23:stockImgRes=_context13.sent;others=true;isUpload=true;typeToSearch='BG';case 27:if(!isGiphy){_context13.next=38;break;}_context13.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchGiphyData,getLib.libData);case 30:gifRes=_context13.sent;if(!(getLib.libData.type==='GIPHY'&&!getLib.libData.isExpanded&&(!gifRes.data||!gifRes.data.aggs||!gifRes.data.aggs.length||gifRes.data.aggs[0].doc_count<=5))){_context13.next=38;break;}_context13.next=34;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchStockImgData,getLib.libData);case 34:stockImgRes=_context13.sent;others=true;typeToSearch='PROP';isUpload=true;case 38:if(!others){_context13.next=43;break;}if(typeToSearch)getLib.libData.type=typeToSearch;_context13.next=42;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchSearchData,getLib.libData);case 42:otherRes=_context13.sent;case 43:if(!isUpload){_context13.next=50;break;}if(uploadSearch)getLib.libData.type=uploadSearch;if(action)getLib.libData.action=action;_context13.next=48;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchSearchData,getLib.libData);case 48:upResponse=_context13.sent;if(upResponse.data.aggs&&!upResponse.data.aggs.length){upResponse={'data':{'aggs':[{key:'UPLOADS',doc_count:0}]}};}case 50:getLib.libData.type=prevType;respAssets=new Map(),upResAssets=new Map(),otherResAssets=new Map(),vidResAssets=new Map(),imgResAssets=new Map(),gifResAssets=new Map();if(getLib.libData.type!=="STOCKIMG"&&getLib.libData.type!=="STOCKVID"){if(response&&response.data&&response.data.hits&&response.data.hits.hits&&response.data.hits.hits.length>0){for(i=0;i<response.data.hits.hits.length;i++){if(response.data.hits.hits[i]._source.brandinfo==='GETTY-VIDEO'){videoData=response.data.hits.hits[i]._source;duration=parseFloat(videoData.clip_length.split(":")[0]*3600)+parseFloat(videoData.clip_length.split(":")[1]*60)+parseFloat(videoData.clip_length.split(":")[2])+"."+parseFloat(videoData.clip_length.split(":")[3]);videoData.duration=parseFloat(parseFloat(duration).toFixed(1));videoData.stockId=videoData.id;respAssets.set(videoData.id,videoData);}else if(response.data.hits.hits[i]._source.brandinfo==='GETTY'){imgData=response.data.hits.hits[i]._source;respAssets.set(imgData.id,{id:imgData.id,stockId:imgData.id,thumbnail:imgData.display_sizes[2].uri,src:imgData.display_sizes[0].uri,name:imgData.title,width:imgData.max_dimensions.width,height:imgData.max_dimensions.height,type:'STOCKIMG',brandinfo:imgData.brandinfo,artist:imgData.artist,title:imgData.title,istock_collection:imgData.istock_collection,subType:imgData.subType,cost:imgData.cost});}else{respAssets.set(response.data.hits.hits[i]._source.id,response.data.hits.hits[i]._source);}}}if(upResponse&&upResponse.data&&upResponse.data.hits&&upResponse.data.hits.hits&&upResponse.data.hits.hits.length>0){for(_i2=0;_i2<upResponse.data.hits.hits.length;_i2++){upResAssets.set(upResponse.data.hits.hits[_i2]._source.id,upResponse.data.hits.hits[_i2]._source);}}if(otherRes&&otherRes.data&&otherRes.data.hits&&otherRes.data.hits.hits&&otherRes.data.hits.hits.length>0){for(_i3=0;_i3<otherRes.data.hits.hits.length;_i3++){otherResAssets.set(otherRes.data.hits.hits[_i3]._source.id,otherRes.data.hits.hits[_i3]._source);}}}if(stockRes){if(stockRes&&stockRes.data.aggs&&stockRes.data.aggs.length){if(Object.keys(response).length&&response.data.aggs)response.data.aggs.push(stockRes.data.aggs[0]);else if(response){response={'data':{'aggs':[stockRes.data.aggs[0]]}};}}if(stockRes.data.hits&&stockRes.data.hits.hits&&stockRes.data.hits.hits.length>0){for(_i4=0;_i4<stockRes.data.hits.hits.length;_i4++){_videoData=stockRes.data.hits.hits[_i4]._source;_duration=parseFloat(_videoData.clip_length.split(":")[0]*3600)+parseFloat(_videoData.clip_length.split(":")[1]*60)+parseFloat(_videoData.clip_length.split(":")[2])+"."+parseFloat(_videoData.clip_length.split(":")[3]);_videoData.duration=parseFloat(parseFloat(_duration).toFixed(1));_videoData.stockId=_videoData.id;vidResAssets.set(_videoData.id,_videoData);}}}if(stockImgRes){if(stockImgRes&&stockImgRes.data&&stockImgRes.data.aggs&&stockImgRes.data.aggs.length){if(Object.keys(response).length&&response.data.aggs)response.data.aggs.push(stockImgRes.data.aggs[0]);else if(response){response={'data':{'aggs':[stockImgRes.data.aggs[0]]}};}}if(stockImgRes.data&&stockImgRes.data.hits&&stockImgRes.data.hits.length>0){for(_i5=0;_i5<stockImgRes.data.hits.length;_i5++){_imgData=stockImgRes.data.hits[_i5];imgResAssets.set(_imgData.id,{id:_imgData.id,stockId:_imgData.id,thumbnail:_imgData.display_sizes[2].uri,src:_imgData.display_sizes[0].uri,name:_imgData.title,width:_imgData.max_dimensions.width,height:_imgData.max_dimensions.height,type:_imgData.type,artist:_imgData.artist,title:_imgData.title,istock_collection:_imgData.istock_collection,subType:_imgData.subType,cost:_imgData.cost});}}}if(gifRes){if(gifRes&&gifRes.data.aggs&&gifRes.data.aggs.length){if(Object.keys(response).length&&response.data.aggs){if(getLib.libData.type==='GIPHY'){response.data.aggs.unshift(gifRes.data.aggs[0]);}else response.data.aggs.push(gifRes.data.aggs[0]);}else if(response){response={'data':{'aggs':[gifRes.data.aggs[0]]}};}}if(gifRes.data.hits&&gifRes.data.hits.length>0){for(_i6=0;_i6<gifRes.data.hits.length;_i6++){gifData=gifRes.data.hits[_i6];gifResAssets.set(gifData.id,gifData);}}}uploadsCount=0;if(upResponse&&upResponse.data&&upResponse.data.aggs&&upResponse.data.aggs.length){isWentIn=false;for(aggs=0;aggs<upResponse.data.aggs.length;aggs++){aggsObj=upResponse.data.aggs[aggs];if(aggsObj.key==='img'||aggsObj.key==='video'||aggsObj.key==='audio'){audioC=0,videoC=0,imgC=0;if(aggsObj.key==='audio'){audioC=aggsObj.doc_count;}if(aggsObj.key==='video'){videoC=aggsObj.doc_count;}if(aggsObj.key==='img'){imgC=aggsObj.doc_count;}overallCount=imgC+videoC+audioC;uploadsCount+=overallCount;isWentIn=true;}}if(isWentIn)upResponse.data.aggs=[];if(uploadsCount){if(Object.keys(response).length){response.data.aggs.push({key:'UPLOADS',doc_count:uploadsCount});}else{response={'data':{'aggs':[{key:'UPLOADS',doc_count:uploadsCount}]}};}}}overAllAggs=[];if(response&&response.data&&response.data.aggs&&response.data.aggs.length){overAllAggs=overAllAggs.concat(response.data.aggs);}if(otherRes&&otherRes.data&&otherRes.data.aggs&&otherRes.data.aggs.length){overAllAggs=overAllAggs.concat(otherRes.data.aggs);}if(upResponse&&upResponse.data&&upResponse.data.aggs&&upResponse.data.aggs.length){overAllAggs=overAllAggs.concat(upResponse.data.aggs);}if(getLib.libData.type==='AUDIO, VIDEO, IMG'){getLib.libData.type='UPLOADS';}if(getLib.libData.type==='SCENEPRE'){getLib.libData.type='PREBUILT';}_context13.next=66;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'LOAD_SEARCH_DATA',data:[{type:getLib.libData.type,data:respAssets},{type:'UPLOADS',data:upResAssets},{type:otherRes&&otherRes.data&&otherRes.data.aggs&&otherRes.data.aggs.length?otherRes.data.aggs[0].key.toUpperCase():getLib.libData.type,data:otherResAssets},{type:'STOCKVID',data:vidResAssets},{type:'STOCKIMG',data:imgResAssets},{type:'GIPHY',data:gifResAssets}],aggs:overAllAggs,isDefault:getLib.libData.isDefault,libType:getLib.libData.type,fromScroll:getLib.libData.fromScroll,tagValue:getLib.libData.tags});case 66:_context13.next=71;break;case 68:_context13.prev=68;_context13.t0=_context13['catch'](0);Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(getLib.libData.type+" search in library failed fetchSearch ",_context13.t0,"Saga-fetchSearch");case 71:case'end':return _context13.stop();}}},_marked13,this,[[0,68]]);}function fetchStockSearch(getLib){var response,libraries,i,imgData,_i7,videoData,duration;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchStockSearch$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.prev=0;_context14.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchStockSearchData,getLib.libData);case 3:response=_context14.sent;libraries={};if(getLib.libData.type==="STOCKIMG"&&response.data.hits.length>0){for(i=0;i<response.data.hits.length;i++){imgData=response.data.hits[i];libraries[imgData.id]={stockId:imgData.id,thumbnail:imgData.display_sizes[2].uri,src:imgData.display_sizes[0].uri,name:imgData.title,width:imgData.max_dimensions.width,height:imgData.max_dimensions.height,type:getLib.libData.type};}}else if(getLib.libData.type==="STOCKVID"&&response.data.hits.length>0){for(_i7=0;_i7<response.data.hits.length;_i7++){videoData=response.data.hits[_i7];if(videoData.clip_length){duration=videoData.clip_length.split(":")[0]*3600+videoData.clip_length.split(":")[1]*60+videoData.clip_length.split(":")[2];libraries[videoData.id]={stockId:videoData.id,thumbnail:videoData.display_sizes[3].uri,src:videoData.display_sizes[0].uri,name:videoData.title,poster:videoData.display_sizes[1].uri,type:getLib.libData.type,duration:parseInt(duration)};}}}_context14.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'LOAD_SEARCH_DATA',data:libraries,total:response.data.hits.total,aggs:response.data.aggs,libType:getLib.libData.type,fromScroll:getLib.libData.fromScroll});case 8:_context14.next=13;break;case 10:_context14.prev=10;_context14.t0=_context14['catch'](0);Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(getLib.libData.type+" stock search in library failed fetchStockSearch ",_context14.t0,"Saga-fetchStockSearch");case 13:case'end':return _context14.stop();}}},_marked14,this,[[0,10]]);}function fetchActionSearch(getLib){var response,libraries,i;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchActionSearch$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.prev=0;_context15.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchSearchData,getLib.libData);case 3:response=_context15.sent;libraries=new Map();if(response.data.hits.total>0){for(i=0;i<response.data.hits.hits.length;i++){libraries.set(response.data.hits.hits[i]._source.id,response.data.hits.hits[i]._source);}}_context15.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'LOAD_ACTIONSEARCH_DATA',data:libraries,total:response.data.hits.total});case 8:_context15.next=13;break;case 10:_context15.prev=10;_context15.t0=_context15['catch'](0);Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(getLib.libData.type+" search in library failed fetchSearch ",_context15.t0,"Saga-fetchActionSearch");case 13:case'end':return _context15.stop();}}},_marked15,this,[[0,10]]);}function loadLibrary(getLib){var libraries,response,total,libProp,brandRes,brandPreResp,dataArr,category,br,_source,hits,i,stockVidData,j,videoData,duration,catName,resultedData,searchTag,bgData,idx,imgData,videoDataArr,k,_videoData2,_duration2,_catName,_i8,libType,errorObj;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadLibrary$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.prev=0;libraries=new Map(),total=0,libProp={};if(!(getLib.libData.type!=="STOCKVID")){_context16.next=9;break;}_context16.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchCategory,getLib.libData);case 5:response=_context16.sent;brandRes=response.data.brand;if(brandRes&&brandRes.length&&!getLib.libData.from){dataArr=[],category='Animaker';for(br=0;br<brandRes.length;br++){dataArr.push(brandRes[br]._source);}if(getLib.libData.type==='MASPROP'){category='Brand Logos';}else if(getLib.libData.type==='MASCHR'){category='Brand Character';}else if(getLib.libData.type==='MASBG'){category='Brand Video';}else if(getLib.libData.type==='MASSCENEPRE'){category='Brand Prebuilt';}_source={category:category,catorder:"1",type:getLib.libData.type,data:dataArr};total=response.data.total+1;if(response.data.hits){response.data.hits.unshift({_source:_source});}else{hits=[{_source:_source}];response.data['hits']=hits;}}else{if(getLib.libData.loadBrand&&getLib.libData.from){if(response.data.total)total=response.data.total+1;}else{total=response.data.total;}}if(getLib.libData.type==='MASPROP'||getLib.libData.type==='MASSTOCKIMG'||getLib.libData.type==='MASBG'||getLib.libData.type==='MASCHR'||getLib.libData.type==='MASGIPHY'||getLib.libData.type==='MASSTOCKVID'||getLib.libData.type==='MASSCENEPRE'||getLib.libData.type==='MASSM'||getLib.libData.type==='MASBPROP'){if(getLib.libData.type==='MASSTOCKIMG'||getLib.libData.type==='MASSTOCKVID'){if(getLib.libData.exclusive)libraries.set('Top Exclusive',{'items':[]});}for(i=0;i<response.data.hits.length;i++){if(getLib.libData.type==='MASSTOCKIMG'||getLib.libData.type==='MASSTOCKVID'){stockVidData=response.data.hits[i]._source.data;if(getLib.libData.type==='MASSTOCKVID'){for(j=0;j<stockVidData.length;j++){videoData=stockVidData[j];duration=videoData.clip_length.split(":")[0]*3600+videoData.clip_length.split(":")[1]*60+videoData.clip_length.split(":")[2]+"."+videoData.clip_length.split(":")[3];videoData.duration=parseFloat(parseFloat(duration).toFixed(1));stockVidData[j]=videoData;}}catName=response.data.hits[i]._source.category;if(response.data.hits[i]._source['category_'+getLib.libData.lang]){catName=response.data.hits[i]._source['category_'+getLib.libData.lang];}libraries.set(catName,{'items':stockVidData,'searchtag':response.data.hits[i]._source.searchtag});}else{resultedData=[],searchTag='';if(getLib.libData.type==='MASBG'&&response.data.hits[i]._source.category==='GETTY'){bgData=response.data.hits[i]._source.data;for(idx=0;idx<bgData.length;idx++){imgData=bgData[idx];searchTag=response.data.hits[i]._source.searchTag;resultedData.push({id:imgData.id,thumbnail:imgData.display_sizes[2].uri,src:imgData.display_sizes[0].uri,name:imgData.title,width:imgData.max_dimensions.width,height:imgData.max_dimensions.height,type:'STOCKIMG',brandinfo:imgData.brandinfo,artist:imgData.artist,title:imgData.title,stockId:imgData.stockid,istock_collection:imgData.istock_collection,subType:imgData.subType,cost:imgData.cost,category:imgData.category,plan:imgData.plan});}}else if(getLib.libData.type==='MASBG'&&(response.data.hits[i]._source.category==='GETTY VIDEO'||response.data.hits[i]._source.category==='Video Backgrounds')){videoDataArr=response.data.hits[i]._source.data;searchTag=response.data.hits[i]._source.searchTag;for(k=0;k<videoDataArr.length;k++){_videoData2=videoDataArr[k];if(response.data.hits[i]._source.category!=='Video Backgrounds'){_duration2=_videoData2.clip_length.split(":")[0]*3600+_videoData2.clip_length.split(":")[1]*60+_videoData2.clip_length.split(":")[2]+"."+_videoData2.clip_length.split(":")[3];_videoData2.duration=parseFloat(parseFloat(_duration2).toFixed(1));}resultedData.push(_videoData2);}}else{resultedData=response.data.hits[i]._source.data;}_catName=response.data.hits[i]._source.category;if(response.data.hits[i]._source['category_'+getLib.libData.lang]){_catName=response.data.hits[i]._source['category_'+getLib.libData.lang];}libraries.set(_catName,{'items':resultedData,'searchtag':searchTag});}}libProp={'data':libraries,'total':total};}else{for(_i8=0;_i8<response.data.hits.length;_i8++){libraries.set(response.data.hits[_i8]._source.id,response.data.hits[_i8]._source);}}case 9:libType=getLib.libData.type;if(getLib.libData.type==='MASPROP')libType='PROP';else if(getLib.libData.type==='MASBG')libType='BG';else if(getLib.libData.type==='MASGIPHY')libType='GIPHY';else if(getLib.libData.type==="MASSCENEPRE")libType="PREBUILT";else if(getLib.libData.type==="MASSM")libType="SM";else if(getLib.libData.type==='MASCHR')libType='CHR';else if(getLib.libData.type==='MASSTOCKIMG')libType='STOCKIMG';else if(getLib.libData.type==='MASSTOCKVID')libType='STOCKVID';if(libraries.size){_context16.next=14;break;}_context16.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'RESP_UPDATE',data:{status:'failed'}});case 14:_context16.next=16;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'LOAD_LIBRARY_COMPLETE',lang:getLib.libData.lang,data:getLib.libData.type!=='MASPROP'&&getLib.libData.type!=='MASSTOCKVID'&&getLib.libData.type!=='MASSTOCKIMG'&&getLib.libData.type!=='MASBG'&&getLib.libData.type!=='MASGIPHY'&&getLib.libData.type!=='MASCHR'&&getLib.libData.type!=='MASSCENEPRE'&&getLib.libData.type!=='MASSM'?libraries:libProp,libType:libType,subType:getLib.libData.subType,total:total});case 16:_context16.next=22;break;case 18:_context16.prev=18;_context16.t0=_context16['catch'](0);errorObj={error:_context16.t0,request:''+JSON.stringify(getLib.libData),response:''+JSON.stringify(response)};Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(" Error in loadLibrary ",errorObj,"Saga-loadLibrary");case 22:case'end':return _context16.stop();}}},_marked16,this,[[0,18]]);}function loadCategoryLibrary(getLib){var libraries,response,total,brandRes,brandTxtObj,bt,i,imgData,_i9,videoData,duration,_i10,resultedData,_imgData2,_videoData3,_duration3,errorObj;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadCategoryLibrary$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.prev=0;libraries=new Map(),total=0,brandTxtObj={};_context17.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchCategory,getLib.libData);case 4:response=_context17.sent;if(!(getLib.libData.type==='TEXT'&&getLib.libData.loadBrand&&!getLib.libData.from)){_context17.next=10;break;}_context17.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchBrandData,getLib.libData);case 8:brandRes=_context17.sent;for(bt=0;bt<brandRes.data.hits.length;bt++){brandTxtObj[bt]=brandRes.data.hits[bt]._source;}case 10:total=response.data.total;if(!(response.data.hits.length>0||response.data.hits.hits&&response.data.hits.hits.length>0)){_context17.next=15;break;}if(getLib.libData.type==='STOCKIMG'){for(i=0;i<response.data.hits.length;i++){imgData=response.data.hits[i];libraries.set(response.data.hits[i].id,{id:imgData.id,thumbnail:imgData.display_sizes[2].uri,src:imgData.display_sizes[0].uri,name:imgData.title,width:imgData.max_dimensions.width,height:imgData.max_dimensions.height,type:getLib.libData.type,artist:imgData.artist,title:imgData.title,stockId:imgData.id,istock_collection:imgData.istock_collection,subType:imgData.subType,cost:imgData.cost});}}else{if(getLib.libData.type==='STOCKVID'){total=response.data.hits.total;for(_i9=0;_i9<response.data.hits.hits.length;_i9++){videoData=response.data.hits.hits[_i9]._source;duration=videoData.clip_length.split(":")[0]*3600+videoData.clip_length.split(":")[1]*60+videoData.clip_length.split(":")[2]+"."+videoData.clip_length.split(":")[3];videoData.duration=parseFloat(parseFloat(duration).toFixed(1));libraries.set(videoData.id,videoData);}}else{for(_i10=0;_i10<response.data.hits.length;_i10++){resultedData=void 0;if(response.data.hits[_i10]._source.brandinfo==='GETTY'){_imgData2=response.data.hits[_i10]._source;resultedData={id:_imgData2.id,thumbnail:_imgData2.display_sizes[2].uri,src:_imgData2.display_sizes[0].uri,name:_imgData2.title,width:_imgData2.max_dimensions.width,height:_imgData2.max_dimensions.height,type:'STOCKIMG',brandinfo:_imgData2.brandinfo,artist:_imgData2.artist,title:_imgData2.title,stockId:_imgData2.stockid,istock_collection:_imgData2.istock_collection,subType:_imgData2.subType,cost:_imgData2.cost,category:_imgData2.category,plan:_imgData2.plan};}else if(response.data.hits[_i10]._source.brandinfo==='GETTY-VIDEO'||response.data.hits[_i10]._source.subtype==='OBGVID'){_videoData3=response.data.hits[_i10]._source;if(response.data.hits[_i10]._source.subtype!=='OBGVID'){_duration3=_videoData3.clip_length.split(":")[0]*3600+_videoData3.clip_length.split(":")[1]*60+_videoData3.clip_length.split(":")[2]+"."+_videoData3.clip_length.split(":")[3];_videoData3.duration=parseFloat(parseFloat(_duration3).toFixed(1));}resultedData=_videoData3;}else{resultedData=response.data.hits[_i10]._source;}libraries.set(response.data.hits[_i10]._source.id,resultedData);}}}_context17.next=18;break;case 15:if(!(getLib.libData.type==='STOCKIMG')){_context17.next=18;break;}_context17.next=18;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'LOAD_COMPLETE',loadComplete:true});case 18:if(!(!getLib.libData.fromSearch&&libraries.size)){_context17.next=26;break;}_context17.next=21;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'LOAD_CATEGORY_COMPLETE',lang:getLib.libData.lang,data:libraries,libData:getLib.libData,total:total,brandData:brandTxtObj});case 21:if(!(getLib.libData.type==='BG')){_context17.next=24;break;}_context17.next=24;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'BG_CATEGORY_LOAD',bgCategoryLoad:true});case 24:_context17.next=29;break;case 26:if(!libraries.size){_context17.next=29;break;}_context17.next=29;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'LOAD_SEARCH_DATA',data:libraries,total:total,libType:getLib.libData.type,fromScroll:getLib.libData.fromScroll});case 29:_context17.next=35;break;case 31:_context17.prev=31;_context17.t0=_context17['catch'](0);errorObj={error:_context17.t0,request:''+JSON.stringify(getLib.libData),response:''+JSON.stringify(response)};Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])(" library failed loadCategoryLibrary ",errorObj,"Saga-loadCategoryLibrary");case 35:case'end':return _context17.stop();}}},_marked17,this,[[0,31]]);}function batchActions(data){var a;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function batchActions$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:_context18.prev=0;a=0;case 2:if(!(a<data.actions.length)){_context18.next=8;break;}_context18.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(data.actions[a]);case 5:a++;_context18.next=2;break;case 8:_context18.next=13;break;case 10:_context18.prev=10;_context18.t0=_context18['catch'](0);Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])("batchActions failed ",_context18.t0,"Saga-batchActions");case 13:case'end':return _context18.stop();}}},_marked18,this,[[0,10]]);}function fetchBrandData(reqData){var url=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+'brand/gb',data=new URLSearchParams();data.append('u',reqData.userId);data.append('t',reqData.teamId);data.append('ty',reqData.brandType);return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:url,headers:{"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:data});}function saveThumbnail(postState){var url=__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a["APIURIS"][environment]+"app/svest";var params=new URLSearchParams();params.append('userId',postState.userId);params.append('projectId',postState.projectId);params.append('project',postState.project);var screenshots={};params.append('screenshots',JSON.stringify(screenshots));return __WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:url,headers:{'Content-Type':'application/x-www-form-urlencoded',"X-CSRFToken":csrftoken,"Authorization":encodetoken},data:params}).then(function(response){return response;}).catch(function(error){return"error";});}function saveSceneThumb(postState){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saveSceneThumb$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:_context19.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(saveThumbnail,postState);case 2:result=_context19.sent;case 3:case'end':return _context19.stop();}}},_marked19,this);}function watchLoadProject(data){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchLoadProject$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:_context20.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* all */])([watchProjectLoader(data),watchLibraryLoader(),watchCreateLibraryFolder(),watchDeleteUserContent()]);case 2:case'end':return _context20.stop();}}},_marked20,this);}function watchLibraryLoader(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchLibraryLoader$(_context21){while(1){switch(_context21.prev=_context21.next){case 0:_context21.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeLatest */])("LOAD_LIBRARY",loadLibrary);case 2:_context21.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeLatest */])("LOAD_LIBRARY_MASTER",loadMasterLibrary);case 4:_context21.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeLatest */])("LOAD_LIBRARY_CATEGORY",loadCategoryLibrary);case 6:_context21.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeLatest */])("LOAD_LIBRARY_UPLOAD",loadLibraryUpload);case 8:_context21.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeLatest */])("LOAD_USER_FOLDERS",loadFolders);case 10:_context21.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeLatest */])("MOVE_FILE_LOCATION",moveFolder);case 12:_context21.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeLatest */])("RENAME_USER_FILE",renameFolder);case 14:_context21.next=16;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeLatest */])("GET_ACTIONS",fetchActions);case 16:_context21.next=18;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeLatest */])("FETCH_SEARCH",fetchSearch);case 18:_context21.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeLatest */])("FETCH_STOCK_SEARCH",fetchStockSearch);case 20:_context21.next=22;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeLatest */])("FETCH_ACTION_SEARCH",fetchActionSearch);case 22:_context21.next=24;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeLatest */])("BATCH_ACTIONS",batchActions);case 24:_context21.next=26;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeLatest */])("EXPORT_PROJECT",onExportProject);case 26:_context21.next=28;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeLatest */])("SHARE_PROJECT",onShareProject);case 28:_context21.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeLatest */])("PROJECT_RESIZE",onProjectResize);case 30:_context21.next=32;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeLatest */])("DUPLICATE_PROJECT",onProjectDuplicate);case 32:_context21.next=34;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeLatest */])("LOAD_SHARE_DETAILS",loadShareDetails);case 34:_context21.next=36;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeLatest */])("SAVE_SCREENSHOT",saveSceneThumb);case 36:case'end':return _context21.stop();}}},_marked21,this);}function watchCreateLibraryFolder(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchCreateLibraryFolder$(_context22){while(1){switch(_context22.prev=_context22.next){case 0:_context22.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeLatest */])("CREATE_LIBRARY_FOLDER",createLibraryFolder);case 2:case'end':return _context22.stop();}}},_marked22,this);}function watchDeleteUserContent(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchDeleteUserContent$(_context23){while(1){switch(_context23.prev=_context23.next){case 0:_context23.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeLatest */])("DELETE_FILE",deleteFiles);case 2:case'end':return _context23.stop();}}},_marked23,this);}function startProjectLoad(data){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function startProjectLoad$(_context24){while(1){switch(_context24.prev=_context24.next){case 0:try{}catch(error){console.log("error",error);}case 1:case'end':return _context24.stop();}}},_marked24,this);}function loadUserFonts(data){var userFonts,uploadedFonts,i;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadUserFonts$(_context25){while(1){switch(_context25.prev=_context25.next){case 0:_context25.prev=0;_context25.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchUserFonts,data);case 3:userFonts=_context25.sent;uploadedFonts=[];if(userFonts.data.success&&(userFonts.data.assets.length>0||userFonts.data.BRAND.length)){for(i=0;i<userFonts.data.assets.length;i++){uploadedFonts.push(userFonts.data.assets[i]._source);}for(i=0;i<userFonts.data.BRAND.length;i++){uploadedFonts.push(userFonts.data.BRAND[i]._source);}}uploadedFonts.sort(function(a,b){return new Date(a.created)-new Date(b.created);});_context25.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:"SET_USER_FONTS",data:uploadedFonts});case 9:_context25.next=14;break;case 11:_context25.prev=11;_context25.t0=_context25['catch'](0);Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])("error",_context25.t0,"Saga-loadUserFonts");case 14:case'end':return _context25.stop();}}},_marked25,this,[[0,11]]);}function loadShareDetails(data){var shareDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadShareDetails$(_context26){while(1){switch(_context26.prev=_context26.next){case 0:_context26.prev=0;_context26.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchShareDetails,data);case 3:shareDetails=_context26.sent;_context26.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:"SET_SHARE_DETAILS",data:shareDetails.data});case 6:_context26.next=11;break;case 8:_context26.prev=8;_context26.t0=_context26['catch'](0);Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])("error",_context26.t0,"Saga-loadShareDetails`");case 11:case'end':return _context26.stop();}}},_marked26,this,[[0,8]]);}function setUserDetails(data){var userDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setUserDetails$(_context27){while(1){switch(_context27.prev=_context27.next){case 0:_context27.prev=0;_context27.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchUserDetails,data.data);case 3:userDetails=_context27.sent;_context27.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:"UPDATE_USER_DETAILS",data:userDetails.data});case 6:_context27.next=11;break;case 8:_context27.prev=8;_context27.t0=_context27['catch'](0);Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])("error",_context27.t0,"Saga-setUserDetails");case 11:case'end':return _context27.stop();}}},_marked27,this,[[0,8]]);}function watchProjectLoader(data){var userDetails,effectData,themesData,tBDataArr,tBData,tempObj,pri,sec,transitionData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchProjectLoader$(_context28){while(1){switch(_context28.prev=_context28.next){case 0:_context28.prev=0;_context28.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchUserDetails,data);case 3:userDetails=_context28.sent;_context28.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:"UPDATE_USER_DETAILS",data:userDetails.data});case 6:data['bf']=userDetails.data.bf;_context28.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(loadUserFonts,data);case 9:_context28.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchEffects,data);case 11:effectData=_context28.sent;_context28.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'LOAD_LIBRARY_COMPLETE',data:effectData.data,libType:'EFFECTS'});case 14:_context28.next=16;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'APP_LOAD_PROGRESS',data:20});case 16:// if(data.mode !== 'slide'){
// const autoSearchData = yield call(fetchAutoSearch, {data});
// yield put({ type: 'LOAD_AUTOSEARCH', data: autoSearchData.data});
// }
themesData=void 0;if(!userDetails.data.bf){_context28.next=23;break;}_context28.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(getColorThemes,{hasBrand:1,data:data});case 20:themesData=_context28.sent;_context28.next=26;break;case 23:_context28.next=25;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(getColorThemes,{hasBrand:0,data:data});case 25:themesData=_context28.sent;case 26:if(themesData.data.brand){tBDataArr=themesData.data.brand.colorpalette,tBData={},tempObj=themesData.data.colorPalettes;pri={},sec={};tBDataArr.forEach(function(val){val.isDefault=true;val.isBrand=true;var bKey=__WEBPACK_IMPORTED_MODULE_8_uuid_v1___default()();if(val.primary){pri[bKey]=val;}else{sec[bKey]=val;}});if(Object.keys(pri).length){tBData=Object.assign({},pri,sec);}else{tBData=sec;}themesData.data.colorPalettes=Object.assign({},tBData,tempObj);}_context28.next=29;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'LOAD_COLOR_THEMES',data:themesData.data});case 29:_context28.next=31;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'APP_LOAD_PROGRESS',data:20});case 31:_context28.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'LOAD_LIBRARY_COMPLETE',data:themesData.data,libType:'COLOR_THEMES'});case 33:_context28.next=35;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'APP_LOAD_PROGRESS',data:20});case 35:_context28.next=37;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetchTransition,data);case 37:transitionData=_context28.sent;_context28.next=40;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'LOAD_LIBRARY_COMPLETE',data:transitionData.data,libType:'TRANS'});case 40:_context28.next=42;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({type:'APP_LOAD_PROGRESS',data:20});case 42:_context28.next=47;break;case 44:_context28.prev=44;_context28.t0=_context28['catch'](0);Object(__WEBPACK_IMPORTED_MODULE_3__helpers_ErrorLogService__["a" /* errorlog */])("Project load failed ",_context28.t0,"Saga-watchProjectLoader");case 47:case'end':return _context28.stop();}}},_marked28,this,[[0,44]]);}

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return payPaymentDue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ErrorLogService__ = __webpack_require__(9);
function hidepopups(){document.getElementById("pastdue_block_model").style.display="none";document.getElementById("pastdue_pay_model").style.display="none";document.getElementsByClassName("anim-new-modal-overlay")[0].style.display="none";window.closePastDuePopups();}var payPaymentDue=function payPaymentDue(propsToDispatch,teamId,type,socket,appType,upgradeType){try{propsToDispatch.setWorkspaceTextFocus(true);var paymentDue=window.pastduepopup(teamId,type,appType,upgradeType).then(function(result){result=JSON.parse(result);propsToDispatch.setWorkspaceTextFocus(false);if(result.error){propsToDispatch.manageToast({action:"add",type:"error","message":"common.toast.msg",subMessage:result.errormsg,formatId:'msg'});hidepopups();}else if(!result.ispastdue){propsToDispatch.setPaymentPastDue({status:result.ispastdue,message:'',action:'banner'},socket);propsToDispatch.manageToast({action:"add",type:"success","message":result.errormsg});hidepopups();return true;}}).catch(function(err){propsToDispatch.setWorkspaceTextFocus(false);propsToDispatch.manageToast({action:"add",type:"error","message":"common.toast.msg",subMessage:"common.toast.submsg",formatId:'both'});hidepopups();});return paymentDue;}catch(err){Object(__WEBPACK_IMPORTED_MODULE_0__ErrorLogService__["a" /* errorlog */])('Error in PaymentDuePay',err,'PaymentDueHelper-PaymentDue');}};

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var http = __webpack_require__(592)
var url = __webpack_require__(251)

var https = module.exports

for (var key in http) {
  if (http.hasOwnProperty(key)) https[key] = http[key]
}

https.request = function (params, cb) {
  params = validateParams(params)
  return http.request.call(this, params, cb)
}

https.get = function (params, cb) {
  params = validateParams(params)
  return http.get.call(this, params, cb)
}

function validateParams (params) {
  if (typeof params === 'string') {
    params = url.parse(params)
  }
  if (!params.protocol) {
    params.protocol = 'https:'
  }
  if (params.protocol !== 'https:') {
    throw new Error('Protocol "' + params.protocol + '" not supported. Expected "https:"')
  }
  return params
}


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var ClientRequest = __webpack_require__(593)
var response = __webpack_require__(242)
var extend = __webpack_require__(604)
var statusCodes = __webpack_require__(605)
var url = __webpack_require__(251)

var http = exports

http.request = function (opts, cb) {
	if (typeof opts === 'string')
		opts = url.parse(opts)
	else
		opts = extend(opts)

	// Normally, the page is loaded from http or https, so not specifying a protocol
	// will result in a (valid) protocol-relative url. However, this won't work if
	// the protocol is something else, like 'file:'
	var defaultProtocol = global.location.protocol.search(/^https?:$/) === -1 ? 'http:' : ''

	var protocol = opts.protocol || defaultProtocol
	var host = opts.hostname || opts.host
	var port = opts.port
	var path = opts.path || '/'

	// Necessary for IPv6 addresses
	if (host && host.indexOf(':') !== -1)
		host = '[' + host + ']'

	// This may be a relative url. The browser should always be able to interpret it correctly.
	opts.url = (host ? (protocol + '//' + host) : '') + (port ? ':' + port : '') + path
	opts.method = (opts.method || 'GET').toUpperCase()
	opts.headers = opts.headers || {}

	// Also valid opts.auth, opts.mode

	var req = new ClientRequest(opts)
	if (cb)
		req.on('response', cb)
	return req
}

http.get = function get (opts, cb) {
	var req = http.request(opts, cb)
	req.end()
	return req
}

http.ClientRequest = ClientRequest
http.IncomingMessage = response.IncomingMessage

http.Agent = function () {}
http.Agent.defaultMaxSockets = 4

http.globalAgent = new http.Agent()

http.STATUS_CODES = statusCodes

http.METHODS = [
	'CHECKOUT',
	'CONNECT',
	'COPY',
	'DELETE',
	'GET',
	'HEAD',
	'LOCK',
	'M-SEARCH',
	'MERGE',
	'MKACTIVITY',
	'MKCOL',
	'MOVE',
	'NOTIFY',
	'OPTIONS',
	'PATCH',
	'POST',
	'PROPFIND',
	'PROPPATCH',
	'PURGE',
	'PUT',
	'REPORT',
	'SEARCH',
	'SUBSCRIBE',
	'TRACE',
	'UNLOCK',
	'UNSUBSCRIBE'
]
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, global, process) {var capability = __webpack_require__(241)
var inherits = __webpack_require__(31)
var response = __webpack_require__(242)
var stream = __webpack_require__(243)
var toArrayBuffer = __webpack_require__(603)

var IncomingMessage = response.IncomingMessage
var rStates = response.readyStates

function decideMode (preferBinary, useFetch) {
	if (capability.fetch && useFetch) {
		return 'fetch'
	} else if (capability.mozchunkedarraybuffer) {
		return 'moz-chunked-arraybuffer'
	} else if (capability.msstream) {
		return 'ms-stream'
	} else if (capability.arraybuffer && preferBinary) {
		return 'arraybuffer'
	} else if (capability.vbArray && preferBinary) {
		return 'text:vbarray'
	} else {
		return 'text'
	}
}

var ClientRequest = module.exports = function (opts) {
	var self = this
	stream.Writable.call(self)

	self._opts = opts
	self._body = []
	self._headers = {}
	if (opts.auth)
		self.setHeader('Authorization', 'Basic ' + new Buffer(opts.auth).toString('base64'))
	Object.keys(opts.headers).forEach(function (name) {
		self.setHeader(name, opts.headers[name])
	})

	var preferBinary
	var useFetch = true
	if (opts.mode === 'disable-fetch' || ('requestTimeout' in opts && !capability.abortController)) {
		// If the use of XHR should be preferred. Not typically needed.
		useFetch = false
		preferBinary = true
	} else if (opts.mode === 'prefer-streaming') {
		// If streaming is a high priority but binary compatibility and
		// the accuracy of the 'content-type' header aren't
		preferBinary = false
	} else if (opts.mode === 'allow-wrong-content-type') {
		// If streaming is more important than preserving the 'content-type' header
		preferBinary = !capability.overrideMimeType
	} else if (!opts.mode || opts.mode === 'default' || opts.mode === 'prefer-fast') {
		// Use binary if text streaming may corrupt data or the content-type header, or for speed
		preferBinary = true
	} else {
		throw new Error('Invalid value for opts.mode')
	}
	self._mode = decideMode(preferBinary, useFetch)
	self._fetchTimer = null

	self.on('finish', function () {
		self._onFinish()
	})
}

inherits(ClientRequest, stream.Writable)

ClientRequest.prototype.setHeader = function (name, value) {
	var self = this
	var lowerName = name.toLowerCase()
	// This check is not necessary, but it prevents warnings from browsers about setting unsafe
	// headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
	// http-browserify did it, so I will too.
	if (unsafeHeaders.indexOf(lowerName) !== -1)
		return

	self._headers[lowerName] = {
		name: name,
		value: value
	}
}

ClientRequest.prototype.getHeader = function (name) {
	var header = this._headers[name.toLowerCase()]
	if (header)
		return header.value
	return null
}

ClientRequest.prototype.removeHeader = function (name) {
	var self = this
	delete self._headers[name.toLowerCase()]
}

ClientRequest.prototype._onFinish = function () {
	var self = this

	if (self._destroyed)
		return
	var opts = self._opts

	var headersObj = self._headers
	var body = null
	if (opts.method !== 'GET' && opts.method !== 'HEAD') {
		if (capability.arraybuffer) {
			body = toArrayBuffer(Buffer.concat(self._body))
		} else if (capability.blobConstructor) {
			body = new global.Blob(self._body.map(function (buffer) {
				return toArrayBuffer(buffer)
			}), {
				type: (headersObj['content-type'] || {}).value || ''
			})
		} else {
			// get utf8 string
			body = Buffer.concat(self._body).toString()
		}
	}

	// create flattened list of headers
	var headersList = []
	Object.keys(headersObj).forEach(function (keyName) {
		var name = headersObj[keyName].name
		var value = headersObj[keyName].value
		if (Array.isArray(value)) {
			value.forEach(function (v) {
				headersList.push([name, v])
			})
		} else {
			headersList.push([name, value])
		}
	})

	if (self._mode === 'fetch') {
		var signal = null
		var fetchTimer = null
		if (capability.abortController) {
			var controller = new AbortController()
			signal = controller.signal
			self._fetchAbortController = controller

			if ('requestTimeout' in opts && opts.requestTimeout !== 0) {
				self._fetchTimer = global.setTimeout(function () {
					self.emit('requestTimeout')
					if (self._fetchAbortController)
						self._fetchAbortController.abort()
				}, opts.requestTimeout)
			}
		}

		global.fetch(self._opts.url, {
			method: self._opts.method,
			headers: headersList,
			body: body || undefined,
			mode: 'cors',
			credentials: opts.withCredentials ? 'include' : 'same-origin',
			signal: signal
		}).then(function (response) {
			self._fetchResponse = response
			self._connect()
		}, function (reason) {
			global.clearTimeout(self._fetchTimer)
			if (!self._destroyed)
				self.emit('error', reason)
		})
	} else {
		var xhr = self._xhr = new global.XMLHttpRequest()
		try {
			xhr.open(self._opts.method, self._opts.url, true)
		} catch (err) {
			process.nextTick(function () {
				self.emit('error', err)
			})
			return
		}

		// Can't set responseType on really old browsers
		if ('responseType' in xhr)
			xhr.responseType = self._mode.split(':')[0]

		if ('withCredentials' in xhr)
			xhr.withCredentials = !!opts.withCredentials

		if (self._mode === 'text' && 'overrideMimeType' in xhr)
			xhr.overrideMimeType('text/plain; charset=x-user-defined')

		if ('requestTimeout' in opts) {
			xhr.timeout = opts.requestTimeout
			xhr.ontimeout = function () {
				self.emit('requestTimeout')
			}
		}

		headersList.forEach(function (header) {
			xhr.setRequestHeader(header[0], header[1])
		})

		self._response = null
		xhr.onreadystatechange = function () {
			switch (xhr.readyState) {
				case rStates.LOADING:
				case rStates.DONE:
					self._onXHRProgress()
					break
			}
		}
		// Necessary for streaming in Firefox, since xhr.response is ONLY defined
		// in onprogress, not in onreadystatechange with xhr.readyState = 3
		if (self._mode === 'moz-chunked-arraybuffer') {
			xhr.onprogress = function () {
				self._onXHRProgress()
			}
		}

		xhr.onerror = function () {
			if (self._destroyed)
				return
			self.emit('error', new Error('XHR error'))
		}

		try {
			xhr.send(body)
		} catch (err) {
			process.nextTick(function () {
				self.emit('error', err)
			})
			return
		}
	}
}

/**
 * Checks if xhr.status is readable and non-zero, indicating no error.
 * Even though the spec says it should be available in readyState 3,
 * accessing it throws an exception in IE8
 */
function statusValid (xhr) {
	try {
		var status = xhr.status
		return (status !== null && status !== 0)
	} catch (e) {
		return false
	}
}

ClientRequest.prototype._onXHRProgress = function () {
	var self = this

	if (!statusValid(self._xhr) || self._destroyed)
		return

	if (!self._response)
		self._connect()

	self._response._onXHRProgress()
}

ClientRequest.prototype._connect = function () {
	var self = this

	if (self._destroyed)
		return

	self._response = new IncomingMessage(self._xhr, self._fetchResponse, self._mode, self._fetchTimer)
	self._response.on('error', function(err) {
		self.emit('error', err)
	})

	self.emit('response', self._response)
}

ClientRequest.prototype._write = function (chunk, encoding, cb) {
	var self = this

	self._body.push(chunk)
	cb()
}

ClientRequest.prototype.abort = ClientRequest.prototype.destroy = function () {
	var self = this
	self._destroyed = true
	global.clearTimeout(self._fetchTimer)
	if (self._response)
		self._response._destroyed = true
	if (self._xhr)
		self._xhr.abort()
	else if (self._fetchAbortController)
		self._fetchAbortController.abort()
}

ClientRequest.prototype.end = function (data, encoding, cb) {
	var self = this
	if (typeof data === 'function') {
		cb = data
		data = undefined
	}

	stream.Writable.prototype.end.call(self, data, encoding, cb)
}

ClientRequest.prototype.flushHeaders = function () {}
ClientRequest.prototype.setTimeout = function () {}
ClientRequest.prototype.setNoDelay = function () {}
ClientRequest.prototype.setSocketKeepAlive = function () {}

// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
var unsafeHeaders = [
	'accept-charset',
	'accept-encoding',
	'access-control-request-headers',
	'access-control-request-method',
	'connection',
	'content-length',
	'cookie',
	'cookie2',
	'date',
	'dnt',
	'expect',
	'host',
	'keep-alive',
	'origin',
	'referer',
	'te',
	'trailer',
	'transfer-encoding',
	'upgrade',
	'via'
]

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50).Buffer, __webpack_require__(1), __webpack_require__(15)))

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 595 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 596 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(72).Buffer;
var util = __webpack_require__(598);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(600);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(15)))

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(250);

/*<replacement>*/
var util = Object.create(__webpack_require__(51));
util.inherits = __webpack_require__(31);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(50).Buffer

module.exports = function (buf) {
	// If the buffer is backed by a Uint8Array, a faster version will work
	if (buf instanceof Uint8Array) {
		// If the buffer isn't a subarray, return the underlying ArrayBuffer
		if (buf.byteOffset === 0 && buf.byteLength === buf.buffer.byteLength) {
			return buf.buffer
		} else if (typeof buf.buffer.slice === 'function') {
			// Otherwise we need to get a proper copy
			return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength)
		}
	}

	if (Buffer.isBuffer(buf)) {
		// This is the slow version that will work with any Buffer
		// implementation (even in old browsers)
		var arrayCopy = new Uint8Array(buf.length)
		var len = buf.length
		for (var i = 0; i < len; i++) {
			arrayCopy[i] = buf[i]
		}
		return arrayCopy.buffer
	} else {
		throw new Error('Argument must be a Buffer')
	}
}


/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports = {
  "100": "Continue",
  "101": "Switching Protocols",
  "102": "Processing",
  "200": "OK",
  "201": "Created",
  "202": "Accepted",
  "203": "Non-Authoritative Information",
  "204": "No Content",
  "205": "Reset Content",
  "206": "Partial Content",
  "207": "Multi-Status",
  "208": "Already Reported",
  "226": "IM Used",
  "300": "Multiple Choices",
  "301": "Moved Permanently",
  "302": "Found",
  "303": "See Other",
  "304": "Not Modified",
  "305": "Use Proxy",
  "307": "Temporary Redirect",
  "308": "Permanent Redirect",
  "400": "Bad Request",
  "401": "Unauthorized",
  "402": "Payment Required",
  "403": "Forbidden",
  "404": "Not Found",
  "405": "Method Not Allowed",
  "406": "Not Acceptable",
  "407": "Proxy Authentication Required",
  "408": "Request Timeout",
  "409": "Conflict",
  "410": "Gone",
  "411": "Length Required",
  "412": "Precondition Failed",
  "413": "Payload Too Large",
  "414": "URI Too Long",
  "415": "Unsupported Media Type",
  "416": "Range Not Satisfiable",
  "417": "Expectation Failed",
  "418": "I'm a teapot",
  "421": "Misdirected Request",
  "422": "Unprocessable Entity",
  "423": "Locked",
  "424": "Failed Dependency",
  "425": "Unordered Collection",
  "426": "Upgrade Required",
  "428": "Precondition Required",
  "429": "Too Many Requests",
  "431": "Request Header Fields Too Large",
  "451": "Unavailable For Legal Reasons",
  "500": "Internal Server Error",
  "501": "Not Implemented",
  "502": "Bad Gateway",
  "503": "Service Unavailable",
  "504": "Gateway Timeout",
  "505": "HTTP Version Not Supported",
  "506": "Variant Also Negotiates",
  "507": "Insufficient Storage",
  "508": "Loop Detected",
  "509": "Bandwidth Limit Exceeded",
  "510": "Not Extended",
  "511": "Network Authentication Required"
}


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.3.2 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.3.2',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)(module), __webpack_require__(1)))

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(609);
exports.encode = exports.stringify = __webpack_require__(610);


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(53).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 612 */
/***/ (function(module, exports) {

function middlewareFactory(errorHandler) {
  return function (store) {
    return function (next) {
      return function (action) {
        try {
          return next(action);
        } catch (err) {
          errorHandler(err, store.getState, action, store.dispatch);
          return err;
        }
      };
    };
  };
}

module.exports = middlewareFactory;


/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_undo_redo__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_undo_redo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_undo_redo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
var _revertingActions;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_undo_redo__["createUndoMiddleware"])({revertingActions:(_revertingActions={'ADD_SCENE':{action:function action(_action,_ref){var index=_ref.index;return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_21" /* removeScene */])(index,_action.socket);},createArgs:function createArgs(state,_ref2){var id=_ref2.id;var index=state.localStore.get("selectedScene")+1;return{index:index};}},"REMOVE_SCENE":{action:function action(_action2,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["j" /* addScene */])(meta,_action2.socket);},createArgs:function createArgs(state,action){var selectedScene=state.localStore.get("selectedScene")-1;var slide=state.project.getIn(["scenes",action.data]);return{selectedScene:selectedScene,slide:slide};}},'MOVE_SCENE':{action:function action(_action3,_ref3){var oldIdx=_ref3.oldIdx,newIdx=_ref3.newIdx;return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_9" /* moveScene */])(oldIdx,newIdx,_action3.socket);},meta:function meta(state,action){return{oldIdx:action.oldIndex,newIdx:action.newIndex};}},"DUPLICATE_SCENE":{action:function action(_action4,_ref4){var index=_ref4.index;return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_21" /* removeScene */])(index,_action4.socket);},createArgs:function createArgs(state,action){var index=state.localStore.get("selectedScene")+1;return{index:index};}}},_defineProperty(_revertingActions,'MOVE_SCENE',{action:function action(_action5,_ref5){var oldIdx=_ref5.oldIdx,newIdx=_ref5.newIdx;return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_9" /* moveScene */])(oldIdx,newIdx,_action5.socket);},meta:function meta(state,action){return{oldIdx:action.oldIndex,newIdx:action.newIndex};}}),_defineProperty(_revertingActions,"ADD_OBJECT",{action:function action(_action6,meta){if(meta.data!==null){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["f" /* addObj */])(meta.data,_action6.socket);}else{return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["T" /* deleteItem */])(meta,_action6.socket);}},createArgs:function createArgs(state,action){var selectedItems=[action.data.item_id];var selectedScene=action.data.selectedScene;var data=null;if(action.data.type==="TXTGRP"||action.data.type==="GROUP")selectedItems=Object.keys(action.data.items.workspaceItems);if(action.data.emptySwap===false){var prevData=state.project.getIn(["scenes",selectedScene,"workspaceItems",state.localStore.getIn(["selectedItems",0])]).toJS();data=prevData;data.emptySwap=true;if(action.data.subType!==prevData.subType){if(prevData.subType==='CHR'){data.src=action.data.charId+"/"+prevData.src;data.src=data.src.split('/')[1]+'/'+data.src.split('/')[2];data.subType=prevData.subType;}else{data.src=prevData.src;data.parts=prevData.parts;data.subType=prevData.subType;}}else if(action.data.subType==='CCHR'){data.subType=prevData.subType;data.parts=prevData.parts;}if(action.data.type==='CHR'&&prevData.type==='CHR'){data.pose=prevData.pose;data.expression=prevData.expression;}data.item_id=state.localStore.getIn(["selectedItems",0]);data.selectedScene=selectedScene;data.videoDuration=action.data.duration;if(action.data.subType==='ECHR'&&action.data.swapDetails.subType==='CHR'){if(action.data.checkAudio.length){data.voiceOverData=action.data.voiceOverData;data.checkAudio=action.data.checkAudio;}}}return{data:data,selectedItems:selectedItems,selectedScene:selectedScene};}}),_defineProperty(_revertingActions,"DELETE_ITEM",{action:function action(_action7,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["a" /* addBulkObjects */])(meta);},createArgs:function createArgs(state,action){var selectedScene=action.data.selectedScene;var socket=action.socket;var selectedItems=state.project.getIn(["scenes",selectedScene,"workspaceItems"]).filter(function(obj,key){return state.localStore.get("selectedItems").keyOf(key)!==undefined;});var workspaceIds=[],workspaceChildIds=[],workspaceData=[],workspaceChildData=[];selectedItems.entrySeq().forEach(function(_ref6){var _ref7=_slicedToArray(_ref6,2),key=_ref7[0],item=_ref7[1];workspaceIds.push(key);workspaceData.push(item.toJS());if(item.get("type")==="GROUP"){item.get("groupChildren").entrySeq().forEach(function(_ref8){var _ref9=_slicedToArray(_ref8,2),index=_ref9[0],childId=_ref9[1];workspaceChildIds.push(childId);workspaceChildData.push(state.project.getIn(["scenes",selectedScene,"workspaceChildren",childId]).toJS());});}});return{selectedScene:selectedScene,workspaceIds:workspaceIds,workspaceData:workspaceData,workspaceChildIds:workspaceChildIds,workspaceChildData:workspaceChildData,socket:socket};}}),_defineProperty(_revertingActions,"MOVE_UPDATE",{action:function action(_action8,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_73" /* undoMove */])(meta);},createArgs:function createArgs(state,action){var prevData=action.data;var selectedScene=prevData.selectedScene;var currentContainer=prevData.currentContainer;var socket=action.socket;var workspaceItems={},workspaceChildren={};prevData.selectedItems.entrySeq().forEach(function(_ref10){var _ref11=_slicedToArray(_ref10,2),index=_ref11[0],id=_ref11[1];var item=state.project.getIn(["scenes",prevData.selectedScene,"workspaceItems",id]);workspaceItems[id]={x:item.get("x"),y:item.get("y")};if(item.get("type")==="GROUP"){item.get("groupChildren").entrySeq().forEach(function(_ref12){var _ref13=_slicedToArray(_ref12,2),index=_ref13[0],childId=_ref13[1];var childItem=state.project.getIn(["scenes",selectedScene,"workspaceChildren",childId]);var childToUpdate={x:childItem.get("x"),y:childItem.get("y")};workspaceChildren[childId]=childToUpdate;});}});return{selectedScene:selectedScene,workspaceItems:workspaceItems,workspaceChildren:workspaceChildren,currentContainer:currentContainer,socket:socket};}}),_defineProperty(_revertingActions,"RESIZE_UPDATE",{action:function action(_action9,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_73" /* undoMove */])(meta);},createArgs:function createArgs(state,action){var prevData=action.data;var selectedScene=prevData.selectedScene;var currentContainer=prevData.currentContainer;var socket=action.socket;var workspaceItems={},workspaceChildren={};prevData.selectedItems.entrySeq().forEach(function(_ref14){var _ref15=_slicedToArray(_ref14,2),index=_ref15[0],id=_ref15[1];var item=state.project.getIn(["scenes",prevData.selectedScene,"workspaceItems",id]);workspaceItems[id]={x:item.get("x"),y:item.get("y"),width:item.get("width"),height:item.get("height")};if(item.get("type")==="TEXT"||item.get("type")==="SHAPE")workspaceItems[id].textData=item.get("textData").toJS();if(item.get("type")==="GROUP"){item.get("groupChildren").entrySeq().forEach(function(_ref16){var _ref17=_slicedToArray(_ref16,2),index=_ref17[0],childId=_ref17[1];var childItem=state.project.getIn(["scenes",selectedScene,"workspaceChildren",childId]);workspaceChildren[childId]={x:childItem.get("x"),y:childItem.get("y"),width:childItem.get("width"),height:childItem.get("height")};if(childItem.get("type")==="TEXT"||childItem.get("type")==="SHAPE")workspaceChildren[childId].textData=childItem.get("textData").toJS();});}});return{selectedScene:selectedScene,workspaceItems:workspaceItems,workspaceChildren:workspaceChildren,currentContainer:currentContainer,socket:socket,resizing:true};}}),_defineProperty(_revertingActions,"ROTATION_UPDATE",{action:function action(_action10,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_73" /* undoMove */])(meta);},createArgs:function createArgs(state,action){var prevData=action.data;var selectedScene=prevData.selectedScene;var currentContainer=prevData.currentContainer;var socket=action.socket;var workspaceItems={},workspaceChildren={};prevData.selectedItems.entrySeq().forEach(function(_ref18){var _ref19=_slicedToArray(_ref18,2),index=_ref19[0],id=_ref19[1];var item=state.project.getIn(["scenes",prevData.selectedScene,"workspaceItems",id]);workspaceItems[id]={x:item.get("x"),y:item.get("y"),angle:item.get("angle")};if(item.get("type")==="GROUP"){item.get("groupChildren").entrySeq().forEach(function(_ref20){var _ref21=_slicedToArray(_ref20,2),index=_ref21[0],childId=_ref21[1];var childItem=state.project.getIn(["scenes",selectedScene,"workspaceChildren",childId]);workspaceChildren[childId]={x:childItem.get("x"),y:childItem.get("y"),angle:childItem.get("angle")};});}});return{selectedScene:selectedScene,workspaceItems:workspaceItems,workspaceChildren:workspaceChildren,currentContainer:currentContainer,socket:socket};}}),_defineProperty(_revertingActions,"UPDATE_TEXT",{action:function action(_action11,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_82" /* updateObject */])(meta,_action11.socket);},createArgs:function createArgs(state,action){var selectedScene=action.data.selectedScene;var selectedItem=action.data.id;var container=action.data.container;var item=state.project.getIn(["scenes",selectedScene,container,selectedItem]);var toUpdate={textData:item.get("textData").toJS(),width:item.get("width"),height:item.get("height")};if(item.get("yRatio")!==undefined)toUpdate.yRatio=item.get("yRatio");if(item.get("heightRatio")!==undefined)toUpdate.heightRatio=item.get("heightRatio");return{selectedScene:selectedScene,selectedItem:selectedItem,container:container,toUpdate:toUpdate};}}),_defineProperty(_revertingActions,"ADD_SCENE_TRANSITION",{action:function action(_action12,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_91" /* updateSlide */])(meta);},createArgs:function createArgs(state,action){var slideIndex=action.slideIndex;var socket=action.socket;var value=state.project.getIn(["scenes",slideIndex,"transEffect"]);var sizes=state.project.getIn(["scenes",slideIndex,"sizes"]);return{slideIndex:slideIndex,value:value,sizes:sizes,socket:socket,subType:"ADD_SCENE_TRANSITION"};}}),_defineProperty(_revertingActions,"UPDATE_SCENE",{action:function action(_action13,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_88" /* updateScene */])(meta,_action13.socket);},createArgs:function createArgs(state,action){var selectedScene=action.data.selectedScene;var toUpdate=state.project.getIn(["scenes",selectedScene]).filter(function(val,key){return action.data.toUpdate[key]!==undefined;}).toJS();return{selectedScene:selectedScene,toUpdate:toUpdate};}}),_defineProperty(_revertingActions,"CHANGE_ACTION",{action:function action(_action14,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["w" /* changeAction */])(meta,_action14.id,_action14.selectedScene,_action14.socket);},createArgs:function createArgs(state,action){var selectedItem=state.project.getIn(["scenes",action.selectedScene,"workspaceItems",action.id]);var toMerge=Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({animdata:selectedItem.get("animdata"),colors:selectedItem.get("colors"),expression:selectedItem.get("expression"),genderType:selectedItem.get("genderType"),height:selectedItem.get("height"),width:selectedItem.get("width"),pose:selectedItem.get("pose"),src:selectedItem.get("src"),thumbnail:selectedItem.get("thumb"),expFlag:selectedItem.get("expFlag")!==undefined?selectedItem.get("expFlag"):"",mouthAction:selectedItem.get("mouthAction")!==undefined?selectedItem.get("mouthAction"):""});var label=action.label.merge(toMerge);return label;}}),_defineProperty(_revertingActions,"CHANGE_EXPRESSION",{action:function action(_action15,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["C" /* changeExpression */])(meta,_action15.id,_action15.selectedScene,_action15.socket);},createArgs:function createArgs(state,action){return state.project.getIn(["scenes",action.selectedScene,"workspaceItems",action.id,"expression"]);}}),_defineProperty(_revertingActions,"SET_Z_INDEX",{action:function action(_action16,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_88" /* updateScene */])(meta,_action16.socket);},createArgs:function createArgs(state,action){var toUpdate={workspaceItems:state.project.getIn(["scenes",action.data.selectedScene,"workspaceItems"])};return{selectedScene:action.data.selectedScene,toUpdate:toUpdate};}}),_defineProperty(_revertingActions,"CHANGE_BG",{action:function action(_action17,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_88" /* updateScene */])(meta,_action17.socket);},createArgs:function createArgs(state,action){var selectedScene=action.data.selectedScene;var workspaceItems=state.project.getIn(["scenes",selectedScene,"workspaceItems"]);var workspaceBG=state.project.getIn(["scenes",selectedScene,"workspaceBG"]);var toUpdate={workspaceItems:workspaceItems.toJS(),workspaceBG:workspaceBG.toJS()};return{selectedScene:action.data.selectedScene,toUpdate:toUpdate};}}),_defineProperty(_revertingActions,"DROP_BG",{action:function action(_action18,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_88" /* updateScene */])(meta,_action18.socket);},createArgs:function createArgs(state,action){var toUpdate={duration:state.project.getIn(["scenes",action.data.selectedScene,"duration"]),workspaceBG:state.project.getIn(["scenes",action.data.selectedScene,"workspaceBG"])};return{selectedScene:action.data.selectedScene,toUpdate:toUpdate};}}),_defineProperty(_revertingActions,"UPDATE_BG",{action:function action(_action19,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_91" /* updateSlide */])(meta);},createArgs:function createArgs(state,action){var selectedScene=action.data.selectedScene;var socket=action.socket;var value=state.project.getIn(["scenes",selectedScene,"workspaceBG"]);return{selectedScene:selectedScene,value:value,socket:socket,subType:"BG_SETTINGS"};}}),_defineProperty(_revertingActions,"UPDATE_BGCOLOR",{action:function action(_action20,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_91" /* updateSlide */])(meta);},createArgs:function createArgs(state,action){var selectedScene=action.selectedScene;var socket=action.socket;var value=state.project.getIn(["scenes",selectedScene,"workspaceBG"]);return{selectedScene:selectedScene,value:value,socket:socket,subType:"BG_SETTINGS"};}}),_defineProperty(_revertingActions,"BG_COLOR_SELECTION",{action:function action(_action21,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_88" /* updateScene */])(meta,_action21.socket);},createArgs:function createArgs(state,action){var toUpdate={workspaceBG:state.project.getIn(["scenes",action.selectedScene,"workspaceBG"])};return{selectedScene:action.selectedScene,toUpdate:toUpdate};}}),_defineProperty(_revertingActions,"BG_GRADIENT_COLORS",{action:function action(_action22,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_88" /* updateScene */])(meta,_action22.socket);},createArgs:function createArgs(state,action){var toUpdate={workspaceBG:state.project.getIn(["scenes",action.selectedScene,"workspaceBG"])};return{selectedScene:action.selectedScene,toUpdate:toUpdate};}}),_defineProperty(_revertingActions,"DELETE_BG",{action:function action(_action23,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_91" /* updateSlide */])(meta);},createArgs:function createArgs(state,action){var selectedScene=action.data.selectedScene;var socket=action.socket;var value=state.project.getIn(["scenes",selectedScene,"workspaceBG"]).toJS();return{selectedScene:selectedScene,value:value,socket:socket,subType:"BG_SETTINGS"};}}),_defineProperty(_revertingActions,"APPLY_FILTER",{action:function action(_action24,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["s" /* applyFilter */])(_action24.active,meta,_action24.selectedScene,_action24.socket);},createArgs:function createArgs(state,action){var objectData;if(action.active!=="BG")objectData=state.project.getIn(["scenes",action.selectedScene,"workspaceItems",action.active,"filter"]);else objectData=state.project.getIn(["scenes",action.selectedScene,"workspaceBG","bgFilter"]);return objectData;}}),_defineProperty(_revertingActions,"CHANGE_OBJECT_END_TIME",{action:function action(_action25,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["E" /* changeObjectThumb */])("CHANGE_OBJECT_END_TIME",_action25.socket,meta,_action25.id,_action25.selectedScene);},createArgs:function createArgs(state,action){return state.project.getIn(['scenes',action.selectedScene,'workspaceItems',action.id,'exitEnd']);}}),_defineProperty(_revertingActions,"UPDATE_SVGCOLOR",{action:function action(_action26,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_86" /* updateSVGColor */])(_action26.socket,_action26.id,_action26.cls,meta,_action26.selectedScene,_action26.container);},createArgs:function createArgs(state,action){return state.project.getIn(["scenes",action.selectedScene,action.container,action.id,"colors",action.cls]);}}),_defineProperty(_revertingActions,"UPDATE_SVG_THEME",{action:function action(_action27,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_87" /* updateSVGTheme */])(_action27.socket,meta.id,meta.colors,meta.selectedScene,meta.container,meta.isBG);},createArgs:function createArgs(state,action){var selectedScene=action.selectedScene;var id=action.id;var container=action.container!==undefined?action.container:"workspaceItems";var colors=state.project.getIn(["scenes",selectedScene,container,id,"colors"]);if(action.isBG)colors=state.project.getIn(["scenes",selectedScene,"workspaceBG","bgColor"]);return{id:id,selectedScene:selectedScene,colors:colors,container:container,isBG:action.isBG};}}),_defineProperty(_revertingActions,"FLIP_ITEM",{action:function action(_action28,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_2" /* flipItem */])(meta,_action28.socket);},createArgs:function createArgs(state,action){var selectedScene=action.data.selectedScene;var active=action.data.active;var flipPosition=state.project.getIn(["scenes",selectedScene,"workspaceItems",active,"flipPosition"]);return{selectedScene:selectedScene,active:active,flipPosition:flipPosition};}}),_defineProperty(_revertingActions,"CROP_IMAGE",{action:function action(_action29,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_82" /* updateObject */])(meta,_action29.socket);},createArgs:function createArgs(state,action){var selectedScene=action.data.selectedScene;var selectedItem=action.data.selectedItems.get(0);var container="workspaceItems";var item=state.project.getIn(["scenes",selectedScene,container,selectedItem]);var toUpdate={width:item.get("width"),height:item.get("height"),x:item.get("x"),y:item.get("y"),original:item.get("original"),isCropped:item.get("isCropped")};return{selectedScene:selectedScene,selectedItem:selectedItem,container:container,toUpdate:toUpdate};}}),_defineProperty(_revertingActions,"CROP_BG",{action:function action(_action30,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["M" /* cropBG */])(meta,_action30.socket);},createArgs:function createArgs(state,action){var selectedScene=action.data.selectedScene;var isVideo=action.data.isVideo;var videoId=action.data.videoId;var selectedItems=action.data.selectedItems;var bgScales={},oldData=action.data;if(!action.data.isVideo){var workspaceBG=state.project.getIn(["scenes",action.data.selectedScene,"workspaceBG"]).toJS();bgScales.x=workspaceBG.x;bgScales.y=workspaceBG.y;bgScales.width=workspaceBG.width;bgScales.height=workspaceBG.height;}else{bgScales=state.project.getIn(["videos",action.data.videoId,"bgScales"]).toJS();}return{selectedScene:selectedScene,isVideo:isVideo,videoId:videoId,selectedItems:selectedItems,bgScales:bgScales};}}),_defineProperty(_revertingActions,"CHANGE_BG_THUMB_VALUE",{action:function action(_action31,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["z" /* changeBGThumbValue */])("CHANGE_BG_THUMB_VALUE",meta,_action31.thumbPosition,_action31.selectedScene,_action31.socket);},createArgs:function createArgs(state,action){var value;if(action.thumbPosition==='bgStart')value=state.project.getIn(["scenes",action.selectedScene,"workspaceBG","enterStart"]);else if(action.thumbPosition==='bgEnd')value=state.project.getIn(["scenes",action.selectedScene,"workspaceBG","exitEnd"]);else if(action.thumbPosition==='bgEnter')value=state.project.getIn(["scenes",action.selectedScene,"workspaceBG","enterEnd"]);else if(action.thumbPosition==='bgExit')value=state.project.getIn(["scenes",action.selectedScene,"workspaceBG","exitStart"]);return value;}}),_defineProperty(_revertingActions,"GROUP_OBJECTS",{action:function action(_action32,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_72" /* unGroupObjects */])(meta,_action32.socket);},createArgs:function createArgs(state,action){var workspaceChildren=action.data.workspaceChildren;var selectedScene=action.data.selectedScene;var selectedItems=Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])([action.data.workspaceItems.keySeq().toArray()[0]]);var workspaceItemsOrder={};state.project.getIn(["scenes",selectedScene,"workspaceItems"]).entrySeq().forEach(function(_ref22){var _ref23=_slicedToArray(_ref22,2),key=_ref23[0],item=_ref23[1];workspaceItemsOrder[key]=item.get('animIndex');});return{selectedScene:selectedScene,selectedItems:selectedItems,workspaceChildren:workspaceChildren,workspaceItemsOrder:workspaceItemsOrder};}}),_defineProperty(_revertingActions,"UNGROUP_OBJECTS",{action:function action(_action33,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_4" /* groupObjects */])(meta,_action33.socket);},createArgs:function createArgs(state,action){var workspaceChildren=action.data.workspaceChildren;var workspaceItems=action.data.workspaceItems;var selectedScene=action.data.selectedScene;var selectedItems=Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(action.data.workspaceChildren.keySeq().toArray());var workspaceItemsOrder={};state.project.getIn(["scenes",selectedScene,"workspaceItems"]).entrySeq().forEach(function(_ref24){var _ref25=_slicedToArray(_ref24,2),key=_ref25[0],item=_ref25[1];workspaceItemsOrder[key]=item.get('animIndex');});return{selectedScene:selectedScene,selectedItems:selectedItems,workspaceChildren:workspaceChildren,workspaceItems:workspaceItems,workspaceItemsOrder:workspaceItemsOrder};}}),_defineProperty(_revertingActions,"UPDATE_TIMELINE_DRAG",{action:function action(_action34,meta){if(meta.type==="scene")return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_88" /* updateScene */])({selectedScene:_action34.selectedScene,toUpdate:meta.toUpdate},_action34.socket);},createArgs:function createArgs(state,action){var selectedScene=action.selectedScene;var type="scene",toUpdate={playHeadValue:state.project.getIn(['scenes',selectedScene,'playHeadValue']),duration:state.project.getIn(['scenes',selectedScene,'duration']),workspaceItems:state.project.getIn(['scenes',selectedScene,'workspaceItems']),workspaceChildren:state.project.getIn(['scenes',selectedScene,'workspaceChildren']),workspaceBG:state.project.getIn(['scenes',selectedScene,'workspaceBG'])};return{type:type,toUpdate:toUpdate};}}),_defineProperty(_revertingActions,"WRITE_TEXT",{action:function action(_action35,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_103" /* writeText */])(meta,_action35.socket);},createArgs:function createArgs(state,action){var selectedScene=action.data.selectedScene;var selectedItem=action.data.selectedItem;var container=action.data.container;var toUpdate=Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({});var item=state.project.getIn(["scenes",selectedScene,container,selectedItem]);for(var key in action.data.toUpdate){toUpdate=toUpdate.set(key,item.get(key));}toUpdate=toUpdate.toJS();toUpdate.width=item.get("width");toUpdate.height=item.get("height");toUpdate.x=item.get("x");toUpdate.y=item.get("y");return{selectedScene:selectedScene,selectedItem:selectedItem,container:container,toUpdate:toUpdate,isTyping:action.data.isTyping,undo:true};}}),_defineProperty(_revertingActions,"UPDATE_GROUP_TEXT",{action:function action(_action36,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_73" /* undoMove */])(meta);},createArgs:function createArgs(state,action){var selectedScene=action.data.selectedScene;var groupId=action.data.groupId,currentId=action.data.currentId,currentContainer="workspaceItems",socket=action.socket;var childIds=state.project.getIn(["scenes",selectedScene,"workspaceItems",groupId,"groupChildren"]);var children=state.project.getIn(["scenes",selectedScene,"workspaceChildren"]).filter(function(obj,key){return childIds.keyOf(key)!==undefined;});var workspaceItems=Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({});var workspaceChildren=Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({});if(action.data.isGrouped){children.entrySeq().forEach(function(_ref26){var _ref27=_slicedToArray(_ref26,2),key=_ref27[0],item=_ref27[1];workspaceChildren=workspaceChildren.setIn([key,"y"],item.get("y"));workspaceChildren=workspaceChildren.setIn([key,"height"],item.get("height"));if(key===currentId&&action.data.textData!==undefined)workspaceChildren=workspaceChildren.setIn([key,"textData"],item.get("textData"));});workspaceItems=workspaceItems.setIn([groupId,"y"],state.project.getIn(["scenes",selectedScene,"workspaceItems",groupId,"y"]));workspaceItems=workspaceItems.setIn([groupId,"height"],state.project.getIn(["scenes",selectedScene,"workspaceItems",groupId,"height"]));}return{selectedScene:selectedScene,workspaceItems:workspaceItems,workspaceChildren:workspaceChildren,currentContainer:currentContainer,socket:socket};}}),_defineProperty(_revertingActions,"UPDATE_ITEM",{action:function action(_action37,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_82" /* updateObject */])(meta,_action37.socket);},createArgs:function createArgs(state,action){var selectedScene=action.data.selectedScene;var selectedItem=action.data.selectedItem;var container=action.data.container;var toUpdate=Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({});for(var key in action.data.toUpdate){toUpdate=toUpdate.set(key,state.project.getIn(["scenes",selectedScene,container,selectedItem,key]));}toUpdate=toUpdate.toJS();return{selectedScene:selectedScene,selectedItem:selectedItem,container:container,toUpdate:toUpdate};}}),_defineProperty(_revertingActions,"PASTE_ITEMS",{action:function action(_action38,meta){if(_action38.data.dataType==="ITEMS"){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_88" /* updateScene */])(meta,_action38.socket);}else if(_action38.data.dataType==="SCENES"){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_74" /* undoScenePaste */])(meta,_action38.socket);}},createArgs:function createArgs(state,action){var selectedScene=action.data.selectedScene;var toReturn={};if(action.data.dataType==="ITEMS"){toReturn={selectedScene:selectedScene,toUpdate:{workspaceItems:state.project.getIn(["scenes",selectedScene,"workspaceItems"]).toJS(),workspaceChildren:state.project.getIn(["scenes",selectedScene,"workspaceChildren"]).toJS()}};}else if(action.data.dataType==="SCENES"){var scenes=state.project.get("scenes").toJS();toReturn={toUpdate:{scenes:scenes},selectedScene:selectedScene};}return toReturn;}}),_defineProperty(_revertingActions,"ADD_PREBUILT",{action:function action(_action39,meta){if(meta.addAll||meta.replace)return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["h" /* addPrebuilt */])(meta,_action39.socket);else{if(!meta.addAll)return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_21" /* removeScene */])(meta.selectedScene+1,_action39.socket);}},createArgs:function createArgs(state,action){var selectedScene=action.data.selectedScene;var addAll=action.data.addAll;var replace=action.data.replace;var undo=true;var prebuilt=void 0;if(addAll!==true){if(replace)prebuilt=state.project.getIn(["scenes",state.localStore.get("selectedScene")]);}else{prebuilt=Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({project:state.project});}return{selectedScene:selectedScene,prebuilt:prebuilt,addAll:addAll,replace:replace,undo:undo};}}),_defineProperty(_revertingActions,"APPLY_ENTER_EFFECT",{action:function action(_action40,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["q" /* applyEnterEffect */])(meta,_action40.socket);},createArgs:function createArgs(state,action){var _action$data=action.data,effectData=_action$data.effectData,selectedScene=_action$data.selectedScene;var sceneEffectData={};if(effectData.isapplyToallSlides){state.project.getIn(['scenes']).entrySeq().forEach(function(_ref28){var _ref29=_slicedToArray(_ref28,2),key=_ref29[0],item=_ref29[1];sceneEffectData[key]={};state.project.getIn(['scenes',key,'workspaceItems']).entrySeq().forEach(function(_ref30){var _ref31=_slicedToArray(_ref30,2),wKey=_ref31[0],wItem=_ref31[1];sceneEffectData[key][wKey]=wItem.get('enterEffectName');});});}else{sceneEffectData[selectedScene]={};state.project.getIn(['scenes',selectedScene,'workspaceItems']).entrySeq().forEach(function(_ref32){var _ref33=_slicedToArray(_ref32,2),key=_ref33[0],item=_ref33[1];sceneEffectData[selectedScene][key]=item.get('enterEffectName');});}return{effectData:effectData,sceneEffectData:sceneEffectData,isUndo:true};}}),_defineProperty(_revertingActions,'ADD_LINK_TO_TEXT',{action:function action(_action41,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_82" /* updateObject */])(meta,_action41.socket);},createArgs:function createArgs(state,action){var selectedScene=action.data.selectedScene;var selectedItem=action.data.selectedItem;var container=action.data.container;var item=state.project.getIn(["scenes",selectedScene,container,selectedItem]);var toUpdate={textData:item.get("textData").toJS(),width:item.get("width"),height:item.get("height")};if(item.get("yRatio")!==undefined)toUpdate.yRatio=item.get("yRatio");if(item.get("heightRatio")!==undefined)toUpdate.yRatio=item.get("heightRatio");return{selectedScene:selectedScene,selectedItem:selectedItem,container:container,toUpdate:toUpdate};}}),_defineProperty(_revertingActions,"ADD_LINK_TO_OBJ",{action:function action(_action42,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_82" /* updateObject */])(meta,_action42.socket);},createArgs:function createArgs(state,action){var selectedScene=action.data.selectedScene;var selectedItem=action.data.selectedItem;var container="workspaceItems";var item=state.project.getIn(["scenes",selectedScene,container,selectedItem]);var toUpdate={link:item.get('link')};return{selectedScene:selectedScene,selectedItem:selectedItem,container:container,toUpdate:toUpdate};}}),_defineProperty(_revertingActions,'APPLY_ALL_TRANSITION',{action:function action(_action43,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["o" /* applyAllTransition */])(meta,_action43.socket);},createArgs:function createArgs(state,action){var sceneTransData=[];for(var i=0;i<state.project.get('scenes').size-1;i++){var scene=state.project.getIn(['scenes',i]);sceneTransData.push({selectedScene:state.project.getIn(['scenes',i]),toUpdate:{'transColor':scene.get('transColor')?scene.get('transColor'):{},'transEffect':scene.get('transEffect'),'sizes':scene.get('sizes')}});}return{sceneTransData:sceneTransData,isUndo:true};}}),_defineProperty(_revertingActions,'SET_ANIMATE_VALUE',{action:function action(_action44,meta){return Object(__WEBPACK_IMPORTED_MODULE_1__actions__["_26" /* setAnimateValue */])(meta,_action44.socket);},createArgs:function createArgs(state,action){var _action$data2=action.data,selectedScene=_action$data2.selectedScene,container=_action$data2.container,selectedItem=_action$data2.selectedItem;var animateData=state.project.getIn(['scenes',selectedScene,container,selectedItem,'animType']);return{selectedScene:selectedScene,container:container,selectedItem:selectedItem,animateData:animateData};}}),_revertingActions)}));

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return autosaveMiddleware; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utilityMethods__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_app_json__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var pushActions=[];var sceneDuration=__WEBPACK_IMPORTED_MODULE_3__config_app_json___default.a["SCENE"]["duration"];var autosaveMiddleware=function autosaveMiddleware(store){return function(next){return function(action){var state=store.getState();var projectid=state.localStore.get("projectid");var socketid=state.localStore.get("socketid");var projectUsr=state.localStore.get("projectUsr");var userId=state.localStore.get("userId");var projectUsrImg=state.localStore.get("projectUsrImg");if(state.localStore.get('isPlay')||state.localStore.get('isPlayAll')){if(action.type.indexOf("COMPLETE")>-1){pushActions.push(action);return;}}else{if(pushActions.length>0){var pushingArr=pushActions.slice();pushActions=[];store.dispatch({type:"BATCH_ACTIONS",actions:pushingArr});}}// if((action.type !== "SAVE_START" && action.type !== "SAVE_DONE"))
// {
//   if (action.type.indexOf("COMPLETE") > -1 && action.type !== "LOAD_LIBRARY_COMPLETE" && action.type !== "LOAD_CATEGORY_COMPLETE" && action.type !== "SET_NEW_ACTION_COMPLETE" && action.type !== "ADD_PREBUILT_COMPLETE")
//   {
//     store.dispatch({ type: "SAVE_DONE" })
//   }
// }
if(action.selectedScene!==undefined&&action.socket!==undefined&&state.localStore.get('selectedScene')!==action.selectedScene){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_46" /* setSelectedScene */])(action.selectedScene,state.project.getIn(["scenes",action.selectedScene,"startTime"]),[action.selectedScene],action.socket));}else if(action.data!==undefined&&action.data.selectedScene!==undefined&&state.localStore.get('selectedScene')!==action.data.selectedScene){if(action.socket!==undefined)store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_46" /* setSelectedScene */])(action.data.selectedScene,state.project.getIn(["scenes",action.data.selectedScene,"startTime"]),[action.selectedScene],action.socket));else if(action.data.socket!==undefined)store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_46" /* setSelectedScene */])(action.data.selectedScene,state.project.getIn(["scenes",action.data.selectedScene,"startTime"]),[action.selectedScene],action.data.socket));}if(action.type==="ADD_SCENE"||action.type==="ADD_OBJECT"||action.type==="MOVE_UPDATE"||action.type==="ROTATION_UPDATE"||action.type==="RESIZE_UPDATE"||action.type==="DUPLICATE_SCENE"||action.type==="REMOVE_SCENE"||action.type==="ADD_SCENE_TRANSITION"||action.type==="CHANGE_ACTION"||action.type==="CHANGE_EXPRESSION"||action.type==="DROP_BG"||action.type==="CHANGE_BG"||action.type==="DELETE_BG"||action.type==="APPLY_FILTER"||action.type==="CHANGE_OBJECT_END_TIME"||action.type==="UPDATE_VIDEO_DATA"||action.type==="UPDATE_SVGCOLOR"||action.type==="FLIP_ITEM"||action.type==="CROP_IMAGE"||action.type==="CROP_BG"||action.type==="BG_COLOR_SELECTION"||action.type==="BG_GRADIENT_COLORS"||action.type==="CHANGE_BG_THUMB_VALUE"||action.type==="CHANGE_TEXT"||action.type==="SET_KEYFRAMES"||action.type==="UPDATE_GROUP_OBJECTS"||action.type==="UPDATE_GROUP_TEXT"||action.type==="DELETE_ITEM"||action.type==="SET_Z_INDEX"||action.type==="GROUP_OBJECTS"||action.type==="UNGROUP_OBJECTS"||action.type==="UPDATE_TEXT"||action.type==="UPDATE_TIMELINE_DRAG"||action.type==="PASTE_ITEMS"||action.type==="MOVE_SCENE"||action.type==="UPDATE_OBJECT"||action.type==='APPLY_ENTER_EFFECT'||action.type==='SET_ANIMATE_VALUE'||action.type==='SET_WORKSPACE_ITEMS_ORDER'||action.type==='ADD_LINK_TO_TEXT'||action.type==='APPLY_ALL_TRANSITION'||action.type==='ADD_PREBUILT'){store.dispatch({type:"SAVE_START"});store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_36" /* setNewActionComplete */])(true));}if(action.type==="ADD_SCENE"){var currentSlide=state.project.getIn(["scenes",action.data.selectedScene]);var bgColors=currentSlide.getIn(["workspaceBG","color"]),color=["#FFFFFF"];if(bgColors!==undefined&&bgColors.size>0){color=bgColors;}var totalDuration=0;for(var i=0;i<action.data.selectedScene+1;i++){totalDuration+=state.project.getIn(['scenes',i,'duration']);}var slideIndex=action.data.selectedScene+1;var newslide={"id":Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString(),"duration":sceneDuration,"workspaceChildren":{},"workspaceItems":{},"workspaceBG":{"color":color,"src":"","x":0,"y":0,"width":1,"height":1,"type":"","videoStart":0,"videoEnd":10},"startTime":totalDuration,"transEffect":"NoTransition"};if(action.data.slide!==undefined){newslide=action.data.slide.toJS();}store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["k" /* addSceneComplete */])(slideIndex,newslide,action.socket.id,action.socket.id));action.socket.emit('addScene',slideIndex,newslide,userId);}if(action.type==="MOVE_SCENE"){action.playheadVal=state.project.getIn(["scenes",action.newIndex,"startTime"]);store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_10" /* moveSceneComplete */])(projectid,action.newIndex,action.oldIndex,action.socket.id,action.socket.id));action.socket.emit('moveScene',action.newIndex,action.oldIndex,userId);}if(action.type==="ADD_OBJECT"){var selectedScene=action.data.selectedScene;var enterStart=0,exitEnd=state.project.getIn(['scenes',selectedScene,'duration']);var enterEnd=0,exitStart=0,enterEffectName="no_Effect",flipPosition=0,childIds=[];var animType='On Load',animIndex=0;if(exitEnd-enterStart<=1&&exitEnd>=2)enterStart=exitEnd-2;if(enterStart===exitEnd)enterStart=0;var workspaceObjects={},childObjects={};var workspaceIds=[],workspaceChildIds=[],workspaceData=[],workspaceChildData=[];if(action.data.type!=="TXTGRP"){var workspaceItems=state.project.getIn(["scenes",selectedScene,"workspaceItems"]);var maxIndex=0;if(workspaceItems.size>0){var maxItem=workspaceItems.maxBy(function(x){return x.get("index");});maxIndex=maxItem.get("index")+1;animIndex=maxItem.get("index")+1;}var uniqueId=action.data.item_id;if(action.data.flipPosition!==undefined)flipPosition=action.data.flipPosition;if(action.data.swapDetails!==null&&!action.data.emptySwap||action.data.undoSwap){uniqueId=state.localStore.getIn(["selectedItems",0])||action.data.swapDetails.id;enterEnd=action.data.enterEnd;enterEffectName=action.data.enterEffectName;enterStart=action.data.enterStart;flipPosition=action.data.flipPosition;maxIndex=action.data.index;}var objectData={"index":maxIndex,"assetId":action.data.assetId,"width":action.data.width,"height":action.data.height,"x":action.data.x,"y":action.data.y,"angle":action.data.angle,"type":action.data.type,"src":action.data.src,"thumb":action.data.thumb,"flipPosition":flipPosition,"enterStart":enterStart,"enterEffectName":enterEffectName,"enterEnd":enterEnd,"opacity":1,"displaysizes":action.data.displaysizes,"animIndex":animIndex,"animType":animType};if(action.data.swapDetails!==null&&!action.data.emptySwap){objectData.animType=action.data.swapDetails.animType;objectData.animIndex=action.data.swapDetails.animIndex;objectData.index=action.data.swapDetails.index;}if(action.data.isBlob!==undefined){objectData['isBlob']=action.data.isBlob;}if(action.data.colors){objectData.colors=action.data.colors;objectData.defaultColor=action.data.defaultColor;}if(action.data.subType!==undefined&&action.data.subType!==null){objectData.subType=action.data.subType;}if(action.data.emptySwap)objectData.index=action.data.index;if(action.data.type==="PROP"){objectData.repeatLoop=action.data.repeatLoop;objectData.colors=action.data.colors;objectData.defaultColor=action.data.colors;objectData.isRepeated=action.data.isRepeated;objectData.isAnimated=action.data.isAnimated;objectData.animsrc=action.data.animsrc;objectData.animdata=action.data.animdata;}else if(action.data.type==="CHR"){objectData.charId=action.data.charId;objectData.colors=action.data.colors;objectData.defaultColor=action.data.colors;objectData.animsrc=action.data.animsrc;objectData.isRepeated=action.data.isRepeated;objectData.isAnimated=action.data.isAnimated;objectData.voiceOver={"audio":{},"data":""};objectData.parts=action.data.parts;objectData.pose="front";objectData.expression="happy";objectData.animdata=action.data.animdata;objectData.genderType=action.data.genderType;objectData.voiceOverData=action.data.voiceOverData;}else if(action.data.type==="SHAPE"){objectData.groupBounds=action.data.groupBounds;objectData.pathData=action.data.pathData;objectData.isVertical=action.data.isVertical;objectData.isHorizontal=action.data.isHorizontal;objectData.scaleType=action.data.scaleType;objectData.textData=action.data.textData;objectData.colors=action.data.colors;objectData.defaultColor=action.data.colors;objectData.widthRatio=action.data.widthRatio;objectData.heightRatio=action.data.heightRatio;objectData.xRatio=action.data.xRatio;objectData.yRatio=action.data.yRatio;objectData.maxWidthRatio=action.data.widthRatio;objectData.maxHeightRatio=action.data.heightRatio;objectData.minXRatio=action.data.xRatio;objectData.minYRatio=action.data.yRatio;if(action.data.subType==="CSTMPTH")objectData.path=action.data.path;}else if(action.data.type==="TEXT"){objectData.textData=action.data.textData;}if(action.data.pose!==undefined)objectData.pose=action.data.pose;if(action.data.opacity!==undefined)objectData.opacity=action.data.opacity;if(action.data.expression!==undefined)objectData.expression=action.data.expression;if(action.data.sizes!==undefined)objectData.sizes=action.data.sizes;if(action.data.sourceType!==undefined)objectData.sourceType=action.data.sourceType;if(action.data.expFlag!==undefined)objectData.expFlag=action.data.expFlag;if(action.data.mouthAction!==undefined)objectData.mouthAction=action.data.mouthAction;if(action.data.filter)objectData.filter=action.data.filter;if(action.data.voiceOver)objectData.voiceOver=action.data.voiceOver;workspaceIds.push(uniqueId);workspaceData.push(objectData);}else{var addedIds=[],key;childIds=[];var _maxIndex=0;for(key in action.data.items.workspaceChildren){if(action.data.items.workspaceChildren.hasOwnProperty(key)){action.data.items.workspaceChildren[key]['animType']='On Click';action.data.items.workspaceChildren[key]['animIndex']=_maxIndex++;childObjects[key]=action.data.items.workspaceChildren[key];childIds.push(key);workspaceChildData.push(action.data.items.workspaceChildren[key]);workspaceChildIds.push(key);}}for(key in action.data.items.workspaceItems){if(action.data.items.workspaceItems.hasOwnProperty(key)){if(action.data.items.workspaceItems[key]['subType']==='CSTMPTH'||action.data.items.workspaceItems[key]['subType']==='DTXT'){action.data.items.workspaceItems[key]['animType']='On Click';}workspaceObjects[key]=action.data.items.workspaceItems[key];workspaceObjects[key]["groupChildren"]=childIds;workspaceIds.push(key);workspaceData.push(workspaceObjects[key]);}}}action.sceneDuration=state.project.getIn(["scenes",state.localStore.get("selectedScene"),"duration"]);action.socket.emit('addObject',selectedScene,workspaceIds,workspaceData,workspaceChildIds,workspaceChildData,userId);store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["g" /* addObjComplete */])(selectedScene,workspaceIds,workspaceData,workspaceChildIds,workspaceChildData,action.socket.id,action.socket.id));}if(action.type==="CHANGE_ANIMATION_TYPE"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["y" /* changeAnimationTypeComplete */])(action.selectedScene,action.itemId,action.value,action.socket.id,action.socket.id));action.socket.emit('changeAnimationType',action.selectedScene,action.itemId,action.value,userId);}if(action.type==="MOVE_UPDATE"){var selectedScene=action.data.selectedScene;var currentContainer=action.data.currentContainer;if(currentContainer===undefined)currentContainer="workspaceItems";var getAllItems=state.project.getIn(["scenes",selectedScene,currentContainer]);var workspaceItems=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({});var workspaceChildren=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({});action.data.items.entrySeq().forEach(function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],item=_ref2[1];if(item.get('x')!==undefined&&item.get('y')!==undefined)workspaceItems=workspaceItems.set(key,Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({x:item.get('x'),y:item.get('y')}));var item_to_merge=getAllItems.get(key);var dX=item.get('x')-item_to_merge.get("x"),dY=item.get('y')-item_to_merge.get("y");if(item.get("type")==="GROUP"){var _item_to_merge=getAllItems.get(key);var _dX=item.get('x')-_item_to_merge.get("x"),_dY=item.get('y')-_item_to_merge.get("y");var groupItems=state.project.getIn(["scenes",selectedScene,"workspaceChildren"]);item.get("groupChildren").entrySeq().forEach(function(_ref3){var _ref4=_slicedToArray(_ref3,2),childKey=_ref4[0],itemId=_ref4[1];var child=groupItems.get(itemId);var childToUpdate={x:child.get("x")+_dX,y:child.get("y")+_dY};workspaceChildren=workspaceChildren.set(itemId,Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(childToUpdate));});}});store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_12" /* moveUpdateComplete */])(selectedScene,workspaceItems,workspaceChildren,currentContainer,action.socket.id,action.socket.id));action.socket.emit('moveUpdate',selectedScene,workspaceItems,workspaceChildren,currentContainer,userId);}if(action.type==="ROTATION_UPDATE"){selectedScene=action.data.selectedScene;currentContainer=action.data.currentContainer;if(currentContainer===undefined)currentContainer="workspaceItems";getAllItems=state.project.getIn(["scenes",selectedScene,currentContainer]);var groupItems=state.project.getIn(["scenes",selectedScene,"workspaceChildren"]);var workspaceItems=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({});var workspaceChildren=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({});action.data.items.entrySeq().forEach(function(_ref5){var _ref6=_slicedToArray(_ref5,2),key=_ref6[0],item=_ref6[1];workspaceItems=workspaceItems.set(key,Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({x:item.get('x'),y:item.get('y'),angle:item.get('angle')}));var item_to_merge=getAllItems.get(key);var dX=item.get('x')-item_to_merge.get("x"),dY=item.get('y')-item_to_merge.get("y"),dA=item.get('angle')-item_to_merge.get("angle");if(item.get("type")==="TXTOVLY"||item.get("type")==="GROUP"){item.get("groupChildren").entrySeq().forEach(function(_ref7){var _ref8=_slicedToArray(_ref7,2),childKey=_ref8[0],itemId=_ref8[1];var child=groupItems.get(itemId);var childToUpdate={x:child.get("x")+dX,y:child.get("y")+dY,angle:child.get("angle")};workspaceChildren=workspaceChildren.set(itemId,Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(childToUpdate));});}});store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_12" /* moveUpdateComplete */])(selectedScene,workspaceItems,workspaceChildren,currentContainer,action.socket.id,action.socket.id));action.socket.emit('moveUpdate',selectedScene,workspaceItems,workspaceChildren,currentContainer,userId);}if(action.type==="RESIZE_UPDATE"){selectedScene=action.data.selectedScene;currentContainer=action.data.currentContainer;if(currentContainer===undefined)currentContainer="workspaceItems";getAllItems=state.project.getIn(["scenes",selectedScene,currentContainer]);var workspaceItems=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({});var workspaceChildren=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({});action.data.items.entrySeq().forEach(function(_ref9){var _ref10=_slicedToArray(_ref9,2),key=_ref10[0],item=_ref10[1];workspaceItems=workspaceItems.set(key,Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({x:item.get('x'),y:item.get('y'),width:item.get('width'),height:item.get('height')}));var item_to_merge=getAllItems.get(key);if(item.get("type")==="TEXT"||item.get("type")==="SHAPE"){var isFixedWidth=item_to_merge.getIn(["textData","formats","others","isFixedWidth"]);if(!isFixedWidth)item_to_merge=item_to_merge.setIn(["textData","formats","others","isFixedWidth"],true);item_to_merge=item_to_merge.setIn(["textData","formats","containerStyle","fontSize"],item.getIn(["textData","formats","containerStyle","fontSize"]));item_to_merge=item_to_merge.setIn(["textData","splittedText"],item.getIn(["textData","splittedText"]));workspaceItems=workspaceItems.setIn([key,"textData"],item_to_merge.get("textData"));}if(item.get("type")==="SHAPE"){workspaceItems=workspaceItems.setIn([key,"groupBounds"],item.get("groupBounds"));if(item.get("pathData")!==undefined)workspaceItems=workspaceItems.setIn([key,"pathData"],item.get("pathData"));if(item.get("path")!==undefined)workspaceItems=workspaceItems.setIn([key,"path"],item.get("path"));}if(item.get("type")==="TEXT"&&item.get("subType")==="BANNER"){if(item.get("pathData")!==undefined)workspaceItems=workspaceItems.setIn([key,"pathData"],item.get("pathData"));if(item.get("path")!==undefined)workspaceItems=workspaceItems.setIn([key,"path"],item.get("path"));if(item.get("xRatio")!==undefined)workspaceItems=workspaceItems.setIn([key,"xRatio"],item.get("xRatio"));if(item.get("yRatio")!==undefined)workspaceItems=workspaceItems.setIn([key,"yRatio"],item.get("yRatio"));if(item.get("widthRatio")!==undefined)workspaceItems=workspaceItems.setIn([key,"widthRatio"],item.get("widthRatio"));if(item.get("heightRatio")!==undefined)workspaceItems=workspaceItems.setIn([key,"heightRatio"],item.get("heightRatio"));}if(item.get("type")==="TXTOVLY"||item.get("type")==="GROUP"){var groupItems=state.project.getIn(["scenes",selectedScene,"workspaceChildren"]);item.get("groupChildren").entrySeq().forEach(function(_ref11){var _ref12=_slicedToArray(_ref11,2),childKey=_ref12[0],itemId=_ref12[1];var child=action.data.children.get(itemId);var childItem=groupItems.get(itemId);if(child.get("type")==="TEXT"){var _isFixedWidth=childItem.getIn(["textData","formats","others","fixedWidth"]);if(!_isFixedWidth)childItem=childItem.setIn(["textData","formats","others","fixedWidth"],true);childItem=childItem.setIn(["textData","formats","containerStyle","fontSize"],child.getIn(["textData","formats","containerStyle","fontSize"]));}var childToUpdate={x:child.get('x'),y:child.get('y'),width:child.get('width'),height:child.get('height')};if(child.get("path")!==undefined)childToUpdate.path=child.get("path");workspaceChildren=workspaceChildren.set(itemId,Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(childToUpdate));if(child.get("type")==="OVLYSVG"&&item.get("isExpands")&&child.get("groupBounds")){workspaceChildren=workspaceChildren.setIn([itemId,"groupBounds"],child.get("groupBounds"));}if(child.get("type")==="TEXT"||child.get("type")==="SHAPE"){var _isFixedWidth2=childItem.getIn(["textData","formats","others","fixedWidth"]);if(!_isFixedWidth2)childItem=childItem.setIn(["textData","formats","others","fixedWidth"],true);childItem=childItem.setIn(["textData","formats","containerStyle","fontSize"],child.getIn(["textData","formats","containerStyle","fontSize"]));}workspaceChildren=workspaceChildren.setIn([itemId,"textData"],childItem.get("textData"));});}});store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_12" /* moveUpdateComplete */])(selectedScene,workspaceItems,workspaceChildren,currentContainer,action.socket.id,action.socket.id));action.socket.emit('moveUpdate',selectedScene,workspaceItems,workspaceChildren,currentContainer,userId);}if(action.type==="DUPLICATE_SCENE"){var currentSlide=action.data;var newslide=state.project.getIn(["scenes",currentSlide]);action.playHeadValue=newslide.get("startTime")+newslide.get("duration");var newWorkspaceItem={},newWorkspaceChildren={};state.project.getIn(["scenes",currentSlide,"workspaceItems"]).entrySeq().forEach(function(_ref13){var _ref14=_slicedToArray(_ref13,2),key=_ref14[0],value=_ref14[1];var childIds=[];if(value.get("type")==="GROUP"){value.get("groupChildren").entrySeq().forEach(function(_ref15){var _ref16=_slicedToArray(_ref15,2),cKey=_ref16[0],childId=_ref16[1];var uniqueId=Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString();var child=newslide.getIn(["workspaceChildren",childId]);newWorkspaceChildren[uniqueId]=child.toJS();childIds.push(uniqueId);});value=value.set("groupChildren",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(childIds));}newWorkspaceItem[Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString()]=value;});newWorkspaceItem=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(newWorkspaceItem);newWorkspaceItem=newWorkspaceItem.sortBy(function(value,key){return value.get("index");});newslide=newslide.set("workspaceItems",newWorkspaceItem.toOrderedMap().toJS());newslide=newslide.set("workspaceChildren",newWorkspaceChildren);var newId=Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString();newslide=newslide.set("id",newId);var duration=state.project.get("duration");var newDuration=state.project.get("duration")+newslide.getIn(["workspaceBG","videoEnd"]);store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["Z" /* duplicateSceneComplete */])(currentSlide+1,newslide.toJS(),action.socket.id,action.socket.id));action.socket.emit('duplicateScene',currentSlide+1,newslide.toJS(),userId);}if(action.type==="REMOVE_SCENE"){if(Number.isNaN(action.data)){action.data=action.data.index;}var sceneNumber=action.data===0?0:action.data-1;action.playHead=state.localStore.get("visibleTimelineTab")!=="musicTab"?0:state.project.getIn(["scenes",sceneNumber,"startTime"]);var currentSceneStartTime=state.project.getIn(['scenes',action.data,"startTime"]);var currentSceneEndTime=currentSceneStartTime+state.project.getIn(['scenes',action.data,"duration"]);action.sceneStart=state.project.getIn(["scenes",sceneNumber,"startTime"]);action.oldDuration=state.project.get("duration");action.selectedSceneDuration=state.project.getIn(["scenes",sceneNumber,"duration"]);action.totalDuration=state.project.get("duration")-state.project.getIn(["scenes",action.data,"duration"]);var localSelectedScene=state.localStore.get("selectedScene");var nextSelectedscene=state.localStore.get("selectedScene");if(action.currentSocketId===action.socketId||action.data===localSelectedScene){nextSelectedscene=action.data===0?0:action.data<=localSelectedScene?localSelectedScene-1:localSelectedScene;}else if(action.data<=localSelectedScene){nextSelectedscene=localSelectedScene===0?0:localSelectedScene-1;}action.selectedSceneDuration=state.project.getIn(["scenes",nextSelectedscene,"duration"]);action.newPlayheadVaue=state.project.getIn(["scenes",nextSelectedscene,"startTime"]);store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_22" /* removeSceneComplete */])(action.data,action.socket.id,action.socket.id));action.socket.emit('removeScene',action.data,userId);}if(action.type==="ADD_SCENE_TRANSITION"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["l" /* addSceneTransitionComplete */])(action.slideIndex,action.data,action.sizes,action.socket.id,action.socket.id));action.socket.emit('addSceneTransition',action.slideIndex,action.data,action.sizes.toJS(),userId);}if(action.type==="UPDATE_SCENE"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_89" /* updateSceneComplete */])(projectid,action.data.selectedScene,action.data.toUpdate,true,action.socket.id,action.socket.id));action.socket.emit("updateSceneValue",action.data.selectedScene,action.data.toUpdate,true,userId);}if(action.type==="CHANGE_ACTION"){var _toUpdate=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({animdata:action.label.get("animdata"),expression:action.label.get("expression"),height:action.label.get("height"),width:action.label.get("width"),pose:action.label.get("pose"),src:action.label.get("src"),expFlag:action.label.get("expFlag"),isRepeated:action.label.get("isRepeated"),mouthAction:action.label.get("mouthAction"),colors:action.label.get("colors"),defaultColor:action.label.get("defaultColor")});store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_84" /* updateObjectComplete */])(projectid,action.selectedScene,action.id,"workspaceItems",_toUpdate.toJS(),action.socket.id,action.socket.id));action.socket.emit('updateObject',action.selectedScene,action.id,"workspaceItems",_toUpdate.toJS(),true,userId);}if(action.type==="CHANGE_EXPRESSION"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["D" /* changeExpressionComplete */])(action.selectedScene,action.id,action.label,action.socket.id,action.socket.id));action.socket.emit('changeExpression',action.selectedScene,action.id,action.label,userId);}if(action.type==="CHANGE_VIDEO_VOLUME"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["K" /* changeVideoVolumeComplete */])(action.data.selectedScene,action.data.value,action.socket.id,action.socket.id));action.socket.emit('changeVideoVolume',action.data.selectedScene,action.data.value,userId);}if(action.type==="DROP_BG"||action.type==="CHANGE_BG"){if(action.data.isRemoveFrmBg){var _enterStart=0,_exitEnd=state.project.getIn(['scenes',action.data.selectedScene,'duration']);var enterEnd=0,exitStart=0,enterEffectName="no_Effect",flipPosition=0,childIds=[];if(_exitEnd-_enterStart<=1&&_exitEnd>=2)_enterStart=_exitEnd-2;if(_enterStart===_exitEnd)_enterStart=0;var itemToAdd=Object.assign(action.data.itemToAdd,{enterStart:_enterStart,enterEnd:enterEnd,enterEffectName:enterEffectName});var _workspaceItems=state.project.getIn(["scenes",action.data.selectedScene,"workspaceItems"]);_workspaceItems=_workspaceItems.set(action.data.itemToAdd.id,itemToAdd).toJS();var _workspaceBG=state.project.getIn(["scenes",action.data.selectedScene,"workspaceBG"]);_workspaceBG=_workspaceBG.delete("videoDuration");_workspaceBG=_workspaceBG.delete("duration");_workspaceBG=_workspaceBG.delete("volume");_workspaceBG=_workspaceBG.set("src","");_workspaceBG=_workspaceBG.set("thumbnail","");_workspaceBG=_workspaceBG.set("type","");_workspaceBG=_workspaceBG.set("subType","");_workspaceBG=_workspaceBG.set("stockId","");_workspaceBG=_workspaceBG.set("flipPosition",0);_workspaceBG=_workspaceBG.set("angle",0);_workspaceBG=_workspaceBG.set("bgFilter","");_workspaceBG=_workspaceBG.set("videoStart",0);_workspaceBG=_workspaceBG.set("isBlob",false);_workspaceBG=_workspaceBG.set("videoEnd",state.project.getIn(["scenes",action.data.selectedScene,"duration"]));var _toUpdate2={workspaceItems:_workspaceItems,workspaceBG:_workspaceBG.toJS()};store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_89" /* updateSceneComplete */])(projectid,action.data.selectedScene,_toUpdate2,true,action.socket.id,action.socket.id));action.socket.emit("updateSceneValue",action.data.selectedScene,_toUpdate2,true,userId);}else{var bgWidth=action.data.bgWidth,bgHeight=action.data.bgHeight,bgScale=null,bgWidthScale=null,bgHeightScale=null;var workspaceWidth=state.project.get("width");var workspaceHeight=state.project.get("height");if(state.localStore.get("anymsUploadStatus")!=="processing"&&!action.data.isSample||action.data.bgType!=="STOCKVID"&&action.data.bgType!=="UPVIDEO"){if(workspaceWidth>=workspaceHeight){bgWidth=workspaceWidth;bgHeight=action.data.bgHeight*(bgWidth/action.data.bgWidth);if(bgHeight<=workspaceHeight){bgHeight=workspaceHeight;bgWidth=bgWidth*(bgHeight/(action.data.bgHeight*(bgWidth/action.data.bgWidth)));}}else{bgHeight=workspaceHeight;bgWidth=action.data.bgWidth*(bgHeight/action.data.bgHeight);if(bgWidth<=workspaceWidth){bgWidth=workspaceWidth;bgHeight=bgHeight*(bgWidth/(action.data.bgWidth*(bgHeight/action.data.bgHeight)));}}}else{if(workspaceWidth>=workspaceHeight){bgWidth=workspaceWidth;bgHeight=action.data.bgHeight*(bgWidth/action.data.bgWidth);if(bgHeight>=workspaceHeight){bgHeight=workspaceHeight;bgWidth=bgWidth*(bgHeight/(action.data.bgHeight*(bgWidth/action.data.bgWidth)));}}else{bgHeight=workspaceHeight;bgWidth=action.data.bgWidth*(bgHeight/action.data.bgHeight);if(bgWidth>=workspaceWidth){bgWidth=workspaceWidth;bgHeight=bgHeight*(bgWidth/(action.data.bgWidth*(bgHeight/action.data.bgHeight)));}}}bgWidthScale=bgWidth/workspaceWidth;bgHeightScale=bgHeight/workspaceHeight;var dW=workspaceWidth-bgWidth,dH=workspaceHeight-bgHeight;if(isNaN(dW))dW=0;if(isNaN(dH))dH=0;var x=dW/2/workspaceWidth,y=dH/2/workspaceHeight,width=bgWidthScale,height=bgHeightScale;selectedScene=action.data.selectedScene;var workspaceBG=state.project.getIn(["scenes",selectedScene,"workspaceBG"]).toJS();if(state.localStore.get("anymsUploadStatus")==="processing"||action.data.isSample)workspaceBG.color=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(["#000000"]);workspaceBG.src=action.data.source;workspaceBG.thumbnail=action.data.thumb;workspaceBG.type=action.data.bgType;workspaceBG.enterStart=0;workspaceBG.exitEnd=state.project.getIn(["scenes",selectedScene,'duration']);workspaceBG.x=x;workspaceBG.y=y;workspaceBG.width=width;workspaceBG.height=height;workspaceBG.angle=0;workspaceBG.flipPosition=0;workspaceBG.assetId=action.data.assetId;if(action.data.actualWidth){workspaceBG.actualWidth=action.data.actualWidth;workspaceBG.actualHeight=action.data.actualHeight;workspaceBG.actualX=x;workspaceBG.actualY=y;}var droppedDuration=state.project.getIn(["scenes",selectedScene,'duration']);if(action.data.bgFilter!==undefined)workspaceBG.bgFilter=action.data.bgFilter;if(action.data.flipPosition!==undefined)workspaceBG.flipPosition=action.data.flipPosition;if(action.data.sourceType!==undefined)workspaceBG.sourceType=action.data.sourceType;workspaceBG.duration=state.project.getIn(["scenes",selectedScene,'duration']);workspaceBG.videoDuration=workspaceBG.duration;if(action.data.subType!==undefined)workspaceBG.subType=action.data.subType;else workspaceBG.subType="";if(action.data.bgType==="STOCKIMG"||action.data.bgType==="STOCKVID"||action.data.bgType==="GIPHY")workspaceBG.stockId=action.data.stockId;if(action.data.bgType==="VIDEO"||action.data.bgType==="STOCKVID"||action.data.bgType==="UPVIDEO"){workspaceBG.videoStart=0;workspaceBG.videoEnd=workspaceBG.duration;workspaceBG.duration=action.data.duration;droppedDuration=action.data.duration;workspaceBG.displaysizes=action.data.displaysizes;workspaceBG.volume=100;if(action.data.bgType==="STOCKVID"||action.data.bgType==='VIDEO'){workspaceBG.poster=action.data.poster;workspaceBG.videoDuration=action.data.videoDuration;}if(action.data.bgType==="UPVIDEO"){workspaceBG.videoDuration=action.data.duration;}}else{workspaceBG.bgColor=action.data.color;workspaceBG.defaultColor=action.data.defaultColor?action.data.defaultColor:action.data.color;workspaceBG.hasGradient=action.data.hasGradient;workspaceBG.videoStart=0;workspaceBG.videoEnd=state.project.getIn(["scenes",selectedScene,"duration"]);workspaceBG.videoDuration=state.project.getIn(["scenes",selectedScene,"workspaceBG","videoDuration"]);}if(action.data.isBlob!==undefined){workspaceBG.isBlob=action.data.isBlob;}workspaceBG.exitEnd=workspaceBG.duration;var deleteId="";if(action.data.isCustomBg===true)deleteId=action.data.selectedItems.get(0);if(!state.localStore.get("addNewScene")){action.totalDuration=droppedDuration+state.project.get("duration")-state.project.getIn(["scenes",selectedScene,"duration"]);workspaceBG.videoEnd=action.data.videoDuration;if(action.data.isTrimedVideo){setTimeout(function(){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_7" /* loadCommonPopup */])("VIDEO",false));},400);}if(workspaceBG.videoDuration===undefined)workspaceBG.videoDuration=state.project.getIn(["scenes",selectedScene,"duration"]);var _duration=state.project.get("duration");var _newDuration=state.project.get("duration")+workspaceBG.videoDuration-state.project.getIn(["scenes",selectedScene,"duration"]);if(workspaceBG.videoDuration<state.project.getIn(["scenes",selectedScene,"duration"])){_newDuration=state.project.get("duration")-(state.project.getIn(["scenes",selectedScene,"duration"])-workspaceBG.videoDuration);}store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["B" /* changeBgComplete */])(selectedScene,workspaceBG,deleteId,action.deleteData,action.socket.id,action.socket.id));action.socket.emit('changeBg',selectedScene,workspaceBG,deleteId,action.deleteData,userId);}else{workspaceBG.enterStart=0;if(action.data.bgType==="VIDEO"||action.data.bgType==="STOCKVID"||action.data.bgType==="UPVIDEO"){workspaceBG.exitEnd=action.data.duration;workspaceBG.videoEnd=action.data.duration;workspaceBG.displaysizes=action.data.displaysizes;}workspaceBG.videoEnd=action.data.videoDuration;var totalDuration=0;for(var i=0;i<state.project.getIn(['scenes']).size;i++){totalDuration+=state.project.getIn(['scenes',i,'duration']);}var slideIndex=state.project.getIn(["scenes"]).size;var newslide={"id":Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString(),"duration":action.data.duration===undefined?sceneDuration:action.data.duration,"workspaceChildren":{},"workspaceItems":{},"workspaceBG":workspaceBG,"startTime":totalDuration,"transEffect":"NoTransition"};if(action.data.slide!==undefined){newslide=action.data.slide.toJS();}var _duration2=state.project.get("duration");var _newDuration2=state.project.get("duration")+newslide["duration"];action.totalDuration=_newDuration2;store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["k" /* addSceneComplete */])(slideIndex,newslide,action.socket.id,action.socket.id));action.socket.emit('addScene',slideIndex,newslide,userId);}}}if(action.type==="DELETE_BG"){var _workspaceBG2=state.project.getIn(["scenes",action.data.selectedScene,"workspaceBG"]);_workspaceBG2=_workspaceBG2.delete("videoDuration");_workspaceBG2=_workspaceBG2.delete("duration");_workspaceBG2=_workspaceBG2.delete("volume");_workspaceBG2=_workspaceBG2.set("src","");_workspaceBG2=_workspaceBG2.set("thumbnail","");_workspaceBG2=_workspaceBG2.set("type","");_workspaceBG2=_workspaceBG2.set("subType","");_workspaceBG2=_workspaceBG2.set("stockId","");_workspaceBG2=_workspaceBG2.set("flipPosition",0);_workspaceBG2=_workspaceBG2.set("angle",0);_workspaceBG2=_workspaceBG2.set("bgFilter","");_workspaceBG2=_workspaceBG2.set("videoStart",0);_workspaceBG2=_workspaceBG2.set("isBlob",false);_workspaceBG2=_workspaceBG2.set("videoEnd",state.project.getIn(["scenes",action.data.selectedScene,"duration"]));if(action.data.color){_workspaceBG2=_workspaceBG2.set("color",action.data.color);_workspaceBG2=_workspaceBG2.set("isRadial",action.data.isRadial);_workspaceBG2=_workspaceBG2.set("radius",action.data.radius);_workspaceBG2=_workspaceBG2.set("direction",action.data.direction);}store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["B" /* changeBgComplete */])(action.data.selectedScene,_workspaceBG2.toJS(),"",[],action.socket.id,action.socket.id));action.socket.emit('changeBg',action.data.selectedScene,_workspaceBG2.toJS(),"",[],userId);}if(action.type==="APPLY_FILTER"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["t" /* applyFilterComplete */])(action.selectedScene,action.active,action.filterCode,action.socket.id,action.socket.id));action.socket.emit('applyFilter',action.selectedScene,action.active,action.filterCode,userId);}if(action.type==="UPDATE_SVGCOLOR"){var container="workspaceItems";if(action.container!==undefined)container=action.container;if(state.project.getIn(["scenes",action.selectedScene,container,action.id,"type"])==="SHAPE"){var path=state.project.getIn(["scenes",action.selectedScene,container,action.id,"path"]);var colors=state.project.getIn(["scenes",action.selectedScene,container,action.id,"colors"]);path=path.setIn([colors.keySeq().toList().findIndex(function(x){return x===action.cls;}),"color"],action.color);store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_84" /* updateObjectComplete */])(projectid,action.selectedScene,action.id,container,{path:path.toJS()},action.socket.id,action.socket.id));action.socket.emit('updateObject',action.selectedScene,action.id,container,{path:path.toJS()},true,userId);}store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_92" /* updateSvgColorComplete */])(action.selectedScene,container,action.id,action.cls,action.color,action.socket.id,action.socket.id));action.socket.emit('updateSvgColor',action.selectedScene,container,action.id,action.cls,action.color,userId);}if(action.type==="UPDATE_SVG_THEME"){var container="workspaceItems";if(action.container!==undefined)container=action.container;store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_93" /* updateSvgThemeComplete */])(projectid,action.selectedScene,container,action.id,action.colorData.toJS(),action.isBG,action.socket.id,action.socket.id));action.socket.emit('updateSvgTheme',action.selectedScene,container,action.id,action.colorData,action.isBG,userId);}if(action.type==="FLIP_ITEM"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_3" /* flipItemComplete */])(action.data.selectedScene,action.data.active,action.data.flipPosition,action.socket.id,action.socket.id));action.socket.emit('flipItem',action.data.selectedScene,action.data.active,action.data.flipPosition,userId);}if(action.type==="CROP_IMAGE"){selectedScene=action.data.selectedScene;var selectedItem=state.project.getIn(["scenes",selectedScene,"workspaceItems",action.data.selectedItems.get(0)]);if(action.data.original.x===0&&action.data.original.y===0&&action.data.original.width===1&&action.data.original.height===1){var original=selectedItem.delete("original");selectedItem=selectedItem.set("isCropped",false);selectedItem=selectedItem.delete("original");}else{selectedItem=selectedItem.merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.crop));selectedItem=selectedItem.set("original",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.original));if(action.data.isCropping)selectedItem=selectedItem.set("isCropped",true);}store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["P" /* cropImageComplete */])(action.data.selectedScene,action.data.selectedItems.get(0),selectedItem.toJS(),action.socket.id,action.socket.id));action.socket.emit('cropImage',action.data.selectedScene,action.data.selectedItems.get(0),selectedItem.toJS(),userId);}if(action.type==="CROP_BG"){selectedScene=action.data.selectedScene;var workspaceBg=state.project.getIn(["scenes",action.data.selectedScene,'workspaceBG']).toJS();if(!action.data.isVideo){workspaceBg.x=action.data.bgScales.x;workspaceBg.y=action.data.bgScales.y;workspaceBg.width=action.data.bgScales.width;workspaceBg.height=action.data.bgScales.height;}else state=state.setIn(["videos",action.data.videoId,"bgScales"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.bgScales));store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["N" /* cropBgComplete */])(action.data.selectedScene,workspaceBg,action.data.isVideo,action.data.videoId,action.data.bgScales,action.socket.id,action.socket.id));action.socket.emit('cropBg',action.data.selectedScene,workspaceBg,action.data.isVideo,action.data.videoId,action.data.bgScales,userId);}if(action.type==="BG_COLOR_SELECTION"){var colorArray=state.project.getIn(["scenes",action.selectedScene,"workspaceBG","color"]);if(action.deletePosition>=0&&action.deletePosition!==null){colorArray=colorArray.remove(action.deletePosition);}else{if(action.enteredColorPosition!==null){colorArray=colorArray.setIn([action.enteredColorPosition],action.value.toUpperCase());}else{if(Array.isArray(action.value)){colorArray=action.value;}else if(colorArray!==undefined&&colorArray.size>=0){colorArray=colorArray.push(action.value.toUpperCase());}}}store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["u" /* bgColorSelectionComplete */])(action.selectedScene,colorArray,action.socket.id,action.socket.id));action.socket.emit('bgColorSelection',action.selectedScene,colorArray,userId);}if(action.type==="BG_GRADIENT_COLORS"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["v" /* bgGradientColorsComplete */])(action.selectedScene,action.radialStatus,action.value,action.radius,action.socket.id,action.socket.id));action.socket.emit('bgGradientColors',action.selectedScene,action.radialStatus,action.value,action.radius,userId);}if(action.type==="UPDATE_BGCOLOR"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_77" /* updateBgColorComplete */])(action.selectedScene,action.cls,action.color,action.socket.id,action.socket.id));action.socket.emit('updateBgColor',action.selectedScene,action.cls,action.color,userId);}if(action.type==="UPDATE_BGGRADIENT"){var gradientIndex=action.cls.charAt(0);var gradientSecIndex=action.cls.charAt(1);store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_79" /* updateBgGradientComplete */])(action.selectedScene,gradientIndex,gradientSecIndex,action.color,action.socket.id,action.socket.id));action.socket.emit('updateBgGradient',action.selectedScene,gradientIndex,gradientSecIndex,action.color,userId);}if(action.type==="SET_SELECTED_ITEMS"){action.selectedSceneDuration=state.project.getIn(["scenes",state.localStore.get("selectedScene"),"duration"]);store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_45" /* setSelectedItemsComplete */])(projectid,action.data.selectedItems[0],projectUsr,userId,projectUsrImg,socketid,socketid));action.socket.emit('setSelectedItems',action.data.selectedItems[0],projectUsr,userId,projectUsrImg,userId);}if(action.type==="SET_SELECTED_SCENE"){action.oldduration=state.project.getIn(["scenes",state.localStore.get("selectedScene"),"duration"]);action.newduration=state.project.getIn(["scenes",action.selectedScenes[0],"duration"]);action.playHead=state.project.getIn(["scenes",action.selectedScenes[0],"startTime"]);store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_47" /* setSelectedSceneComplete */])(projectid,action.selectedScenes[0],projectUsr,userId,projectUsrImg,action.socket.id,action.socket.id));action.socket.emit('setSelectedScene',action.selectedScenes[0],projectUsr,userId,projectUsrImg,userId);}if(action.type==="CHANGE_TEXT"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["I" /* changeTextComplete */])(action.data.selectedScene,action.data.container,action.data.active,action.data.text.toJS(),action.socket.id,action.socket.id,true));action.socket.emit('changeText',action.data.selectedScene,action.data.container,action.data.active,action.data.text,userId);}if(action.type==="UPDATE_GROUP_TEXT"){if(!state.localStore.get("isPlay")&&!state.localStore.get("isPlayAll")){var selectedScene=action.data.selectedScene;var groupId=action.data.groupId,currentId=action.data.currentId;var aboveY=void 0,belowY=void 0,curY=void 0,curHeight=void 0;var aboveHeight=void 0,belowHeight=void 0;if(action.data.verticalAlign==="middle"){aboveY=-1*(action.data.dH/2);belowY=action.data.dH/2;curY=-1*(action.data.dH/2);curHeight=action.data.dH;aboveHeight=0;belowHeight=0;}else if(action.data.verticalAlign==="bottom"){aboveY=-1*action.data.dH;belowY=0;curY=-1*action.data.dH;curHeight=action.data.dH;aboveHeight=0;belowHeight=0;}else{if(action.data.isPrebuilt){aboveY=0;belowY=action.data.dH<0?0:action.data.dH;curY=0;curHeight=action.data.dH<0?0:action.data.dH;aboveHeight=0;belowHeight=0;}else{aboveY=0;belowY=action.data.dH;curY=0;curHeight=action.data.dH;aboveHeight=0;belowHeight=0;}}var childIds=state.project.getIn(["scenes",selectedScene,"workspaceItems",groupId,"groupChildren"]);var children=state.project.getIn(["scenes",selectedScene,"workspaceChildren"]).filter(function(obj,key){return childIds.keyOf(key)!==undefined;});var workspaceItems=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({});var workspaceChildren=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({});var allChildren=state.project.getIn(["scenes",selectedScene,"workspaceChildren"]);var allWorkspaceItems=state.project.getIn(["scenes",selectedScene,"workspaceItems"]);if(action.data.isGrouped){children.entrySeq().forEach(function(_ref17){var _ref18=_slicedToArray(_ref17,2),key=_ref18[0],item=_ref18[1];if(key===currentId){workspaceChildren=workspaceChildren.setIn([key,"y"],parseFloat((item.get("y")+curY).toFixed(2)));workspaceChildren=workspaceChildren.setIn([key,"height"],parseFloat((item.get("height")+curHeight).toFixed(2)));if(action.data.textData!==undefined)workspaceChildren=workspaceChildren.setIn([key,"textData"],action.data.textData);}else if(item.get("y")<action.data.itemY){workspaceChildren=workspaceChildren.setIn([key,"y"],parseFloat((item.get("y")+aboveY).toFixed(2)));workspaceChildren=workspaceChildren.setIn([key,"height"],parseFloat((item.get("height")+aboveHeight).toFixed(2)));}else{workspaceChildren=workspaceChildren.setIn([key,"y"],parseFloat((item.get("y")+belowY).toFixed(2)));workspaceChildren=workspaceChildren.setIn([key,"height"],parseFloat((item.get("height")+belowHeight).toFixed(2)));}});var parentItem=allWorkspaceItems.get(groupId);workspaceItems=workspaceItems.setIn([groupId,"y"],parseFloat((parentItem.get("y")+curY).toFixed(2)));workspaceItems=workspaceItems.setIn([groupId,"height"],parseFloat((parentItem.get("height")+curHeight).toFixed(2)));}else{var siblings=state.project.getIn(["scenes",selectedScene,"workspaceItems"]).filter(function(obj,key){return action.data.selectedItems.keyOf(key)!==undefined;});siblings.entrySeq().forEach(function(_ref19){var _ref20=_slicedToArray(_ref19,2),key=_ref20[0],item=_ref20[1];if(key===currentId){workspaceItems=workspaceItems.setIn([key,"y"],parseFloat((item.get("y")+curY).toFixed(2)));workspaceItems=workspaceItems.setIn([key,"height"],parseFloat((item.get("height")+curHeight).toFixed(2)));if(action.data.textData!==undefined)workspaceItems=workspaceItems.setIn([key,"textData"],action.data.textData);}else if(item.get("y")<action.data.itemY){workspaceItems=workspaceItems.setIn([key,"y"],parseFloat((item.get("y")+aboveY).toFixed(2)));workspaceItems=workspaceItems.setIn([key,"height"],parseFloat((item.get("height")+aboveHeight).toFixed(2)));}else{workspaceItems=workspaceItems.setIn([key,"y"],parseFloat((item.get("y")+belowY).toFixed(2)));workspaceItems=workspaceItems.setIn([key,"height"],parseFloat((item.get("height")+belowHeight).toFixed(2)));}});}store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_81" /* updateGroupTextComplete */])(action.data.selectedScene,workspaceItems.toJS(),workspaceChildren.toJS(),action.socket.id,action.socket.id,true));action.socket.emit("updateGroupText",action.data.selectedScene,workspaceItems.toJS(),workspaceChildren.toJS(),userId);}}if(action.type==="DELETE_ITEM"){var selectedItems=action.data.selectedItems;var selectedScene=action.data.selectedScene;var workspaceItems=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({});var childIds=[];for(var i=0;i<selectedItems.length;i++){if(state.project.getIn(["scenes",selectedScene,"workspaceItems",selectedItems[i],"type"])==="GROUP"){childIds=childIds.concat(state.project.getIn(["scenes",selectedScene,"workspaceItems",selectedItems[i],"groupChildren"]).toJS());}}var getAllItems=state.project.getIn(["scenes",selectedScene,"workspaceItems"]);getAllItems=selectedItems.reduce(function(map,key){return map.delete(key);},getAllItems);i=0;getAllItems.entrySeq().forEach(function(_ref21){var _ref22=_slicedToArray(_ref21,2),key=_ref22[0],value=_ref22[1];workspaceItems=workspaceItems.setIn([key,"index"],i);workspaceItems=workspaceItems.setIn([key,"animIndex"],i);i++;});store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["U" /* deleteItemComplete */])(action.data.selectedScene,selectedItems,childIds,workspaceItems,action.socket.id,action.socket.id));action.socket.emit("deleteItem",action.data.selectedScene,selectedItems,childIds,workspaceItems,userId);}if(action.type==="SET_Z_INDEX"){var selectedScene=action.data.selectedScene;var workspaceItems=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({});var currentIndex=state.project.getIn(["scenes",selectedScene,"workspaceItems",action.data.selectedItem,"index"]);var nextKey=null,prevKey=null,nextItem=null,prevItem=null;var maxObjects=state.project.getIn(["scenes",selectedScene,"workspaceItems"]).filter(function(obj,key){return obj.get("index")>currentIndex;});var minObjects=state.project.getIn(["scenes",selectedScene,"workspaceItems"]).filter(function(obj,key){return obj.get("index")<currentIndex;});if(maxObjects.size>0){nextItem=maxObjects.first();nextKey=maxObjects.keySeq().toArray()[0];}if(minObjects.size>0){prevItem=minObjects.last();var minKeys=minObjects.keySeq().toArray();prevKey=minKeys[minKeys.length-1];}if(action.data.to==="front"&&nextItem!==null){workspaceItems=workspaceItems.setIn([action.data.selectedItem,"index"],nextItem.get("index"));workspaceItems=workspaceItems.setIn([nextKey,"index"],currentIndex);}else if(action.data.to==="back"&&prevItem!==null){workspaceItems=workspaceItems.setIn([action.data.selectedItem,"index"],prevItem.get("index"));workspaceItems=workspaceItems.setIn([prevKey,"index"],currentIndex);}else if(action.data.to==="first"){var count=0;state.project.getIn(["scenes",selectedScene,"workspaceItems"]).entrySeq().forEach(function(_ref23){var _ref24=_slicedToArray(_ref23,2),key=_ref24[0],value=_ref24[1];if(action.data.selectedItem===key){workspaceItems=workspaceItems.setIn([key,"index"],state.project.getIn(["scenes",selectedScene,"workspaceItems"]).size-1);}else{workspaceItems=workspaceItems.setIn([key,"index"],count);count++;}});}else if(action.data.to==="last"){var _count=1;state.project.getIn(["scenes",selectedScene,"workspaceItems"]).entrySeq().forEach(function(_ref25){var _ref26=_slicedToArray(_ref25,2),key=_ref26[0],value=_ref26[1];if(action.data.selectedItem===key){workspaceItems=workspaceItems.setIn([key,"index"],0);}else{workspaceItems=workspaceItems.setIn([key,"index"],_count);_count++;}});}store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_54" /* setZIndexComplete */])(action.data.selectedScene,workspaceItems,action.socket.id,action.socket.id));action.socket.emit("setZIndex",action.data.selectedScene,workspaceItems,userId);}if(action.type==="GROUP_OBJECTS"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_5" /* groupObjectsComplete */])(action.data.selectedScene,action.data.selectedItems.toJS(),action.data.workspaceItems.toJS(),action.data.workspaceChildren.toJS(),action.data.workspaceItemsOrder,action.socket.id,action.socket.id));action.socket.emit("groupObjects",action.data.selectedScene,action.data.selectedItems,action.data.workspaceItems,action.data.workspaceChildren,action.data.workspaceItemsOrder,userId);}if(action.type==="UNGROUP_OBJECTS"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_75" /* ungroupObjectsComplete */])(action.data.selectedScene,action.data.selectedItems.toJS(),action.data.workspaceChildren.toJS(),action.data.workspaceItemsOrder,action.socket.id,action.socket.id));action.socket.emit("ungroupObjects",action.data.selectedScene,action.data.selectedItems,action.data.workspaceChildren,action.data.workspaceItemsOrder,userId);}if(action.type==="UPDATE_TEXT"){if(!state.localStore.get("isPlay")&&!state.localStore.get("isPlayAll")){var container="workspaceItems";if(action.data.container!==undefined)container=action.data.container;selectedScene=action.data.selectedScene;var property=action.data.property;var value=action.data.value;var childIds=[];var formats=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({containerStyle:{},bullet:{},others:{}});if(action.data.isPartial===undefined||!action.data.isPartial){if(property==="bullet"){formats=formats.setIn(["bullet","type"],value);if(formats.getIn(["containerStyle","textAlign"])!=="left")formats=formats.setIn(["containerStyle","textAlign"],"left");}else if(property==="bulletSpace"){formats=formats.setIn(["bullet","bulletSpace"],parseInt(value));}else{if(property==="fontSize"){if(value==="autopx"){formats=formats.setIn(["others","isAutoFontSize"],true);}else{formats=formats.setIn(["others","isAutoFontSize"],false);}formats=formats.setIn(["others","sizeFixed"],true);}formats=formats.setIn(["containerStyle",property],value);}if(property==="fontFamily"&&action.data.textData!==undefined){if(action.data.lineHeight!==undefined)formats=formats.setIn(["containerStyle","lineHeight"],action.data.lineHeight);formats=formats.set("others",action.data.textData.getIn(["formats","others"]));}}else if(property==="bullet"||property==="fontSize"||property==="fontFamily"){if(property==="bullet"){formats=formats.setIn(["bullet","type"],value);if(formats.getIn(["containerStyle","textAlign"])!=="left")formats=formats.setIn(["containerStyle","textAlign"],"left");}else if(property==="fontSize"){if(value==="autopx")formats=formats.setIn(["others","isAutoFontSize"],true);else formats=formats.setIn(["others","isAutoFontSize"],false);formats=formats.setIn(["others","sizeFixed"],true);}}var textData=state.project.getIn(["scenes",action.data.selectedScene,action.data.container,action.data.id,"textData"]);textData=textData.set("formats",textData.get("formats").mergeDeep(formats));if(action.data.htmlText!==undefined)textData=textData.set("htmlText",action.data.htmlText);var toUpdate={textData:textData.toJS()};if(action.data.width!==undefined)toUpdate.width=action.data.width;if(action.data.height!==undefined)toUpdate.height=action.data.height;if(action.data.yRatio!==undefined)toUpdate.yRatio=action.data.yRatio;if(action.data.heightRatio!==undefined)toUpdate.heightRatio=action.data.heightRatio;store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_84" /* updateObjectComplete */])(projectid,action.data.selectedScene,action.data.id,action.data.container,toUpdate,action.socket.id,action.socket.id));action.socket.emit('updateObject',action.data.selectedScene,action.data.id,action.data.container,toUpdate,true,userId);}}if(action.type==="UPDATE_TIMELINE_DRAG"){var childToUpdate=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({});if(action.item==="workspaceItems"){var minDuration=0.1;var items=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data).filter(function(x){return x.get("name")==="enterStart"||x.get("name")==="exitEnd";}).groupBy(function(x){return x.get("id");});items.entrySeq().forEach(function(_ref27){var _ref28=_slicedToArray(_ref27,2),keyVal=_ref28[0],item=_ref28[1];if(state.project.getIn(["scenes",action.selectedScene,"workspaceItems",keyVal,"type"])==="GROUP"){var enterItem=item.find(function(x){return x.get("name")==="enterStart";});var exitItem=item.find(function(x){return x.get("name")==="exitEnd";});var parent=state.project.getIn(["scenes",action.selectedScene,"workspaceItems",keyVal]);var enterDeviation=0,exitDeviation=0;if(enterItem!==undefined)enterDeviation=parseFloat(enterItem.get("value"))-parent.get("enterStart");if(exitItem!==undefined)exitDeviation=parseFloat(exitItem.get("value"))-parent.get("exitEnd");parent.get("groupChildren").entrySeq().forEach(function(_ref29){var _ref30=_slicedToArray(_ref29,2),index=_ref30[0],cKey=_ref30[1];var child=state.project.getIn(["scenes",action.selectedScene,"workspaceChildren",cKey]);var enterStart=child.get("enterStart"),exitEnd=child.get("exitEnd"),entDur=0,extDur=0;var currentStart=parent.get("enterStart")+enterDeviation;enterStart+=enterDeviation;var currentEnd=parent.get("exitEnd")+exitDeviation;exitEnd+=exitDeviation;var chDuration=exitEnd-enterStart;if(child.get("type")==="TEXT")if(chDuration<minDuration){exitEnd+=minDuration*(exitDeviation/chDuration);enterStart-=minDuration*(enterDeviation/chDuration);enterStart=enterStart<0?0:enterStart;}if(exitEnd<=currentStart){enterStart=currentStart;exitEnd=enterStart+minDuration;}else if(enterStart>=currentEnd){enterStart=currentEnd-minDuration;exitEnd=currentEnd;}else if(exitEnd>=currentStart&&enterStart<=currentStart){enterStart=currentStart;if(exitEnd-enterStart<minDuration)exitEnd=enterStart+minDuration;}else if(enterStart<=currentEnd&&exitEnd>=currentEnd){exitEnd=currentEnd;if(exitEnd-enterStart<minDuration)enterStart=exitEnd-minDuration;}var timeScale=(exitEnd-enterStart)/(child.get("exitEnd")-child.get("enterStart"));if(child.get("enterEffectName")!=="no_Effect"&&child.get("enterEnd")>0)entDur=child.get("enterEnd")-child.get("enterStart");if(enterStart+entDur>exitEnd-extDur){entDur=entDur*timeScale>0.1?entDur*timeScale:0.1;extDur=extDur*timeScale>0.1?extDur*timeScale:0.1;}childToUpdate=childToUpdate.setIn([cKey,"enterStart"],parseFloat(enterStart.toFixed(1))).setIn([cKey,"exitEnd"],parseFloat(exitEnd.toFixed(1))).setIn([cKey,"enterEnd"],parseFloat((enterStart+entDur).toFixed(1))).setIn([cKey,"exitStart"],parseFloat((exitEnd-extDur).toFixed(1)));});}});}var tempDuration=0;var newData=action.data.map(function(value){if(value.name==="duration"){tempDuration=value["value"];}if(value.key==="audioplayhead");value.key="playHeadValue";return value;});var nextDuration=state.project.get("duration")+(tempDuration-state.project.getIn(["scenes",action.selectedScene,"duration"]));action.nextDuration=parseFloat(nextDuration.toFixed(1));action.oldduration=state.project.get("duration");store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_96" /* updateTimelineDragChangeComplete */])(action.selectedScene,action.item,action.data,action.id,childToUpdate.toJS(),action.socket.id,action.socket.id));action.socket.emit('updateTimelineDrag',action.selectedScene,action.item,newData,action.id,childToUpdate.toJS(),userId);}if(action.type==="UPDATE_TIMELINE_DRAG_COMPLETE"){selectedScene=action.selectedScene;var itr=0;if(action.itemData==="workspaceItems"){for(itr=0;itr<action.actionData.length;itr++){if(action.actionData[itr].name==='videoStart'){action.actionData.push({name:"audioplayhead",value:state.project.getIn(['scenes',selectedScene,'startTime'])});}else if(action.actionData[itr].name==='duration'){action.actionData[itr].sceneStartTime=state.project.getIn(['scenes',selectedScene,'startTime']);}}}}if(action.type==="PASTE_ITEMS"){var pasteData=action.data;selectedScene=pasteData.selectedScene;if(pasteData.dataType==="ITEMS"){workspaceItems=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(pasteData.data.workspaceItems);var _workspaceChildren=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(pasteData.data.workspaceChildren);workspaceItems=workspaceItems.sortBy(function(value,key){return value.get("index");}).toOrderedMap();var workspaceIds=[],workspaceChildIds=[],workspaceData=[],workspaceChildData=[],uniqueId;var minTime=workspaceItems.getIn([0,"enterStart"]),maxTime=0,a=0;for(a=0;a<workspaceItems.size;a++){if(workspaceItems.getIn([a,'type'])!=='SCR')minTime=minTime<workspaceItems.getIn([a,"enterStart"])?minTime:workspaceItems.getIn([a,"enterStart"]);}var playHead=0,_minDuration=1;var _maxItem=state.project.getIn(["scenes",selectedScene,"workspaceItems"]).maxBy(function(x){return x.get("index");});var nextIndex=0;if(_maxItem!==undefined)nextIndex=_maxItem.get("index");var maxAnimItem=state.project.getIn(["scenes",selectedScene,"workspaceItems"]).maxBy(function(x){return x.get("animIndex");});var nextAnimIndex=0;if(maxAnimItem!==undefined)nextAnimIndex=maxAnimItem.get("animIndex");for(a=0;a<workspaceItems.size;a++){if(workspaceItems.getIn([a,'type'])!=='SCR'){var _workspaceItems$get$t=workspaceItems.get(a).toJS(),isMultimove=_workspaceItems$get$t.isMultimove,exitEffectName=_workspaceItems$get$t.exitEffectName,_exitStart=_workspaceItems$get$t.exitStart,_exitEnd2=_workspaceItems$get$t.exitEnd,keyframes=_workspaceItems$get$t.keyframes,deckworkspaceItems=_objectWithoutProperties(_workspaceItems$get$t,['isMultimove','exitEffectName','exitStart','exitEnd','keyframes']);var item=deckworkspaceItems;nextIndex++;nextAnimIndex++;if(item.subType==='CHR'){var urlItems=item.thumb.split('/');urlItems[1]=item.charId;var thumbUrl=urlItems.join('/');item.thumb=thumbUrl+'.png';}var playDiff=Math.abs(item.enterStart-minTime);playHead=0;var playHeadVal=playHead+playDiff;var slideDuration=state.project.getIn(['scenes',selectedScene,"duration"]);var itemDuration=item.exitEnd-item.enterStart;var prevStart=item.enterStart;var prevEnd=item.exitEnd;var itemEndTime;if(playHeadVal===slideDuration){if(itemDuration>slideDuration)playHeadVal=0;else playHeadVal=slideDuration-itemDuration;itemEndTime=slideDuration;}else{if(playHeadVal+itemDuration>slideDuration)itemEndTime=slideDuration;else itemEndTime=playHeadVal+itemDuration;}var oldStart=item.enterStart;var enterEffectDuration=item.enterEnd-item.enterStart;var exitEffectDuration=item.exitEnd-item.exitStart;item.enterStart=playHeadVal;item.exitEnd=itemEndTime;itemDuration=item.exitEnd-item.enterStart;if(itemDuration<_minDuration){itemDuration=_minDuration;item.enterStart=item.exitEnd-itemDuration;}if(item.enterEffectName!=="no_Effect"){if(enterEffectDuration>itemDuration){if(enterEffectDuration>_minDuration){if(itemDuration===_minDuration)item.enterEnd=itemEndTime;else item.enterEnd=itemEndTime-_minDuration;enterEffectDuration=item.enterEnd-item.enterStart;}else item.enterEffectName="no_Effect";}else item.enterEnd=item.enterStart+enterEffectDuration;}if(item.type==="TEXT"){item.textData.formats.containerStyle.margin='0px';var pxRemoval=30*state.localStore.get('zoomFactor');item.height=item.height-pxRemoval;item.width=item.width-pxRemoval;item.textData.htmlText=item.textData.htmlText.replace(/(<([^>]+)>)/ig,'');}childIds=[];if(item.type==="TXTOVLY"||item.type==="GROUP"){var enterDeviation=item.enterStart-prevStart;var exitDeviation=item.exitEnd-prevEnd;var currentStart=item.enterStart;var currentEnd=item.exitEnd;for(var x=0;x<item.groupChildren.length;x++){var childId=Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString();workspaceChildIds.push(childId);var child=_workspaceChildren.get(item.groupChildren[x]);var _enterStart2=child.get("enterStart")+enterDeviation,_exitEnd3=child.get("exitEnd")+exitDeviation;var chDuration=_exitEnd3-_enterStart2;if(chDuration<_minDuration){_exitEnd3+=_minDuration*(exitDeviation/(currentEnd-currentStart));_enterStart2-=_minDuration*(enterDeviation/(currentEnd-currentStart));}if(_exitEnd3<=currentStart){_enterStart2=currentStart;_exitEnd3=_enterStart2+_minDuration;}else if(_enterStart2>=_exitEnd3){_enterStart2=currentEnd-_minDuration;_exitEnd3=currentEnd;}else if(_exitEnd3>currentStart&&_enterStart2<currentStart){_enterStart2=currentStart;if(_exitEnd3-_enterStart2<_minDuration)_exitEnd3=_enterStart2+_minDuration;}else if(_enterStart2<currentEnd&&_exitEnd3>currentEnd){_exitEnd3=currentEnd;if(_exitEnd3-_enterStart2<_minDuration)_enterStart2=_exitEnd3-_minDuration;}var chEntDur=0,chExtDur=0,chTimeScale=(_exitEnd3-_enterStart2)/(child.get("exitEnd")-child.get("enterStart"));if(child.get("enterEffectName")!=="no_Effect"&&child.get("enterEnd")>0)chEntDur=child.get("enterEnd")-child.get("enterStart");if(child.get("enterEffectName")!=="no_Effect"&&child.get("exitStart")>0)chExtDur=child.get("exitEnd")-child.get("exitStart");if(_enterStart2+chEntDur>_exitEnd3-chExtDur){chEntDur*=chTimeScale;chExtDur*=chTimeScale;chEntDur=chEntDur>0.1?chEntDur:0.1;chExtDur=chExtDur>0.1?chExtDur:0.1;}child=child.set("enterStart",parseFloat(_enterStart2.toFixed(1))).set("enterEnd",parseFloat((_enterStart2+chEntDur).toFixed(1))).set("exitStart",parseFloat((_exitEnd3-chExtDur).toFixed(1))).set("exitEnd",parseFloat(_exitEnd3.toFixed(1)));workspaceChildData.push(child);childIds.push(childId);}}if(item.type==="TXTOVLY"||item.type==="GROUP"){item.groupChildren=childIds;}item.index=nextIndex;item.animIndex=nextAnimIndex;item.animType='On Click';uniqueId=Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString();workspaceIds.push(uniqueId);workspaceData.push(item);}}store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_18" /* pasteItemsComplete */])(selectedScene,workspaceIds,workspaceChildIds,workspaceData,workspaceChildData,action.socket.id,action.socket.id,action.socket));action.socket.emit('pasteItems',selectedScene,workspaceIds,workspaceChildIds,workspaceData,workspaceChildData,userId);}else if(pasteData.dataType==="SCENES"){for(var i=0;i<pasteData.data.length;i++){var _pasteData$data$i=pasteData.data[i],workspaceCameras=_pasteData$data$i.workspaceCameras,playHeadValue=_pasteData$data$i.playHeadValue,actualPasteData=_objectWithoutProperties(_pasteData$data$i,['workspaceCameras','playHeadValue']);pasteData.data[i]=actualPasteData;for(var _key in pasteData.data[i]['workspaceItems']){if(pasteData.data[i]['workspaceItems'][_key]['type']!=='SCR'){if(pasteData.data[i]['workspaceItems'][_key]['animType']===undefined){pasteData.data[i]['workspaceItems'][_key]['animType']='On Click';}if(pasteData.data[i]['workspaceItems'].hasOwnProperty(_key)){var _pasteData$data$i$wor=pasteData.data[i]['workspaceItems'][_key],_isMultimove=_pasteData$data$i$wor.isMultimove,_exitEffectName=_pasteData$data$i$wor.exitEffectName,_exitStart2=_pasteData$data$i$wor.exitStart,_exitEnd4=_pasteData$data$i$wor.exitEnd,_keyframes=_pasteData$data$i$wor.keyframes,actualworkspaceItems=_objectWithoutProperties(_pasteData$data$i$wor,['isMultimove','exitEffectName','exitStart','exitEnd','keyframes']);pasteData.data[i]['workspaceItems'][_key]=actualworkspaceItems;}}}}var copiedScenes=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(pasteData.data);var toPaste=copiedScenes;var widthScale=state.project.get("width")/pasteData.width;var heightScale=state.project.get("height")/pasteData.height;var scale=widthScale<=heightScale?widthScale:heightScale;var _duration3=0;copiedScenes.entrySeq().forEach(function(_ref31){var _ref32=_slicedToArray(_ref31,2),index=_ref32[0],scene=_ref32[1];_duration3+=scene.get("duration");var workspaceItems=scene.get("workspaceItems");var workspaceChildren=scene.get("workspaceChildren");var allItems=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({});var allChildren=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({});workspaceItems=workspaceItems.mapKeys(function(k){return Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString();});i=0;workspaceItems.entrySeq().forEach(function(_ref33){var _ref34=_slicedToArray(_ref33,2),key=_ref34[0],value=_ref34[1];if(workspaceItems.getIn([key,'type'])!=='SCR'){workspaceItems=workspaceItems.setIn([key,"animIndex"],i);i++;}});workspaceItems.entrySeq().forEach(function(_ref35){var _ref36=_slicedToArray(_ref35,2),itemKey=_ref36[0],item=_ref36[1];if(item.get('type')!=='SCR'){if(item.get("type")==="TEXT"){var fontSize=item.getIn(["textData","formats","containerStyle","fontSize"]);if(fontSize!==undefined){item=item.setIn(["textData","formats","containerStyle","fontSize"],parseFloat(fontSize,10)*scale+"px");}item=item.setIn(["textData","formats","containerStyle","margin"],"0px");var _pxRemoval=30*state.localStore.get('zoomFactor');item=item.set('height'-_pxRemoval);item=item.set('width'-_pxRemoval);item=item.setIn(['textData','htmlText'],item.getIn(['textData','htmlText']).replace(/(<([^>]+)>)/ig,''));}if(item.get('subType')==='CHR'){var _urlItems=item.get('thumb').split('/');_urlItems[1]=item.get('charId');var _thumbUrl=_urlItems.join('/');item=item.set('thumb',_thumbUrl+'.png');}var _childIds=[];if(item.get("type")==="GROUP"||item.get("TXT_OVLY")){var itemChildren=workspaceChildren.filter(function(obj,key){return item.get("groupChildren").indexOf(key)!==-1;});itemChildren=itemChildren.mapKeys(function(k){return Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString();});itemChildren=itemChildren.sortBy(function(value,key){return value.get("index");}).toOrderedMap();_childIds=itemChildren.keySeq().toArray();item=item.set("groupChildren",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(_childIds));if(itemChildren!==undefined&&itemChildren.size>0){itemChildren.entrySeq().forEach(function(_ref37){var _ref38=_slicedToArray(_ref37,2),childKey=_ref38[0],childItem=_ref38[1];childItem=childItem.set("width",childItem.get("width")*scale).set("height",childItem.get("height")*scale).set("x",childItem.get("x")*scale).set("y",childItem.get("y")*scale);if(childItem.get("type")==="TEXT"){var _fontSize=childItem.getIn(["textData","formats","containerStyle","fontSize"]);if(_fontSize!==undefined){childItem=childItem.setIn(["textData","formats","containerStyle","fontSize"],parseFloat(_fontSize,10)*scale+"px");}childItem=childItem.setIn(["textData","formats","containerStyle","margin"],"0px");var _pxRemoval2=30*state.localStore.get('zoomFactor');childItem=childItem.set('height'-_pxRemoval2);childItem=childItem.set('width'-_pxRemoval2);childItem=childItem.setIn(['textData','htmlText'],childItem.getIn(['textData','htmlText']).replace(/(<([^>]+)>)/ig,''));if(childItem.get('subType')==="DTXT"){childItem=childItem.setIn(["textData","formats","containerStyle","lineHeight"],"2.25");}}allChildren=allChildren.set(childKey,childItem);});}}allItems=allItems.set(itemKey,item);}});var bgWidth=scene.getIn(["workspaceBG","width"])*pasteData.width,bgHeight=scene.getIn(["workspaceBG","height"])*pasteData.height,bgWidthScale=1,bgHeightScale=1,oldBgWidth=bgWidth,oldBgHeight=bgHeight;if(state.project.get("width")>=state.project.get("height")){bgWidth=state.project.get("width");bgHeight=oldBgHeight*(bgWidth/oldBgWidth);if(bgHeight<=state.project.get("height")){bgHeight=state.project.get("height");bgWidth=bgWidth*(bgHeight/(oldBgHeight*(bgWidth/oldBgWidth)));}}else{bgHeight=state.project.get("height");bgWidth=oldBgWidth*(bgHeight/oldBgHeight);if(bgWidth<=state.project.get("width")){bgWidth=state.project.get("width");bgHeight=bgHeight*(bgWidth/(oldBgWidth*(bgHeight/oldBgHeight)));}}bgWidthScale=bgWidth/state.project.get("width");bgHeightScale=bgHeight/state.project.get("height");var dW=state.project.get("width")-bgWidth,dH=state.project.get("height")-bgHeight;if(isNaN(dW))dW=0;if(isNaN(dH))dH=0;var x=dW/2/state.project.get("width"),y=dH/2/state.project.get("height"),width=bgWidthScale,height=bgHeightScale;toPaste=toPaste.setIn([index,"workspaceBG"],scene.get("workspaceBG").merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({x:x,y:y,width:width,height:height})));toPaste=toPaste.setIn([index,"workspaceItems"],allItems);toPaste=toPaste.setIn([index,"workspaceChildren"],allChildren);toPaste=toPaste.setIn([index,"id"],Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString());});store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_19" /* pasteScenesComplete */])(selectedScene,toPaste.toJS(),action.socket.id,action.socket.id,action.socket));action.socket.emit('pasteScenes',selectedScene,toPaste.toJS(),userId);}}if(action.type==="ADD_BULK_OBJECTS"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["g" /* addObjComplete */])(action.data.selectedScene,action.data.workspaceIds,action.data.workspaceData,action.data.workspaceChildIds,action.data.workspaceChildData,action.data.socket.id));action.data.socket.emit('addObject',action.data.selectedScene,action.data.workspaceIds,action.data.workspaceData,action.data.workspaceChildIds,action.data.workspaceChildData,userId);}if(action.type==='UPLOAD_BULK_UPDATE'){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_101" /* uploadBulkUpdateComplete */])(action.data));action.socket.emit('uploadBulkUpdate',action.data,userId);}if(action.type==='UPLOAD_BULK_DELETE'){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_100" /* uploadBulkDeleteComplete */])(action.data));action.socket.emit('uploadBulkDelete',action.data,userId);}if(action.type==="UNDO_MOVE"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_12" /* moveUpdateComplete */])(action.data.selectedScene,Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.workspaceItems),Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.workspaceChildren),action.data.currentContainer,action.data.socket.id,action.data.socket.id));action.data.socket.emit('moveUpdate',action.data.selectedScene,Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.workspaceItems),Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.data.workspaceChildren),action.data.currentContainer,userId);}if(action.type==="UPDATE_TEXT_FORMATS"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_94" /* updateTextComplete */])(action.data.isGrouped,action.data.selectedScene,action.data.id,action.data.container,action.data.formats,action.data.childIds,action.data.socket.id,action.data.socket.id,true));if(action.data.htmlText!==undefined&&action.data.htmlText!==""){var text=state.project.getIn(["scenes",action.data.selectedScene,action.data.container,action.data.id]);text=text.setIn(["textData","htmlText"],action.data.htmlText);store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["I" /* changeTextComplete */])(action.data.selectedScene,action.data.container,action.data.id,text.toJS(),action.data.socket.id,action.data.socket.id,true));}action.data.socket.emit('updateText',action.data.isGrouped,action.data.selectedScene,action.data.id,action.data.container,action.data.formats,action.data.childIds,userId);}if(action.type==="UPDATE_SLIDE"){if(action.data.subType==="ADD_SCENE_TRANSITION"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["l" /* addSceneTransitionComplete */])(action.data.slideIndex,action.data.value,action.data.sizes,action.data.socket.id,action.data.socket.id));action.data.socket.emit('addSceneTransition',action.data.slideIndex,action.data.value,action.data.sizes.toJS(),userId);}else if(action.data.subType==="BG_SETTINGS"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["B" /* changeBgComplete */])(action.data.selectedScene,action.data.value,action.data.deleteId,action.data.deletedData,action.data.socket.id,action.data.socket.id));action.data.socket.emit('changeBg',action.data.selectedScene,action.data.value,action.data.deleteId,action.data.deletedData,userId);}}if(action.type==="UPDATE_OBJECT_BY_ID"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_84" /* updateObjectComplete */])(projectid,action.data.selectedScene,action.data.id,action.data.container,action.data.toUpdate,action.socket.id,action.socket.id));action.socket.emit('updateObject',action.data.selectedScene,action.data.id,action.data.container,action.data.toUpdate,true,userId);}if(action.type==="ADD_PREBUILT"){var selectedScene;var prebuiltScenes;var prebuiltScenes;var prebuiltScenes;var allScenes;(function(){selectedScene=action.data.selectedScene;var actualprebuiltData=action.data.prebuilt;if(action.data.undo!==true){if(!action.data.addAll){for(var _key2 in actualprebuiltData['workspaceItems']){if(actualprebuiltData['workspaceItems'].hasOwnProperty(_key2)){var _actualprebuiltData$w=actualprebuiltData['workspaceItems'][_key2],_isMultimove2=_actualprebuiltData$w.isMultimove,_exitEffectName2=_actualprebuiltData$w.exitEffectName,_exitStart3=_actualprebuiltData$w.exitStart,_exitEnd5=_actualprebuiltData$w.exitEnd,workSpaceItems=_objectWithoutProperties(_actualprebuiltData$w,['isMultimove','exitEffectName','exitStart','exitEnd']);actualprebuiltData['workspaceItems'][_key2]=workSpaceItems;}}}else{actualprebuiltData['project']['scenes'].forEach(function(val,idx){for(var _key3 in actualprebuiltData['project']['scenes'][idx]['workspaceItems']){if(actualprebuiltData['project']['scenes'][idx]['workspaceItems'].hasOwnProperty(_key3)){var _actualprebuiltData$p=actualprebuiltData['project']['scenes'][idx]['workspaceItems'][_key3],_isMultimove3=_actualprebuiltData$p.isMultimove,_exitEffectName3=_actualprebuiltData$p.exitEffectName,_exitStart4=_actualprebuiltData$p.exitStart,_exitEnd6=_actualprebuiltData$p.exitEnd,workSpaceItemsForAllScenes=_objectWithoutProperties(_actualprebuiltData$p,['isMultimove','exitEffectName','exitStart','exitEnd']);actualprebuiltData['project']['scenes'][idx]['workspaceItems'][_key3]=workSpaceItemsForAllScenes;}}});}}var prebuiltData=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(actualprebuiltData);if(action.data.undo!==true){if(!action.data.addAll){prebuiltData.getIn(['workspaceItems']).entrySeq().forEach(function(_ref39){var _ref40=_slicedToArray(_ref39,2),key=_ref40[0],value=_ref40[1];if(prebuiltData.getIn(['workspaceItems',key,'textData','formats','containerStyle','margin'])){prebuiltData=prebuiltData.setIn(['workspaceItems',key,'textData','formats','containerStyle','margin'],'0px');}});var _allChildren=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({});prebuiltData=prebuiltData.set('workspaceItems',prebuiltData.get('workspaceItems').mapKeys(function(k){return Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString();}));prebuiltData.get("workspaceItems").filter(function(obj,key){return obj.get("type")==="GROUP";}).entrySeq().forEach(function(_ref41){var _ref42=_slicedToArray(_ref41,2),ikey=_ref42[0],item=_ref42[1];var newChildren=prebuiltData.get('workspaceChildren').filter(function(obj,key){return item.get("groupChildren").keyOf(key)!==undefined;}).mapKeys(function(k){return Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString();});prebuiltData=prebuiltData.setIn(["workspaceItems",ikey,"groupChildren"],newChildren.keySeq().toList());_allChildren=_allChildren.merge(newChildren);});prebuiltData=prebuiltData.set('workspaceChildren',Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])(_allChildren));var sortedItems=prebuiltData.get("workspaceItems").sortBy(function(value,key){return value.get("enterStart");});prebuiltData=prebuiltData.set('workspaceItems',sortedItems);// i = 0;
// prebuiltData.get('workspaceItems').entrySeq().forEach(([key, value]) =>
// {
//   prebuiltData=prebuiltData.setIn(['workspaceItems',key,'animType'],'On Click');
//   prebuiltData= prebuiltData.setIn(['workspaceItems',key, "animIndex"], i);
//   prebuiltData= prebuiltData.setIn(['workspaceItems',key, "enterStart"], 0);
//   i++;
// });
prebuiltData=prebuiltData.setIn(['transEffect'],'NoTransition');}else{var _loop=function _loop(_i){prebuiltData.getIn(['project','scenes',_i,'workspaceItems']).entrySeq().forEach(function(key,item){var wsItem=key[1];if(wsItem.get('type')==='TEXT'){if(prebuiltData.getIn(['project','scenes',_i,'workspaceItems',key[0],'textData','formats','containerStyle','margin']))prebuiltData=prebuiltData.setIn(['project','scenes',_i,'workspaceItems',key[0],'textData','formats','containerStyle','margin'],'0px');}});};for(var _i=0;_i<prebuiltData.getIn(['project','scenes']).size;_i++){_loop(_i);}prebuiltScenes=prebuiltData.getIn(["project","scenes"]);if(prebuiltScenes.size>0){prebuiltScenes.entrySeq().forEach(function(_ref43){var _ref44=_slicedToArray(_ref43,2),sceneNum=_ref44[0],sceneVal=_ref44[1];var allChildren=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({});prebuiltScenes=prebuiltScenes.setIn([sceneNum,"workspaceItems"],sceneVal.get("workspaceItems").mapKeys(function(k){return Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString();}));prebuiltScenes.getIn([sceneNum,"workspaceItems"]).filter(function(obj,key){return obj.get("type")==="GROUP";}).entrySeq().forEach(function(_ref45){var _ref46=_slicedToArray(_ref45,2),ikey=_ref46[0],item=_ref46[1];var newChildren=prebuiltScenes.getIn([sceneNum,"workspaceChildren"]).filter(function(obj,key){return item.get("groupChildren").keyOf(key)!==undefined;}).mapKeys(function(k){return Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString();});prebuiltScenes=prebuiltScenes.setIn([sceneNum,"workspaceItems",ikey,"groupChildren"],newChildren.keySeq().toList());allChildren=allChildren.merge(newChildren);});prebuiltScenes=prebuiltScenes.setIn([sceneNum,"workspaceChildren"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])(allChildren));var sortedItems=prebuiltScenes.getIn([sceneNum,"workspaceItems"]).sortBy(function(value,key){return value.get("enterStart");});prebuiltScenes=prebuiltScenes.setIn([sceneNum,"workspaceItems"],sortedItems);// i=0
// prebuiltScenes.getIn([sceneNum,'workspaceItems']).entrySeq().forEach(([key, value]) =>
// {
//   prebuiltScenes=prebuiltScenes.setIn([sceneNum,'workspaceItems',key,'animType'],'On Click');
//   prebuiltScenes=prebuiltScenes.setIn([sceneNum,'workspaceItems',key,'enterStart'],0);                
//   prebuiltScenes= prebuiltScenes.setIn([sceneNum,'workspaceItems',key, "animIndex"], i);
//   i++;
// });
});}}}else{var _loop2=function _loop2(_i2){prebuiltData.getIn(['project','scenes',_i2,'workspaceItems']).entrySeq().forEach(function(key,item){var wsItem=key[1];if(wsItem.get('type')==='TEXT'){if(prebuiltData.getIn(['project','scenes',_i2,'workspaceItems',key[0],'textData','formats','containerStyle','margin']))prebuiltData=prebuiltData.setIn(['project','scenes',_i2,'workspaceItems',key[0],'textData','formats','containerStyle','margin'],'0px');}});};for(var _i2=0;_i2<prebuiltData.getIn(['project','scenes']).size;_i2++){_loop2(_i2);}prebuiltScenes=prebuiltData.getIn(["project","scenes"]);if(prebuiltScenes.size>0){prebuiltScenes.entrySeq().forEach(function(_ref47){var _ref48=_slicedToArray(_ref47,2),sceneNum=_ref48[0],sceneVal=_ref48[1];var allChildren=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({});prebuiltScenes=prebuiltScenes.setIn([sceneNum,"workspaceItems"],sceneVal.get("workspaceItems").mapKeys(function(k){return Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString();}));prebuiltScenes.getIn([sceneNum,"workspaceItems"]).filter(function(obj,key){return obj.get("type")==="GROUP";}).entrySeq().forEach(function(_ref49){var _ref50=_slicedToArray(_ref49,2),ikey=_ref50[0],item=_ref50[1];var newChildren=prebuiltScenes.getIn([sceneNum,"workspaceChildren"]).filter(function(obj,key){return item.get("groupChildren").keyOf(key)!==undefined;}).mapKeys(function(k){return Math.random().toString(36).replace(/[^a-z]+/g,'').substr(0,5)+new Date().getTime().toString();});prebuiltScenes=prebuiltScenes.setIn([sceneNum,"workspaceItems",ikey,"groupChildren"],newChildren.keySeq().toList());allChildren=allChildren.merge(newChildren);});prebuiltScenes=prebuiltScenes.setIn([sceneNum,"workspaceChildren"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])(allChildren));var sortedItems=prebuiltScenes.getIn([sceneNum,"workspaceItems"]).sortBy(function(value,key){return value.get("enterStart");});prebuiltScenes=prebuiltScenes.setIn([sceneNum,"workspaceItems"],sortedItems);});}prebuiltData=prebuiltData.setIn(["project","scenes"],prebuiltScenes).setIn(["project","name"],state.project.get("name"));if(action.data.replace!==true){prebuiltScenes=prebuiltScenes.toJS();allScenes=state.project.get("scenes").toJS();prebuiltScenes.unshift(selectedScene+1,0);Array.prototype.splice.apply(allScenes,prebuiltScenes);allScenes=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(allScenes);prebuiltData=prebuiltData.setIn(["project","scenes"],allScenes).setIn(["project","name"],state.project.get("name"));}else{prebuiltData=prebuiltData.setIn(["project","scenes"],prebuiltScenes).setIn(["project","name"],state.project.get("name"));}}prebuiltData=Object(__WEBPACK_IMPORTED_MODULE_1__helpers_utilityMethods__["c" /* sortGroupEle */])(prebuiltData,action.data.addAll);store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["i" /* addPrebuiltComplete */])(selectedScene,prebuiltData.toJS(),action.data.replace,action.data.addAll,action.socket.id,action.socket.id));action.socket.emit("addPrebuilt",selectedScene,prebuiltData.toJS(),action.data.replace,action.data.addAll,userId);})();}if(action.type==="UPDATE_BG"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_78" /* updateBgComplete */])(projectid,action.data.selectedScene,action.data.toUpdate,action.socket.id,action.socket.id));action.socket.emit("updateBg",action.data.selectedScene,action.data.toUpdate,true,userId);}if(action.type==="SAVE_PROJECT_NAME"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_85" /* updateProjectComplete */])(projectid,action.data.toUpdate,action.socket.id,action.socket.id));action.socket.emit("updateProject",action.data.toUpdate,userId);}if(action.type==="UPDATE_OBJECT"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_84" /* updateObjectComplete */])(projectid,action.data.selectedScene,action.data.selectedItem,action.data.container,action.data.toUpdate,action.socket.id,action.socket.id));action.socket.emit('updateObject',action.data.selectedScene,action.data.selectedItem,action.data.container,action.data.toUpdate,true,userId);}if(action.type==="WRITE_TEXT"){var canEmit=!action.data.isTyping||action.data.undo;store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_84" /* updateObjectComplete */])(projectid,action.data.selectedScene,action.data.selectedItem,action.data.container,action.data.toUpdate,action.socket.id,action.socket.id));action.socket.emit('updateObject',action.data.selectedScene,action.data.selectedItem,action.data.container,action.data.toUpdate,true,userId);}if(action.type==="SYNC_TEXT"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_84" /* updateObjectComplete */])(projectid,action.data.selectedScene,action.data.selectedItem,action.data.container,action.data.toUpdate));}if(action.type==="SET_TEXT_WIDTH"){var _canEmit=!action.data.isTyping||action.data.undo;store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_84" /* updateObjectComplete */])(projectid,action.data.selectedScene,action.data.selectedItem,action.data.container,action.data.toUpdate,action.socket.id,action.socket.id));action.socket.emit('updateObject',action.data.selectedScene,action.data.selectedItem,action.data.container,action.data.toUpdate,_canEmit,userId);}if(action.type==="UPDATE_ITEM"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_84" /* updateObjectComplete */])(projectid,action.data.selectedScene,action.data.selectedItem,action.data.container,action.data.toUpdate,action.socket.id,action.socket.id));action.socket.emit('updateObject',action.data.selectedScene,action.data.selectedItem,action.data.container,action.data.toUpdate,true,userId);}if(action.type==="UNDO_SCENE_PASTE"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_85" /* updateProjectComplete */])(projectid,action.data.toUpdate,action.socket.id,action.socket.id));action.socket.emit("updateProject",action.data.toUpdate,userId);}if(action.type==='APPLY_ENTER_EFFECT'){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["r" /* applyEnterEffectComplete */])(projectid,action.data.selectedScene,action.data.effectData,action.data.isUndo,action.data.sceneEffectData,action.socket.id,action.socket.id));action.socket.emit('applyEnterEffect',action.data.selectedScene,action.data.effectData,action.data.isUndo,action.data.sceneEffectData,userId);}if(action.type==='APPLY_ALL_TRANSITION'){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["p" /* applyAllTransitionComplete */])(projectid,action.data.transData,action.data.isUndo,action.data.sceneTransData,action.socket.id,action.socket.id));action.socket.emit('applyAllTransition',action.data.transData,action.data.isUndo,action.data.sceneTransData,userId);}if(action.type==='ADD_LINK_TO_TEXT'){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["e" /* addLinkToTextComplete */])(projectid,action.data.selectedScene,action.data.container,action.data.selectedItem,action.data.hyperLinkData,action.socket.id,action.socket.id));action.socket.emit('addLinkToText',action.data.selectedScene,action.data.container,action.data.selectedItem,action.data.hyperLinkData,userId);}if(action.type==='ADD_LINK_TO_OBJ'){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["c" /* addLinkToObjComplete */])(projectid,action.data.selectedScene,action.data.selectedItem,action.data.linkData,action.socket.id,action.socket.id));action.socket.emit('addLinkToObj',action.data.selectedScene,action.data.selectedItem,action.data.linkData,userId);}if(action.type==='SET_WORKSPACE_ITEMS_ORDER'){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_50" /* setWorkspaceItemsOrderComplete */])(projectid,action.data.selectedScene,action.data.container,action.data.workspaceItemsOrder,action.socket.id,action.socket.id));action.socket.emit('workspaceItemsOrder',action.data.selectedScene,action.data.container,action.data.workspaceItemsOrder,userId);}if(action.type==='SET_ANIMATE_VALUE'){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_27" /* setAnimateValueComplete */])(projectid,action.data.selectedScene,action.data.container,action.data.selectedItem,action.data.animateData,action.socket.id,action.socket.id));action.socket.emit('setAnimateValue',action.data.selectedScene,action.data.container,action.data.selectedItem,action.data.animateData,userId);}if(action.type==='SET_PLAY_ALL'){try{if(action.data){var projectDataCopy=new __WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"](state.project);var clonedProjectData=projectDataCopy;var _loop3=function _loop3(_m){var itemsToLoad=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])();var workspaceItems=clonedProjectData.getIn(['scenes',_m,'workspaceItems']).sortBy(function(item){return item.get('animIndex');});var workspaceChildren=clonedProjectData.getIn(['scenes',_m,'workspaceChildren']).sortBy(function(item){return item.get('animIndex');});workspaceItems.entrySeq().forEach(function(_ref53){var _ref54=_slicedToArray(_ref53,2),item=_ref54[0],workspaceItem=_ref54[1];if(workspaceItem.get("type")==="GROUP"){if(!(workspaceItem.get("enterEffectName")==="no_Effect"&&workspaceItem.get('animType')==='On Load')){itemsToLoad=itemsToLoad.setIn([item],workspaceItem);itemsToLoad=itemsToLoad.setIn([item,"isChild"],false);}else{workspaceChildren.entrySeq().forEach(function(_ref55){var _ref56=_slicedToArray(_ref55,2),item=_ref56[0],child=_ref56[1];if(workspaceItem.getIn(["groupChildren"]).includes(item)){itemsToLoad=itemsToLoad.setIn([item],child);itemsToLoad=itemsToLoad.setIn([item,"isChild"],true);}});}}else{itemsToLoad=itemsToLoad.setIn([item],workspaceItem);itemsToLoad=itemsToLoad.setIn([item,"isChild"],false);}});clonedProjectData=clonedProjectData.setIn(['scenes',_m,'workspaceItems'],itemsToLoad);};for(var _m=0;_m<clonedProjectData.getIn(['scenes']).size;_m++){_loop3(_m);}var itemLabels={};var labelName=0;var sceneStartTime={};for(var m=0;m<clonedProjectData.getIn(['scenes']).size;m++){//to sort the items using key animIndex
var sortedItems=clonedProjectData.getIn(['scenes',m,'workspaceItems']).sortBy(function(item){return item.get('animIndex');});var currentTime=0;sortedItems.entrySeq().forEach(function(_ref51){var _ref52=_slicedToArray(_ref51,2),key=_ref52[0],value=_ref52[1];itemLabels[key]={};if(value.get("animType")=="On Load"){itemLabels[key].enterStart=clonedProjectData.getIn(['scenes',m,"startTime"])+0;itemLabels[key].enterEnd=clonedProjectData.getIn(['scenes',m,"startTime"])+0.5;}else if(value.get("animType")=="On Click"){currentTime+=1;labelName+=1;itemLabels[key].enterStart=clonedProjectData.getIn(['scenes',m,"startTime"])+currentTime;itemLabels[key].enterEnd=currentTime+0.5;itemLabels[key].labelName=labelName;}else if(value.get("animType")=="With Previous"){itemLabels[key].enterStart=clonedProjectData.getIn(['scenes',m,"startTime"])+currentTime;itemLabels[key].enterEnd=currentTime+0.5;}else if(value.get("animType")=="After Previous"){currentTime+=1;itemLabels[key].enterStart=clonedProjectData.getIn(['scenes',m,"startTime"])+currentTime+0.01;itemLabels[key].enterEnd=currentTime+0.5;}});clonedProjectData=clonedProjectData.setIn(['scenes',m,"duration"],currentTime+1);if(m<clonedProjectData.getIn(['scenes']).size-1){itemLabels["scenetransition"+m]={};itemLabels["scenetransition"+m].enterStart=clonedProjectData.getIn(['scenes',m,"duration"])+clonedProjectData.getIn(['scenes',m,"startTime"]);clonedProjectData=clonedProjectData.setIn(['scenes',m+1,"startTime"],clonedProjectData.getIn(['scenes',m,"duration"])+clonedProjectData.getIn(['scenes',m,"startTime"]));}sceneStartTime[m]=clonedProjectData.getIn(['scenes',m,"startTime"]);}itemLabels['sceneStartTime']=sceneStartTime;store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["_35" /* setLabelValues */])(itemLabels));}}catch(error){console.log(error);}}if(action.type==='PROJECT_RESTORE'){if(action.data.isEmit)action.socket.emit('restoreStart',projectUsr);}next(action);};};};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.4e4e2c86.js